
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("bSweK", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $55fM8 = parcelRequire("55fM8");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $65DSU = parcelRequire("65DSU");


var $iwNka = parcelRequire("iwNka");

parcelRequire("e1iIh");
var $6m7J6 = parcelRequire("6m7J6");


var $bX4Zr = parcelRequire("bX4Zr");


var $35oAA = parcelRequire("35oAA");


var $gsWjA = parcelRequire("gsWjA");


var $g2oof = parcelRequire("g2oof");


var $7QM6o = parcelRequire("7QM6o");


var $3d5UI = parcelRequire("3d5UI");


var $lABjq = parcelRequire("lABjq");


var $9sGCn = parcelRequire("9sGCn");


var $hl1Kw = parcelRequire("hl1Kw");


var $8zMP3 = parcelRequire("8zMP3");


var $6mKj3 = parcelRequire("6mKj3");


var $ep3mz = parcelRequire("ep3mz");


var $1Af7Q = parcelRequire("1Af7Q");


// Rovo Chat reads the other side of this chunk. Kept dynamic so a page load that
// never opens the chat, or is not enrolled, does not pay for it.
const $271996e5cf264d1f$var$loadAutocompletePageContextBridge = ()=>(parcelRequire("eTuLj"));
const $271996e5cf264d1f$var$ViewPageInternal = (t0)=>{
    const $ = (0, $bDgLe.c)(33);
    const { contentId: contentId, spaceKey: spaceKey, ClassicEditorContextProviderLoader: ClassicEditorContextProviderLoader, children: children } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { versionOverride: versionOverride } = (0, $35oAA.useViewPageParams)();
    const [t1] = (0, $ep3mz.usePageState)();
    const { contentType: contentType } = t1;
    const [t2] = (0, $hl1Kw.useSearchSessionId)();
    const { searchSessionId: searchSessionId, additionalAnalytics: additionalAnalytics } = t2;
    const onCurrentContentBodyDynamicChange = $271996e5cf264d1f$var$_temp;
    (0, $bX4Zr.useViewPagePersistentScrollPosition)(contentId);
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = [];
        $[0] = t3;
    } else t3 = $[0];
    (0, $cozmU.useEffect)($271996e5cf264d1f$var$_temp2, t3);
    let contentHeader = null;
    if (contentId && spaceKey) {
        let t4;
        if ($[1] !== contentId || $[2] !== contentType || $[3] !== spaceKey || $[4] !== versionOverride) {
            t4 = (contentQueryData)=>{
                const contentNode = contentQueryData?.content?.nodes?.[0];
                const hasCurrentContent = contentNode?.id === contentId;
                const contentNodeWithHeader = contentNode;
                const contentQueryDataWithHeader = contentQueryData;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6m7J6.ContentHeader), {
                    spaceKey: spaceKey,
                    contentId: contentId,
                    versionOverride: versionOverride,
                    isContentTypePublicLinkEligible: contentType === "page",
                    useDocumentContract: true,
                    contentFragmentRef: hasCurrentContent ? contentNodeWithHeader?.contentHeaderFragment : null,
                    spaceFragmentRef: hasCurrentContent ? contentQueryDataWithHeader?.space?.contentHeaderFragment : null,
                    publicLinkPage: contentQueryDataWithHeader?.publicLinkPage?.pageId === contentId ? contentQueryDataWithHeader.publicLinkPage : null
                });
            };
            $[1] = contentId;
            $[2] = contentType;
            $[3] = spaceKey;
            $[4] = versionOverride;
            $[5] = t4;
        } else t4 = $[5];
        contentHeader = t4;
    }
    const spaceId = (0, $7QM6o.useSpaceId)(spaceKey);
    let t4;
    let t5;
    if ($[6] !== contentId || $[7] !== createAnalyticsEvent || $[8] !== spaceId) {
        t4 = ()=>{
            (0, $3d5UI.waitForGlobal)({
                listener: "ViewPage",
                globalProperty: "AJS.bind"
            }, ()=>{
                window.AJS.bind("createGASv3Event", (_, data)=>{
                    createAnalyticsEvent(data).fire();
                });
            });
            if ((0, $lABjq.pagePublishedState).pageJustPublished) {
                (0, $lABjq.pagePublishedState).pageJustPublished = false;
                createAnalyticsEvent({
                    type: "sendTrackEvent",
                    data: {
                        action: "viewed",
                        actionSubject: "pagePublished",
                        source: "viewPage",
                        objectId: contentId,
                        containerId: spaceId,
                        containerType: "space"
                    }
                }).fire();
            }
            return $271996e5cf264d1f$var$_temp4;
        };
        t5 = [
            createAnalyticsEvent,
            contentId,
            spaceId
        ];
        $[6] = contentId;
        $[7] = createAnalyticsEvent;
        $[8] = spaceId;
        $[9] = t4;
        $[10] = t5;
    } else {
        t4 = $[9];
        t5 = $[10];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    let t7;
    if ($[11] !== additionalAnalytics || $[12] !== contentId || $[13] !== createAnalyticsEvent || $[14] !== searchSessionId || $[15] !== spaceId) {
        t6 = ()=>{
            const scrollContainer = document.getElementById("AkMainContent") ?? document;
            const handlePageScrolledAnalytics = ()=>{
                const { scrollX: scrollX, scrollY: scrollY, innerWidth: innerWidth, innerHeight: innerHeight } = window;
                const { scrollWidth: scrollWidth, scrollHeight: scrollHeight } = document.documentElement;
                const attributes = {
                    scrollX: scrollX,
                    scrollY: scrollY,
                    innerWidth: innerWidth,
                    innerHeight: innerHeight,
                    scrollWidth: scrollWidth,
                    scrollHeight: scrollHeight,
                    depthX: Math.trunc((scrollX + innerWidth) / scrollWidth * 100) / 100,
                    depthY: Math.trunc((scrollY + innerHeight) / scrollHeight * 100) / 100,
                    searchSessionId: searchSessionId,
                    ...additionalAnalytics
                };
                createAnalyticsEvent({
                    type: "sendUIEvent",
                    data: {
                        action: "scrolled",
                        actionSubject: "page",
                        source: "viewPage",
                        objectId: contentId,
                        containerId: spaceId,
                        containerType: "space",
                        attributes: attributes
                    }
                })?.fire();
            };
            const debouncePageScrolledAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(handlePageScrolledAnalytics, 250);
            scrollContainer.addEventListener("scroll", debouncePageScrolledAnalytics);
            return ()=>{
                scrollContainer.removeEventListener("scroll", debouncePageScrolledAnalytics);
                debouncePageScrolledAnalytics.cancel();
            };
        };
        t7 = [
            createAnalyticsEvent,
            contentId,
            spaceId,
            searchSessionId,
            additionalAnalytics
        ];
        $[11] = additionalAnalytics;
        $[12] = contentId;
        $[13] = createAnalyticsEvent;
        $[14] = searchSessionId;
        $[15] = spaceId;
        $[16] = t6;
        $[17] = t7;
    } else {
        t6 = $[16];
        t7 = $[17];
    }
    (0, $cozmU.useEffect)(t6, t7);
    let t8;
    if ($[18] !== contentId) {
        t8 = (0, $9sGCn.getCachedPageData)(contentId);
        $[18] = contentId;
        $[19] = t8;
    } else t8 = $[19];
    const cachedPageData = t8;
    (0, $iwNka.useExposeGoogleMeetScreenShare)();
    let t9;
    if ($[20] !== contentId) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gsWjA.StartViewPageLoad), {
            contentId: contentId
        });
        $[20] = contentId;
        $[21] = t9;
    } else t9 = $[21];
    let t10;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1Af7Q.LegacyBridgeNext), null);
        $[22] = t10;
    } else t10 = $[22];
    let t11;
    if ($[23] !== ClassicEditorContextProviderLoader || $[24] !== cachedPageData || $[25] !== children || $[26] !== contentHeader || $[27] !== contentId || $[28] !== spaceKey) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $g2oof.ViewPageCommon), {
            spaceKey: spaceKey,
            contentId: contentId,
            contentHeader: contentHeader,
            hasDocumentContractContentHeader: true,
            hasPageComments: true,
            hasLabels: true,
            hasReactions: true,
            hasInlineComments: true,
            hasEOPRecs: true,
            ClassicEditorContextProviderLoader: ClassicEditorContextProviderLoader,
            cachedPageData: cachedPageData,
            onCurrentContentBodyDynamicChange: (0, $6mKj3.UNSAFE_expValEqualsNoExposure)("platform_editor_ai_autocomplete_rovo_chat_editor", "isEnabled", true) ? onCurrentContentBodyDynamicChange : undefined
        }, children, t10);
        $[23] = ClassicEditorContextProviderLoader;
        $[24] = cachedPageData;
        $[25] = children;
        $[26] = contentHeader;
        $[27] = contentId;
        $[28] = spaceKey;
        $[29] = t11;
    } else t11 = $[29];
    let t12;
    if ($[30] !== t11 || $[31] !== t9) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t9, t11);
        $[30] = t11;
        $[31] = t9;
        $[32] = t12;
    } else t12 = $[32];
    return t12;
};
const $271996e5cf264d1f$export$767e3006bdbb424a = (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
            dataFetcherName: "content-main"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $65DSU.default), {
            name: "view-page"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($271996e5cf264d1f$var$ViewPageInternal, props)));
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
function $271996e5cf264d1f$var$_temp(contentBodyDynamic, currentContentId) {
    $271996e5cf264d1f$var$loadAutocompletePageContextBridge().then((t0)=>{
        const { publishAutocompletePageContent: publishAutocompletePageContent } = t0;
        publishAutocompletePageContent(contentBodyDynamic, currentContentId);
    });
}
function $271996e5cf264d1f$var$_temp2() {
    (0, $6mKj3.expVal)("confluence_aa_test", "isEnabled", false);
    (0, $6mKj3.expVal)("confluence_aa_test_fy27h1", "isEnabled", false);
}
function $271996e5cf264d1f$var$_temp3() {
    window.AJS.bind("createGASv3Event");
}
function $271996e5cf264d1f$var$_temp4() {
    (0, $3d5UI.waitForGlobal)({
        listener: "ViewPage",
        globalProperty: "AJS.unbind"
    }, $271996e5cf264d1f$var$_temp3);
}
module.exports["ViewPage"] = $271996e5cf264d1f$export$767e3006bdbb424a;

});

parcelRegister("iwNka", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7zgzO = parcelRequire("7zgzO");


var $fFk4O = parcelRequire("fFk4O");

const $54ae78ae571a596a$export$1a20dd7f74852e6b = ()=>{
    // Linter is forcing us to use getHref instead of window.location.href to retrieve href and it isn't the full href - it doesn't include origin
    const { getHref: getHref } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    (0, $cozmU.useEffect)(()=>{
        // https://atlassian.slack.com/archives/C0131PNA4GL/p1723738281832269
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        if ('setCaptureHandleConfig' in (navigator?.mediaDevices ?? {})) {
            const href = getHref();
            (0, $fFk4O.appendGoogleMeetScreenSharingScript)(href);
        }
    // Only execute on initial render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
module.exports["useExposeGoogleMeetScreenShare"] = $54ae78ae571a596a$export$1a20dd7f74852e6b;

});

parcelRegister("fFk4O", function(module, exports) {

var $9ICY6 = parcelRequire("9ICY6");

const $1cd0e9177e768135$export$449f0d0bb2c2424b = 'https://www.gstatic.com/meetjs/addons/1.1.0/meet.addons.js';
const $1cd0e9177e768135$export$8ea5dba186347383 = (href)=>{
    // Create script
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const script = document.createElement('script');
    script.src = $1cd0e9177e768135$export$449f0d0bb2c2424b;
    script.async = true;
    // When script is done loading, run the Google Meet screenshare method
    script.onload = ()=>{
        (0, $9ICY6.exposeToMeetWhenScreensharing)(href);
    };
    // Add script to DOM
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.head.appendChild(script);
};
module.exports["appendGoogleMeetScreenSharingScript"] = $1cd0e9177e768135$export$8ea5dba186347383;

});

parcelRegister("9ICY6", function(module, exports) {

var $hYqCQ = parcelRequire("hYqCQ");

var $f29836a0ec4c93d3$export$eab8e91f09e6d84a = /*#__PURE__*/ function(ProjectNumber) {
    ProjectNumber["staging"] = "1017113233545";
    ProjectNumber["production"] = "118174936708";
    return ProjectNumber;
}({});
var $f29836a0ec4c93d3$export$73691bb86ec75a9 = /*#__PURE__*/ function(Hostname) {
    Hostname["staging"] = "cc-embedded-pages-integ-ui.stg-east.frontend.public.atl-paas.net";
    Hostname["production"] = "cc-embedded-pages-integ.atlassian.com";
    return Hostname;
}({});
const $f29836a0ec4c93d3$export$8446085e93adc95b = (hostname, queryParams)=>`https://${hostname}/google-meet/page?${queryParams}`;
const $f29836a0ec4c93d3$export$7973aed45b22124c = (href)=>{
    const buildUrl = `${window.location.origin}${href}`;
    const parsedURL = (0, $hYqCQ.parseUrl)(buildUrl) ?? {};
    return new URLSearchParams(parsedURL).toString();
};
const $f29836a0ec4c93d3$export$88041f03017aa037 = (href)=>{
    const currentEnv = "production";
    // Create the correct query params for the main stage url - based on confluence embedded page
    const queryParams = $f29836a0ec4c93d3$export$7973aed45b22124c(href);
    // Grab hardcoded hostname and project number based on current env
    const hostname = $f29836a0ec4c93d3$export$73691bb86ec75a9[currentEnv] ?? "cc-embedded-pages-integ-ui.stg-east.frontend.public.atl-paas.net";
    const cloudProjectNumber = $f29836a0ec4c93d3$export$eab8e91f09e6d84a[currentEnv] ?? "1017113233545";
    // Fire the Google add-on method to allow promotion and add-on use when screensharing
    // startActivityOnOpen needs to be set to true as long as we use mainstageUrl
    // See docs for additional info: https://developers.google.com/meet/add-ons/reference/websdk/screenshare_api.addonscreenshareinfo.startactivityonopen
    window?.meet?.addon?.screensharing?.exposeToMeetWhenScreensharing({
        cloudProjectNumber: cloudProjectNumber,
        startActivityOnOpen: true,
        mainStageUrl: $f29836a0ec4c93d3$export$8446085e93adc95b(hostname, queryParams)
    });
};
module.exports["exposeToMeetWhenScreensharing"] = $f29836a0ec4c93d3$export$88041f03017aa037;

});

parcelRegister("e1iIh", function(module, exports) {
$parcel$export(module.exports, "ContentHeader", () => (parcelRequire("6m7J6")).ContentHeader);

var $6m7J6 = parcelRequire("6m7J6");


});

parcelRegister("6m7J6", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $aJHKK = parcelRequire("aJHKK");


var $eTq5t = parcelRequire("eTq5t");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $6SsN4 = parcelRequire("6SsN4");


var $kz1Yj = parcelRequire("kz1Yj");


var $kA6Zo = parcelRequire("kA6Zo");


var $buxP3 = parcelRequire("buxP3");


var $3izAL = parcelRequire("3izAL");


var $2wCqQ = parcelRequire("2wCqQ");


var $gnKXs = parcelRequire("gnKXs");


var $bavCP = parcelRequire("bavCP");


var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");

var $1eaCJ = parcelRequire("1eaCJ");


var $4Wxqa = parcelRequire("4Wxqa");


var $dnfJM = parcelRequire("dnfJM");


var $JJ6wk = parcelRequire("JJ6wk");


var $iuFvk = parcelRequire("iuFvk");


var $cgsIj = parcelRequire("cgsIj");


var $8MMdp = parcelRequire("8MMdp");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $4PPzL = parcelRequire("4PPzL");


var $7Sm4c = parcelRequire("7Sm4c");


var $hFGQl = parcelRequire("hFGQl");


var $7boqA = parcelRequire("7boqA");


var $foQ4a = parcelRequire("foQ4a");


var $jmjWc = parcelRequire("jmjWc");


var $bFMG7 = parcelRequire("bFMG7");


var $2XV0z = parcelRequire("2XV0z");


var $6mKj3 = parcelRequire("6mKj3");


var $bLtXM = parcelRequire("bLtXM");


var $fwwrH = parcelRequire("fwwrH");


var $1xpoY = parcelRequire("1xpoY");


var $fiBb3 = parcelRequire("fiBb3");


var $80xNa = parcelRequire("80xNa");


var $fabPv = parcelRequire("fabPv");


var $5W37o = parcelRequire("5W37o");


var $jbFlk = parcelRequire("jbFlk");


var $4Uc69 = parcelRequire("4Uc69");


var $JHogp = parcelRequire("JHogp");


var $hlP5l = parcelRequire("hlP5l");


var $a3W69 = parcelRequire("a3W69");


const $a6738032862091d5$var$ContentClassificationTagLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "mTy4w",
    name: 'ContentClassificationTag',
    loader: async ()=>(await (parcelRequire("ds2ZC"))).ContentClassificationTag
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a6738032862091d5$var$SpacedActionItem = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2XsHFM1Y8M",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $a6738032862091d5$var$breadcrumbsAreaWrapper = (0, $buxP3.xcss)({
    flexWrap: 'nowrap',
    flex: '0 1 auto',
    minWidth: 'fit-content',
    gap: 'space.050',
    overflow: 'hidden',
    [(0, $gnKXs.media).above.xs]: {
        minWidth: '96px'
    }
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $a6738032862091d5$var$Metadata = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(11);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { shouldDisplayClassification: shouldDisplayClassification, ...__cmpldp } = __cmplp;
        const t3 = __cmplp.shouldDisplayClassification ? "20px" : "30px";
        let t4;
        if ($[3] !== t3) {
            t4 = (0, $9aYkv.default)(t3);
            $[3] = t3;
            $[4] = t4;
        } else t4 = $[4];
        const t5 = __cmplp.shouldDisplayClassification ? "-5px" : "0";
        let t6;
        if ($[5] !== t5) {
            t6 = (0, $9aYkv.default)(t5);
            $[5] = t5;
            $[6] = t6;
        } else t6 = $[6];
        let t7;
        if ($[7] !== __cmpls || $[8] !== t4 || $[9] !== t6) {
            t7 = {
                ...__cmpls,
                "--_17u00py": t4,
                "--_p0qxq3": t6
            };
            $[7] = __cmpls;
            $[8] = t4;
            $[9] = t6;
            $[10] = t7;
        } else t7 = $[10];
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
            ...__cmpldp,
            style: t7,
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0aFT5v1qpb _3TGfC9HnLE _0NUa3rt3nE _4htEjZkbG2",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
}); /**
     * The header container is `position: fixed`, so a banner stacked inside it grows the header without
     * moving the page down and the title ends up behind it. This sibling is in flow, so it does.
     */ 
const $a6738032862091d5$var$AccessLinkBannerSpacer = (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { bannerHeight: bannerHeight } = t0;
    let t1;
    if ($[0] !== bannerHeight) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "aria-hidden": true,
            "data-testid": "access-link-banner-spacer",
            style: {
                height: bannerHeight
            }
        });
        $[0] = bannerHeight;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
const $a6738032862091d5$var$verticalSeparatorStyles = (0, $buxP3.xcss)({
    borderLeft: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    height: '16px',
    margin: 'space.075'
});
const $a6738032862091d5$var$rightSideHeaderStyles = (0, $buxP3.xcss)({
    marginLeft: 'auto',
    alignItems: 'center'
});
const $a6738032862091d5$var$VerticalSeparator = ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $a6738032862091d5$var$verticalSeparatorStyles
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
$a6738032862091d5$var$SpacedActionItem.displayName = 'SpacedActionItem';
const $a6738032862091d5$var$EXCLUDED_SYSTEM_IDS = [
    (0, $hFGQl.CONTENT_METADATA_PAGE_RESTRICTIONS_ID),
    (0, $hFGQl.CONTENT_METADATA_ATTACHMENTS_ID)
];
const $a6738032862091d5$var$SYSTEM_IDS_TO_SHOW_WITH_PAGE_BUTTONS = [
    (0, $hFGQl.CONTENT_METADATA_PAGE_RESTRICTIONS_ID)
];
const $a6738032862091d5$var$ContentHeaderContentFragment = (0, $eTq5t.default);
const $a6738032862091d5$var$ContentHeaderSpaceFragment = (0, $aJHKK.default);
const $a6738032862091d5$var$ContentHeaderFragmentReader = (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { contentFragmentRef: contentFragmentRef, spaceFragmentRef: spaceFragmentRef, children: children } = t0;
    const t1 = (0, $6SsN4.useFragment)($a6738032862091d5$var$ContentHeaderContentFragment, contentFragmentRef);
    const t2 = (0, $6SsN4.useFragment)($a6738032862091d5$var$ContentHeaderSpaceFragment, spaceFragmentRef) ?? null;
    let t3;
    if ($[0] !== children || $[1] !== t1 || $[2] !== t2) {
        t3 = children({
            contentNode: t1,
            space: t2
        });
        $[0] = children;
        $[1] = t1;
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    return t3;
};
const $a6738032862091d5$export$b52a1b6380889dfe = (t0)=>{
    const $ = (0, $bDgLe.c)(64);
    const { spaceKey: spaceKey, contentId: contentId, actionItems: t1, versionOverride: t2, showMetadataItems: t3, isContentTypePublicLinkEligible: t4, useDocumentContract: t5, contentFragmentRef: contentFragmentRef, spaceFragmentRef: spaceFragmentRef, publicLinkPage: publicLinkPage } = t0;
    let t6;
    if ($[0] !== t1) {
        t6 = t1 === undefined ? [] : t1;
        $[0] = t1;
        $[1] = t6;
    } else t6 = $[1];
    const actionItems = t6;
    const versionOverride = t2 === undefined ? null : t2;
    const showMetadataItems = t3 === undefined ? true : t3;
    const isContentTypePublicLinkEligible = t4 === undefined ? false : t4;
    const useDocumentContract = t5 === undefined ? false : t5;
    const [isContentToolsForcedOpen, setIsContentToolsForcedOpen] = (0, $cozmU.useState)(false);
    const isAccessLinkRequest = (0, $dnfJM.useIsAccessLinkRequest)();
    const { banner: accessLinkBanner, bannerHeight: accessLinkBannerHeight } = (0, $cozmU.useContext)((0, $4Wxqa.AccessLinkHeaderReplacementsContext));
    const { isExternalCollaborator: isExternalCollaborator } = (0, $foQ4a.useIsExternalCollaborator)();
    let t7;
    if ($[2] !== contentId || $[3] !== spaceKey) {
        t7 = {
            contentId: contentId,
            spaceKeyOverride: spaceKey,
            contentStatusContext: "current-only"
        };
        $[2] = contentId;
        $[3] = spaceKey;
        $[4] = t7;
    } else t7 = $[4];
    const contentClassificationMetadata = (0, $bFMG7.useContentClassification)(t7);
    const { shouldDisplayClassification: shouldDisplayClassification } = contentClassificationMetadata;
    const { width: width } = (0, $2XV0z.usePageHeightWidthObserver)(false, -37, false);
    let t8;
    if ($[5] !== contentId || $[6] !== shouldDisplayClassification || $[7] !== showMetadataItems || $[8] !== spaceKey || $[9] !== versionOverride || $[10] !== width) {
        t8 = (t9)=>{
            const { contentTitle: contentTitle } = t9;
            const shouldRenderMetadataForPageWidth = ()=>width > 1000;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
                alignItems: "center",
                xcss: $a6738032862091d5$var$breadcrumbsAreaWrapper,
                testId: "breadcrumb"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cgsIj.Breadcrumbs), {
                contentId: contentId,
                spaceKey: spaceKey,
                contentTitle: contentTitle || ""
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
                alignBlock: "center"
            }, showMetadataItems && shouldRenderMetadataForPageWidth() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a6738032862091d5$var$Metadata, {
                "data-testid": "metadata-wrapper",
                shouldDisplayClassification: shouldDisplayClassification
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4Uc69.SystemContentMetadata), {
                key: `metadata-${contentId}`,
                contentId: contentId,
                versionOverride: versionOverride,
                excludeIds: $a6738032862091d5$var$EXCLUDED_SYSTEM_IDS
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jbFlk.PageMetadataBanner), {
                key: `banner-${contentId}`,
                contentId: contentId,
                versionOverride: versionOverride
            }))));
        };
        $[5] = contentId;
        $[6] = shouldDisplayClassification;
        $[7] = showMetadataItems;
        $[8] = spaceKey;
        $[9] = versionOverride;
        $[10] = width;
        $[11] = t8;
    } else t8 = $[11];
    const renderBreadcrumbs = t8;
    let t9;
    if ($[12] !== actionItems || $[13] !== contentClassificationMetadata || $[14] !== contentId || $[15] !== isExternalCollaborator || $[16] !== renderBreadcrumbs || $[17] !== showMetadataItems || $[18] !== spaceKey || $[19] !== versionOverride) {
        t9 = (t10)=>{
            const { contentType: contentType, contentTitle: contentTitle_0, loading: loading, subType: subType, lastModifiedDate: lastModifiedDate, isContentToolsForcedOpen: isContentToolsForcedOpen_0, setIsContentToolsForcedOpen: setIsContentToolsForcedOpen_0, isArchived: isArchived, isFabricPage: isFabricPage } = t10;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, renderBreadcrumbs({
                contentTitle: contentTitle_0
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                testId: "content-classification-tag"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a6738032862091d5$var$ContentClassificationTagLoader, {
                contentId: contentId,
                contentType: contentType || null,
                contentClassificationMetadata: contentClassificationMetadata,
                isEditMode: false
            })), showMetadataItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5W37o.PageMetadataAtl), {
                contentId: contentId
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
                alignItems: "center",
                xcss: $a6738032862091d5$var$rightSideHeaderStyles
            }, !isArchived && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
                alignItems: "center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bLtXM.ContentHeaderPresence), {
                contentId: contentId,
                contentType: contentType,
                analyticSource: "viewPageScreen"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a6738032862091d5$var$VerticalSeparator, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $JHogp.GroupedPageButtons), {
                contentId: contentId,
                version: versionOverride,
                includeSystemIds: $a6738032862091d5$var$SYSTEM_IDS_TO_SHOW_WITH_PAGE_BUTTONS,
                spaceKey: spaceKey,
                contentType: contentType,
                contentSubType: subType,
                isExternalCollaborator: isExternalCollaborator,
                lastModifiedDate: lastModifiedDate,
                showEdit: subType !== "live",
                isContentToolsForcedOpen: isContentToolsForcedOpen_0,
                setIsContentToolsForcedOpen: setIsContentToolsForcedOpen_0,
                isArchived: isArchived,
                isFabricPage: isFabricPage
            })), actionItems?.map((ActionItem, index)=>{
                const actionItemProps = {
                    contentId: contentId,
                    spaceKey: spaceKey,
                    contentType: contentType
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a6738032862091d5$var$SpacedActionItem, {
                    "data-testid": "spacedActionItemTestId",
                    key: ActionItem?.displayName || index
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ActionItem, {
                    ...actionItemProps,
                    disabled: loading
                }));
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
                name: (0, $irVI7.VIEW_PAGE_CONTENT_HEADER_EXPERIENCE),
                attributes: {
                    contentId: contentId,
                    contentType: contentType,
                    subType: subType,
                    isFabricPage: isFabricPage,
                    isContentWrapper: false
                }
            }));
        };
        $[12] = actionItems;
        $[13] = contentClassificationMetadata;
        $[14] = contentId;
        $[15] = isExternalCollaborator;
        $[16] = renderBreadcrumbs;
        $[17] = showMetadataItems;
        $[18] = spaceKey;
        $[19] = versionOverride;
        $[20] = t9;
    } else t9 = $[20];
    const renderContentHeader = t9;
    let t10;
    if ($[21] !== accessLinkBanner || $[22] !== accessLinkBannerHeight || $[23] !== contentId || $[24] !== isContentToolsForcedOpen || $[25] !== renderContentHeader || $[26] !== useDocumentContract || $[27] !== versionOverride) {
        t10 = (t11)=>{
            const { contentNode: contentNode, spaceIsThemed: spaceIsThemed, resolvedPublicLinkPage: resolvedPublicLinkPage, loading: loading_0 } = t11;
            const contentType_0 = contentNode?.type;
            const lastModifiedDate_0 = contentNode?.metadata?.lastModifiedDate;
            const subType_0 = contentNode?.subType;
            const contentTitle_1 = contentNode?.title;
            const isFabricPage_0 = (0, $a3W69.checkIsFabricPage)(contentNode);
            const isArchived_0 = contentNode?.status === "archived";
            const fabricEligibilityFragmentRef = useDocumentContract && contentNode && "fabricEditorEligibility" in contentNode && !(0, $1xpoY.default).isKillSwitchOn("confluence_vp_fabric_eligibility_frag_reader") && (0, $6mKj3.expVal)("confluence_exp_vp_document", "isEnabled", false) ? contentNode.fabricEditorEligibility : null;
            const contentHeader = isFabricPage_0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuFvk.FabricEligibilityFragmentProvider), {
                contentFragmentRef: fabricEligibilityFragmentRef
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $JJ6wk.ContentTypesHeader), {
                contentId: contentId,
                contentFragmentRef: contentNode?.contentTypesHeader,
                editContentFragmentRef: contentNode?.editContentButton,
                shareContentFragmentRef: contentNode?.shareAndRestrictButtonData,
                publicLinkPage: resolvedPublicLinkPage,
                isConvertToFolderHighlighted: isContentToolsForcedOpen,
                setIsConvertToFolderHighlighted: setIsContentToolsForcedOpen
            })) : renderContentHeader({
                contentType: contentType_0,
                contentTitle: contentTitle_1,
                isFabricPage: isFabricPage_0,
                loading: loading_0,
                subType: subType_0,
                lastModifiedDate: lastModifiedDate_0,
                isThemed: spaceIsThemed,
                isContentToolsForcedOpen: isContentToolsForcedOpen,
                setIsContentToolsForcedOpen: setIsContentToolsForcedOpen,
                isArchived: isArchived_0
            });
            const shouldShowAifcCreateBanner = isFabricPage_0;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8MMdp.FixedSpaceHeaderContainer), {
                isThemed: spaceIsThemed,
                "data-testid": "content-header-container",
                shouldHavePadding: !isFabricPage_0,
                hasStackedBanner: shouldShowAifcCreateBanner || Boolean(accessLinkBanner),
                shouldGrowForStackedBanner: Boolean(accessLinkBanner)
            }, accessLinkBanner ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
                grow: "fill"
            }, accessLinkBanner, contentHeader) : shouldShowAifcCreateBanner ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
                grow: "fill"
            }, contentHeader, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fwwrH.SmartCreateFeedbackBannerLoader), {
                contentType: "page",
                contentFragmentRef: useDocumentContract && !versionOverride && contentNode?.id === contentId && "smartCreateFeedback" in contentNode && !(0, $1xpoY.default).isKillSwitchOn("confluence_vp_smart_create_banner_frag_reader") && (0, $6mKj3.expVal)("confluence_exp_vp_document", "isEnabled", false) ? contentNode.smartCreateFeedback : null
            })) : contentHeader), accessLinkBanner && accessLinkBannerHeight ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a6738032862091d5$var$AccessLinkBannerSpacer, {
                bannerHeight: accessLinkBannerHeight
            }) : null);
        };
        $[21] = accessLinkBanner;
        $[22] = accessLinkBannerHeight;
        $[23] = contentId;
        $[24] = isContentToolsForcedOpen;
        $[25] = renderContentHeader;
        $[26] = useDocumentContract;
        $[27] = versionOverride;
        $[28] = t10;
    } else t10 = $[28];
    const renderContentHeaderData = t10;
    let t11;
    if ($[29] !== isAccessLinkRequest || $[30] !== renderContentHeaderData) {
        t11 = (t12)=>{
            const { loading: loading_1, error: error, data: data } = t12;
            const contentNode_0 = data?.content?.nodes?.[0];
            const shouldRenderWithSpaceDenial = isAccessLinkRequest && Boolean(contentNode_0) && (0, $fabPv.isSpaceDenialOnly)(error);
            if (error && shouldRenderWithSpaceDenial) (0, $7Sm4c.markErrorAsHandled)(error);
            else if (error) {
                if ((0, $1uFM6.isUnauthorizedError)(error)) {
                    (0, $7Sm4c.markErrorAsHandled)(error);
                    return null;
                } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
                    error: error
                });
            }
            if (!contentNode_0) return null;
            return renderContentHeaderData({
                contentNode: contentNode_0,
                spaceIsThemed: Boolean(data.space?.theme?.themeKey),
                resolvedPublicLinkPage: data.publicLinkPage,
                loading: loading_1
            });
        };
        $[29] = isAccessLinkRequest;
        $[30] = renderContentHeaderData;
        $[31] = t11;
    } else t11 = $[31];
    const renderQueryChildren = t11;
    let t12;
    let t13;
    if ($[32] !== contentFragmentRef || $[33] !== contentId || $[34] !== isAccessLinkRequest || $[35] !== isContentTypePublicLinkEligible || $[36] !== publicLinkPage || $[37] !== renderContentHeaderData || $[38] !== renderQueryChildren || $[39] !== showMetadataItems || $[40] !== spaceFragmentRef || $[41] !== spaceKey || $[42] !== useDocumentContract || $[43] !== versionOverride) {
        t13 = Symbol.for("react.early_return_sentinel");
        bb0: {
            let useClassificationLevelV2 = false;
            if ((0, $6mKj3.expValEquals)("confluence_classification_level_v2", "isEnabled", true)) useClassificationLevelV2 = true;
            const renderContentHeaderQuery = (t14)=>{
                const { useEditButtonFragment: useEditButtonFragment, useAccessButtonFragment: useAccessButtonFragment, includePublicLink: includePublicLink } = t14;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
                    attribution: (0, $3IBnw.Attribution).BACKBONE
                }, showMetadataItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
                    key: `PageSegmentLoadStart-connect-${contentId}`,
                    metric: (0, $hlP5l.CONNECT_APP_WEB_FRAGMENT_METRIC)
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
                    key: `object-header-${contentId}`,
                    id: contentId,
                    name: (0, $irVI7.OBJECT_HEADER_EXPERIENCE)
                }), (0, $6mKj3.expValEquals)("cc-markdown-mode", "isEnabled", true) ? !(0, $1xpoY.default).isKillSwitchOn("confluence_vp_obj_header_frag_dedup") && (0, $6mKj3.expVal)("confluence_exp_vp_document", "isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bavCP.QueryInterop), {
                    query: (0, $fiBb3.ContentHeaderUnifiedQuery),
                    variables: {
                        contentId: contentId,
                        spaceKey: spaceKey,
                        versionOverride: versionOverride || null,
                        embeddedContentRender: null,
                        limit: (0, $80xNa.DEFAULT_CONTRIBUTORS_FETCH_LIMIT),
                        useNewContentTopper: true,
                        isMarkdownModeEnabled: true,
                        includeDevDocsBylineConnection: false,
                        ...useClassificationLevelV2 ? {
                            useClassificationLevelV2: useClassificationLevelV2
                        } : {},
                        useObjectHeaderFragment: true,
                        useEditButtonFragment: useEditButtonFragment,
                        useAccessButtonFragment: useAccessButtonFragment,
                        includePublicLink: includePublicLink
                    },
                    context: {
                        single: true
                    },
                    errorPolicy: "all",
                    __callerPackage__: "content-header"
                }, renderQueryChildren) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bavCP.QueryInterop), {
                    query: (0, $fiBb3.ContentHeaderUnifiedQuery),
                    variables: {
                        contentId: contentId,
                        spaceKey: spaceKey,
                        versionOverride: versionOverride || null,
                        embeddedContentRender: null,
                        limit: (0, $80xNa.DEFAULT_CONTRIBUTORS_FETCH_LIMIT),
                        useNewContentTopper: true,
                        isMarkdownModeEnabled: true,
                        includeDevDocsBylineConnection: false,
                        ...useClassificationLevelV2 ? {
                            useClassificationLevelV2: useClassificationLevelV2
                        } : {},
                        useObjectHeaderFragment: false,
                        useEditButtonFragment: useEditButtonFragment,
                        useAccessButtonFragment: useAccessButtonFragment,
                        includePublicLink: includePublicLink
                    },
                    context: {
                        single: true
                    },
                    errorPolicy: "all",
                    __callerPackage__: "content-header"
                }, renderQueryChildren) : !(0, $1xpoY.default).isKillSwitchOn("confluence_vp_obj_header_frag_dedup") && (0, $6mKj3.expVal)("confluence_exp_vp_document", "isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bavCP.QueryInterop), {
                    query: (0, $fiBb3.ContentHeaderUnifiedQuery),
                    variables: {
                        contentId: contentId,
                        spaceKey: spaceKey,
                        versionOverride: versionOverride || null,
                        embeddedContentRender: null,
                        limit: (0, $80xNa.DEFAULT_CONTRIBUTORS_FETCH_LIMIT),
                        useNewContentTopper: true,
                        isMarkdownModeEnabled: false,
                        includeDevDocsBylineConnection: false,
                        ...useClassificationLevelV2 ? {
                            useClassificationLevelV2: useClassificationLevelV2
                        } : {},
                        useObjectHeaderFragment: true,
                        useEditButtonFragment: useEditButtonFragment,
                        useAccessButtonFragment: useAccessButtonFragment,
                        includePublicLink: includePublicLink
                    },
                    context: {
                        single: true
                    },
                    errorPolicy: "all",
                    __callerPackage__: "content-header"
                }, renderQueryChildren) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bavCP.QueryInterop), {
                    query: (0, $fiBb3.ContentHeaderUnifiedQuery),
                    variables: {
                        contentId: contentId,
                        spaceKey: spaceKey,
                        versionOverride: versionOverride || null,
                        embeddedContentRender: null,
                        limit: (0, $80xNa.DEFAULT_CONTRIBUTORS_FETCH_LIMIT),
                        useNewContentTopper: true,
                        isMarkdownModeEnabled: false,
                        includeDevDocsBylineConnection: false,
                        ...useClassificationLevelV2 ? {
                            useClassificationLevelV2: useClassificationLevelV2
                        } : {},
                        useObjectHeaderFragment: false,
                        useEditButtonFragment: useEditButtonFragment,
                        useAccessButtonFragment: useAccessButtonFragment,
                        includePublicLink: includePublicLink
                    },
                    context: {
                        single: true
                    },
                    errorPolicy: "all",
                    __callerPackage__: "content-header"
                }, renderQueryChildren));
            };
            if (useDocumentContract && !(0, $1xpoY.default).isKillSwitchOn("confluence_vp_header_frag_reader") && (0, $6mKj3.expVal)("confluence_exp_vp_document", "isEnabled", false)) {
                if (!contentFragmentRef || !spaceFragmentRef && !isAccessLinkRequest) {
                    t13 = null;
                    break bb0;
                }
                let t15;
                if ($[46] !== contentId || $[47] !== showMetadataItems) {
                    t15 = showMetadataItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
                        key: `PageSegmentLoadStart-connect-${contentId}`,
                        metric: (0, $hlP5l.CONNECT_APP_WEB_FRAGMENT_METRIC)
                    });
                    $[46] = contentId;
                    $[47] = showMetadataItems;
                    $[48] = t15;
                } else t15 = $[48];
                const t16 = `object-header-${contentId}`;
                let t17;
                if ($[49] !== contentId || $[50] !== t16) {
                    t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
                        key: t16,
                        id: contentId,
                        name: (0, $irVI7.OBJECT_HEADER_EXPERIENCE)
                    });
                    $[49] = contentId;
                    $[50] = t16;
                    $[51] = t17;
                } else t17 = $[51];
                const t18 = spaceFragmentRef ?? null;
                let t19;
                if ($[52] !== publicLinkPage || $[53] !== renderContentHeaderData) {
                    t19 = (t20)=>{
                        const { contentNode: contentNode_1, space: space } = t20;
                        return renderContentHeaderData({
                            contentNode: contentNode_1,
                            spaceIsThemed: Boolean(space?.theme?.themeKey),
                            resolvedPublicLinkPage: publicLinkPage,
                            loading: false
                        });
                    };
                    $[52] = publicLinkPage;
                    $[53] = renderContentHeaderData;
                    $[54] = t19;
                } else t19 = $[54];
                let t20;
                if ($[55] !== contentFragmentRef || $[56] !== t18 || $[57] !== t19) {
                    t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a6738032862091d5$var$ContentHeaderFragmentReader, {
                        contentFragmentRef: contentFragmentRef,
                        spaceFragmentRef: t18
                    }, t19);
                    $[55] = contentFragmentRef;
                    $[56] = t18;
                    $[57] = t19;
                    $[58] = t20;
                } else t20 = $[58];
                let t21;
                if ($[59] !== t15 || $[60] !== t17 || $[61] !== t20) {
                    t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
                        attribution: (0, $3IBnw.Attribution).BACKBONE
                    }, t15, t17, t20);
                    $[59] = t15;
                    $[60] = t17;
                    $[61] = t20;
                    $[62] = t21;
                } else t21 = $[62];
                t13 = t21;
                break bb0;
            }
            if (!(0, $1xpoY.default).isKillSwitchOn("confluence_vp_edit_frag_reader") && (0, $6mKj3.expVal)("confluence_exp_vp_document", "isEnabled", false)) {
                if (!(0, $1xpoY.default).isKillSwitchOn("confluence_vp_access_frag_reader") && (0, $6mKj3.expVal)("confluence_exp_vp_document", "isEnabled", false)) {
                    t13 = renderContentHeaderQuery({
                        useEditButtonFragment: true,
                        useAccessButtonFragment: true,
                        includePublicLink: isContentTypePublicLinkEligible
                    });
                    break bb0;
                }
                t13 = renderContentHeaderQuery({
                    useEditButtonFragment: true,
                    useAccessButtonFragment: false,
                    includePublicLink: false
                });
                break bb0;
            }
            if (!(0, $1xpoY.default).isKillSwitchOn("confluence_vp_access_frag_reader") && (0, $6mKj3.expVal)("confluence_exp_vp_document", "isEnabled", false)) {
                t13 = renderContentHeaderQuery({
                    useEditButtonFragment: false,
                    useAccessButtonFragment: true,
                    includePublicLink: isContentTypePublicLinkEligible
                });
                break bb0;
            }
            let t15;
            if ($[63] === Symbol.for("react.memo_cache_sentinel")) {
                t15 = {
                    useEditButtonFragment: false,
                    useAccessButtonFragment: false,
                    includePublicLink: false
                };
                $[63] = t15;
            } else t15 = $[63];
            t12 = renderContentHeaderQuery(t15);
        }
        $[32] = contentFragmentRef;
        $[33] = contentId;
        $[34] = isAccessLinkRequest;
        $[35] = isContentTypePublicLinkEligible;
        $[36] = publicLinkPage;
        $[37] = renderContentHeaderData;
        $[38] = renderQueryChildren;
        $[39] = showMetadataItems;
        $[40] = spaceFragmentRef;
        $[41] = spaceKey;
        $[42] = useDocumentContract;
        $[43] = versionOverride;
        $[44] = t12;
        $[45] = t13;
    } else {
        t12 = $[44];
        t13 = $[45];
    }
    if (t13 !== Symbol.for("react.early_return_sentinel")) return t13;
    return t12;
};
module.exports["ContentHeader"] = $a6738032862091d5$export$b52a1b6380889dfe;

});

parcelRegister("aJHKK", function(module, exports) {
/**
 * @generated SignedSource<<4921a62dc6b14d832b71be6cf32a7e64>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $38043ba08586a144$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ContentHeader_space",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "concreteType": "Theme",
            "kind": "LinkedField",
            "name": "theme",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "themeKey"
                }
            ]
        }
    ],
    "type": "Space"
};
$38043ba08586a144$var$node.hash = "54644388464a7491be5acf735f23aa0c";
var $38043ba08586a144$export$2e2bcd8739ae039 = $38043ba08586a144$var$node;
module.exports["default"] = $38043ba08586a144$export$2e2bcd8739ae039;

});

parcelRegister("eTq5t", function(module, exports) {
/**
 * @generated SignedSource<<ca313e1730205ddffbd31fa379cae58a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0a74bce3e640ebe2$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "includeAccessButton"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "includeFabricEditorEligibility"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "includeSmartCreateFeedback"
        }
    ],
    "kind": "Fragment",
    "name": "ContentHeader_content",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "kind": "ScalarField",
            "name": "subType"
        },
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "kind": "ScalarField",
            "name": "status"
        },
        {
            "concreteType": "ContentMetadata",
            "kind": "LinkedField",
            "name": "metadata",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "lastModifiedDate"
                },
                {
                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                    "kind": "LinkedField",
                    "name": "frontend",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "fabricEditorSupported"
                        }
                    ]
                }
            ]
        },
        {
            "condition": "includeFabricEditorEligibility",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "fragment": {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "useFabricEligibilityMigrationQuery_content"
                            }
                        ],
                        "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "fabricEditorEligibility"
                }
            ]
        },
        {
            "condition": "includeSmartCreateFeedback",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "fragment": {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "SmartCreateFeedbackBanner_content"
                            }
                        ],
                        "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "smartCreateFeedback"
                }
            ]
        },
        {
            "fragment": {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "ContentTypesHeader_content"
                    }
                ],
                "type": "Content"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "contentTypesHeader"
        },
        {
            "fragment": {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "EditContentButton_content"
                    }
                ],
                "type": "Content"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "editContentButton"
        },
        {
            "condition": "includeAccessButton",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "fragment": {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "useShareAndRestrictButtonData_content"
                            }
                        ],
                        "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "shareAndRestrictButtonData"
                }
            ]
        }
    ],
    "type": "Content"
};
$0a74bce3e640ebe2$var$node.hash = "5f96edd5ad0b25103dfbe0765b7e9599";
var $0a74bce3e640ebe2$export$2e2bcd8739ae039 = $0a74bce3e640ebe2$var$node;
module.exports["default"] = $0a74bce3e640ebe2$export$2e2bcd8739ae039;

});

parcelRegister("gnKXs", function(module, exports) {
const $cd9ae1db5a8ec9c9$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};
module.exports["media"] = $cd9ae1db5a8ec9c9$export$987d49ffe1b0900f;

});

parcelRegister("4Wxqa", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $8fee23c6d49a3667$export$9ded09b22f16a16c = /*#__PURE__*/ (0, $cozmU.createContext)({});
const $8fee23c6d49a3667$export$54e0aee79ff04c1a = ({ children: children, shareButton: shareButton, title: title, banner: banner, bannerHeight: bannerHeight })=>{
    const value = (0, $cozmU.useMemo)(()=>({
            shareButton: shareButton,
            title: title,
            banner: banner,
            bannerHeight: bannerHeight
        }), [
        shareButton,
        title,
        banner,
        bannerHeight
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8fee23c6d49a3667$export$9ded09b22f16a16c.Provider, {
        value: value
    }, children);
};
module.exports["AccessLinkHeaderReplacementsContext"] = $8fee23c6d49a3667$export$9ded09b22f16a16c;
module.exports["AccessLinkHeaderReplacementsProvider"] = $8fee23c6d49a3667$export$54e0aee79ff04c1a;

});

parcelRegister("dnfJM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $gXrHX = parcelRequire("gXrHX");


var $6mKj3 = parcelRequire("6mKj3");

const $bc7285b0b0f1db1d$export$345da578407654bc = ()=>{
    const { isAccessLinkRequest: isAccessLinkRequest } = (0, $cozmU.useContext)((0, $gXrHX.ExternalShareContext));
    // The experiment is evaluated inline and last (no-preconditioning) so it is
    // only reached for genuine access-link viewers.
    return isAccessLinkRequest && (0, $6mKj3.expValEquals)('cc_perms_ga_access_links', 'isEnabled', true);
};
module.exports["useIsAccessLinkRequest"] = $bc7285b0b0f1db1d$export$345da578407654bc;

});

parcelRegister("cgsIj", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");


var $eCJDV = parcelRequire("eCJDV");


const $b7f6794681d506d9$export$74cf87e24679ef23 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Z3pve",
    name: "BreadcrumbsLoader",
    loader: async ()=>(await Promise.resolve((parcelRequire("8MMdp")))).Breadcrumbs,
    loading: (0, $eCJDV.BreadcrumbsPlaceholder)
});
const $b7f6794681d506d9$export$2dc68d50d56fbbd = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b7f6794681d506d9$export$74cf87e24679ef23, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b7f6794681d506d9$export$74cf87e24679ef23, props);

const $b7f6794681d506d9$export$f979c33d59431f8e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "G1kJd",
    name: "FixedBreadcrumbsNavForPageLayoutLoader",
    loader: async ()=>(await Promise.resolve((parcelRequire("8MMdp")))).FixedBreadcrumbsNavForPageLayout
});
module.exports["BreadcrumbsLoader"] = $b7f6794681d506d9$export$74cf87e24679ef23;
module.exports["Breadcrumbs"] = $b7f6794681d506d9$export$2dc68d50d56fbbd;
module.exports["FixedBreadcrumbsNavForPageLayoutLoader"] = $b7f6794681d506d9$export$f979c33d59431f8e;

});

parcelRegister("eCJDV", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $b8pma = parcelRequire("b8pma");

const $0c4308f795e44815$export$98d1f051069dd73b = (0, $3u0dr.isReactCompilerActiveV2)() ? function BreadcrumbsPlaceholder() {
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
            name: "BreadcrumbsPlaceholder"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "breadcrumbs-placeholder",
            "data-vc": "breadcrumbs-placeholder"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : function BreadcrumbsPlaceholder() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
        name: "BreadcrumbsPlaceholder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "breadcrumbs-placeholder",
        "data-vc": "breadcrumbs-placeholder"
    }));
};
module.exports["BreadcrumbsPlaceholder"] = $0c4308f795e44815$export$98d1f051069dd73b;

});

parcelRegister("7boqA", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $knAY5 = parcelRequire("knAY5");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $18R9N = parcelRequire("18R9N");

const $e6e452b898a1ec38$var$noop = ()=>{};
const $e6e452b898a1ec38$var$EMBEDDED_PREFIX = 'embedded-';
const $e6e452b898a1ec38$var$PageSegmentLoadStartComponent = /*#__PURE__*/ (0, $cozmU.memo)((props)=>{
    const { onComplete: onComplete = $e6e452b898a1ec38$var$noop, timing: timing = (0, $N1nBh.ActionTiming).RENDER_BODY } = props;
    const isEmbedded = (0, $18R9N.useIsEmbeddedTracking)();
    // The discriminated union of PageSegmentLoadStartProps guarantees that exactly one of
    // `metricKey` or `metric` is provided, so resolvedKey is always a defined string at runtime.
    const resolvedKey = props.metricKey ?? props.metric.key;
    const prefixedKey = isEmbedded ? `${$e6e452b898a1ec38$var$EMBEDDED_PREFIX}${resolvedKey}` : resolvedKey;
    const handleSegmentLoadStart = (0, $cozmU.useCallback)(()=>{
        (0, $knAY5.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${prefixedKey}`);
        onComplete();
    }, [
        onComplete,
        prefixedKey
    ]);
    (0, $N1nBh.usePerformanceAction)(handleSegmentLoadStart, timing);
    return null;
});
const $e6e452b898a1ec38$export$f11db193fdaffcc9 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($e6e452b898a1ec38$var$PageSegmentLoadStartComponent);
module.exports["PageSegmentLoadStart"] = $e6e452b898a1ec38$export$f11db193fdaffcc9;

});

parcelRegister("aJv6Q", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4PPzL = parcelRequire("4PPzL");


var $hSqtY = parcelRequire("hSqtY");

function $1d5814e83a6e1177$export$f0c7a449e0cfaec7(errorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $4PPzL.ErrorBoundary), errorBoundaryProps);
}
function $1d5814e83a6e1177$export$c5425be6daeb353e(transparentErrorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $hSqtY.TransparentErrorBoundary), transparentErrorBoundaryProps);
}
function $1d5814e83a6e1177$export$e54e24a14e23c644(BoundaryComponent, boundaryProps) {
    return function(WrappedComponent) {
        return (wrappedProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(BoundaryComponent, boundaryProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, wrappedProps));
    };
}
module.exports["withErrorBoundary"] = $1d5814e83a6e1177$export$f0c7a449e0cfaec7;
module.exports["withTypedErrorBoundary"] = $1d5814e83a6e1177$export$e54e24a14e23c644;
module.exports["withTransparentErrorBoundary"] = $1d5814e83a6e1177$export$c5425be6daeb353e;

});

parcelRegister("N1nBh", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

var $4fef2d066feab689$export$6a673e74e98cdf55 = /*#__PURE__*/ function(ActionTiming) {
    /**
   * This will perform the given action at a scheduled time after the
   * component has painted.
   *
   * This is the default behavior.
   */ ActionTiming["DEFAULT"] = "DEFAULT";
    /**
   * This will perform the given action at the next animation frame (after the
   * component has been painted).
   */ ActionTiming["PAINT"] = "PAINT";
    /**
   * This will perform the given action at the moment its render function
   * fires.
   *
   * NOTE: This is called _within_ the render body, making it unpure. The
   * component is memoized, so it will fire this only once for a given set
   * of props. Be careful when using this, since it is unsafe.
   */ ActionTiming["RENDER_BODY"] = "RENDER_BODY";
    return ActionTiming;
}({});
const $4fef2d066feab689$export$454639fd58f598bd = (action, timing = "DEFAULT")=>{
    // The "RENDER_BODY" mark timing
    if (timing === "RENDER_BODY") action();
    // The "PAINT" mark timing
    (0, $cozmU.useLayoutEffect)(()=>{
        if (timing === "PAINT") {
            const frameRequest = requestAnimationFrame(()=>{
                action();
            });
            return ()=>{
                cancelAnimationFrame(frameRequest);
            };
        }
    }, [
        action,
        timing
    ]);
    // The "DEFAULT" mark timing
    (0, $cozmU.useEffect)(()=>{
        if (timing === "DEFAULT") action();
    }, [
        action,
        timing
    ]);
};
module.exports["ActionTiming"] = $4fef2d066feab689$export$6a673e74e98cdf55;
module.exports["usePerformanceAction"] = $4fef2d066feab689$export$454639fd58f598bd;

});

parcelRegister("3YpC9", function(module, exports) {
const $4dbe182ee19642b3$export$f59b3ea823fcdb3d = 'segment-start';
const $4dbe182ee19642b3$export$a217b163593f51a = 'segment-end';
module.exports["PAGE_SEGMENT_MARK_PREFIX_START"] = $4dbe182ee19642b3$export$f59b3ea823fcdb3d;
module.exports["PAGE_SEGMENT_MARK_PREFIX_END"] = $4dbe182ee19642b3$export$a217b163593f51a;

});

parcelRegister("18R9N", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $6b4f0c0629e8427f$export$fda153f959d0066f = /*#__PURE__*/ (0, $cozmU.createContext)(false);
const $6b4f0c0629e8427f$export$b6c7102a78eb7f7f = ()=>(0, $cozmU.useContext)($6b4f0c0629e8427f$export$fda153f959d0066f);
module.exports["EmbeddedConfluenceTrackingContext"] = $6b4f0c0629e8427f$export$fda153f959d0066f;
module.exports["useIsEmbeddedTracking"] = $6b4f0c0629e8427f$export$b6c7102a78eb7f7f;

});

parcelRegister("foQ4a", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $19052bf55936e796$export$e581bd1f88227e0a = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isExternalCollaborator: accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS
    };
};
module.exports["useIsExternalCollaborator"] = $19052bf55936e796$export$e581bd1f88227e0a;

});

parcelRegister("bFMG7", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $5dyIT = parcelRequire("5dyIT");


var $cod3r = parcelRequire("cod3r");


var $79mss = parcelRequire("79mss");


var $XKAGD = parcelRequire("XKAGD");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $7Sm4c = parcelRequire("7Sm4c");


var $1P7Cq = parcelRequire("1P7Cq");


var $308Wd = parcelRequire("308Wd");

var $jMyy4 = parcelRequire("jMyy4");


var $6mKj3 = parcelRequire("6mKj3");


var $1cYlh = parcelRequire("1cYlh");


var $in5LX = parcelRequire("in5LX");


var $kknEZ = parcelRequire("kknEZ");


var $gSfo4 = parcelRequire("gSfo4");


var $fcQxC = parcelRequire("fcQxC");


var $lwZTW = parcelRequire("lwZTW");


var $kJOuS = parcelRequire("kJOuS");

const $8f8b1f599c43d665$export$13c9dac546825a9c = (0, $XKAGD.default);
// Control query: uses classificationLevel (old field)
const $8f8b1f599c43d665$var$UseContentClassificationContentDataClassificationQuery = (0, $79mss.default);
const $8f8b1f599c43d665$export$160e6dbb5cf9582 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { flagStatus: flagStatus, submittedClassification: submittedClassification, setClassification: setClassification, setFlagStatus: setFlagStatus } = t0;
    let t1;
    let t2;
    if ($[0] !== flagStatus || $[1] !== setClassification || $[2] !== setFlagStatus || $[3] !== submittedClassification) {
        t1 = ()=>{
            if (flagStatus === (0, $in5LX.FlagStatus).SUCCESS) {
                setClassification(submittedClassification ?? null);
                setFlagStatus((0, $in5LX.FlagStatus).NONE);
            }
        };
        t2 = [
            flagStatus,
            submittedClassification,
            setClassification,
            setFlagStatus
        ];
        $[0] = flagStatus;
        $[1] = setClassification;
        $[2] = setFlagStatus;
        $[3] = submittedClassification;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $cozmU.useEffect)(t1, t2);
} : ({ flagStatus: flagStatus, submittedClassification: submittedClassification, setClassification: setClassification, setFlagStatus: setFlagStatus })=>{
    // Updates the classification state with the value of submittedClassification
    // on flag success, ensuring consistent behavior across edit tag & edit modal
    (0, $cozmU.useEffect)(()=>{
        if (flagStatus === (0, $in5LX.FlagStatus).SUCCESS) {
            setClassification(submittedClassification ?? null);
            setFlagStatus((0, $in5LX.FlagStatus).NONE);
        }
    }, [
        flagStatus,
        submittedClassification,
        setClassification,
        setFlagStatus
    ]);
};
/**
 *
 * @param contentId
 * @param spaceKeyOverride
 * @param contentStatusContext
 * @param shouldSkipQueries
 * @returns
 * 1) Content's classification level by contentId & by spaceId,
 * 2) Mutation functions for updating & deleting the content's classification,
 * 3) Flag status for rendering error flag upon updating classification.
 */ const $8f8b1f599c43d665$var$useContentClassificationMetadata = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(42);
    const { contentId: contentId, contentStatusContext: t1, shouldReadFromQueries: t2, useClassificationLevelV2: useClassificationLevelV2, classificationLevelDetails: classificationLevelDetails, contentLevelLoading: t3, contentLevelError: contentLevelError } = t0;
    const contentStatusContext = t1 === undefined ? "current-only" : t1;
    const shouldReadFromQueries = t2 === undefined ? false : t2;
    const contentLevelLoading = t3 === undefined ? false : t3;
    const [flagStatus, setFlagStatus] = (0, $cozmU.useState)((0, $in5LX.FlagStatus).NONE);
    const [classification, setClassification] = (0, $cozmU.useState)(null);
    const [currentContentId, setCurrentContentId] = (0, $cozmU.useState)(undefined);
    const [submittedClassification, setSubmittedClassification] = (0, $cozmU.useState)();
    const renderServerPlaceholder = (0, $1P7Cq.useIsSSROrHydrating)();
    let t4;
    if ($[0] !== contentStatusContext) {
        t4 = (0, $fcQxC.getReadAndWriteContextFromQueryContext)(contentStatusContext);
        $[0] = contentStatusContext;
        $[1] = t4;
    } else t4 = $[1];
    const { readContext: contentStatusReadContext } = t4;
    let t5;
    if ($[2] !== flagStatus || $[3] !== submittedClassification) {
        t5 = {
            flagStatus: flagStatus,
            submittedClassification: submittedClassification,
            setClassification: setClassification,
            setFlagStatus: setFlagStatus
        };
        $[2] = flagStatus;
        $[3] = submittedClassification;
        $[4] = t5;
    } else t5 = $[4];
    $8f8b1f599c43d665$export$160e6dbb5cf9582(t5);
    let t6;
    let t7;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (updateClassificationError)=>{
            setFlagStatus((0, $in5LX.FlagStatus).ERROR);
            (0, $7Sm4c.markErrorAsHandled)(updateClassificationError);
        };
        t7 = (data)=>{
            if (data?.bulkUpdateContentDataClassificationLevel?.success) setFlagStatus((0, $in5LX.FlagStatus).SUCCESS);
        };
        $[5] = t6;
        $[6] = t7;
    } else {
        t6 = $[5];
        t7 = $[6];
    }
    let t8;
    if ($[7] !== contentId || $[8] !== contentStatusReadContext || $[9] !== useClassificationLevelV2) {
        t8 = {
            awaitRefetchQueries: true,
            onError: t6,
            onCompleted: t7,
            refetchQueries: ()=>[
                    {
                        query: useClassificationLevelV2 ? (0, $kJOuS.default) : $8f8b1f599c43d665$var$UseContentClassificationContentDataClassificationQuery,
                        variables: {
                            contentId: contentId,
                            lowerCaseContentStatusArray: (0, $gSfo4.getQuerySingleContentStatusArrayVariable)(contentStatusReadContext)
                        }
                    }
                ]
        };
        $[7] = contentId;
        $[8] = contentStatusReadContext;
        $[9] = useClassificationLevelV2;
        $[10] = t8;
    } else t8 = $[10];
    const [updateContentDataClassificationLevel] = (0, $308Wd.useMutationInterop)((0, $cod3r.default), {
        ...t8,
        __callerPackage__: "data-classification"
    });
    let t10;
    let t9;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = (deleteClassificationError)=>{
            setFlagStatus((0, $in5LX.FlagStatus).ERROR);
            (0, $7Sm4c.markErrorAsHandled)(deleteClassificationError);
        };
        t10 = (data_0)=>{
            if (data_0?.bulkDeleteContentDataClassificationLevel?.success) setFlagStatus((0, $in5LX.FlagStatus).SUCCESS);
        };
        $[11] = t10;
        $[12] = t9;
    } else {
        t10 = $[11];
        t9 = $[12];
    }
    let t11;
    if ($[13] !== contentId || $[14] !== contentStatusReadContext || $[15] !== useClassificationLevelV2) {
        t11 = {
            awaitRefetchQueries: true,
            onError: t9,
            onCompleted: t10,
            refetchQueries: ()=>[
                    {
                        query: useClassificationLevelV2 ? (0, $kJOuS.default) : $8f8b1f599c43d665$var$UseContentClassificationContentDataClassificationQuery,
                        variables: {
                            contentId: contentId,
                            lowerCaseContentStatusArray: (0, $gSfo4.getQuerySingleContentStatusArrayVariable)(contentStatusReadContext)
                        }
                    }
                ]
        };
        $[13] = contentId;
        $[14] = contentStatusReadContext;
        $[15] = useClassificationLevelV2;
        $[16] = t11;
    } else t11 = $[16];
    const [deleteContentDataClassificationLevel, t12] = (0, $308Wd.useMutationInterop)((0, $5dyIT.default), {
        ...t11,
        __callerPackage__: "data-classification"
    });
    const { loading: deleteLoading } = t12;
    const rawClassificationLevel = useClassificationLevelV2 ? classificationLevelDetails?.classificationLevelV2 : classificationLevelDetails?.classificationLevel;
    const contentClassification = rawClassificationLevel?.id === "" ? null : rawClassificationLevel ?? null;
    const spaceDefaultIsOverridden = classificationLevelDetails?.source === "CONTENT";
    const errorState = (0, $lwZTW.useClassificationErrorState)(classification, undefined, contentLevelError);
    const shouldNotDisplayContentClassification = contentClassification?.id === (0, $1cYlh.NO_CLASSIFICATION_OPTION_ID) || contentClassification?.status === (0, $kknEZ.Status).ARCHIVED || classification === null && deleteLoading || Boolean(contentLevelError);
    const contentClassificationFromQueryOrState = shouldReadFromQueries ? contentClassification : currentContentId === contentId && !!classification ? classification : contentClassification;
    const updatedClassification = shouldNotDisplayContentClassification ? null : contentClassificationFromQueryOrState;
    let t13;
    let t14;
    if ($[17] !== classification || $[18] !== contentId || $[19] !== updatedClassification) {
        t13 = ()=>{
            if (updatedClassification !== classification) {
                setClassification(updatedClassification ?? null);
                setCurrentContentId(contentId);
            }
        };
        t14 = [
            updatedClassification,
            classification,
            contentId
        ];
        $[17] = classification;
        $[18] = contentId;
        $[19] = updatedClassification;
        $[20] = t13;
        $[21] = t14;
    } else {
        t13 = $[20];
        t14 = $[21];
    }
    (0, $cozmU.useEffect)(t13, t14);
    const isClassificationPublished = classification?.status === (0, $kknEZ.Status).PUBLISHED || updatedClassification?.status === (0, $kknEZ.Status).PUBLISHED;
    const classificationFeatureEnabled = Boolean(classificationLevelDetails?.featureEnabled);
    const shouldDisplayClassification = classificationFeatureEnabled && (!!classification || !!updatedClassification) && !contentLevelLoading && isClassificationPublished;
    const hasNoClassification = !contentLevelLoading && !classification && !updatedClassification;
    let t15;
    if ($[22] !== classificationLevelDetails?.isReclassificationPermitted) {
        t15 = (classificationLevelDetails?.isReclassificationPermitted ?? false) || !(0, $6mKj3.expVal)("dlp_auto_classifications_enabled", "isEnabled", false);
        $[22] = classificationLevelDetails?.isReclassificationPermitted;
        $[23] = t15;
    } else t15 = $[23];
    const isReclassificationPermitted = t15;
    const isSSRedWithClassification = renderServerPlaceholder && updatedClassification;
    const classificationValue = isSSRedWithClassification ? updatedClassification ?? null : classification ?? updatedClassification ?? null;
    const t16 = classificationValue ?? null;
    const t17 = classificationLevelDetails?.source;
    const t18 = classificationLevelDetails?.canManageSpaceSettings;
    const t19 = classificationLevelDetails?.classificationControlSetting;
    const t20 = classificationLevelDetails?.userOverrideSetting;
    let t21;
    if ($[24] !== classificationFeatureEnabled || $[25] !== contentLevelError || $[26] !== contentLevelLoading || $[27] !== contentStatusContext || $[28] !== deleteContentDataClassificationLevel || $[29] !== errorState || $[30] !== flagStatus || $[31] !== hasNoClassification || $[32] !== isReclassificationPermitted || $[33] !== shouldDisplayClassification || $[34] !== spaceDefaultIsOverridden || $[35] !== t16 || $[36] !== t17 || $[37] !== t18 || $[38] !== t19 || $[39] !== t20 || $[40] !== updateContentDataClassificationLevel) {
        t21 = {
            classification: t16,
            spaceDefaultIsOverridden: spaceDefaultIsOverridden,
            contentLevelLoading: contentLevelLoading,
            contentLevelError: contentLevelError,
            updateContentDataClassificationLevel: updateContentDataClassificationLevel,
            deleteContentDataClassificationLevel: deleteContentDataClassificationLevel,
            setSubmittedClassification: setSubmittedClassification,
            flagStatus: flagStatus,
            setFlagStatus: setFlagStatus,
            errorState: errorState,
            shouldDisplayClassification: shouldDisplayClassification,
            hasNoClassification: hasNoClassification,
            contentStatusContext: contentStatusContext,
            featureEnabled: classificationFeatureEnabled,
            isReclassificationPermitted: isReclassificationPermitted,
            source: t17,
            canManageSpaceSettings: t18,
            classificationControlSetting: t19,
            userOverrideSetting: t20
        };
        $[24] = classificationFeatureEnabled;
        $[25] = contentLevelError;
        $[26] = contentLevelLoading;
        $[27] = contentStatusContext;
        $[28] = deleteContentDataClassificationLevel;
        $[29] = errorState;
        $[30] = flagStatus;
        $[31] = hasNoClassification;
        $[32] = isReclassificationPermitted;
        $[33] = shouldDisplayClassification;
        $[34] = spaceDefaultIsOverridden;
        $[35] = t16;
        $[36] = t17;
        $[37] = t18;
        $[38] = t19;
        $[39] = t20;
        $[40] = updateContentDataClassificationLevel;
        $[41] = t21;
    } else t21 = $[41];
    return t21;
} : ({ contentId: contentId, contentStatusContext: contentStatusContext = 'current-only', shouldReadFromQueries: shouldReadFromQueries = false, useClassificationLevelV2: useClassificationLevelV2, classificationLevelDetails: classificationLevelDetails, contentLevelLoading: contentLevelLoading = false, contentLevelError: contentLevelError })=>{
    const [flagStatus, setFlagStatus] = (0, $cozmU.useState)((0, $in5LX.FlagStatus).NONE);
    const [classification, setClassification] = (0, $cozmU.useState)(null);
    const [currentContentId, setCurrentContentId] = (0, $cozmU.useState)(undefined);
    const [submittedClassification, setSubmittedClassification] = (0, $cozmU.useState)();
    const renderServerPlaceholder = (0, $1P7Cq.useIsSSROrHydrating)();
    const { readContext: contentStatusReadContext } = (0, $fcQxC.getReadAndWriteContextFromQueryContext)(contentStatusContext);
    $8f8b1f599c43d665$export$160e6dbb5cf9582({
        flagStatus: flagStatus,
        submittedClassification: submittedClassification,
        setClassification: setClassification,
        setFlagStatus: setFlagStatus
    });
    // The following two GQL write operations are returned by this hook, behavior upon completion is handled within the hook
    const [updateContentDataClassificationLevel] = (0, $308Wd.useMutationInterop)((0, $cod3r.default), {
        awaitRefetchQueries: true,
        onError: (updateClassificationError)=>{
            setFlagStatus((0, $in5LX.FlagStatus).ERROR);
            (0, $7Sm4c.markErrorAsHandled)(updateClassificationError);
        },
        onCompleted: (data)=>{
            if (data?.bulkUpdateContentDataClassificationLevel?.success) setFlagStatus((0, $in5LX.FlagStatus).SUCCESS);
        },
        refetchQueries: ()=>[
                {
                    query: useClassificationLevelV2 ? (0, $kJOuS.default) : $8f8b1f599c43d665$var$UseContentClassificationContentDataClassificationQuery,
                    variables: {
                        contentId: contentId,
                        lowerCaseContentStatusArray: (0, $gSfo4.getQuerySingleContentStatusArrayVariable)(contentStatusReadContext)
                    }
                }
            ],
        __callerPackage__: "data-classification"
    });
    const [deleteContentDataClassificationLevel, { loading: deleteLoading }] = (0, $308Wd.useMutationInterop)((0, $5dyIT.default), {
        awaitRefetchQueries: true,
        onError: (deleteClassificationError)=>{
            setFlagStatus((0, $in5LX.FlagStatus).ERROR);
            (0, $7Sm4c.markErrorAsHandled)(deleteClassificationError);
        },
        onCompleted: (data_0)=>{
            if (data_0?.bulkDeleteContentDataClassificationLevel?.success) setFlagStatus((0, $in5LX.FlagStatus).SUCCESS);
        },
        refetchQueries: ()=>[
                {
                    query: useClassificationLevelV2 ? (0, $kJOuS.default) : $8f8b1f599c43d665$var$UseContentClassificationContentDataClassificationQuery,
                    variables: {
                        contentId: contentId,
                        lowerCaseContentStatusArray: (0, $gSfo4.getQuerySingleContentStatusArrayVariable)(contentStatusReadContext)
                    }
                }
            ],
        __callerPackage__: "data-classification"
    });
    // Branch on the gate to narrow into the correct union member without an unsafe cast.
    // classificationLevelV2 Branch 4 returns an empty shell object (id: "") when the service
    // finds no level for a given ID — treat this as "no classification" (same as null).
    const rawClassificationLevel = useClassificationLevelV2 ? classificationLevelDetails?.classificationLevelV2 : classificationLevelDetails?.classificationLevel;
    const contentClassification = rawClassificationLevel?.id === '' ? null : rawClassificationLevel ?? null;
    const spaceDefaultIsOverridden = classificationLevelDetails?.source === 'CONTENT';
    const errorState = (0, $lwZTW.useClassificationErrorState)(classification, undefined, contentLevelError);
    // Determine whether to set classification either content level classification, or space default classification, or null through a series of booleans.
    // Cases where we should not display content classification:
    // 1. If "No classification" option is selected as content classification
    // 2. If content classification was archived
    // 3. If classification value from state hook is null (i.e. classification was deleted) and delete GQL call is still loading
    // 4. If delete was successful and classification value from state hook is null
    // 5. If there was an error fetching content level classification
    const shouldNotDisplayContentClassification = contentClassification?.id === (0, $1cYlh.NO_CLASSIFICATION_OPTION_ID) || contentClassification?.status === (0, $kknEZ.Status).ARCHIVED || classification === null && deleteLoading || Boolean(contentLevelError);
    // This ternary determines whether to display content classification value from the GQL response or from state hook.
    // Checks whether content ID has changed since the last render, and if it has then we display the classification value from query.
    // (Resolves bug where classification wasn't properly updating when navigating between pages via page tree)
    const contentClassificationFromQueryOrState = shouldReadFromQueries ? contentClassification : currentContentId === contentId && !!classification ? classification : contentClassification;
    // Ultimately, we'll be displaying one of the two values as a content's current classification (in order of priority):
    // 1. Content level classification
    // 2. No classification (may render Add Classification button instead)
    const updatedClassification = shouldNotDisplayContentClassification ? null : contentClassificationFromQueryOrState;
    (0, $cozmU.useEffect)(()=>{
        if (updatedClassification !== classification) {
            setClassification(updatedClassification ?? null);
            setCurrentContentId(contentId);
        }
    }, [
        updatedClassification,
        classification,
        contentId
    ]);
    const isClassificationPublished = classification?.status === (0, $kknEZ.Status).PUBLISHED || updatedClassification?.status === (0, $kknEZ.Status).PUBLISHED;
    const classificationFeatureEnabled = Boolean(classificationLevelDetails?.featureEnabled);
    const shouldDisplayClassification = classificationFeatureEnabled && (!!classification || !!updatedClassification) && !contentLevelLoading && isClassificationPublished;
    const hasNoClassification = !contentLevelLoading && !classification && !updatedClassification;
    const isReclassificationPermitted = (classificationLevelDetails?.isReclassificationPermitted ?? false) || !(0, $6mKj3.expVal)('dlp_auto_classifications_enabled', 'isEnabled', false);
    //useEffect is not run during SSR, so we can't use classification from the state.
    //we cant use setClassification either as it causes side effects which causes unnecessary re-renders.
    //Instead, we can use updatedClassification for initial load for SSR.
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSRedWithClassification = renderServerPlaceholder && updatedClassification;
    const classificationValue = isSSRedWithClassification ? updatedClassification ?? null : classification ?? updatedClassification ?? null;
    return (0, $cozmU.useMemo)(()=>({
            classification: classificationValue ?? null,
            spaceDefaultIsOverridden: spaceDefaultIsOverridden,
            contentLevelLoading: contentLevelLoading,
            contentLevelError: contentLevelError,
            updateContentDataClassificationLevel: updateContentDataClassificationLevel,
            deleteContentDataClassificationLevel: deleteContentDataClassificationLevel,
            setSubmittedClassification: setSubmittedClassification,
            flagStatus: flagStatus,
            setFlagStatus: setFlagStatus,
            errorState: errorState,
            shouldDisplayClassification: shouldDisplayClassification,
            hasNoClassification: hasNoClassification,
            contentStatusContext: contentStatusContext,
            featureEnabled: classificationFeatureEnabled,
            isReclassificationPermitted: isReclassificationPermitted,
            source: classificationLevelDetails?.source,
            canManageSpaceSettings: classificationLevelDetails?.canManageSpaceSettings,
            classificationControlSetting: classificationLevelDetails?.classificationControlSetting,
            userOverrideSetting: classificationLevelDetails?.userOverrideSetting
        }), [
        classificationValue,
        spaceDefaultIsOverridden,
        contentLevelLoading,
        contentLevelError,
        updateContentDataClassificationLevel,
        deleteContentDataClassificationLevel,
        setSubmittedClassification,
        flagStatus,
        setFlagStatus,
        errorState,
        shouldDisplayClassification,
        hasNoClassification,
        contentStatusContext,
        classificationFeatureEnabled,
        isReclassificationPermitted,
        classificationLevelDetails
    ]);
};
const $8f8b1f599c43d665$export$e948ce957637ade5 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { contentId: contentId, contentStatusContext: t1, shouldSkipQueries: t2, shouldPreloadData: t3, shouldReadFromQueries: t4 } = t0;
    const contentStatusContext = t1 === undefined ? "current-only" : t1;
    const shouldSkipQueries = t2 === undefined ? false : t2;
    const shouldPreloadData = t3 === undefined ? false : t3;
    const shouldReadFromQueries = t4 === undefined ? false : t4;
    let useClassificationLevelV2 = false;
    if ((0, $6mKj3.expValEquals)("confluence_classification_level_v2", "isEnabled", true)) useClassificationLevelV2 = true;
    const shouldPreloadContentClassificationData = window.__SSR_RENDERED__ || shouldPreloadData;
    let shouldSkipQueriesForClassification;
    let t5;
    let t6;
    if ($[0] !== contentId || $[1] !== contentStatusContext || $[2] !== shouldSkipQueries) {
        const { readContext: contentStatusReadContext } = (0, $fcQxC.getReadAndWriteContextFromQueryContext)(contentStatusContext);
        shouldSkipQueriesForClassification = shouldSkipQueries || !contentId;
        t5 = contentId ?? "";
        t6 = (0, $gSfo4.getQuerySingleContentStatusArrayVariable)(contentStatusReadContext);
        $[0] = contentId;
        $[1] = contentStatusContext;
        $[2] = shouldSkipQueries;
        $[3] = shouldSkipQueriesForClassification;
        $[4] = t5;
        $[5] = t6;
    } else {
        shouldSkipQueriesForClassification = $[3];
        t5 = $[4];
        t6 = $[5];
    }
    let t7;
    if ($[6] !== t5 || $[7] !== t6) {
        t7 = {
            contentId: t5,
            lowerCaseContentStatusArray: t6
        };
        $[6] = t5;
        $[7] = t6;
        $[8] = t7;
    } else t7 = $[8];
    const queryVariables = t7;
    const t8 = shouldPreloadContentClassificationData ? "cache-first" : "network-only";
    let t9;
    if ($[9] !== shouldSkipQueriesForClassification || $[10] !== t8) {
        t9 = {
            skip: shouldSkipQueriesForClassification,
            errorPolicy: "all",
            fetchPolicy: t8
        };
        $[9] = shouldSkipQueriesForClassification;
        $[10] = t8;
        $[11] = t9;
    } else t9 = $[11];
    const queryOptions = t9;
    const t10 = shouldSkipQueriesForClassification || useClassificationLevelV2;
    let t11;
    if ($[12] !== queryOptions || $[13] !== queryVariables || $[14] !== t10) {
        t11 = {
            variables: queryVariables,
            ...queryOptions,
            skip: t10
        };
        $[12] = queryOptions;
        $[13] = queryVariables;
        $[14] = t10;
        $[15] = t11;
    } else t11 = $[15];
    const { data: objectLevelDataV1, loading: objectLevelLoadingV1, error: objectLevelErrorV1 } = (0, $jMyy4.useQueryInterop)($8f8b1f599c43d665$var$UseContentClassificationContentDataClassificationQuery, {
        ...t11,
        __callerPackage__: "data-classification"
    });
    const t12 = shouldSkipQueriesForClassification || !useClassificationLevelV2;
    let t13;
    if ($[16] !== queryOptions || $[17] !== queryVariables || $[18] !== t12) {
        t13 = {
            variables: queryVariables,
            ...queryOptions,
            skip: t12
        };
        $[16] = queryOptions;
        $[17] = queryVariables;
        $[18] = t12;
        $[19] = t13;
    } else t13 = $[19];
    const { data: objectLevelDataV2, loading: objectLevelLoadingV2, error: objectLevelErrorV2 } = (0, $jMyy4.useQueryInterop)((0, $kJOuS.default), {
        ...t13,
        __callerPackage__: "data-classification"
    });
    const objectLevelData = useClassificationLevelV2 ? objectLevelDataV2 : objectLevelDataV1;
    const objectLevelLoading = useClassificationLevelV2 ? objectLevelLoadingV2 : objectLevelLoadingV1;
    const objectLevelError = useClassificationLevelV2 ? objectLevelErrorV2 : objectLevelErrorV1;
    const t14 = objectLevelData?.singleContent?.classificationLevelDetails;
    let t15;
    if ($[20] !== contentId || $[21] !== contentStatusContext || $[22] !== objectLevelError || $[23] !== objectLevelLoading || $[24] !== shouldReadFromQueries || $[25] !== t14) {
        t15 = {
            contentId: contentId,
            contentStatusContext: contentStatusContext,
            shouldReadFromQueries: shouldReadFromQueries,
            useClassificationLevelV2: useClassificationLevelV2,
            classificationLevelDetails: t14,
            contentLevelLoading: objectLevelLoading,
            contentLevelError: objectLevelError
        };
        $[20] = contentId;
        $[21] = contentStatusContext;
        $[22] = objectLevelError;
        $[23] = objectLevelLoading;
        $[24] = shouldReadFromQueries;
        $[25] = t14;
        $[26] = t15;
    } else t15 = $[26];
    return $8f8b1f599c43d665$var$useContentClassificationMetadata(t15);
} : ({ contentId: contentId, contentStatusContext: contentStatusContext = 'current-only', shouldSkipQueries: shouldSkipQueries = false, shouldPreloadData: shouldPreloadData = false, shouldReadFromQueries: shouldReadFromQueries = false })=>{
    let useClassificationLevelV2 = false;
    if ((0, $6mKj3.expValEquals)('confluence_classification_level_v2', 'isEnabled', true)) useClassificationLevelV2 = true;
    const shouldPreloadContentClassificationData = window.__SSR_RENDERED__ || shouldPreloadData;
    const { readContext: contentStatusReadContext } = (0, $fcQxC.getReadAndWriteContextFromQueryContext)(contentStatusContext);
    const shouldSkipQueriesForClassification = shouldSkipQueries || !contentId;
    const queryVariables = {
        contentId: contentId ?? '',
        lowerCaseContentStatusArray: (0, $gSfo4.getQuerySingleContentStatusArrayVariable)(contentStatusReadContext)
    };
    const queryOptions = {
        skip: shouldSkipQueriesForClassification,
        errorPolicy: 'all',
        fetchPolicy: shouldPreloadContentClassificationData ? 'cache-first' : 'network-only'
    };
    const { data: objectLevelDataV1, loading: objectLevelLoadingV1, error: objectLevelErrorV1 } = (0, $jMyy4.useQueryInterop)($8f8b1f599c43d665$var$UseContentClassificationContentDataClassificationQuery, {
        variables: queryVariables,
        ...queryOptions,
        skip: shouldSkipQueriesForClassification || useClassificationLevelV2,
        __callerPackage__: "data-classification"
    });
    const { data: objectLevelDataV2, loading: objectLevelLoadingV2, error: objectLevelErrorV2 } = (0, $jMyy4.useQueryInterop)((0, $kJOuS.default), {
        variables: queryVariables,
        ...queryOptions,
        skip: shouldSkipQueriesForClassification || !useClassificationLevelV2,
        __callerPackage__: "data-classification"
    });
    const objectLevelData = useClassificationLevelV2 ? objectLevelDataV2 : objectLevelDataV1;
    const objectLevelLoading = useClassificationLevelV2 ? objectLevelLoadingV2 : objectLevelLoadingV1;
    const objectLevelError = useClassificationLevelV2 ? objectLevelErrorV2 : objectLevelErrorV1;
    return $8f8b1f599c43d665$var$useContentClassificationMetadata({
        contentId: contentId,
        contentStatusContext: contentStatusContext,
        shouldReadFromQueries: shouldReadFromQueries,
        useClassificationLevelV2: useClassificationLevelV2,
        classificationLevelDetails: objectLevelData?.singleContent?.classificationLevelDetails,
        contentLevelLoading: objectLevelLoading,
        contentLevelError: objectLevelError
    });
};
const $8f8b1f599c43d665$export$587e979724cc80f9 = ({ contentId: contentId, contentFragmentRef: contentFragmentRef, contentStatusContext: contentStatusContext = 'current-only', shouldReadFromQueries: shouldReadFromQueries = false })=>{
    const content = (0, $6SsN4.useFragment)($8f8b1f599c43d665$export$13c9dac546825a9c, contentFragmentRef);
    return $8f8b1f599c43d665$var$useContentClassificationMetadata({
        contentId: contentId,
        contentStatusContext: contentStatusContext,
        shouldReadFromQueries: shouldReadFromQueries,
        useClassificationLevelV2: (0, $6mKj3.expValEquals)('confluence_classification_level_v2', 'isEnabled', true),
        classificationLevelDetails: content?.classificationLevelDetails
    });
};
module.exports["useContentClassification"] = $8f8b1f599c43d665$export$e948ce957637ade5;
module.exports["useContentClassificationFromFragment"] = $8f8b1f599c43d665$export$587e979724cc80f9;

});

parcelRegister("5dyIT", function(module, exports) {
/**
 * @generated SignedSource<<20621d8c8d7d7f709ac76a84782dff9d>>
 * @relayHash ee02cd6160cc1cfee6fa6d1fba84a159
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4fde877dd091b461b191c46c59a002d0bc95ac007ed500e5c0f27905f57ca0a2
const $916e4ca779bc282e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatuses"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "contentStatuses",
                            "variableName": "contentStatuses"
                        },
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "id"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "BulkDeleteContentDataClassificationLevelPayload",
            "kind": "LinkedField",
            "name": "bulkDeleteContentDataClassificationLevel",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useContentClassificationBulkDeleteContentDataClassificationLevelMutation",
            "selections": v2 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useContentClassificationBulkDeleteContentDataClassificationLevelMutation",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "ee02cd6160cc1cfee6fa6d1fba84a159",
            "id": "4fde877dd091b461b191c46c59a002d0bc95ac007ed500e5c0f27905f57ca0a2",
            "metadata": {},
            "name": "useContentClassificationBulkDeleteContentDataClassificationLevelMutation",
            "operationKind": "mutation",
            "text": "mutation useContentClassificationBulkDeleteContentDataClassificationLevelMutation($id:Long!,$contentStatuses:[ContentDataClassificationMutationContentStatus]!){bulkDeleteContentDataClassificationLevel(input:{id:$id,contentStatuses:$contentStatuses}){success,errors{message}}}"
        }
    };
}();
$916e4ca779bc282e$var$node.hash = "482a842e925e6082fc32c6749e95ba4b";
var $916e4ca779bc282e$export$2e2bcd8739ae039 = $916e4ca779bc282e$var$node;
module.exports["default"] = $916e4ca779bc282e$export$2e2bcd8739ae039;

});

parcelRegister("cod3r", function(module, exports) {
/**
 * @generated SignedSource<<45eb54206aa80f8b681379fd99d07765>>
 * @relayHash e435d6d2ef1fb5eebfc9d5c505f1e65c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c4bdbbd0abf52ccb487e52e67e59bd8bdce38ce12908470cb465fcad9d07bfba
const $cca7f8f2e7a5e122$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "classificationLevelId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatuses"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v3 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "classificationLevelId",
                            "variableName": "classificationLevelId"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentStatuses",
                            "variableName": "contentStatuses"
                        },
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "id"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "BulkUpdateContentDataClassificationLevelPayload",
            "kind": "LinkedField",
            "name": "bulkUpdateContentDataClassificationLevel",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useContentClassificationBulkUpdateContentDataClassificationLevelMutation",
            "selections": v3 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useContentClassificationBulkUpdateContentDataClassificationLevelMutation",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "e435d6d2ef1fb5eebfc9d5c505f1e65c",
            "id": "c4bdbbd0abf52ccb487e52e67e59bd8bdce38ce12908470cb465fcad9d07bfba",
            "metadata": {},
            "name": "useContentClassificationBulkUpdateContentDataClassificationLevelMutation",
            "operationKind": "mutation",
            "text": "mutation useContentClassificationBulkUpdateContentDataClassificationLevelMutation($id:Long!,$contentStatuses:[ContentDataClassificationMutationContentStatus]!,$classificationLevelId:ID!){bulkUpdateContentDataClassificationLevel(input:{id:$id,contentStatuses:$contentStatuses,classificationLevelId:$classificationLevelId}){success,errors{message}}}"
        }
    };
}();
$cca7f8f2e7a5e122$var$node.hash = "9839fe96ab36e63f6aab91bb7d0d00f7";
var $cca7f8f2e7a5e122$export$2e2bcd8739ae039 = $cca7f8f2e7a5e122$var$node;
module.exports["default"] = $cca7f8f2e7a5e122$export$2e2bcd8739ae039;

});

parcelRegister("79mss", function(module, exports) {
/**
 * @generated SignedSource<<217ed72306ad0003c83611da9b9dfec7>>
 * @relayHash 02343eb4ab11fc6471bc117cd9c349d2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2f9794fe079d8566f47a9f279f6b1eb86fd6f7441be80aea326be0f0bc4e003d
const $22165adc85ae14ea$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "lowerCaseContentStatusArray"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "lowerCaseContentStatusArray"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "ClassificationLevelDetails",
                    "kind": "LinkedField",
                    "name": "classificationLevelDetails",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentDataClassificationLevel",
                            "kind": "LinkedField",
                            "name": "classificationLevel",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "guideline"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "guidelineADF"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "description"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "color"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "status"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "featureEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "source"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isReclassificationPermitted"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "canManageSpaceSettings"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "classificationControlSetting"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "userOverrideSetting"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContentClassificationContentDataClassificationQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContentClassificationContentDataClassificationQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "02343eb4ab11fc6471bc117cd9c349d2",
            "id": "2f9794fe079d8566f47a9f279f6b1eb86fd6f7441be80aea326be0f0bc4e003d",
            "metadata": {},
            "name": "useContentClassificationContentDataClassificationQuery",
            "operationKind": "query",
            "text": "query useContentClassificationContentDataClassificationQuery($contentId:ID!,$lowerCaseContentStatusArray:[String]){singleContent(id:$contentId,status:$lowerCaseContentStatusArray){id,classificationLevelDetails{classificationLevel{id,guideline,guidelineADF,description,color,name,status},featureEnabled,source,isReclassificationPermitted,canManageSpaceSettings,classificationControlSetting,userOverrideSetting}}}"
        }
    };
}();
$22165adc85ae14ea$var$node.hash = "e2a3c90b94181436fe0a32faafb92cf6";
var $22165adc85ae14ea$export$2e2bcd8739ae039 = $22165adc85ae14ea$var$node;
module.exports["default"] = $22165adc85ae14ea$export$2e2bcd8739ae039;

});

parcelRegister("XKAGD", function(module, exports) {
/**
 * @generated SignedSource<<697a253c7c1f7174dbc9377eeba53eb2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $162d832ed06b75d0$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = [
        v0 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "guideline"
        },
        {
            "kind": "ScalarField",
            "name": "guidelineADF"
        },
        {
            "kind": "ScalarField",
            "name": "description"
        },
        {
            "kind": "ScalarField",
            "name": "color"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "status"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "useClassificationLevelV2"
            }
        ],
        "kind": "Fragment",
        "name": "useContentClassification_content",
        "selections": [
            v0 /*: any*/ ,
            {
                "concreteType": "ClassificationLevelDetails",
                "kind": "LinkedField",
                "name": "classificationLevelDetails",
                "plural": false,
                "selections": [
                    {
                        "condition": "useClassificationLevelV2",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                            {
                                "concreteType": "ContentDataClassificationLevel",
                                "kind": "LinkedField",
                                "name": "classificationLevel",
                                "plural": false,
                                "selections": v1 /*: any*/ 
                            }
                        ]
                    },
                    {
                        "condition": "useClassificationLevelV2",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "ContentDataClassificationLevel",
                                "kind": "LinkedField",
                                "name": "classificationLevelV2",
                                "plural": false,
                                "selections": v1 /*: any*/ 
                            }
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "featureEnabled"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "source"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isReclassificationPermitted"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "canManageSpaceSettings"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "classificationControlSetting"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "userOverrideSetting"
                    }
                ]
            }
        ],
        "type": "Content"
    };
}();
$162d832ed06b75d0$var$node.hash = "8caefc9ae5cd8ffee2bc5ea1aa65be77";
var $162d832ed06b75d0$export$2e2bcd8739ae039 = $162d832ed06b75d0$var$node;
module.exports["default"] = $162d832ed06b75d0$export$2e2bcd8739ae039;

});

parcelRegister("1cYlh", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $kknEZ = parcelRequire("kknEZ");

const $e02e634ce8a36ce5$export$44086dc4ad5eb01b = 'NO_CLASSIFICATION';
const $e02e634ce8a36ce5$export$ea52aaec0b4536b2 = 'NO_CLASSIFICATION_OPTION';
const $e02e634ce8a36ce5$export$89b67151eed9295a = {
    id: $e02e634ce8a36ce5$export$ea52aaec0b4536b2,
    name: 'No default',
    order: 0,
    definition: "Pages in this space aren\u2019t classified by default.",
    color: 'NONE',
    status: (0, $kknEZ.Status).PUBLISHED
};
const $e02e634ce8a36ce5$export$de715bd2818cd084 = (0, $kSwu1.defineMessages)({
    name: {
        id: "data-classification.no-classification.content-name",
        defaultMessage: "No classification"
    },
    definition: {
        id: "data-classification.no-classification.content-definition",
        defaultMessage: "Content is not classified."
    }
});
const $e02e634ce8a36ce5$var$getDefaultMessage = (descriptor)=>typeof descriptor.defaultMessage === 'string' ? descriptor.defaultMessage : '';
const $e02e634ce8a36ce5$export$59df3feebe765454 = (formatMessage)=>({
        id: $e02e634ce8a36ce5$export$ea52aaec0b4536b2,
        name: formatMessage($e02e634ce8a36ce5$export$de715bd2818cd084.name),
        order: 0,
        definition: formatMessage($e02e634ce8a36ce5$export$de715bd2818cd084.definition),
        color: 'GREY',
        status: (0, $kknEZ.Status).PUBLISHED
    });
const $e02e634ce8a36ce5$export$2589b5a314728bad = $e02e634ce8a36ce5$export$59df3feebe765454($e02e634ce8a36ce5$var$getDefaultMessage);
module.exports["NO_CLASSIFICATION"] = $e02e634ce8a36ce5$export$44086dc4ad5eb01b;
module.exports["NO_CLASSIFICATION_OPTION_ID"] = $e02e634ce8a36ce5$export$ea52aaec0b4536b2;
module.exports["NO_CLASSIFICATION_OPTION"] = $e02e634ce8a36ce5$export$89b67151eed9295a;
module.exports["getNoClassificationForContent"] = $e02e634ce8a36ce5$export$59df3feebe765454;

});

parcelRegister("kknEZ", function(module, exports) {
var $ac489c3aaa697fba$export$96e9906d6d93a972 = /*#__PURE__*/ function(Status) {
    Status["PUBLISHED"] = "PUBLISHED";
    Status["ARCHIVED"] = "ARCHIVED";
    Status["DRAFT"] = "DRAFT";
    return Status;
}({});
module.exports["Status"] = $ac489c3aaa697fba$export$96e9906d6d93a972;

});

parcelRegister("in5LX", function(module, exports) {
var $4e391701f1805c48$export$4417bd7c8606be45 = /*#__PURE__*/ function(FlagStatus) {
    FlagStatus["NONE"] = "NONE";
    FlagStatus["SUCCESS"] = "SUCCESS";
    FlagStatus["ERROR"] = "ERROR";
    FlagStatus["LOADING"] = "LOADING";
    return FlagStatus;
}({});
module.exports["FlagStatus"] = $4e391701f1805c48$export$4417bd7c8606be45;

});

parcelRegister("gSfo4", function(module, exports) {

var $7tHGa = parcelRequire("7tHGa");

const $d569ee9ba15fe187$var$classificationContentStatusEnumToSingleContentSearchArrayMap = {
    [(0, $7tHGa.ContentStatus).CURRENT]: 'current',
    [(0, $7tHGa.ContentStatus).DRAFT]: 'draft',
    [(0, $7tHGa.ContentStatus).ARCHIVED]: 'archived'
};
const $d569ee9ba15fe187$var$getSingleContentStatusStringFromClassificationStatus = (status)=>{
    return $d569ee9ba15fe187$var$classificationContentStatusEnumToSingleContentSearchArrayMap[status];
};
const $d569ee9ba15fe187$export$930e5fd4dd47a5f1 = (statuses)=>{
    return statuses.map((status)=>$d569ee9ba15fe187$var$getSingleContentStatusStringFromClassificationStatus(status)).filter(Boolean);
};
module.exports["getQuerySingleContentStatusArrayVariable"] = $d569ee9ba15fe187$export$930e5fd4dd47a5f1;

});

parcelRegister("7tHGa", function(module, exports) {
var $c76572742e8d6c54$export$b2be22e9d5dd3927 = /*#__PURE__*/ function(ContentStatus) {
    ContentStatus["CURRENT"] = "CURRENT";
    ContentStatus["DRAFT"] = "DRAFT";
    ContentStatus["ARCHIVED"] = "ARCHIVED";
    return ContentStatus;
}({});
module.exports["ContentStatus"] = $c76572742e8d6c54$export$b2be22e9d5dd3927;

});

parcelRegister("fcQxC", function(module, exports) {

var $7tHGa = parcelRequire("7tHGa");

const $304e5e6450715c84$export$20226314cf99189a = (context)=>{
    let readContext;
    let writeContext;
    switch(context){
        case 'draft-only':
            readContext = [
                (0, $7tHGa.ContentStatus).DRAFT
            ];
            writeContext = [
                (0, $7tHGa.ContentStatus).DRAFT
            ];
            break;
        case 'current-only':
            readContext = [
                (0, $7tHGa.ContentStatus).CURRENT,
                (0, $7tHGa.ContentStatus).ARCHIVED
            ];
            writeContext = [
                (0, $7tHGa.ContentStatus).CURRENT
            ];
            break;
        case 'current-and-draft':
            readContext = [
                (0, $7tHGa.ContentStatus).CURRENT,
                (0, $7tHGa.ContentStatus).ARCHIVED
            ];
            writeContext = [
                (0, $7tHGa.ContentStatus).CURRENT,
                (0, $7tHGa.ContentStatus).DRAFT
            ];
            break;
        default:
            readContext = [
                (0, $7tHGa.ContentStatus).CURRENT,
                (0, $7tHGa.ContentStatus).ARCHIVED
            ];
            writeContext = [
                (0, $7tHGa.ContentStatus).CURRENT
            ];
    }
    return {
        readContext: readContext,
        writeContext: writeContext
    };
};
module.exports["getReadAndWriteContextFromQueryContext"] = $304e5e6450715c84$export$20226314cf99189a;

});

parcelRegister("lwZTW", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $aMcHK = parcelRequire("aMcHK");


var $7Sm4c = parcelRequire("7Sm4c");


var $79yie = parcelRequire("79yie");

const $68e08446abc76753$export$a992cfb755534ea3 = (0, $3u0dr.isReactCompilerActiveV2)() ? (currentClassification, spaceLevelError, contentLevelError)=>{
    const $ = (0, $bDgLe.c)(5);
    const [errorState, setErrorState] = (0, $cozmU.useState)((0, $79yie.ErrorState).NO_ERROR);
    let t0;
    let t1;
    if ($[0] !== contentLevelError || $[1] !== currentClassification || $[2] !== spaceLevelError) {
        t0 = ()=>{
            if (!currentClassification) {
                if (spaceLevelError || contentLevelError) {
                    if ((0, $aMcHK.isStatusCodeError)(contentLevelError, "404") || (0, $aMcHK.isStatusCodeError)(spaceLevelError, "404")) {
                        (0, $7Sm4c.markErrorAsHandled)(contentLevelError);
                        (0, $7Sm4c.markErrorAsHandled)(spaceLevelError);
                        setErrorState((0, $79yie.ErrorState).NULL);
                    } else setErrorState((0, $79yie.ErrorState).MESSAGE);
                }
            } else {
                if (spaceLevelError) (0, $7Sm4c.markErrorAsHandled)(spaceLevelError);
                setErrorState((0, $79yie.ErrorState).NO_ERROR);
            }
        };
        t1 = [
            currentClassification,
            spaceLevelError,
            contentLevelError
        ];
        $[0] = contentLevelError;
        $[1] = currentClassification;
        $[2] = spaceLevelError;
        $[3] = t0;
        $[4] = t1;
    } else {
        t0 = $[3];
        t1 = $[4];
    }
    (0, $cozmU.useEffect)(t0, t1);
    return errorState;
} : (currentClassification, spaceLevelError, contentLevelError)=>{
    const [errorState, setErrorState] = (0, $cozmU.useState)((0, $79yie.ErrorState).NO_ERROR);
    (0, $cozmU.useEffect)(()=>{
        // If error exists, display corresponding components
        if (!currentClassification) {
            if (spaceLevelError || contentLevelError) {
                if ((0, $aMcHK.isStatusCodeError)(contentLevelError, '404') || (0, $aMcHK.isStatusCodeError)(spaceLevelError, '404')) {
                    (0, $7Sm4c.markErrorAsHandled)(contentLevelError);
                    (0, $7Sm4c.markErrorAsHandled)(spaceLevelError);
                    // If there is a handled error (404), return nothing
                    setErrorState((0, $79yie.ErrorState).NULL);
                } else // If there is an unhandled error (a non-404 error), return error message with error displays
                setErrorState((0, $79yie.ErrorState).MESSAGE);
            }
        } else {
            // If there's a content classification, we don't want to render null nor an error message for a space level error. We'll just mark the error as handled.
            if (spaceLevelError) (0, $7Sm4c.markErrorAsHandled)(spaceLevelError);
            setErrorState((0, $79yie.ErrorState).NO_ERROR);
        }
    }, [
        currentClassification,
        spaceLevelError,
        contentLevelError
    ]);
    return errorState;
};
module.exports["useClassificationErrorState"] = $68e08446abc76753$export$a992cfb755534ea3;

});

parcelRegister("79yie", function(module, exports) {
var $b3b9916290115f64$export$c1ed4f415b9e7023 = /*#__PURE__*/ function(ErrorState) {
    ErrorState["NULL"] = "NULL";
    ErrorState["MESSAGE"] = "MESSAGE";
    ErrorState["NO_ERROR"] = "NO_ERROR";
    return ErrorState;
}({});
module.exports["ErrorState"] = $b3b9916290115f64$export$c1ed4f415b9e7023;

});

parcelRegister("kJOuS", function(module, exports) {
/**
 * @generated SignedSource<<1ecb2a6d2d19295fae62133387181821>>
 * @relayHash ab62c7356a626dc786625f88620a3290
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 32cd7cbe2ba59d5f06327d98298806c00a63ac71489e6313e3c4721adcb64c66
const $c19c25ac6851ffdf$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "lowerCaseContentStatusArray"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "lowerCaseContentStatusArray"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "ClassificationLevelDetails",
                    "kind": "LinkedField",
                    "name": "classificationLevelDetails",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentDataClassificationLevel",
                            "kind": "LinkedField",
                            "name": "classificationLevelV2",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "guideline"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "guidelineADF"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "description"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "color"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "status"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "featureEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "source"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isReclassificationPermitted"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "canManageSpaceSettings"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "classificationControlSetting"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "userOverrideSetting"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContentClassificationV2ContentDataClassificationQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContentClassificationV2ContentDataClassificationQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "ab62c7356a626dc786625f88620a3290",
            "id": "32cd7cbe2ba59d5f06327d98298806c00a63ac71489e6313e3c4721adcb64c66",
            "metadata": {},
            "name": "useContentClassificationV2ContentDataClassificationQuery",
            "operationKind": "query",
            "text": "query useContentClassificationV2ContentDataClassificationQuery($contentId:ID!,$lowerCaseContentStatusArray:[String]){singleContent(id:$contentId,status:$lowerCaseContentStatusArray){id,classificationLevelDetails{classificationLevelV2{id,guideline,guidelineADF,description,color,name,status},featureEnabled,source,isReclassificationPermitted,canManageSpaceSettings,classificationControlSetting,userOverrideSetting}}}"
        }
    };
}();
$c19c25ac6851ffdf$var$node.hash = "bdf80caa76bbd41df830127b1a3309c9";
var $c19c25ac6851ffdf$export$2e2bcd8739ae039 = $c19c25ac6851ffdf$var$node;
module.exports["default"] = $c19c25ac6851ffdf$export$2e2bcd8739ae039;

});

parcelRegister("2XV0z", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cMvQV = parcelRequire("cMvQV");


var $3WPGR = parcelRequire("3WPGR");

const $8c9f801fa4f4ae90$export$a5c14cb4205739db = (isPagePreview, leftRightPaddingValueOffset, isPresenterMode)=>{
    const $ = (0, $bDgLe.c)(9);
    const [height, setHeight] = (0, $cozmU.useState)(0);
    const [width, setWidth] = (0, $cozmU.useState)(0);
    const [leftOffset, setLeftOffset] = (0, $cozmU.useState)(0);
    const observerRef = (0, $cozmU.useRef)(null);
    let t0;
    let t1;
    if ($[0] !== isPagePreview || $[1] !== isPresenterMode || $[2] !== leftOffset || $[3] !== leftRightPaddingValueOffset) {
        t0 = ()=>{
            let queryId;
            if (isPresenterMode) queryId = "[id='presenter-mode-header-image-container']";
            else if (isPagePreview) queryId = "[id='header-row-wrapper']";
            else queryId = ".content-screen-component";
            const pageScrollParent = document.querySelector(queryId);
            if (pageScrollParent) {
                observerRef.current = new ResizeObserver((entries)=>{
                    if ((0, $cMvQV.isChrome)() || (0, $cMvQV.isSafari)()) {
                        const innerWidth = Math.floor(entries[0]?.target.clientWidth);
                        const outerWidth = Math.floor(entries[0]?.borderBoxSize?.[0].inlineSize);
                        if (outerWidth > innerWidth) setLeftOffset(outerWidth - innerWidth);
                    }
                    const currentWidth = Math.floor(entries[0]?.target.clientWidth) - leftOffset - leftRightPaddingValueOffset;
                    setWidth(currentWidth);
                    setHeight((0, $3WPGR.getDynamicCoverImageHeight)(currentWidth));
                });
                observerRef.current.observe(pageScrollParent);
                return ()=>observerRef?.current?.disconnect();
            }
        };
        t1 = [
            observerRef,
            leftOffset,
            isPagePreview,
            leftRightPaddingValueOffset,
            isPresenterMode
        ];
        $[0] = isPagePreview;
        $[1] = isPresenterMode;
        $[2] = leftOffset;
        $[3] = leftRightPaddingValueOffset;
        $[4] = t0;
        $[5] = t1;
    } else {
        t0 = $[4];
        t1 = $[5];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    if ($[6] !== height || $[7] !== width) {
        t2 = {
            height: height,
            width: width
        };
        $[6] = height;
        $[7] = width;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
};
module.exports["usePageHeightWidthObserver"] = $8c9f801fa4f4ae90$export$a5c14cb4205739db;

});

parcelRegister("3WPGR", function(module, exports) {

var $1d2ww = parcelRequire("1d2ww");


var $jVylI = parcelRequire("jVylI");


var $zalpJ = parcelRequire("zalpJ");


var $75Ax4 = parcelRequire("75Ax4");


var $dkxaU = parcelRequire("dkxaU");


var $bKd7w = parcelRequire("bKd7w");

function $523f2f8bee18c451$export$da000b5ddbbe9afc(p) {
    let value;
    let version;
    try {
        value = JSON.parse(p.value);
        version = parseInt(JSON.parse(p.version.number));
        // Counting quotes to determine if the value we receive is a string (old cover photos experience without repositioning feature)
        // or object (new cover photos experience with repositioning feature - has a position property in the object).
        // The new designs will have value as an object but stored as a string: "{"id":"http://website.com","position":45}"
        // We need to JSON.parse it again to turn it into an object. The old cover photos will just have value as a string: value: "123-abc",
        // so there is no need to JSON parse it again. We will set its position as the default position value to support this new value format.
        const quoteMatches = value.match(/"/g);
        const quoteCount = quoteMatches ? quoteMatches.length : 0;
        // if quoteCount != null this mean value is part of the new experience so we need to JSON parse the info again since it is a stored as a string and we want the object
        if (quoteCount) try {
            value = JSON.parse(value);
        } catch (e) {
            value = null;
        }
        else // otherwise it was just a regular string (part of old experience without repositioning)
        value = {
            id: value,
            position: (0, $75Ax4.DEFAULT_POSITION_VALUE)
        };
    } catch (e) {
        value = null;
        version = null;
    }
    return p ? {
        value: value,
        version: version
    } : null;
}
function $523f2f8bee18c451$export$64dc6e3789165979(appearanceValue) {
    let appearance;
    if (appearanceValue) try {
        appearance = JSON.parse(appearanceValue);
    } catch (e) {
        appearance = null;
    }
    return appearance ?? (0, $1d2ww.ContentAppearanceType).DEFAULT;
}
function $523f2f8bee18c451$export$df5897f4041f380b(contentQueryData, isLivePage) {
    const pageWidthType = contentQueryData?.content?.nodes?.[0]?.appearancePublished?.nodes?.[0]?.value || `"default"`;
    const properties = contentQueryData?.content?.nodes?.[0]?.properties?.nodes || [];
    const published = isLivePage ? properties[0] : properties.find((p)=>p?.key === (0, $bKd7w.CoverPictureIdPropertyKey).PUBLISHED);
    const coverPictureWidth = contentQueryData?.content?.nodes?.[0]?.metadata?.frontend?.coverPictureWidth || (0, $jVylI.COVERPICTUREWIDTH).FULL;
    const { titleContentProperties: titleContentProperties } = (0, $zalpJ.getTitleContentProperty)(contentQueryData);
    const isTitleCenterAligned = titleContentProperties?.titleLayoutAlignment == (0, $jVylI.TitleAlignmentType).CENTER;
    const coverPicture = {
        draft: null,
        published: $523f2f8bee18c451$export$da000b5ddbbe9afc(published)
    };
    let publishedValue;
    try {
        publishedValue = JSON.parse(pageWidthType);
    } catch (e) {
        publishedValue = 'default';
    }
    const contentAppearance = {
        draft: '',
        published: publishedValue
    };
    const hasCoverPicture = !!coverPicture?.published?.value?.id;
    return {
        coverPicture: coverPicture,
        contentAppearance: contentAppearance,
        hasCoverPicture: hasCoverPicture,
        coverPictureWidth: coverPictureWidth,
        isTitleCenterAligned: isTitleCenterAligned
    };
}
const $523f2f8bee18c451$export$abc9309e623c0351 = (width)=>{
    return (0, $dkxaU.calcDynamicCoverImageHeight)(width);
};
function $523f2f8bee18c451$export$8a432f79b719eeda(imageUrl) {
    if (!imageUrl) return false;
    return imageUrl.includes('images.unsplash.com') || imageUrl.includes('dam-cdn.atl.orangelogic.com') || /^https?:\/\/wac-cdn-[^.]+\.atlassian\.com/.test(imageUrl);
}
module.exports["propertyToId"] = $523f2f8bee18c451$export$da000b5ddbbe9afc;
module.exports["getRendererCoverPictureInfo"] = $523f2f8bee18c451$export$df5897f4041f380b;
module.exports["getDynamicCoverImageHeight"] = $523f2f8bee18c451$export$abc9309e623c0351;
module.exports["isAllowedExternalCoverPictureUrl"] = $523f2f8bee18c451$export$8a432f79b719eeda;

});

parcelRegister("jVylI", function(module, exports) {
var $341ba7bb7f83b82d$export$18feebdc268a3ef1 = /*#__PURE__*/ function(TitleAlignmentType) {
    TitleAlignmentType["LEFT"] = "LEFT";
    TitleAlignmentType["CENTER"] = "CENTER";
    return TitleAlignmentType;
}({});
const $341ba7bb7f83b82d$export$f5c76f9de4274e9b = {
    titleLayoutAlignment: "LEFT",
    titlePropertySubtitle: '',
    titlePropertySubtitleEnabled: false,
    titlePropertyBylineEnabled: false,
    titlePropertyEmojiEnabled: true,
    headerImageStylingEnabled: false
};
var $341ba7bb7f83b82d$export$f84f565b1b747c24 = /*#__PURE__*/ function(COVERPICTUREWIDTH) {
    COVERPICTUREWIDTH["FULL"] = "full";
    COVERPICTUREWIDTH["FIXED"] = "fixed";
    return COVERPICTUREWIDTH;
}({});
module.exports["TitleAlignmentType"] = $341ba7bb7f83b82d$export$18feebdc268a3ef1;
module.exports["defaultPropertyValue"] = $341ba7bb7f83b82d$export$f5c76f9de4274e9b;
module.exports["COVERPICTUREWIDTH"] = $341ba7bb7f83b82d$export$f84f565b1b747c24;

});

parcelRegister("zalpJ", function(module, exports) {

var $4lSsc = parcelRequire("4lSsc");


var $eB536 = parcelRequire("eB536");


var $1Y111 = parcelRequire("1Y111");


var $jtuBN = parcelRequire("jtuBN");


var $jVylI = parcelRequire("jVylI");


var $gzIc1 = parcelRequire("gzIc1");

'use no memo';
const $20e32f1deb8c1fe0$var$UseTitleContentPropertiesForPublishedPageQuery = (0, $1Y111.default);
const $20e32f1deb8c1fe0$export$e114ec4e88c7fe33 = (0, $eB536.default);
const $20e32f1deb8c1fe0$export$c9b63bbfd869a91 = (0, $4lSsc.default);
const $20e32f1deb8c1fe0$export$cef8b8531fa62d5f = (data)=>{
    const titlePropertyContent = data?.content?.nodes?.[0]?.pageTitlePublished?.nodes?.find((node)=>node?.key == 'page-title-property-published');
    const coverPictureWidth = data?.content?.nodes?.[0]?.metadata?.frontend?.coverPictureWidth || (0, $jVylI.COVERPICTUREWIDTH).FULL;
    if (titlePropertyContent?.value) try {
        return {
            titleContentProperties: (0, $gzIc1.contentPropertyHelper)(titlePropertyContent),
            coverPictureWidth: coverPictureWidth
        };
    } catch  {
        return {
            titleContentProperties: (0, $jVylI.defaultPropertyValue),
            coverPictureWidth: coverPictureWidth
        };
    }
    else return {
        titleContentProperties: (0, $jVylI.defaultPropertyValue),
        coverPictureWidth: coverPictureWidth
    };
};
const $20e32f1deb8c1fe0$var$QUERY_OPTIONS = (contentId)=>({
        variables: {
            contentId: contentId,
            status: [
                'current',
                'archived',
                'draft'
            ]
        },
        fetchPolicy: 'cache-first'
    });
const $20e32f1deb8c1fe0$export$9e9d248809e028e8 = ({ contentId: contentId })=>{
    const options = $20e32f1deb8c1fe0$var$QUERY_OPTIONS(contentId);
    const { data: data, error: error, loading: loading } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)($20e32f1deb8c1fe0$var$UseTitleContentPropertiesForPublishedPageQuery, {
        variables: options.variables,
        skip: !contentId,
        __callerPackage__: "content-topper"
    });
    if (!loading && data && !error) {
        const { titleContentProperties: titleContentProperties, coverPictureWidth: coverPictureWidth } = $20e32f1deb8c1fe0$export$cef8b8531fa62d5f(data);
        return {
            titleContentProperties: titleContentProperties,
            coverPictureWidth: coverPictureWidth
        };
    }
    return {
        titleContentProperties: (0, $jVylI.defaultPropertyValue),
        coverPictureWidth: (0, $jVylI.COVERPICTUREWIDTH).FULL
    };
};
module.exports["useTitleContentPropertiesForPublishedPage_content"] = $20e32f1deb8c1fe0$export$e114ec4e88c7fe33;
module.exports["PreloadHomepageIdQuery"] = $20e32f1deb8c1fe0$export$c9b63bbfd869a91;
module.exports["getTitleContentProperty"] = $20e32f1deb8c1fe0$export$cef8b8531fa62d5f;
module.exports["useTitleContentPropertiesForPublishedPage"] = $20e32f1deb8c1fe0$export$9e9d248809e028e8;

});

parcelRegister("4lSsc", function(module, exports) {
/**
 * @generated SignedSource<<27d66eab829e89ba017f17104702246d>>
 * @relayHash 9a31bcd84d31650a9d9bf2ee5045af08
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d71357cc47e8209b6702e84965f7bc95e5209b869d1f811a6841b17bccc364cb
const $f70a6e2cb787614b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "9a31bcd84d31650a9d9bf2ee5045af08",
            "id": "d71357cc47e8209b6702e84965f7bc95e5209b869d1f811a6841b17bccc364cb",
            "metadata": {},
            "name": "useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
            "operationKind": "query",
            "text": "query useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery($spaceKey:String!){space(key:$spaceKey){id,homepage{id}}}"
        }
    };
}();
$f70a6e2cb787614b$var$node.hash = "57678666b7eece7bec595c782b54d686";
var $f70a6e2cb787614b$export$2e2bcd8739ae039 = $f70a6e2cb787614b$var$node;
module.exports["default"] = $f70a6e2cb787614b$export$2e2bcd8739ae039;

});

parcelRegister("eB536", function(module, exports) {
/**
 * @generated SignedSource<<f3aa298d710112bdac45cdae3936c970>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3cc0a8cff50ad3c7$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v0 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "useTitleContentPropertiesForPublishedPage_content",
        "selections": [
            v0 /*: any*/ ,
            {
                "alias": "pageTitlePublished",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "key",
                        "value": "page-title-property-published"
                    }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": v1 /*: any*/ ,
                "storageKey": "properties(key:\"page-title-property-published\")"
            },
            {
                "alias": "pageTitleDraft",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "key",
                        "value": "page-title-property-draft"
                    }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": v1 /*: any*/ ,
                "storageKey": "properties(key:\"page-title-property-draft\")"
            },
            {
                "concreteType": "ContentMetadata",
                "kind": "LinkedField",
                "name": "metadata",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                        "kind": "LinkedField",
                        "name": "frontend",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "coverPictureWidth"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Content"
    };
}();
$3cc0a8cff50ad3c7$var$node.hash = "6913c519b951b36b57b6c77657b055fd";
var $3cc0a8cff50ad3c7$export$2e2bcd8739ae039 = $3cc0a8cff50ad3c7$var$node;
module.exports["default"] = $3cc0a8cff50ad3c7$export$2e2bcd8739ae039;

});

parcelRegister("1Y111", function(module, exports) {
/**
 * @generated SignedSource<<c93173dea6bc8ed379cb4b9b29fb2a88>>
 * @relayHash 6af15886385d86202fbacd0200dc99eb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2ea0830d2908f5128944c3441d9d519bbd473f098af90ea4fb9f9816c899f8a0
const $66bccefa41a7dece$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                }
            ]
        }
    ], v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "alias": "pageTitlePublished",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "page-title-property-published"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v2 /*: any*/ ,
                            "storageKey": "properties(key:\"page-title-property-published\")"
                        },
                        {
                            "alias": "pageTitleDraft",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "page-title-property-draft"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v2 /*: any*/ ,
                            "storageKey": "properties(key:\"page-title-property-draft\")"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "coverPictureWidth"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useTitleContentPropertiesForPublishedPageQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useTitleContentPropertiesForPublishedPageQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "6af15886385d86202fbacd0200dc99eb",
            "id": "2ea0830d2908f5128944c3441d9d519bbd473f098af90ea4fb9f9816c899f8a0",
            "metadata": {},
            "name": "useTitleContentPropertiesForPublishedPageQuery",
            "operationKind": "query",
            "text": "query useTitleContentPropertiesForPublishedPageQuery($contentId:ID,$status:[String]){content(id:$contentId,status:$status){nodes{id,pageTitlePublished:properties(key:\"page-title-property-published\"){nodes{id,key,value,version{number}}},pageTitleDraft:properties(key:\"page-title-property-draft\"){nodes{id,key,value,version{number}}},metadata{frontend{coverPictureWidth}}}}}"
        }
    };
}();
$66bccefa41a7dece$var$node.hash = "9a5b243b4d944acf33577dfb16711cea";
var $66bccefa41a7dece$export$2e2bcd8739ae039 = $66bccefa41a7dece$var$node;
module.exports["default"] = $66bccefa41a7dece$export$2e2bcd8739ae039;

});

parcelRegister("gzIc1", function(module, exports) {

var $jVylI = parcelRequire("jVylI");

const $bda1e030ddde07df$export$e2d610ec02a291e1 = (jsonProperty)=>{
    let value;
    try {
        value = JSON.parse(jsonProperty.value);
        // objects returned from the content property can be double stringified
        const quoteMatches = value.match(/"/g);
        const quoteCount = quoteMatches ? quoteMatches.length : 0;
        // if quoteCount != null this means that the object is double wrapped as a string and needs to be parsed again
        if (quoteCount) try {
            value = JSON.parse(value);
        } catch (error) {
            value = (0, $jVylI.defaultPropertyValue);
            throw new Error(`unable to parse value: ${error.message}`);
        }
    } catch (error) {
        value = (0, $jVylI.defaultPropertyValue);
        throw error;
    }
    return value;
};
module.exports["contentPropertyHelper"] = $bda1e030ddde07df$export$e2d610ec02a291e1;

});

parcelRegister("75Ax4", function(module, exports) {
const $4cdfc0aeee394c11$export$5a7e63ae23cefcb = 50;
const $4cdfc0aeee394c11$export$535fddacdd1506a3 = '?utm_source=Confluence&utm_medium=referral';
const $4cdfc0aeee394c11$export$41f496cb75ebdbf4 = 140;
const $4cdfc0aeee394c11$export$e1a10bbd512cde25 = 750;
const $4cdfc0aeee394c11$export$e63c70235aab4f60 = 38 / 7;
const $4cdfc0aeee394c11$export$a9612492250fd8ea = 'min(max(calc(calc( 100vw - var(--leftPanelWidth, 0px) - var(--leftSidebarWidth, 0px) - var(--rightPanelWidth, 0px) - var(--rightSidebarWidth, 0px) ) * (7 / 38)), 140px), 750px)';
const $4cdfc0aeee394c11$export$b143b999ce4b353a = `round(down, calc(100cqw / (${$4cdfc0aeee394c11$export$e63c70235aab4f60})), 1px)`;
const $4cdfc0aeee394c11$export$f94fb8385ddeea1f = 800;
const $4cdfc0aeee394c11$export$f60e801aad1e2af5 = 147;
const $4cdfc0aeee394c11$export$a682f4bbb3650e11 = 200;
module.exports["DEFAULT_POSITION_VALUE"] = $4cdfc0aeee394c11$export$5a7e63ae23cefcb;
module.exports["REFERRAL_LINK"] = $4cdfc0aeee394c11$export$535fddacdd1506a3;
module.exports["MIN_DYNAMIC_COVER_IMAGE_HEIGHT"] = $4cdfc0aeee394c11$export$41f496cb75ebdbf4;
module.exports["MAX_DYNAMIC_COVER_IMAGE_HEIGHT"] = $4cdfc0aeee394c11$export$e1a10bbd512cde25;
module.exports["COVER_IMAGE_WIDTH_TO_HEIGHT_RATIO"] = $4cdfc0aeee394c11$export$e63c70235aab4f60;
module.exports["CALCULATE_SCALED_COVER_IMAGE_HEIGHT_FOR_EDIT_PAGE"] = $4cdfc0aeee394c11$export$b143b999ce4b353a;
module.exports["COVER_IMAGE_FIXED_WIDTH"] = $4cdfc0aeee394c11$export$f94fb8385ddeea1f;
module.exports["COVER_IMAGE_FIXED_HEIGHT"] = $4cdfc0aeee394c11$export$f60e801aad1e2af5;
module.exports["SMART_SPACE_OVERVIEW_FIXED_HEIGHT_FULL_WIDTH"] = $4cdfc0aeee394c11$export$a682f4bbb3650e11;

});

parcelRegister("dkxaU", function(module, exports) {

var $75Ax4 = parcelRequire("75Ax4");

const $17b31ae3aa6020db$export$6a5c726aaec5b09 = (width)=>{
    const imgHeight = Math.floor(width / (0, $75Ax4.COVER_IMAGE_WIDTH_TO_HEIGHT_RATIO));
    if (imgHeight < (0, $75Ax4.MIN_DYNAMIC_COVER_IMAGE_HEIGHT)) return 0, $75Ax4.MIN_DYNAMIC_COVER_IMAGE_HEIGHT;
    else if (imgHeight >= (0, $75Ax4.MAX_DYNAMIC_COVER_IMAGE_HEIGHT)) return 0, $75Ax4.MAX_DYNAMIC_COVER_IMAGE_HEIGHT;
    else return imgHeight;
};
module.exports["calcDynamicCoverImageHeight"] = $17b31ae3aa6020db$export$6a5c726aaec5b09;

});

parcelRegister("bKd7w", function(module, exports) {
var $9558c78c09e4ba60$export$da638b84af7eb6eb = /*#__PURE__*/ function(CoverPictureIdPropertyKey) {
    CoverPictureIdPropertyKey["PUBLISHED"] = "cover-picture-id-published";
    CoverPictureIdPropertyKey["DRAFT"] = "cover-picture-id-draft";
    return CoverPictureIdPropertyKey;
}({});
module.exports["CoverPictureIdPropertyKey"] = $9558c78c09e4ba60$export$da638b84af7eb6eb;

});

parcelRegister("fwwrH", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $0ba5a3a0ecf1d3dc$export$b44f4ceffd8a6e44 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "0XSep",
    name: "SmartCreateFeedbackBannerLoader",
    loader: async ()=>(await (parcelRequire("6EqCT"))).SmartCreateFeedbackBanner
});
module.exports["SmartCreateFeedbackBannerLoader"] = $0ba5a3a0ecf1d3dc$export$b44f4ceffd8a6e44;

});

parcelRegister("6EqCT", function(module, exports) {

let $4d7b21f3edbfe36e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4d7b21f3edbfe36e$var$load("hzVe9").then(()=>parcelRequire('dSB3l'));

});

parcelRegister("fiBb3", function(module, exports) {

var $fxLAA = parcelRequire("fxLAA");

const $23261b803687ce64$export$2b17287e63c772da = (0, $fxLAA.default);
module.exports["ContentHeaderUnifiedQuery"] = $23261b803687ce64$export$2b17287e63c772da;

});

parcelRegister("fxLAA", function(module, exports) {
/**
 * @generated SignedSource<<1b65fe0ead6353a8c28b7afcf9227c9e>>
 * @relayHash 6f882df997a26df263a08178b5f95bf9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7f2e702bc747eb69f75e8fe2f952ae04598c2335805a8e2a0438ed3c833ed8ee
const $d3bfdb752c338d80$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "embeddedContentRender"
    }, v2 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeClassification"
    }, v3 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeDevDocsBylineConnection"
    }, v4 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includePublicLink"
    }, v5 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isMarkdownModeEnabled"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "limit"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v9 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "useAccessButtonFragment"
    }, v10 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "useClassificationLevelV2"
    }, v11 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "useEditButtonFragment"
    }, v12 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "useNewContentTopper"
    }, v13 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "useObjectHeaderFragment"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "versionOverride"
    }, v15 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
    }, v16 = [
        {
            "kind": "Variable",
            "name": "embeddedContentRender",
            "variableName": "embeddedContentRender"
        },
        v15 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "status",
            "variableName": "status"
        },
        {
            "kind": "Variable",
            "name": "version",
            "variableName": "versionOverride"
        }
    ], v17 = {
        "kind": "ScalarField",
        "name": "id"
    }, v18 = {
        "kind": "ScalarField",
        "name": "type"
    }, v19 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v20 = {
        "kind": "ScalarField",
        "name": "title"
    }, v21 = {
        "kind": "ScalarField",
        "name": "status"
    }, v22 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v23 = {
        "kind": "ScalarField",
        "name": "key"
    }, v24 = {
        "kind": "ScalarField",
        "name": "value"
    }, v25 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v17 /*: any*/ ,
                v23 /*: any*/ ,
                v24 /*: any*/ 
            ]
        }
    ], v26 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "devdocsProperties",
                    "smartFolderProperties"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v25 /*: any*/ ,
        "storageKey": "properties(keys:[\"devdocsProperties\",\"smartFolderProperties\"])"
    }, v27 = {
        "kind": "ScalarField",
        "name": "number"
    }, v28 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v17 /*: any*/ ,
                v23 /*: any*/ ,
                v24 /*: any*/ ,
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        v27 /*: any*/ 
                    ]
                }
            ]
        }
    ], v29 = {
        "alias": "appearancePublished",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "content-appearance-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v28 /*: any*/ ,
        "storageKey": "properties(key:\"content-appearance-published\")"
    }, v30 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v31 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v32 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v33 = [
        v18 /*: any*/ ,
        v22 /*: any*/ ,
        v31 /*: any*/ ,
        v32 /*: any*/ 
    ], v34 = {
        "alias": "emojiTitlePublished",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "emoji-title-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v28 /*: any*/ ,
        "storageKey": "properties(key:\"emoji-title-published\")"
    }, v35 = {
        "condition": "useNewContentTopper",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "alias": "pageTitlePublished",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "key",
                        "value": "page-title-property-published"
                    }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": v28 /*: any*/ ,
                "storageKey": "properties(key:\"page-title-property-published\")"
            }
        ]
    }, v36 = {
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "editor"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v25 /*: any*/ ,
        "storageKey": "properties(key:\"editor\")"
    }, v37 = {
        "kind": "ScalarField",
        "name": "name"
    }, v38 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v17 /*: any*/ ,
            v37 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "homepageId"
            }
        ]
    }, v39 = {
        "kind": "ScalarField",
        "name": "message"
    }, v40 = {
        "kind": "ScalarField",
        "name": "friendlyWhen"
    }, v41 = {
        "kind": "ScalarField",
        "name": "when"
    }, v42 = {
        "kind": "ScalarField",
        "name": "contentTypeModified"
    }, v43 = {
        "concreteType": "ContentProperties",
        "kind": "LinkedField",
        "name": "contentProperties",
        "plural": false,
        "selections": [
            {
                "concreteType": "PublishedContentProperties",
                "kind": "LinkedField",
                "name": "latest",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "generatedBy"
                    },
                    {
                        "condition": "isMarkdownModeEnabled",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isMarkdownMode"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v44 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "sourceTemplateEntityId"
            },
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            },
            {
                "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                "kind": "LinkedField",
                "name": "frontend",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "fabricEditorSupported"
                    },
                    {
                        "condition": "useNewContentTopper",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "coverPictureWidth"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v45 = {
        "condition": "includePublicLink",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "pageId",
                        "variableName": "contentId"
                    }
                ],
                "concreteType": "PublicLinkPage",
                "kind": "LinkedField",
                "name": "publicLinkPage",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "pageId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "pageStatus"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "accessType"
                    }
                ]
            }
        ]
    }, v46 = [
        v15 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "limit",
            "variableName": "limit"
        }
    ], v47 = {
        "kind": "ScalarField",
        "name": "count"
    }, v48 = {
        "kind": "ScalarField",
        "name": "isCurrentUserContributor"
    }, v49 = {
        "kind": "ScalarField",
        "name": "isOwnerContributor"
    }, v50 = [
        v23 /*: any*/ ,
        v24 /*: any*/ 
    ], v51 = {
        "args": [
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "spaceKey"
            }
        ],
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v17 /*: any*/ ,
            {
                "concreteType": "Theme",
                "kind": "LinkedField",
                "name": "theme",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "themeKey"
                    }
                ]
            },
            {
                "concreteType": "LookAndFeel",
                "kind": "LinkedField",
                "name": "lookAndFeel",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "MapOfStringToString",
                        "kind": "LinkedField",
                        "name": "headings",
                        "plural": true,
                        "selections": v50 /*: any*/ 
                    },
                    {
                        "concreteType": "ContentLookAndFeel",
                        "kind": "LinkedField",
                        "name": "content",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "ContainerLookAndFeel",
                                "kind": "LinkedField",
                                "name": "header",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "background"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundAttachment"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundBlendMode"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundClip"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundColor"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundImage"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundOrigin"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundPosition"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundRepeat"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundSize"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "borderRadius"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "padding"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v52 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v53 = [
        v52 /*: any*/ ,
        v18 /*: any*/ ,
        v22 /*: any*/ ,
        v31 /*: any*/ ,
        v32 /*: any*/ 
    ], v54 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v55 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v23 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "alias"
            }
        ]
    }, v56 = [
        v52 /*: any*/ ,
        v22 /*: any*/ 
    ], v57 = [
        v17 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "guideline"
        },
        {
            "kind": "ScalarField",
            "name": "guidelineADF"
        },
        {
            "kind": "ScalarField",
            "name": "description"
        },
        {
            "kind": "ScalarField",
            "name": "color"
        },
        v37 /*: any*/ ,
        v21 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ContentHeaderUnifiedQuery",
            "selections": [
                {
                    "args": v16 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v17 /*: any*/ ,
                                {
                                    "condition": "useEditButtonFragment",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "EditContentButton_content"
                                                    }
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "editContentButton"
                                        }
                                    ]
                                },
                                {
                                    "condition": "useAccessButtonFragment",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "useShareAndRestrictButtonData_content"
                                                    }
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "shareAndRestrictButtonData"
                                        }
                                    ]
                                },
                                {
                                    "condition": "useObjectHeaderFragment",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "ContentTypesHeader_content"
                                                    }
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "contentTypesHeader"
                                        }
                                    ]
                                },
                                {
                                    "condition": "includeClassification",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "args": [
                                                            {
                                                                "kind": "Variable",
                                                                "name": "useClassificationLevelV2",
                                                                "variableName": "useClassificationLevelV2"
                                                            }
                                                        ],
                                                        "kind": "FragmentSpread",
                                                        "name": "BylineClassification_content"
                                                    }
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "bylineClassificationFragment"
                                        }
                                    ]
                                },
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ ,
                                {
                                    "condition": "includeDevDocsBylineConnection",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "ancestors",
                                            "plural": true,
                                            "selections": [
                                                v17 /*: any*/ ,
                                                v20 /*: any*/ ,
                                                v18 /*: any*/ ,
                                                v19 /*: any*/ ,
                                                {
                                                    "concreteType": "History",
                                                    "kind": "LinkedField",
                                                    "name": "history",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "createdBy",
                                                            "plural": false,
                                                            "selections": [
                                                                v22 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v26 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v29 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        v30 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": v33 /*: any*/ 
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "ownedBy",
                                            "plural": false,
                                            "selections": v33 /*: any*/ 
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "lastOwnedBy",
                                            "plural": false,
                                            "selections": v33 /*: any*/ 
                                        }
                                    ]
                                },
                                v34 /*: any*/ ,
                                v35 /*: any*/ ,
                                v36 /*: any*/ ,
                                v38 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v39 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": v33 /*: any*/ 
                                        },
                                        v40 /*: any*/ ,
                                        v41 /*: any*/ ,
                                        v27 /*: any*/ ,
                                        v42 /*: any*/ 
                                    ]
                                },
                                v43 /*: any*/ ,
                                v44 /*: any*/ 
                            ]
                        }
                    ]
                },
                v45 /*: any*/ ,
                {
                    "args": v46 /*: any*/ ,
                    "concreteType": "ContentContributors",
                    "kind": "LinkedField",
                    "name": "contentContributors",
                    "plural": false,
                    "selections": [
                        v47 /*: any*/ ,
                        v48 /*: any*/ ,
                        v49 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": v33 /*: any*/ 
                        }
                    ]
                },
                v51 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v7 /*: any*/ ,
                v14 /*: any*/ ,
                v1 /*: any*/ ,
                v6 /*: any*/ ,
                v12 /*: any*/ ,
                v5 /*: any*/ ,
                v3 /*: any*/ ,
                v13 /*: any*/ ,
                v11 /*: any*/ ,
                v9 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                v10 /*: any*/ ,
                v8 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ContentHeaderUnifiedQuery",
            "selections": [
                {
                    "args": v16 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ ,
                                v29 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        v30 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": v53 /*: any*/ 
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "ownedBy",
                                            "plural": false,
                                            "selections": v53 /*: any*/ 
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "lastOwnedBy",
                                            "plural": false,
                                            "selections": v53 /*: any*/ 
                                        }
                                    ]
                                },
                                v34 /*: any*/ ,
                                v36 /*: any*/ ,
                                v38 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v39 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": v53 /*: any*/ 
                                        },
                                        v40 /*: any*/ ,
                                        v41 /*: any*/ ,
                                        v27 /*: any*/ ,
                                        v42 /*: any*/ 
                                    ]
                                },
                                v43 /*: any*/ ,
                                v44 /*: any*/ ,
                                {
                                    "condition": "useEditButtonFragment",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        v54 /*: any*/ ,
                                        {
                                            "concreteType": "ContentMetadata",
                                            "kind": "LinkedField",
                                            "name": "metadata",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                                    "kind": "LinkedField",
                                                    "name": "frontend",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "embedded"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "collabService"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "Space",
                                            "kind": "LinkedField",
                                            "name": "space",
                                            "plural": false,
                                            "selections": [
                                                v23 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "useAccessButtonFragment",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasInheritedRestrictions"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasRestrictions"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasViewRestrictions"
                                        }
                                    ]
                                },
                                {
                                    "condition": "useObjectHeaderFragment",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        v54 /*: any*/ ,
                                        v55 /*: any*/ ,
                                        {
                                            "alias": "smartFolderProperties",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "keys",
                                                    "value": [
                                                        "smartFolderProperties"
                                                    ]
                                                }
                                            ],
                                            "concreteType": "PaginatedJsonContentPropertyList",
                                            "kind": "LinkedField",
                                            "name": "properties",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JsonContentProperty",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": v50 /*: any*/ 
                                                }
                                            ],
                                            "storageKey": "properties(keys:[\"smartFolderProperties\"])"
                                        },
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "draftVersion",
                                            "plural": false,
                                            "selections": [
                                                v42 /*: any*/ ,
                                                v27 /*: any*/ ,
                                                v40 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "by",
                                                    "plural": false,
                                                    "selections": v56 /*: any*/ 
                                                },
                                                v41 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "includeClassification",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        v54 /*: any*/ ,
                                        v55 /*: any*/ ,
                                        {
                                            "concreteType": "ClassificationLevelDetails",
                                            "kind": "LinkedField",
                                            "name": "classificationLevelDetails",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "condition": "useClassificationLevelV2",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "ContentDataClassificationLevel",
                                                            "kind": "LinkedField",
                                                            "name": "classificationLevel",
                                                            "plural": false,
                                                            "selections": v57 /*: any*/ 
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "useClassificationLevelV2",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "ContentDataClassificationLevel",
                                                            "kind": "LinkedField",
                                                            "name": "classificationLevelV2",
                                                            "plural": false,
                                                            "selections": v57 /*: any*/ 
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "featureEnabled"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "source"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isReclassificationPermitted"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canManageSpaceSettings"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "classificationControlSetting"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "userOverrideSetting"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "includeDevDocsBylineConnection",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "ancestors",
                                            "plural": true,
                                            "selections": [
                                                v17 /*: any*/ ,
                                                v20 /*: any*/ ,
                                                v18 /*: any*/ ,
                                                v19 /*: any*/ ,
                                                {
                                                    "concreteType": "History",
                                                    "kind": "LinkedField",
                                                    "name": "history",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "createdBy",
                                                            "plural": false,
                                                            "selections": v56 /*: any*/ 
                                                        }
                                                    ]
                                                },
                                                v26 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v35 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v46 /*: any*/ ,
                    "concreteType": "ContentContributors",
                    "kind": "LinkedField",
                    "name": "contentContributors",
                    "plural": false,
                    "selections": [
                        v47 /*: any*/ ,
                        v48 /*: any*/ ,
                        v49 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": v53 /*: any*/ 
                        }
                    ]
                },
                v51 /*: any*/ ,
                v45 /*: any*/ 
            ]
        },
        "params": {
            "cacheID": "6f882df997a26df263a08178b5f95bf9",
            "id": "7f2e702bc747eb69f75e8fe2f952ae04598c2335805a8e2a0438ed3c833ed8ee",
            "metadata": {},
            "name": "ContentHeaderUnifiedQuery",
            "operationKind": "query",
            "text": "query ContentHeaderUnifiedQuery($contentId:ID!,$spaceKey:String,$versionOverride:Int,$embeddedContentRender:String,$limit:Int,$useNewContentTopper:Boolean=false,$isMarkdownModeEnabled:Boolean=false,$includeDevDocsBylineConnection:Boolean=false,$useObjectHeaderFragment:Boolean=false,$useEditButtonFragment:Boolean=false,$useAccessButtonFragment:Boolean=false,$includePublicLink:Boolean=false,$includeClassification:Boolean=false,$useClassificationLevelV2:Boolean=false,$status:[String]){content(id:$contentId,version:$versionOverride,embeddedContentRender:$embeddedContentRender,status:$status){nodes{id,...EditContentButton_content@include(if:$useEditButtonFragment),...useShareAndRestrictButtonData_content@include(if:$useAccessButtonFragment),...ContentTypesHeader_content@include(if:$useObjectHeaderFragment),...BylineClassification_content_4MZOe@include(if:$includeClassification),type,subType,title,status,ancestors@include(if:$includeDevDocsBylineConnection){id,title,type,subType,history{createdBy{__typename,displayName}},properties(keys:[\"devdocsProperties\",\"smartFolderProperties\"]){nodes{id,key,value}}},appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},history{createdDate,createdBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},ownedBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},lastOwnedBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}}},emojiTitlePublished:properties(key:\"emoji-title-published\"){nodes{id,key,value,version{number}}},pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},properties(key:\"editor\"){nodes{id,key,value}},space{id,name,homepageId},version{message,by{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},friendlyWhen,when,number,contentTypeModified},contentProperties{latest{generatedBy,isMarkdownMode@include(if:$isMarkdownModeEnabled)}},metadata{sourceTemplateEntityId,lastModifiedDate,frontend{fabricEditorSupported,coverPictureWidth@include(if:$useNewContentTopper)}}}},publicLinkPage(pageId:$contentId)@include(if:$includePublicLink){pageId,pageStatus,accessType},contentContributors(id:$contentId,limit:$limit){count,isCurrentUserContributor,isOwnerContributor,nodes{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}}},space(key:$spaceKey){id,theme{themeKey},lookAndFeel{headings{key,value},content{header{background,backgroundAttachment,backgroundBlendMode,backgroundClip,backgroundColor,backgroundImage,backgroundOrigin,backgroundPosition,backgroundRepeat,backgroundSize,borderRadius,padding}}}}}fragment BylineClassification_content_4MZOe on Content{id,title,type,status,operations{operation,targetType},space{id,name,key,alias},...useContentClassification_content_4MZOe}fragment ContentTypesHeader_content on Content{id,title,operations{operation,targetType},space{id,name,key,alias},type,subType,status,smartFolderProperties:properties(keys:[\"smartFolderProperties\"]){nodes{key,value}},version{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when},draftVersion{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when}}fragment EditContentButton_content on Content{id,type,operations{operation,targetType},metadata{frontend{fabricEditorSupported,embedded,collabService}},subType,space{id,key}}fragment useContentClassification_content_4MZOe on Content{id,classificationLevelDetails{classificationLevel@skip(if:$useClassificationLevelV2){id,guideline,guidelineADF,description,color,name,status},classificationLevelV2@include(if:$useClassificationLevelV2){id,guideline,guidelineADF,description,color,name,status},featureEnabled,source,isReclassificationPermitted,canManageSpaceSettings,classificationControlSetting,userOverrideSetting}}fragment useShareAndRestrictButtonData_content on Content{id,hasInheritedRestrictions,hasRestrictions,hasViewRestrictions,title}"
        }
    };
}();
$d3bfdb752c338d80$var$node.hash = "48d594c4584d37499acde161aa7f48a8";
var $d3bfdb752c338d80$export$2e2bcd8739ae039 = $d3bfdb752c338d80$var$node;
module.exports["default"] = $d3bfdb752c338d80$export$2e2bcd8739ae039;

});

parcelRegister("80xNa", function(module, exports) {
const $5d488939c8bec967$export$21191b0c00ca25f4 = 4;
const $5d488939c8bec967$export$4b915fb24c39b396 = {
    //copied from change-edition. Was not allowed to import it into preloadContentHeader + to prevent bundle size increase.
    FREE: 'FREE',
    PREMIUM: 'PREMIUM',
    STANDARD: 'STANDARD'
};
module.exports["DEFAULT_CONTRIBUTORS_FETCH_LIMIT"] = $5d488939c8bec967$export$21191b0c00ca25f4;
module.exports["CONFLUENCE_EDITION"] = $5d488939c8bec967$export$4b915fb24c39b396;

});

parcelRegister("fabPv", function(module, exports) {

var $1uFM6 = parcelRequire("1uFM6");

const $6c808818233403ab$export$b5cee5b5cb88c751 = (error)=>{
    if (!error) return false;
    const { graphQLErrors: graphQLErrors = [], networkError: networkError } = error;
    return graphQLErrors.length > 0 && !networkError && graphQLErrors.every((graphQLError)=>(0, $1uFM6.isUnauthorizedError)(graphQLError) && graphQLError.path?.length === 1 && graphQLError.path[0] === 'space');
};
module.exports["isSpaceDenialOnly"] = $6c808818233403ab$export$b5cee5b5cb88c751;

});

parcelRegister("5W37o", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6b4nE = parcelRequire("6b4nE");


var $iqPSe = parcelRequire("iqPSe");


var $9Z1sw = parcelRequire("9Z1sw");


var $eSLr0 = parcelRequire("eSLr0");


var $80koo = parcelRequire("80koo");

parcelRequire("fh5wq");
var $f2ook = parcelRequire("f2ook");
var $FFoHM = parcelRequire("FFoHM");

const $7b4282d7c94dcb09$var$webPanelPageMetadataStyle = {
    verticalAlign: 'top',
    display: 'flex',
    alignItem: 'center',
    flexWrap: 'nowrap'
};
const $7b4282d7c94dcb09$var$WRM_MODULES = [
    /*
 https://stash.atlassian.com/projects/CONFCLOUD/repos/confluence-page-banner/browse
 still used for "page-metadata-banner-items"
 https://community.developer.atlassian.com/t/page-metadata-banner-in-custom-theme/12364
 */ 'wr!com.atlassian.confluence.plugins.confluence-page-banner:page-banner-common-resources'
];
class $7b4282d7c94dcb09$export$d55a1c591b25ea6e extends (0, $cozmU.PureComponent) {
    handleQueryCompleted(data) {
        const isPanelLoadedAndEmpty = data && data.webPanels && data.webPanels.length === 0;
        this.setState({
            isPanelLoadedAndEmpty: isPanelLoadedAndEmpty
        });
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Z1sw.WebPanelLocation), {
            contentId: this.props.contentId,
            location: (0, $eSLr0.ATL_PAGE_METADATA),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: $7b4282d7c94dcb09$var$webPanelPageMetadataStyle,
            onCompleted: (data)=>this.handleQueryCompleted(data)
        }, ({ panels: panels })=>{
            if (!panels || !panels.length) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $80koo.RequireLegacyWRM), {
                wrm: $7b4282d7c94dcb09$var$WRM_MODULES
            }, ()=>panels.map((panel)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqPSe.WebPanel), {
                        key: panel.completeKey,
                        html: panel.html
                    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f2ook.ConnectAppLoadEnd), {
                location: (0, $eSLr0.ATL_PAGE_METADATA),
                items: (0, $FFoHM.getConnectAppsItems)(panels)
            }));
        }), this.state.isPanelLoadedAndEmpty && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f2ook.ConnectAppLoadEnd), {
            location: (0, $eSLr0.ATL_PAGE_METADATA),
            items: (0, $FFoHM.getConnectAppsItems)([])
        }));
    }
    constructor(...args){
        super(...args);
        this.state = {
            isPanelLoadedAndEmpty: false
        };
    }
}
$7b4282d7c94dcb09$export$d55a1c591b25ea6e.propTypes = {
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired
};
module.exports["PageMetadataAtl"] = $7b4282d7c94dcb09$export$d55a1c591b25ea6e;

});

parcelRegister("iqPSe", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $brpfO = parcelRequire("brpfO");


var $gH1Fi = parcelRequire("gH1Fi");


var $ep3mz = parcelRequire("ep3mz");


var $eSLr0 = parcelRequire("eSLr0");

function $c50a10795e04dcb9$export$bbe14c99ac0820b3(t0) {
    const $ = (0, $bDgLe.c)(11);
    const { html: html, panelId: panelId, panelLocation: panelLocation } = t0;
    const containerRef = (0, $cozmU.useRef)(null);
    const [t1] = (0, $ep3mz.usePageState)();
    const { contentId: contentId, spaceKey: spaceKey } = t1;
    const dimensionsRef = (0, $gH1Fi.useExtensionDimensions)(panelLocation === (0, $eSLr0.ATL_GENERAL) ? (0, $eSLr0.ATL_GENERAL) : undefined, panelId, contentId || spaceKey || "");
    let t2;
    if ($[0] !== dimensionsRef) {
        t2 = (element)=>{
            containerRef.current = element;
            dimensionsRef(element);
        };
        $[0] = dimensionsRef;
        $[1] = t2;
    } else t2 = $[1];
    const panelRef = t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            const container = containerRef.current;
            if (!container) return;
            (0, $brpfO.evalLegacyConnectInlineScripts)(container);
        };
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== html || $[4] !== panelId) {
        t4 = [
            html,
            panelId
        ];
        $[3] = html;
        $[4] = panelId;
        $[5] = t4;
    } else t4 = $[5];
    (0, $cozmU.useLayoutEffect)(t3, t4);
    let t5;
    if ($[6] !== html) {
        t5 = {
            __html: html
        };
        $[6] = html;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== panelRef || $[9] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: panelRef,
            "data-vc-ignore-if-no-layout-shift": true,
            dangerouslySetInnerHTML: t5
        });
        $[8] = panelRef;
        $[9] = t5;
        $[10] = t6;
    } else t6 = $[10];
    return t6;
}
module.exports["WebPanel"] = $c50a10795e04dcb9$export$bbe14c99ac0820b3;

});

parcelRegister("brpfO", function(module, exports) {

var $cpjd2 = parcelRequire("cpjd2");

const $5886a35f608ee97f$var$evalScripts = (allScripts)=>{
    allScripts.forEach((elementScript)=>{
        /**
		 * When evaluating the connect scripts, the eval function inherits the context in which is it called.
		 *
		 * This means that the eval function will have access to the variables and functions
		 * in the current scope. One of these variables is the `require` passed in from Atlaspack's module system.
		 *
		 * Since the eval scripts rely on AMD's require being globally available, and Atlaspack
		 * is now shadowing that variable, we need to evaluate the scripts in the global scope.
		 *
		 * We can do this using "indirect" eval, see the MDN docs for more info:
		 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/eval#direct_and_indirect_eval
		 *
		 * Assigning the eval function to a variable is enough to trigger the indirect eval behavior,
		 * and the scripts will be able to access the global require.
		 */ const evalInGlobalScope = eval;
        evalInGlobalScope(elementScript.innerHTML);
    });
};
function $5886a35f608ee97f$export$5beb7086100d432e(container, isEarlyInitFGEnabled = false) {
    // Connect macros have an inline script that doesn't work automatically when
    // rendered in react using dangerouslySetInnerHTML. This script evaluates any
    // connect macro.
    if (!container) return Promise.reject(new Error('evalLegacyConnectInlineScripts missing container argument'));
    const connectScripts = Array.from(container.querySelectorAll('script.ap-iframe-body-script'));
    const macroScripts = Array.from(container.querySelectorAll('script.cc-macro-body-script'));
    const allScripts = connectScripts.concat(macroScripts);
    // If the connect resources are preloaded, we don't need to download them again, just evaluate the scripts.
    if (window.__CONNECT_RESOURCES_PRELOADED__ && isEarlyInitFGEnabled) {
        $5886a35f608ee97f$var$evalScripts(allScripts);
        return Promise.resolve(null);
    }
    return new Promise((resolve)=>{
        if (allScripts.length > 0) // Download the connect web resources required to render an add-on before evaluating the inline scripts.
        (0, $cpjd2.requireLegacyWRM)([
            // ensure navigator-context misc dep is loaded before navigator-context
            'wr!confluence.web.resources:querystring',
            // resource to provide the context value of AP.navigator.getLocation
            'wr!confluence.web.resources:navigator-context',
            'wr!com.atlassian.plugins.atlassian-connect-plugin:confluence-atlassian-connect-resources-v5'
        ], ()=>{
            $5886a35f608ee97f$var$evalScripts(allScripts);
            resolve(null);
        }, ()=>{});
        else resolve(null);
    });
}
module.exports["evalLegacyConnectInlineScripts"] = $5886a35f608ee97f$export$5beb7086100d432e;

});

parcelRegister("gH1Fi", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9wGTI = parcelRequire("9wGTI");


var $1P7Cq = parcelRequire("1P7Cq");


var $7W9kD = parcelRequire("7W9kD");

const $46bdebab359d4884$export$8adc0cb9461bf99f = (source, extensionId, contextKey)=>{
    const renderServerPlaceholder = (0, $1P7Cq.useIsSSROrHydrating)();
    const cleanup = (0, $cozmU.useRef)(undefined);
    // The observation belongs to this page context, even when React reuses its DOM node.
    const observationContext = (0, $cozmU.useMemo)(()=>({
            source: source,
            extensionId: extensionId,
            contextKey: contextKey
        }), [
        source,
        extensionId,
        contextKey
    ]);
    return (0, $cozmU.useCallback)((element)=>{
        const { source: source, extensionId: extensionId } = observationContext;
        cleanup.current?.();
        cleanup.current = undefined;
        if (!renderServerPlaceholder && element && source && extensionId && (0, $9wGTI.fg)('confluence_ufo_banner_extension_dimensions')) cleanup.current = (0, $7W9kD.observeExtensionDimensions)(element, source, extensionId);
    }, [
        observationContext,
        renderServerPlaceholder
    ]);
};
module.exports["useExtensionDimensions"] = $46bdebab359d4884$export$8adc0cb9461bf99f;

});

parcelRegister("7W9kD", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $9f0ae7ee0cebc5b7$var$registrations = new Map();
let $9f0ae7ee0cebc5b7$var$observer;
// Bound the addition to the existing UFO payload, even on tenants with many apps.
const $9f0ae7ee0cebc5b7$var$MAX_REPORTED_EXTENSIONS = 50;
const $9f0ae7ee0cebc5b7$export$dbee8f9a070db66b = (element, source, extensionId)=>{
    if (!extensionId || !window.ResizeObserver || !(0, $9wGTI.fg)('confluence_ufo_banner_extension_dimensions')) return;
    if (!$9f0ae7ee0cebc5b7$var$observer) $9f0ae7ee0cebc5b7$var$observer = new ResizeObserver((entries)=>{
        if (!(0, $9wGTI.fg)('confluence_ufo_banner_extension_dimensions')) return;
        for (const entry of entries){
            const registration = $9f0ae7ee0cebc5b7$var$registrations.get(entry.target);
            if (!registration) continue;
            // These wrappers have no padding/border. contentRect supplies physical CSS
            // pixels after layout, without synchronous layout reads or React updates.
            // This measures allocated host space, including any active preset height.
            const { height: height, width: width } = entry.contentRect;
            if (Number.isFinite(height) && Number.isFinite(width) && height >= 0 && width >= 0) registration.dimensions = {
                height: Math.round(height),
                width: Math.round(width)
            };
        }
    });
    const registration = {
        source: source,
        extensionId: extensionId
    };
    $9f0ae7ee0cebc5b7$var$registrations.set(element, registration);
    $9f0ae7ee0cebc5b7$var$observer.observe(element);
    return ()=>{
        if ($9f0ae7ee0cebc5b7$var$registrations.get(element) !== registration) return;
        $9f0ae7ee0cebc5b7$var$observer?.unobserve(element);
        $9f0ae7ee0cebc5b7$var$registrations.delete(element);
        if ($9f0ae7ee0cebc5b7$var$registrations.size === 0) {
            $9f0ae7ee0cebc5b7$var$observer?.disconnect();
            $9f0ae7ee0cebc5b7$var$observer = undefined;
        }
    };
};
const $9f0ae7ee0cebc5b7$export$e4b460b98000468c = ()=>{
    const groups = new Map();
    for (const [element, { source: source, extensionId: extensionId, dimensions: dimensions }] of $9f0ae7ee0cebc5b7$var$registrations){
        if (!element.isConnected || !dimensions) continue;
        const group = groups.get(source) ?? new Map();
        group.set(extensionId, {
            ...dimensions
        });
        groups.set(source, group);
    }
    let reported = 0;
    let omitted = 0;
    const extensionDimensions = Object.fromEntries(Array.from(groups, ([source, dimensions])=>[
            source,
            Object.fromEntries(Array.from(dimensions).filter(()=>{
                if (reported < $9f0ae7ee0cebc5b7$var$MAX_REPORTED_EXTENSIONS) {
                    reported++;
                    return true;
                }
                omitted++;
                return false;
            }))
        ]));
    return {
        extensionDimensions: extensionDimensions,
        ...omitted ? {
            extensionDimensionsOmittedCount: omitted
        } : {}
    };
};
module.exports["observeExtensionDimensions"] = $9f0ae7ee0cebc5b7$export$dbee8f9a070db66b;
module.exports["getExtensionDimensions"] = $9f0ae7ee0cebc5b7$export$e4b460b98000468c;

});

parcelRegister("9Z1sw", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $eq95w = parcelRequire("eq95w");


var $cozmU = parcelRequire("cozmU");


var $ah4BL = parcelRequire("ah4BL");


var $bavCP = parcelRequire("bavCP");


var $8wW9d = parcelRequire("8wW9d");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");


var $ep3mz = parcelRequire("ep3mz");


var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");


var $eSLr0 = parcelRequire("eSLr0");


var $3QyBm = parcelRequire("3QyBm");


var $iqPSe = parcelRequire("iqPSe");

const $0aea74171df1eb15$export$d97dfe528d83a912 = (0, $eq95w.default);
const $0aea74171df1eb15$var$WebPanelLocationBatchContext = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $0aea74171df1eb15$export$784950ebf49d8a5f = (location)=>{
    const $ = (0, $bDgLe.c)(3);
    const batchContext = (0, $cozmU.useContext)($0aea74171df1eb15$var$WebPanelLocationBatchContext);
    let t0;
    if ($[0] !== batchContext || $[1] !== location) {
        t0 = batchContext?.locations.includes(location) ? batchContext.getResultForLocation(location) : null;
        $[0] = batchContext;
        $[1] = location;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
};
const $0aea74171df1eb15$var$getUniqueLocations = (locations)=>Array.from(new Set(locations.filter(Boolean)));
const $0aea74171df1eb15$var$groupPanelsByLocation = (webPanels)=>{
    const panelsByLocation = new Map();
    webPanels?.forEach((panel)=>{
        if (panel?.location) {
            const panels = panelsByLocation.get(panel.location) ?? [];
            panels.push(panel);
            panelsByLocation.set(panel.location, panels);
        }
    });
    return panelsByLocation;
};
const $0aea74171df1eb15$var$getWebPanelLocationVariables = ({ location: location, locations: locations, contentIdentifier: contentIdentifier, spaceIdentifier: spaceIdentifier })=>{
    const selectedLocations = locations ?? (location ? [
        location
    ] : []);
    const locationVariables = selectedLocations.length > 1 ? {
        location: null,
        locations: selectedLocations
    } : {
        location: selectedLocations[0]
    };
    return {
        ...locationVariables,
        ...contentIdentifier != null ? {
            contentId: contentIdentifier
        } : {},
        ...contentIdentifier == null && spaceIdentifier != null ? {
            spaceKey: spaceIdentifier
        } : {}
    };
};
const $0aea74171df1eb15$var$useWebPanelLocationIdentifiers = ()=>{
    const $ = (0, $bDgLe.c)(8);
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { getQueryParams: getQueryParams } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    let t0;
    let t1;
    if ($[0] !== contentId || $[1] !== getQueryParams || $[2] !== spaceKey) {
        const queryParams = getQueryParams();
        t0 = spaceKey || (0, $c3Qwv.getSingleParam)(queryParams, "spaceKey") || (0, $c3Qwv.getSingleParam)(queryParams, "key");
        t1 = contentId || (0, $c3Qwv.getSingleParam)(queryParams, "pageId");
        $[0] = contentId;
        $[1] = getQueryParams;
        $[2] = spaceKey;
        $[3] = t0;
        $[4] = t1;
    } else {
        t0 = $[3];
        t1 = $[4];
    }
    let t2;
    if ($[5] !== t0 || $[6] !== t1) {
        t2 = {
            spaceIdentifier: t0,
            contentIdentifier: t1
        };
        $[5] = t0;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
};
const $0aea74171df1eb15$var$UFOWebPanelLocationWrapper = (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, locationName: locationName, panels: panels } = t0;
    const panelHasContent = panels?.length && panels.some($0aea74171df1eb15$var$_temp);
    let t1;
    let t2;
    if ($[0] !== panels) {
        t1 = ()=>{
            (0, $8wW9d.recordNonContentAppKeys)("web-panel", (panels ?? []).map($0aea74171df1eb15$var$_temp2));
        };
        t2 = [
            panels
        ];
        $[0] = panels;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    if (!panelHasContent) return children;
    const t3 = `web-panel-${locationName}`;
    let t4;
    if ($[3] !== children || $[4] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ah4BL.UFOThirdPartySegment), {
            name: t3
        }, children);
        $[3] = children;
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
};
const $0aea74171df1eb15$var$MemoizedAtlGeneralWebPanel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { panel: panel } = t0;
    let t1;
    if ($[0] !== panel.completeKey || $[1] !== panel.html) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqPSe.WebPanel), {
            panelId: panel.completeKey,
            html: panel.html,
            panelLocation: (0, $eSLr0.ATL_GENERAL)
        });
        $[0] = panel.completeKey;
        $[1] = panel.html;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
}, (prevProps, nextProps)=>prevProps.panel.completeKey === nextProps.panel.completeKey);
const $0aea74171df1eb15$var$WebPanelLocationBatchContextProvider = (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { data: data, loading: loading, error: error, locations: locations, children: children } = t0;
    data?.webPanels;
    const t1 = data?.webPanels;
    let t2;
    if ($[0] !== t1) {
        t2 = $0aea74171df1eb15$var$groupPanelsByLocation(t1);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const panelsByLocation = t2;
    let t3;
    if ($[2] !== data || $[3] !== error || $[4] !== loading || $[5] !== panelsByLocation) {
        t3 = (location)=>({
                data: data ? {
                    webPanels: panelsByLocation.get(location) ?? []
                } : data,
                loading: loading,
                error: error
            });
        $[2] = data;
        $[3] = error;
        $[4] = loading;
        $[5] = panelsByLocation;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== locations || $[8] !== t3) {
        t4 = {
            locations: locations,
            getResultForLocation: t3
        };
        $[7] = locations;
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    const contextValue = t4;
    let t5;
    if ($[10] !== children || $[11] !== contextValue) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0aea74171df1eb15$var$WebPanelLocationBatchContext.Provider, {
            value: contextValue
        }, children);
        $[10] = children;
        $[11] = contextValue;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
};
const $0aea74171df1eb15$export$2c530b46a1768809 = (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { locations: locations, children: children } = t0;
    const { spaceIdentifier: spaceIdentifier, contentIdentifier: contentIdentifier } = $0aea74171df1eb15$var$useWebPanelLocationIdentifiers();
    let t1;
    if ($[0] !== locations) {
        t1 = locations.join("\0");
        $[0] = locations;
        $[1] = t1;
    } else t1 = $[1];
    const locationsKey = t1;
    let t2;
    if ($[2] !== locationsKey) {
        t2 = $0aea74171df1eb15$var$getUniqueLocations(locationsKey.split("\0"));
        $[2] = locationsKey;
        $[3] = t2;
    } else t2 = $[3];
    const uniqueLocations = t2;
    let t3;
    if ($[4] !== contentIdentifier || $[5] !== spaceIdentifier || $[6] !== uniqueLocations) {
        t3 = $0aea74171df1eb15$var$getWebPanelLocationVariables({
            locations: uniqueLocations,
            contentIdentifier: contentIdentifier,
            spaceIdentifier: spaceIdentifier
        });
        $[4] = contentIdentifier;
        $[5] = spaceIdentifier;
        $[6] = uniqueLocations;
        $[7] = t3;
    } else t3 = $[7];
    const variables = t3;
    if (spaceIdentifier === "byDraft" || uniqueLocations.length === 0) {
        let t4;
        if ($[8] !== children) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
            $[8] = children;
            $[9] = t4;
        } else t4 = $[9];
        return t4;
    }
    let t4;
    if ($[10] !== children || $[11] !== uniqueLocations) {
        t4 = (t5)=>{
            const { data: data, loading: loading, error: error } = t5;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0aea74171df1eb15$var$WebPanelLocationBatchContextProvider, {
                data: data,
                loading: loading,
                error: error,
                locations: uniqueLocations
            }, children);
        };
        $[10] = children;
        $[11] = uniqueLocations;
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] !== t4 || $[14] !== variables) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bavCP.QueryInterop), {
            query: $0aea74171df1eb15$export$d97dfe528d83a912,
            variables: variables,
            fetchPolicy: "cache-first",
            __callerPackage__: "web-panel-location"
        }, t4);
        $[13] = t4;
        $[14] = variables;
        $[15] = t5;
    } else t5 = $[15];
    return t5;
};
const $0aea74171df1eb15$export$2482f01f112556a = ({ location: location, style: style = {}, renderWhenLoading: renderWhenLoading, fetchPolicy: // Query is preloaded on the server-side. reused the preloaded data.
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
fetchPolicy = 'cache-and-network', children: children, onCompleted: onCompleted })=>{
    const { spaceIdentifier: spaceIdentifier, contentIdentifier: contentIdentifier } = $0aea74171df1eb15$var$useWebPanelLocationIdentifiers();
    const batchResult = $0aea74171df1eb15$export$784950ebf49d8a5f(location);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const completedBatchResultKeyRef = (0, $cozmU.useRef)(null);
    const EXPERIENCE_NAME_BY_LOCATION = {
        [(0, $eSLr0.ATL_FOOTER)]: (0, $irVI7.EXTENSION_POINT_HOME_FOOTER_EXPERIENCE),
        [(0, $eSLr0.ATL_GENERAL)]: (0, $irVI7.EXTENSION_POINT_HOME_HEADER_EXPERIENCE),
        [(0, $eSLr0.ATL_EDITOR_SAVEBAR)]: (0, $irVI7.EXTENSION_POINT_EDITOR_SAVEBAR_EXPERIENCE)
    };
    const experienceName = EXPERIENCE_NAME_BY_LOCATION[location] || null;
    (0, $cozmU.useEffect)(()=>{
        if (experienceName) experienceTracker.start({
            name: experienceName
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const variables = $0aea74171df1eb15$var$getWebPanelLocationVariables({
        location: location,
        contentIdentifier: contentIdentifier,
        spaceIdentifier: spaceIdentifier
    });
    (0, $cozmU.useEffect)(()=>{
        if (batchResult?.loading || batchResult?.error || !batchResult?.data || !onCompleted) return;
        const batchResultKey = `${contentIdentifier || ''}:${spaceIdentifier || ''}:${location}`;
        if (completedBatchResultKeyRef.current !== batchResultKey) {
            completedBatchResultKeyRef.current = batchResultKey;
            onCompleted();
        }
    }, [
        batchResult,
        contentIdentifier,
        location,
        onCompleted,
        spaceIdentifier
    ]);
    // TODO: The task to remove this hack is captured in CFE-1873.
    // There's some weird scenario where the UI ends up with a space key of "byDraft" relating to the way tinymce
    // creates content. Given that it's tinymce specific, I'm applying this hack for now and we can remove it once we're
    // at 100% rollout for the Fabric editor.
    if (spaceIdentifier === 'byDraft') return null;
    const renderWebPanels = ({ data: data, loading: loading, error: error })=>{
        if (!renderWhenLoading) {
            if (error || !data || loading && !(0, $9wGTI.fg)('confluence_web_panel_location_render_loading')) return null;
        }
        let panels = (data?.webPanels || []).filter((panel)=>panel);
        panels = (0, $3QyBm.filterConnectAppsFromExtensionPoints)(location, panels);
        // For panels that don't have a placeholder
        if (!renderWhenLoading && !panels.length) {
            if (experienceName) experienceTracker.succeed({
                name: experienceName
            });
            return null;
        }
        const shouldMemoizeAtlGeneralWebPanel = location === (0, $eSLr0.ATL_GENERAL) && (0, $6mKj3.expValEquals)('confluence_memorize_atl_general_connect', 'isEnabled', true);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0aea74171df1eb15$var$UFOWebPanelLocationWrapper, {
            locationName: location,
            panels: panels
        }, children ? children({
            panels: panels
        }) : panels.map((panel)=>{
            return shouldMemoizeAtlGeneralWebPanel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0aea74171df1eb15$var$MemoizedAtlGeneralWebPanel, {
                key: panel.completeKey,
                panel: panel
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqPSe.WebPanel), {
                key: panel.completeKey,
                panelId: panel.completeKey,
                html: panel.html,
                panelLocation: location
            });
        })), experienceName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: experienceName
        }) : null);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        /* eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766 */ style: style,
        "data-vc-ignore-if-no-layout-shift": true
    }, batchResult ? renderWebPanels(batchResult) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bavCP.QueryInterop), {
        query: $0aea74171df1eb15$export$d97dfe528d83a912,
        variables: variables,
        fetchPolicy: fetchPolicy,
        onCompleted: onCompleted,
        __callerPackage__: "web-panel-location"
    }, renderWebPanels));
};
function $0aea74171df1eb15$var$_temp(panel) {
    return panel.html !== "";
}
function $0aea74171df1eb15$var$_temp2(panel_0) {
    return panel_0.completeKey;
}
module.exports["WebPanelLocationQuery"] = $0aea74171df1eb15$export$d97dfe528d83a912;
module.exports["useWebPanelLocationBatchResult"] = $0aea74171df1eb15$export$784950ebf49d8a5f;
module.exports["WebPanelLocationBatchProvider"] = $0aea74171df1eb15$export$2c530b46a1768809;
module.exports["WebPanelLocation"] = $0aea74171df1eb15$export$2482f01f112556a;

});

parcelRegister("eq95w", function(module, exports) {
/**
 * @generated SignedSource<<663f21e6dfcd4d4c24754e54b45772e8>>
 * @relayHash 8b133e3996bec5b3feff733a500f3451
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1205b4c053e3bf1a11112543759ae8178f8f0e4161f42e7f549b3c8cdcd56847
const $9206d19da4400201$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "location"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "locations"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "location",
                    "variableName": "location"
                },
                {
                    "kind": "Variable",
                    "name": "locations",
                    "variableName": "locations"
                }
            ],
            "concreteType": "WebPanel",
            "kind": "LinkedField",
            "name": "webPanels",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "moduleKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "completeKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "html"
                },
                {
                    "kind": "ScalarField",
                    "name": "location"
                },
                {
                    "kind": "ScalarField",
                    "name": "label"
                },
                {
                    "kind": "ScalarField",
                    "name": "weight"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "WebPanelLocationQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "WebPanelLocationQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "8b133e3996bec5b3feff733a500f3451",
            "id": "1205b4c053e3bf1a11112543759ae8178f8f0e4161f42e7f549b3c8cdcd56847",
            "metadata": {},
            "name": "WebPanelLocationQuery",
            "operationKind": "query",
            "text": "query WebPanelLocationQuery($location:String,$locations:[String],$contentId:ID,$spaceKey:String){webPanels(location:$location,locations:$locations,contentId:$contentId,key:$spaceKey){moduleKey,completeKey,html,location,label,weight,name}}"
        }
    };
}();
$9206d19da4400201$var$node.hash = "c9e0e68be80f814df706b6c0d828dae1";
var $9206d19da4400201$export$2e2bcd8739ae039 = $9206d19da4400201$var$node;
module.exports["default"] = $9206d19da4400201$export$2e2bcd8739ae039;

});

parcelRegister("fh5wq", function(module, exports) {
$parcel$export(module.exports, "ConnectAppLoadEnd", () => (parcelRequire("f2ook")).ConnectAppLoadEnd);
$parcel$export(module.exports, "getConnectAppsItems", () => (parcelRequire("FFoHM")).getConnectAppsItems);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $8X9dm = parcelRequire("8X9dm");


var $f2ook = parcelRequire("f2ook");


var $FFoHM = parcelRequire("FFoHM");


var $hB3yw = parcelRequire("hB3yw");


});

parcelRegister("8X9dm", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $FFoHM = parcelRequire("FFoHM");

const $fa75a12a8b648c36$var$actions = {
    updateConnectApps: (props)=>({ setState: setState, getState: getState })=>{
            const { location: location, items: items, isLoaded: isLoaded } = props;
            // Update connectApps when it completed load
            const newState = getState().connectApps.map((data)=>{
                if (data.location === location) return {
                    location: location,
                    items: items,
                    isLoaded: isLoaded
                };
                return data;
            });
            setState({
                connectApps: newState
            });
        },
    resetConnectApps: ()=>({ setState: setState })=>{
            setState({
                connectApps: (0, $FFoHM.generateInitialState)()
            });
        }
};
const $fa75a12a8b648c36$var$Store = (0, $8s9DV.createStore)({
    initialState: {
        connectApps: (0, $FFoHM.generateInitialState)()
    },
    actions: $fa75a12a8b648c36$var$actions,
    name: 'connectAppsState'
});
const $fa75a12a8b648c36$var$getConnectAppsState = (state)=>{
    // Check if all measurable connect apps are loaded
    const isReady = state.connectApps.every((cp)=>{
        return cp.isLoaded === true;
    });
    if (!isReady) return {
        isReady: false,
        data: null
    };
    return {
        isReady: true,
        data: (0, $FFoHM.generateMetricData)(state.connectApps)
    };
};
const $fa75a12a8b648c36$export$582ddccddc369c8 = (0, $kBr4q.createHook)($fa75a12a8b648c36$var$Store, {
    selector: $fa75a12a8b648c36$var$getConnectAppsState
});
module.exports["useConnectAppsState"] = $fa75a12a8b648c36$export$582ddccddc369c8;

});

parcelRegister("FFoHM", function(module, exports) {

var $33OR5 = parcelRequire("33OR5");

const $2c1124407cafc284$export$5e6f85e4321dccd5 = (items, prop = 'completeKey')=>{
    if (!items || !items.length) return [];
    return items.map((item)=>{
        if (!item[prop]) return null;
        return item[prop];
    });
};
const $2c1124407cafc284$export$fe8c27474396e3df = (originalData)=>{
    const isEmpty = originalData.every((cp)=>{
        return cp.items.length === 0;
    });
    if (isEmpty) return null;
    return originalData.reduce((result, data)=>{
        if (data.items?.length) result[data.location] = data.items;
        return result;
    }, {});
};
const $2c1124407cafc284$export$6c48ceb03731fb94 = ()=>{
    return (0, $33OR5.measuredLocations).map((location)=>({
            location: location,
            items: [],
            isLoaded: false
        }));
};
module.exports["getConnectAppsItems"] = $2c1124407cafc284$export$5e6f85e4321dccd5;
module.exports["generateMetricData"] = $2c1124407cafc284$export$fe8c27474396e3df;
module.exports["generateInitialState"] = $2c1124407cafc284$export$6c48ceb03731fb94;

});

parcelRegister("33OR5", function(module, exports) {

var $eSLr0 = parcelRequire("eSLr0");

const $026eb3cae9c12bb0$export$b8794672440f0b1 = [
    (0, $eSLr0.PAGE_METADATA_BANNER),
    (0, $eSLr0.SYSTEM_CONTENT_METADATA),
    (0, $eSLr0.ATL_PAGE_METADATA)
];
const $026eb3cae9c12bb0$export$d18781600a31352 = 'com.atlassian.plugins.atlassian-connect-plugin';
module.exports["measuredLocations"] = $026eb3cae9c12bb0$export$b8794672440f0b1;
module.exports["MEASURE_KEY"] = $026eb3cae9c12bb0$export$d18781600a31352;

});

parcelRegister("f2ook", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $33OR5 = parcelRequire("33OR5");


var $8X9dm = parcelRequire("8X9dm");

const $7be4190af38bf0dd$export$2ed36e453078a2a = (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { location: location, items: items } = t0;
    const [, connectAppsActions] = (0, $8X9dm.useConnectAppsState)();
    let t1;
    let t2;
    if ($[0] !== connectAppsActions || $[1] !== items || $[2] !== location) {
        t1 = ()=>{
            if (location && (0, $33OR5.measuredLocations).indexOf(location) !== -1) {
                const filteredItems = items.filter($7be4190af38bf0dd$var$_temp);
                connectAppsActions.updateConnectApps({
                    location: location,
                    items: filteredItems,
                    isLoaded: true
                });
            }
        };
        t2 = [
            location,
            items,
            connectAppsActions
        ];
        $[0] = connectAppsActions;
        $[1] = items;
        $[2] = location;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
};
function $7be4190af38bf0dd$var$_temp(item) {
    return item.indexOf((0, $33OR5.MEASURE_KEY)) !== -1;
}
module.exports["ConnectAppLoadEnd"] = $7be4190af38bf0dd$export$2ed36e453078a2a;

});

parcelRegister("hB3yw", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kvJHJ = parcelRequire("kvJHJ");


var $8X9dm = parcelRequire("8X9dm");

const $ad90018ec7bbfcf2$export$c67125476ea8583f = (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { contentId: contentId, metric: metric } = t0;
    const [connectApps, connectAppsActions] = (0, $8X9dm.useConnectAppsState)();
    let t1;
    if ($[0] !== connectAppsActions) {
        t1 = ()=>{
            connectAppsActions.resetConnectApps();
        };
        $[0] = connectAppsActions;
        $[1] = t1;
    } else t1 = $[1];
    const onMeasureCompleted = t1;
    if (!connectApps?.isReady) return null;
    if (!connectApps?.data) {
        onMeasureCompleted();
        return null;
    }
    const t2 = connectApps?.data;
    let t3;
    if ($[2] !== t2) {
        t3 = {
            connectApps: t2
        };
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== contentId || $[5] !== metric || $[6] !== onMeasureCompleted || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
            key: contentId,
            metric: metric,
            customData: t3,
            onComplete: onMeasureCompleted
        });
        $[4] = contentId;
        $[5] = metric;
        $[6] = onMeasureCompleted;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
};

});

parcelRegister("jbFlk", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6b4nE = parcelRequire("6b4nE");


var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");

var $1eaCJ = parcelRequire("1eaCJ");


var $80koo = parcelRequire("80koo");


var $eSLr0 = parcelRequire("eSLr0");


var $kxhju = parcelRequire("kxhju");


var $hFGQl = parcelRequire("hFGQl");


var $asQED = parcelRequire("asQED");

parcelRequire("fh5wq");
var $f2ook = parcelRequire("f2ook");
var $FFoHM = parcelRequire("FFoHM");

const $2196709888d91a8b$var$WRM_MODULES = [
    'wrc!com.atlassian.confluence.plugins.confluence-feature-discovery-plugin',
    'wrc!com.atlassian.confluence.plugins.confluence-jira-metadata:confluence-jira-metadata-resources'
];
class $2196709888d91a8b$export$3977b622b23eae17 extends (0, $cozmU.PureComponent) {
    render() {
        const { contentId: contentId, versionOverride: versionOverride } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
            name: (0, $irVI7.EXTENSION_POINT_PAGE_METADATA_BANNER_EXPERIENCE)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kxhju.WebItemLocation), {
            tagName: "span",
            location: (0, $eSLr0.PAGE_METADATA_BANNER),
            contentId: contentId,
            version: versionOverride
        }, ({ webItems: webItems })=>{
            const items = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $asQED.WebItemList), {
                pageId: contentId,
                webItems: webItems,
                id: "page-metadata-banner-items"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
                name: (0, $irVI7.EXTENSION_POINT_PAGE_METADATA_BANNER_EXPERIENCE)
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f2ook.ConnectAppLoadEnd), {
                location: (0, $eSLr0.PAGE_METADATA_BANNER),
                items: (0, $FFoHM.getConnectAppsItems)(webItems)
            }));
            if (webItems.some((item)=>item.id === (0, $hFGQl.CONTENT_METADATA_JIRA_ID))) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $80koo.RequireLegacyWRM), {
                wrm: $2196709888d91a8b$var$WRM_MODULES
            }, ()=>items);
            return items;
        }));
    }
}
$2196709888d91a8b$export$3977b622b23eae17.propTypes = {
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    versionOverride: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).number
};
module.exports["PageMetadataBanner"] = $2196709888d91a8b$export$3977b622b23eae17;

});

parcelRegister("asQED", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $5X6fy = parcelRequire("5X6fy");


var $6b4nE = parcelRequire("6b4nE");


var $cozmU = parcelRequire("cozmU");


var $7XPIt = parcelRequire("7XPIt");


var $42cjr = parcelRequire("42cjr");


var $2d38b = parcelRequire("2d38b");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $ht0Th = parcelRequire("ht0Th");


var $4aGJ9 = parcelRequire("4aGJ9");


var $hFGQl = parcelRequire("hFGQl");


var $1CpUP = parcelRequire("1CpUP");


var $d716L = parcelRequire("d716L");

const $27cf6bbb40785c7e$export$392ec14fa63f4ae3 = {
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    display: 'inline-block',
    verticalAlign: 'top',
    paddingLeft: "var(--ds-space-100, 8px)"
};
const $27cf6bbb40785c7e$export$63286b959e8d28b9 = (props)=>{
    const $ = (0, $bDgLe.c)(30);
    const { webItems: webItems, className: className, id: id, webItemClassName: webItemClassName, pageId: pageId, dataTestId: dataTestId, contentSubType: contentSubType, hideDot: hideDot, source: source, ContainerTagName: t0, actions: t1, modifications: t2, disableIcons: t3, noContainer: t4, useBadgeStyles: t5, hasAuthoritativeBylineAppSnapshot: t6, isLegacyConnectApp: t7 } = props;
    const ContainerTagName = t0 === undefined ? "div" : t0;
    let t8;
    if ($[0] !== t1) {
        t8 = t1 === undefined ? {} : t1;
        $[0] = t1;
        $[1] = t8;
    } else t8 = $[1];
    const actions = t8;
    let t9;
    if ($[2] !== t2) {
        t9 = t2 === undefined ? {} : t2;
        $[2] = t2;
        $[3] = t9;
    } else t9 = $[3];
    const modifications = t9;
    const disableIcons = t3 === undefined ? false : t3;
    const noContainer = t4 === undefined ? false : t4;
    const useBadgeStyles = t5 === undefined ? false : t5;
    const hasAuthoritativeBylineAppSnapshot = t6 === undefined ? false : t6;
    const isLegacyConnectApp = t7 === undefined ? false : t7;
    let t10;
    if ($[4] !== actions || $[5] !== contentSubType || $[6] !== disableIcons || $[7] !== hasAuthoritativeBylineAppSnapshot || $[8] !== hideDot || $[9] !== isLegacyConnectApp || $[10] !== modifications || $[11] !== pageId || $[12] !== source || $[13] !== useBadgeStyles || $[14] !== webItemClassName || $[15] !== webItems) {
        t10 = ()=>webItems.map((webItem)=>{
                const webItemProps = {
                    key: webItem.completeKey,
                    url: webItem.url,
                    id: webItem.id,
                    onClick: webItem.onClick || actions[webItem.moduleKey],
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))(webItem.styleClass, webItemClassName, {
                        "with-dot": !hideDot
                    }),
                    params: webItem.params,
                    iconInfo: webItem.icon,
                    label: webItem.label,
                    tooltip: webItem.tooltip,
                    spinner: modifications[webItem.moduleKey] ? modifications[webItem.moduleKey].spinner : false,
                    disableIcon: disableIcons,
                    iconStyle: webItem.iconStyle,
                    addLargerMargin: hideDot,
                    useBylineStyles: hideDot
                };
                if (webItem.id === (0, $hFGQl.CONTENT_METADATA_JIRA_ID)) webItemProps["data-jira-metadata-count"] = -1;
                if (pageId && webItem.id === (0, $hFGQl.DRAFT_STATUS_LOZENGE_ID)) {
                    if (webItem.moduleKey === (0, $hFGQl.SCHEDULED_STATUS_LOZENGE_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $42cjr.ScheduledStatus), {
                        key: pageId,
                        contentId: pageId
                    });
                    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2d38b.DraftStatus), {
                        key: pageId,
                        contentId: pageId
                    });
                }
                if (webItem.id === (0, $hFGQl.CONTENT_METADATA_ATTACHMENTS_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7XPIt.ViewAttachmentsButton), {
                    key: "view-attachments-button"
                });
                if (webItem.id === (0, $hFGQl.INVITE_TO_EDIT_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                    style: $27cf6bbb40785c7e$export$392ec14fa63f4ae3,
                    key: "fabric-share"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
                    attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE,
                    key: "share-and-restrict-button"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aGJ9.ShareAndRestrictButton), {
                    contentId: webItem.contentId,
                    contentType: webItem.contentType ?? "page",
                    contentSubType: contentSubType || undefined,
                    source: source
                })));
                if (webItem.id === (0, $hFGQl.CONTENT_METADATA_PAGE_RESTRICTIONS_ID)) return null;
                if (webItem.id === (0, $hFGQl.ANALYTICS_ADDON_ACTIONS_MENU_ID) || webItem.id === (0, $hFGQl.ANALYTICS_ADDON_BYLINE_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
                if (webItem.id === (0, $hFGQl.CONTENT_METADATA_JIRA_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ht0Th.JiraButtonAnalyticsWrapper), {
                    key: webItem.completeKey
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1CpUP.WebItem), webItemProps));
                if (isLegacyConnectApp) {
                    const appKey = webItem.moduleKey.split("__")[0];
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
                        key: webItem.completeKey
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d716L.ConnectEOSPopup), {
                        appKey: appKey
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1CpUP.WebItem), {
                        ...webItemProps,
                        useBadgeStyles: useBadgeStyles,
                        hasAuthoritativeBylineAppSnapshot: hasAuthoritativeBylineAppSnapshot
                    }));
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1CpUP.WebItem), {
                    key: webItem.completeKey,
                    ...webItemProps,
                    useBadgeStyles: useBadgeStyles,
                    hasAuthoritativeBylineAppSnapshot: hasAuthoritativeBylineAppSnapshot
                });
            });
        $[4] = actions;
        $[5] = contentSubType;
        $[6] = disableIcons;
        $[7] = hasAuthoritativeBylineAppSnapshot;
        $[8] = hideDot;
        $[9] = isLegacyConnectApp;
        $[10] = modifications;
        $[11] = pageId;
        $[12] = source;
        $[13] = useBadgeStyles;
        $[14] = webItemClassName;
        $[15] = webItems;
        $[16] = t10;
    } else t10 = $[16];
    const renderWebItems = t10;
    if (noContainer) {
        let t11;
        if ($[17] !== renderWebItems) {
            t11 = renderWebItems();
            $[17] = renderWebItems;
            $[18] = t11;
        } else t11 = $[18];
        let t12;
        if ($[19] !== t11) {
            t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t11);
            $[19] = t11;
            $[20] = t12;
        } else t12 = $[20];
        return t12;
    }
    const t11 = dataTestId || "web-item-wrapper";
    let t12;
    if ($[21] !== renderWebItems) {
        t12 = renderWebItems();
        $[21] = renderWebItems;
        $[22] = t12;
    } else t12 = $[22];
    let t13;
    if ($[23] !== ContainerTagName || $[24] !== className || $[25] !== dataTestId || $[26] !== id || $[27] !== t11 || $[28] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ContainerTagName, {
            className: className,
            id: id,
            "data-test-id": dataTestId,
            "data-testid": t11
        }, t12);
        $[23] = ContainerTagName;
        $[24] = className;
        $[25] = dataTestId;
        $[26] = id;
        $[27] = t11;
        $[28] = t12;
        $[29] = t13;
    } else t13 = $[29];
    return t13;
};
$27cf6bbb40785c7e$export$63286b959e8d28b9.displayName = 'WebItemList';
$27cf6bbb40785c7e$export$63286b959e8d28b9.propTypes = {
    webItems: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).array,
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object,
    modifications: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    disableIcons: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    ContainerTagName: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    webItemClassName: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    pageId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    dataTestId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    contentSubType: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    hideDot: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    source: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    noContainer: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    useBadgeStyles: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    hasAuthoritativeBylineAppSnapshot: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    isLegacyConnectApp: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool
};
module.exports["SHARE_BTN_STYLE"] = $27cf6bbb40785c7e$export$392ec14fa63f4ae3;
module.exports["WebItemList"] = $27cf6bbb40785c7e$export$63286b959e8d28b9;

});

parcelRegister("7XPIt", function(module, exports) {
/* ViewAttachmentsButton.js generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $6b4nE = parcelRequire("6b4nE");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $5SGpQ = parcelRequire("5SGpQ");


var $gxI48 = parcelRequire("gxI48");


var $2UWuP = parcelRequire("2UWuP");


var $ep3mz = parcelRequire("ep3mz");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $1NBp8 = parcelRequire("1NBp8");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5cc628dffabd5f14$var$ViewAttachmentsButtonContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3syKoKdnbC _2h7MEPdnbC _3tOQhEdnbC _04h2sEdnbC _3wdHVCdnbC _4mSr0ndnbC _2frtJQdnbC _11NgWudnbC _0jwYZZ7zJH _1iJnp6uNcX _2FH9z4uNcX _0gKGieZpcK _1E1xWzZpcK",
            __cmplp.className
        ])
    });
});
const $5cc628dffabd5f14$var$i18n = (0, $kSwu1.defineMessages)({
    attachments: {
        id: "attachments.view-attachments-button",
        defaultMessage: "View attachments"
    }
});
const $5cc628dffabd5f14$var$ATTACHMENTS_ANALYTICS_FROM_VIEW = {
    type: 'sendUIEvent',
    data: {
        action: 'clicked',
        actionSubject: 'ViewAttachmentsButton',
        source: 'attachments',
        attributes: {
            triggeredFrom: 'fromView'
        }
    }
};
const $5cc628dffabd5f14$export$6f695b80f23f4114 = {
    type: 'sendUIEvent',
    data: {
        action: 'clicked',
        actionSubject: 'ViewAttachmentsButton',
        source: 'attachments',
        attributes: {
            triggeredFrom: 'actionsMenu'
        }
    }
};
const $5cc628dffabd5f14$export$774c527e91be8e54 = ({ intl: intl })=>{
    const label = intl.formatMessage($5cc628dffabd5f14$var$i18n.attachments);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            actionSubject: 'feature',
            action: 'exposed',
            source: 'ViewAttachmentsButton',
            attributes: {
                isPageSSRd: window.__SSR_RENDERED__
            }
        }
    }).fire();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).BACKBONE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5cc628dffabd5f14$var$ViewAttachmentsButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5SGpQ.default), {
        appearance: "subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2UWuP.WebItemAnalyticsWrapper), {
        analyticsData: $5cc628dffabd5f14$var$ATTACHMENTS_ANALYTICS_FROM_VIEW
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("a", {
        href: (0, $1NBp8.ATTACHMENTS_PAGE).toUrl({
            spaceKey: spaceKey,
            contentId: contentId
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gxI48))), {
        spacing: "spacious",
        label: label
    }))))));
};
$5cc628dffabd5f14$export$774c527e91be8e54.propTypes = {
    intl: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object
};
const $5cc628dffabd5f14$export$5c9f1ebb6c75cefb = (0, $kSwu1.injectIntl)($5cc628dffabd5f14$export$774c527e91be8e54);
module.exports["ATTACHMENTS_ANALYTICS_FROM_ACTIONS_MENU"] = $5cc628dffabd5f14$export$6f695b80f23f4114;
module.exports["ViewAttachmentsButton"] = $5cc628dffabd5f14$export$5c9f1ebb6c75cefb;

});

parcelRegister("2UWuP", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $ggg0l = parcelRequire("ggg0l");

const $1c62d6fee936c450$var$noop = ()=>{};
function $1c62d6fee936c450$export$907c57431ebf932({ children: children, analyticsData: analyticsData, innerRef: innerRef, wrapChildren: wrapChildren = false }) {
    const handler = children?.props?.onClick || $1c62d6fee936c450$var$noop;
    const handleClick = (0, $ggg0l.useCallbackWithAnalytics)(handler, analyticsData);
    if (wrapChildren) {
        const wrappedChild = /*#__PURE__*/ (0, $cozmU.cloneElement)(children, {
            onClick: handleClick
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            ref: innerRef
        }, wrappedChild);
    }
    return /*#__PURE__*/ (0, $cozmU.cloneElement)(children, {
        onClick: handleClick,
        ref: innerRef
    });
}
module.exports["WebItemAnalyticsWrapper"] = $1c62d6fee936c450$export$907c57431ebf932;

});

parcelRegister("42cjr", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $7f6808c58612208d$export$d10c0abe99daab65 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "a_lQj",
    name: "ScheduledStatus",
    loader: async ()=>(await (parcelRequire("7rkv2"))).ScheduledStatus
});
module.exports["ScheduledStatus"] = $7f6808c58612208d$export$d10c0abe99daab65;

});

parcelRegister("7rkv2", function(module, exports) {

let $56aaf4cc97703232$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $56aaf4cc97703232$var$load("iWKl1").then(()=>parcelRequire('dqNU1'));

});

parcelRegister("2d38b", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $30c96bfad3bb5778$export$ad9db10db9173ca8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "6vTJj",
    name: "DraftStatus",
    loader: async ()=>(await (parcelRequire("3ThaJ"))).DraftStatus
});
module.exports["DraftStatus"] = $30c96bfad3bb5778$export$ad9db10db9173ca8;

});

parcelRegister("3ThaJ", function(module, exports) {

let $2d53d42a7d15aa79$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2d53d42a7d15aa79$var$load("jYr96").then(()=>parcelRequire('1cgZV'));

});

parcelRegister("ht0Th", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6b4nE = parcelRequire("6b4nE");


var $9DHhW = parcelRequire("9DHhW");


var $2UWuP = parcelRequire("2UWuP");


var $hFGQl = parcelRequire("hFGQl");

const $cb75d5f0a986326c$var$JIRA_ANALYTICS = {
    type: 'sendUIEvent',
    data: {
        action: 'clicked',
        source: 'viewPageScreen',
        actionSubject: 'JiraTicketsButton'
    }
};
function $cb75d5f0a986326c$export$549130614231f8f4({ children: children }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const container = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        setTimeout(()=>{
            let linkVisible = false;
            const link = container?.current?.children?.[0, $hFGQl.CONTENT_METADATA_JIRA_ID];
            if (link && !link.classList.contains('hidden')) linkVisible = true;
            if (linkVisible) createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    actionSubject: 'JiraTicketsButton',
                    action: 'shown',
                    source: 'viewPageScreen',
                    attributes: {
                        isPageSSRd: window.__SSR_RENDERED__
                    }
                }
            }).fire();
        }, 5000); // should be enough for render after the plugin has mounted
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2UWuP.WebItemAnalyticsWrapper), {
        analyticsData: $cb75d5f0a986326c$var$JIRA_ANALYTICS,
        innerRef: container,
        wrapChildren: true
    }, children);
}
$cb75d5f0a986326c$export$549130614231f8f4.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).node
};
module.exports["JiraButtonAnalyticsWrapper"] = $cb75d5f0a986326c$export$549130614231f8f4;

});

parcelRegister("1CpUP", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $5X6fy = parcelRequire("5X6fy");


var $3AVOh = parcelRequire("3AVOh");


var $6b4nE = parcelRequire("6b4nE");


var $cozmU = parcelRequire("cozmU");


var $lfoFx = parcelRequire("lfoFx");


var $lpNn5 = parcelRequire("lpNn5");


var $6mKj3 = parcelRequire("6mKj3");


var $bCECL = parcelRequire("bCECL");


var $e5xte = parcelRequire("e5xte");

function $12dd715bfa1d104a$var$_defineProperty(e, r, t) {
    return (r = $12dd715bfa1d104a$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $12dd715bfa1d104a$var$_toPropertyKey(t) {
    var i = $12dd715bfa1d104a$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $12dd715bfa1d104a$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $12dd715bfa1d104a$var$imageStyles = null;
const $12dd715bfa1d104a$var$legacyImageSpacingStyles = null; // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
const $12dd715bfa1d104a$var$baseStyles = null;
const $12dd715bfa1d104a$var$largeMargin = null;
const $12dd715bfa1d104a$var$bylineStyles = null;
const $12dd715bfa1d104a$var$badgeStyles = null;
const $12dd715bfa1d104a$var$sharedBadgeLinkStyles = null;
const $12dd715bfa1d104a$var$WebItemTooltip = (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { tooltip: tooltip, children: children } = t0;
    if (tooltip) {
        let t1;
        if ($[0] !== children) {
            t1 = (tooltipProps)=>children(tooltipProps);
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        let t2;
        if ($[2] !== t1 || $[3] !== tooltip) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
                content: tooltip
            }, t1);
            $[2] = t1;
            $[3] = tooltip;
            $[4] = t2;
        } else t2 = $[4];
        return t2;
    }
    let t1;
    if ($[5] !== children) {
        t1 = children({});
        $[5] = children;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
};
$12dd715bfa1d104a$var$WebItemTooltip.propTypes = {
    /**
   * Tooltip of the web item
   */ tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func.isRequired
};
const $12dd715bfa1d104a$var$WebItemIcon = (t0)=>{
    const $ = (0, $bDgLe.c)(34);
    let addLargerMargin;
    let classes;
    let hasAuthoritativeBylineAppSnapshot;
    let icon;
    let id;
    let label;
    let onClick;
    let otherProps;
    let style;
    let tooltip;
    let url;
    let useBadgeStyles;
    let useBylineStyles;
    if ($[0] !== t0) {
        ({ classes: classes, id: id, url: url, label: label, tooltip: tooltip, onClick: onClick, style: style, icon: icon, addLargerMargin: addLargerMargin, useBylineStyles: useBylineStyles, useBadgeStyles: useBadgeStyles, hasAuthoritativeBylineAppSnapshot: hasAuthoritativeBylineAppSnapshot, ...otherProps } = t0);
        $[0] = t0;
        $[1] = addLargerMargin;
        $[2] = classes;
        $[3] = hasAuthoritativeBylineAppSnapshot;
        $[4] = icon;
        $[5] = id;
        $[6] = label;
        $[7] = onClick;
        $[8] = otherProps;
        $[9] = style;
        $[10] = tooltip;
        $[11] = url;
        $[12] = useBadgeStyles;
        $[13] = useBylineStyles;
    } else {
        addLargerMargin = $[1];
        classes = $[2];
        hasAuthoritativeBylineAppSnapshot = $[3];
        icon = $[4];
        id = $[5];
        label = $[6];
        onClick = $[7];
        otherProps = $[8];
        style = $[9];
        tooltip = $[10];
        url = $[11];
        useBadgeStyles = $[12];
        useBylineStyles = $[13];
    }
    let t1;
    if ($[14] !== label) {
        t1 = typeof label === "string" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            dangerouslySetInnerHTML: {
                __html: label
            }
        }) : label;
        $[14] = label;
        $[15] = t1;
    } else t1 = $[15];
    let t2;
    if ($[16] !== icon || $[17] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, icon, t1);
        $[16] = icon;
        $[17] = t1;
        $[18] = t2;
    } else t2 = $[18];
    const content = t2;
    let t3;
    if ($[19] !== addLargerMargin || $[20] !== classes || $[21] !== content || $[22] !== hasAuthoritativeBylineAppSnapshot || $[23] !== id || $[24] !== onClick || $[25] !== otherProps || $[26] !== style || $[27] !== url || $[28] !== useBadgeStyles || $[29] !== useBylineStyles) {
        t3 = (tooltipProps)=>{
            const linkProps = {
                "data-testid": "web-item-link",
                href: url,
                id: id,
                onClick: onClick,
                style: style,
                ...tooltipProps,
                ...otherProps
            };
            const shouldUseSharedBylineAppTrigger = useBadgeStyles && hasAuthoritativeBylineAppSnapshot && (0, $6mKj3.expValEquals)("confluence_ssr_byline", "isEnabled", true);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("a", {
                ...linkProps,
                className: (0, $hekY6.default)([
                    shouldUseSharedBylineAppTrigger && "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _3iDTPbccYA _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _3WzCGi98eZ _0NqVRtYbGa _3BKYwu6wH8",
                    !shouldUseSharedBylineAppTrigger && "_0adFHs2ADO _26BoRwdIGx",
                    !shouldUseSharedBylineAppTrigger && addLargerMargin && "_0adFHsCLgE _26BoRwa9Mq",
                    !shouldUseSharedBylineAppTrigger && useBylineStyles && "_1UtDYzue9s",
                    !shouldUseSharedBylineAppTrigger && useBadgeStyles && "_0bjKvDKxmn _2mHwu81Y8M _4FKVYE1Y8M _00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _3iDTPbQ4SZ _26BoRwey7F _0adFHsPgdg _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _1eOmH6o126 _3932vvOiJt _3gzVzLN4oS _0NqVRtYbGa",
                    classes
                ])
            }, shouldUseSharedBylineAppTrigger ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e5xte.BylineAppTriggerVisual), {
                isInteractive: true
            }, content) : content);
        };
        $[19] = addLargerMargin;
        $[20] = classes;
        $[21] = content;
        $[22] = hasAuthoritativeBylineAppSnapshot;
        $[23] = id;
        $[24] = onClick;
        $[25] = otherProps;
        $[26] = style;
        $[27] = url;
        $[28] = useBadgeStyles;
        $[29] = useBylineStyles;
        $[30] = t3;
    } else t3 = $[30];
    let t4;
    if ($[31] !== t3 || $[32] !== tooltip) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($12dd715bfa1d104a$var$WebItemTooltip, {
            tooltip: tooltip
        }, t3);
        $[31] = t3;
        $[32] = tooltip;
        $[33] = t4;
    } else t4 = $[33];
    return t4;
};
$12dd715bfa1d104a$var$WebItemIcon.propTypes = {
    /**
   * classes to use for the component
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    /**
   * id passed from WebItem
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    /**
   * Route where the web item will point
   */ url: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    /**
   * Label of the web item
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    /**
   * Tooltip of the web item
   */ tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    /**
   * Handler for clicks
   */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func,
    /**
   * WebItem styles
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object,
    /**
   * Icon obj
   */ icon: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object,
    /**
   * Will be true for live pages since apps have different styling
   */ addLargerMargin: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    /**
   * Will be true for live pages since apps have different styling
   */ useBylineStyles: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    useBadgeStyles: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    hasAuthoritativeBylineAppSnapshot: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool
};
class $12dd715bfa1d104a$export$1c46d4b85d455dd4 extends (0, $cozmU.PureComponent) {
    getIcon() {
        const { disableIcon: disableIcon, params: params, iconStyle: iconStyle, spinner: spinner, iconInfo: iconInfo, label: label, iconSize: iconSize, useBadgeStyles: useBadgeStyles, hasAuthoritativeBylineAppSnapshot: hasAuthoritativeBylineAppSnapshot } = this.props;
        let auiIconClass = params && params.iconClass;
        if (disableIcon) return null;
        if (spinner) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            testId: "spinner",
            size: "small"
        });
        if (iconInfo && iconInfo.path) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        , {
            style: iconStyle,
            src: iconInfo.path,
            width: iconInfo.width,
            height: iconInfo.height,
            alt: label,
            title: label,
            className: (0, $hekY6.default)([
                "_0NUa3rN91d _0jFU0VIZbP _3iDTPbvbI6 _1RrJLit2nV _0adFHsPgdg",
                (!useBadgeStyles || !hasAuthoritativeBylineAppSnapshot || !(0, $6mKj3.expValEquals)('confluence_ssr_byline', 'isEnabled', true)) && "_0adFHsyrFs"
            ])
        });
        if (auiIconClass) {
            if (auiIconClass.indexOf('aui-iconfont-') === -1) auiIconClass = `aui-iconfont-${auiIconClass}`;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bCECL.ContentIcon), {
                iconSize: iconSize,
                className: auiIconClass,
                style: iconStyle
            });
        }
        return null;
    }
    render() {
        const { className: className, id: id, url: url, type: type, label: label, tooltip: tooltip, onClick: onClick, style: style, ...otherProps } = this.props;
        const buttonType = type === 'primary' ? 'aui-button-primary' : '';
        const classes = (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))(className, buttonType);
        const icon = this.getIcon(); //react complains about these extra props but we still need to pass otherProps (e.g. data-jira-metadata-count)
        const webItemIconProps = (0, (/*@__PURE__*/$parcel$interopDefault($3AVOh)))({
            classes: classes,
            id: id,
            url: url,
            label: label,
            tooltip: tooltip,
            onClick: onClick,
            style: style,
            icon: icon,
            ...otherProps
        }, [
            'disableIcon',
            'iconStyle',
            'spinner',
            'iconInfo',
            'iconSize'
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($12dd715bfa1d104a$var$WebItemIcon, webItemIconProps);
    }
}
$12dd715bfa1d104a$var$_defineProperty($12dd715bfa1d104a$export$1c46d4b85d455dd4, "propTypes", {
    /**
   * Classnames. Note that WebItem no longer assumes that it should render as a button
   * And as such you may need to explicitly pass the `aui-button` class here.
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    /**
   * id
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    /**
   * Route where the web item will point
   */ url: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    /**
   * Type of the button
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    /**
   * Label of the web item
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    /**
   * Tooltip of the web item
   */ tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    /**
   * Handler for clicks
   */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func,
    /**
   * Contain parameters setted in the descriptor
   */ params: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object,
    /**
   * Doesn't render icons when true
   */ disableIcon: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    /**
   * icon information used for absolute images
   */ iconInfo: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).shape({
        path: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
        width: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).number,
        height: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).number
    }),
    /**
   * Show spinner instead of an icon if equals true
   */ spinner: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    /**
   * WebItem styles
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object,
    /**
   * Icon styles
   */ iconStyle: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object,
    iconSize: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    /**
   * Will be true for live pages since apps have different styling
   */ addLargerMargin: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    /**
   * Will be true for live pages since apps have different styling
   */ useBylineStyles: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    useBadgeStyles: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    hasAuthoritativeBylineAppSnapshot: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool
});
$12dd715bfa1d104a$var$_defineProperty($12dd715bfa1d104a$export$1c46d4b85d455dd4, "defaultProps", {
    spinner: false,
    iconStyle: {},
    style: {},
    iconSize: 'small'
});
module.exports["WebItem"] = $12dd715bfa1d104a$export$1c46d4b85d455dd4;

});

parcelRegister("e5xte", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");

const $3eccf1aecbd4d6a4$var$styles = {
    trigger: "_0bjKvDKxmn _2sNsIg7NXe _0hPCNLDIqT _0KLXru66of _1UtDYzZpcK _17lj8p1Y8M _3iDTPbccYA _2xTnZxPgdg _0xmtko1Y8M _46hvQm1Y8M _03SyCP1Y8M _0LQT5E1Y8M",
    interactive: "_23rrnHyKLB _1eOmH6o126 _3sFUREiSCN _3gzVzLN4oS",
    dot: "_1Yjlt598eZ _2AckfdYbGa _42hYr56wH8 _0scQGrDIqT _3Ku51IbQDk _0OU75rvbI6 _2vWqy01Y8M"
};
const $3eccf1aecbd4d6a4$export$79ce4225a17e08ee = (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    let children;
    let htmlAttributes;
    let t1;
    let t2;
    if ($[0] !== t0) {
        ({ children: children, isInteractive: t1, showDot: t2, ...htmlAttributes } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = htmlAttributes;
        $[3] = t1;
        $[4] = t2;
    } else {
        children = $[1];
        htmlAttributes = $[2];
        t1 = $[3];
        t2 = $[4];
    }
    const isInteractive = t1 === undefined ? false : t1;
    const showDot = t2 === undefined ? false : t2;
    const t3 = isInteractive && $3eccf1aecbd4d6a4$var$styles.interactive;
    const t4 = showDot && $3eccf1aecbd4d6a4$var$styles.dot;
    let t5;
    if ($[5] !== t3 || $[6] !== t4) {
        t5 = (0, $hekY6.default)([
            $3eccf1aecbd4d6a4$var$styles.trigger,
            t3,
            t4
        ]);
        $[5] = t3;
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== children || $[9] !== htmlAttributes || $[10] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            ...htmlAttributes,
            className: t5
        }, children);
        $[8] = children;
        $[9] = htmlAttributes;
        $[10] = t5;
        $[11] = t6;
    } else t6 = $[11];
    return t6;
};
module.exports["BylineAppTriggerVisual"] = $3eccf1aecbd4d6a4$export$79ce4225a17e08ee;

});

parcelRegister("d716L", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $0ca1f9f6493af470$export$88a847850fd26927 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "VrHkx",
    name: "ConnectEOSPopup",
    loader: async ()=>(await (parcelRequire("j1I7a"))).ConnectEOSPopup
});
module.exports["ConnectEOSPopup"] = $0ca1f9f6493af470$export$88a847850fd26927;

});

parcelRegister("j1I7a", function(module, exports) {

let $dda05492adb3b5fe$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $dda05492adb3b5fe$var$load("Wowvf"),
    $dda05492adb3b5fe$var$load("jkP4F")
]).then(()=>parcelRequire('73nrX'));

});

parcelRegister("4Uc69", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6b4nE = parcelRequire("6b4nE");


var $irVI7 = parcelRequire("irVI7");


var $fGzMp = parcelRequire("fGzMp");


var $eSLr0 = parcelRequire("eSLr0");


var $kxhju = parcelRequire("kxhju");


var $asQED = parcelRequire("asQED");


var $hFGQl = parcelRequire("hFGQl");

parcelRequire("fh5wq");
var $f2ook = parcelRequire("f2ook");
var $FFoHM = parcelRequire("FFoHM");

class $c77793ad2fffc9ee$export$3a0235893ca8c89e extends (0, $cozmU.PureComponent) {
    componentDidMount() {
        const { excludeIds: excludeIds, contentId: contentId } = this.props;
        if (!excludeIds.includes((0, $hFGQl.CONTENT_METADATA_PAGE_RESTRICTIONS_ID))) (0, $fGzMp.getExperienceTracker)().start({
            id: contentId,
            name: (0, $irVI7.VIEW_PAGE_RESTRICTIONS_BUTTON_EXPERIENCE)
        });
    }
    render() {
        const { contentId: contentId, versionOverride: versionOverride, excludeIds: excludeIds } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kxhju.WebItemLocation), {
            tagName: "span",
            contentId: contentId,
            location: (0, $eSLr0.SYSTEM_CONTENT_METADATA),
            version: versionOverride
        }, ({ webItems: webItems })=>{
            let filteredWebItems = webItems;
            if (excludeIds && excludeIds.length) filteredWebItems = filteredWebItems.filter((item)=>!excludeIds.includes(item.id));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $asQED.WebItemList), {
                pageId: contentId,
                webItems: filteredWebItems,
                id: "system- content-items"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f2ook.ConnectAppLoadEnd), {
                location: (0, $eSLr0.SYSTEM_CONTENT_METADATA),
                items: (0, $FFoHM.getConnectAppsItems)(filteredWebItems)
            }));
        });
    }
}
$c77793ad2fffc9ee$export$3a0235893ca8c89e.propTypes = {
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    versionOverride: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).number,
    excludeIds: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string)
};
$c77793ad2fffc9ee$export$3a0235893ca8c89e.defaultProps = {
    excludeIds: []
};
module.exports["SystemContentMetadata"] = $c77793ad2fffc9ee$export$3a0235893ca8c89e;

});

parcelRegister("JHogp", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $6b4nE = parcelRequire("6b4nE");


var $b8pma = parcelRequire("b8pma");


var $jBnsv = parcelRequire("jBnsv");


var $5EoFB = parcelRequire("5EoFB");


var $eSLr0 = parcelRequire("eSLr0");


var $kxhju = parcelRequire("kxhju");


var $hQBR9 = parcelRequire("hQBR9");


var $lECEN = parcelRequire("lECEN");


var $cxCWb = parcelRequire("cxCWb");


var $D7PHQ = parcelRequire("D7PHQ");


var $bvg6Y = parcelRequire("bvg6Y");


var $2REhP = parcelRequire("2REhP");


var $8HdsQ = parcelRequire("8HdsQ");


var $4aGJ9 = parcelRequire("4aGJ9");


var $2pIlF = parcelRequire("2pIlF");


var $eNjW4 = parcelRequire("eNjW4");


var $8Cofr = parcelRequire("8Cofr");

const $6e3ff5db190a542f$var$StyledWebItemButtonList = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $lECEN.WebItemButtonList) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1RrJLit2nV",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $6e3ff5db190a542f$var$StyledContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_0hPCNLDIqT _3iDTPbQ4SZ",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $6e3ff5db190a542f$var$StyledBorder = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2XghbEhM4o _3Jzbae1z4g _3iDTPbvbI6 _39xV02HZdu _0jFU0Vey7F",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $6e3ff5db190a542f$var$WebItemsContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _0jFU0VN91d",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $6e3ff5db190a542f$var$SystemContentButtonMaxWidthContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _1EqgXlgZxp",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $6e3ff5db190a542f$var$ShareButtonPlaceholderSpacer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2XsHFM2ADO",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $6e3ff5db190a542f$var$ContentHeaderShareAndCopyButtons = (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { contentId: contentId, versionOverride: versionOverride, contentType: contentType, contentSubType: contentSubType, isArchived: isArchived } = t0;
    let t1;
    if ($[0] !== contentId || $[1] !== contentSubType || $[2] !== contentType || $[3] !== isArchived || $[4] !== versionOverride) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6e3ff5db190a542f$var$ShareAndCopyButtons, {
            contentId: contentId,
            versionOverride: versionOverride,
            contentType: contentType,
            contentSubType: contentSubType,
            isArchived: isArchived
        });
        $[0] = contentId;
        $[1] = contentSubType;
        $[2] = contentType;
        $[3] = isArchived;
        $[4] = versionOverride;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
};
$6e3ff5db190a542f$var$ContentHeaderShareAndCopyButtons.propTypes = {
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    versionOverride: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).number,
    contentType: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    contentSubType: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    isArchived: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool
};
const $6e3ff5db190a542f$var$ShareAndCopyButtons = (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { contentId: contentId, versionOverride: versionOverride, contentType: contentType, contentSubType: contentSubType, isArchived: isArchived } = t0;
    const t1 = `share-button${isArchived ? "-archived" : ""}`;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = [
            (0, $jBnsv.INVITE_TO_EDIT_KEY)
        ];
        $[0] = t2;
    } else t2 = $[0];
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            display: "flex"
        };
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] !== contentId || $[3] !== contentSubType || $[4] !== contentType) {
        t4 = (t5)=>{
            const { loading: loading, webItems: webItems } = t5;
            if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
                name: "ShareButtonPlaceholderSpacer",
                hold: loading
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6e3ff5db190a542f$var$ShareButtonPlaceholderSpacer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2pIlF.ShareRestrictAndCopyButtonPlaceholder), null)));
            webItems.forEach((item)=>{
                if (item.completeKey === (0, $jBnsv.INVITE_TO_EDIT_KEY)) {
                    item.contentId = contentId;
                    item.contentType = contentType;
                }
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6e3ff5db190a542f$var$StyledWebItemButtonList, {
                pageId: contentId,
                webItems: webItems,
                id: "extracted-share-button",
                contentSubType: contentSubType,
                source: "contentHeader"
            });
        };
        $[2] = contentId;
        $[3] = contentSubType;
        $[4] = contentType;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== contentId || $[7] !== t1 || $[8] !== t4 || $[9] !== versionOverride) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6e3ff5db190a542f$var$StyledContainer, {
            "data-vc": "share-button-copy-link-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kxhju.WebItemLocation), {
            key: t1,
            tagName: "span",
            contentId: contentId,
            allowedWebItems: t2,
            location: (0, $eSLr0.PAGE_BUTTONS),
            version: versionOverride,
            style: t3,
            renderWhenLoading: true
        }, t4));
        $[6] = contentId;
        $[7] = t1;
        $[8] = t4;
        $[9] = versionOverride;
        $[10] = t5;
    } else t5 = $[10];
    return t5;
};
$6e3ff5db190a542f$var$ShareAndCopyButtons.propTypes = {
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    addItem: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func,
    versionOverride: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).number,
    contentType: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    contentSubType: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    isArchived: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool
};
const $6e3ff5db190a542f$export$6955dde08e119b3d = (props)=>{
    const $ = (0, $bDgLe.c)(32);
    const { contentId: contentId, versionOverride: versionOverride, isExternalCollaborator: isExternalCollaborator, spaceKey: spaceKey, contentSubType: contentSubType, contentType: contentType, isArchived: isArchived } = props;
    const isLoomDisabled = (0, $eNjW4.useIsLoomDisabled)();
    (0, $hQBR9.useAutomationUrlParamTrigger)();
    let t0;
    if ($[0] !== contentId) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8HdsQ.CommentButtonWrapper), {
            key: contentId,
            contentId: contentId,
            isCommentButtonSSRd: Boolean(window.__SSR_RENDERED__ || undefined)
        });
        $[0] = contentId;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== contentId || $[3] !== contentType || $[4] !== isArchived || $[5] !== isLoomDisabled || $[6] !== spaceKey) {
        t1 = !isArchived && !isLoomDisabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $D7PHQ.PageHeaderLoomEntryPoint), {
            contentId: contentId,
            spaceKey: spaceKey,
            contentType: contentType
        });
        $[2] = contentId;
        $[3] = contentType;
        $[4] = isArchived;
        $[5] = isLoomDisabled;
        $[6] = spaceKey;
        $[7] = t1;
    } else t1 = $[7];
    let t2;
    let t3;
    if ($[8] !== contentId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cxCWb.FavouriteButton), {
            key: "favourite-button",
            contentId: contentId,
            useLegacyIcon: true
        });
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bvg6Y.WatchDialogWrapper), {
            key: "watch-dialog",
            contentId: contentId,
            defaultTab: (0, $5EoFB.MANAGE_WATCHER_TAB_TYPES).PAGE,
            componentLocation: (0, $2REhP.WATCH_DIALOG_LOCATION).PAGE
        });
        $[8] = contentId;
        $[9] = t2;
        $[10] = t3;
    } else {
        t2 = $[9];
        t3 = $[10];
    }
    let t4;
    if ($[11] !== contentSubType) {
        t4 = (t5)=>{
            const { webItems: webItems } = t5;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6e3ff5db190a542f$var$WebItemsContainer, null, !!webItems.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6e3ff5db190a542f$var$StyledBorder, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6e3ff5db190a542f$var$SystemContentButtonMaxWidthContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6e3ff5db190a542f$var$StyledWebItemButtonList, {
                webItems: webItems,
                buttonType: "aui-button-subtle",
                contentSubType: contentSubType
            })));
        };
        $[11] = contentSubType;
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] !== contentId || $[14] !== t4 || $[15] !== versionOverride) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kxhju.WebItemLocation), {
            key: "page-buttons",
            contentId: contentId,
            location: (0, $eSLr0.PAGE_BUTTONS),
            notAllowedWebItems: (0, $8Cofr.FILTERED_WEB_ITEM_KEYS),
            tagName: "span",
            version: versionOverride
        }, t4);
        $[13] = contentId;
        $[14] = t4;
        $[15] = versionOverride;
        $[16] = t5;
    } else t5 = $[16];
    let t6;
    if ($[17] !== contentId || $[18] !== contentSubType || $[19] !== contentType || $[20] !== isArchived || $[21] !== isExternalCollaborator || $[22] !== versionOverride) {
        t6 = !isExternalCollaborator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6e3ff5db190a542f$var$StyledBorder, null), isArchived && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aGJ9.ShareAndRestrictButton), {
            contentId: contentId,
            contentType: contentType,
            source: "contentHeader",
            isNotifyDisabled: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6e3ff5db190a542f$var$ContentHeaderShareAndCopyButtons, {
            contentId: contentId,
            versionOverride: versionOverride,
            contentType: contentType,
            contentSubType: contentSubType,
            isArchived: isArchived
        }));
        $[17] = contentId;
        $[18] = contentSubType;
        $[19] = contentType;
        $[20] = isArchived;
        $[21] = isExternalCollaborator;
        $[22] = versionOverride;
        $[23] = t6;
    } else t6 = $[23];
    let t7;
    if ($[24] !== props || $[25] !== t0 || $[26] !== t1 || $[27] !== t2 || $[28] !== t3 || $[29] !== t5 || $[30] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Cofr.GroupedPageButtonsCommon), props, t0, t1, t2, t3, t5, t6);
        $[24] = props;
        $[25] = t0;
        $[26] = t1;
        $[27] = t2;
        $[28] = t3;
        $[29] = t5;
        $[30] = t6;
        $[31] = t7;
    } else t7 = $[31];
    return t7;
};
$6e3ff5db190a542f$export$6955dde08e119b3d.propTypes = {
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    versionOverride: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).number,
    headerSticky: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    contentType: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    contentSubType: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    isExternalCollaborator: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    lastModifiedDate: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    isArchived: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool
};
module.exports["GroupedPageButtons"] = $6e3ff5db190a542f$export$6955dde08e119b3d;

});

parcelRegister("5EoFB", function(module, exports) {
const $41d3d3266b0b22cf$export$6b0a1934b74e691a = {
    PAGE: 0,
    SPACE: 1
};
const $41d3d3266b0b22cf$export$1841061cdd9b445a = 20;
module.exports["MANAGE_WATCHER_TAB_TYPES"] = $41d3d3266b0b22cf$export$6b0a1934b74e691a;

});

parcelRegister("lECEN", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $6b4nE = parcelRequire("6b4nE");


var $cozmU = parcelRequire("cozmU");


var $5X6fy = parcelRequire("5X6fy");


var $cpjd2 = parcelRequire("cpjd2");


var $asQED = parcelRequire("asQED");

const $fc3b51da62867b20$export$4354248d0b2a76d1 = [
    'wr!confluence.web.resources:querystring',
    'wr!confluence.web.resources:navigator-context',
    'wr!com.atlassian.plugins.atlassian-connect-plugin:confluence-atlassian-connect-resources-v5'
];
const $fc3b51da62867b20$export$562269fb9a75cb04 = (props)=>{
    const $ = (0, $bDgLe.c)(19);
    const { id: id, webItems: webItems, actions: actions, modifications: modifications, buttonType: buttonType, className: className, disableIcons: disableIcons, contentSubType: contentSubType, source: source } = props;
    let t0;
    if ($[0] !== webItems) {
        t0 = webItems.some($fc3b51da62867b20$var$_temp);
        $[0] = webItems;
        $[1] = t0;
    } else t0 = $[1];
    const needsConnectWRM = t0;
    let t1;
    let t2;
    if ($[2] !== needsConnectWRM) {
        t1 = ()=>{
            if (needsConnectWRM) (0, $cpjd2.requireLegacyWRM)($fc3b51da62867b20$export$4354248d0b2a76d1, $fc3b51da62867b20$var$_temp2, $fc3b51da62867b20$var$_temp3);
        };
        t2 = [
            needsConnectWRM
        ];
        $[2] = needsConnectWRM;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[5] !== className) {
        t3 = (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))("aui-buttons", className);
        $[5] = className;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== buttonType) {
        t4 = (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))(buttonType, "aui-button");
        $[7] = buttonType;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== actions || $[10] !== contentSubType || $[11] !== disableIcons || $[12] !== id || $[13] !== modifications || $[14] !== source || $[15] !== t3 || $[16] !== t4 || $[17] !== webItems) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $asQED.WebItemList), {
            dataTestId: "web-item-button-list",
            id: id,
            actions: actions,
            modifications: modifications,
            webItems: webItems,
            className: t3,
            webItemClassName: t4,
            disableIcons: disableIcons,
            contentSubType: contentSubType,
            source: source
        });
        $[9] = actions;
        $[10] = contentSubType;
        $[11] = disableIcons;
        $[12] = id;
        $[13] = modifications;
        $[14] = source;
        $[15] = t3;
        $[16] = t4;
        $[17] = webItems;
        $[18] = t5;
    } else t5 = $[18];
    return t5;
};
$fc3b51da62867b20$export$562269fb9a75cb04.displayName = 'WebItemButtonList';
$fc3b51da62867b20$export$562269fb9a75cb04.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    webItems: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).array,
    actions: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object,
    modifications: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object,
    buttonType: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    disableIcons: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    contentSubType: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    source: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string
};
function $fc3b51da62867b20$var$_temp(item) {
    return item.completeKey.startsWith("com.atlassian.plugins.atlassian-connect-plugin");
}
function $fc3b51da62867b20$var$_temp2() {}
function $fc3b51da62867b20$var$_temp3() {}
module.exports["WebItemButtonList"] = $fc3b51da62867b20$export$562269fb9a75cb04;

});

parcelRegister("cxCWb", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $gaGKC = parcelRequire("gaGKC");


const $56c3dbef55a81b41$export$a1f5ff36b0810fd8 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "0sh4s",
    name: "FavouriteButton",
    loader: async ()=>(await (parcelRequire("5Wz4b"))).FavouriteButton,
    loading: (0, $gaGKC.FavouriteButtonPlaceholder)
});

const $56c3dbef55a81b41$export$4151d732511e5aa6 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "m_S4n",
    name: "LazyFavouriteButton",
    loader: async ()=>(await (parcelRequire("5Wz4b"))).FavouriteButton,
    loading: (0, $gaGKC.FavouriteButtonPlaceholder)
});
module.exports["FavouriteButton"] = $56c3dbef55a81b41$export$a1f5ff36b0810fd8;
module.exports["LazyFavouriteButton"] = $56c3dbef55a81b41$export$4151d732511e5aa6;

});

parcelRegister("gaGKC", function(module, exports) {
/* FavouriteButtonPlaceholder.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $7ZB0A = parcelRequire("7ZB0A");


var $lbT4j = parcelRequire("lbT4j");

const $97ecf1ddef823285$var$i18n = (0, $kSwu1.defineMessages)({
    starLabel: {
        id: "favourite-button.placeholder.star.label",
        defaultMessage: "Star"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $97ecf1ddef823285$var$StyledButton = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = (0, $7ZB0A.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0sElkwuNcX _4GiLnvFQfX _27WIHEFQfX",
            __cmplp.className
        ])
    });
});
const $97ecf1ddef823285$export$d599e45cb4e3913 = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($97ecf1ddef823285$var$StyledButton, {
        "data-test-id": "page-favourite-button-placeholder",
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbT4j))), {
            label: formatMessage($97ecf1ddef823285$var$i18n.starLabel),
            color: "currentColor",
            spacing: "spacious"
        }),
        isDisabled: true
    });
};
module.exports["FavouriteButtonPlaceholder"] = $97ecf1ddef823285$export$d599e45cb4e3913;

});

parcelRegister("5Wz4b", function(module, exports) {

let $453d9202282cdfb9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $453d9202282cdfb9$var$load("hhu66"),
    $453d9202282cdfb9$var$load("87mhv"),
    $453d9202282cdfb9$var$load("6wr18"),
    $453d9202282cdfb9$var$load("ffEVr"),
    $453d9202282cdfb9$var$load("aLbuU"),
    $453d9202282cdfb9$var$load("1sXQt")
]).then(()=>parcelRequire('lDaLP'));

});

parcelRegister("D7PHQ", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $7ZB0A = parcelRequire("7ZB0A");


var $9DHhW = parcelRequire("9DHhW");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $2pBiX = parcelRequire("2pBiX");


var $4R3wx = parcelRequire("4R3wx");


var $jmjWc = parcelRequire("jmjWc");

var $luv00 = parcelRequire("luv00");


var $3Wf43 = parcelRequire("3Wf43");


var $5i3ci = parcelRequire("5i3ci");


var $aFmsO = parcelRequire("aFmsO");


var $7aRa9 = parcelRequire("7aRa9");


var $6mKj3 = parcelRequire("6mKj3");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $531iT = parcelRequire("531iT");


var $cxQ7E = parcelRequire("cxQ7E");


const $981c6be93b35769c$var$PageHeaderLoomButtonLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Bpphw",
    name: "PageHeaderLoomButtonLoader",
    loader: async ()=>(await (parcelRequire("gkF5C"))).PageHeaderLoomButton,
    loading: ({ isCircle: isCircle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cxQ7E.LoomPageHeaderPlaceholder), {
            isCircle: isCircle
        })
});

const $981c6be93b35769c$var$LoomCrossFlowPopupCardLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "J-rGd",
    name: "LoomCrossFlowPopupCardLoader",
    loader: async ()=>(await (parcelRequire("eH9vo"))).LoomCrossFlowPopupCard,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cxQ7E.LoomPageHeaderPlaceholder), null)
});

const $981c6be93b35769c$var$LoomCrossJoinPopupCardLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "32FyG",
    name: "LoomCrossJoinPopupCardLoader",
    loader: async ()=>(await (parcelRequire("kDIlS"))).LoomCrossJoinPopupCard,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cxQ7E.LoomPageHeaderPlaceholder), null)
}); /**
     * This touchpoint was previously in the page header, but has now been moved to the comments sidebar.
     * The naming will remain the same to avoid breaking any existing usages of this name.
     */ 
const $981c6be93b35769c$var$ENTRYPOINT_ID = 'loom-confluence-page-header';
const $981c6be93b35769c$var$SOURCE_COMPONENT = 'loomConfluencePageHeader';
const $981c6be93b35769c$var$SOURCE_CONTEXT = 'confluencePageHeaderRecordAVideo';
const $981c6be93b35769c$var$i18n = (0, $kSwu1.defineMessages)({
    crossJoinEntryPointLabel: {
        id: "page-header-loom-button.crossJoinEntryPointLabel",
        defaultMessage: "Join your team on Loom to record a video"
    },
    crossSellPopupCardDescription: {
        id: "page-header-loom-button.crossSellPopupCardDescription",
        defaultMessage: "Save time and engage your team with a video walkthrough, demo, update, and more."
    },
    crossSellPopupCardTitle: {
        id: "page-header-loom-button.crossSellPopupCardTitle",
        defaultMessage: "Share your work with video"
    },
    entryPointLabel: {
        id: "page-header-loom-button.entryPointLabel",
        defaultMessage: "Record a Loom video"
    }
});
const $981c6be93b35769c$var$ButtonSpacer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4ouGXIuNcX",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $981c6be93b35769c$var$PageHeaderLoomEntryPointComponent = (t0)=>{
    const $ = (0, $bDgLe.c)(84);
    const { contentId: contentId, contributorsFragmentRef: contributorsFragmentRef, crossSellPopupPlacement: crossSellPopupPlacement, crossSellSpotlightPlacement: crossSellSpotlightPlacement, spaceKey: spaceKey, contentType: contentType, flags: flags, isCircle: t1, testId: testId, source: source, isDisabled: t2 } = t0;
    const isCircle = t1 === undefined ? false : t1;
    const isDisabled = t2 === undefined ? false : t2;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    let entryPointVariant;
    let error;
    let loading;
    if (window.__SSR_RENDERED__ && window.__SSR_LOOM_ENTRY_POINT__) entryPointVariant = window.__SSR_LOOM_ENTRY_POINT__.entryPointVariant;
    const entryPointFromState = (0, $4R3wx.useLoomEntryPointVariant)();
    entryPointVariant = entryPointFromState.entryPointVariant;
    error = entryPointFromState.error;
    loading = entryPointFromState.loading;
    const isEntryPointEnabled = [
        "BETA",
        "CO_USE",
        "CROSS_FLOW",
        "CROSS_JOIN",
        "NONE"
    ].includes(entryPointVariant);
    const { isPulseActive: isPulseActive } = (0, $aFmsO.useDiscoverabilityPulse)($981c6be93b35769c$var$ENTRYPOINT_ID);
    const intl = (0, $kSwu1.useIntl)();
    let t3;
    if ($[0] !== flags) {
        t3 = {
            flags: flags
        };
        $[0] = flags;
        $[1] = t3;
    } else t3 = $[1];
    const loomEntryPointErrorCallback = (0, $2pBiX.useLoomEntryPointErrorCallback)(t3);
    let t4;
    if ($[2] !== createAnalyticsEvent || $[3] !== entryPointVariant) {
        t4 = ()=>{
            if (entryPointVariant === "CROSS_JOIN") createAnalyticsEvent({
                type: "sendScreenEvent",
                data: {
                    action: "viewed",
                    name: "createLoomHeaderItem",
                    attributes: {
                        adType: "crossJoin",
                        entrypoint: $981c6be93b35769c$var$ENTRYPOINT_ID,
                        sourceComponent: $981c6be93b35769c$var$SOURCE_COMPONENT
                    }
                }
            }).fire();
        };
        $[2] = createAnalyticsEvent;
        $[3] = entryPointVariant;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== createAnalyticsEvent || $[6] !== entryPointVariant) {
        t5 = [
            createAnalyticsEvent,
            entryPointVariant
        ];
        $[5] = createAnalyticsEvent;
        $[6] = entryPointVariant;
        $[7] = t5;
    } else t5 = $[7];
    (0, $cozmU.useEffect)(t4, t5);
    if (!isEntryPointEnabled) return null;
    if (entryPointVariant === "BETA" || entryPointVariant === "CO_USE") {
        let t6;
        if ($[8] !== intl) {
            t6 = intl.formatMessage($981c6be93b35769c$var$i18n.entryPointLabel);
            $[8] = intl;
            $[9] = t6;
        } else t6 = $[9];
        let t7;
        if ($[10] !== contentId || $[11] !== contentType || $[12] !== contributorsFragmentRef || $[13] !== isCircle || $[14] !== isDisabled || $[15] !== source || $[16] !== spaceKey || $[17] !== ssrPlaceholderIdProp || $[18] !== t6 || $[19] !== testId) {
            t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($981c6be93b35769c$var$PageHeaderLoomButtonLoader, {
                contributorsFragmentRef: contributorsFragmentRef,
                contentId: contentId,
                contentType: contentType,
                dataVC: "loom-button",
                label: t6,
                spaceKey: spaceKey,
                ssrPlaceholderIdProp: ssrPlaceholderIdProp,
                isCircle: isCircle,
                testId: testId,
                source: source,
                isDisabled: isDisabled
            });
            $[10] = contentId;
            $[11] = contentType;
            $[12] = contributorsFragmentRef;
            $[13] = isCircle;
            $[14] = isDisabled;
            $[15] = source;
            $[16] = spaceKey;
            $[17] = ssrPlaceholderIdProp;
            $[18] = t6;
            $[19] = testId;
            $[20] = t7;
        } else t7 = $[20];
        return t7;
    }
    if (error) {
        let t6;
        if ($[21] !== intl) {
            t6 = intl.formatMessage($981c6be93b35769c$var$i18n.entryPointLabel);
            $[21] = intl;
            $[22] = t6;
        } else t6 = $[22];
        let t7;
        if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $531iT.LoomVideoIcon), {
                label: "",
                color: "var(--ds-icon-subtle, #505258)"
            });
            $[23] = t7;
        } else t7 = $[23];
        let t8;
        if ($[24] !== loomEntryPointErrorCallback || $[25] !== t6) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
                appearance: "subtle",
                "aria-label": t6,
                "data-vc": "loom-button",
                iconAfter: t7,
                onClick: loomEntryPointErrorCallback
            });
            $[24] = loomEntryPointErrorCallback;
            $[25] = t6;
            $[26] = t8;
        } else t8 = $[26];
        return t8;
    }
    if (loading) {
        let t6;
        if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cxQ7E.LoomPageHeaderPlaceholder), null);
            $[27] = t6;
        } else t6 = $[27];
        return t6;
    }
    if (entryPointVariant === "CROSS_FLOW") {
        if (pageMode === (0, $cD1qu.PageMode).VIEW && (0, $6mKj3.expVal)("confluence_selection_hydration_loom_button", "isEnabled", false)) {
            let t6;
            if ($[28] !== intl) {
                t6 = intl.formatMessage($981c6be93b35769c$var$i18n.crossSellPopupCardDescription);
                $[28] = intl;
                $[29] = t6;
            } else t6 = $[29];
            let t7;
            if ($[30] !== intl) {
                t7 = intl.formatMessage($981c6be93b35769c$var$i18n.crossSellPopupCardTitle);
                $[30] = intl;
                $[31] = t7;
            } else t7 = $[31];
            let t8;
            if ($[32] !== intl) {
                t8 = intl.formatMessage($981c6be93b35769c$var$i18n.entryPointLabel);
                $[32] = intl;
                $[33] = t8;
            } else t8 = $[33];
            let t9;
            if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
                t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $531iT.LoomVideoIcon), {
                    label: "",
                    color: "var(--ds-icon-subtle, #505258)"
                });
                $[34] = t9;
            } else t9 = $[34];
            let t10;
            if ($[35] !== crossSellSpotlightPlacement || $[36] !== isCircle || $[37] !== isPulseActive || $[38] !== t6 || $[39] !== t7 || $[40] !== t8) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3Wf43.LoomCrossFlowPopupLoader), {
                    description: t6,
                    entryPointId: $981c6be93b35769c$var$ENTRYPOINT_ID,
                    spotlightPlacement: crossSellSpotlightPlacement,
                    sourceActionSubjectId: "createLoomHeaderItem",
                    sourceComponent: $981c6be93b35769c$var$SOURCE_COMPONENT,
                    sourceContext: $981c6be93b35769c$var$SOURCE_CONTEXT,
                    title: t7,
                    isCircle: isCircle,
                    ariaLabel: t8,
                    iconAfter: t9,
                    appearance: "subtle",
                    immediateActivationCondition: isPulseActive
                });
                $[35] = crossSellSpotlightPlacement;
                $[36] = isCircle;
                $[37] = isPulseActive;
                $[38] = t6;
                $[39] = t7;
                $[40] = t8;
                $[41] = t10;
            } else t10 = $[41];
            return t10;
        }
        let t6;
        if ($[42] !== intl) {
            t6 = intl.formatMessage($981c6be93b35769c$var$i18n.crossSellPopupCardDescription);
            $[42] = intl;
            $[43] = t6;
        } else t6 = $[43];
        let t7;
        if ($[44] !== intl) {
            t7 = intl.formatMessage($981c6be93b35769c$var$i18n.crossSellPopupCardTitle);
            $[44] = intl;
            $[45] = t7;
        } else t7 = $[45];
        let t8;
        if ($[46] !== intl || $[47] !== isCircle || $[48] !== ssrPlaceholderIdProp) {
            t8 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5i3ci.DiscoverabilityPulse), {
                    entryPointId: $981c6be93b35769c$var$ENTRYPOINT_ID,
                    isCircle: isCircle
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($981c6be93b35769c$var$ButtonSpacer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
                    ...triggerProps,
                    appearance: "subtle",
                    "aria-label": intl.formatMessage($981c6be93b35769c$var$i18n.entryPointLabel),
                    "data-vc": "loom-button",
                    iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $531iT.LoomVideoIcon), {
                        label: "",
                        color: "var(--ds-icon-subtle, #505258)"
                    }),
                    ...ssrPlaceholderIdProp
                })));
            $[46] = intl;
            $[47] = isCircle;
            $[48] = ssrPlaceholderIdProp;
            $[49] = t8;
        } else t8 = $[49];
        let t9;
        if ($[50] !== crossSellSpotlightPlacement || $[51] !== t6 || $[52] !== t7 || $[53] !== t8) {
            t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($981c6be93b35769c$var$LoomCrossFlowPopupCardLoader, {
                description: t6,
                entryPointId: $981c6be93b35769c$var$ENTRYPOINT_ID,
                spotlightPlacement: crossSellSpotlightPlacement,
                sourceActionSubjectId: "createLoomHeaderItem",
                sourceComponent: $981c6be93b35769c$var$SOURCE_COMPONENT,
                sourceContext: $981c6be93b35769c$var$SOURCE_CONTEXT,
                title: t7,
                trigger: t8
            });
            $[50] = crossSellSpotlightPlacement;
            $[51] = t6;
            $[52] = t7;
            $[53] = t8;
            $[54] = t9;
        } else t9 = $[54];
        return t9;
    }
    if (entryPointVariant === "CROSS_JOIN") {
        if (pageMode === (0, $cD1qu.PageMode).VIEW && (0, $6mKj3.expVal)("confluence_selection_hydration_loom_button", "isEnabled", false)) {
            let t6;
            if ($[55] !== intl) {
                t6 = intl.formatMessage($981c6be93b35769c$var$i18n.crossSellPopupCardDescription);
                $[55] = intl;
                $[56] = t6;
            } else t6 = $[56];
            let t7;
            if ($[57] !== intl) {
                t7 = intl.formatMessage($981c6be93b35769c$var$i18n.crossSellPopupCardTitle);
                $[57] = intl;
                $[58] = t7;
            } else t7 = $[58];
            let t8;
            if ($[59] !== intl) {
                t8 = intl.formatMessage($981c6be93b35769c$var$i18n.crossJoinEntryPointLabel);
                $[59] = intl;
                $[60] = t8;
            } else t8 = $[60];
            let t9;
            if ($[61] === Symbol.for("react.memo_cache_sentinel")) {
                t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $531iT.LoomVideoIcon), {
                    label: "",
                    color: "var(--ds-icon-subtle, #505258)"
                });
                $[61] = t9;
            } else t9 = $[61];
            let t10;
            if ($[62] !== crossSellPopupPlacement || $[63] !== flags || $[64] !== isCircle || $[65] !== isPulseActive || $[66] !== t6 || $[67] !== t7 || $[68] !== t8) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3Wf43.LoomCrossJoinPopupLoader), {
                    description: t6,
                    placement: crossSellPopupPlacement,
                    sourceActionSubjectId: "createLoomHeaderItem",
                    title: t7,
                    entryPointId: $981c6be93b35769c$var$ENTRYPOINT_ID,
                    isCircle: isCircle,
                    ariaLabel: t8,
                    iconAfter: t9,
                    appearance: "subtle",
                    immediateActivationCondition: isPulseActive,
                    flags: flags,
                    sourceComponent: $981c6be93b35769c$var$SOURCE_COMPONENT
                });
                $[62] = crossSellPopupPlacement;
                $[63] = flags;
                $[64] = isCircle;
                $[65] = isPulseActive;
                $[66] = t6;
                $[67] = t7;
                $[68] = t8;
                $[69] = t10;
            } else t10 = $[69];
            return t10;
        }
        let t6;
        if ($[70] !== intl) {
            t6 = intl.formatMessage($981c6be93b35769c$var$i18n.crossSellPopupCardDescription);
            $[70] = intl;
            $[71] = t6;
        } else t6 = $[71];
        let t7;
        if ($[72] !== intl) {
            t7 = intl.formatMessage($981c6be93b35769c$var$i18n.crossSellPopupCardTitle);
            $[72] = intl;
            $[73] = t7;
        } else t7 = $[73];
        let t8;
        if ($[74] !== intl || $[75] !== isCircle || $[76] !== ssrPlaceholderIdProp) {
            t8 = (href, t9)=>{
                const { onClick: onClick, ...otherTriggerProps } = t9;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5i3ci.DiscoverabilityPulse), {
                    entryPointId: $981c6be93b35769c$var$ENTRYPOINT_ID,
                    isCircle: isCircle
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($981c6be93b35769c$var$ButtonSpacer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
                    ...otherTriggerProps,
                    appearance: "subtle",
                    "aria-label": intl.formatMessage($981c6be93b35769c$var$i18n.crossJoinEntryPointLabel),
                    "data-vc": "loom-button",
                    href: href,
                    iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $531iT.LoomVideoIcon), {
                        label: "",
                        color: "var(--ds-icon-subtle, #505258)"
                    }),
                    rel: "noreferrer",
                    target: "_blank",
                    onClick: onClick,
                    ...ssrPlaceholderIdProp
                })));
            };
            $[74] = intl;
            $[75] = isCircle;
            $[76] = ssrPlaceholderIdProp;
            $[77] = t8;
        } else t8 = $[77];
        let t9;
        if ($[78] !== crossSellPopupPlacement || $[79] !== flags || $[80] !== t6 || $[81] !== t7 || $[82] !== t8) {
            t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($981c6be93b35769c$var$LoomCrossJoinPopupCardLoader, {
                description: t6,
                placement: crossSellPopupPlacement,
                sourceActionSubjectId: "createLoomHeaderItem",
                title: t7,
                entryPointId: $981c6be93b35769c$var$ENTRYPOINT_ID,
                triggerLink: t8,
                flags: flags,
                sourceComponent: $981c6be93b35769c$var$SOURCE_COMPONENT
            });
            $[78] = crossSellPopupPlacement;
            $[79] = flags;
            $[80] = t6;
            $[81] = t7;
            $[82] = t8;
            $[83] = t9;
        } else t9 = $[83];
        return t9;
    }
    return null;
};
const $981c6be93b35769c$export$35695746566a3d63 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
})((0, $7aRa9.withFlags)($981c6be93b35769c$var$PageHeaderLoomEntryPointComponent));
module.exports["PageHeaderLoomEntryPoint"] = $981c6be93b35769c$export$35695746566a3d63;

});

parcelRegister("2pBiX", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");

const $e5ba90f4b97bd7c1$var$i18n = (0, $kSwu1.defineMessages)({
    errorTitleCannotStart: {
        id: "loom-utils.error-flag.title.cannot-start",
        defaultMessage: "We couldn\u2019t start your recording"
    },
    errorSDKFailedToInitialize: {
        id: "loom-utils.error-flag.description.sdk-failed-to-initialize",
        defaultMessage: "Give it a moment and then refresh to try again."
    }
});
const $e5ba90f4b97bd7c1$export$b8f10a3122c10d73 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { flags: flags } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== flags || $[1] !== intl) {
        t1 = ()=>{
            flags.showInfoFlag({
                title: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorTitleCannotStart),
                description: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorSDKFailedToInitialize)
            });
        };
        $[0] = flags;
        $[1] = intl;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ flags: flags })=>{
    const intl = (0, $kSwu1.useIntl)();
    return (0, $cozmU.useCallback)(()=>{
        flags.showInfoFlag({
            title: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorTitleCannotStart),
            description: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorSDKFailedToInitialize)
        });
    }, [
        flags,
        intl
    ]);
};
module.exports["useLoomEntryPointErrorCallback"] = $e5ba90f4b97bd7c1$export$b8f10a3122c10d73;

});

parcelRegister("4R3wx", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $9wGTI = parcelRequire("9wGTI");


var $932VV = parcelRequire("932VV");


var $cYe4v = parcelRequire("cYe4v");


var $dpJII = parcelRequire("dpJII");


var $eNjW4 = parcelRequire("eNjW4");

const $c8aabf9b2e3d2d10$export$62184c98af916d7a = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(10);
    const isBetaEnabled = (0, $cYe4v.useIsLoomBetaEnabled)();
    const isLoomDisabled = (0, $eNjW4.useIsLoomDisabled)();
    const isLoomEntryPointsEnabled = (0, $932VV.useIsLoomEntryPointsEnabled)();
    let t0;
    if ($[0] !== isBetaEnabled || $[1] !== isLoomDisabled || $[2] !== isLoomEntryPointsEnabled) {
        t0 = !isLoomEntryPointsEnabled || isBetaEnabled || isLoomDisabled || !(0, $9wGTI.fg)("confluence_frontend_loom_cross_sell");
        $[0] = isBetaEnabled;
        $[1] = isLoomDisabled;
        $[2] = isLoomEntryPointsEnabled;
        $[3] = t0;
    } else t0 = $[3];
    const skipPermsCheck = t0;
    const t1 = skipPermsCheck || Boolean(window.__SSR_LOOM_ENTRY_POINT__);
    let t2;
    if ($[4] !== t1) {
        t2 = {
            skip: t1
        };
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    const loomEntryPointVariant = (0, $dpJII.useLoomPermissionStatus)(t2);
    if (window.__SSR_LOOM_ENTRY_POINT__) return window.__SSR_LOOM_ENTRY_POINT__;
    if (isLoomDisabled || !isLoomEntryPointsEnabled) {
        let t3;
        if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "DISABLED"
            };
            $[6] = t3;
        } else t3 = $[6];
        return t3;
    }
    if (isBetaEnabled) {
        let t3;
        if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "BETA"
            };
            $[7] = t3;
        } else t3 = $[7];
        return t3;
    }
    if (!(0, $9wGTI.fg)("confluence_frontend_loom_cross_sell")) {
        let t3;
        if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "DISABLED"
            };
            $[8] = t3;
        } else t3 = $[8];
        return t3;
    }
    if (loomEntryPointVariant.entryPointVariant === "CROSS_FLOW" && (0, $9wGTI.fg)("confluence_frontend_loom_cross_flow_ads_opt_out")) {
        let t3;
        if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "DISABLED"
            };
            $[9] = t3;
        } else t3 = $[9];
        return t3;
    }
    return loomEntryPointVariant;
} : ()=>{
    const isBetaEnabled = (0, $cYe4v.useIsLoomBetaEnabled)();
    const isLoomDisabled = (0, $eNjW4.useIsLoomDisabled)();
    const isLoomEntryPointsEnabled = (0, $932VV.useIsLoomEntryPointsEnabled)();
    // This can be replaced entirely by `isLoomDisabled` once Loom Beta is cleaned up
    const skipPermsCheck = !isLoomEntryPointsEnabled || isBetaEnabled || isLoomDisabled || !(0, $9wGTI.fg)('confluence_frontend_loom_cross_sell');
    const loomEntryPointVariant = (0, $dpJII.useLoomPermissionStatus)({
        // If the entry point variant has been SSRd, use that result and skip the permissions check
        skip: skipPermsCheck || Boolean(window.__SSR_LOOM_ENTRY_POINT__)
    });
    // If the entry point already exists via SSR, return that value in the hook here (no need to check anything else)
    if (window.__SSR_LOOM_ENTRY_POINT__) return window.__SSR_LOOM_ENTRY_POINT__;
    if (isLoomDisabled || !isLoomEntryPointsEnabled) return {
        entryPointVariant: 'DISABLED'
    };
    if (isBetaEnabled) return {
        entryPointVariant: 'BETA'
    };
    // This should be moved into useIsLoomDisabled once Loom Beta is cleaned up.
    // For now, we have to do the Beta check first because `confluence_frontend_loom_cross_sell` is
    // not enabled on Beta sites
    if (!(0, $9wGTI.fg)('confluence_frontend_loom_cross_sell')) return {
        entryPointVariant: 'DISABLED'
    };
    if (loomEntryPointVariant.entryPointVariant === 'CROSS_FLOW' && (0, $9wGTI.fg)('confluence_frontend_loom_cross_flow_ads_opt_out')) return {
        entryPointVariant: 'DISABLED'
    };
    return loomEntryPointVariant;
};
module.exports["useLoomEntryPointVariant"] = $c8aabf9b2e3d2d10$export$62184c98af916d7a;

});

parcelRegister("932VV", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $dHiKK = parcelRequire("dHiKK");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $7Sm4c = parcelRequire("7Sm4c");


var $i8Ofl = parcelRequire("i8Ofl");


var $c5JFM = parcelRequire("c5JFM");

const $45094daeb894a50e$var$UseIsLoomEntryPointsEnabledQuery = (0, $dHiKK.default);
const $45094daeb894a50e$export$5d821a9fc4b7faa = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(12);
    const { accessStatus: accessStatus, activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $c5JFM.isMeetingRecorderEligibilityEnabled)();
        $[0] = t0;
    } else t0 = $[0];
    const includeMeetingRecorderEligibility = t0;
    const shouldSkip = accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS && accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    let t1;
    if ($[1] !== cloudId) {
        t1 = {
            cloudId: cloudId,
            includeMeetingRecorderEligibility: includeMeetingRecorderEligibility
        };
        $[1] = cloudId;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== activationId || $[4] !== cloudId) {
        t2 = (0, $i8Ofl.createAtlAttributionHeader)(cloudId, activationId);
        $[3] = activationId;
        $[4] = cloudId;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t2) {
        t3 = {
            headers: {
                ...t2
            }
        };
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    const t4 = shouldSkip || Boolean(window.__SSR_LOOM_ENTRY_POINT__);
    let t5;
    if ($[8] !== t1 || $[9] !== t3 || $[10] !== t4) {
        t5 = {
            variables: t1,
            context: t3,
            skip: t4
        };
        $[8] = t1;
        $[9] = t3;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($45094daeb894a50e$var$UseIsLoomEntryPointsEnabledQuery, {
        ...t5,
        __callerPackage__: "loom-utils"
    });
    if (window.__SSR_LOOM_ENTRY_POINT__) return;
    if (error) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return true;
    }
    if (!loading && data) return data?.confluence_loomEntryPoints?.isLoomEntryPointsEnabled;
} : ()=>{
    const { accessStatus: accessStatus, activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const includeMeetingRecorderEligibility = (0, $c5JFM.isMeetingRecorderEligibilityEnabled)();
    const shouldSkip = accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS && accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($45094daeb894a50e$var$UseIsLoomEntryPointsEnabledQuery, {
        variables: {
            cloudId: cloudId,
            includeMeetingRecorderEligibility: includeMeetingRecorderEligibility
        },
        context: {
            headers: {
                ...(0, $i8Ofl.createAtlAttributionHeader)(cloudId, activationId)
            }
        },
        skip: shouldSkip || Boolean(window.__SSR_LOOM_ENTRY_POINT__),
        __callerPackage__: "loom-utils"
    });
    if (window.__SSR_LOOM_ENTRY_POINT__) return undefined;
    if (error) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return true;
    }
    if (!loading && data) return data?.confluence_loomEntryPoints?.isLoomEntryPointsEnabled;
};
module.exports["useIsLoomEntryPointsEnabled"] = $45094daeb894a50e$export$5d821a9fc4b7faa;

});

parcelRegister("dHiKK", function(module, exports) {
/**
 * @generated SignedSource<<6bffa4411017429251cce91466f25b2c>>
 * @relayHash f7bb335b70d26ad812bfb3643de03577
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f7ffa147cd1d4533462f1fb2c3c994f63b873577cc20f9e4875b94343191953c
const $dc96dcb71a986382$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeMeetingRecorderEligibility"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "siteId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "ConfluenceLoomEntryPoints",
            "kind": "LinkedField",
            "name": "confluence_loomEntryPoints",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isLoomEntryPointsEnabled"
                }
            ]
        },
        {
            "condition": "includeMeetingRecorderEligibility",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "LoomSettings",
                    "kind": "LinkedField",
                    "name": "loom_settings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "meetingRecordingsAvailable"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "meetingNotesEligible"
                        }
                    ]
                },
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "LoomConnectedCalendar",
                    "kind": "LinkedField",
                    "name": "loom_connectedCalendars",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "guid"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsLoomEntryPointsEnabledQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsLoomEntryPointsEnabledQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "f7bb335b70d26ad812bfb3643de03577",
            "id": "f7ffa147cd1d4533462f1fb2c3c994f63b873577cc20f9e4875b94343191953c",
            "metadata": {},
            "name": "useIsLoomEntryPointsEnabledQuery",
            "operationKind": "query",
            "text": "query useIsLoomEntryPointsEnabledQuery($cloudId:ID!,$includeMeetingRecorderEligibility:Boolean!){confluence_loomEntryPoints(cloudId:$cloudId){isLoomEntryPointsEnabled},loom_settings(siteId:$cloudId)@include(if:$includeMeetingRecorderEligibility){meetingRecordingsAvailable,meetingNotesEligible}\n  loom_connectedCalendars(siteId:$cloudId)@include(if:$includeMeetingRecorderEligibility){guid}}"
        }
    };
}();
$dc96dcb71a986382$var$node.hash = "992c3639759f7aa3511f220e9547ecc6";
var $dc96dcb71a986382$export$2e2bcd8739ae039 = $dc96dcb71a986382$var$node;
module.exports["default"] = $dc96dcb71a986382$export$2e2bcd8739ae039;

});

parcelRegister("i8Ofl", function(module, exports) {
const $bde9a1914731baf3$var$PRODUCT = 'Confluence Cloud';
const $bde9a1914731baf3$var$buildWorkspaceId = (tenantId, activationId)=>{
    return `ari:cloud:confluence:${tenantId}:workspace/${activationId}`;
};
const $bde9a1914731baf3$export$14ef296862e3705e = (tenantId, activationId)=>{
    const atlAttributionHeader = {
        atlWorkspaceId: $bde9a1914731baf3$var$buildWorkspaceId(tenantId, activationId),
        tenantId: tenantId,
        product: $bde9a1914731baf3$var$PRODUCT,
        service: 'cc-fe-bifrost'
    };
    return {
        'atl-attribution': JSON.stringify(atlAttributionHeader)
    };
};
module.exports["createAtlAttributionHeader"] = $bde9a1914731baf3$export$14ef296862e3705e;

});

parcelRegister("c5JFM", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $c8d6014c9c636b97$export$7c5b1b3e3108671e = ()=>(0, $9wGTI.fg)('twcg-2202-loom-meeting-nudge-ht-gate') || (0, $9wGTI.fg)('twcg-2202-loom-meeting-nudge-lt-gate');
module.exports["isMeetingRecorderEligibilityEnabled"] = $c8d6014c9c636b97$export$7c5b1b3e3108671e;

});

parcelRegister("cYe4v", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $8dwdz = parcelRequire("8dwdz");

const $9ecfddb6136413dc$export$a3777efa0eef336c = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isConfluenceLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
        $[0] = t0;
    } else t0 = $[0];
    const isMobileDeviceOrMobileWeb = t0;
    let t1;
    if ($[1] !== isConfluenceLicensed) {
        t1 = isConfluenceLicensed && !isMobileDeviceOrMobileWeb && (0, $9wGTI.fg)("confluence_loom_beta_enabled");
        $[1] = isConfluenceLicensed;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isConfluenceLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    // don't enable entry points if user is on a mobile device or viewing mobile web
    const isMobileDeviceOrMobileWeb = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    return isConfluenceLicensed && !isMobileDeviceOrMobileWeb && (0, $9wGTI.fg)('confluence_loom_beta_enabled');
};
module.exports["useIsLoomBetaEnabled"] = $9ecfddb6136413dc$export$a3777efa0eef336c;

});

parcelRegister("dpJII", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bQm3c = parcelRequire("bQm3c");


var $5CUwy = parcelRequire("5CUwy");

const $42c1694041a86183$export$da228976f78945fd = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { skip: t2 } = t1;
    const skip = t2 === undefined ? false : t2;
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const [t3, t4] = (0, $5CUwy.useLoomEntryPointVariantState)();
    const { loomEntryPointVariant: loomEntryPointVariant } = t3;
    const { initLoomEntryPointVariant: initLoomEntryPointVariant } = t4;
    const { entryPointVariant: entryPointVariant, loading: loading } = loomEntryPointVariant;
    let t5;
    let t6;
    if ($[2] !== cloudId || $[3] !== entryPointVariant || $[4] !== initLoomEntryPointVariant || $[5] !== loading || $[6] !== skip || $[7] !== userId) {
        t5 = ()=>{
            if (skip) return;
            if (entryPointVariant === "NONE" && !loading) initLoomEntryPointVariant(cloudId, userId);
        };
        t6 = [
            cloudId,
            initLoomEntryPointVariant,
            loading,
            entryPointVariant,
            skip,
            userId
        ];
        $[2] = cloudId;
        $[3] = entryPointVariant;
        $[4] = initLoomEntryPointVariant;
        $[5] = loading;
        $[6] = skip;
        $[7] = userId;
        $[8] = t5;
        $[9] = t6;
    } else {
        t5 = $[8];
        t6 = $[9];
    }
    (0, $cozmU.useEffect)(t5, t6);
    if (entryPointVariant === "NONE") {
        let t7;
        if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = {
                entryPointVariant: "NONE",
                loading: true
            };
            $[10] = t7;
        } else t7 = $[10];
        return t7;
    }
    return loomEntryPointVariant;
} : ({ skip: skip = false } = {})=>{
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const [{ loomEntryPointVariant: loomEntryPointVariant }, { initLoomEntryPointVariant: initLoomEntryPointVariant }] = (0, $5CUwy.useLoomEntryPointVariantState)();
    const { entryPointVariant: entryPointVariant, loading: loading } = loomEntryPointVariant;
    (0, $cozmU.useEffect)(()=>{
        if (skip) return;
        if (entryPointVariant === 'NONE' && !loading) initLoomEntryPointVariant(cloudId, userId);
    }, [
        cloudId,
        initLoomEntryPointVariant,
        loading,
        entryPointVariant,
        skip,
        userId
    ]);
    if (entryPointVariant === 'NONE') return {
        entryPointVariant: 'NONE',
        loading: true
    };
    return loomEntryPointVariant;
};
module.exports["useLoomPermissionStatus"] = $42c1694041a86183$export$da228976f78945fd;

});

parcelRegister("5CUwy", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $gXfti = parcelRequire("gXfti");


var $c0rhi = parcelRequire("c0rhi");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $8999o = parcelRequire("8999o");


var $lnyJf = parcelRequire("lnyJf");


var $3uzFB = parcelRequire("3uzFB");


var $2gAEP = parcelRequire("2gAEP");

var $9633e2f0bea217d1$export$ebe749be4eb13ac4 = /*#__PURE__*/ function(LoomTenantProvisionStatus) {
    LoomTenantProvisionStatus["PROVISIONED"] = "provisioned";
    LoomTenantProvisionStatus["NOT_PROVISIONED"] = "not-provisioned";
    LoomTenantProvisionStatus["ERROR"] = "error,";
    return LoomTenantProvisionStatus;
}({});
var $9633e2f0bea217d1$export$7909e54672d1c423 = /*#__PURE__*/ function(LoomUserPermissionStatus) {
    LoomUserPermissionStatus["PERMITTED"] = "permitted";
    LoomUserPermissionStatus["NOT_PERMITTED"] = "not-permitted";
    LoomUserPermissionStatus["ERROR"] = "error,";
    return LoomUserPermissionStatus;
}({});
const $9633e2f0bea217d1$var$getLoomTenantProvisionStatus = async ()=>{
    try {
        const licensedProducts = await (0, $c0rhi.queryInterop)({
            query: (0, $2gAEP.default),
            __callerPackage__: "loom-utils"
        });
        const isTenantLicensed = licensedProducts.data.confluence_tenantContext?.licensedProducts.some((product)=>product.productKey === 'loom' && product.licenseStatus === 'ACTIVE');
        return isTenantLicensed ? "provisioned" : "not-provisioned";
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return "error,";
    }
};
const $9633e2f0bea217d1$export$85de6c803181afa9 = async (cloudId, userId)=>{
    if (!userId) return "not-permitted";
    const variables = (0, $3uzFB.getLoomUserPermissionQueryVariables)(cloudId, userId);
    try {
        const { data: data, error: error } = await (0, $c0rhi.queryInterop)({
            query: (0, $3uzFB.LoomUserPermissionQuery),
            variables: variables,
            errorPolicy: 'all',
            interopApolloAggClient: true,
            __callerPackage__: "loom-utils"
        });
        if (error) throw error;
        return (0, $3uzFB.hasExactLoomUserPermission)(data, variables) ? "permitted" : "not-permitted";
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return "error,";
    }
};
const $9633e2f0bea217d1$var$initialState = {
    loomEntryPointVariant: window.__SSR_LOOM_ENTRY_POINT__ ? window.__SSR_LOOM_ENTRY_POINT__ : {
        entryPointVariant: 'NONE'
    }
};
const $9633e2f0bea217d1$export$cbb01c57ec9c933e = {
    initLoomEntryPointVariant: (cloudId, userId)=>async ({ getState: getState, setState: setState })=>{
            const state = getState();
            if (state.loomEntryPointVariant.entryPointVariant !== 'NONE') return;
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CROSS_FLOW',
                    loading: true
                }
            });
            const loomTenantProvisionStatus = await $9633e2f0bea217d1$var$getLoomTenantProvisionStatus();
            if (loomTenantProvisionStatus === "not-provisioned") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_FLOW'
                    }
                });
                return;
            }
            if (loomTenantProvisionStatus === "error,") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_FLOW',
                        error: true
                    }
                });
                return;
            }
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CROSS_JOIN',
                    loading: true
                }
            });
            const loomUserPermissionStatus = await $9633e2f0bea217d1$export$85de6c803181afa9(cloudId, userId);
            if (loomUserPermissionStatus === "not-permitted") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_JOIN'
                    }
                });
                return;
            }
            if (loomUserPermissionStatus === "error,") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_JOIN',
                        error: true
                    }
                });
                return;
            }
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CO_USE'
                }
            });
        },
    // No preloader counterpart needed: setCrossJoinSuccess is a runtime-only action
    // triggered after a user completes the interactive cross-join flow (navigates to
    // Loom, gets provisioned, and returns). This cannot occur during SSR. The
    // window.__SSR_LOOM_ENTRY_POINT__ write updates the cached signal so that
    // useLoomEntryPointVariant sees CO_USE on subsequent client-side navigations
    // without re-running the permissions fetch — same pattern as crossFlowSuccessCheck.
    setCrossJoinSuccess: ()=>({ setState: setState })=>{
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CO_USE'
                }
            });
            window.__SSR_LOOM_ENTRY_POINT__ = {
                entryPointVariant: 'CO_USE'
            };
        },
    crossFlowSuccessCheck: ({ cloudId: cloudId, onCrossflowFailure: onCrossflowFailure, createAnalyticsEvent: createAnalyticsEvent, sourceComponent: sourceComponent })=>async ({ setState: setState })=>{
            // refetch license information since TCS doesn't update automatically
            try {
                const { ok: hasLoom, tries: tries } = await (0, $8999o.waitUntil)({
                    fn: ()=>(0, $lnyJf.fetchLicenseInformation)(cloudId),
                    condition: (info)=>info.products['loom']?.state === 'ACTIVE',
                    maxTries: 2,
                    // arbitrarily deciding on just 1 retry until we have more data to understand the eventual consistency here
                    retryWait: 500
                });
                (0, $gXfti.addUFOCustomData)({
                    pollingTries: tries,
                    hasLoom: hasLoom
                });
                if (hasLoom) {
                    // don't bother getLoomUserPermissionStatus here, we assume if the site has loom, the admin will have been given a license during provisioning
                    setState({
                        loomEntryPointVariant: {
                            entryPointVariant: 'CO_USE'
                        }
                    });
                    //This is needed for SSR to work correctly, since we skip logic in useLoomEntryPointVariant.ts if the entry point was SSR-ed
                    window.__SSR_LOOM_ENTRY_POINT__ = {
                        entryPointVariant: 'CO_USE'
                    };
                } else onCrossflowFailure && onCrossflowFailure();
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        actionSubject: 'confluenceLoomUtils.fetchLicenseInformation',
                        action: 'success',
                        source: 'confluenceLoomUtils',
                        attributes: {
                            hasLoom: hasLoom,
                            tries: tries,
                            sourceComponent: sourceComponent
                        }
                    }
                }).fire();
            } catch (error) {
                onCrossflowFailure && onCrossflowFailure();
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        actionSubject: 'confluenceLoomUtils.fetchLicenseInformation',
                        action: 'fail',
                        source: 'confluenceLoomUtils',
                        attributes: {
                            error: error.message,
                            sourceComponent: sourceComponent
                        }
                    }
                }).fire();
            }
        }
};
const $9633e2f0bea217d1$var$loomEntryPointVariantStore = (0, $8s9DV.createStore)({
    initialState: $9633e2f0bea217d1$var$initialState,
    actions: $9633e2f0bea217d1$export$cbb01c57ec9c933e,
    name: 'loomEntryPointVariantState'
});
const $9633e2f0bea217d1$export$9d93351985de2290 = (0, $kBr4q.createHook)($9633e2f0bea217d1$var$loomEntryPointVariantStore);
const $9633e2f0bea217d1$export$fd0650c7a15c6ef2 = (0, $kBr4q.createActionsHook)($9633e2f0bea217d1$var$loomEntryPointVariantStore);
module.exports["LoomTenantProvisionStatus"] = $9633e2f0bea217d1$export$ebe749be4eb13ac4;
module.exports["LoomUserPermissionStatus"] = $9633e2f0bea217d1$export$7909e54672d1c423;
module.exports["useLoomEntryPointVariantState"] = $9633e2f0bea217d1$export$9d93351985de2290;
module.exports["useLoomEntryPointVariantActions"] = $9633e2f0bea217d1$export$fd0650c7a15c6ef2;

});

parcelRegister("8999o", function(module, exports) {
const $887bf6ed89c38788$export$4e57ed416e50788e = async ({ fn: fn, condition: condition, retryWait: retryWait, maxTries: maxTries })=>{
    let tries = 0;
    while(true){
        tries++;
        const result = await fn();
        const ok = condition(result);
        if (tries === maxTries || ok) return {
            ok: ok,
            result: result,
            tries: tries
        };
        await new Promise((resolve)=>setTimeout(resolve, retryWait));
    }
};
module.exports["waitUntil"] = $887bf6ed89c38788$export$4e57ed416e50788e;

});

parcelRegister("lnyJf", function(module, exports) {

var $8J8QJ = parcelRequire("8J8QJ");

const $1f2e3e69723febb9$export$a573b79a27d213cc = (cloudId)=>(0, $8J8QJ.fetchJSON)(`/gateway/api/xflow/${cloudId}/license-information`);
module.exports["fetchLicenseInformation"] = $1f2e3e69723febb9$export$a573b79a27d213cc;

});

parcelRegister("8J8QJ", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $d6NtA = parcelRequire("d6NtA");

const $a326082f26863093$export$c776284ef4b1209a = (url, data)=>{
    const fetchOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    };
    return (0, $f7B1p.cfetch)(url, fetchOptions).then((response)=>{
        return response.json();
    });
};
const $a326082f26863093$export$81bec6e38e8b706b = (url)=>{
    const fetchOptions = {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ...Boolean(undefined) && Boolean(undefined) && !(0, $d6NtA.isLocal)() ? {
                'x-ssr-service-name': 'identity-platform'
            } : {}
        }
    };
    return (0, $f7B1p.cfetch)(url, fetchOptions).then((response)=>{
        return response.json();
    });
};
module.exports["fetchJSON"] = $a326082f26863093$export$81bec6e38e8b706b;

});

parcelRegister("d6NtA", function(module, exports) {
var $54fed5011c3efebd$export$c32b36f46293e67b = /*#__PURE__*/ function(MicrosEnvironmentType) {
    MicrosEnvironmentType["local"] = "local";
    MicrosEnvironmentType["dev"] = "dev";
    MicrosEnvironmentType["staging"] = "staging";
    MicrosEnvironmentType["prod"] = "prod";
    return MicrosEnvironmentType;
}({});
const $54fed5011c3efebd$export$6dd1bbd39f571125 = ()=>false;
const $54fed5011c3efebd$export$23da1d24a38b0bde = ()=>globalThis.ssrContext.environmentType === "staging";
const $54fed5011c3efebd$export$64471597a28217e6 = ()=>$54fed5011c3efebd$export$6dd1bbd39f571125() || $54fed5011c3efebd$export$23da1d24a38b0bde() || globalThis.ssrContext.environmentType === "dev";
const $54fed5011c3efebd$export$4bd44a2aa29d3d6e = ()=>globalThis.ssrContext.environment;
const $54fed5011c3efebd$export$1038046b28a1d92e = ()=>globalThis.ssrContext.environmentType;
const $54fed5011c3efebd$export$94e128262c4fa6c3 = ()=>globalThis.ssrContext.entryScriptVersionId;
const $54fed5011c3efebd$export$4caa72c46cbac3be = ()=>globalThis.ssrContext?.runtimeImageVersion ?? 'unknown';
const $54fed5011c3efebd$export$7d4093513f0cae50 = ()=>globalThis.ssrContext?.isInShadow === true;
function $54fed5011c3efebd$export$bcbc3e9e1c9133d4() {
    return globalThis.ssrContext.isInIC === true;
}
function $54fed5011c3efebd$export$4b05536c6e03cc69() {
    return globalThis.ssrContext?.isInFedramp === true;
}
function $54fed5011c3efebd$export$9cbc7f94bfb6210() {
    return globalThis.ssrContext.icName;
}
function $54fed5011c3efebd$export$eb7aff7f8b96b11f() {
    return globalThis.ssrContext.isInGCP === true;
}
function $54fed5011c3efebd$export$f0bc966c9609c798() {
    return globalThis.ssrContext.cellName;
}
module.exports["isLocal"] = $54fed5011c3efebd$export$6dd1bbd39f571125;

});

parcelRegister("3uzFB", function(module, exports) {

var $keH2u = parcelRequire("keH2u");

const $9ee481529bbe8b4d$export$a4bb6b905bc500e2 = (0, $keH2u.default);
const $9ee481529bbe8b4d$export$8d50de945dbf45ca = (cloudId, userId)=>({
        principalId: `ari:cloud:identity::user/${userId}`,
        loomResourceId: `ari:cloud:loom::site/${cloudId}`
    });
const $9ee481529bbe8b4d$export$b048e9c33b8e482 = (data, variables)=>{
    const matchingRows = data?.bulkPermitted?.filter((row)=>row?.principalId === variables.principalId && row?.resourceId === variables.loomResourceId && row?.permissionId === 'write') ?? [];
    if (matchingRows.length < 1) return false;
    return matchingRows.every((row)=>row?.permitted === true);
};
module.exports["LoomUserPermissionQuery"] = $9ee481529bbe8b4d$export$a4bb6b905bc500e2;
module.exports["getLoomUserPermissionQueryVariables"] = $9ee481529bbe8b4d$export$8d50de945dbf45ca;
module.exports["hasExactLoomUserPermission"] = $9ee481529bbe8b4d$export$b048e9c33b8e482;

});

parcelRegister("keH2u", function(module, exports) {
/**
 * @generated SignedSource<<9936c66f475f5b5cae80af06b548f8cb>>
 * @relayHash 1246767ea7fb9149278e67c3ec09752c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b59faaba67fb092ef603e9f684b1d3e070c6185add127d90ea41320066a6b1e5
const $ebcff904befcd9cb$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "loomResourceId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "principalId"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "permissionIds",
                    "value": [
                        "write"
                    ]
                },
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "principalIds.0",
                            "variableName": "principalId"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "principalIds"
                },
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "resourceIds.0",
                            "variableName": "loomResourceId"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "resourceIds"
                }
            ],
            "concreteType": "BulkPermittedResponse",
            "kind": "LinkedField",
            "name": "bulkPermitted",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "principalId"
                },
                {
                    "kind": "ScalarField",
                    "name": "resourceId"
                },
                {
                    "kind": "ScalarField",
                    "name": "permissionId"
                },
                {
                    "kind": "ScalarField",
                    "name": "permitted"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "loomUserPermissionQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "loomUserPermissionQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "1246767ea7fb9149278e67c3ec09752c",
            "id": "b59faaba67fb092ef603e9f684b1d3e070c6185add127d90ea41320066a6b1e5",
            "metadata": {},
            "name": "loomUserPermissionQuery",
            "operationKind": "query",
            "text": "query loomUserPermissionQuery($principalId:String!,$loomResourceId:String!){bulkPermitted(principalIds:[$principalId],resourceIds:[$loomResourceId],permissionIds:[\"write\"]){principalId,resourceId,permissionId,permitted}}"
        }
    };
}();
$ebcff904befcd9cb$var$node.hash = "714c5537c580f754bda23bcf99534b30";
var $ebcff904befcd9cb$export$2e2bcd8739ae039 = $ebcff904befcd9cb$var$node;
module.exports["default"] = $ebcff904befcd9cb$export$2e2bcd8739ae039;

});

parcelRegister("2gAEP", function(module, exports) {
/**
 * @generated SignedSource<<7e1563bf12c221b07284eee871d1f539>>
 * @relayHash e7355c15b066e2e1bf0badd5083ad1e0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 828d3d71f54e604f54b7f67c20834db4af8fce46b828590b916534ec1ced08af
const $936b36fbe81f4fb7$var$node = function() {
    var v0 = [
        {
            "concreteType": "ConfluenceTenantContext",
            "kind": "LinkedField",
            "name": "confluence_tenantContext",
            "plural": false,
            "selections": [
                {
                    "concreteType": "LicensedProduct",
                    "kind": "LinkedField",
                    "name": "licensedProducts",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "licenseStatus"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "productKey"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useLoomTenantProvisionStatusQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useLoomTenantProvisionStatusQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "e7355c15b066e2e1bf0badd5083ad1e0",
            "id": "828d3d71f54e604f54b7f67c20834db4af8fce46b828590b916534ec1ced08af",
            "metadata": {},
            "name": "useLoomTenantProvisionStatusQuery",
            "operationKind": "query",
            "text": "query useLoomTenantProvisionStatusQuery{confluence_tenantContext{licensedProducts{licenseStatus,productKey}}}"
        }
    };
}();
$936b36fbe81f4fb7$var$node.hash = "21c387cdafea215b61e4183319580a69";
var $936b36fbe81f4fb7$export$2e2bcd8739ae039 = $936b36fbe81f4fb7$var$node;
module.exports["default"] = $936b36fbe81f4fb7$export$2e2bcd8739ae039;

});

parcelRegister("eNjW4", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $3ricL = parcelRequire("3ricL");


var $8dwdz = parcelRequire("8dwdz");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $a42f1b873e59961a$export$9cca7cb3443dfd1 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const isMobile = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    const isLoomFeatureEnabled = (0, $3ricL.isFeatureEnabled)("confluence", "confluence-loom-integration");
    const { accessStatus: accessStatus, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isLicensed = accessStatus == (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus == (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    if (!isLoggedIn || !isLicensed) return true;
    if (!isLoomFeatureEnabled) return true;
    if (isMobile) return true;
    return false;
} : ()=>{
    const isMobile = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    const isLoomFeatureEnabled = (0, $3ricL.isFeatureEnabled)('confluence', 'confluence-loom-integration');
    const { accessStatus: accessStatus, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isLicensed = accessStatus == (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus == (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    if (!isLoggedIn || !isLicensed) return true;
    // Disable when feature is not enabled in current environment/evaluation
    if (!isLoomFeatureEnabled) return true;
    // don't enable entry points if user is on a mobile device or viewing mobile web
    if (isMobile) return true;
    return false;
};
module.exports["useIsLoomDisabled"] = $a42f1b873e59961a$export$9cca7cb3443dfd1;

});

parcelRegister("3Wf43", function(module, exports) {

var $gIaMn = parcelRequire("gIaMn");

var $jmjWc = parcelRequire("jmjWc");


var $5Abqh = parcelRequire("5Abqh");


const $98cee705389562e0$export$2a0b2901b6f1e4ac = (0, $jmjWc.LoadableActivatable)({
    __loadable_id__: "TnkNJ",
    name: "LoomCrossFlowPopupLoader",
    loader: async ()=>(await (parcelRequire("eBSsH"))).LoomCrossFlowPopupComponent,
    triggers: [
        {
            type: (0, $gIaMn.ActivationTriggerType).HOVER
        }
    ],
    ssrSuccessCheckName: (0, $5Abqh.SSR_PARTIAL_COMPONENT).LoomButton
});

const $98cee705389562e0$export$ba53a8d423873260 = (0, $jmjWc.LoadableActivatable)({
    __loadable_id__: "d4je0",
    name: "LoomCrossJoinPopupLoader",
    loader: async ()=>(await (parcelRequire("fKw3D"))).LoomCrossJoinPopupComponent,
    triggers: [
        {
            type: (0, $gIaMn.ActivationTriggerType).HOVER
        }
    ],
    ssrSuccessCheckName: (0, $5Abqh.SSR_PARTIAL_COMPONENT).LoomButton
});
module.exports["LoomCrossFlowPopupLoader"] = $98cee705389562e0$export$2a0b2901b6f1e4ac;
module.exports["LoomCrossJoinPopupLoader"] = $98cee705389562e0$export$ba53a8d423873260;

});

parcelRegister("eBSsH", function(module, exports) {

let $aa2ec468cb8ed53a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $aa2ec468cb8ed53a$var$load("gpUln"),
    $aa2ec468cb8ed53a$var$load("6wr18"),
    $aa2ec468cb8ed53a$var$load("CqGpG"),
    $aa2ec468cb8ed53a$var$load("ffEVr"),
    $aa2ec468cb8ed53a$var$load("2DxXe")
]).then(()=>parcelRequire('9cwPn'));

});

parcelRegister("fKw3D", function(module, exports) {

let $b77404e49080b07b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b77404e49080b07b$var$load("3CBDb"),
    $b77404e49080b07b$var$load("gpUln"),
    $b77404e49080b07b$var$load("EYiM3")
]).then(()=>parcelRequire('lvs3G'));

});

parcelRegister("5i3ci", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $gWLTH = parcelRequire("gWLTH");


var $9wGTI = parcelRequire("9wGTI");


var $aFmsO = parcelRequire("aFmsO");


var $8jXZv = parcelRequire("8jXZv");


var $9Zall = parcelRequire("9Zall");

const $9fbe62170cacfcf3$export$d6e697640576fe29 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children, entryPointId: entryPointId, isCircle: isCircle } = t0;
    const { isPulseActive: isPulseActive } = (0, $aFmsO.useDiscoverabilityPulse)(entryPointId);
    if (!isPulseActive) return children;
    if ((0, $9wGTI.fg)("confluence_frontend_spotlight_ads_migration")) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Zall.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jXZv.PopoverTarget), null, children));
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    const t1 = isCircle ? 24 : 3;
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gWLTH.Pulse), {
            radius: t1,
            testId: "loom-cross-sell-discoverability-pulse"
        }, children);
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ children: children, entryPointId: entryPointId, isCircle: isCircle })=>{
    const { isPulseActive: isPulseActive } = (0, $aFmsO.useDiscoverabilityPulse)(entryPointId);
    if (!isPulseActive) return children;
    // Feature-gated migration from @atlaskit/onboarding to @atlaskit/spotlight
    if ((0, $9wGTI.fg)('confluence_frontend_spotlight_ads_migration')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Zall.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jXZv.PopoverTarget), null, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gWLTH.Pulse), {
        radius: isCircle ? 24 : 3,
        testId: "loom-cross-sell-discoverability-pulse"
    }, children);
};
module.exports["DiscoverabilityPulse"] = $9fbe62170cacfcf3$export$d6e697640576fe29;

});

parcelRegister("aFmsO", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6m3nS = parcelRequire("6m3nS");


var $gd8AW = parcelRequire("gd8AW");

const $9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS = [
    'cc-loom-x-sell-discoverability-pulse-1',
    'cc-loom-x-sell-discoverability-pulse-2',
    'cc-loom-x-sell-discoverability-pulse-3',
    'cc-loom-x-sell-discoverability-pulse-4',
    'cc-loom-x-sell-discoverability-pulse-5'
];
const $9c43e73b872d5b9c$var$TIMEOUT_MS = 300;
const $9c43e73b872d5b9c$var$LAST_PULSE_INDEX = $9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS.length - 1;
const $9c43e73b872d5b9c$var$requestNextPulse = (nextIndex, pulseHooks, hasRequestedRef, lastRequestedRef)=>{
    if (nextIndex < pulseHooks.length && !hasRequestedRef.current.has(nextIndex)) {
        hasRequestedRef.current.add(nextIndex);
        lastRequestedRef.current = {
            index: nextIndex,
            timestamp: Date.now()
        };
        pulseHooks[nextIndex].requestMessageStart();
    }
};
const $9c43e73b872d5b9c$export$2002ab0670152c89 = (0, $3u0dr.isReactCompilerActiveV2)() ? (entryPointId)=>{
    const $ = (0, $bDgLe.c)(74);
    const isPulseActive = (0, $gd8AW.useIsPulseActive)(entryPointId);
    const { startPulse: startPulse } = (0, $gd8AW.useDiscoverabilityPulseActions)();
    let t0;
    if ($[0] !== isPulseActive) {
        t0 = isPulseActive && (0, $gd8AW.havePulsesEnded)();
        $[0] = isPulseActive;
        $[1] = t0;
    } else t0 = $[1];
    const skipRefreshPulseStatus = t0;
    const pulse1 = (0, $6m3nS.usePostOfficeExernalMessageProxy)($9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[0]);
    const pulse2 = (0, $6m3nS.usePostOfficeExernalMessageProxy)($9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[1]);
    const pulse3 = (0, $6m3nS.usePostOfficeExernalMessageProxy)($9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[2]);
    const pulse4 = (0, $6m3nS.usePostOfficeExernalMessageProxy)($9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[3]);
    const pulse5 = (0, $6m3nS.usePostOfficeExernalMessageProxy)($9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[4]);
    let t1;
    if ($[2] !== pulse1 || $[3] !== pulse2 || $[4] !== pulse3 || $[5] !== pulse4 || $[6] !== pulse5) {
        t1 = [
            pulse1,
            pulse2,
            pulse3,
            pulse4,
            pulse5
        ];
        $[2] = pulse1;
        $[3] = pulse2;
        $[4] = pulse3;
        $[5] = pulse4;
        $[6] = pulse5;
        $[7] = t1;
    } else t1 = $[7];
    const pulseHooks = t1;
    let t2;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = new Set();
        $[8] = t2;
    } else t2 = $[8];
    const hasRequestedRef = (0, $cozmU.useRef)(t2);
    const lastRequestedRef = (0, $cozmU.useRef)(null);
    const lastStartedIndexRef = (0, $cozmU.useRef)(null);
    const [timeoutTrigger, setTimeoutTrigger] = (0, $cozmU.useState)(0);
    let t3;
    if ($[9] !== pulseHooks || $[10] !== skipRefreshPulseStatus) {
        t3 = ()=>{
            if (skipRefreshPulseStatus) return;
            for(let i = 0; i < pulseHooks.length; i++){
                const pulseHook = pulseHooks[i];
                if (pulseHook.hasMessageStarted) {
                    lastRequestedRef.current = null;
                    lastStartedIndexRef.current = i;
                    break;
                }
                if (!hasRequestedRef.current.has(i)) {
                    hasRequestedRef.current.add(i);
                    lastRequestedRef.current = {
                        index: i,
                        timestamp: Date.now()
                    };
                    pulseHook.requestMessageStart();
                    break;
                }
            }
        };
        $[9] = pulseHooks;
        $[10] = skipRefreshPulseStatus;
        $[11] = t3;
    } else t3 = $[11];
    let t4;
    if ($[12] !== pulse1.handleClickTracking || $[13] !== pulse1.hasMessageStarted || $[14] !== pulse1.requestMessageStart || $[15] !== pulse2.handleClickTracking || $[16] !== pulse2.hasMessageStarted || $[17] !== pulse2.requestMessageStart || $[18] !== pulse3.handleClickTracking || $[19] !== pulse3.hasMessageStarted || $[20] !== pulse3.requestMessageStart || $[21] !== pulse4.handleClickTracking || $[22] !== pulse4.hasMessageStarted || $[23] !== pulse4.requestMessageStart || $[24] !== pulse5.handleClickTracking || $[25] !== pulse5.hasMessageStarted || $[26] !== pulse5.requestMessageStart || $[27] !== pulseHooks || $[28] !== skipRefreshPulseStatus) {
        t4 = [
            skipRefreshPulseStatus,
            pulseHooks,
            pulse1.hasMessageStarted,
            pulse2.hasMessageStarted,
            pulse3.hasMessageStarted,
            pulse4.hasMessageStarted,
            pulse5.hasMessageStarted,
            pulse1.requestMessageStart,
            pulse2.requestMessageStart,
            pulse3.requestMessageStart,
            pulse4.requestMessageStart,
            pulse5.requestMessageStart,
            pulse1.handleClickTracking,
            pulse2.handleClickTracking,
            pulse3.handleClickTracking,
            pulse4.handleClickTracking,
            pulse5.handleClickTracking
        ];
        $[12] = pulse1.handleClickTracking;
        $[13] = pulse1.hasMessageStarted;
        $[14] = pulse1.requestMessageStart;
        $[15] = pulse2.handleClickTracking;
        $[16] = pulse2.hasMessageStarted;
        $[17] = pulse2.requestMessageStart;
        $[18] = pulse3.handleClickTracking;
        $[19] = pulse3.hasMessageStarted;
        $[20] = pulse3.requestMessageStart;
        $[21] = pulse4.handleClickTracking;
        $[22] = pulse4.hasMessageStarted;
        $[23] = pulse4.requestMessageStart;
        $[24] = pulse5.handleClickTracking;
        $[25] = pulse5.hasMessageStarted;
        $[26] = pulse5.requestMessageStart;
        $[27] = pulseHooks;
        $[28] = skipRefreshPulseStatus;
        $[29] = t4;
    } else t4 = $[29];
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[30] !== isPulseActive || $[31] !== pulseHooks || $[32] !== skipRefreshPulseStatus) {
        t5 = ()=>{
            if (skipRefreshPulseStatus || !lastRequestedRef.current || isPulseActive) return;
            const { index: index, timestamp: timestamp } = lastRequestedRef.current;
            const pulseHook_0 = pulseHooks[index];
            if (pulseHook_0.hasMessageStarted) {
                lastRequestedRef.current = null;
                return;
            }
            const elapsed = Date.now() - timestamp;
            if (elapsed >= $9c43e73b872d5b9c$var$TIMEOUT_MS) {
                lastRequestedRef.current = null;
                $9c43e73b872d5b9c$var$requestNextPulse(index + 1, pulseHooks, hasRequestedRef, lastRequestedRef);
            } else {
                const remainingTime = $9c43e73b872d5b9c$var$TIMEOUT_MS - elapsed;
                const timeoutId = setTimeout(()=>{
                    setTimeoutTrigger($9c43e73b872d5b9c$var$_temp);
                }, remainingTime);
                return ()=>clearTimeout(timeoutId);
            }
        };
        $[30] = isPulseActive;
        $[31] = pulseHooks;
        $[32] = skipRefreshPulseStatus;
        $[33] = t5;
    } else t5 = $[33];
    let t6;
    if ($[34] !== isPulseActive || $[35] !== pulse1.hasMessageStarted || $[36] !== pulse2.hasMessageStarted || $[37] !== pulse3.hasMessageStarted || $[38] !== pulse4.hasMessageStarted || $[39] !== pulse5.hasMessageStarted || $[40] !== pulseHooks || $[41] !== skipRefreshPulseStatus || $[42] !== timeoutTrigger) {
        t6 = [
            skipRefreshPulseStatus,
            isPulseActive,
            timeoutTrigger,
            pulseHooks,
            pulse1.hasMessageStarted,
            pulse2.hasMessageStarted,
            pulse3.hasMessageStarted,
            pulse4.hasMessageStarted,
            pulse5.hasMessageStarted
        ];
        $[34] = isPulseActive;
        $[35] = pulse1.hasMessageStarted;
        $[36] = pulse2.hasMessageStarted;
        $[37] = pulse3.hasMessageStarted;
        $[38] = pulse4.hasMessageStarted;
        $[39] = pulse5.hasMessageStarted;
        $[40] = pulseHooks;
        $[41] = skipRefreshPulseStatus;
        $[42] = timeoutTrigger;
        $[43] = t6;
    } else t6 = $[43];
    (0, $cozmU.useEffect)(t5, t6);
    let t7;
    if ($[44] !== entryPointId || $[45] !== pulseHooks || $[46] !== skipRefreshPulseStatus || $[47] !== startPulse) {
        t7 = ()=>{
            if (skipRefreshPulseStatus) return;
            for(let i_0 = 0; i_0 < pulseHooks.length; i_0++){
                const pulseHook_1 = pulseHooks[i_0];
                const messageId = $9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[i_0];
                if (pulseHook_1.hasMessageStarted) {
                    lastStartedIndexRef.current = i_0;
                    startPulse(entryPointId, messageId, {
                        onDismiss: ()=>pulseHook_1.dismissMessage(),
                        onClick: ()=>pulseHook_1.handleClickTracking?.()
                    });
                    if (i_0 === $9c43e73b872d5b9c$var$LAST_PULSE_INDEX) (0, $gd8AW.endPulses)();
                    break;
                }
            }
        };
        $[44] = entryPointId;
        $[45] = pulseHooks;
        $[46] = skipRefreshPulseStatus;
        $[47] = startPulse;
        $[48] = t7;
    } else t7 = $[48];
    let t8;
    if ($[49] !== entryPointId || $[50] !== pulse1.hasMessageStarted || $[51] !== pulse2.hasMessageStarted || $[52] !== pulse3.hasMessageStarted || $[53] !== pulse4.hasMessageStarted || $[54] !== pulse5.hasMessageStarted || $[55] !== pulseHooks || $[56] !== skipRefreshPulseStatus || $[57] !== startPulse) {
        t8 = [
            skipRefreshPulseStatus,
            entryPointId,
            startPulse,
            pulseHooks,
            pulse1.hasMessageStarted,
            pulse2.hasMessageStarted,
            pulse3.hasMessageStarted,
            pulse4.hasMessageStarted,
            pulse5.hasMessageStarted
        ];
        $[49] = entryPointId;
        $[50] = pulse1.hasMessageStarted;
        $[51] = pulse2.hasMessageStarted;
        $[52] = pulse3.hasMessageStarted;
        $[53] = pulse4.hasMessageStarted;
        $[54] = pulse5.hasMessageStarted;
        $[55] = pulseHooks;
        $[56] = skipRefreshPulseStatus;
        $[57] = startPulse;
        $[58] = t8;
    } else t8 = $[58];
    (0, $cozmU.useEffect)(t7, t8);
    let t9;
    if ($[59] !== isPulseActive || $[60] !== pulseHooks || $[61] !== skipRefreshPulseStatus) {
        t9 = ()=>{
            if (skipRefreshPulseStatus || lastStartedIndexRef.current === null || isPulseActive) return;
            const startedIndex = lastStartedIndexRef.current;
            const startedPulseHook = pulseHooks[startedIndex];
            if (!startedPulseHook.hasMessageStarted) {
                hasRequestedRef.current.delete(startedIndex);
                lastStartedIndexRef.current = null;
                $9c43e73b872d5b9c$var$requestNextPulse(startedIndex + 1, pulseHooks, hasRequestedRef, lastRequestedRef);
            }
        };
        $[59] = isPulseActive;
        $[60] = pulseHooks;
        $[61] = skipRefreshPulseStatus;
        $[62] = t9;
    } else t9 = $[62];
    let t10;
    if ($[63] !== isPulseActive || $[64] !== pulse1.hasMessageStarted || $[65] !== pulse2.hasMessageStarted || $[66] !== pulse3.hasMessageStarted || $[67] !== pulse4.hasMessageStarted || $[68] !== pulse5.hasMessageStarted || $[69] !== pulseHooks || $[70] !== skipRefreshPulseStatus) {
        t10 = [
            skipRefreshPulseStatus,
            isPulseActive,
            pulseHooks,
            pulse1.hasMessageStarted,
            pulse2.hasMessageStarted,
            pulse3.hasMessageStarted,
            pulse4.hasMessageStarted,
            pulse5.hasMessageStarted
        ];
        $[63] = isPulseActive;
        $[64] = pulse1.hasMessageStarted;
        $[65] = pulse2.hasMessageStarted;
        $[66] = pulse3.hasMessageStarted;
        $[67] = pulse4.hasMessageStarted;
        $[68] = pulse5.hasMessageStarted;
        $[69] = pulseHooks;
        $[70] = skipRefreshPulseStatus;
        $[71] = t10;
    } else t10 = $[71];
    (0, $cozmU.useEffect)(t9, t10);
    let t11;
    if ($[72] !== isPulseActive) {
        t11 = {
            isPulseActive: isPulseActive
        };
        $[72] = isPulseActive;
        $[73] = t11;
    } else t11 = $[73];
    return t11;
} : (entryPointId)=>{
    // All hooks must be called unconditionally (Rules of Hooks)
    const isPulseActive = (0, $gd8AW.useIsPulseActive)(entryPointId);
    const { startPulse: startPulse } = (0, $gd8AW.useDiscoverabilityPulseActions)();
    const skipRefreshPulseStatus = isPulseActive && (0, $gd8AW.havePulsesEnded)();
    // Call hooks at the top level for all message IDs
    const pulse1 = (0, $6m3nS.usePostOfficeExernalMessageProxy)($9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[0]);
    const pulse2 = (0, $6m3nS.usePostOfficeExernalMessageProxy)($9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[1]);
    const pulse3 = (0, $6m3nS.usePostOfficeExernalMessageProxy)($9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[2]);
    const pulse4 = (0, $6m3nS.usePostOfficeExernalMessageProxy)($9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[3]);
    const pulse5 = (0, $6m3nS.usePostOfficeExernalMessageProxy)($9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[4]);
    const pulseHooks = (0, $cozmU.useMemo)(()=>[
            pulse1,
            pulse2,
            pulse3,
            pulse4,
            pulse5
        ], [
        pulse1,
        pulse2,
        pulse3,
        pulse4,
        pulse5
    ]);
    // Track which messages we've requested to avoid duplicate requests
    const hasRequestedRef = (0, $cozmU.useRef)(new Set());
    // Track the last requested message index and when it was requested (for timeout)
    const lastRequestedRef = (0, $cozmU.useRef)(null);
    // Track which message index was last started (to detect dismissal)
    const lastStartedIndexRef = (0, $cozmU.useRef)(null);
    // State trigger to force re-evaluation when timeout expires
    const [timeoutTrigger, setTimeoutTrigger] = (0, $cozmU.useState)(0);
    // Request messages sequentially - only request the next one if previous ones haven't started
    (0, $cozmU.useEffect)(()=>{
        if (skipRefreshPulseStatus) return;
        // Find the first message that hasn't started and request it
        // If a previous message has started, we stop (handled by the other effect)
        for(let i = 0; i < pulseHooks.length; i++){
            const pulseHook = pulseHooks[i];
            // If this message has started, we're done - don't request any more
            if (pulseHook.hasMessageStarted) {
                // Clear the timeout tracking since we found an active message
                lastRequestedRef.current = null;
                // Track which message is started (will be set by the activation effect, but set here too for consistency)
                lastStartedIndexRef.current = i;
                break;
            }
            // If we haven't requested this one yet, request it and stop
            // The effect will re-run when hasMessageStarted changes, allowing us to move to the next one
            if (!hasRequestedRef.current.has(i)) {
                hasRequestedRef.current.add(i);
                lastRequestedRef.current = {
                    index: i,
                    timestamp: Date.now()
                };
                pulseHook.requestMessageStart();
                break;
            }
        }
    }, [
        skipRefreshPulseStatus,
        pulseHooks,
        pulse1.hasMessageStarted,
        pulse2.hasMessageStarted,
        pulse3.hasMessageStarted,
        pulse4.hasMessageStarted,
        pulse5.hasMessageStarted,
        pulse1.requestMessageStart,
        pulse2.requestMessageStart,
        pulse3.requestMessageStart,
        pulse4.requestMessageStart,
        pulse5.requestMessageStart,
        pulse1.handleClickTracking,
        pulse2.handleClickTracking,
        pulse3.handleClickTracking,
        pulse4.handleClickTracking,
        pulse5.handleClickTracking
    ]);
    // Timeout handler: if a requested message hasn't started after a delay, try the next one
    // Note: If a message was already dismissed, Post Office filters it before page load
    // so we only need time for the initial load and state updates (~200-300ms)
    (0, $cozmU.useEffect)(()=>{
        if (skipRefreshPulseStatus || !lastRequestedRef.current || isPulseActive) return;
        const { index: index, timestamp: timestamp } = lastRequestedRef.current;
        const pulseHook_0 = pulseHooks[index];
        // If the message has started, clear the timeout tracking
        if (pulseHook_0.hasMessageStarted) {
            lastRequestedRef.current = null;
            return;
        }
        // If enough time has passed and the message still hasn't started, move to the next one
        const elapsed = Date.now() - timestamp;
        if (elapsed >= $9c43e73b872d5b9c$var$TIMEOUT_MS) {
            // Clear the current request tracking
            lastRequestedRef.current = null;
            // Try the next message if available
            $9c43e73b872d5b9c$var$requestNextPulse(index + 1, pulseHooks, hasRequestedRef, lastRequestedRef);
        } else {
            // Set a timeout to trigger re-evaluation when the timeout period elapses
            const remainingTime = $9c43e73b872d5b9c$var$TIMEOUT_MS - elapsed;
            const timeoutId = setTimeout(()=>{
                setTimeoutTrigger((prev)=>prev + 1);
            }, remainingTime);
            return ()=>clearTimeout(timeoutId);
        }
    }, [
        skipRefreshPulseStatus,
        isPulseActive,
        timeoutTrigger,
        pulseHooks,
        pulse1.hasMessageStarted,
        pulse2.hasMessageStarted,
        pulse3.hasMessageStarted,
        pulse4.hasMessageStarted,
        pulse5.hasMessageStarted
    ]);
    // Reactively respond when a message starts - activate the pulse
    (0, $cozmU.useEffect)(()=>{
        if (skipRefreshPulseStatus) return;
        // Check each pulse in sequence - activate the first one that has started
        for(let i_0 = 0; i_0 < pulseHooks.length; i_0++){
            const pulseHook_1 = pulseHooks[i_0];
            const messageId = $9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[i_0];
            if (pulseHook_1.hasMessageStarted) {
                lastStartedIndexRef.current = i_0;
                startPulse(entryPointId, messageId, {
                    onDismiss: ()=>pulseHook_1.dismissMessage(),
                    onClick: ()=>pulseHook_1.handleClickTracking?.()
                });
                // If this is the last pulse, mark pulses as ended
                if (i_0 === $9c43e73b872d5b9c$var$LAST_PULSE_INDEX) /**
           * Mark the EP message as "complete" and disable Loom discoverability in localStorage
           * immediately after showing the final pulse. Otherwise, if a user ignores the entrypoints
           * entirely and never clicks on one while it's pulsing, they'll:
           *
           * - Remain in the TAP audience forever
           * - Continue to check the EP messages every time an entrypoint renders
           *
           * This will technically unlock EP to show other messages, but the pulse is subtle enough that
           * this shouldn't result in poor UX
           */ (0, $gd8AW.endPulses)();
                break;
            }
        }
    }, [
        skipRefreshPulseStatus,
        entryPointId,
        startPulse,
        pulseHooks,
        pulse1.hasMessageStarted,
        pulse2.hasMessageStarted,
        pulse3.hasMessageStarted,
        pulse4.hasMessageStarted,
        pulse5.hasMessageStarted
    ]);
    // Handle message dismissal: if a started message becomes not started, request the next one
    (0, $cozmU.useEffect)(()=>{
        if (skipRefreshPulseStatus || lastStartedIndexRef.current === null || isPulseActive) return;
        const startedIndex = lastStartedIndexRef.current;
        const startedPulseHook = pulseHooks[startedIndex];
        // If the message that was started is no longer started, it was dismissed
        if (!startedPulseHook.hasMessageStarted) {
            // Clear the tracking for this message so we can move forward
            hasRequestedRef.current.delete(startedIndex);
            lastStartedIndexRef.current = null;
            // Request the next message if available
            $9c43e73b872d5b9c$var$requestNextPulse(startedIndex + 1, pulseHooks, hasRequestedRef, lastRequestedRef);
        }
    }, [
        skipRefreshPulseStatus,
        isPulseActive,
        pulseHooks,
        pulse1.hasMessageStarted,
        pulse2.hasMessageStarted,
        pulse3.hasMessageStarted,
        pulse4.hasMessageStarted,
        pulse5.hasMessageStarted
    ]);
    return {
        isPulseActive: isPulseActive
    };
};
function $9c43e73b872d5b9c$var$_temp(prev) {
    return prev + 1;
}
module.exports["useDiscoverabilityPulse"] = $9c43e73b872d5b9c$export$2002ab0670152c89;

});

parcelRegister("gd8AW", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $f4d1b21b30388c2e$export$48bd74b0cdc86564 = ()=>{
    return !!(0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LOOM_CROSS_SELL_DISCOVERABILITY_PULSES_HAVE_ENDED);
};
const $f4d1b21b30388c2e$export$675fdafde077272f = ()=>{
    return (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LOOM_CROSS_SELL_DISCOVERABILITY_PULSES_HAVE_ENDED, true);
};
const $f4d1b21b30388c2e$var$initialState = {
    activeMessageId: null,
    entryPointIds: [],
    clickTrackingHandler: null,
    dismissHandler: null,
    wasDismissedByUser: false
};
const $f4d1b21b30388c2e$var$actions = {
    startPulse: (entryPointId, messageId, handlers)=>({ getState: getState, setState: setState })=>{
            const state = getState();
            const nextState = state.activeMessageId !== messageId ? {
                activeMessageId: messageId,
                entryPointIds: [
                    entryPointId
                ],
                clickTrackingHandler: handlers?.onClick ?? null,
                dismissHandler: handlers?.onDismiss ?? null,
                wasDismissedByUser: false
            } : {
                activeMessageId: messageId,
                entryPointIds: state.entryPointIds.includes(entryPointId) ? state.entryPointIds : [
                    ...state.entryPointIds,
                    entryPointId
                ],
                clickTrackingHandler: handlers?.onClick ?? state.clickTrackingHandler,
                dismissHandler: handlers?.onDismiss ?? state.dismissHandler,
                wasDismissedByUser: false
            };
            const hasEntryPointListChanged = nextState.entryPointIds !== state.entryPointIds;
            const hasClickHandlerChanged = nextState.clickTrackingHandler !== state.clickTrackingHandler;
            const hasDismissHandlerChanged = nextState.dismissHandler !== state.dismissHandler;
            const hasMessageChanged = nextState.activeMessageId !== state.activeMessageId;
            const hasDismissalReset = state.wasDismissedByUser;
            if (!hasEntryPointListChanged && !hasClickHandlerChanged && !hasDismissHandlerChanged && !hasMessageChanged && !hasDismissalReset) return;
            setState(nextState);
        },
    stopPulse: ()=>({ getState: getState, setState: setState })=>{
            const state = getState();
            state.clickTrackingHandler?.();
            state.dismissHandler?.();
            if (!$f4d1b21b30388c2e$export$48bd74b0cdc86564()) $f4d1b21b30388c2e$export$675fdafde077272f();
            if (state.activeMessageId === null && state.entryPointIds.length === 0 && state.dismissHandler === null && state.clickTrackingHandler === null && state.wasDismissedByUser) return;
            setState({
                activeMessageId: null,
                entryPointIds: [],
                clickTrackingHandler: null,
                dismissHandler: null,
                wasDismissedByUser: true
            });
        }
};
const $f4d1b21b30388c2e$var$Store = (0, $8s9DV.createStore)({
    initialState: $f4d1b21b30388c2e$var$initialState,
    actions: $f4d1b21b30388c2e$var$actions,
    name: 'LoomEntryPointsDiscoverabilityPulse'
});
const $f4d1b21b30388c2e$export$e812389786ffbfd0 = (0, $kBr4q.createStateHook)($f4d1b21b30388c2e$var$Store, {
    selector: (state, entryPointId)=>state.entryPointIds.includes(entryPointId) && !state.wasDismissedByUser
});
const $f4d1b21b30388c2e$export$5628ed37e6d9f626 = (0, $kBr4q.createActionsHook)($f4d1b21b30388c2e$var$Store);
module.exports["havePulsesEnded"] = $f4d1b21b30388c2e$export$48bd74b0cdc86564;
module.exports["endPulses"] = $f4d1b21b30388c2e$export$675fdafde077272f;
module.exports["useIsPulseActive"] = $f4d1b21b30388c2e$export$e812389786ffbfd0;
module.exports["useDiscoverabilityPulseActions"] = $f4d1b21b30388c2e$export$5628ed37e6d9f626;

});

parcelRegister("531iT", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $60Yxm = parcelRequire("60Yxm");

const $bddab39ffd1b2325$export$412f97445c5fb31e = (props)=>{
    const $ = (0, $bDgLe.c)(4);
    const color = props.color || "var(--ds-icon-subtle, #505258)";
    const label = props.label || "";
    let t0;
    if ($[0] !== color || $[1] !== label || $[2] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($60Yxm))), {
            ...props,
            color: color,
            label: label,
            spacing: "spacious"
        });
        $[0] = color;
        $[1] = label;
        $[2] = props;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
};
module.exports["LoomVideoIcon"] = $bddab39ffd1b2325$export$412f97445c5fb31e;

});

parcelRegister("cxQ7E", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $1sCHt = parcelRequire("1sCHt");


var $4R3wx = parcelRequire("4R3wx");


var $531iT = parcelRequire("531iT");

const $acb63ca7a29d5cd7$var$buttonSpacerStyles = (0, $buxP3.xcss)({
    minWidth: '30px'
});
const $acb63ca7a29d5cd7$export$bc169f53ad8d6345 = (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { isCircle: isCircle, isEnabled: isEnabled } = t0;
    const { entryPointVariant: entryPointVariant } = (0, $4R3wx.useLoomEntryPointVariant)();
    if (entryPointVariant === "DISABLED") return null;
    else {
        const t1 = isCircle ? "circle" : "default";
        const t2 = !isEnabled;
        let t3;
        if ($[0] !== t1 || $[1] !== t2) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                xcss: $acb63ca7a29d5cd7$var$buttonSpacerStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                appearance: "subtle",
                shape: t1,
                icon: (0, $531iT.LoomVideoIcon),
                testId: "page-header-loom-entry-point-loading-icon",
                "data-vc": "loom-button",
                isDisabled: t2,
                label: "Record a Loom video"
            }));
            $[0] = t1;
            $[1] = t2;
            $[2] = t3;
        } else t3 = $[2];
        return t3;
    }
};
module.exports["LoomPageHeaderPlaceholder"] = $acb63ca7a29d5cd7$export$bc169f53ad8d6345;

});

parcelRegister("gkF5C", function(module, exports) {

let $be3e6321595ef9f7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $be3e6321595ef9f7$var$load("3CBDb"),
    $be3e6321595ef9f7$var$load("Vjtcp")
]).then(()=>parcelRequire('hmdCl'));

});

parcelRegister("eH9vo", function(module, exports) {

let $ab2c746385ad2b34$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ab2c746385ad2b34$var$load("gpUln"),
    $ab2c746385ad2b34$var$load("6wr18"),
    $ab2c746385ad2b34$var$load("CqGpG"),
    $ab2c746385ad2b34$var$load("ffEVr"),
    $ab2c746385ad2b34$var$load("5Jv0P")
]).then(()=>parcelRequire('3Bted'));

});

parcelRegister("kDIlS", function(module, exports) {

let $f069da867465f297$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f069da867465f297$var$load("3CBDb"),
    $f069da867465f297$var$load("gpUln"),
    $f069da867465f297$var$load("lx2XJ")
]).then(()=>parcelRequire('rnQny'));

});

parcelRegister("bvg6Y", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6b4nE = parcelRequire("6b4nE");


var $jmjWc = parcelRequire("jmjWc");


var $7boqA = parcelRequire("7boqA");


var $blsJs = parcelRequire("blsJs");


var $9SsRl = parcelRequire("9SsRl");


var $bl4QJ = parcelRequire("bl4QJ");


const $3be9bfd0a276360e$export$baaf0df5303f8865 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "L5BJl",
    name: "LazyDialogWrapperLoader",
    loader: async ()=>(await (parcelRequire("3WCyu"))).WatchDialogWrapper,
    loading: (0, $bl4QJ.WatchButtonPlaceholder)
});

const $3be9bfd0a276360e$export$ab7826e0fbb7edbf = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "HpEKn",
    name: "WatchDialogWrapperLoader",
    loader: async ()=>(await (parcelRequire("3WCyu"))).WatchDialogWrapper,
    loading: (0, $bl4QJ.WatchButtonPlaceholder)
});
const $3be9bfd0a276360e$export$a4de2aef32c151a8 = (props)=>{
    (0, $blsJs.useSubmitSSRScriptErrors)('page-watch-button');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
        key: props.contentId,
        metric: (0, $9SsRl.WATCH_BUTTON_METRIC)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3be9bfd0a276360e$export$ab7826e0fbb7edbf, props));
};
$3be9bfd0a276360e$export$a4de2aef32c151a8.propTypes = {
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    defaultTab: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).number,
    componentLocation: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).number
};
module.exports["LazyDialogWrapperLoader"] = $3be9bfd0a276360e$export$baaf0df5303f8865;
module.exports["WatchDialogWrapperLoader"] = $3be9bfd0a276360e$export$ab7826e0fbb7edbf;
module.exports["WatchDialogWrapper"] = $3be9bfd0a276360e$export$a4de2aef32c151a8;

});

parcelRegister("blsJs", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $5ZqQS = parcelRequire("5ZqQS");

const $7bdb5572ed9c8600$export$290a00987d4ffd42 = (scope)=>{
    (0, $cozmU.useEffect)(()=>{
        if (!window.__SSR_CLIENT_ERRORS__ || !window.__SSR_CLIENT_ERRORS__[scope]) return;
        const ssrErrors = window.__SSR_CLIENT_ERRORS__[scope];
        ssrErrors.forEach((error)=>(0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: 'backbone'
            }));
        delete window.__SSR_CLIENT_ERRORS__[scope];
    }, [
        scope
    ]);
};
module.exports["useSubmitSSRScriptErrors"] = $7bdb5572ed9c8600$export$290a00987d4ffd42;

});

parcelRegister("9SsRl", function(module, exports) {

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");

const $730f8b16a3d58539$export$8ce793b178574678 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.WATCH_BUTTON_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
module.exports["WATCH_BUTTON_METRIC"] = $730f8b16a3d58539$export$8ce793b178574678;

});

parcelRegister("fQ3iN", function(module, exports) {
/**
 * BM3 Deprecation Phase 2 — gated wrapper around the raw BM3 page-segment-load factory.
 *
 * This file is the canonical implementation behind the public name
 * `createPageSegmentLoadMetric` (re-exported from
 * `@confluence/browser-metrics/entry-points/metricConfigs.ts`). All Confluence consumers
 * call the gated variant by virtue of importing the public name; there is no separate
 * "raw" public entry point.
 *
 * When the `cc_bm3_deprecation_phase_2` gate is OFF (default), every method call delegates
 * verbatim to the underlying BM3 PageSegmentLoadMetric so existing behaviour and the BM3
 * `PAGE_SEGMENT_LOAD` analytics events are preserved.
 *
 * When the gate is ON, the BM3 calls are skipped and equivalent UFO custom marks / custom
 * data are emitted instead. This lets us roll out the removal of the BM3 page-segment-load
 * events incrementally — controlled by Statsig — without touching any of the ~25
 * perf.config files or ~20 imperative call sites. Consumers continue to use
 * `METRIC.start()`, `.stop()`, `.cancel()`, `.mark()`, `.markFMP()`,
 * `.startFromPageLoad()` exactly as before; the gate decision is centralised here.
 *
 * The gate `fg(...)` is evaluated **inline at the callsite of each method**, never aliased
 * or wrapped, in line with the feature-gate-and-experiment-usage AGENTS guidance. Per-method
 * (rather than per-construction) evaluation is required because perf.config modules are
 * imported very early in app boot — earlier than Statsig data is loaded — so a one-shot
 * `fg()` call at construction time would always read the default (false) value.
 *
 * Implementation note: rather than returning a *new* wrapper object, this helper mutates
 * the real BM3 metric instance by overriding selected methods with bound functions that
 * consult the gate. This preserves the metric's class identity, prototype chain, and
 * private internal state so it remains a fully drop-in substitute everywhere a BM3
 * PageSegmentLoadMetric is used (including in `pageLoadMetric.include[]` / `until[]`
 * arrays where BM3 walks the internal experience graph).
 *
 * Once the gate has fully ramped, this file's body will be replaced with a UFO-only
 * implementation and the BM3 dependency removed entirely.
 */ 
var $gXfti = parcelRequire("gXfti");


var $knAY5 = parcelRequire("knAY5");


var $9wGTI = parcelRequire("9wGTI");


var $3YpC9 = parcelRequire("3YpC9");


var $kw6I9 = parcelRequire("kw6I9");

function $a96d58ddd476e3f0$export$34f706592a2f7442(config) {
    const metric = (0, $kw6I9.createBM3PageSegmentLoadMetricRaw)(config);
    const key = config.key;
    // Capture the original methods before overriding them.
    const realStart = metric.start.bind(metric);
    const realStartFromPageLoad = metric.startFromPageLoad.bind(metric);
    const realStop = metric.stop.bind(metric);
    const realCancel = metric.cancel.bind(metric);
    const realMark = metric.mark.bind(metric);
    const realMarkFMP = metric.markFMP.bind(metric);
    metric.start = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            (0, $knAY5.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${key}`);
            return;
        }
        return realStart(...args);
    };
    metric.startFromPageLoad = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            (0, $knAY5.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${key}`);
            return;
        }
        return realStartFromPageLoad(...args);
    };
    metric.stop = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            (0, $knAY5.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${key}`);
            const opts = args[0];
            if (opts?.customData) (0, $gXfti.addUFOCustomData)(opts.customData);
            return true;
        }
        return realStop(...args);
    };
    metric.cancel = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            // Note - there's no equivalent for cancel in UFO, so we use the end mark instead.
            (0, $knAY5.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${key}`);
            return;
        }
        return realCancel(...args);
    };
    metric.mark = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            const [name, timestamp] = args;
            (0, $knAY5.addUFOCustomMark)(name, timestamp);
            return;
        }
        return realMark(...args);
    };
    metric.markFMP = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            const [timestamp] = args;
            (0, $knAY5.addUFOCustomMark)(`fmp:${key}`, timestamp);
            return;
        }
        return realMarkFMP(...args);
    };
    return metric;
}
module.exports["createPageSegmentLoadMetric"] = $a96d58ddd476e3f0$export$34f706592a2f7442;

});

parcelRegister("kw6I9", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable no-restricted-syntax */ 
var $iDdTC = parcelRequire("iDdTC");

const $864083edfead32eb$export$2a2fe1e11b4e0413 = (0, $iDdTC.metrics).pageSegmentLoad;
module.exports["createBM3PageSegmentLoadMetricRaw"] = $864083edfead32eb$export$2a2fe1e11b4e0413;

});

parcelRegister("iDdTC", function(module, exports) {

var $9aI7t = parcelRequire("9aI7t");


var $b5593 = parcelRequire("b5593");


var $b90aI = parcelRequire("b90aI");


var $1Ht4b = parcelRequire("1Ht4b");


var $aaEQD = parcelRequire("aaEQD");

const $ffb05ca8baf9d9e1$export$b0c5c2fac8144e54 = {
    pageLoad: $1Ht4b.pageLoad,
    pageSegmentLoad: $aaEQD.pageSegmentLoad,
    interaction: $b90aI.interaction,
    custom: $b5593.custom,
    concurrent: $9aI7t.concurrent
};
module.exports["metrics"] = $ffb05ca8baf9d9e1$export$b0c5c2fac8144e54;

});

parcelRegister("9aI7t", function(module, exports) {

var $lCTbz = parcelRequire("lCTbz");


var $b5593 = parcelRequire("b5593");


var $b90aI = parcelRequire("b90aI");

const $95763ae236d73d99$var$concurrentMetrics = {};
const $95763ae236d73d99$var$getKey = (config, type)=>`${type}--${config.key}`;
const $95763ae236d73d99$var$validateConfig = (config)=>{
    if (config.include) throw new Error('"include" is not supported in concurrent actions');
    if (config.until) throw new Error('"until" is not supported in concurrent actions');
};
const $95763ae236d73d99$var$ensurePath = (config, type)=>{
    const key = $95763ae236d73d99$var$getKey(config, type);
    if (!(key in $95763ae236d73d99$var$concurrentMetrics)) $95763ae236d73d99$var$concurrentMetrics[key] = {};
};
const $95763ae236d73d99$var$getMetricFromCache = (concurrentId, config, type)=>{
    const concurrentKey = $95763ae236d73d99$var$getKey(config, type);
    if (concurrentKey in $95763ae236d73d99$var$concurrentMetrics && $95763ae236d73d99$var$concurrentMetrics[concurrentKey][String(concurrentId)]) return $95763ae236d73d99$var$concurrentMetrics[concurrentKey][String(concurrentId)];
    if (!(concurrentKey in $95763ae236d73d99$var$concurrentMetrics)) $95763ae236d73d99$var$concurrentMetrics[concurrentKey] = {};
    return;
};
const $95763ae236d73d99$var$makeConcurrentMetric = (concurrentId, config, type)=>{
    $95763ae236d73d99$var$validateConfig(config);
    $95763ae236d73d99$var$ensurePath(config, type);
    const metricFromCache = $95763ae236d73d99$var$getMetricFromCache(concurrentId, config, type);
    if (metricFromCache) return metricFromCache;
    const metricFactory = type === (0, $lCTbz.BMEventsType).INLINE_RESULT ? (0, $b90aI.interaction) : (0, $b5593.custom);
    const metric = metricFactory(config);
    $95763ae236d73d99$var$concurrentMetrics[$95763ae236d73d99$var$getKey(config, type)][String(concurrentId)] = metric;
    return metric;
};
const $95763ae236d73d99$export$370df09ecc3de059 = {
    pageSegmentLoad: (config)=>(concurrentId)=>$95763ae236d73d99$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $lCTbz.BMEventsType).PAGE_SEGMENT_LOAD),
    interaction: (config)=>(concurrentId)=>$95763ae236d73d99$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $lCTbz.BMEventsType).INLINE_RESULT),
    custom: (config)=>(concurrentId)=>$95763ae236d73d99$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $lCTbz.BMEventsType).CUSTOM)
};
module.exports["concurrent"] = $95763ae236d73d99$export$370df09ecc3de059;

});

parcelRegister("b5593", function(module, exports) {

var $ipFlS = parcelRequire("ipFlS");


var $lCTbz = parcelRequire("lCTbz");

const $39f57926a8ef795b$export$4c00f665f0d4b443 = (config)=>{
    return new (0, $ipFlS.Metric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).CUSTOM
    });
};
module.exports["custom"] = $39f57926a8ef795b$export$4c00f665f0d4b443;

});

parcelRegister("ipFlS", function(module, exports) {

var $hvVQt = parcelRequire("hvVQt");


var $581yf = parcelRequire("581yf");


var $7IphZ = parcelRequire("7IphZ");

class $4db3d4178d03c3ea$export$efdd3e096bc27746 extends (0, $7IphZ.BaseMetric) {
    start({ startTime: startTime } = {}) {
        super.start({
            startTime: startTime
        });
        this.route = (0, $hvVQt.Route).getRoute();
    }
    stop(params = {}) {
        const stoppedSuccessfully = super.stop(params);
        if (stoppedSuccessfully && !this.config.virtual) (0, $581yf.submitter).queue(this.getData());
        return stoppedSuccessfully;
    }
}
module.exports["Metric"] = $4db3d4178d03c3ea$export$efdd3e096bc27746;

});

parcelRegister("b90aI", function(module, exports) {

var $ipFlS = parcelRequire("ipFlS");


var $lCTbz = parcelRequire("lCTbz");

const $060787d14b6a30d6$export$92473e6020ad89b4 = (config)=>{
    return new (0, $ipFlS.Metric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).INLINE_RESULT
    });
};
module.exports["interaction"] = $060787d14b6a30d6$export$92473e6020ad89b4;

});

parcelRegister("1Ht4b", function(module, exports) {

var $3L5Pu = parcelRequire("3L5Pu");


var $lCTbz = parcelRequire("lCTbz");

const $a55ff36d094d83ef$export$791d520f7e8058a5 = (config)=>{
    return new (0, $3L5Pu.PageLoadMetric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).PAGE_LOAD
    });
};
module.exports["pageLoad"] = $a55ff36d094d83ef$export$791d520f7e8058a5;

});

parcelRegister("3L5Pu", function(module, exports) {

var $97AWA = parcelRequire("97AWA");


var $jk8rA = parcelRequire("jk8rA");


var $hvVQt = parcelRequire("hvVQt");


var $581yf = parcelRequire("581yf");


var $lCTbz = parcelRequire("lCTbz");


var $2QFOI = parcelRequire("2QFOI");


var $wgCbG = parcelRequire("wgCbG");


var $eNslE = parcelRequire("eNslE");

class $bbca0ae0eaeecc15$export$3c51073271a9eac3 extends (0, $2QFOI.BasePageLoadMetric) {
    startPageLoad(params = {
        isInitial: false
    }) {
        (0, $wgCbG.pageLoadMetaMetric).startPageLoad({
            ...params,
            cancelStarted: 'startTime' in params
        });
        this.watchUntil();
    }
    stop(params = {}) {
        const stopTime = params.stopTime || window.performance.now();
        const pageLoadData = (0, $wgCbG.pageLoadMetaMetric).getDataToMerge();
        const metaMetricStopped = (0, $wgCbG.pageLoadMetaMetric).stop(params);
        if (!metaMetricStopped) return false;
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[(0, $2QFOI.BasePageLoadMetric).FMP]) {
                const mark = (0, $97AWA.SSRGetDoneMark).getDoneMark();
                if (mark) (0, $wgCbG.pageLoadMetaMetric).markFMP(mark);
            } else (0, $wgCbG.pageLoadMetaMetric).markFMP(this.marks[(0, $2QFOI.BasePageLoadMetric).FMP]);
        }
        this.route = (0, $hvVQt.Route).getRoute();
        const metricStopped = this.stopPageLoad(pageLoadData, {
            ...params,
            stopTime: stopTime
        });
        if (!metricStopped) return false;
        const data = this.getData();
        if (!this.config.virtual) (0, $581yf.submitter).queue(data);
        (0, $jk8rA.logger).logCond(!!this.config.debug, 'page-load', 'stop', this.getData);
        this.enqueueWebVitals();
        return true;
    }
    mark(mark, timestamp = window.performance.now()) {
        (0, $wgCbG.pageLoadMetaMetric).mark(mark, timestamp);
    }
    markFMP(timestamp) {
        (0, $wgCbG.pageLoadMetaMetric).markFMP(timestamp);
    }
    getData() {
        const pageLoadMetaData = (0, $wgCbG.pageLoadMetaMetric).getData();
        return {
            ...super.getData(),
            // marks and explicitTimings are available only in pageLoadMeta
            marks: pageLoadMetaData.marks,
            explicitTimings: pageLoadMetaData.explicitTimings
        };
    }
    async enqueueWebVitals() {
        if (this.config.virtual || !this.isInitial) return false;
        const configChunk = await (0, $581yf.submitter).config.configChunk;
        if (!configChunk?.[(0, $lCTbz.BMEventsType).WEB_VITALS].webVitals?.enabled) return false;
        const webVitalMetric = new (0, $eNslE.WebVitalsMetric)({
            key: this.config.key,
            route: this.route,
            startTime: this.startTime,
            stopTime: this.stopTime,
            pageVisibleState: this.pageVisibleState
        });
        (0, $581yf.submitter).queue(webVitalMetric.getData());
        (0, $jk8rA.logger).logCond(!!this.config.debug, 'web-vitals', webVitalMetric.getData);
        return true;
    }
}
module.exports["PageLoadMetric"] = $bbca0ae0eaeecc15$export$3c51073271a9eac3;

});

parcelRegister("eNslE", function(module, exports) {

var $lCTbz = parcelRequire("lCTbz");


var $7IphZ = parcelRequire("7IphZ");

class $23d0f6650a8bd5e3$export$dc0d85d4d6503cd7 extends (0, $7IphZ.BaseMetric) {
    constructor({ key: key, route: route, startTime: startTime, stopTime: stopTime, pageVisibleState: pageVisibleState }){
        super({
            type: (0, $lCTbz.BMEventsType).WEB_VITALS,
            key: key
        });
        this.route = route;
        this.startTime = startTime;
        this.stopTime = stopTime;
        this.state = (0, $7IphZ.MetricState).FINISHED;
        this.pageVisibleState = pageVisibleState;
    }
}
module.exports["WebVitalsMetric"] = $23d0f6650a8bd5e3$export$dc0d85d4d6503cd7;

});

parcelRegister("aaEQD", function(module, exports) {

var $h51B5 = parcelRequire("h51B5");


var $lCTbz = parcelRequire("lCTbz");

const $2eb5124fdb2b6158$export$94114666844d5f66 = (config)=>{
    return new (0, $h51B5.PageSegmentLoadMetric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).PAGE_SEGMENT_LOAD
    });
};
module.exports["pageSegmentLoad"] = $2eb5124fdb2b6158$export$94114666844d5f66;

});

parcelRegister("h51B5", function(module, exports) {

var $97AWA = parcelRequire("97AWA");


var $lCTbz = parcelRequire("lCTbz");


var $7IphZ = parcelRequire("7IphZ");


var $ipFlS = parcelRequire("ipFlS");


var $wgCbG = parcelRequire("wgCbG");

class $0f8d7af9cfafbf9f$export$24c8bfcd77494cc1 extends (0, $ipFlS.Metric) {
    startFromPageLoad() {
        const pageLoadMetaData = (0, $wgCbG.pageLoadMetaMetric).getData();
        this.start({
            startTime: pageLoadMetaData.start ?? undefined
        });
        this.isInitial = pageLoadMetaData.isInitial;
        this.pageVisibleState = pageLoadMetaData.pageVisibleState;
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP) return;
        super.mark(mark, timestamp);
    }
    markFMP(timestamp) {
        super.mark($0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP, timestamp);
    }
    getPageSegmentLoadData() {
        return {
            isInitial: this.isInitial
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageSegmentLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageSegmentLoadData()
        };
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
    }
    stop(params = {}) {
        const pageLoadData = (0, $wgCbG.pageLoadMetaMetric).getData();
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[$0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP]) {
                const mark = (0, $97AWA.SSRGetDoneMark).getDoneMark();
                if (mark) this.markFMP(mark);
            }
        }
        if (this.config.includePageLoadTimings !== (0, $lCTbz.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT || pageLoadData.state === (0, $7IphZ.MetricState).FINISHED) return super.stop(params);
        const now = performance.now();
        if (pageLoadData.state === (0, $7IphZ.MetricState).STARTED) (0, $wgCbG.pageLoadMetaMetric).onStop(()=>{
            super.stop({
                ...params,
                stopTime: params.stopTime || now
            });
        }, ()=>{
            this.cancel();
        });
        return true;
    }
    constructor(config){
        super(config);
        this.isInitial = true;
        this.config = void 0;
        this.config = config;
    }
}
$0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP = 'fmp';
module.exports["PageSegmentLoadMetric"] = $0f8d7af9cfafbf9f$export$24c8bfcd77494cc1;

});

parcelRegister("jX1qB", function(module, exports) {
// "confluence.fe.page-segment-load.XXX"
const $fa0ea3428ec5aa62$export$9e40500efe28ac9e = 'app-navigation';
const $fa0ea3428ec5aa62$export$38b273cdbbf56c26 = 'blog-tree';
const $fa0ea3428ec5aa62$export$1ac23cd5807df863 = 'byline';
const $fa0ea3428ec5aa62$export$5bbb36bee09a5671 = 'read-time';
const $fa0ea3428ec5aa62$export$a79607497a4a710c = 'content-analytics-viewers';
const $fa0ea3428ec5aa62$export$c56a99673f1bb7bb = 'content-analytics-links-table';
const $fa0ea3428ec5aa62$export$140a493a9e781fe2 = 'content-renderer';
const $fa0ea3428ec5aa62$export$db1285ccb0399c01 = 'content-title';
const $fa0ea3428ec5aa62$export$eb5bb54418693284 = 'favourite-button';
const $fa0ea3428ec5aa62$export$3fde425dbc74423b = 'focused-inline-comment';
const $fa0ea3428ec5aa62$export$6a58cce6529da40e = 'inline-comments-highlights';
const $fa0ea3428ec5aa62$export$8910bc840e3ee4ce = 'fabric-comments-highlights';
const $fa0ea3428ec5aa62$export$bf572571ca036b67 = 'render-inline-comment';
const $fa0ea3428ec5aa62$export$644778267d4a4a82 = 'editor-render-inline-comment';
const $fa0ea3428ec5aa62$export$3afb71dd0b0dbc3a = 'reactions';
const $fa0ea3428ec5aa62$export$e4ff10a0a39a7217 = 'page-comments';
const $fa0ea3428ec5aa62$export$6648c9be174e6923 = 'page-reactions';
const $fa0ea3428ec5aa62$export$2d3d6144128aaee3 = 'feed-reactions';
const $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499 = 'page-tree';
const $fa0ea3428ec5aa62$export$d1dfca9e0eb45581 = 'restrictions-button';
const $fa0ea3428ec5aa62$export$312db7b759bad970 = 'global-navigation';
const $fa0ea3428ec5aa62$export$cf2a6bf49e73b304 = 'space-navigation';
const $fa0ea3428ec5aa62$export$84f6b5717c3fb962 = 'space-apps';
const $fa0ea3428ec5aa62$export$1a423f2548c46be3 = 'watch-button';
const $fa0ea3428ec5aa62$export$b6426c6941656619 = 'home-overview-recent';
const $fa0ea3428ec5aa62$export$14f30a91623dfcf3 = 'home-overview-feed';
const $fa0ea3428ec5aa62$export$c6926beb57b60636 = 'home-overview-right-panel';
const $fa0ea3428ec5aa62$export$687913e127f52cc3 = 'home-overview-spaces-section';
const $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0 = 'home-recents-view';
const $fa0ea3428ec5aa62$export$76243e8aa4afaa0b = 'home-starred-view';
const $fa0ea3428ec5aa62$export$e1df6f3f29083f48 = 'home-drafts-view';
const $fa0ea3428ec5aa62$export$7b32848c9413526a = 'end-of-page-recommendations';
const $fa0ea3428ec5aa62$export$58fbb0ba50341103 = 'in-editor-templates';
const $fa0ea3428ec5aa62$export$4f481f063369df3c = 'ncs-connected-fmp';
const $fa0ea3428ec5aa62$export$db1b9793e009e605 = 'advanced-search-component';
const $fa0ea3428ec5aa62$export$90bda069d4bf981b = 'advanced-search-filter-section';
const $fa0ea3428ec5aa62$export$f11e1d4269141c0e = 'advanced-search-result-section';
const $fa0ea3428ec5aa62$export$f0298cbab4a44998 = 'database-header';
const $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5 = 'smart-link-embed-header';
const $fa0ea3428ec5aa62$export$cf2f52fec740bdea = 'whiteboard-header';
const $fa0ea3428ec5aa62$export$52050233077a1838 = 'object-header';
const $fa0ea3428ec5aa62$export$e1ab333f0b70b317 = 'content-types-header-title';
const $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4 = 'whiteboard-view-page-content';
const $fa0ea3428ec5aa62$export$b95bd4bfc46932fc = 'database-view-page-content';
const $fa0ea3428ec5aa62$export$f6bd20f4f796eb89 = 'folder-page-content';
const $fa0ea3428ec5aa62$export$bf838b84ba2f7b95 = 'share-button';
const $fa0ea3428ec5aa62$export$79910402df6be117 = 'view-page-labels';
const $fa0ea3428ec5aa62$export$d86af34f7dc194b4 = 'admin-announcement-banner';
const $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb = 'cp-web-fragment';
const $fa0ea3428ec5aa62$export$1939caa7fae28ef5 = 'view-space-permissions';
const $fa0ea3428ec5aa62$export$3f06ee123a5ad183 = 'view-page-container';
const $fa0ea3428ec5aa62$export$37da6122cd60d332 = 'embed-view-page-content';
const $fa0ea3428ec5aa62$export$3437c1f145cfce19 = 'embed-view-page-blank-content';
const $fa0ea3428ec5aa62$export$7903037283afbce0 = 'editor';
const $fa0ea3428ec5aa62$export$31d10d7597db11d3 = 'object-sidebar-control';
const $fa0ea3428ec5aa62$export$b64d520f9b37dcd7 = 'comments-panel-open-view';
const $fa0ea3428ec5aa62$export$50553e47471a0f5e = 'comments-panel-unread-view';
const $fa0ea3428ec5aa62$export$40d92ab0c1cc5298 = 'comments-panel-deleted-content-view';
const $fa0ea3428ec5aa62$export$f2a6407ac901fd8d = 'comments-panel-resolved-view';
const $fa0ea3428ec5aa62$export$b3aade49b91bdeba = 'comments-panel-mentions-me-view';
module.exports["APP_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$9e40500efe28ac9e;
module.exports["BLOG_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$38b273cdbbf56c26;
module.exports["BYLINE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1ac23cd5807df863;
module.exports["READ_TIME_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$5bbb36bee09a5671;
module.exports["CONTENT_ANALYTICS_VIEWERS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$a79607497a4a710c;
module.exports["CONTENT_ANALYTICS_LINKS_TABLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c56a99673f1bb7bb;
module.exports["CONTENT_RENDERER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$140a493a9e781fe2;
module.exports["CONTENT_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1285ccb0399c01;
module.exports["FAVOURITE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$eb5bb54418693284;
module.exports["FOCUSED_INLINE_COMMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3fde425dbc74423b;
module.exports["INLINE_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6a58cce6529da40e;
module.exports["FABRIC_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$8910bc840e3ee4ce;
module.exports["RENDERER_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf572571ca036b67;
module.exports["EDITOR_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$644778267d4a4a82;
module.exports["PAGE_COMMENTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e4ff10a0a39a7217;
module.exports["PAGE_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6648c9be174e6923;
module.exports["FEED_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d3d6144128aaee3;
module.exports["PAGE_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499;
module.exports["RESTRICTIONS_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d1dfca9e0eb45581;
module.exports["GLOBAL_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$312db7b759bad970;
module.exports["SPACE_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$cf2a6bf49e73b304;
module.exports["SPACE_APPS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$84f6b5717c3fb962;
module.exports["WATCH_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1a423f2548c46be3;
module.exports["HOME_OVERVIEW_RECENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6426c6941656619;
module.exports["HOME_OVERVIEW_FEED_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$14f30a91623dfcf3;
module.exports["HOME_OVERVIEW_RIGHT_PANEL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c6926beb57b60636;
module.exports["HOME_RECENTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0;
module.exports["HOME_STARRED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$76243e8aa4afaa0b;
module.exports["HOME_DRAFTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1df6f3f29083f48;
module.exports["END_OF_PAGE_RECOMMENDATIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7b32848c9413526a;
module.exports["IN_EDITOR_TEMPLATES_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$58fbb0ba50341103;
module.exports["NCS_CONNECTED_FMP_KEY"] = $fa0ea3428ec5aa62$export$4f481f063369df3c;
module.exports["ADVANCED_SEARCH_COMPONENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1b9793e009e605;
module.exports["ADVANCED_SEARCH_FILTER_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$90bda069d4bf981b;
module.exports["ADVANCED_SEARCH_RESULT_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f11e1d4269141c0e;
module.exports["DATABASE_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$f0298cbab4a44998;
module.exports["SMART_LINK_EMBED_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5;
module.exports["WHITEBOARD_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$cf2f52fec740bdea;
module.exports["OBJECT_HEADER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$52050233077a1838;
module.exports["CONTENT_TYPES_HEADER_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1ab333f0b70b317;
module.exports["WHITEBOARD_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4;
module.exports["DATABASE_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b95bd4bfc46932fc;
module.exports["FOLDER_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f6bd20f4f796eb89;
module.exports["SHARE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf838b84ba2f7b95;
module.exports["VIEW_PAGE_LABELS_METRIC_KEY"] = $fa0ea3428ec5aa62$export$79910402df6be117;
module.exports["ADMIN_ANNOUNCEMENT_BANNER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d86af34f7dc194b4;
module.exports["CONNECT_APP_WEB_FRAGMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb;
module.exports["SPACE_PERMISSIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1939caa7fae28ef5;
module.exports["VIEW_PAGE_CONTAINER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3f06ee123a5ad183;
module.exports["EMBED_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$37da6122cd60d332;
module.exports["EMBED_VIEW_PAGE_BLANK_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3437c1f145cfce19;
module.exports["EDITOR_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7903037283afbce0;
module.exports["OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$31d10d7597db11d3;
module.exports["COMMENTS_PANEL_OPEN_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b64d520f9b37dcd7;
module.exports["COMMENTS_PANEL_UNREAD_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$50553e47471a0f5e;
module.exports["COMMENTS_PANEL_DELETED_CONTENT_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$40d92ab0c1cc5298;
module.exports["COMMENTS_PANEL_RESOLVED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f2a6407ac901fd8d;
module.exports["COMMENTS_PANEL_MENTIONS_ME_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b3aade49b91bdeba;

});

parcelRegister("bl4QJ", function(module, exports) {
/* WatchButtonPlaceholder.js generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $6b4nE = parcelRequire("6b4nE");


var $a79Sy = parcelRequire("a79Sy");


var $7ZB0A = parcelRequire("7ZB0A");

const $84156adddab51810$export$2d5d2ba3c7c8c40b = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = (0, $7ZB0A.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0sElkwuNcX _4GiLnvFQfX _27WIHEFQfX",
            __cmplp.className
        ])
    });
});
const $84156adddab51810$export$2d7669ced06071f = ({ compact: compact })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($84156adddab51810$export$2d5d2ba3c7c8c40b, {
        testId: "watch-button-placeholder",
        "data-test-id": "watch-button-placeholder",
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a79Sy))), {
            label: "WatchIcon",
            spacing: "spacious"
        }),
        isDisabled: true,
        spacing: compact ? 'compact' : 'default'
    });
$84156adddab51810$export$2d7669ced06071f.propTypes = {
    compact: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool
};
module.exports["WatchButtonPlaceholder"] = $84156adddab51810$export$2d7669ced06071f;

});

parcelRegister("3WCyu", function(module, exports) {

let $2df4b22c2c71c1bf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2df4b22c2c71c1bf$var$load("hhu66"),
    $2df4b22c2c71c1bf$var$load("87mhv"),
    $2df4b22c2c71c1bf$var$load("aLbuU"),
    $2df4b22c2c71c1bf$var$load("6wr18"),
    $2df4b22c2c71c1bf$var$load("6damH"),
    $2df4b22c2c71c1bf$var$load("ffEVr"),
    $2df4b22c2c71c1bf$var$load("ayJxT"),
    $2df4b22c2c71c1bf$var$load("cUtrS")
]).then(()=>parcelRequire('9dU2w'));

});

parcelRegister("8HdsQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $h0mTL = parcelRequire("h0mTL");


var $jIlrR = parcelRequire("jIlrR");


var $lF24E = parcelRequire("lF24E");

const $262f69aacf5ded76$var$noop = ()=>{};
const $262f69aacf5ded76$export$e64f20017ef2874a = /*#__PURE__*/ (0, $cozmU.memo)(({ contentId: contentId, isCommentButtonSSRd: isCommentButtonSSRd = false })=>{
    const { data: data, error: error } = (0, $lF24E.usePreloadCommentButton)(contentId, isCommentButtonSSRd);
    const contentNode = data?.commentData?.content?.nodes?.[0];
    const isFabricSuported = contentNode?.metadata?.frontend?.fabricEditorSupported ?? false;
    const [showCommentButton, setShowCommentButton] = (0, $cozmU.useState)(false);
    /* Scenario: A user has clicked on the button in SSR -> SPA transition.
     The mouse click event is captured and the loading of CommentButtonLazy is started.
     */ const handleCommentButtonClick = ()=>{
        setShowCommentButton(true);
    };
    /*Conditional Loading of CommentButtonLazy if FF is ON and showCommentButton true (user click)*/ /* in case of an error from CommentButtonQuery load CommentButtonLazy and allow CommentButton to make
          another network call to fetch data*/ const isDataLoaded = Boolean(data?.commentData && !error);
    if (showCommentButton || error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $h0mTL.CommentButtonLazy), {
        contentId: contentId,
        isDataLoaded: isDataLoaded,
        isFabricPage: isFabricSuported
    }));
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jIlrR.CommentButtonPlaceholder), {
        isDisabled: !isDataLoaded && !isCommentButtonSSRd,
        handleCommentButtonClick: isDataLoaded || isCommentButtonSSRd ? handleCommentButtonClick : $262f69aacf5ded76$var$noop,
        contentId: contentId
    }));
});
module.exports["CommentButtonWrapper"] = $262f69aacf5ded76$export$e64f20017ef2874a;

});

parcelRegister("h0mTL", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");


var $jIlrR = parcelRequire("jIlrR");


const $3ed4db9782b8d46b$export$43a94cba75d164d3 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "pHrwQ",
    name: "CommentButtonLazy",
    loader: async ()=>(await (parcelRequire("7ovsh"))).CommentButton,
    loading: ({ isDataLoaded: isDataLoaded })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jIlrR.CommentButtonPlaceholder), {
            isDisabled: !isDataLoaded
        })
});
module.exports["CommentButtonLazy"] = $3ed4db9782b8d46b$export$43a94cba75d164d3;

});

parcelRegister("jIlrR", function(module, exports) {
/* CommentButtonPlaceholder.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $fJCU9 = parcelRequire("fJCU9");


var $7ZB0A = parcelRequire("7ZB0A");


var $eDtFr = parcelRequire("eDtFr");


var $lpNn5 = parcelRequire("lpNn5");


var $gczDe = parcelRequire("gczDe");


var $7aw3q = parcelRequire("7aw3q");


var $6GD8y = parcelRequire("6GD8y");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");

const $e0f29c26904b1b78$export$2d5d2ba3c7c8c40b = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = (0, $7ZB0A.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0sElkwuNcX _4GiLnvFQfX _27WIHEFQfX",
            __cmplp.className
        ])
    });
});
const $e0f29c26904b1b78$var$CommentCountWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5v1qpb",
            __cmplp.className
        ])
    });
});
const $e0f29c26904b1b78$export$400dbe00d66d91c = ({ isDisabled: isDisabled = true, handleCommentButtonClick: handleCommentButtonClick = ()=>{}, style: style, onRender: onRender })=>{
    (0, $cozmU.useEffect)(()=>{
        if (!isDisabled) onRender && onRender();
    }, [
        isDisabled,
        onRender
    ]);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const commentShortcutStrings = (0, $4tOXV.useShortcutStrings)({
        shortcut: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT)
    });
    const isEmbeddedCommentsEnabled = (0, $7aw3q.useEmbeddedComments)();
    const eventEmitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
    if (!isEmbeddedCommentsEnabled) return null;
    else if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e0f29c26904b1b78$export$2d5d2ba3c7c8c40b, {
        testId: "comment-button-placeholder",
        "data-test-id": "comment-button-placeholder",
        appearance: "subtle",
        "aria-label": formatMessage({
            id: "comment-button.icon.label",
            defaultMessage: "Comment button placeholder"
        }),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))), {
            label: "",
            spacing: "spacious"
        }),
        isDisabled: true // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        ,
        style: style
    });
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
        deprecatedAccelerator: (0, $gnkil.TOGGLE_INLINE_COMMENTS_SHORTCUT_RENDERER),
        accelerator: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT),
        listener: (e)=>{
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            if (document.getElementById('renderer-comments-sidebar')) {
                eventEmitter.emit((0, $fJCU9.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS);
                eventEmitter.emit((0, $fJCU9.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
            } else handleCommentButtonClick(e);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "comment-button.tooltip",
            defaultMessage: "Show comments"
        }),
        shortcut: commentShortcutStrings,
        hideTooltipOnClick: true,
        position: "bottom"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e0f29c26904b1b78$var$CommentCountWrapper, {
        onClick: handleCommentButtonClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e0f29c26904b1b78$export$2d5d2ba3c7c8c40b, {
        "data-id": "comment-button-placeholder",
        "data-cy": "comment-button-placeholder",
        testId: "comment-button-placeholder",
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))), {
            label: formatMessage({
                id: "comment-button.icon.label",
                defaultMessage: "Show comments"
            }),
            spacing: "spacious"
        })),
        isDisabled: isDisabled,
        style: style
    }))));
};
module.exports["CommentButtonPlaceholder"] = $e0f29c26904b1b78$export$400dbe00d66d91c;

});

parcelRegister("7aw3q", function(module, exports) {

var $lTECB = parcelRequire("lTECB");


var $9bL1w = parcelRequire("9bL1w");


var $cxu5H = parcelRequire("cxu5H");

const $440129e2f2e8f952$export$d22f0c9bbe97be97 = ()=>{
    const isEmbeddedConfluence = (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)();
    const { hasComments: hasPageComments, hasInlineCommentsAndHighlightActions: hasViewInlineComments } = (0, $cxu5H.useEmbeddedViewPageFeatures)();
    const { hasInlineCommentsAndHighlightActions: hasEditInlineComments } = (0, $9bL1w.useEmbeddedEditPageFeatures)();
    if (!isEmbeddedConfluence) return true;
    const allowPageCommentsInEmbeddedMode = hasPageComments;
    const allowInlineCommentsInEmbeddedMode = hasViewInlineComments || hasEditInlineComments;
    return allowPageCommentsInEmbeddedMode && allowInlineCommentsInEmbeddedMode;
};
module.exports["useEmbeddedComments"] = $440129e2f2e8f952$export$d22f0c9bbe97be97;

});

parcelRegister("9bL1w", function(module, exports) {

var $36Uax = parcelRequire("36Uax");

var $4PNpW = parcelRequire("4PNpW");


var $9wGTI = parcelRequire("9wGTI");


var $gyiJY = parcelRequire("gyiJY");

const { edit: $30ba1cd08ee89eb0$var$EDIT_PAGE_DEFAULT_ALLOWED_FEATURES } = (0, $36Uax.DEFAULT_ALLOWED_FEATURES);
var $30ba1cd08ee89eb0$export$36621fa7e88734f8 = /*#__PURE__*/ function(EmbeddedEditPageButtons) {
    EmbeddedEditPageButtons["DELETE_DRAFT"] = "delete-draft";
    EmbeddedEditPageButtons["TEMPLATE_BROWSER"] = "template-browser";
    return EmbeddedEditPageButtons;
}({});
const $30ba1cd08ee89eb0$export$3f18272ea50bc7e1 = ()=>{
    const allowedFeatures = (0, $gyiJY.useAllowedFeatures)() || $30ba1cd08ee89eb0$var$EDIT_PAGE_DEFAULT_ALLOWED_FEATURES;
    /**
	 * When allowedFeatures === all, we don't want to enable features that are suppose to disable features.
	 * For example, we want to keep "disable-publish-close-buttons" out of allowedEditPageFeatures,
	 * so that the Publish and Close buttons won't be hidden when allowedFeatures is "all".
	 * Similarly, "enable-share" is an opt-in feature and should not be enabled when allowedFeatures is "all".
	 */ const disableFeatures = [
        'disable-publish-close-buttons',
        'disable-close-button',
        'enable-share'
    ];
    const allAllowedFeaturesEnabled = allowedFeatures === 'all';
    const allowedEditPageFeatures = allAllowedFeaturesEnabled ? (0, $4PNpW.EDIT_PAGE_FEATURES).filter((feature)=>!disableFeatures.includes(feature)) : allowedFeatures;
    const allowedEllipsisButtons = [];
    const isDeleteDraftEnabled = allowedEditPageFeatures?.includes("delete-draft");
    if (isDeleteDraftEnabled) allowedEllipsisButtons.push("delete-draft");
    const templateBrowserConfig = !allAllowedFeaturesEnabled ? allowedFeatures?.find((x)=>typeof x === 'object' && x !== null && 'template-browser' in x) : undefined;
    const templateBrowserPanelConfig = !allAllowedFeaturesEnabled && (0, $9wGTI.fg)('confluence_embedded_decouple_template_browser_bpqa') ? allowedFeatures?.find((x)=>typeof x === 'object' && x !== null && 'template-browser-panel' in x) : undefined;
    const isTemplateBrowserEnabled = allowedEditPageFeatures?.includes("template-browser") || !!templateBrowserConfig;
    const isTemplateBrowserPanelEnabled = (0, $9wGTI.fg)('confluence_embedded_decouple_template_browser_bpqa') && (allowedEditPageFeatures?.includes('template-browser-panel') || !!templateBrowserPanelConfig);
    if (isTemplateBrowserEnabled || isTemplateBrowserPanelEnabled) allowedEllipsisButtons.push("template-browser");
    const spacePickerDisabledByTemplateBrowserPanel = templateBrowserPanelConfig?.['template-browser-panel']?.['space-picker-disabled'];
    const spacePickerDisabledByLegacyTemplateBrowser = templateBrowserConfig?.['template-browser']?.['space-picker-disabled'];
    const isSpacePickerDisabled = (0, $9wGTI.fg)('confluence_embedded_decouple_template_browser_bpqa') ? spacePickerDisabledByTemplateBrowserPanel ?? spacePickerDisabledByLegacyTemplateBrowser ?? false : spacePickerDisabledByLegacyTemplateBrowser ?? false;
    const isBlankPageQuickActionsEnabled = allowedEditPageFeatures?.includes('blank-page-quick-actions');
    const hasInlineCommentsAndHighlightActions = allowedEditPageFeatures?.includes('inline-comments');
    const isPublishModalEnabled = allowedEditPageFeatures?.includes('publish-modal');
    const hidePublishCloseButtons = allowedEditPageFeatures?.includes('disable-publish-close-buttons');
    const hideCloseButton = allowedEditPageFeatures?.includes('disable-close-button');
    const loomExternalOpenRoute = allowedEditPageFeatures?.find((x)=>typeof x === 'object' && x !== null && 'loom-external-open' in x)?.['loom-external-open']?.route;
    /**
	 * Rovo chat is enabled only when:
	 * - The platform AI feature flag is on, and
	 * - The host explicitly allows it via the 'rovo' feature in allowedFeatures.
	 * We require explicit opt-in (not when allowedFeatures === 'all') so hosts
	 * must intentionally enable AI in the embedded context.
	 */ const isRovoEditEnabled = !allAllowedFeaturesEnabled && !!allowedEditPageFeatures?.includes('rovo');
    const showShare = allowedEditPageFeatures?.includes('enable-share');
    return {
        allowedEllipsisButtons: allowedEllipsisButtons,
        isTemplateBrowserEnabled: // @Depracated: This is deprecated, but we need to keep it for backward compatibility.
        // Please use isTemplateBrowserPanelEnabled instead.
        isTemplateBrowserEnabled,
        isTemplateBrowserPanelEnabled: isTemplateBrowserPanelEnabled,
        isBlankPageQuickActionsEnabled: isBlankPageQuickActionsEnabled,
        isSpacePickerDisabled: isSpacePickerDisabled,
        hasInlineCommentsAndHighlightActions: hasInlineCommentsAndHighlightActions,
        isPublishModalEnabled: isPublishModalEnabled,
        hidePublishCloseButtons: hidePublishCloseButtons,
        hideCloseButton: hideCloseButton,
        loomExternalOpenRoute: loomExternalOpenRoute,
        isRovoAllowed: isRovoEditEnabled,
        showShare: showShare
    };
};
module.exports["useEmbeddedEditPageFeatures"] = $30ba1cd08ee89eb0$export$3f18272ea50bc7e1;

});

parcelRegister("7ovsh", function(module, exports) {

let $56232ca43fd1c02e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $56232ca43fd1c02e$var$load("aPyUL"),
    $56232ca43fd1c02e$var$load("8LtYa"),
    $56232ca43fd1c02e$var$load("9H0e8"),
    $56232ca43fd1c02e$var$load("fky9A"),
    $56232ca43fd1c02e$var$load("i1fe2")
]).then(()=>parcelRequire('32Ecy'));

});

parcelRegister("lF24E", function(module, exports) {

var $6nmm4 = parcelRequire("6nmm4");


var $jMyy4 = parcelRequire("jMyy4");

const $d0986d2d4a7f2d28$var$usePreloadCommentButtonQuery = (0, $6nmm4.default);
const $d0986d2d4a7f2d28$export$d1f3401b494de415 = (contentId, isCommentButtonSSRd)=>{
    const { data: commentData, error: commentError } = (0, $jMyy4.useQueryInterop)($d0986d2d4a7f2d28$var$usePreloadCommentButtonQuery, {
        fetchPolicy: isCommentButtonSSRd ? 'cache-first' : 'cache-and-network',
        variables: {
            pageId: contentId
        },
        __callerPackage__: "comment-button"
    });
    return {
        data: {
            commentData: commentData
        },
        error: commentError
    };
};
module.exports["usePreloadCommentButton"] = $d0986d2d4a7f2d28$export$d1f3401b494de415;

});

parcelRegister("6nmm4", function(module, exports) {
/**
 * @generated SignedSource<<88f279dbe5ccdf9215c75bd7dca3235f>>
 * @relayHash 9c0afe40300e5013e32bbea6173aea1d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 06aa97550eece151c700159d732523f4cb4864ece75d8cd83f2a2040951feaf5
const $31e2294f16992ac7$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageId"
        }
    ], v1 = [
        {
            "kind": "Literal",
            "name": "depth",
            "value": "ALL"
        },
        {
            "kind": "Variable",
            "name": "pageId",
            "variableName": "pageId"
        },
        {
            "kind": "Literal",
            "name": "type",
            "value": "UNRESOLVED"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "count"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            }
        ],
        "type": "InlineComment"
    }, v6 = {
        "args": [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "pageId"
            }
        ],
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
            {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v3 /*: any*/ ,
                    {
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "key",
                                "value": "editor"
                            }
                        ],
                        "concreteType": "PaginatedJsonContentPropertyList",
                        "kind": "LinkedField",
                        "name": "properties",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JsonContentProperty",
                                "kind": "LinkedField",
                                "name": "nodes",
                                "plural": true,
                                "selections": [
                                    v3 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "key"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "value"
                                    }
                                ]
                            }
                        ],
                        "storageKey": "properties(key:\"editor\")"
                    },
                    {
                        "concreteType": "ContentMetadata",
                        "kind": "LinkedField",
                        "name": "metadata",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                "kind": "LinkedField",
                                "name": "frontend",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "fabricEditorSupported"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePreloadCommentButtonQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v6 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePreloadCommentButtonQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v6 /*: any*/ 
            ]
        },
        "params": {
            "cacheID": "9c0afe40300e5013e32bbea6173aea1d",
            "id": "06aa97550eece151c700159d732523f4cb4864ece75d8cd83f2a2040951feaf5",
            "metadata": {},
            "name": "usePreloadCommentButtonQuery",
            "operationKind": "query",
            "text": "query usePreloadCommentButtonQuery($pageId:ID!){comments(pageId:$pageId,type:UNRESOLVED,depth:ALL){count,nodes{id,location{__typename,type,...on InlineComment{inlineMarkerRef}}}},content(id:$pageId){nodes{id,properties(key:\"editor\"){nodes{id,key,value}},metadata{frontend{fabricEditorSupported}}}}}"
        }
    };
}();
$31e2294f16992ac7$var$node.hash = "213bd75259a759693c19bec62abadf60";
var $31e2294f16992ac7$export$2e2bcd8739ae039 = $31e2294f16992ac7$var$node;
module.exports["default"] = $31e2294f16992ac7$export$2e2bcd8739ae039;

});

parcelRegister("2pIlF", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1sCHt = parcelRequire("1sCHt");


var $iV65j = parcelRequire("iV65j");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $luv00 = parcelRequire("luv00");


var $lT8a1 = parcelRequire("lT8a1");

const $4c5c52253c9aa054$var$iconSkeletonStyle = (0, $buxP3.xcss)({
    width: '16px',
    height: '16px',
    borderRadius: 'radius.xsmall',
    background: "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)"
});
const $4c5c52253c9aa054$var$SkeletonGlyph = ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            testId: "icon-skeleton",
            xcss: $4c5c52253c9aa054$var$iconSkeletonStyle
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
const $4c5c52253c9aa054$export$4d89be89896b480 = ()=>{
    const $ = (0, $bDgLe.c)(3);
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iV65j.SplitButton), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lT8a1.ShareAndRestrictButtonPlaceholder), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            testId: "copy-link-button-placeholder",
            icon: $4c5c52253c9aa054$var$SkeletonGlyph,
            label: "",
            isDisabled: true
        }));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== ssrPlaceholderIdProp) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", ssrPlaceholderIdProp, t0);
        $[1] = ssrPlaceholderIdProp;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
};
module.exports["ShareRestrictAndCopyButtonPlaceholder"] = $4c5c52253c9aa054$export$4d89be89896b480;

});

parcelRegister("8Cofr", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $6b4nE = parcelRequire("6b4nE");


var $jBnsv = parcelRequire("jBnsv");


var $frvUM = parcelRequire("frvUM");


var $iAOfI = parcelRequire("iAOfI");

const $6464ae7cd7e3f432$export$fa1acf2328e09e6c = [
    (0, $jBnsv.WATCH_BUTTON_KEY),
    (0, $jBnsv.PAGE_FAVOURITE_KEY),
    (0, $jBnsv.PAGE_UNFAVOURITE_KEY),
    (0, $jBnsv.EDIT_BUTTON_PAGE_KEY),
    (0, $jBnsv.EDIT_BUTTON_BLOGPOST_KEY),
    (0, $jBnsv.INVITE_TO_EDIT_KEY)
];
const $6464ae7cd7e3f432$var$displayInlineBlock = {
    display: 'inline-block'
};
const $6464ae7cd7e3f432$var$displayFlex = {
    display: 'flex',
    alignItems: 'center'
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6464ae7cd7e3f432$var$FlexNavigationContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_0hPCNLDIqT _3iDTPbQ4SZ _0aFT5v1qpb _3TGfC9LRg7 _4kiQYAmpvA",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); /* eslint-disable react/prop-types */ 
class $6464ae7cd7e3f432$export$60c40240daccf47b extends (0, $cozmU.PureComponent) {
    render() {
        const { spaceKey: spaceKey, contentId: contentId, versionOverride: versionOverride, showEdit: showEdit = true, isFabricPage: isFabricPage, allowedContentToolsItems: allowedContentToolsItems, children: children, contentType: contentType, isExternalCollaborator: isExternalCollaborator, isContentToolsForcedOpen: isContentToolsForcedOpen, setIsContentToolsForcedOpen: setIsContentToolsForcedOpen } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "data-id": "gpb-common",
            "data-testid": "gpb-common",
            "data-vc": "grouped-page-buttons-common"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6464ae7cd7e3f432$var$FlexNavigationContainer, {
            "data-vc": "grouped-page-buttons-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            style: $6464ae7cd7e3f432$var$displayInlineBlock
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "data-test-id": "content-buttons",
            style: $6464ae7cd7e3f432$var$displayFlex
        }, showEdit === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iAOfI.EditContentButton), {
            key: "edit-content-button",
            contentId: contentId
        }) : null, children)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $frvUM.ContentTools), {
            spaceKey: spaceKey,
            contentId: contentId,
            version: versionOverride,
            isFabricPage: isFabricPage,
            allowedContentToolsItems: allowedContentToolsItems,
            contentType: contentType,
            isExternalCollaborator: isExternalCollaborator,
            isContentToolsForcedOpen: isContentToolsForcedOpen,
            setIsContentToolsForcedOpen: setIsContentToolsForcedOpen
        })));
    }
}
$6464ae7cd7e3f432$export$60c40240daccf47b.propTypes = {
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    versionOverride: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).number,
    showEdit: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    isFabricPage: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    allowedContentToolsItems: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).any,
    contentType: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string
};
module.exports["FILTERED_WEB_ITEM_KEYS"] = $6464ae7cd7e3f432$export$fa1acf2328e09e6c;
module.exports["GroupedPageButtonsCommon"] = $6464ae7cd7e3f432$export$60c40240daccf47b;

});

parcelRegister("frvUM", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $4fa9fecc4e6fa66b$export$8e3d4e3d40a48fc4 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "3cAEv",
    name: "ContentTools",
    loader: async ()=>(await (parcelRequire("8Htnt"))).ContentTools
});
module.exports["ContentTools"] = $4fa9fecc4e6fa66b$export$8e3d4e3d40a48fc4;

});

parcelRegister("8Htnt", function(module, exports) {

let $655920ae7a67c5a1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $655920ae7a67c5a1$var$load("8PJsv"),
    $655920ae7a67c5a1$var$load("5ojOh"),
    $655920ae7a67c5a1$var$load("5iVGR"),
    $655920ae7a67c5a1$var$load("7A87G"),
    $655920ae7a67c5a1$var$load("9V1vV"),
    $655920ae7a67c5a1$var$load("4RQK3"),
    $655920ae7a67c5a1$var$load("c831e"),
    $655920ae7a67c5a1$var$load("6XCf4"),
    $655920ae7a67c5a1$var$load("ebvEF"),
    $655920ae7a67c5a1$var$load("ezYRV"),
    $655920ae7a67c5a1$var$load("30b92"),
    $655920ae7a67c5a1$var$load("bAgF6"),
    $655920ae7a67c5a1$var$load("hhu66"),
    $655920ae7a67c5a1$var$load("fky9A"),
    $655920ae7a67c5a1$var$load("87mhv"),
    $655920ae7a67c5a1$var$load("el56J"),
    $655920ae7a67c5a1$var$load("6dLts"),
    $655920ae7a67c5a1$var$load("jdPbE"),
    $655920ae7a67c5a1$var$load("aEiTV"),
    $655920ae7a67c5a1$var$load("keazL"),
    $655920ae7a67c5a1$var$load("dhXIT"),
    $655920ae7a67c5a1$var$load("1qlDN"),
    $655920ae7a67c5a1$var$load("1yVM6"),
    $655920ae7a67c5a1$var$load("59hV4"),
    $655920ae7a67c5a1$var$load("9cpj1"),
    $655920ae7a67c5a1$var$load("aLbuU"),
    $655920ae7a67c5a1$var$load("fuOfV"),
    $655920ae7a67c5a1$var$load("jL1Ke"),
    $655920ae7a67c5a1$var$load("5MQ0D"),
    $655920ae7a67c5a1$var$load("5gsbh"),
    $655920ae7a67c5a1$var$load("h0X0x"),
    $655920ae7a67c5a1$var$load("7l4Nc"),
    $655920ae7a67c5a1$var$load("fwbNS"),
    $655920ae7a67c5a1$var$load("h4Nf7"),
    $655920ae7a67c5a1$var$load("4g6rd"),
    $655920ae7a67c5a1$var$load("ayJxT"),
    $655920ae7a67c5a1$var$load("2nsSd"),
    $655920ae7a67c5a1$var$load("6wr18"),
    $655920ae7a67c5a1$var$load("bzc8Q"),
    $655920ae7a67c5a1$var$load("Wowvf"),
    $655920ae7a67c5a1$var$load("ffEVr"),
    $655920ae7a67c5a1$var$load("ea3NB"),
    $655920ae7a67c5a1$var$load("kyfJT"),
    $655920ae7a67c5a1$var$load("hhss7"),
    $655920ae7a67c5a1$var$load("7EorR"),
    $655920ae7a67c5a1$var$load("hWs86")
]).then(()=>parcelRequire('bTUBB'));

});

parcelRegister("hlP5l", function(module, exports) {

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");

const $ca1c06444d7dc3f1$export$1acb68730768e8f3 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.BYLINE_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
const $ca1c06444d7dc3f1$export$e2e4f4b09ade4a7e = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.CONTENT_TITLE_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
const $ca1c06444d7dc3f1$export$9f06d0bab23f5435 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.CONNECT_APP_WEB_FRAGMENT_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
module.exports["BYLINE_METRIC"] = $ca1c06444d7dc3f1$export$1acb68730768e8f3;
module.exports["CONTENT_TITLE_METRIC"] = $ca1c06444d7dc3f1$export$e2e4f4b09ade4a7e;
module.exports["CONNECT_APP_WEB_FRAGMENT_METRIC"] = $ca1c06444d7dc3f1$export$9f06d0bab23f5435;

});

parcelRegister("a3W69", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $8bU3n = parcelRequire("8bU3n");


var $5FSHs = parcelRequire("5FSHs");


var $cozmU = parcelRequire("cozmU");


var $6b4nE = parcelRequire("6b4nE");


var $6SsN4 = parcelRequire("6SsN4");


var $9DHhW = parcelRequire("9DHhW");


var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");


var $b3j2Y = parcelRequire("b3j2Y");


var $7Sm4c = parcelRequire("7Sm4c");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $zalpJ = parcelRequire("zalpJ");


var $8rneB = parcelRequire("8rneB");


var $1d2ww = parcelRequire("1d2ww");


var $8VcPj = parcelRequire("8VcPj");


var $7boqA = parcelRequire("7boqA");


var $dnfJM = parcelRequire("dnfJM");


var $jjv3l = parcelRequire("jjv3l");


var $lt6Lx = parcelRequire("lt6Lx");


var $c0urc = parcelRequire("c0urc");

var $1SNEF = parcelRequire("1SNEF");


var $6mKj3 = parcelRequire("6mKj3");


var $jMyy4 = parcelRequire("jMyy4");


var $hlP5l = parcelRequire("hlP5l");


var $fxLAA = parcelRequire("fxLAA");


var $80xNa = parcelRequire("80xNa");


var $fabPv = parcelRequire("fabPv");


var $9BkfL = parcelRequire("9BkfL");


var $7xnK2 = parcelRequire("7xnK2");


var $eP7b6 = parcelRequire("eP7b6");

const $7e6bc24b02592f12$export$8b726f842fdbb0d1 = (0, $5FSHs.default);
const $7e6bc24b02592f12$export$5ab6716f55e6755d = (0, $8bU3n.default);
const $7e6bc24b02592f12$var$deriveLookAndFeelFromData = (data)=>{
    const { space: space } = data;
    if (!space) return null;
    const { lookAndFeel: lookAndFeel } = space;
    return {
        ...lookAndFeel,
        headings: lookAndFeel.headings.reduce((obj, heading)=>{
            obj[heading.key] = heading.value;
            return obj;
        }, {})
    };
};
const $7e6bc24b02592f12$export$27036aac658fb1f1 = (contentNode)=>{
    return contentNode?.metadata?.frontend?.fabricEditorSupported ?? false;
};
const $7e6bc24b02592f12$export$aaf6264d06ddc4ce = (t0)=>{
    const $ = (0, $bDgLe.c)(32);
    let banner;
    let contentId;
    let hasCoverPicture;
    let includeDraftContentStatus;
    let isEmbeddedPage;
    let pageWidthType;
    let passThroughProps;
    let prefix;
    let spaceKey;
    let t1;
    if ($[0] !== t0) {
        ({ spaceKey: spaceKey, banner: banner, contentId: contentId, children: t1, prefix: prefix, hasCoverPicture: hasCoverPicture, pageWidthType: pageWidthType, isEmbeddedPage: isEmbeddedPage, includeDraftContentStatus: includeDraftContentStatus, ...passThroughProps } = t0);
        $[0] = t0;
        $[1] = banner;
        $[2] = contentId;
        $[3] = hasCoverPicture;
        $[4] = includeDraftContentStatus;
        $[5] = isEmbeddedPage;
        $[6] = pageWidthType;
        $[7] = passThroughProps;
        $[8] = prefix;
        $[9] = spaceKey;
        $[10] = t1;
    } else {
        banner = $[1];
        contentId = $[2];
        hasCoverPicture = $[3];
        includeDraftContentStatus = $[4];
        isEmbeddedPage = $[5];
        pageWidthType = $[6];
        passThroughProps = $[7];
        prefix = $[8];
        spaceKey = $[9];
        t1 = $[10];
    }
    const children = t1 === undefined ? null : t1;
    let t2;
    if ($[11] !== contentId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
            id: contentId,
            name: (0, $irVI7.VIEW_PAGE_TITLE_EXPERIENCE)
        });
        $[11] = contentId;
        $[12] = t2;
    } else t2 = $[12];
    let t3;
    if ($[13] !== contentId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
            key: contentId,
            metric: (0, $hlP5l.CONTENT_TITLE_METRIC)
        });
        $[13] = contentId;
        $[14] = t3;
    } else t3 = $[14];
    let t4;
    if ($[15] !== banner || $[16] !== children || $[17] !== contentId || $[18] !== hasCoverPicture || $[19] !== includeDraftContentStatus || $[20] !== isEmbeddedPage || $[21] !== pageWidthType || $[22] !== passThroughProps || $[23] !== prefix || $[24] !== spaceKey) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7e6bc24b02592f12$var$ContentTitleWrapper, {
            contentId: contentId,
            spaceKey: spaceKey,
            banner: banner,
            prefix: prefix,
            hasCoverPicture: hasCoverPicture,
            pageWidthType: pageWidthType,
            isEmbeddedPage: isEmbeddedPage,
            includeDraftContentStatus: includeDraftContentStatus,
            ...passThroughProps
        }, children);
        $[15] = banner;
        $[16] = children;
        $[17] = contentId;
        $[18] = hasCoverPicture;
        $[19] = includeDraftContentStatus;
        $[20] = isEmbeddedPage;
        $[21] = pageWidthType;
        $[22] = passThroughProps;
        $[23] = prefix;
        $[24] = spaceKey;
        $[25] = t4;
    } else t4 = $[25];
    let t5;
    if ($[26] !== t3 || $[27] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).BACKBONE
        }, t3, t4);
        $[26] = t3;
        $[27] = t4;
        $[28] = t5;
    } else t5 = $[28];
    let t6;
    if ($[29] !== t2 || $[30] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, t2, t5);
        $[29] = t2;
        $[30] = t5;
        $[31] = t6;
    } else t6 = $[31];
    return t6;
};
const $7e6bc24b02592f12$export$50dbf7c0405e659c = (t0)=>{
    const $ = (0, $bDgLe.c)(34);
    let banner;
    let contentFragmentRef;
    let contentId;
    let hasCoverPicture;
    let isEmbeddedPage;
    let pageWidthType;
    let passThroughProps;
    let prefix;
    let spaceFragmentRef;
    let spaceKey;
    let t1;
    if ($[0] !== t0) {
        ({ contentFragmentRef: contentFragmentRef, spaceFragmentRef: spaceFragmentRef, spaceKey: spaceKey, banner: banner, contentId: contentId, children: t1, prefix: prefix, hasCoverPicture: hasCoverPicture, pageWidthType: pageWidthType, isEmbeddedPage: isEmbeddedPage, ...passThroughProps } = t0);
        $[0] = t0;
        $[1] = banner;
        $[2] = contentFragmentRef;
        $[3] = contentId;
        $[4] = hasCoverPicture;
        $[5] = isEmbeddedPage;
        $[6] = pageWidthType;
        $[7] = passThroughProps;
        $[8] = prefix;
        $[9] = spaceFragmentRef;
        $[10] = spaceKey;
        $[11] = t1;
    } else {
        banner = $[1];
        contentFragmentRef = $[2];
        contentId = $[3];
        hasCoverPicture = $[4];
        isEmbeddedPage = $[5];
        pageWidthType = $[6];
        passThroughProps = $[7];
        prefix = $[8];
        spaceFragmentRef = $[9];
        spaceKey = $[10];
        t1 = $[11];
    }
    const children = t1 === undefined ? null : t1;
    let t2;
    if ($[12] !== contentId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
            id: contentId,
            name: (0, $irVI7.VIEW_PAGE_TITLE_EXPERIENCE)
        });
        $[12] = contentId;
        $[13] = t2;
    } else t2 = $[13];
    let t3;
    if ($[14] !== contentId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
            key: contentId,
            metric: (0, $hlP5l.CONTENT_TITLE_METRIC)
        });
        $[14] = contentId;
        $[15] = t3;
    } else t3 = $[15];
    let t4;
    if ($[16] !== banner || $[17] !== children || $[18] !== contentFragmentRef || $[19] !== contentId || $[20] !== hasCoverPicture || $[21] !== isEmbeddedPage || $[22] !== pageWidthType || $[23] !== passThroughProps || $[24] !== prefix || $[25] !== spaceFragmentRef || $[26] !== spaceKey) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7e6bc24b02592f12$var$ContentTitleFragmentWrapper, {
            contentFragmentRef: contentFragmentRef,
            spaceFragmentRef: spaceFragmentRef,
            contentId: contentId,
            spaceKey: spaceKey,
            banner: banner,
            prefix: prefix,
            hasCoverPicture: hasCoverPicture,
            pageWidthType: pageWidthType,
            isEmbeddedPage: isEmbeddedPage,
            ...passThroughProps
        }, children);
        $[16] = banner;
        $[17] = children;
        $[18] = contentFragmentRef;
        $[19] = contentId;
        $[20] = hasCoverPicture;
        $[21] = isEmbeddedPage;
        $[22] = pageWidthType;
        $[23] = passThroughProps;
        $[24] = prefix;
        $[25] = spaceFragmentRef;
        $[26] = spaceKey;
        $[27] = t4;
    } else t4 = $[27];
    let t5;
    if ($[28] !== t3 || $[29] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).BACKBONE
        }, t3, t4);
        $[28] = t3;
        $[29] = t4;
        $[30] = t5;
    } else t5 = $[30];
    let t6;
    if ($[31] !== t2 || $[32] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, t2, t5);
        $[31] = t2;
        $[32] = t5;
        $[33] = t6;
    } else t6 = $[33];
    return t6;
};
const $7e6bc24b02592f12$var$ContentTitleFragmentWrapper = (t0)=>{
    const $ = (0, $bDgLe.c)(54);
    let banner;
    let children;
    let contentFragmentRef;
    let contentId;
    let hasCoverPicture;
    let isEmbeddedPage;
    let pageWidthType;
    let passThroughProps;
    let prefix;
    let spaceFragmentRef;
    let spaceKey;
    if ($[0] !== t0) {
        ({ contentFragmentRef: contentFragmentRef, spaceFragmentRef: spaceFragmentRef, spaceKey: spaceKey, banner: banner, contentId: contentId, children: children, prefix: prefix, hasCoverPicture: hasCoverPicture, pageWidthType: pageWidthType, isEmbeddedPage: isEmbeddedPage, ...passThroughProps } = t0);
        $[0] = t0;
        $[1] = banner;
        $[2] = children;
        $[3] = contentFragmentRef;
        $[4] = contentId;
        $[5] = hasCoverPicture;
        $[6] = isEmbeddedPage;
        $[7] = pageWidthType;
        $[8] = passThroughProps;
        $[9] = prefix;
        $[10] = spaceFragmentRef;
        $[11] = spaceKey;
    } else {
        banner = $[1];
        children = $[2];
        contentFragmentRef = $[3];
        contentId = $[4];
        hasCoverPicture = $[5];
        isEmbeddedPage = $[6];
        pageWidthType = $[7];
        passThroughProps = $[8];
        prefix = $[9];
        spaceFragmentRef = $[10];
        spaceKey = $[11];
    }
    const data = (0, $6SsN4.useFragment)($7e6bc24b02592f12$export$8b726f842fdbb0d1, contentFragmentRef);
    const space = (0, $6SsN4.useFragment)($7e6bc24b02592f12$export$5ab6716f55e6755d, spaceFragmentRef ?? null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const title = data?.title || "";
    let t1;
    let t2;
    if ($[12] !== contentId || $[13] !== createAnalyticsEvent || $[14] !== title) {
        t1 = ()=>{
            if (title === "") createAnalyticsEvent({
                type: "sendOperationalEvent",
                data: {
                    actionSubject: "emptyPageTitle",
                    action: "shown",
                    source: "ContentTitleComponent",
                    attributes: {
                        contentId: contentId
                    }
                }
            }).fire();
        };
        t2 = [
            createAnalyticsEvent,
            title,
            contentId
        ];
        $[12] = contentId;
        $[13] = createAnalyticsEvent;
        $[14] = title;
        $[15] = t1;
        $[16] = t2;
    } else {
        t1 = $[15];
        t2 = $[16];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[17] !== data) {
        t3 = $7e6bc24b02592f12$export$27036aac658fb1f1(data);
        $[17] = data;
        $[18] = t3;
    } else t3 = $[18];
    const isFabricPage = t3;
    let t4;
    if ($[19] !== data) {
        t4 = (0, $8VcPj.getContentAppearancePublished)(data);
        $[19] = data;
        $[20] = t4;
    } else t4 = $[20];
    const contentAppearance = t4;
    const centerTitle = isFabricPage && contentAppearance.appearance === (0, $1d2ww.ContentAppearanceType).DEFAULT;
    let t5;
    if ($[21] !== data) {
        t5 = (0, $8rneB.getPublishedEmojiId)({
            content: {
                nodes: [
                    data
                ]
            }
        });
        $[21] = data;
        $[22] = t5;
    } else t5 = $[22];
    const emojiId = t5;
    let t6;
    if ($[23] !== data) {
        t6 = (0, $8rneB.doesContentHaveEmojiPublished)(data);
        $[23] = data;
        $[24] = t6;
    } else t6 = $[24];
    const hasEmoji = t6;
    let t7;
    if ($[25] !== data) {
        t7 = (0, $zalpJ.getTitleContentProperty)({
            content: {
                nodes: [
                    data
                ]
            }
        });
        $[25] = data;
        $[26] = t7;
    } else t7 = $[26];
    const { titleContentProperties: titleContentProperties } = t7;
    let t8;
    if ($[27] !== space) {
        t8 = $7e6bc24b02592f12$var$deriveLookAndFeelFromData({
            space: space
        });
        $[27] = space;
        $[28] = t8;
    } else t8 = $[28];
    const t9 = pageWidthType === "\"full-width\"";
    const t10 = pageWidthType === "\"max\"";
    const t11 = data?.type ?? "";
    let t12;
    if ($[29] !== banner || $[30] !== centerTitle || $[31] !== children || $[32] !== contentId || $[33] !== emojiId || $[34] !== hasCoverPicture || $[35] !== hasEmoji || $[36] !== isEmbeddedPage || $[37] !== passThroughProps || $[38] !== prefix || $[39] !== spaceKey || $[40] !== t10 || $[41] !== t11 || $[42] !== t8 || $[43] !== t9 || $[44] !== title || $[45] !== titleContentProperties) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9BkfL.ContentTitleComponent), {
            contentId: contentId,
            title: title,
            lookAndFeel: t8,
            banner: banner,
            centerTitle: centerTitle,
            prefix: prefix,
            emojiId: emojiId,
            hasEmoji: hasEmoji,
            loading: false,
            hasCoverPicture: hasCoverPicture,
            isPageContentFullWidth: t9,
            isPageContentMaxWidth: t10,
            isEmbeddedPage: isEmbeddedPage,
            spaceKey: spaceKey,
            contentType: t11,
            titleContentProperties: titleContentProperties,
            ...passThroughProps
        }, children);
        $[29] = banner;
        $[30] = centerTitle;
        $[31] = children;
        $[32] = contentId;
        $[33] = emojiId;
        $[34] = hasCoverPicture;
        $[35] = hasEmoji;
        $[36] = isEmbeddedPage;
        $[37] = passThroughProps;
        $[38] = prefix;
        $[39] = spaceKey;
        $[40] = t10;
        $[41] = t11;
        $[42] = t8;
        $[43] = t9;
        $[44] = title;
        $[45] = titleContentProperties;
        $[46] = t12;
    } else t12 = $[46];
    const t13 = data?.space?.name || "";
    let t14;
    if ($[47] !== prefix || $[48] !== t13 || $[49] !== title) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lt6Lx.DocumentContentTitle), {
            contentTitle: title,
            contentSpace: t13,
            titlePrefix: prefix
        });
        $[47] = prefix;
        $[48] = t13;
        $[49] = title;
        $[50] = t14;
    } else t14 = $[50];
    let t15;
    if ($[51] !== t12 || $[52] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, t12, t14);
        $[51] = t12;
        $[52] = t14;
        $[53] = t15;
    } else t15 = $[53];
    return t15;
};
const $7e6bc24b02592f12$var$ContentTitleWrapper = (t0)=>{
    const $ = (0, $bDgLe.c)(74);
    let banner;
    let children;
    let contentId;
    let hasCoverPicture;
    let includeDraftContentStatus;
    let isEmbeddedPage;
    let pageWidthType;
    let passThroughProps;
    let prefix;
    let spaceKey;
    if ($[0] !== t0) {
        ({ spaceKey: spaceKey, banner: banner, contentId: contentId, children: children, prefix: prefix, hasCoverPicture: hasCoverPicture, pageWidthType: pageWidthType, isEmbeddedPage: isEmbeddedPage, includeDraftContentStatus: includeDraftContentStatus, ...passThroughProps } = t0);
        $[0] = t0;
        $[1] = banner;
        $[2] = children;
        $[3] = contentId;
        $[4] = hasCoverPicture;
        $[5] = includeDraftContentStatus;
        $[6] = isEmbeddedPage;
        $[7] = pageWidthType;
        $[8] = passThroughProps;
        $[9] = prefix;
        $[10] = spaceKey;
    } else {
        banner = $[1];
        children = $[2];
        contentId = $[3];
        hasCoverPicture = $[4];
        includeDraftContentStatus = $[5];
        isEmbeddedPage = $[6];
        pageWidthType = $[7];
        passThroughProps = $[8];
        prefix = $[9];
        spaceKey = $[10];
    }
    const shouldCenterFabricPage = $7e6bc24b02592f12$var$_temp;
    let t1;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (graphqlData_0)=>{
            const isFabricPage = $7e6bc24b02592f12$export$27036aac658fb1f1(graphqlData_0);
            return isFabricPage ? shouldCenterFabricPage(graphqlData_0) : false;
        };
        $[11] = t1;
    } else t1 = $[11];
    const isCenteredTitle = t1;
    const isRestrictedExternalShare = (0, $jjv3l.useIsRestrictedExternalShareRequest)();
    const isAccessLinkRequest = (0, $dnfJM.useIsAccessLinkRequest)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t2;
    let t3;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $6mKj3.expValEquals)("cc-markdown-mode", "isEnabled", true);
        t3 = (0, $6mKj3.expValEquals)("confluence_classification_level_v2", "isEnabled", true) ? {
            useClassificationLevelV2: true
        } : {};
        $[12] = t2;
        $[13] = t3;
    } else {
        t2 = $[12];
        t3 = $[13];
    }
    let t4;
    if ($[14] !== includeDraftContentStatus || $[15] !== isRestrictedExternalShare) {
        t4 = includeDraftContentStatus && !isRestrictedExternalShare && {
            status: [
                "current",
                "draft"
            ]
        };
        $[14] = includeDraftContentStatus;
        $[15] = isRestrictedExternalShare;
        $[16] = t4;
    } else t4 = $[16];
    let t5;
    if ($[17] !== contentId || $[18] !== spaceKey || $[19] !== t4) {
        t5 = {
            contentId: contentId,
            spaceKey: spaceKey,
            versionOverride: null,
            embeddedContentRender: null,
            limit: (0, $80xNa.DEFAULT_CONTRIBUTORS_FETCH_LIMIT),
            useNewContentTopper: true,
            isMarkdownModeEnabled: t2,
            ...t3,
            includeDevDocsBylineConnection: false,
            ...t4
        };
        $[17] = contentId;
        $[18] = spaceKey;
        $[19] = t4;
        $[20] = t5;
    } else t5 = $[20];
    let t6;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = {
            single: true,
            allowOnExternalPage: true
        };
        $[21] = t6;
    } else t6 = $[21];
    let t7;
    if ($[22] !== t5) {
        t7 = {
            variables: t5,
            context: t6,
            errorPolicy: "all"
        };
        $[22] = t5;
        $[23] = t7;
    } else t7 = $[23];
    const { loading: loading, error: error, data: queryData, refetch: refetch } = (0, $jMyy4.useQueryInterop)(isRestrictedExternalShare ? (0, $eP7b6.default) : (0, $fxLAA.default), {
        ...t7,
        __callerPackage__: "content-header"
    });
    const data = isRestrictedExternalShare ? queryData?.singleContent : queryData?.content?.nodes?.[0];
    const shouldRenderWithSpaceDenial = isAccessLinkRequest && Boolean(data) && (0, $fabPv.isSpaceDenialOnly)(error);
    if (error && shouldRenderWithSpaceDenial) (0, $7Sm4c.markErrorAsHandled)(error);
    let t8;
    if ($[24] !== contentId || $[25] !== refetch) {
        t8 = ()=>{
            const refetchVariables = {
                contentId: contentId,
                cacheBuster: ""
            };
            return refetch(refetchVariables);
        };
        $[24] = contentId;
        $[25] = refetch;
        $[26] = t8;
    } else t8 = $[26];
    const reload = t8;
    let t9;
    if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = [
            (0, $c0urc.ReloadType).content
        ];
        $[27] = t9;
    } else t9 = $[27];
    let t10;
    if ($[28] !== reload) {
        t10 = {
            name: "title",
            types: t9,
            reload: reload
        };
        $[28] = reload;
        $[29] = t10;
    } else t10 = $[29];
    (0, $1SNEF.useQuickReloadSubscriber)(t10);
    const title = data?.title || "";
    let t11;
    let t12;
    if ($[30] !== contentId || $[31] !== createAnalyticsEvent || $[32] !== error || $[33] !== loading || $[34] !== title) {
        t11 = ()=>{
            if (!loading && !error && title === "") createAnalyticsEvent({
                type: "sendOperationalEvent",
                data: {
                    actionSubject: "emptyPageTitle",
                    action: "shown",
                    source: "ContentTitleComponent",
                    attributes: {
                        contentId: contentId
                    }
                }
            }).fire();
        };
        t12 = [
            createAnalyticsEvent,
            title,
            loading,
            error,
            contentId
        ];
        $[30] = contentId;
        $[31] = createAnalyticsEvent;
        $[32] = error;
        $[33] = loading;
        $[34] = title;
        $[35] = t11;
        $[36] = t12;
    } else {
        t11 = $[35];
        t12 = $[36];
    }
    (0, $cozmU.useEffect)(t11, t12);
    if (error && !shouldRenderWithSpaceDenial) {
        let t13;
        if ($[37] !== error) {
            t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: error
            });
            $[37] = error;
            $[38] = t13;
        } else t13 = $[38];
        return t13;
    } else if (!data) {
        let t13;
        if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
            t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7xnK2.ContentTitlePlaceholder), null);
            $[39] = t13;
        } else t13 = $[39];
        return t13;
    }
    let t13;
    if ($[40] !== queryData) {
        t13 = $7e6bc24b02592f12$var$deriveLookAndFeelFromData(queryData);
        $[40] = queryData;
        $[41] = t13;
    } else t13 = $[41];
    const lookAndFeel = t13;
    const spaceName = !isRestrictedExternalShare ? data?.space?.name : "";
    const centerTitle = isCenteredTitle(data);
    let t14;
    if ($[42] !== queryData) {
        t14 = (0, $8rneB.getPublishedEmojiId)(queryData);
        $[42] = queryData;
        $[43] = t14;
    } else t14 = $[43];
    const emojiId = t14;
    const t15 = isRestrictedExternalShare ? queryData?.singleContent : queryData?.content?.nodes?.[0];
    let t16;
    if ($[44] !== t15) {
        t16 = (0, $8rneB.doesContentHaveEmojiPublished)(t15);
        $[44] = t15;
        $[45] = t16;
    } else t16 = $[45];
    const hasEmoji = t16;
    let t17;
    if ($[46] !== queryData) {
        t17 = (0, $zalpJ.getTitleContentProperty)(queryData);
        $[46] = queryData;
        $[47] = t17;
    } else t17 = $[47];
    const { titleContentProperties: titleContentProperties } = t17;
    const t18 = pageWidthType === "\"full-width\"";
    const t19 = pageWidthType === "\"max\"";
    const t20 = data?.type ?? "";
    let t21;
    if ($[48] !== banner || $[49] !== centerTitle || $[50] !== children || $[51] !== contentId || $[52] !== emojiId || $[53] !== hasCoverPicture || $[54] !== hasEmoji || $[55] !== isEmbeddedPage || $[56] !== loading || $[57] !== lookAndFeel || $[58] !== passThroughProps || $[59] !== prefix || $[60] !== spaceKey || $[61] !== t18 || $[62] !== t19 || $[63] !== t20 || $[64] !== title || $[65] !== titleContentProperties) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9BkfL.ContentTitleComponent), {
            contentId: contentId,
            title: title,
            lookAndFeel: lookAndFeel,
            banner: banner,
            centerTitle: centerTitle,
            prefix: prefix,
            emojiId: emojiId,
            hasEmoji: hasEmoji,
            loading: loading,
            hasCoverPicture: hasCoverPicture,
            isPageContentFullWidth: t18,
            isPageContentMaxWidth: t19,
            isEmbeddedPage: isEmbeddedPage,
            spaceKey: spaceKey,
            contentType: t20,
            titleContentProperties: titleContentProperties,
            ...passThroughProps
        }, children);
        $[48] = banner;
        $[49] = centerTitle;
        $[50] = children;
        $[51] = contentId;
        $[52] = emojiId;
        $[53] = hasCoverPicture;
        $[54] = hasEmoji;
        $[55] = isEmbeddedPage;
        $[56] = loading;
        $[57] = lookAndFeel;
        $[58] = passThroughProps;
        $[59] = prefix;
        $[60] = spaceKey;
        $[61] = t18;
        $[62] = t19;
        $[63] = t20;
        $[64] = title;
        $[65] = titleContentProperties;
        $[66] = t21;
    } else t21 = $[66];
    const t22 = spaceName || "";
    let t23;
    if ($[67] !== prefix || $[68] !== t22 || $[69] !== title) {
        t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lt6Lx.DocumentContentTitle), {
            contentTitle: title,
            contentSpace: t22,
            titlePrefix: prefix
        });
        $[67] = prefix;
        $[68] = t22;
        $[69] = title;
        $[70] = t23;
    } else t23 = $[70];
    let t24;
    if ($[71] !== t21 || $[72] !== t23) {
        t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, t21, t23);
        $[71] = t21;
        $[72] = t23;
        $[73] = t24;
    } else t24 = $[73];
    return t24;
};
$7e6bc24b02592f12$export$aaf6264d06ddc4ce.propTypes = {
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    banner: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).node,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).node,
    prefix: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    headingContainer: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).elementType
};
$7e6bc24b02592f12$export$aaf6264d06ddc4ce.displayName = 'ContentTitle';
function $7e6bc24b02592f12$var$_temp(graphqlData) {
    const contentAppearance = (0, $8VcPj.getContentAppearancePublished)(graphqlData);
    return contentAppearance.appearance === (0, $1d2ww.ContentAppearanceType).DEFAULT;
}
module.exports["checkIsFabricPage"] = $7e6bc24b02592f12$export$27036aac658fb1f1;
module.exports["ContentTitle"] = $7e6bc24b02592f12$export$aaf6264d06ddc4ce;
module.exports["ContentTitleFromFragment"] = $7e6bc24b02592f12$export$50dbf7c0405e659c;

});

parcelRegister("8bU3n", function(module, exports) {
/**
 * @generated SignedSource<<f602b3213f22bdf8f4d0cba101775046>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ab8f885a3e16c01f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ContentTitle_space",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "concreteType": "Theme",
            "kind": "LinkedField",
            "name": "theme",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "themeKey"
                }
            ]
        },
        {
            "concreteType": "LookAndFeel",
            "kind": "LinkedField",
            "name": "lookAndFeel",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MapOfStringToString",
                    "kind": "LinkedField",
                    "name": "headings",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                },
                {
                    "concreteType": "ContentLookAndFeel",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContainerLookAndFeel",
                            "kind": "LinkedField",
                            "name": "header",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "background"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "backgroundAttachment"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "backgroundBlendMode"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "backgroundClip"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "backgroundColor"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "backgroundImage"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "backgroundOrigin"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "backgroundPosition"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "backgroundRepeat"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "backgroundSize"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "borderRadius"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "padding"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Space"
};
$ab8f885a3e16c01f$var$node.hash = "4554ec437025ed6932758ad73dffd78f";
var $ab8f885a3e16c01f$export$2e2bcd8739ae039 = $ab8f885a3e16c01f$var$node;
module.exports["default"] = $ab8f885a3e16c01f$export$2e2bcd8739ae039;

});

parcelRegister("5FSHs", function(module, exports) {
/**
 * @generated SignedSource<<f6e18ceca7458a82cb67b114b5b429a5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ed356ae207881d70$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "key"
    }, v2 = {
        "kind": "ScalarField",
        "name": "value"
    }, v3 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "useNewContentTopper"
            }
        ],
        "kind": "Fragment",
        "name": "ContentTitle_content",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "ScalarField",
                "name": "title"
            },
            {
                "alias": "appearancePublished",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "key",
                        "value": "content-appearance-published"
                    }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": v3 /*: any*/ ,
                "storageKey": "properties(key:\"content-appearance-published\")"
            },
            {
                "alias": "emojiTitlePublished",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "key",
                        "value": "emoji-title-published"
                    }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": v3 /*: any*/ ,
                "storageKey": "properties(key:\"emoji-title-published\")"
            },
            {
                "condition": "useNewContentTopper",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "alias": "pageTitlePublished",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "key",
                                "value": "page-title-property-published"
                            }
                        ],
                        "concreteType": "PaginatedJsonContentPropertyList",
                        "kind": "LinkedField",
                        "name": "properties",
                        "plural": false,
                        "selections": v3 /*: any*/ ,
                        "storageKey": "properties(key:\"page-title-property-published\")"
                    }
                ]
            },
            {
                "alias": "editorProperty",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "key",
                        "value": "editor"
                    }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JsonContentProperty",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                            v0 /*: any*/ ,
                            v1 /*: any*/ ,
                            v2 /*: any*/ 
                        ]
                    }
                ],
                "storageKey": "properties(key:\"editor\")"
            },
            {
                "concreteType": "ContentMetadata",
                "kind": "LinkedField",
                "name": "metadata",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                        "kind": "LinkedField",
                        "name": "frontend",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "fabricEditorSupported"
                            },
                            {
                                "condition": "useNewContentTopper",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "coverPictureWidth"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "concreteType": "Space",
                "kind": "LinkedField",
                "name": "space",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "homepageId"
                    }
                ]
            }
        ],
        "type": "Content"
    };
}();
$ed356ae207881d70$var$node.hash = "749c768a4388809afc319a8a547db370";
var $ed356ae207881d70$export$2e2bcd8739ae039 = $ed356ae207881d70$var$node;
module.exports["default"] = $ed356ae207881d70$export$2e2bcd8739ae039;

});

parcelRegister("lt6Lx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $d5RCH = parcelRequire("d5RCH");


var $1ytiN = parcelRequire("1ytiN");


var $gSgn8 = parcelRequire("gSgn8");


var $8vxJi = parcelRequire("8vxJi");

const $5a5ab99dc3af9e56$var$i18n = (0, $kSwu1.defineMessages)({
    notFound: {
        id: "document-title.not.found",
        defaultMessage: "Page Not Found"
    }
});
const $5a5ab99dc3af9e56$export$8f4c40b84dd15d46 = ({ titlePrefix: titlePrefix = '', contentTitle: contentTitle = '', contentSpace: contentSpace = '', siteTitleOnly: siteTitleOnly = false, notFound: notFound = false, isHomePage: isHomePage = false })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { siteTitle: siteTitle } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            window['__DOCUMENT_TITLE_TAG__'] = '';
        };
    }, []);
    // In the case when page is rendered by SSR, the __DOCUMENT_TITLE_TAG__ will be
    // populated and we can skip document title — but only when this render has no
    // meaningful content to contribute. If contentTitle, titlePrefix, notFound,
    // isHomePage, or siteTitleOnly are set, we must still update the title
    // (e.g. relay race: new page renders before old cleanup effect runs).
    if (window['__DOCUMENT_TITLE_TAG__'] && window['__SSR_RENDERED__'] && // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.title && !contentTitle && !titlePrefix && !notFound && !isHomePage && !siteTitleOnly) return null;
    const title = [
        titlePrefix || (notFound ? intl.formatMessage($5a5ab99dc3af9e56$var$i18n.notFound) : ''),
        siteTitleOnly ? undefined : contentTitle,
        siteTitleOnly ? undefined : contentSpace,
        siteTitle
    ].filter((part)=>part).join(' - ');
    // Don't override an existing title with a less specific one (e.g., don't set "Confluence"
    // when there's already a title with content like "Page Title - Space - Confluence").
    // This prevents components with empty contentTitle from overriding titles set by components
    // with actual content during navigation/rendering transitions.
    // Note: This check happens during render, so it may not catch titles set in the same render cycle,
    // but useLayoutEffect in PageTitle ensures the last component to render wins.
    // A title is considered "specific" if it provides either a contentTitle or a titlePrefix.
    // Pages like the advanced search page pass a titlePrefix (e.g. "Search") without a
    // contentTitle, and we must still allow that title to replace the previous page's title
    // during client-side navigation. notFound, isHomePage, and siteTitleOnly are also
    // meaningful signals that must always be allowed to update the title.
    if (typeof document !== 'undefined' && document.title && !contentTitle && !titlePrefix && !notFound && !isHomePage && !siteTitleOnly) {
        // If contentTitle, titlePrefix, notFound, isHomePage, and siteTitleOnly are all empty/false,
        // we're likely setting a generic title (just siteTitle or siteTitle with space).
        // If there's already a more specific title (3+ parts, or 2 parts where first isn't siteTitle), skip.
        const existingTitleParts = document.title.split(' - ');
        const hasMoreSpecificContent = existingTitleParts.length > 2 || existingTitleParts.length === 2 && existingTitleParts[0] !== siteTitle;
        // Skip if we're trying to set a less specific title when a more specific one exists and it is not the home page
        if (hasMoreSpecificContent && title !== document.title) return null;
    }
    // Set for SSR document title
    window['__DOCUMENT_TITLE_TAG__'] = title;
    if (window.__SSR_REACT_STREAMING__) {
        const inject = (0, $gSgn8.getStreamInject)();
        inject(()=>`document.title=${(0, $8vxJi.stringifyForSSR)(title)}`);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5RCH.PageTitle), {
        title: title
    });
};
module.exports["DocumentContentTitle"] = $5a5ab99dc3af9e56$export$8f4c40b84dd15d46;

});

parcelRegister("d5RCH", function(module, exports) {
function $69aebb91e74cbedb$export$155581e8dc02007a({ title: title }) {
    // document.title is safe to set during render:
    // - It's idempotent (setting the same value multiple times is safe)
    // - It doesn't trigger React re-renders
    // - Many React libraries do this (react-helmet, react-document-title, etc.)
    // - It's a browser API, not React state, so it doesn't violate React's rules
    // - The last component to render will have its title set, avoiding race conditions
    if (typeof document !== 'undefined' && title) document.title = title;
    return null;
}
module.exports["PageTitle"] = $69aebb91e74cbedb$export$155581e8dc02007a;

});

parcelRegister("9BkfL", function(module, exports) {
/* ContentTitleComponent.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/ui-styling-standard/no-dynamic-styles, @atlaskit/ui-styling-standard/no-imported-style-values */ /** @jsxFrag React.Fragment */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $3izAL = parcelRequire("3izAL");


var $6Pqow = parcelRequire("6Pqow");


var $buxP3 = parcelRequire("buxP3");


var $b9k8w = parcelRequire("b9k8w");


var $8Iwqw = parcelRequire("8Iwqw");


var $8lt1a = parcelRequire("8lt1a");


var $i7cz5 = parcelRequire("i7cz5");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");


var $kvJHJ = parcelRequire("kvJHJ");


var $dPJCf = parcelRequire("dPJCf");


var $di8q4 = parcelRequire("di8q4");


var $Qlykt = parcelRequire("Qlykt");


var $jVylI = parcelRequire("jVylI");


var $zalpJ = parcelRequire("zalpJ");


var $bPoXA = parcelRequire("bPoXA");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $kycWk = parcelRequire("kycWk");

var $iuuqT = parcelRequire("iuuqT");

var $2MwVI = parcelRequire("2MwVI");


var $hlP5l = parcelRequire("hlP5l");

const $7dc66c9df3113525$var$EMOJI_TOP_OFFSET_OBJECT_HEADER_WITH_COVER_IMG = '-40px';
const $7dc66c9df3113525$var$EMOJI_TOP_OFFSET_DEFAULT = 'unset'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $7dc66c9df3113525$var$HeadingWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isEmbeddedPage: isEmbeddedPage, hasBanner: hasBanner, isNativeEmbed: isNativeEmbed, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1mT5xdRAKS _1DCdHidnbC",
            __cmplp.isNativeEmbed && ((0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true) || (0, $9wGTI.fg)('platform_native_embeds_rollout_non_maui_experience')) ? "_46hvQmp0Oa" : "_46hvQmdnbC",
            __cmplp.className
        ])
    });
}); // TODO: Refactor to a common location
const $7dc66c9df3113525$var$styledContentTitle = null;
const $7dc66c9df3113525$var$centerTitleStyles = null;
const $7dc66c9df3113525$var$fullWidthLeftAlignStyles = null;
const $7dc66c9df3113525$var$maxWidthLeftAlignStyles = null; // Matches the 72px full-page gutter applied to the renderer in embedded view.
const $7dc66c9df3113525$var$embeddedUITitlePaddingStyles = null;
const $7dc66c9df3113525$var$getMarginTopStyledH1 = (isEmbeddedPage, hasCoverPicture, hasEmoji)=>{
    return isEmbeddedPage || hasCoverPicture && hasEmoji ? '0px' : '72px';
};
const $7dc66c9df3113525$var$getEmojiTopOffsetValue = (hasCoverPicture)=>{
    if (hasCoverPicture) return $7dc66c9df3113525$var$EMOJI_TOP_OFFSET_OBJECT_HEADER_WITH_COVER_IMG;
    else return $7dc66c9df3113525$var$EMOJI_TOP_OFFSET_DEFAULT;
}; // Note: this component extracts the props that we don't want to send to the DOM
// This avoids styled errors about these props being passed to the DOM
/* eslint-disable @typescript-eslint/no-unused-vars */ const $7dc66c9df3113525$var$ExperimentalHeadingContainer = ({ children: children, isTitleCenterAligned: isTitleCenterAligned, hasCoverPicture: hasCoverPicture, isPageContentFullWidth: isPageContentFullWidth, isPageContentMaxWidth: isPageContentMaxWidth, isEmbeddedPage: isEmbeddedPage, hasEmoji: hasEmoji, isFixedWidthImageOption: isFixedWidthImageOption, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", props, children);
}; /* eslint-enable @typescript-eslint/no-unused-vars */ 
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $7dc66c9df3113525$var$StyledHeadingContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = $7dc66c9df3113525$var$ExperimentalHeadingContainer, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1ywc76f": (0, $9aYkv.default)($7dc66c9df3113525$var$getMarginTopStyledH1(__cmplp.isEmbeddedPage, __cmplp.hasCoverPicture, __cmplp.hasEmoji))
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _1UtDYzy7kJ _3W2Oc8wPeg _1T2N03wPeg _1ANEUS4oEs _4kiQYArIqH _0Of8r2dnbC _0wOv4Q7zJH _3iDTPbQ4SZ _4wYTBBXwEm _1dW7FxDIqT _2Jd1exu7m9 _0zdWqnOz3Q",
            __cmplp.isTitleCenterAligned || __cmplp.isFixedWidthImageOption && __cmplp.hasEmoji && !__cmplp.isTitleCenterAligned && (__cmplp.isPageContentFullWidth || __cmplp.isPageContentMaxWidth) && __cmplp.hasCoverPicture ? "_3QCn8Ybt8w" : "_3QCn8YZqHV",
            __cmplp.isTitleCenterAligned && !__cmplp.hasCoverPicture ? "_1Sj9yC5zaO" : "_1Sj9yCyL8i",
            __cmplp.onClick ? "_1pp6Nd18ZR" : "_1pp6NdYbGa",
            __cmplp.isTitleCenterAligned && "_37wbyuDIqT _2fwxA5DIqT _0aFT5vbt8w _0hPCNLDIqT",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $7dc66c9df3113525$var$StyledHeadingText = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "h1", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIgXwEm _1kk5Tku7m9 _3iDTPbS8kF",
            __cmplp.className
        ])
    });
});
const $7dc66c9df3113525$var$emojiFullWidthLeftAlignWrapper = null;
const $7dc66c9df3113525$var$EmojiAlignmentWrapper = ({ children: children, isLeftAlignedTitleWithFixedWidthImageAndEmoji: isLeftAlignedTitleWithFixedWidthImageAndEmoji })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, isLeftAlignedTitleWithFixedWidthImageAndEmoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "emoji-alignment-wrapper",
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _37wbyuzUZr _39xV02OAqP _2Zuz6QS40j"
        ])
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children));
const $7dc66c9df3113525$var$titleTextFullWidthLeftAlignWrapper = null;
const $7dc66c9df3113525$var$TitleTextAlignmentWrapper = ({ children: children, isLeftAlignedTitleWithFixedWidthImageAndEmoji: isLeftAlignedTitleWithFixedWidthImageAndEmoji })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, isLeftAlignedTitleWithFixedWidthImageAndEmoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "title-alignment-wrapper",
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _37wbyuchRC _39xV02N91d"
        ])
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $7dc66c9df3113525$var$EmojiWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isTitleCenterAligned: isTitleCenterAligned, hasCoverPicture: hasCoverPicture, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _37wbyuDIqT _2IhTonuXtm _1ACWzoQ4SZ _19MPeiDIqT _2ND2qhnQyn _0MI5WBnQyn _0gfXbTDIqT",
            __cmplp.isTitleCenterAligned ? "_1ZnuxbdnbC" : "_1ZnuxbuFDC",
            __cmplp.hasCoverPicture ? "_1EqgXlljYU" : "_1EqgXlUF4f",
            __cmplp.isTitleCenterAligned ? "_0hPCNLzUZr" : "_0hPCNLDIqT",
            __cmplp.hasCoverPicture ? "_1mT5xdWVPG" : "_1mT5xdZqHV",
            __cmplp.hasCoverPicture ? "_1oPLtcljYU" : "_1oPLtcUF4f",
            __cmplp.hasCoverPicture ? "_0PNsB9ljYU" : "_0PNsB9UF4f",
            __cmplp.className
        ])
    });
});
const $7dc66c9df3113525$var$titleCenteredMargin = (isTitleCenterAligned)=>{
    return isTitleCenterAligned ? '-5px' : 'unset';
};
const $7dc66c9df3113525$var$getMarginTopTitleTextWrapper = (isTitleCenterAligned, hasCoverPicture, hasEmoji, isEmbeddedPage)=>{
    return isEmbeddedPage ? '0px' : hasCoverPicture && hasEmoji ? '96px' : $7dc66c9df3113525$var$titleCenteredMargin(isTitleCenterAligned);
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $7dc66c9df3113525$var$TitleTextWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isTitleCenterAligned: isTitleCenterAligned, hasCoverPicture: hasCoverPicture, hasEmoji: hasEmoji, isEmbeddedPage: isEmbeddedPage, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1gac3l6": (0, $9aYkv.default)($7dc66c9df3113525$var$getMarginTopTitleTextWrapper(__cmplp.isTitleCenterAligned, __cmplp.hasCoverPicture, __cmplp.hasEmoji, __cmplp.isEmbeddedPage))
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_313842BBIK _3L4DaX7dHp _4sG9F37dHp _3XTYJ0YbGa _4zqEKHYbGa _2fWlBce6K4 _1nNgbAe6K4",
            __cmplp.className
        ])
    });
});
const $7dc66c9df3113525$var$copyLinkWrapper = (0, $buxP3.xcss)({
    font: 'font.body',
    opacity: '0',
    position: 'absolute',
    transform: 'translateX(-4px)',
    transition: 'opacity 0.2s ease-out 0s, transform 0.2s ease-out 0s'
});
const $7dc66c9df3113525$var$migratedSpotlightTitleTarget = null;
const $7dc66c9df3113525$var$isURLVisible = ()=>window.top === window.self;
const $7dc66c9df3113525$export$c5305ddfc413155f = ({ lookAndFeel: lookAndFeel, banner: banner, title: title, children: children, centerTitle: centerTitle, prefix: prefix, hasEmoji: hasEmoji, emojiId: emojiId, contentId: contentId, spaceKey: spaceKey, contentType: contentType, loading: loading, headingContainer: HeadingContainer, hasCoverPicture: hasCoverPicture, isPageContentFullWidth: isPageContentFullWidth, isPageContentMaxWidth: isPageContentMaxWidth, isEmbeddedPage: isEmbeddedPage, titleContentProperties: titleContentProperties })=>{
    'use no memo';
    const isNativeEmbed = Boolean((0, $i7cz5.maybeParseNativeEmbedParams)(new URLSearchParams(window.location.search)));
    const emojiTitle = hasEmoji ? emojiId : null;
    const { setQueryParams: routeActionsSetQueryParams } = (0, $dPJCf.useRouteActions)();
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { coverPictureWidth: coverPictureWidth } = (0, $zalpJ.useTitleContentPropertiesForPublishedPage)({
        contentId: contentId
    });
    const isFixedWidthImageOption = coverPictureWidth === (0, $jVylI.COVERPICTUREWIDTH).FIXED;
    const isTitleCenterAligned = titleContentProperties?.titleLayoutAlignment == (0, $jVylI.TitleAlignmentType).CENTER; /**
                                                                                                           * The feature of clearing query params by clicking title is only useful when it's used in standalone Confluence with the URL visible.
                                                                                                           * When a page gets embedded e.g. rendered within iframe macro, user won't be able to see the effect from clearing query params and the mouse pointer and clicking lead to a confusing user experience.
                                                                                                           */ 
    const clearQueryParams = ()=>{
        if (!$7dc66c9df3113525$var$isURLVisible()) return;
        const queryParams = routeDataRef?.current?.queryParams;
        if (!queryParams) return;
        Object.keys(queryParams).forEach((k)=>{
            routeActionsSetQueryParams({
                [k]: undefined
            }, true);
        });
    };
    const isLeftAlignedTitleWithFixedWidthImageAndEmoji = isFixedWidthImageOption && hasEmoji && !isTitleCenterAligned && hasCoverPicture && (isPageContentFullWidth || isPageContentMaxWidth);
    (0, $2MwVI.useTrackTitleRedactionRendered)({
        contentId: contentId,
        title: title
    });
    const { activeSpotlight: activeSpotlight, renderMigratedSpotlight: renderMigratedSpotlight } = (0, $iuuqT.useRedactionsTour)({
        contentId: contentId,
        step: (0, $kycWk.RedactionsTourSteps).FIRST,
        firstStepSource: (0, $kycWk.RedactionTourStepSource).titleRedaction
    });
    const headingId = 'heading-title-text';
    const titleTextForSpotlight = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7dc66c9df3113525$var$TitleTextWrapper, {
        isTitleCenterAligned: isTitleCenterAligned,
        hasCoverPicture: hasCoverPicture,
        hasEmoji: hasEmoji,
        isEmbeddedPage: isEmbeddedPage,
        id: "content-title-id"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7dc66c9df3113525$var$StyledHeadingText, {
        id: headingId
    }, prefix && !emojiTitle ? `${prefix} - ${title}` : title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        as: "span",
        paddingInlineStart: "space.100",
        xcss: $7dc66c9df3113525$var$copyLinkWrapper,
        "data-vc": "copylink-wrapper",
        testId: "copylink-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bPoXA.CopyLinkButtonLoader), {
        shouldResetOnHover: true,
        contentId: contentId,
        spaceKey: spaceKey,
        contentType: contentType,
        pageMode: "view",
        source: "pageTitle",
        buttonAppearance: "subtle-link",
        tooltipPosition: "top",
        referencedContentId: headingId
    })));
    const heading = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7dc66c9df3113525$var$StyledHeadingContainer, {
        id: "title-text",
        "data-test-id": "title-text",
        "data-testid": "title-text",
        style: lookAndFeel?.headings,
        onClick: clearQueryParams,
        isTitleCenterAligned: isTitleCenterAligned,
        hasCoverPicture: hasCoverPicture,
        isPageContentFullWidth: isPageContentFullWidth,
        isPageContentMaxWidth: isPageContentMaxWidth,
        isFixedWidthImageOption: isFixedWidthImageOption,
        isEmbeddedPage: isEmbeddedPage,
        hasEmoji: hasEmoji
    }, prefix && emojiTitle ? `${prefix} - ` : null, emojiTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7dc66c9df3113525$var$EmojiAlignmentWrapper, {
        isLeftAlignedTitleWithFixedWidthImageAndEmoji: isLeftAlignedTitleWithFixedWidthImageAndEmoji
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7dc66c9df3113525$var$EmojiWrapper, {
        isTitleCenterAligned: isTitleCenterAligned,
        hasCoverPicture: hasCoverPicture,
        isEmbeddedPage: isEmbeddedPage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
        testId: "emoji-title"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
        emoji: emojiTitle,
        height: hasCoverPicture ? (0, $Qlykt.EMOJI_SIZE_LARGE) : (0, $Qlykt.EMOJI_SIZE_MEDIUM),
        hasCoverPicture: hasCoverPicture,
        context: "viewPage",
        showTooltip: true,
        renderResourcedEmoji: true,
        isPageTitleComponent: true
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7dc66c9df3113525$var$TitleTextAlignmentWrapper, {
        isLeftAlignedTitleWithFixedWidthImageAndEmoji: isLeftAlignedTitleWithFixedWidthImageAndEmoji
    }, (0, $9wGTI.fg)('cc-dlp-fix-regressed-redactions-spotlight-tour') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            "_3iDTPbcK7c _2tL4YxccYA"
        ])
    }, renderMigratedSpotlight(titleTextForSpotlight)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b9k8w.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Iwqw.default), {
        name: (0, $kycWk.REDACTIONS_TOUR_TARGETS).TITLE_REDACTION
    }, titleTextForSpotlight), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8lt1a.default), null, activeSpotlight))));
    const headerStyles = {
        ...lookAndFeel?.content?.header
    }; // header is from graphql result which will contain __typename
    delete headerStyles.__typename;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "title-wrapper",
        className: (0, $hekY6.default)([
            !centerTitle && isPageContentFullWidth && "_313842dnbC _0adFHsIZbP _1DCdHidnbC _2XsHFMIZbP _1EqgXlJKzk",
            !centerTitle && isPageContentMaxWidth && "_313842dnbC _0adFHsIZbP _1DCdHidnbC _2XsHFMIZbP _1EqgXlwKnr",
            isNativeEmbed && ((0, $6mKj3.expValEquals)('cc-maui-experiment', 'isEnabled', true) || (0, $9wGTI.fg)('platform_native_embeds_rollout_non_maui_experience')) && "_2Zuz6QL04q _1ZnuxbL04q"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: headerStyles,
        "data-test-id": "page-content-header",
        "data-testid": "page-content-header",
        className: (0, $hekY6.default)([
            "_3iDTPbvbI6 _24h04i2Njc _4kiQYAv6H3 _39xV02N91d _1EqgXlN91d",
            centerTitle && "_313842dnbC _0adFHsIZbP _1DCdHidnbC _2XsHFMIZbP _3iDTPbvLZJ _3W2Oc8wPeg _1T2N03wPeg _1EqgXl8yGE"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7dc66c9df3113525$var$HeadingWrapper, {
        hasBanner: !!banner,
        isEmbeddedPage: isEmbeddedPage,
        isNativeEmbed: isNativeEmbed
    }, HeadingContainer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(HeadingContainer, {
        showInlineCommentButton: true,
        hasCoverPicture: hasCoverPicture && (0, $6mKj3.expValEquals)('confluence_restore_embedded_header_spacing', 'isEnabled', true)
    }, heading) : heading), banner || null, !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
        key: contentId,
        metric: (0, $hlP5l.CONTENT_TITLE_METRIC)
    }), children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.VIEW_PAGE_TITLE_EXPERIENCE)
    })));
};
$7dc66c9df3113525$export$c5305ddfc413155f.displayName = 'ContentTitleComponent';
module.exports["ContentTitleComponent"] = $7dc66c9df3113525$export$c5305ddfc413155f;

});

parcelRegister("i7cz5", function(module, exports) {

var $5TlVH = parcelRequire("5TlVH");

const $1b581ea1c80d4d76$var$ROVO_RECEIVER_ID_DATA_ATTR = 'data-rovo-receiver-id';
const [$1b581ea1c80d4d76$var$ROVO_CHILD_ID_QUERY_PARAM_KEY, $1b581ea1c80d4d76$var$ROVO_PARENT_ID_QUERY_PARAM_KEY] = (0, $5TlVH.NATIVE_EMBED_BRIDGE_QUERY_PARAM_KEYS);
function $1b581ea1c80d4d76$export$d5ca420e0d8fc785(bridgeParams) {
    const { embedClientId: embedClientId, hostClientId: hostClientId } = bridgeParams;
    return {
        clientId: embedClientId,
        getQueryParams: ()=>({
                [$1b581ea1c80d4d76$var$ROVO_CHILD_ID_QUERY_PARAM_KEY]: embedClientId,
                [$1b581ea1c80d4d76$var$ROVO_PARENT_ID_QUERY_PARAM_KEY]: hostClientId
            }),
        getIframeDataAttributes: ()=>({
                [$1b581ea1c80d4d76$var$ROVO_RECEIVER_ID_DATA_ATTR]: embedClientId
            })
    };
}
function $1b581ea1c80d4d76$export$a5e60906cc8da6df(params) {
    const id = params.get($1b581ea1c80d4d76$var$ROVO_CHILD_ID_QUERY_PARAM_KEY);
    const parentId = params.get($1b581ea1c80d4d76$var$ROVO_PARENT_ID_QUERY_PARAM_KEY);
    if (!id || id.length === 0 || !parentId || parentId.length === 0) return undefined;
    return {
        childClientId: id,
        parentClientId: parentId
    };
}
module.exports["createNativeEmbedClientIframeIntegrator"] = $1b581ea1c80d4d76$export$d5ca420e0d8fc785;
module.exports["maybeParseNativeEmbedParams"] = $1b581ea1c80d4d76$export$a5e60906cc8da6df;

});

parcelRegister("5TlVH", function(module, exports) {
const $2a2de016186788ad$export$4238689d357e0d1e = [
    'nativeEmbedChildId',
    'nativeEmbedParentId'
];
module.exports["NATIVE_EMBED_BRIDGE_QUERY_PARAM_KEYS"] = $2a2de016186788ad$export$4238689d357e0d1e;

});

parcelRegister("Qlykt", function(module, exports) {
const $f866e8db934ec558$export$d7240ab6bd9deaf0 = 40;
const $f866e8db934ec558$export$7d383c70a74caba8 = 80;
module.exports["EMOJI_SIZE_MEDIUM"] = $f866e8db934ec558$export$d7240ab6bd9deaf0;
module.exports["EMOJI_SIZE_LARGE"] = $f866e8db934ec558$export$7d383c70a74caba8;

});

parcelRegister("bPoXA", function(module, exports) {
$parcel$export(module.exports, "PAGE_MODE", () => (parcelRequire("1RN2b")).PAGE_MODE);

var $jmjWc = parcelRequire("jmjWc");


var $7VdCF = parcelRequire("7VdCF");


var $1RN2b = parcelRequire("1RN2b");


const $593a9a70400e9fe4$export$9d30156e45c09e81 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "VbFx8",
    name: "CopyLinkButtonLoader",
    loader: async ()=>{
        return (await (parcelRequire("jlS8S"))).CopyLink;
    },
    loading: (0, $7VdCF.CopyLinkButtonPlaceholder)
});
module.exports["CopyLinkButtonLoader"] = $593a9a70400e9fe4$export$9d30156e45c09e81;

});

parcelRegister("7VdCF", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kTb7m = parcelRequire("kTb7m");


var $7ZB0A = parcelRequire("7ZB0A");

const $e679cdda51869592$var$i18n = (0, $kSwu1.defineMessages)({
    copyLinkLabel: {
        id: "share-and-restrict-dialog.copylink.icon.label",
        defaultMessage: "Copy link"
    }
});
const $e679cdda51869592$export$1f3200a5b8d4d8e1 = ()=>{
    const $ = (0, $bDgLe.c)(4);
    const intl = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== intl) {
        t0 = intl.formatMessage($e679cdda51869592$var$i18n.copyLinkLabel);
        $[0] = intl;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            testId: "copy-link-button-placeholder",
            "data-test-id": "copy-link-button-placeholder",
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
                label: t0,
                spacing: "spacious"
            }),
            isDisabled: true
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
};
module.exports["CopyLinkButtonPlaceholder"] = $e679cdda51869592$export$1f3200a5b8d4d8e1;

});

parcelRegister("1RN2b", function(module, exports) {
const $d453ec9fb76ba7fd$export$9957974f8b4d8f74 = 'copyShareLink';
var $d453ec9fb76ba7fd$export$e82cf716cce37b4e = /*#__PURE__*/ function(PAGE_MODE) {
    PAGE_MODE["VIEW"] = "view";
    PAGE_MODE["EDIT"] = "edit";
    return PAGE_MODE;
}({});
module.exports["ACTION_SUBJECT_ID"] = $d453ec9fb76ba7fd$export$9957974f8b4d8f74;
module.exports["PAGE_MODE"] = $d453ec9fb76ba7fd$export$e82cf716cce37b4e;

});

parcelRegister("jlS8S", function(module, exports) {

let $e169fa03977d77ab$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e169fa03977d77ab$var$load("9RX5o").then(()=>parcelRequire('eB05M'));

});

parcelRegister("kycWk", function(module, exports) {
// Extension
const $a7399ed0bcbe7ac9$export$ebe904a0bbf57df1 = 'com.atlassian.guard-premium';
const $a7399ed0bcbe7ac9$export$d20f6356992396b7 = 'false';
var $a7399ed0bcbe7ac9$export$80edbf15fa61a4db = /*#__PURE__*/ function(MessageType) {
    MessageType["Engagement"] = "engagement";
    MessageType["Transactional"] = "transactional";
    return MessageType;
}({});
var $a7399ed0bcbe7ac9$export$ca2bc0ed0fbb9a2a = /*#__PURE__*/ function(RedactionsTourSteps) {
    RedactionsTourSteps[RedactionsTourSteps["FIRST"] = 0] = "FIRST";
    RedactionsTourSteps[RedactionsTourSteps["SECOND"] = 1] = "SECOND";
    return RedactionsTourSteps;
}({});
var $a7399ed0bcbe7ac9$export$f5d398bf946a6bf8 = /*#__PURE__*/ function(RedactionTourStepSource) {
    RedactionTourStepSource["bodyRedaction"] = "bodyRedaction";
    RedactionTourStepSource["titleRedaction"] = "titleRedaction";
    return RedactionTourStepSource;
}({});
const $a7399ed0bcbe7ac9$export$4d54b6650166caf9 = {
    REDACTION: 'redactions-tour-redaction',
    DETAILS_BUTTON: 'redactions-tour-details-button'
};
const $a7399ed0bcbe7ac9$var$REDACTIONS_TOUR_TARGET_PREFIX = 'redactions-tour:';
const $a7399ed0bcbe7ac9$var$OBJECT_SIDEBAR_TOUR_TARGET_PREFIX = 'object-sidebar-tour-target:';
const $a7399ed0bcbe7ac9$export$4ac8baee730e0515 = {
    REDACTION_EXTENSION: `${$a7399ed0bcbe7ac9$var$REDACTIONS_TOUR_TARGET_PREFIX}redaction-extension`,
    TITLE_REDACTION: `${$a7399ed0bcbe7ac9$var$REDACTIONS_TOUR_TARGET_PREFIX}title-redaction`,
    // Note: SpotlightTarget already exist on this element, so we must target that one
    SIDEBAR_DETAILS_BUTTON: `${$a7399ed0bcbe7ac9$var$OBJECT_SIDEBAR_TOUR_TARGET_PREFIX}sidebar-details-button`
};
const $a7399ed0bcbe7ac9$export$765a9736cc8e2d1f = 'https://support.atlassian.com/confluence-cloud/docs/how-redaction-works/';
module.exports["REDACTION_EXTENSION_TYPE"] = $a7399ed0bcbe7ac9$export$ebe904a0bbf57df1;
module.exports["IS_DISMISSED_FLAG"] = $a7399ed0bcbe7ac9$export$d20f6356992396b7;
module.exports["MessageType"] = $a7399ed0bcbe7ac9$export$80edbf15fa61a4db;
module.exports["RedactionsTourSteps"] = $a7399ed0bcbe7ac9$export$ca2bc0ed0fbb9a2a;
module.exports["RedactionTourStepSource"] = $a7399ed0bcbe7ac9$export$f5d398bf946a6bf8;
module.exports["REDACTIONS_TOUR_MESSAGE_IDS"] = $a7399ed0bcbe7ac9$export$4d54b6650166caf9;
module.exports["REDACTIONS_TOUR_TARGETS"] = $a7399ed0bcbe7ac9$export$4ac8baee730e0515;
module.exports["READ_MORE_URL"] = $a7399ed0bcbe7ac9$export$765a9736cc8e2d1f;

});

parcelRegister("iuuqT", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $i1t43 = parcelRequire("i1t43");


var $ivb8S = parcelRequire("ivb8S");


var $dBcar = parcelRequire("dBcar");


var $lsxnT = parcelRequire("lsxnT");


var $aWwYt = parcelRequire("aWwYt");


var $ep3mz = parcelRequire("ep3mz");


var $lfBMY = parcelRequire("lfBMY");


var $2wo33 = parcelRequire("2wo33");


var $8Lx5S = parcelRequire("8Lx5S");


var $26Yfd = parcelRequire("26Yfd");


var $kycWk = parcelRequire("kycWk");


var $gsf3i = parcelRequire("gsf3i");

const { IS_REDACTIONS_TOUR_VISIBLE: $cbee4c9267979126$var$IS_REDACTIONS_TOUR_VISIBLE } = (0, $dBcar.ONBOARDING_EXPERIENCES);
const $cbee4c9267979126$var$i18n = (0, $kSwu1.defineMessages)({
    stepOfSteps: {
        id: "redactions.redactions-tour.steps",
        defaultMessage: "{step}/{steps}"
    },
    dismiss: {
        id: "redactions.redactions-tour.dismiss",
        defaultMessage: "Dismiss"
    },
    next: {
        id: "redactions.redactions-tour.next",
        defaultMessage: "Next"
    },
    ok: {
        id: "redactions.redactions-tour.ok",
        defaultMessage: "OK"
    },
    readMore: {
        id: "redactions.redactions-tour.read-more",
        defaultMessage: "Read more"
    },
    solidBarIndicates: {
        id: "redactions.redactions-tour.solid-bar-indicates",
        defaultMessage: "The solid bar indicates that your organization detected and deleted sensitive data."
    },
    goToRedactions: {
        id: "redactions.redactions-tour.go-to-redactions",
        defaultMessage: "Go to Redactions in this menu to view details about the redactions on this page."
    },
    aboutRedactions: {
        id: "redactions.redactions-tour.about-redactions",
        defaultMessage: "About redactions"
    },
    viewRedactionDetails: {
        id: "redactions.redactions-tour.view-redaction-details",
        defaultMessage: "View redaction details"
    }
});
const $cbee4c9267979126$var$useSpotlights = ({ next: next, end: end, tourStartsInTitle: tourStartsInTitle })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const firstSpotlightKeyTarget = tourStartsInTitle ? (0, $kycWk.REDACTIONS_TOUR_TARGETS).TITLE_REDACTION : (0, $kycWk.REDACTIONS_TOUR_TARGETS).REDACTION_EXTENSION;
    return [
        {
            key: firstSpotlightKeyTarget,
            messageId: (0, $kycWk.REDACTIONS_TOUR_MESSAGE_IDS).REDACTION,
            target: firstSpotlightKeyTarget,
            messageType: (0, $kycWk.MessageType).Engagement,
            heading: formatMessage($cbee4c9267979126$var$i18n.aboutRedactions),
            actionsBeforeElement: formatMessage($cbee4c9267979126$var$i18n.stepOfSteps, {
                step: 1,
                steps: 2
            }),
            targetRadius: 3,
            actions: [
                {
                    text: formatMessage($cbee4c9267979126$var$i18n.dismiss),
                    onClick: end
                },
                {
                    text: formatMessage($cbee4c9267979126$var$i18n.next),
                    onClick: next
                }
            ],
            children: formatMessage($cbee4c9267979126$var$i18n.solidBarIndicates)
        },
        {
            key: (0, $kycWk.REDACTIONS_TOUR_TARGETS).SIDEBAR_DETAILS_BUTTON,
            messageId: (0, $kycWk.REDACTIONS_TOUR_MESSAGE_IDS).DETAILS_BUTTON,
            target: (0, $kycWk.REDACTIONS_TOUR_TARGETS).SIDEBAR_DETAILS_BUTTON,
            messageType: (0, $kycWk.MessageType).Transactional,
            heading: formatMessage($cbee4c9267979126$var$i18n.viewRedactionDetails),
            actionsBeforeElement: formatMessage($cbee4c9267979126$var$i18n.stepOfSteps, {
                step: 2,
                steps: 2
            }),
            targetRadius: 100,
            actions: [
                {
                    text: formatMessage($cbee4c9267979126$var$i18n.ok),
                    onClick: end
                }
            ],
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, formatMessage($cbee4c9267979126$var$i18n.goToRedactions), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                href: (0, $kycWk.READ_MORE_URL),
                target: "_blank",
                rel: "noopener noreferrer"
            }, formatMessage($cbee4c9267979126$var$i18n.readMore)))
        }
    ];
};
const $cbee4c9267979126$export$9b351a5d16cec916 = ({ contentId: contentId, step: step, firstStepSource: firstStepSource = (0, $kycWk.RedactionTourStepSource).bodyRedaction })=>{
    const { sidebarControlState: sidebarControlState } = (0, $aWwYt.useObjectSidebarState)();
    const [{ activeSpotlightIndex: activeSpotlightIndex, lastActiveSpotlightIndex: lastActiveSpotlightIndex, firstRedactionIdRendered: firstRedactionIdRendered, firstRedactionRenderedForContentId: firstRedactionRenderedForContentId, titleRedactionRenderedForContentId: titleRedactionRenderedForContentId, firstStepSource: activeFirstStepSource }, { concludeTour: endTour, proceedToNext: proceedToNext, initiateTour: initiateTour, resetTour: resetTour, setFirstRedactionIdRendered: setFirstRedactionIdRendered, setTitleRedactionRenderedForContentId: setTitleRedactionRenderedForContentId }] = (0, $gsf3i.useRedactionsTourState)();
    const isFirstTourTargetVisible = firstStepSource === (0, $kycWk.RedactionTourStepSource).bodyRedaction ? step === 0 && firstRedactionIdRendered && firstRedactionRenderedForContentId === contentId && titleRedactionRenderedForContentId !== contentId : step === 0 && titleRedactionRenderedForContentId === contentId; // otherwise, it's a title redaction
    const isSecondTourTargetVisible = sidebarControlState === 'shown';
    const [contentType] = (0, $ep3mz.useContentType)();
    const canUpdateContent = (0, $2wo33.useCanPerformContentOperation)({
        contentId: contentId ?? '',
        contentType: contentType,
        operation: (0, $lfBMY.OperationTypes).UPDATE
    });
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { data: onboardingStateData, error: onboardingStateError, loading: onboardingStateLoading } = (0, $ivb8S.useGetOnboardingState)($cbee4c9267979126$var$IS_REDACTIONS_TOUR_VISIBLE, false);
    const isTourOnboardingStateCompleted = onboardingStateData?.onboardingState?.some(({ key: key, value: value })=>{
        return key === $cbee4c9267979126$var$IS_REDACTIONS_TOUR_VISIBLE && value === (0, $kycWk.IS_DISMISSED_FLAG);
    });
    const isTourCompleted = !onboardingStateError && !onboardingStateLoading && isTourOnboardingStateCompleted;
    const { Spotlight: Spotlight, SpotlightTarget: SpotlightTarget } = (0, $lsxnT.useChoreographerAssets)();
    const concludeTour = (0, $cozmU.useCallback)(()=>{
        endTour();
        setOnboardingState({
            key: $cbee4c9267979126$var$IS_REDACTIONS_TOUR_VISIBLE,
            value: (0, $kycWk.IS_DISMISSED_FLAG)
        });
    }, [
        endTour,
        setOnboardingState
    ]);
    const initiateTourForSource = (0, $cozmU.useCallback)(()=>{
        initiateTour(firstStepSource);
    }, [
        firstStepSource,
        initiateTour
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (activeSpotlightIndex === null && isFirstTourTargetVisible && isSecondTourTargetVisible && !isTourCompleted && !onboardingStateError && !onboardingStateLoading && isLicensed && canUpdateContent) {
            const timeoutId = setTimeout(()=>{
                initiateTourForSource();
            }, 0);
            return ()=>clearTimeout(timeoutId);
        }
        return undefined;
    }, [
        activeSpotlightIndex,
        initiateTourForSource,
        isFirstTourTargetVisible,
        isSecondTourTargetVisible,
        isTourCompleted,
        onboardingStateError,
        onboardingStateLoading,
        isLicensed,
        canUpdateContent
    ]);
    const spotlights = $cbee4c9267979126$var$useSpotlights({
        next: proceedToNext,
        end: concludeTour,
        tourStartsInTitle: firstStepSource === (0, $kycWk.RedactionTourStepSource).titleRedaction
    });
    const spotlight = spotlights[step];
    const isSpotlightVisible = activeSpotlightIndex === step && (step !== (0, $kycWk.RedactionsTourSteps).FIRST || activeFirstStepSource === firstStepSource);
    const renderMigratedSpotlight = (0, $26Yfd.useStableCallback)((target)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SpotlightTarget, {
            name: spotlight.target
        }, target), isSpotlightVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Spotlight, {
            isMigrated: true,
            dialogPlacement: "bottom right",
            shouldWatchTarget: true,
            targetBgColor: "var(--ds-surface-raised, #FFFFFF)",
            ...spotlight
        }) : null));
    return {
        activeSpotlight: isSpotlightVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Spotlight, {
            dialogPlacement: "bottom right",
            shouldWatchTarget: true // Note: problematic layout shifts for both spotlights
            ,
            targetBgColor: "var(--ds-surface-raised, #FFFFFF)",
            ...spotlights[activeSpotlightIndex]
        }) : null,
        initiateTour: initiateTourForSource,
        proceedToNext: proceedToNext,
        concludeTour: concludeTour,
        resetTour: resetTour,
        renderMigratedSpotlight: renderMigratedSpotlight,
        activeSpotlightIndex: activeSpotlightIndex,
        lastActiveSpotlightIndex: lastActiveSpotlightIndex,
        isTourCompleted: isTourCompleted,
        setFirstRedactionIdRendered: setFirstRedactionIdRendered,
        setTitleRedactionRenderedForContentId: setTitleRedactionRenderedForContentId // Note: mainly here for testing purposes
    };
};
module.exports["useRedactionsTour"] = $cbee4c9267979126$export$9b351a5d16cec916;

});

parcelRegister("gsf3i", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $kycWk = parcelRequire("kycWk");

const $4c2208d3e228490f$var$initialState = {
    firstRedactionIdRendered: null,
    firstRedactionRenderedForContentId: null,
    titleRedactionRenderedForContentId: null,
    firstStepSource: null,
    activeSpotlightIndex: null,
    lastActiveSpotlightIndex: null
};
const $4c2208d3e228490f$var$Store = (0, $8s9DV.createStore)({
    initialState: $4c2208d3e228490f$var$initialState,
    actions: {
        setFirstRedactionIdRendered: (redactionId, contentId)=>({ getState: getState, setState: setState })=>{
                const { firstRedactionIdRendered: firstRedactionIdRendered, firstRedactionRenderedForContentId: firstRedactionRenderedForContentId } = getState();
                if (firstRedactionIdRendered && firstRedactionRenderedForContentId === contentId) return;
                setState({
                    firstRedactionIdRendered: redactionId,
                    firstRedactionRenderedForContentId: contentId ?? null
                });
            },
        setTitleRedactionRenderedForContentId: (contentId)=>({ setState: setState })=>{
                setState({
                    titleRedactionRenderedForContentId: contentId
                });
            },
        clearTitleRedactionRenderedForContentId: (contentId)=>({ getState: getState, setState: setState })=>{
                if (getState().titleRedactionRenderedForContentId !== contentId) return;
                setState({
                    titleRedactionRenderedForContentId: null
                });
            },
        resetTour: ()=>({ setState: setState })=>{
                setState({
                    activeSpotlightIndex: $4c2208d3e228490f$var$initialState.activeSpotlightIndex,
                    lastActiveSpotlightIndex: $4c2208d3e228490f$var$initialState.lastActiveSpotlightIndex,
                    firstStepSource: $4c2208d3e228490f$var$initialState.firstStepSource
                });
            },
        initiateTour: (firstStepSource)=>({ getState: getState, setState: setState })=>{
                const { activeSpotlightIndex: activeSpotlightIndex, firstRedactionRenderedForContentId: firstRedactionRenderedForContentId, titleRedactionRenderedForContentId: titleRedactionRenderedForContentId } = getState();
                if (activeSpotlightIndex !== null) return;
                if (firstStepSource === (0, $kycWk.RedactionTourStepSource).bodyRedaction && titleRedactionRenderedForContentId !== null && firstRedactionRenderedForContentId === titleRedactionRenderedForContentId) return;
                setState({
                    activeSpotlightIndex: 0,
                    firstStepSource: firstStepSource
                });
            },
        proceedToNext: ()=>({ setState: setState, getState: getState })=>{
                const { activeSpotlightIndex: activeSpotlightIndex } = getState();
                if (activeSpotlightIndex === null) return;
                setState({
                    activeSpotlightIndex: activeSpotlightIndex + 1,
                    lastActiveSpotlightIndex: activeSpotlightIndex
                });
            },
        concludeTour: ()=>({ setState: setState, getState: getState })=>{
                const { activeSpotlightIndex: activeSpotlightIndex } = getState();
                setState({
                    activeSpotlightIndex: null,
                    lastActiveSpotlightIndex: activeSpotlightIndex,
                    firstStepSource: $4c2208d3e228490f$var$initialState.firstStepSource
                });
            }
    }
});
const $4c2208d3e228490f$export$4e8589b303f4384d = (0, $kBr4q.createHook)($4c2208d3e228490f$var$Store);
const $4c2208d3e228490f$export$b121a589d2d05ff2 = (0, $kBr4q.createActionsHook)($4c2208d3e228490f$var$Store);
const $4c2208d3e228490f$export$f2a6ed6b1eb18db8 = (0, $kBr4q.createStateHook)($4c2208d3e228490f$var$Store, {
    selector: (state)=>state.activeSpotlightIndex !== null
});
module.exports["useRedactionsTourState"] = $4c2208d3e228490f$export$4e8589b303f4384d;
module.exports["useRedactionsTourActions"] = $4c2208d3e228490f$export$b121a589d2d05ff2;

});

parcelRegister("2MwVI", function(module, exports) {

var $635s2 = parcelRequire("635s2");


var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $aMcHK = parcelRequire("aMcHK");


var $7Sm4c = parcelRequire("7Sm4c");


var $gsf3i = parcelRequire("gsf3i");

const $49bfbfa6f9c85bf2$export$ea561d273e8cda71 = "\u2588\u2588\u2588\u2588";
const $49bfbfa6f9c85bf2$var$TITLE_REDACTION_WITH_ID_PATTERN = /██\s*\[ID:[^\]]+\]/u;
const $49bfbfa6f9c85bf2$var$doesTitleContainCurrentRedactionString = (title)=>Boolean(title && $49bfbfa6f9c85bf2$var$TITLE_REDACTION_WITH_ID_PATTERN.test(title));
const $49bfbfa6f9c85bf2$var$doesTitleContainLegacyRedactionString = (title)=>Boolean(title && title.includes($49bfbfa6f9c85bf2$export$ea561d273e8cda71));
const $49bfbfa6f9c85bf2$export$d7a7fedf1f7b03e1 = (title)=>{
    return $49bfbfa6f9c85bf2$var$doesTitleContainLegacyRedactionString(title) || $49bfbfa6f9c85bf2$var$doesTitleContainCurrentRedactionString(title);
};
const $49bfbfa6f9c85bf2$export$19187316a5e6c180 = ({ contentId: contentId, title: title })=>{
    const { clearTitleRedactionRenderedForContentId: clearTitleRedactionRenderedForContentId, setTitleRedactionRenderedForContentId: setTitleRedactionRenderedForContentId } = (0, $gsf3i.useRedactionsTourActions)();
    const titleHasCurrentRedaction = (0, $cozmU.useMemo)(()=>$49bfbfa6f9c85bf2$var$doesTitleContainCurrentRedactionString(title), [
        title
    ]);
    const titleMaybeHasLegacyRedaction = (0, $cozmU.useMemo)(()=>!titleHasCurrentRedaction && $49bfbfa6f9c85bf2$var$doesTitleContainLegacyRedactionString(title), [
        title,
        titleHasCurrentRedaction
    ]);
    const { data: data, error: redactionsCountError } = (0, $jMyy4.useQueryInterop)((0, $635s2.default), {
        skip: !titleMaybeHasLegacyRedaction,
        variables: {
            contentId: contentId
        },
        errorPolicy: 'all',
        __callerPackage__: "redactions"
    });
    // handle 4xx errors
    (0, $cozmU.useEffect)(()=>{
        if (redactionsCountError && (0, $aMcHK.isStatusCodeError)(redactionsCountError, '404')) (0, $7Sm4c.markErrorAsHandled)(redactionsCountError);
    }, [
        redactionsCountError
    ]);
    const redactionsCount = data?.singleContent?.redactionMetadataCount ?? 0;
    const isTitleRedactionConfirmed = titleHasCurrentRedaction || titleMaybeHasLegacyRedaction && redactionsCount > 0;
    (0, $cozmU.useEffect)(()=>{
        if (contentId && isTitleRedactionConfirmed) setTitleRedactionRenderedForContentId(contentId);
        return ()=>{
            clearTitleRedactionRenderedForContentId(contentId);
        };
    }, [
        clearTitleRedactionRenderedForContentId,
        contentId,
        isTitleRedactionConfirmed,
        setTitleRedactionRenderedForContentId
    ]);
};
module.exports["useTrackTitleRedactionRendered"] = $49bfbfa6f9c85bf2$export$19187316a5e6c180;

});

parcelRegister("635s2", function(module, exports) {
/**
 * @generated SignedSource<<a0a12f229cf3db623a511192bab87885>>
 * @relayHash a2231280d1a64c0467ba87a246116380
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5ebec3823398761cbff8ccd89859729728b177003609485a43378ea74e2188e9
const $a51c9ec4f18af0fc$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "redactionMetadataCount"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useTrackTitleRedactionRenderedRedactionsCountQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useTrackTitleRedactionRenderedRedactionsCountQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "a2231280d1a64c0467ba87a246116380",
            "id": "5ebec3823398761cbff8ccd89859729728b177003609485a43378ea74e2188e9",
            "metadata": {},
            "name": "useTrackTitleRedactionRenderedRedactionsCountQuery",
            "operationKind": "query",
            "text": "query useTrackTitleRedactionRenderedRedactionsCountQuery($contentId:ID!){singleContent(id:$contentId){id,redactionMetadataCount}}"
        }
    };
}();
$a51c9ec4f18af0fc$var$node.hash = "f9a742b4e2840cd061fc6915ae9b6b93";
var $a51c9ec4f18af0fc$export$2e2bcd8739ae039 = $a51c9ec4f18af0fc$var$node;
module.exports["default"] = $a51c9ec4f18af0fc$export$2e2bcd8739ae039;

});

parcelRegister("7xnK2", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $57ce080eaea1a7ac$var$Placeholder = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_39xV02HZdu _0jFU0Vv6H3",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $57ce080eaea1a7ac$export$14728599fd1e0142 = ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($57ce080eaea1a7ac$var$Placeholder, null);
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
module.exports["ContentTitlePlaceholder"] = $57ce080eaea1a7ac$export$14728599fd1e0142;

});

parcelRegister("eP7b6", function(module, exports) {
/**
 * @generated SignedSource<<293007c6777799aa33e10204d25d472b>>
 * @relayHash 002ee32db0695a9b63af69a407a07639
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5d8fe2acb674a13f635de2de38cd556b5d67fea5e30e200be8bdac0269751a54
const $0ba271c76ca4c8d2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "key"
    }, v3 = {
        "kind": "ScalarField",
        "name": "value"
    }, v4 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                }
            ]
        }
    ], v5 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "title"
                },
                {
                    "alias": "appearancePublished",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "key",
                            "value": "content-appearance-published"
                        }
                    ],
                    "concreteType": "PaginatedJsonContentPropertyList",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": v4 /*: any*/ ,
                    "storageKey": "properties(key:\"content-appearance-published\")"
                },
                {
                    "alias": "emojiTitlePublished",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "key",
                            "value": "emoji-title-published"
                        }
                    ],
                    "concreteType": "PaginatedJsonContentPropertyList",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": v4 /*: any*/ ,
                    "storageKey": "properties(key:\"emoji-title-published\")"
                },
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "key",
                            "value": "editor"
                        }
                    ],
                    "concreteType": "PaginatedJsonContentPropertyList",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JsonContentProperty",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ ,
                                v3 /*: any*/ 
                            ]
                        }
                    ],
                    "storageKey": "properties(key:\"editor\")"
                },
                {
                    "concreteType": "ContentMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                            "kind": "LinkedField",
                            "name": "frontend",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "fabricEditorSupported"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentTitleExternalQuery",
            "selections": v5 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentTitleExternalQuery",
            "selections": v5 /*: any*/ 
        },
        "params": {
            "cacheID": "002ee32db0695a9b63af69a407a07639",
            "id": "5d8fe2acb674a13f635de2de38cd556b5d67fea5e30e200be8bdac0269751a54",
            "metadata": {},
            "name": "ContentTitleExternalQuery",
            "operationKind": "query",
            "text": "query ContentTitleExternalQuery($contentId:ID!){singleContent(id:$contentId){id,title,appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},emojiTitlePublished:properties(key:\"emoji-title-published\"){nodes{id,key,value,version{number}}},properties(key:\"editor\"){nodes{id,key,value}},metadata{frontend{fabricEditorSupported}}}}"
        }
    };
}();
$0ba271c76ca4c8d2$var$node.hash = "99403818c8d620c95107a7fed0ae3cd7";
var $0ba271c76ca4c8d2$export$2e2bcd8739ae039 = $0ba271c76ca4c8d2$var$node;
module.exports["default"] = $0ba271c76ca4c8d2$export$2e2bcd8739ae039;

});

parcelRegister("ds2ZC", function(module, exports) {

let $9cb036305994698d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9cb036305994698d$var$load("5odbj"),
    $9cb036305994698d$var$load("frTOf")
]).then(()=>parcelRequire('8taxc'));

});

parcelRegister("bX4Zr", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $2FsQH = parcelRequire("2FsQH");


var $7zgzO = parcelRequire("7zgzO");

const $5437b70689f01310$var$useUnload = (fn)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    let t1;
    if ($[0] !== fn) {
        t0 = ()=>{
            window.addEventListener("beforeunload", fn);
            return ()=>{
                window.removeEventListener("beforeunload", fn);
            };
        };
        t1 = [
            fn
        ];
        $[0] = fn;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $cozmU.useEffect)(t0, t1);
};
function $5437b70689f01310$export$e38025aebea82d38(contentId, storageKeySuffix) {
    const $ = (0, $bDgLe.c)(7);
    const { getHash: getHash } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const hashRef = (0, $cozmU.useRef)(getHash);
    let t0;
    let t1;
    if ($[0] !== contentId || $[1] !== storageKeySuffix) {
        t0 = ()=>{
            (0, $2FsQH.restoreScrollPositionIfNeeded)({
                contentId: contentId,
                isInViewPage: true,
                contentReadyState: 1,
                docObject: document,
                winObject: window,
                hash: hashRef.current(),
                storageKeySuffix: storageKeySuffix
            });
        };
        t1 = [
            contentId,
            storageKeySuffix
        ];
        $[0] = contentId;
        $[1] = storageKeySuffix;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    if ($[4] !== contentId || $[5] !== storageKeySuffix) {
        t2 = ()=>{
            (0, $2FsQH.persistRelativeScrollPosition)({
                contentId: contentId,
                isInViewPage: true,
                docObject: document,
                winObject: window,
                storageKeySuffix: storageKeySuffix
            });
        };
        $[4] = contentId;
        $[5] = storageKeySuffix;
        $[6] = t2;
    } else t2 = $[6];
    $5437b70689f01310$var$useUnload(t2);
}
module.exports["useViewPagePersistentScrollPosition"] = $5437b70689f01310$export$e38025aebea82d38;

});

parcelRegister("2FsQH", function(module, exports) {

var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $5ZqQS = parcelRequire("5ZqQS");


var $id4ij = parcelRequire("id4ij");

const $0318c9ad181ada0b$export$b2593172c1a4a4fd = (els)=>{
    const result = [];
    // use `Array.some` to stop the loop sooner.
    if (els) {
        for(let index = 0; index < els.length; index++)if ((0, $id4ij.isPartOfElementStillInViewPort)(els[index])) result.push({
            targetElementIndex: index,
            visibleBlockEl: els[index]
        });
    }
    return result;
};
const $0318c9ad181ada0b$export$9639f4e44d5443af = (els)=>{
    const visibleEls = $0318c9ad181ada0b$export$b2593172c1a4a4fd(els);
    let elHasTopVisible = null;
    const foundVisible = visibleEls.some((item)=>{
        if ((0, $id4ij.isTopOfElementStillInViewPort)(item.visibleBlockEl)) {
            elHasTopVisible = item;
            return true;
        }
        return false;
    });
    // in the worst case, return first element which is still in viewport
    if (!foundVisible && visibleEls.length > 0) return visibleEls[0];
    // a default value which indicates that no element is in viewport
    const noElementValue = {
        targetElementIndex: -1,
        visibleBlockEl: null
    };
    return elHasTopVisible || noElementValue;
};
const $0318c9ad181ada0b$export$f506f531b96875f7 = (columns)=>{
    const result = {
        targetElementIndexInColumn: -1,
        columnIndex: -1,
        // visible block element in target column
        visibleBlockEl: null
    };
    // usage of .some iterator without using its return value is considered a bug.
    for(let index = 0; index < columns.length; index++){
        const { visibleBlockEl: visibleBlockEl, targetElementIndex: targetElementIndex } = $0318c9ad181ada0b$export$9639f4e44d5443af(columns[index].children);
        if (visibleBlockEl) {
            result.columnIndex = index;
            result.targetElementIndexInColumn = targetElementIndex;
            result.visibleBlockEl = visibleBlockEl;
            break;
        }
    }
    return result;
};
const $0318c9ad181ada0b$export$7256c638fbf51d15 = (elContainer)=>{
    if (!elContainer) return false;
    const firstChildEl = elContainer.children[0];
    return firstChildEl && firstChildEl.classList.contains('contentLayout2');
};
function $0318c9ad181ada0b$export$2bc8e9ae2ef96ba4(elContainer, scrollY) {
    if (scrollY === 0 || elContainer === null) return null;
    const viewPositionData = {
        // index of block element in page, we call it as target element
        targetElementIndex: -1,
        // number of pixels from top of target element to current scroll position
        offsetBetweenTargetAndCurrentScroll: 0,
        // in case page has column layout, we need to save extra info.
        columnLayoutPosition: {
            columnIndex: -1,
            rowIndex: -1
        }
    };
    if (!$0318c9ad181ada0b$export$7256c638fbf51d15(elContainer)) {
        // easy in case page does not have column layout
        const { targetElementIndex: targetElementIndex, visibleBlockEl: visibleBlockEl } = $0318c9ad181ada0b$export$9639f4e44d5443af(elContainer.children);
        if (visibleBlockEl) {
            viewPositionData.targetElementIndex = targetElementIndex;
            viewPositionData.offsetBetweenTargetAndCurrentScroll = scrollY - (0, $id4ij.getElementTop)(visibleBlockEl);
            // don't need column layout data
            delete viewPositionData.columnLayoutPosition;
        }
    } else {
        // page has column layout so page content starts from first element
        const startPageContent = elContainer.children[0];
        const rows = startPageContent.children;
        // find visible row.
        const { targetElementIndex: rowIndex, visibleBlockEl: visibleRow } = $0318c9ad181ada0b$export$9639f4e44d5443af(rows);
        if (visibleRow && visibleRow.getElementsByClassName) {
            const columns = visibleRow.getElementsByClassName('innerCell');
            const { columnIndex: columnIndex, targetElementIndexInColumn: targetElementIndexInColumn, visibleBlockEl: visibleBlockInColumn } = $0318c9ad181ada0b$export$f506f531b96875f7(columns);
            if (visibleBlockInColumn) {
                viewPositionData.targetElementIndex = targetElementIndexInColumn;
                viewPositionData.offsetBetweenTargetAndCurrentScroll = scrollY - (0, $id4ij.getElementTop)(visibleBlockInColumn);
                viewPositionData.columnLayoutPosition = {
                    rowIndex: rowIndex,
                    columnIndex: columnIndex
                };
            }
        }
    }
    return viewPositionData.targetElementIndex !== -1 ? viewPositionData : null;
}
const $0318c9ad181ada0b$export$c3e0418bbdcd04e9 = (options)=>{
    const { contentId: contentId, isInViewPage: isInViewPage, docObject: // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    docObject = document, winObject: winObject = window, storageKeySuffix: storageKeySuffix = '' } = options;
    let mainContentEl;
    if (isInViewPage) // in view page
    mainContentEl = docObject.getElementById((0, $1UApO.keys).ID_START_CONTENT_IN_VIEW_PAGE);
    else // in edit page
    mainContentEl = docObject.body;
    const scrollPosition = $0318c9ad181ada0b$export$2bc8e9ae2ef96ba4(mainContentEl, winObject.pageYOffset);
    const persistScrollKey = (0, $1UApO.keys).PERSIST_SCROLL_POSITION_IN_VIEW_PAGE + contentId + storageKeySuffix;
    if (scrollPosition) {
        // add extra information so that when we do restoring, the data is safer
        scrollPosition.contentId = contentId;
        scrollPosition.isInViewPage = isInViewPage;
        (0, $17wUi.confluenceSessionStorageInstance).setItem(persistScrollKey, JSON.stringify(scrollPosition));
    } else {
        // when the scroll position is at the very top (default)
        // the scrollPosition is null, and we must check if there is a persisted value to avoid
        // the page from jumping
        const storedPosition = (0, $17wUi.confluenceSessionStorageInstance).getItem(persistScrollKey);
        if (storedPosition) (0, $17wUi.confluenceSessionStorageInstance).removeItem(persistScrollKey);
    }
};
const $0318c9ad181ada0b$export$a9f5dc6d645cb9a8 = (options)=>{
    const { contentId: contentId, isInViewPage: isInViewPage, contentReadyState: contentReadyState = 0, docObject: // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    docObject = document, winObject: winObject = window, hash: hash, storageKeySuffix: storageKeySuffix = '' } = options;
    const persistScrollKey = (0, $1UApO.keys).PERSIST_SCROLL_POSITION_IN_VIEW_PAGE + contentId + storageKeySuffix;
    let savedPosition = (0, $17wUi.confluenceSessionStorageInstance).getItem(persistScrollKey);
    try {
        savedPosition = JSON.parse(savedPosition);
        if (hash) {
            const decodeHash = decodeURIComponent(hash);
            const el = docObject.getElementById(decodeHash);
            const scrollPosition = el?.getBoundingClientRect().top;
            scrollPosition && winObject.scrollTo({
                top: scrollPosition
            });
        }
    } catch (error) {
        // could not parse the savedPosition or
        // anchor is invalid, may contain UTF-8 encoding of emoji which does not nice map back to the querySelector
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: 'backbone'
        });
    } finally{
        // removing the persisted scroll position here would cause the scroll position to jump
        // since this function should get called when content is and is not ready during SSR to SPA.
        // ideally we will use local storage values on SSR
        // however, when the content is READY (1) there is no need to persist the position
        if (contentReadyState === 1) (0, $17wUi.confluenceSessionStorageInstance).removeItem(persistScrollKey);
    }
    if (hash || // hash exists in the url, window already scrolled to the element in view
    !savedPosition || // does not match contentId so this data is invalid
    savedPosition.contentId !== contentId) return;
    let contentWrapper;
    if (isInViewPage) contentWrapper = docObject.getElementById((0, $1UApO.keys).ID_START_CONTENT_IN_VIEW_PAGE);
    else // inside editor iframe, content starts from body tag
    contentWrapper = docObject.body;
    if (!contentWrapper || !contentWrapper.children[0]) return;
    const { columnLayoutPosition: columnLayoutPosition } = savedPosition;
    let targetElement;
    if (columnLayoutPosition) {
        // page have layout
        const startEditorContent = contentWrapper.children[0];
        const targetRow = startEditorContent.children[columnLayoutPosition.rowIndex];
        const columns = targetRow?.getElementsByClassName('innerCell');
        const targetColumn = columns?.[columnLayoutPosition.columnIndex];
        targetElement = targetColumn && targetColumn?.children?.[savedPosition.targetElementIndex];
    } else // page does not have layout
    targetElement = contentWrapper.children[savedPosition.targetElementIndex];
    if (targetElement) {
        const topOffset = (0, $id4ij.getElementTop)(targetElement);
        const offset = savedPosition.offsetBetweenTargetAndCurrentScroll;
        let newPosition = topOffset + offset;
        // start scrolling to avoid jumping to the top of the page.
        if (isInViewPage) {
            const maxScrollHeight = docObject?.querySelector?.('#main-content')?.clientHeight || 0;
            newPosition = Math.min(maxScrollHeight, newPosition);
        }
        winObject.scrollTo(0, newPosition);
    }
};
module.exports["persistRelativeScrollPosition"] = $0318c9ad181ada0b$export$c3e0418bbdcd04e9;
module.exports["restoreScrollPositionIfNeeded"] = $0318c9ad181ada0b$export$a9f5dc6d645cb9a8;

});

parcelRegister("gsWjA", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $hDLmU = parcelRequire("hDLmU");


var $c411D = parcelRequire("c411D");


var $jOO7o = parcelRequire("jOO7o");


var $bQm3c = parcelRequire("bQm3c");


var $iFjdQ = parcelRequire("iFjdQ");


var $lSOAM = parcelRequire("lSOAM");

var $fQ3iN = parcelRequire("fQ3iN");

var $i3c1S = parcelRequire("i3c1S");


var $5q601 = parcelRequire("5q601");


var $1UCmC = parcelRequire("1UCmC");


var $jX1qB = parcelRequire("jX1qB");


var $lXYVJ = parcelRequire("lXYVJ");


var $6VdZc = parcelRequire("6VdZc");

var $7fw2E = parcelRequire("7fw2E");


var $7sK8i = parcelRequire("7sK8i");


var $8w1c1 = parcelRequire("8w1c1");

parcelRequire("1InRL");
var $hlP5l = parcelRequire("hlP5l");


var $5qUgM = parcelRequire("5qUgM");


var $1q7H7 = parcelRequire("1q7H7");


var $aWrnw = parcelRequire("aWrnw");


var $5YLPl = parcelRequire("5YLPl");


var $fgdVB = parcelRequire("fgdVB");


var $itS9i = parcelRequire("itS9i");


var $6mKj3 = parcelRequire("6mKj3");


var $5vi32 = parcelRequire("5vi32");


var $5ZqQS = parcelRequire("5ZqQS");


var $dtDUi = parcelRequire("dtDUi");

const $a99ff50c139ee598$var$baseConfig = {
    slo: {
        // based on production p90
        fmp: {
            initial: {
                threshold: 14300
            },
            transition: {
                threshold: 3200
            }
        },
        tti: {
            initial: {
                threshold: 14300
            },
            transition: {
                threshold: 3200
            }
        }
    },
    histogram: {
        // based on pre-production pollinator and prod p90
        initial: {
            fmp: '5000_6000_7000_8000_10000_12000_14000',
            tti: '5000_6000_7000_8000_10000_12000_14000'
        },
        transition: {
            fmp: '2000_2500_3000_3500_4000_4500_5000',
            tti: '2000_2500_3000_3500_4000_4500_5000'
        }
    },
    timings: [
        // breakdowns in order of occurrence
        {
            key: 'html',
            endMark: 'html'
        },
        {
            key: 'appLoad',
            startMark: 'html',
            endMark: 'app'
        },
        {
            key: 'appRootRender',
            startMark: 'app',
            endMark: 'root-component-render'
        },
        {
            key: 'routerMatched',
            startMark: 'root-component-render',
            endMark: 'route-manager-initialized'
        }
    ]
};
const $a99ff50c139ee598$var$NOOP = ()=>{};
const $a99ff50c139ee598$export$2d5e2a82ee58820b = ({ isLite: isLite, isInitialLoad: isInitialLoad })=>{
    if (isLite) return [
        (0, $hlP5l.BYLINE_METRIC),
        (0, $hlP5l.CONTENT_TITLE_METRIC),
        (0, $5YLPl.CONTENT_RENDERER_METRIC)
    ];
    const segments = [
        // New metric adding to this list should also be added to fmpAsUntilStopTimeMetrics
        // See comments in fmpAsUntilStopTimeMetrics for more information
        (0, $hlP5l.BYLINE_METRIC),
        (0, $hlP5l.CONTENT_TITLE_METRIC),
        (0, $5YLPl.CONTENT_RENDERER_METRIC),
        $a99ff50c139ee598$export$e190581c76254e9
    ];
    segments.push((0, $fgdVB.OBJECT_SIDEBAR_CONTROL_METRIC));
    segments.push((0, $5qUgM.OBJECT_HEADER_SEGMENT_METRIC));
    if (isInitialLoad) {
        segments.push((0, $8w1c1.APP_NAVIGATION_METRIC), (0, $aWrnw.SPACE_NAVIGATION_METRIC));
        segments.push((0, $1q7H7.PAGE_TREE_METRIC));
    }
    return segments;
};
/**
 * fmpAsUntilStopTimeMetrics
 *
 * UPDATE 2025-04-29: TTI is deprecated. Going forward, new segments should be included here by default in order to
 * preserve the original TTI definition. Segments should be included even if they are not minimally interactive.
 *
 * What is minimally interactive?
 * Minimally interactive during the SSR phase at it's core, is determined if the component/element is clickable,
 * can register the action, and display a visual response that the action has been received.
 * The SSR phase can be stalled by appending ?NO_SPA=1 at the end of a CONNIE url.
 *
 * I.E. If you click on an inline comment/highlight, the click is registered, and displays a loading sidebar component.
 *
 * If a required segment is SSR'd and determined to be minimally interactive at FMP, ADD TO THIS LIST
 * If a required segment is SSR'd but determined to NOT be minimally interactive at FMP, DO NOT ADD TO THIS LIST
 * If a required segment is yet to be SSR'd, this config will not update TTI for that segment, by default is OFF.
 *
 * CONTEXT
 * the returned segments are considered to be minimally interactive during SSR
 * hence we want to use FMP (ssr-ttr mark)
 *
 * PageSegment TTI is measured: useFmpAsUntilStopTime ? FMP : Eventual load time
 * Content-renderer TTI: macros are SSRed ? FMP : Eventual Load Time
 *
 * View Page TTI is measured: Math.max(Non SSR PageSegments TTI, Content-renderer TTI)
 *
 */ const $a99ff50c139ee598$var$fmpAsUntilStopTimeMetrics = ({ isLite: isLite })=>{
    if (isLite) return [
        (0, $jX1qB.BYLINE_SEGMENT_KEY),
        (0, $jX1qB.CONTENT_TITLE_SEGMENT_KEY)
    ];
    return [
        (0, $jX1qB.BYLINE_SEGMENT_KEY),
        (0, $jX1qB.CONTENT_TITLE_SEGMENT_KEY),
        (0, $jX1qB.APP_NAVIGATION_SEGMENT_KEY),
        (0, $jX1qB.SPACE_NAVIGATION_SEGMENT_KEY),
        (0, $jX1qB.PAGE_TREE_SEGMENT_KEY),
        (0, $jX1qB.FAVOURITE_BUTTON_SEGMENT_KEY),
        (0, $jX1qB.RESTRICTIONS_BUTTON_SEGMENT_KEY),
        (0, $jX1qB.WATCH_BUTTON_SEGMENT_KEY),
        (0, $jX1qB.VIEW_PAGE_CONTAINER_SEGMENT_KEY),
        (0, $jX1qB.OBJECT_HEADER_SEGMENT_KEY),
        (0, $jX1qB.OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY)
    ];
};
const $a99ff50c139ee598$export$acf5746d268ae4ee = (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { contentId: contentId, isLite: isLite, customConfig: customConfig } = t0;
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const pageLoadMetricRef = (0, $cozmU.useRef)();
    const sendMetrics = (0, $c411D.useEmbeddedConfluenceEventMarkers)();
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== customConfig?.expectedPageLoadSegments || $[2] !== customConfig?.fmpUntilStopTimeMetrics || $[3] !== customConfig?.pageLoadKey || $[4] !== isEmbeddedConfluence || $[5] !== isLite || $[6] !== sendMetrics) {
        t1 = ()=>{
            const _isInitialLoad = (0, $6VdZc.isInitial)();
            const expectedPageSegments = customConfig?.expectedPageLoadSegments ?? $a99ff50c139ee598$export$2d5e2a82ee58820b({
                isInitialLoad: _isInitialLoad,
                isLite: isLite
            });
            if (0, $itS9i.debuggerEnabled) (0, $itS9i.cacheExpectedViewPageSegments)(expectedPageSegments);
            (0, $iFjdQ.ExperienceActionMeasures).markMeasureStart((0, $5q601.VIEW_EDIT_BUTTON_CLICKED_ACTION));
            const untilExperienceMetricNames = customConfig?.fmpUntilStopTimeMetrics ?? $a99ff50c139ee598$var$fmpAsUntilStopTimeMetrics({
                isLite: isLite
            });
            const untilPageSegments = expectedPageSegments.map((segment)=>({
                    experience: segment,
                    useFmpAsUntilStopTime: untilExperienceMetricNames.includes(segment.key)
                }));
            pageLoadMetricRef.current = (0, $lSOAM.createPageLoadMetric)({
                ...$a99ff50c139ee598$var$baseConfig,
                key: customConfig?.pageLoadKey ?? (0, $1UCmC.VIEW_PAGE_LOAD_KEY),
                timings: [
                    ...$a99ff50c139ee598$var$baseConfig.timings,
                    ...(0, $i3c1S.getWaterfallTimings)(expectedPageSegments)
                ],
                include: expectedPageSegments,
                until: untilPageSegments
            });
            if (!_isInitialLoad) expectedPageSegments.forEach($a99ff50c139ee598$var$_temp);
            pageLoadMetricRef.current.startPageLoad();
            pageLoadMetricRef.current.onStop((0, $7fw2E.markBrowserMetricEnd).bind(null, pageLoadMetricRef.current), $a99ff50c139ee598$var$NOOP);
            pageLoadMetricRef.current.onStop((0, $7sK8i.resumeLowPriorityEvents), (0, $7sK8i.resumeLowPriorityEvents));
            pageLoadMetricRef.current.onStop((0, $lXYVJ.resetViewTransitionSource), (0, $lXYVJ.resetViewTransitionSource));
            pageLoadMetricRef.current.onStop(()=>{
                if (isEmbeddedConfluence) {
                    const observableObject = (0, $jOO7o.getIframeObservable_DO_NOT_USE)();
                    const uniqueKey = observableObject?.object?.uniqueKey;
                    sendMetrics({
                        timestamp: Date.now(),
                        customData: uniqueKey ? {
                            uniqueKey: uniqueKey
                        } : {}
                    }, `${(0, $hDLmU.EMBEDDED_CONFLUENCE_METRICS_PREFIX)}${(0, $hDLmU.EMBEDDED_VIEW_TTI)}`);
                }
            }, $a99ff50c139ee598$var$NOOP);
            pageLoadMetricRef.current.onStop(()=>{
                if (_isInitialLoad && Boolean(window.__HYDRATION_FAILED__)) {
                    const { error: errorWithRoute, route: route } = (0, $dtDUi.getHydrationErrorWithRoute)(window.location.toString());
                    if (window.__HYDRATION_ERRORS__ && window.__HYDRATION_ERRORS__.length > 0) {
                        const monitoringClient = (0, $5ZqQS.getMonitoringClient)();
                        window.__HYDRATION_ERRORS__.forEach((error)=>{
                            if (error.type) {
                                const normalizedType = error.type.startsWith("UNSAFE_") ? error.type.slice(7) : error.type;
                                monitoringClient.incrementCounter("hydrationErrorCount", [
                                    `type:${normalizedType}`,
                                    `route:${route}`
                                ]);
                            }
                        });
                    }
                    if ((0, $6mKj3.expVal)("confluence_frontend_hydration_failure_reporting", "isEnabled", false)) createAnalyticsEvent((0, $dtDUi.getHydrationFailureOperationalEvent)({
                        source: "viewPageCommon",
                        route: route,
                        errorWithRoute: errorWithRoute,
                        isSSRReactStreaming: Boolean(window.__SSR_REACT_STREAMING__)
                    })).fire();
                    else (0, $5ZqQS.getMonitoringClient)().submitError(errorWithRoute, {
                        attribution: "hydration"
                    });
                }
            }, $a99ff50c139ee598$var$NOOP);
            pageLoadMetricRef.current.onStop(()=>{
                if (_isInitialLoad && Boolean(window.__HYDRATION_FAILED__) && Boolean(window.__SSR_REACT_STREAMING__) && !(0, $6mKj3.expVal)("confluence_frontend_hydration_failure_reporting", "isEnabled", false)) {
                    const { error: errorWithRoute_0 } = (0, $dtDUi.getHydrationErrorWithRoute)(window.location.toString());
                    (0, $5ZqQS.getMonitoringClient)().submitError(errorWithRoute_0, {
                        attribution: "streaming-hydration"
                    });
                }
            }, $a99ff50c139ee598$var$NOOP);
            return ()=>{
                pageLoadMetricRef.current?.cancel();
            };
        };
        $[0] = createAnalyticsEvent;
        $[1] = customConfig?.expectedPageLoadSegments;
        $[2] = customConfig?.fmpUntilStopTimeMetrics;
        $[3] = customConfig?.pageLoadKey;
        $[4] = isEmbeddedConfluence;
        $[5] = isLite;
        $[6] = sendMetrics;
        $[7] = t1;
    } else t1 = $[7];
    let t2;
    if ($[8] !== contentId || $[9] !== createAnalyticsEvent || $[10] !== customConfig || $[11] !== isEmbeddedConfluence || $[12] !== isLite || $[13] !== sendMetrics || $[14] !== userId) {
        t2 = [
            contentId,
            customConfig,
            userId,
            isLite,
            isEmbeddedConfluence,
            sendMetrics,
            createAnalyticsEvent
        ];
        $[8] = contentId;
        $[9] = createAnalyticsEvent;
        $[10] = customConfig;
        $[11] = isEmbeddedConfluence;
        $[12] = isLite;
        $[13] = sendMetrics;
        $[14] = userId;
        $[15] = t2;
    } else t2 = $[15];
    (0, $cozmU.useEffect)(t1, t2);
    return null;
};
const $a99ff50c139ee598$export$e190581c76254e9 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.VIEW_PAGE_CONTAINER_SEGMENT_KEY),
    ssr: window.__SSR_RENDERED__ ? {
        doneAsFmp: true
    } : undefined
});
function $a99ff50c139ee598$var$_temp(m) {
    return m.startFromPageLoad();
}
module.exports["VIEW_PAGE_CONTAINER_METRIC"] = $a99ff50c139ee598$export$e190581c76254e9;
module.exports["StartViewPageLoad"] = $a99ff50c139ee598$export$acf5746d268ae4ee;

});

parcelRegister("c411D", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");

const $351b756af5d314b8$export$6654a9a4dc3a2802 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return $351b756af5d314b8$var$_temp;
} : ()=>{
    return (0, $cozmU.useCallback)((payload, type)=>{
        window.parent.postMessage({
            type: type,
            payload: payload
        }, '*');
    }, []);
};
function $351b756af5d314b8$var$_temp(payload, type) {
    window.parent.postMessage({
        type: type,
        payload: payload
    }, "*");
}
module.exports["useEmbeddedConfluenceEventMarkers"] = $351b756af5d314b8$export$6654a9a4dc3a2802;

});

parcelRegister("lSOAM", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable no-restricted-syntax */ 
var $iDdTC = parcelRequire("iDdTC");


var $8RwKN = parcelRequire("8RwKN");


var $64KID = parcelRequire("64KID");


var $fQ3iN = parcelRequire("fQ3iN");


var $i3c1S = parcelRequire("i3c1S");

const $2a47a9fc48674e91$export$d539c641d560c25d = new Set([
    (0, $64KID.namedRoutes).CREATE_BLOG.name,
    (0, $64KID.namedRoutes).CREATE_BLOG_ACTION_LEGACY.name,
    (0, $64KID.namedRoutes).CREATE_PAGE.name,
    (0, $64KID.namedRoutes).CREATE_PAGE_ACTION_LEGACY.name,
    (0, $64KID.namedRoutes).EDIT_BLOG.name,
    (0, $64KID.namedRoutes).EDIT_BLOG_V2.name,
    (0, $64KID.namedRoutes).EDIT_PAGE.name,
    (0, $64KID.namedRoutes).EDIT_PAGE_V2.name,
    (0, $64KID.namedRoutes).EDIT_PAGE_EMBED.name,
    (0, $64KID.namedRoutes).VIEW_PAGE.name,
    (0, $64KID.namedRoutes).VIEW_BLOG.name,
    (0, $64KID.namedRoutes).VIEW_BLOG_DATE_LEGACY.name,
    (0, $64KID.namedRoutes).SPACE_INDEX.name,
    (0, $64KID.namedRoutes).SPACE_OVERVIEW.name,
    (0, $64KID.namedRoutes).TEMPLATE_GALLERY.name,
    (0, $64KID.namedRoutes).CONTENT_HISTORY.name,
    (0, $64KID.namedRoutes).ADVANCED_SEARCH.name,
    (0, $64KID.namedRoutes).HOME.name,
    (0, $64KID.namedRoutes).SPACE_DIRECTORY.name,
    (0, $64KID.namedRoutes).SPACE_PAGES.name
]);
const $2a47a9fc48674e91$export$9dede01b6f349441 = (match)=>{
    if (!match) return false;
    return $2a47a9fc48674e91$export$d539c641d560c25d.has(match.name);
};
const $2a47a9fc48674e91$export$cb339d0cd5cc821c = ()=>{
    const currentMetric = (0, $8RwKN.browserMetrics).getPageLoadMetric();
    return currentMetric.getData().start !== null;
};
const $2a47a9fc48674e91$export$c5aa7fcaede4a84d = (0, $iDdTC.metrics).pageLoad;
const $2a47a9fc48674e91$export$19ba7be4fcf34f3d = (0, $iDdTC.metrics).custom;
const $2a47a9fc48674e91$export$36d7a61d0660e29c = (0, $iDdTC.metrics).interaction;
const $2a47a9fc48674e91$var$concurrent = (0, $iDdTC.metrics).concurrent;
const $2a47a9fc48674e91$export$9db2e0f538bb10fa = $2a47a9fc48674e91$var$concurrent.custom;
module.exports["createPageLoadMetric"] = $2a47a9fc48674e91$export$c5aa7fcaede4a84d;
module.exports["createCustomMetric"] = $2a47a9fc48674e91$export$19ba7be4fcf34f3d;
module.exports["createInteractionMetric"] = $2a47a9fc48674e91$export$36d7a61d0660e29c;
module.exports["createConcurrentCustomMetric"] = $2a47a9fc48674e91$export$9db2e0f538bb10fa;

});

parcelRegister("i3c1S", function(module, exports) {

var $hZpML = parcelRequire("hZpML");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");

// We preload a bunch of queries on mousedown. This is actually before transition happens.
// At the moment when queries were sent we don't know the next route yet.
// So we need to look back a bit see if we can find any queries that were sent before.
const $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS = 500;
function $82eb5b0eb983d5b4$export$9dbd6bda36500fa9(expectedPageSegments) {
    // Create list of timings for every segment that indicate actual start and end time for it.
    // This is useful for displaying page loading sequence as a waterfall, while tracking every
    // segment from page load start. Waterfall timings are prefixed with `wf/`.
    const markers = expectedPageSegments.map((segment)=>({
            key: `wf/react/${segment.key}`,
            endMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END}:${segment.key}`,
            startMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START}:${segment.key}`
        }));
    let measures;
    if ((0, $6VdZc.isInitial)()) measures = Object.values((0, $hZpML.WATERFALL_INITIAL_MEASURES));
    else {
        measures = (0, $hZpML.WaterfallMeasures).getMeasureKeys((0, $6VdZc.browserMetricsState).pageLoadStartTimestamp - $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS).filter((key)=>key.startsWith('wf/client'));
        (0, $hZpML.WaterfallMeasures).clearMeasures();
    }
    measures.forEach((key)=>{
        markers.push({
            key: key,
            startMark: `${key}.start`,
            endMark: `${key}.end`
        });
    });
    return markers;
}
module.exports["getWaterfallTimings"] = $82eb5b0eb983d5b4$export$9dbd6bda36500fa9;

});

parcelRegister("5q601", function(module, exports) {
const $23ec6b91fddb9839$export$190611e0edbb22d5 = 'viewEditButtonClicked';
const $23ec6b91fddb9839$export$ed5bb54d3f9e4a8e = 'editButtonClickedToEditRouteChange';
const $23ec6b91fddb9839$export$caabe0b707a0bfac = 'editRouteChangeToPageLoad';
const $23ec6b91fddb9839$export$a5b3479b02282e8c = 'tinySynchronyPluginsLoad';
const $23ec6b91fddb9839$export$1787f4f7916eb601 = 'tinySynchronyContentFetch';
const $23ec6b91fddb9839$export$99c2e20685f1cd4e = 'editIntentToEditPageTTI';
const $23ec6b91fddb9839$export$e04cfb21f00b2ad0 = 'editIntentToEditPageFMP';
const $23ec6b91fddb9839$export$1d8f87e0ed24898e = 'editEmbeddedPageTTI';
const $23ec6b91fddb9839$export$16bdef2ba2fa4a5 = 'editEmbeddedPageFMP';
const $23ec6b91fddb9839$export$4d09a02f749e3cc2 = 'routeChangeToEditorTTI';
const $23ec6b91fddb9839$export$c2bda34fe2c26f89 = 'tinySynchronyContentMetadaPreload';
module.exports["VIEW_EDIT_BUTTON_CLICKED_ACTION"] = $23ec6b91fddb9839$export$190611e0edbb22d5;
module.exports["EDIT_ROUTE_CHANGE_ACTION"] = $23ec6b91fddb9839$export$ed5bb54d3f9e4a8e;
module.exports["EDIT_ROUTE_CHANGE_TO_FMP_ACTION"] = $23ec6b91fddb9839$export$caabe0b707a0bfac;
module.exports["TINY_SYNCHRONY_PLUGINS_LOAD_ACTION"] = $23ec6b91fddb9839$export$a5b3479b02282e8c;
module.exports["TINY_SYNCHRONY_CONTENT_FETCH_ACTION"] = $23ec6b91fddb9839$export$1787f4f7916eb601;
module.exports["EDIT_INTENT_EDIT_TTI_ACTION"] = $23ec6b91fddb9839$export$99c2e20685f1cd4e;
module.exports["EDIT_INTENT_EDIT_FMP_ACTION"] = $23ec6b91fddb9839$export$e04cfb21f00b2ad0;
module.exports["EMBEDDED_EDIT_TTI_ACTION"] = $23ec6b91fddb9839$export$1d8f87e0ed24898e;
module.exports["EMBEDDED_EDIT_FMP_ACTION"] = $23ec6b91fddb9839$export$16bdef2ba2fa4a5;
module.exports["EDIT_ROUTE_CHANGE_TO_TTI_ACTION"] = $23ec6b91fddb9839$export$4d09a02f749e3cc2;
module.exports["TINY_SYNCHRONY_CONTENT_METADATA_PRELOAD"] = $23ec6b91fddb9839$export$c2bda34fe2c26f89;

});

parcelRegister("1UCmC", function(module, exports) {
const $00aca2e58bbddd9e$export$9ee3c9e81070f140 = 'admin-announcement-banner-setting-page';
const $00aca2e58bbddd9e$export$162462d8f302c50a = 'advanced-search';
const $00aca2e58bbddd9e$export$17e011598d6a739d = 'unified-search';
const $00aca2e58bbddd9e$export$a88513891a2ab6b7 = 'confluence-home';
const $00aca2e58bbddd9e$export$5614199f62986e3b = 'all-drafts';
const $00aca2e58bbddd9e$export$3bbaa81ece500746 = 'recent-pages';
const $00aca2e58bbddd9e$export$b634edee624f5dc2 = 'starred-pages';
const $00aca2e58bbddd9e$export$5946c48030569b81 = 'content-history';
const $00aca2e58bbddd9e$export$1eefb862c6c6ce00 = 'edit-page';
const $00aca2e58bbddd9e$export$e164999ba8681ff6 = 'edit-template';
const $00aca2e58bbddd9e$export$6cdf3f4614ddd679 = 'edit-template-old';
const $00aca2e58bbddd9e$export$8faa34d8ba45e128 = 'embedded-view-page';
const $00aca2e58bbddd9e$export$3fb3338cf2b36704 = 'embedded-edit-page';
const $00aca2e58bbddd9e$export$779fbc1a16a8cb5d = 'global-permissions';
const $00aca2e58bbddd9e$export$9d8c586f3355f180 = 'inaccessible-page';
const $00aca2e58bbddd9e$export$a0c73183bde575ec = 'not-found';
const $00aca2e58bbddd9e$export$6d480c75094dbd7f = 'space-directory';
const $00aca2e58bbddd9e$export$8d0f9920174f22b4 = 'space-overview';
const $00aca2e58bbddd9e$export$228f2841a225e5ad = 'space-pages';
const $00aca2e58bbddd9e$export$fe4f0edc4d6532a8 = 'tasks-home';
const $00aca2e58bbddd9e$export$cc53520b570e0a46 = 'content-manager';
const $00aca2e58bbddd9e$export$bdc26b2b517231a = 'space-manager';
const $00aca2e58bbddd9e$export$b6d237d1e8f12e5d = 'template-gallery';
const $00aca2e58bbddd9e$export$a715ad00b824ec3f = 'view-page';
const $00aca2e58bbddd9e$export$132f38e0c19c02b6 = 'embedded-marketplace';
const $00aca2e58bbddd9e$export$803e647119e41cc = 'embedded-store';
const $00aca2e58bbddd9e$export$d2dddf4422ad7ae8 = 'create-content';
const $00aca2e58bbddd9e$export$9c7a9f4f853f6fba = 'public-link-shared-page';
const $00aca2e58bbddd9e$export$643b9c181748da38 = 'public-link-site-setting-page';
const $00aca2e58bbddd9e$export$4716363caa82a23b = 'public-links-space-settings-page';
const $00aca2e58bbddd9e$export$75726af5c0ee9402 = 'whiteboard-view-page';
const $00aca2e58bbddd9e$export$afe76b61b3f9aaa8 = 'database-view-page';
const $00aca2e58bbddd9e$export$dd63a13fc6c1ba34 = 'embed-view-page';
const $00aca2e58bbddd9e$export$16aeb03ec0c24b89 = 'live-page';
const $00aca2e58bbddd9e$export$2b4bf316b2f90e51 = 'folder-page';
const $00aca2e58bbddd9e$export$ce4e0f6f3d614d45 = 'live-edit';
const $00aca2e58bbddd9e$export$ecea02b4eaa314f3 = 'team-calendars';
const $00aca2e58bbddd9e$export$726cbfa087a55101 = 'admin-team-calendars';
const $00aca2e58bbddd9e$export$2f245ed7ebaea89 = 'admin-general-configuration';
const $00aca2e58bbddd9e$export$2af60fefae96902b = 'admin-configure-code-macro';
const $00aca2e58bbddd9e$export$fbea00ed02ef2502 = 'admin-default-space-logo-config';
const $00aca2e58bbddd9e$export$6e9c07174668ae36 = 'admin-header-and-footer';
const $00aca2e58bbddd9e$export$51fdddeccf175d74 = 'admin-security-configuration';
const $00aca2e58bbddd9e$export$2d0370cc7d14b72e = 'admin-templates-and-blueprints';
const $00aca2e58bbddd9e$export$a8d02dbd84c83dd = 'admin-import-spaces';
const $00aca2e58bbddd9e$export$1d91ea2ef976728a = 'admin-trashed-spaces';
const $00aca2e58bbddd9e$export$a13bfc71dc6b7924 = 'admin-application-navigator';
const $00aca2e58bbddd9e$export$3ba6335cd90d2e59 = 'admin-themes';
const $00aca2e58bbddd9e$export$cb4b6b707a32ee92 = 'admin-jira-macro-repair';
const $00aca2e58bbddd9e$export$5cb6689cb672a5c0 = 'admin-pdf-export';
const $00aca2e58bbddd9e$export$fff7d33fb1514c44 = 'admin-macro-usage';
const $00aca2e58bbddd9e$export$d4aa60a3ffc18652 = 'admin-user-access';
const $00aca2e58bbddd9e$export$52c0c13179848b50 = 'CONTENT_ANALYTICS';
const $00aca2e58bbddd9e$export$40dab65f060e1231 = 'SPACE_ANALYTICS';
const $00aca2e58bbddd9e$export$b682ed6d6fa429fb = 'INSTANCE_ANALYTICS';
const $00aca2e58bbddd9e$export$93cf1e51c6a6b6b1 = 'space-details';
const $00aca2e58bbddd9e$export$2633c6986b98b723 = 'pdf-export-route';
module.exports["ADMIN_ANNOUNCEMENT_BANNER_SETTING_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$9ee3c9e81070f140;
module.exports["ADVANCED_SEARCH_LOAD_KEY"] = $00aca2e58bbddd9e$export$162462d8f302c50a;
module.exports["UNIFIED_SEARCH_LOAD_KEY"] = $00aca2e58bbddd9e$export$17e011598d6a739d;
module.exports["CONFLUENCE_HOME_LOAD_KEY"] = $00aca2e58bbddd9e$export$a88513891a2ab6b7;
module.exports["CONFLUENCE_DRAFTS_LOAD_KEY"] = $00aca2e58bbddd9e$export$5614199f62986e3b;
module.exports["CONFLUENCE_RECENT_LOAD_KEY"] = $00aca2e58bbddd9e$export$3bbaa81ece500746;
module.exports["CONFLUENCE_STARRED_LOAD_KEY"] = $00aca2e58bbddd9e$export$b634edee624f5dc2;
module.exports["CONTENT_HISTORY_LOAD_KEY"] = $00aca2e58bbddd9e$export$5946c48030569b81;
module.exports["EDIT_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$1eefb862c6c6ce00;
module.exports["EDIT_TEMPLATE_LOAD_KEY"] = $00aca2e58bbddd9e$export$e164999ba8681ff6;
module.exports["EDIT_TEMPLATE_OLD_LOAD_KEY"] = $00aca2e58bbddd9e$export$6cdf3f4614ddd679;
module.exports["EMBEDDED_VIEW_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$8faa34d8ba45e128;
module.exports["EMBEDDED_EDIT_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$3fb3338cf2b36704;
module.exports["GLOBAL_PERMISSIONS_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$779fbc1a16a8cb5d;
module.exports["INACCESSIBLE_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$9d8c586f3355f180;
module.exports["NOT_FOUND_LOAD_KEY"] = $00aca2e58bbddd9e$export$a0c73183bde575ec;
module.exports["SPACE_DIRECTORY_LOAD_KEY"] = $00aca2e58bbddd9e$export$6d480c75094dbd7f;
module.exports["SPACE_OVERVIEW_LOAD_KEY"] = $00aca2e58bbddd9e$export$8d0f9920174f22b4;
module.exports["SPACE_PAGES_LOAD_KEY"] = $00aca2e58bbddd9e$export$228f2841a225e5ad;
module.exports["TASKS_HOME_LOAD_KEY"] = $00aca2e58bbddd9e$export$fe4f0edc4d6532a8;
module.exports["CONTENT_MANAGER_LOAD_KEY"] = $00aca2e58bbddd9e$export$cc53520b570e0a46;
module.exports["SPACE_MANAGER_LOAD_KEY"] = $00aca2e58bbddd9e$export$bdc26b2b517231a;
module.exports["TEMPLATE_GALLERY_LOAD_KEY"] = $00aca2e58bbddd9e$export$b6d237d1e8f12e5d;
module.exports["VIEW_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$a715ad00b824ec3f;
module.exports["EMBEDDED_MARKETPLACE_LOAD_KEY"] = $00aca2e58bbddd9e$export$132f38e0c19c02b6;
module.exports["EMBEDDED_STORE_LOAD_KEY"] = $00aca2e58bbddd9e$export$803e647119e41cc;
module.exports["CREATE_CONTENT_LOAD_KEY"] = $00aca2e58bbddd9e$export$d2dddf4422ad7ae8;
module.exports["PUBLIC_LINK_SHARED_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$9c7a9f4f853f6fba;
module.exports["PUBLIC_LINK_SITE_SETTING_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$643b9c181748da38;
module.exports["WHITEBOARD_VIEW_PAGE_KEY"] = $00aca2e58bbddd9e$export$75726af5c0ee9402;
module.exports["DATABASE_VIEW_PAGE_KEY"] = $00aca2e58bbddd9e$export$afe76b61b3f9aaa8;
module.exports["EMBED_VIEW_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$dd63a13fc6c1ba34;
module.exports["LIVE_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$16aeb03ec0c24b89;
module.exports["FOLDER_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$2b4bf316b2f90e51;
module.exports["LIVE_PAGE_REACT_UFO_LOAD_KEY"] = $00aca2e58bbddd9e$export$ce4e0f6f3d614d45;
module.exports["TEAM_CALENDARS_LOAD_KEY"] = $00aca2e58bbddd9e$export$ecea02b4eaa314f3;
module.exports["ADMIN_TEAM_CALENDARS_LOAD_KEY"] = $00aca2e58bbddd9e$export$726cbfa087a55101;
module.exports["ADMIN_GENERAL_CONFIGURATION_LOAD_KEY"] = $00aca2e58bbddd9e$export$2f245ed7ebaea89;
module.exports["ADMIN_CONFIGURE_CODE_MACRO_LOAD_KEY"] = $00aca2e58bbddd9e$export$2af60fefae96902b;
module.exports["ADMIN_DEFAULT_SPACE_LOGO_CONFIG_LOAD_KEY"] = $00aca2e58bbddd9e$export$fbea00ed02ef2502;
module.exports["ADMIN_HEADER_AND_FOOTER_LOAD_KEY"] = $00aca2e58bbddd9e$export$6e9c07174668ae36;
module.exports["ADMIN_SECURITY_CONFIGURATION_LOAD_KEY"] = $00aca2e58bbddd9e$export$51fdddeccf175d74;
module.exports["ADMIN_TEMPLATES_AND_BLUEPRINTS_LOAD_KEY"] = $00aca2e58bbddd9e$export$2d0370cc7d14b72e;
module.exports["ADMIN_IMPORT_SPACES_LOAD_KEY"] = $00aca2e58bbddd9e$export$a8d02dbd84c83dd;
module.exports["ADMIN_TRASHED_SPACES_LOAD_KEY"] = $00aca2e58bbddd9e$export$1d91ea2ef976728a;
module.exports["ADMIN_APPLICATION_NAVIGATOR_KEY"] = $00aca2e58bbddd9e$export$a13bfc71dc6b7924;
module.exports["ADMIN_THEMES_LOAD_KEY"] = $00aca2e58bbddd9e$export$3ba6335cd90d2e59;
module.exports["ADMIN_JIRA_MACRO_REPAIR_LOAD_KEY"] = $00aca2e58bbddd9e$export$cb4b6b707a32ee92;
module.exports["ADMIN_PDF_EXPORT_LOAD_KEY"] = $00aca2e58bbddd9e$export$5cb6689cb672a5c0;
module.exports["ADMIN_MACRO_USAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$fff7d33fb1514c44;
module.exports["ADMIN_USER_ACCESS_KEY"] = $00aca2e58bbddd9e$export$d4aa60a3ffc18652;
module.exports["PAGE_ANALYTICS_LOAD_KEY"] = $00aca2e58bbddd9e$export$52c0c13179848b50;
module.exports["SPACE_ANALYTICS_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$40dab65f060e1231;
module.exports["SITE_ANALYTICS_LOAD_KEY"] = $00aca2e58bbddd9e$export$b682ed6d6fa429fb;
module.exports["SPACE_DETAILS_LOAD_KEY"] = $00aca2e58bbddd9e$export$93cf1e51c6a6b6b1;
module.exports["PDF_EXPORT_ROUTE_LOAD_KEY"] = $00aca2e58bbddd9e$export$2633c6986b98b723;

});

parcelRegister("7fw2E", function(module, exports) {

var $6VdZc = parcelRequire("6VdZc");

const $4bc3b2e76c18c48c$export$94f26401757ac8e7 = (metric)=>{
    let params;
    try {
        if ((0, $6VdZc.isInitial)()) {
            if (metric) {
                const data = metric.getData?.();
                const start = data?.start || 0;
                const stop = data?.stop || 0;
                params = [
                    {
                        duration: stop - start,
                        end: 'browser-metric.end'
                    }
                ];
            } else params = [
                undefined,
                'browser-metric.end'
            ];
        } else params = [
            'browser-metric.start',
            'browser-metric.end'
        ];
        performance.mark('browser-metric.end');
        performance.measure('browser-metric:tti', ...params);
    } catch (e) {
    // Suppress error when performance API failed.
    // Note: in MicrosoftEdge version 18 and prior, performance.measure(name, startMark, endMark) API will throw SyntaxError if startMark is undefined.
    // That's why wrap with try catch statement.
    }
};
module.exports["markBrowserMetricEnd"] = $4bc3b2e76c18c48c$export$94f26401757ac8e7;

});

parcelRegister("8w1c1", function(module, exports) {

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");

const $73e19354f9924125$export$d9a22aa9387ada7a = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.APP_NAVIGATION_SEGMENT_KEY),
    ssr: window.__SSR_RENDERED__ ? {
        doneAsFmp: true
    } : undefined
});
module.exports["APP_NAVIGATION_METRIC"] = $73e19354f9924125$export$d9a22aa9387ada7a;

});

parcelRegister("1InRL", function(module, exports) {
$parcel$export(module.exports, "BYLINE_METRIC", () => (parcelRequire("hlP5l")).BYLINE_METRIC);
$parcel$export(module.exports, "CONTENT_TITLE_METRIC", () => (parcelRequire("hlP5l")).CONTENT_TITLE_METRIC);

var $hlP5l = parcelRequire("hlP5l");


});

parcelRegister("5qUgM", function(module, exports) {

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");


var $14SPd = parcelRequire("14SPd");


var $7d41Y = parcelRequire("7d41Y");


var $gw4Bt = parcelRequire("gw4Bt");

const $325dcacdd45838d0$export$fd9c234c55ebf87b = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.CONTENT_TYPES_HEADER_TITLE_SEGMENT_KEY),
    ssr: window.__SSR_RENDERED__ ? {
        doneAsFmp: true
    } : undefined
});
const $325dcacdd45838d0$var$CONTENT_TYPES_HEADER_COMMON_SUBSEGMENT_METRICS = [
    $325dcacdd45838d0$export$fd9c234c55ebf87b,
    (0, $7d41Y.FAVOURITE_BUTTON_METRIC),
    (0, $14SPd.RESTRICTIONS_BUTTON_METRIC)
];
const $325dcacdd45838d0$export$31dafa10be5579b1 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.OBJECT_HEADER_SEGMENT_KEY),
    ssr: window.__SSR_RENDERED__ ? {
        doneAsFmp: true
    } : undefined
});
const $325dcacdd45838d0$export$13d0f4f758cb96f = [
    ...$325dcacdd45838d0$var$CONTENT_TYPES_HEADER_COMMON_SUBSEGMENT_METRICS
];
const $325dcacdd45838d0$export$2afecd1facfcf464 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.DATABASE_HEADER_SEGMENT_METRIC_KEY),
    ssr: window.__SSR_RENDERED__ ? {
        doneAsFmp: true
    } : undefined,
    until: $325dcacdd45838d0$export$13d0f4f758cb96f
});
const $325dcacdd45838d0$export$48a0148c0fcdf96 = [
    ...$325dcacdd45838d0$var$CONTENT_TYPES_HEADER_COMMON_SUBSEGMENT_METRICS,
    (0, $gw4Bt.SHARE_BUTTON_PAGE_SEGMENT_LOAD)
];
const $325dcacdd45838d0$export$a8f0e1718c3ba46b = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.SMART_LINK_EMBED_HEADER_SEGMENT_METRIC_KEY),
    ssr: window.__SSR_RENDERED__ ? {
        doneAsFmp: true
    } : undefined,
    until: $325dcacdd45838d0$export$48a0148c0fcdf96
});
const $325dcacdd45838d0$export$585906e42509a641 = [
    ...$325dcacdd45838d0$var$CONTENT_TYPES_HEADER_COMMON_SUBSEGMENT_METRICS,
    (0, $gw4Bt.SHARE_BUTTON_PAGE_SEGMENT_LOAD)
];
const $325dcacdd45838d0$export$de21700de0084df7 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.WHITEBOARD_HEADER_SEGMENT_METRIC_KEY),
    ssr: window.__SSR_RENDERED__ ? {
        doneAsFmp: true
    } : undefined,
    until: $325dcacdd45838d0$export$585906e42509a641
});
module.exports["CONTENT_TYPES_HEADER_TITLE_SEGMENT"] = $325dcacdd45838d0$export$fd9c234c55ebf87b;
module.exports["OBJECT_HEADER_SEGMENT_METRIC"] = $325dcacdd45838d0$export$31dafa10be5579b1;
module.exports["DATABASE_HEADER_SUBSEGMENT_METRICS"] = $325dcacdd45838d0$export$13d0f4f758cb96f;
module.exports["DATABASE_HEADER_SEGMENT_METRIC"] = $325dcacdd45838d0$export$2afecd1facfcf464;
module.exports["SMART_LINK_EMBED_HEADER_SUBSEGMENT_METRICS"] = $325dcacdd45838d0$export$48a0148c0fcdf96;
module.exports["SMART_LINK_EMBED_HEADER_SEGMENT_METRIC"] = $325dcacdd45838d0$export$a8f0e1718c3ba46b;
module.exports["WHITEBOARD_HEADER_SUBSEGMENT_METRICS"] = $325dcacdd45838d0$export$585906e42509a641;
module.exports["WHITEBOARD_HEADER_SEGMENT_METRIC"] = $325dcacdd45838d0$export$de21700de0084df7;

});

parcelRegister("14SPd", function(module, exports) {

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");

const $8ab24ab9418ac89d$export$34cc51d2a4e5cf67 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.RESTRICTIONS_BUTTON_SEGMENT_KEY),
    timings: [
        {
            key: 'fmp',
            endMark: 'fmp'
        },
        {
            key: 'tti',
            endMark: 'tti'
        }
    ]
});
module.exports["RESTRICTIONS_BUTTON_METRIC"] = $8ab24ab9418ac89d$export$34cc51d2a4e5cf67;

});

parcelRegister("7d41Y", function(module, exports) {

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");

const $9b3034aec76dfadd$export$ecb802558c1ba05e = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.FAVOURITE_BUTTON_SEGMENT_KEY),
    ssr: window.__SSR_RENDERED__ ? {
        doneAsFmp: true
    } : undefined
});
module.exports["FAVOURITE_BUTTON_METRIC"] = $9b3034aec76dfadd$export$ecb802558c1ba05e;

});

parcelRegister("gw4Bt", function(module, exports) {

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");

const $08e48bbb9421afc0$export$8fdec53caa79133c = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.SHARE_BUTTON_SEGMENT_KEY)
});
module.exports["SHARE_BUTTON_PAGE_SEGMENT_LOAD"] = $08e48bbb9421afc0$export$8fdec53caa79133c;

});

parcelRegister("1q7H7", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");

var $fQ3iN = parcelRequire("fQ3iN");


var $jIOyV = parcelRequire("jIOyV");


var $jX1qB = parcelRequire("jX1qB");

const $108e3019fffb7b94$export$6e28125ef9389dc6 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.PAGE_TREE_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
const $108e3019fffb7b94$export$45b21bbf8961b519 = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.MOVE_PAGE_DIALOG_INTERACTION)
});
module.exports["PAGE_TREE_METRIC"] = $108e3019fffb7b94$export$6e28125ef9389dc6;
module.exports["MOVE_PAGE_DIALOG_INTERACTION_METRIC"] = $108e3019fffb7b94$export$45b21bbf8961b519;

});

parcelRegister("jIOyV", function(module, exports) {
// "confluence.fe.interaction.XXX"
const $4fa41f80373a2ebe$export$f49429c67898bd15 = 'more-actions-dropdown';
const $4fa41f80373a2ebe$export$daaf73616fe91ce9 = 'move-page-dialog';
const $4fa41f80373a2ebe$export$d4222bce9029f393 = 'content-analytics-dialog';
const $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c = 'content-analytics-dialog-mentions-tab';
const $4fa41f80373a2ebe$export$ef2fb65c026ab7d3 = 'quick-summary-dialog';
const $4fa41f80373a2ebe$export$8122cf0ca2968a7b = 'open-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$ea9696a28a6fbc61 = 'initialize-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$e561726b92a6162d = 'comments_summary_component';
const $4fa41f80373a2ebe$export$e348981755bdab67 = 'create-space-drawer';
const $4fa41f80373a2ebe$export$af1eb8557193d022 = 'ai-presentation-modal';
const $4fa41f80373a2ebe$export$7f72b8ffbbbfef58 = 'ai-content-catchup';
const $4fa41f80373a2ebe$export$576b15c3bba51667 = 'ai-audio-briefing';
module.exports["MORE_ACTIONS_DROPDOWN_INTERACTION"] = $4fa41f80373a2ebe$export$f49429c67898bd15;
module.exports["MOVE_PAGE_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$daaf73616fe91ce9;
module.exports["CONTENT_ANALYTICS_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$d4222bce9029f393;
module.exports["CONTENT_ANALYTICS_DIALOG_MENTIONS_TAB_INTERACTION"] = $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c;
module.exports["QUICK_SUMMARY_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$ef2fb65c026ab7d3;
module.exports["OPEN_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$8122cf0ca2968a7b;
module.exports["INITIALIZE_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$ea9696a28a6fbc61;
module.exports["COMMENTS_SUMMARY_COMPONENT_INTERACTION"] = $4fa41f80373a2ebe$export$e561726b92a6162d;
module.exports["CREATE_SPACE_DRAWER_INTERACTION"] = $4fa41f80373a2ebe$export$e348981755bdab67;
module.exports["AI_CONTENT_CATCHUP_INTERACTION"] = $4fa41f80373a2ebe$export$7f72b8ffbbbfef58;
module.exports["AI_AUDIO_BRIEFING_INTERACTION"] = $4fa41f80373a2ebe$export$576b15c3bba51667;

});

parcelRegister("aWrnw", function(module, exports) {

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");


var $1Hqbt = parcelRequire("1Hqbt");

const $d4615ab6ca7803f7$export$b9931e60e47a0122 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.SPACE_NAVIGATION_SEGMENT_KEY),
    ssr: (0, $1Hqbt.ssrConfig)()
});
const $d4615ab6ca7803f7$export$618f453a5683e37b = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.SPACE_APPS_SEGMENT_KEY),
    ssr: (0, $1Hqbt.ssrConfig)()
});
module.exports["SPACE_NAVIGATION_METRIC"] = $d4615ab6ca7803f7$export$b9931e60e47a0122;
module.exports["SPACE_APPS_METRIC"] = $d4615ab6ca7803f7$export$618f453a5683e37b;

});

parcelRegister("1Hqbt", function(module, exports) {
const $a75b16828791e7fd$export$ea92d4e542ec02b3 = ()=>window.__SSR_RENDERED__ ? {
        doneAsFmp: true
    } : undefined;
module.exports["ssrConfig"] = $a75b16828791e7fd$export$ea92d4e542ec02b3;

});

parcelRegister("fgdVB", function(module, exports) {

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");

const $70b3fb0961586b52$export$ac619e1da09d5f80 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY),
    ssr: window.__SSR_RENDERED__ ? {
        doneAsFmp: true
    } : undefined
});
module.exports["OBJECT_SIDEBAR_CONTROL_METRIC"] = $70b3fb0961586b52$export$ac619e1da09d5f80;

});

parcelRegister("5vi32", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lTECB = parcelRequire("lTECB");


var $7zgzO = parcelRequire("7zgzO");

function $36802f16e927d19b$export$c850f609dc850980() {
    const { location: location } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    return (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)(location || window.location);
}
module.exports["useIsEmbeddedConfluence_DO_NOT_USE"] = $36802f16e927d19b$export$c850f609dc850980;

});

parcelRegister("dtDUi", function(module, exports) {
/* eslint-disable prefer-template */ 
var $64KID = parcelRequire("64KID");


var $fMEnQ = parcelRequire("fMEnQ");

const $dab54f7f733e6dc2$var$DOC_LINK = 'https://hello.atlassian.net/wiki/spaces/CCPERF/pages/4848884799/Debugging+Hydration+Mismatches';
const $dab54f7f733e6dc2$export$476b9d1d68660527 = [
    {
        matchers: [
            /Hydration failed because the initial UI does not match what was rendered on the server/
        ],
        friendlyError: {
            friendlyMessage: 'Hydration failed because the initial UI does not match what was rendered on the server.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /The server could not finish this Suspense boundary, likely due to an error during server rendering/
        ],
        friendlyError: {
            friendlyMessage: 'The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering/
        ],
        friendlyError: {
            friendlyMessage: 'This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering./
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /This root received an early update, before anything was able hydrate. Switched the entire root to client rendering./
        ],
        friendlyError: {
            friendlyMessage: 'This root received an early update, before anything was able hydrate. Switched the entire root to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Text content does not match server-rendered HTML./
        ],
        friendlyError: {
            friendlyMessage: 'Text content does not match server-rendered HTML.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /There was an error while hydrating this Suspense boundary. Switched to client rendering./
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating this Suspense boundary. Switched to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    //Production errors
    {
        matchers: [
            /Minified React error #418/
        ],
        friendlyError: {
            friendlyMessage: 'Hydration failed because the initial UI does not match what was rendered on the server in production. Run in development mode for more details.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #419/
        ],
        friendlyError: {
            friendlyMessage: 'The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering. Run in development mode for more details.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #421/
        ],
        friendlyError: {
            friendlyMessage: 'This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #422/
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating this Suspense boundary. Switched to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #423/
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #424/
        ],
        friendlyError: {
            friendlyMessage: 'This root received an early update, before anything was able hydrate. Switched the entire root to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #425/
        ],
        friendlyError: {
            friendlyMessage: 'Text content does not match server-rendered HTML.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    }
];
const $dab54f7f733e6dc2$export$5796b97ecb5a412 = (errorString)=>{
    for (const { matchers: matchers, friendlyError: friendlyError, hydrationFailed: hydrationFailed } of $dab54f7f733e6dc2$export$476b9d1d68660527){
        if (matchers.some((matcher)=>matcher.test(errorString))) return {
            ...friendlyError,
            originalString: errorString,
            hydrationFailed: hydrationFailed
        };
    }
    return {
        friendlyMessage: 'An additional error occurred, attached below.',
        docLink: '',
        fallback: true,
        originalString: errorString,
        hydrationFailed: false
    };
};
const $dab54f7f733e6dc2$export$2ce86ea0a2fd49b2 = (url)=>{
    const match = (0, $fMEnQ.Route).matchFirst(Object.values((0, $64KID.namedRoutes)), url);
    return {
        error: new Error(`Hydration failed on route ${match?.name}`),
        route: match?.name || 'unknown'
    };
};
function $dab54f7f733e6dc2$export$260985b5e8a6fce6({ source: source, route: route, errorWithRoute: errorWithRoute, isSSRReactStreaming: isSSRReactStreaming }) {
    const attribution = isSSRReactStreaming ? 'streaming-hydration' : 'hydration';
    const error = $dab54f7f733e6dc2$var$trimTextLength(errorWithRoute.message || String(errorWithRoute), 1000);
    return {
        type: 'sendOperationalEvent',
        data: {
            source: source,
            route: route,
            action: 'failed',
            actionSubject: 'hydration',
            attributes: {
                error: error,
                route: route,
                attribution: attribution,
                isSSRReactStreaming: isSSRReactStreaming
            }
        }
    };
}
function $dab54f7f733e6dc2$var$trimTextLength(text, maxLength) {
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
}
module.exports["matchHydrationError"] = $dab54f7f733e6dc2$export$5796b97ecb5a412;
module.exports["getHydrationErrorWithRoute"] = $dab54f7f733e6dc2$export$2ce86ea0a2fd49b2;
module.exports["getHydrationFailureOperationalEvent"] = $dab54f7f733e6dc2$export$260985b5e8a6fce6;

});

parcelRegister("lABjq", function(module, exports) {
const $8cb98e143c540908$export$79ede1af301c436c = {
    pageJustPublished: false
};
module.exports["pagePublishedState"] = $8cb98e143c540908$export$79ede1af301c436c;

});

parcelRegister("9sGCn", function(module, exports) {

var $5RVp4 = parcelRequire("5RVp4");


var $5tydj = parcelRequire("5tydj");


var $kBBRP = parcelRequire("kBBRP");


var $b22Ya = parcelRequire("b22Ya");


var $dOBRD = parcelRequire("dOBRD");


var $fFmJj = parcelRequire("fFmJj");


var $ge2sX = parcelRequire("ge2sX");

var $416a341702253f60$var$Client = /*#__PURE__*/ function(Client) {
    Client["CC_GRAPHQL"] = "Cc graphql client";
    Client["AGG_GRAPHQL"] = "Agg graphql client";
    return Client;
}($416a341702253f60$var$Client || {});
const $416a341702253f60$var$FRAGMENTS_BY_TYPE = [
    {
        client: "Cc graphql client",
        gqlType: 'Content',
        fragment: (0, $b22Ya.default)
    },
    {
        client: "Cc graphql client",
        gqlType: 'Content',
        // If we don't have `status` cached but do have `subType` cached, this ensures we still fast load it. We prefer fast loading live docs even if we're uncertain whether they're archived.
        fragment: (0, $kBBRP.default)
    },
    {
        client: "Cc graphql client",
        gqlType: 'PTPage',
        fragment: (0, $5tydj.default)
    },
    {
        // Search query uses agg graphql client
        client: "Agg graphql client",
        gqlType: 'SearchConfluencePageBlogAttachment',
        fragment: (0, $5RVp4.default)
    }
];
const $416a341702253f60$export$b4dacd1dfdee469b = (0, $dOBRD.default)((contentId)=>{
    if (!contentId) // When content id does not exist, return undefined values
    return {
        subType: undefined,
        isArchived: undefined,
        gqlType: undefined
    };
    const cloudId = (0, $ge2sX.getCloudId)();
    let subType;
    let isArchived = undefined;
    let gqlTypeUsed;
    $416a341702253f60$var$FRAGMENTS_BY_TYPE.some(({ client: client, gqlType: gqlType, fragment: fragment })=>{
        // readFragment throws an error if it finds the item in the cache without both id and subtype, so we wrap in try/catch
        try {
            let id = `${gqlType}:${contentId}`;
            if (gqlType === 'SearchConfluencePageBlogAttachment') // Search graphql query includes the ARI in the id
            id = `${gqlType}:ari:cloud:confluence:${cloudId}:page/${contentId}`;
            const fragmentData = (0, $fFmJj.readFragmentInterop)({
                id: id,
                fragment: fragment,
                interopApolloAggClient: client === "Agg graphql client",
                __callerPackage__: "live-pages-utils"
            });
            if (fragmentData && 'subType' in fragmentData && fragmentData.subType) {
                subType = fragmentData.subType;
                isArchived = 'status' in fragmentData && fragmentData.status ? fragmentData.status?.toLowerCase?.() === 'archived' : undefined;
                gqlTypeUsed = gqlType;
                return true;
            } else if (fragmentData && 'subtype' in fragmentData && fragmentData.subtype) {
                // In search graphql query's response, subtype exists as an inline fragment on ConfluencePage
                subType = fragmentData.subtype?.toLowerCase?.();
                gqlTypeUsed = gqlType;
                return true;
            }
        } catch  {}
    });
    return {
        subType: subType,
        isArchived: isArchived,
        gqlType: gqlTypeUsed
    };
});
const $416a341702253f60$export$d56c32e9e73f8f9b = ()=>$416a341702253f60$export$b4dacd1dfdee469b.clear();
module.exports["getCachedPageData"] = $416a341702253f60$export$b4dacd1dfdee469b;
module.exports["clearMemoizedCachedPageData"] = $416a341702253f60$export$d56c32e9e73f8f9b;

});

parcelRegister("5RVp4", function(module, exports) {
/**
 * @generated SignedSource<<9964ae8171b6e20649f2fca9a76ff96a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d1b5c3b39238b90e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "getCachedPageDataSubTypeSearchFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "LinkedField",
            "name": "confluenceEntity",
            "plural": false,
            "selections": [
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "subtype"
                        }
                    ],
                    "type": "ConfluencePage"
                }
            ]
        }
    ],
    "type": "SearchConfluencePageBlogAttachment"
};
$d1b5c3b39238b90e$var$node.hash = "029b00b42bd8ba9e9b5ecf4947b241c2";
var $d1b5c3b39238b90e$export$2e2bcd8739ae039 = $d1b5c3b39238b90e$var$node;
module.exports["default"] = $d1b5c3b39238b90e$export$2e2bcd8739ae039;

});

parcelRegister("5tydj", function(module, exports) {
/**
 * @generated SignedSource<<06b30fff81deb6c9145868aacd1b6057>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $019558c9ca245006$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "getCachedPageDataSubTypePageTreeFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "subType"
        }
    ],
    "type": "PTPage"
};
$019558c9ca245006$var$node.hash = "7ccb76f2a832d90b6f167fe96a11f5a9";
var $019558c9ca245006$export$2e2bcd8739ae039 = $019558c9ca245006$var$node;
module.exports["default"] = $019558c9ca245006$export$2e2bcd8739ae039;

});

parcelRegister("kBBRP", function(module, exports) {
/**
 * @generated SignedSource<<ba803410513b2e2b6e70f77d471effb5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6f66d8210bca9b3e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "getCachedPageDataSubTypeContentFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "subType"
        }
    ],
    "type": "Content"
};
$6f66d8210bca9b3e$var$node.hash = "03b28a640aee18909db0a4f3575e7f08";
var $6f66d8210bca9b3e$export$2e2bcd8739ae039 = $6f66d8210bca9b3e$var$node;
module.exports["default"] = $6f66d8210bca9b3e$export$2e2bcd8739ae039;

});

parcelRegister("b22Ya", function(module, exports) {
/**
 * @generated SignedSource<<3f51ca78fc05b3943b12ce8587361a0d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f9170d170545992b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "getCachedPageDataContentFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "subType"
        },
        {
            "kind": "ScalarField",
            "name": "status"
        }
    ],
    "type": "Content"
};
$f9170d170545992b$var$node.hash = "b940ae3a5484e1099f106d12713d37f5";
var $f9170d170545992b$export$2e2bcd8739ae039 = $f9170d170545992b$var$node;
module.exports["default"] = $f9170d170545992b$export$2e2bcd8739ae039;

});

parcelRegister("8zMP3", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $65DSU = parcelRequire("65DSU");


var $hZpML = parcelRequire("hZpML");


var $cemw8 = parcelRequire("cemw8");


var $8zKDl = parcelRequire("8zKDl");


var $dAPGk = parcelRequire("dAPGk");

const $5cfe2edd168ef31e$export$b17d024ed060ce0b = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $dAPGk.useSuspenseBoundaryName)();
} : ()=>(0, $dAPGk.useSuspenseBoundaryName)();
const $5cfe2edd168ef31e$var$SuspenseWithDataFetcherReader = (0, $3u0dr.isReactCompilerActiveV2)() ? function SuspenseWithDataFetcherReader(t0) {
    const $ = (0, $bDgLe.c)(2);
    const { dataFetcher: dataFetcher, children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : function SuspenseWithDataFetcherReader({ dataFetcher: dataFetcher, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
function $5cfe2edd168ef31e$export$553ede96e278ba94({ dataFetcherName: dataFetcherName, fallback: fallback = null, children: children }) {
    // Capture the SSR streaming value on initial render using useRef
    // This ensures the component tree doesn't change when the global variable
    // is deleted during route navigation
    const isSSRStreaming = (0, $cozmU.useRef)(window.__SSR_REACT_STREAMING__);
    // Get the current boundary chain from parent context
    const parentBoundaryChain = (0, $cozmU.useContext)((0, $dAPGk.SuspenseBoundaryNameContext));
    // Create new chain by appending current boundary to parent chain
    const currentBoundaryChain = (0, $cozmU.useMemo)(()=>[
            ...parentBoundaryChain,
            dataFetcherName
        ], [
        parentBoundaryChain,
        dataFetcherName
    ]);
    if (isSSRStreaming.current) {
        const dataFetcher = (0, $8zKDl.getDataFetcherForSuspense)(dataFetcherName, isSSRStreaming.current);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dAPGk.SuspenseBoundaryNameContext).Provider, {
            value: currentBoundaryChain
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cemw8.HydrationSafeSuspense), {
            fallback: fallback
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5cfe2edd168ef31e$var$SuspenseWithDataFetcherReader, {
            dataFetcher: dataFetcher
        }, (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_SUSPENSE}/${dataFetcherName}.start`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $65DSU.default), {
            name: `stream-suspense-${dataFetcherName}`
        }, children), (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_SUSPENSE}/${dataFetcherName}.end`))));
    } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
}
module.exports["SuspenseWithDataFetcher"] = $5cfe2edd168ef31e$export$553ede96e278ba94;

});

parcelRegister("cemw8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1P7Cq = parcelRequire("1P7Cq");

const $28f120e398482486$var$HydrationSafeSuspenseContent = /*#__PURE__*/ (0, $cozmU.memo)(function HydrationSafeSuspenseContent({ children: children, fallback: fallback }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: fallback
    }, children);
}, (_prevProps, nextProps)=>{
    // Block updates while locked (during hydration)
    return nextProps.isLocked;
});
function $28f120e398482486$export$a0bfcafd6d556141({ fallback: fallback = null, children: children }) {
    const renderServerPlaceholder = (0, $1P7Cq.useIsSSROrHydrating)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($28f120e398482486$var$HydrationSafeSuspenseContent, {
        isLocked: renderServerPlaceholder,
        fallback: fallback
    }, children);
}
module.exports["HydrationSafeSuspense"] = $28f120e398482486$export$a0bfcafd6d556141;

});

parcelRegister("8zKDl", function(module, exports) {
function $2b2227915da27313$export$63116239d47be9ca(dataFetcherName, isSSRStreaming = true) {
    if (!isSSRStreaming || !dataFetcherName) return null;
    return window.__dataFetcherForSuspense__?.[dataFetcherName] ?? null;
}
module.exports["getDataFetcherForSuspense"] = $2b2227915da27313$export$63116239d47be9ca;

});

parcelRegister("1Af7Q", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ep3mz = parcelRequire("ep3mz");


var $3fCLI = parcelRequire("3fCLI");

function $9a1f832417de6544$export$ae2b233b73197bb6() {
    const $ = (0, $bDgLe.c)(2);
    const [contentId] = (0, $ep3mz.usePageContentId)();
    let t0;
    if ($[0] !== contentId) {
        t0 = contentId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3fCLI.LegacyBridgeNextInner), {
            contentId: contentId
        }) : null;
        $[0] = contentId;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
}
module.exports["LegacyBridgeNext"] = $9a1f832417de6544$export$ae2b233b73197bb6;

});

parcelRegister("3fCLI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $ep3mz = parcelRequire("ep3mz");


var $7W8i8 = parcelRequire("7W8i8");


var $1ytiN = parcelRequire("1ytiN");


var $1P7Cq = parcelRequire("1P7Cq");


var $8vxJi = parcelRequire("8vxJi");


var $3d5UI = parcelRequire("3d5UI");


var $jMyy4 = parcelRequire("jMyy4");


var $98Fgg = parcelRequire("98Fgg");

const $fdddd5e334b3dceb$var$logger = (0, $7W8i8.getLogger)('LegacyBridgeNext');
function $fdddd5e334b3dceb$export$af02eebb080c844({ contentId: contentId }) {
    const [contentType] = (0, $ep3mz.useContentType)();
    const { experimentFeatures: experimentFeatures } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    const nonceValue = window.__SSR_NONCE_VALUE__;
    const renderServerPlaceholder = (0, $1P7Cq.useIsSSROrHydrating)();
    // Due to circular dependency issues we are using the PreloadLegacyBridgeQuery from query-preloaders-common package
    const { data: data, error: error } = (0, $jMyy4.useQueryInterop)((0, $98Fgg.default), {
        variables: {
            contentId: contentId || '',
            isBlog: contentType === 'blogpost'
        },
        context: {
            single: true
        },
        __callerPackage__: "view-page"
    });
    const { ptpage: ptpage, content: content } = data || {};
    const contentNode = content?.nodes?.[0];
    const spaceNode = contentNode?.space;
    const pageVersion = contentNode?.version?.number;
    const ajsMetaParameters = [
        {
            key: 'space-key',
            value: spaceNode?.key
        },
        {
            key: 'space-name',
            value: spaceNode?.name
        },
        {
            key: 'space-type',
            value: spaceNode?.type
        },
        {
            key: 'content-type',
            value: contentNode?.type
        },
        {
            key: 'page-version',
            value: pageVersion
        },
        {
            key: 'page-title',
            value: contentNode?.title
        },
        {
            key: 'parent-page-id',
            value: ptpage?.nearestAncestors?.edges?.[0]?.node?.id
        },
        {
            key: 'parent-page-title',
            value: ptpage?.nearestAncestors?.edges?.[0]?.node?.title
        },
        {
            key: 'experiment-features',
            value: experimentFeatures
        }
    ];
    if (contentId) {
        const createPage = pageVersion === 0;
        const pageId = createPage ? '0' : contentId;
        ajsMetaParameters.push({
            key: 'content-id',
            value: contentId
        });
        ajsMetaParameters.push({
            key: 'latest-page-id',
            value: contentId
        });
        ajsMetaParameters.push({
            key: 'new-page',
            value: createPage
        });
        ajsMetaParameters.push({
            key: 'page-id',
            value: pageId
        });
    }
    const operations = contentNode?.operations;
    if (operations) {
        const canRemovePage = operations.filter((item)=>item?.operation === 'delete' && item?.targetType === 'page').length > 0;
        ajsMetaParameters.push({
            key: 'can-remove-page',
            value: canRemovePage
        });
    }
    const filteredAjsMetaParameters = ajsMetaParameters.filter(({ value: value })=>value !== undefined && value !== null);
    (0, $cozmU.useEffect)(()=>{
        (0, $3d5UI.waitForGlobal)({
            listener: 'LegacyBridgeNext.js',
            globalProperty: 'AJS.Meta.set'
        }, ()=>{
            if (error) {
                $fdddd5e334b3dceb$var$logger.error`Failed to Query Legacy AJSMetaData ${error}`;
                return;
            }
            if (filteredAjsMetaParameters.length === 0 || window.AJS.Meta.get('has-next-legacy-bridge')) return;
            // We have 2 legacy bridge here based on graphql
            // Another in packages/confluence-frontend-server/src/components/LegacyBridge/LegacyBridge.js based on Redux.
            // We need to let the legacy one know we have already dealt with these meta tags don't override
            window.AJS.Meta.set('has-next-legacy-bridge', true);
            filteredAjsMetaParameters.forEach(({ key: key, value: value_0 })=>window.AJS.Meta.set(key, value_0));
        });
        return ()=>{
            const ajsMeta = window.AJS?.Meta;
            ajsMeta && ajsMeta.set('has-next-legacy-bridge', false);
        };
    }, [
        error,
        contentId,
        filteredAjsMetaParameters
    ]);
    if (renderServerPlaceholder) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("script", {
        nonce: nonceValue,
        "data-testid": "legacyBridge-ssr",
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `window.__SSR_AJS_META__=${(0, $8vxJi.stringifyForSSR)(filteredAjsMetaParameters)}`
        }
    });
    return null;
}
module.exports["LegacyBridgeNextInner"] = $fdddd5e334b3dceb$export$af02eebb080c844;

});

parcelRegister("98Fgg", function(module, exports) {
/**
 * @generated SignedSource<<9e3e16b02d7e839cb28fafbd9cc22027>>
 * @relayHash 1eef94f086d4818dc81396289138687a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 57138c5ec4f8edfbd221571e7278778f53d34a1487ac2bb480000f3f99715f09
const $314d226daa5f5ce2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isBlog"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "title"
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = [
        {
            "condition": "isBlog",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ ,
                        {
                            "kind": "Literal",
                            "name": "status",
                            "value": [
                                "CURRENT"
                            ]
                        }
                    ],
                    "concreteType": "PTPage",
                    "kind": "LinkedField",
                    "name": "ptpage",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 1
                                }
                            ],
                            "concreteType": "PTPaginatedPageList",
                            "kind": "LinkedField",
                            "name": "nearestAncestors",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PTPageEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "PTPage",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "nearestAncestors(first:1)"
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                v1 /*: any*/ 
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v4 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "number"
                                }
                            ]
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                v4 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadLegacyBridgeQuery",
            "selections": v5 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadLegacyBridgeQuery",
            "selections": v5 /*: any*/ 
        },
        "params": {
            "cacheID": "1eef94f086d4818dc81396289138687a",
            "id": "57138c5ec4f8edfbd221571e7278778f53d34a1487ac2bb480000f3f99715f09",
            "metadata": {},
            "name": "preloadLegacyBridgeQuery",
            "operationKind": "query",
            "text": "query preloadLegacyBridgeQuery($contentId:ID!,$isBlog:Boolean!){ptpage(id:$contentId,status:[CURRENT])@skip(if:$isBlog){id,nearestAncestors(first:1){edges{node{id,title}}}},content(id:$contentId){nodes{id,type,title,version{number},space{id,key,name,type},operations{operation,targetType}}}}"
        }
    };
}();
$314d226daa5f5ce2$var$node.hash = "6d396d281028b16cc64fd39e7d8cd3db";
var $314d226daa5f5ce2$export$2e2bcd8739ae039 = $314d226daa5f5ce2$var$node;
module.exports["default"] = $314d226daa5f5ce2$export$2e2bcd8739ae039;

});

parcelRegister("eTuLj", function(module, exports) {

let $ad7e106f0dc8aacf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ad7e106f0dc8aacf$var$load("2SbEZ").then(()=>parcelRequire('dI68T'));

});

parcelRegister("eieXD", function(module, exports) {
$parcel$export(module.exports, "Integrations", () => $02af7510cb9721a1$export$99d02219d259eb94);
$parcel$export(module.exports, "Transports", () => (parcelRequire("a2lmi")));

var $fbwmZ = parcelRequire("fbwmZ");


var $dcw8o = parcelRequire("dcw8o");


var $ilRwI = parcelRequire("ilRwI");


var $6NrTk = parcelRequire("6NrTk");


var $eIjjl = parcelRequire("eIjjl");


var $a2lmi = parcelRequire("a2lmi");

var $02af7510cb9721a1$var$windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
var $02af7510cb9721a1$var$_window = (0, $6NrTk.getGlobalObject)();
if ($02af7510cb9721a1$var$_window.Sentry && $02af7510cb9721a1$var$_window.Sentry.Integrations) $02af7510cb9721a1$var$windowIntegrations = $02af7510cb9721a1$var$_window.Sentry.Integrations;
var $02af7510cb9721a1$export$99d02219d259eb94 = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, $02af7510cb9721a1$var$windowIntegrations), (0, $ilRwI)), $eIjjl);
 //# sourceMappingURL=index.js.map
$parcel$exportWildcard(module.exports, $dcw8o);

});

parcelRegister("dcw8o", function(module, exports) {
$parcel$export(module.exports, "Severity", () => (parcelRequire("dtZ6d")).Severity);
$parcel$export(module.exports, "addGlobalEventProcessor", () => (parcelRequire("hkv0W")).addGlobalEventProcessor);
$parcel$export(module.exports, "addBreadcrumb", () => (parcelRequire("9HPf3")).addBreadcrumb);
$parcel$export(module.exports, "captureException", () => (parcelRequire("9HPf3")).captureException);
$parcel$export(module.exports, "captureEvent", () => (parcelRequire("9HPf3")).captureEvent);
$parcel$export(module.exports, "captureMessage", () => (parcelRequire("9HPf3")).captureMessage);
$parcel$export(module.exports, "configureScope", () => (parcelRequire("9HPf3")).configureScope);
$parcel$export(module.exports, "getHubFromCarrier", () => (parcelRequire("amM2J")).getHubFromCarrier);
$parcel$export(module.exports, "getCurrentHub", () => (parcelRequire("amM2J")).getCurrentHub);
$parcel$export(module.exports, "Hub", () => (parcelRequire("amM2J")).Hub);
$parcel$export(module.exports, "makeMain", () => (parcelRequire("amM2J")).makeMain);
$parcel$export(module.exports, "Scope", () => (parcelRequire("hkv0W")).Scope);
$parcel$export(module.exports, "Session", () => (parcelRequire("dQl3s")).Session);
$parcel$export(module.exports, "startTransaction", () => (parcelRequire("9HPf3")).startTransaction);
$parcel$export(module.exports, "SDK_VERSION", () => (parcelRequire("a953x")).SDK_VERSION);
$parcel$export(module.exports, "setContext", () => (parcelRequire("9HPf3")).setContext);
$parcel$export(module.exports, "setExtra", () => (parcelRequire("9HPf3")).setExtra);
$parcel$export(module.exports, "setExtras", () => (parcelRequire("9HPf3")).setExtras);
$parcel$export(module.exports, "setTag", () => (parcelRequire("9HPf3")).setTag);
$parcel$export(module.exports, "setTags", () => (parcelRequire("9HPf3")).setTags);
$parcel$export(module.exports, "setUser", () => (parcelRequire("9HPf3")).setUser);
$parcel$export(module.exports, "withScope", () => (parcelRequire("9HPf3")).withScope);
$parcel$export(module.exports, "BrowserClient", () => (parcelRequire("e9HlS")).BrowserClient);
$parcel$export(module.exports, "injectReportDialog", () => (parcelRequire("9whyS")).injectReportDialog);
$parcel$export(module.exports, "eventFromException", () => (parcelRequire("l17tw")).eventFromException);
$parcel$export(module.exports, "eventFromMessage", () => (parcelRequire("l17tw")).eventFromMessage);
$parcel$export(module.exports, "defaultIntegrations", () => (parcelRequire("eAdCn")).defaultIntegrations);
$parcel$export(module.exports, "forceLoad", () => (parcelRequire("eAdCn")).forceLoad);
$parcel$export(module.exports, "init", () => (parcelRequire("eAdCn")).init);
$parcel$export(module.exports, "lastEventId", () => (parcelRequire("eAdCn")).lastEventId);
$parcel$export(module.exports, "onLoad", () => (parcelRequire("eAdCn")).onLoad);
$parcel$export(module.exports, "showReportDialog", () => (parcelRequire("eAdCn")).showReportDialog);
$parcel$export(module.exports, "flush", () => (parcelRequire("eAdCn")).flush);
$parcel$export(module.exports, "close", () => (parcelRequire("eAdCn")).close);
$parcel$export(module.exports, "wrap", () => (parcelRequire("eAdCn")).wrap);
$parcel$export(module.exports, "SDK_NAME", () => (parcelRequire("7iBHc")).SDK_NAME);

var $dtZ6d = parcelRequire("dtZ6d");


var $9HPf3 = parcelRequire("9HPf3");

var $hkv0W = parcelRequire("hkv0W");

var $amM2J = parcelRequire("amM2J");

var $a953x = parcelRequire("a953x");

var $dQl3s = parcelRequire("dQl3s");


var $e9HlS = parcelRequire("e9HlS");


var $9whyS = parcelRequire("9whyS");


var $l17tw = parcelRequire("l17tw");


var $eAdCn = parcelRequire("eAdCn");


var $7iBHc = parcelRequire("7iBHc");

 //# sourceMappingURL=exports.js.map

});

parcelRegister("7iBHc", function(module, exports) {
// TODO: Remove in the next major release and rely only on @sentry/core SDK_VERSION and SdkInfo metadata
var $55077470b8523cd3$export$ca61d37259221480 = 'sentry.javascript.browser'; //# sourceMappingURL=version.js.map
module.exports["SDK_NAME"] = $55077470b8523cd3$export$ca61d37259221480;

});

parcelRegister("eIjjl", function(module, exports) {
$parcel$export(module.exports, "GlobalHandlers", () => (parcelRequire("cEELl")).GlobalHandlers);
$parcel$export(module.exports, "TryCatch", () => (parcelRequire("51FBI")).TryCatch);
$parcel$export(module.exports, "Breadcrumbs", () => (parcelRequire("bNfZ4")).Breadcrumbs);
$parcel$export(module.exports, "LinkedErrors", () => (parcelRequire("6oUta")).LinkedErrors);
$parcel$export(module.exports, "UserAgent", () => (parcelRequire("aMh6Y")).UserAgent);
$parcel$export(module.exports, "Dedupe", () => (parcelRequire("lBiNe")).Dedupe);

var $cEELl = parcelRequire("cEELl");


var $51FBI = parcelRequire("51FBI");


var $bNfZ4 = parcelRequire("bNfZ4");


var $6oUta = parcelRequire("6oUta");


var $aMh6Y = parcelRequire("aMh6Y");


var $lBiNe = parcelRequire("lBiNe");

 //# sourceMappingURL=index.js.map

});

parcelRegister("a2lmi", function(module, exports) {
$parcel$export(module.exports, "BaseTransport", () => (parcelRequire("l2hU1")).BaseTransport);
$parcel$export(module.exports, "FetchTransport", () => (parcelRequire("9yqZL")).FetchTransport);
$parcel$export(module.exports, "XHRTransport", () => (parcelRequire("5a5jw")).XHRTransport);
$parcel$export(module.exports, "makeNewFetchTransport", () => (parcelRequire("hu9Hi")).makeNewFetchTransport);
$parcel$export(module.exports, "makeNewXHRTransport", () => (parcelRequire("3FUEv")).makeNewXHRTransport);

var $l2hU1 = parcelRequire("l2hU1");


var $9yqZL = parcelRequire("9yqZL");


var $5a5jw = parcelRequire("5a5jw");


var $hu9Hi = parcelRequire("hu9Hi");


var $3FUEv = parcelRequire("3FUEv");

 //# sourceMappingURL=index.js.map

});

parcelRegister("gKr8t", function(module, exports) {

var $9B4fQ = parcelRequire("9B4fQ");


var $10d5H = parcelRequire("10d5H");


var $7G1r9 = parcelRequire("7G1r9");


var $2bfWW = parcelRequire("2bfWW");


var $cC0P5 = parcelRequire("cC0P5");


var $adWn1 = parcelRequire("adWn1");


var $9jPdT = parcelRequire("9jPdT");




var $iMHGI = parcelRequire("iMHGI");


var $8xqRi = parcelRequire("8xqRi");


var $3cnNA = parcelRequire("3cnNA");



var $11MAl = parcelRequire("11MAl");


var $5c4nm = parcelRequire("5c4nm");

let $6d0c6b833ab477dd$var$apolloClient = null;
const $6d0c6b833ab477dd$var$wrappedFetch = (0, $iMHGI.createWrappedFetch)();
const $6d0c6b833ab477dd$export$ed315e0c0d70f648 = 'agg';
const $6d0c6b833ab477dd$var$fragmentMatcher = new (0, $cC0P5.IntrospectionFragmentMatcher)({
    introspectionQueryResultData: {
        __schema: {
            types: (0, (/*@__PURE__*/$parcel$interopDefault($adWn1)))
        }
    }
});
const $6d0c6b833ab477dd$export$8ddb56c88a6a3feb = new (0, $5c4nm.BroadcastConfigurableInMemoryCache)({
    fragmentMatcher: $6d0c6b833ab477dd$var$fragmentMatcher
});
const $6d0c6b833ab477dd$export$73fc90876f9d2053 = ()=>{
    $6d0c6b833ab477dd$var$apolloClient = null;
};
const $6d0c6b833ab477dd$export$13fdb03e350a572c = ()=>{
    // Use mock gateway Apollo client in tests
    if (window.MOCK_GATEWAY_APOLLO_CLIENT) return window.MOCK_GATEWAY_APOLLO_CLIENT;
    if (!$6d0c6b833ab477dd$var$apolloClient) {
        $6d0c6b833ab477dd$var$apolloClient = $6d0c6b833ab477dd$var$createApolloClient();
        window.GLOBAL_APOLLO_AGG_CLIENT = $6d0c6b833ab477dd$var$apolloClient;
    }
    return $6d0c6b833ab477dd$var$apolloClient;
};
const $6d0c6b833ab477dd$var$createLinks = ()=>{
    const links = [
        (0, $9jPdT.createOnErrorLink)()
    ];
    const subscriptionLinks = [];
    links.push((0, $11MAl.SSRClientLink)($6d0c6b833ab477dd$export$ed315e0c0d70f648, $6d0c6b833ab477dd$export$8ddb56c88a6a3feb));
    subscriptionLinks.push((0, $3cnNA.AttachExtensionsLink));
    subscriptionLinks.push((0, $8xqRi.getAGGWebSocketLinkInstance)());
    links.push(new (0, $2bfWW.HttpLink)({
        credentials: 'include',
        uri: '/gateway/api/graphql',
        fetch: $6d0c6b833ab477dd$var$wrappedFetch
    }));
    return (0, $10d5H.split)(// Condition for handling subscriptions
    // we don't want to use subscriptions in SSR mode
    ({ query: query })=>{
        const definition = (0, $7G1r9.getMainDefinition)(query);
        return definition?.kind === 'OperationDefinition' && definition?.operation === 'subscription' && // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        true;
    }, // WebSocket link for subscriptions
    (0, $10d5H.from)(subscriptionLinks), // HTTP link for non-subscription operations
    (0, $10d5H.from)(links));
};
const $6d0c6b833ab477dd$var$createApolloClient = ()=>{
    if (typeof window['__APOLLO_AGG_STATE__'] === 'object') $6d0c6b833ab477dd$export$8ddb56c88a6a3feb.restore(window['__APOLLO_AGG_STATE__']);
    const client = new (0, $9B4fQ.ApolloClient)({
        // Prevent cache and network query to refresh when they are already preloaded on server-side.
        // Refreshing data will cause component to fallback to loading state.
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        ssrMode: Boolean(undefined),
        connectToDevTools: false,
        link: (0, $10d5H.from)([
            $6d0c6b833ab477dd$var$createLinks()
        ]),
        cache: $6d0c6b833ab477dd$export$8ddb56c88a6a3feb
    });
    // This is not actual API from Apollo. This field is read in next/packages/ssr-app/src/module-replacements/apollo-client.js
    client.__isAGGClient = true;
    return client;
};
module.exports["apolloAGGCache"] = $6d0c6b833ab477dd$export$8ddb56c88a6a3feb;
module.exports["getAGGClient"] = $6d0c6b833ab477dd$export$13fdb03e350a572c;

});

parcelRegister("8xqRi", function(module, exports) {

var $4cvLo = parcelRequire("4cvLo");

function $aa9065bb91596100$export$91893b414ff080f2() {
    let WEBSOCKET_URL;
    WEBSOCKET_URL = `wss://${window?.location?.host}/gateway/api/graphql/subscriptions`;
    return WEBSOCKET_URL;
}
let $aa9065bb91596100$var$wsLink;
function $aa9065bb91596100$export$4b71fe053d09625a() {
    const WEBSOCKET_URL = $aa9065bb91596100$export$91893b414ff080f2();
    if (!$aa9065bb91596100$var$wsLink) $aa9065bb91596100$var$wsLink = new (0, $4cvLo.GraphQLWSLink)({
        url: ()=>{
            return WEBSOCKET_URL;
        },
        shouldRetry: ()=>{
            return true;
        },
        keepAlive: (0, $4cvLo.KEEP_ALIVE),
        retryAttempts: 5
    });
    return $aa9065bb91596100$var$wsLink;
}
module.exports["getAGGWebSocketLinkInstance"] = $aa9065bb91596100$export$4b71fe053d09625a;

});

parcelRegister("4cvLo", function(module, exports) {

var $bKqeQ = parcelRequire("bKqeQ");


var $10d5H = parcelRequire("10d5H");


var $bPh6H = parcelRequire("bPh6H");


var $422HI = parcelRequire("422HI");


var $04e9M = parcelRequire("04e9M");


var $dbZMH = parcelRequire("dbZMH");


var $ac4MN = parcelRequire("ac4MN");


var $bBofs = parcelRequire("bBofs");

const $fca9c472df15863c$export$e9ff5bb5c39478ed = 600000;
class $fca9c472df15863c$export$b26b2f8eae2af9a extends (0, $10d5H.ApolloLink) {
    request(operation) {
        // Add null check for operation.getContext to prevent "Cannot read properties of undefined" errors
        const context = operation.getContext?.() || {};
        // context is coming from a previous link since we are using apollo v2
        // subscriptions does not have context or extensions in some cases
        return new (0, $10d5H.Observable)((observer)=>{
            const subscription = this.client.subscribe({
                ...operation,
                query: (0, $bPh6H.print)(operation.query),
                extensions: context?.extensions
            }, {
                next: (result)=>{
                    // Transform null data to empty object
                    const transformedResult = {
                        ...result,
                        data: result.data === null ? {} : result.data
                    };
                    observer.next(transformedResult);
                },
                complete: observer.complete.bind(observer),
                error: (err)=>{
                    if (this.closedInfo && !this.closedInfo?.wasClean && !err?.message) (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                        client.sendOperationalEvent({
                            source: 'confluence-AGGWebSocketLink',
                            actionSubject: 'webSocket',
                            action: 'closed-socket-error',
                            attributes: {
                                reason: this.closedInfo?.reason,
                                code: this.closedInfo?.code,
                                wasClean: this.closedInfo?.wasClean
                            }
                        });
                    });
                    if (err instanceof Error) return observer.error(err);
                    return observer.error(new (0, $422HI.ApolloErrorInterop)({
                        graphQLErrors: Array.isArray(err) ? err : [
                            err
                        ]
                    }));
                }
            });
            // keep track of the subscription so we can unsubscribe later
            this.replayQueries[operation.operationName] = {
                unsubscribe: subscription,
                query: (0, $bPh6H.print)(operation.query)
            };
            return subscription;
        });
    }
    constructor(options){
        super();
        this.client = void 0;
        this.internetConnectionState = 'healthy';
        this.timedOut = null;
        this.closedInfo = null;
        this.replayQueries = {};
        this.currentGetInternetConnectionStatePromise = null;
        this.onConnected = (_socket, _payload, wasRetry)=>{
            (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                client.sendOperationalEvent({
                    source: 'confluence-AGGWebSocketLink',
                    actionSubject: 'webSocket',
                    action: wasRetry ? 'reconnected' : 'connected'
                });
            });
        };
        this.verifyAndUpdateInternetHealth = async ()=>{
            this.currentGetInternetConnectionStatePromise = this.currentGetInternetConnectionStatePromise || (0, $dbZMH.getInternetConnectionState)();
            const internetHealthState = await this.currentGetInternetConnectionStatePromise;
            this.internetConnectionState = internetHealthState;
            this.currentGetInternetConnectionStatePromise = null;
        };
        this.verifyAndUpdateInternetHealthUntilHealthy = async ()=>{
            await this.verifyAndUpdateInternetHealth();
            if (this.internetConnectionState === 'healthy') return;
            else this.client?.terminate();
            await new Promise((resolve)=>{
                setTimeout(resolve, 500);
            });
            return this.verifyAndUpdateInternetHealthUntilHealthy();
        };
        this.retryWait = async (retries)=>{
            const retryDelayRange = await (0, $ac4MN.getDelayRangeFromGraphqlWebsocketState)(retries);
            // This is the logic reused from legacy WebSocket with a check verifyAndUpdateInternetHealthUntilHealthy
            // If the internet connection is healthy then we can retry, otherwise we do not need to retry
            // We subtract the time spent waiting to reconnect from the exponential backoff
            const startedAt = Date.now();
            await this.verifyAndUpdateInternetHealthUntilHealthy();
            // since we took some time to verify internet health, reduce the exponential backoff
            const msCheckingInternetHealth = Date.now() - startedAt;
            const retryDelay = (0, $ac4MN.getBackOffDelay)({
                range: retryDelayRange,
                timeSpent: msCheckingInternetHealth
            });
            // monitor status looks at if a user is idle or hidden to determine the retry delay
            await new Promise((resolve)=>{
                let timeoutId = setTimeout(resolve, retryDelay);
                const newRetryDelayRange = (0, $bBofs.calculateBackOffRange)({
                    status: 'active',
                    attemptsCount: retries
                });
                const msAlreadyWaited = Date.now() - startedAt;
                const newRetryDelay = (0, $ac4MN.getBackOffDelay)({
                    range: newRetryDelayRange,
                    timeSpent: msAlreadyWaited
                });
                const actualReconnectionDelay = Math.max(newRetryDelay - msAlreadyWaited, 0);
                // Clear old timeout and set a new one with the updated delay
                clearTimeout(timeoutId);
                timeoutId = setTimeout(resolve, actualReconnectionDelay);
            });
        };
        this.client = (0, $bKqeQ.createClient)({
            ...options,
            retryWait: this.retryWait,
            on: {
                connected: this.onConnected,
                closed: (info)=>{
                    this.closedInfo = info;
                },
                ping: (received)=>{
                    if (!received /* sent */ ) this.timedOut = setTimeout(()=>{
                        // unsubscribe so that we can reconnect with new arguments
                        for(const key in this.replayQueries)// unsubscribes queries so that we can reconnect with new arguments
                        if (this.replayQueries[key]) {
                            this.replayQueries[key].unsubscribe();
                            delete this.replayQueries[key];
                        }
                        this.client.terminate();
                    }, $fca9c472df15863c$export$e9ff5bb5c39478ed / 2);
                },
                pong: (received)=>{
                    if (received && this.timedOut !== null) clearTimeout(this.timedOut);
                }
            }
        });
    }
}
module.exports["KEEP_ALIVE"] = $fca9c472df15863c$export$e9ff5bb5c39478ed;
module.exports["GraphQLWSLink"] = $fca9c472df15863c$export$b26b2f8eae2af9a;

});

parcelRegister("dbZMH", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/getInternetConnectionState.ts when we move to Relay.
 */ // partially copied from Trello modified to use confluences network check
const $3d23f6bbdf409903$export$ddfffe3f5c167fa6 = async ()=>{
    // we can early return unhealthy if offline for navigator, but we cant if onLine.
    // That's because you can be online, but be waiting for VPN connection or something
    // else that blocks actually allowing internet.
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    if (!navigator.onLine) return 'unhealthy';
    for(let i = 0; i < 3; i++){
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        if (!navigator.onLine) return 'unhealthy';
        // stagger it a little because of flakey VPN's and firewalls
        await new Promise((res)=>setTimeout(res, 1000));
    }
    // we got 3 good attempts, safe to say healthy
    return 'healthy';
};
module.exports["getInternetConnectionState"] = $3d23f6bbdf409903$export$ddfffe3f5c167fa6;

});

parcelRegister("ac4MN", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/getBackOffDelay.ts when we move to Relay.
 */ // copied from Trello

var $bBofs = parcelRequire("bBofs");

function $5a87cb4548ea235b$export$ffd8c9a5b80f1e57(start, end) {
    const spread = end - start;
    return Math.floor(start + Math.random() * spread);
}
const $5a87cb4548ea235b$export$73e02b3a26ecb0d7 = ({ range: range, timeSpent: timeSpent = 0 })=>{
    const [lowerBound, upperBound] = range;
    const delay = $5a87cb4548ea235b$export$ffd8c9a5b80f1e57(lowerBound, upperBound);
    return Math.max(delay - timeSpent, 0);
};
const $5a87cb4548ea235b$export$ac8ba6656a385f56 = async (retries)=>{
    /**
	 * We're overriding the status multipliers here to make the reconnection
	 * back-off less aggressive. To reduce client
	 * reconnect load on graphql-subscriptions.
	 * The default status multipliers are: { active: 1, idle: 10 }.
	 */ const activeMultiplier = 1;
    let status = 'idle';
    if (typeof window !== 'undefined') // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    status = document.visibilityState === 'visible' ? 'active' : 'idle';
    else status = 'idle';
    return (0, $bBofs.calculateBackOffRange)({
        status: status,
        attemptsCount: retries,
        statusMultipliersOverride: {
            active: activeMultiplier,
            idle: 10
        }
    });
};
module.exports["getBackOffDelay"] = $5a87cb4548ea235b$export$73e02b3a26ecb0d7;
module.exports["getDelayRangeFromGraphqlWebsocketState"] = $5a87cb4548ea235b$export$ac8ba6656a385f56;

});

parcelRegister("bBofs", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/calculateBackOffRange.ts when we move to Relay.
 */ // copied from Trello

var $11y02 = parcelRequire("11y02");

function $35212ac5bc2e900f$export$de85ae9dfb4a57bc({ status: status, attemptsCount: attemptsCount, statusMultipliersOverride: statusMultipliersOverride, jitterStatusMultipliersOverride: jitterStatusMultipliersOverride, connectionHealth: connectionHealth = 'base', baseLowerBoundOverride: baseLowerBoundOverride, baseUpperBoundOverride: baseUpperBoundOverride, maxDelayOverride: maxDelayOverride }) {
    const [baseLowerBound, baseUpperBound] = (0, $11y02.getReconnectDelayBounds)(connectionHealth);
    const maxDelay = maxDelayOverride ?? (0, $11y02.getMaxDelay)({
        status: status,
        connectionHealth: connectionHealth
    });
    const statusMultipliers = statusMultipliersOverride ?? (0, $11y02.getDefaultStatusMultipliers)();
    const jitterStatusMultipliers = jitterStatusMultipliersOverride ?? (0, $11y02.jitterStatusMultipliers);
    const attemptsMultiplier = Math.pow(2, attemptsCount);
    const totalMultiplier = statusMultipliers[status] * attemptsMultiplier;
    const jitterMultiplier = jitterStatusMultipliers[status];
    const maxFirstActiveDelay = 2000;
    const maxFirstIdleDelay = 60000;
    let tempUpperOverride;
    if (attemptsCount > 0) tempUpperOverride = undefined;
    else if (status === 'active') tempUpperOverride = maxFirstActiveDelay;
    else tempUpperOverride = maxFirstIdleDelay;
    const lowerBound = (baseLowerBoundOverride ?? baseLowerBound) * totalMultiplier;
    const upperBound = tempUpperOverride ?? (baseUpperBoundOverride ?? baseUpperBound) * totalMultiplier * jitterMultiplier;
    return [
        Math.min(lowerBound, maxDelay),
        Math.min(upperBound, maxDelay)
    ];
}
module.exports["calculateBackOffRange"] = $35212ac5bc2e900f$export$de85ae9dfb4a57bc;

});

parcelRegister("11y02", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/backOffConfig.ts when we move to Relay.
 */ // copied from Trello
const $0b8d464841156fc9$var$TEN_MINUTES_IN_MS = 600000;
const $0b8d464841156fc9$export$d89658363be37383 = ({ status: status, connectionHealth: connectionHealth })=>{
    const maxDelays = {
        active: {
            base: 64000,
            serverIncident: $0b8d464841156fc9$var$TEN_MINUTES_IN_MS
        },
        idle: {
            base: 450000,
            serverIncident: $0b8d464841156fc9$var$TEN_MINUTES_IN_MS
        }
    };
    return maxDelays[status][connectionHealth];
};
const $0b8d464841156fc9$export$1b131e77a0e75a0a = ()=>({
        active: 1,
        idle: 15
    });
const $0b8d464841156fc9$export$a1d6d3ff41cd93e9 = {
    active: 1,
    idle: 2
};
const $0b8d464841156fc9$export$e5680a2329370bd3 = (connectionHealth)=>{
    const bounds = {
        base: [
            800,
            2000
        ],
        serverIncident: [
            800,
            4000
        ]
    };
    return bounds[connectionHealth];
};
module.exports["getMaxDelay"] = $0b8d464841156fc9$export$d89658363be37383;
module.exports["getDefaultStatusMultipliers"] = $0b8d464841156fc9$export$1b131e77a0e75a0a;
module.exports["jitterStatusMultipliers"] = $0b8d464841156fc9$export$a1d6d3ff41cd93e9;
module.exports["getReconnectDelayBounds"] = $0b8d464841156fc9$export$e5680a2329370bd3;

});

parcelRegister("3cnNA", function(module, exports) {

var $10d5H = parcelRequire("10d5H");

const $eb414ef0fc36a486$export$51a2bb897a605125 = new (0, $10d5H.ApolloLink)((operation, forward)=>{
    if (operation.variables && operation.variables.__extensions) {
        operation.setContext({
            extensions: operation.variables.__extensions
        });
        // remove the property since it's not an actual valid variable
        delete operation.variables.__extensions;
    }
    return forward(operation);
});
module.exports["AttachExtensionsLink"] = $eb414ef0fc36a486$export$51a2bb897a605125;

});

parcelRegister("lyWac", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");


var $3mugH = parcelRequire("3mugH");

// Mirrors GraphqlErrorProcessor's mark. Read through the global symbol registry rather than
// importing `isErrorMarkedAsHandled`, because ~20 test files mock
// `@confluence/graphql-error-processor` partially and a new import here would break all of them.
// The registry is the same mechanism GraphqlErrorProcessor relies on to share the mark across the
// preloader and main-app bundles, and `ignores errors already marked as handled` in this module's
// tests exercises the real `markErrorAsHandled`, so the key cannot drift unnoticed.
const $6e8f7926b945fe5e$var$HANDLED_ERROR_MARK_SYMBOL = Symbol.for('error marked as handled');
function $6e8f7926b945fe5e$var$isErrorMarkedAsHandled(error) {
    return typeof error === 'object' && error !== null && Boolean(error[$6e8f7926b945fe5e$var$HANDLED_ERROR_MARK_SYMBOL]);
}
const $6e8f7926b945fe5e$var$isLegacyUnauthorizedGraphQLError = (error)=>error?.extensions?.data?.authorized === false;
/**
 * A page the viewer is not allowed to see is a normal SSR outcome, not a defect — the render falls
 * back to the restricted-content screen. `query()` marks these as handled when a preloader resolves
 * with its query result, but a task that *rejects* with a permission error (or resolves with the
 * error itself) never passes through that path, so the handled mark alone does not keep restricted
 * pages out of the SSR prepare errors.
 *
 * Covers both status codes of the permission contract — 401 (unauthenticated) and 403 (not
 * permitted) — plus the legacy `extensions.data.authorized === false` shape, matching
 * `@confluence/unauthorized-error-boundary`. `isStatusCodeError` walks `graphQLErrors`,
 * `networkError` and `originalError`, so a rejected ApolloError wrapping a 403 is recognised too.
 * `@confluence/error-types` is used rather than the boundary's copy of this predicate to keep React
 * out of the preloader bundle.
 *
 * https://pug.jira-dev.com/wiki/spaces/CCB/pages/4709260932/GraphQL+Errors+Contract+for+Status+Code+401+and+403
 */ function $6e8f7926b945fe5e$var$isPermissionError(error) {
    const candidate = error;
    return (0, $aMcHK.isStatusCodeError)(candidate, '403', $6e8f7926b945fe5e$var$isLegacyUnauthorizedGraphQLError) || (0, $aMcHK.isStatusCodeError)(candidate, '401');
}
/**
 * Errors that are an expected outcome of preloading and must not be reported as SSR prepare errors.
 */ function $6e8f7926b945fe5e$var$isExpectedPreloadError(error) {
    return $6e8f7926b945fe5e$var$isErrorMarkedAsHandled(error) || $6e8f7926b945fe5e$var$isPermissionError(error);
}
function $6e8f7926b945fe5e$var$expandErrorToErrors(error) {
    // Error from createDataFetcherForSuspense might have nested errors
    const errors = [
        error
    ];
    if (Array.isArray(error.otherErrors)) errors.push(...error.otherErrors);
    delete error.otherErrors;
    return errors;
}
/**
 * `query()` and `queryAgg()` resolve to `{ data, errors, hasErrors }` rather than rejecting or
 * resolving to an `Error`, so a preloader that returns its result object straight into the task
 * list would otherwise slip past the `instanceof Error` checks below.
 */ function $6e8f7926b945fe5e$var$isPreloaderQueryResultWithErrors(value) {
    return typeof value === 'object' && value !== null && value.hasErrors === true && Array.isArray(value.errors);
}
/**
 * Only surfaces errors nobody has claimed. `query()` marks the expected ones (unauthorized,
 * not-found, and other known shapes) as handled before resolving, and those still come back with
 * `hasErrors: true` — reporting them here would turn every restricted or missing page into a bogus
 * SSR prepare error, since preloaders like `preloadPageStatusQuery` return their result object
 * straight into the task list.
 *
 * Filtering happens here, before the conversion below, because `new Error(message)` drops
 * `extensions` — the only place the permission status code lives on a plain GraphQL error object.
 */ function $6e8f7926b945fe5e$var$collectUnhandledQueryErrors(result) {
    const unhandledErrors = [];
    for (const error of result.errors ?? []){
        if ($6e8f7926b945fe5e$var$isExpectedPreloadError(error)) continue;
        unhandledErrors.push(error instanceof Error ? error : new Error(String(error?.message ?? error)));
    }
    return unhandledErrors;
}
function $6e8f7926b945fe5e$var$collectErrorsFromFulfilledValue(fulfilledValue) {
    if (fulfilledValue instanceof Error) return $6e8f7926b945fe5e$var$expandErrorToErrors(fulfilledValue);
    if (Array.isArray(fulfilledValue)) return fulfilledValue.flatMap((value)=>value instanceof Error || $6e8f7926b945fe5e$var$isPreloaderQueryResultWithErrors(value) ? $6e8f7926b945fe5e$var$collectErrorsFromFulfilledValue(value) : []);
    if ($6e8f7926b945fe5e$var$isPreloaderQueryResultWithErrors(fulfilledValue)) return $6e8f7926b945fe5e$var$collectUnhandledQueryErrors(fulfilledValue);
    return [];
}
async function $6e8f7926b945fe5e$export$ba9c3910d56be969(values) {
    if (!Array.isArray(values)) values = [
        values
    ];
    return Promise.allSettled(values).then((results)=>{
        const errors = [];
        for (const result of results){
            if (result.status === 'rejected') errors.push(...$6e8f7926b945fe5e$var$expandErrorToErrors(result.reason));
            else if (result.status === 'fulfilled') errors.push(...$6e8f7926b945fe5e$var$collectErrorsFromFulfilledValue(result.value));
        }
        // Drop the expected outcomes — already-handled and permission errors — so a restricted page
        // does not report a prepare error. Rejections and error values are filtered here rather than
        // at each collection site so that every path is held to the same rule; query results are
        // filtered earlier, while their `extensions` are still intact.
        const reportableErrors = errors.filter((error)=>!$6e8f7926b945fe5e$var$isExpectedPreloadError(error));
        if (reportableErrors.length > 0) {
            // Errors on preloader functions are not meant to break anything.
            // But we still want to know them...
            for (const error of reportableErrors)(0, $3mugH.ssrPrepareErrorsClient).submitError(new Error(`Error caught by waitForAllReturnWhenError: ${error.message}`));
            return reportableErrors;
        }
    });
}
module.exports["waitForAllReturnWhenError"] = $6e8f7926b945fe5e$export$ba9c3910d56be969;

});

parcelRegister("3mugH", function(module, exports) {

var $lrjR8 = parcelRequire("lrjR8");

const $d967841d02dde0d1$export$17bc715070d0e7ef = new (0, $lrjR8.SSRPrepareErrorsClient)();
module.exports["ssrPrepareErrorsClient"] = $d967841d02dde0d1$export$17bc715070d0e7ef;

});

parcelRegister("lrjR8", function(module, exports) {
class $7cc20c0ac0ad5b24$export$622a2782a1f9c63 {
    submitError(e, errorData = {}) {
        let additional = {};
        // Not actually importing the error class to avoid circular dependency
        const response = // RateLimitedError or BadStatusError
        e?.response || // Apollo Error
        e?.networkError?.response;
        if (response) additional = {
            response: {
                url: response.url,
                status: response.status,
                statusText: response.statusText
            }
        };
        this.errors.push({
            error: {
                message: e.message,
                stack: e.stack
            },
            meta: errorData,
            ...additional
        });
    }
    getErrors() {
        return this.errors;
    }
    constructor(){
        this.errors = void 0;
        this.errors = [];
    }
}
module.exports["SSRPrepareErrorsClient"] = $7cc20c0ac0ad5b24$export$622a2782a1f9c63;

});

parcelRegister("lrDw7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $6a66563ef19581ba$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $cozmU.useRef)(null);
    const setRef = (0, $cozmU.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};
module.exports["useElementRef"] = $6a66563ef19581ba$export$ff879f35a69d56b7;

});

parcelRegister("g3XYx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $f8fe10123ae9dc81$var$getHookDeps = (opts)=>{
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
const $f8fe10123ae9dc81$export$1775f27e7c8051ca = (opts = {
    cleanup: 'unmount'
})=>{
    const frames = (0, $cozmU.useRef)([]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (frames.current.length) {
                frames.current.forEach((id)=>cancelAnimationFrame(id));
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $f8fe10123ae9dc81$var$getHookDeps(opts));
    return (0, $cozmU.useCallback)((handler)=>{
        const id = requestAnimationFrame((time)=>{
            frames.current = frames.current.filter((frameId)=>frameId !== id);
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
module.exports["useRequestAnimationFrame"] = $f8fe10123ae9dc81$export$1775f27e7c8051ca;

});

parcelRegister("kyH1y", function(module, exports) {

var $jevsd = parcelRequire("jevsd");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/confluence/workspace/manifest.ts
var $ef785b50c9b3efca$var$confluenceWorkspaceAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $jevsd.ConfluenceWorkspaceAriResourceOwner),
    resourceType: (0, $jevsd.ConfluenceWorkspaceAriResourceType),
    resourceIdSlug: "{activationId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/
    }
};
// src/confluence/workspace/index.ts
var $ef785b50c9b3efca$export$d47d8a7e69df1865 = class _ConfluenceWorkspaceAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $ef785b50c9b3efca$var$confluenceWorkspaceAriStaticOpts.qualifier,
            platformQualifier: $ef785b50c9b3efca$var$confluenceWorkspaceAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $ef785b50c9b3efca$var$confluenceWorkspaceAriStaticOpts.resourceOwner,
            resourceType: $ef785b50c9b3efca$var$confluenceWorkspaceAriStaticOpts.resourceType,
            resourceId: `${opts.activationId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $ef785b50c9b3efca$var$confluenceWorkspaceAriStaticOpts);
        return new _ConfluenceWorkspaceAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $ef785b50c9b3efca$var$confluenceWorkspaceAriStaticOpts);
        return new _ConfluenceWorkspaceAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId;
    }
};
module.exports["ConfluenceWorkspaceAri"] = $ef785b50c9b3efca$export$d47d8a7e69df1865;

});

parcelRegister("jevsd", function(module, exports) {
// src/confluence/workspace/types.ts
var $e007b94796479ac0$export$19f1a63686ec0369 = "confluence", $e007b94796479ac0$export$f1c423a93fbc71 = "workspace";
module.exports["ConfluenceWorkspaceAriResourceOwner"] = $e007b94796479ac0$export$19f1a63686ec0369;
module.exports["ConfluenceWorkspaceAriResourceType"] = $e007b94796479ac0$export$f1c423a93fbc71;

});

parcelRegister("iU5Yo", function(module, exports) {
/**
 * @generated SignedSource<<01f44261cad9aef59fcacd236ec168f3>>
 * @relayHash 1e79e599cf0986bfab52cda14838f58b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b204ce99dbc883bcc44bc4a88014083df60b82880ea056642e055bb80de3551e
const $1361d756abf1f7da$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v4 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "args": [
            v4 /*: any*/ ,
            {
                "kind": "Literal",
                "name": "status",
                "value": [
                    "current",
                    "draft",
                    "archived"
                ]
            }
        ],
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
            {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "status"
                    }
                ]
            }
        ]
    }, v7 = {
        "args": [
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "spaceKey"
            }
        ],
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            {
                "concreteType": "SpaceUserMetadata",
                "kind": "LinkedField",
                "name": "currentUser",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isAdmin"
                    }
                ]
            }
        ]
    }, v8 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        v4 /*: any*/ 
    ], v9 = {
        "kind": "ScalarField",
        "name": "count"
    }, v10 = {
        "kind": "ScalarField",
        "name": "type"
    }, v11 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v12 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v13 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v14 = {
        "kind": "InlineFragment",
        "selections": [
            v13 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "jobTitle"
            }
        ],
        "type": "KnownUser"
    }, v15 = {
        "concreteType": "ConfluenceAgent",
        "kind": "LinkedField",
        "name": "agent",
        "plural": false,
        "selections": [
            v11 /*: any*/ ,
            v13 /*: any*/ ,
            v12 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "PageOwnershipByLineWithCollaboratorsDropdownContentQuery",
            "selections": [
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                {
                    "args": v8 /*: any*/ ,
                    "concreteType": "ConfluenceCollaboratorConnection",
                    "kind": "LinkedField",
                    "name": "confluence_contentCollaborators",
                    "plural": false,
                    "selections": [
                        v9 /*: any*/ ,
                        {
                            "concreteType": "ConfluenceCollaborator",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "person",
                                    "plural": false,
                                    "selections": [
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        v14 /*: any*/ 
                                    ]
                                },
                                v15 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "PageOwnershipByLineWithCollaboratorsDropdownContentQuery",
            "selections": [
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                {
                    "args": v8 /*: any*/ ,
                    "concreteType": "ConfluenceCollaboratorConnection",
                    "kind": "LinkedField",
                    "name": "confluence_contentCollaborators",
                    "plural": false,
                    "selections": [
                        v9 /*: any*/ ,
                        {
                            "concreteType": "ConfluenceCollaborator",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "person",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        v14 /*: any*/ 
                                    ]
                                },
                                v15 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "1e79e599cf0986bfab52cda14838f58b",
            "id": "b204ce99dbc883bcc44bc4a88014083df60b82880ea056642e055bb80de3551e",
            "metadata": {},
            "name": "PageOwnershipByLineWithCollaboratorsDropdownContentQuery",
            "operationKind": "query",
            "text": "query PageOwnershipByLineWithCollaboratorsDropdownContentQuery($cloudId:ID!,$id:ID!,$spaceKey:String!,$first:Int!){content(id:$id,status:[\"current\",\"draft\",\"archived\"]){nodes{id,status}},space(key:$spaceKey){id,currentUser{isAdmin}},confluence_contentCollaborators(cloudId:$cloudId,id:$id,first:$first){count,nodes{person{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId,jobTitle}},agent{displayName,accountId,profilePicture{path}}}}}"
        }
    };
}();
$1361d756abf1f7da$var$node.hash = "c82cea2a9b2b6126e7fc7b1f235c58f3";
var $1361d756abf1f7da$export$2e2bcd8739ae039 = $1361d756abf1f7da$var$node;
module.exports["default"] = $1361d756abf1f7da$export$2e2bcd8739ae039;

});

parcelRegister("jBVey", function(module, exports) {
// GraphQL Int is signed 32-bit; retain the existing request limit for all collaborators.
const $a8ef658bbe571a90$var$MAX_GRAPHQL_INT = 2147483647;
const $a8ef658bbe571a90$export$2ca5f942f8975c8a = ({ cloudId: cloudId, contentId: contentId, spaceKey: spaceKey })=>({
        cloudId: cloudId,
        id: contentId,
        spaceKey: spaceKey,
        first: $a8ef658bbe571a90$var$MAX_GRAPHQL_INT
    });
module.exports["getContentCollaboratorsQueryVariables"] = $a8ef658bbe571a90$export$2ca5f942f8975c8a;

});

parcelRegister("4YBSq", function(module, exports) {
/**
 * @generated SignedSource<<9700b2b14bf1783e20ed515703a9c457>>
 * @relayHash f85bb73042ebe75e2cb50dec93f9b7c4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ea06e652012418baf02c0133f828dbef03e488a63e53403257a821a52af7d139
const $16e983e3bee16ecd$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "fabricEditorSupported"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "embedded"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "collabService"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "subType"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "EditContentButtonQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "EditContentButtonQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "f85bb73042ebe75e2cb50dec93f9b7c4",
            "id": "ea06e652012418baf02c0133f828dbef03e488a63e53403257a821a52af7d139",
            "metadata": {},
            "name": "EditContentButtonQuery",
            "operationKind": "query",
            "text": "query EditContentButtonQuery($contentId:ID!){content(id:$contentId){nodes{id,type,operations{operation,targetType},metadata{frontend{fabricEditorSupported,embedded,collabService}},subType,space{id,key}}}}"
        }
    };
}();
$16e983e3bee16ecd$var$node.hash = "94b096c536d2633f3df010c4409c1c2a";
var $16e983e3bee16ecd$export$2e2bcd8739ae039 = $16e983e3bee16ecd$var$node;
module.exports["default"] = $16e983e3bee16ecd$export$2e2bcd8739ae039;

});

parcelRegister("kwDQA", function(module, exports) {
/**
 * @generated SignedSource<<c4c634ffb5984138b240a2bcc61996d1>>
 * @relayHash 68505bc224ec19edfba49afd43c7d907
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7618a04782001a87f52f617aa9203459f640bc016a7615579a83c2dc59caaf99
const $377c093245c44338$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ContentAnalyticsViewers",
            "kind": "LinkedField",
            "name": "contentAnalyticsViewers",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "count"
                }
            ]
        },
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "permissionType"
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useAnalyticsByLineQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useAnalyticsByLineQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "68505bc224ec19edfba49afd43c7d907",
            "id": "7618a04782001a87f52f617aa9203459f640bc016a7615579a83c2dc59caaf99",
            "metadata": {},
            "name": "useAnalyticsByLineQuery",
            "operationKind": "query",
            "text": "query useAnalyticsByLineQuery($contentId:ID!){contentAnalyticsViewers(contentId:$contentId){count},user:confluence_atlassianUser(current:true){id,confluence{permissionType}}}"
        }
    };
}();
$377c093245c44338$var$node.hash = "1059930ceaf11a1fca0cb8f2f9d20c27";
var $377c093245c44338$export$2e2bcd8739ae039 = $377c093245c44338$var$node;
module.exports["default"] = $377c093245c44338$export$2e2bcd8739ae039;

});

parcelRegister("euq7N", function(module, exports) {

var $7Ndnw = parcelRequire("7Ndnw");


var $grspz = parcelRequire("grspz");

const $6dc423d8105f54f8$export$f11fa81fda7aba5a = (extensions = window.__SSR_FORGE_EXTENSIONS__?.[0, $7Ndnw.FORGE_MODULE_BYLINE]?.extensions ?? [])=>{
    const keys = new Set();
    for (const extension of extensions){
        const contentPropertyKey = extension.properties.contentPropertyKey;
        if (!contentPropertyKey) continue;
        // Forge UI Kit namespaces useContentProperty keys, while apps using the REST API can
        // persist the manifest key directly. Query both exact forms and keep the response bounded.
        keys.add(contentPropertyKey);
        keys.add(`forge-${(0, $grspz.getLocalId)(extension.id)}-${contentPropertyKey}`);
    }
    return [
        ...keys
    ].sort();
};
module.exports["getBylineAppContentPropertyKeys"] = $6dc423d8105f54f8$export$f11fa81fda7aba5a;

});

parcelRegister("grspz", function(module, exports) {
const $cdcead6f01277136$export$957229695d10ea4a = (extensionId)=>{
    return extensionId.replace(/[^a-zA-Z0-9-]/g, '-');
};
module.exports["getLocalId"] = $cdcead6f01277136$export$957229695d10ea4a;

});

parcelRegister("7sf7C", function(module, exports) {
/**
 * @generated SignedSource<<fedf2e7c613e909441ea794a19d16f08>>
 * @relayHash 8547d0f98c831317a8e1f099d9dd5e48
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 287cd399384b3669f9337addcc127ff0da7c0f662eea8cff6a77161d92893bcf
const $7d674aec1e0705be$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "keys"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "keys",
                                    "variableName": "keys"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "number"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ByLineForgeAppGeneralContentPropertyQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ByLineForgeAppGeneralContentPropertyQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "8547d0f98c831317a8e1f099d9dd5e48",
            "id": "287cd399384b3669f9337addcc127ff0da7c0f662eea8cff6a77161d92893bcf",
            "metadata": {},
            "name": "ByLineForgeAppGeneralContentPropertyQuery",
            "operationKind": "query",
            "text": "query ByLineForgeAppGeneralContentPropertyQuery($contentId:ID!,$keys:[String!]){content(id:$contentId){nodes{id,properties(keys:$keys){nodes{id,key,version{number},value}}}}}"
        }
    };
}();
$7d674aec1e0705be$var$node.hash = "66eca16603f88617f8c995c6596e989e";
var $7d674aec1e0705be$export$2e2bcd8739ae039 = $7d674aec1e0705be$var$node;
module.exports["default"] = $7d674aec1e0705be$export$2e2bcd8739ae039;

});

parcelRegister("568fA", function(module, exports) {
/**
 * @generated SignedSource<<edb2a48d5268bebed303963270db4c3a>>
 * @relayHash b647ff34a22d9e67b3330f440f310bb5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8e540b0c89e30ec6f141235a6f4e47d93b9ce22a39faec34b35e59dfd7657f73
const $0dc90704ec36fa39$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        },
        {
            "kind": "Literal",
            "name": "status",
            "value": [
                "archived",
                "current",
                "draft"
            ]
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "title"
    }, v4 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v5 = {
        "kind": "ScalarField",
        "name": "key"
    }, v6 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v2 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            },
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "alias"
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "type"
    }, v8 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v9 = {
        "kind": "ScalarField",
        "name": "status"
    }, v10 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "smartFolderProperties"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ]
            }
        ],
        "storageKey": "properties(keys:[\"smartFolderProperties\"])"
    }, v11 = {
        "kind": "ScalarField",
        "name": "contentTypeModified"
    }, v12 = {
        "kind": "ScalarField",
        "name": "number"
    }, v13 = {
        "kind": "ScalarField",
        "name": "friendlyWhen"
    }, v14 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v15 = {
        "kind": "ScalarField",
        "name": "when"
    }, v16 = [
        v11 /*: any*/ ,
        v12 /*: any*/ ,
        v13 /*: any*/ ,
        {
            "kind": "LinkedField",
            "name": "by",
            "plural": false,
            "selections": [
                v14 /*: any*/ 
            ]
        },
        v15 /*: any*/ 
    ], v17 = [
        v11 /*: any*/ ,
        v12 /*: any*/ ,
        v13 /*: any*/ ,
        {
            "kind": "LinkedField",
            "name": "by",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                v14 /*: any*/ 
            ]
        },
        v15 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentTypesHeaderQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": v16 /*: any*/ 
                                },
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "draftVersion",
                                    "plural": false,
                                    "selections": v16 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentTypesHeaderQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": v17 /*: any*/ 
                                },
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "draftVersion",
                                    "plural": false,
                                    "selections": v17 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "b647ff34a22d9e67b3330f440f310bb5",
            "id": "8e540b0c89e30ec6f141235a6f4e47d93b9ce22a39faec34b35e59dfd7657f73",
            "metadata": {},
            "name": "ContentTypesHeaderQuery",
            "operationKind": "query",
            "text": "query ContentTypesHeaderQuery($contentId:ID){content(id:$contentId,status:[\"archived\",\"current\",\"draft\"]){nodes{id,title,operations{operation,targetType},space{id,name,key,alias},type,subType,status,properties(keys:[\"smartFolderProperties\"]){nodes{key,value}},version{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when},draftVersion{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when}}}}"
        }
    };
}();
$0dc90704ec36fa39$var$node.hash = "1e8693f245d726bc820bbd0bffbc0cff";
var $0dc90704ec36fa39$export$2e2bcd8739ae039 = $0dc90704ec36fa39$var$node;
module.exports["default"] = $0dc90704ec36fa39$export$2e2bcd8739ae039;

});

parcelRegister("fyUox", function(module, exports) {
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports

var $lyWac = parcelRequire("lyWac");


var $dYU3e = parcelRequire("dYU3e");


var $1Y111 = parcelRequire("1Y111");


var $zalpJ = parcelRequire("zalpJ");

const $bf604cb6b214d1ef$var$preloadHomepageId = async (spaceKey)=>{
    const res = await (0, $dYU3e.query)({
        query: (0, $zalpJ.PreloadHomepageIdQuery),
        variables: {
            spaceKey: spaceKey
        },
        __callerPackage__: "content-topper"
    });
    return res?.data?.space?.homepage?.id;
};
const $bf604cb6b214d1ef$var$preloadTitleContentProperty = (contentId, fetchPolicy = 'cache-first')=>(0, $dYU3e.query)({
        query: (0, $1Y111.default),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'archived',
                'draft'
            ]
        },
        fetchPolicy: fetchPolicy,
        __callerPackage__: "content-topper"
    });
const $bf604cb6b214d1ef$export$a65164d365713802 = async ({ contentId: contentId, contentIdPromise: contentIdPromise, spaceKey: spaceKey, fetchPolicy: fetchPolicy = 'cache-first' })=>{
    const promises = [];
    if (!contentId) {
        const homepageIdPromise = contentIdPromise || $bf604cb6b214d1ef$var$preloadHomepageId(spaceKey);
        promises.push(homepageIdPromise.then((homepageId)=>{
            return homepageId ? $bf604cb6b214d1ef$var$preloadTitleContentProperty(homepageId) : Promise.resolve({});
        }));
    } else promises.push($bf604cb6b214d1ef$var$preloadTitleContentProperty(contentId, fetchPolicy));
    return (0, $lyWac.waitForAllReturnWhenError)(promises);
};
module.exports["preloadPageTitleContentProperties"] = $bf604cb6b214d1ef$export$a65164d365713802;

});

parcelRegister("6IsMq", function(module, exports) {
/**
 * @generated SignedSource<<d76d95039bbf9cae17d368276aebc792>>
 * @relayHash b0b89409f45955f1d6631ca601f67f8b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 916fc9c88cdf0763a685d23187d4deb77c6c3625098021bbc28d6dba182b8d9b
const $684f397ef7ad0ae2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueAri"
        },
        {
            "defaultValue": 65536,
            "kind": "LocalArgument",
            "name": "maxTokenLength"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "issueAri"
        }
    ], v2 = {
        "args": [
            {
                "kind": "Variable",
                "name": "maxTokenLength",
                "variableName": "maxTokenLength"
            }
        ],
        "concreteType": "JiraMediaReadToken",
        "kind": "LinkedField",
        "name": "mediaReadToken",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "clientId"
            },
            {
                "kind": "ScalarField",
                "name": "endpointUrl"
            },
            {
                "kind": "ScalarField",
                "name": "tokenLifespanInSeconds"
            },
            {
                "concreteType": "JiraMediaTokenWithFilesConnection",
                "kind": "LinkedField",
                "name": "tokensWithFiles",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraMediaTokenWithFilesEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraMediaTokenWithFiles",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "token"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "graphqlHelpersFetchJiraMediaTokenQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueById",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "graphqlHelpersFetchJiraMediaTokenQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueById",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "b0b89409f45955f1d6631ca601f67f8b",
            "id": "916fc9c88cdf0763a685d23187d4deb77c6c3625098021bbc28d6dba182b8d9b",
            "metadata": {},
            "name": "graphqlHelpersFetchJiraMediaTokenQuery",
            "operationKind": "query",
            "text": "query graphqlHelpersFetchJiraMediaTokenQuery($issueAri:ID!,$maxTokenLength:Int=65536){jira{issueById(id:$issueAri){mediaReadToken(maxTokenLength:$maxTokenLength)@optIn(to:\"JiraMediaReadTokenInIssue\"){clientId,endpointUrl,tokenLifespanInSeconds,tokensWithFiles{edges{node{token}}}},id}}}"
        }
    };
}();
$684f397ef7ad0ae2$var$node.hash = "7036cf95096a08504e6375127746a507";
var $684f397ef7ad0ae2$export$2e2bcd8739ae039 = $684f397ef7ad0ae2$var$node;
module.exports["default"] = $684f397ef7ad0ae2$export$2e2bcd8739ae039;

});

parcelRegister("iTcHJ", function(module, exports) {
/**
 * @generated SignedSource<<5e736080ce8c5ab015a5851e0537f7fa>>
 * @relayHash 60dcb7a4a06a5eaa2ddb4f4df7437c8c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID da295508da11933cde6015c5899a2dae3ede521437117bf85391f779f362e076
const $cd49b7baa8bd0c54$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "missingContentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v3 = [
        {
            "condition": "missingContentId",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "status",
                            "variableName": "status"
                        }
                    ],
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "concreteType": "ContentBodyPerRepresentation",
                                    "kind": "LinkedField",
                                    "name": "body",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ContentBody",
                                            "kind": "LinkedField",
                                            "name": "atlas_doc_format",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "EmbeddedMediaToken",
                                                    "kind": "LinkedField",
                                                    "name": "mediaToken",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "token"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "MediaConfiguration",
            "kind": "LinkedField",
            "name": "mediaConfiguration",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "clientId"
                },
                {
                    "kind": "ScalarField",
                    "name": "fileStoreUrl"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "graphqlHelpersFetchMediaTokenQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "graphqlHelpersFetchMediaTokenQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "60dcb7a4a06a5eaa2ddb4f4df7437c8c",
            "id": "da295508da11933cde6015c5899a2dae3ede521437117bf85391f779f362e076",
            "metadata": {},
            "name": "graphqlHelpersFetchMediaTokenQuery",
            "operationKind": "query",
            "text": "query graphqlHelpersFetchMediaTokenQuery($contentId:ID,$status:[String],$missingContentId:Boolean=false){content(id:$contentId,status:$status)@skip(if:$missingContentId){nodes{id,body{atlas_doc_format{mediaToken{token}}}}},mediaConfiguration{clientId,fileStoreUrl}}"
        }
    };
}();
$cd49b7baa8bd0c54$var$node.hash = "c53e0852d23c6b17549e89592c16b84c";
var $cd49b7baa8bd0c54$export$2e2bcd8739ae039 = $cd49b7baa8bd0c54$var$node;
module.exports["default"] = $cd49b7baa8bd0c54$export$2e2bcd8739ae039;

});

parcelRegister("3j8TZ", function(module, exports) {
/**
 * @generated SignedSource<<bcf6371051972dda4e73703ef8d6345b>>
 * @relayHash 44fbfb9d6df590a6ee4e002cd5037220
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3e8b1b354828c70d1a3ff4efd4b04c1bb4b5dbec948132154a057ea3cc5e9c01
const $bcd0dbc3bf494067$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "missingContentId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "size"
    }, v7 = {
        "kind": "ScalarField",
        "name": "mimeType"
    }, v8 = {
        "kind": "ScalarField",
        "name": "processingStatus"
    }, v9 = {
        "kind": "ScalarField",
        "name": "createdAt"
    }, v10 = [
        {
            "condition": "missingContentId",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "status",
                            "variableName": "status"
                        }
                    ],
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "ContentBodyPerRepresentation",
                                    "kind": "LinkedField",
                                    "name": "body",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ContentBody",
                                            "kind": "LinkedField",
                                            "name": "atlas_doc_format",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "EmbeddedMediaToken",
                                                    "kind": "LinkedField",
                                                    "name": "mediaToken",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "token"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "cloudId",
                                                            "variableName": "cloudId"
                                                        }
                                                    ],
                                                    "concreteType": "MediaItem",
                                                    "kind": "LinkedField",
                                                    "name": "mediaItems",
                                                    "plural": true,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "type"
                                                        },
                                                        {
                                                            "concreteType": "MediaFileDetails",
                                                            "kind": "LinkedField",
                                                            "name": "details",
                                                            "plural": false,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                v6 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "mediaType"
                                                                },
                                                                v8 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "failReason"
                                                                },
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "concreteType": "MediaFilePreview",
                                                                    "kind": "LinkedField",
                                                                    "name": "preview",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "cdnUrl"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "MediaFileArtifact",
                                                                    "kind": "LinkedField",
                                                                    "name": "artifactsList",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v9 /*: any*/ ,
                                                                        v7 /*: any*/ ,
                                                                        v5 /*: any*/ ,
                                                                        v8 /*: any*/ ,
                                                                        v6 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "MediaFileRepresentations",
                                                                    "kind": "LinkedField",
                                                                    "name": "representations",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "MediaImageRepresentation",
                                                                            "kind": "LinkedField",
                                                                            "name": "image",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "_empty"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "MediaFileMetadata",
                                                                    "kind": "LinkedField",
                                                                    "name": "mediaMetadata",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "duration"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "MediaFileAbuseClassification",
                                                                    "kind": "LinkedField",
                                                                    "name": "abuseClassification",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "classification"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "confidence"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "MediaConfiguration",
            "kind": "LinkedField",
            "name": "mediaConfiguration",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "clientId"
                },
                {
                    "kind": "ScalarField",
                    "name": "fileStoreUrl"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "graphqlHelpersFetchMediaTokenWithMediaItemsQuery",
            "selections": v10 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "graphqlHelpersFetchMediaTokenWithMediaItemsQuery",
            "selections": v10 /*: any*/ 
        },
        "params": {
            "cacheID": "44fbfb9d6df590a6ee4e002cd5037220",
            "id": "3e8b1b354828c70d1a3ff4efd4b04c1bb4b5dbec948132154a057ea3cc5e9c01",
            "metadata": {},
            "name": "graphqlHelpersFetchMediaTokenWithMediaItemsQuery",
            "operationKind": "query",
            "text": "query graphqlHelpersFetchMediaTokenWithMediaItemsQuery($cloudId:ID!,$contentId:ID,$status:[String],$missingContentId:Boolean=false){content(id:$contentId,status:$status)@skip(if:$missingContentId){nodes{id,body{atlas_doc_format{mediaToken{token},mediaItems(cloudId:$cloudId){id,type,details{name,size,mimeType,mediaType,processingStatus,failReason,createdAt,preview{cdnUrl},artifactsList{createdAt,mimeType,name,processingStatus,size,url},representations{image{_empty}},mediaMetadata{duration},abuseClassification{classification,confidence}}}}}}},mediaConfiguration{clientId,fileStoreUrl}}"
        }
    };
}();
$bcd0dbc3bf494067$var$node.hash = "c03e617139295e9107b3907ee1a06cb3";
var $bcd0dbc3bf494067$export$2e2bcd8739ae039 = $bcd0dbc3bf494067$var$node;
module.exports["default"] = $bcd0dbc3bf494067$export$2e2bcd8739ae039;

});

parcelRegister("k5dl6", function(module, exports) {
/**
 * @generated SignedSource<<6dc466aba14c78f3432cf6d35f092a95>>
 * @relayHash 9f9cb3b101c0d783a0151d795ee8a444
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 97db17732754f14f8a0a3024abfd1a748e416b71742d827d0bfd273f20b59b06
const $bff977656480fdfe$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "commentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v3 = {
        "args": [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "contentId"
            }
        ],
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
            {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    {
                        "concreteType": "Space",
                        "kind": "LinkedField",
                        "name": "space",
                        "plural": false,
                        "selections": [
                            v1 /*: any*/ ,
                            v2 /*: any*/ 
                        ]
                    },
                    v2 /*: any*/ 
                ]
            }
        ]
    }, v4 = [
        {
            "kind": "Variable",
            "name": "commentId",
            "variableName": "commentId"
        },
        {
            "kind": "Literal",
            "name": "depth",
            "value": "ALL"
        },
        {
            "kind": "Literal",
            "name": "type",
            "value": "UNRESOLVED"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "value"
    }, v6 = [
        v5 /*: any*/ 
    ], v7 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v6 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v8 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v6 /*: any*/ 
    }, v9 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v10 = {
        "kind": "ScalarField",
        "name": "isInlineComment"
    }, v11 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v13 = {
        "kind": "ScalarField",
        "name": "when"
    }, v14 = {
        "kind": "ScalarField",
        "name": "number"
    }, v15 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v12 /*: any*/ 
                ]
            },
            v13 /*: any*/ ,
            v14 /*: any*/ 
        ]
    }, v16 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "editui"
            }
        ]
    }, v17 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v18 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v19 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v20 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v12 /*: any*/ ,
            v17 /*: any*/ ,
            v18 /*: any*/ ,
            v19 /*: any*/ 
        ]
    }, v21 = {
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "replies",
        "plural": true,
        "selections": [
            v1 /*: any*/ ,
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v10 /*: any*/ ,
            v11 /*: any*/ ,
            v15 /*: any*/ ,
            v16 /*: any*/ ,
            v20 /*: any*/ 
        ]
    }, v22 = {
        "alias": "user",
        "args": [
            {
                "kind": "Literal",
                "name": "current",
                "value": true
            }
        ],
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "confluence_atlassianUser",
        "plural": false,
        "selections": [
            v1 /*: any*/ ,
            v12 /*: any*/ ,
            {
                "concreteType": "AtlassianUserPhoto",
                "kind": "LinkedField",
                "name": "photos",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "isPrimary"
                    }
                ]
            }
        ],
        "storageKey": "confluence_atlassianUser(current:true)"
    }, v23 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v24 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v23 /*: any*/ ,
                    v12 /*: any*/ 
                ]
            },
            v13 /*: any*/ ,
            v14 /*: any*/ 
        ]
    }, v25 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v23 /*: any*/ ,
            v12 /*: any*/ ,
            v17 /*: any*/ ,
            v18 /*: any*/ ,
            v19 /*: any*/ 
        ]
    }, v26 = {
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "replies",
        "plural": true,
        "selections": [
            v1 /*: any*/ ,
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v10 /*: any*/ ,
            v11 /*: any*/ ,
            v24 /*: any*/ ,
            v16 /*: any*/ ,
            v25 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "InlineCommentsFocusedInlineCommentQuery",
            "selections": [
                v3 /*: any*/ ,
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "ancestors",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ 
                                    ]
                                },
                                v1 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ 
                            ]
                        }
                    ]
                },
                v22 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "InlineCommentsFocusedInlineCommentQuery",
            "selections": [
                v3 /*: any*/ ,
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "ancestors",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        v26 /*: any*/ 
                                    ]
                                },
                                v1 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v24 /*: any*/ ,
                                v16 /*: any*/ ,
                                v25 /*: any*/ ,
                                v26 /*: any*/ 
                            ]
                        }
                    ]
                },
                v22 /*: any*/ 
            ]
        },
        "params": {
            "cacheID": "9f9cb3b101c0d783a0151d795ee8a444",
            "id": "97db17732754f14f8a0a3024abfd1a748e416b71742d827d0bfd273f20b59b06",
            "metadata": {},
            "name": "InlineCommentsFocusedInlineCommentQuery",
            "operationKind": "query",
            "text": "query InlineCommentsFocusedInlineCommentQuery($commentId:ID!,$contentId:ID){content(id:$contentId){nodes{id,type,space{id,operations{operation,targetType}},operations{operation,targetType}}},comments(commentId:$commentId,depth:ALL,type:UNRESOLVED){nodes{ancestors{id,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,isInlineComment,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},links{webui,editui},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},replies{id,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,isInlineComment,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},links{webui,editui},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}}}},id,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,isInlineComment,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},links{webui,editui},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},replies{id,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,isInlineComment,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},links{webui,editui},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}}}}},user:confluence_atlassianUser(current:true){id,displayName,photos{value,isPrimary}}}"
        }
    };
}();
$bff977656480fdfe$var$node.hash = "c6bc55705b1b90c4e9cb60ee0b5a4650";
var $bff977656480fdfe$export$2e2bcd8739ae039 = $bff977656480fdfe$var$node;
module.exports["default"] = $bff977656480fdfe$export$2e2bcd8739ae039;

});

parcelRegister("5DJsZ", function(module, exports) {
/**
 * @generated SignedSource<<8b96b7ca504d956e62c9a3c7888eb72c>>
 * @relayHash 736318216100158fedfd1efdb0277723
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ee7b55ba4a12d84512c880cfd1a46392ff785081052c438befeefd868cef06a6
const $4dc353069380bea7$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "draftShareId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skipPublishedFragment"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v4 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                }
            ]
        }
    ], v6 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "condition": "skipPublishedFragment",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "alias": "emojiTitlePublished",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "key",
                                            "value": "emoji-title-published"
                                        }
                                    ],
                                    "concreteType": "PaginatedJsonContentPropertyList",
                                    "kind": "LinkedField",
                                    "name": "properties",
                                    "plural": false,
                                    "selections": v5 /*: any*/ ,
                                    "storageKey": "properties(key:\"emoji-title-published\")"
                                }
                            ]
                        },
                        {
                            "alias": "emojiTitleDraft",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "emoji-title-draft"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v5 /*: any*/ ,
                            "storageKey": "properties(key:\"emoji-title-draft\")"
                        },
                        {
                            "concreteType": "ContentProperties",
                            "kind": "LinkedField",
                            "name": "contentProperties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PublishedContentProperties",
                                    "kind": "LinkedField",
                                    "name": "latest",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "defaultTitleEmoji"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "EmojiTitleQuery",
            "selections": v6 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "EmojiTitleQuery",
            "selections": v6 /*: any*/ 
        },
        "params": {
            "cacheID": "736318216100158fedfd1efdb0277723",
            "id": "ee7b55ba4a12d84512c880cfd1a46392ff785081052c438befeefd868cef06a6",
            "metadata": {},
            "name": "EmojiTitleQuery",
            "operationKind": "query",
            "text": "query EmojiTitleQuery($contentId:ID,$status:[String],$draftShareId:String,$skipPublishedFragment:Boolean!){content(id:$contentId,draftShareId:$draftShareId,status:$status){nodes{id,emojiTitlePublished:properties(key:\"emoji-title-published\")@skip(if:$skipPublishedFragment){nodes{id,key,value,version{number}}},emojiTitleDraft:properties(key:\"emoji-title-draft\"){nodes{id,key,value,version{number}}},contentProperties{latest{defaultTitleEmoji}}}}}"
        }
    };
}();
$4dc353069380bea7$var$node.hash = "c3af19fccb4a5096e4bb34c9aa198098";
var $4dc353069380bea7$export$2e2bcd8739ae039 = $4dc353069380bea7$var$node;
module.exports["default"] = $4dc353069380bea7$export$2e2bcd8739ae039;

});

parcelRegister("7PLO8", function(module, exports) {
const $3009aa09d1bfedbe$export$93a0fdadbf6c055a = ()=>{
    return new URLSearchParams(window.location.search.substring(1)).get('draftShareId') || '';
};
module.exports["getDraftShareIdFromQueryParam"] = $3009aa09d1bfedbe$export$93a0fdadbf6c055a;

});

parcelRegister("irrTO", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $9o4Fw = parcelRequire("9o4Fw");

const $e1546bd447729439$export$f4a1f447ac6a7a9a = (contentId, useCache = true)=>{
    return (0, $dYU3e.query)({
        query: (0, $9o4Fw.default),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ],
            ...!useCache ? {
                cacheBuster: Date.now()
            } : {}
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only',
        // Match Apollo's warm-cache behavior across editor unmounts and subsequent page visits.
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr -- This controls request-scoped cache retention, not rendered output.
        relayQueryPreloadRetention: 'environment',
        __callerPackage__: "content-appearance"
    });
};
module.exports["preloadDraftContentAppearance"] = $e1546bd447729439$export$f4a1f447ac6a7a9a;

});

parcelRegister("kae7O", function(module, exports) {
/**
 * @generated SignedSource<<235e2f4f1cae802c5b7683463fdf34f9>>
 * @relayHash 177df4e8b836b390b9636d650c93a7b2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 73afdec0b7224f93dd9771ff4d32ef23242471659162b27d31de856f0e22f612
const $99e3ac9ccccf9f94$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                }
            ]
        }
    ], v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "alias": "pageTitlePublished",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "page-title-property-published"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v2 /*: any*/ ,
                            "storageKey": "properties(key:\"page-title-property-published\")"
                        },
                        {
                            "alias": "pageTitleDraft",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "page-title-property-draft"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v2 /*: any*/ ,
                            "storageKey": "properties(key:\"page-title-property-draft\")"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "coverPictureWidth"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useTitleContentPropertiesForEditorQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useTitleContentPropertiesForEditorQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "177df4e8b836b390b9636d650c93a7b2",
            "id": "73afdec0b7224f93dd9771ff4d32ef23242471659162b27d31de856f0e22f612",
            "metadata": {},
            "name": "useTitleContentPropertiesForEditorQuery",
            "operationKind": "query",
            "text": "query useTitleContentPropertiesForEditorQuery($contentId:ID,$status:[String]){content(id:$contentId,status:$status){nodes{id,pageTitlePublished:properties(key:\"page-title-property-published\"){nodes{id,key,value,version{number}}},pageTitleDraft:properties(key:\"page-title-property-draft\"){nodes{id,key,value,version{number}}},metadata{frontend{coverPictureWidth}}}}}"
        }
    };
}();
$99e3ac9ccccf9f94$var$node.hash = "cdd7743e3348e4dc97a35c6808323ae0";
var $99e3ac9ccccf9f94$export$2e2bcd8739ae039 = $99e3ac9ccccf9f94$var$node;
module.exports["default"] = $99e3ac9ccccf9f94$export$2e2bcd8739ae039;

});

parcelRegister("grd6j", function(module, exports) {
/**
 * @generated SignedSource<<eff7d44a3c3325ad9844d6a92fba38bc>>
 * @relayHash f812791104b0d3338eca867ab249c516
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a655ee1f977a9f534301bf4073cd137e9afcf643751bd79aaaac4c541f973511
const $634ac6ca07897c3c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentBodyPerRepresentation",
                            "kind": "LinkedField",
                            "name": "body",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentBody",
                                    "kind": "LinkedField",
                                    "name": "dynamic",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "representation"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "BylinePageAdfQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "BylinePageAdfQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "f812791104b0d3338eca867ab249c516",
            "id": "a655ee1f977a9f534301bf4073cd137e9afcf643751bd79aaaac4c541f973511",
            "metadata": {},
            "name": "BylinePageAdfQuery",
            "operationKind": "query",
            "text": "query BylinePageAdfQuery($contentId:ID,$status:[String]){content(id:$contentId,status:$status){nodes{id,body{dynamic{value,representation}}}}}"
        }
    };
}();
$634ac6ca07897c3c$var$node.hash = "71971ced9613217ef152b156007bcf74";
var $634ac6ca07897c3c$export$2e2bcd8739ae039 = $634ac6ca07897c3c$var$node;
module.exports["default"] = $634ac6ca07897c3c$export$2e2bcd8739ae039;

});

parcelRegister("jGizm", function(module, exports) {

var $2zscg = parcelRequire("2zscg");

const $04d4b8463fee3aa7$var$extensionCache = new WeakMap();
const $04d4b8463fee3aa7$var$isStringArray = (value)=>Array.isArray(value) && value.every((item)=>typeof item === 'string');
/**
 * Most property values (`title`, `key`, `type`, `resource`, `icon`, …) are plain strings
 * rather than JSON, so parsing them unconditionally throws for the majority of the list —
 * around 1,100 caught `SyntaxError`s per pass on a real 143-app payload, which dominates
 * the transform.
 *
 * A JSON document can only open as an object, array, string or number, or be one of the
 * three bare literals. Anything else would have thrown and fallen back to the raw string,
 * so skipping the parse is equivalent.
 *
 * Property values that are not strings are kept verbatim for the same reason: stringifying
 * them for `JSON.parse` throws for anything but a bare literal, so the raw value survives.
 */ const $04d4b8463fee3aa7$var$canStartJsonDocument = (value)=>{
    const firstCharacter = value[0];
    return firstCharacter === '{' || firstCharacter === '[' || firstCharacter === '"' || firstCharacter === '-' || firstCharacter >= '0' && firstCharacter <= '9' || value === 'true' || value === 'false' || value === 'null';
};
const $04d4b8463fee3aa7$var$normalizeProperties = (properties)=>{
    const normalizedProperties = properties.reduce((acc, property)=>{
        if (!property.value || !property.key) return acc;
        if (typeof property.value !== 'string' || !$04d4b8463fee3aa7$var$canStartJsonDocument(property.value.trim())) {
            acc[property.key] = property.value;
            return acc;
        }
        try {
            const jsonValue = JSON.parse(property.value);
            acc[property.key] = jsonValue;
        } catch (_error) {
            acc[property.key] = property.value;
        }
        return acc;
    }, {});
    if ('migratedFrom' in normalizedProperties && !$04d4b8463fee3aa7$var$isStringArray(normalizedProperties.migratedFrom)) {
        const { migratedFrom: _migratedFrom, ...propertiesWithoutInvalidMigratedFrom } = normalizedProperties;
        return propertiesWithoutInvalidMigratedFrom;
    }
    return normalizedProperties;
};
const $04d4b8463fee3aa7$export$9ff84ea1b2ab439c = (extensions)=>{
    if (!extensions || extensions.length === 0) return [];
    if ($04d4b8463fee3aa7$var$extensionCache.has(extensions)) return $04d4b8463fee3aa7$var$extensionCache.get(extensions);
    const result = (extensions || []).flatMap((extension)=>{
        if (!extension) return [];
        if (!extension.environmentKey) return [];
        return [
            {
                id: extension.id,
                appId: extension.appId,
                key: extension.key,
                environmentId: extension.environmentId,
                environmentType: extension.environmentType === (0, $2zscg.ExtensionEnvironment).DEVELOPMENT || extension.environmentType === (0, $2zscg.ExtensionEnvironment).STAGING || extension.environmentType === (0, $2zscg.ExtensionEnvironment).PRODUCTION ? extension.environmentType : (0, $2zscg.ExtensionEnvironment).DEVELOPMENT,
                environmentKey: extension.environmentKey,
                properties: $04d4b8463fee3aa7$var$normalizeProperties(extension.properties),
                license: extension.license ? {
                    ...extension.license,
                    capabilitySet: $04d4b8463fee3aa7$var$mapCapabilitySet(extension.license.capabilitySet)
                } : null,
                userAccess: extension.userAccess ? {
                    hasAccess: extension.userAccess.hasAccess ?? false,
                    enabled: extension.userAccess.enabled ?? false
                } : null,
                type: extension.type,
                installationId: extension.installationId,
                appVersion: extension.appVersion ?? undefined,
                consentUrl: extension.consentUrl ?? undefined,
                remoteInstallationRegion: extension.remoteInstallationRegion ?? undefined,
                migrationKey: extension.migrationKey ?? undefined,
                egress: extension.egress?.flatMap((egress)=>{
                    if (!egress.type || !egress.addresses) return [];
                    return [
                        {
                            type: egress.type,
                            addresses: egress.addresses?.flatMap((address)=>address ?? []),
                            category: egress.category ?? undefined,
                            inScopeEUD: egress.inScopeEUD ?? undefined
                        }
                    ];
                }) ?? undefined,
                sandboxPolicies: extension.sandboxPolicies ?? undefined,
                scopes: extension.scopes ?? undefined,
                installationConfig: extension.installationConfig?.flatMap((config)=>{
                    if (!config?.key || config.value === null) return [];
                    return [
                        {
                            key: config.key,
                            value: config.value
                        }
                    ];
                }) ?? undefined,
                dataClassificationPolicyDecision: {
                    status: extension.hiddenBy === 'APP_ACCESS_RULES' ? 'BLOCKED' : 'ALLOWED'
                }
            }
        ];
    });
    const IS_TESTING_ENV = false;
    if (!IS_TESTING_ENV) $04d4b8463fee3aa7$var$extensionCache.set(extensions, result);
    return result;
};
const $04d4b8463fee3aa7$var$mapCapabilitySet = (capabilitySet)=>{
    switch(capabilitySet){
        case 'CAPABILITY_ADVANCED':
            return 'capabilityAdvanced';
        default:
            return 'capabilityStandard';
    }
};
module.exports["transformPreFilteredExtensions"] = $04d4b8463fee3aa7$export$9ff84ea1b2ab439c;

});

parcelRegister("2zscg", function(module, exports) {
var $a413c718e4c7bf40$export$6e95f5308d9156f9 = /*#__PURE__*/ function(ExtensionEnvironment) {
    ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExtensionEnvironment["STAGING"] = "STAGING";
    ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
    return ExtensionEnvironment;
}({});
const $a413c718e4c7bf40$export$9a2372818e2520c6 = {
    ATTACHMENT_ACTION: 'confluence:attachmentAction',
    BYLINE: 'confluence:contentBylineItem',
    CONTEXT_MENU: 'confluence:contextMenu',
    CONTENT_ACTION: 'confluence:contentAction',
    FULL_PAGE: 'confluence:fullPage',
    GLOBAL_PAGE: 'confluence:globalPage',
    GLOBAL_SETTINGS: 'confluence:globalSettings',
    HOMEPAGE_FEED: 'confluence:homepageFeed',
    SPACE_PAGE: 'confluence:spacePage',
    SPACE_SETTINGS: 'confluence:spaceSettings',
    CUSTOM_CONTENT: 'confluence:customContent',
    MACRO: 'xen:macro',
    TEST_MODULE: 'test:module'
};
const $a413c718e4c7bf40$export$f06ffa3aa6bfec95 = {
    BACKLOG_ACTION: 'jira:backlogAction',
    BOARD_ACTION: 'jira:boardAction',
    PERSONAL_SETTINGS_PAGE: 'jira:personalSettingsPage',
    FULL_PAGE: 'jira:fullPage',
    ISSUE_PANEL: 'jira:issuePanel',
    ISSUE_ACTION: 'jira:issueAction',
    ISSUE_GLANCE: 'jira:issueGlance',
    ISSUE_CONTEXT: 'jira:issueContext',
    ISSUE_ACTIVITY: 'jira:issueActivity',
    UI_MODIFICATIONS: 'jira:uiModifications',
    CUSTOM_FIELD: 'jira:customField',
    CUSTOM_FIELD_TYPE: 'jira:customFieldType',
    ADMIN_PAGE: 'jira:adminPage',
    GLOBAL_PAGE: 'jira:globalPage',
    PROJECT_PAGE: 'jira:projectPage',
    PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
    DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
    ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
    DASHBOARD_GADGET: 'jira:dashboardGadget',
    WORKFLOW_VALIDATOR: 'jira:workflowValidator',
    WORKFLOW_CONDITION: 'jira:workflowCondition',
    WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
    SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
    SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};
const $a413c718e4c7bf40$export$586232a3e4271798 = {
    CUSTOM_MERGE_CHECK: 'bitbucket:mergeCheck',
    DYNAMIC_PIPELINES_PROVIDER: 'bitbucket:dynamicPipelinesProvider',
    REPOSITORY_CODE_FILE_VIEWER: 'bitbucket:repoCodeFileViewer',
    REPOSITORY_CODE_OVERVIEW_CARD: 'bitbucket:repoCodeOverviewCard',
    REPOSITORY_CODE_OVERVIEW_ACTION: 'bitbucket:repoCodeOverviewAction',
    REPOSITORY_CODE_OVERVIEW_PANEL: 'bitbucket:repoCodeOverviewPanel',
    REPOSITORY_PULL_REQUEST_CARD: 'bitbucket:repoPullRequestCard',
    REPOSITORY_PULL_REQUEST_ACTION: 'bitbucket:repoPullRequestAction',
    REPOSITORY_PULL_REQUEST_OVERVIEW_PANEL: 'bitbucket:repoPullRequestOverviewPanel',
    REPOSITORY_MAIN_MENU_PAGE: 'bitbucket:repoMainMenuPage',
    REPOSITORY_SETTINGS_MENU_PAGE: 'bitbucket:repoSettingsMenuPage',
    PROJECT_SETTINGS_MENU_PAGE: 'bitbucket:projectSettingsMenuPage',
    WORKSPACE_GLOBAL_PAGE: 'bitbucket:workspaceGlobalPage',
    WORKSPACE_PERSONAL_SETTINGS_PAGE: 'bitbucket:workspacePersonalSettingsPage',
    WORKSPACE_SETTINGS_MENU_PAGE: 'bitbucket:workspaceSettingsMenuPage'
};
const $a413c718e4c7bf40$export$ffcb70f38ee10c0a = {
    FULL_PAGE: 'global:fullPage',
    GLOBAL_UI: 'global:ui'
};
module.exports["ExtensionEnvironment"] = $a413c718e4c7bf40$export$6e95f5308d9156f9;
module.exports["ConfluenceExtension"] = $a413c718e4c7bf40$export$9a2372818e2520c6;
module.exports["JiraExtension"] = $a413c718e4c7bf40$export$f06ffa3aa6bfec95;
module.exports["BitbucketExtension"] = $a413c718e4c7bf40$export$586232a3e4271798;
module.exports["GlobalExtension"] = $a413c718e4c7bf40$export$ffcb70f38ee10c0a;

});

parcelRegister("nIvaQ", function(module, exports) {

var $7ZQNA = parcelRequire("7ZQNA");

const $c4f625141049567c$export$1248f2ac56981fbd = ()=>(0, $7ZQNA.CollabDraftQuery);
module.exports["getCollabDraftQuery"] = $c4f625141049567c$export$1248f2ac56981fbd;

});

parcelRegister("7ZQNA", function(module, exports) {

var $lU81J = parcelRequire("lU81J");

const $270318977b9095e1$export$89183b1b5e58f33c = (0, $lU81J.default);
module.exports["CollabDraftQuery"] = $270318977b9095e1$export$89183b1b5e58f33c;

});

parcelRegister("lU81J", function(module, exports) {
/**
 * @generated SignedSource<<81d932c04171cccd3ee1c517fa2180ce>>
 * @relayHash cd92794db2ea2a3b9bfa36b4fb9ae833
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 44e85cfd7f416b92fd30c810982ddfc4aeaa8b9ab964fe47829b79185c29b63a
const $e1affc2f9f206abd$var$node = function() {
    var v0 = {
        "defaultValue": "",
        "kind": "LocalArgument",
        "name": "draftShareId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hydrateAdf"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "hydrateAdf",
                    "variableName": "hydrateAdf"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "CollabDraft",
            "kind": "LinkedField",
            "name": "collabDraft",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "document"
                },
                {
                    "kind": "ScalarField",
                    "name": "version"
                },
                {
                    "concreteType": "CollabDraftMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CollabDraftQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CollabDraftQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "cd92794db2ea2a3b9bfa36b4fb9ae833",
            "id": "44e85cfd7f416b92fd30c810982ddfc4aeaa8b9ab964fe47829b79185c29b63a",
            "metadata": {},
            "name": "CollabDraftQuery",
            "operationKind": "query",
            "text": "query CollabDraftQuery($id:ID!,$draftShareId:String=\"\",$hydrateAdf:Boolean){collabDraft(id:$id,draftShareId:$draftShareId,hydrateAdf:$hydrateAdf){document,version,metadata{title}}}"
        }
    };
}();
$e1affc2f9f206abd$var$node.hash = "3cf6959ca06a0e7e4a4e60e0c720b14e";
var $e1affc2f9f206abd$export$2e2bcd8739ae039 = $e1affc2f9f206abd$var$node;
module.exports["default"] = $e1affc2f9f206abd$export$2e2bcd8739ae039;

});

parcelRegister("hNtOj", function(module, exports) {

var $etu7G = parcelRequire("etu7G");

const $120c25b1424bdefe$export$c82fe4eede9104df = new (0, $etu7G.SSRPermissionsErrorHandler)();
module.exports["ssrPermissionsErrorHandler"] = $120c25b1424bdefe$export$c82fe4eede9104df;

});

parcelRegister("etu7G", function(module, exports) {
class $c6d83b8df27b1c26$export$e70f491dc46ba2ed {
    markSSRPreloadPermissionError(route, error) {
        this.hasSSRPreloadPermissionsErrorForRoute = route;
        if (error) this.errorType = error?.graphQLErrors?.[0]?.extensions?.data?.errors?.[0]?.message?.key === 'confluence.content.restricted.inherited' ? 'inherited' : 'view';
    }
    getRestrictedRoute() {
        return this.hasSSRPreloadPermissionsErrorForRoute || window.__SSR_RESTRICTED_PAGE__?.route || null;
    }
    getErrorType() {
        return this.errorType || window.__SSR_RESTRICTED_PAGE__?.errorType || null;
    }
    constructor(){
        this.hasSSRPreloadPermissionsErrorForRoute = void 0;
        this.errorType = void 0;
        this.hasSSRPreloadPermissionsErrorForRoute = null;
        this.errorType = null;
    }
}
module.exports["SSRPermissionsErrorHandler"] = $c6d83b8df27b1c26$export$e70f491dc46ba2ed;

});

parcelRegister("6GQtz", function(module, exports) {

var $6RwwD = parcelRequire("6RwwD");


var $6mKj3 = parcelRequire("6mKj3");

const $1f40ba7d8e61cd02$var$isTrelloBoardUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?trello\.com\/b/);
const $1f40ba7d8e61cd02$var$isFigmaFileUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?figma\.com\/(design|board|file|proto|slides)/);
const $1f40ba7d8e61cd02$var$isFigmaMakeSiteUrl = (url)=>!!url.match(/^https:\/\/.+\.figma\.site/);
const $1f40ba7d8e61cd02$var$isMiroUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?miro\.com\/app\/board/);
const $1f40ba7d8e61cd02$var$isCanvaUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?canva\.com\/design/);
const $1f40ba7d8e61cd02$var$isLucidUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?lucid\.app\/lucidchart/);
const $1f40ba7d8e61cd02$var$isGoogleSlidesUrl = (url)=>!!url.match(/^https:\/\/docs\.google\.com\/presentation/);
const $1f40ba7d8e61cd02$var$isOneDrivePowerPointUrl = (url)=>!!url.match(/^https:\/\/onedrive\.live\.com\/:p/) || !!url.match(/^https:\/\/1drv\.ms\/p/);
const $1f40ba7d8e61cd02$var$isTrelloCardUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?trello\.com\/c/);
const $1f40ba7d8e61cd02$var$isPowerBIUrl = (url)=>!!url.match(/^https:\/\/app\.powerbi\.com\/(groups|reportEmbed)/);
const $1f40ba7d8e61cd02$var$isGoogleDocsUrl = (url)=>!!url.match(/^https:\/\/docs\.google\.com\/document/);
// https://learn.microsoft.com/en-us/onedrive/developer/controls/file-pickers/?view=odsp-graph-online
const $1f40ba7d8e61cd02$var$isLearnMicrosoftUrl = (url)=>!!url.match(/^https:\/\/learn\.microsoft\.com/);
// https://support.google.com/mail/answer/112508?hl=en&co=GENIE.Platform%3DDesktop
const $1f40ba7d8e61cd02$var$isSupportGoogleUrl = (url)=>!!url.match(/^https:\/\/support\.google\.com/);
// https://docs.github.com/en/codespaces
const $1f40ba7d8e61cd02$var$isDocsGithubUrl = (url)=>!!url.match(/^https:\/\/docs\.github\.com/);
const $1f40ba7d8e61cd02$var$isDropboxUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?dropbox\.com\/(home|preview|s|sh|sc|t|scl)/);
const $1f40ba7d8e61cd02$var$isBoxUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?box\.com\/(folder|file|notes|integrations|services|s|v)/);
const $1f40ba7d8e61cd02$var$isSlackUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?slack\.com\/(archives|client)/);
const $1f40ba7d8e61cd02$var$isTeamsUrl = (url)=>!!url.match(/^https:\/\/teams\.microsoft\.com\/l\/channel/) || !!url.match(/^https:\/\/teams\.cloud\.microsoft\/l\/channel/);
const $1f40ba7d8e61cd02$var$isLovableAppUrl = (url)=>!!url.match(/^https:\/\/.+\.lovable\.app/);
const $1f40ba7d8e61cd02$var$isReplitAppUrl = (url)=>!!url.match(/^https:\/\/.+\.replit\.app/);
class $1f40ba7d8e61cd02$export$9d24f5da29b1273e extends (0, $6RwwD.EditorCardProvider) {
    getHardCodedAppearance(url) {
        if (this.shouldDisplayAsEmbed(url)) return 'embed';
        if (this.shouldDisplayAsCard(url)) return 'block';
        return super.getHardCodedAppearance(url);
    }
    /**
   * Opt in to honouring an explicitly-requested embed appearance as the default
   * (validated, with a card fallback) for the quick-insert embed flow. Both active
   * cohorts of the quick-insert embeds experiment (`prioritizeLinkInQIM` and
   * `prioritizeEmbedInQIM`) enable this — they differ only in quick-insert menu
   * ordering, not in embedding behaviour. Only `control` and unenrolled users keep
   * the existing behaviour.
   *
   * The platform only calls this when a link is inserted with a requested embed
   * appearance and the user has no saved preference, so the exposure here is
   * scoped to the quick-insert embed insertion path.
   */ shouldHonorRequestedEmbedAsDefault() {
        return (0, $6mKj3.expVal)('confluence_quick_insert_embeds', 'cohort', 'control') !== 'control';
    }
    shouldDisplayAsEmbed(url) {
        return $1f40ba7d8e61cd02$var$isTrelloBoardUrl(url) || $1f40ba7d8e61cd02$var$isFigmaFileUrl(url) || $1f40ba7d8e61cd02$var$isFigmaMakeSiteUrl(url) || $1f40ba7d8e61cd02$var$isMiroUrl(url) || $1f40ba7d8e61cd02$var$isCanvaUrl(url) || $1f40ba7d8e61cd02$var$isLucidUrl(url) || $1f40ba7d8e61cd02$var$isGoogleSlidesUrl(url) || $1f40ba7d8e61cd02$var$isOneDrivePowerPointUrl(url);
    }
    shouldDisplayAsCard(url) {
        return $1f40ba7d8e61cd02$var$isTrelloCardUrl(url) || $1f40ba7d8e61cd02$var$isPowerBIUrl(url) || $1f40ba7d8e61cd02$var$isGoogleDocsUrl(url) || $1f40ba7d8e61cd02$var$isLearnMicrosoftUrl(url) || $1f40ba7d8e61cd02$var$isSupportGoogleUrl(url) || $1f40ba7d8e61cd02$var$isDocsGithubUrl(url) || $1f40ba7d8e61cd02$var$isDropboxUrl(url) || $1f40ba7d8e61cd02$var$isBoxUrl(url) || $1f40ba7d8e61cd02$var$isSlackUrl(url) || $1f40ba7d8e61cd02$var$isTeamsUrl(url) || $1f40ba7d8e61cd02$var$isLovableAppUrl(url) || $1f40ba7d8e61cd02$var$isReplitAppUrl(url);
    }
    constructor(envKey, baseUrlOverride, onResolve, customCardClient, supportedUrlFilter, name){
        super(envKey, baseUrlOverride, 'CONFLUENCE', onResolve, customCardClient, supportedUrlFilter);
        this.name = void 0;
        this.name = name ?? 'editorCardProvider';
    }
}
module.exports["ConfluenceEditorCardProvider"] = $1f40ba7d8e61cd02$export$9d24f5da29b1273e;

});

parcelRegister("6RwwD", function(module, exports) {
/* eslint-disable require-unicode-regexp,prefer-regex-literals */ 
var $6Q8Dd = parcelRequire("6Q8Dd");


var $8OcYi = parcelRequire("8OcYi");


var $3ewaO = parcelRequire("3ewaO");


var $4yccB = parcelRequire("4yccB");


var $kzwaO = parcelRequire("kzwaO");


var $cXJjm = parcelRequire("cXJjm");


var $ggGdk = parcelRequire("ggGdk");


var $drRzc = parcelRequire("drRzc");


var $iDrrr = parcelRequire("iDrrr");


var $biKbJ = parcelRequire("biKbJ");


var $iyuxZ = parcelRequire("iyuxZ");


var $koAyx = parcelRequire("koAyx");


var $8kONW = parcelRequire("8kONW");

const $d4521f0694a3bb0e$var$BATCH_WAIT_TIME = 50;
// Check if it is matching a Jira Roadmaps or Jira Timeline url
// NOT to be confused with JSM timeline
const $d4521f0694a3bb0e$var$JIRA_ROADMAP_OR_TIMELINE_REGEX = /^https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/boards\/.*?\/(timeline|roadmap)\/?/;
const $d4521f0694a3bb0e$var$POLARIS_VIEW_REGEX = /^https:\/\/.*?\/jira\/polaris\/projects\/[^\/]+?\/ideas\/view\/\d+$|^https:\/\/.*?\/secure\/JiraProductDiscoveryAnonymous\.jspa\?hash=\w+|^https:\/\/.*?\/jira\/polaris\/share\/\w+|^https:\/\/.*?\/jira\/discovery\/share\/views\/[\w-]+(\?selectedIssue=[\w-]+&issueViewLayout=sidebar&issueViewSection=[\w-]+)?$/;
const $d4521f0694a3bb0e$var$JWM_VIEW_REGEX = /^https:\/\/.*?\/jira\/core\/projects\/[^\/]+?\/(timeline|calendar|list|board|summary|(form\/[^\/]+?))\/?/;
const $d4521f0694a3bb0e$var$JIRA_LIST_REGEX = /^https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/list\/?/;
const $d4521f0694a3bb0e$var$GIPHY_MEDIA_REGEX = /^https:\/\/(.*?\.)?giphy\.com\/(gifs|media|clips)\//;
const $d4521f0694a3bb0e$var$PROFORMA_VIEW_REGEX = /^https:\/\/[^/]+\/jira\/(core|software(\/c)?|servicedesk)\/projects\/\w+\/forms\/form\/direct\/\d+\/\d+.*$/;
// prettier-ignore
const $d4521f0694a3bb0e$var$CONFLUENCE_WHITEBOARD_DECIMAL_REGEX = RegExp("\\/wiki\\/spaces\\/?.*\\/whiteboard\\/(?<resourceId>\\d+)(\\?\\/)?");
// prettier-ignore
const $d4521f0694a3bb0e$var$CONFLUENCE_WHITEBOARD_UUID_REGEX = RegExp("\\/wiki\\/spaces\\/?.*\\/whiteboard\\/(?<resourceId>[0-9a-fA-F]{8}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{12})(\\?\\/)?");
const $d4521f0694a3bb0e$var$CONFLUENCE_DATABASE_REGEX = /\/wiki\/spaces\/~?[\d\w]+\/database\/\d+(\?.*)?$/;
const $d4521f0694a3bb0e$var$YOUTUBE_VIDEO_REGEX = /^https:\/\/(.*?\.)?(youtube\..*?\/(watch\?|v\/|shorts\/)|youtu\.be)/;
// prettier-ignore
const $d4521f0694a3bb0e$var$LOOM_VIDEO_URL_REGEX = RegExp("^https:\\/\\/(.*?\\.)?(loom\\..*?\\/(share|embed))\\/([a-zA-Z0-9-]*-)?(?<videoId>[a-f0-9]{32})");
// prettier-ignore
const $d4521f0694a3bb0e$var$LOOM_PLAYLIST_URL_REGEX = /^https:\/\/(.*?\.)?loom\..*?\/(?:playlists\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(?:\/view)?|embed\/playlists\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})(?:\?|$)/i;
const $d4521f0694a3bb0e$var$LOOM_SCREENSHOT_URL_REGEX = RegExp("^https:\\/\\/(.*?\\.)?loom\\..*?\\/i\\/(?<id>[a-f0-9]{32})");
const $d4521f0694a3bb0e$var$JIRA_DASHBOARD_REGEX = /^https:\/\/.*?\/jira\/dashboards\/[0-9]+.*/;
const $d4521f0694a3bb0e$var$JIRA_BACKLOG_REGEX = /https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/boards\/\d\/backlog\??.*/;
const $d4521f0694a3bb0e$var$JIRA_BOARD_REGEX = /https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/boards\/\d\??.*/;
const $d4521f0694a3bb0e$var$JIRA_PLAN_REGEX = RegExp("https:\\/\\/.*?\\/jira\\/plans\\/(?<resourceId>\\d+)");
// prettier-ignore
const $d4521f0694a3bb0e$var$JIRA_PLAN_WITH_SCENARIO_REGEX = RegExp("https:\\/\\/.*?\\/jira\\/plans\\/(?<resourceId>\\d+)\\/scenarios\\/(?<resourceContext>\\d+)\\/(timeline|summary|calendar|program\\/\\d+|dependencies)\\/?");
const $d4521f0694a3bb0e$var$JIRA_VERSION_REGEX = /https:\/\/.*?\/projects\/[^\/]+?\/versions\/\d+\/tab\/release-report-all-issues/;
const $d4521f0694a3bb0e$var$JIRA_FORM_REGEX = /https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/form\/\d\??.*/;
const $d4521f0694a3bb0e$var$JIRA_SUMMARY_REGEX = /^https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/summary/;
const $d4521f0694a3bb0e$var$ROVO_AGENT_PROFILE_PAGE_REGEX = /^https:\/\/.*?\/people\/agent\/.+$/;
const $d4521f0694a3bb0e$var$CUSTOMER_360_LANDING_PAGE_REGEX = /^https:\/\/customer\.atlassian\.com\/.*$/;
// prettier-ignore
const $d4521f0694a3bb0e$var$CONFLUENCE_TEAM_CALENDARS_REGEX = RegExp("\\/wiki\\/spaces\\/(?<resourceContext>[^\\/]+)\\/calendars\\/(?<resourceId>[a-zA-Z0-9-]+)");
const $d4521f0694a3bb0e$var$JIRA_ISSUE_NAVIGATOR_REGEX = /^https:\/\/.*?\/jira\/software|core\/(c\/)?projects\/[^\/]+?\/issues\/?/;
const $d4521f0694a3bb0e$var$AVP_VISUALIZATION_VIEW_REGEX = /^https:\/\/.*?\/avpviz\/c\/[^\/]+.*/;
const $d4521f0694a3bb0e$var$ARTIFACT_UUID = '[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}';
// Keep in sync with ARTIFACT_URL_PATTERNS in @atlassian/native-embeds-artifacts-experience
const $d4521f0694a3bb0e$var$ARTIFACT_SHARE_REGEX = [
    new RegExp(`/artifacts/${$d4521f0694a3bb0e$var$ARTIFACT_UUID}(?:[/?#].*)?$`),
    new RegExp(`/apps/${$d4521f0694a3bb0e$var$ARTIFACT_UUID}/${$d4521f0694a3bb0e$var$ARTIFACT_UUID}/[^?#]*\\?(?:[^#]*&)?smartlink=artifact`)
];
const $d4521f0694a3bb0e$var$DASHBOARDS_CHART_VIEW_REGEX = /^https:\/\/.*?\/dashboards\/c\/[^\/]+.*/;
const $d4521f0694a3bb0e$var$JIRA_WORK_ITEM_REGEX = /\/browse\/((?:\w+)-(?:\d+))/i;
const $d4521f0694a3bb0e$var$DOES_URL_MATCH_PATH_START_REGEX = /^[a-zA-Z0-9]/;
const $d4521f0694a3bb0e$var$DOES_URL_MATCH_PATH_END_REGEX = /[a-zA-Z0-9]$/;
const $d4521f0694a3bb0e$var$CONFLUENCE_SHORT_LINK_URL_REGEX = /^https:\/\/[^/?#]+\/wiki\/x\/[A-Za-z0-9_-]+\/?(?:[?#].*)?$/;
const $d4521f0694a3bb0e$var$isConfluenceShortLinkUrl = (url)=>url.match($d4521f0694a3bb0e$var$CONFLUENCE_SHORT_LINK_URL_REGEX);
const $d4521f0694a3bb0e$var$isJiraRoadmapOrTimeline = (url)=>url.match($d4521f0694a3bb0e$var$JIRA_ROADMAP_OR_TIMELINE_REGEX);
const $d4521f0694a3bb0e$var$isPolarisView = (url)=>url.match($d4521f0694a3bb0e$var$POLARIS_VIEW_REGEX);
const $d4521f0694a3bb0e$var$isJwmView = (url)=>url.match($d4521f0694a3bb0e$var$JWM_VIEW_REGEX);
const $d4521f0694a3bb0e$var$isJiraList = (url)=>url.match($d4521f0694a3bb0e$var$JIRA_LIST_REGEX);
const $d4521f0694a3bb0e$var$isGiphyMedia = (url)=>url.match($d4521f0694a3bb0e$var$GIPHY_MEDIA_REGEX);
const $d4521f0694a3bb0e$var$isProformaView = (url)=>url.match($d4521f0694a3bb0e$var$PROFORMA_VIEW_REGEX);
const $d4521f0694a3bb0e$var$isConfluenceWhiteboard = (url)=>url.match($d4521f0694a3bb0e$var$CONFLUENCE_WHITEBOARD_DECIMAL_REGEX) || url.match($d4521f0694a3bb0e$var$CONFLUENCE_WHITEBOARD_UUID_REGEX);
const $d4521f0694a3bb0e$var$isConfluenceDatabase = (url)=>url.match($d4521f0694a3bb0e$var$CONFLUENCE_DATABASE_REGEX);
const $d4521f0694a3bb0e$var$isYoutubeVideo = (url)=>url.match($d4521f0694a3bb0e$var$YOUTUBE_VIDEO_REGEX);
const $d4521f0694a3bb0e$var$isLoomVideoUrl = (url)=>{
    return url.match($d4521f0694a3bb0e$var$LOOM_VIDEO_URL_REGEX);
};
const $d4521f0694a3bb0e$var$isLoomPlaylistUrl = (url)=>{
    return url.match($d4521f0694a3bb0e$var$LOOM_PLAYLIST_URL_REGEX);
};
const $d4521f0694a3bb0e$var$isLoomScreenshotUrl = (url)=>{
    return url.match($d4521f0694a3bb0e$var$LOOM_SCREENSHOT_URL_REGEX);
};
const $d4521f0694a3bb0e$var$isJiraDashboard = (url)=>{
    return url.match($d4521f0694a3bb0e$var$JIRA_DASHBOARD_REGEX);
};
const $d4521f0694a3bb0e$var$isJiraBacklog = (url)=>{
    return url.match($d4521f0694a3bb0e$var$JIRA_BACKLOG_REGEX);
};
const $d4521f0694a3bb0e$var$isJiraBoard = (url)=>{
    return url.match($d4521f0694a3bb0e$var$JIRA_BOARD_REGEX);
};
const $d4521f0694a3bb0e$var$isJiraPlan = (url)=>{
    return url.match($d4521f0694a3bb0e$var$JIRA_PLAN_REGEX) || url.match($d4521f0694a3bb0e$var$JIRA_PLAN_WITH_SCENARIO_REGEX);
};
const $d4521f0694a3bb0e$var$isJiraVersion = (url)=>{
    return url.match($d4521f0694a3bb0e$var$JIRA_VERSION_REGEX);
};
const $d4521f0694a3bb0e$var$isJiraForm = (url)=>{
    return url.match($d4521f0694a3bb0e$var$JIRA_FORM_REGEX);
};
const $d4521f0694a3bb0e$var$isJiraSummary = (url)=>{
    return url.match($d4521f0694a3bb0e$var$JIRA_SUMMARY_REGEX);
};
const $d4521f0694a3bb0e$var$isRovoAgentProfilePage = (url)=>{
    return url.match($d4521f0694a3bb0e$var$ROVO_AGENT_PROFILE_PAGE_REGEX);
};
const $d4521f0694a3bb0e$var$isCustomer360LandingPage = (url)=>url.match($d4521f0694a3bb0e$var$CUSTOMER_360_LANDING_PAGE_REGEX);
const $d4521f0694a3bb0e$var$isConfluenceTeamCalendars = (url)=>url.match($d4521f0694a3bb0e$var$CONFLUENCE_TEAM_CALENDARS_REGEX);
const $d4521f0694a3bb0e$var$isJiraIssueNavigator = (url)=>url.match($d4521f0694a3bb0e$var$JIRA_ISSUE_NAVIGATOR_REGEX);
const $d4521f0694a3bb0e$var$isAvpVisualizationView = (url)=>url.match($d4521f0694a3bb0e$var$AVP_VISUALIZATION_VIEW_REGEX) || ((0, $iDrrr.fg)('platform_avp_viz_dashboard_link_embed') ? url.match($d4521f0694a3bb0e$var$DASHBOARDS_CHART_VIEW_REGEX) : null);
const $d4521f0694a3bb0e$var$isArtifactsShareView = (url)=>{
    for (const pattern of $d4521f0694a3bb0e$var$ARTIFACT_SHARE_REGEX){
        const match = url.match(pattern);
        if (match) return match;
    }
    return null;
};
const $d4521f0694a3bb0e$export$6a9668b99d8a1708 = (url)=>$d4521f0694a3bb0e$var$JIRA_WORK_ITEM_REGEX.test(url);
// Local UrlChecker-compatible wrapper around the boolean-returning
// `isConfluenceSlideUrl` from `./url-checkers` (the single source of truth for
// slide URL matching). Wrapping (rather than aliasing the imported identifier
// directly inside the exported `internalUrlCheckers` object) avoids the
// @atlaskit/editor/no-re-export lint rule and gives the registry a uniform
// `(url) => RegExpMatchArray | null` signature. Consumers of
// `internalUrlCheckers` only check the truthiness of the result, so returning
// a synthetic single-element match array (or `null`) preserves behaviour.
const $d4521f0694a3bb0e$var$isConfluenceSlide = (url)=>(0, $8kONW.isConfluenceSlideUrl)(url) ? [
        url
    ] : null;
const $d4521f0694a3bb0e$export$da256e60841d38fd = {
    isJiraRoadmapOrTimeline: $d4521f0694a3bb0e$var$isJiraRoadmapOrTimeline,
    isPolarisView: $d4521f0694a3bb0e$var$isPolarisView,
    isJwmView: $d4521f0694a3bb0e$var$isJwmView,
    isJiraList: $d4521f0694a3bb0e$var$isJiraList,
    isConfluenceWhiteboard: $d4521f0694a3bb0e$var$isConfluenceWhiteboard,
    isConfluenceDatabase: $d4521f0694a3bb0e$var$isConfluenceDatabase,
    isConfluenceSlide: $d4521f0694a3bb0e$var$isConfluenceSlide,
    isJiraDashboard: $d4521f0694a3bb0e$var$isJiraDashboard,
    isJiraBacklog: $d4521f0694a3bb0e$var$isJiraBacklog,
    isJiraBoard: $d4521f0694a3bb0e$var$isJiraBoard,
    isJiraPlan: $d4521f0694a3bb0e$var$isJiraPlan,
    isJiraVersion: $d4521f0694a3bb0e$var$isJiraVersion,
    isJiraForm: $d4521f0694a3bb0e$var$isJiraForm,
    isJiraSummary: $d4521f0694a3bb0e$var$isJiraSummary,
    isRovoAgentProfilePage: $d4521f0694a3bb0e$var$isRovoAgentProfilePage,
    isConfluenceTeamCalendars: $d4521f0694a3bb0e$var$isConfluenceTeamCalendars,
    isJiraIssueNavigator: $d4521f0694a3bb0e$var$isJiraIssueNavigator
};
function $d4521f0694a3bb0e$export$4006295459a20a0(url) {
    return Object.values($d4521f0694a3bb0e$export$da256e60841d38fd).some((checker)=>checker(url));
}
function $d4521f0694a3bb0e$export$78234eee43b97e81(url) {
    return !$d4521f0694a3bb0e$export$4006295459a20a0(url);
}
function $d4521f0694a3bb0e$var$getAppearanceForNode(node) {
    return node.type === 'blockCard' ? 'block' : node.type === 'embedCard' ? 'embed' : 'inline';
}
function $d4521f0694a3bb0e$var$isCardNode(node) {
    return [
        'inlineCard',
        'blockCard',
        'embedCard'
    ].includes(node.type) && !!node.attrs && 'url' in node.attrs && typeof node.attrs.url === 'string';
}
class $d4521f0694a3bb0e$export$e4635c0135e1a519 extends (0, $drRzc.NodeDataProvider) {
    refreshCache(node) {
        if (this.getCacheStatusForNode(node) !== 'network') this.getData(node, ()=>{});
    }
    getData(node, callback) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) return;
        // if we can load a response from cache, use it first
        const key = this.nodeDataKey(jsonNode);
        const details = this.smartCardLocalCacheClient.getItem(key);
        // NAVX-4712: Handle responses with non-resolved statuses that were previously cached
        const isResolvedCachedResponse = details && details.meta && (0, $ggGdk.getStatus)(details) === 'resolved';
        if (isResolvedCachedResponse) callback({
            data: details
        });
        // if parent class NodeDataProvider has cached the network request for the node
        // we can skip fetching the data async and updating the session storage cache
        if (isResolvedCachedResponse && this.getCacheStatusForNode(jsonNode) === 'network') return;
        // fetch the latest data async and update the session storage cache
        this.getDataAsync(node, (payload)=>{
            const response = payload.data;
            if (!payload.error && response?.meta) {
                const status = (0, $ggGdk.getStatus)(response);
                if (status === 'resolved') this.smartCardLocalCacheClient.setItem(key, response);
            }
            callback(payload);
        });
    }
    nodeDataKey(node) {
        if (!(0, $iDrrr.fg)('platform_smartlink_inline_resolve_optimization')) return node.attrs.url;
        return `${node.attrs.url}|${$d4521f0694a3bb0e$var$getAppearanceForNode(node)}`;
    }
    fetchNodesData(nodes) {
        const promises = nodes.map((node)=>{
            const url = node.attrs.url;
            const appearance = (0, $iDrrr.fg)('platform_smartlink_inline_resolve_optimization') ? $d4521f0694a3bb0e$var$getAppearanceForNode(node) : undefined;
            return this.cardClient.fetchData(url, false, appearance);
        });
        return Promise.all(promises);
    }
    isNodeSupported(node) {
        if (!$d4521f0694a3bb0e$var$isCardNode(node)) return false;
        if (!this.supportedUrlFilter) return true;
        return this.supportedUrlFilter(node.attrs.url);
    }
    async batchProviders(keys) {
        // EDM-2205: Batch requests in the case that user paste multiple links at
        // once. This is so that only one /providersData is being called.
        const providersData = await this.fetchProvidersData();
        return keys.map(()=>providersData);
    }
    async checkLinkResolved(resourceUrl) {
        try {
            const response = await this.fetchData(resourceUrl);
            if ((0, $ggGdk.getStatus)(response) !== 'not_found') return true;
        } catch  {
            return false;
        }
    }
    async fetchDataForResource(resourceUrl) {
        try {
            const response = await this.fetchData(resourceUrl);
            if ((0, $ggGdk.getStatus)(response) !== 'not_found') return response;
        } catch  {
            return undefined;
        }
    }
    extractAriFromData(responseData) {
        if (responseData.data && 'atlassian:ari' in responseData.data) return responseData.data['atlassian:ari'];
        return undefined;
    }
    async fetchProvidersData() {
        const endpoint = `${this.resolverUrl}/providers`;
        const response = await (0, $biKbJ.request)('post', endpoint, undefined, this.requestHeaders);
        return {
            patterns: response.providers.reduce((allSources, provider)=>{
                return allSources.concat(provider.patterns);
            }, []),
            userPreferences: response.userPreferences
        };
    }
    async loadProviderData() {
        try {
            this.providersData = await this.providersLoader.load('providersData');
        } catch (err) {
            // eslint-disable-next-line
            console.error('failed to fetch /providers', err);
            this.providersLoader.clear('providerData');
            return undefined;
        }
    }
    async findPattern(url) {
        return !!await this.findPatternData(url) || !!await this.checkLinkResolved(url);
    }
    doesUrlMatchPath(path, url) {
        // Using [a-zA-Z0-9] here instead of \w since that includes underscores
        const startingRegex = $d4521f0694a3bb0e$var$DOES_URL_MATCH_PATH_START_REGEX.test(path) ? '(^|[^a-zA-Z0-9])' : '';
        const endingRegex = $d4521f0694a3bb0e$var$DOES_URL_MATCH_PATH_END_REGEX.test(path) ? '($|[^a-zA-Z0-9])' : '';
        const escapedPath = path.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
        const regexPattern = new RegExp(`${startingRegex}${escapedPath}${endingRegex}`);
        return regexPattern.test(url);
    }
    async findUserPreference(url) {
        if (!this.providersData) await this.loadProviderData();
        const userPreferences = this.providersData?.userPreferences;
        if (userPreferences) {
            const { defaultAppearance: defaultAppearance, appearances: appearances } = userPreferences;
            const allMatchedLabeledAppearances = appearances.filter(({ urlSegment: urlSegment })=>this.doesUrlMatchPath(urlSegment, url));
            if (allMatchedLabeledAppearances.length > 0) {
                const longestMatchedLabeledAppearance = allMatchedLabeledAppearances.reduce((previousLabeledAppearance, currentLabeledAppearance)=>previousLabeledAppearance.urlSegment.length > currentLabeledAppearance.urlSegment.length ? previousLabeledAppearance : currentLabeledAppearance);
                return longestMatchedLabeledAppearance.appearance;
            }
            if (defaultAppearance !== 'inline') return defaultAppearance;
        }
    }
    async findPatternData(url) {
        if (!this.providersData) await this.loadProviderData();
        return this.providersData?.patterns.find((pattern)=>url.match(pattern.source));
    }
    /**
   *
   * Decides whether the url passed in should be embedded by default
   *
   * protected so that subclasses can override this in order to custom handle links embedded by default
   *
   * @param url
   * @returns 'embed' for the card appearance to embed by default
   */ getHardCodedAppearance(url) {
        // Replace directly with isJiraPlan(url) on cleanup
        const isJiraPlanEvaluated = $d4521f0694a3bb0e$var$isJiraPlan(url);
        const isJiraFormEvaluated = $d4521f0694a3bb0e$var$isJiraForm(url);
        const isJiraSummaryEvaluated = $d4521f0694a3bb0e$var$isJiraSummary(url);
        let isConfluenceTeamCalendarsEvaluated;
        if ((0, $iDrrr.fg)('tc_smart_link_embed_view')) isConfluenceTeamCalendarsEvaluated = $d4521f0694a3bb0e$var$isConfluenceTeamCalendars(url);
        if ($d4521f0694a3bb0e$var$isJiraRoadmapOrTimeline(url) || $d4521f0694a3bb0e$var$isPolarisView(url) || $d4521f0694a3bb0e$var$isJwmView(url) || $d4521f0694a3bb0e$var$isJiraList(url) || $d4521f0694a3bb0e$var$isGiphyMedia(url) || $d4521f0694a3bb0e$var$isProformaView(url) || $d4521f0694a3bb0e$var$isConfluenceWhiteboard(url) || $d4521f0694a3bb0e$var$isConfluenceDatabase(url) || (0, $8kONW.isConfluenceSlideUrl)(url) || $d4521f0694a3bb0e$var$isYoutubeVideo(url) || $d4521f0694a3bb0e$var$isLoomVideoUrl(url) || $d4521f0694a3bb0e$var$isLoomPlaylistUrl(url) && (0, $iDrrr.fg)('loom-playlist-smartlink-embed-default') || $d4521f0694a3bb0e$var$isLoomScreenshotUrl(url) && (0, $iDrrr.fg)('loom-support-screenshot-sl-resolution') || $d4521f0694a3bb0e$var$isJiraDashboard(url) || $d4521f0694a3bb0e$var$isJiraBacklog(url) || $d4521f0694a3bb0e$var$isJiraBoard(url) || $d4521f0694a3bb0e$var$isRovoAgentProfilePage(url) || $d4521f0694a3bb0e$var$isJiraVersion(url) || isJiraPlanEvaluated || isJiraFormEvaluated || isJiraSummaryEvaluated || $d4521f0694a3bb0e$var$isCustomer360LandingPage(url) || isConfluenceTeamCalendarsEvaluated || $d4521f0694a3bb0e$var$isJiraIssueNavigator(url) || $d4521f0694a3bb0e$var$isAvpVisualizationView(url) || $d4521f0694a3bb0e$var$isArtifactsShareView(url) && (0, $iDrrr.fg)('platform_forge_ui_artifact_confluence_integration')) return 'embed';
    }
    async fetchData(url) {
        // it uses fetchNodesData internally and caches the result
        return await this.getDataAsPromise_DO_NOT_USE_OUTSIDE_MIGRATIONS({
            // It's ok to cast any resourceUrl to inlineCard here, because only URL is important for the request.
            type: 'inlineCard',
            attrs: {
                url: url
            }
        });
    }
    async resolvesToHardCodedEmbed(url) {
        try {
            const response = await this.fetchData(url);
            const resolvedUrl = (0, $3ewaO.extractSmartLinkUrl)(response);
            return resolvedUrl !== undefined && this.getHardCodedAppearance(resolvedUrl) === 'embed';
        } catch  {
            return false;
        }
    }
    /**
   * Make a /resolve call and find out if result has embed capability
   */ async canBeResolvedAsEmbed(url) {
        try {
            const details = await this.fetchData(url);
            if (!details) return false;
            // Imagine response is "unauthorized". We won't be able to tell if even after auth
            // page going to have preview. Yes, we can show auth view for embed. But what if even after
            // success auth flow there won't be preview? We will already have ugly embed ADF.
            // Being on a safe side - if we get anything but resolved - we decide it can't be an embed.
            if ((0, $ggGdk.getStatus)(details) !== 'resolved') return false;
            const embed = (0, $8OcYi.extractSmartLinkEmbed)(details);
            return !!embed;
        } catch  {
            return false;
        }
    }
    /**
   * Opt-in hook: when a caller explicitly requests an `'embed'` appearance and the
   * user has no saved preference for the URL, honour that request as the default
   * (above any provider default), validating embeddability first and falling back
   * to a card (`'block'`) when the link cannot be embedded.
   *
   * Defaults to `false` so behaviour is unchanged for every existing consumer.
   * Subclasses (e.g. Confluence) can override this to opt in, typically behind an
   * experiment.
   */ shouldHonorRequestedEmbedAsDefault() {
        return false;
    }
    async getAuthStatusFromResolveResponse(url) {
        try {
            const { meta: { access: access, visibility: visibility } } = await this.fetchData(url);
            return {
                access: access,
                visibility: visibility
            };
        } catch  {
            return undefined;
        }
    }
    /**
   * Make a /resolve call and find out if result has datasource capability
   */ async getDatasourceFromResolveResponse(url) {
        try {
            const response = await this.fetchData(url);
            const datasources = response && response.datasources || [];
            if (datasources.length > 0) // For now we only have one datasource expected even though it is in an array.
            // When we have resources returning more than one we will have revisit this part.
            return datasources[0];
        } catch  {
            return undefined;
        }
    }
    /**
   * This is used to determine if the url is a local Jira url or a remote one.
   */ isLocalUrl(url) {
        return new URL(url).origin === this.baseUrl;
    }
    async resolve(url, appearance, shouldForceAppearance, isEmbedFriendlyLocation) {
        try {
            if (shouldForceAppearance === true) // At this point we don't need to check pattern nor call `check` because manual change means
            // this url is already supported and can be resolved. We want to ignore all other options and
            // respect user's choice.
            return this.transformer.toSmartlinkAdf(url, appearance);
            const hardCodedAppearance = this.getHardCodedAppearance(url);
            const [matchedProviderPattern, userPreference] = await Promise.all([
                this.findPatternData(url),
                this.findUserPreference(url)
            ]);
            if ((0, $iDrrr.fg)('issue-link-suggestions-in-comments')) {
                if ($d4521f0694a3bb0e$export$6a9668b99d8a1708(url) && this.isLocalUrl(url)) {
                    const data = await this.fetchDataForResource(url);
                    if (data) {
                        const issueAri = this.extractAriFromData(data);
                        if (issueAri) this.onResolve?.(url, issueAri);
                    }
                }
            }
            if (shouldForceAppearance === false && userPreference === 'url') return Promise.reject(undefined);
            const isSupported = !!matchedProviderPattern || await this.checkLinkResolved(url);
            if (isSupported) {
                const providerDefaultAppearance = matchedProviderPattern?.defaultView;
                const isEmbedFriendlyLocationEvaluated = isEmbedFriendlyLocation || isEmbedFriendlyLocation === undefined;
                let preferredAppearance = shouldForceAppearance === undefined ? // Ignore both User and provider's appearances if older editor that doesn't send shouldForceAppearance
                hardCodedAppearance || appearance : // User preferred appearance. It would be either one that has matching domain/path pattern OR
                // if user's default choice is NOT "inline" (so, block or embed at this point, url was dealt with above)
                userPreference || // If user's default choice is "inline" or user hasn't specified preferences at all,
                // we check whatever one of the hardcoded providers match url (jira /timeline, polaris, etc)
                isEmbedFriendlyLocationEvaluated && hardCodedAppearance || // If non match, we see if this provider has default appearance for this particular regexp
                providerDefaultAppearance || // If not, we pick what editor (or any other client) requested
                appearance;
                const isNativeEmbedShortlinkResolutionEnabled = (0, $iDrrr.fg)('platform_native_embeds_enable_shortlink_resolution');
                const shouldResolveShortLinkForEmbed = isNativeEmbedShortlinkResolutionEnabled && matchedProviderPattern !== undefined && $d4521f0694a3bb0e$var$isConfluenceShortLinkUrl(url) && userPreference === undefined && isEmbedFriendlyLocationEvaluated;
                // Confluence shortlinks do not identify their content type. Resolve the URL before
                // deciding whether it should use one of the existing hardcoded embed appearances.
                if (shouldResolveShortLinkForEmbed && await this.resolvesToHardCodedEmbed(url)) preferredAppearance = 'embed';
                if (preferredAppearance === userPreference && userPreference === 'embed') {
                    const canItBeEmbed = await this.canBeResolvedAsEmbed(url);
                    if (!canItBeEmbed) preferredAppearance = 'inline';
                }
                // When a caller explicitly requested an embed (e.g. Confluence's quick-insert
                // embed flow tags the inserted link) and the user has no saved preference for
                // this URL, honour embed-by-default above the provider default — but only in an
                // embed-friendly location (matching how hard-coded embeds are gated above) and
                // only when the link can actually be embedded, otherwise fall back to a card.
                // Gated behind a default-off opt-in hook so other consumers are unaffected.
                if (!userPreference && appearance === 'embed' && isEmbedFriendlyLocationEvaluated && this.shouldHonorRequestedEmbedAsDefault()) {
                    const canItBeEmbed = await this.canBeResolvedAsEmbed(url);
                    preferredAppearance = canItBeEmbed ? 'embed' : 'block';
                }
                const datasource = await this.getDatasourceFromResolveResponse(url);
                if (datasource) {
                    const { id: id, parameters: parameters } = datasource;
                    return this.transformer.toDatasourceAdf({
                        id: id,
                        parameters: parameters,
                        // in the future when we support multiple views, we will need to pass this in as a parameter
                        // transform toDatasourceAdf to accept multiple views (like how how appearance for other other transforms are handled)
                        views: [
                            {
                                type: 'table'
                            }
                        ]
                    }, url);
                }
                if (isEmbedFriendlyLocationEvaluated && !userPreference) {
                    const authStatus = await this.getAuthStatusFromResolveResponse(url);
                    if (authStatus) {
                        const { access: access } = authStatus;
                        if (access === 'unauthorized') return this.transformer.toSmartlinkAdf(url, 'block');
                    }
                }
                return this.transformer.toSmartlinkAdf(url, preferredAppearance);
            }
        } catch (e) {
            // eslint-disable-next-line
            console.warn(`Error when trying to check Smart Card url "${url}"${e instanceof Error ? ` - ${e.name} ${e.message}` : ''}`, e);
        }
        return Promise.reject(undefined);
    }
    constructor(envKey, baseUrlOverride, product, onResolve, customCardClient, supportedUrlFilter){
        super();
        this.name = void 0;
        this.baseUrl = void 0;
        this.resolverUrl = void 0;
        this.providersData = void 0;
        this.requestHeaders = void 0;
        this.transformer = void 0;
        this.providersLoader = void 0;
        this.cardClient = void 0;
        this.smartCardLocalCacheClient = (0, $iyuxZ.SmartCardLocalCacheClient).getInstance();
        this.onResolve = void 0;
        this.supportedUrlFilter = void 0;
        this.name = 'editorCardProvider';
        this.baseUrl = baseUrlOverride || (0, $kzwaO.getBaseUrl)(envKey);
        this.resolverUrl = (0, $cXJjm.getResolverUrl)(envKey, baseUrlOverride);
        this.transformer = new (0, $koAyx.Transformer)();
        this.onResolve = onResolve;
        this.supportedUrlFilter = supportedUrlFilter;
        this.requestHeaders = {
            Origin: this.baseUrl
        };
        this.providersLoader = new (0, (/*@__PURE__*/$parcel$interopDefault($6Q8Dd)))((keys)=>this.batchProviders(keys), {
            batchScheduleFn: (callback)=>setTimeout(callback, $d4521f0694a3bb0e$var$BATCH_WAIT_TIME)
        });
        this.cardClient = customCardClient ?? new (0, $4yccB.default)(envKey, baseUrlOverride);
        if (!customCardClient && product) this.cardClient.setProduct(product);
    }
}
const $d4521f0694a3bb0e$export$b7c3c9a99f7959f5 = new $d4521f0694a3bb0e$export$e4635c0135e1a519();
module.exports["isInternalUrl"] = $d4521f0694a3bb0e$export$4006295459a20a0;
module.exports["isExternalUrl"] = $d4521f0694a3bb0e$export$78234eee43b97e81;
module.exports["EditorCardProvider"] = $d4521f0694a3bb0e$export$e4635c0135e1a519;
module.exports["editorCardProvider"] = $d4521f0694a3bb0e$export$b7c3c9a99f7959f5;

});

parcelRegister("6Q8Dd", function(module, exports) {

var $1P2f3 = parcelRequire("1P2f3");

"use strict";
/**
 * Copyright (c) 2019-present, GraphQL Foundation
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ // A Function, which when given an Array of keys, returns a Promise of an Array
// of values or Errors.
// Optionally turn off batching or caching or provide a cache key function or a
// custom cache instance.
// If a custom cache is provided, it must be of this type (a subset of ES6 Map).
/**
 * A `DataLoader` creates a public API for loading data from a particular
 * data back-end with unique keys such as the `id` column of a SQL table or
 * document name in a MongoDB database, given a batch loading function.
 *
 * Each `DataLoader` instance contains a unique memoized cache. Use caution when
 * used in long-lived applications or those which serve many users with
 * different access permissions and consider creating a new instance per
 * web request.
 */ var $4fae4b715d22864c$var$DataLoader = /*#__PURE__*/ function() {
    function DataLoader(batchLoadFn, options) {
        if (typeof batchLoadFn !== 'function') throw new TypeError('DataLoader must be constructed with a function which accepts ' + ("Array<key> and returns Promise<Array<value>>, but got: " + batchLoadFn + "."));
        this._batchLoadFn = batchLoadFn;
        this._maxBatchSize = $4fae4b715d22864c$var$getValidMaxBatchSize(options);
        this._batchScheduleFn = $4fae4b715d22864c$var$getValidBatchScheduleFn(options);
        this._cacheKeyFn = $4fae4b715d22864c$var$getValidCacheKeyFn(options);
        this._cacheMap = $4fae4b715d22864c$var$getValidCacheMap(options);
        this._batch = null;
        this.name = $4fae4b715d22864c$var$getValidName(options);
    } // Private
    var _proto = DataLoader.prototype;
    /**
   * Loads a key, returning a `Promise` for the value represented by that key.
   */ _proto.load = function load(key) {
        if (key === null || key === undefined) throw new TypeError('The loader.load() function must be called with a value, ' + ("but got: " + String(key) + "."));
        var batch = $4fae4b715d22864c$var$getCurrentBatch(this);
        var cacheMap = this._cacheMap;
        var cacheKey; // If caching and there is a cache-hit, return cached Promise.
        if (cacheMap) {
            cacheKey = this._cacheKeyFn(key);
            var cachedPromise = cacheMap.get(cacheKey);
            if (cachedPromise) {
                var cacheHits = batch.cacheHits || (batch.cacheHits = []);
                return new Promise(function(resolve) {
                    cacheHits.push(function() {
                        resolve(cachedPromise);
                    });
                });
            }
        } // Otherwise, produce a new Promise for this key, and enqueue it to be
        // dispatched along with the current batch.
        batch.keys.push(key);
        var promise = new Promise(function(resolve, reject) {
            batch.callbacks.push({
                resolve: resolve,
                reject: reject
            });
        }); // If caching, cache this promise.
        if (cacheMap) cacheMap.set(cacheKey, promise);
        return promise;
    };
    _proto.loadMany = function loadMany(keys) {
        if (!$4fae4b715d22864c$var$isArrayLike(keys)) throw new TypeError('The loader.loadMany() function must be called with Array<key> ' + ("but got: " + keys + "."));
         // Support ArrayLike by using only minimal property access
        var loadPromises = [];
        for(var i = 0; i < keys.length; i++)loadPromises.push(this.load(keys[i])["catch"](function(error) {
            return error;
        }));
        return Promise.all(loadPromises);
    };
    _proto.clear = function clear(key) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key);
            cacheMap["delete"](cacheKey);
        }
        return this;
    };
    _proto.clearAll = function clearAll() {
        var cacheMap = this._cacheMap;
        if (cacheMap) cacheMap.clear();
        return this;
    };
    _proto.prime = function prime(key, value) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key); // Only add the key if it does not already exist.
            if (cacheMap.get(cacheKey) === undefined) {
                // Cache a rejected promise if the value is an Error, in order to match
                // the behavior of load(key).
                var promise;
                if (value instanceof Error) {
                    promise = Promise.reject(value); // Since this is a case where an Error is intentionally being primed
                    // for a given key, we want to disable unhandled promise rejection.
                    promise["catch"](function() {});
                } else promise = Promise.resolve(value);
                cacheMap.set(cacheKey, promise);
            }
        }
        return this;
    };
    return DataLoader;
}(); // Private: Enqueue a Job to be executed after all "PromiseJobs" Jobs.
//
// ES6 JavaScript uses the concepts Job and JobQueue to schedule work to occur
// after the current execution context has completed:
// http://www.ecma-international.org/ecma-262/6.0/#sec-jobs-and-job-queues
//
// Node.js uses the `process.nextTick` mechanism to implement the concept of a
// Job, maintaining a global FIFO JobQueue for all Jobs, which is flushed after
// the current call stack ends.
//
// When calling `then` on a Promise, it enqueues a Job on a specific
// "PromiseJobs" JobQueue which is flushed in Node as a single Job on the
// global JobQueue.
//
// DataLoader batches all loads which occur in a single frame of execution, but
// should include in the batch all loads which occur during the flushing of the
// "PromiseJobs" JobQueue after that same execution frame.
//
// In order to avoid the DataLoader dispatch Job occuring before "PromiseJobs",
// A Promise Job is created with the sole purpose of enqueuing a global Job,
// ensuring that it always occurs after "PromiseJobs" ends.
//
// Node.js's job queue is unique. Browsers do not have an equivalent mechanism
// for enqueuing a job to be performed after promise microtasks and before the
// next macrotask. For browser environments, a macrotask is used (via
// setImmediate or setTimeout) at a potential performance penalty.
var $4fae4b715d22864c$var$enqueuePostPromiseJob = typeof $1P2f3 === 'object' && typeof $1P2f3.nextTick === 'function' ? function(fn) {
    if (!$4fae4b715d22864c$var$resolvedPromise) $4fae4b715d22864c$var$resolvedPromise = Promise.resolve();
    $4fae4b715d22864c$var$resolvedPromise.then(function() {
        $1P2f3.nextTick(fn);
    });
} : typeof setImmediate === 'function' ? function(fn) {
    setImmediate(fn);
} : function(fn) {
    setTimeout(fn);
}; // Private: cached resolved Promise instance
var $4fae4b715d22864c$var$resolvedPromise; // Private: Describes a batch of requests
// Private: Either returns the current batch, or creates and schedules a
// dispatch of a new batch for the given loader.
function $4fae4b715d22864c$var$getCurrentBatch(loader) {
    // If there is an existing batch which has not yet dispatched and is within
    // the limit of the batch size, then return it.
    var existingBatch = loader._batch;
    if (existingBatch !== null && !existingBatch.hasDispatched && existingBatch.keys.length < loader._maxBatchSize) return existingBatch;
     // Otherwise, create a new batch for this loader.
    var newBatch = {
        hasDispatched: false,
        keys: [],
        callbacks: []
    }; // Store it on the loader so it may be reused.
    loader._batch = newBatch; // Then schedule a task to dispatch this batch of requests.
    loader._batchScheduleFn(function() {
        $4fae4b715d22864c$var$dispatchBatch(loader, newBatch);
    });
    return newBatch;
}
function $4fae4b715d22864c$var$dispatchBatch(loader, batch) {
    // Mark this batch as having been dispatched.
    batch.hasDispatched = true; // If there's nothing to load, resolve any cache hits and return early.
    if (batch.keys.length === 0) {
        $4fae4b715d22864c$var$resolveCacheHits(batch);
        return;
    } // Call the provided batchLoadFn for this loader with the batch's keys and
    // with the loader as the `this` context.
    var batchPromise;
    try {
        batchPromise = loader._batchLoadFn(batch.keys);
    } catch (e) {
        return $4fae4b715d22864c$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function " + ("errored synchronously: " + String(e) + ".")));
    } // Assert the expected response from batchLoadFn
    if (!batchPromise || typeof batchPromise.then !== 'function') return $4fae4b715d22864c$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise: " + String(batchPromise) + ".")));
     // Await the resolution of the call to batchLoadFn.
    batchPromise.then(function(values) {
        // Assert the expected resolution from batchLoadFn.
        if (!$4fae4b715d22864c$var$isArrayLike(values)) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise of an Array: " + String(values) + "."));
        if (values.length !== batch.keys.length) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did not return a Promise of an Array of the same length as the Array of keys." + ("\n\nKeys:\n" + String(batch.keys)) + ("\n\nValues:\n" + String(values)));
         // Resolve all cache hits in the same micro-task as freshly loaded values.
        $4fae4b715d22864c$var$resolveCacheHits(batch); // Step through values, resolving or rejecting each Promise in the batch.
        for(var i = 0; i < batch.callbacks.length; i++){
            var _value = values[i];
            if (_value instanceof Error) batch.callbacks[i].reject(_value);
            else batch.callbacks[i].resolve(_value);
        }
    })["catch"](function(error) {
        $4fae4b715d22864c$var$failedDispatch(loader, batch, error);
    });
} // Private: do not cache individual loads if the entire batch dispatch fails,
// but still reject each request so they do not hang.
function $4fae4b715d22864c$var$failedDispatch(loader, batch, error) {
    // Cache hits are resolved, even though the batch failed.
    $4fae4b715d22864c$var$resolveCacheHits(batch);
    for(var i = 0; i < batch.keys.length; i++){
        loader.clear(batch.keys[i]);
        batch.callbacks[i].reject(error);
    }
} // Private: Resolves the Promises for any cache hits in this batch.
function $4fae4b715d22864c$var$resolveCacheHits(batch) {
    if (batch.cacheHits) for(var i = 0; i < batch.cacheHits.length; i++)batch.cacheHits[i]();
} // Private: given the DataLoader's options, produce a valid max batch size.
function $4fae4b715d22864c$var$getValidMaxBatchSize(options) {
    var shouldBatch = !options || options.batch !== false;
    if (!shouldBatch) return 1;
    var maxBatchSize = options && options.maxBatchSize;
    if (maxBatchSize === undefined) return Infinity;
    if (typeof maxBatchSize !== 'number' || maxBatchSize < 1) throw new TypeError("maxBatchSize must be a positive number: " + maxBatchSize);
    return maxBatchSize;
} // Private
function $4fae4b715d22864c$var$getValidBatchScheduleFn(options) {
    var batchScheduleFn = options && options.batchScheduleFn;
    if (batchScheduleFn === undefined) return $4fae4b715d22864c$var$enqueuePostPromiseJob;
    if (typeof batchScheduleFn !== 'function') throw new TypeError("batchScheduleFn must be a function: " + batchScheduleFn);
    return batchScheduleFn;
} // Private: given the DataLoader's options, produce a cache key function.
function $4fae4b715d22864c$var$getValidCacheKeyFn(options) {
    var cacheKeyFn = options && options.cacheKeyFn;
    if (cacheKeyFn === undefined) return function(key) {
        return key;
    };
    if (typeof cacheKeyFn !== 'function') throw new TypeError("cacheKeyFn must be a function: " + cacheKeyFn);
    return cacheKeyFn;
} // Private: given the DataLoader's options, produce a CacheMap to be used.
function $4fae4b715d22864c$var$getValidCacheMap(options) {
    var shouldCache = !options || options.cache !== false;
    if (!shouldCache) return null;
    var cacheMap = options && options.cacheMap;
    if (cacheMap === undefined) return new Map();
    if (cacheMap !== null) {
        var cacheFunctions = [
            'get',
            'set',
            'delete',
            'clear'
        ];
        var missingFunctions = cacheFunctions.filter(function(fnName) {
            return cacheMap && typeof cacheMap[fnName] !== 'function';
        });
        if (missingFunctions.length !== 0) throw new TypeError('Custom cacheMap missing methods: ' + missingFunctions.join(', '));
    }
    return cacheMap;
}
function $4fae4b715d22864c$var$getValidName(options) {
    if (options && options.name) return options.name;
    return null;
} // Private
function $4fae4b715d22864c$var$isArrayLike(x) {
    return typeof x === 'object' && x !== null && typeof x.length === 'number' && (x.length === 0 || x.length > 0 && Object.prototype.hasOwnProperty.call(x, x.length - 1));
}
module.exports = $4fae4b715d22864c$var$DataLoader;

});

parcelRegister("3ewaO", function(module, exports) {

var $8YE7G = parcelRequire("8YE7G");


var $jMcHR = parcelRequire("jMcHR");


var $kAdyG = parcelRequire("kAdyG");

const $15d3ac0a1a1c5122$export$7ba9b12c6a1b73de = (response)=>{
    if ((0, $kAdyG.isEntityPresent)(response)) return (0, $8YE7G.extractEntity)(response)?.url;
    return (0, $jMcHR.extractLink)(response?.data);
};
module.exports["extractSmartLinkUrl"] = $15d3ac0a1a1c5122$export$7ba9b12c6a1b73de;

});

parcelRegister("4yccB", function(module, exports) {

var $QO4PV = parcelRequire("QO4PV");


var $6Q8Dd = parcelRequire("6Q8Dd");


var $iKWdo = parcelRequire("iKWdo");


var $lPEt0 = parcelRequire("lPEt0");


var $axuex = parcelRequire("axuex");


var $j39Hd = parcelRequire("j39Hd");


var $ixC10 = parcelRequire("ixC10");


var $cXJjm = parcelRequire("cXJjm");


var $grief = parcelRequire("grief");


var $2g31M = parcelRequire("2g31M");


var $ggGdk = parcelRequire("ggGdk");


var $iDrrr = parcelRequire("iDrrr");


var $c2kDy = parcelRequire("c2kDy");


var $44Sj0 = parcelRequire("44Sj0");

const $614b823604b25d0c$var$MAX_BATCH_SIZE = 50;
const $614b823604b25d0c$var$MIN_TIME_BETWEEN_BATCHES = 250;
const $614b823604b25d0c$var$URL_RESPONSE_CACHE_SIZE = 100;
const $614b823604b25d0c$export$d6a66073b5d79eb3 = new (0, $lPEt0.LRUMap)($614b823604b25d0c$var$URL_RESPONSE_CACHE_SIZE);
const $614b823604b25d0c$var$urlResponseInFlightCache = new Map();
class $614b823604b25d0c$export$2e2bcd8739ae039 {
    setProduct(product) {
        this.product = product;
    }
    /**
   * Set custom headers to be sent with each request to the resolver.
   *
   * @param headers - Object containing headers to be sent with each request.
   */ setHeaders(headers) {
        this.headers = headers;
    }
    createUrlLoader() {
        const batchResolveThrottler = (0, (/*@__PURE__*/$parcel$interopDefault($axuex)))({
            limit: 1,
            interval: $614b823604b25d0c$var$MIN_TIME_BETWEEN_BATCHES
        });
        const throttledBatchResolve = batchResolveThrottler(this.batchResolveUrl);
        return new (0, (/*@__PURE__*/$parcel$interopDefault($6Q8Dd)))(// We place all calls to `batchResolve` in a limiter so we don't send off several simultaneous batch requests.
        // This is for two reasons:
        //  1: we want to avoid getting rate limited upstream (eg: forge and other APIs)
        //  2: we want to avoid sending out heaps of requests from the client at once
        (urls)=>throttledBatchResolve(urls), {
            maxBatchSize: $614b823604b25d0c$var$MAX_BATCH_SIZE,
            // NOTE: we turn off DataLoader's cache because it doesn't work for our use-case. Consider the following:
            // - a smartlink to a restricted item is resolved to "forbidden" with a "request access button"
            // - the user clicks "request access", and then following the auth prompts and gets access
            // - the frontend now re-renders the smartlink, but due to DataLoader's caching, the previous "forbidden" state is
            //   because the smartlink's URL (which is the cache key) is exactly the same
            //
            // For this reason, we disable DataLoader's cache.
            // This means that URLs will not be de-duplicated by DataLoader, so we perform the de-duplication logic
            // ourselves in `this.batchResolveUrl`.
            cache: false
        });
    }
    getUrlLoader(hostname) {
        if (!this.urlLoadersByDomain[hostname]) this.urlLoadersByDomain[hostname] = this.createUrlLoader();
        return this.urlLoadersByDomain[hostname];
    }
    getHostName(url) {
        try {
            return new URL(url).hostname;
        } catch (error) {
            throw new (0, $grief.InvalidUrlError)(error);
        }
    }
    async resolveUrlWithoutInlineOptimization(url, hostname, force) {
        let responsePromise = $614b823604b25d0c$export$d6a66073b5d79eb3.get(url);
        if (!responsePromise || force) {
            const urlLoader = this.getUrlLoader(hostname);
            responsePromise = urlLoader.load({
                resourceUrl: url,
                ignoreCachedValue: force || undefined
            });
            $614b823604b25d0c$export$d6a66073b5d79eb3.set(url, responsePromise);
        }
        let response;
        try {
            response = await responsePromise;
        } catch (e) {
            // Technically this never happens, since batchResolve handles errors and doesn't throw,
            // But just in case.
            $614b823604b25d0c$export$d6a66073b5d79eb3.delete(url);
            throw e;
        }
        const isUnresolvedLink = !(0, $44Sj0.isSuccessfulResponse)(response) || (0, $ggGdk.getStatus)(response.body) !== 'resolved';
        if (isUnresolvedLink) // We want consequent calls for fetchData() to cause actual http call
        $614b823604b25d0c$export$d6a66073b5d79eb3.delete(url);
        return response;
    }
    async resolveUrlWithInlineOptimization(url, hostname, force, appearance) {
        const cacheKey = `${url}|${appearance}`;
        const inFlightCacheKey = JSON.stringify([
            url,
            appearance,
            force
        ]);
        let responsePromise = $614b823604b25d0c$var$urlResponseInFlightCache.get(inFlightCacheKey);
        if (!responsePromise) {
            responsePromise = $614b823604b25d0c$export$d6a66073b5d79eb3.get(cacheKey);
            if (!responsePromise || force) {
                const urlLoader = this.getUrlLoader(hostname);
                responsePromise = urlLoader.load({
                    resourceUrl: url,
                    ignoreCachedValue: force || undefined,
                    appearance: appearance
                });
                $614b823604b25d0c$export$d6a66073b5d79eb3.set(cacheKey, responsePromise);
                $614b823604b25d0c$var$urlResponseInFlightCache.set(inFlightCacheKey, responsePromise);
            }
        }
        let response;
        try {
            response = await responsePromise;
        } catch (e) {
            // Technically this never happens, since batchResolve handles errors and doesn't throw,
            // But just in case.
            $614b823604b25d0c$export$d6a66073b5d79eb3.delete(cacheKey);
            throw e;
        } finally{
            if ($614b823604b25d0c$var$urlResponseInFlightCache.get(inFlightCacheKey) === responsePromise) $614b823604b25d0c$var$urlResponseInFlightCache.delete(inFlightCacheKey);
        }
        const isUnresolvedLink = !(0, $44Sj0.isSuccessfulResponse)(response) || (0, $ggGdk.getStatus)(response.body) !== 'resolved';
        if (isUnresolvedLink) // We want consequent calls for fetchData() to cause actual http call
        $614b823604b25d0c$export$d6a66073b5d79eb3.delete(cacheKey);
        return response;
    }
    async resolveUrl(url, force = false, appearance) {
        const hostname = this.getHostName(url);
        if (appearance !== undefined && (0, $iDrrr.fg)('platform_smartlink_inline_resolve_optimization')) return this.resolveUrlWithInlineOptimization(url, hostname, force, appearance);
        return this.resolveUrlWithoutInlineOptimization(url, hostname, force);
    }
    async prefetchData(url, appearance) {
        // 1. Queue the URL as part of a dataloader batch.
        const response = await this.resolveUrl(url, false, appearance);
        if ((0, $44Sj0.isSuccessfulResponse)(response)) // 2. If the URL resolves, send it back.
        return response.body;
        else try {
            // 3. If the URL does not resolve, retry it with exponential backoff.
            // This is done so that we avoid the scenario where users are unable to
            // see a resolved Smart Link, when their expectation is to be able to.
            const retriedResponse = await (0, (/*@__PURE__*/$parcel$interopDefault($QO4PV)))(async ()=>{
                // We check if the link has resolved in the cache and stop trying if so.
                // We do this by triggering an error that the link has already been resolved.
                // This cascades <retryCount> times after which it is handled like a normal
                // 'error', returning `undefined`.
                if (!this.resolvedCache[url]) {
                    const response = await this.resolveUrl(url, false, appearance);
                    if ((0, $44Sj0.isSuccessfulResponse)(response)) return response;
                    else throw new Error('Retry for URL failed');
                } else // Short-circuit each of the retries, as described above.
                throw new Error('Retry unneeded - link has been resolved.');
            }, this.retryConfig);
            // Trigger callback after successful backoff.
            return retriedResponse.body;
        } catch  {
            // Do nothing in the case of an error - prefetching
            // failures should be silent. Once a link is visible,
            // it will be re-fetched anyhow, in which case a
            // user-facing error is required.
            return undefined;
        }
    }
    isRateLimitError(response) {
        return (0, $c2kDy.isErrorResponse)(response) && response.error.status === 429;
    }
    /**
   * Fetch data from URL
   * @param url - The URL to fetch data for
   * @param force - Whether to force a fresh fetch, bypassing cache
   * @param appearance - Card appearance hint for ORS to optimize response payload.
   *                     When 'inline', ORS returns minimal data (title, status).
   *                     When 'block' or 'embed', ORS returns full data including summary.
   */ async fetchData(url, force, appearance) {
        let response = await this.resolveUrl(url, force, appearance);
        if (this.isRateLimitError(response)) response = await (0, (/*@__PURE__*/$parcel$interopDefault($QO4PV)))(async ()=>{
            const retryResponse = await this.resolveUrl(url, false, appearance);
            if (this.isRateLimitError(retryResponse)) throw this.mapErrorResponse(retryResponse, new URL(url).hostname);
            return retryResponse;
        }, this.retryConfig);
        if (!(0, $44Sj0.isSuccessfulResponse)(response)) throw this.mapErrorResponse(response, new URL(url).hostname);
        // Set a flag in the `resolvedCache` for this URL. The intent of this is
        // to ensure that the exponential backoff method in `prefetchData` does
        // not continue to retry fetching for this URL, especially if it was previously
        // in a failed state. Note: this scenario only occurs on initial page load, if the
        // user scrolls through the page very fast. Once the URL is visible, prefetching
        // no longer takes place.
        this.resolvedCache[url] = true;
        // Return the JSON-LD response back up!
        return response.body;
    }
    /**
   * Fetch data for multiple ARIs (batch) in one operation
   * @param aris Array of ARIs to fetch data for
   */ async fetchDataAris(aris) {
        return await this.batchResolveAris(aris);
    }
    async postData(data) {
        const requestData = {
            key: data.key,
            action: data.action,
            context: data.context
        };
        return await (0, $j39Hd.request)('post', `${this.resolverUrl}/invoke`, requestData);
    }
    /**
   * Make request to the Search endpoint See `InvocationRequest` in ORS openapi.yaml for backend
   * spec.
   * @param data Payload including the search provider key and query. An empty search query string
   * results in recent results being returned (pre-query).
   * @returns JsonLd collection of search results.
   */ async search(data) {
        const { key: key, action: action } = data;
        // Note: context in action is different to context in data, see types.
        const { query: query, context: context } = action;
        const requestData = {
            key: key,
            search: {
                query: query,
                context: context
            }
        };
        const response = await (0, $j39Hd.request)('post', `${this.resolverUrl}/invoke/search`, requestData);
        if ((0, $c2kDy.isErrorResponse)(response)) // There is no hostname/it is not known. Hostname is not logged anyway as it's considered PII.
        throw this.mapErrorResponse(response);
        return response;
    }
    async fetchAvailableSearchProviders() {
        const response = await (0, $j39Hd.request)('post', `${this.resolverUrl}/providers`, {
            type: 'search'
        });
        return response.providers;
    }
    mapErrorResponse(response, hostname = '') {
        // Catch non-200 server responses to fallback or return useful information.
        if (response?.error) {
            const errorType = response.error.type;
            const errorMessage = response.error.message;
            const extensionKey = response.error.extensionKey;
            // this means there was a network error and we fallback to blue link
            // without impacting SLO's
            if (response.error instanceof (0, $2g31M.NetworkError)) return new (0, $ixC10.APIError)('fallback', hostname, errorMessage, errorType);
            switch(errorType){
                // BadRequestError - indicative of an API error, render
                // a blue link to mitigate customer impact.
                case 'ResolveBadRequestError':
                case 'SearchBadRequestError':
                case 'BadRequestError':
                    return new (0, $ixC10.APIError)('fallback', hostname, errorMessage, errorType, extensionKey);
                // AuthError - if the user logs in, we may be able
                // to recover. Render an unauthorized card.
                case 'ResolveAuthError':
                case 'SearchAuthError':
                case 'AuthError':
                    return new (0, $ixC10.APIError)('auth', hostname, errorMessage, errorType, extensionKey);
                // UnsupportedError - we do not know how to render this URL.
                // Bail out and ask the Editor to render as a blue link.
                case 'ResolveUnsupportedError':
                case 'SearchUnsupportedError':
                case 'UnsupportedError':
                    // URL isn't supported
                    return new (0, $ixC10.APIError)('fatal', hostname, errorMessage, errorType, extensionKey);
                case 'ResolveFailedError':
                case 'SearchFailedError':
                case 'ResolveTimeoutError':
                case 'SearchTimeoutError':
                case 'SearchRateLimitError':
                case 'ResolveRateLimitError':
                case 'InternalServerError':
                case 'TimeoutError':
                case 'RateLimitError':
                    return new (0, $ixC10.APIError)('error', hostname, errorMessage, errorType, extensionKey);
            }
        }
        // Catch all: we don't know this error, bail out.
        const { error: error, ...rest } = response || {};
        return new (0, $ixC10.APIError)('fatal', hostname, // reason we stringify the error differently is because
        // JSON.stringify will return "{}" if it is an instance of Error
        // e.g. JSON.stringify(new Error('something went wrong')) will return '{}'
        // reason is JSON.stringify method only serializes enumerable properties but properties like "message" and "stack" are non enumerable
        // e.g. https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/message
        // more info here https://stackoverflow.com/questions/18391212/is-it-not-possible-to-stringify-an-error-using-json-stringify
        // we assume 'rest'  to "serializable" meaning all its properties are enumerable
        response ? `${this.stringifyError(error)} ${JSON.stringify(rest)}` : 'Response undefined', 'UnexpectedError');
    }
    /**
   * This method will strigify both enumerable and  non enumerable properties of an object
   * @param err
   * @returns object serialized to JSON with both enumerable and non enumerable objects
   */ stringifyError(err) {
        /**
     * By default JSON.stringify only serializes enumerable properties of an object. In order for us to
     * serialize non enumerable properties out of an error we need to expclitily provide the non enumerable property names.
     * the second parameter to JSON.stringify gets the properties that will be serialized from the object passed in the first argument
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/getOwnPropertyNames
     */ return JSON.stringify(err, //In ES5, if the argument to getOwnPropertyNames method is not an object (a primitive), then it will cause a TypeError
        typeof err === 'object' ? Object.getOwnPropertyNames(err) : undefined);
    }
    constructor(envKey, baseUrlOverride){
        this.resolverUrl = void 0;
        this.envKey = void 0;
        this.baseUrlOverride = void 0;
        this.urlLoadersByDomain = void 0;
        this.retryConfig = void 0;
        this.resolvedCache = void 0;
        this.product = void 0;
        this.headers = void 0;
        this.postBatchResolveNew = async (resources, resourceType, keyGetter)=>{
            // De-duplicate requested URLs (see `this.createUrlLoader` for more detail).
            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
            const deDuplicatedResources = (0, (/*@__PURE__*/$parcel$interopDefault($iKWdo)))(resources, keyGetter);
            let resolvedResources = [];
            const headers = {
                /**
         * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
         * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
         */ 'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone,
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {},
                // add custom headers if defined
                ...this.headers ?? {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                if (resourceType === 'URL') resolvedResources = await (0, $j39Hd.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources, headers);
                // Ask the backend to resolve the ARIs for us.
                if (resourceType === 'ARI') resolvedResources = await (0, $j39Hd.request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources, headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url/ari
                resolvedResources = resources.map(()=>{
                    // @ts-ignore
                    const status = (0, $c2kDy.isErrorResponse)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
            for(let i = 0; i < deDuplicatedResources.length; ++i){
                const resource = deDuplicatedResources[i];
                const data = resolvedResources[i];
                map[keyGetter(resource)] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return resources.map((originalResource)=>map[keyGetter(originalResource)]);
        };
        this.postBatchResolve = async (resources, resourceType = 'URL')=>{
            // De-duplicate requested URLs (see `this.createUrlLoader` for more detail).
            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
            const deDuplicatedResources = [
                ...new Set(resources)
            ];
            let resolvedResources = [];
            const headers = {
                /**
         * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
         * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
         */ 'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone,
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {},
                // add custom headers if defined
                ...this.headers ? this.headers : {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                if (resourceType === 'URL') resolvedResources = await (0, $j39Hd.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources.map((resourceUrl)=>({
                        resourceUrl: resourceUrl
                    })), headers);
                // Ask the backend to resolve the ARIs for us.
                if (resourceType === 'ARI') resolvedResources = await (0, $j39Hd.request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources.map((ari)=>({
                        ari: ari
                    })), headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url/ari
                resolvedResources = resources.map(()=>{
                    // @ts-ignore
                    const status = (0, $c2kDy.isErrorResponse)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
            for(let i = 0; i < deDuplicatedResources.length; ++i){
                const resource = deDuplicatedResources[i];
                const data = resolvedResources[i];
                map[resource] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return resources.map((originalResource)=>map[originalResource]);
        };
        this.batchResolveUrl = async (urls)=>{
            return this.postBatchResolveNew(urls, 'URL', (resource)=>{
                // Appearance is only added to the payload when the inline resolve optimization gate is on.
                // Preserve differently shaped requests for the same URL so a reduced inline response cannot
                // be returned to a block request from the same batch.
                if (resource.appearance !== undefined && (0, $iDrrr.fg)('platform_smartlink_inline_resolve_optimization')) return JSON.stringify([
                    resource.resourceUrl,
                    resource.appearance,
                    resource.ignoreCachedValue === true
                ]);
                return resource.resourceUrl;
            });
        };
        // Endpoint for batch resolve ari
        this.batchResolveAris = async (aris)=>{
            return this.postBatchResolve(aris, 'ARI');
        };
        this.resolverUrl = (0, $cXJjm.getResolverUrl)(envKey, baseUrlOverride);
        this.urlLoadersByDomain = {};
        this.retryConfig = {
            retries: 2
        };
        this.resolvedCache = {};
        this.envKey = envKey;
        this.baseUrlOverride = baseUrlOverride;
    }
}
module.exports["default"] = $614b823604b25d0c$export$2e2bcd8739ae039;

});

parcelRegister("QO4PV", function(module, exports) {
// Packages

var $lbZ9z = parcelRequire("lbZ9z");

function $09ebb3b1b19cd625$var$retry(fn, opts) {
    function run(resolve, reject) {
        var options = opts || {};
        var op;
        // Default `randomize` to true
        if (!('randomize' in options)) options.randomize = true;
        op = $lbZ9z.operation(options);
        // We allow the user to abort retrying
        // this makes sense in the cases where
        // knowledge is obtained that retrying
        // would be futile (e.g.: auth errors)
        function bail(err) {
            reject(err || new Error('Aborted'));
        }
        function onError(err, num) {
            if (err.bail) {
                bail(err);
                return;
            }
            if (!op.retry(err)) reject(op.mainError());
            else if (options.onRetry) options.onRetry(err, num);
        }
        function runAttempt(num) {
            var val;
            try {
                val = fn(bail, num);
            } catch (err) {
                onError(err, num);
                return;
            }
            Promise.resolve(val).then(resolve).catch(function catchIt(err) {
                onError(err, num);
            });
        }
        op.attempt(runAttempt);
    }
    return new Promise(run);
}
module.exports = $09ebb3b1b19cd625$var$retry;

});

parcelRegister("lbZ9z", function(module, exports) {

module.exports = (parcelRequire("4co4r"));

});

parcelRegister("4co4r", function(module, exports) {

var $8xi9I = parcelRequire("8xi9I");

exports.operation = function(options) {
    var timeouts = exports.timeouts(options);
    return new $8xi9I(timeouts, {
        forever: options && (options.forever || options.retries === Infinity),
        unref: options && options.unref,
        maxRetryTime: options && options.maxRetryTime
    });
};
exports.timeouts = function(options) {
    if (options instanceof Array) return [].concat(options);
    var opts = {
        retries: 10,
        factor: 2,
        minTimeout: 1000,
        maxTimeout: Infinity,
        randomize: false
    };
    for(var key in options)opts[key] = options[key];
    if (opts.minTimeout > opts.maxTimeout) throw new Error('minTimeout is greater than maxTimeout');
    var timeouts = [];
    for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
    if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
    // sort the array numerically ascending
    timeouts.sort(function(a, b) {
        return a - b;
    });
    return timeouts;
};
exports.createTimeout = function(attempt, opts) {
    var random = opts.randomize ? Math.random() + 1 : 1;
    var timeout = Math.round(random * Math.max(opts.minTimeout, 1) * Math.pow(opts.factor, attempt));
    timeout = Math.min(timeout, opts.maxTimeout);
    return timeout;
};
exports.wrap = function(obj, options, methods) {
    if (options instanceof Array) {
        methods = options;
        options = null;
    }
    if (!methods) {
        methods = [];
        for(var key in obj)if (typeof obj[key] === 'function') methods.push(key);
    }
    for(var i = 0; i < methods.length; i++){
        var method = methods[i];
        var original = obj[method];
        obj[method] = (function retryWrapper(original) {
            var op = exports.operation(options);
            var args = Array.prototype.slice.call(arguments, 1);
            var callback = args.pop();
            args.push(function(err) {
                if (op.retry(err)) return;
                if (err) arguments[0] = op.mainError();
                callback.apply(this, arguments);
            });
            op.attempt(function() {
                original.apply(obj, args);
            });
        }).bind(obj, original);
        obj[method].options = options;
    }
};

});

parcelRegister("8xi9I", function(module, exports) {
function $636f7d2929f63478$var$RetryOperation(timeouts, options) {
    // Compatibility for the old (timeouts, retryForever) signature
    if (typeof options === 'boolean') options = {
        forever: options
    };
    this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
    this._timeouts = timeouts;
    this._options = options || {};
    this._maxRetryTime = options && options.maxRetryTime || Infinity;
    this._fn = null;
    this._errors = [];
    this._attempts = 1;
    this._operationTimeout = null;
    this._operationTimeoutCb = null;
    this._timeout = null;
    this._operationStart = null;
    this._timer = null;
    if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
}
module.exports = $636f7d2929f63478$var$RetryOperation;
$636f7d2929f63478$var$RetryOperation.prototype.reset = function() {
    this._attempts = 1;
    this._timeouts = this._originalTimeouts.slice(0);
};
$636f7d2929f63478$var$RetryOperation.prototype.stop = function() {
    if (this._timeout) clearTimeout(this._timeout);
    if (this._timer) clearTimeout(this._timer);
    this._timeouts = [];
    this._cachedTimeouts = null;
};
$636f7d2929f63478$var$RetryOperation.prototype.retry = function(err) {
    if (this._timeout) clearTimeout(this._timeout);
    if (!err) return false;
    var currentTime = new Date().getTime();
    if (err && currentTime - this._operationStart >= this._maxRetryTime) {
        this._errors.push(err);
        this._errors.unshift(new Error('RetryOperation timeout occurred'));
        return false;
    }
    this._errors.push(err);
    var timeout = this._timeouts.shift();
    if (timeout === undefined) {
        if (this._cachedTimeouts) {
            // retry forever, only keep last error
            this._errors.splice(0, this._errors.length - 1);
            timeout = this._cachedTimeouts.slice(-1);
        } else return false;
    }
    var self = this;
    this._timer = setTimeout(function() {
        self._attempts++;
        if (self._operationTimeoutCb) {
            self._timeout = setTimeout(function() {
                self._operationTimeoutCb(self._attempts);
            }, self._operationTimeout);
            if (self._options.unref) self._timeout.unref();
        }
        self._fn(self._attempts);
    }, timeout);
    if (this._options.unref) this._timer.unref();
    return true;
};
$636f7d2929f63478$var$RetryOperation.prototype.attempt = function(fn, timeoutOps) {
    this._fn = fn;
    if (timeoutOps) {
        if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
        if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
    }
    var self = this;
    if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
        self._operationTimeoutCb();
    }, self._operationTimeout);
    this._operationStart = new Date().getTime();
    this._fn(this._attempts);
};
$636f7d2929f63478$var$RetryOperation.prototype.try = function(fn) {
    console.log('Using RetryOperation.try() is deprecated');
    this.attempt(fn);
};
$636f7d2929f63478$var$RetryOperation.prototype.start = function(fn) {
    console.log('Using RetryOperation.start() is deprecated');
    this.attempt(fn);
};
$636f7d2929f63478$var$RetryOperation.prototype.start = $636f7d2929f63478$var$RetryOperation.prototype.try;
$636f7d2929f63478$var$RetryOperation.prototype.errors = function() {
    return this._errors;
};
$636f7d2929f63478$var$RetryOperation.prototype.attempts = function() {
    return this._attempts;
};
$636f7d2929f63478$var$RetryOperation.prototype.mainError = function() {
    if (this._errors.length === 0) return null;
    var counts = {};
    var mainError = null;
    var mainErrorCount = 0;
    for(var i = 0; i < this._errors.length; i++){
        var error = this._errors[i];
        var message = error.message;
        var count = (counts[message] || 0) + 1;
        counts[message] = count;
        if (count >= mainErrorCount) {
            mainError = error;
            mainErrorCount = count;
        }
    }
    return mainError;
};

});

parcelRegister("lPEt0", function(module, exports) {
!function(g, c) {
    c(module.exports);
}(module.exports, function(g) {
    const c = Symbol("newer"), e = Symbol("older");
    class n {
        _markEntryAsUsed(a) {
            if (a === this.newest) return;
            a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
        }
        assign(a) {
            let b, d = this.limit || Number.MAX_VALUE;
            this._keymap.clear();
            let m = a[Symbol.iterator]();
            for(let h = m.next(); !h.done; h = m.next()){
                let f = new l(h.value[0], h.value[1]);
                this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                if (d-- == 0) throw new Error("overflow");
            }
            this.newest = b, this.size = this._keymap.size;
        }
        get(a) {
            var b = this._keymap.get(a);
            return b ? (this._markEntryAsUsed(b), b.value) : void 0;
        }
        set(a, b) {
            var d = this._keymap.get(a);
            return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
        }
        shift() {
            var a = this.oldest;
            if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                a.key,
                a.value
            ];
        }
        find(a) {
            let b = this._keymap.get(a);
            return b ? b.value : void 0;
        }
        has(a) {
            return this._keymap.has(a);
        }
        delete(a) {
            var b = this._keymap.get(a);
            return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
        }
        clear() {
            this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
        }
        keys() {
            return new j(this.oldest);
        }
        values() {
            return new k(this.oldest);
        }
        entries() {
            return this;
        }
        [Symbol.iterator]() {
            return new i(this.oldest);
        }
        forEach(a, b) {
            typeof b !== "object" && (b = this);
            let d = this.oldest;
            for(; d;)a.call(b, d.value, d.key, this), d = d[c];
        }
        toJSON() {
            for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                key: d.key,
                value: d.value
            }, d = d[c];
            return a;
        }
        toString() {
            for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
            return a;
        }
        constructor(a, b){
            typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
        }
    }
    g.LRUMap = n;
    function l(a, b) {
        this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
    }
    function i(a) {
        this.entry = a;
    }
    i.prototype[Symbol.iterator] = function() {
        return this;
    }, i.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: [
                a.key,
                a.value
            ]
        }) : {
            done: !0,
            value: void 0
        };
    };
    function j(a) {
        this.entry = a;
    }
    j.prototype[Symbol.iterator] = function() {
        return this;
    }, j.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.key
        }) : {
            done: !0,
            value: void 0
        };
    };
    function k(a) {
        this.entry = a;
    }
    k.prototype[Symbol.iterator] = function() {
        return this;
    }, k.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.value
        }) : {
            done: !0,
            value: void 0
        };
    };
}); //# sourceMappingURL=lru.js.map

});

parcelRegister("axuex", function(module, exports) {
'use strict';
class $7ac4702e317338af$var$AbortError extends Error {
    constructor(){
        super('Throttled function aborted');
        this.name = 'AbortError';
    }
}
const $7ac4702e317338af$var$pThrottle = ({ limit: limit, interval: interval, strict: strict })=>{
    if (!Number.isFinite(limit)) throw new TypeError('Expected `limit` to be a finite number');
    if (!Number.isFinite(interval)) throw new TypeError('Expected `interval` to be a finite number');
    const queue = new Map();
    let currentTick = 0;
    let activeCount = 0;
    function windowedDelay() {
        const now = Date.now();
        if (now - currentTick > interval) {
            activeCount = 1;
            currentTick = now;
            return 0;
        }
        if (activeCount < limit) activeCount++;
        else {
            currentTick += interval;
            activeCount = 1;
        }
        return currentTick - now;
    }
    const strictTicks = [];
    function strictDelay() {
        const now = Date.now();
        if (strictTicks.length < limit) {
            strictTicks.push(now);
            return 0;
        }
        const earliestTime = strictTicks.shift() + interval;
        if (now >= earliestTime) {
            strictTicks.push(now);
            return 0;
        }
        strictTicks.push(earliestTime);
        return earliestTime - now;
    }
    const getDelay = strict ? strictDelay : windowedDelay;
    return (function_)=>{
        const throttled = function(...args) {
            if (!throttled.isEnabled) return (async ()=>function_.apply(this, args))();
            let timeout;
            return new Promise((resolve, reject)=>{
                const execute = ()=>{
                    resolve(function_.apply(this, args));
                    queue.delete(timeout);
                };
                timeout = setTimeout(execute, getDelay());
                queue.set(timeout, reject);
            });
        };
        throttled.abort = ()=>{
            for (const timeout of queue.keys()){
                clearTimeout(timeout);
                queue.get(timeout)(new $7ac4702e317338af$var$AbortError());
            }
            queue.clear();
            strictTicks.splice(0, strictTicks.length);
        };
        throttled.isEnabled = true;
        return throttled;
    };
};
module.exports = $7ac4702e317338af$var$pThrottle;
module.exports.AbortError = $7ac4702e317338af$var$AbortError;

});

parcelRegister("j39Hd", function(module, exports) {

var $2g31M = parcelRequire("2g31M");

const $53f448a1a60c9e76$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
async function $53f448a1a60c9e76$export$b5fe3f66a567bec0(method, url, data, headers, statuses = $53f448a1a60c9e76$var$ALLOWED_RESPONSE_STATUS_CODES) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || statuses?.includes(response.status)) {
            if (statuses.includes(204)) {
                const text = await response.text();
                // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
                return text ? JSON.parse(text) : undefined;
            } else return await response.json();
        }
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new (0, $2g31M.NetworkError)(error);
        throw error;
    }
}
module.exports["request"] = $53f448a1a60c9e76$export$b5fe3f66a567bec0;

});

parcelRegister("2g31M", function(module, exports) {
class $70283a430bb4f4fe$export$bae979e68e4dc802 extends Error {
    constructor(error){
        super(error);
    }
}
module.exports["NetworkError"] = $70283a430bb4f4fe$export$bae979e68e4dc802;

});

parcelRegister("ixC10", function(module, exports) {
class $5661a24319617f8d$export$3e5b797e39668f84 extends Error {
    constructor(kind, hostname, message, type, extensionKey){
        super(`${kind}: ${message}`), this.kind = kind, this.hostname = hostname, this.message = message, this.type = type, this.extensionKey = extensionKey;
        this.name = 'APIError';
        // The error type received from the server.
        this.type = type;
        // The kind mapped to on the client.
        this.kind = kind;
        // The message received from the server.
        this.message = message;
        // The hostname of the URL which failed - do NOT log this (contains PII/UGC).
        this.hostname = hostname;
        // The extensionKey passed from the error response from ORS
        this.extensionKey = extensionKey;
    }
}
module.exports["APIError"] = $5661a24319617f8d$export$3e5b797e39668f84;

});

parcelRegister("cXJjm", function(module, exports) {

var $kzwaO = parcelRequire("kzwaO");

const $aee62c7b870e0d6a$export$dc37652c1696f231 = (envKey, baseUrlOverride)=>{
    // The `custom` environment is used if the full resolver URL is provided by the user.
    // It could be useful for SSR, where `CardClient` should use direct service URL instead of the Edge Proxy.
    if (envKey === 'custom') return baseUrlOverride ?? '/gateway/api/object-resolver';
    // If an environment is provided, then use Stargate directly for requests.
    if (envKey || baseUrlOverride) {
        const baseUrl = baseUrlOverride || (0, $kzwaO.getBaseUrl)(envKey);
        return `${baseUrl}/object-resolver`;
    } else // Otherwise, we fallback to using the Edge Proxy to access Stargate,
    // which fixes some cookie issues with strict Browser policies.
    return '/gateway/api/object-resolver';
};
module.exports["getResolverUrl"] = $aee62c7b870e0d6a$export$dc37652c1696f231;

});

parcelRegister("kzwaO", function(module, exports) {

var $4B79C = parcelRequire("4B79C");

const $445f8294ba7508fe$export$f654b28f82155665 = (envKey, baseUrlOverride)=>{
    // The `custom` environment is used if the full resolver URL is provided by the user.
    // It could be useful for SSR, where `CardClient` should use direct service URL instead of the Edge Proxy.
    if (envKey === 'custom') return baseUrlOverride ?? (0, $4B79C.prodBaseUrl);
    // If an environment is provided, then use Stargate.
    if (envKey) return envKey in (0, $4B79C.BaseUrls) ? (0, $4B79C.BaseUrls)[envKey] : (0, $4B79C.prodBaseUrl);
    return typeof window !== 'undefined' && typeof window.location !== 'undefined' ? window.location.origin : '';
};
module.exports["getBaseUrl"] = $445f8294ba7508fe$export$f654b28f82155665;

});

parcelRegister("4B79C", function(module, exports) {
const $ef9de7657ea9d2d2$var$devBaseUrl = 'https://api-private.dev.atlassian.com';
const $ef9de7657ea9d2d2$var$stgBaseUrl = 'https://pug.jira-dev.com/gateway/api';
const $ef9de7657ea9d2d2$export$7469f9cd9cda802c = 'https://api-private.atlassian.com';
const $ef9de7657ea9d2d2$export$e2b040f052407032 = {
    dev: $ef9de7657ea9d2d2$var$devBaseUrl,
    development: $ef9de7657ea9d2d2$var$devBaseUrl,
    stg: $ef9de7657ea9d2d2$var$stgBaseUrl,
    staging: $ef9de7657ea9d2d2$var$stgBaseUrl,
    prd: $ef9de7657ea9d2d2$export$7469f9cd9cda802c,
    prod: $ef9de7657ea9d2d2$export$7469f9cd9cda802c,
    production: $ef9de7657ea9d2d2$export$7469f9cd9cda802c
};
var $ef9de7657ea9d2d2$export$2e2bcd8739ae039 = $ef9de7657ea9d2d2$export$e2b040f052407032;
module.exports["prodBaseUrl"] = $ef9de7657ea9d2d2$export$7469f9cd9cda802c;
module.exports["BaseUrls"] = $ef9de7657ea9d2d2$export$e2b040f052407032;

});

parcelRegister("grief", function(module, exports) {
class $8165f67089b396cb$export$19fa02dd69bd4efd extends Error {
    constructor(error){
        super(error);
        this.name = 'InvalidUrlError';
    }
}
module.exports["InvalidUrlError"] = $8165f67089b396cb$export$19fa02dd69bd4efd;

});

parcelRegister("ggGdk", function(module, exports) {
const $b75c372cb2906748$var$getStatusForNotFoundVisibility = (meta)=>{
    const accessType = meta.requestAccess?.accessType;
    if (!accessType || accessType === 'ACCESS_EXISTS') return 'not_found';
    // for the rest of the accessTypes we will return forbidden,see https://product-fabric.atlassian.net/browse/EDM-7125
    return 'forbidden';
};
const $b75c372cb2906748$export$b70265791d2079d4 = ({ meta: meta })=>{
    const { access: access, visibility: visibility } = meta;
    switch(access){
        case 'forbidden':
            if (visibility === 'not_found') return $b75c372cb2906748$var$getStatusForNotFoundVisibility(meta);
            else return 'forbidden';
        case 'unauthorized':
            return 'unauthorized';
        default:
            return 'resolved';
    }
};
module.exports["getStatus"] = $b75c372cb2906748$export$b70265791d2079d4;

});

parcelRegister("c2kDy", function(module, exports) {
const $3cbc4520680d3a92$export$bea7bee8a87e7c52 = (response)=>{
    if (!response) return false;
    const hasStatus = 'status' in response && response.status >= 200;
    const hasErrorBody = 'error' in response;
    return hasStatus && hasErrorBody;
};
module.exports["isErrorResponse"] = $3cbc4520680d3a92$export$bea7bee8a87e7c52;

});

parcelRegister("44Sj0", function(module, exports) {
const $d86f0936ed92dc7f$export$1b59fe731a28a49d = (response)=>{
    if (!response) return false;
    const hasSuccessfulStatus = response.status === 200;
    const hasSuccessBody = 'body' in response;
    return hasSuccessfulStatus && hasSuccessBody;
};
module.exports["isSuccessfulResponse"] = $d86f0936ed92dc7f$export$1b59fe731a28a49d;

});

parcelRegister("biKbJ", function(module, exports) {
const $57ceb58159fd0951$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
class $57ceb58159fd0951$export$bae979e68e4dc802 extends Error {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(error){
        super(error);
    }
}
async function $57ceb58159fd0951$export$b5fe3f66a567bec0(method, url, // eslint-disable-next-line @typescript-eslint/no-explicit-any
data, headers) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || $57ceb58159fd0951$var$ALLOWED_RESPONSE_STATUS_CODES.includes(response.status)) return await response.json();
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new $57ceb58159fd0951$export$bae979e68e4dc802(error);
        throw error;
    }
}
module.exports["request"] = $57ceb58159fd0951$export$b5fe3f66a567bec0;

});

parcelRegister("iyuxZ", function(module, exports) {
parcelRequire("6YrB3");
var $f9XbP = parcelRequire("f9XbP");


var $iDrrr = parcelRequire("iDrrr");

var $842937149a04b8ba$var$_SmartCardLocalCacheClient;
const $842937149a04b8ba$var$SMART_CARD_CACHE_CLIENT_KEY = 'smart-card-url-data';
const $842937149a04b8ba$var$SMART_CARD_CACHE_KEY = 'response-cache';
const $842937149a04b8ba$var$SMART_CARD_CACHE_DEFAULT_MAX_ITEMS = 100;
class $842937149a04b8ba$export$1987ad1ab31f2528 {
    /**
   * Gets the singleton instance of SmartCardLocalCacheClient.
   * This ensures all callers share the same in-memory cache and prevents
   * race conditions when multiple instances write to the same storage key.
   * @param maxItems Maximum number of items to store in the cache (only used on first instantiation)
   * @returns The singleton instance
   */ static getInstance(maxItems = $842937149a04b8ba$var$SMART_CARD_CACHE_DEFAULT_MAX_ITEMS) {
        if (!$842937149a04b8ba$export$1987ad1ab31f2528.instance) $842937149a04b8ba$export$1987ad1ab31f2528.instance = new $842937149a04b8ba$export$1987ad1ab31f2528(maxItems);
        return $842937149a04b8ba$export$1987ad1ab31f2528.instance;
    }
    /**
   * Resets the singleton instance. Only intended for testing purposes.
   * @internal
   */ static resetInstance() {
        $842937149a04b8ba$export$1987ad1ab31f2528.instance = null;
    }
    constructor(maxItems = $842937149a04b8ba$var$SMART_CARD_CACHE_DEFAULT_MAX_ITEMS){
        this.storageClient = new (0, $f9XbP.StorageClient)($842937149a04b8ba$var$SMART_CARD_CACHE_CLIENT_KEY, {
            storageEngine: 'sessionStorage'
        });
        this.maxItems = void 0;
        this.memoryCache = void 0;
        this.documentCache = {};
        this.pendingWrite = false;
        /**
     * Retrieves the entire cache object from memory
     * @returns The entire cache object
     */ this.getCache = ()=>{
            if ((0, $iDrrr.fg)('platform_smartlink_document_cache')) // Keep restored session data out of this cache if the gate changes after initialization.
            return this.documentCache;
            else return this.memoryCache;
        };
        /**
     * Caches the SmartLinkResponse against the provided url
     * @param url The url (key) to store the response against
     * @param response The SmartLinkResponse to be cached
     */ this.setItem = (url, response)=>{
            if ((0, $iDrrr.fg)('platform_smartlink_document_cache')) {
                this.documentCache[url] = {
                    data: response,
                    timestamp: Date.now()
                };
                const cacheKeys = Object.keys(this.documentCache);
                if (cacheKeys.length > this.maxItems) {
                    const sortedKeys = cacheKeys.sort((a, b)=>this.documentCache[a].timestamp - this.documentCache[b].timestamp);
                    const itemsToRemove = cacheKeys.length - this.maxItems;
                    const keysToRemove = sortedKeys.slice(0, itemsToRemove);
                    keysToRemove.forEach((key)=>{
                        delete this.documentCache[key];
                    });
                }
            } else {
                // Add or update the item in the cache with current timestamp
                this.memoryCache[url] = {
                    data: response,
                    timestamp: Date.now()
                };
                // Apply FIFO behavior if cache exceeds maxItems
                const cacheKeys = Object.keys(this.memoryCache);
                if (cacheKeys.length > this.maxItems) {
                    // Sort keys by timestamp (oldest first) and remove the oldest items
                    const sortedKeys = cacheKeys.sort((a, b)=>this.memoryCache[a].timestamp - this.memoryCache[b].timestamp);
                    const itemsToRemove = cacheKeys.length - this.maxItems;
                    const keysToRemove = sortedKeys.slice(0, itemsToRemove);
                    keysToRemove.forEach((key)=>{
                        delete this.memoryCache[key];
                    });
                }
                // Write through to storage asynchronously (non-blocking)
                // Debounced to batch multiple rapid calls into a single write
                if (!this.pendingWrite) {
                    this.pendingWrite = true;
                    queueMicrotask(()=>{
                        try {
                            this.storageClient.setItemWithExpiry($842937149a04b8ba$var$SMART_CARD_CACHE_KEY, JSON.stringify(this.memoryCache));
                        } catch (_) {
                        // Ignore storage write errors (e.g. quota exceeded) to prevent blocking future writes
                        // Cache will still function in-memory for the session, but won't persist
                        } finally{
                            this.pendingWrite = false;
                        }
                    });
                }
            }
        };
        /**
     * Retrieves the cached SmartLinkResponse for the provided url (if it exists)
     * @param url The url (key) to retrieve the cached response for
     * @returns The cached SmartLinkResponse if it exists, else undefined
     */ this.getItem = (url)=>{
            if (!url) return;
            if ((0, $iDrrr.fg)('platform_smartlink_document_cache')) return this.documentCache[url]?.data;
            else {
                const response = this.memoryCache?.[url]?.data;
                return response;
            }
        };
        /**
     * Checks if a cached entry exists for the provided url
     * @param url The url (key) to check for existence in the cache
     * @returns True if a cached entry exists, else false
     */ this.isUrlInCache = (url)=>{
            if ((0, $iDrrr.fg)('platform_smartlink_document_cache')) return url in this.documentCache;
            else return url in this.memoryCache;
        };
        this.maxItems = maxItems;
        if ((0, $iDrrr.fg)('platform_smartlink_document_cache')) this.memoryCache = {};
        else {
            // Load cache from storage into memory on instantiation
            const stored = this.storageClient.getItem($842937149a04b8ba$var$SMART_CARD_CACHE_KEY, {
                useExpiredItem: true
            });
            this.memoryCache = stored ? JSON.parse(stored) : {};
        }
    }
}
$842937149a04b8ba$var$_SmartCardLocalCacheClient = $842937149a04b8ba$export$1987ad1ab31f2528;
$842937149a04b8ba$export$1987ad1ab31f2528.instance = null;
module.exports["SmartCardLocalCacheClient"] = $842937149a04b8ba$export$1987ad1ab31f2528;

});

parcelRegister("6YrB3", function(module, exports) {
$parcel$export(module.exports, "StorageClient", () => (parcelRequire("f9XbP")).StorageClient);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $f9XbP = parcelRequire("f9XbP");


var $293056f9068f55f6$export$2e2bcd8739ae039 = (0, $f9XbP.StorageClient);

});

parcelRegister("f9XbP", function(module, exports) {

var $fmV2n = parcelRequire("fmV2n");


var $4KkEB = parcelRequire("4KkEB");

class $cecff34dc45d8bb2$export$6c85f5032e75eff9 {
    captureException(e, tags) {
        if (this.handlers?.captureException) this.handlers.captureException(e, tags);
    }
    itemKey(key) {
        return `${this.clientKey}_${key}`;
    }
    constructor(clientKey, options){
        this.client = void 0;
        this.clientKey = void 0;
        this.handlers = void 0;
        this.getItem = (key, { useExpiredItem: useExpiredItem } = {
            useExpiredItem: false
        })=>{
            const item = this.client.getItem(this.itemKey(key));
            if (item) try {
                const parsedItem = JSON.parse(item);
                if (parsedItem.expires && new Date(parsedItem.expires) < new Date()) {
                    if (!useExpiredItem) return undefined;
                }
                return parsedItem.value;
            } catch (e) {
                this.captureException(e);
                return undefined; // Return undefined on parsing error
            }
            return undefined;
        };
        this.removeItem = (key)=>{
            try {
                this.client.removeItem(this.itemKey(key));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.setItemWithExpiry = (key, value, expireInMS)=>{
            const itemWithExpiry = {
                value: value,
                expires: typeof expireInMS === 'number' ? Date.now() + expireInMS : undefined
            };
            try {
                this.client.setItem(this.itemKey(key), JSON.stringify(itemWithExpiry));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.clientKey = clientKey;
        this.handlers = options?.handlers;
        const storageEngine = options?.storageEngine || (0, $4KkEB.DEFAULT_STORAGE_ENGINE);
        if (typeof window === 'undefined' || !Object.prototype.hasOwnProperty.call(window, storageEngine)) (0, $fmV2n.mockWindowStorage)([
            storageEngine
        ]);
        // Get window reference after mockWindowStorage has potentially created it
        const windowRef = typeof window !== 'undefined' ? window : $parcel$global.window;
        this.client = windowRef[storageEngine];
    }
}
module.exports["StorageClient"] = $cecff34dc45d8bb2$export$6c85f5032e75eff9;

});

parcelRegister("fmV2n", function(module, exports) {
/**
 * This can be used to mock local storage for Edge and other browsers
 * that have disabled local storage setting
 */ const $a61ea4cfed034b37$export$c65e688d8b365035 = {
    _data: {},
    length: 0,
    setItem: function(id, val) {
        return this._data[id] = String(val);
    },
    getItem: function(id) {
        return this._data.hasOwnProperty(id) ? this._data[id] : undefined;
    },
    removeItem: function(id) {
        return delete this._data[id];
    },
    clear: function() {
        return this._data = {};
    },
    key: function(index) {
        const keys = Object.keys(this._data);
        return keys[index] || null;
    }
};
const $a61ea4cfed034b37$export$efebfe7859cae3c7 = (storageToMock = [
    'localStorage',
    'sessionStorage'
])=>{
    // Handle SSR environment where window is undefined
    let windowRef;
    let replacedWindowRef = false;
    if (typeof window === 'undefined') {
        // Ensure global exists and create window if needed
        if (typeof $parcel$global !== 'undefined') {
            $parcel$global.window = $parcel$global.window || {};
            windowRef = $parcel$global.window;
        } else {
            // Fallback for environments where global might not exist
            windowRef = {};
            replacedWindowRef = true;
        }
    } else windowRef = window;
    // Ensure windowRef is always defined and is an object
    if (!windowRef || typeof windowRef !== 'object') {
        windowRef = {};
        replacedWindowRef = true;
    }
    // If we had to replace the window reference, reflect it back to global.window
    if (replacedWindowRef && typeof $parcel$global !== 'undefined') $parcel$global.window = windowRef;
    for (const storageToMockElement of storageToMock)Object.defineProperty(windowRef, storageToMockElement, {
        value: {
            ...$a61ea4cfed034b37$export$c65e688d8b365035
        },
        configurable: true,
        writable: true
    });
};
module.exports["mockWindowStorage"] = $a61ea4cfed034b37$export$efebfe7859cae3c7;

});

parcelRegister("4KkEB", function(module, exports) {
const $0745f528b71a1a3c$export$3364800d9d60baf9 = 'localStorage';
module.exports["DEFAULT_STORAGE_ENGINE"] = $0745f528b71a1a3c$export$3364800d9d60baf9;

});

parcelRegister("koAyx", function(module, exports) {
class $b7cac00c977cfcad$export$f993aef960936087 {
    buildInlineAdf(url) {
        return {
            type: 'inlineCard',
            attrs: {
                url: url
            }
        };
    }
    buildBlockAdf(url) {
        return {
            type: 'blockCard',
            attrs: {
                url: url
            }
        };
    }
    buildEmbedAdf(url) {
        return {
            type: 'embedCard',
            attrs: {
                url: url,
                layout: 'wide'
            }
        };
    }
    buildDatasourceAdf(datasource, url) {
        return {
            type: 'blockCard',
            attrs: {
                url: url,
                datasource: datasource
            }
        };
    }
    toSmartlinkAdf(url, appearance) {
        switch(appearance){
            case 'inline':
                return this.buildInlineAdf(url);
            case 'block':
                return this.buildBlockAdf(url);
            case 'embed':
                return this.buildEmbedAdf(url);
        }
    }
    toDatasourceAdf(datasource, url) {
        return this.buildDatasourceAdf(datasource, url);
    }
}
module.exports["Transformer"] = $b7cac00c977cfcad$export$f993aef960936087;

});

parcelRegister("8kONW", function(module, exports) {
/**
 * URL checker utilities for Confluence content types.
 *
 * Exported via the `@atlaskit/editor-card-provider/url-checkers` subpath
 * so consumers don't have to depend on the barrel file.
 */ /**
 * Matches Confluence Slides URLs.
 *
 * Examples:
 *   - /wiki/spaces/TEAM/slide/12345
 *   - /wiki/spaces/~uid/slide/8fb8c642-803d-59fe-8d1c-066610e860c6
 */ // eslint-disable-next-line require-unicode-regexp -- consistent with isConfluenceDatabase in provider.ts
const $025d94307c54f6b4$var$CONFLUENCE_SLIDE_URL_PATTERN = /\/wiki\/spaces\/~?[\d\w]+\/slide\/[\d\w-]+(\?.*)?$/;
const $025d94307c54f6b4$export$4091d55e0211d2e1 = (url)=>$025d94307c54f6b4$var$CONFLUENCE_SLIDE_URL_PATTERN.test(url);
module.exports["isConfluenceSlideUrl"] = $025d94307c54f6b4$export$4091d55e0211d2e1;

});

parcelRegister("yuV6Z", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $378a693b2c26358e$export$ca6dda5263526f75 = '/gateway/api/emoji';
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
const $378a693b2c26358e$var$isServerEnvironment = ()=>false; // "1" true || "" false || undefined false
const $378a693b2c26358e$var$isClientEnvironment = ()=>!!window.__SSR_RENDERED__;
const $378a693b2c26358e$export$2e27ba8337eb718f = '/gateway/api/elements/emoji';
const $378a693b2c26358e$export$756c07819e5ddb69 = (cloudId, emojiId, scale)=>{
    const baseUrl = (0, $iDrrr.fg)('use-elements-stargate-emoji-path') ? $378a693b2c26358e$export$2e27ba8337eb718f : $378a693b2c26358e$export$ca6dda5263526f75;
    return `${baseUrl}/${cloudId}/${emojiId}/path?scale=${scale ?? 'MDPI'}`;
};
const $378a693b2c26358e$export$761bef4dd134445c = (params)=>{
    const { isSSR: isSSR, hasCloudId: hasCloudId, isGuestUser: isGuestUser } = params;
    const ssrEnabled = !!(isSSR && hasCloudId);
    // SSR Not Supported
    if (!ssrEnabled || isGuestUser) return false;
    // SSR For Logged in Users
    return true;
};
const $378a693b2c26358e$export$fc7d38d59502d4a6 = ({ onEmojiLoadSuccess: onEmojiLoadSuccess, onEmojiLoadFail: onEmojiLoadFail })=>{
    if (!onEmojiLoadSuccess && !onEmojiLoadFail) return undefined;
    return {
        onEmojiLoadSuccess: onEmojiLoadSuccess,
        onEmojiLoadFail: onEmojiLoadFail
    };
};
const $378a693b2c26358e$export$91e66df277b39831 = (emojiId)=>{
    const { id: id, shortName: shortName } = emojiId;
    const regexp = new RegExp(/:([^:]+):/g); // tests and takes the value between two colons
    if (id) return id;
    if (regexp.test(shortName)) return shortName.replaceAll(':', '');
    return shortName;
};
const $378a693b2c26358e$export$1dcae2834e6255a2 = (params)=>{
    // Feature enabled flags
    const isSSR = $378a693b2c26358e$var$isServerEnvironment() || $378a693b2c26358e$var$isClientEnvironment();
    const isGuestUser = !params.isLicensed || !params.isLoggedIn;
    // Transform parameters
    const cloudId = params?.cloudId ?? '';
    const userId = params?.userId ?? undefined;
    const disableUpload = params?.disableUpload;
    const emojiSSRConfig = params?.emojiSSRConfig ?? {};
    // Enable emoji ssr
    const useEmojiSSR = $378a693b2c26358e$export$761bef4dd134445c({
        isSSR: isSSR,
        hasCloudId: !!cloudId,
        isGuestUser: isGuestUser
    });
    // Default emoji SSR interface
    const emojiSSRConfigOverride = useEmojiSSR ? {
        optimisticImageApi: {
            getUrl: (emojiId)=>$378a693b2c26358e$export$756c07819e5ddb69(cloudId, $378a693b2c26358e$export$91e66df277b39831(emojiId))
        },
        ...emojiSSRConfig
    } : undefined;
    // Enable emoji load callbacks
    const emojiLoadCallbacks = $378a693b2c26358e$export$fc7d38d59502d4a6({
        onEmojiLoadSuccess: params?.onEmojiLoadSuccess,
        onEmojiLoadFail: params?.onEmojiLoadFail
    });
    return {
        cloudId: cloudId,
        userId: userId,
        disableUpload: disableUpload,
        ...useEmojiSSR && {
            emojiSSRConfig: emojiSSRConfigOverride
        },
        emojiLoadCallbacks: emojiLoadCallbacks
    };
};
module.exports["getOptimisticImageURL"] = $378a693b2c26358e$export$756c07819e5ddb69;
module.exports["getEmojiSSRSupport"] = $378a693b2c26358e$export$761bef4dd134445c;
module.exports["createEmojiProviderParameters"] = $378a693b2c26358e$export$1dcae2834e6255a2;

});

parcelRegister("jQQYu", function(module, exports) {
// Creates a cookie for object-resolver header
const $64671b371f568ec9$export$7892c26d6c7a7447 = (userContext)=>{
    const cookieTarget = 'cloud.session.token';
    return `${cookieTarget}=${userContext}`;
};
module.exports["createCookie"] = $64671b371f568ec9$export$7892c26d6c7a7447;

});

parcelRegister("8Pm8w", function(module, exports) {
/* eslint-disable require-unicode-regexp  */ 
var $cozmU = parcelRequire("cozmU");


var $ieeJu = parcelRequire("ieeJu");


var $3xsB6 = parcelRequire("3xsB6");


var $05aaK = parcelRequire("05aaK");


var $79ir6 = parcelRequire("79ir6");


var $916Gd = parcelRequire("916Gd");


var $7GRSG = parcelRequire("7GRSG");


var $cuwGS = parcelRequire("cuwGS");


var $d04Ge = parcelRequire("d04Ge");

const $9b0c4608cd445e14$var$BLOCK_ARI_TO_RESOURCE_ID_REGEX = /^ari:cloud:blocks:.*:synced-block\/(.+)$/;
const $9b0c4608cd445e14$var$EXTRACT_RESOURCE_ID_FROM_BLOCK_ARI_REGEX = /ari:cloud:blocks:[^:]+:synced-block\/(.+)$/;
const $9b0c4608cd445e14$var$mapBlockError = (error)=>{
    switch(error.status){
        case 400:
        case 401:
            return (0, $79ir6.SyncBlockError).InvalidRequest;
        case 403:
            return (0, $79ir6.SyncBlockError).Forbidden;
        case 404:
            return (0, $79ir6.SyncBlockError).NotFound;
        case 409:
            return (0, $79ir6.SyncBlockError).Conflict;
        case 429:
            return (0, $79ir6.SyncBlockError).RateLimited;
        case 500:
        case 503:
        case 504:
            return (0, $79ir6.SyncBlockError).ServerError;
    }
    return (0, $79ir6.SyncBlockError).Errored;
};
const $9b0c4608cd445e14$var$mapErrorResponseCode = (errorCode)=>{
    switch(errorCode){
        case 'FORBIDDEN':
            return (0, $79ir6.SyncBlockError).Forbidden;
        case 'RESOURCE_NOT_FOUND':
        case 'NOT_FOUND':
            return (0, $79ir6.SyncBlockError).NotFound;
        case 'EntityNotFound':
            return (0, $79ir6.SyncBlockError).EntityNotFound;
        case 'INVALID_REQUEST':
            return (0, $79ir6.SyncBlockError).InvalidRequest;
        case 'CONFLICT':
            return (0, $79ir6.SyncBlockError).Conflict;
        case 'RATE_LIMITED':
            return (0, $79ir6.SyncBlockError).RateLimited;
        case 'SERVER_ERROR':
            return (0, $79ir6.SyncBlockError).ServerError;
        case 'INVALID_CONTENT':
            return (0, $79ir6.SyncBlockError).InvalidContent;
        default:
            return (0, $79ir6.SyncBlockError).Errored;
    }
};
const $9b0c4608cd445e14$export$7a367d6c9621d11 = (blockAri)=>{
    // Validate ARI format and extract resourceId using regex
    // Format: ari:cloud:blocks:{uuid}:synced-block/{product}/{parentId}/{resourceId}
    // The regex captures the full path after synced-block/
    // e.g. ari:cloud:blocks:DUMMY-a5a01d21-1cc3-4f29-9565-f2bb8cd969f5:synced-block/confluence-page/455232061495/e8cf64e3-1b6e-489b-ad86-8465b0905bb4
    // should return confluence-page/455232061495/e8cf64e3-1b6e-489b-ad86-8465b0905bb4
    const match = blockAri.match($9b0c4608cd445e14$var$BLOCK_ARI_TO_RESOURCE_ID_REGEX);
    return match?.[1] || null;
};
const $9b0c4608cd445e14$export$bba762cb095b2f42 = (data, resourceId)=>{
    let createdAt;
    if (data.createdAt !== undefined && data.createdAt !== null) try {
        createdAt = new Date(data.createdAt).toISOString();
    } catch  {
        // fallback to undefined
        // as we don't want to block the whole process due to invalid date
        createdAt = undefined;
    }
    return {
        blockInstanceId: data.blockInstanceId,
        content: JSON.parse(data.content),
        contentUpdatedAt: (0, $d04Ge.convertContentUpdatedAt)(data.contentUpdatedAt),
        createdAt: createdAt,
        createdBy: data.createdBy,
        product: data.product,
        resourceId: resourceId,
        sourceAri: data.sourceAri,
        status: data.status
    };
};
const $9b0c4608cd445e14$export$17132bdfdc28611c = async (documentAri)=>{
    let response;
    try {
        response = await (0, $05aaK.getReferenceSyncedBlocks)(documentAri);
    } catch (error) {
        if (error instanceof (0, $05aaK.BlockError)) return $9b0c4608cd445e14$var$mapBlockError(error);
        return (0, $79ir6.SyncBlockError).Errored;
    }
    const { blocks: blocks, errors: errors } = response || {};
    const blocksInstances = (blocks || []).map((blockContentResponse)=>{
        try {
            const resourceId = $9b0c4608cd445e14$export$7a367d6c9621d11(blockContentResponse.blockAri);
            if (!resourceId) // could not extract resourceId from blockAri, return InvalidContent error
            return {
                error: {
                    type: (0, $79ir6.SyncBlockError).InvalidContent
                },
                resourceId: blockContentResponse.blockAri
            };
            return {
                data: $9b0c4608cd445e14$export$bba762cb095b2f42(blockContentResponse, resourceId),
                resourceId: resourceId
            };
        } catch  {
            // JSON parsing error, return InvalidContent error
            return {
                error: {
                    type: (0, $79ir6.SyncBlockError).InvalidContent
                },
                resourceId: blockContentResponse.blockAri
            };
        }
    });
    const errorInstances = (errors || []).map((errorBlock)=>({
            error: {
                type: (0, $79ir6.SyncBlockError).Errored
            },
            resourceId: errorBlock.blockAri
        }));
    return [
        ...blocksInstances,
        ...errorInstances
    ];
};
const $9b0c4608cd445e14$export$2837853885c81488 = (blockAri)=>{
    const match = blockAri.match($9b0c4608cd445e14$var$EXTRACT_RESOURCE_ID_FROM_BLOCK_ARI_REGEX);
    return match?.[1];
};
const $9b0c4608cd445e14$export$abdcb5d4d6767e73 = async (cloudId, parentAri, blockNodeIdentifiers, config)=>{
    const blockIdentifiers = blockNodeIdentifiers.map((blockIdentifier)=>({
            blockAri: (0, $3xsB6.generateBlockAriFromReference)({
                cloudId: cloudId,
                resourceId: blockIdentifier.resourceId
            }),
            blockInstanceId: blockIdentifier.blockInstanceId
        }));
    // Create a set of valid resourceIds for validation
    const validResourceIds = new Set(blockNodeIdentifiers.map((blockNodeIdentifier)=>blockNodeIdentifier.resourceId));
    // Track which resourceIds have been processed
    const processedResourceIds = new Set();
    if (!parentAri) return blockNodeIdentifiers.map((blockNodeIdentifier)=>({
            error: {
                type: (0, $79ir6.SyncBlockError).Errored
            },
            resourceId: blockNodeIdentifier.resourceId
        }));
    try {
        const response = await (0, $05aaK.batchRetrieveSyncedBlocks)({
            blockIdentifiers: blockIdentifiers,
            config: config
        });
        const results = [];
        // Process successful blocks
        if (response.success) for (const blockContentResponse of response.success){
            // Extract resourceId from the returned blockAri
            const resourceId = $9b0c4608cd445e14$export$2837853885c81488(blockContentResponse.blockAri);
            if (!resourceId || !validResourceIds.has(resourceId)) continue;
            processedResourceIds.add(resourceId);
            const { content: content, deletionReason: deletionReason, sourceAri: sourceAri, blockAri: blockAri, contentUpdatedAt: contentUpdatedAt, blockInstanceId: blockInstanceId, product: product, status: status } = blockContentResponse;
            if (!content) {
                results.push({
                    error: {
                        type: (0, $79ir6.SyncBlockError).NotFound,
                        reason: deletionReason,
                        sourceAri: sourceAri
                    },
                    resourceId: resourceId
                });
                continue;
            }
            try {
                const syncedBlockData = JSON.parse(content);
                results.push({
                    data: {
                        content: syncedBlockData,
                        resourceId: blockAri,
                        contentUpdatedAt: (0, $d04Ge.convertContentUpdatedAt)(contentUpdatedAt),
                        blockInstanceId: blockInstanceId,
                        sourceAri: sourceAri,
                        product: product,
                        status: status,
                        deletionReason: deletionReason
                    },
                    resourceId: resourceId
                });
            } catch  {
                results.push({
                    error: {
                        type: (0, $79ir6.SyncBlockError).Errored,
                        reason: `parsing JSON content response failed for resourceId: ${resourceId} localId: ${blockAri}`
                    },
                    resourceId: resourceId
                });
            }
        }
        // Process errors
        if (response.error) for (const errorResponse of response.error){
            // Extract resourceId from the returned blockAri
            const resourceId = $9b0c4608cd445e14$export$2837853885c81488(errorResponse.blockAri);
            if (!resourceId || !validResourceIds.has(resourceId)) continue;
            processedResourceIds.add(resourceId);
            results.push({
                error: {
                    type: $9b0c4608cd445e14$var$mapErrorResponseCode(errorResponse.code),
                    reason: errorResponse.reason
                },
                resourceId: resourceId
            });
        }
        // Ensure all resourceIds have a result - return NotFound for any missing ones
        for (const blockNodeIdentifier of blockNodeIdentifiers)if (!processedResourceIds.has(blockNodeIdentifier.resourceId)) results.push({
            error: {
                type: (0, $79ir6.SyncBlockError).NotFound
            },
            resourceId: blockNodeIdentifier.resourceId
        });
        return results;
    } catch (error) {
        if (error instanceof (0, $05aaK.BlockTimeoutError) && (0, $ieeJu.expValEquals)('platform_editor_sync_block_ssr_config', 'isEnabled', true)) return blockNodeIdentifiers.map((blockNodeIdentifier)=>({
                error: {
                    type: (0, $79ir6.SyncBlockError).Aborted,
                    reason: error.message
                },
                resourceId: blockNodeIdentifier.resourceId
            }));
        // If batch request fails, return error for all resourceIds. Capture the HTTP
        // status from `BlockError` so fetch analytics can break failures down by
        // statusCode (EDITOR-7862); undefined for non-HTTP failures. Thread the PII-safe
        // original message/name so the renderer can de-opaque the `errored` bucket.
        return blockNodeIdentifiers.map((blockNodeIdentifier)=>({
                error: {
                    type: error instanceof (0, $05aaK.BlockError) ? $9b0c4608cd445e14$var$mapBlockError(error) : (0, $79ir6.SyncBlockError).Errored,
                    reason: error.message,
                    ...error instanceof (0, $05aaK.BlockError) && {
                        statusCode: error.status
                    },
                    ...(0, $916Gd.getPiiSafeOriginalError)(error)
                },
                resourceId: blockNodeIdentifier.resourceId
            }));
    }
};
const $9b0c4608cd445e14$export$13b682467148f88a = async (cloudId, parentAri, parentId, product, data, stepVersion)=>{
    if (!parentAri || !parentId) return data.map((block)=>({
            error: (0, $79ir6.SyncBlockError).Errored,
            resourceId: block.resourceId
        }));
    try {
        // Create a map from blockAri to original resourceId for matching responses
        const blockAriToResourceIdMap = new Map();
        const blocks = data.map((block)=>{
            const blockAri = (0, $3xsB6.generateBlockAri)({
                cloudId: cloudId,
                parentId: parentId,
                product: product,
                resourceId: block.resourceId
            });
            blockAriToResourceIdMap.set(blockAri, block.resourceId);
            return {
                blockAri: blockAri,
                content: JSON.stringify(block.content),
                status: block.status,
                stepVersion: stepVersion
            };
        });
        const response = await (0, $05aaK.updateSyncedBlocks)({
            blocks: blocks
        });
        const results = [];
        // Process successful updates
        if (response.success) {
            const successResourceIds = new Set(response.success.map((block)=>blockAriToResourceIdMap.get(block.blockAri)));
            for (const block of data)if (successResourceIds.has(block.resourceId)) results.push({
                resourceId: block.resourceId
            });
        }
        if (response.error) {
            const errorResourceIds = new Map(response.error.map((err)=>[
                    // Use the map to get the original resourceId
                    blockAriToResourceIdMap.get(err.blockAri) || '',
                    $9b0c4608cd445e14$var$mapErrorResponseCode(err.code)
                ]));
            for (const block of data){
                const error = errorResourceIds.get(block.resourceId);
                if (error) results.push({
                    error: error,
                    resourceId: block.resourceId
                });
                else if (!results.some((r)=>r.resourceId === block.resourceId)) // If not in success or error lists, mark as errored
                results.push({
                    error: (0, $79ir6.SyncBlockError).Errored,
                    resourceId: block.resourceId
                });
            }
        }
        return results;
    } catch (error) {
        if (error instanceof (0, $05aaK.BlockError)) return data.map((block)=>({
                error: $9b0c4608cd445e14$var$mapBlockError(error),
                resourceId: block.resourceId,
                statusCode: error.status
            }));
        return data.map((block)=>({
                error: (0, $916Gd.stringifyError)(error),
                resourceId: block.resourceId
            }));
    }
};

/**
 * ADFFetchProvider implementation that fetches synced block data from Block Service API
 */ class $9b0c4608cd445e14$var$BlockServiceADFFetchProvider {
    // resourceId of the reference synced block.
    // the ARI must be constructed to call the block service API
    async fetchData(resourceId) {
        const blockAri = (0, $3xsB6.generateBlockAriFromReference)({
            cloudId: this.cloudId,
            resourceId: resourceId
        });
        try {
            const blockContentResponse = await (0, $05aaK.getSyncedBlockContent)({
                blockAri: blockAri
            });
            const { content: content, sourceAri: sourceAri, deletionReason: deletionReason, blockInstanceId: blockInstanceId, contentUpdatedAt: contentUpdatedAt, product: product, status: status } = blockContentResponse;
            if (!content) return {
                error: {
                    type: (0, $79ir6.SyncBlockError).NotFound,
                    reason: deletionReason,
                    sourceAri: sourceAri
                },
                resourceId: resourceId
            };
            // Parse the synced block content from the response's content
            const syncedBlockData = JSON.parse(content);
            return {
                data: {
                    content: syncedBlockData,
                    resourceId: blockAri,
                    blockInstanceId: blockInstanceId,
                    // this was the node's localId, but has become the resourceId.
                    contentUpdatedAt: (0, $d04Ge.convertContentUpdatedAt)(contentUpdatedAt),
                    sourceAri: sourceAri,
                    product: product,
                    status: status,
                    deletionReason: deletionReason
                },
                resourceId: resourceId
            };
        } catch (error) {
            if (error instanceof (0, $05aaK.BlockError)) // Capture the HTTP status so fetch analytics can break failures down by
            // statusCode (EDITOR-7862). Thread the PII-safe original message/name so
            // the renderer can de-opaque failures.
            return {
                error: {
                    type: $9b0c4608cd445e14$var$mapBlockError(error),
                    reason: error.message,
                    statusCode: error.status,
                    ...(0, $916Gd.getPiiSafeOriginalError)(error)
                },
                resourceId: resourceId
            };
            return {
                error: {
                    type: (0, $79ir6.SyncBlockError).Errored,
                    reason: error.message,
                    ...(0, $916Gd.getPiiSafeOriginalError)(error)
                },
                resourceId: resourceId
            };
        }
    }
    async fetchReferences(referenceResourceId) {
        try {
            const blockAri = (0, $3xsB6.generateBlockAriFromReference)({
                cloudId: this.cloudId,
                resourceId: referenceResourceId
            });
            const response = await (0, $05aaK.getReferenceSyncedBlocksByBlockAri)({
                blockAri: blockAri
            });
            const locationScopeOf = (documentAri)=>(0, $7GRSG.getFieldAwareLocationScope)({
                    documentAri: documentAri,
                    hostAri: this.parentAri,
                    productType: (0, $3xsB6.getProductFromSourceAri)(documentAri)
                });
            const references = [];
            response.references.forEach((reference)=>{
                references.push({
                    ...reference,
                    hasAccess: true,
                    onSameDocument: this.parentAri === reference.documentAri,
                    ...locationScopeOf(reference.documentAri)
                });
            });
            response.errors.forEach((reference)=>{
                if (reference.code === 'FORBIDDEN') references.push({
                    blockAri: reference.blockAri,
                    documentAri: reference.documentAri,
                    hasAccess: false,
                    onSameDocument: false,
                    ...locationScopeOf(reference.documentAri)
                });
            });
            return {
                references: references
            };
        } catch (error) {
            if (error instanceof (0, $05aaK.BlockError)) return {
                error: $9b0c4608cd445e14$var$mapBlockError(error)
            };
            return {
                error: (0, $79ir6.SyncBlockError).Errored
            };
        }
    }
    /**
   * Batch fetches multiple synced blocks by their resource IDs.
   * @param blockNodeIdentifiers - Array of block node identifiers to fetch
   * @param config - Optional batch fetch configuration
   * @returns Array of SyncBlockInstance results
   */ async batchFetchData(blockNodeIdentifiers, config) {
        return await $9b0c4608cd445e14$export$abdcb5d4d6767e73(this.cloudId, this.parentAri, blockNodeIdentifiers, config);
    }
    /**
   * Subscribes to real-time updates for a specific block using GraphQL WebSocket subscriptions.
   * @param resourceId - The resource ID of the block to subscribe to
   * @param onUpdate - Callback function invoked when the block is updated
   * @param onError - Optional callback function invoked on subscription errors
   * @returns Unsubscribe function to stop receiving updates
   */ subscribeToBlockUpdates(resourceId, onUpdate, onError, onComplete) {
        const blockAri = (0, $3xsB6.generateBlockAriFromReference)({
            cloudId: this.cloudId,
            resourceId: resourceId
        });
        // Track the real unsubscribe fn once the dynamic import resolves
        let unsubscribe;
        let cancelled = false;
        // Dynamically import blockSubscription so that graphql-ws is NOT pulled
        // into the SSR/preload bundle that imports this subpath.
        (parcelRequire("hteGz")).then(({ subscribeToBlockUpdates: subscribeToBlockUpdatesWS })=>{
            if (cancelled) return;
            unsubscribe = subscribeToBlockUpdatesWS(blockAri, (parsedData)=>{
                // Convert ParsedBlockSubscriptionData to SyncBlockInstance
                const syncBlockInstance = {
                    data: {
                        content: parsedData.content,
                        resourceId: parsedData.blockAri,
                        blockInstanceId: parsedData.blockInstanceId,
                        sourceAri: parsedData.sourceAri,
                        product: parsedData.product,
                        createdAt: parsedData.createdAt,
                        contentUpdatedAt: parsedData.contentUpdatedAt,
                        createdBy: parsedData.createdBy,
                        status: parsedData.status
                    },
                    resourceId: parsedData.resourceId
                };
                onUpdate(syncBlockInstance);
            }, onError, onComplete);
        }).catch((err)=>{
            if (cancelled) return;
            onError?.(err instanceof Error ? err : new Error('Failed to load subscription module'));
        });
        // Return an unsubscribe fn that works whether the import has resolved or not
        return ()=>{
            cancelled = true;
            unsubscribe?.();
        };
    }
    constructor({ cloudId: cloudId, parentAri: parentAri }){
        this.cloudId = void 0;
        this.parentAri = void 0;
        this.cloudId = cloudId;
        this.parentAri = parentAri;
    }
}
/**
 * ADFWriteProvider implementation that writes synced block data to Block Service API
 */ class $9b0c4608cd445e14$var$BlockServiceADFWriteProvider {
    async writeData(data) {
        if (!this.parentAri || !this.parentId) return {
            error: (0, $79ir6.SyncBlockError).Errored
        };
        const { resourceId: resourceId } = data;
        const blockAri = (0, $3xsB6.generateBlockAri)({
            cloudId: this.cloudId,
            parentId: this.parentId,
            product: this.product,
            resourceId: resourceId
        });
        const stepVersion = this.getVersion ? await this.getVersion() : undefined;
        try {
            const status = data.status;
            await (0, $05aaK.updateSyncedBlock)({
                blockAri: blockAri,
                content: JSON.stringify(data.content),
                stepVersion: stepVersion,
                status: status
            });
            return {
                resourceId: resourceId
            };
        } catch (error) {
            if (error instanceof (0, $05aaK.BlockError)) return {
                error: $9b0c4608cd445e14$var$mapBlockError(error),
                resourceId: resourceId,
                statusCode: error.status
            };
            return {
                error: (0, $916Gd.stringifyError)(error),
                resourceId: resourceId
            };
        }
    }
    async createData(data) {
        if (!this.parentAri || !this.parentId) return {
            error: (0, $79ir6.SyncBlockError).Errored
        };
        const { resourceId: resourceId } = data;
        const blockAri = (0, $3xsB6.generateBlockAri)({
            cloudId: this.cloudId,
            parentId: this.parentId,
            product: this.product,
            resourceId: resourceId
        });
        const stepVersion = this.getVersion ? await this.getVersion() : undefined;
        const status = 'unpublished';
        try {
            await (0, $05aaK.createSyncedBlock)({
                blockAri: blockAri,
                blockInstanceId: data.blockInstanceId,
                sourceAri: this.parentAri,
                product: this.product,
                content: JSON.stringify(data.content),
                stepVersion: stepVersion,
                status: status
            });
            return {
                resourceId: resourceId
            };
        } catch (error) {
            if (error instanceof (0, $05aaK.BlockError)) return {
                error: $9b0c4608cd445e14$var$mapBlockError(error),
                resourceId: resourceId,
                statusCode: error.status
            };
            return {
                error: (0, $916Gd.stringifyError)(error),
                resourceId: resourceId
            };
        }
    }
    // soft deletes the source synced block
    async deleteData(resourceId, deleteReason) {
        if (!this.parentId) return {
            resourceId: resourceId,
            success: false,
            error: (0, $79ir6.SyncBlockError).Errored
        };
        const blockAri = (0, $3xsB6.generateBlockAri)({
            cloudId: this.cloudId,
            parentId: this.parentId,
            product: this.product,
            resourceId: resourceId
        });
        try {
            await (0, $05aaK.deleteSyncedBlock)({
                blockAri: blockAri,
                deleteReason: deleteReason
            });
            return {
                resourceId: resourceId,
                success: true,
                error: undefined
            };
        } catch (error) {
            if (error instanceof (0, $05aaK.BlockNotFoundError) && this.parentAri) return this.deleteOrphanBlock({
                blockAri: blockAri,
                resourceId: resourceId,
                parentAri: this.parentAri,
                deleteReason: deleteReason
            });
            if (error instanceof (0, $05aaK.BlockError)) {
                if (error.status === 404) // User should not be blocked by not_found error when deleting,
                // hence returns successful result for 404 error
                return {
                    resourceId: resourceId,
                    success: true
                };
                return {
                    resourceId: resourceId,
                    success: false,
                    error: $9b0c4608cd445e14$var$mapBlockError(error),
                    statusCode: error.status
                };
            }
            return {
                resourceId: resourceId,
                success: false,
                error: (0, $916Gd.stringifyError)(error)
            };
        }
    }
    // The block is an orphan (e.g. from a copied page) — it doesn't exist in Block Service.
    // Block Service uses soft-deletes, so we must first create the block then delete it,
    // ensuring a deletion-reason record is stored (used to display errors in reference blocks).
    async deleteOrphanBlock({ blockAri: blockAri, resourceId: resourceId, parentAri: parentAri, deleteReason: deleteReason }) {
        try {
            const stepVersion = this.getVersion ? await this.getVersion() : undefined;
            try {
                await (0, $05aaK.createSyncedBlock)({
                    blockAri: blockAri,
                    blockInstanceId: resourceId,
                    sourceAri: parentAri,
                    product: this.product,
                    content: '[]',
                    stepVersion: stepVersion
                });
            } catch (createError) {
                // "Conditional check failed" means the block already exists in Block Service.
                // This can happen when an orphan block is copied and pasted — a reference block repair
                // in the backend may have already created it. We can proceed directly to delete it.
                if (createError instanceof Error && createError.message.includes('Conditional check failed')) ;
                else if (createError instanceof (0, $05aaK.BlockError)) return {
                    resourceId: resourceId,
                    success: false,
                    error: $9b0c4608cd445e14$var$mapBlockError(createError),
                    statusCode: createError.status
                };
                else return {
                    resourceId: resourceId,
                    success: false,
                    error: (0, $916Gd.stringifyError)(createError)
                };
            }
            await (0, $05aaK.deleteSyncedBlock)({
                blockAri: blockAri,
                deleteReason: deleteReason
            });
            return {
                resourceId: resourceId,
                success: true,
                error: undefined
            };
        } catch (error) {
            if (error instanceof (0, $05aaK.BlockError)) return {
                resourceId: resourceId,
                success: false,
                error: $9b0c4608cd445e14$var$mapBlockError(error),
                statusCode: error.status
            };
            return {
                resourceId: resourceId,
                success: false,
                error: (0, $916Gd.stringifyError)(error)
            };
        }
    }
    // the sourceId is the resourceId of the source synced block.
    generateResourceIdForReference(sourceId) {
        return (0, $cuwGS.createResourceIdForReference)(this.product, this.parentId || '', sourceId);
    }
    generateResourceId() {
        return crypto.randomUUID();
    }
    generateBlockAri(resourceId) {
        return (0, $3xsB6.generateBlockAri)({
            cloudId: this.cloudId,
            parentId: this.parentId || '',
            product: this.product,
            resourceId: resourceId
        });
    }
    async updateReferenceData(blocks, noContent) {
        if (!this.parentAri) return {
            success: false,
            error: (0, $79ir6.SyncBlockError).Errored
        };
        try {
            await (0, $05aaK.updateReferenceSyncedBlockOnDocument)({
                documentAri: this.parentAri,
                blocks: blocks.map((block)=>({
                        blockAri: (0, $3xsB6.generateBlockAriFromReference)({
                            cloudId: this.cloudId,
                            resourceId: block.resourceId
                        }),
                        blockInstanceId: block.localId
                    })),
                noContent: noContent
            });
            return {
                success: true
            };
        } catch (error) {
            if (error instanceof (0, $05aaK.BlockError)) return {
                success: false,
                error: $9b0c4608cd445e14$var$mapBlockError(error),
                statusCode: error.status
            };
            return {
                success: false,
                error: (0, $916Gd.stringifyError)(error)
            };
        }
    }
    async writeDataBatch(data) {
        if (!this.parentAri || !this.parentId) return data.map((block)=>({
                error: (0, $79ir6.SyncBlockError).Errored,
                resourceId: block.resourceId
            }));
        const stepVersion = this.getVersion ? await this.getVersion() : undefined;
        try {
            // Create a map from blockAri to original resourceId for matching responses
            const blockAriToResourceIdMap = new Map();
            const blocks = data.map((block)=>{
                const blockAri = this.generateBlockAri(block.resourceId);
                blockAriToResourceIdMap.set(blockAri, block.resourceId);
                return {
                    blockAri: blockAri,
                    content: JSON.stringify(block.content),
                    status: block.status,
                    stepVersion: stepVersion
                };
            });
            const response = await (0, $05aaK.updateSyncedBlocks)({
                blocks: blocks
            });
            const results = [];
            // Process successful updates
            if (response.success) {
                const successBlocks = new Map(response.success.map((block)=>[
                        blockAriToResourceIdMap.get(block.blockAri),
                        block
                    ]));
                for (const block of data){
                    const successBlock = successBlocks.get(block.resourceId);
                    if (successBlock) results.push({
                        resourceId: block.resourceId,
                        status: successBlock.status
                    });
                }
            }
            if (response.error) {
                const errorResourceIds = new Map(response.error.map((err)=>[
                        // Use the map to get the original resourceId
                        blockAriToResourceIdMap.get(err.blockAri) || '',
                        $9b0c4608cd445e14$var$mapErrorResponseCode(err.code)
                    ]));
                for (const block of data){
                    const error = errorResourceIds.get(block.resourceId);
                    if (error) {
                        if (error !== (0, $79ir6.SyncBlockError).NotFound) results.push({
                            error: error,
                            resourceId: block.resourceId
                        });
                    } else if (!results.some((r)=>r.resourceId === block.resourceId)) // If not in success or error lists, mark as errored
                    results.push({
                        error: (0, $79ir6.SyncBlockError).Errored,
                        resourceId: block.resourceId
                    });
                }
            }
            return results;
        } catch (error) {
            if (error instanceof (0, $05aaK.BlockError)) return data.map((block)=>({
                    error: $9b0c4608cd445e14$var$mapBlockError(error),
                    resourceId: block.resourceId,
                    statusCode: error.status
                }));
            return data.map((block)=>({
                    error: (0, $916Gd.stringifyError)(error),
                    resourceId: block.resourceId
                }));
        }
    }
    constructor({ cloudId: cloudId, parentAri: parentAri, parentId: parentId, product: product, getVersion: getVersion }){
        this.cloudId = void 0;
        this.parentId = void 0;
        this.getVersion = void 0;
        this.product = void 0;
        this.parentAri = void 0;
        this.cloudId = cloudId;
        this.parentAri = parentAri;
        this.parentId = parentId;
        this.product = product;
        this.getVersion = getVersion;
    }
}
const $9b0c4608cd445e14$var$createBlockServiceAPIProviders = ({ cloudId: cloudId, parentAri: parentAri, parentId: parentId, product: product, getVersion: getVersion })=>{
    return {
        fetchProvider: new $9b0c4608cd445e14$var$BlockServiceADFFetchProvider({
            cloudId: cloudId,
            parentAri: parentAri
        }),
        writeProvider: new $9b0c4608cd445e14$var$BlockServiceADFWriteProvider({
            cloudId: cloudId,
            parentAri: parentAri,
            parentId: parentId,
            product: product,
            getVersion: getVersion
        })
    };
};
const $9b0c4608cd445e14$export$ec654f5ac7e6d976 = ({ cloudId: cloudId, parentAri: parentAri, parentId: parentId, product: product, getVersion: getVersion })=>{
    return (0, $cozmU.useMemo)(()=>{
        return $9b0c4608cd445e14$var$createBlockServiceAPIProviders({
            cloudId: cloudId,
            parentAri: parentAri,
            parentId: parentId,
            product: product,
            getVersion: getVersion
        });
    }, [
        cloudId,
        parentAri,
        parentId,
        product,
        getVersion
    ]);
};
const $9b0c4608cd445e14$var$createBlockServiceFetchOnlyAPIProvider = ({ cloudId: cloudId, parentAri: parentAri })=>{
    return {
        fetchProvider: new $9b0c4608cd445e14$var$BlockServiceADFFetchProvider({
            cloudId: cloudId,
            parentAri: parentAri
        }),
        writeProvider: undefined
    };
};
const $9b0c4608cd445e14$export$1e67317f82b65067 = ({ cloudId: cloudId, parentAri: parentAri })=>(0, $cozmU.useMemo)(()=>$9b0c4608cd445e14$var$createBlockServiceFetchOnlyAPIProvider({
            cloudId: cloudId,
            parentAri: parentAri
        }), [
        cloudId,
        parentAri
    ]);
module.exports["batchFetchData"] = $9b0c4608cd445e14$export$abdcb5d4d6767e73;
module.exports["useMemoizedBlockServiceAPIProviders"] = $9b0c4608cd445e14$export$ec654f5ac7e6d976;

});

parcelRegister("3xsB6", function(module, exports) {
/* eslint-disable require-unicode-regexp */ 
var $4o0zT = parcelRequire("4o0zT");


var $EBNuL = parcelRequire("EBNuL");

const $a2c616dead6b3b85$var$GET_LOCAL_ID_FROM_BLOCK_RESOURCE_ID_REGEX = /ari:cloud:blocks:[^:]+:synced-block\/([a-zA-Z0-9-]+)/;
const $a2c616dead6b3b85$var$JIRA_SOURCE_ARI_REGEX = /ari:cloud:jira:.*/;
const $a2c616dead6b3b85$var$CONFLUENCE_SOURCE_ARI_REGEX = /ari:cloud:confluence:.*/;
const $a2c616dead6b3b85$export$e79189cdb9940bc5 = ({ cloudId: cloudId, parentId: parentId, product: product, resourceId: resourceId })=>{
    return `ari:cloud:blocks:${cloudId}:synced-block/${product}/${parentId}/${resourceId}`;
};
const $a2c616dead6b3b85$export$92a2331f8a9ed841 = ({ cloudId: cloudId, resourceId: resourceId })=>{
    return `ari:cloud:blocks:${cloudId}:synced-block/${resourceId}`;
};
const $a2c616dead6b3b85$export$3f0878b0afe5a2c0 = (ari)=>{
    const match = ari.match($a2c616dead6b3b85$var$GET_LOCAL_ID_FROM_BLOCK_RESOURCE_ID_REGEX);
    if (match?.[1]) return match[1];
    throw new Error(`Invalid block ARI: ${ari}`);
};
const $a2c616dead6b3b85$export$36d45714d1e88dec = ({ documentAri: documentAri, hostAri: hostAri })=>{
    if (documentAri === hostAri) return 'same-document';
    const location = (0, $EBNuL.parseJiraFieldLocation)({
        ari: documentAri
    });
    const hostLocation = (0, $EBNuL.parseJiraFieldLocation)({
        ari: hostAri
    });
    if (!location || !hostLocation || location.issueAri !== hostLocation.issueAri) return 'elsewhere';
    return location.fieldId === hostLocation.fieldId ? 'same-document' : 'same-parent-document';
};
const $a2c616dead6b3b85$export$c10656f449ea0fb5 = (ari)=>{
    if (!ari && (0, $4o0zT.isExperimentEnabled)('platform_editor_blocks_patch_11')) return undefined;
    const jiraMatch = ari?.search($a2c616dead6b3b85$var$JIRA_SOURCE_ARI_REGEX);
    if (jiraMatch !== -1) return 'jira-work-item';
    const confluenceMatch = ari?.search($a2c616dead6b3b85$var$CONFLUENCE_SOURCE_ARI_REGEX);
    if (confluenceMatch !== -1) return 'confluence-page';
    return undefined;
};
module.exports["generateBlockAri"] = $a2c616dead6b3b85$export$e79189cdb9940bc5;
module.exports["generateBlockAriFromReference"] = $a2c616dead6b3b85$export$92a2331f8a9ed841;
module.exports["getLocationScope"] = $a2c616dead6b3b85$export$36d45714d1e88dec;
module.exports["getProductFromSourceAri"] = $a2c616dead6b3b85$export$c10656f449ea0fb5;

});

parcelRegister("EBNuL", function(module, exports) {
/* eslint-disable require-unicode-regexp  */ const $059546548da04295$var$JIRA_WORK_ITEM_ARI_REGEX = /ari:cloud:jira:([^:]+):issue\/(\d+)/;
const $059546548da04295$var$JIRA_ISSUE_FIELD_VALUE_ARI_REGEX = /ari:cloud:jira:([^:]+):issuefieldvalue\/([^/]+)\/([^/]+)/;
const $059546548da04295$export$e7d6f26185793d4f = ({ cloudId: cloudId, workItemId: workItemId })=>{
    return `ari:cloud:jira:${cloudId}:issue/${workItemId}`;
};
const $059546548da04295$var$getFieldValueAriParts = (ari)=>{
    const match = ari.match($059546548da04295$var$JIRA_ISSUE_FIELD_VALUE_ARI_REGEX);
    if (match?.[1] && match[2] && match[3]) return {
        cloudId: match[1],
        issueId: match[2],
        fieldId: match[3]
    };
    return undefined;
};
const $059546548da04295$export$3ee1e41ffca0b1ff = ({ ari: ari })=>{
    const match = ari.match($059546548da04295$var$JIRA_WORK_ITEM_ARI_REGEX);
    if (match?.[2]) return match[2];
    const fieldValueParts = $059546548da04295$var$getFieldValueAriParts(ari);
    if (fieldValueParts) return fieldValueParts.issueId;
    throw new Error(`Invalid Jira work item ARI: ${ari}`);
};
const $059546548da04295$export$9d29a8e91440be5c = ({ ari: ari })=>{
    const fieldValueParts = $059546548da04295$var$getFieldValueAriParts(ari);
    if (fieldValueParts) return $059546548da04295$export$e7d6f26185793d4f({
        cloudId: fieldValueParts.cloudId,
        workItemId: fieldValueParts.issueId
    });
    return ari;
};
const $059546548da04295$var$JIRA_DESCRIPTION_FIELD_ID = 'description';
const $059546548da04295$var$toJiraFieldLocation = ({ cloudId: cloudId, fieldId: fieldId, issueId: issueId })=>({
        fieldId: fieldId,
        issueAri: $059546548da04295$export$e7d6f26185793d4f({
            cloudId: cloudId,
            workItemId: issueId
        })
    });
const $059546548da04295$export$decd92eb8dd00bf5 = ({ ari: ari })=>{
    const workItemMatch = ari.match($059546548da04295$var$JIRA_WORK_ITEM_ARI_REGEX);
    if (workItemMatch?.[1] && workItemMatch[2]) return $059546548da04295$var$toJiraFieldLocation({
        cloudId: workItemMatch[1],
        fieldId: $059546548da04295$var$JIRA_DESCRIPTION_FIELD_ID,
        issueId: workItemMatch[2]
    });
    const fieldValueParts = $059546548da04295$var$getFieldValueAriParts(ari);
    return fieldValueParts && $059546548da04295$var$toJiraFieldLocation(fieldValueParts);
};
module.exports["getJiraIssueAriFromSourceAri"] = $059546548da04295$export$9d29a8e91440be5c;
module.exports["parseJiraFieldLocation"] = $059546548da04295$export$decd92eb8dd00bf5;

});

parcelRegister("05aaK", function(module, exports) {

var $4o0zT = parcelRequire("4o0zT");


var $48FpT = parcelRequire("48FpT");

const $59e004c7d849e8bb$export$f426a9918d7f49b3 = (response)=>{
    const content = response.content;
    return typeof content === 'string';
};
const $59e004c7d849e8bb$export$571f6abc3f4e5951 = async (documentAri)=>{
    const bodyData = {
        query: $59e004c7d849e8bb$var$buildGetDocumentReferenceBlocksQuery(documentAri),
        operationName: $59e004c7d849e8bb$var$GET_DOCUMENT_REFERENCE_BLOCKS_OPERATION_NAME
    };
    const url = `${$59e004c7d849e8bb$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockGetDocumentReferenceBlocks`;
    const response = await (0, $48FpT.fetchWithRetry)(url, {
        method: 'POST',
        headers: $59e004c7d849e8bb$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $59e004c7d849e8bb$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!result.data) throw new Error('No data returned from GraphQL query');
    return result.data.blockService_getDocumentReferenceBlocks;
};
const $59e004c7d849e8bb$var$COMMON_HEADERS = {
    'Content-Type': 'application/json',
    Accept: 'application/json'
};
const $59e004c7d849e8bb$var$GRAPHQL_ENDPOINT = '/gateway/api/graphql';
const $59e004c7d849e8bb$var$GET_DOCUMENT_REFERENCE_BLOCKS_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_GET_DOCUMENT_REFERENCE_BLOCKS';
const $59e004c7d849e8bb$var$UPDATE_BLOCK_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_UPDATE_BLOCK';
const $59e004c7d849e8bb$var$DELETE_BLOCK_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_DELETE_BLOCK';
const $59e004c7d849e8bb$var$CREATE_BLOCK_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_CREATE_BLOCK';
const $59e004c7d849e8bb$var$UPDATE_DOCUMENT_REFERENCES_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_UPDATE_DOCUMENT_REFERENCES';
const $59e004c7d849e8bb$var$BATCH_RETRIEVE_BLOCKS_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_BATCH_RETRIEVE_BLOCKS';
const $59e004c7d849e8bb$var$GET_BLOCK_REFERENCES_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_GET_REFERENCES';
const $59e004c7d849e8bb$var$GET_BLOCK_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_GET_BLOCK';
const $59e004c7d849e8bb$var$BATCH_UPDATE_BLOCKS_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_BATCH_UPDATE_BLOCKS';
const $59e004c7d849e8bb$var$buildGetDocumentReferenceBlocksQuery = (documentAri)=>`query ${$59e004c7d849e8bb$var$GET_DOCUMENT_REFERENCE_BLOCKS_OPERATION_NAME} {
	blockService_getDocumentReferenceBlocks(documentAri: ${JSON.stringify(documentAri)}) {
		blocks {
			blockAri
			blockInstanceId
			content
			contentUpdatedAt
			createdAt
			createdBy
			product
			sourceAri
			status
			version
		}
		errors {
			blockAri
			code
			reason
		}
	}
}`;
const $59e004c7d849e8bb$var$buildGetBlockQuery = (blockAri)=>`query ${$59e004c7d849e8bb$var$GET_BLOCK_OPERATION_NAME} {
	blockService_getBlock(blockAri: ${JSON.stringify(blockAri)}) {
		blockAri
		blockInstanceId
		content
		contentUpdatedAt
		createdAt
		createdBy
		deletionReason
		product
		sourceAri
		status
		version
	}
}`;
const $59e004c7d849e8bb$var$buildUpdateBlockMutation = (blockAri, content, stepVersion, status)=>{
    const inputParts = [
        `blockAri: ${JSON.stringify(blockAri)}`,
        `content: ${JSON.stringify(content)}`
    ];
    if (stepVersion !== undefined) inputParts.push(`stepVersion: ${stepVersion}`);
    if (status !== undefined) inputParts.push(`status: ${JSON.stringify(status)}`);
    const inputArgs = inputParts.join(', ');
    return `mutation ${$59e004c7d849e8bb$var$UPDATE_BLOCK_OPERATION_NAME} {
	blockService_updateBlock(input: { ${inputArgs} }) {
		__typename
	}
}`;
};
const $59e004c7d849e8bb$var$buildDeleteBlockMutation = (blockAri, deletionReason)=>{
    const inputParts = [
        `blockAri: ${JSON.stringify(blockAri)}`
    ];
    if (deletionReason !== undefined) inputParts.push(`deletionReason: ${JSON.stringify(deletionReason)}`);
    const inputArgs = inputParts.join(', ');
    return `mutation ${$59e004c7d849e8bb$var$DELETE_BLOCK_OPERATION_NAME} {
	blockService_deleteBlock(input: { ${inputArgs} }) {
		deleted
	}
}`;
};
/**
 * Converts product string to GraphQL enum format
 * 'confluence-page' -> 'CONFLUENCE_PAGE'
 * 'jira-work-item' -> 'JIRA_WORK_ITEM'
 */ const $59e004c7d849e8bb$var$convertProductToGraphQLEnum = (product)=>{
    switch(product){
        case 'confluence-page':
            return 'CONFLUENCE_PAGE';
        case 'jira-work-item':
            return 'JIRA_WORK_ITEM';
        default:
            {
                const exhaustiveCheck = product;
                throw new Error(`Unsupported product: ${exhaustiveCheck}`);
            }
    }
};
const $59e004c7d849e8bb$var$buildCreateBlockMutation = (blockAri, blockInstanceId, content, product, sourceAri, stepVersion, status)=>{
    const inputParts = [
        `blockAri: ${JSON.stringify(blockAri)}`,
        `blockInstanceId: ${JSON.stringify(blockInstanceId)}`,
        `content: ${JSON.stringify(content)}`,
        `product: ${$59e004c7d849e8bb$var$convertProductToGraphQLEnum(product)}`,
        `sourceAri: ${JSON.stringify(sourceAri)}`
    ];
    if (stepVersion !== undefined) inputParts.push(`stepVersion: ${stepVersion}`);
    if (status !== undefined) inputParts.push(`status: ${JSON.stringify(status)}`);
    const inputArgs = inputParts.join(', ');
    return `mutation ${$59e004c7d849e8bb$var$CREATE_BLOCK_OPERATION_NAME} {
	blockService_createBlock(input: { ${inputArgs} }) {
		blockAri
		blockInstanceId
		content
		contentUpdatedAt
		createdAt
		createdBy
		deletionReason
		product
		sourceAri
		status
		version
	}
}`;
};
const $59e004c7d849e8bb$var$buildUpdateDocumentReferencesMutation = (documentAri, blocks, noContent)=>{
    const blocksArray = blocks.map((block)=>`{ blockAri: ${JSON.stringify(block.blockAri)}, blockInstanceId: ${JSON.stringify(block.blockInstanceId)} }`).join(', ');
    const inputArgs = `documentAri: ${JSON.stringify(documentAri)}, blocks: [${blocksArray}], noContent: ${noContent}`;
    return `mutation ${$59e004c7d849e8bb$var$UPDATE_DOCUMENT_REFERENCES_OPERATION_NAME} {
	blockService_updateDocumentReferences(input: { ${inputArgs} }) {
		blocks {
			blockAri
			blockInstanceId
			content
			contentUpdatedAt
			createdAt
			createdBy
			product
			sourceAri
			status
			version
		}
		errors {
			blockAri
			code
			reason
		}
	}
}`;
};
const $59e004c7d849e8bb$var$buildBatchRetrieveBlocksQuery = (blockAris)=>{
    const blockArisArray = blockAris.map((ari)=>JSON.stringify(ari)).join(', ');
    const inputArgs = `blockAris: [${blockArisArray}]`;
    return `query ${$59e004c7d849e8bb$var$BATCH_RETRIEVE_BLOCKS_OPERATION_NAME} {
	blockService_batchRetrieveBlocks(input: { ${inputArgs} }) {
		success {
			blockAri
			blockInstanceId
			content
			contentUpdatedAt
			createdAt
			createdBy
			deletionReason
			product
			sourceAri
			status
			version
		}
		error {
			blockAri
			code
			reason
		}
	}
}`;
};
const $59e004c7d849e8bb$var$buildGetBlockReferencesQuery = (blockAri)=>{
    return `query ${$59e004c7d849e8bb$var$GET_BLOCK_REFERENCES_OPERATION_NAME} {
	blockService_getReferences(blockAri: ${JSON.stringify(blockAri)}) {
		references {
			blockAri
			blockInstanceId
			createdAt
			createdBy
			documentAri
		}
		errors {
			blockAri
			code${(0, $4o0zT.isExperimentEnabled)('platform_editor_blocks_patch_11') ? '\n\t\t\tdocumentAri' : ''}
			reason
		}
	}
}`;
};
const $59e004c7d849e8bb$var$buildBatchUpdateBlocksMutation = (blocks)=>{
    const blocksArray = blocks.map((block)=>{
        const inputParts = [
            `blockAri: ${JSON.stringify(block.blockAri)}`,
            `content: ${JSON.stringify(block.content)}`
        ];
        if (block.stepVersion !== undefined) inputParts.push(`stepVersion: ${block.stepVersion}`);
        if (block.status !== undefined) inputParts.push(`status: ${JSON.stringify(block.status)}`);
        return `{ ${inputParts.join(', ')} }`;
    }).join(', ');
    return `mutation ${$59e004c7d849e8bb$var$BATCH_UPDATE_BLOCKS_OPERATION_NAME} {
	blockService_batchUpdateBlocks(input: { blocks: [${blocksArray}] }) {
		success {
			blockAri
			blockInstanceId
			content
			contentUpdatedAt
			createdAt
			createdBy
			deletionReason
			product
			sourceAri
			status
			version
		}
		error {
			blockAri
			code
			reason
		}
	}
}`;
};
class $59e004c7d849e8bb$export$e47a0a94b0998697 extends Error {
    constructor(status){
        super(`Block error`), this.status = status;
    }
}
class $59e004c7d849e8bb$export$f5a00468af285e38 extends Error {
    constructor(){
        super('Block not found in Block Service');
        this.name = 'BlockNotFoundError';
    }
}
class $59e004c7d849e8bb$export$b5687000eb0902be extends Error {
    constructor(){
        super('Block request timed out');
        this.name = 'BlockTimeoutError';
    }
}
const $59e004c7d849e8bb$export$fab66d51cc0c1a7 = async ({ blockAri: blockAri })=>{
    const bodyData = {
        query: $59e004c7d849e8bb$var$buildGetBlockQuery(blockAri),
        operationName: $59e004c7d849e8bb$var$GET_BLOCK_OPERATION_NAME
    };
    const url = `${$59e004c7d849e8bb$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockGetBlock`;
    const response = await (0, $48FpT.fetchWithRetry)(url, {
        method: 'POST',
        headers: $59e004c7d849e8bb$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $59e004c7d849e8bb$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!result.data?.blockService_getBlock) throw new Error('No data returned from GraphQL query');
    return result.data.blockService_getBlock;
};
const $59e004c7d849e8bb$export$48a4f565308f4741 = async ({ blockIdentifiers: blockIdentifiers, config: config })=>{
    const blockAris = blockIdentifiers.map((blockIdentifier)=>blockIdentifier.blockAri);
    const bodyData = {
        query: $59e004c7d849e8bb$var$buildBatchRetrieveBlocksQuery(blockAris),
        operationName: $59e004c7d849e8bb$var$BATCH_RETRIEVE_BLOCKS_OPERATION_NAME
    };
    const url = `${$59e004c7d849e8bb$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockBatchRetrieveBlocks`;
    // undefined or 0 or negative means no timeout,
    // We don't enforce a minimum timeout for simplicity
    const fetchPromise = (0, $48FpT.fetchWithRetry)(url, {
        method: 'POST',
        headers: $59e004c7d849e8bb$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    const timeoutMs = config?.timeoutMs ?? 0;
    const response = await (timeoutMs > 0 ? Promise.race([
        fetchPromise,
        new Promise((_, reject)=>setTimeout(()=>reject(new $59e004c7d849e8bb$export$b5687000eb0902be()), timeoutMs))
    ]) : fetchPromise);
    if (!response.ok) throw new $59e004c7d849e8bb$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!result.data?.blockService_batchRetrieveBlocks) throw new Error('No data returned from GraphQL query');
    const graphqlResponse = result.data.blockService_batchRetrieveBlocks;
    return {
        success: graphqlResponse.success,
        error: graphqlResponse.error
    };
};
const $59e004c7d849e8bb$export$cbbc86409cac3ee5 = async ({ blockAri: blockAri, deleteReason: deleteReason })=>{
    const bodyData = {
        query: $59e004c7d849e8bb$var$buildDeleteBlockMutation(blockAri, deleteReason),
        operationName: $59e004c7d849e8bb$var$DELETE_BLOCK_OPERATION_NAME
    };
    const url = `${$59e004c7d849e8bb$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockDeleteBlock`;
    const response = await (0, $48FpT.fetchWithRetry)(url, {
        method: 'POST',
        headers: $59e004c7d849e8bb$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $59e004c7d849e8bb$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) {
        const allNotFound = result.errors.every((e)=>e.extensions?.errorType === 'RESOURCE_NOT_FOUND');
        if (allNotFound) // Throw BlockNotFoundError so the caller can create the block first then retry the delete.
        // Block Service uses soft-deletes: the entry must exist before deletion so a deletion-reason
        // is stored (used to display errors in reference blocks).
        throw new $59e004c7d849e8bb$export$f5a00468af285e38();
        throw new Error(result.errors.map((e)=>e.message).join(', '));
    }
    const isDeleted = result.data?.blockService_deleteBlock?.deleted;
    if (!isDeleted) throw new Error('Block deletion failed; deleted flag is false');
};
const $59e004c7d849e8bb$export$d5bf0c5618431e5e = async ({ blockAri: blockAri, content: content, stepVersion: stepVersion, status: status })=>{
    const bodyData = {
        query: $59e004c7d849e8bb$var$buildUpdateBlockMutation(blockAri, content, stepVersion, status),
        operationName: $59e004c7d849e8bb$var$UPDATE_BLOCK_OPERATION_NAME
    };
    const url = `${$59e004c7d849e8bb$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockUpdateBlock`;
    const response = await (0, $48FpT.fetchWithRetry)(url, {
        method: 'POST',
        headers: $59e004c7d849e8bb$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $59e004c7d849e8bb$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
};
const $59e004c7d849e8bb$export$fbc30658d812c800 = async ({ blockAri: blockAri, blockInstanceId: blockInstanceId, sourceAri: sourceAri, product: product, content: content, stepVersion: stepVersion, status: status })=>{
    const bodyData = {
        query: $59e004c7d849e8bb$var$buildCreateBlockMutation(blockAri, blockInstanceId, content, product, sourceAri, stepVersion, status),
        operationName: $59e004c7d849e8bb$var$CREATE_BLOCK_OPERATION_NAME
    };
    const url = `${$59e004c7d849e8bb$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockCreateBlock`;
    const response = await (0, $48FpT.fetchWithRetry)(url, {
        method: 'POST',
        headers: $59e004c7d849e8bb$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $59e004c7d849e8bb$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!result.data?.blockService_createBlock) throw new Error('No data returned from GraphQL mutation');
    return result.data.blockService_createBlock;
};
const $59e004c7d849e8bb$export$59c7369fa04bcba1 = async ({ documentAri: documentAri, blocks: blocks, noContent: noContent = true })=>{
    const bodyData = {
        query: $59e004c7d849e8bb$var$buildUpdateDocumentReferencesMutation(documentAri, blocks, noContent),
        operationName: $59e004c7d849e8bb$var$UPDATE_DOCUMENT_REFERENCES_OPERATION_NAME
    };
    const url = `${$59e004c7d849e8bb$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockUpdateDocumentReferences`;
    const response = await (0, $48FpT.fetchWithRetry)(url, {
        method: 'POST',
        headers: $59e004c7d849e8bb$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData),
        keepalive: true
    });
    if (!response.ok) throw new $59e004c7d849e8bb$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!noContent) {
        if (!result.data?.blockService_updateDocumentReferences) throw new Error('No data returned from GraphQL mutation');
        return result.data.blockService_updateDocumentReferences;
    }
};
const $59e004c7d849e8bb$export$75f5aeff9ce22a33 = async ({ blockAri: blockAri })=>{
    const bodyData = {
        query: $59e004c7d849e8bb$var$buildGetBlockReferencesQuery(blockAri),
        operationName: $59e004c7d849e8bb$var$GET_BLOCK_REFERENCES_OPERATION_NAME
    };
    const url = `${$59e004c7d849e8bb$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockGetReferences`;
    const response = await (0, $48FpT.fetchWithRetry)(url, {
        method: 'POST',
        headers: $59e004c7d849e8bb$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $59e004c7d849e8bb$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!result.data?.blockService_getReferences) throw new Error('No data returned from GraphQL query');
    const graphqlResponse = result.data.blockService_getReferences;
    return {
        blockAri: blockAri,
        references: graphqlResponse.references || [],
        errors: graphqlResponse.errors || []
    };
};
const $59e004c7d849e8bb$export$a9e53fa4329b5ed2 = async ({ blocks: blocks })=>{
    const bodyData = {
        query: $59e004c7d849e8bb$var$buildBatchUpdateBlocksMutation(blocks),
        operationName: $59e004c7d849e8bb$var$BATCH_UPDATE_BLOCKS_OPERATION_NAME
    };
    const url = `${$59e004c7d849e8bb$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockBatchUpdateBlocks`;
    const response = await (0, $48FpT.fetchWithRetry)(url, {
        method: 'POST',
        headers: $59e004c7d849e8bb$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $59e004c7d849e8bb$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!result.data?.blockService_batchUpdateBlocks) throw new Error('No data returned from GraphQL mutation');
    const graphqlResponse = result.data.blockService_batchUpdateBlocks;
    return {
        success: graphqlResponse.success,
        error: graphqlResponse.error
    };
};
module.exports["getReferenceSyncedBlocks"] = $59e004c7d849e8bb$export$571f6abc3f4e5951;
module.exports["BlockError"] = $59e004c7d849e8bb$export$e47a0a94b0998697;
module.exports["BlockNotFoundError"] = $59e004c7d849e8bb$export$f5a00468af285e38;
module.exports["BlockTimeoutError"] = $59e004c7d849e8bb$export$b5687000eb0902be;
module.exports["getSyncedBlockContent"] = $59e004c7d849e8bb$export$fab66d51cc0c1a7;
module.exports["batchRetrieveSyncedBlocks"] = $59e004c7d849e8bb$export$48a4f565308f4741;
module.exports["deleteSyncedBlock"] = $59e004c7d849e8bb$export$cbbc86409cac3ee5;
module.exports["updateSyncedBlock"] = $59e004c7d849e8bb$export$d5bf0c5618431e5e;
module.exports["createSyncedBlock"] = $59e004c7d849e8bb$export$fbc30658d812c800;
module.exports["updateReferenceSyncedBlockOnDocument"] = $59e004c7d849e8bb$export$59c7369fa04bcba1;
module.exports["getReferenceSyncedBlocksByBlockAri"] = $59e004c7d849e8bb$export$75f5aeff9ce22a33;
module.exports["updateSyncedBlocks"] = $59e004c7d849e8bb$export$a9e53fa4329b5ed2;

});

parcelRegister("48FpT", function(module, exports) {
const $fc075454b76b2577$var$MAX_RETRY_DELAY = 30000;
const $fc075454b76b2577$var$parseRetryAfter = (retryAfter)=>{
    // retryAfter can either be in seconds or HTTP date
    const parsedRetryAfter = parseInt(retryAfter, 10);
    if (!isNaN(parsedRetryAfter) && parsedRetryAfter > 0) return parsedRetryAfter * 1000;
    const retryDate = new Date(retryAfter);
    if (isNaN(retryDate.getTime())) return undefined;
    const delayFromDate = retryDate.getTime() - Date.now();
    if (delayFromDate > 0) return delayFromDate;
    return undefined;
};
const $fc075454b76b2577$export$cffaac380b94df26 = async (url, options, retriesRemaining = 3, delay = 1000)=>{
    const response = await fetch(url, options);
    const shouldRetry = !response.ok && response.status === 429 && retriesRemaining > 1;
    if (!shouldRetry) return response;
    const retryAfter = response.headers.get('Retry-After');
    const parsedDelay = (retryAfter ? $fc075454b76b2577$var$parseRetryAfter(retryAfter) : undefined) ?? delay;
    const retryDelay = Math.min(parsedDelay, $fc075454b76b2577$var$MAX_RETRY_DELAY);
    await new Promise((resolve)=>setTimeout(resolve, retryDelay));
    return $fc075454b76b2577$export$cffaac380b94df26(url, options, retriesRemaining - 1, delay * 2);
};
module.exports["fetchWithRetry"] = $fc075454b76b2577$export$cffaac380b94df26;

});

parcelRegister("79ir6", function(module, exports) {
var $2ca041ce04439e9b$export$686dd843fdf311d4 = /*#__PURE__*/ function(SyncBlockError) {
    SyncBlockError["Errored"] = "errored";
    SyncBlockError["NotFound"] = "not_found";
    SyncBlockError["Forbidden"] = "forbidden";
    SyncBlockError["InvalidRequest"] = "invalid_request";
    SyncBlockError["RateLimited"] = "rate_limited";
    SyncBlockError["Conflict"] = "conflict";
    // attempt to create block that already exists
    SyncBlockError["ServerError"] = "server_error";
    SyncBlockError["InvalidContent"] = "invalid_content";
    // content is not a valid JSON
    SyncBlockError["Offline"] = "offline";
    SyncBlockError["Unpublished"] = "unpublished";
    // request was aborted, typically due to client timeout
    SyncBlockError["Aborted"] = "aborted";
    // block does not exist on this site (e.g. cross-site reference or hard deleted)
    SyncBlockError["EntityNotFound"] = "entity_not_found";
    return SyncBlockError;
}({});
const $2ca041ce04439e9b$export$7486a7adf8b0d591 = 'Data provider not set';
class $2ca041ce04439e9b$export$ca0858d4f5eeeac extends Error {
    constructor(message = $2ca041ce04439e9b$export$7486a7adf8b0d591){
        super(message);
        this.isProviderNotReadyError = true;
        this.name = 'ProviderNotReadyError';
        // Restore prototype chain so instanceof works after transpilation.
        Object.setPrototypeOf(this, $2ca041ce04439e9b$export$ca0858d4f5eeeac.prototype);
    }
}
const $2ca041ce04439e9b$export$7ba508051f94701f = (error)=>{
    if (error instanceof $2ca041ce04439e9b$export$ca0858d4f5eeeac) return true;
    if (typeof error === 'object' && error !== null && error.isProviderNotReadyError === true) return true;
    return error instanceof Error && error.message === $2ca041ce04439e9b$export$7486a7adf8b0d591;
};
module.exports["SyncBlockError"] = $2ca041ce04439e9b$export$686dd843fdf311d4;
module.exports["ProviderNotReadyError"] = $2ca041ce04439e9b$export$ca0858d4f5eeeac;
module.exports["isProviderNotReadyError"] = $2ca041ce04439e9b$export$7ba508051f94701f;

});

parcelRegister("916Gd", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $79ir6 = parcelRequire("79ir6");

const $5f570f8dd9ccb4e4$export$7fc2c997455452c8 = (error)=>{
    try {
        return JSON.stringify(error);
    } catch  {
        return undefined;
    }
};
const $5f570f8dd9ccb4e4$export$74ce7fda6da1109 = (error)=>{
    if (error instanceof Error) return {
        ...error.message && {
            originalMessage: error.message
        },
        ...error.name && {
            originalName: error.name
        }
    };
    return {};
};
const $5f570f8dd9ccb4e4$var$SYNC_BLOCK_ERROR_REASONS = new Set(Object.values((0, $79ir6.SyncBlockError)));
const $5f570f8dd9ccb4e4$export$3bf11deac13e0617 = (error)=>{
    if (error && $5f570f8dd9ccb4e4$var$SYNC_BLOCK_ERROR_REASONS.has(error)) return error;
    return 'unknown';
};
const $5f570f8dd9ccb4e4$export$78792f4ddc3998e8 = (error, statusCode)=>{
    return {
        reason: $5f570f8dd9ccb4e4$export$3bf11deac13e0617(error),
        ...statusCode !== undefined && {
            statusCode: statusCode
        }
    };
};
const $5f570f8dd9ccb4e4$export$9bd766f5cc31fe3b = new Set([
    'source_deleted',
    'source_unpublished',
    'source_unsynced',
    'source_not_found',
    'permission_denied',
    'unauthenticated',
    // Mirror the benign write-path enum equivalents so already-classified errors are
    // treated consistently.
    'not_found',
    'forbidden',
    'unpublished',
    // `offline` is an expected client connectivity state, not a read-path system failure:
    // the error component is rendered for the offline experience, so it should not inflate
    // the true error rate. It still emits `reason` (so its volume can be inspected) but is
    // excluded from true-error counts.
    'offline'
]);
/**
 * Ordered list of substring matchers mapping known free-text fetch/subscribe error
 * strings to a categorical {@link SyncBlockFetchErrorReason}. Each entry is a list of
 * lowercase needles; if ANY needle is found (case-insensitively) in the raw `error`
 * string, the entry's reason is used. Order matters: more specific entries must precede
 * more general ones.
 *
 * Plain `String.includes` substring matching is used deliberately instead of `RegExp`:
 * it sidesteps the `require-unicode-regexp` lint rule AND the declaration build's lower
 * compile target (which rejects the regex `u` flag with TS1501), while being faster and
 * easier to read. Doing this classification in code (rather than in dashboard SQL) keeps
 * the buckets versioned with the source strings that produce them (EDITOR-7862).
 */ const $5f570f8dd9ccb4e4$var$FETCH_REASON_MATCHERS = [
    // Benign: source-state transitions (deletionReason values + free text).
    [
        [
            'source-document-deleted'
        ],
        'source_deleted'
    ],
    [
        [
            'source-block-deleted'
        ],
        'source_deleted'
    ],
    [
        [
            'source-block-unpublished'
        ],
        'source_unpublished'
    ],
    [
        [
            'source-block-unsynced'
        ],
        'source_unsynced'
    ],
    [
        [
            'does not exist'
        ],
        'source_not_found'
    ],
    [
        [
            'unpublished'
        ],
        'source_unpublished'
    ],
    // Working-as-designed permission outcomes.
    [
        [
            'unauthenticated'
        ],
        'unauthenticated'
    ],
    [
        [
            'not permitted to read synced block'
        ],
        'permission_denied'
    ],
    [
        [
            'bulk permission check failed'
        ],
        'permission_denied'
    ],
    [
        [
            'permission denied'
        ],
        'permission_denied'
    ],
    // Genuine system failures.
    [
        [
            'reconnection failed after'
        ],
        'websocket_exhausted'
    ],
    // `reconnect to the subscription` (not a bare `reconnect`) avoids false positives on
    // unrelated DB/GraphQL "reconnect" messages while still matching the WS-drop string.
    [
        [
            'websocket',
            'reconnect to the subscription',
            'subscription terminated'
        ],
        'websocket_drop'
    ],
    [
        [
            '429',
            'rate limit',
            'rate-limit',
            'ratelimit'
        ],
        'rate_limited'
    ],
    // `econnrefused`/`econnreset` (not a bare `econn`, which would also match `reconnect`).
    [
        [
            'network',
            'failed to fetch',
            'econnrefused',
            'econnreset',
            'timed out',
            'timeout'
        ],
        'network'
    ],
    [
        [
            'data provider not set'
        ],
        'data_provider_not_ready'
    ]
];
const $5f570f8dd9ccb4e4$export$b7fb09a58aa76c55 = (error)=>{
    const enumReason = $5f570f8dd9ccb4e4$export$3bf11deac13e0617(error);
    if (enumReason !== 'unknown') return enumReason;
    if (error) {
        const haystack = error.toLowerCase();
        for (const [needles, reason] of $5f570f8dd9ccb4e4$var$FETCH_REASON_MATCHERS){
            if (needles.some((needle)=>haystack.includes(needle))) return reason;
        }
    }
    return 'unknown';
};
const $5f570f8dd9ccb4e4$export$4ae89cef01c11c46 = (error, statusCode, deferred)=>{
    const reason = $5f570f8dd9ccb4e4$export$b7fb09a58aa76c55(error);
    return {
        reason: reason,
        // A deferred (tab-hidden) exhaustion is benign regardless of reason bucket.
        benign: deferred === true || $5f570f8dd9ccb4e4$export$9bd766f5cc31fe3b.has(reason),
        ...statusCode !== undefined && {
            statusCode: statusCode
        },
        ...deferred === true && {
            deferred: true
        }
    };
};
function $5f570f8dd9ccb4e4$export$999ed1af1b20ac2d(actionSubjectId, error, resourceId, sourceProduct, attribution) {
    return {
        action: (0, $krYZG.ACTION).ERROR,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: actionSubjectId,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            error: error,
            ...resourceId && {
                resourceId: resourceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            },
            ...attribution?.reason && {
                reason: attribution.reason
            },
            ...attribution?.statusCode !== undefined && {
                statusCode: attribution.statusCode
            },
            // `benign` is only present on fetch/subscribe attribution (EDITOR-7862). It is a
            // boolean (never UGC); the `'benign' in attribution` check both guards the
            // write-path attribution (which has no `benign`) and narrows the union so
            // `attribution.benign` is accessible.
            ...attribution && 'benign' in attribution && {
                benign: attribution.benign
            },
            // `deferred` is only present on fetch/subscribe attribution, and only when a
            // tab-hidden exhaustion was deferred rather than surfaced. Boolean, never UGC.
            ...attribution && 'deferred' in attribution && attribution.deferred === true && {
                deferred: true
            }
        }
    };
}
const $5f570f8dd9ccb4e4$export$94dcd08406353dba = (error, resourceId, sourceProduct, attribution)=>// Branch on attribution presence so each call resolves to a concrete overload: with
    // attribution it hits the fetch overload (wider `reason`); without it, the
    // no-attribution overload. Both produce a fetch event regardless.
    attribution ? $5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_FETCH, error, resourceId, sourceProduct, attribution) : $5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_FETCH, error, resourceId, sourceProduct);
const $5f570f8dd9ccb4e4$export$c5131f589148b9d3 = (error, resourceId, sourceProduct)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_GET_SOURCE_INFO, error, resourceId, sourceProduct);
const $5f570f8dd9ccb4e4$export$adc2363832f8735d = (error, resourceId, sourceProduct, attribution)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_UPDATE, error, resourceId, sourceProduct, attribution);
const $5f570f8dd9ccb4e4$export$154595d209a77913 = (error, resourceId, sourceProduct, attribution)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).REFERENCE_SYNCED_BLOCK_UPDATE, error, resourceId, sourceProduct, attribution);
const $5f570f8dd9ccb4e4$export$5d2f0c264cf49280 = (error, resourceId, sourceProduct, attribution)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_CREATE, error, resourceId, sourceProduct, attribution);
const $5f570f8dd9ccb4e4$export$cd0aaab38ff32ec2 = (error, resourceId, sourceProduct, attribution)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_DELETE, error, resourceId, sourceProduct, attribution);
const $5f570f8dd9ccb4e4$export$e40ed1768baf5d1e = (error, resourceId, sourceProduct)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_UPDATE_CACHE, error, resourceId, sourceProduct);
const $5f570f8dd9ccb4e4$export$5665a31a69693485 = (resourceId, sourceProduct, context)=>({
        action: (0, $krYZG.ACTION).ERROR,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_SOURCE_INFO_ORPHANED,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            ...resourceId && {
                resourceId: resourceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            },
            ...context?.hasPendingDeletion !== undefined && {
                hasPendingDeletion: context.hasPendingDeletion
            },
            ...context?.hasSubscribers !== undefined && {
                hasSubscribers: context.hasSubscribers
            }
        }
    });
const $5f570f8dd9ccb4e4$export$82f9608c8438ecb2 = (rescheduleCount, resourceId, sourceProduct)=>({
        action: (0, $krYZG.ACTION).ERROR,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_CACHE_DELETION_FORCED,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            rescheduleCount: rescheduleCount,
            ...resourceId && {
                resourceId: resourceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            }
        }
    });
const $5f570f8dd9ccb4e4$export$ebf3ba305f3f0e1a = (error, resourceId, sourceProduct)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_FETCH_REFERENCES, error, resourceId, sourceProduct);
const $5f570f8dd9ccb4e4$export$b20c56c32ea6ad76 = (resourceId, blockInstanceId, sourceProduct)=>({
        action: (0, $krYZG.ACTION).FETCHED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_FETCH,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            blockInstanceId: blockInstanceId,
            ...sourceProduct && {
                sourceProduct: sourceProduct
            }
        }
    });
const $5f570f8dd9ccb4e4$export$5b8e0915870366d0 = (resourceId, sourceProduct)=>{
    return {
        action: (0, $krYZG.ACTION).INSERTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).BODIED_SYNCED_BLOCK,
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        attributes: {
            resourceId: resourceId,
            ...sourceProduct && {
                sourceProduct: sourceProduct
            }
        }
    };
};
const $5f570f8dd9ccb4e4$export$23e42fbf8039414c = (resourceId, blockInstanceId, sourceProduct, enrichment)=>({
        action: (0, $krYZG.ACTION).INSERTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_CREATE,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            ...blockInstanceId && {
                blockInstanceId: blockInstanceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            },
            ...enrichment?.inputMethod && {
                inputMethod: enrichment.inputMethod
            },
            ...enrichment?.createdEmpty !== undefined && {
                createdEmpty: enrichment.createdEmpty
            },
            ...enrichment?.nodeTypes?.length && {
                nodeTypes: enrichment.nodeTypes
            }
        }
    });
const $5f570f8dd9ccb4e4$export$c76f6dd50db89cda = (resourceId, blockInstanceId, sourceProduct)=>({
        action: (0, $krYZG.ACTION).ADDED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_ADD_CONTENT,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            ...blockInstanceId && {
                blockInstanceId: blockInstanceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            }
        }
    });
const $5f570f8dd9ccb4e4$export$f2b4214fae56af83 = (resourceId, hasReference, sourceProduct)=>({
        action: (0, $krYZG.ACTION).UPDATED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_UPDATE,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            ...hasReference !== undefined && {
                hasReference: hasReference
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            }
        }
    });
const $5f570f8dd9ccb4e4$export$2283f5d682476cde = (resourceId, sourceProduct, enrichment)=>({
        action: (0, $krYZG.ACTION).DELETED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_DELETE,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            ...sourceProduct && {
                sourceProduct: sourceProduct
            },
            ...enrichment?.blockInstanceId && {
                blockInstanceId: enrichment.blockInstanceId
            },
            ...enrichment?.deletionReason && {
                deletionReason: enrichment.deletionReason
            },
            ...enrichment?.mechanism && {
                mechanism: enrichment.mechanism
            }
        }
    });
module.exports["stringifyError"] = $5f570f8dd9ccb4e4$export$7fc2c997455452c8;
module.exports["getPiiSafeOriginalError"] = $5f570f8dd9ccb4e4$export$74ce7fda6da1109;
module.exports["buildErrorAttribution"] = $5f570f8dd9ccb4e4$export$78792f4ddc3998e8;
module.exports["buildFetchErrorAttribution"] = $5f570f8dd9ccb4e4$export$4ae89cef01c11c46;
module.exports["fetchErrorPayload"] = $5f570f8dd9ccb4e4$export$94dcd08406353dba;
module.exports["getSourceInfoErrorPayload"] = $5f570f8dd9ccb4e4$export$c5131f589148b9d3;
module.exports["updateErrorPayload"] = $5f570f8dd9ccb4e4$export$adc2363832f8735d;
module.exports["updateReferenceErrorPayload"] = $5f570f8dd9ccb4e4$export$154595d209a77913;
module.exports["createErrorPayload"] = $5f570f8dd9ccb4e4$export$5d2f0c264cf49280;
module.exports["deleteErrorPayload"] = $5f570f8dd9ccb4e4$export$cd0aaab38ff32ec2;
module.exports["updateCacheErrorPayload"] = $5f570f8dd9ccb4e4$export$e40ed1768baf5d1e;
module.exports["sourceInfoOrphanedPayload"] = $5f570f8dd9ccb4e4$export$5665a31a69693485;
module.exports["cacheDeletionForcedPayload"] = $5f570f8dd9ccb4e4$export$82f9608c8438ecb2;
module.exports["fetchReferencesErrorPayload"] = $5f570f8dd9ccb4e4$export$ebf3ba305f3f0e1a;
module.exports["fetchSuccessPayload"] = $5f570f8dd9ccb4e4$export$b20c56c32ea6ad76;
module.exports["createSuccessPayload"] = $5f570f8dd9ccb4e4$export$5b8e0915870366d0;
module.exports["createSuccessOperationalPayload"] = $5f570f8dd9ccb4e4$export$23e42fbf8039414c;
module.exports["addContentSuccessPayload"] = $5f570f8dd9ccb4e4$export$c76f6dd50db89cda;
module.exports["updateSuccessPayload"] = $5f570f8dd9ccb4e4$export$f2b4214fae56af83;
module.exports["deleteSuccessPayload"] = $5f570f8dd9ccb4e4$export$2283f5d682476cde;

});

parcelRegister("7GRSG", function(module, exports) {

var $4o0zT = parcelRequire("4o0zT");


var $3xsB6 = parcelRequire("3xsB6");

const $23c76758ad9684b4$export$63fea0488f1f3b79 = (productType)=>productType === 'jira-work-item' && (0, $4o0zT.isExperimentEnabled)('editor_synced_blocks_jira_custom_rich_text');
const $23c76758ad9684b4$export$6f2c88a8b48b006f = ({ documentAri: documentAri, hostAri: hostAri, productType: productType })=>hostAri !== undefined && $23c76758ad9684b4$export$63fea0488f1f3b79(productType) ? {
        locationScope: (0, $3xsB6.getLocationScope)({
            documentAri: documentAri,
            hostAri: hostAri
        })
    } : undefined;
module.exports["getFieldAwareLocationScope"] = $23c76758ad9684b4$export$6f2c88a8b48b006f;

});

parcelRegister("cuwGS", function(module, exports) {

var $kcJaM = parcelRequire("kcJaM");

const $dfc9aeca876e07dc$var$isSyncBlockProduct = (product)=>{
    return (0, $kcJaM.SYNC_BLOCK_PRODUCTS).includes(product);
};
const $dfc9aeca876e07dc$export$8aafdd7901afa57f = (resourceId)=>{
    if (!resourceId) return undefined;
    const [product, contentId, uuid, ...rest] = resourceId.split('/');
    // invalid if any part is missing or there are extra parts
    if (!product || !contentId || !uuid || rest.length > 0) return undefined;
    // invalid if product is not recognized
    if (!$dfc9aeca876e07dc$var$isSyncBlockProduct(product)) return undefined;
    return {
        product: product,
        contentId: contentId,
        uuid: uuid
    };
};
const $dfc9aeca876e07dc$export$cf5895b3b46faf63 = (product, contentId, uuid)=>{
    return `${product}/${contentId}/${uuid}`;
};
module.exports["parseResourceId"] = $dfc9aeca876e07dc$export$8aafdd7901afa57f;
module.exports["createResourceIdForReference"] = $dfc9aeca876e07dc$export$cf5895b3b46faf63;

});

parcelRegister("kcJaM", function(module, exports) {
const $d6e2f975e4365dc3$export$c05408ef703373ad = [
    'confluence-page',
    'jira-work-item'
];
module.exports["SYNC_BLOCK_PRODUCTS"] = $d6e2f975e4365dc3$export$c05408ef703373ad;

});

parcelRegister("d04Ge", function(module, exports) {
/* eslint-disable require-unicode-regexp  */ const $acebaa6737646e6e$var$GET_CONTENT_ID_AND_PRODUCT_REGEX = /^(confluence-page|jira-work-item)\/([^/]+)/;
const $acebaa6737646e6e$var$normalizeSyncBlockJSONContentInternal = (content, options)=>{
    let normalizedContent;
    content.forEach((contentNode, index)=>{
        if (!contentNode) {
            normalizedContent?.push(contentNode);
            return;
        }
        const hasAnnotationMark = contentNode.marks?.some((mark)=>mark.type === 'annotation');
        const shouldConvertPanelC1 = options.convertPanelC1ToPanel && contentNode.type === 'panel_c1';
        const childContent = contentNode.content ? $acebaa6737646e6e$var$normalizeSyncBlockJSONContentInternal(contentNode.content, options) : undefined;
        const hasContentChanged = childContent !== undefined && childContent !== contentNode.content;
        if (!hasAnnotationMark && !shouldConvertPanelC1 && !hasContentChanged) {
            normalizedContent?.push(contentNode);
            return;
        }
        if (!normalizedContent) normalizedContent = content.slice(0, index);
        const normalizedNode = {
            ...contentNode
        };
        if (shouldConvertPanelC1) normalizedNode.type = 'panel';
        if (hasAnnotationMark) {
            const marks = contentNode.marks?.filter((mark)=>mark.type !== 'annotation');
            if (marks && marks.length > 0) normalizedNode.marks = marks;
            else delete normalizedNode.marks;
        }
        if (hasContentChanged && childContent) normalizedNode.content = childContent;
        normalizedContent.push(normalizedNode);
    });
    return normalizedContent ?? content;
};
const $acebaa6737646e6e$export$19bb1d88f473b9c5 = (content)=>{
    return $acebaa6737646e6e$var$normalizeSyncBlockJSONContentInternal(content, {
        convertPanelC1ToPanel: false
    });
};
const $acebaa6737646e6e$export$b223a7607ed061dc = (content)=>{
    return $acebaa6737646e6e$var$normalizeSyncBlockJSONContentInternal(content, {
        convertPanelC1ToPanel: true
    });
};
const $acebaa6737646e6e$export$aafb32b192c8228c = (node)=>{
    const content = node.content.toJSON();
    return {
        blockInstanceId: node.attrs.localId,
        content: content ? $acebaa6737646e6e$export$b223a7607ed061dc(content) : content,
        resourceId: node.attrs.resourceId
    };
};
const $acebaa6737646e6e$export$c5b34fb9069ebb1d = (localId, resourceId)=>{
    return {
        type: 'syncBlock',
        attrs: {
            localId: localId,
            resourceId: resourceId
        }
    };
};
const $acebaa6737646e6e$export$cd9b0caaea319019 = (node)=>{
    if (node.type !== 'syncBlock' || !node.attrs || !('localId' in node.attrs) || !('resourceId' in node.attrs) || typeof node.attrs.localId !== 'string' || typeof node.attrs.resourceId !== 'string') return undefined;
    return $acebaa6737646e6e$export$c5b34fb9069ebb1d(node.attrs.localId, node.attrs.resourceId);
};
const $acebaa6737646e6e$export$648ff8dd259e0d9c = (node)=>{
    if (node.type.name !== 'syncBlock' || !node.attrs?.localId || !node.attrs?.resourceId || typeof node.attrs.localId !== 'string' || typeof node.attrs.resourceId !== 'string') return undefined;
    return $acebaa6737646e6e$export$c5b34fb9069ebb1d(node.attrs.localId, node.attrs.resourceId);
};
const $acebaa6737646e6e$export$18b85168a73dad03 = (nodes)=>{
    return nodes.map((node)=>$acebaa6737646e6e$export$648ff8dd259e0d9c(node)).filter((node)=>node !== undefined);
};
const $acebaa6737646e6e$export$2cf4a74c3e18f31a = (resourceId)=>{
    const match = resourceId.match($acebaa6737646e6e$var$GET_CONTENT_ID_AND_PRODUCT_REGEX);
    if (match?.[2]) return {
        sourceProduct: match[1],
        sourceContentId: match[2]
    };
    throw new Error(`Invalid resourceId: ${resourceId}`);
};
const $acebaa6737646e6e$export$31cbe0bed21e05b1 = (resourceId)=>{
    if (!resourceId) return undefined;
    try {
        return $acebaa6737646e6e$export$2cf4a74c3e18f31a(resourceId).sourceProduct;
    } catch  {
        return undefined;
    }
};
const $acebaa6737646e6e$export$4c6687d128f55da5 = (contentUpdatedAt)=>{
    if (typeof contentUpdatedAt === 'number') try {
        return new Date(contentUpdatedAt).toISOString();
    } catch  {
        return undefined;
    }
    return undefined;
};
module.exports["normalizeSyncBlockJSONContent"] = $acebaa6737646e6e$export$b223a7607ed061dc;
module.exports["convertSyncBlockPMNodeToSyncBlockData"] = $acebaa6737646e6e$export$aafb32b192c8228c;
module.exports["createSyncBlockNode"] = $acebaa6737646e6e$export$c5b34fb9069ebb1d;
module.exports["convertSyncBlockJSONNodeToSyncBlockNode"] = $acebaa6737646e6e$export$cd9b0caaea319019;
module.exports["convertPMNodesToSyncBlockNodes"] = $acebaa6737646e6e$export$18b85168a73dad03;
module.exports["getContentIdAndProductFromResourceId"] = $acebaa6737646e6e$export$2cf4a74c3e18f31a;
module.exports["getSourceProductFromResourceIdSafe"] = $acebaa6737646e6e$export$31cbe0bed21e05b1;
module.exports["convertContentUpdatedAt"] = $acebaa6737646e6e$export$4c6687d128f55da5;

});

parcelRegister("hteGz", function(module, exports) {

let $cb808955b5de3615$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $cb808955b5de3615$var$load("h0X0x"),
    $cb808955b5de3615$var$load("7l4Nc"),
    $cb808955b5de3615$var$load("cp9QV")
]).then(()=>parcelRequire('kRm6Y'));

});

parcelRegister("6oMcp", function(module, exports) {
/* eslint-disable require-unicode-regexp  */ const $0dfedb71521ac678$var$CONFLUENCE_PAGE_ARI_REGEX = /ari:cloud:confluence:[^:]+:(page|blogpost)\/(\d+)/;
const $0dfedb71521ac678$export$3c54cf45dfed84ea = ({ pageId: pageId, cloudId: cloudId, pageType: pageType })=>{
    return `ari:cloud:confluence:${cloudId}:${pageType}/${pageId}`;
};
const $0dfedb71521ac678$export$2ee4e689bde04de2 = ({ ari: ari })=>{
    const match = ari.match($0dfedb71521ac678$var$CONFLUENCE_PAGE_ARI_REGEX);
    if (match?.[2]) return {
        type: match[1],
        id: match[2]
    };
    throw new Error(`Invalid page ARI: ${ari}`);
};
module.exports["getConfluencePageAri"] = $0dfedb71521ac678$export$3c54cf45dfed84ea;
module.exports["getPageIdAndTypeFromConfluencePageAri"] = $0dfedb71521ac678$export$2ee4e689bde04de2;

});

parcelRegister("gb05o", function(module, exports) {
/**
 * Error codes for synced blocks preloading
 * Used for tracking and monitoring errors during SSR preload phase
 */ const $dcd4a25c1def153c$export$f10410d219e3ec29 = {
    /**
   * Occurs when the fetch operation returns fewer results than requested.
   * This indicates incomplete data retrieval or potential data loss.
   * Included in error: list of missing block identifiers
   */ FETCH_INCOMPLETE: 'SYNCED_BLOCKS_FETCH_INCOMPLETE',
    /**
   * Occurs when the batch fetch operation throws an error during execution.
   * This indicates a network error, timeout, or API failure.
   * Included in error: resource IDs that failed to fetch
   */ BATCH_FETCH_FAILED: 'SYNCED_BLOCKS_BATCH_FETCH_FAILED',
    /**
   * Occurs when the fetch operation times out without returning results.
   * This is specific to the bulk fetch operation with a configurable timeout.
   */ FETCH_TIMEOUT: 'SYNCED_BLOCKS_FETCH_TIMEOUT'
};
module.exports["SyncedBlocksSSRErrorCodeMap"] = $dcd4a25c1def153c$export$f10410d219e3ec29;

});

parcelRegister("8wyJO", function(module, exports) {

var $ibGN4 = parcelRequire("ibGN4");


var $3V1KT = parcelRequire("3V1KT");

const $01eec1a417789222$export$17ab88ef0193bb4 = (data)=>{
    if (!data) return data;
    if ($01eec1a417789222$var$isConfluenceContentReactions(data)) return data?.confluence_contentReactionsSummary?.contentReactionsSummary?.[0];
    if ($01eec1a417789222$var$isContentReactions(data)) return data?.content?.nodes?.[0]?.contentReactionsSummary;
    if ($01eec1a417789222$var$isCommentReactions(data)) return data?.comments?.nodes?.[0]?.reactionsSummary;
};
const $01eec1a417789222$var$isConfluenceContentReactions = (data)=>Boolean(data.confluence_contentReactionsSummary);
const $01eec1a417789222$var$isContentReactions = (data)=>Boolean(data.content);
const $01eec1a417789222$var$isCommentReactions = (data)=>Boolean(data.comments);
const $01eec1a417789222$var$getReactionsContentQuery = ()=>{
    return 0, $3V1KT.ReactionsContentQuery;
};
const $01eec1a417789222$export$d765e1092b1f36ff = (isComment, contentId, containerId)=>{
    const query = isComment ? (0, $ibGN4.ReactionsCommentsQuery) : $01eec1a417789222$var$getReactionsContentQuery();
    const queryVariables = isComment ? {
        contentId: contentId,
        containerId: containerId
    } : {
        contentId: contentId
    };
    return {
        query: query,
        queryVariables: queryVariables
    };
};
module.exports["getReactionsSummary"] = $01eec1a417789222$export$17ab88ef0193bb4;
module.exports["getReactionsQueryInfo"] = $01eec1a417789222$export$d765e1092b1f36ff;

});

parcelRegister("ibGN4", function(module, exports) {

var $bcPqk = parcelRequire("bcPqk");


var $hMpSP = parcelRequire("hMpSP");

const $0c4d3fd1a40dc0de$export$ea32e9ef3caf8ce7 = (0, $hMpSP.default);
const $0c4d3fd1a40dc0de$export$c0002d0cc70e364a = (0, $bcPqk.default);
module.exports["ReactionsCommentsQuery"] = $0c4d3fd1a40dc0de$export$c0002d0cc70e364a;

});

parcelRegister("bcPqk", function(module, exports) {
/**
 * @generated SignedSource<<d1f71583f1da07d7d25964da546e340a>>
 * @relayHash cbefab13307a82cf7144a0c0749ceeba
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 856749e0bcac9514035b3ed1c7488b61824433724d4eda1d05cbcff973b7dcce
const $6247a0815b189874$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "containerId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "commentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "contentStatus",
                    "value": [
                        "DRAFT",
                        "CURRENT"
                    ]
                }
            ],
            "concreteType": "PaginatedCommentList",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "childType",
                                    "value": "comment"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "contentType",
                                    "value": "page"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "pageId",
                                    "variableName": "containerId"
                                }
                            ],
                            "concreteType": "ReactionsSummaryResponse",
                            "kind": "LinkedField",
                            "name": "reactionsSummary",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "reactionsCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "ari"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "containerAri"
                                },
                                {
                                    "concreteType": "ReactionsSummaryForEmoji",
                                    "kind": "LinkedField",
                                    "name": "reactionsSummaryForEmoji",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "emojiId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "count"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "reacted"
                                        },
                                        v2 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ReactionsCommentsQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ReactionsCommentsQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "cbefab13307a82cf7144a0c0749ceeba",
            "id": "856749e0bcac9514035b3ed1c7488b61824433724d4eda1d05cbcff973b7dcce",
            "metadata": {},
            "name": "ReactionsCommentsQuery",
            "operationKind": "query",
            "text": "query ReactionsCommentsQuery($contentId:ID!,$containerId:ID!){comments(commentId:$contentId,contentStatus:[DRAFT,CURRENT]){nodes{id,reactionsSummary(pageId:$containerId,contentType:\"page\",childType:\"comment\"){reactionsCount,ari,containerAri,reactionsSummaryForEmoji{emojiId,count,reacted,id}}}}}"
        }
    };
}();
$6247a0815b189874$var$node.hash = "44a0a66242011ccb75c569988c203697";
var $6247a0815b189874$export$2e2bcd8739ae039 = $6247a0815b189874$var$node;
module.exports["default"] = $6247a0815b189874$export$2e2bcd8739ae039;

});

parcelRegister("hMpSP", function(module, exports) {
/**
 * @generated SignedSource<<eb7ea3f49a5750a597b7cccc9d474194>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $31e432aaf867a396$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "containerId"
            }
        ],
        "kind": "Fragment",
        "name": "ReactionsCommentsQuery_comment",
        "selections": [
            v0 /*: any*/ ,
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "childType",
                        "value": "comment"
                    },
                    {
                        "kind": "Literal",
                        "name": "contentType",
                        "value": "page"
                    },
                    {
                        "kind": "Variable",
                        "name": "pageId",
                        "variableName": "containerId"
                    }
                ],
                "concreteType": "ReactionsSummaryResponse",
                "kind": "LinkedField",
                "name": "reactionsSummary",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "reactionsCount"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "ari"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "containerAri"
                    },
                    {
                        "concreteType": "ReactionsSummaryForEmoji",
                        "kind": "LinkedField",
                        "name": "reactionsSummaryForEmoji",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "emojiId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "count"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "reacted"
                            },
                            v0 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "type": "Comment"
    };
}();
$31e432aaf867a396$var$node.hash = "af213ff403659043868c02fbd688a22c";
var $31e432aaf867a396$export$2e2bcd8739ae039 = $31e432aaf867a396$var$node;
module.exports["default"] = $31e432aaf867a396$export$2e2bcd8739ae039;

});

parcelRegister("3V1KT", function(module, exports) {

var $71jDq = parcelRequire("71jDq");

const $bb6fcff23ee99252$export$d1ed7f06ad741aec = (0, $71jDq.default);
module.exports["ReactionsContentQuery"] = $bb6fcff23ee99252$export$d1ed7f06ad741aec;

});

parcelRegister("71jDq", function(module, exports) {
/**
 * @generated SignedSource<<4ace922d92a4d91954ed2877f69143ae>>
 * @relayHash f5d80e75401b9c7d3d224f964fef6438
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1233c9b22c359c5d8cbed7e4b61033fe5b764797cdcb71dc0673a7aa5eed93f4
const $380a75471f8fd0e5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "concreteType": "ReactionsSummaryResponse",
                            "kind": "LinkedField",
                            "name": "contentReactionsSummary",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "reactionsCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "ari"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "containerAri"
                                },
                                {
                                    "concreteType": "ReactionsSummaryForEmoji",
                                    "kind": "LinkedField",
                                    "name": "reactionsSummaryForEmoji",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "emojiId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "count"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "reacted"
                                        },
                                        v1 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ReactionsContentQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ReactionsContentQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "f5d80e75401b9c7d3d224f964fef6438",
            "id": "1233c9b22c359c5d8cbed7e4b61033fe5b764797cdcb71dc0673a7aa5eed93f4",
            "metadata": {},
            "name": "ReactionsContentQuery",
            "operationKind": "query",
            "text": "query ReactionsContentQuery($contentId:ID!){content(id:$contentId){nodes{id,contentReactionsSummary{reactionsCount,ari,containerAri,reactionsSummaryForEmoji{emojiId,count,reacted,id}}}}}"
        }
    };
}();
$380a75471f8fd0e5$var$node.hash = "324529dfd12ad8cfc9429a4857981e84";
var $380a75471f8fd0e5$export$2e2bcd8739ae039 = $380a75471f8fd0e5$var$node;
module.exports["default"] = $380a75471f8fd0e5$export$2e2bcd8739ae039;

});

parcelRegister("9inwL", function(module, exports) {
/**
 * @generated SignedSource<<f8edd74a2bf0cef86303775c92f6818c>>
 * @relayHash f92419f4eae7659107884daf44afe353
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c5083034f862ac3ea960cfc4592f08715470b77981a4653cdbbd9dc1f12df8a1
const $5791e6e7c338c837$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "missingSpaceKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "alias"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "condition": "missingSpaceKey",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "key",
                            "variableName": "spaceKey"
                        }
                    ],
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentPrerequisitesQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentPrerequisitesQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "f92419f4eae7659107884daf44afe353",
            "id": "c5083034f862ac3ea960cfc4592f08715470b77981a4653cdbbd9dc1f12df8a1",
            "metadata": {},
            "name": "ContentPrerequisitesQuery",
            "operationKind": "query",
            "text": "query ContentPrerequisitesQuery($contentId:ID!,$missingSpaceKey:Boolean=false,$spaceKey:String,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,space{id,key,alias}}},space(key:$spaceKey)@skip(if:$missingSpaceKey){id,name}}"
        }
    };
}();
$5791e6e7c338c837$var$node.hash = "96ae26a7fa99861b8e368c368e56f6cc";
var $5791e6e7c338c837$export$2e2bcd8739ae039 = $5791e6e7c338c837$var$node;
module.exports["default"] = $5791e6e7c338c837$export$2e2bcd8739ae039;

});

parcelRegister("4uNpa", function(module, exports) {
/**
 * @generated SignedSource<<d7fe2a7a66643bd9c72401c8da9b795f>>
 * @relayHash 81e3b75d8ec7e8341dfb9fe5d7c36fac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9df42f2f20f0917766b188fd5cf2b943f7c14748bf3e7fc1c3a1ae1f61a77911
const $2411ee21620b66c4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "versionOverride"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "version",
                    "variableName": "versionOverride"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "homepageId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "alias"
                                }
                            ]
                        },
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "createdDate"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentRedirectQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentRedirectQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "81e3b75d8ec7e8341dfb9fe5d7c36fac",
            "id": "9df42f2f20f0917766b188fd5cf2b943f7c14748bf3e7fc1c3a1ae1f61a77911",
            "metadata": {},
            "name": "ContentRedirectQuery",
            "operationKind": "query",
            "text": "query ContentRedirectQuery($contentId:ID,$versionOverride:Int){content(id:$contentId,version:$versionOverride){nodes{id,title,space{id,homepageId,key,alias},history{createdDate}}}}"
        }
    };
}();
$2411ee21620b66c4$var$node.hash = "440c7fc38cc16d750fa69bd87e3ba7c2";
var $2411ee21620b66c4$export$2e2bcd8739ae039 = $2411ee21620b66c4$var$node;
module.exports["default"] = $2411ee21620b66c4$export$2e2bcd8739ae039;

});

parcelRegister("2HQyh", function(module, exports) {
/**
 * @generated SignedSource<<3ccde3616734a111f53da6e5e1f8991e>>
 * @relayHash ab13c035f40ba0298bd82a325ff2c401
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e58f63c20fdf70f91a40059b6e32935f05ca4978a7c84ffed3e0dfca58f47c41
const $5b8dbd4fd00aa380$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "exp"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "key"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "keyString"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "type"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "args": [
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "keyString"
            }
        ],
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v5 /*: any*/ 
        ]
    }, v7 = [
        {
            "kind": "Variable",
            "name": "entityId",
            "variableName": "id"
        },
        {
            "kind": "Variable",
            "name": "entityType",
            "variableName": "type"
        },
        {
            "kind": "Variable",
            "name": "experience",
            "variableName": "exp"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "title"
    }, v9 = {
        "kind": "ScalarField",
        "name": "type"
    }, v10 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v11 = {
        "kind": "ScalarField",
        "name": "creatorId"
    }, v12 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v13 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v14 = {
        "kind": "ScalarField",
        "name": "key"
    }, v15 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            v14 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            }
        ]
    }, v16 = {
        "alias": "emoji",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "emoji-title-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    v14 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ]
            }
        ],
        "storageKey": "properties(key:\"emoji-title-published\")"
    }, v17 = {
        "kind": "ScalarField",
        "name": "strategy"
    }, v18 = {
        "args": [
            {
                "kind": "Variable",
                "name": "entityId",
                "variableName": "key"
            }
        ],
        "concreteType": "RecommendedPagesSpaceStatus",
        "kind": "LinkedField",
        "name": "getRecommendedPagesSpaceStatus",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "recommendedPagesEnabled"
            },
            {
                "kind": "ScalarField",
                "name": "defaultBehavior"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "EndOfPageRecommendationQuery",
            "selections": [
                v6 /*: any*/ ,
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "RecommendedPages",
                    "kind": "LinkedField",
                    "name": "getRecommendedPages",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "RecommendedPagesItem",
                            "kind": "LinkedField",
                            "name": "recommendedPages",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v13 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v15 /*: any*/ ,
                                        v16 /*: any*/ 
                                    ]
                                },
                                v17 /*: any*/ 
                            ]
                        }
                    ]
                },
                v18 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v4 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "EndOfPageRecommendationQuery",
            "selections": [
                v6 /*: any*/ ,
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "RecommendedPages",
                    "kind": "LinkedField",
                    "name": "getRecommendedPages",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "RecommendedPagesItem",
                            "kind": "LinkedField",
                            "name": "recommendedPages",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        v13 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v15 /*: any*/ ,
                                        v16 /*: any*/ 
                                    ]
                                },
                                v17 /*: any*/ 
                            ]
                        }
                    ]
                },
                v18 /*: any*/ 
            ]
        },
        "params": {
            "cacheID": "ab13c035f40ba0298bd82a325ff2c401",
            "id": "e58f63c20fdf70f91a40059b6e32935f05ca4978a7c84ffed3e0dfca58f47c41",
            "metadata": {},
            "name": "EndOfPageRecommendationQuery",
            "operationKind": "query",
            "text": "query EndOfPageRecommendationQuery($type:String!,$id:ID!,$exp:String!,$key:ID!,$keyString:String!){space(key:$keyString){id},getRecommendedPages(entityType:$type,entityId:$id,experience:$exp){recommendedPages{content{id,title,type,subType,creatorId,links{webui},history{ownedBy{__typename,displayName}},space{id,key,name},emoji:properties(key:\"emoji-title-published\"){nodes{id,key,value}}},strategy}},getRecommendedPagesSpaceStatus(entityId:$key){recommendedPagesEnabled,defaultBehavior}}"
        }
    };
}();
$5b8dbd4fd00aa380$var$node.hash = "e939560761a450cc2ece30ee9466334e";
var $5b8dbd4fd00aa380$export$2e2bcd8739ae039 = $5b8dbd4fd00aa380$var$node;
module.exports["default"] = $5b8dbd4fd00aa380$export$2e2bcd8739ae039;

});

parcelRegister("2rapj", function(module, exports) {
/**
 * @generated SignedSource<<ecf2ccf6da6891e95b8c24bfee1ef6f6>>
 * @relayHash c4c4095c882cb71b80fdf7c511e33e69
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e1d623029b3f50e0253d05074cea0ec94b1f823ad4c4b61177f50d160b5886b2
const $029fef3d04f7e0c0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cypherQuery"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "key"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "keyString"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = {
        "args": [
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "keyString"
            }
        ],
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": v2 /*: any*/ 
    }, v4 = {
        "args": [
            {
                "kind": "Variable",
                "name": "entityId",
                "variableName": "key"
            }
        ],
        "concreteType": "RecommendedPagesSpaceStatus",
        "kind": "LinkedField",
        "name": "getRecommendedPagesSpaceStatus",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "recommendedPagesEnabled"
            },
            {
                "kind": "ScalarField",
                "name": "defaultBehavior"
            }
        ]
    }, v5 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "cypherQuery"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "key"
    }, v7 = {
        "kind": "ScalarField",
        "name": "pageId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "title"
    }, v9 = {
        "kind": "ScalarField",
        "name": "type"
    }, v10 = {
        "kind": "ScalarField",
        "name": "subtype"
    }, v11 = {
        "alias": "pageStatus",
        "kind": "ScalarField",
        "name": "status"
    }, v12 = [
        {
            "kind": "ScalarField",
            "name": "webUi"
        }
    ], v13 = {
        "concreteType": "ConfluencePageLinks",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v12 /*: any*/ 
    }, v14 = {
        "kind": "ScalarField",
        "name": "name"
    }, v15 = {
        "concreteType": "ConfluenceSpace",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v1 /*: any*/ ,
            v6 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "alias"
            },
            v14 /*: any*/ 
        ]
    }, v16 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v17 = {
        "concreteType": "ConfluenceUserInfo",
        "kind": "LinkedField",
        "name": "owner",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    v14 /*: any*/ ,
                    v16 /*: any*/ 
                ]
            }
        ]
    }, v18 = [
        {
            "kind": "Literal",
            "name": "keys",
            "value": [
                "emoji-title-published"
            ]
        }
    ], v19 = {
        "kind": "ScalarField",
        "name": "value"
    }, v20 = [
        v6 /*: any*/ ,
        v19 /*: any*/ 
    ], v21 = {
        "kind": "ScalarField",
        "name": "blogPostId"
    }, v22 = {
        "alias": "blogPostStatus",
        "kind": "ScalarField",
        "name": "status"
    }, v23 = {
        "concreteType": "ConfluenceBlogPostLinks",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v12 /*: any*/ 
    }, v24 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v25 = {
        "concreteType": "ConfluenceUserInfo",
        "kind": "LinkedField",
        "name": "owner",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    v24 /*: any*/ ,
                    v14 /*: any*/ ,
                    v16 /*: any*/ ,
                    v1 /*: any*/ 
                ]
            },
            v1 /*: any*/ 
        ]
    }, v26 = [
        v6 /*: any*/ ,
        v19 /*: any*/ ,
        v1 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "EndOfPageRecommendationTwgQuery",
            "selections": [
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "GraphStoreCypherQueryV2Connection",
                    "kind": "LinkedField",
                    "name": "graphStore_cypherQueryV2",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GraphStoreCypherQueryV2Edge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreCypherQueryV2Node",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphStoreCypherQueryV2Column",
                                            "kind": "LinkedField",
                                            "name": "columns",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "value",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v1 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "data",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v7 /*: any*/ ,
                                                                                v8 /*: any*/ ,
                                                                                v9 /*: any*/ ,
                                                                                v10 /*: any*/ ,
                                                                                v11 /*: any*/ ,
                                                                                v13 /*: any*/ ,
                                                                                v15 /*: any*/ ,
                                                                                v17 /*: any*/ ,
                                                                                {
                                                                                    "args": v18 /*: any*/ ,
                                                                                    "concreteType": "ConfluencePageProperty",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "properties",
                                                                                    "plural": true,
                                                                                    "selections": v20 /*: any*/ ,
                                                                                    "storageKey": "properties(keys:[\"emoji-title-published\"])"
                                                                                }
                                                                            ],
                                                                            "type": "ConfluencePage"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v21 /*: any*/ ,
                                                                                v8 /*: any*/ ,
                                                                                v9 /*: any*/ ,
                                                                                v22 /*: any*/ ,
                                                                                v23 /*: any*/ ,
                                                                                v15 /*: any*/ ,
                                                                                v17 /*: any*/ ,
                                                                                {
                                                                                    "args": v18 /*: any*/ ,
                                                                                    "concreteType": "ConfluenceBlogPostProperty",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "properties",
                                                                                    "plural": true,
                                                                                    "selections": v20 /*: any*/ ,
                                                                                    "storageKey": "properties(keys:[\"emoji-title-published\"])"
                                                                                }
                                                                            ],
                                                                            "type": "ConfluenceBlogPost"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "GraphStoreCypherQueryV2AriNode"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "EndOfPageRecommendationTwgQuery",
            "selections": [
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "GraphStoreCypherQueryV2Connection",
                    "kind": "LinkedField",
                    "name": "graphStore_cypherQueryV2",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GraphStoreCypherQueryV2Edge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreCypherQueryV2Node",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphStoreCypherQueryV2Column",
                                            "kind": "LinkedField",
                                            "name": "columns",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "value",
                                                    "plural": false,
                                                    "selections": [
                                                        v24 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v1 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "data",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v24 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v7 /*: any*/ ,
                                                                                v8 /*: any*/ ,
                                                                                v9 /*: any*/ ,
                                                                                v10 /*: any*/ ,
                                                                                v11 /*: any*/ ,
                                                                                v13 /*: any*/ ,
                                                                                v15 /*: any*/ ,
                                                                                v25 /*: any*/ ,
                                                                                {
                                                                                    "args": v18 /*: any*/ ,
                                                                                    "concreteType": "ConfluencePageProperty",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "properties",
                                                                                    "plural": true,
                                                                                    "selections": v26 /*: any*/ ,
                                                                                    "storageKey": "properties(keys:[\"emoji-title-published\"])"
                                                                                }
                                                                            ],
                                                                            "type": "ConfluencePage"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v21 /*: any*/ ,
                                                                                v8 /*: any*/ ,
                                                                                v9 /*: any*/ ,
                                                                                v22 /*: any*/ ,
                                                                                v23 /*: any*/ ,
                                                                                v15 /*: any*/ ,
                                                                                v25 /*: any*/ ,
                                                                                {
                                                                                    "args": v18 /*: any*/ ,
                                                                                    "concreteType": "ConfluenceBlogPostProperty",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "properties",
                                                                                    "plural": true,
                                                                                    "selections": v26 /*: any*/ ,
                                                                                    "storageKey": "properties(keys:[\"emoji-title-published\"])"
                                                                                }
                                                                            ],
                                                                            "type": "ConfluenceBlogPost"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "Node",
                                                                            "abstractKey": "__isNode"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "AppUser"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "AtlassianAccountUser"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "CustomerUser"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "DevOpsFeatureFlag"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "DevOpsOperationsComponentDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "DevOpsOperationsIncidentDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "DevOpsOperationsPostIncidentReviewDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "DevOpsProjectDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "DevOpsPullRequestDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "DevOpsRepository"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "DevOpsSecurityVulnerabilityDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "JiraAutodevJob"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "JiraConfluenceRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "JiraCustomRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "JiraIssueRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "JiraWebRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "TeamCustomFieldValue"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "TeamType"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "ThirdPartyUser"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "GraphStoreCypherQueryV2AriNode"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "c4c4095c882cb71b80fdf7c511e33e69",
            "id": "e1d623029b3f50e0253d05074cea0ec94b1f823ad4c4b61177f50d160b5886b2",
            "metadata": {},
            "name": "EndOfPageRecommendationTwgQuery",
            "operationKind": "query",
            "text": "query EndOfPageRecommendationTwgQuery($cypherQuery:String!,$first:Int,$key:ID!,$keyString:String!){space(key:$keyString){id},getRecommendedPagesSpaceStatus(entityId:$key){recommendedPagesEnabled,defaultBehavior},graphStore_cypherQueryV2(query:$cypherQuery,first:$first)@optIn(to:\"GraphStoreCypherQueryV2\"){edges{node{columns{key,value{__typename,...on GraphStoreCypherQueryV2AriNode{id,data{__typename,...on ConfluencePage{pageId,title,type,subtype,pageStatus:status,links{webUi},space{id,key,alias,name},owner{user{__typename,name,accountId,id},id},properties(keys:[\"emoji-title-published\"]){key,value,id}},...on ConfluenceBlogPost{blogPostId,title,type,blogPostStatus:status,links{webUi},space{id,key,alias,name},owner{user{__typename,name,accountId,id},id},properties(keys:[\"emoji-title-published\"]){key,value,id}},...on Node{__isNode:__typename,id},...on AppUser{id},...on AtlassianAccountUser{id},...on CustomerUser{id},...on DevOpsFeatureFlag{id},...on DevOpsOperationsComponentDetails{id},...on DevOpsOperationsIncidentDetails{id},...on DevOpsOperationsPostIncidentReviewDetails{id},...on DevOpsProjectDetails{id},...on DevOpsPullRequestDetails{id},...on DevOpsRepository{id},...on DevOpsSecurityVulnerabilityDetails{id},...on JiraAutodevJob{id},...on JiraConfluenceRemoteIssueLink{id},...on JiraCustomRemoteIssueLink{id},...on JiraIssueRemoteIssueLink{id},...on JiraWebRemoteIssueLink{id},...on TeamCustomFieldValue{id},...on TeamType{id},...on ThirdPartyUser{id}}}}}}}}}"
        }
    };
}();
$029fef3d04f7e0c0$var$node.hash = "fde8f13a8c898c317f96538ff58fec17";
var $029fef3d04f7e0c0$export$2e2bcd8739ae039 = $029fef3d04f7e0c0$var$node;
module.exports["default"] = $029fef3d04f7e0c0$export$2e2bcd8739ae039;

});

parcelRegister("ky8L5", function(module, exports) {
// Shared query config + variable builders for the TWG recs query. Used by both the
// client hook and the SSR preloader so they issue byte-identical variables (needed
// for the client's cache-first read to hit the SSR-primed entry).
// TWG relationship for related Confluence content (spec: CA3).
const $5282e58fea25450f$var$TWG_RELATIONSHIP = 'confluence_content_has_related_confluence_content';
// Relationship from a content node to its authority-score node.
const $5282e58fea25450f$var$TWG_AUTHORITY_RELATIONSHIP = 'confluence_content_has_confluence_content_authority_score';
const $5282e58fea25450f$export$fe20e5d4b8358f61 = 12;
const $5282e58fea25450f$export$5bb8653eb6cf29f = (cloudId)=>`ari:cloud:platform::site/${cloudId}`;
const $5282e58fea25450f$export$46c71f7bb38c3d98 = (cloudId, contentId, contentType)=>`ari:cloud:confluence:${cloudId}:${contentType === 'blogpost' ? 'blogpost' : 'page'}/${contentId}`;
const $5282e58fea25450f$export$7135c395d1f4b359 = (pageAri)=>[
        `MATCH (page {ari: "${pageAri}"})-[:${$5282e58fea25450f$var$TWG_RELATIONSHIP}]->(entity)`,
        `OPTIONAL MATCH (entity)-[:${$5282e58fea25450f$var$TWG_AUTHORITY_RELATIONSHIP}]->(auth)`,
        `RETURN DISTINCT entity, auth`
    ].join('\n');
const $5282e58fea25450f$export$8d8ea6a33dea6f1f = (contentType)=>contentType === 'page' || contentType === 'blogpost';
module.exports["MAX_TWG_RECS"] = $5282e58fea25450f$export$fe20e5d4b8358f61;
module.exports["buildTwgQueryContext"] = $5282e58fea25450f$export$5bb8653eb6cf29f;
module.exports["buildTwgContentAri"] = $5282e58fea25450f$export$46c71f7bb38c3d98;
module.exports["buildTwgRecsCypher"] = $5282e58fea25450f$export$7135c395d1f4b359;
module.exports["isTwgSupportedContentType"] = $5282e58fea25450f$export$8d8ea6a33dea6f1f;

});

parcelRegister("38Ncj", function(module, exports) {
/**
 * @generated SignedSource<<97620748d8d680bcf5801bcd64a5c19f>>
 * @relayHash 21cebd3db50676fd19d57554f2f4d6fc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fcc453c87e447898e23b0fd063f4631ca349fe93580bd0dea45de46209594904
const $630a58f9ca4672ab$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isContentTypePublicLinkEligible"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasInheritedRestrictions"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasRestrictions"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasViewRestrictions"
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                }
            ]
        },
        {
            "condition": "isContentTypePublicLinkEligible",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "pageId",
                            "variableName": "contentId"
                        }
                    ],
                    "concreteType": "PublicLinkPage",
                    "kind": "LinkedField",
                    "name": "publicLinkPage",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "pageId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "pageStatus"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "accessType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useShareAndRestrictButtonDataQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useShareAndRestrictButtonDataQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "21cebd3db50676fd19d57554f2f4d6fc",
            "id": "fcc453c87e447898e23b0fd063f4631ca349fe93580bd0dea45de46209594904",
            "metadata": {},
            "name": "useShareAndRestrictButtonDataQuery",
            "operationKind": "query",
            "text": "query useShareAndRestrictButtonDataQuery($contentId:ID!,$isContentTypePublicLinkEligible:Boolean!){singleContent(id:$contentId){id,hasInheritedRestrictions,hasRestrictions,hasViewRestrictions,title},publicLinkPage(pageId:$contentId)@include(if:$isContentTypePublicLinkEligible){pageId,pageStatus,accessType}}"
        }
    };
}();
$630a58f9ca4672ab$var$node.hash = "336fe7f51ff27baeb231379611028a5d";
var $630a58f9ca4672ab$export$2e2bcd8739ae039 = $630a58f9ca4672ab$var$node;
module.exports["default"] = $630a58f9ca4672ab$export$2e2bcd8739ae039;

});

parcelRegister("1ydBT", function(module, exports) {
/**
 * @generated SignedSource<<8bf3e558a6ab7f9cbe727ebec14e7660>>
 * @relayHash 6268a05e132ec3982e53079d2aba0f1b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ce1d7cffa61983594faed4d537e36e9aeef26539ed557ceaf1f6c2812ed8f78f
const $4edc52e24113851d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "focusedCommentId"
    }, v3 = {
        "defaultValue": true,
        "kind": "LocalArgument",
        "name": "includeCommentReactions"
    }, v4 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeCommentThreads"
    }, v5 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeConversationData"
    }, v6 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeFocusedComment"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v8 = {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
    }, v9 = [
        {
            "kind": "Literal",
            "name": "confluenceCommentFilter",
            "value": {
                "commentState": "UNRESOLVED",
                "commentType": "FOOTER"
            }
        },
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "contentStatus"
        },
        {
            "kind": "Literal",
            "name": "depth",
            "value": "ROOT"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        v8 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "type",
            "value": [
                "FOOTER"
            ]
        }
    ], v10 = {
        "kind": "ScalarField",
        "name": "id"
    }, v11 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v12 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v13 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v14 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v15 = {
        "kind": "ScalarField",
        "name": "type"
    }, v16 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v17 = {
        "kind": "LinkedField",
        "name": "contributors",
        "plural": true,
        "selections": [
            v11 /*: any*/ ,
            v12 /*: any*/ ,
            v14 /*: any*/ ,
            v16 /*: any*/ 
        ]
    }, v18 = {
        "kind": "ScalarField",
        "name": "value"
    }, v19 = [
        v18 /*: any*/ 
    ], v20 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v19 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v21 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v22 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v19 /*: any*/ 
    }, v23 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v24 = {
        "kind": "ScalarField",
        "name": "editui"
    }, v25 = {
        "kind": "ScalarField",
        "name": "webui"
    }, v26 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            v24 /*: any*/ ,
            v25 /*: any*/ 
        ]
    }, v27 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v28 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v29 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v30 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v31 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v11 /*: any*/ ,
            v15 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "commentResolveProperties",
                        "plural": false,
                        "selections": [
                            v27 /*: any*/ ,
                            v28 /*: any*/ ,
                            v29 /*: any*/ ,
                            v30 /*: any*/ 
                        ]
                    }
                ],
                "type": "FooterComment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "inlineMarkerRef"
                    },
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "inlineResolveProperties",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isDangling"
                            },
                            v27 /*: any*/ ,
                            v28 /*: any*/ ,
                            v29 /*: any*/ ,
                            v30 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "inlineText"
                    }
                ],
                "type": "InlineComment"
            }
        ]
    }, v32 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v33 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v34 = {
        "condition": "includeCommentReactions",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "childType",
                        "value": "comment"
                    },
                    {
                        "kind": "Literal",
                        "name": "contentType",
                        "value": "page"
                    },
                    v8 /*: any*/ 
                ],
                "concreteType": "ReactionsSummaryResponse",
                "kind": "LinkedField",
                "name": "reactionsSummary",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "ari"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "containerAri"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reactionsCount"
                    },
                    {
                        "concreteType": "ReactionsSummaryForEmoji",
                        "kind": "LinkedField",
                        "name": "reactionsSummaryForEmoji",
                        "plural": true,
                        "selections": [
                            v10 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "count"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "emojiId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "reacted"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v35 = {
        "kind": "LinkedField",
        "name": "by",
        "plural": false,
        "selections": [
            v11 /*: any*/ ,
            v12 /*: any*/ 
        ]
    }, v36 = {
        "kind": "ScalarField",
        "name": "number"
    }, v37 = {
        "kind": "ScalarField",
        "name": "when"
    }, v38 = {
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
            v10 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                    v11 /*: any*/ ,
                    v12 /*: any*/ ,
                    v13 /*: any*/ ,
                    v14 /*: any*/ ,
                    v15 /*: any*/ ,
                    v16 /*: any*/ 
                ]
            },
            v17 /*: any*/ ,
            v20 /*: any*/ ,
            {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "container",
                "plural": false,
                "selections": [
                    v10 /*: any*/ 
                ]
            },
            v21 /*: any*/ ,
            v22 /*: any*/ ,
            v23 /*: any*/ ,
            v26 /*: any*/ ,
            v31 /*: any*/ ,
            v32 /*: any*/ ,
            v33 /*: any*/ ,
            {
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "replies",
                "plural": true,
                "selections": [
                    v10 /*: any*/ ,
                    {
                        "kind": "LinkedField",
                        "name": "author",
                        "plural": false,
                        "selections": [
                            v11 /*: any*/ ,
                            v12 /*: any*/ ,
                            v13 /*: any*/ ,
                            v16 /*: any*/ ,
                            v14 /*: any*/ 
                        ]
                    },
                    v20 /*: any*/ ,
                    v21 /*: any*/ ,
                    v22 /*: any*/ ,
                    v23 /*: any*/ ,
                    v26 /*: any*/ ,
                    v31 /*: any*/ ,
                    v32 /*: any*/ ,
                    v33 /*: any*/ ,
                    v34 /*: any*/ ,
                    {
                        "concreteType": "Version",
                        "kind": "LinkedField",
                        "name": "version",
                        "plural": false,
                        "selections": [
                            v35 /*: any*/ ,
                            v36 /*: any*/ ,
                            v37 /*: any*/ 
                        ]
                    },
                    v17 /*: any*/ 
                ]
            },
            {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "by",
                        "plural": false,
                        "selections": [
                            v11 /*: any*/ ,
                            v15 /*: any*/ ,
                            v12 /*: any*/ ,
                            v16 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "friendlyWhen"
                    },
                    v36 /*: any*/ ,
                    v37 /*: any*/ 
                ]
            },
            v34 /*: any*/ 
        ]
    }, v39 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v40 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "pageId"
    }, v41 = [
        v40 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "status",
            "value": [
                "current",
                "archived",
                "draft"
            ]
        }
    ], v42 = [
        {
            "kind": "Variable",
            "name": "commentId",
            "variableName": "focusedCommentId"
        },
        {
            "kind": "Literal",
            "name": "depth",
            "value": "ALL"
        },
        {
            "kind": "Literal",
            "name": "type",
            "value": "UNRESOLVED"
        }
    ], v43 = [
        {
            "kind": "Literal",
            "name": "current",
            "value": true
        }
    ], v44 = {
        "kind": "ScalarField",
        "name": "isPrimary"
    }, v45 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v46 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v10 /*: any*/ ,
            v45 /*: any*/ 
        ]
    }, v47 = {
        "kind": "ScalarField",
        "name": "isInlineComment"
    }, v48 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            v35 /*: any*/ ,
            v37 /*: any*/ ,
            v36 /*: any*/ 
        ]
    }, v49 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            v25 /*: any*/ ,
            v24 /*: any*/ 
        ]
    }, v50 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v11 /*: any*/ ,
            v12 /*: any*/ ,
            v14 /*: any*/ ,
            v13 /*: any*/ ,
            v16 /*: any*/ 
        ]
    }, v51 = {
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "replies",
        "plural": true,
        "selections": [
            v10 /*: any*/ ,
            v20 /*: any*/ ,
            v22 /*: any*/ ,
            v23 /*: any*/ ,
            v47 /*: any*/ ,
            v33 /*: any*/ ,
            v48 /*: any*/ ,
            v49 /*: any*/ ,
            v50 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ObjectCommentContainerPreloadObjectCommentsQuery",
            "selections": [
                {
                    "args": v9 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        v38 /*: any*/ ,
                        v39 /*: any*/ ,
                        v11 /*: any*/ ,
                        {
                            "condition": "includeCommentThreads",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "ViewPageConversation_commentThreads"
                                            }
                                        ],
                                        "type": "PaginatedCommentList"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "conversationCommentThreads"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "includeConversationData",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "fragment": {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "ViewPageConversation_currentUser"
                                    }
                                ],
                                "type": "Query"
                            },
                            "kind": "AliasedInlineFragmentSpread",
                            "name": "conversationCurrentUser"
                        },
                        {
                            "args": v41 /*: any*/ ,
                            "concreteType": "PaginatedContentListWithChild",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ViewPageConversation_contentPermission"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "includeFocusedComment",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "focusedInlineComment",
                            "args": v42 /*: any*/ ,
                            "concreteType": "PaginatedCommentList",
                            "kind": "LinkedField",
                            "name": "comments",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "ViewPageConversation_focusedInlineComment"
                                }
                            ]
                        },
                        {
                            "fragment": {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "ViewPageConversation_focusedInlineCommentContext"
                                    }
                                ],
                                "type": "Query"
                            },
                            "kind": "AliasedInlineFragmentSpread",
                            "name": "focusedInlineCommentContext"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v7 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ObjectCommentContainerPreloadObjectCommentsQuery",
            "selections": [
                {
                    "args": v9 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        v38 /*: any*/ ,
                        v39 /*: any*/ ,
                        v11 /*: any*/ 
                    ]
                },
                {
                    "condition": "includeConversationData",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "user",
                            "args": v43 /*: any*/ ,
                            "concreteType": "AtlassianUser",
                            "kind": "LinkedField",
                            "name": "confluence_atlassianUser",
                            "plural": false,
                            "selections": [
                                v10 /*: any*/ ,
                                v12 /*: any*/ ,
                                {
                                    "concreteType": "AtlassianUserPhoto",
                                    "kind": "LinkedField",
                                    "name": "photos",
                                    "plural": true,
                                    "selections": [
                                        v44 /*: any*/ ,
                                        v18 /*: any*/ 
                                    ]
                                }
                            ],
                            "storageKey": "confluence_atlassianUser(current:true)"
                        },
                        {
                            "args": v41 /*: any*/ ,
                            "concreteType": "PaginatedContentListWithChild",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v10 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        v45 /*: any*/ ,
                                        v46 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v11 /*: any*/ ,
                                                        v16 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "includeFocusedComment",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "focusedInlineComment",
                            "args": v42 /*: any*/ ,
                            "concreteType": "PaginatedCommentList",
                            "kind": "LinkedField",
                            "name": "comments",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "Comment",
                                            "kind": "LinkedField",
                                            "name": "ancestors",
                                            "plural": true,
                                            "selections": [
                                                v10 /*: any*/ ,
                                                v20 /*: any*/ ,
                                                v22 /*: any*/ ,
                                                v23 /*: any*/ ,
                                                v47 /*: any*/ ,
                                                v33 /*: any*/ ,
                                                v48 /*: any*/ ,
                                                v49 /*: any*/ ,
                                                v50 /*: any*/ ,
                                                v51 /*: any*/ 
                                            ]
                                        },
                                        v10 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v22 /*: any*/ ,
                                        v23 /*: any*/ ,
                                        v47 /*: any*/ ,
                                        v33 /*: any*/ ,
                                        v48 /*: any*/ ,
                                        v49 /*: any*/ ,
                                        v50 /*: any*/ ,
                                        v51 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "focusedContent",
                            "args": [
                                v40 /*: any*/ 
                            ],
                            "concreteType": "PaginatedContentListWithChild",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v10 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        v46 /*: any*/ ,
                                        v45 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "user",
                            "args": v43 /*: any*/ ,
                            "concreteType": "AtlassianUser",
                            "kind": "LinkedField",
                            "name": "confluence_atlassianUser",
                            "plural": false,
                            "selections": [
                                v10 /*: any*/ ,
                                v12 /*: any*/ ,
                                {
                                    "concreteType": "AtlassianUserPhoto",
                                    "kind": "LinkedField",
                                    "name": "photos",
                                    "plural": true,
                                    "selections": [
                                        v18 /*: any*/ ,
                                        v44 /*: any*/ 
                                    ]
                                }
                            ],
                            "storageKey": "confluence_atlassianUser(current:true)"
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "6268a05e132ec3982e53079d2aba0f1b",
            "id": "ce1d7cffa61983594faed4d537e36e9aeef26539ed557ceaf1f6c2812ed8f78f",
            "metadata": {},
            "name": "ObjectCommentContainerPreloadObjectCommentsQuery",
            "operationKind": "query",
            "text": "query ObjectCommentContainerPreloadObjectCommentsQuery($pageId:ID!,$contentStatus:[GraphQLContentStatus],$first:Long,$includeCommentReactions:Boolean=true,$includeConversationData:Boolean=false,$includeCommentThreads:Boolean=false,$focusedCommentId:ID,$includeFocusedComment:Boolean=false){...ViewPageConversation_currentUser@include(if:$includeConversationData)\n  content(id:$pageId,status:[\"current\",\"archived\",\"draft\"])@include(if:$includeConversationData){nodes{...ViewPageConversation_contentPermission,id}},comments(pageId:$pageId,contentStatus:$contentStatus,depth:ROOT,first:$first,type:[FOOTER],confluenceCommentFilter:{commentState:UNRESOLVED,commentType:FOOTER}){nodes{id,author{__typename,displayName,permissionType,...on KnownUser{accountId,permissionType},profilePicture{path},type},contributors{__typename,displayName,profilePicture{path},...on KnownUser{accountId}},body(representation:ATLAS_DOC_FORMAT){value},container{id},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\")@include(if:$includeCommentReactions){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},replies{id,author{__typename,displayName,permissionType,...on KnownUser{accountId},profilePicture{path}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\")@include(if:$includeCommentReactions){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},version{by{__typename,displayName},number,when},contributors{__typename,displayName,profilePicture{path},...on KnownUser{accountId}}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,when}},totalCount,__typename,...ViewPageConversation_commentThreads@include(if:$includeCommentThreads)},focusedInlineComment:comments(commentId:$focusedCommentId,depth:ALL,type:UNRESOLVED)@include(if:$includeFocusedComment){...ViewPageConversation_focusedInlineComment}\n  ...ViewPageConversation_focusedInlineCommentContext@include(if:$includeFocusedComment)}fragment ViewPageConversation_commentThreads on PaginatedCommentList{nodes{id,author{__typename,displayName,permissionType,...on KnownUser{accountId,permissionType},profilePicture{path},type},contributors{__typename,displayName,profilePicture{path},...on KnownUser{accountId}},body(representation:ATLAS_DOC_FORMAT){value},container{id},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\")@include(if:$includeCommentReactions){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},replies{id,author{__typename,displayName,permissionType,...on KnownUser{accountId},profilePicture{path}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\")@include(if:$includeCommentReactions){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},version{by{__typename,displayName},number,when},contributors{__typename,displayName,profilePicture{path},...on KnownUser{accountId}}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,when}},totalCount,__typename}fragment ViewPageConversation_contentPermission on Content{id,type,operations{operation,targetType},space{id,operations{operation,targetType}},history{createdBy{__typename,...on KnownUser{accountId}}}}fragment ViewPageConversation_currentUser on Query{user:confluence_atlassianUser(current:true){id,displayName,photos{isPrimary,value}}}fragment ViewPageConversation_focusedInlineComment on PaginatedCommentList{nodes{ancestors{id,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,isInlineComment,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},links{webui,editui},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},replies{id,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,isInlineComment,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},links{webui,editui},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}}}},id,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,isInlineComment,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},links{webui,editui},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},replies{id,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,isInlineComment,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},links{webui,editui},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}}}}}fragment ViewPageConversation_focusedInlineCommentContext on Query{focusedContent:content(id:$pageId){nodes{id,type,space{id,operations{operation,targetType}},operations{operation,targetType}}},user:confluence_atlassianUser(current:true){id,displayName,photos{value,isPrimary}}}"
        }
    };
}();
$4edc52e24113851d$var$node.hash = "2cfe5fc37f71ef70f39b17155896292b";
var $4edc52e24113851d$export$2e2bcd8739ae039 = $4edc52e24113851d$var$node;
module.exports["default"] = $4edc52e24113851d$export$2e2bcd8739ae039;

});

parcelRegister("cQbnm", function(module, exports) {
const $a2901bd3596bb581$export$c6ff0a0df62acf44 = 3;
const $a2901bd3596bb581$export$fa19d42490144c8 = (contentId, includeConversationData = false, includeCommentThreads = false, focusedCommentId, includeFocusedComment = false)=>({
        pageId: contentId,
        contentStatus: [
            'DRAFT',
            'CURRENT',
            'ARCHIVED'
        ],
        first: $a2901bd3596bb581$export$c6ff0a0df62acf44,
        includeCommentReactions: true,
        includeConversationData: includeConversationData,
        includeCommentThreads: includeCommentThreads,
        focusedCommentId: focusedCommentId ?? null,
        includeFocusedComment: includeFocusedComment
    });
module.exports["buildPreloadObjectCommentsQueryVariables"] = $a2901bd3596bb581$export$fa19d42490144c8;

});

parcelRegister("dd33Q", function(module, exports) {
/**
 * @generated SignedSource<<aa6a269424bc1b4fc1bcb7ed6da5dcee>>
 * @relayHash 10a6e74201e75f7fd05257845e870e22
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5f78c38bf43db12554ba0f37ad39b4afd115d6ef16213fadbd51e8708bc161d2
const $b17ca59e188f1f50$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "concreteType": "SpaceTypeSettings",
                    "kind": "LinkedField",
                    "name": "spaceTypeSettings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "EnabledContentTypes",
                            "kind": "LinkedField",
                            "name": "enabledContentTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isBlogsEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isDatabasesEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isEmbedsEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isLivePagesEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isSlidesEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isWhiteboardsEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isFoldersEnabled"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceEnabledContentTypesQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceEnabledContentTypesQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "10a6e74201e75f7fd05257845e870e22",
            "id": "5f78c38bf43db12554ba0f37ad39b4afd115d6ef16213fadbd51e8708bc161d2",
            "metadata": {},
            "name": "useSpaceEnabledContentTypesQuery",
            "operationKind": "query",
            "text": "query useSpaceEnabledContentTypesQuery($spaceKey:String){space(key:$spaceKey){id,key,spaceTypeSettings{enabledContentTypes{isBlogsEnabled,isDatabasesEnabled,isEmbedsEnabled,isLivePagesEnabled,isSlidesEnabled,isWhiteboardsEnabled,isFoldersEnabled}}}}"
        }
    };
}();
$b17ca59e188f1f50$var$node.hash = "b239b4c898f62763088962d6011df617";
var $b17ca59e188f1f50$export$2e2bcd8739ae039 = $b17ca59e188f1f50$var$node;
module.exports["default"] = $b17ca59e188f1f50$export$2e2bcd8739ae039;

});

parcelRegister("47TZD", function(module, exports) {

var $6PfFM = parcelRequire("6PfFM");

const $fb0dcbfe669881ea$export$8f6fbf7ac56d5471 = 3;
const $fb0dcbfe669881ea$var$SOURCE_COLUMN = 'source';
function $fb0dcbfe669881ea$export$6bfcbd8be080e9d0(contentId, status, count) {
    if (status === 'present') return Object.freeze({
        contentId: contentId,
        status: status,
        count: count ?? 0
    });
    return Object.freeze({
        contentId: contentId,
        status: status
    });
}
const $fb0dcbfe669881ea$var$buildIncomingLinksCypher = (targetAri, contentType)=>{
    const label = (0, $6PfFM.getContentGraphNodeLabel)(contentType);
    return [
        `MATCH (source)-[:content_referenced_entity]->(target:${label} {ari: "${targetAri}"})`,
        'WHERE source <> target',
        'RETURN source',
        `LIMIT ${$fb0dcbfe669881ea$export$8f6fbf7ac56d5471}`
    ].join('\n');
};
const $fb0dcbfe669881ea$export$5ecfd95d81f175ce = (cloudId, contentId, contentType)=>{
    if (!cloudId.trim() || !/^[1-9]\d*$/.test(contentId)) return undefined;
    let targetAri;
    try {
        targetAri = (0, $6PfFM.buildContentAri)(cloudId, contentId, contentType);
    } catch  {
        return undefined;
    }
    return {
        cypherQuery: $fb0dcbfe669881ea$var$buildIncomingLinksCypher(targetAri, contentType),
        first: $fb0dcbfe669881ea$export$8f6fbf7ac56d5471
    };
};
const $fb0dcbfe669881ea$export$ea0577b4a4a51553 = (data)=>{
    const edges = data?.graphStore_cypherQueryV2?.edges;
    if (!edges || edges.length > $fb0dcbfe669881ea$export$8f6fbf7ac56d5471) return {
        status: 'unavailable',
        reason: 'malformed-response'
    };
    for (const edge of edges){
        const columns = edge.node.columns;
        if (columns.length !== 1) return {
            status: 'unavailable',
            reason: 'malformed-response'
        };
        const column = columns[0];
        if (column.key !== $fb0dcbfe669881ea$var$SOURCE_COLUMN || column.value?.__typename !== 'GraphStoreCypherQueryV2AriNode' || typeof column.value.id !== 'string' || !column.value.id.startsWith('ari:')) return {
            status: 'unavailable',
            reason: 'malformed-response'
        };
    }
    return {
        status: 'available',
        count: edges.length
    };
};
const $fb0dcbfe669881ea$export$2f3db422bbda5145 = (contentId, data)=>{
    const result = $fb0dcbfe669881ea$export$ea0577b4a4a51553(data);
    if (result.status === 'unavailable') return $fb0dcbfe669881ea$export$6bfcbd8be080e9d0(contentId, 'unavailable');
    return result.count > 0 ? $fb0dcbfe669881ea$export$6bfcbd8be080e9d0(contentId, 'present', result.count) : $fb0dcbfe669881ea$export$6bfcbd8be080e9d0(contentId, 'empty');
};
module.exports["INCOMING_LINKS_SAMPLE_LIMIT"] = $fb0dcbfe669881ea$export$8f6fbf7ac56d5471;
module.exports["createIncomingLinksSsrState"] = $fb0dcbfe669881ea$export$6bfcbd8be080e9d0;
module.exports["buildIncomingLinksSampleVariables"] = $fb0dcbfe669881ea$export$5ecfd95d81f175ce;
module.exports["normalizeIncomingLinksSampleData"] = $fb0dcbfe669881ea$export$ea0577b4a4a51553;
module.exports["normalizeIncomingLinksSsrState"] = $fb0dcbfe669881ea$export$2f3db422bbda5145;

});

parcelRegister("6PfFM", function(module, exports) {

var $5BvyC = parcelRequire("5BvyC");

var $8jDil = parcelRequire("8jDil");

const $94b9463fa3199f01$export$4e018a7b6e50d21f = (contentType)=>contentType === 'blogpost' ? 'ConfluenceBlogpost' : 'ConfluencePage';
const $94b9463fa3199f01$export$4d9ebde52d2b3998 = (cloudId, contentId, contentType)=>contentType === 'blogpost' ? (0, $5BvyC.ConfluenceBlogpostAri).create({
        siteId: cloudId,
        blogpostId: contentId
    }).toString() : (0, $8jDil.ConfluencePageAri).create({
        siteId: cloudId,
        pageId: contentId
    }).toString();
module.exports["getContentGraphNodeLabel"] = $94b9463fa3199f01$export$4e018a7b6e50d21f;
module.exports["buildContentAri"] = $94b9463fa3199f01$export$4d9ebde52d2b3998;

});

parcelRegister("6U179", function(module, exports) {
/**
 * @generated SignedSource<<ae7b4939fdea464930e0f014fce7c3a3>>
 * @relayHash 5ebf1285eea0f6e277ccc1791c349170
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 83f26dc21ea579fed2d0d4ec2f290a108314a7d06a83cc5b9fbf80b01a76c7b9
const $784926291035c30b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cypherQuery"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                },
                {
                    "kind": "Variable",
                    "name": "query",
                    "variableName": "cypherQuery"
                }
            ],
            "concreteType": "GraphStoreCypherQueryV2Connection",
            "kind": "LinkedField",
            "name": "graphStore_cypherQueryV2",
            "plural": false,
            "selections": [
                {
                    "concreteType": "GraphStoreCypherQueryV2Edge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "GraphStoreCypherQueryV2Node",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreCypherQueryV2Column",
                                    "kind": "LinkedField",
                                    "name": "columns",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "value",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "GraphStoreCypherQueryV2AriNode"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadIncomingLinksSampleQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadIncomingLinksSampleQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "5ebf1285eea0f6e277ccc1791c349170",
            "id": "83f26dc21ea579fed2d0d4ec2f290a108314a7d06a83cc5b9fbf80b01a76c7b9",
            "metadata": {},
            "name": "preloadIncomingLinksSampleQuery",
            "operationKind": "query",
            "text": "query preloadIncomingLinksSampleQuery($cypherQuery:String!,$first:Int!){graphStore_cypherQueryV2(query:$cypherQuery,first:$first)@optIn(to:\"GraphStoreCypherQueryV2\"){edges{node{columns{key,value{__typename,...on GraphStoreCypherQueryV2AriNode{id}}}}}}}"
        }
    };
}();
$784926291035c30b$var$node.hash = "60d2b49af10374001914afa2e5cda7a3";
var $784926291035c30b$export$2e2bcd8739ae039 = $784926291035c30b$var$node;
module.exports["default"] = $784926291035c30b$export$2e2bcd8739ae039;

});

parcelRegister("8VTwN", function(module, exports) {
/**
 * @generated SignedSource<<0701e763b7958be6f57b93d2e75de942>>
 * @relayHash 7fd97179862fdacd6b49b0adb6cfd0aa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c44ed6bca2ecf5a5d045d88ddcff4658f3106307ef36fc4574a1a4b7108eb1ad
const $bb28486076354be0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "smartLinksFromDraft"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        },
        {
            "kind": "Literal",
            "name": "includeHyperlinks",
            "value": true
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "url"
    }, v3 = [
        {
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v2 /*: any*/ 
            ]
        }
    ], v4 = [
        {
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                v2 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "BylineSmartLinksQuery",
            "selections": [
                {
                    "condition": "smartLinksFromDraft",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "PaginatedSmartLinkList",
                            "kind": "LinkedField",
                            "name": "contentSmartLinks",
                            "plural": false,
                            "selections": v3 /*: any*/ 
                        }
                    ]
                },
                {
                    "condition": "smartLinksFromDraft",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "PaginatedSmartLinkList",
                            "kind": "LinkedField",
                            "name": "confluence_contentSmartLinksForDraft",
                            "plural": false,
                            "selections": v3 /*: any*/ 
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "BylineSmartLinksQuery",
            "selections": [
                {
                    "condition": "smartLinksFromDraft",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "PaginatedSmartLinkList",
                            "kind": "LinkedField",
                            "name": "contentSmartLinks",
                            "plural": false,
                            "selections": v4 /*: any*/ 
                        }
                    ]
                },
                {
                    "condition": "smartLinksFromDraft",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "PaginatedSmartLinkList",
                            "kind": "LinkedField",
                            "name": "confluence_contentSmartLinksForDraft",
                            "plural": false,
                            "selections": v4 /*: any*/ 
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "7fd97179862fdacd6b49b0adb6cfd0aa",
            "id": "c44ed6bca2ecf5a5d045d88ddcff4658f3106307ef36fc4574a1a4b7108eb1ad",
            "metadata": {},
            "name": "BylineSmartLinksQuery",
            "operationKind": "query",
            "text": "query BylineSmartLinksQuery($contentId:ID!,$first:Int!,$smartLinksFromDraft:Boolean!){contentSmartLinks(id:$contentId,first:$first,includeHyperlinks:true)@skip(if:$smartLinksFromDraft){nodes{__typename,url}},confluence_contentSmartLinksForDraft(id:$contentId,first:$first,includeHyperlinks:true)@include(if:$smartLinksFromDraft){nodes{__typename,url}}}"
        }
    };
}();
$bb28486076354be0$var$node.hash = "cf02c7bcd3075e2d4d370793343d5acb";
var $bb28486076354be0$export$2e2bcd8739ae039 = $bb28486076354be0$var$node;
module.exports["default"] = $bb28486076354be0$export$2e2bcd8739ae039;

});

parcelRegister("jJhQa", function(module, exports) {

var $hDf5o = parcelRequire("hDf5o");


var $eyzEJ = parcelRequire("eyzEJ");


var $9pUdg = parcelRequire("9pUdg");


var $5b9Ab = parcelRequire("5b9Ab");

const $414ed69874d93138$export$391068ad89fee276 = 3;
const $414ed69874d93138$var$isUnconnectedSmartLink = (link)=>link.access !== 'granted';
const $414ed69874d93138$var$toIcon = (link, icon)=>{
    const product = (0, $hDf5o.formatLabel)(link.product);
    const isAppLogo = icon.kind === 'logo';
    return {
        // App logos collapse Jira / Jira Software and Atlas apps onto one chip.
        key: isAppLogo ? icon.key : product || icon.key,
        label: (isAppLogo ? (0, $eyzEJ.formatProduct)(link.product) : product) ?? icon.label ?? '',
        icon: icon
    };
};
const $414ed69874d93138$var$dedupeIcons = (icons)=>{
    const seenKeys = new Set();
    const dedupedIcons = [];
    for (const icon of icons)if (!seenKeys.has(icon.key)) {
        seenKeys.add(icon.key);
        dedupedIcons.push(icon);
    }
    return dedupedIcons;
};
const $414ed69874d93138$var$sortRankedIcons = (left, right)=>{
    if (left.isUnconnected !== right.isUnconnected) return Number(right.isUnconnected) - Number(left.isUnconnected);
    return left.occurrenceIndex - right.occurrenceIndex;
};
// Ranks one direction: unconnected links first (they carry a connect prompt), then document or
// recency order.
const $414ed69874d93138$var$rankIcons = (links)=>{
    const rankedIcons = [];
    for (const link of links){
        const icon = (0, $9pUdg.getProductAppIcon)(link) ?? (0, $5b9Ab.getSmartLinkIcon)(link);
        if (!icon) continue;
        rankedIcons.push({
            icon: $414ed69874d93138$var$toIcon(link, icon),
            isUnconnected: $414ed69874d93138$var$isUnconnectedSmartLink(link),
            occurrenceIndex: link.occurrenceIndex
        });
    }
    rankedIcons.sort($414ed69874d93138$var$sortRankedIcons);
    return rankedIcons.map(({ icon: icon })=>icon);
};
const $414ed69874d93138$export$a95e00393b41fca9 = (links, additionalIcons = [], incomingLinks = [])=>$414ed69874d93138$var$dedupeIcons([
        ...additionalIcons,
        ...$414ed69874d93138$var$rankIcons(links),
        ...$414ed69874d93138$var$rankIcons(incomingLinks)
    ]).slice(0, $414ed69874d93138$export$391068ad89fee276);
module.exports["MAX_BYLINE_CONNECTION_ICONS"] = $414ed69874d93138$export$391068ad89fee276;
module.exports["getBylineConnectionIcons"] = $414ed69874d93138$export$a95e00393b41fca9;

});

parcelRegister("hDf5o", function(module, exports) {
function $1f3713d3e01cb733$export$957d7daebd899f12(value) {
    if (!value || !Number.isNaN(Number(value))) return undefined;
    return value.replace(/([a-z])([A-Z])/g, '$1 $2').split(' ').map((word)=>word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
}
module.exports["formatLabel"] = $1f3713d3e01cb733$export$957d7daebd899f12;

});

parcelRegister("eyzEJ", function(module, exports) {

var $hDf5o = parcelRequire("hDf5o");


var $giSsj = parcelRequire("giSsj");

const $e6477f7a4fe60a65$export$dfedf783fc78a20b = (product)=>{
    if (!product) return undefined;
    if ((0, $giSsj.groupsUnderGoals)(product)) return 0, $giSsj.TOWNSQUARE_GROUP_LABEL;
    if (/^[A-Z]/.test(product)) return product;
    return (0, $hDf5o.formatLabel)(product) ?? product;
};
module.exports["formatProduct"] = $e6477f7a4fe60a65$export$dfedf783fc78a20b;

});

parcelRegister("giSsj", function(module, exports) {
/**
 * Internal platform codename ORS returns in `meta.product` for Atlas surfaces
 * (Projects, Goals, Focus). It is not a customer-facing product name.
 */ const $c0ba95e47527c98f$export$cd8157ef8480dd6e = 'townsquare';
const $c0ba95e47527c98f$export$7dcfe620b740d488 = 'Goals';
const $c0ba95e47527c98f$export$a2347c5c71d8b747 = (product)=>product?.toLowerCase().trim() === $c0ba95e47527c98f$export$cd8157ef8480dd6e;
/**
 * Atlas app names that can surface as the product itself — via `data.generator.name`
 * — when the response carries no `townsquare` `meta.product` (e.g. Focus links,
 * which resolve through mercury-object-provider without a product). They collapse
 * under the same "Goals" group as the codename, with the app shown per-row.
 */ const $c0ba95e47527c98f$var$ATLAS_APP_PRODUCTS = new Set([
    'focus',
    'goals',
    'projects'
]);
const $c0ba95e47527c98f$export$93f5f4f2e1b01303 = (product)=>{
    if ($c0ba95e47527c98f$export$a2347c5c71d8b747(product)) return true;
    const normalized = product?.toLowerCase().trim();
    return normalized != null && $c0ba95e47527c98f$var$ATLAS_APP_PRODUCTS.has(normalized);
};
module.exports["TOWNSQUARE_GROUP_LABEL"] = $c0ba95e47527c98f$export$7dcfe620b740d488;
module.exports["isTownsquareProduct"] = $c0ba95e47527c98f$export$a2347c5c71d8b747;
module.exports["groupsUnderGoals"] = $c0ba95e47527c98f$export$93f5f4f2e1b01303;

});

parcelRegister("9pUdg", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $fxqZn = parcelRequire("fxqZn");


var $hZx6a = parcelRequire("hZx6a");


var $5lkNm = parcelRequire("5lkNm");


var $5k2zo = parcelRequire("5k2zo");


var $ldJ1U = parcelRequire("ldJ1U");


var $lb2PL = parcelRequire("lb2PL");


var $8JGXU = parcelRequire("8JGXU");


var $eyzEJ = parcelRequire("eyzEJ");


var $giSsj = parcelRequire("giSsj");

const $7dfc51a40edbd36a$var$FIRST_PARTY_LOGOS = {
    bitbucket: (0, $fxqZn.BitbucketIcon),
    compass: (0, $hZx6a.CompassIcon),
    confluence: (0, $5lkNm.ConfluenceIcon),
    jira: (0, $ldJ1U.JiraIcon),
    loom: (0, $lb2PL.LoomIcon),
    trello: (0, $8JGXU.TrelloIcon)
};
const $7dfc51a40edbd36a$var$getAppIconId = (product)=>{
    if ((0, $giSsj.groupsUnderGoals)(product)) return 'goals';
    const key = product?.toLowerCase().trim();
    if (!key) return undefined;
    if (key === 'jira' || key.startsWith('jira ') || key.startsWith('jira-')) return 'jira';
    return $7dfc51a40edbd36a$var$FIRST_PARTY_LOGOS[key] ? key : undefined;
};
const $7dfc51a40edbd36a$export$86510ddd964a8ddd = (source)=>{
    const appIconId = $7dfc51a40edbd36a$var$getAppIconId(source.product);
    if (!appIconId) return undefined;
    const Logo = appIconId === 'goals' ? (0, $5k2zo.GoalsIcon) : $7dfc51a40edbd36a$var$FIRST_PARTY_LOGOS[appIconId];
    if (!Logo) return undefined;
    return {
        node: (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Logo, {
            appearance: 'brand',
            size: 'xxsmall',
            testId: `${appIconId}-app-icon`
        }),
        key: `product:${appIconId}`,
        label: (0, $eyzEJ.formatProduct)(source.product) ?? source.product,
        kind: 'logo'
    };
};
module.exports["getProductAppIcon"] = $7dfc51a40edbd36a$export$86510ddd964a8ddd;

});

parcelRegister("fxqZn", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $d28d5aedb34440f3$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#94c748)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="m17.898 11.353-.994 6.064c-.065.367-.324.583-.691.583H7.787c-.367 0-.627-.216-.691-.583L5.346 6.604C5.28 6.237 5.476 6 5.82 6h12.358c.346 0 .54.237.475.604l-.475 2.85c-.065.41-.303.582-.691.582h-7.432c-.109 0-.173.065-.152.194l.584 3.583c.021.086.086.151.172.151h2.68c.086 0 .15-.065.172-.151l.41-2.59c.044-.324.26-.453.563-.453H17.4c.432 0 .562.216.497.582"/>
</svg>
`;
const $d28d5aedb34440f3$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.821 6c-.345 0-.54.238-.475.604l1.75 10.813c.065.367.324.583.691.583h8.426c.367 0 .627-.216.691-.583l.994-6.065c.065-.366-.065-.582-.497-.582h-2.917c-.302 0-.518.13-.561.453l-.41 2.59c-.022.086-.087.15-.173.15h-2.68c-.086 0-.151-.064-.173-.15l-.583-3.583c-.021-.129.044-.194.152-.194h7.431c.39 0 .627-.173.692-.583l.475-2.849c.065-.366-.13-.604-.475-.604z"/>
</svg>
`;
const $d28d5aedb34440f3$export$5fc1066e677788d4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BitbucketIcon(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { iconColor: iconColor, size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Bitbucket" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== iconColor || $[2] !== label || $[3] !== size || $[4] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $d28d5aedb34440f3$var$svg,
            customThemeSvg: $d28d5aedb34440f3$var$customThemeSvg,
            iconColor: iconColor,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = iconColor;
        $[2] = label;
        $[3] = size;
        $[4] = testId;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
} : function BitbucketIcon({ iconColor: iconColor, size: size = 'medium', appearance: appearance = 'brand', label: label = 'Bitbucket', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $d28d5aedb34440f3$var$svg,
        customThemeSvg: $d28d5aedb34440f3$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["BitbucketIcon"] = $d28d5aedb34440f3$export$5fc1066e677788d4;

});

parcelRegister("hZx6a", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $08074ca1ab8ce06c$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#94c748)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M12.75 7.877v-3.37l6.16-.007h.007a.59.59 0 0 1 .583.598v6.147h-3.366V7.877z"/>
    <path fill="var(--icon-color, #101214)" d="M12.75 14.615v-3.37h3.368v6.165a.59.59 0 0 1-.591.59H6.583A.59.59 0 0 1 6 17.402V8.467a.59.59 0 0 1 .591-.59h6.16v3.368H9.373v3.37z"/>
</svg>
`;
const $08074ca1ab8ce06c$export$f7857fe64d7161d9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CompassIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Compass" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $08074ca1ab8ce06c$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : function CompassIcon({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Compass', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $08074ca1ab8ce06c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["CompassIcon"] = $08074ca1ab8ce06c$export$f7857fe64d7161d9;

});

parcelRegister("5k2zo", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $ad20b5467f7f9ada$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M14.352 12a2.352 2.352 0 1 1-4.704 0 2.352 2.352 0 0 1 4.704 0"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M12 18.563a6.562 6.562 0 1 0 0-13.125 6.562 6.562 0 0 0 0 13.125M16.102 12a4.102 4.102 0 1 1-8.204 0 4.102 4.102 0 0 1 8.204 0" clip-rule="evenodd"/>
</svg>
`;
const $ad20b5467f7f9ada$export$9eb74917ea768ed4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function GoalsIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Goals" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $ad20b5467f7f9ada$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : function GoalsIcon({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Goals', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $ad20b5467f7f9ada$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["GoalsIcon"] = $ad20b5467f7f9ada$export$9eb74917ea768ed4;

});

parcelRegister("lb2PL", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $c420f5a156d6b7cf$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302"/>
</svg>
`;
const $c420f5a156d6b7cf$export$8d789f76fde3e05 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function LoomIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Loom" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $c420f5a156d6b7cf$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : function LoomIcon({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Loom', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $c420f5a156d6b7cf$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["LoomIcon"] = $c420f5a156d6b7cf$export$8d789f76fde3e05;

});

parcelRegister("8JGXU", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $24d0e9af25866402$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1558bc)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M9.39 18.23a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95H5.38a.95.95 0 0 0-.95.95v11.91c0 .52.42.95.95.95zm9.23-5.46a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95h-4.01a.95.95 0 0 0-.95.95v6.44c0 .52.42.95.95.95z"/>
</svg>
`;
const $24d0e9af25866402$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.379 4.43a.95.95 0 0 0-.948.949v11.907c0 .523.424.948.948.948H9.39a.95.95 0 0 0 .947-.948V5.38a.95.95 0 0 0-.947-.948zm9.23 0a.95.95 0 0 0-.947.949v6.44c0 .523.423.948.947.949h4.012a.95.95 0 0 0 .948-.949V5.38a.95.95 0 0 0-.948-.948z"/>
</svg>
`;
const $24d0e9af25866402$export$4384da9b8b140bf4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TrelloIcon(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { iconColor: iconColor, size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Trello" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== iconColor || $[2] !== label || $[3] !== size || $[4] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $24d0e9af25866402$var$svg,
            customThemeSvg: $24d0e9af25866402$var$customThemeSvg,
            iconColor: iconColor,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = iconColor;
        $[2] = label;
        $[3] = size;
        $[4] = testId;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
} : function TrelloIcon({ iconColor: iconColor, size: size = 'medium', appearance: appearance = 'brand', label: label = 'Trello', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $24d0e9af25866402$var$svg,
        customThemeSvg: $24d0e9af25866402$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["TrelloIcon"] = $24d0e9af25866402$export$4384da9b8b140bf4;

});

parcelRegister("5b9Ab", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kTb7m = parcelRequire("kTb7m");


var $3Xkfu = parcelRequire("3Xkfu");


var $3IBnw = parcelRequire("3IBnw");


var $5ZqQS = parcelRequire("5ZqQS");

const $8753b7baffe8fa69$var$getUrlOrigin = (url)=>{
    try {
        return new URL(url).origin;
    } catch  {
        return url;
    }
};
const $8753b7baffe8fa69$var$isUrlLabelTuple = (icon)=>Array.isArray(icon) && typeof icon[0] === 'string';
const $8753b7baffe8fa69$var$normalizeInlineIcon = (source, inlineIcon, label)=>{
    if (typeof inlineIcon === 'string') return {
        src: inlineIcon,
        key: `url:${$8753b7baffe8fa69$var$getUrlOrigin(source.url)}:${inlineIcon}`,
        label: label,
        kind: 'image'
    };
    if ($8753b7baffe8fa69$var$isUrlLabelTuple(inlineIcon)) {
        const [iconUrl, iconLabel] = inlineIcon;
        return {
            src: iconUrl,
            key: `url:${$8753b7baffe8fa69$var$getUrlOrigin(source.url)}:${iconUrl}`,
            label: iconLabel ?? label,
            kind: 'image'
        };
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(inlineIcon)) return {
        node: inlineIcon,
        key: `node:${source.product ?? $8753b7baffe8fa69$var$getUrlOrigin(source.url)}:${source.ari ?? source.occurrenceIndex}`,
        label: label ?? source.product,
        kind: 'element'
    };
    return undefined;
};
// extractSmartLinkInlineIcon throws on malformed JSON-LD (e.g. a string `generator`, or an entity
// `meta.generator` missing name/icon). Fall back to a neutral link icon so one bad response doesn't
// break icon building for the whole byline — mirrors the failed-image fallback in SmartLinkIconRenderer.
const $8753b7baffe8fa69$var$createFallbackIcon = (source)=>({
        node: (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
            label: '',
            color: "var(--ds-icon-subtle, #505258)"
        }),
        key: `fallback:${$8753b7baffe8fa69$var$getUrlOrigin(source.url)}:${source.ari ?? source.occurrenceIndex}`,
        label: source.product,
        kind: 'element'
    });
const $8753b7baffe8fa69$export$d1801a90e60dadcf = (url, source)=>$8753b7baffe8fa69$var$normalizeInlineIcon(source, url, source.product);
const $8753b7baffe8fa69$export$35040aed9264b11c = (response, source)=>{
    let inlineIcon;
    try {
        inlineIcon = (0, $3Xkfu.extractSmartLinkInlineIcon)(response ?? undefined, false);
    } catch (err) {
        const errorObj = err instanceof Error ? err : new Error(String(err));
        (0, $5ZqQS.getMonitoringClient)().submitError(errorObj, {
            attribution: (0, $3IBnw.Attribution).INTEGRATIONS
        });
        return $8753b7baffe8fa69$var$createFallbackIcon(source);
    }
    return $8753b7baffe8fa69$var$normalizeInlineIcon(source, inlineIcon, source.product);
};
const $8753b7baffe8fa69$export$1d1e77a71ad0be9f = (link)=>{
    // Keep iconUrl as a compatibility fallback for EnhancedSmartLink objects built before icon normalization.
    return link.icon ?? (link.iconUrl ? $8753b7baffe8fa69$var$normalizeInlineIcon(link, link.iconUrl, link.product) : undefined);
};
module.exports["buildImageIcon"] = $8753b7baffe8fa69$export$d1801a90e60dadcf;
module.exports["extractSmartLinkIcon"] = $8753b7baffe8fa69$export$35040aed9264b11c;
module.exports["getSmartLinkIcon"] = $8753b7baffe8fa69$export$1d1e77a71ad0be9f;

});

parcelRegister("3Xkfu", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kkFbH = parcelRequire("kkFbH");


var $fBqzD = parcelRequire("fBqzD");


var $iMQz5 = parcelRequire("iMQz5");


var $fHe6f = parcelRequire("fHe6f");


var $ahlZa = parcelRequire("ahlZa");


var $3CYX0 = parcelRequire("3CYX0");


var $39Mwn = parcelRequire("39Mwn");


var $6MsAF = parcelRequire("6MsAF");


var $38zdI = parcelRequire("38zdI");


var $cVpj0 = parcelRequire("cVpj0");


var $gITbz = parcelRequire("gITbz");


var $bvjEB = parcelRequire("bvjEB");


var $jMFOf = parcelRequire("jMFOf");


var $a5G9M = parcelRequire("a5G9M");


var $S7fVP = parcelRequire("S7fVP");


var $hhrxw = parcelRequire("hhrxw");


var $kku4L = parcelRequire("kku4L");


var $g0csk = parcelRequire("g0csk");


var $2A177 = parcelRequire("2A177");


var $2GG3F = parcelRequire("2GG3F");


var $jrSlu = parcelRequire("jrSlu");


var $c1Kdq = parcelRequire("c1Kdq");


var $kAdyG = parcelRequire("kAdyG");

const $f1ce3764841d3d06$var$extractorPriorityMap = {
    Object: 0,
    Document: 5,
    'schema:TextDigitalDocument': 10,
    'schema:DigitalDocument': 10,
    'schema:BlogPosting': 10,
    'schema:SpreadsheetDigitalDocument': 10,
    'schema:PresentationDigitalDocument': 10,
    'atlassian:Goal': 10,
    'atlassian:Task': 10,
    'atlassian:Project': 10,
    'atlassian:Template': 10,
    'atlassian:SourceCodeCommit': 10,
    'atlassian:SourceCodeRepository': 10,
    'atlassian:SourceCodePullRequest': 10,
    'atlassian:SourceCodeReference': 10,
    'atlassian:UndefinedLink': 10
};
const $f1ce3764841d3d06$var$emptyData = {
    '@context': {
        '@vocab': 'https://www.w3.org/ns/activitystreams#',
        atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
        schema: 'http://schema.org/'
    },
    '@type': 'Object'
};
const $f1ce3764841d3d06$var$getEmptyJsonLd = ()=>$f1ce3764841d3d06$var$emptyData;
const $f1ce3764841d3d06$var$prioritiseIcon = ({ fileFormatIcon: fileFormatIcon, documentTypeIcon: documentTypeIcon, urlIcon: urlIcon, providerIcon: providerIcon })=>urlIcon || fileFormatIcon || documentTypeIcon || providerIcon;
const $f1ce3764841d3d06$var$extractTaskType = (jsonLd)=>{
    const taskType = jsonLd['atlassian:taskType'] || jsonLd.taskType;
    if (taskType) {
        if (typeof taskType === 'string') return {
            id: taskType
        };
        else if (taskType['@type'] === 'Link') return {
            id: taskType.href
        };
        else return {
            id: taskType['@id'],
            name: taskType.name,
            icon: taskType.icon && (0, $2GG3F.extractUrlFromIconJsonLd)(taskType.icon)
        };
    }
};
const $f1ce3764841d3d06$var$extractFileFormat = (jsonLd)=>jsonLd['schema:fileFormat'];

const $f1ce3764841d3d06$var$getBlogIconWrapped = ()=>(parcelRequire("6kJW0")).default;

const $f1ce3764841d3d06$var$getDocumentIcon = ()=>(parcelRequire("9v3GN")).default;

const $f1ce3764841d3d06$var$getFileIcon = ()=>(parcelRequire("4Emmj")).default;

const $f1ce3764841d3d06$var$getLiveDocumentIconWrapped = ()=>(parcelRequire("dGdE6")).default;

const $f1ce3764841d3d06$var$getPresentationIcon = ()=>(parcelRequire("b5Dss")).default;

const $f1ce3764841d3d06$var$getSpreadsheetIcon = ()=>(parcelRequire("7vzLW")).default;
const $f1ce3764841d3d06$var$digitalDocumentToIcon = (opts)=>{
    if (opts.provider?.id && (0, $c1Kdq.isConfluenceGenerator)(opts.provider.id)) {
        const LiveDocumentIconWrapped = $f1ce3764841d3d06$var$getLiveDocumentIconWrapped();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(LiveDocumentIconWrapped, {
            label: opts.showIconLabel ? 'live document' : '',
            testId: "live-doc-icon"
        });
    }
    const FileIcon = $f1ce3764841d3d06$var$getFileIcon();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(FileIcon, {
        label: opts.showIconLabel ? 'file' : '',
        testId: "file-icon"
    });
};
const $f1ce3764841d3d06$var$documentTypeToIcon = (type, opts)=>{
    switch(type){
        case 'schema:BlogPosting':
            {
                const BlogIconWrapped = $f1ce3764841d3d06$var$getBlogIconWrapped();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(BlogIconWrapped, {
                    label: opts.showIconLabel ? 'blog' : '',
                    testId: "blog-icon"
                });
            }
        case 'schema:DigitalDocument':
            return $f1ce3764841d3d06$var$digitalDocumentToIcon(opts);
        case 'schema:TextDigitalDocument':
            {
                const DocumentIcon = $f1ce3764841d3d06$var$getDocumentIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(DocumentIcon, {
                    label: opts.showIconLabel ? 'document' : '',
                    testId: "document-icon"
                });
            }
        case 'schema:PresentationDigitalDocument':
            {
                const PresentationIcon = $f1ce3764841d3d06$var$getPresentationIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PresentationIcon, {
                    label: opts.showIconLabel ? 'presentation' : '',
                    testId: "presentation-icon"
                });
            }
        case 'schema:SpreadsheetDigitalDocument':
            {
                const SpreadsheetIcon = $f1ce3764841d3d06$var$getSpreadsheetIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SpreadsheetIcon, {
                    label: opts.showIconLabel ? 'spreadsheet' : '',
                    testId: "spreadsheet-icon"
                });
            }
        case 'atlassian:Template':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kkFbH))), {
                color: "currentColor",
                label: opts.showIconLabel ? 'template' : '',
                testId: "document-filled-icon"
            });
        case 'atlassian:UndefinedLink':
            {
                const DocumentIcon = $f1ce3764841d3d06$var$getDocumentIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(DocumentIcon, {
                    label: opts.showIconLabel ? 'document' : '',
                    testId: "document-icon"
                });
            }
    }
};
const $f1ce3764841d3d06$var$extractIconFromDocument = (type, opts)=>{
    const iconFromType = $f1ce3764841d3d06$var$documentTypeToIcon(type, opts);
    const iconFromFileFormat = opts.fileFormat ? (0, $jrSlu.getIconForFileType)(opts.fileFormat, opts.showIconLabel) : undefined;
    const iconFromProvider = opts.provider && opts.provider.icon;
    return $f1ce3764841d3d06$var$prioritiseIcon({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
};
const $f1ce3764841d3d06$var$extractIconFromTask = (opts)=>{
    const { taskType: taskType, provider: provider } = opts;
    const defaultIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a5G9M.default), {
        label: "Task",
        testId: "default-task-icon"
    });
    if (provider && provider.id === (0, $hhrxw.JIRA_GENERATOR_ID) && taskType && taskType.id) {
        const taskTypeId = taskType.id;
        const taskTypeName = taskTypeId.split('#').pop();
        switch(taskTypeName){
            case 0, $hhrxw.JIRA_TASK:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a5G9M.default), {
                    label: "Task",
                    testId: "jira-task-icon"
                });
            case 0, $hhrxw.JIRA_SUB_TASK:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jMFOf.default), {
                    label: "Sub-task",
                    testId: "jira-subtask-icon"
                });
            case 0, $hhrxw.JIRA_STORY:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bvjEB.default), {
                    label: "Story",
                    testId: "jira-story-icon"
                });
            case 0, $hhrxw.JIRA_BUG:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fHe6f.default), {
                    label: "Bug",
                    testId: "jira-bug-icon"
                });
            case 0, $hhrxw.JIRA_EPIC:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6MsAF.default), {
                    label: "Epic",
                    testId: "jira-epic-icon"
                });
            case 0, $hhrxw.JIRA_INCIDENT:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $38zdI.default), {
                    label: "Incident",
                    testId: "jira-incident-icon"
                });
            case 0, $hhrxw.JIRA_SERVICE_REQUEST:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $S7fVP.default), {
                    label: "Service request",
                    testId: "jira-service-request-icon"
                });
            case 0, $hhrxw.JIRA_CHANGE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ahlZa.default), {
                    label: "Change",
                    testId: "jira-change-icon"
                });
            case 0, $hhrxw.JIRA_PROBLEM:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cVpj0.default), {
                    label: "Problem",
                    testId: "jira-problem-icon"
                });
            case 0, $hhrxw.JIRA_CUSTOM_TASK_TYPE:
                return taskType.icon || opts.icon || provider.icon || defaultIcon;
        }
    }
    return defaultIcon;
};
const $f1ce3764841d3d06$var$typeToIcon = (type, opts)=>{
    switch(type){
        case 'atlassian:SourceCodeCommit':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $39Mwn.default), {
                label: "commit",
                testId: "commit-icon"
            });
        case 'atlassian:Project':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fBqzD))), {
                label: "project",
                testId: "project-icon",
                color: "currentColor"
            });
        case 'atlassian:SourceCodePullRequest':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gITbz.default), {
                label: "pull request",
                testId: "pull-request-icon"
            });
        case 'atlassian:SourceCodeReference':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMQz5.default), {
                label: "reference",
                testId: "branch-icon"
            });
        case 'atlassian:SourceCodeRepository':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3CYX0.default), {
                label: "repository",
                testId: "repo-icon"
            });
        case 'atlassian:Goal':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a5G9M.default), {
                label: "goal",
                testId: "task-icon"
            });
        case 'atlassian:Task':
            return $f1ce3764841d3d06$var$extractIconFromTask(opts);
        default:
            return undefined;
    }
};
const $f1ce3764841d3d06$var$standardisedExtractIcon = (type, opts)=>{
    const iconFromType = $f1ce3764841d3d06$var$typeToIcon(type, opts);
    const iconFromFileFormat = opts.fileFormat ? (0, $jrSlu.getIconForFileType)(opts.fileFormat, opts.showIconLabel) : undefined;
    const iconFromProvider = opts.provider && opts.provider.icon;
    return $f1ce3764841d3d06$var$prioritiseIcon({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
};
const $f1ce3764841d3d06$var$extractIconByType = (type, opts)=>{
    switch(type){
        case 'Document':
        case 'schema:BlogPosting':
        case 'schema:DigitalDocument':
        case 'schema:TextDigitalDocument':
        case 'schema:PresentationDigitalDocument':
        case 'schema:SpreadsheetDigitalDocument':
        case 'atlassian:Template':
        case 'atlassian:UndefinedLink':
            return $f1ce3764841d3d06$var$extractIconFromDocument(type, opts);
        default:
            return type ? $f1ce3764841d3d06$var$standardisedExtractIcon(type, opts) : undefined;
    }
};
const $f1ce3764841d3d06$var$extractIcon = (jsonLd, priority = 'type', showIconLabel = true)=>{
    const type = jsonLd['@type'];
    const opts = {
        provider: (0, $2A177.extractProvider)(jsonLd),
        fileFormat: $f1ce3764841d3d06$var$extractFileFormat(jsonLd),
        taskType: $f1ce3764841d3d06$var$extractTaskType(jsonLd),
        icon: jsonLd.icon && (0, $2GG3F.extractUrlFromIconJsonLd)(jsonLd.icon),
        priority: priority,
        showIconLabel: showIconLabel
    };
    if (Array.isArray(type)) {
        const highestPriorityType = type.sort((a, b)=>$f1ce3764841d3d06$var$extractorPriorityMap[b] - $f1ce3764841d3d06$var$extractorPriorityMap[a])[0];
        return $f1ce3764841d3d06$var$extractIconByType(highestPriorityType, opts);
    } else return $f1ce3764841d3d06$var$extractIconByType(type, opts);
};
const $f1ce3764841d3d06$var$extractInlineIcon = (jsonLd, showIconLabel = true)=>{
    const provider = (0, $2A177.extractProvider)(jsonLd);
    if (provider && provider.id) {
        if (provider.id === (0, $hhrxw.CONFLUENCE_GENERATOR_ID) || provider.id === (0, $hhrxw.JIRA_GENERATOR_ID)) return $f1ce3764841d3d06$var$extractIcon(jsonLd, 'type', showIconLabel);
    }
    return $f1ce3764841d3d06$var$extractIcon(jsonLd, 'provider', showIconLabel);
};
const $f1ce3764841d3d06$export$643db2ee2409e635 = (response, showLabel = true)=>{
    if ((0, $kAdyG.isEntityPresent)(response)) {
        const entityIcon = (0, $kku4L.extractEntityIcon)(response);
        if (entityIcon) return [
            entityIcon.url,
            entityIcon.label
        ];
        const provider = (0, $g0csk.extractEntityProvider)(response);
        if (provider) return provider.icon;
    }
    return $f1ce3764841d3d06$var$extractInlineIcon(response?.data || $f1ce3764841d3d06$var$getEmptyJsonLd(), showLabel);
};
module.exports["extractSmartLinkInlineIcon"] = $f1ce3764841d3d06$export$643db2ee2409e635;

});

parcelRegister("iMQz5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $gIfnJ = parcelRequire("gIfnJ");


var $4hmAW = parcelRequire("4hmAW");

const $6e22e7dea691eafe$var$BranchObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BranchObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Branch" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gIfnJ))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function BranchObject({ label: label = 'Branch', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gIfnJ))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $6e22e7dea691eafe$export$2e2bcd8739ae039 = $6e22e7dea691eafe$var$BranchObject;
module.exports["default"] = $6e22e7dea691eafe$export$2e2bcd8739ae039;

});

parcelRegister("fHe6f", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $6spAz = parcelRequire("6spAz");


var $4hmAW = parcelRequire("4hmAW");

const $344e992330cc90e5$var$BugObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BugObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Bug" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6spAz))),
            color: "var(--ds-icon-accent-red, #C9372C)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function BugObject({ label: label = 'Bug', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6spAz))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
};
var $344e992330cc90e5$export$2e2bcd8739ae039 = $344e992330cc90e5$var$BugObject;
module.exports["default"] = $344e992330cc90e5$export$2e2bcd8739ae039;

});

parcelRegister("ahlZa", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $lCTy3 = parcelRequire("lCTy3");


var $4hmAW = parcelRequire("4hmAW");

const $4e5aedb3fb5b2488$var$ChangesObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ChangesObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Changes" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lCTy3))),
            color: "var(--ds-icon-accent-yellow, #B38600)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function ChangesObject({ label: label = 'Changes', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lCTy3))),
        color: "var(--ds-icon-accent-yellow, #B38600)"
    });
};
var $4e5aedb3fb5b2488$export$2e2bcd8739ae039 = $4e5aedb3fb5b2488$var$ChangesObject;
module.exports["default"] = $4e5aedb3fb5b2488$export$2e2bcd8739ae039;

});

parcelRegister("3CYX0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $6YkHb = parcelRequire("6YkHb");


var $4hmAW = parcelRequire("4hmAW");

const $ff9912959f94fce6$var$CodeObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CodeObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Code" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6YkHb))),
            color: "var(--ds-icon-accent-purple, #AF59E1)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function CodeObject({ label: label = 'Code', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6YkHb))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
};
var $ff9912959f94fce6$export$2e2bcd8739ae039 = $ff9912959f94fce6$var$CodeObject;
module.exports["default"] = $ff9912959f94fce6$export$2e2bcd8739ae039;

});

parcelRegister("39Mwn", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $lepke = parcelRequire("lepke");


var $4hmAW = parcelRequire("4hmAW");

const $29a7acb65f94e0ba$var$CommitObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CommitObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Commit" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lepke))),
            color: "var(--ds-icon-accent-yellow, #B38600)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function CommitObject({ label: label = 'Commit', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lepke))),
        color: "var(--ds-icon-accent-yellow, #B38600)"
    });
};
var $29a7acb65f94e0ba$export$2e2bcd8739ae039 = $29a7acb65f94e0ba$var$CommitObject;
module.exports["default"] = $29a7acb65f94e0ba$export$2e2bcd8739ae039;

});

parcelRegister("6MsAF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $7vAVv = parcelRequire("7vAVv");


var $4hmAW = parcelRequire("4hmAW");

const $caa0390e0439cdc5$var$EpicObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function EpicObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Epic" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7vAVv))),
            color: "var(--ds-icon-accent-purple, #AF59E1)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function EpicObject({ label: label = 'Epic', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7vAVv))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
};
var $caa0390e0439cdc5$export$2e2bcd8739ae039 = $caa0390e0439cdc5$var$EpicObject;
module.exports["default"] = $caa0390e0439cdc5$export$2e2bcd8739ae039;

});

parcelRegister("38zdI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $ipvL3 = parcelRequire("ipvL3");


var $4hmAW = parcelRequire("4hmAW");

const $021e642953ecdf56$var$IncidentObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function IncidentObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Incident" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($ipvL3))),
            color: "var(--ds-icon-accent-red, #C9372C)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function IncidentObject({ label: label = 'Incident', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ipvL3))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
};
var $021e642953ecdf56$export$2e2bcd8739ae039 = $021e642953ecdf56$var$IncidentObject;
module.exports["default"] = $021e642953ecdf56$export$2e2bcd8739ae039;

});

parcelRegister("cVpj0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $7EFpK = parcelRequire("7EFpK");


var $4hmAW = parcelRequire("4hmAW");

const $c45be7d7373a5bd1$var$ProblemObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ProblemObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Problem" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7EFpK))),
            color: "var(--ds-icon-accent-red, #C9372C)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function ProblemObject({ label: label = 'Problem', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7EFpK))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
};
var $c45be7d7373a5bd1$export$2e2bcd8739ae039 = $c45be7d7373a5bd1$var$ProblemObject;
module.exports["default"] = $c45be7d7373a5bd1$export$2e2bcd8739ae039;

});

parcelRegister("gITbz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hQhpy = parcelRequire("hQhpy");


var $4hmAW = parcelRequire("4hmAW");

const $d9b76c60fcca1e74$var$PullRequestObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PullRequestObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Pull Request" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hQhpy))),
            color: "var(--ds-icon-accent-green, #22A06B)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function PullRequestObject({ label: label = 'Pull Request', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hQhpy))),
        color: "var(--ds-icon-accent-green, #22A06B)"
    });
};
var $d9b76c60fcca1e74$export$2e2bcd8739ae039 = $d9b76c60fcca1e74$var$PullRequestObject;
module.exports["default"] = $d9b76c60fcca1e74$export$2e2bcd8739ae039;

});

parcelRegister("bvjEB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $jrU5N = parcelRequire("jrU5N");


var $4hmAW = parcelRequire("4hmAW");

const $1e23ddd70a37a65a$var$StoryObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function StoryObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Story" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($jrU5N))),
            color: "var(--ds-icon-accent-green, #22A06B)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function StoryObject({ label: label = 'Story', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jrU5N))),
        color: "var(--ds-icon-accent-green, #22A06B)"
    });
};
var $1e23ddd70a37a65a$export$2e2bcd8739ae039 = $1e23ddd70a37a65a$var$StoryObject;
module.exports["default"] = $1e23ddd70a37a65a$export$2e2bcd8739ae039;

});

parcelRegister("jMFOf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $lSw2p = parcelRequire("lSw2p");


var $4hmAW = parcelRequire("4hmAW");

const $08adce465a629da4$var$SubtaskObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SubtaskObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Subtask" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lSw2p))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function SubtaskObject({ label: label = 'Subtask', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lSw2p))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $08adce465a629da4$export$2e2bcd8739ae039 = $08adce465a629da4$var$SubtaskObject;
module.exports["default"] = $08adce465a629da4$export$2e2bcd8739ae039;

});

parcelRegister("a5G9M", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $iAaYd = parcelRequire("iAaYd");


var $4hmAW = parcelRequire("4hmAW");

const $dcf12dc0efc2d892$var$TaskObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TaskObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Task" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iAaYd))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function TaskObject({ label: label = 'Task', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iAaYd))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $dcf12dc0efc2d892$export$2e2bcd8739ae039 = $dcf12dc0efc2d892$var$TaskObject;
module.exports["default"] = $dcf12dc0efc2d892$export$2e2bcd8739ae039;

});

parcelRegister("S7fVP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $iRFKG = parcelRequire("iRFKG");


var $4hmAW = parcelRequire("4hmAW");

const $ae65607ca2739f04$var$WorkItemObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function WorkItemObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Work Item" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function WorkItemObject({ label: label = 'Work Item', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $ae65607ca2739f04$export$2e2bcd8739ae039 = $ae65607ca2739f04$var$WorkItemObject;
module.exports["default"] = $ae65607ca2739f04$export$2e2bcd8739ae039;

});

parcelRegister("jrSlu", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4wH3g = parcelRequire("4wH3g");


var $hhrxw = parcelRequire("hhrxw");


var $l8WFq = parcelRequire("l8WFq");























const $73d439951cf388f8$var$getLazyIcons = ()=>({
        [(0, $hhrxw.IconType).Document]: {
            default: ()=>Promise.resolve((parcelRequire("9v3GN")))
        },
        [(0, $hhrxw.IconType).Audio]: {
            default: ()=>(parcelRequire("kPWC0"))
        },
        [(0, $hhrxw.IconType).Code]: {
            default: ()=>(parcelRequire("7nVQ2"))
        },
        [(0, $hhrxw.IconType).File]: {
            default: ()=>Promise.resolve((parcelRequire("4Emmj")))
        },
        [(0, $hhrxw.IconType).Folder]: {
            default: ()=>(parcelRequire("9VLzs"))
        },
        [(0, $hhrxw.IconType).Generic]: {
            default: ()=>Promise.resolve((parcelRequire("4Emmj")))
        },
        [(0, $hhrxw.IconType).Image]: {
            default: ()=>(parcelRequire("j9LJx"))
        },
        [(0, $hhrxw.IconType).Presentation]: {
            default: ()=>Promise.resolve((parcelRequire("b5Dss")))
        },
        [(0, $hhrxw.IconType).Spreadsheet]: {
            default: ()=>Promise.resolve((parcelRequire("7vzLW")))
        },
        [(0, $hhrxw.IconType).Video]: {
            default: ()=>(parcelRequire("96zb4"))
        },
        [(0, $hhrxw.IconType).Archive]: {
            default: ()=>(parcelRequire("8KvsV"))
        },
        [(0, $hhrxw.IconType).Executable]: {
            default: ()=>(parcelRequire("kKj89"))
        },
        [(0, $hhrxw.IconType).GIF]: {
            default: ()=>(parcelRequire("1N5Ke"))
        },
        [(0, $hhrxw.IconType).GoogleDocs]: {
            default: ()=>(parcelRequire("7KlQ2"))
        },
        [(0, $hhrxw.IconType).GoogleForms]: {
            default: ()=>(parcelRequire("4D6tQ"))
        },
        [(0, $hhrxw.IconType).GoogleSheets]: {
            default: ()=>(parcelRequire("30pMN"))
        },
        [(0, $hhrxw.IconType).GoogleSlides]: {
            default: ()=>(parcelRequire("hbVly"))
        },
        [(0, $hhrxw.IconType).MSExcel]: {
            default: ()=>(parcelRequire("5eRas"))
        },
        [(0, $hhrxw.IconType).MSPowerpoint]: {
            default: ()=>(parcelRequire("bmQsw"))
        },
        [(0, $hhrxw.IconType).MSWord]: {
            default: ()=>(parcelRequire("3tCrI"))
        },
        [(0, $hhrxw.IconType).PDF]: {
            default: ()=>(parcelRequire("eiZGU"))
        },
        [(0, $hhrxw.IconType).Sketch]: {
            default: ()=>(parcelRequire("ldRXm"))
        }
    });
const $73d439951cf388f8$var$getTypeToIconMap = (fileFormat)=>{
    const iconDescriptor = (0, $l8WFq.default)(fileFormat);
    if (!iconDescriptor?.icon) return null;
    const lazyIcons = $73d439951cf388f8$var$getLazyIcons();
    return [
        lazyIcons[iconDescriptor.icon]?.default,
        iconDescriptor.label ?? ''
    ];
};
const $73d439951cf388f8$export$4d685c85ebc7a1e3 = (fileMimeType, showIconLabel)=>{
    if (!fileMimeType) return;
    const icon = $73d439951cf388f8$var$getTypeToIconMap(fileMimeType.toLowerCase());
    if (!icon) return;
    const [importCb] = icon;
    if (!importCb) return;
    const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
        __loadable_id__: "hbd6r",
        name: "Icon",
        loader: ()=>importCb().then((module)=>module.default),
        loading: ()=>null
    });
    const descriptorLabel = icon[1] || '';
    const label = showIconLabel ?? true ? descriptorLabel : '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
        testId: "document-file-format-icon",
        label: label
    });
};
module.exports["getIconForFileType"] = $73d439951cf388f8$export$4d685c85ebc7a1e3;

});

parcelRegister("l8WFq", function(module, exports) {

var $hhrxw = parcelRequire("hhrxw");

const $eb169b73453c71b7$var$extractFileFormatIcon = (fileFormat)=>{
    const getIconDescriptor = (icon, label)=>({
            icon: icon,
            label: label
        });
    switch(fileFormat){
        case 'folder':
            return getIconDescriptor((0, $hhrxw.IconType).Folder, 'folder');
        case 'text/plain':
        case 'application/vnd.oasis.opendocument.text':
        case 'application/vnd.apple.pages':
            return getIconDescriptor((0, $hhrxw.IconType).Document, 'document');
        case 'application/pdf':
            return getIconDescriptor((0, $hhrxw.IconType).PDF, 'pdf');
        case 'application/vnd.oasis.opendocument.presentation':
        case 'application/vnd.apple.keynote':
            return getIconDescriptor((0, $hhrxw.IconType).Presentation, 'presentation');
        case 'application/vnd.oasis.opendocument.spreadsheet':
        case 'application/vnd.apple.numbers':
            return getIconDescriptor((0, $hhrxw.IconType).Spreadsheet, 'spreadsheet');
        case 'application/vnd.google-apps.document':
            return getIconDescriptor((0, $hhrxw.IconType).GoogleDocs, 'google document');
        case 'application/vnd.google-apps.form':
            return getIconDescriptor((0, $hhrxw.IconType).GoogleForms, 'google form');
        case 'application/vnd.google-apps.spreadsheet':
            return getIconDescriptor((0, $hhrxw.IconType).GoogleSheets, 'google sheet');
        case 'application/vnd.google-apps.presentation':
            return getIconDescriptor((0, $hhrxw.IconType).GoogleSlides, 'google slide');
        case 'application/vnd.ms-excel':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return getIconDescriptor((0, $hhrxw.IconType).MSExcel, 'excel spreadsheet');
        case 'application/vnd.ms-powerpoint':
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
            return getIconDescriptor((0, $hhrxw.IconType).MSPowerpoint, 'powerpoint');
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            return getIconDescriptor((0, $hhrxw.IconType).MSWord, 'word document');
        case 'image/png':
        case 'image/jpeg':
        case 'image/bmp':
        case 'image/webp':
        case 'image/svg+xml':
            return getIconDescriptor((0, $hhrxw.IconType).Image, 'image');
        case 'image/gif':
            return getIconDescriptor((0, $hhrxw.IconType).GIF, 'gif');
        case 'audio/midi':
        case 'audio/mpeg':
        case 'audio/webm':
        case 'audio/ogg':
        case 'audio/wav':
            return getIconDescriptor((0, $hhrxw.IconType).Audio, 'audio');
        case 'video/mp4':
        case 'video/quicktime':
        case 'video/mov':
        case 'video/webm':
        case 'video/ogg':
        case 'video/x-ms-wmv':
        case 'video/x-msvideo':
            return getIconDescriptor((0, $hhrxw.IconType).Video, 'video');
        case 'text/css':
        case 'text/html':
        case 'application/javascript':
            return getIconDescriptor((0, $hhrxw.IconType).Code, 'code');
        case 'application/zip':
        case 'application/x-tar':
        case 'application/x-gtar':
        case 'application/x-7z-compressed':
        case 'application/x-apple-diskimage':
        case 'application/vnd.rar':
            return getIconDescriptor((0, $hhrxw.IconType).Archive, 'archive');
        case 'application/dmg':
            return getIconDescriptor((0, $hhrxw.IconType).Executable, 'disk image');
        case 'application/sketch':
            return getIconDescriptor((0, $hhrxw.IconType).Sketch, 'sketch');
        case 'application/octet-stream':
        case 'application/invision.prototype':
            return getIconDescriptor((0, $hhrxw.IconType).Generic, 'file');
        default:
            return undefined;
    }
};
var $eb169b73453c71b7$export$2e2bcd8739ae039 = $eb169b73453c71b7$var$extractFileFormatIcon;
module.exports["default"] = $eb169b73453c71b7$export$2e2bcd8739ae039;

});

parcelRegister("kPWC0", function(module, exports) {

let $f2b60935c73a6c05$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f2b60935c73a6c05$var$load("gkVge"),
    $f2b60935c73a6c05$var$load("hLbGw")
]).then(()=>parcelRequire('hyaPI'));

});

parcelRegister("7nVQ2", function(module, exports) {

let $56078bdb4bba4b6f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $56078bdb4bba4b6f$var$load("kDfOJ").then(()=>parcelRequire('gMML3'));

});

parcelRegister("9VLzs", function(module, exports) {

let $73ae5688c13ac7f1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $73ae5688c13ac7f1$var$load("6wr18"),
    $73ae5688c13ac7f1$var$load("ffEVr"),
    $73ae5688c13ac7f1$var$load("iN2uJ")
]).then(()=>parcelRequire('giuMD'));

});

parcelRegister("j9LJx", function(module, exports) {

let $df23e277716dc04b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $df23e277716dc04b$var$load("6wr18"),
    $df23e277716dc04b$var$load("ffEVr"),
    $df23e277716dc04b$var$load("6aZeI")
]).then(()=>parcelRequire('4b38C'));

});

parcelRegister("96zb4", function(module, exports) {

let $6a0ff61f5e39486f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6a0ff61f5e39486f$var$load("6wr18"),
    $6a0ff61f5e39486f$var$load("ffEVr"),
    $6a0ff61f5e39486f$var$load("8TGE7")
]).then(()=>parcelRequire('8aT6O'));

});

parcelRegister("8KvsV", function(module, exports) {

let $65eb06ff5571b2cc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $65eb06ff5571b2cc$var$load("5JWJI").then(()=>parcelRequire('iqehY'));

});

parcelRegister("kKj89", function(module, exports) {

let $f1a6f16f6403b629$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f1a6f16f6403b629$var$load("aQ5uu").then(()=>parcelRequire('3OVVx'));

});

parcelRegister("1N5Ke", function(module, exports) {

let $14ded2ce3ce05390$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $14ded2ce3ce05390$var$load("geXPZ").then(()=>parcelRequire('EhIdb'));

});

parcelRegister("7KlQ2", function(module, exports) {

let $5a3dc4e9d091ba35$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5a3dc4e9d091ba35$var$load("b4nm1").then(()=>parcelRequire('hmd8r'));

});

parcelRegister("4D6tQ", function(module, exports) {

let $35efd4ccf002d2a8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $35efd4ccf002d2a8$var$load("jfYeU").then(()=>parcelRequire('lLxTI'));

});

parcelRegister("30pMN", function(module, exports) {

let $23055fbb4908668b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $23055fbb4908668b$var$load("kYkz1").then(()=>parcelRequire('kUQwC'));

});

parcelRegister("hbVly", function(module, exports) {

let $c83ff29c592bd62f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c83ff29c592bd62f$var$load("5kI0b").then(()=>parcelRequire('1G3Dq'));

});

parcelRegister("5eRas", function(module, exports) {

let $3d078090de5174e1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3d078090de5174e1$var$load("3i44s").then(()=>parcelRequire('1kVaD'));

});

parcelRegister("bmQsw", function(module, exports) {

let $846a710eb4b35adb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $846a710eb4b35adb$var$load("4QwAJ").then(()=>parcelRequire('aeJll'));

});

parcelRegister("3tCrI", function(module, exports) {

let $2881e71a7d44971f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2881e71a7d44971f$var$load("fHlIz").then(()=>parcelRequire('8If3N'));

});

parcelRegister("eiZGU", function(module, exports) {

let $a6a299b1e4e47c5f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a6a299b1e4e47c5f$var$load("aaRXj").then(()=>parcelRequire('8B1YK'));

});

parcelRegister("ldRXm", function(module, exports) {

let $f734aa7c232eacf4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f734aa7c232eacf4$var$load("6OMo6").then(()=>parcelRequire('AzmWu'));

});

parcelRegister("c1Kdq", function(module, exports) {

var $hhrxw = parcelRequire("hhrxw");

const $b2f43b4ca89bcf94$export$38df542ff03a4183 = (id)=>{
    return id === (0, $hhrxw.CONFLUENCE_GENERATOR_ID);
};
module.exports["isConfluenceGenerator"] = $b2f43b4ca89bcf94$export$38df542ff03a4183;

});

parcelRegister("6kJW0", function(module, exports) {

var $iW3KC = parcelRequire("iW3KC");


var $ai0Ge = parcelRequire("ai0Ge");


var $eqhrF = parcelRequire("eqhrF");

// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $616e4ede6f48d352$var$BlogIconWithColor = (0, $eqhrF.renderIconPerSize)((0, $iW3KC.default), (0, $ai0Ge.default));
$616e4ede6f48d352$var$BlogIconWithColor.displayName = 'BlogIconWithColor';
var $616e4ede6f48d352$export$2e2bcd8739ae039 = $616e4ede6f48d352$var$BlogIconWithColor;
module.exports["default"] = $616e4ede6f48d352$export$2e2bcd8739ae039;

});

parcelRegister("ai0Ge", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $d4GYd = parcelRequire("d4GYd");


var $gEyoZ = parcelRequire("gEyoZ");

const $36820b590bf4d8fd$var$BlogObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BlogObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Blog" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($d4GYd))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function BlogObjectTile({ label: label = 'Blog', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d4GYd))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $36820b590bf4d8fd$export$2e2bcd8739ae039 = $36820b590bf4d8fd$var$BlogObjectTile;
module.exports["default"] = $36820b590bf4d8fd$export$2e2bcd8739ae039;

});

parcelRegister("gEyoZ", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $bB0i2 = parcelRequire("bB0i2");


var $9NPFC = parcelRequire("9NPFC");

/**
 * __Object tile base__
 *
 * An object tile represents an Atlassian-specific content type.
 *
 */ const $e64fa8a7fc69b505$var$ObjectTileBase = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ObjectTileBase(t0) {
    const $ = (0, $bDgLe.c)(9);
    const { label: t1, size: t2, testId: testId, color: color, backgroundColor: backgroundColor, icon: Icon } = t0;
    const label = t1 === undefined ? "" : t1;
    const size = t2 === undefined ? "medium" : t2;
    const validSizes = [
        "xsmall",
        "small",
        "medium",
        "large",
        "xlarge"
    ];
    (0, $bB0i2.default)(validSizes.includes(size), `ObjectTile: size "${size}" is not valid. Valid sizes are: ${validSizes.join(", ")}`);
    let t3;
    if ($[0] !== Icon || $[1] !== color || $[2] !== label || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
            label: label,
            color: color,
            testId: testId,
            shouldScale: true
        });
        $[0] = Icon;
        $[1] = color;
        $[2] = label;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== backgroundColor || $[6] !== size || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9NPFC.default), {
            label: "",
            backgroundColor: backgroundColor,
            size: size,
            children: t3
        });
        $[5] = backgroundColor;
        $[6] = size;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
} : function ObjectTileBase({ label: label = '', size: size = 'medium', testId: testId, color: color, backgroundColor: backgroundColor, icon: Icon }) {
    // Validate that size is a valid `ObjectTileSize` (and won't allow Tile's `xxsmall` size to be passed)
    const validSizes = [
        'xsmall',
        'small',
        'medium',
        'large',
        'xlarge'
    ];
    (0, $bB0i2.default)(validSizes.includes(size), `ObjectTile: size "${size}" is not valid. Valid sizes are: ${validSizes.join(', ')}`);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9NPFC.default), {
        label: "",
        backgroundColor: backgroundColor,
        size: size,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
            label: label,
            color: color,
            testId: testId,
            // @ts-expect-error - Internal, undocumented prop
            shouldScale: true
        })
    });
};
var $e64fa8a7fc69b505$export$2e2bcd8739ae039 = $e64fa8a7fc69b505$var$ObjectTileBase;
module.exports["default"] = $e64fa8a7fc69b505$export$2e2bcd8739ae039;

});

parcelRegister("9NPFC", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


const $60cc37ad75899268$var$tileSizePx = {
    xxsmall: 16,
    xsmall: 20,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 48
};
const $60cc37ad75899268$var$styles = {
    root: "_0bjKvD0O7w _4bt5LAnQyn _2WAcuGnQyn _1mT5xdRAKS _3iDTPbccYA _24h04i2Njc _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC _2O5VijdnbC _4ouGXIdnbC _4kiQYAdnbC _1RrJLit2nV",
    border: "_2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67",
    inset: "_3B3jB1IZbP _0LETLXIZbP _4ACwSfIZbP _2Qxi4nIZbP",
    nonInset: "_49oNbqN91d _1tJeXfN91d _0VARMJN91d _27VeLCN91d _3B3jB1N91d _0LETLXN91d _4ACwSfN91d _2Qxi4nN91d _3G0Ib8iObl"
};
const $60cc37ad75899268$var$sizeMap = {
    xxsmall: "_39xV02ey7F _0jFU0Vey7F _4ya3eEuFDC",
    xsmall: "_39xV02SPN1 _0jFU0VSPN1 _4ya3eExpxF",
    small: "_39xV02oWWg _0jFU0VoWWg _4ya3eEEbN9",
    medium: "_39xV02Uofl _0jFU0VUofl _4ya3eEey7F",
    large: "_39xV02UF4f _0jFU0VUF4f _4ya3eESPN1",
    xlarge: "_39xV02pJKa _0jFU0VpJKa _4ya3eEoWWg"
};
const $60cc37ad75899268$var$insetSizeMap = {
    xxsmall: "_49oNbquFDC _1tJeXfuFDC _0VARMJuFDC _27VeLCuFDC _0mzAWiNKBH _3woHNtNKBH _430i96NKBH _1GBPVvNKBH",
    xsmall: "_49oNbqxpxF _1tJeXfxpxF _0VARMJxpxF _27VeLCxpxF _0mzAWiqBG1 _3woHNtqBG1 _430i96qBG1 _1GBPVvqBG1",
    small: "_49oNbqEbN9 _1tJeXfEbN9 _0VARMJEbN9 _27VeLCEbN9 _0mzAWif9wp _3woHNtf9wp _430i96f9wp _1GBPVvf9wp",
    medium: "_49oNbqey7F _1tJeXfey7F _0VARMJey7F _27VeLCey7F _0mzAWiIRC9 _3woHNtIRC9 _430i96IRC9 _1GBPVvIRC9",
    large: "_49oNbqSPN1 _1tJeXfSPN1 _0VARMJSPN1 _27VeLCSPN1 _0mzAWiPcut _3woHNtPcut _430i96Pcut _1GBPVvPcut",
    xlarge: "_49oNbqoWWg _1tJeXfoWWg _0VARMJoWWg _27VeLCoWWg _0mzAWiY6u9 _3woHNtY6u9 _430i96Y6u9 _1GBPVvY6u9"
};
const $60cc37ad75899268$var$backgroundColorMap = {
    white: "_0KLXrut28M",
    black: "_0KLXru52mJ",
    transparent: "_0KLXrujOvk",
    'color.background.accent.lime.subtlest': "_0KLXruXL80",
    'color.background.accent.lime.subtler': "_0KLXruuKDS",
    'color.background.accent.lime.subtle': "_0KLXruZcd0",
    'color.background.accent.lime.bolder': "_0KLXrubYhN",
    'color.background.accent.red.subtlest': "_0KLXrusDFP",
    'color.background.accent.red.subtler': "_0KLXrubV9i",
    'color.background.accent.red.subtle': "_0KLXru0cUQ",
    'color.background.accent.red.bolder': "_0KLXruQrW1",
    'color.background.accent.orange.subtlest': "_0KLXru2QQR",
    'color.background.accent.orange.subtler': "_0KLXruwJ86",
    'color.background.accent.orange.subtle': "_0KLXruuwVU",
    'color.background.accent.orange.bolder': "_0KLXrux4f7",
    'color.background.accent.yellow.subtlest': "_0KLXru56u3",
    'color.background.accent.yellow.subtler': "_0KLXruLv9B",
    'color.background.accent.yellow.subtle': "_0KLXruC29w",
    'color.background.accent.yellow.bolder': "_0KLXruYB6L",
    'color.background.accent.green.subtlest': "_0KLXruV6wL",
    'color.background.accent.green.subtler': "_0KLXruNUep",
    'color.background.accent.green.subtle': "_0KLXru50ZN",
    'color.background.accent.green.bolder': "_0KLXrude1t",
    'color.background.accent.teal.subtlest': "_0KLXruuBpz",
    'color.background.accent.teal.subtler': "_0KLXrunfgW",
    'color.background.accent.teal.subtle': "_0KLXrufjGw",
    'color.background.accent.teal.bolder': "_0KLXruzHaB",
    'color.background.accent.blue.subtlest': "_0KLXruVva3",
    'color.background.accent.blue.subtler': "_0KLXrup9dS",
    'color.background.accent.blue.subtle': "_0KLXru28sy",
    'color.background.accent.blue.bolder': "_0KLXrutfbE",
    'color.background.accent.purple.subtlest': "_0KLXruB8KG",
    'color.background.accent.purple.subtler': "_0KLXruWOdT",
    'color.background.accent.purple.subtle': "_0KLXruf89Q",
    'color.background.accent.purple.bolder': "_0KLXruhdss",
    'color.background.accent.magenta.subtlest': "_0KLXru8frT",
    'color.background.accent.magenta.subtler': "_0KLXruXM4x",
    'color.background.accent.magenta.subtle': "_0KLXrupmfs",
    'color.background.accent.magenta.bolder': "_0KLXruxE6Y",
    'color.background.accent.gray.subtlest': "_0KLXrumhAQ",
    'color.background.accent.gray.subtler': "_0KLXruG6qS",
    'color.background.accent.gray.subtle': "_0KLXrueZ10",
    'color.background.accent.gray.bolder': "_0KLXrurxgm",
    'color.background.inverse.subtle': "_0KLXruB4sa",
    'color.background.neutral': "_0KLXruDMqu",
    'color.background.neutral.bold': "_0KLXrugozt",
    'color.background.brand.subtlest': "_0KLXrunl7T",
    'color.background.brand.bold': "_0KLXruDM2k",
    'color.background.brand.boldest': "_0KLXru2o0p",
    'color.background.danger': "_0KLXruhH7k",
    'color.background.danger.bold': "_0KLXruqsXs",
    'color.background.warning': "_0KLXruhxIM",
    'color.background.warning.bold': "_0KLXruKLKE",
    'color.background.success': "_0KLXruzaZe",
    'color.background.success.bold': "_0KLXruhbjP",
    'color.background.discovery': "_0KLXru94rk",
    'color.background.discovery.bold': "_0KLXruqjHC",
    'color.background.information': "_0KLXrugNg3",
    'color.background.information.bold': "_0KLXruASYT"
}; /**
    * __Tile__
    *
    * A tile is a rounded square that takes an asset and represents a noun.
    *
    */ 
const $60cc37ad75899268$var$Tile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Tile(props) {
    const $ = (0, $bDgLe.c)(17);
    const { children: children, label: label, size: t0, backgroundColor: backgroundColor, hasBorder: hasBorder, isInset: t1, testId: testId } = props;
    const size = t0 === undefined ? "medium" : t0;
    const isInset = t1 === undefined ? true : t1;
    const containerRef = (0, $cozmU.useRef)(null);
    let t2;
    if ($[0] !== size) {
        t2 = ()=>{
            return;
        };
        $[0] = size;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== children || $[3] !== size) {
        t3 = [
            children,
            size
        ];
        $[2] = children;
        $[3] = size;
        $[4] = t3;
    } else t3 = $[4];
    (0, $cozmU.useEffect)(t2, t3);
    const t4 = label !== "" ? label : undefined;
    const t5 = label !== "" ? "img" : undefined;
    const t6 = $60cc37ad75899268$var$sizeMap[size];
    const t7 = isInset ? $60cc37ad75899268$var$styles.inset : $60cc37ad75899268$var$styles.nonInset;
    const t8 = isInset && $60cc37ad75899268$var$insetSizeMap[size];
    const t9 = $60cc37ad75899268$var$backgroundColorMap[backgroundColor || "color.background.neutral"];
    const t10 = hasBorder && $60cc37ad75899268$var$styles.border;
    let t11;
    if ($[5] !== t10 || $[6] !== t6 || $[7] !== t7 || $[8] !== t8 || $[9] !== t9) {
        t11 = (0, $hekY6.default)([
            $60cc37ad75899268$var$styles.root,
            t6,
            t7,
            t8,
            t9,
            t10
        ]);
        $[5] = t10;
        $[6] = t6;
        $[7] = t7;
        $[8] = t8;
        $[9] = t9;
        $[10] = t11;
    } else t11 = $[10];
    let t12;
    if ($[11] !== children || $[12] !== t11 || $[13] !== t4 || $[14] !== t5 || $[15] !== testId) {
        t12 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            ref: containerRef,
            "data-testid": testId,
            "aria-label": t4,
            role: t5,
            className: t11,
            children: children
        });
        $[11] = children;
        $[12] = t11;
        $[13] = t4;
        $[14] = t5;
        $[15] = testId;
        $[16] = t12;
    } else t12 = $[16];
    return t12;
} : function Tile(props) {
    const { children: children, label: label, size: size = 'medium', backgroundColor: backgroundColor, hasBorder: hasBorder, isInset: isInset = true, testId: testId } = props;
    const containerRef = (0, $cozmU.useRef)(null); // Dev-mode only: validate that raster images passed into the tile
    // are square and retina-compatible (at least 2x the rendered tile size).
    (0, $cozmU.useEffect)(()=>{
        return;
    }, [
        children,
        size
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        ref: containerRef,
        "data-testid": testId,
        "aria-label": label !== '' ? label : undefined,
        role: label !== '' ? 'img' : undefined,
        className: (0, $hekY6.default)([
            $60cc37ad75899268$var$styles.root,
            $60cc37ad75899268$var$sizeMap[size],
            isInset ? $60cc37ad75899268$var$styles.inset : $60cc37ad75899268$var$styles.nonInset,
            isInset && $60cc37ad75899268$var$insetSizeMap[size],
            $60cc37ad75899268$var$backgroundColorMap[backgroundColor || 'color.background.neutral'],
            hasBorder && $60cc37ad75899268$var$styles.border
        ]),
        children: children
    });
};
var $60cc37ad75899268$export$2e2bcd8739ae039 = $60cc37ad75899268$var$Tile;
function $60cc37ad75899268$var$_temp(fn) {
    return fn();
}
module.exports["default"] = $60cc37ad75899268$export$2e2bcd8739ae039;

});

parcelRegister("eqhrF", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $hhrxw = parcelRequire("hhrxw");

const $ef7997acb045a8f6$var$isIconSizeLarge = (size)=>size && [
        (0, $hhrxw.SmartLinkSize).Large,
        (0, $hhrxw.SmartLinkSize).XLarge
    ].includes(size);
const $ef7997acb045a8f6$export$28dd5ad82647c000 = (ObjectIcon, ObjectTileIcon)=>{
    return ({ size: size, ...props })=>{
        if ($ef7997acb045a8f6$var$isIconSizeLarge(size)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ObjectTileIcon, {
            ...props,
            size: "small"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ObjectIcon, props);
    };
};
module.exports["renderIconPerSize"] = $ef7997acb045a8f6$export$28dd5ad82647c000;

});

parcelRegister("9v3GN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $hMaHH = parcelRequire("hMaHH");


var $9D4WS = parcelRequire("9D4WS");

const $fc0d527adbaaccfa$var$PageIconWithColor = (0, $9D4WS.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))), 'blueBold');
$fc0d527adbaaccfa$var$PageIconWithColor.displayName = 'PageIconWithColor';
var $fc0d527adbaaccfa$export$2e2bcd8739ae039 = $fc0d527adbaaccfa$var$PageIconWithColor;
module.exports["default"] = $fc0d527adbaaccfa$export$2e2bcd8739ae039;

});

parcelRegister("9D4WS", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lSQgn = parcelRequire("lSQgn");


var $6nWVS = parcelRequire("6nWVS");

const $eb6ec3e0096439cb$var$appearanceToStandaloneIconColor = {
    blue: "var(--ds-icon-accent-blue, #357DE8)",
    blueBold: "var(--ds-icon-accent-blue, #357DE8)",
    gray: "var(--ds-icon-accent-gray, #7D818A)",
    grayBold: "var(--ds-icon-accent-gray, #7D818A)",
    green: "var(--ds-icon-accent-green, #22A06B)",
    greenBold: "var(--ds-icon-accent-green, #22A06B)",
    lime: "var(--ds-icon-accent-lime, #6A9A23)",
    limeBold: "var(--ds-icon-accent-lime, #6A9A23)",
    magenta: "var(--ds-icon-accent-magenta, #CD519D)",
    magentaBold: "var(--ds-icon-accent-magenta, #CD519D)",
    orange: "var(--ds-icon-accent-orange, #E06C00)",
    orangeBold: "var(--ds-icon-accent-orange, #E06C00)",
    purple: "var(--ds-icon-accent-purple, #AF59E1)",
    purpleBold: "var(--ds-icon-accent-purple, #AF59E1)",
    red: "var(--ds-icon-accent-red, #C9372C)",
    redBold: "var(--ds-icon-accent-red, #C9372C)",
    teal: "var(--ds-icon-accent-teal, #2898BD)",
    tealBold: "var(--ds-icon-accent-teal, #2898BD)",
    yellow: "var(--ds-icon-accent-yellow, #B38600)",
    yellowBold: "var(--ds-icon-accent-yellow, #B38600)"
};
const $eb6ec3e0096439cb$export$87c3646d0e299cfe = (Icon, appearance)=>{
    return ({ size: size, isTiledIcon: isTiledIcon, ...props })=>{
        const tileSize = (0, $6nWVS.transformSmartLinkSizeToIconTileSize)(size);
        if (tileSize === undefined) {
            const label = props.label ?? '';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                role: label ? 'img' : undefined,
                "aria-label": label || undefined,
                "data-testid": props.testId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
                color: $eb6ec3e0096439cb$var$appearanceToStandaloneIconColor[appearance],
                label: ""
            }));
        }
        const { ...tileProps } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
            appearance: appearance,
            icon: isTiledIcon ? (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
                    ...iconProps,
                    spacing: "spacious"
                }) : Icon,
            size: tileSize,
            ...tileProps
        });
    };
};
module.exports["renderIconTile"] = $eb6ec3e0096439cb$export$87c3646d0e299cfe;

});

parcelRegister("6nWVS", function(module, exports) {

var $hhrxw = parcelRequire("hhrxw");

const $7fb62870d007a2a2$export$3acc3fb10995f020 = (size)=>{
    switch(size){
        case (0, $hhrxw.SmartLinkSize).Small:
        case (0, $hhrxw.SmartLinkSize).Medium:
            return undefined;
        case (0, $hhrxw.SmartLinkSize).XLarge:
        case (0, $hhrxw.SmartLinkSize).Large:
            return 'small';
        default:
            return undefined;
    }
};
module.exports["transformSmartLinkSizeToIconTileSize"] = $7fb62870d007a2a2$export$3acc3fb10995f020;

});

parcelRegister("4Emmj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $kkFbH = parcelRequire("kkFbH");


var $9D4WS = parcelRequire("9D4WS");

const $30795df12c6626e4$var$FileIconWithColor = (0, $9D4WS.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($kkFbH))), 'grayBold');
$30795df12c6626e4$var$FileIconWithColor.displayName = 'FileIconWithColor';
var $30795df12c6626e4$export$2e2bcd8739ae039 = $30795df12c6626e4$var$FileIconWithColor;
module.exports["default"] = $30795df12c6626e4$export$2e2bcd8739ae039;

});

parcelRegister("dGdE6", function(module, exports) {

var $7pJjg = parcelRequire("7pJjg");


var $dipyx = parcelRequire("dipyx");


var $eqhrF = parcelRequire("eqhrF");

// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $c10f705a5270d647$var$LiveDocumentIconWithColor = (0, $eqhrF.renderIconPerSize)((0, $7pJjg.default), (0, $dipyx.default));
$c10f705a5270d647$var$LiveDocumentIconWithColor.displayName = 'LiveDocumentIconWithColor';
var $c10f705a5270d647$export$2e2bcd8739ae039 = $c10f705a5270d647$var$LiveDocumentIconWithColor;
module.exports["default"] = $c10f705a5270d647$export$2e2bcd8739ae039;

});

parcelRegister("7pJjg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $kLlYX = parcelRequire("kLlYX");


var $4hmAW = parcelRequire("4hmAW");

const $5d24b7fd99811061$var$PageLiveDocObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PageLiveDocObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Page Live Doc" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
            color: "var(--ds-icon-accent-magenta, #CD519D)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function PageLiveDocObject({ label: label = 'Page Live Doc', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
        color: "var(--ds-icon-accent-magenta, #CD519D)"
    });
};
var $5d24b7fd99811061$export$2e2bcd8739ae039 = $5d24b7fd99811061$var$PageLiveDocObject;
module.exports["default"] = $5d24b7fd99811061$export$2e2bcd8739ae039;

});

parcelRegister("kLlYX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::80e1615540ac9d82a9937150e7cfa4ab>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f1d93fa86ac2ebd2$var$_react = $f1d93fa86ac2ebd2$var$_interopRequireDefault((parcelRequire("cozmU")));

var $f1d93fa86ac2ebd2$var$_iconNew = $f1d93fa86ac2ebd2$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $f1d93fa86ac2ebd2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/page-live-doc
 * Usage guidance:
 * Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f1d93fa86ac2ebd2$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $f1d93fa86ac2ebd2$var$_react.default.createElement($f1d93fa86ac2ebd2$var$_iconNew.default, Object.assign({
        name: "PageLiveDocIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$f1d93fa86ac2ebd2$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $f1d93fa86ac2ebd2$var$_default = module.exports.default = $f1d93fa86ac2ebd2$var$PageLiveDocIcon;

});

parcelRegister("dipyx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $kLlYX = parcelRequire("kLlYX");


var $gEyoZ = parcelRequire("gEyoZ");

const $5d01faeb97b0ed22$var$PageLiveDocObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PageLiveDocObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Page Live Doc" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-magenta, #CD519D)";
    const t3 = isBold ? "color.background.accent.magenta.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function PageLiveDocObjectTile({ label: label = 'Page Live Doc', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-magenta, #CD519D)",
        backgroundColor: isBold ? 'color.background.accent.magenta.subtle' : undefined
    });
};
var $5d01faeb97b0ed22$export$2e2bcd8739ae039 = $5d01faeb97b0ed22$var$PageLiveDocObjectTile;
module.exports["default"] = $5d01faeb97b0ed22$export$2e2bcd8739ae039;

});

parcelRegister("b5Dss", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gJ798 = parcelRequire("gJ798");


var $9D4WS = parcelRequire("9D4WS");

// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $77093538826d7e25$var$ChartBarIconWithColor = (0, $9D4WS.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($gJ798))), 'purpleBold');
$77093538826d7e25$var$ChartBarIconWithColor.displayName = 'ChartBarIconWithColor';
var $77093538826d7e25$export$2e2bcd8739ae039 = $77093538826d7e25$var$ChartBarIconWithColor;
module.exports["default"] = $77093538826d7e25$export$2e2bcd8739ae039;

});

parcelRegister("7vzLW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $3fO5l = parcelRequire("3fO5l");


var $9D4WS = parcelRequire("9D4WS");

const $7d25c80ed1a76c0d$var$ListBulletedIconWithColor = (0, $9D4WS.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($3fO5l))), 'greenBold');
$7d25c80ed1a76c0d$var$ListBulletedIconWithColor.displayName = 'ListBulletedIconWithColor';
var $7d25c80ed1a76c0d$export$2e2bcd8739ae039 = $7d25c80ed1a76c0d$var$ListBulletedIconWithColor;
module.exports["default"] = $7d25c80ed1a76c0d$export$2e2bcd8739ae039;

});

parcelRegister("3C8hL", function(module, exports) {

var $jJhQa = parcelRequire("jJhQa");

function $55debb7a67d5b98d$export$f1091f4b134fe3fc(contentId, status, linkCount) {
    if (status === 'present') return Object.freeze({
        contentId: contentId,
        status: status,
        iconCount: (0, $jJhQa.MAX_BYLINE_CONNECTION_ICONS),
        linkCount: linkCount ?? 0
    });
    return Object.freeze({
        contentId: contentId,
        status: status
    });
}
const $55debb7a67d5b98d$export$e84841b18fa82831 = (outboundState, hasDevDocsConnection, hasIncomingConnection = false)=>{
    // Unavailable or missing data does not establish a connection. Keep empty pages hidden.
    return outboundState?.status === 'present' || hasDevDocsConnection || hasIncomingConnection ? (0, $jJhQa.MAX_BYLINE_CONNECTION_ICONS) : 0;
};
const $55debb7a67d5b98d$export$6a56c90936a4d835 = (contentId, data)=>{
    const nodes = data?.contentSmartLinks?.nodes;
    if (nodes === null || nodes === undefined) return $55debb7a67d5b98d$export$f1091f4b134fe3fc(contentId, 'unavailable');
    // Malformed data does not establish a reliable connection signal.
    const hasMalformedNode = nodes.some((node)=>typeof node?.url !== 'string' || node.url.length === 0);
    if (hasMalformedNode) return $55debb7a67d5b98d$export$f1091f4b134fe3fc(contentId, 'unavailable');
    if (nodes.length === 0) return $55debb7a67d5b98d$export$f1091f4b134fe3fc(contentId, 'empty');
    return $55debb7a67d5b98d$export$f1091f4b134fe3fc(contentId, 'present', nodes.length);
};
module.exports["createOutboundBylineSsrState"] = $55debb7a67d5b98d$export$f1091f4b134fe3fc;
module.exports["getReservedBylineIconCount"] = $55debb7a67d5b98d$export$e84841b18fa82831;
module.exports["normalizeOutboundBylineSsrState"] = $55debb7a67d5b98d$export$6a56c90936a4d835;

});

parcelRegister("9fkV7", function(module, exports) {
/**
 * @generated SignedSource<<bf3b84ff5db7fbd1354d5e5f33678352>>
 * @relayHash f211e4f25f2d5432851e491c92cdc406
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0703ec7ce014790acdd2d6795569b07a845ca7f407bc014577f6d7dd6f24ce08
const $1065e549e6af80e3$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cypherQuery"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "queryContext"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "version"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                },
                {
                    "kind": "Variable",
                    "name": "query",
                    "variableName": "cypherQuery"
                },
                {
                    "kind": "Variable",
                    "name": "queryContext",
                    "variableName": "queryContext"
                },
                {
                    "kind": "Variable",
                    "name": "version",
                    "variableName": "version"
                }
            ],
            "concreteType": "GraphStoreCypherQueryV2Connection",
            "kind": "LinkedField",
            "name": "graphStore_cypherQueryV2",
            "plural": false,
            "selections": [
                {
                    "concreteType": "GraphStoreCypherQueryV2Edge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "GraphStoreCypherQueryV2Node",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreCypherQueryV2Column",
                                    "kind": "LinkedField",
                                    "name": "columns",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "value",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "GraphStoreCypherQueryV2AriNode"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "preloadRelatedContentSampleQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "preloadRelatedContentSampleQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "f211e4f25f2d5432851e491c92cdc406",
            "id": "0703ec7ce014790acdd2d6795569b07a845ca7f407bc014577f6d7dd6f24ce08",
            "metadata": {},
            "name": "preloadRelatedContentSampleQuery",
            "operationKind": "query",
            "text": "query preloadRelatedContentSampleQuery($cypherQuery:String!,$queryContext:String!,$version:GraphStoreCypherQueryV2VersionEnum,$first:Int!){graphStore_cypherQueryV2(query:$cypherQuery,queryContext:$queryContext,version:$version,first:$first)@optIn(to:\"GraphStoreCypherQueryV2\"){edges{node{columns{key,value{__typename,...on GraphStoreCypherQueryV2AriNode{id}}}}}}}"
        }
    };
}();
$1065e549e6af80e3$var$node.hash = "9ee274feb138005cc398fbd96e50cebf";
var $1065e549e6af80e3$export$2e2bcd8739ae039 = $1065e549e6af80e3$var$node;
module.exports["default"] = $1065e549e6af80e3$export$2e2bcd8739ae039;

});

parcelRegister("26brz", function(module, exports) {

var $kyH1y = parcelRequire("kyH1y");


var $6PfFM = parcelRequire("6PfFM");


var $jHgXN = parcelRequire("jHgXN");

const $13be98e4b03e3a85$export$70a27f3f852cc3c6 = 3;
const $13be98e4b03e3a85$var$RELATED_CONTENT_COLUMN = 'relatedContent';
function $13be98e4b03e3a85$export$d16170f393ff6f4f(contentId, status, count) {
    if (status === 'present') return Object.freeze({
        contentId: contentId,
        status: status,
        count: count ?? 0
    });
    return Object.freeze({
        contentId: contentId,
        status: status
    });
}
const $13be98e4b03e3a85$export$2a14dc35c22a5496 = (cloudId, activationId, contentId, contentType)=>{
    if (!cloudId.trim() || !activationId.trim() || !/^[1-9]\d*$/.test(contentId)) return undefined;
    let pageAri;
    let queryContext;
    try {
        pageAri = (0, $6PfFM.buildContentAri)(cloudId, contentId, contentType);
        queryContext = (0, $kyH1y.ConfluenceWorkspaceAri).create({
            siteId: cloudId,
            activationId: activationId
        }).toString();
    } catch  {
        return undefined;
    }
    // Same edges, context and graph version as the client's `useRelatedContent`, capped per edge.
    return {
        cypherQuery: (0, $jHgXN.buildRelatedContentCypher)(pageAri, $13be98e4b03e3a85$export$70a27f3f852cc3c6),
        queryContext: queryContext,
        version: 'V3',
        first: $13be98e4b03e3a85$export$70a27f3f852cc3c6
    };
};
const $13be98e4b03e3a85$export$e183d7d97a71bd95 = (data)=>{
    const edges = data?.graphStore_cypherQueryV2?.edges;
    if (!edges || edges.length > $13be98e4b03e3a85$export$70a27f3f852cc3c6) return {
        status: 'unavailable',
        reason: 'malformed-response'
    };
    for (const edge of edges){
        const columns = edge.node.columns;
        if (columns.length !== 1) return {
            status: 'unavailable',
            reason: 'malformed-response'
        };
        const column = columns[0];
        if (column.key !== $13be98e4b03e3a85$var$RELATED_CONTENT_COLUMN || column.value?.__typename !== 'GraphStoreCypherQueryV2AriNode' || typeof column.value.id !== 'string' || !column.value.id.startsWith('ari:')) return {
            status: 'unavailable',
            reason: 'malformed-response'
        };
    }
    return {
        status: 'available',
        count: edges.length
    };
};
const $13be98e4b03e3a85$export$860ac37a9507480f = (contentId, data)=>{
    const result = $13be98e4b03e3a85$export$e183d7d97a71bd95(data);
    if (result.status === 'unavailable') return $13be98e4b03e3a85$export$d16170f393ff6f4f(contentId, 'unavailable');
    return result.count > 0 ? $13be98e4b03e3a85$export$d16170f393ff6f4f(contentId, 'present', result.count) : $13be98e4b03e3a85$export$d16170f393ff6f4f(contentId, 'empty');
};
module.exports["RELATED_CONTENT_SAMPLE_LIMIT"] = $13be98e4b03e3a85$export$70a27f3f852cc3c6;
module.exports["createRelatedContentSsrState"] = $13be98e4b03e3a85$export$d16170f393ff6f4f;
module.exports["buildRelatedContentSampleVariables"] = $13be98e4b03e3a85$export$2a14dc35c22a5496;
module.exports["normalizeRelatedContentSampleData"] = $13be98e4b03e3a85$export$e183d7d97a71bd95;
module.exports["normalizeRelatedContentSsrState"] = $13be98e4b03e3a85$export$860ac37a9507480f;

});

parcelRegister("jHgXN", function(module, exports) {
/**
 * The Teamwork Graph edges "Related content" is read over, from the page to the entity the graph
 * infers as related. The first-party edge targets Confluence content; the second targets
 * third-party entities such as Google Drive files and Figma designs.
 */ const $1736f7a9f3d6c286$var$RELATED_CONTENT_RELATIONSHIPS = [
    'confluence_content_has_related_confluence_content',
    'confluence_content_has_related_entity'
];
const $1736f7a9f3d6c286$export$acb2e2ce2cfb2561 = 6;
const $1736f7a9f3d6c286$export$55aac79ee103d4c5 = $1736f7a9f3d6c286$export$acb2e2ce2cfb2561 * $1736f7a9f3d6c286$var$RELATED_CONTENT_RELATIONSHIPS.length;
const $1736f7a9f3d6c286$export$264f5646b95aac63 = (pageAri, limitPerRelationship = $1736f7a9f3d6c286$export$acb2e2ce2cfb2561)=>$1736f7a9f3d6c286$var$RELATED_CONTENT_RELATIONSHIPS.map((relationship)=>[
            `MATCH (page {ari: "${pageAri}"})-[:${relationship}]->(entity)`,
            'RETURN DISTINCT entity AS relatedContent',
            `LIMIT ${limitPerRelationship}`
        ].join('\n')).join('\nUNION ALL\n');
module.exports["MAX_RELATED_CONTENT"] = $1736f7a9f3d6c286$export$55aac79ee103d4c5;
module.exports["buildRelatedContentCypher"] = $1736f7a9f3d6c286$export$264f5646b95aac63;

});

parcelRegister("i9pyX", function(module, exports) {

var $gABt9 = parcelRequire("gABt9");


var $bZF61 = parcelRequire("bZF61");


var $fyjce = parcelRequire("fyjce");


var $9C63M = parcelRequire("9C63M");


var $bfpjP = parcelRequire("bfpjP");


var $d9nAp = parcelRequire("d9nAp");

const $c1ab7bf16286d454$var$RELATIVE_URL = '/gateway/api/xpsearch-aggregator/configuration/v1';
const $c1ab7bf16286d454$var$RELATIVE_URL_V2 = '/gateway/api/xpsearch-aggregator/api/v2/configuration';
const $c1ab7bf16286d454$var$RELATIVE_3P_URL = '/gateway/api/third-party-configuration/connected-data-sources';
const $c1ab7bf16286d454$var$RELATIVE_LOOM_AUTH_URL = '/gateway/api/loom-auth/api/internal/identity/user-status';
const $c1ab7bf16286d454$export$19524a749d98a458 = 'search-config';
const $c1ab7bf16286d454$export$cf95148f36a28b96 = 'search-3p-config';
const $c1ab7bf16286d454$export$44d1e7c4ef26c467 = 'loom-user-auth';
const { refreshOnAccessDecorator: $c1ab7bf16286d454$var$refreshOnAccessDecoratorSearch } = (0, $fyjce.promiseCache)({
    name: $c1ab7bf16286d454$export$19524a749d98a458
});
const { refreshOnAccessDecorator: $c1ab7bf16286d454$var$refreshOnAccessDecorator3pSearch, update: $c1ab7bf16286d454$var$update3pCache } = (0, $fyjce.promiseCache)({
    name: $c1ab7bf16286d454$export$cf95148f36a28b96,
    expiration: 300000
});
const { refreshOnAccessDecorator: $c1ab7bf16286d454$var$refreshOnAccessDecoratorUserLoomAuth } = (0, $fyjce.promiseCache)({
    name: $c1ab7bf16286d454$export$44d1e7c4ef26c467
});
const $c1ab7bf16286d454$var$SITELESS_PRODUCTS = [
    'trello',
    'bitbucket'
];
/**
 * Creates a traceInfoExtractor that reads from a mutable headers reference.
 * Used by REST config endpoints to extract requestId/traceId from HTTP response headers
 * without storing them in the cache.
 */ const $c1ab7bf16286d454$var$createTraceInfoExtractor = (headersRef)=>{
    return ()=>{
        const headers = headersRef();
        const requestId = headers['atl-request-id'];
        const traceId = headers['x-trace-id'];
        if (requestId || traceId) return {
            requestId: requestId,
            traceId: traceId
        };
        return undefined;
    };
};
const $c1ab7bf16286d454$export$2e9655e8b4177582 = async ({ absoluteUrl: absoluteUrl = '', hostName: hostName, cloudId: cloudId, userId: userId, onlyRefreshIfExpired: onlyRefreshIfExpired, expiration: expiration })=>{
    const url = absoluteUrl || `${hostName || ''}${$c1ab7bf16286d454$var$RELATIVE_URL}`;
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }
    };
    const key = (0, $bZF61.generateHash)(`1p|${userId}|${cloudId}`);
    const supplier = ()=>(0, $gABt9.utils).requestService({
            url: url
        }, options).then((data)=>{
            const resources = data.resources.filter((resource)=>cloudId ? resource.id.includes(cloudId) || $c1ab7bf16286d454$var$SITELESS_PRODUCTS.find((product)=>resource.id.includes(product)) // Allow access to products that are not associated with a site
                 : true);
            return {
                resources: resources,
                intercomHmac: data.intercomHmac || '',
                siteMetadata: data.siteMetadata || []
            };
        });
    return $c1ab7bf16286d454$var$refreshOnAccessDecoratorSearch({
        key: key.toString(),
        supplier: supplier,
        onlyRefreshIfExpired: onlyRefreshIfExpired,
        expiration: expiration,
        serveResolvedDuringRefresh: true
    });
};
const $c1ab7bf16286d454$export$c6f4290269f11bd5 = async ({ absoluteUrl: absoluteUrl = '', hostName: hostName, cloudId: cloudId, userId: userId, onlyRefreshIfExpired: onlyRefreshIfExpired, expiration: expiration, cacheAnalyticsCallback: cacheAnalyticsCallback, degradationCallback: degradationCallback = ()=>{}, returnExpired: returnExpired, networkCallbacks: networkCallbacks })=>{
    const url = absoluteUrl || `${hostName || ''}${$c1ab7bf16286d454$var$RELATIVE_URL_V2}/${cloudId}`;
    const queryParams = {
        operationName: 'searchPageFirstPartyConfig'
    };
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        },
        queryParams: queryParams
    };
    const key = (0, $bZF61.generateHash)(`1p|${userId}|${cloudId}|v2`);
    // Mutable reference for capturing tracing headers from the REST response.
    // Set by the supplier's reportTracingHeaders callback, read by traceInfoExtractor.
    // This avoids storing tracing headers in the cache — they're only used transiently for VitalStats events.
    let capturedTracingHeaders = {};
    const supplier = ()=>{
        capturedTracingHeaders = {};
        const searchConfigPromise = (0, $gABt9.utils).requestService({
            url: url
        }, {
            ...options,
            reportTracingHeaders: (headers)=>{
                capturedTracingHeaders = headers;
            }
        }).then((data)=>{
            return {
                resources: data.resources,
                intercomHmac: data.intercomHmac || '',
                siteMetadata: data.siteMetadata || []
            };
        });
        // Two cases here, due to the promiseCache from refreshOnAccessDecoratorSearch below
        // 1. Cache-miss: we of course want to handle degradation!
        // 2. Cache-hit: we actually still want to handle degradation, because if we can't refresh the cache due to a slow dependency, that is a signal we need in healthchecks
        // The alternate approach here would be to wrap the promiseCache in the DegradablePromise, but then we'd only get degradation pings on cache-miss.
        const degrader = new (0, $9C63M.DegradablePromise)(searchConfigPromise, degradationCallback);
        return degrader.promise();
    };
    const traceInfoExtractor = $c1ab7bf16286d454$var$createTraceInfoExtractor(()=>capturedTracingHeaders);
    return $c1ab7bf16286d454$var$refreshOnAccessDecoratorSearch({
        key: key.toString(),
        supplier: supplier,
        onlyRefreshIfExpired: onlyRefreshIfExpired,
        expiration: expiration,
        returnExpired: returnExpired,
        analyticsCallback: cacheAnalyticsCallback,
        networkCallbacks: networkCallbacks,
        serveResolvedDuringRefresh: true,
        traceInfoExtractor: traceInfoExtractor
    });
};
const $c1ab7bf16286d454$export$6916ea7f169882e0 = async ({ absoluteUrl: absoluteUrl = '', cloudId: cloudId, userId: userId, onlyRefreshIfExpired: onlyRefreshIfExpired, expiration: expiration, cacheAnalyticsCallback: cacheAnalyticsCallback, degradationCallback: degradationCallback = ()=>{}, returnExpired: returnExpired, networkCallbacks: networkCallbacks })=>{
    const baseUrl = absoluteUrl || $c1ab7bf16286d454$var$RELATIVE_3P_URL;
    const url = `${baseUrl}/${cloudId}`;
    const queryParams = {
        operationName: 'searchPageThirdPartyConfig'
    };
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        },
        queryParams: queryParams
    };
    const key = (0, $d9nAp.generate3pHash)(userId || '', cloudId || '');
    // Mutable reference for capturing tracing headers from the REST response.
    // Set by the supplier's reportTracingHeaders callback, read by traceInfoExtractor.
    // This avoids storing tracing headers in the cache — they're only used transiently for VitalStats events.
    let capturedTracingHeaders = {};
    const supplier = ()=>{
        capturedTracingHeaders = {};
        const searchConfig3PPromise = (0, $gABt9.utils).requestService({
            url: url
        }, {
            ...options,
            reportTracingHeaders: (headers)=>{
                capturedTracingHeaders = headers;
            }
        });
        // Two cases here, due to the promiseCache from refreshOnAccessDecorator3pSearch below
        // 1. Cache-miss: we of course want to handle degradation!
        // 2. Cache-hit: we actually still want to handle degradation, because if we can't refresh the cache due to a slow dependency, that is a signal we need in healthchecks
        // The alternate approach here would be to wrap the promiseCache in the DegradablePromise, but then we'd only get degradation pings on cache-miss.
        const degrader = new (0, $9C63M.DegradablePromise)(searchConfig3PPromise, degradationCallback);
        return degrader.promise();
    };
    const traceInfoExtractor = $c1ab7bf16286d454$var$createTraceInfoExtractor(()=>capturedTracingHeaders);
    return $c1ab7bf16286d454$var$refreshOnAccessDecorator3pSearch({
        key: key.toString(),
        supplier: supplier,
        returnExpired: returnExpired,
        onlyRefreshIfExpired: onlyRefreshIfExpired,
        expiration: expiration,
        analyticsCallback: cacheAnalyticsCallback,
        networkCallbacks: networkCallbacks,
        serveResolvedDuringRefresh: true,
        traceInfoExtractor: traceInfoExtractor
    });
};
const $c1ab7bf16286d454$export$b75556aa5958ec1f = (userId, cloudId, updater)=>{
    const key = (0, $d9nAp.generate3pHash)(userId, cloudId);
    return $c1ab7bf16286d454$var$update3pCache(key.toString(), updater);
};
const $c1ab7bf16286d454$export$46e3d34ee7b8c58a = async ({ cloudId: cloudId, userId: userId })=>{
    const url = $c1ab7bf16286d454$var$RELATIVE_LOOM_AUTH_URL;
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }
    };
    const key = (0, $bfpjP.generateLoomAuthHash)(userId || '', cloudId || '');
    const supplier = ()=>(0, $gABt9.utils).requestService({
            url: url
        }, options);
    return $c1ab7bf16286d454$var$refreshOnAccessDecoratorUserLoomAuth({
        key: key.toString(),
        supplier: supplier,
        returnExpired: false
    });
};
module.exports["getSearchConfigV2"] = $c1ab7bf16286d454$export$c6f4290269f11bd5;
module.exports["get3pSearchConfig"] = $c1ab7bf16286d454$export$6916ea7f169882e0;
module.exports["update3pConfigCacheEntry"] = $c1ab7bf16286d454$export$b75556aa5958ec1f;
module.exports["getUserLoomAuthStatus"] = $c1ab7bf16286d454$export$46e3d34ee7b8c58a;

});

parcelRegister("bZF61", function(module, exports) {
/**
 * Simple implementation of djb2 hashing.
 * The reason we have it internally is because at the moment we can't add new
 * dependencies into search-client package as it triggers a deprecated VR test in Editor
 * and it is locked down. So it fails to resolve the new dependency
 */ const $a6b1de276595dc61$export$daf4c137c5f56404 = (query)=>{
    let hash = 5381;
    for(let i = 0; i < query.length; i++){
        const char = query.charCodeAt(i);
        hash = (hash << 5) + hash + char; /* hash * 33 + char */ 
    }
    return hash;
};
const $a6b1de276595dc61$export$5c07a4287a46fa1f = (variables)=>{
    try {
        return $a6b1de276595dc61$export$daf4c137c5f56404(JSON.stringify(variables)).toString();
    } catch (e) {
        return '';
    }
};
module.exports["generateHash"] = $a6b1de276595dc61$export$daf4c137c5f56404;
module.exports["generateHashFromVariables"] = $a6b1de276595dc61$export$5c07a4287a46fa1f;

});

parcelRegister("fyjce", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $6dPGs = parcelRequire("6dPGs");


var $6s56R = parcelRequire("6s56R");


var $8N8EQ = parcelRequire("8N8EQ");


var $7jITD = parcelRequire("7jITD");


var $5oT59 = parcelRequire("5oT59");


var $esAoV = parcelRequire("esAoV");

const $86ca83201018b107$export$e89e805418f4d2c = (args)=>{
    const { name: name, shouldUseStorageAdapter: shouldUseStorageAdapter } = args;
    let cacheInstance = null;
    let resolvedStorage = null;
    // During refresh, the main cache will hold pending promises so we need a way to access the last resolved value
    // This cache can return these values while the refresh is in progress
    const resolvedValueCache = new Map();
    /**
   * NOTE: Scope control (QS-9209)
   *
   * The storage adapter system is introduced specifically so the combined search config cache
   * can participate in host-provided persistence (e.g., Confluence SSR local storage).
   */ const COMBINED_CONFIG_PERSISTED_CACHE_KEY = (0, $5oT59.SEARCH_COMBINED_CONFIG_CACHE_KEY);
    const defaultLocalStorageAdapter = {
        getItem: (key)=>(0, $6dPGs.getLocalStorageItemAsString)(key),
        setItem: (key, value)=>(0, $6dPGs.setLocalStorageItem)(key, value)
    };
    function shouldUseAdapterSystemForThisCache() {
        // Explicit opt-in/out takes precedence (lets two caches share a `name` but
        // target different storage — bare key vs host-adapter/account-namespaced key).
        // When unspecified, preserve the historical behaviour: the combined-config
        // cache routes through the host adapter so the legacy path is untouched.
        if (shouldUseStorageAdapter !== undefined && ((0, $iDrrr.fg)('rovo_fps_use_rovo_config') || (0, $6s56R.isUsingRovoConfigStoreExperiment)())) return shouldUseStorageAdapter;
        return name === COMBINED_CONFIG_PERSISTED_CACHE_KEY;
    }
    const getCacheInstance = ()=>{
        /**
     * We lazily create the cache instance to avoid the issue in SSR
     * where the localStorage isn't available.
     */ if (!cacheInstance) {
            cacheInstance = (0, $7jITD.getInstance)(args);
            // Resolve persisted state lazily (SSR-safe)
            let persistedState = null;
            try {
                if (shouldUseAdapterSystemForThisCache()) {
                    const factory = (0, $esAoV.getSearchClientStorageAdapterFactory)();
                    if (factory) {
                        resolvedStorage = factory();
                        persistedState = resolvedStorage?.getItem(name) ?? null;
                    }
                    // If the adapter cache is cold or the factory isn't registered yet, fall back
                    // to the raw localStorage key. This ensures stale-but-present data is served
                    // immediately rather than blocking on the network and potentially timing out
                    // the DegradablePromise.
                    // SSR-safe: getLocalStorageItemAsString throws in SSR -> caught by outer try/catch.
                    if (!persistedState) persistedState = (0, $6dPGs.getLocalStorageItemAsString)(name);
                } else persistedState = (0, $6dPGs.getLocalStorageItemAsString)(name);
            } catch  {
            // Error retrieving persisted state - continue without it
            }
            if (persistedState) {
                // Populate the resolved value cache with the contents of local storage
                const object = cacheInstance.deserialize(persistedState);
                if (object) Object.entries(object).forEach(([key, entry])=>{
                    if (entry && 'result' in entry) resolvedValueCache.set(key, entry.result);
                });
            }
        }
        return cacheInstance;
    };
    const get = (key, returnExpired)=>{
        const storedValue = getCacheInstance().get(key, returnExpired ?? true); // fetch expired result by default
        const isExpired = getCacheInstance().isExpired(key);
        return {
            storedValue: storedValue,
            isExpired: isExpired
        };
    };
    const set = async (key, result, expiration)=>{
        getCacheInstance().set(key, result, expiration);
        try {
            const resolvedValue = await result;
            resolvedValueCache.set(key, resolvedValue);
            const serialized = await getCacheInstance().serialize();
            if (serialized) {
                if (shouldUseAdapterSystemForThisCache()) {
                    const adapter = resolvedStorage ?? (0, $esAoV.getSearchClientStorageAdapterFactory)()?.() ?? defaultLocalStorageAdapter;
                    adapter.setItem(name, serialized);
                } else (0, $6dPGs.setLocalStorageItem)(name, serialized);
            }
        } catch  {
        // noop - an exception in the result promise or serialisation should be ignored so we dont throw unhandled exceptions
        }
    };
    const update = async (key, updater, expiration)=>{
        // Read remaining TTL before get(), which removes expired entries from the map
        const remainingTtl = expiration ?? getCacheInstance().getRemainingTtl(key);
        const { storedValue: storedValue } = get(key, true);
        if (!storedValue) return false;
        try {
            const currentValue = await storedValue;
            const updatedValue = updater(currentValue);
            await set(key, Promise.resolve(updatedValue), remainingTtl || undefined);
            return true;
        } catch  {
            return false;
        }
    };
    const clear = (key)=>{
        if (key) resolvedValueCache.delete(key);
        else resolvedValueCache.clear();
        getCacheInstance().clear(key);
    };
    const refreshOnAccessDecorator = ({ key: key, supplier: supplier, returnExpired: returnExpired, onlyRefreshIfExpired: onlyRefreshIfExpired, expiration: expiration, analyticsCallback: analyticsCallback, networkCallbacks: networkCallbacks, serveResolvedDuringRefresh: serveResolvedDuringRefresh, traceInfoExtractor: traceInfoExtractor })=>{
        const { storedValue: storedValue, isExpired: isExpired } = get(key, returnExpired);
        const shouldRefresh = onlyRefreshIfExpired ? isExpired : true;
        // When enabled, returns already-resolved values from an in-memory cache during background
        // refresh instead of returning pending promises. Callers can opt out by passing false.
        const serveResolvedDuringRefreshEnabled = serveResolvedDuringRefresh ?? false;
        if (!storedValue || shouldRefresh) {
            // Wrap the supplier to track network calls
            const trackedSupplier = async ()=>{
                networkCallbacks?.onStart();
                try {
                    const result = await supplier();
                    const traceInfo = traceInfoExtractor ? traceInfoExtractor() : (0, $8N8EQ.extractTraceInfoFromResponse)(result);
                    networkCallbacks?.onSuccess(traceInfo);
                    return result;
                } catch (error) {
                    const errorName = error?.name || 'UnknownError';
                    const errorMessage = error?.message || 'An unknown error occurred';
                    networkCallbacks?.onError(errorName, errorMessage, undefined);
                    throw error;
                }
            };
            const apiPromise = trackedSupplier();
            set(key, apiPromise, expiration);
            // If there was already a stored value prior to refreshing, return it
            if (storedValue) {
                if (analyticsCallback) analyticsCallback({
                    refreshTriggered: true,
                    hit: true
                });
                // Return resolved value if serveResolvedDuringRefresh is enabled and we have it cached
                if (serveResolvedDuringRefreshEnabled) {
                    const resolvedValue = resolvedValueCache.get(key);
                    if (resolvedValue !== undefined) return resolvedValue;
                }
                return storedValue;
            } else {
                if (analyticsCallback) analyticsCallback({
                    refreshTriggered: true,
                    hit: false
                });
                return apiPromise;
            }
        } else {
            if (analyticsCallback) analyticsCallback({
                refreshTriggered: false,
                hit: true
            });
            // Return resolved value if serveResolvedDuringRefresh is enabled and we have it cached
            if (serveResolvedDuringRefreshEnabled) {
                const resolvedValue = resolvedValueCache.get(key);
                if (resolvedValue !== undefined) return resolvedValue;
            }
            return storedValue;
        }
    };
    const seed = (key, value, expiration)=>set(key, Promise.resolve(value), expiration);
    return {
        get: get,
        refreshOnAccessDecorator: refreshOnAccessDecorator,
        clear: clear,
        update: update,
        seed: seed
    };
};
module.exports["promiseCache"] = $86ca83201018b107$export$e89e805418f4d2c;

});

parcelRegister("6dPGs", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $7dBf8 = parcelRequire("7dBf8");

// `localStorage` is a browser-only Web API and does not exist during server-side
// rendering (SSR). Accessing the bare `localStorage` identifier on the server
// throws a `ReferenceError`, which crashes the render.
const $96c9493b1d7fc1a3$var$isLocalStorageAvailable = ()=>{
    return typeof window !== 'undefined' && typeof localStorage !== 'undefined';
};
const $96c9493b1d7fc1a3$export$5aa524d86254b4f = (key, value)=>{
    if (!$96c9493b1d7fc1a3$var$isLocalStorageAvailable()) return;
    if ((0, $iDrrr.fg)('search_page_use_browser_storage_controls')) (0, $7dBf8.AtlBrowserStorageLocal).setItem(key, value);
    else // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.setItem(key, value);
};
const $96c9493b1d7fc1a3$export$93d719890ad66653 = (key)=>{
    if (!$96c9493b1d7fc1a3$var$isLocalStorageAvailable()) return null;
    const item = (0, $iDrrr.fg)('search_page_use_browser_storage_controls') ? (0, $7dBf8.AtlBrowserStorageLocal).getItem(key) : // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
};
const $96c9493b1d7fc1a3$export$5df15f289f441790 = (key)=>{
    if (!$96c9493b1d7fc1a3$var$isLocalStorageAvailable()) return null;
    const item = (0, $iDrrr.fg)('search_page_use_browser_storage_controls') ? (0, $7dBf8.AtlBrowserStorageLocal).getItem(key) : // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem(key);
    return item ? item : null;
};
const $96c9493b1d7fc1a3$export$baf306891f1b93bd = (key)=>{
    if (!$96c9493b1d7fc1a3$var$isLocalStorageAvailable()) return;
    if ((0, $iDrrr.fg)('search_page_use_browser_storage_controls')) (0, $7dBf8.AtlBrowserStorageLocal).removeItem(key);
    else // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(key);
};
module.exports["setLocalStorageItem"] = $96c9493b1d7fc1a3$export$5aa524d86254b4f;
module.exports["getLocalStorageItem"] = $96c9493b1d7fc1a3$export$93d719890ad66653;
module.exports["getLocalStorageItemAsString"] = $96c9493b1d7fc1a3$export$5df15f289f441790;
module.exports["removeLocalStorageItem"] = $96c9493b1d7fc1a3$export$baf306891f1b93bd;

});

parcelRegister("6s56R", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");

const $0f4933595e34bba8$export$aa9f97d4dfccb6ff = ()=>{
    if ((0, $iDrrr.fg)('rovo_cas_use_rovo_config')) return true;
    return (0, $cXtTj.default).getExperimentValue('rovo_cas_use_rovo_config_exp', 'cohort', 'control') === 'test';
};
module.exports["isUsingRovoConfigStoreExperiment"] = $0f4933595e34bba8$export$aa9f97d4dfccb6ff;

});

parcelRegister("8N8EQ", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $20c1508e7bfb5af0$var$NOT_AVAILABLE = 'not_available';
/**
 * HTTP response headers the gateway returns its trace / request IDs on. `fetchAgg` copies these
 * onto the parsed result as `gatewayTracingHeaders`.
 */ const $20c1508e7bfb5af0$var$TRACE_ID_HEADER = 'x-trace-id';
const $20c1508e7bfb5af0$var$REQUEST_ID_HEADER = 'atl-request-id';
const $20c1508e7bfb5af0$export$fca3401e33379daf = (result)=>{
    if (!result || typeof result !== 'object') return undefined;
    const preferTracingHeaders = (0, $iDrrr.fg)('rovo-search-vitalstats-trace-from-headers');
    if (preferTracingHeaders) {
        const tracingHeaders = result.gatewayTracingHeaders;
        const traceId = tracingHeaders?.[$20c1508e7bfb5af0$var$TRACE_ID_HEADER];
        const requestId = tracingHeaders?.[$20c1508e7bfb5af0$var$REQUEST_ID_HEADER];
        if (traceId || requestId) return {
            requestId: requestId,
            traceId: traceId
        };
    }
    if ('extensions' in result) {
        const extensions = result.extensions;
        const gateway = extensions?.gateway;
        if (gateway) return {
            requestId: gateway.request_id ?? undefined,
            // `tId` is the current gateway field name, `trace_id` the older one.
            traceId: preferTracingHeaders ? gateway.tId ?? gateway.trace_id ?? undefined : gateway.trace_id ?? undefined
        };
    }
    return undefined;
};
const $20c1508e7bfb5af0$export$4acb28c262cd52bd = (traceInfo)=>({
        requestId: traceInfo?.requestId ?? $20c1508e7bfb5af0$var$NOT_AVAILABLE,
        traceId: traceInfo?.traceId ?? $20c1508e7bfb5af0$var$NOT_AVAILABLE
    });
module.exports["extractTraceInfoFromResponse"] = $20c1508e7bfb5af0$export$fca3401e33379daf;
module.exports["normaliseTraceInfo"] = $20c1508e7bfb5af0$export$4acb28c262cd52bd;

});

parcelRegister("7jITD", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $df3ea53f68f38eaa$var$DEFAULT_EXPIRATION = 900000; // 15 mins in milliseconds
const $df3ea53f68f38eaa$var$PERSISTED_EXPIRATION_GRACE_PERIOD = 86400000;
class $df3ea53f68f38eaa$var$Cache {
    get(key, returnExpired = false) {
        const entry = this.map[key];
        if (entry) {
            if (entry.isExpired()) {
                delete this.map[key];
                return returnExpired ? entry.getResult() : undefined;
            } else return entry.getResult();
        }
        return;
    }
    set(key, result, expiration) {
        const entry = new $df3ea53f68f38eaa$var$Entry({
            result: result,
            expirationTime: Date.now() + (expiration || this.expiration),
            accessCount: 0
        });
        this.map[key] = entry;
    }
    has(key) {
        return key in this.map;
    }
    clear(key) {
        if (key) delete this.map[key];
        else this.map = {};
    }
    async serialize() {
        const serialized = {};
        const cleanupEnabled = (0, $iDrrr.fg)('search_cache_cleanup_on_write');
        const cutoff = Date.now() - $df3ea53f68f38eaa$var$PERSISTED_EXPIRATION_GRACE_PERIOD;
        const resolvers = Object.entries(this.map).map(([key, entry])=>(async ()=>{
                // Filter persistence only: stale responses remain available in memory.
                // Skip before awaiting so obsolete promises cannot block this write.
                if (cleanupEnabled && entry.getExpirationTime() < cutoff) return;
                serialized[key] = {
                    result: await entry.getResult(),
                    expirationTime: entry.getExpirationTime(),
                    accessCount: entry.getAccessCount()
                };
            })());
        await Promise.all(resolvers);
        return JSON.stringify(serialized);
    }
    deserialize(persisted) {
        try {
            const object = JSON.parse(persisted);
            for(const key in object){
                const { result: result, expirationTime: expirationTime, accessCount: accessCount } = object[key];
                this.map[key] = new $df3ea53f68f38eaa$var$Entry({
                    result: Promise.resolve(result),
                    expirationTime: expirationTime,
                    accessCount: accessCount
                });
            }
            return object;
        } catch  {
        // TODO: Log error via sentry
        }
        return undefined;
    }
    isExpired(key) {
        const entry = this.map[key];
        return entry ? entry.isExpired() : true;
    }
    getRemainingTtl(key) {
        const entry = this.map[key];
        if (!entry) return undefined;
        return Math.max(0, entry.getExpirationTime() - Date.now());
    }
    constructor(args = {}){
        this.map = void 0;
        this.expiration = void 0;
        const { expiration: expiration = $df3ea53f68f38eaa$var$DEFAULT_EXPIRATION } = args;
        this.map = {};
        this.expiration = expiration;
    }
}
class $df3ea53f68f38eaa$var$Entry {
    getResult() {
        this.accessCount++;
        return this.result;
    }
    isExpired() {
        return this.expirationTime < Date.now();
    }
    getExpirationTime() {
        return this.expirationTime;
    }
    getAccessCount() {
        return this.accessCount;
    }
    constructor({ result: result, expirationTime: expirationTime, accessCount: accessCount }){
        this.result = void 0;
        this.expirationTime = void 0;
        this.accessCount = void 0;
        this.result = result;
        this.expirationTime = expirationTime;
        this.accessCount = accessCount;
    }
}
const $df3ea53f68f38eaa$export$8bedcca5bbd73999 = (args)=>{
    return new $df3ea53f68f38eaa$var$Cache(args);
};
module.exports["getInstance"] = $df3ea53f68f38eaa$export$8bedcca5bbd73999;

});

parcelRegister("9C63M", function(module, exports) {
$parcel$export(module.exports, "DegradeError", () => (parcelRequire("aHhuQ")).DegradeError);

var $aHhuQ = parcelRequire("aHhuQ");

const $40115e6ed8d3612b$export$ff01cc10d3c607be = 6000; // default timeout
const $40115e6ed8d3612b$var$DEGRADE_ERROR = new (0, $aHhuQ.DegradeError)('Promise is degraded');
class $40115e6ed8d3612b$export$ea6d6e4c9647fa9 {
    static from(wrapped, degradationCallback = ()=>{}, timeoutMs) {
        return new $40115e6ed8d3612b$export$ea6d6e4c9647fa9(wrapped, degradationCallback, timeoutMs ?? $40115e6ed8d3612b$export$ff01cc10d3c607be);
    }
    constructor(wrapped, degradationCallback, timeoutMs = $40115e6ed8d3612b$export$ff01cc10d3c607be){
        this.degradablePromiseInternal = void 0;
        this.degradeTimeout = void 0;
        this.timeoutMs = void 0;
        this.degradeInternal = ()=>{
            // Default throws an error as this should never happen
            throw new Error('Programming error, cancelling promise is not properly rejected');
        };
        this.timeout = ()=>{
            this.degradeInternal();
        };
        this.promise = ()=>this.degradablePromiseInternal;
        const degrader = new Promise((_, reject)=>{
            this.degradeInternal = ()=>{
                reject($40115e6ed8d3612b$var$DEGRADE_ERROR);
                degradationCallback('timeout');
            };
        });
        // Call the degradation callback with 'failed' if the wrapped promise fails, easy way to track metrics at fetch level
        wrapped.catch(()=>{
            degradationCallback('failure');
        });
        // Build a finally chain into the wrapped promise so if it resolves early, we cancel the degradation
        const wrappedFinally = wrapped.finally(()=>{
            if (this.degradeTimeout) clearTimeout(this.degradeTimeout);
        });
        const wrapper = Promise.race([
            wrappedFinally,
            degrader
        ]);
        this.degradablePromiseInternal = wrapper;
        this.timeoutMs = timeoutMs ?? $40115e6ed8d3612b$export$ff01cc10d3c607be;
        this.degradeTimeout = setTimeout(this.timeout, this.timeoutMs);
    }
}
module.exports["DegradablePromise"] = $40115e6ed8d3612b$export$ea6d6e4c9647fa9;

});

parcelRegister("aHhuQ", function(module, exports) {
class $b0ed35fbaacb89be$export$85bf8e4fb143676a extends Error {
    constructor(...args){
        super(...args);
        this.isDegraded = true;
    }
}
module.exports["DegradeError"] = $b0ed35fbaacb89be$export$85bf8e4fb143676a;

});

parcelRegister("bfpjP", function(module, exports) {

var $bZF61 = parcelRequire("bZF61");

const $413fa6e1c2c21add$export$42b67d93e908c9dc = (userId, cloudId)=>(0, $bZF61.generateHash)(`loom|${userId}|${cloudId}`);
module.exports["generateLoomAuthHash"] = $413fa6e1c2c21add$export$42b67d93e908c9dc;

});

parcelRegister("d9nAp", function(module, exports) {

var $bZF61 = parcelRequire("bZF61");

const $de62146c16c69af1$export$f80795c7fd0ce9fc = (userId, cloudId)=>(0, $bZF61.generateHash)(`3p|${userId}|${cloudId}`);
module.exports["generate3pHash"] = $de62146c16c69af1$export$f80795c7fd0ce9fc;

});

parcelRegister("fR63l", function(module, exports) {
/**
 * Product keys for third-party connectors.
 * Each key maps to a unique identifier used throughout the search system.
 */ // oxlint-disable-next-line eslint/no-redeclare
const $dce31c4071a2ecfb$export$93aa518ca2694c2d = {
    AtlassianWebCrawler: 'atlassian-web-crawler',
    Figma: 'figma',
    Github: 'github',
    GoogleDrive: 'drive',
    Loom: 'loom',
    OneDrive: 'onedrive',
    Dropbox: 'dropbox',
    Slack: 'slack',
    Sharepoint: 'sharepoint',
    Teams: 'teams',
    GoogleCalendar: 'google-calendar',
    OutlookCalendar: 'outlook-calendar',
    OutlookMail: 'outlook-mail',
    Gmail: 'gmail',
    AdobeSign: 'adobe-sign',
    Asana: 'asana',
    Zendesk: 'zendesk',
    Airtable: 'airtable',
    Smartsheet: 'smartsheet',
    Notion: 'notion',
    Miro: 'miro',
    Docusign: 'docusign',
    Lucid: 'lucid',
    Monday: 'monday',
    AzureDevops: 'azure-devops',
    Gitlab: 'gitlab',
    ConfluenceDC: 'confluence-dc',
    Canva: 'canva',
    Box: 'box',
    Zeplin: 'zeplin',
    ServiceNow: 'servicenow',
    Freshservice: 'freshservice',
    PowerBI: 'power-bi',
    ClickUp: 'clickup',
    Amplitude: 'amplitude',
    Stripe: 'stripe',
    AdobeXD: 'adobexd',
    Aha: 'aha',
    Mural: 'mural',
    Webex: 'webex',
    Todoist: 'todoist',
    PagerDuty: 'pagerduty',
    Pipedrive: 'pipedrive',
    Hubspot: 'hubspot',
    Dovetail: 'dovetail',
    LaunchDarkly: 'launchdarkly',
    Salesforce: 'salesforce',
    Sentry: 'sentry',
    JiraDC: 'jira-dc',
    Gitbook: 'gitbook',
    AWSS3: 'aws-s3',
    Databricks: 'databricks',
    JsmDC: 'jsm-dc',
    ForgeAdamVitareqDev: 'forge-connector-dAkghOClvWGokDftTTaIgNoD6pnNt74z-vitareq-connector',
    ForgeAdamVitareqProd: 'forge-connector-EjfoGWrWrETl3Zc5zkGynPyESZO5Qu93-vitareq-connector',
    ForgeK15tScrollSitesDev: 'forge-connector-h1n3NRFAn84v7ECSONVidlCS88qZh8cy-scroll-sites-connector',
    ForgeK15tScrollSitesProd: 'forge-connector-ofe9zXccOCQ3U4t4kDVywSyJUoZjb1sO-scroll-sites-connector',
    ForgePioAwsDev: 'forge-connector-HaxJprV0zzjjvwLhGkAN2gDPhHZwXNiL-s3-connector',
    ForgePioAwsProd: 'forge-connector-mRcqWRwqkUd4JwapGkvGHUViyySX9MVy-s3-connector',
    ForgePioClickupDev: 'forge-connector-ELuz3hTMhig0Jdrr6ytI45SifO9DfKrY-clickup-connector',
    ForgePioClickupProd: 'forge-connector-uwYqtNjM6w0QIhHOFG0Cq4cnkUM9mt3K-clickup-connector',
    ForgePioGitbookDev: 'forge-connector-Xh70v2yqkzOjTQqTMLxk1lElehWIXoYi-gitbook-connector',
    ForgePioGitbookProd: 'forge-connector-cQ1IDSmJT0DrQuF8pGa4ijz0XZ6IGF5u-gitbook-connector',
    ForgePioGithubDev: 'forge-connector-3QYYBgeNDilQB3Jc7uGMCchNgUGvCi7j-github-connector',
    ForgePioGithubProd: 'forge-connector-0Sw5Yr860fgfx5sYS7kEUoxnGhEvrhhI-github-connector',
    ForgePioGitlabDev: 'forge-connector-psr1wBkasRuKCwsvwi4aTJNhjmlVFebC-gitlab-connector',
    ForgePioGitlabProd: 'forge-connector-QLK5Xf8nBqejSZTulw5s3Cl6fIS24MwL-gitlab-connector',
    ForgePioGoogleDriveDev: 'forge-connector-JhqjCcAP6AHHxkYhY2akTgZsYXY93SMq-google-drive-connector',
    ForgePioGoogleDriveProd: 'forge-connector-pcIwW04B398CSnilRIyzPJ5v5GevlCCo-google-drive-connector',
    ForgePioGuruDev: 'forge-connector-NtY3W5Z8JTBshAgPZFIfT7VjYAARj1P5-guru-connector',
    ForgePioGuruProd: 'forge-connector-mulxOVrXWOZObhFZH5WAqs7Ga2lCPK29-guru-connector',
    ForgePioHelpjuiceDev: 'forge-connector-f1rvRuAyoDWIwDs7Xubi5AZJTuESM5PC-helpjuice-connector',
    ForgePioHelpjuiceProd: 'forge-connector-8durapLyclxZeEexKkwxw6ZpCRpBz4dP-helpjuice-connector',
    ForgePioHubspotDev: 'forge-connector-RtvzhBL0FFFIjLCBHjXI8QfgDqAs79WF-hubspot-connector',
    ForgePioHubspotProd: 'forge-connector-O19vyTOCxgkZ6KSHycRjpzC0543x6Z0J-hubspot-connector',
    ForgePioSalesforceDev: 'forge-connector-50BYkfgS4GXtr6iO8qUeBFbbHHbuFleo-salesforce-connector',
    ForgePioSalesforceProd: 'forge-connector-nn5lJU1KJxJsUNML5GWV3blDYHMT6nAb-salesforce-connector',
    ForgePioSharepointDev: 'forge-connector-cl5i3J8L463hTuQiDt7f1mK4vZllsAo0-sharepoint-connector',
    ForgePioSharepointProd: 'forge-connector-7yrzYPlAOcZAif2tIymeDXBUNUAxI95G-sharepoint-connector',
    ForgePioStackOverflowDev: 'forge-connector-ojk0u9oXGmVmS3BC7VmVSBPPIuuF5df3-stack-overflow-connector',
    ForgePioStackOverflowProd: 'forge-connector-vUmPXguTcgLzdG1R3H0kTUQwxoGnZcsS-stack-overflow-connector',
    ForgeUtoolityGitbookDev: 'forge-connector-FEJ0dhTb8HC3UYmqhPAKYCWVTcpoHsp5-gitbook-connector',
    ForgeUtoolityGitbookProd: 'forge-connector-byNN1wfDuTnx7VndySG7Qq3ZfoXudUcL-gitbook-connector',
    ForgeGdriveEugeneTestDev: 'forge-connector-s7M8FnmJVPQh9FtRqvqwSL3QFtqMijua-gdrive',
    ForgeGdriveEugeneTestProd: 'forge-connector-bkRlqLiPfviKrVtbA6Q0QGN22x6b37mf-gdrive',
    ForgeUnitoSalesforceDev: 'forge-connector-h8rZu86YJHRfyVlmVeUR464Kuhz9OZvV-salesforce',
    ForgeUnitoSalesforceProd: 'forge-connector-qjk3Z8Kt2DWx29hdZHQapEYXAGCPIyd8-salesforce',
    ForgeUnitoServicenowDev: 'forge-connector-52qcnF9TIgxkDKY4OL7xNxAzcM0amb7q-servicenow',
    ForgeUnitoServicenowProd: 'forge-connector-RzFogW4EQLcXYmYpKkItRUhLAn3jETMq-servicenow',
    ForgeUnitoWrikeDev: 'forge-connector-gw0rFhQkj7PuTllmYdHbMaPw6jC18YvO-wrike',
    ForgeUnitoWrikeProd: 'forge-connector-390XhSnH4YgwqVgmyqYOujxVoL3IOUcM-wrike',
    ForgeUnitoAsanaDev: 'forge-connector-6wHDDwNbam77WvGwMKYMGDiTWP8pza54-asana',
    ForgeUnitoAsanaProd: 'forge-connector-sFXfxz3XEDS1wAWWCe345UVrSbUm9zyb-asana',
    ForgeUnitoBasecampDev: 'forge-connector-nImlCTNLZUCtQzFsthpnlYJL0B981lMH-basecamp',
    ForgeUnitoBasecampProd: 'forge-connector-TZqLHQtzvKxRikkh1KQlp4acwCzS5W1Z-basecamp',
    Gong: 'gong',
    Zoom: 'zoom'
};
const $dce31c4071a2ecfb$export$5378b945bea99ba3 = {
    AtlassianWebCrawler: 'webcrawler-connector',
    Figma: 'figma-connector',
    Github: 'github-connector',
    GoogleDrive: 'google-drive-connector',
    OneDrive: 'onedrive-connector',
    Dropbox: 'dropbox-connector',
    Slack: 'slack-connector',
    Sharepoint: 'sharepoint-connector',
    Teams: 'microsoft-teams-connector',
    GoogleCalendar: 'google-calendar-connector',
    OutlookCalendar: 'outlook-calendar-connector',
    OutlookMail: 'outlook-mail-connector',
    Gmail: 'gmail-connector',
    AdobeSign: 'adobe-sign-connector',
    Asana: 'asana-connector',
    Zendesk: 'zendesk-connector',
    Airtable: 'airtable-connector',
    Smartsheet: 'smartsheet-connector',
    Notion: 'notion-connector',
    Miro: 'miro-connector',
    Docusign: 'docusign-connector',
    Lucid: 'lucid-connector',
    Monday: 'monday-connector',
    AzureDevops: 'azure-devops-connector',
    Gitlab: 'gitlab-connector',
    ConfluenceDC: 'confluence-dc-connector',
    JiraDC: 'jira-dc-connector',
    JsmDC: 'jsm-dc-connector',
    Canva: 'canva-connector',
    Box: 'box-connector',
    Zeplin: 'smartlinks-connector-zeplin',
    ServiceNow: 'servicenow-connector',
    Freshservice: 'freshservice-connector',
    PowerBI: 'smartlinks-connector-power-bi',
    ClickUp: 'smartlinks-connector-clickup',
    Amplitude: 'smartlinks-connector-amplitude',
    Stripe: 'smartlinks-connector-stripe',
    AdobeXD: 'smartlinks-connector-adobexd',
    Aha: 'aha-connector',
    Mural: 'smartlinks-connector-mural',
    Webex: 'smartlinks-connector-webex',
    Todoist: 'smartlinks-connector-todoist',
    PagerDuty: 'smartlinks-connector-pagerduty',
    Pipedrive: 'smartlinks-connector-pipedrive',
    Hubspot: 'hubspot-connector',
    Dovetail: 'smartlinks-connector-dovetail',
    LaunchDarkly: 'smartlinks-connector-launchdarkly',
    Salesforce: 'salesforce-connector',
    Sentry: 'smartlinks-connector-sentry',
    Gitbook: 'gitbook-connector',
    AWSS3: 'aws-s3-connector',
    Databricks: 'databricks-connector',
    ForgeAdamVitareqDev: 'forge-connector-dAkghOClvWGokDftTTaIgNoD6pnNt74z-vitareq-connector',
    ForgeAdamVitareqProd: 'forge-connector-EjfoGWrWrETl3Zc5zkGynPyESZO5Qu93-vitareq-connector',
    ForgeK15tScrollSitesDev: 'forge-connector-h1n3NRFAn84v7ECSONVidlCS88qZh8cy-scroll-sites-connector',
    ForgeK15tScrollSitesProd: 'forge-connector-ofe9zXccOCQ3U4t4kDVywSyJUoZjb1sO-scroll-sites-connector',
    ForgePioAwsDev: 'forge-connector-HaxJprV0zzjjvwLhGkAN2gDPhHZwXNiL-s3-connector',
    ForgePioAwsProd: 'forge-connector-mRcqWRwqkUd4JwapGkvGHUViyySX9MVy-s3-connector',
    ForgePioClickupDev: 'forge-connector-ELuz3hTMhig0Jdrr6ytI45SifO9DfKrY-clickup-connector',
    ForgePioClickupProd: 'forge-connector-uwYqtNjM6w0QIhHOFG0Cq4cnkUM9mt3K-clickup-connector',
    ForgePioGitbookDev: 'forge-connector-Xh70v2yqkzOjTQqTMLxk1lElehWIXoYi-gitbook-connector',
    ForgePioGitbookProd: 'forge-connector-cQ1IDSmJT0DrQuF8pGa4ijz0XZ6IGF5u-gitbook-connector',
    ForgePioGithubDev: 'forge-connector-3QYYBgeNDilQB3Jc7uGMCchNgUGvCi7j-github-connector',
    ForgePioGithubProd: 'forge-connector-0Sw5Yr860fgfx5sYS7kEUoxnGhEvrhhI-github-connector',
    ForgePioGitlabDev: 'forge-connector-psr1wBkasRuKCwsvwi4aTJNhjmlVFebC-gitlab-connector',
    ForgePioGitlabProd: 'forge-connector-QLK5Xf8nBqejSZTulw5s3Cl6fIS24MwL-gitlab-connector',
    ForgePioGoogleDriveDev: 'forge-connector-JhqjCcAP6AHHxkYhY2akTgZsYXY93SMq-google-drive-connector',
    ForgePioGoogleDriveProd: 'forge-connector-pcIwW04B398CSnilRIyzPJ5v5GevlCCo-google-drive-connector',
    ForgePioGuruDev: 'forge-connector-NtY3W5Z8JTBshAgPZFIfT7VjYAARj1P5-guru-connector',
    ForgePioGuruProd: 'forge-connector-mulxOVrXWOZObhFZH5WAqs7Ga2lCPK29-guru-connector',
    ForgePioHelpjuiceDev: 'forge-connector-f1rvRuAyoDWIwDs7Xubi5AZJTuESM5PC-helpjuice-connector',
    ForgePioHelpjuiceProd: 'forge-connector-8durapLyclxZeEexKkwxw6ZpCRpBz4dP-helpjuice-connector',
    ForgePioHubspotDev: 'forge-connector-RtvzhBL0FFFIjLCBHjXI8QfgDqAs79WF-hubspot-connector',
    ForgePioHubspotProd: 'forge-connector-O19vyTOCxgkZ6KSHycRjpzC0543x6Z0J-hubspot-connector',
    ForgePioSalesforceDev: 'forge-connector-50BYkfgS4GXtr6iO8qUeBFbbHHbuFleo-salesforce-connector',
    ForgePioSalesforceProd: 'forge-connector-nn5lJU1KJxJsUNML5GWV3blDYHMT6nAb-salesforce-connector',
    ForgePioSharepointDev: 'forge-connector-cl5i3J8L463hTuQiDt7f1mK4vZllsAo0-sharepoint-connector',
    ForgePioSharepointProd: 'forge-connector-7yrzYPlAOcZAif2tIymeDXBUNUAxI95G-sharepoint-connector',
    ForgePioStackOverflowDev: 'forge-connector-ojk0u9oXGmVmS3BC7VmVSBPPIuuF5df3-stack-overflow-connector',
    ForgePioStackOverflowProd: 'forge-connector-vUmPXguTcgLzdG1R3H0kTUQwxoGnZcsS-stack-overflow-connector',
    ForgeUtoolityGitbookDev: 'forge-connector-FEJ0dhTb8HC3UYmqhPAKYCWVTcpoHsp5-gitbook-connector',
    ForgeUtoolityGitbookProd: 'forge-connector-byNN1wfDuTnx7VndySG7Qq3ZfoXudUcL-gitbook-connector',
    ForgeGdriveEugeneTestDev: 'forge-connector-s7M8FnmJVPQh9FtRqvqwSL3QFtqMijua-gdrive',
    ForgeGdriveEugeneTestProd: 'forge-connector-bkRlqLiPfviKrVtbA6Q0QGN22x6b37mf-gdrive',
    ForgeUnitoSalesforceDev: 'forge-connector-h8rZu86YJHRfyVlmVeUR464Kuhz9OZvV-salesforce',
    ForgeUnitoSalesforceProd: 'forge-connector-qjk3Z8Kt2DWx29hdZHQapEYXAGCPIyd8-salesforce',
    ForgeUnitoServicenowDev: 'forge-connector-52qcnF9TIgxkDKY4OL7xNxAzcM0amb7q-servicenow',
    ForgeUnitoServicenowProd: 'forge-connector-RzFogW4EQLcXYmYpKkItRUhLAn3jETMq-servicenow',
    ForgeUnitoWrikeDev: 'forge-connector-gw0rFhQkj7PuTllmYdHbMaPw6jC18YvO-wrike',
    ForgeUnitoWrikeProd: 'forge-connector-390XhSnH4YgwqVgmyqYOujxVoL3IOUcM-wrike',
    ForgeUnitoAsanaDev: 'forge-connector-6wHDDwNbam77WvGwMKYMGDiTWP8pza54-asana',
    ForgeUnitoAsanaProd: 'forge-connector-sFXfxz3XEDS1wAWWCe345UVrSbUm9zyb-asana',
    ForgeUnitoBasecampDev: 'forge-connector-nImlCTNLZUCtQzFsthpnlYJL0B981lMH-basecamp',
    ForgeUnitoBasecampProd: 'forge-connector-TZqLHQtzvKxRikkh1KQlp4acwCzS5W1Z-basecamp',
    Gong: 'gong-connector',
    Zoom: 'zoom-connector'
};
module.exports["ProductKeys3P"] = $dce31c4071a2ecfb$export$93aa518ca2694c2d;
module.exports["ProductResourceTypes3P"] = $dce31c4071a2ecfb$export$5378b945bea99ba3;

});

parcelRegister("dAuCI", function(module, exports) {

var $fR63l = parcelRequire("fR63l");


class $a264614d865c7774$export$50e7f6c2eabc665 {
    /**
   * Returns the number of registered configs.
   */ get size() {
        return this.factories.size;
    }
    /**
   * Checks whether a config is registered for the given key.
   */ has(key) {
        return this.factories.has(key);
    }
    /**
   * Returns all registered product keys synchronously.
   */ keys() {
        return Array.from(this.factories.keys());
    }
    /**
   * Asynchronously retrieves a single config by key.
   * The config module is loaded on first access and cached thereafter.
   */ async get(key) {
        if (this.cache.has(key)) return this.cache.get(key);
        const factory = this.factories.get(key);
        if (!factory) return undefined;
        const config = await factory();
        this.cache.set(key, config);
        return config;
    }
    /**
   * Asynchronously iterates over all entries, invoking the callback for each.
   * Each config is lazily loaded as the iteration reaches it.
   */ async forEach(callbackfn) {
        for (const key of this.factories.keys()){
            const config = await this.get(key);
            if (config) await callbackfn(config, key);
        }
    }
    /**
   * Async generator that yields [key, config] entries lazily.
   */ async *entries() {
        for (const key of this.factories.keys()){
            const config = await this.get(key);
            if (config) yield [
                key,
                config
            ];
        }
    }
    /**
   * Async generator that yields config values lazily.
   */ async *values() {
        for (const key of this.factories.keys()){
            const config = await this.get(key);
            if (config) yield config;
        }
    }
    /**
   * Resolves all configs and returns them as a standard Map.
   * Useful when all configs are needed at once.
   */ async getAll() {
        const result = new Map();
        for (const key of this.factories.keys()){
            const config = await this.get(key);
            if (config) result.set(key, config);
        }
        return result;
    }
    constructor(entries){
        this.factories = void 0;
        this.cache = new Map();
        this.factories = new Map(entries);
    }
}

































































































































































































const $a264614d865c7774$export$f7937c5f282f2571 = new $a264614d865c7774$export$50e7f6c2eabc665([
    [
        (0, $fR63l.ProductKeys3P).AtlassianWebCrawler,
        ()=>(parcelRequire("iBxe8")).then((m)=>m.atlassianWebCrawlerConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Figma,
        ()=>(parcelRequire("gT6ig")).then((m)=>m.figmaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Github,
        ()=>(parcelRequire("ctb8J")).then((m)=>m.githubConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).GoogleDrive,
        ()=>(parcelRequire("aBc9a")).then((m)=>m.googleDriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Sharepoint,
        ()=>(parcelRequire("gPij5")).then((m)=>m.sharepointConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Loom,
        ()=>(parcelRequire("7boTC")).then((m)=>m.loomConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).OneDrive,
        ()=>(parcelRequire("6GYA1")).then((m)=>m.oneDriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Dropbox,
        ()=>(parcelRequire("62RGF")).then((m)=>m.dropboxConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Slack,
        ()=>(parcelRequire("df2sa")).then((m)=>m.slackConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Teams,
        ()=>(parcelRequire("TPBVI")).then((m)=>m.teamsConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).GoogleCalendar,
        ()=>(parcelRequire("1EmMA")).then((m)=>m.googleCalendarConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Gmail,
        ()=>(parcelRequire("gsNVH")).then((m)=>m.gmailConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).OutlookCalendar,
        ()=>(parcelRequire("lr0CG")).then((m)=>m.outlookCalendarConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).OutlookMail,
        ()=>(parcelRequire("83jvW")).then((m)=>m.outlookMail)
    ],
    [
        (0, $fR63l.ProductKeys3P).Asana,
        ()=>(parcelRequire("aMNB6")).then((m)=>m.asanaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Zendesk,
        ()=>(parcelRequire("74xIl")).then((m)=>m.zendeskConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Airtable,
        ()=>(parcelRequire("8Vszy")).then((m)=>m.airtableConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Smartsheet,
        ()=>(parcelRequire("b22hO")).then((m)=>m.smartsheetConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Notion,
        ()=>(parcelRequire("cEdIY")).then((m)=>m.notionConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Miro,
        ()=>(parcelRequire("31RHj")).then((m)=>m.miroConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Docusign,
        ()=>(parcelRequire("02Ynr")).then((m)=>m.docusignConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Lucid,
        ()=>(parcelRequire("fwd4N")).then((m)=>m.lucidConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Monday,
        ()=>(parcelRequire("2RnL3")).then((m)=>m.mondayConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AzureDevops,
        ()=>(parcelRequire("58OWX")).then((m)=>m.azureDevopsConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Gitlab,
        ()=>(parcelRequire("kL104")).then((m)=>m.gitlabConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ConfluenceDC,
        ()=>(parcelRequire("1qFjr")).then((m)=>m.confluenceDCConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).JiraDC,
        ()=>(parcelRequire("8jbCm")).then((m)=>m.jiraDCConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).JsmDC,
        ()=>(parcelRequire("cffKz")).then((m)=>m.jsmDCConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Canva,
        ()=>(parcelRequire("3QlPK")).then((m)=>m.canvaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Box,
        ()=>(parcelRequire("hElI5")).then((m)=>m.boxConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Zoom,
        ()=>(parcelRequire("a5g8K")).then((m)=>m.zoomConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Zeplin,
        ()=>(parcelRequire("bgwDS")).then((m)=>m.zeplinConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ServiceNow,
        ()=>(parcelRequire("lAH85")).then((m)=>m.serviceNowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Freshservice,
        ()=>(parcelRequire("iKBOF")).then((m)=>m.freshserviceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).PowerBI,
        ()=>(parcelRequire("5pBM8")).then((m)=>m.powerBIConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ClickUp,
        ()=>(parcelRequire("92ME9")).then((m)=>m.clickUpConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Amplitude,
        ()=>(parcelRequire("6Jh1p")).then((m)=>m.amplitudeConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Stripe,
        ()=>(parcelRequire("jzPn4")).then((m)=>m.stripeConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AdobeXD,
        ()=>(parcelRequire("kZqu6")).then((m)=>m.adobeXDConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Aha,
        ()=>(parcelRequire("ajtDF")).then((m)=>m.ahaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AdobeSign,
        ()=>(parcelRequire("fKfb7")).then((m)=>m.adobeSignConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Mural,
        ()=>(parcelRequire("hXJgg")).then((m)=>m.muralConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Webex,
        ()=>(parcelRequire("hhNgf")).then((m)=>m.webexConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Todoist,
        ()=>(parcelRequire("crz44")).then((m)=>m.todoistConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).PagerDuty,
        ()=>(parcelRequire("3Igok")).then((m)=>m.pagerDutyConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Pipedrive,
        ()=>(parcelRequire("cz85h")).then((m)=>m.pipedriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Hubspot,
        ()=>(parcelRequire("dvJin")).then((m)=>m.hubSpotConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Dovetail,
        ()=>(parcelRequire("7Mz2I")).then((m)=>m.dovetailConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).LaunchDarkly,
        ()=>(parcelRequire("aiSZX")).then((m)=>m.launchDarklyConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Salesforce,
        ()=>(parcelRequire("9EADZ")).then((m)=>m.salesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Sentry,
        ()=>(parcelRequire("8PK6n")).then((m)=>m.sentryConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Gitbook,
        ()=>(parcelRequire("jctME")).then((m)=>m.gitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AWSS3,
        ()=>(parcelRequire("bR0Iu")).then((m)=>m.awss3Config)
    ],
    [
        (0, $fR63l.ProductKeys3P).Databricks,
        ()=>(parcelRequire("3jXBQ")).then((m)=>m.databricksConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeAdamVitareqDev,
        ()=>(parcelRequire("bAiH4")).then((m)=>m.forgeAdamVitareqConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeAdamVitareqProd,
        ()=>(parcelRequire("1xgz2")).then((m)=>m.forgeAdamVitareqConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeK15tScrollSitesDev,
        ()=>(parcelRequire("4RPDt")).then((m)=>m.forgeK15tScrollSitesConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeK15tScrollSitesProd,
        ()=>(parcelRequire("fsXZE")).then((m)=>m.forgeK15tScrollSitesConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioAwsDev,
        ()=>(parcelRequire("9aDYK")).then((m)=>m.forgePioAwsConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioAwsProd,
        ()=>(parcelRequire("6JW0P")).then((m)=>m.forgePioAwsConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioClickupDev,
        ()=>(parcelRequire("Uh4Xn")).then((m)=>m.forgePioClickupConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioClickupProd,
        ()=>(parcelRequire("jirMU")).then((m)=>m.forgePioClickupConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGitbookDev,
        ()=>(parcelRequire("lemnx")).then((m)=>m.forgePioGitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGitbookProd,
        ()=>(parcelRequire("dzON5")).then((m)=>m.forgePioGitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGithubDev,
        ()=>(parcelRequire("bhHm2")).then((m)=>m.forgePioGithubConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGithubProd,
        ()=>(parcelRequire("cpHnm")).then((m)=>m.forgePioGithubConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGitlabDev,
        ()=>(parcelRequire("kdTUL")).then((m)=>m.forgePioGitlabConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGitlabProd,
        ()=>(parcelRequire("2ixRt")).then((m)=>m.forgePioGitlabConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGoogleDriveDev,
        ()=>(parcelRequire("41BIu")).then((m)=>m.forgePioGoogleDriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGoogleDriveProd,
        ()=>(parcelRequire("6s4rU")).then((m)=>m.forgePioGoogleDriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGuruDev,
        ()=>(parcelRequire("6KzzT")).then((m)=>m.forgePioGuruConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGuruProd,
        ()=>(parcelRequire("9DwSf")).then((m)=>m.forgePioGuruConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioHelpjuiceDev,
        ()=>(parcelRequire("gxp6w")).then((m)=>m.forgePioHelpjuiceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioHelpjuiceProd,
        ()=>(parcelRequire("aYbsr")).then((m)=>m.forgePioHelpjuiceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioHubspotDev,
        ()=>(parcelRequire("acx6k")).then((m)=>m.forgePioHubspotConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioHubspotProd,
        ()=>(parcelRequire("iWCTF")).then((m)=>m.forgePioHubspotConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioSalesforceDev,
        ()=>(parcelRequire("2tWj9")).then((m)=>m.forgePioSalesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioSalesforceProd,
        ()=>(parcelRequire("arh0c")).then((m)=>m.forgePioSalesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioSharepointDev,
        ()=>(parcelRequire("fb826")).then((m)=>m.forgePioSharepointConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioSharepointProd,
        ()=>(parcelRequire("iO6my")).then((m)=>m.forgePioSharepointConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioStackOverflowDev,
        ()=>(parcelRequire("cXcSd")).then((m)=>m.forgePioStackOverflowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioStackOverflowProd,
        ()=>(parcelRequire("bIQJz")).then((m)=>m.forgePioStackOverflowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUtoolityGitbookDev,
        ()=>(parcelRequire("8ILPc")).then((m)=>m.forgeUtoolityGitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUtoolityGitbookProd,
        ()=>(parcelRequire("hUid6")).then((m)=>m.forgeUtoolityGitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeGdriveEugeneTestDev,
        ()=>(parcelRequire("4ZlVU")).then((m)=>m.forgeGdriveEugeneTestDevConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeGdriveEugeneTestProd,
        ()=>(parcelRequire("ft0CM")).then((m)=>m.forgeGdriveEugeneTestProdConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoSalesforceDev,
        ()=>(parcelRequire("4EGFU")).then((m)=>m.forgeUnitoSalesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoSalesforceProd,
        ()=>(parcelRequire("hJUgO")).then((m)=>m.forgeUnitoSalesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoServicenowDev,
        ()=>(parcelRequire("26Y6c")).then((m)=>m.forgeUnitoServicenowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoServicenowProd,
        ()=>(parcelRequire("k2jJ5")).then((m)=>m.forgeUnitoServicenowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoWrikeDev,
        ()=>(parcelRequire("8t1lq")).then((m)=>m.forgeUnitoWrikeConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoWrikeProd,
        ()=>(parcelRequire("9uiEL")).then((m)=>m.forgeUnitoWrikeConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoAsanaDev,
        ()=>(parcelRequire("lghtg")).then((m)=>m.forgeUnitoAsanaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoAsanaProd,
        ()=>(parcelRequire("3qEIn")).then((m)=>m.forgeUnitoAsanaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoBasecampDev,
        ()=>(parcelRequire("fbkFk")).then((m)=>m.forgeUnitoBasecampConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoBasecampProd,
        ()=>(parcelRequire("lcUNq")).then((m)=>m.forgeUnitoBasecampConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AtlassianWebCrawler,
        ()=>(parcelRequire("iBxe8")).then((m)=>m.atlassianWebCrawlerConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Figma,
        ()=>(parcelRequire("gT6ig")).then((m)=>m.figmaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Github,
        ()=>(parcelRequire("ctb8J")).then((m)=>m.githubConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).GoogleDrive,
        ()=>(parcelRequire("aBc9a")).then((m)=>m.googleDriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Sharepoint,
        ()=>(parcelRequire("gPij5")).then((m)=>m.sharepointConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Loom,
        ()=>(parcelRequire("7boTC")).then((m)=>m.loomConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).OneDrive,
        ()=>(parcelRequire("6GYA1")).then((m)=>m.oneDriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Dropbox,
        ()=>(parcelRequire("62RGF")).then((m)=>m.dropboxConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Slack,
        ()=>(parcelRequire("df2sa")).then((m)=>m.slackConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Teams,
        ()=>(parcelRequire("TPBVI")).then((m)=>m.teamsConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).GoogleCalendar,
        ()=>(parcelRequire("1EmMA")).then((m)=>m.googleCalendarConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Gmail,
        ()=>(parcelRequire("gsNVH")).then((m)=>m.gmailConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).OutlookCalendar,
        ()=>(parcelRequire("lr0CG")).then((m)=>m.outlookCalendarConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).OutlookMail,
        ()=>(parcelRequire("83jvW")).then((m)=>m.outlookMail)
    ],
    [
        (0, $fR63l.ProductKeys3P).Asana,
        ()=>(parcelRequire("aMNB6")).then((m)=>m.asanaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Zendesk,
        ()=>(parcelRequire("74xIl")).then((m)=>m.zendeskConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Airtable,
        ()=>(parcelRequire("8Vszy")).then((m)=>m.airtableConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Smartsheet,
        ()=>(parcelRequire("b22hO")).then((m)=>m.smartsheetConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Notion,
        ()=>(parcelRequire("cEdIY")).then((m)=>m.notionConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Miro,
        ()=>(parcelRequire("31RHj")).then((m)=>m.miroConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Docusign,
        ()=>(parcelRequire("02Ynr")).then((m)=>m.docusignConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Lucid,
        ()=>(parcelRequire("fwd4N")).then((m)=>m.lucidConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Monday,
        ()=>(parcelRequire("2RnL3")).then((m)=>m.mondayConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AzureDevops,
        ()=>(parcelRequire("58OWX")).then((m)=>m.azureDevopsConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Gitlab,
        ()=>(parcelRequire("kL104")).then((m)=>m.gitlabConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ConfluenceDC,
        ()=>(parcelRequire("1qFjr")).then((m)=>m.confluenceDCConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).JiraDC,
        ()=>(parcelRequire("8jbCm")).then((m)=>m.jiraDCConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).JsmDC,
        ()=>(parcelRequire("cffKz")).then((m)=>m.jsmDCConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Canva,
        ()=>(parcelRequire("3QlPK")).then((m)=>m.canvaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Box,
        ()=>(parcelRequire("hElI5")).then((m)=>m.boxConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Gong,
        ()=>(parcelRequire("7isp4")).then((m)=>m.gongConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Zoom,
        ()=>(parcelRequire("a5g8K")).then((m)=>m.zoomConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Zeplin,
        ()=>(parcelRequire("bgwDS")).then((m)=>m.zeplinConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ServiceNow,
        ()=>(parcelRequire("lAH85")).then((m)=>m.serviceNowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Freshservice,
        ()=>(parcelRequire("iKBOF")).then((m)=>m.freshserviceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).PowerBI,
        ()=>(parcelRequire("5pBM8")).then((m)=>m.powerBIConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ClickUp,
        ()=>(parcelRequire("92ME9")).then((m)=>m.clickUpConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Amplitude,
        ()=>(parcelRequire("6Jh1p")).then((m)=>m.amplitudeConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Stripe,
        ()=>(parcelRequire("jzPn4")).then((m)=>m.stripeConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AdobeXD,
        ()=>(parcelRequire("kZqu6")).then((m)=>m.adobeXDConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Aha,
        ()=>(parcelRequire("ajtDF")).then((m)=>m.ahaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AdobeSign,
        ()=>(parcelRequire("fKfb7")).then((m)=>m.adobeSignConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Mural,
        ()=>(parcelRequire("hXJgg")).then((m)=>m.muralConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Webex,
        ()=>(parcelRequire("hhNgf")).then((m)=>m.webexConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Todoist,
        ()=>(parcelRequire("crz44")).then((m)=>m.todoistConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).PagerDuty,
        ()=>(parcelRequire("3Igok")).then((m)=>m.pagerDutyConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Pipedrive,
        ()=>(parcelRequire("cz85h")).then((m)=>m.pipedriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Hubspot,
        ()=>(parcelRequire("dvJin")).then((m)=>m.hubSpotConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Dovetail,
        ()=>(parcelRequire("7Mz2I")).then((m)=>m.dovetailConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).LaunchDarkly,
        ()=>(parcelRequire("aiSZX")).then((m)=>m.launchDarklyConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Salesforce,
        ()=>(parcelRequire("9EADZ")).then((m)=>m.salesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Sentry,
        ()=>(parcelRequire("8PK6n")).then((m)=>m.sentryConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Gitbook,
        ()=>(parcelRequire("jctME")).then((m)=>m.gitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AWSS3,
        ()=>(parcelRequire("bR0Iu")).then((m)=>m.awss3Config)
    ],
    [
        (0, $fR63l.ProductKeys3P).Databricks,
        ()=>(parcelRequire("3jXBQ")).then((m)=>m.databricksConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeAdamVitareqDev,
        ()=>(parcelRequire("bAiH4")).then((m)=>m.forgeAdamVitareqConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeAdamVitareqProd,
        ()=>(parcelRequire("1xgz2")).then((m)=>m.forgeAdamVitareqConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeK15tScrollSitesDev,
        ()=>(parcelRequire("4RPDt")).then((m)=>m.forgeK15tScrollSitesConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeK15tScrollSitesProd,
        ()=>(parcelRequire("fsXZE")).then((m)=>m.forgeK15tScrollSitesConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioAwsDev,
        ()=>(parcelRequire("9aDYK")).then((m)=>m.forgePioAwsConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioAwsProd,
        ()=>(parcelRequire("6JW0P")).then((m)=>m.forgePioAwsConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioClickupDev,
        ()=>(parcelRequire("Uh4Xn")).then((m)=>m.forgePioClickupConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioClickupProd,
        ()=>(parcelRequire("jirMU")).then((m)=>m.forgePioClickupConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGitbookDev,
        ()=>(parcelRequire("lemnx")).then((m)=>m.forgePioGitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGitbookProd,
        ()=>(parcelRequire("dzON5")).then((m)=>m.forgePioGitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGithubDev,
        ()=>(parcelRequire("bhHm2")).then((m)=>m.forgePioGithubConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGithubProd,
        ()=>(parcelRequire("cpHnm")).then((m)=>m.forgePioGithubConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGitlabDev,
        ()=>(parcelRequire("kdTUL")).then((m)=>m.forgePioGitlabConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGitlabProd,
        ()=>(parcelRequire("2ixRt")).then((m)=>m.forgePioGitlabConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGoogleDriveDev,
        ()=>(parcelRequire("41BIu")).then((m)=>m.forgePioGoogleDriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGoogleDriveProd,
        ()=>(parcelRequire("6s4rU")).then((m)=>m.forgePioGoogleDriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGuruDev,
        ()=>(parcelRequire("6KzzT")).then((m)=>m.forgePioGuruConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGuruProd,
        ()=>(parcelRequire("9DwSf")).then((m)=>m.forgePioGuruConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioHelpjuiceDev,
        ()=>(parcelRequire("gxp6w")).then((m)=>m.forgePioHelpjuiceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioHelpjuiceProd,
        ()=>(parcelRequire("aYbsr")).then((m)=>m.forgePioHelpjuiceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioHubspotDev,
        ()=>(parcelRequire("acx6k")).then((m)=>m.forgePioHubspotConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioHubspotProd,
        ()=>(parcelRequire("iWCTF")).then((m)=>m.forgePioHubspotConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioSalesforceDev,
        ()=>(parcelRequire("2tWj9")).then((m)=>m.forgePioSalesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioSalesforceProd,
        ()=>(parcelRequire("arh0c")).then((m)=>m.forgePioSalesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioSharepointDev,
        ()=>(parcelRequire("fb826")).then((m)=>m.forgePioSharepointConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioSharepointProd,
        ()=>(parcelRequire("iO6my")).then((m)=>m.forgePioSharepointConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioStackOverflowDev,
        ()=>(parcelRequire("cXcSd")).then((m)=>m.forgePioStackOverflowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioStackOverflowProd,
        ()=>(parcelRequire("bIQJz")).then((m)=>m.forgePioStackOverflowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUtoolityGitbookDev,
        ()=>(parcelRequire("8ILPc")).then((m)=>m.forgeUtoolityGitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUtoolityGitbookProd,
        ()=>(parcelRequire("hUid6")).then((m)=>m.forgeUtoolityGitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeGdriveEugeneTestDev,
        ()=>(parcelRequire("4ZlVU")).then((m)=>m.forgeGdriveEugeneTestDevConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeGdriveEugeneTestProd,
        ()=>(parcelRequire("ft0CM")).then((m)=>m.forgeGdriveEugeneTestProdConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoSalesforceDev,
        ()=>(parcelRequire("4EGFU")).then((m)=>m.forgeUnitoSalesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoSalesforceProd,
        ()=>(parcelRequire("hJUgO")).then((m)=>m.forgeUnitoSalesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoServicenowDev,
        ()=>(parcelRequire("26Y6c")).then((m)=>m.forgeUnitoServicenowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoServicenowProd,
        ()=>(parcelRequire("k2jJ5")).then((m)=>m.forgeUnitoServicenowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoWrikeDev,
        ()=>(parcelRequire("8t1lq")).then((m)=>m.forgeUnitoWrikeConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoWrikeProd,
        ()=>(parcelRequire("9uiEL")).then((m)=>m.forgeUnitoWrikeConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoAsanaDev,
        ()=>(parcelRequire("lghtg")).then((m)=>m.forgeUnitoAsanaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoAsanaProd,
        ()=>(parcelRequire("3qEIn")).then((m)=>m.forgeUnitoAsanaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoBasecampDev,
        ()=>(parcelRequire("fbkFk")).then((m)=>m.forgeUnitoBasecampConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoBasecampProd,
        ()=>(parcelRequire("lcUNq")).then((m)=>m.forgeUnitoBasecampConfig)
    ]
]);
const $a264614d865c7774$var$productKeys3PValues = new Set(Object.values((0, $fR63l.ProductKeys3P)));
const $a264614d865c7774$export$985cb3900add20c8 = (value)=>$a264614d865c7774$var$productKeys3PValues.has(value);
module.exports["ThirdPartyConfigs"] = $a264614d865c7774$export$f7937c5f282f2571;
module.exports["isProductKey3P"] = $a264614d865c7774$export$985cb3900add20c8;

});

parcelRegister("iBxe8", function(module, exports) {

let $d8b574e2a5cc37c1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d8b574e2a5cc37c1$var$load("6wr18"),
    $d8b574e2a5cc37c1$var$load("ffEVr"),
    $d8b574e2a5cc37c1$var$load("bRtkB")
]).then(()=>parcelRequire('jAKKt'));

});

parcelRegister("gT6ig", function(module, exports) {

let $c4b6aa311ef513a4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c4b6aa311ef513a4$var$load("aF2C4").then(()=>parcelRequire('7dzhu'));

});

parcelRegister("ctb8J", function(module, exports) {

let $9140d59f8ad886b7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9140d59f8ad886b7$var$load("3eAWG").then(()=>parcelRequire('aZX0c'));

});

parcelRegister("aBc9a", function(module, exports) {

let $7b76c832d4976913$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7b76c832d4976913$var$load("1HPRy").then(()=>parcelRequire('kFYBW'));

});

parcelRegister("gPij5", function(module, exports) {

let $c3ff9c1894b5ec04$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c3ff9c1894b5ec04$var$load("7zQG2").then(()=>parcelRequire('gOrBS'));

});

parcelRegister("7boTC", function(module, exports) {

let $53acdf53cb7a2bb3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $53acdf53cb7a2bb3$var$load("h0X0x"),
    $53acdf53cb7a2bb3$var$load("7l4Nc"),
    $53acdf53cb7a2bb3$var$load("fdFOR")
]).then(()=>parcelRequire('lSeWC'));

});

parcelRegister("6GYA1", function(module, exports) {

let $4df5a84501aea93d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4df5a84501aea93d$var$load("hUZCM").then(()=>parcelRequire('4TRyZ'));

});

parcelRegister("62RGF", function(module, exports) {

let $466c932715083697$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $466c932715083697$var$load("2zKe1").then(()=>parcelRequire('2qza4'));

});

parcelRegister("df2sa", function(module, exports) {

let $9a3e943c15d3b5a9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9a3e943c15d3b5a9$var$load("dgWVQ").then(()=>parcelRequire('kDG5l'));

});

parcelRegister("TPBVI", function(module, exports) {

let $0a7d2bfe5b7d495f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0a7d2bfe5b7d495f$var$load("3cJjP").then(()=>parcelRequire('6sCQO'));

});

parcelRegister("1EmMA", function(module, exports) {

let $133b3308a7233083$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $133b3308a7233083$var$load("RMzu0").then(()=>parcelRequire('6eg6r'));

});

parcelRegister("gsNVH", function(module, exports) {

let $bfc5fdd4fc7f4d22$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bfc5fdd4fc7f4d22$var$load("4ZzjZ").then(()=>parcelRequire('52jas'));

});

parcelRegister("lr0CG", function(module, exports) {

let $f9ac9a496374d705$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f9ac9a496374d705$var$load("k90dx").then(()=>parcelRequire('ijAga'));

});

parcelRegister("83jvW", function(module, exports) {

let $5dcdbda30e12c09c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5dcdbda30e12c09c$var$load("amIJr").then(()=>parcelRequire('dPp45'));

});

parcelRegister("aMNB6", function(module, exports) {

let $7da4dc18e877575a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7da4dc18e877575a$var$load("gguK2").then(()=>parcelRequire('4Be7r'));

});

parcelRegister("74xIl", function(module, exports) {

let $52630f17b0854dee$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $52630f17b0854dee$var$load("hZzel").then(()=>parcelRequire('kmEEk'));

});

parcelRegister("8Vszy", function(module, exports) {

let $67f9cf78855bdd75$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $67f9cf78855bdd75$var$load("jTrn5").then(()=>parcelRequire('52Drw'));

});

parcelRegister("b22hO", function(module, exports) {

let $8081a799b789106b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8081a799b789106b$var$load("eOlJP").then(()=>parcelRequire('aaz0Y'));

});

parcelRegister("cEdIY", function(module, exports) {

let $9353ddd09a324ff5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9353ddd09a324ff5$var$load("3BeCY").then(()=>parcelRequire('kcCFv'));

});

parcelRegister("31RHj", function(module, exports) {

let $234b1e534467b651$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $234b1e534467b651$var$load("6b6gt").then(()=>parcelRequire('6lsSn'));

});

parcelRegister("02Ynr", function(module, exports) {

let $008f05a6f17f22ea$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $008f05a6f17f22ea$var$load("407Jg").then(()=>parcelRequire('k521G'));

});

parcelRegister("fwd4N", function(module, exports) {

let $b4c3fcde50fe0553$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b4c3fcde50fe0553$var$load("63b2S").then(()=>parcelRequire('43W2t'));

});

parcelRegister("2RnL3", function(module, exports) {

let $2152f5d98da817b1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2152f5d98da817b1$var$load("fJLp0").then(()=>parcelRequire('6ThsT'));

});

parcelRegister("58OWX", function(module, exports) {

let $3be538af45050ae5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3be538af45050ae5$var$load("bzCMM").then(()=>parcelRequire('4x6XK'));

});

parcelRegister("kL104", function(module, exports) {

let $f1c8f9056a588ec3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f1c8f9056a588ec3$var$load("alsd0").then(()=>parcelRequire('382mb'));

});

parcelRegister("1qFjr", function(module, exports) {

let $10a843f1aa70dd2e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $10a843f1aa70dd2e$var$load("h0X0x"),
    $10a843f1aa70dd2e$var$load("7l4Nc"),
    $10a843f1aa70dd2e$var$load("jZNbu")
]).then(()=>parcelRequire('8oQ7k'));

});

parcelRegister("8jbCm", function(module, exports) {

let $60c91c210864c0b6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $60c91c210864c0b6$var$load("h0X0x"),
    $60c91c210864c0b6$var$load("7l4Nc"),
    $60c91c210864c0b6$var$load("cYv6T")
]).then(()=>parcelRequire('79ijY'));

});

parcelRegister("cffKz", function(module, exports) {

let $8ea31a66da7bd737$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $8ea31a66da7bd737$var$load("h0X0x"),
    $8ea31a66da7bd737$var$load("7l4Nc"),
    $8ea31a66da7bd737$var$load("9BBvG")
]).then(()=>parcelRequire('e7BOf'));

});

parcelRegister("3QlPK", function(module, exports) {

let $2cc72a2827e9e607$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2cc72a2827e9e607$var$load("jRzSB").then(()=>parcelRequire('fg2gb'));

});

parcelRegister("hElI5", function(module, exports) {

let $cd9703462afb8136$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cd9703462afb8136$var$load("2MOvO").then(()=>parcelRequire('fauGM'));

});

parcelRegister("a5g8K", function(module, exports) {

let $7576e419eec1cb14$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7576e419eec1cb14$var$load("1Sqxt").then(()=>parcelRequire('bj13p'));

});

parcelRegister("bgwDS", function(module, exports) {

let $833a8266b04eb5a8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $833a8266b04eb5a8$var$load("11sVB").then(()=>parcelRequire('3VdqU'));

});

parcelRegister("lAH85", function(module, exports) {

let $fb7e6a65b66ccf78$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fb7e6a65b66ccf78$var$load("frCen").then(()=>parcelRequire('iN1Vs'));

});

parcelRegister("iKBOF", function(module, exports) {

let $da69db677e750701$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $da69db677e750701$var$load("22bew").then(()=>parcelRequire('fA9zj'));

});

parcelRegister("5pBM8", function(module, exports) {

let $3f0c96f8bef833fc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3f0c96f8bef833fc$var$load("4NtL2").then(()=>parcelRequire('iTxTm'));

});

parcelRegister("92ME9", function(module, exports) {

let $695a0929d74d2f0e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $695a0929d74d2f0e$var$load("3peYA").then(()=>parcelRequire('5pWqV'));

});

parcelRegister("6Jh1p", function(module, exports) {

let $4e642630456ad387$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4e642630456ad387$var$load("DPLw5").then(()=>parcelRequire('juuLe'));

});

parcelRegister("jzPn4", function(module, exports) {

let $e409226bb43ffbc8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e409226bb43ffbc8$var$load("emPuN").then(()=>parcelRequire('3juV6'));

});

parcelRegister("kZqu6", function(module, exports) {

let $f47e0c6fe7314294$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f47e0c6fe7314294$var$load("a8X2u").then(()=>parcelRequire('hIDj1'));

});

parcelRegister("ajtDF", function(module, exports) {

let $7822ab60aaa856ca$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7822ab60aaa856ca$var$load("39rcm").then(()=>parcelRequire('7WW80'));

});

parcelRegister("fKfb7", function(module, exports) {

let $b766ecf99dcb12e7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b766ecf99dcb12e7$var$load("6xDnX").then(()=>parcelRequire('au9jr'));

});

parcelRegister("hXJgg", function(module, exports) {

let $d13b0e50e5899a08$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d13b0e50e5899a08$var$load("bWrbO").then(()=>parcelRequire('diJOH'));

});

parcelRegister("hhNgf", function(module, exports) {

let $c95a3c704c7acf2e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c95a3c704c7acf2e$var$load("e2pEU").then(()=>parcelRequire('5bQLl'));

});

parcelRegister("crz44", function(module, exports) {

let $90f334c6140cf4a0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $90f334c6140cf4a0$var$load("4s14m").then(()=>parcelRequire('dVIA3'));

});

parcelRegister("3Igok", function(module, exports) {

let $2b42321f56861e0b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2b42321f56861e0b$var$load("ake72").then(()=>parcelRequire('emznk'));

});

parcelRegister("cz85h", function(module, exports) {

let $925f063e9e60a948$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $925f063e9e60a948$var$load("icZ4h").then(()=>parcelRequire('fMCQp'));

});

parcelRegister("dvJin", function(module, exports) {

let $9d614e56edab5644$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9d614e56edab5644$var$load("ceQaW").then(()=>parcelRequire('cdiu6'));

});

parcelRegister("7Mz2I", function(module, exports) {

let $5aa832e47052f086$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5aa832e47052f086$var$load("lKvqu").then(()=>parcelRequire('8djpu'));

});

parcelRegister("aiSZX", function(module, exports) {

let $78063f56f0861dfa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $78063f56f0861dfa$var$load("6nEcR").then(()=>parcelRequire('3P9fk'));

});

parcelRegister("9EADZ", function(module, exports) {

let $707446315559077a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $707446315559077a$var$load("5d2zd").then(()=>parcelRequire('lPRuX'));

});

parcelRegister("8PK6n", function(module, exports) {

let $66e6d904c8677960$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $66e6d904c8677960$var$load("lmH6s").then(()=>parcelRequire('2zNcl'));

});

parcelRegister("jctME", function(module, exports) {

let $dfa63db87e8bb2b1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dfa63db87e8bb2b1$var$load("h7ufj").then(()=>parcelRequire('h8Js2'));

});

parcelRegister("bR0Iu", function(module, exports) {

let $8a153339a5d5476b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8a153339a5d5476b$var$load("7ravW").then(()=>parcelRequire('9Om9G'));

});

parcelRegister("3jXBQ", function(module, exports) {

let $26b1629b18db5440$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $26b1629b18db5440$var$load("aZ5Xl").then(()=>parcelRequire('kiNtZ'));

});

parcelRegister("bAiH4", function(module, exports) {

let $86f18eac9cf3c96e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $86f18eac9cf3c96e$var$load("cTH3r").then(()=>parcelRequire('1RpaO'));

});

parcelRegister("1xgz2", function(module, exports) {

let $11e5b8d1886eee68$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $11e5b8d1886eee68$var$load("dne17").then(()=>parcelRequire('jENKA'));

});

parcelRegister("4RPDt", function(module, exports) {

let $38b42a6c124bdd71$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $38b42a6c124bdd71$var$load("cHAvQ").then(()=>parcelRequire('j34lg'));

});

parcelRegister("fsXZE", function(module, exports) {

let $b42801fc65ba38db$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b42801fc65ba38db$var$load("gpIIT").then(()=>parcelRequire('in2Pi'));

});

parcelRegister("9aDYK", function(module, exports) {

let $6ad40f2a8491628c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6ad40f2a8491628c$var$load("8qNIV").then(()=>parcelRequire('7vbr8'));

});

parcelRegister("6JW0P", function(module, exports) {

let $4e83f21bd16f4d79$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4e83f21bd16f4d79$var$load("701fE").then(()=>parcelRequire('k6vRK'));

});

parcelRegister("Uh4Xn", function(module, exports) {

let $0a927a99cc57cc79$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0a927a99cc57cc79$var$load("05bRk").then(()=>parcelRequire('aiL8h'));

});

parcelRegister("jirMU", function(module, exports) {

let $e0c540e00d23fa0c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e0c540e00d23fa0c$var$load("lnWlT").then(()=>parcelRequire('cY0ZT'));

});

parcelRegister("lemnx", function(module, exports) {

let $03fd19ddc4d2f4f5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $03fd19ddc4d2f4f5$var$load("jQK5h").then(()=>parcelRequire('9SYma'));

});

parcelRegister("dzON5", function(module, exports) {

let $9e25f13380966ec6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9e25f13380966ec6$var$load("kg1Ok").then(()=>parcelRequire('ie06K'));

});

parcelRegister("bhHm2", function(module, exports) {

let $8372e98813ff3fca$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8372e98813ff3fca$var$load("kobFT").then(()=>parcelRequire('h5NUz'));

});

parcelRegister("cpHnm", function(module, exports) {

let $90997763425d308b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $90997763425d308b$var$load("bLIUJ").then(()=>parcelRequire('9Y160'));

});

parcelRegister("kdTUL", function(module, exports) {

let $eb906502f834c30e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $eb906502f834c30e$var$load("cklhl").then(()=>parcelRequire('hdy05'));

});

parcelRegister("2ixRt", function(module, exports) {

let $1ac7876a9dbc87f3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1ac7876a9dbc87f3$var$load("2GC7K").then(()=>parcelRequire('djF8v'));

});

parcelRegister("41BIu", function(module, exports) {

let $2ee483264ab9d610$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2ee483264ab9d610$var$load("bD8in").then(()=>parcelRequire('dChew'));

});

parcelRegister("6s4rU", function(module, exports) {

let $4b28cf1866257ad5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4b28cf1866257ad5$var$load("gdVxH").then(()=>parcelRequire('TCovD'));

});

parcelRegister("6KzzT", function(module, exports) {

let $4ea2a2f6c2fe6e5a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4ea2a2f6c2fe6e5a$var$load("7xK5Z").then(()=>parcelRequire('feDPe'));

});

parcelRegister("9DwSf", function(module, exports) {

let $704141aa2412a02b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $704141aa2412a02b$var$load("b4BtI").then(()=>parcelRequire('klS4t'));

});

parcelRegister("gxp6w", function(module, exports) {

let $c0a333981d8cd2fb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c0a333981d8cd2fb$var$load("iljFU").then(()=>parcelRequire('hFdyH'));

});

parcelRegister("aYbsr", function(module, exports) {

let $7fc865388b2cddea$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7fc865388b2cddea$var$load("bXUvd").then(()=>parcelRequire('e6TPF'));

});

parcelRegister("acx6k", function(module, exports) {

let $76d4b38e8201bd79$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $76d4b38e8201bd79$var$load("26c2h").then(()=>parcelRequire('7piBv'));

});

parcelRegister("iWCTF", function(module, exports) {

let $dcabd0daf6868c6b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dcabd0daf6868c6b$var$load("3lk6X").then(()=>parcelRequire('3yXQ1'));

});

parcelRegister("2tWj9", function(module, exports) {

let $1ceb84f13c590a70$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1ceb84f13c590a70$var$load("huBNP").then(()=>parcelRequire('cmwLF'));

});

parcelRegister("arh0c", function(module, exports) {

let $79999d4c2faee95d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $79999d4c2faee95d$var$load("5tJYH").then(()=>parcelRequire('brRUk'));

});

parcelRegister("fb826", function(module, exports) {

let $b0ce1d3dbf7b805f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b0ce1d3dbf7b805f$var$load("ewhxr").then(()=>parcelRequire('dwyZc'));

});

parcelRegister("iO6my", function(module, exports) {

let $db11d5024549f94a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $db11d5024549f94a$var$load("boWJM").then(()=>parcelRequire('9sIt4'));

});

parcelRegister("cXcSd", function(module, exports) {

let $96e4fb255f7ce319$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $96e4fb255f7ce319$var$load("eNHPW").then(()=>parcelRequire('7UyZr'));

});

parcelRegister("bIQJz", function(module, exports) {

let $888cb5a34d15a279$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $888cb5a34d15a279$var$load("kUBpV").then(()=>parcelRequire('2KPYZ'));

});

parcelRegister("8ILPc", function(module, exports) {

let $659787c6ebdd7679$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $659787c6ebdd7679$var$load("baUsS").then(()=>parcelRequire('9lVxQ'));

});

parcelRegister("hUid6", function(module, exports) {

let $d095cad68f060ea0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d095cad68f060ea0$var$load("d0r9z").then(()=>parcelRequire('1HfnT'));

});

parcelRegister("4ZlVU", function(module, exports) {

let $3a1ddf5858170b02$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3a1ddf5858170b02$var$load("hG1ar").then(()=>parcelRequire('9JBuG'));

});

parcelRegister("ft0CM", function(module, exports) {

let $b42a0c6fad21d679$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b42a0c6fad21d679$var$load("kMyku").then(()=>parcelRequire('aHqTQ'));

});

parcelRegister("4EGFU", function(module, exports) {

let $363c002ee4aa7beb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $363c002ee4aa7beb$var$load("3xL2F").then(()=>parcelRequire('34wuK'));

});

parcelRegister("hJUgO", function(module, exports) {

let $cea249b3255b390d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cea249b3255b390d$var$load("7Ysw6").then(()=>parcelRequire('g36Mb'));

});

parcelRegister("26Y6c", function(module, exports) {

let $189ac2b9db3551f0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $189ac2b9db3551f0$var$load("7sOKp").then(()=>parcelRequire('eODbN'));

});

parcelRegister("k2jJ5", function(module, exports) {

let $e9634bc35b15b21e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e9634bc35b15b21e$var$load("jvUhP").then(()=>parcelRequire('2k3z5'));

});

parcelRegister("8t1lq", function(module, exports) {

let $62a2133071fe9094$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $62a2133071fe9094$var$load("fhT77").then(()=>parcelRequire('lHAGV'));

});

parcelRegister("9uiEL", function(module, exports) {

let $6e85632d71c22264$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6e85632d71c22264$var$load("cpTbC").then(()=>parcelRequire('iPw5B'));

});

parcelRegister("lghtg", function(module, exports) {

let $f7a8a4f4e0eff5ee$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f7a8a4f4e0eff5ee$var$load("2iL13").then(()=>parcelRequire('3LgSg'));

});

parcelRegister("3qEIn", function(module, exports) {

let $27f361e80ece6b26$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $27f361e80ece6b26$var$load("9RGBF").then(()=>parcelRequire('bRkOn'));

});

parcelRegister("fbkFk", function(module, exports) {

let $b0d7e9d4cfa90463$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b0d7e9d4cfa90463$var$load("gQYVn").then(()=>parcelRequire('eoGOF'));

});

parcelRegister("lcUNq", function(module, exports) {

let $f706c67fd5e57d65$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f706c67fd5e57d65$var$load("11yNG").then(()=>parcelRequire('jWqmd'));

});

parcelRegister("7isp4", function(module, exports) {

let $55003f27c5d67294$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $55003f27c5d67294$var$load("6IOAT").then(()=>parcelRequire('bzVC8'));

});

parcelRegister("5PPrc", function(module, exports) {
const $b36df32f21d2d1ae$export$49f6cbb853d30562 = {
    Document: 'document',
    Spreadsheet: 'spreadsheet',
    Presentation: 'presentation',
    Repository: 'repository',
    PullRequest: 'pull-request',
    Branch: 'branch',
    Commit: 'commit',
    DevopsWorkItem: 'devops-work-item',
    WebPage: 'web-page',
    Conversation: 'conversation',
    Message: 'message',
    Video: 'video',
    Design: 'design',
    Page: 'page',
    Blogpost: 'blogpost',
    Attachment: 'attachment',
    Space: 'space',
    Whiteboard: 'whiteboard',
    Slide: 'slide',
    Comment: 'comment',
    Database: 'database',
    Embed: 'embed',
    Folder: 'folder',
    Calendar: 'calendar',
    SpaceCalendar: 'space-calendar',
    Question: 'question',
    Answer: 'answer',
    Issue: 'issue',
    Epic: 'epic',
    Bug: 'bug',
    Story: 'story',
    Task: 'task',
    Subtask: 'subtask',
    Project: 'project',
    Incident: 'incident',
    Filter: 'filter',
    Plan: 'plan',
    Board: 'board',
    Component: 'component',
    Card: 'card',
    Goal: 'goal',
    Tag: 'tag',
    WorkItem: 'work-item',
    FocusArea: 'focus-area',
    Organization: 'organization',
    Ask: 'ask',
    Risk: 'risk',
    Dashboard: 'dashboard',
    Invoice: 'invoice',
    Deal: 'deal',
    Gliffy: 'gliffy',
    CustomerContact: 'customer-contact',
    CustomerOrg: 'customer-org',
    DataTable: 'data-table',
    AssetsObject: 'object',
    Type: 'type',
    Schema: 'schema',
    Position: 'position',
    Image: 'image',
    Audio: 'audio',
    Pdf: 'pdf',
    Shortcut: 'shortcut',
    Code: 'code',
    Archive: 'archive',
    Other: 'other',
    Notebook: 'notebook',
    Form: 'form',
    Article: 'article',
    Post: 'post',
    Ticket: 'ticket',
    Campaign: 'campaign',
    Case: 'case',
    CatalogItem: 'catalog-item',
    RequestedItem: 'requested-item',
    Demand: 'demand',
    KnowledgeArticle: 'knowledge-article',
    NewsArticle: 'news-article',
    Lead: 'lead'
};
const $b36df32f21d2d1ae$export$e01073b80ff953d5 = Object.values($b36df32f21d2d1ae$export$49f6cbb853d30562);
const $b36df32f21d2d1ae$export$1f2db89e0caa00c9 = {
    Document: 'document',
    Spreadsheet: 'spreadsheet',
    Presentation: 'presentation',
    File: 'file',
    Database: 'database',
    WebPage: 'web-page',
    Page: 'page',
    Blogpost: 'blogpost',
    Article: 'article',
    Post: 'post',
    Dashboard: 'dashboard',
    Invoice: 'invoice',
    Design: 'design',
    Deal: 'deal',
    Video: 'video',
    Task: 'task',
    Issue: 'issue',
    Space: 'space',
    Project: 'project',
    Repository: 'repository',
    CustomerContact: 'customer-contact',
    CustomerOrg: 'customer-org',
    Image: 'image',
    Archive: 'archive',
    Audio: 'audio',
    Code: 'code',
    Pdf: 'pdf',
    Other: 'other',
    Software: 'software',
    ServiceDesk: 'service_desk',
    Business: 'business',
    DataTable: 'data-table',
    AssetsObject: 'object',
    Schema: 'schema',
    Type: 'type',
    Folder: 'folder',
    Notebook: 'notebook',
    Form: 'form',
    Shortcut: 'shortcut',
    Site: 'site',
    Subsite: 'subsite',
    Drive: 'drive',
    Comment: 'comment',
    Incident: 'incident',
    CatalogItem: 'catalog_item',
    RequestedItem: 'requested_item',
    KnowledgeArticle: 'knowledge_article',
    Demand: 'demand',
    NewsArticle: 'news_article',
    Epic: 'epic'
};
/**
 * Maps CloudGraph ATI to TypeFilterValueKey
 */ const $b36df32f21d2d1ae$var$ATI_TO_TYPE_FILTER_KEY_MAP = {
    'ati:cloud:graph:document': $b36df32f21d2d1ae$export$49f6cbb853d30562.Document,
    'ati:cloud:graph:message': $b36df32f21d2d1ae$export$49f6cbb853d30562.Message,
    'ati:cloud:graph:conversation': $b36df32f21d2d1ae$export$49f6cbb853d30562.Conversation,
    'ati:cloud:graph:design': $b36df32f21d2d1ae$export$49f6cbb853d30562.Design,
    'ati:cloud:graph:video': $b36df32f21d2d1ae$export$49f6cbb853d30562.Video,
    'ati:cloud:graph:space': $b36df32f21d2d1ae$export$49f6cbb853d30562.Space,
    'ati:cloud:graph:comment': $b36df32f21d2d1ae$export$49f6cbb853d30562.Comment,
    'ati:cloud:graph:repository': $b36df32f21d2d1ae$export$49f6cbb853d30562.Repository,
    'ati:cloud:graph:pull-request': $b36df32f21d2d1ae$export$49f6cbb853d30562.PullRequest,
    'ati:cloud:graph:commit': $b36df32f21d2d1ae$export$49f6cbb853d30562.Commit,
    'ati:cloud:graph:branch': $b36df32f21d2d1ae$export$49f6cbb853d30562.Branch,
    'ati:cloud:graph:calendar-event': $b36df32f21d2d1ae$export$49f6cbb853d30562.Calendar,
    'ati:cloud:graph:work-item': $b36df32f21d2d1ae$export$49f6cbb853d30562.WorkItem,
    'ati:cloud:graph:project': $b36df32f21d2d1ae$export$49f6cbb853d30562.Project,
    'ati:cloud:graph:deal': $b36df32f21d2d1ae$export$49f6cbb853d30562.Deal,
    'ati:cloud:graph:customer-org': $b36df32f21d2d1ae$export$49f6cbb853d30562.CustomerOrg,
    'ati:cloud:graph:customer-contact': $b36df32f21d2d1ae$export$49f6cbb853d30562.CustomerContact,
    'ati:cloud:graph:dashboard': $b36df32f21d2d1ae$export$49f6cbb853d30562.Dashboard,
    'ati:cloud:graph:data-table': $b36df32f21d2d1ae$export$49f6cbb853d30562.DataTable,
    'ati:cloud:graph:campaign': $b36df32f21d2d1ae$export$49f6cbb853d30562.Campaign,
    'ati:cloud:graph:case': $b36df32f21d2d1ae$export$49f6cbb853d30562.Case,
    'ati:cloud:graph:lead': $b36df32f21d2d1ae$export$49f6cbb853d30562.Lead
};
/**
 * Checks if an ATI string is a CloudGraph ATI
 */ const $b36df32f21d2d1ae$var$isCloudGraphAti = (ati)=>{
    return ati.startsWith('ati:cloud:graph:');
};
function $b36df32f21d2d1ae$export$770175465f396551(atis) {
    const typeFilterConfig = new Map();
    // Group ATIs by their corresponding TypeFilterValueKey
    const atisByTypeKey = new Map();
    for (const ati of atis)if ($b36df32f21d2d1ae$var$isCloudGraphAti(ati)) {
        const typeKey = $b36df32f21d2d1ae$var$ATI_TO_TYPE_FILTER_KEY_MAP[ati];
        if (typeKey) {
            if (!atisByTypeKey.has(typeKey)) atisByTypeKey.set(typeKey, []);
            atisByTypeKey.get(typeKey).push(ati);
        }
    }
    // Convert to TypeFilterConfig3P format
    for (const [typeKey, entityAtis] of atisByTypeKey)typeFilterConfig.set(typeKey, {
        entities3P: entityAtis,
        subTypes3P: [] // Most configs use empty subTypes3P, can be extended if needed
    });
    return typeFilterConfig;
}
module.exports["TypeFilterValueKey"] = $b36df32f21d2d1ae$export$49f6cbb853d30562;
module.exports["allTypeFilterValueKeys"] = $b36df32f21d2d1ae$export$e01073b80ff953d5;
module.exports["NounSubtypeKey"] = $b36df32f21d2d1ae$export$1f2db89e0caa00c9;
module.exports["mapAtisToTypeFilterConfig"] = $b36df32f21d2d1ae$export$770175465f396551;

});

parcelRegister("i52Hf", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");




var $6suVE = parcelRequire("6suVE");


var $ehKBQ = parcelRequire("ehKBQ");


var $iS3Tu = parcelRequire("iS3Tu");


var $dULnI = parcelRequire("dULnI");


var $2sFbd = parcelRequire("2sFbd");



var $9Jc29 = parcelRequire("9Jc29");





var $Douji = parcelRequire("Douji");


var $iPmoS = parcelRequire("iPmoS");

// Legacy custom @atlaskit/icon glyphs render one size smaller than requested, so this container
// is bumped up a step to compensate (see `correctedSize` below).
const $8a7a1ec4b7d3b7f4$var$legacySvgIconContainerStyles = {
    small: "_39xV02ey7F _0jFU0Vey7F _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    medium: "_39xV02oWWg _0jFU0VoWWg _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    large: "_39xV02Uofl _0jFU0VUofl _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    xlarge: "_39xV02Uofl _0jFU0VUofl _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT"
};
// The official brand icon library (behind rovo-search-team-eu-26-brand-icon-library) renders
// through ADS Tile, whose size scale already matches the Logo scale 1:1 — no compensation needed.
const $8a7a1ec4b7d3b7f4$var$accurateSvgIconContainerStyles = {
    xxsmall: "_39xV02ey7F _0jFU0Vey7F _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    xsmall: "_39xV02SPN1 _0jFU0VSPN1 _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    small: "_39xV02oWWg _0jFU0VoWWg _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    medium: "_39xV02Uofl _0jFU0VUofl _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    large: "_39xV02UF4f _0jFU0VUF4f _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT"
};
const $8a7a1ec4b7d3b7f4$var$SVGIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { glyph: SVG, label: label, legacySize: legacySize, accurateSize: accurateSize } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $iDrrr.fg)("rovo-search-team-eu-26-brand-icon-library");
        $[0] = t1;
    } else t1 = $[0];
    const isAccurateSizeEnabled = t1;
    const t2 = isAccurateSizeEnabled ? $8a7a1ec4b7d3b7f4$var$accurateSvgIconContainerStyles[accurateSize] : $8a7a1ec4b7d3b7f4$var$legacySvgIconContainerStyles[legacySize];
    const t3 = label || undefined;
    const t4 = label ? "img" : "presentation";
    let t5;
    if ($[1] !== SVG || $[2] !== accurateSize) {
        t5 = isAccurateSizeEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SVG, {
            size: accurateSize
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SVG, null);
        $[1] = SVG;
        $[2] = accurateSize;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== t2 || $[5] !== t3 || $[6] !== t4 || $[7] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t2,
            "aria-label": t3,
            role: t4
        }, t5);
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
        $[7] = t5;
        $[8] = t6;
    } else t6 = $[8];
    return t6;
} : ({ glyph: SVG, label: label, legacySize: legacySize, accurateSize: accurateSize })=>{
    const isAccurateSizeEnabled = (0, $iDrrr.fg)('rovo-search-team-eu-26-brand-icon-library');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: isAccurateSizeEnabled ? $8a7a1ec4b7d3b7f4$var$accurateSvgIconContainerStyles[accurateSize] : $8a7a1ec4b7d3b7f4$var$legacySvgIconContainerStyles[legacySize],
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation'
    }, isAccurateSizeEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SVG, {
        size: accurateSize
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SVG, null));
};
const $8a7a1ec4b7d3b7f4$var$isCorrectableRovoSize = (size)=>{
    return [
        'xxsmall',
        'xsmall',
        'small',
        'medium',
        'large'
    ].includes(size);
};
const $8a7a1ec4b7d3b7f4$var$correctedSize = {
    xxsmall: 'small',
    xsmall: 'small',
    small: 'medium',
    medium: 'large',
    large: 'xlarge'
};
const $8a7a1ec4b7d3b7f4$var$sizeStyles = {
    small: "_39xV02ey7F _0jFU0Vey7F",
    medium: "_39xV02oWWg _0jFU0VoWWg",
    large: "_39xV02Uofl _0jFU0VUofl",
    xlarge: "_39xV02pJKa _0jFU0VpJKa"
}; // The official brand icon library (behind rovo-search-team-eu-26-brand-icon-library) renders
// through ADS Tile, whose size scale already matches the Logo scale 1:1 — unlike the legacy
// custom @atlaskit/icon glyphs above, it needs no "one size bigger" compensation.
const $8a7a1ec4b7d3b7f4$var$accurateSizeStyles = {
    xxsmall: "_39xV02ey7F _0jFU0Vey7F",
    xsmall: "_39xV02SPN1 _0jFU0VSPN1",
    small: "_39xV02oWWg _0jFU0VoWWg",
    medium: "_39xV02Uofl _0jFU0VUofl",
    large: "_39xV02UF4f _0jFU0VUF4f"
}; /**
    * A wrapper for providing an internal \@atlaskit/icon - alike experience for working with custom Rovo Icons
    *
    * Internally uses <Icon glyph={glyph} ... />
    *
    * @param {} glyph function returning an SVG as JSX
    * @param defaultLabel an accessible label for the logo
    */ 
const $8a7a1ec4b7d3b7f4$export$7b66a86355afbb91 = (Glyph, defaultLabel = '', defaultSize = 'medium')=>{
    return ({ size: size = defaultSize, label: label = defaultLabel, testId: testId })=>{
        const resolvedSize = size && $8a7a1ec4b7d3b7f4$var$isCorrectableRovoSize(size) ? size : defaultSize;
        const isAccurateSizeEnabled = (0, $iDrrr.fg)('rovo-search-team-eu-26-brand-icon-library');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "aria-label": label || undefined,
            "data-testid": testId,
            role: label ? 'img' : 'presentation',
            className: (0, $hekY6.default)([
                isAccurateSizeEnabled ? $8a7a1ec4b7d3b7f4$var$accurateSizeStyles[resolvedSize] : $8a7a1ec4b7d3b7f4$var$sizeStyles[$8a7a1ec4b7d3b7f4$var$correctedSize[resolvedSize]]
            ])
        }, isAccurateSizeEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Glyph, {
            size: resolvedSize
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Glyph, null));
    };
}; /**
    * A wrapper for rendering 3P svg illustrations in a similar way for atlaskit icon components
    *
    * @param {} glyph function returning an SVG as JSX
    * @param defaultLabel an accessible label for the logo
    */ 
const $8a7a1ec4b7d3b7f4$export$dae027fade2c6d1d = (glyph, defaultLabel = '', defaultSize)=>{
    return ({ label: label = defaultLabel, size: size = defaultSize })=>{
        const resolvedSize = size && $8a7a1ec4b7d3b7f4$var$isCorrectableRovoSize(size) ? size : defaultSize ?? 'medium';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8a7a1ec4b7d3b7f4$var$SVGIcon, {
            label: label,
            glyph: glyph,
            legacySize: $8a7a1ec4b7d3b7f4$var$correctedSize[resolvedSize],
            accurateSize: resolvedSize
        });
    };
}; /**
    * A wrapper for providing an internal \@atlaskit/icon - alike experience for working with \@atlaskit/logo
    *
    * Internally uses <LogoComponent ... />
    *
    * @param {} LogoComponent an import from \@atlaskit/logo
    * @param defaultLabel an accessible label for the logo
    */ 
const $8a7a1ec4b7d3b7f4$export$32db889b380fa03c = (LogoComponent, defaultLabel = '')=>{
    return ({ size: size, label: label, testId: testId })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(LogoComponent, {
            label: label || defaultLabel,
            testId: testId,
            size: size || 'medium',
            appearance: "brand"
        });
    };
}; /**
    * Takes a logo component and returns a new logo component that uses the new logo design.
    */ 
function $8a7a1ec4b7d3b7f4$export$a34cd1871c6541c9(Icon) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, props);
}
function $8a7a1ec4b7d3b7f4$export$fab9faef3411dc6c(iconGlyph, iconLabel, size) {
    return $8a7a1ec4b7d3b7f4$export$dae027fade2c6d1d(iconGlyph, iconLabel, size);
}
const $8a7a1ec4b7d3b7f4$var$imageStyles = null; /**
                           * Helper function to convert an image URL into a glyph function
                           *
                           * @param imageUrl URL string pointing to the image
                           * @returns A glyph function that returns an img element
                           */ 
const $8a7a1ec4b7d3b7f4$export$f9f7178f66750cba = (imageUrl)=>{
    return ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
            src: imageUrl,
            alt: "",
            className: (0, $hekY6.default)([
                "_39xV02N91d _0jFU0VN91d _00EA0egIor"
            ])
        });
    };
}; /**
    * Creates a RovoLogo from a URL. Useful for Forge connectors that provide icon URLs.
    * Uses the existing RovoLogoFromSVG infrastructure for consistent handling.
    */ 
function $8a7a1ec4b7d3b7f4$export$97ac28be52c9e29f(iconUrl, iconLabel, size) {
    return $8a7a1ec4b7d3b7f4$export$dae027fade2c6d1d($8a7a1ec4b7d3b7f4$export$f9f7178f66750cba(iconUrl), iconLabel, size);
} // Jira-specific icons
module.exports["RovoLogoFromGlyph"] = $8a7a1ec4b7d3b7f4$export$7b66a86355afbb91;
module.exports["RovoLogoFromSVG"] = $8a7a1ec4b7d3b7f4$export$dae027fade2c6d1d;
module.exports["RovoLogoFromLogo"] = $8a7a1ec4b7d3b7f4$export$32db889b380fa03c;
module.exports["get3PLogo"] = $8a7a1ec4b7d3b7f4$export$fab9faef3411dc6c;
module.exports["get3PLogoFromURL"] = $8a7a1ec4b7d3b7f4$export$97ac28be52c9e29f;

});

parcelRegister("6suVE", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $db93e344a28daeff$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("4hzFj")).then((m)=>m.GitHubIcon), {
    moduleId: '@atlassian/logo-third-party/github'
});

const $db93e344a28daeff$var$LazyGithubIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("3w7xz")).then((m)=>m.GithubIcon), {
    moduleId: '@atlassian/rovo-connectors-config/github/icon'
});

const $db93e344a28daeff$var$LazyGithubSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("3w7xz")).then((m)=>m.GithubSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/github/search-result-icon'
});
const $db93e344a28daeff$export$e8e65f186ccd8749 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($db93e344a28daeff$var$LazyGithubIconComponent, null)), $db93e344a28daeff$var$OfficialIcon, 'small');
const $db93e344a28daeff$export$fa0f141eb732d2d7 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($db93e344a28daeff$var$LazyGithubSearchResultIconComponent, null)), $db93e344a28daeff$var$OfficialIcon, 'medium');
module.exports["GithubIcon"] = $db93e344a28daeff$export$e8e65f186ccd8749;
module.exports["GithubSearchResultIcon"] = $db93e344a28daeff$export$fa0f141eb732d2d7;

});

parcelRegister("5mh7K", function(module, exports) {

var $6zMm4 = parcelRequire("6zMm4");


var $3zIme = parcelRequire("3zIme");


var $jrpaf = parcelRequire("jrpaf");


var $iqYgx = parcelRequire("iqYgx");


var $3Zhtx = parcelRequire("3Zhtx");

var $dZb8A = parcelRequire("dZb8A");


var $9W961 = parcelRequire("9W961");


var $f1SiZ = parcelRequire("f1SiZ");


var $6DjRB = parcelRequire("6DjRB");


var $ah4XH = parcelRequire("ah4XH");


var $cU4Ow = parcelRequire("cU4Ow");


var $31PDK = parcelRequire("31PDK");


function $bfc96ad9243c26fc$var$noop() {}
function $bfc96ad9243c26fc$var$deferToPhase(phase) {
    switch(phase){
        case (0, $iqYgx.PHASE).PAINT:
            return (0, $6zMm4.postTask)($bfc96ad9243c26fc$var$noop, {
                priority: 'user-blocking'
            });
        case (0, $iqYgx.PHASE).AFTER_PAINT:
            return (0, $6zMm4.postTask)($bfc96ad9243c26fc$var$noop, {
                priority: 'user-visible'
            });
        case (0, $iqYgx.PHASE).LAZY:
            return (0, $6zMm4.postTask)($bfc96ad9243c26fc$var$noop, {
                priority: 'background'
            });
        default:
            return Promise.resolve();
    }
}
function $bfc96ad9243c26fc$var$lazyProxy(loader, { defer: defer = (0, $iqYgx.PHASE).PAINT, moduleId: moduleId = '', ssr: ssr = true } = {}) {
    const isServer = (0, $3Zhtx.isNodeEnvironment)();
    const dataLazyId = (0, $dZb8A.default)(moduleId);
    // eslint-disable-next-line @typescript-eslint/no-restricted-types
    const LazyInternal = isServer ? (0, $f1SiZ.createComponentServer)({
        dataLazyId: dataLazyId,
        defer: defer,
        loader: loader,
        moduleId: moduleId,
        ssr: ssr
    }) : (0, $9W961.createComponentClient)({
        dataLazyId: dataLazyId,
        defer: defer,
        // We separate the preload from the retryable request, as we do not want the preload to contribute to retry
        // attempts, when the the loader fallback is used
        deferred: (0, $ah4XH.createDeferred)(dataLazyId, {
            loader: ()=>{
                const { retry: maxAttempts, usePostTaskPhases: usePostTaskPhases } = (0, $jrpaf.getConfig)();
                const deferredLoader = usePostTaskPhases ? ()=>$bfc96ad9243c26fc$var$deferToPhase(defer).then(()=>loader()) : loader;
                return (0, $31PDK.retry)(deferredLoader, {
                    delay: (0, $6DjRB.RETRY_DELAY),
                    factor: (0, $6DjRB.RETRY_FACTOR),
                    maxAttempts: maxAttempts
                });
            },
            preload: loader
        }),
        moduleId: moduleId
    });
    LazyInternal.displayName = `Lazy(${(0, $3Zhtx.displayNameFromId)(moduleId)})`;
    /**
   * Allows getting module chunks urls
   */ const getAssetUrls = ()=>{
        const { manifest: manifest } = (0, $jrpaf.getConfig)();
        return (0, $3zIme.getAssetUrlsFromId)(manifest, moduleId);
    };
    /**
   * Allows imperatively preload/ prefetch the module chunk asset
   */ const preload = (priority)=>{
        const p = priority ?? (defer === (0, $iqYgx.PHASE).PAINT ? (0, $6DjRB.PRIORITY).HIGH : (0, $6DjRB.PRIORITY).LOW);
        return (0, $cU4Ow.preloadAsset)({
            loader: loader,
            moduleId: moduleId,
            priority: p
        });
    };
    return Object.assign(LazyInternal, {
        getAssetUrls: getAssetUrls,
        moduleId: moduleId,
        preload: preload
    });
}
const $bfc96ad9243c26fc$export$93ca5d3f8675ae4c = {
    lazyForPaint: {
        ssr: true,
        defer: (0, $iqYgx.PHASE).PAINT
    },
    lazyAfterPaint: {
        ssr: true,
        defer: (0, $iqYgx.PHASE).AFTER_PAINT
    },
    lazy: {
        ssr: false,
        defer: (0, $iqYgx.PHASE).LAZY
    }
};
function $bfc96ad9243c26fc$export$c952e5f94576010e(loader, opts) {
    return $bfc96ad9243c26fc$var$lazyProxy(loader, {
        ...$bfc96ad9243c26fc$export$93ca5d3f8675ae4c.lazyForPaint,
        ...opts || {}
    });
}
function $bfc96ad9243c26fc$export$291dd592399bdafa(loader, opts) {
    return $bfc96ad9243c26fc$var$lazyProxy(loader, {
        ...$bfc96ad9243c26fc$export$93ca5d3f8675ae4c.lazyAfterPaint,
        ...opts || {}
    });
}
function $bfc96ad9243c26fc$export$488013bae63b21da(loader, opts) {
    return $bfc96ad9243c26fc$var$lazyProxy(loader, {
        ...$bfc96ad9243c26fc$export$93ca5d3f8675ae4c.lazy,
        ...opts || {}
    });
}
module.exports["lazyForPaint"] = $bfc96ad9243c26fc$export$c952e5f94576010e;
module.exports["lazy"] = $bfc96ad9243c26fc$export$488013bae63b21da;

});

parcelRegister("3zIme", function(module, exports) {
const $26c544e248d4f3ef$export$303f43e55cf1ef2f = (manifest, id)=>{
    if (!manifest.assets || !manifest.assets[id]) return;
    return manifest.assets[id].map((asset)=>`${manifest.publicPath}${asset}`);
};
module.exports["getAssetUrlsFromId"] = $26c544e248d4f3ef$export$303f43e55cf1ef2f;

});

parcelRegister("jrpaf", function(module, exports) {
$parcel$export(module.exports, "MODE", () => (parcelRequire("hwBK6")).MODE);

var $hwBK6 = parcelRequire("hwBK6");

const $8f2b5a3b1d08430b$var$DEFAULT_CROSS_ORIGIN = undefined;
const $8f2b5a3b1d08430b$var$DEFAULT_MANIFEST = {
    publicPath: '/',
    assets: {}
};
const $8f2b5a3b1d08430b$var$DEFAULT_MODE = (0, $hwBK6.MODE).HYDRATE;
const $8f2b5a3b1d08430b$var$DEFAULT_RETRY = 2;
const $8f2b5a3b1d08430b$var$nullFunction = ()=>{};
const $8f2b5a3b1d08430b$var$config = {
    crossOrigin: $8f2b5a3b1d08430b$var$DEFAULT_CROSS_ORIGIN,
    manifest: $8f2b5a3b1d08430b$var$DEFAULT_MANIFEST,
    mode: $8f2b5a3b1d08430b$var$DEFAULT_MODE,
    retry: $8f2b5a3b1d08430b$var$DEFAULT_RETRY,
    react18: false,
    onChunkRender: $8f2b5a3b1d08430b$var$nullFunction,
    usePostTaskPhases: false,
    modernErrorFallback: false,
    markedForPreload: [],
    environment: undefined
};
const $8f2b5a3b1d08430b$export$44487a86467333c3 = ()=>$8f2b5a3b1d08430b$var$config;
const $8f2b5a3b1d08430b$export$940a7873bb071df8 = (nextConfig)=>{
    $8f2b5a3b1d08430b$var$config.crossOrigin = nextConfig.crossOrigin ?? $8f2b5a3b1d08430b$var$DEFAULT_CROSS_ORIGIN;
    $8f2b5a3b1d08430b$var$config.manifest = nextConfig.manifest ?? $8f2b5a3b1d08430b$var$DEFAULT_MANIFEST;
    $8f2b5a3b1d08430b$var$config.mode = nextConfig.mode ?? $8f2b5a3b1d08430b$var$DEFAULT_MODE;
    $8f2b5a3b1d08430b$var$config.retry = nextConfig.retry ?? $8f2b5a3b1d08430b$var$DEFAULT_RETRY;
    $8f2b5a3b1d08430b$var$config.react18 = nextConfig.react18 ?? false;
    $8f2b5a3b1d08430b$var$config.onChunkRender = nextConfig.onChunkRender ?? $8f2b5a3b1d08430b$var$nullFunction;
    $8f2b5a3b1d08430b$var$config.usePostTaskPhases = nextConfig.usePostTaskPhases ?? false;
    $8f2b5a3b1d08430b$var$config.modernErrorFallback = nextConfig.modernErrorFallback ?? false;
    $8f2b5a3b1d08430b$var$config.markedForPreload = nextConfig.markedForPreload ?? undefined;
    $8f2b5a3b1d08430b$var$config.environment = nextConfig.environment ?? undefined;
};
module.exports["getConfig"] = $8f2b5a3b1d08430b$export$44487a86467333c3;

});

parcelRegister("hwBK6", function(module, exports) {
const $b5e78af7707a7c4f$export$e48589d9e4824227 = {
    RENDER: 'RENDER',
    HYDRATE: 'HYDRATE'
};
module.exports["MODE"] = $b5e78af7707a7c4f$export$e48589d9e4824227;

});

parcelRegister("iqYgx", function(module, exports) {
const $affaceaac00ccc54$export$2cc7a2eaaea7809f = {
    PAINT: 0,
    AFTER_PAINT: 1,
    LAZY: 2
};
const $affaceaac00ccc54$export$4831ef3968ea94ef = new Map();
module.exports["PHASE"] = $affaceaac00ccc54$export$2cc7a2eaaea7809f;
module.exports["COLLECTED"] = $affaceaac00ccc54$export$4831ef3968ea94ef;

});

parcelRegister("3Zhtx", function(module, exports) {

var $dZb8A = parcelRequire("dZb8A");

const $a3803c67f4544810$export$d4c07b1daf44a7f = (m)=>'default' in m ? m.default : m;
const $a3803c67f4544810$export$4429f98ef60d2d87 = (id)=>{
    const fName = id.split('/').slice(-3).join('/');
    return fName || 'Component';
};
const $a3803c67f4544810$export$283635c04a02cc36 = ()=>{
    if (typeof window === 'undefined') return true;
    if (window.name === 'nodejs') return true;
    return false;
};
function $a3803c67f4544810$export$62bf630d0de3d781(props, attr) {
    switch(attr.name){
        case 'style':
            break;
        case 'class':
            props.className = attr.value;
            break;
        case 'crossorigin':
            props.crossOrigin = attr.value;
            break;
        default:
            props[attr.name] = attr.value;
    }
    return props;
}
module.exports["getExport"] = $a3803c67f4544810$export$d4c07b1daf44a7f;
module.exports["displayNameFromId"] = $a3803c67f4544810$export$4429f98ef60d2d87;
module.exports["isNodeEnvironment"] = $a3803c67f4544810$export$283635c04a02cc36;
module.exports["attrToProp"] = $a3803c67f4544810$export$62bf630d0de3d781;

});

parcelRegister("dZb8A", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a2d13c19047c2e6$export$2e2bcd8739ae039);
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $2a2d13c19047c2e6$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        // @ts-ignore TS7029 fallthrough
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        // @ts-ignore TS7029 fallthrough
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});

parcelRegister("9W961", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $jrpaf = parcelRequire("jrpaf");
var $hwBK6 = parcelRequire("hwBK6");


var $iqYgx = parcelRequire("iqYgx");


var $6pwcu = parcelRequire("6pwcu");


var $hGTvt = parcelRequire("hGTvt");


var $bSocS = parcelRequire("bSocS");


var $3UFgg = parcelRequire("3UFgg");


var $27xqQ = parcelRequire("27xqQ");


var $bYDpj = parcelRequire("bYDpj");


var $iQUPl = parcelRequire("iQUPl");


var $6mYYR = parcelRequire("6mYYR");

function $9e10a968465c2ceb$export$6898b5504b58699a({ defer: defer, deferred: deferred, dataLazyId: dataLazyId, moduleId: moduleId }) {
    const ResolvedLazy = /*#__PURE__*/ (0, $cozmU.lazy)(()=>deferred.promise);
    return (props)=>{
        // use a single piece of state to hold info about progress or eventually
        // throw an error. We do change it via direct mutation as re-renders
        // break Suspense in React 18, making it lose hydration state
        const [status, bubbleError] = (0, $cozmU.useState)(()=>({
                noWait: undefined,
                phase: defer === (0, $iqYgx.PHASE).AFTER_PAINT ? false : true,
                preloaded: defer === (0, $iqYgx.PHASE).AFTER_PAINT ? false : true,
                started: false
            }));
        const { usePostTaskPhases: usePostTaskPhases } = (0, $jrpaf.getConfig)();
        const { setFallback: setFallback, getIsBoundaryInitialized: getIsBoundaryInitialized } = (0, $cozmU.useContext)((0, $3UFgg.LazySuspenseContext));
        const profiler = (0, $cozmU.useContext)((0, $bSocS.ProfilerContext)).current;
        const load = ()=>{
            if (usePostTaskPhases) {
                if (status.started) return;
            } else {
                if (status.started || !status.phase || !status.noWait) return;
            }
            status.started = true;
            let onResolve;
            if (profiler) {
                const eventInfo = {
                    identifier: moduleId
                };
                onResolve = ()=>{
                    profiler.onLoadComplete(eventInfo);
                };
                profiler.onLoadStart(eventInfo);
            }
            const result = deferred.start().catch((err)=>{
                // Throw the error within the component lifecycle
                // refer to https://github.com/facebook/react/issues/11409
                bubbleError(()=>{
                    throw (0, $27xqQ.createLoaderError)(err);
                });
            });
            if (onResolve) result.then(onResolve);
        };
        if (usePostTaskPhases) // Start loading immediately, as the loader itself will be delayed until the appropriate phase
        (0, $cozmU.useMemo)(()=>{
            load();
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
        else {
            // Subscribe to LazyWait context, triggering load when until is true
            (0, $6mYYR.useSubscription)({
                context: (0, $6pwcu.WaitContext),
                load: load,
                onValue: (v)=>status.noWait = v === 1
            });
            if (defer === (0, $iqYgx.PHASE).AFTER_PAINT) // Subscribe to LazyPhase context, triggering load when own phase starts
            (0, $6mYYR.useSubscription)({
                context: (0, $hGTvt.LazyPhaseContext),
                load: load,
                onValue: (v)=>status.phase = v >= defer
            });
        }
        (0, $cozmU.useMemo)(()=>{
            // Skip collecting fallbacks if the boundary is already initialized
            if (usePostTaskPhases && getIsBoundaryInitialized()) return;
            // find SSR content (or fallbacks) wrapped in inputs based on lazyId
            const content = ((0, $iqYgx.COLLECTED).get(dataLazyId) || []).shift();
            if (!content) return;
            // override Suspense fallback with magic input wrappers
            const component = (0, $jrpaf.getConfig)().mode === (0, $hwBK6.MODE).RENDER ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iQUPl.PlaceholderFallbackRender), {
                id: dataLazyId,
                content: content
            }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bYDpj.PlaceholderFallbackHydrate), {
                id: dataLazyId,
                content: content
            });
            setFallback(component);
        }, [
            setFallback,
            getIsBoundaryInitialized,
            usePostTaskPhases
        ]);
        (0, $cozmU.useMemo)(()=>{
            const { mode: mode, react18: react18 } = (0, $jrpaf.getConfig)();
            // we dont remove fallback in RENDER mode as it happens too early
            // however it's not a problem for HYDRATION as Suspense will handle all nuances
            if (mode === (0, $hwBK6.MODE).HYDRATE && react18) // Allow hydration to support partials without server components
            // suspense will discard ssr during hydration if re-renders so we
            // set a dummy fallback to block updates from the provider until we resolve
            setFallback(/*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {}));
        }, [
            setFallback
        ]);
        return /*#__PURE__*/ (0, $8aG6j.jsx)(ResolvedLazy, {
            ...props
        });
    };
}
module.exports["createComponentClient"] = $9e10a968465c2ceb$export$6898b5504b58699a;

});

parcelRegister("6pwcu", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $aJQSl = parcelRequire("aJQSl");

const $548763ff32fd4fa9$export$9ba3fe09d15de47b = (0, $cozmU.createContext)({
    subscribe: ()=>(0, $aJQSl.noopCleanup),
    currentValue: ()=>1
});
module.exports["WaitContext"] = $548763ff32fd4fa9$export$9ba3fe09d15de47b;

});

parcelRegister("aJQSl", function(module, exports) {
const $05617924a76d0a6c$export$276c7dbda7675aec = ()=>{
// Nothing to cleanup...
};
module.exports["noopCleanup"] = $05617924a76d0a6c$export$276c7dbda7675aec;

});

parcelRegister("hGTvt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iqYgx = parcelRequire("iqYgx");


var $lJvTv = parcelRequire("lJvTv");


var $dcIK9 = parcelRequire("dcIK9");

let $672f0e6595584070$var$CURRENT_PHASE = (0, $iqYgx.PHASE).PAINT;
const $672f0e6595584070$export$5f80f094fd31fffd = (phase)=>{
    $672f0e6595584070$var$CURRENT_PHASE = phase;
    (0, $lJvTv.LISTENERS).slice(0).forEach((listener)=>listener(phase));
};
const $672f0e6595584070$export$5a25eca35e5debcb = /*#__PURE__*/ (0, $cozmU.createContext)({
    subscribe: (0, $dcIK9.createSubscribe)((0, $lJvTv.LISTENERS)),
    currentValue: ()=>$672f0e6595584070$var$CURRENT_PHASE,
    api: {
        startNextPhase: ()=>{
            $672f0e6595584070$export$5f80f094fd31fffd((0, $iqYgx.PHASE).AFTER_PAINT);
        },
        resetPhase: ()=>$672f0e6595584070$export$5f80f094fd31fffd((0, $iqYgx.PHASE).PAINT)
    }
});
const $672f0e6595584070$export$1dc361b277327f88 = ()=>{
    const v = (0, $cozmU.useContext)($672f0e6595584070$export$5a25eca35e5debcb);
    return v.api;
};
module.exports["LazyPhaseContext"] = $672f0e6595584070$export$5a25eca35e5debcb;

});

parcelRegister("lJvTv", function(module, exports) {
const $17f151a063744015$export$81b9c458a026d68f = [];
module.exports["LISTENERS"] = $17f151a063744015$export$81b9c458a026d68f;

});

parcelRegister("dcIK9", function(module, exports) {
const $66c4eef17986e77d$export$364097d812234b3f = (listeners)=>(listener)=>{
        listeners.push(listener);
        return ()=>{
            const index = listeners.indexOf(listener);
            if (index !== -1) listeners.splice(index, 1);
        };
    };
module.exports["createSubscribe"] = $66c4eef17986e77d$export$364097d812234b3f;

});

parcelRegister("bSocS", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $0b79a9622223785f$export$e2d53c0cbedd2710 = {
    current: null
};
const $0b79a9622223785f$export$8146ab57a3f7a7cb = (0, $cozmU.createContext)($0b79a9622223785f$export$e2d53c0cbedd2710);
module.exports["GlobalReactLooselyLazyProfiler"] = $0b79a9622223785f$export$e2d53c0cbedd2710;
module.exports["ProfilerContext"] = $0b79a9622223785f$export$8146ab57a3f7a7cb;

});

parcelRegister("3UFgg", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $jrpaf = parcelRequire("jrpaf");
var $hwBK6 = parcelRequire("hwBK6");

const $307cdf761723c83f$export$c33990e84065970c = /*#__PURE__*/ (0, $cozmU.createContext)({
    getIsBoundaryInitialized: ()=>false,
    fallback: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Fragment), {}),
    setFallback: ()=>{
        if ((0, $jrpaf.getConfig)().mode === (0, $hwBK6.MODE).RENDER) // render mode MUST have a properly configured boundary
        // eslint-disable-next-line no-console
        console.warn('Missing <LooselySuspense /> boundary');
    }
});
module.exports["LazySuspenseContext"] = $307cdf761723c83f$export$c33990e84065970c;

});

parcelRegister("27xqQ", function(module, exports) {
const $8d723af0e292a27d$export$6aa69c1258005366 = Symbol.for('@atlassian/react-loosely-lazy/loader-error');
const $8d723af0e292a27d$export$c73a6a6f0bf7d425 = (error)=>{
    if (typeof error === 'object') // @ts-expect-error Explicitly untyped
    return Object.assign(error, {
        [$8d723af0e292a27d$export$6aa69c1258005366]: true
    });
    return error;
};
const $8d723af0e292a27d$export$16a03aca4a3508b4 = (error)=>Object.getOwnPropertySymbols(error).includes($8d723af0e292a27d$export$6aa69c1258005366);
module.exports["createLoaderError"] = $8d723af0e292a27d$export$c73a6a6f0bf7d425;

});

parcelRegister("bYDpj", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $3Zhtx = parcelRequire("3Zhtx");

const $308221388927349f$export$ca5b8fbc835d95e4 = ({ id: id, content: content })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
                type: "hidden",
                "data-lazy-begin": id
            }),
            content.map((el, i)=>{
                const { tagName: tagName = '', childNodes: childNodes = [], attributes: attributes = [] } = el;
                const props = Array.from(attributes).reduce((0, $3Zhtx.attrToProp), {
                    key: String(i)
                });
                // text node
                if (!tagName) return /*#__PURE__*/ (0, $cozmU.createElement)((0, $cozmU.Fragment), props, el.textContent);
                // childless tag
                if (!childNodes.length) return /*#__PURE__*/ (0, $cozmU.createElement)(tagName.toLowerCase(), props);
                // tag with content
                return /*#__PURE__*/ (0, $cozmU.createElement)(tagName.toLowerCase(), {
                    ...props,
                    dangerouslySetInnerHTML: {
                        __html: ''
                    },
                    suppressHydrationWarning: true
                });
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
                type: "hidden",
                "data-lazy-end": id
            })
        ]
    });
};
module.exports["PlaceholderFallbackHydrate"] = $308221388927349f$export$ca5b8fbc835d95e4;

});

parcelRegister("iQUPl", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $6pwcu = parcelRequire("6pwcu");


var $bSocS = parcelRequire("bSocS");


var $3UFgg = parcelRequire("3UFgg");

function $fac82888d07c9621$var$isLinkPrefetch(el) {
    return el.tagName === 'LINK' && el.rel === 'prefetch';
}
const $fac82888d07c9621$var$usePlaceholderRender = (resolveId, content)=>{
    const hydrationRef = (0, $cozmU.useRef)(null);
    const { current: ssrDomNodes } = (0, $cozmU.useRef)(content || []);
    const profilerContext = (0, $cozmU.useContext)((0, $bSocS.ProfilerContext)).current;
    const waitContext = (0, $cozmU.useContext)((0, $6pwcu.WaitContext));
    const suspenseContext = (0, $cozmU.useContext)((0, $3UFgg.LazySuspenseContext));
    (0, $cozmU.useLayoutEffect)(()=>{
        const element = hydrationRef.current;
        const { parentNode: parentNode } = element || {};
        profilerContext?.placeholderFallBackMounted(resolveId, suspenseContext.name, !waitContext.currentValue());
        if (parentNode && !parentNode.contains(ssrDomNodes[0])) ssrDomNodes.reverse().forEach((node)=>{
            // this fixes an issue with Chrome that re-triggers and cancels prefetch
            // when node is appended again, making network panel quite noisy
            if ($fac82888d07c9621$var$isLinkPrefetch(node)) node.rel = '';
            parentNode.insertBefore(node, element.nextSibling);
        });
        return ()=>{
            profilerContext?.placeholderFallBackUnmounted(resolveId, suspenseContext.name, !waitContext.currentValue());
            ssrDomNodes.forEach((node)=>node.parentNode?.removeChild(node));
        };
    // [hydrationRef.current, ssrDomNodes] are expected to be stable
    // with the second one never changing by design and the first one changing after first render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return hydrationRef;
};
const $fac82888d07c9621$export$d55db778a3e1446b = ({ id: id, content: content })=>{
    const placeholderRef = $fac82888d07c9621$var$usePlaceholderRender(id, content);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
        type: "hidden",
        "data-lazy-begin": id,
        ref: placeholderRef
    });
};
module.exports["PlaceholderFallbackRender"] = $fac82888d07c9621$export$d55db778a3e1446b;

});

parcelRegister("6mYYR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $fb43d3d8deaa2f13$export$368b4214baeb914c({ context: context, load: load, onValue: onValue }) {
    const { subscribe: subscribe, currentValue: currentValue } = (0, $cozmU.useContext)(context);
    (0, $cozmU.useMemo)(()=>{
        let unsubscribe = null;
        const check = ()=>{
            const done = onValue(currentValue());
            if (done) load();
            if (done && unsubscribe) unsubscribe();
            return done;
        };
        unsubscribe = !check() ? subscribe(check) : null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
module.exports["useSubscription"] = $fb43d3d8deaa2f13$export$368b4214baeb914c;

});

parcelRegister("f1SiZ", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $3zIme = parcelRequire("3zIme");


var $jrpaf = parcelRequire("jrpaf");
var $hwBK6 = parcelRequire("hwBK6");


var $iqYgx = parcelRequire("iqYgx");


var $3UFgg = parcelRequire("3UFgg");


var $3Zhtx = parcelRequire("3Zhtx");


var $27xqQ = parcelRequire("27xqQ");

function $e4910f9bc5a8efc5$var$load(moduleId, loader) {
    try {
        return (0, $3Zhtx.getExport)(loader());
    } catch (err) {
        throw (0, $27xqQ.createLoaderError)(err);
    }
}
function $e4910f9bc5a8efc5$export$eb2e4b04351cdd9e({ dataLazyId: dataLazyId, defer: defer, loader: loader, moduleId: moduleId, ssr: ssr }) {
    return (props)=>{
        const { fallback: fallback } = (0, $cozmU.useContext)((0, $3UFgg.LazySuspenseContext));
        const { crossOrigin: crossOrigin, manifest: manifest, onChunkRender: onChunkRender, mode: mode, react18: react18, modernErrorFallback: modernErrorFallback, environment: environment } = (0, $jrpaf.getConfig)();
        const shouldLoad = ssr || environment === 'client';
        const Resolved = shouldLoad ? $e4910f9bc5a8efc5$var$load(moduleId, loader) : null;
        onChunkRender(dataLazyId, moduleId, defer);
        if (mode === (0, $hwBK6.MODE).HYDRATE && react18) {
            if (!Resolved) throw new $e4910f9bc5a8efc5$var$ReactLooselyLazyNoSsrError(moduleId);
            return /*#__PURE__*/ (0, $8aG6j.jsx)(Resolved, {
                ...props
            });
        }
        if (modernErrorFallback) {
            if (!Resolved) // lets just return the fallback without extra fuzz
            // and "error" fallback is usually totally empty, so why bother?
            return fallback;
        }
        return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
                    type: "hidden",
                    "data-lazy-begin": dataLazyId
                }),
                defer !== (0, $iqYgx.PHASE).LAZY && (0, $3zIme.getAssetUrlsFromId)(manifest, moduleId)?.map((url)=>/*#__PURE__*/ (0, $8aG6j.jsx)("link", {
                        rel: defer === (0, $iqYgx.PHASE).PAINT ? 'preload' : 'prefetch',
                        href: url,
                        crossOrigin: crossOrigin,
                        as: "script"
                    }, url)),
                Resolved ? /*#__PURE__*/ (0, $8aG6j.jsx)(Resolved, {
                    ...props
                }) : fallback,
                /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
                    type: "hidden",
                    "data-lazy-end": dataLazyId
                })
            ]
        });
    };
}
class $e4910f9bc5a8efc5$var$ReactLooselyLazyNoSsrError extends Error {
    constructor(moduleId){
        super(`[no-error] React-Loosely-Lazy SSR opt out - ${moduleId}`);
        // This error is used to indicate to React that this component should not
        // render in SSR (it will instead trigger the nearest Suspense boundary)
        // so we mark it as ignored in SSR reporting.
        this.skipSsr = void 0;
        this.skipSsr = true;
    }
}
module.exports["createComponentServer"] = $e4910f9bc5a8efc5$export$eb2e4b04351cdd9e;

});

parcelRegister("6DjRB", function(module, exports) {
const $ee7f0d866347d691$export$bb34f3538ba26c7e = {
    HIGH: 0,
    LOW: 2
};
const $ee7f0d866347d691$export$a339266ad71b2447 = 300;
const $ee7f0d866347d691$export$ba64c908e55507fe = 1;
module.exports["PRIORITY"] = $ee7f0d866347d691$export$bb34f3538ba26c7e;
module.exports["RETRY_DELAY"] = $ee7f0d866347d691$export$a339266ad71b2447;
module.exports["RETRY_FACTOR"] = $ee7f0d866347d691$export$ba64c908e55507fe;

});

parcelRegister("ah4XH", function(module, exports) {
/**
 * a map of all created deferred to
 * - ensure there is single deferred created for every lazy (NOT YET ENFORCED/USED)
 * - track list of known LazyComponents so we can, for example, preload them by id
 */ const $841e841717fb4840$var$lazyIds = new Map();
/**
 * ids "marked" for preload on spot
 */ let $841e841717fb4840$var$preloadIds;
const $841e841717fb4840$export$ac21d099cbc8d569 = (preload)=>{
    $841e841717fb4840$var$preloadIds = preload;
    try {
        $841e841717fb4840$var$preloadIds.forEach((lazyId)=>{
            const deffered = $841e841717fb4840$var$lazyIds.get(lazyId);
            if (deffered) // preload dont have any "phases" and visa versa. Just load it ASAP
            deffered.preload();
        });
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('RLL preload', e);
    }
};
const $841e841717fb4840$export$e673efccd97e4223 = (lazyId, { loader: loader, preload: preload })=>{
    // we dont cache deferred FOR NOW as the goal is to handle networking first
    // the next step would in better pre-resolving deferred, so Suspense might be never triggered
    // if (lazyIds.has(lazyId)) {
    // 	return lazyIds.get(lazyId)!;
    // }
    let resolve;
    const deferred = {
        promise: new Promise((res)=>{
            resolve = (m)=>{
                let withDefault;
                deferred.result = m;
                if (!m.default) withDefault = {
                    default: m
                };
                res(withDefault ? withDefault : m);
            };
        }),
        result: undefined,
        preload: ()=>{
            if (deferred.result) return;
            preload().then((m)=>{
                deferred.result = m;
            }).catch(()=>{
            // Do nothing...
            });
        },
        start: ()=>{
            if (deferred.result) {
                resolve(deferred.result);
                return Promise.resolve();
            }
            // Make a new loader request when none have started or resolved yet
            return loader().then(resolve);
        }
    };
    $841e841717fb4840$var$lazyIds.set(lazyId, deferred);
    // in case of "just created" deferred is already marked for preload
    // do instant preload
    if ($841e841717fb4840$var$preloadIds?.includes(lazyId)) deferred.preload();
    return deferred;
};
module.exports["createDeferred"] = $841e841717fb4840$export$e673efccd97e4223;

});

parcelRegister("cU4Ow", function(module, exports) {

var $3zIme = parcelRequire("3zIme");


var $aJQSl = parcelRequire("aJQSl");


var $jrpaf = parcelRequire("jrpaf");


var $bSocS = parcelRequire("bSocS");


var $3Zhtx = parcelRequire("3Zhtx");


var $6DjRB = parcelRequire("6DjRB");


var $1Y0Bp = parcelRequire("1Y0Bp");

function $72b45db42b4960fa$export$3af04dbcb01bad4d({ moduleId: moduleId, rel: rel }) {
    const { manifest: manifest } = (0, $jrpaf.getConfig)();
    const assets = (0, $3zIme.getAssetUrlsFromId)(manifest, moduleId);
    if (!assets) throw new Error('Unsupported preload strategy');
    const cleanupLinkTags = assets.map((url)=>(0, $1Y0Bp.insertLinkTag)(url, rel));
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
const $72b45db42b4960fa$var$fakePromise = {
    then: ()=>$72b45db42b4960fa$var$fakePromise,
    catch: ()=>$72b45db42b4960fa$var$fakePromise,
    finally: ()=>$72b45db42b4960fa$var$fakePromise
};
function $72b45db42b4960fa$export$1046fd6a49d5e7a({ loader: loader, rel: rel }) {
    if (typeof __webpack_require__ === 'undefined' || typeof __webpack_get_script_filename__ === 'undefined') throw new Error('Unsupported preload strategy');
    // Replace requireEnsure to create link tags instead of scripts
    const requireEnsure = __webpack_require__.e;
    const cleanupLinkTags = [];
    __webpack_require__.e = function requirePreload(chunkId) {
        const href = __webpack_get_script_filename__(chunkId);
        cleanupLinkTags.push((0, $1Y0Bp.insertLinkTag)(href, rel));
        return $72b45db42b4960fa$var$fakePromise;
    };
    try {
        loader();
    } catch (err) {
    // Ignore any errors
    }
    // Restore real webpack require ensure
    __webpack_require__.e = requireEnsure;
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
function $72b45db42b4960fa$export$eb05139fa4dcf992({ loader: loader }) {
    loader();
    return 0, $aJQSl.noopCleanup;
}
function $72b45db42b4960fa$export$25bad4aa00c45355({ loader: loader, moduleId: moduleId, priority: priority }) {
    if ((0, $3Zhtx.isNodeEnvironment)()) return 0, $aJQSl.noopCleanup;
    (0, $bSocS.GlobalReactLooselyLazyProfiler).current?.onPreload(moduleId, priority);
    const rel = priority === (0, $6DjRB.PRIORITY).HIGH ? 'preload' : 'prefetch';
    const preloadStrategies = [
        $72b45db42b4960fa$export$3af04dbcb01bad4d,
        $72b45db42b4960fa$export$1046fd6a49d5e7a,
        $72b45db42b4960fa$export$eb05139fa4dcf992
    ];
    for (const strategy of preloadStrategies)try {
        return strategy({
            loader: loader,
            moduleId: moduleId,
            rel: rel
        });
    } catch (_) {
    // Try next strategy...
    }
    return 0, $aJQSl.noopCleanup;
}
module.exports["preloadAsset"] = $72b45db42b4960fa$export$25bad4aa00c45355;

});

parcelRegister("1Y0Bp", function(module, exports) {

var $aJQSl = parcelRequire("aJQSl");


var $jrpaf = parcelRequire("jrpaf");


var $bSocS = parcelRequire("bSocS");

function $e5a7bcb8f7812549$export$6610512821c8a4ce(href, rel) {
    // Skip if already preloaded, prefetched, or loaded
    if (document.querySelector(`link[href="${href}"]`) || document.querySelector(`script[src="${href}"]`)) return 0, $aJQSl.noopCleanup;
    const { crossOrigin: crossOrigin } = (0, $jrpaf.getConfig)();
    const link = document.createElement('link');
    link.rel = rel;
    link.as = 'script';
    if (crossOrigin) link.crossOrigin = crossOrigin;
    link.href = href;
    const profiler = (0, $bSocS.GlobalReactLooselyLazyProfiler).current;
    let removableListener = null;
    if (profiler) {
        const eventInfo = {
            identifier: href
        };
        const listener = ()=>{
            link.removeEventListener('onload', listener);
            removableListener = null;
            profiler.onLoadComplete(eventInfo);
        };
        link.addEventListener('onload', listener);
        removableListener = listener;
        profiler.onLoadStart(eventInfo);
    }
    document.head?.appendChild(link);
    return ()=>{
        // Remove the link if it is still in the document head
        if (link.parentNode === document.head) document.head?.removeChild(link);
        if (removableListener) link.removeEventListener('onload', removableListener);
    };
}
module.exports["insertLinkTag"] = $e5a7bcb8f7812549$export$6610512821c8a4ce;

});

parcelRegister("31PDK", function(module, exports) {
const $e0741a36efbb4dfa$var$calculateDelay = (context, policy)=>{
    const { attempt: attempt } = context;
    const { delay: delay, factor: factor } = policy;
    const retryAttempt = attempt - 1;
    // Do not use a delay on the first retry, or when the configured delay is 0
    if (retryAttempt === 1 || delay === 0) return 0;
    // Linear factor, like: https://github.com/Polly-Contrib/Polly.Contrib.WaitAndRetry#wait-and-retry-with-linear-back-off
    const add = factor * delay;
    return delay + add * (retryAttempt - 2);
};
const $e0741a36efbb4dfa$var$sleep = (delay)=>new Promise((resolve)=>setTimeout(resolve, delay));
const $e0741a36efbb4dfa$var$getPolicy = (configuration)=>({
        delay: Math.max(0, configuration.delay ?? 0),
        factor: Math.max(0, configuration.factor ?? 0),
        maxAttempts: Math.max(0, configuration.maxAttempts ?? 0)
    });
function $e0741a36efbb4dfa$export$9369b12211e1fce4(retryable, policyConfiguration = {}) {
    const policy = $e0741a36efbb4dfa$var$getPolicy(policyConfiguration);
    const { maxAttempts: maxAttempts } = policy;
    const context = {
        attempt: 1,
        attemptsRemaining: maxAttempts
    };
    const onError = async (err)=>{
        if (context.attemptsRemaining === 0) throw err;
        context.attempt += 1;
        context.attemptsRemaining -= 1;
        const delay = $e0741a36efbb4dfa$var$calculateDelay(context, policy);
        if (delay) await $e0741a36efbb4dfa$var$sleep(delay);
        return retryable().catch(onError);
    };
    return retryable().catch(onError);
}
module.exports["retry"] = $e0741a36efbb4dfa$export$9369b12211e1fce4;

});

parcelRegister("3LxIp", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");

function $1efef99f0e02a868$export$7c51f1b21238e429(LegacyIcon, OfficialIcon, defaultSize) {
    return function BrandIcon({ size: size = defaultSize } = {}) {
        if ((0, $iDrrr.fg)('rovo-search-team-eu-26-brand-icon-library')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(OfficialIcon, {
            label: "",
            size: size
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(LegacyIcon, null);
    };
}
module.exports["withBrandIcon"] = $1efef99f0e02a868$export$7c51f1b21238e429;

});

parcelRegister("4hzFj", function(module, exports) {

let $31e46a58d87c0f49$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $31e46a58d87c0f49$var$load("jxGqt").then(()=>parcelRequire('fyTd1'));

});

parcelRegister("3w7xz", function(module, exports) {

let $28fa35a07f4c32d8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $28fa35a07f4c32d8$var$load("ECQ6q").then(()=>parcelRequire('kGNh6'));

});

parcelRegister("ehKBQ", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $6ce68911b0df4e15$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("9dtYX")).then((m)=>m.GitlabIcon), {
    moduleId: '@atlassian/logo-third-party/gitlab'
});

const $6ce68911b0df4e15$var$LazyGitlabIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("ilgI1")).then((m)=>m.GitlabIcon), {
    moduleId: '@atlassian/rovo-connectors-config/gitlab/icon'
});

const $6ce68911b0df4e15$var$LazyGitlabSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("ilgI1")).then((m)=>m.GitlabSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/gitlab/search-result-icon'
});

const $6ce68911b0df4e15$var$LazyGitlabIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("ilgI1")).then((m)=>m.GitlabIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/gitlab/icon-borderless'
});
const $6ce68911b0df4e15$export$8b4e5326778cce0f = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6ce68911b0df4e15$var$LazyGitlabIconComponent, null)), $6ce68911b0df4e15$var$OfficialIcon, 'small');
const $6ce68911b0df4e15$export$b828123bc19648f9 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6ce68911b0df4e15$var$LazyGitlabSearchResultIconComponent, null)), $6ce68911b0df4e15$var$OfficialIcon, 'medium');
const $6ce68911b0df4e15$export$7e0d364467f49036 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6ce68911b0df4e15$var$LazyGitlabIconBorderlessComponent, null)), $6ce68911b0df4e15$var$OfficialIcon, 'xxsmall');
module.exports["GitlabIcon"] = $6ce68911b0df4e15$export$8b4e5326778cce0f;
module.exports["GitlabSearchResultIcon"] = $6ce68911b0df4e15$export$b828123bc19648f9;
module.exports["GitlabIconBorderless"] = $6ce68911b0df4e15$export$7e0d364467f49036;

});

parcelRegister("9dtYX", function(module, exports) {

let $6b5c95c494a16587$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6b5c95c494a16587$var$load("4LY4N").then(()=>parcelRequire('kmcLM'));

});

parcelRegister("ilgI1", function(module, exports) {

let $d5a726386ad88d53$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d5a726386ad88d53$var$load("1p9Ip").then(()=>parcelRequire('hYL6T'));

});

parcelRegister("iS3Tu", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $83bbbb3fda08bb6a$var$LazyGitbookIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("lbDA4")).then((m)=>m.GitbookIcon), {
    moduleId: '@atlassian/rovo-connectors-config/gitbook/icon'
});

const $83bbbb3fda08bb6a$var$LazyGitbookSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("lbDA4")).then((m)=>m.GitbookSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/gitbook/search-result-icon'
});
const $83bbbb3fda08bb6a$export$6da1c7984975c183 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($83bbbb3fda08bb6a$var$LazyGitbookIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($83bbbb3fda08bb6a$var$LazyGitbookIconComponent, null));
const $83bbbb3fda08bb6a$export$65b356f251826206 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($83bbbb3fda08bb6a$var$LazyGitbookSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($83bbbb3fda08bb6a$var$LazyGitbookSearchResultIconComponent, null));
module.exports["GitbookIcon"] = $83bbbb3fda08bb6a$export$6da1c7984975c183;
module.exports["GitbookSearchResultIcon"] = $83bbbb3fda08bb6a$export$65b356f251826206;

});

parcelRegister("lbDA4", function(module, exports) {

let $f6c953f826ed6884$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f6c953f826ed6884$var$load("k1ije").then(()=>parcelRequire('lG6hv'));

});

parcelRegister("dULnI", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $2cad9d35507cac43$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("enDSk")).then((m)=>m.MicrosoftAzureDevOpsIcon), {
    moduleId: '@atlassian/logo-third-party/microsoft-azure-devops'
});

const $2cad9d35507cac43$var$LazyAzureDevopsIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("8WMbv")).then((m)=>m.AzureDevopsIcon), {
    moduleId: '@atlassian/rovo-connectors-config/azure-devops/icon'
});

const $2cad9d35507cac43$var$LazyAzureDevopsSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("8WMbv")).then((m)=>m.AzureDevopsSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/azure-devops/search-result-icon'
});
const $2cad9d35507cac43$export$2dcf704e717ca168 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2cad9d35507cac43$var$LazyAzureDevopsIconComponent, null)), $2cad9d35507cac43$var$OfficialIcon, 'small');
const $2cad9d35507cac43$export$a64bb17da4dc2efb = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2cad9d35507cac43$var$LazyAzureDevopsSearchResultIconComponent, null)), $2cad9d35507cac43$var$OfficialIcon, 'medium');
module.exports["AzureDevopsIcon"] = $2cad9d35507cac43$export$2dcf704e717ca168;
module.exports["AzureDevopsSearchResultIcon"] = $2cad9d35507cac43$export$a64bb17da4dc2efb;

});

parcelRegister("enDSk", function(module, exports) {

let $a782250e15e8574e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a782250e15e8574e$var$load("jLsGY").then(()=>parcelRequire('b9s7D'));

});

parcelRegister("8WMbv", function(module, exports) {

let $68391df23b860e75$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $68391df23b860e75$var$load("axvMK").then(()=>parcelRequire('fTk3N'));

});

parcelRegister("2sFbd", function(module, exports) {
/**
 * Lazy-loaded Slack icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $809b94d6e1c8821b$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("ln0Jc")).then((m)=>m.SlackIcon), {
    moduleId: '@atlassian/logo-third-party/slack'
});

// Lazy load the actual icon components from utils
const $809b94d6e1c8821b$var$LazySlackIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("iCjpP")).then((m)=>m.SlackIcon), {
    moduleId: '@atlassian/rovo-connectors-config/slack/icon'
});

const $809b94d6e1c8821b$var$LazySlackIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("iCjpP")).then((m)=>m.SlackIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/slack/icon-borderless'
});

const $809b94d6e1c8821b$var$LazySlackSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("iCjpP")).then((m)=>m.SlackSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/slack/search-result-icon'
});

const $809b94d6e1c8821b$var$LazySlackAppSelectorIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("iCjpP")).then((m)=>m.SlackAppSelectorIcon), {
    moduleId: '@atlassian/rovo-connectors-config/slack/app-selector-icon'
});
const $809b94d6e1c8821b$export$b33fb54b08bb6422 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($809b94d6e1c8821b$var$LazySlackIconComponent, null)), $809b94d6e1c8821b$var$OfficialIcon, 'small');
const $809b94d6e1c8821b$export$359ca796b415372 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($809b94d6e1c8821b$var$LazySlackIconBorderlessComponent, null)), $809b94d6e1c8821b$var$OfficialIcon, 'xxsmall');
const $809b94d6e1c8821b$export$9e3ecebaf98513b9 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($809b94d6e1c8821b$var$LazySlackSearchResultIconComponent, null)), $809b94d6e1c8821b$var$OfficialIcon, 'medium');
const $809b94d6e1c8821b$export$f11b42d1aefdd173 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($809b94d6e1c8821b$var$LazySlackAppSelectorIconComponent, null)), $809b94d6e1c8821b$var$OfficialIcon, 'xxsmall');
module.exports["SlackIcon"] = $809b94d6e1c8821b$export$b33fb54b08bb6422;
module.exports["SlackIconBorderless"] = $809b94d6e1c8821b$export$359ca796b415372;
module.exports["SlackSearchResultIcon"] = $809b94d6e1c8821b$export$9e3ecebaf98513b9;

});

parcelRegister("ln0Jc", function(module, exports) {

let $f8ec4f8a6e6abecf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f8ec4f8a6e6abecf$var$load("7S2Sh").then(()=>parcelRequire('eaD9b'));

});

parcelRegister("iCjpP", function(module, exports) {

let $d8dad6234f740135$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d8dad6234f740135$var$load("hUTu6").then(()=>parcelRequire('gaQ0m'));

});

parcelRegister("9Jc29", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $f96caf77f5e0e90e$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>Promise.resolve((parcelRequire("4zc1o"))).then((m)=>m.GoogleDriveIcon), {
    moduleId: '@atlassian/logo-third-party/google-drive'
});

const $f96caf77f5e0e90e$var$LazyGoogleDriveIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eauWV")).then((m)=>m.GoogleDriveIcon), {
    moduleId: '@atlassian/rovo-connectors-config/google/icon'
});

const $f96caf77f5e0e90e$var$LazyGoogleDriveSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eauWV")).then((m)=>m.GoogleDriveSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/google/search-result-icon'
});

const $f96caf77f5e0e90e$var$LazyGoogleDriveIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eauWV")).then((m)=>m.GoogleDriveIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/google/icon-borderless'
});

const $f96caf77f5e0e90e$var$LazyGoogleDriveAppSelectorIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eauWV")).then((m)=>m.GoogleDriveAppSelectorIcon), {
    moduleId: '@atlassian/rovo-connectors-config/google/app-selector-icon'
});
const $f96caf77f5e0e90e$export$e16bd899bb4eebf9 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f96caf77f5e0e90e$var$LazyGoogleDriveIconComponent, null)), $f96caf77f5e0e90e$var$OfficialIcon, 'small');
const $f96caf77f5e0e90e$export$99050685a064f8e = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f96caf77f5e0e90e$var$LazyGoogleDriveSearchResultIconComponent, null)), $f96caf77f5e0e90e$var$OfficialIcon, 'medium');
const $f96caf77f5e0e90e$export$1f3b452b60b13122 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f96caf77f5e0e90e$var$LazyGoogleDriveIconBorderlessComponent, null)), $f96caf77f5e0e90e$var$OfficialIcon, 'xxsmall');
const $f96caf77f5e0e90e$export$e087ba40596ff085 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f96caf77f5e0e90e$var$LazyGoogleDriveAppSelectorIconComponent, null)), $f96caf77f5e0e90e$var$OfficialIcon, 'xxsmall');
module.exports["GoogleDriveIcon"] = $f96caf77f5e0e90e$export$e16bd899bb4eebf9;
module.exports["GoogleDriveSearchResultIcon"] = $f96caf77f5e0e90e$export$99050685a064f8e;
module.exports["GoogleDriveIconBorderless"] = $f96caf77f5e0e90e$export$1f3b452b60b13122;
module.exports["GoogleDriveAppSelectorIcon"] = $f96caf77f5e0e90e$export$e087ba40596ff085;

});

parcelRegister("eauWV", function(module, exports) {

let $a50a01c0fe4d8419$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a50a01c0fe4d8419$var$load("fz4Mg").then(()=>parcelRequire('aqriX'));

});

parcelRegister("Douji", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $216cd14c42636556$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("60nw9")).then((m)=>m.MicrosoftSharePointIcon), {
    moduleId: '@atlassian/logo-third-party/microsoft-sharepoint'
});

const $216cd14c42636556$var$LazySharePointIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("kabYe")).then((m)=>m.SharePointIcon), {
    moduleId: '@atlassian/rovo-connectors-config/sharepoint/icon'
});

const $216cd14c42636556$var$LazySharePointSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("kabYe")).then((m)=>m.SharePointSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/sharepoint/search-result-icon'
});

const $216cd14c42636556$var$LazySharepointIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("kabYe")).then((m)=>m.SharepointIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/sharepoint/icon-borderless'
});
const $216cd14c42636556$export$53d8bcde0f28cd56 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($216cd14c42636556$var$LazySharePointIconComponent, null)), $216cd14c42636556$var$OfficialIcon, 'small');
const $216cd14c42636556$export$65b9e0ddb04a51a1 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($216cd14c42636556$var$LazySharePointSearchResultIconComponent, null)), $216cd14c42636556$var$OfficialIcon, 'medium');
const $216cd14c42636556$export$a0d18fc9cea4f40e = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($216cd14c42636556$var$LazySharepointIconBorderlessComponent, null)), $216cd14c42636556$var$OfficialIcon, 'xxsmall');
module.exports["SharePointIcon"] = $216cd14c42636556$export$53d8bcde0f28cd56;
module.exports["SharePointSearchResultIcon"] = $216cd14c42636556$export$65b9e0ddb04a51a1;
module.exports["SharepointIconBorderless"] = $216cd14c42636556$export$a0d18fc9cea4f40e;

});

parcelRegister("60nw9", function(module, exports) {

let $45f4fc3fccb59bad$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $45f4fc3fccb59bad$var$load("i8lZ0").then(()=>parcelRequire('8RTwe'));

});

parcelRegister("kabYe", function(module, exports) {

let $eade06eb3e209cb5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $eade06eb3e209cb5$var$load("c2llp").then(()=>parcelRequire('58jvK'));

});

parcelRegister("iPmoS", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $b77f1e6828d0ac82$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("4hzFj")).then((m)=>m.GitHubIcon), {
    moduleId: '@atlassian/logo-third-party/github'
});

const $b77f1e6828d0ac82$var$LazyForgePioGithubIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("9RFVr")).then((m)=>m.ForgePioGithubIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-github-prod/icon'
});

const $b77f1e6828d0ac82$var$LazyForgePioGithubSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("9RFVr")).then((m)=>m.ForgePioGithubSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-github-prod/search-result-icon'
});
const $b77f1e6828d0ac82$export$f1d7e8d930f0538e = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b77f1e6828d0ac82$var$LazyForgePioGithubIconComponent, null)), $b77f1e6828d0ac82$var$OfficialIcon, 'small');
const $b77f1e6828d0ac82$export$f318f463f9328f3f = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b77f1e6828d0ac82$var$LazyForgePioGithubSearchResultIconComponent, null)), $b77f1e6828d0ac82$var$OfficialIcon, 'medium');
module.exports["ForgePioGithubIcon"] = $b77f1e6828d0ac82$export$f1d7e8d930f0538e;
module.exports["ForgePioGithubSearchResultIcon"] = $b77f1e6828d0ac82$export$f318f463f9328f3f;

});

parcelRegister("9RFVr", function(module, exports) {

let $72e995d3df53c84c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $72e995d3df53c84c$var$load("cNleL").then(()=>parcelRequire('gcarM'));

});

parcelRegister("fyTd1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c68b07ff1d2c6b607ecdbaaeae25db0f>>
 * @codegenCommand afm workspace @atlassian/logo-third-party generate:components
 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $bD1F5 = parcelRequire("bD1F5");

const $750b22bef93e24d6$var$markup = '<svg width="100%" height="100%" fill="none" viewBox="0 0 48 48"><path fill="#1d2022" d="M23.464 9h1.062c.25.044.607.037.872.061q.87.083 1.724.263c3.622.77 6.83 2.853 9.008 5.846a14.9 14.9 0 0 1 2.817 7.54c.01.12.034.652.053.74v1.118c-.026.12-.044.629-.058.795a15 15 0 0 1-3.77 8.653 15 15 0 0 1-5.437 3.86c-.31.13-.645.265-.969.354-.25.069-.596.023-.79-.156-.28-.26-.229-.653-.226-.998l.006-.812c.008-.999.02-2.018.008-3.016-.013-.996-.278-1.925-1.01-2.632.31-.026.708-.09 1.016-.145 1.372-.245 2.74-.71 3.793-1.657 1.44-1.297 1.914-3.084 2.02-4.954.101-1.817-.286-3.305-1.523-4.677.512-1.32.328-2.686-.148-3.978-1.246-.24-3.129.874-4.12 1.539-2.52-.66-4.979-.692-7.502.003-1.01-.668-2.857-1.762-4.121-1.542-.53 1.184-.614 2.759-.152 3.98a5.78 5.78 0 0 0-1.511 3.43c-.172 1.874.247 4.173 1.473 5.649 1.283 1.544 3.398 2.173 5.325 2.35-.605.582-.831 1.195-.958 2.013-.467.197-.849.323-1.363.375-1.127.114-2.08-.325-2.754-1.232-.139-.187-.257-.39-.39-.582a4 4 0 0 0-.707-.766c-.5-.41-1.041-.626-1.691-.558-.449.047-.618.241-.264.608.248.256.57.358.818.608.45.443.799 1.01 1.087 1.568.1.19.168.39.256.58.19.416.488.772.862 1.035 1.138.8 2.77.689 4.072.46-.011.245 0 .569.002.819l.007 1.311c.002.203.038.642-.007.82-.238.937-1.213.505-1.745.296a15 15 0 0 1-3.514-1.957 14.97 14.97 0 0 1-5.95-10.574c-.022-.248-.029-.645-.063-.87L9 24.553v-1.078c.022-.112.036-.544.047-.69q.049-.614.148-1.22a14.9 14.9 0 0 1 2.691-6.418A15 15 0 0 1 22.57 9.065c.273-.026.635-.02.894-.065"/></svg>';
function $750b22bef93e24d6$export$1e450c42b77127b1({ size: size, label: label = 'GitHub', testId: testId, type: type, UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bD1F5.ThirdPartyLogoWrapper), {
        markup: $750b22bef93e24d6$var$markup,
        label: label,
        size: size,
        testId: testId,
        type: type,
        UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry
    });
}
module.exports["GitHubIcon"] = $750b22bef93e24d6$export$1e450c42b77127b1;

});

parcelRegister("bD1F5", function(module, exports) {
/* wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $9NPFC = parcelRequire("9NPFC");

const $4c67a4021f7bef2b$var$glyphStyles = null;
const $4c67a4021f7bef2b$var$hexagonSizeStyles = {
    xxsmall: "_39xV02ey7F _0jFU0Vey7F",
    xsmall: "_39xV02SPN1 _0jFU0VSPN1",
    small: "_39xV02oWWg _0jFU0VoWWg",
    medium: "_39xV02Uofl _0jFU0VUofl",
    large: "_39xV02UF4f _0jFU0VUF4f",
    xlarge: "_39xV02pJKa _0jFU0VpJKa"
};
const $4c67a4021f7bef2b$var$updatedHexagonSizeStyles = {
    xxsmall: "_39xV02EGCh _0jFU0VQSd4",
    xsmall: "_39xV029oBa _0jFU0VDwJf",
    small: "_39xV021R6D _0jFU0V7qhK",
    medium: "_39xV02U2XU _0jFU0VRlO4",
    large: "_39xV02s3iu _0jFU0VNmyB",
    xlarge: "_39xV026W6Q _0jFU0VoFHQ"
};
const $4c67a4021f7bef2b$var$updatedHexagonClipPath = null;
const $4c67a4021f7bef2b$var$hexagonRootStyles = null;
const $4c67a4021f7bef2b$var$hexagonStyles = null;
const $4c67a4021f7bef2b$var$hexagonBorderStyles = null;
const $4c67a4021f7bef2b$var$hexagonContentStyles = null;
const $4c67a4021f7bef2b$var$svgIdAttributePattern = /\sid=(["'])([^"']+)\1/g;
const $4c67a4021f7bef2b$var$getSvgIdNamespace = (instanceId)=>`third-party-logo-${instanceId.replace(/[^a-zA-Z0-9_-]/g, '-')}`; /**
                                                                                                                             * Third-party SVGs can contain gradients, masks, and clipPaths with document-wide IDs.
                                                                                                                             * Namespacing each render keeps repeated logos from resolving `url(#id)` references to the
                                                                                                                             * first matching SVG definition elsewhere on the page.
                                                                                                                             */ 
const $4c67a4021f7bef2b$var$namespaceSvgIds = (markup, namespace)=>{
    const ids = Array.from(markup.matchAll($4c67a4021f7bef2b$var$svgIdAttributePattern), ([, , id])=>id);
    const uniqueIds = Array.from(new Set(ids));
    return uniqueIds.reduce((updatedMarkup, id)=>{
        const namespacedId = `${namespace}-${id}`;
        const escapedId = $4c67a4021f7bef2b$var$escapeRegExp(id);
        return updatedMarkup.replace(new RegExp(`\\sid=(["'])${escapedId}\\1`, 'g'), ` id=$1${namespacedId}$1`).replace(new RegExp(`url\\(#${escapedId}\\)`, 'g'), `url(#${namespacedId})`).replace(new RegExp(`(\\s(?:href|xlink:href)=["'])#${escapedId}(["'])`, 'g'), `$1#${namespacedId}$2`);
    }, markup);
};
const $4c67a4021f7bef2b$var$escapeRegExp = (value)=>value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
function $4c67a4021f7bef2b$export$96b07167eb29fb14({ markup: markup, size: size = 'medium', label: label = '', testId: testId, type: type = 'app', UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry }) {
    const instanceId = (0, $cozmU.useId)();
    const namespacedMarkup = (0, $cozmU.useMemo)(()=>$4c67a4021f7bef2b$var$namespaceSvgIds(markup, $4c67a4021f7bef2b$var$getSvgIdNamespace(instanceId)), [
        markup,
        instanceId
    ]);
    const glyph = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        "aria-hidden": "true",
        dangerouslySetInnerHTML: {
            __html: namespacedMarkup
        },
        className: (0, $hekY6.default)([
            "_3iDTPbvLZJ _39xV02N91d _0jFU0VN91d"
        ])
    });
    if (type === 'agent') return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        "data-testid": testId,
        "aria-label": label !== '' ? label : undefined,
        role: label !== '' ? 'img' : undefined,
        className: (0, $hekY6.default)([
            "_3iDTPbccYA _3YEZNOdnbC _1RrJLit2nV",
            !UNSAFE_isUpdatedGeometry && $4c67a4021f7bef2b$var$hexagonSizeStyles[size],
            UNSAFE_isUpdatedGeometry && $4c67a4021f7bef2b$var$updatedHexagonSizeStyles[size]
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            className: (0, $hekY6.default)([
                "_3iDTPbccYA _24h04i2Njc _39xV02N91d _0jFU0VN91d _1uo2ZfTcEg",
                "_4c065UNvrM _2Y7lL4NvrM _0KLXruIDZ8",
                UNSAFE_isUpdatedGeometry && "_1uo2ZfEXe0"
            ]),
            children: /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                className: (0, $hekY6.default)([
                    "_3iDTPbvLZJ _39xV02N91d _0jFU0VN91d _0KLXrut28M _1uo2ZfOLYo"
                ]),
                children: glyph
            })
        })
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9NPFC.default // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- Tile's backgroundColor API accepts the semantic `white` value.
    ), {
        backgroundColor: "white",
        label: label,
        size: size,
        testId: testId,
        hasBorder: true,
        isInset: false,
        children: glyph
    });
}
module.exports["ThirdPartyLogoWrapper"] = $4c67a4021f7bef2b$export$96b07167eb29fb14;

});

parcelRegister("4zc1o", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ac338e9874c603146412047b69e4afeb>>
 * @codegenCommand afm workspace @atlassian/logo-third-party generate:components
 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $bD1F5 = parcelRequire("bD1F5");

const $0245abe18739bd2c$var$markup = '<svg width="100%" height="100%" fill="none" viewBox="0 0 48 48"><mask id="mask0_118280_5589" width="32" height="28" x="8" y="9" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#b43333" d="M18.03 12.455c2.659-4.606 9.307-4.607 11.967 0l8.187 14.181C40.844 31.242 37.52 37 32.201 37H15.825c-5.318 0-8.642-5.758-5.983-10.364z"/></mask><g mask="url(#mask0_118280_5589)"><path fill="url(#paint0_linear_118280_5589)" d="M44.178 37.004H27.47l-3.457-5.988 8.353-14.47z"/><path fill="url(#paint1_linear_118280_5589)" d="m3.846 37.004 11.811-20.457-3.456 5.987h6.913l8.354 14.47z"/><path fill="url(#paint2_linear_118280_5589)" d="m24.015 2.074 8.354 14.47-3.457 5.987H12.204z"/></g><defs><linearGradient id="paint0_linear_118280_5589" x1="41.759" x2="25.302" y1="35.836" y2="25.947" gradientUnits="userSpaceOnUse"><stop offset=".09" stop-color="#ffe921"/><stop offset="1" stop-color="#fec700"/></linearGradient><linearGradient id="paint1_linear_118280_5589" x1="27.359" x2="9.383" y1="38.75" y2="27.875" gradientUnits="userSpaceOnUse"><stop offset=".15" stop-color="#a9a8ff"/><stop offset=".33" stop-color="#6d97ff"/><stop offset=".48" stop-color="#3186ff"/></linearGradient><linearGradient id="paint2_linear_118280_5589" x1="29.992" x2="11.777" y1="12.613" y2="21.115" gradientUnits="userSpaceOnUse"><stop offset=".55" stop-color="#0ebc5f"/><stop offset=".85" stop-color="#78c9ff"/></linearGradient></defs></svg>';
function $0245abe18739bd2c$export$e16bd899bb4eebf9({ size: size, label: label = 'Google Drive', testId: testId, type: type, UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bD1F5.ThirdPartyLogoWrapper), {
        markup: $0245abe18739bd2c$var$markup,
        label: label,
        size: size,
        testId: testId,
        type: type,
        UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry
    });
}
module.exports["GoogleDriveIcon"] = $0245abe18739bd2c$export$e16bd899bb4eebf9;

});

parcelRegister("8RTwe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6f2aa8c41b28ad95f2edc4a75dfe3a27>>
 * @codegenCommand afm workspace @atlassian/logo-third-party generate:components
 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $bD1F5 = parcelRequire("bD1F5");

const $9a3d60b77ddc3f21$var$markup = '<svg width="100%" height="100%" fill="none" viewBox="0 0 48 48"><path fill="url(#paint0_linear_118280_5862)" d="M22.58 27.1c5.006 0 9.064-4.052 9.064-9.05S27.585 9 22.58 9s-9.064 4.052-9.064 9.05 4.058 9.05 9.064 9.05"/><path fill="url(#paint1_radial_118280_5862)" d="M22.58 27.1c5.006 0 9.064-4.052 9.064-9.05S27.585 9 22.58 9s-9.064 4.052-9.064 9.05 4.058 9.05 9.064 9.05"/><path fill="url(#paint2_radial_118280_5862)" d="M22.58 27.1c5.006 0 9.064-4.052 9.064-9.05S27.585 9 22.58 9s-9.064 4.052-9.064 9.05 4.058 9.05 9.064 9.05"/><path fill="url(#paint3_radial_118280_5862)" d="M22.58 27.1c5.006 0 9.064-4.052 9.064-9.05S27.585 9 22.58 9s-9.064 4.052-9.064 9.05 4.058 9.05 9.064 9.05"/><path fill="url(#paint4_linear_118280_5862)" d="M30.847 33.13c4.172 0 7.553-3.376 7.553-7.541s-3.381-7.542-7.553-7.542c-4.171 0-7.553 3.376-7.553 7.542 0 4.165 3.382 7.541 7.553 7.541"/><path fill="url(#paint5_radial_118280_5862)" d="M30.847 33.13c4.172 0 7.553-3.376 7.553-7.541s-3.381-7.542-7.553-7.542c-4.171 0-7.553 3.376-7.553 7.542 0 4.165 3.382 7.541 7.553 7.541"/><path fill="url(#paint6_radial_118280_5862)" d="M30.847 33.13c4.172 0 7.553-3.376 7.553-7.541s-3.381-7.542-7.553-7.542c-4.171 0-7.553 3.376-7.553 7.542 0 4.165 3.382 7.541 7.553 7.541"/><path fill="url(#paint7_linear_118280_5862)" d="M23.712 39.169c3.546 0 6.42-2.87 6.42-6.41s-2.874-6.411-6.42-6.411a6.415 6.415 0 0 0-6.42 6.41c0 3.54 2.875 6.41 6.42 6.41"/><path fill="url(#paint8_linear_118280_5862)" d="M23.712 39.169c3.546 0 6.42-2.87 6.42-6.41s-2.874-6.411-6.42-6.411a6.415 6.415 0 0 0-6.42 6.41c0 3.54 2.875 6.41 6.42 6.41"/><path fill="url(#paint9_radial_118280_5862)" d="M13.703 23.324h7.179a2.453 2.453 0 0 1 2.453 2.453v7.16a2.453 2.453 0 0 1-2.453 2.454h-7.179a2.453 2.453 0 0 1-2.453-2.453v-7.16a2.453 2.453 0 0 1 2.453-2.454"/><path fill="url(#paint10_radial_118280_5862)" d="M13.703 23.324h7.179a2.453 2.453 0 0 1 2.453 2.453v7.16a2.453 2.453 0 0 1-2.453 2.454h-7.179a2.453 2.453 0 0 1-2.453-2.453v-7.16a2.453 2.453 0 0 1 2.453-2.454"/><path fill="#fff" d="m14.689 31.445 1.31-.683q.221.447.579.659.36.211.79.212.476 0 .726-.193.25-.198.25-.591a.67.67 0 0 0-.24-.52q-.24-.216-.853-.327-1.166-.212-1.695-.74-.525-.53-.525-1.318 0-.981.694-1.569.694-.585 1.83-.586.765 0 1.349.313.583.312.925.894l-1.281.66a1.4 1.4 0 0 0-.457-.472q-.247-.15-.617-.15-.443 0-.675.193a.63.63 0 0 0-.226.5q0 .265.217.467.222.197.886.322 1.117.212 1.666.77.555.553.554 1.4 0 1.03-.66 1.63t-1.883.6q-.886 0-1.599-.384a2.54 2.54 0 0 1-1.064-1.087z"/><defs><radialGradient id="paint1_radial_118280_5862" cx="0" cy="0" r="1" gradientTransform="matrix(-5.32263 -12.8627 -23.1621 9.55567 25.665 29.882)" gradientUnits="userSpaceOnUse"><stop offset=".29" stop-color="#003b5d" stop-opacity=".2"/><stop offset=".61" stop-color="#004a6c" stop-opacity=".138"/><stop offset=".97" stop-color="#006f94" stop-opacity="0"/></radialGradient><radialGradient id="paint2_radial_118280_5862" cx="0" cy="0" r="1" gradientTransform="matrix(-4.41835 -10.8865 -19.5798 7.9222 24.391 24.611)" gradientUnits="userSpaceOnUse"><stop offset=".26" stop-color="#002a42" stop-opacity=".31"/><stop offset=".61" stop-color="#004261" stop-opacity=".214"/><stop offset=".97" stop-color="#006f94" stop-opacity="0"/></radialGradient><radialGradient id="paint3_radial_118280_5862" cx="0" cy="0" r="1" gradientTransform="matrix(-5.56759 8.10392 8.11617 5.55934 27.893 10.686)" gradientUnits="userSpaceOnUse"><stop stop-color="#78edff" stop-opacity=".698"/><stop offset="1" stop-color="#2ccfca" stop-opacity="0"/></radialGradient><radialGradient id="paint5_radial_118280_5862" cx="0" cy="0" r="1" gradientTransform="matrix(3.0738 -8.81188 -15.9013 -5.52951 26.098 31.084)" gradientUnits="userSpaceOnUse"><stop stop-color="#003b5d" stop-opacity=".502"/><stop offset=".49" stop-color="#004c6c" stop-opacity=".362"/><stop offset=".97" stop-color="#007a86" stop-opacity="0"/></radialGradient><radialGradient id="paint6_radial_118280_5862" cx="0" cy="0" r="1" gradientTransform="matrix(-4.6396 6.75319 6.76325 4.63263 34.97 19.304)" gradientUnits="userSpaceOnUse"><stop stop-color="#78edff" stop-opacity=".698"/><stop offset="1" stop-color="#2ccfca" stop-opacity="0"/></radialGradient><radialGradient id="paint9_radial_118280_5862" cx="0" cy="0" r="1" gradientTransform="matrix(12.1028 12.086 12.105 -12.0839 13.08 23.761)" gradientUnits="userSpaceOnUse"><stop offset=".06" stop-color="#00b6bd"/><stop offset=".89" stop-color="#00495c"/></radialGradient><radialGradient id="paint10_radial_118280_5862" cx="0" cy="0" r="1" gradientTransform="matrix(0 8.45945 -9.64483 0 17.124 30.643)" gradientUnits="userSpaceOnUse"><stop offset=".57" stop-color="#1e8581" stop-opacity="0"/><stop offset=".97" stop-color="#1ecbe6" stop-opacity=".6"/></radialGradient><linearGradient id="paint0_linear_118280_5862" x1="16.812" x2="28.885" y1="10.479" y2="26.325" gradientUnits="userSpaceOnUse"><stop stop-color="#00e3df"/><stop offset=".41" stop-color="#0097a8"/><stop offset="1" stop-color="#007791"/></linearGradient><linearGradient id="paint4_linear_118280_5862" x1="26.04" x2="36.102" y1="19.279" y2="32.485" gradientUnits="userSpaceOnUse"><stop stop-color="#00e3df"/><stop offset=".48" stop-color="#00a2b8"/><stop offset=".95" stop-color="#00637c"/></linearGradient><linearGradient id="paint7_linear_118280_5862" x1="20.506" x2="26.919" y1="26.346" y2="39.17" gradientUnits="userSpaceOnUse"><stop offset=".05" stop-color="#75fff6"/><stop offset=".51" stop-color="#00c7d1"/><stop offset=".96" stop-color="#0096ad"/></linearGradient><linearGradient id="paint8_linear_118280_5862" x1="28.894" x2="25.466" y1="40.029" y2="35.22" gradientUnits="userSpaceOnUse"><stop offset=".26" stop-color="#0e5a5d" stop-opacity=".322"/><stop offset=".54" stop-color="#126c6b" stop-opacity=".222"/><stop offset=".97" stop-color="#1c948a" stop-opacity="0"/></linearGradient></defs></svg>';
function $9a3d60b77ddc3f21$export$18737550276ca4ad({ size: size, label: label = 'Microsoft SharePoint', testId: testId, type: type, UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bD1F5.ThirdPartyLogoWrapper), {
        markup: $9a3d60b77ddc3f21$var$markup,
        label: label,
        size: size,
        testId: testId,
        type: type,
        UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry
    });
}
module.exports["MicrosoftSharePointIcon"] = $9a3d60b77ddc3f21$export$18737550276ca4ad;

});

parcelRegister("5TdBT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::352a2d656f28112e2ef3d91735e599d7>>
 * @codegenCommand afm workspace @atlassian/logo-third-party generate:components
 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $bD1F5 = parcelRequire("bD1F5");

const $f87149460128dc3a$var$markup = '<svg width="100%" height="100%" fill="none" viewBox="0 0 48 48"><path fill="url(#paint0_radial_118280_5819)" d="M16.396 15.797c-5.198 0-9.083 4.255-9.376 8.995.181 1.021.776 3.038 1.708 2.935 1.165-.13 4.1 0 6.602-4.531 1.828-3.31 5.589-7.4 1.066-7.4"/><path fill="url(#paint1_radial_118280_5819)" d="M15.194 17.566c-1.747 2.767-4.1 6.73-4.893 7.978-.944 1.483-3.442.853-3.235-1.273q-.03.26-.047.522a9.517 9.517 0 0 0 9.497 10.121c6.013 0 20.353-7.491 18.902-14.997-1.53-4.412-5.83-7.577-10.701-7.577s-7.995 2.807-9.523 5.226"/><path fill="url(#paint2_radial_118280_5819)" fill-opacity=".4" d="M15.194 17.566c-1.747 2.767-4.1 6.73-4.893 7.978-.944 1.483-3.442.853-3.235-1.273q-.03.26-.047.522a9.517 9.517 0 0 0 9.497 10.121c6.013 0 20.353-7.491 18.902-14.997-1.53-4.412-5.83-7.577-10.701-7.577s-7.995 2.807-9.523 5.226"/><path fill="url(#paint3_radial_118280_5819)" d="M15.194 17.566c-1.747 2.767-4.1 6.73-4.893 7.978-.944 1.483-3.442.853-3.235-1.273q-.03.26-.047.522a9.517 9.517 0 0 0 9.497 10.121c6.013 0 20.353-7.491 18.902-14.997-1.53-4.412-5.83-7.577-10.701-7.577s-7.995 2.807-9.523 5.226"/><path fill="url(#paint4_radial_118280_5819)" fill-opacity=".6" d="M15.194 17.566c-1.747 2.767-4.1 6.73-4.893 7.978-.944 1.483-3.442.853-3.235-1.273q-.03.26-.047.522a9.517 9.517 0 0 0 9.497 10.121c6.013 0 20.353-7.491 18.902-14.997-1.53-4.412-5.83-7.577-10.701-7.577s-7.995 2.807-9.523 5.226"/><path fill="url(#paint5_radial_118280_5819)" fill-opacity=".9" d="M15.194 17.566c-1.747 2.767-4.1 6.73-4.893 7.978-.944 1.483-3.442.853-3.235-1.273q-.03.26-.047.522a9.517 9.517 0 0 0 9.497 10.121c6.013 0 20.353-7.491 18.902-14.997-1.53-4.412-5.83-7.577-10.701-7.577s-7.995 2.807-9.523 5.226"/><path fill="url(#paint6_linear_118280_5819)" d="M16.429 34.918s14.357.028 16.792.028c4.419 0 7.779-3.608 7.779-7.818s-3.428-7.796-7.78-7.796c-4.351 0-6.857 3.256-8.74 6.81-2.205 4.164-5.019 8.726-8.051 8.776"/><path fill="url(#paint7_radial_118280_5819)" fill-opacity=".4" d="M16.429 34.918s14.357.028 16.792.028c4.419 0 7.779-3.608 7.779-7.818s-3.428-7.796-7.78-7.796c-4.351 0-6.857 3.256-8.74 6.81-2.205 4.164-5.019 8.726-8.051 8.776"/><path fill="url(#paint8_radial_118280_5819)" fill-opacity=".9" d="M16.429 34.918s14.357.028 16.792.028c4.419 0 7.779-3.608 7.779-7.818s-3.428-7.796-7.78-7.796c-4.351 0-6.857 3.256-8.74 6.81-2.205 4.164-5.019 8.726-8.051 8.776"/><defs><radialGradient id="paint0_radial_118280_5819" cx="0" cy="0" r="1" gradientTransform="rotate(50.153 -14.375 16.71)scale(10.7161 17.7747)" gradientUnits="userSpaceOnUse"><stop stop-color="#4894fe"/><stop offset=".695" stop-color="#0934b3"/></radialGradient><radialGradient id="paint1_radial_118280_5819" cx="0" cy="0" r="1" gradientTransform="rotate(130.923 17.143 10.667)scale(46.0803 34.1459)" gradientUnits="userSpaceOnUse"><stop offset=".165" stop-color="#23c0fe"/><stop offset=".534" stop-color="#1c91ff"/></radialGradient><radialGradient id="paint2_radial_118280_5819" cx="0" cy="0" r="1" gradientTransform="rotate(220.014 10.522 6.163)scale(9.36856 21.4466)" gradientUnits="userSpaceOnUse"><stop stop-color="#fff"/><stop offset=".661" stop-color="#adc0ff" stop-opacity="0"/></radialGradient><radialGradient id="paint3_radial_118280_5819" cx="0" cy="0" r="1" gradientTransform="rotate(220.236 17.663 9.818)scale(10.5597 16.0372)" gradientUnits="userSpaceOnUse"><stop stop-color="#033acc"/><stop offset="1" stop-color="#368eff" stop-opacity="0"/></radialGradient><radialGradient id="paint4_radial_118280_5819" cx="0" cy="0" r="1" gradientTransform="rotate(66.571 -1.855 16.474)scale(23.1705 25.0138)" gradientUnits="userSpaceOnUse"><stop offset=".593" stop-color="#3464e3" stop-opacity="0"/><stop offset="1" stop-color="#033acc"/></radialGradient><radialGradient id="paint5_radial_118280_5819" cx="0" cy="0" r="1" gradientTransform="rotate(135 16.558 11.022)scale(34.0831 53.3967)" gradientUnits="userSpaceOnUse"><stop stop-color="#4bfde8"/><stop offset=".544" stop-color="#4bfde8" stop-opacity="0"/></radialGradient><radialGradient id="paint7_radial_118280_5819" cx="0" cy="0" r="1" gradientTransform="rotate(21.632 -45.065 64.673)scale(15.4444 29.2464)" gradientUnits="userSpaceOnUse"><stop stop-color="#fff"/><stop offset=".785" stop-color="#fff" stop-opacity="0"/></radialGradient><radialGradient id="paint8_radial_118280_5819" cx="0" cy="0" r="1" gradientTransform="rotate(139.243 16.894 16.587)scale(21.1738 21.2455)" gradientUnits="userSpaceOnUse"><stop stop-color="#4bfde8"/><stop offset=".585" stop-color="#4bfde8" stop-opacity="0"/></radialGradient><linearGradient id="paint6_linear_118280_5819" x1="28.722" x2="28.722" y1="34.931" y2="19.517" gradientUnits="userSpaceOnUse"><stop stop-color="#0086ff"/><stop offset=".49" stop-color="#0bf"/></linearGradient></defs></svg>';
function $f87149460128dc3a$export$adf3a43722623322({ size: size, label: label = 'Microsoft OneDrive', testId: testId, type: type, UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bD1F5.ThirdPartyLogoWrapper), {
        markup: $f87149460128dc3a$var$markup,
        label: label,
        size: size,
        testId: testId,
        type: type,
        UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry
    });
}
module.exports["MicrosoftOneDriveIcon"] = $f87149460128dc3a$export$adf3a43722623322;

});

parcelRegister("9dBNg", function(module, exports) {

var $fR63l = parcelRequire("fR63l");

const $e48c29dee48cfc00$export$ae953a2876729d03 = new Map([
    [
        (0, $fR63l.ProductResourceTypes3P).AtlassianWebCrawler,
        (0, $fR63l.ProductKeys3P).AtlassianWebCrawler
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Figma,
        (0, $fR63l.ProductKeys3P).Figma
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Github,
        (0, $fR63l.ProductKeys3P).Github
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).GoogleDrive,
        (0, $fR63l.ProductKeys3P).GoogleDrive
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).OneDrive,
        (0, $fR63l.ProductKeys3P).OneDrive
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Dropbox,
        (0, $fR63l.ProductKeys3P).Dropbox
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Slack,
        (0, $fR63l.ProductKeys3P).Slack
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Sharepoint,
        (0, $fR63l.ProductKeys3P).Sharepoint
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Teams,
        (0, $fR63l.ProductKeys3P).Teams
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).GoogleCalendar,
        (0, $fR63l.ProductKeys3P).GoogleCalendar
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).OutlookCalendar,
        (0, $fR63l.ProductKeys3P).OutlookCalendar
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).OutlookMail,
        (0, $fR63l.ProductKeys3P).OutlookMail
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Gmail,
        (0, $fR63l.ProductKeys3P).Gmail
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).AdobeSign,
        (0, $fR63l.ProductKeys3P).AdobeSign
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Asana,
        (0, $fR63l.ProductKeys3P).Asana
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Zendesk,
        (0, $fR63l.ProductKeys3P).Zendesk
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Airtable,
        (0, $fR63l.ProductKeys3P).Airtable
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Smartsheet,
        (0, $fR63l.ProductKeys3P).Smartsheet
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Notion,
        (0, $fR63l.ProductKeys3P).Notion
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Miro,
        (0, $fR63l.ProductKeys3P).Miro
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Docusign,
        (0, $fR63l.ProductKeys3P).Docusign
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Lucid,
        (0, $fR63l.ProductKeys3P).Lucid
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Monday,
        (0, $fR63l.ProductKeys3P).Monday
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).AzureDevops,
        (0, $fR63l.ProductKeys3P).AzureDevops
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Gitlab,
        (0, $fR63l.ProductKeys3P).Gitlab
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ConfluenceDC,
        (0, $fR63l.ProductKeys3P).ConfluenceDC
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).JiraDC,
        (0, $fR63l.ProductKeys3P).JiraDC
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).JsmDC,
        (0, $fR63l.ProductKeys3P).JsmDC
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Canva,
        (0, $fR63l.ProductKeys3P).Canva
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Box,
        (0, $fR63l.ProductKeys3P).Box
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Gong,
        (0, $fR63l.ProductKeys3P).Gong
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Zoom,
        (0, $fR63l.ProductKeys3P).Zoom
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Zeplin,
        (0, $fR63l.ProductKeys3P).Zeplin
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ServiceNow,
        (0, $fR63l.ProductKeys3P).ServiceNow
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Freshservice,
        (0, $fR63l.ProductKeys3P).Freshservice
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).PowerBI,
        (0, $fR63l.ProductKeys3P).PowerBI
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ClickUp,
        (0, $fR63l.ProductKeys3P).ClickUp
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Amplitude,
        (0, $fR63l.ProductKeys3P).Amplitude
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Stripe,
        (0, $fR63l.ProductKeys3P).Stripe
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).AdobeXD,
        (0, $fR63l.ProductKeys3P).AdobeXD
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Aha,
        (0, $fR63l.ProductKeys3P).Aha
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Mural,
        (0, $fR63l.ProductKeys3P).Mural
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Webex,
        (0, $fR63l.ProductKeys3P).Webex
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Todoist,
        (0, $fR63l.ProductKeys3P).Todoist
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).PagerDuty,
        (0, $fR63l.ProductKeys3P).PagerDuty
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Pipedrive,
        (0, $fR63l.ProductKeys3P).Pipedrive
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Hubspot,
        (0, $fR63l.ProductKeys3P).Hubspot
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Dovetail,
        (0, $fR63l.ProductKeys3P).Dovetail
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).LaunchDarkly,
        (0, $fR63l.ProductKeys3P).LaunchDarkly
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Salesforce,
        (0, $fR63l.ProductKeys3P).Salesforce
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Sentry,
        (0, $fR63l.ProductKeys3P).Sentry
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Gitbook,
        (0, $fR63l.ProductKeys3P).Gitbook
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).AWSS3,
        (0, $fR63l.ProductKeys3P).AWSS3
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Databricks,
        (0, $fR63l.ProductKeys3P).Databricks
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgeAdamVitareqDev,
        (0, $fR63l.ProductKeys3P).ForgeAdamVitareqDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgeAdamVitareqProd,
        (0, $fR63l.ProductKeys3P).ForgeAdamVitareqProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgeK15tScrollSitesDev,
        (0, $fR63l.ProductKeys3P).ForgeK15tScrollSitesDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgeK15tScrollSitesProd,
        (0, $fR63l.ProductKeys3P).ForgeK15tScrollSitesProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioAwsDev,
        (0, $fR63l.ProductKeys3P).ForgePioAwsDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioAwsProd,
        (0, $fR63l.ProductKeys3P).ForgePioAwsProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioClickupDev,
        (0, $fR63l.ProductKeys3P).ForgePioClickupDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioClickupProd,
        (0, $fR63l.ProductKeys3P).ForgePioClickupProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioGitbookDev,
        (0, $fR63l.ProductKeys3P).ForgePioGitbookDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioGitbookProd,
        (0, $fR63l.ProductKeys3P).ForgePioGitbookProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioGithubDev,
        (0, $fR63l.ProductKeys3P).ForgePioGithubDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioGithubProd,
        (0, $fR63l.ProductKeys3P).ForgePioGithubProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioGitlabDev,
        (0, $fR63l.ProductKeys3P).ForgePioGitlabDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioGitlabProd,
        (0, $fR63l.ProductKeys3P).ForgePioGitlabProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioGoogleDriveDev,
        (0, $fR63l.ProductKeys3P).ForgePioGoogleDriveDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioGoogleDriveProd,
        (0, $fR63l.ProductKeys3P).ForgePioGoogleDriveProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioGuruDev,
        (0, $fR63l.ProductKeys3P).ForgePioGuruDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioGuruProd,
        (0, $fR63l.ProductKeys3P).ForgePioGuruProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioHelpjuiceDev,
        (0, $fR63l.ProductKeys3P).ForgePioHelpjuiceDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioHelpjuiceProd,
        (0, $fR63l.ProductKeys3P).ForgePioHelpjuiceProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioHubspotDev,
        (0, $fR63l.ProductKeys3P).ForgePioHubspotDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioHubspotProd,
        (0, $fR63l.ProductKeys3P).ForgePioHubspotProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioSalesforceDev,
        (0, $fR63l.ProductKeys3P).ForgePioSalesforceDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioSalesforceProd,
        (0, $fR63l.ProductKeys3P).ForgePioSalesforceProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioSharepointDev,
        (0, $fR63l.ProductKeys3P).ForgePioSharepointDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioSharepointProd,
        (0, $fR63l.ProductKeys3P).ForgePioSharepointProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioStackOverflowDev,
        (0, $fR63l.ProductKeys3P).ForgePioStackOverflowDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioStackOverflowProd,
        (0, $fR63l.ProductKeys3P).ForgePioStackOverflowProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgeUtoolityGitbookDev,
        (0, $fR63l.ProductKeys3P).ForgeUtoolityGitbookDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgeUtoolityGitbookProd,
        (0, $fR63l.ProductKeys3P).ForgeUtoolityGitbookProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgeGdriveEugeneTestDev,
        (0, $fR63l.ProductKeys3P).ForgeGdriveEugeneTestDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgeGdriveEugeneTestProd,
        (0, $fR63l.ProductKeys3P).ForgeGdriveEugeneTestProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgeUnitoSalesforceDev,
        (0, $fR63l.ProductKeys3P).ForgeUnitoSalesforceDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgeUnitoSalesforceProd,
        (0, $fR63l.ProductKeys3P).ForgeUnitoSalesforceProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgeUnitoServicenowDev,
        (0, $fR63l.ProductKeys3P).ForgeUnitoServicenowDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgeUnitoServicenowProd,
        (0, $fR63l.ProductKeys3P).ForgeUnitoServicenowProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgeUnitoWrikeDev,
        (0, $fR63l.ProductKeys3P).ForgeUnitoWrikeDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgeUnitoWrikeProd,
        (0, $fR63l.ProductKeys3P).ForgeUnitoWrikeProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgeUnitoAsanaDev,
        (0, $fR63l.ProductKeys3P).ForgeUnitoAsanaDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgeUnitoAsanaProd,
        (0, $fR63l.ProductKeys3P).ForgeUnitoAsanaProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgeUnitoBasecampDev,
        (0, $fR63l.ProductKeys3P).ForgeUnitoBasecampDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgeUnitoBasecampProd,
        (0, $fR63l.ProductKeys3P).ForgeUnitoBasecampProd
    ]
]);
module.exports["ResourceTypeToProductKeyMap"] = $e48c29dee48cfc00$export$ae953a2876729d03;

});

parcelRegister("hXDOc", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");

var $b22e252a6b9677fd$export$3c7387d0e5ed624d = /*#__PURE__*/ function(PreloadingMode) {
    PreloadingMode["onlyJS"] = "onlyJS";
    PreloadingMode["onlyJSAndCriticalData"] = "onlyJSAndCriticalData";
    PreloadingMode["everything"] = "everything";
    return PreloadingMode;
}({});
const $b22e252a6b9677fd$var$PRELOAD_TIMER = 100;
const $b22e252a6b9677fd$var$sendAnalyticsEvent = (createAnalyticsEvent, action, name, attributes)=>{
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: action,
            actionSubject: 'hoverPreloader',
            actionSubjectId: name ?? 'n/a',
            source: 'hoverPreloader',
            attributes: attributes
        }
    }).fire();
};
const $b22e252a6b9677fd$var$preload = (preloadUrl, options = {})=>{
    window.dispatchEvent(new CustomEvent('preloadOnHover', {
        bubbles: true,
        detail: {
            preloadUrl: preloadUrl,
            ...options
        }
    }));
};
const $b22e252a6b9677fd$var$TransitionPreloaderImpl = ({ name: name, children: children, preloadUrl: preloadUrl, preloadOptions: preloadOptions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const hoverTimeoutRef = (0, $cozmU.useRef)(null);
    const preloadRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            preloadRef.current = false;
            if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        };
    }, []);
    // Here we implement multi-stage preloading. JS can be preloaded immediately and unconditionally.
    // For the rest of the preload options / experiments require at least a timeout, but other cases
    // may require more sophisticated logic to decide when or whether to preload.
    const onMouseEnter = (0, $cozmU.useCallback)(()=>{
        preloadRef.current = false;
        $b22e252a6b9677fd$var$preload(preloadUrl, {
            preloadingMode: "onlyJS"
        });
        // Only the everything mode proceeds to data preloading.
        if (preloadOptions?.preloadingMode !== "everything") return;
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        hoverTimeoutRef.current = window.setTimeout(()=>{
            $b22e252a6b9677fd$var$preload(preloadUrl, preloadOptions);
            preloadRef.current = true;
        }, $b22e252a6b9677fd$var$PRELOAD_TIMER);
    }, [
        preloadUrl,
        preloadOptions
    ]);
    const onMouseLeave = (0, $cozmU.useCallback)(()=>{
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        if (preloadRef.current) $b22e252a6b9677fd$var$sendAnalyticsEvent(createAnalyticsEvent, 'preloadAndLeave', name, {
            preloadingMode: preloadOptions?.preloadingMode
        });
    }, [
        createAnalyticsEvent,
        name,
        preloadOptions?.preloadingMode
    ]);
    const onMouseDown = (0, $cozmU.useCallback)(()=>{
        preloadRef.current = false;
    }, []);
    // Helper to chain child handlers with hover-preloader handlers
    const chain = (...fns)=>(...args)=>{
            fns.forEach((fn)=>{
                if (fn) fn(...args);
            });
        };
    const wrappedChild = /*#__PURE__*/ (0, $cozmU.isValidElement)(children) ? /*#__PURE__*/ (0, $cozmU.cloneElement)(children, {
        onMouseEnter: chain(children.props.onMouseEnter, onMouseEnter),
        onFocus: chain(children.props.onFocus, onMouseEnter),
        onMouseLeave: chain(children.props.onMouseLeave, onMouseLeave),
        onBlur: chain(children.props.onBlur, onMouseLeave),
        onMouseDown: chain(children.props.onMouseDown, onMouseDown)
    }) : children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-vc": `hover-preloader-${name}`,
        "data-testid": "hover-preloader"
    }, wrappedChild);
};
const $b22e252a6b9677fd$export$16d0fec7f7c7ddfa = (props)=>{
    if (!props.preloadUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, props.children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b22e252a6b9677fd$var$TransitionPreloaderImpl, props);
};
const $b22e252a6b9677fd$export$f5ad7b1003f136b2 = {
    onlyJS: {
        preloadingMode: "onlyJS"
    },
    onlyJSAndCriticalData: {
        preloadingMode: "onlyJSAndCriticalData"
    },
    everything: {
        preloadingMode: "everything"
    }
};
module.exports["PreloadingMode"] = $b22e252a6b9677fd$export$3c7387d0e5ed624d;
module.exports["HoverPreloader"] = $b22e252a6b9677fd$export$16d0fec7f7c7ddfa;
module.exports["PreloadingPresets"] = $b22e252a6b9677fd$export$f5ad7b1003f136b2;

});

parcelRegister("hpnxK", function(module, exports) {
const $88d658a04ba6cccf$export$bb4f02e6ef6f6e17 = (error)=>error.message?.includes('Cannot find space');
const $88d658a04ba6cccf$export$8e8597efbb5c0cd8 = (error)=>{
    const { extensions: extensions, path: path } = error;
    if (extensions?.errorSource !== 'GRAPHQL_GATEWAY' || extensions.classification !== 'CustomerAccountsNotSupportedException' || String(extensions.statusCode) !== '403') return false;
    return extensions.service === 'knowledge_discovery' && (!path?.length || path[0] === 'knowledgeDiscovery') || extensions.service === 'confluence_analytics' && (!path?.length || path[0] === 'contentAnalyticsViewers');
};
module.exports["isNotFoundSpaceError"] = $88d658a04ba6cccf$export$bb4f02e6ef6f6e17;
module.exports["isUnsupportedCustomerAccountFieldError"] = $88d658a04ba6cccf$export$8e8597efbb5c0cd8;

});

parcelRegister("3qGQ7", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");

const $1ddb1afb9a8b0771$var$DEFAULT_BYLINE_CONTRIBUTORS_FETCH_LIMIT = 4;
const $1ddb1afb9a8b0771$var$createSharedVariables = ({ userId: userId, spaceKey: spaceKey, versionOverride: versionOverride, isSSR: isSSR, preloadLabels: preloadLabels = false, includeAgentTrustReceiptData: includeAgentTrustReceiptData = false, includeAutomationDiscoveries: includeAutomationDiscoveries = false, includeAudioContent: includeAudioContent = false, includeRendererAssetsMedia: includeRendererAssetsMedia = false, includeRendererAssetsCustomChrome: includeRendererAssetsCustomChrome = false, includeMetadata: includeMetadata = false, includeClassification: includeClassification = false, includeContentHeader: includeContentHeader = false, includeSmartCreateFeedback: includeSmartCreateFeedback = false, includeContentHeaderAccess: includeContentHeaderAccess = false, includeFabricEditorEligibility: includeFabricEditorEligibility = false, includeReactions: includeReactions = false, includeRestrictions: includeRestrictions = false, includeRestrictionAncestors: includeRestrictionAncestors = false, useContentModeFragment: useContentModeFragment = false, autohighlightsQueryVariables: autohighlightsQueryVariables })=>({
        spaceKey: spaceKey,
        versionOverride: versionOverride,
        isSSR: isSSR,
        useNewContentTopper: true,
        ...preloadLabels || includeMetadata ? {
            preloadLabels: true
        } : {},
        ...includeAgentTrustReceiptData ? {
            includeAgentTrustReceiptData: true
        } : {},
        ...includeAutomationDiscoveries ? {
            includeAutomationDiscoveries: true
        } : {},
        ...includeAudioContent ? {
            includeAudioContent: true
        } : {},
        ...includeRendererAssetsMedia ? {
            includeRendererAssetsMedia: true
        } : {},
        ...includeRendererAssetsCustomChrome ? {
            includeRendererAssetsCustomChrome: true
        } : {},
        ...includeClassification || includeMetadata ? {
            includeClassification: true
        } : {},
        ...(includeClassification || includeMetadata) && (0, $6mKj3.expValEquals)('confluence_classification_level_v2', 'isEnabled', true) ? {
            useClassificationLevelV2: true
        } : {},
        ...includeContentHeader ? {
            includeContentHeader: true
        } : {},
        ...includeSmartCreateFeedback ? {
            includeSmartCreateFeedback: true
        } : {},
        ...includeContentHeaderAccess ? {
            includeContentHeaderAccess: true
        } : {},
        ...includeFabricEditorEligibility ? {
            includeFabricEditorEligibility: true
        } : {},
        ...includeReactions ? {
            includeReactions: true
        } : {},
        ...includeRestrictions ? {
            includeRestrictions: true
        } : {},
        ...includeRestrictionAncestors ? {
            includeRestrictionAncestors: true
        } : {},
        ...useContentModeFragment ? {
            useContentModeFragment: true
        } : {},
        ...autohighlightsQueryVariables && !(userId?.startsWith('qm:') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false)) ? {
            includeAutohighlights: true,
            autohighlightsEntityAri: autohighlightsQueryVariables.entityAri,
            autohighlightsWorkspaceId: autohighlightsQueryVariables.workspaceId
        } : {}
    });
const $1ddb1afb9a8b0771$var$createAgentSessionVariables = (agentSessionsUserId)=>agentSessionsUserId ? {
        agentSessionsPropertyKey: `cc-agent-mention-sessions:${agentSessionsUserId}`,
        fetchAgentSessionsMarker: true
    } : {};
const $1ddb1afb9a8b0771$var$createBylineVariables = (includeBylineContributors = false)=>includeBylineContributors ? {
        includeBylineContributors: true,
        bylineContributorsLimit: $1ddb1afb9a8b0771$var$DEFAULT_BYLINE_CONTRIBUTORS_FETCH_LIMIT
    } : {};
// Customer accounts have site-specific qm: IDs and are unsupported by these AGG services.
// Keep this exclusion inside the document experiment; standalone queries are unchanged.
const $1ddb1afb9a8b0771$var$createAnalyticsBylineVariables = (includeAnalyticsByline = false, userId)=>includeAnalyticsByline && !(userId?.startsWith('qm:') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false)) ? {
        includeAnalyticsByline: true
    } : {};
const $1ddb1afb9a8b0771$var$createConnectionAncestorVariables = (includeConnectionAncestors = false)=>includeConnectionAncestors ? {
        includeConnectionAncestors: true
    } : {};
const $1ddb1afb9a8b0771$export$5aa9cbe79a3cf3 = ({ contentId: contentId, agentSessionsUserId: agentSessionsUserId, includeBylineContributors: includeBylineContributors, includeConnectionAncestors: includeConnectionAncestors, includeAnalyticsByline: includeAnalyticsByline, includeContentHeaderPublicLink: includeContentHeaderPublicLink, includeRendererAssetsDsp: includeRendererAssetsDsp, rendererAssetsDspAction: rendererAssetsDspAction, externalLabelsQueryVariables: externalLabelsQueryVariables, rovoActivationQueryVariables: rovoActivationQueryVariables, ...sharedOptions })=>({
        contentId: contentId,
        ...$1ddb1afb9a8b0771$var$createSharedVariables(sharedOptions),
        ...$1ddb1afb9a8b0771$var$createAgentSessionVariables(agentSessionsUserId),
        ...$1ddb1afb9a8b0771$var$createBylineVariables(includeBylineContributors),
        ...$1ddb1afb9a8b0771$var$createConnectionAncestorVariables(includeConnectionAncestors),
        ...$1ddb1afb9a8b0771$var$createAnalyticsBylineVariables(includeAnalyticsByline, sharedOptions.userId),
        ...includeContentHeaderPublicLink ? {
            includeContentHeaderPublicLink: true
        } : {},
        ...includeRendererAssetsDsp ? {
            includeRendererAssetsDsp: true,
            rendererAssetsDspAction: rendererAssetsDspAction || 'PAGE_EXPORT'
        } : {},
        // Managed (external) labels: emit the include flag and args only when the
        // feature is on for this content. `externalLabelsCloudId`/`externalLabelsAri`
        // are declared nullable-with-default (`ID = ""`) on `ContentUnifiedQuery`, so
        // omitting them here is safe — GraphQL supplies the default, and a
        // nullable-with-default variable still satisfies the fragment's non-null
        // `ID!` argument via the variable-usage rule. Mirrors the autohighlights
        // pattern so omitting consumers get an unchanged variables object.
        ...externalLabelsQueryVariables ? {
            includeExternalLabels: true,
            externalLabelsCloudId: externalLabelsQueryVariables.cloudId,
            externalLabelsAri: externalLabelsQueryVariables.ari
        } : {},
        ...rovoActivationQueryVariables ? {
            includeRovoActivation: true,
            rovoActivationCloudId: rovoActivationQueryVariables.cloudId
        } : {}
    });
const $1ddb1afb9a8b0771$export$85ff462ea4060e8a = ({ contentId: contentId, includeBylineContributors: includeBylineContributors, includeAnalyticsByline: includeAnalyticsByline, includeContentHeaderPublicLink: includeContentHeaderPublicLink, includeRendererAssetsDsp: includeRendererAssetsDsp, rendererAssetsDspAction: rendererAssetsDspAction, ...sharedOptions })=>({
        contentId: contentId,
        ...$1ddb1afb9a8b0771$var$createSharedVariables(sharedOptions),
        ...$1ddb1afb9a8b0771$var$createBylineVariables(includeBylineContributors),
        ...$1ddb1afb9a8b0771$var$createAnalyticsBylineVariables(includeAnalyticsByline, sharedOptions.userId),
        ...includeContentHeaderPublicLink ? {
            includeContentHeaderPublicLink: true
        } : {},
        ...includeRendererAssetsDsp ? {
            includeRendererAssetsDsp: true,
            rendererAssetsDspAction: rendererAssetsDspAction || 'PAGE_EXPORT'
        } : {}
    });
const $1ddb1afb9a8b0771$export$2021e0be086a965a = ({ spaceKey: spaceKey, agentSessionsUserId: agentSessionsUserId, includeBylineContributors: includeBylineContributors, includeConnectionAncestors: includeConnectionAncestors, ...sharedOptions })=>({
        ...$1ddb1afb9a8b0771$var$createSharedVariables({
            ...sharedOptions,
            spaceKey: spaceKey
        }),
        spaceKey: spaceKey,
        ...$1ddb1afb9a8b0771$var$createAgentSessionVariables(agentSessionsUserId),
        ...includeBylineContributors ? {
            includeBylineContributors: true
        } : {},
        ...$1ddb1afb9a8b0771$var$createConnectionAncestorVariables(includeConnectionAncestors)
    });
module.exports["createContentUnifiedQueryVariables"] = $1ddb1afb9a8b0771$export$5aa9cbe79a3cf3;
module.exports["createContentBlogUnifiedQueryVariables"] = $1ddb1afb9a8b0771$export$85ff462ea4060e8a;
module.exports["createContentUnifiedWithSpaceKeyQueryVariables"] = $1ddb1afb9a8b0771$export$2021e0be086a965a;

});

parcelRegister("b2p4s", function(module, exports) {
/**
 * @generated SignedSource<<4e480f3ff7d119a77ec41231b6b4ab42>>
 * @relayHash aa12b95dc97d2068b03de4a55dcec507
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0ef2c27ad493d782c86e25177000afba538c3c0eb50c460bf6d939aa03f2139c
const $ac606d0e22e5c37c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "draftShareId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "webui"
                                }
                            ]
                        },
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "editor"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(key:\"editor\")"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "NotFoundContainerQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "NotFoundContainerQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "aa12b95dc97d2068b03de4a55dcec507",
            "id": "0ef2c27ad493d782c86e25177000afba538c3c0eb50c460bf6d939aa03f2139c",
            "metadata": {},
            "name": "NotFoundContainerQuery",
            "operationKind": "query",
            "text": "query NotFoundContainerQuery($contentId:ID!,$draftShareId:String,$status:[String]){content(id:$contentId,draftShareId:$draftShareId,status:$status){nodes{id,links{webui},properties(key:\"editor\"){nodes{id,key,value}}}}}"
        }
    };
}();
$ac606d0e22e5c37c$var$node.hash = "df3b0c202e5cf0f97257fa8a583747bc";
var $ac606d0e22e5c37c$export$2e2bcd8739ae039 = $ac606d0e22e5c37c$var$node;
module.exports["default"] = $ac606d0e22e5c37c$export$2e2bcd8739ae039;

});

parcelRegister("cS4kb", function(module, exports) {
const $5b142abb1411e5f7$var$UNKNOWN = 'unknown';
function $5b142abb1411e5f7$var$sanitizeUrl(url) {
    try {
        const urlObject = new URL(url);
        const hostname = urlObject.hostname;
        const pathname = urlObject.pathname;
        const firstPathSegment = pathname.split('/')[1];
        return firstPathSegment ? `${hostname}/${firstPathSegment}` : hostname;
    } catch  {
        return '';
    }
}
function $5b142abb1411e5f7$export$8071740a02e53ce2(link) {
    if (link.includes('/jira/') || link.includes('/servicedesk/') || link.includes('/helpcenter/') || link.includes('/projects/')) return 'jira';
    else if (link.includes('/wiki/')) return 'confluence';
    else if (link.includes('bitbucket')) return 'bitbucket';
    else if (link.includes('atlassian') || link.includes('jira-dev')) {
        // eslint-disable-next-line no-console
        console.log(`Resolving other atlassian link type: ${$5b142abb1411e5f7$var$sanitizeUrl(link)}`);
        return 'otherAtlassian';
    }
    return 'thirdParty';
}
function $5b142abb1411e5f7$export$70b802114e3b3d52(smartLinks) {
    return Object.values(smartLinks.reduce((acc, smartLink)=>{
        try {
            var _acc, _hostname;
            const hostname = new URL(smartLink.resourceUrl).hostname;
            ((_acc = acc)[_hostname = hostname] || (_acc[_hostname] = [])).push(smartLink);
        // eslint-disable-next-line no-unused-vars
        } catch (e) {
            var _acc1, _UNKNOWN;
            ((_acc1 = acc)[_UNKNOWN = $5b142abb1411e5f7$var$UNKNOWN] || (_acc1[_UNKNOWN] = [])).push(smartLink);
        }
        return acc;
    }, {}));
}
function $5b142abb1411e5f7$export$9f4b5e6e623e6720(smartLinksGroups, max) {
    const result = [];
    for (const smartLinks of smartLinksGroups){
        if (smartLinks.length <= max) result.push(smartLinks);
        else for(let i = 0; i < smartLinks.length; i += max)result.push(smartLinks.slice(i, i + max));
    }
    return result;
}
function $5b142abb1411e5f7$export$3e7fb54d0ef2df07(smartLinksGroups, min) {
    const result = [];
    const smallThirdPartyBatches = [];
    for (const smartLinks of smartLinksGroups)if (smartLinks.length >= min || $5b142abb1411e5f7$export$8071740a02e53ce2(smartLinks[0].resourceUrl) !== 'thirdParty') result.push(smartLinks);
    else smallThirdPartyBatches.push(...smartLinks);
    if (smallThirdPartyBatches.length > 0) result.push(smallThirdPartyBatches);
    return result;
}
function $5b142abb1411e5f7$export$8c4674ec524aaf2c(resourceUrl) {
    const type = $5b142abb1411e5f7$export$8071740a02e53ce2(resourceUrl);
    switch(type){
        case 'jira':
        case 'confluence':
        case 'bitbucket':
        case 'otherAtlassian':
            return true;
        default:
            return false;
    }
}
module.exports["getLinkType"] = $5b142abb1411e5f7$export$8071740a02e53ce2;
module.exports["groupSmartLinksByHostname"] = $5b142abb1411e5f7$export$70b802114e3b3d52;
module.exports["splitLinksIntoBatches"] = $5b142abb1411e5f7$export$9f4b5e6e623e6720;
module.exports["mergeSmallThirdPartyBatches"] = $5b142abb1411e5f7$export$3e7fb54d0ef2df07;
module.exports["isFirstPartyLink"] = $5b142abb1411e5f7$export$8c4674ec524aaf2c;

});

parcelRegister("hu6Tz", function(module, exports) {

var $gw4Eo = parcelRequire("gw4Eo");

const $ceeb6fd84b3cae53$export$7625152cc0552e6b = ({ contentId: contentId, cloudId: cloudId, activationId: activationId, contentType: contentType })=>({
        entityAri: (0, $gw4Eo.getConfluenceContentAri)({
            siteId: cloudId,
            resourceType: contentType,
            resourceId: contentId,
            activationId: ''
        }),
        workspaceId: (0, $gw4Eo.getConfluenceContentAri)({
            siteId: cloudId,
            resourceType: 'workspace',
            resourceId: activationId,
            activationId: ''
        })
    });
module.exports["getAutohighlightsQueryVariables"] = $ceeb6fd84b3cae53$export$7625152cc0552e6b;

});

parcelRegister("gw4Eo", function(module, exports) {

var $1ggpj = parcelRequire("1ggpj");

const $17a724fe65d90332$export$6a2f2c83863e9bfe = (confluenceContentAriParameters)=>{
    const { siteId: siteId, resourceType: resourceType, activationId: activationId, resourceId: resourceId } = confluenceContentAriParameters;
    if ((0, $1ggpj.TYPES_WITH_ACTIVATIONID).includes(resourceType)) return `ari:cloud:confluence:${siteId}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:confluence:${siteId}:${resourceType}/${resourceId}`;
};
module.exports["getConfluenceContentAri"] = $17a724fe65d90332$export$6a2f2c83863e9bfe;

});

parcelRegister("1ggpj", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $lx6jn = parcelRequire("lx6jn");

var $2aa2bdb281c6889a$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["WHITEBOARD"] = "whiteboard";
    ContentType["PAGE"] = "page";
    ContentType["BLOGPOST"] = "blogpost";
    ContentType["DATABASE"] = "database";
    ContentType["SLIDE"] = "slide";
    ContentType["EMBED"] = "embed";
    ContentType["FOLDER"] = "folder";
    return ContentType;
}({});
const $2aa2bdb281c6889a$export$31930b8b7828306b = [
    (0, $1NBp8.DATABASE_VIEW).name,
    (0, $1NBp8.VIEW_PAGE).name,
    (0, $1NBp8.WHITEBOARD_BOARD).name,
    (0, $1NBp8.SLIDES_VIEW).name,
    (0, $1NBp8.EMBED_VIEW).name
];
const $2aa2bdb281c6889a$export$e8b4d9d0d681efa4 = [
    (0, $1NBp8.DATABASE_VIEW).name,
    (0, $1NBp8.VIEW_PAGE).name,
    (0, $1NBp8.WHITEBOARD_BOARD).name,
    (0, $1NBp8.SLIDES_VIEW).name,
    (0, $1NBp8.EMBED_VIEW).name,
    (0, $1NBp8.EDIT_PAGE).name,
    (0, $1NBp8.EDIT_PAGE_V2).name
];
const $2aa2bdb281c6889a$export$142530096b49b828 = [
    "whiteboard",
    "database",
    "slide",
    "embed",
    "page",
    "folder",
    "blogpost"
];
const $2aa2bdb281c6889a$export$de22146d402d9bdd = {
    ["whiteboard"]: (0, $lx6jn.FeedbackSource).WHITEBOARD,
    ["embed"]: (0, $lx6jn.FeedbackSource).EMBED,
    ["database"]: (0, $lx6jn.FeedbackSource).DATABASE,
    ["slide"]: (0, $lx6jn.FeedbackSource).SLIDE
};
const $2aa2bdb281c6889a$export$4aba9c2e2995f563 = [
    "whiteboard",
    "slide"
];
const $2aa2bdb281c6889a$export$ea7ca1acbbc07168 = (contentType)=>!!contentType && $2aa2bdb281c6889a$export$4aba9c2e2995f563.includes(contentType);
const $2aa2bdb281c6889a$export$10c6f1bef31d587c = [
    'database',
    'slide',
    'embed',
    'folder'
];
const $2aa2bdb281c6889a$export$544bad8872c0b7ed = 400;
module.exports["ContentType"] = $2aa2bdb281c6889a$export$e2e108cbe2e4f865;
module.exports["ARCHIVE_SUCCESS_REDIRECT_ROUTES"] = $2aa2bdb281c6889a$export$31930b8b7828306b;
module.exports["DELETE_SUCCESS_REDIRECT_ROUTES"] = $2aa2bdb281c6889a$export$e8b4d9d0d681efa4;
module.exports["VALID_OPERATION_TARGETS"] = $2aa2bdb281c6889a$export$142530096b49b828;
module.exports["CONTENT_TYPE_FEEDBACK_SOURCE"] = $2aa2bdb281c6889a$export$de22146d402d9bdd;
module.exports["isCanvasContentType"] = $2aa2bdb281c6889a$export$ea7ca1acbbc07168;
module.exports["TYPES_WITH_ACTIVATIONID"] = $2aa2bdb281c6889a$export$10c6f1bef31d587c;
module.exports["onChangeTitleDebounceTime"] = $2aa2bdb281c6889a$export$544bad8872c0b7ed;

});

parcelRegister("lx6jn", function(module, exports) {
var $4d57d476a3596595$export$1953473fc535c5c1 = /*#__PURE__*/ function(FeedbackSource) {
    FeedbackSource["EDITOR"] = "Editor";
    FeedbackSource["HELP_PANEL"] = "Help Panel";
    FeedbackSource["THEME_SELECTOR"] = "Theme Selector";
    FeedbackSource["WHITEBOARD"] = "Whiteboard";
    FeedbackSource["EMBED"] = "Embed";
    FeedbackSource["DATABASE"] = "Database";
    FeedbackSource["NAV_4"] = "Nav4";
    FeedbackSource["SHARE_DIALOG"] = "Share Dialog";
    FeedbackSource["CONTENT_WRAPPER"] = "Content Wrapper";
    FeedbackSource["LIVE_DOCS"] = "Live Docs";
    FeedbackSource["EDITOR_CONTROLS"] = "Editor Controls";
    FeedbackSource["NOTES"] = "Notes";
    FeedbackSource["CREATE_WITH_ROVO"] = "Create with Rovo";
    FeedbackSource["SLIDE"] = "Slide";
    FeedbackSource["TABS"] = "Tabs";
    return FeedbackSource;
}({});
module.exports["FeedbackSource"] = $4d57d476a3596595$export$1953473fc535c5c1;

});

parcelRegister("8pcS0", function(module, exports) {
const $6863c3b6124eda1d$export$2400baf28368a887 = {
    TEMPLATE: 'com.atlassian.confluence.template',
    MACRO_CORE: 'com.atlassian.confluence.macro.core',
    MIGRATION: 'com.atlassian.confluence.migration',
    // used for all macros that use Extension API and require references to be rendered
    MACRO_WITH_REFERENCES: 'com.atlassian.confluence.macro.with.references',
    NATIVE: 'com.atlassian.confluence.native'
};
const $6863c3b6124eda1d$export$8e1715e14eb19dce = {
    INVALID: '__confluenceADFMigrationUnsupportedContentInternalExtension__'
};
const $6863c3b6124eda1d$export$a4903313a3329d59 = {
    UNSUPPORTED_EXTENSION: 'unsupportedExtension',
    INVALID_ADF: 'invalidAdf'
};
const $6863c3b6124eda1d$export$84b772adeaf6b683 = 'extension';
const $6863c3b6124eda1d$export$5da07912b4c30471 = 'inlineExtension';
const $6863c3b6124eda1d$export$2af94dcd5e74e23b = 'bodiedExtension';
const $6863c3b6124eda1d$export$43b3eb119fc177ea = 'multiBodiedExtension';
const $6863c3b6124eda1d$export$6e997645168087e1 = [
    {
        content: [],
        type: 'paragraph'
    }
];
const $6863c3b6124eda1d$export$87be616c9ded92ee = [
    {
        type: 'extensionFrame',
        content: [
            {
                type: 'paragraph',
                content: []
            }
        ]
    }
];
const $6863c3b6124eda1d$export$f9804d409e73a2cd = {
    TEMPLATE: 'variable',
    INLINE_EXTERNAL_IMAGE: 'inline-external-image',
    INLINE_MEDIA_IMAGE: 'inline-media-image',
    PRIVACY_MARK: 'privacy-mark',
    ANCHOR: 'anchor',
    PANEL: 'panel',
    SECTION: 'section',
    CHEESE: 'cheese',
    COLUMN: 'column',
    CONTENT_BY_LABEL: 'contentbylabel',
    CONTENT_BY_USER: 'content-by-user',
    CREATE_SPACE_BUTTON: 'create-space-button',
    FAVORITE_PAGES: 'favpages',
    GLOBAL_REPORTS: 'global-reports',
    IM_PRESENCE: 'im',
    LOREMIPSUM: 'loremipsum',
    NAVIGATION_MAP: 'navmap',
    PAGE_TREE: 'pagetree',
    RECENTLY_UPDATED: 'recently-updated',
    RECENTLY_USED_LABELS: 'recently-used-labels',
    SEARCH: 'search',
    SPACE_DETAILS: 'space-details',
    INVALID: '__confluenceADFMigrationUnsupportedContentInternalExtension__',
    REDACTED_MACRO_PLACEHOLDER: 'redactedMacroPlaceholder',
    TOC: 'toc',
    LIVE_SEARCH: 'livesearch',
    CREATE_FROM_TEMPLATE: 'create-from-template',
    CONFLUENCE_DATABASES: 'database-extension',
    DETAILS: 'details',
    DETAILS_SUMMARY: 'detailssummary',
    EXPAND: 'expand',
    EXCERPT: 'excerpt',
    EXCERPT_INCLUDE: 'excerpt-include',
    CHILDREN: 'children',
    PROFILE_PICTURE: 'profile-picture',
    PROFILE: 'profile',
    BLOG_POSTS: 'blog-posts',
    INCLUDE: 'include',
    JIRA: 'jira',
    JIRACHART: 'jirachart',
    LEGACY_CONTENT: 'legacy-content',
    TEAM_CALENDARS: 'calendar',
    CONTRIBUTORS: 'contributors',
    IFRAME: 'iframe',
    LIST_LABELS: 'listlabels',
    POPULAR_LABELS: 'popular-labels',
    TASKS_REPORT_MACRO: 'tasks-report-macro',
    NATIVE_EMBED: 'native-embed',
    HIDE: 'hide',
    PAGE_TREE_SEARCH: 'pagetreesearch',
    WIDGET: 'widget',
    CONTENT_REPORT_TABLE: 'content-report-table',
    CHANGE_HISTORY: 'change-history',
    VIEWPDF: 'viewpdf',
    ATTACHMENTS: 'attachments',
    AGENT_MANAGED_BLOCK: 'agent-managed-block',
    VIEWXLS: 'viewxls'
};
const $6863c3b6124eda1d$export$52ab8a936196819e = [
    'toc',
    'expand',
    'trello-board',
    'status',
    'jiraroadmap'
];
const $6863c3b6124eda1d$export$ab3b6d629a99a505 = [
    $6863c3b6124eda1d$export$f9804d409e73a2cd.TOC,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.ANCHOR,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.LIVE_SEARCH,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS_SUMMARY,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXPAND,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT_INCLUDE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CREATE_FROM_TEMPLATE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.REDACTED_MACRO_PLACEHOLDER,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONFLUENCE_DATABASES,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PROFILE_PICTURE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PROFILE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.ATTACHMENTS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.BLOG_POSTS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.RECENTLY_UPDATED,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.TEAM_CALENDARS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONTRIBUTORS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.IFRAME,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.POPULAR_LABELS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.LIST_LABELS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONTENT_BY_LABEL,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PAGE_TREE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PAGE_TREE_SEARCH,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.INCLUDE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.WIDGET,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONTENT_REPORT_TABLE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CHANGE_HISTORY,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.VIEWPDF,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.TASKS_REPORT_MACRO,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.VIEWXLS
];
const $6863c3b6124eda1d$export$77fa9372f916e938 = new Set([
    $6863c3b6124eda1d$export$84b772adeaf6b683,
    $6863c3b6124eda1d$export$5da07912b4c30471,
    $6863c3b6124eda1d$export$2af94dcd5e74e23b
]);
const $6863c3b6124eda1d$export$12c3fa6b8a339bbd = 255;
const $6863c3b6124eda1d$export$3b4caad8695d985a = [
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CHILDREN,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT_INCLUDE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONTENT_BY_LABEL,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.RECENTLY_UPDATED
];
const $6863c3b6124eda1d$export$b700e56f703b191 = [
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CHILDREN,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PAGE_TREE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.INCLUDE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS_SUMMARY
];
module.exports["EXTENSION_TYPE"] = $6863c3b6124eda1d$export$2400baf28368a887;
module.exports["MIGRATION_EXTENSION_KEYS"] = $6863c3b6124eda1d$export$8e1715e14eb19dce;
module.exports["REGULAR_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$84b772adeaf6b683;
module.exports["INLINE_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$5da07912b4c30471;
module.exports["BODIED_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$2af94dcd5e74e23b;
module.exports["MULTI_BODIED_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$43b3eb119fc177ea;
module.exports["EMPTY_ADF_CONTENT"] = $6863c3b6124eda1d$export$6e997645168087e1;
module.exports["MULTI_BODIED_INITIAL_CONTENT"] = $6863c3b6124eda1d$export$87be616c9ded92ee;
module.exports["EXTENSION_KEY"] = $6863c3b6124eda1d$export$f9804d409e73a2cd;
module.exports["allowedMacrosForInsertMenu"] = $6863c3b6124eda1d$export$52ab8a936196819e;
module.exports["serverRenderedExtensions"] = $6863c3b6124eda1d$export$ab3b6d629a99a505;
module.exports["supportedExtensions"] = $6863c3b6124eda1d$export$77fa9372f916e938;
module.exports["MAX_ATLASSIAN_ALLOWED_FRAGMENT_LENGTH"] = $6863c3b6124eda1d$export$12c3fa6b8a339bbd;
module.exports["MODERENIZED_MACRO_KEYS"] = $6863c3b6124eda1d$export$3b4caad8695d985a;
module.exports["MACROS_WITH_LIVE_DOC_REFERENCE"] = $6863c3b6124eda1d$export$b700e56f703b191;

});

parcelRegister("GLgaM", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $6kV7w = parcelRequire("6kV7w");


var $3FAG5 = parcelRequire("3FAG5");

async function $2229ddfbe95e9ad1$export$4b00e7449e7c9147(fetchOptions, variables) {
    const { url: url, method: method, body: body, headers: headers, credentials: credentials, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError } = fetchOptions;
    try {
        const resolvedMethod = typeof method === 'function' ? method(variables) : method;
        const defaultBody = resolvedMethod === 'GET' ? undefined : JSON.stringify(variables);
        // Tesseract instruments the outgoing http requests automatically, no need to pass tracing headers when running in SSR.
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        const tracingHeaders = (0, $6kV7w.getActiveTraceHttpRequestHeaders)('' /* url, not used */ );
        const enhancedHeaders = {
            ...headers,
            ...tracingHeaders
        };
        const response = await (0, $f7B1p.cfetch)(typeof url === 'function' ? url(variables) : url, {
            method: resolvedMethod,
            body: typeof body === 'function' ? body(variables) : body || defaultBody,
            headers: enhancedHeaders,
            credentials: credentials
        });
        if (parseResponseOnSuccess) return parseResponseOnSuccess(response);
        return await $2229ddfbe95e9ad1$var$parseResponse(response);
    } catch (error) {
        if (parseResponseOnError) return parseResponseOnError(error, variables);
        throw error;
    }
}
async function $2229ddfbe95e9ad1$var$parseResponse(response) {
    if (response.status === 204) return {};
    // In case a service happens to return a 200 instead of 204 with no content
    if (response.headers?.get('content-length') === '0') return {};
    try {
        return await response.json();
    } catch (error) {
        throw (0, $3FAG5.throwErrorWithResponse)(error, response);
    }
}
module.exports["fetchResponse"] = $2229ddfbe95e9ad1$export$4b00e7449e7c9147;

});

parcelRegister("3FAG5", function(module, exports) {
// copied from next/packages/graphql/src/resolvers/throwErrorWithResponse.ts b/c of circ dep
function $6c7ad22961ce35d0$export$8a24908f7aac7ac7(error, response) {
    // Don't swallow the Response object, attach it to the error so the rest of
    // the app has a chance to see it e.g. OnErrorLink:
    if (typeof error === 'object' && error) {
        // At times our various resolver implementations interpret the JSON body of
        // non-OK responses as errors. And sometimes these errors contain a response
        // property (which may be an empty object) that leads to the loss of
        // Response information such as trace ID.
        if ('response' in error) {
            const existingErrorResponse = error.response;
            // Try to attach at least the trace ID to the existing error response:
            if (typeof existingErrorResponse === 'object' && existingErrorResponse) {
                // OnError's getResponseFromError needs the status property:
                if (!('status' in existingErrorResponse)) existingErrorResponse.status = response.status;
                // getTraceIdFromResponse needs the headers property:
                if (!('headers' in existingErrorResponse)) existingErrorResponse.headers = response.headers;
            }
        } else error.response = response;
    }
    throw error;
}
module.exports["throwErrorWithResponse"] = $6c7ad22961ce35d0$export$8a24908f7aac7ac7;

});

parcelRegister("7ji4X", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $67e5a1fc9f6e62d4$export$c6060eb21313da7c = {
    data: undefined,
    loading: false,
    error: undefined,
    called: false
};
const $67e5a1fc9f6e62d4$export$baa1629d06692c30 = {
    data: undefined,
    loading: true,
    error: undefined,
    called: true
};
const $67e5a1fc9f6e62d4$var$Store = (0, $8s9DV.createStore)({
    initialState: {},
    actions: {
        setQueryState: (key, state)=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                const prevState = currentState[key] || $67e5a1fc9f6e62d4$export$c6060eb21313da7c;
                const newState = typeof state === 'function' ? state(prevState) : state;
                setState({
                    ...currentState,
                    [key]: newState
                });
            }
    },
    name: 'useExperimentalQueryState'
});
const $67e5a1fc9f6e62d4$export$3904d1f229fe9b3a = (0, $kBr4q.createActionsHook)($67e5a1fc9f6e62d4$var$Store);
const $67e5a1fc9f6e62d4$export$39156bd8f00c1e38 = (0, $kBr4q.createStateHook)($67e5a1fc9f6e62d4$var$Store, {
    selector: (state, params)=>state[params.key]
});
const $67e5a1fc9f6e62d4$export$14d57088f5885a49 = $67e5a1fc9f6e62d4$var$Store;
module.exports["INITIAL_IDLE_STATE"] = $67e5a1fc9f6e62d4$export$c6060eb21313da7c;
module.exports["INITIAL_LOADING_STATE"] = $67e5a1fc9f6e62d4$export$baa1629d06692c30;
module.exports["useExperimentalQueryStateActions"] = $67e5a1fc9f6e62d4$export$3904d1f229fe9b3a;
module.exports["useExperimentalQueryState"] = $67e5a1fc9f6e62d4$export$39156bd8f00c1e38;
module.exports["queryStateStore"] = $67e5a1fc9f6e62d4$export$14d57088f5885a49;

});

parcelRegister("6l6jb", function(module, exports) {
function $459f9fedb053e25e$export$a4f9b7f788f9e71f(params) {
    const { url: url, method: method = 'GET', headers: headers, body: body, credentials: credentials, variables: variables } = params;
    return $459f9fedb053e25e$var$canonicalStringify({
        url: typeof url === 'function' ? url.toString() : url,
        method: typeof method === 'function' ? method.toString() : method,
        headers: headers,
        body: typeof body === 'function' ? body.toString() : body,
        credentials: credentials,
        variables: variables
    });
}
function $459f9fedb053e25e$export$ebaa599ca92b9c11(requestConfigs, variables) {
    const keys = requestConfigs.map((config)=>$459f9fedb053e25e$export$a4f9b7f788f9e71f({
            ...config,
            variables: variables
        })).sort();
    return $459f9fedb053e25e$var$canonicalStringify(keys);
}
// Serializes with sorted object keys for deterministic output
function $459f9fedb053e25e$var$canonicalStringify(value) {
    return JSON.stringify(value, $459f9fedb053e25e$var$canonicalStringifyReplacer);
}
function $459f9fedb053e25e$var$canonicalStringifyReplacer(_key, value) {
    // Ensures we only process plain objects (not arrays, dates, etc.)
    if (value && typeof value === 'object') {
        const proto = Object.getPrototypeOf(value);
        if (proto === Object.prototype || proto === null) {
            const keys = Object.keys(value);
            // If keys are already sorted, return the original value unchanged to avoid unnecessary object creation
            if (keys.every($459f9fedb053e25e$var$everyKeyInOrder)) return value;
            keys.sort();
            const sortedObject = Object.create(proto);
            keys.forEach((key)=>{
                sortedObject[key] = value[key];
            });
            return sortedObject;
        }
    }
    return value;
}
function $459f9fedb053e25e$var$everyKeyInOrder(key, i, keys) {
    return i === 0 || keys[i - 1] <= key;
}
module.exports["generateCacheKey"] = $459f9fedb053e25e$export$a4f9b7f788f9e71f;
module.exports["generateCacheKeyForMultipleFetches"] = $459f9fedb053e25e$export$ebaa599ca92b9c11;

});

parcelRegister("bjeS8", function(module, exports) {

var $krgsn = parcelRequire("krgsn");


var $422HI = parcelRequire("422HI");

const $79bfccd7ee2a0d89$export$657ce0d4a1b8cb1a = (error)=>{
    const message = error.message || 'Unknown error';
    const status = 'response' in error ? error.response?.status : undefined;
    return new (0, $422HI.ApolloErrorInterop)({
        graphQLErrors: [
            $79bfccd7ee2a0d89$var$createGraphQLError({
                message: message,
                status: status,
                originalError: error
            })
        ]
    });
};
const $79bfccd7ee2a0d89$var$createGraphQLError = ({ message: message, status: status, originalError: originalError })=>{
    const extensions = status ? {
        statusCode: status,
        http: {
            status: status
        }
    } : undefined;
    return new (0, $krgsn.GraphQLError)(message, null, // nodes - no GraphQL query AST
    null, // source - no GraphQL query text
    null, // positions - no GraphQL query positions
    null, // path - not executing GraphQL schema fields
    originalError, extensions);
};
module.exports["convertToApolloError"] = $79bfccd7ee2a0d89$export$657ce0d4a1b8cb1a;

});

parcelRegister("aBfpe", function(module, exports) {
/**
 * https://www.iana.org/assignments/media-types/media-types.xhtml
 */ var $c27c52d002752847$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["JSON"] = "application/json";
    MediaType["X_WWW_FORM_URLENCODED"] = "application/x-www-form-urlencoded";
    return MediaType;
}({});
module.exports["MediaType"] = $c27c52d002752847$export$483c11740a902fcd;

});

parcelRegister("bS81H", function(module, exports) {
/**
 * @generated SignedSource<<ecee5cb68219750c899a663dd271634b>>
 * @relayHash 611f36fd3ab140915814f503f8503110
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 97be9875eda07a3755479859d908d73b01a8526a1d7d39ebe7c437e3317987f8
const $5a2ebb253ede159a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "action"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentStatus"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentVersion"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "concreteType": "Confluence_dataSecurityPolicy",
            "kind": "LinkedField",
            "name": "dataSecurityPolicy",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "action",
                            "variableName": "action"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentStatus",
                            "variableName": "contentStatus"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentVersion",
                            "variableName": "contentVersion"
                        },
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "spaceKey"
                        }
                    ],
                    "concreteType": "DataSecurityPolicyDecision",
                    "kind": "LinkedField",
                    "name": "isActionEnabledForContent",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "action"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "allowed"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "graphqlHelpersDSPIsActionEnabledForContentQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "graphqlHelpersDSPIsActionEnabledForContentQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "611f36fd3ab140915814f503f8503110",
            "id": "97be9875eda07a3755479859d908d73b01a8526a1d7d39ebe7c437e3317987f8",
            "metadata": {},
            "name": "graphqlHelpersDSPIsActionEnabledForContentQuery",
            "operationKind": "query",
            "text": "query graphqlHelpersDSPIsActionEnabledForContentQuery($action:DataSecurityPolicyAction!,$contentId:ID!,$contentStatus:DataSecurityPolicyDecidableContentStatus!,$contentVersion:Int!,$spaceKey:String){dataSecurityPolicy{isActionEnabledForContent(action:$action,contentId:$contentId,contentStatus:$contentStatus,contentVersion:$contentVersion,spaceKey:$spaceKey){action,allowed}}}"
        }
    };
}();
$5a2ebb253ede159a$var$node.hash = "c488c053b9896d7e6d5b6c4474dd396b";
var $5a2ebb253ede159a$export$2e2bcd8739ae039 = $5a2ebb253ede159a$var$node;
module.exports["default"] = $5a2ebb253ede159a$export$2e2bcd8739ae039;

});

parcelRegister("axutP", function(module, exports) {
/**
 * @generated SignedSource<<1489173bfe4b7806076804a6e2602ed8>>
 * @relayHash fa5b50f9c89692d4dd86caf1df42c2d1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 60833378a8743a6756bd6e1c0fa498d563c23b5e85cbe46b5ee3f3b782265d4a
const $972689412971ec2f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "ConfluenceTeamPresence",
            "kind": "LinkedField",
            "name": "confluence_teamPresenceContentSetting",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEnabledOnContentView"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentHeaderPresenceContentSettingsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentHeaderPresenceContentSettingsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "fa5b50f9c89692d4dd86caf1df42c2d1",
            "id": "60833378a8743a6756bd6e1c0fa498d563c23b5e85cbe46b5ee3f3b782265d4a",
            "metadata": {},
            "name": "ContentHeaderPresenceContentSettingsQuery",
            "operationKind": "query",
            "text": "query ContentHeaderPresenceContentSettingsQuery($cloudId:ID!,$spaceKey:String!){confluence_teamPresenceContentSetting(cloudId:$cloudId,spaceKey:$spaceKey){isEnabledOnContentView}}"
        }
    };
}();
$972689412971ec2f$var$node.hash = "2d4682166f4edbdf50428f0d98c0918c";
var $972689412971ec2f$export$2e2bcd8739ae039 = $972689412971ec2f$var$node;
module.exports["default"] = $972689412971ec2f$export$2e2bcd8739ae039;

});

parcelRegister("6jrkJ", function(module, exports) {

var $68uaC = parcelRequire("68uaC");

const $00ee7f2affe27fcd$var$SUPER_ADMIN_COOKIE = 'confluence.asSuperAdmin';
function $00ee7f2affe27fcd$export$2fc1623749affa1a() {
    return Boolean((0, $68uaC.Cookies).get($00ee7f2affe27fcd$var$SUPER_ADMIN_COOKIE));
}
function $00ee7f2affe27fcd$export$b097cdee5288154b() {
    (0, $68uaC.Cookies).removeStrictlyNecessary($00ee7f2affe27fcd$var$SUPER_ADMIN_COOKIE);
}
async function $00ee7f2affe27fcd$export$f5d5d0f409509831() {
    await (0, $68uaC.Cookies).set($00ee7f2affe27fcd$var$SUPER_ADMIN_COOKIE, 'true', undefined, (0, $68uaC.CookieLevel).NECESSARY);
}
module.exports["getSuperAdminClaim"] = $00ee7f2affe27fcd$export$2fc1623749affa1a;
module.exports["removeSuperAdminClaim"] = $00ee7f2affe27fcd$export$b097cdee5288154b;
module.exports["setSuperAdminClaim"] = $00ee7f2affe27fcd$export$f5d5d0f409509831;

});

parcelRegister("hiC7Y", function(module, exports) {
/**
 * @generated SignedSource<<994231445f227a67e1aaccbbe4790b5b>>
 * @relayHash 0f84e07ae7daaa03ff834c7e22000d77
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 54df31e8c4d8a985ea8cf57de4e9987537d70dbc168cfc0cfa0a076f20f53d78
const $55ca182de67fa1f0$var$node = function() {
    var v0 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GraphQLConfluenceUserRoles",
                            "kind": "LinkedField",
                            "name": "roles",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isSuperAdmin"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "IsSuperAdminQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "IsSuperAdminQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "0f84e07ae7daaa03ff834c7e22000d77",
            "id": "54df31e8c4d8a985ea8cf57de4e9987537d70dbc168cfc0cfa0a076f20f53d78",
            "metadata": {},
            "name": "IsSuperAdminQuery",
            "operationKind": "query",
            "text": "query IsSuperAdminQuery{user:confluence_atlassianUser(current:true){id,confluence{roles{isSuperAdmin}}}}"
        }
    };
}();
$55ca182de67fa1f0$var$node.hash = "9aa53dcf116596c8f8285a3aa93878ce";
var $55ca182de67fa1f0$export$2e2bcd8739ae039 = $55ca182de67fa1f0$var$node;
module.exports["default"] = $55ca182de67fa1f0$export$2e2bcd8739ae039;

});

parcelRegister("5cryL", function(module, exports) {
const $d59a11eb5a1dc2b2$export$a5c9a23fa8bd992b = {
    EDITOR_ONBOARDING_ELIGIBLE_NEW: 'editor-state:editorOnboardingEligiblity',
    EDITOR_VISITED: 'editor-state:editorVisited',
    WAS_DRAFT_BANNER_SEEN: 'editor-state:wasDraftBannerSeen',
    IS_DRAFT_BANNER_VISIBLE: 'editor-state:isDraftBannerVisible',
    IS_LAND_IN_EDITOR_BANNER_VISIBLE: 'editor-state:isLandInEditorBannerVisible',
    HAS_USER_PUBLISHED: 'editor-state:hasUserPublished',
    SUCCESS_FLAG_SEEN: 'editor-state:successFlagCompleted',
    RECENT_SPOTLIGHT_OPEN: 'editor-state:recentSpotlightOpen',
    RECENT_SPOTLIGHT_SEEN: 'editor-state:recentSpotlightCompleted',
    EDITOR_TUTORIAL_SUCCESS_FLAG_SEEN: 'editor-state:editorTutorialSuccessFlagCompleted',
    WAS_EDITOR_CONVERSION_DIALOG_SEEN: 'editor-state:wasEditorConversionModalSeen',
    WAS_EDITOR_CONVERSION_DIALOG_V3_SEEN: 'editor-state:wasEditorConversionModalV3Seen'
};
const $d59a11eb5a1dc2b2$export$1a907d3885d0a16c = 'com.atlassian.confluence.plugins.confluence-onboarding:using-the-editor-template-blueprint';
const $d59a11eb5a1dc2b2$export$3cae7707c5db4087 = 'com.atlassian.confluence.plugins.confluence-onboarding:using-the-editor-template-v2-blueprint';
const $d59a11eb5a1dc2b2$export$fa405f661a23ebc5 = 'editor-onboarding';
const $d59a11eb5a1dc2b2$export$caf77613d415fe3 = [
    ...Object.values($d59a11eb5a1dc2b2$export$a5c9a23fa8bd992b),
    $d59a11eb5a1dc2b2$export$1a907d3885d0a16c,
    $d59a11eb5a1dc2b2$export$3cae7707c5db4087
];
module.exports["EDITOR_ONBOARDING_STATE_KEYS"] = $d59a11eb5a1dc2b2$export$a5c9a23fa8bd992b;
module.exports["EDITOR_ONBOARDING_BLUEPRINT_KEY"] = $d59a11eb5a1dc2b2$export$1a907d3885d0a16c;
module.exports["EDITOR_ONBOARDING_BLUEPRINT_KEY_LIVE_DOCS_ENABLED"] = $d59a11eb5a1dc2b2$export$3cae7707c5db4087;
module.exports["ONBOARDING_TUTORIAL_LABEL"] = $d59a11eb5a1dc2b2$export$fa405f661a23ebc5;
module.exports["EditorOnboardingKeys"] = $d59a11eb5a1dc2b2$export$caf77613d415fe3;

});

parcelRegister("eoU1C", function(module, exports) {
const $b3332cb66ea1a913$export$7f1c6b461c54348b = {
    DIALOG_SPOTLIGHT_SEEN: 'random:ShareAndRestrictDialog:spotlightSeen',
    PUBLIC_LINK_FOOTER_BUTTON_SEEN: 'ShareAndRestrictDialog:editPublicLinkFooterSpotLightSeen',
    EDIT_PUBLIC_LINK_PERMISSION_SEEN: 'ShareAndRestrictDialog:editPublicLinkPermissionSpotLightSeen',
    GENERAL_AND_SPECIFIC_ACCESS_SEEN: 'ShareAndRestrictDialog:generalAndSpecificAccessSpotLightSeen',
    CTA_NOTIFY_MESSAGE_FOOTER_SEEN: 'ShareAndRestrictDialog:ctaNotifyMessageFooterSpotLightSeen'
};
const $b3332cb66ea1a913$export$e5c211f9c9c7792f = Object.values($b3332cb66ea1a913$export$7f1c6b461c54348b);
module.exports["ONBOARDING_SHARE_AND_RESTRICT_DIALOG"] = $b3332cb66ea1a913$export$7f1c6b461c54348b;
module.exports["ShareAndRestrictDialogOnboardingKeys"] = $b3332cb66ea1a913$export$e5c211f9c9c7792f;

});

parcelRegister("fsF73", function(module, exports) {
const $29520d740d888926$export$84bb2ff8e52d4c63 = {
    HAS_SEEN_PUBLISH_SPOTLIGHT: 'confluence-recap:hasSeenPublishSpotlight'
};
const $29520d740d888926$export$42e96b8eba35eec9 = Object.values($29520d740d888926$export$84bb2ff8e52d4c63);
module.exports["CONFLUENCE_RECAP_ONBOARDING_STATE_KEYS"] = $29520d740d888926$export$84bb2ff8e52d4c63;
module.exports["ConfluenceRecapOnboardingKeys"] = $29520d740d888926$export$42e96b8eba35eec9;

});

parcelRegister("aqBZ0", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $1f65bcd6ebccf55c$export$41b2e06f27dfe96e = 'archived';
const $1f65bcd6ebccf55c$export$e2153f1ee0381860 = 'ARCHIVE_';
const $1f65bcd6ebccf55c$export$c8e98879124fb1f0 = 'UNARCHIVE_';
const $1f65bcd6ebccf55c$export$781b73bccf46ba2c = 255;
const $1f65bcd6ebccf55c$export$ab874a69c0b17d25 = 500;
var $1f65bcd6ebccf55c$export$ca079fdb822b790f = /*#__PURE__*/ function(ArchiveStatus) {
    ArchiveStatus["LOADING"] = "loading";
    ArchiveStatus["ERROR"] = "error";
    ArchiveStatus["SUCCESS"] = "success";
    return ArchiveStatus;
}({});
const $1f65bcd6ebccf55c$export$90622b83e51be397 = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/';
const $1f65bcd6ebccf55c$export$a2742df05b19b873 = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/#When-content-is-inheriting-restrictions-from-parent-content';
const $1f65bcd6ebccf55c$export$9de02bef22980fc = 'https://support.atlassian.com/confluence-cloud/docs/archive-pages/#Who-can-archive-an-item';
const $1f65bcd6ebccf55c$export$45c8fb669461b6d5 = 'https://support.atlassian.com/confluence-cloud/docs/restore-archived-pages-to-the-page-tree/#Who-can-restore-an-item';
const $1f65bcd6ebccf55c$export$f71e45bebd610efa = 'archivedPageBanner';
const $1f65bcd6ebccf55c$export$7d669dd29a0917b2 = 'archive-page-banner-restore-link';
const $1f65bcd6ebccf55c$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    restoreLinkMessage: {
        id: "archive-pages.page-banner.link.unarchive",
        defaultMessage: "Restore"
    },
    learnMoreLinkMessage: {
        id: "archive-pages.page-banner.link.learn-more",
        defaultMessage: "Learn more"
    },
    hasRestoreContentPermissionBannerMessage: {
        id: "archive-pages.content-banner.message-restorable",
        defaultMessage: "This content is archived. Restore to make changes."
    },
    noRestoreContentPermissionBannerMessage: {
        id: "archive-pages.content-banner.message-unrestorable",
        defaultMessage: "This content is archived."
    }
});
module.exports["CONTENT_STATUS_ARCHIVED"] = $1f65bcd6ebccf55c$export$41b2e06f27dfe96e;
module.exports["ARCHIVE_INTL_PREFIX"] = $1f65bcd6ebccf55c$export$e2153f1ee0381860;
module.exports["UNARCHIVE_INTL_PREFIX"] = $1f65bcd6ebccf55c$export$c8e98879124fb1f0;
module.exports["ARCHIVE_PAGES_WITH_NOTE_CHARACTER_LIMIT"] = $1f65bcd6ebccf55c$export$781b73bccf46ba2c;
module.exports["BULK_ARCHIVE_PAGE_SELECTION_LIMIT"] = $1f65bcd6ebccf55c$export$ab874a69c0b17d25;
module.exports["ArchiveStatus"] = $1f65bcd6ebccf55c$export$ca079fdb822b790f;
module.exports["PAGE_INHERITED_RESTRICTIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$a2742df05b19b873;
module.exports["ARCHIVE_PERMISSIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$9de02bef22980fc;
module.exports["UNARCHIVE_PERMISSIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$45c8fb669461b6d5;
module.exports["ARCHIVED_PAGE_BANNER_ANALYTICS_SOURCE"] = $1f65bcd6ebccf55c$export$f71e45bebd610efa;
module.exports["ARCHIVED_PAGE_BANNER_RESTORE_LINK_TESTID"] = $1f65bcd6ebccf55c$export$7d669dd29a0917b2;
module.exports["i18n"] = $1f65bcd6ebccf55c$export$a7357cdd1f0b0168;

});

parcelRegister("lKLmX", function(module, exports) {
/**
 * @generated SignedSource<<0fb7b778e884fde647da24980606dd2b>>
 * @relayHash 0e97369e1bfa5659fc7cb13e5e23293d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ef04a28901a87d914dea7ee1db36f3d9adc5f2ceeff420236ef0357e7a9388a9
const $c7a72aad1b5e4549$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeApprovalExpirationConfig"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeApprovalsBetaFeatures"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "otherContentStatus"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "transitionType"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "kind": "ScalarField",
        "name": "name"
    }, v10 = {
        "args": [
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "spaceKey"
            }
        ],
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v8 /*: any*/ ,
            {
                "concreteType": "SpaceTypeSettings",
                "kind": "LinkedField",
                "name": "spaceTypeSettings",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "EnabledFeatures",
                        "kind": "LinkedField",
                        "name": "enabledFeatures",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isContentApprovalsEnabled"
                            }
                        ]
                    }
                ]
            },
            {
                "condition": "includeApprovalExpirationConfig",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "SpaceSettings",
                        "kind": "LinkedField",
                        "name": "settings",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "ContentStateSettings",
                                "kind": "LinkedField",
                                "name": "contentStateSettings",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "ContentState",
                                        "kind": "LinkedField",
                                        "name": "spaceContentStates",
                                        "plural": true,
                                        "selections": [
                                            v8 /*: any*/ ,
                                            v9 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v11 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v12 = {
        "kind": "ScalarField",
        "name": "success"
    }, v13 = {
        "kind": "ScalarField",
        "name": "message"
    }, v14 = {
        "kind": "ScalarField",
        "name": "isEnabled"
    }, v15 = {
        "kind": "ScalarField",
        "name": "value"
    }, v16 = {
        "kind": "ScalarField",
        "name": "principalType"
    }, v17 = {
        "kind": "ScalarField",
        "name": "principalId"
    }, v18 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v19 = {
        "kind": "ScalarField",
        "name": "isActive"
    }, v20 = {
        "kind": "ScalarField",
        "name": "isPrimary"
    }, v21 = [
        v8 /*: any*/ ,
        v18 /*: any*/ ,
        v19 /*: any*/ ,
        {
            "concreteType": "AtlassianUserPhoto",
            "kind": "LinkedField",
            "name": "photos",
            "plural": true,
            "selections": [
                v15 /*: any*/ ,
                v20 /*: any*/ 
            ]
        }
    ], v22 = {
        "condition": "includeApprovalsBetaFeatures",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    v11 /*: any*/ 
                ],
                "concreteType": "ConfluenceContentApprovalsSiteSettings",
                "kind": "LinkedField",
                "name": "confluence_contentApprovalsSiteSettings",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "enabled"
                    }
                ]
            },
            {
                "args": [
                    v11 /*: any*/ ,
                    {
                        "kind": "Literal",
                        "name": "filterSelf",
                        "value": false
                    },
                    {
                        "kind": "Variable",
                        "name": "spaceKey",
                        "variableName": "spaceKey"
                    }
                ],
                "concreteType": "ConfluenceContentApprovalsSpaceSettingConfigPayload",
                "kind": "LinkedField",
                "name": "confluence_contentApprovalsSpaceSettingConfig",
                "plural": false,
                "selections": [
                    v12 /*: any*/ ,
                    {
                        "concreteType": "MutationError",
                        "kind": "LinkedField",
                        "name": "errors",
                        "plural": true,
                        "selections": [
                            v13 /*: any*/ 
                        ]
                    },
                    {
                        "concreteType": "ConfluenceContentApprovalsSpaceSettingConfig",
                        "kind": "LinkedField",
                        "name": "config",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "disallowFirstPublish"
                            },
                            {
                                "condition": "includeApprovalExpirationConfig",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "concreteType": "ConfluenceApprovalExpirationConfig",
                                        "kind": "LinkedField",
                                        "name": "approvalExpirationConfig",
                                        "plural": false,
                                        "selections": [
                                            v14 /*: any*/ ,
                                            {
                                                "concreteType": "ConfluenceApprovalExpirationInterval",
                                                "kind": "LinkedField",
                                                "name": "interval",
                                                "plural": false,
                                                "selections": [
                                                    v15 /*: any*/ ,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "unit"
                                                    }
                                                ]
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "restartApproval"
                                            },
                                            {
                                                "concreteType": "ConfluenceApprovalExpirationChangeStatus",
                                                "kind": "LinkedField",
                                                "name": "changeStatus",
                                                "plural": false,
                                                "selections": [
                                                    v14 /*: any*/ ,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "expireToContentStateId"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "concreteType": "ConfluenceApprovalReviewerConfig",
                                "kind": "LinkedField",
                                "name": "enforcedApprovalReviewerConfig",
                                "plural": false,
                                "selections": [
                                    v14 /*: any*/ ,
                                    {
                                        "concreteType": "ConfluenceSpaceApprovalReviewerEntry",
                                        "kind": "LinkedField",
                                        "name": "reviewers",
                                        "plural": true,
                                        "selections": [
                                            v16 /*: any*/ ,
                                            v17 /*: any*/ ,
                                            {
                                                "concreteType": "AtlassianUser",
                                                "kind": "LinkedField",
                                                "name": "user",
                                                "plural": false,
                                                "selections": v21 /*: any*/ 
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v23 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v24 = {
        "kind": "ScalarField",
        "name": "status"
    }, v25 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "number"
            }
        ]
    }, v26 = {
        "args": [
            v11 /*: any*/ ,
            {
                "kind": "Variable",
                "name": "transitionType",
                "variableName": "transitionType"
            }
        ],
        "concreteType": "ConfluenceApprovalsWorkflowStatus",
        "kind": "LinkedField",
        "name": "confluence_contentApprovalStatuses",
        "plural": true,
        "selections": [
            v8 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "allowsReviews"
            },
            {
                "concreteType": "ConfluenceApprovalsWorkflowStatusDisplayProperties",
                "kind": "LinkedField",
                "name": "displayProperties",
                "plural": false,
                "selections": [
                    v9 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "color"
                    }
                ]
            }
        ]
    }, v27 = {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
    }, v28 = {
        "kind": "Literal",
        "name": "fetchWorkflowReview",
        "value": true
    }, v29 = {
        "kind": "Literal",
        "name": "workflowId",
        "value": "1"
    }, v30 = [
        v11 /*: any*/ ,
        v27 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "otherContentStatus"
        },
        v28 /*: any*/ ,
        v29 /*: any*/ 
    ], v31 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v32 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v33 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            v13 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                    v31 /*: any*/ ,
                    v32 /*: any*/ 
                ]
            }
        ]
    }, v34 = {
        "kind": "ScalarField",
        "name": "reviewStatus"
    }, v35 = {
        "concreteType": "ConfluenceWorkflowReviewWithDecisions",
        "kind": "LinkedField",
        "name": "workflowReviewWithDecisions",
        "plural": false,
        "selections": [
            v8 /*: any*/ ,
            v34 /*: any*/ 
        ]
    }, v36 = [
        v11 /*: any*/ ,
        v27 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "contentStatus"
        },
        v28 /*: any*/ ,
        v29 /*: any*/ 
    ], v37 = {
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "creator",
        "plural": false,
        "selections": v21 /*: any*/ 
    }, v38 = [
        v15 /*: any*/ 
    ], v39 = {
        "concreteType": "ConfluenceWorkflowApplicationDetails",
        "kind": "LinkedField",
        "name": "workflowApplication",
        "plural": false,
        "selections": [
            v8 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "workflowId"
            },
            {
                "kind": "ScalarField",
                "name": "contentId"
            },
            {
                "kind": "ScalarField",
                "name": "contentVersion"
            },
            {
                "kind": "ScalarField",
                "name": "contentStatus"
            },
            {
                "kind": "ScalarField",
                "name": "workflowStatusId"
            },
            v19 /*: any*/ ,
            v37 /*: any*/ ,
            {
                "concreteType": "ConfluenceApprovalsDate",
                "kind": "LinkedField",
                "name": "lastModificationDate",
                "plural": false,
                "selections": v38 /*: any*/ 
            },
            {
                "concreteType": "AtlassianUser",
                "kind": "LinkedField",
                "name": "modifier",
                "plural": false,
                "selections": v21 /*: any*/ 
            }
        ]
    }, v40 = {
        "concreteType": "ConfluenceWorkflowReviewWithDecisions",
        "kind": "LinkedField",
        "name": "workflowReviewWithDecisions",
        "plural": false,
        "selections": [
            v8 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "creatorAaid"
            },
            {
                "concreteType": "ConfluenceApprovalsDate",
                "kind": "LinkedField",
                "name": "creationDate",
                "plural": false,
                "selections": v38 /*: any*/ 
            },
            v34 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "reviewComment"
            },
            {
                "condition": "includeApprovalsBetaFeatures",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "ConfluenceApprovalsDate",
                        "kind": "LinkedField",
                        "name": "dueDate",
                        "plural": false,
                        "selections": v38 /*: any*/ 
                    }
                ]
            },
            {
                "concreteType": "ConfluenceApprovalsDate",
                "kind": "LinkedField",
                "name": "reviewLastModified",
                "plural": false,
                "selections": v38 /*: any*/ 
            },
            v37 /*: any*/ ,
            {
                "concreteType": "ConfluenceReviewerDecisionInfo",
                "kind": "LinkedField",
                "name": "reviewerDecisions",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "decisionId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reviewerId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "required"
                    },
                    v16 /*: any*/ ,
                    v17 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "reviewerDecisionStatus"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "comment"
                    },
                    {
                        "concreteType": "ConfluenceApprovalsDate",
                        "kind": "LinkedField",
                        "name": "lastModifiedDate",
                        "plural": false,
                        "selections": v38 /*: any*/ 
                    },
                    {
                        "concreteType": "AtlassianUser",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                            v8 /*: any*/ ,
                            v18 /*: any*/ ,
                            v19 /*: any*/ ,
                            {
                                "concreteType": "AtlassianUserPhoto",
                                "kind": "LinkedField",
                                "name": "photos",
                                "plural": true,
                                "selections": [
                                    v20 /*: any*/ ,
                                    v15 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v41 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            v13 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__typename"
                    },
                    v31 /*: any*/ ,
                    v32 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v8 /*: any*/ 
                        ],
                        "type": "BulkMutationErrorExtension"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ApprovalsContextApprovalsDataQuery",
            "selections": [
                v10 /*: any*/ ,
                v22 /*: any*/ ,
                {
                    "args": v23 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v24 /*: any*/ ,
                                v25 /*: any*/ 
                            ]
                        }
                    ]
                },
                v26 /*: any*/ ,
                {
                    "alias": "confluence_getActiveWorkflowApplicationForOtherStatus",
                    "args": v30 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v33 /*: any*/ ,
                        v35 /*: any*/ 
                    ]
                },
                {
                    "args": v36 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v33 /*: any*/ ,
                        v39 /*: any*/ ,
                        v40 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v5 /*: any*/ ,
                v7 /*: any*/ ,
                v6 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ApprovalsContextApprovalsDataQuery",
            "selections": [
                v10 /*: any*/ ,
                v22 /*: any*/ ,
                {
                    "args": v23 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v24 /*: any*/ ,
                                v25 /*: any*/ ,
                                v8 /*: any*/ 
                            ]
                        }
                    ]
                },
                v26 /*: any*/ ,
                {
                    "alias": "confluence_getActiveWorkflowApplicationForOtherStatus",
                    "args": v30 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v41 /*: any*/ ,
                        v35 /*: any*/ 
                    ]
                },
                {
                    "args": v36 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v41 /*: any*/ ,
                        v39 /*: any*/ ,
                        v40 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "0e97369e1bfa5659fc7cb13e5e23293d",
            "id": "ef04a28901a87d914dea7ee1db36f3d9adc5f2ceeff420236ef0357e7a9388a9",
            "metadata": {},
            "name": "ApprovalsContextApprovalsDataQuery",
            "operationKind": "query",
            "text": "query ApprovalsContextApprovalsDataQuery($cloudId:ID!,$contentId:ID!,$contentStatus:String!,$otherContentStatus:String!,$transitionType:ConfluenceApprovalTransitionType,$spaceKey:String!,$includeApprovalsBetaFeatures:Boolean!,$includeApprovalExpirationConfig:Boolean!){space(key:$spaceKey){id,spaceTypeSettings{enabledFeatures{isContentApprovalsEnabled}},settings@include(if:$includeApprovalExpirationConfig){contentStateSettings{spaceContentStates{id,name}}}},confluence_contentApprovalsSiteSettings(cloudId:$cloudId)@include(if:$includeApprovalsBetaFeatures){enabled}\n  confluence_contentApprovalsSpaceSettingConfig(cloudId:$cloudId,spaceKey:$spaceKey,filterSelf:false)@include(if:$includeApprovalsBetaFeatures){success,errors{message},config{disallowFirstPublish,approvalExpirationConfig@include(if:$includeApprovalExpirationConfig){isEnabled,interval{value,unit},restartApproval,changeStatus{isEnabled,expireToContentStateId}},enforcedApprovalReviewerConfig{isEnabled,reviewers{principalType,principalId,user{id,displayName,isActive,photos{value,isPrimary}}}}}},content(id:$contentId){nodes{status,version{number},id}},confluence_contentApprovalStatuses(cloudId:$cloudId,transitionType:$transitionType){id,allowsReviews,displayProperties{name,color}},confluence_getActiveWorkflowApplicationForOtherStatus:confluence_getActiveWorkflowApplication(cloudId:$cloudId,contentId:$contentId,contentStatus:$otherContentStatus,workflowId:\"1\",fetchWorkflowReview:true){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},workflowReviewWithDecisions{id,reviewStatus}},confluence_getActiveWorkflowApplication(cloudId:$cloudId,contentId:$contentId,contentStatus:$contentStatus,workflowId:\"1\",fetchWorkflowReview:true){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},workflowApplication{id,workflowId,contentId,contentVersion,contentStatus,workflowStatusId,isActive,creator{id,displayName,isActive,photos{value,isPrimary}},lastModificationDate{value},modifier{id,displayName,isActive,photos{value,isPrimary}}},workflowReviewWithDecisions{id,creatorAaid,creationDate{value},reviewStatus,reviewComment,dueDate@include(if:$includeApprovalsBetaFeatures){value},reviewLastModified{value},creator{id,displayName,isActive,photos{value,isPrimary}},reviewerDecisions{decisionId,reviewerId,required,principalType,principalId,reviewerDecisionStatus,comment,lastModifiedDate{value},user{id,displayName,isActive,photos{isPrimary,value}}}}}}"
        }
    };
}();
$c7a72aad1b5e4549$var$node.hash = "a285f0ce20dbf6d66aa1a29a488d317f";
var $c7a72aad1b5e4549$export$2e2bcd8739ae039 = $c7a72aad1b5e4549$var$node;
module.exports["default"] = $c7a72aad1b5e4549$export$2e2bcd8739ae039;

});

parcelRegister("iOp5s", function(module, exports) {

var $7Sm4c = parcelRequire("7Sm4c");

const $e8d397546331cd08$var$APPROVALS_DISABLED_ERROR_MESSAGE = 'Approvals are disabled';
const $e8d397546331cd08$var$isApprovalsDisabledGraphQLError = (error)=>Boolean(error.message?.includes($e8d397546331cd08$var$APPROVALS_DISABLED_ERROR_MESSAGE));
const $e8d397546331cd08$export$b724ffcdc4a2c130 = (error)=>{
    if (!error) return false;
    const graphQLErrors = 'graphQLErrors' in error ? error.graphQLErrors : undefined;
    if (graphQLErrors?.length) return graphQLErrors.every($e8d397546331cd08$var$isApprovalsDisabledGraphQLError);
    return $e8d397546331cd08$var$isApprovalsDisabledGraphQLError(error);
};
const $e8d397546331cd08$var$markGraphQLErrorAndCauseAsHandled = (error)=>{
    (0, $7Sm4c.markErrorAsHandled)(error);
    const originalCause = error.originalError?.cause;
    if (originalCause && $e8d397546331cd08$var$isApprovalsDisabledGraphQLError(originalCause)) (0, $7Sm4c.markErrorAsHandled)(originalCause);
};
const $e8d397546331cd08$export$50302788ce0889ee = (error)=>{
    if (!error || !$e8d397546331cd08$export$b724ffcdc4a2c130(error)) return;
    (0, $7Sm4c.markErrorAsHandled)(error);
    const graphQLErrors = 'graphQLErrors' in error ? error.graphQLErrors : undefined;
    graphQLErrors?.forEach($e8d397546331cd08$var$markGraphQLErrorAndCauseAsHandled);
};
module.exports["markApprovalsDisabledErrorAsHandled"] = $e8d397546331cd08$export$50302788ce0889ee;

});

parcelRegister("yuLaV", function(module, exports) {
// eslint-disable-next-line no-restricted-imports

var $jH9cM = parcelRequire("jH9cM");


var $3ricL = parcelRequire("3ricL");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");

const $705f1ec06aff7fce$export$dd376e644565eb89 = (contentType)=>{
    if (contentType === 'database' || contentType === 'whiteboard' || contentType === 'slide') {
        if ((0, $9wGTI.fg)('use_frontend_feature_encoding_sdk')) {
            const featureKeyMap = {
                database: 'confluence-databases',
                slide: 'confluence-slides',
                whiteboard: 'confluence-whiteboards'
            };
            const isEnvEnabled = (0, $3ricL.isFeatureEnabled)('confluence', featureKeyMap[contentType], {
                'fedramp-moderate': ()=>(0, $9wGTI.fg)('confluence_frontend_enable_canvas_types_in_fedramp'),
                'isolated-cloud-commercial': ()=>(0, $9wGTI.fg)('confluence_frontend_enable_canvas_types_in_ic')
            });
            if (contentType === 'slide') return isEnvEnabled && !(0, $9wGTI.fg)('cc-mui-slides-opted-out') && (0, $6mKj3.expValEquals)('cc-mui-slides-experiment', 'isEnabled', true);
            return isEnvEnabled;
        }
        if (contentType === 'slide') return !(0, $jH9cM.isFedRamp)() && !(0, $9wGTI.fg)('cc-mui-slides-opted-out') && (0, $6mKj3.expValEquals)('cc-mui-slides-experiment', 'isEnabled', true);
        return !(0, $jH9cM.isFedRamp)();
    }
    return true;
};
module.exports["isContentTypeEnabledInCurrentEnv"] = $705f1ec06aff7fce$export$dd376e644565eb89;

});

parcelRegister("9HhEw", function(module, exports) {
/**
 * @generated SignedSource<<79c229d4f4ae3adcbe0b4f7f72920a16>>
 * @relayHash 80f146a83f48be7b9331f291c6222df0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 441a5a61fe71025e06bc5da2cffef931ef0f47310237ad63b8470d65a380d962
const $cb80c8184222fcac$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "type"
    }, v4 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v5 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v7 = [
        v3 /*: any*/ ,
        v5 /*: any*/ ,
        v6 /*: any*/ 
    ], v8 = {
        "kind": "ScalarField",
        "name": "friendlyWhen"
    }, v9 = {
        "kind": "ScalarField",
        "name": "number"
    }, v10 = {
        "kind": "ScalarField",
        "name": "confRev"
    }, v11 = {
        "kind": "ScalarField",
        "name": "syncRev"
    }, v12 = {
        "kind": "ScalarField",
        "name": "contentTypeModified"
    }, v13 = [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        v3 /*: any*/ ,
        v5 /*: any*/ ,
        v6 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ExternalByLineQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "createdBy",
                                    "plural": false,
                                    "selections": v7 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "ownedBy",
                                    "plural": false,
                                    "selections": v7 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "lastOwnedBy",
                                    "plural": false,
                                    "selections": v7 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": v7 /*: any*/ 
                                },
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ExternalByLineQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "createdBy",
                                    "plural": false,
                                    "selections": v13 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "ownedBy",
                                    "plural": false,
                                    "selections": v13 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "lastOwnedBy",
                                    "plural": false,
                                    "selections": v13 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": v13 /*: any*/ 
                                },
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "80f146a83f48be7b9331f291c6222df0",
            "id": "441a5a61fe71025e06bc5da2cffef931ef0f47310237ad63b8470d65a380d962",
            "metadata": {},
            "name": "ExternalByLineQuery",
            "operationKind": "query",
            "text": "query ExternalByLineQuery($contentId:ID!){singleContent(id:$contentId){id,type,history{createdDate,createdBy{__typename,type,displayName,...on KnownUser{accountId}},ownedBy{__typename,type,displayName,...on KnownUser{accountId}},lastOwnedBy{__typename,type,displayName,...on KnownUser{accountId}}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,confRev,syncRev,contentTypeModified}}}"
        }
    };
}();
$cb80c8184222fcac$var$node.hash = "012bf9a7497572d73e22134c755e8758";
var $cb80c8184222fcac$export$2e2bcd8739ae039 = $cb80c8184222fcac$var$node;
module.exports["default"] = $cb80c8184222fcac$export$2e2bcd8739ae039;

});

parcelRegister("83sfO", function(module, exports) {
const $567f280605647fdf$export$5d4c19aec4201e9 = 'live';
module.exports["LIVE_PAGE_SUBTYPE"] = $567f280605647fdf$export$5d4c19aec4201e9;

});

parcelRegister("gGK1T", function(module, exports) {
/**
 * @generated SignedSource<<e983bd00ea24afc042f5f11535352524>>
 * @relayHash b8208417e6c09fc98b947c6af794b0f3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c971c003da78a01cf940b7459511673bdc72b6148aa95f1c43a4a7a4369e8327
const $edbbfe37cbd0175f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": 4,
            "kind": "LocalArgument",
            "name": "limit"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v5 = {
        "kind": "ScalarField",
        "name": "type"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v7 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v8 = [
        v4 /*: any*/ ,
        v5 /*: any*/ ,
        v6 /*: any*/ ,
        v7 /*: any*/ 
    ], v9 = [
        v1 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "limit",
            "variableName": "limit"
        }
    ], v10 = [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        v4 /*: any*/ ,
        v5 /*: any*/ ,
        v6 /*: any*/ ,
        v7 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContentOwnershipContributorsContentOwnershipContributorsQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "ownedBy",
                                            "plural": false,
                                            "selections": v8 /*: any*/ 
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": v8 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v9 /*: any*/ ,
                    "concreteType": "ContentContributors",
                    "kind": "LinkedField",
                    "name": "contentContributors",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": v8 /*: any*/ 
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContentOwnershipContributorsContentOwnershipContributorsQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "ownedBy",
                                            "plural": false,
                                            "selections": v10 /*: any*/ 
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": v10 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v9 /*: any*/ ,
                    "concreteType": "ContentContributors",
                    "kind": "LinkedField",
                    "name": "contentContributors",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": v10 /*: any*/ 
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "b8208417e6c09fc98b947c6af794b0f3",
            "id": "c971c003da78a01cf940b7459511673bdc72b6148aa95f1c43a4a7a4369e8327",
            "metadata": {},
            "name": "useContentOwnershipContributorsContentOwnershipContributorsQuery",
            "operationKind": "query",
            "text": "query useContentOwnershipContributorsContentOwnershipContributorsQuery($contentId:ID!,$limit:Int=4){content(id:$contentId){nodes{id,history{ownedBy{__typename,displayName,type,...on KnownUser{accountId},profilePicture{path}}},version{by{__typename,displayName,type,...on KnownUser{accountId},profilePicture{path}}}}},contentContributors(id:$contentId,limit:$limit){nodes{__typename,displayName,type,...on KnownUser{accountId},profilePicture{path}}}}"
        }
    };
}();
$edbbfe37cbd0175f$var$node.hash = "e8dd42a19657acc23120ab54c46606ff";
var $edbbfe37cbd0175f$export$2e2bcd8739ae039 = $edbbfe37cbd0175f$var$node;
module.exports["default"] = $edbbfe37cbd0175f$export$2e2bcd8739ae039;

});

parcelRegister("2E1L5", function(module, exports) {
const $f1205e6da653ae62$export$16708f74bd486c8 = 'confluence_page_ownership_changeboarding';
const $f1205e6da653ae62$export$9ed1986df73b834a = 'change-page-ownership-link';
const $f1205e6da653ae62$export$21191b0c00ca25f4 = 10;
const $f1205e6da653ae62$export$83728ea2bd792f67 = {
    USER_IS_NULL: 'You cannot set an owner as an anonymous user.',
    USER_NOT_FOUND: 'Owner id is an invalid account id.',
    USER_MISSING_PAGE_PERMISSION: 'New owner must have view and edit permission on the content.',
    CONTENT_ID_INVALID: 'Content id is invalid.',
    INSUFFICIENT_PERMISSIONS: 'You must be the content creator, owner, or a space admin to set the owner.'
};
const $f1205e6da653ae62$export$f0b683cb64dc68b0 = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/';
const $f1205e6da653ae62$export$b344b39e3835f655 = 'https://support.atlassian.com/confluence-cloud/docs/transfer-ownership-of-your-page-to-another-person/';
const $f1205e6da653ae62$export$7ab4b084abc24ac8 = 'https://support.atlassian.com/confluence-cloud/docs/transfer-ownership-of-your-page-to-another-person/';
module.exports["CONTENT_OWNERSHIP_WEB_ITEM_ID"] = $f1205e6da653ae62$export$9ed1986df73b834a;
module.exports["DEFAULT_CONTRIBUTORS_FETCH_LIMIT"] = $f1205e6da653ae62$export$21191b0c00ca25f4;
module.exports["EXPECTED_ERROR_MESSAGES"] = $f1205e6da653ae62$export$83728ea2bd792f67;
module.exports["PARENT_PAGE_LEARN_MORE_URL"] = $f1205e6da653ae62$export$f0b683cb64dc68b0;
module.exports["CONFIRM_MODAL_LEARN_MORE_LINK"] = $f1205e6da653ae62$export$7ab4b084abc24ac8;

});

parcelRegister("ieWRE", function(module, exports) {
/**
 * @generated SignedSource<<cc3649e97b9be1d6269151089c18fb3f>>
 * @relayHash 544e060744fb4498c2bc0371295ea8f5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 44a5510e6c08eb024dc9e65741680c85b5e934e6cb2711735740a5c625e28126
const $89ec832c644948be$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SpaceTypeSettings",
                    "kind": "LinkedField",
                    "name": "spaceTypeSettings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "EnabledContentTypes",
                            "kind": "LinkedField",
                            "name": "enabledContentTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isFoldersEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isSmartFoldersEnabled"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsSmartFoldersEnabledQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsSmartFoldersEnabledQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "544e060744fb4498c2bc0371295ea8f5",
            "id": "44a5510e6c08eb024dc9e65741680c85b5e934e6cb2711735740a5c625e28126",
            "metadata": {},
            "name": "useIsSmartFoldersEnabledQuery",
            "operationKind": "query",
            "text": "query useIsSmartFoldersEnabledQuery($spaceKey:String!){space(key:$spaceKey){id,spaceTypeSettings{enabledContentTypes{isFoldersEnabled,isSmartFoldersEnabled}}}}"
        }
    };
}();
$89ec832c644948be$var$node.hash = "03675b093cffce21dc93e86a9415a3c7";
var $89ec832c644948be$export$2e2bcd8739ae039 = $89ec832c644948be$var$node;
module.exports["default"] = $89ec832c644948be$export$2e2bcd8739ae039;

});

parcelRegister("1hmAp", function(module, exports) {
/**
 * @generated SignedSource<<dc205b784e864c4042673f60370ebfb9>>
 * @relayHash 70e80297d041fb31c0639d661a01c799
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6578095b63bae12a8f819f71aa69d97fa02d466cfabbd61192951b7f59869e54
const $dc4c6b557b36d823$var$node = function() {
    var v0 = [
        {
            "alias": "storage",
            "concreteType": "ConfluenceStorage",
            "kind": "LinkedField",
            "name": "confluence_storage",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "bytesUsed"
                },
                {
                    "kind": "ScalarField",
                    "name": "isStorageEnforcementGracePeriodComplete"
                },
                {
                    "kind": "ScalarField",
                    "name": "gracePeriodEndDate"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useGetCurrentStorageUsageQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useGetCurrentStorageUsageQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "70e80297d041fb31c0639d661a01c799",
            "id": "6578095b63bae12a8f819f71aa69d97fa02d466cfabbd61192951b7f59869e54",
            "metadata": {},
            "name": "useGetCurrentStorageUsageQuery",
            "operationKind": "query",
            "text": "query useGetCurrentStorageUsageQuery{storage:confluence_storage{bytesUsed,isStorageEnforcementGracePeriodComplete,gracePeriodEndDate}}"
        }
    };
}();
$dc4c6b557b36d823$var$node.hash = "41d2bf41d832c3866355b26b49942948";
var $dc4c6b557b36d823$export$2e2bcd8739ae039 = $dc4c6b557b36d823$var$node;
module.exports["default"] = $dc4c6b557b36d823$export$2e2bcd8739ae039;

});

parcelRegister("a9aSv", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $5EzLH = parcelRequire("5EzLH");


var $iDrrr = parcelRequire("iDrrr");

const $19ad0c297e7cfe22$var$shimmerKeyframes = null;
const $19ad0c297e7cfe22$var$skeletonStyles = null;
const $19ad0c297e7cfe22$var$activeShimmerStyles = null; /**
                                   * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
                                   * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
                                   * which makes things simpler than doing an `isServer` check or a `null` check.
                                   *
                                   * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
                                   */ 
const $19ad0c297e7cfe22$var$useLayoutEffect = typeof window === 'undefined' ? (0, $cozmU.useEffect) : (0, $cozmU.useLayoutEffect); /**
                                                                                          * __Skeleton__
                                                                                          *
                                                                                          * A skeleton acts as a placeholder for content, usually while the content loads.
                                                                                          *
                                                                                          * - [Examples](https://atlassian.design/components/skeleton/examples)
                                                                                          * - [Code](https://atlassian.design/components/skeleton/code)
                                                                                          */ 
const $19ad0c297e7cfe22$var$Skeleton = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    const { width: width, height: height, borderRadius: t1, color: color, ShimmeringEndColor: ShimmeringEndColor, isShimmering: t2, groupName: groupName, interactionName: interactionName, testId: testId } = t0;
    const borderRadius = t1 === undefined ? "var(--ds-radius-small, 4px)" : t1;
    const isShimmering = t2 === undefined ? false : t2;
    const groupDataAttribute = groupName && `data-${groupName}`;
    const context = (0, $cozmU.useContext)((0, $5EzLH.default));
    let t3;
    let t4;
    if ($[0] !== context || $[1] !== interactionName) {
        t3 = ()=>{
            if (context != null && (0, $iDrrr.fg)("platform-dst-skeleton-ufo-hold")) return context.hold(interactionName);
        };
        t4 = [
            context,
            interactionName
        ];
        $[0] = context;
        $[1] = interactionName;
        $[2] = t3;
        $[3] = t4;
    } else {
        t3 = $[2];
        t4 = $[3];
    }
    $19ad0c297e7cfe22$var$useLayoutEffect(t3, t4);
    const t5 = color && ShimmeringEndColor ? color : undefined;
    const t6 = color && ShimmeringEndColor ? ShimmeringEndColor : undefined;
    let t7;
    if ($[4] !== borderRadius || $[5] !== color || $[6] !== height || $[7] !== t5 || $[8] !== t6 || $[9] !== width) {
        t7 = {
            width: width,
            height: height,
            borderRadius: borderRadius,
            backgroundColor: color,
            "--ds-skeleton-from-color": t5,
            "--ds-skeleton-to-color": t6
        };
        $[4] = borderRadius;
        $[5] = color;
        $[6] = height;
        $[7] = t5;
        $[8] = t6;
        $[9] = width;
        $[10] = t7;
    } else t7 = $[10];
    const t8 = t7;
    let t9;
    if ($[11] !== groupDataAttribute) {
        t9 = groupDataAttribute && {
            [groupDataAttribute]: "true"
        };
        $[11] = groupDataAttribute;
        $[12] = t9;
    } else t9 = $[12];
    const t10 = isShimmering && "";
    const t11 = isShimmering && "_1gBibyKB6V";
    let t12;
    if ($[13] !== t10 || $[14] !== t11) {
        t12 = (0, $hekY6.default)([
            "_0uDzWjkSs3 _0nFVCGfONH _03m2nySHWH _43vdfTHVQb _0KLXruGsB2",
            t10,
            t11
        ]);
        $[13] = t10;
        $[14] = t11;
        $[15] = t12;
    } else t12 = $[15];
    let t13;
    if ($[16] !== t12 || $[17] !== t8 || $[18] !== t9 || $[19] !== testId) {
        t13 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": testId,
            style: t8,
            ...t9,
            className: t12
        });
        $[16] = t12;
        $[17] = t8;
        $[18] = t9;
        $[19] = testId;
        $[20] = t13;
    } else t13 = $[20];
    return t13;
} : ({ width: width, height: height, borderRadius: borderRadius = "var(--ds-radius-small, 4px)", color: color, ShimmeringEndColor: ShimmeringEndColor, isShimmering: isShimmering = false, groupName: groupName, interactionName: interactionName, testId: testId })=>{
    const groupDataAttribute = groupName && `data-${groupName}`;
    const context = (0, $cozmU.useContext)((0, $5EzLH.default));
    $19ad0c297e7cfe22$var$useLayoutEffect(()=>{
        if (context != null && (0, $iDrrr.fg)('platform-dst-skeleton-ufo-hold')) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        "data-testid": testId,
        style: {
            width: width,
            height: height,
            borderRadius: borderRadius,
            backgroundColor: color,
            // Override the keyframes if both colors are provided, otherwise use the CSS variable fallbacks in our keyframes
            '--ds-skeleton-from-color': color && ShimmeringEndColor ? color : undefined,
            '--ds-skeleton-to-color': color && ShimmeringEndColor ? ShimmeringEndColor : undefined
        },
        ...groupDataAttribute && {
            [groupDataAttribute]: 'true'
        },
        className: (0, $hekY6.default)([
            "_0uDzWjkSs3 _0nFVCGfONH _03m2nySHWH _43vdfTHVQb _0KLXruGsB2",
            isShimmering && "",
            isShimmering && "_1gBibyKB6V"
        ])
    });
};
var $19ad0c297e7cfe22$export$2e2bcd8739ae039 = $19ad0c297e7cfe22$var$Skeleton;
module.exports["default"] = $19ad0c297e7cfe22$export$2e2bcd8739ae039;

});

parcelRegister("gkHoc", function(module, exports) {
$parcel$export(module.exports, "default", () => $be402bcc938fe0c2$export$2e2bcd8739ae039);

var $kr6hK = parcelRequire("kr6hK");


var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $be402bcc938fe0c2$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $3yGK6.default)(2, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var amount = (0, $kr6hK.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

});

parcelRegister("9ivsj", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $dX6FL = parcelRequire("dX6FL");


var $jlWUB = parcelRequire("jlWUB");

const $68c74ae30c005fed$export$c537e63161742ce3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const [prefersReducedMotion, setPrefersReducedMotion] = (0, $cozmU.useState)((0, $jlWUB.isReducedMotion));
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>{
            if (!(0, $dX6FL.isMatchMediaAvailable)()) return;
            const mediaQueryList = window.matchMedia("(prefers-reduced-motion: reduce)");
            const onChange = (event)=>setPrefersReducedMotion(event.matches);
            return (0, $cbY7C.bind)(mediaQueryList, {
                type: "change",
                listener: onChange
            });
        };
        t1 = [];
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    (0, $cozmU.useEffect)(t0, t1);
    return prefersReducedMotion;
} : ()=>{
    const [prefersReducedMotion, setPrefersReducedMotion] = (0, $cozmU.useState)((0, $jlWUB.isReducedMotion));
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $dX6FL.isMatchMediaAvailable)()) return;
        const mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        const onChange = (event)=>setPrefersReducedMotion(event.matches);
        return (0, $cbY7C.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
module.exports["useIsReducedMotion"] = $68c74ae30c005fed$export$c537e63161742ce3;

});

parcelRegister("jhrdR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7BVQi = parcelRequire("7BVQi");

const $8584e1bffd64d1d0$export$9e95200239cd148b = (cb)=>{
    const isFirstRender = (0, $cozmU.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $7BVQi.useLayoutEffect)(()=>{
        isFirstRender.current = false;
    }, []);
};
module.exports["useSnapshotBeforeUpdate"] = $8584e1bffd64d1d0$export$9e95200239cd148b;

});

parcelRegister("8D7c3", function(module, exports) {
const $9c67d6e83108154f$export$acd187a38a2cd68a = 'confluence:twcg-2055:flag-to-share-action';
const $9c67d6e83108154f$export$f28869dd2aadb934 = (detail)=>{
    const browserWindow = globalThis.document?.defaultView;
    if (!browserWindow) return false;
    const actionEvent = new CustomEvent($9c67d6e83108154f$export$acd187a38a2cd68a, {
        cancelable: true,
        detail: detail
    });
    browserWindow.dispatchEvent(actionEvent);
    return actionEvent.defaultPrevented;
};
module.exports["CONFLUENCE_FLAG_TO_SHARE_ACTION_EVENT"] = $9c67d6e83108154f$export$acd187a38a2cd68a;
module.exports["dispatchConfluenceFlagToShareAction"] = $9c67d6e83108154f$export$f28869dd2aadb934;

});

parcelRegister("1KLPb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c95e5a45617b6a4ede76b7e8e6442d6b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $146f2f46410fb12f$var$_react = $146f2f46410fb12f$var$_interopRequireDefault((parcelRequire("cozmU")));

var $146f2f46410fb12f$var$_iconNew = $146f2f46410fb12f$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $146f2f46410fb12f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BookOpen".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/book-open
 * Usage guidance:
 * Known uses: None
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $146f2f46410fb12f$var$BookOpenIcon = (props)=>/*#__PURE__*/ $146f2f46410fb12f$var$_react.default.createElement($146f2f46410fb12f$var$_iconNew.default, Object.assign({
        name: "BookOpenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.5 2.25v10H8.75V4.625a2.375 2.375 0 0 1 2.375-2.375zM8 2.333A3.87 3.87 0 0 1 11.125.75h3.501C15.387.75 16 1.367 16 2.125v10.25c0 .76-.616 1.375-1.375 1.375H8.75v1.5h-1.5v-1.5H1.375C.615 13.75 0 13.134 0 12.375V2.125C0 1.366.615.75 1.375.75h3.5A3.87 3.87 0 0 1 8 2.333m-.75 9.917V4.625A2.375 2.375 0 0 0 4.875 2.25H1.5v10zm6-8H10.5v1.5h2.75zm0 2.5H10.5v1.5h2.75z" clip-rule="evenodd"/>`
    }, props));
$146f2f46410fb12f$var$BookOpenIcon.displayName = 'BookOpenIcon';
var $146f2f46410fb12f$var$_default = module.exports.default = $146f2f46410fb12f$var$BookOpenIcon;

});

parcelRegister("iMZH0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a2f90348ffd0aefc186c142725e2cedf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dadc90963697fdad$var$_react = $dadc90963697fdad$var$_interopRequireDefault((parcelRequire("cozmU")));

var $dadc90963697fdad$var$_iconNew = $dadc90963697fdad$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $dadc90963697fdad$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Sync".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/sync
 * Usage guidance:
 * Reserved for syncing changes and save operations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dadc90963697fdad$var$SyncIcon = (props)=>/*#__PURE__*/ $dadc90963697fdad$var$_react.default.createElement($dadc90963697fdad$var$_iconNew.default, Object.assign({
        name: "SyncIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 .5h4.25a.75.75 0 0 1 .75.75V5.5H5.5V2.941a9 9 0 0 0-1.094.916C3.42 4.83 2.5 6.214 2.5 8c0 1.813.817 3.18 1.871 4.11 1.079.95 2.346 1.39 3.129 1.39V15c-1.217 0-2.825-.623-4.121-1.765C2.058 12.07 1 10.312 1 8c0-2.339 1.21-4.084 2.354-5.211.308-.304.615-.567.9-.789H2zm10.621 2.266C13.942 3.93 15 5.688 15 8c0 2.338-1.204 4.079-2.344 5.201-.304.3-.607.56-.889.78H14v1.5H9.75a.75.75 0 0 1-.75-.75v-4.25h1.5v2.573a9 9 0 0 0 1.104-.921C12.584 11.166 13.5 9.787 13.5 8c0-1.813-.817-3.18-1.871-4.11C10.551 2.94 9.283 2.5 8.5 2.5V1c1.217 0 2.825.623 4.121 1.766" clip-rule="evenodd"/>`
    }, props));
$dadc90963697fdad$var$SyncIcon.displayName = 'SyncIcon';
var $dadc90963697fdad$var$_default = module.exports.default = $dadc90963697fdad$var$SyncIcon;

});

parcelRegister("i1agE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::251f5452f3f0754765959a05130502fa>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d1e048e4b12a2678$var$_react = $d1e048e4b12a2678$var$_interopRequireDefault((parcelRequire("cozmU")));

var $d1e048e4b12a2678$var$_iconNew = $d1e048e4b12a2678$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $d1e048e4b12a2678$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WarningOutline".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/warning-outline
 * Usage guidance:
 * Low-impact warnings. Overdue dates in Atlassian Home.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d1e048e4b12a2678$var$WarningOutlineIcon = (props)=>/*#__PURE__*/ $d1e048e4b12a2678$var$_react.default.createElement($d1e048e4b12a2678$var$_iconNew.default, Object.assign({
        name: "WarningOutlineIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.7 1.383c.996-1.816 3.605-1.817 4.602-.002l5.35 9.73C16.612 12.86 15.346 15 13.35 15H2.667C.67 15-.594 12.862.365 11.113zm3.288.72a1.125 1.125 0 0 0-1.972.002L1.68 11.834c-.41.75.132 1.666.987 1.666H13.35c.855 0 1.398-.917.986-1.667z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M7.25 9V4h1.5v5z" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$d1e048e4b12a2678$var$WarningOutlineIcon.displayName = 'WarningOutlineIcon';
var $d1e048e4b12a2678$var$_default = module.exports.default = $d1e048e4b12a2678$var$WarningOutlineIcon;

});

parcelRegister("1NWCx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $19a7da84dd2786d0$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $cozmU.useEffect) : (0, $cozmU.useLayoutEffect);
module.exports["useLayoutEffect"] = $19a7da84dd2786d0$export$e5c5a5f917a5871c;

});

parcelRegister("4Uejl", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jlWUB = parcelRequire("jlWUB");


var $lrDw7 = parcelRequire("lrDw7");


var $7BVQi = parcelRequire("7BVQi");


var $g3XYx = parcelRequire("g3XYx");


var $1U6E9 = parcelRequire("1U6E9");


var $jhrdR = parcelRequire("jhrdR");

/**
 * Parses a CSS time value (e.g. `"0.2s"` or `"200ms"`) and returns milliseconds.
 * Falls back to 0 if the value cannot be parsed.
 */ function $8b8583a0a90649e3$var$parseCSSTimeToMs(value) {
    const parsed = parseFloat(value);
    if (Number.isNaN(parsed)) return 0;
    if (value.endsWith('ms')) return parsed;
    return parsed * 1000;
}
/**
 * Returns `true` if any of the dimension(s) being animated have changed
 * between the previous and next measurements.
 */ function $8b8583a0a90649e3$var$hasDimensionChanged(dimension, prev, next) {
    if (dimension === 'width') return prev.width !== next.width;
    if (dimension === 'height') return prev.height !== next.height;
    return prev.width !== next.width || prev.height !== next.height;
}
/**
 * Returns the CSS `transition-property` / `will-change` value for the
 * given dimension(s).
 */ function $8b8583a0a90649e3$var$getDimensionPropertyList(dimension) {
    if (dimension === 'both') return 'width, height';
    return dimension;
}
const $8b8583a0a90649e3$export$a300664a1a230956 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { dimension: dimension, duration: duration, easing: easing, onFinishMotion: onFinishMotion, onStartMotion: onStartMotion } = t0;
    const prevDimensions = (0, $cozmU.useRef)();
    const [element, setElementRef] = (0, $lrDw7.useElementRef)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            cleanup: "next-effect"
        };
        $[0] = t1;
    } else t1 = $[0];
    const setTimeout = (0, $1U6E9.useSetTimeout)(t1);
    const requestAnimationFrame = (0, $g3XYx.useRequestAnimationFrame)();
    let t2;
    if ($[1] !== element) {
        t2 = ()=>{
            if ((0, $jlWUB.isReducedMotion)() || !element) return;
            const rect = element.getBoundingClientRect();
            prevDimensions.current = {
                width: rect.width,
                height: rect.height
            };
        };
        $[1] = element;
        $[2] = t2;
    } else t2 = $[2];
    (0, $jhrdR.useSnapshotBeforeUpdate)(t2);
    let t3;
    if ($[3] !== dimension || $[4] !== duration || $[5] !== easing || $[6] !== element || $[7] !== onFinishMotion || $[8] !== onStartMotion || $[9] !== requestAnimationFrame || $[10] !== setTimeout) {
        t3 = ()=>{
            if (!element) return;
            if ((0, $jlWUB.isReducedMotion)()) {
                onFinishMotion?.();
                return;
            }
            if (!prevDimensions.current) return;
            element.setAttribute("style", "");
            const rect_0 = element.getBoundingClientRect();
            const nextDimensions = {
                width: rect_0.width,
                height: rect_0.height
            };
            if (!$8b8583a0a90649e3$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
                onFinishMotion?.();
                return;
            }
            onStartMotion?.();
            const propertyList = $8b8583a0a90649e3$var$getDimensionPropertyList(dimension);
            const newStyles = {
                willChange: propertyList,
                transitionProperty: propertyList,
                transitionDuration: duration,
                boxSizing: "border-box",
                transitionTimingFunction: easing
            };
            if (dimension === "width" || dimension === "both") newStyles.width = `${prevDimensions.current.width}px`;
            if (dimension === "height" || dimension === "both") newStyles.height = `${prevDimensions.current.height}px`;
            Object.assign(element.style, newStyles);
            const resolvedDuration = $8b8583a0a90649e3$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    if (!element) return;
                    if (dimension === "width" || dimension === "both") element.style.width = `${nextDimensions.width}px`;
                    if (dimension === "height" || dimension === "both") element.style.height = `${nextDimensions.height}px`;
                    setTimeout(()=>{
                        if (!element) return;
                        element.setAttribute("style", "");
                        onFinishMotion?.();
                    }, resolvedDuration);
                });
            });
        };
        $[3] = dimension;
        $[4] = duration;
        $[5] = easing;
        $[6] = element;
        $[7] = onFinishMotion;
        $[8] = onStartMotion;
        $[9] = requestAnimationFrame;
        $[10] = setTimeout;
        $[11] = t3;
    } else t3 = $[11];
    (0, $7BVQi.useLayoutEffect)(t3);
    let t4;
    if ($[12] !== setElementRef) {
        t4 = {
            ref: setElementRef
        };
        $[12] = setElementRef;
        $[13] = t4;
    } else t4 = $[13];
    return t4;
} : ({ dimension: dimension, duration: duration, easing: easing, onFinishMotion: onFinishMotion, onStartMotion: onStartMotion })=>{
    const prevDimensions = (0, $cozmU.useRef)();
    const [element, setElementRef] = (0, $lrDw7.useElementRef)();
    const setTimeout = (0, $1U6E9.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $g3XYx.useRequestAnimationFrame)();
    (0, $jhrdR.useSnapshotBeforeUpdate)(()=>{
        if ((0, $jlWUB.isReducedMotion)() || !element) return;
        const rect = element.getBoundingClientRect();
        prevDimensions.current = {
            width: rect.width,
            height: rect.height
        };
    });
    (0, $7BVQi.useLayoutEffect)(()=>{
        if (!element) return;
        if ((0, $jlWUB.isReducedMotion)()) {
            // No motion will ever run, so the element is already at its final dimensions.
            onFinishMotion?.();
            return;
        }
        if (!prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination dimensions first.
        element.setAttribute('style', '');
        const rect_0 = element.getBoundingClientRect();
        const nextDimensions = {
            width: rect_0.width,
            height: rect_0.height
        };
        if (!$8b8583a0a90649e3$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
            onFinishMotion?.();
            return;
        }
        // Any in-flight transition styles have been cleared and the next ones haven't been applied
        // yet, so the element is at the natural layout it will settle at.
        onStartMotion?.();
        const propertyList = $8b8583a0a90649e3$var$getDimensionPropertyList(dimension);
        const newStyles = {
            willChange: propertyList,
            transitionProperty: propertyList,
            transitionDuration: duration,
            boxSizing: 'border-box',
            transitionTimingFunction: easing
        };
        if (dimension === 'width' || dimension === 'both') newStyles.width = `${prevDimensions.current.width}px`;
        if (dimension === 'height' || dimension === 'both') newStyles.height = `${prevDimensions.current.height}px`;
        Object.assign(element.style, newStyles);
        const resolvedDuration = $8b8583a0a90649e3$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                if (dimension === 'width' || dimension === 'both') element.style.width = `${nextDimensions.width}px`;
                if (dimension === 'height' || dimension === 'both') element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                    onFinishMotion?.();
                }, resolvedDuration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
module.exports["useResizing"] = $8b8583a0a90649e3$export$a300664a1a230956;

});

parcelRegister("f7FiQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $gIfnJ = parcelRequire("gIfnJ");


var $gEyoZ = parcelRequire("gEyoZ");

const $b8829d8a161753f9$var$BranchObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BranchObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Branch" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gIfnJ))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function BranchObjectTile({ label: label = 'Branch', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gIfnJ))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $b8829d8a161753f9$export$2e2bcd8739ae039 = $b8829d8a161753f9$var$BranchObjectTile;
module.exports["default"] = $b8829d8a161753f9$export$2e2bcd8739ae039;

});

parcelRegister("6gVpf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $lepke = parcelRequire("lepke");


var $gEyoZ = parcelRequire("gEyoZ");

const $90d14fc97efa5c87$var$CommitObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CommitObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Commit" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-yellow, #B38600)";
    const t3 = isBold ? "color.background.accent.yellow.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lepke))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function CommitObjectTile({ label: label = 'Commit', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lepke))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-yellow, #B38600)",
        backgroundColor: isBold ? 'color.background.accent.yellow.subtle' : undefined
    });
};
var $90d14fc97efa5c87$export$2e2bcd8739ae039 = $90d14fc97efa5c87$var$CommitObjectTile;
module.exports["default"] = $90d14fc97efa5c87$export$2e2bcd8739ae039;

});

parcelRegister("lvsY2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hQhpy = parcelRequire("hQhpy");


var $gEyoZ = parcelRequire("gEyoZ");

const $c843d2b7ba70d597$var$PullRequestObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PullRequestObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Pull Request" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-green, #22A06B)";
    const t3 = isBold ? "color.background.accent.green.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hQhpy))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function PullRequestObjectTile({ label: label = 'Pull Request', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hQhpy))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-green, #22A06B)",
        backgroundColor: isBold ? 'color.background.accent.green.subtle' : undefined
    });
};
var $c843d2b7ba70d597$export$2e2bcd8739ae039 = $c843d2b7ba70d597$var$PullRequestObjectTile;
module.exports["default"] = $c843d2b7ba70d597$export$2e2bcd8739ae039;

});

parcelRegister("2z1Cx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $6YkHb = parcelRequire("6YkHb");


var $gEyoZ = parcelRequire("gEyoZ");

const $3fba6eb33cac86c2$var$CodeObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CodeObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Code" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-purple, #AF59E1)";
    const t3 = isBold ? "color.background.accent.purple.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6YkHb))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function CodeObjectTile({ label: label = 'Code', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6YkHb))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-purple, #AF59E1)",
        backgroundColor: isBold ? 'color.background.accent.purple.subtle' : undefined
    });
};
var $3fba6eb33cac86c2$export$2e2bcd8739ae039 = $3fba6eb33cac86c2$var$CodeObjectTile;
module.exports["default"] = $3fba6eb33cac86c2$export$2e2bcd8739ae039;

});

parcelRegister("ix7Nw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $6spAz = parcelRequire("6spAz");


var $gEyoZ = parcelRequire("gEyoZ");

const $e3c6782640cca582$var$BugObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BugObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Bug" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)";
    const t3 = isBold ? "color.background.accent.red.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6spAz))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function BugObjectTile({ label: label = 'Bug', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6spAz))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)",
        backgroundColor: isBold ? 'color.background.accent.red.subtle' : undefined
    });
};
var $e3c6782640cca582$export$2e2bcd8739ae039 = $e3c6782640cca582$var$BugObjectTile;
module.exports["default"] = $e3c6782640cca582$export$2e2bcd8739ae039;

});

parcelRegister("lfmf4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $lCTy3 = parcelRequire("lCTy3");


var $gEyoZ = parcelRequire("gEyoZ");

const $d8f6dc54ca6872bb$var$ChangesObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ChangesObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Changes" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-yellow, #B38600)";
    const t3 = isBold ? "color.background.accent.yellow.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lCTy3))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function ChangesObjectTile({ label: label = 'Changes', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lCTy3))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-yellow, #B38600)",
        backgroundColor: isBold ? 'color.background.accent.yellow.subtle' : undefined
    });
};
var $d8f6dc54ca6872bb$export$2e2bcd8739ae039 = $d8f6dc54ca6872bb$var$ChangesObjectTile;
module.exports["default"] = $d8f6dc54ca6872bb$export$2e2bcd8739ae039;

});

parcelRegister("bht3M", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $7vAVv = parcelRequire("7vAVv");


var $gEyoZ = parcelRequire("gEyoZ");

const $ff1c12598ed3ba74$var$EpicObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function EpicObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Epic" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-purple, #AF59E1)";
    const t3 = isBold ? "color.background.accent.purple.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7vAVv))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function EpicObjectTile({ label: label = 'Epic', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7vAVv))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-purple, #AF59E1)",
        backgroundColor: isBold ? 'color.background.accent.purple.subtle' : undefined
    });
};
var $ff1c12598ed3ba74$export$2e2bcd8739ae039 = $ff1c12598ed3ba74$var$EpicObjectTile;
module.exports["default"] = $ff1c12598ed3ba74$export$2e2bcd8739ae039;

});

parcelRegister("tBrWH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $ipvL3 = parcelRequire("ipvL3");


var $gEyoZ = parcelRequire("gEyoZ");

const $d409ccda82578191$var$IncidentObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function IncidentObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Incident" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)";
    const t3 = isBold ? "color.background.accent.red.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($ipvL3))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function IncidentObjectTile({ label: label = 'Incident', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ipvL3))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)",
        backgroundColor: isBold ? 'color.background.accent.red.subtle' : undefined
    });
};
var $d409ccda82578191$export$2e2bcd8739ae039 = $d409ccda82578191$var$IncidentObjectTile;
module.exports["default"] = $d409ccda82578191$export$2e2bcd8739ae039;

});

parcelRegister("e9ExL", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $7EFpK = parcelRequire("7EFpK");


var $gEyoZ = parcelRequire("gEyoZ");

const $70d7bc77e47e0fe4$var$ProblemObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ProblemObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Problem" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)";
    const t3 = isBold ? "color.background.accent.red.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7EFpK))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function ProblemObjectTile({ label: label = 'Problem', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7EFpK))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)",
        backgroundColor: isBold ? 'color.background.accent.red.subtle' : undefined
    });
};
var $70d7bc77e47e0fe4$export$2e2bcd8739ae039 = $70d7bc77e47e0fe4$var$ProblemObjectTile;
module.exports["default"] = $70d7bc77e47e0fe4$export$2e2bcd8739ae039;

});

parcelRegister("2hwbE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $iRFKG = parcelRequire("iRFKG");


var $gEyoZ = parcelRequire("gEyoZ");

const $0c8c4b462cd0e972$var$WorkItemObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function WorkItemObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Work Item" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function WorkItemObjectTile({ label: label = 'Work Item', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $0c8c4b462cd0e972$export$2e2bcd8739ae039 = $0c8c4b462cd0e972$var$WorkItemObjectTile;
module.exports["default"] = $0c8c4b462cd0e972$export$2e2bcd8739ae039;

});

parcelRegister("bnm2b", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $jrU5N = parcelRequire("jrU5N");


var $gEyoZ = parcelRequire("gEyoZ");

const $54244c8cd22493dc$var$StoryObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function StoryObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Story" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-green, #22A06B)";
    const t3 = isBold ? "color.background.accent.green.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($jrU5N))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function StoryObjectTile({ label: label = 'Story', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jrU5N))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-green, #22A06B)",
        backgroundColor: isBold ? 'color.background.accent.green.subtle' : undefined
    });
};
var $54244c8cd22493dc$export$2e2bcd8739ae039 = $54244c8cd22493dc$var$StoryObjectTile;
module.exports["default"] = $54244c8cd22493dc$export$2e2bcd8739ae039;

});

parcelRegister("h3uhG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $lSw2p = parcelRequire("lSw2p");


var $gEyoZ = parcelRequire("gEyoZ");

const $35e12172f066a32d$var$SubtaskObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SubtaskObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Subtask" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lSw2p))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function SubtaskObjectTile({ label: label = 'Subtask', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lSw2p))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $35e12172f066a32d$export$2e2bcd8739ae039 = $35e12172f066a32d$var$SubtaskObjectTile;
module.exports["default"] = $35e12172f066a32d$export$2e2bcd8739ae039;

});

parcelRegister("glDuG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $iAaYd = parcelRequire("iAaYd");


var $gEyoZ = parcelRequire("gEyoZ");

const $41a316049a2a2c13$var$TaskObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TaskObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Task" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iAaYd))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function TaskObjectTile({ label: label = 'Task', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iAaYd))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $41a316049a2a2c13$export$2e2bcd8739ae039 = $41a316049a2a2c13$var$TaskObjectTile;
module.exports["default"] = $41a316049a2a2c13$export$2e2bcd8739ae039;

});

parcelRegister("2zVsi", function(module, exports) {
/**
 * Returns one of functions depending on a boolean condition.
 * Both functions should have the same signature.
 * @see {@link functionUnionWithCondition} for functions with different return types
 */ function $70b08b83582e8047$export$af3c0e82a18fc057(condition, functionTrue, functionFalse) {
    const fnWithCondition = (...args)=>condition() ? functionTrue(...args) : functionFalse(...args);
    // Improvement: set name on a function. Requires external helper, not required for production
    return fnWithCondition;
}
module.exports["functionWithCondition"] = $70b08b83582e8047$export$af3c0e82a18fc057;

});

parcelRegister("7LPcf", function(module, exports) {

var $9EREa = parcelRequire("9EREa");

const $367262c04ca8598b$export$19ee667f3f7a6ec3 = (jsonLd)=>{
    const ownedBy = jsonLd['atlassian:ownedBy'];
    if (ownedBy) {
        if (Array.isArray(ownedBy)) return ownedBy.map((0, $9EREa.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $9EREa.extractPersonFromJsonLd)(ownedBy);
            if (item) return [
                item
            ];
        }
    }
    return undefined;
};
module.exports["extractPersonOwnedBy"] = $367262c04ca8598b$export$19ee667f3f7a6ec3;

});

parcelRegister("9EREa", function(module, exports) {

var $2GG3F = parcelRequire("2GG3F");

const $9cbb96c910c4c39f$export$c471ae5fddcf1392 = (person)=>{
    if (typeof person === 'string') throw Error('Link.person needs to be an object.');
    else if (person['@type'] === 'Link') {
        if (person.name) return {
            name: person.name
        };
    } else {
        if (person.name) return {
            name: person.name,
            src: person.icon && (0, $2GG3F.extractUrlFromIconJsonLd)(person.icon)
        };
    }
    return undefined;
};
module.exports["extractPersonFromJsonLd"] = $9cbb96c910c4c39f$export$c471ae5fddcf1392;

});

parcelRegister("303LV", function(module, exports) {
$parcel$export(module.exports, "default", () => $22f44c32aa84ec90$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

function $22f44c32aa84ec90$var$n() {
    return $22f44c32aa84ec90$var$n = Object.assign ? Object.assign.bind() : function(e) {
        for(var n = 1; n < arguments.length; n++){
            var r = arguments[n];
            for(var t in r)Object.prototype.hasOwnProperty.call(r, t) && (e[t] = r[t]);
        }
        return e;
    }, $22f44c32aa84ec90$var$n.apply(this, arguments);
}
const $22f44c32aa84ec90$var$r = [
    "children",
    "options"
], $22f44c32aa84ec90$export$e0aa44767d8750d5 = {
    blockQuote: "0",
    breakLine: "1",
    breakThematic: "2",
    codeBlock: "3",
    codeFenced: "4",
    codeInline: "5",
    footnote: "6",
    footnoteReference: "7",
    gfmTask: "8",
    heading: "9",
    headingSetext: "10",
    htmlBlock: "11",
    htmlComment: "12",
    htmlSelfClosing: "13",
    image: "14",
    link: "15",
    linkAngleBraceStyleDetector: "16",
    linkBareUrlDetector: "17",
    linkMailtoDetector: "18",
    newlineCoalescer: "19",
    orderedList: "20",
    paragraph: "21",
    ref: "22",
    refImage: "23",
    refLink: "24",
    table: "25",
    tableSeparator: "26",
    text: "27",
    textBolded: "28",
    textEmphasized: "29",
    textEscaped: "30",
    textMarked: "31",
    textStrikethroughed: "32",
    unorderedList: "33"
}, $22f44c32aa84ec90$var$o = [
    "allowFullScreen",
    "allowTransparency",
    "autoComplete",
    "autoFocus",
    "autoPlay",
    "cellPadding",
    "cellSpacing",
    "charSet",
    "classId",
    "colSpan",
    "contentEditable",
    "contextMenu",
    "crossOrigin",
    "encType",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "frameBorder",
    "hrefLang",
    "inputMode",
    "keyParams",
    "keyType",
    "marginHeight",
    "marginWidth",
    "maxLength",
    "mediaGroup",
    "minLength",
    "noValidate",
    "radioGroup",
    "readOnly",
    "rowSpan",
    "spellCheck",
    "srcDoc",
    "srcLang",
    "srcSet",
    "tabIndex",
    "useMap"
].reduce((e, n)=>(e[n.toLowerCase()] = n, e), {
    class: "className",
    for: "htmlFor"
}), $22f44c32aa84ec90$var$a = {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    nbsp: "\xa0",
    quot: "\u201C"
}, $22f44c32aa84ec90$var$c = [
    "style",
    "script",
    "pre"
], $22f44c32aa84ec90$var$i = [
    "src",
    "href",
    "data",
    "formAction",
    "srcDoc",
    "action"
], $22f44c32aa84ec90$var$u = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, $22f44c32aa84ec90$var$l = /\n{2,}$/, $22f44c32aa84ec90$var$s = /^(\s*>[\s\S]*?)(?=\n\n|$)/, $22f44c32aa84ec90$var$f = /^ *> ?/gm, $22f44c32aa84ec90$var$_ = /^(?:\[!([^\]]*)\]\n)?([\s\S]*)/, $22f44c32aa84ec90$var$d = /^ {2,}\n/, $22f44c32aa84ec90$var$p = /^(?:([-*_])( *\1){2,}) *(?:\n *)+\n/, $22f44c32aa84ec90$var$y = /^(?: {1,3})?(`{3,}|~{3,}) *(\S+)? *([^\n]*?)?\n([\s\S]*?)(?:\1\n?|$)/, $22f44c32aa84ec90$var$h = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, $22f44c32aa84ec90$var$g = /^(`+)((?:\\`|(?!\1)`|[^`])+)\1/, $22f44c32aa84ec90$var$m = /^(?:\n *)*\n/, $22f44c32aa84ec90$var$k = /\r\n?/g, $22f44c32aa84ec90$var$x = /^\[\^([^\]]+)](:(.*)((\n+ {4,}.*)|(\n(?!\[\^).+))*)/, $22f44c32aa84ec90$var$q = /^\[\^([^\]]+)]/, $22f44c32aa84ec90$var$v = /\f/g, $22f44c32aa84ec90$var$b = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, $22f44c32aa84ec90$var$$ = /^\s*?\[(x|\s)\]/, $22f44c32aa84ec90$var$S = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $22f44c32aa84ec90$var$z = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $22f44c32aa84ec90$var$E = /^([^\n]+)\n *(=|-)\2{2,} *\n/, $22f44c32aa84ec90$var$A = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?((?:[^>]*[^/])?)>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1\b)[\s\S])*?)<\/\1>(?!<\/\1>)\n*/i, $22f44c32aa84ec90$var$R = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, $22f44c32aa84ec90$var$B = /^<!--[\s\S]*?(?:-->)/, $22f44c32aa84ec90$var$L = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, $22f44c32aa84ec90$var$O = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, $22f44c32aa84ec90$var$j = /^\{.*\}$/, $22f44c32aa84ec90$var$C = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, $22f44c32aa84ec90$var$I = /^<([^ >]+[:@\/][^ >]+)>/, $22f44c32aa84ec90$var$T = /-([a-z])?/gi, $22f44c32aa84ec90$var$M = /^(\|.*)\n(?: *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*))?\n?/, $22f44c32aa84ec90$var$w = /^[^\n]+(?:  \n|\n{2,})/, $22f44c32aa84ec90$var$D = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, $22f44c32aa84ec90$var$F = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, $22f44c32aa84ec90$var$P = /^\[([^\]]*)\] ?\[([^\]]*)\]/, $22f44c32aa84ec90$var$Z = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, $22f44c32aa84ec90$var$N = /\t/g, $22f44c32aa84ec90$var$G = /(^ *\||\| *$)/g, $22f44c32aa84ec90$var$U = /^ *:-+: *$/, $22f44c32aa84ec90$var$V = /^ *:-+ *$/, $22f44c32aa84ec90$var$H = /^ *-+: *$/, $22f44c32aa84ec90$var$Q = (e)=>`(?=[\\s\\S]+?\\1${e ? "\\1" : ""})`, $22f44c32aa84ec90$var$W = "((?:\\[.*?\\][([].*?[)\\]]|<.*?>(?:.*?<.*?>)?|`.*?`|\\\\\\1|[\\s\\S])+?)", $22f44c32aa84ec90$var$J = RegExp(`^([*_])\\1${$22f44c32aa84ec90$var$Q(1)}${$22f44c32aa84ec90$var$W}\\1\\1(?!\\1)`), $22f44c32aa84ec90$var$K = RegExp(`^([*_])${$22f44c32aa84ec90$var$Q(0)}${$22f44c32aa84ec90$var$W}\\1(?!\\1)`), $22f44c32aa84ec90$var$X = RegExp(`^(==)${$22f44c32aa84ec90$var$Q(0)}${$22f44c32aa84ec90$var$W}\\1`), $22f44c32aa84ec90$var$Y = RegExp(`^(~~)${$22f44c32aa84ec90$var$Q(0)}${$22f44c32aa84ec90$var$W}\\1`), $22f44c32aa84ec90$var$ee = /^(:[a-zA-Z0-9-_]+:)/, $22f44c32aa84ec90$var$ne = /^\\([^0-9A-Za-z\s])/, $22f44c32aa84ec90$var$re = /\\([^0-9A-Za-z\s])/g, $22f44c32aa84ec90$var$te = /^[\s\S](?:(?!  \n|[0-9]\.|http)[^=*_~\-\n:<`\\\[!])*/, $22f44c32aa84ec90$var$oe = /^\n+/, $22f44c32aa84ec90$var$ae = /^([ \t]*)/, $22f44c32aa84ec90$var$ce = /(?:^|\n)( *)$/, $22f44c32aa84ec90$var$ie = "(?:\\d+\\.)", $22f44c32aa84ec90$var$ue = "(?:[*+-])";
function $22f44c32aa84ec90$var$le(e) {
    return "( *)(" + (1 === e ? $22f44c32aa84ec90$var$ie : $22f44c32aa84ec90$var$ue) + ") +";
}
const $22f44c32aa84ec90$var$se = $22f44c32aa84ec90$var$le(1), $22f44c32aa84ec90$var$fe = $22f44c32aa84ec90$var$le(2);
function $22f44c32aa84ec90$var$_e(e) {
    return RegExp("^" + (1 === e ? $22f44c32aa84ec90$var$se : $22f44c32aa84ec90$var$fe));
}
const $22f44c32aa84ec90$var$de = $22f44c32aa84ec90$var$_e(1), $22f44c32aa84ec90$var$pe = $22f44c32aa84ec90$var$_e(2);
function $22f44c32aa84ec90$var$ye(e) {
    return RegExp("^" + (1 === e ? $22f44c32aa84ec90$var$se : $22f44c32aa84ec90$var$fe) + "[^\\n]*(?:\\n(?!\\1" + (1 === e ? $22f44c32aa84ec90$var$ie : $22f44c32aa84ec90$var$ue) + " )[^\\n]*)*(\\n|$)", "gm");
}
const $22f44c32aa84ec90$var$he = $22f44c32aa84ec90$var$ye(1), $22f44c32aa84ec90$var$ge = $22f44c32aa84ec90$var$ye(2);
function $22f44c32aa84ec90$var$me(e) {
    const n = 1 === e ? $22f44c32aa84ec90$var$ie : $22f44c32aa84ec90$var$ue;
    return RegExp("^( *)(" + n + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + n + " (?!" + n + " ))\\n*|\\s*\\n*$)");
}
const $22f44c32aa84ec90$var$ke = $22f44c32aa84ec90$var$me(1), $22f44c32aa84ec90$var$xe = $22f44c32aa84ec90$var$me(2);
function $22f44c32aa84ec90$var$qe(e, n) {
    const r = 1 === n, t = r ? $22f44c32aa84ec90$var$ke : $22f44c32aa84ec90$var$xe, o = r ? $22f44c32aa84ec90$var$he : $22f44c32aa84ec90$var$ge, a = r ? $22f44c32aa84ec90$var$de : $22f44c32aa84ec90$var$pe;
    return {
        t: (e)=>a.test(e),
        o: $22f44c32aa84ec90$var$je(function(e, n) {
            const r = $22f44c32aa84ec90$var$ce.exec(n.prevCapture);
            return r && (n.list || !n.inline && !n.simple) ? t.exec(e = r[1] + e) : null;
        }),
        i: 1,
        u (e, n, t) {
            const c = r ? +e[2] : void 0, i = e[0].replace($22f44c32aa84ec90$var$l, "\n").match(o);
            let u = !1;
            return {
                items: i.map(function(e, r) {
                    const o = a.exec(e)[0].length, c = RegExp("^ {1," + o + "}", "gm"), l = e.replace(c, "").replace(a, ""), s = r === i.length - 1, f = -1 !== l.indexOf("\n\n") || s && u;
                    u = f;
                    const _ = t.inline, d = t.list;
                    let p;
                    t.list = !0, f ? (t.inline = !1, p = $22f44c32aa84ec90$var$Se(l) + "\n\n") : (t.inline = !0, p = $22f44c32aa84ec90$var$Se(l));
                    const y = n(p, t);
                    return t.inline = _, t.list = d, y;
                }),
                ordered: r,
                start: c
            };
        },
        l: (n, r, t)=>e(n.ordered ? "ol" : "ul", {
                key: t.key,
                start: "20" === n.type ? n.start : void 0
            }, n.items.map(function(n, o) {
                return e("li", {
                    key: o
                }, r(n, t));
            }))
    };
}
const $22f44c32aa84ec90$var$ve = RegExp("^\\[((?:\\[[^\\[\\]]*(?:\\[[^\\[\\]]*\\][^\\[\\]]*)*\\]|[^\\[\\]])*)\\]\\(\\s*<?((?:\\([^)]*\\)|[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"), $22f44c32aa84ec90$var$be = /^!\[(.*?)\]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/;
function $22f44c32aa84ec90$var$$e(e) {
    return "string" == typeof e;
}
function $22f44c32aa84ec90$var$Se(e) {
    let n = e.length;
    for(; n > 0 && e[n - 1] <= " ";)n--;
    return e.slice(0, n);
}
function $22f44c32aa84ec90$var$ze(e, n) {
    return e.startsWith(n);
}
function $22f44c32aa84ec90$var$Ee(e, n, r) {
    if (Array.isArray(r)) {
        for(let n = 0; n < r.length; n++)if ($22f44c32aa84ec90$var$ze(e, r[n])) return !0;
        return !1;
    }
    return r(e, n);
}
function $22f44c32aa84ec90$export$c383cdd2a518017a(e) {
    return e.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function $22f44c32aa84ec90$var$Re(e) {
    return $22f44c32aa84ec90$var$H.test(e) ? "right" : $22f44c32aa84ec90$var$U.test(e) ? "center" : $22f44c32aa84ec90$var$V.test(e) ? "left" : null;
}
function $22f44c32aa84ec90$var$Be(e, n, r, t) {
    const o = r.inTable;
    r.inTable = !0;
    let a = [
        []
    ], c = "";
    function i() {
        if (!c) return;
        const e = a[a.length - 1];
        e.push.apply(e, n(c, r)), c = "";
    }
    return e.trim().split(/(`[^`]*`|\\\||\|)/).filter(Boolean).forEach((e, n, r)=>{
        "|" === e.trim() && (i(), t) ? 0 !== n && n !== r.length - 1 && a.push([]) : c += e;
    }), i(), r.inTable = o, a;
}
function $22f44c32aa84ec90$var$Le(e, n, r) {
    r.inline = !0;
    const t = e[2] ? e[2].replace($22f44c32aa84ec90$var$G, "").split("|").map($22f44c32aa84ec90$var$Re) : [], o = e[3] ? function(e, n, r) {
        return e.trim().split("\n").map(function(e) {
            return $22f44c32aa84ec90$var$Be(e, n, r, !0);
        });
    }(e[3], n, r) : [], a = $22f44c32aa84ec90$var$Be(e[1], n, r, !!o.length);
    return r.inline = !1, o.length ? {
        align: t,
        cells: o,
        header: a,
        type: "25"
    } : {
        children: a,
        type: "21"
    };
}
function $22f44c32aa84ec90$var$Oe(e, n) {
    return null == e.align[n] ? {} : {
        textAlign: e.align[n]
    };
}
function $22f44c32aa84ec90$var$je(e) {
    return e.inline = 1, e;
}
function $22f44c32aa84ec90$var$Ce(e) {
    return $22f44c32aa84ec90$var$je(function(n, r) {
        return r.inline ? e.exec(n) : null;
    });
}
function $22f44c32aa84ec90$var$Ie(e) {
    return $22f44c32aa84ec90$var$je(function(n, r) {
        return r.inline || r.simple ? e.exec(n) : null;
    });
}
function $22f44c32aa84ec90$var$Te(e) {
    return function(n, r) {
        return r.inline || r.simple ? null : e.exec(n);
    };
}
function $22f44c32aa84ec90$var$Me(e) {
    return $22f44c32aa84ec90$var$je(function(n) {
        return e.exec(n);
    });
}
const $22f44c32aa84ec90$var$we = /(javascript|vbscript|data(?!:image)):/i;
function $22f44c32aa84ec90$export$3e2338ea76b578c9(e) {
    try {
        const n = decodeURIComponent(e).replace(/[^A-Za-z0-9/:]/g, "");
        if ($22f44c32aa84ec90$var$we.test(n)) return null;
    } catch (e) {
        return null;
    }
    return e;
}
function $22f44c32aa84ec90$var$Fe(e) {
    return e ? e.replace($22f44c32aa84ec90$var$re, "$1") : e;
}
function $22f44c32aa84ec90$var$Pe(e, n, r) {
    const t = r.inline || !1, o = r.simple || !1;
    r.inline = !0, r.simple = !0;
    const a = e(n, r);
    return r.inline = t, r.simple = o, a;
}
function $22f44c32aa84ec90$var$Ze(e, n, r) {
    const t = r.inline || !1, o = r.simple || !1;
    r.inline = !1, r.simple = !0;
    const a = e(n, r);
    return r.inline = t, r.simple = o, a;
}
function $22f44c32aa84ec90$var$Ne(e, n, r) {
    const t = r.inline || !1;
    r.inline = !1;
    const o = e(n, r);
    return r.inline = t, o;
}
const $22f44c32aa84ec90$var$Ge = (e, n, r)=>({
        children: $22f44c32aa84ec90$var$Pe(n, e[2], r)
    });
function $22f44c32aa84ec90$var$Ue() {
    return {};
}
function $22f44c32aa84ec90$var$Ve() {
    return null;
}
function $22f44c32aa84ec90$var$He(...e) {
    return e.filter(Boolean).join(" ");
}
function $22f44c32aa84ec90$var$Qe(e, n, r) {
    let t = e;
    const o = n.split(".");
    for(; o.length && (t = t[o[0]], void 0 !== t);)o.shift();
    return t || r;
}
function $22f44c32aa84ec90$export$69f434acfbdb0b32(r = "", t = {}) {
    t.overrides = t.overrides || {}, t.namedCodesToUnicode = t.namedCodesToUnicode ? $22f44c32aa84ec90$var$n({}, $22f44c32aa84ec90$var$a, t.namedCodesToUnicode) : $22f44c32aa84ec90$var$a;
    const l = t.slugify || $22f44c32aa84ec90$export$c383cdd2a518017a, G = t.sanitizer || $22f44c32aa84ec90$export$3e2338ea76b578c9, U = t.createElement || $cozmU.createElement, V = [
        $22f44c32aa84ec90$var$s,
        $22f44c32aa84ec90$var$y,
        $22f44c32aa84ec90$var$h,
        t.enforceAtxHeadings ? $22f44c32aa84ec90$var$z : $22f44c32aa84ec90$var$S,
        $22f44c32aa84ec90$var$E,
        $22f44c32aa84ec90$var$M,
        $22f44c32aa84ec90$var$ke,
        $22f44c32aa84ec90$var$xe
    ], H = [
        ...V,
        $22f44c32aa84ec90$var$w,
        $22f44c32aa84ec90$var$A,
        $22f44c32aa84ec90$var$B,
        $22f44c32aa84ec90$var$O
    ];
    function Q(e, n) {
        for(let r = 0; r < e.length; r++)if (e[r].test(n)) return !0;
        return !1;
    }
    function W(e, r, ...o) {
        const a = $22f44c32aa84ec90$var$Qe(t.overrides, e + ".props", {});
        return U(function(e, n) {
            const r = $22f44c32aa84ec90$var$Qe(n, e);
            return r ? "function" == typeof r || "object" == typeof r && "render" in r ? r : $22f44c32aa84ec90$var$Qe(n, e + ".component", e) : e;
        }(e, t.overrides), $22f44c32aa84ec90$var$n({}, r, a, {
            className: $22f44c32aa84ec90$var$He(null == r ? void 0 : r.className, a.className) || void 0
        }), ...o);
    }
    function re(e) {
        e = e.replace($22f44c32aa84ec90$var$b, "");
        let n = !1;
        t.forceInline ? n = !0 : t.forceBlock || (n = !1 === $22f44c32aa84ec90$var$Z.test(e));
        const r = fe(se(n ? e : $22f44c32aa84ec90$var$Se(e).replace($22f44c32aa84ec90$var$oe, "") + "\n\n", {
            inline: n
        }));
        for(; $22f44c32aa84ec90$var$$e(r[r.length - 1]) && !r[r.length - 1].trim();)r.pop();
        if (null === t.wrapper) return r;
        const o = t.wrapper || (n ? "span" : "div");
        let a;
        if (r.length > 1 || t.forceWrapper) a = r;
        else {
            if (1 === r.length) return a = r[0], "string" == typeof a ? W("span", {
                key: "outer"
            }, a) : a;
            a = null;
        }
        return U(o, {
            key: "outer"
        }, a);
    }
    function ce(e, n) {
        if (!n || !n.trim()) return null;
        const r = n.match($22f44c32aa84ec90$var$u);
        return r ? r.reduce(function(n, r) {
            const t = r.indexOf("=");
            if (-1 !== t) {
                const a = (function(e) {
                    return -1 !== e.indexOf("-") && null === e.match($22f44c32aa84ec90$var$L) && (e = e.replace($22f44c32aa84ec90$var$T, function(e, n) {
                        return n.toUpperCase();
                    })), e;
                })(r.slice(0, t)).trim(), c = function(e) {
                    const n = e[0];
                    return ('"' === n || "'" === n) && e.length >= 2 && e[e.length - 1] === n ? e.slice(1, -1) : e;
                }(r.slice(t + 1).trim()), u = $22f44c32aa84ec90$var$o[a] || a;
                if ("ref" === u) return n;
                const l = n[u] = function(e, n, r, t) {
                    return "style" === n ? (function(e) {
                        const n = [];
                        let r = "", t = !1, o = !1, a = "";
                        if (!e) return n;
                        for(let c = 0; c < e.length; c++){
                            const i = e[c];
                            if ('"' !== i && "'" !== i || t || (o ? i === a && (o = !1, a = "") : (o = !0, a = i)), "(" === i && r.endsWith("url") ? t = !0 : ")" === i && t && (t = !1), ";" !== i || o || t) r += i;
                            else {
                                const e = r.trim();
                                if (e) {
                                    const r = e.indexOf(":");
                                    if (r > 0) {
                                        const t = e.slice(0, r).trim(), o = e.slice(r + 1).trim();
                                        n.push([
                                            t,
                                            o
                                        ]);
                                    }
                                }
                                r = "";
                            }
                        }
                        const c = r.trim();
                        if (c) {
                            const e = c.indexOf(":");
                            if (e > 0) {
                                const r = c.slice(0, e).trim(), t = c.slice(e + 1).trim();
                                n.push([
                                    r,
                                    t
                                ]);
                            }
                        }
                        return n;
                    })(r).reduce(function(n, [r, o]) {
                        return n[r.replace(/(-[a-z])/g, (e)=>e[1].toUpperCase())] = t(o, e, r), n;
                    }, {}) : -1 !== $22f44c32aa84ec90$var$i.indexOf(n) ? t($22f44c32aa84ec90$var$Fe(r), e, n) : (r.match($22f44c32aa84ec90$var$j) && (r = $22f44c32aa84ec90$var$Fe(r.slice(1, r.length - 1))), "true" === r || "false" !== r && r);
                }(e, a, c, G);
                "string" == typeof l && ($22f44c32aa84ec90$var$A.test(l) || $22f44c32aa84ec90$var$O.test(l)) && (n[u] = re(l.trim()));
            } else "style" !== r && (n[$22f44c32aa84ec90$var$o[r] || r] = !0);
            return n;
        }, {}) : null;
    }
    const ie = [], ue = {}, le = {
        0: {
            t: [
                ">"
            ],
            o: $22f44c32aa84ec90$var$Te($22f44c32aa84ec90$var$s),
            i: 1,
            u (e, n, r) {
                const [, t, o] = e[0].replace($22f44c32aa84ec90$var$f, "").match($22f44c32aa84ec90$var$_);
                return {
                    alert: t,
                    children: n(o, r)
                };
            },
            l (e, n, r) {
                const t = {
                    key: r.key
                };
                return e.alert && (t.className = "markdown-alert-" + l(e.alert.toLowerCase(), $22f44c32aa84ec90$export$c383cdd2a518017a), e.children.unshift({
                    attrs: {},
                    children: [
                        {
                            type: "27",
                            text: e.alert
                        }
                    ],
                    noInnerParse: !0,
                    type: "11",
                    tag: "header"
                })), W("blockquote", t, n(e.children, r));
            }
        },
        1: {
            t: [
                "  "
            ],
            o: $22f44c32aa84ec90$var$Me($22f44c32aa84ec90$var$d),
            i: 1,
            u: $22f44c32aa84ec90$var$Ue,
            l: (e, n, r)=>W("br", {
                    key: r.key
                })
        },
        2: {
            t: [
                "--",
                "__",
                "**",
                "- ",
                "* ",
                "_ "
            ],
            o: $22f44c32aa84ec90$var$Te($22f44c32aa84ec90$var$p),
            i: 1,
            u: $22f44c32aa84ec90$var$Ue,
            l: (e, n, r)=>W("hr", {
                    key: r.key
                })
        },
        3: {
            t: [
                "    "
            ],
            o: $22f44c32aa84ec90$var$Te($22f44c32aa84ec90$var$h),
            i: 0,
            u: (e)=>({
                    lang: void 0,
                    text: $22f44c32aa84ec90$var$Fe($22f44c32aa84ec90$var$Se(e[0].replace(/^ {4}/gm, "")))
                }),
            l: (e, r, t)=>W("pre", {
                    key: t.key
                }, W("code", $22f44c32aa84ec90$var$n({}, e.attrs, {
                    className: e.lang ? "lang-" + e.lang : ""
                }), e.text))
        },
        4: {
            t: [
                "```",
                "~~~"
            ],
            o: $22f44c32aa84ec90$var$Te($22f44c32aa84ec90$var$y),
            i: 0,
            u: (e)=>({
                    attrs: ce("code", e[3] || ""),
                    lang: e[2] || void 0,
                    text: e[4],
                    type: "3"
                })
        },
        5: {
            t: [
                "`"
            ],
            o: $22f44c32aa84ec90$var$Ie($22f44c32aa84ec90$var$g),
            i: 3,
            u: (e)=>({
                    text: $22f44c32aa84ec90$var$Fe(e[2])
                }),
            l: (e, n, r)=>W("code", {
                    key: r.key
                }, e.text)
        },
        6: {
            t: [
                "[^"
            ],
            o: $22f44c32aa84ec90$var$Te($22f44c32aa84ec90$var$x),
            i: 0,
            u: (e)=>(ie.push({
                    footnote: e[2],
                    identifier: e[1]
                }), {}),
            l: $22f44c32aa84ec90$var$Ve
        },
        7: {
            t: [
                "[^"
            ],
            o: $22f44c32aa84ec90$var$Ce($22f44c32aa84ec90$var$q),
            i: 1,
            u: (e)=>({
                    target: "#" + l(e[1], $22f44c32aa84ec90$export$c383cdd2a518017a),
                    text: e[1]
                }),
            l: (e, n, r)=>W("a", {
                    key: r.key,
                    href: G(e.target, "a", "href")
                }, W("sup", {
                    key: r.key
                }, e.text))
        },
        8: {
            t: [
                "[ ]",
                "[x]"
            ],
            o: $22f44c32aa84ec90$var$Ce($22f44c32aa84ec90$var$$),
            i: 1,
            u: (e)=>({
                    completed: "x" === e[1].toLowerCase()
                }),
            l: (e, n, r)=>W("input", {
                    checked: e.completed,
                    key: r.key,
                    readOnly: !0,
                    type: "checkbox"
                })
        },
        9: {
            t: [
                "#"
            ],
            o: $22f44c32aa84ec90$var$Te(t.enforceAtxHeadings ? $22f44c32aa84ec90$var$z : $22f44c32aa84ec90$var$S),
            i: 1,
            u: (e, n, r)=>({
                    children: $22f44c32aa84ec90$var$Pe(n, e[2], r),
                    id: l(e[2], $22f44c32aa84ec90$export$c383cdd2a518017a),
                    level: e[1].length
                }),
            l: (e, n, r)=>W("h" + e.level, {
                    id: e.id,
                    key: r.key
                }, n(e.children, r))
        },
        10: {
            t: (e)=>{
                const n = e.indexOf("\n");
                return n > 0 && n < e.length - 1 && ("=" === e[n + 1] || "-" === e[n + 1]);
            },
            o: $22f44c32aa84ec90$var$Te($22f44c32aa84ec90$var$E),
            i: 1,
            u: (e, n, r)=>({
                    children: $22f44c32aa84ec90$var$Pe(n, e[1], r),
                    level: "=" === e[2] ? 1 : 2,
                    type: "9"
                })
        },
        11: {
            t: [
                "<"
            ],
            o: $22f44c32aa84ec90$var$Me($22f44c32aa84ec90$var$A),
            i: 1,
            u (e, n, r) {
                const [, t] = e[3].match($22f44c32aa84ec90$var$ae), o = RegExp("^" + t, "gm"), a = e[3].replace(o, ""), i = Q(H, a) ? $22f44c32aa84ec90$var$Ne : $22f44c32aa84ec90$var$Pe, u = e[1].toLowerCase(), l = -1 !== $22f44c32aa84ec90$var$c.indexOf(u), s = (l ? u : e[1]).trim(), f = {
                    attrs: ce(s, e[2]),
                    noInnerParse: l,
                    tag: s
                };
                if (r.inAnchor = r.inAnchor || "a" === u, l) f.text = e[3];
                else {
                    const e = r.inHTML;
                    r.inHTML = !0, f.children = i(n, a, r), r.inHTML = e;
                }
                return r.inAnchor = !1, f;
            },
            l: (e, r, t)=>W(e.tag, $22f44c32aa84ec90$var$n({
                    key: t.key
                }, e.attrs), e.text || (e.children ? r(e.children, t) : ""))
        },
        13: {
            t: [
                "<"
            ],
            o: $22f44c32aa84ec90$var$Me($22f44c32aa84ec90$var$O),
            i: 1,
            u (e) {
                const n = e[1].trim();
                return {
                    attrs: ce(n, e[2] || ""),
                    tag: n
                };
            },
            l: (e, r, t)=>W(e.tag, $22f44c32aa84ec90$var$n({}, e.attrs, {
                    key: t.key
                }))
        },
        12: {
            t: [
                "\x3c!--"
            ],
            o: $22f44c32aa84ec90$var$Me($22f44c32aa84ec90$var$B),
            i: 1,
            u: ()=>({}),
            l: $22f44c32aa84ec90$var$Ve
        },
        14: {
            t: [
                "!["
            ],
            o: $22f44c32aa84ec90$var$Ie($22f44c32aa84ec90$var$be),
            i: 1,
            u: (e)=>({
                    alt: $22f44c32aa84ec90$var$Fe(e[1]),
                    target: $22f44c32aa84ec90$var$Fe(e[2]),
                    title: $22f44c32aa84ec90$var$Fe(e[3])
                }),
            l: (e, n, r)=>W("img", {
                    key: r.key,
                    alt: e.alt || void 0,
                    title: e.title || void 0,
                    src: G(e.target, "img", "src")
                })
        },
        15: {
            t: [
                "["
            ],
            o: $22f44c32aa84ec90$var$Ce($22f44c32aa84ec90$var$ve),
            i: 3,
            u: (e, n, r)=>({
                    children: $22f44c32aa84ec90$var$Ze(n, e[1], r),
                    target: $22f44c32aa84ec90$var$Fe(e[2]),
                    title: $22f44c32aa84ec90$var$Fe(e[3])
                }),
            l: (e, n, r)=>W("a", {
                    key: r.key,
                    href: G(e.target, "a", "href"),
                    title: e.title
                }, n(e.children, r))
        },
        16: {
            t: [
                "<"
            ],
            o: $22f44c32aa84ec90$var$Ce($22f44c32aa84ec90$var$I),
            i: 0,
            u (e) {
                let n = e[1], r = !1;
                return -1 !== n.indexOf("@") && -1 === n.indexOf("//") && (r = !0, n = n.replace("mailto:", "")), {
                    children: [
                        {
                            text: n,
                            type: "27"
                        }
                    ],
                    target: r ? "mailto:" + n : n,
                    type: "15"
                };
            }
        },
        17: {
            t: (e, n)=>!n.inAnchor && !t.disableAutoLink && ($22f44c32aa84ec90$var$ze(e, "http://") || $22f44c32aa84ec90$var$ze(e, "https://")),
            o: $22f44c32aa84ec90$var$Ce($22f44c32aa84ec90$var$C),
            i: 0,
            u: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: "27"
                        }
                    ],
                    target: e[1],
                    title: void 0,
                    type: "15"
                })
        },
        20: $22f44c32aa84ec90$var$qe(W, 1),
        33: $22f44c32aa84ec90$var$qe(W, 2),
        19: {
            t: [
                "\n"
            ],
            o: $22f44c32aa84ec90$var$Te($22f44c32aa84ec90$var$m),
            i: 3,
            u: $22f44c32aa84ec90$var$Ue,
            l: ()=>"\n"
        },
        21: {
            o: $22f44c32aa84ec90$var$je(function(e, n) {
                if (n.inline || n.simple || n.inHTML && -1 === e.indexOf("\n\n") && -1 === n.prevCapture.indexOf("\n\n")) return null;
                let r = "", t = 0;
                for(;;){
                    const n = e.indexOf("\n", t), o = e.slice(t, -1 === n ? void 0 : n + 1);
                    if (Q(V, o)) break;
                    if (r += o, -1 === n || !o.trim()) break;
                    t = n + 1;
                }
                const o = $22f44c32aa84ec90$var$Se(r);
                return "" === o ? null : [
                    r,
                    ,
                    o
                ];
            }),
            i: 3,
            u: $22f44c32aa84ec90$var$Ge,
            l: (e, n, r)=>W("p", {
                    key: r.key
                }, n(e.children, r))
        },
        22: {
            t: [
                "["
            ],
            o: $22f44c32aa84ec90$var$Ce($22f44c32aa84ec90$var$D),
            i: 0,
            u: (e)=>(ue[e[1]] = {
                    target: e[2],
                    title: e[4]
                }, {}),
            l: $22f44c32aa84ec90$var$Ve
        },
        23: {
            t: [
                "!["
            ],
            o: $22f44c32aa84ec90$var$Ie($22f44c32aa84ec90$var$F),
            i: 0,
            u: (e)=>({
                    alt: e[1] ? $22f44c32aa84ec90$var$Fe(e[1]) : void 0,
                    ref: e[2]
                }),
            l: (e, n, r)=>ue[e.ref] ? W("img", {
                    key: r.key,
                    alt: e.alt,
                    src: G(ue[e.ref].target, "img", "src"),
                    title: ue[e.ref].title
                }) : null
        },
        24: {
            t: (e)=>"[" === e[0] && -1 === e.indexOf("]("),
            o: $22f44c32aa84ec90$var$Ce($22f44c32aa84ec90$var$P),
            i: 0,
            u: (e, n, r)=>({
                    children: n(e[1], r),
                    fallbackChildren: e[0],
                    ref: e[2]
                }),
            l: (e, n, r)=>ue[e.ref] ? W("a", {
                    key: r.key,
                    href: G(ue[e.ref].target, "a", "href"),
                    title: ue[e.ref].title
                }, n(e.children, r)) : W("span", {
                    key: r.key
                }, e.fallbackChildren)
        },
        25: {
            t: [
                "|"
            ],
            o: $22f44c32aa84ec90$var$Te($22f44c32aa84ec90$var$M),
            i: 1,
            u: $22f44c32aa84ec90$var$Le,
            l (e, n, r) {
                const t = e;
                return W("table", {
                    key: r.key
                }, W("thead", null, W("tr", null, t.header.map(function(e, o) {
                    return W("th", {
                        key: o,
                        style: $22f44c32aa84ec90$var$Oe(t, o)
                    }, n(e, r));
                }))), W("tbody", null, t.cells.map(function(e, o) {
                    return W("tr", {
                        key: o
                    }, e.map(function(e, o) {
                        return W("td", {
                            key: o,
                            style: $22f44c32aa84ec90$var$Oe(t, o)
                        }, n(e, r));
                    }));
                })));
            }
        },
        27: {
            o: $22f44c32aa84ec90$var$je(function(e, n) {
                let r;
                return $22f44c32aa84ec90$var$ze(e, ":") && (r = $22f44c32aa84ec90$var$ee.exec(e)), r || $22f44c32aa84ec90$var$te.exec(e);
            }),
            i: 4,
            u (e) {
                const n = e[0];
                return {
                    text: -1 === n.indexOf("&") ? n : n.replace($22f44c32aa84ec90$var$R, (e, n)=>t.namedCodesToUnicode[n] || e)
                };
            },
            l: (e)=>e.text
        },
        28: {
            t: [
                "**",
                "__"
            ],
            o: $22f44c32aa84ec90$var$Ie($22f44c32aa84ec90$var$J),
            i: 2,
            u: (e, n, r)=>({
                    children: n(e[2], r)
                }),
            l: (e, n, r)=>W("strong", {
                    key: r.key
                }, n(e.children, r))
        },
        29: {
            t: (e)=>{
                const n = e[0];
                return ("*" === n || "_" === n) && e[1] !== n;
            },
            o: $22f44c32aa84ec90$var$Ie($22f44c32aa84ec90$var$K),
            i: 3,
            u: (e, n, r)=>({
                    children: n(e[2], r)
                }),
            l: (e, n, r)=>W("em", {
                    key: r.key
                }, n(e.children, r))
        },
        30: {
            t: [
                "\\"
            ],
            o: $22f44c32aa84ec90$var$Ie($22f44c32aa84ec90$var$ne),
            i: 1,
            u: (e)=>({
                    text: e[1],
                    type: "27"
                })
        },
        31: {
            t: [
                "=="
            ],
            o: $22f44c32aa84ec90$var$Ie($22f44c32aa84ec90$var$X),
            i: 3,
            u: $22f44c32aa84ec90$var$Ge,
            l: (e, n, r)=>W("mark", {
                    key: r.key
                }, n(e.children, r))
        },
        32: {
            t: [
                "~~"
            ],
            o: $22f44c32aa84ec90$var$Ie($22f44c32aa84ec90$var$Y),
            i: 3,
            u: $22f44c32aa84ec90$var$Ge,
            l: (e, n, r)=>W("del", {
                    key: r.key
                }, n(e.children, r))
        }
    };
    !0 === t.disableParsingRawHTML && (delete le[11], delete le[13]);
    const se = function(e) {
        var n = Object.keys(e);
        function r(t, o) {
            var a = [];
            if (o.prevCapture = o.prevCapture || "", t.trim()) for(; t;)for(var c = 0; c < n.length;){
                var i = n[c], u = e[i];
                if (!u.t || $22f44c32aa84ec90$var$Ee(t, o, u.t)) {
                    var l = u.o(t, o);
                    if (l && l[0]) {
                        t = t.substring(l[0].length);
                        var s = u.u(l, r, o);
                        o.prevCapture += l[0], s.type || (s.type = i), a.push(s);
                        break;
                    }
                    c++;
                } else c++;
            }
            return o.prevCapture = "", a;
        }
        return n.sort(function(n, r) {
            return e[n].i - e[r].i || (n < r ? -1 : 1);
        }), function(e, n) {
            return r(function(e) {
                return e.replace($22f44c32aa84ec90$var$k, "\n").replace($22f44c32aa84ec90$var$v, "").replace($22f44c32aa84ec90$var$N, "    ");
            }(e), n);
        };
    }(le), fe = function(e, n) {
        return function r(t, o = {}) {
            if (Array.isArray(t)) {
                const e = o.key, n = [];
                let a = !1;
                for(let e = 0; e < t.length; e++){
                    o.key = e;
                    const c = r(t[e], o), i = $22f44c32aa84ec90$var$$e(c);
                    i && a ? n[n.length - 1] += c : null !== c && n.push(c), a = i;
                }
                return o.key = e, n;
            }
            return function(r, t, o) {
                const a = e[r.type].l;
                return n ? n(()=>a(r, t, o), r, t, o) : a(r, t, o);
            }(t, r, o);
        };
    }(le, t.renderRule), _e = re(r);
    return ie.length ? W("div", null, _e, W("footer", {
        key: "footer"
    }, ie.map(function(e) {
        return W("div", {
            id: l(e.identifier, $22f44c32aa84ec90$export$c383cdd2a518017a),
            key: e.identifier
        }, e.identifier, fe(se(e.footnote, {
            inline: !0
        })));
    }))) : _e;
}
var $22f44c32aa84ec90$export$2e2bcd8739ae039 = (n)=>{
    let { children: t, options: o } = n, a = function(e, n) {
        if (null == e) return {};
        var r, t, o = {}, a = Object.keys(e);
        for(t = 0; t < a.length; t++)n.indexOf(r = a[t]) >= 0 || (o[r] = e[r]);
        return o;
    }(n, $22f44c32aa84ec90$var$r);
    return $cozmU.cloneElement($22f44c32aa84ec90$export$69f434acfbdb0b32(null == t ? "" : t, o), a);
};
 //# sourceMappingURL=index.modern.js.map

});

parcelRegister("d4O2g", function(module, exports) {

var $1kPn4 = parcelRequire("1kPn4");

const $b61bca3ca7bdd7f0$export$4c753a1297cb9805 = (jsonLd)=>{
    const image = jsonLd.image;
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return (0, $1kPn4.extractUrlFromLinkJsonLd)(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return (0, $1kPn4.extractUrlFromLinkJsonLd)(image.url);
        }
    }
    return undefined;
};
module.exports["extractImage"] = $b61bca3ca7bdd7f0$export$4c753a1297cb9805;

});

parcelRegister("lXmY5", function(module, exports) {

var $hiX3M = parcelRequire("hiX3M");


var $8YE7G = parcelRequire("8YE7G");


var $kAdyG = parcelRequire("kAdyG");

const $652810c159b94aae$export$16b02be3e2bb31ad = (response)=>{
    if ((0, $kAdyG.isEntityPresent)(response)) return (0, $8YE7G.extractEntity)(response)?.ari || (0, $8YE7G.extractEntity)(response)?.thirdPartyAri;
    const data = response?.data;
    return (0, $hiX3M.extractAri)(data);
};
module.exports["extractSmartLinkAri"] = $652810c159b94aae$export$16b02be3e2bb31ad;

});

parcelRegister("cLyLO", function(module, exports) {

var $8YE7G = parcelRequire("8YE7G");


var $htsh0 = parcelRequire("htsh0");


var $kAdyG = parcelRequire("kAdyG");

const $b816614c9f5e4543$export$41fc716e1bc2dc90 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $kAdyG.isEntityPresent)(response)) {
        const entity = (0, $8YE7G.extractEntity)(response);
        const owners = entity?.owners;
        if (owners) return owners.map((owner)=>({
                name: owner.displayName,
                src: owner.picture
            })).filter((item)=>!!item);
    }
    return (0, $htsh0.extractPersonCreatedBy)(response.data);
};
module.exports["extractSmartLinkAuthorGroup"] = $b816614c9f5e4543$export$41fc716e1bc2dc90;

});

parcelRegister("htsh0", function(module, exports) {

var $9EREa = parcelRequire("9EREa");

const $94cdde39bec9c233$export$a66235cba0c9d11a = (jsonLd)=>{
    const attributedTo = jsonLd.attributedTo;
    if (attributedTo) {
        if (Array.isArray(attributedTo)) return attributedTo.map((0, $9EREa.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $9EREa.extractPersonFromJsonLd)(attributedTo);
            if (item) return [
                item
            ];
        }
    }
    return undefined;
};
module.exports["extractPersonCreatedBy"] = $94cdde39bec9c233$export$a66235cba0c9d11a;

});

parcelRegister("ddzkt", function(module, exports) {

var $8YE7G = parcelRequire("8YE7G");


var $htsh0 = parcelRequire("htsh0");


var $kAdyG = parcelRequire("kAdyG");

const $8118f7b98ace9299$export$242875b46118beb2 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $kAdyG.isEntityPresent)(response)) return (0, $8YE7G.extractEntity)(response)?.createdBy?.displayName;
    const persons = (0, $htsh0.extractPersonCreatedBy)(response.data);
    return !!persons?.length ? persons[0].name : undefined;
};
module.exports["extractSmartLinkCreatedBy"] = $8118f7b98ace9299$export$242875b46118beb2;

});

parcelRegister("cbT5r", function(module, exports) {

var $04wHu = parcelRequire("04wHu");


var $8YE7G = parcelRequire("8YE7G");


var $kAdyG = parcelRequire("kAdyG");

const $0016e53066bcc8e1$export$7a685df468cbf38f = (response)=>{
    if ((0, $kAdyG.isEntityPresent)(response)) return (0, $8YE7G.extractEntity)(response)?.createdAt;
    return response?.data && (0, $04wHu.extractDateCreated)(response.data);
};
module.exports["extractSmartLinkCreatedOn"] = $0016e53066bcc8e1$export$7a685df468cbf38f;

});

parcelRegister("04wHu", function(module, exports) {
const $cb783639b44cd885$export$e1226a5e0bbbf862 = (jsonLd)=>{
    if (jsonLd['schema:dateCreated']) return jsonLd['schema:dateCreated'];
    return undefined;
};
module.exports["extractDateCreated"] = $cb783639b44cd885$export$e1226a5e0bbbf862;

});

parcelRegister("e1RBl", function(module, exports) {

var $8YE7G = parcelRequire("8YE7G");


var $JTvZe = parcelRequire("JTvZe");


var $kAdyG = parcelRequire("kAdyG");

const $0ec810a5f5f35d9a$export$7f099a839071a190 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $kAdyG.isEntityPresent)(response)) return (0, $8YE7G.extractEntity)(response)?.lastUpdatedBy?.displayName;
    const person = (0, $JTvZe.extractPersonUpdatedBy)(response.data);
    return person ? person.name : undefined;
};
module.exports["extractSmartLinkModifiedBy"] = $0ec810a5f5f35d9a$export$7f099a839071a190;

});

parcelRegister("JTvZe", function(module, exports) {

var $9EREa = parcelRequire("9EREa");

const $a5f06d98edfcf1aa$export$8a2d1ed7e6f336f0 = (jsonLd)=>{
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) return (0, $9EREa.extractPersonFromJsonLd)(updatedBy);
    return undefined;
};
module.exports["extractPersonUpdatedBy"] = $a5f06d98edfcf1aa$export$8a2d1ed7e6f336f0;

});

parcelRegister("ltT9o", function(module, exports) {

var $hltP6 = parcelRequire("hltP6");


var $8YE7G = parcelRequire("8YE7G");


var $kAdyG = parcelRequire("kAdyG");

const $42cf6b151797d39e$export$75047940e157fd1f = (response)=>{
    if ((0, $kAdyG.isEntityPresent)(response)) return (0, $8YE7G.extractEntity)(response)?.lastUpdatedAt;
    return response?.data && (0, $hltP6.extractDateUpdated)(response.data);
};
module.exports["extractSmartLinkModifiedOn"] = $42cf6b151797d39e$export$75047940e157fd1f;

});

parcelRegister("hltP6", function(module, exports) {
const $57fe09cd1e375acc$export$7fc2f5e6f9d22ae7 = (jsonLd)=>{
    if (jsonLd.updated) return jsonLd.updated;
    return undefined;
};
module.exports["extractDateUpdated"] = $57fe09cd1e375acc$export$7fc2f5e6f9d22ae7;

});

parcelRegister("hoB2R", function(module, exports) {

var $8YE7G = parcelRequire("8YE7G");


var $kAdyG = parcelRequire("kAdyG");

const $dedbbfb6fd3975a3$export$96ed4c1b14ac210a = (response)=>{
    if ((0, $kAdyG.isEntityPresent)(response)) {
        const entity = (0, $8YE7G.extractEntity)(response);
        return entity && 'exportLinks' in entity && Array.isArray(entity.exportLinks) && entity.exportLinks.length > 0 ? entity?.exportLinks?.[0].url : undefined;
    }
    return response?.data?.['atlassian:downloadUrl'];
};
module.exports["extractSmartLinkDownloadUrl"] = $dedbbfb6fd3975a3$export$96ed4c1b14ac210a;

});

parcelRegister("cuq2s", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $q9Cpn = parcelRequire("q9Cpn");

const $cc5224b9f28cd9ed$export$a54013f0d02a8f82 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { children: children, locale: t1, fetchTranslations: fetchTranslations } = t0;
    const incomingLocale = t1 === undefined ? (0, $q9Cpn.DEFAULT_LOCALE) : t1;
    const [messages, setMessages] = (0, $cozmU.useState)();
    let t2;
    if ($[0] !== incomingLocale) {
        t2 = (0, $q9Cpn.normalizeLocale)(incomingLocale);
        $[0] = incomingLocale;
        $[1] = t2;
    } else t2 = $[1];
    const locale = t2;
    let t3;
    let t4;
    if ($[2] !== fetchTranslations || $[3] !== locale) {
        t3 = ()=>{
            const loadTranslations = async ()=>{
                const localeMessages = await fetchTranslations(locale);
                setMessages(localeMessages);
            };
            loadTranslations();
        };
        t4 = [
            fetchTranslations,
            locale
        ];
        $[2] = fetchTranslations;
        $[3] = locale;
        $[4] = t3;
        $[5] = t4;
    } else {
        t3 = $[4];
        t4 = $[5];
    }
    (0, $cozmU.useEffect)(t3, t4);
    if (!messages) return null;
    let t5;
    if ($[6] !== children || $[7] !== locale || $[8] !== messages) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
            locale: locale,
            messages: messages,
            defaultLocale: (0, $q9Cpn.DEFAULT_LOCALE)
        }, children);
        $[6] = children;
        $[7] = locale;
        $[8] = messages;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
} : ({ children: children, locale: incomingLocale = (0, $q9Cpn.DEFAULT_LOCALE), fetchTranslations: fetchTranslations })=>{
    const [messages, setMessages] = (0, $cozmU.useState)();
    const locale = (0, $cozmU.useMemo)(()=>(0, $q9Cpn.normalizeLocale)(incomingLocale), [
        incomingLocale
    ]);
    (0, $cozmU.useEffect)(()=>{
        const loadTranslations = async ()=>{
            const localeMessages = await fetchTranslations(locale);
            setMessages(localeMessages);
        };
        loadTranslations();
    }, [
        fetchTranslations,
        locale
    ]);
    if (!messages) return null;
    // Do not place formatMessage / FormattedMessage / useIntl calls here outside of the I18nProvider.
    // They will not function correctly due to a lack of I18n context.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
        locale: locale,
        messages: messages,
        defaultLocale: (0, $q9Cpn.DEFAULT_LOCALE)
    }, children);
};
module.exports["I18nProvider"] = $cc5224b9f28cd9ed$export$a54013f0d02a8f82;

});

parcelRegister("q9Cpn", function(module, exports) {
const $bacd93d5d71e2df6$var$DEFAULT_LANGUAGE = 'en';
const $bacd93d5d71e2df6$var$DEFAULT_REGION = 'US';
const $bacd93d5d71e2df6$export$1af4c7e47ad72f44 = `${$bacd93d5d71e2df6$var$DEFAULT_LANGUAGE}-${$bacd93d5d71e2df6$var$DEFAULT_REGION}`;
const $bacd93d5d71e2df6$var$languageToLongLocaleCode = {
    cs: 'cs-CZ',
    da: 'da-DK',
    de: 'de-DE',
    en: 'en-US',
    es: 'es-ES',
    fi: 'fi-FI',
    fr: 'fr-FR',
    hu: 'hu-HU',
    it: 'it-IT',
    ja: 'ja-JP',
    ko: 'ko-KR',
    // Both `no` and `nb` language codes refer to Norwegian. Refer both to long locale code as `no-NO`
    no: 'no-NO',
    nb: 'no-NO',
    nl: 'nl-NL',
    pl: 'pl-PL',
    ru: 'ru-RU',
    sv: 'sv-SE',
    th: 'th-TH',
    tr: 'tr-TR',
    uk: 'uk-UA',
    vi: 'vi-VN',
    zh: 'zh-CN'
};
const $bacd93d5d71e2df6$export$dca0327c9b9c6498 = (locale)=>{
    if (!locale) return $bacd93d5d71e2df6$export$1af4c7e47ad72f44;
    const match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale);
    if (!match) throw Error('Unable to get language and country from the supplied locale.');
    const [, language, region] = match;
    const normalizedLanguage = (language ?? '').toLowerCase();
    const normalizedRegion = (region ?? '').toUpperCase();
    if (normalizedLanguage && normalizedRegion) return [
        normalizedLanguage,
        normalizedRegion
    ].join('-');
    const longLocaleCode = $bacd93d5d71e2df6$var$languageToLongLocaleCode[normalizedLanguage];
    return longLocaleCode ?? $bacd93d5d71e2df6$export$1af4c7e47ad72f44;
};
module.exports["DEFAULT_LOCALE"] = $bacd93d5d71e2df6$export$1af4c7e47ad72f44;
module.exports["normalizeLocale"] = $bacd93d5d71e2df6$export$dca0327c9b9c6498;

});

parcelRegister("bIcvA", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $jKLZ2 = parcelRequire("jKLZ2");

const $1ec3abac0f6c1bfe$export$865423e6f8e2e839 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)((0, $jKLZ2.PerformanceMetricsContext));
} : ()=>{
    return (0, $cozmU.useContext)((0, $jKLZ2.PerformanceMetricsContext));
};
module.exports["usePerformanceMetrics"] = $1ec3abac0f6c1bfe$export$865423e6f8e2e839;

});

parcelRegister("jKLZ2", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $67682ba06b731a04$export$57c7d895214badd4 = /*#__PURE__*/ (0, $cozmU.createContext)({
    isInitialized: false,
    cancelIframeLoadMetrics: ()=>{},
    markIframeLoadMetrics: ()=>{},
    setContentType: ()=>{}
});
module.exports["PerformanceMetricsContext"] = $67682ba06b731a04$export$57c7d895214badd4;

});

parcelRegister("gyfUL", function(module, exports) {

var $fcaWu = parcelRequire("fcaWu");

const $8eb929a208703a52$export$6e43e60d51b79331 = (themeState)=>{
    const themeString = (0, $fcaWu.themeObjectToString)(themeState);
    return encodeURIComponent(themeString);
};
module.exports["themeStateObjectToQueryString"] = $8eb929a208703a52$export$6e43e60d51b79331;

});

parcelRegister("4ZxtP", function(module, exports) {

var $9EREa = parcelRequire("9EREa");

const $4dbfd7f5dbf19ca5$export$6281d080d62a0719 = (jsonLd)=>{
    const members = jsonLd['atlassian:member'];
    if (members) {
        if (typeof members === 'string') throw Error('Link[atlassian:members] must be an array or object.');
        else if (members.hasOwnProperty('totalItems')) {
            const collection = members;
            if (collection.items) return collection.items.map((member)=>(0, $9EREa.extractPersonFromJsonLd)(member)).filter((member)=>!!member);
        } else {
            const memberItem = members;
            const memberItemForLink = (0, $9EREa.extractPersonFromJsonLd)(memberItem);
            if (memberItemForLink) return [
                memberItemForLink
            ];
        }
    }
    return undefined;
};
module.exports["extractMembers"] = $4dbfd7f5dbf19ca5$export$6281d080d62a0719;

});

parcelRegister("6CHZa", function(module, exports) {

var $9EREa = parcelRequire("9EREa");

const $e6695a46069ee43e$export$38a0979ebf273662 = (jsonLd)=>{
    const assignedTo = jsonLd['atlassian:assignedTo'];
    if (assignedTo) return (0, $9EREa.extractPersonFromJsonLd)(assignedTo);
    return undefined;
};
module.exports["extractPersonAssignedTo"] = $e6695a46069ee43e$export$38a0979ebf273662;

});

parcelRegister("9f1Yt", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cMyWi = parcelRequire("cMyWi");

const $ec1ab019c54e6386$var$useContextMemoized = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useContextMemoized(reactContext) {
    const $ = (0, $bDgLe.c)(4);
    const value = (0, $cozmU.useContext)(reactContext);
    let t0;
    if ($[0] !== reactContext.Consumer || $[1] !== reactContext.Provider || $[2] !== value) {
        t0 = {
            Provider: reactContext.Provider,
            Consumer: reactContext.Consumer,
            value: value
        };
        $[0] = reactContext.Consumer;
        $[1] = reactContext.Provider;
        $[2] = value;
        $[3] = t0;
    } else t0 = $[3];
    const context = t0;
    return context;
} : function useContextMemoized(reactContext) {
    const value = (0, $cozmU.useContext)(reactContext);
    const context = (0, $cozmU.useMemo)(()=>({
            Provider: reactContext.Provider,
            Consumer: reactContext.Consumer,
            value: value
        }), [
        value,
        reactContext
    ]);
    return context;
};
const $ec1ab019c54e6386$export$10e9cca30e50f657 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return $ec1ab019c54e6386$var$useContextMemoized((0, $cMyWi.SmartCardContext));
} : ()=>$ec1ab019c54e6386$var$useContextMemoized((0, $cMyWi.SmartCardContext));
module.exports["useSmartCardContext"] = $ec1ab019c54e6386$export$10e9cca30e50f657;

});

parcelRegister("dqxOF", function(module, exports) {
function $9c67ef4150ae4cb3$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
function $9c67ef4150ae4cb3$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(let i = 0; i < len; i++){
        const key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $9c67ef4150ae4cb3$export$d36bdfa510afb180(a, b) {
    const aIsArr = Array.isArray(a);
    const bIsArr = Array.isArray(b);
    if (aIsArr !== bIsArr) return false;
    if (aIsArr && bIsArr) return $9c67ef4150ae4cb3$export$967a6b9924a689f7(a, b);
    return $9c67ef4150ae4cb3$export$3e67810a3f0e9f1c(a, b);
}
 //# sourceMappingURL=index.modern.mjs.map
module.exports["shallowEqualObjects"] = $9c67ef4150ae4cb3$export$3e67810a3f0e9f1c;

});

parcelRegister("dDboE", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $6JrSr = parcelRequire("6JrSr");

const $92e077c22efcc597$export$6be90bcb437e928f = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ children: children, postfix: postfix = '', prefix: prefix = '' }, ref)=>{
    const id = `${prefix}${(0, $6JrSr.useId)()}${postfix}`;
    (0, $cozmU.useEffect)(()=>{
        if (!ref) return;
        switch(typeof ref){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error(`Unreachable case for unsupported type of ref "${typeof ref}"`);
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: typeof children === 'function' ? children({
            id: id
        }) : children
    });
});
module.exports["IdProvider"] = $92e077c22efcc597$export$6be90bcb437e928f;

});

parcelRegister("1TlML", function(module, exports) {
function $cc70dd2ba0f00d0d$export$e618dc39ac9ad607(source, target = {}) {
    // initialize with source styles
    const styles = {
        ...source
    };
    // massage in target styles
    Object.keys(target).forEach((keyAsString)=>{
        const key = keyAsString;
        if (source[key]) styles[key] = (rsCss, props)=>{
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
module.exports["mergeStyles"] = $cc70dd2ba0f00d0d$export$e618dc39ac9ad607;

});

parcelRegister("4nIKB", function(module, exports) {

var $7ZH1D = parcelRequire("7ZH1D");


var $04KxR = parcelRequire("04KxR");

function $330c05f262f9f947$export$c9058316764c140e(refs) {
    return (0, $04KxR.createCallbackRef)((newValue)=>refs.forEach((ref)=>(0, $7ZH1D.assignRef)(ref, newValue)));
}
module.exports["mergeRefs"] = $330c05f262f9f947$export$c9058316764c140e;

});

parcelRegister("04KxR", function(module, exports) {
/**
 * creates a Ref object with on change callback
 * @param callback
 * @returns {RefObject}
 *
 * @see {@link useCallbackRef}
 * @see https://reactjs.org/docs/refs-and-the-dom.html#creating-refs
 */ function $00e47aba7bcb22e2$export$35a19128eb4acba4(callback) {
    let current = null;
    return {
        get current () {
            return current;
        },
        set current (value){
            const last = current;
            if (last !== value) {
                current = value;
                callback(value, last);
            }
        }
    };
}
module.exports["createCallbackRef"] = $00e47aba7bcb22e2$export$35a19128eb4acba4;

});

parcelRegister("1Ltep", function(module, exports) {
$parcel$export(module.exports, "default", () => $1490daf4e920e8da$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $1490daf4e920e8da$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3yGK6.default)(1, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("2iY37", function(module, exports) {
$parcel$export(module.exports, "default", () => $1adbd7c5d1b8dbaa$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $1Ltep = parcelRequire("1Ltep");


var $WeoLw = parcelRequire("WeoLw");


var $3yGK6 = parcelRequire("3yGK6");

function $1adbd7c5d1b8dbaa$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3yGK6.default)(1, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    return (0, $1Ltep.default)(date).getTime() === (0, $WeoLw.default)(date).getTime();
}

});

parcelRegister("WeoLw", function(module, exports) {
$parcel$export(module.exports, "default", () => $0af0962005736f62$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $0af0962005736f62$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3yGK6.default)(1, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("faU9A", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $03RpJ = parcelRequire("03RpJ");


var $iUTeb = parcelRequire("iUTeb");

function $062aa849ee2ceabc$export$a2e9b4862ddcda9d({ url: url }) {
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const id = (0, $cozmU.useMemo)(()=>(0, $03RpJ.default)(), []);
    const linkActions = (0, $iUTeb.useSmartCardActions)(id, url);
    return linkActions.reload;
}
module.exports["useSmartLinkReload"] = $062aa849ee2ceabc$export$a2e9b4862ddcda9d;

});

parcelRegister("gybyF", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $03RpJ = parcelRequire("03RpJ");


var $bI14T = parcelRequire("bI14T");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");


var $6Vsq4 = parcelRequire("6Vsq4");


var $apFwO = parcelRequire("apFwO");


var $jINxM = parcelRequire("jINxM");


var $2FmJb = parcelRequire("2FmJb");


var $dM7c5 = parcelRequire("dM7c5");


var $kG7AM = parcelRequire("kG7AM");


var $kfxZm = parcelRequire("kfxZm");


var $cEvdy = parcelRequire("cEvdy");


var $dz9dk = parcelRequire("dz9dk");


var $9H66G = parcelRequire("9H66G");

function $f78fd23812cb38dc$export$a95296ded9241771({ url: url, appearance: appearance, origin: origin, actionOptions: actionOptions, prefetch: prefetch }) {
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const id = (0, $cozmU.useMemo)(()=>(0, $03RpJ.default)(), []);
    const linkState = (0, $9H66G.useSmartCardState)(url);
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    const { isPreviewPanelAvailable: isPreviewPanelAvailable, isPreviewRestricted: isPreviewRestricted, openPreviewPanel: openPreviewPanel } = (0, $bI14T.useSmartLinkContext)();
    const invokeClientAction = (0, $kfxZm.default)({
        fireEvent: fireEvent
    });
    const resolve = (0, $cEvdy.default)();
    const appendCrossProductAnalyticsParams = (0, $dz9dk.useSmartLinkCrossProductUrlWrapper)({
        details: linkState.details
    });
    if ((0, $ieeJu.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && prefetch && !linkState.details) resolve({
        url: url
    });
    if (linkState.details && !actionOptions?.hide) {
        const actions = [];
        const invokeParam = {
            actionOptions: actionOptions,
            appearance: appearance,
            id: id,
            response: linkState.details
        };
        const downloadActionProps = (0, $apFwO.extractInvokeDownloadAction)(invokeParam);
        if (downloadActionProps) actions.push((0, $kG7AM.toAction)(downloadActionProps, invokeClientAction, (0, $dM7c5.messages).download, 'download-content'));
        const viewActionProps = (0, $2FmJb.extractInvokeViewAction)({
            ...invokeParam,
            transformUrl: (destinationUrl = url)=>appendCrossProductAnalyticsParams(destinationUrl)
        });
        if (viewActionProps) actions.push((0, $kG7AM.toAction)(viewActionProps, invokeClientAction, (0, $dM7c5.messages).view, 'view-content'));
        const previewActionProps = (0, $jINxM.extractInvokePreviewAction)({
            ...invokeParam,
            fireEvent: fireEvent,
            origin: origin,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            ...(0, $iDrrr.fg)('preview_panel_unit_check') ? {
                isPreviewRestricted: isPreviewRestricted
            } : undefined,
            openPreviewPanel: openPreviewPanel,
            transformUrl: (destinationUrl = url)=>appendCrossProductAnalyticsParams(destinationUrl)
        });
        if (previewActionProps) actions.push((0, $kG7AM.toAction)(previewActionProps.invokeAction, invokeClientAction, (0, $dM7c5.messages).preview_improved, 'preview-content'));
        return actions;
    }
    return [];
}
module.exports["useSmartLinkActions"] = $f78fd23812cb38dc$export$a95296ded9241771;

});

parcelRegister("kG7AM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");

const $658c5c09596e5d2b$export$9d52be0dab870c7 = (action, invokeClientAction, message, id)=>{
    return {
        id: id,
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), message),
        invoke: ()=>invokeClientAction(action)
    };
};
module.exports["toAction"] = $658c5c09596e5d2b$export$9d52be0dab870c7;

});

parcelRegister("hEt1x", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $g9ZnD = parcelRequire("g9ZnD");


var $IY7Mb = parcelRequire("IY7Mb");

const $2ddf178f2decc0e9$export$c94ff18a59d4c4d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext(undefined);
const $2ddf178f2decc0e9$export$57164260bc1f1218 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { children: children, mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings } = t0;
    let t1;
    if ($[0] !== mediaClientConfig) {
        t1 = (0, $g9ZnD.getMediaClient)(mediaClientConfig);
        $[0] = mediaClientConfig;
        $[1] = t1;
    } else t1 = $[1];
    const mediaClient = t1;
    const settings = (0, $IY7Mb.useMediaParsedSettings)(mediaSettings);
    let t2;
    if ($[2] !== mediaClient || $[3] !== settings) {
        t2 = {
            mediaClient: mediaClient,
            settings: settings
        };
        $[2] = mediaClient;
        $[3] = settings;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== children || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2ddf178f2decc0e9$export$c94ff18a59d4c4d.Provider, {
            value: t2
        }, children);
        $[5] = children;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ children: children, mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings })=>{
    const mediaClient = (0, $cozmU.useMemo)(()=>(0, $g9ZnD.getMediaClient)(mediaClientConfig), [
        mediaClientConfig
    ]);
    const settings = (0, $IY7Mb.useMediaParsedSettings)(mediaSettings);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2ddf178f2decc0e9$export$c94ff18a59d4c4d.Provider, {
        value: {
            mediaClient: mediaClient,
            settings: settings
        }
    }, children);
};
module.exports["MediaContext"] = $2ddf178f2decc0e9$export$c94ff18a59d4c4d;
module.exports["MediaProvider"] = $2ddf178f2decc0e9$export$57164260bc1f1218;

});

parcelRegister("IY7Mb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $gYqFD = parcelRequire("gYqFD");

const $a0017e6c99530c15$export$d54af28440a5efc0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const mediaSettings = t1;
    let newSettings;
    if ($[2] !== mediaSettings) {
        newSettings = {
            ...mediaSettings
        };
        newSettings.mediaUserPreferences = (0, $gYqFD.defaultMediaUserPreferences);
        $[2] = mediaSettings;
        $[3] = newSettings;
    } else newSettings = $[3];
    const settings = newSettings;
    return settings;
} : (mediaSettings = {})=>{
    const settings = (0, $cozmU.useMemo)(()=>{
        const newSettings = {
            ...mediaSettings
        };
        newSettings.mediaUserPreferences = (0, $gYqFD.defaultMediaUserPreferences);
        return newSettings;
    }, [
        mediaSettings
    ]);
    return settings;
};
module.exports["useMediaParsedSettings"] = $a0017e6c99530c15$export$d54af28440a5efc0;

});

parcelRegister("gYqFD", function(module, exports) {
// Currently only supports boolean, string. Uncomment below to support number
const $c55cff04bbd4c82d$var$MediaUserPreferencesTypes = {
    videoCaptionsEnabled: 'boolean',
    videoCaptionsPreferredLocale: 'string'
};
const $c55cff04bbd4c82d$export$7e209e67b965bc63 = (userPreferences)=>({
        set: (key, value)=>{
            userPreferences.set(key, value.toString());
        },
        get: (key)=>{
            const value = userPreferences.get(key);
            if (value === null || value === undefined) return undefined;
            if ($c55cff04bbd4c82d$var$MediaUserPreferencesTypes[key] === 'boolean') return value === 'true';
            // Uncomment to support number
            // if (MediaUserSettingsTypes[key] === 'number') {
            // 	return Number(value) as MediaSettingsTypeMap[K];
            // }
            return value;
        }
    });
const $c55cff04bbd4c82d$var$defaultUserPreferences = {
    set: (key, value)=>{
        const MEDIA_KEY = 'media';
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        localStorage.setItem(`${MEDIA_KEY}-${key}`, value);
    },
    get: (key)=>{
        const MEDIA_KEY = 'media';
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        return localStorage.getItem(`${MEDIA_KEY}-${key}`);
    }
};
const $c55cff04bbd4c82d$export$2d23ed2854ac1650 = $c55cff04bbd4c82d$export$7e209e67b965bc63($c55cff04bbd4c82d$var$defaultUserPreferences);
module.exports["defaultMediaUserPreferences"] = $c55cff04bbd4c82d$export$2d23ed2854ac1650;

});

parcelRegister("lNvN4", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $gIMcb = parcelRequire("gIMcb");


var $hEt1x = parcelRequire("hEt1x");

const $e5ff9295aa55af63$export$8b3e87ea56c3a345 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $gIMcb.MediaClientContext));
    const { mediaClient: altMediaClient } = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $hEt1x.MediaContext)) || {};
    if (!mediaClient && !altMediaClient) throw new Error("No MediaClient set, use MediaClientProvider or MediaProvider to set one");
    return mediaClient || altMediaClient;
} : ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $gIMcb.MediaClientContext));
    const { mediaClient: altMediaClient } = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $hEt1x.MediaContext)) || {};
    if (!mediaClient && !altMediaClient) throw new Error('No MediaClient set, use MediaClientProvider or MediaProvider to set one');
    // WARNING: typescript can't infer that at least one mediaClient is defined here. Adding the `!` is a hack to make typescript happy.
    return mediaClient || altMediaClient;
};
module.exports["useMediaClient"] = $e5ff9295aa55af63$export$8b3e87ea56c3a345;

});

parcelRegister("lUcpS", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $k78uC = parcelRequire("k78uC");


var $8IfK6 = parcelRequire("8IfK6");

const $91b0a64470223be6$export$5bf35293e545f20c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t0;
    if ($[0] !== createAnalyticsEvent) {
        t0 = (...t1)=>{
            const params = t1;
            const event = createAnalyticsEvent((0, $8IfK6.default)(...params));
            event.fire((0, $k78uC.EVENT_CHANNEL));
        };
        $[0] = createAnalyticsEvent;
        $[1] = t0;
    } else t0 = $[1];
    const fireEvent = t0;
    let t1;
    if ($[2] !== fireEvent) {
        t1 = {
            fireEvent: fireEvent
        };
        $[2] = fireEvent;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireEvent = (0, $cozmU.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $8IfK6.default)(...params));
        event.fire((0, $k78uC.EVENT_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};
module.exports["useAnalyticsEvents"] = $91b0a64470223be6$export$5bf35293e545f20c;

});

parcelRegister("k78uC", function(module, exports) {
const $0de3cce3bcdfa361$export$3f072f06b90c3985 = 'peopleTeams';
module.exports["EVENT_CHANNEL"] = $0de3cce3bcdfa361$export$3f072f06b90c3985;

});

parcelRegister("8IfK6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::378c0a04d2cca8641793d5a92fac3d1a>>
 * @codegenCommand afm workspace @atlassian/analytics-tooling analytics:codegen teams-app-internal-analytics
 */ const $fcb00cbaaafbad36$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $fcb00cbaaafbad36$export$2e2bcd8739ae039 = $fcb00cbaaafbad36$var$createEventPayload;
module.exports["default"] = $fcb00cbaaafbad36$export$2e2bcd8739ae039;

});

parcelRegister("cSSWJ", function(module, exports) {
const $e8b102093dcaac45$export$849551cf61929d4f = {
    packageName: "platform-pkg" ?? '',
    packageVersion: "0.0.0-use.local" ?? ''
};
const $e8b102093dcaac45$export$efd16d9cf43b6e97 = 'teamProfileCard';
const $e8b102093dcaac45$export$7611b3e6899481f9 = 'profilecard';
const $e8b102093dcaac45$export$4c23d6e68fa71371 = 'rovoAgentProfilecard';
module.exports["PACKAGE_META_DATA"] = $e8b102093dcaac45$export$849551cf61929d4f;
module.exports["TEAM_SUBJECT"] = $e8b102093dcaac45$export$efd16d9cf43b6e97;
module.exports["USER_SUBJECT"] = $e8b102093dcaac45$export$7611b3e6899481f9;
module.exports["AGENT_SUBJECT"] = $e8b102093dcaac45$export$4c23d6e68fa71371;

});

parcelRegister("4PAHv", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");


var $7G50J = parcelRequire("7G50J");


var $hMCZS = parcelRequire("hMCZS");


var $lUcpS = parcelRequire("lUcpS");


var $dSW04 = parcelRequire("dSW04");


var $dRAjC = parcelRequire("dRAjC");


var $4k5Wq = parcelRequire("4k5Wq");


var $kb2tZ = parcelRequire("kb2tZ");


var $hIwXM = parcelRequire("hIwXM");

const $fe1c8bc12e81e628$export$4b013ffffcb40af8 = (props)=>{
    const [agentData, setAgentData] = (0, $cozmU.useState)();
    // Initialize as true when fix is enabled since we fetch immediately on mount,
    // avoiding a brief error screen flash before the useEffect fires.
    const [isLoading, setIsLoading] = (0, $cozmU.useState)((0, $iDrrr.fg)('confluence_fix_agent_profile_card_flash'));
    const [error, setError] = (0, $cozmU.useState)();
    const [isPermitted, setIsPermitted] = (0, $cozmU.useState)(true);
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    const creatorUserId = (0, $cozmU.useMemo)(()=>agentData?.creator_type === 'CUSTOMER' && agentData.creator ? (0, $dRAjC.getAAIDFromARI)(agentData.creator) : '', [
        agentData?.creator_type,
        agentData?.creator
    ]);
    const navResult = (0, $hMCZS.navigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: creatorUserId || ''
        },
        cloudId: props.cloudId
    });
    let profileHref = navResult.href;
    const getCreator = (0, $cozmU.useCallback)(async ({ creator_type: creator_type, creator: creator, authoringTeam: authoringTeam })=>{
        try {
            let userCreatorInfo;
            const currentCreatorUserId = (0, $iDrrr.fg)('confluence_fix_agent_profile_card_flash') ? creator_type === 'CUSTOMER' && creator ? (0, $dRAjC.getAAIDFromARI)(creator) : undefined : creatorUserId;
            if (currentCreatorUserId && props.cloudId) {
                userCreatorInfo = await props.resourceClient.getProfile(props.cloudId, currentCreatorUserId, fireEvent);
                if ((0, $iDrrr.fg)('confluence_fix_agent_profile_card_flash')) profileHref = (0, $hMCZS.navigateToTeamsApp)({
                    type: 'USER',
                    payload: {
                        userId: currentCreatorUserId
                    },
                    cloudId: props.cloudId
                }).href;
            }
            const creatorInfo = (0, $7G50J.getAgentCreator)({
                creatorType: creator_type,
                authoringTeam: authoringTeam ? {
                    displayName: authoringTeam.displayName ?? '',
                    profileLink: authoringTeam.profileUrl ?? undefined
                } : undefined,
                userCreator: userCreatorInfo ? {
                    name: userCreatorInfo.fullName ?? '',
                    profileLink: (0, $iDrrr.fg)('platform-adopt-teams-nav-config') ? profileHref : `/people/${currentCreatorUserId}`
                } : undefined,
                forgeCreator: creator ?? undefined
            });
            return creatorInfo;
        } catch  {
            return undefined;
        }
    }, [
        creatorUserId,
        fireEvent,
        props.cloudId,
        props.resourceClient,
        profileHref
    ]);
    const fetchData = (0, $cozmU.useCallback)(async ()=>{
        setIsLoading(true);
        try {
            const profileResult = await props.resourceClient.getRovoAgentProfile({
                type: 'identity',
                value: props.accountId
            }, fireEvent);
            const profileData = profileResult.restData;
            const creatorInfoProps = {
                creator_type: profileData?.creator_type,
                creator: profileData?.creator || undefined,
                authoringTeam: profileResult.aggData?.authoringTeam ?? undefined
            };
            const agentCreatorInfo = await getCreator(creatorInfoProps);
            setAgentData({
                ...profileData,
                creatorInfo: agentCreatorInfo
            });
        } catch (err) {
            if (err instanceof (0, $dSW04.AgentForbiddenError) && (0, $cXtTj.default).getExperimentValue('platform_editor_reduced_agent_profile_cards', 'isEnabled', false)) setIsPermitted(false);
            else setError(err);
        } finally{
            setIsLoading(false);
        }
    }, [
        fireEvent,
        getCreator,
        props.accountId,
        props.resourceClient
    ]);
    // Depend on accountId rather than fetchData to avoid a re-fetch loop:
    // agentData changes → creatorUserId → getCreator → fetchData ref changes → useEffect re-fires.
    // Reset state on accountId change so stale data from the previous agent isn't briefly shown.
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $iDrrr.fg)('confluence_fix_agent_profile_card_flash')) return;
        setAgentData(undefined);
        setError(undefined);
        setIsLoading(true);
        fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        props.accountId
    ]);
    (0, $cozmU.useEffect)(()=>{
        if ((0, $iDrrr.fg)('confluence_fix_agent_profile_card_flash')) return;
        fetchData();
    }, [
        fetchData
    ]);
    const forbiddenAgent = (0, $cozmU.useMemo)(()=>(0, $iDrrr.fg)('platform_editor_agent_mentions_drop_one_fixes') ? {
            id: '',
            named_id: '',
            name: props.agentName ?? '',
            description: '\u00A0',
            creator_type: 'CUSTOMER',
            is_default: false,
            actor_type: 'AGENT',
            user_defined_conversation_starters: null,
            favourite: false,
            favourite_count: 0,
            identity_account_id: props.accountId,
            creatorInfo: undefined
        } : undefined, [
        props.agentName,
        props.accountId
    ]);
    if (!isPermitted && (0, $cXtTj.default).getExperimentValue('platform_editor_reduced_agent_profile_cards', 'isEnabled', false)) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kb2tZ.AgentProfileCardWrapper), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
            fallback: null,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hIwXM.AgentProfileCardLazy), {
                agent: (0, $iDrrr.fg)('platform_editor_agent_mentions_drop_one_fixes') ? forbiddenAgent : {
                    id: '',
                    named_id: '',
                    name: props.agentName ?? '',
                    description: '\u00A0',
                    creator_type: 'CUSTOMER',
                    is_default: false,
                    actor_type: 'AGENT',
                    user_defined_conversation_starters: null,
                    favourite: false,
                    favourite_count: 0,
                    identity_account_id: props.accountId,
                    creatorInfo: undefined
                },
                isLoading: false,
                resourceClient: props.resourceClient,
                cloudId: props.cloudId,
                hideAgentActions: true,
                hideConversationStarters: true,
                hideAiDisclaimer: true,
                hideStarButton: props.hideStarButton,
                showCreatorNameWithoutLink: props.showCreatorNameWithoutLink,
                footerComponent: props.footerComponent
            })
        })
    });
    if (error || !isLoading && !agentData) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kb2tZ.AgentProfileCardWrapper), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4k5Wq.default), {
            reload: ()=>{
                fetchData();
            },
            errorType: error || null,
            fireAnalytics: fireEvent
        })
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hIwXM.AgentProfileCardLazy), {
            agent: agentData,
            isLoading: isLoading,
            hasError: !!error,
            onConversationStartersClick: props.onConversationStartersClick,
            onChatClick: props.onChatClick,
            addFlag: props.addFlag,
            resourceClient: props.resourceClient,
            cloudId: props.cloudId,
            onDeleteAgent: props.onDeleteAgent,
            hideMoreActions: props.hideMoreActions,
            hideAiDisclaimer: props.hideAiDisclaimer,
            hideConversationStarters: props.hideConversationStarters,
            hideAgentActions: props.hideAgentActions,
            hideStarButton: props.hideStarButton,
            showCreatorNameWithoutLink: props.showCreatorNameWithoutLink,
            footerComponent: props.footerComponent
        })
    });
};
module.exports["AgentProfileCardResourced"] = $fe1c8bc12e81e628$export$4b013ffffcb40af8;

});

parcelRegister("7G50J", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $I7hWB = parcelRequire("I7hWB");


var $i1t43 = parcelRequire("i1t43");


var $etoPX = parcelRequire("etoPX");


var $NlHoa = parcelRequire("NlHoa");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");


var $a9aSv = parcelRequire("a9aSv");


var $ieeJu = parcelRequire("ieeJu");


var $lpNn5 = parcelRequire("lpNn5");


var $6h4xM = parcelRequire("6h4xM");


var $i4kCF = parcelRequire("i4kCF");


var $hq9Cp = parcelRequire("hq9Cp");


var $fNIRw = parcelRequire("fNIRw");

const $f5fec235121c7193$var$styles = {
    clickableItem: "_2mHwu81Y8M _3iDTPbQ4SZ _0hPCNLDIqT",
    rovoIconWrapper: "_3iDTPbQ4SZ",
    name: "_37wbyuI7V3 _0hPCNLchRC",
    description: "_3SamIHPgdg _3zvHkHdC7N _3W2Oc8wPeg",
    headingWrapper: "_1mT5xdRAKS",
    hiddenIconWrapper: "_313842FQfX"
};
const $f5fec235121c7193$export$7cbebf266a9bcc3c = ({ creatorType: creatorType, authoringTeam: authoringTeam, userCreator: userCreator, forgeCreator: forgeCreator })=>{
    if (creatorType === 'SYSTEM') return {
        type: 'SYSTEM'
    };
    if ((0, $iDrrr.fg)('rovo_agent_support_a2a_avatar') ? (0, $hq9Cp.isForgeAgentByCreatorType)(creatorType) : creatorType === 'FORGE' || creatorType === 'THIRD_PARTY' // THIRD_PARTY is deprecated in convo-ai, use FORGE instead
    ) return {
        // @todo: remove cast in rovo_agent_support_a2a_avatar cleanup
        type: (0, $iDrrr.fg)('jira_improve_agent_profile_for_a2a') ? creatorType : 'FORGE',
        name: forgeCreator ?? ''
    };
    if (creatorType === 'OOTB') return {
        type: 'OOTB'
    };
    if (creatorType === 'CUSTOMER') {
        if (authoringTeam) return {
            type: 'CUSTOMER',
            name: authoringTeam.displayName,
            profileLink: authoringTeam.profileLink ?? ''
        };
        if (!userCreator?.profileLink) return undefined;
        return {
            type: 'CUSTOMER',
            name: userCreator.name,
            profileLink: userCreator.profileLink,
            status: userCreator.status
        };
    }
    return;
};
const $f5fec235121c7193$export$f35b2eeaa7e3db15 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { creator: creator, onCreatorLinkClick: onCreatorLinkClick, isLoading: isLoading, showCreatorNameWithoutLink: t1 } = t0;
    const showCreatorNameWithoutLink = t1 === undefined ? false : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== creator || $[1] !== formatMessage || $[2] !== isLoading || $[3] !== onCreatorLinkClick || $[4] !== showCreatorNameWithoutLink) {
        const getCreatorRender = ()=>{
            if (isLoading) return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
                creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
                    testId: "agent-profile-creator-skeleton",
                    isShimmering: true,
                    height: 18,
                    width: 100
                })
            });
            if (!creator) return null;
            if (creator.type === "SYSTEM" || creator.type === "OOTB") return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
                creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                    alignBlock: "center",
                    testId: "atlassian-icon"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $NlHoa.AtlassianIcon), {
                    label: "",
                    size: "small",
                    appearance: "brand"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, "Atlassian"))
            });
            if (creator.type === "CUSTOMER") {
                const creatorName = `${creator.name} ${creator.status === "inactive" ? formatMessage((0, $fNIRw.messages).agentDeactivated) : ""}`;
                return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
                    creatorNameWithLink: showCreatorNameWithoutLink ? creatorName : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                        href: creator.profileLink,
                        onClick: ()=>onCreatorLinkClick(),
                        target: "_blank"
                    }, creatorName)
                });
            }
            if (creator.type === "REMOTE_A2A") return formatMessage((0, $fNIRw.messages).remoteAgentCreatedBy, {
                creatorNameWithLink: creator.name
            });
            if (creator.type === "THIRD_PARTY" || creator.type === "FORGE") return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
                creatorNameWithLink: creator.name
            });
            return null;
        };
        t2 = getCreatorRender();
        $[0] = creator;
        $[1] = formatMessage;
        $[2] = isLoading;
        $[3] = onCreatorLinkClick;
        $[4] = showCreatorNameWithoutLink;
        $[5] = t2;
    } else t2 = $[5];
    const creatorRender = t2;
    let t3;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $ieeJu.expValEquals)("platform_editor_agent_mentions", "isEnabled", true) && (0, $iDrrr.fg)("platform_editor_agent_mentions_drop_one_fixes") || (0, $iDrrr.fg)("platform_editor_agent_card_fixes");
        $[6] = t3;
    } else t3 = $[6];
    const hideCreatorIcon = t3;
    if ((0, $iDrrr.fg)("jira_improve_agent_profile_for_a2a")) {
        const showRovoIcon = !hideCreatorIcon && creator?.type !== "REMOTE_A2A";
        let t4;
        if ($[7] !== creatorRender || $[8] !== showRovoIcon) {
            t4 = creatorRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $f5fec235121c7193$var$styles.clickableItem
            }, showRovoIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $f5fec235121c7193$var$styles.rovoIconWrapper,
                testId: "rovo-icon-wrapper",
                "aria-hidden": "true"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $etoPX.RovoIcon), {
                appearance: "brand",
                size: "small"
            })) : null, creatorRender) : null;
            $[7] = creatorRender;
            $[8] = showRovoIcon;
            $[9] = t4;
        } else t4 = $[9];
        return t4;
    }
    let t4;
    if ($[10] !== creatorRender) {
        t4 = creatorRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.clickableItem
        }, !hideCreatorIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.rovoIconWrapper,
            testId: "rovo-icon-wrapper",
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $etoPX.RovoIcon), {
            appearance: "brand",
            size: "small"
        })), creatorRender) : null;
        $[10] = creatorRender;
        $[11] = t4;
    } else t4 = $[11];
    return t4;
} : ({ creator: creator, onCreatorLinkClick: onCreatorLinkClick, isLoading: isLoading, showCreatorNameWithoutLink: showCreatorNameWithoutLink = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const getCreatorRender = ()=>{
        if (isLoading) return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
            creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
                testId: "agent-profile-creator-skeleton",
                isShimmering: true,
                height: 18,
                width: 100
            })
        });
        if (!creator) return null;
        if (creator.type === 'SYSTEM' || creator.type === 'OOTB') return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
            creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                alignBlock: "center",
                testId: "atlassian-icon"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $NlHoa.AtlassianIcon), {
                label: "",
                size: "small",
                appearance: "brand"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, "Atlassian"))
        });
        if (creator.type === 'CUSTOMER') {
            const creatorName = `${creator.name} ${creator.status === 'inactive' ? formatMessage((0, $fNIRw.messages).agentDeactivated) : ''}`;
            return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
                creatorNameWithLink: showCreatorNameWithoutLink ? creatorName : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                    href: creator.profileLink,
                    onClick: ()=>onCreatorLinkClick(),
                    target: "_blank"
                }, creatorName)
            });
        }
        if (creator.type === 'REMOTE_A2A') return formatMessage((0, $fNIRw.messages).remoteAgentCreatedBy, {
            creatorNameWithLink: creator.name
        });
         // THIRD_PARTY is deprecated in convo-ai, use FORGE instead
        if (creator.type === 'THIRD_PARTY' || creator.type === 'FORGE') return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
            creatorNameWithLink: creator.name
        });
        return null;
    };
    const creatorRender = getCreatorRender();
    const hideCreatorIcon = (0, $ieeJu.expValEquals)('platform_editor_agent_mentions', 'isEnabled', true) && (0, $iDrrr.fg)('platform_editor_agent_mentions_drop_one_fixes') || (0, $iDrrr.fg)('platform_editor_agent_card_fixes');
    if ((0, $iDrrr.fg)('jira_improve_agent_profile_for_a2a')) {
        const showRovoIcon = !hideCreatorIcon && creator?.type !== 'REMOTE_A2A';
        return creatorRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.clickableItem
        }, showRovoIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.rovoIconWrapper,
            testId: "rovo-icon-wrapper",
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $etoPX.RovoIcon), {
            appearance: "brand",
            size: "small"
        })) : null, creatorRender) : null;
    }
    return creatorRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f5fec235121c7193$var$styles.clickableItem
    }, !hideCreatorIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f5fec235121c7193$var$styles.rovoIconWrapper,
        testId: "rovo-icon-wrapper",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $etoPX.RovoIcon), {
        appearance: "brand",
        size: "small"
    })), creatorRender) : null;
};
const $f5fec235121c7193$export$e02348ba0b01a210 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { agentName: agentName, agentDescription: agentDescription, creatorRender: creatorRender, starCountRender: starCountRender, headingRender: headingRender, isStarred: isStarred, isHidden: isHidden, onStarToggle: onStarToggle, showStarButton: t1, renderAdditionalContent: renderAdditionalContent } = t0;
    const showStarButton = t1 === undefined ? true : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== agentName) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            as: "h2",
            size: "medium"
        }, agentName);
        $[0] = agentName;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== formatMessage || $[3] !== isHidden) {
        t3 = isHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.hiddenIconWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: formatMessage((0, $fNIRw.messages).hiddenTooltip),
            position: "top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6h4xM.HiddenIcon), {
            label: formatMessage((0, $fNIRw.messages).hiddenIcon)
        })));
        $[2] = formatMessage;
        $[3] = isHidden;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== headingRender || $[6] !== t2 || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.075",
            xcss: $f5fec235121c7193$var$styles.headingWrapper
        }, t2, headingRender, t3);
        $[5] = headingRender;
        $[6] = t2;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== agentName || $[10] !== isStarred || $[11] !== onStarToggle || $[12] !== showStarButton) {
        t5 = showStarButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i4kCF.StarIconButton), {
            isStarred: isStarred,
            handleToggle: onStarToggle,
            agentName: agentName
        });
        $[9] = agentName;
        $[10] = isStarred;
        $[11] = onStarToggle;
        $[12] = showStarButton;
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== t4 || $[15] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $f5fec235121c7193$var$styles.name,
            space: "space.100",
            alignBlock: "center"
        }, t4, t5);
        $[14] = t4;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    let t7;
    if ($[17] !== agentDescription) {
        t7 = !!agentDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.description,
            as: "p"
        }, agentDescription);
        $[17] = agentDescription;
        $[18] = t7;
    } else t7 = $[18];
    let t8;
    if ($[19] !== renderAdditionalContent) {
        t8 = !!renderAdditionalContent && renderAdditionalContent();
        $[19] = renderAdditionalContent;
        $[20] = t8;
    } else t8 = $[20];
    let t9;
    if ($[21] !== creatorRender || $[22] !== starCountRender || $[23] !== t6 || $[24] !== t7 || $[25] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, t6, creatorRender, t7, starCountRender, t8);
        $[21] = creatorRender;
        $[22] = starCountRender;
        $[23] = t6;
        $[24] = t7;
        $[25] = t8;
        $[26] = t9;
    } else t9 = $[26];
    return t9;
} : ({ agentName: agentName, agentDescription: agentDescription, creatorRender: creatorRender, starCountRender: starCountRender, headingRender: headingRender, isStarred: isStarred, isHidden: isHidden, onStarToggle: onStarToggle, showStarButton: showStarButton = true, renderAdditionalContent: renderAdditionalContent })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $f5fec235121c7193$var$styles.name,
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.075",
        xcss: $f5fec235121c7193$var$styles.headingWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        as: "h2",
        size: "medium"
    }, agentName), headingRender, isHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f5fec235121c7193$var$styles.hiddenIconWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: formatMessage((0, $fNIRw.messages).hiddenTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6h4xM.HiddenIcon), {
        label: formatMessage((0, $fNIRw.messages).hiddenIcon)
    })))), showStarButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i4kCF.StarIconButton), {
        isStarred: isStarred,
        handleToggle: onStarToggle,
        agentName: agentName
    })), creatorRender, !!agentDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f5fec235121c7193$var$styles.description,
        as: "p"
    }, agentDescription), starCountRender, !!renderAdditionalContent && renderAdditionalContent());
};
module.exports["getAgentCreator"] = $f5fec235121c7193$export$7cbebf266a9bcc3c;
module.exports["AgentProfileCreator"] = $f5fec235121c7193$export$f35b2eeaa7e3db15;
module.exports["AgentProfileInfo"] = $f5fec235121c7193$export$e02348ba0b01a210;

});

parcelRegister("6h4xM", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bsSbN = parcelRequire("bsSbN");

const $fc7d462f5dd0deaa$export$bce21421c351deb1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bsSbN))), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bsSbN))), props);
module.exports["HiddenIcon"] = $fc7d462f5dd0deaa$export$bce21421c351deb1;

});

parcelRegister("i4kCF", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $w6R6I = parcelRequire("w6R6I");


var $6Cex3 = parcelRequire("6Cex3");


var $lbT4j = parcelRequire("lbT4j");


var $iMnC5 = parcelRequire("iMnC5");


var $4ssVW = parcelRequire("4ssVW");

const $fbe2d7b3097e2d22$var$styles = {
    hidden: "_1YKVNsdnbC"
};
const $fbe2d7b3097e2d22$export$703abb8bd2abdfa5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { isStarred: isStarred, handleToggle: handleToggle, visible: t1, agentName: agentName } = t0;
    const visible = t1 === undefined ? true : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const t2 = !visible && $fbe2d7b3097e2d22$var$styles.hidden;
    let t3;
    if ($[0] !== t2) {
        t3 = (0, $w6R6I.cx)(t2);
        $[0] = t2;
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] !== isHovered || $[3] !== isStarred) {
        t4 = (iconProps)=>isStarred || isHovered ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Cex3))), {
                ...iconProps,
                color: "var(--ds-icon-accent-orange, #E06C00)"
            }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbT4j))), {
                ...iconProps,
                color: "var(--ds-icon, #292A2E)"
            });
        $[2] = isHovered;
        $[3] = isStarred;
        $[4] = t4;
    } else t4 = $[4];
    const t5 = isStarred ? (0, $4ssVW.default).removeFromFavouritesLabel : (0, $4ssVW.default).clickToFavouriteLabel;
    let t6;
    if ($[5] !== agentName || $[6] !== formatMessage || $[7] !== t5) {
        t6 = formatMessage(t5, {
            agentName: agentName
        });
        $[5] = agentName;
        $[6] = formatMessage;
        $[7] = t5;
        $[8] = t6;
    } else t6 = $[8];
    let t7;
    let t8;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = ()=>setIsHovered(true);
        t8 = ()=>setIsHovered(false);
        $[9] = t7;
        $[10] = t8;
    } else {
        t7 = $[9];
        t8 = $[10];
    }
    let t9;
    if ($[11] !== handleToggle || $[12] !== t4 || $[13] !== t6) {
        t9 = /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
            appearance: "subtle",
            spacing: "compact",
            icon: t4,
            label: t6,
            onClick: handleToggle,
            onMouseEnter: t7,
            onMouseLeave: t8
        });
        $[11] = handleToggle;
        $[12] = t4;
        $[13] = t6;
        $[14] = t9;
    } else t9 = $[14];
    let t10;
    if ($[15] !== t3 || $[16] !== t9) {
        t10 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: t3
        }, t9);
        $[15] = t3;
        $[16] = t9;
        $[17] = t10;
    } else t10 = $[17];
    return t10;
} : ({ isStarred: isStarred, handleToggle: handleToggle, visible: visible = true, agentName: agentName })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)(!visible && $fbe2d7b3097e2d22$var$styles.hidden)
    }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        appearance: "subtle",
        spacing: "compact",
        icon: (iconProps)=>isStarred || isHovered ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Cex3))), {
                ...iconProps,
                color: "var(--ds-icon-accent-orange, #E06C00)"
            }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbT4j))), {
                ...iconProps,
                color: "var(--ds-icon, #292A2E)"
            }),
        label: formatMessage(isStarred ? (0, $4ssVW.default).removeFromFavouritesLabel : (0, $4ssVW.default).clickToFavouriteLabel, {
            agentName: agentName
        }),
        onClick: handleToggle,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false)
    }));
};
module.exports["StarIconButton"] = $fbe2d7b3097e2d22$export$703abb8bd2abdfa5;

});

parcelRegister("4ssVW", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $a47d9a7d981bdb91$var$message = (0, $kSwu1.defineMessages)({
    removeFromFavouritesLabel: {
        id: "rovo-chat.browse-agents.remove-from-favourites-label",
        defaultMessage: "Remove {agentName} from favourites"
    },
    clickToFavouriteLabel: {
        id: "rovo-chat.browse-agents.click-to-favourite-label",
        defaultMessage: "Add {agentName} to favourites"
    }
});
var $a47d9a7d981bdb91$export$2e2bcd8739ae039 = $a47d9a7d981bdb91$var$message;
module.exports["default"] = $a47d9a7d981bdb91$export$2e2bcd8739ae039;

});

parcelRegister("hq9Cp", function(module, exports) {
const $84118747f7725463$export$3055eac4de8cbd2b = (creatorType)=>creatorType === 'THIRD_PARTY' || creatorType === 'FORGE' || creatorType === 'REMOTE_A2A';
module.exports["isForgeAgentByCreatorType"] = $84118747f7725463$export$3055eac4de8cbd2b;

});

parcelRegister("fNIRw", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $246a354bdf98d3ad$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    agentCreatedBy: {
        id: "ai-mate.agent-profile-info.created-by",
        defaultMessage: "Rovo Agent by {creatorNameWithLink}"
    },
    remoteAgentCreatedBy: {
        id: "ai-mate.agent-profile-info.agent-by",
        defaultMessage: "Agent by {creatorNameWithLink}"
    },
    agentDeactivated: {
        id: "ai-mate.agent-profile-info.deactivated",
        defaultMessage: "(deactivated)"
    },
    starredCount: {
        id: "ai-mate.agent-profile-info.starred-count",
        defaultMessage: "{count} starred"
    },
    hiddenIcon: {
        id: "ai-mate.agent-profile-info.hidden-icon",
        defaultMessage: "Hidden"
    },
    hiddenTooltip: {
        id: "ai-mate.agent-profile-info.hidden-tooltip",
        defaultMessage: "Agent won't show in search results"
    },
    starAgentTooltip: {
        id: "ai-mate.agent-profile-info.star-agent-tooltip",
        defaultMessage: "Star Agent"
    },
    creatorLabel: {
        id: "ai-mate.agent-profile-info.creator",
        defaultMessage: "Creator"
    }
});
module.exports["messages"] = $246a354bdf98d3ad$export$defe85febe8b728c;

});

parcelRegister("dSW04", function(module, exports) {
class $99c5d70c0df67415$export$a6d78d75d03919f1 extends Error {
    constructor(){
        super('Agent access forbidden');
        this.status = 403;
        this.name = 'AgentForbiddenError';
    }
}
module.exports["AgentForbiddenError"] = $99c5d70c0df67415$export$a6d78d75d03919f1;

});

parcelRegister("dRAjC", function(module, exports) {
const $d2643a1af3062f27$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $d2643a1af3062f27$export$3761e66a04602cbd = (ari)=>{
    return ari.replace($d2643a1af3062f27$export$470b0d72e4fdc43a, '');
};
module.exports["USER_ARI_PREFIX"] = $d2643a1af3062f27$export$470b0d72e4fdc43a;
module.exports["getAAIDFromARI"] = $d2643a1af3062f27$export$3761e66a04602cbd;

});

parcelRegister("4k5Wq", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $5avUB = parcelRequire("5avUB");


var $4aRua = parcelRequire("4aRua");


var $eU2tf = parcelRequire("eU2tf");


var $hHYlx = parcelRequire("hHYlx");


var $cSSWJ = parcelRequire("cSSWJ");

const $0f12e30f7425acf6$var$ErrorMessage = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(18);
    let t0;
    if ($[0] !== props.errorType) {
        t0 = props.errorType || {
            reason: "default"
        };
        $[0] = props.errorType;
        $[1] = t0;
    } else t0 = $[1];
    const errorType = t0;
    const errorReason = errorType.reason;
    const { fireAnalytics: fireAnalytics, reload: reload } = props;
    const hasRetry = !!reload;
    let t1;
    let t2;
    if ($[2] !== errorReason || $[3] !== fireAnalytics || $[4] !== hasRetry) {
        t1 = ()=>{
            fireAnalytics("ui.profilecard.rendered.error", {
                hasRetry: hasRetry,
                errorType: errorReason,
                firedAt: Math.round(performance.now()),
                ...(0, $cSSWJ.PACKAGE_META_DATA)
            });
        };
        t2 = [
            errorReason,
            fireAnalytics,
            hasRetry
        ];
        $[2] = errorReason;
        $[3] = fireAnalytics;
        $[4] = hasRetry;
        $[5] = t1;
        $[6] = t2;
    } else {
        t1 = $[5];
        t2 = $[6];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[7] !== errorReason || $[8] !== reload) {
        t3 = ()=>{
            if (errorReason === "NotFound") return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hHYlx.ErrorTitle), {
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                    ...(0, $eU2tf.default).errorUserNotFound
                })
            });
            return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hHYlx.ErrorTitle), {
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                        ...(0, $eU2tf.default).errorGeneric
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("br", {}),
                    reload && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        color: "color.text.subtlest",
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                            ...(0, $eU2tf.default).errorRetrySuggestion
                        })
                    })
                ]
            });
        };
        $[7] = errorReason;
        $[8] = reload;
        $[9] = t3;
    } else t3 = $[9];
    const errorContent = t3;
    let t4;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
            label: "icon error"
        });
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== errorContent) {
        t5 = errorContent();
        $[11] = errorContent;
        $[12] = t5;
    } else t5 = $[12];
    let t6;
    if ($[13] !== reload) {
        t6 = reload && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
            onClick: reload,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                ...(0, $eU2tf.default).errorTryAgain
            })
        });
        $[13] = reload;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== t5 || $[16] !== t6) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hHYlx.ErrorWrapper), {
            testId: "profilecard-error",
            children: [
                t4,
                t5,
                t6
            ]
        });
        $[15] = t5;
        $[16] = t6;
        $[17] = t7;
    } else t7 = $[17];
    return t7;
} : (props)=>{
    const errorType = props.errorType || {
        reason: 'default'
    };
    const errorReason = errorType.reason;
    const { fireAnalytics: fireAnalytics, reload: reload } = props;
    const hasRetry = !!reload;
    (0, $cozmU.useEffect)(()=>{
        fireAnalytics('ui.profilecard.rendered.error', {
            hasRetry: hasRetry,
            errorType: errorReason,
            firedAt: Math.round(performance.now()),
            ...(0, $cSSWJ.PACKAGE_META_DATA)
        });
    }, [
        errorReason,
        fireAnalytics,
        hasRetry
    ]);
    const errorContent = ()=>{
        if (errorReason === 'NotFound') return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hHYlx.ErrorTitle), {
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                ...(0, $eU2tf.default).errorUserNotFound
            })
        });
        return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hHYlx.ErrorTitle), {
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                    ...(0, $eU2tf.default).errorGeneric
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("br", {}),
                reload && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                    color: "color.text.subtlest",
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                        ...(0, $eU2tf.default).errorRetrySuggestion
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hHYlx.ErrorWrapper), {
        testId: "profilecard-error",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
                label: "icon error"
            }),
            errorContent(),
            reload && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                onClick: reload,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                    ...(0, $eU2tf.default).errorTryAgain
                })
            })
        ]
    });
};
var $0f12e30f7425acf6$export$2e2bcd8739ae039 = $0f12e30f7425acf6$var$ErrorMessage;
module.exports["default"] = $0f12e30f7425acf6$export$2e2bcd8739ae039;

});

parcelRegister("eU2tf", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $fe57f9d19e98fdc0$var$messages = (0, $kSwu1.defineMessages)({
    inactiveAccountMsg: {
        id: "pt.profile-card.inactive.account",
        defaultMessage: "Account deactivated"
    },
    generalDescMsgForDisabledUser: {
        id: "pt.profile-card.general.msg.disabled.user",
        defaultMessage: "You can no longer collaborate with this person."
    },
    inactiveAccountDescMsgNoDate: {
        id: "pt.profile-card.inactive.account.no.date",
        defaultMessage: "Their account has been deactivated."
    },
    inactiveAccountDescMsgHasDateThisWeek: {
        id: "pt.profile-card.inactive.account.has.date.this.week",
        defaultMessage: "Their account was deactivated this week."
    },
    inactiveAccountDescMsgHasDateThisMonth: {
        id: "pt.profile-card.inactive.account.has.date.this.month",
        defaultMessage: "Their account was deactivated this month."
    },
    inactiveAccountDescMsgHasDateLastMonth: {
        id: "pt.profile-card.inactive.account.has.date.last.month",
        defaultMessage: "Their account was deactivated last month."
    },
    inactiveAccountDescMsgHasDateAFewMonths: {
        id: "pt.profile-card.inactive.account.has.date.a.few.months",
        defaultMessage: "Their account has been deactivated for a few months."
    },
    inactiveAccountDescMsgHasDateSeveralMonths: {
        id: "pt.profile-card.inactive.account.has.date.several.months",
        defaultMessage: "Their account has been deactivated for several months."
    },
    inactiveAccountDescMsgHasDateMoreThanAYear: {
        id: "pt.profile-card.inactive.account.has.date.more.than.a.year",
        defaultMessage: "Their account has been deactivated for more than a year."
    },
    closedAccountMsg: {
        id: "pt.profile-card.closed.account",
        defaultMessage: "Account deleted"
    },
    closedAccountDescMsgNoDate: {
        id: "pt.profile-card.closed.account.no.date",
        defaultMessage: "Their account has been deleted."
    },
    closedAccountDescMsgHasDateThisWeek: {
        id: "pt.profile-card.closed.account.has.date.this.week",
        defaultMessage: "Their account was deleted this week."
    },
    closedAccountDescMsgHasDateThisMonth: {
        id: "pt.profile-card.closed.account.has.date.this.month",
        defaultMessage: "Their account was deleted this month."
    },
    closedAccountDescMsgHasDateLastMonth: {
        id: "pt.profile-card.closed.account.has.date.last.month",
        defaultMessage: "Their account was deleted last month."
    },
    closedAccountDescMsgHasDateAFewMonths: {
        id: "pt.profile-card.closed.account.has.date.a.few.months",
        defaultMessage: "Their account has been deleted for a few months."
    },
    closedAccountDescMsgHasDateSeveralMonths: {
        id: "pt.profile-card.closed.account.has.date.several.months",
        defaultMessage: "Their account has been deleted for several months."
    },
    closedAccountDescMsgHasDateMoreThanAYear: {
        id: "pt.profile-card.closed.account.has.date.more.than.a.year",
        defaultMessage: "Their account has been deleted for more than a year."
    },
    disabledAccountDefaultName: {
        id: "pt.profile-card.disabled.account.default.name",
        defaultMessage: "Former user"
    },
    teamViewProfile: {
        id: "pt.team-profile-card.team.action.view-profile",
        defaultMessage: "View profile"
    },
    memberCount: {
        id: "pt.team-profile-card.team.member.count",
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}"
    },
    memberCountIncludingYou: {
        id: "pt.team-profile-card.team.member.count-including-you",
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you"
    },
    membersMoreThan50: {
        id: "pt.team-profile-card.team.member.many",
        defaultMessage: "Team \u2022 50+ members"
    },
    membersMoreThan50IncludingYou: {
        id: "pt.team-profile-card.team.member.many-including-you",
        defaultMessage: "Team \u2022 50+ members, including you"
    },
    teamErrorTitle: {
        id: "pt.team-profile-card.error.title",
        defaultMessage: "We\u2019re having trouble retrieving this teams information"
    },
    teamErrorText: {
        id: "pt.team-profile-card.error.suggestion",
        defaultMessage: "Wait a few moments, then try again."
    },
    teamErrorButton: {
        id: "pt.team-profile-card.error.refresh-button",
        defaultMessage: "Try again"
    },
    teamForbiddenErrorStateTitle: {
        id: "pt.team-profile-card.forbidden-error-state.title",
        defaultMessage: "We can\u2019t show you this team"
    },
    teamForbiddenErrorStateDescription: {
        id: "pt.team-profile-card.forbidden-error-state.description",
        defaultMessage: "You don\u2019t have access to view this team."
    },
    managerSectionHeading: {
        id: "pt.team-profile-card.manager.heading",
        defaultMessage: "Manager"
    },
    directReportsSectionHeading: {
        id: "pt.team-profile-card.directReports.heading",
        defaultMessage: "Direct reports"
    },
    teamProfileCardAriaLabel: {
        id: "pt.team-profile-card.aria-label",
        defaultMessage: "More information about this team"
    },
    giveKudosButton: {
        id: "pt.profile-card.give-kudos",
        defaultMessage: "Give kudos"
    },
    // Remove this as part of the FG Cleanup for jfp_a11y_team_profile_card_actions_label
    profileCardMoreIconLabel: {
        id: "pt.profile-card.more-icon-label",
        defaultMessage: "More"
    },
    profileCardMoreIconLabelWithName: {
        id: "pt.profile-card.more-icon-label-with-name",
        defaultMessage: "More actions for {fullName}"
    },
    profileCardMoreReportingLinesLabel: {
        id: "pt.user-profile-card.reporting-lines.more-icon-label",
        defaultMessage: "+{count} more {count, plural, one {profile} other {profiles}}"
    },
    profileCardMoreMembersLabel: {
        id: "pt.team.profile-card.members.more-icon-label",
        defaultMessage: "+{count} more {count, plural, one {members} other {members}}"
    },
    archivedLozenge: {
        id: "pt.team-profile-card.archived-lozenge",
        defaultMessage: "Archived"
    },
    errorUserNotFound: {
        id: "pt.profile-card.error.user-not-found",
        defaultMessage: "The user is no longer available for the site"
    },
    errorGeneric: {
        id: "pt.profile-card.error.generic",
        defaultMessage: "Oops, looks like we\u2019re having issues"
    },
    errorRetrySuggestion: {
        id: "pt.profile-card.error.retry-suggestion",
        defaultMessage: "Try again and we\u2019ll give it another shot"
    },
    errorTryAgain: {
        id: "pt.profile-card.error.try-again-button",
        defaultMessage: "Try again"
    },
    errorDialogLabel: {
        id: "pt.profile-card.error.dialog-label",
        defaultMessage: "Profile card error"
    },
    loadingDialogLabel: {
        id: "pt.profile-card.loading.dialog-label",
        defaultMessage: "Loading profile card"
    },
    serviceAccountLabel: {
        id: "pt.profile-card.service-account.label",
        defaultMessage: "SERVICE ACCOUNT"
    },
    botAccountLabel: {
        id: "pt.profile-card.bot-account.label",
        defaultMessage: "APP"
    },
    viewManagerProfile: {
        id: "pt.profile-card.view-manager-profile",
        defaultMessage: "View {name} profile"
    }
});
var $fe57f9d19e98fdc0$export$2e2bcd8739ae039 = $fe57f9d19e98fdc0$var$messages;
module.exports["default"] = $fe57f9d19e98fdc0$export$2e2bcd8739ae039;

});

parcelRegister("hHYlx", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");

const $3b2daa1fed2d9894$var$styles = {
    errorWrapper: "_2fwxA5DIqT _0Of8r2NHnM _1ZnuxbNHnM _1wydGWNHnM _2Zuz6QNHnM",
    errorTitle: "_3138422ADO",
    teamErrorText: "_1UtDYzKGUX _3138422ADO"
};
const $3b2daa1fed2d9894$export$bb27b7e39840238f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $w6R6I.cx)($3b2daa1fed2d9894$var$styles.errorWrapper);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: t0,
            ...props
        });
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($3b2daa1fed2d9894$var$styles.errorWrapper),
        ...props
    });
const $3b2daa1fed2d9894$export$b065fd053267ec81 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props.children) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $3b2daa1fed2d9894$var$styles.errorTitle,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                color: "color.text",
                children: props.children
            })
        });
        $[0] = props.children;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $3b2daa1fed2d9894$var$styles.errorTitle,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
            color: "color.text",
            children: props.children
        })
    });
const $3b2daa1fed2d9894$export$90d92ccfb27352c6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $w6R6I.cx)($3b2daa1fed2d9894$var$styles.teamErrorText);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props.children) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: t0,
            children: props.children
        });
        $[1] = props.children;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($3b2daa1fed2d9894$var$styles.teamErrorText),
        children: props.children
    });
module.exports["ErrorWrapper"] = $3b2daa1fed2d9894$export$bb27b7e39840238f;
module.exports["ErrorTitle"] = $3b2daa1fed2d9894$export$b065fd053267ec81;

});

parcelRegister("kb2tZ", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $ieeJu = parcelRequire("ieeJu");

const $d107d3e886647d93$var$styles = {
    wrapper: "_0bjKvD8fU6 _39xV02wBC3 _0KLXruoI2d _2OUyjtGk8v",
    wrapperLegacy: "_0bjKvD8fU6 _39xV02wBC3 _0KLXruoI2d"
};
const $d107d3e886647d93$export$2c6604b50c274e6f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children } = t0;
    if ((0, $ieeJu.expValEquals)("platform_editor_agent_mentions", "isEnabled", true) && (0, $iDrrr.fg)("platform_editor_agent_mentions_drop_one_fixes") || (0, $iDrrr.fg)("platform_editor_agent_card_fixes")) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: $d107d3e886647d93$var$styles.wrapper,
                children: children
            });
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    let t1;
    if ($[2] !== children) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $d107d3e886647d93$var$styles.wrapperLegacy,
            children: children
        });
        $[2] = children;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ({ children: children })=>{
    if ((0, $ieeJu.expValEquals)('platform_editor_agent_mentions', 'isEnabled', true) && (0, $iDrrr.fg)('platform_editor_agent_mentions_drop_one_fixes') || (0, $iDrrr.fg)('platform_editor_agent_card_fixes')) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $d107d3e886647d93$var$styles.wrapper,
        children: children
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $d107d3e886647d93$var$styles.wrapperLegacy,
        children: children
    });
};
module.exports["AgentProfileCardWrapper"] = $d107d3e886647d93$export$2c6604b50c274e6f;

});

parcelRegister("hIwXM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $795534535f4e0b8b$export$ed0ca9c1d49ea0bf = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("gN4or")));
module.exports["AgentProfileCardLazy"] = $795534535f4e0b8b$export$ed0ca9c1d49ea0bf;

});

parcelRegister("gN4or", function(module, exports) {

let $c394a15c24dd8910$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c394a15c24dd8910$var$load("h0X0x"),
    $c394a15c24dd8910$var$load("7l4Nc"),
    $c394a15c24dd8910$var$load("6wr18"),
    $c394a15c24dd8910$var$load("iYJZz"),
    $c394a15c24dd8910$var$load("jqoep"),
    $c394a15c24dd8910$var$load("ea3NB"),
    $c394a15c24dd8910$var$load("ffEVr"),
    $c394a15c24dd8910$var$load("7EorR"),
    $c394a15c24dd8910$var$load("hhss7"),
    $c394a15c24dd8910$var$load("68aog")
]).then(()=>parcelRequire('ark00'));

});

parcelRegister("a2bT0", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ekCm6 = parcelRequire("ekCm6");


var $w6R6I = parcelRequire("w6R6I");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


const $86a4b05b54bce4ef$var$RefreshedCustomerInsightAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("iGZJA")));

const $86a4b05b54bce4ef$var$RefreshedBacklogBuddyAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("fP7cd")));

const $86a4b05b54bce4ef$var$RefreshedDecisionDirectorAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("isMen")));

const $86a4b05b54bce4ef$var$RefreshedCommsCrafterAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("3WrUa")));

const $86a4b05b54bce4ef$var$RefreshedAutoDevAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("4yA6G")));

const $86a4b05b54bce4ef$var$RefreshedOkrOracleAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("fEx6p")));

const $86a4b05b54bce4ef$var$RefreshedCultureAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("jaq6v")));

const $86a4b05b54bce4ef$var$RefreshedSocialMediaScribeAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("mEHH8")));

const $86a4b05b54bce4ef$var$RefreshedTeamConnectionAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("l64Lr")));

const $86a4b05b54bce4ef$var$RefreshedHireWriterAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("iBg9j")));

const $86a4b05b54bce4ef$var$RefreshedOpsAgentAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("aoj7n")));

const $86a4b05b54bce4ef$var$RefreshedResearchScoutAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("lnLxh")));

const $86a4b05b54bce4ef$var$RefreshedReleaseNotesAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("2nka8")));

const $86a4b05b54bce4ef$var$RefreshedMyUserManualAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("9UKCb")));

const $86a4b05b54bce4ef$var$RefreshedPitchPerfectorAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("23pjP")));

const $86a4b05b54bce4ef$var$RefreshedAutoFixAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("16ZJh")));

const $86a4b05b54bce4ef$var$RefreshedAutoReviewAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("hiE2p")));

const $86a4b05b54bce4ef$var$RefreshedMarketingMessageMaestroAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("hqvBW")));

const $86a4b05b54bce4ef$var$RefreshedFeatureFlagAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("9eCxF")));

const $86a4b05b54bce4ef$var$RefreshedProductRequirementAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("fewZY")));

const $86a4b05b54bce4ef$var$RefreshedJiraCodingAgentAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("bhJ1m")));

const $86a4b05b54bce4ef$var$RefreshedJiraIntelligentTriageAgentAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("9Y1Ze")));

const $86a4b05b54bce4ef$var$RefreshedJiraDeliveryAgentAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("2uslO")));

const $86a4b05b54bce4ef$var$RefreshedJiraAdminAgentAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("cNes1")));

const $86a4b05b54bce4ef$var$RefreshedRequestResolverAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("2NvtN")));

const $86a4b05b54bce4ef$var$RefreshedOpsExpertAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("kxFXt")));
const $86a4b05b54bce4ef$var$styles = {
    image: "_00EA0eiObl _0jFU0VN91d _39xV02N91d _3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT",
    banner: "_39xV02N91d",
    bannerFillSpace: "_39xV02N91d _0jFU0VN91d _00EA0eiObl",
    bannerRemoteA2A: "_0KLXruG6qS"
};
const $86a4b05b54bce4ef$var$Observer = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { onLoad: onLoad } = t0;
    let t1;
    let t2;
    if ($[0] !== onLoad) {
        t1 = ()=>{
            onLoad();
        };
        t2 = [
            onLoad
        ];
        $[0] = onLoad;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
} : ({ onLoad: onLoad })=>{
    (0, $cozmU.useEffect)(()=>{
        onLoad();
    }, [
        onLoad
    ]);
    return null;
};

const $86a4b05b54bce4ef$var$AutoDevAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("kYpKY")));

const $86a4b05b54bce4ef$var$AutoFixAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("feg39")));

const $86a4b05b54bce4ef$var$AutoReviewAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("4RJuR")));

const $86a4b05b54bce4ef$var$BacklogBuddyAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("di1lo")));

const $86a4b05b54bce4ef$var$CommsCrafterAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("j5vOg")));

const $86a4b05b54bce4ef$var$CultureAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("ir4Zs")));

const $86a4b05b54bce4ef$var$CustomerInsightAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("huaWP")));

const $86a4b05b54bce4ef$var$DecisionDirectorAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("e7aux")));

const $86a4b05b54bce4ef$var$DocumentWriterAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("gWtbL")));

const $86a4b05b54bce4ef$var$FeatureFlagAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("ef6sM")));

const $86a4b05b54bce4ef$var$GenericAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("eMArC")));

const $86a4b05b54bce4ef$var$HireWriterAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("lLIpI")));

const $86a4b05b54bce4ef$var$MarketingMessageMaestroAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("guf1O")));

const $86a4b05b54bce4ef$var$MyUserManualAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("fqQ0Z")));

const $86a4b05b54bce4ef$var$OkrOracleAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("g5Au7")));

const $86a4b05b54bce4ef$var$OpsAgentAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("jduPc")));

const $86a4b05b54bce4ef$var$PitchPerfectorAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("2BsbE")));

const $86a4b05b54bce4ef$var$ProductRequirementAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("ccwx8")));

const $86a4b05b54bce4ef$var$ReleaseNotesAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("kCYzi")));

const $86a4b05b54bce4ef$var$ResearchScoutAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("eGpCl")));

const $86a4b05b54bce4ef$var$RovoChatAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("fZHZI")));

const $86a4b05b54bce4ef$var$RovoDevAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("iLJ1v")));

const $86a4b05b54bce4ef$var$SocialMediaScribeAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("j6OuY")));

const $86a4b05b54bce4ef$var$TeamConnectionAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("ddq5w")));

const $86a4b05b54bce4ef$var$WorkflowBuilderAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("lnaW2")));

const $86a4b05b54bce4ef$var$TrialGuideAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("jMZdA")));

const $86a4b05b54bce4ef$var$JsmRovoServiceAgentAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("4Jhm3")));

const $86a4b05b54bce4ef$var$JsmRequestResolverAgentAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("e3WMy"))); /**
                                          * OOTB Agents avatars - start
                                          */ 

const $86a4b05b54bce4ef$var$AmplitudeAgentAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("1lG7v")));

const $86a4b05b54bce4ef$var$AmplitudeAgentAvatarV2 = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("l7BNW")));

const $86a4b05b54bce4ef$var$BoxAgentAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("cr6cT")));

const $86a4b05b54bce4ef$var$CanvaAgentAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("l39Ik")));

const $86a4b05b54bce4ef$var$FigmaAgentAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("eWJHH")));

const $86a4b05b54bce4ef$var$HubSpotAgentAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("hpLK5")));

const $86a4b05b54bce4ef$var$IntercomAgentAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("ceWMu")));

const $86a4b05b54bce4ef$var$GammaAgentAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("5BSGs")));

const $86a4b05b54bce4ef$var$LovableAgentAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("dU4PR")));

const $86a4b05b54bce4ef$var$ReplitAgentAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("4d0IW")));

const $86a4b05b54bce4ef$var$RovoAgentAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("7kGM2")));

const $86a4b05b54bce4ef$var$JiraWorkAgentAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("hNwBH")));

const $86a4b05b54bce4ef$var$JiraTaskPlannerAgentAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("356rB")));

const $86a4b05b54bce4ef$var$ContentReviewerAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("j37DR")));

const $86a4b05b54bce4ef$var$JiraCodingAgentAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("eYFGv")));

const $86a4b05b54bce4ef$var$JiraIntelligentTriageAgentAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("hUkXO")));

const $86a4b05b54bce4ef$var$JiraDeliveryAgentAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("f75bz")));

const $86a4b05b54bce4ef$var$JsmServiceTriageAgentAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("hXuuu"))); /**
                                        * OOTB Agents avatars - end
                                        */ 
const $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2 = {
    v1: {
        primary: '#FCA700',
        secondary: '#FFC716',
        cover: '#FEF7C8'
    },
    v2: {
        primary: '#FFC716',
        iconColor: '#101214',
        cover: '#FEF7C8'
    }
};
const $86a4b05b54bce4ef$export$3e344798f7855e62 = {
    v1: {
        primary: '#BF63F3',
        secondary: '#D8A0F7',
        cover: '#F8EEFE'
    },
    v2: {
        primary: '#C97CF4',
        iconColor: '#101214',
        cover: '#F8EEFE'
    }
};
const $86a4b05b54bce4ef$export$a3d0897f023251ae = {
    v1: {
        primary: '#82B536',
        secondary: '#B3DF72',
        cover: '#EFFFD6'
    },
    v2: {
        primary: '#94C748',
        iconColor: '#101214',
        cover: '#EFFFD6'
    }
};
const $86a4b05b54bce4ef$export$d933daaf7b69e6ee = {
    v1: {
        primary: '#357DE8',
        secondary: '#669DF1',
        cover: '#E9F2FE'
    },
    v2: {
        primary: '#1868DB',
        iconColor: '#FFFFFF',
        cover: '#E9F2FE'
    }
};
const $86a4b05b54bce4ef$var$colorList = [
    $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2,
    $86a4b05b54bce4ef$export$3e344798f7855e62,
    $86a4b05b54bce4ef$export$a3d0897f023251ae,
    $86a4b05b54bce4ef$export$d933daaf7b69e6ee
]; /**
                                                                      * NOTE: DO NOT ADD OOTB AGENTAVATARS TO THIS LIST
                                                                      */ 
const $86a4b05b54bce4ef$var$avatarList = [
    {
        v1: $86a4b05b54bce4ef$var$CustomerInsightAvatar,
        v2: $86a4b05b54bce4ef$var$RefreshedCustomerInsightAvatar
    },
    {
        v1: $86a4b05b54bce4ef$var$BacklogBuddyAvatar,
        v2: $86a4b05b54bce4ef$var$RefreshedBacklogBuddyAvatar
    },
    {
        v1: $86a4b05b54bce4ef$var$DecisionDirectorAvatar,
        v2: $86a4b05b54bce4ef$var$RefreshedDecisionDirectorAvatar
    },
    {
        v1: $86a4b05b54bce4ef$var$CommsCrafterAvatar,
        v2: $86a4b05b54bce4ef$var$RefreshedCommsCrafterAvatar
    },
    {
        v1: $86a4b05b54bce4ef$var$AutoDevAvatar,
        v2: $86a4b05b54bce4ef$var$RefreshedAutoDevAvatar
    },
    {
        v1: $86a4b05b54bce4ef$var$OkrOracleAvatar,
        v2: $86a4b05b54bce4ef$var$RefreshedOkrOracleAvatar
    },
    {
        v1: $86a4b05b54bce4ef$var$CultureAvatar,
        v2: $86a4b05b54bce4ef$var$RefreshedCultureAvatar
    },
    {
        v1: $86a4b05b54bce4ef$var$SocialMediaScribeAvatar,
        v2: $86a4b05b54bce4ef$var$RefreshedSocialMediaScribeAvatar
    },
    {
        v1: $86a4b05b54bce4ef$var$TeamConnectionAvatar,
        v2: $86a4b05b54bce4ef$var$RefreshedTeamConnectionAvatar
    },
    {
        v1: $86a4b05b54bce4ef$var$HireWriterAvatar,
        v2: $86a4b05b54bce4ef$var$RefreshedHireWriterAvatar
    },
    {
        v1: $86a4b05b54bce4ef$var$OpsAgentAvatar,
        v2: $86a4b05b54bce4ef$var$RefreshedOpsAgentAvatar
    },
    {
        v1: $86a4b05b54bce4ef$var$ResearchScoutAvatar,
        v2: $86a4b05b54bce4ef$var$RefreshedResearchScoutAvatar
    },
    {
        v1: $86a4b05b54bce4ef$var$ReleaseNotesAvatar,
        v2: $86a4b05b54bce4ef$var$RefreshedReleaseNotesAvatar
    },
    {
        v1: $86a4b05b54bce4ef$var$MyUserManualAvatar,
        v2: $86a4b05b54bce4ef$var$RefreshedMyUserManualAvatar
    },
    {
        v1: $86a4b05b54bce4ef$var$PitchPerfectorAvatar,
        v2: $86a4b05b54bce4ef$var$RefreshedPitchPerfectorAvatar
    },
    {
        v1: $86a4b05b54bce4ef$var$AutoDevAvatar,
        v2: $86a4b05b54bce4ef$var$RefreshedAutoDevAvatar
    },
    {
        v1: $86a4b05b54bce4ef$var$AutoFixAvatar,
        v2: $86a4b05b54bce4ef$var$RefreshedAutoFixAvatar
    },
    {
        v1: $86a4b05b54bce4ef$var$AutoReviewAvatar,
        v2: $86a4b05b54bce4ef$var$RefreshedAutoReviewAvatar
    },
    {
        v1: $86a4b05b54bce4ef$var$MarketingMessageMaestroAvatar,
        v2: $86a4b05b54bce4ef$var$RefreshedMarketingMessageMaestroAvatar
    },
    {
        v1: $86a4b05b54bce4ef$var$FeatureFlagAvatar,
        v2: $86a4b05b54bce4ef$var$RefreshedFeatureFlagAvatar
    },
    {
        v1: $86a4b05b54bce4ef$var$ProductRequirementAvatar,
        v2: $86a4b05b54bce4ef$var$RefreshedProductRequirementAvatar
    }
];
const $86a4b05b54bce4ef$export$a834793a4d0d739e = $86a4b05b54bce4ef$var$avatarList.length * $86a4b05b54bce4ef$var$colorList.length;
const $86a4b05b54bce4ef$var$outOfTheBoxAgentAvatar = {
    ai_mate_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$RovoChatAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$d933daaf7b69e6ee.v1.primary,
                secondaryColor: $86a4b05b54bce4ef$export$d933daaf7b69e6ee.v1.secondary
            }),
        getColor: ()=>$86a4b05b54bce4ef$export$d933daaf7b69e6ee.v1
    },
    autodev_template_unit_test_creator: {
        getRender: (size)=>(0, $iDrrr.fg)('platform-dst-avatar-updated-geometry') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$RefreshedAutoFixAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.v2.primary,
                iconColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.v2.iconColor
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$AutoFixAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.v1.primary,
                secondaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.v1.secondary
            }),
        getColor: ()=>(0, $iDrrr.fg)('platform-dst-avatar-updated-geometry') ? $86a4b05b54bce4ef$export$a3d0897f023251ae.v2 : $86a4b05b54bce4ef$export$a3d0897f023251ae.v1
    },
    autodev_template_migration_config_changer_agent: {
        getRender: (size)=>(0, $iDrrr.fg)('platform-dst-avatar-updated-geometry') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$RefreshedOpsAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.v2.primary,
                iconColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.v2.iconColor
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$OpsAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.v1.primary,
                secondaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.v1.secondary
            }),
        getColor: ()=>(0, $iDrrr.fg)('platform-dst-avatar-updated-geometry') ? $86a4b05b54bce4ef$export$a3d0897f023251ae.v2 : $86a4b05b54bce4ef$export$a3d0897f023251ae.v1
    },
    autodev_template_vulnerable_dependency_updater_agent: {
        getRender: (size)=>(0, $iDrrr.fg)('platform-dst-avatar-updated-geometry') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$RefreshedMarketingMessageMaestroAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.v2.primary,
                iconColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.v2.iconColor
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$MarketingMessageMaestroAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.v1.primary,
                secondaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.v1.secondary
            }),
        getColor: ()=>(0, $iDrrr.fg)('platform-dst-avatar-updated-geometry') ? $86a4b05b54bce4ef$export$a3d0897f023251ae.v2 : $86a4b05b54bce4ef$export$a3d0897f023251ae.v1
    },
    autodev_template_code_standardizer_agent: {
        getRender: (size)=>(0, $iDrrr.fg)('platform-dst-avatar-updated-geometry') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$RefreshedMyUserManualAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.v2.primary,
                iconColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.v2.iconColor
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$MyUserManualAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.v1.primary,
                secondaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.v1.secondary
            }),
        getColor: ()=>(0, $iDrrr.fg)('platform-dst-avatar-updated-geometry') ? $86a4b05b54bce4ef$export$a3d0897f023251ae.v2 : $86a4b05b54bce4ef$export$a3d0897f023251ae.v1
    },
    autodev_template_code_observer_agent: {
        getRender: (size)=>(0, $iDrrr.fg)('platform-dst-avatar-updated-geometry') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$RefreshedResearchScoutAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.v2.primary,
                iconColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.v2.iconColor
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$ResearchScoutAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.v1.primary,
                secondaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.v1.secondary
            }),
        getColor: ()=>(0, $iDrrr.fg)('platform-dst-avatar-updated-geometry') ? $86a4b05b54bce4ef$export$a3d0897f023251ae.v2 : $86a4b05b54bce4ef$export$a3d0897f023251ae.v1
    },
    autodev_template_code_accessibility_checker_agent: {
        getRender: (size)=>(0, $iDrrr.fg)('platform-dst-avatar-updated-geometry') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$RefreshedHireWriterAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.v2.primary,
                iconColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.v2.iconColor
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$HireWriterAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.v1.primary,
                secondaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.v1.secondary
            }),
        getColor: ()=>(0, $iDrrr.fg)('platform-dst-avatar-updated-geometry') ? $86a4b05b54bce4ef$export$a3d0897f023251ae.v2 : $86a4b05b54bce4ef$export$a3d0897f023251ae.v1
    },
    autodev_code_documentation_writer_agent: {
        getRender: (size)=>(0, $iDrrr.fg)('platform-dst-avatar-updated-geometry') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$RefreshedSocialMediaScribeAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.v2.primary,
                iconColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.v2.iconColor
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$SocialMediaScribeAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.v1.primary,
                secondaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.v1.secondary
            }),
        getColor: ()=>(0, $iDrrr.fg)('platform-dst-avatar-updated-geometry') ? $86a4b05b54bce4ef$export$a3d0897f023251ae.v2 : $86a4b05b54bce4ef$export$a3d0897f023251ae.v1
    },
    autodev_feature_flag_cleaner_agent: {
        getRender: (size)=>(0, $iDrrr.fg)('platform-dst-avatar-updated-geometry') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$RefreshedFeatureFlagAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.v2.primary,
                iconColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.v2.iconColor
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$FeatureFlagAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.v1.primary,
                secondaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.v1.secondary
            }),
        getColor: ()=>(0, $iDrrr.fg)('platform-dst-avatar-updated-geometry') ? $86a4b05b54bce4ef$export$a3d0897f023251ae.v2 : $86a4b05b54bce4ef$export$a3d0897f023251ae.v1
    },
    decision_director_agent: {
        getRender: (size)=>(0, $iDrrr.fg)('platform-dst-avatar-updated-geometry') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$RefreshedDecisionDirectorAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.v2.primary,
                iconColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.v2.iconColor
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$DecisionDirectorAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.v1.primary,
                secondaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.v1.secondary
            }),
        getColor: ()=>(0, $iDrrr.fg)('platform-dst-avatar-updated-geometry') ? $86a4b05b54bce4ef$export$a3d0897f023251ae.v2 : $86a4b05b54bce4ef$export$a3d0897f023251ae.v1
    },
    planner_agent: {
        getRender: (size)=>(0, $iDrrr.fg)('platform-dst-avatar-updated-geometry') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$RefreshedOpsAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$3e344798f7855e62.v2.primary,
                iconColor: $86a4b05b54bce4ef$export$3e344798f7855e62.v2.iconColor
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$OpsAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$3e344798f7855e62.v1.primary,
                secondaryColor: $86a4b05b54bce4ef$export$3e344798f7855e62.v1.secondary
            }),
        getColor: ()=>(0, $iDrrr.fg)('platform-dst-avatar-updated-geometry') ? $86a4b05b54bce4ef$export$3e344798f7855e62.v2 : $86a4b05b54bce4ef$export$3e344798f7855e62.v1
    },
    tech_writer_agent: {
        getRender: (size)=>(0, $iDrrr.fg)('platform-dst-avatar-updated-geometry') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$RefreshedSocialMediaScribeAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$d933daaf7b69e6ee.v2.primary,
                iconColor: $86a4b05b54bce4ef$export$d933daaf7b69e6ee.v2.iconColor
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$SocialMediaScribeAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$d933daaf7b69e6ee.v1.primary,
                secondaryColor: $86a4b05b54bce4ef$export$d933daaf7b69e6ee.v1.secondary
            }),
        getColor: ()=>(0, $iDrrr.fg)('platform-dst-avatar-updated-geometry') ? $86a4b05b54bce4ef$export$d933daaf7b69e6ee.v2 : $86a4b05b54bce4ef$export$d933daaf7b69e6ee.v1
    },
    content_reviewer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$ContentReviewerAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        getColor: ()=>$86a4b05b54bce4ef$export$d933daaf7b69e6ee.v1
    },
    user_manual_writer_agent: {
        getRender: (size)=>(0, $iDrrr.fg)('platform-dst-avatar-updated-geometry') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$RefreshedMyUserManualAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2.v2.primary,
                iconColor: $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2.v2.iconColor
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$MyUserManualAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2.v1.primary,
                secondaryColor: $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2.v1.secondary
            }),
        getColor: ()=>(0, $iDrrr.fg)('platform-dst-avatar-updated-geometry') ? $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2.v2 : $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2.v1
    },
    product_requirements_expert_agent: {
        getRender: (size)=>(0, $iDrrr.fg)('platform-dst-avatar-updated-geometry') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$RefreshedProductRequirementAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2.v2.primary,
                iconColor: $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2.v2.iconColor
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$ProductRequirementAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2.v1.primary,
                secondaryColor: $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2.v1.secondary
            }),
        getColor: ()=>(0, $iDrrr.fg)('platform-dst-avatar-updated-geometry') ? $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2.v2 : $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2.v1
    },
    document_writer: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$DocumentWriterAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$d933daaf7b69e6ee.v1.primary,
                secondaryColor: $86a4b05b54bce4ef$export$d933daaf7b69e6ee.v1.secondary
            }),
        getColor: ()=>$86a4b05b54bce4ef$export$d933daaf7b69e6ee.v1
    },
    issue_organizer_agent: {
        getRender: (size)=>(0, $iDrrr.fg)('platform-dst-avatar-updated-geometry') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$RefreshedBacklogBuddyAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.v2.primary,
                iconColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.v2.iconColor
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$BacklogBuddyAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.v1.primary,
                secondaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.v1.secondary
            }),
        getColor: ()=>(0, $iDrrr.fg)('platform-dst-avatar-updated-geometry') ? $86a4b05b54bce4ef$export$a3d0897f023251ae.v2 : $86a4b05b54bce4ef$export$a3d0897f023251ae.v1
    },
    ops_guide_agent: {
        getRender: (size)=>(0, $iDrrr.fg)('platform-dst-avatar-updated-geometry') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$RefreshedOpsExpertAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2.v2.primary,
                iconColor: $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2.v2.iconColor
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$OpsAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2.v1.primary,
                secondaryColor: $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2.v1.secondary
            }),
        getColor: ()=>(0, $iDrrr.fg)('platform-dst-avatar-updated-geometry') ? $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2.v2 : $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2.v1
    },
    discovery_and_feedback_agent: {
        getRender: (size)=>(0, $iDrrr.fg)('platform-dst-avatar-updated-geometry') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$RefreshedCommsCrafterAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.v2.primary,
                iconColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.v2.iconColor
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$CommsCrafterAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.v1.primary,
                secondaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.v1.secondary
            }),
        getColor: ()=>(0, $iDrrr.fg)('platform-dst-avatar-updated-geometry') ? $86a4b05b54bce4ef$export$a3d0897f023251ae.v2 : $86a4b05b54bce4ef$export$a3d0897f023251ae.v1
    },
    jira_workflow_builder_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$WorkflowBuilderAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$d933daaf7b69e6ee.v1.primary,
                secondaryColor: $86a4b05b54bce4ef$export$d933daaf7b69e6ee.v1.secondary
            }),
        getColor: ()=>$86a4b05b54bce4ef$export$d933daaf7b69e6ee.v1
    },
    itops_rca_agent: {
        getRender: (size)=>(0, $iDrrr.fg)('platform-dst-avatar-updated-geometry') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$RefreshedAutoReviewAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2.v2.primary,
                iconColor: $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2.v2.iconColor
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$AutoReviewAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2.v1.primary,
                secondaryColor: $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2.v1.secondary
            }),
        getColor: ()=>(0, $iDrrr.fg)('platform-dst-avatar-updated-geometry') ? $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2.v2 : $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2.v1
    },
    jira_trial_guide_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$TrialGuideAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$d933daaf7b69e6ee.v1.primary,
                secondaryColor: $86a4b05b54bce4ef$export$d933daaf7b69e6ee.v1.secondary
            }),
        getColor: ()=>$86a4b05b54bce4ef$export$d933daaf7b69e6ee.v1
    },
    daily_brief_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$TrialGuideAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2.v1.primary,
                secondaryColor: $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2.v1.secondary
            }),
        getColor: ()=>$86a4b05b54bce4ef$export$cf7c9ad03f4a70b2.v1
    },
    jira_admin_agent: {
        getRender: (size)=>(0, $iDrrr.fg)('platform-dst-avatar-updated-geometry') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$RefreshedJiraAdminAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$d933daaf7b69e6ee.v2.primary,
                iconColor: $86a4b05b54bce4ef$export$d933daaf7b69e6ee.v2.iconColor
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$JiraCodingAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$d933daaf7b69e6ee.v1.primary,
                secondaryColor: $86a4b05b54bce4ef$export$d933daaf7b69e6ee.v1.secondary
            }),
        getColor: ()=>(0, $iDrrr.fg)('platform-dst-avatar-updated-geometry') ? $86a4b05b54bce4ef$export$d933daaf7b69e6ee.v2 : $86a4b05b54bce4ef$export$d933daaf7b69e6ee.v1
    },
    jsm_rovo_service_agent: {
        getRender: (size)=>{
            if ((0, $iDrrr.fg)('platform-dst-avatar-updated-geometry')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$RefreshedRequestResolverAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2.v2.primary,
                iconColor: $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2.v2.iconColor
            });
            if ((0, $iDrrr.fg)('rename-rovo-service-to-request-resolver')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$JsmRequestResolverAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$JsmRovoServiceAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            });
        },
        getColor: ()=>(0, $iDrrr.fg)('platform-dst-avatar-updated-geometry') ? $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2.v2 : $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2.v1
    },
    mcp_amplitude_agent: {
        getRender: (size)=>(0, $iDrrr.fg)('rovo_agent_amplitude_avatar_v2') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$AmplitudeAgentAvatarV2, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$AmplitudeAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        getColor: ()=>$86a4b05b54bce4ef$export$d933daaf7b69e6ee.v1
    },
    mcp_box_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$BoxAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        getColor: ()=>$86a4b05b54bce4ef$export$d933daaf7b69e6ee.v1
    },
    mcp_canva_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$CanvaAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        getColor: ()=>$86a4b05b54bce4ef$export$d933daaf7b69e6ee.v1
    },
    mcp_figma_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$FigmaAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        getColor: ()=>$86a4b05b54bce4ef$export$d933daaf7b69e6ee.v1
    },
    mcp_hubspot_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$HubSpotAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        getColor: ()=>$86a4b05b54bce4ef$export$d933daaf7b69e6ee.v1
    },
    mcp_intercom_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$IntercomAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        getColor: ()=>$86a4b05b54bce4ef$export$d933daaf7b69e6ee.v1
    },
    mcp_gamma_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$GammaAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        getColor: ()=>$86a4b05b54bce4ef$export$d933daaf7b69e6ee.v1
    },
    mcp_lovable_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$LovableAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        getColor: ()=>$86a4b05b54bce4ef$export$d933daaf7b69e6ee.v1
    },
    mcp_replit_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$ReplitAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        getColor: ()=>$86a4b05b54bce4ef$export$d933daaf7b69e6ee.v1
    },
    rovo_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$RovoAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        getColor: ()=>$86a4b05b54bce4ef$export$d933daaf7b69e6ee.v1
    },
    jira_work_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$JiraWorkAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        getColor: ()=>$86a4b05b54bce4ef$export$d933daaf7b69e6ee.v1
    },
    jira_task_planner_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$JiraTaskPlannerAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        getColor: ()=>$86a4b05b54bce4ef$export$d933daaf7b69e6ee.v1
    },
    jira_intelligent_triage_agent: {
        getRender: (size)=>(0, $iDrrr.fg)('platform-dst-avatar-updated-geometry') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$RefreshedJiraIntelligentTriageAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$d933daaf7b69e6ee.v2.primary,
                iconColor: $86a4b05b54bce4ef$export$d933daaf7b69e6ee.v2.iconColor
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$JiraIntelligentTriageAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        getColor: ()=>(0, $iDrrr.fg)('platform-dst-avatar-updated-geometry') ? $86a4b05b54bce4ef$export$d933daaf7b69e6ee.v2 : $86a4b05b54bce4ef$export$d933daaf7b69e6ee.v1
    },
    jira_delivery_agent: {
        getRender: (size)=>(0, $iDrrr.fg)('platform-dst-avatar-updated-geometry') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$RefreshedJiraDeliveryAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$d933daaf7b69e6ee.v2.primary,
                iconColor: $86a4b05b54bce4ef$export$d933daaf7b69e6ee.v2.iconColor
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$JiraDeliveryAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        getColor: ()=>(0, $iDrrr.fg)('platform-dst-avatar-updated-geometry') ? $86a4b05b54bce4ef$export$d933daaf7b69e6ee.v2 : $86a4b05b54bce4ef$export$d933daaf7b69e6ee.v1
    },
    jsm_service_triage_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$JsmServiceTriageAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        getColor: ()=>$86a4b05b54bce4ef$export$cf7c9ad03f4a70b2.v1
    },
    jira_coding_agent: {
        getRender: (size)=>(0, $iDrrr.fg)('platform-dst-avatar-updated-geometry') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$RefreshedJiraCodingAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.v2.primary,
                iconColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.v2.iconColor
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$JiraCodingAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        getColor: ()=>(0, $iDrrr.fg)('platform-dst-avatar-updated-geometry') ? $86a4b05b54bce4ef$export$a3d0897f023251ae.v2 : $86a4b05b54bce4ef$export$d933daaf7b69e6ee.v1
    }
};
const $86a4b05b54bce4ef$export$c84eb7708138dd4 = ({ agentIdentityAccountId: agentIdentityAccountId, agentId: agentId })=>{
    // we prioritise agentIdentityAccountId first if it is available
    // this is because agentIdentityAccountId is more widely available (e.g. in ProfilePage)
    const idForAgentAvatar = agentIdentityAccountId || agentId;
    if (idForAgentAvatar) {
        // Take the last 8 characters of the id because JS can't handle 16 digit numbers
        const trimmedId = idForAgentAvatar.slice(-8).replace(/[-:]/g, '');
        const parsedId = parseInt(trimmedId, 16);
        if (isNaN(parsedId)) return 0;
        else return parsedId;
    }
    return null;
};
const $86a4b05b54bce4ef$var$ROVO_DEV_AGENT_ID = '027f0676-e8e9-4939-8962-3850987d78bb';
const $86a4b05b54bce4ef$var$getAvatarRender = ({ agentNamedId: agentNamedId, agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, isRovoDev: isRovoDev, size: size })=>{
    if (isRovoDev) return {
        render: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$RovoDevAvatar, {
            size: (0, $ekCm6.AVATAR_SIZES)[size],
            primaryColor: "",
            secondaryColor: ""
        }),
        color: $86a4b05b54bce4ef$export$a3d0897f023251ae.v1
    };
     //@TODO CRCS-3129: Remove Rovo Dev hardcoded icon after TeamEU demos
    // Handle Rovo Dev agent avatar for TeamEU Demo
    if (agentId === $86a4b05b54bce4ef$var$ROVO_DEV_AGENT_ID && (0, $iDrrr.fg)('jira_ai_force_rovo_dev_avatar')) return {
        render: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$RovoDevAvatar, {
            size: (0, $ekCm6.AVATAR_SIZES)[size],
            primaryColor: "",
            secondaryColor: ""
        }),
        color: $86a4b05b54bce4ef$export$a3d0897f023251ae.v1
    };
    if (typeof agentNamedId === 'string' && $86a4b05b54bce4ef$var$outOfTheBoxAgentAvatar[agentNamedId]) {
        const avatar = $86a4b05b54bce4ef$var$outOfTheBoxAgentAvatar[agentNamedId];
        return {
            render: avatar.getRender(size),
            color: avatar.getColor()
        };
    }
    const numberId = $86a4b05b54bce4ef$export$c84eb7708138dd4({
        agentIdentityAccountId: agentIdentityAccountId,
        agentId: agentId
    });
    if (numberId !== null) {
        /**
     * this create all possible combinations of avatars and colors
     * e.g. [[avatar1, color1], [avatar1, color2], [avatar2, color1], [avatar2, color2]]
     * then choose 1 based on agentId
     */ const totalCombinations = $86a4b05b54bce4ef$var$avatarList.length * $86a4b05b54bce4ef$var$colorList.length;
        const combinationIndex = numberId % totalCombinations;
        const avatarIndex = Math.floor(combinationIndex / $86a4b05b54bce4ef$var$colorList.length);
        const colorIndex = combinationIndex % $86a4b05b54bce4ef$var$colorList.length;
        const avatar = $86a4b05b54bce4ef$var$avatarList[avatarIndex];
        const color = $86a4b05b54bce4ef$var$colorList[colorIndex];
        if ((0, $iDrrr.fg)('platform-dst-avatar-updated-geometry')) {
            const Avatar = avatar.v2;
            return {
                render: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Avatar, {
                    size: (0, $ekCm6.AVATAR_SIZES)[size],
                    primaryColor: color.v2.primary,
                    iconColor: color.v2.iconColor
                }),
                color: color.v2
            };
        }
        const Avatar = avatar.v1;
        return {
            render: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Avatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: color.v1.primary,
                secondaryColor: color.v1.secondary
            }),
            color: color.v1
        };
    }
    const fallbackColor = (0, $iDrrr.fg)('platform-dst-avatar-updated-geometry') ? $86a4b05b54bce4ef$export$d933daaf7b69e6ee.v2 : $86a4b05b54bce4ef$export$d933daaf7b69e6ee.v1;
    return {
        render: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$GenericAvatar, {
            size: (0, $ekCm6.AVATAR_SIZES)[size],
            primaryColor: fallbackColor.primary,
            secondaryColor: 'iconColor' in fallbackColor ? fallbackColor.iconColor : fallbackColor.secondary
        }),
        color: fallbackColor
    };
};
const $86a4b05b54bce4ef$export$d30ec808815da53a = (props)=>$86a4b05b54bce4ef$var$getAvatarRender({
        ...props,
        size: 'medium'
    }).color;
const $86a4b05b54bce4ef$export$6efaefb8ad2fba40 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { agentNamedId: agentNamedId, agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, isRovoDev: isRovoDev, creatorType: creatorType, height: height, fillSpace: fillSpace } = t0;
    let t1;
    if ($[0] !== agentId || $[1] !== agentIdentityAccountId || $[2] !== agentNamedId || $[3] !== isRovoDev) {
        t1 = $86a4b05b54bce4ef$export$d30ec808815da53a({
            agentNamedId: agentNamedId,
            agentId: agentId,
            agentIdentityAccountId: agentIdentityAccountId,
            isRovoDev: isRovoDev
        });
        $[0] = agentId;
        $[1] = agentIdentityAccountId;
        $[2] = agentNamedId;
        $[3] = isRovoDev;
        $[4] = t1;
    } else t1 = $[4];
    const color = t1;
    const isRemoteA2A = (0, $iDrrr.fg)("jira_improve_agent_profile_for_a2a") && creatorType === "REMOTE_A2A";
    const t2 = fillSpace ? $86a4b05b54bce4ef$var$styles.bannerFillSpace : undefined;
    const t3 = isRemoteA2A ? $86a4b05b54bce4ef$var$styles.bannerRemoteA2A : undefined;
    let t4;
    if ($[5] !== t2 || $[6] !== t3) {
        t4 = (0, $w6R6I.cx)($86a4b05b54bce4ef$var$styles.banner, t2, t3);
        $[5] = t2;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    const t5 = isRemoteA2A ? undefined : color.primary;
    const t6 = height ? `${height}px` : undefined;
    let t7;
    if ($[8] !== t5 || $[9] !== t6) {
        t7 = {
            backgroundColor: t5,
            height: t6
        };
        $[8] = t5;
        $[9] = t6;
        $[10] = t7;
    } else t7 = $[10];
    let t8;
    if ($[11] !== t4 || $[12] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t4,
            style: t7
        });
        $[11] = t4;
        $[12] = t7;
        $[13] = t8;
    } else t8 = $[13];
    return t8;
} : ({ agentNamedId: agentNamedId, agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, isRovoDev: isRovoDev, creatorType: creatorType, height: height, fillSpace: fillSpace })=>{
    const color = $86a4b05b54bce4ef$export$d30ec808815da53a({
        agentNamedId: agentNamedId,
        agentId: agentId,
        agentIdentityAccountId: agentIdentityAccountId,
        isRovoDev: isRovoDev
    });
    const isRemoteA2A = (0, $iDrrr.fg)('jira_improve_agent_profile_for_a2a') && creatorType === 'REMOTE_A2A';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($86a4b05b54bce4ef$var$styles.banner, fillSpace ? $86a4b05b54bce4ef$var$styles.bannerFillSpace : undefined, isRemoteA2A ? $86a4b05b54bce4ef$var$styles.bannerRemoteA2A : undefined),
        style: {
            backgroundColor: isRemoteA2A ? undefined : color.primary,
            height: height ? `${height}px` : undefined
        }
    });
};
const $86a4b05b54bce4ef$export$96bb253b7de22616 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(12);
    let t0;
    if ($[0] !== props) {
        t0 = $86a4b05b54bce4ef$var$getAvatarRender(props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    const { render: render, color: color } = t0;
    const { onLoad: onLoad } = props;
    let t1;
    if ($[2] !== color.primary) {
        t1 = {
            backgroundColor: color.primary
        };
        $[2] = color.primary;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== onLoad) {
        t2 = onLoad && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$Observer, {
            onLoad: onLoad
        });
        $[4] = onLoad;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== render || $[7] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, t2, render);
        $[6] = render;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== t1 || $[10] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $86a4b05b54bce4ef$var$styles.image,
            style: t1
        }, t3);
        $[9] = t1;
        $[10] = t3;
        $[11] = t4;
    } else t4 = $[11];
    return t4;
} : (props)=>{
    const { render: render, color: color } = $86a4b05b54bce4ef$var$getAvatarRender(props);
    const { onLoad: onLoad } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $86a4b05b54bce4ef$var$styles.image,
        style: {
            backgroundColor: color.primary
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, onLoad && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$Observer, {
        onLoad: onLoad
    }), render));
};
module.exports["getAgentAvatarColor"] = $86a4b05b54bce4ef$export$d30ec808815da53a;
module.exports["AgentBanner"] = $86a4b05b54bce4ef$export$6efaefb8ad2fba40;
module.exports["GeneratedAvatar"] = $86a4b05b54bce4ef$export$96bb253b7de22616;

});

parcelRegister("iGZJA", function(module, exports) {

let $d9bc0964567c8893$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d9bc0964567c8893$var$load("4T36V").then(()=>parcelRequire('4JzBf'));

});

parcelRegister("fP7cd", function(module, exports) {

let $b851336a8c46d3d8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b851336a8c46d3d8$var$load("kHeJt").then(()=>parcelRequire('7IZ41'));

});

parcelRegister("isMen", function(module, exports) {

let $d710412a9fa0727e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d710412a9fa0727e$var$load("1jS5r").then(()=>parcelRequire('cPfLC'));

});

parcelRegister("3WrUa", function(module, exports) {

let $2dec6f32da637906$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2dec6f32da637906$var$load("8pQqR").then(()=>parcelRequire('307Y8'));

});

parcelRegister("4yA6G", function(module, exports) {

let $3516587a40857196$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3516587a40857196$var$load("7uZtR").then(()=>parcelRequire('7C38m'));

});

parcelRegister("fEx6p", function(module, exports) {

let $b65444deb301ed95$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b65444deb301ed95$var$load("h3Q9O").then(()=>parcelRequire('2Ay6w'));

});

parcelRegister("jaq6v", function(module, exports) {

let $df433330a4f5da6f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $df433330a4f5da6f$var$load("lQ2Wv").then(()=>parcelRequire('RrRkO'));

});

parcelRegister("mEHH8", function(module, exports) {

let $0441a11b1fa95490$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0441a11b1fa95490$var$load("luY5S").then(()=>parcelRequire('2EQVx'));

});

parcelRegister("l64Lr", function(module, exports) {

let $f5bdda94279afbce$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f5bdda94279afbce$var$load("jLQoO").then(()=>parcelRequire('4yLMc'));

});

parcelRegister("iBg9j", function(module, exports) {

let $d8a8359c9293a257$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d8a8359c9293a257$var$load("8XzKF").then(()=>parcelRequire('aMHKP'));

});

parcelRegister("aoj7n", function(module, exports) {

let $790af9b5d47dee23$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $790af9b5d47dee23$var$load("aVPeB").then(()=>parcelRequire('77piP'));

});

parcelRegister("lnLxh", function(module, exports) {

let $f9109e8eaffb6c3b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f9109e8eaffb6c3b$var$load("29YpP").then(()=>parcelRequire('5pi1P'));

});

parcelRegister("2nka8", function(module, exports) {

let $1bad5e9f89066e90$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1bad5e9f89066e90$var$load("khSk2").then(()=>parcelRequire('7rJJs'));

});

parcelRegister("9UKCb", function(module, exports) {

let $737d80c0d59dc513$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $737d80c0d59dc513$var$load("cBAs3").then(()=>parcelRequire('enFb5'));

});

parcelRegister("23pjP", function(module, exports) {

let $17ef8065b87564f1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $17ef8065b87564f1$var$load("eRtyl").then(()=>parcelRequire('a8X2J'));

});

parcelRegister("16ZJh", function(module, exports) {

let $0cf63c2500cf8c5d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0cf63c2500cf8c5d$var$load("adzZc").then(()=>parcelRequire('dKaVL'));

});

parcelRegister("hiE2p", function(module, exports) {

let $c9832cd0c6f74619$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c9832cd0c6f74619$var$load("i7Bvz").then(()=>parcelRequire('l3LVB'));

});

parcelRegister("hqvBW", function(module, exports) {

let $cafd62ad8d83edb0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cafd62ad8d83edb0$var$load("lMDhZ").then(()=>parcelRequire('6Jur4'));

});

parcelRegister("9eCxF", function(module, exports) {

let $6b935182f77c3973$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6b935182f77c3973$var$load("fnTUG").then(()=>parcelRequire('fteS3'));

});

parcelRegister("fewZY", function(module, exports) {

let $b171c2a41dab3503$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b171c2a41dab3503$var$load("eI9qf").then(()=>parcelRequire('3szNQ'));

});

parcelRegister("bhJ1m", function(module, exports) {

let $837434721a45c952$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $837434721a45c952$var$load("esEDZ").then(()=>parcelRequire('7eR3o'));

});

parcelRegister("9Y1Ze", function(module, exports) {

let $741b422ce74e095e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $741b422ce74e095e$var$load("9kaOX").then(()=>parcelRequire('8gWTR'));

});

parcelRegister("2uslO", function(module, exports) {

let $1d046004fa76b4db$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1d046004fa76b4db$var$load("4PB6V").then(()=>parcelRequire('6QTHA'));

});

parcelRegister("cNes1", function(module, exports) {

let $95054549f907928f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $95054549f907928f$var$load("iimYM").then(()=>parcelRequire('gES8s'));

});

parcelRegister("2NvtN", function(module, exports) {

let $209893901f7a2615$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $209893901f7a2615$var$load("8t5HW").then(()=>parcelRequire('hlyG9'));

});

parcelRegister("kxFXt", function(module, exports) {

let $ef476fba7f2f153c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ef476fba7f2f153c$var$load("eFn4T").then(()=>parcelRequire('97dge'));

});

parcelRegister("kYpKY", function(module, exports) {

let $f44d63f7a74f8acb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f44d63f7a74f8acb$var$load("iMObC").then(()=>parcelRequire('iXsN7'));

});

parcelRegister("feg39", function(module, exports) {

let $b1649cfe483ec9a0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b1649cfe483ec9a0$var$load("kstRm").then(()=>parcelRequire('bK6sM'));

});

parcelRegister("4RJuR", function(module, exports) {

let $38af675cb55db454$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $38af675cb55db454$var$load("llcXv").then(()=>parcelRequire('dCNdL'));

});

parcelRegister("di1lo", function(module, exports) {

let $9acdffb5c59e3f0d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9acdffb5c59e3f0d$var$load("b4KKP").then(()=>parcelRequire('20vx6'));

});

parcelRegister("j5vOg", function(module, exports) {

let $de5728acaffb9591$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $de5728acaffb9591$var$load("407ox").then(()=>parcelRequire('4MOGN'));

});

parcelRegister("ir4Zs", function(module, exports) {

let $d6be9e8e0052869c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d6be9e8e0052869c$var$load("48VmB").then(()=>parcelRequire('h7Jie'));

});

parcelRegister("huaWP", function(module, exports) {

let $cbadbb06a0117620$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cbadbb06a0117620$var$load("7J2T4").then(()=>parcelRequire('jEDvD'));

});

parcelRegister("e7aux", function(module, exports) {

let $a469db8def0a1348$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a469db8def0a1348$var$load("k8VH8").then(()=>parcelRequire('8DKak'));

});

parcelRegister("gWtbL", function(module, exports) {

let $c558b46049a51761$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c558b46049a51761$var$load("4oDvX").then(()=>parcelRequire('irLRE'));

});

parcelRegister("ef6sM", function(module, exports) {

let $a5e77ad7ccb3cdb5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a5e77ad7ccb3cdb5$var$load("73ECg").then(()=>parcelRequire('K1eyd'));

});

parcelRegister("eMArC", function(module, exports) {

let $ac31d1852b44e66b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ac31d1852b44e66b$var$load("l7xQ8").then(()=>parcelRequire('8uuyE'));

});

parcelRegister("lLIpI", function(module, exports) {

let $fd907066efd418c0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fd907066efd418c0$var$load("gZUKs").then(()=>parcelRequire('ky2MY'));

});

parcelRegister("guf1O", function(module, exports) {

let $c00b1afcb70b5574$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c00b1afcb70b5574$var$load("iUIIz").then(()=>parcelRequire('gu3EK'));

});

parcelRegister("fqQ0Z", function(module, exports) {

let $b3c1a1ca91afe332$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b3c1a1ca91afe332$var$load("4WEyz").then(()=>parcelRequire('gECy4'));

});

parcelRegister("g5Au7", function(module, exports) {

let $bb696a1487973d02$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bb696a1487973d02$var$load("hTrWv").then(()=>parcelRequire('eHp1N'));

});

parcelRegister("jduPc", function(module, exports) {

let $dfd72461b7e5efd7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dfd72461b7e5efd7$var$load("hgSu9").then(()=>parcelRequire('jGDeV'));

});

parcelRegister("2BsbE", function(module, exports) {

let $1e54e6d15e249ea8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1e54e6d15e249ea8$var$load("1Cm5e").then(()=>parcelRequire('1c1x3'));

});

parcelRegister("ccwx8", function(module, exports) {

let $8e1fd77f340721b6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8e1fd77f340721b6$var$load("gW1VO").then(()=>parcelRequire('jldw7'));

});

parcelRegister("kCYzi", function(module, exports) {

let $f04656d6233e5a5c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f04656d6233e5a5c$var$load("2xiJO").then(()=>parcelRequire('kNSgL'));

});

parcelRegister("eGpCl", function(module, exports) {

let $ab08dc039565a58c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ab08dc039565a58c$var$load("3s3o5").then(()=>parcelRequire('8eply'));

});

parcelRegister("fZHZI", function(module, exports) {

let $ba4eade7bb03669c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ba4eade7bb03669c$var$load("8wB5Z").then(()=>parcelRequire('HlF0Y'));

});

parcelRegister("iLJ1v", function(module, exports) {

let $da9f8a7981ec2ce4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $da9f8a7981ec2ce4$var$load("lGvlN").then(()=>parcelRequire('kEjPu'));

});

parcelRegister("j6OuY", function(module, exports) {

let $de95bfd69ede0761$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $de95bfd69ede0761$var$load("hdDMK").then(()=>parcelRequire('6bCpe'));

});

parcelRegister("ddq5w", function(module, exports) {

let $99f0b9d3ccdd4a58$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $99f0b9d3ccdd4a58$var$load("3mJV2").then(()=>parcelRequire('7Gb4S'));

});

parcelRegister("lnaW2", function(module, exports) {

let $f8f43a6dc90f9eee$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f8f43a6dc90f9eee$var$load("cMLT2").then(()=>parcelRequire('5tcSN'));

});

parcelRegister("jMZdA", function(module, exports) {

let $e681fcafe11e5342$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e681fcafe11e5342$var$load("6194k").then(()=>parcelRequire('6LeK2'));

});

parcelRegister("4Jhm3", function(module, exports) {

let $3718d3b36fa5fd70$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3718d3b36fa5fd70$var$load("izPy1").then(()=>parcelRequire('hZ7pV'));

});

parcelRegister("e3WMy", function(module, exports) {

let $a3cef16899247aea$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a3cef16899247aea$var$load("iAvXE").then(()=>parcelRequire('am4Fa'));

});

parcelRegister("1lG7v", function(module, exports) {

let $0fb86cc2c4073147$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0fb86cc2c4073147$var$load("i1Et0").then(()=>parcelRequire('kTKKU'));

});

parcelRegister("l7BNW", function(module, exports) {

let $f607939f9dd51c37$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f607939f9dd51c37$var$load("j0hWb").then(()=>parcelRequire('j06NM'));

});

parcelRegister("cr6cT", function(module, exports) {

let $90dcd23c2f2236db$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $90dcd23c2f2236db$var$load("5OeCI").then(()=>parcelRequire('7ynR8'));

});

parcelRegister("l39Ik", function(module, exports) {

let $f53169c4259cb361$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f53169c4259cb361$var$load("1SMTI").then(()=>parcelRequire('8sDTM'));

});

parcelRegister("eWJHH", function(module, exports) {

let $ae19ef4d540d8f6b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ae19ef4d540d8f6b$var$load("9UVYf").then(()=>parcelRequire('9KXxY'));

});

parcelRegister("hpLK5", function(module, exports) {

let $cad9ce1adc1d7cd1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cad9ce1adc1d7cd1$var$load("4wV7K").then(()=>parcelRequire('eW24X'));

});

parcelRegister("ceWMu", function(module, exports) {

let $8e94638544de9830$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8e94638544de9830$var$load("4iPF7").then(()=>parcelRequire('dcQg7'));

});

parcelRegister("5BSGs", function(module, exports) {

let $415ad37e6a0ebc27$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $415ad37e6a0ebc27$var$load("gwLRR").then(()=>parcelRequire('2T7Fz'));

});

parcelRegister("dU4PR", function(module, exports) {

let $a1f4418b8e7e3f7b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a1f4418b8e7e3f7b$var$load("8qEhZ").then(()=>parcelRequire('1RnD4'));

});

parcelRegister("4d0IW", function(module, exports) {

let $3108f0168aaf0c49$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3108f0168aaf0c49$var$load("8FUME").then(()=>parcelRequire('77zEU'));

});

parcelRegister("7kGM2", function(module, exports) {

let $556b94a300dbe36c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $556b94a300dbe36c$var$load("eOveI").then(()=>parcelRequire('74dGw'));

});

parcelRegister("hNwBH", function(module, exports) {

let $cf504e5f033f5a23$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cf504e5f033f5a23$var$load("5wdgL").then(()=>parcelRequire('7iDJ1'));

});

parcelRegister("356rB", function(module, exports) {

let $23e6d66c4e074d0b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $23e6d66c4e074d0b$var$load("gqUBC").then(()=>parcelRequire('kBwMH'));

});

parcelRegister("j37DR", function(module, exports) {

let $dde439ae718235cc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dde439ae718235cc$var$load("9WOR4").then(()=>parcelRequire('233ll'));

});

parcelRegister("eYFGv", function(module, exports) {

let $ae7700fce28cc575$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ae7700fce28cc575$var$load("gfDZQ").then(()=>parcelRequire('eSnga'));

});

parcelRegister("hUkXO", function(module, exports) {

let $d097ed960fc80e30$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d097ed960fc80e30$var$load("044PY").then(()=>parcelRequire('lUlGx'));

});

parcelRegister("f75bz", function(module, exports) {

let $b00b8834faa082f1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b00b8834faa082f1$var$load("hMnqJ").then(()=>parcelRequire('l6t8J'));

});

parcelRegister("hXuuu", function(module, exports) {

let $d12f992cae96639c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d12f992cae96639c$var$load("4iEdG").then(()=>parcelRequire('kYlrO'));

});

parcelRegister("6gGPb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $arQY7 = parcelRequire("arQY7");


var $7zsi1 = parcelRequire("7zsi1");


var $ekCm6 = parcelRequire("ekCm6");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $a2bT0 = parcelRequire("a2bT0");


var $iH3wh = parcelRequire("iH3wh");

const $2433037a0219ceb9$export$2f5dfaa7873e8973 = `polygon(45% 1.33975%, 46.5798% 0.60307%, 48.26352% 0.15192%, 50% 0%, 51.73648% 0.15192%, 53.4202% 0.60307%, 55% 1.33975%, 89.64102% 21.33975%, 91.06889% 22.33956%, 92.30146% 23.57212%, 93.30127% 25%, 94.03794% 26.5798%, 94.48909% 28.26352%, 94.64102% 30%, 94.64102% 70%, 94.48909% 71.73648%, 94.03794% 73.4202%, 93.30127% 75%, 92.30146% 76.42788%, 91.06889% 77.66044%, 89.64102% 78.66025%, 55% 98.66025%, 53.4202% 99.39693%, 51.73648% 99.84808%, 50% 100%, 48.26352% 99.84808%, 46.5798% 99.39693%, 45% 98.66025%, 10.35898% 78.66025%, 8.93111% 77.66044%, 7.69854% 76.42788%, 6.69873% 75%, 5.96206% 73.4202%, 5.51091% 71.73648%, 5.35898% 70%, 5.35898% 30%, 5.51091% 28.26352%, 5.96206% 26.5798%, 6.69873% 25%, 7.69854% 23.57212%, 8.93111% 22.33956%, 10.35898% 21.33975%)`;
const $2433037a0219ceb9$var$styles = {
    agentAvatar: "_3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT _1uo2ZfTcEg",
    image: "_00EA0eiObl _0jFU0VN91d _39xV02N91d",
    avatarContentContainer: "_39xV02N91d _0jFU0VN91d _3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT"
};
const $2433037a0219ceb9$var$stylesCompiled = {
    innerShape: "_0jFU0VwOVE _39xV02wOVE _1uo2ZfTcEg"
};
const $2433037a0219ceb9$export$38b71b080e1832c8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(46);
    const { imageUrl: imageUrl, size: t1, label: label, name: name, agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, agentNamedId: agentNamedId, showBorder: t2, isRovoDev: isRovoDev, isForgeAgent: isForgeAgent, forgeAgentIconUrl: forgeAgentIconUrl, UNSAFE_useAdsAvatar: UNSAFE_useAdsAvatar } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const showBorder = t2 === undefined ? true : t2;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const imgUrl = isForgeAgent && forgeAgentIconUrl ? forgeAgentIconUrl : imageUrl;
    let t3;
    if ($[0] !== formatMessage || $[1] !== label || $[2] !== name) {
        t3 = name || label || formatMessage((0, $iH3wh.messages).agentAvatarLabel);
        $[0] = formatMessage;
        $[1] = label;
        $[2] = name;
        $[3] = t3;
    } else t3 = $[3];
    const avatarName = t3;
    let t4;
    if ($[4] !== agentId || $[5] !== agentIdentityAccountId || $[6] !== agentNamedId || $[7] !== imgUrl || $[8] !== isRovoDev || $[9] !== size) {
        t4 = imgUrl ? null : /*#__PURE__*/ $cozmU.createElement((0, $a2bT0.GeneratedAvatar), {
            agentId: agentId,
            agentNamedId: agentNamedId,
            agentIdentityAccountId: agentIdentityAccountId,
            isRovoDev: isRovoDev,
            size: size
        });
        $[4] = agentId;
        $[5] = agentIdentityAccountId;
        $[6] = agentNamedId;
        $[7] = imgUrl;
        $[8] = isRovoDev;
        $[9] = size;
        $[10] = t4;
    } else t4 = $[10];
    const generatedAvatar = t4;
    if (UNSAFE_useAdsAvatar) {
        let t5;
        if ($[11] !== avatarName || $[12] !== label || $[13] !== size) {
            t5 = {
                appearance: "hexagon",
                label: label,
                name: avatarName,
                size: size,
                UNSAFE_isUpdatedGeometry: true
            };
            $[11] = avatarName;
            $[12] = label;
            $[13] = size;
            $[14] = t5;
        } else t5 = $[14];
        const adsAvatarProps = t5;
        if (imgUrl) {
            let t6;
            if ($[15] !== adsAvatarProps || $[16] !== imgUrl) {
                t6 = /*#__PURE__*/ $cozmU.createElement((0, $arQY7.default), {
                    ...adsAvatarProps,
                    src: imgUrl
                });
                $[15] = adsAvatarProps;
                $[16] = imgUrl;
                $[17] = t6;
            } else t6 = $[17];
            return t6;
        }
        let t6;
        if ($[18] !== generatedAvatar) {
            t6 = /*#__PURE__*/ $cozmU.createElement((0, $7zsi1.AvatarContent), null, generatedAvatar);
            $[18] = generatedAvatar;
            $[19] = t6;
        } else t6 = $[19];
        let t7;
        if ($[20] !== adsAvatarProps || $[21] !== t6) {
            t7 = /*#__PURE__*/ $cozmU.createElement((0, $arQY7.default), adsAvatarProps, t6);
            $[20] = adsAvatarProps;
            $[21] = t6;
            $[22] = t7;
        } else t7 = $[22];
        return t7;
    }
    const t5 = (0, $ekCm6.AVATAR_SIZES)[size];
    const t6 = (0, $ekCm6.AVATAR_SIZES)[size];
    let t7;
    if ($[23] !== showBorder) {
        t7 = showBorder ? {
            backgroundColor: "#fff"
        } : {};
        $[23] = showBorder;
        $[24] = t7;
    } else t7 = $[24];
    let t8;
    if ($[25] !== size) {
        t8 = (0, $iDrrr.fg)("rovo_chat_bugfix_agent_avatar_squish") ? {
            minHeight: (0, $ekCm6.AVATAR_SIZES)[size],
            minWidth: (0, $ekCm6.AVATAR_SIZES)[size]
        } : {};
        $[25] = size;
        $[26] = t8;
    } else t8 = $[26];
    let t9;
    if ($[27] !== t5 || $[28] !== t6 || $[29] !== t7 || $[30] !== t8) {
        t9 = {
            height: t5,
            width: t6,
            ...t7,
            ...t8
        };
        $[27] = t5;
        $[28] = t6;
        $[29] = t7;
        $[30] = t8;
        $[31] = t9;
    } else t9 = $[31];
    let t10;
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = (0, $hekY6.default)([
            $2433037a0219ceb9$var$stylesCompiled.innerShape
        ]);
        $[32] = t10;
    } else t10 = $[32];
    let t11;
    if ($[33] !== avatarName || $[34] !== generatedAvatar || $[35] !== imgUrl) {
        t11 = imgUrl ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            as: "img",
            xcss: $2433037a0219ceb9$var$styles.image,
            src: imgUrl,
            alt: avatarName
        }) : generatedAvatar;
        $[33] = avatarName;
        $[34] = generatedAvatar;
        $[35] = imgUrl;
        $[36] = t11;
    } else t11 = $[36];
    let t12;
    if ($[37] !== t11) {
        t12 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $2433037a0219ceb9$var$styles.avatarContentContainer
        }, t11);
        $[37] = t11;
        $[38] = t12;
    } else t12 = $[38];
    let t13;
    if ($[39] !== t10 || $[40] !== t12) {
        t13 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t10
        }, t12);
        $[39] = t10;
        $[40] = t12;
        $[41] = t13;
    } else t13 = $[41];
    let t14;
    if ($[42] !== label || $[43] !== t13 || $[44] !== t9) {
        t14 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            "aria-label": label,
            xcss: $2433037a0219ceb9$var$styles.agentAvatar,
            style: t9
        }, t13);
        $[42] = label;
        $[43] = t13;
        $[44] = t9;
        $[45] = t14;
    } else t14 = $[45];
    return t14;
} : ({ imageUrl: imageUrl, size: size = 'medium', label: label, name: name, agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, agentNamedId: agentNamedId, showBorder: showBorder = true, isRovoDev: isRovoDev, isForgeAgent: isForgeAgent, forgeAgentIconUrl: forgeAgentIconUrl, UNSAFE_useAdsAvatar: UNSAFE_useAdsAvatar })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const imgUrl = isForgeAgent && forgeAgentIconUrl ? forgeAgentIconUrl : imageUrl;
    const avatarName = name || label || formatMessage((0, $iH3wh.messages).agentAvatarLabel);
    const generatedAvatar = imgUrl ? null : /*#__PURE__*/ $cozmU.createElement((0, $a2bT0.GeneratedAvatar), {
        agentId: agentId,
        agentNamedId: agentNamedId,
        agentIdentityAccountId: agentIdentityAccountId,
        isRovoDev: isRovoDev,
        size: size
    });
    if (UNSAFE_useAdsAvatar) {
        const adsAvatarProps = {
            appearance: 'hexagon',
            label: label,
            name: avatarName,
            size: size,
            UNSAFE_isUpdatedGeometry: true
        };
        if (imgUrl) return /*#__PURE__*/ $cozmU.createElement((0, $arQY7.default), {
            ...adsAvatarProps,
            src: imgUrl
        });
        return /*#__PURE__*/ $cozmU.createElement((0, $arQY7.default), adsAvatarProps, /*#__PURE__*/ $cozmU.createElement((0, $7zsi1.AvatarContent), null, generatedAvatar));
    }
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        "aria-label": label,
        xcss: $2433037a0219ceb9$var$styles.agentAvatar,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
            height: (0, $ekCm6.AVATAR_SIZES)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
            width: (0, $ekCm6.AVATAR_SIZES)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/ensure-design-token-usage
            ...showBorder ? {
                backgroundColor: '#fff'
            } : {},
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...(0, $iDrrr.fg)('rovo_chat_bugfix_agent_avatar_squish') ? {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                minHeight: (0, $ekCm6.AVATAR_SIZES)[size],
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                minWidth: (0, $ekCm6.AVATAR_SIZES)[size]
            } : {}
        }
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $2433037a0219ceb9$var$stylesCompiled.innerShape
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $2433037a0219ceb9$var$styles.avatarContentContainer
    }, imgUrl ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: "img",
        xcss: $2433037a0219ceb9$var$styles.image,
        src: imgUrl,
        alt: avatarName
    }) : generatedAvatar)));
};
module.exports["AGENT_AVATAR_CLIP_PATH"] = $2433037a0219ceb9$export$2f5dfaa7873e8973;
module.exports["AgentAvatar"] = $2433037a0219ceb9$export$38b71b080e1832c8;

});

parcelRegister("iH3wh", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $a5c48f60363d438d$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    agentAvatarLabel: {
        id: "ai-mate.agent-avatar-label",
        defaultMessage: "Agent avatar"
    }
});
module.exports["messages"] = $a5c48f60363d438d$export$defe85febe8b728c;

});

parcelRegister("jgqX6", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0646b18c90b3a18$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3c3I9 = parcelRequire("3c3I9");


var $eYSi7 = parcelRequire("eYSi7");


var $3yGK6 = parcelRequire("3yGK6");


var $2iY37 = parcelRequire("2iY37");

function $e0646b18c90b3a18$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $3yGK6.default)(2, arguments);
    var dateLeft = (0, $dkBOe.default)(dirtyDateLeft);
    var dateRight = (0, $dkBOe.default)(dirtyDateRight);
    var sign = (0, $eYSi7.default)(dateLeft, dateRight);
    var difference = Math.abs((0, $3c3I9.default)(dateLeft, dateRight));
    var result;
    // Check for the difference of less than month
    if (difference < 1) result = 0;
    else {
        if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) // This will check if the date is end of Feb and assign a higher end of month date
        // to compare it with Jan
        dateLeft.setDate(30);
        dateLeft.setMonth(dateLeft.getMonth() - sign * difference);
        // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
        // If so, result must be decreased by 1 in absolute value
        var isLastMonthNotFull = (0, $eYSi7.default)(dateLeft, dateRight) === -sign;
        // Check for cases of one full calendar month
        if ((0, $2iY37.default)((0, $dkBOe.default)(dirtyDateLeft)) && difference === 1 && (0, $eYSi7.default)(dirtyDateLeft, dateRight) === 1) isLastMonthNotFull = false;
        result = sign * (difference - Number(isLastMonthNotFull));
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});

parcelRegister("3c3I9", function(module, exports) {
$parcel$export(module.exports, "default", () => $25355f04f79cc351$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $25355f04f79cc351$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $3yGK6.default)(2, arguments);
    var dateLeft = (0, $dkBOe.default)(dirtyDateLeft);
    var dateRight = (0, $dkBOe.default)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}

});

parcelRegister("eYSi7", function(module, exports) {
$parcel$export(module.exports, "default", () => $ae80c86a80ef7d08$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $ae80c86a80ef7d08$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $3yGK6.default)(2, arguments);
    var dateLeft = (0, $dkBOe.default)(dirtyDateLeft);
    var dateRight = (0, $dkBOe.default)(dirtyDateRight);
    var diff = dateLeft.getTime() - dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}

});

parcelRegister("ez9xU", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $kSwu1 = parcelRequire("kSwu1");


var $jmUhx = parcelRequire("jmUhx");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $hBYtq = parcelRequire("hBYtq");


var $eytcg = parcelRequire("eytcg");

const $c25508467e1a19ee$var$triggerStyles = {
    button: "_23rrnHyKLB _3hxITiYbGa _0Of8r22ADO _1wydGW2ADO _2Zuz6Q5zaO _1Znuxb5zaO _0KLXrujOvk _0wOv4Q7zJH _39xV02N91d _1eOmH6o126",
    text: "_2sNsIg7NXe _1UtDYzKGUX"
};
const $c25508467e1a19ee$var$DefaultTrigger = ({ open: open })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $c25508467e1a19ee$var$triggerStyles.button,
        onClick: ()=>open()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        gap: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jmUhx))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $c25508467e1a19ee$var$triggerStyles.text
    }, formatMessage((0, $eytcg.messages).defaultTriggerLabel))));
};

const $c25508467e1a19ee$var$LazyRovoSettingsModalProvider = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("9dvYt")).then((mod)=>({
            default: mod.RovoSettingsModalLazy
        }))); /**
       * Self-contained entrypoint for the Rovo Settings modal.
       *
       * The trigger renders eagerly. The provider tree and modal
       * are lazy-loaded only when the user first clicks the trigger.
       * Subsequent opens reuse the mounted provider — no re-mount or re-fetch.
       */ 
const $c25508467e1a19ee$export$f2c3f3e62df426ba = ({ children: renderTrigger, ...providerProps })=>{
    const [isActivated, setIsActivated] = (0, $cozmU.useState)(false);
    const pendingOpenOptions = (0, $cozmU.useRef)(undefined);
    const openModalRef = (0, $cozmU.useRef)(null);
    const open = (0, $cozmU.useCallback)((options)=>{
        if (openModalRef.current) // Provider already mounted — open directly
        openModalRef.current(options);
        else {
            // First click — store options and mount the provider
            pendingOpenOptions.current = options;
            setIsActivated(true);
        }
    }, []); // Calling the render function directly (rather than mounting it as a
    // component) makes React diff the returned JSX in-place against the previous
    // render, so the trigger element survives parent re-renders even if the
    // render function's identity changes (e.g. inline arrows).
    const triggerNode = renderTrigger ? renderTrigger({
        open: open
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c25508467e1a19ee$var$DefaultTrigger, {
        open: open
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        fallbackRender: ()=>null
    }, triggerNode, isActivated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c25508467e1a19ee$var$LazyRovoSettingsModalProvider, {
        ...providerProps,
        pendingOpenOptions: pendingOpenOptions,
        openModalRef: openModalRef
    })));
};
module.exports["RovoSettingsModal"] = $c25508467e1a19ee$export$f2c3f3e62df426ba;

});

parcelRegister("eytcg", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $2c6792bc438bfd46$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    modalTitle: {
        id: "ai-mate.rovo-settings-modal.portable-rovo-settings.modal-title.non-final",
        defaultMessage: "Sources & apps"
    },
    searchPlaceholder: {
        id: "ai-mate.rovo-settings-modal.portable-rovo-settings.search-placeholder.non-final",
        defaultMessage: "Search settings"
    },
    defaultTriggerLabel: {
        id: "ai-mate.rovo-settings-modal.portable-rovo-settings.default-trigger-label.non-final",
        defaultMessage: "Explore all apps"
    }
});
module.exports["messages"] = $2c6792bc438bfd46$export$defe85febe8b728c;

});

parcelRegister("9dvYt", function(module, exports) {

let $6b5e2165537d224a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6b5e2165537d224a$var$load("kT6dz"),
    $6b5e2165537d224a$var$load("h0X0x"),
    $6b5e2165537d224a$var$load("7l4Nc"),
    $6b5e2165537d224a$var$load("6wr18"),
    $6b5e2165537d224a$var$load("7SteV"),
    $6b5e2165537d224a$var$load("64FEU"),
    $6b5e2165537d224a$var$load("7EorR"),
    $6b5e2165537d224a$var$load("Wowvf"),
    $6b5e2165537d224a$var$load("hhss7"),
    $6b5e2165537d224a$var$load("9zpfi"),
    $6b5e2165537d224a$var$load("9pNir"),
    $6b5e2165537d224a$var$load("he7Ox"),
    $6b5e2165537d224a$var$load("ffEVr"),
    $6b5e2165537d224a$var$load("8lMr1"),
    $6b5e2165537d224a$var$load("1vUE6"),
    $6b5e2165537d224a$var$load("7A87G"),
    $6b5e2165537d224a$var$load("cKDij")
]).then(()=>parcelRequire('7bLo5'));

});

parcelRegister("bg9GW", function(module, exports) {
$parcel$export(module.exports, "default", () => $8328b4ddc95230a8$export$2e2bcd8739ae039);

var $jO73f = parcelRequire("jO73f");


var $g93kp = parcelRequire("g93kp");


var $3yGK6 = parcelRequire("3yGK6");


var $byLBW = parcelRequire("byLBW");

function $8328b4ddc95230a8$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $3yGK6.default)(2, arguments);
    var diff = (0, $g93kp.default)(dateLeft, dateRight) / (0, $jO73f.millisecondsInHour);
    return (0, $byLBW.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("g93kp", function(module, exports) {
$parcel$export(module.exports, "default", () => $bc101184c63d7a7a$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $bc101184c63d7a7a$export$2e2bcd8739ae039(dateLeft, dateRight) {
    (0, $3yGK6.default)(2, arguments);
    return (0, $dkBOe.default)(dateLeft).getTime() - (0, $dkBOe.default)(dateRight).getTime();
}

});

parcelRegister("byLBW", function(module, exports) {
var $86a7cd36e9b99950$var$roundingMap = {
    ceil: Math.ceil,
    round: Math.round,
    floor: Math.floor,
    trunc: function trunc(value) {
        return value < 0 ? Math.ceil(value) : Math.floor(value);
    } // Math.trunc is not supported by IE
};
var $86a7cd36e9b99950$var$defaultRoundingMethod = 'trunc';
function $86a7cd36e9b99950$export$b6474a47258c1211(method) {
    return method ? $86a7cd36e9b99950$var$roundingMap[method] : $86a7cd36e9b99950$var$roundingMap[$86a7cd36e9b99950$var$defaultRoundingMethod];
}
module.exports["getRoundingMethod"] = $86a7cd36e9b99950$export$b6474a47258c1211;

});

parcelRegister("fNtG8", function(module, exports) {
$parcel$export(module.exports, "default", () => $b8027429ed7dcbe2$export$2e2bcd8739ae039);

var $jO73f = parcelRequire("jO73f");


var $g93kp = parcelRequire("g93kp");


var $3yGK6 = parcelRequire("3yGK6");


var $byLBW = parcelRequire("byLBW");

function $b8027429ed7dcbe2$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $3yGK6.default)(2, arguments);
    var diff = (0, $g93kp.default)(dateLeft, dateRight) / (0, $jO73f.millisecondsInMinute);
    return (0, $byLBW.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("aZ9If", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6dd963a85e6ff5109cc3c4973c0fbdf4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7ff722a3b4d1cbe6$var$_react = $7ff722a3b4d1cbe6$var$_interopRequireDefault((parcelRequire("cozmU")));

var $7ff722a3b4d1cbe6$var$_iconNew = $7ff722a3b4d1cbe6$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $7ff722a3b4d1cbe6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TeamworkGraph".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/teamwork-graph
 * Usage guidance:
 * Reserved for Teamwork Graph features.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7ff722a3b4d1cbe6$var$TeamworkGraphIcon = (props)=>/*#__PURE__*/ $7ff722a3b4d1cbe6$var$_react.default.createElement($7ff722a3b4d1cbe6$var$_iconNew.default, Object.assign({
        name: "TeamworkGraphIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.5 12.25a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0m8.5 0a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0m0-8.5a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0m-7 8.5a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0m-1.5-8.5a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0m1.5 0c0 .61-.169 1.18-.46 1.668l4.04 4.042a3.25 3.25 0 1 1-1.074 1.047L5.492 6.492A3.25 3.25 0 1 1 7 3.75m8.5 0a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0"/>`
    }, props));
$7ff722a3b4d1cbe6$var$TeamworkGraphIcon.displayName = 'TeamworkGraphIcon';
var $7ff722a3b4d1cbe6$var$_default = module.exports.default = $7ff722a3b4d1cbe6$var$TeamworkGraphIcon;

});

parcelRegister("f8dGE", function(module, exports) {

var $hGc5T = parcelRequire("hGc5T");

/** Used to compose bitmasks for cloning. */ var $b042384c0682c153$var$CLONE_DEEP_FLAG = 1, $b042384c0682c153$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $b042384c0682c153$var$cloneDeep(value) {
    return $hGc5T(value, $b042384c0682c153$var$CLONE_DEEP_FLAG | $b042384c0682c153$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $b042384c0682c153$var$cloneDeep;

});

parcelRegister("fOp0R", function(module, exports) {

var $bUA3T = parcelRequire("bUA3T");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/jira/site/manifest.ts
var $b82eed94c40664a5$var$jiraSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $bUA3T.JiraSiteAriResourceOwner),
    resourceType: (0, $bUA3T.JiraSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/jira/site/index.ts
var $b82eed94c40664a5$export$6c0f81f222d09301 = class _JiraSiteAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $b82eed94c40664a5$var$jiraSiteAriStaticOpts.qualifier,
            platformQualifier: $b82eed94c40664a5$var$jiraSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $b82eed94c40664a5$var$jiraSiteAriStaticOpts.resourceOwner,
            resourceType: $b82eed94c40664a5$var$jiraSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $b82eed94c40664a5$var$jiraSiteAriStaticOpts);
        return new _JiraSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $b82eed94c40664a5$var$jiraSiteAriStaticOpts);
        return new _JiraSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.resourceIdSegmentValues.siteId;
    }
};
module.exports["JiraSiteAri"] = $b82eed94c40664a5$export$6c0f81f222d09301;

});

parcelRegister("bUA3T", function(module, exports) {
// src/jira/site/types.ts
var $8ac0e5c8b2cbf8ed$export$b7d590981b504412 = "jira", $8ac0e5c8b2cbf8ed$export$886165a991f21644 = "site";
module.exports["JiraSiteAriResourceOwner"] = $8ac0e5c8b2cbf8ed$export$b7d590981b504412;
module.exports["JiraSiteAriResourceType"] = $8ac0e5c8b2cbf8ed$export$886165a991f21644;

});

parcelRegister("eRn3r", function(module, exports) {
$parcel$export(module.exports, "lazyForPaint", () => (parcelRequire("9aUDG")).lazyForPaint);
$parcel$export(module.exports, "lazy", () => (parcelRequire("9aUDG")).lazy);
$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("3QYdZ")).LazySuspense);
parcelRequire("jxKH9");
var $3Pobi = parcelRequire("3Pobi");


var $5a3Es = parcelRequire("5a3Es");


var $9aUDG = parcelRequire("9aUDG");

parcelRequire("6VSrF");
var $86UVJ = parcelRequire("86UVJ");
var $dHqFW = parcelRequire("dHqFW");

parcelRequire("hZz7i");
var $3QYdZ = parcelRequire("3QYdZ");


var $itHHy = parcelRequire("itHHy");


var $bvYi1 = parcelRequire("bvYi1");


});

parcelRegister("jxKH9", function(module, exports) {
$parcel$export(module.exports, "MODE", () => (parcelRequire("3Pobi")).MODE);

var $3Pobi = parcelRequire("3Pobi");

const $e3a55206c71bac9e$var$DEFAULT_CROSS_ORIGIN = undefined;
const $e3a55206c71bac9e$var$DEFAULT_MANIFEST = {
    publicPath: '/',
    assets: {}
};
const $e3a55206c71bac9e$var$DEFAULT_MODE = (0, $3Pobi.MODE).HYDRATE;
const $e3a55206c71bac9e$var$DEFAULT_RETRY = 2;
const $e3a55206c71bac9e$var$config = {
    crossOrigin: $e3a55206c71bac9e$var$DEFAULT_CROSS_ORIGIN,
    manifest: $e3a55206c71bac9e$var$DEFAULT_MANIFEST,
    mode: $e3a55206c71bac9e$var$DEFAULT_MODE,
    retry: $e3a55206c71bac9e$var$DEFAULT_RETRY
};
const $e3a55206c71bac9e$export$44487a86467333c3 = ()=>$e3a55206c71bac9e$var$config;
const $e3a55206c71bac9e$export$940a7873bb071df8 = (nextConfig)=>{
    var _nextConfig$crossOrig, _nextConfig$manifest, _nextConfig$mode, _nextConfig$retry;
    $e3a55206c71bac9e$var$config.crossOrigin = (_nextConfig$crossOrig = nextConfig.crossOrigin) != null ? _nextConfig$crossOrig : $e3a55206c71bac9e$var$DEFAULT_CROSS_ORIGIN;
    $e3a55206c71bac9e$var$config.manifest = (_nextConfig$manifest = nextConfig.manifest) != null ? _nextConfig$manifest : $e3a55206c71bac9e$var$DEFAULT_MANIFEST;
    $e3a55206c71bac9e$var$config.mode = (_nextConfig$mode = nextConfig.mode) != null ? _nextConfig$mode : $e3a55206c71bac9e$var$DEFAULT_MODE;
    $e3a55206c71bac9e$var$config.retry = (_nextConfig$retry = nextConfig.retry) != null ? _nextConfig$retry : $e3a55206c71bac9e$var$DEFAULT_RETRY;
};
module.exports["getConfig"] = $e3a55206c71bac9e$export$44487a86467333c3;
module.exports["setConfig"] = $e3a55206c71bac9e$export$940a7873bb071df8;

});

parcelRegister("3Pobi", function(module, exports) {
const $2c98e46ce94c4b5d$export$e48589d9e4824227 = {
    RENDER: 'RENDER',
    HYDRATE: 'HYDRATE'
};
module.exports["MODE"] = $2c98e46ce94c4b5d$export$e48589d9e4824227;

});

parcelRegister("5a3Es", function(module, exports) {

var $eegtN = parcelRequire("eegtN");


var $jxKH9 = parcelRequire("jxKH9");

parcelRequire("itHHy");
var $ehkpF = parcelRequire("ehkpF");
var $8r5Wf = parcelRequire("8r5Wf");


var $hBrZE = parcelRequire("hBrZE");

const $3c20b80e9e8d3df3$export$33c5f161e1d4706 = {
    init: (config)=>{
        (0, $jxKH9.setConfig)(config);
        (0, $ehkpF.LISTENERS).length = 0;
        (0, $8r5Wf.setCurrent)(0);
        if (!(0, $hBrZE.isNodeEnvironment)()) (0, $eegtN.collect)();
    }
};

});

parcelRegister("eegtN", function(module, exports) {

var $jxKH9 = parcelRequire("jxKH9");
var $3Pobi = parcelRequire("3Pobi");


var $gy5kI = parcelRequire("gy5kI");


var $4qzp5 = parcelRequire("4qzp5");


var $8WAU6 = parcelRequire("8WAU6");

const $a5bf27f95a5c4338$export$bb44f104e3c54dae = ()=>{
    const markers = document.querySelectorAll('input[data-lazy-begin]');
    const { mode: mode } = (0, $jxKH9.getConfig)();
    for(let i = 0, j = markers.length; i < j; i += 1){
        const el = markers[i];
        const { lazyBegin: lazyBegin } = el.dataset || {};
        const value = mode === (0, $3Pobi.MODE).RENDER ? (0, $4qzp5.cloneElements)(markers[i], lazyBegin) : (0, $8WAU6.refElements)(markers[i], lazyBegin);
        if ((0, $gy5kI.COLLECTED).has(lazyBegin)) (0, $gy5kI.COLLECTED).get(lazyBegin).push(value);
        else (0, $gy5kI.COLLECTED).set(lazyBegin, [
            value
        ]);
    }
};
module.exports["collect"] = $a5bf27f95a5c4338$export$bb44f104e3c54dae;

});

parcelRegister("gy5kI", function(module, exports) {
const $c0c3f558a37c633a$export$2cc7a2eaaea7809f = {
    PAINT: 0,
    AFTER_PAINT: 1,
    LAZY: 2
};
const $c0c3f558a37c633a$export$4831ef3968ea94ef = new Map();
module.exports["PHASE"] = $c0c3f558a37c633a$export$2cc7a2eaaea7809f;
module.exports["COLLECTED"] = $c0c3f558a37c633a$export$4831ef3968ea94ef;

});

parcelRegister("4qzp5", function(module, exports) {
const $33950d892bd67505$export$c42217d53a7ebafb = (fromEl, id)=>{
    const fragment = document.createElement('div');
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        // cloneNode is 50% faster than outerHTML/textContent
        fragment.appendChild(el.cloneNode(true));
    }
    return Array.from(fragment.childNodes);
};
module.exports["cloneElements"] = $33950d892bd67505$export$c42217d53a7ebafb;

});

parcelRegister("8WAU6", function(module, exports) {
const $68305ddfb331b362$export$c69443129766a7fc = (fromEl, id)=>{
    const result = [];
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        result.push(el);
    }
    return result;
};
module.exports["refElements"] = $68305ddfb331b362$export$c69443129766a7fc;

});

parcelRegister("itHHy", function(module, exports) {
$parcel$export(module.exports, "LazyPhaseContext", () => (parcelRequire("8r5Wf")).LazyPhaseContext);
$parcel$export(module.exports, "setCurrent", () => (parcelRequire("8r5Wf")).setCurrent);
$parcel$export(module.exports, "LISTENERS", () => (parcelRequire("ehkpF")).LISTENERS);

var $8r5Wf = parcelRequire("8r5Wf");


var $ehkpF = parcelRequire("ehkpF");


var $6h5l4 = parcelRequire("6h5l4");


});

parcelRegister("8r5Wf", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $gy5kI = parcelRequire("gy5kI");


var $ehkpF = parcelRequire("ehkpF");


var $6h5l4 = parcelRequire("6h5l4");

let $6245739e6eaab8ef$var$CURRENT_PHASE = (0, $gy5kI.PHASE).PAINT;
const $6245739e6eaab8ef$export$5f80f094fd31fffd = (phase)=>{
    $6245739e6eaab8ef$var$CURRENT_PHASE = phase;
    (0, $ehkpF.LISTENERS).slice(0).forEach((listener)=>listener(phase));
};
const $6245739e6eaab8ef$export$5a25eca35e5debcb = /*#__PURE__*/ (0, $cozmU.createContext)({
    subscribe: (0, $6h5l4.createSubscribe)((0, $ehkpF.LISTENERS)),
    currentValue: ()=>$6245739e6eaab8ef$var$CURRENT_PHASE,
    api: {
        startNextPhase: ()=>{
            $6245739e6eaab8ef$export$5f80f094fd31fffd((0, $gy5kI.PHASE).AFTER_PAINT);
        },
        resetPhase: ()=>$6245739e6eaab8ef$export$5f80f094fd31fffd((0, $gy5kI.PHASE).PAINT)
    }
});
const $6245739e6eaab8ef$export$1dc361b277327f88 = ()=>{
    const v = (0, $cozmU.useContext)($6245739e6eaab8ef$export$5a25eca35e5debcb);
    return v.api;
};
module.exports["setCurrent"] = $6245739e6eaab8ef$export$5f80f094fd31fffd;
module.exports["LazyPhaseContext"] = $6245739e6eaab8ef$export$5a25eca35e5debcb;

});

parcelRegister("ehkpF", function(module, exports) {
const $a6527ccf54714552$export$81b9c458a026d68f = [];
module.exports["LISTENERS"] = $a6527ccf54714552$export$81b9c458a026d68f;

});

parcelRegister("6h5l4", function(module, exports) {
const $491878cc97587aa1$export$364097d812234b3f = (listeners)=>(listener)=>{
        listeners.push(listener);
        return ()=>{
            const index = listeners.indexOf(listener);
            if (index !== -1) listeners.splice(index, 1);
        };
    };
module.exports["createSubscribe"] = $491878cc97587aa1$export$364097d812234b3f;

});

parcelRegister("hBrZE", function(module, exports) {
$parcel$export(module.exports, "hash", () => (parcelRequire("9fFjP")).default);

var $9fFjP = parcelRequire("9fFjP");

const $cd0b9b420a47cee1$export$d4c07b1daf44a7f = (m)=>'default' in m ? m.default : m;
const $cd0b9b420a47cee1$export$4429f98ef60d2d87 = (id)=>{
    const fName = id.split('/').slice(-3).join('/');
    return fName || 'Component';
};
const $cd0b9b420a47cee1$export$283635c04a02cc36 = ()=>{
    if (typeof window === "undefined" || window.name === 'nodejs') return true;
    return globalThis !== globalThis.window;
};
function $cd0b9b420a47cee1$export$62bf630d0de3d781(props, attr) {
    switch(attr.name){
        case 'style':
            break;
        case 'class':
            props.className = attr.value;
            break;
        case 'crossorigin':
            props.crossOrigin = attr.value;
            break;
        default:
            props[attr.name] = attr.value;
    }
    return props;
}
module.exports["getExport"] = $cd0b9b420a47cee1$export$d4c07b1daf44a7f;
module.exports["displayNameFromId"] = $cd0b9b420a47cee1$export$4429f98ef60d2d87;
module.exports["isNodeEnvironment"] = $cd0b9b420a47cee1$export$283635c04a02cc36;
module.exports["attrToProp"] = $cd0b9b420a47cee1$export$62bf630d0de3d781;

});

parcelRegister("9fFjP", function(module, exports) {
$parcel$export(module.exports, "default", () => $6bc590d7746b5907$export$2e2bcd8739ae039);
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $6bc590d7746b5907$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});

parcelRegister("9aUDG", function(module, exports) {

var $hXfAR = parcelRequire("hXfAR");


var $jxKH9 = parcelRequire("jxKH9");


var $gy5kI = parcelRequire("gy5kI");


var $hBrZE = parcelRequire("hBrZE");
var $9fFjP = parcelRequire("9fFjP");


var $aH9lN = parcelRequire("aH9lN");


var $ilEj6 = parcelRequire("ilEj6");


var $lJ3sU = parcelRequire("lJ3sU");


var $ajpr4 = parcelRequire("ajpr4");


var $67Nku = parcelRequire("67Nku");


var $edTIv = parcelRequire("edTIv");


var $17PxK = parcelRequire("17PxK");

function $6ae0fb8adbd87448$var$_extends() {
    $6ae0fb8adbd87448$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6ae0fb8adbd87448$var$_extends.apply(this, arguments);
}
function $6ae0fb8adbd87448$var$lazyProxy(_loader, { defer: defer = (0, $gy5kI.PHASE).PAINT, moduleId: moduleId = '', ssr: ssr = true } = {}) {
    const isServer = (0, $hBrZE.isNodeEnvironment)();
    const dataLazyId = (0, $9fFjP.default)(moduleId);
    const LazyInternal = isServer ? (0, $lJ3sU.createComponentServer)({
        dataLazyId: dataLazyId,
        defer: defer,
        loader: _loader,
        moduleId: moduleId,
        ssr: ssr
    }) : (0, $ilEj6.createComponentClient)({
        dataLazyId: dataLazyId,
        defer: defer,
        // We separate the preload from the retryable request, as we do not want the preload to contribute to retry
        // attempts, when the the loader fallback is used
        deferred: (0, $ajpr4.createDeferred)({
            loader: ()=>{
                const { retry: maxAttempts } = (0, $jxKH9.getConfig)();
                return (0, $edTIv.retry)(_loader, {
                    delay: (0, $aH9lN.RETRY_DELAY),
                    factor: (0, $aH9lN.RETRY_FACTOR),
                    maxAttempts: maxAttempts
                });
            },
            preload: _loader
        }),
        moduleId: moduleId
    });
    LazyInternal.displayName = `Lazy(${(0, $hBrZE.displayNameFromId)(moduleId)})`;
    /**
   * Allows getting module chunks urls
   */ const getAssetUrls = ()=>{
        const { manifest: manifest } = (0, $jxKH9.getConfig)();
        return (0, $hXfAR.getAssetUrlsFromId)(manifest, moduleId);
    };
    /**
   * Allows imperatively preload/ prefetch the module chunk asset
   */ const preload = (priority)=>{
        const p = priority != null ? priority : defer === (0, $gy5kI.PHASE).PAINT ? (0, $aH9lN.PRIORITY).HIGH : (0, $aH9lN.PRIORITY).LOW;
        return (0, $67Nku.preloadAsset)({
            loader: _loader,
            moduleId: moduleId,
            priority: p
        });
    };
    return Object.assign(LazyInternal, {
        getAssetUrls: getAssetUrls,
        preload: preload
    });
}
const $6ae0fb8adbd87448$export$93ca5d3f8675ae4c = {
    lazyForPaint: {
        ssr: true,
        defer: (0, $gy5kI.PHASE).PAINT
    },
    lazyAfterPaint: {
        ssr: true,
        defer: (0, $gy5kI.PHASE).AFTER_PAINT
    },
    lazy: {
        ssr: false,
        defer: (0, $gy5kI.PHASE).LAZY
    }
};
function $6ae0fb8adbd87448$export$c952e5f94576010e(loader, opts) {
    return $6ae0fb8adbd87448$var$lazyProxy(loader, $6ae0fb8adbd87448$var$_extends({}, $6ae0fb8adbd87448$export$93ca5d3f8675ae4c.lazyForPaint, opts || {}));
}
function $6ae0fb8adbd87448$export$291dd592399bdafa(loader, opts) {
    return $6ae0fb8adbd87448$var$lazyProxy(loader, $6ae0fb8adbd87448$var$_extends({}, $6ae0fb8adbd87448$export$93ca5d3f8675ae4c.lazyAfterPaint, opts || {}));
}
function $6ae0fb8adbd87448$export$488013bae63b21da(loader, opts) {
    return $6ae0fb8adbd87448$var$lazyProxy(loader, $6ae0fb8adbd87448$var$_extends({}, $6ae0fb8adbd87448$export$93ca5d3f8675ae4c.lazy, opts || {}));
}
module.exports["lazyForPaint"] = $6ae0fb8adbd87448$export$c952e5f94576010e;
module.exports["lazy"] = $6ae0fb8adbd87448$export$488013bae63b21da;

});

parcelRegister("hXfAR", function(module, exports) {
const $d1240ae4295f4288$export$303f43e55cf1ef2f = (manifest, id)=>{
    if (!manifest.assets[id]) return;
    return manifest.assets[id].map((asset)=>`${manifest.publicPath}${asset}`);
};
module.exports["getAssetUrlsFromId"] = $d1240ae4295f4288$export$303f43e55cf1ef2f;

});

parcelRegister("aH9lN", function(module, exports) {
const $7c952c608ad2380e$export$bb34f3538ba26c7e = {
    HIGH: 0,
    LOW: 2
};
const $7c952c608ad2380e$export$a339266ad71b2447 = 300;
const $7c952c608ad2380e$export$ba64c908e55507fe = 1;
module.exports["PRIORITY"] = $7c952c608ad2380e$export$bb34f3538ba26c7e;
module.exports["RETRY_DELAY"] = $7c952c608ad2380e$export$a339266ad71b2447;
module.exports["RETRY_FACTOR"] = $7c952c608ad2380e$export$ba64c908e55507fe;

});

parcelRegister("ilEj6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jxKH9 = parcelRequire("jxKH9");
var $3Pobi = parcelRequire("3Pobi");


var $gy5kI = parcelRequire("gy5kI");

parcelRequire("6VSrF");
var $dHqFW = parcelRequire("dHqFW");

parcelRequire("itHHy");
var $8r5Wf = parcelRequire("8r5Wf");

parcelRequire("hZz7i");
var $aZNtm = parcelRequire("aZNtm");


var $aH9lN = parcelRequire("aH9lN");


var $17PxK = parcelRequire("17PxK");


var $6adGO = parcelRequire("6adGO");


var $jl5l1 = parcelRequire("jl5l1");


var $67Nku = parcelRequire("67Nku");


var $bvYi1 = parcelRequire("bvYi1");


var $aiyJe = parcelRequire("aiyJe");

function $d5b97455f4530d40$export$6898b5504b58699a({ defer: defer, deferred: deferred, dataLazyId: dataLazyId, moduleId: moduleId }) {
    const { requestIdleCallback: requestIdleCallback = setTimeout } = window;
    const ResolvedLazy = /*#__PURE__*/ (0, $cozmU.lazy)(()=>deferred.promise);
    return (props)=>{
        // use a single piece of state to hold info about progress or eventually
        // throw an error. We do change it via direct mutation as re-renders
        // break Suspense in React 18, making it lose hydration state
        const [status, bubbleError] = (0, $cozmU.useState)(()=>({
                noWait: undefined,
                phase: defer === (0, $gy5kI.PHASE).AFTER_PAINT ? false : true,
                preloaded: defer === (0, $gy5kI.PHASE).AFTER_PAINT ? false : true,
                started: false
            }));
        const profiler = (0, $cozmU.useContext)((0, $bvYi1.ProfilerContext)).current;
        const load = ()=>{
            if (status.started || !status.phase || !status.noWait) return;
            status.started = true;
            let onResolve;
            if (profiler) {
                const eventInfo = {
                    identifier: moduleId
                };
                onResolve = ()=>{
                    profiler.onLoadComplete(eventInfo);
                };
                profiler.onLoadStart(eventInfo);
            }
            const result = deferred.start().catch((err)=>{
                // Throw the error within the component lifecycle
                // refer to https://github.com/facebook/react/issues/11409
                bubbleError(()=>{
                    throw (0, $17PxK.createLoaderError)(err);
                });
            });
            if (onResolve) result.then(onResolve);
        };
        // Subscribe to LazyWait context, triggering load when until is true
        (0, $aiyJe.useSubscription)({
            context: (0, $dHqFW.WaitContext),
            load: load,
            onValue: (v)=>status.noWait = v === 1
        });
        if (defer === (0, $gy5kI.PHASE).AFTER_PAINT) {
            // Subscribe to LazyPhase context, triggering load when own phase starts
            (0, $aiyJe.useSubscription)({
                context: (0, $8r5Wf.LazyPhaseContext),
                load: load,
                onValue: (v)=>status.phase = v >= defer
            });
            // Schedule preloading as will be needed soon
            (0, $cozmU.useMemo)(()=>{
                if (!status.preloaded) {
                    status.preloaded = true;
                    requestIdleCallback(()=>{
                        if (status.started) return;
                        (0, $67Nku.preloadAsset)({
                            loader: deferred.preload,
                            moduleId: moduleId,
                            priority: (0, $aH9lN.PRIORITY).LOW
                        });
                    });
                }
            }, [
                status
            ]);
        }
        const { setFallback: setFallback } = (0, $cozmU.useContext)((0, $aZNtm.LazySuspenseContext));
        (0, $cozmU.useMemo)(()=>{
            // find SSR content (or fallbacks) wrapped in inputs based on lazyId
            const content = ((0, $gy5kI.COLLECTED).get(dataLazyId) || []).shift();
            if (!content) return;
            // override Suspense fallback with magic input wrappers
            const component = (0, $jxKH9.getConfig)().mode === (0, $3Pobi.MODE).RENDER ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6adGO.PlaceholderFallbackRender), {
                id: dataLazyId,
                content: content
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jl5l1.PlaceholderFallbackHydrate), {
                id: dataLazyId,
                content: content
            });
            setFallback(component);
        }, [
            setFallback
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ResolvedLazy, props);
    };
}
module.exports["createComponentClient"] = $d5b97455f4530d40$export$6898b5504b58699a;

});

parcelRegister("6VSrF", function(module, exports) {
$parcel$export(module.exports, "WaitContext", () => (parcelRequire("dHqFW")).WaitContext);

var $dHqFW = parcelRequire("dHqFW");


var $86UVJ = parcelRequire("86UVJ");


});

parcelRegister("dHqFW", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $eYtLL = parcelRequire("eYtLL");

const $9f93fbb489094a52$export$9ba3fe09d15de47b = /*#__PURE__*/ (0, $cozmU.createContext)({
    subscribe: ()=>(0, $eYtLL.noopCleanup),
    currentValue: ()=>1
});
module.exports["WaitContext"] = $9f93fbb489094a52$export$9ba3fe09d15de47b;

});

parcelRegister("eYtLL", function(module, exports) {
const $ae6dc2e0431b9395$export$276c7dbda7675aec = ()=>{
// Nothing to cleanup...
};
module.exports["noopCleanup"] = $ae6dc2e0431b9395$export$276c7dbda7675aec;

});

parcelRegister("86UVJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dHqFW = parcelRequire("dHqFW");

const $5e7b0b64cd38d641$export$7bf6cf03fd32cddb = ({ until: until, children: children })=>{
    const closestWait = (0, $cozmU.useContext)((0, $dHqFW.WaitContext));
    const value = (0, $cozmU.useRef)(until && closestWait.currentValue() ? 1 : 0);
    const subscribers = (0, $cozmU.useRef)(new Set());
    const api = (0, $cozmU.useRef)({
        subscribe: (subscriber)=>{
            subscribers.current.add(subscriber);
            return ()=>{
                subscribers.current.delete(subscriber);
            };
        },
        currentValue: ()=>value.current
    });
    (0, $cozmU.useEffect)(()=>{
        // Notify subscribers when until prop or closest until value changes
        const notify = ()=>{
            value.current = closestWait.currentValue() && until ? 1 : 0;
            subscribers.current.forEach((subscriber)=>subscriber());
        };
        notify();
        return closestWait.subscribe(notify);
    }, [
        closestWait,
        until
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dHqFW.WaitContext).Provider, {
        value: api.current
    }, children);
};

});

parcelRegister("hZz7i", function(module, exports) {
$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("3QYdZ")).LazySuspense);
$parcel$export(module.exports, "LazySuspenseContext", () => (parcelRequire("aZNtm")).LazySuspenseContext);

var $3QYdZ = parcelRequire("3QYdZ");


var $aZNtm = parcelRequire("aZNtm");


});

parcelRegister("3QYdZ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $hBrZE = parcelRequire("hBrZE");


var $aZNtm = parcelRequire("aZNtm");

class $2ce4f1cfa8b44b57$export$256c542058532d6f extends (0, $cozmU.Component) {
    componentDidMount() {
        this.mounted = true;
    }
    renderFallback(outsideSuspense) {
        const { DynamicFallback: DynamicFallback } = this;
        // Use render prop component to allow switch to hydration fallback
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(DynamicFallback, {
            outsideSuspense: outsideSuspense
        }, (fallback)=>fallback);
    }
    renderServer() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aZNtm.LazySuspenseContext).Provider, {
            value: this.state
        }, this.props.children);
    }
    renderClient() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aZNtm.LazySuspenseContext).Provider, {
            value: this.state
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: this.renderFallback(false)
        }, this.props.children), (!this.mounted || this.hydrationFallback) && this.renderFallback(true));
    }
    render() {
        return (0, $hBrZE.isNodeEnvironment)() ? this.renderServer() : this.renderClient();
    }
    constructor(props){
        super(props);
        this.state = {
            // Used on server to render fallback down the tree
            fallback: this.props.fallback,
            // Used on client to replace fallback with magic input
            setFallback: (fallback)=>{
                if (this.hydrationFallback === fallback) return;
                this.hydrationFallback = fallback;
                // Schedule an update so we force switch from the sibling tree
                // back to the suspense boundary
                if (this.mounted) this.forceUpdate();
            }
        };
        this.hydrationFallback = null;
        this.mounted = false;
        this.DynamicFallback = ({ children: children, outsideSuspense: outsideSuspense })=>{
            // eslint-disable-next-line react-hooks/rules-of-hooks
            (0, $cozmU.useLayoutEffect)(()=>{
                return ()=>{
                    // the effect cleanup is called by the Suspense boundary itself
                    // when both Lazy AND the eventual promises thrown are done
                    // so Suspense will re-render with actual content and we remove
                    // the hydration fallback at the same time
                    if (!outsideSuspense) this.state.setFallback(null);
                };
            }, [
                outsideSuspense
            ]);
            return outsideSuspense ? children(this.hydrationFallback ? this.hydrationFallback : null) : children(this.hydrationFallback ? null : this.props.fallback);
        };
        this.DynamicFallback.displayName = 'DynamicFallback';
    }
}
module.exports["LazySuspense"] = $2ce4f1cfa8b44b57$export$256c542058532d6f;

});

parcelRegister("aZNtm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $8015fa1bd12f3c41$export$c33990e84065970c = /*#__PURE__*/ (0, $cozmU.createContext)({
    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null),
    setFallback: ()=>{
        console.warn('Missing <LooselySuspense /> boundary');
    }
});
module.exports["LazySuspenseContext"] = $8015fa1bd12f3c41$export$c33990e84065970c;

});

parcelRegister("17PxK", function(module, exports) {
const $0d1e6d5848f254be$export$6aa69c1258005366 = Symbol.for('react-loosely-lazy/loader-error');
const $0d1e6d5848f254be$export$c73a6a6f0bf7d425 = (error)=>{
    if (typeof error === 'object') // @ts-expect-error Explicitly untyped
    return Object.assign(error, {
        [$0d1e6d5848f254be$export$6aa69c1258005366]: true
    });
    return error;
};
const $0d1e6d5848f254be$export$16a03aca4a3508b4 = (error)=>Object.getOwnPropertySymbols(error).includes($0d1e6d5848f254be$export$6aa69c1258005366);
module.exports["createLoaderError"] = $0d1e6d5848f254be$export$c73a6a6f0bf7d425;

});

parcelRegister("6adGO", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $47ce4bb11269d032$var$isLinkPrefetch(el) {
    return el.tagName === 'LINK' && el.rel === 'prefetch';
}
const $47ce4bb11269d032$var$usePlaceholderRender = (resolveId, content)=>{
    const hydrationRef = (0, $cozmU.useRef)(null);
    const { current: ssrDomNodes } = (0, $cozmU.useRef)(content || []);
    (0, $cozmU.useLayoutEffect)(()=>{
        const element = hydrationRef.current;
        const { parentNode: parentNode } = element || {};
        if (parentNode && !parentNode.contains(ssrDomNodes[0])) ssrDomNodes.reverse().forEach((node)=>{
            // this fixes an issue with Chrome that re-triggers and cancels prefetch
            // when node is appended again, making network panel quite noisy
            if ($47ce4bb11269d032$var$isLinkPrefetch(node)) node.rel = '';
            parentNode.insertBefore(node, element.nextSibling);
        });
        return ()=>{
            ssrDomNodes.forEach((node)=>{
                var _node$parentNode;
                return (_node$parentNode = node.parentNode) == null ? void 0 : _node$parentNode.removeChild(node);
            });
        };
    // [hydrationRef.current, ssrDomNodes] are expected to be stable
    // with the second one never changing by design and the first one changing after first render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return hydrationRef;
};
const $47ce4bb11269d032$export$d55db778a3e1446b = ({ id: id, content: content })=>{
    const placeholderRef = $47ce4bb11269d032$var$usePlaceholderRender(id, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id,
        ref: placeholderRef
    });
};
module.exports["PlaceholderFallbackRender"] = $47ce4bb11269d032$export$d55db778a3e1446b;

});

parcelRegister("jl5l1", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $hBrZE = parcelRequire("hBrZE");

function $e1441e868bb78192$var$_extends() {
    $e1441e868bb78192$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e1441e868bb78192$var$_extends.apply(this, arguments);
}
const $e1441e868bb78192$export$ca5b8fbc835d95e4 = ({ id: id, content: content })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id
    }), content.map((el, i)=>{
        const { tagName: tagName = '', childNodes: childNodes = [], attributes: attributes = [] } = el;
        const props = Array.from(attributes).reduce((0, $hBrZE.attrToProp), {
            key: String(i)
        });
        // text node
        if (!tagName) return /*#__PURE__*/ (0, $cozmU.createElement)((0, $cozmU.Fragment), props, el.textContent);
        // childless tag
        if (!childNodes.length) return /*#__PURE__*/ (0, $cozmU.createElement)(tagName.toLowerCase(), props);
        // tag with content
        return /*#__PURE__*/ (0, $cozmU.createElement)(tagName.toLowerCase(), $e1441e868bb78192$var$_extends({}, props, {
            dangerouslySetInnerHTML: {
                __html: ''
            },
            suppressHydrationWarning: true
        }));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
        type: "hidden",
        "data-lazy-end": id
    }));
};
module.exports["PlaceholderFallbackHydrate"] = $e1441e868bb78192$export$ca5b8fbc835d95e4;

});

parcelRegister("67Nku", function(module, exports) {

var $hXfAR = parcelRequire("hXfAR");


var $eYtLL = parcelRequire("eYtLL");


var $jxKH9 = parcelRequire("jxKH9");


var $hBrZE = parcelRequire("hBrZE");


var $aH9lN = parcelRequire("aH9lN");


var $2mjKV = parcelRequire("2mjKV");


var $bvYi1 = parcelRequire("bvYi1");

function $4759a958e17e309b$export$3af04dbcb01bad4d({ moduleId: moduleId, rel: rel }) {
    const { manifest: manifest } = (0, $jxKH9.getConfig)();
    const assets = (0, $hXfAR.getAssetUrlsFromId)(manifest, moduleId);
    if (!assets) throw new Error('Unsupported preload strategy');
    const cleanupLinkTags = assets.map((url)=>(0, $2mjKV.insertLinkTag)(url, rel));
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
const $4759a958e17e309b$var$fakePromise = {
    then: ()=>$4759a958e17e309b$var$fakePromise,
    catch: ()=>$4759a958e17e309b$var$fakePromise,
    finally: ()=>$4759a958e17e309b$var$fakePromise
};
function $4759a958e17e309b$export$1046fd6a49d5e7a({ loader: loader, rel: rel }) {
    if (typeof __webpack_require__ === 'undefined' || typeof __webpack_get_script_filename__ === 'undefined') throw new Error('Unsupported preload strategy');
    // Replace requireEnsure to create link tags instead of scripts
    const requireEnsure = __webpack_require__.e;
    const cleanupLinkTags = [];
    __webpack_require__.e = function requirePreload(chunkId) {
        const href = __webpack_get_script_filename__(chunkId);
        cleanupLinkTags.push((0, $2mjKV.insertLinkTag)(href, rel));
        return $4759a958e17e309b$var$fakePromise;
    };
    try {
        loader();
    } catch (err) {
    // Ignore any errors
    }
    // Restore real webpack require ensure
    __webpack_require__.e = requireEnsure;
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
function $4759a958e17e309b$export$eb05139fa4dcf992({ loader: loader }) {
    loader();
    return 0, $eYtLL.noopCleanup;
}
function $4759a958e17e309b$export$25bad4aa00c45355({ loader: loader, moduleId: moduleId, priority: priority }) {
    var _GlobalReactLooselyLa;
    if ((0, $hBrZE.isNodeEnvironment)()) return 0, $eYtLL.noopCleanup;
    (_GlobalReactLooselyLa = (0, $bvYi1.GlobalReactLooselyLazyProfiler).current) == null || _GlobalReactLooselyLa.onPreload(moduleId, priority);
    const rel = priority === (0, $aH9lN.PRIORITY).HIGH ? 'preload' : 'prefetch';
    const preloadStrategies = [
        $4759a958e17e309b$export$3af04dbcb01bad4d,
        $4759a958e17e309b$export$1046fd6a49d5e7a,
        $4759a958e17e309b$export$eb05139fa4dcf992
    ];
    for (const strategy of preloadStrategies)try {
        return strategy({
            loader: loader,
            moduleId: moduleId,
            rel: rel
        });
    } catch (_) {
    // Try next strategy...
    }
    return 0, $eYtLL.noopCleanup;
}
module.exports["preloadAsset"] = $4759a958e17e309b$export$25bad4aa00c45355;

});

parcelRegister("2mjKV", function(module, exports) {

var $bvYi1 = parcelRequire("bvYi1");


var $eYtLL = parcelRequire("eYtLL");


var $jxKH9 = parcelRequire("jxKH9");

function $1b7cf5f1f73f5f76$export$6610512821c8a4ce(href, rel) {
    var _document$head;
    // Skip if already preloaded, prefetched, or loaded
    if (document.querySelector(`link[href="${href}"]`) || document.querySelector(`script[src="${href}"]`)) return 0, $eYtLL.noopCleanup;
    const { crossOrigin: crossOrigin } = (0, $jxKH9.getConfig)();
    const link = document.createElement('link');
    link.rel = rel;
    link.as = 'script';
    if (crossOrigin) link.crossOrigin = crossOrigin;
    link.href = href;
    const profiler = (0, $bvYi1.GlobalReactLooselyLazyProfiler).current;
    let removableListener = null;
    if (profiler) {
        const eventInfo = {
            identifier: href
        };
        const listener = ()=>{
            link.removeEventListener('onload', listener);
            removableListener = null;
            profiler.onLoadComplete(eventInfo);
        };
        link.addEventListener('onload', listener);
        removableListener = listener;
        profiler.onLoadStart(eventInfo);
    }
    (_document$head = document.head) == null || _document$head.appendChild(link);
    return ()=>{
        // Remove the link if it is still in the document head
        if (link.parentNode === document.head) {
            var _document$head2;
            (_document$head2 = document.head) == null || _document$head2.removeChild(link);
        }
        if (removableListener) link.removeEventListener('onload', removableListener);
    };
}
module.exports["insertLinkTag"] = $1b7cf5f1f73f5f76$export$6610512821c8a4ce;

});

parcelRegister("bvYi1", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $86215b3df1759e88$export$e2d53c0cbedd2710 = {
    current: null
};
const $86215b3df1759e88$export$8146ab57a3f7a7cb = /*#__PURE__*/ (0, $cozmU.createContext)($86215b3df1759e88$export$e2d53c0cbedd2710);
module.exports["GlobalReactLooselyLazyProfiler"] = $86215b3df1759e88$export$e2d53c0cbedd2710;
module.exports["ProfilerContext"] = $86215b3df1759e88$export$8146ab57a3f7a7cb;

});

parcelRegister("aiyJe", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $77f6862aa953f5ea$export$368b4214baeb914c({ context: context, load: load, onValue: onValue }) {
    const { subscribe: subscribe, currentValue: currentValue } = (0, $cozmU.useContext)(context);
    (0, $cozmU.useMemo)(()=>{
        let unsubscribe = null;
        const check = ()=>{
            const done = onValue(currentValue());
            if (done) load();
            if (done && unsubscribe) unsubscribe();
            return done;
        };
        unsubscribe = !check() ? subscribe(check) : null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
module.exports["useSubscription"] = $77f6862aa953f5ea$export$368b4214baeb914c;

});

parcelRegister("lJ3sU", function(module, exports) {

var $hXfAR = parcelRequire("hXfAR");


var $cozmU = parcelRequire("cozmU");


var $jxKH9 = parcelRequire("jxKH9");


var $gy5kI = parcelRequire("gy5kI");

parcelRequire("hZz7i");
var $aZNtm = parcelRequire("aZNtm");


var $hBrZE = parcelRequire("hBrZE");


var $17PxK = parcelRequire("17PxK");

function $fd107d191750b962$var$load(moduleId, loader) {
    try {
        return (0, $hBrZE.getExport)(loader());
    } catch (err) {
        throw (0, $17PxK.createLoaderError)(err);
    }
}
function $fd107d191750b962$export$eb2e4b04351cdd9e({ dataLazyId: dataLazyId, defer: defer, loader: loader, moduleId: moduleId, ssr: ssr }) {
    return (props)=>{
        var _getAssetUrlsFromId;
        const Resolved = ssr ? $fd107d191750b962$var$load(moduleId, loader) : null;
        const { fallback: fallback } = (0, $cozmU.useContext)((0, $aZNtm.LazySuspenseContext));
        const { crossOrigin: crossOrigin, manifest: manifest } = (0, $jxKH9.getConfig)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
            type: "hidden",
            "data-lazy-begin": dataLazyId
        }), defer !== (0, $gy5kI.PHASE).LAZY && ((_getAssetUrlsFromId = (0, $hXfAR.getAssetUrlsFromId)(manifest, moduleId)) == null ? void 0 : _getAssetUrlsFromId.map((url)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("link", {
                key: url,
                rel: defer === (0, $gy5kI.PHASE).PAINT ? 'preload' : 'prefetch',
                href: url,
                crossOrigin: crossOrigin,
                as: "script"
            }))), Resolved ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Resolved, props) : fallback, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
            type: "hidden",
            "data-lazy-end": dataLazyId
        }));
    };
}
module.exports["createComponentServer"] = $fd107d191750b962$export$eb2e4b04351cdd9e;

});

parcelRegister("ajpr4", function(module, exports) {
const $781f68b739b0ef47$export$e673efccd97e4223 = ({ loader: loader, preload: preload })=>{
    let resolve;
    const deferred = {
        promise: new Promise((res)=>{
            resolve = (m)=>{
                let withDefault;
                deferred.result = m;
                if (!m.default) withDefault = {
                    default: m
                };
                res(withDefault ? withDefault : m);
            };
        }),
        result: undefined,
        preload: function(_preload) {
            function preload() {
                return _preload.apply(this, arguments);
            }
            preload.toString = function() {
                return _preload.toString();
            };
            return preload;
        }(()=>{
            if (deferred.result) return;
            preload().then((m)=>{
                deferred.result = m;
            }).catch(()=>{
            // Do nothing...
            });
        }),
        start: ()=>{
            if (deferred.result) {
                resolve(deferred.result);
                return Promise.resolve();
            }
            // Make a new loader request when none have started or resolved yet
            return loader().then(resolve);
        }
    };
    return deferred;
};
module.exports["createDeferred"] = $781f68b739b0ef47$export$e673efccd97e4223;

});

parcelRegister("edTIv", function(module, exports) {
const $a5ad7fc44a458961$var$calculateDelay = (context, policy)=>{
    const { attempt: attempt } = context;
    const { delay: delay, factor: factor } = policy;
    const retryAttempt = attempt - 1;
    // Do not use a delay on the first retry, or when the configured delay is 0
    if (retryAttempt === 1 || delay === 0) return 0;
    // Linear factor, like: https://github.com/Polly-Contrib/Polly.Contrib.WaitAndRetry#wait-and-retry-with-linear-back-off
    const add = factor * delay;
    return delay + add * (retryAttempt - 2);
};
const $a5ad7fc44a458961$var$sleep = (delay)=>new Promise((resolve)=>setTimeout(resolve, delay));
const $a5ad7fc44a458961$var$getPolicy = (configuration)=>{
    var _configuration$delay, _configuration$factor, _configuration$maxAtt;
    return {
        delay: Math.max(0, (_configuration$delay = configuration.delay) != null ? _configuration$delay : 0),
        factor: Math.max(0, (_configuration$factor = configuration.factor) != null ? _configuration$factor : 0),
        maxAttempts: Math.max(0, (_configuration$maxAtt = configuration.maxAttempts) != null ? _configuration$maxAtt : 0)
    };
};
function $a5ad7fc44a458961$export$9369b12211e1fce4(retryable, policyConfiguration = {}) {
    const policy = $a5ad7fc44a458961$var$getPolicy(policyConfiguration);
    const { maxAttempts: maxAttempts } = policy;
    const context = {
        attempt: 1,
        attemptsRemaining: maxAttempts
    };
    const onError = async (err)=>{
        if (context.attemptsRemaining === 0) throw err;
        context.attempt += 1;
        context.attemptsRemaining -= 1;
        const delay = $a5ad7fc44a458961$var$calculateDelay(context, policy);
        if (delay) await $a5ad7fc44a458961$var$sleep(delay);
        return retryable().catch(onError);
    };
    return retryable().catch(onError);
}
module.exports["retry"] = $a5ad7fc44a458961$export$9369b12211e1fce4;

});

parcelRegister("isuYJ", function(module, exports) {

var $d5Ozc = parcelRequire("d5Ozc");

function $a1048cda8104f400$export$691e93bad45e6f07(condition, newHook, oldHook) {
    const hookFn = (...args)=>{
        // call each time so we can track exposures
        const conditionResult = condition();
        const cache = globalThis[0, $d5Ozc.CACHE_MAP_KEY];
        if (!cache.has(hookFn)) cache.set(hookFn, conditionResult);
        if (cache.get(hookFn)) return newHook(...args);
        else return oldHook(...args);
    };
    return hookFn;
}
module.exports["conditionalHooksFactory"] = $a1048cda8104f400$export$691e93bad45e6f07;

});

parcelRegister("d5Ozc", function(module, exports) {
const $dacf5aee5e6a9a5a$export$3c82709bf1b7e3a = '__conditionalHooksFactory_conditionCacheMap_dont_modify_this_manually_unless_you_want_react_to_blow_up';
globalThis[$dacf5aee5e6a9a5a$export$3c82709bf1b7e3a] = globalThis[$dacf5aee5e6a9a5a$export$3c82709bf1b7e3a] || new WeakMap();
module.exports["CACHE_MAP_KEY"] = $dacf5aee5e6a9a5a$export$3c82709bf1b7e3a;

});

parcelRegister("6ojvx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

parcelRequire("bLswh");
var $hBxDy = parcelRequire("hBxDy");

const $59e5036a3fbf2e2e$export$6a671bebd9daad64 = (0, $cozmU.createContext)((0, $hBxDy.ProductEnvironment).PRODUCTION);
module.exports["EnvironmentContext"] = $59e5036a3fbf2e2e$export$6a671bebd9daad64;

});

parcelRegister("bLswh", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("hBxDy")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("hBxDy")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2zscg")).ExtensionEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2zscg")).ConfluenceExtension);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2zscg")).JiraExtension);
parcelRequire("9iaDP");
var $2zscg = parcelRequire("2zscg");
var $hBxDy = parcelRequire("hBxDy");

parcelRequire("gwrSD");
var $hcYP2 = parcelRequire("hcYP2");
var $31kME = parcelRequire("31kME");
var $d8yi8 = parcelRequire("d8yi8");


});

parcelRegister("9iaDP", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("hBxDy")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("hBxDy")).ForgeCDNEnvironment);
$parcel$export(module.exports, "BitbucketExtension", () => (parcelRequire("2zscg")).BitbucketExtension);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2zscg")).ConfluenceExtension);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2zscg")).ExtensionEnvironment);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2zscg")).JiraExtension);
$parcel$export(module.exports, "GlobalExtension", () => (parcelRequire("2zscg")).GlobalExtension);

var $2y56N = parcelRequire("2y56N");


var $hBxDy = parcelRequire("hBxDy");


var $iztBQ = parcelRequire("iztBQ");


var $2zscg = parcelRequire("2zscg");


});

parcelRegister("2y56N", function(module, exports) {
const $43f88a3108220757$export$3b98ab6402702476 = [
    'Em',
    'Link',
    'Strike',
    'String',
    'Strong',
    'User'
];
const $43f88a3108220757$export$3ee8c58bb87b9685 = [
    ...$43f88a3108220757$export$3b98ab6402702476,
    'Badge',
    'Code',
    'DateLozenge',
    'StatusLozenge',
    'Tag',
    'UserGroup'
];

});

parcelRegister("iztBQ", function(module, exports) {
const $6db1db68019c99c9$export$21b318cfdd670495 = (error)=>({
        type: 'render',
        aux: {
            type: 'View',
            children: [
                {
                    type: 'ErrorPanel',
                    props: {
                        error: error
                    },
                    children: []
                }
            ]
        },
        state: {}
    });

});

parcelRegister("gwrSD", function(module, exports) {

var $d8yi8 = parcelRequire("d8yi8");


var $31kME = parcelRequire("31kME");


var $hcYP2 = parcelRequire("hcYP2");


});

parcelRegister("d8yi8", function(module, exports) {
// DELETE FILE http://go/j/FUI-1091
const $487f0b3478e8e725$export$7e816460364ed464 = (effect)=>{
    return effect.type === 'initialize';
};
const $487f0b3478e8e725$export$eb5bd7f371e458af = (effect)=>{
    return effect.type === 'action';
};
const $487f0b3478e8e725$export$f632ad3064955f31 = (effect)=>{
    return effect.type === 'event';
};
const $487f0b3478e8e725$export$dfeb34e64fee2572 = (effect)=>{
    return effect.type === 'render';
};
function $487f0b3478e8e725$export$20b9f6acb0888554(effect) {
    return $487f0b3478e8e725$export$7e816460364ed464(effect) || $487f0b3478e8e725$export$eb5bd7f371e458af(effect) || $487f0b3478e8e725$export$f632ad3064955f31(effect);
}

});

parcelRegister("31kME", function(module, exports) {
const $7d3783c6a9539d7e$export$709a27a9f80556b8 = (effect)=>{
    return effect.type === 'event';
};
const $7d3783c6a9539d7e$export$65d7078e01574f24 = (effect)=>{
    return effect.type === 'action';
};
const $7d3783c6a9539d7e$export$8089f608f1d0c22d = (effect)=>{
    return effect.type === 'render';
};
const $7d3783c6a9539d7e$export$84909efba3133df = (effect)=>{
    return effect.type === 'result';
};
function $7d3783c6a9539d7e$export$caa8cab0db5b0a61(effect) {
    return $7d3783c6a9539d7e$export$65d7078e01574f24(effect) || $7d3783c6a9539d7e$export$709a27a9f80556b8(effect) || $7d3783c6a9539d7e$export$8089f608f1d0c22d(effect);
}

});

parcelRegister("hcYP2", function(module, exports) {
// From forge.ts
const $1da5394af23f0a63$export$3ab8eca5875a9c7e = (auxNode)=>{
    return auxNode !== null && typeof auxNode !== 'boolean' && auxNode !== undefined;
};
var $1da5394af23f0a63$export$c8914e6b1e019577 = /*#__PURE__*/ function(EcosystemLicenseMode) {
    EcosystemLicenseMode["USER_ACCESS"] = "USER_ACCESS";
    return EcosystemLicenseMode;
}({});
const $1da5394af23f0a63$export$a3b8d8814f1b9262 = (context)=>context.type === 'jira';
const $1da5394af23f0a63$export$d8e8de7bd6b731b7 = (extensionContext)=>extensionContext.type === 'issuePanel';
const $1da5394af23f0a63$export$1404d10ac8f82a03 = (extensionContext)=>extensionContext.type === 'contextConfig';
const $1da5394af23f0a63$export$9e5e0ca9e718a261 = (extensionContext)=>extensionContext.type === 'customField' || extensionContext.type === 'customFieldType';
const $1da5394af23f0a63$export$881df9824c17587a = (extensionContext)=>extensionContext.type === 'confluence:attachmentAction';
const $1da5394af23f0a63$export$2f4ddb77a2467d4a = (extensionContext)=>extensionContext.type === 'contextMenu';
const $1da5394af23f0a63$export$dfe2b8f5623b1a39 = (extensionContext)=>extensionContext.type === 'contentAction';
const $1da5394af23f0a63$export$aee7a41cc3ed0e4 = (extensionContext)=>extensionContext.type === 'dashboardGadget';
var $1da5394af23f0a63$export$24835b97bd9481e3 = /*#__PURE__*/ function(CompassContextTypes) {
    CompassContextTypes["AdminPage"] = "compass:adminPage";
    CompassContextTypes["ComponentPage"] = "compass:componentPage";
    CompassContextTypes["TeamPage"] = "compass:teamPage";
    CompassContextTypes["ComponentImporter"] = "compass:componentImporter";
    return CompassContextTypes;
}({});
var $1da5394af23f0a63$export$1718b7e1799fa866 = /*#__PURE__*/ function(RenderingLocations) {
    RenderingLocations["AppConfigurationPage"] = "appConfigurationPage";
    RenderingLocations["OnboardingFlow"] = "onboardingFlow";
    return RenderingLocations;
}({});

});

parcelRegister("ix7El", function(module, exports) {
var $04c5b557f78447f3$export$d76ef0f862d061a6 = /*#__PURE__*/ function(GQLExtensionContextsFilterType) {
    GQLExtensionContextsFilterType["Container"] = "CONTAINER";
    GQLExtensionContextsFilterType["DataClassificationTag"] = "DATA_CLASSIFICATION_TAG";
    GQLExtensionContextsFilterType["ExtensionType"] = "EXTENSION_TYPE";
    GQLExtensionContextsFilterType["PrincipalType"] = "PRINCIPAL_TYPE";
    GQLExtensionContextsFilterType["AppIdEnvironmentId"] = "APP_ID_ENVIRONMENT_ID";
    return GQLExtensionContextsFilterType;
}({});
const $04c5b557f78447f3$export$1a949ef92fd30eca = (error)=>{
    return error instanceof Error && error.name === 'RelayNetwork' && 'source' in error && Array.isArray(error.source?.errors);
};
const $04c5b557f78447f3$export$8d1c210bc17223c1 = (err)=>err.extensions && err.extensions.errorSource && err.extensions.errorSource === 'GRAPHQL_GATEWAY';
const $04c5b557f78447f3$export$9c0545f564a8227f = (err)=>err.extensions && err.extensions.errorSource && err.extensions.errorSource === 'UNDERLYING_SERVICE';
module.exports["GQLExtensionContextsFilterType"] = $04c5b557f78447f3$export$d76ef0f862d061a6;
module.exports["isRelayNetworkError"] = $04c5b557f78447f3$export$1a949ef92fd30eca;
module.exports["isGQLGatewayError"] = $04c5b557f78447f3$export$8d1c210bc17223c1;
module.exports["isGQLUnderlyingServiceError"] = $04c5b557f78447f3$export$9c0545f564a8227f;

});

parcelRegister("4K6lC", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $852mP = parcelRequire("852mP");


var $3d3WW = parcelRequire("3d3WW");


var $cXtTj = parcelRequire("cXtTj");

const $a3a18abb8f8abee5$export$d28801614368e543 = 'forge-ui';
const $a3a18abb8f8abee5$export$7329bcdc3edcd90e = (client)=>(event)=>{
        switch(event.eventType){
            case 0, $852mP.UI_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendUIEvent(event));
                break;
            case 0, $852mP.OPERATIONAL_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendOperationalEvent(event));
                break;
            case 0, $852mP.TRACK_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendTrackEvent(event));
                break;
            case 0, $852mP.SCREEN_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendScreenEvent(event));
                break;
        }
    };
/** extract the attributes from event context which should be in the top-level payload */ function $a3a18abb8f8abee5$var$getPayloadAttributesFromContext(contexts) {
    return (contexts.find((obj)=>obj && obj.forgeUIAnalyticsContext) ?? {}).forgeUIAnalyticsContext ?? {};
}
// Merge forgeUIAttributes from outermost to innermost analytics contexts, so child contexts can
// override parent values in the final payload. If an inner context replaces extensionKey, keep the
// previous extensionKey separately so embedded macro events can report it as parentExtensionKey.
function $a3a18abb8f8abee5$var$getForgeUIAttributesFromContext(contexts) {
    return contexts.reduce((prev, curr)=>{
        // Only extract attributes passed as an object via the forgeUIAttributes key
        const forgeUIAttributes = curr && curr.forgeUIAttributes && typeof curr.forgeUIAttributes === 'object' ? curr.forgeUIAttributes : {};
        const previousExtensionKey = prev.forgeUIAttributes.extensionKey;
        const nextExtensionKey = forgeUIAttributes.extensionKey;
        const isExtensionKeyOverridden = Boolean(previousExtensionKey && nextExtensionKey && previousExtensionKey !== nextExtensionKey);
        // Capture the first extensionKey that gets replaced by a nested context. That replaced
        // value is the parent macro key once a child renderer context contributes its own key.
        const overriddenExtensionKey = prev.overriddenExtensionKey ?? (isExtensionKeyOverridden ? previousExtensionKey : undefined);
        return {
            forgeUIAttributes: {
                ...prev.forgeUIAttributes,
                ...forgeUIAttributes
            },
            overriddenExtensionKey: overriddenExtensionKey
        };
    }, {
        forgeUIAttributes: {}
    });
}
const $a3a18abb8f8abee5$var$ForgeUIAnalyticsListener = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { children: children, client: client, commonAttributes: t1 } = t0;
    let t2;
    if ($[0] !== t1) {
        t2 = t1 === undefined ? {} : t1;
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const commonAttributes = t2;
    let t3;
    if ($[2] !== client || $[3] !== commonAttributes) {
        t3 = (event)=>{
            const { eventType: eventType, data: data } = event.payload;
            const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes, tags: tags, source: sourceFromEvent } = data;
            const forgeUIAnalyticsContext = $a3a18abb8f8abee5$var$getPayloadAttributesFromContext(event.context);
            const source = sourceFromEvent ?? forgeUIAnalyticsContext.source ?? "unknown";
            let nestingAnalyticsAttributes;
            if ((0, $cXtTj.default).getExperimentValue("platform_forge_nesting_analytics", "isEnabled", false)) {
                const { forgeUIAttributes: forgeUIAttributes, overriddenExtensionKey: overriddenExtensionKey } = $a3a18abb8f8abee5$var$getForgeUIAttributesFromContext(event.context);
                let parentExtensionKey = {};
                if (action === "rendered" && actionSubject === "forge.ui.renderer" && forgeUIAttributes.isEmbeddedMacro && overriddenExtensionKey) parentExtensionKey = {
                    parentExtensionKey: overriddenExtensionKey
                };
                else if (action === "rendered" && actionSubject === "forge.ui.bodied_macro_embedded_content" && attributes?.extensionKey && forgeUIAttributes.extensionKey) parentExtensionKey = {
                    parentExtensionKey: forgeUIAttributes.extensionKey
                };
                nestingAnalyticsAttributes = {
                    ...forgeUIAttributes,
                    ...parentExtensionKey
                };
            }
            const payload = {
                action: action,
                actionSubject: actionSubject,
                actionSubjectId: actionSubjectId,
                ...forgeUIAnalyticsContext,
                source: source,
                attributes: {
                    ...commonAttributes,
                    ...nestingAnalyticsAttributes ?? event.context.reduce($a3a18abb8f8abee5$var$_temp, {}),
                    ...attributes
                },
                tags: tags
            };
            $a3a18abb8f8abee5$export$7329bcdc3edcd90e(client)({
                eventType: eventType,
                ...payload
            });
        };
        $[2] = client;
        $[3] = commonAttributes;
        $[4] = t3;
    } else t3 = $[4];
    const listenerHandler = t3;
    let t4;
    if ($[5] !== children || $[6] !== listenerHandler) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
            onEvent: listenerHandler,
            channel: $a3a18abb8f8abee5$export$d28801614368e543
        }, children);
        $[5] = children;
        $[6] = listenerHandler;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : ({ children: children, client: client, commonAttributes: commonAttributes = {} })=>{
    const listenerHandler = (event)=>{
        const { eventType: eventType, data: data } = event.payload;
        const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes, tags: tags, source: sourceFromEvent } = data;
        const forgeUIAnalyticsContext = $a3a18abb8f8abee5$var$getPayloadAttributesFromContext(event.context);
        const source = sourceFromEvent ?? forgeUIAnalyticsContext.source ?? 'unknown';
        // Use the merged nested context attributes and add parentExtensionKey for embedded macro
        // events that override extensionKey.
        let nestingAnalyticsAttributes;
        if ((0, $cXtTj.default).getExperimentValue('platform_forge_nesting_analytics', 'isEnabled', false)) {
            const { forgeUIAttributes: forgeUIAttributes, overriddenExtensionKey: overriddenExtensionKey } = $a3a18abb8f8abee5$var$getForgeUIAttributesFromContext(event.context);
            let parentExtensionKey = {};
            if (action === 'rendered' && actionSubject === 'forge.ui.renderer' && forgeUIAttributes.isEmbeddedMacro && overriddenExtensionKey) // Child Forge renderer contexts replace extensionKey with the child macro key, so the
            // parent key is the previous extensionKey captured during context merging.
            parentExtensionKey = {
                parentExtensionKey: overriddenExtensionKey
            };
            else if (action === 'rendered' && actionSubject === 'forge.ui.bodied_macro_embedded_content' && attributes?.extensionKey && forgeUIAttributes.extensionKey) // Embedded macro events carry the child macro key on the event attributes, while the
            // surrounding context still carries the parent macro extensionKey.
            parentExtensionKey = {
                parentExtensionKey: forgeUIAttributes.extensionKey
            };
            nestingAnalyticsAttributes = {
                ...forgeUIAttributes,
                ...parentExtensionKey
            };
        }
        const payload = {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            ...forgeUIAnalyticsContext,
            source: source,
            attributes: {
                ...commonAttributes,
                ...nestingAnalyticsAttributes ?? event.context.reduce((prev, curr)=>{
                    // Only extract attributes passed as an object via the forgeUIAttributes key
                    const forgeUIAttributes_0 = curr && curr.forgeUIAttributes && typeof curr.forgeUIAttributes === 'object' ? curr.forgeUIAttributes : {};
                    return {
                        ...prev,
                        ...forgeUIAttributes_0
                    };
                }, {}),
                ...attributes
            },
            tags: tags
        };
        $a3a18abb8f8abee5$export$7329bcdc3edcd90e(client)({
            eventType: eventType,
            ...payload
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
        onEvent: listenerHandler,
        channel: $a3a18abb8f8abee5$export$d28801614368e543
    }, children);
};
var $a3a18abb8f8abee5$export$2e2bcd8739ae039 = $a3a18abb8f8abee5$var$ForgeUIAnalyticsListener;
function $a3a18abb8f8abee5$var$_temp(prev, curr) {
    const forgeUIAttributes_0 = curr && curr.forgeUIAttributes && typeof curr.forgeUIAttributes === "object" ? curr.forgeUIAttributes : {};
    return {
        ...prev,
        ...forgeUIAttributes_0
    };
}
module.exports["FORGE_UI_ANALYTICS_CHANNEL"] = $a3a18abb8f8abee5$export$d28801614368e543;
module.exports["sendEvent"] = $a3a18abb8f8abee5$export$7329bcdc3edcd90e;
module.exports["default"] = $a3a18abb8f8abee5$export$2e2bcd8739ae039;

});

parcelRegister("DIyeF", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5xQdV = parcelRequire("5xQdV");


var $6ojvx = parcelRequire("6ojvx");

const $5577a309d6f3499e$export$b438ce9ad9530ae5 = /*#__PURE__*/ (0, $cozmU.createContext)({
    environment: undefined,
    product: '',
    page: ''
});
const $5577a309d6f3499e$export$163ecee29aa3a8f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { value: value, children: children } = t0;
    const envFromContext = (0, $cozmU.useContext)((0, $6ojvx.EnvironmentContext));
    const { product: product, page: page, environment: environment } = value;
    let t1;
    let t2;
    if ($[0] !== envFromContext || $[1] !== environment || $[2] !== page || $[3] !== product) {
        t1 = ()=>({
                environment: environment ?? envFromContext,
                product: product,
                page: page
            });
        t2 = [
            page,
            environment,
            envFromContext,
            product
        ];
        $[0] = envFromContext;
        $[1] = environment;
        $[2] = page;
        $[3] = product;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    const memoedValue = (0, $5xQdV.useMemoOne)(t1, t2);
    let t3;
    if ($[6] !== children || $[7] !== memoedValue) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5577a309d6f3499e$export$b438ce9ad9530ae5.Provider, {
            value: memoedValue
        }, children);
        $[6] = children;
        $[7] = memoedValue;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : ({ value: value, children: children })=>{
    const envFromContext = (0, $cozmU.useContext)((0, $6ojvx.EnvironmentContext));
    const { product: product, page: page, environment: environment } = value;
    const memoedValue = (0, $5xQdV.useMemoOne)(()=>{
        return {
            environment: environment ?? envFromContext,
            product: product,
            page: page
        };
    }, [
        page,
        environment,
        envFromContext,
        product
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5577a309d6f3499e$export$b438ce9ad9530ae5.Provider, {
        value: memoedValue
    }, children);
};
const $5577a309d6f3499e$export$dba2dab0d0f39612 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($5577a309d6f3499e$export$b438ce9ad9530ae5);
} : ()=>{
    return (0, $cozmU.useContext)($5577a309d6f3499e$export$b438ce9ad9530ae5);
};
module.exports["MetricsContext"] = $5577a309d6f3499e$export$b438ce9ad9530ae5;
module.exports["MetricsContextProvider"] = $5577a309d6f3499e$export$163ecee29aa3a8f;
module.exports["useMetricsContext"] = $5577a309d6f3499e$export$dba2dab0d0f39612;

});

parcelRegister("iGKcz", function(module, exports) {
// our service
const $fa265340e5382bcc$var$SERVICE = 'forge-ui';
const $fa265340e5382bcc$export$14ef296862e3705e = (workspaceAri)=>{
    return JSON.stringify({
        atlWorkspaceAri: workspaceAri,
        service: $fa265340e5382bcc$var$SERVICE
    });
};
module.exports["createAtlAttributionHeader"] = $fa265340e5382bcc$export$14ef296862e3705e;

});

parcelRegister("2rD5H", function(module, exports) {

var $iLX84 = parcelRequire("iLX84");


var $iDrrr = parcelRequire("iDrrr");

const $2571750a7eec7dec$var$convertDataClassificationTagsToString = (dataClassificationTagIds)=>{
    return `[
    ${dataClassificationTagIds.map((id)=>`"${id}"`).join(', ')}
  ]`;
};
const $2571750a7eec7dec$export$b4649e379af92913 = (expandAppOwner, moduleTypes, dataClassificationTagIds)=>{
    const modules = moduleTypes?.map((m)=>`"${m}"`) || [
        '$type'
    ];
    const userAccessField = (0, $iDrrr.fg)('platform-forge-ui-useraccess-in-extension-query') ? `userAccess {
    enabled
    hasAccess
  }` : '';
    const query = `
  query forge_ui_extensionList($contextIds: [ID!]!${moduleTypes ? '' : ', $type: String!'}, $locale: String) {
    extensionContexts(contextIds: $contextIds) {
      id
      ${modules.map((m)=>`
        extensionsByType(type: ${m}, locale: $locale ) {
          id
          appId
          key
          ${expandAppOwner ? `appOwner {
            name
          }` : ''}
          environmentId
          environmentType
          environmentKey
          properties
          license {
            active
            type
            supportEntitlementNumber
            trialEndDate
            subscriptionEndDate
            isEvaluation
            billingPeriod
            ccpEntitlementId
            ccpEntitlementSlug
						capabilitySet
            modes
          }
          ${userAccessField}
          type
          appVersion
          installationId
          remoteInstallationRegion
          migrationKey
					installationConfig {
						key
						value
					}
          egress {
            type
            addresses
						category
						inScopeEUD
          }
					sandboxPolicies
					scopes
					consentUrl
					currentUserConsent {
						user {
							aaid
						}
						appEnvironmentVersion {
							id
						}
						consentedAt
					}
					requiresUserConsent
          ${dataClassificationTagIds && dataClassificationTagIds.length > 0 ? `
                dataClassificationPolicyDecision(input: {
                  dataClassificationTags: ${$2571750a7eec7dec$var$convertDataClassificationTagsToString(dataClassificationTagIds)}
                }) {
                  status
                }
              ` : ''}
        }`).join('')}
    }
  }`;
    return (0, $iLX84.default)`${query}`;
};
const $2571750a7eec7dec$export$23f6ad93bea7724 = (expandAppOwner, dataClassificationTagIds)=>{
    const userAccessField = (0, $iDrrr.fg)('platform-forge-ui-useraccess-in-extension-query') ? `userAccess {
    enabled
    hasAccess
  }` : '';
    const query = `
  query forge_ui_extensionList($contextIds: [ID!]!, $filter: [ExtensionContextsFilter!]!, $locale: String ) {
    extensionContexts(contextIds: $contextIds) {
      id
      extensions(filter: $filter, locale: $locale) @optIn(to: "Access-Narrowing") {
        id
        appId
        key
        ${expandAppOwner ? `appOwner {
          name
        }` : ''}
        environmentId
        environmentType
        environmentKey
        properties
        license {
          active
          type
          supportEntitlementNumber
          trialEndDate
          subscriptionEndDate
          isEvaluation
          billingPeriod
          ccpEntitlementId
          ccpEntitlementSlug
					capabilitySet
          modes
        }
        ${userAccessField}
        type
        appVersion
        installationId
        remoteInstallationRegion
        migrationKey
				installationConfig {
					key
					value
				}
        egress {
          type
          addresses
					category
					inScopeEUD
        }
				sandboxPolicies
				scopes
				consentUrl
				currentUserConsent {
					user {
						aaid
					}
					appEnvironmentVersion {
						id
					}
					consentedAt
				}
				requiresUserConsent
        ${dataClassificationTagIds && dataClassificationTagIds.length > 0 ? `
              dataClassificationPolicyDecision(input: {
                dataClassificationTags: ${$2571750a7eec7dec$var$convertDataClassificationTagsToString(dataClassificationTagIds)}
              }) {
                status
              }
            ` : ''}
      },
    }
  }`;
    return (0, $iLX84.default)`${query}`;
};
const $2571750a7eec7dec$export$54ff27488d768aba = (0, $iLX84.default)`query FetchPreFilteredForgeAppsQuery($cloudId:ID!$context:ConfluenceExtensionRenderingContextInput$includeHidden:Boolean$locale:String$types:[String]){confluence_forgeExtensionsByType(cloudId:$cloudId context:$context includeHidden:$includeHidden locale:$locale types:$types){id appId appVersion appOwner environmentId environmentType environmentKey consentUrl migrationKey userAccess{enabled hasAccess}key properties{key value}egress{addresses category type inScopeEUD}sandboxPolicies scopes license{active capabilitySet billingPeriod ccpEntitlementId ccpEntitlementSlug isEvaluation subscriptionEndDate trialEndDate type}type installationId remoteInstallationRegion hiddenBy}}`;
module.exports["getExtensionListQueryOld"] = $2571750a7eec7dec$export$b4649e379af92913;
module.exports["getExtensionListQuery"] = $2571750a7eec7dec$export$23f6ad93bea7724;
module.exports["FetchPreFilteredForgeAppsQuery"] = $2571750a7eec7dec$export$54ff27488d768aba;

});

parcelRegister("hzmpb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $gGKeL = parcelRequire("gGKeL");


var $cozmU = parcelRequire("cozmU");


var $7EPz1 = parcelRequire("7EPz1");


var $6SsN4 = parcelRequire("6SsN4");


var $852mP = parcelRequire("852mP");


var $9DHhW = parcelRequire("9DHhW");


var $4K6lC = parcelRequire("4K6lC");


var $DIyeF = parcelRequire("DIyeF");


var $iGKcz = parcelRequire("iGKcz");


var $ix7El = parcelRequire("ix7El");


var $2rD5H = parcelRequire("2rD5H");


var $jGizm = parcelRequire("jGizm");

const $c7be4ab3ad813948$export$7f11ec46a05c7477 = (cloudId, context, client, types, locale, includeHidden, queryOptions, contextIds = [
    cloudId
])=>{
    const variables = {
        cloudId: cloudId,
        context: context,
        includeHidden: includeHidden ?? false,
        types: types,
        locale: locale
    };
    return {
        variables: variables,
        ...queryOptions,
        client: client,
        /**
     * We don't want to set 'ignore' because that discards errors and we need to inspect
     * them for SLI reporting. We also need 'all' so we don't discard data on errors:http://go/j/AUX-317
     * https://www.apollographql.com/docs/react/data/error-handling/
     */ errorPolicy: 'all',
        context: {
            headers: {
                'atl-attribution': (0, $iGKcz.createAtlAttributionHeader)([
                    ...contextIds
                ].sort().join())
            },
            allowOnExternalPage: true
        }
    };
};
const $c7be4ab3ad813948$export$88e0391b02a3c5c9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(28);
    const { cloudId: cloudId, context: context, includeHidden: includeHidden, locale: locale, types: types, client: client, queryOptions: queryOptions } = t0;
    let t1;
    if ($[0] !== client || $[1] !== cloudId || $[2] !== context || $[3] !== includeHidden || $[4] !== locale || $[5] !== queryOptions || $[6] !== types) {
        t1 = $c7be4ab3ad813948$export$7f11ec46a05c7477(cloudId, context, client, types, locale, includeHidden, queryOptions);
        $[0] = client;
        $[1] = cloudId;
        $[2] = context;
        $[3] = includeHidden;
        $[4] = locale;
        $[5] = queryOptions;
        $[6] = types;
        $[7] = t1;
    } else t1 = $[7];
    const requestOptions = t1;
    const { error: error, loading: loading, data: data } = (0, $7EPz1.useQuery)((0, $2rD5H.FetchPreFilteredForgeAppsQuery), requestOptions);
    let t2;
    if ($[8] !== data || $[9] !== loading) {
        t2 = $c7be4ab3ad813948$export$55348c7eb6377fe1({
            loading: loading,
            data: data
        });
        $[8] = data;
        $[9] = loading;
        $[10] = t2;
    } else t2 = $[10];
    const extensions = t2;
    const { page: page } = (0, $DIyeF.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t3;
    let t4;
    if ($[11] !== createAnalyticsEvent || $[12] !== extensions || $[13] !== page) {
        t3 = ()=>{
            if (extensions) createAnalyticsEvent({
                eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: "succeeded",
                    actionSubject: "forge.ui.webClient",
                    source: page,
                    tags: [
                        "forge"
                    ],
                    attributes: {
                        target: "usePrefilteredExtensionList"
                    }
                }
            }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
        };
        t4 = [
            extensions,
            page,
            createAnalyticsEvent
        ];
        $[11] = createAnalyticsEvent;
        $[12] = extensions;
        $[13] = page;
        $[14] = t3;
        $[15] = t4;
    } else {
        t3 = $[14];
        t4 = $[15];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    let t6;
    if ($[16] !== createAnalyticsEvent || $[17] !== error || $[18] !== extensions || $[19] !== page) {
        t5 = ()=>{
            if (!extensions && error && error.graphQLErrors.length > 0) {
                const err_0 = error.graphQLErrors.find($c7be4ab3ad813948$var$_temp);
                createAnalyticsEvent({
                    eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                    data: {
                        action: "failed",
                        actionSubject: "forge.ui.webClient",
                        source: page,
                        tags: [
                            "forge"
                        ],
                        attributes: {
                            target: "usePrefilteredExtensionList",
                            errorName: err_0 ? (0, $ix7El.isGQLUnderlyingServiceError)(err_0) ? "componentApi" : "componentGraphQL" : "uncaught"
                        }
                    }
                }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
            }
        };
        t6 = [
            extensions,
            error,
            page,
            createAnalyticsEvent
        ];
        $[16] = createAnalyticsEvent;
        $[17] = error;
        $[18] = extensions;
        $[19] = page;
        $[20] = t5;
        $[21] = t6;
    } else {
        t5 = $[20];
        t6 = $[21];
    }
    (0, $cozmU.useEffect)(t5, t6);
    let t7;
    if ($[22] !== extensions) {
        t7 = extensions || [];
        $[22] = extensions;
        $[23] = t7;
    } else t7 = $[23];
    let t8;
    if ($[24] !== error || $[25] !== loading || $[26] !== t7) {
        t8 = {
            error: error,
            extensions: t7,
            loading: loading
        };
        $[24] = error;
        $[25] = loading;
        $[26] = t7;
        $[27] = t8;
    } else t8 = $[27];
    return t8;
} : ({ cloudId: cloudId, context: context, includeHidden: includeHidden, locale: locale, types: types, client: client, queryOptions: queryOptions })=>{
    const requestOptions = $c7be4ab3ad813948$export$7f11ec46a05c7477(cloudId, context, client, types, locale, includeHidden, queryOptions);
    const { error: error, loading: loading, data: data } = (0, $7EPz1.useQuery)((0, $2rD5H.FetchPreFilteredForgeAppsQuery), requestOptions);
    const extensions = $c7be4ab3ad813948$export$55348c7eb6377fe1({
        loading: loading,
        data: data
    });
    const { page: page } = (0, $DIyeF.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        if (extensions) createAnalyticsEvent({
            eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
            data: {
                action: 'succeeded',
                actionSubject: 'forge.ui.webClient',
                source: page,
                tags: [
                    'forge'
                ],
                attributes: {
                    target: 'usePrefilteredExtensionList'
                }
            }
        }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
    }, [
        extensions,
        page,
        createAnalyticsEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (// if hydration of appOwners (non-critical data) fails but we still have the extensions,
        // we shouldn't count this as a bad event
        !extensions && error && error.graphQLErrors.length > 0) {
            const err_0 = error.graphQLErrors.find((err)=>(0, $ix7El.isGQLUnderlyingServiceError)(err) || (0, $ix7El.isGQLGatewayError)(err));
            createAnalyticsEvent({
                eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: 'failed',
                    actionSubject: 'forge.ui.webClient',
                    source: page,
                    tags: [
                        'forge'
                    ],
                    attributes: {
                        target: 'usePrefilteredExtensionList',
                        errorName: err_0 ? (0, $ix7El.isGQLUnderlyingServiceError)(err_0) ? 'componentApi' : 'componentGraphQL' : 'uncaught'
                    }
                }
            }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
        }
    }, [
        extensions,
        error,
        page,
        createAnalyticsEvent
    ]);
    return {
        error: error,
        extensions: extensions || [],
        loading: loading
    };
};
const $c7be4ab3ad813948$export$55348c7eb6377fe1 = ({ loading: loading, data: data })=>{
    const extensions = data?.confluence_forgeExtensionsByType || [];
    if (!loading && extensions.length > 0) return (0, $jGizm.transformPreFilteredExtensions)(extensions);
    return null;
};
const $c7be4ab3ad813948$var$fetchRequests = new Map();
const $c7be4ab3ad813948$export$f55e1916fecb1860 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    const { cloudId: cloudId, context: context, includeHidden: includeHidden, locale: locale, types: types } = t0;
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const [extensions, setExtensions] = (0, $cozmU.useState)(null);
    const [loading, setLoading] = (0, $cozmU.useState)(true);
    const [error, setError] = (0, $cozmU.useState)(undefined);
    const { page: page } = (0, $DIyeF.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    let t2;
    if ($[0] !== cloudId || $[1] !== context || $[2] !== environment || $[3] !== includeHidden || $[4] !== locale || $[5] !== types) {
        t1 = ()=>{
            const cacheKey = JSON.stringify({
                cloudId: cloudId,
                context: context,
                includeHidden: includeHidden,
                locale: locale,
                types: types
            });
            if (!$c7be4ab3ad813948$var$fetchRequests.has(cacheKey)) {
                const extensions_0 = new Promise((resolve, reject)=>{
                    (0, $6SsN4.fetchQuery)(environment, (0, $gGKeL.default), {
                        cloudId: cloudId,
                        context: context,
                        includeHidden: includeHidden,
                        locale: locale,
                        types: types
                    }, {
                        networkCacheConfig: {
                            metadata: {
                                headers: {
                                    "atl-attribution": (0, $iGKcz.createAtlAttributionHeader)(cloudId)
                                },
                                allowOnExternalPage: true
                            }
                        }
                    }).subscribe({
                        next: (data)=>{
                            resolve($c7be4ab3ad813948$export$55348c7eb6377fe1({
                                data: data,
                                loading: false
                            }));
                        },
                        error: (error_0)=>{
                            $c7be4ab3ad813948$var$fetchRequests.delete(cacheKey);
                            reject(error_0);
                        }
                    });
                });
                $c7be4ab3ad813948$var$fetchRequests.set(cacheKey, extensions_0);
            }
            $c7be4ab3ad813948$var$fetchRequests.get(cacheKey).then((extensions_1)=>{
                setExtensions(extensions_1);
                setLoading(false);
            }).catch((error_1)=>{
                setError(error_1);
                setLoading(false);
            });
        };
        t2 = [
            cloudId,
            context,
            includeHidden,
            locale,
            types,
            environment
        ];
        $[0] = cloudId;
        $[1] = context;
        $[2] = environment;
        $[3] = includeHidden;
        $[4] = locale;
        $[5] = types;
        $[6] = t1;
        $[7] = t2;
    } else {
        t1 = $[6];
        t2 = $[7];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    let t4;
    if ($[8] !== createAnalyticsEvent || $[9] !== extensions || $[10] !== page) {
        t3 = ()=>{
            if (extensions) createAnalyticsEvent({
                eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: "succeeded",
                    actionSubject: "forge.ui.webClient",
                    source: page,
                    tags: [
                        "forge"
                    ],
                    attributes: {
                        target: "usePrefilteredExtensionList"
                    }
                }
            }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
        };
        t4 = [
            extensions,
            page,
            createAnalyticsEvent
        ];
        $[8] = createAnalyticsEvent;
        $[9] = extensions;
        $[10] = page;
        $[11] = t3;
        $[12] = t4;
    } else {
        t3 = $[11];
        t4 = $[12];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    let t6;
    if ($[13] !== createAnalyticsEvent || $[14] !== error || $[15] !== extensions || $[16] !== page) {
        t5 = ()=>{
            if (!extensions && error && (0, $ix7El.isRelayNetworkError)(error)) {
                const err_0 = error.source.errors.find($c7be4ab3ad813948$var$_temp2);
                createAnalyticsEvent({
                    eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                    data: {
                        action: "failed",
                        actionSubject: "forge.ui.webClient",
                        source: page,
                        tags: [
                            "forge"
                        ],
                        attributes: {
                            target: "useExtensionList",
                            errorName: err_0 ? (0, $ix7El.isGQLUnderlyingServiceError)(err_0) ? "componentApi" : "componentGraphQL" : "uncaught"
                        }
                    }
                }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
            }
        };
        t6 = [
            extensions,
            error,
            page,
            createAnalyticsEvent
        ];
        $[13] = createAnalyticsEvent;
        $[14] = error;
        $[15] = extensions;
        $[16] = page;
        $[17] = t5;
        $[18] = t6;
    } else {
        t5 = $[17];
        t6 = $[18];
    }
    (0, $cozmU.useEffect)(t5, t6);
    let t7;
    if ($[19] !== extensions) {
        t7 = extensions || [];
        $[19] = extensions;
        $[20] = t7;
    } else t7 = $[20];
    let t8;
    if ($[21] !== error || $[22] !== loading || $[23] !== t7) {
        t8 = {
            extensions: t7,
            loading: loading,
            error: error
        };
        $[21] = error;
        $[22] = loading;
        $[23] = t7;
        $[24] = t8;
    } else t8 = $[24];
    return t8;
} : ({ cloudId: cloudId, context: context, includeHidden: includeHidden, locale: locale, types: types })=>{
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const [extensions, setExtensions] = (0, $cozmU.useState)(null);
    const [loading, setLoading] = (0, $cozmU.useState)(true);
    const [error, setError] = (0, $cozmU.useState)(undefined);
    const { page: page } = (0, $DIyeF.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        const cacheKey = JSON.stringify({
            cloudId: cloudId,
            context: context,
            includeHidden: includeHidden,
            locale: locale,
            types: types
        });
        if (!$c7be4ab3ad813948$var$fetchRequests.has(cacheKey)) {
            const extensions_0 = new Promise((resolve, reject)=>{
                (0, $6SsN4.fetchQuery)(environment, (0, $gGKeL.default), {
                    cloudId: cloudId,
                    context: // @ts-ignore - the generated types convert GQL Long to a number, which may truncate the id. The type will be changed to string
                    context,
                    includeHidden: includeHidden,
                    locale: locale,
                    types: types
                }, {
                    networkCacheConfig: {
                        metadata: {
                            headers: {
                                'atl-attribution': (0, $iGKcz.createAtlAttributionHeader)(cloudId)
                            },
                            allowOnExternalPage: true
                        }
                    }
                }).subscribe({
                    next: (data)=>{
                        resolve($c7be4ab3ad813948$export$55348c7eb6377fe1({
                            data: data,
                            loading: false
                        }));
                    },
                    error: (error_0)=>{
                        $c7be4ab3ad813948$var$fetchRequests.delete(cacheKey);
                        reject(error_0);
                    }
                });
            });
            $c7be4ab3ad813948$var$fetchRequests.set(cacheKey, extensions_0);
        }
        $c7be4ab3ad813948$var$fetchRequests.get(cacheKey).then((extensions_1)=>{
            setExtensions(extensions_1);
            setLoading(false);
        }).catch((error_1)=>{
            setError(error_1);
            setLoading(false);
        });
    }, [
        cloudId,
        context,
        includeHidden,
        locale,
        types,
        environment
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (extensions) createAnalyticsEvent({
            eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
            data: {
                action: 'succeeded',
                actionSubject: 'forge.ui.webClient',
                source: page,
                tags: [
                    'forge'
                ],
                attributes: {
                    target: 'usePrefilteredExtensionList'
                }
            }
        }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
    }, [
        extensions,
        page,
        createAnalyticsEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (// if hydration of appOwners (non-critical data) fails but we still have the extensions,
        // we shouldn't count this as a bad event
        !extensions && error && (0, $ix7El.isRelayNetworkError)(error)) {
            const err_0 = error.source.errors.find((err)=>(0, $ix7El.isGQLUnderlyingServiceError)(err) || (0, $ix7El.isGQLGatewayError)(err));
            createAnalyticsEvent({
                eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: 'failed',
                    actionSubject: 'forge.ui.webClient',
                    source: page,
                    tags: [
                        'forge'
                    ],
                    attributes: {
                        target: 'useExtensionList',
                        errorName: err_0 ? (0, $ix7El.isGQLUnderlyingServiceError)(err_0) ? 'componentApi' : 'componentGraphQL' : 'uncaught'
                    }
                }
            }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
        }
    }, [
        extensions,
        error,
        page,
        createAnalyticsEvent
    ]);
    return {
        extensions: extensions || [],
        loading: loading,
        error: error
    };
};
function $c7be4ab3ad813948$var$_temp(err) {
    return (0, $ix7El.isGQLUnderlyingServiceError)(err) || (0, $ix7El.isGQLGatewayError)(err);
}
function $c7be4ab3ad813948$var$_temp2(err) {
    return (0, $ix7El.isGQLUnderlyingServiceError)(err) || (0, $ix7El.isGQLGatewayError)(err);
}
module.exports["createUsePrefilteredExtensionListQueryOptions"] = $c7be4ab3ad813948$export$7f11ec46a05c7477;
module.exports["usePrefilteredExtensionList"] = $c7be4ab3ad813948$export$88e0391b02a3c5c9;
module.exports["getPrefilteredExtensionsGQLResult"] = $c7be4ab3ad813948$export$55348c7eb6377fe1;
module.exports["usePrefilteredExtensionListRelay"] = $c7be4ab3ad813948$export$f55e1916fecb1860;

});

parcelRegister("gGKeL", function(module, exports) {
/**
 * @generated SignedSource<<7da5a0cc59e307e949d5c921ecd41a2b>>
 * @relayHash ae8c0df8b458c191f8dbdc3067c4d451
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f5629fcf1f358b362aa590d439d2c0b3b1226aeff22ab5c3341f879647bc9d2c
const $57d2af88a889106f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "context"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeHidden"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "locale"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "types"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "key"
    }, v2 = {
        "kind": "ScalarField",
        "name": "type"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "context",
                    "variableName": "context"
                },
                {
                    "kind": "Variable",
                    "name": "includeHidden",
                    "variableName": "includeHidden"
                },
                {
                    "kind": "Variable",
                    "name": "locale",
                    "variableName": "locale"
                },
                {
                    "kind": "Variable",
                    "name": "types",
                    "variableName": "types"
                }
            ],
            "concreteType": "ConfluenceForgeExtension",
            "kind": "LinkedField",
            "name": "confluence_forgeExtensionsByType",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "appId"
                },
                {
                    "kind": "ScalarField",
                    "name": "appVersion"
                },
                {
                    "kind": "ScalarField",
                    "name": "appOwner"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentId"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentType"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "consentUrl"
                },
                {
                    "kind": "ScalarField",
                    "name": "migrationKey"
                },
                {
                    "concreteType": "ConfluenceUserAccess",
                    "kind": "LinkedField",
                    "name": "userAccess",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "enabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasAccess"
                        }
                    ]
                },
                v1 /*: any*/ ,
                {
                    "concreteType": "KeyValueHierarchyMap",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceExtensionEgressDeclaration",
                    "kind": "LinkedField",
                    "name": "egress",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "addresses"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "category"
                        },
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "inScopeEUD"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "sandboxPolicies"
                },
                {
                    "kind": "ScalarField",
                    "name": "scopes"
                },
                {
                    "concreteType": "ConfluenceAppInstallationLicense",
                    "kind": "LinkedField",
                    "name": "license",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "active"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "capabilitySet"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "billingPeriod"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "ccpEntitlementId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "ccpEntitlementSlug"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isEvaluation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "subscriptionEndDate"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "trialEndDate"
                        },
                        v2 /*: any*/ 
                    ]
                },
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "installationId"
                },
                {
                    "kind": "ScalarField",
                    "name": "remoteInstallationRegion"
                },
                {
                    "kind": "ScalarField",
                    "name": "hiddenBy"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePrefilteredExtensionList_forge_ui_Query",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePrefilteredExtensionList_forge_ui_Query",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "id": "f5629fcf1f358b362aa590d439d2c0b3b1226aeff22ab5c3341f879647bc9d2c",
            "metadata": {},
            "name": "usePrefilteredExtensionList_forge_ui_Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$57d2af88a889106f$var$node.hash = "9988fba56919e313afdb928b7bdb852d";
var $57d2af88a889106f$export$2e2bcd8739ae039 = $57d2af88a889106f$var$node;
module.exports["default"] = $57d2af88a889106f$export$2e2bcd8739ae039;

});

parcelRegister("9cGsb", function(module, exports) {
"use strict";
var $6b362a72760d8152$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
function $6b362a72760d8152$var$__export(m) {
    for(var p in m)if (!module.exports.hasOwnProperty(p)) module.exports[p] = m[p];
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bAWmc = parcelRequire("bAWmc");


$6b362a72760d8152$var$__export((parcelRequire("5ixmT")));
/**
 * InvalidAriError - an error thrown if an invalid Ari is constructed
 */ var $6b362a72760d8152$var$InvalidAriError = /** @class */ function(_super) {
    $6b362a72760d8152$var$__extends(InvalidAriError, _super);
    /**
   * Construct an InvalidAriError given an error message
   *
   * @param {string} ariString - the ARI that failed to parse
   * @param {string|undefined} description - The error message
   */ function InvalidAriError(ariString, description) {
        var _this = _super.call(this, "Invalid ari string: " + ariString + (description ? '. ' + description : '')) || this;
        _this.ariString = ariString;
        // Support correct inheritance in ES5
        Object.setPrototypeOf(_this, InvalidAriError.prototype);
        return _this;
    }
    /**
   * Construct an InvalidAriError given some constraint violations
   *
   * @param {string} ariString - the ARI that failed to parse
   * @param {ConstraintViolation<Object>[]} violations - The array of constraint errors
   */ InvalidAriError.withConstraintViolations = function(ariString, violations) {
        return new InvalidAriError(ariString, violations.map(function(v) {
            return v.toString();
        }).join('\n'));
    };
    return InvalidAriError;
}(Error);
module.exports.InvalidAriError = $6b362a72760d8152$var$InvalidAriError;
function $6b362a72760d8152$var$matchesSegment(value1, value2) {
    if (value1 === value2) return true;
    else if (value1 === undefined) return true;
    return false;
}
// constraints are based on draft of v2 spec https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0#AtlassianResourceIdentifierSpec(draft-2.0)-Syntax
var $6b362a72760d8152$var$basicCharConstraint = $bAWmc.pattern(/^[a-z][a-z.-]*$/);
var $6b362a72760d8152$var$resourceOwnerConstraints = [
    $bAWmc.lengthBetween(3, 255),
    $6b362a72760d8152$var$basicCharConstraint
];
var $6b362a72760d8152$var$resourceTypeConstraints = [
    $bAWmc.lengthBetween(3, 255),
    $6b362a72760d8152$var$basicCharConstraint
];
var $6b362a72760d8152$var$cloudIdConstraints = [
    $bAWmc.lengthBetween(36, 255)
];
var $6b362a72760d8152$var$siteResourceType = 'site';
var $6b362a72760d8152$var$resourceIdChars = /[\w-._~:@#]/.source;
var $6b362a72760d8152$var$resourceIdConstraints = [
    $bAWmc.pattern(new RegExp("^" + $6b362a72760d8152$var$resourceIdChars + "+(/" + $6b362a72760d8152$var$resourceIdChars + "*)*(;v=" + $6b362a72760d8152$var$resourceIdChars + "*)*$"))
];
/**
 * Returns an Ari that is of the latest version of the Ari spec that we support. Any legacy formats
 * (like those for site wide ARIs) are upgraded to their latest form.
 */ function $6b362a72760d8152$var$upgrade(values) {
    var resourceId = values.resourceId, resourceOwner = values.resourceOwner, cloudId = values.cloudId;
    // note: The new ARI spec has not defined a format for system wide contexts so we exclude them from upgrade
    if (!resourceId && cloudId) return {
        resourceOwner: resourceOwner,
        resourceType: $6b362a72760d8152$var$siteResourceType,
        resourceId: cloudId
    };
    else return values;
}
var $6b362a72760d8152$var$ResourceIdentifier = /** @class */ function() {
    /**
   * Create a new Ari
   *
   * Only the resourceOwner is a required field, any other field can be omitted.
   * Older format types are converted on creation
   *
   * @param {string} values.resourceOwner - the owner of this resource (e.g. hipchat, confluence or jira)
   * @param {string|undefined} values.cloudId - the cloud id for this identifier, defined in AID
   * @param {string|undefined} values.resourceType - the resource type this Ari is associated with (e.g. conversation in hipchat)
   * @param {string|undefined} values.resourceId - a resource identifier, if this is specified the associated resourceType *must* be provided.
   *
   * @throws {InvalidAriError} if the provided segments fail to pass validation
   */ function ResourceIdentifier(values) {
        var _a = $6b362a72760d8152$var$upgrade(values), resourceId = _a.resourceId, resourceOwner = _a.resourceOwner, resourceType = _a.resourceType, cloudId = _a.cloudId;
        this.resourceOwner = resourceOwner;
        this.internalCloudId = cloudId;
        this.resourceType = resourceType;
        this.resourceId = resourceId;
        this.validate();
    }
    Object.defineProperty(ResourceIdentifier.prototype, "cloudId", {
        get: function() {
            if (this.resourceType === $6b362a72760d8152$var$siteResourceType) return this.internalCloudId ? this.internalCloudId : this.resourceId;
            return this.internalCloudId;
        },
        enumerable: true,
        configurable: true
    });
    /**
  * Parse a string as an Ari
  *
  * @param {string} ariString - the string to parse
  * @returns {Ari} the parsed ari
  * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
  */ ResourceIdentifier.parse = function(ariString) {
        if (!ariString) throw new $6b362a72760d8152$var$InvalidAriError(ariString);
        var match = ariString.match(/^ari:cloud:([^:/]+):([^:/]*):([^:/]*)\/(.*)$/);
        if (!match || match.length !== 5) throw new $6b362a72760d8152$var$InvalidAriError(ariString);
        var terms = match.map(function(a) {
            return a && a.length > 0 ? a : undefined;
        });
        var resourceOwner = terms[1];
        if (!resourceOwner) throw new $6b362a72760d8152$var$InvalidAriError(ariString);
        return new ResourceIdentifier({
            resourceOwner: resourceOwner,
            cloudId: terms[2],
            resourceType: terms[3],
            resourceId: terms[4]
        });
    };
    ResourceIdentifier.parseEncoded = function(encodedAriString) {
        return $6b362a72760d8152$var$parse(decodeURIComponent(encodedAriString));
    };
    /**
   * Converts this Ari to a string.
   */ ResourceIdentifier.prototype.toString = function() {
        if (!this.ariString) {
            var resourceId = this.resourceType === $6b362a72760d8152$var$siteResourceType && this.internalCloudId ? this.internalCloudId : this.resourceId || '';
            var resourceType = this.resourceType || '';
            var sanitizedCloudId = this.resourceType === $6b362a72760d8152$var$siteResourceType ? '' : this.internalCloudId || '';
            this.ariString = "ari:cloud:" + this.resourceOwner + ":" + sanitizedCloudId + ":" + resourceType + "/" + resourceId;
        }
        return this.ariString;
    };
    /**
   * Converts this object to its json representation
   */ ResourceIdentifier.prototype.toJSON = function() {
        return this.toString();
    };
    /**
   * Checks if this context is the same as another context
   *
   * @param {Ari} other - the other parameter to match with
   * @returns {boolean} - true if all segments of both Aris are equal, false otherwise
   */ ResourceIdentifier.prototype.equals = function(other) {
        return other instanceof ResourceIdentifier && this.resourceOwner === other.resourceOwner && this.cloudId === other.cloudId && this.resourceType === other.resourceType && this.resourceId === other.resourceId;
    };
    /**
   * This method checks if the current context contains the other context.
   *
   * Note: it does that by transforming a site context  (e.g. `ari:cloud:<resource owner>:site/<cloud id>`)
   * if required to an "any" resource type context (e.g. `ari:cloud:<resource owner>:<cloud id>:/`)
   *
   * @param {Ari} other
   * @returns {boolean}
   */ ResourceIdentifier.prototype.contains = function(other) {
        return this.matches(new ResourceIdentifier(other));
    };
    /**
   * Checks if this context is the same as or contains the provided context.
   *
   * Undefined segments in this ARI are treated as wildcards for matching purposes, but must exactly
   *  match if they are provided in the `other` Ari - i.e. this method is not commutative.
   *
   * e.g.
   * ```
   * parse('ari:cloud:hipchat::/').contains(parse('ari:cloud:hipchat:cloudid:conversation/blah')) === true
   * parse('ari:cloud:hipchat:cloudid:conversation/blah').contains(parse('ari:cloud:hipchat::/')) === false
   *
   * @param {Ari} other - the other parameter to match with
   * @returns {boolean} true if this Ari is the same as the other Ari, or matches the other Ari. False otherwise.
   */ ResourceIdentifier.prototype.matches = function(other) {
        return $6b362a72760d8152$var$matchesSegment(this.resourceOwner, other.resourceOwner) && $6b362a72760d8152$var$matchesSegment(this.cloudId, other.cloudId) && (this.resourceType === $6b362a72760d8152$var$siteResourceType && !!other.resourceType || $6b362a72760d8152$var$matchesSegment(this.resourceType, other.resourceType)) && (this.resourceType === $6b362a72760d8152$var$siteResourceType && !!other.resourceType || $6b362a72760d8152$var$matchesSegment(this.resourceId, other.resourceId));
    };
    ResourceIdentifier.prototype.validateSiteWide = function() {
        var _a = this, resourceType = _a.resourceType, cloudId = _a.cloudId;
        if (resourceType === $6b362a72760d8152$var$siteResourceType && !cloudId) return new $bAWmc.GeneralValidationError('site wide ARIs must have a cloudId');
    };
    ResourceIdentifier.prototype.validate = function() {
        var constraintViolations = [
            $bAWmc.validateField(this, 'resourceOwner', $6b362a72760d8152$var$resourceOwnerConstraints),
            $bAWmc.validateField(this, 'resourceType', $6b362a72760d8152$var$resourceTypeConstraints),
            $bAWmc.validateField(this, 'resourceId', $6b362a72760d8152$var$resourceIdConstraints),
            $bAWmc.validateField(this, 'cloudId', $6b362a72760d8152$var$cloudIdConstraints),
            this.validateSiteWide()
        ].filter(function(v) {
            return v;
        });
        if (constraintViolations.length > 0) throw $6b362a72760d8152$var$InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
        if (this.resourceId !== undefined && this.resourceType === undefined) throw new $6b362a72760d8152$var$InvalidAriError(this.toString(), 'The resource type must be specified if the resource id is defined.');
    };
    ResourceIdentifier.prototype.urlEncode = function() {
        return encodeURIComponent(this.toString());
    };
    ResourceIdentifier.prototype.urlDecode = function() {
        return decodeURIComponent(this.toString());
    };
    return ResourceIdentifier;
}();
module.exports.ResourceIdentifier = $6b362a72760d8152$var$ResourceIdentifier;
/**
 * Parse a string as an Ari
 *
 * @param {string} ariString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $6b362a72760d8152$var$parse(ariString) {
    return $6b362a72760d8152$var$ResourceIdentifier.parse(ariString);
}
module.exports.parse = $6b362a72760d8152$var$parse;
/**
 * Parse a URL encoded string as an Ari
 *
 * @param {string} encodedAriString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $6b362a72760d8152$var$parseEncoded(encodedAriString) {
    return $6b362a72760d8152$var$ResourceIdentifier.parseEncoded(encodedAriString);
}
module.exports.parseEncoded = $6b362a72760d8152$var$parseEncoded;

});

parcelRegister("bAWmc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $871053056dfd3da9$var$LengthConstraint = /** @class */ function() {
    function LengthConstraint(min, max) {
        this.min = min;
        this.max = max;
    }
    Object.defineProperty(LengthConstraint.prototype, "description", {
        get: function() {
            return "length must be between " + this.min + " and " + this.max;
        },
        enumerable: true,
        configurable: true
    });
    LengthConstraint.prototype.isValid = function(value) {
        return !value || value.length >= this.min && value.length <= this.max;
    };
    return LengthConstraint;
}();
module.exports.LengthConstraint = $871053056dfd3da9$var$LengthConstraint;
var $871053056dfd3da9$var$RegexConstraint = /** @class */ function() {
    function RegexConstraint(regex) {
        this.regex = regex;
    }
    Object.defineProperty(RegexConstraint.prototype, "description", {
        get: function() {
            return "value must match regex " + this.regex.source;
        },
        enumerable: true,
        configurable: true
    });
    RegexConstraint.prototype.isValid = function(value) {
        return !value || this.regex.test(value);
    };
    return RegexConstraint;
}();
module.exports.RegexConstraint = $871053056dfd3da9$var$RegexConstraint;
var $871053056dfd3da9$var$GeneralValidationError = /** @class */ function() {
    function GeneralValidationError(error) {
        this.error = error;
    }
    GeneralValidationError.prototype.toString = function() {
        return this.error;
    };
    return GeneralValidationError;
}();
module.exports.GeneralValidationError = $871053056dfd3da9$var$GeneralValidationError;
var $871053056dfd3da9$var$ConstraintViolation = /** @class */ function() {
    function ConstraintViolation(fieldName, value, constraints) {
        this.fieldName = fieldName;
        this.value = value;
        this.constraints = constraints;
    }
    ConstraintViolation.prototype.toString = function() {
        var constraintSummary = this.constraints.map(function(c) {
            return "  - " + c.description;
        }).join('\n');
        return "'" + this.value + "' is not a valid value for " + this.fieldName + " as it violates the following constraints:\n" + constraintSummary;
    };
    return ConstraintViolation;
}();
module.exports.ConstraintViolation = $871053056dfd3da9$var$ConstraintViolation;
function $871053056dfd3da9$var$lengthBetween(min, max) {
    return new $871053056dfd3da9$var$LengthConstraint(min, max);
}
module.exports.lengthBetween = $871053056dfd3da9$var$lengthBetween;
function $871053056dfd3da9$var$pattern(regex) {
    return new $871053056dfd3da9$var$RegexConstraint(regex);
}
module.exports.pattern = $871053056dfd3da9$var$pattern;
function $871053056dfd3da9$var$validateField(object, fieldName, constraints) {
    var value = object[fieldName];
    var violatedConstraints = constraints.map(function(c) {
        return c.isValid(value) ? undefined : c;
    }).filter(function(c) {
        return c;
    });
    return violatedConstraints.length > 0 ? new $871053056dfd3da9$var$ConstraintViolation(fieldName, value, violatedConstraints) : undefined;
}
module.exports.validateField = $871053056dfd3da9$var$validateField;

});

parcelRegister("5ixmT", function(module, exports) {
"use strict";
var $3db8846e4ba8de9f$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $199iK = parcelRequire("199iK");

var $3db8846e4ba8de9f$var$AppFamilyAri;
(function(AppFamilyAri) {
    AppFamilyAri.resourceOwner = 'ecosystem';
    AppFamilyAri.appResourceType = 'app';
    AppFamilyAri.environmentResourceType = 'environment';
    AppFamilyAri.extensionGroupResourceType = 'extension-group';
    AppFamilyAri.extensionResourceType = 'extension';
    AppFamilyAri.appFamilyResourceTypes = [
        AppFamilyAri.appResourceType,
        AppFamilyAri.environmentResourceType,
        AppFamilyAri.extensionGroupResourceType,
        AppFamilyAri.extensionResourceType
    ];
})($3db8846e4ba8de9f$var$AppFamilyAri = module.exports.AppFamilyAri || (module.exports.AppFamilyAri = {}));
var $3db8846e4ba8de9f$var$AppFamilyAriError = /** @class */ function(_super) {
    $3db8846e4ba8de9f$var$__extends(AppFamilyAriError, _super);
    function AppFamilyAriError(message, cause) {
        var _this = _super.call(this, message) || this;
        _this.cause = cause;
        return _this;
    }
    return AppFamilyAriError;
}(Error);
module.exports.AppFamilyAriError = $3db8846e4ba8de9f$var$AppFamilyAriError;
var $3db8846e4ba8de9f$var$NotAppFamilyAriError = /** @class */ function(_super) {
    $3db8846e4ba8de9f$var$__extends(NotAppFamilyAriError, _super);
    function NotAppFamilyAriError(ari, reason) {
        var _this = _super.call(this, "ari is not a valid App family ari: " + ari.toString() + " as " + reason) || this;
        _this.reason = reason;
        return _this;
    }
    return NotAppFamilyAriError;
}($3db8846e4ba8de9f$var$AppFamilyAriError);
module.exports.NotAppFamilyAriError = $3db8846e4ba8de9f$var$NotAppFamilyAriError;
var $3db8846e4ba8de9f$var$NotExpectedAppFamilyAriTypeError = /** @class */ function(_super) {
    $3db8846e4ba8de9f$var$__extends(NotExpectedAppFamilyAriTypeError, _super);
    function NotExpectedAppFamilyAriTypeError(type, ari, cause) {
        var _this = _super.call(this, "App family ari (" + ari.toString() + ") is not of expected type: " + type, cause) || this;
        _this.cause = cause;
        return _this;
    }
    return NotExpectedAppFamilyAriTypeError;
}($3db8846e4ba8de9f$var$AppFamilyAriError);
module.exports.NotExpectedAppFamilyAriTypeError = $3db8846e4ba8de9f$var$NotExpectedAppFamilyAriTypeError;
/**
 * throws NotAppFamilyAriError if not a valid app family ari
 */ function $3db8846e4ba8de9f$var$parseAppAri(ari) {
    return $199iK.AppFamilyAriImpl.parse(ari);
}
module.exports.parseAppAri = $3db8846e4ba8de9f$var$parseAppAri;
function $3db8846e4ba8de9f$var$createAppAri(json) {
    return new $199iK.AppFamilyAriImpl(json);
}
module.exports.createAppAri = $3db8846e4ba8de9f$var$createAppAri;

});

parcelRegister("199iK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $5ixmT = parcelRequire("5ixmT");


var $9cGsb = parcelRequire("9cGsb");

var $0d5dd8c916c95343$var$versionPrefix = ';v=';
var $0d5dd8c916c95343$var$AppFamilyAriImpl = /** @class */ function() {
    function AppFamilyAriImpl(json) {
        this.json = json;
    }
    Object.defineProperty(AppFamilyAriImpl.prototype, "appId", {
        get: function() {
            return this.json.appId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "environmentId", {
        get: function() {
            return this.json.environmentId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "version", {
        get: function() {
            return this.json.version;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "extensionGroupId", {
        get: function() {
            return this.json.extensionGroupId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "extensionKey", {
        get: function() {
            return this.json.extensionKey;
        },
        enumerable: true,
        configurable: true
    });
    AppFamilyAriImpl.prototype.toJSON = function() {
        return this.json;
    };
    AppFamilyAriImpl.parse = function(ari) {
        var resourceOwner = ari.resourceOwner, resourceType = ari.resourceType, resourceId = ari.resourceId;
        if (resourceOwner !== $5ixmT.AppFamilyAri.resourceOwner) throw new $5ixmT.NotAppFamilyAriError(ari, "resourceOwner (" + resourceOwner + ") must be " + $5ixmT.AppFamilyAri.resourceOwner);
        if (!resourceType || $5ixmT.AppFamilyAri.appFamilyResourceTypes.indexOf(resourceType) < 0) throw new $5ixmT.NotAppFamilyAriError(ari, "resourceType must be one of " + $5ixmT.AppFamilyAri.appFamilyResourceTypes);
        if (!resourceId) throw new $5ixmT.NotAppFamilyAriError(ari, 'resourceId is must be provided');
        var versionIndex = resourceId.indexOf($0d5dd8c916c95343$var$versionPrefix);
        if (versionIndex > 0 && resourceId.lastIndexOf($0d5dd8c916c95343$var$versionPrefix) > versionIndex) throw new $5ixmT.NotAppFamilyAriError(ari, 'can only include one version suffix');
        var _a = resourceId.split($0d5dd8c916c95343$var$versionPrefix), mainResourceId = _a[0], version = _a[1];
        var segments = mainResourceId.split('/').map($0d5dd8c916c95343$var$stripToUndefined);
        if (segments.length > 4) throw new $5ixmT.NotAppFamilyAriError(ari, "no path segments can be added after extensionKey " + segments.slice(4));
        var _b = segments[0], appId = _b === void 0 ? undefined : _b, _c = segments[1], environmentId = _c === void 0 ? undefined : _c, _d = segments[2], providedExtensionGroupId = _d === void 0 ? undefined : _d, _e = segments[3], extensionKey = _e === void 0 ? undefined : _e;
        if (!appId) throw new $5ixmT.NotAppFamilyAriError(ari, 'appId must be included');
        var extensionGroupId = providedExtensionGroupId || (resourceType === $5ixmT.AppFamilyAri.extensionGroupResourceType || resourceType === $5ixmT.AppFamilyAri.extensionResourceType ? 'static' : undefined);
        if (resourceType === $5ixmT.AppFamilyAri.extensionResourceType && !(environmentId && providedExtensionGroupId && extensionKey)) throw new $5ixmT.NotAppFamilyAriError(ari, "environmentId, extensionGroupId, extensionKey must all be provided for resourceType " + $5ixmT.AppFamilyAri.extensionResourceType);
        else if (resourceType === $5ixmT.AppFamilyAri.extensionGroupResourceType && (!(environmentId && extensionGroupId) || extensionKey)) throw new $5ixmT.NotAppFamilyAriError(ari, "environmentId, extensionGroupId must all be provided for resourceType " + $5ixmT.AppFamilyAri.extensionGroupResourceType);
        else if (resourceType === $5ixmT.AppFamilyAri.environmentResourceType && (!environmentId || providedExtensionGroupId || extensionKey)) throw new $5ixmT.NotAppFamilyAriError(ari, "environmentId must be provided for resourceType " + $5ixmT.AppFamilyAri.environmentResourceType);
        else if (resourceType === $5ixmT.AppFamilyAri.appResourceType && (environmentId || providedExtensionGroupId || extensionKey)) throw new $5ixmT.NotAppFamilyAriError(ari, "environmentId must be provided for resourceType " + $5ixmT.AppFamilyAri.environmentResourceType);
        return new AppFamilyAriImpl({
            appId: appId,
            environmentId: environmentId,
            extensionGroupId: extensionGroupId,
            extensionKey: extensionKey,
            version: version
        });
    };
    AppFamilyAriImpl.prototype.asAppAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isAppAri();
        }, 'app');
    };
    AppFamilyAriImpl.prototype.asAppEnvironmentAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isAppEnvironmentAri();
        }, 'environment');
    };
    AppFamilyAriImpl.prototype.asExtensionGroupAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isExtensionGroupAri();
        }, 'extension-group');
    };
    AppFamilyAriImpl.prototype.asExtensionAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isExtensionAri();
        }, 'extension');
    };
    AppFamilyAriImpl.prototype.isAppAri = function() {
        return !this.isAtLeastAppEnvironmentAri;
    };
    AppFamilyAriImpl.prototype.isAppEnvironmentAri = function() {
        return this.isAtLeastAppEnvironmentAri && !this.isAtLeastExtensionGroupAri;
    };
    AppFamilyAriImpl.prototype.isExtensionGroupAri = function() {
        return this.isAtLeastExtensionGroupAri && !this.isExtensionAri();
    };
    AppFamilyAriImpl.prototype.isExtensionAri = function() {
        return this.isAtLeastExtensionGroupAri && this.extensionKey !== undefined;
    };
    AppFamilyAriImpl.prototype.returnIf = function(check, type) {
        if (!check()) throw new $5ixmT.NotExpectedAppFamilyAriTypeError(type, this);
        return this; // :sadpanda:
    };
    Object.defineProperty(AppFamilyAriImpl.prototype, "isAtLeastAppEnvironmentAri", {
        get: function() {
            return this.environmentId !== undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "isAtLeastExtensionGroupAri", {
        get: function() {
            return this.isAtLeastAppEnvironmentAri && this.extensionGroupId !== undefined;
        },
        enumerable: true,
        configurable: true
    });
    AppFamilyAriImpl.prototype.toAri = function() {
        var resourceOwner = $5ixmT.AppFamilyAri.resourceOwner;
        var _a = this.toJSON(), appId = _a.appId, environmentId = _a.environmentId, extensionGroupId = _a.extensionGroupId, extensionKey = _a.extensionKey, version = _a.version;
        function withVersion(segments) {
            var path = segments.join('/');
            if (!version) return path;
            else return "" + path + $0d5dd8c916c95343$var$versionPrefix + version;
        }
        if (this.isExtensionAri()) return new $9cGsb.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $5ixmT.AppFamilyAri.extensionResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId,
                extensionKey
            ])
        });
        else if (this.isExtensionGroupAri()) return new $9cGsb.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $5ixmT.AppFamilyAri.extensionGroupResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId
            ])
        });
        else if (this.isAppEnvironmentAri()) return new $9cGsb.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $5ixmT.AppFamilyAri.environmentResourceType,
            resourceId: withVersion([
                appId,
                environmentId
            ])
        });
        else return new $9cGsb.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $5ixmT.AppFamilyAri.appResourceType,
            resourceId: appId
        });
    };
    AppFamilyAriImpl.prototype.toString = function() {
        return this.toAri().toString();
    };
    return AppFamilyAriImpl;
}();
module.exports.AppFamilyAriImpl = $0d5dd8c916c95343$var$AppFamilyAriImpl;
function $0d5dd8c916c95343$var$stripToUndefined(str) {
    if (!str) return undefined;
    var trimmed = str.trim();
    if (trimmed.length === 0) return undefined;
    return trimmed;
}

});

parcelRegister("cY2bA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7b65b5456cb58a89c127465c15e914fb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $970cc8b2424c50e3$var$_react = $970cc8b2424c50e3$var$_interopRequireDefault((parcelRequire("cozmU")));

var $970cc8b2424c50e3$var$_iconNew = $970cc8b2424c50e3$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $970cc8b2424c50e3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CommentAdd".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/comment-add
 * Usage guidance:
 * Single purpose - Reserved for adding a comment to an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $970cc8b2424c50e3$var$CommentAddIcon = (props)=>/*#__PURE__*/ $970cc8b2424c50e3$var$_react.default.createElement($970cc8b2424c50e3$var$_iconNew.default, Object.assign({
        name: "CommentAddIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2zM0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM7.25 6.5V4.25h1.5V6.5H11V8H8.75v2.25h-1.5V8H5V6.5z" clip-rule="evenodd"/>`
    }, props));
$970cc8b2424c50e3$var$CommentAddIcon.displayName = 'CommentAddIcon';
var $970cc8b2424c50e3$var$_default = module.exports.default = $970cc8b2424c50e3$var$CommentAddIcon;

});

parcelRegister("g9HBv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::992e8918978cf8d73dfb2675b487c3ba>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bc2f4f6c34e02809$var$_react = $bc2f4f6c34e02809$var$_interopRequireDefault((parcelRequire("cozmU")));

var $bc2f4f6c34e02809$var$_iconNew = $bc2f4f6c34e02809$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $bc2f4f6c34e02809$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowDownLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/arrow-down-left
 * Usage guidance:
 * Known uses: Adding content from Rovo Chat into Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bc2f4f6c34e02809$var$ArrowDownLeftIcon = (props)=>/*#__PURE__*/ $bc2f4f6c34e02809$var$_react.default.createElement($bc2f4f6c34e02809$var$_iconNew.default, Object.assign({
        name: "ArrowDownLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.06 12h5.19v1.5h-7a.75.75 0 0 1-.75-.75v-7H4v5.19l8.47-8.47 1.06 1.06z" clip-rule="evenodd"/>`
    }, props));
$bc2f4f6c34e02809$var$ArrowDownLeftIcon.displayName = 'ArrowDownLeftIcon';
var $bc2f4f6c34e02809$var$_default = module.exports.default = $bc2f4f6c34e02809$var$ArrowDownLeftIcon;

});

parcelRegister("6bk1K", function(module, exports) {

var $fR63l = parcelRequire("fR63l");

const $2fd246f9bd706ba4$var$productResourceTypes3PValues = new Set(Object.values((0, $fR63l.ProductResourceTypes3P)));
const $2fd246f9bd706ba4$export$128faf298ac1c721 = (value)=>$2fd246f9bd706ba4$var$productResourceTypes3PValues.has(value);
module.exports["isProductResourceTypes3P"] = $2fd246f9bd706ba4$export$128faf298ac1c721;

});

parcelRegister("5c5T9", function(module, exports) {

var $dAuCI = parcelRequire("dAuCI");


var $ekIRz = parcelRequire("ekIRz");


var $gi5iB = parcelRequire("gi5iB");


var $9dBNg = parcelRequire("9dBNg");

const $f31ceefb57d68572$var$getProductKey3P = (key)=>{
    if ((0, $dAuCI.isProductKey3P)(key)) return key;
    return (0, $9dBNg.ResourceTypeToProductKeyMap).get(key);
};
/**
 * Main facade for accessing connector configuration.
 * Provides a simple, consistent API for all consumers.
 *
 * Accepts either a ProductKeys3P or ProductResourceTypes3P value
 * and resolves the correct config from the appropriate registry.
 */ class $f31ceefb57d68572$var$ConnectorsConfig {
    getProductKey(productKeyOrResourceType) {
        return $f31ceefb57d68572$var$getProductKey3P(productKeyOrResourceType);
    }
    /**
   * Get the full configuration for a specific product.
   */ async getConfig(productKeyOrResourceType) {
        const productKey = $f31ceefb57d68572$var$getProductKey3P(productKeyOrResourceType);
        if (!productKey) return undefined;
        return await (0, $dAuCI.ThirdPartyConfigs).get(productKey);
    }
    /**
   * Get the display name for a product.
   */ async getDisplayName(productKeyOrResourceType) {
        const config = await this.getConfig(productKeyOrResourceType);
        return config?.displayName;
    }
    /**
   * Get the icon for a product.
   */ async getIcon(productKeyOrResourceType) {
        const config = await this.getConfig(productKeyOrResourceType);
        return config?.icon;
    }
    /**
   * Get the search result icon for a product.
   */ async getSearchResultIcon(productKeyOrResourceType) {
        const config = await this.getConfig(productKeyOrResourceType);
        return config?.searchResultIcon;
    }
    /**
   * Check if a product is enabled.
   * Returns false if the product is not found.
   */ async isEnabled(productKeyOrResourceType) {
        const config = await this.getConfig(productKeyOrResourceType);
        return config?.isEnabled() ?? false;
    }
    /**
   * Get the integration ARI for a product.
   */ async getIntegrationAri(productKeyOrResourceType) {
        const config = await this.getConfig(productKeyOrResourceType);
        return config?.integrationAri;
    }
    /**
   * Get the type filter config for a product.
   */ async getTypeFilterConfig(productKeyOrResourceType) {
        const config = await this.getConfig(productKeyOrResourceType);
        return config?.typeFilterConfig;
    }
    /**
   * Get the filters for a product.
   */ async getFilters(productKeyOrResourceType) {
        const config = await this.getConfig(productKeyOrResourceType);
        return config?.filters;
    }
    /**
   * Get the available filters for a product.
   * Returns universal filters merged with product-specific filters, deduped and ordered
   * by the standard filter ordering.
   * Returns only universal filters if the product is not found or has no filters.
   */ async getAvailableFilters(productKeyOrResourceType) {
        const filters = await this.getFilters(productKeyOrResourceType) ?? [];
        // Merge universal + product-specific, deduplicate
        const filterIdSet = new Set([
            ...(0, $gi5iB.UNIVERSAL_FILTER_IDS),
            ...filters
        ]);
        return (0, $ekIRz.filterIdOrdering).filter((id)=>filterIdSet.has(id));
    }
    /**
   * Get all entity ATIs for a product by extracting them from the type filter config.
   * Returns an empty array if the product is not found or has no type filter config.
   */ async getEntitiesForProduct(productKeyOrResourceType) {
        const config = await this.getConfig(productKeyOrResourceType);
        if (!config?.typeFilterConfig) return [];
        const entities = [];
        for (const [, value] of config.typeFilterConfig)entities.push(...value.entities3P);
        return entities;
    }
}
const $f31ceefb57d68572$export$1ed0e6bf09503f7d = new $f31ceefb57d68572$var$ConnectorsConfig();
module.exports["connectorsConfig"] = $f31ceefb57d68572$export$1ed0e6bf09503f7d;

});

parcelRegister("ekIRz", function(module, exports) {
const $45580d730e2d8a50$export$64f2f70bb9f8e772 = [
    'lastUpdated',
    'universalTypeFilter',
    'contributor',
    'space',
    'createdBy',
    'lastUpdatedBy',
    'calendarType',
    'leadStatus',
    'taskStatus',
    'taskType',
    'campaignStatus',
    'caseStatus',
    'documentStatus',
    'opportunityStatus',
    'owner',
    'assignee',
    'project',
    'content',
    'label',
    'onlyTitleMatch',
    'pullRequestStatus',
    'salesforceStage',
    'slackChannel'
];
module.exports["filterIdOrdering"] = $45580d730e2d8a50$export$64f2f70bb9f8e772;

});

parcelRegister("gi5iB", function(module, exports) {
const $c86b822ab75aacde$export$248c41a814b13698 = [
    'lastUpdated',
    'universalTypeFilter',
    'contributor'
];
module.exports["UNIVERSAL_FILTER_IDS"] = $c86b822ab75aacde$export$248c41a814b13698;

});

parcelRegister("b6fxF", function(module, exports) {
/* UserProfileCardForMention.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $6SsN4 = parcelRequire("6SsN4");


var $lQV5m = parcelRequire("lQV5m");


var $cK21K = parcelRequire("cK21K");


var $iMnC5 = parcelRequire("iMnC5");


var $jp2Q3 = parcelRequire("jp2Q3");


var $bPFqZ = parcelRequire("bPFqZ");


var $d5gEx = parcelRequire("d5gEx");


var $1koI0 = parcelRequire("1koI0");


var $g0RaX = parcelRequire("g0RaX");


var $3Z1Pc = parcelRequire("3Z1Pc");


var $fxdou = parcelRequire("fxdou");


var $9zU5G = parcelRequire("9zU5G");

const $0b67b0fc1e6d3033$var$ENTRY_POINT_ID = 'user-profile-card-for-mention';
const $0b67b0fc1e6d3033$var$mentionPopupStyles = {
    hidden: "_0fKRyPnQyn _1pp6NdYbGa"
};
function $0b67b0fc1e6d3033$var$PopperContent({ entryPointReference: entryPointReference, entryPointErrorFallback: entryPointErrorFallback, cloudId: cloudId, testId: testId, agent: agent, customerCardDataLoader: customerCardDataLoader, isReduced: isReduced }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bPFqZ.InternalEntryPointContainer), {
        id: $0b67b0fc1e6d3033$var$ENTRY_POINT_ID,
        entryPointReference: entryPointReference,
        fallback: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fxdou.CardLoading), {
            isReduced: isReduced
        }),
        errorFallback: entryPointErrorFallback,
        runtimeProps: {
            cloudId: cloudId,
            testId: testId,
            agent: agent,
            customerCardDataLoader: customerCardDataLoader,
            isReduced: isReduced
        }
    });
} /**
   * Props common to both render paths.
   */ 
function $0b67b0fc1e6d3033$export$b3a703a1f8ebb0c8(props) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $d5gEx.AtlassianRelayEnvironmentProvider), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($0b67b0fc1e6d3033$var$UserProfileCardForMentionInner, {
            ...props
        })
    });
} /** Inner implementation of {@link UserProfileCardForMention}. */ 
function $0b67b0fc1e6d3033$var$UserProfileCardForMentionInner({ userId: userId, cloudId: cloudId, orgId: orgId, viewerId: viewerId, children: children, referenceElement: referenceElement, placement: placement = 'bottom-start', trigger: trigger, testId: testId, agent: agent, isReduced: isReduced, analyticsAttributes: analyticsAttributes, prefilledProfileData: prefilledProfileData, customerCardDataLoader: customerCardDataLoader, onOpen: onOpen }) {
    const environmentProvider = (0, $d5gEx.useRelayEnvironmentProvider)();
    const onErrorBoundary = (0, $cozmU.useCallback)(()=>{
        (0, $g0RaX.getPageTime)();
    }, []);
    const entryPointErrorFallback = (0, $cozmU.useCallback)((_props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $3Z1Pc.CardError), {
            testId: testId
        }), [
        testId
    ]);
    const [entryPointReference, setEntryPointReference] = (0, $cozmU.useState)(null);
    (0, $cozmU.useEffect)(()=>{
        if (!referenceElement || !userId || !cloudId || !orgId || !viewerId) return;
        const reference = (0, $6SsN4.loadEntryPoint)(environmentProvider, (0, $1koI0.entryPoint), {
            userId: userId,
            cloudId: cloudId,
            orgId: orgId,
            viewerId: viewerId,
            isReduced: isReduced
        });
        setEntryPointReference(reference);
        return ()=>{
            reference.dispose();
            setEntryPointReference(null);
        };
    }, [
        referenceElement,
        userId,
        cloudId,
        orgId,
        viewerId,
        isReduced,
        environmentProvider
    ]); // Both render paths require these identifiers to make a valid API call. Bail out to
    // the plain children (mention chip without a card) when any are missing - the editor
    // path also needs this guard before its popper renders.
    if (!userId || !cloudId || !orgId || !viewerId) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
    if (!referenceElement) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9zU5G.UserProfileCardWithTrigger), {
        userId: userId,
        cloudId: cloudId,
        orgId: orgId,
        viewerId: viewerId,
        placement: placement,
        trigger: trigger,
        testId: testId,
        agent: agent,
        isReduced: isReduced,
        analyticsAttributes: analyticsAttributes,
        prefilledProfileData: prefilledProfileData,
        customerCardDataLoader: customerCardDataLoader,
        onOpen: onOpen,
        shouldRenderToParent: false,
        children: children
    });
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            children,
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9EOlJ.ErrorBoundary), {
                onError: onErrorBoundary,
                fallback: null,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cK21K.default), {
                    zIndex: (0, $jp2Q3.layers).modal(),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lQV5m.Popper), {
                        referenceElement: referenceElement,
                        placement: placement,
                        children: ({ ref: ref, style: style, isReferenceHidden: isReferenceHidden })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                                ref: ref,
                                style: style,
                                xcss: isReferenceHidden ? $0b67b0fc1e6d3033$var$mentionPopupStyles.hidden : undefined,
                                testId: testId ? `${testId}--mention-popup` : undefined,
                                children: entryPointReference ? /*#__PURE__*/ (0, $8aG6j.jsx)($0b67b0fc1e6d3033$var$PopperContent, {
                                    entryPointReference: entryPointReference,
                                    entryPointErrorFallback: entryPointErrorFallback,
                                    cloudId: cloudId,
                                    testId: testId,
                                    agent: agent,
                                    customerCardDataLoader: customerCardDataLoader,
                                    isReduced: isReduced
                                }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fxdou.CardLoading), {
                                    isReduced: isReduced
                                })
                            })
                    })
                })
            })
        ]
    });
}
module.exports["UserProfileCardForMention"] = $0b67b0fc1e6d3033$export$b3a703a1f8ebb0c8;

});

parcelRegister("bUd6P", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $d73bd19527e99345$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--rovo-blue-color, #1868db)" fill-rule="evenodd" d="m13.227 16.789-7.154 4.169-3.403-1.96a2.72 2.72 0 0 1-1.362-2.355V7.366c0-.973.518-1.87 1.361-2.354l6.044-3.487-.038.114a3.6 3.6 0 0 0-.172 1.088v9.278c0 1.274.68 2.45 1.786 3.085z" clip-rule="evenodd"/>
    <path fill="var(--rovo-green-color, #6a9a23)" fill-rule="evenodd" d="m11.296 15.671-7.193 4.153 6.607 3.812a2.73 2.73 0 0 0 2.676.026l.048-.033a2.73 2.73 0 0 0 1.232-1.525 2.7 2.7 0 0 0 .127-.822v-3.594z" clip-rule="evenodd"/>
    <path fill="var(--rovo-purple-color, #af59e1)" fill-rule="evenodd" d="m21.477 5.003-4.404-2.539-5.904 4.89 2.69 1.556a3.56 3.56 0 0 1 1.785 3.086v9.277a3.6 3.6 0 0 1-.21 1.202l6.044-3.486a2.71 2.71 0 0 0 1.362-2.355V7.357c0-.97-.521-1.87-1.363-2.354" clip-rule="evenodd"/>
    <path fill="var(--rovo-yellow-color, #fca700)" fill-rule="evenodd" d="M12.74 8.266 9.353 6.312V2.718c0-.283.044-.56.127-.821A2.73 2.73 0 0 1 10.71.372V.37a.4.4 0 0 0 .048-.033 2.73 2.73 0 0 1 2.676.026l6.499 3.75z" clip-rule="evenodd"/>
</svg>
`;
const $d73bd19527e99345$export$9e62346a60cfb459 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function RovoHexIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Rovo" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $d73bd19527e99345$var$svg,
            label: label,
            type: "rovo",
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : function RovoHexIcon({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Rovo', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $d73bd19527e99345$var$svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["RovoHexIcon"] = $d73bd19527e99345$export$9e62346a60cfb459;

});

parcelRegister("k9SFD", function(module, exports) {

var $drRzc = parcelRequire("drRzc");

const $00f984e1ee672b7a$var$getAppType = (userType)=>userType === 'APP' || userType === 'AGENT' ? 'agent' : 'user';
const $00f984e1ee672b7a$var$enrichMentionNodeData = (mention, data)=>({
        ...data,
        appType: data?.appType ?? $00f984e1ee672b7a$var$getAppType(mention.userType)
    });
const $00f984e1ee672b7a$var$toMentionNode = ({ id: id, userType: userType })=>({
        attrs: {
            id: id,
            // NodeDataProvider uses an ADF node internally, so normalize the runtime-only value.
            userType: userType === 'AGENT' ? 'APP' : userType
        },
        type: 'mention'
    });
const $00f984e1ee672b7a$var$isMentionNode = (node)=>node.type === 'mention' && node.attrs !== undefined && 'id' in node.attrs && typeof node.attrs.id === 'string';
const $00f984e1ee672b7a$var$SUBSCRIPTION_KEY_PREFIX = 'mention-node-data-provider';
let $00f984e1ee672b7a$var$subscriptionKeyCounter = 0;
const $00f984e1ee672b7a$var$cacheMentionData = (cache, mentions)=>{
    mentions.forEach((mention)=>{
        if (mention.isPlaceholder || !mention.avatarUrl) {
            cache.delete(mention.id);
            return;
        }
        cache.set(mention.id, {
            avatarUrl: mention.avatarUrl,
            appType: mention.appType
        });
    });
};
class $00f984e1ee672b7a$export$d2331d8e30b7662 extends (0, $drRzc.NodeDataProvider) {
    isNodeSupported(node) {
        return $00f984e1ee672b7a$var$isMentionNode(node) && node.attrs.userType !== 'SPECIAL';
    }
    nodeDataKey(node) {
        return node.attrs.id;
    }
    async fetchNodesData(nodes) {
        const accountIds = Array.from(new Set(nodes.map(({ attrs: attrs })=>attrs.id)));
        const dataByAccountId = await this.enqueueFetch(accountIds);
        return nodes.map(({ attrs: attrs })=>$00f984e1ee672b7a$var$enrichMentionNodeData(attrs, dataByAccountId[attrs.id]));
    }
    getMentionData(mention, callback) {
        const resolvedData = this.resolveMentionNodeDataFromCache(mention);
        if (resolvedData) {
            callback({
                data: $00f984e1ee672b7a$var$enrichMentionNodeData(mention, resolvedData)
            });
            return;
        }
        this.getData($00f984e1ee672b7a$var$toMentionNode(mention), callback);
    }
    getMentionDataFromCache(mention) {
        const resolvedData = this.resolveMentionNodeDataFromCache(mention);
        if (resolvedData) return $00f984e1ee672b7a$var$enrichMentionNodeData(mention, resolvedData);
        const data = this.getNodeDataFromCache($00f984e1ee672b7a$var$toMentionNode(mention))?.data;
        return data ? $00f984e1ee672b7a$var$enrichMentionNodeData(mention, data) : undefined;
    }
    connect(mentionResource) {
        if (this.lastMentionResource && this.lastMentionResource !== mentionResource) {
            this.emittedMentionCache.clear();
            this.resetCache();
        }
        this.lastMentionResource = mentionResource;
        if (this.abortControllerRef.current.signal.aborted) this.abortControllerRef.current = new AbortController();
        let isDisconnected = false;
        let subscribedMentionProvider;
        mentionResource.then((mentionProvider)=>{
            if (isDisconnected) return;
            subscribedMentionProvider = mentionProvider;
            mentionProvider.subscribe(this.subscriptionKey, (mentions)=>{
                $00f984e1ee672b7a$var$cacheMentionData(this.emittedMentionCache, mentions);
            });
        }).catch(()=>undefined);
        return ()=>{
            isDisconnected = true;
            this.abortControllerRef.current.abort();
            subscribedMentionProvider?.unsubscribe(this.subscriptionKey);
            subscribedMentionProvider = undefined;
        };
    }
    resolveMentionNodeDataFromCache(mention) {
        return this.resolveMentionNodeData?.(mention) ?? this.emittedMentionCache.get(mention.id);
    }
    enqueueFetch(accountIds) {
        const result = new Promise((resolve, reject)=>{
            this.queuedFetches.push({
                accountIds: accountIds,
                reject: reject,
                resolve: resolve
            });
        });
        if (!this.isFlushScheduled) {
            this.isFlushScheduled = true;
            Promise.resolve().then(()=>this.flushFetches());
        }
        return result;
    }
    async flushFetches() {
        this.isFlushScheduled = false;
        const queuedFetches = this.queuedFetches;
        this.queuedFetches = [];
        const accountIds = Array.from(new Set(queuedFetches.flatMap((request)=>request.accountIds)));
        try {
            const data = await this.fetchMentionNodeData(accountIds, this.abortControllerRef.current.signal);
            queuedFetches.forEach(({ resolve: resolve })=>resolve(data));
        } catch (error) {
            queuedFetches.forEach(({ reject: reject })=>reject(error));
        }
    }
    constructor(fetchMentionNodeData, resolveMentionNodeData){
        super(), this.fetchMentionNodeData = fetchMentionNodeData, this.resolveMentionNodeData = resolveMentionNodeData;
        this.name = 'mentionNodeDataProvider';
        this.abortControllerRef = {
            current: new AbortController()
        };
        this.emittedMentionCache = new Map();
        this.subscriptionKey = `${$00f984e1ee672b7a$var$SUBSCRIPTION_KEY_PREFIX}:${++$00f984e1ee672b7a$var$subscriptionKeyCounter}`;
        this.lastMentionResource = void 0;
        this.queuedFetches = [];
        this.isFlushScheduled = false;
    }
}
module.exports["MentionNodeDataProvider"] = $00f984e1ee672b7a$export$d2331d8e30b7662;

});

parcelRegister("i6ZUk", function(module, exports) {

var $15uL0 = parcelRequire("15uL0");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/identity/team/manifest.ts
var $d2f8cf1894db7ef9$var$identityTeamAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $15uL0.IdentityTeamAriResourceOwner),
    resourceType: (0, $15uL0.IdentityTeamAriResourceType),
    resourceIdSlug: "{teamId}",
    resourceIdSegmentFormats: {
        teamId: /[a-zA-Z0-9.\-_~]+/
    }
};
// src/identity/team/index.ts
var $d2f8cf1894db7ef9$export$33bbb2d79e520118 = class _IdentityTeamAri extends (0, $9j37t.RegisteredAri) {
    get teamId() {
        return this._teamId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $d2f8cf1894db7ef9$var$identityTeamAriStaticOpts.qualifier,
            platformQualifier: $d2f8cf1894db7ef9$var$identityTeamAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $d2f8cf1894db7ef9$var$identityTeamAriStaticOpts.resourceOwner,
            resourceType: $d2f8cf1894db7ef9$var$identityTeamAriStaticOpts.resourceType,
            resourceId: `${opts.teamId}`,
            resourceIdSegmentValues: {
                teamId: opts.teamId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $d2f8cf1894db7ef9$var$identityTeamAriStaticOpts);
        return new _IdentityTeamAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $d2f8cf1894db7ef9$var$identityTeamAriStaticOpts);
        return new _IdentityTeamAri(opts);
    }
    getVariables() {
        return {
            teamId: this.teamId
        };
    }
    constructor(opts){
        super(opts), this._teamId = opts.resourceIdSegmentValues.teamId;
    }
};
module.exports["IdentityTeamAri"] = $d2f8cf1894db7ef9$export$33bbb2d79e520118;

});

parcelRegister("15uL0", function(module, exports) {
// src/identity/team/types.ts
var $0cae1dd2c8cb7865$export$49beddf48ffb3f35 = "identity", $0cae1dd2c8cb7865$export$b2079a2a841afe32 = "team";
module.exports["IdentityTeamAriResourceOwner"] = $0cae1dd2c8cb7865$export$49beddf48ffb3f35;
module.exports["IdentityTeamAriResourceType"] = $0cae1dd2c8cb7865$export$b2079a2a841afe32;

});

parcelRegister("6e6qw", function(module, exports) {

var $9C0Fm = parcelRequire("9C0Fm");


var $kRX0a = parcelRequire("kRX0a");


var $iDrrr = parcelRequire("iDrrr");


var $7Y8M5 = parcelRequire("7Y8M5");

/**
 * Fixed telepointer palette slot for each `@atlaskit/agent-color` brand this editor recognises by
 * a reserved identity colour rather than a hashed one. Positions also back the telepointer CSS
 * classes, so preserve them when editing the palette.
 */ const $c454c81005f3f72e$var$BRAND_PARTICIPANT_COLOR_INDEX = {
    'agent-brand-claude': 7,
    'agent-brand-rovo': 4,
    'agent-brand-chatgpt': 9,
    'agent-brand-figma': 9,
    'agent-brand-lovable': 9,
    'agent-brand-replit': 9
};
/** Brands whose registered `bold`/`boldText` values take precedence over their palette slot. */ const $c454c81005f3f72e$var$BRAND_EXACT_COLOR_SCHEMES = new Set([
    'agent-brand-chatgpt',
    'agent-brand-rovo',
    'agent-brand-figma',
    'agent-brand-lovable',
    'agent-brand-replit'
]);
/** Maps Agent Studio's semantic palette to the established telepointer palette slots. */ const $c454c81005f3f72e$var$AGENT_COLOR_TO_PARTICIPANT_COLOR_INDEX = {
    yellow: 3,
    purple: 4,
    lime: 8,
    blue: 1
};
/** The two red palette slots. Red reads as "deleted", so it never identifies a participant. */ const $c454c81005f3f72e$var$RESERVED_PARTICIPANT_COLOR_INDEXES = new Set([
    0,
    11
]);
/** Advances past a reserved slot, wrapping around the palette. */ const $c454c81005f3f72e$var$getAssignableIndex = (index)=>{
    for(let offset = 0; offset < (0, $7Y8M5.participantColors).length; offset++){
        const candidate = (index + offset) % (0, $7Y8M5.participantColors).length;
        if (!$c454c81005f3f72e$var$RESERVED_PARTICIPANT_COLOR_INDEXES.has(candidate)) return candidate;
    }
    return index;
};
function $c454c81005f3f72e$export$c14f61804029af13(str) {
    let hash = 0;
    for(let i = 0; i < str.length; i++){
        /* eslint-disable no-bitwise */ hash = (hash << 5) - hash + str.charCodeAt(i);
        hash = (hash & hash) >>> 0;
    /* eslint-enable no-bitwise */ }
    return hash;
}
function $c454c81005f3f72e$export$60ba61eca4eb64f2(str, agentType) {
    // `agentType` may be a named id (e.g. `mcp_lovable_agent`) or a display name (e.g. `lovable`).
    const brand = agentType ? (0, $kRX0a.getThirdPartyAgentColor)({
        agentNamedId: agentType,
        agentName: agentType
    }) : undefined;
    if (brand) {
        const fixedIndex = $c454c81005f3f72e$var$BRAND_PARTICIPANT_COLOR_INDEX[brand.scheme];
        if (fixedIndex !== undefined) {
            const color = $c454c81005f3f72e$var$BRAND_EXACT_COLOR_SCHEMES.has(brand.scheme) ? {
                backgroundColor: brand.bold,
                svgBackgroundColor: brand.bold,
                textColor: brand.boldText
            } : (0, $7Y8M5.participantColors)[fixedIndex];
            return {
                index: fixedIndex,
                color: color,
                isFixed: true
            };
        }
    }
    const agentColor = agentType ? (0, $9C0Fm.getAgentColor)({
        agentId: str
    }) : undefined;
    const preferredIndex = agentColor ? $c454c81005f3f72e$var$AGENT_COLOR_TO_PARTICIPANT_COLOR_INDEX[agentColor] : $c454c81005f3f72e$export$c14f61804029af13(str) % (0, $7Y8M5.participantColors).length;
    const index = (0, $iDrrr.fg)('confluence_ncs_step_diffing_version_history') ? $c454c81005f3f72e$var$getAssignableIndex(preferredIndex) : preferredIndex;
    return {
        index: index,
        color: (0, $7Y8M5.participantColors)[index]
    };
}
module.exports["getHashCode"] = $c454c81005f3f72e$export$c14f61804029af13;
module.exports["getParticipantColor"] = $c454c81005f3f72e$export$60ba61eca4eb64f2;

});

parcelRegister("9C0Fm", function(module, exports) {
const $57a968c3db13c543$var$AGENT_COLOR_ORDER = [
    'yellow',
    'purple',
    'lime',
    'blue'
];
const $57a968c3db13c543$var$NAMED_AGENT_COLORS = {
    autodev_template_unit_test_creator: 'lime',
    autodev_template_migration_config_changer_agent: 'lime',
    autodev_template_vulnerable_dependency_updater_agent: 'lime',
    autodev_template_code_standardizer_agent: 'lime',
    autodev_template_code_observer_agent: 'lime',
    autodev_template_code_accessibility_checker_agent: 'lime',
    autodev_code_documentation_writer_agent: 'lime',
    autodev_feature_flag_cleaner_agent: 'lime',
    decision_director_agent: 'lime',
    planner_agent: 'purple',
    tech_writer_agent: 'blue',
    user_manual_writer_agent: 'yellow',
    product_requirements_expert_agent: 'yellow',
    issue_organizer_agent: 'lime',
    ops_guide_agent: 'yellow',
    discovery_and_feedback_agent: 'lime',
    jira_workflow_builder_agent: 'blue',
    itops_rca_agent: 'yellow',
    jira_trial_guide_agent: 'blue',
    daily_brief_agent: 'yellow',
    jira_admin_agent: 'blue',
    jsm_rovo_service_agent: 'yellow',
    mcp_amplitude_agent: 'blue',
    mcp_box_agent: 'blue',
    mcp_canva_agent: 'blue',
    mcp_figma_agent: 'blue',
    mcp_hubspot_agent: 'blue',
    mcp_intercom_agent: 'blue',
    mcp_gamma_agent: 'blue',
    mcp_lovable_agent: 'blue',
    mcp_replit_agent: 'blue',
    rovo_agent: 'blue',
    jira_work_agent: 'blue',
    jira_intelligent_triage_agent: 'blue',
    jira_coding_agent: 'blue'
};
const $57a968c3db13c543$export$8ff4e76da970e804 = ({ agentId: agentId, agentNamedId: agentNamedId, agentIdentityAccountId: agentIdentityAccountId })=>{
    const namedAgentColor = agentNamedId ? $57a968c3db13c543$var$NAMED_AGENT_COLORS[agentNamedId] : undefined;
    if (namedAgentColor) return namedAgentColor;
    const id = agentIdentityAccountId || agentId;
    const parsedId = Number.parseInt(id?.slice(-8).replace(/[-:]/gu, '') ?? '', 16);
    const stableAgentId = Number.isNaN(parsedId) ? 0 : parsedId;
    return $57a968c3db13c543$var$AGENT_COLOR_ORDER[stableAgentId % $57a968c3db13c543$var$AGENT_COLOR_ORDER.length] ?? 'yellow';
};
module.exports["getAgentColor"] = $57a968c3db13c543$export$8ff4e76da970e804;

});

parcelRegister("kRX0a", function(module, exports) {

var $aLnnX = parcelRequire("aLnnX");

const $8b0c132afa0fd924$var$namedBrands = {
    mcp_amplitude_agent: 'agent-brand-amplitude',
    mcp_figma_agent: 'agent-brand-figma',
    mcp_lovable_agent: 'agent-brand-lovable',
    mcp_replit_agent: 'agent-brand-replit'
};
/** Every alias a brand is identified by, normalised (trimmed, lowercased) before matching. */ const $8b0c132afa0fd924$var$displayNameBrands = {
    amplitude: 'agent-brand-amplitude',
    antigravity: 'agent-brand-antigravity',
    chatgpt: 'agent-brand-chatgpt',
    claude: 'agent-brand-claude',
    copilot: 'agent-brand-copilot',
    cortex: 'agent-brand-cortex',
    databricks: 'agent-brand-databricks',
    figma: 'agent-brand-figma',
    gemini: 'agent-brand-gemini',
    lovable: 'agent-brand-lovable',
    loveable: 'agent-brand-lovable',
    manus: 'agent-brand-manus',
    replit: 'agent-brand-replit',
    rovo: 'agent-brand-rovo',
    rovo_chat: 'agent-brand-rovo',
    slack: 'agent-brand-slack'
};
/** Canonical display name for each brand, so callers stop maintaining their own copy. */ const $8b0c132afa0fd924$var$brandDisplayNames = {
    'agent-brand-amplitude': 'Amplitude',
    'agent-brand-antigravity': 'Antigravity',
    'agent-brand-chatgpt': 'ChatGPT',
    'agent-brand-claude': 'Claude',
    'agent-brand-copilot': 'Copilot',
    'agent-brand-cortex': 'Cortex',
    'agent-brand-databricks': 'Databricks',
    'agent-brand-figma': 'Figma',
    'agent-brand-gemini': 'Gemini',
    'agent-brand-lovable': 'Lovable',
    'agent-brand-manus': 'Manus',
    'agent-brand-replit': 'Replit',
    'agent-brand-rovo': 'Rovo',
    'agent-brand-slack': 'Slack'
};
const $8b0c132afa0fd924$export$6a8569a6e7f99156 = ({ agentNamedId: agentNamedId, agentName: agentName })=>{
    const namedId = agentNamedId ?? '';
    const displayName = agentName?.trim().toLowerCase() ?? '';
    const namedScheme = Object.prototype.hasOwnProperty.call($8b0c132afa0fd924$var$namedBrands, namedId) ? $8b0c132afa0fd924$var$namedBrands[namedId] : undefined;
    const displayScheme = Object.prototype.hasOwnProperty.call($8b0c132afa0fd924$var$displayNameBrands, displayName) ? $8b0c132afa0fd924$var$displayNameBrands[displayName] : undefined;
    const scheme = namedScheme ?? displayScheme;
    return scheme ? {
        ...(0, $aLnnX.agentBrandColorSchemes)[scheme],
        name: $8b0c132afa0fd924$var$brandDisplayNames[scheme],
        scheme: scheme
    } : undefined;
};
module.exports["getThirdPartyAgentColor"] = $8b0c132afa0fd924$export$6a8569a6e7f99156;

});

parcelRegister("aLnnX", function(module, exports) {
const $73546ddb798eba32$var$themed = (light, dark)=>`light-dark(${light}, ${dark})`;
const $73546ddb798eba32$var$monochrome = {
    accentText: $73546ddb798eba32$var$themed('#000000', '#E8E8EA'),
    background: $73546ddb798eba32$var$themed('#E5E5E5', '#333335'),
    bold: $73546ddb798eba32$var$themed('#000000', '#E8E8EA'),
    boldText: $73546ddb798eba32$var$themed('#FFFFFF', '#292A2E'),
    border: $73546ddb798eba32$var$themed('#BEB9B9', '#656567'),
    text: $73546ddb798eba32$var$themed('#292A2E', '#E8E8EA')
};
/** Brand values use the product's CSS colour scheme, so existing decorations follow theme changes. */ const $73546ddb798eba32$var$brandColors = {
    'agent-brand-replit': {
        accentText: $73546ddb798eba32$var$themed('#000000', '#E8E8EA'),
        background: $73546ddb798eba32$var$themed('#E5E5E5', '#333335'),
        bold: $73546ddb798eba32$var$themed('#000000', '#E8E8EA'),
        boldText: $73546ddb798eba32$var$themed('#FFFFFF', '#000000'),
        border: $73546ddb798eba32$var$themed('#BEB9B9', '#656567'),
        text: $73546ddb798eba32$var$themed('#292A2E', '#E8E8EA')
    },
    'agent-brand-lovable': {
        accentText: $73546ddb798eba32$var$themed('#000000', '#E8E8EA'),
        background: $73546ddb798eba32$var$themed('#E5E5E5', '#333335'),
        bold: $73546ddb798eba32$var$themed('#000000', '#E8E8EA'),
        boldText: $73546ddb798eba32$var$themed('#FFFFFF', '#000000'),
        border: $73546ddb798eba32$var$themed('#BEB9B9', '#656567'),
        text: $73546ddb798eba32$var$themed('#292A2E', '#E8E8EA')
    },
    'agent-brand-figma': {
        accentText: $73546ddb798eba32$var$themed('#000000', '#E8E8EA'),
        background: $73546ddb798eba32$var$themed('#E5E5E5', '#333335'),
        bold: $73546ddb798eba32$var$themed('#000000', '#E8E8EA'),
        boldText: $73546ddb798eba32$var$themed('#FFFFFF', '#000000'),
        border: $73546ddb798eba32$var$themed('#BEB9B9', '#656567'),
        emphasisBackground: $73546ddb798eba32$var$themed('#E5E5E5', '#333335'),
        text: $73546ddb798eba32$var$themed('#292A2E', '#E8E8EA')
    },
    'agent-brand-databricks': {
        accentText: $73546ddb798eba32$var$themed('#B52113', '#FF8C80'),
        background: $73546ddb798eba32$var$themed('#FFEBE9', '#352525'),
        bold: $73546ddb798eba32$var$themed('#FF3621', '#FF5F4D'),
        boldText: $73546ddb798eba32$var$themed('#FFFFFF', '#292A2E'),
        border: $73546ddb798eba32$var$themed('#FFBBB4', '#6D3530'),
        text: $73546ddb798eba32$var$themed('#292A2E', '#E8E8EA')
    },
    'agent-brand-amplitude': {
        accentText: $73546ddb798eba32$var$themed('#0052F2', '#8FB9FF'),
        background: $73546ddb798eba32$var$themed('#E5EEFE', '#242A37'),
        bold: $73546ddb798eba32$var$themed('#0052F2', '#4C8DFF'),
        boldText: $73546ddb798eba32$var$themed('#FFFFFF', '#000000'),
        border: $73546ddb798eba32$var$themed('#B9D1FC', '#2F466F'),
        text: $73546ddb798eba32$var$themed('#292A2E', '#E8E8EA')
    },
    'agent-brand-slack': {
        accentText: $73546ddb798eba32$var$themed('#611F69', '#E8E8EA'),
        background: $73546ddb798eba32$var$themed('#EFE9F0', '#333335'),
        bold: $73546ddb798eba32$var$themed('#611F69', '#E8E8EA'),
        boldText: $73546ddb798eba32$var$themed('#FFFFFF', '#292A2E'),
        border: $73546ddb798eba32$var$themed('#C892D1', '#656567'),
        text: $73546ddb798eba32$var$themed('#292A2E', '#E8E8EA')
    },
    'agent-brand-copilot': $73546ddb798eba32$var$monochrome,
    'agent-brand-cortex': {
        accentText: $73546ddb798eba32$var$themed('#25074D', '#AA8AD4'),
        background: $73546ddb798eba32$var$themed('#E9E6ED', '#2D2A33'),
        bold: $73546ddb798eba32$var$themed('#25074D', '#AA8AD4'),
        boldText: $73546ddb798eba32$var$themed('#FFFFFF', '#292A2E'),
        border: $73546ddb798eba32$var$themed('#AA8AD4', '#504460'),
        text: $73546ddb798eba32$var$themed('#292A2E', '#E8E8EA')
    },
    'agent-brand-manus': {
        accentText: $73546ddb798eba32$var$themed('#34322D', '#C7C1B5'),
        background: $73546ddb798eba32$var$themed('#EBEAEA', '#302F30'),
        bold: $73546ddb798eba32$var$themed('#34322D', '#C7C1B5'),
        boldText: $73546ddb798eba32$var$themed('#FFFFFF', '#292A2E'),
        border: $73546ddb798eba32$var$themed('#B5AFAF', '#5A5855'),
        text: $73546ddb798eba32$var$themed('#292A2E', '#E8E8EA')
    },
    'agent-brand-gemini': $73546ddb798eba32$var$monochrome,
    'agent-brand-antigravity': $73546ddb798eba32$var$monochrome,
    /** ADS orange, the fixed telepointer/attribution slot Claude has always used. */ 'agent-brand-claude': {
        accentText: "var(--ds-text-accent-orange, #9E4C00)",
        background: "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
        bold: "var(--ds-background-accent-orange-bolder, #BD5B00)",
        boldText: "var(--ds-text-inverse, #FFFFFF)",
        border: "var(--ds-border-accent-orange, #E06C00)",
        text: "var(--ds-text, #292A2E)"
    },
    /** ADS purple, the fixed telepointer/attribution slot Rovo has always used. */ 'agent-brand-rovo': {
        accentText: "var(--ds-text-accent-purple, #803FA5)",
        background: "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
        bold: "var(--ds-background-accent-purple-bolder, #964AC0)",
        boldText: "var(--ds-text-inverse, #FFFFFF)",
        border: "var(--ds-border-accent-purple, #AF59E1)",
        text: "var(--ds-text, #292A2E)"
    },
    'agent-brand-chatgpt': {
        accentText: $73546ddb798eba32$var$themed('#000000', '#E8E8EA'),
        background: $73546ddb798eba32$var$themed('#E5E5E5', '#333335'),
        bold: $73546ddb798eba32$var$themed('#000000', '#E8E8EA'),
        boldText: $73546ddb798eba32$var$themed('#FFFFFF', '#000000'),
        border: $73546ddb798eba32$var$themed('#BEB9B9', '#656567'),
        text: $73546ddb798eba32$var$themed('#292A2E', '#E8E8EA')
    }
};
const $73546ddb798eba32$export$6dbdccb358142509 = Object.fromEntries(Object.entries($73546ddb798eba32$var$brandColors).map(([scheme, colors])=>[
        scheme,
        Object.fromEntries(Object.entries(colors).map(([role, value])=>[
                role,
                `var(--${scheme}-${role}, ${value})`
            ]))
    ]));
module.exports["agentBrandColorSchemes"] = $73546ddb798eba32$export$6dbdccb358142509;

});

parcelRegister("3xwCI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c5429223205b4172af0cbd0d2ddcaa04>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $293dc2808d336068$var$_react = $293dc2808d336068$var$_interopRequireDefault((parcelRequire("cozmU")));

var $293dc2808d336068$var$_iconNew = $293dc2808d336068$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $293dc2808d336068$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Pencil".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/pencil
 * Usage guidance:
 * Known uses: compose video title in Loom
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $293dc2808d336068$var$PencilIcon = (props)=>/*#__PURE__*/ $293dc2808d336068$var$_react.default.createElement($293dc2808d336068$var$_iconNew.default, Object.assign({
        name: "PencilIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.336 1.604a2 2 0 0 1 2.828 0l1.233 1.232a2 2 0 0 1 0 2.828l-8.099 8.099a2 2 0 0 1-1.022.547l-3.379.675a.75.75 0 0 1-.882-.882l.675-3.379a2 2 0 0 1 .547-1.022zm1.768 1.06a.5.5 0 0 0-.707 0l-.961.961 1.939 1.94.96-.961a.5.5 0 0 0 0-.707zm-.79 3.961-1.939-1.94-6.077 6.078a.5.5 0 0 0-.137.255l-.455 2.276 2.276-.455a.5.5 0 0 0 .255-.137zM16 15H8v-1.5h8z" clip-rule="evenodd"/>`
    }, props));
$293dc2808d336068$var$PencilIcon.displayName = 'PencilIcon';
var $293dc2808d336068$var$_default = module.exports.default = $293dc2808d336068$var$PencilIcon;

});

parcelRegister("aIn0d", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $i1t43 = parcelRequire("i1t43");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");


var $10I6z = parcelRequire("10I6z");

const $5f85a79aee555eb3$var$AI_DISCLAIMER_LINK = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $5f85a79aee555eb3$var$styles = {
    text: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8"
};
const $5f85a79aee555eb3$export$e0542ba0c737fe5c = ({ onLinkClick: onLinkClick, withLink: withLink = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const disclaimerContent = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, formatMessage((0, $10I6z.i18n).disclaimerMessage));
    if (withLink) return /*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
        appearance: "subtle",
        href: $5f85a79aee555eb3$var$AI_DISCLAIMER_LINK,
        target: "_blank",
        onClick: onLinkClick
    }, disclaimerContent);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($5f85a79aee555eb3$var$styles.text)
    }, disclaimerContent);
};
module.exports["AIDisclaimer"] = $5f85a79aee555eb3$export$e0542ba0c737fe5c;

});

parcelRegister("10I6z", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $1ae8fb340800d3e1$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    disclaimerMessage: {
        id: "ai-disclaimer.disclaimerMessage",
        defaultMessage: "Uses AI. Verify results."
    }
});
module.exports["i18n"] = $1ae8fb340800d3e1$export$a7357cdd1f0b0168;

});

parcelRegister("5FMVr", function(module, exports) {

var $6EphZ = parcelRequire("6EphZ");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/confluence/site/manifest.ts
var $4216bba50de8d2e4$var$confluenceSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $6EphZ.ConfluenceSiteAriResourceOwner),
    resourceType: (0, $6EphZ.ConfluenceSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/confluence/site/index.ts
var $4216bba50de8d2e4$export$82e6693d75ffdd8 = class _ConfluenceSiteAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $4216bba50de8d2e4$var$confluenceSiteAriStaticOpts.qualifier,
            platformQualifier: $4216bba50de8d2e4$var$confluenceSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $4216bba50de8d2e4$var$confluenceSiteAriStaticOpts.resourceOwner,
            resourceType: $4216bba50de8d2e4$var$confluenceSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $4216bba50de8d2e4$var$confluenceSiteAriStaticOpts);
        return new _ConfluenceSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $4216bba50de8d2e4$var$confluenceSiteAriStaticOpts);
        return new _ConfluenceSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.resourceIdSegmentValues.siteId;
    }
};
module.exports["ConfluenceSiteAri"] = $4216bba50de8d2e4$export$82e6693d75ffdd8;

});

parcelRegister("6EphZ", function(module, exports) {
// src/confluence/site/types.ts
var $4d7a18635b736c71$export$9e07499cd8b0bde5 = "confluence", $4d7a18635b736c71$export$57b7cabbf31f1f68 = "site";
module.exports["ConfluenceSiteAriResourceOwner"] = $4d7a18635b736c71$export$9e07499cd8b0bde5;
module.exports["ConfluenceSiteAriResourceType"] = $4d7a18635b736c71$export$57b7cabbf31f1f68;

});

parcelRegister("8BP5b", function(module, exports) {

var $lGE71 = parcelRequire("lGE71");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/jira/issue/manifest.ts
var $6449675e1ef1fb59$var$jiraIssueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $lGE71.JiraIssueAriResourceOwner),
    resourceType: (0, $lGE71.JiraIssueAriResourceType),
    resourceIdSlug: "{issueId}",
    resourceIdSegmentFormats: {
        issueId: /[0-9]+/
    }
};
// src/jira/issue/index.ts
var $6449675e1ef1fb59$export$1da6808e89ee03e = class _JiraIssueAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get issueId() {
        return this._issueId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $6449675e1ef1fb59$var$jiraIssueAriStaticOpts.qualifier,
            platformQualifier: $6449675e1ef1fb59$var$jiraIssueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $6449675e1ef1fb59$var$jiraIssueAriStaticOpts.resourceOwner,
            resourceType: $6449675e1ef1fb59$var$jiraIssueAriStaticOpts.resourceType,
            resourceId: `${opts.issueId}`,
            resourceIdSegmentValues: {
                issueId: opts.issueId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $6449675e1ef1fb59$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $6449675e1ef1fb59$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            issueId: this.issueId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._issueId = opts.resourceIdSegmentValues.issueId;
    }
};
module.exports["JiraIssueAri"] = $6449675e1ef1fb59$export$1da6808e89ee03e;

});

parcelRegister("lGE71", function(module, exports) {
// src/jira/issue/types.ts
var $fc9ca2abfea94195$export$665a39f1b4e29e0a = "jira", $fc9ca2abfea94195$export$76beb4d0da177ad4 = "issue";
module.exports["JiraIssueAriResourceOwner"] = $fc9ca2abfea94195$export$665a39f1b4e29e0a;
module.exports["JiraIssueAriResourceType"] = $fc9ca2abfea94195$export$76beb4d0da177ad4;

});

parcelRegister("5O8nX", function(module, exports) {

var $ilC9E = parcelRequire("ilC9E");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/townsquare/project/manifest.ts
var $43a820726e3539da$var$townsquareProjectAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $ilC9E.TownsquareProjectAriResourceOwner),
    resourceType: (0, $ilC9E.TownsquareProjectAriResourceType),
    resourceIdSlug: "{projectUuid}",
    resourceIdSegmentFormats: {
        projectUuid: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/townsquare/project/index.ts
var $43a820726e3539da$export$41215e8d01921e7d = class _TownsquareProjectAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get projectUuid() {
        return this._projectUuid;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $43a820726e3539da$var$townsquareProjectAriStaticOpts.qualifier,
            platformQualifier: $43a820726e3539da$var$townsquareProjectAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $43a820726e3539da$var$townsquareProjectAriStaticOpts.resourceOwner,
            resourceType: $43a820726e3539da$var$townsquareProjectAriStaticOpts.resourceType,
            resourceId: `${opts.projectUuid}`,
            resourceIdSegmentValues: {
                projectUuid: opts.projectUuid
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $43a820726e3539da$var$townsquareProjectAriStaticOpts);
        return new _TownsquareProjectAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $43a820726e3539da$var$townsquareProjectAriStaticOpts);
        return new _TownsquareProjectAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            projectUuid: this.projectUuid
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._projectUuid = opts.resourceIdSegmentValues.projectUuid;
    }
};
module.exports["TownsquareProjectAri"] = $43a820726e3539da$export$41215e8d01921e7d;

});

parcelRegister("ilC9E", function(module, exports) {
// src/townsquare/project/types.ts
var $d5b7c8e3ddea6aee$export$a258bc824c789b17 = "townsquare", $d5b7c8e3ddea6aee$export$aa8900dadffaa32a = "project";
module.exports["TownsquareProjectAriResourceOwner"] = $d5b7c8e3ddea6aee$export$a258bc824c789b17;
module.exports["TownsquareProjectAriResourceType"] = $d5b7c8e3ddea6aee$export$aa8900dadffaa32a;

});

parcelRegister("lT7Mv", function(module, exports) {

var $jp6rV = parcelRequire("jp6rV");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/confluence/database/manifest.ts
var $fef4c53c0d169c78$var$confluenceDatabaseAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $jp6rV.ConfluenceDatabaseAriResourceOwner),
    resourceType: (0, $jp6rV.ConfluenceDatabaseAriResourceType),
    resourceIdSlug: "activation/{activationId}/{databaseId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        databaseId: /[0-9]+/
    }
};
// src/confluence/database/index.ts
var $fef4c53c0d169c78$export$317cd32472deea7e = class _ConfluenceDatabaseAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get databaseId() {
        return this._databaseId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $fef4c53c0d169c78$var$confluenceDatabaseAriStaticOpts.qualifier,
            platformQualifier: $fef4c53c0d169c78$var$confluenceDatabaseAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $fef4c53c0d169c78$var$confluenceDatabaseAriStaticOpts.resourceOwner,
            resourceType: $fef4c53c0d169c78$var$confluenceDatabaseAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.databaseId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                databaseId: opts.databaseId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $fef4c53c0d169c78$var$confluenceDatabaseAriStaticOpts);
        return new _ConfluenceDatabaseAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $fef4c53c0d169c78$var$confluenceDatabaseAriStaticOpts);
        return new _ConfluenceDatabaseAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            databaseId: this.databaseId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._databaseId = opts.resourceIdSegmentValues.databaseId;
    }
};
module.exports["ConfluenceDatabaseAri"] = $fef4c53c0d169c78$export$317cd32472deea7e;

});

parcelRegister("jp6rV", function(module, exports) {
// src/confluence/database/types.ts
var $e2055ad385da7e5a$export$e83bc7b627335f1d = "confluence", $e2055ad385da7e5a$export$d26db9a1a0b750aa = "database";
module.exports["ConfluenceDatabaseAriResourceOwner"] = $e2055ad385da7e5a$export$e83bc7b627335f1d;
module.exports["ConfluenceDatabaseAriResourceType"] = $e2055ad385da7e5a$export$d26db9a1a0b750aa;

});

parcelRegister("k0a0F", function(module, exports) {

var $1pgGd = parcelRequire("1pgGd");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/confluence/embed/manifest.ts
var $e8fb927b13f87211$var$confluenceEmbedAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $1pgGd.ConfluenceEmbedAriResourceOwner),
    resourceType: (0, $1pgGd.ConfluenceEmbedAriResourceType),
    resourceIdSlug: "activation/{activationId}/{embedId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        embedId: /[0-9]+/
    }
};
// src/confluence/embed/index.ts
var $e8fb927b13f87211$export$47d4b4205d0ac61a = class _ConfluenceEmbedAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get embedId() {
        return this._embedId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $e8fb927b13f87211$var$confluenceEmbedAriStaticOpts.qualifier,
            platformQualifier: $e8fb927b13f87211$var$confluenceEmbedAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $e8fb927b13f87211$var$confluenceEmbedAriStaticOpts.resourceOwner,
            resourceType: $e8fb927b13f87211$var$confluenceEmbedAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.embedId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                embedId: opts.embedId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $e8fb927b13f87211$var$confluenceEmbedAriStaticOpts);
        return new _ConfluenceEmbedAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $e8fb927b13f87211$var$confluenceEmbedAriStaticOpts);
        return new _ConfluenceEmbedAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            embedId: this.embedId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._embedId = opts.resourceIdSegmentValues.embedId;
    }
};
module.exports["ConfluenceEmbedAri"] = $e8fb927b13f87211$export$47d4b4205d0ac61a;

});

parcelRegister("1pgGd", function(module, exports) {
// src/confluence/embed/types.ts
var $10651083a44828c2$export$7a02af293cacddd2 = "confluence", $10651083a44828c2$export$f817d48842ea0d4a = "embed";
module.exports["ConfluenceEmbedAriResourceOwner"] = $10651083a44828c2$export$7a02af293cacddd2;
module.exports["ConfluenceEmbedAriResourceType"] = $10651083a44828c2$export$f817d48842ea0d4a;

});

parcelRegister("bAV6O", function(module, exports) {

var $7SOnZ = parcelRequire("7SOnZ");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/confluence/folder/manifest.ts
var $870f5b1ead2b6083$var$confluenceFolderAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $7SOnZ.ConfluenceFolderAriResourceOwner),
    resourceType: (0, $7SOnZ.ConfluenceFolderAriResourceType),
    resourceIdSlug: "activation/{activationId}/{folderId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        folderId: /[0-9]+/
    }
};
// src/confluence/folder/index.ts
var $870f5b1ead2b6083$export$501a782385a3f485 = class _ConfluenceFolderAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get folderId() {
        return this._folderId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $870f5b1ead2b6083$var$confluenceFolderAriStaticOpts.qualifier,
            platformQualifier: $870f5b1ead2b6083$var$confluenceFolderAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $870f5b1ead2b6083$var$confluenceFolderAriStaticOpts.resourceOwner,
            resourceType: $870f5b1ead2b6083$var$confluenceFolderAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.folderId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                folderId: opts.folderId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $870f5b1ead2b6083$var$confluenceFolderAriStaticOpts);
        return new _ConfluenceFolderAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $870f5b1ead2b6083$var$confluenceFolderAriStaticOpts);
        return new _ConfluenceFolderAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            folderId: this.folderId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._folderId = opts.resourceIdSegmentValues.folderId;
    }
};
module.exports["ConfluenceFolderAri"] = $870f5b1ead2b6083$export$501a782385a3f485;

});

parcelRegister("7SOnZ", function(module, exports) {
// src/confluence/folder/types.ts
var $5bd4a92be6836a9b$export$77cf4e1b17902bfa = "confluence", $5bd4a92be6836a9b$export$6256ff329bc25a9c = "folder";
module.exports["ConfluenceFolderAriResourceOwner"] = $5bd4a92be6836a9b$export$77cf4e1b17902bfa;
module.exports["ConfluenceFolderAriResourceType"] = $5bd4a92be6836a9b$export$6256ff329bc25a9c;

});

parcelRegister("5WTxQ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $dinVW = parcelRequire("dinVW");


var $2oyXR = parcelRequire("2oyXR");

const $e01be1a23d2a446d$var$styles = {
    wrapper: "_0jFU0VN91d _0KLXrulfZc"
};
const $e01be1a23d2a446d$export$9520f072db304aa0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, testId: testId } = t0;
    if ((0, $iDrrr.fg)("ads-panel-system-gpp")) {
        let t1;
        if ($[0] !== children || $[1] !== testId) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2oyXR.PanelContainer), {
                testId: testId
            }, children);
            $[0] = children;
            $[1] = testId;
            $[2] = t1;
        } else t1 = $[2];
        return t1;
    }
    let t1;
    if ($[3] !== children || $[4] !== testId) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            xcss: $e01be1a23d2a446d$var$styles.wrapper,
            testId: testId
        }, children);
        $[3] = children;
        $[4] = testId;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
} : ({ children: children, testId: testId })=>{
    if ((0, $iDrrr.fg)('ads-panel-system-gpp')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2oyXR.PanelContainer), {
        testId: testId
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $e01be1a23d2a446d$var$styles.wrapper,
        testId: testId
    }, children);
};
module.exports["PreviewPanel"] = $e01be1a23d2a446d$export$9520f072db304aa0;

});

parcelRegister("2oyXR", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");


var $biqj4 = parcelRequire("biqj4");

const $6ccdb3d7b226a54f$var$styles = {
    wrapper: "_0jFU0VN91d _0KLXrulfZc _3iDTPbQ4SZ _0aFT5vbt8w _1mT5xdRAKS",
    content: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0aFT5vbt8w _0jFU0VN91d _4kiQYAdnbC"
}; /**
    * The PanelContainer component provides a standardized container for displaying content
    * in a side panel layout. It follows the design system patterns and integrates
    * with the navigation system for consistent styling and behavior.
    *
    * Compose it with a fixed `PanelHeader` / `PanelFooter` and a scrollable `PanelContent`
    * (wrapping `PanelSubheader` and `PanelBody`).
    *
    * For resizable panels, use the `PanelSplitter` from `@atlaskit/navigation-system/layout/panel-splitter`
    * alongside the `Panel` slot from `@atlaskit/navigation-system/layout/panel`.
    */ 
const $6ccdb3d7b226a54f$export$7c4d2b536147788a = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PanelContainer(t0) {
    const $ = (0, $bDgLe.c)(8);
    const { children: children, testId: testId, isFocusLockEnabled: t1 } = t0;
    const isFocusLockEnabled = t1 === undefined ? false : t1;
    let t2;
    if ($[0] !== children) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $6ccdb3d7b226a54f$var$styles.content,
            children: children
        });
        $[0] = children;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== t2 || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            as: "section",
            testId: testId,
            xcss: $6ccdb3d7b226a54f$var$styles.wrapper,
            children: t2
        });
        $[2] = t2;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== isFocusLockEnabled || $[6] !== t3) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $biqj4.PanelFocusLock), {
            isFocusLockEnabled: isFocusLockEnabled,
            children: t3
        });
        $[5] = isFocusLockEnabled;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : function PanelContainer({ children: children, testId: testId, isFocusLockEnabled: isFocusLockEnabled = false }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $biqj4.PanelFocusLock), {
        isFocusLockEnabled: isFocusLockEnabled,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            as: "section",
            testId: testId,
            xcss: $6ccdb3d7b226a54f$var$styles.wrapper,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: $6ccdb3d7b226a54f$var$styles.content,
                children: children
            })
        })
    });
};
module.exports["PanelContainer"] = $6ccdb3d7b226a54f$export$7c4d2b536147788a;

});

parcelRegister("biqj4", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $1enXm = parcelRequire("1enXm");


var $1hQ0e = parcelRequire("1hQ0e");

// box model so PanelContainer's own height/flex styles work exactly as if this wrapper
// were not there. This avoids breaking resize and full-height layouts.
const $2153848f433e7d96$var$contentsStyle = {
    display: 'contents'
};
const $2153848f433e7d96$var$containerStyles = null; /**
                               * Module-level count of currently-mounted PanelFocusLock instances.
                               *
                               * Used to suppress the return-focus restore when one panel is replaced by
                               * another (e.g. Jira admin sidebar swaps Sidebar A → Sidebar B by changing
                               * the Provider component, which unmounts/remounts PanelFocusLock). Without
                               * this guard, the unmounting panel's queued double-rAF restore would fire
                               * AFTER the new panel's autofocus, snapping focus back to the original
                               * trigger while a replacement panel is on screen.
                               *
                               * The counter is decremented synchronously on cleanup BEFORE the new
                               * instance's mount effect runs, then re-checked inside the deferred restore.
                               * If another instance has mounted by the time the double-rAF fires, the
                               * restore is skipped.
                               */ 
let $2153848f433e7d96$var$panelFocusLockMountCount = 0; /**
                                   * Module-level handoff for the "previously focused" element across an
                                   * unmount → mount swap.
                                   *
                                   * When one PanelFocusLock unmounts and is immediately replaced by another
                                   * because a button INSIDE the unmounting panel triggered the swap (e.g.
                                   * Sidebar A's footer "Add spaces" button opens Sidebar B), the replacement's
                                   * mount effect sees `document.activeElement === document.body` because the
                                   * previously-focused element lived inside the panel that just unmounted.
                                   * Without a handoff, the replacement would capture `body` as its "previously
                                   * focused" snapshot and on close would restore focus to nothing / blur.
                                   *
                                   * The unmounting instance writes its own previously-focused snapshot here,
                                   * and the next mounting instance reads + clears it. The handoff is used
                                   * ONLY when the replacement's `document.activeElement` is `body` (or null) —
                                   * meaning focus disappeared because it lived inside the unmounting panel.
                                   * If `document.activeElement` is a real element (e.g. the user clicked a
                                   * different page-level trigger to open this panel), that element wins
                                   * because it's a more accurate "where focus came from" signal than the
                                   * previous panel's snapshot. Cleared either by the next mount or by the
                                   * deferred restore when no replacement appears, so a stale value can't leak
                                   * across unrelated open cycles.
                                   */ 
let $2153848f433e7d96$var$pendingPreviouslyFocused = null; /**
                                                          * Selector for all focusable elements inside a container, in LTR tab order.
                                                          */ 
const $2153848f433e7d96$var$FOCUSABLE_SELECTOR = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
    'details > summary',
    'audio[controls]',
    'video[controls]'
].join(', ');
const $2153848f433e7d96$export$85d112ac7df5c04f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PanelFocusLock(t0) {
    const $ = (0, $bDgLe.c)(12);
    const { children: children, isFocusLockEnabled: t1 } = t0;
    const isFocusLockEnabled = t1 === undefined ? false : t1;
    const containerRef = (0, $cozmU.useRef)(null);
    const previouslyFocusedRef = (0, $cozmU.useRef)(null);
    let t2;
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            const doc = (0, $1hQ0e.getDocument)();
            $2153848f433e7d96$var$pendingPreviouslyFocused = null;
            const activeElement = doc?.activeElement ?? null;
            const activeIsBodyOrNull = !activeElement || activeElement === doc?.body;
            const activeIsInsideOwnContainer = !!activeElement && !!containerRef.current?.contains(activeElement);
            const shouldUseHandoff = activeIsBodyOrNull || activeIsInsideOwnContainer;
            const handoffIsAttached = !!$2153848f433e7d96$var$pendingPreviouslyFocused && !!doc?.body?.contains($2153848f433e7d96$var$pendingPreviouslyFocused);
            previouslyFocusedRef.current = shouldUseHandoff && handoffIsAttached ? $2153848f433e7d96$var$pendingPreviouslyFocused : activeElement;
            $2153848f433e7d96$var$panelFocusLockMountCount = $2153848f433e7d96$var$panelFocusLockMountCount + 1;
            return ()=>{
                $2153848f433e7d96$var$panelFocusLockMountCount = $2153848f433e7d96$var$panelFocusLockMountCount - 1;
                $2153848f433e7d96$var$pendingPreviouslyFocused = previouslyFocusedRef.current;
                const toFocus = previouslyFocusedRef.current;
                setTimeout(()=>{
                    setTimeout(()=>{
                        if ($2153848f433e7d96$var$panelFocusLockMountCount > 0) return;
                        $2153848f433e7d96$var$pendingPreviouslyFocused = null;
                        toFocus?.focus();
                    }, 0);
                }, 0);
            };
        };
        t3 = [];
        $[0] = t2;
        $[1] = t3;
    } else {
        t2 = $[0];
        t3 = $[1];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    let t5;
    if ($[2] !== isFocusLockEnabled) {
        t4 = ()=>{
            if (isFocusLockEnabled) return;
            const container = containerRef.current;
            if (!container) return;
            const firstFocusable = container.querySelector($2153848f433e7d96$var$FOCUSABLE_SELECTOR);
            if (firstFocusable) firstFocusable.focus({
                preventScroll: true
            });
        };
        t5 = [
            isFocusLockEnabled
        ];
        $[2] = isFocusLockEnabled;
        $[3] = t4;
        $[4] = t5;
    } else {
        t4 = $[3];
        t5 = $[4];
    }
    (0, $cozmU.useEffect)(t4, t5);
    if (isFocusLockEnabled) {
        let t6;
        if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
            t6 = {
                style: $2153848f433e7d96$var$contentsStyle
            };
            $[5] = t6;
        } else t6 = $[5];
        let t7;
        if ($[6] !== children) {
            t7 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1enXm.default), {
                autoFocus: true,
                returnFocus: false,
                lockProps: t6,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                    ref: containerRef,
                    style: $2153848f433e7d96$var$contentsStyle,
                    children: children
                })
            });
            $[6] = children;
            $[7] = t7;
        } else t7 = $[7];
        return t7;
    }
    let t6;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $hekY6.default)([
            "_0jFU0VN91d"
        ]);
        $[8] = t6;
    } else t6 = $[8];
    let t7;
    if ($[9] !== children || $[10] !== t6) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            ref: containerRef,
            className: t6,
            children: children
        });
        $[9] = children;
        $[10] = t6;
        $[11] = t7;
    } else t7 = $[11];
    return t7;
} : function PanelFocusLock({ children: children, isFocusLockEnabled: isFocusLockEnabled = false }) {
    const containerRef = (0, $cozmU.useRef)(null); // Capture the element that was focused before the panel opened so we can
    // restore focus to it when the panel closes — regardless of which close
    // path is taken (X button, footer Close, programmatic close, etc.).
    const previouslyFocusedRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        // Determine the element focus should return to when this panel closes.
        //
        // Default: use the element that was focused at the moment we mount —
        // this is the natural "page trigger" the user just clicked.
        //
        // Edge case (handoff): when one panel unmounts and is immediately
        // replaced by another because a button INSIDE the previous panel
        // triggered the swap (e.g. Sidebar A's footer "Add spaces" button
        // opens Sidebar B), focus has nowhere to go: the trigger button just
        // unmounted with the previous panel, so `document.activeElement`
        // falls back to `body`. In that specific case we adopt the previous
        // panel's snapshot via the module-level handoff slot — it's typically
        // the original page-level trigger that opened the chain.
        //
        // Edge case (StrictMode): in development, React double-invokes
        // effects (setup → cleanup → setup). The second setup runs AFTER
        // Effect 2 below has already moved focus to our own first focusable,
        // so `document.activeElement` is inside our own container — but the
        // DOM was never actually unmounted, so the focused element is still
        // attached. We treat this case the same as body: the user never
        // "came from" our own input, so we should fall back to the handoff
        // (which was just set by Pass 1's cleanup). Without this guard,
        // `previouslyFocused` would be set to our own first focusable, and
        // on close `focus()` would target an element that is by then detached.
        //
        // Always clear the handoff slot regardless of whether we used it, so
        // a stale value can't leak forward into an unrelated future mount.
        const doc = (0, $1hQ0e.getDocument)();
        const handoff = $2153848f433e7d96$var$pendingPreviouslyFocused;
        $2153848f433e7d96$var$pendingPreviouslyFocused = null;
        const activeElement = doc?.activeElement ?? null;
        const activeIsBodyOrNull = !activeElement || activeElement === doc?.body;
        const activeIsInsideOwnContainer = !!activeElement && !!containerRef.current?.contains(activeElement);
        const shouldUseHandoff = activeIsBodyOrNull || activeIsInsideOwnContainer;
        const handoffIsAttached = !!handoff && !!doc?.body?.contains(handoff);
        previouslyFocusedRef.current = shouldUseHandoff && handoffIsAttached ? handoff : activeElement;
        $2153848f433e7d96$var$panelFocusLockMountCount += 1;
        return ()=>{
            $2153848f433e7d96$var$panelFocusLockMountCount -= 1; // Hand our snapshot off in case a replacement instance is about to
            // mount in the same commit — it will consume this and use it as its
            // own return-focus target, preserving the original trigger across the
            // swap. The slot is cleared either by the next mount or by the
            // deferred restore below if no replacement appears.
            $2153848f433e7d96$var$pendingPreviouslyFocused = previouslyFocusedRef.current; // Capture the target locally so it survives even if something else
            // mutates the ref between now and when the deferred callback fires.
            const toFocus = previouslyFocusedRef.current; // Restore focus on unmount (panel close). Two chained `setTimeout(0)`
            // ensure this fires after react-focus-lock's own deactivation logic
            // when the lock is active, and after React has finished applying any
            // commit that mounted a replacement panel.
            //
            // We use setTimeout rather than requestAnimationFrame here because
            // the latter is unreliable under jsdom + the React 18 concurrent
            // scheduler in unit tests: rAF callbacks scheduled inside a passive
            // effect cleanup don't always flush even when `jest.runAllTimers`
            // is called inside an `act` block (the scheduler uses MessageChannel,
            // which fake timers don't drive). setTimeout(0) flushes reliably with
            // both fake and real timers.
            setTimeout(()=>{
                setTimeout(()=>{
                    // Skip restore if another PanelFocusLock instance has mounted in
                    // the meantime — e.g. a sidebar swap where the consumer unmounts
                    // the current panel and mounts a replacement. The new instance's
                    // autofocus already moved focus into the replacement; restoring
                    // here would yank focus back to this panel's previously-focused
                    // element (typically the original page trigger) and visibly steal
                    // focus away from the replacement panel.
                    if ($2153848f433e7d96$var$panelFocusLockMountCount > 0) return;
                     // We're the last one out — clear the handoff so a future,
                    // unrelated panel open doesn't inherit a stale snapshot.
                    $2153848f433e7d96$var$pendingPreviouslyFocused = null;
                    toFocus?.focus();
                }, 0);
            }, 0);
        };
    }, []);
    // When the lock is NOT enabled, handle auto-focus ourselves — do NOT use
    // react-focus-lock even in disabled mode as it causes layout recalculations
    // that causes animation jank when the panel is inside a CSS transform animation
    // (e.g. SlideIn from @atlaskit/motion).
    (0, $cozmU.useEffect)(()=>{
        if (isFocusLockEnabled) return;
        const container = containerRef.current;
        if (!container) return;
         // Focus synchronously in useEffect (post-paint) with preventScroll to avoid
        // the browser calling scrollIntoView on a mid-animation element.
        const firstFocusable = container.querySelector($2153848f433e7d96$var$FOCUSABLE_SELECTOR);
        if (firstFocusable) firstFocusable.focus({
            preventScroll: true
        });
    }, [
        isFocusLockEnabled
    ]); // When the lock IS enabled, use react-focus-lock for both autoFocus and the trap.
    if (isFocusLockEnabled) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1enXm.default), {
        autoFocus: true,
        returnFocus: false,
        lockProps: {
            style: $2153848f433e7d96$var$contentsStyle
        },
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            ref: containerRef,
            style: $2153848f433e7d96$var$contentsStyle,
            children: children
        })
    });
     // Default (no lock): plain wrapper div, auto-focus handled by useEffect above.
    // We deliberately avoid react-focus-lock here to prevent animation jank.
    // height: 100% ensures PanelContainer's own height: 100% resolves correctly.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        ref: containerRef,
        className: (0, $hekY6.default)([
            "_0jFU0VN91d"
        ]),
        children: children
    });
};
module.exports["PanelFocusLock"] = $2153848f433e7d96$export$85d112ac7df5c04f;

});

parcelRegister("kMhHg", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $aio9r = parcelRequire("aio9r");


var $2Emkv = parcelRequire("2Emkv");

const $f9d4da2be7611286$var$panelSystemStyles = {
    fillParent: "_0jFU0VN91d _3iDTPbQ4SZ _0aFT5vbt8w"
};
const $f9d4da2be7611286$export$cda5e69749e7aeee = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(23);
    const { children: children, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, analyticsAttributes: analyticsAttributes, styles: consumerStyles } = t0;
    const bodyRef = (0, $cozmU.useRef)(null);
    let t1;
    let t2;
    if ($[0] !== analyticsAttributes || $[1] !== analyticsClient || $[2] !== panelType || $[3] !== parentProduct) {
        t1 = ()=>{
            if (analyticsClient) {
                analyticsClient.sendTrackEvent({
                    action: "viewed",
                    actionSubject: "preview-panel",
                    actionSubjectId: "preview-panel-view",
                    source: "preview-panel",
                    attributes: {
                        parentProduct: parentProduct,
                        panelType: panelType,
                        ...(0, $iDrrr.fg)("add_capacity_tab_to_the_board_horizontal_nav") || (0, $iDrrr.fg)("add-trigger-point-key-attribute-to-preview-panel") || (0, $cXtTj.default).getExperimentValue("individual_capacity_planning_ga", "isEnabled", false, {
                            fireExperimentExposure: false
                        }) ? analyticsAttributes : {}
                    }
                });
                analyticsClient?.startUIViewedEvent();
            }
        };
        t2 = [
            analyticsClient,
            parentProduct,
            panelType,
            analyticsAttributes
        ];
        $[0] = analyticsAttributes;
        $[1] = analyticsClient;
        $[2] = panelType;
        $[3] = parentProduct;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[6] !== children || $[7] !== consumerStyles) {
        t3 = (0, $iDrrr.fg)("ads-panel-system-gpp") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($f9d4da2be7611286$var$panelSystemStyles.fillParent, !!consumerStyles && consumerStyles),
            ref: bodyRef
        }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)(!!consumerStyles && consumerStyles),
            ref: bodyRef
        }, children);
        $[6] = children;
        $[7] = consumerStyles;
        $[8] = t3;
    } else t3 = $[8];
    const panelBodyContent = t3;
    if ((0, $iDrrr.fg)("ads-panel-system-gpp")) {
        let t4;
        if ($[9] !== panelBodyContent) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aio9r.PanelBody), {
                spacing: "none"
            }, panelBodyContent);
            $[9] = panelBodyContent;
            $[10] = t4;
        } else t4 = $[10];
        const wrappedBody = t4;
        let t5;
        if ($[11] !== analyticsAttributes || $[12] !== analyticsClient || $[13] !== panelType || $[14] !== parentProduct || $[15] !== wrappedBody) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Emkv.PreviewPanelSniffer), {
                containerRef: bodyRef,
                analyticsClient: analyticsClient,
                parentProduct: parentProduct,
                panelType: panelType,
                analyticsAttributes: analyticsAttributes
            }, wrappedBody);
            $[11] = analyticsAttributes;
            $[12] = analyticsClient;
            $[13] = panelType;
            $[14] = parentProduct;
            $[15] = wrappedBody;
            $[16] = t5;
        } else t5 = $[16];
        return t5;
    }
    let t4;
    if ($[17] !== analyticsAttributes || $[18] !== analyticsClient || $[19] !== panelBodyContent || $[20] !== panelType || $[21] !== parentProduct) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Emkv.PreviewPanelSniffer), {
            containerRef: bodyRef,
            analyticsClient: analyticsClient,
            parentProduct: parentProduct,
            panelType: panelType,
            analyticsAttributes: analyticsAttributes
        }, panelBodyContent);
        $[17] = analyticsAttributes;
        $[18] = analyticsClient;
        $[19] = panelBodyContent;
        $[20] = panelType;
        $[21] = parentProduct;
        $[22] = t4;
    } else t4 = $[22];
    return t4;
} : ({ children: children, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, analyticsAttributes: analyticsAttributes, styles: consumerStyles })=>{
    const bodyRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (analyticsClient) {
            analyticsClient.sendTrackEvent({
                action: 'viewed',
                actionSubject: 'preview-panel',
                actionSubjectId: 'preview-panel-view',
                source: 'preview-panel',
                attributes: {
                    parentProduct: parentProduct,
                    panelType: panelType,
                    // Availability check only — this decides whether to decorate the preview-panel
                    // "viewed" track event with analyticsAttributes, NOT whether the user is
                    // accessing the Capacity planning experience. We therefore read the GA
                    // experiment WITHOUT firing a Statsig exposure (fireExperimentExposure: false);
                    // exposure is fired at the point the user actually opens the Capacity
                    // experience, keeping the GA experiment's population clean.
                    //
                    // The OR (now 3-way) still short-circuits: when either the legacy EAP gate or
                    // the `add-trigger-point-key-attribute-to-preview-panel` gate is ON, the GA
                    // experiment is never read at all. EAP customers remain unconditionally enabled.
                    ...(0, $iDrrr.fg)('add_capacity_tab_to_the_board_horizontal_nav') || (0, $iDrrr.fg)('add-trigger-point-key-attribute-to-preview-panel') || (0, $cXtTj.default).getExperimentValue('individual_capacity_planning_ga', 'isEnabled', false, {
                        fireExperimentExposure: false
                    }) ? analyticsAttributes : {}
                }
            });
            // https://developer.atlassian.com/platform/analytics-pipeline/guides/deep-dive/cloud-mau/
            // Fires at most once per hour, per product.
            // Requires tenantInfo and userInfo to be set
            analyticsClient?.startUIViewedEvent();
        }
    }, [
        analyticsClient,
        parentProduct,
        panelType,
        analyticsAttributes
    ]);
    // ignoring the rule as we have so many consumers of this that we need to be able to pass in styles
    /* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ const panelBodyContent = (0, $iDrrr.fg)('ads-panel-system-gpp') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($f9d4da2be7611286$var$panelSystemStyles.fillParent, !!consumerStyles && consumerStyles),
        ref: bodyRef
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)(!!consumerStyles && consumerStyles),
        ref: bodyRef
    }, children); /* eslint-enable @atlaskit/design-system/consistent-css-prop-usage */ 
    if ((0, $iDrrr.fg)('ads-panel-system-gpp')) {
        const wrappedBody = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aio9r.PanelBody), {
            spacing: "none"
        }, panelBodyContent);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Emkv.PreviewPanelSniffer), {
            containerRef: bodyRef,
            analyticsClient: analyticsClient,
            parentProduct: parentProduct,
            panelType: panelType,
            analyticsAttributes: analyticsAttributes
        }, wrappedBody);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Emkv.PreviewPanelSniffer), {
        containerRef: bodyRef,
        analyticsClient: analyticsClient,
        parentProduct: parentProduct,
        panelType: panelType,
        analyticsAttributes: analyticsAttributes
    }, panelBodyContent);
};
module.exports["PreviewPanelBody"] = $f9d4da2be7611286$export$cda5e69749e7aeee;

});

parcelRegister("aio9r", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");

const $d35068f09c7abc33$var$styles = {
    body: "_2O5Vij7dHp _3zvHkHdC7N _1mT5xdRAKS",
    defaultSpacing: "_4c065UPgdg _0LQT5ENHnM _03SyCPNHnM"
}; /**
    * The PanelBody component provides the main content area for panels
    * with consistent styling and scroll behavior.
    */ 
const $d35068f09c7abc33$export$3ac6fba5a6f84a87 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PanelBody(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { children: children, spacing: t1, testId: testId } = t0;
    const spacing = t1 === undefined ? "default" : t1;
    const t2 = spacing === "default" && $d35068f09c7abc33$var$styles.defaultSpacing;
    let t3;
    if ($[0] !== t2) {
        t3 = (0, $w6R6I.cx)($d35068f09c7abc33$var$styles.body, t2);
        $[0] = t2;
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] !== children || $[3] !== t3 || $[4] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            testId: testId,
            xcss: t3,
            children: children
        });
        $[2] = children;
        $[3] = t3;
        $[4] = testId;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
} : function PanelBody({ children: children, spacing: spacing = 'default', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        testId: testId,
        xcss: (0, $w6R6I.cx)($d35068f09c7abc33$var$styles.body, spacing === 'default' && $d35068f09c7abc33$var$styles.defaultSpacing),
        children: children
    });
};
module.exports["PanelBody"] = $d35068f09c7abc33$export$3ac6fba5a6f84a87;

});

parcelRegister("2Emkv", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");

const $75ef0261b167901c$export$93a96f69a5c679de = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { children: children, containerRef: containerRef, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, analyticsAttributes: analyticsAttributes } = t0;
    const hasSentOverflowEventRef = (0, $cozmU.useRef)(false);
    let t1;
    if ($[0] !== containerRef) {
        t1 = (event, contentSizePayload)=>{
            if (contentSizePayload.type !== "contentSize" || typeof contentSizePayload.width !== "number" || contentSizePayload.width <= 0 || typeof contentSizePayload.height !== "number" || contentSizePayload.height <= 0) return false;
            const panelIframe = containerRef.current?.querySelector("iframe");
            const panelIframeWindow = panelIframe?.contentWindow;
            if (!panelIframeWindow || event.source !== panelIframeWindow) return false;
            if (event.origin && event.origin !== "null" && panelIframe?.src) try {
                const iframeOrigin = new URL(panelIframe.src, window.location.href).origin;
                if (event.origin !== iframeOrigin) return false;
            } catch  {
                return false;
            }
            return true;
        };
        $[0] = containerRef;
        $[1] = t1;
    } else t1 = $[1];
    const isValidContentSizeMessage = t1;
    let t2;
    if ($[2] !== analyticsAttributes || $[3] !== analyticsClient || $[4] !== panelType || $[5] !== parentProduct) {
        t2 = (t3)=>{
            const { clientWidth: clientWidth, detectionMethod: detectionMethod, scrollWidth: scrollWidth } = t3;
            if (!analyticsClient || hasSentOverflowEventRef.current) return;
            hasSentOverflowEventRef.current = true;
            const overflowPx = typeof clientWidth === "number" && typeof scrollWidth === "number" ? Math.max(scrollWidth - clientWidth, 0) : undefined;
            analyticsClient.sendOperationalEvent({
                action: "detected",
                actionSubject: "layoutOverflow",
                actionSubjectId: "preview-panel-horizontal-overflow",
                source: "preview-panel",
                attributes: {
                    parentProduct: parentProduct,
                    panelType: panelType,
                    detectionMethod: detectionMethod,
                    clientWidth: clientWidth,
                    scrollWidth: scrollWidth,
                    overflowPx: overflowPx,
                    ...(0, $iDrrr.fg)("add_capacity_tab_to_the_board_horizontal_nav") || (0, $cXtTj.default).getExperimentValue("individual_capacity_planning_ga", "isEnabled", false, {
                        fireExperimentExposure: false
                    }) ? analyticsAttributes : {}
                }
            });
        };
        $[2] = analyticsAttributes;
        $[3] = analyticsClient;
        $[4] = panelType;
        $[5] = parentProduct;
        $[6] = t2;
    } else t2 = $[6];
    const sendOverflowEvent = t2;
    let t3;
    let t4;
    if ($[7] !== containerRef || $[8] !== sendOverflowEvent) {
        t3 = ()=>{
            const bodyElement = containerRef.current;
            if (!bodyElement || typeof ResizeObserver === "undefined") return;
            const detectBodyOverflow = ()=>{
                const clientWidth_0 = bodyElement.clientWidth;
                const scrollWidth_0 = bodyElement.scrollWidth;
                if (scrollWidth_0 > clientWidth_0) sendOverflowEvent({
                    detectionMethod: "body-observer",
                    clientWidth: clientWidth_0,
                    scrollWidth: scrollWidth_0
                });
            };
            detectBodyOverflow();
            const observer = new ResizeObserver(detectBodyOverflow);
            observer.observe(bodyElement);
            return ()=>{
                observer.disconnect();
            };
        };
        t4 = [
            containerRef,
            sendOverflowEvent
        ];
        $[7] = containerRef;
        $[8] = sendOverflowEvent;
        $[9] = t3;
        $[10] = t4;
    } else {
        t3 = $[9];
        t4 = $[10];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    let t6;
    if ($[11] !== containerRef || $[12] !== isValidContentSizeMessage || $[13] !== sendOverflowEvent) {
        t5 = ()=>{
            const handleMessage = (event_0)=>{
                const contentSizePayload_0 = event_0.data;
                if (!isValidContentSizeMessage(event_0, contentSizePayload_0)) return;
                const panelIframe_0 = containerRef.current?.querySelector("iframe");
                const iframeClientWidth = panelIframe_0?.clientWidth ?? 0;
                const clientWidth_1 = iframeClientWidth > 0 ? iframeClientWidth : containerRef.current?.clientWidth;
                if (typeof clientWidth_1 !== "number" || contentSizePayload_0.width <= clientWidth_1) return;
                sendOverflowEvent({
                    detectionMethod: "iframe-content-size-message",
                    clientWidth: clientWidth_1,
                    scrollWidth: contentSizePayload_0.width
                });
            };
            return (0, $cbY7C.bind)(window, {
                type: "message",
                listener: handleMessage
            });
        };
        t6 = [
            containerRef,
            isValidContentSizeMessage,
            sendOverflowEvent
        ];
        $[11] = containerRef;
        $[12] = isValidContentSizeMessage;
        $[13] = sendOverflowEvent;
        $[14] = t5;
        $[15] = t6;
    } else {
        t5 = $[14];
        t6 = $[15];
    }
    (0, $cozmU.useEffect)(t5, t6);
    let t7;
    if ($[16] !== children) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[16] = children;
        $[17] = t7;
    } else t7 = $[17];
    return t7;
} : ({ children: children, containerRef: containerRef, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, analyticsAttributes: analyticsAttributes })=>{
    const hasSentOverflowEventRef = (0, $cozmU.useRef)(false);
    const isValidContentSizeMessage = (0, $cozmU.useCallback)((event, contentSizePayload)=>{
        if (contentSizePayload.type !== 'contentSize' || typeof contentSizePayload.width !== 'number' || contentSizePayload.width <= 0 || typeof contentSizePayload.height !== 'number' || contentSizePayload.height <= 0) return false;
        const panelIframe = containerRef.current?.querySelector('iframe');
        const panelIframeWindow = panelIframe?.contentWindow;
        if (!panelIframeWindow || event.source !== panelIframeWindow) return false;
        // If both origins are known, ensure the message comes from the iframe's origin.
        if (event.origin && event.origin !== 'null' && panelIframe?.src) try {
            const iframeOrigin = new URL(panelIframe.src, window.location.href).origin;
            if (event.origin !== iframeOrigin) return false;
        } catch  {
            return false;
        }
        return true;
    }, [
        containerRef
    ]);
    const sendOverflowEvent = (0, $cozmU.useCallback)(({ clientWidth: clientWidth, detectionMethod: detectionMethod, scrollWidth: scrollWidth })=>{
        if (!analyticsClient || hasSentOverflowEventRef.current) return;
        hasSentOverflowEventRef.current = true;
        const overflowPx = typeof clientWidth === 'number' && typeof scrollWidth === 'number' ? Math.max(scrollWidth - clientWidth, 0) : undefined;
        analyticsClient.sendOperationalEvent({
            action: 'detected',
            actionSubject: 'layoutOverflow',
            actionSubjectId: 'preview-panel-horizontal-overflow',
            source: 'preview-panel',
            attributes: {
                parentProduct: parentProduct,
                panelType: panelType,
                detectionMethod: detectionMethod,
                clientWidth: clientWidth,
                scrollWidth: scrollWidth,
                overflowPx: overflowPx,
                // Availability check only — this decides whether to decorate the overflow
                // operational event with analyticsAttributes, NOT whether the user is
                // accessing the Capacity planning experience. We therefore read the GA
                // experiment WITHOUT firing a Statsig exposure
                // (fireExperimentExposure: false); exposure is fired at the point the user
                // actually opens the Capacity experience, keeping the GA experiment's
                // population clean.
                //
                // The OR still short-circuits: when the legacy EAP gate is ON the experiment
                // is never read at all. EAP customers remain unconditionally enabled.
                ...(0, $iDrrr.fg)('add_capacity_tab_to_the_board_horizontal_nav') || (0, $cXtTj.default).getExperimentValue('individual_capacity_planning_ga', 'isEnabled', false, {
                    fireExperimentExposure: false
                }) ? analyticsAttributes : {}
            }
        });
    }, [
        analyticsClient,
        parentProduct,
        panelType,
        analyticsAttributes
    ]);
    (0, $cozmU.useEffect)(()=>{
        const bodyElement = containerRef.current;
        if (!bodyElement || typeof ResizeObserver === 'undefined') return;
        const detectBodyOverflow = ()=>{
            const clientWidth_0 = bodyElement.clientWidth;
            const scrollWidth_0 = bodyElement.scrollWidth;
            if (scrollWidth_0 > clientWidth_0) sendOverflowEvent({
                detectionMethod: 'body-observer',
                clientWidth: clientWidth_0,
                scrollWidth: scrollWidth_0
            });
        };
        detectBodyOverflow();
        const observer = new ResizeObserver(detectBodyOverflow);
        observer.observe(bodyElement);
        return ()=>{
            observer.disconnect();
        };
    }, [
        containerRef,
        sendOverflowEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        const handleMessage = (event_0)=>{
            const contentSizePayload_0 = event_0.data;
            if (!isValidContentSizeMessage(event_0, contentSizePayload_0)) return;
            const panelIframe_0 = containerRef.current?.querySelector('iframe');
            const iframeClientWidth = panelIframe_0?.clientWidth ?? 0;
            const clientWidth_1 = iframeClientWidth > 0 ? iframeClientWidth : containerRef.current?.clientWidth;
            if (typeof clientWidth_1 !== 'number' || contentSizePayload_0.width <= clientWidth_1) return;
            sendOverflowEvent({
                detectionMethod: 'iframe-content-size-message',
                clientWidth: clientWidth_1,
                scrollWidth: contentSizePayload_0.width
            });
        };
        return (0, $cbY7C.bind)(window, {
            type: 'message',
            listener: handleMessage
        });
    }, [
        containerRef,
        isValidContentSizeMessage,
        sendOverflowEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
module.exports["PreviewPanelSniffer"] = $75ef0261b167901c$export$93a96f69a5c679de;

});

parcelRegister("fE1YT", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $aIlZA = parcelRequire("aIlZA");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $kdlgT = parcelRequire("kdlgT");


var $l3wuH = parcelRequire("l3wuH");


var $V3JOP = parcelRequire("V3JOP");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $1l0kj = parcelRequire("1l0kj");


var $7ZpVx = parcelRequire("7ZpVx");

var $i68yG = parcelRequire("i68yG");

var $7ZxlY = parcelRequire("7ZxlY");

var $1jpZo = parcelRequire("1jpZo");


var $Emr0i = parcelRequire("Emr0i");


var $7Yky3 = parcelRequire("7Yky3");

const $30b8761d1cee2886$export$e1ea1fbf111a14fe = (url, paramToRemove)=>{
    try {
        const urlObj = new URL(url);
        urlObj.searchParams.delete(paramToRemove);
        return urlObj.toString();
    } catch  {
        // If URL parsing fails, return the original URL
        return url;
    }
};
const $30b8761d1cee2886$var$styles = {
    header: "_3vBAKH9r67 _0LQT5ENHnM _03SyCPNHnM _46hvQm5zaO _0xmtko5zaO _2yjt2x6wH8 _4auqkJNvrM _0jFU0VmdCj",
    childWrapper: "_2O5Vij7dHp",
    titleRegion: "_2mHwu82ADO _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _37wbyuI7V3 _2O5Vij7dHp _4ouGXIdnbC"
}; /**
    * @private
    * @deprecated `@atlassian/preview-panel` is deprecated. Use `@atlassian/panel-system` instead.
    * {@link https://atlassian.design/components/panel-system/examples}
    */ 
const $30b8761d1cee2886$export$426d4171de44bac0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(72);
    const { children: children, onClose: onClose, onOpenInNewTab: onOpenInNewTab, onNavigateBack: onNavigateBack, testId: testId, url: url, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, moreActions: moreActions } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $iDrrr.fg)("platform_preview_panels_cross_app_interaction");
        $[0] = t1;
    } else t1 = $[0];
    const enableCrossMAUUsage = t1;
    const t2 = parentProduct ?? "unknown";
    let t3;
    if ($[1] !== t2) {
        t3 = {
            bridge: "preview-panels",
            product: t2
        };
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    const buildUrlWithAnalyticsParams = (0, $aIlZA.default)(t3);
    let t4;
    if ($[3] !== analyticsClient || $[4] !== onClose || $[5] !== panelType || $[6] !== parentProduct) {
        t4 = ()=>{
            analyticsClient?.sendTrackEvent({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "preview-panel-close",
                source: "preview-panel",
                attributes: {
                    parentProduct: parentProduct,
                    panelType: panelType
                }
            });
            onClose?.();
        };
        $[3] = analyticsClient;
        $[4] = onClose;
        $[5] = panelType;
        $[6] = parentProduct;
        $[7] = t4;
    } else t4 = $[7];
    const onPanelClose = t4;
    let t5;
    if ($[8] !== analyticsClient || $[9] !== buildUrlWithAnalyticsParams || $[10] !== onOpenInNewTab || $[11] !== panelType || $[12] !== parentProduct || $[13] !== url) {
        t5 = ()=>{
            analyticsClient?.sendTrackEvent({
                action: "clicked",
                actionSubject: "link",
                actionSubjectId: "preview-panel-open-in-new-window",
                source: "preview-panel",
                attributes: {
                    parentProduct: parentProduct,
                    panelType: panelType
                }
            });
            onOpenInNewTab?.();
            if (url) window.open(enableCrossMAUUsage ? buildUrlWithAnalyticsParams($30b8761d1cee2886$export$e1ea1fbf111a14fe(url, "previewPanels")) : $30b8761d1cee2886$export$e1ea1fbf111a14fe(url, "previewPanels"));
        };
        $[8] = analyticsClient;
        $[9] = buildUrlWithAnalyticsParams;
        $[10] = onOpenInNewTab;
        $[11] = panelType;
        $[12] = parentProduct;
        $[13] = url;
        $[14] = t5;
    } else t5 = $[14];
    const onOpenInNewWindow = t5;
    let t6;
    if ($[15] !== analyticsClient || $[16] !== onNavigateBack || $[17] !== panelType || $[18] !== parentProduct) {
        t6 = ()=>{
            analyticsClient?.sendTrackEvent({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "preview-panel-navigate-back",
                source: "preview-panel",
                attributes: {
                    parentProduct: parentProduct,
                    panelType: panelType
                }
            });
            onNavigateBack?.();
        };
        $[15] = analyticsClient;
        $[16] = onNavigateBack;
        $[17] = panelType;
        $[18] = parentProduct;
        $[19] = t6;
    } else t6 = $[19];
    const onPanelNavigateBack = t6;
    if ((0, $iDrrr.fg)("ads-panel-system-gpp")) {
        let t7;
        if ($[20] !== formatMessage || $[21] !== onNavigateBack || $[22] !== onPanelNavigateBack || $[23] !== testId) {
            t7 = onNavigateBack && (0, $iDrrr.fg)("jivtech-1920-back-navigation-gpp") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZpVx.PanelAction), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))),
                label: formatMessage((0, $Emr0i.default).previewPanelNavigateBackLabel),
                onClick: onPanelNavigateBack,
                testId: testId && `${testId}.navigate-back-button`,
                appearance: "default"
            });
            $[20] = formatMessage;
            $[21] = onNavigateBack;
            $[22] = onPanelNavigateBack;
            $[23] = testId;
            $[24] = t7;
        } else t7 = $[24];
        let t8;
        if ($[25] !== children) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $30b8761d1cee2886$var$styles.titleRegion
            }, children);
            $[25] = children;
            $[26] = t8;
        } else t8 = $[26];
        let t9;
        if ($[27] !== formatMessage || $[28] !== onOpenInNewWindow || $[29] !== testId || $[30] !== url) {
            t9 = url && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZpVx.PanelAction), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))),
                label: formatMessage((0, $Emr0i.default).previewPanelOpenInNewWindowLabel),
                onClick: onOpenInNewWindow,
                testId: testId && `${testId}.open-in-new-window-button`,
                appearance: "subtle"
            });
            $[27] = formatMessage;
            $[28] = onOpenInNewWindow;
            $[29] = testId;
            $[30] = url;
            $[31] = t9;
        } else t9 = $[31];
        let t10;
        if ($[32] !== formatMessage || $[33] !== onClose || $[34] !== onPanelClose || $[35] !== testId) {
            t10 = onClose && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i68yG.PanelActionClose), {
                onClick: onPanelClose,
                testId: testId && `${testId}.close-button`,
                label: formatMessage((0, $Emr0i.default).previewPanelCloseButtonLabel)
            });
            $[32] = formatMessage;
            $[33] = onClose;
            $[34] = onPanelClose;
            $[35] = testId;
            $[36] = t10;
        } else t10 = $[36];
        let t11;
        if ($[37] !== moreActions || $[38] !== t10 || $[39] !== t9) {
            t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZxlY.PanelActionGroup), null, t9, moreActions, t10);
            $[37] = moreActions;
            $[38] = t10;
            $[39] = t9;
            $[40] = t11;
        } else t11 = $[40];
        let t12;
        if ($[41] !== t11 || $[42] !== t7 || $[43] !== t8 || $[44] !== testId) {
            t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1jpZo.PanelHeader), {
                testId: testId
            }, t7, t8, t11);
            $[41] = t11;
            $[42] = t7;
            $[43] = t8;
            $[44] = testId;
            $[45] = t12;
        } else t12 = $[45];
        return t12;
    }
    let t7;
    if ($[46] !== formatMessage || $[47] !== onNavigateBack || $[48] !== onPanelNavigateBack || $[49] !== testId) {
        t7 = onNavigateBack && (0, $iDrrr.fg)("jivtech-1920-back-navigation-gpp") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: $30b8761d1cee2886$var$_temp,
            label: formatMessage((0, $Emr0i.default).previewPanelNavigateBackLabel),
            onClick: onPanelNavigateBack,
            testId: testId && `${testId}.navigate-back-button`
        });
        $[46] = formatMessage;
        $[47] = onNavigateBack;
        $[48] = onPanelNavigateBack;
        $[49] = testId;
        $[50] = t7;
    } else t7 = $[50];
    let t8;
    if ($[51] !== children) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $30b8761d1cee2886$var$styles.childWrapper,
            spread: "space-between",
            alignBlock: "center",
            space: "space.100"
        }, children);
        $[51] = children;
        $[52] = t8;
    } else t8 = $[52];
    let t9;
    if ($[53] !== formatMessage || $[54] !== onOpenInNewWindow || $[55] !== testId || $[56] !== url) {
        t9 = url && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7Yky3.PreviewPanelNewTabLink), {
            label: formatMessage((0, $Emr0i.default).previewPanelOpenInNewWindowLabel),
            onClick: onOpenInNewWindow,
            testId: testId && `${testId}.open-in-new-window-button`
        });
        $[53] = formatMessage;
        $[54] = onOpenInNewWindow;
        $[55] = testId;
        $[56] = url;
        $[57] = t9;
    } else t9 = $[57];
    let t10;
    if ($[58] !== formatMessage || $[59] !== onClose || $[60] !== onPanelClose || $[61] !== testId) {
        t10 = onClose && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: $30b8761d1cee2886$var$_temp2,
            label: formatMessage((0, $Emr0i.default).previewPanelCloseButtonLabel),
            onClick: onPanelClose,
            testId: testId && `${testId}.close-button`,
            role: "button"
        });
        $[58] = formatMessage;
        $[59] = onClose;
        $[60] = onPanelClose;
        $[61] = testId;
        $[62] = t10;
    } else t10 = $[62];
    let t11;
    if ($[63] !== moreActions || $[64] !== t10 || $[65] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            gap: "space.100"
        }, t9, moreActions, t10);
        $[63] = moreActions;
        $[64] = t10;
        $[65] = t9;
        $[66] = t11;
    } else t11 = $[66];
    let t12;
    if ($[67] !== t11 || $[68] !== t7 || $[69] !== t8 || $[70] !== testId) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $30b8761d1cee2886$var$styles.header,
            testId: testId,
            alignBlock: "center",
            space: "space.100"
        }, t7, t8, t11);
        $[67] = t11;
        $[68] = t7;
        $[69] = t8;
        $[70] = testId;
        $[71] = t12;
    } else t12 = $[71];
    return t12;
} : ({ children: children, onClose: onClose, onOpenInNewTab: onOpenInNewTab, onNavigateBack: onNavigateBack, testId: testId, url: url, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, moreActions: moreActions })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const enableCrossMAUUsage = (0, $iDrrr.fg)('platform_preview_panels_cross_app_interaction');
    const buildUrlWithAnalyticsParams = (0, $aIlZA.default)({
        bridge: 'preview-panels',
        product: parentProduct ?? 'unknown'
    });
    const onPanelClose = ()=>{
        analyticsClient?.sendTrackEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'preview-panel-close',
            source: 'preview-panel',
            attributes: {
                parentProduct: parentProduct,
                panelType: panelType
            }
        });
        onClose?.();
    };
    const onOpenInNewWindow = ()=>{
        analyticsClient?.sendTrackEvent({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'preview-panel-open-in-new-window',
            source: 'preview-panel',
            attributes: {
                parentProduct: parentProduct,
                panelType: panelType
            }
        });
        onOpenInNewTab?.();
        if (url) window.open(enableCrossMAUUsage ? buildUrlWithAnalyticsParams($30b8761d1cee2886$export$e1ea1fbf111a14fe(url, 'previewPanels')) : $30b8761d1cee2886$export$e1ea1fbf111a14fe(url, 'previewPanels'));
    };
    const onPanelNavigateBack = ()=>{
        analyticsClient?.sendTrackEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'preview-panel-navigate-back',
            source: 'preview-panel',
            attributes: {
                parentProduct: parentProduct,
                panelType: panelType
            }
        });
        onNavigateBack?.();
    };
    if ((0, $iDrrr.fg)('ads-panel-system-gpp')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1jpZo.PanelHeader), {
        testId: testId
    }, onNavigateBack && (0, $iDrrr.fg)('jivtech-1920-back-navigation-gpp') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZpVx.PanelAction), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))),
        label: formatMessage((0, $Emr0i.default).previewPanelNavigateBackLabel),
        onClick: onPanelNavigateBack,
        testId: testId && `${testId}.navigate-back-button`,
        appearance: "default"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $30b8761d1cee2886$var$styles.titleRegion
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZxlY.PanelActionGroup), null, url && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZpVx.PanelAction), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))),
        label: formatMessage((0, $Emr0i.default).previewPanelOpenInNewWindowLabel),
        onClick: onOpenInNewWindow,
        testId: testId && `${testId}.open-in-new-window-button`,
        appearance: "subtle"
    }), moreActions, onClose && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i68yG.PanelActionClose), {
        onClick: onPanelClose,
        testId: testId && `${testId}.close-button`,
        label: formatMessage((0, $Emr0i.default).previewPanelCloseButtonLabel)
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $30b8761d1cee2886$var$styles.header,
        testId: testId,
        alignBlock: "center",
        space: "space.100"
    }, onNavigateBack && (0, $iDrrr.fg)('jivtech-1920-back-navigation-gpp') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))), {
                ...iconProps,
                size: "small"
            }),
        label: formatMessage((0, $Emr0i.default).previewPanelNavigateBackLabel),
        onClick: onPanelNavigateBack,
        testId: testId && `${testId}.navigate-back-button`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $30b8761d1cee2886$var$styles.childWrapper,
        spread: "space-between",
        alignBlock: "center",
        space: "space.100"
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        gap: "space.100"
    }, url && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7Yky3.PreviewPanelNewTabLink), {
        label: formatMessage((0, $Emr0i.default).previewPanelOpenInNewWindowLabel),
        onClick: onOpenInNewWindow,
        testId: testId && `${testId}.open-in-new-window-button`
    }), moreActions, onClose && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (iconProps_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                ...iconProps_0,
                size: "small"
            }),
        label: formatMessage((0, $Emr0i.default).previewPanelCloseButtonLabel),
        onClick: onPanelClose,
        testId: testId && `${testId}.close-button`,
        role: "button"
    })));
};
function $30b8761d1cee2886$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))), {
        ...iconProps,
        size: "small"
    });
}
function $30b8761d1cee2886$var$_temp2(iconProps_0) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
        ...iconProps_0,
        size: "small"
    });
}
module.exports["PreviewPanelHeader"] = $30b8761d1cee2886$export$426d4171de44bac0;

});

parcelRegister("7ZpVx", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ad7Ou = parcelRequire("ad7Ou");


var $1sCHt = parcelRequire("1sCHt");


var $7WEaj = parcelRequire("7WEaj");


var $7vK9E = parcelRequire("7vK9E");

const $2efd2cd3ca9e912b$export$2a18e3520151503 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(43);
    const { children: children, onClick: onClick, href: href, testId: testId, target: target, rel: rel, "aria-label": ariaLabel, "aria-haspopup": ariaHaspopup, "aria-expanded": ariaExpanded, icon: icon, label: label, appearance: t1, spacing: t2 } = t0;
    const appearance = t1 === undefined ? "subtle" : t1;
    const spacing = t2 === undefined ? "default" : t2;
    if (icon && href) {
        const t3 = ref;
        const t4 = onClick;
        const t5 = label || ariaLabel;
        let t6;
        if ($[0] !== appearance || $[1] !== ariaExpanded || $[2] !== ariaHaspopup || $[3] !== href || $[4] !== icon || $[5] !== rel || $[6] !== spacing || $[7] !== t3 || $[8] !== t4 || $[9] !== t5 || $[10] !== target || $[11] !== testId) {
            t6 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7WEaj.default), {
                ref: t3,
                href: href,
                onClick: t4,
                testId: testId,
                target: target,
                rel: rel,
                icon: icon,
                label: t5,
                appearance: appearance,
                "aria-haspopup": ariaHaspopup,
                "aria-expanded": ariaExpanded,
                isTooltipDisabled: false,
                spacing: spacing
            });
            $[0] = appearance;
            $[1] = ariaExpanded;
            $[2] = ariaHaspopup;
            $[3] = href;
            $[4] = icon;
            $[5] = rel;
            $[6] = spacing;
            $[7] = t3;
            $[8] = t4;
            $[9] = t5;
            $[10] = target;
            $[11] = testId;
            $[12] = t6;
        } else t6 = $[12];
        return t6;
    }
    if (icon) {
        const t3 = ref;
        const t4 = onClick;
        const t5 = label || ariaLabel;
        let t6;
        if ($[13] !== appearance || $[14] !== ariaExpanded || $[15] !== ariaHaspopup || $[16] !== icon || $[17] !== spacing || $[18] !== t3 || $[19] !== t4 || $[20] !== t5 || $[21] !== testId) {
            t6 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                ref: t3,
                onClick: t4,
                testId: testId,
                icon: icon,
                label: t5,
                appearance: appearance,
                "aria-haspopup": ariaHaspopup,
                "aria-expanded": ariaExpanded,
                isTooltipDisabled: false,
                spacing: spacing
            });
            $[13] = appearance;
            $[14] = ariaExpanded;
            $[15] = ariaHaspopup;
            $[16] = icon;
            $[17] = spacing;
            $[18] = t3;
            $[19] = t4;
            $[20] = t5;
            $[21] = testId;
            $[22] = t6;
        } else t6 = $[22];
        return t6;
    }
    if (href) {
        const t3 = ref;
        const t4 = onClick;
        let t5;
        if ($[23] !== ariaExpanded || $[24] !== ariaHaspopup || $[25] !== ariaLabel || $[26] !== children || $[27] !== href || $[28] !== rel || $[29] !== t3 || $[30] !== t4 || $[31] !== target || $[32] !== testId) {
            t5 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7vK9E.Anchor), {
                ref: t3,
                href: href,
                onClick: t4,
                testId: testId,
                target: target,
                rel: rel,
                "aria-label": ariaLabel,
                "aria-haspopup": ariaHaspopup,
                "aria-expanded": ariaExpanded,
                children: children
            });
            $[23] = ariaExpanded;
            $[24] = ariaHaspopup;
            $[25] = ariaLabel;
            $[26] = children;
            $[27] = href;
            $[28] = rel;
            $[29] = t3;
            $[30] = t4;
            $[31] = target;
            $[32] = testId;
            $[33] = t5;
        } else t5 = $[33];
        return t5;
    }
    const t3 = ref;
    const t4 = onClick;
    let t5;
    if ($[34] !== appearance || $[35] !== ariaExpanded || $[36] !== ariaHaspopup || $[37] !== ariaLabel || $[38] !== children || $[39] !== t3 || $[40] !== t4 || $[41] !== testId) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
            ref: t3,
            onClick: t4,
            testId: testId,
            "aria-label": ariaLabel,
            "aria-haspopup": ariaHaspopup,
            "aria-expanded": ariaExpanded,
            appearance: appearance,
            children: children
        });
        $[34] = appearance;
        $[35] = ariaExpanded;
        $[36] = ariaHaspopup;
        $[37] = ariaLabel;
        $[38] = children;
        $[39] = t3;
        $[40] = t4;
        $[41] = testId;
        $[42] = t5;
    } else t5 = $[42];
    return t5;
} : ({ children: children, onClick: onClick, href: href, testId: testId, target: target, rel: rel, 'aria-label': ariaLabel, 'aria-haspopup': ariaHaspopup, 'aria-expanded': ariaExpanded, icon: icon, label: label, appearance: appearance = 'subtle', spacing: spacing = 'default' }, ref)=>{
    if (icon && href) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7WEaj.default), {
        ref: ref,
        href: href,
        onClick: onClick,
        testId: testId,
        target: target,
        rel: rel,
        icon: icon,
        label: label || ariaLabel,
        appearance: appearance,
        "aria-haspopup": ariaHaspopup,
        "aria-expanded": ariaExpanded,
        isTooltipDisabled: false,
        spacing: spacing
    });
    if (icon) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
        ref: ref,
        onClick: onClick,
        testId: testId,
        icon: icon,
        label: label || ariaLabel,
        appearance: appearance,
        "aria-haspopup": ariaHaspopup,
        "aria-expanded": ariaExpanded,
        isTooltipDisabled: false,
        spacing: spacing
    });
    if (href) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7vK9E.Anchor), {
        ref: ref,
        href: href,
        onClick: onClick,
        testId: testId,
        target: target,
        rel: rel,
        "aria-label": ariaLabel,
        "aria-haspopup": ariaHaspopup,
        "aria-expanded": ariaExpanded,
        children: children
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
        ref: ref,
        onClick: onClick,
        testId: testId,
        "aria-label": ariaLabel,
        "aria-haspopup": ariaHaspopup,
        "aria-expanded": ariaExpanded,
        appearance: appearance,
        children: children
    });
});
module.exports["PanelAction"] = $2efd2cd3ca9e912b$export$2a18e3520151503;

});

parcelRegister("i68yG", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $l3wuH = parcelRequire("l3wuH");


var $7ZpVx = parcelRequire("7ZpVx");

const $837042f62dde5900$export$75d0a5a5f71a1ab1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(8);
    const { onClick: onClick, onBeforeClose: onBeforeClose, testId: testId, label: label } = t0;
    let t1;
    if ($[0] !== onBeforeClose || $[1] !== onClick) {
        t1 = async (event, analyticsEvent)=>{
            if (onBeforeClose) {
                const canClose = await onBeforeClose();
                if (!canClose) return;
            }
            if (onClick) onClick(event, analyticsEvent);
        };
        $[0] = onBeforeClose;
        $[1] = onClick;
        $[2] = t1;
    } else t1 = $[2];
    const handleClick = t1;
    const t2 = label || "Close panel";
    let t3;
    if ($[3] !== handleClick || $[4] !== ref || $[5] !== t2 || $[6] !== testId) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7ZpVx.PanelAction), {
            ref: ref,
            onClick: handleClick,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
            label: t2,
            spacing: "compact",
            appearance: "subtle"
        });
        $[3] = handleClick;
        $[4] = ref;
        $[5] = t2;
        $[6] = testId;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ onClick: onClick, onBeforeClose: onBeforeClose, testId: testId, label: label }, ref)=>{
    const handleClick = async (event, analyticsEvent)=>{
        if (onBeforeClose) {
            const canClose = await onBeforeClose();
            if (!canClose) return;
        }
        if (onClick) onClick(event, analyticsEvent);
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7ZpVx.PanelAction), {
        ref: ref,
        onClick: handleClick,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
        label: label || 'Close panel',
        spacing: "compact",
        appearance: "subtle"
    });
});
module.exports["PanelActionClose"] = $837042f62dde5900$export$75d0a5a5f71a1ab1;

});

parcelRegister("7ZxlY", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

const $2d2f9566579f7703$var$styles = {
    group: "_2mHwu82ADO _3iDTPbQ4SZ _0hPCNLDIqT"
}; /**
    * The PanelActionGroup component provides a container for grouping
    * panel actions together with consistent spacing and layout.
    */ 
const $2d2f9566579f7703$export$9546bd4ca18522f9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PanelActionGroup(t0) {
    const $ = (0, $bDgLe.c)(3);
    const { children: children, testId: testId } = t0;
    let t1;
    if ($[0] !== children || $[1] !== testId) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            testId: testId,
            xcss: $2d2f9566579f7703$var$styles.group,
            children: children
        });
        $[0] = children;
        $[1] = testId;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : function PanelActionGroup({ children: children, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        testId: testId,
        xcss: $2d2f9566579f7703$var$styles.group,
        children: children
    });
};
module.exports["PanelActionGroup"] = $2d2f9566579f7703$export$9546bd4ca18522f9;

});

parcelRegister("1jpZo", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

const $2747dc4177a5f32c$var$styles = {
    header: "_0jFU0V36Ow _3iDTPbQ4SZ _0hPCNLDIqT _0LQT5EkG2W _03SyCPkG2W _46hvQm5zaO _0xmtko5zaO",
    headerContent: "_2mHwu82ADO _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuI7V3 _39xV02N91d"
}; /**
    * The PanelHeader component provides a standardized header area for panels
    * containing the title, actions, and other header-specific content.
    * It automatically organizes content into left (back button + title) and right (actions) sections
    * using flexbox layout. Place PanelActionGroup as the last child to position it on the right.
    */ 
const $2747dc4177a5f32c$export$968713404ca1c9aa = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PanelHeader(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { children: children, testId: testId } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4ez2K.Flex), {
            xcss: $2747dc4177a5f32c$var$styles.headerContent,
            children: children
        });
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1 || $[3] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            as: "header",
            testId: testId,
            xcss: $2747dc4177a5f32c$var$styles.header,
            children: t1
        });
        $[2] = t1;
        $[3] = testId;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : function PanelHeader({ children: children, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        as: "header",
        testId: testId,
        xcss: $2747dc4177a5f32c$var$styles.header,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4ez2K.Flex), {
            xcss: $2747dc4177a5f32c$var$styles.headerContent,
            children: children
        })
    });
};
module.exports["PanelHeader"] = $2747dc4177a5f32c$export$968713404ca1c9aa;

});

parcelRegister("Emr0i", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $e1da37ec0a029195$var$_default_1 = (0, $kSwu1.defineMessages)({
    previewPanelCloseButtonLabel: {
        id: "navigation.preview-panel.preview-panel-header.close-button-label",
        defaultMessage: "Close"
    },
    previewPanelExpandActionLabel: {
        id: "navigation.preview-panel.preview-panel-action-variants.preview-panel-expand.expand-action-label",
        defaultMessage: "Expand"
    },
    previewPanelNewTabActionLabel: {
        id: "navigation.preview-panel.preview-panel-action-variants.preview-panel-new-tab.new-tab-action-label",
        defaultMessage: "Open in new tab"
    },
    previewPanelMoreDropdownActionLabel: {
        id: "navigation.preview-panel.preview-panel-action-variants.preview-panel-more-dropdown.more-dropdown-action-label",
        defaultMessage: "More"
    },
    previewPanelOpenInNewWindowLabel: {
        id: "navigation.preview-panel.preview-panel-header.open-in-new-window-label",
        defaultMessage: "Open in new window"
    },
    previewPanelNavigateBackLabel: {
        id: "navigation.preview-panel.preview-panel-header.navigate-back-label",
        defaultMessage: "Go back to previous panel"
    }
});
var $e1da37ec0a029195$export$2e2bcd8739ae039 = $e1da37ec0a029195$var$_default_1;
module.exports["default"] = $e1da37ec0a029195$export$2e2bcd8739ae039;

});

parcelRegister("7Yky3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $V3JOP = parcelRequire("V3JOP");


var $Emr0i = parcelRequire("Emr0i");


var $6GBgL = parcelRequire("6GBgL");

const $3d98d316d4b42e83$export$d05dda6f1d91eaad = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { href: href, label: label, onClick: onClick, testId: testId, analyticsContext: analyticsContext } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== formatMessage || $[1] !== label) {
        t1 = label || formatMessage((0, $Emr0i.default).previewPanelNewTabActionLabel);
        $[0] = formatMessage;
        $[1] = label;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== analyticsContext || $[4] !== href || $[5] !== onClick || $[6] !== t1 || $[7] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GBgL.PreviewPanelAction), {
            label: t1,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))),
            onClick: onClick,
            href: href,
            testId: testId,
            analyticsContext: analyticsContext
        });
        $[3] = analyticsContext;
        $[4] = href;
        $[5] = onClick;
        $[6] = t1;
        $[7] = testId;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : ({ href: href, label: label, onClick: onClick, testId: testId, analyticsContext: analyticsContext })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GBgL.PreviewPanelAction), {
        label: label || formatMessage((0, $Emr0i.default).previewPanelNewTabActionLabel),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))),
        onClick: onClick,
        href: href,
        testId: testId,
        analyticsContext: analyticsContext
    });
};
module.exports["PreviewPanelNewTabLink"] = $3d98d316d4b42e83$export$d05dda6f1d91eaad;

});

parcelRegister("6GBgL", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1sCHt = parcelRequire("1sCHt");


var $7WEaj = parcelRequire("7WEaj");


var $iDrrr = parcelRequire("iDrrr");


var $7ZpVx = parcelRequire("7ZpVx");

const $e48bc72cc4b3f1f2$export$a37cb5f447b2cf16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((0, $gtMdU.isReactCompilerActivePlatform)() ? function PreviewPanelAction(t0, ref) {
    const $ = (0, $bDgLe.c)(22);
    const { icon: icon, label: label, onClick: onClick, href: href, testId: testId, analyticsContext: analyticsContext } = t0;
    if ((0, $iDrrr.fg)("ads-panel-system-gpp")) {
        if (analyticsContext || href) {
            let t1;
            if ($[0] !== analyticsContext || $[1] !== href || $[2] !== icon || $[3] !== label || $[4] !== onClick || $[5] !== ref || $[6] !== testId) {
                t1 = href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7WEaj.default), {
                    icon: icon,
                    label: label,
                    onClick: onClick,
                    href: href,
                    testId: testId,
                    analyticsContext: analyticsContext,
                    appearance: "subtle",
                    target: "_blank",
                    ref: ref,
                    role: "button"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                    icon: icon,
                    label: label,
                    onClick: onClick,
                    testId: testId,
                    analyticsContext: analyticsContext,
                    appearance: "subtle",
                    ref: ref,
                    role: "button"
                });
                $[0] = analyticsContext;
                $[1] = href;
                $[2] = icon;
                $[3] = label;
                $[4] = onClick;
                $[5] = ref;
                $[6] = testId;
                $[7] = t1;
            } else t1 = $[7];
            return t1;
        }
        let t1;
        if ($[8] !== icon || $[9] !== label || $[10] !== onClick || $[11] !== ref || $[12] !== testId) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZpVx.PanelAction), {
                ref: ref,
                icon: icon,
                label: label,
                onClick: onClick,
                testId: testId,
                appearance: "subtle"
            });
            $[8] = icon;
            $[9] = label;
            $[10] = onClick;
            $[11] = ref;
            $[12] = testId;
            $[13] = t1;
        } else t1 = $[13];
        return t1;
    }
    let t1;
    if ($[14] !== analyticsContext || $[15] !== href || $[16] !== icon || $[17] !== label || $[18] !== onClick || $[19] !== ref || $[20] !== testId) {
        t1 = href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7WEaj.default), {
            icon: icon,
            label: label,
            onClick: onClick,
            href: href,
            testId: testId,
            analyticsContext: analyticsContext,
            appearance: "subtle",
            target: "_blank",
            ref: ref,
            role: "button"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: icon,
            label: label,
            onClick: onClick,
            testId: testId,
            analyticsContext: analyticsContext,
            appearance: "subtle",
            ref: ref,
            role: "button"
        });
        $[14] = analyticsContext;
        $[15] = href;
        $[16] = icon;
        $[17] = label;
        $[18] = onClick;
        $[19] = ref;
        $[20] = testId;
        $[21] = t1;
    } else t1 = $[21];
    return t1;
} : function PreviewPanelAction({ icon: icon, label: label, onClick: onClick, href: href, testId: testId, analyticsContext: analyticsContext }, ref) {
    if ((0, $iDrrr.fg)('ads-panel-system-gpp')) {
        if (analyticsContext || href) return href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7WEaj.default), {
            icon: icon,
            label: label,
            onClick: onClick,
            href: href,
            testId: testId,
            analyticsContext: analyticsContext,
            appearance: "subtle",
            target: "_blank",
            ref: ref,
            role: "button"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: icon,
            label: label,
            onClick: onClick,
            testId: testId,
            analyticsContext: analyticsContext,
            appearance: "subtle",
            ref: ref,
            role: "button"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZpVx.PanelAction), {
            ref: ref,
            icon: icon,
            label: label,
            onClick: onClick,
            testId: testId,
            appearance: "subtle"
        });
    }
    return href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7WEaj.default), {
        icon: icon,
        label: label,
        onClick: onClick,
        href: href,
        testId: testId,
        analyticsContext: analyticsContext,
        appearance: "subtle",
        target: "_blank",
        ref: ref,
        role: "button"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: icon,
        label: label,
        onClick: onClick,
        testId: testId,
        analyticsContext: analyticsContext,
        appearance: "subtle",
        ref: ref,
        role: "button"
    });
});
module.exports["PreviewPanelAction"] = $e48bc72cc4b3f1f2$export$a37cb5f447b2cf16;

});

parcelRegister("bRCqW", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");


var $aMRlV = parcelRequire("aMRlV");

const $33c23c71035fcd90$export$92a58681483f4529 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { title: title, icon: icon, color: color } = t0;
    if ((0, $iDrrr.fg)("ads-panel-system-gpp")) {
        let t1;
        if ($[0] !== icon || $[1] !== title) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aMRlV.PanelTitle), {
                icon: icon
            }, title);
            $[0] = icon;
            $[1] = title;
            $[2] = t1;
        } else t1 = $[2];
        return t1;
    }
    let t1;
    if ($[3] !== color || $[4] !== title) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            weight: "bold",
            maxLines: 1,
            color: color
        }, title);
        $[3] = color;
        $[4] = title;
        $[5] = t1;
    } else t1 = $[5];
    let t2;
    if ($[6] !== icon || $[7] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center"
        }, icon, t1);
        $[6] = icon;
        $[7] = t1;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : ({ title: title, icon: icon, color: color })=>{
    if ((0, $iDrrr.fg)('ads-panel-system-gpp')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aMRlV.PanelTitle), {
        icon: icon
    }, title);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "bold",
        maxLines: 1,
        color: color
    }, title));
};
module.exports["PreviewPanelTitle"] = $33c23c71035fcd90$export$92a58681483f4529;

});

parcelRegister("aMRlV", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $I7hWB = parcelRequire("I7hWB");


var $iMnC5 = parcelRequire("iMnC5");

const $4105ecb3e4516dff$var$styles = {
    title: "_3iDTPbQ4SZ _0hPCNLDIqT _2O5Vij7dHp",
    titleText: "_0LQT5E1Y8M",
    icon: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV029DVM _0jFU0V9DVM"
}; /**
    * The PanelTitle component provides a standardized title display for panels
    * with optional icon support and consistent typography.
    */ 
const $4105ecb3e4516dff$export$86de09faaa70680d = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PanelTitle(t0) {
    const $ = (0, $bDgLe.c)(9);
    const { children: children, icon: icon, testId: testId } = t0;
    let t1;
    if ($[0] !== icon) {
        t1 = icon && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $4105ecb3e4516dff$var$styles.icon,
            children: icon
        });
        $[0] = icon;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            $4105ecb3e4516dff$var$styles.titleText
        ]);
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== children) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            className: t2,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I7hWB.default), {
                size: "small",
                as: "h2",
                children: children
            })
        });
        $[3] = children;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== t1 || $[6] !== t3 || $[7] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
            testId: testId,
            xcss: $4105ecb3e4516dff$var$styles.title,
            children: [
                t1,
                t3
            ]
        });
        $[5] = t1;
        $[6] = t3;
        $[7] = testId;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
} : function PanelTitle({ children: children, icon: icon, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
        testId: testId,
        xcss: $4105ecb3e4516dff$var$styles.title,
        children: [
            icon && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: $4105ecb3e4516dff$var$styles.icon,
                children: icon
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                className: (0, $hekY6.default)([
                    $4105ecb3e4516dff$var$styles.titleText
                ]),
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I7hWB.default), {
                    size: "small",
                    as: "h2",
                    children: children
                })
            })
        ]
    });
};
module.exports["PanelTitle"] = $4105ecb3e4516dff$export$86de09faaa70680d;

});

parcelRegister("fxbF1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8123c7d174e08dae4e5d4a014122c25>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b4f2fba9f65c2ddf$var$_react = $b4f2fba9f65c2ddf$var$_interopRequireDefault((parcelRequire("cozmU")));

var $b4f2fba9f65c2ddf$var$_iconNew = $b4f2fba9f65c2ddf$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $b4f2fba9f65c2ddf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "History".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/history
 * Usage guidance:
 * Reserved for history and recent
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b4f2fba9f65c2ddf$var$HistoryIcon = (props)=>/*#__PURE__*/ $b4f2fba9f65c2ddf$var$_react.default.createElement($b4f2fba9f65c2ddf$var$_iconNew.default, Object.assign({
        name: "HistoryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1.5 8A6.5 6.5 0 1 0 8 1.5a6.36 6.36 0 0 0-4.651 2.005l1.298.26a.75.75 0 0 1-.09 1.483l-3.25.25A.75.75 0 0 1 .5 4.75V1.5l.013-.137a.75.75 0 0 1 1.456-.079l.34 1.138A7.86 7.86 0 0 1 8 0a8 8 0 1 1-8 8zm7.25-4.25v4.389l2.219 1.775-.938 1.172-2.5-2A.75.75 0 0 1 7.25 8.5V3.75z"/>`
    }, props));
$b4f2fba9f65c2ddf$var$HistoryIcon.displayName = 'HistoryIcon';
var $b4f2fba9f65c2ddf$var$_default = module.exports.default = $b4f2fba9f65c2ddf$var$HistoryIcon;

});

parcelRegister("iRqYE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f26cb4555fd0a9c76f3908210a54af9e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dbb21a5762820d00$var$_react = $dbb21a5762820d00$var$_interopRequireDefault((parcelRequire("cozmU")));

var $dbb21a5762820d00$var$_iconNew = $dbb21a5762820d00$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $dbb21a5762820d00$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Terminal".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/terminal
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dbb21a5762820d00$var$TerminalIcon = (props)=>/*#__PURE__*/ $dbb21a5762820d00$var$_react.default.createElement($dbb21a5762820d00$var$_iconNew.default, Object.assign({
        name: "TerminalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 3a.5.5 0 0 0-.4-.49L14 2.5H2a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5zM16 13a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h12l.204.01A2 2 0 0 1 16 3z"/><path fill="currentcolor" d="m4.28 4.72 2.75 2.75a.75.75 0 0 1 0 1.06l-2.75 2.75-1.06-1.06L5.44 8 3.22 5.78zM12.5 9.5V11H8V9.5z"/>`
    }, props));
$dbb21a5762820d00$var$TerminalIcon.displayName = 'TerminalIcon';
var $dbb21a5762820d00$var$_default = module.exports.default = $dbb21a5762820d00$var$TerminalIcon;

});

parcelRegister("i8aB6", function(module, exports) {
/* eslint-disable perfectionist/sort-object-types */ 
var $cozmU = parcelRequire("cozmU");


var $34VCg = parcelRequire("34VCg");

const $89c606f0d1f4dfb4$export$fade2d05a6320d49 = ({ id: id, component: component, type: type, performanceType: performanceType })=>{
    const ufoExperience = (0, $cozmU.useRef)(new (0, $34VCg.UFOExperience)(id, {
        type: type,
        performanceType: performanceType,
        platform: {
            component: component
        }
    }));
    const start = (0, $cozmU.useCallback)((startTime)=>{
        return ufoExperience.current.start(startTime);
    }, []);
    const success = (0, $cozmU.useCallback)((config)=>{
        return ufoExperience.current.success(config);
    }, []);
    const mark = (0, $cozmU.useCallback)((name, timestamp)=>{
        ufoExperience.current.mark(name, timestamp);
    }, []);
    const addMetadata = (0, $cozmU.useCallback)((data)=>{
        ufoExperience.current.addMetadata(data);
    }, []);
    const markFMP = (0, $cozmU.useCallback)((timestamp)=>{
        ufoExperience.current.markFMP(timestamp);
    }, []);
    const markInlineResponse = (0, $cozmU.useCallback)((timestamp)=>{
        ufoExperience.current.markInlineResponse(timestamp);
    }, []);
    const failure = (0, $cozmU.useCallback)((config)=>{
        return ufoExperience.current.failure(config);
    }, []);
    const abort = (0, $cozmU.useCallback)((config)=>{
        return ufoExperience.current.abort(config);
    }, []);
    return {
        start: start,
        success: success,
        failure: failure,
        abort: abort,
        mark: mark,
        addMetadata: addMetadata,
        markFMP: markFMP,
        markInlineResponse: markInlineResponse
    };
};
module.exports["useUFOExperience"] = $89c606f0d1f4dfb4$export$fade2d05a6320d49;

});

parcelRegister("lU4RT", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $dpsRj = parcelRequire("dpsRj");


var $9d7Pd = parcelRequire("9d7Pd");


var $acQiA = parcelRequire("acQiA");


var $3jSHR = parcelRequire("3jSHR");


var $43dcO = parcelRequire("43dcO");


var $imIsb = parcelRequire("imIsb");


var $1P2f3 = parcelRequire("1P2f3");

/**
 * __Dropdown item checkbox__
 *
 * A dropdown item checkbox creates groups that have multiple selections.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/usage)
 */ const $6b3a69811500fe11$var$DropdownItemCheckbox = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(36);
    let children;
    let defaultSelected;
    let description;
    let id;
    let interactionName;
    let isDisabled;
    let isSelected;
    let rest;
    let t1;
    let t2;
    let t3;
    let testId;
    if ($[0] !== t0) {
        ({ children: children, defaultSelected: defaultSelected, description: description, id: id, isDisabled: isDisabled, isSelected: isSelected, onClick: t1, shouldDescriptionWrap: t2, shouldTitleWrap: t3, testId: testId, interactionName: interactionName, ...rest } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = defaultSelected;
        $[3] = description;
        $[4] = id;
        $[5] = interactionName;
        $[6] = isDisabled;
        $[7] = isSelected;
        $[8] = rest;
        $[9] = t1;
        $[10] = t2;
        $[11] = t3;
        $[12] = testId;
    } else {
        children = $[1];
        defaultSelected = $[2];
        description = $[3];
        id = $[4];
        interactionName = $[5];
        isDisabled = $[6];
        isSelected = $[7];
        rest = $[8];
        t1 = $[9];
        t2 = $[10];
        t3 = $[11];
        testId = $[12];
    }
    const providedOnClick = t1 === undefined ? (0, $dpsRj.default) : t1;
    const shouldDescriptionWrap = t2 === undefined ? true : t2;
    const shouldTitleWrap = t3 === undefined ? true : t3;
    typeof $1P2f3;
    let t4;
    if ($[13] !== defaultSelected || $[14] !== id || $[15] !== isSelected) {
        t4 = {
            id: id,
            isSelected: isSelected,
            defaultSelected: defaultSelected
        };
        $[13] = defaultSelected;
        $[14] = id;
        $[15] = isSelected;
        $[16] = t4;
    } else t4 = $[16];
    const [selected, setSelected] = (0, $43dcO.default)(t4);
    let t5;
    if ($[17] !== providedOnClick || $[18] !== setSelected) {
        t5 = (event)=>{
            setSelected($6b3a69811500fe11$var$_temp);
            providedOnClick(event);
        };
        $[17] = providedOnClick;
        $[18] = setSelected;
        $[19] = t5;
    } else t5 = $[19];
    const onClickHandler = t5;
    const itemRef = (0, $imIsb.default)();
    let t6;
    if ($[20] !== selected) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3jSHR.default), {
            checked: selected
        });
        $[20] = selected;
        $[21] = t6;
    } else t6 = $[21];
    let t7;
    if ($[22] !== children || $[23] !== description || $[24] !== id || $[25] !== interactionName || $[26] !== isDisabled || $[27] !== itemRef || $[28] !== onClickHandler || $[29] !== rest || $[30] !== selected || $[31] !== shouldDescriptionWrap || $[32] !== shouldTitleWrap || $[33] !== t6 || $[34] !== testId) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $acQiA.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
            value: "none",
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9d7Pd.default), {
                "aria-checked": selected,
                description: description,
                iconBefore: t6,
                id: id,
                isDisabled: isDisabled,
                isSelected: selected,
                onClick: onClickHandler,
                ref: itemRef,
                role: "menuitemcheckbox",
                shouldDescriptionWrap: shouldDescriptionWrap,
                shouldTitleWrap: shouldTitleWrap,
                testId: testId,
                interactionName: interactionName,
                ...rest,
                children: children
            })
        });
        $[22] = children;
        $[23] = description;
        $[24] = id;
        $[25] = interactionName;
        $[26] = isDisabled;
        $[27] = itemRef;
        $[28] = onClickHandler;
        $[29] = rest;
        $[30] = selected;
        $[31] = shouldDescriptionWrap;
        $[32] = shouldTitleWrap;
        $[33] = t6;
        $[34] = testId;
        $[35] = t7;
    } else t7 = $[35];
    return t7;
} : ({ children: children, defaultSelected: defaultSelected, description: description, id: id, isDisabled: isDisabled, isSelected: isSelected, onClick: providedOnClick = (0, $dpsRj.default), shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, testId: testId, interactionName: interactionName, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    typeof $1P2f3;
    const [selected, setSelected] = (0, $43dcO.default)({
        id: id,
        isSelected: isSelected,
        defaultSelected: defaultSelected
    });
    const onClickHandler = (0, $cozmU.useCallback)((event)=>{
        setSelected((selected_0)=>!selected_0);
        providedOnClick(event);
    }, [
        providedOnClick,
        setSelected
    ]);
    const itemRef = (0, $imIsb.default)();
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $acQiA.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "none",
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9d7Pd.default), {
            "aria-checked": selected,
            description: description,
            iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3jSHR.default), {
                checked: selected
            }),
            id: id,
            isDisabled: isDisabled,
            isSelected: selected,
            onClick: onClickHandler,
            ref: itemRef,
            role: "menuitemcheckbox",
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            interactionName: interactionName,
            ...rest,
            children: children
        })
    });
};
var $6b3a69811500fe11$export$2e2bcd8739ae039 = $6b3a69811500fe11$var$DropdownItemCheckbox;
function $6b3a69811500fe11$var$_temp(selected_0) {
    return !selected_0;
}
module.exports["default"] = $6b3a69811500fe11$export$2e2bcd8739ae039;

});

parcelRegister("3jSHR", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");

parcelRequire("cozmU");

const $a8ec5e894df17170$var$svgStyles = null; /**
                         * __Checkbox icon__
                         *
                         * Used to visually represent the selected state in DropdownItemCheckbox
                         *
                         * @internal
                         */ 
const $a8ec5e894df17170$var$CheckboxIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { checked: checked } = t0;
    const t1 = checked ? "var(--ds-background-selected-bold, #1868DB)" : "var(--ds-background-input, #FFFFFF)";
    const t2 = checked ? "var(--ds-icon-inverse, #FFFFFF)" : "transparent";
    let t3;
    if ($[0] !== t1 || $[1] !== t2) {
        t3 = {
            color: t1,
            fill: t2
        };
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _1rdFvhlfZc _1pp6NdYbGa"
        ]);
        $[3] = t4;
    } else t4 = $[3];
    const t5 = checked ? "var(--ds-border-selected, #1868DB)" : "var(--ds-border-input, #8C8F97)";
    let t6;
    if ($[4] !== t5) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
            stroke: t5,
            x: "5.5",
            y: "5.5",
            width: "13",
            height: "13",
            rx: "1.5",
            fill: "currentColor"
        });
        $[4] = t5;
        $[5] = t6;
    } else t6 = $[5];
    let t7;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
            fill: "inherit"
        });
        $[6] = t7;
    } else t7 = $[6];
    let t8;
    if ($[7] !== t6) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                t6,
                t7
            ]
        });
        $[7] = t6;
        $[8] = t8;
    } else t8 = $[8];
    let t9;
    if ($[9] !== t3 || $[10] !== t8) {
        t9 = /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
            width: 24,
            height: 24,
            viewBox: "0 0 24 24",
            style: t3,
            role: "presentation",
            className: t4,
            children: t8
        });
        $[9] = t3;
        $[10] = t8;
        $[11] = t9;
    } else t9 = $[11];
    return t9;
} : ({ checked: checked })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            color: checked ? "var(--ds-background-selected-bold, #1868DB)" : "var(--ds-background-input, #FFFFFF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            fill: checked ? "var(--ds-icon-inverse, #FFFFFF)" : 'transparent'
        },
        role: "presentation",
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _1rdFvhlfZc _1pp6NdYbGa"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                    stroke: checked ? "var(--ds-border-selected, #1868DB)" : "var(--ds-border-input, #8C8F97)",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
                    fill: "inherit"
                })
            ]
        })
    });
};
var $a8ec5e894df17170$export$2e2bcd8739ae039 = $a8ec5e894df17170$var$CheckboxIcon;
module.exports["default"] = $a8ec5e894df17170$export$2e2bcd8739ae039;

});

parcelRegister("43dcO", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hR9fw = parcelRequire("hR9fw");


var $lOWpM = parcelRequire("lOWpM");

/**
 * Custom hook to handle checkbox state for dropdown menu.
 * It works in tandem with the selection store context when the
 * component is uncontrolled.
 */ const $e413fac5530a681e$var$useCheckboxState = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { isSelected: isSelected, id: id, defaultSelected: defaultSelected } = t0;
    const { setItemState: setItemState, getItemState: getItemState } = (0, $cozmU.useContext)((0, $lOWpM.SelectionStoreContext));
    const groupId = (0, $cozmU.useContext)((0, $hR9fw.CheckboxGroupContext));
    let t1;
    if ($[0] !== getItemState || $[1] !== groupId || $[2] !== id) {
        t1 = getItemState(groupId, id);
        $[0] = getItemState;
        $[1] = groupId;
        $[2] = id;
        $[3] = t1;
    } else t1 = $[3];
    const persistedIsSelected = t1;
    let t2;
    if ($[4] !== defaultSelected || $[5] !== persistedIsSelected) {
        t2 = ()=>persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false;
        $[4] = defaultSelected;
        $[5] = persistedIsSelected;
        $[6] = t2;
    } else t2 = $[6];
    const [localIsSelected, setLocalIsSelected] = (0, $cozmU.useState)(t2);
    let t3;
    if ($[7] !== groupId || $[8] !== id || $[9] !== persistedIsSelected || $[10] !== setItemState) {
        t3 = (newValue)=>{
            const nextValue = newValue(persistedIsSelected);
            setLocalIsSelected(nextValue);
            setItemState(groupId, id, nextValue);
        };
        $[7] = groupId;
        $[8] = id;
        $[9] = persistedIsSelected;
        $[10] = setItemState;
        $[11] = t3;
    } else t3 = $[11];
    const setLocalState = t3;
    if (typeof isSelected === "boolean") {
        let t4;
        if ($[12] !== isSelected) {
            t4 = [
                isSelected,
                $e413fac5530a681e$var$_temp
            ];
            $[12] = isSelected;
            $[13] = t4;
        } else t4 = $[13];
        return t4;
    }
    if (persistedIsSelected === undefined) setItemState(groupId, id, defaultSelected || false);
    let t4;
    if ($[14] !== localIsSelected || $[15] !== setLocalState) {
        t4 = [
            localIsSelected,
            setLocalState
        ];
        $[14] = localIsSelected;
        $[15] = setLocalState;
        $[16] = t4;
    } else t4 = $[16];
    return t4;
} : ({ isSelected: isSelected, id: id, defaultSelected: defaultSelected })=>{
    const { setItemState: setItemState, getItemState: getItemState } = (0, $cozmU.useContext)((0, $lOWpM.SelectionStoreContext));
    const groupId = (0, $cozmU.useContext)((0, $hR9fw.CheckboxGroupContext));
    const persistedIsSelected = getItemState(groupId, id);
    const [localIsSelected, setLocalIsSelected] = (0, $cozmU.useState)(// Initial state is set depending on value being defined or not.
    // This state is only utilised if the checkbox is uncontrolled.
    ()=>persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false);
    const setLocalState = (0, $cozmU.useCallback)((newValue)=>{
        const nextValue = newValue(persistedIsSelected);
        setLocalIsSelected(nextValue);
        setItemState(groupId, id, nextValue);
    }, [
        setItemState,
        persistedIsSelected,
        groupId,
        id
    ]);
    // Checkbox is controlled - do nothing!
    if (typeof isSelected === 'boolean') return [
        isSelected,
        ()=>false
    ];
    // Checkbox is going through its first render pass!
    if (persistedIsSelected === undefined) // Set the item so we have this state to access next time the checkbox renders (either by mounting or re-rendering!)
    setItemState(groupId, id, defaultSelected || false);
    // Return the value and setter!
    // Remember this flow is only returned if the checkbox is uncontrolled.
    return [
        localIsSelected,
        setLocalState
    ];
};
var $e413fac5530a681e$export$2e2bcd8739ae039 = $e413fac5530a681e$var$useCheckboxState;
function $e413fac5530a681e$var$_temp() {
    return false;
}
module.exports["default"] = $e413fac5530a681e$export$2e2bcd8739ae039;

});

parcelRegister("hR9fw", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $c7ae6da6a8b76651$export$baf37c4be89255b8 = /*#__PURE__*/ (0, $cozmU.createContext)('');
module.exports["CheckboxGroupContext"] = $c7ae6da6a8b76651$export$baf37c4be89255b8;

});

parcelRegister("7DqNt", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $6JrSr = parcelRequire("6JrSr");


var $8FgJC = parcelRequire("8FgJC");


var $eiIYc = parcelRequire("eiIYc");


var $hR9fw = parcelRequire("hR9fw");

/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu checkbox items.
 *
 */ const $1b4057c4abe15cf7$var$DropdownItemCheckboxGroup = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    let children;
    let hasSeparator;
    let id;
    let isList;
    let isScrollable;
    let rest;
    let testId;
    let title;
    if ($[0] !== t0) {
        ({ children: children, hasSeparator: hasSeparator, id: id, isList: isList, isScrollable: isScrollable, testId: testId, title: title, ...rest } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = hasSeparator;
        $[3] = id;
        $[4] = isList;
        $[5] = isScrollable;
        $[6] = rest;
        $[7] = testId;
        $[8] = title;
    } else {
        children = $[1];
        hasSeparator = $[2];
        id = $[3];
        isList = $[4];
        isScrollable = $[5];
        rest = $[6];
        testId = $[7];
        title = $[8];
    }
    const uid = (0, $6JrSr.useId)();
    const titleId = `dropdown-menu-item-checkbox-group-title-${uid}`;
    const t1 = title ? titleId : undefined;
    let t2;
    if ($[9] !== title || $[10] !== titleId) {
        t2 = title && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eiIYc.default), {
            id: titleId,
            title: title
        });
        $[9] = title;
        $[10] = titleId;
        $[11] = t2;
    } else t2 = $[11];
    let t3;
    if ($[12] !== children || $[13] !== hasSeparator || $[14] !== id || $[15] !== isList || $[16] !== isScrollable || $[17] !== rest || $[18] !== t1 || $[19] !== t2 || $[20] !== testId) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8FgJC.default), {
            hasSeparator: hasSeparator,
            id: id,
            isList: isList,
            isScrollable: isScrollable,
            testId: testId,
            titleId: t1,
            ...rest,
            children: [
                t2,
                children
            ]
        });
        $[12] = children;
        $[13] = hasSeparator;
        $[14] = id;
        $[15] = isList;
        $[16] = isScrollable;
        $[17] = rest;
        $[18] = t1;
        $[19] = t2;
        $[20] = testId;
        $[21] = t3;
    } else t3 = $[21];
    let t4;
    if ($[22] !== id || $[23] !== t3) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hR9fw.CheckboxGroupContext).Provider, {
            value: id,
            children: t3
        });
        $[22] = id;
        $[23] = t3;
        $[24] = t4;
    } else t4 = $[24];
    return t4;
} : ({ children: children, hasSeparator: hasSeparator, id: id, isList: isList, isScrollable: isScrollable, testId: testId, title: title, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    const uid = (0, $6JrSr.useId)();
    const titleId = `dropdown-menu-item-checkbox-group-title-${uid}`;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hR9fw.CheckboxGroupContext).Provider, {
        value: id,
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8FgJC.default), {
            hasSeparator: hasSeparator,
            id: id,
            isList: isList,
            isScrollable: isScrollable,
            testId: testId,
            titleId: title ? titleId : undefined,
            ...rest,
            children: [
                title && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eiIYc.default), {
                    id: titleId,
                    title: title
                }),
                children
            ]
        })
    });
};
var $1b4057c4abe15cf7$export$2e2bcd8739ae039 = $1b4057c4abe15cf7$var$DropdownItemCheckboxGroup;
module.exports["default"] = $1b4057c4abe15cf7$export$2e2bcd8739ae039;

});

parcelRegister("fGDv8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4wH3g = parcelRequire("4wH3g");


var $iDrrr = parcelRequire("iDrrr");


var $b8pma = parcelRequire("b8pma");


var $7Myh3 = parcelRequire("7Myh3");

const $11be68f9ade9fe63$var$conversationAssistantLazy = (0, $cozmU.lazy)(()=>(0, $7Myh3.importConversationAssistant)().then((module)=>({
            default: module.ConversationAssistant
        })));
const $11be68f9ade9fe63$var$createLoadingComponent = ()=>{
    return (0, $b8pma.default)({
        name: 'LoadingConversationAssistantBundle'
    });
};
const $11be68f9ade9fe63$var$conversationAssistantLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "hDEDK",
    name: "conversationAssistantLoadable",
    loader: ()=>(0, $7Myh3.importConversationAssistant)().then((m)=>m.ConversationAssistant),
    loading: $11be68f9ade9fe63$var$createLoadingComponent
});
const $11be68f9ade9fe63$var$AsyncConversationAssistant = Object.assign((props)=>{
    if ((0, $iDrrr.fg)('aimate_conversation_assistant_async_loading')) return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: $11be68f9ade9fe63$var$createLoadingComponent()
    }, (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($11be68f9ade9fe63$var$conversationAssistantLazy, props));
    if (props.useChildrenAsLoadingFallback && props.overridingChildren) return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: props.overridingChildren
    }, (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($11be68f9ade9fe63$var$conversationAssistantLazy, props));
    return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($11be68f9ade9fe63$var$conversationAssistantLoadable, props);
}, {
    preload: ()=>{
        // React.lazy has no preload API, so warm the shared chunk directly on the R19
        // lazy path; keep react-loadable's preload (which also marks it loaded) otherwise.
        if ((0, $iDrrr.fg)('aimate_conversation_assistant_async_loading')) (0, $7Myh3.importConversationAssistant)();
        else $11be68f9ade9fe63$var$conversationAssistantLoadable.preload();
    }
});
var $11be68f9ade9fe63$export$2e2bcd8739ae039 = $11be68f9ade9fe63$var$AsyncConversationAssistant;
module.exports["default"] = $11be68f9ade9fe63$export$2e2bcd8739ae039;

});

parcelRegister("4H55s", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::59a9afa412fc227cfd2e3839c8269fd5>>
 * @codegenCommand afm workspace @atlassian/logo-third-party generate:components
 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $bD1F5 = parcelRequire("bD1F5");

const $3b8b1dedf3cc6ac9$var$markup = '<svg width="100%" height="100%" fill="none" viewBox="0 0 48 48"><path fill="#d97757" d="m14.279 29.274 6.294-3.53.105-.307-.105-.17h-.308l-1.053-.065-3.597-.097-3.119-.13-3.022-.161-.761-.162-.713-.94.073-.469.64-.429.915.081 2.026.138 3.038.21 2.203.13 3.265.34h.518l.073-.21-.178-.13-.138-.13-3.143-2.129-3.402-2.25-1.783-1.296-.964-.655-.486-.616-.21-1.343.875-.964 1.174.081.3.081 1.19.915 2.545 1.967 3.321 2.445.486.405.195-.138.024-.097-.219-.364-1.806-3.263-1.928-3.319-.86-1.376-.226-.826c-.081-.34-.138-.623-.138-.971l.997-1.352.55-.178 1.33.178.558.486.826 1.886 1.337 2.97 2.074 4.04.608 1.198.324 1.11.121.34h.21v-.195l.171-2.275.316-2.792.308-3.595.105-1.012.503-1.214.996-.655.778.372.64.915-.09.59-.38 2.47-.745 3.87-.487 2.59h.284l.324-.324 1.312-1.74 2.204-2.753.972-1.093 1.134-1.206.73-.575h1.377l1.012 1.506-.453 1.554-1.418 1.797-1.175 1.522-1.685 2.267-1.053 1.813.097.146.251-.024 3.808-.81 2.058-.372 2.454-.421 1.11.518.122.526-.438 1.076-2.625.648-3.078.615-4.585 1.085-.057.04.065.082 2.066.194.883.048h2.163l4.026.3 1.053.696.632.85-.105.648-1.62.825-2.188-.518-5.104-1.214-1.75-.437h-.243v.146l1.459 1.424 2.673 2.413 3.346 3.108.17.77-.43.606-.453-.064-2.94-2.21-1.135-.996-2.568-2.161h-.17v.226l.591.866 3.127 4.696.162 1.44-.227.47-.81.283-.89-.162-1.832-2.566-1.887-2.89-1.523-2.59-.187.105-.899 9.674-.421.494-.972.372-.81-.615-.43-.996.43-1.967.518-2.566.421-2.04.381-2.534.227-.842-.016-.056-.187.024-1.911 2.623-2.909 3.926-2.3 2.46-.552.22-.956-.495.09-.882.534-.785 3.184-4.048 1.92-2.51 1.24-1.448-.008-.21h-.073l-8.458 5.488-1.507.194-.648-.607.08-.996.309-.324 2.544-1.748z"/></svg>';
function $3b8b1dedf3cc6ac9$export$c6f809367786e4de({ size: size, label: label = 'Claude', testId: testId, type: type, UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bD1F5.ThirdPartyLogoWrapper), {
        markup: $3b8b1dedf3cc6ac9$var$markup,
        label: label,
        size: size,
        testId: testId,
        type: type,
        UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry
    });
}
module.exports["ClaudeIcon"] = $3b8b1dedf3cc6ac9$export$c6f809367786e4de;

});

parcelRegister("ctTo0", function(module, exports) {
/**
 * @generated SignedSource<<991ce2d939a58c458f86c450ce401fbc>>
 * @relayHash cfd6fa9dcb9e9305611fc3619dc85ec3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5c673b0736dce3bbc3183b766ba5dc60fdc106f9b1261efc2d3ca8806009b3f6
const $d7558363fe39fca1$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "enabled"
        },
        {
            "kind": "ScalarField",
            "name": "messageContent"
        }
    ], v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "ConfluenceAccessRequestSettingsConfiguration",
            "kind": "LinkedField",
            "name": "confluence_accessRequestSettings",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceAccessRequestSettings",
                    "kind": "LinkedField",
                    "name": "contentAccessRequestSettings",
                    "plural": false,
                    "selections": v1 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceAccessRequestSettings",
                    "kind": "LinkedField",
                    "name": "spaceAccessRequestSettings",
                    "plural": false,
                    "selections": v1 /*: any*/ 
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useAccessRequestSettingsQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useAccessRequestSettingsQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "cfd6fa9dcb9e9305611fc3619dc85ec3",
            "id": "5c673b0736dce3bbc3183b766ba5dc60fdc106f9b1261efc2d3ca8806009b3f6",
            "metadata": {},
            "name": "useAccessRequestSettingsQuery",
            "operationKind": "query",
            "text": "query useAccessRequestSettingsQuery($cloudId:ID!){confluence_accessRequestSettings(cloudId:$cloudId){contentAccessRequestSettings{enabled,messageContent},spaceAccessRequestSettings{enabled,messageContent}}}"
        }
    };
}();
$d7558363fe39fca1$var$node.hash = "a036ba125a56fbf2de00fed43babc58f";
var $d7558363fe39fca1$export$2e2bcd8739ae039 = $d7558363fe39fca1$var$node;
module.exports["default"] = $d7558363fe39fca1$export$2e2bcd8739ae039;

});

parcelRegister("kdKo9", function(module, exports) {
/**
 * @generated SignedSource<<f026ee318392a45fe95d1de0923dc1ed>>
 * @relayHash 8899b56f857af5bbb6a7740a976421fb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ccc3fed4f1272376987ab0969757e99e08b473a8f3181629a4d10c47646cafb7
const $04119cd59f78d958$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SpaceSettings",
                    "kind": "LinkedField",
                    "name": "settings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "routeOverrideEnabled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceRestrictionCheckQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceRestrictionCheckQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "8899b56f857af5bbb6a7740a976421fb",
            "id": "ccc3fed4f1272376987ab0969757e99e08b473a8f3181629a4d10c47646cafb7",
            "metadata": {},
            "name": "SpaceRestrictionCheckQuery",
            "operationKind": "query",
            "text": "query SpaceRestrictionCheckQuery($spaceKey:String!){space(key:$spaceKey){id,settings{routeOverrideEnabled}}}"
        }
    };
}();
$04119cd59f78d958$var$node.hash = "57291753cf0096ea57a2f2351520a494";
var $04119cd59f78d958$export$2e2bcd8739ae039 = $04119cd59f78d958$var$node;
module.exports["default"] = $04119cd59f78d958$export$2e2bcd8739ae039;

});

parcelRegister("dA1Sn", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $18ccf8477934fc9e$export$2a8604960d7d23d9 = 30000;
const $18ccf8477934fc9e$var$useTwoStageHydration = (name, enabled)=>{
    const fullCycleOutput = window.__FULLCYCLE__?.[name];
    const isNoFullCycleOutput = fullCycleOutput === undefined;
    const isNoSSR = !window.__SSR_RENDERED__;
    // Rely on a normal hydration/rendering flow when it's a transition or there's no full cycle output
    // or when experience is not hydratable
    const [hydrated, setHydrated] = (0, $cozmU.useState)(isNoSSR || isNoFullCycleOutput || !window.__HYDRATABLE__ || !enabled);
    (0, $cozmU.useEffect)(()=>{
        setHydrated(true);
        const cleanup = ()=>{
            delete window.__FULLCYCLE__?.[name];
        };
        // Arbitrary 30s CLEANUP_TIMEOUT to allow for the element to be rendered before removal
        // to not force an unecessary re-render or flash of blank content, even in slowest cases
        setTimeout(cleanup, $18ccf8477934fc9e$export$2a8604960d7d23d9);
        return cleanup;
    }, [
        name
    ]);
    return {
        hydrated: hydrated,
        fullCycleOutput: fullCycleOutput
    };
};
const $18ccf8477934fc9e$export$ca5d80b93e3e21b2 = ()=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals -- the saveFullCycleOutput() only runs in the browser
    const nodesForPartialHydration = document.querySelectorAll('[data-fullcycle-name]');
    if (nodesForPartialHydration.length > 0) window.__FULLCYCLE__ = Array.from(nodesForPartialHydration).reduce((acc, node)=>{
        acc[node.dataset.fullcycleName] = node.innerHTML;
        return acc;
    }, {});
};
const $18ccf8477934fc9e$export$137b13ff1789fa49 = (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { name: name, children: children, enabled: t1, ssrPlaceholder: t2 } = t0;
    const enabled = t1 === undefined ? false : t1;
    const ssrPlaceholder = t2 === undefined ? false : t2;
    const { hydrated: hydrated, fullCycleOutput: fullCycleOutput } = $18ccf8477934fc9e$var$useTwoStageHydration(name, enabled);
    if (!enabled) return children;
    if (hydrated) {
        let t3;
        if ($[0] !== name || $[1] !== ssrPlaceholder) {
            t3 = ssrPlaceholder ? {
                "data-ssr-placeholder": name,
                "data-ssr-placeholder-replace": name
            } : {};
            $[0] = name;
            $[1] = ssrPlaceholder;
            $[2] = t3;
        } else t3 = $[2];
        let t4;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
            t4 = {
                position: "relative",
                height: "100%",
                width: "100%"
            };
            $[3] = t4;
        } else t4 = $[3];
        let t5;
        if ($[4] !== children || $[5] !== name || $[6] !== t3) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                "data-testid": "two-stage-hydration",
                "data-fullcycle-name": name,
                ...t3,
                style: t4
            }, children);
            $[4] = children;
            $[5] = name;
            $[6] = t3;
            $[7] = t5;
        } else t5 = $[7];
        return t5;
    }
    const innerHTML = fullCycleOutput;
    let t3;
    if ($[8] !== name || $[9] !== ssrPlaceholder) {
        t3 = ssrPlaceholder ? {
            "data-ssr-placeholder": name,
            "data-ssr-placeholder-replace": name
        } : {};
        $[8] = name;
        $[9] = ssrPlaceholder;
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    if ($[11] !== innerHTML) {
        t4 = {
            __html: innerHTML
        };
        $[11] = innerHTML;
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
            position: "relative",
            height: "100%",
            width: "100%"
        };
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== name || $[15] !== t3 || $[16] !== t4) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "two-stage-hydration",
            "data-fullcycle-name": name,
            ...t3,
            dangerouslySetInnerHTML: t4,
            style: t5
        });
        $[14] = name;
        $[15] = t3;
        $[16] = t4;
        $[17] = t6;
    } else t6 = $[17];
    return t6;
};
const $18ccf8477934fc9e$export$b6db8e1e111c3550 = (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { name: name, children: children, enabled: t1, ssrPlaceholder: t2 } = t0;
    const enabled = t1 === undefined ? true : t1;
    const ssrPlaceholder = t2 === undefined ? false : t2;
    let t3;
    if ($[0] !== children || $[1] !== enabled || $[2] !== name || $[3] !== ssrPlaceholder) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($18ccf8477934fc9e$export$137b13ff1789fa49, {
            name: name,
            enabled: enabled,
            ssrPlaceholder: ssrPlaceholder
        }, children);
        $[0] = children;
        $[1] = enabled;
        $[2] = name;
        $[3] = ssrPlaceholder;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
};
module.exports["saveFullCycleOutput"] = $18ccf8477934fc9e$export$ca5d80b93e3e21b2;
module.exports["TwoStageHydration"] = $18ccf8477934fc9e$export$b6db8e1e111c3550;

});

parcelRegister("8dbvt", function(module, exports) {

var $cxMI6 = parcelRequire("cxMI6");

const $d8f8e39152f0bc27$export$19f6fc45ac74736 = (data, strategiesCounter)=>{
    const pageCardData = (0, $cxMI6.transformGlobalContent)(data.content);
    pageCardData.likesCount = 0;
    pageCardData.commentsCount = 0;
    pageCardData.recommendationStrategy = $d8f8e39152f0bc27$export$7c50bf2d337b5c51(data, strategiesCounter);
    return pageCardData;
};
const $d8f8e39152f0bc27$export$7c50bf2d337b5c51 = (data, strategiesCounter)=>{
    const strategies = data.strategy;
    if (strategies.includes('CONTENT_TO_CONTENT')) return 'CONTENT_TO_CONTENT';
    const currentCounter = new Map();
    strategies.forEach((entry)=>{
        const entryCount = strategiesCounter.get(entry) || 0;
        currentCounter.set(entry, entryCount);
    });
    const sortedCounter = new Map([
        ...currentCounter.entries()
    ].sort((a, b)=>a[1] - b[1]));
    const strategy = [
        ...sortedCounter.keys()
    ][0];
    const count = strategiesCounter.get(strategy) || 0;
    strategiesCounter.set(strategy, count + 1);
    return strategy;
};
const $d8f8e39152f0bc27$export$9c80c5ff7d0b31d7 = (recs)=>{
    if (!recs) return;
    const strategiesCounter = new Map();
    const recsSortedByStrategyCount = [
        ...recs
    ].sort((a, b)=>a.strategy.length > b.strategy.length ? 1 : -1);
    const transformedRecs = recsSortedByStrategyCount.map((rec)=>$d8f8e39152f0bc27$export$19f6fc45ac74736(rec, strategiesCounter));
    // return to initial order
    const pageCards = new Array();
    recs.forEach((rec)=>{
        const contentId = rec?.content?.id;
        if (!contentId) return;
        const el = transformedRecs.find((card)=>card?.id === contentId);
        if (el) pageCards.push(el);
    });
    return pageCards;
};
module.exports["transformEndOfPageRecContent"] = $d8f8e39152f0bc27$export$19f6fc45ac74736;
module.exports["transformAndOrderRecs"] = $d8f8e39152f0bc27$export$9c80c5ff7d0b31d7;

});

parcelRegister("cxMI6", function(module, exports) {

var $brn6e = parcelRequire("brn6e");


var $8rneB = parcelRequire("8rneB");


var $huWyw = parcelRequire("huWyw");


var $c7GB4 = parcelRequire("c7GB4");

const $c6273926c8df4325$var$ALL_CONTENT_TYPE = [
    'page',
    'blogpost',
    'whiteboard',
    'database',
    'embed',
    'folder',
    'slide'
];
const $c6273926c8df4325$var$resumeDraftWebUiBypass = (urlPath, content)=>{
    const bypassUrl = (0, $huWyw.getURLBypassingResumeDraftAction)({
        url: urlPath || '',
        spaceKey: content?.space?.alias || content?.space?.key || '',
        contentType: content?.type,
        editorVersion: content?.editorVersion?.nodes?.[0]?.value?.replace(/['"]+/g, ''),
        contentId: content?.id || '',
        noContextPath: true
    });
    return bypassUrl;
};
const $c6273926c8df4325$export$a0bd4958aceee288 = (content, untitledDraftText, isWhiteboardEmojiFGEnabled, isActivityV3HomeRecent)=>{
    const EMOJI_CONTENT_TYPE = isWhiteboardEmojiFGEnabled ? [
        'page',
        'blogpost',
        'embed',
        'whiteboard',
        'slide'
    ] : [
        'page',
        'blogpost',
        'embed'
    ];
    const contentType = $c6273926c8df4325$var$ALL_CONTENT_TYPE.includes(content?.type) ? content.type : 'page';
    if (isActivityV3HomeRecent) return {
        id: (0, $c7GB4.getIdFromConfluenceContentAri)({
            ari: content?.id,
            resourceType: contentType
        }) || '',
        status: content?.status === 'draft' || content?.status === 'unpublished' ? content?.status : undefined,
        // @ts-expect-error TODO FIXME there is some deep null mismatch, which might be worth fixing
        title: (0, $brn6e.getTitleAndEmoji)(content?.title, content?.metadata?.titleEmojiPublished?.value || '', content?.metadata?.titleEmojiDraft?.value || '', content?.status, untitledDraftText, EMOJI_CONTENT_TYPE.includes(contentType)),
        type: contentType,
        subType: content?.subtype,
        editorVersion: content?.editorVersion,
        links: {
            editui: $c6273926c8df4325$var$resumeDraftWebUiBypass(content?.links?.editUi, content),
            webui: $c6273926c8df4325$var$resumeDraftWebUiBypass(content?.links?.webUi, content)
        },
        isStarred: content?.viewer?.favoritedSummary?.isFavorite || false,
        likesCount: content?.likesSummary?.count || 0,
        commentsCount: content?.commentCountSummary?.total || 0,
        excerpt: content?.body?.excerpt?.trim()
    };
    return {
        id: content?.id || '',
        status: content?.status === 'draft' || content?.status === 'unpublished' ? content?.status : undefined,
        // @ts-expect-error TODO FIXME there is some deep null mismatch, which might be worth fixing
        title: (0, $brn6e.getTitleAndEmoji)(content?.title, (0, $8rneB.getEmojiPublishedFromProperties)(content), (0, $8rneB.getEmojiDraftFromProperties)(content), content?.status, untitledDraftText, EMOJI_CONTENT_TYPE.includes(contentType)),
        type: contentType,
        subType: content?.subType,
        editorVersion: content?.editorVersion,
        links: {
            editui: $c6273926c8df4325$var$resumeDraftWebUiBypass(content?.links?.editui, content),
            webui: $c6273926c8df4325$var$resumeDraftWebUiBypass(content?.links?.webui, content)
        },
        isStarred: content?.metadata?.currentuser?.favourited?.isFavourite || false,
        likesCount: content?.likes?.count || 0,
        commentsCount: content?.metadata?.comments?.commentsCount || 0,
        excerpt: content?.excerpt?.trim(),
        lastAction: {
            when: content?.metadata?.lastModifiedDate || '',
            action: 'updated'
        }
    };
};
const $c6273926c8df4325$export$898674fde3fd0597 = (content, untitledDraftText, isWhiteboardEmojiFGEnabled, isActivityV3HomeRecent = false)=>{
    const spaceAlias = content?.space?.alias || content?.space?.key;
    return {
        ...$c6273926c8df4325$export$a0bd4958aceee288(content, untitledDraftText, isWhiteboardEmojiFGEnabled, isActivityV3HomeRecent),
        space: {
            spaceKey: spaceAlias || '',
            name: content?.space?.name || ''
        },
        creatorId: content?.creatorId || '',
        history: {
            ownedBy: {
                displayName: content?.history?.ownedBy?.displayName || ''
            }
        }
    };
};
const $c6273926c8df4325$export$1e1d4cb60561af2b = (content, untitledDraftText = '', isWhiteboardEmojiFGEnabled = false)=>{
    const createdBy = content?.status === 'draft' ? content?.version?.by : content?.history?.createdBy;
    const ownedBy = content?.status === 'draft' ? content?.version?.by : content?.history?.ownedBy;
    return {
        ...$c6273926c8df4325$export$a0bd4958aceee288(content, untitledDraftText, isWhiteboardEmojiFGEnabled),
        createdBy: {
            displayName: createdBy?.displayName || '',
            profilePicture: createdBy?.profilePicture?.path || '',
            accountId: createdBy?.accountId || ''
        },
        ownedBy: {
            displayName: ownedBy?.displayName || '',
            profilePicture: ownedBy?.profilePicture?.path || '',
            accountId: ownedBy?.accountId || ''
        }
    };
};
const $c6273926c8df4325$export$ee67d5d6f48183b0 = (card)=>Boolean(card.createdBy);
module.exports["transformGlobalContent"] = $c6273926c8df4325$export$898674fde3fd0597;
module.exports["transformSpaceContent"] = $c6273926c8df4325$export$1e1d4cb60561af2b;
module.exports["isSpacePageCard"] = $c6273926c8df4325$export$ee67d5d6f48183b0;

});

parcelRegister("brn6e", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $7PLO8 = parcelRequire("7PLO8");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $6mKj3 = parcelRequire("6mKj3");


var $3shHM = parcelRequire("3shHM");


var $8rneB = parcelRequire("8rneB");


var $5DJsZ = parcelRequire("5DJsZ");


var $5amrO = parcelRequire("5amrO");

const $a7a7184e7345058e$export$8807f1cb55bf77de = async ({ userId: userId, cloudId: cloudId, emojiId: emojiId })=>{
    const provider = await (0, $8rneB.getEmojiProvider)(cloudId, userId);
    if (provider) {
        const emoji = await provider.findById(emojiId);
        if (emoji) return provider.loadMediaEmoji(emoji);
    }
    return Promise.resolve(null);
};
const $a7a7184e7345058e$export$66e71aac8865f81a = /([a-z\d_-]+):/;
let $a7a7184e7345058e$var$hasSetFavicon = false;
let $a7a7184e7345058e$var$previousFavicon = null;
const $a7a7184e7345058e$var$updateFaviconHref = (href)=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const favIcons = document.querySelectorAll("link[rel~='icon']");
    favIcons.forEach((linkEl)=>{
        // remember default favicon on first change in case we need to revert
        if (!$a7a7184e7345058e$var$hasSetFavicon) {
            $a7a7184e7345058e$var$previousFavicon = linkEl.href;
            $a7a7184e7345058e$var$hasSetFavicon = true;
        }
        linkEl.href = href;
    });
};
const $a7a7184e7345058e$export$4bb2c221b7e4cc0 = (emoji)=>{
    if (!(0, $iDrrr.fg)('confluence_emoji_title_favicon')) return;
    if (!emoji) {
        if ($a7a7184e7345058e$var$hasSetFavicon && $a7a7184e7345058e$var$previousFavicon) $a7a7184e7345058e$var$updateFaviconHref($a7a7184e7345058e$var$previousFavicon);
        return;
    }
    $a7a7184e7345058e$var$updateFaviconHref(emoji);
};
const $a7a7184e7345058e$export$ea48fb6f63107646 = async ({ selectedEmoji: selectedEmoji, emojiProvider: emojiProvider, onUpdateStartEmoji: onUpdateStartEmoji, createAnalyticsEvent: createAnalyticsEvent, emojiTitleState: emojiTitleState, onEmojiUpdated: onEmojiUpdated, onUpdateEndEmoji: onUpdateEndEmoji, updateContentProperty: updateContentProperty, contentId: contentId, componentName: componentName, isLivePage: isLivePage, emojiStatusFieldName: emojiStatusFieldName, aiSuggestedEmojiId: aiSuggestedEmojiId, isSmartCreate: isSmartCreate, hasReplacedAIFCEmoji: hasReplacedAIFCEmoji, setHasReplacedAIFCEmoji: setHasReplacedAIFCEmoji, aiEmojiSuggestionSource: aiEmojiSuggestionSource }, _event)=>{
    onUpdateStartEmoji && onUpdateStartEmoji();
    // Snapshot before overwrite to detect if the AIFC-suggested emoji was replaced.
    const previouslySelectedEmoji = emojiTitleState.state.selectedEmoji;
    const previouslySelectedEmojiId = typeof previouslySelectedEmoji === 'string' ? previouslySelectedEmoji : previouslySelectedEmoji?.id;
    const replacedAIFCSuggestedEmoji = !hasReplacedAIFCEmoji && !!isSmartCreate && !!aiSuggestedEmojiId && previouslySelectedEmojiId === aiSuggestedEmojiId;
    if (replacedAIFCSuggestedEmoji) setHasReplacedAIFCEmoji?.(true);
    const replacedBlankPageAutoSuggestedEmoji = !hasReplacedAIFCEmoji && aiEmojiSuggestionSource === 'pasteAutoTitle' && !!aiSuggestedEmojiId && previouslySelectedEmojiId === aiSuggestedEmojiId;
    if (replacedBlankPageAutoSuggestedEmoji) setHasReplacedAIFCEmoji?.(true);
    const replacedSuggestTitleSuggestedEmoji = !hasReplacedAIFCEmoji && aiEmojiSuggestionSource === 'suggestTitle' && !!aiSuggestedEmojiId && previouslySelectedEmojiId === aiSuggestedEmojiId;
    if (replacedSuggestTitleSuggestedEmoji) setHasReplacedAIFCEmoji?.(true);
    // Snapshot the shared flag at fire time so the value reflects the latest
    // state regardless of when/where the picker JSX was created.
    const justRestoredEmoji = !!emojiTitleState.justRestoredEmoji;
    (0, $3shHM.sendAnalyticsEvent)(createAnalyticsEvent, {
        eventType: 'sendUIEvent',
        element: 'button',
        action: 'clicked',
        actionSubject: 'emojiPicker',
        actionSubjectId: 'emoji',
        attributes: {
            emojiId: selectedEmoji?.id,
            inputMethod: 'title',
            isLivePage: isLivePage,
            replacedAIFCSuggestedEmoji: replacedAIFCSuggestedEmoji,
            replacedBlankPageAutoSuggestedEmoji: replacedBlankPageAutoSuggestedEmoji,
            replacedSuggestTitleSuggestedEmoji: replacedSuggestTitleSuggestedEmoji,
            aiEmojiSuggestionSource: aiEmojiSuggestionSource,
            isRestoreLatestEmojiEnabled: (0, $6mKj3.isExperimentEnabled)('cc_page_experiences_livedocs_restore_latest_emoji'),
            replacedRestoredEmoji: justRestoredEmoji
        }
    });
    // Reset after firing so the next selection correctly reports
    // replacedRestoredEmoji=false.
    emojiTitleState.justRestoredEmoji = false;
    const propertyKey = (0, $5amrO.convertEmojiFieldNameToPropertyKey)(emojiStatusFieldName);
    const loadedEmoji = await emojiProvider.loadMediaEmoji(selectedEmoji, true);
    emojiTitleState.setOpenSecondEmojiPicker(false);
    emojiTitleState.setSelectedEmoji(loadedEmoji);
    return onEmojiUpdated().then(({ data: data })=>{
        const versionNumber = (0, $8rneB.getVersionNumber)(data, emojiStatusFieldName);
        const newVersionNumber = versionNumber ? versionNumber + 1 : 1;
        const emojiValue = selectedEmoji?.id?.replace(/['"]+/g, '') ?? '';
        return updateContentProperty({
            propertyKey: propertyKey,
            propertyValue: emojiValue,
            hasExistingProperty: versionNumber > 0,
            options: {
                update: ()=>{
                    try {
                        const cacheData = (0, $l1uFv.readQueryInterop)({
                            query: (0, $5DJsZ.default),
                            variables: {
                                contentId: contentId,
                                status: [
                                    'current',
                                    'draft'
                                ],
                                skipPublishedFragment: true,
                                draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                            },
                            __callerPackage__: "emoji-title"
                        });
                        if (cacheData.content.nodes[0][emojiStatusFieldName]) cacheData.content.nodes[0][emojiStatusFieldName].nodes[0] = {
                            ...cacheData.content.nodes[0][emojiStatusFieldName].nodes[0],
                            id: contentId,
                            key: propertyKey,
                            value: emojiValue,
                            version: {
                                number: newVersionNumber,
                                __typename: 'Version'
                            }
                        };
                        (0, $fEmGS.writeQueryInterop)({
                            query: (0, $5DJsZ.default),
                            variables: {
                                contentId: contentId,
                                status: [
                                    'current',
                                    'draft'
                                ],
                                skipPublishedFragment: true,
                                draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                            },
                            data: data,
                            __callerPackage__: "emoji-title"
                        });
                    } catch (error) {
                        throw new Error(`${componentName} failed to write to cache while updating ${propertyKey} content property after user selecting emoji ${error.message}`);
                    }
                }
            },
            shouldOptimisticResponse: true
        }).then(()=>{
            onUpdateEndEmoji && onUpdateEndEmoji();
            emojiTitleState.setSelectedEmoji(loadedEmoji);
        }).catch((error)=>{
            throw new Error(`${componentName} failed to update ${propertyKey} content property after user selecting emoji ${error.message}`);
        });
    });
};
const $a7a7184e7345058e$export$fbfb144f0da80edc = (_event, { onUpdateStartEmoji: onUpdateStartEmoji, onUpdateEndEmoji: onUpdateEndEmoji, onEmojiUpdated: onEmojiUpdated, contentId: contentId, updateContentProperty: updateContentProperty, componentName: componentName = '', emojiStatusFieldName: emojiStatusFieldName })=>{
    onUpdateStartEmoji && onUpdateStartEmoji();
    const propertyKey = (0, $5amrO.convertEmojiFieldNameToPropertyKey)(emojiStatusFieldName);
    return onEmojiUpdated().then(()=>{
        return updateContentProperty({
            propertyKey: propertyKey,
            isDelete: true,
            options: {
                update: ()=>{
                    try {
                        const data = (0, $l1uFv.readQueryInterop)({
                            query: (0, $5DJsZ.default),
                            variables: {
                                contentId: contentId,
                                status: [
                                    'current',
                                    'draft'
                                ],
                                skipPublishedFragment: true,
                                draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                            },
                            __callerPackage__: "emoji-title"
                        });
                        data.content.nodes[0][emojiStatusFieldName] = {
                            nodes: [],
                            __typename: 'PaginatedJsonContentPropertyList'
                        };
                        (0, $fEmGS.writeQueryInterop)({
                            query: (0, $5DJsZ.default),
                            variables: {
                                contentId: contentId,
                                status: [
                                    'current',
                                    'draft'
                                ],
                                skipPublishedFragment: true,
                                draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                            },
                            data: data,
                            __callerPackage__: "emoji-title"
                        });
                    } catch (error) {
                        throw new Error(`${componentName} failed to write to cache while updating content property after user removing emoji ${error.message}`);
                    }
                }
            },
            shouldOptimisticResponse: true
        }).finally(()=>{
            onUpdateEndEmoji && onUpdateEndEmoji();
        }).catch((error)=>{
            throw new Error(`${componentName} failed to update ${propertyKey} content property after user removing emoji ${error.message}`);
        });
    });
};
const $a7a7184e7345058e$export$8c0236acf4c550c0 = RegExp("^(\\p{RI}\\p{RI}|\\p{Extended_Pictographic}(\\p{Emoji_Modifier}|\\u{FE0F}\\u{20E3}?|[\\u{E0020}-\\u{E007E}]+\\u{E007F})?(\\u{200D}\\p{Extended_Pictographic}(\\p{Emoji_Modifier}|\\u{FE0F}\\u{20E3}?|[\\u{E0020}-\\u{E007E}]+\\u{E007F})?)*)", "u");
const $a7a7184e7345058e$export$cb9bb843138d9261 = (title)=>title && title.replace($a7a7184e7345058e$export$8c0236acf4c550c0, '').trimLeft() || '';
const $a7a7184e7345058e$export$9d1875ac2476f6b6 = (title)=>title && $a7a7184e7345058e$export$8c0236acf4c550c0.exec(title)?.[0] || '';
const $a7a7184e7345058e$export$388f90f8e727e4d5 = (rawTitle = '', rawPublishedEmoji = '', rawDraftEmoji = '', status = '', untitledDraftText = '', getEmoji = true)=>{
    const nativeEmoji = getEmoji ? $a7a7184e7345058e$export$9d1875ac2476f6b6(rawTitle) : '';
    let selectedEmoji = '';
    if (getEmoji) selectedEmoji = status?.toLowerCase() === 'draft' ? rawDraftEmoji : rawPublishedEmoji;
    const hasNativeEmoji = nativeEmoji.length > 0;
    const hasSelectedEmoji = selectedEmoji.length > 0;
    const emoji = hasSelectedEmoji ? selectedEmoji : nativeEmoji;
    let text = hasNativeEmoji && !hasSelectedEmoji ? $a7a7184e7345058e$export$cb9bb843138d9261(rawTitle) : rawTitle;
    if (status === 'draft' && !text) text = untitledDraftText;
    return {
        text: text,
        emoji: emoji,
        selectedEmoji: selectedEmoji
    };
};
module.exports["getEmojiFromEmojiId"] = $a7a7184e7345058e$export$8807f1cb55bf77de;
module.exports["maybeOverrideFaviconWithEmoji"] = $a7a7184e7345058e$export$4bb2c221b7e4cc0;
module.exports["onSelectEmoji"] = $a7a7184e7345058e$export$ea48fb6f63107646;
module.exports["onRemoveEmoji"] = $a7a7184e7345058e$export$fbfb144f0da80edc;
module.exports["emojiExp"] = $a7a7184e7345058e$export$8c0236acf4c550c0;
module.exports["removeEmojiFromTitle"] = $a7a7184e7345058e$export$cb9bb843138d9261;
module.exports["getEmojiFromTitle"] = $a7a7184e7345058e$export$9d1875ac2476f6b6;
module.exports["getTitleAndEmoji"] = $a7a7184e7345058e$export$388f90f8e727e4d5;

});

parcelRegister("3shHM", function(module, exports) {

var $c0rhi = parcelRequire("c0rhi");


var $8rneB = parcelRequire("8rneB");


var $5amrO = parcelRequire("5amrO");


var $5DJsZ = parcelRequire("5DJsZ");

const $d6c558249b167bda$export$5e53520e517ec9ab = (createAnalyticsEvent, { eventType: eventType, element: element, action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes = {} })=>{
    createAnalyticsEvent({
        type: eventType,
        data: {
            action: action,
            source: 'EmojiTitleSection',
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: {
                element: element,
                ...attributes
            }
        }
    }).fire();
};
const $d6c558249b167bda$export$1fa99c5c7c4cc530 = async ({ createAnalyticsEvent: createAnalyticsEvent, contentId: contentId, isLivePage: isLivePage })=>{
    const { data: data } = await (0, $c0rhi.queryInterop)({
        query: (0, $5DJsZ.default),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ],
            skipPublishedFragment: false
        },
        __callerPackage__: "emoji-title"
    });
    const emojiId = (0, $8rneB.getEmojiId)(data, (0, $5amrO.EMOJI_TITLE_DRAFT_FIELD));
    const hasDraftEmoji = emojiId.length >= 0 && emojiId !== '';
    // only track draft with emoji
    if (hasDraftEmoji) $d6c558249b167bda$export$5e53520e517ec9ab(createAnalyticsEvent, {
        eventType: 'sendTrackEvent',
        element: '',
        action: 'created',
        actionSubject: 'draftWithEmoji',
        actionSubjectId: '',
        attributes: {
            emojiId: emojiId,
            isLivePage: isLivePage
        }
    });
};
const $d6c558249b167bda$export$5a8401d422e6e576 = ({ createAnalyticsEvent: createAnalyticsEvent, emoji: emoji, context: context, error: error = {
    message: ''
}, isLivePage: isLivePage })=>{
    $d6c558249b167bda$export$5e53520e517ec9ab(createAnalyticsEvent, {
        eventType: 'sendTrackEvent',
        element: 'emoji',
        action: 'error',
        actionSubject: 'renderEmoji',
        actionSubjectId: 'renderEmojiError',
        attributes: {
            emojiShortName: emoji && emoji.shortName,
            emojiId: emoji && emoji.id,
            context: context,
            errorMessage: error.message,
            isLivePage: isLivePage
        }
    });
};
module.exports["sendAnalyticsEvent"] = $d6c558249b167bda$export$5e53520e517ec9ab;
module.exports["trackDraftCreatedWithEmoji"] = $d6c558249b167bda$export$1fa99c5c7c4cc530;
module.exports["onFailedToLoadEmoji"] = $d6c558249b167bda$export$5a8401d422e6e576;

});

parcelRegister("huWyw", function(module, exports) {

var $jlIaF = parcelRequire("jlIaF");

const $61f50eb1c9d5c417$export$35f6369946b1d8c9 = ({ url: url, spaceKey: spaceKey, contentType: contentType, editorVersion: editorVersion, contentId: contentId, fabricEditorSupported: fabricEditorSupported, noContextPath: noContextPath })=>{
    const isPage = contentType === 'page';
    const isBlog = contentType === 'blogpost';
    const isPageOrBlog = isPage || isBlog;
    const isUsingFabricEditor = fabricEditorSupported || editorVersion === 'v2'; // as opposed to the v1 TinyMCE editor
    const providedURLHitsResumeDraftAction = url.includes('resumedraft.action');
    if (isPageOrBlog && isUsingFabricEditor && providedURLHitsResumeDraftAction) {
        const contentTypeForURL = isPage ? 'pages' : 'blog';
        const contentIdForURL = contentId;
        // Extract the query string from the relative URL.
        const queryString = url.includes('?') ? url.slice(url.indexOf('?') + 1) : '';
        // Extract the `draftShareId` from the query string.
        const urlSearchParams = new URLSearchParams(queryString);
        const draftShareId = urlSearchParams.get('draftShareId');
        const draftShareIdParamString = draftShareId ? `draftShareId=${draftShareId}` : '';
        const optionalContextPath = noContextPath ? '' : (0, $jlIaF.CONTEXT_PATH);
        const bypassURL = `${optionalContextPath}/spaces/${spaceKey}/${contentTypeForURL}/edit-v2/${contentIdForURL}?${draftShareIdParamString}`;
        return bypassURL;
    } else return url;
};
module.exports["getURLBypassingResumeDraftAction"] = $61f50eb1c9d5c417$export$35f6369946b1d8c9;

});

parcelRegister("c7GB4", function(module, exports) {

var $5BvyC = parcelRequire("5BvyC");

var $lT7Mv = parcelRequire("lT7Mv");

var $k0a0F = parcelRequire("k0a0F");

var $bAV6O = parcelRequire("bAV6O");

var $8jDil = parcelRequire("8jDil");

var $dLbqW = parcelRequire("dLbqW");

var $7GbwS = parcelRequire("7GbwS");


var $1ggpj = parcelRequire("1ggpj");

const $c96e0d62cf176fc6$export$84dfa7fadd8a006b = ({ ari: ari, resourceType: resourceType })=>{
    if (!ari) return null;
    switch(resourceType){
        case (0, $1ggpj.ContentType).PAGE:
            return (0, $8jDil.ConfluencePageAri).parse(ari).pageId;
        case (0, $1ggpj.ContentType).BLOGPOST:
            return (0, $5BvyC.ConfluenceBlogpostAri).parse(ari).blogpostId;
        case (0, $1ggpj.ContentType).WHITEBOARD:
            return (0, $7GbwS.ConfluenceWhiteboardAri).parse(ari).whiteboardId;
        case (0, $1ggpj.ContentType).DATABASE:
            return (0, $lT7Mv.ConfluenceDatabaseAri).parse(ari).databaseId;
        case (0, $1ggpj.ContentType).EMBED:
            return (0, $k0a0F.ConfluenceEmbedAri).parse(ari).embedId;
        case (0, $1ggpj.ContentType).FOLDER:
            return (0, $bAV6O.ConfluenceFolderAri).parse(ari).folderId;
        case (0, $1ggpj.ContentType).SLIDE:
            return (0, $dLbqW.ConfluenceSlideAri).parse(ari).slideId;
    }
};
module.exports["getIdFromConfluenceContentAri"] = $c96e0d62cf176fc6$export$84dfa7fadd8a006b;

});

parcelRegister("dLbqW", function(module, exports) {

var $1AG0i = parcelRequire("1AG0i");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/confluence/slide/manifest.ts
var $a04888a2b5576260$var$confluenceSlideAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $1AG0i.ConfluenceSlideAriResourceOwner),
    resourceType: (0, $1AG0i.ConfluenceSlideAriResourceType),
    resourceIdSlug: "activation/{activationId}/{slideId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        slideId: /[0-9]+/
    }
};
// src/confluence/slide/index.ts
var $a04888a2b5576260$export$86048ac46024146a = class _ConfluenceSlideAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get slideId() {
        return this._slideId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $a04888a2b5576260$var$confluenceSlideAriStaticOpts.qualifier,
            platformQualifier: $a04888a2b5576260$var$confluenceSlideAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $a04888a2b5576260$var$confluenceSlideAriStaticOpts.resourceOwner,
            resourceType: $a04888a2b5576260$var$confluenceSlideAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.slideId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                slideId: opts.slideId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $a04888a2b5576260$var$confluenceSlideAriStaticOpts);
        return new _ConfluenceSlideAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $a04888a2b5576260$var$confluenceSlideAriStaticOpts);
        return new _ConfluenceSlideAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            slideId: this.slideId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._slideId = opts.resourceIdSegmentValues.slideId;
    }
};
module.exports["ConfluenceSlideAri"] = $a04888a2b5576260$export$86048ac46024146a;

});

parcelRegister("1AG0i", function(module, exports) {
// src/confluence/slide/types.ts
var $1289bc4ba87a8942$export$204fa7edd529d4b3 = "confluence", $1289bc4ba87a8942$export$3de52c55a164daa4 = "slide";
module.exports["ConfluenceSlideAriResourceOwner"] = $1289bc4ba87a8942$export$204fa7edd529d4b3;
module.exports["ConfluenceSlideAriResourceType"] = $1289bc4ba87a8942$export$3de52c55a164daa4;

});

parcelRegister("kcIQr", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $9DHhW = parcelRequire("9DHhW");

const $8f5ec29d1cc276d5$export$b8af4dbcbdf99d70 = ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t0;
    if ($[0] !== createAnalyticsEvent) {
        t0 = (payload)=>createAnalyticsEvent(payload);
        $[0] = createAnalyticsEvent;
        $[1] = t0;
    } else t0 = $[1];
    const createEvent = t0;
    let t1;
    if ($[2] !== createEvent) {
        t1 = {
            createEvent: createEvent
        };
        $[2] = createEvent;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
};
module.exports["useConfluenceAnalyticsEvents"] = $8f5ec29d1cc276d5$export$b8af4dbcbdf99d70;

});

parcelRegister("f7MuR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $60cDW = parcelRequire("60cDW");


var $dcJRl = parcelRequire("dcJRl");

const $26d702ce000cc6e9$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $26d702ce000cc6e9$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                loading: true,
                error: null
            });
        },
    success: (data)=>({ setState: setState })=>{
            setState({
                data: data,
                loading: false,
                error: null
            });
        },
    error: (err)=>({ setState: setState })=>{
            setState({
                error: err,
                loading: false
            });
        }
};
const $26d702ce000cc6e9$export$39f521003d60a645 = (0, $8s9DV.createStore)({
    initialState: $26d702ce000cc6e9$var$initialState,
    actions: $26d702ce000cc6e9$var$actions,
    name: 'siteUserTraitsStore'
});
const $26d702ce000cc6e9$export$55703aaacc066827 = (0, $kBr4q.createHook)($26d702ce000cc6e9$export$39f521003d60a645);
const $26d702ce000cc6e9$export$60cc1c45e628d86f = (0, $kBr4q.createActionsHook)($26d702ce000cc6e9$export$39f521003d60a645);
async function $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId) {
    const res = await (0, $f7B1p.cfetch)(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`, {
        method: 'GET'
    });
    if (!res.ok) {
        const text = await res.text().catch(()=>'');
        throw new Error(`Request failed with ${res.status}: ${text || res.statusText}`);
    }
    return await res.json();
}
// Use a module-level variable to ensure we only fetch once per app lifecycle
// This way multiple components using the hook won't trigger multiple fetches
let $26d702ce000cc6e9$var$hasFetched = false;
function $26d702ce000cc6e9$export$f1fbc6ad89f91b89() {
    $26d702ce000cc6e9$var$hasFetched = false;
}
function $26d702ce000cc6e9$var$getSiteUserTraitsFromSources() {
    let attributes = null;
    // First check window.__SSR_TAP_CONTEXT__ which contains raw tapContext data
    if (typeof window !== 'undefined' && window.__SSR_TAP_CONTEXT__) {
        attributes = (0, $dcJRl.formatTapTraits)(window.__SSR_TAP_CONTEXT__.siteUser);
        if (attributes) return {
            attributes: attributes
        };
    }
    // Fallback to getSSRRenderInputs() for SSR scenarios
    const { tapContext: tapContext } = (0, $60cDW.getSSRRenderInputs)();
    attributes = (0, $dcJRl.formatTapTraits)(tapContext?.siteUser);
    if (attributes) return {
        attributes: attributes
    };
    return null;
}
function $26d702ce000cc6e9$export$f02520a2cf0afa96({ skip: skip, skipBootstrap: skipBootstrap, fetchPolicy: fetchPolicy = 'cache-first' } = {}) {
    // skip=true -> full idle, no preload/store/fetch
    const preloadedData = (0, $cozmU.useMemo)(()=>skip ? null : $26d702ce000cc6e9$var$getSiteUserTraitsFromSources(), [
        skip
    ]);
    const [storeState, storeActions] = $26d702ce000cc6e9$export$55703aaacc066827();
    const { accessStatus: accessStatus, cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = accessStatus === 'LICENSED_USE_ACCESS' || accessStatus === 'LICENSED_ADMIN_ACCESS';
    // Track whether cache-and-network fetch dispatched this mount
    const fetchDispatchedRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (skip) return;
        if (!cloudId || !userId) return;
        if (skipBootstrap) return;
        if (!hasLicensedAccess) return;
        if (fetchPolicy === 'cache-first') {
            // Old behavior: don't fetch if we have data from any source
            if (preloadedData || storeState.data || storeState.loading || storeState.error) return;
            if ($26d702ce000cc6e9$var$hasFetched) return;
            $26d702ce000cc6e9$var$hasFetched = true;
            storeActions.start();
            $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId).then((data)=>storeActions.success(data), (err)=>storeActions.error(err));
        } else {
            // cache-and-network: fetch once per mount
            if (storeState.loading) {
                fetchDispatchedRef.current = true;
                return;
            }
            if (fetchDispatchedRef.current) return;
            fetchDispatchedRef.current = true;
            storeActions.start();
            $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId).then((data)=>storeActions.success(data), (err)=>storeActions.error(err));
        }
    }, [
        skip,
        skipBootstrap,
        fetchPolicy,
        cloudId,
        userId,
        hasLicensedAccess,
        preloadedData,
        storeState,
        storeActions
    ]);
    if (skip) return {
        data: null,
        loading: false,
        error: null
    };
    // Fetched store result wins over preloaded data
    if (storeState.data) return {
        data: storeState.data,
        loading: storeState.loading,
        error: storeState.error
    };
    if (preloadedData) return {
        data: preloadedData,
        loading: storeState.loading,
        error: null
    };
    return {
        data: null,
        loading: storeState.loading,
        error: storeState.error
    };
}
module.exports["useSiteUserTraits"] = $26d702ce000cc6e9$export$f02520a2cf0afa96;

});

parcelRegister("hSHWm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $d1e7679282bf3961$export$8b4809eaf655f286 = /*#__PURE__*/ (0, $cozmU.createContext)({});
module.exports["CoreInvitesContext"] = $d1e7679282bf3961$export$8b4809eaf655f286;

});

parcelRegister("hrAmX", function(module, exports) {

var $a4dgs = parcelRequire("a4dgs");


var $8zRYE = parcelRequire("8zRYE");


var $jecot = parcelRequire("jecot");

const $6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME = 'ServerRenderedBanners';
const $6ee3834dea9f6c5c$export$f7df67e8f3ba0620 = (name, inArray)=>inArray.findIndex((banner)=>banner.name === name);
class $6ee3834dea9f6c5c$export$bbac707b3ebb5681 extends (0, $a4dgs.BaseStateContainer) {
    constructor(props = {}){
        super();
        // Resolved unconditionally, even when it is about to be discarded, so that exposure for the
        // nav-height flags is unchanged from before this was extracted into a helper.
        /** Frozen at construction: a mid-session flag flip must not change an instance's arithmetic. */ this.topNavHeight = void 0;
        this.suppressed = void 0;
        this.pendingNotify = null;
        this.unsubscribeFromStore = null;
        this.state = {
            banners: []
        };
        this._updateServerRenderedBanners = (spaBannerHeight)=>{
            if (spaBannerHeight === 0) this.hide($6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME);
            else this.show($6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME, spaBannerHeight);
        };
        /**
     * Adds or updates the specified banner in the list of visible banners.
     * Add the banner is not already in the list, otherwise update the banner's height.
     * Applied on the next microtask; a suppressed container drops the write entirely.
     *
     * @param {string} name Unique name of the banner
     * @param {number} height Height of the banner, in pixels
     */ this.show = (name, height)=>{
            if (this.suppressed) return;
            (0, $8zRYE.showBanner)(name, height);
        };
        /**
     * Removes the specified banner from the list of visible banners
     * Remove the banner if it is in the list, do nothing it is not
     *
     * @param {string} name Unique name of the banner
     */ this.hide = (name)=>{
            if (this.suppressed) return;
            (0, $8zRYE.hideBanner)(name);
        };
        /**
     * Returns the combined height of all banners in the list.
     * @param {boolean} includeTopNav Include `TOP_NAV_HEIGHT` in the calculation
     * if not `false`
     * @returns {number} Combined height of all visible banners
     */ this.getTotalHeight = (includeTopNav)=>this.state.banners.reduce((totalOffset, banner)=>totalOffset + banner.height, includeTopNav !== false ? this.topNavHeight : 0);
        /**
     * Returns list of all banners in visible list in "-" seperated string.
     * @returns {string} Combined names of all banners in visible list seperated by "-"
     */ this.getBannerList = ()=>this.state.banners.map((banner)=>banner.name).join('-');
        /**
     * Detaches from the store. unstated gives containers no teardown hook, so any caller that creates
     * short-lived containers — fixtures, tests, anything mounted more than once — must call this, or
     * the store keeps the listener and with it this instance alive for the lifetime of the module.
     */ this.destroy = ()=>{
            this.unsubscribeFromStore?.();
            this.unsubscribeFromStore = null;
        };
        this.scheduleNotify = ()=>{
            if (this.pendingNotify) return;
            this.pendingNotify = Promise.resolve().then(()=>{
                this.pendingNotify = null;
                return this.notifyListeners();
            });
        };
        const navHeight = (0, $jecot.resolveTopNavHeight)();
        this.topNavHeight = props.hasTopNav === false ? 0 : navHeight;
        this.suppressed = props.suppressed === true;
        if (this.suppressed) return;
        (0, $8zRYE.seedBanners)(props.initialState?.banners ?? []);
        this.state = {
            banners: (0, $8zRYE.getBanners)()
        };
        // The mirror is synchronous so a read straight after a flush is fresh; the notification is
        // coalesced, so a tick's worth of store changes costs one round no matter which container
        // (or hook) wrote them.
        this.unsubscribeFromStore = (0, $8zRYE.subscribeToBanners)(()=>{
            this.state = {
                banners: (0, $8zRYE.getBanners)()
            };
            this.scheduleNotify();
        });
    }
}
module.exports["findBanner"] = $6ee3834dea9f6c5c$export$f7df67e8f3ba0620;
module.exports["BannerStateContainer"] = $6ee3834dea9f6c5c$export$bbac707b3ebb5681;

});

parcelRegister("a4dgs", function(module, exports) {
// unstated is deprecated; new banner state belongs in src/bannerStore.ts
// eslint-disable-next-line no-restricted-imports

var $kNIYN = parcelRequire("kNIYN");

class $5ed4587dbe3a0e20$export$5db0f71585d91cd4 extends (0, $kNIYN.Container) {
    subscribe(fn) {
        this.listeners.add(fn);
    }
    unsubscribe(fn) {
        this.listeners.delete(fn);
    }
    setState(updater, callback) {
        return Promise.resolve().then(()=>{
            const next = typeof updater === 'function' ? updater(this.state) : updater;
            if (next == null) {
                callback?.();
                return;
            }
            this.state = Object.assign({}, this.state, next);
            return this.notifyListeners().then(()=>{
                callback?.();
            });
        });
    }
    notifyListeners() {
        // Snapshot before notifying: a listener's re-render makes unstated's Subscribe unsubscribe
        // and resubscribe, which would mutate the Set mid-iteration.
        const snapshot = Array.from(this.listeners);
        return Promise.all(snapshot.map((listener)=>listener())).then(()=>undefined);
    }
    constructor(...args){
        super(...args);
        this.listeners = new Set();
    }
}
module.exports["BaseStateContainer"] = $5ed4587dbe3a0e20$export$5db0f71585d91cd4;

});

parcelRegister("8zRYE", function(module, exports) {

var $i3jcY = parcelRequire("i3jcY");

/**
 * Module store for the page-top banner stack, read through `useSyncExternalStore`.
 *
 * A module store, not a library: see `docs/llm/agent-instructions/common/state-management.md`.
 *
 * Writes are deferred to a microtask and coalesced here rather than in any caller, so every writer —
 * the container shim and the `useBannerState` hooks — inherits it. Notification is synchronous and
 * several banners still call `show`/`hide` from a render body, so an undeferred write would update
 * other components mid-render.
 *
 * Global and unscoped: only three production containers exist — the client root, the SSR root
 * (mutually exclusive with it), and `WithoutBanners`, which is write-free and read-once.
 *
 * SSR: Tesseract isolates each request, so module state is per-request. `handleReactRender.tsx`
 * serialises the server's list into `window.__SSR_BANNERS__`, which this store reads at module init,
 * so the first render — including the hydrating one — matches the server without waiting on a
 * container. The server has no such global, so its seed is an explicit `seedBanners` call from the
 * SSR entry point; that keeps `ssrBannerManager` out of this module.
 *
 * `stableUI=1` (E2E/VR runs) is honoured here, at all three entry points that can change `banners`,
 * rather than in each writer: `ssrBannerManager` registers banners regardless of the URL param, so
 * an unguarded hydration seed would give a hydrating render banners the SSR render dropped, and the
 * `useBannerState` hooks never see the param at all.
 */ /** Frozen so a consumer cannot mutate it, and stable so `getSnapshot` never triggers a re-render. */ const $827d62b6188a5818$var$NO_BANNERS = Object.freeze([]);
/**
 * Read at module init rather than from a component, so the store is populated before anything
 * renders. Entries are validated because the value is deserialised from the page.
 *
 * No `typeof window` guard: the build substitutes `globalThis`, so `window` is always defined in both
 * environments. On the server the property simply is not set, which the `Array.isArray` check already
 * covers — the server seed comes from `seedBanners` instead.
 */ const $827d62b6188a5818$var$readHydrationBanners = ()=>{
    // `Array.isArray` is deliberately first: it short-circuits on the server, where the global is
    // never set, so the request URI — not available this early in module evaluation — is never read.
    if (!Array.isArray(window.__SSR_BANNERS__) || (0, $i3jcY.isStableUIEnabledForTests)()) return $827d62b6188a5818$var$NO_BANNERS;
    const parsed = window.__SSR_BANNERS__.filter((banner)=>typeof banner?.name === 'string' && typeof banner?.height === 'number');
    return parsed.length > 0 ? parsed : $827d62b6188a5818$var$NO_BANNERS;
};
let $827d62b6188a5818$var$banners = $827d62b6188a5818$var$readHydrationBanners();
const $827d62b6188a5818$var$listeners = new Set();
const $827d62b6188a5818$export$49fd326b255f6ddb = ()=>$827d62b6188a5818$var$banners;
const $827d62b6188a5818$export$7cfac2c025b473e4 = (listener)=>{
    $827d62b6188a5818$var$listeners.add(listener);
    return ()=>{
        $827d62b6188a5818$var$listeners.delete(listener);
    };
};
const $827d62b6188a5818$var$commit = (next)=>{
    $827d62b6188a5818$var$banners = next;
    // Snapshot first: a listener may unsubscribe while being notified.
    Array.from($827d62b6188a5818$var$listeners).forEach((listener)=>listener());
};
let $827d62b6188a5818$var$pending = [];
let $827d62b6188a5818$var$pendingFlush = null;
const $827d62b6188a5818$var$enqueue = (mutate)=>{
    // Evaluated per call rather than memoised at module init: an SPA transition changes
    // `window.location.search`, so the param is not a session constant.
    // Hides are dropped along with shows, which is safe because nothing can enter the store.
    if ((0, $i3jcY.isStableUIEnabledForTests)()) return;
    $827d62b6188a5818$var$pending.push(mutate);
    if ($827d62b6188a5818$var$pendingFlush) return;
    $827d62b6188a5818$var$pendingFlush = Promise.resolve().then(()=>{
        $827d62b6188a5818$var$pendingFlush = null;
        const queued = $827d62b6188a5818$var$pending;
        $827d62b6188a5818$var$pending = [];
        let next = $827d62b6188a5818$var$banners;
        let changed = false;
        for (const run of queued){
            // Applied against the running value, not the pre-flush one, so a name shown twice in a tick
            // resolves against the first write rather than duplicating.
            const result = run(next);
            if (result === undefined) continue;
            next = result;
            changed = true;
        }
        if (changed) $827d62b6188a5818$var$commit(next);
    });
};
const $827d62b6188a5818$export$f5c0eb035ef26e87 = (name, height)=>{
    $827d62b6188a5818$var$enqueue((current)=>{
        const index = current.findIndex((banner)=>banner.name === name);
        if (index === -1) return [
            ...current,
            {
                name: name,
                height: height
            }
        ];
        if (current[index].height !== height) {
            const next = [
                ...current
            ];
            // Replace rather than mutate, so the previous array keeps the old height.
            next[index] = {
                name: name,
                height: height
            };
            return next;
        }
        return undefined;
    });
};
const $827d62b6188a5818$export$11fa8b7d26b756a8 = (name)=>{
    $827d62b6188a5818$var$enqueue((current)=>{
        const index = current.findIndex((banner)=>banner.name === name);
        if (index === -1) return undefined;
        const next = [
            ...current
        ];
        next.splice(index, 1);
        return next;
    });
};
const $827d62b6188a5818$export$468156c225d4c0f9 = (initial)=>{
    if ((0, $i3jcY.isStableUIEnabledForTests)()) return;
    if ($827d62b6188a5818$var$banners.length === 0 && initial.length > 0) $827d62b6188a5818$var$commit([
        ...initial
    ]);
};
const $827d62b6188a5818$export$b3f5cfd1906442cb = ()=>{
    $827d62b6188a5818$var$banners = $827d62b6188a5818$var$NO_BANNERS;
    $827d62b6188a5818$var$listeners.clear();
    $827d62b6188a5818$var$pending = [];
    $827d62b6188a5818$var$pendingFlush = null;
};
module.exports["getBanners"] = $827d62b6188a5818$export$49fd326b255f6ddb;
module.exports["subscribeToBanners"] = $827d62b6188a5818$export$7cfac2c025b473e4;
module.exports["showBanner"] = $827d62b6188a5818$export$f5c0eb035ef26e87;
module.exports["hideBanner"] = $827d62b6188a5818$export$11fa8b7d26b756a8;
module.exports["seedBanners"] = $827d62b6188a5818$export$468156c225d4c0f9;

});

parcelRegister("jecot", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");

const $ff48e00b2c36a911$export$756e5b68ec79d923 = ()=>{
    if (// The increased height change is applied when FHS or app switcher improvements are enabled.
    // Ideally we could check `useIsFhsEnabled()` but this has to work outside React too.
    // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    (0, $6mKj3.expVal)('navx-full-height-sidebar-exp', 'isEnabled', false) || (0, $9wGTI.fg)('platform_dst_ads_appswitcher_improvements')) return 56;
    return 48;
};
module.exports["resolveTopNavHeight"] = $ff48e00b2c36a911$export$756e5b68ec79d923;

});

parcelRegister("bJX6u", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $kNIYN = parcelRequire("kNIYN");

const $258e0d668fcd3778$export$7e292eecf5a8f340 = {
    contentState: null,
    contentStateLastUpdated: null,
    shouldRunContentStateEffect: true,
    defaultStatesArray: [],
    customStatesArray: [],
    isContentStateEnabled: true,
    isSuggestedEnabled: true,
    isCustomEnabled: true,
    isUpdating: false,
    lastFetchedIsDraft: null,
    lastFetchedContentId: null
};
class $258e0d668fcd3778$export$ade89fbf99f42685 extends (0, $kNIYN.Container) {
    populateState(ssrContentStateData) {
        const newContentStateValues = Object.assign({}, $258e0d668fcd3778$export$7e292eecf5a8f340);
        newContentStateValues.shouldRunContentStateEffect = false;
        newContentStateValues.contentState = ssrContentStateData?.singleContent?.contentState || null;
        newContentStateValues.contentStateLastUpdated = ssrContentStateData?.singleContent?.contentStateLastUpdated?.value || null;
        newContentStateValues.defaultStatesArray = ssrContentStateData?.availableContentStates?.spaceContentStates?.filter((i)=>!!i) || [];
        newContentStateValues.customStatesArray = ssrContentStateData?.availableContentStates?.customContentStates?.filter((i)=>!!i) || [];
        // If an admin has turned off a toggle, BE returns us the value as null
        // If an empty array is returned [], means the feature is still enabled - there's just no values in there.
        // if both return as null it means the admin disabled content states
        const isSuggestedContentStatesDisabled = !ssrContentStateData?.availableContentStates?.spaceContentStates;
        const isCustomContentStatesDisabled = !ssrContentStateData?.availableContentStates?.customContentStates;
        const isContentStatesDisabled = isSuggestedContentStatesDisabled && isCustomContentStatesDisabled;
        if (isContentStatesDisabled) newContentStateValues.isContentStateEnabled = false;
        else if (isSuggestedContentStatesDisabled) // if spaceContentStates is null, admin disabled suggested
        newContentStateValues.isSuggestedEnabled = false;
        else if (isCustomContentStatesDisabled) // if customContentStates is null, admin disabled custom
        newContentStateValues.isCustomEnabled = false;
        this.state = newContentStateValues;
    }
    constructor(ssrContentStateData){
        super();
        this.state = {
            ...$258e0d668fcd3778$export$7e292eecf5a8f340
        };
        // Guards optimistic, mutation-owned fields (applied status + option list) from being
        // clobbered by stale refetches while an operation is pending. Kept off `state` so it
        // survives the refetch-driven `setInitialValues` calls.
        this.isOptimisticOperationPending = false;
        this.setIsOptimisticOperationPending = (isOptimisticOperationPending)=>{
            this.isOptimisticOperationPending = isOptimisticOperationPending;
        };
        // The contentId for which the empty add-status trigger should be kept visible after a
        // view-mode delete. Stored as an id (not a boolean) so render can scope it to the current page
        // without a navigation listener — it's only honored while this matches the active contentId,
        // so it naturally clears on navigation. Kept off `state` so a fresh container (refresh) resets it.
        this.keepEmptyTriggerForContentId = null;
        this.setKeepEmptyTriggerForContentId = (contentId)=>{
            this.keepEmptyTriggerForContentId = contentId;
        };
        this.setContentState = (contentState)=>this.setState({
                contentState: contentState
            });
        this.setShouldRunContentStateEffect = (shouldRunContentStateEffect)=>this.setState({
                shouldRunContentStateEffect: shouldRunContentStateEffect
            });
        this.setDefaultStatesArray = (defaultStatesArray)=>this.setState({
                defaultStatesArray: defaultStatesArray
            });
        this.setCustomStatesArray = (customStatesArray)=>this.setState({
                customStatesArray: customStatesArray
            });
        this.setIsContentStateEnabled = (isContentStateEnabled)=>this.setState({
                isContentStateEnabled: isContentStateEnabled
            });
        this.setIsSuggestedEnabled = (isSuggestedEnabled)=>this.setState({
                isSuggestedEnabled: isSuggestedEnabled
            });
        this.setIsCustomEnabled = (isCustomEnabled)=>this.setState({
                isCustomEnabled: isCustomEnabled
            });
        this.setIsUpdating = (isUpdating)=>this.setState({
                isUpdating: isUpdating
            });
        this.setLastFetchedIsDraft = (lastFetchedIsDraft)=>this.setState({
                lastFetchedIsDraft: lastFetchedIsDraft
            });
        this.setLastFetchedContentId = (lastFetchedContentId)=>this.setState({
                lastFetchedContentId: lastFetchedContentId
            });
        this.setInitialValues = (contentStateState)=>this.setState(contentStateState);
        this.resetToDefaults = ()=>this.setState({
                ...$258e0d668fcd3778$export$7e292eecf5a8f340
            });
        if (ssrContentStateData) this.populateState(ssrContentStateData);
    }
}
module.exports["defaultValues"] = $258e0d668fcd3778$export$7e292eecf5a8f340;
module.exports["ContentStateStateContainer"] = $258e0d668fcd3778$export$ade89fbf99f42685;

});

parcelRegister("ktUCG", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $kNIYN = parcelRequire("kNIYN");


var $6mKj3 = parcelRequire("6mKj3");


var $8rneB = parcelRequire("8rneB");


var $bKZz0 = parcelRequire("bKZz0");

class $122734ff4c4db131$export$c7d05d5ff2632978 extends (0, $kNIYN.Container) {
    populateState(ssrEmojiTitleData) {
        const { emojiStatusFieldName: emojiStatusFieldName, queryData: queryData, isLivePage: isLivePage } = ssrEmojiTitleData;
        const emojiId = (0, $8rneB.getEmojiId)(queryData, emojiStatusFieldName);
        const hasDefaultLiveTitleEmoji = (0, $8rneB.getHasLiveDocsDefaultEmoji)(queryData);
        this.setSelectedEmoji(emojiId || null);
        this.setHasLiveDocsDefaultEmoji(hasDefaultLiveTitleEmoji && isLivePage);
    }
    constructor(ssrEmojiTitleData){
        super();
        // Analytics-only flag: intentionally bypasses Container state so mutations
        // never trigger subscriber re-renders.
        this.justRestoredEmoji = false;
        this.state = {
            emojiPickerLoaded: false,
            isLoading: true,
            isMouseEnterTitle: false,
            isUpdatingEmoji: false,
            openFirstEmojiPicker: false,
            openSecondEmojiPicker: false,
            selectedEmoji: null,
            isEmojiButtonFocused: false,
            isRemovingEmoji: false,
            hasLiveDocsDefaultEmoji: false,
            previousEmojiIdByContentId: {}
        };
        this.onUpdateStart = ()=>this.setState({
                isUpdatingEmoji: true
            });
        this.onUpdateEnd = ()=>{
            this.setState({
                isUpdatingEmoji: false
            });
            this.setState({
                isRemovingEmoji: false
            });
        };
        this.setIsEmojiButtonFocused = (isEmojiButtonFocused)=>this.setState({
                isEmojiButtonFocused: isEmojiButtonFocused
            });
        this.setIsRemovingEmoji = (isRemovingEmoji)=>this.setState({
                isRemovingEmoji: isRemovingEmoji
            });
        this.setIsUpdatingEmoji = (isUpdatingEmoji)=>this.setState({
                isUpdatingEmoji: isUpdatingEmoji
            });
        // first emoji picker is open when user already selected an emoji
        // click on the emoji and want to change it to different emoji
        this.setOpenFirstEmojiPicker = (isOpen)=>{
            if (this.state.openFirstEmojiPicker !== isOpen) this.setState({
                openFirstEmojiPicker: isOpen
            });
        };
        // second emoji picker is open when not yet selected an emoji
        // and want to add emoji via Add emoji button
        this.setOpenSecondEmojiPicker = (isOpen)=>{
            if (this.state.openSecondEmojiPicker !== isOpen) this.setState({
                openSecondEmojiPicker: isOpen
            });
        };
        this.setSelectedEmoji = (emoji)=>this.setState({
                selectedEmoji: emoji
            });
        this.onEmojiPickerLoaded = ()=>{
            if (!this.state.emojiPickerLoaded) this.setState({
                emojiPickerLoaded: true
            });
        };
        // for testing
        this.setContainerState = (newState)=>this.setState((state)=>({
                    ...state,
                    ...newState
                }));
        this.setLoadingEmoji = (isLoading)=>this.setState({
                isLoading: isLoading
            });
        this.setHasLiveDocsDefaultEmoji = (hasDefaultEmoji)=>this.setState({
                hasLiveDocsDefaultEmoji: hasDefaultEmoji
            });
        this.getPreviousEmojiId = (contentId)=>this.state.previousEmojiIdByContentId[contentId] ?? null;
        // Pass `null` to clear just that entry.
        this.setPreviousEmojiId = (contentId, previousEmojiId)=>{
            const next = {
                ...this.state.previousEmojiIdByContentId
            };
            if (previousEmojiId === null) delete next[contentId];
            else next[contentId] = previousEmojiId;
            if ((0, $6mKj3.isExperimentEnabled)('cc_page_experiences_livedocs_restore_latest_emoji')) (0, $bKZz0.writeSessionStoragePreviousEmojiCache)(next);
            return this.setState({
                previousEmojiIdByContentId: next
            });
        };
        if ((0, $6mKj3.isExperimentEnabled)('cc_page_experiences_livedocs_restore_latest_emoji')) {
            const hydrated = (0, $bKZz0.readSessionStoragePreviousEmojiCache)();
            if (Object.keys(hydrated).length > 0) this.state = {
                ...this.state,
                previousEmojiIdByContentId: hydrated
            };
        }
        if (ssrEmojiTitleData) this.populateState(ssrEmojiTitleData);
    }
}
module.exports["EmojiTitleStateContainer"] = $122734ff4c4db131$export$c7d05d5ff2632978;

});

parcelRegister("bKZz0", function(module, exports) {
/**
 * sessionStorage mirror for the per-contentId `previousEmojiId` cache used by
 * the Live Docs "Restore emoji" affordance. Survives same-tab refresh; not a
 * source of truth — the in-memory unstated state is. Failures degrade silently.
 */ 
var $17wUi = parcelRequire("17wUi");


var $ivEX1 = parcelRequire("ivEX1");

const $dabf2e5c28263f4b$var$STORAGE_KEY = (0, $ivEX1.sessionKeys).EMOJI_TITLE_PREVIOUS_EMOJI;
const $dabf2e5c28263f4b$export$6adb2744b497be8f = ()=>{
    try {
        const raw = (0, $17wUi.confluenceSessionStorageInstance)?.getItem($dabf2e5c28263f4b$var$STORAGE_KEY);
        if (!raw || typeof raw !== 'string') return {};
        const parsed = JSON.parse(raw);
        if (!parsed || parsed.v !== 1 || typeof parsed.entries !== 'object' || !parsed.entries) return {};
        // Defensive: filter to non-empty string values in case the slot was
        // mutated by something else on the same origin.
        const out = {};
        for (const [contentId, emojiId] of Object.entries(parsed.entries))if (typeof emojiId === 'string' && emojiId.length > 0) out[contentId] = emojiId;
        return out;
    } catch  {
        return {};
    }
};
const $dabf2e5c28263f4b$export$3ef572a2467e08f4 = (map)=>{
    try {
        const entries = {};
        for (const [contentId, emojiId] of Object.entries(map))if (typeof emojiId === 'string' && emojiId.length > 0) entries[contentId] = emojiId;
        // Drop the key entirely when empty to keep storage clean.
        if (Object.keys(entries).length === 0) {
            (0, $17wUi.confluenceSessionStorageInstance)?.removeItem($dabf2e5c28263f4b$var$STORAGE_KEY);
            return;
        }
        (0, $17wUi.confluenceSessionStorageInstance)?.setItem($dabf2e5c28263f4b$var$STORAGE_KEY, JSON.stringify({
            v: 1,
            entries: entries
        }));
    } catch  {
    // Quota / consent / disabled storage — swallow; in-memory cache is unaffected.
    }
};
const $dabf2e5c28263f4b$export$fc4e54f3757eb471 = $dabf2e5c28263f4b$var$STORAGE_KEY;
module.exports["readSessionStoragePreviousEmojiCache"] = $dabf2e5c28263f4b$export$6adb2744b497be8f;
module.exports["writeSessionStoragePreviousEmojiCache"] = $dabf2e5c28263f4b$export$3ef572a2467e08f4;

});

parcelRegister("ivEX1", function(module, exports) {
/**
 * Registry of keys used with `confluenceSessionStorageInstance` (session storage).
 *
 * Keys here are intentionally NOT persisted across browser sessions.
 * Do NOT add keys here that should survive a tab close — use `LocalStorageKeys.ts` instead.
 */ const $ebcfca89ee3399cd$export$43572ca00746d574 = {
    /**
	 * The layout ('grid' | 'list') selected by the user for the folder contents view.
	 * Persisted for the duration of the browser session only.
	 */ FOLDER_VIEW_LAYOUT: 'folder.view.layout',
    /**
	 * Overrides the release track to 'dev'. Useful for running end-to-end tests
	 * from a dev machine against a production instance.
	 * Used by @confluence/build-info.
	 */ TELEMETRY_DEV_TRACK_OVERRIDE: 'confluence.telemetry-dev-track-override',
    /**
	 * Enables Confluence frontend logging when set to 'true'.
	 * Used by @confluence/logger.
	 */ ENABLE_LOGGING: 'confluence.enable-logging',
    /**
	 * Controls the minimum log level (1–5) for Confluence frontend logging.
	 * Used by @confluence/logger.
	 */ LOG_LEVEL: 'confluence.log-level',
    /**
	 * Tracks when the page-watch nudge was last shown to the user.
	 * Used by @confluence/third-party-nudge.
	 */ PAGE_VIEW_NUDGE_DATE: 'page-view-nudge-date',
    /**
	 * Tracks the state of the notification section nudge.
	 * Used by @confluence/third-party-nudge.
	 */ NOTIFICATION_NUDGE_STATE: 'notification-nudge-state',
    /**
	 * Per-contentId cache of the most recent custom emoji observed on a Live
	 * Doc, used to drive the "Restore emoji" affordance.
	 * Used by @confluence/emoji-title.
	 */ EMOJI_TITLE_PREVIOUS_EMOJI: 'confluence.emoji-title.previousEmojiId.v1',
    /**
	 * Identifies the title-based agent suggestion already shown in this editing
	 * session. The value is the owning agent/content pair so the currently visible
	 * suggestion can remain mounted while all other title suggestions are suppressed.
	 * Used by @confluence/experiment-ootb-title-based-agent-suggestion-nudge.
	 */ TITLE_AGENT_NUDGE_SHOWN_SESSION: 'confluence.title-agent-nudge.shown-session'
};
module.exports["sessionKeys"] = $ebcfca89ee3399cd$export$43572ca00746d574;

});

parcelRegister("hjygH", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1kHsc = parcelRequire("1kHsc");

function $1aeb691895c5954d$export$85823f26dca064c3(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { name: name, error: error, attributes: attributes } = t0;
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== error || $[2] !== experienceTracker || $[3] !== name) {
        t1 = ()=>{
            if (error) experienceTracker.stopOnError({
                name: name,
                error: error,
                attributes: attributes
            });
            else experienceTracker.succeed({
                name: name,
                attributes: attributes
            });
        };
        t2 = [
            experienceTracker,
            name,
            attributes,
            error
        ];
        $[0] = attributes;
        $[1] = error;
        $[2] = experienceTracker;
        $[3] = name;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceStop"] = $1aeb691895c5954d$export$85823f26dca064c3;

});

parcelRegister("ecUYt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $7xVCs = parcelRequire("7xVCs");

function $1b739b5871223ff5$export$347bd2772961ad32(WrappedComponent) {
    function withPageTreeStateUpdater(props) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
            to: [
                (0, $7xVCs.PageTreeStateUpdater)
            ]
        }, (pageTreeStateUpdater)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
                pageTreeStateUpdater: pageTreeStateUpdater,
                ...props
            }));
    }
    return withPageTreeStateUpdater;
}
module.exports["withPageTreeStateUpdater"] = $1b739b5871223ff5$export$347bd2772961ad32;

});

parcelRegister("7xVCs", function(module, exports) {

var $3u5lg = parcelRequire("3u5lg");


var $kNIYN = parcelRequire("kNIYN");

class $3c23582ca65aa05a$export$90a06df90d015db9 extends (0, $kNIYN.Container) {
    scrollToCurrentPage() {
        this.setState({
            scrollToCurrent: true
        });
    }
    clearScrollTo() {
        this.setState({
            scrollToCurrent: false
        });
    }
    setHighlightPagesIds(pageIds) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(this.state.highlightPagesIds, pageIds)) this.setState({
            highlightPagesIds: pageIds
        });
    }
    clearHighlightedPages() {
        this.setHighlightPagesIds([]);
    }
    setForceFetchPageId(pageId) {
        this.setState({
            forceFetchPageId: pageId
        });
    }
    clearForceFetch() {
        this.setForceFetchPageId(null);
    }
    setOptimisticDeleteId(pageId) {
        this.setState({
            optimisticDeletePageId: pageId
        });
    }
    clearOptimisticDeleteId() {
        this.setOptimisticDeleteId(null);
    }
    setIsEditingTitleId(contentId) {
        return this.setState({
            editingTitle: {
                contentId: contentId
            }
        });
    }
    // This is for content types such as folders that do not have a create content url
    // Instead, we allow naming the content inside the page tree immediately after creation
    forceFetchWithInlineRename(forceFetchId, contentId) {
        this.setState({
            forceFetchPageId: forceFetchId,
            editingTitle: {
                contentId: contentId,
                isNewContent: true
            },
            scrollToPageId: contentId
        });
    }
    clearScrollToPageId() {
        this.setState({
            scrollToPageId: null
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            highlightPagesIds: [],
            forceFetchPageId: null,
            optimisticDeletePageId: null,
            scrollToCurrent: false,
            scrollToPageId: null,
            editingTitle: {
                contentId: null
            }
        };
    }
}
module.exports["PageTreeStateUpdater"] = $3c23582ca65aa05a$export$90a06df90d015db9;

});

parcelRegister("bNhgs", function(module, exports) {

var $dpu2n = parcelRequire("dpu2n");


var $ecHHC = parcelRequire("ecHHC");


var $9mfmQ = parcelRequire("9mfmQ");

const $099bc251bcbff389$export$101d00feadd67b75 = (svgRoot)=>{
    // by this point we have a safe SVG string: we can safely string interpolate to encode as a
    // data:image to enable passing it to an <img> src attribute
    return `data:image/svg+xml;base64,${btoa(new XMLSerializer().serializeToString(svgRoot))}`;
};
const $099bc251bcbff389$export$ad5dfe87b2150403 = (cssProperties)=>{
    let styleString = '';
    Object.keys(cssProperties).forEach((key)=>{
        styleString += `${key}: ${cssProperties[key]}; `;
    });
    return styleString;
};
const $099bc251bcbff389$export$1ce458cf91bd8e41 = (svgRoot, cssProperties)=>{
    const styleRule = new CSSStyleSheet();
    const styleString = $099bc251bcbff389$export$ad5dfe87b2150403(cssProperties);
    // even if styling is malicious, it will be sanitized by the CSSStyleSheet with the string being empty, ensuring safety
    styleRule.insertRule(`svg { ${styleString} }`);
    // we need to cast to CSSStyleRule to access the .style property
    const styleRuleString = styleRule.cssRules[0].style.cssText;
    svgRoot.setAttribute('style', styleRuleString);
};
const $099bc251bcbff389$export$7572e098f6cf1a37 = (index)=>{
    return index !== undefined ? index % (0, $dpu2n.ANONYMOUS_ASSETS).length : Math.floor(Math.random() * (0, $dpu2n.ANONYMOUS_ASSETS).length);
};
const $099bc251bcbff389$export$e79675c646a31542 = (svgString)=>{
    return new DOMParser().parseFromString(svgString, 'image/svg+xml');
};
const $099bc251bcbff389$export$65fe496f5eb91c21 = async (props)=>{
    const index = $099bc251bcbff389$export$7572e098f6cf1a37(props?.index);
    const { id: id, messageDescriptor: messageDescriptor, src: src } = (0, $dpu2n.ANONYMOUS_ASSETS)[index];
    const intl = await (0, $ecHHC.getIntl)();
    const response = await (0, $9mfmQ.fetchWithRetry)({
        url: src,
        shouldRetryOnApiError: true,
        retries: props.retries || 3,
        options: props.options,
        baseDelay: props.baseDelay,
        maxDelay: props.maxDelay
    });
    const svgString = await response.result?.text();
    if (!response.success) throw new Error(`Error while fetching svg ${id} with src ${src}`);
    if (!svgString) throw new Error(`svg returned null with svg ${id} with src ${src}`);
    const doc = $099bc251bcbff389$export$e79675c646a31542(svgString);
    const svg = doc.documentElement;
    $099bc251bcbff389$export$1ce458cf91bd8e41(svg, props.styleProperties);
    return {
        id: id,
        name: intl.formatMessage(messageDescriptor),
        src: $099bc251bcbff389$export$101d00feadd67b75(svg)
    };
};
const $099bc251bcbff389$export$da26b707e2b53fcf = async (props)=>{
    const index = $099bc251bcbff389$export$7572e098f6cf1a37(props?.index);
    const asset = (0, $dpu2n.ANONYMOUS_ASSETS)[index];
    const intl = await (0, $ecHHC.getIntl)();
    return {
        ...asset,
        name: intl.formatMessage(asset.messageDescriptor)
    };
};
const $099bc251bcbff389$export$aa51d138a7f855d7 = async ()=>{
    const intl = await (0, $ecHHC.getIntl)();
    return (0, $dpu2n.ANONYMOUS_ASSETS).map((asset)=>({
            id: asset.id,
            name: intl.formatMessage(asset.messageDescriptor),
            src: asset.src
        }));
};
module.exports["getAnonymousAvatarWithStyling"] = $099bc251bcbff389$export$65fe496f5eb91c21;

});

parcelRegister("dpu2n", function(module, exports) {

var $6RZbK = parcelRequire("6RZbK");


var $hDQT9 = parcelRequire("hDQT9");

var $01Y7m = parcelRequire("01Y7m");

var $hYUzZ = parcelRequire("hYUzZ");

var $iuR2u = parcelRequire("iuR2u");

var $kkbx9 = parcelRequire("kkbx9");

var $cFEKY = parcelRequire("cFEKY");

var $6Ytc9 = parcelRequire("6Ytc9");

var $6I2hp = parcelRequire("6I2hp");

var $9jRbs = parcelRequire("9jRbs");

var $doHfX = parcelRequire("doHfX");

var $iQQz2 = parcelRequire("iQQz2");

var $6aQGf = parcelRequire("6aQGf");

var $rKSC9 = parcelRequire("rKSC9");

var $1HhEl = parcelRequire("1HhEl");

var $59SWb = parcelRequire("59SWb");

var $sNNnf = parcelRequire("sNNnf");

var $3lBYI = parcelRequire("3lBYI");

var $4xgJQ = parcelRequire("4xgJQ");

var $h2x1V = parcelRequire("h2x1V");

var $dpF2z = parcelRequire("dpF2z");

var $1sURO = parcelRequire("1sURO");

var $97Vlu = parcelRequire("97Vlu");

var $kVpsY = parcelRequire("kVpsY");

var $hCuul = parcelRequire("hCuul");

var $fuLed = parcelRequire("fuLed");

var $3kpwJ = parcelRequire("3kpwJ");

var $ei5ou = parcelRequire("ei5ou");

var $jveHG = parcelRequire("jveHG");

var $kG0T4 = parcelRequire("kG0T4");

var $iq6me = parcelRequire("iq6me");

var $amt9P = parcelRequire("amt9P");

var $unK7p = parcelRequire("unK7p");

var $7myjl = parcelRequire("7myjl");

var $c3CGq = parcelRequire("c3CGq");

var $73XLd = parcelRequire("73XLd");

var $4O6RS = parcelRequire("4O6RS");

var $1GH6m = parcelRequire("1GH6m");

var $1HXyl = parcelRequire("1HXyl");

var $htAoo = parcelRequire("htAoo");

var $0547j = parcelRequire("0547j");

var $cgVUh = parcelRequire("cgVUh");

var $cQ8lp = parcelRequire("cQ8lp");

var $5JQ20 = parcelRequire("5JQ20");

var $2YPi6 = parcelRequire("2YPi6");

var $cdkwi = parcelRequire("cdkwi");

var $kh1OZ = parcelRequire("kh1OZ");

var $8Sl6f = parcelRequire("8Sl6f");

var $9Qn7m = parcelRequire("9Qn7m");

var $3vrZh = parcelRequire("3vrZh");

var $2InqY = parcelRequire("2InqY");

var $dWYu6 = parcelRequire("dWYu6");

var $e4PgN = parcelRequire("e4PgN");

var $19hVO = parcelRequire("19hVO");

var $2UNgz = parcelRequire("2UNgz");

var $fVzqf = parcelRequire("fVzqf");

var $lj2Ls = parcelRequire("lj2Ls");

var $fr7Nb = parcelRequire("fr7Nb");

var $3Xksf = parcelRequire("3Xksf");

var $bBmIz = parcelRequire("bBmIz");

var $gYk9S = parcelRequire("gYk9S");

var $iii2c = parcelRequire("iii2c");

var $2AIpZ = parcelRequire("2AIpZ");

var $apAKP = parcelRequire("apAKP");

var $eHyqm = parcelRequire("eHyqm");

var $3qxDD = parcelRequire("3qxDD");

var $eHLy0 = parcelRequire("eHLy0");

var $kdS3N = parcelRequire("kdS3N");

var $1Sij2 = parcelRequire("1Sij2");

var $3pGfT = parcelRequire("3pGfT");

var $4LuNj = parcelRequire("4LuNj");

var $9gWob = parcelRequire("9gWob");

var $dRNzY = parcelRequire("dRNzY");

var $iMJSX = parcelRequire("iMJSX");

var $5cLsu = parcelRequire("5cLsu");

var $iN75X = parcelRequire("iN75X");

var $dKZNQ = parcelRequire("dKZNQ");

var $3N5nT = parcelRequire("3N5nT");

var $gAbKd = parcelRequire("gAbKd");

var $3KwZg = parcelRequire("3KwZg");

var $53QJP = parcelRequire("53QJP");

var $3tNjt = parcelRequire("3tNjt");

var $1QOVp = parcelRequire("1QOVp");

var $8BdMq = parcelRequire("8BdMq");

var $kzKxq = parcelRequire("kzKxq");

var $2bFMn = parcelRequire("2bFMn");

var $1mGLL = parcelRequire("1mGLL");

var $6hNPs = parcelRequire("6hNPs");

var $swN6A = parcelRequire("swN6A");

var $jlxMa = parcelRequire("jlxMa");

var $hY9h4 = parcelRequire("hY9h4");

var $21edV = parcelRequire("21edV");

var $i42iL = parcelRequire("i42iL");

var $5brqg = parcelRequire("5brqg");

var $55gO3 = parcelRequire("55gO3");

var $2cB6n = parcelRequire("2cB6n");

var $drBaG = parcelRequire("drBaG");

var $6OMjq = parcelRequire("6OMjq");

var $8MYut = parcelRequire("8MYut");

var $j8C9j = parcelRequire("j8C9j");

var $6yJEz = parcelRequire("6yJEz");

var $dtUp6 = parcelRequire("dtUp6");

var $isP63 = parcelRequire("isP63");

var $9lleE = parcelRequire("9lleE");

var $5uWd9 = parcelRequire("5uWd9");

var $iIHIG = parcelRequire("iIHIG");

const $357db4d5f3da3ec7$export$4522d3d70312bbdc = [
    {
        id: 'alligator',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iq6me))),
        messageDescriptor: (0, $6RZbK.messages).alligator
    },
    {
        id: 'alpaca',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($lj2Ls))),
        messageDescriptor: (0, $6RZbK.messages).alpaca
    },
    {
        id: 'ape',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3qxDD))),
        messageDescriptor: (0, $6RZbK.messages).ape
    },
    {
        id: 'apple',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hDQT9))),
        messageDescriptor: (0, $6RZbK.messages).apple
    },
    {
        id: 'avocado',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($01Y7m))),
        messageDescriptor: (0, $6RZbK.messages).avocado
    },
    {
        id: 'baboon',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3qxDD))),
        messageDescriptor: (0, $6RZbK.messages).baboon
    },
    {
        id: 'badger',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hYUzZ))),
        messageDescriptor: (0, $6RZbK.messages).badger
    },
    {
        id: 'bat',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iuR2u))),
        messageDescriptor: (0, $6RZbK.messages).bat
    },
    {
        id: 'bear',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kkbx9))),
        messageDescriptor: (0, $6RZbK.messages).bear
    },
    {
        id: 'beaver',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cFEKY))),
        messageDescriptor: (0, $6RZbK.messages).beaver
    },
    {
        id: 'bee',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6Ytc9))),
        messageDescriptor: (0, $6RZbK.messages).bee
    },
    {
        id: 'bird',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kdS3N))),
        messageDescriptor: (0, $6RZbK.messages).bird
    },
    {
        id: 'bison',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6I2hp))),
        messageDescriptor: (0, $6RZbK.messages).bison
    },
    {
        id: 'blobfish',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($0547j))),
        messageDescriptor: (0, $6RZbK.messages).blobfish
    },
    {
        id: 'blossom',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9jRbs))),
        messageDescriptor: (0, $6RZbK.messages).blossom
    },
    {
        id: 'blowfish',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($doHfX))),
        messageDescriptor: (0, $6RZbK.messages).blowfish
    },
    {
        id: 'blueberries',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iQQz2))),
        messageDescriptor: (0, $6RZbK.messages).blueberries
    },
    {
        id: 'boar',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6aQGf))),
        messageDescriptor: (0, $6RZbK.messages).boar
    },
    {
        id: 'broccoli',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($rKSC9))),
        messageDescriptor: (0, $6RZbK.messages).broccoli
    },
    {
        id: 'buffalo',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6I2hp))),
        messageDescriptor: (0, $6RZbK.messages).buffalo
    },
    {
        id: 'bug',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1HhEl))),
        messageDescriptor: (0, $6RZbK.messages).bug
    },
    {
        id: 'bull',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jveHG))),
        messageDescriptor: (0, $6RZbK.messages).bull
    },
    {
        id: 'bunny',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gAbKd))),
        messageDescriptor: (0, $6RZbK.messages).bunny
    },
    {
        id: 'butterfly',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1HhEl))),
        messageDescriptor: (0, $6RZbK.messages).butterfly
    },
    {
        id: 'cactus',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($59SWb))),
        messageDescriptor: (0, $6RZbK.messages).cactus
    },
    {
        id: 'camel',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($sNNnf))),
        messageDescriptor: (0, $6RZbK.messages).camel
    },
    {
        id: 'candy',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3lBYI))),
        messageDescriptor: (0, $6RZbK.messages).candy
    },
    {
        id: 'cantaloupe',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bBmIz))),
        messageDescriptor: (0, $6RZbK.messages).cantaloupe
    },
    {
        id: 'capsicum',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4xgJQ))),
        messageDescriptor: (0, $6RZbK.messages).capsicum
    },
    {
        id: 'carrot',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($h2x1V))),
        messageDescriptor: (0, $6RZbK.messages).carrot
    },
    {
        id: 'cat',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dpF2z))),
        messageDescriptor: (0, $6RZbK.messages).cat
    },
    {
        id: 'caterpiller',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1sURO))),
        messageDescriptor: (0, $6RZbK.messages).caterpiller
    },
    {
        id: 'chameleon',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($fVzqf))),
        messageDescriptor: (0, $6RZbK.messages).chameleon
    },
    {
        id: 'cherry',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($97Vlu))),
        messageDescriptor: (0, $6RZbK.messages).cherry
    },
    {
        id: 'chili',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kVpsY))),
        messageDescriptor: (0, $6RZbK.messages).chili
    },
    {
        id: 'chimp',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gYk9S))),
        messageDescriptor: (0, $6RZbK.messages).chimp
    },
    {
        id: 'chimpanzee',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gYk9S))),
        messageDescriptor: (0, $6RZbK.messages).chimpanzee
    },
    {
        id: 'clover',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hCuul))),
        messageDescriptor: (0, $6RZbK.messages).clover
    },
    {
        id: 'clownfish',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6yJEz))),
        messageDescriptor: (0, $6RZbK.messages).clownfish
    },
    {
        id: 'cobra',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hY9h4))),
        messageDescriptor: (0, $6RZbK.messages).cobra
    },
    {
        id: 'coconut',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($fuLed))),
        messageDescriptor: (0, $6RZbK.messages).coconut
    },
    {
        id: 'cod',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($0547j))),
        messageDescriptor: (0, $6RZbK.messages).cod
    },
    {
        id: 'cookie',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3kpwJ))),
        messageDescriptor: (0, $6RZbK.messages).cookie
    },
    {
        id: 'corn',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ei5ou))),
        messageDescriptor: (0, $6RZbK.messages).corn
    },
    {
        id: 'cow',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jveHG))),
        messageDescriptor: (0, $6RZbK.messages).cow
    },
    {
        id: 'crab',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kG0T4))),
        messageDescriptor: (0, $6RZbK.messages).crab
    },
    {
        id: 'crocodile',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iq6me))),
        messageDescriptor: (0, $6RZbK.messages).crocodile
    },
    {
        id: 'deer',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($amt9P))),
        messageDescriptor: (0, $6RZbK.messages).deer
    },
    {
        id: 'dinosaur',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($unK7p))),
        messageDescriptor: (0, $6RZbK.messages).dinosaur
    },
    {
        id: 'dodo',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7myjl))),
        messageDescriptor: (0, $6RZbK.messages).dodo
    },
    {
        id: 'dog',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($c3CGq))),
        messageDescriptor: (0, $6RZbK.messages).dog
    },
    {
        id: 'dolphin',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($73XLd))),
        messageDescriptor: (0, $6RZbK.messages).dolphin
    },
    {
        id: 'donut',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4O6RS))),
        messageDescriptor: (0, $6RZbK.messages).donut
    },
    {
        id: 'dragon',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1GH6m))),
        messageDescriptor: (0, $6RZbK.messages).dragon
    },
    {
        id: 'duck',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1HXyl))),
        messageDescriptor: (0, $6RZbK.messages).duck
    },
    {
        id: 'elephant',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($htAoo))),
        messageDescriptor: (0, $6RZbK.messages).elephant
    },
    {
        id: 'elk',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($amt9P))),
        messageDescriptor: (0, $6RZbK.messages).elk
    },
    {
        id: 'fish',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($0547j))),
        messageDescriptor: (0, $6RZbK.messages).fish
    },
    {
        id: 'flamingo',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cgVUh))),
        messageDescriptor: (0, $6RZbK.messages).flamingo
    },
    {
        id: 'fox',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cQ8lp))),
        messageDescriptor: (0, $6RZbK.messages).fox
    },
    {
        id: 'frog',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5JQ20))),
        messageDescriptor: (0, $6RZbK.messages).frog
    },
    {
        id: 'gecko',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($fVzqf))),
        messageDescriptor: (0, $6RZbK.messages).gecko
    },
    {
        id: 'giraffe',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2YPi6))),
        messageDescriptor: (0, $6RZbK.messages).giraffe
    },
    {
        id: 'gorilla',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cdkwi))),
        messageDescriptor: (0, $6RZbK.messages).gorilla
    },
    {
        id: 'grape',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kh1OZ))),
        messageDescriptor: (0, $6RZbK.messages).grape
    },
    {
        id: 'hammerhead',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2bFMn))),
        messageDescriptor: (0, $6RZbK.messages).hammerhead
    },
    {
        id: 'hedgehog',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8Sl6f))),
        messageDescriptor: (0, $6RZbK.messages).hedgehog
    },
    {
        id: 'hippo',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9Qn7m))),
        messageDescriptor: (0, $6RZbK.messages).hippo
    },
    {
        id: 'kangaroo',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3vrZh))),
        messageDescriptor: (0, $6RZbK.messages).kangaroo
    },
    {
        id: 'kitten',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dpF2z))),
        messageDescriptor: (0, $6RZbK.messages).kitten
    },
    {
        id: 'kiwi',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2InqY))),
        messageDescriptor: (0, $6RZbK.messages).kiwi
    },
    {
        id: 'koala',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dWYu6))),
        messageDescriptor: (0, $6RZbK.messages).koala
    },
    {
        id: 'lemon',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($e4PgN))),
        messageDescriptor: (0, $6RZbK.messages).lemon
    },
    {
        id: 'leopard',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($drBaG))),
        messageDescriptor: (0, $6RZbK.messages).leopard
    },
    {
        id: 'lettuce',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($19hVO))),
        messageDescriptor: (0, $6RZbK.messages).lettuce
    },
    {
        id: 'lion',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2UNgz))),
        messageDescriptor: (0, $6RZbK.messages).lion
    },
    {
        id: 'lizard',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($fVzqf))),
        messageDescriptor: (0, $6RZbK.messages).lizard
    },
    {
        id: 'llama',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($lj2Ls))),
        messageDescriptor: (0, $6RZbK.messages).llama
    },
    {
        id: 'lobster',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($fr7Nb))),
        messageDescriptor: (0, $6RZbK.messages).lobster
    },
    {
        id: 'macaque',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gYk9S))),
        messageDescriptor: (0, $6RZbK.messages).macaque
    },
    {
        id: 'mango',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3Xksf))),
        messageDescriptor: (0, $6RZbK.messages).mango
    },
    {
        id: 'melon',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9lleE))),
        messageDescriptor: (0, $6RZbK.messages).melon
    },
    {
        id: 'millipede',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1sURO))),
        messageDescriptor: (0, $6RZbK.messages).millipede
    },
    {
        id: 'monkey',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gYk9S))),
        messageDescriptor: (0, $6RZbK.messages).monkey
    },
    {
        id: 'mouse',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iii2c))),
        messageDescriptor: (0, $6RZbK.messages).mouse
    },
    {
        id: 'octopus',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2AIpZ))),
        messageDescriptor: (0, $6RZbK.messages).octopus
    },
    {
        id: 'olive',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($apAKP))),
        messageDescriptor: (0, $6RZbK.messages).olive
    },
    {
        id: 'orange',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eHyqm))),
        messageDescriptor: (0, $6RZbK.messages).orange
    },
    {
        id: 'orangutan',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3qxDD))),
        messageDescriptor: (0, $6RZbK.messages).orangutan
    },
    {
        id: 'otter',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eHLy0))),
        messageDescriptor: (0, $6RZbK.messages).otter
    },
    {
        id: 'owl',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kdS3N))),
        messageDescriptor: (0, $6RZbK.messages).owl
    },
    {
        id: 'ox',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1Sij2))),
        messageDescriptor: (0, $6RZbK.messages).ox
    },
    {
        id: 'oyster',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3pGfT))),
        messageDescriptor: (0, $6RZbK.messages).oyster
    },
    {
        id: 'panda',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4LuNj))),
        messageDescriptor: (0, $6RZbK.messages).panda
    },
    {
        id: 'parrot',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9gWob))),
        messageDescriptor: (0, $6RZbK.messages).parrot
    },
    {
        id: 'peacock',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dRNzY))),
        messageDescriptor: (0, $6RZbK.messages).peacock
    },
    {
        id: 'pear',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iMJSX))),
        messageDescriptor: (0, $6RZbK.messages).pear
    },
    {
        id: 'penguin',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5cLsu))),
        messageDescriptor: (0, $6RZbK.messages).penguin
    },
    {
        id: 'pig',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iN75X))),
        messageDescriptor: (0, $6RZbK.messages).pig
    },
    {
        id: 'pineapple',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dKZNQ))),
        messageDescriptor: (0, $6RZbK.messages).pineapple
    },
    {
        id: 'poodle',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3N5nT))),
        messageDescriptor: (0, $6RZbK.messages).poodle
    },
    {
        id: 'puppy',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($c3CGq))),
        messageDescriptor: (0, $6RZbK.messages).puppy
    },
    {
        id: 'python',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hY9h4))),
        messageDescriptor: (0, $6RZbK.messages).python
    },
    {
        id: 'rabbit',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gAbKd))),
        messageDescriptor: (0, $6RZbK.messages).rabbit
    },
    {
        id: 'raccoon',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3KwZg))),
        messageDescriptor: (0, $6RZbK.messages).raccoon
    },
    {
        id: 'rat',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iii2c))),
        messageDescriptor: (0, $6RZbK.messages).rat
    },
    {
        id: 'rhino',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($53QJP))),
        messageDescriptor: (0, $6RZbK.messages).rhino
    },
    {
        id: 'robot',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3tNjt))),
        messageDescriptor: (0, $6RZbK.messages).robot
    },
    {
        id: 'rose',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1QOVp))),
        messageDescriptor: (0, $6RZbK.messages).rose
    },
    {
        id: 'seal',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8BdMq))),
        messageDescriptor: (0, $6RZbK.messages).seal
    },
    {
        id: 'seedling',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kzKxq))),
        messageDescriptor: (0, $6RZbK.messages).seedling
    },
    {
        id: 'shark',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2bFMn))),
        messageDescriptor: (0, $6RZbK.messages).shark
    },
    {
        id: 'shrimp',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1mGLL))),
        messageDescriptor: (0, $6RZbK.messages).shrimp
    },
    {
        id: 'skunk',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6hNPs))),
        messageDescriptor: (0, $6RZbK.messages).skunk
    },
    {
        id: 'sloth',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($swN6A))),
        messageDescriptor: (0, $6RZbK.messages).sloth
    },
    {
        id: 'snail',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jlxMa))),
        messageDescriptor: (0, $6RZbK.messages).snail
    },
    {
        id: 'snake',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hY9h4))),
        messageDescriptor: (0, $6RZbK.messages).snake
    },
    {
        id: 'snowman',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($21edV))),
        messageDescriptor: (0, $6RZbK.messages).snowman
    },
    {
        id: 'squid',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($i42iL))),
        messageDescriptor: (0, $6RZbK.messages).squid
    },
    {
        id: 'squirrel',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5brqg))),
        messageDescriptor: (0, $6RZbK.messages).squirrel
    },
    {
        id: 'strawberry',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($55gO3))),
        messageDescriptor: (0, $6RZbK.messages).strawberry
    },
    {
        id: 'sunfish',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6yJEz))),
        messageDescriptor: (0, $6RZbK.messages).sunfish
    },
    {
        id: 'sunflower',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2cB6n))),
        messageDescriptor: (0, $6RZbK.messages).sunflower
    },
    {
        id: 'tiger',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($drBaG))),
        messageDescriptor: (0, $6RZbK.messages).tiger
    },
    {
        id: 'tomato',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6OMjq))),
        messageDescriptor: (0, $6RZbK.messages).tomato
    },
    {
        id: 'tortoise',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($isP63))),
        messageDescriptor: (0, $6RZbK.messages).tortoise
    },
    {
        id: 'tree',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8MYut))),
        messageDescriptor: (0, $6RZbK.messages).tree
    },
    {
        id: 'trex',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($j8C9j))),
        messageDescriptor: (0, $6RZbK.messages).trex
    },
    {
        id: 'trout',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($0547j))),
        messageDescriptor: (0, $6RZbK.messages).trout
    },
    {
        id: 'turkey',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dtUp6))),
        messageDescriptor: (0, $6RZbK.messages).turkey
    },
    {
        id: 'turtle',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($isP63))),
        messageDescriptor: (0, $6RZbK.messages).turtle
    },
    {
        id: 'wasp',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6Ytc9))),
        messageDescriptor: (0, $6RZbK.messages).wasp
    },
    {
        id: 'watermelon',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9lleE))),
        messageDescriptor: (0, $6RZbK.messages).watermelon
    },
    {
        id: 'whale',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5uWd9))),
        messageDescriptor: (0, $6RZbK.messages).whale
    },
    {
        id: 'wolf',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iIHIG))),
        messageDescriptor: (0, $6RZbK.messages).wolf
    }
];
module.exports["ANONYMOUS_ASSETS"] = $357db4d5f3da3ec7$export$4522d3d70312bbdc;

});

parcelRegister("6RZbK", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $52c1b6ebf0043fde$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    alligator: {
        id: "platform.anonymous-asset-name.alligator",
        defaultMessage: "Anonymous Alligator"
    },
    alpaca: {
        id: "platform.anonymous-asset-name.alpaca",
        defaultMessage: "Anonymous Alpaca"
    },
    ape: {
        id: "platform.anonymous-asset-name.ape",
        defaultMessage: "Anonymous Ape"
    },
    apple: {
        id: "platform.anonymous-asset-name.apple",
        defaultMessage: "Anonymous Apple"
    },
    avocado: {
        id: "platform.anonymous-asset-name.avocado",
        defaultMessage: "Anonymous Avocado"
    },
    baboon: {
        id: "platform.anonymous-asset-name.baboon",
        defaultMessage: "Anonymous Baboon"
    },
    badger: {
        id: "platform.anonymous-asset-name.badger",
        defaultMessage: "Anonymous Badger"
    },
    bat: {
        id: "platform.anonymous-asset-name.bat",
        defaultMessage: "Anonymous Bat"
    },
    bear: {
        id: "platform.anonymous-asset-name.bear",
        defaultMessage: "Anonymous Bear"
    },
    beaver: {
        id: "platform.anonymous-asset-name.beaver",
        defaultMessage: "Anonymous Beaver"
    },
    bee: {
        id: "platform.anonymous-asset-name.bee",
        defaultMessage: "Anonymous Bee"
    },
    bird: {
        id: "platform.anonymous-asset-name.bird",
        defaultMessage: "Anonymous Bird"
    },
    bison: {
        id: "platform.anonymous-asset-name.bison",
        defaultMessage: "Anonymous Bison"
    },
    blobfish: {
        id: "platform.anonymous-asset-name.blobfish",
        defaultMessage: "Anonymous Blobfish"
    },
    blossom: {
        id: "platform.anonymous-asset-name.blossom",
        defaultMessage: "Anonymous Blossom"
    },
    blowfish: {
        id: "platform.anonymous-asset-name.blowfish",
        defaultMessage: "Anonymous Blowfish"
    },
    blueberries: {
        id: "platform.anonymous-asset-name.blueberries",
        defaultMessage: "Anonymous Blueberries"
    },
    boar: {
        id: "platform.anonymous-asset-name.boar",
        defaultMessage: "Anonymous Boar"
    },
    broccoli: {
        id: "platform.anonymous-asset-name.broccoli",
        defaultMessage: "Anonymous Broccoli"
    },
    buffalo: {
        id: "platform.anonymous-asset-name.buffalo",
        defaultMessage: "Anonymous Buffalo"
    },
    bug: {
        id: "platform.anonymous-asset-name.bug",
        defaultMessage: "Anonymous Bug"
    },
    bull: {
        id: "platform.anonymous-asset-name.bull",
        defaultMessage: "Anonymous Bull"
    },
    bunny: {
        id: "platform.anonymous-asset-name.bunny",
        defaultMessage: "Anonymous Bunny"
    },
    butterfly: {
        id: "platform.anonymous-asset-name.butterfly",
        defaultMessage: "Anonymous Butterfly"
    },
    cactus: {
        id: "platform.anonymous-asset-name.cactus",
        defaultMessage: "Anonymous Cactus"
    },
    camel: {
        id: "platform.anonymous-asset-name.camel",
        defaultMessage: "Anonymous Camel"
    },
    candy: {
        id: "platform.anonymous-asset-name.candy",
        defaultMessage: "Anonymous Candy"
    },
    cantaloupe: {
        id: "platform.anonymous-asset-name.cantaloupe",
        defaultMessage: "Anonymous Cantaloupe"
    },
    capsicum: {
        id: "platform.anonymous-asset-name.capsicum",
        defaultMessage: "Anonymous Capsicum"
    },
    carrot: {
        id: "platform.anonymous-asset-name.carrot",
        defaultMessage: "Anonymous Carrot"
    },
    cat: {
        id: "platform.anonymous-asset-name.cat",
        defaultMessage: "Anonymous Cat"
    },
    caterpiller: {
        id: "platform.anonymous-asset-name.caterpiller",
        defaultMessage: "Anonymous Caterpiller"
    },
    chameleon: {
        id: "platform.anonymous-asset-name.chameleon",
        defaultMessage: "Anonymous Chameleon"
    },
    cherry: {
        id: "platform.anonymous-asset-name.cherry",
        defaultMessage: "Anonymous Cherry"
    },
    chili: {
        id: "platform.anonymous-asset-name.chili",
        defaultMessage: "Anonymous Chili"
    },
    chimp: {
        id: "platform.anonymous-asset-name.chimp",
        defaultMessage: "Anonymous Chimp"
    },
    chimpanzee: {
        id: "platform.anonymous-asset-name.chimpanzee",
        defaultMessage: "Anonymous Chimpanzee"
    },
    clover: {
        id: "platform.anonymous-asset-name.clover",
        defaultMessage: "Anonymous Clover"
    },
    clownfish: {
        id: "platform.anonymous-asset-name.clownfish",
        defaultMessage: "Anonymous Clownfish"
    },
    cobra: {
        id: "platform.anonymous-asset-name.cobra",
        defaultMessage: "Anonymous Cobra"
    },
    coconut: {
        id: "platform.anonymous-asset-name.coconut",
        defaultMessage: "Anonymous Coconut"
    },
    cod: {
        id: "platform.anonymous-asset-name.cod",
        defaultMessage: "Anonymous Cod"
    },
    cookie: {
        id: "platform.anonymous-asset-name.cookie",
        defaultMessage: "Anonymous Cookie"
    },
    corn: {
        id: "platform.anonymous-asset-name.corn",
        defaultMessage: "Anonymous Corn"
    },
    cow: {
        id: "platform.anonymous-asset-name.cow",
        defaultMessage: "Anonymous Cow"
    },
    crab: {
        id: "platform.anonymous-asset-name.crab",
        defaultMessage: "Anonymous Crab"
    },
    crocodile: {
        id: "platform.anonymous-asset-name.crocodile",
        defaultMessage: "Anonymous Crocodile"
    },
    deer: {
        id: "platform.anonymous-asset-name.deer",
        defaultMessage: "Anonymous Deer"
    },
    dinosaur: {
        id: "platform.anonymous-asset-name.dinosaur",
        defaultMessage: "Anonymous Dinosaur"
    },
    dodo: {
        id: "platform.anonymous-asset-name.dodo",
        defaultMessage: "Anonymous Dodo"
    },
    dog: {
        id: "platform.anonymous-asset-name.dog",
        defaultMessage: "Anonymous Dog"
    },
    dolphin: {
        id: "platform.anonymous-asset-name.dolphin",
        defaultMessage: "Anonymous Dolphin"
    },
    donut: {
        id: "platform.anonymous-asset-name.donut",
        defaultMessage: "Anonymous Donut"
    },
    dragon: {
        id: "platform.anonymous-asset-name.dragon",
        defaultMessage: "Anonymous Dragon"
    },
    duck: {
        id: "platform.anonymous-asset-name.duck",
        defaultMessage: "Anonymous Duck"
    },
    elephant: {
        id: "platform.anonymous-asset-name.elephant",
        defaultMessage: "Anonymous Elephant"
    },
    elk: {
        id: "platform.anonymous-asset-name.elk",
        defaultMessage: "Anonymous Elk"
    },
    fish: {
        id: "platform.anonymous-asset-name.fish",
        defaultMessage: "Anonymous Fish"
    },
    flamingo: {
        id: "platform.anonymous-asset-name.flamingo",
        defaultMessage: "Anonymous Flamingo"
    },
    fox: {
        id: "platform.anonymous-asset-name.fox",
        defaultMessage: "Anonymous Fox"
    },
    frog: {
        id: "platform.anonymous-asset-name.frog",
        defaultMessage: "Anonymous Frog"
    },
    gecko: {
        id: "platform.anonymous-asset-name.gecko",
        defaultMessage: "Anonymous Gecko"
    },
    giraffe: {
        id: "platform.anonymous-asset-name.giraffe",
        defaultMessage: "Anonymous Giraffe"
    },
    gorilla: {
        id: "platform.anonymous-asset-name.gorilla",
        defaultMessage: "Anonymous Gorilla"
    },
    grape: {
        id: "platform.anonymous-asset-name.grape",
        defaultMessage: "Anonymous Grape"
    },
    hammerhead: {
        id: "platform.anonymous-asset-name.hammerhead",
        defaultMessage: "Anonymous Hammerhead"
    },
    hedgehog: {
        id: "platform.anonymous-asset-name.hedgehog",
        defaultMessage: "Anonymous Hedgehog"
    },
    hippo: {
        id: "platform.anonymous-asset-name.hippo",
        defaultMessage: "Anonymous Hippo"
    },
    kangaroo: {
        id: "platform.anonymous-asset-name.kangaroo",
        defaultMessage: "Anonymous Kangaroo"
    },
    kitten: {
        id: "platform.anonymous-asset-name.kitten",
        defaultMessage: "Anonymous Kitten"
    },
    kiwi: {
        id: "platform.anonymous-asset-name.kiwi",
        defaultMessage: "Anonymous Kiwi"
    },
    koala: {
        id: "platform.anonymous-asset-name.koala",
        defaultMessage: "Anonymous Koala"
    },
    lemon: {
        id: "platform.anonymous-asset-name.lemon",
        defaultMessage: "Anonymous Lemon"
    },
    leopard: {
        id: "platform.anonymous-asset-name.leopard",
        defaultMessage: "Anonymous Leopard"
    },
    lettuce: {
        id: "platform.anonymous-asset-name.lettuce",
        defaultMessage: "Anonymous Lettuce"
    },
    lion: {
        id: "platform.anonymous-asset-name.lion",
        defaultMessage: "Anonymous Lion"
    },
    lizard: {
        id: "platform.anonymous-asset-name.lizard",
        defaultMessage: "Anonymous Lizard"
    },
    llama: {
        id: "platform.anonymous-asset-name.llama",
        defaultMessage: "Anonymous Llama"
    },
    lobster: {
        id: "platform.anonymous-asset-name.lobster",
        defaultMessage: "Anonymous Lobster"
    },
    macaque: {
        id: "platform.anonymous-asset-name.macaque",
        defaultMessage: "Anonymous Macaque"
    },
    mango: {
        id: "platform.anonymous-asset-name.mango",
        defaultMessage: "Anonymous Mango"
    },
    melon: {
        id: "platform.anonymous-asset-name.melon",
        defaultMessage: "Anonymous Melon"
    },
    millipede: {
        id: "platform.anonymous-asset-name.millipede",
        defaultMessage: "Anonymous Millipede"
    },
    monkey: {
        id: "platform.anonymous-asset-name.monkey",
        defaultMessage: "Anonymous Monkey"
    },
    mouse: {
        id: "platform.anonymous-asset-name.mouse",
        defaultMessage: "Anonymous Mouse"
    },
    octopus: {
        id: "platform.anonymous-asset-name.octopus",
        defaultMessage: "Anonymous Octopus"
    },
    olive: {
        id: "platform.anonymous-asset-name.olive",
        defaultMessage: "Anonymous Olive"
    },
    orange: {
        id: "platform.anonymous-asset-name.orange",
        defaultMessage: "Anonymous Orange"
    },
    orangutan: {
        id: "platform.anonymous-asset-name.orangutan",
        defaultMessage: "Anonymous Orangutan"
    },
    otter: {
        id: "platform.anonymous-asset-name.otter",
        defaultMessage: "Anonymous Otter"
    },
    owl: {
        id: "platform.anonymous-asset-name.owl",
        defaultMessage: "Anonymous Owl"
    },
    ox: {
        id: "platform.anonymous-asset-name.ox",
        defaultMessage: "Anonymous Ox"
    },
    oyster: {
        id: "platform.anonymous-asset-name.oyster",
        defaultMessage: "Anonymous Oyster"
    },
    panda: {
        id: "platform.anonymous-asset-name.panda",
        defaultMessage: "Anonymous Panda"
    },
    parrot: {
        id: "platform.anonymous-asset-name.parrot",
        defaultMessage: "Anonymous Parrot"
    },
    peacock: {
        id: "platform.anonymous-asset-name.peacock",
        defaultMessage: "Anonymous Peacock"
    },
    pear: {
        id: "platform.anonymous-asset-name.pear",
        defaultMessage: "Anonymous Pear"
    },
    penguin: {
        id: "platform.anonymous-asset-name.penguin",
        defaultMessage: "Anonymous Penguin"
    },
    pig: {
        id: "platform.anonymous-asset-name.pig",
        defaultMessage: "Anonymous Pig"
    },
    pineapple: {
        id: "platform.anonymous-asset-name.pineapple",
        defaultMessage: "Anonymous Pineapple"
    },
    poodle: {
        id: "platform.anonymous-asset-name.poodle",
        defaultMessage: "Anonymous Poodle"
    },
    puppy: {
        id: "platform.anonymous-asset-name.puppy",
        defaultMessage: "Anonymous Puppy"
    },
    python: {
        id: "platform.anonymous-asset-name.python",
        defaultMessage: "Anonymous Python"
    },
    rabbit: {
        id: "platform.anonymous-asset-name.rabbit",
        defaultMessage: "Anonymous Rabbit"
    },
    raccoon: {
        id: "platform.anonymous-asset-name.raccoon",
        defaultMessage: "Anonymous Raccoon"
    },
    rat: {
        id: "platform.anonymous-asset-name.rat",
        defaultMessage: "Anonymous Rat"
    },
    rhino: {
        id: "platform.anonymous-asset-name.rhino",
        defaultMessage: "Anonymous Rhino"
    },
    robot: {
        id: "platform.anonymous-asset-name.robot",
        defaultMessage: "Anonymous Robot"
    },
    rose: {
        id: "platform.anonymous-asset-name.rose",
        defaultMessage: "Anonymous Rose"
    },
    seal: {
        id: "platform.anonymous-asset-name.seal",
        defaultMessage: "Anonymous Seal"
    },
    seedling: {
        id: "platform.anonymous-asset-name.seedling",
        defaultMessage: "Anonymous Seedling"
    },
    shark: {
        id: "platform.anonymous-asset-name.shark",
        defaultMessage: "Anonymous Shark"
    },
    shrimp: {
        id: "platform.anonymous-asset-name.shrimp",
        defaultMessage: "Anonymous Shrimp"
    },
    skunk: {
        id: "platform.anonymous-asset-name.skunk",
        defaultMessage: "Anonymous Skunk"
    },
    sloth: {
        id: "platform.anonymous-asset-name.sloth",
        defaultMessage: "Anonymous Sloth"
    },
    snail: {
        id: "platform.anonymous-asset-name.snail",
        defaultMessage: "Anonymous Snail"
    },
    snake: {
        id: "platform.anonymous-asset-name.snake",
        defaultMessage: "Anonymous Snake"
    },
    snowman: {
        id: "platform.anonymous-asset-name.snowman",
        defaultMessage: "Anonymous Snowman"
    },
    squid: {
        id: "platform.anonymous-asset-name.squid",
        defaultMessage: "Anonymous Squid"
    },
    squirrel: {
        id: "platform.anonymous-asset-name.squirrel",
        defaultMessage: "Anonymous Squirrel"
    },
    strawberry: {
        id: "platform.anonymous-asset-name.strawberry",
        defaultMessage: "Anonymous Strawberry"
    },
    sunfish: {
        id: "platform.anonymous-asset-name.sunfish",
        defaultMessage: "Anonymous Sunfish"
    },
    sunflower: {
        id: "platform.anonymous-asset-name.sunflower",
        defaultMessage: "Anonymous Sunflower"
    },
    tiger: {
        id: "platform.anonymous-asset-name.tiger",
        defaultMessage: "Anonymous Tiger"
    },
    tomato: {
        id: "platform.anonymous-asset-name.tomato",
        defaultMessage: "Anonymous Tomato"
    },
    tortoise: {
        id: "platform.anonymous-asset-name.tortoise",
        defaultMessage: "Anonymous Tortoise"
    },
    tree: {
        id: "platform.anonymous-asset-name.tree",
        defaultMessage: "Anonymous Tree"
    },
    trex: {
        id: "platform.anonymous-asset-name.trex",
        defaultMessage: "Anonymous T-rex"
    },
    trout: {
        id: "platform.anonymous-asset-name.trout",
        defaultMessage: "Anonymous Trout"
    },
    turkey: {
        id: "platform.anonymous-asset-name.turkey",
        defaultMessage: "Anonymous Turkey"
    },
    turtle: {
        id: "platform.anonymous-asset-name.turtle",
        defaultMessage: "Anonymous Turtle"
    },
    wasp: {
        id: "platform.anonymous-asset-name.wasp",
        defaultMessage: "Anonymous Wasp"
    },
    watermelon: {
        id: "platform.anonymous-asset-name.watermelon",
        defaultMessage: "Anonymous Watermelon"
    },
    whale: {
        id: "platform.anonymous-asset-name.whale",
        defaultMessage: "Anonymous Whale"
    },
    wolf: {
        id: "platform.anonymous-asset-name.wolf",
        defaultMessage: "Anonymous Wolf"
    }
});
module.exports["messages"] = $52c1b6ebf0043fde$export$defe85febe8b728c;

});

parcelRegister("hDQT9", function(module, exports) {
module.exports = new URL("apple.ee886279.svg", import.meta.url).toString();

});

parcelRegister("01Y7m", function(module, exports) {
module.exports = new URL("avocado.8855629b.svg", import.meta.url).toString();

});

parcelRegister("hYUzZ", function(module, exports) {
module.exports = new URL("badger.0fb3ff8d.svg", import.meta.url).toString();

});

parcelRegister("iuR2u", function(module, exports) {
module.exports = new URL("bat.3a3e8172.svg", import.meta.url).toString();

});

parcelRegister("kkbx9", function(module, exports) {
module.exports = new URL("bear.6250dade.svg", import.meta.url).toString();

});

parcelRegister("cFEKY", function(module, exports) {
module.exports = new URL("beaver.72239cbc.svg", import.meta.url).toString();

});

parcelRegister("6Ytc9", function(module, exports) {
module.exports = new URL("bee.1d8bfe50.svg", import.meta.url).toString();

});

parcelRegister("6I2hp", function(module, exports) {
module.exports = new URL("bison.4fe77735.svg", import.meta.url).toString();

});

parcelRegister("9jRbs", function(module, exports) {
module.exports = new URL("blossom.90b2a1c3.svg", import.meta.url).toString();

});

parcelRegister("doHfX", function(module, exports) {
module.exports = new URL("blowfish.8afad7f1.svg", import.meta.url).toString();

});

parcelRegister("iQQz2", function(module, exports) {
module.exports = new URL("blueberries.688d225d.svg", import.meta.url).toString();

});

parcelRegister("6aQGf", function(module, exports) {
module.exports = new URL("boar.15310caf.svg", import.meta.url).toString();

});

parcelRegister("rKSC9", function(module, exports) {
module.exports = new URL("broccoli.fa9fd55e.svg", import.meta.url).toString();

});

parcelRegister("1HhEl", function(module, exports) {
module.exports = new URL("butterfly.f41d19d4.svg", import.meta.url).toString();

});

parcelRegister("59SWb", function(module, exports) {
module.exports = new URL("cactus.0c5c265c.svg", import.meta.url).toString();

});

parcelRegister("sNNnf", function(module, exports) {
module.exports = new URL("camel.6111d481.svg", import.meta.url).toString();

});

parcelRegister("3lBYI", function(module, exports) {
module.exports = new URL("candy.ffd5e59f.svg", import.meta.url).toString();

});

parcelRegister("4xgJQ", function(module, exports) {
module.exports = new URL("capsicum.30f76734.svg", import.meta.url).toString();

});

parcelRegister("h2x1V", function(module, exports) {
module.exports = new URL("carrot.6193f6d7.svg", import.meta.url).toString();

});

parcelRegister("dpF2z", function(module, exports) {
module.exports = new URL("cat.154e1595.svg", import.meta.url).toString();

});

parcelRegister("1sURO", function(module, exports) {
module.exports = new URL("caterpiller.1b6fd239.svg", import.meta.url).toString();

});

parcelRegister("97Vlu", function(module, exports) {
module.exports = new URL("cherry.087938da.svg", import.meta.url).toString();

});

parcelRegister("kVpsY", function(module, exports) {
module.exports = new URL("chili.27401d1a.svg", import.meta.url).toString();

});

parcelRegister("hCuul", function(module, exports) {
module.exports = new URL("clover.296ea840.svg", import.meta.url).toString();

});

parcelRegister("fuLed", function(module, exports) {
module.exports = new URL("coconut.69480f00.svg", import.meta.url).toString();

});

parcelRegister("3kpwJ", function(module, exports) {
module.exports = new URL("cookie.099bb841.svg", import.meta.url).toString();

});

parcelRegister("ei5ou", function(module, exports) {
module.exports = new URL("corn.f527dc60.svg", import.meta.url).toString();

});

parcelRegister("jveHG", function(module, exports) {
module.exports = new URL("cow.e41482e6.svg", import.meta.url).toString();

});

parcelRegister("kG0T4", function(module, exports) {
module.exports = new URL("crab.39812367.svg", import.meta.url).toString();

});

parcelRegister("iq6me", function(module, exports) {
module.exports = new URL("crocodile.221fa99c.svg", import.meta.url).toString();

});

parcelRegister("amt9P", function(module, exports) {
module.exports = new URL("deer.3662e324.svg", import.meta.url).toString();

});

parcelRegister("unK7p", function(module, exports) {
module.exports = new URL("dinosaur.e5c6efb5.svg", import.meta.url).toString();

});

parcelRegister("7myjl", function(module, exports) {
module.exports = new URL("dodo.a7114237.svg", import.meta.url).toString();

});

parcelRegister("c3CGq", function(module, exports) {
module.exports = new URL("dog.6630bd37.svg", import.meta.url).toString();

});

parcelRegister("73XLd", function(module, exports) {
module.exports = new URL("dolphin.3052ec02.svg", import.meta.url).toString();

});

parcelRegister("4O6RS", function(module, exports) {
module.exports = new URL("donut.e4649522.svg", import.meta.url).toString();

});

parcelRegister("1GH6m", function(module, exports) {
module.exports = new URL("dragon.4b6d8278.svg", import.meta.url).toString();

});

parcelRegister("1HXyl", function(module, exports) {
module.exports = new URL("duck.e8819dfa.svg", import.meta.url).toString();

});

parcelRegister("htAoo", function(module, exports) {
module.exports = new URL("elephant.f64545b1.svg", import.meta.url).toString();

});

parcelRegister("0547j", function(module, exports) {
module.exports = new URL("fish.91063cf4.svg", import.meta.url).toString();

});

parcelRegister("cgVUh", function(module, exports) {
module.exports = new URL("flamingo.2d59f884.svg", import.meta.url).toString();

});

parcelRegister("cQ8lp", function(module, exports) {
module.exports = new URL("fox.c1068dfa.svg", import.meta.url).toString();

});

parcelRegister("5JQ20", function(module, exports) {
module.exports = new URL("frog.4c69f05a.svg", import.meta.url).toString();

});

parcelRegister("2YPi6", function(module, exports) {
module.exports = new URL("giraffe.65216e18.svg", import.meta.url).toString();

});

parcelRegister("cdkwi", function(module, exports) {
module.exports = new URL("gorilla.51f05093.svg", import.meta.url).toString();

});

parcelRegister("kh1OZ", function(module, exports) {
module.exports = new URL("grapes.6a50728f.svg", import.meta.url).toString();

});

parcelRegister("8Sl6f", function(module, exports) {
module.exports = new URL("hedgehog.4cc9668b.svg", import.meta.url).toString();

});

parcelRegister("9Qn7m", function(module, exports) {
module.exports = new URL("hippo.81684e99.svg", import.meta.url).toString();

});

parcelRegister("3vrZh", function(module, exports) {
module.exports = new URL("kangaroo.099f9dd4.svg", import.meta.url).toString();

});

parcelRegister("2InqY", function(module, exports) {
module.exports = new URL("kiwi.13ce1a05.svg", import.meta.url).toString();

});

parcelRegister("dWYu6", function(module, exports) {
module.exports = new URL("koala.730a01eb.svg", import.meta.url).toString();

});

parcelRegister("e4PgN", function(module, exports) {
module.exports = new URL("lemon.7d7dfe19.svg", import.meta.url).toString();

});

parcelRegister("19hVO", function(module, exports) {
module.exports = new URL("lettuce.39b86ec6.svg", import.meta.url).toString();

});

parcelRegister("2UNgz", function(module, exports) {
module.exports = new URL("lion.191125b1.svg", import.meta.url).toString();

});

parcelRegister("fVzqf", function(module, exports) {
module.exports = new URL("lizard.de3c3103.svg", import.meta.url).toString();

});

parcelRegister("lj2Ls", function(module, exports) {
module.exports = new URL("llama.d767d641.svg", import.meta.url).toString();

});

parcelRegister("fr7Nb", function(module, exports) {
module.exports = new URL("lobster.2b4a4d94.svg", import.meta.url).toString();

});

parcelRegister("3Xksf", function(module, exports) {
module.exports = new URL("mango.6b9252cb.svg", import.meta.url).toString();

});

parcelRegister("bBmIz", function(module, exports) {
module.exports = new URL("melon.9c97f1e1.svg", import.meta.url).toString();

});

parcelRegister("gYk9S", function(module, exports) {
module.exports = new URL("monkey.423f2177.svg", import.meta.url).toString();

});

parcelRegister("iii2c", function(module, exports) {
module.exports = new URL("mouse.3d0aefe8.svg", import.meta.url).toString();

});

parcelRegister("2AIpZ", function(module, exports) {
module.exports = new URL("octopus.2c0d1056.svg", import.meta.url).toString();

});

parcelRegister("apAKP", function(module, exports) {
module.exports = new URL("olive.3e3e2c53.svg", import.meta.url).toString();

});

parcelRegister("eHyqm", function(module, exports) {
module.exports = new URL("orange.ed5e97f9.svg", import.meta.url).toString();

});

parcelRegister("3qxDD", function(module, exports) {
module.exports = new URL("orangutan.9fa13362.svg", import.meta.url).toString();

});

parcelRegister("eHLy0", function(module, exports) {
module.exports = new URL("otter.1b9e17fe.svg", import.meta.url).toString();

});

parcelRegister("kdS3N", function(module, exports) {
module.exports = new URL("owl.13d3c4d9.svg", import.meta.url).toString();

});

parcelRegister("1Sij2", function(module, exports) {
module.exports = new URL("ox.0ed06fd3.svg", import.meta.url).toString();

});

parcelRegister("3pGfT", function(module, exports) {
module.exports = new URL("oyster.ad23795d.svg", import.meta.url).toString();

});

parcelRegister("4LuNj", function(module, exports) {
module.exports = new URL("panda.0b0047af.svg", import.meta.url).toString();

});

parcelRegister("9gWob", function(module, exports) {
module.exports = new URL("parrot.6fd92eec.svg", import.meta.url).toString();

});

parcelRegister("dRNzY", function(module, exports) {
module.exports = new URL("peacock.80ac60a6.svg", import.meta.url).toString();

});

parcelRegister("iMJSX", function(module, exports) {
module.exports = new URL("pear.c8d37fb0.svg", import.meta.url).toString();

});

parcelRegister("5cLsu", function(module, exports) {
module.exports = new URL("penguin.6577e559.svg", import.meta.url).toString();

});

parcelRegister("iN75X", function(module, exports) {
module.exports = new URL("pig.2ba131ea.svg", import.meta.url).toString();

});

parcelRegister("dKZNQ", function(module, exports) {
module.exports = new URL("pineapple.61ebb967.svg", import.meta.url).toString();

});

parcelRegister("3N5nT", function(module, exports) {
module.exports = new URL("poodle.b40487d6.svg", import.meta.url).toString();

});

parcelRegister("gAbKd", function(module, exports) {
module.exports = new URL("rabbit.b4ce71c1.svg", import.meta.url).toString();

});

parcelRegister("3KwZg", function(module, exports) {
module.exports = new URL("raccoon.16b4372e.svg", import.meta.url).toString();

});

parcelRegister("53QJP", function(module, exports) {
module.exports = new URL("rhino.6dcdebb2.svg", import.meta.url).toString();

});

parcelRegister("3tNjt", function(module, exports) {
module.exports = new URL("robot.fdf311ba.svg", import.meta.url).toString();

});

parcelRegister("1QOVp", function(module, exports) {
module.exports = new URL("rose.22a6e8e6.svg", import.meta.url).toString();

});

parcelRegister("8BdMq", function(module, exports) {
module.exports = new URL("seal.de226e3b.svg", import.meta.url).toString();

});

parcelRegister("kzKxq", function(module, exports) {
module.exports = new URL("seedling.562f3bc0.svg", import.meta.url).toString();

});

parcelRegister("2bFMn", function(module, exports) {
module.exports = new URL("shark.af44e0c5.svg", import.meta.url).toString();

});

parcelRegister("1mGLL", function(module, exports) {
module.exports = new URL("shrimp.116d9eea.svg", import.meta.url).toString();

});

parcelRegister("6hNPs", function(module, exports) {
module.exports = new URL("skunk.a5578a4f.svg", import.meta.url).toString();

});

parcelRegister("swN6A", function(module, exports) {
module.exports = new URL("sloth.f3e9da22.svg", import.meta.url).toString();

});

parcelRegister("jlxMa", function(module, exports) {
module.exports = new URL("snail.06380b65.svg", import.meta.url).toString();

});

parcelRegister("hY9h4", function(module, exports) {
module.exports = new URL("snake.3ead898b.svg", import.meta.url).toString();

});

parcelRegister("21edV", function(module, exports) {
module.exports = new URL("snowman.cdcd9574.svg", import.meta.url).toString();

});

parcelRegister("i42iL", function(module, exports) {
module.exports = new URL("squid.0638299b.svg", import.meta.url).toString();

});

parcelRegister("5brqg", function(module, exports) {
module.exports = new URL("squirrel.e3a31ee3.svg", import.meta.url).toString();

});

parcelRegister("55gO3", function(module, exports) {
module.exports = new URL("strawberry.4111dfb6.svg", import.meta.url).toString();

});

parcelRegister("2cB6n", function(module, exports) {
module.exports = new URL("sunflower.ff291a55.svg", import.meta.url).toString();

});

parcelRegister("drBaG", function(module, exports) {
module.exports = new URL("tiger.2ba2da26.svg", import.meta.url).toString();

});

parcelRegister("6OMjq", function(module, exports) {
module.exports = new URL("tomato.e755033f.svg", import.meta.url).toString();

});

parcelRegister("8MYut", function(module, exports) {
module.exports = new URL("tree.e62f2602.svg", import.meta.url).toString();

});

parcelRegister("j8C9j", function(module, exports) {
module.exports = new URL("t-rex.d85831fb.svg", import.meta.url).toString();

});

parcelRegister("6yJEz", function(module, exports) {
module.exports = new URL("tropical-fish.797d455e.svg", import.meta.url).toString();

});

parcelRegister("dtUp6", function(module, exports) {
module.exports = new URL("turkey.a79defab.svg", import.meta.url).toString();

});

parcelRegister("isP63", function(module, exports) {
module.exports = new URL("turtle.acbe0058.svg", import.meta.url).toString();

});

parcelRegister("9lleE", function(module, exports) {
module.exports = new URL("watermelon.199e013c.svg", import.meta.url).toString();

});

parcelRegister("5uWd9", function(module, exports) {
module.exports = new URL("whale.cc048b8e.svg", import.meta.url).toString();

});

parcelRegister("iIHIG", function(module, exports) {
module.exports = new URL("wolf.a39956da.svg", import.meta.url).toString();

});

parcelRegister("ecHHC", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $1hQ0e = parcelRequire("1hQ0e");


var $2EIXa = parcelRequire("2EIXa");


var $1XjTg = parcelRequire("1XjTg");

const $3bd1d010186fe7d0$var$localeMap = {
    pt: 'pt-BR',
    'pt-PT': 'pt-BR',
    'en-AU': 'en-GB'
};
const $3bd1d010186fe7d0$var$intlCacheMap = new Map();
const $3bd1d010186fe7d0$export$51771ec7613ad564 = async ()=>{
    const key = (0, $1hQ0e.getDocument)()?.documentElement?.lang || 'en-US';
    if (!$3bd1d010186fe7d0$var$intlCacheMap.has(key)) {
        const messages = await $3bd1d010186fe7d0$var$fetchMessages(key);
        const cache = (0, $kSwu1.createIntlCache)();
        const intl = (0, $kSwu1.createIntl)({
            locale: key,
            messages: messages
        }, cache);
        $3bd1d010186fe7d0$var$intlCacheMap.set(key, intl);
    }
    return $3bd1d010186fe7d0$var$intlCacheMap.get(key);
};
const $3bd1d010186fe7d0$var$fetchMessages = async (locale)=>{
    try {
        const targetLocale = ($3bd1d010186fe7d0$var$localeMap[locale] ?? locale ?? '').replace('-', '_');
        if (targetLocale in (0, $2EIXa.locales)) {
            const messages = await (0, $2EIXa.locales)[targetLocale]();
            return messages.default;
        }
        const parentLocale = locale.split(/[-_]/)[0];
        if (parentLocale in (0, $2EIXa.locales)) {
            const messages = await (0, $2EIXa.locales)[parentLocale]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
    /**
   * English bundled by default as this is the majority of users
   */ return 0, $1XjTg.default;
};
module.exports["getIntl"] = $3bd1d010186fe7d0$export$51771ec7613ad564;

});

parcelRegister("2EIXa", function(module, exports) {




























const $85bfd356356e38c7$export$df1c34db1371eeed = {
    en: ()=>Promise.resolve((parcelRequire("1XjTg"))),
    cs: ()=>(parcelRequire("c5iVz")),
    da: ()=>(parcelRequire("cKTv6")),
    de: ()=>(parcelRequire("ba7qQ")),
    en_GB: ()=>(parcelRequire("fIKLP")),
    en_ZZ: ()=>(parcelRequire("lVpcM")),
    es: ()=>(parcelRequire("5MC3a")),
    fi: ()=>(parcelRequire("lbr9Z")),
    fr: ()=>(parcelRequire("gfgLh")),
    hr: ()=>(parcelRequire("icWxs")),
    hu: ()=>(parcelRequire("l4lhV")),
    it: ()=>(parcelRequire("8txuZ")),
    ja: ()=>(parcelRequire("lcXoz")),
    ko: ()=>(parcelRequire("e5NrO")),
    nb: ()=>(parcelRequire("b8oPP")),
    nl: ()=>(parcelRequire("imK3v")),
    pl: ()=>(parcelRequire("lvXZc")),
    pt_BR: ()=>(parcelRequire("fojwr")),
    ru: ()=>(parcelRequire("g4Br4")),
    sr_RS: ()=>(parcelRequire("hnd9o")),
    sr_YR: ()=>(parcelRequire("hILXZ")),
    sv: ()=>(parcelRequire("lejHX")),
    th: ()=>(parcelRequire("ka0If")),
    tr: ()=>(parcelRequire("36Auo")),
    uk: ()=>(parcelRequire("9eUA6")),
    vi: ()=>(parcelRequire("kytde")),
    zh: ()=>(parcelRequire("4xtb4")),
    zh_TW: ()=>(parcelRequire("c0Rct"))
};
module.exports["locales"] = $85bfd356356e38c7$export$df1c34db1371eeed;

});

parcelRegister("c5iVz", function(module, exports) {

let $8cc4a2443282ceff$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8cc4a2443282ceff$var$load("8QW6R").then(()=>parcelRequire('4mdX2'));

});

parcelRegister("cKTv6", function(module, exports) {

let $9494d53681d834cb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9494d53681d834cb$var$load("awxdk").then(()=>parcelRequire('eyLXS'));

});

parcelRegister("ba7qQ", function(module, exports) {

let $820664b746ea9374$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $820664b746ea9374$var$load("5mEC2").then(()=>parcelRequire('55NFn'));

});

parcelRegister("fIKLP", function(module, exports) {

let $b71f3eb9195aa892$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b71f3eb9195aa892$var$load("fu2xp").then(()=>parcelRequire('czahw'));

});

parcelRegister("lVpcM", function(module, exports) {

let $ff62790ade421c02$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ff62790ade421c02$var$load("5zM7C").then(()=>parcelRequire('dTXdc'));

});

parcelRegister("5MC3a", function(module, exports) {

let $435ef369ce6bcd83$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $435ef369ce6bcd83$var$load("batm0").then(()=>parcelRequire('4u9wg'));

});

parcelRegister("lbr9Z", function(module, exports) {

let $f6bfb18052abcbf3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f6bfb18052abcbf3$var$load("3AVnS").then(()=>parcelRequire('4ntN9'));

});

parcelRegister("gfgLh", function(module, exports) {

let $bd3b0c896a7b5931$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bd3b0c896a7b5931$var$load("51j60").then(()=>parcelRequire('02VrM'));

});

parcelRegister("icWxs", function(module, exports) {

let $d416c18bc8da1813$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d416c18bc8da1813$var$load("2b71C").then(()=>parcelRequire('9tr0O'));

});

parcelRegister("l4lhV", function(module, exports) {

let $f56a7c183817b9d7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f56a7c183817b9d7$var$load("2JFq0").then(()=>parcelRequire('fQhwW'));

});

parcelRegister("8txuZ", function(module, exports) {

let $62bb0457f716dbd3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $62bb0457f716dbd3$var$load("5f16k").then(()=>parcelRequire('gdp3a'));

});

parcelRegister("lcXoz", function(module, exports) {

let $f708ca9bf4c70287$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f708ca9bf4c70287$var$load("56V0s").then(()=>parcelRequire('8GtTX'));

});

parcelRegister("e5NrO", function(module, exports) {

let $a427e3982aeb4a03$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a427e3982aeb4a03$var$load("l8lGz").then(()=>parcelRequire('aYRuH'));

});

parcelRegister("b8oPP", function(module, exports) {

let $81b3b4c4c8461dbb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $81b3b4c4c8461dbb$var$load("hlqmT").then(()=>parcelRequire('14Tag'));

});

parcelRegister("imK3v", function(module, exports) {

let $d5ee01ba6cbe8436$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d5ee01ba6cbe8436$var$load("2s2yj").then(()=>parcelRequire('iMXzI'));

});

parcelRegister("lvXZc", function(module, exports) {

let $fa9b0632ba688ead$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fa9b0632ba688ead$var$load("8ozt0").then(()=>parcelRequire('h20wn'));

});

parcelRegister("fojwr", function(module, exports) {

let $b3483da11a3b950e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b3483da11a3b950e$var$load("g88j4").then(()=>parcelRequire('8J3ag'));

});

parcelRegister("g4Br4", function(module, exports) {

let $bb3a0efcec506624$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bb3a0efcec506624$var$load("fev14").then(()=>parcelRequire('hWxo6'));

});

parcelRegister("hnd9o", function(module, exports) {

let $ca5ec90f467ce7de$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ca5ec90f467ce7de$var$load("9PBHw").then(()=>parcelRequire('9hkS6'));

});

parcelRegister("hILXZ", function(module, exports) {

let $ce6bc0e0a0642b0c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ce6bc0e0a0642b0c$var$load("1L95h").then(()=>parcelRequire('cDAjj'));

});

parcelRegister("lejHX", function(module, exports) {

let $f74a3165a8a03385$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f74a3165a8a03385$var$load("jtWXB").then(()=>parcelRequire('gblRe'));

});

parcelRegister("ka0If", function(module, exports) {

let $ead54b51938002ef$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ead54b51938002ef$var$load("hY0sT").then(()=>parcelRequire('kCJ7N'));

});

parcelRegister("36Auo", function(module, exports) {

let $242e3c9e966f6b26$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $242e3c9e966f6b26$var$load("itQsm").then(()=>parcelRequire('aOIVH'));

});

parcelRegister("9eUA6", function(module, exports) {

let $6ba14fb6b210bd41$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6ba14fb6b210bd41$var$load("jMJn5").then(()=>parcelRequire('iW3aI'));

});

parcelRegister("kytde", function(module, exports) {

let $ef6da49931e0d3f3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ef6da49931e0d3f3$var$load("1wgqd").then(()=>parcelRequire('evzRl'));

});

parcelRegister("4xtb4", function(module, exports) {

let $34e0e0881054a2f0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $34e0e0881054a2f0$var$load("fv30i").then(()=>parcelRequire('lWYHM'));

});

parcelRegister("c0Rct", function(module, exports) {

let $0241c94c98c6e436$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0241c94c98c6e436$var$load("hL7rW").then(()=>parcelRequire('3cYOH'));

});

parcelRegister("1XjTg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $e1e566f32a0c97fd$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $hkAF2 = parcelRequire("hkAF2");

var $e1e566f32a0c97fd$export$2e2bcd8739ae039 = (0, $hkAF2.default);

});

parcelRegister("hkAF2", function(module, exports) {
$parcel$export(module.exports, "default", () => $a4e8f77ee27d7e3a$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $a4e8f77ee27d7e3a$export$2e2bcd8739ae039 = {
    'platform.anonymous-asset-name.alligator': 'Anonymous Alligator',
    'platform.anonymous-asset-name.alpaca': 'Anonymous Alpaca',
    'platform.anonymous-asset-name.ape': 'Anonymous Ape',
    'platform.anonymous-asset-name.apple': 'Anonymous Apple',
    'platform.anonymous-asset-name.avocado': 'Anonymous Avocado',
    'platform.anonymous-asset-name.baboon': 'Anonymous Baboon',
    'platform.anonymous-asset-name.badger': 'Anonymous Badger',
    'platform.anonymous-asset-name.bat': 'Anonymous Bat',
    'platform.anonymous-asset-name.bear': 'Anonymous Bear',
    'platform.anonymous-asset-name.beaver': 'Anonymous Beaver',
    'platform.anonymous-asset-name.bee': 'Anonymous Bee',
    'platform.anonymous-asset-name.bird': 'Anonymous Bird',
    'platform.anonymous-asset-name.bison': 'Anonymous Bison',
    'platform.anonymous-asset-name.blobfish': 'Anonymous Blobfish',
    'platform.anonymous-asset-name.blossom': 'Anonymous Blossom',
    'platform.anonymous-asset-name.blowfish': 'Anonymous Blowfish',
    'platform.anonymous-asset-name.blueberries': 'Anonymous Blueberries',
    'platform.anonymous-asset-name.boar': 'Anonymous Boar',
    'platform.anonymous-asset-name.broccoli': 'Anonymous Broccoli',
    'platform.anonymous-asset-name.buffalo': 'Anonymous Buffalo',
    'platform.anonymous-asset-name.bug': 'Anonymous Bug',
    'platform.anonymous-asset-name.bull': 'Anonymous Bull',
    'platform.anonymous-asset-name.bunny': 'Anonymous Bunny',
    'platform.anonymous-asset-name.butterfly': 'Anonymous Butterfly',
    'platform.anonymous-asset-name.cactus': 'Anonymous Cactus',
    'platform.anonymous-asset-name.camel': 'Anonymous Camel',
    'platform.anonymous-asset-name.candy': 'Anonymous Candy',
    'platform.anonymous-asset-name.cantaloupe': 'Anonymous Cantaloupe',
    'platform.anonymous-asset-name.capsicum': 'Anonymous Capsicum',
    'platform.anonymous-asset-name.carrot': 'Anonymous Carrot',
    'platform.anonymous-asset-name.cat': 'Anonymous Cat',
    'platform.anonymous-asset-name.caterpiller': 'Anonymous Caterpiller',
    'platform.anonymous-asset-name.chameleon': 'Anonymous Chameleon',
    'platform.anonymous-asset-name.cherry': 'Anonymous Cherry',
    'platform.anonymous-asset-name.chili': 'Anonymous Chili',
    'platform.anonymous-asset-name.chimp': 'Anonymous Chimp',
    'platform.anonymous-asset-name.chimpanzee': 'Anonymous Chimpanzee',
    'platform.anonymous-asset-name.clover': 'Anonymous Clover',
    'platform.anonymous-asset-name.clownfish': 'Anonymous Clownfish',
    'platform.anonymous-asset-name.cobra': 'Anonymous Cobra',
    'platform.anonymous-asset-name.coconut': 'Anonymous Coconut',
    'platform.anonymous-asset-name.cod': 'Anonymous Cod',
    'platform.anonymous-asset-name.cookie': 'Anonymous Cookie',
    'platform.anonymous-asset-name.corn': 'Anonymous Corn',
    'platform.anonymous-asset-name.cow': 'Anonymous Cow',
    'platform.anonymous-asset-name.crab': 'Anonymous Crab',
    'platform.anonymous-asset-name.crocodile': 'Anonymous Crocodile',
    'platform.anonymous-asset-name.deer': 'Anonymous Deer',
    'platform.anonymous-asset-name.dinosaur': 'Anonymous Dinosaur',
    'platform.anonymous-asset-name.dodo': 'Anonymous Dodo',
    'platform.anonymous-asset-name.dog': 'Anonymous Dog',
    'platform.anonymous-asset-name.dolphin': 'Anonymous Dolphin',
    'platform.anonymous-asset-name.donut': 'Anonymous Donut',
    'platform.anonymous-asset-name.dragon': 'Anonymous Dragon',
    'platform.anonymous-asset-name.duck': 'Anonymous Duck',
    'platform.anonymous-asset-name.elephant': 'Anonymous Elephant',
    'platform.anonymous-asset-name.elk': 'Anonymous Elk',
    'platform.anonymous-asset-name.fish': 'Anonymous Fish',
    'platform.anonymous-asset-name.flamingo': 'Anonymous Flamingo',
    'platform.anonymous-asset-name.fox': 'Anonymous Fox',
    'platform.anonymous-asset-name.frog': 'Anonymous Frog',
    'platform.anonymous-asset-name.gecko': 'Anonymous Gecko',
    'platform.anonymous-asset-name.giraffe': 'Anonymous Giraffe',
    'platform.anonymous-asset-name.gorilla': 'Anonymous Gorilla',
    'platform.anonymous-asset-name.grape': 'Anonymous Grape',
    'platform.anonymous-asset-name.hammerhead': 'Anonymous Hammerhead',
    'platform.anonymous-asset-name.hedgehog': 'Anonymous Hedgehog',
    'platform.anonymous-asset-name.hippo': 'Anonymous Hippo',
    'platform.anonymous-asset-name.kangaroo': 'Anonymous Kangaroo',
    'platform.anonymous-asset-name.kitten': 'Anonymous Kitten',
    'platform.anonymous-asset-name.kiwi': 'Anonymous Kiwi',
    'platform.anonymous-asset-name.koala': 'Anonymous Koala',
    'platform.anonymous-asset-name.lemon': 'Anonymous Lemon',
    'platform.anonymous-asset-name.leopard': 'Anonymous Leopard',
    'platform.anonymous-asset-name.lettuce': 'Anonymous Lettuce',
    'platform.anonymous-asset-name.lion': 'Anonymous Lion',
    'platform.anonymous-asset-name.lizard': 'Anonymous Lizard',
    'platform.anonymous-asset-name.llama': 'Anonymous Llama',
    'platform.anonymous-asset-name.lobster': 'Anonymous Lobster',
    'platform.anonymous-asset-name.macaque': 'Anonymous Macaque',
    'platform.anonymous-asset-name.mango': 'Anonymous Mango',
    'platform.anonymous-asset-name.melon': 'Anonymous Melon',
    'platform.anonymous-asset-name.millipede': 'Anonymous Millipede',
    'platform.anonymous-asset-name.monkey': 'Anonymous Monkey',
    'platform.anonymous-asset-name.mouse': 'Anonymous Mouse',
    'platform.anonymous-asset-name.octopus': 'Anonymous Octopus',
    'platform.anonymous-asset-name.olive': 'Anonymous Olive',
    'platform.anonymous-asset-name.orange': 'Anonymous Orange',
    'platform.anonymous-asset-name.orangutan': 'Anonymous Orangutan',
    'platform.anonymous-asset-name.otter': 'Anonymous Otter',
    'platform.anonymous-asset-name.owl': 'Anonymous Owl',
    'platform.anonymous-asset-name.ox': 'Anonymous Ox',
    'platform.anonymous-asset-name.oyster': 'Anonymous Oyster',
    'platform.anonymous-asset-name.panda': 'Anonymous Panda',
    'platform.anonymous-asset-name.parrot': 'Anonymous Parrot',
    'platform.anonymous-asset-name.peacock': 'Anonymous Peacock',
    'platform.anonymous-asset-name.pear': 'Anonymous Pear',
    'platform.anonymous-asset-name.penguin': 'Anonymous Penguin',
    'platform.anonymous-asset-name.pig': 'Anonymous Pig',
    'platform.anonymous-asset-name.pineapple': 'Anonymous Pineapple',
    'platform.anonymous-asset-name.poodle': 'Anonymous Poodle',
    'platform.anonymous-asset-name.puppy': 'Anonymous Puppy',
    'platform.anonymous-asset-name.python': 'Anonymous Python',
    'platform.anonymous-asset-name.rabbit': 'Anonymous Rabbit',
    'platform.anonymous-asset-name.raccoon': 'Anonymous Raccoon',
    'platform.anonymous-asset-name.rat': 'Anonymous Rat',
    'platform.anonymous-asset-name.rhino': 'Anonymous Rhino',
    'platform.anonymous-asset-name.robot': 'Anonymous Robot',
    'platform.anonymous-asset-name.rose': 'Anonymous Rose',
    'platform.anonymous-asset-name.seal': 'Anonymous Seal',
    'platform.anonymous-asset-name.seedling': 'Anonymous Seedling',
    'platform.anonymous-asset-name.shark': 'Anonymous Shark',
    'platform.anonymous-asset-name.shrimp': 'Anonymous Shrimp',
    'platform.anonymous-asset-name.skunk': 'Anonymous Skunk',
    'platform.anonymous-asset-name.sloth': 'Anonymous Sloth',
    'platform.anonymous-asset-name.snail': 'Anonymous Snail',
    'platform.anonymous-asset-name.snake': 'Anonymous Snake',
    'platform.anonymous-asset-name.snowman': 'Anonymous Snowman',
    'platform.anonymous-asset-name.squid': 'Anonymous Squid',
    'platform.anonymous-asset-name.squirrel': 'Anonymous Squirrel',
    'platform.anonymous-asset-name.strawberry': 'Anonymous Strawberry',
    'platform.anonymous-asset-name.sunfish': 'Anonymous Sunfish',
    'platform.anonymous-asset-name.sunflower': 'Anonymous Sunflower',
    'platform.anonymous-asset-name.tiger': 'Anonymous Tiger',
    'platform.anonymous-asset-name.tomato': 'Anonymous Tomato',
    'platform.anonymous-asset-name.tortoise': 'Anonymous Tortoise',
    'platform.anonymous-asset-name.tree': 'Anonymous Tree',
    'platform.anonymous-asset-name.trex': 'Anonymous T-rex',
    'platform.anonymous-asset-name.trout': 'Anonymous Trout',
    'platform.anonymous-asset-name.turkey': 'Anonymous Turkey',
    'platform.anonymous-asset-name.turtle': 'Anonymous Turtle',
    'platform.anonymous-asset-name.wasp': 'Anonymous Wasp',
    'platform.anonymous-asset-name.watermelon': 'Anonymous Watermelon',
    'platform.anonymous-asset-name.whale': 'Anonymous Whale',
    'platform.anonymous-asset-name.wolf': 'Anonymous Wolf'
};

});

parcelRegister("9mfmQ", function(module, exports) {
const $3f8e2a2fed025998$export$435a991cb82816ff = (retryCount, initialDelay = 1000, maxDelay = 30000, factor = 2)=>{
    // Calculate exponential backoff
    const delay = Math.min(initialDelay * Math.pow(factor, retryCount), maxDelay);
    // Add random jitter (between 0 and current delay value)
    return Math.floor(Math.random() * delay);
};
const $3f8e2a2fed025998$export$cffaac380b94df26 = async ({ url: url, options: options, shouldRetryOnApiError: shouldRetryOnApiError, retries: retries = 3, baseDelay: baseDelay = 300, maxDelay: maxDelay = 10000 })=>{
    try {
        const response = await fetch(url, options);
        if (response.ok) return {
            success: true,
            result: response
        };
        if (shouldRetryOnApiError) throw new Error('Failed request with an error');
        const errorBody = await response.json();
        return {
            success: false,
            error: new Error(errorBody)
        };
    } catch (error) {
        if (retries > 0) {
            const retryDelay = $3f8e2a2fed025998$export$435a991cb82816ff(retries, baseDelay, maxDelay);
            await new Promise((resolve)=>setTimeout(resolve, retryDelay));
            return $3f8e2a2fed025998$export$cffaac380b94df26({
                url: url,
                options: options,
                shouldRetryOnApiError: shouldRetryOnApiError,
                retries: retries - 1,
                baseDelay: baseDelay,
                maxDelay: maxDelay
            });
        }
        const newError = error instanceof Error ? error : new Error('An unknown error occurred');
        return {
            success: false,
            error: newError
        };
    }
};
module.exports["fetchWithRetry"] = $3f8e2a2fed025998$export$cffaac380b94df26;

});

parcelRegister("4GGNn", function(module, exports) {

var $jhbO3 = parcelRequire("jhbO3");


var $GLgaM = parcelRequire("GLgaM");


var $bjeS8 = parcelRequire("bjeS8");

async function $aeaa62655b9da260$export$4199ef03ec2aea3f({ url: url, method: method, headers: headers, body: body, credentials: credentials, variables: variables, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError }) {
    const fetchData = async ()=>{
        const json = await (0, $GLgaM.fetchResponse)({
            url: url,
            method: method,
            body: body,
            headers: headers,
            credentials: credentials,
            parseResponseOnSuccess: parseResponseOnSuccess,
            parseResponseOnError: parseResponseOnError
        }, variables);
        return await parseResult(json, variables);
    };
    const handleConvertToApolloError = async (error)=>{
        return (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    };
    return (0, $jhbO3.apolloCompatibleMutation)({
        fetchData: fetchData,
        onCompleted: onCompleted,
        onError: onError,
        convertToApolloError: handleConvertToApolloError
    });
}
module.exports["experimentalMutate"] = $aeaa62655b9da260$export$4199ef03ec2aea3f;

});

parcelRegister("jhwJP", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $8e78cdefc122a0a9$export$d1326a8d9df930b6 = (i18nBase, i18nLiveDocs)=>{
    const initializeData = (targetObj)=>{
        targetObj._data = (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? {
            ...i18nBase,
            ...i18nLiveDocs
        } : i18nBase;
        targetObj._initialized = true;
    };
    return new Proxy({}, {
        get: (targetObj, prop)=>{
            // Ensures retrieval of properties on i18n object use i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return targetObj._data[prop];
        },
        ownKeys: (targetObj)=>{
            // ensures `.keys` uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return Reflect.ownKeys(targetObj._data);
        },
        has: (targetObj, prop)=>{
            // Ensures for...in uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return prop in targetObj._data;
        },
        getOwnPropertyDescriptor: (targetObj, prop)=>{
            // Ensures i18n props are enumerable, required for ownKeys/etc to work
            if (!targetObj._initialized) initializeData(targetObj);
            const descriptor = Object.getOwnPropertyDescriptor(targetObj._data, prop);
            return descriptor ? {
                ...descriptor,
                enumerable: true
            } : undefined;
        }
    });
};
module.exports["mergeLiveDocI18n"] = $8e78cdefc122a0a9$export$d1326a8d9df930b6;

});

parcelRegister("i9VoI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6UYek = parcelRequire("6UYek");

const $357775eda04c1a81$export$63ba9f3f1b368ae8 = ({ onDataReceived: onDataReceived, skip: skip = false, contentId: contentId, contentType: contentType, delta: delta, subscriberId: subscriberId })=>{
    const dispatch = (0, $6UYek.useSubscriptionsDispatchContext)();
    const { setContentId: setContentId, setContentType: setContentType, removeSubscriber: removeSubscriber, addSubscriber: addSubscriber } = dispatch || {};
    (0, $cozmU.useEffect)(()=>{
        if (skip || !addSubscriber || !contentId || !contentType || !removeSubscriber) return;
        setContentId?.(contentId);
        setContentType?.(contentType);
        const uniqueSubscriberId = addSubscriber({
            delta: delta,
            subscriberId: subscriberId,
            onSubscriptionData: onDataReceived
        });
        return ()=>{
            removeSubscriber({
                delta: delta,
                subscriberId: uniqueSubscriberId
            });
        };
    }, [
        skip,
        dispatch,
        contentId,
        contentType,
        setContentId,
        setContentType,
        addSubscriber,
        removeSubscriber,
        subscriberId,
        delta,
        onDataReceived
    ]);
    return null;
};
module.exports["useSubscriptionEvent"] = $357775eda04c1a81$export$63ba9f3f1b368ae8;

});

parcelRegister("6UYek", function(module, exports) {

var $fbcPJ = parcelRequire("fbcPJ");


var $cozmU = parcelRequire("cozmU");


var $kyKWe = parcelRequire("kyKWe");


var $fD0Uz = parcelRequire("fD0Uz");


var $9wGTI = parcelRequire("9wGTI");


var $7Sm4c = parcelRequire("7Sm4c");


var $fJlJm = parcelRequire("fJlJm");


var $5ZqQS = parcelRequire("5ZqQS");


var $1xpoY = parcelRequire("1xpoY");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $3vc4U = parcelRequire("3vc4U");

const $da160e8fa3112de6$var$SubscriptionsContext = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $da160e8fa3112de6$var$SubscriptionsDispatchContext = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $da160e8fa3112de6$export$2612561ece05d878 = [
    '401',
    'Failed to fetch',
    'Load Failed',
    'Network error',
    'GraphQL error: undefined',
    'Auth category: UNAUTHENTICATED is not allowed in service confluence_monolith_subscriptions'
];
const $da160e8fa3112de6$var$getLegacyApolloError = (error)=>{
    if (!('errors' in error) || !Array.isArray(error.errors)) return undefined;
    const firstError = error.errors[0];
    return firstError && typeof firstError === 'object' ? firstError : undefined;
};
const $da160e8fa3112de6$var$getLegacyApolloErrorMessage = (error)=>{
    const firstError = $da160e8fa3112de6$var$getLegacyApolloError(error);
    if (!firstError || !('message' in firstError)) return undefined;
    return typeof firstError.message === 'string' ? firstError.message : undefined;
};
const $da160e8fa3112de6$var$getLegacyApolloErrorStatusCode = (error)=>{
    const firstError = $da160e8fa3112de6$var$getLegacyApolloError(error);
    if (!firstError || !('extensions' in firstError)) return undefined;
    const { extensions: extensions } = firstError;
    if (!extensions || typeof extensions !== 'object' || !('statusCode' in extensions)) return undefined;
    return typeof extensions.statusCode === 'number' ? extensions.statusCode : undefined;
};
const $da160e8fa3112de6$export$5f043fff8b6d3ca6 = ({ children: children })=>{
    const [contentModified, setContentModified] = (0, $cozmU.useState)(null);
    const [contentId, setContentId] = (0, $cozmU.useState)(null);
    const [contentType, setContentType] = (0, $cozmU.useState)(null);
    const subscribersRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef({});
    // if there are no subscribers left we set the contentId and contentType to null
    // remove subscriber on unmount of subscription component
    /***
   * Adds a subscriber to the context.
   * @delta - the delta to subscribe to
   * @subscriberId - an id for the subscriber, used to remove the subscriber later
   * @onSubscriptionData - callback to be called when data is received for the delta
   * @returns uniqueSubscriberId - a unique id for the subscriber, used to remove the subscriber later
   */ const addSubscriber = (0, $cozmU.useCallback)(({ subscriberId: subscriberId, onSubscriptionData: onSubscriptionData, delta: delta })=>{
        const subscribers = subscribersRef.current;
        const uniqueSubscriberId = `${subscriberId}-${(0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))()}`; // ensure unique subscriberId
        const currentSubscribersForDelta = subscribers?.[delta] || [];
        subscribers[delta] = [
            ...currentSubscribersForDelta,
            {
                id: uniqueSubscriberId,
                onSubscriptionData: onSubscriptionData
            }
        ];
        return uniqueSubscriberId;
    }, []);
    const removeSubscriber = (0, $cozmU.useCallback)(({ delta: delta, subscriberId: subscriberId })=>{
        const subscribers = subscribersRef.current;
        if (subscribers.hasOwnProperty(delta)) {
            subscribers[delta] = (subscribers[delta] ?? []).filter((sub)=>sub.id !== subscriberId);
            // if there are no subscribers left for this delta, we can remove the delta
            if (subscribers[delta].length === 0) {
                delete subscribers[delta];
                // if that was the last subscriber we can stop the subscription entirely
                if (Object.keys(subscribers).length === 0) {
                    setContentId(null);
                    setContentType(null);
                }
            }
        }
    }, [
        setContentId,
        setContentType
    ]);
    const callSubscribers = (0, $cozmU.useCallback)((deltas, data)=>{
        const subscribers = subscribersRef.current;
        deltas.forEach((delta)=>{
            const subscribersForDelta = subscribers[delta];
            if (subscribersForDelta) subscribersForDelta.forEach((subscriber)=>{
                const callback = subscriber?.onSubscriptionData?.(delta, data);
                if (callback instanceof Promise) Promise.resolve(callback).catch((err)=>{
                    (0, $5ZqQS.getMonitoringClient)().submitError(err, {
                        // hard coded as the package will cause circular dependency
                        attribution: 'page-experiences'
                    });
                });
            });
        });
    }, []);
    const { id: id, onSubscriptionComplete: onSubscriptionComplete, extensions: extensions, onSubscriptionData: onDataReceived } = (0, $3vc4U.useSubscriptionValues)({
        contentType: contentType,
        contentId: contentId
    });
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const skipSubscriptionForAnonUsers = accessStatus === (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS;
    const { error: error } = (0, $fD0Uz.useSubscriptionInterop)((0, $fbcPJ.default), {
        variables: {
            id: id,
            __extensions: extensions
        },
        extensions: extensions,
        onSubscriptionComplete: onSubscriptionComplete,
        onSubscriptionData (response) {
            onDataReceived(response);
            const { subscriptionData: subscriptionData } = response;
            if (!subscriptionData || !subscriptionData.data) return;
            const deltas = subscriptionData?.data?.confluence_onContentModified?._deltas;
            const data = subscriptionData?.data?.confluence_onContentModified;
            if (deltas && Array.isArray(deltas) && deltas.length > 0 && data) callSubscribers(deltas, data);
            setContentModified(data ?? null);
        },
        skip: !id || skipSubscriptionForAnonUsers || !(0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider'),
        interopApolloAggClient: true,
        __callerPackage__: "graphql"
    });
    (0, $cozmU.useEffect)(()=>{
        if (error) {
            const errorMessage = error?.message || $da160e8fa3112de6$var$getLegacyApolloErrorMessage(error) || error?.graphQLErrors?.[0]?.message || error?.graphQLErrors?.[0]?.originalError?.message || error?.graphQLErrors?.[0]?.extensions?.data?.errors?.[0]?.message || error?.graphQLErrors?.[0]?.extensions?.message;
            const statusCode = $da160e8fa3112de6$var$getLegacyApolloErrorStatusCode(error);
            // if there is no error message it is likely to be a client side network issue
            // eg spotty vpn
            //
            // When graphql-subscriptions rate-limits us it returns an HTML page (eg a 429),
            // which graphql-ws feeds into JSON.parse and throws a SyntaxError. In V8 the
            // thrown message embeds the offending token, eg:
            //   Unexpected token '<', "<!DOCTYPE "... is not valid JSON
            // We match on the HTML markers rather than the generic "Unexpected token" so we
            // only suppress HTML payloads and not unrelated malformed-JSON bugs.
            const isHtmlRateLimitError = (0, $1xpoY.default).getBoolean('confluence_html_error_catching', false) && Boolean(errorMessage && /Unexpected token '<'|<!DOCTYPE|<html/.test(errorMessage));
            const isIgnoredError = $da160e8fa3112de6$export$2612561ece05d878.some((errorString)=>error?.message.includes(errorString)) || !errorMessage || isHtmlRateLimitError;
            if (statusCode !== 403 && !isIgnoredError) {
                const e = new Error(`Subscription Error - :${errorMessage}`);
                (0, $fJlJm.setContentErrorAttributes)(e, {
                    objectId: contentId,
                    objectType: contentType
                });
                (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                    // hard coded as the package will cause circular dependency
                    attribution: 'page-experiences'
                });
            }
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    }, [
        error,
        contentId,
        contentType
    ]);
    const contextValue = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>({
            contentModified: contentModified,
            error: error
        }), [
        contentModified,
        error
    ]);
    const dispatchContextValue = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>({
            setContentType: setContentType,
            setContentId: setContentId,
            addSubscriber: addSubscriber,
            removeSubscriber: removeSubscriber
        }), [
        setContentType,
        setContentId,
        addSubscriber,
        removeSubscriber
    ]);
    if ((0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($da160e8fa3112de6$var$SubscriptionsContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($da160e8fa3112de6$var$SubscriptionsDispatchContext.Provider, {
        value: dispatchContextValue
    }, children));
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
const $da160e8fa3112de6$export$98d6302051bd25df = ()=>{
    return (0, $cozmU.useContext)($da160e8fa3112de6$var$SubscriptionsContext);
};
const $da160e8fa3112de6$export$e2675019a3c1d99f = ()=>{
    return (0, $cozmU.useContext)($da160e8fa3112de6$var$SubscriptionsDispatchContext);
};
module.exports["SubscriptionsContextProvider"] = $da160e8fa3112de6$export$5f043fff8b6d3ca6;
module.exports["useSubscriptionsContext"] = $da160e8fa3112de6$export$98d6302051bd25df;
module.exports["useSubscriptionsDispatchContext"] = $da160e8fa3112de6$export$e2675019a3c1d99f;

});

parcelRegister("fbcPJ", function(module, exports) {
/**
 * @generated SignedSource<<75dc67bed6c2efce761cd8d41d39e8c1>>
 * @relayHash 509c79ed3aa65395a6739ffb9126f832
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c37239834392dbf88f3de4f8af11c861efb04723bfa417c1f6958c4e58059293
const $31174e902ea6e4b2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "type"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "key"
    }, v5 = {
        "kind": "ScalarField",
        "name": "version"
    }, v6 = [
        v4 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "value"
        },
        v5 /*: any*/ ,
        v3 /*: any*/ 
    ], v7 = [
        v4 /*: any*/ ,
        v3 /*: any*/ 
    ], v8 = {
        "kind": "ScalarField",
        "name": "spaceKey"
    }, v9 = {
        "kind": "ScalarField",
        "name": "contentId"
    }, v10 = [
        v9 /*: any*/ ,
        v3 /*: any*/ 
    ], v11 = {
        "kind": "ScalarField",
        "name": "confVersion"
    }, v12 = {
        "kind": "ScalarField",
        "name": "commentId"
    }, v13 = {
        "kind": "ScalarField",
        "name": "inlineCommentType"
    }, v14 = {
        "kind": "ScalarField",
        "name": "adfBodyContent"
    }, v15 = {
        "kind": "ScalarField",
        "name": "markerRef"
    }, v16 = {
        "kind": "ScalarField",
        "name": "publishVersionNumber"
    }, v17 = {
        "kind": "ScalarField",
        "name": "from"
    }, v18 = {
        "kind": "ScalarField",
        "name": "to"
    }, v19 = {
        "kind": "ScalarField",
        "name": "pos"
    }, v20 = {
        "kind": "ScalarField",
        "name": "annotationType"
    }, v21 = [
        v12 /*: any*/ ,
        v15 /*: any*/ ,
        v3 /*: any*/ 
    ], v22 = {
        "kind": "ScalarField",
        "name": "replies"
    }, v23 = {
        "kind": "ScalarField",
        "name": "pageCommentType"
    }, v24 = [
        v3 /*: any*/ ,
        v12 /*: any*/ 
    ], v25 = {
        "kind": "ScalarField",
        "name": "emojiId"
    }, v26 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "ConfluenceContentModified",
            "kind": "LinkedField",
            "name": "confluence_onContentModified",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "accountId"
                },
                {
                    "kind": "ScalarField",
                    "name": "originTabId"
                },
                v3 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "_deltas"
                },
                {
                    "concreteType": "ConfluenceContentPropertyUpdated",
                    "kind": "LinkedField",
                    "name": "contentStateUpdated",
                    "plural": false,
                    "selections": v6 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentPropertyUpdated",
                    "kind": "LinkedField",
                    "name": "emojiTitleUpdated",
                    "plural": false,
                    "selections": v6 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentPropertyUpdated",
                    "kind": "LinkedField",
                    "name": "coverPictureUpdated",
                    "plural": false,
                    "selections": v6 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentPropertyUpdated",
                    "kind": "LinkedField",
                    "name": "pageTitlePropertyUpdated",
                    "plural": false,
                    "selections": v6 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentPropertyDeleted",
                    "kind": "LinkedField",
                    "name": "coverPictureDeleted",
                    "plural": false,
                    "selections": v7 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentPropertyDeleted",
                    "kind": "LinkedField",
                    "name": "emojiTitleDeleted",
                    "plural": false,
                    "selections": v7 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentPropertyDeleted",
                    "kind": "LinkedField",
                    "name": "contentStateDeleted",
                    "plural": false,
                    "selections": v7 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceCoverPictureWidthUpdated",
                    "kind": "LinkedField",
                    "name": "coverPictureWidthUpdated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "coverPictureWidth"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluencePageBlogified",
                    "kind": "LinkedField",
                    "name": "pageBlogified",
                    "plural": false,
                    "selections": [
                        v8 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "spaceName"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "blogTitle"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "converterDisplayName"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceEmbedUpdated",
                    "kind": "LinkedField",
                    "name": "embedUpdated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "product"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isBlankStateUpdate"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluencePageMigrated",
                    "kind": "LinkedField",
                    "name": "pageMigrated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "fabricEligibility"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceContentRestrictionUpdated",
                    "kind": "LinkedField",
                    "name": "contentRestrictionUpdated",
                    "plural": false,
                    "selections": v10 /*: any*/ 
                },
                {
                    "concreteType": "ConfluencePageMoved",
                    "kind": "LinkedField",
                    "name": "pageMoved",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "oldSpaceKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "newSpaceKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "oldParentId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "oldPosition"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "newSpaceAlias"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "oldSpaceAlias"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluencePageUpdated",
                    "kind": "LinkedField",
                    "name": "pageUpdated",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "trigger"
                        },
                        v11 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceWorkflowApplicationChanged",
                    "kind": "LinkedField",
                    "name": "workflowApplicationChanged",
                    "plural": false,
                    "selections": [
                        v9 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "changeType"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "newWorkflowStatusId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "contentStatus"
                        },
                        v5 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceMarkdownModeUpdated",
                    "kind": "LinkedField",
                    "name": "markdownModeUpdated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isMarkdownMode"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceContentUpdatedWithTemplate",
                    "kind": "LinkedField",
                    "name": "contentUpdatedWithTemplate",
                    "plural": false,
                    "selections": [
                        v8 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "subtype"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineCommentCreated",
                    "kind": "LinkedField",
                    "name": "inlineCommentCreated",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v13 /*: any*/ ,
                        v14 /*: any*/ ,
                        v3 /*: any*/ ,
                        v15 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceRendererInlineCommentCreated",
                    "kind": "LinkedField",
                    "name": "rendererInlineCommentCreated",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v12 /*: any*/ ,
                        v14 /*: any*/ ,
                        v13 /*: any*/ ,
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        {
                            "concreteType": "ConfluenceInlineCommentStep",
                            "kind": "LinkedField",
                            "name": "step",
                            "plural": false,
                            "selections": [
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                {
                                    "concreteType": "ConfluenceInlineCommentStepMark",
                                    "kind": "LinkedField",
                                    "name": "mark",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ConfluenceInlineCommentStepMarkAttrs",
                                            "kind": "LinkedField",
                                            "name": "attrs",
                                            "plural": false,
                                            "selections": [
                                                v20 /*: any*/ ,
                                                v3 /*: any*/ 
                                            ]
                                        },
                                        v3 /*: any*/ 
                                    ]
                                },
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineCommentCreated",
                    "kind": "LinkedField",
                    "name": "editorInlineCommentCreated",
                    "plural": false,
                    "selections": [
                        v14 /*: any*/ ,
                        v12 /*: any*/ ,
                        v13 /*: any*/ ,
                        v15 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineCommentUpdated",
                    "kind": "LinkedField",
                    "name": "inlineCommentUpdated",
                    "plural": false,
                    "selections": v21 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceInlineCommentDeleted",
                    "kind": "LinkedField",
                    "name": "inlineCommentDeleted",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v13 /*: any*/ ,
                        v15 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineCommentResolved",
                    "kind": "LinkedField",
                    "name": "inlineCommentResolved",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        {
                            "concreteType": "ConfluenceInlineCommentResolveProperties",
                            "kind": "LinkedField",
                            "name": "inlineResolveProperties",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isDangling"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resolved"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resolvedByDangling"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resolvedFriendlyDate"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resolvedTime"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resolvedUser"
                                },
                                v3 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "inlineText"
                        },
                        v15 /*: any*/ ,
                        v22 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineCommentUpdated",
                    "kind": "LinkedField",
                    "name": "inlineCommentUnresolved",
                    "plural": false,
                    "selections": v21 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceInlineCommentReattached",
                    "kind": "LinkedField",
                    "name": "inlineCommentReattached",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v3 /*: any*/ ,
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        {
                            "concreteType": "ConfluenceInlineCommentStep",
                            "kind": "LinkedField",
                            "name": "step",
                            "plural": false,
                            "selections": [
                                v17 /*: any*/ ,
                                {
                                    "concreteType": "ConfluenceInlineCommentStepMark",
                                    "kind": "LinkedField",
                                    "name": "mark",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ConfluenceInlineCommentStepMarkAttrs",
                                            "kind": "LinkedField",
                                            "name": "attrs",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v20 /*: any*/ 
                                            ]
                                        },
                                        v3 /*: any*/ 
                                    ]
                                },
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceCommentCreated",
                    "kind": "LinkedField",
                    "name": "commentCreated",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v14 /*: any*/ ,
                        v12 /*: any*/ ,
                        v23 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceCommentUpdated",
                    "kind": "LinkedField",
                    "name": "commentUpdated",
                    "plural": false,
                    "selections": v24 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceCommentUpdated",
                    "kind": "LinkedField",
                    "name": "commentDeleted",
                    "plural": false,
                    "selections": v24 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceCommentCreated",
                    "kind": "LinkedField",
                    "name": "commentResolved",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v14 /*: any*/ ,
                        v12 /*: any*/ ,
                        v23 /*: any*/ ,
                        v22 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceCommentUpdated",
                    "kind": "LinkedField",
                    "name": "commentReopened",
                    "plural": false,
                    "selections": v24 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceSchedulePublished",
                    "kind": "LinkedField",
                    "name": "schedulePublished",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "publishTime"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "eventType"
                        },
                        v11 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceContentAccessRequested",
                    "kind": "LinkedField",
                    "name": "contentAccessRequested",
                    "plural": false,
                    "selections": v10 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentAccessDecisionMade",
                    "kind": "LinkedField",
                    "name": "contentAccessDecisionMade",
                    "plural": false,
                    "selections": [
                        v9 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "decision"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineReactionAdded",
                    "kind": "LinkedField",
                    "name": "inlineReactionAdded",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v15 /*: any*/ ,
                        v25 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "newHighlight"
                        },
                        {
                            "concreteType": "ConfluenceInlineCommentStep",
                            "kind": "LinkedField",
                            "name": "step",
                            "plural": false,
                            "selections": [
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                {
                                    "concreteType": "ConfluenceInlineCommentStepMark",
                                    "kind": "LinkedField",
                                    "name": "mark",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ConfluenceInlineCommentStepMarkAttrs",
                                            "kind": "LinkedField",
                                            "name": "attrs",
                                            "plural": false,
                                            "selections": [
                                                v20 /*: any*/ ,
                                                v2 /*: any*/ 
                                            ]
                                        },
                                        v1 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "stepType"
                                }
                            ]
                        },
                        v16 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineReactionRemoved",
                    "kind": "LinkedField",
                    "name": "inlineReactionRemoved",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v15 /*: any*/ ,
                        v25 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineReactionHighlightDeleted",
                    "kind": "LinkedField",
                    "name": "inlineReactionHighlightDeleted",
                    "plural": false,
                    "selections": v21 /*: any*/ 
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SubscriptionsContextProviderSubscription",
            "selections": v26 /*: any*/ ,
            "type": "Subscription"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SubscriptionsContextProviderSubscription",
            "selections": v26 /*: any*/ 
        },
        "params": {
            "cacheID": "509c79ed3aa65395a6739ffb9126f832",
            "id": "c37239834392dbf88f3de4f8af11c861efb04723bfa417c1f6958c4e58059293",
            "metadata": {},
            "name": "SubscriptionsContextProviderSubscription",
            "operationKind": "subscription",
            "text": "subscription SubscriptionsContextProviderSubscription($id:ID!){confluence_onContentModified(id:$id){type,id,accountId,originTabId,__typename,_deltas,contentStateUpdated{key,value,version,__typename},emojiTitleUpdated{key,value,version,__typename},coverPictureUpdated{key,value,version,__typename},pageTitlePropertyUpdated{key,value,version,__typename},coverPictureDeleted{key,__typename},emojiTitleDeleted{key,__typename},contentStateDeleted{key,__typename},coverPictureWidthUpdated{coverPictureWidth,__typename},pageBlogified{spaceKey,spaceName,blogTitle,converterDisplayName,__typename},embedUpdated{product,isBlankStateUpdate,__typename},pageMigrated{fabricEligibility,__typename},contentRestrictionUpdated{contentId,__typename},pageMoved{oldSpaceKey,newSpaceKey,oldParentId,oldPosition,newSpaceAlias,oldSpaceAlias,__typename},pageUpdated{__typename,trigger,confVersion},workflowApplicationChanged{contentId,changeType,newWorkflowStatusId,contentStatus,version,__typename},markdownModeUpdated{isMarkdownMode,__typename},contentUpdatedWithTemplate{spaceKey,subtype,__typename},inlineCommentCreated{commentId,inlineCommentType,adfBodyContent,__typename,markerRef},rendererInlineCommentCreated{__typename,commentId,adfBodyContent,inlineCommentType,markerRef,publishVersionNumber,step{from,to,pos,mark{attrs{annotationType,__typename},__typename},__typename}},editorInlineCommentCreated{adfBodyContent,commentId,inlineCommentType,markerRef,__typename},inlineCommentUpdated{commentId,markerRef,__typename},inlineCommentDeleted{commentId,inlineCommentType,markerRef,__typename},inlineCommentResolved{commentId,inlineResolveProperties{isDangling,resolved,resolvedByDangling,resolvedFriendlyDate,resolvedTime,resolvedUser,__typename},inlineText,markerRef,replies,__typename},inlineCommentUnresolved{commentId,markerRef,__typename},inlineCommentReattached{commentId,__typename,markerRef,publishVersionNumber,step{from,mark{attrs{__typename,annotationType},__typename},__typename}},commentCreated{__typename,adfBodyContent,commentId,pageCommentType},commentUpdated{__typename,commentId},commentDeleted{__typename,commentId},commentResolved{__typename,adfBodyContent,commentId,pageCommentType,replies},commentReopened{__typename,commentId},schedulePublished{publishTime,eventType,confVersion,__typename},contentAccessRequested{contentId,__typename},contentAccessDecisionMade{contentId,decision,__typename},inlineReactionAdded{commentId,markerRef,emojiId,newHighlight,step{from,to,pos,mark{attrs{annotationType,id},type},stepType},publishVersionNumber,__typename},inlineReactionRemoved{commentId,markerRef,emojiId,__typename},inlineReactionHighlightDeleted{commentId,markerRef,__typename}}}"
        }
    };
}();
$31174e902ea6e4b2$var$node.hash = "c37cfea9a825383fc3da89eb6b15ecfd";
var $31174e902ea6e4b2$export$2e2bcd8739ae039 = $31174e902ea6e4b2$var$node;
module.exports["default"] = $31174e902ea6e4b2$export$2e2bcd8739ae039;

});

parcelRegister("fD0Uz", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7EPz1 = parcelRequire("7EPz1");


var $6SsN4 = parcelRequire("6SsN4");


var $eqEJl = parcelRequire("eqEJl");


var $422HI = parcelRequire("422HI");


var $iffSy = parcelRequire("iffSy");


var $86okN = parcelRequire("86okN");


var $iF5wn = parcelRequire("iF5wn");

const $c7f06d7e4ea271ae$var$isRelayGraphQLTaggedNode = (subscription)=>typeof subscription === 'function' || subscription.kind !== 'Document';
const $c7f06d7e4ea271ae$var$isFormattedExecutionResult = (response)=>Boolean(response && typeof response === 'object' && ('data' in response || 'errors' in response));
const $c7f06d7e4ea271ae$var$isSubscriptionData = (response)=>!$c7f06d7e4ea271ae$var$isFormattedExecutionResult(response);
const $c7f06d7e4ea271ae$var$getSubscriptionDataAndExtensions = (response)=>{
    if (response == null) return {
        data: undefined,
        extensions: undefined
    };
    if ($c7f06d7e4ea271ae$var$isSubscriptionData(response)) return {
        data: response,
        extensions: undefined
    };
    return {
        data: response.data ?? undefined,
        extensions: response.extensions
    };
};
const $c7f06d7e4ea271ae$export$4966ff7f324f6363 = (response)=>{
    const { data: data, extensions: extensions } = $c7f06d7e4ea271ae$var$getSubscriptionDataAndExtensions(response);
    return {
        ...extensions ? {
            extensions: extensions
        } : {},
        subscriptionData: {
            data: data,
            loading: false,
            ...extensions ? {
                extensions: extensions
            } : {}
        }
    };
};
const $c7f06d7e4ea271ae$var$__TEST_ONLY_isTestOnlySafeEnvironment = ()=>{
    const isProduction = true;
    const isCloudProduction = true;
    const isCloudStaging = false;
    if (isProduction || isCloudProduction || isCloudStaging) return false;
    const isTest = false;
    const isDevelopment = false;
    const isLocalhost = typeof window !== 'undefined' && window.location.hostname === 'localhost';
    return isTest || isDevelopment || isLocalhost;
};
const $c7f06d7e4ea271ae$export$1bed67b955596e29 = (forceRelay)=>{
    if (!$c7f06d7e4ea271ae$var$__TEST_ONLY_isTestOnlySafeEnvironment()) return false;
    window.__TEST_ONLY_FORCE_RELAY_MODE__ = forceRelay;
    return true;
};
function $c7f06d7e4ea271ae$export$275462b87cef6610(subscription, options) {
    const forceRelayMode = window.__TEST_ONLY_FORCE_RELAY_MODE__;
    const shouldUseRelay = forceRelayMode || (0, $iffSy.isRelayEnabled)(options?.__callerPackage__, {
        phase: 'subscription'
    });
    if (shouldUseRelay) {
        if (!$c7f06d7e4ea271ae$var$isRelayGraphQLTaggedNode(subscription)) throw new Error('[Relay migration] useSubscriptionInterop Relay mode requires graphql tag');
        // eslint-disable-next-line react-hooks/rules-of-hooks
        return $c7f06d7e4ea271ae$var$useSubscriptionInteropRelay(subscription, options);
    } else {
        const { interopApolloAggClient: interopApolloAggClient, extensions: extensions, ...apolloOptions } = options ?? {};
        // Apollo v2's `useSubscription` does not forward a per-call `context` option down
        // to the WebSocket link, so we smuggle `extensions` through `variables.__extensions`.
        // `AttachExtensionsLink` strips it back out and re-attaches it to the operation
        // context, which `GraphQLWSLink.request` then sets on the wire payload.
        const variables = extensions !== undefined ? {
            ...apolloOptions.variables,
            __extensions: extensions
        } : apolloOptions.variables;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        return (0, $7EPz1.useSubscription)((0, $86okN.toDocumentNode)(subscription), {
            ...apolloOptions,
            variables: variables,
            ...interopApolloAggClient ? {
                client: window.GLOBAL_APOLLO_AGG_CLIENT ?? window.MOCK_GATEWAY_APOLLO_CLIENT
            } : {}
        });
    }
}
const $c7f06d7e4ea271ae$var$toApolloErrorInterop = (error)=>new (0, $422HI.ApolloErrorInterop)({
        networkError: error instanceof Error ? error : new Error(String(error))
    });
function $c7f06d7e4ea271ae$var$useSubscriptionInteropRelay(subscription, options) {
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const [data, setData] = (0, $cozmU.useState)(undefined);
    const [error, setError] = (0, $cozmU.useState)(undefined);
    const [loading, setLoading] = (0, $cozmU.useState)(!options?.skip);
    const disposableRef = (0, $cozmU.useRef)(null);
    const callbacksRef = (0, $cozmU.useRef)(options);
    callbacksRef.current = options;
    const skip = options?.skip;
    const variables = (0, $iF5wn.useMemoObj)(options?.variables, options?.__callerPackage__, {
        phase: 'subscription'
    });
    const extensions = (0, $iF5wn.useMemoObj)(options?.extensions, options?.__callerPackage__, {
        phase: 'subscription'
    });
    (0, $cozmU.useEffect)(()=>{
        if (skip) {
            setLoading(false);
            return;
        }
        setLoading(true);
        setError(undefined);
        setData(undefined);
        try {
            disposableRef.current = (0, $eqEJl.requestSubscription)(environment, {
                subscription: subscription,
                variables: variables,
                // `RelayWebSocketSubscriptionHandler` reads `cacheConfig.metadata.extensions`
                // and attaches them to the WS payload's `extensions` field.
                // cacheConfig is always set because useMemoObj coerces undefined → {}, so any
                // guard on `extensions` would always evaluate the same way. The consumer
                // (RelayWebSocketSubscriptionHandler) ignores an empty extensions object.
                cacheConfig: {
                    metadata: {
                        extensions: extensions
                    }
                },
                onNext: (response)=>{
                    const { data: responseData } = $c7f06d7e4ea271ae$var$getSubscriptionDataAndExtensions(response);
                    setData(responseData);
                    setError(undefined);
                    setLoading(false);
                    callbacksRef.current?.onSubscriptionData?.($c7f06d7e4ea271ae$export$4966ff7f324f6363(response));
                },
                onError: (err_0)=>{
                    setError($c7f06d7e4ea271ae$var$toApolloErrorInterop(err_0));
                    setLoading(false);
                },
                onCompleted: ()=>{
                    setLoading(false);
                    callbacksRef.current?.onSubscriptionComplete?.();
                }
            });
        } catch (err) {
            setError($c7f06d7e4ea271ae$var$toApolloErrorInterop(err));
            setLoading(false);
        }
        return ()=>{
            if (!disposableRef.current) return;
            disposableRef.current.dispose();
            disposableRef.current = null;
        };
    }, [
        environment,
        subscription,
        variables,
        extensions,
        skip
    ]);
    return {
        data: data,
        loading: loading,
        error: error
    };
}
module.exports["useSubscriptionInterop"] = $c7f06d7e4ea271ae$export$275462b87cef6610;

});

parcelRegister("3vc4U", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");


var $fSDun = parcelRequire("fSDun");

const $e5d99b79ae0d2558$var$REPLAY_WINDOW_HOURS = 48;
const $e5d99b79ae0d2558$export$d9c46c14618307b6 = ({ contentId: contentId, contentType: contentType, replayCap: replayCap })=>{
    const { activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const lastSequenceId = (0, $cozmU.useRef)(Math.floor(new Date().getTime() / 1000));
    const [updateExtensionsTrigger, setUpdateExtensionsTrigger] = (0, $cozmU.useState)(0);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const onSubscriptionComplete = (0, $cozmU.useCallback)(()=>{
        setUpdateExtensionsTrigger(updateExtensionsTrigger + 1);
    }, [
        updateExtensionsTrigger,
        setUpdateExtensionsTrigger
    ]);
    const onSubscriptionData = (0, $cozmU.useCallback)((result)=>{
        // update the last received message timestamp with either the messages time or use a best guess from the current time
        lastSequenceId.current = result?.extensions?.sequenceNumber ?? Math.floor(new Date().getTime() / 1000);
        const subscriptionField = Object.keys(result?.subscriptionData?.data ?? {}).find((field)=>field !== '__typename');
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'received',
                actionSubject: 'subscription.event',
                source: 'AGGSubscriptions',
                attributes: {
                    contentId: contentId,
                    contentType: contentType,
                    request_id: result?.extensions?.agg?.request_id || '',
                    traceId: result?.extensions?.traceId || '',
                    ...subscriptionField && (0, $6mKj3.expValEquals)('platform_editor_ai_content_suggested_edits', 'isEnabled', true) ? {
                        subscriptionField: subscriptionField
                    } : {}
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        contentId,
        contentType
    ]);
    const ari = !contentId || !contentType || !cloudId || !activationId ? '' : (0, $fSDun.getConfluenceContentAri)({
        siteId: cloudId,
        resourceType: contentType,
        activationId: activationId,
        resourceId: contentId
    });
    const extensions = (0, $cozmU.useMemo)(()=>{
        const fallbackReplayCapInSeconds = Math.floor((Date.now() - $e5d99b79ae0d2558$var$REPLAY_WINDOW_HOURS * 3600000) / 1000);
        let sequenceNumber;
        if (replayCap !== undefined) sequenceNumber = replayCap;
        else if (lastSequenceId.current < fallbackReplayCapInSeconds) sequenceNumber = fallbackReplayCapInSeconds;
        else sequenceNumber = lastSequenceId.current;
        return updateExtensionsTrigger > 0 ? {
            command: {
                type: 'replay',
                data: {
                    sequenceNumber: sequenceNumber
                }
            }
        } : {};
    }, [
        updateExtensionsTrigger,
        replayCap
    ]);
    return {
        id: ari,
        extensions: extensions,
        onSubscriptionComplete: onSubscriptionComplete,
        onSubscriptionData: onSubscriptionData
    };
};
module.exports["useSubscriptionValues"] = $e5d99b79ae0d2558$export$d9c46c14618307b6;

});

parcelRegister("fSDun", function(module, exports) {
// Copied from @confluence/content-types-utils/src/getConfluenceContentAri.ts
/**
 * Resource types where the ARIs include activationIds. This is a pattern
 * that started with Confluence Databases.
 */ const $ad4104a6b6731a94$var$TYPES_WITH_ACTIVATIONID = [
    'database',
    'embed',
    'folder',
    'slide'
];
const $ad4104a6b6731a94$export$6a2f2c83863e9bfe = (confluenceContentAriParameters)=>{
    const { siteId: siteId, resourceType: resourceType, activationId: activationId, resourceId: resourceId } = confluenceContentAriParameters;
    if ($ad4104a6b6731a94$var$TYPES_WITH_ACTIVATIONID.includes(resourceType)) return `ari:cloud:confluence:${siteId}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:confluence:${siteId}:${resourceType}/${resourceId}`;
};
module.exports["getConfluenceContentAri"] = $ad4104a6b6731a94$export$6a2f2c83863e9bfe;

});

parcelRegister("9o40q", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $5JnOJ = parcelRequire("5JnOJ");


var $6mKj3 = parcelRequire("6mKj3");


var $1GTIR = parcelRequire("1GTIR");


var $bjeS8 = parcelRequire("bjeS8");


var $hNILR = parcelRequire("hNILR");

function $ca37881e75cd694f$export$59b64e912820d0fb({ url: url, method: method, headers: headers, body: body, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError, maxRetries: maxRetries = 0, variables: defaultVariables, update: update, optimisticResponse: optimisticResponse }) {
    if (!(0, $6mKj3.expValEquals)('cc_move_legacy-schema-bridge-code-into-interops', 'isEnabled', true)) // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    return (0, $hNILR.useExperimentalMutationLegacy)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        maxRetries: maxRetries,
        variables: defaultVariables,
        update: update,
        optimisticResponse: optimisticResponse
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    const { fetchData: fetchData } = (0, $1GTIR.useFetchData)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError,
        variables: defaultVariables
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    const fetchDataWithRetry = (0, $cozmU.useCallback)(async (variables, count = 0)=>{
        try {
            return await fetchData(variables);
        } catch (error) {
            if (count < maxRetries && error?.response?.status === 409) return fetchDataWithRetry(variables, ++count);
            throw error;
        }
    }, [
        maxRetries,
        fetchData
    ]);
    // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    return $ca37881e75cd694f$export$a2949d410ca8baf1({
        fetchData: fetchDataWithRetry,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        update: update,
        optimisticResponse: optimisticResponse
    });
}
function $ca37881e75cd694f$export$a2949d410ca8baf1({ fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, update: update, optimisticResponse: optimisticResponse }) {
    const handleConvertToApolloError = async (error)=>{
        return (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    };
    return (0, $5JnOJ.useApolloCompatibleMutation)({
        fetchData: fetchData,
        onCompleted: onCompleted,
        onError: onError,
        update: update,
        optimisticResponse: optimisticResponse,
        convertToApolloError: handleConvertToApolloError
    });
}
module.exports["useExperimentalMutation"] = $ca37881e75cd694f$export$59b64e912820d0fb;
module.exports["useExperimentalMutationBase"] = $ca37881e75cd694f$export$a2949d410ca8baf1;

});

parcelRegister("5JnOJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $26Yfd = parcelRequire("26Yfd");


var $7Sm4c = parcelRequire("7Sm4c");

function $0e0c7f21ad093cb8$export$36caaad0aa36f272({ fetchData: fetchData, onCompleted: onCompleted, onError: onError, update: defaultUpdate, optimisticResponse: defaultOptimisticResponse, convertToApolloError: convertToApolloError }) {
    const [result, setResult] = (0, $cozmU.useState)({
        data: undefined,
        loading: false,
        error: undefined,
        called: false
    });
    const mutate = (0, $26Yfd.useStableCallback)(async (options = {})=>{
        const { variables: variables, update: optionsUpdate, optimisticResponse: optionsOptimisticResponse } = options;
        const update = optionsUpdate ?? defaultUpdate;
        setResult({
            data: undefined,
            loading: true,
            error: undefined,
            called: true
        });
        const optimisticResponse = optionsOptimisticResponse ?? defaultOptimisticResponse;
        if (optimisticResponse) {
            const optimisticData = typeof optimisticResponse === 'function' ? optimisticResponse(variables ?? {}) : optimisticResponse;
            update?.(null, {
                data: optimisticData
            });
        }
        try {
            const data = await fetchData(variables);
            // The `update` function matches the Apollo useMutation API for compatibility
            // This hook does not implement a cache, so `cache` is always null
            update?.(null, {
                data: data
            });
            const newResult_0 = {
                data: data,
                loading: false,
                error: undefined,
                called: true
            };
            setResult(newResult_0);
            await onCompleted?.(data);
            return {
                data: newResult_0.data
            };
        } catch (error) {
            // Rollback optimistic update on error
            if (optimisticResponse && update) // Signal rollback by calling update with undefined data
            // Consumers should handle this to revert to the previous state
            update(null, {
                data: undefined
            });
            const apolloError = await Promise.resolve(convertToApolloError(error));
            if (apolloError.graphQLErrors?.length) apolloError.graphQLErrors.forEach((e)=>{
                (0, $7Sm4c.processError)(e);
            });
            onError?.(apolloError);
            const newResult = {
                data: undefined,
                loading: false,
                error: apolloError,
                called: true
            };
            setResult(newResult);
            if (!onError) throw apolloError;
            return {
                data: newResult.data
            };
        }
    });
    return [
        mutate,
        result
    ];
}
module.exports["useApolloCompatibleMutation"] = $0e0c7f21ad093cb8$export$36caaad0aa36f272;

});

parcelRegister("1GTIR", function(module, exports) {

var $26Yfd = parcelRequire("26Yfd");


var $GLgaM = parcelRequire("GLgaM");

// Allows using variables from either the mutate call or initial hook call
// Follows Apollo Client behavior: only falls back when variables is undefined, not empty object
const $e94116a19c839dfc$var$resolveVariables = (localVariables, fallbackVariables)=>{
    return localVariables !== undefined ? localVariables : fallbackVariables ?? {};
};
const $e94116a19c839dfc$export$80ee20aa64f130f = ({ url: url, method: method, variables: variables = {}, headers: headers, body: body, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError })=>{
    const fetchData = (0, $26Yfd.useStableCallback)(async (localVariables)=>{
        const resolvedVariables = $e94116a19c839dfc$var$resolveVariables(localVariables, variables);
        const response = await (0, $GLgaM.fetchResponse)({
            url: url,
            method: method,
            body: body,
            headers: headers,
            credentials: credentials,
            parseResponseOnSuccess: parseResponseOnSuccess,
            parseResponseOnError: parseResponseOnError
        }, resolvedVariables);
        return parseResult(response, resolvedVariables);
    });
    return {
        fetchData: fetchData
    };
};
const $e94116a19c839dfc$export$54f10667ecd8890d = ({ requestConfigs: requestConfigs, variables: variables = {}, parseResult: parseResult })=>{
    const fetchData = (0, $26Yfd.useStableCallback)(async (localVariables)=>{
        const resolvedVariables = $e94116a19c839dfc$var$resolveVariables(localVariables, variables);
        const responses = await Promise.all(requestConfigs.map((fetchOptions)=>(0, $GLgaM.fetchResponse)(fetchOptions, resolvedVariables)));
        return parseResult(responses, resolvedVariables);
    });
    return {
        fetchData: fetchData
    };
};
module.exports["useFetchData"] = $e94116a19c839dfc$export$80ee20aa64f130f;
module.exports["useFetchDataWithMultipleFetches"] = $e94116a19c839dfc$export$54f10667ecd8890d;

});

parcelRegister("hNILR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $26Yfd = parcelRequire("26Yfd");


var $1GTIR = parcelRequire("1GTIR");


var $hR9WV = parcelRequire("hR9WV");

function $fa6207d2b246a38d$export$9aaca330ad9c982e({ url: url, method: method, headers: headers, body: body, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError, maxRetries: maxRetries = 0, variables: defaultVariables, update: update, optimisticResponse: optimisticResponse }) {
    const { fetchData: fetchData } = (0, $1GTIR.useFetchData)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError,
        variables: defaultVariables
    });
    const fetchDataWithRetry = (0, $cozmU.useCallback)(async (variables, count = 0)=>{
        try {
            return await fetchData(variables);
        } catch (error) {
            if (count < maxRetries && error?.response?.status === 409) return fetchDataWithRetry(variables, ++count);
            throw error;
        }
    }, [
        maxRetries,
        fetchData
    ]);
    return $fa6207d2b246a38d$export$a2949d410ca8baf1({
        fetchData: fetchDataWithRetry,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        update: update,
        optimisticResponse: optimisticResponse
    });
}
function $fa6207d2b246a38d$export$a2949d410ca8baf1({ fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, update: defaultUpdate, optimisticResponse: defaultOptimisticResponse }) {
    const [result, setResult] = (0, $cozmU.useState)({
        data: undefined,
        loading: false,
        error: undefined,
        called: false
    });
    const mutate = (0, $26Yfd.useStableCallback)(async (options = {})=>{
        const { variables: variables, update: optionsUpdate, optimisticResponse: optionsOptimisticResponse } = options;
        const update = optionsUpdate ?? defaultUpdate;
        setResult({
            data: undefined,
            loading: true,
            error: undefined,
            called: true
        });
        const optimisticResponse = optionsOptimisticResponse ?? defaultOptimisticResponse;
        if (optimisticResponse) {
            const optimisticData = typeof optimisticResponse === 'function' ? optimisticResponse(variables ?? {}) : optimisticResponse;
            update?.(null, {
                data: optimisticData
            });
        }
        try {
            const data = await fetchData(variables);
            // The `update` function matches the Apollo useMutation API for compatibility
            // This hook does not implement a cache, so `cache` is always null
            update?.(null, {
                data: data
            });
            const newResult = {
                data: data,
                loading: false,
                error: undefined,
                called: true
            };
            setResult(newResult);
            await onCompleted?.(data);
            return {
                data: newResult.data
            };
        } catch (error) {
            // Rollback optimistic update on error
            if (optimisticResponse && update) // Signal rollback by calling update with undefined data
            // Consumers should handle this to revert to the previous state
            update(null, {
                data: undefined
            });
            const finalError = await (0, $hR9WV.handleError)({
                error: error,
                transformError: transformError,
                onError: onError
            });
            const newResult = {
                data: undefined,
                loading: false,
                error: finalError,
                called: true
            };
            setResult(newResult);
            if (!onError) throw finalError;
            return {
                data: newResult.data
            };
        }
    });
    return [
        mutate,
        result
    ];
}
module.exports["useExperimentalMutationLegacy"] = $fa6207d2b246a38d$export$9aaca330ad9c982e;

});

parcelRegister("hR9WV", function(module, exports) {

var $7Sm4c = parcelRequire("7Sm4c");


var $bjeS8 = parcelRequire("bjeS8");

const $b1a7f6ba28f294ca$export$d3da1ecaf1206c58 = async ({ error: error, transformError: transformError, onError: onError })=>{
    // The `transformError` callback can optionally return a new error to replace the original,
    // allowing for custom errors (e.g. based on the error's status code)
    const finalError = (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    // Process error for monitoring/analytics
    if (finalError.graphQLErrors?.length) finalError.graphQLErrors.forEach((e)=>{
        (0, $7Sm4c.processError)(e);
    });
    onError?.(finalError);
    return finalError;
};
module.exports["handleError"] = $b1a7f6ba28f294ca$export$d3da1ecaf1206c58;

});

parcelRegister("jacyh", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $d9bb792bb433dc50$var$initialState = {
    shouldForceRefetch: false // this is just a boolean that we toggle between false and true to force a refetch in blog tree
};
const $d9bb792bb433dc50$var$actions = {
    forceRefetchBlogTree: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                shouldForceRefetch: !currentState.shouldForceRefetch
            });
        }
};
const $d9bb792bb433dc50$var$BlogTreeStore = (0, $8s9DV.createStore)({
    initialState: $d9bb792bb433dc50$var$initialState,
    actions: $d9bb792bb433dc50$var$actions
});
const $d9bb792bb433dc50$export$9638016a54f09a07 = (0, $kBr4q.createHook)($d9bb792bb433dc50$var$BlogTreeStore);
const $d9bb792bb433dc50$export$861bc4451e1cbefa = (0, $kBr4q.createActionsHook)($d9bb792bb433dc50$var$BlogTreeStore);
module.exports["useBlogTreeStore"] = $d9bb792bb433dc50$export$9638016a54f09a07;
module.exports["useBlogTreeActions"] = $d9bb792bb433dc50$export$861bc4451e1cbefa;

});

parcelRegister("hYoU4", function(module, exports) {

var $nStJY = parcelRequire("nStJY");


var $kBr4q = parcelRequire("kBr4q");

var $j8on0 = parcelRequire("j8on0");

var $8s9DV = parcelRequire("8s9DV");

const $cf3a2c4e252823d7$export$79b973328ab6a08a = {
    collabEditProvider: null,
    collabEditInitialized: false,
    hasInitialDraft: false,
    isDraftSyncPending: false,
    collabEditConnected: false
};
const $cf3a2c4e252823d7$export$e324594224ef24da = {
    setCollabEditProvider: (collabEditProvider)=>({ setState: setState })=>{
            setState({
                collabEditProvider: collabEditProvider
            });
        },
    setCollabEditInitialized: (collabEditInitialized)=>({ setState: setState })=>{
            setState({
                collabEditInitialized: collabEditInitialized
            });
        },
    setHasInitialDraft: (hasInitialDraft)=>({ setState: setState })=>{
            setState({
                hasInitialDraft: hasInitialDraft
            });
        },
    setIsDraftSyncPending: // PGXT-3849 Remove this if we update lodash to 5.0+ and use debounce.pending() instead
    (isDraftSyncPending)=>({ setState: setState })=>{
            setState({
                isDraftSyncPending: isDraftSyncPending
            });
        },
    setCollabEditConnected: (collabEditConnected)=>({ setState: setState })=>{
            setState({
                collabEditConnected: collabEditConnected
            });
        },
    resetNativeCollabState: ()=>({ setState: setState })=>{
            setState({
                collabEditProvider: null,
                collabEditInitialized: false,
                hasInitialDraft: false,
                isDraftSyncPending: false,
                collabEditConnected: false
            });
        }
};
const $cf3a2c4e252823d7$export$a3d4598f4626641c = (0, $8s9DV.createStore)({
    initialState: {
        ...$cf3a2c4e252823d7$export$79b973328ab6a08a
    },
    actions: $cf3a2c4e252823d7$export$e324594224ef24da,
    name: 'nativeCollabState'
});
const $cf3a2c4e252823d7$export$8af37259b4604092 = (0, $j8on0.createContainer)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    onInit: ()=>async ({ dispatch: dispatch }, { initialCollabState: initialCollabState })=>{
            initialCollabState?.collabEditProvider && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditProvider(initialCollabState?.collabEditProvider));
            initialCollabState?.collabEditInitialized && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditInitialized(initialCollabState?.collabEditInitialized));
            initialCollabState?.hasInitialDraft && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setHasInitialDraft(initialCollabState?.hasInitialDraft));
            initialCollabState?.isDraftSyncPending && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setIsDraftSyncPending(initialCollabState?.isDraftSyncPending));
            initialCollabState?.collabEditConnected && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditConnected(initialCollabState?.collabEditConnected));
        }
});
const $cf3a2c4e252823d7$export$b01c6ac62a4aed2c = (0, $kBr4q.createHook)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($nStJY)))(state, 'collabEditProvider', 'collabEditInitialized', 'hasInitialDraft')
});
const $cf3a2c4e252823d7$export$3f0287ea828df991 = (0, $kBr4q.createActionsHook)($cf3a2c4e252823d7$export$a3d4598f4626641c);
const $cf3a2c4e252823d7$export$31e00ebc52451b8e = (0, $kBr4q.createHook)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($nStJY)))(state, 'isDraftSyncPending')
});
const $cf3a2c4e252823d7$export$4bfbf4dd405bc207 = (0, $kBr4q.createHook)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($nStJY)))(state, 'collabEditConnected')
});
module.exports["useNativeCollabState"] = $cf3a2c4e252823d7$export$b01c6ac62a4aed2c;
module.exports["useNativeCollabActions"] = $cf3a2c4e252823d7$export$3f0287ea828df991;
module.exports["useNativeCollabDraftSync"] = $cf3a2c4e252823d7$export$31e00ebc52451b8e;
module.exports["useNativeCollabConnected"] = $cf3a2c4e252823d7$export$4bfbf4dd405bc207;

});

parcelRegister("5M5fB", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3jwuS = parcelRequire("3jwuS");

/**
 * To avoid multiple people saving the draft simultaneously, which causes a lock exception,
 * we only want the first active user to be in charge of saving.
 * See issue CFE-1369 for details.
 */ const $ecd355b99e8f624d$var$checkIsFirstParticipant = (participants, currentUserSessionId)=>{
    if (participants === null || participants.length === 0 || currentUserSessionId === null) return true;
    // Check if the first participant is the current user
    return participants[0].sessionId === currentUserSessionId;
};
/**
 * Verifies if the current user is the primary participant and has edit permissions.
 * @returns {boolean} True if the user is the first participant with edit permissions,
 *                    false if the user has view only or is not the first participant.
 */ const $ecd355b99e8f624d$var$isPrimaryParticipantWithPermissions = (participants, currentUserSessionId)=>{
    if (participants === null || participants.length === 0 || currentUserSessionId === null) return true;
    // Find the first participant in the sorted list with edit permissions
    const primaryParticipant = participants.find((activeUser)=>activeUser.permit?.isPermittedToEdit);
    return !!primaryParticipant && primaryParticipant.sessionId === currentUserSessionId;
};
const $ecd355b99e8f624d$var$updatePresence = (presenceData, currentParticipants)=>{
    const { joined: joined = [], left: left = [] } = presenceData;
    let updatedParticipants = [];
    if (currentParticipants === null) updatedParticipants = joined;
    else {
        // Add new participants to the list
        updatedParticipants = [
            ...currentParticipants,
            ...joined
        ];
        // Remove participants who have left
        updatedParticipants = updatedParticipants.filter((participant)=>!left.some((leftUser)=>leftUser.sessionId === participant.sessionId));
    }
    // Sort the session IDs to ensure the comparison for choosing the
    // draft sync leader is deterministic.
    updatedParticipants.sort((a, b)=>a.sessionId.localeCompare(b.sessionId));
    return updatedParticipants;
};
const $ecd355b99e8f624d$export$2a8c16d82a0a0e26 = (collabEditProvider)=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const currentUserSessionId = (0, $cozmU.useRef)(null);
    const currentParticipants = (0, $cozmU.useRef)(null);
    const [isFirstParticipant, setIsFirstParticipant] = (0, $cozmU.useState)(true);
    const [isSingleUserSession, setIsSingleUserSession] = (0, $cozmU.useState)(true);
    // Listen to the connected event to grab the current user's sessionId
    (0, $cozmU.useEffect)(()=>{
        if (!collabEditProvider) return;
        const handleConnected = (event)=>{
            currentUserSessionId.current = event?.sid;
        };
        collabEditProvider.on('connected', handleConnected);
        return ()=>{
            collabEditProvider.off('connected', handleConnected);
        };
    }, [
        collabEditProvider
    ]);
    const handleUpdatePresence = (0, $cozmU.useCallback)((presenceData)=>{
        const updatedParticipants = $ecd355b99e8f624d$var$updatePresence(presenceData, currentParticipants.current);
        currentParticipants.current = updatedParticipants;
        const isFirst = isLivePage ? $ecd355b99e8f624d$var$isPrimaryParticipantWithPermissions(updatedParticipants, currentUserSessionId.current) : $ecd355b99e8f624d$var$checkIsFirstParticipant(updatedParticipants, currentUserSessionId.current);
        setIsFirstParticipant(isFirst);
        setIsSingleUserSession(currentParticipants.current.length <= 1);
    }, [
        isLivePage
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!collabEditProvider) return;
        collabEditProvider.on('presence', handleUpdatePresence);
        return ()=>{
            collabEditProvider.off('presence', handleUpdatePresence);
        };
    }, [
        collabEditProvider,
        handleUpdatePresence
    ]);
    return {
        isFirstParticipant: isFirstParticipant,
        isSingleUserSession: isSingleUserSession
    };
};
module.exports["usePresence"] = $ecd355b99e8f624d$export$2a8c16d82a0a0e26;

});

parcelRegister("bMmYR", function(module, exports) {
/**
 * Sleep an async context for timeoutMs milliseconds
 *
 * Note this does not block but instead sets a timeout
 *
 * @param timeoutMs The timeout in milliseconds
 * @returns {Promise} A promise that resolves after timeoutMs milliseconds
 */ const $e3747894d76f1f8c$var$sleep = (timeoutMs)=>new Promise((resolve)=>setTimeout(resolve, timeoutMs));
const $e3747894d76f1f8c$export$9369b12211e1fce4 = (action, { backOff: backOff = true, jitter: jitter = true, timeout: timeout = 2000, maxAttempts: maxAttempts = 3 } = {}, shouldRetry)=>{
    const recursiveRetry = async (attempt)=>{
        let nextTryIn = null;
        if (attempt < maxAttempts) {
            const jitterFactor = jitter ? 1 + Math.random() : 1;
            const backOffFactor = backOff ? Math.pow(2, attempt) : 1;
            nextTryIn = timeout * backOffFactor * jitterFactor;
        }
        try {
            return await action(attempt, nextTryIn);
        } catch (ex) {
            if (nextTryIn === null) throw ex;
            if (shouldRetry && !await shouldRetry(ex)) throw ex;
            await $e3747894d76f1f8c$var$sleep(nextTryIn);
            return await recursiveRetry(attempt + 1);
        }
    };
    return recursiveRetry(0);
};
module.exports["retry"] = $e3747894d76f1f8c$export$9369b12211e1fce4;

});

parcelRegister("2wSyg", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7W8i8 = parcelRequire("7W8i8");

const $87bc0f5ac3c4b9fb$var$logger = (0, $7W8i8.getLogger)('native-collab');
const $87bc0f5ac3c4b9fb$var$DraftSyncAndPublishContext = /*#__PURE__*/ (0, $cozmU.createContext)({
    getIsPublishing: ()=>false,
    setIsPublishing: (_)=>{
    // Intentional no-op
    },
    isPublishing: false,
    subscribeDraftSyncSuccess: ()=>()=>{},
    notifyDraftSyncSuccess: ()=>{}
});
const $87bc0f5ac3c4b9fb$export$dc8d83ecee528ce8 = ({ children: children })=>{
    // These should remain in sync. The ref is used while a draft sync occurs, while
    // the state variable is used for re-rendering.
    const isPublishingRef = (0, $cozmU.useRef)(false);
    const [isPublishing, setIsPublishing] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    const draftSyncSuccessListeners = (0, $cozmU.useRef)(new Set());
    const subscribeDraftSyncSuccess = (0, $cozmU.useCallback)((listener)=>{
        draftSyncSuccessListeners.current.add(listener);
        return ()=>{
            draftSyncSuccessListeners.current.delete(listener);
        };
    }, []);
    const notifyDraftSyncSuccess = (0, $cozmU.useCallback)((contentId)=>{
        draftSyncSuccessListeners.current.forEach((listener)=>{
            try {
                listener(contentId);
            } catch (error) {
                // An observer failure must not turn a successful draft save into a sync error.
                $87bc0f5ac3c4b9fb$var$logger.error`Draft sync success listener failed: ${error}`;
            }
        });
    }, []);
    const getIsPublishing = (0, $cozmU.useCallback)(()=>isPublishingRef.current, []);
    const setPublishing = (0, $cozmU.useCallback)((value)=>{
        isPublishingRef.current = value;
        setIsPublishing(value);
    }, []);
    const contextValue = (0, $cozmU.useMemo)(()=>({
            getIsPublishing: getIsPublishing,
            setIsPublishing: setPublishing,
            isPublishing: isPublishing,
            subscribeDraftSyncSuccess: subscribeDraftSyncSuccess,
            notifyDraftSyncSuccess: notifyDraftSyncSuccess
        }), [
        getIsPublishing,
        setPublishing,
        isPublishing,
        subscribeDraftSyncSuccess,
        notifyDraftSyncSuccess
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87bc0f5ac3c4b9fb$var$DraftSyncAndPublishContext.Provider, {
        value: contextValue
    }, children);
};
const $87bc0f5ac3c4b9fb$export$bceb447197cf2e23 = ({ children: children })=>{
    const context = $87bc0f5ac3c4b9fb$export$6aa44ee82d5db3e4();
    return children(context);
};
const $87bc0f5ac3c4b9fb$export$6aa44ee82d5db3e4 = ()=>{
    return (0, $cozmU.useContext)($87bc0f5ac3c4b9fb$var$DraftSyncAndPublishContext);
};
module.exports["DraftSyncAndPublishContextProvider"] = $87bc0f5ac3c4b9fb$export$dc8d83ecee528ce8;
module.exports["DraftSyncAndPublishContextConsumer"] = $87bc0f5ac3c4b9fb$export$bceb447197cf2e23;
module.exports["useDraftSyncAndPublishContext"] = $87bc0f5ac3c4b9fb$export$6aa44ee82d5db3e4;

});

parcelRegister("2VZOl", function(module, exports) {

var $j8on0 = parcelRequire("j8on0");

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $9HkI0 = parcelRequire("9HkI0");

const $a3221c0e46c131d6$export$cd763072e62a98fa = (0, $j8on0.createContainer)();
const $a3221c0e46c131d6$var$Store = (0, $8s9DV.createStore)({
    containedBy: $a3221c0e46c131d6$export$cd763072e62a98fa,
    initialState: {
        presenceId: ''
    },
    actions: {},
    handlers: {
        onInit: ()=>({ setState: setState })=>{
                setState({
                    presenceId: (0, $9HkI0.v4)()
                });
            }
    }
});
const $a3221c0e46c131d6$export$f529db6cceb299f5 = (0, $kBr4q.createHook)($a3221c0e46c131d6$var$Store);
module.exports["NativeCollabPresenceStateContainer"] = $a3221c0e46c131d6$export$cd763072e62a98fa;
module.exports["useNativeCollabPresenceState"] = $a3221c0e46c131d6$export$f529db6cceb299f5;

});

parcelRegister("3mVfX", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $8i27m = parcelRequire("8i27m");


var $kgNLQ = parcelRequire("kgNLQ");

var $4440a0699c7a4c4d$export$ca559f4ef107f965 = /*#__PURE__*/ function(ViewValues) {
    ViewValues["OPEN"] = "OPEN";
    ViewValues["UNREAD"] = "UNREAD";
    ViewValues["DELETED_CONTENT"] = "DELETED_CONTENT";
    ViewValues["RESOLVED"] = "RESOLVED";
    ViewValues["MENTIONS_ME"] = "MENTIONS_ME";
    return ViewValues;
}({});
var $4440a0699c7a4c4d$export$edda0a7e0ba757fd = /*#__PURE__*/ function(SortValues) {
    SortValues["PAGE_ORDER"] = "PAGE_ORDER";
    SortValues["MOST_RECENT"] = "MOST_RECENT";
    return SortValues;
}({});
var $4440a0699c7a4c4d$export$8d8bcfcd1bcc8a7c = /*#__PURE__*/ function(CommentMode) {
    CommentMode["VIEW"] = "view";
    CommentMode["ADD"] = "add";
    return CommentMode;
}({});
var $4440a0699c7a4c4d$export$94f8d08c2312472b = /*#__PURE__*/ function(AddFooterCommentMode) {
    AddFooterCommentMode["FOOTER"] = "footer";
    AddFooterCommentMode["STICKY_DRAFT"] = "sticky_draft";
    AddFooterCommentMode["STICKY_FOOTER"] = "sticky_footer";
    return AddFooterCommentMode;
}({});
const $4440a0699c7a4c4d$var$getInitialState = ()=>({
        currentView: undefined,
        currentSort: "PAGE_ORDER",
        showInlineComments: true,
        showGeneralComments: true,
        currentlySelectedThreadKey: undefined,
        isCurrentlySelectedThreadOptimisticallyAdded: false,
        initialDataLoadedForViewMap: {
            ["UNREAD"]: false,
            ["OPEN"]: false,
            ["DELETED_CONTENT"]: false,
            ["RESOLVED"]: false,
            ["MENTIONS_ME"]: false
        },
        replyToCommentId: undefined,
        replyToCommentUser: undefined,
        replyToContributorUsers: undefined,
        footerEditCommentIds: new Set(),
        currentlyRenderedThreads: [],
        location: undefined,
        commentType: undefined,
        commentMode: "view",
        isCommentAddPromptFocused: false,
        commentContainerToFocus: undefined,
        addFooterCommentAdf: undefined,
        cachedSummary: null,
        triggerOnDemandSummary: false,
        isSummaryDismissedByUser: false,
        automaticSummariesPreference: undefined
    });
// Actions for managing the comments state in the comments panel
const $4440a0699c7a4c4d$var$actions = {
    getCommentsPanelState: ()=>({ getState: getState })=>{
            return getState();
        },
    setCurrentView: (view)=>({ setState: setState })=>{
            setState({
                currentView: view
            });
        },
    setCurrentSort: (sort)=>({ setState: setState })=>{
            setState({
                currentSort: sort
            });
        },
    setShowInlineComments: (showInline)=>({ setState: setState })=>{
            setState({
                showInlineComments: showInline
            });
        },
    setShowGeneralComments: (showGeneral)=>({ setState: setState })=>{
            setState({
                showGeneralComments: showGeneral
            });
        },
    setCurrentlySelectedThreadKey: (threadKey, commentType, isOptimisticAddSuccess)=>({ getState: getState, setState: setState })=>{
            const { currentlySelectedThreadKey: currentlySelectedThreadKey } = getState();
            if (!!isOptimisticAddSuccess && commentType === (0, $8i27m.CommentType).GENERAL && currentlySelectedThreadKey !== (0, $kgNLQ.OPTIMISTIC_SAVE_COMMENT_ID)) // This means that user has selected a different comment thread
            // after new comment was optimistically added on UI but before
            // the GQL mutation succeeded. In this case, we shouldn't set
            // currentlySelectedThreadKey to the new comment.
            return;
            setState({
                currentlySelectedThreadKey: threadKey,
                commentType: commentType,
                // Note: Added for COMMENTS-6792: Optimistically adding a footer comment.
                // When adding a footer comment optimistically, setCurrentlySelectedThreadKey is
                // called twice: once when the comment is added to UI optimistically with a fake id,
                // and once more when the mutation succeeds and UI is updated with the actual id.
                // The effect of the second call is rendered on UI before the updated comment list
                // is rendered, which causes a visible flicker, where the new comment goes from
                // "selected" -> "unselected" (for an instant) -> "selected" again.
                // To fix this flicker, we keep showing the comment with fake id as "selected" when
                // this flag is true, even if value of `currentlySelectedThreadKey` has changed.
                isCurrentlySelectedThreadOptimisticallyAdded: commentType === (0, $8i27m.CommentType).GENERAL && !!isOptimisticAddSuccess
            });
        },
    setInitialDataLoadedForView: ({ viewToSetLoaded: viewToSetLoaded })=>({ getState: getState, setState: setState })=>{
            const { initialDataLoadedForViewMap: initialDataLoadedForViewMap } = getState();
            initialDataLoadedForViewMap[viewToSetLoaded] = true;
            setState({
                initialDataLoadedForViewMap: initialDataLoadedForViewMap
            });
        },
    setReplyToCommentId: ({ parentCommentId: parentCommentId, location: location, user: user, contributorUsers: contributorUsers } = {})=>({ setState: setState })=>{
            setState({
                replyToCommentId: parentCommentId,
                location: location,
                replyToCommentUser: user,
                replyToContributorUsers: contributorUsers
            });
        },
    setReplyToContributorUsers: (users)=>({ setState: setState })=>{
            setState({
                replyToContributorUsers: users
            });
        },
    resetInitialDataLoadedMap: ()=>({ setState: setState })=>{
            setState($4440a0699c7a4c4d$var$getInitialState());
        },
    setCurrentlyRenderedThreads: (threads)=>({ setState: setState })=>{
            setState({
                currentlyRenderedThreads: threads
            });
        },
    addFooterEditCommentId: (commentId)=>({ setState: setState, getState: getState })=>{
            const { footerEditCommentIds: footerEditCommentIds } = getState();
            // Required to change the state object reference to trigger a re-render
            const newFooterEditCommentIds = new Set(footerEditCommentIds);
            newFooterEditCommentIds.add(commentId);
            setState({
                footerEditCommentIds: newFooterEditCommentIds
            });
        },
    removeFooterEditCommentId: (commentId)=>({ setState: setState, getState: getState })=>{
            const { footerEditCommentIds: footerEditCommentIds } = getState();
            // Required to change the state object reference to trigger a re-render
            const newFooterEditCommentIds = new Set(footerEditCommentIds);
            newFooterEditCommentIds.delete(commentId);
            setState({
                footerEditCommentIds: newFooterEditCommentIds
            });
        },
    setCommentMode: (mode)=>({ setState: setState })=>{
            setState({
                commentMode: mode
            });
        },
    setIsCommentAddPromptFocused: (isFocused)=>({ setState: setState })=>{
            setState({
                isCommentAddPromptFocused: isFocused
            });
        },
    resetCommentMode: ()=>({ setState: setState })=>{
            setState({
                commentMode: "view",
                isCommentAddPromptFocused: false
            });
        },
    setCommentContainerToFocus: (commentContainerToFocus)=>({ setState: setState })=>{
            setState({
                commentContainerToFocus: commentContainerToFocus
            });
        },
    setAddFooterCommentAdf: (addFooterCommentAdf)=>({ setState: setState })=>{
            setState({
                addFooterCommentAdf: addFooterCommentAdf
            });
        },
    setCachedSummary: (cachedSummary)=>({ setState: setState })=>{
            setState({
                cachedSummary: cachedSummary
            });
        },
    setTriggerOnDemandSummary: (triggerOnDemandSummary)=>({ setState: setState })=>{
            setState({
                triggerOnDemandSummary: triggerOnDemandSummary
            });
        },
    setIsSummaryDismissedByUser: (isSummaryDismissedByUser)=>({ setState: setState })=>{
            setState({
                isSummaryDismissedByUser: isSummaryDismissedByUser
            });
        },
    setAutomaticSummariesPreference: (automaticSummariesPreference)=>({ setState: setState })=>{
            setState({
                automaticSummariesPreference: automaticSummariesPreference
            });
        }
};
const $4440a0699c7a4c4d$var$CommentsStore = (0, $8s9DV.createStore)({
    initialState: $4440a0699c7a4c4d$var$getInitialState(),
    actions: $4440a0699c7a4c4d$var$actions,
    name: 'CommentsStore'
});
const $4440a0699c7a4c4d$export$8607294e360a4610 = (0, $kBr4q.createHook)($4440a0699c7a4c4d$var$CommentsStore);
const $4440a0699c7a4c4d$export$1719a5796ebd8e85 = (0, $kBr4q.createActionsHook)($4440a0699c7a4c4d$var$CommentsStore);
const $4440a0699c7a4c4d$export$5b0e6f8eb2b6ddcb = (0, $kBr4q.createStateHook)($4440a0699c7a4c4d$var$CommentsStore);
module.exports["ViewValues"] = $4440a0699c7a4c4d$export$ca559f4ef107f965;
module.exports["SortValues"] = $4440a0699c7a4c4d$export$edda0a7e0ba757fd;
module.exports["CommentMode"] = $4440a0699c7a4c4d$export$8d8bcfcd1bcc8a7c;
module.exports["AddFooterCommentMode"] = $4440a0699c7a4c4d$export$94f8d08c2312472b;
module.exports["useCommentsPanel"] = $4440a0699c7a4c4d$export$8607294e360a4610;
module.exports["useCommentsPanelActions"] = $4440a0699c7a4c4d$export$1719a5796ebd8e85;
module.exports["useCommentsPanelState"] = $4440a0699c7a4c4d$export$5b0e6f8eb2b6ddcb;

});

parcelRegister("8i27m", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $3u5lg = parcelRequire("3u5lg");

var $33a0cfbfba499043$export$ffa1150e6a48f9cd = /*#__PURE__*/ function(CommentType) {
    CommentType["INLINE"] = "inline";
    CommentType["GENERAL"] = "general";
    return CommentType;
}({});
var $33a0cfbfba499043$export$74159dff405238c0 = /*#__PURE__*/ function(CommentActionType) {
    CommentActionType["DELETE_COMMENT"] = "deleted";
    // If you ever update this, please also update commentsNavigationUtils, which relies on the string to avoid circular deps
    CommentActionType["RESOLVE_COMMENT_THREAD"] = "resolved";
    return CommentActionType;
}({});
const $33a0cfbfba499043$export$53ac33307b5acee9 = ()=>({
        orderedActiveAnnotationIdList: [],
        commentThreadsRemovedByOtherUsers: {}
    });
const $33a0cfbfba499043$export$e324594224ef24da = {
    setOrderedActiveAnnotationIdList: (newCommentsList)=>({ getState: getState, setState: setState })=>{
            const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList } = getState();
            if (!newCommentsList || newCommentsList.length === 0) {
                // Only update state if the current list is not already empty
                if (orderedActiveAnnotationIdList.length > 0) setState({
                    orderedActiveAnnotationIdList: []
                });
                return;
            }
            // Create a map of existing annotationId to their isLoaded states for quick lookup
            const existingAnnotationsMap = new Map(orderedActiveAnnotationIdList.map(({ threadKey: threadKey, isLoaded: isLoaded })=>[
                    threadKey,
                    isLoaded
                ]));
            // Use a Set to ensure unique annotation IDs
            const uniqueCommentsSet = new Set(newCommentsList);
            // Map the unique comments set to the new state, preserving isLoaded where possible
            const updatedAnnotationList = Array.from(uniqueCommentsSet).map((threadKey)=>({
                    threadKey: threadKey,
                    isLoaded: existingAnnotationsMap.get(threadKey) ?? false // Preserve existing isLoaded or default to false
                }));
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(orderedActiveAnnotationIdList, updatedAnnotationList)) setState({
                orderedActiveAnnotationIdList: updatedAnnotationList
            });
        },
    getCurrentCommentsPanelState: ()=>({ getState: getState })=>{
            return getState();
        },
    // keep track of removed annotations
    updateRemovedCommentIdsMap: ({ commentId: commentId, commentActionType: commentActionType })=>({ setState: setState, getState: getState })=>{
            const { commentThreadsRemovedByOtherUsers: commentThreadsRemovedByOtherUsers } = getState();
            // Update commentThreadsRemovedByOtherUsers map
            const updatedRemovedComments = {
                ...commentThreadsRemovedByOtherUsers
            };
            updatedRemovedComments[commentId] = commentActionType;
            // Update the removed-by-other-users map.
            setState({
                commentThreadsRemovedByOtherUsers: updatedRemovedComments
            });
        },
    reopenParentComment: ({ parentCommentId: parentCommentId })=>({ setState: setState, getState: getState })=>{
            // Records a reopened parent comment in the commentThreadsRemovedByOtherUsers map.
            if (!parentCommentId) return;
            const { commentThreadsRemovedByOtherUsers: currentRemovedComments } = getState();
            const updatedRemovedComments = {
                ...currentRemovedComments
            };
            delete updatedRemovedComments[parentCommentId];
            setState({
                commentThreadsRemovedByOtherUsers: updatedRemovedComments
            });
        },
    clearRemovedComments: ()=>({ setState: setState })=>{
            setState({
                commentThreadsRemovedByOtherUsers: {}
            });
        },
    clearCommentsData: ()=>({ setState: setState })=>{
            setState($33a0cfbfba499043$export$53ac33307b5acee9());
        }
};
const $33a0cfbfba499043$export$13b7c646235a7fd4 = (0, $8s9DV.createStore)({
    initialState: $33a0cfbfba499043$export$53ac33307b5acee9(),
    actions: $33a0cfbfba499043$export$e324594224ef24da,
    name: 'CommentsDataStore'
});
const $33a0cfbfba499043$export$80f09eb388fa70f9 = (0, $kBr4q.createHook)($33a0cfbfba499043$export$13b7c646235a7fd4);
const $33a0cfbfba499043$export$b5e3986841a4e13f = (0, $kBr4q.createActionsHook)($33a0cfbfba499043$export$13b7c646235a7fd4);
const $33a0cfbfba499043$export$c14a8182bd597724 = (0, $kBr4q.createStateHook)($33a0cfbfba499043$export$13b7c646235a7fd4);
module.exports["CommentType"] = $33a0cfbfba499043$export$ffa1150e6a48f9cd;
module.exports["CommentActionType"] = $33a0cfbfba499043$export$74159dff405238c0;
module.exports["useCommentsData"] = $33a0cfbfba499043$export$80f09eb388fa70f9;
module.exports["useCommentsDataActions"] = $33a0cfbfba499043$export$b5e3986841a4e13f;
module.exports["useCommentsDataState"] = $33a0cfbfba499043$export$c14a8182bd597724;

});

parcelRegister("fHAwL", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $7fff4328005dca96$var$initialState = {
    // isUpdatingUnreadComments tracks when we're updating the unread comments set
    // (e.g., during initial render or when manually updating the set).
    isUpdatingUnreadComments: true,
    // isUnreadQueryLoading tracks when we're actively fetching comments from the server.
    isUnreadQueryLoading: false,
    unreadCommentIDSet: new Set(),
    shouldClearVisibleThreads: false
};
const $7fff4328005dca96$var$actions = {
    setIsUpdatingUnreadComments: (isUpdatingUnreadComments)=>({ setState: setState })=>{
            setState({
                isUpdatingUnreadComments: isUpdatingUnreadComments
            });
        },
    setIsUnreadQueryLoading: (loading)=>({ setState: setState })=>{
            setState({
                isUnreadQueryLoading: loading
            });
        },
    updateUnreadCommentIDSet: (unreadCommentIDSet, operation = 'initialize')=>({ setState: setState, getState: getState })=>{
            const { unreadCommentIDSet: existingSet } = getState();
            switch(operation){
                case 'initialize':
                    setState({
                        unreadCommentIDSet: unreadCommentIDSet
                    });
                    break;
                case 'add':
                    setState({
                        unreadCommentIDSet: new Set([
                            ...existingSet,
                            ...unreadCommentIDSet
                        ])
                    });
                    break;
                case 'remove':
                    const newSet = new Set(existingSet);
                    unreadCommentIDSet.forEach((id)=>newSet.delete(id));
                    setState({
                        unreadCommentIDSet: newSet
                    });
                    break;
                case 'removeAll':
                    setState({
                        unreadCommentIDSet: new Set()
                    });
                    break;
            }
        },
    setShouldClearVisibleThreads: (shouldClearVisibleThreads)=>({ setState: setState })=>{
            setState({
                shouldClearVisibleThreads: shouldClearVisibleThreads
            });
        }
};
const $7fff4328005dca96$var$UnreadCommentsStore = (0, $8s9DV.createStore)({
    initialState: $7fff4328005dca96$var$initialState,
    actions: $7fff4328005dca96$var$actions,
    name: 'UnreadCommentsStore'
});
const $7fff4328005dca96$export$df6365a5248dcd96 = (0, $kBr4q.createHook)($7fff4328005dca96$var$UnreadCommentsStore);
const $7fff4328005dca96$export$b7fe87478f70c759 = (0, $kBr4q.createActionsHook)($7fff4328005dca96$var$UnreadCommentsStore);
const $7fff4328005dca96$export$fdd0a0c032c12265 = (0, $kBr4q.createStateHook)($7fff4328005dca96$var$UnreadCommentsStore);
module.exports["useUnreadComments"] = $7fff4328005dca96$export$df6365a5248dcd96;
module.exports["useUnreadCommentsActions"] = $7fff4328005dca96$export$b7fe87478f70c759;
module.exports["useUnreadCommentsState"] = $7fff4328005dca96$export$fdd0a0c032c12265;

});

parcelRegister("liGyh", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6tkbf = parcelRequire("6tkbf");


var $7zgzO = parcelRequire("7zgzO");


var $ep3mz = parcelRequire("ep3mz");


var $lb2Lp = parcelRequire("lb2Lp");


var $kgNLQ = parcelRequire("kgNLQ");


var $aSsfA = parcelRequire("aSsfA");

const $ba57c93125c5375a$export$63c5e37b7c8d14d1 = ({ location: location } = {})=>{
    const { getQueryParams: getQueryParams, setQueryParams: setQueryParams } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const [pageId] = (0, $ep3mz.usePageContentId)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { focusedCommentId: focusedCommentId, editComment: editComment, commentId: commentId, replyToComment: replyToComment, showCommentArea: showCommentArea, shouldMention: shouldMention, unreadCommentMark: unreadCommentMark } = getQueryParams();
    const targetCommentId = focusedCommentId || replyToComment || editComment && commentId;
    const shouldSkipQuery = !targetCommentId || !location;
    const { comment: comment, error: error } = (0, $lb2Lp.useCommentById)({
        commentId: targetCommentId || '',
        contentId: pageId || '',
        contentStatus: (0, $kgNLQ.buildDefaultCommentsContentStatusFilters)(pageMode),
        options: {
            skip: shouldSkipQuery
        }
    });
    // Note that this will detect missing inline and footer comments because the query will find
    // either type of comment - so if the comment doesn't exist, we will get the "not found" error
    // In the new flow, useCommentById returns an error when the comment isn't found after loading completes
    const isCommentNotFound = error ? (0, $6tkbf.isCommentNotFoundError)(error.message || String(error)) : false;
    let focusedId;
    let editCommentId;
    let replyToCommentId;
    let commentContainerId;
    if (comment && 'container' in comment) // Comment replies coming from the new manager don't have a container
    commentContainerId = comment.container?.id;
    else commentContainerId = undefined;
    // Only return comment IDs for relevant location; If no location is given, return them all
    const shouldReturnIds = (!location || location === comment?.location?.type) && (pageId === commentContainerId || commentContainerId === undefined);
    if (shouldReturnIds) {
        /* A focused comment query param just uses "focusedCommentId={COMMENT_ID}" */ focusedId = focusedCommentId ? focusedCommentId : undefined;
        /* An edit comment query param uses a combination of "editComment=true&commentId={COMMENT_ID}" */ editCommentId = editComment && editComment === 'true' && commentId ? commentId : undefined;
        /* A reply to comment query param just uses "replyToComment={COMMENT_ID}" */ replyToCommentId = replyToComment ? replyToComment : undefined;
    }
    /* PAGE COMMENTS ONLY: A new comment uses the "showCommentArea=true" query param */ const shouldOpenNewCommentEditor = showCommentArea === 'true';
    /* A mention comment uses the "shouldMention=true" query param */ const shouldMentionInNewCommentEditor = shouldMention === 'true' && replyToCommentId !== undefined;
    const removeCommentQueryParamsFunction = ()=>{
        let commentTypeKey = '', commentIdKey = '', commentMentionKey = '';
        if (focusedId) commentTypeKey = 'focusedCommentId';
        else if (shouldMentionInNewCommentEditor) {
            commentTypeKey = 'replyToComment';
            commentMentionKey = 'shouldMention';
        } else if (replyToCommentId) commentTypeKey = 'replyToComment';
        else if (editCommentId) {
            commentTypeKey = 'editComment';
            commentIdKey = 'commentId';
        } else if (shouldOpenNewCommentEditor) commentTypeKey = 'showCommentArea';
        if (commentTypeKey || commentIdKey || commentMentionKey || unreadCommentMark) {
            const params = getQueryParams();
            setQueryParams({
                ...params,
                [commentTypeKey]: undefined,
                [commentIdKey]: undefined,
                [commentMentionKey]: undefined,
                unreadCommentMark: undefined
            });
        }
    };
    const removeCommentQueryParams = (0, $cozmU.useCallback)(removeCommentQueryParamsFunction, [
        getQueryParams,
        setQueryParams,
        unreadCommentMark,
        editCommentId,
        replyToCommentId,
        shouldOpenNewCommentEditor,
        shouldMentionInNewCommentEditor,
        focusedId
    ]);
    const setFocusedCommentQueryParam = (commentId)=>{
        const params = getQueryParams();
        setQueryParams({
            ...params,
            focusedCommentId: commentId
        });
    };
    return {
        focusedCommentId: focusedId,
        editCommentId: editCommentId,
        replyToCommentId: replyToCommentId,
        shouldOpenNewCommentEditor: shouldOpenNewCommentEditor,
        shouldMentionInNewCommentEditor: shouldMentionInNewCommentEditor,
        unreadCommentMark: unreadCommentMark,
        removeCommentQueryParams: removeCommentQueryParams,
        setFocusedCommentQueryParam: setFocusedCommentQueryParam,
        isCommentNotFound: isCommentNotFound
    };
};
const $ba57c93125c5375a$export$b073d30d47d4035b = ({ queryArchivedContent: queryArchivedContent = false } = {})=>$ba57c93125c5375a$export$63c5e37b7c8d14d1({
        location: 'INLINE',
        queryArchivedContent: queryArchivedContent
    });
const $ba57c93125c5375a$export$97d0ff531551284c = ()=>$ba57c93125c5375a$export$63c5e37b7c8d14d1({
        location: 'FOOTER'
    });
module.exports["useInlineCommentQueryParams"] = $ba57c93125c5375a$export$b073d30d47d4035b;

});

parcelRegister("6tkbf", function(module, exports) {

var $lb2Lp = parcelRequire("lb2Lp");


var $6mKj3 = parcelRequire("6mKj3");

const $6b00aa328c211ce7$export$5c24224d7e29c719 = ()=>{
    return {
        context: {
            fetchOptions: {
                ignoreNoNetworkError: (0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_offline_fix', 'isEnabled', true)
            }
        }
    };
};
const $6b00aa328c211ce7$export$9f99b736afd21d01 = (errorMessage)=>{
    if (errorMessage) {
        // Check if the full error message matches the string thrown from useCommentById
        if (errorMessage === (0, $lb2Lp.USE_COMMENT_BY_ID_COMMENT_NOT_FOUND_MESSAGE)) return true;
        // Also check the reason message (extracted from backend error format)
        const reasonStartIdx = errorMessage.lastIndexOf(':') + 1;
        const reasonMessage = errorMessage.substring(reasonStartIdx, errorMessage.length).trim();
        // If this string is ever updated on the BE and you need to change it - make sure to also update USE_COMMENT_BY_ID_COMMENT_NOT_FOUND_MESSAGE for consistency
        const backendReasonMessage = 'No comment found for the given id';
        return reasonMessage === backendReasonMessage;
    }
    return false;
};
module.exports["buildMutationContextForNoNetworkError"] = $6b00aa328c211ce7$export$5c24224d7e29c719;
module.exports["isCommentNotFoundError"] = $6b00aa328c211ce7$export$9f99b736afd21d01;

});

parcelRegister("lb2Lp", function(module, exports) {

var $dc3kb = parcelRequire("dc3kb");


var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $c0rhi = parcelRequire("c0rhi");


var $7Sm4c = parcelRequire("7Sm4c");


var $NYiei = parcelRequire("NYiei");


var $kgNLQ = parcelRequire("kgNLQ");


var $4L9ve = parcelRequire("4L9ve");

// The `useCommentById` hook efficiently fetches a single comment by ID with a simple strategy:
// First, it checks the cache for the allCommentsDataQuery using useAllCommentsData with cache-only
// policy. If the comment is found in the cache and data is processed, it uses that data. Otherwise,
// it makes a separate query for just the specific comment. This ensures quick access to individual
// comments without unnecessary network requests when data is already cached. The hook also provides
// loading states, error handling, and comprehensive type safety.
// Unfortunately our Relay-friendly type generation tools don't support GQL fragments yet - but in
// order to keep the definition of the comment fields in sync (so the cache update fragment is
// always in sync with the full query) we will need to manually make any changes to one definition
// in any others as well, until our tooling supports fragments and then we move to a more
// fragmented-based approach.  Note there are also comment queries or fragments in the following
// files that need to be kept in sync as well:
// - next/packages/comments-data-manager/src/useAllCommentsData.ts
// - next/packages/comments-data-manager/src/updateCommentInCache.ts
// - next/packages/comments-data-manager/src/useCreateObjectCommentMutation.ts
// - next/packages/comments-data-manager/src/useCreateInlineCommentMutation.ts
// - next/packages/comments-data-manager/src/useCreateInlineReplyMutation.ts
// - next/packages/object-comments/src/components/ObjectCommentContainer.tsx
// TODO: Replace with the exported fragment from useAllCommentsData.ts when our tooling supports
// it, if we are allowed to share fragments between packages/files.  If we are not allowed to share
// fragments, we should move this hook - or at least the part that executes the query into the
// useAllCommentsData.ts file.
const $f4841d4502be35b2$var$commentByIdQuery = (0, $dc3kb.default);
const $f4841d4502be35b2$export$4bf99575c214d4b = 'Comment not found: No comment found for the given id';
const $f4841d4502be35b2$export$1f091977fe1929e2 = 'useCommentById requires either commentId or markerRef and contentId to be provided';
const $f4841d4502be35b2$export$778dda4ccca7793f = ({ commentId: commentId, markerRef: markerRef, contentId: contentId, contentStatus: contentStatus = [
    'CURRENT'
], options: options = {} })=>{
    const { fetchPolicy: fetchPolicy = 'cache-first', onError: parentOnError, skip: skip = false } = options;
    // Get processed comments data
    const { isDataProcessed: isDataProcessed, flatCommentsMap: flatCommentsMap, flatMarkerRefMap: flatMarkerRefMap, error: processedCommentsError } = (0, $4L9ve.useProcessedCommentsDataState)();
    // Validate that at least one identifier is provided (only if not skipping)
    const validationError = (0, $cozmU.useMemo)(()=>!skip && (!contentId || !commentId && !markerRef) ? new Error($f4841d4502be35b2$export$1f091977fe1929e2) : undefined, [
        skip,
        commentId,
        markerRef,
        contentId
    ]);
    const skipQueries = skip || !!validationError;
    // Skip the individual comment query if we have cached data from the full query, it's been processed, and we're not asking for fresh BE data
    const shouldSkipOneCommentQuery = skipQueries || fetchPolicy !== 'network-only' && isDataProcessed;
    // Always query with all 4 content statuses to guarantee cache hits on preloaded data
    // We'll filter the result client-side based on the passed-in contentStatus
    const oneCommentData = (0, $jMyy4.useQueryInterop)($f4841d4502be35b2$var$commentByIdQuery, {
        variables: {
            pageId: contentId ?? '',
            commentId: commentId || undefined,
            inlineMarkerRef: markerRef || undefined,
            contentStatus: (0, $NYiei.allContentStatuses)
        },
        fetchPolicy: fetchPolicy,
        skip: shouldSkipOneCommentQuery,
        onError: (error)=>{
            // Handle specific GraphQL errors gracefully
            // WS-3494 - If the error isn't related to reactionsSummary returning null, just mark it handled
            // COMMENTS-188 - Or if the error isn't related to cc-pages not being reachable just mark it handled
            if (error?.message?.search(/reactions/i) !== -1 || error?.message?.search(/cc-pages/i) !== -1) (0, $7Sm4c.markErrorAsHandled)(error);
        },
        __callerPackage__: "comments-data-manager"
    });
    // Look for the comment using the flat map for O(1) lookup, or fall back to searching arrays
    const finalComment = (0, $cozmU.useMemo)(()=>{
        if (validationError) return undefined;
        // If data is processed, try to find in the flat maps (fastest - O(1))
        if (isDataProcessed) {
            if (commentId) {
                const cachedComment = flatCommentsMap?.[commentId];
                if (cachedComment) return cachedComment;
            } else if (markerRef) {
                const cachedCommentByMarkerRef = flatMarkerRefMap?.[markerRef];
                if (cachedCommentByMarkerRef) return cachedCommentByMarkerRef;
            }
        }
        // Fall back to searching in oneCommentData if available
        if (oneCommentData.data?.comments?.nodes) {
            // Filter out any null nodes - can't just use .filter because TS complains about type
            // mismatch.  Fortunately, this query should only have one comment node anyway.
            const commentData = oneCommentData.data.comments.nodes.filter((node)=>!!node);
            if (!commentData) return undefined;
            // Search in retrieved comments and their replies
            return (0, $kgNLQ.findAndFilterComment)(commentData, commentId, markerRef, contentStatus);
        }
        return undefined;
    }, [
        validationError,
        commentId,
        flatCommentsMap,
        flatMarkerRefMap,
        isDataProcessed,
        oneCommentData.data?.comments?.nodes,
        markerRef,
        contentStatus
    ]);
    // Create an error if we have the full response but can't find the comment
    // 99% of the time this error will be thrown when cachedUseAllCommentsData is populated, but the comment isn't available
    // useCommentByIdQuery **should** throw a similar error if the comment isn't found from the BE,
    // but keep the check here in case the BE changes, or our comment is in another status & is filtered out
    const commentNotFoundError = (0, $cozmU.useMemo)(()=>{
        // Only create error if:
        // 1. We're not loading anymore (have full response)
        // 2. We have data (either from processedCommentsData or oneCommentData)
        // 3. We searched for the comment but didn't find it
        // 4. There's no existing error
        if (!skipQueries && isDataProcessed && !oneCommentData.loading && !processedCommentsError && !oneCommentData.error && finalComment === undefined) return new Error($f4841d4502be35b2$export$4bf99575c214d4b);
        return undefined;
    }, [
        skipQueries,
        isDataProcessed,
        processedCommentsError,
        oneCommentData.loading,
        oneCommentData.error,
        finalComment
    ]);
    // Memoize the final error to ensure stable reference for use in external useEffects
    const error = (0, $cozmU.useMemo)(()=>{
        return validationError || processedCommentsError || oneCommentData.error || commentNotFoundError;
    }, [
        validationError,
        processedCommentsError,
        oneCommentData.error,
        commentNotFoundError
    ]);
    // Call onError when the error changes
    (0, $cozmU.useEffect)(()=>{
        if (error && parentOnError) parentOnError(error);
    }, [
        error,
        parentOnError
    ]);
    return {
        loading: !isDataProcessed && oneCommentData.loading,
        error: // (Only loading state if both are loading)
        error,
        comment: finalComment
    };
};
const $f4841d4502be35b2$export$77a85b13740d9b96 = async ({ commentId: commentId, markerRef: markerRef, contentId: contentId, fetchPolicy: fetchPolicy = 'network-only' })=>{
    if (!contentId || !commentId && !markerRef) return Promise.resolve(null);
    const response = await (0, $c0rhi.queryInterop)({
        query: $f4841d4502be35b2$var$commentByIdQuery,
        variables: {
            pageId: contentId,
            commentId: commentId || undefined,
            inlineMarkerRef: markerRef || undefined,
            // Query for all content statuses - don't filter by contentStatus
            contentStatus: (0, $NYiei.allContentStatuses)
        },
        fetchPolicy: fetchPolicy,
        __callerPackage__: "comments-data-manager"
    });
    const nodes = response?.data?.comments?.nodes;
    if (!nodes || nodes.length === 0) return null;
    // Filter out nulls and convert readonly array to mutable array
    const comments = nodes.filter((node)=>node !== null);
    return (0, $kgNLQ.findAndFilterComment)(comments, commentId, markerRef, (0, $NYiei.allContentStatuses));
};
module.exports["USE_COMMENT_BY_ID_COMMENT_NOT_FOUND_MESSAGE"] = $f4841d4502be35b2$export$4bf99575c214d4b;
module.exports["useCommentById"] = $f4841d4502be35b2$export$778dda4ccca7793f;
module.exports["fetchCommentById"] = $f4841d4502be35b2$export$77a85b13740d9b96;

});

parcelRegister("dc3kb", function(module, exports) {
/**
 * @generated SignedSource<<1ab88c86ecf711245680266df88d829b>>
 * @relayHash 30943931b9ef970914fcabde1ec18427
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e72641598fb62206869fe26a1fc4981fbd345a6b2241970ee8cf4532c3ad8454
const $09771c757ee62765$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "commentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "inlineMarkerRef"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v4 = {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v8 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v9 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v10 = {
        "kind": "ScalarField",
        "name": "type"
    }, v11 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v12 = {
        "kind": "LinkedField",
        "name": "contributors",
        "plural": true,
        "selections": [
            v6 /*: any*/ ,
            v7 /*: any*/ ,
            v9 /*: any*/ ,
            v11 /*: any*/ 
        ]
    }, v13 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v14 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v13 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v15 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v16 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v13 /*: any*/ 
    }, v17 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v18 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "editui"
            },
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v19 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v20 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v21 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v22 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v23 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            v10 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "commentResolveProperties",
                        "plural": false,
                        "selections": [
                            v19 /*: any*/ ,
                            v20 /*: any*/ ,
                            v21 /*: any*/ ,
                            v22 /*: any*/ 
                        ]
                    }
                ],
                "type": "FooterComment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "inlineMarkerRef"
                    },
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "inlineResolveProperties",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isDangling"
                            },
                            v19 /*: any*/ ,
                            v20 /*: any*/ ,
                            v21 /*: any*/ ,
                            v22 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "inlineText"
                    }
                ],
                "type": "InlineComment"
            }
        ]
    }, v24 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v25 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v26 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            v4 /*: any*/ 
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    }
                ]
            }
        ]
    }, v27 = {
        "kind": "ScalarField",
        "name": "number"
    }, v28 = {
        "kind": "ScalarField",
        "name": "when"
    }, v29 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "commentId",
                    "variableName": "commentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentStatus",
                    "variableName": "contentStatus"
                },
                {
                    "kind": "Variable",
                    "name": "inlineMarkerRef",
                    "variableName": "inlineMarkerRef"
                },
                v4 /*: any*/ 
            ],
            "concreteType": "PaginatedCommentList",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ 
                            ]
                        },
                        v12 /*: any*/ ,
                        v14 /*: any*/ ,
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "container",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ 
                            ]
                        },
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        v17 /*: any*/ ,
                        v18 /*: any*/ ,
                        v23 /*: any*/ ,
                        v24 /*: any*/ ,
                        v25 /*: any*/ ,
                        v26 /*: any*/ ,
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "replies",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v9 /*: any*/ 
                                    ]
                                },
                                v12 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                v25 /*: any*/ ,
                                v26 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        },
                                        v27 /*: any*/ ,
                                        v28 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v11 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "friendlyWhen"
                                },
                                v27 /*: any*/ ,
                                v28 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useCommentByIdQuery",
            "selections": v29 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useCommentByIdQuery",
            "selections": v29 /*: any*/ 
        },
        "params": {
            "cacheID": "30943931b9ef970914fcabde1ec18427",
            "id": "e72641598fb62206869fe26a1fc4981fbd345a6b2241970ee8cf4532c3ad8454",
            "metadata": {},
            "name": "useCommentByIdQuery",
            "operationKind": "query",
            "text": "query useCommentByIdQuery($pageId:ID!,$commentId:ID,$inlineMarkerRef:String,$contentStatus:[GraphQLContentStatus]){comments(pageId:$pageId,contentStatus:$contentStatus,commentId:$commentId,inlineMarkerRef:$inlineMarkerRef){nodes{id,author{__typename,displayName,permissionType,...on KnownUser{accountId,permissionType},profilePicture{path},type},contributors{__typename,displayName,profilePicture{path},...on KnownUser{accountId}},body(representation:ATLAS_DOC_FORMAT){value},container{id},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},replies{id,author{__typename,displayName,permissionType,...on KnownUser{accountId},profilePicture{path}},contributors{__typename,displayName,profilePicture{path},...on KnownUser{accountId}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},version{by{__typename,displayName},number,when}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,when}}}}"
        }
    };
}();
$09771c757ee62765$var$node.hash = "e144cc71550d14f94a82d8439ed2ba0e";
var $09771c757ee62765$export$2e2bcd8739ae039 = $09771c757ee62765$var$node;
module.exports["default"] = $09771c757ee62765$export$2e2bcd8739ae039;

});

parcelRegister("NYiei", function(module, exports) {

var $1Pttz = parcelRequire("1Pttz");


var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $7Sm4c = parcelRequire("7Sm4c");


var $6mKj3 = parcelRequire("6mKj3");


var $kgNLQ = parcelRequire("kgNLQ");

const $bd3b81debc212a33$export$ef1591875b2a95ef = 1500;
const $bd3b81debc212a33$export$a1c5d5765ca44631 = [
    'DRAFT',
    'CURRENT',
    'ARCHIVED',
    'DELETED'
];
const $bd3b81debc212a33$export$a5752cd8da7feaeb = (0, $1Pttz.default);
const $bd3b81debc212a33$export$66fa4e722aa8c832 = (contentId)=>({
        pageId: contentId,
        contentStatus: $bd3b81debc212a33$export$a1c5d5765ca44631,
        first: $bd3b81debc212a33$export$ef1591875b2a95ef
    });
const $bd3b81debc212a33$var$addCommentRootToCache = ({ cachedRootComments: cachedRootComments, totalCount: totalCount, newComment: newComment, repliesCount: repliesCount })=>{
    const updatedRootComments = [
        ...cachedRootComments
    ];
    let updatedTotalCount = totalCount;
    // If there is already a comment with the same ID in the root array, replace it
    // Normally this shouldn't happen because new comments should always have unique IDs, but there
    // is a case were this can happen with replies (see below) - so let's be safe and handle it just
    // in case it ever happens with root comments as well.
    const existingRootIndex = updatedRootComments.findIndex((comment)=>newComment?.id && comment?.id === newComment?.id);
    if (existingRootIndex !== -1) updatedRootComments[existingRootIndex] = newComment;
    else {
        // Else add the newly added comment to the end of the root comments list
        updatedRootComments.push(newComment);
        // Increment total count. Note that we can only add individual comments without any replies, but
        // let's be safe and adjust for any replies in case this ever changes
        updatedTotalCount += repliesCount + 1;
    }
    return {
        updatedRootComments: updatedRootComments,
        updatedTotalCount: updatedTotalCount,
        error: undefined
    };
};
const $bd3b81debc212a33$var$addCommentReplyInCache = ({ cachedRootComments: cachedRootComments, totalCount: totalCount, newComment: newComment, repliesCount: repliesCount, parentId: parentId })=>{
    // For replies, we need to add the reply from the top-level parent's replies list in the main
    // query's cache. This is because the reply arrays are actually flat arrays of Comment objects -
    // nested comments are not actually nested in the GQL data schema but stored flat in the root
    // parent's replies array with the parentId field that indicates which comment they really reply
    // to (we build the actual nested structure elsewhere in the FE). So to add a reply, we need to
    // find the top-level parent comment first.
    let updatedTotalCount = totalCount;
    let error = undefined;
    // First, find the top-level parent comment
    const parentComment = (0, $kgNLQ.findRootCommentForReply)(cachedRootComments, parentId);
    if (parentComment) {
        // Create a copy of the parent's replies array, as the original is readonly
        const updatedReplies = [
            ...parentComment.replies
        ];
        // If there is already a reply with the same ID in the parent's replies, replace it
        // Normally this shouldn't happen because new comments should always have unique IDs, but there
        // is a case were this can happen - when we're in edit mode and another user who is also in
        // edit mode also adds a reply to comment on the new text and then Updates the page -> we get
        // the new reply via the pubsub events and again when the new text is added by the Update.
        const existingReplyIndex = updatedReplies.findIndex((reply)=>newComment?.id && reply?.id === newComment?.id);
        if (existingReplyIndex !== -1) updatedReplies[existingReplyIndex] = newComment;
        else {
            // Else add the new  reply to the array
            updatedReplies.push(newComment);
            // Increment total count. We can only add individual comments without any replies, but let's be
            // safe and adjust for any replies in case this ever changes
            updatedTotalCount += 1 + repliesCount;
        }
        // Coerce the readonly replies array to be modifiable so we don't have to create new
        // modifiable comment objects all the way up the parent chain
        parentComment.replies = updatedReplies;
    } else // Parent comment not found
    error = Error(`Cannot add reply comment in cache: can not find parent comment with ID ${parentId}`);
    return {
        updatedRootComments: cachedRootComments,
        updatedTotalCount: updatedTotalCount,
        error: error
    };
};
const $bd3b81debc212a33$var$addCommentToCache = ({ cachedRootComments: cachedRootComments, newComment: newComment, totalCount: totalCount })=>{
    // Update the appropriate part of the cache depending on whether it's a root comment or a reply
    const parentId = newComment?.parentId;
    const repliesCount = newComment?.replies?.length || 0;
    return !parentId ? $bd3b81debc212a33$var$addCommentRootToCache({
        cachedRootComments: cachedRootComments,
        totalCount: totalCount,
        newComment: newComment,
        repliesCount: repliesCount
    }) : $bd3b81debc212a33$var$addCommentReplyInCache({
        cachedRootComments: cachedRootComments,
        totalCount: totalCount,
        newComment: newComment,
        repliesCount: repliesCount,
        parentId: parentId
    });
};
const $bd3b81debc212a33$var$deleteRootCommentInCache = ({ cachedRootComments: cachedRootComments, totalCount: totalCount, commentId: commentId, repliesCount: repliesCount })=>{
    let updatedTotalCount = totalCount;
    // Remove the newly resolved comment from the list if we can find it
    // Create a copy of the root comment array without the deleted reply, as the original is readonly
    const updatedRootComments = cachedRootComments.filter((comment)=>comment?.id !== commentId);
    // Decrement total count - currently we can't delete a reply that has any comments, but
    // let's be safe and adjust for any replies in case this ever changes
    updatedTotalCount -= 1 + repliesCount;
    return {
        updatedRootComments: updatedRootComments,
        updatedTotalCount: updatedTotalCount,
        error: undefined
    };
};
const $bd3b81debc212a33$var$deleteCommentReplyInCache = ({ cachedRootComments: cachedRootComments, totalCount: totalCount, commentId: commentId, repliesCount: repliesCount, parentId: parentId })=>{
    // For replies, we need to remove the reply from the top-level comment's replies list in the main
    // query's cache. This is because the reply arrays are actually flat arrays of Comment objects -
    // nested comments are not actually nested in the GQL data schema but stored flat in the root
    // parent's replies array with the parentId field that indicates which comment they really reply
    // to (we build the actual nested structure elsewhere in the FE).  So to remove a reply, we need to
    // find the top-level parent comment first.
    let updatedTotalCount = totalCount;
    let error = undefined;
    // First, find the top-level parent comment
    const parentComment = (0, $kgNLQ.findRootCommentForReply)(cachedRootComments, parentId);
    if (parentComment) {
        // Create a copy of the parent's replies array without the deleted reply, as the original
        // is readonly
        const updatedReplies = (parentComment.replies || []).filter((reply)=>reply?.id !== commentId);
        // Coerce the readonly replies array to be modifiable so we don't have to create new
        // modifiable comment objects all the way up the parent chain
        parentComment.replies = updatedReplies;
        // Decrement total count. Currently we can't delete a reply that has any comments. Also
        // since we can’t have spread fragments in Relay-friendly queries yet, the current
        // CommentReply type doesn't have a `replies` field. And the backend, sends the nested
        // replies to us in a flat list with the correct parentIDs so the FE must manually nest
        // them. But let's adjust the count for replies just in case this ever changes.
        updatedTotalCount -= 1 + repliesCount;
    } else // Parent comment not found
    error = Error(`Cannot delete reply comment in cache: can not find parent comment with ID ${parentId}`);
    return {
        updatedRootComments: cachedRootComments,
        updatedTotalCount: updatedTotalCount,
        error: error
    };
};
const $bd3b81debc212a33$var$removeCommentFromCache = ({ cachedRootComments: cachedRootComments, commentId: commentId, totalCount: totalCount })=>{
    // Find the comment to delete to determine if it's a root comment or a reply
    const commentToDelete = (0, $kgNLQ.findCommentInData)(cachedRootComments, commentId);
    if (!commentToDelete) return {
        updatedRootComments: [],
        updatedTotalCount: 0,
        error: new Error(`Cannot delete comment in cache: comment with ID ${commentId} not found`)
    };
    // Update the appropriate part of the cache depending on whether it's a root comment or a reply
    const parentId = commentToDelete.parentId;
    const repliesCount = commentToDelete.replies?.length || 0;
    return !parentId ? $bd3b81debc212a33$var$deleteRootCommentInCache({
        cachedRootComments: cachedRootComments,
        totalCount: totalCount,
        commentId: commentId,
        repliesCount: repliesCount
    }) : $bd3b81debc212a33$var$deleteCommentReplyInCache({
        cachedRootComments: cachedRootComments,
        totalCount: totalCount,
        commentId: commentId,
        repliesCount: repliesCount,
        parentId: parentId
    });
};
const $bd3b81debc212a33$export$19f817fe57f17368 = ({ contentId: contentId, options: options = {} })=>{
    const { fetchPolicy: fetchPolicy = 'cache-first', onCompleted: parentOnCompleted, onError: parentOnError } = options;
    // Shared handling for query errors (initial load and refetch): mark certain errors as handled, then invoke callback.
    // WS-3494 / COMMENTS-188
    const applyQueryErrorHandling = (0, $cozmU.useCallback)((error, callback)=>{
        if (error?.message?.search(/reactions/i) !== -1 || error?.message?.search(/cc-pages/i) !== -1) (0, $7Sm4c.markErrorAsHandled)(error);
        callback?.(error);
    }, []);
    const handleQueryError = (0, $cozmU.useCallback)((error)=>applyQueryErrorHandling(error, parentOnError), [
        applyQueryErrorHandling,
        parentOnError
    ]);
    // Skip query if no content ID or explicitly skipped
    const shouldSkip = !contentId || !!options.skip;
    const queryResponse = (0, $jMyy4.useQueryInterop)($bd3b81debc212a33$export$a5752cd8da7feaeb, {
        variables: $bd3b81debc212a33$export$66fa4e722aa8c832(contentId ?? ''),
        skip: shouldSkip,
        context: {
            single: true
        },
        fetchPolicy: // We auto-batch queries that fire within 10ms of eachother. Since this query is slow, this unbatches it to avoid slowing down everything else
        fetchPolicy,
        onCompleted: (data)=>{
            parentOnCompleted?.(data);
        },
        onError: handleQueryError,
        __callerPackage__: "comments-data-manager"
    });
    const refetch = (0, $cozmU.useCallback)(async ({ onError: refetchOnError } = {})=>{
        try {
            return await queryResponse.refetch();
        } catch (error) {
            applyQueryErrorHandling(error, refetchOnError ?? parentOnError);
        }
    }, [
        queryResponse,
        applyQueryErrorHandling,
        parentOnError
    ]);
    const addCommentInCache = (0, $cozmU.useCallback)(({ newComment: newComment, onError: onError, onCacheMiss: onCacheMiss })=>{
        // If the new comment is a root comment, we need to add it to the root comments list and
        // update the main query's cache and totalCount. If it's a reply, we need to add it to its
        // parent comments's replies list in the cache - but we still  update the whole main query
        // (vs. just update the parent comment itself via a fragment update) because we need to
        // update the main query's totalCount in the cache to keep everything in sync.
        try {
            // Read the (root level) query from the cache
            let dataProxy = null;
            try {
                dataProxy = (0, $l1uFv.readQueryInterop)({
                    query: $bd3b81debc212a33$export$a5752cd8da7feaeb,
                    variables: $bd3b81debc212a33$export$66fa4e722aa8c832(contentId),
                    __callerPackage__: "comments-data-manager"
                });
            } catch (e) {
                // If cache miss, readQuery throws an error, which we ignore if comment is optimisticResponse.
                // Otherwise rethrow to invoke `onCacheMiss`.
                if ((0, $6mKj3.expValEquals)('confluence_fe_handle_use_all_comments_cache_miss', 'isEnabled', true)) {
                    if (newComment?.id !== (0, $kgNLQ.OPTIMISTIC_SAVE_COMMENT_ID)) onCacheMiss?.(new Error(`Cache miss when adding comment with ID ${newComment?.id} to cache: ${e}`));
                    return;
                }
                throw e;
            }
            // Make a shallow copy that's not readonly if there are nodes (which are readonly),
            // otherwise use an empty array
            const nodes = dataProxy?.comments?.nodes ? [
                ...dataProxy.comments.nodes
            ] : [];
            const cachedRootComments = nodes.filter((comment)=>!!comment);
            const totalCount = dataProxy?.comments?.totalCount || 0;
            const { updatedRootComments: updatedRootComments, updatedTotalCount: updatedTotalCount, error: error } = $bd3b81debc212a33$var$addCommentToCache({
                cachedRootComments: cachedRootComments,
                newComment: newComment,
                totalCount: totalCount
            });
            if (error) {
                onError?.(error);
                return;
            }
            (0, $fEmGS.writeQueryInterop)({
                query: $bd3b81debc212a33$export$a5752cd8da7feaeb,
                variables: $bd3b81debc212a33$export$66fa4e722aa8c832(contentId),
                data: {
                    comments: {
                        nodes: updatedRootComments,
                        totalCount: updatedTotalCount,
                        __typename: 'PaginatedCommentList'
                    }
                },
                __callerPackage__: "comments-data-manager"
            });
        } catch (err) {
            onError?.(new Error(`An error occurred when adding new comment to cache with ID ${newComment?.id}: ${err}`));
        }
    }, [
        contentId
    ]);
    const deleteCommentInCache = (0, $cozmU.useCallback)(({ commentId: commentId, onError: onError, onCacheMiss: onCacheMiss })=>{
        // First, we try to find the comment to determine if it's a root comment or a reply.  If it's a
        // root comment, we need to remove it from the root comments list and update the main query's
        // cache and totalCount. If it's a reply, we need to update its parent comments's replies list
        // in the cache - but we still  update the whole main query (vs. just update the parent comment
        // itself via a fragment update) because we need to update the main query's totalCount in the
        // cache to keep everything in sync.
        try {
            // Read the (root level) query from the cache
            let dataProxy = null;
            try {
                dataProxy = (0, $l1uFv.readQueryInterop)({
                    query: $bd3b81debc212a33$export$a5752cd8da7feaeb,
                    variables: $bd3b81debc212a33$export$66fa4e722aa8c832(contentId),
                    __callerPackage__: "comments-data-manager"
                });
            } catch (e) {
                if ((0, $6mKj3.expValEquals)('confluence_fe_handle_use_all_comments_cache_miss', 'isEnabled', true)) {
                    onCacheMiss?.(new Error(`Cache miss when deleting comment with ID ${commentId} from cache: ${e}`));
                    return false;
                }
                throw e;
            }
            // Make a shallow copy that's not readonly if there are nodes (which are readonly),
            // otherwise use an empty array
            const nodes = dataProxy?.comments?.nodes ? [
                ...dataProxy.comments.nodes
            ] : [];
            const cachedRootComments = nodes.filter((comment)=>!!comment);
            const totalCount = dataProxy?.comments?.totalCount || 0;
            const { updatedRootComments: updatedRootComments, updatedTotalCount: updatedTotalCount, error: error } = $bd3b81debc212a33$var$removeCommentFromCache({
                cachedRootComments: cachedRootComments,
                commentId: commentId,
                totalCount: totalCount
            });
            if (error) {
                onError?.(error);
                return false;
            }
            (0, $fEmGS.writeQueryInterop)({
                query: $bd3b81debc212a33$export$a5752cd8da7feaeb,
                variables: $bd3b81debc212a33$export$66fa4e722aa8c832(contentId),
                data: {
                    comments: {
                        nodes: updatedRootComments,
                        totalCount: updatedTotalCount,
                        __typename: 'PaginatedCommentList'
                    }
                },
                __callerPackage__: "comments-data-manager"
            });
            return true;
        } catch (err) {
            onError?.(new Error(`An error occurred when deleting cached comment with ID ${commentId}: ${err}`));
            return false;
        }
    }, [
        contentId
    ]);
    return {
        loading: queryResponse.loading,
        error: queryResponse.error,
        refetch: refetch,
        data: queryResponse.data,
        addCommentInCache: addCommentInCache,
        deleteCommentInCache: deleteCommentInCache
    };
};
const $bd3b81debc212a33$export$713a041e7ad7d7c4 = (contentId)=>{
    const dataProxy = (0, $l1uFv.readQueryInterop)({
        query: $bd3b81debc212a33$export$a5752cd8da7feaeb,
        variables: $bd3b81debc212a33$export$66fa4e722aa8c832(contentId),
        __callerPackage__: "comments-data-manager"
    });
    return dataProxy;
};
module.exports["MAX_COMMENTS_TO_RETURN"] = $bd3b81debc212a33$export$ef1591875b2a95ef;
module.exports["allContentStatuses"] = $bd3b81debc212a33$export$a1c5d5765ca44631;
module.exports["useAllCommentsData"] = $bd3b81debc212a33$export$19f817fe57f17368;
module.exports["getCommentsDataFromCache"] = $bd3b81debc212a33$export$713a041e7ad7d7c4;

});

parcelRegister("1Pttz", function(module, exports) {
/**
 * @generated SignedSource<<88a71c42d0cb01ab5e7d98601a8ad2dc>>
 * @relayHash e661073d22fa388ab2cfa6921674c35d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a72eb2929d0b453a77d38c0daac00993d0e7ed83ff549852056b0cf9f11bcde6
const $e5d3dc3314ebdbc2$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v3 = {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v7 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v8 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v9 = {
        "kind": "ScalarField",
        "name": "type"
    }, v10 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v11 = {
        "kind": "LinkedField",
        "name": "contributors",
        "plural": true,
        "selections": [
            v5 /*: any*/ ,
            v6 /*: any*/ ,
            v8 /*: any*/ ,
            v10 /*: any*/ 
        ]
    }, v12 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v13 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v12 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v14 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v15 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v12 /*: any*/ 
    }, v16 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v17 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "editui"
            },
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v18 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v19 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v20 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v21 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v22 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            v9 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "commentResolveProperties",
                        "plural": false,
                        "selections": [
                            v18 /*: any*/ ,
                            v19 /*: any*/ ,
                            v20 /*: any*/ ,
                            v21 /*: any*/ 
                        ]
                    }
                ],
                "type": "FooterComment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "inlineMarkerRef"
                    },
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "inlineResolveProperties",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isDangling"
                            },
                            v18 /*: any*/ ,
                            v19 /*: any*/ ,
                            v20 /*: any*/ ,
                            v21 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "inlineText"
                    }
                ],
                "type": "InlineComment"
            }
        ]
    }, v23 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v24 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v25 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            v3 /*: any*/ 
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    v4 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    }
                ]
            }
        ]
    }, v26 = {
        "kind": "ScalarField",
        "name": "number"
    }, v27 = {
        "kind": "ScalarField",
        "name": "when"
    }, v28 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentStatus",
                    "variableName": "contentStatus"
                },
                {
                    "kind": "Literal",
                    "name": "depth",
                    "value": "ROOT"
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                },
                v3 /*: any*/ 
            ],
            "concreteType": "PaginatedCommentList",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ 
                            ]
                        },
                        v11 /*: any*/ ,
                        v13 /*: any*/ ,
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "container",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ 
                            ]
                        },
                        v14 /*: any*/ ,
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        v17 /*: any*/ ,
                        v22 /*: any*/ ,
                        v23 /*: any*/ ,
                        v24 /*: any*/ ,
                        v25 /*: any*/ ,
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "replies",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v11 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                v25 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        },
                                        v26 /*: any*/ ,
                                        v27 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "friendlyWhen"
                                },
                                v26 /*: any*/ ,
                                v27 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "totalCount"
                },
                v5 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useAllCommentsDataQuery",
            "selections": v28 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useAllCommentsDataQuery",
            "selections": v28 /*: any*/ 
        },
        "params": {
            "cacheID": "e661073d22fa388ab2cfa6921674c35d",
            "id": "a72eb2929d0b453a77d38c0daac00993d0e7ed83ff549852056b0cf9f11bcde6",
            "metadata": {},
            "name": "useAllCommentsDataQuery",
            "operationKind": "query",
            "text": "query useAllCommentsDataQuery($pageId:ID!,$contentStatus:[GraphQLContentStatus],$first:Long!){comments(pageId:$pageId,contentStatus:$contentStatus,depth:ROOT,first:$first){nodes{id,author{__typename,displayName,permissionType,...on KnownUser{accountId,permissionType},profilePicture{path},type},contributors{__typename,displayName,profilePicture{path},...on KnownUser{accountId}},body(representation:ATLAS_DOC_FORMAT){value},container{id},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},replies{id,author{__typename,displayName,permissionType,...on KnownUser{accountId},profilePicture{path}},contributors{__typename,displayName,profilePicture{path},...on KnownUser{accountId}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},version{by{__typename,displayName},number,when}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,when}},totalCount,__typename}}"
        }
    };
}();
$e5d3dc3314ebdbc2$var$node.hash = "776a014f361baa317c627109df7aaaa3";
var $e5d3dc3314ebdbc2$export$2e2bcd8739ae039 = $e5d3dc3314ebdbc2$var$node;
module.exports["default"] = $e5d3dc3314ebdbc2$export$2e2bcd8739ae039;

});

parcelRegister("kDhla", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $9a24de4c41696be8$export$d4c72bab9d6cc13a = {
    fullPageEditorPresetAPI: undefined
};
const $9a24de4c41696be8$export$e324594224ef24da = {
    setEditorApi: (fullPageEditorPresetAPI)=>({ setState: setState })=>{
            setState({
                fullPageEditorPresetAPI: fullPageEditorPresetAPI
            });
        },
    resetEditorApi: ()=>({ setState: setState })=>{
            setState($9a24de4c41696be8$export$d4c72bab9d6cc13a);
        }
};
const $9a24de4c41696be8$var$FullPageEditorApiStore = (0, $8s9DV.createStore)({
    initialState: $9a24de4c41696be8$export$d4c72bab9d6cc13a,
    actions: $9a24de4c41696be8$export$e324594224ef24da,
    name: 'FullPageEditorApiStore'
});
const $9a24de4c41696be8$export$dc2b462ca736d2cc = (0, $kBr4q.createHook)($9a24de4c41696be8$var$FullPageEditorApiStore);
const $9a24de4c41696be8$export$6e619048e155ac67 = (0, $kBr4q.createActionsHook)($9a24de4c41696be8$var$FullPageEditorApiStore);
const $9a24de4c41696be8$export$4875e84e17c56c5c = (0, $kBr4q.createStateHook)($9a24de4c41696be8$var$FullPageEditorApiStore);
module.exports["useFullPageEditorApi"] = $9a24de4c41696be8$export$dc2b462ca736d2cc;
module.exports["useFullPageEditorApiActions"] = $9a24de4c41696be8$export$6e619048e155ac67;
module.exports["useFullPageEditorApiState"] = $9a24de4c41696be8$export$4875e84e17c56c5c;

});

parcelRegister("3ejfs", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $d1e9edb9f1563526$export$454b2229580969d0 = (0, $kSwu1.defineMessages)({
    resolvedByInfoText: {
        id: "comments-util.resolved.by.info.text",
        defaultMessage: "Resolved by {username} {friendlyDate}"
    },
    reopenedByTooltipTextCommentsPanel: {
        id: "comments-util.reopened.by.tooltip.text.comments.panel",
        defaultMessage: "Added {createdAtNonLocalized}, reopened by {username}"
    },
    createdTimestamp: {
        id: "comments-util.timestamp.created",
        defaultMessage: "created {timestamp}"
    },
    resolvedDateInfoText: {
        id: "comments-util.resolved.date.info.text",
        defaultMessage: "Resolved {friendlyDate}"
    },
    reopenedDateInfoText: {
        id: "comments-util.reopened.date.info.text",
        defaultMessage: "Reopened {friendlyDate}"
    },
    generalCommentTooltip: {
        id: "comments-util.view.tooltip.general.comment",
        defaultMessage: "General comment"
    },
    anonymous: {
        id: "comments-util.display.name.anonymous",
        defaultMessage: "Anonymous"
    },
    editedBy: {
        id: "comments-util.edited.by",
        defaultMessage: "Edited by {username} {at}"
    },
    edited: {
        id: "comments-util.edited",
        defaultMessage: "Edited"
    },
    resolvedByTooltipTextCommentsPanel: {
        id: "comments-util.resolved.by.tooltip.text.comments.panel",
        defaultMessage: "By {username}"
    }
});
module.exports["commentsi18n"] = $d1e9edb9f1563526$export$454b2229580969d0;

});

parcelRegister("jvYFk", function(module, exports) {
var $d9aaea339f75cad2$export$328a8baf694e5d32 = /*#__PURE__*/ function(PanelName) {
    PanelName["CommentsPanel"] = "commentsPanel";
    PanelName["DetailsPanel"] = "detailsPanel";
    PanelName["AgentReceiptPanel"] = "agentReceiptPanel";
    PanelName["WorkflowsPanel"] = "workflowsPanel";
    PanelName["SpaceSuggestionReviewPanel"] = "space-suggestion-review-panel";
    PanelName["SuggestionsPanel"] = "suggestionsPanel";
    PanelName["AutomationsPanel"] = "automationsPanel";
    return PanelName;
}({});
const $d9aaea339f75cad2$var$MIGRATED_PANEL_IDS = new Set([
    "commentsPanel",
    "detailsPanel",
    "agentReceiptPanel",
    "space-suggestion-review-panel",
    "suggestionsPanel",
    "automationsPanel",
    'jiraWorkItemsPanel'
]);
function $d9aaea339f75cad2$export$a9799883e6d611cc(panelId) {
    return !!panelId && $d9aaea339f75cad2$var$MIGRATED_PANEL_IDS.has(panelId);
}
module.exports["PanelName"] = $d9aaea339f75cad2$export$328a8baf694e5d32;
module.exports["isMigratedToPanelSystem"] = $d9aaea339f75cad2$export$a9799883e6d611cc;

});

parcelRegister("6hmtW", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");


var $83FW4 = parcelRequire("83FW4");


var $jil6p = parcelRequire("jil6p");

const $99a81cd20c880202$export$1cacdacf9568d373 = ()=>{
    const context = (0, $cozmU.useContext)((0, $83FW4.CommentContext));
    const memoizedCommentService = (0, $cozmU.useMemo)(()=>new (0, $jil6p.ContentTypesCommentService)(), []);
    if (!context) return {
        commentService: (0, $6mKj3.expValEquals)('cc_fe_performance_page_comments_stability', 'cohort', 'experiment') ? memoizedCommentService : new (0, $jil6p.ContentTypesCommentService)()
    };
    return context;
};
module.exports["useCommentService"] = $99a81cd20c880202$export$1cacdacf9568d373;

});

parcelRegister("83FW4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jil6p = parcelRequire("jil6p");

const $c63b34a18b0f8af5$export$f70cbd0dcaa225fc = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $c63b34a18b0f8af5$export$71e478688b05b68d = ({ children: children })=>{
    const commentService = (0, $cozmU.useRef)(new (0, $jil6p.ContentTypesCommentService)()).current;
    (0, $cozmU.useEffect)(()=>{
        // Cleanup on unmount
        return ()=>{
            commentService.dispose();
        };
    }, [
        commentService
    ]);
    const handleSelectThread = (0, $cozmU.useCallback)((threadId)=>{
        commentService.selectCommentThread(threadId);
    }, [
        commentService
    ]);
    (0, $cozmU.useEffect)(()=>{
        commentService.registerSelectThreadHandler(handleSelectThread);
        return ()=>{
            // un-set the handler on component unmount
            commentService.registerSelectThreadHandler(undefined);
        };
    }, [
        commentService,
        handleSelectThread
    ]);
    const contextValue = (0, $cozmU.useMemo)(()=>({
            commentService: commentService
        }), [
        commentService
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c63b34a18b0f8af5$export$f70cbd0dcaa225fc.Provider, {
        value: contextValue
    }, children);
};
module.exports["CommentContext"] = $c63b34a18b0f8af5$export$f70cbd0dcaa225fc;
module.exports["CommentProvider"] = $c63b34a18b0f8af5$export$71e478688b05b68d;

});

parcelRegister("jil6p", function(module, exports) {
class $569106325e18c3c1$export$6c0a8b19f951b1bc {
    dispose() {
        this.selectThreadHandler = undefined;
        this.reopenResolvedCommentHandler = undefined;
        this.showPanelHandler = undefined;
        this.selectCommentThreadHandler = undefined;
        this.hidePanelHandler = undefined;
        this.onCreateCommentHandler = undefined;
        this.onDeleteCommentHandler = undefined;
        this.triggerCommentPanelRefreshHandler = undefined;
        this.onUpdateCommentHandler = undefined;
        this.onResolveCommentHandler = undefined;
        this.onUpdateReactionHandler = undefined;
        this.onUpdateUnreadCommentsHandler = undefined;
        this.triggerReadStatusCommentHandler = undefined;
        this.syncActiveCommentMarkersHandler = undefined;
    }
    /**
   * Register a handler for thread selection events
   */ registerSelectThreadHandler(handler) {
        this.selectThreadHandler = handler;
    }
    /**
   * Handle thread selection events
   */ handleSelectThread(threadId) {
        this.selectThreadHandler?.(threadId);
    }
    /**
   * Register a handler for show panel events
   */ registerShowPanelHandler(handler) {
        this.showPanelHandler = handler;
    }
    /**
   * Show the comments panel
   */ showPanel(threadId) {
        this.showPanelHandler?.(threadId);
    }
    /**
   * Register a handler for hide panel events
   */ registerHidePanelHandler(handler) {
        this.hidePanelHandler = handler;
    }
    /**
   * Hide the comments panel
   */ hidePanel() {
        this.hidePanelHandler?.();
    }
    /**
   * Register a handler for select comment thread events
   */ registerSelectCommentThreadHandler(handler) {
        this.selectCommentThreadHandler = handler;
    }
    /**
   * Select a specific comment thread
   */ selectCommentThread(threadId) {
        this.selectCommentThreadHandler?.(threadId);
    }
    /**
   * This is called in databases to register the callback confluence FE
   * will call after a resolved comment has been reopened
   */ registerOnReopenResolvedComment(callback) {
        this.reopenResolvedCommentHandler = callback;
    }
    /**
   * This will be called in confluence FE after we have successfully
   * reopened a resolved comment. This allows databases to re-fetch and re-render
   * the comment
   */ onReopenResolvedComment(commentIds) {
        this.reopenResolvedCommentHandler?.(commentIds);
    }
    /**
   * Register a handler for create comment events (called by content types).
   * Canvas registers this so it can be notified when a new top-level comment
   * is created inside the Confluence comments panel.
   */ registerOnCreateComment(callback) {
        this.onCreateCommentHandler = callback;
    }
    /**
   * Handle a create comment event (fired by CFE after a new comment is saved
   * in the comments panel).  This allows Canvas to sync the new comment to
   * other collaborators.
   */ onCreateComment(threadKey) {
        this.onCreateCommentHandler?.(threadKey);
    }
    /**
   * Register a handler for delete comment events (called by content types)
   */ registerOnDeleteComment(callback) {
        this.onDeleteCommentHandler = callback;
    }
    /**
   * Handle a delete comment event (fired by CF)
   */ onDeleteComment(threadKey) {
        this.onDeleteCommentHandler?.(threadKey);
    }
    /**
   * Register a handler for update comment events (called by content types)
   */ registerOnUpdateComment(callback) {
        this.onUpdateCommentHandler = callback;
    }
    /**
   * Handle an update comment event (fired by CF)
   * @param threadKey - The thread key of the comment
   * @param actionType - Optional action type: 'reply' for new replies, 'edit' for comment edits
   */ onUpdateComment(threadKey, actionType) {
        this.onUpdateCommentHandler?.(threadKey, actionType);
    }
    /**
   * Register a handler for trigger comment panel refresh events (called by content types)
   */ registerTriggerCommentPanelRefresh(handler) {
        this.triggerCommentPanelRefreshHandler = handler;
        // If a refresh was requested while no handler was registered, trigger it now
        // so the newly mounted view refetches immediately.
        if (handler && this.hasPendingCommentPanelRefresh) {
            this.hasPendingCommentPanelRefresh = false;
            handler();
        }
    }
    /**
   * Register a handler for resolve comment events (called by content types)
   */ registerOnResolveComment(callback) {
        this.onResolveCommentHandler = callback;
    }
    /**
   * Handle a delete comment event (fired by CF)
   */ onResolveComment(threadKey) {
        this.onResolveCommentHandler?.(threadKey);
    }
    /**
   * Trigger a refresh of the comment panel
   */ async triggerCommentPanelRefresh() {
        if (this.triggerCommentPanelRefreshHandler) {
            await this.triggerCommentPanelRefreshHandler();
            return;
        }
        // No handler registered means the panel is likely closed/unmounted.
        // Remember to refresh on next registration.
        this.hasPendingCommentPanelRefresh = true;
    }
    /**
   * Register a handler for update reaction events (called by content types)
   * @param callback - A callback function that will be called when a reaction is updated
   */ registerOnUpdateReaction(callback) {
        this.onUpdateReactionHandler = callback;
    }
    /**
   * Handle an update reaction event (fired by CF)
   * @param threadKey - The thread key of the comment
   * @param emojiId - The emoji ID of the reaction
   * @param actionType - The action type of the reaction
   * @returns
   */ onUpdateReaction(threadKey, emojiId, actionType) {
        return this.onUpdateReactionHandler?.(threadKey, emojiId, actionType);
    }
    /**
   * Register a handler for update unread comments events (called by content types)
   * @param handler - A callback function that will be called by content types (whiteboards, databases) to register a handler that CFE can use
   * to notify about the comment being read (e.g. update the unread comments status).
   */ registerOnUpdateUnreadComments(handler) {
        this.onUpdateUnreadCommentsHandler = handler;
    }
    /**
   * Handle an update unread comments event (fired by CF)
   * CFE -> Content Types (whiteboards, databases)
   * @param commentIds - The IDs of the comments that have been read
   * @param read - Whether the comments have been read or unread
   * @see triggerReadStatusComment for the counterpart method
   */ onUpdateUnreadComments(commentIds, read = false) {
        return this.onUpdateUnreadCommentsHandler?.(commentIds, read);
    }
    /**
   * Register a handler for trigger read status comment events (called by CF)
   * @param handler - A callback function used by CFE to register a handler that can be used when content types notifies CFE about a comment being read.
   */ registerTriggerReadStatusComment(handler) {
        this.triggerReadStatusCommentHandler = handler;
    }
    /**
   * Triggers an update of the unread comments status (fired by content types)
   * Content Types (whiteboards, databases) -> CFE
   * @param commentIds - The IDs of the comments that have been read
   * @param read - Whether the comments have been read or unread.
   * @see onUpdateUnreadComments for the counterpart method
   */ triggerReadStatusComment(commentIds, read = false) {
        return this.triggerReadStatusCommentHandler?.(commentIds, read);
    }
    /**
   * Register a handler for active comment marker updates (called by CFE)
   * @param handler - Receives the `inlineMarkerRef` of each inline comment in the
   * content, in display order
   * @see syncActiveCommentMarkers for the counterpart method
   */ registerSyncActiveCommentMarkers(handler) {
        this.syncActiveCommentMarkersHandler = handler;
    }
    /**
   * Replaces the active comment markers (fired by content types) Content Types -> CFE
   * @param markerRefs - The `inlineMarkerRef` of each inline comment in the content, in
   * display order
   * @see registerSyncActiveCommentMarkers for the counterpart method
   */ syncActiveCommentMarkers(markerRefs) {
        this.syncActiveCommentMarkersHandler?.(markerRefs);
    }
    constructor(){
        this.selectThreadHandler = void 0;
        this.reopenResolvedCommentHandler = void 0;
        this.showPanelHandler = void 0;
        this.hidePanelHandler = void 0;
        this.selectCommentThreadHandler = void 0;
        this.onDeleteCommentHandler = void 0;
        this.triggerCommentPanelRefreshHandler = void 0;
        // When a refresh is requested while the comments panel is unmounted (no handler
        // registered), we set this flag so the next registration triggers a refetch.
        this.hasPendingCommentPanelRefresh = false;
        this.onCreateCommentHandler = void 0;
        this.onUpdateCommentHandler = void 0;
        this.onResolveCommentHandler = void 0;
        this.onUpdateReactionHandler = void 0;
        this.onUpdateUnreadCommentsHandler = void 0;
        this.triggerReadStatusCommentHandler = void 0;
        this.syncActiveCommentMarkersHandler = void 0;
        this.selectThreadHandler = undefined;
        this.reopenResolvedCommentHandler = undefined;
        this.showPanelHandler = undefined;
        this.selectCommentThreadHandler = undefined;
        this.hidePanelHandler = undefined;
        this.onCreateCommentHandler = undefined;
        this.onDeleteCommentHandler = undefined;
        this.onUpdateCommentHandler = undefined;
        this.triggerCommentPanelRefreshHandler = undefined;
        this.onResolveCommentHandler = undefined;
        this.onUpdateReactionHandler = undefined;
        this.hasPendingCommentPanelRefresh = false;
        this.onUpdateUnreadCommentsHandler = undefined;
        this.triggerReadStatusCommentHandler = undefined;
        this.syncActiveCommentMarkersHandler = undefined;
    }
}
module.exports["ContentTypesCommentService"] = $569106325e18c3c1$export$6c0a8b19f951b1bc;

});

parcelRegister("6faGq", function(module, exports) {

var $3ejfs = parcelRequire("3ejfs");


var $3iaSn = parcelRequire("3iaSn");

const $fd14f0f09d6b2a27$export$48c62524de3612b3 = (dateString)=>{
    if (!dateString) return new Date(0); // Return earliest possible date if missing
    // Ensure UTC timezone. Some createdAt values are missing the UTC timezone identifier, and some have it
    const normalizedDate = dateString.endsWith('Z') ? dateString : `${dateString}Z`;
    // Try to parse the date, return earliest date if invalid
    const parsed = new Date(normalizedDate);
    return isNaN(parsed.getTime()) ? new Date(0) : parsed;
};

const $fd14f0f09d6b2a27$export$63880caa66d80fb9 = ({ intl: intl, dateString: dateString, commentStatus: commentStatus = (0, $3iaSn.CommentStatus).OPEN, resolveProperties: resolveProperties, isReply: isReply = false })=>{
    if (!dateString) return '';
    // Get formatted timestamp
    let timestamp;
    try {
        const { formatTimeAgo: formatTimeAgo } = (parcelRequire("1JmNR"));
        timestamp = formatTimeAgo(intl, $fd14f0f09d6b2a27$export$48c62524de3612b3(dateString));
    } catch (error) {
        // Fallback to a simple date format if formatTimeAgo is not available
        const date = $fd14f0f09d6b2a27$export$48c62524de3612b3(dateString);
        timestamp = date.toLocaleDateString(intl.locale);
    }
    // For replies, just return the timestamp without comment status
    if (isReply) return timestamp;
    // Format based on comment status
    switch(commentStatus){
        case (0, $3iaSn.CommentStatus).RESOLVED:
            return intl.formatMessage((0, $3ejfs.commentsi18n).resolvedByInfoText, {
                friendlyDate: timestamp,
                username: resolveProperties?.resolvedUser
            });
        case (0, $3iaSn.CommentStatus).REOPENED:
            return intl.formatMessage((0, $3ejfs.commentsi18n).reopenedByTooltipTextCommentsPanel, {
                createdAtNonLocalized: timestamp,
                username: resolveProperties?.resolvedUser
            });
        case (0, $3iaSn.CommentStatus).OPEN:
        default:
            return intl.formatMessage((0, $3ejfs.commentsi18n).createdTimestamp, {
                timestamp: timestamp
            });
    }
};
module.exports["getValidDate"] = $fd14f0f09d6b2a27$export$48c62524de3612b3;
module.exports["formatTimestampForAriaLabel"] = $fd14f0f09d6b2a27$export$63880caa66d80fb9;

});

parcelRegister("3iaSn", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

var $c6395b80aeb36ecd$export$4f1057b172870e9c = /*#__PURE__*/ function(CommentStatus) {
    CommentStatus["OPEN"] = "OPEN";
    CommentStatus["RESOLVED"] = "RESOLVED";
    CommentStatus["REOPENED"] = "REOPENED";
    return CommentStatus;
}({});
const $c6395b80aeb36ecd$export$eac30d30628b994a = ({ resolveProperties: resolveProperties })=>{
    return (0, $cozmU.useMemo)(()=>{
        // If no resolve properties, the comment is open
        if (!resolveProperties) return "OPEN";
        // If resolved is false, the comment is reopened
        if (!resolveProperties.resolved) return "REOPENED";
        return "RESOLVED";
    }, [
        resolveProperties
    ]);
};
module.exports["CommentStatus"] = $c6395b80aeb36ecd$export$4f1057b172870e9c;
module.exports["useGetCommentStatus"] = $c6395b80aeb36ecd$export$eac30d30628b994a;

});

parcelRegister("1JmNR", function(module, exports) {
$parcel$export(module.exports, "formatTimeAgo", () => (parcelRequire("1YXTQ")).formatTimeAgo);
$parcel$export(module.exports, "TimeAgo", () => (parcelRequire("1YXTQ")).TimeAgo);
$parcel$export(module.exports, "StaticTimeAgo", () => (parcelRequire("1YXTQ")).StaticTimeAgo);
$parcel$export(module.exports, "formatRelativeTimeAgo", () => (parcelRequire("6gnMn")).formatRelativeTimeAgo);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $1YXTQ = parcelRequire("1YXTQ");


var $6gnMn = parcelRequire("6gnMn");


});

parcelRegister("1YXTQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $clUfR = parcelRequire("clUfR");


var $7GLtr = parcelRequire("7GLtr");


var $awd1Q = parcelRequire("awd1Q");


var $bQm3c = parcelRequire("bQm3c");

'use no memo';
const $6f4eb0725770e50a$var$i18n = (0, $kSwu1.defineMessages)({
    now: {
        id: "time-ago.time.now",
        defaultMessage: "now"
    },
    lessThanAMinute: {
        id: "time-ago.time.lessThanAMinute",
        defaultMessage: "less than a minute ago"
    },
    onPreposition: {
        id: "time-ago.prepositions.on",
        defaultMessage: "on {datetime}"
    }
});
const $6f4eb0725770e50a$var$gradation = [
    // Less than 5 seconds -> "now"
    {
        format: ({ intl: intl })=>intl.formatMessage($6f4eb0725770e50a$var$i18n.now)
    },
    // Between 5-45 seconds -> "less than a minute ago"
    {
        threshold: 5,
        format: ({ intl: intl })=>intl.formatMessage($6f4eb0725770e50a$var$i18n.lessThanAMinute)
    },
    // Between 45 seconds-2.5 minutes -> "X minutes ago"
    {
        threshold: 45,
        factor: 60,
        unit: 'minute'
    },
    // Between 2.5-45 minutes -> "X minutes ago" (rounded to 5)
    {
        threshold: 150,
        factor: 60,
        granularity: 5,
        unit: 'minute'
    },
    // Between 45 minutes-24 hours -> "X hours ago"
    {
        threshold: 2700,
        factor: 3600,
        unit: 'hour'
    },
    // After 24 hours -> "full date"
    {
        threshold: 86400,
        format: ({ intl: intl, date: date, locale: locale, usePrepositions: usePrepositions, dateFormatOptions: dateFormatOptions, timeZone: timeZone, tenantTimeZone: tenantTimeZone })=>{
            const datetime = date.toLocaleDateString(locale, {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                timeZone: (()=>{
                    // Prefer timeZone if provided, otherwise use tenantTimeZone, otherwise use browser timezone
                    const tz = timeZone || tenantTimeZone || (0, $clUfR.guessTimeZone)();
                    // Validate the timezone, use UTC as fallback for invalid values
                    return (0, $7GLtr.isValidTimeZone)(tz) ? tz : 'Etc/UTC';
                })(),
                ...dateFormatOptions
            });
            if (usePrepositions) return intl.formatMessage($6f4eb0725770e50a$var$i18n.onPreposition, {
                datetime: datetime
            });
            return datetime;
        }
    }
];
const $6f4eb0725770e50a$var$getGradationIndex = (seconds)=>{
    let i = $6f4eb0725770e50a$var$gradation.length - 1;
    while(i > 0 && seconds < ($6f4eb0725770e50a$var$gradation[i].threshold || seconds))i--;
    return i;
};
const $6f4eb0725770e50a$var$getSecondsSince = (date)=>(Date.now() - date.getTime()) / 1000;
const $6f4eb0725770e50a$export$78ae3e68d8c394bc = (intl, date, usePrepositions, dateFormatOptions, timeZone, tenantTimeZone)=>{
    const locale = (0, $awd1Q.getTranslation)().locale;
    const dateObject = new Date(date);
    const seconds = $6f4eb0725770e50a$var$getSecondsSince(dateObject);
    const i = $6f4eb0725770e50a$var$getGradationIndex(seconds);
    const customFormat = $6f4eb0725770e50a$var$gradation[i].format;
    if (customFormat) return customFormat({
        intl: intl,
        date: dateObject,
        locale: locale,
        usePrepositions: usePrepositions,
        dateFormatOptions: dateFormatOptions,
        timeZone: timeZone,
        tenantTimeZone: tenantTimeZone
    });
    const localeLanguage = new Intl.Locale(locale).language;
    const formatter = new Intl.RelativeTimeFormat(localeLanguage, {
        style: 'long',
        numeric: 'auto'
    });
    const granularity = $6f4eb0725770e50a$var$gradation[i].granularity || 1;
    const factor = $6f4eb0725770e50a$var$gradation[i].factor || 1;
    const value = -Math.round(seconds / factor / granularity) * granularity;
    const unit = $6f4eb0725770e50a$var$gradation[i].unit || 'second';
    return formatter.format(value, unit);
};
const $6f4eb0725770e50a$export$fc791eb9f9c39e49 = ({ date: date, usePrepositions: usePrepositions, dateFormatOptions: dateFormatOptions })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { timeZone: timeZone, tenantTimeZone: tenantTimeZone } = (0, $bQm3c.useSessionData)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        suppressHydrationWarning: true
    }, $6f4eb0725770e50a$export$78ae3e68d8c394bc(intl, date, usePrepositions, dateFormatOptions, timeZone, tenantTimeZone));
};
const $6f4eb0725770e50a$export$9e4a631e7281406a = ({ date: date, ...otherProps })=>{
    const [, setRenders] = (0, $cozmU.useState)(0);
    const dateObject = new Date(date);
    const seconds = $6f4eb0725770e50a$var$getSecondsSince(dateObject);
    const i = $6f4eb0725770e50a$var$getGradationIndex(seconds);
    (0, $cozmU.useEffect)(()=>{
        if (i != $6f4eb0725770e50a$var$gradation.length - 1) {
            const timeToNextGradation = ($6f4eb0725770e50a$var$gradation[i + 1].threshold || seconds) - seconds;
            const timeout = setTimeout(()=>{
                setRenders((x)=>x + 1);
            }, timeToNextGradation * 1000);
            return ()=>clearTimeout(timeout);
        }
    }, [
        i,
        seconds
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f4eb0725770e50a$export$fc791eb9f9c39e49, {
        date: date,
        ...otherProps
    });
};
module.exports["formatTimeAgo"] = $6f4eb0725770e50a$export$78ae3e68d8c394bc;
module.exports["StaticTimeAgo"] = $6f4eb0725770e50a$export$fc791eb9f9c39e49;
module.exports["TimeAgo"] = $6f4eb0725770e50a$export$9e4a631e7281406a;

});

parcelRegister("clUfR", function(module, exports) {
const $dad8374cf8f904e8$export$c333b33f2586074c = ()=>{
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch  {
        return 'Etc/UTC';
    }
};
module.exports["guessTimeZone"] = $dad8374cf8f904e8$export$c333b33f2586074c;

});

parcelRegister("7GLtr", function(module, exports) {
const $0e3ee782c26ab488$export$c793e14020d7c7b = (timeZone)=>{
    try {
        Intl.DateTimeFormat(undefined, {
            timeZone: timeZone
        });
        return true;
    } catch  {
        return false;
    }
};
module.exports["isValidTimeZone"] = $0e3ee782c26ab488$export$c793e14020d7c7b;

});

parcelRegister("6gnMn", function(module, exports) {

var $jb2R2 = parcelRequire("jb2R2");

var $bg9GW = parcelRequire("bg9GW");

var $fNtG8 = parcelRequire("fNtG8");

var $jgqX6 = parcelRequire("jgqX6");

var $hnDzv = parcelRequire("hnDzv");


var $kSwu1 = parcelRequire("kSwu1");

const $926347e03f273aaa$var$i18n = (0, $kSwu1.defineMessages)({
    justNow: {
        id: "time-ago.relative.just-now",
        defaultMessage: "Just now"
    },
    minutesAgo: {
        id: "time-ago.relative.minutes-ago",
        defaultMessage: "{minuteCount} {minuteCount, plural, one {minute} other {minutes}} ago"
    },
    hoursAgo: {
        id: "time-ago.relative.hours-ago",
        defaultMessage: "{hourCount} {hourCount, plural, one {hour} other {hours}} ago"
    },
    daysAgo: {
        id: "time-ago.relative.days-ago",
        defaultMessage: "{dayCount} {dayCount, plural, one {day} other {days}} ago"
    },
    monthsAgo: {
        id: "time-ago.relative.months-ago",
        defaultMessage: "{monthCount} {monthCount, plural, one {month} other {months}} ago"
    },
    yearsAgo: {
        id: "time-ago.relative.years-ago",
        defaultMessage: "{yearCount} {yearCount, plural, one {year} other {years}} ago"
    }
});
const $926347e03f273aaa$export$b77ccb75f39eecf = (date, intl, now = new Date())=>{
    const dateObject = new Date(date);
    const minutesDiff = (0, $fNtG8.default)(now, dateObject);
    const hoursDiff = (0, $bg9GW.default)(now, dateObject);
    const daysDiff = (0, $jb2R2.default)(now, dateObject);
    const monthsDiff = (0, $jgqX6.default)(now, dateObject);
    const yearsDiff = (0, $hnDzv.default)(now, dateObject);
    if (minutesDiff < 1) return intl.formatMessage($926347e03f273aaa$var$i18n.justNow);
    if (minutesDiff < 60) return intl.formatMessage($926347e03f273aaa$var$i18n.minutesAgo, {
        minuteCount: minutesDiff
    });
    if (hoursDiff < 24) return intl.formatMessage($926347e03f273aaa$var$i18n.hoursAgo, {
        hourCount: hoursDiff
    });
    if (daysDiff < 31) return intl.formatMessage($926347e03f273aaa$var$i18n.daysAgo, {
        dayCount: daysDiff
    });
    if (monthsDiff < 12) return intl.formatMessage($926347e03f273aaa$var$i18n.monthsAgo, {
        monthCount: monthsDiff
    });
    return intl.formatMessage($926347e03f273aaa$var$i18n.yearsAgo, {
        yearCount: yearsDiff
    });
};
module.exports["formatRelativeTimeAgo"] = $926347e03f273aaa$export$b77ccb75f39eecf;

});

parcelRegister("hnDzv", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca7347c324945db7$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $9wdry = parcelRequire("9wdry");


var $eYSi7 = parcelRequire("eYSi7");


var $3yGK6 = parcelRequire("3yGK6");

function $ca7347c324945db7$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $3yGK6.default)(2, arguments);
    var dateLeft = (0, $dkBOe.default)(dirtyDateLeft);
    var dateRight = (0, $dkBOe.default)(dirtyDateRight);
    var sign = (0, $eYSi7.default)(dateLeft, dateRight);
    var difference = Math.abs((0, $9wdry.default)(dateLeft, dateRight));
    // Set both dates to a valid leap year for accurate comparison when dealing
    // with leap days
    dateLeft.setFullYear(1584);
    dateRight.setFullYear(1584);
    // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastYearNotFull = (0, $eYSi7.default)(dateLeft, dateRight) === -sign;
    var result = sign * (difference - Number(isLastYearNotFull));
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});

parcelRegister("9wdry", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ee187ccd32d3646$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $6ee187ccd32d3646$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $3yGK6.default)(2, arguments);
    var dateLeft = (0, $dkBOe.default)(dirtyDateLeft);
    var dateRight = (0, $dkBOe.default)(dirtyDateRight);
    return dateLeft.getFullYear() - dateRight.getFullYear();
}

});

parcelRegister("i6UMJ", function(module, exports) {

var $9B4fQ = parcelRequire("9B4fQ");


var $422HI = parcelRequire("422HI");


var $6faGq = parcelRequire("6faGq");


var $3mVfX = parcelRequire("3mVfX");

var $6ed006a18ff2d87d$export$50c823aead020a09 = /*#__PURE__*/ function(LocationValue) {
    LocationValue["PANEL"] = "panel";
    LocationValue["FOOTER"] = "footer";
    LocationValue["STANDALONE"] = "standalone";
    return LocationValue;
}({});
const $6ed006a18ff2d87d$var$getCommentResolvedOrCreatedTime = (comment)=>{
    const commentLocation = comment.location;
    const resolvedTime = commentLocation?.inlineResolveProperties?.resolvedTime || commentLocation?.commentResolveProperties?.resolvedTime;
    return resolvedTime || (0, $6faGq.getValidDate)(comment.createdAtNonLocalized).getTime();
};
const $6ed006a18ff2d87d$export$d2935240a910e26e = (currentSort, commentThreads)=>{
    if (currentSort === (0, $3mVfX.SortValues).MOST_RECENT) return [
        ...commentThreads
    ].sort((a, b)=>$6ed006a18ff2d87d$var$getCommentResolvedOrCreatedTime(b) - $6ed006a18ff2d87d$var$getCommentResolvedOrCreatedTime(a));
    return commentThreads;
};
const $6ed006a18ff2d87d$export$47f9a121266175f = (annotations)=>annotations.map((annotation)=>annotation.threadKey);
const $6ed006a18ff2d87d$export$7119b2a60583b6dc = (marks = [])=>marks.map((mark)=>mark.attrs.id);
const $6ed006a18ff2d87d$export$b02d74cde949c060 = (commentA, commentB)=>(0, $6faGq.getValidDate)(commentA?.createdAtNonLocalized).getTime() - (0, $6faGq.getValidDate)(commentB?.createdAtNonLocalized).getTime();
const $6ed006a18ff2d87d$export$5425fcea1abfd6f7 = (error)=>{
    if (!error) // if falsy, consider it as NOT containing non-reactionsSummary errors
    return true;
    else if (error instanceof (0, $422HI.ApolloErrorInterop) || error instanceof (0, $9B4fQ.ApolloError)) {
        // TODO we will need to migrate to ApolloRelayInterops to get proper error type of ApolloErrorInterop instead of ApolloError
        // after migration, we can remove the instanceof ApolloError check here
        const hasOtherGqlErrors = error.graphQLErrors?.filter((e)=>!e.path?.includes('reactionsSummary'))?.length > 0;
        return !hasOtherGqlErrors && !error.networkError;
    } else // if truthy but not an ApolloErrorInterop, consider it as containing non-reactionsSummary errors
    return false;
};
module.exports["LocationValue"] = $6ed006a18ff2d87d$export$50c823aead020a09;
module.exports["getSortedCommentThreads"] = $6ed006a18ff2d87d$export$d2935240a910e26e;
module.exports["getAnnotationThreadKeys"] = $6ed006a18ff2d87d$export$47f9a121266175f;
module.exports["getMarkIds"] = $6ed006a18ff2d87d$export$7119b2a60583b6dc;
module.exports["getCommentsSortedOldestToNewest"] = $6ed006a18ff2d87d$export$b02d74cde949c060;
module.exports["onlyHasReactionsSummaryErrors"] = $6ed006a18ff2d87d$export$5425fcea1abfd6f7;

});

parcelRegister("en1dX", function(module, exports) {
var $88e03e673e36ecc4$export$6890652a1aff7d1c = /*#__PURE__*/ function(AnalyticsSource) {
    AnalyticsSource["COMMENTS_PANEL"] = "commentsPanel";
    AnalyticsSource["STANDALONE"] = "standalone";
    AnalyticsSource["PAGE_FOOTER"] = "pageFooter";
    return AnalyticsSource;
}({});
var $88e03e673e36ecc4$export$9c95d6e1614bad84 = /*#__PURE__*/ function(ActionName) {
    ActionName["REOPEN_COMMENT"] = "reopenComment";
    return ActionName;
}({});
var $88e03e673e36ecc4$export$ffa1150e6a48f9cd = /*#__PURE__*/ function(CommentType) {
    CommentType["INLINE"] = "inline";
    CommentType["GENERAL"] = "general";
    CommentType["PAGE"] = "page";
    return CommentType;
}({});
module.exports["AnalyticsSource"] = $88e03e673e36ecc4$export$6890652a1aff7d1c;
module.exports["ActionName"] = $88e03e673e36ecc4$export$9c95d6e1614bad84;
module.exports["CommentType"] = $88e03e673e36ecc4$export$ffa1150e6a48f9cd;

});

parcelRegister("9CnRS", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $90dae8a726ff859c$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    addNew: {
        id: "inline-comments-common.reactions.add.new",
        defaultMessage: "Add new"
    },
    invalidHighlight: {
        id: "inline-comments-common.error.invalid.highlight",
        defaultMessage: "We\u2019re having trouble adding your comment. Try highlighting more or less text."
    },
    replyCommentPlaceholder: {
        id: "inline-comments-common.reply-comment-placeholder",
        defaultMessage: "Reply"
    },
    staleContent: {
        id: "inline-comments-common.error.stale.content",
        defaultMessage: "Refresh to view the latest updates, and try adding your comment again."
    },
    viewNotPermitted: {
        id: "inline-comments-common.error.view.not.permitted",
        defaultMessage: "Your permission settings don\u2019t allow you to view this comment. Check with your administrator if you need this ability."
    },
    createNotPermitted: {
        id: "inline-comments-common.error.create.not.permitted",
        defaultMessage: "You can\u2019t create comments in this space. A space admin can modify your permissions."
    },
    inlineMarkerRefAlreadyExists: {
        id: "inline-comments-common.error.inline.marker.ref.already.exists",
        defaultMessage: "We failed to display your comment. Please refresh to see it."
    },
    unableToApplyAnnotation: {
        id: "inline-comments-common.error.unable.to.apply.annotation",
        defaultMessage: "Something went wrong when adding this comment to the document. Refresh to see your comment."
    },
    unableToApplyDanglingCommentAnnotation: {
        id: "inline-comments-common.error.unable.to.apply.dangling.comment.annotation",
        defaultMessage: "Your comment was created but could not be added to the document because the text has been changed or removed."
    },
    contentHasBeenRemoved: {
        id: "inline-comments-common.error.create.content.removed",
        defaultMessage: "The text you highlighted has already been deleted by someone else. Refresh to view the latest updates."
    },
    cannotHighlightContent: {
        id: "inline-comments-common.error.cannot.highlight.content",
        defaultMessage: "An error occurred when commenting on the highlighted content. The page may be outdated. Refresh to view the latest updates."
    },
    viewOrModifyNotPermitted: {
        id: "inline-comments-common.error.view.or.modify.not.permitted",
        defaultMessage: "You can\u2019t view or modify comments in this space. A space admin can modify your permissions."
    },
    deleteWithRepliesNotAllowed: {
        id: "inline-comments-common.error.delete.with.replies",
        defaultMessage: "You can\u2019t delete this comment anymore because someone else replied to it. Refresh to see all replies."
    },
    commentAlreadyDeleted: {
        id: "inline-comments-common.error.comment.already.deleted",
        defaultMessage: "This comment has been deleted by someone else. Refresh to view the latest updates."
    },
    commentAlreadyDeletedTitle: {
        id: "inline-comments-common.error.comment.already.deleted.title",
        defaultMessage: "Unable to delete comment"
    },
    noCommentsFoundForGivenMarkerRef: {
        id: "inline-comments-common.error.no.comments.found.for.given.marker.ref",
        defaultMessage: "This comment couldn\u2019t be found. Refresh to view the latest updates."
    },
    resolveNotPermitted: {
        id: "inline-comments-common.error.resolve.not.permitted",
        defaultMessage: "You can\u2019t resolve comments in this space. A space admin can modify your permissions."
    },
    resolveError: {
        id: "inline-comments-common.error.resolve.error",
        defaultMessage: "We failed to resolve your comment due to an error. Try resolving the comment again."
    },
    resolveErrorTitle: {
        id: "inline-comments-common.error.resolve.error.title",
        defaultMessage: "Failed to resolve comment"
    },
    deleteError: {
        id: "inline-comments-common.error.delete.error",
        defaultMessage: "We failed to delete your comment due to an error. Try deleting the comment again."
    },
    deleteErrorTitle: {
        id: "inline-comments-common.error.delete.error.title",
        defaultMessage: "Failed to delete comment"
    },
    editNotPermitted: {
        id: "inline-comments-common.error.edit.not.permitted",
        defaultMessage: "You can\u2019t edit comments in this space. A space admin can modify your permissions."
    },
    replyNotPermitted: {
        id: "inline-comments-common.error.reply.not.permitted",
        defaultMessage: "You can\u2019t reply to comments in this space. A space admin can modify your permissions."
    },
    replyNotAllowedParentDeleted: {
        id: "inline-comments-common.error.reply.not.allowed.parent.deleted",
        defaultMessage: "You can\u2019t reply to this comment because it was just deleted by someone else. Refresh to view the latest updates."
    },
    unableToMarkDOM: {
        id: "inline-comments-common.error.unable.to.mark.dom",
        defaultMessage: "Your comment has been successfully created. Refresh to view it."
    },
    networkError: {
        id: "inline-comments-common.error.network",
        defaultMessage: "Your comment wasn't added due to a network error. Check your connection and try again."
    },
    unexpectedError: {
        id: "inline-comments-common.error.unexpected",
        defaultMessage: "Something went wrong when saving this comment. Close the comment or refresh, and try adding your comment again."
    },
    actionNotPermittedTitle: {
        id: "inline-comments-common.error.action.not.permitted.title",
        defaultMessage: "Unauthorized action"
    },
    actionNotPermitted: {
        id: "inline-comments-common.error.action.not.permitted",
        defaultMessage: "You can\u2019t perform that action on inline comments in this space. A space admin can modify your permissions."
    },
    cannotReplyToResolvedComment: {
        id: "inline-comments-common.error.cannot.reply.to.resolved",
        defaultMessage: "You can\u2019t reply to this comment because it was recently resolved by another user. Refresh to view the latest updates."
    },
    cannotUpdateResolvedComment: {
        id: "inline-comments-common.error.cannot.update.resolved",
        defaultMessage: "You can\u2019t edit this comment because it was recently resolved by another user. Refresh to view the latest updates."
    },
    unableToGenerateStep: {
        id: "inline-comments-common.error.unable.to.generate.step",
        defaultMessage: "You can\u2019t create a comment because something went wrong with your highlight. Close this window and create a new highlight."
    },
    contentOutOfDate: {
        id: "inline-comments-common.error.content.out.of.date",
        defaultMessage: "You can\u2019t create a comment here because the text has been changed or removed."
    },
    createTimeout: {
        id: "inline-comments-common.error.create.timeout",
        defaultMessage: "Your request to create a comment timed out. Wait a few moments and save the comment again."
    },
    /**
   * The message below is duplicated in the next files:
   * next/packages/resolved-inline-comments-dialog/src/ResolvedInlineCommentsDialogComponent.tsx
   * packages/confluence-frontend-server/src/components/Comment/PageCommentRenderer.js
   *
   * If you are going to change the message please make sure that the same changes are made in the mentioned above files
   */ a11yCommentLabel: {
        id: "inline-comments-common.a11y.comment.wrapper.label",
        defaultMessage: "Comment by {username}"
    },
    commentActionsMenuLabel: {
        id: "inline-comments-common.comment.actions.menu.label",
        defaultMessage: "More actions"
    },
    copyLinkTooltip: {
        id: "inline-comments-common.tooltip.copy.link",
        defaultMessage: "Copy link to comment"
    },
    linkCopiedTooltip: {
        id: "inline-comments-common.tooltip.link.has.been.copied",
        defaultMessage: "Copied!"
    },
    resolve: {
        id: "inline-comments-common.view.action.resolve",
        defaultMessage: "Resolve"
    },
    resolved: {
        id: "inline-comments-common.view.action.resolved",
        defaultMessage: "Resolved"
    },
    edit: {
        id: "inline-comments-common.view.action.edit",
        defaultMessage: "Edit"
    },
    delete: {
        id: "inline-comments-common.view.action.delete",
        defaultMessage: "Delete"
    },
    reopen: {
        id: "inline-comments-common.action.reopen",
        defaultMessage: "Reopen"
    },
    replyPlaceholder: {
        id: "inline-comments-common.reply.placeholder",
        defaultMessage: "Reply"
    },
    replyPlaceholderWithName: {
        id: "inline-comments-common.reply.placeholder.with-name",
        defaultMessage: "Reply to {name}"
    },
    reactionAriaLabelWithName: {
        id: "inline-comments-common.reaction.aria-label.with-name",
        defaultMessage: "React to {name}\u2019s comment"
    },
    resolveThread: {
        id: "inline-comments-common.resolve-thread",
        defaultMessage: "Resolve comment thread"
    },
    /**
   * Collaborator Onboarding sample comment
   */ sampleAuthor: {
        id: "inline-comments-common.sample.comment.author",
        defaultMessage: "Confluence"
    },
    sampleBody: {
        id: "inline-comments-common.sample.comment.body",
        defaultMessage: "Highlight content to add an inline comment. All viewers can see these, so it\u2019s great for targeted discussion on a specific word or phrase"
    },
    sampleReply: {
        id: "inline-comments-common.sample.reply.input",
        defaultMessage: "disabled reply input"
    },
    sampleReplyPlaceholder: {
        id: "inline-comments-common.sample.reply.placeholder",
        defaultMessage: "Reply"
    },
    sampleReplyTooltip: {
        id: "inline-comments-common.sample.reply.tooltip",
        defaultMessage: "Reply is unavailable for sample comments"
    },
    sampleDeleteHeader: {
        id: "inline-comments-common.sample.comment.delete.header",
        defaultMessage: "Only you can see this."
    },
    sampleDeleteIcon: {
        id: "inline-comments-common.sample.comment.delete.icon",
        defaultMessage: "Delete icon"
    },
    sampleDeleteTooltip: {
        id: "inline-comments-common.sample.comment.delete.tooltip",
        defaultMessage: "Delete sample comment"
    },
    sampleCloseIconLabel: {
        id: "inline-comments-common.sample.comment.delete.icon.label",
        defaultMessage: "Close sample comment"
    },
    collapsedRepliesMore: {
        id: "inline-comments-common.collapsed.replies.more",
        defaultMessage: "{numCollapsedReplies} more replies"
    },
    unreadInlineComment: {
        id: "inline-comments-common.unread.inline.comment",
        defaultMessage: "This is an unread inline comment"
    },
    resolvedText: {
        id: "inline-comments-common.resolved",
        defaultMessage: "[Resolved]"
    },
    resolvedFlagText: {
        id: "inline-comments-common.resolved.flag.text",
        defaultMessage: "Comment resolved"
    },
    deletedText: {
        id: "inline-comments-common.deleted",
        defaultMessage: "[Deleted]"
    },
    copyLink: {
        id: "inline-comments-common.copy.link",
        defaultMessage: "Copy link"
    },
    goToCommentCTA: {
        id: "inline-comments-common.comment.reopened.flag.cta.gotocomment",
        defaultMessage: "Go to comment"
    },
    undoCTA: {
        id: "inline-comments-common.comment.reopened.flag.cta.undo",
        defaultMessage: "Undo"
    },
    contentDeleted: {
        id: "inline-comments-common.content.deleted",
        defaultMessage: "Content deleted"
    },
    originalContentDeleted: {
        id: "inline-comments-common.original.content.deleted",
        defaultMessage: "Original content deleted"
    },
    thisContentWasDeleted: {
        id: "inline-comments-common.dangling.comments.this.content.was.deleted",
        defaultMessage: "This content was deleted."
    },
    viewDeletedContent: {
        id: "inline-comments-common.dangling.comments.view.deleted.content",
        defaultMessage: "View deleted content"
    },
    collapseDeletedContent: {
        id: "inline-comments-common.dangling.comments.collapse.deleted.content",
        defaultMessage: "Collapse deleted content"
    }
});
module.exports["i18n"] = $90dae8a726ff859c$export$a7357cdd1f0b0168;

});

parcelRegister("4pGaH", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $0873c4e49e24a2d5$export$1011b0dca615a7c4 = (0, $cozmU.createContext)(undefined);
module.exports["CommentsPanelPermissionContext"] = $0873c4e49e24a2d5$export$1011b0dca615a7c4;

});

parcelRegister("4hCFw", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $6SsN4 = parcelRequire("6SsN4");


var $w6R6I = parcelRequire("w6R6I");


var $cXtTj = parcelRequire("cXtTj");


var $7akNQ = parcelRequire("7akNQ");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $fNTq8 = parcelRequire("fNTq8");

var $cFVPs = parcelRequire("cFVPs");


var $5JhlM = parcelRequire("5JhlM");

var $bBIvl = parcelRequire("bBIvl");


var $d5gEx = parcelRequire("d5gEx");


var $gZFfs = parcelRequire("gZFfs");


var $i8aB6 = parcelRequire("i8aB6");


var $a7t2v = parcelRequire("a7t2v");


var $lgull = parcelRequire("lgull");


var $iTtzC = parcelRequire("iTtzC");

const $2795fb4dc781be1d$var$SNIPPET_ENTRYPOINT_ID = '55dba3ae-58fa-41e0-828b-1e30fe66c0ba';
const $2795fb4dc781be1d$var$ANALYTICS_FROM_CODE = 'SMARTLINK';
const $2795fb4dc781be1d$var$DEFAULT_MAX_LINES = 4;
const $2795fb4dc781be1d$var$styles = {
    container: "_2sNsIg7NXe"
};
const $2795fb4dc781be1d$var$getContentTypeParam = (contentType)=>contentType === 'page' ? 'PAGE' : contentType === 'blogpost' ? 'BLOGPOST' : null;
const $2795fb4dc781be1d$var$getAnalyticsConfig = (props)=>({
        product: 'confluence',
        subproduct: 'confluence',
        source: 'confluencePage',
        aiFeatureName: 'aiSnippet',
        proactiveGeneratedAI: 1,
        userGeneratedAI: 0,
        additionalAttributes: {
            contentId: props.contentId,
            contentType: props.contentType,
            from: props.from ?? $2795fb4dc781be1d$var$ANALYTICS_FROM_CODE,
            productAttributionOverride: 'confluence'
        },
        enablePlatformEvents: true,
        skipAISessionValidation: true
    }); /**
     * Main AI Snippet component. Fetches the AI snippet data from the server and displays it.
     * If the snippet data type is not supported, it will display the fallback component.
     * If the AI snippet data is not found or another error occurs it will display the AISnippet component,
     * but with the fallback text in place of the response text.
     *
     * @param contentId - The content ID of the AI snippet
     * @param contentType - The content type of the AI snippet
     * @param cloudId - The cloud ID of the AI snippet
     * @param fallbackText - The text to display if the AI snippet fails to load
     * @param fallbackComponent - The component to display if the AI snippet is not supported
     * @param source [optional] - The source for where the AI snippet was triggered from defaults to 'smartlink'
     * @param onLoadComplete [optional] - The callback function that executes when loading has completed
     * @returns
     */ 
const $2795fb4dc781be1d$export$1b2af18ca4bb327b = (props)=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $fNTq8.AIEventsInstrumentationProvider), {
        config: $2795fb4dc781be1d$var$getAnalyticsConfig(props)
    }, /*#__PURE__*/ $cozmU.createElement($2795fb4dc781be1d$export$ac90160f7ae1e32f, props));
};
const $2795fb4dc781be1d$export$ac90160f7ae1e32f = ({ contentId: contentId, contentType: contentType, cloudId: cloudId, fallbackText: fallbackText, fallbackComponent: fallbackComponent, userId: userId, displayName: displayName, source: source = 'smartlink', maxLines: maxLines = $2795fb4dc781be1d$var$DEFAULT_MAX_LINES, isHidden: isHidden = false, onLoadComplete: onLoadComplete, showFooter: showFooter, showAwareness: showAwareness })=>{
    const [queryRef, loadQuery] = (0, $6SsN4.useQueryLoader)((0, $iTtzC.default));
    const isLoadingRef = (0, $cozmU.useRef)(true);
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultError: trackAIResultError, trackAIInteractionDismiss: trackAIInteractionDismiss } = (0, $cFVPs.useAIEventsInstrumentation)();
    const { start: start, success: success, failure: failure } = (0, $i8aB6.useUFOExperience)({
        id: 'ai-snippet-load',
        component: 'ai-snippet',
        type: (0, $gZFfs.ExperienceTypes).Load,
        performanceType: (0, $gZFfs.ExperiencePerformanceTypes).InlineResult
    });
    const contentTypeParam = $2795fb4dc781be1d$var$getContentTypeParam(contentType);
    const isValidQuery = contentType && cloudId && contentId && contentTypeParam;
    const isEnabledForJira = (0, $iDrrr.fg)('jira-cc-ai-snippet-gate');
    const isTrackingEnabled = (0, $cXtTj.default).getExperimentValue('cc-ai-snippet-experiment-tracking', 'isEnabled', false);
    (0, $cozmU.useEffect)(()=>{
        if (!isHidden) trackAIInteractionInit();
        return ()=>{
            if (isLoadingRef.current && !isHidden) trackAIInteractionDismiss();
        }; // Only on component mount/unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $cozmU.useEffect)(()=>{
        isLoadingRef.current = !queryRef;
        if (queryRef) {
            if (isTrackingEnabled) success();
            onLoadComplete?.();
        }
    }, [
        queryRef,
        onLoadComplete,
        success,
        isTrackingEnabled
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isValidQuery) // Skip query if we don't have valid params as we'll just return the fallback component
        return;
        if (isTrackingEnabled) start();
        loadQuery({
            contentId: contentId,
            contentType: contentTypeParam,
            cloudId: cloudId,
            includeMe: isEnabledForJira
        });
    }, [
        contentId,
        contentTypeParam,
        cloudId,
        loadQuery,
        isValidQuery,
        isEnabledForJira,
        start,
        isTrackingEnabled
    ]);
    if (!isValidQuery) return fallbackComponent;
    const content = /*#__PURE__*/ $cozmU.createElement((0, $9EOlJ.ErrorBoundary), {
        fallback: /*#__PURE__*/ $cozmU.createElement((0, $a7t2v.AISnippetContent), {
            text: fallbackText,
            contentId: contentId,
            showFooter: false,
            showAwareness: showAwareness,
            source: source,
            isHidden: isHidden,
            maxLines: maxLines
        }),
        onError: (error)=>{
            if (!isHidden) {
                if (isTrackingEnabled) failure({
                    metadata: {
                        errorCode: 'extensions' in error ? error.extensions?.statusCode || 500 : 999,
                        errorMessage: error.message || 'Unknown error'
                    }
                });
                trackAIResultError({
                    aiErrorCode: 'extensions' in error ? error.extensions?.statusCode || 500 : 999,
                    aiErrorMessage: error.message || 'Unknown error'
                });
            }
        }
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($2795fb4dc781be1d$var$styles.container)
    }, /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ $cozmU.createElement((0, $bBIvl.AIStreamLoading), null)
    }, queryRef ? /*#__PURE__*/ $cozmU.createElement((0, $lgull.AISnippetLoader), {
        queryRef: queryRef,
        fallbackText: fallbackText,
        contentId: contentId,
        source: source,
        isHidden: isHidden,
        maxLines: maxLines,
        showFooter: showFooter,
        showAwareness: showAwareness
    }) : /*#__PURE__*/ $cozmU.createElement((0, $bBIvl.AIStreamLoading), null))));
    return /*#__PURE__*/ $cozmU.createElement((0, $7akNQ.FlagsProvider), null, isEnabledForJira ? content : /*#__PURE__*/ $cozmU.createElement((0, $5JhlM.AIFeedbackPropertiesProvider), {
        entrypointId: $2795fb4dc781be1d$var$SNIPPET_ENTRYPOINT_ID,
        userId: userId,
        displayName: displayName
    }, content));
};
const $2795fb4dc781be1d$export$c9a07cebec67e951 = (props)=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $d5gEx.RelayEnvironmentProvider), null, /*#__PURE__*/ $cozmU.createElement($2795fb4dc781be1d$export$1b2af18ca4bb327b, props));
};
module.exports["AISnippetWithRelayEnvironment"] = $2795fb4dc781be1d$export$c9a07cebec67e951;

});

parcelRegister("5JhlM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");

const $2eafd2f31cb677aa$var$FEEDBACK_CONTEXT_CF = 'customfield_10047';
const $2eafd2f31cb677aa$export$f906c21bacdb2d8e = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $2eafd2f31cb677aa$export$e9e654940dee103b = ({ children: children, entrypointId: entrypointId, locale: locale, feedbackContextId: feedbackContextId = $2eafd2f31cb677aa$var$FEEDBACK_CONTEXT_CF, feedbackContext: feedbackContext = {}, userId: userId, displayName: displayName })=>{
    const { locale: intlLocale } = (0, $kSwu1.useIntl)();
    const feedbackContextString = Object.entries(feedbackContext).map(([key, value])=>`${key}: ${JSON.stringify(value)}`).join(' ');
    const contextValue = (0, $cozmU.useMemo)(()=>({
            entrypointId: entrypointId,
            feedbackContextId: feedbackContextId,
            feedbackContext: feedbackContextString,
            locale: locale || intlLocale,
            userId: userId,
            displayName: displayName
        }), [
        entrypointId,
        feedbackContextId,
        feedbackContextString,
        locale,
        intlLocale,
        userId,
        displayName
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2eafd2f31cb677aa$export$f906c21bacdb2d8e.Provider, {
        value: contextValue
    }, children);
};
const $2eafd2f31cb677aa$export$ff3deb4415ee32e3 = ()=>{
    const context = (0, $cozmU.useContext)($2eafd2f31cb677aa$export$f906c21bacdb2d8e);
    if (context === undefined) throw new Error('useAIFeedbackProperties must be used within a AIFeedbackPropertiesProvider');
    return context;
};
module.exports["AIFeedbackPropertiesProvider"] = $2eafd2f31cb677aa$export$e9e654940dee103b;
module.exports["useAIFeedbackProperties"] = $2eafd2f31cb677aa$export$ff3deb4415ee32e3;

});

parcelRegister("bBIvl", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3izAL = parcelRequire("3izAL");

var $kz1Yj = parcelRequire("kz1Yj");

var $buxP3 = parcelRequire("buxP3");


var $7m1U4 = parcelRequire("7m1U4");

const $b089d8c6b56c64f6$var$styles = (0, $buxP3.xcss)({
    color: 'color.text.subtle'
});
const $b089d8c6b56c64f6$var$i18n = (0, $kSwu1.defineMessages)({
    generatingSummaryText: {
        id: "ai-stream-loading.title",
        defaultMessage: "AI is working..."
    },
    generatingSummaryAnimationAlt: {
        id: "ai-stream-loading.generation-animation",
        defaultMessage: "Generating"
    }
});
const $b089d8c6b56c64f6$export$47a62cbf3ee79fef = ({ padding: padding = 'space.300', titleMessage: titleMessage })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const title = titleMessage ?? $b089d8c6b56c64f6$var$i18n.generatingSummaryText;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        padding: padding,
        xcss: $b089d8c6b56c64f6$var$styles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
        alignBlock: "center",
        space: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7m1U4.GeneratingStreamAnimation), {
        alt: formatMessage($b089d8c6b56c64f6$var$i18n.generatingSummaryAnimationAlt)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), title)));
};
module.exports["AIStreamLoading"] = $b089d8c6b56c64f6$export$47a62cbf3ee79fef;

});

parcelRegister("7m1U4", function(module, exports) {
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $cozmU = parcelRequire("cozmU");

const $c344a4b7f3959518$export$3709887a1be0e305 = ({ alt: alt })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("title", null, alt), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("circle", {
        cx: "5.5",
        cy: "12.5",
        r: "1.5",
        fill: "#0C66E4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0s"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("circle", {
        cx: "11.5",
        cy: "10.5",
        r: "1.5",
        fill: "#1D7AFC"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.2s"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("circle", {
        cx: "17.5",
        cy: "12.5",
        r: "1.5",
        fill: "#388BFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.4s"
    })));
};
module.exports["GeneratingStreamAnimation"] = $c344a4b7f3959518$export$3709887a1be0e305;

});

parcelRegister("a7t2v", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $303LV = parcelRequire("303LV");


var $cXtTj = parcelRequire("cXtTj");


var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $cFVPs = parcelRequire("cFVPs");


var $cAiYt = parcelRequire("cAiYt");

var $aIn0d = parcelRequire("aIn0d");

var $cHkK6 = parcelRequire("cHkK6");


var $5GgqH = parcelRequire("5GgqH");

const $24521ba341a214c8$var$MAU_CRITERIA_DWELL_TIME = 3000;
const $24521ba341a214c8$var$sanitizeMarkdown = (text)=>{
    if (!text) return '';
    return text.replace(/={4,}/g, '===') // h1 headers
    .replace(/-{4,}/g, '---'); // h2 headers
};
const $24521ba341a214c8$export$3cf37822a11d3ff3 = ({ text: text, contentId: contentId, showFooter: showFooter = true, showAwareness: showAwareness = false, source: source, isHidden: isHidden, maxLines: maxLines, renderAsMarkdown: renderAsMarkdown = true })=>{
    const ref = (0, $cozmU.useRef)(null);
    const { getDwellTime: getDwellTime } = (0, $5GgqH.usePopupDwellTime)(ref, 250);
    const { trackAIResultView: trackAIResultView, trackAIFeedbackSubmit: trackAIFeedbackSubmit } = (0, $cFVPs.useAIEventsInstrumentation)();
    // This is needed to keep the snippet value in scope when running the unmount effect
    const snippetValueRef = (0, $cozmU.useRef)(text);
    const isExperimentEnabled = (0, $cXtTj.default).getExperimentValue('cc-ai-snippet-fixes-1025', 'isEnabled', false);
    const isFeedbackEnabled = (0, $cXtTj.default).getExperimentValue('cc-ai-snippet-experiment-feedback', 'isEnabled', false);
    const handleLikeClicked = (0, $cozmU.useCallback)(()=>{
        trackAIFeedbackSubmit('up');
    }, [
        trackAIFeedbackSubmit
    ]);
    const handleDislikeClicked = (0, $cozmU.useCallback)(()=>{
        trackAIFeedbackSubmit('down');
    }, [
        trackAIFeedbackSubmit
    ]);
    (0, $cozmU.useEffect)(()=>{
        const currentText = snippetValueRef.current;
        return ()=>{
            const dwellTime = getDwellTime();
            if (!isHidden) {
                if (showFooter && currentText && dwellTime >= $24521ba341a214c8$var$MAU_CRITERIA_DWELL_TIME) trackAIResultView({
                    attributes: {
                        dwellTime: dwellTime,
                        source: source,
                        wasShownAIContent: true
                    }
                });
                else trackAIResultView({
                    attributes: {
                        dwellTime: dwellTime,
                        source: source,
                        wasShownAIContent: showFooter && !!currentText
                    },
                    doesNotMeetMAUCriteria: true
                });
            }
        };
    // we only want to run this effect on un-mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100",
        ref: ref
    }, showAwareness && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cAiYt.AIAwareness), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        maxLines: maxLines
    }, renderAsMarkdown ? isExperimentEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $303LV.default), {
        options: {
            disableParsingRawHTML: true
        }
    }, $24521ba341a214c8$var$sanitizeMarkdown(text || '')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $303LV.default), null, text || '') : text || ''), showFooter && text && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aIn0d.AIDisclaimer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cHkK6.AIFeedbackComponent), {
        contentId: contentId,
        onLikeClicked: isFeedbackEnabled ? handleLikeClicked : undefined,
        onDislikeClicked: isFeedbackEnabled ? handleDislikeClicked : undefined
    })));
};
module.exports["AISnippetContent"] = $24521ba341a214c8$export$3cf37822a11d3ff3;

});

parcelRegister("cAiYt", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $etoPX = parcelRequire("etoPX");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");


var $1kxSE = parcelRequire("1kxSE");

const $b6dbb4b671decd4a$var$styles = {
    text: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8"
};
const $b6dbb4b671decd4a$export$fde99ed387d90f1 = ({ variant: variant = 'summary' })=>{
    const MESSAGE_MAP = {
        summary: (0, $1kxSE.i18n).rovoAwarenessMessage,
        define: (0, $1kxSE.i18n).rovoAwarenessDefineMessage
    };
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const message = MESSAGE_MAP[variant];
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($b6dbb4b671decd4a$var$styles.text)
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ $cozmU.createElement((0, $etoPX.RovoIcon), {
        size: "xxsmall",
        appearance: "brand"
    }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: "color.text.subtlest"
    }, formatMessage(message))));
};
module.exports["AIAwareness"] = $b6dbb4b671decd4a$export$fde99ed387d90f1;

});

parcelRegister("1kxSE", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $c8fb6889a2026e6c$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    rovoAwarenessMessage: {
        id: "ai-awareness.rovoAwarenessMessage",
        defaultMessage: "Summary by Rovo"
    },
    rovoAwarenessDefineMessage: {
        id: "ai-awareness-define.message",
        defaultMessage: "Definition by Rovo"
    }
});
module.exports["i18n"] = $c8fb6889a2026e6c$export$a7357cdd1f0b0168;

});

parcelRegister("cHkK6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7ZB0A = parcelRequire("7ZB0A");


var $91uAX = parcelRequire("91uAX");


var $4MnFz = parcelRequire("4MnFz");


var $chu6R = parcelRequire("chu6R");


var $i1t43 = parcelRequire("i1t43");


var $iDrrr = parcelRequire("iDrrr");


var $3izAL = parcelRequire("3izAL");

var $kz1Yj = parcelRequire("kz1Yj");

var $buxP3 = parcelRequire("buxP3");


var $lpNn5 = parcelRequire("lpNn5");


var $5JhlM = parcelRequire("5JhlM");


var $gecH2 = parcelRequire("gecH2");

const $2e66c8b5b2928379$var$LINK_TO_PRIVACY_POLICY = 'https://www.atlassian.com/legal/privacy-policy';
const $2e66c8b5b2928379$var$LINK_TO_RESEARCH_GROUP = 'https://www.atlassian.com/research-group';
const $2e66c8b5b2928379$var$i18n = (0, $kSwu1.defineMessages)({
    flagTitle: {
        id: "quick-summary.feedback.flag.title",
        defaultMessage: "Thanks!"
    },
    flagDescription: {
        id: "quick-summary.feedback.flag.description",
        defaultMessage: "We appreciate you taking the time to send this feedback."
    },
    likeTooltip: {
        id: "quick-summary.like.tooltip",
        defaultMessage: "Helpful"
    },
    dislikeTooltip: {
        id: "quick-summary.dislike.tooltip",
        defaultMessage: "Not helpful"
    },
    feedbackTitle: {
        id: "quick-summary.feedback.title",
        defaultMessage: "Help us improve Atlassian Intelligence"
    },
    feedbackSummaryTitle: {
        id: "quick-summary.feedback.summary.title",
        defaultMessage: "Tell us about your experience"
    },
    feedbackSummaryPlaceholder: {
        id: "quick-summary.feedback.summary.placeholder",
        defaultMessage: "What did Atlassian Intelligence do well? What could be improved?"
    },
    canContactText: {
        id: "quick-summary.feedback.can-contact.label",
        defaultMessage: "Atlassian can contact me about this feedback. See our {privacyPolicyLink}."
    },
    privacyPolicyLink: {
        id: "quick-summary.feedback.privacy-policy.link",
        defaultMessage: "privacy policy"
    },
    improveAtlassianText: {
        id: "quick-summary.feedback.improve-atlassian",
        defaultMessage: "I\u2019d like to help improve Atlassian products by joining the {researchGroupLink}."
    },
    improveAtlassianTextAppify: {
        id: "quick-summary.feedback.improve-atlassian-appify",
        defaultMessage: "I\u2019d like to help improve Atlassian apps by joining the {researchGroupLink}."
    },
    researchGroupLink: {
        id: "quick-summary.feedback.research-group.link",
        defaultMessage: "Atlassian Research Group"
    }
});
const $2e66c8b5b2928379$var$PrivacyPolicyLink = ({ link: link })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        target: "_blank",
        href: link
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $2e66c8b5b2928379$var$i18n.privacyPolicyLink));
const $2e66c8b5b2928379$var$ResearchGroupLink = ({ link: link })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        target: "_blank",
        href: link
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $2e66c8b5b2928379$var$i18n.researchGroupLink));
const $2e66c8b5b2928379$var$CanContactLabel = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$2e66c8b5b2928379$var$i18n.canContactText,
        values: {
            privacyPolicyLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e66c8b5b2928379$var$PrivacyPolicyLink, {
                link: $2e66c8b5b2928379$var$LINK_TO_PRIVACY_POLICY
            })
        }
    });
};
const $2e66c8b5b2928379$var$EnrolLabel = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $iDrrr.fg)('product-terminology-refresh') ? $2e66c8b5b2928379$var$i18n.improveAtlassianTextAppify : $2e66c8b5b2928379$var$i18n.improveAtlassianText,
        values: {
            researchGroupLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e66c8b5b2928379$var$ResearchGroupLink, {
                link: $2e66c8b5b2928379$var$LINK_TO_RESEARCH_GROUP
            })
        }
    });
};
const $2e66c8b5b2928379$var$DislikeIconWrapperXCSS = (0, $buxP3.xcss)({
    transform: 'rotate(180deg)'
});
const $2e66c8b5b2928379$var$ButtonWrapperXCSS = (0, $buxP3.xcss)({
    height: '24px',
    width: '24px'
});
const $2e66c8b5b2928379$export$f9f34317e5bc3551 = ({ contentId: contentId, onLikeClicked: onLikeClicked, onDislikeClicked: onDislikeClicked })=>{
    const { showFlag: showFlag } = (0, $4MnFz.useFlags)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isFeedbackOpen, setIsFeedbackOpen] = (0, $cozmU.useState)(false);
    const feedbackCollectorProperties = (0, $5JhlM.useAIFeedbackProperties)();
    const [sentiment, setSentiment] = (0, $cozmU.useState)('');
    const [hasGoodFeedbackBeenSubmitted, setHasGoodFeedbackBeenSubmitted] = (0, $cozmU.useState)(false);
    const [hasBadFeedbackBeenSubmitted, setHasBadFeedbackBeenSubmitted] = (0, $cozmU.useState)(false);
    const feedbackContextString = `contentId: ${contentId} sentiment: ${sentiment}${feedbackCollectorProperties.feedbackContext.length > 0 ? ` ${feedbackCollectorProperties.feedbackContext}` : ''}`;
    const showFeedbackFlag = ()=>{
        showFlag({
            title: formatMessage($2e66c8b5b2928379$var$i18n.flagTitle),
            description: formatMessage($2e66c8b5b2928379$var$i18n.flagDescription),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
                spacing: "spacious",
                color: "var(--ds-icon-success, #6A9A23)",
                label: "success"
            }),
            isAutoDismiss: true
        });
    };
    const handleLikeClicked = ()=>{
        onLikeClicked?.();
        setIsFeedbackOpen(true);
        setSentiment('good');
    };
    const handleDislikeClicked = ()=>{
        onDislikeClicked?.();
        setIsFeedbackOpen(true);
        setSentiment('bad');
    };
    const onFeedbackSubmit = ()=>{
        showFeedbackFlag();
        setIsFeedbackOpen(false);
        if (sentiment === 'good') {
            setHasGoodFeedbackBeenSubmitted(true);
            setHasBadFeedbackBeenSubmitted(false);
        } else {
            setHasBadFeedbackBeenSubmitted(true);
            setHasGoodFeedbackBeenSubmitted(false);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        role: "none",
        onClick: (e)=>e.stopPropagation()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        hideTooltipOnMouseDown: true,
        content: formatMessage($2e66c8b5b2928379$var$i18n.likeTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $2e66c8b5b2928379$var$ButtonWrapperXCSS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "subtle",
        "aria-label": formatMessage($2e66c8b5b2928379$var$i18n.likeTooltip),
        spacing: "none",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gecH2.ThumbIcon), {
            isSelected: hasGoodFeedbackBeenSubmitted
        }),
        onClick: handleLikeClicked,
        testId: "feedback-like-button",
        isDisabled: hasGoodFeedbackBeenSubmitted
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        hideTooltipOnMouseDown: true,
        content: formatMessage($2e66c8b5b2928379$var$i18n.dislikeTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $2e66c8b5b2928379$var$ButtonWrapperXCSS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "subtle",
        "aria-label": formatMessage($2e66c8b5b2928379$var$i18n.dislikeTooltip),
        spacing: "none",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $2e66c8b5b2928379$var$DislikeIconWrapperXCSS
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gecH2.ThumbIcon), {
            isSelected: hasBadFeedbackBeenSubmitted
        })),
        onClick: handleDislikeClicked,
        testId: "feedback-dislike-button",
        isDisabled: hasBadFeedbackBeenSubmitted
    }))), isFeedbackOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91uAX.default), {
        locale: feedbackCollectorProperties.locale,
        onSubmit: onFeedbackSubmit,
        onClose: ()=>setIsFeedbackOpen(false),
        atlassianAccountId: feedbackCollectorProperties.userId,
        name: feedbackCollectorProperties.displayName,
        entrypointId: feedbackCollectorProperties.entrypointId,
        summaryPlaceholder: formatMessage($2e66c8b5b2928379$var$i18n.feedbackSummaryPlaceholder),
        additionalFields: [
            {
                id: feedbackCollectorProperties.feedbackContextId,
                value: feedbackContextString
            }
        ],
        feedbackTitle: formatMessage($2e66c8b5b2928379$var$i18n.feedbackTitle),
        showTypeField: false,
        customTextAreaLabel: formatMessage($2e66c8b5b2928379$var$i18n.feedbackSummaryTitle),
        canBeContactedLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e66c8b5b2928379$var$CanContactLabel, null),
        enrolInResearchLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e66c8b5b2928379$var$EnrolLabel, null)
    })));
};
module.exports["AIFeedbackComponent"] = $2e66c8b5b2928379$export$f9f34317e5bc3551;

});

parcelRegister("gecH2", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $c8bBH = parcelRequire("c8bBH");

const $62e24cf344a5b8b1$export$ec2ba0e929740f73 = ({ isSelected: isSelected })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8bBH))), {
        color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon-subtle, #505258)",
        label: ""
    });
module.exports["ThumbIcon"] = $62e24cf344a5b8b1$export$ec2ba0e929740f73;

});

parcelRegister("5GgqH", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $44sV7 = parcelRequire("44sV7");

const $518681ac338b53b3$export$15dda63faa44a0df = (ref, interval = 500)=>{
    const isOnScreen = (0, $44sV7.useOnScreen)(ref);
    const dwellTimeRef = (0, $cozmU.useRef)(0);
    (0, $cozmU.useEffect)(()=>{
        const incremental = setInterval(()=>{
            if (isOnScreen) dwellTimeRef.current += interval;
        }, interval);
        return ()=>{
            clearInterval(incremental);
        };
    }, [
        isOnScreen,
        interval
    ]);
    const getDwellTime = ()=>dwellTimeRef.current;
    return {
        getDwellTime: getDwellTime
    };
};
module.exports["usePopupDwellTime"] = $518681ac338b53b3$export$15dda63faa44a0df;

});

parcelRegister("44sV7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $9f61f2cd2c8e0202$export$edb9b52ab3f1abbb = (ref)=>{
    const [isIntersecting, setIntersecting] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!ref.current) return;
        const observer = new IntersectionObserver(([entry])=>setIntersecting(entry.isIntersecting));
        if (ref.current) observer.observe(ref.current);
        return ()=>{
            if (observer) observer.disconnect();
        };
    });
    return isIntersecting;
};
module.exports["useOnScreen"] = $9f61f2cd2c8e0202$export$edb9b52ab3f1abbb;

});

parcelRegister("lgull", function(module, exports) {

var $iTtzC = parcelRequire("iTtzC");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $iDrrr = parcelRequire("iDrrr");


var $5JhlM = parcelRequire("5JhlM");


var $a7t2v = parcelRequire("a7t2v");

const $a1264e7348edcdb0$var$SNIPPET_ENTRYPOINT_ID = '55dba3ae-58fa-41e0-828b-1e30fe66c0ba';
const $a1264e7348edcdb0$export$f50b64530422ea99 = ({ contentId: contentId, fallbackText: fallbackText, queryRef: queryRef, source: source, isHidden: isHidden, maxLines: maxLines, showFooter: showFooter, showAwareness: showAwareness })=>{
    const data = (0, $6SsN4.usePreloadedQuery)((0, $iTtzC.default), queryRef);
    const aiSnippetText = data?.confluence_latestKnowledgeGraphObjectV2?.objectData;
    const content = /*#__PURE__*/ $cozmU.createElement((0, $a7t2v.AISnippetContent), {
        text: aiSnippetText || fallbackText,
        contentId: contentId,
        showFooter: !!aiSnippetText && showFooter,
        showAwareness: !!aiSnippetText && showAwareness,
        source: source,
        isHidden: isHidden,
        maxLines: maxLines,
        renderAsMarkdown: !!aiSnippetText
    });
    if ((0, $iDrrr.fg)('jira-cc-ai-snippet-gate')) return /*#__PURE__*/ $cozmU.createElement((0, $5JhlM.AIFeedbackPropertiesProvider), {
        entrypointId: $a1264e7348edcdb0$var$SNIPPET_ENTRYPOINT_ID,
        userId: data?.me?.user?.accountId,
        displayName: data?.me?.user?.name
    }, content);
    return content;
};
module.exports["AISnippetLoader"] = $a1264e7348edcdb0$export$f50b64530422ea99;

});

parcelRegister("iTtzC", function(module, exports) {
/**
 * @generated SignedSource<<77586322f750ae0b68f16053ceaefeac>>
 * @relayHash 83b5f9dcca400199c020ae8cd7e6e7c7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8b58eeaebb38ad38241e0152019eb289a93c640b57ebbf0774ddd0706e3cda40
const $34c51f4beec18331$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentType"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeMe"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "args": [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            },
            {
                "kind": "Variable",
                "name": "contentId",
                "variableName": "contentId"
            },
            {
                "kind": "Variable",
                "name": "contentType",
                "variableName": "contentType"
            },
            {
                "kind": "Literal",
                "name": "objectType",
                "value": "snippet_v2"
            }
        ],
        "concreteType": "KnowledgeGraphObjectResponseV2",
        "kind": "LinkedField",
        "name": "confluence_latestKnowledgeGraphObjectV2",
        "plural": false,
        "selections": [
            v4 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "objectData"
            }
        ]
    }, v6 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "aiSnippetLoaderQuery",
            "selections": [
                v5 /*: any*/ ,
                {
                    "condition": "includeMe",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "AuthenticationContext",
                            "kind": "LinkedField",
                            "name": "me",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "aiSnippetLoaderQuery",
            "selections": [
                v5 /*: any*/ ,
                {
                    "condition": "includeMe",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "AuthenticationContext",
                            "kind": "LinkedField",
                            "name": "me",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8b58eeaebb38ad38241e0152019eb289a93c640b57ebbf0774ddd0706e3cda40",
            "metadata": {},
            "name": "aiSnippetLoaderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$34c51f4beec18331$var$node.hash = "9d618230ccff7c19cd4e4fee2e2c0a2c";
var $34c51f4beec18331$export$2e2bcd8739ae039 = $34c51f4beec18331$var$node;
module.exports["default"] = $34c51f4beec18331$export$2e2bcd8739ae039;

});

parcelRegister("fNzRA", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $en1dX = parcelRequire("en1dX");


var $irVI7 = parcelRequire("irVI7");


var $8Ss4E = parcelRequire("8Ss4E");


var $bQm3c = parcelRequire("bQm3c");

var $7b4a2f6cc35c72e1$export$94f8d08c2312472b = /*#__PURE__*/ function(AddFooterCommentMode) {
    AddFooterCommentMode["FOOTER"] = "footer";
    // The footer comments section
    AddFooterCommentMode["STICKY_DRAFT"] = "sticky_draft";
    // The sticky draft that persists outside of the footer
    AddFooterCommentMode["STICKY_FOOTER"] = "sticky_footer";
    return AddFooterCommentMode;
}({});
const $7b4a2f6cc35c72e1$export$8a175172a11240d4 = /*#__PURE__*/ (0, $cozmU.createContext)({
    expandCommentContainer: ()=>{},
    closeCommentContainer: ()=>{},
    setWrapperWidth: ()=>{},
    setIsObjectCommentWrapperVisible: ()=>{},
    setFooterEditorEntry: ()=>{}
});
$7b4a2f6cc35c72e1$export$8a175172a11240d4.displayName = 'ObjectCommentDispatchContext';
const $7b4a2f6cc35c72e1$export$358734f355c08965 = /*#__PURE__*/ (0, $cozmU.createContext)({
    expanded: false,
    footerEditorEntry: undefined,
    width: undefined,
    isObjectCommentWrapperVisible: false
});
$7b4a2f6cc35c72e1$export$358734f355c08965.displayName = 'ObjectCommentContext';
const $7b4a2f6cc35c72e1$export$d248a0e4aca56201 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(20);
    const { children: children } = t0;
    const [expanded, setExpanded] = (0, $cozmU.useState)(false);
    const [footerEditorEntry, setFooterEditorEntry] = (0, $cozmU.useState)(undefined);
    const [width, setWidth] = (0, $cozmU.useState)(undefined);
    const [isObjectCommentWrapperVisible, setIsObjectCommentWrapperVisible] = (0, $cozmU.useState)(false);
    const { edition: edition, accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isGuest = accessStatus === "EXTERNAL_COLLABORATOR_ACCESS";
    let t1;
    if ($[0] !== expanded || $[1] !== footerEditorEntry || $[2] !== isObjectCommentWrapperVisible || $[3] !== width) {
        t1 = {
            expanded: expanded,
            footerEditorEntry: footerEditorEntry,
            width: width,
            isObjectCommentWrapperVisible: isObjectCommentWrapperVisible
        };
        $[0] = expanded;
        $[1] = footerEditorEntry;
        $[2] = isObjectCommentWrapperVisible;
        $[3] = width;
        $[4] = t1;
    } else t1 = $[4];
    const providerValue = t1;
    let t2;
    if ($[5] !== edition || $[6] !== isGuest) {
        t2 = (props)=>{
            const { entryPoint: entryPoint } = props ?? {};
            if (entryPoint) (0, $8Ss4E.startEditorExperiences)({
                name: (0, $irVI7.ADD_PAGE_COMMENT_EXPERIENCE),
                attributes: {
                    editor: "FABRIC",
                    isSingleExperience: true,
                    edition: edition,
                    source: (0, $en1dX.AnalyticsSource).PAGE_FOOTER,
                    entryPoint: entryPoint,
                    isGuest: isGuest
                }
            }, {
                name: (0, $irVI7.ADD_PAGE_COMMENT_LOAD_EXPERIENCE)
            }, {
                name: (0, $irVI7.ADD_PAGE_COMMENT_PUBLISH_EXPERIENCE)
            });
            setExpanded(true);
        };
        $[5] = edition;
        $[6] = isGuest;
        $[7] = t2;
    } else t2 = $[7];
    let t3;
    let t4;
    let t5;
    let t6;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            setFooterEditorEntry(undefined);
            setExpanded(false);
        };
        t4 = (width_0)=>{
            setWidth(width_0 ? `${width_0}px` : "100%");
        };
        t5 = (visible)=>{
            setIsObjectCommentWrapperVisible(visible);
        };
        t6 = (footerEditorEntry_0)=>{
            setFooterEditorEntry(footerEditorEntry_0);
        };
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
        $[11] = t6;
    } else {
        t3 = $[8];
        t4 = $[9];
        t5 = $[10];
        t6 = $[11];
    }
    let t7;
    if ($[12] !== t2) {
        t7 = {
            expandCommentContainer: t2,
            closeCommentContainer: t3,
            setWrapperWidth: t4,
            setIsObjectCommentWrapperVisible: t5,
            setFooterEditorEntry: t6
        };
        $[12] = t2;
        $[13] = t7;
    } else t7 = $[13];
    const dispatchProviderValue = t7;
    let t8;
    if ($[14] !== children || $[15] !== dispatchProviderValue) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7b4a2f6cc35c72e1$export$8a175172a11240d4.Provider, {
            value: dispatchProviderValue
        }, children);
        $[14] = children;
        $[15] = dispatchProviderValue;
        $[16] = t8;
    } else t8 = $[16];
    let t9;
    if ($[17] !== providerValue || $[18] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7b4a2f6cc35c72e1$export$358734f355c08965.Provider, {
            value: providerValue
        }, t8);
        $[17] = providerValue;
        $[18] = t8;
        $[19] = t9;
    } else t9 = $[19];
    return t9;
} : ({ children: children })=>{
    const [expanded, setExpanded] = (0, $cozmU.useState)(false);
    const [footerEditorEntry, setFooterEditorEntry] = (0, $cozmU.useState)(undefined);
    const [width, setWidth] = (0, $cozmU.useState)(undefined);
    const [isObjectCommentWrapperVisible, setIsObjectCommentWrapperVisible] = (0, $cozmU.useState)(false);
    const { edition: edition, accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isGuest = accessStatus === 'EXTERNAL_COLLABORATOR_ACCESS';
    const providerValue = (0, $cozmU.useMemo)(()=>({
            expanded: expanded,
            footerEditorEntry: footerEditorEntry,
            width: width,
            isObjectCommentWrapperVisible: isObjectCommentWrapperVisible
        }), [
        expanded,
        footerEditorEntry,
        width,
        isObjectCommentWrapperVisible
    ]);
    const dispatchProviderValue = (0, $cozmU.useMemo)(()=>({
            expandCommentContainer: (props)=>{
                const { entryPoint: entryPoint } = props ?? {};
                if (entryPoint) (0, $8Ss4E.startEditorExperiences)({
                    name: (0, $irVI7.ADD_PAGE_COMMENT_EXPERIENCE),
                    attributes: {
                        editor: 'FABRIC',
                        isSingleExperience: true,
                        edition: edition,
                        source: (0, $en1dX.AnalyticsSource).PAGE_FOOTER,
                        entryPoint: entryPoint,
                        isGuest: isGuest
                    }
                }, {
                    name: (0, $irVI7.ADD_PAGE_COMMENT_LOAD_EXPERIENCE)
                }, {
                    name: (0, $irVI7.ADD_PAGE_COMMENT_PUBLISH_EXPERIENCE)
                });
                setExpanded(true);
            },
            closeCommentContainer: ()=>{
                setFooterEditorEntry(undefined);
                setExpanded(false);
            },
            setWrapperWidth: (width_0)=>{
                setWidth(width_0 ? `${width_0}px` : '100%');
            },
            setIsObjectCommentWrapperVisible: (visible)=>{
                setIsObjectCommentWrapperVisible(visible);
            },
            setFooterEditorEntry: (footerEditorEntry_0)=>{
                setFooterEditorEntry(footerEditorEntry_0);
            }
        }), [
        setExpanded,
        setFooterEditorEntry,
        setWidth,
        setIsObjectCommentWrapperVisible,
        edition,
        isGuest
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7b4a2f6cc35c72e1$export$358734f355c08965.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7b4a2f6cc35c72e1$export$8a175172a11240d4.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $7b4a2f6cc35c72e1$export$da430766ddf17a6b = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $cozmU.useContext)($7b4a2f6cc35c72e1$export$358734f355c08965);
} : ()=>{
    return (0, $cozmU.useContext)($7b4a2f6cc35c72e1$export$358734f355c08965);
};
const $7b4a2f6cc35c72e1$export$8ba3235fe153fa01 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $cozmU.useContext)($7b4a2f6cc35c72e1$export$8a175172a11240d4);
} : ()=>{
    return (0, $cozmU.useContext)($7b4a2f6cc35c72e1$export$8a175172a11240d4);
};
module.exports["AddFooterCommentMode"] = $7b4a2f6cc35c72e1$export$94f8d08c2312472b;
module.exports["ObjectCommentProvider"] = $7b4a2f6cc35c72e1$export$d248a0e4aca56201;
module.exports["useObjectCommentContext"] = $7b4a2f6cc35c72e1$export$da430766ddf17a6b;
module.exports["useObjectCommentDispatchContext"] = $7b4a2f6cc35c72e1$export$8ba3235fe153fa01;

});

parcelRegister("7lu50", function(module, exports) {
// old definition from tysy - not a real query being used
const $a928a12ca5fd59f3$export$adaf854818ff0d42 = (queryData)=>{
    return queryData?.entitlements?.externalCollaborator.isEntitled;
};
module.exports["getExternalCollaboratorEntitlementFromQuery"] = $a928a12ca5fd59f3$export$adaf854818ff0d42;

});

parcelRegister("9fywD", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9KSWX = parcelRequire("9KSWX");


var $lpNn5 = parcelRequire("lpNn5");

const $43aed8c383cce8da$var$i18n = (0, $kSwu1.defineMessages)({
    externalUserLozengeText: {
        id: "external-collab-ui.user-guest-lozenge",
        defaultMessage: "Guest"
    },
    guestUserTooltip: {
        id: "external-collab-ui.user-guest-lozenge.tooltip",
        defaultMessage: "Guests can only access certain spaces and have limited access to user info."
    }
});
const $43aed8c383cce8da$export$4de00d985a23014d = {
    text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $43aed8c383cce8da$var$i18n.guestUserTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $43aed8c383cce8da$var$i18n.externalUserLozengeText)),
    appearance: 'default',
    isBold: false
};
const $43aed8c383cce8da$export$aa87bb37f13b8b5 = ()=>{
    const { text: text, appearance: appearance, isBold: isBold } = $43aed8c383cce8da$export$4de00d985a23014d;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        appearance: appearance,
        isBold: isBold
    }, text);
};
module.exports["ExternalUserLozengeProps"] = $43aed8c383cce8da$export$4de00d985a23014d;
module.exports["ExternalUserLozenge"] = $43aed8c383cce8da$export$aa87bb37f13b8b5;

});

parcelRegister("fd6g2", function(module, exports) {
// "confluence.fe.custom.XXX"
const $88f9a74d7687653d$export$3fe4a04f712fdf3b = 'mentions-query';
const $88f9a74d7687653d$export$18a3d3c084ff47d0 = 'profile-card-query';
const $88f9a74d7687653d$export$95463e4d15a0dca9 = 'legacy-extension-loading';
const $88f9a74d7687653d$export$5a66bfdc2ac06329 = 'fabric-publish-page';
const $88f9a74d7687653d$export$96dfe3e664538004 = 'time-to-app-idle';
const $88f9a74d7687653d$export$18a3e97ff841447b = 'share-notif-from-restrictions';
const $88f9a74d7687653d$export$d0eb1faf5fa0dbc7 = 'tc-events-fetch';
const $88f9a74d7687653d$export$ec119fee4dbc7f75 = 'tc-subcals-fetch';
const $88f9a74d7687653d$export$693c7d831f137ed3 = 'tc-jira-projects-fetch';
module.exports["MENTIONS_QUERY_CUSTOM_KEY"] = $88f9a74d7687653d$export$3fe4a04f712fdf3b;
module.exports["PROFILE_CARD_QUERY_CUSTOM_KEY"] = $88f9a74d7687653d$export$18a3d3c084ff47d0;
module.exports["LEGACY_EXTENSION_LOADING_CUSTOM_KEY"] = $88f9a74d7687653d$export$95463e4d15a0dca9;
module.exports["FABRIC_PUBLISH_PAGE_KEY"] = $88f9a74d7687653d$export$5a66bfdc2ac06329;
module.exports["TIME_TO_APP_IDLE_KEY"] = $88f9a74d7687653d$export$96dfe3e664538004;
module.exports["TEAM_CALENDARS_EVENT_FETCH_KEY"] = $88f9a74d7687653d$export$d0eb1faf5fa0dbc7;
module.exports["TEAM_CALENDARS_SUBCALS_FETCH_KEY"] = $88f9a74d7687653d$export$ec119fee4dbc7f75;
module.exports["TEAM_CALENDARS_JIRA_PROJECTS_FETCH_KEY"] = $88f9a74d7687653d$export$693c7d831f137ed3;

});

parcelRegister("4IoVL", function(module, exports) {
/* eslint-disable import-extensions/file-extension-required */ 
var $204vt = parcelRequire("204vt");


var $hfrng = parcelRequire("hfrng");


var $3kI72 = parcelRequire("3kI72");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $1NBp8 = parcelRequire("1NBp8");


var $2TuWI = parcelRequire("2TuWI");


var $cga1x = parcelRequire("cga1x");


var $kzNtP = parcelRequire("kzNtP");


var $c4QoG = parcelRequire("c4QoG");


var $I0A3i = parcelRequire("I0A3i");


var $kQiXs = parcelRequire("kQiXs");

const $17b0f8a5b73de479$var$DEFAULT_CONFIG = {
    clientId: '',
    fileStoreUrl: ''
};
const $17b0f8a5b73de479$var$cachedGetDownloadData = (0, $kzNtP.cacheWithExp)(async ({ contentId: contentId, contentAri: contentAri, contentProduct: contentProduct, isExternalShare: isExternalShare, shareToken: shareToken })=>{
    if ((0, $3kI72.requiresCrossProductAuth)({
        hostProduct: 'confluence-page',
        sourceProduct: contentProduct
    })) return (0, $3kI72.fetchTokenForSourceProduct)({
        contentAri: contentAri ?? contentId,
        contentId: contentId,
        sourceProduct: contentProduct
    });
    if (isExternalShare && shareToken) {
        const tokenResponse = await (0, $I0A3i.fetchExternalContentMediaSessionToken)(shareToken);
        const tokenData = tokenResponse?.data;
        return {
            token: tokenData?.externalContentMediaSession?.accessTokens?.readOnlyToken?.value || '',
            config: tokenData?.externalContentMediaSession?.configuration || $17b0f8a5b73de479$var$DEFAULT_CONFIG
        };
    }
    // Fallback to existing logic for backward compatibility
    const response = await (isExternalShare ? (0, $I0A3i.fetchExternalShareMediaToken) : (0, $I0A3i.fetchMediaToken))(contentId);
    const data = response?.data;
    const externalData = data?.['singleContent'];
    const content = isExternalShare ? externalData : data?.['content']?.nodes?.[0];
    return {
        token: content?.body?.atlas_doc_format?.mediaToken?.token || '',
        config: data?.mediaConfiguration || $17b0f8a5b73de479$var$DEFAULT_CONFIG
    };
}, (json)=>json.token);
const $17b0f8a5b73de479$var$getContentIdFromCollection = (authContext)=>{
    const match = /^contentId-(\d+)$/.exec(authContext?.collectionName ?? '');
    return match?.[1];
};
const $17b0f8a5b73de479$export$6176af039388fdbf = (dataGetter)=>async (authContext)=>{
        const data = await dataGetter(authContext);
        return {
            token: data?.token || '',
            clientId: data?.config?.clientId || '',
            baseUrl: data?.config?.fileStoreUrl || ''
        };
    };
const $17b0f8a5b73de479$export$da46cefd33160c4d = (viewDataGetter, uploadDataGetter)=>async (params)=>{
        // Currently, supplying upload token only for file and collection update action.
        // If no params are provided, the view token is returned.
        const isUpdateAction = !!params?.access?.find(({ type: type, actions: actions })=>(type === 'file' || type == 'collection') && actions.includes('update'));
        const data = await (isUpdateAction ? uploadDataGetter() : viewDataGetter(params));
        return {
            token: data?.token || '',
            clientId: data?.config?.clientId || '',
            baseUrl: data?.config?.fileStoreUrl || ''
        };
    };
const $17b0f8a5b73de479$export$6cb774192b5cd093 = (contextId)=>{
    try {
        const { snippetId: snippetId, scope: scope } = JSON.parse(contextId);
        return snippetId ? {
            snippetId: snippetId,
            scope: scope
        } : undefined;
    } catch  {} // not JSON or not a SnippetContextId.
};
const $17b0f8a5b73de479$export$724cb324eb7535cd = async (contextId, contentProduct, contentAri)=>{
    if ((0, $3kI72.requiresCrossProductAuth)({
        hostProduct: 'confluence-page',
        sourceProduct: contentProduct
    })) {
        const auth = await (0, $3kI72.fetchTokenForSourceProduct)({
            contentAri: contentAri ?? contextId,
            contentId: contextId,
            sourceProduct: contentProduct
        });
        return {
            clientId: auth.config.clientId || '',
            token: auth.token || '',
            baseUrl: auth.config.fileStoreUrl || ''
        };
    }
    if ((0, $6mKj3.expVal)('platform_editor_blocks_conf', 'isEnabled', false)) {
        const snippetContext = $17b0f8a5b73de479$export$6cb774192b5cd093(contextId);
        if (snippetContext && snippetContext.scope !== (0, $cga1x.SnippetScope).GLOBAL) {
            const auth = await (0, $2TuWI.fetchSnippetMediaToken)(snippetContext.snippetId);
            return {
                clientId: auth.clientId,
                token: auth.token,
                baseUrl: auth.baseUrl
            };
        }
    }
    const { collectionId: collectionId, templateId: templateId, spaceKey: spaceKey } = (0, $c4QoG.getTemplateMediaContextValues)(contextId);
    // template media informtion is stored slightly different in the context
    // to be able to discern which call to make
    if (collectionId || templateId) return (0, $c4QoG.getTemplateMediaAuth)({
        collectionId: collectionId,
        spaceKey: spaceKey,
        templateId: templateId
    });
    const response = await (0, $I0A3i.fetchMediaToken)(contextId);
    const { clientId: clientId = '', fileStoreUrl: fileStoreUrl = '' } = response?.data?.mediaConfiguration || {};
    return {
        clientId: clientId,
        token: response?.data?.content?.nodes?.[0]?.body?.atlas_doc_format?.mediaToken?.token || '',
        baseUrl: fileStoreUrl || ''
    };
};
const $17b0f8a5b73de479$var$cachedGetUploadData = (0, $kzNtP.cacheWithExp)(async (options)=>{
    const response = options.contentType === 'comment' && options.cloudId ? await (0, $I0A3i.getCommentUploadToken)(options.contentId, options.cloudId) : await (0, $I0A3i.getUploadToken)(options.contentId);
    const session = response?.data?.contentMediaSession;
    return {
        token: session?.token?.value || '',
        config: session?.configuration || $17b0f8a5b73de479$var$DEFAULT_CONFIG,
        collectionId: session?.collection || ''
    };
}, (json)=>json.token);
const $17b0f8a5b73de479$var$getUploadCollectionId = async (options)=>{
    const uploadData = await $17b0f8a5b73de479$var$cachedGetUploadData.getValue(options);
    return uploadData.collectionId;
};
const $17b0f8a5b73de479$var$createUploadAuthProviderDataGetter = (options)=>()=>$17b0f8a5b73de479$var$cachedGetUploadData.getValue(options);
const $17b0f8a5b73de479$var$getUploadMediaClientConfig = async (options)=>({
        authProvider: $17b0f8a5b73de479$export$6176af039388fdbf($17b0f8a5b73de479$var$createUploadAuthProviderDataGetter(options)),
        getAuthFromContext: $17b0f8a5b73de479$export$724cb324eb7535cd,
        useSha256ForUploads: true
    });
const $17b0f8a5b73de479$var$createRenameFile = (mediaClientConfig, getCollection)=>{
    const mediaClient = new (0, $204vt.MediaClient)(mediaClientConfig);
    return async (fileId, name)=>{
        const collection = getCollection();
        if (!collection) throw new Error('Cannot rename media file without a collection');
        await mediaClient.mediaStore.request('/files/rename', {
            method: 'PUT',
            endpoint: '/files/rename',
            authContext: {
                collectionName: collection
            },
            params: {
                collection: collection
            },
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                collection: collection,
                files: [
                    {
                        fileId: fileId,
                        fileName: name,
                        oldFileName: ''
                    }
                ]
            })
        });
    };
};
const $17b0f8a5b73de479$var$cachedGetExportDspData = (0, $kzNtP.cacheWithExp)(async ({ contentId: contentId, spaceKey: spaceKey })=>{
    const response = await (0, $I0A3i.getIsExportEnabledForContent)(contentId, spaceKey);
    const isExportAllowed = response?.data?.dataSecurityPolicy?.isActionEnabledForContent?.allowed;
    return {
        isExportAllowed: isExportAllowed,
        exp: Date.now() + 60000
    };
}, (json)=>json.exp);
const $17b0f8a5b73de479$var$getEnforceDataSecurityPolicy = async (options)=>{
    if (!(0, $9wGTI.fg)('dlp_attachment_download_respects_data_export_dsp')) return false;
    const { contentId: contentId, spaceKey: spaceKey, mediaDspContentId: mediaDspContentId } = options;
    try {
        const relevantContentId = mediaDspContentId || contentId;
        const response = await $17b0f8a5b73de479$var$cachedGetExportDspData.getValue({
            contentId: relevantContentId,
            spaceKey: spaceKey
        });
        const isExportAllowed = response?.isExportAllowed;
        return !isExportAllowed;
    } catch  {
        // Fails CLOSED
        return true;
    }
};
const $17b0f8a5b73de479$var$createViewAuthProviderDataGetter = (options)=>async (authContext)=>{
        const contentIdFromCollection = options.resolveContentIdFromCollection && !options.isExternalShare && !options.mediaToken && options.contentProduct !== 'jira-work-item' && (0, $6mKj3.expValEquals)('platform_media_token_nested_macro', 'isEnabled', true) ? $17b0f8a5b73de479$var$getContentIdFromCollection(authContext) : undefined;
        const contentId = contentIdFromCollection ?? options.contentId;
        // Only pass contentId, isExternalShare, and shareToken to the cacheWithExp function
        // to avoid unnecessary re-fetching of the token if other options differ
        const authQueryOptions = {
            contentId: contentId,
            contentAri: options.contentAri,
            contentProduct: options.contentProduct,
            isExternalShare: options.isExternalShare,
            shareToken: options.shareToken
        };
        let data = await $17b0f8a5b73de479$var$cachedGetDownloadData.getValue(authQueryOptions);
        if (options.mediaToken) data = {
            ...data,
            token: options.mediaToken
        };
        // For drafts mediaToken by default is null and created once any media added to them
        // So, once publishing draft that just got media but token was cached before as `null`
        // we need to re-fetch the token without the cache
        if (!data.token) data = await $17b0f8a5b73de479$var$cachedGetDownloadData.forceGetValue(authQueryOptions);
        return data;
    };
const $17b0f8a5b73de479$export$9891be2d4fea1436 = async (options)=>{
    return {
        enforceDataSecurityPolicy: await $17b0f8a5b73de479$var$getEnforceDataSecurityPolicy(options),
        authProvider: $17b0f8a5b73de479$export$6176af039388fdbf($17b0f8a5b73de479$var$createViewAuthProviderDataGetter(options)),
        getAuthFromContext: (contextId)=>$17b0f8a5b73de479$export$724cb324eb7535cd(contextId, options.contentProduct, options.contentAri)
    };
};
const $17b0f8a5b73de479$export$e43b4f8676d4deae = async (options)=>({
        enforceDataSecurityPolicy: await $17b0f8a5b73de479$var$getEnforceDataSecurityPolicy(options),
        authProvider: $17b0f8a5b73de479$export$da46cefd33160c4d($17b0f8a5b73de479$var$createViewAuthProviderDataGetter(options), $17b0f8a5b73de479$var$createUploadAuthProviderDataGetter(options)),
        getAuthFromContext: (contextId)=>$17b0f8a5b73de479$export$724cb324eb7535cd(contextId, options.contentProduct, options.contentAri)
    });
const $17b0f8a5b73de479$export$39c5d94533971b79 = async (options)=>({
        viewMediaClientConfig: await $17b0f8a5b73de479$export$9891be2d4fea1436(options)
    });
const $17b0f8a5b73de479$export$4887a1cde0f552dc = async (options)=>{
    $17b0f8a5b73de479$var$registerGlobalFileAddedListener(options);
    const [viewMediaClientConfig, uploadMediaClientConfig, viewAndUploadMediaClientConfig, collection] = await Promise.all([
        $17b0f8a5b73de479$export$9891be2d4fea1436(options),
        $17b0f8a5b73de479$var$getUploadMediaClientConfig(options),
        (0, $9wGTI.fg)('platform_media_video_captions') ? $17b0f8a5b73de479$export$e43b4f8676d4deae(options) : undefined,
        $17b0f8a5b73de479$var$getUploadCollectionId(options)
    ]);
    return {
        viewMediaClientConfig: viewMediaClientConfig,
        uploadParams: {
            collection: collection,
            onUploadRejection: options.onUploadRejection
        },
        uploadMediaClientConfig: uploadMediaClientConfig,
        viewAndUploadMediaClientConfig: viewAndUploadMediaClientConfig,
        renameFile: $17b0f8a5b73de479$var$createRenameFile(uploadMediaClientConfig, ()=>collection)
    };
};
const $17b0f8a5b73de479$export$c64cc28e06e9eda = (pathname)=>{
    return !!(0, $1NBp8.PDF_EXPORT_PAGE).match(pathname);
};
let $17b0f8a5b73de479$var$previousAttachUploadedMediaListener;
const $17b0f8a5b73de479$var$registerGlobalFileAddedListener = (options)=>{
    if ($17b0f8a5b73de479$var$previousAttachUploadedMediaListener) (0, $hfrng.globalMediaEventEmitter).off('file-added', $17b0f8a5b73de479$var$previousAttachUploadedMediaListener);
    $17b0f8a5b73de479$var$previousAttachUploadedMediaListener = (0, $kQiXs.attachUploadedMedia)(options);
    (0, $hfrng.globalMediaEventEmitter).on('file-added', $17b0f8a5b73de479$var$previousAttachUploadedMediaListener);
};
const $17b0f8a5b73de479$var$createViewAuthProviderDataGetterDynamic = (getOptions)=>async (authContext)=>{
        const options = getOptions();
        return $17b0f8a5b73de479$var$createViewAuthProviderDataGetter(options)(authContext);
    };
const $17b0f8a5b73de479$var$createUploadAuthProviderDataGetterDynamic = (getOptions)=>async ()=>{
        const options = getOptions();
        return $17b0f8a5b73de479$var$createUploadAuthProviderDataGetter(options)();
    };
const $17b0f8a5b73de479$export$af68076132bb2083 = async (getOptions)=>{
    const options = getOptions();
    return {
        enforceDataSecurityPolicy: await $17b0f8a5b73de479$var$getEnforceDataSecurityPolicy(options),
        authProvider: $17b0f8a5b73de479$export$6176af039388fdbf($17b0f8a5b73de479$var$createViewAuthProviderDataGetterDynamic(getOptions)),
        getAuthFromContext: (contextId)=>$17b0f8a5b73de479$export$724cb324eb7535cd(contextId, getOptions().contentProduct, getOptions().contentAri)
    };
};
const $17b0f8a5b73de479$export$de798661504725b9 = async (getOptions)=>{
    const options = getOptions();
    return {
        enforceDataSecurityPolicy: await $17b0f8a5b73de479$var$getEnforceDataSecurityPolicy(options),
        authProvider: $17b0f8a5b73de479$export$da46cefd33160c4d($17b0f8a5b73de479$var$createViewAuthProviderDataGetterDynamic(getOptions), $17b0f8a5b73de479$var$createUploadAuthProviderDataGetterDynamic(getOptions)),
        getAuthFromContext: (contextId)=>$17b0f8a5b73de479$export$724cb324eb7535cd(contextId, getOptions().contentProduct, getOptions().contentAri)
    };
};
const $17b0f8a5b73de479$export$221251ab27f63f41 = async (getOptions)=>({
        viewMediaClientConfig: await $17b0f8a5b73de479$export$af68076132bb2083(getOptions)
    });
const $17b0f8a5b73de479$export$e6a9b44aa174a3d4 = async (getOptions)=>{
    const initialOptions = getOptions();
    $17b0f8a5b73de479$var$registerGlobalFileAddedListener(initialOptions);
    // Register the global file-added listener dynamically so that SPA navigations always
    // register the attachment callback against the current page's contentId.
    const registerDynamicFileAddedListener = ()=>{
        $17b0f8a5b73de479$var$registerGlobalFileAddedListener(getOptions());
    };
    // Track the last contentId we fetched upload data for, and the cached result.
    // This lets us detect a contentId change and eagerly re-fetch before any upload.
    let lastFetchedContentId = initialOptions.contentId;
    let latestUploadData;
    // Deduplicate concurrent calls to refreshUploadDataIfNeeded — if a refresh is already
    // in-flight (e.g. from useMediaOptions and authProvider both calling simultaneously),
    // subsequent callers share the same promise rather than racing to write latestUploadData.
    let inFlightRefresh;
    // Refresh upload data for the current options if contentId has changed since the
    // last fetch. Concurrent calls are deduplicated via inFlightRefresh.
    // Called by useMediaOptions on navigation so all uploadParams.collection read sites
    // get the correct collection without needing to do anything special themselves.
    const refreshUploadDataIfNeeded = async ()=>{
        const currentOptions = getOptions();
        if (currentOptions.contentId !== lastFetchedContentId) {
            if (inFlightRefresh) return inFlightRefresh;
            inFlightRefresh = (async ()=>{
                registerDynamicFileAddedListener();
                latestUploadData = await $17b0f8a5b73de479$var$cachedGetUploadData.getValue(currentOptions);
                lastFetchedContentId = currentOptions.contentId;
                inFlightRefresh = undefined;
            })();
            return inFlightRefresh;
        }
    };
    // Build a fully-dynamic uploadMediaClientConfig whose authProvider always fetches
    // upload data for the CURRENT options so tokens stay correct across SPA navigations.
    // Note: we do NOT call registerDynamicFileAddedListener here — the listener is only
    // re-registered in refreshUploadDataIfNeeded (on actual navigation), not on every
    // token fetch, to avoid unnecessary teardown/rebuild of the module-level singleton.
    const dynamicUploadMediaClientConfig = {
        authProvider: $17b0f8a5b73de479$export$6176af039388fdbf(async ()=>{
            const currentOptions = getOptions();
            const uploadData = await $17b0f8a5b73de479$var$cachedGetUploadData.getValue(currentOptions);
            latestUploadData = uploadData;
            lastFetchedContentId = currentOptions.contentId;
            return uploadData;
        }),
        getAuthFromContext: $17b0f8a5b73de479$export$724cb324eb7535cd,
        useSha256ForUploads: true
    };
    // Fetch all async dependencies in parallel — no waterfall.
    const [viewMediaClientConfig, viewAndUploadMediaClientConfig, initialUploadData] = await Promise.all([
        $17b0f8a5b73de479$export$af68076132bb2083(()=>getOptions()),
        (0, $9wGTI.fg)('platform_media_video_captions') ? $17b0f8a5b73de479$export$de798661504725b9(()=>getOptions()) : undefined,
        $17b0f8a5b73de479$var$cachedGetUploadData.getValue(getOptions())
    ]);
    latestUploadData = initialUploadData;
    return {
        viewMediaClientConfig: viewMediaClientConfig,
        // uploadParams is resolved via a getter so SPA navigations don't leave the collection
        // frozen to the page that was active when this provider was first created.
        get uploadParams () {
            return {
                collection: latestUploadData.collectionId,
                onUploadRejection: getOptions().onUploadRejection
            };
        },
        refreshUploadDataIfNeeded: refreshUploadDataIfNeeded,
        uploadMediaClientConfig: dynamicUploadMediaClientConfig,
        viewAndUploadMediaClientConfig: viewAndUploadMediaClientConfig,
        renameFile: $17b0f8a5b73de479$var$createRenameFile(dynamicUploadMediaClientConfig, ()=>latestUploadData.collectionId)
    };
}; /**
 * Usage sketch (React):
 * const liveOptionsRef = useRef(currentOptions);
 * liveOptionsRef.current = currentOptions; // update on changes
 * const providerPromise = useMemo(() => createEditorMediaProviderDynamic(() => liveOptionsRef.current), []);
 * editorApi.media.actions.setProvider(providerPromise);
 */ 
module.exports["createAuthProvider"] = $17b0f8a5b73de479$export$6176af039388fdbf;
module.exports["getAuthFromContext"] = $17b0f8a5b73de479$export$724cb324eb7535cd;
module.exports["getViewMediaClientConfig"] = $17b0f8a5b73de479$export$9891be2d4fea1436;
module.exports["createRendererMediaProvider"] = $17b0f8a5b73de479$export$39c5d94533971b79;
module.exports["createEditorMediaProvider"] = $17b0f8a5b73de479$export$4887a1cde0f552dc;
module.exports["controlDataExportOnCertainFeatures"] = $17b0f8a5b73de479$export$c64cc28e06e9eda;
module.exports["createRendererMediaProviderDynamic"] = $17b0f8a5b73de479$export$221251ab27f63f41;
module.exports["createEditorMediaProviderDynamic"] = $17b0f8a5b73de479$export$e6a9b44aa174a3d4;

});

parcelRegister("3kI72", function(module, exports) {

var $oWJUu = parcelRequire("oWJUu");


var $55mlV = parcelRequire("55mlV");

const $515968ab7e772985$export$8953ee4427cc19a2 = ({ hostProduct: hostProduct, sourceProduct: sourceProduct })=>{
    return !!sourceProduct && sourceProduct !== hostProduct;
};
const $515968ab7e772985$export$9f88fc74c33fbfe = ({ contentAri: contentAri, contentId: contentId, sourceProduct: sourceProduct })=>{
    switch(sourceProduct){
        case 'confluence-page':
            return (0, $oWJUu.fetchMediaToken)(contentId);
        case 'jira-work-item':
            return (0, $55mlV.fetchJiraMediaToken)(contentAri);
        default:
            throw new Error(`Unsupported source product for token fetch: ${sourceProduct}`);
    }
};
module.exports["requiresCrossProductAuth"] = $515968ab7e772985$export$8953ee4427cc19a2;
module.exports["fetchTokenForSourceProduct"] = $515968ab7e772985$export$9f88fc74c33fbfe;

});

parcelRegister("oWJUu", function(module, exports) {

var $jv11C = parcelRequire("jv11C");


var $48FpT = parcelRequire("48FpT");

const $61ef070287c5800f$var$COMMON_HEADERS = {
    'Content-Type': 'application/json',
    Accept: 'application/json'
};
const $61ef070287c5800f$var$AGG_HEADERS = {
    'X-ExperimentalApi': 'confluence-agg-beta'
};
const $61ef070287c5800f$var$GRAPHQL_ENDPOINT = '/gateway/api/graphql';
const $61ef070287c5800f$var$GET_CONTENT_MEDIA_SESSION_OPERATION_NAME = 'MediaUploadTokenQuery';
const $61ef070287c5800f$var$GET_CONTENT_MEDIA_SESSION_QUERY = `query ${$61ef070287c5800f$var$GET_CONTENT_MEDIA_SESSION_OPERATION_NAME}($contentId: ID!) {
	contentMediaSession(contentId: $contentId) {
		token {
			value
		}
		configuration {
			clientId
			fileStoreUrl
		}
		collection
	}
}`;
const $61ef070287c5800f$var$getContentMediaSession = async (contentId)=>{
    const bodyData = {
        query: $61ef070287c5800f$var$GET_CONTENT_MEDIA_SESSION_QUERY,
        operationName: $61ef070287c5800f$var$GET_CONTENT_MEDIA_SESSION_OPERATION_NAME,
        variables: {
            contentId: contentId
        }
    };
    const response = await (0, $48FpT.fetchWithRetry)($61ef070287c5800f$var$GRAPHQL_ENDPOINT, {
        method: 'POST',
        headers: {
            ...$61ef070287c5800f$var$COMMON_HEADERS,
            ...$61ef070287c5800f$var$AGG_HEADERS
        },
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new Error(`Failed to get content media session: ${response.statusText}`);
    const result = await response.json();
    return result;
};
const $61ef070287c5800f$export$2b7fb70f168591f8 = async (contentId)=>{
    try {
        const response = await $61ef070287c5800f$var$getContentMediaSession(contentId);
        const contentData = response.data?.contentMediaSession;
        const token = contentData?.token?.value;
        const configuration = contentData?.configuration;
        const collection = contentData?.collection;
        if (!token || !configuration || !collection) throw new Error('Failed to get content media session data');
        return {
            config: configuration,
            token: token,
            collectionId: collection
        };
    } catch (error) {
        (0, $jv11C.logException)(error, {
            location: 'editor-synced-block-provider/fetchMediaToken'
        });
        const errorMsg = error instanceof Error ? error.message : String(error);
        throw new Error(`Failed to get content media session: ${errorMsg}`);
    }
};
module.exports["fetchMediaToken"] = $61ef070287c5800f$export$2b7fb70f168591f8;

});

parcelRegister("55mlV", function(module, exports) {

var $jv11C = parcelRequire("jv11C");


var $48FpT = parcelRequire("48FpT");


var $EBNuL = parcelRequire("EBNuL");

const $05854aa166d857a3$var$COMMON_HEADERS = {
    'Content-Type': 'application/json',
    Accept: 'application/json'
};
const $05854aa166d857a3$var$AGG_HEADERS = {
    'X-ExperimentalApi': 'confluence-agg-beta'
};
const $05854aa166d857a3$var$GRAPHQL_ENDPOINT = '/gateway/api/graphql';
const $05854aa166d857a3$var$JIRA_MEDIA_READ_TOKEN_MAX_TOKEN_LENGTH = 2048;
const $05854aa166d857a3$var$GET_JIRA_MEDIA_READ_TOKEN_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_GET_JIRA_MEDIA_TOKEN';
const $05854aa166d857a3$var$GET_JIRA_MEDIA_READ_TOKEN_QUERY = `query ${$05854aa166d857a3$var$GET_JIRA_MEDIA_READ_TOKEN_OPERATION_NAME}($issueAri: ID!, $maxTokenLength: Int!) {
  jira {
    issueById(id: $issueAri) {
      mediaReadToken(maxTokenLength: $maxTokenLength) @optIn(to: "JiraMediaReadTokenInIssue") {
        clientId
        endpointUrl
        tokenLifespanInSeconds
        tokensWithFiles {
          edges {
            node {
              token
            }
          }
        }
      }
    }
  }
}`;
const $05854aa166d857a3$var$getJiraMediaReadToken = async (issueAri)=>{
    const bodyData = {
        query: $05854aa166d857a3$var$GET_JIRA_MEDIA_READ_TOKEN_QUERY,
        operationName: $05854aa166d857a3$var$GET_JIRA_MEDIA_READ_TOKEN_OPERATION_NAME,
        variables: {
            issueAri: issueAri,
            maxTokenLength: $05854aa166d857a3$var$JIRA_MEDIA_READ_TOKEN_MAX_TOKEN_LENGTH
        }
    };
    const response = await (0, $48FpT.fetchWithRetry)($05854aa166d857a3$var$GRAPHQL_ENDPOINT, {
        method: 'POST',
        headers: {
            ...$05854aa166d857a3$var$COMMON_HEADERS,
            ...$05854aa166d857a3$var$AGG_HEADERS
        },
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new Error(`Failed to get Jira media read token: ${response.statusText}`);
    return await response.json();
};
const $05854aa166d857a3$export$5bc7dcc953e26849 = async (sourceAri)=>{
    try {
        const issueAri = (0, $EBNuL.getJiraIssueAriFromSourceAri)({
            ari: sourceAri
        });
        const response = await $05854aa166d857a3$var$getJiraMediaReadToken(issueAri);
        const mediaReadToken = response.data?.jira?.issueById?.mediaReadToken;
        const clientId = mediaReadToken?.clientId;
        const endpointUrl = mediaReadToken?.endpointUrl;
        // Use the first available token from tokensWithFiles, or fall back to empty string.
        // A generic read token (without specific file IDs) is sufficient for rendering.
        const token = mediaReadToken?.tokensWithFiles?.edges?.[0]?.node?.token ?? '';
        if (!clientId || !endpointUrl) throw new Error('Missing clientId or endpointUrl');
        return {
            config: {
                clientId: clientId,
                fileStoreUrl: endpointUrl
            },
            token: token
        };
    } catch (error) {
        (0, $jv11C.logException)(error, {
            location: 'editor-synced-block-provider/fetchJiraMediaToken'
        });
        const errorMsg = error instanceof Error ? error.message : String(error);
        throw new Error(`Failed to get Jira media read token: ${errorMsg}`);
    }
};
module.exports["fetchJiraMediaToken"] = $05854aa166d857a3$export$5bc7dcc953e26849;

});

parcelRegister("2TuWI", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $15f98e0699368f56$var$BLOCK_SERVICE_SNIPPETS_MEDIA_TOKEN_URL = '/gateway/api/blocks/v1/snippets';
const $15f98e0699368f56$export$73c71f9590626082 = async (snippetId)=>{
    try {
        const response = await (0, $f7B1p.cfetch)(`${$15f98e0699368f56$var$BLOCK_SERVICE_SNIPPETS_MEDIA_TOKEN_URL}/${snippetId}/media-token`, {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            }
        });
        const data = await response.json();
        const collectionId = data.collectionNames?.[snippetId];
        return {
            clientId: data.config.clientId,
            token: data.token,
            baseUrl: data.config.fileStoreUrl,
            ...collectionId !== undefined && {
                collectionId: collectionId
            }
        };
    } catch (error) {
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).INTEGRATIONS
        });
        throw error;
    }
};
module.exports["fetchSnippetMediaToken"] = $15f98e0699368f56$export$73c71f9590626082;

});

parcelRegister("cga1x", function(module, exports) {
/** Define the source of the snippets */ var $bd320fc30ef678ce$export$100829e61c5df591 = /*#__PURE__*/ function(SnippetScope) {
    SnippetScope["GLOBAL"] = "GLOBAL";
    SnippetScope["USER"] = "USER";
    SnippetScope["SITE"] = "SITE";
    return SnippetScope;
}({});
module.exports["SnippetScope"] = $bd320fc30ef678ce$export$100829e61c5df591;

});

parcelRegister("kzNtP", function(module, exports) {

var $6AroL = parcelRequire("6AroL");


var $3u5lg = parcelRequire("3u5lg");

const $852f3734fd3706d8$var$BUFFER_MS = 60000; // refresh token 60 seconds before it expires
const $852f3734fd3706d8$var$EMPTY = [
    -Infinity,
    null,
    null
];
function $852f3734fd3706d8$export$d18015d30d3c28a4(asyncFunction, tokenOrExpInMsAccessor, tokenExpBufferInMs = $852f3734fd3706d8$var$BUFFER_MS) {
    const cache = {};
    async function getValue(arg, force) {
        // It is ok to have clashing hash because we are going to check args anyway
        // Worse case is calling fn() more often than it should
        let hash = '';
        try {
            hash = JSON.stringify(arg);
        } catch  {}
        const [exp, lastArg, lastValue] = cache[hash] || $852f3734fd3706d8$var$EMPTY;
        if (force || exp <= Date.now() || !(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(lastArg, arg)) {
            const value = await asyncFunction(arg);
            let tokenOrExp = null;
            try {
                tokenOrExp = tokenOrExpInMsAccessor(value);
            } catch (e) {}
            let exp = null;
            if (tokenOrExp) {
                if (!isNaN(tokenOrExp)) exp = Number(tokenOrExp);
                else if (typeof tokenOrExp === 'string') try {
                    exp = (0, $6AroL.default)(tokenOrExp).exp * 1000 - tokenExpBufferInMs;
                } catch (e) {}
            }
            cache[hash] = exp === null ? $852f3734fd3706d8$var$EMPTY : [
                exp,
                arg,
                value
            ];
            return value;
        }
        return lastValue;
    }
    return {
        forceGetValue: (arg)=>{
            return getValue(arg, true);
        },
        getValue: (arg)=>{
            return getValue(arg, false);
        }
    };
}
module.exports["cacheWithExp"] = $852f3734fd3706d8$export$d18015d30d3c28a4;

});

parcelRegister("6AroL", function(module, exports) {
function $4cbb5ba451601f11$var$e(e) {
    this.message = e;
}
$4cbb5ba451601f11$var$e.prototype = new Error, $4cbb5ba451601f11$var$e.prototype.name = "InvalidCharacterError";
var $4cbb5ba451601f11$var$r = "undefined" != typeof window && window.atob && window.atob.bind(window) || function(r) {
    var t = String(r).replace(/=+$/, "");
    if (t.length % 4 == 1) throw new $4cbb5ba451601f11$var$e("'atob' failed: The string to be decoded is not correctly encoded.");
    for(var n, o, a = 0, i = 0, c = ""; o = t.charAt(i++); ~o && (n = a % 4 ? 64 * n + o : o, a++ % 4) && (c += String.fromCharCode(255 & n >> (-2 * a & 6))))o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);
    return c;
};
function $4cbb5ba451601f11$var$t(e) {
    var t = e.replace(/-/g, "+").replace(/_/g, "/");
    switch(t.length % 4){
        case 0:
            break;
        case 2:
            t += "==";
            break;
        case 3:
            t += "=";
            break;
        default:
            throw "Illegal base64url string!";
    }
    try {
        return function(e) {
            return decodeURIComponent($4cbb5ba451601f11$var$r(e).replace(/(.)/g, function(e, r) {
                var t = r.charCodeAt(0).toString(16).toUpperCase();
                return t.length < 2 && (t = "0" + t), "%" + t;
            }));
        }(t);
    } catch (e) {
        return $4cbb5ba451601f11$var$r(t);
    }
}
function $4cbb5ba451601f11$export$b9721ef022f71a68(e) {
    this.message = e;
}
function $4cbb5ba451601f11$var$o(e, r) {
    if ("string" != typeof e) throw new $4cbb5ba451601f11$export$b9721ef022f71a68("Invalid token specified");
    var o = !0 === (r = r || {}).header ? 0 : 1;
    try {
        return JSON.parse($4cbb5ba451601f11$var$t(e.split(".")[o]));
    } catch (e) {
        throw new $4cbb5ba451601f11$export$b9721ef022f71a68("Invalid token specified: " + e.message);
    }
}
$4cbb5ba451601f11$export$b9721ef022f71a68.prototype = new Error, $4cbb5ba451601f11$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
var $4cbb5ba451601f11$export$2e2bcd8739ae039 = $4cbb5ba451601f11$var$o;
 //# sourceMappingURL=jwt-decode.esm.js.map
module.exports["default"] = $4cbb5ba451601f11$export$2e2bcd8739ae039;

});

parcelRegister("c4QoG", function(module, exports) {

var $kzNtP = parcelRequire("kzNtP");


var $4IoVL = parcelRequire("4IoVL");


var $7EQEd = parcelRequire("7EQEd");

// blueprints/templates in uuid form are technically a new template
const $30f3da79b755ac50$var$isBlueprint = (templateId)=>!/^[0-9]+$/.test(templateId);
const $30f3da79b755ac50$var$isNewTemplate = (templateId)=>!templateId || templateId === '';
const $30f3da79b755ac50$var$shouldUseTemplateId = (templateIds)=>templateIds.length;
const $30f3da79b755ac50$var$formatTemplateId = (templateId, isFirstLoad, isUpload)=>{
    if ($30f3da79b755ac50$var$isNewTemplate(templateId) || $30f3da79b755ac50$var$isBlueprint(templateId) && isUpload || !isFirstLoad) return [];
    else return [
        templateId
    ];
};
const $30f3da79b755ac50$var$cachedGetTemplateUploadData = (0, $kzNtP.cacheWithExp)(async (options)=>{
    const response = await (0, $7EQEd.getTemplateUploadToken)({
        spaceKey: options.spaceKey,
        templateIds: options.templateIds,
        collectionId: options.collectionId
    });
    const session = response?.data?.templateMediaSession;
    const collectionId = session?.collections?.[0]?.value || '';
    return {
        token: session?.uploadToken?.value || '',
        config: session?.configuration || {
            fileStoreUrl: '',
            clientId: ''
        },
        collectionId: collectionId
    };
}, (json)=>json.token);
const $30f3da79b755ac50$var$cachedGetTemplateDownloadData = (0, $kzNtP.cacheWithExp)(async (options)=>{
    const response = await (0, $7EQEd.getTemplateDownloadToken)({
        spaceKey: options.spaceKey,
        templateIds: options.templateIds,
        collectionId: options.collectionId
    });
    return {
        token: response?.data?.templateMediaSession?.downloadToken?.value || '',
        config: response?.data?.templateMediaSession?.configuration || {
            fileStoreUrl: '',
            clientId: ''
        }
    };
}, (json)=>json.token);
const $30f3da79b755ac50$export$ea5d75839efa2930 = async (editorOptions)=>{
    const templateIds = $30f3da79b755ac50$var$formatTemplateId(editorOptions.templateId, !editorOptions.collectionId, true);
    const uploadData = await $30f3da79b755ac50$var$cachedGetTemplateUploadData.getValue({
        ...editorOptions,
        templateIds: templateIds,
        collectionId: $30f3da79b755ac50$var$shouldUseTemplateId(templateIds) ? null : editorOptions.collectionId
    });
    return uploadData.collectionId;
};
const $30f3da79b755ac50$export$8867d7a854cea94a = (contextId)=>{
    let collectionId, templateId, spaceKey = null;
    try {
        ({ collectionId: collectionId, templateId: templateId, spaceKey: spaceKey } = JSON.parse(contextId));
    } catch (_) {}
    return {
        collectionId: collectionId,
        templateId: templateId,
        spaceKey: spaceKey
    };
};
const $30f3da79b755ac50$export$c52d46b5239d3052 = async ({ templateId: templateId, collectionId: collectionId, spaceKey: spaceKey })=>{
    // if given a templateId the source is the renderer, otherwise it's the editor
    const response = await (0, $7EQEd.getTemplateDownloadToken)({
        templateIds: templateId ? [
            templateId
        ] : [],
        collectionId: templateId ? null : collectionId,
        spaceKey: spaceKey
    });
    const { clientId: clientId = '', fileStoreUrl: fileStoreUrl = '' } = response?.data?.templateMediaSession?.configuration || {};
    return {
        clientId: clientId,
        token: response?.data?.templateMediaSession?.downloadToken?.value || '',
        baseUrl: fileStoreUrl
    };
};
const $30f3da79b755ac50$var$getAuthFromContext = async (contextId)=>{
    const { collectionId: collectionId, templateId: templateId, spaceKey: spaceKey } = $30f3da79b755ac50$export$8867d7a854cea94a(contextId);
    // templateID = null/undefined -> not template type
    // templateId = "" -> new template
    // templateId = "2394234324" -> user modified template
    // templateId = "23j4h-23jk4h-kj2h34-kj23h4" -> new template
    if (typeof collectionId !== 'string' && typeof templateId !== 'string') // copy source is page contentType
    return (0, $4IoVL.getAuthFromContext)(contextId);
    return $30f3da79b755ac50$export$c52d46b5239d3052({
        collectionId: collectionId,
        spaceKey: spaceKey,
        templateId: templateId
    });
};
const $30f3da79b755ac50$export$e7a68a11bc740f17 = (options)=>{
    return {
        authProvider: (0, $4IoVL.createAuthProvider)(async ()=>$30f3da79b755ac50$var$cachedGetTemplateDownloadData.getValue(options)),
        getAuthFromContext: $30f3da79b755ac50$var$getAuthFromContext
    };
};
const $30f3da79b755ac50$export$4f3a63958bc8e871 = (options)=>{
    return Promise.resolve({
        viewMediaClientConfig: $30f3da79b755ac50$export$e7a68a11bc740f17(options)
    });
};
const $30f3da79b755ac50$export$582e7673a587f23a = async (options)=>{
    let isFirstDownload = true;
    let collectionId = options.collectionId;
    const getEditorViewTemplateMediaClientConfig = (editorOptions)=>{
        return {
            authProvider: (0, $4IoVL.createAuthProvider)(async ()=>{
                const templateIds = $30f3da79b755ac50$var$formatTemplateId(editorOptions.templateId, isFirstDownload, false);
                isFirstDownload = false;
                return $30f3da79b755ac50$var$cachedGetTemplateDownloadData.getValue({
                    ...editorOptions,
                    templateIds: templateIds,
                    collectionId: $30f3da79b755ac50$var$shouldUseTemplateId(templateIds) ? null : collectionId
                });
            }),
            getAuthFromContext: (context)=>{
                isFirstDownload = false;
                return $30f3da79b755ac50$var$getAuthFromContext(context);
            }
        };
    };
    const getTemplateMediaUploadMediaClientConfig = (editorOptions)=>{
        return {
            authProvider: (0, $4IoVL.createAuthProvider)(()=>{
                const templateIds = $30f3da79b755ac50$var$formatTemplateId(editorOptions.templateId, !collectionId, true);
                return $30f3da79b755ac50$var$cachedGetTemplateUploadData.getValue({
                    ...editorOptions,
                    templateIds: templateIds,
                    collectionId: $30f3da79b755ac50$var$shouldUseTemplateId(templateIds) ? null : collectionId
                });
            }),
            getAuthFromContext: (context)=>{
                return $30f3da79b755ac50$var$getAuthFromContext(context);
            }
        };
    };
    const viewMediaClientConfig = getEditorViewTemplateMediaClientConfig(options);
    const uploadMediaClientConfig = getTemplateMediaUploadMediaClientConfig(options);
    const collection = await $30f3da79b755ac50$export$ea5d75839efa2930(options);
    collectionId = collection || null;
    return {
        viewMediaClientConfig: viewMediaClientConfig,
        uploadParams: {
            collection: collection,
            onUploadRejection: options.onUploadRejection
        },
        uploadMediaClientConfig: uploadMediaClientConfig
    };
};
module.exports["getTemplateUploadCollectionId"] = $30f3da79b755ac50$export$ea5d75839efa2930;
module.exports["getTemplateMediaContextValues"] = $30f3da79b755ac50$export$8867d7a854cea94a;
module.exports["getTemplateMediaAuth"] = $30f3da79b755ac50$export$c52d46b5239d3052;
module.exports["createRendererTemplateMediaProvider"] = $30f3da79b755ac50$export$4f3a63958bc8e871;
module.exports["createTemplateEditorMediaProvider"] = $30f3da79b755ac50$export$582e7673a587f23a;

});

parcelRegister("7EQEd", function(module, exports) {

var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $6UhpO = parcelRequire("6UhpO");


var $23pnW = parcelRequire("23pnW");


var $c0rhi = parcelRequire("c0rhi");

const $bced78bb0973f66e$export$852d9acd488f2352 = async ({ spaceKey: spaceKey, templateIds: templateIds, collectionId: collectionId = null })=>{
    return (0, $c0rhi.queryInterop)({
        query: (0, $6UhpO.default),
        variables: {
            spaceKey: spaceKey || null,
            templateIds: templateIds,
            collectionId: collectionId
        },
        fetchPolicy: 'network-only',
        __callerPackage__: "fabric-media-support"
    }).catch((error)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).PAGE_MODES
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        return undefined;
    });
};
const $bced78bb0973f66e$export$779a7b38112a4dbb = async ({ spaceKey: spaceKey, templateIds: templateIds, collectionId: collectionId = null })=>{
    return (0, $c0rhi.queryInterop)({
        query: (0, $23pnW.default),
        variables: {
            spaceKey: spaceKey || null,
            templateIds: templateIds,
            collectionId: collectionId
        },
        fetchPolicy: 'no-cache',
        __callerPackage__: "fabric-media-support"
    }).catch((error)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).PAGE_MODES
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        return undefined;
    });
};
module.exports["getTemplateDownloadToken"] = $bced78bb0973f66e$export$852d9acd488f2352;
module.exports["getTemplateUploadToken"] = $bced78bb0973f66e$export$779a7b38112a4dbb;

});

parcelRegister("6UhpO", function(module, exports) {
/**
 * @generated SignedSource<<6f71e30a6f3ff9ae17bdb70469621c47>>
 * @relayHash 7da80c4186ab379cb41cda405bebee65
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b087f1d76c63fdcc9767cdf0710dfa4efaf3f7db7a96f39d1b7b4eef575b40c1
const $ba0dcc1d393f4102$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "collectionId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "templateIds"
    }, v3 = {
        "kind": "ScalarField",
        "name": "value"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "collectionId",
                    "variableName": "collectionId"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "templateIds",
                    "variableName": "templateIds"
                }
            ],
            "concreteType": "TemplateMediaSession",
            "kind": "LinkedField",
            "name": "templateMediaSession",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MapOfStringToString",
                    "kind": "LinkedField",
                    "name": "collections",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "MediaConfiguration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "fileStoreUrl"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "clientId"
                        }
                    ]
                },
                {
                    "concreteType": "TemplateMediaToken",
                    "kind": "LinkedField",
                    "name": "downloadToken",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "duration"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "TemplateMediaSessionDownloadQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "TemplateMediaSessionDownloadQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "7da80c4186ab379cb41cda405bebee65",
            "id": "b087f1d76c63fdcc9767cdf0710dfa4efaf3f7db7a96f39d1b7b4eef575b40c1",
            "metadata": {},
            "name": "TemplateMediaSessionDownloadQuery",
            "operationKind": "query",
            "text": "query TemplateMediaSessionDownloadQuery($spaceKey:String,$templateIds:[String]!,$collectionId:String){templateMediaSession(spaceKey:$spaceKey,templateIds:$templateIds,collectionId:$collectionId){collections{key,value},configuration{fileStoreUrl,clientId},downloadToken{value,duration}}}"
        }
    };
}();
$ba0dcc1d393f4102$var$node.hash = "cb69ec0c674b12c3415c2289771f970f";
var $ba0dcc1d393f4102$export$2e2bcd8739ae039 = $ba0dcc1d393f4102$var$node;
module.exports["default"] = $ba0dcc1d393f4102$export$2e2bcd8739ae039;

});

parcelRegister("23pnW", function(module, exports) {
/**
 * @generated SignedSource<<d8493d612cba7ab67c2663a1ef2f2968>>
 * @relayHash f5528f55bdab5a02587ef6cd5262334d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7ce5237137eaa73015ff248d0a763c44e037f18ed58c1bb4ff3b73e41cc13059
const $d22835c5674bcb0e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "collectionId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "templateIds"
    }, v3 = {
        "kind": "ScalarField",
        "name": "value"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "collectionId",
                    "variableName": "collectionId"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "templateIds",
                    "variableName": "templateIds"
                }
            ],
            "concreteType": "TemplateMediaSession",
            "kind": "LinkedField",
            "name": "templateMediaSession",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MapOfStringToString",
                    "kind": "LinkedField",
                    "name": "collections",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "MediaConfiguration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "fileStoreUrl"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "clientId"
                        }
                    ]
                },
                {
                    "concreteType": "TemplateMediaToken",
                    "kind": "LinkedField",
                    "name": "uploadToken",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "duration"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "TemplateMediaSessionUploadQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "TemplateMediaSessionUploadQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "f5528f55bdab5a02587ef6cd5262334d",
            "id": "7ce5237137eaa73015ff248d0a763c44e037f18ed58c1bb4ff3b73e41cc13059",
            "metadata": {},
            "name": "TemplateMediaSessionUploadQuery",
            "operationKind": "query",
            "text": "query TemplateMediaSessionUploadQuery($spaceKey:String,$templateIds:[String]!,$collectionId:String){templateMediaSession(spaceKey:$spaceKey,templateIds:$templateIds,collectionId:$collectionId){collections{key,value},configuration{fileStoreUrl,clientId},uploadToken{value,duration}}}"
        }
    };
}();
$d22835c5674bcb0e$var$node.hash = "1d0108dcbf48addfcc8b1c4145c7178d";
var $d22835c5674bcb0e$export$2e2bcd8739ae039 = $d22835c5674bcb0e$var$node;
module.exports["default"] = $d22835c5674bcb0e$export$2e2bcd8739ae039;

});

parcelRegister("I0A3i", function(module, exports) {

var $6IsMq = parcelRequire("6IsMq");


var $3j8TZ = parcelRequire("3j8TZ");


var $iTcHJ = parcelRequire("iTcHJ");


var $bS81H = parcelRequire("bS81H");


var $1UWNP = parcelRequire("1UWNP");


var $6AroL = parcelRequire("6AroL");


var $7Sm4c = parcelRequire("7Sm4c");


var $aMcHK = parcelRequire("aMcHK");


var $9wGTI = parcelRequire("9wGTI");


var $c0rhi = parcelRequire("c0rhi");


var $lUobS = parcelRequire("lUobS");


var $62FVQ = parcelRequire("62FVQ");


var $6mmMU = parcelRequire("6mmMU");


var $egLSs = parcelRequire("egLSs");


var $dqLCu = parcelRequire("dqLCu");

const $1fd47ba2b01e31e6$var$DSPIsActionEnabledForContentQuery = (0, $bS81H.default);
const $1fd47ba2b01e31e6$var$FetchMediaTokenQuery = (0, $iTcHJ.default);
const $1fd47ba2b01e31e6$export$96b44174d5bb0faa = (0, $3j8TZ.default);
const $1fd47ba2b01e31e6$var$JiraFetchMediaTokenQuery = (0, $6IsMq.default);
let $1fd47ba2b01e31e6$var$isFirstLoad = true;
const $1fd47ba2b01e31e6$export$f3bf3f7b03608218 = (requestBody)=>{
    if (requestBody.contentType === 'comment') // Hard disable drag-and-drop upload functionality for comments
    return;
    // Normal uploads (file browser, copy-paste, etc.) go through the regular upload mutation.
    return (0, $egLSs.experimentalFileUploadMutate)({
        variables: requestBody
    });
};
const $1fd47ba2b01e31e6$export$2b7fb70f168591f8 = (contentId)=>(0, $c0rhi.queryInterop)({
        query: $1fd47ba2b01e31e6$var$FetchMediaTokenQuery,
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft',
                'archived'
            ],
            missingContentId: !contentId
        },
        context: {
            allowOnExternalPage: true
        },
        // If SSR has populated the cache then we want to use the cache when rendering SPA-over-SSR
        fetchPolicy: $1fd47ba2b01e31e6$var$isFirstLoad ? 'cache-first' : 'network-only',
        __callerPackage__: "fabric-media-support"
    }).then(/* onFulfilled */ (value)=>{
        $1fd47ba2b01e31e6$var$isFirstLoad = false;
        try {
            $1fd47ba2b01e31e6$var$throttleFetchMediaTokenErrors(contentId)(value?.error?.graphQLErrors);
        } catch  {}
        return value;
    }, /* onRejected */ (reason)=>{
        try {
            $1fd47ba2b01e31e6$var$throttleFetchMediaTokenErrors(contentId)(reason?.graphQLErrors, reason?.networkError);
        } catch  {}
        throw reason;
    });
let $1fd47ba2b01e31e6$var$isFirstLoadJira = true;
const $1fd47ba2b01e31e6$export$5bc7dcc953e26849 = (issueAri)=>(0, $c0rhi.queryInterop)({
        query: $1fd47ba2b01e31e6$var$JiraFetchMediaTokenQuery,
        variables: {
            issueAri: issueAri,
            maxTokenLength: 65536
        },
        context: {
            allowOnExternalPage: true
        },
        // If SSR has populated the cache then we want to use the cache when rendering SPA-over-SSR
        fetchPolicy: $1fd47ba2b01e31e6$var$isFirstLoadJira ? 'cache-first' : 'network-only',
        __callerPackage__: "fabric-media-support"
    }).then(/* onFulfilled */ (value)=>{
        $1fd47ba2b01e31e6$var$isFirstLoadJira = false;
        try {
            $1fd47ba2b01e31e6$var$throttleFetchMediaTokenErrors(issueAri)(value?.error?.graphQLErrors);
        } catch  {}
        return value;
    }, /* onRejected */ (reason)=>{
        try {
            $1fd47ba2b01e31e6$var$throttleFetchMediaTokenErrors(issueAri)(reason?.graphQLErrors, reason?.networkError);
        } catch  {}
        throw reason;
    });
/**
 * `fetchMediaToken` is called repetitively to renew the token before it
 * expires. If an error condition arises (because of frontend or backend), the
 * same error(s) may be reported as unhandled to our analytics and monitoring at
 * a very high rate/volume. Such repetitive reporting fron one user in one tab
 * is noisy. `throttleFetchMediaTokenErrors` attempts to reduce the noise.
 */ const $1fd47ba2b01e31e6$var$throttleFetchMediaTokenErrors = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((_cacheKey)=>{
    /**
   * The errors that happened last time. The `GraphQLError` instances are big
   * and are not trivial to compare so `prevErrors` caches partial info.
   */ let prevErrors = undefined;
    return (graphQLErrors, networkError)=>{
        // Each of `graphQLErrors` and `networkError` are reported to analytics and
        // monitoring so type of `Error` does not matter to what follows and
        // `GraphQLError` is the most convenient TypeScript type to deal with.
        if (networkError) graphQLErrors = (graphQLErrors || []).concat(networkError);
        if (graphQLErrors) {
            /**
       * The new/current errors which will become `prevErrors` at the end of
       * this iteration.
       */ const nextErrors = {};
            for (const graphQLError of graphQLErrors){
                // Extract the partial, easy-to-compare, cachable info from the big
                // `GraphQLError` instance:
                const message = graphQLError.message || String(graphQLError) || graphQLError.originalError?.message || String(graphQLError.originalError);
                const { path: path } = graphQLError;
                const key = Array.isArray(path) && path.join('.') || message;
                if (key) {
                    const value = (0, $aMcHK.getStatusCode)(graphQLError) || message;
                    if (value) {
                        nextErrors[key] = value;
                        // If a similar error happened in the previous iteration, do not
                        // report it to analytics and monitoring again:
                        if (prevErrors?.[key] === value) (0, $7Sm4c.markErrorAsHandled)(graphQLError);
                    }
                }
            }
            prevErrors = nextErrors;
        } else // If `MediaDownloadTokenQuery` succeeds, report subsequent/future errors
        // even if similar ones occurred and were reported before the current
        // success - there is a meaningful change in state and it may be useful in
        // debugging.
        prevErrors = undefined;
    };
});
const $1fd47ba2b01e31e6$export$e5e77dc812ab6e52 = (contentId)=>(0, $c0rhi.queryInterop)({
        query: (0, $lUobS.default),
        variables: {
            contentId: contentId
        },
        context: {
            allowOnExternalPage: true
        },
        fetchPolicy: 'network-only',
        __callerPackage__: "fabric-media-support"
    });
const $1fd47ba2b01e31e6$export$db4c125247d46dd = (shareToken)=>(0, $c0rhi.queryInterop)({
        query: (0, $dqLCu.default),
        variables: {
            shareToken: shareToken
        },
        context: {
            allowOnExternalPage: true
        },
        fetchPolicy: 'network-only',
        __callerPackage__: "fabric-media-support"
    });
const $1fd47ba2b01e31e6$export$2b96f2ad626f63d2 = (contentId)=>(0, $c0rhi.queryInterop)({
        query: (0, $62FVQ.default),
        variables: {
            contentId: contentId
        },
        fetchPolicy: 'no-cache',
        __callerPackage__: "fabric-media-support"
    });
const $1fd47ba2b01e31e6$export$de87322aceb1e609 = async (contentId)=>{
    if (!(0, $9wGTI.fg)('confluence-media-upload-token-cache')) return $1fd47ba2b01e31e6$export$2b96f2ad626f63d2(contentId);
    try {
        const { data: data } = await (0, $c0rhi.queryInterop)({
            query: (0, $62FVQ.default),
            variables: {
                contentId: contentId
            },
            fetchPolicy: 'cache-first',
            __callerPackage__: "fabric-media-support"
        });
        const token = data?.contentMediaSession?.token?.value;
        if (token) {
            const { exp: exp } = (0, $6AroL.default)(token);
            const currentTime = Math.floor(Date.now() / 1000);
            // Check if the token has not expired
            if (exp > currentTime) return {
                data: data
            };
        }
    } catch  {
    // Fall through to refetch on decode failure
    }
    // Refetch with network-only policy if token is expired, or invalid
    return (0, $c0rhi.queryInterop)({
        query: (0, $62FVQ.default),
        variables: {
            contentId: contentId
        },
        fetchPolicy: 'network-only',
        __callerPackage__: "fabric-media-support"
    });
};
const $1fd47ba2b01e31e6$export$4205291ac54c446e = async (contentId, cloudId)=>{
    try {
        const { data: data } = await (0, $c0rhi.queryInterop)({
            query: (0, $6mmMU.default),
            variables: {
                cloudId: cloudId,
                contentId: contentId
            },
            fetchPolicy: 'cache-first',
            __callerPackage__: "fabric-media-support"
        });
        const token = data?.contentMediaSession?.token?.value;
        if (token) {
            const { exp: exp } = (0, $6AroL.default)(token);
            const currentTime = Math.floor(Date.now() / 1000);
            // Check if the token has not expired
            if (exp > currentTime) return {
                data: data
            };
        }
    } catch  {
    // Fall through to refetch on decode failure
    }
    // Refetch with network-only policy if token is expired, or invalid
    return (0, $c0rhi.queryInterop)({
        query: (0, $6mmMU.default),
        variables: {
            cloudId: cloudId,
            contentId: contentId
        },
        fetchPolicy: 'network-only',
        __callerPackage__: "fabric-media-support"
    });
};
const $1fd47ba2b01e31e6$export$4777fc7c5d601381 = (contentId, spaceKey)=>{
    const variables = {
        action: 'ATTACHMENT_DOWNLOAD',
        contentId: contentId,
        contentStatus: 'CURRENT',
        contentVersion: 1,
        ...spaceKey && {
            spaceKey: spaceKey
        }
    };
    /* Note -> a relay-compatible replacement is available in the @confluence/data-security package.
   * Using queryInterop for compatibility with Relay migration
   */ return (0, $c0rhi.queryInterop)({
        query: $1fd47ba2b01e31e6$var$DSPIsActionEnabledForContentQuery,
        variables: variables,
        context: {
            allowOnExternalPage: true
        },
        fetchPolicy: 'cache-first',
        __callerPackage__: "fabric-media-support"
    });
};
module.exports["setAttachment"] = $1fd47ba2b01e31e6$export$f3bf3f7b03608218;
module.exports["fetchMediaToken"] = $1fd47ba2b01e31e6$export$2b7fb70f168591f8;
module.exports["fetchExternalShareMediaToken"] = $1fd47ba2b01e31e6$export$e5e77dc812ab6e52;
module.exports["fetchExternalContentMediaSessionToken"] = $1fd47ba2b01e31e6$export$db4c125247d46dd;
module.exports["getUploadToken"] = $1fd47ba2b01e31e6$export$de87322aceb1e609;
module.exports["getCommentUploadToken"] = $1fd47ba2b01e31e6$export$4205291ac54c446e;
module.exports["getIsExportEnabledForContent"] = $1fd47ba2b01e31e6$export$4777fc7c5d601381;

});

parcelRegister("lUobS", function(module, exports) {
/**
 * @generated SignedSource<<57e8668d9fe3c9f67ee75bb15b6e474f>>
 * @relayHash ea7172d4f00c5846ec23ab207abff057
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID def5df9707285fd6e6ce8403c4b6e14be14ec1bc83092c3a8315bd1cae3d8b6e
const $2624e38a54eebf0f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ContentBodyPerRepresentation",
                    "kind": "LinkedField",
                    "name": "body",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentBody",
                            "kind": "LinkedField",
                            "name": "atlas_doc_format",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "EmbeddedMediaToken",
                                    "kind": "LinkedField",
                                    "name": "mediaToken",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "token"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "MediaConfiguration",
            "kind": "LinkedField",
            "name": "mediaConfiguration",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "clientId"
                },
                {
                    "kind": "ScalarField",
                    "name": "fileStoreUrl"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ExternalShareMediaDownloadTokenQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ExternalShareMediaDownloadTokenQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "ea7172d4f00c5846ec23ab207abff057",
            "id": "def5df9707285fd6e6ce8403c4b6e14be14ec1bc83092c3a8315bd1cae3d8b6e",
            "metadata": {},
            "name": "ExternalShareMediaDownloadTokenQuery",
            "operationKind": "query",
            "text": "query ExternalShareMediaDownloadTokenQuery($contentId:ID!){singleContent(id:$contentId){id,body{atlas_doc_format{mediaToken{token}}}},mediaConfiguration{clientId,fileStoreUrl}}"
        }
    };
}();
$2624e38a54eebf0f$var$node.hash = "3592e1b2dcd3aa2c38a177d9b363dafe";
var $2624e38a54eebf0f$export$2e2bcd8739ae039 = $2624e38a54eebf0f$var$node;
module.exports["default"] = $2624e38a54eebf0f$export$2e2bcd8739ae039;

});

parcelRegister("62FVQ", function(module, exports) {
/**
 * @generated SignedSource<<025b00e9b31b73f237130d2a69699587>>
 * @relayHash 20688ce23e5e858cfc82d72bb57f43b8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6675bb1797e9ac9206231ded11f5893e0128fe48eaeb5c3ee4b3024ed69be54c
const $15e95f80a91466f9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ContentMediaSession",
            "kind": "LinkedField",
            "name": "contentMediaSession",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MediaToken",
                    "kind": "LinkedField",
                    "name": "token",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                },
                {
                    "concreteType": "MediaConfiguration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "clientId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "fileStoreUrl"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "collection"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "MediaUploadTokenQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "MediaUploadTokenQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "20688ce23e5e858cfc82d72bb57f43b8",
            "id": "6675bb1797e9ac9206231ded11f5893e0128fe48eaeb5c3ee4b3024ed69be54c",
            "metadata": {},
            "name": "MediaUploadTokenQuery",
            "operationKind": "query",
            "text": "query MediaUploadTokenQuery($contentId:ID!){contentMediaSession(contentId:$contentId){token{value},configuration{clientId,fileStoreUrl},collection}}"
        }
    };
}();
$15e95f80a91466f9$var$node.hash = "1f89a4aaada59e040e6317ae1cdc704c";
var $15e95f80a91466f9$export$2e2bcd8739ae039 = $15e95f80a91466f9$var$node;
module.exports["default"] = $15e95f80a91466f9$export$2e2bcd8739ae039;

});

parcelRegister("6mmMU", function(module, exports) {
/**
 * @generated SignedSource<<daf984ad5eaae28ba5768f141c1480ac>>
 * @relayHash c06482aa2ab100620d21019ae889668d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6f18fbd3655dc7d982b17a901a58731161062354f5b6b10a2c133f035fcb7e37
const $39c17bb60e74ced3$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "alias": "contentMediaSession",
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ContentMediaSession",
            "kind": "LinkedField",
            "name": "confluence_commentMediaSession",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MediaToken",
                    "kind": "LinkedField",
                    "name": "token",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                },
                {
                    "concreteType": "MediaConfiguration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "clientId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "fileStoreUrl"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "collection"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "MediaUploadTokenQueryCommentQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "MediaUploadTokenQueryCommentQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "c06482aa2ab100620d21019ae889668d",
            "id": "6f18fbd3655dc7d982b17a901a58731161062354f5b6b10a2c133f035fcb7e37",
            "metadata": {},
            "name": "MediaUploadTokenQueryCommentQuery",
            "operationKind": "query",
            "text": "query MediaUploadTokenQueryCommentQuery($cloudId:ID!,$contentId:ID!){contentMediaSession:confluence_commentMediaSession(cloudId:$cloudId,contentId:$contentId){token{value},configuration{clientId,fileStoreUrl},collection}}"
        }
    };
}();
$39c17bb60e74ced3$var$node.hash = "ecbc3538cd4e4434bac2e03ab7969cd8";
var $39c17bb60e74ced3$export$2e2bcd8739ae039 = $39c17bb60e74ced3$var$node;
module.exports["default"] = $39c17bb60e74ced3$export$2e2bcd8739ae039;

});

parcelRegister("egLSs", function(module, exports) {

var $4GGNn = parcelRequire("4GGNn");


var $aBfpe = parcelRequire("aBfpe");

const $7fce44bdcdfe3fe8$export$1b01a64a392afa44 = ({ variables: variables })=>{
    return (0, $4GGNn.experimentalMutate)({
        url: `/wiki/rest/drag-and-drop/1/filestore/upload`,
        method: 'POST',
        body: JSON.stringify(variables),
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        variables: variables,
        parseResult: ()=>({
                experimentalFileUpload: true
            })
    });
};
module.exports["experimentalFileUploadMutate"] = $7fce44bdcdfe3fe8$export$1b01a64a392afa44;

});

parcelRegister("dqLCu", function(module, exports) {
/**
 * @generated SignedSource<<4edd735d079b37bb48067afaa74a4066>>
 * @relayHash c64eff3bdc2352e89d29fc9d40e39f79
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0383b95992e0b08fce6e9726b252b827c2a925f54a0ef8d6bdc7d88c65deb255
const $b85e553ccc70de04$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shareToken"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "shareToken",
                    "variableName": "shareToken"
                }
            ],
            "concreteType": "ContentMediaSession",
            "kind": "LinkedField",
            "name": "externalContentMediaSession",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MediaAccessTokens",
                    "kind": "LinkedField",
                    "name": "accessTokens",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "MediaToken",
                            "kind": "LinkedField",
                            "name": "readOnlyToken",
                            "plural": false,
                            "selections": v1 /*: any*/ 
                        },
                        {
                            "concreteType": "MediaToken",
                            "kind": "LinkedField",
                            "name": "readWriteToken",
                            "plural": false,
                            "selections": v1 /*: any*/ 
                        }
                    ]
                },
                {
                    "concreteType": "MediaConfiguration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "fileStoreUrl"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "clientId"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ExternalContentMediaSessionQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ExternalContentMediaSessionQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "c64eff3bdc2352e89d29fc9d40e39f79",
            "id": "0383b95992e0b08fce6e9726b252b827c2a925f54a0ef8d6bdc7d88c65deb255",
            "metadata": {},
            "name": "ExternalContentMediaSessionQuery",
            "operationKind": "query",
            "text": "query ExternalContentMediaSessionQuery($shareToken:String!){externalContentMediaSession(shareToken:$shareToken){accessTokens{readOnlyToken{value},readWriteToken{value}},configuration{fileStoreUrl,clientId}}}"
        }
    };
}();
$b85e553ccc70de04$var$node.hash = "73d645a33a55cbb7625d57b6d5cf2a1a";
var $b85e553ccc70de04$export$2e2bcd8739ae039 = $b85e553ccc70de04$var$node;
module.exports["default"] = $b85e553ccc70de04$export$2e2bcd8739ae039;

});

parcelRegister("kQiXs", function(module, exports) {

var $I0A3i = parcelRequire("I0A3i");

const $c59debd6932d7898$var$noop = ()=>{};
const $c59debd6932d7898$export$ad897c91dfb246e9 = (options)=>{
    if (options.contentId && options.contentType) return (file)=>{
        const { id: id, name: name, size: size, mimeType: mimeType } = file;
        const { contentId: contentId, contentType: contentType } = options;
        const requestBody = {
            size: size,
            contentType: contentType,
            mimeType: mimeType,
            fileName: name,
            pageId: contentId,
            fileStoreId: id,
            minorEdit: true,
            renderEditorHTML: false,
            collectionName: `contentId-${contentId}`,
            uploadSource: 'fabric-editor'
        };
        (0, $I0A3i.setAttachment)(requestBody);
    };
    else return $c59debd6932d7898$var$noop;
};
module.exports["attachUploadedMedia"] = $c59debd6932d7898$export$ad897c91dfb246e9;

});

parcelRegister("bumSD", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $5hJlu = parcelRequire("5hJlu");


var $bp86Z = parcelRequire("bp86Z");

const $226eb0cd9c5c41b1$var$DIRECTORY_GRAPHQL_PATH = '/gateway/api/directory/graphql';
const $226eb0cd9c5c41b1$var$USER_PROFILE_CONFIG = {
    url: $226eb0cd9c5c41b1$var$DIRECTORY_GRAPHQL_PATH,
    cacheSize: 100,
    cacheMaxAge: 300000 // - 5 minutes
};
const $226eb0cd9c5c41b1$export$441fd008df03d370 = (0, $dOBRD.default)((cloudId, _)=>{
    const profileClientConfig = {
        ...$226eb0cd9c5c41b1$var$USER_PROFILE_CONFIG,
        productIdentifier: 'confluence',
        cloudId: cloudId
    };
    return new (0, $5hJlu.ProfileClient)(profileClientConfig, {
        userClient: new (0, $bp86Z.UserProfileClientForConfluence)(profileClientConfig)
    });
});
module.exports["getProfileClient"] = $226eb0cd9c5c41b1$export$441fd008df03d370;

});

parcelRegister("bp86Z", function(module, exports) {

var $34knR = parcelRequire("34knR");


var $9fywD = parcelRequire("9fywD");


var $7lu50 = parcelRequire("7lu50");


var $ldOrZ = parcelRequire("ldOrZ");


var $2A84u = parcelRequire("2A84u");


var $9jSPN = parcelRequire("9jSPN");


var $c0rhi = parcelRequire("c0rhi");

class $e0ed8187aad1d5de$export$8e0680112f77975e extends (0, $34knR.default) {
    async makeRequest(cloudId, userId) {
        // Note because we are only subclassing "makeRequest()", we are still using UserProfileClient's
        // default "getProfile()" function - which means we automatically get the standard
        // UserProfileClient caching of the full user profile data, including our added properties
        (0, $9jSPN.PROFILE_CARD_QUERY_METRIC).start();
        const UserProfileClientForConfluencePromise = (0, $c0rhi.queryInterop)({
            query: (0, $2A84u.UserProfileClientForConfluenceQuery),
            variables: {
                userId: userId
            },
            __callerPackage__: "profile"
        });
        // If the standard user data query fails, we want to reject the returned promise because there
        // won't be any data for the caller to make a useful ProfileCard.  But if the standard user
        // data query succeeds but External Collaboration data query fails, we want to still display
        // the ProfileCard with the standard user data (that is, we don't want to reject).  In order to
        // do this, we can't use "Promise.all()" because it will return immediately when any of its
        // requests fail.  Instead we need to wait until all of the requests complete or fail, and that
        // means using "Promise.allSettled()", which has a much more complicated return object.
        const [userProfileClientForConfluenceQueryResult, standardUserDataResult] = await Promise.allSettled([
            UserProfileClientForConfluencePromise,
            super.makeRequest(cloudId, userId)
        ]);
        if (standardUserDataResult.status === 'rejected') {
            (0, $9jSPN.PROFILE_CARD_QUERY_METRIC).stop({
                customData: {
                    success: false
                }
            });
            return Promise.reject(standardUserDataResult.reason);
        }
        // If the External Collaboration query was successful and External Collaboration is entitled
        // and this user is an External user, then add our custom Lozenge to the standard user profile
        // data
        const customLozenges = [];
        if (userProfileClientForConfluenceQueryResult.status === 'fulfilled') {
            const confluenceUserResponse = userProfileClientForConfluenceQueryResult.value.data;
            if ((0, $7lu50.getExternalCollaboratorEntitlementFromQuery)(confluenceUserResponse) && confluenceUserResponse?.user?.confluence?.permissionType === (0, $ldOrZ.SitePermissionType).EXTERNAL) customLozenges.push({
                ...(0, $9fywD.ExternalUserLozengeProps),
                key: 'ExternalUserLozenge'
            });
        }
        (0, $9jSPN.PROFILE_CARD_QUERY_METRIC).stop({
            customData: {
                success: true
            }
        });
        return {
            ...standardUserDataResult.value,
            customLozenges: customLozenges
        };
    }
}
module.exports["UserProfileClientForConfluence"] = $e0ed8187aad1d5de$export$8e0680112f77975e;

});

parcelRegister("ldOrZ", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $0709253cacc9fe3a$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["SitePermissionType"] = $0709253cacc9fe3a$export$8995abb8169b2cb8;

});

parcelRegister("2A84u", function(module, exports) {

var $ay9Uu = parcelRequire("ay9Uu");

const $ab1c6257ac115bcc$export$8322eea6a290b246 = (0, $ay9Uu.default);
module.exports["UserProfileClientForConfluenceQuery"] = $ab1c6257ac115bcc$export$8322eea6a290b246;

});

parcelRegister("ay9Uu", function(module, exports) {
/**
 * @generated SignedSource<<c8072e566be2615c9f169051b183f1d7>>
 * @relayHash e3b7fcde55b949bf8d80bddd9a0ac180
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ee7894fc24fdc7e2f211db85d0b9ca04c99930331a3373b4aec2e287d771850d
const $bb661b120eec94ae$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "userId"
        }
    ], v1 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": false
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "userId"
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "permissionType"
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "Entitlements",
            "kind": "LinkedField",
            "name": "entitlements",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ExternalCollaboratorFeature",
                    "kind": "LinkedField",
                    "name": "externalCollaborator",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEntitled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "UserProfileClientForConfluenceQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "UserProfileClientForConfluenceQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "e3b7fcde55b949bf8d80bddd9a0ac180",
            "id": "ee7894fc24fdc7e2f211db85d0b9ca04c99930331a3373b4aec2e287d771850d",
            "metadata": {},
            "name": "UserProfileClientForConfluenceQuery",
            "operationKind": "query",
            "text": "query UserProfileClientForConfluenceQuery($userId:ID){user:confluence_atlassianUser(current:false,id:$userId){id,confluence{permissionType}},entitlements{externalCollaborator{isEntitled}}}"
        }
    };
}();
$bb661b120eec94ae$var$node.hash = "f636f7ede64e4c0d1757767b061d53b5";
var $bb661b120eec94ae$export$2e2bcd8739ae039 = $bb661b120eec94ae$var$node;
module.exports["default"] = $bb661b120eec94ae$export$2e2bcd8739ae039;

});

parcelRegister("9jSPN", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $fd6g2 = parcelRequire("fd6g2");

const $5487d57e41530957$export$c2710940b43dcf08 = (0, $lSOAM.createCustomMetric)({
    key: (0, $fd6g2.PROFILE_CARD_QUERY_CUSTOM_KEY)
});
module.exports["PROFILE_CARD_QUERY_METRIC"] = $5487d57e41530957$export$c2710940b43dcf08;

});

parcelRegister("bedVD", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $lpNn5 = parcelRequire("lpNn5");

const $e4e11ee9fe4a88c9$var$i18n = (0, $kSwu1.defineMessages)({
    follow: {
        id: "profile.card.follow",
        defaultMessage: "Follow"
    },
    unfollow: {
        id: "profile.card.unfollow",
        defaultMessage: "Unfollow"
    },
    followTooltip: {
        id: "profile.card.follow.tooltip",
        defaultMessage: "See activity in feed"
    },
    unfollowTooltip: {
        id: "profile.card.unfollow.tooltip",
        defaultMessage: "Stop seeing activity in feed"
    }
});
const $e4e11ee9fe4a88c9$export$d258f317c876c5dc = (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { followed: followed } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== followed || $[1] !== intl) {
        t1 = intl.formatMessage(followed ? $e4e11ee9fe4a88c9$var$i18n.unfollowTooltip : $e4e11ee9fe4a88c9$var$i18n.followTooltip);
        $[0] = followed;
        $[1] = intl;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== followed || $[4] !== intl) {
        t2 = intl.formatMessage(followed ? $e4e11ee9fe4a88c9$var$i18n.unfollow : $e4e11ee9fe4a88c9$var$i18n.follow);
        $[3] = followed;
        $[4] = intl;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, t2);
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== t1 || $[9] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: t1,
            position: "bottom",
            testId: "feed-follow-tooltip"
        }, t3);
        $[8] = t1;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
};
module.exports["FeedFollow"] = $e4e11ee9fe4a88c9$export$d258f317c876c5dc;

});

parcelRegister("4GlQ9", function(module, exports) {

var $k7Nop = parcelRequire("k7Nop");


var $hOSkW = parcelRequire("hOSkW");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $bQm3c = parcelRequire("bQm3c");


var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");

const $e2d6f47b8e3454eb$var$useFeedFollowFeedFollowQuery = (0, $hOSkW.default);
const $e2d6f47b8e3454eb$var$useFeedFollowFeedFollowMutation = (0, $k7Nop.default);
const $e2d6f47b8e3454eb$var$isUserHasNoAccessError = (error)=>error?.graphQLErrors?.some((gqlError)=>gqlError?.path?.includes('getFeedUserConfig') && gqlError?.message?.includes('User not permitted to access Confluence'));
let $e2d6f47b8e3454eb$export$8631e45fce8db7c6 = false;
function $e2d6f47b8e3454eb$export$438df56e0ed352e6() {
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { data: data, loading: queryLoading, error: feedConfigError } = (0, $jMyy4.useQueryInterop)($e2d6f47b8e3454eb$var$useFeedFollowFeedFollowQuery, {
        skip: !isLicensed || $e2d6f47b8e3454eb$export$8631e45fce8db7c6,
        onError: (error)=>$e2d6f47b8e3454eb$export$8631e45fce8db7c6 = $e2d6f47b8e3454eb$var$isUserHasNoAccessError(error),
        __callerPackage__: "profile"
    });
    const [mutateFeedFollow, { error: mutationError }] = (0, $308Wd.useMutationInterop)($e2d6f47b8e3454eb$var$useFeedFollowFeedFollowMutation, {
        refetchQueries: [
            {
                query: $e2d6f47b8e3454eb$var$useFeedFollowFeedFollowQuery
            }
        ],
        __callerPackage__: "profile"
    });
    const followedUsersRaw = data?.getFeedUserConfig?.accountIds;
    const followedUsers = (0, $cozmU.useMemo)(()=>followedUsersRaw?.map((id)=>id ?? null) ?? [], [
        followedUsersRaw
    ]);
    const getToggleFollowUser = (0, $cozmU.useCallback)((accountId, following, source)=>async ()=>{
            if (!accountId) return;
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'feedFollow',
                    source: source,
                    attributes: {
                        id: accountId,
                        settingType: 'user',
                        actionType: following ? 'unfollow' : 'follow'
                    }
                }
            }).fire();
            try {
                if (following) await mutateFeedFollow({
                    variables: {
                        unfollow: [
                            accountId
                        ]
                    }
                });
                else await mutateFeedFollow({
                    variables: {
                        follow: [
                            accountId
                        ]
                    }
                });
            } catch  {
            // noop since the hook consumer logs the error through <ErrorDisplay>
            // mutateFeedFollow() has the potential to throw an error;
            // since we do not provide an onError callback to the useMutation hook
            // we need to catch the error here as a safety net.
            }
        }, [
        mutateFeedFollow,
        createAnalyticsEvent
    ]);
    return (0, $cozmU.useMemo)(()=>({
            renderFeedFollow: !(queryLoading || feedConfigError || $e2d6f47b8e3454eb$export$8631e45fce8db7c6) && isLicensed,
            loading: queryLoading,
            getToggleFollowUser: getToggleFollowUser,
            feedConfigError: feedConfigError,
            mutationError: mutationError,
            followedUsers: followedUsers
        }), [
        queryLoading,
        feedConfigError,
        isLicensed,
        getToggleFollowUser,
        mutationError,
        followedUsers
    ]);
}
module.exports["useFeedFollow"] = $e2d6f47b8e3454eb$export$438df56e0ed352e6;

});

parcelRegister("k7Nop", function(module, exports) {
/**
 * @generated SignedSource<<faabaa80182918f5d00c229b25800acb>>
 * @relayHash 564d8ad9d36377c3d791529bbbb8a24b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5d32fc5b6758b0cdbd537bc59e7432e83998cce61163ae34755c64a402dc367c
const $2274f77c1a29b092$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "follow"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "unfollow"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "followUsers",
                            "variableName": "follow"
                        },
                        {
                            "kind": "Variable",
                            "name": "unfollowUsers",
                            "variableName": "unfollow"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "SetFeedUserConfigPayload",
            "kind": "LinkedField",
            "name": "setFeedUserConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useFeedFollowFeedFollowMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useFeedFollowFeedFollowMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "564d8ad9d36377c3d791529bbbb8a24b",
            "id": "5d32fc5b6758b0cdbd537bc59e7432e83998cce61163ae34755c64a402dc367c",
            "metadata": {},
            "name": "useFeedFollowFeedFollowMutation",
            "operationKind": "mutation",
            "text": "mutation useFeedFollowFeedFollowMutation($follow:[ID],$unfollow:[ID]){setFeedUserConfig(input:{followUsers:$follow,unfollowUsers:$unfollow}){success}}"
        }
    };
}();
$2274f77c1a29b092$var$node.hash = "7ecf9b28db7400fffab67e3a3c52027c";
var $2274f77c1a29b092$export$2e2bcd8739ae039 = $2274f77c1a29b092$var$node;
module.exports["default"] = $2274f77c1a29b092$export$2e2bcd8739ae039;

});

parcelRegister("hOSkW", function(module, exports) {
/**
 * @generated SignedSource<<597a7b2d7b3333c8532a887f4cdcbd48>>
 * @relayHash bc87c04b481deeaeaae914ab875dc44e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 11f28c2ff5a1dd7dd27036b76ee213cfc4cc4dc180b6462f1906390361cc096b
const $eeb53afb4cc8b670$var$node = function() {
    var v0 = [
        {
            "concreteType": "FollowingFeedGetUserConfig",
            "kind": "LinkedField",
            "name": "getFeedUserConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "accountIds"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useFeedFollowFeedFollowQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useFeedFollowFeedFollowQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "bc87c04b481deeaeaae914ab875dc44e",
            "id": "11f28c2ff5a1dd7dd27036b76ee213cfc4cc4dc180b6462f1906390361cc096b",
            "metadata": {},
            "name": "useFeedFollowFeedFollowQuery",
            "operationKind": "query",
            "text": "query useFeedFollowFeedFollowQuery{getFeedUserConfig{accountIds}}"
        }
    };
}();
$eeb53afb4cc8b670$var$node.hash = "73bdcd7f6c8309a4d0a16e77fd4c5fed";
var $eeb53afb4cc8b670$export$2e2bcd8739ae039 = $eeb53afb4cc8b670$var$node;
module.exports["default"] = $eeb53afb4cc8b670$export$2e2bcd8739ae039;

});

parcelRegister("eLV9q", function(module, exports) {
$parcel$export(module.exports, "useGetNavigateToTeamsApp", () => (parcelRequire("eWzPA")).useGetNavigateToTeamsApp);

var $eWzPA = parcelRequire("eWzPA");


});

parcelRegister("eWzPA", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $hMCZS = parcelRequire("hMCZS");


var $bQm3c = parcelRequire("bQm3c");

const $8c3fac113683eb0d$export$bb1230c0e6efa9dc = ()=>{
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const getNavigateToTeamsApp = (navActionPayload, shouldOpenInSameTab)=>{
        return (0, $hMCZS.navigateToTeamsApp)({
            hostProduct: 'confluence',
            orgId: orgId,
            cloudId: cloudId,
            userHasNav4Enabled: true,
            shouldOpenInSameTab: shouldOpenInSameTab,
            ...navActionPayload
        });
    };
    return (0, $cozmU.useCallback)(getNavigateToTeamsApp, [
        cloudId,
        orgId
    ]);
};
module.exports["useGetNavigateToTeamsApp"] = $8c3fac113683eb0d$export$bb1230c0e6efa9dc;

});

parcelRegister("hcnuR", function(module, exports) {

var $4o0zT = parcelRequire("4o0zT");

const $62bc818b780bdfc1$export$68a914b05fdf9ed1 = (classification)=>{
    if (!(0, $4o0zT.isExperimentEnabled)('platform_editor_non_production_build_analytics')) return {};
    const isNonProductionBuild = typeof classification === 'function' ? classification() : classification;
    return isNonProductionBuild !== undefined ? {
        isNonProductionBuild: isNonProductionBuild
    } : {};
};
module.exports["getNonProductionBuildAnalyticsAttributes"] = $62bc818b780bdfc1$export$68a914b05fdf9ed1;

});

parcelRegister("3jRrs", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cXtTj = parcelRequire("cXtTj");


var $3PNw6 = parcelRequire("3PNw6");

const $7f8675ab969ce2e0$export$e275bea1043f4431 = ()=>{
    // This explicitly does not fire exposure, in order to prevent a Holdout exposure, which can dilute the Holdout measurement.
    const isInConfluenceHoldout = (0, $cXtTj.default).initializeCompleted() && !(0, $cXtTj.default).checkGate('product-confluence-holdout-observability-gate', {
        fireGateExposure: false
    });
    return {
        holdout: isInConfluenceHoldout ? 'confluence-holdout' : ''
    };
};
const $7f8675ab969ce2e0$export$c7fd2161616b0849 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3PNw6.default), {
        data: $7f8675ab969ce2e0$export$e275bea1043f4431()
    });
};
module.exports["getIsInConfluenceHoldoutData"] = $7f8675ab969ce2e0$export$e275bea1043f4431;

});

parcelRegister("2SowE", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ function $3c96f0e6009ebcf8$export$dc64ca688fb64c26(payload, newAttributes) {
    return {
        ...payload,
        attributes: {
            ...payload.attributes,
            ...newAttributes
        }
    };
}
const $3c96f0e6009ebcf8$export$a9a68a8b41555f13 = (startTime, duration)=>{
    return Number.isFinite(startTime) && Number.isFinite(duration) ? Math.round(startTime + duration) : undefined;
};
const $3c96f0e6009ebcf8$export$7ed9e23d68ab9aa6 = (context)=>{
    return context.filter((obj)=>obj.attributes && typeof obj.attributes === 'object' && !Array.isArray(obj.attributes)).reduce((acc, obj)=>({
            ...acc,
            ...obj.attributes
        }), {});
};
module.exports["extendPayloadAttributes"] = $3c96f0e6009ebcf8$export$dc64ca688fb64c26;
module.exports["getProseMirrorFMPTimestamp"] = $3c96f0e6009ebcf8$export$a9a68a8b41555f13;
module.exports["extractAttributesFromContext"] = $3c96f0e6009ebcf8$export$7ed9e23d68ab9aa6;

});

parcelRegister("8ld8H", function(module, exports) {

var $eSuZj = parcelRequire("eSuZj");


var $68uaC = parcelRequire("68uaC");

const $ca70a3574c04adc8$var$BRANCH_COOKIE = 'useFrontendBranch';
const $ca70a3574c04adc8$var$BIFROST_OVERRIDE_COOKIE = 'bifrost-override';
const $ca70a3574c04adc8$var$isActiveBranchCookie = (value)=>{
    if (!value || value === 'off') return false;
    const override = JSON.parse(value);
    if (!override || typeof override !== 'object' || Array.isArray(override)) return undefined;
    const version = override?.['cc-fe-bifrost']?.version ?? override?.version;
    if (version === undefined) return false;
    return typeof version === 'string' ? Boolean(version && version !== 'off' && version !== 'CLASSIC-off-off') : undefined;
};
const $ca70a3574c04adc8$export$89ba981936f5422e = ()=>{
    try {
        const { RELEASE_TRACK: RELEASE_TRACK } = (0, $eSuZj.getBuildInfo)();
        if (RELEASE_TRACK === 'dev' || RELEASE_TRACK === 'staging') return true;
        if (![
            'prod',
            'hello',
            'canary'
        ].includes(RELEASE_TRACK)) return undefined;
        if (window.__SSR_RENDERED__) {
            let bifrostOverride;
            try {
                bifrostOverride = (0, $68uaC.Cookies).get($ca70a3574c04adc8$var$BIFROST_OVERRIDE_COOKIE);
            } catch  {
            // Fall back to the frontend branch cookie if the Bifrost cookie cannot be read.
            }
            if (bifrostOverride) return $ca70a3574c04adc8$var$isActiveBranchCookie(bifrostOverride);
        }
        const branchVersion = (0, $68uaC.Cookies).get($ca70a3574c04adc8$var$BRANCH_COOKIE);
        return Boolean(branchVersion && branchVersion !== 'off');
    } catch  {
        return undefined;
    }
};
module.exports["getConfluenceNonProductionBuild"] = $ca70a3574c04adc8$export$89ba981936f5422e;

});

parcelRegister("icKZN", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $76c86d96bcffdba9$export$4128d9964cdd56b5 = (event, options)=>{
    return event?.isDefaultPrevented() && (Boolean(options?.shouldCheckIframe) && $76c86d96bcffdba9$var$isIframe() || $76c86d96bcffdba9$var$isCtrlOrCommandClick(event) || $76c86d96bcffdba9$var$isMiddleClick(event));
};
const $76c86d96bcffdba9$var$isIframe = ()=>window.parent !== parent;
const $76c86d96bcffdba9$var$isMiddleClick = (event)=>{
    const nativeEvent = event?.nativeEvent;
    return nativeEvent.button === 1;
};
const $76c86d96bcffdba9$var$isCtrlOrCommandClick = (event)=>{
    const nativeEvent = event?.nativeEvent;
    return (0, $9wGTI.fg)('platform-smart-card-shift-key') ? nativeEvent.ctrlKey || nativeEvent.metaKey || nativeEvent.shiftKey : nativeEvent.ctrlKey || nativeEvent.metaKey;
};
module.exports["isClickEventToOpenNewTab"] = $76c86d96bcffdba9$export$4128d9964cdd56b5;

});

parcelRegister("bFDX4", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $8182af0d2f396edd$export$5df30e64c619846d = (error)=>(0, $aMcHK.isStatusCodeError)(error, '429');
module.exports["isTooManyRequestsError"] = $8182af0d2f396edd$export$5df30e64c619846d;

});

parcelRegister("8aF6s", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $cozmU = parcelRequire("cozmU");


var $2BAFx = parcelRequire("2BAFx");

const $ff30daea9524db5f$var$onChildClose = (key, ...args)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        // A child dialog called its onClose prop
        // Find the stack frame for the respective child
        const childFrame = state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onClose) childFrame.originalProps.onClose(...args);
        // Don't remove this dialog from the stack; instead mark it as not alive. This will pull the
        // component from its enclosing <ModalTransition>, but keep the <ModalTransition> around, for now.
        // The child that we provide to the <ModalTransition> has an onCloseComplete prop, to trigger the
        // final cleanup.
        setState({
            stack: state.stack.map((frame)=>frame === childFrame ? {
                    ...frame,
                    alive: false
                } : frame)
        });
    };
const $ff30daea9524db5f$var$onChildCloseComplete = (key, ...args)=>({ getState: getState, setState: setState })=>{
        // A child dialog called its onCloseComplete prop
        const state = getState();
        // Find the stack frame for the respective child
        const childFrame = state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onCloseComplete) childFrame.originalProps.onCloseComplete(...args);
        // The transition has completed, so complete the cleanup: remove the
        // frame from the stack to pull the <ModalTransition>.
        setState({
            stack: state.stack.filter((frame)=>frame.key !== childFrame.key)
        });
    };
const $ff30daea9524db5f$var$actions = {
    showModal: (componentClass, originalProps, children)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const key = (0, $2BAFx.dialogKeyState).nextKey;
            const props = originalProps || {};
            const onClose = (...args)=>dispatch($ff30daea9524db5f$var$onChildClose(key, ...args));
            const onCloseComplete = (...args)=>dispatch($ff30daea9524db5f$var$onChildCloseComplete(key, ...args));
            const component = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(componentClass, {
                ...props,
                onClose: onClose,
                onCloseComplete: onCloseComplete
            }, children);
            const state = getState();
            setState({
                stack: [
                    ...state.stack,
                    {
                        key: key,
                        component: component,
                        alive: true,
                        originalProps: {
                            onClose: props?.onClose,
                            onCloseComplete: props?.onCloseComplete
                        }
                    }
                ]
            });
            // Returns a method that the caller can use to close the dialog (though, most often,
            // a child would self-close)
            return onClose;
        }
};
const $ff30daea9524db5f$var$store = (0, $8s9DV.createStore)({
    initialState: {
        stack: []
    },
    actions: $ff30daea9524db5f$var$actions,
    name: 'DialogsStore'
});
/**
 * This is a work around to enforce the type requirement for the modal component.
 * For some reason the types don't resolve correctly in the bound actions
 */ const $ff30daea9524db5f$var$getTypedActions = (actions)=>{
    const showModal = (component, originalProps)=>{
        actions.showModal(component, originalProps);
    };
    return {
        showModal: showModal
    };
};
const $ff30daea9524db5f$var$useDialogActions = (0, $kBr4q.createActionsHook)($ff30daea9524db5f$var$store);
const $ff30daea9524db5f$export$f3af872d774d3d3f = ()=>{
    const actions = $ff30daea9524db5f$var$useDialogActions();
    return (0, $cozmU.useMemo)(()=>$ff30daea9524db5f$var$getTypedActions(actions), [
        actions
    ]);
};
const $ff30daea9524db5f$var$useDialogsStore = (0, $kBr4q.createHook)($ff30daea9524db5f$var$store);
const $ff30daea9524db5f$export$ecef86e74aed0d6b = ()=>{
    const [state, actions] = $ff30daea9524db5f$var$useDialogsStore();
    return (0, $cozmU.useMemo)(()=>({
            state: state,
            ...$ff30daea9524db5f$var$getTypedActions(actions)
        }), [
        actions,
        state
    ]);
};
module.exports["useDialogs"] = $ff30daea9524db5f$export$f3af872d774d3d3f;
module.exports["useDialogsState"] = $ff30daea9524db5f$export$ecef86e74aed0d6b;

});

parcelRegister("9cZ1w", function(module, exports) {

var $epLE5 = parcelRequire("epLE5");


const $486bada329940e5a$export$f6e059b56d9aeb26 = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("3iVMq"))).showCreateWithRovoModalCloseFeedbackFlagThunk);
module.exports["useLazyShowFeedbackFlag"] = $486bada329940e5a$export$f6e059b56d9aeb26;

});

parcelRegister("epLE5", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $dfceb6b0f6d6cccb$export$729b27bc0f344ffe = (loader)=>{
    return (...deps)=>(0, $cozmU.useCallback)((...args)=>{
            return loader().then((thunk)=>thunk(...deps)(...args));
        }, // Linter doesn't like spread syntax
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            ...deps
        ]);
};
module.exports["createLazyCallbackHook"] = $dfceb6b0f6d6cccb$export$729b27bc0f344ffe;

});

parcelRegister("3iVMq", function(module, exports) {

let $267fdf6f9345f6b7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $267fdf6f9345f6b7$var$load("dQT3c"),
    $267fdf6f9345f6b7$var$load("kHXvF"),
    $267fdf6f9345f6b7$var$load("6wr18"),
    $267fdf6f9345f6b7$var$load("ffEVr"),
    $267fdf6f9345f6b7$var$load("7gL7H"),
    $267fdf6f9345f6b7$var$load("hhss7"),
    $267fdf6f9345f6b7$var$load("Wowvf"),
    $267fdf6f9345f6b7$var$load("4g6rd"),
    $267fdf6f9345f6b7$var$load("7EorR"),
    $267fdf6f9345f6b7$var$load("k7MRD")
]).then(()=>parcelRequire('hlCkz'));

});

parcelRegister("7CX60", function(module, exports) {

var $lyqUH = parcelRequire("lyqUH");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/townsquare/goal/manifest.ts
var $58d9ec349b8fda63$var$townsquareGoalAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $lyqUH.TownsquareGoalAriResourceOwner),
    resourceType: (0, $lyqUH.TownsquareGoalAriResourceType),
    resourceIdSlug: "{goalUuid}",
    resourceIdSegmentFormats: {
        goalUuid: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/townsquare/goal/index.ts
var $58d9ec349b8fda63$export$e45ea1bd9a289a4f = class _TownsquareGoalAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get goalUuid() {
        return this._goalUuid;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $58d9ec349b8fda63$var$townsquareGoalAriStaticOpts.qualifier,
            platformQualifier: $58d9ec349b8fda63$var$townsquareGoalAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $58d9ec349b8fda63$var$townsquareGoalAriStaticOpts.resourceOwner,
            resourceType: $58d9ec349b8fda63$var$townsquareGoalAriStaticOpts.resourceType,
            resourceId: `${opts.goalUuid}`,
            resourceIdSegmentValues: {
                goalUuid: opts.goalUuid
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $58d9ec349b8fda63$var$townsquareGoalAriStaticOpts);
        return new _TownsquareGoalAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $58d9ec349b8fda63$var$townsquareGoalAriStaticOpts);
        return new _TownsquareGoalAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            goalUuid: this.goalUuid
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._goalUuid = opts.resourceIdSegmentValues.goalUuid;
    }
};
module.exports["TownsquareGoalAri"] = $58d9ec349b8fda63$export$e45ea1bd9a289a4f;

});

parcelRegister("lyqUH", function(module, exports) {
// src/townsquare/goal/types.ts
var $fb11a66b9944d017$export$947838268868cc57 = "townsquare", $fb11a66b9944d017$export$935b9c2af9d62e80 = "goal";
module.exports["TownsquareGoalAriResourceOwner"] = $fb11a66b9944d017$export$947838268868cc57;
module.exports["TownsquareGoalAriResourceType"] = $fb11a66b9944d017$export$935b9c2af9d62e80;

});

parcelRegister("28WJb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $3Ap09 = parcelRequire("3Ap09");

const $065389573511adac$export$5351114e92b31bc6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    if (context?.state.panel == null) return null;
    let t0;
    if ($[0] !== context.setPanelWidth || $[1] !== context.state.panel || $[2] !== context.width) {
        t0 = {
            ...context.state.panel,
            width: context.width,
            setWidth: context.setPanelWidth
        };
        $[0] = context.setPanelWidth;
        $[1] = context.state.panel;
        $[2] = context.width;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : ()=>{
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    if (context?.state.panel == null) return null;
    return {
        ...context.state.panel,
        width: context.width,
        setWidth: context.setPanelWidth
    };
};
module.exports["useCurrentPreviewPanel"] = $065389573511adac$export$5351114e92b31bc6;

});

parcelRegister("8OpiN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::48df6a4b08988964a6c19ca298fb7fa6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $66a69eb8c574d02b$var$_react = $66a69eb8c574d02b$var$_interopRequireDefault((parcelRequire("cozmU")));

var $66a69eb8c574d02b$var$_iconNew = $66a69eb8c574d02b$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $66a69eb8c574d02b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AssetsObject".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/assets-object
 * Usage guidance:
 * Reserved for representing objects in Assets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $66a69eb8c574d02b$var$AssetsObjectIcon = (props)=>/*#__PURE__*/ $66a69eb8c574d02b$var$_react.default.createElement($66a69eb8c574d02b$var$_iconNew.default, Object.assign({
        name: "AssetsObjectIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 3a.5.5 0 0 0-.5-.5h-2.5v3.75a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75V2.5H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM7 5.5h2v-3H7zm8 7.5a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>`
    }, props));
$66a69eb8c574d02b$var$AssetsObjectIcon.displayName = 'AssetsObjectIcon';
var $66a69eb8c574d02b$var$_default = module.exports.default = $66a69eb8c574d02b$var$AssetsObjectIcon;

});

parcelRegister("df5DJ", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $99V2N = parcelRequire("99V2N");

var $9jEqd = parcelRequire("9jEqd");

var $hG4SA = parcelRequire("hG4SA");


var $6i6Hm = parcelRequire("6i6Hm");

const $3d79566ecfd5a94d$var$SITE_RESOURCE_TYPE = 'site';
const $3d79566ecfd5a94d$var$siteIdOf = (siteIdOrAri)=>{
    try {
        const ari = (0, $99V2N.AnyAri).parse(siteIdOrAri);
        return ari.resourceType === $3d79566ecfd5a94d$var$SITE_RESOURCE_TYPE ? ari.resourceId : siteIdOrAri;
    } catch  {
        return siteIdOrAri;
    }
};
const $3d79566ecfd5a94d$var$createSiteAri = (siteAriType, siteId)=>{
    try {
        return siteAriType.create({
            siteId: siteId
        }).toString();
    } catch  {
        return '';
    }
};
const $3d79566ecfd5a94d$var$getAppSiteAri = (siteIdOrAri, siteAriType)=>{
    const siteId = $3d79566ecfd5a94d$var$siteIdOf(siteIdOrAri);
    if (!(0, $iDrrr.fg)('townsquare_goal_project_site_aris')) // Pre-migration behaviour: site ARIs are passed through untouched, bare site ids
    // are turned into the deprecated townsquare-owned site ARI.
    return siteId === siteIdOrAri ? $3d79566ecfd5a94d$var$createSiteAri((0, $6i6Hm.TownsquareSiteAri), siteId) : siteIdOrAri;
    return $3d79566ecfd5a94d$var$createSiteAri(siteAriType, siteId);
};
const $3d79566ecfd5a94d$export$20d6ddd0cf2f686b = (siteIdOrAri)=>$3d79566ecfd5a94d$var$getAppSiteAri(siteIdOrAri, (0, $9jEqd.GoalSiteAri));
const $3d79566ecfd5a94d$export$565bf3b5b10d78e9 = (siteIdOrAri)=>$3d79566ecfd5a94d$var$getAppSiteAri(siteIdOrAri, (0, $hG4SA.ProjectSiteAri));
module.exports["getGoalSiteAri"] = $3d79566ecfd5a94d$export$20d6ddd0cf2f686b;
module.exports["getProjectSiteAri"] = $3d79566ecfd5a94d$export$565bf3b5b10d78e9;

});

parcelRegister("9jEqd", function(module, exports) {

var $ei2P9 = parcelRequire("ei2P9");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/goal/site/manifest.ts
var $6c853e59257dbecf$var$goalSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $ei2P9.GoalSiteAriResourceOwner),
    resourceType: (0, $ei2P9.GoalSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/goal/site/index.ts
var $6c853e59257dbecf$export$25f6e07f2c803459 = class _GoalSiteAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $6c853e59257dbecf$var$goalSiteAriStaticOpts.qualifier,
            platformQualifier: $6c853e59257dbecf$var$goalSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $6c853e59257dbecf$var$goalSiteAriStaticOpts.resourceOwner,
            resourceType: $6c853e59257dbecf$var$goalSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $6c853e59257dbecf$var$goalSiteAriStaticOpts);
        return new _GoalSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $6c853e59257dbecf$var$goalSiteAriStaticOpts);
        return new _GoalSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.resourceIdSegmentValues.siteId;
    }
};
module.exports["GoalSiteAri"] = $6c853e59257dbecf$export$25f6e07f2c803459;

});

parcelRegister("ei2P9", function(module, exports) {
// src/goal/site/types.ts
var $a674efe79f341c4b$export$856c52490bfaa1d5 = "goal", $a674efe79f341c4b$export$21b302361b3c545e = "site";
module.exports["GoalSiteAriResourceOwner"] = $a674efe79f341c4b$export$856c52490bfaa1d5;
module.exports["GoalSiteAriResourceType"] = $a674efe79f341c4b$export$21b302361b3c545e;

});

parcelRegister("hG4SA", function(module, exports) {

var $5isyS = parcelRequire("5isyS");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/project/site/manifest.ts
var $cdea24de3f27642d$var$projectSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $5isyS.ProjectSiteAriResourceOwner),
    resourceType: (0, $5isyS.ProjectSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/project/site/index.ts
var $cdea24de3f27642d$export$ac5d12d294f83be4 = class _ProjectSiteAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $cdea24de3f27642d$var$projectSiteAriStaticOpts.qualifier,
            platformQualifier: $cdea24de3f27642d$var$projectSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $cdea24de3f27642d$var$projectSiteAriStaticOpts.resourceOwner,
            resourceType: $cdea24de3f27642d$var$projectSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $cdea24de3f27642d$var$projectSiteAriStaticOpts);
        return new _ProjectSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $cdea24de3f27642d$var$projectSiteAriStaticOpts);
        return new _ProjectSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.resourceIdSegmentValues.siteId;
    }
};
module.exports["ProjectSiteAri"] = $cdea24de3f27642d$export$ac5d12d294f83be4;

});

parcelRegister("5isyS", function(module, exports) {
// src/project/site/types.ts
var $3db4c9e7774a7202$export$9eea0d5b157c61be = "project", $3db4c9e7774a7202$export$cbe80ac90c61c70d = "site";
module.exports["ProjectSiteAriResourceOwner"] = $3db4c9e7774a7202$export$9eea0d5b157c61be;
module.exports["ProjectSiteAriResourceType"] = $3db4c9e7774a7202$export$cbe80ac90c61c70d;

});

parcelRegister("6i6Hm", function(module, exports) {

var $4Yksf = parcelRequire("4Yksf");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/townsquare/site/manifest.ts
var $49499eaaef8ec6c2$var$townsquareSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $4Yksf.TownsquareSiteAriResourceOwner),
    resourceType: (0, $4Yksf.TownsquareSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/townsquare/site/index.ts
var $49499eaaef8ec6c2$export$87ae3de5f1f7725a = class _TownsquareSiteAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $49499eaaef8ec6c2$var$townsquareSiteAriStaticOpts.qualifier,
            platformQualifier: $49499eaaef8ec6c2$var$townsquareSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $49499eaaef8ec6c2$var$townsquareSiteAriStaticOpts.resourceOwner,
            resourceType: $49499eaaef8ec6c2$var$townsquareSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $49499eaaef8ec6c2$var$townsquareSiteAriStaticOpts);
        return new _TownsquareSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $49499eaaef8ec6c2$var$townsquareSiteAriStaticOpts);
        return new _TownsquareSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.resourceIdSegmentValues.siteId;
    }
};
module.exports["TownsquareSiteAri"] = $49499eaaef8ec6c2$export$87ae3de5f1f7725a;

});

parcelRegister("4Yksf", function(module, exports) {
// src/townsquare/site/types.ts
var $39eca1dd131685dd$export$9ee8c46ef1f3e6a8 = "townsquare", $39eca1dd131685dd$export$44737bde24f3bac1 = "site";
module.exports["TownsquareSiteAriResourceOwner"] = $39eca1dd131685dd$export$9ee8c46ef1f3e6a8;
module.exports["TownsquareSiteAriResourceType"] = $39eca1dd131685dd$export$44737bde24f3bac1;

});

parcelRegister("4slsU", function(module, exports) {

var $7CX60 = parcelRequire("7CX60");

var $5O8nX = parcelRequire("5O8nX");

var $6i6Hm = parcelRequire("6i6Hm");

function $4caae11b2ff1f088$export$3ae2d1e732b25194(entity, ari) {
    try {
        if (entity === 'goal') return (0, $7CX60.TownsquareGoalAri).parse(ari).siteId;
        if (entity === 'project') return (0, $5O8nX.TownsquareProjectAri).parse(ari).siteId;
        if (entity === 'site') return (0, $6i6Hm.TownsquareSiteAri).parse(ari).siteId;
    } catch (error) {
        //TODO: send error metrics/monitoring https://product-fabric.atlassian.net/browse/TC-13492
        //We try to extract the siteId manually: ari:cloud:townsquare:${siteId}:{entity}/{uuid}
        if (entity === 'goal' || entity === 'project') return ari.split(':')[3] ?? '';
    }
    return '';
}
module.exports["getSiteId"] = $4caae11b2ff1f088$export$3ae2d1e732b25194;

});

parcelRegister("fvoKJ", function(module, exports) {

var $6i6Hm = parcelRequire("6i6Hm");

const $e160175aa6804997$export$792aeacb7990bc6 = (containerId)=>{
    // we wrap in a try/catch incase there are any issues with creating the site ari
    try {
        return (0, $6i6Hm.TownsquareSiteAri).create({
            siteId: containerId
        }).toString();
    } catch  {
        return '';
    }
};
module.exports["getSiteAri"] = $e160175aa6804997$export$792aeacb7990bc6;

});

parcelRegister("6Mfv2", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ef33fad4d0e8632$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $4ef33fad4d0e8632$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $3yGK6.default)(2, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var dateToCompare = (0, $dkBOe.default)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}

});

parcelRegister("6gp4u", function(module, exports) {

var $d8qQB = parcelRequire("d8qQB");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/bitbucket/repository/manifest.ts
var $48f7af6154c09f2a$var$bitbucketRepositoryAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $d8qQB.BitbucketRepositoryAriResourceOwner),
    resourceType: (0, $d8qQB.BitbucketRepositoryAriResourceType),
    resourceIdSlug: "{repositoryId}",
    resourceIdSegmentFormats: {
        repositoryId: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/bitbucket/repository/index.ts
var $48f7af6154c09f2a$export$ff8171d8f91447e5 = class _BitbucketRepositoryAri extends (0, $9j37t.RegisteredAri) {
    get repositoryId() {
        return this._repositoryId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $48f7af6154c09f2a$var$bitbucketRepositoryAriStaticOpts.qualifier,
            platformQualifier: $48f7af6154c09f2a$var$bitbucketRepositoryAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $48f7af6154c09f2a$var$bitbucketRepositoryAriStaticOpts.resourceOwner,
            resourceType: $48f7af6154c09f2a$var$bitbucketRepositoryAriStaticOpts.resourceType,
            resourceId: `${opts.repositoryId}`,
            resourceIdSegmentValues: {
                repositoryId: opts.repositoryId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $48f7af6154c09f2a$var$bitbucketRepositoryAriStaticOpts);
        return new _BitbucketRepositoryAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $48f7af6154c09f2a$var$bitbucketRepositoryAriStaticOpts);
        return new _BitbucketRepositoryAri(opts);
    }
    getVariables() {
        return {
            repositoryId: this.repositoryId
        };
    }
    constructor(opts){
        super(opts), this._repositoryId = opts.resourceIdSegmentValues.repositoryId;
    }
};
module.exports["BitbucketRepositoryAri"] = $48f7af6154c09f2a$export$ff8171d8f91447e5;

});

parcelRegister("d8qQB", function(module, exports) {
// src/bitbucket/repository/types.ts
var $9900d911788b6dcb$export$ca6588ee4ebd8c29 = "bitbucket", $9900d911788b6dcb$export$f39d523cb13867d3 = "repository";
module.exports["BitbucketRepositoryAriResourceOwner"] = $9900d911788b6dcb$export$ca6588ee4ebd8c29;
module.exports["BitbucketRepositoryAriResourceType"] = $9900d911788b6dcb$export$f39d523cb13867d3;

});

parcelRegister("eToX6", function(module, exports) {
/**
 * Utility functions for detecting and working with preview panels
 */ // Types for preview panel detection
// Preview panel indicators
const $cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS = {
    EMBEDDED_SOURCE: 'embeddedConfluenceSource',
    PREVIEW_PANELS: 'previewPanels',
    CONFLUENCE_PAGE_PREVIEW: 'confluence-page-preview-panel'
};
/**
 * Gets URL search parameters safely
 */ const $cf00e918e2c1556d$var$getUrlSearchParams = (url)=>{
    try {
        return new URLSearchParams(url);
    } catch  {
        return null;
    }
};
const $cf00e918e2c1556d$export$5c3b154013d00c5f = (searchParams)=>{
    return searchParams.has($cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS.PREVIEW_PANELS) || searchParams.get($cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS.EMBEDDED_SOURCE) === $cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS.CONFLUENCE_PAGE_PREVIEW;
};
const $cf00e918e2c1556d$export$cd88bef28d20da33 = ()=>{
    try {
        const currentSearch = window.location.search;
        if (currentSearch) {
            const currentParams = $cf00e918e2c1556d$var$getUrlSearchParams(currentSearch);
            if (currentParams && $cf00e918e2c1556d$export$5c3b154013d00c5f(currentParams)) return true;
        }
        return false;
    } catch  {
        return false;
    }
};
const $cf00e918e2c1556d$export$9f140ed41af5108c = ()=>{
    try {
        return window !== window.top;
    } catch  {
        // If we can't access window.top due to cross-origin restrictions, assume we're in an iframe
        return true;
    }
};
module.exports["hasPreviewPanelIndicators"] = $cf00e918e2c1556d$export$5c3b154013d00c5f;
module.exports["isInPreviewPanel"] = $cf00e918e2c1556d$export$cd88bef28d20da33;
module.exports["isInIframe"] = $cf00e918e2c1556d$export$9f140ed41af5108c;

});

parcelRegister("4o1RV", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $1eD4P = parcelRequire("1eD4P");


var $ihkY1 = parcelRequire("ihkY1");


var $kBW0t = parcelRequire("kBW0t");

function $f3bd82ae210529c7$export$57395cb9dce31159() {
    const $ = (0, $bDgLe.c)(3);
    const { navigationPolicy: navigationPolicy } = (0, $1eD4P.useReactProps_DO_NOT_USE)() || {};
    const routePolicy = (0, $ihkY1.useRoutePolicy)(navigationPolicy);
    const shimUrl = (0, $kBW0t.useShimUrl)(navigationPolicy);
    let t0;
    if ($[0] !== routePolicy || $[1] !== shimUrl) {
        t0 = {
            routePolicy: routePolicy,
            ...shimUrl
        };
        $[0] = routePolicy;
        $[1] = shimUrl;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
}
module.exports["useNavigationPolicy"] = $f3bd82ae210529c7$export$57395cb9dce31159;

});

parcelRegister("ihkY1", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lTECB = parcelRequire("lTECB");


var $1eD4P = parcelRequire("1eD4P");


var $cb6fO = parcelRequire("cb6fO");


var $kBW0t = parcelRequire("kBW0t");

function $477c5af85d2d7fb0$export$53e37724c6846f41(navigationPolicy) {
    const isEmbeddedConfluence = (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)();
    const { shimUrl: shimUrl } = (0, $kBW0t.useShimUrl)(navigationPolicy);
    const iframePassThroughProps = (0, $1eD4P.useReactProps_DO_NOT_USE)();
    const enableIframeSpaTransitions = iframePassThroughProps?.enableSpaTransitions;
    const getEmbeddedConfluenceRoutePolicy = (0, $cozmU.useCallback)(()=>({
            push ({ match: match, matchSupportedRoute: matchSupportedRoute, open: open, push: defaultPush }, url, forceReload) {
                // When navigate to an url with anchor only e.g. `#test`, the navigation doesn't need to continue as SPA transition,
                // Hence, there is no need to continue the navigation using `push` and potentially execute parent product's navigate method.
                // In this case, we exit `routePolicy.push` earlier and use `open` (window.open) to load the url in the exisitng browsing context
                if ((0, $cb6fO.isHashedOnlyURL)(url)) {
                    open(url, '_self');
                    return;
                }
                const _currRouteName = match?.name;
                const _currRouteContentId = match?.params.contentId;
                const _destinationRoute = matchSupportedRoute(url);
                const _dstRouteName = _destinationRoute?.name;
                const _dstRouteContentId = _destinationRoute?.params.contentId;
                const _dstRouteSpaceKey = _destinationRoute?.params.spaceKey;
                /**
       * Transition within the same window if the target route is navigating to the same content
       * This can ensure link to anchors in the page can still happen within the same window, instead of opening a new tab
       **/ const modifiers = {
                    routeName: $477c5af85d2d7fb0$var$toEPRouteName(_dstRouteName),
                    contentId: _dstRouteContentId,
                    spaceKey: _dstRouteSpaceKey,
                    target: this.willPushInSelf(_currRouteName, _currRouteContentId, _dstRouteName, _dstRouteContentId) ? '_self' : '_blank'
                };
                const defaultNavigate = (url_0, { target: target })=>{
                    // We double check the url here in case parent product modify the `url` in `navigate` function and provided the hashed-only url to `defaultNavigate`
                    if ((0, $cb6fO.isHashedOnlyURL)(url_0)) {
                        open(url_0, '_self');
                        return;
                    }
                    const destRoute = matchSupportedRoute(url_0);
                    const willPushInSelf = this.willPushInSelf(_currRouteName, _currRouteContentId, destRoute?.name, destRoute?.params.contentId);
                    // When navigate to an url with anchor and destination is under the same route for same content,
                    // EP's default navigtation should simply follow browser's navigation instead of going to `defaultPush` and execute `history.push`.
                    // In this case, we use `open` (window.open) to load in the exisitng browsing context
                    if (willPushInSelf && Boolean(destRoute?.hash)) {
                        open(destRoute?.hash, '_self');
                        return;
                    }
                    if (target === '_self') defaultPush(url_0, forceReload);
                    else open(url_0, target);
                };
                /**
       * defaultNavigate can be invoked by the embedding product because it's the 3rd argument to
       * navigationPolicy's navigate. If embedding product tells EP to navigate to a URL in a new
       * tab, EP should not shim (rebase) it since the embedding product has already had a chance
       * and they chose not to. On the other hand, if the embedding product does not tell EP to
       * nagivate, EP can shim the url only when opening a new tab (some links might not have been
       * shimmed, need to shim all links supposed to be shimmed as the last defense).
       **/ return navigationPolicy?.navigate ? navigationPolicy?.navigate(url, modifiers, defaultNavigate) : defaultNavigate(modifiers.target === '_self' ? url : shimUrl(url), modifiers);
            },
            willPushInSelf (currRouteName, currRouteContentId, dstRouteName, dstRouteContentId) {
                const isEPRoute = !!$477c5af85d2d7fb0$var$toEPRouteName(dstRouteName);
                const isSameRoute = currRouteName === dstRouteName && currRouteContentId === dstRouteContentId;
                const shouldTransition = !!enableIframeSpaTransitions && [
                    'VIEW_PAGE',
                    'EDIT_PAGE_EMBED'
                ].includes(currRouteName ?? '') && [
                    'VIEW_PAGE',
                    'EDIT_PAGE_EMBED'
                ].includes(dstRouteName ?? '') && currRouteContentId === dstRouteContentId;
                return isEPRoute && (isSameRoute || shouldTransition);
            }
        }), [
        enableIframeSpaTransitions,
        navigationPolicy,
        shimUrl
    ]);
    return (0, $cozmU.useMemo)(()=>isEmbeddedConfluence ? getEmbeddedConfluenceRoutePolicy() : undefined, [
        isEmbeddedConfluence,
        getEmbeddedConfluenceRoutePolicy
    ]);
}
function $477c5af85d2d7fb0$var$toEPRouteName(routeName) {
    switch(routeName){
        case 'VIEW_PAGE':
        case 'EDIT_PAGE_EMBED':
            return routeName;
        default:
            return undefined;
    }
}
module.exports["useRoutePolicy"] = $477c5af85d2d7fb0$export$53e37724c6846f41;

});

parcelRegister("kBW0t", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $dOBRD = parcelRequire("dOBRD");


var $f8dGE = parcelRequire("f8dGE");


var $7nEuU = parcelRequire("7nEuU");

var $bnFzS = parcelRequire("bnFzS");


var $cb6fO = parcelRequire("cb6fO");

const $734ea8da77496ad5$var$isAdfContent = (content)=>{
    return content && typeof content === 'object' && content.type === 'doc' && Array.isArray(content.content);
};
function $734ea8da77496ad5$export$8ed0b067e5cd675d(navigationPolicy) {
    const $ = (0, $bDgLe.c)(17);
    const shimTemplate = navigationPolicy?.shimUrl;
    const domainNamesToReplace = navigationPolicy?.domainNamesToReplace;
    const spaceKeyFilter = navigationPolicy?.spaceKeyFilter;
    let t0;
    if ($[0] !== domainNamesToReplace || $[1] !== shimTemplate || $[2] !== spaceKeyFilter) {
        t0 = (urlToShim)=>$734ea8da77496ad5$var$shimThisUrl(urlToShim, shimTemplate, domainNamesToReplace, spaceKeyFilter);
        $[0] = domainNamesToReplace;
        $[1] = shimTemplate;
        $[2] = spaceKeyFilter;
        $[3] = t0;
    } else t0 = $[3];
    const shimUrl = t0;
    let t1;
    if ($[4] !== domainNamesToReplace || $[5] !== shimTemplate || $[6] !== spaceKeyFilter) {
        t1 = (adf)=>{
            if (!shimTemplate || !adf || !Object.keys(adf).length) return adf;
            const adfClone = (0, (/*@__PURE__*/$parcel$interopDefault($f8dGE)))(adf);
            $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(adfClone, shimTemplate, domainNamesToReplace, spaceKeyFilter);
            return adfClone;
        };
        $[4] = domainNamesToReplace;
        $[5] = shimTemplate;
        $[6] = spaceKeyFilter;
        $[7] = t1;
    } else t1 = $[7];
    const shimAdfUrls = t1;
    let t2;
    if ($[8] !== domainNamesToReplace || $[9] !== shimAdfUrls || $[10] !== shimTemplate || $[11] !== spaceKeyFilter) {
        t2 = (html)=>{
            if (!shimTemplate || !html) return html;
            try {
                const parsedContent = JSON.parse(html);
                if ($734ea8da77496ad5$var$isAdfContent(parsedContent)) {
                    if (html.includes("\"extensionKey\":\"nested-table\"")) {
                        const processedAdf = $734ea8da77496ad5$var$shimAdfWithNestedTables(parsedContent, shimAdfUrls);
                        return JSON.stringify(processedAdf);
                    } else {
                        const shimmedAdf = shimAdfUrls(parsedContent);
                        return JSON.stringify(shimmedAdf);
                    }
                }
            } catch  {}
            try {
                return $734ea8da77496ad5$var$shimDomUrls(new DOMParser().parseFromString(html, "text/html"), shimTemplate, domainNamesToReplace, spaceKeyFilter).body.innerHTML;
            } catch  {
                return html;
            }
        };
        $[8] = domainNamesToReplace;
        $[9] = shimAdfUrls;
        $[10] = shimTemplate;
        $[11] = spaceKeyFilter;
        $[12] = t2;
    } else t2 = $[12];
    const shimHtmlUrls = t2;
    let t3;
    if ($[13] !== shimAdfUrls || $[14] !== shimHtmlUrls || $[15] !== shimUrl) {
        t3 = {
            shimUrl: shimUrl,
            shimAdfUrls: shimAdfUrls,
            shimHtmlUrls: shimHtmlUrls
        };
        $[13] = shimAdfUrls;
        $[14] = shimHtmlUrls;
        $[15] = shimUrl;
        $[16] = t3;
    } else t3 = $[16];
    return t3;
}
function $734ea8da77496ad5$var$shimDomUrls(dom, shimTemplate, domainNamesToReplace, spaceKeyFilter) {
    const anchors = dom.getElementsByTagName('a');
    Array.from(anchors).forEach((a)=>{
        a.href = $734ea8da77496ad5$var$shimThisUrl(a.href, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    });
    const imgs = dom.getElementsByTagName('img');
    Array.from(imgs).forEach((img)=>{
        img.src = $734ea8da77496ad5$var$shimThisUrl(img.src, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    });
    return dom;
}
function $734ea8da77496ad5$var$shimThisUrl(urlToShim, shimTemplate, domainNamesToReplace, spaceKeyFilter) {
    if (!shimTemplate || !urlToShim || (0, $cb6fO.isHashedOnlyURL)(urlToShim) || !$734ea8da77496ad5$var$isUrlForShimmedSpace(urlToShim, spaceKeyFilter)) return urlToShim;
    try {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const baseUrl = document.baseURI || window.location.toString();
        const absUrlWithDomainToShim = $734ea8da77496ad5$var$getAbsUrlWithDomain(urlToShim, baseUrl);
        const urlPrefixToShim = $734ea8da77496ad5$var$ccAbsUrlWithDomain(baseUrl);
        const urlShimTemplate = $734ea8da77496ad5$var$shimAbsUrlWithDomain(shimTemplate, baseUrl);
        return $734ea8da77496ad5$var$getShimmedUrl(absUrlWithDomainToShim, urlPrefixToShim, urlShimTemplate, baseUrl, domainNamesToReplace);
    } catch  {
        return urlToShim;
    }
}
function $734ea8da77496ad5$var$isUrlForShimmedSpace(url, spaceKeyFilter) {
    // If no filter, shim all URLs (backwards compatibility)
    if (!spaceKeyFilter?.length) return true;
    // Regex to extract spaceKey from /spaces/<spaceKey>/
    const match = url.match(/\/spaces\/([^/]+)/);
    if (match) {
        // If URL contains /spaces/<spaceKey>, only shim if spaceKey is in the filter
        const spaceKey = match[1];
        return spaceKeyFilter.includes(spaceKey);
    }
    // For other /wiki URLs (e.g., share links), retain previous behavior and shim
    return true;
}
const $734ea8da77496ad5$var$ccAbsUrlWithDomain = (0, $dOBRD.default)((base)=>$734ea8da77496ad5$var$appendSlash($734ea8da77496ad5$var$getAbsUrlWithDomain((0, $cb6fO.CONTEXT_PATH), base)));
const $734ea8da77496ad5$var$shimAbsUrlWithDomain = (0, $dOBRD.default)((urlShimTemplate, base)=>$734ea8da77496ad5$var$appendSlash($734ea8da77496ad5$var$getAbsUrlWithDomain(urlShimTemplate, base)));
function $734ea8da77496ad5$var$getAbsUrlWithDomain(url, base) {
    return new URL(url, base).toString();
}
function $734ea8da77496ad5$var$getShimmedUrl(absUrlWithDomainToShim, urlPrefixToShim, urlShimTemplate, baseUrl, domainNamesToReplace) {
    if (absUrlWithDomainToShim.includes((0, $cb6fO.CONTEXT_PATH))) {
        //We can only rebase or shim /wiki URLs
        const absUrlObj = new URL(absUrlWithDomainToShim);
        const baseUrlObj = new URL(baseUrl);
        //Check if the URL should be rebased
        if (domainNamesToReplace?.includes(absUrlObj.hostname)) {
            //Rebase the URL by replacing the origin string of absUrlWithDomainToShim with that of baseUrl
            const rebasedAbsUrlToShim = absUrlWithDomainToShim.replace(absUrlObj.origin, baseUrlObj.origin);
            //Shimming the rebased URL
            return rebasedAbsUrlToShim.replace(urlPrefixToShim, urlShimTemplate);
        }
    }
    return absUrlWithDomainToShim.replace(urlPrefixToShim, urlShimTemplate);
}
function $734ea8da77496ad5$var$appendSlash(url) {
    if (!url.endsWith('/')) return `${url}/`;
    return url;
}
const $734ea8da77496ad5$var$URL_ADF_KEYS = [
    'url',
    'href'
];
function $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(adfJson, shimTemplate, domainNamesToReplace, spaceKeyFilter) {
    Object.entries(adfJson).forEach(([key, value])=>{
        if (!value) return;
        if ($734ea8da77496ad5$var$URL_ADF_KEYS.includes(key) && typeof value === 'string') adfJson[key] = $734ea8da77496ad5$var$shimThisUrl(value, shimTemplate, domainNamesToReplace, spaceKeyFilter);
        else if (typeof value === 'object') $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(value, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    });
}
/**
 * Shims URLs in ADF content that contains nested tables.
 * This function processes ADF document content with nested tables by:
 * 1. Transforming nested tables (incoming)
 * 2. Applying URL shimming via shimAdfUrls
 * 3. Transforming nested tables (outgoing)
 *
 * @param adfContent - Parsed ADF document content (already validated)
 * @param shimAdfUrls - Function to apply URL shimming to ADF objects
 * @returns Processed ADF object with shimmed URLs and transformed nested tables
 */ function $734ea8da77496ad5$var$shimAdfWithNestedTables(adfContent, shimAdfUrls) {
    // Process ADF document with nested tables - transform and delegate to shimAdfUrls
    const { transformedAdf: transformedAdf } = (0, $bnFzS.transformNestedTablesIncomingDocument)(adfContent);
    const shimmedAdf = shimAdfUrls(transformedAdf);
    return (0, $7nEuU.transformNestedTableNodeOutgoingDocument)(shimmedAdf);
}
module.exports["useShimUrl"] = $734ea8da77496ad5$export$8ed0b067e5cd675d;

});

parcelRegister("83Z6R", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7EPz1 = parcelRequire("7EPz1");


var $6SsN4 = parcelRequire("6SsN4");


var $422HI = parcelRequire("422HI");


var $zXpxJ = parcelRequire("zXpxJ");


var $iffSy = parcelRequire("iffSy");


var $7q7rs = parcelRequire("7q7rs");


var $7M67g = parcelRequire("7M67g");


var $86okN = parcelRequire("86okN");


var $iF5wn = parcelRequire("iF5wn");

/**
 * Coerce an unknown thrown value into an ApolloErrorInterop, so a rejection carries Apollo's
 * `graphQLErrors` / `networkError` fields on both branches. Mirrors the helper in
 * `useLazyQueryInterop`.
 */ function $b847dc1d37d68706$var$toApolloError(err) {
    if ((0, $422HI.isApolloError)(err)) return err;
    const networkError = err instanceof Error ? err : new Error(String(err));
    return new (0, $422HI.ApolloErrorInterop)({
        networkError: networkError
    });
}
function $b847dc1d37d68706$export$dcf9d4e77de27956(query, options) {
    const operationName = (0, $7M67g.getRelayOperationName)(query);
    if ((0, $iffSy.isRelayEnabled)(options?.__callerPackage__, {
        operationName: operationName,
        phase: 'lazy'
    })) // eslint-disable-next-line react-hooks/rules-of-hooks -- Apollo/Relay route is branch-stable for a given caller package.
    return $b847dc1d37d68706$var$useLazyQueryPromiseInteropRelay(query, options);
    // eslint-disable-next-line react-hooks/rules-of-hooks -- Apollo/Relay route is branch-stable for a given caller package.
    return $b847dc1d37d68706$var$useLazyQueryPromiseInteropApollo(query, options);
}
const $b847dc1d37d68706$var$useLazyQueryPromiseInteropApollo = (0, $3u0dr.isReactCompilerActiveV2)() ? function useLazyQueryPromiseInteropApollo(query, options) {
    const $ = (0, $bDgLe.c)(13);
    const resolversRef = (0, $cozmU.useRef)();
    let t0;
    if ($[0] !== query) {
        t0 = (0, $86okN.toDocumentNode)(query);
        $[0] = query;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== options) {
        t1 = options && {
            ...options,
            fetchPolicy: (0, $7q7rs.mapFetchPolicyForApollo)(options.fetchPolicy),
            ...options.nextFetchPolicy ? {
                nextFetchPolicy: (0, $7q7rs.mapFetchPolicyForApollo)(options.nextFetchPolicy)
            } : {}
        };
        $[2] = options;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== t0 || $[5] !== t1) {
        t2 = [
            t0,
            t1
        ];
        $[4] = t0;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    const [doQuery, t3] = (0, $7EPz1.useLazyQuery)(...t2);
    const { data: data, error: error } = t3;
    let t4;
    let t5;
    if ($[7] !== data || $[8] !== error) {
        t4 = ()=>{
            if (data) resolversRef.current?.resolve?.(data);
            if (error) resolversRef.current?.reject?.(error);
        };
        t5 = [
            data,
            error
        ];
        $[7] = data;
        $[8] = error;
        $[9] = t4;
        $[10] = t5;
    } else {
        t4 = $[9];
        t5 = $[10];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[11] !== doQuery) {
        t6 = (vars)=>{
            let resolve;
            let reject;
            const promise = new Promise((res, rej)=>{
                resolve = res;
                reject = rej;
            });
            resolversRef.current = {
                resolve: resolve,
                reject: reject
            };
            doQuery(vars);
            return promise;
        };
        $[11] = doQuery;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
} : function useLazyQueryPromiseInteropApollo(query, options) {
    const resolversRef = (0, $cozmU.useRef)();
    /**
   * NOTE: Using `onCompleted` and `onError` callbacks does not work as expected due to Apollo bug which is present in both v2 and v3 - https://github.com/apollographql/apollo-client/issues/9338
   */ // Interop-only fetch policies must be translated or they reach Apollo untranslated and silently
    // degrade to its default cache behaviour. That matters for `'no-store'` specifically: Apollo's
    // `'no-cache'` is its exact equivalent, and without this mapping a query that is correct today
    // would start writing to the cache.
    const [doQuery, { data: data, error: error }] = (0, $7EPz1.useLazyQuery)(...[
        (0, $86okN.toDocumentNode)(query),
        options && {
            ...options,
            fetchPolicy: (0, $7q7rs.mapFetchPolicyForApollo)(options.fetchPolicy),
            ...options.nextFetchPolicy ? {
                nextFetchPolicy: (0, $7q7rs.mapFetchPolicyForApollo)(options.nextFetchPolicy)
            } : {}
        }
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (data) resolversRef.current?.resolve?.(data);
        if (error) resolversRef.current?.reject?.(error);
    }, [
        data,
        error
    ]);
    return (0, $cozmU.useCallback)((vars)=>{
        let resolve;
        let reject;
        const promise = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        // @ts-expect-error `resolve` and `reject` *will* be assigned via the Promise constructor, but TS can't guarantee that. This should be replaced with `Promise.withResolvers` once out jest setup properly supports that
        resolversRef.current = {
            resolve: resolve,
            reject: reject
        };
        doQuery(vars);
        return promise;
    }, [
        doQuery
    ]);
};
function $b847dc1d37d68706$var$useLazyQueryPromiseInteropRelay(query, options) {
    // Validate before any hook call so the throw isn't masked by useRelayEnvironment().
    if (!('params' in query)) throw new Error(`[Relay migration] unsupported tagged node provided for operation "${(0, $7M67g.getRelayOperationName)(query) ?? 'unknown'}". Please make sure you generated Relay artifacts for your operation`);
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const operationName = (0, $7M67g.getRelayOperationName)(query) ?? undefined;
    const hookVariables = (0, $iF5wn.useMemoObj)(options?.variables, options?.__callerPackage__, {
        operationName: operationName,
        phase: 'memo'
    });
    // Read through refs rather than closing over these directly, so the returned callback keeps a
    // `[environment, query]` dependency list. Every current caller drives it from a `useEffect`
    // dependency array, so a new identity per render would re-fire the query on each render.
    // `context` in particular is usually an inline object and would change identity every time.
    const latestOptionsRef = (0, $cozmU.useRef)(options);
    latestOptionsRef.current = options;
    const hookVariablesRef = (0, $cozmU.useRef)(hookVariables);
    hookVariablesRef.current = hookVariables;
    return (0, $cozmU.useCallback)((callOptions)=>{
        const hookOptions = latestOptionsRef.current;
        // Per-call options win over hook-level ones, and variables merge rather than replace —
        // matching Apollo, which merges the variables handed to its lazy `doQuery` over the ones
        // given to the hook.
        const variables = {
            ...hookVariablesRef.current,
            ...callOptions?.variables
        };
        // Shared with `queryInterop` so the fetch-policy mapping and the `noStore` derivation have
        // one home. `noStore` is load-bearing for this hook specifically: `PagePanelContentQuery`
        // runs through it and is one of the operations whose response carries two `Content` objects
        // sharing an id, so a missed flag reintroduces the record collision.
        return (0, $zXpxJ.executeRelayQuery)({
            environment: environment,
            query: query,
            variables: variables,
            fetchPolicy: callOptions?.fetchPolicy ?? hookOptions?.fetchPolicy,
            errorPolicy: callOptions?.errorPolicy ?? hookOptions?.errorPolicy ?? 'none',
            context: callOptions?.context ?? hookOptions?.context
        }).then((result)=>{
            // Diverges from `queryInterop`, which hands `{ data, error }` back: this hook mirrors
            // Apollo's promise, which rejects. Under `errorPolicy: 'all'` a result carries both
            // data and error, and Apollo's effect resolves before it rejects — a promise settles
            // once — so data being present means resolve.
            if (result.error && result.data === undefined) throw result.error;
            return result.data;
        }).catch((err)=>{
            // Reject with an ApolloErrorInterop on both branches, so callers can read
            // `graphQLErrors` / `networkError` without knowing which branch ran.
            throw $b847dc1d37d68706$var$toApolloError(err);
        });
    }, [
        environment,
        query
    ]);
}
module.exports["useLazyQueryPromiseInterop"] = $b847dc1d37d68706$export$dcf9d4e77de27956;

});

parcelRegister("zCcSI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $kwzZh = parcelRequire("kwzZh");


var $6mKj3 = parcelRequire("6mKj3");


var $32x2E = parcelRequire("32x2E");


var $dPJCf = parcelRequire("dPJCf");


var $bQm3c = parcelRequire("bQm3c");


var $8aF6s = parcelRequire("8aF6s");


var $jyA9t = parcelRequire("jyA9t");


var $c96tF = parcelRequire("c96tF");


var $9cZ1w = parcelRequire("9cZ1w");

const $e34c3f63766da5b3$var$CLOSE_MODAL_DELAY = 500;
const $e34c3f63766da5b3$var$AGENT_MENU_CREATE_SOURCE = 'confluence-rovo-agent-menu-create-agent';
const $e34c3f63766da5b3$export$a9c99c9d804e8c41 = ({ assistanceServiceConfigHeaders: assistanceServiceConfigHeaders = {}, preventAbortRequestsOnStagingModalClose: preventAbortRequestsOnStagingModalClose = false, preventAbortRequestsOnStandaloneChatClose: preventAbortRequestsOnStandaloneChatClose = false })=>{
    const { cloudId: cloudId, orgId: orgId, userId: userId } = (0, $bQm3c.useSessionData)();
    const emojiProvider = (0, $cozmU.useMemo)(()=>{
        return (0, $32x2E.getEmojiProvider)((0, $kwzZh.default), {
            cloudId: cloudId,
            userId: userId
        });
    }, [
        userId,
        cloudId
    ]);
    // Keep the config object identity stable when its semantic inputs are stable.
    const assistanceServiceConfig = (0, $cozmU.useMemo)(()=>({
            headers: assistanceServiceConfigHeaders,
            baseUrl: '/gateway/api/assist'
        }), [
        assistanceServiceConfigHeaders
    ]);
    return (0, $cozmU.useMemo)(()=>({
            displaySubmitFlag: true,
            siteId: cloudId,
            product: 'confluence',
            orgId: orgId,
            assistanceServiceConfig: assistanceServiceConfig,
            emojiProvider: emojiProvider,
            userId: userId ?? undefined,
            preventAbortRequestsOnStagingModalClose: preventAbortRequestsOnStagingModalClose,
            preventAbortRequestsOnStandaloneChatClose: preventAbortRequestsOnStandaloneChatClose
        }), [
        assistanceServiceConfig,
        cloudId,
        emojiProvider,
        orgId,
        preventAbortRequestsOnStagingModalClose,
        preventAbortRequestsOnStandaloneChatClose,
        userId
    ]);
};
const $e34c3f63766da5b3$export$577864d1e6735f1b = ({ flags: flags, customGreeting: customGreeting, shouldShowGreeting: shouldShowGreeting, shouldHideFeedback: shouldHideFeedback })=>{
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const intl = (0, $kSwu1.useIntl)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { openModal: openModal } = (0, $jyA9t.useSmartCreationModalActions)();
    const navigateToObject = (0, $cozmU.useCallback)(async ({ baseUrl: baseUrlNav, path: path })=>{
        (0, $c96tF.createNavigateToObject)(push)({
            baseUrl: baseUrlNav,
            path: path
        });
        // artifical delay before closing the modal gives the app a moment to transition to the created object while the modal is still open, this creates a smoother transition from modal to new object.
        // For non-SPA transitions, a full page reload will happen so this delay will be ignored
        await new Promise((r)=>setTimeout(r, $e34c3f63766da5b3$var$CLOSE_MODAL_DELAY));
    }, [
        push
    ]);
    const showCreateWithRovoModalCloseFeedbackFlag = (0, $9cZ1w.useLazyShowFeedbackFlag)(flags, intl, showModal, createAnalyticsEvent);
    const handleCloseSmartCreate = (0, $cozmU.useCallback)(({ feedbackVariant: feedbackVariant, sourceEntryPoint: sourceEntryPoint, currentConversationId: currentConversationId, traceId: traceId, requestId: requestId, remixMetadata: remixMetadata, contentType: contentType, contentMode: contentMode })=>{
        if (shouldHideFeedback) return;
        if (feedbackVariant === undefined) return;
        showCreateWithRovoModalCloseFeedbackFlag({
            feedbackVariant: feedbackVariant,
            sourceEntryPoint: sourceEntryPoint,
            contentType: contentType,
            contentMode: contentMode,
            cloudId: cloudId,
            currentConversationId: currentConversationId ?? undefined,
            traceId: traceId,
            requestId: requestId,
            remixMetadata: remixMetadata
        });
    }, [
        showCreateWithRovoModalCloseFeedbackFlag,
        shouldHideFeedback,
        cloudId
    ]);
    const handleCreateAgent = (0, $cozmU.useCallback)(()=>{
        if (!(0, $6mKj3.expVal)('cc_contextual_agent_creation_v2', 'isEnabled', false)) return;
        openModal({
            entryPoint: $e34c3f63766da5b3$var$AGENT_MENU_CREATE_SOURCE,
            initialOutcomeType: 'agent',
            lockInitialOutcomeType: true
        });
    }, [
        openModal
    ]);
    // Keep uiConfig identity stable when handler/greeting inputs are stable.
    return (0, $cozmU.useMemo)(()=>({
            customHandlers: {
                onCreateAgentClick: handleCreateAgent,
                handleSubmitSmartCreate: navigateToObject,
                handleCloseSmartCreate: handleCloseSmartCreate
            },
            elements: {
                voiceDictationButton: true,
                shouldShowGreeting: shouldShowGreeting ?? undefined
            },
            customGreeting: customGreeting ?? undefined
        }), [
        customGreeting,
        handleCloseSmartCreate,
        handleCreateAgent,
        navigateToObject,
        shouldShowGreeting
    ]);
};
module.exports["useConversationAssistantConfig"] = $e34c3f63766da5b3$export$a9c99c9d804e8c41;
module.exports["useConversationAssistantUiConfig"] = $e34c3f63766da5b3$export$577864d1e6735f1b;

});

parcelRegister("c96tF", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $jlIaF = parcelRequire("jlIaF");

const $8f856ee350559225$export$b2e60ce4b3907e57 = (baseUrl)=>{
    const host = window.location.host;
    return baseUrl.includes(host) && baseUrl.includes((0, $jlIaF.CONTEXT_PATH));
};
// database need flow query param for special case handling
const $8f856ee350559225$var$addFlowParam = (baseUrl, path)=>{
    const url = new URL(path, baseUrl);
    url.searchParams.set('flow', 'aiCreate');
    return url.pathname + url.search;
};
const $8f856ee350559225$export$38454a8d1321e65a = (push)=>({ baseUrl: baseUrl, path: path })=>{
        const isDatabase = Boolean((0, $1NBp8.DATABASE_VIEW).match(`${baseUrl}${path}`));
        let finalPath = path;
        if (isDatabase) finalPath = $8f856ee350559225$var$addFlowParam(baseUrl, path);
        if ($8f856ee350559225$export$b2e60ce4b3907e57(baseUrl)) push((0, $jlIaF.CONTEXT_PATH) + finalPath);
        else window.location.href = `${baseUrl}${finalPath}`;
    };
module.exports["createNavigateToObject"] = $8f856ee350559225$export$38454a8d1321e65a;

});

parcelRegister("5pQ1Y", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $676464c7222bdee0$export$d84a6ddaa8e6e9d9 = /*#__PURE__*/ (0, $cozmU.createContext)({
    refetchContent: false
});
$676464c7222bdee0$export$d84a6ddaa8e6e9d9.displayName = 'ContentRefetchContext';
const $676464c7222bdee0$export$dfd2d999f6a2731 = /*#__PURE__*/ (0, $cozmU.createContext)({
    setRefetchContent: ()=>{}
});
$676464c7222bdee0$export$dfd2d999f6a2731.displayName = 'ContentRefetchDispatchContext';
const $676464c7222bdee0$export$cfa813593f7b7ba = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { children: children } = t0;
    const [refetchContent, setRefetchContent] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] !== refetchContent) {
        t1 = {
            refetchContent: refetchContent
        };
        $[0] = refetchContent;
        $[1] = t1;
    } else t1 = $[1];
    const providerValue = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            setRefetchContent: (shouldRefetchContent)=>setRefetchContent(shouldRefetchContent)
        };
        $[2] = t2;
    } else t2 = $[2];
    const dispatchProviderValue = t2;
    let t3;
    if ($[3] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($676464c7222bdee0$export$dfd2d999f6a2731.Provider, {
            value: dispatchProviderValue
        }, children);
        $[3] = children;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== providerValue || $[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($676464c7222bdee0$export$d84a6ddaa8e6e9d9.Provider, {
            value: providerValue
        }, t3);
        $[5] = providerValue;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
};
const $676464c7222bdee0$export$68e22604851d391b = ()=>{
    return (0, $cozmU.useContext)($676464c7222bdee0$export$d84a6ddaa8e6e9d9);
};
const $676464c7222bdee0$export$8ebf7a2378ada555 = ()=>{
    return (0, $cozmU.useContext)($676464c7222bdee0$export$dfd2d999f6a2731);
};
module.exports["ContentRefetchProvider"] = $676464c7222bdee0$export$cfa813593f7b7ba;
module.exports["useContentRefetch"] = $676464c7222bdee0$export$68e22604851d391b;
module.exports["useContentRefetchDispatch"] = $676464c7222bdee0$export$8ebf7a2378ada555;

});

parcelRegister("666Tc", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $5SGpQ = parcelRequire("5SGpQ");

const $003eb47e4cfe7fce$var$slideOut = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$48377ae1c677702b = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "ul" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2sNsIg7NXe _4FKVYEXJe6 _3iDTPbQ4SZ _3TGfC9HnLE _0hPCNLDIqT _4kiQYAcM5X",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$4fbc87ee9c503b41 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_35rKQm98eZ _1ghXkF0Rl6 _4xX39A6wH8 _22U8hD7zJH",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // Editor feedback button has a z-index of 460; Table sticky header has a z-index of 500; Renderer Page Toolbar has a z-index of 12
const $003eb47e4cfe7fce$export$f39f3f768bc98e3d = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { isSticky: isSticky, isAutoDismissResolve: isAutoDismissResolve, ...__cmpldp } = __cmplp;
        const { rightOffset: t3 } = __cmplp;
        const rightOffset = t3 === undefined ? 0 : t3;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_16090q4": (0, $9aYkv.default)(`${rightOffset}px`),
                "--_162hus6": (0, $9aYkv.default)(__cmplp.offset, "px")
            },
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_30huDKOeNX _0bjKvD4Y4b _2OUyjtFYNq _0KLXrulfZc _4ApkO2e9hC _2IhTon3k40 _3iDTPbQ4SZ _0aFT5vbt8w _24h04i2Njc _1DCdHiQEt6 _39xV02ehCh _0NUa3rYbGa",
                __cmplp.mode === "view" ? "_42Yu6BYVCu" : "_42Yu6B6zpv",
                __cmplp.isSticky ? "_1mT5xdy1CL" : "_1mT5xdWVPG",
                Boolean(__cmplp.isAutoDismissResolve) && "",
                Boolean(__cmplp.isAutoDismissResolve) && "_2fBhtevGEi",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $003eb47e4cfe7fce$export$82f8f5af33982290 = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { isSticky: isSticky, isAutoDismissResolve: isAutoDismissResolve, ...__cmpldp } = __cmplp;
        const { rightOffset: t3 } = __cmplp;
        const rightOffset = t3 === undefined ? 0 : t3;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_16090q4": (0, $9aYkv.default)(`${rightOffset}px`),
                "--_162hus6": (0, $9aYkv.default)(__cmplp.offset, "px")
            },
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_30huDKOeNX _0bjKvDyzSk _2OUyjtGk8v _0KLXrulfZc _4ApkO2e9hC _2IhTon3k40 _3iDTPbQ4SZ _0aFT5vbt8w _24h04i2Njc _1DCdHiQEt6 _39xV02ehCh _0NUa3rYbGa",
                __cmplp.mode === "view" ? "_42Yu6BYVCu" : "_42Yu6B6zpv",
                __cmplp.isSticky ? "_1mT5xdy1CL" : "_1mT5xdWVPG",
                Boolean(__cmplp.isAutoDismissResolve) && "",
                Boolean(__cmplp.isAutoDismissResolve) && "_2fBhtevGEi",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $003eb47e4cfe7fce$export$18986330a3dbad03 = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
/*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5vbt8w _0KLXrulfZc _0kH15VOeNX",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$86b1f0d05f7b12cd = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(11);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { isCommentsPanel: isCommentsPanel, isFabricPage: isFabricPage, isStandaloneComment: isStandaloneComment, ...__cmpldp } = __cmplp;
        let result;
        if (__cmplp.isStandaloneComment) result = "var(--ds-space-150, 12px)";
        else {
            const basePadding = __cmplp.mode === "view" ? "var(--ds-space-150, 12px) var(--ds-space-200, 16px)" : "var(--ds-space-100, 8px) var(--ds-space-150, 12px)";
            result = __cmplp.isCommentsPanel ? "0" : basePadding;
        }
        const t3 = result;
        let t4;
        if ($[3] !== t3) {
            t4 = (0, $9aYkv.default)(t3);
            $[3] = t3;
            $[4] = t4;
        } else t4 = $[4];
        let result_0;
        if (__cmplp.isStandaloneComment) result_0 = "var(--ds-space-150, 12px)";
        else if (!__cmplp.isCommentsPanel) result_0 = "var(--ds-space-200, 16px)";
        else result_0 = "var(--ds-space-150, 12px)";
        const t5 = result_0;
        let t6;
        if ($[5] !== t5) {
            t6 = (0, $9aYkv.default)(t5);
            $[5] = t5;
            $[6] = t6;
        } else t6 = $[6];
        let t7;
        if ($[7] !== __cmpls || $[8] !== t4 || $[9] !== t6) {
            t7 = {
                ...__cmpls,
                "--_4ynthd": t4,
                "--_af4pt2": t6
            };
            $[7] = __cmpls;
            $[8] = t4;
            $[9] = t6;
            $[10] = t7;
        } else t7 = $[10];
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
            ...__cmpldp,
            style: t7,
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_4FKVYE9A9H _1wydGWcX41 _3HchHnGPOD _2ITIGQUofl _4xN29yKGUX",
                __cmplp.isCommentsPanel || __cmplp.isFabricPage ? "_2bqfgdYbGa" : "_2bqfgdNCjk",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $003eb47e4cfe7fce$export$5aae1a36fc838370 = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
/*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4FKVYEOKqs _3iDTPbQ4SZ _0hPCNLDIqT _0aFT5vbt8w _3zRROk7NXe _0BZd8NnlTt _1lgKZdxah3 _2waFOoy7kJ _0csg4eDIqT _0XEZqI7NXe _0TAcaW8HPE _0mTZRh7zJH _45Fm8lDIqT",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // View mode styled components
const $003eb47e4cfe7fce$export$b38a2fd24b22fb35 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isReply: isReply, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "",
            !__cmplp.isReply && "_4FKVYE8HPE _1x1D3gOeNX",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$d1b98bde82a43bb3 = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
/*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _2OcHUsFQfX _4pkS4ZuFDC _33EFmxgv4a _4fkkfBZpcK",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $003eb47e4cfe7fce$export$6e006bd290301009 = '24px';
const $003eb47e4cfe7fce$export$3421cb2750fe78a7 = '28px';
const $003eb47e4cfe7fce$export$28ae196bde1430fd = '24px'; // Needed to get the correct overall size to match the comment icon next to it
const $003eb47e4cfe7fce$var$inlineHeaderButtonTheme = (isSSRFocusedComment)=>(currentTheme, themeProps)=>{
        const theme = currentTheme(themeProps);
        return {
            ...theme,
            buttonStyles: {
                ...theme.buttonStyles,
                background: 'none',
                borderRadius: "var(--ds-radius-small, 4px)",
                height: $003eb47e4cfe7fce$export$6e006bd290301009,
                width: $003eb47e4cfe7fce$export$6e006bd290301009,
                '&:hover': {
                    backgroundColor: `${"var(--ds-surface-hovered, #F0F1F2)"}`
                },
                '&:focus': {
                    boxShadow: `0 0 0 2px ${"var(--ds-border-focused, #4688EC)"}`
                },
                cursor: isSSRFocusedComment ? 'not-allowed' : 'pointer',
                '*': {
                    color: isSSRFocusedComment ? `${"var(--ds-text-subtlest, #6B6E76)"}` : `inherit`
                }
            }
        };
    };
const $003eb47e4cfe7fce$export$2616e8e1e1a7c3e5 = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    let isSSRFocusedComment;
    let props;
    if ($[0] !== t0) {
        ({ isSSRFocusedComment: isSSRFocusedComment, ...props } = t0);
        $[0] = t0;
        $[1] = isSSRFocusedComment;
        $[2] = props;
    } else {
        isSSRFocusedComment = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] !== isSSRFocusedComment) {
        t1 = $003eb47e4cfe7fce$var$inlineHeaderButtonTheme(isSSRFocusedComment);
        $[3] = isSSRFocusedComment;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== props || $[6] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5SGpQ.default), {
            theme: t1,
            ...props
        });
        $[5] = props;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
};
const $003eb47e4cfe7fce$export$e575a964a1fe8b0 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { shouldShowNavigation: shouldShowNavigation, isReattachHeader: isReattachHeader, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1mT5xdRAKS _3iDTPbQ4SZ _2Zuz6Q8HPE _1Znuxb8HPE",
            __cmplp.shouldShowNavigation ? "_37wbyuI7V3" : "_37wbyuz9WS",
            __cmplp.shouldShowNavigation && "_0jFU0VfFOW _0Of8r28HPE",
            __cmplp.isReattachHeader && "_0jFU0VfFOW _0Of8r25zaO",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$b3b0191112eea395 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $003eb47e4cfe7fce$export$f39f3f768bc98e3d : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_39xV02ehCh _0jFU0V71Z1",
            __cmplp.showSkeleton ? "_3iDTPbvLZJ" : "_3iDTPbYbGa",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $003eb47e4cfe7fce$export$f895097fe90363d1 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { showNavigation: showNavigation, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ",
            __cmplp.showNavigation ? "_313842Va5s" : "_313842Pgdg",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$32dd8f1956fe77b1 = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
/*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1mT5xdWVPG _4ApkO28HPE _42Yu6B7dHp _2IhTon8HPE",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$4b61d9d7155e9162 = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
/*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2mHwu8gVvo _1mT5xdWVPG _2IhTon5zaO _3OE6xY5zaO _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $003eb47e4cfe7fce$var$closeButtonTheme = (isUpdatedStandaloneComment)=>(currentTheme, themeProps)=>{
        const theme = currentTheme(themeProps);
        return {
            ...theme,
            buttonStyles: {
                ...theme.buttonStyles,
                height: $003eb47e4cfe7fce$export$6e006bd290301009,
                width: isUpdatedStandaloneComment ? $003eb47e4cfe7fce$export$28ae196bde1430fd : $003eb47e4cfe7fce$export$3421cb2750fe78a7
            }
        };
    };
const $003eb47e4cfe7fce$export$de65de8213222d10 = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    let isUpdatedStandaloneComment;
    let props;
    if ($[0] !== t0) {
        ({ isUpdatedStandaloneComment: isUpdatedStandaloneComment, ...props } = t0);
        $[0] = t0;
        $[1] = isUpdatedStandaloneComment;
        $[2] = props;
    } else {
        isUpdatedStandaloneComment = $[1];
        props = $[2];
    }
    const t1 = isUpdatedStandaloneComment ?? false;
    let t2;
    if ($[3] !== t1) {
        t2 = $003eb47e4cfe7fce$var$closeButtonTheme(t1);
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== props || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5SGpQ.default), {
            theme: t2,
            ...props
        });
        $[5] = props;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};
module.exports["ActionsContainer"] = $003eb47e4cfe7fce$export$48377ae1c677702b;
module.exports["SidebarContainer"] = $003eb47e4cfe7fce$export$f39f3f768bc98e3d;
module.exports["SidebarContainerRounded"] = $003eb47e4cfe7fce$export$82f8f5af33982290;
module.exports["ReplyListContainer"] = $003eb47e4cfe7fce$export$18986330a3dbad03;
module.exports["NewReplyContainer"] = $003eb47e4cfe7fce$export$86b1f0d05f7b12cd;
module.exports["ResolvedNotificationContainer"] = $003eb47e4cfe7fce$export$5aae1a36fc838370;
module.exports["EditorContainer"] = $003eb47e4cfe7fce$export$b38a2fd24b22fb35;
module.exports["NavigationContainer"] = $003eb47e4cfe7fce$export$d1b98bde82a43bb3;
module.exports["InlineHeaderButton"] = $003eb47e4cfe7fce$export$2616e8e1e1a7c3e5;
module.exports["SidebarHeader"] = $003eb47e4cfe7fce$export$e575a964a1fe8b0;
module.exports["LoadingSkeletonContainer"] = $003eb47e4cfe7fce$export$b3b0191112eea395;
module.exports["CloseButtonContainer"] = $003eb47e4cfe7fce$export$32dd8f1956fe77b1;
module.exports["CloseButton"] = $003eb47e4cfe7fce$export$de65de8213222d10;

});

parcelRegister("8SCD6", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $l5y3Y = parcelRequire("l5y3Y");

const $6881c6359fe8b822$export$4da9db299e81cd38 = /*#__PURE__*/ (0, $cozmU.createContext)({
    isReactionsEnabled: false
});
$6881c6359fe8b822$export$4da9db299e81cd38.displayName = 'ReactionsContext';
const $6881c6359fe8b822$export$2157a4212fd7f5b1 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { contentId: contentId, children: children } = t0;
    const isReactionsEnabled = (0, $l5y3Y.useIsReactionsEnabled)(contentId);
    let t1;
    if ($[0] !== isReactionsEnabled) {
        t1 = {
            isReactionsEnabled: isReactionsEnabled
        };
        $[0] = isReactionsEnabled;
        $[1] = t1;
    } else t1 = $[1];
    const reactionsContextValue = t1;
    let t2;
    if ($[2] !== children || $[3] !== reactionsContextValue) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6881c6359fe8b822$export$4da9db299e81cd38.Provider, {
            value: reactionsContextValue
        }, children);
        $[2] = children;
        $[3] = reactionsContextValue;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ contentId: contentId, children: children })=>{
    const isReactionsEnabled = (0, $l5y3Y.useIsReactionsEnabled)(contentId);
    const reactionsContextValue = (0, $cozmU.useMemo)(()=>({
            isReactionsEnabled: isReactionsEnabled
        }), [
        isReactionsEnabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6881c6359fe8b822$export$4da9db299e81cd38.Provider, {
        value: reactionsContextValue
    }, children);
};
module.exports["ReactionsContext"] = $6881c6359fe8b822$export$4da9db299e81cd38;
module.exports["ReactionsProvider"] = $6881c6359fe8b822$export$2157a4212fd7f5b1;

});

parcelRegister("l5y3Y", function(module, exports) {
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports

var $jtuBN = parcelRequire("jtuBN");


var $eSLr0 = parcelRequire("eSLr0");


var $9Z1sw = parcelRequire("9Z1sw");


var $dPJCf = parcelRequire("dPJCf");

const $13602a0094cde4d6$export$da23010c6e2ddd94 = (contentId)=>{
    const isPDFExport = (0, $dPJCf.usePathnameMatcher)({
        selector: (pathname)=>pathname?.indexOf('/wiki/pdf/') !== -1
    });
    const baseOptions = {
        variables: {
            contentId: contentId,
            location: (0, $eSLr0.ATL_PAGE_CONTENT_FOOTER_ACTIONS)
        },
        skip: isPDFExport
    };
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const queryResult = (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $9Z1sw.WebPanelLocationQuery), {
        ...baseOptions,
        __callerPackage__: "comments-hooks"
    });
    const data = queryResult.data;
    return !isPDFExport && Boolean(data?.webPanels?.length);
};
module.exports["useIsReactionsEnabled"] = $13602a0094cde4d6$export$da23010c6e2ddd94;

});

parcelRegister("jyPfN", function(module, exports) {

var $foQ4a = parcelRequire("foQ4a");

const $10d1e40b190a4139$export$5a38a817745a0c6f = ()=>{
    const { isExternalCollaborator: isExternalCollaborator } = (0, $foQ4a.useIsExternalCollaborator)();
    return {
        canViewUserProfile: !isExternalCollaborator
    };
};
module.exports["useViewUserProfile"] = $10d1e40b190a4139$export$5a38a817745a0c6f;

});

parcelRegister("8lYIw", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7fpiF = parcelRequire("7fpiF");


var $7zgzO = parcelRequire("7zgzO");


var $dHSeC = parcelRequire("dHSeC");

const $9673d4c78655a9a1$export$a6c7ac8248d6e38a = /*#__PURE__*/ (0, $cozmU.forwardRef)((props, ref)=>{
    const $ = (0, $bDgLe.c)(9);
    const { target: t0, name: name, href: t1, to: t2, params: t3 } = props;
    const target = t0 === undefined ? undefined : t0;
    const href = t1 === undefined ? null : t1;
    const to = t2 === undefined ? null : t2;
    const params = t3 === undefined ? {} : t3;
    const routesContext = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const { matchSupportedRoute: matchSupportedRoute, toUrl: toUrl } = routesContext;
    const customPath = href || to;
    if (!customPath && !name) {
        let t4;
        if ($[0] !== props || $[1] !== ref) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9673d4c78655a9a1$var$WrappedAnchor, {
                ...props,
                ref: ref,
                path: ""
            });
            $[0] = props;
            $[1] = ref;
            $[2] = t4;
        } else t4 = $[2];
        return t4;
    }
    const hrefParams = customPath && {
        href: customPath
    };
    const path = toUrl(name, {
        ...params,
        ...hrefParams
    });
    const match = matchSupportedRoute(path);
    let t4;
    if ($[3] !== match || $[4] !== path || $[5] !== props || $[6] !== ref || $[7] !== target) {
        t4 = match && target !== "_blank" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9673d4c78655a9a1$var$WrappedReactRouterLink, {
            ...props,
            ref: ref,
            match: match
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9673d4c78655a9a1$var$WrappedAnchor, {
            ...props,
            ref: ref,
            path: path
        });
        $[3] = match;
        $[4] = path;
        $[5] = props;
        $[6] = ref;
        $[7] = target;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
});
const $9673d4c78655a9a1$var$WrappedAnchor = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, ref)=>{
    const $ = (0, $bDgLe.c)(21);
    let parentProps;
    let path;
    if ($[0] !== t0) {
        ({ path: path, ...parentProps } = t0);
        $[0] = t0;
        $[1] = parentProps;
        $[2] = path;
    } else {
        parentProps = $[1];
        path = $[2];
    }
    const { children: children, className: className, target: t1, testId: testId, style: style, id: id } = parentProps;
    const target = t1 === undefined ? undefined : t1;
    const routesContext = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const { onPageReload: onPageReload } = routesContext;
    let t2;
    if ($[3] !== onPageReload || $[4] !== parentProps) {
        t2 = (e)=>{
            onPageReload(e.target.getAttribute("href"), false);
            if (parentProps.onClick) parentProps.onClick(e);
        };
        $[3] = onPageReload;
        $[4] = parentProps;
        $[5] = t2;
    } else t2 = $[5];
    const onAnchorLinkClick = t2;
    let t3;
    if ($[6] !== parentProps) {
        t3 = (e_0)=>{
            parentProps.onContextMenu?.(e_0);
        };
        $[6] = parentProps;
        $[7] = t3;
    } else t3 = $[7];
    const onAnchorContextMenuClick = t3;
    const t4 = target === "_blank" ? "noreferrer" : undefined;
    const t5 = parentProps["aria-label"];
    let t6;
    if ($[8] !== children || $[9] !== className || $[10] !== id || $[11] !== onAnchorContextMenuClick || $[12] !== onAnchorLinkClick || $[13] !== path || $[14] !== ref || $[15] !== style || $[16] !== t4 || $[17] !== t5 || $[18] !== target || $[19] !== testId) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("a", {
            href: path,
            className: className,
            onClick: onAnchorLinkClick,
            onContextMenu: onAnchorContextMenuClick,
            target: target,
            id: id,
            rel: t4,
            "data-testid": testId,
            ref: ref,
            "aria-label": t5,
            style: style
        }, children);
        $[8] = children;
        $[9] = className;
        $[10] = id;
        $[11] = onAnchorContextMenuClick;
        $[12] = onAnchorLinkClick;
        $[13] = path;
        $[14] = ref;
        $[15] = style;
        $[16] = t4;
        $[17] = t5;
        $[18] = target;
        $[19] = testId;
        $[20] = t6;
    } else t6 = $[20];
    return t6;
});
const $9673d4c78655a9a1$var$WrappedReactRouterLink = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, ref)=>{
    const $ = (0, $bDgLe.c)(22);
    let match;
    let parentProps;
    if ($[0] !== t0) {
        ({ match: match, ...parentProps } = t0);
        $[0] = t0;
        $[1] = match;
        $[2] = parentProps;
    } else {
        match = $[1];
        parentProps = $[2];
    }
    const routesContext = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const { children: children, className: className, style: style, id: id } = parentProps;
    const { preloadRoute: preloadRoute } = routesContext;
    let t1;
    if ($[3] !== match || $[4] !== preloadRoute) {
        t1 = async ()=>preloadRoute(match);
        $[3] = match;
        $[4] = preloadRoute;
        $[5] = t1;
    } else t1 = $[5];
    const onMouseDownCapture = t1;
    let t2;
    if ($[6] !== parentProps || $[7] !== routesContext) {
        t2 = (event)=>{
            if (parentProps.onClick) parentProps.onClick(event);
            const details = (0, $dHSeC.getSpaTransitionDetails)(event, routesContext);
            if (!event.defaultPrevented && details?.href) {
                event.preventDefault();
                routesContext.push(details.href);
            }
        };
        $[6] = parentProps;
        $[7] = routesContext;
        $[8] = t2;
    } else t2 = $[8];
    const onClick = t2;
    let t3;
    if ($[9] !== parentProps) {
        t3 = (e)=>{
            parentProps.onContextMenu?.(e);
        };
        $[9] = parentProps;
        $[10] = t3;
    } else t3 = $[10];
    const onContextMenu = t3;
    const t4 = `${match.pathname}${match.search}${match.hash}`;
    const t5 = parentProps["aria-label"];
    let t6;
    if ($[11] !== children || $[12] !== className || $[13] !== id || $[14] !== onClick || $[15] !== onContextMenu || $[16] !== onMouseDownCapture || $[17] !== ref || $[18] !== style || $[19] !== t4 || $[20] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7fpiF.Link), {
            to: t4,
            className: className,
            onClick: onClick,
            onContextMenu: onContextMenu,
            onMouseDownCapture: onMouseDownCapture,
            innerRef: ref,
            id: id,
            "aria-label": t5,
            style: style
        }, children);
        $[11] = children;
        $[12] = className;
        $[13] = id;
        $[14] = onClick;
        $[15] = onContextMenu;
        $[16] = onMouseDownCapture;
        $[17] = ref;
        $[18] = style;
        $[19] = t4;
        $[20] = t5;
        $[21] = t6;
    } else t6 = $[21];
    return t6;
});
module.exports["Link"] = $9673d4c78655a9a1$export$a6c7ac8248d6e38a;

});

parcelRegister("7fpiF", function(module, exports) {

var $KDAt0 = parcelRequire("KDAt0");


var $cgTkH = parcelRequire("cgTkH");


var $cozmU = parcelRequire("cozmU");


var $22s37 = parcelRequire("22s37");




var $eb3ax = parcelRequire("eb3ax");


var $1eVGO = parcelRequire("1eVGO");


var $bB0i2 = parcelRequire("bB0i2");

/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $546d8f2c65102c44$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $cgTkH.default)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $22s37.createBrowserHistory)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $KDAt0.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $546d8f2c65102c44$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $cgTkH.default)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $22s37.createHashHistory)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $KDAt0.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component);
var $546d8f2c65102c44$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $546d8f2c65102c44$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, $22s37.createLocation)(to, null, null, currentLocation) : to;
};
var $546d8f2c65102c44$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $546d8f2c65102c44$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef;
if (typeof $546d8f2c65102c44$var$forwardRef === "undefined") $546d8f2c65102c44$var$forwardRef = $546d8f2c65102c44$var$forwardRefShim;
function $546d8f2c65102c44$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $546d8f2c65102c44$var$LinkAnchor = $546d8f2c65102c44$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, $1eVGO.default)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, $eb3ax.default)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$546d8f2c65102c44$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($546d8f2c65102c44$var$forwardRefShim !== $546d8f2c65102c44$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var $546d8f2c65102c44$export$a6c7ac8248d6e38a = $546d8f2c65102c44$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $546d8f2c65102c44$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, $1eVGO.default)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $KDAt0.__RouterContext).Consumer, null, function(context) {
        !context && (0, $bB0i2.default)(false);
        var history = context.history;
        var location = $546d8f2c65102c44$var$normalizeToLocation($546d8f2c65102c44$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, $eb3ax.default)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $546d8f2c65102c44$var$resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, $22s37.createPath)(context.location) === (0, $22s37.createPath)($546d8f2c65102c44$var$normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if ($546d8f2c65102c44$var$forwardRefShim !== $546d8f2c65102c44$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(component, props);
    });
});
var $546d8f2c65102c44$var$toType, $546d8f2c65102c44$var$refType;
var $546d8f2c65102c44$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $546d8f2c65102c44$var$forwardRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef;
if (typeof $546d8f2c65102c44$var$forwardRef$1 === "undefined") $546d8f2c65102c44$var$forwardRef$1 = $546d8f2c65102c44$var$forwardRefShim$1;
function $546d8f2c65102c44$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $546d8f2c65102c44$export$b0d92dbee9b5b60d = $546d8f2c65102c44$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, $1eVGO.default)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $KDAt0.__RouterContext).Consumer, null, function(context) {
        !context && (0, $bB0i2.default)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = $546d8f2c65102c44$var$normalizeToLocation($546d8f2c65102c44$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, $KDAt0.matchPath)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = $546d8f2c65102c44$var$joinClassnames(className, activeClassName);
            style = (0, $eb3ax.default)({}, style, activeStyle);
        }
        var props = (0, $eb3ax.default)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($546d8f2c65102c44$var$forwardRefShim$1 !== $546d8f2c65102c44$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($546d8f2c65102c44$export$a6c7ac8248d6e38a, props);
    });
});
var $546d8f2c65102c44$var$ariaCurrentType;
 //# sourceMappingURL=react-router-dom.js.map
module.exports["Link"] = $546d8f2c65102c44$export$a6c7ac8248d6e38a;

});

parcelRegister("22s37", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $5hfGv = parcelRequire("5hfGv");


var $ucZb7 = parcelRequire("ucZb7");



var $bB0i2 = parcelRequire("bB0i2");

function $17c186b078d80207$var$addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
}
function $17c186b078d80207$var$stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
}
function $17c186b078d80207$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function $17c186b078d80207$var$stripBasename(path, prefix) {
    return $17c186b078d80207$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $17c186b078d80207$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function $17c186b078d80207$export$8ccf933b0513f8d0(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
}
function $17c186b078d80207$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
    return path;
}
function $17c186b078d80207$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === 'string') {
        // Two-arg form: push(path, state)
        location = $17c186b078d80207$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $eb3ax.default)({}, path);
        if (location.pathname === undefined) location.pathname = '';
        if (location.search) {
            if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
        } else location.search = '';
        if (location.hash) {
            if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
        } else location.hash = '';
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== '/') location.pathname = (0, $5hfGv.default)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = '/';
    return location;
}
function $17c186b078d80207$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $ucZb7.default)(a.state, b.state);
}
function $17c186b078d80207$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
            if (typeof result === 'string') {
                if (typeof getUserConfirmation === 'function') getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $17c186b078d80207$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $17c186b078d80207$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $17c186b078d80207$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $17c186b078d80207$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $17c186b078d80207$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $17c186b078d80207$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}
var $17c186b078d80207$var$PopStateEvent = 'popstate';
var $17c186b078d80207$var$HashChangeEvent = 'hashchange';
function $17c186b078d80207$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $17c186b078d80207$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$17c186b078d80207$var$canUseDOM && (0, $bB0i2.default)(false);
    var globalHistory = window.history;
    var canUseHistory = $17c186b078d80207$var$supportsHistory();
    var needsHashChangeListener = !$17c186b078d80207$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $17c186b078d80207$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $17c186b078d80207$var$stripTrailingSlash($17c186b078d80207$var$addLeadingSlash(props.basename)) : '';
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $17c186b078d80207$var$stripBasename(path, basename);
        return $17c186b078d80207$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $17c186b078d80207$var$createTransitionManager();
    function setState(nextState) {
        (0, $eb3ax.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($17c186b078d80207$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($17c186b078d80207$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($17c186b078d80207$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $17c186b078d80207$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $17c186b078d80207$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $17c186b078d80207$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($17c186b078d80207$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($17c186b078d80207$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($17c186b078d80207$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($17c186b078d80207$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $17c186b078d80207$var$HashChangeEvent$1 = 'hashchange';
var $17c186b078d80207$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === '!' ? path : '!/' + $17c186b078d80207$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === '!' ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $17c186b078d80207$var$stripLeadingSlash,
        decodePath: $17c186b078d80207$var$addLeadingSlash
    },
    slash: {
        encodePath: $17c186b078d80207$var$addLeadingSlash,
        decodePath: $17c186b078d80207$var$addLeadingSlash
    }
};
function $17c186b078d80207$var$stripHash(url) {
    var hashIndex = url.indexOf('#');
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $17c186b078d80207$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf('#');
    return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}
function $17c186b078d80207$var$pushHashPath(path) {
    window.location.hash = path;
}
function $17c186b078d80207$var$replaceHashPath(path) {
    window.location.replace($17c186b078d80207$var$stripHash(window.location.href) + '#' + path);
}
function $17c186b078d80207$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$17c186b078d80207$var$canUseDOM && (0, $bB0i2.default)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $17c186b078d80207$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $17c186b078d80207$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
    var basename = props.basename ? $17c186b078d80207$var$stripTrailingSlash($17c186b078d80207$var$addLeadingSlash(props.basename)) : '';
    var _HashPathCoders$hashT = $17c186b078d80207$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($17c186b078d80207$var$getHashPath());
        if (basename) path = $17c186b078d80207$var$stripBasename(path, basename);
        return $17c186b078d80207$export$90c043f1c57770b8(path);
    }
    var transitionManager = $17c186b078d80207$var$createTransitionManager();
    function setState(nextState) {
        (0, $eb3ax.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $17c186b078d80207$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $17c186b078d80207$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $17c186b078d80207$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($17c186b078d80207$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($17c186b078d80207$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $17c186b078d80207$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $17c186b078d80207$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $17c186b078d80207$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector('base');
        var href = '';
        if (baseTag && baseTag.getAttribute('href')) href = $17c186b078d80207$var$stripHash(window.location.href);
        return href + '#' + encodePath(basename + $17c186b078d80207$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $17c186b078d80207$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $17c186b078d80207$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $17c186b078d80207$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $17c186b078d80207$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($17c186b078d80207$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $17c186b078d80207$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $17c186b078d80207$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $17c186b078d80207$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $17c186b078d80207$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($17c186b078d80207$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($17c186b078d80207$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($17c186b078d80207$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $17c186b078d80207$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $17c186b078d80207$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        '/'
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $17c186b078d80207$var$createTransitionManager();
    function setState(nextState) {
        (0, $eb3ax.default)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $17c186b078d80207$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === 'string' ? $17c186b078d80207$export$90c043f1c57770b8(entry, undefined, createKey()) : $17c186b078d80207$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $17c186b078d80207$export$fe53371bee54353d;
    function push(path, state) {
        var action = 'PUSH';
        var location = $17c186b078d80207$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $17c186b078d80207$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $17c186b078d80207$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = 'POP';
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: 'POP',
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}
module.exports["createPath"] = $17c186b078d80207$export$fe53371bee54353d;
module.exports["createLocation"] = $17c186b078d80207$export$90c043f1c57770b8;
module.exports["createBrowserHistory"] = $17c186b078d80207$export$719fc203c4e16dee;
module.exports["createHashHistory"] = $17c186b078d80207$export$b71fdd3798280242;

});

parcelRegister("a6t12", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kNIYN = parcelRequire("kNIYN");


var $9DHhW = parcelRequire("9DHhW");


var $hSs5g = parcelRequire("hSs5g");


var $9zU5G = parcelRequire("9zU5G");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $jyPfN = parcelRequire("jyPfN");


var $jlIaF = parcelRequire("jlIaF");


var $bQm3c = parcelRequire("bQm3c");


var $gqqjz = parcelRequire("gqqjz");

parcelRequire("6OL2O");
var $5t3NX = parcelRequire("5t3NX");

parcelRequire("dD7ks");
var $4N3op = parcelRequire("4N3op");


var $bedVD = parcelRequire("bedVD");


var $l7wqU = parcelRequire("l7wqU");


var $4GlQ9 = parcelRequire("4GlQ9");


var $bumSD = parcelRequire("bumSD");


var $4qzKl = parcelRequire("4qzKl");


var $gj42z = parcelRequire("gj42z");

const $3d0f3ea3171aff68$var$i18n = (0, $kSwu1.defineMessages)({
    viewProfile: {
        id: "profile.card.viewProfile",
        defaultMessage: "View profile"
    }
});
const $3d0f3ea3171aff68$export$98f80b73da7beaf4 = ({ push: push, userId: userId })=>({
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3d0f3ea3171aff68$var$i18n.viewProfile),
        id: 'view-profile',
        callback: ()=>(0, $4qzKl.getAtlassianPeopleProfileUrlAsync)(userId).then(push),
        shouldRender: (userData)=>{
            // missing/deleted/corrupted users don't return any data or status
            if (!userData) return false;
            return userData.status && userData.status !== 'inactive';
        },
        link: (0, $4qzKl.getAtlassianPeopleProfileUrl)(userId, '', (0, $jlIaF.CONTEXT_PATH))
    });
const $3d0f3ea3171aff68$export$4f94384af0327320 = ({ navigate: navigate, url: url })=>({
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3d0f3ea3171aff68$var$i18n.viewProfile),
        id: 'view-profile',
        callback: navigate,
        shouldRender: (userData)=>{
            // missing/deleted/corrupted users don't return any data or status
            if (!userData) return false;
            return userData.status && userData.status !== 'inactive';
        },
        link: url
    });
const $3d0f3ea3171aff68$export$d114163e55e8b2c5 = ({ loggedInUserId: loggedInUserId, getToggleFollowUser: getToggleFollowUser, renderFeedFollow: renderFeedFollow, userId: userId, followedUsers: followedUsers })=>{
    const followed = !!(userId && followedUsers?.includes(userId));
    return {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bedVD.FeedFollow), {
            followed: followed
        }),
        id: 'feed-follow-user',
        callback: getToggleFollowUser(userId, followed, 'profileCard'),
        shouldRender: (userData)=>renderFeedFollow && Boolean(userId) && userId !== loggedInUserId && userData?.status === 'active'
    };
};
const $3d0f3ea3171aff68$export$ba990269c861f33b = ({ loggedInUserId: loggedInUserId, getToggleFollowUser: getToggleFollowUser, renderFeedFollow: renderFeedFollow, followedRef: followedRef, userId: userId })=>({
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l7wqU.FeedFollowAction), {
            userId: userId
        }),
        id: 'feed-follow-user',
        callback: ()=>getToggleFollowUser(userId, followedRef.current, 'profileCard')(),
        shouldRender: ()=>renderFeedFollow && Boolean(userId) && userId !== loggedInUserId
    });
const $3d0f3ea3171aff68$export$59abd6feb7dc8540 = ({ position: position = 'bottom-start', userId: userId, isAnonymous: isAnonymous = false, canViewProfile: canViewProfile = true, children: children, trigger: trigger = 'hover', fullName: fullName, disabledAriaAttributes: disabledAriaAttributes, onVisibilityChange: onVisibilityChange, offset: offset, ariaLabel: ariaLabel, agent: agent, fullWidthTrigger: fullWidthTrigger })=>{
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const { userId: loggedInUserId, cloudId: cloudId, featureFlags: featureFlags, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const reportingLines = (0, $4N3op.useNavigateToTeamsApp)({
        type: 'LANDING'
    });
    const getReportingLinesUserProfile = (clickedUserId)=>(0, $5t3NX.getNavigateToTeamsApp)(orgId || '', {
            type: 'USER',
            payload: {
                userId: clickedUserId
            }
        });
    const userProfile = (0, $4N3op.useNavigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: userId || ''
        }
    });
    const reportingLinesProfileUrl = reportingLines.href;
    const { feedConfigError: feedConfigError, followedUsers: followedUsers, getToggleFollowUser: getToggleFollowUser, mutationError: mutationError, renderFeedFollow: renderFeedFollow } = (0, $4GlQ9.useFeedFollow)();
    const viewProfileAction = (0, $cozmU.useMemo)(()=>$3d0f3ea3171aff68$export$4f94384af0327320({
            navigate: userProfile.onNavigate,
            url: userProfile.href
        }), [
        userProfile
    ]);
    const followUserAction = (0, $cozmU.useMemo)(()=>$3d0f3ea3171aff68$export$d114163e55e8b2c5({
            loggedInUserId: loggedInUserId,
            getToggleFollowUser: getToggleFollowUser,
            renderFeedFollow: renderFeedFollow,
            userId: userId,
            followedUsers: followedUsers
        }), [
        loggedInUserId,
        getToggleFollowUser,
        renderFeedFollow,
        userId,
        followedUsers
    ]);
    // The card snapshots the actions, so the follow callback reads the latest follow state
    // from this ref (updated on every render) instead of a value captured when the action
    // was built. This keeps repeated follow/unfollow toggles in the correct direction.
    const followedRef = (0, $cozmU.useRef)(false);
    followedRef.current = !!(userId && followedUsers?.includes(userId));
    const followUserActionNext = (0, $cozmU.useMemo)(()=>$3d0f3ea3171aff68$export$ba990269c861f33b({
            loggedInUserId: loggedInUserId,
            getToggleFollowUser: getToggleFollowUser,
            renderFeedFollow: renderFeedFollow,
            followedRef: followedRef,
            userId: userId
        }), [
        loggedInUserId,
        getToggleFollowUser,
        renderFeedFollow,
        userId
    ]);
    // Should display profile?
    if (isAnonymous || !canViewProfile || !userId || !loggedInUserId || !hasViewUserProfilePermission) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    const reportingLinesClickCallback = (clickedUserId_0)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'profileCardWrapper',
                action: 'clicked',
                actionSubject: 'viewProfile',
                actionSubjectId: 'userProfileCard',
                attributes: {
                    clickTarget: 'userReportingLine'
                }
            }
        }).fire();
        getReportingLinesUserProfile(clickedUserId_0).onNavigate();
        return false;
    };
    if ((0, $9wGTI.fg)('people-teams_migrate-user-profile-card') || (0, $6mKj3.expValEquals)('pt_user_profile_card_migration_exp', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gj42z.FeedFollowErrorDisplay), {
        feedConfigError: feedConfigError,
        mutationError: mutationError,
        showErrorFlag: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9zU5G.UserProfileCardWithTrigger), {
        cloudId: cloudId,
        orgId: orgId || '',
        userId: userId,
        viewerId: loggedInUserId,
        placement: position,
        offset: offset,
        trigger: trigger,
        fullWidthTrigger: fullWidthTrigger,
        actions: [
            followUserActionNext
        ],
        isAgent: Boolean(agent),
        agent: agent ? {
            ...agent,
            resourceClient: (0, $bumSD.getProfileClient)(cloudId, featureFlags)
        } : undefined,
        ...disabledAriaAttributes ? {} : {
            ariaLabel: ariaLabel
        },
        testId: "profileCardTrigger"
    }, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gj42z.FeedFollowErrorDisplay), {
            feedConfigError: feedConfigError,
            mutationError: mutationError,
            showErrorFlag: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSs5g.default), {
            cloudId: cloudId,
            userId: userId,
            resourceClient: (0, $bumSD.getProfileClient)(cloudId, featureFlags),
            position: position,
            trigger: trigger,
            actions: [
                viewProfileAction,
                followUserAction
            ],
            reportingLinesProfileUrl: reportingLinesProfileUrl,
            onReportingLinesClick: (user)=>reportingLinesClickCallback(user.accountIdentifier),
            addFlag: (flag)=>flags.showFlag(flag),
            prepopulatedData: {
                fullName: fullName
            },
            disabledAriaAttributes: disabledAriaAttributes,
            onVisibilityChange: onVisibilityChange,
            offset: offset,
            testId: "profileCardTrigger",
            viewingUserId: loggedInUserId,
            ...disabledAriaAttributes ? {} : {
                ariaLabel: ariaLabel
            }
        }, children)));
};
module.exports["ProfileCardWrapper"] = $3d0f3ea3171aff68$export$59abd6feb7dc8540;

});

parcelRegister("6OL2O", function(module, exports) {
$parcel$export(module.exports, "getNavigateToTeamsApp", () => (parcelRequire("5t3NX")).getNavigateToTeamsApp);

var $5t3NX = parcelRequire("5t3NX");


});

parcelRegister("5t3NX", function(module, exports) {

var $hMCZS = parcelRequire("hMCZS");

const $57c6b51502cb940c$export$cfadab73fb247145 = (orgId, navActionPayload, shouldOpenInSameTab)=>{
    return (0, $hMCZS.navigateToTeamsApp)({
        hostProduct: 'confluence',
        orgId: orgId,
        userHasNav4Enabled: true,
        shouldOpenInSameTab: shouldOpenInSameTab,
        ...navActionPayload
    });
};
module.exports["getNavigateToTeamsApp"] = $57c6b51502cb940c$export$cfadab73fb247145;

});

parcelRegister("dD7ks", function(module, exports) {
$parcel$export(module.exports, "useNavigateToTeamsApp", () => (parcelRequire("4N3op")).useNavigateToTeamsApp);

var $4N3op = parcelRequire("4N3op");


});

parcelRegister("4N3op", function(module, exports) {

var $hMCZS = parcelRequire("hMCZS");


var $bQm3c = parcelRequire("bQm3c");


var $dPJCf = parcelRequire("dPJCf");

const $bf6b29a56d69bf9f$export$520a42ab062954ec = (navActionPayload, shouldOpenInSameTab)=>{
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    return (0, $hMCZS.navigateToTeamsApp)({
        push: push,
        hostProduct: 'confluence',
        orgId: orgId,
        cloudId: cloudId,
        userHasNav4Enabled: true,
        shouldOpenInSameTab: shouldOpenInSameTab,
        ...navActionPayload
    });
};
module.exports["useNavigateToTeamsApp"] = $bf6b29a56d69bf9f$export$520a42ab062954ec;

});

parcelRegister("l7wqU", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bedVD = parcelRequire("bedVD");


var $4GlQ9 = parcelRequire("4GlQ9");

const $460a3972eab8fd69$export$38809e1c08e05a16 = (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { userId: userId } = t0;
    const { followedUsers: followedUsers } = (0, $4GlQ9.useFeedFollow)();
    let t1;
    if ($[0] !== followedUsers || $[1] !== userId) {
        t1 = userId && followedUsers?.includes(userId);
        $[0] = followedUsers;
        $[1] = userId;
        $[2] = t1;
    } else t1 = $[2];
    const followed = !!t1;
    let t2;
    if ($[3] !== followed) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bedVD.FeedFollow), {
            followed: followed
        });
        $[3] = followed;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
};
module.exports["FeedFollowAction"] = $460a3972eab8fd69$export$38809e1c08e05a16;

});

parcelRegister("4qzKl", function(module, exports) {
// TODO: remove once @confluence-classic/confluence-urls is added to next

var $jlIaF = parcelRequire("jlIaF");

const $7b986e69785602e5$export$3b6a64cfeda8b00 = (accountId, src, context = '')=>{
    if (!accountId) return '';
    return `${context}/people/${accountId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$5f1a0e9946984804 = async (accountId, src)=>{
    if (!accountId) return '';
    return `${0, $jlIaF.CONTEXT_PATH}/people/${accountId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$cb80ef5511478588 = (teamId, src, context = '')=>{
    if (!teamId) return '';
    return `${context}/people/team/${teamId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$470c1413f7223a06 = async (teamId, src)=>{
    if (!teamId) return '';
    return `${0, $jlIaF.CONTEXT_PATH}/people/team/${teamId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
// Replacement for the getAttributeNames DOM API since it's not supported by IE
const $7b986e69785602e5$var$getAttributeNames = (element)=>Array.from(element.attributes).map((attribute)=>attribute.name);
// Return only DOM elements that have the data-account-id attribute
const $7b986e69785602e5$var$withAccountId = (element)=>element.getAttribute('data-account-id');
// Returns React props that can be used to recreate a DOM element
const $7b986e69785602e5$var$getReactPropsFromDOMElement = (element)=>{
    const attributeToProp = {
        class: 'className'
    };
    const props = {};
    $7b986e69785602e5$var$getAttributeNames(element).forEach((attribute)=>{
        props[attributeToProp[attribute] || attribute] = element.getAttribute(attribute);
    });
    props.dangerouslySetInnerHTML = {
        __html: element.innerHTML
    };
    return props;
};
function $7b986e69785602e5$export$a98860edfb97e545(userElements) {
    return userElements.filter($7b986e69785602e5$var$withAccountId).map((element)=>{
        const props = $7b986e69785602e5$var$getReactPropsFromDOMElement(element);
        // Set this attribute to stop the old user profile hovers from binding
        props['data-user-hover-bound'] = 'true';
        // Ensure that links go to the same location as the profile card
        props.href = $7b986e69785602e5$export$3b6a64cfeda8b00(props['data-account-id'], null);
        const placeholder = window.document.createElement('span');
        if (!element.parentNode) return {};
        element.parentNode.replaceChild(placeholder, element);
        return {
            props: props,
            placeholder: placeholder
        };
    });
}
module.exports["getAtlassianPeopleProfileUrl"] = $7b986e69785602e5$export$3b6a64cfeda8b00;
module.exports["getAtlassianPeopleProfileUrlAsync"] = $7b986e69785602e5$export$5f1a0e9946984804;
module.exports["getTeamUrl"] = $7b986e69785602e5$export$cb80ef5511478588;
module.exports["replaceUserElementsWithPlaceholders"] = $7b986e69785602e5$export$a98860edfb97e545;

});

parcelRegister("gj42z", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $kSwu1 = parcelRequire("kSwu1");


var $b3j2Y = parcelRequire("b3j2Y");


var $gqqjz = parcelRequire("gqqjz");

const $3ade761a05c1a959$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    followMutationErrorTitle: {
        id: "profile.card.feed.follow.mutation.error.title",
        defaultMessage: "We\u2019re having trouble doing that"
    },
    followMutationErrorDescription: {
        id: "profile.card.feed.follow.mutation.error.description",
        defaultMessage: "Try following or unfollowing this user again "
    }
});
const $3ade761a05c1a959$export$cb92340e76dc7cda = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { feedConfigError: feedConfigError, mutationError: mutationError, showErrorFlag: showErrorFlag } = t0;
    let t1;
    if ($[0] !== feedConfigError) {
        t1 = feedConfigError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: feedConfigError
        }) : null;
        $[0] = feedConfigError;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== mutationError || $[3] !== showErrorFlag) {
        t2 = mutationError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: mutationError
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
            to: [
                (0, $gqqjz.FlagsStateContainer)
            ]
        }, (flags)=>{
            if (showErrorFlag) flags.showErrorFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3ade761a05c1a959$export$a7357cdd1f0b0168.followMutationErrorTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3ade761a05c1a959$export$a7357cdd1f0b0168.followMutationErrorDescription)
            });
            return null;
        })) : null;
        $[2] = mutationError;
        $[3] = showErrorFlag;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t1 || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t1, t2);
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};
module.exports["FeedFollowErrorDisplay"] = $3ade761a05c1a959$export$cb92340e76dc7cda;

});

parcelRegister("fs6LW", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $arQY7 = parcelRequire("arQY7");


var $jyPfN = parcelRequire("jyPfN");


var $9wGTI = parcelRequire("9wGTI");


var $a6t12 = parcelRequire("a6t12");

const $98dff64af54e38f8$var$avatarWrapperStyles = {
    base: (0, $buxP3.xcss)({
        display: 'inline-flex',
        backgroundColor: 'color.background.neutral.subtle',
        borderWidth: '0',
        padding: 'space.0',
        borderRadius: 'radius.full',
        outlineOffset: 'space.0',
        ':focus-within': {
            outlineStyle: 'solid',
            outlineWidth: 'border.width.focused',
            outlineColor: 'color.border.focused'
        }
    }),
    blockBase: (0, $buxP3.xcss)({
        display: 'flex'
    }),
    cursor: (0, $buxP3.xcss)({
        cursor: 'pointer'
    })
};
const $98dff64af54e38f8$var$i18n = (0, $kSwu1.defineMessages)({
    label: {
        id: "profile.avatar.image",
        defaultMessage: "profile image of a user"
    },
    ariaLabel: {
        id: "profile.avatar.ariaLabel",
        defaultMessage: "More information about {name}"
    }
});
const $98dff64af54e38f8$export$3778be82376b06d7 = (t0)=>{
    const $ = (0, $bDgLe.c)(44);
    const { userId: userId, canViewProfile: t1, isAnonymous: t2, size: t3, src: src, onClick: onClick, trigger: trigger, name: name, stackIndex: stackIndex, testId: testId, position: position, borderColor: borderColor, offset: offset, isBlockLevel: t4 } = t0;
    const canViewProfile = t1 === undefined ? true : t1;
    const isAnonymous = t2 === undefined ? false : t2;
    const size = t3 === undefined ? "medium" : t3;
    const isBlockLevel = t4 === undefined ? false : t4;
    const intl = (0, $kSwu1.useIntl)();
    const avatarSrc = isAnonymous || !canViewProfile || !src ? undefined : src;
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const willRenderProfileCardTrigger = !isAnonymous && canViewProfile && !!userId && hasViewUserProfilePermission;
    const avatarRef = (0, $cozmU.useRef)(null);
    const [isVisible, setIsVisible] = (0, $cozmU.useState)(false);
    const [shouldReturnFocus, setShouldReturnFocus] = (0, $cozmU.useState)(false);
    const [wasKeyboardAction, setWasKeyboardAction] = (0, $cozmU.useState)(false);
    let t5;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (isVisible_0)=>{
            setIsVisible(isVisible_0);
        };
        $[0] = t5;
    } else t5 = $[0];
    const handleVisibilityChange = t5;
    let t6;
    let t7;
    if ($[1] !== isVisible || $[2] !== shouldReturnFocus) {
        t6 = ()=>{
            if (shouldReturnFocus && !isVisible && avatarRef.current) {
                avatarRef.current.focus();
                setShouldReturnFocus(false);
            }
        };
        t7 = [
            isVisible,
            shouldReturnFocus
        ];
        $[1] = isVisible;
        $[2] = shouldReturnFocus;
        $[3] = t6;
        $[4] = t7;
    } else {
        t6 = $[3];
        t7 = $[4];
    }
    (0, $cozmU.useEffect)(t6, t7);
    let t8;
    if ($[5] !== isVisible || $[6] !== wasKeyboardAction) {
        t8 = (e)=>{
            e.stopPropagation();
            if (e.key === "Enter") {
                setWasKeyboardAction(true);
                setIsVisible($98dff64af54e38f8$var$_temp);
                setShouldReturnFocus(true);
            } else if (e.key === "Escape" && isVisible && wasKeyboardAction) {
                setIsVisible(false);
                setWasKeyboardAction(false);
                setShouldReturnFocus(true);
            }
        };
        $[5] = isVisible;
        $[6] = wasKeyboardAction;
        $[7] = t8;
    } else t8 = $[7];
    const handleKeyDown = t8;
    const t9 = (0, $9wGTI.fg)("a11y_whiteboards_changes") ? "" : name || "";
    let t10;
    if ($[8] !== intl) {
        t10 = (0, $9wGTI.fg)("a11y_whiteboards_changes") ? {} : {
            label: intl.formatMessage($98dff64af54e38f8$var$i18n.label)
        };
        $[8] = intl;
        $[9] = t10;
    } else t10 = $[9];
    let t11;
    if ($[10] !== avatarSrc || $[11] !== borderColor || $[12] !== onClick || $[13] !== size || $[14] !== stackIndex || $[15] !== t10 || $[16] !== t9 || $[17] !== testId) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
            src: avatarSrc,
            size: size,
            target: "_blank",
            name: t9,
            ...t10,
            stackIndex: stackIndex,
            testId: testId,
            borderColor: borderColor,
            onClick: onClick
        });
        $[10] = avatarSrc;
        $[11] = borderColor;
        $[12] = onClick;
        $[13] = size;
        $[14] = stackIndex;
        $[15] = t10;
        $[16] = t9;
        $[17] = testId;
        $[18] = t11;
    } else t11 = $[18];
    const Icon = t11;
    let t12;
    if ($[19] !== intl || $[20] !== isVisible || $[21] !== name || $[22] !== willRenderProfileCardTrigger) {
        t12 = ()=>{
            if ((0, $9wGTI.fg)("a11y_whiteboards_changes")) return {};
            if (willRenderProfileCardTrigger) return {
                tabIndex: -1
            };
            return {
                "aria-haspopup": "true",
                "aria-expanded": isVisible,
                "aria-label": intl.formatMessage($98dff64af54e38f8$var$i18n.ariaLabel, {
                    name: name || ""
                }),
                role: "button",
                tabIndex: 0
            };
        };
        $[19] = intl;
        $[20] = isVisible;
        $[21] = name;
        $[22] = willRenderProfileCardTrigger;
        $[23] = t12;
    } else t12 = $[23];
    const getAriaProps = t12;
    const t13 = name || "";
    let t14;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = (0, $9wGTI.fg)("a11y_whiteboards_changes");
        $[24] = t14;
    } else t14 = $[24];
    const t15 = isBlockLevel && $98dff64af54e38f8$var$avatarWrapperStyles.blockBase;
    const t16 = canViewProfile && hasViewUserProfilePermission && $98dff64af54e38f8$var$avatarWrapperStyles.cursor;
    let t17;
    if ($[25] !== t15 || $[26] !== t16) {
        t17 = [
            $98dff64af54e38f8$var$avatarWrapperStyles.base,
            t15,
            t16
        ];
        $[25] = t15;
        $[26] = t16;
        $[27] = t17;
    } else t17 = $[27];
    let t18;
    if ($[28] !== getAriaProps) {
        t18 = getAriaProps();
        $[28] = getAriaProps;
        $[29] = t18;
    } else t18 = $[29];
    let t19;
    if ($[30] !== Icon || $[31] !== handleKeyDown || $[32] !== t17 || $[33] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: t17,
            testId: "avatarWrapperTestId",
            ref: avatarRef,
            onKeyDown: handleKeyDown,
            ...t18
        }, Icon);
        $[30] = Icon;
        $[31] = handleKeyDown;
        $[32] = t17;
        $[33] = t18;
        $[34] = t19;
    } else t19 = $[34];
    let t20;
    if ($[35] !== canViewProfile || $[36] !== isAnonymous || $[37] !== offset || $[38] !== position || $[39] !== t13 || $[40] !== t19 || $[41] !== trigger || $[42] !== userId) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6t12.ProfileCardWrapper), {
            userId: userId,
            canViewProfile: canViewProfile,
            isAnonymous: isAnonymous,
            trigger: trigger,
            fullName: t13,
            disabledAriaAttributes: t14,
            onVisibilityChange: handleVisibilityChange,
            position: position,
            offset: offset
        }, t19);
        $[35] = canViewProfile;
        $[36] = isAnonymous;
        $[37] = offset;
        $[38] = position;
        $[39] = t13;
        $[40] = t19;
        $[41] = trigger;
        $[42] = userId;
        $[43] = t20;
    } else t20 = $[43];
    return t20;
};
function $98dff64af54e38f8$var$_temp(prev) {
    return !prev;
}
module.exports["ProfileAvatar"] = $98dff64af54e38f8$export$3778be82376b06d7;

});

parcelRegister("gvWVt", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $4af2e88caf28e461$export$632b2aa69aba4fdd = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iyBz0",
    name: "ExternalCollaboratorUserLozenge",
    loader: async ()=>(await Promise.resolve((parcelRequire("9fywD")))).ExternalUserLozenge
});
module.exports["ExternalCollaboratorUserLozenge"] = $4af2e88caf28e461$export$632b2aa69aba4fdd;

});

parcelRegister("7tI6B", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $89d6a09a4f827a20$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["SitePermissionType"] = $89d6a09a4f827a20$export$8995abb8169b2cb8;

});

parcelRegister("fnCzB", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $arQY7 = parcelRequire("arQY7");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");


var $6mKj3 = parcelRequire("6mKj3");


var $d6Ahp = parcelRequire("d6Ahp");


var $bcPDX = parcelRequire("bcPDX");


var $393Hh = parcelRequire("393Hh");

const $f53519bf96c3cca1$var$AGENT_USER_DUAL_AVATAR_AGENT_SIZE = 'small';
const $f53519bf96c3cca1$var$AGENT_USER_DUAL_AVATAR_USER_SIZE = 'xxsmall';
const $f53519bf96c3cca1$var$DEFAULT_AVATAR_ITEM_COVER = {
    top: 0,
    left: 0,
    width: 32,
    height: 32
};
// 14px is not an ADS space token; cssMap rejects it.
const $f53519bf96c3cca1$var$dualAvatarUserDefaultFrameStyles = null;
// 18px is not an ADS space token; cssMap rejects it.
const $f53519bf96c3cca1$var$dualAvatarUserLargeFrameStyles = null; // Avatar xxsmall paints a 16px face with 2px slot margin; clip it so only the face shows.
const $f53519bf96c3cca1$var$dualAvatarUserFaceClipStyles = null;
const $f53519bf96c3cca1$var$dualAvatarUserAvatarShiftStyles = null;
const $f53519bf96c3cca1$var$dualAvatarCardTriggerStyles = null;
const $f53519bf96c3cca1$var$useAvatarItemCover = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const rootRef = (0, $cozmU.useRef)(null);
    const [cover, setCover] = (0, $cozmU.useState)($f53519bf96c3cca1$var$DEFAULT_AVATAR_ITEM_COVER);
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>{
            const root = rootRef.current;
            const identityCell = root?.parentElement;
            if (!root || !identityCell) return;
            const updateCover = ()=>{
                const identityRect = identityCell.getBoundingClientRect();
                const rootRect = root.getBoundingClientRect();
                if (identityRect.width === 0 && identityRect.height === 0) return;
                setCover({
                    top: identityRect.top - rootRect.top,
                    left: identityRect.left - rootRect.left,
                    width: identityRect.width,
                    height: identityRect.height
                });
            };
            updateCover();
            if (typeof ResizeObserver === "undefined") return;
            const observer = new ResizeObserver(updateCover);
            observer.observe(identityCell);
            observer.observe(root);
            return ()=>observer.disconnect();
        };
        t1 = [
            rootRef
        ];
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    (0, $cozmU.useLayoutEffect)(t0, t1);
    let t2;
    if ($[2] !== cover) {
        t2 = {
            rootRef: rootRef,
            cover: cover
        };
        $[2] = cover;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ()=>{
    const rootRef = (0, $cozmU.useRef)(null);
    const [cover, setCover] = (0, $cozmU.useState)($f53519bf96c3cca1$var$DEFAULT_AVATAR_ITEM_COVER);
    (0, $cozmU.useLayoutEffect)(()=>{
        const root = rootRef.current;
        const identityCell = root?.parentElement;
        if (!root || !identityCell) return;
        const updateCover = ()=>{
            const identityRect = identityCell.getBoundingClientRect();
            const rootRect = root.getBoundingClientRect();
            if (identityRect.width === 0 && identityRect.height === 0) return;
            setCover({
                top: identityRect.top - rootRect.top,
                left: identityRect.left - rootRect.left,
                width: identityRect.width,
                height: identityRect.height
            });
        };
        updateCover();
        if (typeof ResizeObserver === 'undefined') return;
        const observer = new ResizeObserver(updateCover);
        observer.observe(identityCell);
        observer.observe(root);
        return ()=>observer.disconnect();
    }, [
        rootRef
    ]);
    return {
        rootRef: rootRef,
        cover: cover
    };
};
const $f53519bf96c3cca1$var$styles = {
    dualAvatar: "_1mT5xdRAKS _39xV02Uofl _0jFU0VUofl _3YEZNOdnbC _2xTnZxFQfX",
    dualAvatarOffsetInlineStart: "_1mT5xdRAKS _39xV02Uofl _0jFU0VUofl _3YEZNOdnbC _2xTnZxFQfX _1VJPcac8DQ",
    dualAvatarDefault: "_4bt5LAYvD1 _2WAcuGYvD1 _1mT5xdRAKS _39xV02oWWg _0jFU0VoWWg _3YEZNOdnbC _4xdlr0DIqT _43nrzTFQfX _0rIjykFQfX _0GTcwRFQfX _2xTnZxFQfX",
    dualAvatarDefaultOffset: "_4bt5LAYvD1 _2WAcuGYvD1 _1mT5xdRAKS _39xV02oWWg _0jFU0VoWWg _3YEZNOdnbC _4xdlr0DIqT _43nrzTFQfX _0rIjykFQfX _0GTcwRFQfX _2xTnZxFQfX",
    dualAvatarLarge: "_4bt5LAYvD1 _2WAcuGYvD1 _1mT5xdRAKS _39xV02Uofl _0jFU0VUofl _3YEZNOdnbC _4xdlr0DIqT _43nrzTFQfX _0rIjykFQfX _0GTcwRFQfX _2xTnZxFQfX",
    dualAvatarLargeOffset: "_4bt5LAYvD1 _2WAcuGYvD1 _1mT5xdRAKS _39xV02Uofl _0jFU0VUofl _3YEZNOdnbC _4xdlr0DIqT _43nrzTFQfX _0rIjykFQfX _0GTcwRFQfX _2xTnZxFQfX",
    dualAvatarAgent: "_1mT5xdWVPG _2IhTonPgdg _3iC0zdPgdg _39xV02SPN1 _0jFU0VSPN1 _1VJPca4XqE _0yKXXaXmhc",
    dualAvatarAgentDefault: "_4bt5LAYvD1 _2WAcuGYvD1 _1mT5xdWVPG _2IhTonPgdg _3iC0zdPgdg _39xV02oWWg _0jFU0VoWWg _1VJPcaYbGa",
    dualAvatarAgentLarge: "_4bt5LAYvD1 _2WAcuGYvD1 _1mT5xdWVPG _2IhTonPgdg _3iC0zdPgdg _39xV02Uofl _0jFU0VUofl _1VJPcaYbGa",
    dualAvatarUser: "_0bjKvDS5Zs _1mT5xdWVPG _2IhTon8HPE _1OKFqYFQfX _43nrzTFQfX _0KLXrulfZc",
    dualAvatarUserDefaultInner: "_39xV02ey7F _0jFU0Vey7F _1VJPcaTCRo _0yKXXaXmhc",
    dualAvatarTriggerFill: "_1mT5xdRAKS _39xV02N91d _0jFU0VN91d _3iDTPbvLZJ _1pp6NdYbGa",
    dualAvatarVisualStack: "_1mT5xdWVPG _39xV02Uofl _0jFU0VUofl _1pp6NdYbGa",
    dualAvatarVisualStackDefault: "_4bt5LAYvD1 _2WAcuGYvD1 _1mT5xdWVPG _39xV02oWWg _0jFU0VoWWg _1pp6NdYbGa",
    dualAvatarVisualStackLarge: "_4bt5LAYvD1 _2WAcuGYvD1 _1mT5xdWVPG _39xV02Uofl _0jFU0VUofl _1pp6NdYbGa",
    dualAvatarTriggerTarget: "_1pp6NdIZbP"
};
const $f53519bf96c3cca1$var$stackRootAttrs = (stack)=>{
    if (stack === 'default') return {
        'data-width': '24px',
        'data-height': '24px',
        'data-overflow': 'visible',
        'data-slot-margin': 'space.025'
    };
    if (stack === 'large') return {
        'data-width': '32px',
        'data-height': '32px',
        'data-overflow': 'visible',
        'data-slot-margin': 'space.025'
    };
    return {
        'data-width': '32px',
        'data-height': '32px'
    };
};
const $f53519bf96c3cca1$var$stackAgentAttrs = (stack)=>{
    if (stack === 'default') return {
        'data-width': '24px',
        'data-height': '24px',
        'data-transform': 'none',
        'data-clip': 'none'
    };
    if (stack === 'large') return {
        'data-width': '32px',
        'data-height': '32px',
        'data-transform': 'none',
        'data-clip': 'none'
    };
    return {
        'data-width': '20px',
        'data-height': '20px',
        'data-transform': 'scale(0.8333333333333334)'
    };
};
const $f53519bf96c3cca1$var$stackUserFrameAttrs = (stack)=>{
    if (stack === 'default') return {
        'data-width': '12px',
        'data-height': '12px',
        'data-top': '14px',
        'data-left': '14px',
        'data-overflow': 'visible',
        'data-avatar-slot-shift': 'space.negative.025'
    };
    return {
        'data-width': '16px',
        'data-height': '16px',
        'data-top': '18px',
        'data-left': '18px',
        'data-overflow': 'visible',
        'data-avatar-slot-shift': 'space.negative.025'
    };
};
const $f53519bf96c3cca1$export$524e3ea25887b088 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(57);
    const { agentName: agentName, agentIcon: agentIcon, agentAvatarUrl: agentAvatarUrl, agentBorderColor: agentBorderColor, userBorderColor: userBorderColor, agentUserId: agentUserId, userName: userName, userAvatarUrl: userAvatarUrl, relatedUserId: relatedUserId, isOffsetInlineStart: t1, size: t2, fillProfileClickableFrame: t3, profileCardTrigger: profileCardTrigger, position: position, offset: offset, colorMode: t4 } = t0;
    const isOffsetInlineStart = t1 === undefined ? false : t1;
    const size = t2 === undefined ? "default" : t2;
    const fillProfileClickableFrame = t3 === undefined ? false : t3;
    const colorMode = t4 === undefined ? "light" : t4;
    const effectiveAgentUserId = (0, $6mKj3.expVal)("dual_agent_avatar_card", "isEnabled", false) ? (0, $bcPDX.isClickableAgentIdentity)({
        accountId: agentUserId,
        agentIcon: agentIcon,
        displayName: agentName
    }) ? agentUserId : undefined : agentUserId;
    let t5;
    if ($[0] !== userAvatarUrl || $[1] !== userName) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
            src: userAvatarUrl,
            name: userName,
            size: $f53519bf96c3cca1$var$AGENT_USER_DUAL_AVATAR_USER_SIZE,
            borderColor: "transparent",
            label: ""
        });
        $[0] = userAvatarUrl;
        $[1] = userName;
        $[2] = t5;
    } else t5 = $[2];
    const userAvatar = t5;
    if (size === "large" && (0, $6mKj3.expVal)("dual_agent_avatar_card", "isEnabled", false)) {
        const t6 = fillProfileClickableFrame && effectiveAgentUserId !== undefined;
        let t7;
        if ($[3] !== agentAvatarUrl || $[4] !== agentBorderColor || $[5] !== agentIcon || $[6] !== agentName || $[7] !== colorMode || $[8] !== t6) {
            t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d6Ahp.AgentRowAvatar), {
                name: agentName,
                agentIcon: agentIcon,
                avatarUrl: agentAvatarUrl,
                borderColor: agentBorderColor,
                avatarSize: "medium",
                hasInlineSpacing: false,
                fillProfileClickableFrame: t6,
                colorMode: colorMode
            });
            $[3] = agentAvatarUrl;
            $[4] = agentBorderColor;
            $[5] = agentIcon;
            $[6] = agentName;
            $[7] = colorMode;
            $[8] = t6;
            $[9] = t7;
        } else t7 = $[9];
        let t8;
        if ($[10] !== agentName || $[11] !== effectiveAgentUserId || $[12] !== isOffsetInlineStart || $[13] !== offset || $[14] !== position || $[15] !== profileCardTrigger || $[16] !== relatedUserId || $[17] !== t7 || $[18] !== userAvatar || $[19] !== userBorderColor || $[20] !== userName) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f53519bf96c3cca1$export$382fb1bfcc6c89af, {
                agentName: agentName,
                agentUserId: effectiveAgentUserId,
                userName: userName,
                relatedUserId: relatedUserId,
                isOffsetInlineStart: isOffsetInlineStart,
                stack: "large",
                userBorderColor: userBorderColor,
                profileCardTrigger: profileCardTrigger,
                position: position,
                offset: offset,
                agentAvatar: t7,
                userAvatar: userAvatar
            });
            $[10] = agentName;
            $[11] = effectiveAgentUserId;
            $[12] = isOffsetInlineStart;
            $[13] = offset;
            $[14] = position;
            $[15] = profileCardTrigger;
            $[16] = relatedUserId;
            $[17] = t7;
            $[18] = userAvatar;
            $[19] = userBorderColor;
            $[20] = userName;
            $[21] = t8;
        } else t8 = $[21];
        return t8;
    }
    if ((0, $6mKj3.expVal)("dual_agent_avatar_card", "isEnabled", false)) {
        const t6 = fillProfileClickableFrame && effectiveAgentUserId !== undefined;
        let t7;
        if ($[22] !== agentAvatarUrl || $[23] !== agentBorderColor || $[24] !== agentIcon || $[25] !== agentName || $[26] !== colorMode || $[27] !== t6) {
            t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d6Ahp.AgentRowAvatar), {
                name: agentName,
                agentIcon: agentIcon,
                avatarUrl: agentAvatarUrl,
                borderColor: agentBorderColor,
                avatarSize: "small",
                hasInlineSpacing: false,
                fillProfileClickableFrame: t6,
                colorMode: colorMode
            });
            $[22] = agentAvatarUrl;
            $[23] = agentBorderColor;
            $[24] = agentIcon;
            $[25] = agentName;
            $[26] = colorMode;
            $[27] = t6;
            $[28] = t7;
        } else t7 = $[28];
        let t8;
        if ($[29] !== agentName || $[30] !== effectiveAgentUserId || $[31] !== isOffsetInlineStart || $[32] !== offset || $[33] !== position || $[34] !== profileCardTrigger || $[35] !== relatedUserId || $[36] !== t7 || $[37] !== userAvatar || $[38] !== userBorderColor || $[39] !== userName) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f53519bf96c3cca1$export$382fb1bfcc6c89af, {
                agentName: agentName,
                agentUserId: effectiveAgentUserId,
                userName: userName,
                relatedUserId: relatedUserId,
                isOffsetInlineStart: isOffsetInlineStart,
                stack: "default",
                userBorderColor: userBorderColor,
                profileCardTrigger: profileCardTrigger,
                position: position,
                offset: offset,
                agentAvatar: t7,
                userAvatar: userAvatar
            });
            $[29] = agentName;
            $[30] = effectiveAgentUserId;
            $[31] = isOffsetInlineStart;
            $[32] = offset;
            $[33] = position;
            $[34] = profileCardTrigger;
            $[35] = relatedUserId;
            $[36] = t7;
            $[37] = userAvatar;
            $[38] = userBorderColor;
            $[39] = userName;
            $[40] = t8;
        } else t8 = $[40];
        return t8;
    }
    let t6;
    if ($[41] !== agentAvatarUrl || $[42] !== agentIcon || $[43] !== agentName || $[44] !== colorMode) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d6Ahp.AgentRowAvatar), {
            name: agentName,
            agentIcon: agentIcon,
            avatarUrl: agentAvatarUrl,
            avatarSize: $f53519bf96c3cca1$var$AGENT_USER_DUAL_AVATAR_AGENT_SIZE,
            hasInlineSpacing: false,
            colorMode: colorMode
        });
        $[41] = agentAvatarUrl;
        $[42] = agentIcon;
        $[43] = agentName;
        $[44] = colorMode;
        $[45] = t6;
    } else t6 = $[45];
    let t7;
    if ($[46] !== agentName || $[47] !== effectiveAgentUserId || $[48] !== isOffsetInlineStart || $[49] !== offset || $[50] !== position || $[51] !== profileCardTrigger || $[52] !== relatedUserId || $[53] !== t6 || $[54] !== userAvatar || $[55] !== userName) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f53519bf96c3cca1$export$382fb1bfcc6c89af, {
            agentName: agentName,
            agentUserId: effectiveAgentUserId,
            userName: userName,
            relatedUserId: relatedUserId,
            isOffsetInlineStart: isOffsetInlineStart,
            stack: "legacy",
            profileCardTrigger: profileCardTrigger,
            position: position,
            offset: offset,
            agentAvatar: t6,
            userAvatar: userAvatar
        });
        $[46] = agentName;
        $[47] = effectiveAgentUserId;
        $[48] = isOffsetInlineStart;
        $[49] = offset;
        $[50] = position;
        $[51] = profileCardTrigger;
        $[52] = relatedUserId;
        $[53] = t6;
        $[54] = userAvatar;
        $[55] = userName;
        $[56] = t7;
    } else t7 = $[56];
    return t7;
} : ({ agentName: agentName, agentIcon: agentIcon, agentAvatarUrl: agentAvatarUrl, agentBorderColor: agentBorderColor, userBorderColor: userBorderColor, agentUserId: agentUserId, userName: userName, userAvatarUrl: userAvatarUrl, relatedUserId: relatedUserId, isOffsetInlineStart: isOffsetInlineStart = false, size: size = 'default', fillProfileClickableFrame: fillProfileClickableFrame = false, profileCardTrigger: profileCardTrigger, position: position, offset: offset, colorMode: colorMode = 'light' })=>{
    const effectiveAgentUserId = (0, $6mKj3.expVal)('dual_agent_avatar_card', 'isEnabled', false) ? (0, $bcPDX.isClickableAgentIdentity)({
        accountId: agentUserId,
        agentIcon: agentIcon,
        displayName: agentName
    }) ? agentUserId : undefined : agentUserId;
    const userAvatar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
        src: userAvatarUrl,
        name: userName,
        size: $f53519bf96c3cca1$var$AGENT_USER_DUAL_AVATAR_USER_SIZE,
        borderColor: "transparent",
        label: ""
    });
    if (size === 'large' && (0, $6mKj3.expVal)('dual_agent_avatar_card', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f53519bf96c3cca1$export$382fb1bfcc6c89af, {
        agentName: agentName,
        agentUserId: effectiveAgentUserId,
        userName: userName,
        relatedUserId: relatedUserId,
        isOffsetInlineStart: isOffsetInlineStart,
        stack: "large",
        userBorderColor: userBorderColor,
        profileCardTrigger: profileCardTrigger,
        position: position,
        offset: offset,
        agentAvatar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d6Ahp.AgentRowAvatar), {
            name: agentName,
            agentIcon: agentIcon,
            avatarUrl: agentAvatarUrl,
            borderColor: agentBorderColor,
            avatarSize: "medium",
            hasInlineSpacing: false,
            fillProfileClickableFrame: fillProfileClickableFrame && effectiveAgentUserId !== undefined,
            colorMode: colorMode
        }),
        userAvatar: userAvatar
    });
    if ((0, $6mKj3.expVal)('dual_agent_avatar_card', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f53519bf96c3cca1$export$382fb1bfcc6c89af, {
        agentName: agentName,
        agentUserId: effectiveAgentUserId,
        userName: userName,
        relatedUserId: relatedUserId,
        isOffsetInlineStart: isOffsetInlineStart,
        stack: "default",
        userBorderColor: userBorderColor,
        profileCardTrigger: profileCardTrigger,
        position: position,
        offset: offset,
        agentAvatar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d6Ahp.AgentRowAvatar), {
            name: agentName,
            agentIcon: agentIcon,
            avatarUrl: agentAvatarUrl,
            borderColor: agentBorderColor,
            avatarSize: "small",
            hasInlineSpacing: false,
            fillProfileClickableFrame: fillProfileClickableFrame && effectiveAgentUserId !== undefined,
            colorMode: colorMode
        }),
        userAvatar: userAvatar
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f53519bf96c3cca1$export$382fb1bfcc6c89af, {
        agentName: agentName,
        agentUserId: effectiveAgentUserId,
        userName: userName,
        relatedUserId: relatedUserId,
        isOffsetInlineStart: isOffsetInlineStart,
        stack: "legacy",
        profileCardTrigger: profileCardTrigger,
        position: position,
        offset: offset,
        agentAvatar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d6Ahp.AgentRowAvatar), {
            name: agentName,
            agentIcon: agentIcon,
            avatarUrl: agentAvatarUrl,
            avatarSize: $f53519bf96c3cca1$var$AGENT_USER_DUAL_AVATAR_AGENT_SIZE,
            hasInlineSpacing: false,
            colorMode: colorMode
        }),
        userAvatar: userAvatar
    });
};
const $f53519bf96c3cca1$export$382fb1bfcc6c89af = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(66);
    const { agentName: agentName, agentUserId: agentUserId, userName: userName, relatedUserId: relatedUserId, isOffsetInlineStart: isOffsetInlineStart, stack: stack, userBorderColor: userBorderColor, profileCardTrigger: profileCardTrigger, position: position, offset: offset, agentAvatar: agentAvatar, userAvatar: userAvatar } = t0;
    const { rootRef: rootRef, cover: cover } = $f53519bf96c3cca1$var$useAvatarItemCover();
    let t1;
    if ($[0] !== cover.height || $[1] !== cover.left || $[2] !== cover.top || $[3] !== cover.width) {
        t1 = {
            top: cover.top,
            left: cover.left,
            width: cover.width,
            height: cover.height
        };
        $[0] = cover.height;
        $[1] = cover.left;
        $[2] = cover.top;
        $[3] = cover.width;
        $[4] = t1;
    } else t1 = $[4];
    const coverStyle = t1;
    const t2 = -cover.top;
    const t3 = -cover.left;
    let t4;
    if ($[5] !== t2 || $[6] !== t3) {
        t4 = {
            top: t2,
            left: t3
        };
        $[5] = t2;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    const visualStackStyle = t4;
    let t5;
    if ($[8] !== stack || $[9] !== userAvatar || $[10] !== userBorderColor) {
        t5 = stack === "default" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "agent-user-dual-avatar-user-frame",
            style: {
                "--agent-user-dual-avatar-user-border": userBorderColor
            },
            ...$f53519bf96c3cca1$var$stackUserFrameAttrs(stack),
            className: (0, $hekY6.default)([
                "_4bt5LAYvD1 _2WAcuGYvD1 _0bjKvDS5Zs _1mT5xdWVPG _2IhTonEbN9 _3iC0zdEbN9 _39xV02xpxF _0jFU0VxpxF _2OUyjtvBjV"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: "agent-user-dual-avatar-user-target",
            xcss: (0, $w6R6I.cx)($f53519bf96c3cca1$var$styles.dualAvatarTriggerFill, $f53519bf96c3cca1$var$styles.dualAvatarTriggerTarget),
            "data-analytics-card-pointer": "auto"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f53519bf96c3cca1$var$styles.dualAvatarUserDefaultInner
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_4bt5LAnQyn _2WAcuGnQyn _0bjKvDS5Zs _39xV02ey7F _0jFU0Vey7F"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_43nrzTLl21 _0rIjykLl21 _0GTcwRLl21 _2xTnZxLl21"
            ])
        }, userAvatar))))) : stack === "large" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "agent-user-dual-avatar-user-frame",
            style: {
                "--agent-user-dual-avatar-user-border": userBorderColor
            },
            ...$f53519bf96c3cca1$var$stackUserFrameAttrs(stack),
            className: (0, $hekY6.default)([
                "_4bt5LAYvD1 _2WAcuGYvD1 _0bjKvDS5Zs _1mT5xdWVPG _2IhTon70UD _3iC0zd70UD _39xV02ey7F _0jFU0Vey7F _2OUyjtvBjV"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: "agent-user-dual-avatar-user-target",
            xcss: (0, $w6R6I.cx)($f53519bf96c3cca1$var$styles.dualAvatarTriggerFill, $f53519bf96c3cca1$var$styles.dualAvatarTriggerTarget),
            "data-analytics-card-pointer": "auto"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_4bt5LAnQyn _2WAcuGnQyn _0bjKvDS5Zs _39xV02ey7F _0jFU0Vey7F"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_43nrzTLl21 _0rIjykLl21 _0GTcwRLl21 _2xTnZxLl21"
            ])
        }, userAvatar)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: "agent-user-dual-avatar-user-target",
            xcss: (0, $w6R6I.cx)($f53519bf96c3cca1$var$styles.dualAvatarUser, $f53519bf96c3cca1$var$styles.dualAvatarTriggerTarget),
            "data-analytics-card-pointer": "auto"
        }, userAvatar);
        $[8] = stack;
        $[9] = userAvatar;
        $[10] = userBorderColor;
        $[11] = t5;
    } else t5 = $[11];
    const userTarget = t5;
    const t6 = stack === "default" ? isOffsetInlineStart ? $f53519bf96c3cca1$var$styles.dualAvatarDefaultOffset : $f53519bf96c3cca1$var$styles.dualAvatarDefault : stack === "large" ? isOffsetInlineStart ? $f53519bf96c3cca1$var$styles.dualAvatarLargeOffset : $f53519bf96c3cca1$var$styles.dualAvatarLarge : isOffsetInlineStart ? $f53519bf96c3cca1$var$styles.dualAvatarOffsetInlineStart : $f53519bf96c3cca1$var$styles.dualAvatar;
    let t7;
    if ($[12] !== stack) {
        t7 = $f53519bf96c3cca1$var$stackRootAttrs(stack);
        $[12] = stack;
        $[13] = t7;
    } else t7 = $[13];
    let t8;
    if ($[14] !== stack || $[15] !== t7) {
        t8 = {
            "data-analytics-card-anchor": "avatar-item",
            "data-stack": stack,
            ...t7
        };
        $[14] = stack;
        $[15] = t7;
        $[16] = t8;
    } else t8 = $[16];
    let t9;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = (0, $hekY6.default)([
            "_1mT5xdWVPG _3iDTPbvLZJ _1pp6NdYbGa _24h04i2Njc _1xEG70vLZJ _24tft3vLZJ _1Nqf5wN91d _3tmQIgN91d _4mufQ4N91d _23vwGLN91d _2TvjbiYbGa _0wiJmLYbGa"
        ]);
        $[17] = t9;
    } else t9 = $[17];
    let t10;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = {};
        $[18] = t10;
    } else t10 = $[18];
    let t11;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = {
            "data-analytics-card-fill": "avatar-item",
            "data-analytics-card-pointer": "none"
        };
        $[19] = t11;
    } else t11 = $[19];
    const t12 = stack === "default" ? $f53519bf96c3cca1$var$styles.dualAvatarVisualStackDefault : stack === "large" ? $f53519bf96c3cca1$var$styles.dualAvatarVisualStackLarge : $f53519bf96c3cca1$var$styles.dualAvatarVisualStack;
    const t13 = stack === "default" ? $f53519bf96c3cca1$var$styles.dualAvatarAgentDefault : stack === "large" ? $f53519bf96c3cca1$var$styles.dualAvatarAgentLarge : $f53519bf96c3cca1$var$styles.dualAvatarAgent;
    let t14;
    if ($[20] !== t13) {
        t14 = (0, $w6R6I.cx)(t13, $f53519bf96c3cca1$var$styles.dualAvatarTriggerTarget);
        $[20] = t13;
        $[21] = t14;
    } else t14 = $[21];
    let t15;
    if ($[22] !== stack) {
        t15 = $f53519bf96c3cca1$var$stackAgentAttrs(stack);
        $[22] = stack;
        $[23] = t15;
    } else t15 = $[23];
    let t16;
    if ($[24] !== t15) {
        t16 = {
            "data-analytics-card-pointer": "auto",
            ...t15
        };
        $[24] = t15;
        $[25] = t16;
    } else t16 = $[25];
    let t17;
    if ($[26] !== agentAvatar || $[27] !== t14 || $[28] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: "agent-user-dual-avatar-agent-target",
            xcss: t14,
            ...t16
        }, agentAvatar);
        $[26] = agentAvatar;
        $[27] = t14;
        $[28] = t16;
        $[29] = t17;
    } else t17 = $[29];
    let t18;
    if ($[30] !== t12 || $[31] !== t17 || $[32] !== visualStackStyle) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: "agent-user-dual-avatar-agent-trigger",
            xcss: $f53519bf96c3cca1$var$styles.dualAvatarTriggerFill,
            ...t11
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t12,
            style: visualStackStyle
        }, t17));
        $[30] = t12;
        $[31] = t17;
        $[32] = visualStackStyle;
        $[33] = t18;
    } else t18 = $[33];
    let t19;
    if ($[34] !== agentName || $[35] !== agentUserId || $[36] !== offset || $[37] !== position || $[38] !== profileCardTrigger || $[39] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $393Hh.ProfileIdentity), {
            userId: agentUserId,
            fullName: agentName,
            agent: t10,
            trigger: profileCardTrigger,
            position: position,
            offset: offset
        }, t18);
        $[34] = agentName;
        $[35] = agentUserId;
        $[36] = offset;
        $[37] = position;
        $[38] = profileCardTrigger;
        $[39] = t18;
        $[40] = t19;
    } else t19 = $[40];
    let t20;
    if ($[41] !== coverStyle || $[42] !== t19) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "agent-user-dual-avatar-agent-anchor",
            "data-analytics-card-anchor": "avatar-item",
            style: coverStyle,
            className: t9
        }, t19);
        $[41] = coverStyle;
        $[42] = t19;
        $[43] = t20;
    } else t20 = $[43];
    let t21;
    if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
        t21 = (0, $hekY6.default)([
            "_1mT5xdWVPG _3iDTPbvLZJ _1pp6NdYbGa _24h04i2Njc _1xEG70vLZJ _24tft3vLZJ _1Nqf5wN91d _3tmQIgN91d _4mufQ4N91d _23vwGLN91d _2TvjbiYbGa _0wiJmLYbGa"
        ]);
        $[44] = t21;
    } else t21 = $[44];
    let t22;
    if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
        t22 = {
            "data-analytics-card-fill": "avatar-item",
            "data-analytics-card-pointer": "none"
        };
        $[45] = t22;
    } else t22 = $[45];
    const t23 = stack === "default" ? $f53519bf96c3cca1$var$styles.dualAvatarVisualStackDefault : stack === "large" ? $f53519bf96c3cca1$var$styles.dualAvatarVisualStackLarge : $f53519bf96c3cca1$var$styles.dualAvatarVisualStack;
    let t24;
    if ($[46] !== t23 || $[47] !== userTarget || $[48] !== visualStackStyle) {
        t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: "agent-user-dual-avatar-user-trigger",
            xcss: $f53519bf96c3cca1$var$styles.dualAvatarTriggerFill,
            ...t22
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t23,
            style: visualStackStyle
        }, userTarget));
        $[46] = t23;
        $[47] = userTarget;
        $[48] = visualStackStyle;
        $[49] = t24;
    } else t24 = $[49];
    let t25;
    if ($[50] !== offset || $[51] !== position || $[52] !== profileCardTrigger || $[53] !== relatedUserId || $[54] !== t24 || $[55] !== userName) {
        t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $393Hh.ProfileIdentity), {
            userId: relatedUserId,
            fullName: userName,
            trigger: profileCardTrigger,
            position: position,
            offset: offset
        }, t24);
        $[50] = offset;
        $[51] = position;
        $[52] = profileCardTrigger;
        $[53] = relatedUserId;
        $[54] = t24;
        $[55] = userName;
        $[56] = t25;
    } else t25 = $[56];
    let t26;
    if ($[57] !== coverStyle || $[58] !== t25) {
        t26 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "agent-user-dual-avatar-user-anchor",
            "data-analytics-card-anchor": "avatar-item",
            style: coverStyle,
            className: t21
        }, t25);
        $[57] = coverStyle;
        $[58] = t25;
        $[59] = t26;
    } else t26 = $[59];
    let t27;
    if ($[60] !== rootRef || $[61] !== t20 || $[62] !== t26 || $[63] !== t6 || $[64] !== t8) {
        t27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            ref: rootRef,
            testId: "agent-user-dual-avatar",
            xcss: t6,
            ...t8
        }, t20, t26);
        $[60] = rootRef;
        $[61] = t20;
        $[62] = t26;
        $[63] = t6;
        $[64] = t8;
        $[65] = t27;
    } else t27 = $[65];
    return t27;
} : ({ agentName: agentName, agentUserId: agentUserId, userName: userName, relatedUserId: relatedUserId, isOffsetInlineStart: isOffsetInlineStart, stack: stack, userBorderColor: userBorderColor, profileCardTrigger: profileCardTrigger, position: position, offset: offset, agentAvatar: agentAvatar, userAvatar: userAvatar })=>{
    const { rootRef: rootRef, cover: cover } = $f53519bf96c3cca1$var$useAvatarItemCover();
    const coverStyle = {
        top: cover.top,
        left: cover.left,
        width: cover.width,
        height: cover.height
    };
    const visualStackStyle = {
        top: -cover.top,
        left: -cover.left
    };
    const userTarget = stack === 'default' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "agent-user-dual-avatar-user-frame",
        style: {
            '--agent-user-dual-avatar-user-border': userBorderColor
        },
        ...$f53519bf96c3cca1$var$stackUserFrameAttrs(stack),
        className: (0, $hekY6.default)([
            "_4bt5LAYvD1 _2WAcuGYvD1 _0bjKvDS5Zs _1mT5xdWVPG _2IhTonEbN9 _3iC0zdEbN9 _39xV02xpxF _0jFU0VxpxF _2OUyjtvBjV"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "agent-user-dual-avatar-user-target",
        xcss: (0, $w6R6I.cx)($f53519bf96c3cca1$var$styles.dualAvatarTriggerFill, $f53519bf96c3cca1$var$styles.dualAvatarTriggerTarget),
        'data-analytics-card-pointer': 'auto'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f53519bf96c3cca1$var$styles.dualAvatarUserDefaultInner
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _0bjKvDS5Zs _39xV02ey7F _0jFU0Vey7F"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_43nrzTLl21 _0rIjykLl21 _0GTcwRLl21 _2xTnZxLl21"
        ])
    }, userAvatar))))) : stack === 'large' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "agent-user-dual-avatar-user-frame",
        style: {
            '--agent-user-dual-avatar-user-border': userBorderColor
        },
        ...$f53519bf96c3cca1$var$stackUserFrameAttrs(stack),
        className: (0, $hekY6.default)([
            "_4bt5LAYvD1 _2WAcuGYvD1 _0bjKvDS5Zs _1mT5xdWVPG _2IhTon70UD _3iC0zd70UD _39xV02ey7F _0jFU0Vey7F _2OUyjtvBjV"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "agent-user-dual-avatar-user-target",
        xcss: (0, $w6R6I.cx)($f53519bf96c3cca1$var$styles.dualAvatarTriggerFill, $f53519bf96c3cca1$var$styles.dualAvatarTriggerTarget),
        'data-analytics-card-pointer': 'auto'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _0bjKvDS5Zs _39xV02ey7F _0jFU0Vey7F"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_43nrzTLl21 _0rIjykLl21 _0GTcwRLl21 _2xTnZxLl21"
        ])
    }, userAvatar)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "agent-user-dual-avatar-user-target",
        xcss: (0, $w6R6I.cx)($f53519bf96c3cca1$var$styles.dualAvatarUser, $f53519bf96c3cca1$var$styles.dualAvatarTriggerTarget),
        'data-analytics-card-pointer': 'auto'
    }, userAvatar);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: rootRef,
        testId: "agent-user-dual-avatar",
        xcss: stack === 'default' ? isOffsetInlineStart ? $f53519bf96c3cca1$var$styles.dualAvatarDefaultOffset : $f53519bf96c3cca1$var$styles.dualAvatarDefault : stack === 'large' ? isOffsetInlineStart ? $f53519bf96c3cca1$var$styles.dualAvatarLargeOffset : $f53519bf96c3cca1$var$styles.dualAvatarLarge : isOffsetInlineStart ? $f53519bf96c3cca1$var$styles.dualAvatarOffsetInlineStart : $f53519bf96c3cca1$var$styles.dualAvatar,
        'data-analytics-card-anchor': 'avatar-item',
        'data-stack': stack,
        ...$f53519bf96c3cca1$var$stackRootAttrs(stack)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "agent-user-dual-avatar-agent-anchor",
        "data-analytics-card-anchor": "avatar-item",
        style: coverStyle,
        className: (0, $hekY6.default)([
            "_1mT5xdWVPG _3iDTPbvLZJ _1pp6NdYbGa _24h04i2Njc _1xEG70vLZJ _24tft3vLZJ _1Nqf5wN91d _3tmQIgN91d _4mufQ4N91d _23vwGLN91d _2TvjbiYbGa _0wiJmLYbGa"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $393Hh.ProfileIdentity), {
        userId: agentUserId,
        fullName: agentName,
        agent: {},
        trigger: profileCardTrigger,
        position: position,
        offset: offset
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "agent-user-dual-avatar-agent-trigger",
        xcss: $f53519bf96c3cca1$var$styles.dualAvatarTriggerFill,
        'data-analytics-card-fill': 'avatar-item',
        'data-analytics-card-pointer': 'none'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: stack === 'default' ? $f53519bf96c3cca1$var$styles.dualAvatarVisualStackDefault : stack === 'large' ? $f53519bf96c3cca1$var$styles.dualAvatarVisualStackLarge : $f53519bf96c3cca1$var$styles.dualAvatarVisualStack,
        style: visualStackStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "agent-user-dual-avatar-agent-target",
        xcss: (0, $w6R6I.cx)(stack === 'default' ? $f53519bf96c3cca1$var$styles.dualAvatarAgentDefault : stack === 'large' ? $f53519bf96c3cca1$var$styles.dualAvatarAgentLarge : $f53519bf96c3cca1$var$styles.dualAvatarAgent, $f53519bf96c3cca1$var$styles.dualAvatarTriggerTarget),
        'data-analytics-card-pointer': 'auto',
        ...$f53519bf96c3cca1$var$stackAgentAttrs(stack)
    }, agentAvatar))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "agent-user-dual-avatar-user-anchor",
        "data-analytics-card-anchor": "avatar-item",
        style: coverStyle,
        className: (0, $hekY6.default)([
            "_1mT5xdWVPG _3iDTPbvLZJ _1pp6NdYbGa _24h04i2Njc _1xEG70vLZJ _24tft3vLZJ _1Nqf5wN91d _3tmQIgN91d _4mufQ4N91d _23vwGLN91d _2TvjbiYbGa _0wiJmLYbGa"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $393Hh.ProfileIdentity), {
        userId: relatedUserId,
        fullName: userName,
        trigger: profileCardTrigger,
        position: position,
        offset: offset
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "agent-user-dual-avatar-user-trigger",
        xcss: $f53519bf96c3cca1$var$styles.dualAvatarTriggerFill,
        'data-analytics-card-fill': 'avatar-item',
        'data-analytics-card-pointer': 'none'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: stack === 'default' ? $f53519bf96c3cca1$var$styles.dualAvatarVisualStackDefault : stack === 'large' ? $f53519bf96c3cca1$var$styles.dualAvatarVisualStackLarge : $f53519bf96c3cca1$var$styles.dualAvatarVisualStack,
        style: visualStackStyle
    }, userTarget)))));
};
module.exports["AgentUserDualAvatar"] = $f53519bf96c3cca1$export$524e3ea25887b088;
module.exports["DualAvatarWithIdentityCards"] = $f53519bf96c3cca1$export$382fb1bfcc6c89af;

});

parcelRegister("d6Ahp", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $arQY7 = parcelRequire("arQY7");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");


var $6gGPb = parcelRequire("6gGPb");


var $jC4nA = parcelRequire("jC4nA");


var $lSQgn = parcelRequire("lSQgn");


var $t45G9 = parcelRequire("t45G9");


var $7gxpq = parcelRequire("7gxpq");


var $dnhRJ = parcelRequire("dnhRJ");

var $jeQ2h = parcelRequire("jeQ2h");


var $jmjWc = parcelRequire("jmjWc");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $3EM6l = parcelRequire("3EM6l");


const $b1fbd1cdbf216579$var$CursorIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "b1Pb5",
    name: "CursorIcon",
    loader: async ()=>(await (parcelRequire("1ryYR"))).CursorIcon
});

const $b1fbd1cdbf216579$var$CursorPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "d5MrK",
    name: "CursorPresenceIcon",
    loader: async ()=>(await (parcelRequire("dIIWs"))).CursorPresenceIcon
});

const $b1fbd1cdbf216579$var$ExternalPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "5eua7",
    name: "ExternalPresenceIcon",
    loader: async ()=>(await (parcelRequire("79Gwb"))).ExternalPresenceIcon
});

const $b1fbd1cdbf216579$var$CanvaPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ggvDj",
    name: "CanvaPresenceIcon",
    loader: async ()=>(await (parcelRequire("h9Vld"))).CanvaPresenceIcon
}); /**
     * The Claude, ChatGPT and Figma brand icons only render for the rare
     * `agentIcon === 'claude'` / `'chatgpt'` / `'figma'` cases, so — like the Cursor icon —
     * they are code-split into their own chunks and loaded after paint rather than weighing
     * down every chunk that includes this module.
     */ 

const $b1fbd1cdbf216579$var$ClaudeIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "dxvVm",
    name: "ClaudeIcon",
    loader: async ()=>(await (parcelRequire("i13et"))).ClaudeIcon
}); /**
     * Presence tiles render inside LazyAnalyticsDialog (LAZY). LoadablePaint here
     * crashes the byline dialog: "ClaudePresenceIcon [PAINT] has a higher priority
     * of it's parent component LazyAnalyticsDialog[LAZY]". Match Figma/Lovable and
     * load after paint.
     */ 

const $b1fbd1cdbf216579$var$ClaudePresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "GVMA6",
    name: "ClaudePresenceIcon",
    loader: async ()=>(await (parcelRequire("kmCSD"))).ClaudePresenceIcon
});

const $b1fbd1cdbf216579$var$ChatGptIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "EXw4a",
    name: "ChatGptIcon",
    loader: async ()=>(await (parcelRequire("5werP"))).ChatGptIcon
});

const $b1fbd1cdbf216579$var$FigmaPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "NcBW4",
    name: "FigmaPresenceIcon",
    loader: async ()=>(await (parcelRequire("2o4Bs"))).FigmaPresenceIcon
});

const $b1fbd1cdbf216579$var$LovablePresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "hiKXZ",
    name: "LovablePresenceIcon",
    loader: async ()=>(await (parcelRequire("2IHZs"))).LovablePresenceIcon
});

const $b1fbd1cdbf216579$var$ReplitPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BdY0I",
    name: "ReplitPresenceIcon",
    loader: async ()=>(await (parcelRequire("lcZdN"))).ReplitPresenceIcon
}); /**
     * The Dia and Codex icons only render for the rare `agentIcon === 'dia'` / `'codex'`
     * cases, so — like the other brand icons — they are code-split into their own chunks and
     * loaded after paint.
     */ 

const $b1fbd1cdbf216579$var$DiaIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "00DEF",
    name: "DiaIcon",
    loader: async ()=>(await (parcelRequire("k5k9O"))).DiaIcon
});

const $b1fbd1cdbf216579$var$CodexIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "UYqXM",
    name: "CodexIcon",
    loader: async ()=>(await (parcelRequire("1d3Yv"))).CodexIcon
});

const $b1fbd1cdbf216579$var$CodexPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "stDdE",
    name: "CodexPresenceIcon",
    loader: async ()=>(await (parcelRequire("1G2db"))).CodexPresenceIcon
});

const $b1fbd1cdbf216579$var$RovoPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "i0C6G",
    name: "RovoPresenceIcon",
    loader: async ()=>(await (parcelRequire("c0CFL"))).RovoPresenceIcon
});

const $b1fbd1cdbf216579$var$GrokIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "rHk7j",
    name: "GrokIcon",
    loader: async ()=>(await (parcelRequire("j1q6z"))).GrokIcon
});

const $b1fbd1cdbf216579$var$GitHubCopilotIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "dP-Du",
    name: "GitHubCopilotIcon",
    loader: async ()=>(await (parcelRequire("60XCe"))).GitHubCopilotIcon
});

const $b1fbd1cdbf216579$var$VisualStudioCodeIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Nlex7",
    name: "VisualStudioCodeIcon",
    loader: async ()=>(await (parcelRequire("56hyP"))).VisualStudioCodeIcon
});

const $b1fbd1cdbf216579$var$OpenCodeIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "IBz4P",
    name: "OpenCodeIcon",
    loader: async ()=>(await (parcelRequire("8xiCz"))).OpenCodeIcon
});

const $b1fbd1cdbf216579$var$HermesAgentIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ygIH0",
    name: "HermesAgentIcon",
    loader: async ()=>(await (parcelRequire("kEfEw"))).HermesAgentIcon
});

const $b1fbd1cdbf216579$var$KiroIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "GmIrZ",
    name: "KiroIcon",
    loader: async ()=>(await (parcelRequire("752sB"))).KiroIcon
});

const $b1fbd1cdbf216579$var$FirstPartyAgentPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "RlN7s",
    name: "FirstPartyAgentPresenceIcon",
    loader: async ()=>(await (parcelRequire("6Q9J9"))).FirstPartyAgentPresenceIcon
});

const $b1fbd1cdbf216579$var$AmplitudePresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "erxfS",
    name: "AmplitudePresenceIcon",
    loader: async ()=>(await (parcelRequire("dWUzC"))).AmplitudePresenceIcon
});

const $b1fbd1cdbf216579$var$ChatGptPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "5Sn5H",
    name: "ChatGptPresenceIcon",
    loader: async ()=>(await (parcelRequire("055n4"))).ChatGptPresenceIcon
});

const $b1fbd1cdbf216579$var$CortexPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "aKhvU",
    name: "CortexPresenceIcon",
    loader: async ()=>(await (parcelRequire("j5D4h"))).CortexPresenceIcon
});

const $b1fbd1cdbf216579$var$DatabricksPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "56vYg",
    name: "DatabricksPresenceIcon",
    loader: async ()=>(await (parcelRequire("1nWYx"))).DatabricksPresenceIcon
});

const $b1fbd1cdbf216579$var$GitHubCopilotPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zvpYp",
    name: "GitHubCopilotPresenceIcon",
    loader: async ()=>(await (parcelRequire("4LPyf"))).GitHubCopilotPresenceIcon
});

const $b1fbd1cdbf216579$var$ManusPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "NPozu",
    name: "ManusPresenceIcon",
    loader: async ()=>(await (parcelRequire("eBS61"))).ManusPresenceIcon
});

const $b1fbd1cdbf216579$var$OpenAiPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "E8yL1",
    name: "OpenAiPresenceIcon",
    loader: async ()=>(await (parcelRequire("5DQMY"))).OpenAiPresenceIcon
});

const $b1fbd1cdbf216579$var$SlackPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "shcwR",
    name: "SlackPresenceIcon",
    loader: async ()=>(await (parcelRequire("dhvgg"))).SlackPresenceIcon
});

const $b1fbd1cdbf216579$var$AntigravityPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HAuKS",
    name: "AntigravityPresenceIcon",
    loader: async ()=>(await (parcelRequire("asP6p"))).AntigravityPresenceIcon
});

const $b1fbd1cdbf216579$var$DiaPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "khAwZ",
    name: "DiaPresenceIcon",
    loader: async ()=>(await (parcelRequire("1r0Kk"))).DiaPresenceIcon
});

const $b1fbd1cdbf216579$var$GeminiPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "M9R0Y",
    name: "GeminiPresenceIcon",
    loader: async ()=>(await (parcelRequire("dCjmm"))).GeminiPresenceIcon
});

const $b1fbd1cdbf216579$var$GrokPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "3EC9u",
    name: "GrokPresenceIcon",
    loader: async ()=>(await (parcelRequire("hNuBp"))).GrokPresenceIcon
});

const $b1fbd1cdbf216579$var$HermesAgentPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "bHfrR",
    name: "HermesAgentPresenceIcon",
    loader: async ()=>(await (parcelRequire("jURii"))).HermesAgentPresenceIcon
});

const $b1fbd1cdbf216579$var$KiroPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "g9WFV",
    name: "KiroPresenceIcon",
    loader: async ()=>(await (parcelRequire("mPmb7"))).KiroPresenceIcon
});

const $b1fbd1cdbf216579$var$MicrosoftCopilotPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "fPa7_",
    name: "MicrosoftCopilotPresenceIcon",
    loader: async ()=>(await (parcelRequire("e6Wll"))).MicrosoftCopilotPresenceIcon
});

const $b1fbd1cdbf216579$var$VisualStudioCodePresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Q1mvx",
    name: "VisualStudioCodePresenceIcon",
    loader: async ()=>(await (parcelRequire("96KjE"))).VisualStudioCodePresenceIcon
});
const $b1fbd1cdbf216579$var$unidentifiedAgentAvatarBackgroundStyles = null;
const $b1fbd1cdbf216579$var$AGENT_AVATAR_CLIP_PATH = 'polygon(45% 1.33975%, 46.5798% 0.60307%, 48.26352% 0.15192%, 50% 0%, 51.73648% 0.15192%, 53.4202% 0.60307%, 55% 1.33975%, 89.64102% 21.33975%, 91.06889% 22.33956%, 92.30146% 23.57212%, 93.30127% 25%, 94.03794% 26.5798%, 94.48909% 28.26352%, 94.64102% 30%, 94.64102% 70%, 94.48909% 71.73648%, 94.03794% 73.4202%, 93.30127% 75%, 92.30146% 76.42788%, 91.06889% 77.66044%, 89.64102% 78.66025%, 55% 98.66025%, 53.4202% 99.39693%, 51.73648% 99.84808%, 50% 100%, 48.26352% 99.84808%, 46.5798% 99.39693%, 45% 98.66025%, 10.35898% 78.66025%, 8.93111% 77.66044%, 7.69854% 76.42788%, 6.69873% 75%, 5.96206% 73.4202%, 5.51091% 71.73648%, 5.35898% 70%, 5.35898% 30%, 5.51091% 28.26352%, 5.96206% 26.5798%, 6.69873% 25%, 7.69854% 23.57212%, 8.93111% 22.33956%, 10.35898% 21.33975%)';
const $b1fbd1cdbf216579$var$styles = {
    xxsmall: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02ey7F _0jFU0Vey7F _3YEZNOdnbC",
    compactInlineSpacing: "_0GTcwRFQfX _2xTnZxFQfX",
    small: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02oWWg _0jFU0VoWWg _3YEZNOdnbC _0GTcwRFQfX _2xTnZxFQfX",
    medium: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02Uofl _0jFU0VUofl _3YEZNOdnbC _2xTnZxFQfX",
    iconWrapperSmallNoSpacing: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02oWWg _0jFU0VoWWg _3YEZNOdnbC",
    iconWrapperMediumNoSpacing: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02Uofl _0jFU0VUofl _3YEZNOdnbC",
    unidentifiedAgentAvatarSmall: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02oWWg _0jFU0VoWWg _3YEZNOdnbC _0GTcwRFQfX _2xTnZxFQfX _1uo2ZfTcEg",
    unidentifiedAgentAvatarMedium: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02Uofl _0jFU0VUofl _3YEZNOdnbC _2xTnZxFQfX _1uo2ZfTcEg",
    unidentifiedAgentAvatarSmallNoSpacing: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02oWWg _0jFU0VoWWg _3YEZNOdnbC _1uo2ZfTcEg",
    unidentifiedAgentAvatarMediumNoSpacing: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02Uofl _0jFU0VUofl _3YEZNOdnbC _1uo2ZfTcEg",
    brandAgentTile: "_1uo2ZfTcEg _0KLXruDMqu",
    accountAvatarTile: "_1uo2ZfTcEg",
    accountAvatarSurface: "_0KLXrulfZc",
    profileClickableAccountAvatar: "_1VJPcaV97n _0yKXXaDIqT",
    profileClickableAccountAvatarTile: "_1VJPca3VxJ _0yKXXaDIqT",
    presenceGlyphTile: "_4bt5LAYvD1 _2WAcuGYvD1 _3iDTPbQ4SZ",
    avatarOffsetInlineStart: "_1VJPcac8DQ"
};
const $b1fbd1cdbf216579$var$AgentAvatarContainer = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { avatarSize: avatarSize, hasInlineSpacing: hasInlineSpacing, children: children } = t0;
    if (avatarSize === "xxsmall") {
        const t1 = hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing;
        let t2;
        if ($[0] !== t1) {
            t2 = (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles.xxsmall, t1);
            $[0] = t1;
            $[1] = t2;
        } else t2 = $[1];
        let t3;
        if ($[2] !== children || $[3] !== t2) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: t2
            }, children);
            $[2] = children;
            $[3] = t2;
            $[4] = t3;
        } else t3 = $[4];
        return t3;
    }
    if (avatarSize === "medium" && hasInlineSpacing) {
        let t1;
        if ($[5] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $b1fbd1cdbf216579$var$styles.medium
            }, children);
            $[5] = children;
            $[6] = t1;
        } else t1 = $[6];
        return t1;
    }
    if (avatarSize === "medium") {
        let t1;
        if ($[7] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $b1fbd1cdbf216579$var$styles.iconWrapperMediumNoSpacing
            }, children);
            $[7] = children;
            $[8] = t1;
        } else t1 = $[8];
        return t1;
    }
    if (hasInlineSpacing) {
        let t1;
        if ($[9] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $b1fbd1cdbf216579$var$styles.small
            }, children);
            $[9] = children;
            $[10] = t1;
        } else t1 = $[10];
        return t1;
    }
    let t1;
    if ($[11] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $b1fbd1cdbf216579$var$styles.iconWrapperSmallNoSpacing
        }, children);
        $[11] = children;
        $[12] = t1;
    } else t1 = $[12];
    return t1;
} : ({ avatarSize: avatarSize, hasInlineSpacing: hasInlineSpacing, children: children })=>{
    if (avatarSize === 'xxsmall') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles.xxsmall, hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing)
    }, children);
    if (avatarSize === 'medium' && hasInlineSpacing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $b1fbd1cdbf216579$var$styles.medium
    }, children);
    if (avatarSize === 'medium') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $b1fbd1cdbf216579$var$styles.iconWrapperMediumNoSpacing
    }, children);
    if (hasInlineSpacing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $b1fbd1cdbf216579$var$styles.small
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $b1fbd1cdbf216579$var$styles.iconWrapperSmallNoSpacing
    }, children);
};
const $b1fbd1cdbf216579$var$UnidentifiedAgentAvatar = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    const { avatarSize: avatarSize, hasInlineSpacing: hasInlineSpacing } = t0;
    if (avatarSize === "xxsmall") {
        const t1 = hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing;
        let t2;
        if ($[0] !== t1) {
            t2 = (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles.xxsmall, $b1fbd1cdbf216579$var$styles.brandAgentTile, t1);
            $[0] = t1;
            $[1] = t2;
        } else t2 = $[1];
        let t3;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jC4nA))), {
                label: "",
                size: "small",
                color: "var(--ds-icon-subtle, #505258)"
            });
            $[2] = t3;
        } else t3 = $[2];
        let t4;
        if ($[3] !== t2) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                testId: "unidentified-agent-avatar",
                xcss: t2
            }, t3);
            $[3] = t2;
            $[4] = t4;
        } else t4 = $[4];
        return t4;
    }
    let t1;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_2yBoao1qiM"
        ]);
        $[5] = t1;
    } else t1 = $[5];
    let t2;
    if ($[6] !== avatarSize) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($jC4nA))),
            label: "",
            appearance: "gray",
            size: avatarSize
        });
        $[6] = avatarSize;
        $[7] = t2;
    } else t2 = $[7];
    let t3;
    if ($[8] !== t1 || $[9] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "data-testid": "unidentified-agent-avatar-background",
            className: t1
        }, t2);
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
    } else t3 = $[10];
    const icon = t3;
    if (avatarSize === "medium" && hasInlineSpacing) {
        let t4;
        if ($[11] !== icon) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                testId: "unidentified-agent-avatar",
                xcss: $b1fbd1cdbf216579$var$styles.unidentifiedAgentAvatarMedium
            }, icon);
            $[11] = icon;
            $[12] = t4;
        } else t4 = $[12];
        return t4;
    }
    if (avatarSize === "medium") {
        let t4;
        if ($[13] !== icon) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                testId: "unidentified-agent-avatar",
                xcss: $b1fbd1cdbf216579$var$styles.unidentifiedAgentAvatarMediumNoSpacing
            }, icon);
            $[13] = icon;
            $[14] = t4;
        } else t4 = $[14];
        return t4;
    }
    if (hasInlineSpacing) {
        let t4;
        if ($[15] !== icon) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                testId: "unidentified-agent-avatar",
                xcss: $b1fbd1cdbf216579$var$styles.unidentifiedAgentAvatarSmall
            }, icon);
            $[15] = icon;
            $[16] = t4;
        } else t4 = $[16];
        return t4;
    }
    let t4;
    if ($[17] !== icon) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: "unidentified-agent-avatar",
            xcss: $b1fbd1cdbf216579$var$styles.unidentifiedAgentAvatarSmallNoSpacing
        }, icon);
        $[17] = icon;
        $[18] = t4;
    } else t4 = $[18];
    return t4;
} : ({ avatarSize: avatarSize, hasInlineSpacing: hasInlineSpacing })=>{
    if (avatarSize === 'xxsmall') // IconTile starts at 20px; compose the compact 16px hexagon with the native small icon.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "unidentified-agent-avatar",
        xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles.xxsmall, $b1fbd1cdbf216579$var$styles.brandAgentTile, hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jC4nA))), {
        label: "",
        size: "small",
        color: "var(--ds-icon-subtle, #505258)"
    }));
    const icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "data-testid": "unidentified-agent-avatar-background",
        className: (0, $hekY6.default)([
            "_2yBoao1qiM"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jC4nA))),
        label: "",
        appearance: "gray",
        size: avatarSize
    }));
    if (avatarSize === 'medium' && hasInlineSpacing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "unidentified-agent-avatar",
        xcss: $b1fbd1cdbf216579$var$styles.unidentifiedAgentAvatarMedium
    }, icon);
    if (avatarSize === 'medium') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "unidentified-agent-avatar",
        xcss: $b1fbd1cdbf216579$var$styles.unidentifiedAgentAvatarMediumNoSpacing
    }, icon);
    if (hasInlineSpacing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "unidentified-agent-avatar",
        xcss: $b1fbd1cdbf216579$var$styles.unidentifiedAgentAvatarSmall
    }, icon);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "unidentified-agent-avatar",
        xcss: $b1fbd1cdbf216579$var$styles.unidentifiedAgentAvatarSmallNoSpacing
    }, icon);
}; /**
    * Renders an agent row's leading icon: the fixed AiAgent/Rovo icon for agents that
    * couldn't be resolved to an account, otherwise an ADS Avatar in a hexagon. The
    * feature gate keeps the deprecated AgentAvatar as the fallback during rollout.
    */ 
const $b1fbd1cdbf216579$export$951877a280bbd2e = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(306);
    const { name: name, agentIcon: agentIcon, borderColor: providedBorderColor, avatarUrl: avatarUrl, avatarSize: t1, markSize: markSize, isOffsetInlineStart: t2, hasInlineSpacing: t3, fillProfileClickableFrame: t4, colorMode: providedColorMode, usePresenceArtwork: t5, presenceTileFill: presenceTileFill, presenceOutline: presenceOutline } = t0;
    const avatarSize = t1 === undefined ? "small" : t1;
    const isOffsetInlineStart = t2 === undefined ? false : t2;
    const hasInlineSpacing = t3 === undefined ? true : t3;
    const fillProfileClickableFrame = t4 === undefined ? false : t4;
    const usePresenceArtwork = t5 === undefined ? false : t5;
    let isDualAgentAvatarCardEnabled;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        isDualAgentAvatarCardEnabled = false;
        if ((0, $6mKj3.expVal)("dual_agent_avatar_card", "isEnabled", false)) isDualAgentAvatarCardEnabled = true;
        $[0] = isDualAgentAvatarCardEnabled;
    } else isDualAgentAvatarCardEnabled = $[0];
    const observedColorMode = (0, $3EM6l.useAgentAvatarColorMode)();
    const colorMode = providedColorMode ?? (isDualAgentAvatarCardEnabled ? observedColorMode : "light");
    const borderColor = providedBorderColor === undefined && isDualAgentAvatarCardEnabled ? "var(--ds-surface, #FFFFFF)" : providedBorderColor;
    isDualAgentAvatarCardEnabled;
    let t6;
    if ($[1] !== agentIcon || $[2] !== colorMode || $[3] !== presenceOutline) {
        t6 = presenceOutline ?? (isDualAgentAvatarCardEnabled ? (0, $jeQ2h.resolvePresenceOutline)({
            tone: (0, $dnhRJ.getAgentBrandTone)(agentIcon),
            colorMode: colorMode
        }) : undefined);
        $[1] = agentIcon;
        $[2] = colorMode;
        $[3] = presenceOutline;
        $[4] = t6;
    } else t6 = $[4];
    const resolvedPresenceOutline = t6;
    const presenceArtworkEnabled = usePresenceArtwork || isDualAgentAvatarCardEnabled;
    let t7;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = {
            xxsmall: 16,
            small: 24,
            medium: 32
        };
        $[5] = t7;
    } else t7 = $[5];
    const iconSize = t7[avatarSize];
    const iconMarkSize = markSize ?? iconSize;
    const shouldFillProfileClickableFrame = fillProfileClickableFrame && isDualAgentAvatarCardEnabled;
    let t8;
    if ($[6] !== avatarSize || $[7] !== hasInlineSpacing || $[8] !== resolvedPresenceOutline) {
        t8 = (icon)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AgentAvatarContainer, {
                avatarSize: avatarSize,
                hasInlineSpacing: hasInlineSpacing
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $b1fbd1cdbf216579$var$styles.presenceGlyphTile,
                testId: "presence-brand-tile"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7gxpq.PresenceHexOutlineContext).Provider, {
                value: resolvedPresenceOutline
            }, icon)));
        $[6] = avatarSize;
        $[7] = hasInlineSpacing;
        $[8] = resolvedPresenceOutline;
        $[9] = t8;
    } else t8 = $[9];
    const presenceTile = t8;
    let t9;
    bb0: {
        if (agentIcon === "ai-agent" && presenceArtworkEnabled) {
            let t10;
            if ($[10] !== usePresenceArtwork) {
                t10 = !usePresenceArtwork || (0, $6mKj3.expVal)("dual_agent_avatar_card", "isEnabled", false);
                $[10] = usePresenceArtwork;
                $[11] = t10;
            } else t10 = $[11];
            let t11;
            if ($[12] !== iconSize || $[13] !== providedBorderColor || $[14] !== t10) {
                t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ExternalPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: providedBorderColor,
                    useBorderlessArtwork: t10
                });
                $[12] = iconSize;
                $[13] = providedBorderColor;
                $[14] = t10;
                $[15] = t11;
            } else t11 = $[15];
            let t12;
            if ($[16] !== presenceTile || $[17] !== t11) {
                t12 = presenceTile(t11);
                $[16] = presenceTile;
                $[17] = t11;
                $[18] = t12;
            } else t12 = $[18];
            t9 = t12;
            break bb0;
        }
        if (agentIcon === "ai-agent") {
            let t10;
            if ($[19] !== avatarSize || $[20] !== hasInlineSpacing) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$UnidentifiedAgentAvatar, {
                    avatarSize: avatarSize,
                    hasInlineSpacing: hasInlineSpacing
                });
                $[19] = avatarSize;
                $[20] = hasInlineSpacing;
                $[21] = t10;
            } else t10 = $[21];
            t9 = t10;
            break bb0;
        }
        if (agentIcon === "rovo" && presenceArtworkEnabled) {
            let t10;
            if ($[22] !== borderColor || $[23] !== colorMode || $[24] !== iconSize || $[25] !== presenceTileFill) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$RovoPresenceIcon, {
                    label: "",
                    size: iconSize,
                    colorMode: colorMode,
                    borderColor: borderColor,
                    fill: presenceTileFill
                });
                $[22] = borderColor;
                $[23] = colorMode;
                $[24] = iconSize;
                $[25] = presenceTileFill;
                $[26] = t10;
            } else t10 = $[26];
            let t11;
            if ($[27] !== presenceTile || $[28] !== t10) {
                t11 = presenceTile(t10);
                $[27] = presenceTile;
                $[28] = t10;
                $[29] = t11;
            } else t11 = $[29];
            t9 = t11;
            break bb0;
        }
        if (agentIcon === "rovo") {
            let t10;
            if ($[30] !== iconMarkSize) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $t45G9.RovoIcon), {
                    label: "",
                    size: iconMarkSize
                });
                $[30] = iconMarkSize;
                $[31] = t10;
            } else t10 = $[31];
            let t11;
            if ($[32] !== avatarSize || $[33] !== hasInlineSpacing || $[34] !== t10) {
                t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AgentAvatarContainer, {
                    avatarSize: avatarSize,
                    hasInlineSpacing: hasInlineSpacing
                }, t10);
                $[32] = avatarSize;
                $[33] = hasInlineSpacing;
                $[34] = t10;
                $[35] = t11;
            } else t11 = $[35];
            t9 = t11;
            break bb0;
        }
        if (agentIcon === "cursor" && presenceArtworkEnabled) {
            let t10;
            if ($[36] !== borderColor || $[37] !== iconSize) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$CursorPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[36] = borderColor;
                $[37] = iconSize;
                $[38] = t10;
            } else t10 = $[38];
            let t11;
            if ($[39] !== presenceTile || $[40] !== t10) {
                t11 = presenceTile(t10);
                $[39] = presenceTile;
                $[40] = t10;
                $[41] = t11;
            } else t11 = $[41];
            t9 = t11;
            break bb0;
        }
        if (agentIcon === "cursor") {
            let t10;
            if ($[42] !== iconMarkSize) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$CursorIcon, {
                    label: "",
                    size: iconMarkSize
                });
                $[42] = iconMarkSize;
                $[43] = t10;
            } else t10 = $[43];
            let t11;
            if ($[44] !== avatarSize || $[45] !== hasInlineSpacing || $[46] !== t10) {
                t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AgentAvatarContainer, {
                    avatarSize: avatarSize,
                    hasInlineSpacing: hasInlineSpacing
                }, t10);
                $[44] = avatarSize;
                $[45] = hasInlineSpacing;
                $[46] = t10;
                $[47] = t11;
            } else t11 = $[47];
            t9 = t11;
            break bb0;
        }
        if (agentIcon === "canva" && presenceArtworkEnabled) {
            let t10;
            if ($[48] !== borderColor || $[49] !== iconSize) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$CanvaPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[48] = borderColor;
                $[49] = iconSize;
                $[50] = t10;
            } else t10 = $[50];
            let t11;
            if ($[51] !== presenceTile || $[52] !== t10) {
                t11 = presenceTile(t10);
                $[51] = presenceTile;
                $[52] = t10;
                $[53] = t11;
            } else t11 = $[53];
            t9 = t11;
            break bb0;
        }
        if (agentIcon === "claude" && presenceArtworkEnabled) {
            let t10;
            if ($[54] !== borderColor || $[55] !== iconSize) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ClaudePresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[54] = borderColor;
                $[55] = iconSize;
                $[56] = t10;
            } else t10 = $[56];
            let t11;
            if ($[57] !== presenceTile || $[58] !== t10) {
                t11 = presenceTile(t10);
                $[57] = presenceTile;
                $[58] = t10;
                $[59] = t11;
            } else t11 = $[59];
            t9 = t11;
            break bb0;
        }
        if (agentIcon === "claude") {
            const t10 = $b1fbd1cdbf216579$var$styles[avatarSize];
            const t11 = avatarSize === "xxsmall" && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing;
            let t12;
            if ($[60] !== t10 || $[61] !== t11) {
                t12 = (0, $w6R6I.cx)(t10, t11);
                $[60] = t10;
                $[61] = t11;
                $[62] = t12;
            } else t12 = $[62];
            let t13;
            if ($[63] !== iconMarkSize) {
                t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ClaudeIcon, {
                    label: "",
                    size: iconMarkSize
                });
                $[63] = iconMarkSize;
                $[64] = t13;
            } else t13 = $[64];
            let t14;
            if ($[65] !== t12 || $[66] !== t13) {
                t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t12
                }, t13);
                $[65] = t12;
                $[66] = t13;
                $[67] = t14;
            } else t14 = $[67];
            t9 = t14;
            break bb0;
        }
        if (agentIcon === "chatgpt" && presenceArtworkEnabled) {
            let t10;
            if ($[68] !== borderColor || $[69] !== iconSize) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ChatGptPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[68] = borderColor;
                $[69] = iconSize;
                $[70] = t10;
            } else t10 = $[70];
            let t11;
            if ($[71] !== presenceTile || $[72] !== t10) {
                t11 = presenceTile(t10);
                $[71] = presenceTile;
                $[72] = t10;
                $[73] = t11;
            } else t11 = $[73];
            t9 = t11;
            break bb0;
        }
        if (agentIcon === "antigravity" && presenceArtworkEnabled) {
            let t10;
            if ($[74] !== borderColor || $[75] !== iconSize || $[76] !== presenceTileFill) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AntigravityPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor,
                    fill: presenceTileFill
                });
                $[74] = borderColor;
                $[75] = iconSize;
                $[76] = presenceTileFill;
                $[77] = t10;
            } else t10 = $[77];
            let t11;
            if ($[78] !== presenceTile || $[79] !== t10) {
                t11 = presenceTile(t10);
                $[78] = presenceTile;
                $[79] = t10;
                $[80] = t11;
            } else t11 = $[80];
            t9 = t11;
            break bb0;
        }
        if (agentIcon === "dia" && presenceArtworkEnabled) {
            let t10;
            if ($[81] !== borderColor || $[82] !== iconSize) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$DiaPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[81] = borderColor;
                $[82] = iconSize;
                $[83] = t10;
            } else t10 = $[83];
            let t11;
            if ($[84] !== presenceTile || $[85] !== t10) {
                t11 = presenceTile(t10);
                $[84] = presenceTile;
                $[85] = t10;
                $[86] = t11;
            } else t11 = $[86];
            t9 = t11;
            break bb0;
        }
        if (agentIcon === "gemini" && presenceArtworkEnabled) {
            let t10;
            if ($[87] !== borderColor || $[88] !== iconSize || $[89] !== presenceTileFill) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$GeminiPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor,
                    fill: presenceTileFill
                });
                $[87] = borderColor;
                $[88] = iconSize;
                $[89] = presenceTileFill;
                $[90] = t10;
            } else t10 = $[90];
            let t11;
            if ($[91] !== presenceTile || $[92] !== t10) {
                t11 = presenceTile(t10);
                $[91] = presenceTile;
                $[92] = t10;
                $[93] = t11;
            } else t11 = $[93];
            t9 = t11;
            break bb0;
        }
        if (agentIcon === "grok" && presenceArtworkEnabled) {
            let t10;
            if ($[94] !== borderColor || $[95] !== iconSize) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$GrokPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[94] = borderColor;
                $[95] = iconSize;
                $[96] = t10;
            } else t10 = $[96];
            let t11;
            if ($[97] !== presenceTile || $[98] !== t10) {
                t11 = presenceTile(t10);
                $[97] = presenceTile;
                $[98] = t10;
                $[99] = t11;
            } else t11 = $[99];
            t9 = t11;
            break bb0;
        }
        if (agentIcon === "hermes" && presenceArtworkEnabled) {
            let t10;
            if ($[100] !== borderColor || $[101] !== iconSize || $[102] !== presenceTileFill) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$HermesAgentPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor,
                    fill: presenceTileFill
                });
                $[100] = borderColor;
                $[101] = iconSize;
                $[102] = presenceTileFill;
                $[103] = t10;
            } else t10 = $[103];
            let t11;
            if ($[104] !== presenceTile || $[105] !== t10) {
                t11 = presenceTile(t10);
                $[104] = presenceTile;
                $[105] = t10;
                $[106] = t11;
            } else t11 = $[106];
            t9 = t11;
            break bb0;
        }
        if (agentIcon === "kiro" && presenceArtworkEnabled) {
            let t10;
            if ($[107] !== borderColor || $[108] !== iconSize) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$KiroPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[107] = borderColor;
                $[108] = iconSize;
                $[109] = t10;
            } else t10 = $[109];
            let t11;
            if ($[110] !== presenceTile || $[111] !== t10) {
                t11 = presenceTile(t10);
                $[110] = presenceTile;
                $[111] = t10;
                $[112] = t11;
            } else t11 = $[112];
            t9 = t11;
            break bb0;
        }
        if (agentIcon === "microsoft-copilot" && presenceArtworkEnabled) {
            let t10;
            if ($[113] !== borderColor || $[114] !== iconSize || $[115] !== presenceTileFill) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$MicrosoftCopilotPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor,
                    fill: presenceTileFill
                });
                $[113] = borderColor;
                $[114] = iconSize;
                $[115] = presenceTileFill;
                $[116] = t10;
            } else t10 = $[116];
            let t11;
            if ($[117] !== presenceTile || $[118] !== t10) {
                t11 = presenceTile(t10);
                $[117] = presenceTile;
                $[118] = t10;
                $[119] = t11;
            } else t11 = $[119];
            t9 = t11;
            break bb0;
        }
        if (agentIcon === "vscode" && presenceArtworkEnabled) {
            let t10;
            if ($[120] !== borderColor || $[121] !== iconSize || $[122] !== presenceTileFill) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$VisualStudioCodePresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor,
                    fill: presenceTileFill
                });
                $[120] = borderColor;
                $[121] = iconSize;
                $[122] = presenceTileFill;
                $[123] = t10;
            } else t10 = $[123];
            let t11;
            if ($[124] !== presenceTile || $[125] !== t10) {
                t11 = presenceTile(t10);
                $[124] = presenceTile;
                $[125] = t10;
                $[126] = t11;
            } else t11 = $[126];
            t9 = t11;
            break bb0;
        }
        if (agentIcon === "chatgpt") {
            const t10 = $b1fbd1cdbf216579$var$styles[avatarSize];
            const t11 = avatarSize === "xxsmall" && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing;
            let t12;
            if ($[127] !== t10 || $[128] !== t11) {
                t12 = (0, $w6R6I.cx)(t10, t11);
                $[127] = t10;
                $[128] = t11;
                $[129] = t12;
            } else t12 = $[129];
            let t13;
            if ($[130] !== iconMarkSize) {
                t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ChatGptIcon, {
                    label: "",
                    size: iconMarkSize
                });
                $[130] = iconMarkSize;
                $[131] = t13;
            } else t13 = $[131];
            let t14;
            if ($[132] !== t12 || $[133] !== t13) {
                t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t12
                }, t13);
                $[132] = t12;
                $[133] = t13;
                $[134] = t14;
            } else t14 = $[134];
            t9 = t14;
            break bb0;
        }
        if (agentIcon === "figma" && presenceArtworkEnabled) {
            let t10;
            if ($[135] !== borderColor || $[136] !== iconSize) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$FigmaPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[135] = borderColor;
                $[136] = iconSize;
                $[137] = t10;
            } else t10 = $[137];
            let t11;
            if ($[138] !== presenceTile || $[139] !== t10) {
                t11 = presenceTile(t10);
                $[138] = presenceTile;
                $[139] = t10;
                $[140] = t11;
            } else t11 = $[140];
            t9 = t11;
            break bb0;
        }
        if (agentIcon === "lovable" && presenceArtworkEnabled) {
            let t10;
            if ($[141] !== borderColor || $[142] !== iconSize) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$LovablePresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[141] = borderColor;
                $[142] = iconSize;
                $[143] = t10;
            } else t10 = $[143];
            let t11;
            if ($[144] !== presenceTile || $[145] !== t10) {
                t11 = presenceTile(t10);
                $[144] = presenceTile;
                $[145] = t10;
                $[146] = t11;
            } else t11 = $[146];
            t9 = t11;
            break bb0;
        }
        if (agentIcon === "replit" && presenceArtworkEnabled) {
            let t10;
            if ($[147] !== borderColor || $[148] !== iconSize) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ReplitPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[147] = borderColor;
                $[148] = iconSize;
                $[149] = t10;
            } else t10 = $[149];
            let t11;
            if ($[150] !== presenceTile || $[151] !== t10) {
                t11 = presenceTile(t10);
                $[150] = presenceTile;
                $[151] = t10;
                $[152] = t11;
            } else t11 = $[152];
            t9 = t11;
            break bb0;
        }
        if (agentIcon === "dia") {
            const t10 = $b1fbd1cdbf216579$var$styles[avatarSize];
            const t11 = avatarSize === "xxsmall" && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing;
            let t12;
            if ($[153] !== t10 || $[154] !== t11) {
                t12 = (0, $w6R6I.cx)(t10, t11, $b1fbd1cdbf216579$var$styles.brandAgentTile);
                $[153] = t10;
                $[154] = t11;
                $[155] = t12;
            } else t12 = $[155];
            let t13;
            if ($[156] !== iconMarkSize) {
                t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$DiaIcon, {
                    label: "",
                    size: iconMarkSize
                });
                $[156] = iconMarkSize;
                $[157] = t13;
            } else t13 = $[157];
            let t14;
            if ($[158] !== t12 || $[159] !== t13) {
                t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t12
                }, t13);
                $[158] = t12;
                $[159] = t13;
                $[160] = t14;
            } else t14 = $[160];
            t9 = t14;
            break bb0;
        }
        if (agentIcon === "codex" && presenceArtworkEnabled) {
            let t10;
            if ($[161] !== borderColor || $[162] !== colorMode || $[163] !== iconSize) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$CodexPresenceIcon, {
                    label: "",
                    size: iconSize,
                    colorMode: colorMode,
                    borderColor: borderColor
                });
                $[161] = borderColor;
                $[162] = colorMode;
                $[163] = iconSize;
                $[164] = t10;
            } else t10 = $[164];
            let t11;
            if ($[165] !== presenceTile || $[166] !== t10) {
                t11 = presenceTile(t10);
                $[165] = presenceTile;
                $[166] = t10;
                $[167] = t11;
            } else t11 = $[167];
            t9 = t11;
            break bb0;
        }
        if (agentIcon === "first-party" && presenceArtworkEnabled) {
            let t10;
            if ($[168] !== borderColor || $[169] !== iconSize) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$FirstPartyAgentPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[168] = borderColor;
                $[169] = iconSize;
                $[170] = t10;
            } else t10 = $[170];
            let t11;
            if ($[171] !== presenceTile || $[172] !== t10) {
                t11 = presenceTile(t10);
                $[171] = presenceTile;
                $[172] = t10;
                $[173] = t11;
            } else t11 = $[173];
            t9 = t11;
            break bb0;
        }
        if (agentIcon === "amplitude" && presenceArtworkEnabled) {
            let t10;
            if ($[174] !== borderColor || $[175] !== iconSize) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AmplitudePresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[174] = borderColor;
                $[175] = iconSize;
                $[176] = t10;
            } else t10 = $[176];
            let t11;
            if ($[177] !== presenceTile || $[178] !== t10) {
                t11 = presenceTile(t10);
                $[177] = presenceTile;
                $[178] = t10;
                $[179] = t11;
            } else t11 = $[179];
            t9 = t11;
            break bb0;
        }
        if (agentIcon === "cortex" && presenceArtworkEnabled) {
            let t10;
            if ($[180] !== borderColor || $[181] !== iconSize) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$CortexPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[180] = borderColor;
                $[181] = iconSize;
                $[182] = t10;
            } else t10 = $[182];
            let t11;
            if ($[183] !== presenceTile || $[184] !== t10) {
                t11 = presenceTile(t10);
                $[183] = presenceTile;
                $[184] = t10;
                $[185] = t11;
            } else t11 = $[185];
            t9 = t11;
            break bb0;
        }
        if (agentIcon === "databricks" && presenceArtworkEnabled) {
            let t10;
            if ($[186] !== borderColor || $[187] !== iconSize) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$DatabricksPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[186] = borderColor;
                $[187] = iconSize;
                $[188] = t10;
            } else t10 = $[188];
            let t11;
            if ($[189] !== presenceTile || $[190] !== t10) {
                t11 = presenceTile(t10);
                $[189] = presenceTile;
                $[190] = t10;
                $[191] = t11;
            } else t11 = $[191];
            t9 = t11;
            break bb0;
        }
        if (agentIcon === "github-copilot" && presenceArtworkEnabled) {
            let t10;
            if ($[192] !== borderColor || $[193] !== iconSize) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$GitHubCopilotPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[192] = borderColor;
                $[193] = iconSize;
                $[194] = t10;
            } else t10 = $[194];
            let t11;
            if ($[195] !== presenceTile || $[196] !== t10) {
                t11 = presenceTile(t10);
                $[195] = presenceTile;
                $[196] = t10;
                $[197] = t11;
            } else t11 = $[197];
            t9 = t11;
            break bb0;
        }
        if (agentIcon === "manus" && presenceArtworkEnabled) {
            let t10;
            if ($[198] !== borderColor || $[199] !== iconSize) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ManusPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[198] = borderColor;
                $[199] = iconSize;
                $[200] = t10;
            } else t10 = $[200];
            let t11;
            if ($[201] !== presenceTile || $[202] !== t10) {
                t11 = presenceTile(t10);
                $[201] = presenceTile;
                $[202] = t10;
                $[203] = t11;
            } else t11 = $[203];
            t9 = t11;
            break bb0;
        }
        if (agentIcon === "openai" && presenceArtworkEnabled) {
            let t10;
            if ($[204] !== borderColor || $[205] !== iconSize) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$OpenAiPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[204] = borderColor;
                $[205] = iconSize;
                $[206] = t10;
            } else t10 = $[206];
            let t11;
            if ($[207] !== presenceTile || $[208] !== t10) {
                t11 = presenceTile(t10);
                $[207] = presenceTile;
                $[208] = t10;
                $[209] = t11;
            } else t11 = $[209];
            t9 = t11;
            break bb0;
        }
        if (agentIcon === "slack" && presenceArtworkEnabled) {
            let t10;
            if ($[210] !== borderColor || $[211] !== iconSize) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$SlackPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[210] = borderColor;
                $[211] = iconSize;
                $[212] = t10;
            } else t10 = $[212];
            let t11;
            if ($[213] !== presenceTile || $[214] !== t10) {
                t11 = presenceTile(t10);
                $[213] = presenceTile;
                $[214] = t10;
                $[215] = t11;
            } else t11 = $[215];
            t9 = t11;
            break bb0;
        }
        if (agentIcon === "codex") {
            const t10 = $b1fbd1cdbf216579$var$styles[avatarSize];
            const t11 = avatarSize === "xxsmall" && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing;
            let t12;
            if ($[216] !== t10 || $[217] !== t11) {
                t12 = (0, $w6R6I.cx)(t10, t11, $b1fbd1cdbf216579$var$styles.brandAgentTile);
                $[216] = t10;
                $[217] = t11;
                $[218] = t12;
            } else t12 = $[218];
            let t13;
            if ($[219] !== iconMarkSize) {
                t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$CodexIcon, {
                    label: "",
                    size: iconMarkSize
                });
                $[219] = iconMarkSize;
                $[220] = t13;
            } else t13 = $[220];
            let t14;
            if ($[221] !== t12 || $[222] !== t13) {
                t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t12
                }, t13);
                $[221] = t12;
                $[222] = t13;
                $[223] = t14;
            } else t14 = $[223];
            t9 = t14;
            break bb0;
        }
        if (agentIcon === "grok" && presenceArtworkEnabled) {
            const t10 = $b1fbd1cdbf216579$var$styles[avatarSize];
            const t11 = avatarSize === "xxsmall" && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing;
            let t12;
            if ($[224] !== t10 || $[225] !== t11) {
                t12 = (0, $w6R6I.cx)(t10, t11, $b1fbd1cdbf216579$var$styles.brandAgentTile);
                $[224] = t10;
                $[225] = t11;
                $[226] = t12;
            } else t12 = $[226];
            let t13;
            if ($[227] !== iconMarkSize) {
                t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$GrokIcon, {
                    label: "",
                    size: iconMarkSize
                });
                $[227] = iconMarkSize;
                $[228] = t13;
            } else t13 = $[228];
            let t14;
            if ($[229] !== t12 || $[230] !== t13) {
                t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t12
                }, t13);
                $[229] = t12;
                $[230] = t13;
                $[231] = t14;
            } else t14 = $[231];
            t9 = t14;
            break bb0;
        }
        if (agentIcon === "github-copilot" && presenceArtworkEnabled) {
            const t10 = $b1fbd1cdbf216579$var$styles[avatarSize];
            const t11 = avatarSize === "xxsmall" && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing;
            let t12;
            if ($[232] !== t10 || $[233] !== t11) {
                t12 = (0, $w6R6I.cx)(t10, t11, $b1fbd1cdbf216579$var$styles.brandAgentTile);
                $[232] = t10;
                $[233] = t11;
                $[234] = t12;
            } else t12 = $[234];
            let t13;
            if ($[235] !== iconMarkSize) {
                t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$GitHubCopilotIcon, {
                    label: "",
                    size: iconMarkSize
                });
                $[235] = iconMarkSize;
                $[236] = t13;
            } else t13 = $[236];
            let t14;
            if ($[237] !== t12 || $[238] !== t13) {
                t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t12
                }, t13);
                $[237] = t12;
                $[238] = t13;
                $[239] = t14;
            } else t14 = $[239];
            t9 = t14;
            break bb0;
        }
        if (agentIcon === "vscode" && presenceArtworkEnabled) {
            const t10 = $b1fbd1cdbf216579$var$styles[avatarSize];
            const t11 = avatarSize === "xxsmall" && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing;
            let t12;
            if ($[240] !== t10 || $[241] !== t11) {
                t12 = (0, $w6R6I.cx)(t10, t11, $b1fbd1cdbf216579$var$styles.brandAgentTile);
                $[240] = t10;
                $[241] = t11;
                $[242] = t12;
            } else t12 = $[242];
            let t13;
            if ($[243] !== iconMarkSize) {
                t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$VisualStudioCodeIcon, {
                    label: "",
                    size: iconMarkSize
                });
                $[243] = iconMarkSize;
                $[244] = t13;
            } else t13 = $[244];
            let t14;
            if ($[245] !== t12 || $[246] !== t13) {
                t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t12
                }, t13);
                $[245] = t12;
                $[246] = t13;
                $[247] = t14;
            } else t14 = $[247];
            t9 = t14;
            break bb0;
        }
        if (agentIcon === "open-code" && presenceArtworkEnabled) {
            const t10 = $b1fbd1cdbf216579$var$styles[avatarSize];
            const t11 = avatarSize === "xxsmall" && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing;
            let t12;
            if ($[248] !== t10 || $[249] !== t11) {
                t12 = (0, $w6R6I.cx)(t10, t11, $b1fbd1cdbf216579$var$styles.brandAgentTile);
                $[248] = t10;
                $[249] = t11;
                $[250] = t12;
            } else t12 = $[250];
            let t13;
            if ($[251] !== iconMarkSize) {
                t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$OpenCodeIcon, {
                    label: "",
                    size: iconMarkSize
                });
                $[251] = iconMarkSize;
                $[252] = t13;
            } else t13 = $[252];
            let t14;
            if ($[253] !== t12 || $[254] !== t13) {
                t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t12
                }, t13);
                $[253] = t12;
                $[254] = t13;
                $[255] = t14;
            } else t14 = $[255];
            t9 = t14;
            break bb0;
        }
        if (agentIcon === "hermes" && presenceArtworkEnabled) {
            const t10 = $b1fbd1cdbf216579$var$styles[avatarSize];
            const t11 = avatarSize === "xxsmall" && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing;
            let t12;
            if ($[256] !== t10 || $[257] !== t11) {
                t12 = (0, $w6R6I.cx)(t10, t11, $b1fbd1cdbf216579$var$styles.brandAgentTile);
                $[256] = t10;
                $[257] = t11;
                $[258] = t12;
            } else t12 = $[258];
            let t13;
            if ($[259] !== iconMarkSize) {
                t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$HermesAgentIcon, {
                    label: "",
                    size: iconMarkSize
                });
                $[259] = iconMarkSize;
                $[260] = t13;
            } else t13 = $[260];
            let t14;
            if ($[261] !== t12 || $[262] !== t13) {
                t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t12
                }, t13);
                $[261] = t12;
                $[262] = t13;
                $[263] = t14;
            } else t14 = $[263];
            t9 = t14;
            break bb0;
        }
        if (agentIcon === "kiro" && presenceArtworkEnabled) {
            const t10 = $b1fbd1cdbf216579$var$styles[avatarSize];
            const t11 = avatarSize === "xxsmall" && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing;
            let t12;
            if ($[264] !== t10 || $[265] !== t11) {
                t12 = (0, $w6R6I.cx)(t10, t11, $b1fbd1cdbf216579$var$styles.brandAgentTile);
                $[264] = t10;
                $[265] = t11;
                $[266] = t12;
            } else t12 = $[266];
            let t13;
            if ($[267] !== iconMarkSize) {
                t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$KiroIcon, {
                    label: "",
                    size: iconMarkSize
                });
                $[267] = iconMarkSize;
                $[268] = t13;
            } else t13 = $[268];
            let t14;
            if ($[269] !== t12 || $[270] !== t13) {
                t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t12
                }, t13);
                $[269] = t12;
                $[270] = t13;
                $[271] = t14;
            } else t14 = $[271];
            t9 = t14;
            break bb0;
        }
        const hasDefaultAccountAvatarBorder = providedBorderColor === undefined && isDualAgentAvatarCardEnabled;
        let t10;
        if ($[272] !== avatarSize || $[273] !== avatarUrl || $[274] !== borderColor || $[275] !== hasDefaultAccountAvatarBorder || $[276] !== name) {
            t10 = isDualAgentAvatarCardEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
                appearance: "hexagon",
                src: avatarUrl,
                name: name,
                label: "",
                borderColor: borderColor ?? "var(--ds-surface, #FFFFFF)",
                size: avatarSize,
                UNSAFE_isUpdatedGeometry: (0, $9wGTI.fg)("platform-dst-avatar-updated-geometry")
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6gGPb.AgentAvatar), {
                size: avatarSize,
                name: name,
                label: "",
                imageUrl: avatarUrl,
                showBorder: borderColor === undefined && !hasDefaultAccountAvatarBorder,
                UNSAFE_useAdsAvatar: (0, $9wGTI.fg)("platform-dst-avatar-updated-geometry")
            });
            $[272] = avatarSize;
            $[273] = avatarUrl;
            $[274] = borderColor;
            $[275] = hasDefaultAccountAvatarBorder;
            $[276] = name;
            $[277] = t10;
        } else t10 = $[277];
        const accountAvatar = t10;
        if ((0, $9wGTI.fg)("platform-dst-avatar-updated-geometry")) {
            let t11;
            if ($[278] !== accountAvatar || $[279] !== avatarSize || $[280] !== hasInlineSpacing) {
                t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AgentAvatarContainer, {
                    avatarSize: avatarSize,
                    hasInlineSpacing: hasInlineSpacing
                }, accountAvatar);
                $[278] = accountAvatar;
                $[279] = avatarSize;
                $[280] = hasInlineSpacing;
                $[281] = t11;
            } else t11 = $[281];
            t9 = t11;
            break bb0;
        }
        let t11;
        if ($[282] !== accountAvatar || $[283] !== shouldFillProfileClickableFrame) {
            t11 = shouldFillProfileClickableFrame ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                testId: "profile-clickable-agent-avatar-frame",
                xcss: $b1fbd1cdbf216579$var$styles.profileClickableAccountAvatar
            }, accountAvatar) : accountAvatar;
            $[282] = accountAvatar;
            $[283] = shouldFillProfileClickableFrame;
            $[284] = t11;
        } else t11 = $[284];
        const sizedAccountAvatar = t11;
        if (hasDefaultAccountAvatarBorder) {
            const t12 = shouldFillProfileClickableFrame && $b1fbd1cdbf216579$var$styles.profileClickableAccountAvatarTile;
            let t13;
            if ($[285] !== t12) {
                t13 = (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles.accountAvatarTile, $b1fbd1cdbf216579$var$styles.accountAvatarSurface, t12);
                $[285] = t12;
                $[286] = t13;
            } else t13 = $[286];
            let t14;
            if ($[287] !== sizedAccountAvatar || $[288] !== t13) {
                t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t13
                }, sizedAccountAvatar);
                $[287] = sizedAccountAvatar;
                $[288] = t13;
                $[289] = t14;
            } else t14 = $[289];
            let t15;
            if ($[290] !== avatarSize || $[291] !== hasInlineSpacing || $[292] !== t14) {
                t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AgentAvatarContainer, {
                    avatarSize: avatarSize,
                    hasInlineSpacing: hasInlineSpacing
                }, t14);
                $[290] = avatarSize;
                $[291] = hasInlineSpacing;
                $[292] = t14;
                $[293] = t15;
            } else t15 = $[293];
            t9 = t15;
            break bb0;
        }
        let t12;
        if ($[294] !== borderColor || $[295] !== providedBorderColor || $[296] !== shouldFillProfileClickableFrame || $[297] !== sizedAccountAvatar) {
            t12 = borderColor === undefined ? sizedAccountAvatar : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles.accountAvatarTile, shouldFillProfileClickableFrame && $b1fbd1cdbf216579$var$styles.profileClickableAccountAvatarTile),
                style: {
                    backgroundColor: providedBorderColor
                }
            }, sizedAccountAvatar);
            $[294] = borderColor;
            $[295] = providedBorderColor;
            $[296] = shouldFillProfileClickableFrame;
            $[297] = sizedAccountAvatar;
            $[298] = t12;
        } else t12 = $[298];
        let t13;
        if ($[299] !== avatarSize || $[300] !== hasInlineSpacing || $[301] !== t12) {
            t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AgentAvatarContainer, {
                avatarSize: avatarSize,
                hasInlineSpacing: hasInlineSpacing
            }, t12);
            $[299] = avatarSize;
            $[300] = hasInlineSpacing;
            $[301] = t12;
            $[302] = t13;
        } else t13 = $[302];
        t9 = t13;
    }
    const avatar = t9;
    let t10;
    if ($[303] !== avatar || $[304] !== isOffsetInlineStart) {
        t10 = isOffsetInlineStart ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: "agent-avatar-offset",
            xcss: $b1fbd1cdbf216579$var$styles.avatarOffsetInlineStart
        }, avatar) : avatar;
        $[303] = avatar;
        $[304] = isOffsetInlineStart;
        $[305] = t10;
    } else t10 = $[305];
    return t10;
} : ({ name: name, agentIcon: agentIcon, borderColor: providedBorderColor, avatarUrl: avatarUrl, avatarSize: avatarSize = 'small', markSize: markSize, isOffsetInlineStart: isOffsetInlineStart = false, hasInlineSpacing: hasInlineSpacing = true, fillProfileClickableFrame: fillProfileClickableFrame = false, colorMode: providedColorMode, usePresenceArtwork: usePresenceArtwork = false, presenceTileFill: presenceTileFill, presenceOutline: presenceOutline })=>{
    let isDualAgentAvatarCardEnabled = false;
    if ((0, $6mKj3.expVal)('dual_agent_avatar_card', 'isEnabled', false)) isDualAgentAvatarCardEnabled = true;
    const observedColorMode = (0, $3EM6l.useAgentAvatarColorMode)(); // Callers that resolve the color mode themselves, such as the presence face pile, keep priority.
    const colorMode = providedColorMode ?? (isDualAgentAvatarCardEnabled ? observedColorMode : 'light');
    const borderColor = providedBorderColor === undefined && isDualAgentAvatarCardEnabled ? "var(--ds-surface, #FFFFFF)" : providedBorderColor; // Memoized because it becomes a context value, which would otherwise re-render every tile.
    const resolvedPresenceOutline = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>presenceOutline ?? (isDualAgentAvatarCardEnabled ? (0, $jeQ2h.resolvePresenceOutline)({
            tone: (0, $dnhRJ.getAgentBrandTone)(agentIcon),
            colorMode: colorMode
        }) : undefined), [
        presenceOutline,
        isDualAgentAvatarCardEnabled,
        agentIcon,
        colorMode
    ]);
    const presenceArtworkEnabled = usePresenceArtwork || isDualAgentAvatarCardEnabled;
    const iconSize = {
        xxsmall: 16,
        small: 24,
        medium: 32
    }[avatarSize];
    const iconMarkSize = markSize ?? iconSize;
    const shouldFillProfileClickableFrame = fillProfileClickableFrame && isDualAgentAvatarCardEnabled;
    const presenceTile = (icon)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AgentAvatarContainer, {
            avatarSize: avatarSize,
            hasInlineSpacing: hasInlineSpacing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $b1fbd1cdbf216579$var$styles.presenceGlyphTile,
            testId: "presence-brand-tile"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7gxpq.PresenceHexOutlineContext).Provider, {
            value: resolvedPresenceOutline
        }, icon)));
    };
    const avatar = (()=>{
        if (agentIcon === 'ai-agent' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ExternalPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: providedBorderColor,
            useBorderlessArtwork: !usePresenceArtwork || (0, $6mKj3.expVal)('dual_agent_avatar_card', 'isEnabled', false)
        }));
        if (agentIcon === 'ai-agent') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$UnidentifiedAgentAvatar, {
            avatarSize: avatarSize,
            hasInlineSpacing: hasInlineSpacing
        });
        if (agentIcon === 'rovo' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$RovoPresenceIcon, {
            label: "",
            size: iconSize,
            colorMode: colorMode,
            borderColor: borderColor,
            fill: presenceTileFill
        }));
        if (agentIcon === 'rovo') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AgentAvatarContainer, {
            avatarSize: avatarSize,
            hasInlineSpacing: hasInlineSpacing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $t45G9.RovoIcon), {
            label: "",
            size: iconMarkSize
        }));
        if (agentIcon === 'cursor' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$CursorPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'cursor') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AgentAvatarContainer, {
            avatarSize: avatarSize,
            hasInlineSpacing: hasInlineSpacing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$CursorIcon, {
            label: "",
            size: iconMarkSize
        }));
        if (agentIcon === 'canva' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$CanvaPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'claude' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ClaudePresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'claude') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles[avatarSize], avatarSize === 'xxsmall' && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ClaudeIcon, {
            label: "",
            size: iconMarkSize
        }));
        if (agentIcon === 'chatgpt' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ChatGptPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'antigravity' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AntigravityPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor,
            fill: presenceTileFill
        }));
        if (agentIcon === 'dia' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$DiaPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'gemini' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$GeminiPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor,
            fill: presenceTileFill
        }));
        if (agentIcon === 'grok' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$GrokPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'hermes' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$HermesAgentPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor,
            fill: presenceTileFill
        }));
        if (agentIcon === 'kiro' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$KiroPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'microsoft-copilot' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$MicrosoftCopilotPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor,
            fill: presenceTileFill
        }));
        if (agentIcon === 'vscode' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$VisualStudioCodePresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor,
            fill: presenceTileFill
        }));
        if (agentIcon === 'chatgpt') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles[avatarSize], avatarSize === 'xxsmall' && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ChatGptIcon, {
            label: "",
            size: iconMarkSize
        }));
        if (agentIcon === 'figma' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$FigmaPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'lovable' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$LovablePresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'replit' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ReplitPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'dia') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles[avatarSize], avatarSize === 'xxsmall' && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing, $b1fbd1cdbf216579$var$styles.brandAgentTile)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$DiaIcon, {
            label: "",
            size: iconMarkSize
        }));
        if (agentIcon === 'codex' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$CodexPresenceIcon, {
            label: "",
            size: iconSize,
            colorMode: colorMode,
            borderColor: borderColor
        }));
        if (agentIcon === 'first-party' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$FirstPartyAgentPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'amplitude' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AmplitudePresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'cortex' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$CortexPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'databricks' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$DatabricksPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'github-copilot' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$GitHubCopilotPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'manus' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ManusPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'openai' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$OpenAiPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'slack' && presenceArtworkEnabled) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$SlackPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'codex') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles[avatarSize], avatarSize === 'xxsmall' && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing, $b1fbd1cdbf216579$var$styles.brandAgentTile)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$CodexIcon, {
            label: "",
            size: iconMarkSize
        }));
        if (agentIcon === 'grok' && presenceArtworkEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles[avatarSize], avatarSize === 'xxsmall' && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing, $b1fbd1cdbf216579$var$styles.brandAgentTile)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$GrokIcon, {
            label: "",
            size: iconMarkSize
        }));
        if (agentIcon === 'github-copilot' && presenceArtworkEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles[avatarSize], avatarSize === 'xxsmall' && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing, $b1fbd1cdbf216579$var$styles.brandAgentTile)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$GitHubCopilotIcon, {
            label: "",
            size: iconMarkSize
        }));
        if (agentIcon === 'vscode' && presenceArtworkEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles[avatarSize], avatarSize === 'xxsmall' && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing, $b1fbd1cdbf216579$var$styles.brandAgentTile)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$VisualStudioCodeIcon, {
            label: "",
            size: iconMarkSize
        }));
        if (agentIcon === 'open-code' && presenceArtworkEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles[avatarSize], avatarSize === 'xxsmall' && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing, $b1fbd1cdbf216579$var$styles.brandAgentTile)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$OpenCodeIcon, {
            label: "",
            size: iconMarkSize
        }));
        if (agentIcon === 'hermes' && presenceArtworkEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles[avatarSize], avatarSize === 'xxsmall' && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing, $b1fbd1cdbf216579$var$styles.brandAgentTile)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$HermesAgentIcon, {
            label: "",
            size: iconMarkSize
        }));
        if (agentIcon === 'kiro' && presenceArtworkEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles[avatarSize], avatarSize === 'xxsmall' && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing, $b1fbd1cdbf216579$var$styles.brandAgentTile)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$KiroIcon, {
            label: "",
            size: iconMarkSize
        }));
        const hasDefaultAccountAvatarBorder = providedBorderColor === undefined && isDualAgentAvatarCardEnabled;
        const accountAvatar = isDualAgentAvatarCardEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
            appearance: "hexagon",
            src: avatarUrl,
            name: name,
            label: "",
            borderColor: borderColor ?? "var(--ds-surface, #FFFFFF)",
            size: avatarSize,
            UNSAFE_isUpdatedGeometry: (0, $9wGTI.fg)('platform-dst-avatar-updated-geometry')
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6gGPb.AgentAvatar), {
            size: avatarSize,
            name: name,
            label: "",
            imageUrl: avatarUrl,
            showBorder: borderColor === undefined && !hasDefaultAccountAvatarBorder,
            UNSAFE_useAdsAvatar: (0, $9wGTI.fg)('platform-dst-avatar-updated-geometry')
        });
        if ((0, $9wGTI.fg)('platform-dst-avatar-updated-geometry')) // ADS owns the hexagon clip, border, and alignment, so the local clip-path tile cut to the
        // old geometry would shave its corners and the scale corrections would double up.
        // The enlarged hexagon also overflows its nominal box, 25.76px tall at `small`, not 24px.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AgentAvatarContainer, {
            avatarSize: avatarSize,
            hasInlineSpacing: hasInlineSpacing
        }, accountAvatar);
        const sizedAccountAvatar = shouldFillProfileClickableFrame ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: "profile-clickable-agent-avatar-frame",
            xcss: $b1fbd1cdbf216579$var$styles.profileClickableAccountAvatar
        }, accountAvatar) : accountAvatar;
        if (hasDefaultAccountAvatarBorder) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AgentAvatarContainer, {
            avatarSize: avatarSize,
            hasInlineSpacing: hasInlineSpacing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles.accountAvatarTile, $b1fbd1cdbf216579$var$styles.accountAvatarSurface, shouldFillProfileClickableFrame && $b1fbd1cdbf216579$var$styles.profileClickableAccountAvatarTile)
        }, sizedAccountAvatar));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AgentAvatarContainer, {
            avatarSize: avatarSize,
            hasInlineSpacing: hasInlineSpacing
        }, borderColor === undefined ? sizedAccountAvatar : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles.accountAvatarTile, shouldFillProfileClickableFrame && $b1fbd1cdbf216579$var$styles.profileClickableAccountAvatarTile),
            style: {
                backgroundColor: providedBorderColor
            }
        }, sizedAccountAvatar));
    })();
    return isOffsetInlineStart ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "agent-avatar-offset",
        xcss: $b1fbd1cdbf216579$var$styles.avatarOffsetInlineStart
    }, avatar) : avatar;
};
module.exports["AgentRowAvatar"] = $b1fbd1cdbf216579$export$951877a280bbd2e;

});

parcelRegister("t45G9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $af798cdb90e165d5$export$e23ae35269442b4f = ({ label: label = '', size: size = 16 })=>{
    const clipId = (0, $cozmU.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: label ? 'img' : 'presentation',
        "aria-label": label || undefined,
        "aria-hidden": label ? undefined : true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: `url(#${clipId})`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.0615 20.8951L5.47045 26.4325L3.56007 25.3303C2.43818 24.6835 1.7439 23.4836 1.7439 22.1908V9.82129C1.7439 8.52343 2.4341 7.32872 3.55933 6.68226L11.6173 2.0332C11.5995 2.08338 11.5824 2.13389 11.5662 2.18472C11.4171 2.6476 11.338 3.13666 11.338 3.63654V16.0061C11.338 17.7052 12.2431 19.2725 13.7181 20.1203L15.0615 20.8951Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.0615 20.8945L5.47046 26.4319L14.2797 31.5144C15.3815 32.1496 16.7374 32.1609 17.8482 31.5482C17.8683 31.5326 17.8898 31.5182 17.9124 31.5051C18.704 31.0488 19.2828 30.317 19.555 29.4716C19.6657 29.1222 19.7243 28.7529 19.7243 28.3749V23.5835L15.0615 20.8945Z",
        fill: "#6A9A23"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M28.6364 6.66986L26.5817 5.48438L16.9906 11.0218L18.479 11.8801C19.9542 12.7278 20.8587 14.2949 20.8587 15.9942V28.3637C20.8587 28.8643 20.7794 29.354 20.6298 29.8174C20.6138 29.8676 20.597 29.9175 20.5793 29.967L28.6373 25.318C29.7626 24.6715 30.4528 23.4768 30.4528 22.1789V9.80941C30.4528 8.51667 29.7583 7.31666 28.6364 6.66986Z",
        fill: "#AF59E1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.9875 11.0216L12.4691 8.41593V3.62449C12.4691 3.24694 12.5275 2.87812 12.6381 2.52898C12.9098 1.68399 13.4877 0.95247 14.2784 0.495822L14.2808 0.494438C14.3035 0.481361 14.3251 0.466857 14.3452 0.451262C15.456 -0.161474 16.8119 -0.150218 17.9137 0.485033L26.5786 5.48421L16.9875 11.0216Z",
        fill: "#FCA700"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: clipId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "32",
        height: "32",
        fill: "white"
    }))));
};
module.exports["RovoIcon"] = $af798cdb90e165d5$export$e23ae35269442b4f;

});

parcelRegister("7gxpq", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $06f1794fd21acdfd$export$642f401a307b8452 = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $06f1794fd21acdfd$export$685cad5d7f4d1a8c = (size)=>{
    const outline = (0, $cozmU.useContext)($06f1794fd21acdfd$export$642f401a307b8452);
    return outline?.svgHeight ?? size;
};
const $06f1794fd21acdfd$export$82f0d998d3955f1f = ({ d: d, fill: fill, stroke: stroke, strokeWidth: strokeWidth, viewBox: viewBox, size: size, insetStroke: insetStroke = false })=>{
    const outline = (0, $cozmU.useContext)($06f1794fd21acdfd$export$642f401a307b8452);
    const clipPathId = `presence-hex-clip-${(0, $cozmU.useId)()}`;
    if (!outline && insetStroke && stroke && strokeWidth) {
        const insetViewBoxWidth = Number(viewBox.trim().split(/\s+/)[2]);
        const cssPixelScale = Number.isFinite(insetViewBoxWidth) && insetViewBoxWidth > 0 ? insetViewBoxWidth / size : 1;
        // Clipping a doubled stroke to the hexagon leaves only its inner half visible.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: clipPathId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: d
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: d,
            fill: fill
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            "data-presence-layer": "inset-stroke",
            d: d,
            fill: "none",
            stroke: stroke,
            strokeWidth: strokeWidth * cssPixelScale * 2,
            clipPath: `url(#${clipPathId})`
        }));
    }
    if (!outline) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: d,
        fill: fill,
        stroke: stroke,
        strokeWidth: strokeWidth
    });
    const viewBoxWidth = Number(viewBox.trim().split(/\s+/)[2]);
    if (!Number.isFinite(viewBoxWidth) || viewBoxWidth <= 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: d,
        fill: fill,
        stroke: stroke,
        strokeWidth: strokeWidth
    });
    const toSvgStrokeWidth = (cssPixels)=>cssPixels * viewBoxWidth / size;
    if (outline.width <= 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: d,
        fill: fill,
        stroke: stroke,
        strokeWidth: strokeWidth
    }), outline.centerStrokeColor && outline.centerStrokeWidth ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        "data-presence-layer": "center-stroke",
        d: d,
        fill: "none",
        stroke: outline.centerStrokeColor,
        strokeWidth: toSvgStrokeWidth(outline.centerStrokeWidth)
    }) : null);
    const centerStrokeWidth = outline.centerStrokeColor ? outline.centerStrokeWidth ?? 0 : 0;
    // Half the backing stroke is covered by the fill; the center stroke covers another half-width.
    const backingStrokeWidth = toSvgStrokeWidth(outline.width * 2 + centerStrokeWidth);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        "data-presence-layer": "outline",
        d: d,
        fill: stroke,
        stroke: stroke,
        strokeWidth: backingStrokeWidth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        "data-presence-layer": "fill",
        d: d,
        fill: fill
    }), outline.centerStrokeColor && outline.centerStrokeWidth ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        "data-presence-layer": "center-stroke",
        d: d,
        fill: "none",
        stroke: outline.centerStrokeColor,
        strokeWidth: toSvgStrokeWidth(outline.centerStrokeWidth)
    }) : null);
};
module.exports["PresenceHexOutlineContext"] = $06f1794fd21acdfd$export$642f401a307b8452;
module.exports["usePresenceSvgHeight"] = $06f1794fd21acdfd$export$685cad5d7f4d1a8c;
module.exports["PresenceHexArtwork"] = $06f1794fd21acdfd$export$82f0d998d3955f1f;

});

parcelRegister("dnhRJ", function(module, exports) {
const $b850dfcf5a08d5ec$var$AGENT_BRAND_TONE = {
    chatgpt: 'dark',
    claude: 'neutral',
    codex: 'light',
    cursor: 'dark',
    figma: 'dark',
    lovable: 'dark',
    replit: 'dark',
    rovo: 'adaptive'
};
const $b850dfcf5a08d5ec$export$20ae0a8376081883 = (agentIcon)=>(agentIcon && $b850dfcf5a08d5ec$var$AGENT_BRAND_TONE[agentIcon]) ?? 'neutral';
module.exports["getAgentBrandTone"] = $b850dfcf5a08d5ec$export$20ae0a8376081883;

});

parcelRegister("jeQ2h", function(module, exports) {

var $IQ4Dz = parcelRequire("IQ4Dz");


var $dnhRJ = parcelRequire("dnhRJ");

const $a20a024b40817505$var$FINAL_PRESENCE_HEX_GEOMETRY = {
    24: {
        viewBox: '0 1.3358 24 24',
        hex: 'M22.0557 5.35887L14.06 0.568665C12.7922 -0.190923 11.2087 -0.189455 9.94226 0.572483L1.93793 5.38806C0.735427 6.11151 0 7.41223 0 8.81558V17.8788C0 19.2848 0.738177 20.5876 1.94429 21.3101L9.94429 26.1029C11.2099 26.8611 12.7901 26.8611 14.0557 26.1029L22.0557 21.3101C23.2618 20.5876 24 19.2848 24 17.8788V8.7902C24 7.38421 23.2618 6.08145 22.0557 5.35887Z',
        markOffset: {
            x: -2,
            y: -2.0098
        }
    },
    32: {
        viewBox: '0 0.7639 32 32',
        hex: 'M29.4485 6.81587L18.4537 0.64055C16.9302 -0.215083 15.0707 -0.213413 13.5488 0.644954L2.54367 6.85208C0.972102 7.73848 0 9.40283 0 11.2071V22.3496C0 24.1571 0.975536 25.8239 2.55149 26.709L13.5515 32.8872C15.0721 33.7413 16.9279 33.7413 18.4485 32.8872L29.4485 26.709C31.0245 25.8239 32 24.1571 32 22.3496V11.1753C32 9.3678 31.0245 7.70101 29.4485 6.81587Z',
        markOffset: {
            x: -1.0016,
            y: -1.4473
        }
    }
};
const $a20a024b40817505$var$getFinalPresenceSize = (size)=>{
    if (size > 16 && size <= 24) return 24;
    if (size > 24 && size <= 32) return 32;
    return undefined;
};
const $a20a024b40817505$export$86d5d0060359870e = (size)=>$a20a024b40817505$var$getFinalPresenceSize(size) !== undefined;
const $a20a024b40817505$export$7f633a98e1823142 = (size)=>{
    const finalSize = $a20a024b40817505$var$getFinalPresenceSize(size);
    return finalSize === undefined ? undefined : $a20a024b40817505$var$FINAL_PRESENCE_HEX_GEOMETRY[finalSize];
};
const $a20a024b40817505$export$28ca8990d5adc773 = (art, size)=>{
    const geometry = $a20a024b40817505$export$7f633a98e1823142(size);
    if (!geometry) return art;
    return {
        ...art,
        viewBox: geometry.viewBox,
        hex: geometry.hex,
        ...art.mark ? {
            mark: {
                ...art.mark,
                x: art.mark.x + geometry.markOffset.x,
                y: art.mark.y + geometry.markOffset.y
            }
        } : {}
    };
};
const $a20a024b40817505$export$6909a3e7b7de66da = ()=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    return colorMode === 'dark' ? 'dark' : 'light';
};
/**
 * With the inset border on, an unset or `transparent` border asks for the tile's own border rather
 * than removing it, so callers that suppress the card-colored ring still get the contrast border.
 */ const $a20a024b40817505$var$getRequestedBorder = (borderColor)=>borderColor === 'transparent' ? undefined : borderColor;
const $a20a024b40817505$export$196946f0e26e59cd = (borderColor)=>$a20a024b40817505$var$getRequestedBorder(borderColor) === undefined;
const $a20a024b40817505$export$7d41bd8c4cb42194 = ({ fill: fill, borderIn: borderIn, colorMode: colorMode = 'light', borderColor: borderColor, defaultStrokeWidth: defaultStrokeWidth })=>{
    const tileFill = fill === 'surface' ? "var(--ds-surface, #FFFFFF)" : undefined;
    const requestedBorder = $a20a024b40817505$var$getRequestedBorder(borderColor);
    if (requestedBorder !== undefined) return {
        fill: tileFill,
        stroke: requestedBorder,
        strokeWidth: defaultStrokeWidth
    };
    if (borderIn === 'dark' && colorMode !== 'dark') return {
        fill: tileFill,
        stroke: 'transparent',
        strokeWidth: defaultStrokeWidth
    };
    return {
        fill: tileFill,
        stroke: "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)",
        strokeWidth: 1,
        insetStroke: true
    };
};
/**
 * A tile only loses contrast when its own tone matches the surface behind it, so the center stroke
 * is drawn on light tiles in light mode and dark tiles in dark mode, and never on both. `neutral`
 * tiles hold against either surface, and `adaptive` tiles invert to follow the surface, so neither
 * needs one.
 */ const $a20a024b40817505$var$needsCenterStroke = (tone, colorMode)=>tone === colorMode;
const $a20a024b40817505$export$52f6e8c3279899c3 = ({ tone: tone, colorMode: colorMode })=>({
        width: 0,
        centerStrokeColor: $a20a024b40817505$var$needsCenterStroke(tone, colorMode) ? "var(--ds-background-accent-gray-subtler, #DDDEE1)" : undefined,
        centerStrokeWidth: 1
    });
const $a20a024b40817505$export$9e99d98c0acd42bd = ({ size: size, colorMode: colorMode, borderColor: borderColor, defaultBorderColor: defaultBorderColor, defaultStrokeWidth: defaultStrokeWidth })=>{
    if (!$a20a024b40817505$export$86d5d0060359870e(size)) return {
        fill: 'white',
        stroke: borderColor ?? defaultBorderColor,
        strokeWidth: defaultStrokeWidth
    };
    const stroke = borderColor ?? (colorMode === 'light' ? "var(--ds-background-accent-gray-subtler, #DDDEE1)" : undefined);
    return {
        fill: 'white',
        stroke: stroke,
        strokeWidth: stroke === undefined ? undefined : 1
    };
};
module.exports["isFinalPresenceSize"] = $a20a024b40817505$export$86d5d0060359870e;
module.exports["getFinalPresenceHexGeometry"] = $a20a024b40817505$export$7f633a98e1823142;
module.exports["applyFinalPresenceHexGeometry"] = $a20a024b40817505$export$28ca8990d5adc773;
module.exports["usePresenceColorMode"] = $a20a024b40817505$export$6909a3e7b7de66da;
module.exports["isBorderUnset"] = $a20a024b40817505$export$196946f0e26e59cd;
module.exports["getInsetBorderChrome"] = $a20a024b40817505$export$7d41bd8c4cb42194;
module.exports["resolvePresenceOutline"] = $a20a024b40817505$export$52f6e8c3279899c3;
module.exports["getWhiteFillPresenceChrome"] = $a20a024b40817505$export$9e99d98c0acd42bd;

});

parcelRegister("3EM6l", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $IQ4Dz = parcelRequire("IQ4Dz");

const $4dbee925501a87b6$export$97ecd45ebbe7353 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    return colorMode === "dark" ? "dark" : "light";
} : ()=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    return colorMode === 'dark' ? 'dark' : 'light';
};
module.exports["useAgentAvatarColorMode"] = $4dbee925501a87b6$export$97ecd45ebbe7353;

});

parcelRegister("1ryYR", function(module, exports) {

let $10d3727709e09775$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $10d3727709e09775$var$load("3vVgx").then(()=>parcelRequire('hWomQ'));

});

parcelRegister("dIIWs", function(module, exports) {

let $9fd23ef0d8d8fabf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9fd23ef0d8d8fabf$var$load("AvocN").then(()=>parcelRequire('gU8L0'));

});

parcelRegister("79Gwb", function(module, exports) {

let $535a5adfa9fd7614$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $535a5adfa9fd7614$var$load("fsX9p").then(()=>parcelRequire('4WDJq'));

});

parcelRegister("h9Vld", function(module, exports) {

let $c7dfc1b5d43acdb2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c7dfc1b5d43acdb2$var$load("7hP3t").then(()=>parcelRequire('gAlam'));

});

parcelRegister("i13et", function(module, exports) {

let $d1dad3e0ddcd3c45$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d1dad3e0ddcd3c45$var$load("3vth9").then(()=>parcelRequire('hOYpb'));

});

parcelRegister("kmCSD", function(module, exports) {

let $ed34057fa7fb5bac$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ed34057fa7fb5bac$var$load("4xQlr").then(()=>parcelRequire('4RcHH'));

});

parcelRegister("5werP", function(module, exports) {

let $404b25f05781b9d6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $404b25f05781b9d6$var$load("2gRg3").then(()=>parcelRequire('dBAX8'));

});

parcelRegister("2o4Bs", function(module, exports) {

let $1bd164c40e5cf943$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1bd164c40e5cf943$var$load("3Qa4M").then(()=>parcelRequire('g68r6'));

});

parcelRegister("2IHZs", function(module, exports) {

let $1fb1d05b3852dafc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1fb1d05b3852dafc$var$load("9BDv8").then(()=>parcelRequire('aFLeE'));

});

parcelRegister("lcZdN", function(module, exports) {

let $f70a35417dbd5fdd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f70a35417dbd5fdd$var$load("5zlcp").then(()=>parcelRequire('l0hLa'));

});

parcelRegister("k5k9O", function(module, exports) {

let $e9f3e91a74f68edb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e9f3e91a74f68edb$var$load("CwBn2").then(()=>parcelRequire('6g7vS'));

});

parcelRegister("1d3Yv", function(module, exports) {

let $0e1a16b354c55459$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0e1a16b354c55459$var$load("2XGiK").then(()=>parcelRequire('3WEjC'));

});

parcelRegister("1G2db", function(module, exports) {

let $138b6dde00315047$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $138b6dde00315047$var$load("iL0Td").then(()=>parcelRequire('a7IdQ'));

});

parcelRegister("c0CFL", function(module, exports) {

let $8be37bb2ddd9e09d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8be37bb2ddd9e09d$var$load("inqXM").then(()=>parcelRequire('2bUT0'));

});

parcelRegister("j1q6z", function(module, exports) {

let $dd925c37417b1dff$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dd925c37417b1dff$var$load("7ASbe").then(()=>parcelRequire('6Sqz8'));

});

parcelRegister("60XCe", function(module, exports) {

let $4610fc9d09fd6c9c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4610fc9d09fd6c9c$var$load("3RFem").then(()=>parcelRequire('jATtc'));

});

parcelRegister("56hyP", function(module, exports) {

let $3b6b2278ed68af19$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3b6b2278ed68af19$var$load("hhlGo").then(()=>parcelRequire('gwIMx'));

});

parcelRegister("8xiCz", function(module, exports) {

let $636fd9904357db9b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $636fd9904357db9b$var$load("ekDMC").then(()=>parcelRequire('g8WKc'));

});

parcelRegister("kEfEw", function(module, exports) {

let $f083af58e38f0f83$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f083af58e38f0f83$var$load("1qGCp").then(()=>parcelRequire('cs3U4'));

});

parcelRegister("752sB", function(module, exports) {

let $527ae89db7896101$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $527ae89db7896101$var$load("3C2EI").then(()=>parcelRequire('f6xwk'));

});

parcelRegister("6Q9J9", function(module, exports) {

let $4faf250ce6f1f5bf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4faf250ce6f1f5bf$var$load("3aCW7").then(()=>parcelRequire('tE3eQ'));

});

parcelRegister("dWUzC", function(module, exports) {

let $a27c9371f1259619$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a27c9371f1259619$var$load("54lzf").then(()=>parcelRequire('aXLjr'));

});

parcelRegister("055n4", function(module, exports) {

let $00f4a2583b1344da$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $00f4a2583b1344da$var$load("h5fE5").then(()=>parcelRequire('cJTh1'));

});

parcelRegister("j5D4h", function(module, exports) {

let $de5cca067e6b976c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $de5cca067e6b976c$var$load("1YAXz").then(()=>parcelRequire('7TiP7'));

});

parcelRegister("1nWYx", function(module, exports) {

let $1025afb1f092df8e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1025afb1f092df8e$var$load("lgi8F").then(()=>parcelRequire('1DEmL'));

});

parcelRegister("4LPyf", function(module, exports) {

let $37938a430603b2e0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $37938a430603b2e0$var$load("6nbpE").then(()=>parcelRequire('bAfpV'));

});

parcelRegister("eBS61", function(module, exports) {

let $aa2e7bc734eccab8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $aa2e7bc734eccab8$var$load("hebRT").then(()=>parcelRequire('62lYN'));

});

parcelRegister("5DQMY", function(module, exports) {

let $41b98b0cdcb07512$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $41b98b0cdcb07512$var$load("lNk5S").then(()=>parcelRequire('dBtm2'));

});

parcelRegister("dhvgg", function(module, exports) {

let $9ab51cbf6b3410a0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9ab51cbf6b3410a0$var$load("gVYrv").then(()=>parcelRequire('cwTyL'));

});

parcelRegister("asP6p", function(module, exports) {

let $79e428c82fd0981c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $79e428c82fd0981c$var$load("fkpjl").then(()=>parcelRequire('khv0p'));

});

parcelRegister("1r0Kk", function(module, exports) {

let $10b8e44356859c8f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $10b8e44356859c8f$var$load("1qkVW").then(()=>parcelRequire('dA3QK'));

});

parcelRegister("dCjmm", function(module, exports) {

let $9e9dd765ad3fefb5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9e9dd765ad3fefb5$var$load("qus56").then(()=>parcelRequire('Hqfh4'));

});

parcelRegister("hNuBp", function(module, exports) {

let $cf4ec045be666d04$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cf4ec045be666d04$var$load("8JIW0").then(()=>parcelRequire('4xm9S'));

});

parcelRegister("jURii", function(module, exports) {

let $e7fc96615f769463$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e7fc96615f769463$var$load("7LgwE").then(()=>parcelRequire('23Zgt'));

});

parcelRegister("mPmb7", function(module, exports) {

let $0449e49004194b13$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0449e49004194b13$var$load("6mdJi").then(()=>parcelRequire('9JUQP'));

});

parcelRegister("e6Wll", function(module, exports) {

let $a45ee200c8c723c8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a45ee200c8c723c8$var$load("8vPRr").then(()=>parcelRequire('hxTG4'));

});

parcelRegister("96KjE", function(module, exports) {

let $6a1899f4cf720fb9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6a1899f4cf720fb9$var$load("eVXM2").then(()=>parcelRequire('bO7mD'));

});

parcelRegister("bcPDX", function(module, exports) {

var $a4kze = parcelRequire("a4kze");


var $iyJql = parcelRequire("iyJql");

const $51d3d2c94479c1d3$var$FALLBACK_KEY_PREFIX = '__fallback__:';
const $51d3d2c94479c1d3$export$4fcfd4291fd95196 = `${$51d3d2c94479c1d3$var$FALLBACK_KEY_PREFIX}rovo_chat`;
const $51d3d2c94479c1d3$export$e3b8290e8c3dc86b = `${$51d3d2c94479c1d3$var$FALLBACK_KEY_PREFIX}unknown`;
const $51d3d2c94479c1d3$var$ROVO_FALLBACK_DISPLAY_NAME = 'Rovo';
const $51d3d2c94479c1d3$export$1f92ae96899118d1 = ({ accountId: accountId, agentIcon: agentIcon, groupKey: groupKey, displayName: displayName })=>{
    const isAriAccountId = Boolean(accountId?.startsWith('ari:'));
    if (!isAriAccountId && !(0, $iyJql.toUsableIdentityAccountId)(accountId)) return false;
    if (agentIcon) return false;
    if (groupKey && (groupKey === $51d3d2c94479c1d3$export$e3b8290e8c3dc86b || groupKey === $51d3d2c94479c1d3$export$4fcfd4291fd95196)) return false;
    if (displayName === $51d3d2c94479c1d3$var$ROVO_FALLBACK_DISPLAY_NAME) return false;
    const brand = displayName ? (0, $a4kze.getAgentBrand)(displayName) : undefined;
    if (brand && brand.agentIcon !== 'rovo') return false;
    return true;
};
module.exports["isClickableAgentIdentity"] = $51d3d2c94479c1d3$export$1f92ae96899118d1;

});

parcelRegister("a4kze", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $d4yCt = parcelRequire("d4yCt");

const $6b1a38d2e8ef626f$export$75658d737923c3d1 = (displayName)=>(0, $d4yCt.getAgentBrand)(displayName, {
        includePresenceBrands: (0, $6mKj3.expVal)('dual_agent_avatar_card', 'isEnabled', false)
    });
module.exports["getAgentBrand"] = $6b1a38d2e8ef626f$export$75658d737923c3d1;

});

parcelRegister("d4yCt", function(module, exports) {
const $adef0f6cc11fa8bb$var$AGENT_BRANDS = [
    {
        name: 'Claude Code',
        agentIcon: 'claude'
    },
    {
        name: 'Claude',
        agentIcon: 'claude'
    },
    {
        name: 'Codex',
        agentIcon: 'codex'
    },
    {
        name: 'Rovo',
        agentIcon: 'rovo'
    },
    {
        name: 'Cursor',
        agentIcon: 'cursor'
    },
    {
        name: 'ChatGPT',
        agentIcon: 'chatgpt'
    },
    {
        name: 'Dia',
        agentIcon: 'dia'
    }
];
const $adef0f6cc11fa8bb$var$PRESENCE_AGENT_BRANDS = [
    {
        name: '1P',
        agentIcon: 'first-party'
    },
    {
        name: '1P Agent',
        agentIcon: 'first-party'
    },
    {
        name: 'Amplitude',
        agentIcon: 'amplitude'
    },
    {
        name: 'Antigravity',
        agentIcon: 'antigravity'
    },
    {
        name: 'Canva',
        agentIcon: 'canva'
    },
    {
        name: 'Cortex',
        agentIcon: 'cortex'
    },
    {
        name: 'Databricks',
        agentIcon: 'databricks'
    },
    {
        name: 'Figma',
        agentIcon: 'figma'
    },
    {
        name: 'Gemini',
        agentIcon: 'gemini'
    },
    {
        name: 'GitHub Copilot',
        agentIcon: 'github-copilot'
    },
    {
        name: 'Grok',
        agentIcon: 'grok'
    },
    {
        name: 'Hermes Agent',
        agentIcon: 'hermes'
    },
    {
        name: 'Kiro',
        agentIcon: 'kiro'
    },
    {
        name: 'Lovable',
        agentIcon: 'lovable'
    },
    {
        name: 'Manus',
        agentIcon: 'manus'
    },
    {
        name: 'Microsoft Copilot',
        agentIcon: 'microsoft-copilot'
    },
    {
        name: 'OpenAI',
        agentIcon: 'openai'
    },
    {
        name: 'Replit',
        agentIcon: 'replit'
    },
    {
        name: 'Slack',
        agentIcon: 'slack'
    },
    {
        name: 'Visual Studio Code',
        agentIcon: 'vscode'
    },
    {
        name: 'VS Code',
        agentIcon: 'vscode'
    },
    // Deprecated but kept for legacy purposes — some backends still emit these older
    // "<Brand> Agent" account names for Figma, Lovable, and Replit.
    {
        name: 'Figma Agent',
        agentIcon: 'figma'
    },
    {
        name: 'Lovable Agent',
        agentIcon: 'lovable'
    },
    {
        name: 'Replit Agent',
        agentIcon: 'replit'
    }
];
const $adef0f6cc11fa8bb$export$75658d737923c3d1 = (displayName, { includePresenceBrands: includePresenceBrands = false } = {})=>{
    const matches = ({ name: name })=>displayName === name || displayName.startsWith(`${name} (`);
    const brand = $adef0f6cc11fa8bb$var$AGENT_BRANDS.find(matches);
    if (brand) return brand;
    const presenceBrand = $adef0f6cc11fa8bb$var$PRESENCE_AGENT_BRANDS.find(matches);
    if (presenceBrand && includePresenceBrands) return presenceBrand;
    return undefined;
};
module.exports["getAgentBrand"] = $adef0f6cc11fa8bb$export$75658d737923c3d1;

});

parcelRegister("iyJql", function(module, exports) {
const $730db11406f82e55$var$ANONYMOUS = 'Anonymous';
const $730db11406f82e55$var$UNIDENTIFIED = 'unidentified';
const $730db11406f82e55$var$FALLBACK_KEY_PREFIX = '__fallback__:';
const $730db11406f82e55$export$e66103ae8a5b999c = (value)=>{
    if (!value) return undefined;
    if (value === $730db11406f82e55$var$ANONYMOUS || value === $730db11406f82e55$var$UNIDENTIFIED) return undefined;
    if (value.startsWith('ari:') || value.startsWith($730db11406f82e55$var$FALLBACK_KEY_PREFIX)) return undefined;
    return value;
};
module.exports["toUsableIdentityAccountId"] = $730db11406f82e55$export$e66103ae8a5b999c;

});

parcelRegister("393Hh", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7akNQ = parcelRequire("7akNQ");


var $a6t12 = parcelRequire("a6t12");


var $iyJql = parcelRequire("iyJql");

const $926764df61793b09$export$9d42da855fcdda87 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { userId: userId, fullName: fullName, children: children, agent: agent, trigger: t1, position: t2, offset: t3 } = t0;
    const trigger = t1 === undefined ? "click" : t1;
    const position = t2 === undefined ? "bottom-start" : t2;
    let t4;
    if ($[0] !== t3) {
        t4 = t3 === undefined ? [
            0,
            8
        ] : t3;
        $[0] = t3;
        $[1] = t4;
    } else t4 = $[1];
    const offset = t4;
    let t5;
    if ($[2] !== userId) {
        t5 = (0, $iyJql.toUsableIdentityAccountId)(userId);
        $[2] = userId;
        $[3] = t5;
    } else t5 = $[3];
    const usableUserId = t5;
    if (!usableUserId) {
        let t6;
        if ($[4] !== children) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
            $[4] = children;
            $[5] = t6;
        } else t6 = $[5];
        return t6;
    }
    let t6;
    if ($[6] !== agent) {
        t6 = agent ? {
            agent: agent
        } : {};
        $[6] = agent;
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] !== children || $[9] !== fullName || $[10] !== offset || $[11] !== position || $[12] !== t6 || $[13] !== trigger || $[14] !== usableUserId) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6t12.ProfileCardWrapper), {
            userId: usableUserId,
            fullName: fullName,
            trigger: trigger,
            position: position,
            offset: offset,
            ...t6
        }, children);
        $[8] = children;
        $[9] = fullName;
        $[10] = offset;
        $[11] = position;
        $[12] = t6;
        $[13] = trigger;
        $[14] = usableUserId;
        $[15] = t7;
    } else t7 = $[15];
    const card = t7;
    if (agent) {
        let t8;
        if ($[16] !== card) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7akNQ.FlagsProvider), null, card);
            $[16] = card;
            $[17] = t8;
        } else t8 = $[17];
        return t8;
    }
    return card;
} : ({ userId: userId, fullName: fullName, children: children, agent: agent, trigger: trigger = 'click', position: position = 'bottom-start', offset: offset = [
    0,
    8
] })=>{
    const usableUserId = (0, $iyJql.toUsableIdentityAccountId)(userId);
    if (!usableUserId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    const card = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6t12.ProfileCardWrapper), {
        userId: usableUserId,
        fullName: fullName,
        trigger: trigger,
        position: position,
        offset: offset,
        ...agent ? {
            agent: agent
        } : {}
    }, children);
    if (agent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7akNQ.FlagsProvider), null, card);
    return card;
};
module.exports["ProfileIdentity"] = $926764df61793b09$export$9d42da855fcdda87;

});

parcelRegister("bzqa9", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $lTECB = parcelRequire("lTECB");


var $dPJCf = parcelRequire("dPJCf");


var $4qzKl = parcelRequire("4qzKl");


var $icKZN = parcelRequire("icKZN");

const $abb6860b27595ef6$export$8ce912bc34d0dbea = ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { push: push } = (0, $dPJCf.useRouteActions)();
    let t0;
    if ($[0] !== push) {
        t0 = (event, url)=>{
            if (!event?.isDefaultPrevented()) event?.preventDefault();
            if ((0, $icKZN.isClickEventToOpenNewTab)(event)) window.open(url, "_blank");
            else push(url);
        };
        $[0] = push;
        $[1] = t0;
    } else t0 = $[1];
    const handleClick = t0;
    let t1;
    if ($[2] !== handleClick) {
        t1 = (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)() ? {
            mention: {
                onClick: async (userId, _, event_0)=>{
                    event_0?.preventDefault();
                    event_0?.stopPropagation();
                    const url_0 = await (0, $4qzKl.getAtlassianPeopleProfileUrlAsync)(userId);
                    handleClick(event_0, url_0);
                }
            },
            link: {
                onClick (e, url_1) {
                    handleClick(e, url_1);
                }
            },
            smartCard: {
                onClick (e_0, url_2) {
                    handleClick(e_0, url_2);
                }
            }
        } : undefined;
        $[2] = handleClick;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
};
module.exports["useEventHandlers"] = $abb6860b27595ef6$export$8ce912bc34d0dbea;

});

parcelRegister("1a6Dn", function(module, exports) {

var $hrAmX = parcelRequire("hrAmX");


var $a4dgs = parcelRequire("a4dgs");

class $d3905c2d386f370c$export$c59406a16f2704a5 extends (0, $a4dgs.BaseStateContainer) {
    constructor(...args){
        super(...args);
        this.state = {
            floatingBanners: []
        };
        this.showFloating = (name, height)=>{
            // The lookup has to happen inside the updater: updates queued in the same microtask are
            // applied in sequence, so an index resolved beforehand would already be stale.
            this.setState((state)=>{
                const index = (0, $hrAmX.findBanner)(name, state.floatingBanners);
                if (index === -1) return {
                    ...state,
                    floatingBanners: [
                        ...state.floatingBanners,
                        {
                            name: name,
                            height: height
                        }
                    ]
                };
                if (state.floatingBanners[index].height !== height) {
                    const newArray = [
                        ...state.floatingBanners
                    ];
                    // Replace rather than mutate, so the previous state keeps the old height.
                    newArray[index] = {
                        name: name,
                        height: height
                    };
                    return {
                        ...state,
                        floatingBanners: newArray
                    };
                }
                return undefined;
            });
        };
        this.hideFloating = (name)=>{
            this.setState((state)=>{
                const index = (0, $hrAmX.findBanner)(name, state.floatingBanners);
                if (index > -1) {
                    const newArray = [
                        ...state.floatingBanners
                    ];
                    newArray.splice(index, 1);
                    return {
                        ...state,
                        floatingBanners: newArray
                    };
                }
                return undefined;
            });
        };
        this.getFloatingHeightBefore = (name)=>{
            const index = (0, $hrAmX.findBanner)(name, this.state.floatingBanners);
            if (index === -1) return 0;
            return this.state.floatingBanners.slice(0, index).reduce((height, banner)=>{
                return height + banner.height;
            }, 0);
        };
        this.getFloatingHeight = ()=>this.state.floatingBanners.reduce((height, banner)=>height + banner.height, 0);
    }
}
module.exports["FloatingBannerStateContainer"] = $d3905c2d386f370c$export$c59406a16f2704a5;

});

parcelRegister("8WfxO", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $eSLr0 = parcelRequire("eSLr0");


var $ep3mz = parcelRequire("ep3mz");


var $6mKj3 = parcelRequire("6mKj3");


var $dS3n9 = parcelRequire("dS3n9");

const $720c81ac24834d84$export$dc9cc84753faedac = ()=>{
    const $ = (0, $bDgLe.c)(10);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [];
        $[0] = t0;
    } else t0 = $[0];
    const atlGeneralHeightChanges = (0, $cozmU.useRef)(t0);
    const [webPanelHeight, setWebPanelHeight] = (0, $cozmU.useState)($720c81ac24834d84$var$_temp);
    const [t1] = (0, $ep3mz.usePageState)();
    const { contentId: contentId, spaceKey: spaceKey } = t1;
    let t2;
    if ($[1] !== contentId || $[2] !== spaceKey) {
        t2 = {
            location: (0, $eSLr0.ATL_GENERAL),
            fetchPolicy: "cache-first",
            spaceKey: spaceKey,
            contentId: contentId
        };
        $[1] = contentId;
        $[2] = spaceKey;
        $[3] = t2;
    } else t2 = $[3];
    const { panels: panels } = (0, $dS3n9.useWebPanelLocation)(t2);
    const isATLGeneralWebPanelFixed = panels.length > 0;
    let t3;
    let t4;
    if ($[4] !== isATLGeneralWebPanelFixed) {
        t3 = ()=>{
            const listener = (e)=>{
                let newHeight;
                if ((0, $6mKj3.expVal)("confluence_p2m_style_recalc_and_expand_joint_exp", "isEnabled", false)) {
                    setWebPanelHeight(e?.detail?.height ?? 0);
                    newHeight = e?.detail?.height ?? 0;
                } else {
                    setWebPanelHeight($720c81ac24834d84$var$getAtlGeneralWebPanelHeight());
                    newHeight = $720c81ac24834d84$var$getAtlGeneralWebPanelHeight();
                }
                if (typeof window !== "undefined" && Boolean(window.__SSR_RENDERED__)) {
                    const lastHeight = atlGeneralHeightChanges.current.length === 0 ? window.__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__ || 0 : atlGeneralHeightChanges.current[atlGeneralHeightChanges.current.length - 1];
                    if (lastHeight !== newHeight) atlGeneralHeightChanges.current.push(newHeight);
                    window.__ATL_GENERAL_WEBPANEL_HEIGHT_CHANGES__ = atlGeneralHeightChanges.current;
                }
            };
            if (isATLGeneralWebPanelFixed) document.addEventListener("atlGeneralWebPanelHeightUpdated", listener);
            return ()=>{
                if (isATLGeneralWebPanelFixed) document.removeEventListener("atlGeneralWebPanelHeightUpdated", listener);
            };
        };
        t4 = [
            isATLGeneralWebPanelFixed
        ];
        $[4] = isATLGeneralWebPanelFixed;
        $[5] = t3;
        $[6] = t4;
    } else {
        t3 = $[5];
        t4 = $[6];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[7] !== isATLGeneralWebPanelFixed || $[8] !== webPanelHeight) {
        t5 = {
            isATLGeneralWebPanelFixed: isATLGeneralWebPanelFixed,
            atlGeneralWebPanelHeight: webPanelHeight
        };
        $[7] = isATLGeneralWebPanelFixed;
        $[8] = webPanelHeight;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
};
const $720c81ac24834d84$var$getAtlGeneralWebPanelHeight = ()=>{
    if (typeof document === 'undefined') return 0;
    return parseInt(// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    getComputedStyle(document.documentElement).getPropertyValue('--atl-general-webpanel-height')) || 0;
};
function $720c81ac24834d84$var$_temp() {
    if (typeof window !== "undefined" && Boolean(window.__SSR_RENDERED__) && (0, $6mKj3.expVal)("confluence_p2m_style_recalc_and_expand_joint_exp", "isEnabled", false)) {
        const initialHeight = window.__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__;
        return initialHeight ?? 0;
    } else return $720c81ac24834d84$var$getAtlGeneralWebPanelHeight();
}
module.exports["useATLGeneralWebPanelListener"] = $720c81ac24834d84$export$dc9cc84753faedac;

});

parcelRegister("dS3n9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jtuBN = parcelRequire("jtuBN");


var $jMyy4 = parcelRequire("jMyy4");


var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");


var $eSLr0 = parcelRequire("eSLr0");


var $9Z1sw = parcelRequire("9Z1sw");

const $9fffd50bbcc7c343$export$c8daa7260f75e213 = ({ spaceKey: spaceKey, contentId: contentId, location: location, fetchPolicy: // Query is preloaded on the server-side. reused the preloaded data.
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
fetchPolicy = 'cache-and-network', onCompleted: onCompleted })=>{
    const { getQueryParams: getQueryParams } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const queryParams = getQueryParams();
    const spaceIdentifier = spaceKey || (0, $c3Qwv.getSingleParam)(queryParams, 'spaceKey') || (0, $c3Qwv.getSingleParam)(queryParams, 'key');
    const contentIdentifier = contentId || (0, $c3Qwv.getSingleParam)(queryParams, 'pageId');
    const variables = contentIdentifier ? {
        contentId: contentIdentifier,
        location: location
    } : {
        spaceKey: spaceIdentifier,
        location: location
    };
    const batchResult = (0, $9Z1sw.useWebPanelLocationBatchResult)(location);
    const batchResultData = batchResult?.data;
    const batchResultError = batchResult?.error;
    const batchResultLoading = batchResult?.loading;
    const completedBatchResultKeyRef = (0, $cozmU.useRef)(null);
    const baseOptions = {
        variables: variables,
        skip: Boolean(batchResult),
        ...onCompleted && {
            onCompleted: onCompleted
        }
    };
    // Keep watching query for home route to avoid VC90 regression
    const useNoFurtherUpdate = location !== (0, $eSLr0.DASHBOARD_SECONDARY);
    const { loading: loading, data: data, error: error } = useNoFurtherUpdate ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $9Z1sw.WebPanelLocationQuery), {
        ...baseOptions,
        __callerPackage__: "web-panel-location"
    }) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jMyy4.useQueryInterop)((0, $9Z1sw.WebPanelLocationQuery), {
        ...baseOptions,
        fetchPolicy: fetchPolicy,
        __callerPackage__: "web-panel-location"
    });
    const result = batchResult ?? {
        loading: loading,
        data: data,
        error: error
    };
    (0, $cozmU.useEffect)(()=>{
        if (batchResultLoading || batchResultError || !batchResultData || !onCompleted) return;
        const batchResultKey = `${contentIdentifier || ''}:${spaceIdentifier || ''}:${location}`;
        if (completedBatchResultKeyRef.current !== batchResultKey) {
            completedBatchResultKeyRef.current = batchResultKey;
            onCompleted();
        }
    }, [
        batchResultData,
        batchResultError,
        batchResultLoading,
        contentIdentifier,
        location,
        onCompleted,
        spaceIdentifier
    ]);
    const panels = (result.data?.webPanels || []).filter((panel)=>panel);
    return {
        panels: panels,
        loading: result.loading,
        error: result.error
    };
};
module.exports["useWebPanelLocation"] = $9fffd50bbcc7c343$export$c8daa7260f75e213;

});

parcelRegister("7VJPz", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $8jDil = parcelRequire("8jDil");

var $5FMVr = parcelRequire("5FMVr");


var $aJPUt = parcelRequire("aJPUt");


var $5kjCz = parcelRequire("5kjCz");


var $4KFTW = parcelRequire("4KFTW");


var $au7xi = parcelRequire("au7xi");


var $1lyRS = parcelRequire("1lyRS");

const $cd53535796fd282e$export$16ffa5f7b88dc45f = ({ contentId: contentId, contentType: contentType, cloudId: cloudId })=>{
    const extensionHandlers = {};
    extensionHandlers[0, $au7xi.smartButtonExtensionType] = (extension)=>{
        const pageAri = contentId ? (0, $8jDil.ConfluencePageAri).create({
            siteId: cloudId,
            pageId: contentId
        }).toString() : undefined;
        const site = (0, $5FMVr.ConfluenceSiteAri).create({
            siteId: cloudId
        }).toString();
        const experienceName = (0, $5kjCz.getExperienceName)((0, $5kjCz.RENDERER), extension);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4KFTW.MacroExperienceStart), {
            name: experienceName,
            contentId: contentId ?? '',
            mode: (0, $5kjCz.RENDERER),
            extensionKey: extension.extensionKey,
            attributes: (0, $5kjCz.getMacroAttributesFromADFNode)(extension),
            timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1lyRS.SmartButtonLoader), {
            ruleId: extension.parameters?.ruleId,
            scopeId: extension.parameters?.scopeId,
            pageAri: pageAri,
            site: site,
            smartButtonName: extension.parameters?.smartButtonName,
            experienceTrackerName: experienceName,
            contentId: contentId ?? '',
            contentType: contentType ?? '',
            isViewMode: true
        }));
    };
    return extensionHandlers;
};
module.exports["getRendererSmartButtonExtensionHandlers"] = $cd53535796fd282e$export$16ffa5f7b88dc45f;

});

parcelRegister("5kjCz", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $irVI7 = parcelRequire("irVI7");


var $glCMv = parcelRequire("glCMv");


var $fGzMp = parcelRequire("fGzMp");


var $kmyYx = parcelRequire("kmyYx");


var $aJPUt = parcelRequire("aJPUt");


var $04e9M = parcelRequire("04e9M");


var $78QFu = parcelRequire("78QFu");


var $9Cbhx = parcelRequire("9Cbhx");

const $44f37a86f8c1409e$export$c3c3c3f81a03570c = 'renderer';
const $44f37a86f8c1409e$export$e70b8cd540123fd4 = 'editor';
const $44f37a86f8c1409e$export$f783453b83c906eb = 'pdf';
const $44f37a86f8c1409e$var$ACTION = {
    SUCCESS: 'taskSuccess',
    FAIL: 'taskFail',
    ABORT: 'taskAbort',
    START: 'taskStart'
};
const $44f37a86f8c1409e$export$84a4de0ef6621278 = (name)=>name.split('.').slice(1).join('.');
const $44f37a86f8c1409e$export$b94fa6ed199caed2 = (macroEventRegister = new Map())=>{
    const macros = [];
    // @ts-ignore
    for (const v of macroEventRegister.values()){
        const { name: name } = v;
        if (name !== (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE)) {
            const macro = {
                uniqueHash: $44f37a86f8c1409e$export$84a4de0ef6621278(name),
                ...$44f37a86f8c1409e$export$ae13022b12e7d19a(v)
            };
            macros.push(macro);
        }
    }
    return macros;
};
const $44f37a86f8c1409e$export$c1196ba2be68e8d3 = (macro)=>{
    return {
        type: macro?.type || '',
        macroId: (0, $9Cbhx.getMacroId)(macro?.parameters),
        extensionKey: (0, $9Cbhx.getExtensionKey)(macro),
        extensionType: macro?.extensionType || ''
    };
};
const $44f37a86f8c1409e$export$ae13022b12e7d19a = (macroEvent)=>{
    return {
        extensionKey: (0, $9Cbhx.getExtensionKey)(macroEvent?.experienceAttributes),
        extensionType: macroEvent?.experienceAttributes?.extensionType || '',
        type: macroEvent?.experienceAttributes?.type || '',
        macroId: macroEvent?.experienceAttributes?.macroId || '',
        duration: macroEvent?.duration || '',
        status: macroEvent?.status || '',
        pageId: macroEvent?.pageId || ''
    };
};
const $44f37a86f8c1409e$export$b16b3cab64ff0bd4 = (mode, contentId)=>{
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    if (macroEventRegister.has(contentId)) return;
    $44f37a86f8c1409e$export$f7c63e38d5d9fd0b(mode, contentId).start({
        attributes: {
            mode: mode
        },
        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD,
        id: contentId
    });
};
const $44f37a86f8c1409e$export$f9ebd83e8406755f = (mode, contentId)=>{
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    if (macroEventRegister.has(contentId)) {
        if ($44f37a86f8c1409e$export$d693932e457c5586(macroEventRegister)) {
            const macroAttributes = {
                mode: mode,
                macros: null
            };
            if ($44f37a86f8c1409e$export$375cf77d729480fb(macroEventRegister)) macroAttributes.macros = $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister);
            (0, $fGzMp.getExperienceTracker)().succeed({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                attributes: {
                    ...macroAttributes
                }
            });
        } else (0, $fGzMp.getExperienceTracker)().abort({
            name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
            reason: `Some macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`,
            attributes: {
                macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                mode: mode
            }
        });
        const jiraMacro = $44f37a86f8c1409e$export$32db3a6a0c8b81ea(macroEventRegister);
        jiraMacro.forEach((macro)=>{
            const extensionKey = (0, $9Cbhx.getExtensionKey)(macro.experienceAttributes);
            const status = macro.status;
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: status,
                    attributes: {
                        ...macro.experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`
                    }
                });
            });
        });
        // clean up after aborting all event
        macroEventRegister.clear();
        $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
    }
};
const $44f37a86f8c1409e$export$d693932e457c5586 = (eventRegister = new Map())=>{
    if (eventRegister.size === 0) return true;
    // only check whether all sub-experience has finished
    // @ts-ignore
    for (const v of eventRegister.values()){
        if (v.name !== (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE) && v.status !== $44f37a86f8c1409e$var$ACTION.SUCCESS) return false;
    }
    return true;
};
const $44f37a86f8c1409e$export$375cf77d729480fb = (eventRegister = new Map())=>{
    // @ts-ignore
    for (const v of eventRegister.values()){
        if (v.name !== (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE)) return true;
    }
    return false;
};
const $44f37a86f8c1409e$export$faf154bb66b40b64 = (name)=>name.includes((0, $9Cbhx.JIRA_EXTENSION_KEY));
const $44f37a86f8c1409e$export$f2ada44de4a33ea1 = (eventRegister)=>{
    const macros = [];
    // Type 'IterableIterator<[string, MacroExperienceAttribute]>' is not an array type
    // or a string type. Use compiler option '--downlevelIteration'
    // to allow iterating of iterators
    // @ts-ignore
    for (const v of eventRegister.values())if ($44f37a86f8c1409e$export$faf154bb66b40b64(v.name) && v.status !== $44f37a86f8c1409e$var$ACTION.SUCCESS) macros.push(v);
    return macros;
};
const $44f37a86f8c1409e$export$32db3a6a0c8b81ea = (eventRegister)=>{
    const macros = [];
    // Type 'IterableIterator<[string, MacroExperienceAttribute]>' is not an array type
    // or a string type. Use compiler option '--downlevelIteration'
    // to allow iterating of iterators
    // @ts-ignore
    for (const v of eventRegister.values())if ($44f37a86f8c1409e$export$faf154bb66b40b64(v.name)) macros.push(v);
    return macros;
};
const $44f37a86f8c1409e$export$98d7b4463a1de442 = (contentId, mode)=>{
    (function macroTimeout() {
        setTimeout(()=>{
            const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
            if (!macroEventRegister.has(contentId)) return;
            const pageEvent = macroEventRegister.get(contentId);
            const isTimedOut = Math.round(window.performance.now() - pageEvent.startTime) > (0, $aJPUt.ExperienceTimeout).MACRO_LOAD;
            // 1. all macro loaded or main-experience timeout and have sub-experience
            //    succeed the main experience and report to experience tracker and done
            if ($44f37a86f8c1409e$export$d693932e457c5586(macroEventRegister) && $44f37a86f8c1409e$export$375cf77d729480fb(macroEventRegister)) (0, $fGzMp.getExperienceTracker)().succeed({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                attributes: {
                    macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                    mode: mode
                }
            });
            else if (isTimedOut) {
                // 2a. timeout does not has sub-experience, succeed the main experience
                if (!$44f37a86f8c1409e$export$375cf77d729480fb(macroEventRegister)) (0, $fGzMp.getExperienceTracker)().succeed({
                    name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                    attributes: {
                        mode: mode
                    }
                });
                else {
                    (0, $fGzMp.getExperienceTracker)().abort({
                        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                        reason: `Some macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`,
                        attributes: {
                            macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                            mode: mode
                        }
                    });
                    const unsuceededJIRAMacro = $44f37a86f8c1409e$export$f2ada44de4a33ea1(macroEventRegister);
                    unsuceededJIRAMacro.forEach((macro)=>{
                        const extensionKey = (0, $9Cbhx.getExtensionKey)(macro.experienceAttributes);
                        (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                            analyticsWebClient.sendOperationalEvent({
                                source: 'ui',
                                actionSubject: 'macroTracker',
                                action: 'taskAbort',
                                attributes: {
                                    ...macro.experienceAttributes,
                                    extensionKey: extensionKey,
                                    mode: mode,
                                    task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                                    reason: `JIRA macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`
                                }
                            });
                        });
                    });
                }
                // clean up after aborting all event
                macroEventRegister.clear();
                $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            } else macroTimeout();
        }, 2000);
    })();
};
const $44f37a86f8c1409e$var$macroEventRegisterHash = new Map();
const $44f37a86f8c1409e$export$adf8cb42c7fe1834 = (mode, contentId)=>{
    if ($44f37a86f8c1409e$var$macroEventRegisterHash.has(`${mode}.${contentId}`)) return $44f37a86f8c1409e$var$macroEventRegisterHash.get(`${mode}.${contentId}`);
    $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, new Map());
    return $44f37a86f8c1409e$var$macroEventRegisterHash.get(`${mode}.${contentId}`);
};
const $44f37a86f8c1409e$export$d7fca4196d2b6b6c = (mode, contentId, name, experienceAttributes)=>{
    if ($44f37a86f8c1409e$export$faf154bb66b40b64(name)) {
        const extensionKey = (0, $9Cbhx.getExtensionKey)(experienceAttributes);
        (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
            analyticsWebClient.sendOperationalEvent({
                source: 'ui',
                actionSubject: 'macroTracker',
                action: 'taskStart',
                attributes: {
                    ...experienceAttributes,
                    extensionKey: extensionKey,
                    mode: mode,
                    pageId: contentId,
                    task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                }
            });
        });
    }
};
const $44f37a86f8c1409e$export$d10b6dded8392899 = (mode, contentId, name, experienceAttributes)=>{
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    const macroId = experienceAttributes?.macroId;
    if (!macroEventRegister.has(macroId)) return;
    if ($44f37a86f8c1409e$export$faf154bb66b40b64(name)) {
        const extensionKey = (0, $9Cbhx.getExtensionKey)(experienceAttributes);
        const { status: status } = macroEventRegister.get(macroId);
        if (status === $44f37a86f8c1409e$var$ACTION.SUCCESS) {
            const { duration: duration } = macroEventRegister.get(macroId);
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: 'taskSuccess',
                    attributes: {
                        ...experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        duration: duration,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                        pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                    }
                });
            });
        } else if (status === $44f37a86f8c1409e$var$ACTION.ABORT) {
            const { duration: duration } = macroEventRegister.get(macroId);
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: 'taskAbort',
                    attributes: {
                        ...experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        duration: duration,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                        reason: `JIRA macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`
                    }
                });
            });
        } else if (status === $44f37a86f8c1409e$var$ACTION.FAIL) {
            const { duration: duration } = macroEventRegister.get(macroId);
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: 'taskFail',
                    attributes: {
                        ...experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        duration: duration,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                        error: new (0, $glCMv.ExperienceTimeoutError)(`JIRA macro failed to complete in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`)
                    }
                });
            });
        }
    }
};
const $44f37a86f8c1409e$export$f7c63e38d5d9fd0b = (0, $dOBRD.default)((mode, contentId)=>{
    const macroTracker = new (0, $kmyYx.ExperienceTracker)();
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    macroTracker.subscribe((event)=>{
        const { action: action, name: name, attributes: experienceAttributes, ...rest } = event;
        const macroId = experienceAttributes?.macroId;
        if (action === $44f37a86f8c1409e$var$ACTION.START) {
            // prevent triggering of event
            const current = macroEventRegister.get(macroId);
            if (current && current.id === macroId) return;
            if (name === (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE)) // prevent firing the same view-all-macro more than once
            {
                if (!macroEventRegister.has(contentId)) {
                    // clear the event register, prevent event being re-tracked between SPA transition
                    macroEventRegister.clear();
                    (0, $fGzMp.getExperienceTracker)().start({
                        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                        timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD,
                        id: contentId,
                        attributes: {
                            mode: mode
                        }
                    });
                    macroEventRegister.set(contentId, {
                        status: $44f37a86f8c1409e$var$ACTION.START,
                        name: name,
                        mode: mode,
                        ...rest
                    });
                    $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
                }
            } else {
                // tracking each macro, report to MacroTracker
                macroEventRegister.set(macroId, {
                    status: $44f37a86f8c1409e$var$ACTION.START,
                    name: name,
                    experienceAttributes: {
                        ...experienceAttributes,
                        extensionKey: (0, $9Cbhx.getExtensionKey)(experienceAttributes)
                    },
                    pageId: contentId,
                    mode: mode,
                    ...rest
                });
                $44f37a86f8c1409e$export$d7fca4196d2b6b6c(mode, contentId, name, experienceAttributes);
            }
        } else if (action === $44f37a86f8c1409e$var$ACTION.SUCCESS) {
            // if event is not yet track
            if (!macroEventRegister.has(macroId)) return;
            const { duration: duration, name: name } = event;
            // tracking each macro when it successfully loads
            macroEventRegister.set(macroId, {
                ...macroEventRegister.get(macroId),
                id: macroId,
                name: name,
                mode: mode,
                status: $44f37a86f8c1409e$var$ACTION.SUCCESS,
                duration: duration,
                pageId: contentId
            });
            $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            $44f37a86f8c1409e$export$d10b6dded8392899(mode, contentId, name, experienceAttributes);
        } else if (action === $44f37a86f8c1409e$var$ACTION.ABORT) {
            // if event is not yet track
            if (!macroEventRegister.has(macroId)) return;
            const { duration: duration, reason: reason, name: name } = event;
            // tracking each macro when it aborts loading
            macroEventRegister.set(macroId, {
                ...macroEventRegister.get(macroId),
                id: macroId,
                name: name,
                mode: mode,
                status: $44f37a86f8c1409e$var$ACTION.ABORT,
                duration: duration,
                pageId: contentId,
                reason: reason
            });
            $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            // one macro aborts to load, aborts the entire experience and report to ExperienceTracker
            (0, $fGzMp.getExperienceTracker)().abort({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                reason: 'Macro abort loading',
                attributes: {
                    macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                    mode: mode
                }
            });
            $44f37a86f8c1409e$export$d10b6dded8392899(mode, contentId, name, experienceAttributes);
        } else if (action == $44f37a86f8c1409e$var$ACTION.FAIL) {
            // if event is not yet track
            if (!macroEventRegister.has(macroId)) return;
            const { duration: duration, error: error, name: name } = event;
            // tracking each macro when it fails to load
            macroEventRegister.set(macroId, {
                ...macroEventRegister.get(macroId),
                id: macroId,
                name: name,
                mode: mode,
                status: $44f37a86f8c1409e$var$ACTION.FAIL,
                duration: duration,
                pageId: contentId,
                error: error
            });
            $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            // one macro fails to load, fails the entire experience and report to ExperienceTracker
            (0, $fGzMp.getExperienceTracker)().fail({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                error: error,
                attributes: {
                    macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                    mode: mode,
                    ...experienceAttributes
                }
            });
            $44f37a86f8c1409e$export$d10b6dded8392899(mode, contentId, name, experienceAttributes);
        }
        $44f37a86f8c1409e$export$98d7b4463a1de442(contentId, mode);
    });
    return macroTracker;
});
const $44f37a86f8c1409e$export$4ce0bedef4e84bb7 = (mode, extension)=>{
    const attributes = $44f37a86f8c1409e$export$c1196ba2be68e8d3(extension);
    return `${mode}.${(0, $9Cbhx.getExtensionKey)(attributes)}.${attributes.macroId}`;
};
module.exports["RENDERER"] = $44f37a86f8c1409e$export$c3c3c3f81a03570c;
module.exports["EDITOR"] = $44f37a86f8c1409e$export$e70b8cd540123fd4;
module.exports["PDF"] = $44f37a86f8c1409e$export$f783453b83c906eb;
module.exports["getMacroAttributesFromADFNode"] = $44f37a86f8c1409e$export$c1196ba2be68e8d3;
module.exports["startMacroExperience"] = $44f37a86f8c1409e$export$b16b3cab64ff0bd4;
module.exports["getMacroExperienceTracker"] = $44f37a86f8c1409e$export$f7c63e38d5d9fd0b;
module.exports["stopMacroExperience"] = $44f37a86f8c1409e$export$f9ebd83e8406755f;
module.exports["stopJIRAMacro"] = $44f37a86f8c1409e$export$d10b6dded8392899;
module.exports["getExperienceName"] = $44f37a86f8c1409e$export$4ce0bedef4e84bb7;

});

parcelRegister("9Cbhx", function(module, exports) {

var $kyKWe = parcelRequire("kyKWe");


var $hukUK = parcelRequire("hukUK");

const $9293ebd9645c82d6$export$7486394da5136452 = 'jira';
const $9293ebd9645c82d6$export$8d178e7efa3ed0e7 = 'issue-count';
const $9293ebd9645c82d6$export$c3f023baaa9b214b = 'table-view';
const $9293ebd9645c82d6$export$7d601f5ae4a82040 = 'single-issue';
const $9293ebd9645c82d6$export$47eae2202f029f6b = (parameters)=>{
    if (!parameters) return (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
    const idFromNode = parameters?.macroMetadata?.macroId?.value;
    if (idFromNode) return idFromNode;
    // for macro that does not have unique macro id, we want to generate some unique id
    return (0, $hukUK.objectHash)(parameters);
};
const $9293ebd9645c82d6$export$218d96312e385949 = (attributes)=>{
    if (!attributes) return '';
    const { extensionKey: extensionKey } = attributes;
    const macroParams = attributes?.parameters?.macroParams;
    if (extensionKey === $9293ebd9645c82d6$export$7486394da5136452) return `${extensionKey}${$9293ebd9645c82d6$export$cc2f094f034c7f8f(macroParams)}`;
    return extensionKey;
};
const $9293ebd9645c82d6$export$cc2f094f034c7f8f = (macroParams)=>{
    const prefix = '-';
    if (macroParams?.count?.value === 'true') return prefix + $9293ebd9645c82d6$export$8d178e7efa3ed0e7;
    else if (macroParams?.columns && macroParams?.maximumIssues) return prefix + $9293ebd9645c82d6$export$c3f023baaa9b214b;
    else if (macroParams?.key?.value) return prefix + $9293ebd9645c82d6$export$7d601f5ae4a82040;
    return '';
};
module.exports["JIRA_EXTENSION_KEY"] = $9293ebd9645c82d6$export$7486394da5136452;
module.exports["getMacroId"] = $9293ebd9645c82d6$export$47eae2202f029f6b;
module.exports["getExtensionKey"] = $9293ebd9645c82d6$export$218d96312e385949;

});

parcelRegister("4KFTW", function(module, exports) {

var $2bAZx = parcelRequire("2bAZx");


var $5kjCz = parcelRequire("5kjCz");

function $38a1fdadc870189c$export$ed05b2901e9d7d22({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, mode: mode, name: name, timeout: timeout }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).start({
            attributes: attributes,
            name: name,
            timeout: timeout,
            id: attributes?.macroId || contentId
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        mode,
        name,
        timeout
    ]);
    // https://stackoverflow.com/questions/54905376
    return children;
}
module.exports["MacroExperienceStart"] = $38a1fdadc870189c$export$ed05b2901e9d7d22;

});

parcelRegister("2bAZx", function(module, exports) {
// inspired by https://github.com/kentcdodds/use-deep-compare-effect/blob/master/src/index.js
/* eslint react-hooks/exhaustive-deps: 0 */ //Todo: this is flawed because callback is not included in the dependency array generated by useDeepCompareMemoize
// if the callback function (all use cases I found were inline functions and therfore not passed as a ref, were passes to the dep array they would trigger a re-evaluation every render defeating the purpose
// in order to properly work and handle the callback function being changed, the callback argument must be a useCallback or other function passed by ref and have it be included in the memoized depenedency array

var $cozmU = parcelRequire("cozmU");


var $3u5lg = parcelRequire("3u5lg");

function $a4fa77695d2683a4$export$db77f469fe79526e(callback, dependencies) {
    (0, $cozmU.useEffect)(callback, $a4fa77695d2683a4$var$useDeepCompareMemoize(dependencies));
}
//eslint-ignore react-hooks/exhaustive-deps
function $a4fa77695d2683a4$var$useDeepCompareMemoize(value) {
    const ref = (0, $cozmU.useRef)();
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(value, ref.current)) ref.current = value;
    return ref.current;
}
module.exports["useDeepCompareEffect"] = $a4fa77695d2683a4$export$db77f469fe79526e;

});

parcelRegister("au7xi", function(module, exports) {
const $ea41547e1b4f38b6$export$73185dbd06fc0dd8 = 'com.atlassian.automation.smart-button';
module.exports["smartButtonExtensionType"] = $ea41547e1b4f38b6$export$73185dbd06fc0dd8;

});

parcelRegister("1lyRS", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $16e92128cf9491a8$export$32d8d71ddecea49c = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "LmILK",
    name: "SmartButtonLoader",
    loader: async ()=>(await (parcelRequire("dUYBA"))).SmartButton
});
module.exports["SmartButtonLoader"] = $16e92128cf9491a8$export$32d8d71ddecea49c;

});

parcelRegister("dUYBA", function(module, exports) {

let $a21f843f3a21a18d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a21f843f3a21a18d$var$load("jXx9i"),
    $a21f843f3a21a18d$var$load("6wr18"),
    $a21f843f3a21a18d$var$load("2xKrc"),
    $a21f843f3a21a18d$var$load("4AElS"),
    $a21f843f3a21a18d$var$load("hhss7"),
    $a21f843f3a21a18d$var$load("ffEVr"),
    $a21f843f3a21a18d$var$load("lhkXg")
]).then(()=>parcelRequire('hLSQl'));

});

parcelRegister("dK51B", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1GTIR = parcelRequire("1GTIR");


var $fqCbQ = parcelRequire("fqCbQ");


var $7ji4X = parcelRequire("7ji4X");


var $6l6jb = parcelRequire("6l6jb");

function $7ac155b86059b716$export$9a41df5b9f27a628({ url: url, method: method, headers: headers, body: body, variables: variables, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError, skip: skip = false, fetchPolicy: fetchPolicy = 'cache-first', pollInterval: pollInterval }) {
    const { fetchData: fetchData } = (0, $1GTIR.useFetchData)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError
    });
    const key = (0, $6l6jb.generateCacheKey)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables
    });
    return $7ac155b86059b716$export$defacdf98710c90a({
        key: key,
        fetchData: fetchData,
        variables: variables,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        skip: skip,
        fetchPolicy: fetchPolicy,
        pollInterval: pollInterval
    });
}
function $7ac155b86059b716$export$defacdf98710c90a({ key: key, fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, skip: skip = false, fetchPolicy: fetchPolicy = 'cache-first', pollInterval: pollInterval }) {
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(undefined);
    const { queryState: queryState, execute: execute, refetch: refetch, stopPolling: stopPolling } = (0, $fqCbQ.useExperimentalQueryExecution)({
        key: key,
        fetchData: fetchData,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        fetchPolicy: fetchPolicy,
        isLazyQuery: false,
        pollInterval: pollInterval,
        isSSR: isSSR
    });
    (0, $cozmU.useEffect)(()=>{
        // Edit Page uses JSDOM, so effects run in SSR. Experimental queries should not execute during SSR
        if (!skip && !isSSR) execute();
    }, [
        execute,
        key,
        skip,
        fetchPolicy,
        isSSR
    ]);
    // If skip is true, return idle state with refetch
    if (skip) return {
        ...(0, $7ji4X.INITIAL_IDLE_STATE),
        refetch: refetch,
        stopPolling: stopPolling
    };
    // Use store state if available, otherwise return initial loading state with refetch
    // (stable reference prevents extra renders before query executes)
    return queryState ? {
        ...queryState,
        refetch: refetch,
        stopPolling: stopPolling
    } : {
        ...(0, $7ji4X.INITIAL_LOADING_STATE),
        refetch: refetch,
        stopPolling: stopPolling
    };
}
module.exports["useExperimentalQuery"] = $7ac155b86059b716$export$9a41df5b9f27a628;
module.exports["useExperimentalQueryBase"] = $7ac155b86059b716$export$defacdf98710c90a;

});

parcelRegister("fqCbQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $26Yfd = parcelRequire("26Yfd");


var $hR9WV = parcelRequire("hR9WV");


var $7ji4X = parcelRequire("7ji4X");


var $iXGsw = parcelRequire("iXGsw");

const $2b5be438041a56b3$export$96d43f36deadf5d1 = new Map();
function $2b5be438041a56b3$export$ca796a141438ab25({ key: key, fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, fetchPolicy: fetchPolicy, isLazyQuery: isLazyQuery = false, pollInterval: pollInterval, isSSR: isSSR = false }) {
    // For no-cache: use local state per hook instance instead of shared state
    const [localState, setLocalState] = (0, $cozmU.useState)();
    const sharedState = (0, $7ji4X.useExperimentalQueryState)({
        key: key
    });
    const { setQueryState: setQueryState } = (0, $7ji4X.useExperimentalQueryStateActions)();
    // Store the last used variables for polling
    // This ensures lazy queries remember their variables for subsequent poll requests
    const lastVariablesRef = (0, $cozmU.useRef)(undefined);
    // Choose which state to expose based on fetchPolicy
    const queryState = fetchPolicy === 'no-cache' ? localState : sharedState;
    const execute = (0, $26Yfd.useStableCallback)(async (variables, options)=>{
        // Store variables for future polling requests
        // This matches Apollo's behavior where lazy queries remember their variables
        if (variables !== undefined) lastVariablesRef.current = variables;
        // Use provided variables, or fall back to stored variables (e.g., during polling)
        const effectiveVariables = variables ?? lastVariablesRef.current;
        // If cache-first and we have data, return immediately (unless bypassCache is true, e.g., for polling)
        if (fetchPolicy === 'cache-first' && queryState?.data !== undefined && !options?.bypassCache) {
            onCompleted?.(queryState.data);
            return;
        }
        // Check if this exact query is already in flight (deduplication)
        const existingPromise = $2b5be438041a56b3$export$96d43f36deadf5d1.get(key);
        if (existingPromise) {
            // Wait for the shared promise
            const outcome = await existingPromise;
            // Set local state if no-cache policy. Other fetch policies use shared state
            if (fetchPolicy === 'no-cache') {
                if (outcome.error) setLocalState((prev)=>({
                        data: prev?.data,
                        loading: false,
                        error: outcome.error,
                        called: true
                    }));
                else if (outcome.data !== undefined) setLocalState({
                    data: outcome.data,
                    loading: false,
                    error: undefined,
                    called: true
                });
            }
            // Call this component's callbacks
            if (outcome.error) onError?.(outcome.error);
            else if (outcome.data !== undefined) onCompleted?.(outcome.data);
            return;
        }
        // Create a Promise for the fetch operation that resolves to the outcome
        const fetchPromise = (async ()=>{
            try {
                // Set loading state if not initial fetch
                const shouldSetLoadingState = !options?.skipLoadingState && (isLazyQuery || queryState?.loading === false || queryState?.data !== undefined || queryState?.error);
                if (shouldSetLoadingState) {
                    // Update the appropriate state based on fetchPolicy
                    if (fetchPolicy === 'no-cache') setLocalState({
                        data: queryState?.data,
                        loading: true,
                        error: undefined,
                        called: true
                    });
                    else setQueryState(key, {
                        data: queryState?.data,
                        loading: true,
                        error: undefined,
                        called: true
                    });
                }
                const data = await fetchData(effectiveVariables);
                if (fetchPolicy === 'no-cache') setLocalState({
                    data: data,
                    loading: false,
                    error: undefined,
                    called: true
                });
                else setQueryState(key, {
                    data: data,
                    loading: false,
                    error: undefined,
                    called: true
                });
                onCompleted?.(data);
                return {
                    data: data
                };
            } catch (error) {
                const finalError = await (0, $hR9WV.handleError)({
                    error: error,
                    transformError: transformError,
                    onError: onError
                });
                if (fetchPolicy === 'no-cache') setLocalState((prev)=>({
                        data: prev?.data,
                        loading: false,
                        error: finalError,
                        called: true
                    }));
                else setQueryState(key, (prev)=>({
                        data: prev.data,
                        loading: false,
                        error: finalError,
                        called: true
                    }));
                return {
                    error: finalError
                };
            } finally{
                // Remove from in-flight map so future calls create a new request
                $2b5be438041a56b3$export$96d43f36deadf5d1.delete(key);
            }
        })();
        // Store the Promise in the Map before starting the fetch
        $2b5be438041a56b3$export$96d43f36deadf5d1.set(key, fetchPromise);
        await fetchPromise;
    });
    // Note: This only updates the shared state, so any fetch policies (e.g. "no-cache") will be ignored.
    // Please implement local state usage if it's needed in the future.
    const refetch = (0, $26Yfd.useStableCallback)(async (variables)=>{
        try {
            setQueryState(key, {
                data: queryState?.data,
                loading: true,
                error: undefined,
                called: true
            });
            const data = await fetchData(variables);
            setQueryState(key, {
                data: data,
                loading: false,
                error: undefined,
                called: true
            });
            onCompleted?.(data);
            return {
                data: data
            };
        } catch (error) {
            const finalError = await (0, $hR9WV.handleError)({
                error: error,
                transformError: transformError,
                onError: onError
            });
            setQueryState(key, (prev)=>({
                    data: prev.data,
                    loading: false,
                    error: finalError,
                    called: true
                }));
            throw finalError;
        }
    });
    const { stopPolling: stopPolling } = (0, $iXGsw.usePollInterval)(pollInterval, execute, fetchPolicy, isLazyQuery, queryState?.called, isSSR);
    return {
        queryState: queryState,
        execute: execute,
        refetch: refetch,
        stopPolling: stopPolling
    };
}
module.exports["useExperimentalQueryExecution"] = $2b5be438041a56b3$export$ca796a141438ab25;

});

parcelRegister("iXGsw", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $d90d6eaddcfc40bd$export$55982a4d88e0db29(pollInterval, execute, fetchPolicy, isLazyQuery, called, isSSR) {
    if (pollInterval && fetchPolicy === 'cache-first') throw new Error('Queries that specify the cache-first fetchPolicy cannot also be polling queries.');
    const pollIntervalRef = (0, $cozmU.useRef)(null);
    const stopPolling = (0, $cozmU.useCallback)(()=>{
        if (pollIntervalRef.current) {
            clearInterval(pollIntervalRef.current);
            pollIntervalRef.current = null;
        }
    }, []);
    const handlePoll = (0, $cozmU.useCallback)(()=>{
        execute(undefined, {
            bypassCache: true,
            skipLoadingState: true
        });
    }, [
        execute
    ]);
    // For non-lazy queries: poll immediately when pollInterval > 0
    // For lazy queries: only poll after query has been called at least once
    const shouldStartPolling = (0, $cozmU.useMemo)(()=>{
        if (isSSR || !pollInterval || pollInterval <= 0) return false;
        return !isLazyQuery || called;
    }, [
        isSSR,
        pollInterval,
        isLazyQuery,
        called
    ]);
    (0, $cozmU.useEffect)(()=>{
        // Clear any existing poll interval when conditions change
        if (pollIntervalRef.current) {
            clearInterval(pollIntervalRef.current);
            pollIntervalRef.current = null;
        }
        if (shouldStartPolling) pollIntervalRef.current = setInterval(()=>{
            handlePoll();
        }, pollInterval);
        // Cleanup on unmount or when dependencies change
        return ()=>{
            if (pollIntervalRef.current) {
                clearInterval(pollIntervalRef.current);
                pollIntervalRef.current = null;
            }
        };
    }, [
        pollInterval,
        handlePoll,
        shouldStartPolling
    ]);
    return {
        stopPolling: stopPolling
    };
}
module.exports["usePollInterval"] = $d90d6eaddcfc40bd$export$55982a4d88e0db29;

});

parcelRegister("cLo2u", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ep3mz = parcelRequire("ep3mz");


var $7zgzO = parcelRequire("7zgzO");

function $91bacb73ef37142f$export$12ed3d1363567203(spaceKey) {
    const $ = (0, $bDgLe.c)(1);
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { match: match } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const routesContextSpaceKey = match?.params?.spaceKey;
    if (spaceKey) return spaceKey;
    if (pageContextSpaceKey) return pageContextSpaceKey;
    if (routesContextSpaceKey) return routesContextSpaceKey;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = typeof document !== "undefined" ? document.querySelector("meta#confluence-space-key")?.content : null;
        $[0] = t0;
    } else t0 = $[0];
    const documentMetaSpaceKey = t0;
    return documentMetaSpaceKey ?? null;
}
module.exports["useSpaceKey"] = $91bacb73ef37142f$export$12ed3d1363567203;

});

parcelRegister("hjUDQ", function(module, exports) {
var $3f94275ae089f93c$export$bdc3c19374266b98 = /*#__PURE__*/ function(ButtonStyle) {
    ButtonStyle["DEFAULT"] = "default";
    ButtonStyle["ALTERNATIVE_1"] = "alternative_1";
    return ButtonStyle;
}({});
var $3f94275ae089f93c$export$a6e645fda5339bf8 = /*#__PURE__*/ function(CornerStyle) {
    CornerStyle["ROUNDED"] = "rounded";
    CornerStyle["SQUARED"] = "squared";
    return CornerStyle;
}({});
var $3f94275ae089f93c$export$8954cfac7c08d16a = /*#__PURE__*/ function(Height) {
    Height["MEDIUM"] = "medium";
    Height["SMALL"] = "small";
    Height["LARGE"] = "large";
    return Height;
}({});
var $3f94275ae089f93c$export$9d7927214ed7d2cf = /*#__PURE__*/ function(Alignment) {
    Alignment["LEFT"] = "left";
    Alignment["RIGHT"] = "right";
    Alignment["CENTER"] = "center";
    return Alignment;
}({});
var $3f94275ae089f93c$export$df54d73aa0ec5e82 = /*#__PURE__*/ function(Orientation) {
    Orientation["ROW"] = "row";
    Orientation["STACKED"] = "stacked";
    return Orientation;
}({});
var $3f94275ae089f93c$export$21e76ed09a093e97 = /*#__PURE__*/ function(CardLayout) {
    CardLayout["FOLDERS"] = "folders";
    CardLayout["ACCORDIONS"] = "accordions";
    return CardLayout;
}({});
var $3f94275ae089f93c$export$42809f9f1496f50d = /*#__PURE__*/ function(CommonLayout) {
    CommonLayout["FRAME_ABOVE_IMAGE"] = "frame-above-image";
    CommonLayout["SPLIT_IMAGE_RIGHT"] = "split-image-right";
    CommonLayout["SPLIT_IMAGE_LEFT"] = "split-image-left";
    CommonLayout["FULL_IMAGE_BACKGROUND"] = "full-image-background";
    CommonLayout["NO_IMAGE_BACKGROUND"] = "no-image-background";
    return CommonLayout;
}({});
var $3f94275ae089f93c$export$d4c0482bf980ef26 = /*#__PURE__*/ function(FeedbackType) {
    FeedbackType["CARDS"] = "Cards";
    FeedbackType["CAROUSEL"] = "Carousel";
    FeedbackType["COMPANY_HUB"] = "Company hub";
    FeedbackType["CUSTOMIZE_NAVIGATION"] = "Customize Navigation";
    FeedbackType["LINKS_MENU"] = "Links menu";
    FeedbackType["SPOTLIGHT"] = "Spotlight";
    FeedbackType["SECTION"] = "Section";
    FeedbackType["CUSTOM_SEARCH"] = "Custom search";
    return FeedbackType;
}({});
var $3f94275ae089f93c$export$533ae1c1b7b7ac6 = /*#__PURE__*/ function(ExtensionMode) {
    ExtensionMode["RENDERER"] = "renderer";
    ExtensionMode["EDITOR"] = "editor";
    return ExtensionMode;
}({});
const $3f94275ae089f93c$export$cb307dad255adf47 = 'epic.logout.LOG_OUT';
var $3f94275ae089f93c$export$1f60141b6ce5efed = /*#__PURE__*/ function(RenderVariant) {
    RenderVariant["MANUAL"] = "manual";
    RenderVariant["DYNAMIC"] = "dynamic";
    return RenderVariant;
}({});
var $3f94275ae089f93c$export$f6cd408cac7f930c = /*#__PURE__*/ function(SegmentationTargets) {
    SegmentationTargets["ALL"] = "all";
    SegmentationTargets["EACH"] = "each";
    return SegmentationTargets;
}({});
var $3f94275ae089f93c$export$bf7ebf7fed6e7189 = /*#__PURE__*/ function(ITEM_FIELDS) {
    ITEM_FIELDS["CARD_ID"] = "cardId";
    ITEM_FIELDS["TITLE"] = "title";
    ITEM_FIELDS["IS_TITLE_USER_EDITED"] = "isTitleUserEdited";
    ITEM_FIELDS["DESCRIPTION"] = "description";
    ITEM_FIELDS["IS_DESCRIPTION_USER_EDITED"] = "isDescriptionUserEdited";
    ITEM_FIELDS["IS_DESCRIPTION_SHOWN"] = "isDescriptionShown";
    ITEM_FIELDS["LABEL"] = "label";
    ITEM_FIELDS["IS_LABEL_HIDDEN"] = "isLabelHidden";
    ITEM_FIELDS["LINK"] = "link";
    ITEM_FIELDS["IS_LINK_USER_EDITED"] = "isLinkUserEdited";
    ITEM_FIELDS["IMAGE_SRC"] = "imageSrc";
    ITEM_FIELDS["CONFLUENCE_PAGE_ID"] = "confluencePageId";
    ITEM_FIELDS["IMAGE_ALT_TEXT"] = "imageAltText";
    ITEM_FIELDS["SEGMENTATION_TARGETS"] = "segmentationTarget";
    ITEM_FIELDS["AUDIENCE_SEGMENTATION_GROUP_IDS"] = "audienceSegmentationGroupIds";
    // group preferences stored via this field when segmentationTarget is EACH
    ITEM_FIELDS["LINK_RESOURCE_TYPE"] = "linkResourceType";
    ITEM_FIELDS["BACKGROUND_COLOR"] = "backgroundColor";
    ITEM_FIELDS["TEXT_COLOR"] = "textColor";
    ITEM_FIELDS["LABEL_COLOR"] = "labelColor";
    ITEM_FIELDS["LAYOUT"] = "layout";
    ITEM_FIELDS["IS_BUTTON_SHOWN"] = "isButtonShown";
    ITEM_FIELDS["BUTTON_TEXT"] = "buttonText";
    ITEM_FIELDS["BUTTON_STYLE"] = "buttonStyle";
    ITEM_FIELDS["HEIGHT"] = "height";
    return ITEM_FIELDS;
}({});
module.exports["ButtonStyle"] = $3f94275ae089f93c$export$bdc3c19374266b98;
module.exports["CornerStyle"] = $3f94275ae089f93c$export$a6e645fda5339bf8;
module.exports["Height"] = $3f94275ae089f93c$export$8954cfac7c08d16a;
module.exports["Alignment"] = $3f94275ae089f93c$export$9d7927214ed7d2cf;
module.exports["Orientation"] = $3f94275ae089f93c$export$df54d73aa0ec5e82;
module.exports["CardLayout"] = $3f94275ae089f93c$export$21e76ed09a093e97;
module.exports["CommonLayout"] = $3f94275ae089f93c$export$42809f9f1496f50d;
module.exports["FeedbackType"] = $3f94275ae089f93c$export$d4c0482bf980ef26;
module.exports["ExtensionMode"] = $3f94275ae089f93c$export$533ae1c1b7b7ac6;
module.exports["RenderVariant"] = $3f94275ae089f93c$export$1f60141b6ce5efed;
module.exports["SegmentationTargets"] = $3f94275ae089f93c$export$f6cd408cac7f930c;
module.exports["ITEM_FIELDS"] = $3f94275ae089f93c$export$bf7ebf7fed6e7189;

});

parcelRegister("cfM7x", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $090373eba5349880$export$49e1053dfc41d188 = /*#__PURE__*/ (0, $cozmU.createContext)({
    // AI and Company Hub
    isCompanyHub: true,
    isHelpHub: false,
    isAdminHubAIEnabled: false,
    enableLinkInputInMediaPicker: false,
    helpCenterAri: '',
    showConfigPreambleSupportLink: false,
    // Shortcuts
    shortcutListener: undefined,
    // Smart cards
    smartCardProviderComponent: undefined,
    // Custom search configuration
    orgId: '',
    userId: '',
    searchConfigProvider: {
        peopleDirectoryUrl: '',
        advancedSearchUrl: '',
        searchSessionId: ''
    },
    displayName: '',
    // Theming
    isSSRProductInDarkMode: undefined,
    branding: undefined,
    hideExtensionBorders: false,
    // Feedback collection
    useFeedbackCollector: undefined,
    // Media providers
    cloudId: '',
    useMediaConfig: undefined,
    createEditorMediaProvider: ()=>Promise.resolve({
            viewMediaClientConfig: {
                authProvider: async ()=>({})
            },
            uploadMediaClientConfig: {
                authProvider: async ()=>({})
            }
        }),
    // Error handling
    submitError: ()=>{},
    markErrorAsHandled: ()=>{},
    errorDisplayComponent: ()=>null,
    errorBoundaryComponent: undefined,
    // Premium upsells
    ConfigUpsellScreen: undefined,
    // Experience tracking
    mediaUploadExperienceTracker: undefined,
    aiDescriptionExperienceTracker: undefined,
    experienceSuccessComponent: ()=>null,
    experienceStopComponent: ()=>null,
    experienceStartComponent: ()=>null,
    // Analytics
    analyticsContext: {},
    // User segmentation
    useSegmentationTargetGroups: ()=>{},
    isTargetAudience: ()=>false,
    // Link picker configuration
    linkPickerConfig: {},
    enableTargeting: false,
    enableUnifiedSearchFeatures: false,
    enableSmartCardsFields: false
});
const $090373eba5349880$export$774887fcc3922763 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    let children;
    let props;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    const defaultValue = (0, $cozmU.useContext)($090373eba5349880$export$49e1053dfc41d188);
    let t1;
    if ($[3] !== defaultValue || $[4] !== props) {
        t1 = {
            ...defaultValue,
            ...props
        };
        $[3] = defaultValue;
        $[4] = props;
        $[5] = t1;
    } else t1 = $[5];
    const value = t1;
    let t2;
    if ($[6] !== children || $[7] !== value) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($090373eba5349880$export$49e1053dfc41d188.Provider, {
            value: value
        }, children);
        $[6] = children;
        $[7] = value;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : ({ children: children, ...props })=>{
    const defaultValue = (0, $cozmU.useContext)($090373eba5349880$export$49e1053dfc41d188);
    const value = {
        ...defaultValue,
        ...props
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($090373eba5349880$export$49e1053dfc41d188.Provider, {
        value: value
    }, children);
};
const $090373eba5349880$export$8dcbb40932065737 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useProductDependencies() {
    const ctx = (0, $cozmU.useContext)($090373eba5349880$export$49e1053dfc41d188);
    if (!ctx) throw new Error("useProductDependencies must be used within ProductDependenciesProvider");
    return ctx;
} : function useProductDependencies() {
    const ctx = (0, $cozmU.useContext)($090373eba5349880$export$49e1053dfc41d188);
    if (!ctx) throw new Error('useProductDependencies must be used within ProductDependenciesProvider');
    return ctx;
};
module.exports["ProductDependenciesContext"] = $090373eba5349880$export$49e1053dfc41d188;
module.exports["useProductDependencies"] = $090373eba5349880$export$8dcbb40932065737;

});

parcelRegister("hUS75", function(module, exports) {

var $6fil2 = parcelRequire("6fil2");


var $5kjCz = parcelRequire("5kjCz");


var $2bAZx = parcelRequire("2bAZx");

function $50ff55d614a641f6$export$720dc4209419df4e(name, error, mode, contentId, attributes, source) {
    if ((0, $6fil2.containsNetworkError)(error)) {
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).abort({
            name: name,
            reason: `Aborted ${name} because of network error: ${error.toString()}`,
            checkForTimeout: false,
            attributes: {
                ...attributes,
                source: source
            }
        });
        return;
    }
    (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).fail({
        name: name,
        error: error,
        attributes: {
            ...attributes,
            source: source
        }
    });
}
function $50ff55d614a641f6$export$d22b49804594ed4d({ attributes: attributes, children: children = null, error: error, contentId: contentId, mode: mode, name: name, source: source }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        if (error) $50ff55d614a641f6$export$720dc4209419df4e(name, error, mode, contentId, attributes, source);
        else (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).succeed({
            name: name,
            attributes: attributes
        });
    }, [
        attributes,
        contentId,
        error,
        mode,
        name,
        source
    ]);
    // https://stackoverflow.com/questions/54905376
    return children;
}
module.exports["MacroExperienceStop"] = $50ff55d614a641f6$export$d22b49804594ed4d;

});

parcelRegister("bX5uj", function(module, exports) {

var $5kjCz = parcelRequire("5kjCz");


var $2bAZx = parcelRequire("2bAZx");

function $b23c2b4e39153eb4$export$3462df5a881e125d({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, mode: mode, name: name }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).succeed({
            name: name,
            attributes: attributes
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        mode,
        name
    ]);
    // https://stackoverflow.com/questions/54905376
    return children;
}
module.exports["MacroExperienceSuccess"] = $b23c2b4e39153eb4$export$3462df5a881e125d;

});

parcelRegister("lOeVN", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $8aF6s = parcelRequire("8aF6s");


var $jmjWc = parcelRequire("jmjWc");

function $926167cc1656a619$export$4be696be8a3bff13(props) {
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const propsRef = (0, $cozmU.useRef)();
    propsRef.current = props;
    return (0, $cozmU.useCallback)(()=>showModal($926167cc1656a619$var$FeedbackCollectorLoader, propsRef.current), [
        showModal
    ]);
}

const $926167cc1656a619$var$FeedbackCollectorLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "nSIir",
    name: "FeedbackCollectorLoader",
    loader: async ()=>(await (parcelRequire("5E8QK"))).FeedbackCollector
});
module.exports["useFeedbackCollector"] = $926167cc1656a619$export$4be696be8a3bff13;

});

parcelRegister("5E8QK", function(module, exports) {

let $41c78d93fde5dc21$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $41c78d93fde5dc21$var$load("4nZ85"),
    $41c78d93fde5dc21$var$load("hhss7"),
    $41c78d93fde5dc21$var$load("kHXvF"),
    $41c78d93fde5dc21$var$load("bUC6C")
]).then(()=>parcelRequire('cz7bE'));

});

parcelRegister("f9jv7", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $b29e4bf652226e80$export$6ccdb59d3479f4f1 = (error)=>(0, $aMcHK.isStatusCodeError)(error, '404');
module.exports["isNotFoundError"] = $b29e4bf652226e80$export$6ccdb59d3479f4f1;

});

parcelRegister("1SPMi", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3d3WW = parcelRequire("3d3WW");


var $iTJtk = parcelRequire("iTJtk");


var $hcnuR = parcelRequire("hcnuR");


var $bQm3c = parcelRequire("bQm3c");


var $1P7Cq = parcelRequire("1P7Cq");


var $2SowE = parcelRequire("2SowE");


var $8ld8H = parcelRequire("8ld8H");

const $c749b0358b0b3fb9$export$46da93e796378064 = (props)=>{
    const { objectId: objectId, objectType: objectType, children: children, source: source } = props;
    // setting default to development so in tests it doesn't fail due to being undefined
    const { environment: environment } = (0, $bQm3c.useSessionData)() || {};
    // setting default to development so in tests it doesn't fail due to being undefined
    const safeEnvironment = environment || 'DEVELOPMENT';
    const renderServerPlaceholder = (0, $1P7Cq.useIsSSROrHydrating)();
    const nonProductionBuildAnalyticsAttributes = (0, $cozmU.useMemo)(()=>(0, $hcnuR.getNonProductionBuildAnalyticsAttributes)(()=>renderServerPlaceholder ? undefined : (0, $8ld8H.getConfluenceNonProductionBuild)()), [
        renderServerPlaceholder
    ]);
    const handleEvent = (0, $cozmU.useCallback)((event)=>{
        const instanceName = safeEnvironment;
        event.update((payload)=>{
            let newPayload = (0, $2SowE.extendPayloadAttributes)(payload, {
                objectId: objectId,
                objectType: objectType,
                rendererSource: source
            });
            if (instanceName) newPayload = (0, $2SowE.extendPayloadAttributes)(newPayload, {
                instance: instanceName
            });
            if (nonProductionBuildAnalyticsAttributes.isNonProductionBuild !== undefined) newPayload = (0, $2SowE.extendPayloadAttributes)(newPayload, nonProductionBuildAnalyticsAttributes);
            return newPayload;
        });
    }, [
        safeEnvironment,
        objectId,
        objectType,
        source,
        nonProductionBuildAnalyticsAttributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
        onEvent: handleEvent,
        channel: (0, $iTJtk.FabricChannel).editor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
        onEvent: handleEvent,
        channel: (0, $iTJtk.FabricChannel).media
    }, children));
};
module.exports["RendererAnalyticsListener"] = $c749b0358b0b3fb9$export$46da93e796378064;

});

parcelRegister("iP9x4", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $2j0AL = parcelRequire("2j0AL");


var $8fBh8 = parcelRequire("8fBh8");


var $4h1jl = parcelRequire("4h1jl");


var $9wGTI = parcelRequire("9wGTI");


var $4IoVL = parcelRequire("4IoVL");

const $2c59df77bd212c3d$var$MEDIA_PROVIDER_UNAVAILABLE_ERROR = 'mediaProvider unavailable, must use initialAuth';
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
const $2c59df77bd212c3d$var$isServerEnvironment = ()=>undefined;
const $2c59df77bd212c3d$var$isClientEnvironment = ()=>window.__SSR_RENDERED__;
const $2c59df77bd212c3d$var$getInitialAuth = (config)=>{
    const recordedAuth = config.contentProduct === 'jira-work-item' ? (0, $4h1jl.jiraMediaConfigRecorder)?.get() : (0, $4h1jl.mediaConfigRecorder)?.get();
    if (!recordedAuth) return undefined;
    return {
        ...recordedAuth,
        // If the mediaToken is provided in the config, use it.
        // This ensures the correct token is used in cases where the token differs from
        // the initial page, such as media included through an `include` macro.
        token: config?.mediaToken || recordedAuth.token
    };
};
const $2c59df77bd212c3d$var$getInitialEnforceDataSecurityPolicy = ()=>{
    if (!(0, $9wGTI.fg)('dlp_attachment_download_respects_data_export_dsp')) return false;
    const shouldEnforceDataSecurityPolicy = (0, $4h1jl.mediaConfigEnforceDSPRecorder)?.get();
    return !!shouldEnforceDataSecurityPolicy;
};
const $2c59df77bd212c3d$var$getInitialSsrMediaItems = (mediaItems)=>{
    if (!Array.isArray(mediaItems) || mediaItems.length === 0) return undefined;
    return mediaItems;
};
const $2c59df77bd212c3d$var$getServerModeConfig = (config)=>({
        mode: 'server',
        config: {
            authProvider: ()=>Promise.reject(new Error($2c59df77bd212c3d$var$MEDIA_PROVIDER_UNAVAILABLE_ERROR)),
            initialAuth: $2c59df77bd212c3d$var$getInitialAuth(config),
            enforceDataSecurityPolicy: $2c59df77bd212c3d$var$getInitialEnforceDataSecurityPolicy()
        },
        ssrMediaItems: $2c59df77bd212c3d$var$getInitialSsrMediaItems((0, $8fBh8.getMediaNodes)())
    });
const $2c59df77bd212c3d$var$createClientAuthProvider = ({ contentAri: contentAri, contentId: contentId, contentProduct: contentProduct, spaceKey: spaceKey, isExternalShare: isExternalShare, mediaToken: mediaToken })=>async (authContext)=>{
        if (!!contentId && (!!spaceKey || contentProduct === 'jira-work-item')) {
            const { viewMediaClientConfig: viewMediaClientConfig } = await (0, $4IoVL.createRendererMediaProvider)({
                contentAri: contentAri,
                contentId: contentId,
                contentProduct: contentProduct,
                spaceKey: spaceKey,
                isExternalShare: isExternalShare,
                mediaToken: mediaToken
            });
            return viewMediaClientConfig.authProvider(authContext);
        } else throw new Error($2c59df77bd212c3d$var$MEDIA_PROVIDER_UNAVAILABLE_ERROR);
    };
const $2c59df77bd212c3d$var$getClientModeConfig = (config)=>({
        mode: 'client',
        config: {
            authProvider: $2c59df77bd212c3d$var$createClientAuthProvider(config),
            initialAuth: config.contentProduct === 'jira-work-item' ? window.__JIRA_MEDIA_CONFIG__ : window.__MEDIA_CONFIG__,
            enforceDataSecurityPolicy: window.__MEDIA_CONFIG_ENFORCE_DSP__
        },
        ssrMediaItems: $2c59df77bd212c3d$var$getInitialSsrMediaItems(window.__MEDIA_NODE_META_DATA__)
    });
const $2c59df77bd212c3d$var$getMediaSSRModeAndAuthConfig = (config)=>{
    if ($2c59df77bd212c3d$var$isServerEnvironment()) return $2c59df77bd212c3d$var$getServerModeConfig(config);
    else if ($2c59df77bd212c3d$var$isClientEnvironment()) return $2c59df77bd212c3d$var$getClientModeConfig(config);
};
const $2c59df77bd212c3d$export$85decadf1b9d641b = (0, $dOBRD.default)($2c59df77bd212c3d$var$getMediaSSRModeAndAuthConfig, (0, (/*@__PURE__*/$parcel$interopDefault($2j0AL))));
const $2c59df77bd212c3d$export$45c8e19bd67cadee = (config)=>{
    return $2c59df77bd212c3d$export$85decadf1b9d641b(config);
};
module.exports["getMediaSSRModeAndAuthConfigMemoized"] = $2c59df77bd212c3d$export$85decadf1b9d641b;
module.exports["useMediaSSRModeAndAuthConfig"] = $2c59df77bd212c3d$export$45c8e19bd67cadee;

});

parcelRegister("8fBh8", function(module, exports) {
/**
 * A simple module-level singleton used to hand media node metadata from the
 * SSR data-preload phase to the render phase.
 *
 * During SSR, Confluence preloads media node metadata and
 * records it here via {@link setMediaNodes}. It is later read via
 * {@link getMediaNodes} both by the product's render pipeline and by platform
 * consumers such as `@atlaskit/media-file-preview`.
 *
 * This lives in `@atlaskit/media-common` (rather than a product package) so that
 * both product code and platform packages can share the exact same singleton
 * instance without platform depending on a product package.
 */ let $b78ae25b6276049e$var$mediaNodes = null;
const $b78ae25b6276049e$export$cfabe671d3a31c35 = (nodes)=>{
    $b78ae25b6276049e$var$mediaNodes = nodes;
};
const $b78ae25b6276049e$export$684919eb15443d6b = ()=>$b78ae25b6276049e$var$mediaNodes;
const $b78ae25b6276049e$export$d55d7b4fc145db9 = ()=>{
    $b78ae25b6276049e$var$mediaNodes = null;
};
module.exports["getMediaNodes"] = $b78ae25b6276049e$export$684919eb15443d6b;

});

parcelRegister("4h1jl", function(module, exports) {

var $2BiLx = parcelRequire("2BiLx");

const $c75b7ce9b9db2aec$export$279f2f878f49d0df = new (0, $2BiLx.ObjectRecorder)();
const $c75b7ce9b9db2aec$export$269fe681eda28e68 = new (0, $2BiLx.ObjectRecorder)();
const $c75b7ce9b9db2aec$export$e125b144e38aa5db = new (0, $2BiLx.ObjectRecorder)();
module.exports["mediaConfigRecorder"] = $c75b7ce9b9db2aec$export$279f2f878f49d0df;
module.exports["jiraMediaConfigRecorder"] = $c75b7ce9b9db2aec$export$269fe681eda28e68;
module.exports["mediaConfigEnforceDSPRecorder"] = $c75b7ce9b9db2aec$export$e125b144e38aa5db;

});

parcelRegister("2BiLx", function(module, exports) {
class $53dcea44a491523c$export$e411414ea02dd271 {
    set(object) {
        this.object = object;
    }
    get() {
        return this.object;
    }
    reset() {
        this.object = null;
    }
    constructor(){
        this.object = null;
    }
}
module.exports["ObjectRecorder"] = $53dcea44a491523c$export$e411414ea02dd271;

});

parcelRegister("7EIq6", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $dd33Q = parcelRequire("dd33Q");


var $9Pmcg = parcelRequire("9Pmcg");


var $6SsN4 = parcelRequire("6SsN4");


var $jtuBN = parcelRequire("jtuBN");


var $iLgzu = parcelRequire("iLgzu");

const $649b778bbd82b1bb$var$spaceEnabledContentTypesFragment = (0, $9Pmcg.default);
function $649b778bbd82b1bb$export$67a7293b6dfe9c76(spaceFragmentRef) {
    const $ = (0, $bDgLe.c)(2);
    const space = (0, $6SsN4.useFragment)($649b778bbd82b1bb$var$spaceEnabledContentTypesFragment, spaceFragmentRef);
    const t0 = space.spaceTypeSettings?.enabledContentTypes;
    let t1;
    if ($[0] !== t0) {
        t1 = $649b778bbd82b1bb$var$getEnabledContentTypes(t0, false);
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
}
const $649b778bbd82b1bb$var$useSpaceEnabledContentTypesQuery = (0, $dd33Q.default);
function $649b778bbd82b1bb$export$1defcb29347f9ac6(spaceKey) {
    const { data: defaultSpaceKeyData, loading: isDefaultSpaceKeyLoading } = (0, $iLgzu.useExperimentalPromotedSpacesQuery)({
        skip: spaceKey !== undefined,
        variables: {
            promotedSpacesLimit: 1,
            otherSpacesLimit: 1,
            promotedSpaceKey: null
        }
    });
    const spaceEnabledContentTypesQueryOptions = {
        errorPolicy: 'all',
        skip: !spaceKey && !defaultSpaceKeyData,
        variables: {
            spaceKey: spaceKey || defaultSpaceKeyData?.experimentalPromotedSpaces?.nodes?.[0]?.id
        }
    };
    const { data: enabledContentTypesData, loading: isAnyContentTypesLoading } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)($649b778bbd82b1bb$var$useSpaceEnabledContentTypesQuery, {
        ...spaceEnabledContentTypesQueryOptions,
        __callerPackage__: "create-blank-fabric-page"
    });
    const enabledContentTypes = enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes;
    return $649b778bbd82b1bb$var$getEnabledContentTypes(enabledContentTypes, isDefaultSpaceKeyLoading || isAnyContentTypesLoading);
}
function $649b778bbd82b1bb$var$getEnabledContentTypes(enabledContentTypes, loading) {
    const hasUndefinedContentTypes = enabledContentTypes === undefined || Object.values(enabledContentTypes).some((type)=>type === undefined);
    const isLoading = loading || hasUndefinedContentTypes;
    return {
        isCreateWhiteboardEnabled: Boolean(enabledContentTypes?.isWhiteboardsEnabled),
        isCreateBlogEnabled: Boolean(enabledContentTypes?.isBlogsEnabled),
        isCreateDatabaseEnabled: Boolean(enabledContentTypes?.isDatabasesEnabled),
        isCreateSmartLinkEnabled: Boolean(enabledContentTypes?.isEmbedsEnabled),
        isCreateLiveDocEnabled: Boolean(enabledContentTypes?.isLivePagesEnabled),
        isCreateFolderEnabled: Boolean(enabledContentTypes?.isFoldersEnabled),
        isCreateSlidesEnabled: Boolean(enabledContentTypes?.isSlidesEnabled),
        isLoading: isLoading
    };
}
module.exports["useSpaceEnabledContentTypesFragment"] = $649b778bbd82b1bb$export$67a7293b6dfe9c76;
module.exports["useSpaceEnabledContentTypes"] = $649b778bbd82b1bb$export$1defcb29347f9ac6;

});

parcelRegister("9Pmcg", function(module, exports) {
/**
 * @generated SignedSource<<6a622c3ccbbe286fe0564af388855ebd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e1a2866ab6e1d474$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useSpaceEnabledContentTypes_space",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "concreteType": "SpaceTypeSettings",
            "kind": "LinkedField",
            "name": "spaceTypeSettings",
            "plural": false,
            "selections": [
                {
                    "concreteType": "EnabledContentTypes",
                    "kind": "LinkedField",
                    "name": "enabledContentTypes",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isBlogsEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isDatabasesEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isEmbedsEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isLivePagesEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isSlidesEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isWhiteboardsEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isFoldersEnabled"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Space"
};
$e1a2866ab6e1d474$var$node.hash = "b4c0be9fdc8089ef19cf4d9ec776f16e";
var $e1a2866ab6e1d474$export$2e2bcd8739ae039 = $e1a2866ab6e1d474$var$node;
module.exports["default"] = $e1a2866ab6e1d474$export$2e2bcd8739ae039;

});

parcelRegister("iLgzu", function(module, exports) {

var $jaPWl = parcelRequire("jaPWl");


var $dK51B = parcelRequire("dK51B");

const $e671a111e943b77f$export$409ac92b3aba27f5 = ({ skip: skip, onError: onError, variables: variables = {}, fetchPolicy: fetchPolicy } = {})=>{
    const promotedSpacesLimit = variables.promotedSpacesLimit || 10;
    const otherSpacesLimit = variables.otherSpacesLimit || 10;
    const promotedSpaceKey = variables.promotedSpaceKey || '';
    return (0, $dK51B.useExperimentalQuery)({
        url: `/wiki/rest/create-dialog/1.0/spaces?promotedSpacesLimit=${promotedSpacesLimit}&otherSpacesLimit=${otherSpacesLimit}&promotedSpaceKey=${promotedSpaceKey}`,
        method: 'GET',
        headers: {
            'Content-Type': (0, $jaPWl.MediaType).JSON
        },
        parseResult: (json)=>{
            const matchedPromotedSpaces = json.matchedPromotedSpaces && json.matchedPromotedSpaces.spaces || [];
            const nodes = (json.promotedSpaces && json.promotedSpaces.spaces || []).concat(json.otherSpaces && json.otherSpaces.spaces || []);
            return {
                experimentalPromotedSpaces: {
                    nodes: nodes,
                    matchedPromotedSpaces: matchedPromotedSpaces,
                    __typename: 'ExperimentalPromotedSpaces'
                }
            };
        },
        skip: skip,
        onError: onError,
        variables: variables,
        fetchPolicy: fetchPolicy
    });
};
module.exports["useExperimentalPromotedSpacesQuery"] = $e671a111e943b77f$export$409ac92b3aba27f5;

});

parcelRegister("jaPWl", function(module, exports) {
var $5e96abf23293f6d5$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["JSON"] = "application/json";
    MediaType["X_WWW_FORM_URLENCODED"] = "application/x-www-form-urlencoded";
    return MediaType;
}({});
module.exports["MediaType"] = $5e96abf23293f6d5$export$483c11740a902fcd;

});

parcelRegister("kDja4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dUvcQ = parcelRequire("dUvcQ");


var $9wGTI = parcelRequire("9wGTI");


var $yuLaV = parcelRequire("yuLaV");

// These flags are no longer used in confluence and can be removed from this array entirely after we confirm that have been removed from the whiteboards side too
const $9cbb170f29556407$var$ARCHIVED_FEATURE_FLAGS = [
    'headerV1',
    'headerV2',
    'whiteboardArchive',
    'removeWhiteboardsHome',
    'removeWhiteboardsHomeInSideNav',
    'whiteboardCreation',
    'whiteboardsEnabled',
    'whiteboardBifrost',
    'whiteboardVersionHistory'
];
const $9cbb170f29556407$export$6f83cfa4fd660300 = ()=>{
    const isWhiteboardsEnabledInEnv = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('whiteboard');
    const isWhiteboardFeatureEnabled = (0, $cozmU.useCallback)((featureName)=>{
        if (featureName === 'whiteboardsEnabled') return isWhiteboardsEnabledInEnv;
        // If the FF has been cleaned up on our end just return true
        if ($9cbb170f29556407$var$ARCHIVED_FEATURE_FLAGS.some((feature)=>feature === featureName)) return true;
        // Use static feature gate calls to satisfy confluence-feature-gating/static-feature-gates
        switch(featureName){
            case 'whiteboardSolidHeader':
                return (0, $9wGTI.fg)('confluence_frontend_solid_whiteboard_header');
            case 'whiteboardOptOut':
                return (0, $9wGTI.fg)('whiteboards_compliance_opt_out');
            case 'digitalTeammate':
                return (0, $9wGTI.fg)('cc-ai-whiteboards-enable-digital-teammate');
            case 'aiFirstCreation':
                return true;
            default:
                return false;
        }
    }, [
        isWhiteboardsEnabledInEnv
    ]);
    const isWhiteboardCreationDropdownEnabled = (0, $cozmU.useCallback)(()=>{
        return isWhiteboardFeatureEnabled('whiteboardsEnabled') && !isWhiteboardFeatureEnabled('whiteboardOptOut');
    }, [
        isWhiteboardFeatureEnabled
    ]);
    const isWhiteboardGAOnboardingEnabled = (0, $cozmU.useCallback)(()=>{
        return isWhiteboardFeatureEnabled('whiteboardsEnabled') && !isWhiteboardFeatureEnabled('whiteboardOptOut');
    }, [
        isWhiteboardFeatureEnabled
    ]);
    return {
        platformFeatureFlagResolver: (0, $dUvcQ.getBooleanFF),
        isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled,
        isWhiteboardCreationDropdownEnabled: isWhiteboardCreationDropdownEnabled,
        isWhiteboardGAOnboardingEnabled: isWhiteboardGAOnboardingEnabled
    };
};
module.exports["useIsWhiteboardFeatureEnabled"] = $9cbb170f29556407$export$6f83cfa4fd660300;

});

parcelRegister("dUvcQ", function(module, exports) {

var $7FQjS = parcelRequire("7FQjS");

function $c3d67b941c4ebe95$export$470e5c2be1411c89(name) {
    return (0, $7FQjS.resolveBooleanFlag)(name);
}
module.exports["getBooleanFF"] = $c3d67b941c4ebe95$export$470e5c2be1411c89;

});

parcelRegister("eVXGa", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $1337beb96693807c$var$isAllowedToCreate = (accessStatus)=>accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
const $1337beb96693807c$export$1060ff57674ca8ef = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $1337beb96693807c$var$isAllowedToCreate(accessStatus);
};
module.exports["useIsAllowedToCreateWhiteboard"] = $1337beb96693807c$export$1060ff57674ca8ef;

});

parcelRegister("8a9Dm", function(module, exports) {
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$var$isMigratedFromConnect = (app)=>{
    if (!app.properties) return false;
    const props = app.properties;
    return props.migratedFromConnect === true || props.migratedFromConnect === 'true';
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    if ($2cc1b73219e08564$var$isMigratedFromConnect(app) && app.migrationKey) return `ac:${app.migrationKey}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("2Zz3q", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $g4vf3 = parcelRequire("g4vf3");

function $9d9e360fdbb0177e$export$954628993bf3188e(timeLeft) {
    if (timeLeft === null || timeLeft === undefined) return undefined;
    if (timeLeft <= 0) return 0;
    // Use Math.ceil to round up for fractional days
    return Math.ceil(timeLeft / (0, $g4vf3.MILLISECONDS_IN_A_DAY));
}
function $9d9e360fdbb0177e$export$165abb069513be0e(trialEndTime) {
    if (trialEndTime === null || trialEndTime === undefined) return undefined;
    return $9d9e360fdbb0177e$export$954628993bf3188e(trialEndTime - Date.now());
}
function $9d9e360fdbb0177e$export$bc3e0c760835aa1e(trialEndTime) {
    return (0, $cozmU.useMemo)(()=>$9d9e360fdbb0177e$export$165abb069513be0e(trialEndTime), [
        trialEndTime
    ]);
}
function $9d9e360fdbb0177e$export$ee6c4faab08346c(trialEndDate) {
    if (trialEndDate === null || trialEndDate === undefined) return undefined;
    // The expected format is YYYY-MM-DD, which is treated as UTC by the JS Date constructor
    return $9d9e360fdbb0177e$export$954628993bf3188e(new Date(trialEndDate).getTime() - Date.now());
}
function $9d9e360fdbb0177e$export$f13e974fb2ad4415(trialEndDate) {
    return (0, $cozmU.useMemo)(()=>$9d9e360fdbb0177e$export$ee6c4faab08346c(trialEndDate), [
        trialEndDate
    ]);
}
module.exports["getTrialDaysLeft"] = $9d9e360fdbb0177e$export$954628993bf3188e;
module.exports["getTrialDaysLeftFromTrialEndDate"] = $9d9e360fdbb0177e$export$ee6c4faab08346c;

});

parcelRegister("g4vf3", function(module, exports) {
const $d163a47e1480b111$export$98a7370239de6730 = 86400000;
module.exports["MILLISECONDS_IN_A_DAY"] = $d163a47e1480b111$export$98a7370239de6730;

});

parcelRegister("wtSEP", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $251dbde4d6244b59$export$271f9f08425019c7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "pM5to",
    name: "NotFound",
    loader: async ()=>// eslint-disable-next-line
        (await (parcelRequire("8QtAd"))).NotFound
});
module.exports["NotFound"] = $251dbde4d6244b59$export$271f9f08425019c7;

});

parcelRegister("8QtAd", function(module, exports) {

let $670a20a4fbd43a07$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $670a20a4fbd43a07$var$load("h0X0x"),
    $670a20a4fbd43a07$var$load("7l4Nc"),
    $670a20a4fbd43a07$var$load("85Ack"),
    $670a20a4fbd43a07$var$load("k0Z8C"),
    $670a20a4fbd43a07$var$load("hhss7"),
    $670a20a4fbd43a07$var$load("7EorR"),
    $670a20a4fbd43a07$var$load("gEi5K")
]).then(()=>parcelRequire('3nvKi'));

});

parcelRegister("lLRfG", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $gXfti = parcelRequire("gXfti");


var $78QFu = parcelRequire("78QFu");


var $7sK8i = parcelRequire("7sK8i");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $6VdZc = parcelRequire("6VdZc");


var $4XtQK = parcelRequire("4XtQK");


var $2O7Qv = parcelRequire("2O7Qv");

const $4291167636037428$var$PageLoadEndComponent = /*#__PURE__*/ (0, $cozmU.memo)(({ metric: metric, customData: customData = {}, stopTime: stopTime })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const hasFiredRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (hasFiredRef.current) return;
        hasFiredRef.current = true;
        if (metric) (0, $2O7Qv.addCustomTimingForMetric)(metric.key);
        (0, $gXfti.addUFOCustomData)({
            ...customData,
            ...typeof stopTime === 'number' ? {
                stopTime: stopTime
            } : {},
            previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
            pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
        });
        (0, $7sK8i.resumeLowPriorityEvents)();
    // Not adding exhaustive dependencies because we want this to fire only once,
    // despite any changes to `customData`
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        metric
    ]);
    (0, $4XtQK.reportHydrationError)(createAnalyticsEvent, metric?.key);
    return null;
});
const $4291167636037428$export$570dec5b65c6715b = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($4291167636037428$var$PageLoadEndComponent);
module.exports["PageLoadEnd"] = $4291167636037428$export$570dec5b65c6715b;

});

parcelRegister("4XtQK", function(module, exports) {

var $5ZqQS = parcelRequire("5ZqQS");


var $dtDUi = parcelRequire("dtDUi");


var $6mKj3 = parcelRequire("6mKj3");

function $433efe87b2d05424$export$e885a680acb7d12e(createAnalyticsEvent, metricKey) {
    if (!(window?.__SSR_RENDERED__ && Boolean(window.__HYDRATION_FAILED__))) return;
    const { error: errorWithRoute, route: route } = (0, $dtDUi.getHydrationErrorWithRoute)(window.location.toString());
    const attribution = window.__SSR_REACT_STREAMING__ ? 'streaming-hydration' : 'hydration';
    if ((0, $6mKj3.expVal)('confluence_frontend_hydration_failure_reporting', 'isEnabled', false)) createAnalyticsEvent((0, $dtDUi.getHydrationFailureOperationalEvent)({
        source: `PageLoadEnd - ${metricKey}`,
        route: route,
        errorWithRoute: errorWithRoute,
        isSSRReactStreaming: Boolean(window.__SSR_REACT_STREAMING__)
    })).fire();
    else (0, $5ZqQS.getMonitoringClient)().submitError(errorWithRoute, {
        attribution: attribution
    });
}
module.exports["reportHydrationError"] = $433efe87b2d05424$export$e885a680acb7d12e;

});

parcelRegister("jEeDd", function(module, exports) {

var $6LNuT = parcelRequire("6LNuT");


var $jH9cM = parcelRequire("jH9cM");


var $i3S9F = parcelRequire("i3S9F");


var $9wGTI = parcelRequire("9wGTI");


var $6X8o4 = parcelRequire("6X8o4");


var $ge2sX = parcelRequire("ge2sX");

function $2dd269c5e0cf48e9$export$264b5fa7ee2d3260(continueUrl) {
    const identity = $2dd269c5e0cf48e9$var$getIdentity();
    if (typeof continueUrl === 'function') continueUrl = continueUrl(identity);
    if (!continueUrl) continueUrl = window.location.href; // eslint-disable-line no-restricted-syntax
    return `https://${identity}/login?application=confluence&continue=${encodeURIComponent(continueUrl)}`;
}
function $2dd269c5e0cf48e9$var$getIdentity() {
    let identity;
    const DEFAULT_PRODUCTION = 'id.atlassian.com';
    const DEFAULT_STAGING = 'id.stg.internal.atlassian.com';
    // 2. Fall back to the frontend build environment:
    if (!identity) identity = "id.atlassian.com";
    if (!identity && (0, $jH9cM.isFedRamp)()) {
        const isStagingFed = false;
        identity = isStagingFed ? 'id.stg.atlassian-us-gov-mod.com' : 'id.atlassian-us-gov-mod.com';
    }
    // 3. Fall back to the backend runtime environment:
    if (!identity) {
        // Turning getLoginLink into a hook would add the complexity of skipability.
        // Given that (a) we're implementing a fallback here and (b) the frontend
        // app figures out whether login is necessary by looking at session data,
        // the backend runtime environment will very likely be known already.
        const environment = (0, $6X8o4.getValue)((0, $ge2sX.getSessionData)())?.environment;
        identity = environment === 'PRODUCTION' ? DEFAULT_PRODUCTION : DEFAULT_STAGING;
    }
    if (!(0, $i3S9F.isIsolatedCloud)() || !(0, $9wGTI.fg)('confluence_ic_custom_domain_links')) return identity;
    // IC domains are derived from runtime perimeter context; the environment
    // argument only affects non-IC resolution.
    return (0, $6LNuT.getDomainInContext)('id', 'prod') ?? identity;
}
module.exports["getLoginLink"] = $2dd269c5e0cf48e9$export$264b5fa7ee2d3260;

});

parcelRegister("hpRYU", function(module, exports) {

var $1dUJk = parcelRequire("1dUJk");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kfLla = parcelRequire("kfLla");


var $l9ukq = parcelRequire("l9ukq");


var $24tIi = parcelRequire("24tIi");


var $bQm3c = parcelRequire("bQm3c");


var $iMnC5 = parcelRequire("iMnC5");


var $b3j2Y = parcelRequire("b3j2Y");


var $7lu50 = parcelRequire("7lu50");


var $7Sm4c = parcelRequire("7Sm4c");


var $83Z6R = parcelRequire("83Z6R");


var $jjoF2 = parcelRequire("jjoF2");


var $VQdE0 = parcelRequire("VQdE0");


var $g3p2i = parcelRequire("g3p2i");


var $jMyy4 = parcelRequire("jMyy4");

const $4cbf051190fe8573$var$MIN_SEARCH_LENGTH = 2;
const $4cbf051190fe8573$export$1434adfffc17371d = 200;
const $4cbf051190fe8573$var$withoutAriaLabelledBy = (props)=>{
    const { 'aria-labelledby': _ariaLabelledBy, ...inputProps } = props;
    return inputProps;
};
const $4cbf051190fe8573$var$LabelledInput = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).Input, $4cbf051190fe8573$var$withoutAriaLabelledBy(props));
const $4cbf051190fe8573$var$wrapWithLabelledInput = (InputComponent)=>{
    const WrappedLabelledInput = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(InputComponent, $4cbf051190fe8573$var$withoutAriaLabelledBy(props));
    return WrappedLabelledInput;
};
const $4cbf051190fe8573$var$getLabelledComponents = (components)=>{
    return {
        ...components,
        Input: components?.Input ? $4cbf051190fe8573$var$wrapWithLabelledInput(components.Input) : $4cbf051190fe8573$var$LabelledInput
    };
};
function $4cbf051190fe8573$export$e11674744930cd15(error) {
    if ('statusCode' in error && error['statusCode'] === 403 || error.message?.includes('403') || error.message?.includes('not allowed')) return true;
    return false;
}
const $4cbf051190fe8573$var$DefaultWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, children);
const $4cbf051190fe8573$export$fd4159eb872f73c6 = ({ appearance: appearance, fieldId: fieldId, isMulti: isMulti, includeGroup: includeGroup, onSelect: onSelect, onChange: onChange, onClear: onClear, onFocus: onFocus, onBlur: onBlur, onOpen: onOpen, onClose: onClose, onInputChange: onInputChange, onKeyDown: onKeyDown, filterSearchResults: filterSearchResults, smartFilterOptions: smartFilterOptions, value: value, defaultValue: defaultValue, noOptionsMessage: noOptionsMessage, addMoreMessage: addMoreMessage, menuPortalTarget: menuPortalTarget, autoFocus: autoFocus, width: width, maxPickerHeight: maxPickerHeight, smart: smart, styles: styles, placeholder: placeholder, sitePermissionTypeFilter: sitePermissionTypeFilter = (0, $g3p2i.SitePermissionTypeFilter).NONE, displayEmailInByline: displayEmailInByline, allowEmail: allowEmail, suggestEmailsForDomain: suggestEmailsForDomain, enableEmailSearch: enableEmailSearch, allowEmailSelectionWhenEmailMatched: allowEmailSelectionWhenEmailMatched, includeTeams: includeTeams, includeTeamsUpdates: includeTeamsUpdates, verifiedTeams: verifiedTeams, menuPosition: menuPosition, customInclusion: customInclusion = [], ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, 'aria-labelledby': ariaLabelledByFromField, ariaDescribedBy: ariaDescribedBy, role: role, isDisabled: isDisabled = false, isLoading: isLoading = false, bootstrapOptions: bootstrapOptions = [], inputId: inputId, withUsers: withUsers = true, Wrapper: Wrapper = $4cbf051190fe8573$var$DefaultWrapper, header: header, open: open, userpickerDescribedbyId: userpickerDescribedbyId, isClearable: isClearable = true, includeUsers: includeUsers = true, transformOptions: transformOptions, userResolvers: userResolvers, components: components, isHeaderFocused: isHeaderFocused, setIsHeaderFocused: setIsHeaderFocused })=>{
    const [error, setError] = (0, $cozmU.useState)(undefined);
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const queryUserAndGroupSearch = (0, $83Z6R.useLazyQueryPromiseInterop)((0, $VQdE0.default), {
        __callerPackage__: "user-and-group-search"
    });
    const { loading: searchPickerLoading, data: searchPickerData } = (0, $jMyy4.useQueryInterop)((0, $1dUJk.default), {
        __callerPackage__: "user-and-group-search"
    });
    const handleError = (searchError)=>{
        if (searchError) {
            setError(searchError);
            // mark error as handled so we don't have ui unhandled errors
            (0, $7Sm4c.markErrorAsHandled)(searchError);
        }
    };
    const promiseOptions = (searchTerm)=>!searchTerm || searchTerm.length < $4cbf051190fe8573$var$MIN_SEARCH_LENGTH ? [] : (0, $jjoF2.userGroupSearchPromise)({
            searchTerm: searchTerm,
            queryData: queryUserAndGroupSearch({
                variables: {
                    withGroups: includeGroup,
                    searchTerm: searchTerm,
                    sitePermissionTypeFilter: sitePermissionTypeFilter,
                    withUsers: withUsers
                }
            }),
            customInclusion: customInclusion,
            setError: setError,
            filterResults: filterSearchResults
        });
    const searchErrorMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "user-and-group-search.search.error",
        defaultMessage: "Sorry, we\u2019re having trouble loading search results right now."
    });
    const permissionErrorMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "user-and-group-search.permission.error",
        defaultMessage: "We couldn\u2019t find any results because you don't have permission to search the user directory."
    });
    // TODO: <UserPicker> expects `noOptionsMessage` to return string | null
    // but this callback returns JSX.Element | string | null, so error message must be string.
    const emptyResultsMessage = (input)=>{
        if (error) {
            if ($4cbf051190fe8573$export$e11674744930cd15(error)) return permissionErrorMessage;
            return searchErrorMessage;
        } else if (typeof noOptionsMessage === 'function') return noOptionsMessage(input);
        return noOptionsMessage;
    };
    const isEntitledExternalCollaboration = (0, $7lu50.getExternalCollaboratorEntitlementFromQuery)(searchPickerData) ?? false;
    const finalPlaceholder = placeholder || (includeGroup ? allowEmail ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "user-and-group-search.placeholder.text.users.groups.and.email",
        defaultMessage: "Add people by name, email, or group"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "user-and-group-search.placeholder.text.users.and.groups",
        // TODO: a content designer should check this case. This isn't the usual sentence structure for placeholders.
        defaultMessage: "Type a user name or group"
    }) : allowEmail ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "user-and-group-search.placeholder.text.users.and.email",
        defaultMessage: "Add people, emails"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "user-and-group-search.placeholder.text.users",
        // TODO: a content designer should check this case. This isn't the usual sentence structure for placeholders.
        defaultMessage: "Type a user name"
    }));
    const pickerAriaLabelledBy = ariaLabel ? undefined : ariaLabelledBy || ariaLabelledByFromField || `react-select-${fieldId}-placeholder`;
    const pickerComponents = (0, $cozmU.useMemo)(()=>ariaLabel ? $4cbf051190fe8573$var$getLabelledComponents(components) : components, [
        ariaLabel,
        components
    ]);
    const commonProps = {
        appearance: appearance,
        placeholder: finalPlaceholder,
        addMoreMessage: addMoreMessage,
        isMulti: isMulti,
        defaultValue: defaultValue,
        fieldId: fieldId,
        menuPortalTarget: menuPortalTarget,
        noOptionsMessage: emptyResultsMessage,
        onChange: onChange,
        onClear: onClear,
        onFocus: onFocus,
        onOpen: onOpen,
        onClose: onClose,
        onInputChange: onInputChange,
        onSelection: onSelect,
        value: value,
        width: width,
        maxPickerHeight: maxPickerHeight,
        displayEmailInByline: displayEmailInByline,
        allowEmail: allowEmail,
        suggestEmailsForDomain: suggestEmailsForDomain,
        enableEmailSearch: enableEmailSearch,
        allowEmailSelectionWhenEmailMatched: allowEmailSelectionWhenEmailMatched,
        styles: styles,
        menuPosition: menuPosition,
        isDisabled: isDisabled,
        inputId: inputId,
        components: pickerComponents,
        withUsers: // Type assertion: runtime receives Option, but UserPicker types expect OptionData
        withUsers,
        header: header,
        open: open,
        ariaLabel: ariaLabel,
        ariaLabelledBy: pickerAriaLabelledBy,
        'aria-describedby': userpickerDescribedbyId,
        isHeaderFocused: isHeaderFocused,
        setIsHeaderFocused: setIsHeaderFocused
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Wrapper, {
        "aria-label": ariaLabel,
        "aria-describedby": ariaDescribedBy,
        role: role
    }, error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }) : null, !smart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kfLla.UserPicker), {
        ...commonProps,
        inputId: inputId,
        autoFocus: autoFocus,
        loadOptions: promiseOptions,
        // bug with UserPicker forces us to use a callback rather than just pass in a string
        onBlur: onBlur,
        isLoading: isLoading,
        appearance: appearance,
        isClearable: isClearable
    }), smart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $24tIi.default), {
        ...commonProps,
        inputId: inputId,
        debounceTime: $4cbf051190fe8573$export$1434adfffc17371d,
        includeGroups: includeGroup,
        includeUsers: includeUsers,
        isLoading: searchPickerLoading || isLoading,
        maxOptions: 60,
        onError: handleError,
        filterOptions: smartFilterOptions,
        productAttributes: {
            isEntitledConfluenceExternalCollaborator: isEntitledExternalCollaboration
        },
        principalId: "context",
        productKey: "confluence",
        autoFocus: autoFocus,
        siteId: cloudId,
        orgId: orgId,
        includeTeams: includeTeams,
        includeTeamsUpdates: includeTeamsUpdates,
        verifiedTeams: verifiedTeams,
        bootstrapOptions: bootstrapOptions,
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        isClearable: isClearable,
        transformOptions: transformOptions,
        userResolvers: userResolvers,
        displayEmailInByline: true,
        enableEmailSearch: true,
        allowEmailSelectionWhenEmailMatched: false,
        isTeamSyncedToGroupDirectoryFilter: true
    }));
};
const $4cbf051190fe8573$export$ca514d5352bb0171 = $4cbf051190fe8573$export$fd4159eb872f73c6;
module.exports["UserAndGroupSearchPicker"] = $4cbf051190fe8573$export$ca514d5352bb0171;

});

parcelRegister("1dUJk", function(module, exports) {
/**
 * @generated SignedSource<<b63c5c1bb2388ba01c0f335df08966f1>>
 * @relayHash 55f887ce338962f3d231967eb05baaf5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f5f3ec7358095a4d557e0d2edf4c5f6fa4971b5401acfcdacb83cc07f551b55a
const $a7eff2b640cdd5ac$var$node = function() {
    var v0 = [
        {
            "concreteType": "Entitlements",
            "kind": "LinkedField",
            "name": "entitlements",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ExternalCollaboratorFeature",
                    "kind": "LinkedField",
                    "name": "externalCollaborator",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEntitled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "UserAndGroupSearchPickerQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "UserAndGroupSearchPickerQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "55f887ce338962f3d231967eb05baaf5",
            "id": "f5f3ec7358095a4d557e0d2edf4c5f6fa4971b5401acfcdacb83cc07f551b55a",
            "metadata": {},
            "name": "UserAndGroupSearchPickerQuery",
            "operationKind": "query",
            "text": "query UserAndGroupSearchPickerQuery{entitlements{externalCollaborator{isEntitled}}}"
        }
    };
}();
$a7eff2b640cdd5ac$var$node.hash = "6fe67cddff8056d8e38840c5214712ee";
var $a7eff2b640cdd5ac$export$2e2bcd8739ae039 = $a7eff2b640cdd5ac$var$node;
module.exports["default"] = $a7eff2b640cdd5ac$export$2e2bcd8739ae039;

});

parcelRegister("jjoF2", function(module, exports) {

var $9fywD = parcelRequire("9fywD");


var $11dKl = parcelRequire("11dKl");


var $9eE57 = parcelRequire("9eE57");


var $g3p2i = parcelRequire("g3p2i");

const $9d3a4572140e810a$export$c139484855007019 = ({ searchTerm: searchTerm, queryData: queryData, customInclusion: customInclusion, setError: setError, filterResults: filterResults })=>{
    const subject = 'userAndGroupSearchQuery';
    (0, $9eE57.perfMarkStart)({
        subject: subject
    });
    return queryData.then((data)=>{
        const { users: users = [], groups: groups = [] } = data.userGroupSearch ?? {};
        const userList = users.map((item)=>({
                id: `user-${item && 'accountId' in item ? item.accountId : ''}`,
                name: item?.displayName || '',
                extra: item,
                type: 'user',
                avatarUrl: item?.profilePicture ? item.profilePicture.path : '',
                lozenge: // ExternalUserLozengeProps type has same name as the one provided by @atlaskit/user-picker but different properties.
                // casting for now to avoid TS error, no change to original properties
                item?.permissionType === (0, $g3p2i.SitePermissionType).EXTERNAL ? (0, $9fywD.ExternalUserLozengeProps) : null
            }));
        const groupList = groups.map((item)=>({
                id: `group-${item?.id}`,
                name: item?.name || '',
                type: 'group',
                extra: item,
                lozenge: // ExternalUserLozengeProps type has same name as the one provided by @atlaskit/user-picker but different properties.
                // casting for now to avoid TS error, no change to original properties
                item?.permissionType === (0, $g3p2i.SitePermissionType).EXTERNAL ? (0, $11dKl.ExternalGroupLozengeProps) : null
            }));
        const customInclusionList = [];
        const cleanedSearchTerm = searchTerm.replace(/\s/g, '').toLowerCase();
        customInclusion.forEach((inclusionObj)=>{
            Object.keys(inclusionObj).forEach((key)=>{
                if (key.toLowerCase().includes(cleanedSearchTerm)) customInclusionList.push(inclusionObj[key]);
            });
        });
        const usersGroupsAndAccessClasses = [
            ...customInclusionList,
            ...userList,
            ...groupList
        ];
        (0, $9eE57.perfMarkEnd)({
            subject: subject
        });
        return filterResults ? usersGroupsAndAccessClasses.filter(filterResults) : usersGroupsAndAccessClasses;
    }).catch((error)=>{
        setError(error);
        return [];
    });
};
module.exports["userGroupSearchPromise"] = $9d3a4572140e810a$export$c139484855007019;

});

parcelRegister("11dKl", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9KSWX = parcelRequire("9KSWX");


var $lpNn5 = parcelRequire("lpNn5");

const $f9006b515271a00f$var$i18n = (0, $kSwu1.defineMessages)({
    externalGroupLozengeText: {
        id: "external-collab-ui.group-guest-lozenge",
        defaultMessage: "Guest"
    },
    externalGroupTooltip: {
        id: "external-collab-ui.group-guest-lozenge.tooltip",
        defaultMessage: "Guest groups can only access certain spaces and have limited access to user info."
    }
});
const $f9006b515271a00f$export$fef38ba78dbe85a6 = {
    text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $f9006b515271a00f$var$i18n.externalGroupTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $f9006b515271a00f$var$i18n.externalGroupLozengeText)),
    appearance: 'new',
    isBold: false
};
const $f9006b515271a00f$export$e899659b70340bcf = ()=>{
    const { text: text, appearance: appearance, isBold: isBold } = $f9006b515271a00f$export$fef38ba78dbe85a6;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        appearance: appearance,
        isBold: isBold
    }, text);
};
module.exports["ExternalGroupLozengeProps"] = $f9006b515271a00f$export$fef38ba78dbe85a6;

});

parcelRegister("g3p2i", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $fc6a2e7c662c45f6$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
var $fc6a2e7c662c45f6$export$3347a7c058a0368a = /*#__PURE__*/ function(SitePermissionTypeFilter) {
    SitePermissionTypeFilter["ALL"] = "ALL";
    SitePermissionTypeFilter["EXTERNALCOLLABORATOR"] = "EXTERNALCOLLABORATOR";
    SitePermissionTypeFilter["NONE"] = "NONE";
    return SitePermissionTypeFilter;
}({});
module.exports["SitePermissionType"] = $fc6a2e7c662c45f6$export$8995abb8169b2cb8;
module.exports["SitePermissionTypeFilter"] = $fc6a2e7c662c45f6$export$3347a7c058a0368a;

});

parcelRegister("VQdE0", function(module, exports) {
/**
 * @generated SignedSource<<d8c13f003578e6757b54483ce7e2bebb>>
 * @relayHash 8824351f0529abac5573900b2bee2db5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2f8b43e5b1993f0813a23a44917516743e194299c3565ccbf17994b391776751
const $3fbecf5b2b9bf0ac$var$node = function() {
    var v0 = {
        "defaultValue": 50,
        "kind": "LocalArgument",
        "name": "maxResults"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchTerm"
    }, v2 = {
        "defaultValue": "NONE",
        "kind": "LocalArgument",
        "name": "sitePermissionTypeFilter"
    }, v3 = {
        "defaultValue": true,
        "kind": "LocalArgument",
        "name": "withGroups"
    }, v4 = {
        "defaultValue": true,
        "kind": "LocalArgument",
        "name": "withUsers"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "maxResults",
            "variableName": "maxResults"
        },
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "searchTerm"
        },
        {
            "kind": "Variable",
            "name": "sitePermissionTypeFilter",
            "variableName": "sitePermissionTypeFilter"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "type"
    }, v7 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v8 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v9 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v10 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v11 = {
        "condition": "withGroups",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "Group",
                "kind": "LinkedField",
                "name": "groups",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "id"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    v8 /*: any*/ 
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "UserAndGroupSearchQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "GraphQLUserAndGroupSearchResults",
                    "kind": "LinkedField",
                    "name": "userGroupSearch",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "withUsers",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "users",
                                    "plural": true,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v11 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "UserAndGroupSearchQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "GraphQLUserAndGroupSearchResults",
                    "kind": "LinkedField",
                    "name": "userGroupSearch",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "withUsers",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "users",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v11 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "8824351f0529abac5573900b2bee2db5",
            "id": "2f8b43e5b1993f0813a23a44917516743e194299c3565ccbf17994b391776751",
            "metadata": {},
            "name": "UserAndGroupSearchQuery",
            "operationKind": "query",
            "text": "query UserAndGroupSearchQuery($searchTerm:String!,$maxResults:Int=50,$withGroups:Boolean=true,$withUsers:Boolean=true,$sitePermissionTypeFilter:SitePermissionTypeFilter=NONE){userGroupSearch(query:$searchTerm,maxResults:$maxResults,sitePermissionTypeFilter:$sitePermissionTypeFilter){users@include(if:$withUsers){__typename,type,displayName,permissionType,profilePicture{path},...on KnownUser{accountId}},groups@include(if:$withGroups){id,name,permissionType}}}"
        }
    };
}();
$3fbecf5b2b9bf0ac$var$node.hash = "52200fecbeb2441b36c8ceb106bad130";
var $3fbecf5b2b9bf0ac$export$2e2bcd8739ae039 = $3fbecf5b2b9bf0ac$var$node;
module.exports["default"] = $3fbecf5b2b9bf0ac$export$2e2bcd8739ae039;

});

parcelRegister("hkzol", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $kTb7m = parcelRequire("kTb7m");


var $ad7Ou = parcelRequire("ad7Ou");


var $1sCHt = parcelRequire("1sCHt");


var $lpNn5 = parcelRequire("lpNn5");


var $9GVkD = parcelRequire("9GVkD");


var $56QzY = parcelRequire("56QzY");


var $6abPE = parcelRequire("6abPE");


var $jooGc = parcelRequire("jooGc");


var $kfIha = parcelRequire("kfIha");

const $5e3895b62fe84f52$var$i18n = (0, $kSwu1.defineMessages)({
    copyLinkLabel: {
        id: "copy-content-link.icon.label",
        defaultMessage: "Copy link"
    },
    copiedTextLabel: {
        id: "copy-content-link.copied.tooltip",
        defaultMessage: "Copied!"
    },
    errorCopyingTextLabel: {
        id: "copy-content-link.error.tooltip",
        defaultMessage: "Something went wrong."
    }
});
const $5e3895b62fe84f52$var$DEFAULT_TOOLTIP_DELAY = 100;
const $5e3895b62fe84f52$var$RESET_COPYTEXT_TIMEOUT = 2500;
const $5e3895b62fe84f52$var$iconButtonAppearances = new Set([
    'default',
    'primary',
    'discovery',
    'subtle'
]);
const $5e3895b62fe84f52$var$formatIconButtonAppearance = (appearance)=>$5e3895b62fe84f52$var$iconButtonAppearances.has(appearance) ? appearance : 'default';
const $5e3895b62fe84f52$export$9957974f8b4d8f74 = 'copyShareLink';
const $5e3895b62fe84f52$export$534d10f1c5b9c7b3 = ({ pageMode: pageMode, contentType: contentType, contentId: contentId, spaceKey: spaceKey, source: source, isDraft: isDraft = false, isLivePage: isLivePage = false, isDisabled: isDisabled = false, shouldResetOnHover: shouldResetOnHover = false, buttonAppearance: buttonAppearance = 'subtle', tooltipPosition: tooltipPosition = 'bottom', buttonText: buttonText = '', copiedTextTooltipLabel: copiedTextTooltipLabel = $5e3895b62fe84f52$var$i18n.copiedTextLabel, onClickAttributes: onClickAttributes, iconColor: iconColor, urlOverride: urlOverride = '' })=>{
    const intl = (0, $kSwu1.useIntl)();
    const cleanupCopiedTimer = (0, $cozmU.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [isCopied, setIsCopied] = (0, $cozmU.useState)(false);
    const [errorDuringCopy, setErrorDuringCopy] = (0, $cozmU.useState)();
    const updateTooltip = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef();
    // Hook to store copy content link click state
    const { setHasClickedCopyContentLink: setHasClickedCopyContentLink, resetHasClickedCopyContentLink: resetHasClickedCopyContentLink } = (0, $jooGc.useCopyContentLinkActions)();
    const { copyToClipboard: copyToClipboard } = (0, $kfIha.useCopyToClipboard)();
    (0, $cozmU.useEffect)(()=>{
        if (isCopied) cleanupCopiedTimer.current = setTimeout(()=>setIsCopied(false), $5e3895b62fe84f52$var$RESET_COPYTEXT_TIMEOUT);
        return ()=>{
            clearTimeout(cleanupCopiedTimer.current);
        };
    }, [
        isCopied
    ]);
    (0, $cozmU.useEffect)(()=>{
        resetHasClickedCopyContentLink();
    }, [
        resetHasClickedCopyContentLink
    ]);
    const { unsupportedLinkError: unsupportedLinkError, copyContentLink: copyContentLink } = (0, $6abPE.useCopyContentLink)({
        pageMode: pageMode,
        contentType: contentType,
        contentId: contentId,
        spaceKey: spaceKey,
        source: source,
        skip: Boolean(urlOverride)
    });
    const handleCopyLink = async ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: $5e3895b62fe84f52$export$9957974f8b4d8f74,
                source: source,
                attributes: {
                    pageMode: pageMode,
                    contentType: contentType,
                    navdexPointType: (0, $56QzY.END),
                    isDraft: isDraft,
                    isLivePage: isLivePage,
                    ...onClickAttributes ?? {}
                }
            }
        }).fire();
        //mark has copy content link click to true
        setHasClickedCopyContentLink();
        try {
            if (!urlOverride) await copyContentLink();
            else await copyToClipboard(urlOverride);
        } catch (e) {
            setErrorDuringCopy(e);
        }
        setIsCopied(true);
    };
    // report errors from the hook's query silently since we have fallback link retrieval
    // methods, but show user error tooltip text if we actually
    // couldn't get any link to copy or the copy itself failed
    const copyError = unsupportedLinkError || errorDuringCopy;
    const copyLinkText = intl.formatMessage($5e3895b62fe84f52$var$i18n.copyLinkLabel);
    const confirmationText = intl.formatMessage(copyError ? $5e3895b62fe84f52$var$i18n.errorCopyingTextLabel : copiedTextTooltipLabel);
    const onMouseLeave = ()=>{
        if (shouldResetOnHover) setIsCopied(false);
    };
    (0, $cozmU.useLayoutEffect)(()=>{
        updateTooltip.current?.();
    }, [
        isCopied
    ]);
    const iconButtonAppearance = $5e3895b62fe84f52$var$formatIconButtonAppearance(buttonAppearance);
    const getCopyButton = ()=>buttonText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            testId: "copy-link-button",
            "aria-label": copyLinkText,
            appearance: buttonAppearance,
            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))),
            onClick: handleCopyLink,
            onMouseLeave: onMouseLeave,
            isDisabled: isDisabled
        }, buttonText) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            testId: "copy-link-button",
            label: copyLinkText,
            icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
                    ...iconProps,
                    color: iconColor
                }),
            onClick: handleCopyLink,
            onMouseLeave: onMouseLeave,
            isDisabled: isDisabled,
            appearance: iconButtonAppearance
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), {
        role: "status",
        "aria-live": "assertive",
        "aria-atomic": "true"
    }, isCopied && confirmationText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: ({ update: update })=>{
            updateTooltip.current = update;
            if (isCopied) return confirmationText;
            if (buttonText) return buttonText;
            else return copyLinkText;
        },
        position: tooltipPosition,
        ignoreTooltipPointerEvents: true,
        delay: $5e3895b62fe84f52$var$DEFAULT_TOOLTIP_DELAY,
        hasNewContentOnTriggerClick: true
    }, getCopyButton()));
};
module.exports["ACTION_SUBJECT_ID"] = $5e3895b62fe84f52$export$9957974f8b4d8f74;
module.exports["CopyLinkButton"] = $5e3895b62fe84f52$export$534d10f1c5b9c7b3;

});

parcelRegister("6abPE", function(module, exports) {

var $2i78V = parcelRequire("2i78V");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $jMyy4 = parcelRequire("jMyy4");


var $1NBp8 = parcelRequire("1NBp8");


var $7zgzO = parcelRequire("7zgzO");


var $hkzol = parcelRequire("hkzol");


var $kfIha = parcelRequire("kfIha");

const $68bb0af1984f782c$var$useCopyContentLinkQuery = (0, $2i78V.default);
const $68bb0af1984f782c$export$a049904f049cf16d = ({ pageMode: pageMode, contentType: contentType, contentId: contentId, spaceKey: spaceKey, source: source, skip: skip = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [unsupportedLinkError, setUnsupportedLinkError] = (0, $cozmU.useState)();
    const { toUrl: toUrl } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const { copyToClipboard: copyToClipboard } = (0, $kfIha.useCopyToClipboard)();
    const { data: data, loading: loading, error: queryError } = (0, $jMyy4.useQueryInterop)($68bb0af1984f782c$var$useCopyContentLinkQuery, {
        variables: {
            contentId: contentId || ''
        },
        skip: !contentId || skip,
        __callerPackage__: "copy-content-link"
    });
    const makeContentLink = (0, $cozmU.useCallback)(()=>{
        let copyLink;
        // Try to get the page link from queried data, shortened (for view mode) if possible.
        if (data) {
            const links = data?.singleContent?.links;
            if (pageMode === 'edit') copyLink = links?.editui;
            else // pageMode === "view" OR no page mode specified, eg for whiteboards
            copyLink = links?.tinyui || links?.webui;
            if (copyLink && links?.base) {
                const copyLinkUrl = `${links.base}${copyLink}`;
                return copyLinkUrl;
            }
        }
        // Fallback behavior: Use content type + page mode to construct URL.
        let routeName, additionalParams;
        if (pageMode === 'edit') {
            routeName = contentType === 'blogpost' ? (0, $1NBp8.EDIT_BLOG_V2).name : (0, $1NBp8.EDIT_PAGE_V2).name;
            additionalParams = {
                contentType: // EDIT_BLOG_V2 and EDIT_PAGE_V2 routes expect particular contentType format during route construction
                contentType === 'blogpost' ? 'blog' : 'pages'
            };
        } else switch(contentType){
            case 'overview':
                routeName = (0, $1NBp8.SPACE_OVERVIEW).name;
                break;
            case 'blogpost':
                routeName = (0, $1NBp8.VIEW_BLOG).name;
                break;
            case 'page':
                routeName = (0, $1NBp8.VIEW_PAGE).name;
                break;
            case 'whiteboard':
                routeName = (0, $1NBp8.WHITEBOARD_BOARD).name;
                break;
            case 'slide':
                routeName = (0, $1NBp8.SLIDES_VIEW).name;
                break;
            case 'folder':
                routeName = (0, $1NBp8.FOLDER_VIEW).name;
                break;
            // omit databases and other unsupported content types
            default:
                if (!contentType) // contentType is undefined/empty - this is a data issue, not a
                // truly unsupported type. Return undefined rather than erroring.
                return undefined;
                const error = new Error(`Received an unexpected content type: '${contentType}'`);
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'thrown',
                        actionSubject: 'error',
                        actionSubjectId: (0, $hkzol.ACTION_SUBJECT_ID),
                        source: source,
                        attributes: {
                            error: error?.message,
                            contentType: contentType,
                            pageMode: pageMode
                        }
                    }
                }).fire();
                setUnsupportedLinkError(error);
        }
        if (routeName) {
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'generated',
                    actionSubject: 'fallbackLink',
                    actionSubjectId: (0, $hkzol.ACTION_SUBJECT_ID),
                    source: source,
                    attributes: {
                        queryError: queryError?.message,
                        isDataLoading: loading,
                        route: routeName
                    }
                }
            }).fire();
            // Omit contentSlug, because user perception is that link sharing
            // is more secure without the content title in the URL.
            const copyLinkUrl = `${window.location.origin}${toUrl(routeName, {
                contentId: contentId,
                spaceKey: spaceKey,
                ...additionalParams
            })}`;
            return copyLinkUrl;
        }
        return undefined;
    }, [
        toUrl,
        contentId,
        contentType,
        spaceKey,
        pageMode,
        source,
        data,
        loading,
        queryError,
        createAnalyticsEvent
    ]);
    const copyContentLink = (0, $cozmU.useCallback)(()=>{
        return copyToClipboard(makeContentLink());
    }, [
        makeContentLink,
        copyToClipboard
    ]);
    return {
        queryError: queryError,
        unsupportedLinkError: unsupportedLinkError,
        makeContentLink: makeContentLink,
        copyContentLink: copyContentLink
    };
};
module.exports["useCopyContentLink"] = $68bb0af1984f782c$export$a049904f049cf16d;

});

parcelRegister("2i78V", function(module, exports) {
/**
 * @generated SignedSource<<0b2f5f44bd64ba7831c6ee7b039fb54f>>
 * @relayHash 29cac5aad51907935410d62eca7f1996
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9e424bd39a886792a42fa3d08fff564fafdbc617d54015972ab0f69de51e1d34
const $77e7fa3fd8a73973$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "editui"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "webui"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "tinyui"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "base"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useCopyContentLinkQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useCopyContentLinkQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "29cac5aad51907935410d62eca7f1996",
            "id": "9e424bd39a886792a42fa3d08fff564fafdbc617d54015972ab0f69de51e1d34",
            "metadata": {},
            "name": "useCopyContentLinkQuery",
            "operationKind": "query",
            "text": "query useCopyContentLinkQuery($contentId:ID!){singleContent(id:$contentId){id,links{editui,webui,tinyui,base}}}"
        }
    };
}();
$77e7fa3fd8a73973$var$node.hash = "37d735340f7b52ac7552b4a67a3fb5da";
var $77e7fa3fd8a73973$export$2e2bcd8739ae039 = $77e7fa3fd8a73973$var$node;
module.exports["default"] = $77e7fa3fd8a73973$export$2e2bcd8739ae039;

});

parcelRegister("jooGc", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $4ca5e403580d1e7d$var$initialState = {
    hasClickedCopyContentLink: false
};
const $4ca5e403580d1e7d$var$actions = {
    setHasClickedCopyContentLink: ()=>({ setState: setState })=>{
            setState({
                hasClickedCopyContentLink: true
            });
        },
    resetHasClickedCopyContentLink: ()=>({ setState: setState })=>{
            setState({
                hasClickedCopyContentLink: false
            });
        }
};
const $4ca5e403580d1e7d$var$CopyContentLinkStore = (0, $8s9DV.createStore)({
    initialState: $4ca5e403580d1e7d$var$initialState,
    actions: $4ca5e403580d1e7d$var$actions,
    name: 'CopyContentLinkStore'
});
const $4ca5e403580d1e7d$export$77cd2a2387f7879a = (0, $kBr4q.createStateHook)($4ca5e403580d1e7d$var$CopyContentLinkStore);
const $4ca5e403580d1e7d$export$c42bcb6cac241c15 = (0, $kBr4q.createActionsHook)($4ca5e403580d1e7d$var$CopyContentLinkStore);
module.exports["useCopyContentLinkActions"] = $4ca5e403580d1e7d$export$c42bcb6cac241c15;

});

parcelRegister("536md", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $4n1IT = parcelRequire("4n1IT");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $hBYtq = parcelRequire("hBYtq");

var $4aRua = parcelRequire("4aRua");


var $lpNn5 = parcelRequire("lpNn5");


var $bNtJQ = parcelRequire("bNtJQ");


var $iN3XE = parcelRequire("iN3XE");


var $5kxDu = parcelRequire("5kxDu");


var $5uSrW = parcelRequire("5uSrW");

const $b41f6df5eadabeb5$var$styles = {
    base: "_2mHwu81Y8M _0bjKvDKxmn _3iDTPbccYA _0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M _0hPCNLDIqT _37wbyuDIqT _1ANEUSzUZr _39HuIbz8Lp _0wOv4Q18ZR",
    compact: "_0jFU0VSPN1",
    expanded: "_0jFU0VoWWg",
    disabled: "_1UtDYzot27 _0KLXruVrZW _0wOv4Q18ZR",
    clickable: "_0wOv4Q7zJH",
    red: "_1UtDYzy7kJ _0KLXrubV9i",
    redClickable: "_2BK2LlbV9i _1eOmH6FOVf _3gzVzLFnU8",
    redBold: "_1UtDYze5R3 _0KLXruQrW1",
    redBoldClickable: "_2BK2LlQrW1 _1eOmH6mCVf _3gzVzLPm25",
    orange: "_1UtDYzy7kJ _0KLXruuwVU",
    orangeClickable: "_2BK2LluwVU _1eOmH6nwBH _3gzVzLKHmw",
    yellow: "_1UtDYzy7kJ _0KLXru56u3",
    yellowClickable: "_2BK2Ll56u3 _1eOmH6BwZU _3gzVzLHN5H",
    green: "_1UtDYzy7kJ _0KLXruV6wL",
    greenClickable: "_2BK2LlV6wL _1eOmH6Mqh8 _3gzVzLUxn0",
    blue: "_1UtDYzy7kJ _0KLXrup9dS",
    blueClickable: "_2BK2Llp9dS _1eOmH6RRyT _3gzVzLeeqx",
    teal: "_1UtDYzy7kJ _0KLXrunfgW",
    tealClickable: "_2BK2LlnfgW _1eOmH6A8mq _3gzVzLjHQE",
    lime: "_1UtDYzy7kJ _0KLXruuKDS",
    limeClickable: "_2BK2LluKDS _1eOmH6uIDk _3gzVzLyTNr",
    purple: "_1UtDYzy7kJ _0KLXruB8KG",
    purpleClickable: "_2BK2LlB8KG _1eOmH6eJK9 _3gzVzLhT4j",
    grey: "_1UtDYzy7kJ _0KLXrumhAQ",
    greyClickable: "_2BK2LlmhAQ _1eOmH6Bee8 _3gzVzLysrI",
    popup: "_39xV02BmSS"
};
const $b41f6df5eadabeb5$var$DataClassificationLevel = (0, $gtMdU.isReactCompilerActivePlatform)() ? function DataClassificationLevel(t0) {
    const $ = (0, $bDgLe.c)(45);
    const { testId: testId, name: name, tooltip: tooltip, tooltipPosition: tooltipPosition, color: t1, iconSize: t2, guideline: guideline, guidelineADF: guidelineADF, isDisabled: t3, isPopupDisabled: t4, isPopupOpenByDefault: t5, getPopupStateControllers: getPopupStateControllers, popupZIndex: popupZIndex, guidelineRepresentation: t6, onPopupShown: onPopupShown, onPopupClose: onPopupClose, onClick: onClick, renderPopupComponent: renderPopupComponent, popupLabel: popupLabel, popupTitleId: popupTitleId, popupRole: popupRole, popupPlacement: t7, shouldRenderToParent: shouldRenderToParent, isIconOnly: t8, associatedPoliciesCount: associatedPoliciesCount, spacing: t9 } = t0;
    const color = t1 === undefined ? "GREY" : t1;
    const iconSize = t2 === undefined ? "small" : t2;
    const isDisabled = t3 === undefined ? false : t3;
    const isPopupDisabled = t4 === undefined ? false : t4;
    const isPopupOpenByDefault = t5 === undefined ? false : t5;
    const guidelineRepresentation = t6 === undefined ? "PLAIN" : t6;
    const popupPlacement = t7 === undefined ? "bottom-start" : t7;
    const isIconOnlyProp = t8 === undefined ? false : t8;
    const spacing = t9 === undefined ? "default" : t9;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isPopupOpen, setIsPopupOpen] = (0, $cozmU.useState)(isDisabled || isPopupDisabled ? false : isPopupOpenByDefault);
    if (getPopupStateControllers) {
        const getOpenState = ()=>isPopupOpen;
        const setOpenState = (isOpen)=>setIsPopupOpen(isOpen);
        getPopupStateControllers(getOpenState, setOpenState);
    }
    const isMissingName = !name || name.length === 0;
    const isIconOnly = isMissingName || isIconOnlyProp;
    let t10;
    if ($[0] !== associatedPoliciesCount || $[1] !== formatMessage || $[2] !== isMissingName || $[3] !== name) {
        t10 = isMissingName ? "" : associatedPoliciesCount ? name + " " + formatMessage((0, $5uSrW.messages).rules, {
            associatedPoliciesCount: associatedPoliciesCount
        }) : name;
        $[0] = associatedPoliciesCount;
        $[1] = formatMessage;
        $[2] = isMissingName;
        $[3] = name;
        $[4] = t10;
    } else t10 = $[4];
    const nameWithRules = t10;
    const t11 = nameWithRules ?? "";
    let t12;
    if ($[5] !== t11) {
        t12 = t11.substring(0, (0, $iN3XE.nameMaxLength));
        $[5] = t11;
        $[6] = t12;
    } else t12 = $[6];
    const nameTruncated = t12;
    const iconPx = iconSize === "small" ? 12 : iconSize === "medium" ? 18 : iconSize === "large" ? 24 : iconSize === "xlarge" ? 32 : iconSize === "xxlarge" ? 40 : 12;
    let t13;
    if ($[7] !== isDisabled || $[8] !== isMissingName || $[9] !== isPopupDisabled || $[10] !== isPopupOpen || $[11] !== onPopupShown) {
        t13 = ()=>{
            if (isPopupDisabled || isDisabled || isMissingName) return;
            if (onPopupShown) onPopupShown();
            setIsPopupOpen(!isPopupOpen);
        };
        $[7] = isDisabled;
        $[8] = isMissingName;
        $[9] = isPopupDisabled;
        $[10] = isPopupOpen;
        $[11] = onPopupShown;
        $[12] = t13;
    } else t13 = $[12];
    const handleContainerClicked = t13;
    let t14;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = ()=>{
            setIsPopupOpen(false);
        };
        $[13] = t14;
    } else t14 = $[13];
    const closePopup = t14;
    const isClickable = !isPopupDisabled && !isDisabled && !isMissingName;
    let t15;
    if ($[14] !== color || $[15] !== formatMessage || $[16] !== handleContainerClicked || $[17] !== iconPx || $[18] !== isClickable || $[19] !== isDisabled || $[20] !== isIconOnly || $[21] !== name || $[22] !== nameTruncated || $[23] !== onClick || $[24] !== spacing || $[25] !== testId) {
        t15 = (t16)=>{
            const triggerProps = t16 === undefined ? {} : t16;
            const { "aria-expanded": ariaExpanded, ...restProps } = triggerProps;
            const Container = isClickable ? (0, $hBYtq.Pressable) : (0, $iMnC5.Box);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Container, {
                role: isClickable ? "button" : "presentation",
                "aria-disabled": isDisabled,
                ...isClickable ? {
                    "aria-label": `${formatMessage((0, $5uSrW.messages).dataClassificationLevel)} - ${name}`
                } : {},
                xcss: (0, $w6R6I.cx)(...[
                    $b41f6df5eadabeb5$var$styles.base,
                    ...!isIconOnly ? [
                        spacing === "expanded" ? $b41f6df5eadabeb5$var$styles.expanded : $b41f6df5eadabeb5$var$styles.compact
                    ] : [],
                    ...isDisabled ? [
                        $b41f6df5eadabeb5$var$styles.disabled
                    ] : [],
                    ...!isDisabled ? [
                        {
                            RED: $b41f6df5eadabeb5$var$styles.red,
                            RED_BOLD: $b41f6df5eadabeb5$var$styles.redBold,
                            ORANGE: $b41f6df5eadabeb5$var$styles.orange,
                            YELLOW: $b41f6df5eadabeb5$var$styles.yellow,
                            GREEN: $b41f6df5eadabeb5$var$styles.green,
                            BLUE: $b41f6df5eadabeb5$var$styles.blue,
                            TEAL: $b41f6df5eadabeb5$var$styles.teal,
                            LIME: $b41f6df5eadabeb5$var$styles.lime,
                            PURPLE: $b41f6df5eadabeb5$var$styles.purple,
                            GREY: $b41f6df5eadabeb5$var$styles.grey
                        }[color]
                    ] : [],
                    ...!isDisabled && isClickable ? [
                        $b41f6df5eadabeb5$var$styles.clickable,
                        {
                            RED: $b41f6df5eadabeb5$var$styles.redClickable,
                            RED_BOLD: $b41f6df5eadabeb5$var$styles.redBoldClickable,
                            ORANGE: $b41f6df5eadabeb5$var$styles.orangeClickable,
                            YELLOW: $b41f6df5eadabeb5$var$styles.yellowClickable,
                            GREEN: $b41f6df5eadabeb5$var$styles.greenClickable,
                            BLUE: $b41f6df5eadabeb5$var$styles.blueClickable,
                            TEAL: $b41f6df5eadabeb5$var$styles.tealClickable,
                            LIME: $b41f6df5eadabeb5$var$styles.limeClickable,
                            PURPLE: $b41f6df5eadabeb5$var$styles.purpleClickable,
                            GREY: $b41f6df5eadabeb5$var$styles.greyClickable
                        }[color]
                    ] : []
                ]),
                testId: testId,
                padding: "space.050",
                onClick: ()=>{
                    if (onClick) onClick();
                    handleContainerClicked();
                },
                ...isClickable ? triggerProps : restProps
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
                justifyContent: "center",
                alignItems: "center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5kxDu.ClassificationIcon), {
                width: iconPx,
                height: iconPx,
                color: isDisabled ? (0, $iN3XE.disabledColorConfig).iconColor : (0, $iN3XE.colorsConfig)[color].iconColor
            })), !isIconOnly && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                size: "small",
                maxLines: 1,
                color: color === "RED_BOLD" ? "color.text.inverse" : "color.text",
                testId: "data-classification-level-name"
            }, nameTruncated));
        };
        $[14] = color;
        $[15] = formatMessage;
        $[16] = handleContainerClicked;
        $[17] = iconPx;
        $[18] = isClickable;
        $[19] = isDisabled;
        $[20] = isIconOnly;
        $[21] = name;
        $[22] = nameTruncated;
        $[23] = onClick;
        $[24] = spacing;
        $[25] = testId;
        $[26] = t15;
    } else t15 = $[26];
    const getContainer = t15;
    let t16;
    if ($[27] !== getContainer || $[28] !== guideline || $[29] !== guidelineADF || $[30] !== guidelineRepresentation || $[31] !== isPopupDisabled || $[32] !== isPopupOpen || $[33] !== name || $[34] !== onPopupClose || $[35] !== popupLabel || $[36] !== popupPlacement || $[37] !== popupRole || $[38] !== popupTitleId || $[39] !== popupZIndex || $[40] !== renderPopupComponent || $[41] !== shouldRenderToParent || $[42] !== tooltip || $[43] !== tooltipPosition) {
        t16 = isPopupDisabled ? getContainer() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
            label: popupLabel,
            titleId: popupTitleId,
            role: popupRole,
            shouldRenderToParent: shouldRenderToParent,
            placement: popupPlacement,
            trigger: (triggerProps_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
                    content: isPopupOpen ? null : tooltip,
                    hideTooltipOnClick: true,
                    position: tooltipPosition
                }, getContainer(triggerProps_0)),
            content: ()=>renderPopupComponent ? renderPopupComponent(closePopup) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    padding: "space.250",
                    xcss: $b41f6df5eadabeb5$var$styles.popup,
                    role: "dialog",
                    "aria-labelledby": "data-classification-read-content-name",
                    "aria-describedby": "data-classification-read-content-guideline",
                    "aria-modal": "true"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bNtJQ.ClassificationView), {
                    name: name,
                    guideline: guideline,
                    guidelineADF: guidelineADF,
                    guidelineRepresentation: guidelineRepresentation
                })),
            isOpen: isPopupOpen,
            onClose: ()=>{
                if (onPopupClose) onPopupClose();
                closePopup();
            },
            zIndex: popupZIndex
        });
        $[27] = getContainer;
        $[28] = guideline;
        $[29] = guidelineADF;
        $[30] = guidelineRepresentation;
        $[31] = isPopupDisabled;
        $[32] = isPopupOpen;
        $[33] = name;
        $[34] = onPopupClose;
        $[35] = popupLabel;
        $[36] = popupPlacement;
        $[37] = popupRole;
        $[38] = popupTitleId;
        $[39] = popupZIndex;
        $[40] = renderPopupComponent;
        $[41] = shouldRenderToParent;
        $[42] = tooltip;
        $[43] = tooltipPosition;
        $[44] = t16;
    } else t16 = $[44];
    return t16;
} : function DataClassificationLevel({ testId: testId, name: name, tooltip: tooltip, tooltipPosition: tooltipPosition, color: color = 'GREY', iconSize: iconSize = 'small', guideline: guideline, guidelineADF: guidelineADF, isDisabled: isDisabled = false, isPopupDisabled: isPopupDisabled = false, isPopupOpenByDefault: isPopupOpenByDefault = false, getPopupStateControllers: getPopupStateControllers, popupZIndex: popupZIndex, guidelineRepresentation: guidelineRepresentation = 'PLAIN', onPopupShown: onPopupShown, onPopupClose: onPopupClose, onClick: onClick, renderPopupComponent: renderPopupComponent, popupLabel: popupLabel, popupTitleId: popupTitleId, popupRole: popupRole, popupPlacement: popupPlacement = 'bottom-start', shouldRenderToParent: shouldRenderToParent, isIconOnly: isIconOnlyProp = false, associatedPoliciesCount: associatedPoliciesCount, spacing: spacing = 'default' }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isPopupOpen, setIsPopupOpen] = (0, $cozmU.useState)(isDisabled || isPopupDisabled ? false : isPopupOpenByDefault);
    if (getPopupStateControllers) {
        const getOpenState = ()=>isPopupOpen;
        const setOpenState = (isOpen)=>setIsPopupOpen(isOpen);
        getPopupStateControllers(getOpenState, setOpenState);
    }
    const isMissingName = !name || name.length === 0;
    const isIconOnly = isMissingName || isIconOnlyProp;
    const nameWithRules = isMissingName ? '' : associatedPoliciesCount ? name + ' ' + formatMessage((0, $5uSrW.messages).rules, {
        associatedPoliciesCount: associatedPoliciesCount
    }) : name;
    const nameTruncated = (nameWithRules ?? '').substring(0, (0, $iN3XE.nameMaxLength));
    const iconPx = iconSize === 'small' ? 12 : iconSize === 'medium' ? 18 : iconSize === 'large' ? 24 : iconSize === 'xlarge' ? 32 : iconSize === 'xxlarge' ? 40 : 12;
    const handleContainerClicked = ()=>{
        if (isPopupDisabled || isDisabled || isMissingName) return;
        if (onPopupShown) onPopupShown();
        setIsPopupOpen(!isPopupOpen);
    };
    const closePopup = ()=>{
        setIsPopupOpen(false);
    };
    const isClickable = !isPopupDisabled && !isDisabled && !isMissingName;
    const getContainer = (triggerProps = {})=>{
        // @ts-ignore
        const { 'aria-expanded': ariaExpanded, ...restProps } = triggerProps;
        const Container = isClickable ? (0, $hBYtq.Pressable) : (0, $iMnC5.Box);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Container, {
            role: isClickable ? 'button' : 'presentation',
            "aria-disabled": isDisabled,
            ...isClickable ? {
                'aria-label': `${formatMessage((0, $5uSrW.messages).dataClassificationLevel)} - ${name}`
            } : {},
            xcss: (0, $w6R6I.cx)(...[
                $b41f6df5eadabeb5$var$styles.base,
                // Add size styles if not icon only
                ...!isIconOnly ? [
                    spacing === 'expanded' ? $b41f6df5eadabeb5$var$styles.expanded : $b41f6df5eadabeb5$var$styles.compact
                ] : [],
                // Add disabled styles if disabled
                ...isDisabled ? [
                    $b41f6df5eadabeb5$var$styles.disabled
                ] : [],
                // Add color styles
                ...!isDisabled ? [
                    {
                        RED: $b41f6df5eadabeb5$var$styles.red,
                        RED_BOLD: $b41f6df5eadabeb5$var$styles.redBold,
                        ORANGE: $b41f6df5eadabeb5$var$styles.orange,
                        YELLOW: $b41f6df5eadabeb5$var$styles.yellow,
                        GREEN: $b41f6df5eadabeb5$var$styles.green,
                        BLUE: $b41f6df5eadabeb5$var$styles.blue,
                        TEAL: $b41f6df5eadabeb5$var$styles.teal,
                        LIME: $b41f6df5eadabeb5$var$styles.lime,
                        PURPLE: $b41f6df5eadabeb5$var$styles.purple,
                        GREY: $b41f6df5eadabeb5$var$styles.grey
                    }[color]
                ] : [],
                // Add clickable styles if clickable
                ...!isDisabled && isClickable ? [
                    $b41f6df5eadabeb5$var$styles.clickable,
                    {
                        RED: $b41f6df5eadabeb5$var$styles.redClickable,
                        RED_BOLD: $b41f6df5eadabeb5$var$styles.redBoldClickable,
                        ORANGE: $b41f6df5eadabeb5$var$styles.orangeClickable,
                        YELLOW: $b41f6df5eadabeb5$var$styles.yellowClickable,
                        GREEN: $b41f6df5eadabeb5$var$styles.greenClickable,
                        BLUE: $b41f6df5eadabeb5$var$styles.blueClickable,
                        TEAL: $b41f6df5eadabeb5$var$styles.tealClickable,
                        LIME: $b41f6df5eadabeb5$var$styles.limeClickable,
                        PURPLE: $b41f6df5eadabeb5$var$styles.purpleClickable,
                        GREY: $b41f6df5eadabeb5$var$styles.greyClickable
                    }[color]
                ] : []
            ]),
            testId: testId,
            padding: "space.050",
            onClick: ()=>{
                if (onClick) onClick();
                handleContainerClicked();
            },
            ...isClickable ? triggerProps : restProps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            justifyContent: "center",
            alignItems: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5kxDu.ClassificationIcon), {
            width: iconPx,
            height: iconPx,
            color: isDisabled ? (0, $iN3XE.disabledColorConfig).iconColor : (0, $iN3XE.colorsConfig)[color].iconColor
        })), !isIconOnly && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            maxLines: 1,
            color: color === 'RED_BOLD' ? 'color.text.inverse' : 'color.text',
            testId: "data-classification-level-name"
        }, nameTruncated));
    };
    return isPopupDisabled ? getContainer() : // eslint-disable-next-line @atlaskit/design-system/use-should-render-to-parent
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
        label: popupLabel,
        titleId: popupTitleId,
        role: popupRole,
        shouldRenderToParent: shouldRenderToParent,
        placement: popupPlacement,
        trigger: (triggerProps_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
                content: isPopupOpen ? null : tooltip,
                hideTooltipOnClick: true,
                position: tooltipPosition
            }, getContainer(triggerProps_0)),
        content: ()=>renderPopupComponent ? renderPopupComponent(closePopup) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                padding: "space.250",
                xcss: $b41f6df5eadabeb5$var$styles.popup,
                role: "dialog",
                "aria-labelledby": "data-classification-read-content-name",
                "aria-describedby": "data-classification-read-content-guideline",
                "aria-modal": "true"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bNtJQ.ClassificationView), {
                name: name,
                guideline: guideline,
                guidelineADF: guidelineADF,
                guidelineRepresentation: guidelineRepresentation
            })),
        isOpen: isPopupOpen,
        onClose: ()=>{
            if (onPopupClose) onPopupClose();
            closePopup();
        },
        zIndex: popupZIndex
    });
};
var $b41f6df5eadabeb5$export$2e2bcd8739ae039 = $b41f6df5eadabeb5$var$DataClassificationLevel;
module.exports["default"] = $b41f6df5eadabeb5$export$2e2bcd8739ae039;

});

parcelRegister("bNtJQ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $c2Doe = parcelRequire("c2Doe");


var $iMnC5 = parcelRequire("iMnC5");


var $3BY7M = parcelRequire("3BY7M");


var $iN3XE = parcelRequire("iN3XE");


var $dAbha = parcelRequire("dAbha");


var $eMflC = parcelRequire("eMflC");

// Maximum height for guideline content to enable scrolling for long text
const $93953b443768a836$var$GUIDELINE_MAX_HEIGHT = '300px'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $93953b443768a836$var$Name = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "h2" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2sNsIgWSk4 _1UtDYzy7kJ",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIgWSk4 _1UtDYzy7kJ",
            __cmplp.className
        ])
    });
});
const $93953b443768a836$var$Guideline = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "p" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2sNsIgmnOE _1UtDYzy7kJ _1ANEUSlpBW _3zvHkHwPeg _0NUa3rBfNa _2WAcuGIZbP",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIgmnOE _1UtDYzy7kJ _1ANEUSlpBW _3zvHkHwPeg _0NUa3rBfNa _2WAcuGIZbP",
            __cmplp.className
        ])
    });
});
const $93953b443768a836$var$GuidelineADFContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_0NUa3rBfNa _2WAcuGIZbP",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0NUa3rBfNa _2WAcuGIZbP",
            __cmplp.className
        ])
    });
});
const $93953b443768a836$export$d413367b4cbb5577 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { name: name, guideline: guideline, guidelineADF: guidelineADF, guidelineRepresentation: t1 } = t0;
    const guidelineRepresentation = t1 === undefined ? "PLAIN" : t1;
    const t2 = name ?? "";
    let t3;
    if ($[0] !== t2) {
        t3 = t2.substring(0, (0, $iN3XE.nameMaxLength));
        $[0] = t2;
        $[1] = t3;
    } else t3 = $[1];
    const nameTruncated = t3;
    let parsedADF;
    let selectedGuideline;
    let t4;
    if ($[2] !== guideline || $[3] !== guidelineADF || $[4] !== guidelineRepresentation) {
        selectedGuideline = (0, $eMflC.selectGuideline)({
            guidelineADF: guidelineADF,
            guideline: guideline,
            guidelineRepresentation: guidelineRepresentation
        });
        parsedADF = guidelineRepresentation === "EDITOR" ? (0, $dAbha.safeParseGuidelineADF)(selectedGuideline) : undefined;
        t4 = (selectedGuideline ?? "").substring(0, (0, $iN3XE.guidelineMaxLength));
        $[2] = guideline;
        $[3] = guidelineADF;
        $[4] = guidelineRepresentation;
        $[5] = parsedADF;
        $[6] = selectedGuideline;
        $[7] = t4;
    } else {
        parsedADF = $[5];
        selectedGuideline = $[6];
        t4 = $[7];
    }
    const guidelineTruncated = t4;
    let t5;
    if ($[8] !== nameTruncated) {
        t5 = nameTruncated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($93953b443768a836$var$Name, {
            id: "data-classification-read-content-name"
        }, nameTruncated);
        $[8] = nameTruncated;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== guidelineRepresentation || $[11] !== guidelineTruncated || $[12] !== parsedADF || $[13] !== selectedGuideline) {
        t6 = selectedGuideline && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            paddingBlockStart: "space.200"
        }, guidelineRepresentation === "PLAIN" || !parsedADF ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($93953b443768a836$var$Guideline, {
            id: "data-classification-read-content-guideline"
        }, guidelineTruncated) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($93953b443768a836$var$GuidelineADFContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c2Doe.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3BY7M.default), {
            document: parsedADF
        }))));
        $[10] = guidelineRepresentation;
        $[11] = guidelineTruncated;
        $[12] = parsedADF;
        $[13] = selectedGuideline;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== t5 || $[16] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, t5, t6);
        $[15] = t5;
        $[16] = t6;
        $[17] = t7;
    } else t7 = $[17];
    return t7;
} : ({ name: name, guideline: guideline, guidelineADF: guidelineADF, guidelineRepresentation: guidelineRepresentation = 'PLAIN' })=>{
    const nameTruncated = (name ?? '').substring(0, (0, $iN3XE.nameMaxLength));
    // Select the appropriate guideline based on guidelineRepresentation
    // Prefers guidelineADF when in EDITOR mode, falls back to guideline
    const selectedGuideline = (0, $eMflC.selectGuideline)({
        guidelineADF: guidelineADF,
        guideline: guideline,
        guidelineRepresentation: guidelineRepresentation
    });
    // Parse ADF if in EDITOR mode - parse before truncation to avoid breaking JSON
    const parsedADF = guidelineRepresentation === 'EDITOR' ? (0, $dAbha.safeParseGuidelineADF)(selectedGuideline) : undefined;
    // Only truncate for plain text mode - ADF content shows full text with scrolling
    const guidelineTruncated = (selectedGuideline ?? '').substring(0, (0, $iN3XE.guidelineMaxLength));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, nameTruncated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($93953b443768a836$var$Name, {
        id: "data-classification-read-content-name"
    }, nameTruncated), selectedGuideline && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        paddingBlockStart: "space.200"
    }, guidelineRepresentation === 'PLAIN' || !parsedADF ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($93953b443768a836$var$Guideline, {
        id: "data-classification-read-content-guideline"
    }, guidelineTruncated) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($93953b443768a836$var$GuidelineADFContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c2Doe.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3BY7M.default), {
        document: parsedADF
    })))));
};
module.exports["ClassificationView"] = $93953b443768a836$export$d413367b4cbb5577;

});

parcelRegister("iN3XE", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $5uSrW = parcelRequire("5uSrW");

const { formatMessage: $9038897dcbdba2ca$var$formatMessage } = (0, $kSwu1.createIntl)({
    locale: 'en'
});
const $9038897dcbdba2ca$export$89b67151eed9295a = {
    definition: $9038897dcbdba2ca$var$formatMessage((0, $5uSrW.messages).noClassification),
    includeIcon: false
};
const $9038897dcbdba2ca$export$5f11f8883714351 = {
    id: 'no-selection',
    name: 'No selection'
};
const $9038897dcbdba2ca$export$253bdad208569777 = 50;
const $9038897dcbdba2ca$export$cbc3cef853d1014b = 1000;
const $9038897dcbdba2ca$export$e1444e5b0a63d793 = 1000;
const $9038897dcbdba2ca$export$fb2992e82b83582a = {
    YELLOW: {
        iconColor: "var(--ds-icon-accent-yellow, #B38600)",
        bgColor: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
        fontColor: "var(--ds-text, #292A2E)"
    },
    ORANGE: {
        iconColor: "var(--ds-icon-accent-orange, #E06C00)",
        bgColor: "var(--ds-background-accent-orange-subtle, #FCA700)",
        fontColor: "var(--ds-text, #292A2E)"
    },
    RED: {
        iconColor: "var(--ds-icon-accent-red, #C9372C)",
        bgColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        fontColor: "var(--ds-text, #292A2E)"
    },
    RED_BOLD: {
        iconColor: "var(--ds-icon-inverse, #FFFFFF)",
        bgColor: "var(--ds-background-accent-red-bolder, #C9372C)",
        fontColor: "var(--ds-text-inverse, #FFFFFF)"
    },
    PURPLE: {
        iconColor: "var(--ds-icon-accent-purple, #AF59E1)",
        bgColor: "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
        fontColor: "var(--ds-text, #292A2E)"
    },
    BLUE: {
        iconColor: "var(--ds-icon-accent-blue, #357DE8)",
        bgColor: "var(--ds-background-accent-blue-subtler, #CFE1FD)",
        fontColor: "var(--ds-text, #292A2E)"
    },
    TEAL: {
        iconColor: "var(--ds-icon-accent-teal, #2898BD)",
        bgColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        fontColor: "var(--ds-text, #292A2E)"
    },
    GREEN: {
        iconColor: "var(--ds-icon-accent-green, #22A06B)",
        bgColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
        fontColor: "var(--ds-text, #292A2E)"
    },
    GREY: {
        iconColor: "var(--ds-icon-accent-gray, #7D818A)",
        bgColor: "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
        fontColor: "var(--ds-text, #292A2E)"
    },
    LIME: {
        iconColor: "var(--ds-icon-accent-lime, #6A9A23)",
        bgColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
        fontColor: "var(--ds-text, #292A2E)"
    }
};
const $9038897dcbdba2ca$export$9cdea53b8993b139 = {
    iconColor: "var(--ds-icon-disabled, #080F214A)",
    bgColor: "var(--ds-background-disabled, #0515240F)",
    fontColor: "var(--ds-text-disabled, #080F214A)"
};
module.exports["NO_SELECTION_OPTION"] = $9038897dcbdba2ca$export$5f11f8883714351;
module.exports["nameMaxLength"] = $9038897dcbdba2ca$export$253bdad208569777;
module.exports["guidelineMaxLength"] = $9038897dcbdba2ca$export$e1444e5b0a63d793;
module.exports["colorsConfig"] = $9038897dcbdba2ca$export$fb2992e82b83582a;
module.exports["disabledColorConfig"] = $9038897dcbdba2ca$export$9cdea53b8993b139;

});

parcelRegister("5uSrW", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $3adb11bc26592ffe$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    noClassification: {
        id: "data-classification-level.no-classification",
        defaultMessage: "No classification"
    },
    classifyContent: {
        id: "data-classification-level.edit-popup.classify-content",
        defaultMessage: "Classify content"
    },
    selectClassification: {
        id: "data-classification-level.edit-popup.select-classification",
        defaultMessage: "Select classification"
    },
    updateButton: {
        id: "data-classification-level.edit-popup.update-button",
        defaultMessage: "Update"
    },
    cancelButton: {
        id: "data-classification-level.edit-popup.cancel-button",
        defaultMessage: "Cancel"
    },
    changeLevel: {
        id: "data-classification-level.read-popup.change-level",
        defaultMessage: "Change level"
    },
    rules: {
        id: "data-classification-level.rules",
        defaultMessage: "({associatedPoliciesCount, plural, one {# rule} other {# rules}})"
    },
    dataClassificationLevel: {
        id: "data-classification-level.data-classification-level",
        defaultMessage: "Data classification level"
    },
    dataClassificationLevelDialog: {
        id: "data-classification-level.read-popup.data-classification-level",
        defaultMessage: "Data classification level Dialog"
    },
    classificationLevelGuidelines: {
        id: "data-classification-level.read-popup.heading",
        defaultMessage: "Classification level guidelines"
    },
    sourceAutoClassification: {
        id: "data-classification-level.read-popup.source-auto-classification",
        defaultMessage: "The current classification level is based on information detected in the content. <a>Update classification level</a>"
    },
    sourceUserClassification: {
        id: "data-classification-level.read-popup.source-user-classification",
        defaultMessage: "A user assigned the current classification level. <a>Update classification level</a>"
    },
    sourceSpaceDefaultClassification: {
        id: "data-classification-level.read-popup.source-space-default-classification",
        defaultMessage: "The current classification level is the default for this space. <a>Update classification level</a>"
    },
    sourceOrgDefaultClassification: {
        id: "data-classification-level.read-popup.source-org-default-classification",
        defaultMessage: "The current classification level is the default for your organization. <a>Update classification level</a>"
    },
    sourceNoneClassification: {
        id: "data-classification-level.read-popup.source-none-classification",
        defaultMessage: "<a>Update classification level</a>"
    },
    sourceAutoClassificationUserOverrideDisallow: {
        id: "data-classification-level.read-popup.source-auto-classification-user-override-disallow",
        defaultMessage: "The current classification level is based on information detected in the content. Updates to classification levels aren't permitted."
    },
    sourceUserClassificationUserOverrideDisallow: {
        id: "data-classification-level.read-popup.source-user-classification-user-override-disallow",
        defaultMessage: "A user assigned the current classification level. Updates to classification levels aren't permitted."
    },
    sourceSpaceDefaultClassificationUserOverrideDisallow: {
        id: "data-classification-level.read-popup.source-space-default-classification-user-override-disallow",
        defaultMessage: "The current classification level is the default for this space. Updates to classification levels aren't permitted."
    },
    sourceOrgDefaultClassificationUserOverrideDisallow: {
        id: "data-classification-level.read-popup.source-org-default-classification-user-override-disallow",
        defaultMessage: "The current classification level is the default for your organization. Updates to classification levels aren't permitted."
    },
    sourceNoneClassificationUserOverrideDisallow: {
        id: "data-classification-level.read-popup.source-none-classification-user-override-disallow",
        defaultMessage: "Updates to classification levels aren't permitted."
    },
    sourceAutoClassificationNotContainerAdmin: {
        id: "data-classification-level.read-popup.source-auto-classification-not-container-admin",
        defaultMessage: "The current classification level is based on information detected in the content. Only users who can manage space settings can update the current classification level."
    },
    sourceUserClassificationNotContainerAdmin: {
        id: "data-classification-level.read-popup.source-user-classification-not-container-admin",
        defaultMessage: "A user assigned the current classification level. Only users who can manage space settings can update the current classification level."
    },
    sourceSpaceDefaultClassificationNotContainerAdmin: {
        id: "data-classification-level.read-popup.source-space-default-classification-not-container-admin",
        defaultMessage: "The current classification level is the default for this space. Only users who can manage space settings can update the current classification level."
    },
    sourceOrgDefaultClassificationNotContainerAdmin: {
        id: "data-classification-level.read-popup.source-org-default-classification-not-container-admin",
        defaultMessage: "The current classification level is the default for your organization. Only users who can manage space settings can update the current classification level."
    },
    sourceNoneClassificationNotContainerAdmin: {
        id: "data-classification-level.read-popup.source-none-classification-not-container-admin",
        defaultMessage: "Only users who can manage space settings can update the current classification level."
    },
    assignClassificationLevel: {
        id: "data-classification-level.edit-popup.assign-classification-level",
        defaultMessage: "Assign classification level"
    },
    lowestPermittedLevelOrgDefault: {
        id: "data-classification-level.edit-popup.lowest-permitted-level-org-default",
        defaultMessage: "Classification levels less sensitive than the organization default aren't available."
    },
    lowestPermittedLevelSpaceDefault: {
        id: "data-classification-level.edit-popup.lowest-permitted-level-space-default",
        defaultMessage: "Classification levels less sensitive than the space default aren't available."
    },
    lowestPermittedLevelAutoClassification: {
        id: "data-classification-level.edit-popup.lowest-permitted-level-auto-classification",
        defaultMessage: "Classification levels less sensitive than the level automatically applied aren't available."
    },
    noSelection: {
        id: "data-classification-level.edit-popup.no-selection",
        defaultMessage: "No selection"
    },
    noSelectionDescription: {
        id: "data-classification-level.edit-popup.no-selection-description",
        defaultMessage: "The classification level will be updated based on the default or detected content."
    },
    assignButton: {
        id: "data-classification-level.edit-popup.assign-button",
        defaultMessage: "Assign"
    }
});
module.exports["messages"] = $3adb11bc26592ffe$export$defe85febe8b728c;

});

parcelRegister("dAbha", function(module, exports) {
/**
 * @fileoverview ADF parsing utilities for handling guideline content
 *
 * TODO: Consider extracting these utilities to a shared ADF library once the API is stable.
 * This would benefit other teams dealing with similar ReactRenderer empty content issues.
 */ /**
 * Valid empty ADF document that ComposableEditor can work with
 */ const $70a050e8fd107260$var$EMPTY_ADF_DOCUMENT = {
    version: 1,
    type: 'doc',
    content: []
};
/**
 * Type guard to check if a parsed object is a valid ADF DocNode
 *
 * Performs basic structural validation of ADF documents. This intentionally does not validate
 * the entire ADF content tree, as ReactRenderer will handle that validation during rendering.
 * This approach allows for graceful degradation - if the ADF is invalid at a deeper level,
 * the component will fallback to plain text rendering.
 *
 * @param {unknown} obj - Object to validate
 * @returns {boolean} True if the object has the basic structure of an ADF DocNode
 */ const $70a050e8fd107260$var$isValidADFDocument = (obj)=>{
    if (!obj || typeof obj !== 'object') return false;
    const doc = obj;
    // ADF documents must have type 'doc', version 1, and content array
    // Note: We don't validate the content array items themselves, as ReactRenderer
    // will handle that and provide appropriate error handling
    return doc.type === 'doc' && doc.version === 1 && Array.isArray(doc.content);
};
/**
 * Checks if a text node is empty (no text or only whitespace)
 */ const $70a050e8fd107260$var$isEmptyText = (node)=>{
    if (!node || typeof node !== 'object') return true;
    const textNode = node;
    if (textNode.type !== 'text') return false;
    const text = textNode.text;
    return !text || text.trim().length === 0;
};
/**
 * Checks if a paragraph node is empty (no content or only empty text nodes)
 */ const $70a050e8fd107260$var$isEmptyParagraph = (node)=>{
    if (!node || typeof node !== 'object') return true;
    const paragraph = node;
    if (paragraph.type !== 'paragraph') return false;
    // Paragraph with no content property or empty array
    if (!('content' in paragraph) || !paragraph.content || paragraph.content.length === 0) return true;
    // Paragraph with only empty text nodes
    return paragraph.content.every($70a050e8fd107260$var$isEmptyText);
};
/**
 * Returns true if the given ADF doc is "visually empty".
 *
 * The ReactRenderer shows "Unsupported text" errors when it encounters certain
 * empty content structures that the backend may return (e.g., paragraphs with
 * empty text nodes). This function detects those cases so we can normalize them
 * to a proper empty ADF document, allowing components to gracefully fallback
 * to plain text rendering.
 *
 * Handles canonical empty forms like:
 * - {"version":1,"type":"doc","content":[]}
 * - {"version":1,"type":"doc","content":[{"type":"paragraph"}]}
 * - {"version":1,"type":"doc","content":[{"type":"paragraph","content":[]}]}
 * - {"version":1,"type":"doc","content":[{"type":"paragraph","content":[{"type":"text","text":""}]}]}
 * - And variations where text is only whitespace
 *
 * Note: Only handles single-paragraph empty documents to avoid false positives.
 * More complex documents are passed through for ReactRenderer to handle.
 *
 * @param {DocNode} doc - ADF document to check
 * @returns {boolean} True if the document is visually empty
 */ const $70a050e8fd107260$var$isVisuallyEmptyAdf = (doc)=>{
    // Type guard - should always be valid at this point
    if (!doc || doc.type !== 'doc') return true;
    const content = doc.content ?? [];
    // Empty content array
    if (content.length === 0) return true;
    // Only handle simple single-paragraph case to avoid false positives
    // More complex documents should be handled by ReactRenderer
    if (content.length === 1) return $70a050e8fd107260$var$isEmptyParagraph(content[0]);
    return false;
};
const $70a050e8fd107260$export$caab9411b15d6295 = (guideline)=>{
    if (!guideline) return $70a050e8fd107260$var$EMPTY_ADF_DOCUMENT;
    try {
        const parsed = JSON.parse(guideline);
        if (!$70a050e8fd107260$var$isValidADFDocument(parsed)) return $70a050e8fd107260$var$EMPTY_ADF_DOCUMENT;
        // Check if the ADF is visually empty (would cause renderer errors)
        if ($70a050e8fd107260$var$isVisuallyEmptyAdf(parsed)) return $70a050e8fd107260$var$EMPTY_ADF_DOCUMENT;
        return parsed;
    } catch  {
        return $70a050e8fd107260$var$EMPTY_ADF_DOCUMENT;
    }
};
module.exports["safeParseGuidelineADF"] = $70a050e8fd107260$export$caab9411b15d6295;

});

parcelRegister("eMflC", function(module, exports) {
const $d97b9ff8f7ce91a4$export$1da3a1abbabd0674 = ({ guidelineADF: guidelineADF, guideline: guideline, guidelineRepresentation: guidelineRepresentation })=>{
    if (guidelineRepresentation === 'EDITOR') // Prefer ADF format when in EDITOR mode, fallback to plain text
    // Use nullish coalescing to treat empty strings as valid values
    return guidelineADF ?? guideline;
    // Use plain text guideline for PLAIN mode
    return guideline;
};
module.exports["selectGuideline"] = $d97b9ff8f7ce91a4$export$1da3a1abbabd0674;

});

parcelRegister("5kxDu", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $a2dfd28afe2e79cc$export$d2e14829910b9b7d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { color: color, width: width, height: height } = t0;
    let t1;
    if ($[0] !== color) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.6309 0.724217L10.6368 0.729015L10.6564 0.744926C10.674 0.759116 10.7003 0.780345 10.7346 0.807883C10.8033 0.86297 10.9038 0.94325 11.03 1.04291C11.2825 1.24238 11.637 1.51872 12.0437 1.82565C12.8662 2.44636 13.8693 3.16677 14.6721 3.63718C15.3586 4.03945 16.2922 4.34531 17.1042 4.55315C17.5006 4.65463 17.8498 4.72824 18.0989 4.7763C18.2232 4.80028 18.3219 4.81775 18.3882 4.82904C18.4214 4.83469 18.4464 4.83877 18.4625 4.84135L18.4797 4.84408L18.4828 4.84456C18.9716 4.91866 19.3332 5.33888 19.3332 5.8333C19.3332 11.6129 17.1353 15.5513 14.9124 18.041C13.8065 19.2797 12.6995 20.1547 11.8642 20.7227C11.4461 21.0071 11.0944 21.2155 10.8427 21.3551C10.7168 21.4249 10.6157 21.4775 10.5435 21.5139C10.5074 21.5321 10.4785 21.5462 10.4574 21.5564C10.4469 21.5615 10.4382 21.5655 10.4316 21.5687L10.4231 21.5726L10.4201 21.5741L10.4188 21.5746C10.4183 21.5749 10.4177 21.5751 9.99984 20.6666C9.58193 21.5751 9.58142 21.5749 9.58087 21.5746L9.57961 21.5741L9.57653 21.5726L9.56808 21.5687C9.56477 21.5671 9.56096 21.5653 9.55666 21.5633C9.55235 21.5612 9.54754 21.5589 9.54226 21.5564C9.52113 21.5462 9.49227 21.5321 9.45618 21.5139C9.38402 21.4775 9.2829 21.4249 9.15697 21.3551C8.90523 21.2155 8.55357 21.0071 8.13544 20.7227C7.30013 20.1547 6.19319 19.2797 5.08723 18.041C2.86434 15.5513 0.666504 11.6129 0.666504 5.8333C0.666504 5.56667 0.772986 5.31108 0.962294 5.12331C1.15074 4.9364 1.40573 4.8321 1.67105 4.83331L1.67917 4.83324C1.68856 4.83313 1.70565 4.83282 1.72992 4.832C1.77849 4.83035 1.85559 4.82664 1.9571 4.81831C2.1605 4.80162 2.45966 4.76655 2.82229 4.69315C3.55079 4.5457 4.51413 4.24791 5.47072 3.65142C6.36007 3.09685 7.32664 2.37311 8.08223 1.77725C8.45737 1.48141 8.77527 1.22127 8.99892 1.03546C9.11068 0.942624 9.1987 0.868514 9.25835 0.817986C9.28817 0.792727 9.31088 0.773375 9.3259 0.760538L9.3426 0.74625L9.34728 0.742228C9.7143 0.426181 10.2551 0.418601 10.6309 0.724217ZM2.68698 6.74634C2.9006 11.4629 4.75094 14.6614 6.57911 16.709C7.55649 17.8036 8.53288 18.5744 9.26006 19.0689C9.55402 19.2688 9.80621 19.4228 9.99984 19.5342C10.1935 19.4228 10.4457 19.2688 10.7396 19.0689C11.4668 18.5744 12.4432 17.8036 13.4206 16.709C15.2602 14.6486 17.1222 11.4228 17.3165 6.65758C17.106 6.61216 16.8662 6.55674 16.6082 6.49068C15.741 6.26872 14.5913 5.90791 13.6609 5.36276C12.7521 4.83022 11.6718 4.05063 10.8389 3.42208C10.5278 3.18731 10.2466 2.97006 10.0155 2.78938C9.81835 2.95079 9.58294 3.14086 9.32067 3.34769C8.544 3.96016 7.51057 4.73642 6.52896 5.34851C5.31888 6.10307 4.11556 6.47195 3.21905 6.6534C3.02778 6.69212 2.84951 6.7225 2.68698 6.74634ZM9.99984 20.6666L9.58087 21.5746C9.84611 21.6966 10.1536 21.6966 10.4188 21.5746L9.99984 20.6666Z",
            fill: color
        });
        $[0] = color;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== height || $[3] !== t1 || $[4] !== width) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: width,
            height: height,
            viewBox: "0 0 20 22",
            xmlns: "http://www.w3.org/2000/svg"
        }, t1);
        $[2] = height;
        $[3] = t1;
        $[4] = width;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ color: color, width: width, height: height })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 22",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.6309 0.724217L10.6368 0.729015L10.6564 0.744926C10.674 0.759116 10.7003 0.780345 10.7346 0.807883C10.8033 0.86297 10.9038 0.94325 11.03 1.04291C11.2825 1.24238 11.637 1.51872 12.0437 1.82565C12.8662 2.44636 13.8693 3.16677 14.6721 3.63718C15.3586 4.03945 16.2922 4.34531 17.1042 4.55315C17.5006 4.65463 17.8498 4.72824 18.0989 4.7763C18.2232 4.80028 18.3219 4.81775 18.3882 4.82904C18.4214 4.83469 18.4464 4.83877 18.4625 4.84135L18.4797 4.84408L18.4828 4.84456C18.9716 4.91866 19.3332 5.33888 19.3332 5.8333C19.3332 11.6129 17.1353 15.5513 14.9124 18.041C13.8065 19.2797 12.6995 20.1547 11.8642 20.7227C11.4461 21.0071 11.0944 21.2155 10.8427 21.3551C10.7168 21.4249 10.6157 21.4775 10.5435 21.5139C10.5074 21.5321 10.4785 21.5462 10.4574 21.5564C10.4469 21.5615 10.4382 21.5655 10.4316 21.5687L10.4231 21.5726L10.4201 21.5741L10.4188 21.5746C10.4183 21.5749 10.4177 21.5751 9.99984 20.6666C9.58193 21.5751 9.58142 21.5749 9.58087 21.5746L9.57961 21.5741L9.57653 21.5726L9.56808 21.5687C9.56477 21.5671 9.56096 21.5653 9.55666 21.5633C9.55235 21.5612 9.54754 21.5589 9.54226 21.5564C9.52113 21.5462 9.49227 21.5321 9.45618 21.5139C9.38402 21.4775 9.2829 21.4249 9.15697 21.3551C8.90523 21.2155 8.55357 21.0071 8.13544 20.7227C7.30013 20.1547 6.19319 19.2797 5.08723 18.041C2.86434 15.5513 0.666504 11.6129 0.666504 5.8333C0.666504 5.56667 0.772986 5.31108 0.962294 5.12331C1.15074 4.9364 1.40573 4.8321 1.67105 4.83331L1.67917 4.83324C1.68856 4.83313 1.70565 4.83282 1.72992 4.832C1.77849 4.83035 1.85559 4.82664 1.9571 4.81831C2.1605 4.80162 2.45966 4.76655 2.82229 4.69315C3.55079 4.5457 4.51413 4.24791 5.47072 3.65142C6.36007 3.09685 7.32664 2.37311 8.08223 1.77725C8.45737 1.48141 8.77527 1.22127 8.99892 1.03546C9.11068 0.942624 9.1987 0.868514 9.25835 0.817986C9.28817 0.792727 9.31088 0.773375 9.3259 0.760538L9.3426 0.74625L9.34728 0.742228C9.7143 0.426181 10.2551 0.418601 10.6309 0.724217ZM2.68698 6.74634C2.9006 11.4629 4.75094 14.6614 6.57911 16.709C7.55649 17.8036 8.53288 18.5744 9.26006 19.0689C9.55402 19.2688 9.80621 19.4228 9.99984 19.5342C10.1935 19.4228 10.4457 19.2688 10.7396 19.0689C11.4668 18.5744 12.4432 17.8036 13.4206 16.709C15.2602 14.6486 17.1222 11.4228 17.3165 6.65758C17.106 6.61216 16.8662 6.55674 16.6082 6.49068C15.741 6.26872 14.5913 5.90791 13.6609 5.36276C12.7521 4.83022 11.6718 4.05063 10.8389 3.42208C10.5278 3.18731 10.2466 2.97006 10.0155 2.78938C9.81835 2.95079 9.58294 3.14086 9.32067 3.34769C8.544 3.96016 7.51057 4.73642 6.52896 5.34851C5.31888 6.10307 4.11556 6.47195 3.21905 6.6534C3.02778 6.69212 2.84951 6.7225 2.68698 6.74634ZM9.99984 20.6666L9.58087 21.5746C9.84611 21.6966 10.1536 21.6966 10.4188 21.5746L9.99984 20.6666Z",
        fill: color
    }));
};
module.exports["ClassificationIcon"] = $a2dfd28afe2e79cc$export$d2e14829910b9b7d;

});

parcelRegister("4B2M3", function(module, exports) {
/* ObservableSpinner.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $lfoFx = parcelRequire("lfoFx");


var $l8oxh = parcelRequire("l8oxh");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5ccd6b86c893b680$var$SpinnerWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_39xV02N91d _0jFU0VUF4f _3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT",
            __cmplp.className
        ])
    });
});
const $5ccd6b86c893b680$var$SpinnerContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4FKVYEdDL8 _4bt5LAnQyn _2WAcuGnQyn _4kiQYAoWWg",
            __cmplp.className
        ])
    });
});
const $5ccd6b86c893b680$export$9c05ccc6295d539b = ({ onScrollTo: onScrollTo, testId: testId, cursor: cursor, observerOptions: observerOptions, spinnerSize: spinnerSize = 'medium' })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8oxh.InfiniteScroll), {
        onScrollTo: onScrollTo,
        cursor: cursor,
        observerOptions: observerOptions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5ccd6b86c893b680$var$SpinnerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5ccd6b86c893b680$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: spinnerSize,
        testId: testId
    }))));
};
module.exports["ObservableSpinner"] = $5ccd6b86c893b680$export$9c05ccc6295d539b;

});

parcelRegister("l8oxh", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $cb0d4ce40dbff1b4$export$c5295390d6167a3e = ({ onScrollTo: onScrollTo, cursor: cursor, observerOptions: observerOptions, children: children })=>{
    const loaderTarget = (0, $cozmU.useRef)(null);
    const previousCursor = (0, $cozmU.useRef)(null);
    // This function is called by the IntersectionObserver API when "loaderTarget" UI element
    // changes visibility.  If it has become visible (typically by user scrolling), call our
    // scroll handler and the parent will attempt to load more data
    const handleIntersect = (0, $cozmU.useCallback)((entries)=>{
        // Sometimes based on an unknown render race condition, the previous IntersectionObserver is not
        // properly cleared before the next one is observed, which causes the 0th indexed IntersectionObserver
        // to never be intersecting, which causes the onScrollTo callback to not be called when it should be.
        // To fix this just get rid of the old observer if it is not properly cleaned up.
        if (entries.length > 1) entries.shift();
        // On the first scroll the previousCursor = null and cursor is a string or undefined
        // Intersection can occur multiple times but we only call onScrollTo again if we have a new cursor.
        if (entries?.[0]?.isIntersecting && cursor !== previousCursor.current) {
            previousCursor.current = cursor;
            onScrollTo();
        }
    }, [
        onScrollTo,
        cursor
    ]);
    // IntersectionObserver detects when our target element becomes visible
    (0, $cozmU.useEffect)(()=>{
        // Adding a positive 'rootMargin' and setting 'root' to the scroll container *should* trigger
        // a positive 'intersection' result (thus loading results) before this element even comes into view
        // (when it is Xpx away from the viewport). 'rootMargin' follows CSS 'margin' syntax.
        // However, this doesn't seem to be working, intersection only triggers when element is in viewport.
        // Have also attempted to pass in a ref from the table tree container instead of querying the document,
        // but that also does not work.
        // @TODO figure out what is wrong here.
        // eslint-disable-next-line
        const observer = new IntersectionObserver(handleIntersect, observerOptions);
        const target = loaderTarget?.current;
        if (target) observer.observe(target);
        return ()=>{
            if (target) observer.unobserve(target);
            observer.disconnect();
        };
    }, [
        loaderTarget,
        handleIntersect,
        observerOptions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cb0d4ce40dbff1b4$var$LoaderTarget, {
        ref: loaderTarget
    }, children);
};
const $cb0d4ce40dbff1b4$var$LoaderTarget = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ children: children }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: ref
    }, children));
module.exports["InfiniteScroll"] = $cb0d4ce40dbff1b4$export$c5295390d6167a3e;

});

parcelRegister("lvOsp", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $7EPz1 = parcelRequire("7EPz1");


var $3u5lg = parcelRequire("3u5lg");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $eqEJl = parcelRequire("eqEJl");


var $8BQV6 = parcelRequire("8BQV6");


var $422HI = parcelRequire("422HI");


var $26Yfd = parcelRequire("26Yfd");


var $bUmU8 = parcelRequire("bUmU8");


var $kczYx = parcelRequire("kczYx");


var $iffSy = parcelRequire("iffSy");


var $3NBsC = parcelRequire("3NBsC");


var $7q7rs = parcelRequire("7q7rs");


var $5T18X = parcelRequire("5T18X");


var $86okN = parcelRequire("86okN");


var $iF5wn = parcelRequire("iF5wn");


var $bFdYQ = parcelRequire("bFdYQ");


var $3VgTg = parcelRequire("3VgTg");


var $7M67g = parcelRequire("7M67g");

/** Synced-each-render ref; no microtask lag. */ function $278c8d04dad7bc1d$var$useSyncedRef(value) {
    const ref = (0, $cozmU.useRef)(value);
    ref.current = value;
    return ref;
}
/**
 * Coerce an unknown thrown value into an ApolloErrorInterop so callers can
 * read Apollo's `graphQLErrors` / `networkError` fields uniformly across the
 * Apollo and Relay branches.
 */ function $278c8d04dad7bc1d$var$toApolloError(err) {
    if ((0, $422HI.isApolloError)(err)) return err;
    const networkError = err instanceof Error ? err : new Error(String(err));
    return new (0, $422HI.ApolloErrorInterop)({
        networkError: networkError
    });
}
function $278c8d04dad7bc1d$var$getOperationName(node) {
    if ('definitions' in node) {
        const def = node.definitions?.find((d)=>d.kind === 'OperationDefinition' && 'name' in d);
        return def?.name?.value ?? 'unknown';
    }
    return 'unknown';
}
function $278c8d04dad7bc1d$export$363a8d7f501f3769(query, options) {
    const operationName = (0, $7M67g.getRelayOperationName)(query);
    if ((0, $iffSy.isRelayEnabled)(options?.__callerPackage__, {
        operationName: operationName,
        phase: 'lazy'
    })) // eslint-disable-next-line react-hooks/rules-of-hooks -- Apollo/Relay route is branch-stable for a given caller package.
    return $278c8d04dad7bc1d$var$useLazyQueryInteropRelay(query, options);
    // eslint-disable-next-line react-hooks/rules-of-hooks -- Apollo/Relay route is branch-stable for a given caller package.
    return $278c8d04dad7bc1d$var$useLazyQueryInteropApollo(query, options);
}
const $278c8d04dad7bc1d$var$useLazyQueryInteropApollo = (0, $3u0dr.isReactCompilerActiveV2)() ? function useLazyQueryInteropApollo(query, options) {
    const $ = (0, $bDgLe.c)(53);
    let apolloFetchPolicy;
    let apolloOptions;
    let interopApolloAggClient;
    let t0;
    if ($[0] !== options) {
        ({ interopApolloAggClient: interopApolloAggClient, ...apolloOptions } = options ?? {});
        apolloFetchPolicy = (0, $7q7rs.mapFetchPolicyForApollo)(apolloOptions.fetchPolicy);
        t0 = (0, $7q7rs.mapFetchPolicyForApollo)(apolloOptions.nextFetchPolicy);
        $[0] = options;
        $[1] = apolloFetchPolicy;
        $[2] = apolloOptions;
        $[3] = interopApolloAggClient;
        $[4] = t0;
    } else {
        apolloFetchPolicy = $[1];
        apolloOptions = $[2];
        interopApolloAggClient = $[3];
        t0 = $[4];
    }
    const apolloNextFetchPolicy = t0;
    const t1 = options?.__callerPackage__;
    let t2;
    if ($[5] !== apolloFetchPolicy || $[6] !== apolloOptions.onCompleted || $[7] !== apolloOptions.variables || $[8] !== interopApolloAggClient || $[9] !== query || $[10] !== t1) {
        t2 = {
            query: query,
            variables: apolloOptions.variables,
            fetchPolicy: apolloFetchPolicy,
            useAggClient: interopApolloAggClient,
            onCompleted: apolloOptions.onCompleted,
            callerPackage: t1
        };
        $[5] = apolloFetchPolicy;
        $[6] = apolloOptions.onCompleted;
        $[7] = apolloOptions.variables;
        $[8] = interopApolloAggClient;
        $[9] = query;
        $[10] = t1;
        $[11] = t2;
    } else t2 = $[11];
    const { getLatestVariables: getLatestVariables, getVariables: getCacheBridgeVariables, isEnabled: isCacheBridgeEnabled, onCompleted: onApolloCompletedWithCacheBridge, syncObservedResult: syncObservedResult, updateLatestVariables: updateLatestVariables } = (0, $3VgTg.useApolloQueryCacheBridgeSync)(t2);
    const onApolloCompleted = isCacheBridgeEnabled ? onApolloCompletedWithCacheBridge : apolloOptions.onCompleted;
    let t3;
    if ($[12] !== query) {
        t3 = (0, $86okN.toDocumentNode)(query);
        $[12] = query;
        $[13] = t3;
    } else t3 = $[13];
    let t4;
    if ($[14] !== apolloNextFetchPolicy) {
        t4 = apolloNextFetchPolicy ? {
            nextFetchPolicy: apolloNextFetchPolicy
        } : {};
        $[14] = apolloNextFetchPolicy;
        $[15] = t4;
    } else t4 = $[15];
    let t5;
    if ($[16] !== onApolloCompleted) {
        t5 = onApolloCompleted ? {
            onCompleted: onApolloCompleted
        } : {};
        $[16] = onApolloCompleted;
        $[17] = t5;
    } else t5 = $[17];
    let t6;
    if ($[18] !== interopApolloAggClient) {
        t6 = interopApolloAggClient ? {
            client: window.GLOBAL_APOLLO_AGG_CLIENT ?? window.MOCK_GATEWAY_APOLLO_CLIENT
        } : {};
        $[18] = interopApolloAggClient;
        $[19] = t6;
    } else t6 = $[19];
    const t7 = apolloOptions?.context;
    const t8 = query.params?.id;
    let t9;
    if ($[20] !== t7 || $[21] !== t8) {
        t9 = {
            ...t7,
            requestId: t8
        };
        $[20] = t7;
        $[21] = t8;
        $[22] = t9;
    } else t9 = $[22];
    let t10;
    if ($[23] !== apolloFetchPolicy || $[24] !== apolloOptions || $[25] !== t4 || $[26] !== t5 || $[27] !== t6 || $[28] !== t9) {
        t10 = {
            ...apolloOptions,
            fetchPolicy: apolloFetchPolicy,
            ...t4,
            ...t5,
            ...t6,
            context: t9
        };
        $[23] = apolloFetchPolicy;
        $[24] = apolloOptions;
        $[25] = t4;
        $[26] = t5;
        $[27] = t6;
        $[28] = t9;
        $[29] = t10;
    } else t10 = $[29];
    const lazyQueryResult = (0, $7EPz1.useLazyQuery)(t3, t10);
    const [executeLazyQuery, apolloResult] = lazyQueryResult;
    const apolloData = apolloResult.data;
    const apolloError = apolloResult.error;
    const apolloCalled = apolloResult.called;
    let t11;
    if ($[30] !== apolloResult.variables || $[31] !== getCacheBridgeVariables) {
        t11 = getCacheBridgeVariables(apolloResult.variables);
        $[30] = apolloResult.variables;
        $[31] = getCacheBridgeVariables;
        $[32] = t11;
    } else t11 = $[32];
    const apolloVariables = t11;
    let t12;
    let t13;
    if ($[33] !== apolloVariables || $[34] !== isCacheBridgeEnabled || $[35] !== updateLatestVariables) {
        t12 = ()=>{
            if (!isCacheBridgeEnabled) return;
            updateLatestVariables(apolloVariables);
        };
        t13 = [
            apolloVariables,
            isCacheBridgeEnabled,
            updateLatestVariables
        ];
        $[33] = apolloVariables;
        $[34] = isCacheBridgeEnabled;
        $[35] = updateLatestVariables;
        $[36] = t12;
        $[37] = t13;
    } else {
        t12 = $[36];
        t13 = $[37];
    }
    (0, $cozmU.useEffect)(t12, t13);
    let t14;
    let t15;
    if ($[38] !== apolloCalled || $[39] !== apolloData || $[40] !== apolloError || $[41] !== apolloVariables || $[42] !== isCacheBridgeEnabled || $[43] !== syncObservedResult) {
        t14 = ()=>{
            if (!isCacheBridgeEnabled) return;
            syncObservedResult({
                skip: !apolloCalled,
                variables: apolloVariables,
                data: apolloData,
                error: apolloError
            });
        };
        t15 = [
            apolloCalled,
            apolloData,
            apolloError,
            apolloVariables,
            isCacheBridgeEnabled,
            syncObservedResult
        ];
        $[38] = apolloCalled;
        $[39] = apolloData;
        $[40] = apolloError;
        $[41] = apolloVariables;
        $[42] = isCacheBridgeEnabled;
        $[43] = syncObservedResult;
        $[44] = t14;
        $[45] = t15;
    } else {
        t14 = $[44];
        t15 = $[45];
    }
    (0, $cozmU.useEffect)(t14, t15);
    let t16;
    if ($[46] !== executeLazyQuery || $[47] !== getLatestVariables || $[48] !== updateLatestVariables) {
        t16 = (executeOptions)=>{
            updateLatestVariables(executeOptions?.variables ?? getLatestVariables());
            return executeLazyQuery(executeOptions);
        };
        $[46] = executeLazyQuery;
        $[47] = getLatestVariables;
        $[48] = updateLatestVariables;
        $[49] = t16;
    } else t16 = $[49];
    const executeLazyQueryWithCacheBridgeVariables = t16;
    if (!isCacheBridgeEnabled) return lazyQueryResult;
    let t17;
    if ($[50] !== apolloResult || $[51] !== executeLazyQueryWithCacheBridgeVariables) {
        t17 = [
            executeLazyQueryWithCacheBridgeVariables,
            apolloResult
        ];
        $[50] = apolloResult;
        $[51] = executeLazyQueryWithCacheBridgeVariables;
        $[52] = t17;
    } else t17 = $[52];
    return t17;
} : function useLazyQueryInteropApollo(query, options) {
    const { interopApolloAggClient: interopApolloAggClient, ...apolloOptions } = options ?? {};
    // Interop-only policies must be translated before they reach Apollo — see mapFetchPolicyForApollo.
    const apolloFetchPolicy = (0, $7q7rs.mapFetchPolicyForApollo)(apolloOptions.fetchPolicy);
    const apolloNextFetchPolicy = (0, $7q7rs.mapFetchPolicyForApollo)(apolloOptions.nextFetchPolicy);
    const { getLatestVariables: getLatestVariables, getVariables: getCacheBridgeVariables, isEnabled: isCacheBridgeEnabled, onCompleted: onApolloCompletedWithCacheBridge, syncObservedResult: syncObservedResult, updateLatestVariables: updateLatestVariables } = (0, $3VgTg.useApolloQueryCacheBridgeSync)({
        query: query,
        variables: apolloOptions.variables,
        fetchPolicy: apolloFetchPolicy,
        useAggClient: interopApolloAggClient,
        onCompleted: apolloOptions.onCompleted,
        callerPackage: options?.__callerPackage__
    });
    const onApolloCompleted = isCacheBridgeEnabled ? onApolloCompletedWithCacheBridge : apolloOptions.onCompleted;
    const lazyQueryResult = (0, $7EPz1.useLazyQuery)((0, $86okN.toDocumentNode)(query), {
        ...apolloOptions,
        fetchPolicy: apolloFetchPolicy,
        ...apolloNextFetchPolicy ? {
            nextFetchPolicy: apolloNextFetchPolicy
        } : {},
        ...onApolloCompleted ? {
            onCompleted: onApolloCompleted
        } : {},
        ...interopApolloAggClient ? {
            client: window['GLOBAL_APOLLO_AGG_CLIENT'] ?? window['MOCK_GATEWAY_APOLLO_CLIENT']
        } : {},
        context: {
            ...apolloOptions?.context,
            requestId: query.params?.id
        }
    });
    const [executeLazyQuery, apolloResult] = lazyQueryResult;
    const apolloData = apolloResult.data;
    const apolloError = apolloResult.error;
    const apolloCalled = apolloResult.called;
    const apolloVariables = getCacheBridgeVariables(apolloResult.variables);
    (0, $cozmU.useEffect)(()=>{
        if (!isCacheBridgeEnabled) return;
        updateLatestVariables(apolloVariables);
    }, [
        apolloVariables,
        isCacheBridgeEnabled,
        updateLatestVariables
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isCacheBridgeEnabled) return;
        syncObservedResult({
            skip: !apolloCalled,
            variables: apolloVariables,
            data: apolloData,
            error: apolloError
        });
    }, [
        apolloCalled,
        apolloData,
        apolloError,
        apolloVariables,
        isCacheBridgeEnabled,
        syncObservedResult
    ]);
    const executeLazyQueryWithCacheBridgeVariables = (0, $cozmU.useCallback)((executeOptions)=>{
        updateLatestVariables(executeOptions?.variables ?? getLatestVariables());
        return executeLazyQuery(executeOptions);
    }, [
        executeLazyQuery,
        getLatestVariables,
        updateLatestVariables
    ]);
    if (!isCacheBridgeEnabled) return lazyQueryResult;
    return [
        executeLazyQueryWithCacheBridgeVariables,
        apolloResult
    ];
};
function $278c8d04dad7bc1d$var$useLazyQueryInteropRelay(query, options) {
    // Validate before any hook call so the throw isn't masked by useRelayEnvironment().
    if (!('params' in query)) throw new Error(`[Relay migration] unsupported tagged node provided for operation "${$278c8d04dad7bc1d$var$getOperationName(query)}". Please make sure you generated Relay artifacts for your operation`);
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const operationName = (0, $7M67g.getRelayOperationName)(query) ?? undefined;
    const hookVariables = (0, $iF5wn.useMemoObj)(options?.variables, options?.__callerPackage__, {
        operationName: operationName,
        phase: 'memo'
    });
    const hookContext = options?.context;
    // Match Apollo's cache-first default rather than inheriting fetchQuery's
    // network-only default when the caller omits fetchPolicy.
    // See the equivalent comment in useQueryInterop: 'no-store' suppresses store reads as well as
    // writes, and is derived from the initial policy only.
    const noStore = (0, $3NBsC.isNoStoreFetchPolicy)(options?.fetchPolicy);
    const initialFetchPolicy = (0, $3NBsC.mapFetchPolicyForQuery)(options?.fetchPolicy);
    const subsequentFetchPolicy = options?.nextFetchPolicy ? (0, $3NBsC.mapFetchPolicyForQuery)(options.nextFetchPolicy) : initialFetchPolicy;
    const cacheBridgeFetchPolicy = options?.fetchPolicy;
    const cacheBridgeSubsequentFetchPolicy = options?.nextFetchPolicy ?? cacheBridgeFetchPolicy;
    const interopApolloAggClient = options?.interopApolloAggClient;
    const pollInterval = options?.pollInterval ?? 0;
    const notifyOnNetworkStatusChange = options?.notifyOnNetworkStatusChange || false;
    const onError = (0, $26Yfd.useStableCallback)(options?.onError ?? function noop() {});
    const onCompleted = (0, $26Yfd.useStableCallback)(options?.onCompleted ?? function noop() {});
    // Defers onCompleted/onError to a post-commit effect so callers observe the state
    // that describes the result being reported, matching Apollo — whose lazy path routes
    // through the same `afterExecute` -> `handleErrorOrCompleted` effect once the query
    // has been run. `queueNotification` is referentially stable, so listing it in the
    // `execute`/`fetchMore` dependency arrays cannot re-issue a request.
    const { queueNotification: queueNotification, markLoading: markLoading } = (0, $bUmU8.useDeferredQueryNotifications)({
        onCompleted: onCompleted,
        onError: onError,
        hasCallbacks: Boolean(options?.onCompleted || options?.onError)
    });
    const [data, setData] = (0, $cozmU.useState)(undefined);
    const [error, setError] = (0, $cozmU.useState)(undefined);
    const [loading, setLoading] = (0, $cozmU.useState)(false);
    const [called, setCalled] = (0, $cozmU.useState)(false);
    // Mirrors Apollo's `variables` from the most recent invocation.
    const [activeVariables, setActiveVariables] = (0, $cozmU.useState)(hookVariables);
    // True only while a poll tick is the in-flight request. Apollo reports a tick as
    // `networkStatus: poll` rather than `loading`, and the lazy result has no `networkStatus`
    // field, so this flag is what keeps a tick out of the UFO hold below.
    const [isPollTickInFlight, setIsPollTickInFlight] = (0, $cozmU.useState)(false);
    const isMountedRef = (0, $cozmU.useRef)(true);
    (0, $cozmU.useEffect)(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    // Subscribe to cache updates after query is called to keep data reactive.
    // This ensures that when mutations update the cache, components using this
    // lazy query will automatically re-render with the fresh data, matching
    // Apollo's behavior where useLazyQuery subscribes to cache changes.
    // See: https://hello.atlassian.net/browse/COPPER-XXXXX (Star menu bug)
    (0, $cozmU.useEffect)(()=>{
        if (!called) return;
        // 'no-store' writes nothing, so there is no record of its own to watch — and subscribing
        // would surface *other* operations' writes to the same ids, which is the pollution the
        // policy exists to prevent. These queries refetch explicitly instead.
        if (noStore) return;
        // Subscribe to the Relay store to watch for cache updates (e.g., from mutations).
        // This matches the pattern used in useQueryInterop for reactive cache updates.
        const operation = (0, $eqEJl.createOperationDescriptor)((0, $eqEJl.getRequest)(query), activeVariables);
        const retainDisposable = environment.retain(operation);
        const storeSubscription = environment.subscribe(environment.lookup(operation.fragment), (snapshot)=>{
            // Only update if mounted and data is not missing from cache
            if (isMountedRef.current && !snapshot.isMissingData) setData(snapshot.data);
        });
        return ()=>{
            storeSubscription.dispose();
            retainDisposable.dispose();
        };
    }, [
        called,
        environment,
        query,
        activeVariables,
        noStore
    ]);
    // Sequencing counters discard out-of-order responses.
    const executeIdRef = (0, $cozmU.useRef)(0);
    const fetchMoreIdRef = (0, $cozmU.useRef)(0);
    // A poll tick must not race an `execute` for the same query — see `pollTick`.
    const executeInFlightRef = (0, $cozmU.useRef)(false);
    // hookContext is unmemoised; data/activeVariables can change mid-fetchMore via a concurrent execute.
    const hookContextRef = $278c8d04dad7bc1d$var$useSyncedRef(hookContext);
    const dataRef = $278c8d04dad7bc1d$var$useSyncedRef(data);
    const activeVarsRef = $278c8d04dad7bc1d$var$useSyncedRef(activeVariables);
    const mirrorRelayResultToApollo = (0, $cozmU.useCallback)((relayResult, resultVariables, fetchPolicy)=>{
        // Lazy Relay execution remains the original source of truth; mirror
        // successful payloads into Apollo with the variables from that run.
        (0, $bFdYQ.syncQueryCacheBridge)({
            source: 'relay',
            query: query,
            variables: resultVariables,
            data: relayResult,
            fetchPolicy: fetchPolicy,
            useAggClient: interopApolloAggClient
        });
    }, [
        interopApolloAggClient,
        query
    ]);
    const ufoContext = (0, $cozmU.useContext)((0, $8BQV6.default));
    const ufoOperationName = `relay_${query.params?.name ?? 'unnamed'}`;
    (0, $cozmU.useEffect)(()=>{
        // A poll tick is excluded: it can repeat indefinitely, so holding the interaction for one
        // would never release. Mirrors useQueryInterop, which excludes `networkStatus: poll`.
        if (called && loading && !isPollTickInFlight) return ufoContext?.hold(ufoOperationName);
    }, [
        called,
        loading,
        isPollTickInFlight,
        ufoOperationName,
        ufoContext
    ]);
    const execute = (0, $cozmU.useCallback)((executeOptions)=>{
        const variables = executeOptions?.variables ?? hookVariables;
        const context = {
            ...hookContextRef.current,
            ...executeOptions?.context
        };
        // First execute uses fetchPolicy, re-invocations use nextFetchPolicy.
        const isFirstCall = executeIdRef.current === 0;
        const cacheBridgeResultFetchPolicy = isFirstCall ? cacheBridgeFetchPolicy : cacheBridgeSubsequentFetchPolicy;
        executeIdRef.current += 1;
        // Invalidate any in-flight fetchMore so it can't merge into fresh execute data.
        fetchMoreIdRef.current += 1;
        const id = executeIdRef.current;
        const isStillCurrent = ()=>isMountedRef.current && id === executeIdRef.current;
        setCalled(true);
        setActiveVariables(variables);
        setLoading(true);
        setError(undefined);
        // Every execute is a fresh loading transition, so a repeat execute with identical
        // variables still reports — matching Apollo, whose dedup guard is bypassed by the
        // loading flag going true.
        markLoading();
        executeInFlightRef.current = true;
        (0, $kczYx.fetchQuery)(environment, query, variables, {
            fetchPolicy: isFirstCall ? initialFetchPolicy : subsequentFetchPolicy,
            networkCacheConfig: {
                metadata: context
            }
        }, {
            noStore: noStore
        }).toPromise().then((result)=>{
            // Cleared even when unmounted, and only by the latest execute, so a superseded
            // response cannot open the door for a poll tick while a newer request is in flight.
            if (id === executeIdRef.current) executeInFlightRef.current = false;
            if (!isStillCurrent()) return;
            setLoading(false);
            if (result !== undefined) {
                mirrorRelayResultToApollo(result, variables, cacheBridgeResultFetchPolicy);
                setData(result);
                setError(undefined);
                queueNotification({
                    type: 'completed',
                    data: result,
                    identity: {
                        query: query,
                        variables: variables
                    }
                });
                return;
            }
            // Store-only cache miss: surface so callers aren't left indeterminate.
            const err = $278c8d04dad7bc1d$var$toApolloError(new Error('[Relay migration] fetchQuery resolved with no data (likely a store-only cache miss)'));
            setError(err);
            queueNotification({
                type: 'error',
                error: err,
                identity: {
                    query: query,
                    variables: variables
                }
            });
        }).catch((rawErr)=>{
            if (id === executeIdRef.current) executeInFlightRef.current = false;
            if (!isStillCurrent()) return;
            const err = $278c8d04dad7bc1d$var$toApolloError(rawErr);
            setError(err);
            setLoading(false);
            queueNotification({
                type: 'error',
                error: err,
                identity: {
                    query: query,
                    variables: variables
                }
            });
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- refs (hookContextRef) have stable identity, omitted intentionally
    [
        environment,
        query,
        hookVariables,
        initialFetchPolicy,
        subsequentFetchPolicy,
        cacheBridgeFetchPolicy,
        cacheBridgeSubsequentFetchPolicy,
        mirrorRelayResultToApollo,
        queueNotification,
        markLoading,
        noStore
    ]);
    const fetchMore = (0, $cozmU.useCallback)((fetchMoreOpts)=>{
        const baseVariables = activeVarsRef.current;
        const variables = {
            ...baseVariables,
            ...fetchMoreOpts.variables
        };
        fetchMoreIdRef.current += 1;
        const id = fetchMoreIdRef.current;
        const isStillCurrent = ()=>isMountedRef.current && id === fetchMoreIdRef.current;
        setLoading(true);
        return (0, $kczYx.fetchQuery)(environment, query, variables, {
            // fetchMore must always hit the network (matches Apollo); cached pages would be stale.
            fetchPolicy: 'network-only',
            networkCacheConfig: {
                metadata: hookContextRef.current
            }
        }, {
            noStore: noStore
        }).toPromise().then((fetchMoreResult)=>{
            // Throw so .catch handles it (avoids double onError).
            if (fetchMoreResult === undefined) throw new Error('[Relay migration] fetchMore resolved with no data (likely a store-only cache miss)');
            const merged = fetchMoreOpts.updateQuery(dataRef.current ?? {}, {
                fetchMoreResult: fetchMoreResult,
                variables: variables
            });
            if (isStillCurrent()) {
                mirrorRelayResultToApollo(merged, baseVariables, cacheBridgeSubsequentFetchPolicy);
                setData(merged);
                setLoading(false);
                setError(undefined);
            }
            return {
                data: merged,
                loading: false,
                networkStatus: (0, $5T18X.NetworkStatus).ready,
                stale: false
            };
        }).catch((rawErr)=>{
            // Deliberately does NOT report via onError. Measured against real Apollo
            // (useLazyQuery + fetchMore, success and failure, either
            // notifyOnNetworkStatusChange): neither callback is invoked — the promise
            // rejection is the only signal. Reporting here would over-fire relative to
            // Apollo and disagree with useQueryInterop.fetchMore, which reports nothing.
            // Error state is still surfaced so the hook's `error` field stays accurate.
            const err = $278c8d04dad7bc1d$var$toApolloError(rawErr);
            if (isStillCurrent()) {
                setError(err);
                setLoading(false);
            }
            throw err;
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- refs (activeVarsRef, dataRef, hookContextRef) have stable identity, omitted intentionally
    [
        environment,
        query,
        cacheBridgeSubsequentFetchPolicy,
        mirrorRelayResultToApollo,
        noStore
    ]);
    // ── Polling ──────────────────────────────────────────────────────────────────────────────
    // Apollo's lazy queries DO poll, contrary to what this hook previously assumed. `pollInterval`
    // reaches `client.watchQuery`, and `ObservableQuery.setUpQuery` starts the timer as soon as the
    // observable is subscribed — which for `useLazyQuery` is the first `execute`, since
    // `QueryData.execute` short-circuits until `runLazy` is true. Dropping the option left callers
    // with a single request and a promise that never resolves: the report/long-task call sites poll
    // a `ConfluenceLongTask` until it reports success, so one `InProgress` response stalled them
    // forever with no error to show for it.
    // A generation counter invalidates ticks that a `stopPolling()` or an effect teardown has
    // superseded, so an in-flight tick can never schedule its successor after being cancelled.
    const pollGenerationRef = (0, $cozmU.useRef)(0);
    const pollTimeoutRef = (0, $cozmU.useRef)(null);
    // The variables that were active when the caller last called `stopPolling()`. Apollo's
    // `stopPolling` is sticky: it clears `options.pollInterval` on the observable, and polling only
    // resumes once the *prepared* options change — i.e. a later `execute` with different variables
    // (`QueryData.updateObservableQuery` -> `ObservableQuery.setOptions` -> `startPolling`). A bare
    // re-execute with identical variables leaves polling stopped, so the guard is deep-compared
    // against the active variables rather than just cleared on the next execute.
    const pollStoppedVariablesRef = (0, $cozmU.useRef)(null);
    // Declared ahead of `pollTick` so a tick can schedule its successor without referencing its own
    // binding; re-pointed at the freshly-closed-over `pollTick` on every render below.
    const pollTickRef = (0, $cozmU.useRef)(()=>{});
    const cancelScheduledPoll = (0, $cozmU.useCallback)(()=>{
        pollGenerationRef.current += 1;
        if (pollTimeoutRef.current !== null) {
            clearTimeout(pollTimeoutRef.current);
            pollTimeoutRef.current = null;
        }
    }, []);
    const stopPolling = (0, $cozmU.useCallback)(()=>{
        pollStoppedVariablesRef.current = activeVarsRef.current;
        cancelScheduledPoll();
    }, [
        cancelScheduledPoll,
        activeVarsRef
    ]);
    // Redefined each render rather than memoised, and reached only through the synced ref below, so
    // a tick always closes over the current environment/variables/callbacks with no stale-closure
    // window and no dependency array that could re-arm the timer.
    const pollTick = (interval, generation)=>{
        const isCurrentGeneration = ()=>isMountedRef.current && generation === pollGenerationRef.current;
        const scheduleNextTick = ()=>{
            if (!isCurrentGeneration()) return;
            // setTimeout chained off the previous tick's settlement, not setInterval: Apollo
            // reschedules in `poll()` only after the fetch resolves or rejects
            // (`QueryManager.startPollingQuery`), so a response slower than the interval can never
            // stack requests.
            pollTimeoutRef.current = setTimeout(()=>pollTickRef.current(interval, generation), interval);
        };
        // Apollo skips a tick outright while a request for the query is already in flight and just
        // reschedules (`maybeFetch` -> `checkInFlight`).
        if (executeInFlightRef.current) {
            scheduleNextTick();
            return;
        }
        const variables = activeVarsRef.current;
        if (notifyOnNetworkStatusChange) {
            setIsPollTickInFlight(true);
            setLoading(true);
        }
        (0, $kczYx.fetchQuery)(environment, query, variables, {
            // Apollo forces `network-only` on every tick regardless of the query's own policy
            // (`startPollingQuery` overrides `info.options.fetchPolicy`) — a poll that could be
            // served from the cache would never observe the change it is polling for.
            fetchPolicy: 'network-only',
            networkCacheConfig: {
                metadata: hookContextRef.current
            }
        }, {
            noStore: noStore
        }).toPromise().then((result)=>{
            if (!isMountedRef.current) return;
            if (notifyOnNetworkStatusChange) {
                setIsPollTickInFlight(false);
                setLoading(false);
            }
            if (!isCurrentGeneration()) return;
            // Guard against empty completions so a store-only miss can't wipe `data`.
            if (result !== undefined) {
                mirrorRelayResultToApollo(result, variables, cacheBridgeSubsequentFetchPolicy);
                setData(result);
                setError(undefined);
                // `markLoading()` is deliberately NOT called for a tick: the dedup guard in
                // useDeferredQueryNotifications then suppresses this notification for an
                // unchanged operation, which is what makes a tick apply its data without
                // reporting to onCompleted/onError. Same arrangement as useQueryInterop's
                // runPollTick, and the contract callers are documented against.
                queueNotification({
                    type: 'completed',
                    data: result,
                    identity: {
                        query: query,
                        variables: variables
                    }
                });
            }
            scheduleNextTick();
        }).catch((rawErr)=>{
            if (!isMountedRef.current) return;
            if (notifyOnNetworkStatusChange) {
                setIsPollTickInFlight(false);
                setLoading(false);
            }
            if (!isCurrentGeneration()) return;
            const err = $278c8d04dad7bc1d$var$toApolloError(rawErr);
            setError(err);
            queueNotification({
                type: 'error',
                error: err,
                identity: {
                    query: query,
                    variables: variables
                }
            });
            // Apollo keeps polling after a failed tick (`fetchQuery(...).then(poll, poll)`).
            scheduleNextTick();
        });
    };
    pollTickRef.current = pollTick;
    (0, $cozmU.useEffect)(()=>{
        // Gated on `called`, not mount: Apollo cannot poll before the observable is subscribed, and
        // for a lazy query that is the first `execute`.
        if (!called || pollInterval <= 0) return;
        // Apollo's QueryManager does not poll in `ssrMode`.
        if (typeof window === 'undefined') return;
        if (pollStoppedVariablesRef.current !== null && (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(pollStoppedVariablesRef.current, activeVariables)) return;
        pollStoppedVariablesRef.current = null;
        pollGenerationRef.current += 1;
        const generation = pollGenerationRef.current;
        // First tick lands one interval after the execute, matching Apollo's initial `poll()`.
        pollTimeoutRef.current = setTimeout(()=>pollTickRef.current(pollInterval, generation), pollInterval);
        return cancelScheduledPoll;
    // `activeVariables` is a dependency so a re-execute re-arms the timer from now, as Apollo's
    // `setOptions` -> `startPolling` does when the prepared options change.
    }, [
        called,
        pollInterval,
        activeVariables,
        cancelScheduledPoll
    ]);
    // Cast: Apollo's overloaded fetchMore is structurally a superset of FetchMoreType.
    return [
        execute,
        {
            data: data,
            loading: loading,
            error: error,
            called: called,
            variables: activeVariables,
            fetchMore: fetchMore,
            stopPolling: stopPolling
        }
    ];
}
module.exports["useLazyQueryInterop"] = $278c8d04dad7bc1d$export$363a8d7f501f3769;

});

parcelRegister("3b6WO", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $kSwu1 = parcelRequire("kSwu1");


var $cozmU = parcelRequire("cozmU");


var $isuYJ = parcelRequire("isuYJ");


var $hzmpb = parcelRequire("hzmpb");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");


var $kqIWy = parcelRequire("kqIWy");


var $bFDX4 = parcelRequire("bFDX4");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $7Ndnw = parcelRequire("7Ndnw");


var $6qkXi = parcelRequire("6qkXi");

const $8eb9026be26e0c85$export$cab421e039d23b2 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(26);
    const { moduleType: moduleType, queryOptions: queryOptions, returnBlockedExtensions: t1, skipQuery: t2, spaceContextOnly: spaceContextOnly, skipSpaceDetail: t3, attachmentId: attachmentId, contentId: providedContentId, spaceKey: providedSpaceKey } = t0;
    const returnBlockedExtensions = t1 === undefined ? false : t1;
    const skipQuery = t2 === undefined ? false : t2;
    const skipSpaceDetail = t3 === undefined ? false : t3;
    const { locale: locale } = (0, $kSwu1.useIntl)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [pageSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const spaceKey = providedSpaceKey || pageSpaceKey;
    const [pageContentId] = (0, $ep3mz.usePageContentId)();
    const contentId = providedContentId || pageContentId;
    const resolvedAttachmentId = attachmentId && (0, $9wGTI.fg)("forge_attachment_display_conditions") ? attachmentId : undefined;
    let t4;
    if ($[0] !== skipSpaceDetail) {
        t4 = {
            skip: skipSpaceDetail
        };
        $[0] = skipSpaceDetail;
        $[1] = t4;
    } else t4 = $[1];
    const { error: spaceError } = (0, $kqIWy.useSpaceDetail)(spaceKey, t4);
    let t5;
    if ($[2] !== moduleType) {
        t5 = ()=>window.__SSR_FORGE_EXTENSIONS__?.[moduleType];
        $[2] = moduleType;
        $[3] = t5;
    } else t5 = $[3];
    const [ssrExtensionResult] = (0, $cozmU.useState)(t5);
    let t6;
    if ($[4] !== cloudId || $[5] !== contentId || $[6] !== locale || $[7] !== moduleType || $[8] !== queryOptions || $[9] !== resolvedAttachmentId || $[10] !== returnBlockedExtensions || $[11] !== skipQuery || $[12] !== spaceContextOnly || $[13] !== spaceKey) {
        t6 = (0, $6qkXi.getUsePrefilteredExtensionListOptions)({
            cloudId: cloudId,
            locale: locale,
            moduleType: moduleType,
            queryOptions: {
                ...queryOptions,
                skip: skipQuery
            },
            includeHidden: returnBlockedExtensions,
            spaceKey: spaceKey,
            contentId: contentId,
            ...resolvedAttachmentId ? {
                attachmentId: resolvedAttachmentId
            } : {},
            spaceContextOnly: spaceContextOnly
        });
        $[4] = cloudId;
        $[5] = contentId;
        $[6] = locale;
        $[7] = moduleType;
        $[8] = queryOptions;
        $[9] = resolvedAttachmentId;
        $[10] = returnBlockedExtensions;
        $[11] = skipQuery;
        $[12] = spaceContextOnly;
        $[13] = spaceKey;
        $[14] = t6;
    } else t6 = $[14];
    const options = t6;
    const { extensions: extsData, loading: extsLoading, error: extsError } = $8eb9026be26e0c85$var$usePrefilteredExtensionList(options);
    let t7;
    let t8;
    if ($[15] !== extsError || $[16] !== spaceError) {
        t7 = ()=>{
            if (extsError && (0, $1uFM6.isUnauthorizedError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
            if ((0, $bFDX4.isTooManyRequestsError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
            if (spaceError) (0, $7Sm4c.markErrorAsHandled)(spaceError);
        };
        t8 = [
            extsError,
            spaceError
        ];
        $[15] = extsError;
        $[16] = spaceError;
        $[17] = t7;
        $[18] = t8;
    } else {
        t7 = $[17];
        t8 = $[18];
    }
    (0, $cozmU.useEffect)(t7, t8);
    if (!skipQuery && extsLoading && ssrExtensionResult !== undefined && ssrExtensionResult.context !== undefined && ssrExtensionResult.context.spaceKey === spaceKey && ssrExtensionResult.context.includeHidden === returnBlockedExtensions && ssrExtensionResult.context.spaceContextOnly === Boolean(spaceContextOnly) && (spaceContextOnly || ssrExtensionResult.context.contentId === contentId) && (moduleType === (0, $7Ndnw.FORGE_MODULE_SPACE_PAGE) || moduleType === (0, $7Ndnw.FORGE_MODULE_BYLINE) && (0, $6mKj3.expValEquals)("confluence_ssr_byline", "isEnabled", true))) {
        let t9;
        if ($[19] !== ssrExtensionResult.error || $[20] !== ssrExtensionResult.extensions) {
            t9 = {
                extensions: ssrExtensionResult.extensions,
                loading: false,
                error: ssrExtensionResult.error
            };
            $[19] = ssrExtensionResult.error;
            $[20] = ssrExtensionResult.extensions;
            $[21] = t9;
        } else t9 = $[21];
        return t9;
    }
    let t9;
    if ($[22] !== extsData || $[23] !== extsError || $[24] !== extsLoading) {
        t9 = {
            extensions: extsData,
            loading: extsLoading,
            error: extsError
        };
        $[22] = extsData;
        $[23] = extsError;
        $[24] = extsLoading;
        $[25] = t9;
    } else t9 = $[25];
    return t9;
} : ({ moduleType: moduleType, queryOptions: queryOptions, returnBlockedExtensions: returnBlockedExtensions = false, skipQuery: skipQuery = false, spaceContextOnly: spaceContextOnly, skipSpaceDetail: skipSpaceDetail = false, attachmentId: attachmentId, contentId: providedContentId, spaceKey: providedSpaceKey })=>{
    const { locale: locale } = (0, $kSwu1.useIntl)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [pageSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const spaceKey = providedSpaceKey || pageSpaceKey;
    const [pageContentId] = (0, $ep3mz.usePageContentId)();
    const contentId = providedContentId || pageContentId;
    const resolvedAttachmentId = attachmentId && (0, $9wGTI.fg)('forge_attachment_display_conditions') ? attachmentId : undefined;
    const { error: spaceError } = (0, $kqIWy.useSpaceDetail)(spaceKey, {
        skip: skipSpaceDetail
    });
    const [ssrExtensionResult] = (0, $cozmU.useState)(()=>window.__SSR_FORGE_EXTENSIONS__?.[moduleType]);
    const options = (0, $cozmU.useMemo)(()=>(0, $6qkXi.getUsePrefilteredExtensionListOptions)({
            cloudId: cloudId,
            locale: locale,
            moduleType: moduleType,
            queryOptions: {
                ...queryOptions,
                skip: skipQuery
            },
            includeHidden: returnBlockedExtensions,
            spaceKey: spaceKey,
            contentId: contentId,
            ...resolvedAttachmentId ? {
                attachmentId: resolvedAttachmentId
            } : {},
            spaceContextOnly: spaceContextOnly
        }), [
        cloudId,
        locale,
        moduleType,
        queryOptions,
        returnBlockedExtensions,
        skipQuery,
        spaceKey,
        contentId,
        resolvedAttachmentId,
        spaceContextOnly
    ]);
    const { extensions: extsData, loading: extsLoading, error: extsError } = $8eb9026be26e0c85$var$usePrefilteredExtensionList(options);
    (0, $cozmU.useEffect)(()=>{
        // suppress 403 errors as we can't do much with them
        if (extsError && (0, $1uFM6.isUnauthorizedError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
        // suppress 429 errors for offending users
        if ((0, $bFDX4.isTooManyRequestsError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
        if (spaceError) (0, $7Sm4c.markErrorAsHandled)(spaceError);
    }, [
        extsError,
        spaceError
    ]);
    if (!skipQuery && extsLoading && ssrExtensionResult !== undefined && ssrExtensionResult.context !== undefined && ssrExtensionResult.context.spaceKey === spaceKey && ssrExtensionResult.context.includeHidden === returnBlockedExtensions && ssrExtensionResult.context.spaceContextOnly === Boolean(spaceContextOnly) && (spaceContextOnly || ssrExtensionResult.context.contentId === contentId) && (moduleType === (0, $7Ndnw.FORGE_MODULE_SPACE_PAGE) || moduleType === (0, $7Ndnw.FORGE_MODULE_BYLINE) && (0, $6mKj3.expValEquals)('confluence_ssr_byline', 'isEnabled', true))) return {
        extensions: ssrExtensionResult.extensions,
        loading: false,
        error: ssrExtensionResult.error
    };
    return {
        extensions: extsData,
        loading: extsLoading,
        error: extsError
    };
};
const $8eb9026be26e0c85$var$usePrefilteredExtensionList = (0, $isuYJ.conditionalHooksFactory)(()=>(0, $9wGTI.fg)('forge-ui-migrate-extension-list-query-to-relay'), (0, $hzmpb.usePrefilteredExtensionListRelay), (0, $hzmpb.usePrefilteredExtensionList));
module.exports["useExtensionList"] = $8eb9026be26e0c85$export$cab421e039d23b2;

});

parcelRegister("6qkXi", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $gKr8t = parcelRequire("gKr8t");

const $26379cee560cb131$export$4b3c44afb1a70b38 = ({ cloudId: cloudId, locale: locale, moduleType: moduleType, queryOptions: queryOptions, includeHidden: includeHidden, spaceKey: spaceKey, contentId: contentId, attachmentId: attachmentId, spaceContextOnly: spaceContextOnly = false })=>{
    const context = spaceContextOnly ? {
        spaceKey: spaceKey
    } : {
        spaceKey: spaceKey,
        contentId: contentId,
        ...attachmentId && (0, $9wGTI.fg)('forge_attachment_display_conditions') ? {
            attachmentId: attachmentId
        } : {}
    };
    const options = {
        client: (0, $gKr8t.getAGGClient)(),
        cloudId: cloudId,
        types: [
            moduleType
        ],
        queryOptions: {
            ...queryOptions
        },
        locale: locale,
        context: context,
        includeHidden: includeHidden
    };
    return options;
};
module.exports["getUsePrefilteredExtensionListOptions"] = $26379cee560cb131$export$4b3c44afb1a70b38;

});

parcelRegister("jYZsR", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $55fM8 = parcelRequire("55fM8");

const $0b4c17fd4adf87fd$export$de5a461d22cbfa90 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { onUpdate: onUpdate, popupRef: popupRef, children: children } = t0;
    let t1;
    let t2;
    if ($[0] !== onUpdate || $[1] !== popupRef) {
        t1 = ()=>{
            if (!popupRef) return;
            const updateWithDelay = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(onUpdate, 100);
            const observer = new ResizeObserver(()=>{
                updateWithDelay();
            });
            observer.observe(popupRef);
            return ()=>{
                updateWithDelay.cancel();
                observer.disconnect();
            };
        };
        t2 = [
            popupRef,
            onUpdate
        ];
        $[0] = onUpdate;
        $[1] = popupRef;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[4] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children);
        $[4] = children;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : ({ onUpdate: onUpdate, popupRef: popupRef, children: children })=>{
    (0, $cozmU.useEffect)(()=>{
        if (!popupRef) return;
        const updateWithDelay = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(onUpdate, 100);
        // Workaround to update popup position (by using scheduleUpdate function)
        // on any Forge App resize
        const observer = new ResizeObserver(()=>{
            updateWithDelay();
        });
        observer.observe(popupRef);
        return ()=>{
            updateWithDelay.cancel();
            observer.disconnect();
        };
    }, [
        popupRef,
        onUpdate
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children);
};
module.exports["ResizeChangeListener"] = $0b4c17fd4adf87fd$export$de5a461d22cbfa90;

});

parcelRegister("kZEms", function(module, exports) {
/* ViewPageLabelsLoader.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $jmjWc = parcelRequire("jmjWc");


var $7boqA = parcelRequire("7boqA");


var $PPtZc = parcelRequire("PPtZc");

const $ba30ab1568e9f84e$export$78128841bacb1fe0 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_39xV02N91d _0jFU0VUF4f",
            __cmplp.className
        ])
    });
});

const $ba30ab1568e9f84e$var$ViewPageLabelsLoaderBase = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "vfOAM",
    name: "ViewPageLabelsLoaderBase",
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ba30ab1568e9f84e$export$78128841bacb1fe0, null),
    loader: async ()=>(await (parcelRequire("1nROP"))).ViewPageLabels
});
const $ba30ab1568e9f84e$export$34eb2891dd16ab98 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
        metric: (0, $PPtZc.VIEW_PAGE_LABELS_METRIC)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ba30ab1568e9f84e$var$ViewPageLabelsLoaderBase, props));
module.exports["LabelsSelectPlaceholder"] = $ba30ab1568e9f84e$export$78128841bacb1fe0;
module.exports["ViewPageLabelsLoader"] = $ba30ab1568e9f84e$export$34eb2891dd16ab98;

});

parcelRegister("PPtZc", function(module, exports) {

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");

const $7c335dc4c85f3f9f$export$3a36b2d62e2d34a2 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.VIEW_PAGE_LABELS_METRIC_KEY)
});
module.exports["VIEW_PAGE_LABELS_METRIC"] = $7c335dc4c85f3f9f$export$3a36b2d62e2d34a2;

});

parcelRegister("1nROP", function(module, exports) {

let $1021afbd6437aa49$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1021afbd6437aa49$var$load("aLbuU"),
    $1021afbd6437aa49$var$load("ezYRV"),
    $1021afbd6437aa49$var$load("6wr18"),
    $1021afbd6437aa49$var$load("4fYzp"),
    $1021afbd6437aa49$var$load("ffEVr"),
    $1021afbd6437aa49$var$load("ayJxT"),
    $1021afbd6437aa49$var$load("jigcs"),
    $1021afbd6437aa49$var$load("4LmEY")
]).then(()=>parcelRequire('heHIK'));

});

parcelRegister("i28ZW", function(module, exports) {

var $i0mmi = parcelRequire("i0mmi");


var $6mKj3 = parcelRequire("6mKj3");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $iquRY = parcelRequire("iquRY");


var $jMyy4 = parcelRequire("jMyy4");

const $981a614bc39b93a3$var$useSpaceManagementOperationsSpacePropertiesQuery = (0, $i0mmi.default);
const $981a614bc39b93a3$export$42add616309f8ea4 = 'manage_users';
const $981a614bc39b93a3$export$ceb95831d69da149 = 'manage_nonlicensed_users';
const $981a614bc39b93a3$export$3eb61eb33a05d6fe = 'manage_guest_users';
const $981a614bc39b93a3$export$fae9e1a00840692e = 'manage_public_links';
const $981a614bc39b93a3$export$d9a801072630763d = 'manage_templates';
const $981a614bc39b93a3$export$80ed1bd55ccf4772 = 'administer';
const $981a614bc39b93a3$export$a89133b28496ff30 = 'manage_look_and_feel';
const $981a614bc39b93a3$export$50faaafd42078ad9 = 'manage_content';
const $981a614bc39b93a3$export$a7c1ec142e70d69d = 'archive';
const $981a614bc39b93a3$export$92f9e1ed9114d3a6 = 'copy';
const $981a614bc39b93a3$export$3ea24d3a964169d2 = 'view_analytics';
const $981a614bc39b93a3$export$df267ad9042b4cda = 'export';
const $981a614bc39b93a3$export$4111393d4921f4a7 = 'create';
const $981a614bc39b93a3$export$5c2e91d1aa10ff80 = 'attachment';
const $981a614bc39b93a3$export$b838cef2a8827875 = (operations, spaceOperation)=>{
    return operations?.some((operation)=>operation?.operation === spaceOperation && operation?.targetType === 'space') ?? false;
};
const $981a614bc39b93a3$export$f8731d5631669ee8 = ({ spaceKey: spaceKey, skip: skip })=>{
    const { isRbacEnabled: isRbacEnabled, loading: isLoadingSpaceRoleMode } = (0, $iquRY.useSpaceRoleMode)();
    const defaultSkip = !spaceKey || !isRbacEnabled && !(0, $6mKj3.expVal)('permissions_rbac_dependencies_callsites', 'isEnabled', false);
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)($981a614bc39b93a3$var$useSpaceManagementOperationsSpacePropertiesQuery, {
        variables: {
            spaceKey: spaceKey
        },
        skip: skip !== undefined ? skip : defaultSkip,
        onError: (error)=>{
            if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
            else (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
            });
        },
        __callerPackage__: "space-utils"
    });
    const operations = data?.space?.operations;
    return {
        canManageSomeUsers: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$42add616309f8ea4) || $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$ceb95831d69da149) || $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$3eb61eb33a05d6fe),
        canManageUsers: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$42add616309f8ea4),
        canManageNonlicensedUsers: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$ceb95831d69da149),
        canManageGuestUsers: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$3eb61eb33a05d6fe),
        canManagePublicLinks: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$fae9e1a00840692e),
        canManageTemplates: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$d9a801072630763d),
        canManageLookAndFeel: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$a89133b28496ff30),
        canManageSettingsAutomation: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$80ed1bd55ccf4772),
        canManageContent: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$50faaafd42078ad9),
        canArchive: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$a7c1ec142e70d69d),
        canCopy: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$92f9e1ed9114d3a6),
        canViewAnalytics: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$3ea24d3a964169d2),
        canExportSpace: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$df267ad9042b4cda),
        canAddAttachment: operations?.some((operation)=>operation?.operation === $981a614bc39b93a3$export$4111393d4921f4a7 && operation?.targetType === $981a614bc39b93a3$export$5c2e91d1aa10ff80) ?? false,
        loading: loading || isLoadingSpaceRoleMode
    };
};
module.exports["MANAGE_PUBLIC_LINKS"] = $981a614bc39b93a3$export$fae9e1a00840692e;
module.exports["ADMINISTER"] = $981a614bc39b93a3$export$80ed1bd55ccf4772;
module.exports["MANAGE_CONTENT"] = $981a614bc39b93a3$export$50faaafd42078ad9;
module.exports["hasSpaceOperation"] = $981a614bc39b93a3$export$b838cef2a8827875;
module.exports["useSpaceManagementOperations"] = $981a614bc39b93a3$export$f8731d5631669ee8;

});

parcelRegister("i0mmi", function(module, exports) {
/**
 * @generated SignedSource<<10e9286ab7437b1579bfb197b3cdf663>>
 * @relayHash 0a3dc9cecca8233daf01e0443fdaa5e6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1509aa25f2392b1667fcb4313ac8da10a214bb194abea1065d129f0c6ea9e471
const $7dc84e66153faa36$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isAdmin"
                        }
                    ]
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceManagementOperationsSpacePropertiesQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceManagementOperationsSpacePropertiesQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "0a3dc9cecca8233daf01e0443fdaa5e6",
            "id": "1509aa25f2392b1667fcb4313ac8da10a214bb194abea1065d129f0c6ea9e471",
            "metadata": {},
            "name": "useSpaceManagementOperationsSpacePropertiesQuery",
            "operationKind": "query",
            "text": "query useSpaceManagementOperationsSpacePropertiesQuery($spaceKey:String!){space(key:$spaceKey){id,currentUser{isAdmin},operations{operation,targetType}}}"
        }
    };
}();
$7dc84e66153faa36$var$node.hash = "4d967e32f567d3367490b1d8fb6f1ecf";
var $7dc84e66153faa36$export$2e2bcd8739ae039 = $7dc84e66153faa36$var$node;
module.exports["default"] = $7dc84e66153faa36$export$2e2bcd8739ae039;

});

parcelRegister("iquRY", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $24WXz = parcelRequire("24WXz");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $cccaa992351fdb79$export$dcac763621aee435 = ()=>{
    const $ = (0, $bDgLe.c)(9);
    const { cloudId: cloudId, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] !== cloudId) {
        t0 = {
            cloudId: cloudId
        };
        $[0] = cloudId;
        $[1] = t0;
    } else t0 = $[1];
    const t1 = !isLoggedIn;
    let t2;
    if ($[2] !== t0 || $[3] !== t1) {
        t2 = {
            variables: t0,
            skip: t1,
            onError: $cccaa992351fdb79$var$_temp
        };
        $[2] = t0;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $24WXz.default), {
        ...t2,
        __callerPackage__: "space-utils"
    });
    const isNotPreRoles = data?.confluence_spaceRoleMode ? data.confluence_spaceRoleMode !== "PRE_ROLES" : false;
    const t3 = data?.confluence_spaceRoleMode;
    let t4;
    if ($[5] !== isNotPreRoles || $[6] !== loading || $[7] !== t3) {
        t4 = {
            spaceRoleMode: t3,
            isRbacEnabled: isNotPreRoles,
            loading: loading
        };
        $[5] = isNotPreRoles;
        $[6] = loading;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
};
function $cccaa992351fdb79$var$_temp(error) {
    (0, $5ZqQS.getMonitoringClient)().submitError(error, {
        attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
    });
    (0, $7Sm4c.markErrorAsHandled)(error);
}
module.exports["useSpaceRoleMode"] = $cccaa992351fdb79$export$dcac763621aee435;

});

parcelRegister("24WXz", function(module, exports) {
/**
 * @generated SignedSource<<2ff02ee1cce578f61d9a435abf2def2c>>
 * @relayHash 60ed41889a4cd98154a0419dcf1f59f5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 568a16c2dadb6c51097438a074053eda35e4744d08b20d0f79c582acba061e82
const $016cc5cc0310f39a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ScalarField",
            "name": "confluence_spaceRoleMode"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceRoleModeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceRoleModeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "60ed41889a4cd98154a0419dcf1f59f5",
            "id": "568a16c2dadb6c51097438a074053eda35e4744d08b20d0f79c582acba061e82",
            "metadata": {},
            "name": "useSpaceRoleModeQuery",
            "operationKind": "query",
            "text": "query useSpaceRoleModeQuery($cloudId:ID!){confluence_spaceRoleMode(cloudId:$cloudId)}"
        }
    };
}();
$016cc5cc0310f39a$var$node.hash = "88c4ae8983cc6692099b2b1e1d7a4379";
var $016cc5cc0310f39a$export$2e2bcd8739ae039 = $016cc5cc0310f39a$var$node;
module.exports["default"] = $016cc5cc0310f39a$export$2e2bcd8739ae039;

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$1764bc361f317144 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "dQS92",
    name: "AttachmentActionForgeApp",
    loader: async ()=>(await (parcelRequire("8CoyJ"))).AttachmentActionForgeApp
});

const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("fln8Q"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("7wqtP"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("aSm6f"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("6LLF4"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("fdwhW"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("i7McC"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("4PDvd"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("3OJGs"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("2keEU"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("lGCvn"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("1L9Do"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("lDlMC"))).PageBannerForgeApp
});
module.exports["AttachmentActionForgeApp"] = $02976f123c8f8e25$export$1764bc361f317144;
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("8CoyJ", function(module, exports) {

let $6464ec4b11e0139e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6464ec4b11e0139e$var$load("hUbK8"),
    $6464ec4b11e0139e$var$load("LWh5V"),
    $6464ec4b11e0139e$var$load("eRlPy"),
    $6464ec4b11e0139e$var$load("30b92"),
    $6464ec4b11e0139e$var$load("9cVML"),
    $6464ec4b11e0139e$var$load("4AElS"),
    $6464ec4b11e0139e$var$load("7G12e"),
    $6464ec4b11e0139e$var$load("1Gr4q"),
    $6464ec4b11e0139e$var$load("e95jE"),
    $6464ec4b11e0139e$var$load("cKPFM"),
    $6464ec4b11e0139e$var$load("7SteV"),
    $6464ec4b11e0139e$var$load("6dLts"),
    $6464ec4b11e0139e$var$load("jdPbE"),
    $6464ec4b11e0139e$var$load("L98h8"),
    $6464ec4b11e0139e$var$load("dfVn7"),
    $6464ec4b11e0139e$var$load("aLwQm"),
    $6464ec4b11e0139e$var$load("lkHIj"),
    $6464ec4b11e0139e$var$load("b8BFA"),
    $6464ec4b11e0139e$var$load("keazL"),
    $6464ec4b11e0139e$var$load("dhXIT"),
    $6464ec4b11e0139e$var$load("kHXvF"),
    $6464ec4b11e0139e$var$load("ea3NB"),
    $6464ec4b11e0139e$var$load("59hV4"),
    $6464ec4b11e0139e$var$load("9zpfi"),
    $6464ec4b11e0139e$var$load("9pNir"),
    $6464ec4b11e0139e$var$load("fuOfV"),
    $6464ec4b11e0139e$var$load("jL1Ke"),
    $6464ec4b11e0139e$var$load("5MQ0D"),
    $6464ec4b11e0139e$var$load("cvcNg"),
    $6464ec4b11e0139e$var$load("iZR3N"),
    $6464ec4b11e0139e$var$load("jXM1T"),
    $6464ec4b11e0139e$var$load("6wr18"),
    $6464ec4b11e0139e$var$load("4N1MY"),
    $6464ec4b11e0139e$var$load("ffEVr"),
    $6464ec4b11e0139e$var$load("7BHAC"),
    $6464ec4b11e0139e$var$load("N3TvS"),
    $6464ec4b11e0139e$var$load("5gsbh"),
    $6464ec4b11e0139e$var$load("8lMr1"),
    $6464ec4b11e0139e$var$load("1vUE6"),
    $6464ec4b11e0139e$var$load("h0X0x"),
    $6464ec4b11e0139e$var$load("7l4Nc"),
    $6464ec4b11e0139e$var$load("fwbNS"),
    $6464ec4b11e0139e$var$load("fEvpQ"),
    $6464ec4b11e0139e$var$load("h4Nf7"),
    $6464ec4b11e0139e$var$load("Wowvf"),
    $6464ec4b11e0139e$var$load("4g6rd"),
    $6464ec4b11e0139e$var$load("7A87G"),
    $6464ec4b11e0139e$var$load("hhss7"),
    $6464ec4b11e0139e$var$load("1sii7"),
    $6464ec4b11e0139e$var$load("lnKog"),
    $6464ec4b11e0139e$var$load("kT6dz"),
    $6464ec4b11e0139e$var$load("aAWLw"),
    $6464ec4b11e0139e$var$load("7EorR"),
    $6464ec4b11e0139e$var$load("fJ8Kj")
]).then(()=>parcelRequire('2L9yO'));

});

parcelRegister("fln8Q", function(module, exports) {

let $b2bac4a6264562ea$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b2bac4a6264562ea$var$load("hUbK8"),
    $b2bac4a6264562ea$var$load("LWh5V"),
    $b2bac4a6264562ea$var$load("eRlPy"),
    $b2bac4a6264562ea$var$load("30b92"),
    $b2bac4a6264562ea$var$load("9cVML"),
    $b2bac4a6264562ea$var$load("4AElS"),
    $b2bac4a6264562ea$var$load("7G12e"),
    $b2bac4a6264562ea$var$load("1Gr4q"),
    $b2bac4a6264562ea$var$load("e95jE"),
    $b2bac4a6264562ea$var$load("cKPFM"),
    $b2bac4a6264562ea$var$load("7SteV"),
    $b2bac4a6264562ea$var$load("6dLts"),
    $b2bac4a6264562ea$var$load("jdPbE"),
    $b2bac4a6264562ea$var$load("L98h8"),
    $b2bac4a6264562ea$var$load("dfVn7"),
    $b2bac4a6264562ea$var$load("aLwQm"),
    $b2bac4a6264562ea$var$load("lkHIj"),
    $b2bac4a6264562ea$var$load("b8BFA"),
    $b2bac4a6264562ea$var$load("keazL"),
    $b2bac4a6264562ea$var$load("dhXIT"),
    $b2bac4a6264562ea$var$load("kHXvF"),
    $b2bac4a6264562ea$var$load("ea3NB"),
    $b2bac4a6264562ea$var$load("59hV4"),
    $b2bac4a6264562ea$var$load("9zpfi"),
    $b2bac4a6264562ea$var$load("9pNir"),
    $b2bac4a6264562ea$var$load("fuOfV"),
    $b2bac4a6264562ea$var$load("jL1Ke"),
    $b2bac4a6264562ea$var$load("5MQ0D"),
    $b2bac4a6264562ea$var$load("cvcNg"),
    $b2bac4a6264562ea$var$load("iZR3N"),
    $b2bac4a6264562ea$var$load("jXM1T"),
    $b2bac4a6264562ea$var$load("6wr18"),
    $b2bac4a6264562ea$var$load("4N1MY"),
    $b2bac4a6264562ea$var$load("ffEVr"),
    $b2bac4a6264562ea$var$load("7BHAC"),
    $b2bac4a6264562ea$var$load("N3TvS"),
    $b2bac4a6264562ea$var$load("5gsbh"),
    $b2bac4a6264562ea$var$load("8lMr1"),
    $b2bac4a6264562ea$var$load("1vUE6"),
    $b2bac4a6264562ea$var$load("h0X0x"),
    $b2bac4a6264562ea$var$load("7l4Nc"),
    $b2bac4a6264562ea$var$load("fwbNS"),
    $b2bac4a6264562ea$var$load("fEvpQ"),
    $b2bac4a6264562ea$var$load("h4Nf7"),
    $b2bac4a6264562ea$var$load("Wowvf"),
    $b2bac4a6264562ea$var$load("4g6rd"),
    $b2bac4a6264562ea$var$load("7A87G"),
    $b2bac4a6264562ea$var$load("hhss7"),
    $b2bac4a6264562ea$var$load("1sii7"),
    $b2bac4a6264562ea$var$load("lnKog"),
    $b2bac4a6264562ea$var$load("kT6dz"),
    $b2bac4a6264562ea$var$load("aAWLw"),
    $b2bac4a6264562ea$var$load("7EorR"),
    $b2bac4a6264562ea$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("7wqtP", function(module, exports) {

let $57a00ff211860b2f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $57a00ff211860b2f$var$load("hUbK8"),
    $57a00ff211860b2f$var$load("LWh5V"),
    $57a00ff211860b2f$var$load("eRlPy"),
    $57a00ff211860b2f$var$load("30b92"),
    $57a00ff211860b2f$var$load("9cVML"),
    $57a00ff211860b2f$var$load("4AElS"),
    $57a00ff211860b2f$var$load("7G12e"),
    $57a00ff211860b2f$var$load("1Gr4q"),
    $57a00ff211860b2f$var$load("e95jE"),
    $57a00ff211860b2f$var$load("cKPFM"),
    $57a00ff211860b2f$var$load("7SteV"),
    $57a00ff211860b2f$var$load("6dLts"),
    $57a00ff211860b2f$var$load("jdPbE"),
    $57a00ff211860b2f$var$load("L98h8"),
    $57a00ff211860b2f$var$load("dfVn7"),
    $57a00ff211860b2f$var$load("aLwQm"),
    $57a00ff211860b2f$var$load("lkHIj"),
    $57a00ff211860b2f$var$load("b8BFA"),
    $57a00ff211860b2f$var$load("keazL"),
    $57a00ff211860b2f$var$load("dhXIT"),
    $57a00ff211860b2f$var$load("kHXvF"),
    $57a00ff211860b2f$var$load("ea3NB"),
    $57a00ff211860b2f$var$load("59hV4"),
    $57a00ff211860b2f$var$load("9zpfi"),
    $57a00ff211860b2f$var$load("9pNir"),
    $57a00ff211860b2f$var$load("fuOfV"),
    $57a00ff211860b2f$var$load("jL1Ke"),
    $57a00ff211860b2f$var$load("5MQ0D"),
    $57a00ff211860b2f$var$load("cvcNg"),
    $57a00ff211860b2f$var$load("iZR3N"),
    $57a00ff211860b2f$var$load("jXM1T"),
    $57a00ff211860b2f$var$load("6wr18"),
    $57a00ff211860b2f$var$load("4N1MY"),
    $57a00ff211860b2f$var$load("ffEVr"),
    $57a00ff211860b2f$var$load("7BHAC"),
    $57a00ff211860b2f$var$load("N3TvS"),
    $57a00ff211860b2f$var$load("5gsbh"),
    $57a00ff211860b2f$var$load("8lMr1"),
    $57a00ff211860b2f$var$load("1vUE6"),
    $57a00ff211860b2f$var$load("h0X0x"),
    $57a00ff211860b2f$var$load("7l4Nc"),
    $57a00ff211860b2f$var$load("fwbNS"),
    $57a00ff211860b2f$var$load("fEvpQ"),
    $57a00ff211860b2f$var$load("h4Nf7"),
    $57a00ff211860b2f$var$load("Wowvf"),
    $57a00ff211860b2f$var$load("4g6rd"),
    $57a00ff211860b2f$var$load("7A87G"),
    $57a00ff211860b2f$var$load("hhss7"),
    $57a00ff211860b2f$var$load("1sii7"),
    $57a00ff211860b2f$var$load("lnKog"),
    $57a00ff211860b2f$var$load("kT6dz"),
    $57a00ff211860b2f$var$load("aAWLw"),
    $57a00ff211860b2f$var$load("7EorR"),
    $57a00ff211860b2f$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("aSm6f", function(module, exports) {

let $7eb01712d39004cb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $7eb01712d39004cb$var$load("hUbK8"),
    $7eb01712d39004cb$var$load("LWh5V"),
    $7eb01712d39004cb$var$load("eRlPy"),
    $7eb01712d39004cb$var$load("30b92"),
    $7eb01712d39004cb$var$load("9cVML"),
    $7eb01712d39004cb$var$load("4AElS"),
    $7eb01712d39004cb$var$load("7G12e"),
    $7eb01712d39004cb$var$load("1Gr4q"),
    $7eb01712d39004cb$var$load("e95jE"),
    $7eb01712d39004cb$var$load("cKPFM"),
    $7eb01712d39004cb$var$load("7SteV"),
    $7eb01712d39004cb$var$load("6dLts"),
    $7eb01712d39004cb$var$load("jdPbE"),
    $7eb01712d39004cb$var$load("L98h8"),
    $7eb01712d39004cb$var$load("dfVn7"),
    $7eb01712d39004cb$var$load("aLwQm"),
    $7eb01712d39004cb$var$load("lkHIj"),
    $7eb01712d39004cb$var$load("b8BFA"),
    $7eb01712d39004cb$var$load("keazL"),
    $7eb01712d39004cb$var$load("dhXIT"),
    $7eb01712d39004cb$var$load("kHXvF"),
    $7eb01712d39004cb$var$load("ea3NB"),
    $7eb01712d39004cb$var$load("59hV4"),
    $7eb01712d39004cb$var$load("9zpfi"),
    $7eb01712d39004cb$var$load("9pNir"),
    $7eb01712d39004cb$var$load("fuOfV"),
    $7eb01712d39004cb$var$load("jL1Ke"),
    $7eb01712d39004cb$var$load("5MQ0D"),
    $7eb01712d39004cb$var$load("cvcNg"),
    $7eb01712d39004cb$var$load("iZR3N"),
    $7eb01712d39004cb$var$load("jXM1T"),
    $7eb01712d39004cb$var$load("6wr18"),
    $7eb01712d39004cb$var$load("4N1MY"),
    $7eb01712d39004cb$var$load("ffEVr"),
    $7eb01712d39004cb$var$load("7BHAC"),
    $7eb01712d39004cb$var$load("N3TvS"),
    $7eb01712d39004cb$var$load("5gsbh"),
    $7eb01712d39004cb$var$load("8lMr1"),
    $7eb01712d39004cb$var$load("1vUE6"),
    $7eb01712d39004cb$var$load("h0X0x"),
    $7eb01712d39004cb$var$load("7l4Nc"),
    $7eb01712d39004cb$var$load("fwbNS"),
    $7eb01712d39004cb$var$load("fEvpQ"),
    $7eb01712d39004cb$var$load("h4Nf7"),
    $7eb01712d39004cb$var$load("Wowvf"),
    $7eb01712d39004cb$var$load("4g6rd"),
    $7eb01712d39004cb$var$load("7A87G"),
    $7eb01712d39004cb$var$load("hhss7"),
    $7eb01712d39004cb$var$load("1sii7"),
    $7eb01712d39004cb$var$load("lnKog"),
    $7eb01712d39004cb$var$load("kT6dz"),
    $7eb01712d39004cb$var$load("aAWLw"),
    $7eb01712d39004cb$var$load("7EorR"),
    $7eb01712d39004cb$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("6LLF4", function(module, exports) {

let $4edc1a6da3659c4d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $4edc1a6da3659c4d$var$load("h0X0x"),
    $4edc1a6da3659c4d$var$load("7l4Nc"),
    $4edc1a6da3659c4d$var$load("hUbK8"),
    $4edc1a6da3659c4d$var$load("9cVML"),
    $4edc1a6da3659c4d$var$load("4AElS"),
    $4edc1a6da3659c4d$var$load("7G12e"),
    $4edc1a6da3659c4d$var$load("1Gr4q"),
    $4edc1a6da3659c4d$var$load("e95jE"),
    $4edc1a6da3659c4d$var$load("cKPFM"),
    $4edc1a6da3659c4d$var$load("7SteV"),
    $4edc1a6da3659c4d$var$load("6dLts"),
    $4edc1a6da3659c4d$var$load("jdPbE"),
    $4edc1a6da3659c4d$var$load("L98h8"),
    $4edc1a6da3659c4d$var$load("dfVn7"),
    $4edc1a6da3659c4d$var$load("aLwQm"),
    $4edc1a6da3659c4d$var$load("lkHIj"),
    $4edc1a6da3659c4d$var$load("b8BFA"),
    $4edc1a6da3659c4d$var$load("kHXvF"),
    $4edc1a6da3659c4d$var$load("ea3NB"),
    $4edc1a6da3659c4d$var$load("9zpfi"),
    $4edc1a6da3659c4d$var$load("9pNir"),
    $4edc1a6da3659c4d$var$load("cvcNg"),
    $4edc1a6da3659c4d$var$load("iZR3N"),
    $4edc1a6da3659c4d$var$load("jXM1T"),
    $4edc1a6da3659c4d$var$load("6wr18"),
    $4edc1a6da3659c4d$var$load("4N1MY"),
    $4edc1a6da3659c4d$var$load("ffEVr"),
    $4edc1a6da3659c4d$var$load("7BHAC"),
    $4edc1a6da3659c4d$var$load("N3TvS"),
    $4edc1a6da3659c4d$var$load("5gsbh"),
    $4edc1a6da3659c4d$var$load("8lMr1"),
    $4edc1a6da3659c4d$var$load("1vUE6"),
    $4edc1a6da3659c4d$var$load("1sii7"),
    $4edc1a6da3659c4d$var$load("fEvpQ"),
    $4edc1a6da3659c4d$var$load("h4Nf7"),
    $4edc1a6da3659c4d$var$load("Wowvf"),
    $4edc1a6da3659c4d$var$load("4g6rd"),
    $4edc1a6da3659c4d$var$load("7A87G"),
    $4edc1a6da3659c4d$var$load("hhss7"),
    $4edc1a6da3659c4d$var$load("kT6dz"),
    $4edc1a6da3659c4d$var$load("aAWLw"),
    $4edc1a6da3659c4d$var$load("7EorR"),
    $4edc1a6da3659c4d$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("fdwhW", function(module, exports) {

let $b1411db00e0dc856$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b1411db00e0dc856$var$load("h0X0x"),
    $b1411db00e0dc856$var$load("7l4Nc"),
    $b1411db00e0dc856$var$load("hUbK8"),
    $b1411db00e0dc856$var$load("9cVML"),
    $b1411db00e0dc856$var$load("4AElS"),
    $b1411db00e0dc856$var$load("7G12e"),
    $b1411db00e0dc856$var$load("1Gr4q"),
    $b1411db00e0dc856$var$load("e95jE"),
    $b1411db00e0dc856$var$load("cKPFM"),
    $b1411db00e0dc856$var$load("7SteV"),
    $b1411db00e0dc856$var$load("6dLts"),
    $b1411db00e0dc856$var$load("jdPbE"),
    $b1411db00e0dc856$var$load("L98h8"),
    $b1411db00e0dc856$var$load("dfVn7"),
    $b1411db00e0dc856$var$load("aLwQm"),
    $b1411db00e0dc856$var$load("lkHIj"),
    $b1411db00e0dc856$var$load("b8BFA"),
    $b1411db00e0dc856$var$load("kHXvF"),
    $b1411db00e0dc856$var$load("ea3NB"),
    $b1411db00e0dc856$var$load("9zpfi"),
    $b1411db00e0dc856$var$load("9pNir"),
    $b1411db00e0dc856$var$load("cvcNg"),
    $b1411db00e0dc856$var$load("iZR3N"),
    $b1411db00e0dc856$var$load("jXM1T"),
    $b1411db00e0dc856$var$load("6wr18"),
    $b1411db00e0dc856$var$load("4N1MY"),
    $b1411db00e0dc856$var$load("ffEVr"),
    $b1411db00e0dc856$var$load("7BHAC"),
    $b1411db00e0dc856$var$load("N3TvS"),
    $b1411db00e0dc856$var$load("5gsbh"),
    $b1411db00e0dc856$var$load("8lMr1"),
    $b1411db00e0dc856$var$load("1vUE6"),
    $b1411db00e0dc856$var$load("1sii7"),
    $b1411db00e0dc856$var$load("fEvpQ"),
    $b1411db00e0dc856$var$load("h4Nf7"),
    $b1411db00e0dc856$var$load("Wowvf"),
    $b1411db00e0dc856$var$load("4g6rd"),
    $b1411db00e0dc856$var$load("7A87G"),
    $b1411db00e0dc856$var$load("hhss7"),
    $b1411db00e0dc856$var$load("kT6dz"),
    $b1411db00e0dc856$var$load("aAWLw"),
    $b1411db00e0dc856$var$load("7EorR"),
    $b1411db00e0dc856$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("i7McC", function(module, exports) {

let $d31e4577521d4629$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d31e4577521d4629$var$load("h0X0x"),
    $d31e4577521d4629$var$load("7l4Nc"),
    $d31e4577521d4629$var$load("hUbK8"),
    $d31e4577521d4629$var$load("9cVML"),
    $d31e4577521d4629$var$load("4AElS"),
    $d31e4577521d4629$var$load("7G12e"),
    $d31e4577521d4629$var$load("1Gr4q"),
    $d31e4577521d4629$var$load("e95jE"),
    $d31e4577521d4629$var$load("cKPFM"),
    $d31e4577521d4629$var$load("7SteV"),
    $d31e4577521d4629$var$load("6dLts"),
    $d31e4577521d4629$var$load("jdPbE"),
    $d31e4577521d4629$var$load("L98h8"),
    $d31e4577521d4629$var$load("dfVn7"),
    $d31e4577521d4629$var$load("aLwQm"),
    $d31e4577521d4629$var$load("lkHIj"),
    $d31e4577521d4629$var$load("b8BFA"),
    $d31e4577521d4629$var$load("kHXvF"),
    $d31e4577521d4629$var$load("ea3NB"),
    $d31e4577521d4629$var$load("9zpfi"),
    $d31e4577521d4629$var$load("9pNir"),
    $d31e4577521d4629$var$load("cvcNg"),
    $d31e4577521d4629$var$load("iZR3N"),
    $d31e4577521d4629$var$load("jXM1T"),
    $d31e4577521d4629$var$load("6wr18"),
    $d31e4577521d4629$var$load("4N1MY"),
    $d31e4577521d4629$var$load("ffEVr"),
    $d31e4577521d4629$var$load("7BHAC"),
    $d31e4577521d4629$var$load("N3TvS"),
    $d31e4577521d4629$var$load("5gsbh"),
    $d31e4577521d4629$var$load("8lMr1"),
    $d31e4577521d4629$var$load("1vUE6"),
    $d31e4577521d4629$var$load("1sii7"),
    $d31e4577521d4629$var$load("fEvpQ"),
    $d31e4577521d4629$var$load("h4Nf7"),
    $d31e4577521d4629$var$load("Wowvf"),
    $d31e4577521d4629$var$load("4g6rd"),
    $d31e4577521d4629$var$load("7A87G"),
    $d31e4577521d4629$var$load("hhss7"),
    $d31e4577521d4629$var$load("kT6dz"),
    $d31e4577521d4629$var$load("aAWLw"),
    $d31e4577521d4629$var$load("7EorR"),
    $d31e4577521d4629$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("4PDvd", function(module, exports) {

let $384a9132593faf2a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $384a9132593faf2a$var$load("h0X0x"),
    $384a9132593faf2a$var$load("7l4Nc"),
    $384a9132593faf2a$var$load("hUbK8"),
    $384a9132593faf2a$var$load("9cVML"),
    $384a9132593faf2a$var$load("4AElS"),
    $384a9132593faf2a$var$load("7G12e"),
    $384a9132593faf2a$var$load("1Gr4q"),
    $384a9132593faf2a$var$load("e95jE"),
    $384a9132593faf2a$var$load("cKPFM"),
    $384a9132593faf2a$var$load("7SteV"),
    $384a9132593faf2a$var$load("6dLts"),
    $384a9132593faf2a$var$load("jdPbE"),
    $384a9132593faf2a$var$load("L98h8"),
    $384a9132593faf2a$var$load("dfVn7"),
    $384a9132593faf2a$var$load("aLwQm"),
    $384a9132593faf2a$var$load("lkHIj"),
    $384a9132593faf2a$var$load("b8BFA"),
    $384a9132593faf2a$var$load("kHXvF"),
    $384a9132593faf2a$var$load("ea3NB"),
    $384a9132593faf2a$var$load("9zpfi"),
    $384a9132593faf2a$var$load("9pNir"),
    $384a9132593faf2a$var$load("cvcNg"),
    $384a9132593faf2a$var$load("iZR3N"),
    $384a9132593faf2a$var$load("jXM1T"),
    $384a9132593faf2a$var$load("6wr18"),
    $384a9132593faf2a$var$load("4N1MY"),
    $384a9132593faf2a$var$load("ffEVr"),
    $384a9132593faf2a$var$load("7BHAC"),
    $384a9132593faf2a$var$load("N3TvS"),
    $384a9132593faf2a$var$load("5gsbh"),
    $384a9132593faf2a$var$load("8lMr1"),
    $384a9132593faf2a$var$load("1vUE6"),
    $384a9132593faf2a$var$load("fEvpQ"),
    $384a9132593faf2a$var$load("h4Nf7"),
    $384a9132593faf2a$var$load("Wowvf"),
    $384a9132593faf2a$var$load("4g6rd"),
    $384a9132593faf2a$var$load("7A87G"),
    $384a9132593faf2a$var$load("hhss7"),
    $384a9132593faf2a$var$load("1sii7"),
    $384a9132593faf2a$var$load("lnKog"),
    $384a9132593faf2a$var$load("kT6dz"),
    $384a9132593faf2a$var$load("aAWLw"),
    $384a9132593faf2a$var$load("7EorR"),
    $384a9132593faf2a$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("3OJGs", function(module, exports) {

let $2c797a725c1ae67a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2c797a725c1ae67a$var$load("hUbK8"),
    $2c797a725c1ae67a$var$load("30b92"),
    $2c797a725c1ae67a$var$load("9cVML"),
    $2c797a725c1ae67a$var$load("4AElS"),
    $2c797a725c1ae67a$var$load("7G12e"),
    $2c797a725c1ae67a$var$load("1Gr4q"),
    $2c797a725c1ae67a$var$load("e95jE"),
    $2c797a725c1ae67a$var$load("cKPFM"),
    $2c797a725c1ae67a$var$load("7SteV"),
    $2c797a725c1ae67a$var$load("6dLts"),
    $2c797a725c1ae67a$var$load("jdPbE"),
    $2c797a725c1ae67a$var$load("L98h8"),
    $2c797a725c1ae67a$var$load("dfVn7"),
    $2c797a725c1ae67a$var$load("aLwQm"),
    $2c797a725c1ae67a$var$load("lkHIj"),
    $2c797a725c1ae67a$var$load("b8BFA"),
    $2c797a725c1ae67a$var$load("keazL"),
    $2c797a725c1ae67a$var$load("dhXIT"),
    $2c797a725c1ae67a$var$load("kHXvF"),
    $2c797a725c1ae67a$var$load("ea3NB"),
    $2c797a725c1ae67a$var$load("59hV4"),
    $2c797a725c1ae67a$var$load("9zpfi"),
    $2c797a725c1ae67a$var$load("9pNir"),
    $2c797a725c1ae67a$var$load("fuOfV"),
    $2c797a725c1ae67a$var$load("jL1Ke"),
    $2c797a725c1ae67a$var$load("5MQ0D"),
    $2c797a725c1ae67a$var$load("cvcNg"),
    $2c797a725c1ae67a$var$load("iZR3N"),
    $2c797a725c1ae67a$var$load("jXM1T"),
    $2c797a725c1ae67a$var$load("6wr18"),
    $2c797a725c1ae67a$var$load("4N1MY"),
    $2c797a725c1ae67a$var$load("ffEVr"),
    $2c797a725c1ae67a$var$load("7BHAC"),
    $2c797a725c1ae67a$var$load("N3TvS"),
    $2c797a725c1ae67a$var$load("5gsbh"),
    $2c797a725c1ae67a$var$load("8lMr1"),
    $2c797a725c1ae67a$var$load("1vUE6"),
    $2c797a725c1ae67a$var$load("h0X0x"),
    $2c797a725c1ae67a$var$load("7l4Nc"),
    $2c797a725c1ae67a$var$load("fwbNS"),
    $2c797a725c1ae67a$var$load("fEvpQ"),
    $2c797a725c1ae67a$var$load("h4Nf7"),
    $2c797a725c1ae67a$var$load("Wowvf"),
    $2c797a725c1ae67a$var$load("4g6rd"),
    $2c797a725c1ae67a$var$load("7A87G"),
    $2c797a725c1ae67a$var$load("hhss7"),
    $2c797a725c1ae67a$var$load("1sii7"),
    $2c797a725c1ae67a$var$load("lnKog"),
    $2c797a725c1ae67a$var$load("kT6dz"),
    $2c797a725c1ae67a$var$load("aAWLw"),
    $2c797a725c1ae67a$var$load("7EorR"),
    $2c797a725c1ae67a$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("2keEU", function(module, exports) {

let $1b18d1fd65a78b59$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1b18d1fd65a78b59$var$load("hUbK8"),
    $1b18d1fd65a78b59$var$load("30b92"),
    $1b18d1fd65a78b59$var$load("9cVML"),
    $1b18d1fd65a78b59$var$load("4AElS"),
    $1b18d1fd65a78b59$var$load("7G12e"),
    $1b18d1fd65a78b59$var$load("1Gr4q"),
    $1b18d1fd65a78b59$var$load("e95jE"),
    $1b18d1fd65a78b59$var$load("cKPFM"),
    $1b18d1fd65a78b59$var$load("7SteV"),
    $1b18d1fd65a78b59$var$load("6dLts"),
    $1b18d1fd65a78b59$var$load("jdPbE"),
    $1b18d1fd65a78b59$var$load("L98h8"),
    $1b18d1fd65a78b59$var$load("dfVn7"),
    $1b18d1fd65a78b59$var$load("aLwQm"),
    $1b18d1fd65a78b59$var$load("lkHIj"),
    $1b18d1fd65a78b59$var$load("b8BFA"),
    $1b18d1fd65a78b59$var$load("keazL"),
    $1b18d1fd65a78b59$var$load("dhXIT"),
    $1b18d1fd65a78b59$var$load("kHXvF"),
    $1b18d1fd65a78b59$var$load("ea3NB"),
    $1b18d1fd65a78b59$var$load("59hV4"),
    $1b18d1fd65a78b59$var$load("9zpfi"),
    $1b18d1fd65a78b59$var$load("9pNir"),
    $1b18d1fd65a78b59$var$load("fuOfV"),
    $1b18d1fd65a78b59$var$load("jL1Ke"),
    $1b18d1fd65a78b59$var$load("5MQ0D"),
    $1b18d1fd65a78b59$var$load("cvcNg"),
    $1b18d1fd65a78b59$var$load("iZR3N"),
    $1b18d1fd65a78b59$var$load("jXM1T"),
    $1b18d1fd65a78b59$var$load("6wr18"),
    $1b18d1fd65a78b59$var$load("4N1MY"),
    $1b18d1fd65a78b59$var$load("ffEVr"),
    $1b18d1fd65a78b59$var$load("7BHAC"),
    $1b18d1fd65a78b59$var$load("N3TvS"),
    $1b18d1fd65a78b59$var$load("5gsbh"),
    $1b18d1fd65a78b59$var$load("8lMr1"),
    $1b18d1fd65a78b59$var$load("1vUE6"),
    $1b18d1fd65a78b59$var$load("h0X0x"),
    $1b18d1fd65a78b59$var$load("7l4Nc"),
    $1b18d1fd65a78b59$var$load("fwbNS"),
    $1b18d1fd65a78b59$var$load("fEvpQ"),
    $1b18d1fd65a78b59$var$load("h4Nf7"),
    $1b18d1fd65a78b59$var$load("Wowvf"),
    $1b18d1fd65a78b59$var$load("4g6rd"),
    $1b18d1fd65a78b59$var$load("7A87G"),
    $1b18d1fd65a78b59$var$load("hhss7"),
    $1b18d1fd65a78b59$var$load("1sii7"),
    $1b18d1fd65a78b59$var$load("lnKog"),
    $1b18d1fd65a78b59$var$load("kT6dz"),
    $1b18d1fd65a78b59$var$load("aAWLw"),
    $1b18d1fd65a78b59$var$load("7EorR"),
    $1b18d1fd65a78b59$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("lGCvn", function(module, exports) {

let $fc9b638b32ba4f63$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $fc9b638b32ba4f63$var$load("h0X0x"),
    $fc9b638b32ba4f63$var$load("7l4Nc"),
    $fc9b638b32ba4f63$var$load("hUbK8"),
    $fc9b638b32ba4f63$var$load("9cVML"),
    $fc9b638b32ba4f63$var$load("4AElS"),
    $fc9b638b32ba4f63$var$load("7G12e"),
    $fc9b638b32ba4f63$var$load("1Gr4q"),
    $fc9b638b32ba4f63$var$load("e95jE"),
    $fc9b638b32ba4f63$var$load("cKPFM"),
    $fc9b638b32ba4f63$var$load("7SteV"),
    $fc9b638b32ba4f63$var$load("6dLts"),
    $fc9b638b32ba4f63$var$load("jdPbE"),
    $fc9b638b32ba4f63$var$load("L98h8"),
    $fc9b638b32ba4f63$var$load("dfVn7"),
    $fc9b638b32ba4f63$var$load("aLwQm"),
    $fc9b638b32ba4f63$var$load("lkHIj"),
    $fc9b638b32ba4f63$var$load("b8BFA"),
    $fc9b638b32ba4f63$var$load("kHXvF"),
    $fc9b638b32ba4f63$var$load("ea3NB"),
    $fc9b638b32ba4f63$var$load("9zpfi"),
    $fc9b638b32ba4f63$var$load("9pNir"),
    $fc9b638b32ba4f63$var$load("cvcNg"),
    $fc9b638b32ba4f63$var$load("iZR3N"),
    $fc9b638b32ba4f63$var$load("jXM1T"),
    $fc9b638b32ba4f63$var$load("6wr18"),
    $fc9b638b32ba4f63$var$load("4N1MY"),
    $fc9b638b32ba4f63$var$load("ffEVr"),
    $fc9b638b32ba4f63$var$load("7BHAC"),
    $fc9b638b32ba4f63$var$load("N3TvS"),
    $fc9b638b32ba4f63$var$load("5gsbh"),
    $fc9b638b32ba4f63$var$load("8lMr1"),
    $fc9b638b32ba4f63$var$load("1vUE6"),
    $fc9b638b32ba4f63$var$load("1sii7"),
    $fc9b638b32ba4f63$var$load("fEvpQ"),
    $fc9b638b32ba4f63$var$load("h4Nf7"),
    $fc9b638b32ba4f63$var$load("Wowvf"),
    $fc9b638b32ba4f63$var$load("4g6rd"),
    $fc9b638b32ba4f63$var$load("7A87G"),
    $fc9b638b32ba4f63$var$load("hhss7"),
    $fc9b638b32ba4f63$var$load("kT6dz"),
    $fc9b638b32ba4f63$var$load("aAWLw"),
    $fc9b638b32ba4f63$var$load("7EorR"),
    $fc9b638b32ba4f63$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("1L9Do", function(module, exports) {

let $1481a76df074217e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1481a76df074217e$var$load("h0X0x"),
    $1481a76df074217e$var$load("7l4Nc"),
    $1481a76df074217e$var$load("hUbK8"),
    $1481a76df074217e$var$load("9cVML"),
    $1481a76df074217e$var$load("4AElS"),
    $1481a76df074217e$var$load("7G12e"),
    $1481a76df074217e$var$load("1Gr4q"),
    $1481a76df074217e$var$load("e95jE"),
    $1481a76df074217e$var$load("cKPFM"),
    $1481a76df074217e$var$load("7SteV"),
    $1481a76df074217e$var$load("6dLts"),
    $1481a76df074217e$var$load("jdPbE"),
    $1481a76df074217e$var$load("L98h8"),
    $1481a76df074217e$var$load("dfVn7"),
    $1481a76df074217e$var$load("aLwQm"),
    $1481a76df074217e$var$load("lkHIj"),
    $1481a76df074217e$var$load("b8BFA"),
    $1481a76df074217e$var$load("kHXvF"),
    $1481a76df074217e$var$load("ea3NB"),
    $1481a76df074217e$var$load("9zpfi"),
    $1481a76df074217e$var$load("9pNir"),
    $1481a76df074217e$var$load("cvcNg"),
    $1481a76df074217e$var$load("iZR3N"),
    $1481a76df074217e$var$load("jXM1T"),
    $1481a76df074217e$var$load("6wr18"),
    $1481a76df074217e$var$load("4N1MY"),
    $1481a76df074217e$var$load("ffEVr"),
    $1481a76df074217e$var$load("7BHAC"),
    $1481a76df074217e$var$load("N3TvS"),
    $1481a76df074217e$var$load("5gsbh"),
    $1481a76df074217e$var$load("8lMr1"),
    $1481a76df074217e$var$load("1vUE6"),
    $1481a76df074217e$var$load("fEvpQ"),
    $1481a76df074217e$var$load("h4Nf7"),
    $1481a76df074217e$var$load("Wowvf"),
    $1481a76df074217e$var$load("4g6rd"),
    $1481a76df074217e$var$load("7A87G"),
    $1481a76df074217e$var$load("hhss7"),
    $1481a76df074217e$var$load("1sii7"),
    $1481a76df074217e$var$load("lnKog"),
    $1481a76df074217e$var$load("kT6dz"),
    $1481a76df074217e$var$load("aAWLw"),
    $1481a76df074217e$var$load("7EorR"),
    $1481a76df074217e$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("lDlMC", function(module, exports) {

let $04107c702544292c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $04107c702544292c$var$load("h0X0x"),
    $04107c702544292c$var$load("7l4Nc"),
    $04107c702544292c$var$load("hUbK8"),
    $04107c702544292c$var$load("9cVML"),
    $04107c702544292c$var$load("4AElS"),
    $04107c702544292c$var$load("7G12e"),
    $04107c702544292c$var$load("1Gr4q"),
    $04107c702544292c$var$load("e95jE"),
    $04107c702544292c$var$load("cKPFM"),
    $04107c702544292c$var$load("7SteV"),
    $04107c702544292c$var$load("6dLts"),
    $04107c702544292c$var$load("jdPbE"),
    $04107c702544292c$var$load("L98h8"),
    $04107c702544292c$var$load("dfVn7"),
    $04107c702544292c$var$load("aLwQm"),
    $04107c702544292c$var$load("lkHIj"),
    $04107c702544292c$var$load("b8BFA"),
    $04107c702544292c$var$load("kHXvF"),
    $04107c702544292c$var$load("ea3NB"),
    $04107c702544292c$var$load("9zpfi"),
    $04107c702544292c$var$load("9pNir"),
    $04107c702544292c$var$load("cvcNg"),
    $04107c702544292c$var$load("iZR3N"),
    $04107c702544292c$var$load("jXM1T"),
    $04107c702544292c$var$load("6wr18"),
    $04107c702544292c$var$load("4N1MY"),
    $04107c702544292c$var$load("ffEVr"),
    $04107c702544292c$var$load("7BHAC"),
    $04107c702544292c$var$load("N3TvS"),
    $04107c702544292c$var$load("5gsbh"),
    $04107c702544292c$var$load("8lMr1"),
    $04107c702544292c$var$load("1vUE6"),
    $04107c702544292c$var$load("fEvpQ"),
    $04107c702544292c$var$load("h4Nf7"),
    $04107c702544292c$var$load("Wowvf"),
    $04107c702544292c$var$load("4g6rd"),
    $04107c702544292c$var$load("7A87G"),
    $04107c702544292c$var$load("hhss7"),
    $04107c702544292c$var$load("1sii7"),
    $04107c702544292c$var$load("lnKog"),
    $04107c702544292c$var$load("43z9c"),
    $04107c702544292c$var$load("kT6dz"),
    $04107c702544292c$var$load("aAWLw"),
    $04107c702544292c$var$load("7EorR"),
    $04107c702544292c$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("lOkIA", function(module, exports) {
/* CenteredSpinner.js generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $6b4nE = parcelRequire("6b4nE");


var $cozmU = parcelRequire("cozmU");


var $lfoFx = parcelRequire("lfoFx");

function $fe0e56b204487583$var$_defineProperty(e, r, t) {
    return (r = $fe0e56b204487583$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $fe0e56b204487583$var$_toPropertyKey(t) {
    var i = $fe0e56b204487583$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $fe0e56b204487583$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $fe0e56b204487583$export$57732b6846a8df7c = {
    small: 12,
    medium: 26,
    large: 36
};
const $fe0e56b204487583$var$wrapperStyles = null;
const $fe0e56b204487583$var$spinnerStyles = null;
class $fe0e56b204487583$export$a2638930496865a0 extends (0, $cozmU.PureComponent) {
    render() {
        const { style: style, size: size } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: style,
            "data-test-id": "wrapper-spinner",
            className: (0, $hekY6.default)([
                "_39xV02N91d _0jFU0VN91d _1mT5xdRAKS"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-test-id": "spinner",
            style: {
                marginLeft: `${-$fe0e56b204487583$export$57732b6846a8df7c[size] / 2}px`,
                marginTop: `${-$fe0e56b204487583$export$57732b6846a8df7c[size] / 2}px`
            },
            className: (0, $hekY6.default)([
                "_1mT5xdWVPG _3OE6xY715P _2IhTon715P _42Yu6BgtVO"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            size: $fe0e56b204487583$export$57732b6846a8df7c[size]
        })));
    }
}
$fe0e56b204487583$var$_defineProperty($fe0e56b204487583$export$a2638930496865a0, "displayName", 'CenteredSpinner');
$fe0e56b204487583$var$_defineProperty($fe0e56b204487583$export$a2638930496865a0, "propTypes", {
    /**
   * custom spinner style
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object,
    /**
   * Size of spinner
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).oneOf([
        'small',
        'medium',
        'large'
    ])
});
$fe0e56b204487583$var$_defineProperty($fe0e56b204487583$export$a2638930496865a0, "defaultProps", {
    size: 'small'
});
module.exports["CenteredSpinner"] = $fe0e56b204487583$export$a2638930496865a0;

});

parcelRegister("lJDEI", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $6mKj3 = parcelRequire("6mKj3");

const $4a3de077c1d50444$export$339879d9e7e1b505 = 'inEditorTemplatesPanel';
const $4a3de077c1d50444$export$a957a3414f664a78 = 'open';
const $4a3de077c1d50444$export$5f52a3f66b36af8a = 'keep_open';
const $4a3de077c1d50444$export$3077ff8b594d6ef8 = 'auto_closed';
const $4a3de077c1d50444$export$e03fa63b521a0c2 = 'createdWithTemplate';
const $4a3de077c1d50444$export$79a38b1b3ee7546f = 'contextPanelTabTarget';
const $4a3de077c1d50444$export$d3c15ca89bcfbca6 = 'templates';
const $4a3de077c1d50444$export$9d622978cb62b57d = 'block';
const $4a3de077c1d50444$export$3059f9ac1064e696 = 'import';
const $4a3de077c1d50444$export$ccd8928f1e8269de = 'templates';
const $4a3de077c1d50444$export$2f49124c0813d6f9 = 'import';
const $4a3de077c1d50444$export$5a50171a4c5c3a34 = (getQueryParams)=>{
    return getQueryParams()[$4a3de077c1d50444$export$e03fa63b521a0c2] === 'true';
};
const $4a3de077c1d50444$export$944cd488c360bc7a = (getQueryParams)=>{
    return getQueryParams()[$4a3de077c1d50444$export$339879d9e7e1b505];
};
const $4a3de077c1d50444$export$c1ea49786444cf5a = (getQueryParams)=>{
    return getQueryParams()[$4a3de077c1d50444$export$79a38b1b3ee7546f];
};
const $4a3de077c1d50444$export$e991edcb7a1d128f = (getQueryParams)=>{
    return $4a3de077c1d50444$export$944cd488c360bc7a(getQueryParams) === $4a3de077c1d50444$export$a957a3414f664a78;
};
const $4a3de077c1d50444$export$835e1f3b6fb2ce1a = (getQueryParams)=>{
    const queryParamValue = $4a3de077c1d50444$export$944cd488c360bc7a(getQueryParams);
    return queryParamValue === $4a3de077c1d50444$export$a957a3414f664a78 || queryParamValue === $4a3de077c1d50444$export$5f52a3f66b36af8a;
};
const $4a3de077c1d50444$export$242446a58b76be13 = (getQueryParams)=>{
    const queryParamValue = $4a3de077c1d50444$export$944cd488c360bc7a(getQueryParams);
    const tabTarget = $4a3de077c1d50444$export$c1ea49786444cf5a(getQueryParams);
    return (queryParamValue === $4a3de077c1d50444$export$a957a3414f664a78 || queryParamValue === $4a3de077c1d50444$export$5f52a3f66b36af8a) && (tabTarget === $4a3de077c1d50444$export$d3c15ca89bcfbca6 || tabTarget === $4a3de077c1d50444$export$9d622978cb62b57d);
};
const $4a3de077c1d50444$export$56073af4e8655248 = (setQueryParams, isRovoLLMEnabled = false)=>{
    const paramsToRemove = {
        [$4a3de077c1d50444$export$339879d9e7e1b505]: null
    };
    // Clear contextPanelTabTarget when either platform_editor_blocks_conf or cwr_blank_object_experiment is enabled
    if (isRovoLLMEnabled && (0, $6mKj3.expVal)('cwr_blank_object_experiment', 'isEnabled', false) || (0, $6mKj3.expVal)('platform_editor_blocks_conf', 'isEnabled', false)) paramsToRemove[$4a3de077c1d50444$export$79a38b1b3ee7546f] = null;
    setQueryParams(paramsToRemove, true);
};
const $4a3de077c1d50444$export$90fd502a25d2c01 = (setQueryParams, inEditorTemplatesPanel, tabTarget, isRovoLLMEnabled = false)=>{
    const params = {
        [$4a3de077c1d50444$export$339879d9e7e1b505]: inEditorTemplatesPanel
    };
    // Set contextPanelTabTarget when either platform_editor_blocks_conf or cwr_blank_object_experiment is enabled
    if (tabTarget && (isRovoLLMEnabled && (0, $6mKj3.expVal)('cwr_blank_object_experiment', 'isEnabled', false) || (0, $6mKj3.expVal)('platform_editor_blocks_conf', 'isEnabled', false))) params[$4a3de077c1d50444$export$79a38b1b3ee7546f] = tabTarget;
    setQueryParams(params, true);
};
const $4a3de077c1d50444$export$828af32839880b11 = (spaceKey)=>{
    if (spaceKey) return (0, $1NBp8.SPACE_SETTINGS_TEMPLATES).toUrl({
        spaceKey: spaceKey
    });
    return (0, $1NBp8.ADMIN_TEMPLATES_AND_BLUEPRINTS).toUrl();
};
module.exports["IN_EDITOR_TEMPLATES_QUERY_PARAM_NAME"] = $4a3de077c1d50444$export$339879d9e7e1b505;
module.exports["IN_EDITOR_TEMPLATES_QUERY_OPEN"] = $4a3de077c1d50444$export$a957a3414f664a78;
module.exports["IN_EDITOR_TEMPLATES_QUERY_KEEP_OPEN"] = $4a3de077c1d50444$export$5f52a3f66b36af8a;
module.exports["IN_EDITOR_TEMPLATES_QUERY_AUTO_CLOSED"] = $4a3de077c1d50444$export$3077ff8b594d6ef8;
module.exports["CREATED_WITH_TEMPLATE_QUERY_PARAM_NAME"] = $4a3de077c1d50444$export$e03fa63b521a0c2;
module.exports["CONTEXT_PANEL_TAB_TARGET"] = $4a3de077c1d50444$export$79a38b1b3ee7546f;
module.exports["CONTEXT_PANEL_TAB_TARGET_TEMPLATES"] = $4a3de077c1d50444$export$d3c15ca89bcfbca6;
module.exports["CONTEXT_PANEL_TAB_TARGET_BLOCK"] = $4a3de077c1d50444$export$9d622978cb62b57d;
module.exports["CONTEXT_PANEL_TAB_TARGET_IMPORT"] = $4a3de077c1d50444$export$3059f9ac1064e696;
module.exports["PANEL_MODE_TEMPLATES"] = $4a3de077c1d50444$export$ccd8928f1e8269de;
module.exports["PANEL_MODE_IMPORT"] = $4a3de077c1d50444$export$2f49124c0813d6f9;
module.exports["getCreatedWithTemplateQueryParamValue"] = $4a3de077c1d50444$export$5a50171a4c5c3a34;
module.exports["getInEditorTemplatesPanelQueryParamValue"] = $4a3de077c1d50444$export$944cd488c360bc7a;
module.exports["isInEditorTemplatesPanelQueryParamValueOpen"] = $4a3de077c1d50444$export$e991edcb7a1d128f;
module.exports["isInEditorTemplatesPanelQueryParamValueOpenOrKeepOpen"] = $4a3de077c1d50444$export$835e1f3b6fb2ce1a;
module.exports["isInEditorTemplatesPanelQueryParamValueOpenOrKeepOpenWithTemplatesPanelMode"] = $4a3de077c1d50444$export$242446a58b76be13;
module.exports["removeInEditorTemplatesQueryParam"] = $4a3de077c1d50444$export$56073af4e8655248;
module.exports["setInEditorTemplatesPanelQueryParam"] = $4a3de077c1d50444$export$90fd502a25d2c01;
module.exports["getTemplateListPage"] = $4a3de077c1d50444$export$828af32839880b11;

});

parcelRegister("c1UWH", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");

class $992a1265dc051ead$var$UnreadCommentsIntersectionObserver {
    createObserver() {
        try {
            if (typeof IntersectionObserver === 'undefined') return;
            const observer = new IntersectionObserver((entries)=>{
                entries.forEach((entry)=>{
                    const commentId = entry.target.getAttribute('data-comment-id');
                    if (!commentId) return;
                    if (entry.isIntersecting) {
                        // Comment became visible - set new timer for this specific comment
                        const timer = setTimeout(()=>{
                            this.intersectionCallbacks.forEach((callback)=>{
                                callback(commentId);
                            });
                            // Clear the timer for this comment
                            this.commentTimersMap.delete(commentId);
                            // Unobserve this element since it's been processed
                            if (this.observer && typeof this.observer.unobserve === 'function') {
                                this.observer.unobserve(entry.target);
                                this.observedElementsSet.delete(entry.target);
                            }
                        }, 2000); // 2 seconds default
                        this.commentTimersMap.set(commentId, timer);
                    } else // Comment became invisible - clear timer for this comment
                    if (this.commentTimersMap.has(commentId)) {
                        clearTimeout(this.commentTimersMap.get(commentId));
                        this.commentTimersMap.delete(commentId);
                    }
                });
            }, {
                threshold: [
                    0.25
                ],
                // add a bottom root margin to account for sticky elements at the bottom of the observable viewport such as the sticky footer
                // this is because the intersection observer doesn't know about elements that are above the observed comments, and so we can avoid
                // marking comments as read when they're not actually visible to the user. this is a best effort approach
                rootMargin: '0px 0px -65px 0px',
                // Add a custom name to identify this as the unread comments observer
                // This helps in tests to distinguish it from other intersection observers
                name: 'unreadCommentsObserver'
            });
            // Only set observer if it has the required methods
            if (observer && typeof observer.disconnect === 'function' && typeof observer.observe === 'function' && typeof observer.unobserve === 'function') this.observer = observer;
            else this.observer = null;
        } catch  {
            this.observer = null;
        }
    }
    observeComment(targetElement) {
        // don't observe if the observer is not initialized
        if (!this.observer) return;
        // don't observe if the targetElement is not a valid element
        if (!targetElement) return;
        // don't observe the same element twice
        if (this.observedElementsSet.has(targetElement)) return;
        this.observer.observe(targetElement);
        this.observedElementsSet.add(targetElement);
    }
    unobserveComment(targetElement) {
        // don't unobserve if the observer is not initialized
        if (!this.observer) return;
        // don't unobserve if the targetElement is not a valid element
        if (!targetElement) return;
        // only unobserve if we're actually observing this element
        if (!this.observedElementsSet.has(targetElement)) return;
        // Clear any running timer for this comment
        const commentId = targetElement.getAttribute('data-comment-id');
        if (commentId && this.commentTimersMap.has(commentId)) {
            clearTimeout(this.commentTimersMap.get(commentId));
            this.commentTimersMap.delete(commentId);
        }
        this.observer.unobserve(targetElement);
        this.observedElementsSet.delete(targetElement);
    }
    // By exposing this function, we allow consumers to register callbacks
    registerIntersectionCallback(callback) {
        this.intersectionCallbacks.push(callback);
    }
    deregisterIntersectionCallback(callback) {
        this.intersectionCallbacks = this.intersectionCallbacks.filter((cb)=>cb !== callback);
    }
    // Reconnect the observer if it was disconnected
    reconnect() {
        if (!this.observer) this.createObserver();
    }
    // Clean up method
    disconnect() {
        if (this.observer && typeof this.observer.disconnect === 'function') {
            this.observer.disconnect();
            this.observer = null;
        }
        // Clear all timers
        this.commentTimersMap.forEach((timer)=>clearTimeout(timer));
        this.commentTimersMap.clear();
        // Clear observed elements
        this.observedElementsSet.clear();
        // Clear callbacks
        this.intersectionCallbacks = [];
    }
    constructor(){
        this.observer = null;
        this.commentTimersMap = new Map();
        this.observedElementsSet = new Set();
        this.intersectionCallbacks = [];
        this.createObserver();
    }
}
// memoize ensures an IntersectionObserver is instantiated only once
const $992a1265dc051ead$var$getStableIntersectionObserver = (0, $dOBRD.default)(()=>{
    return new $992a1265dc051ead$var$UnreadCommentsIntersectionObserver();
});
const $992a1265dc051ead$export$ad65f5516d9692ed = ()=>{
    const intersectionObserver = $992a1265dc051ead$var$getStableIntersectionObserver();
    intersectionObserver.reconnect();
    return intersectionObserver;
};
module.exports["getUnreadCommentsIntersectionObserver"] = $992a1265dc051ead$export$ad65f5516d9692ed;

});

parcelRegister("d3bcC", function(module, exports) {

var $5VFXo = parcelRequire("5VFXo");


var $aXiya = parcelRequire("aXiya");


var $eLFD2 = parcelRequire("eLFD2");


var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $ij4CE = parcelRequire("ij4CE");


var $fFmJj = parcelRequire("fFmJj");





var $ep3mz = parcelRequire("ep3mz");


var $1ggpj = parcelRequire("1ggpj");


var $7Sm4c = parcelRequire("7Sm4c");


var $1uFM6 = parcelRequire("1uFM6");


var $6fil2 = parcelRequire("6fil2");


var $fJlJm = parcelRequire("fJlJm");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $18a2fd912dfb58ac$var$ContentAnalyticsViewedComments = (0, $eLFD2.default);
// Helper function to safely convert content type for the viewed comments query
const $18a2fd912dfb58ac$var$getValidContentTypeForViewedComments = (contentType)=>{
    // Only page, database, whiteboard, and slide support the viewed comments query
    if (contentType === 'page' || contentType === 'database' || (0, $1ggpj.isCanvasContentType)(contentType)) return contentType;
    // Fallback to page for other content types (blogpost, embed, etc.)
    return 'page';
};
// Helper to generate stable ROOT_QUERY cache key
// Ensures consistent key format regardless of object property order
const $18a2fd912dfb58ac$var$getRootQueryCacheId = (pageId, contentType)=>{
    const validContentType = $18a2fd912dfb58ac$var$getValidContentTypeForViewedComments(contentType);
    // Sort keys to ensure stable JSON.stringify output
    const variables = {
        contentId: pageId,
        contentType: validContentType
    };
    return `$ROOT_QUERY.contentAnalyticsViewedComments(${JSON.stringify(variables)})`;
};
const $18a2fd912dfb58ac$export$cd81a9ad0848990 = ({ pageId: pageId })=>{
    const [contentType] = (0, $ep3mz.useContentType)();
    const writeFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentArtifact: (0, $aXiya.default),
        fragmentSpec: (0, $aXiya.default),
        __callerPackage__: "unread-comments"
    });
    const readFragmentInterop = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $5VFXo.default),
        __callerPackage__: "unread-comments"
    });
    // Network-only query for fresh data
    const { refetch: refetch } = (0, $jMyy4.useQueryInterop)($18a2fd912dfb58ac$var$ContentAnalyticsViewedComments, {
        skip: true,
        // Never query on render
        fetchPolicy: 'network-only',
        variables: {
            contentId: pageId,
            contentType: $18a2fd912dfb58ac$var$getValidContentTypeForViewedComments(contentType)
        },
        __callerPackage__: "unread-comments"
    });
    // Helper function to process the query result
    const processQueryResult = (0, $cozmU.useCallback)((data)=>{
        const commentIds = data?.contentAnalyticsViewedComments?.commentIds ?? [];
        const viewedCommentsSet = new Set(commentIds.filter((id)=>id !== null && id !== undefined));
        return {
            success: true,
            data: viewedCommentsSet
        };
    }, []);
    // Helper function for cache-only queries
    const executeCacheOnlyQuery = (0, $cozmU.useCallback)(()=>{
        if (!pageId || !contentType) throw new Error('Page ID and content type are required');
        try {
            // Read from ROOT_QUERY (where Apollo stores query results)
            const rootQueryCacheId = $18a2fd912dfb58ac$var$getRootQueryCacheId(pageId, contentType);
            const rootQueryData = readFragmentInterop({
                id: rootQueryCacheId
            });
            if (rootQueryData) {
                // Convert fragment data to query result format
                const queryResult = {
                    contentAnalyticsViewedComments: {
                        commentIds: rootQueryData.commentIds
                    }
                };
                return processQueryResult(queryResult);
            }
            return {
                success: false,
                error: new Error('No viewed comments data found in cache')
            };
        } catch (error) {
            // Handle cache read errors - these are local operations so we just log unexpected errors
            (0, $fJlJm.setContentErrorAttributes)(error, {
                objectId: pageId,
                objectType: 'page'
            });
            (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).COMMENTS
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
            return {
                success: false,
                error: error
            };
        }
    }, [
        pageId,
        contentType,
        processQueryResult,
        readFragmentInterop
    ]);
    // Helper function for network-only queries
    const executeNetworkOnlyQuery = (0, $cozmU.useCallback)(async ()=>{
        if (!pageId) throw new Error('Page ID and content type are required');
        try {
            const result = await refetch({
                contentId: pageId,
                contentType: $18a2fd912dfb58ac$var$getValidContentTypeForViewedComments(contentType)
            });
            // Apollo automatically writes query results to ROOT_QUERY cache, so we don't need to explicitly write
            // The executeCacheOnlyQuery function will read from ROOT_QUERY directly
            return processQueryResult(result.data);
        } catch (error) {
            // Handle expected errors (403/unauthorized, network errors) - just mark as handled
            if ((0, $1uFM6.isUnauthorizedError)(error) || (0, $6fil2.containsNetworkError)(error)) {
                (0, $7Sm4c.markErrorAsHandled)(error);
                return {
                    success: false,
                    error: error
                };
            }
            // Handle unexpected errors
            (0, $fJlJm.setContentErrorAttributes)(error, {
                objectId: pageId,
                objectType: 'page'
            });
            (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).COMMENTS
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
            return {
                success: false,
                error: error
            };
        }
    }, [
        pageId,
        contentType,
        processQueryResult,
        refetch
    ]);
    // Cached data query - uses cache-only for performance
    const getViewedCommentsCacheOnly = (0, $cozmU.useCallback)(()=>{
        try {
            return executeCacheOnlyQuery();
        } catch (error) {
            return {
                success: false,
                error: error
            };
        }
    }, [
        executeCacheOnlyQuery
    ]);
    // Fresh data query - always uses network-only for latest data
    const getViewedCommentsFresh = (0, $cozmU.useCallback)(()=>executeNetworkOnlyQuery(), [
        executeNetworkOnlyQuery
    ]);
    // Function to update the viewed comments cache
    // This is used for optimistic updates when comments are viewed locally
    const updateViewedCommentsCache = (0, $cozmU.useCallback)((commentIds)=>{
        if (!pageId || !contentType || commentIds.length === 0) return;
        try {
            // Read from ROOT_QUERY (where Apollo stores query results)
            const rootQueryCacheId = $18a2fd912dfb58ac$var$getRootQueryCacheId(pageId, contentType);
            const rootQueryData = readFragmentInterop({
                id: rootQueryCacheId
            });
            const existingCommentIds = rootQueryData?.commentIds ?? [];
            // Merge new comment IDs with existing ones
            const existingSet = new Set(existingCommentIds.filter((id)=>id !== null));
            commentIds.forEach((id)=>existingSet.add(id));
            const mergedCommentIds = Array.from(existingSet);
            // Update ROOT_QUERY cache
            writeFragmentInterop({
                fragmentId: rootQueryCacheId,
                data: {
                    commentIds: mergedCommentIds,
                    __typename: 'ViewedComments'
                }
            });
        } catch (error) {
            // Handle cache writing errors - these are local operations so we just log unexpected errors
            (0, $fJlJm.setContentErrorAttributes)(error, {
                objectId: pageId,
                objectType: 'page'
            });
            (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).COMMENTS
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    }, [
        pageId,
        contentType,
        readFragmentInterop,
        writeFragmentInterop
    ]);
    return {
        getViewedCommentsCacheOnly: getViewedCommentsCacheOnly,
        getViewedCommentsFresh: getViewedCommentsFresh,
        updateViewedCommentsCache: updateViewedCommentsCache
    };
};
module.exports["useViewedComments"] = $18a2fd912dfb58ac$export$cd81a9ad0848990;

});

parcelRegister("5VFXo", function(module, exports) {
/**
 * @generated SignedSource<<81d1b8de15cc7be4dc05b1f67ad843c8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a1027eddc6949c38$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useViewedComments_read",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "commentIds"
        }
    ],
    "type": "ViewedComments"
};
$a1027eddc6949c38$var$node.hash = "8133cc01831582777d2e0911570e19eb";
var $a1027eddc6949c38$export$2e2bcd8739ae039 = $a1027eddc6949c38$var$node;
module.exports["default"] = $a1027eddc6949c38$export$2e2bcd8739ae039;

});

parcelRegister("aXiya", function(module, exports) {
/**
 * @generated SignedSource<<958fb5adbccc1c73817035c31c0d22af>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7e3d4a4e06abb15d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useViewedComments_write",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "commentIds"
        }
    ],
    "type": "ViewedComments"
};
$7e3d4a4e06abb15d$var$node.hash = "d155cf7774eeec1efd57aa640539aef9";
var $7e3d4a4e06abb15d$export$2e2bcd8739ae039 = $7e3d4a4e06abb15d$var$node;
module.exports["default"] = $7e3d4a4e06abb15d$export$2e2bcd8739ae039;

});

parcelRegister("eLFD2", function(module, exports) {
/**
 * @generated SignedSource<<5a09a8bafd0f0986741b44b0b326104b>>
 * @relayHash 62839dc9a36eb801c9e817f5ebefa91f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 525c1fabca433deba33679d7a93d12d89e84cc662a445506517775392adadc65
const $61b7521c17137f8d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentType"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentType",
                    "variableName": "contentType"
                }
            ],
            "concreteType": "ViewedComments",
            "kind": "LinkedField",
            "name": "contentAnalyticsViewedComments",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "commentIds"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useViewedCommentsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useViewedCommentsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "62839dc9a36eb801c9e817f5ebefa91f",
            "id": "525c1fabca433deba33679d7a93d12d89e84cc662a445506517775392adadc65",
            "metadata": {},
            "name": "useViewedCommentsQuery",
            "operationKind": "query",
            "text": "query useViewedCommentsQuery($contentId:ID!,$contentType:ConfluenceAnalyticsCommentContentType!){contentAnalyticsViewedComments(contentId:$contentId,contentType:$contentType){commentIds}}"
        }
    };
}();
$61b7521c17137f8d$var$node.hash = "3584bbc92d39d1aa58e2ff1c3396ad40";
var $61b7521c17137f8d$export$2e2bcd8739ae039 = $61b7521c17137f8d$var$node;
module.exports["default"] = $61b7521c17137f8d$export$2e2bcd8739ae039;

});

parcelRegister("e4kZB", function(module, exports) {
const $5243889752facbc2$export$446c7c25f5f55821 = (comment)=>{
    return {
        id: comment.id,
        author: {
            accountId: comment.author?.__typename === 'KnownUser' ? comment.author.accountId : undefined
        },
        createdAt: {
            value: comment.createdAt?.value || ''
        },
        location: {
            type: comment.location.type,
            inlineMarkerRef: comment.location?.inlineMarkerRef,
            inlineResolveProperties: comment.location?.inlineResolveProperties,
            commentResolveProperties: comment.location?.commentResolveProperties
        }
    };
};
const $5243889752facbc2$export$77349abd6de54bd8 = ({ commentId: commentId, userId: userId, createdAt: createdAt, commentType: commentType, resolveProperties: resolveProperties })=>{
    return {
        id: commentId,
        author: {
            accountId: userId || undefined
        },
        createdAt: {
            value: createdAt || ''
        },
        location: {
            type: commentType,
            ...commentType === 'INLINE' ? {
                inlineResolveProperties: resolveProperties || {
                    resolved: false
                }
            } : {
                commentResolveProperties: resolveProperties || {
                    resolved: false
                }
            }
        }
    };
};
const $5243889752facbc2$export$8df0b6c8bcdda615 = ({ pageMode: pageMode = 'view', annotationsInEditorDoc: annotationsInEditorDoc, rendererAnnotations: rendererAnnotations })=>(markerRef)=>{
        if (!markerRef) return false; // default to false if no marker ref
        // Treat 'live' mode as 'edit' mode
        const effectivePageMode = pageMode === 'live' ? 'edit' : pageMode;
        return effectivePageMode === 'view' ? !rendererAnnotations.has(markerRef) : !annotationsInEditorDoc.has(markerRef);
    };
const $5243889752facbc2$export$22ce26f7ba09f326 = ({ comment: comment, currentUserId: currentUserId, viewedComments: viewedComments, isDanglingCallback: isDanglingCallback })=>{
    // Early return if comment is already viewed
    if (viewedComments.has(comment.id)) return false;
    const isNotOwnComment = comment.author?.accountId && comment.author.accountId !== currentUserId;
    const createdLast30Days = new Date(comment.createdAt?.value) > new Date(Date.now() - 2592000000);
    const commentLocation = comment?.location;
    const markerRef = commentLocation?.inlineMarkerRef;
    const isDanglingInlineComment = isDanglingCallback ? isDanglingCallback(markerRef) : false;
    const isPageComment = comment?.location.type === 'FOOTER';
    const isResolved = comment?.location?.inlineResolveProperties?.resolved || comment?.location?.commentResolveProperties?.resolved;
    return !isResolved && isNotOwnComment && createdLast30Days && (!isDanglingInlineComment || isPageComment);
};
const $5243889752facbc2$export$92c1e243fe45a57f = async ({ allComments: allComments, currentUserId: currentUserId, pageId: pageId, updateUnreadCommentIDSet: updateUnreadCommentIDSet, resetStates: resetStates, viewedComments: viewedComments, isDanglingCallback: isDanglingCallback })=>{
    if (!allComments || !pageId) return;
    const unreadCommentIds = new Set();
    allComments.forEach((comment)=>{
        if (!comment) return;
        if (currentUserId) {
            const parentCommentForValidation = $5243889752facbc2$export$446c7c25f5f55821(comment);
            if ($5243889752facbc2$export$22ce26f7ba09f326({
                comment: parentCommentForValidation,
                currentUserId: currentUserId,
                viewedComments: viewedComments,
                isDanglingCallback: isDanglingCallback
            })) unreadCommentIds.add(comment.id);
            if (comment.replies) comment.replies.forEach((reply)=>{
                if (reply) {
                    const replyForValidation = $5243889752facbc2$export$446c7c25f5f55821(reply);
                    if ($5243889752facbc2$export$22ce26f7ba09f326({
                        comment: replyForValidation,
                        currentUserId: currentUserId,
                        viewedComments: viewedComments,
                        isDanglingCallback: isDanglingCallback
                    })) unreadCommentIds.add(reply.id);
                }
            });
        }
    });
    updateUnreadCommentIDSet(unreadCommentIds, 'initialize');
    // Once we are done updating the unread list, need to reset the states.
    resetStates();
};
module.exports["buildValidationObjectFromProps"] = $5243889752facbc2$export$77349abd6de54bd8;
module.exports["commentIsDangling"] = $5243889752facbc2$export$8df0b6c8bcdda615;
module.exports["isValidUnreadComment"] = $5243889752facbc2$export$22ce26f7ba09f326;
module.exports["createUnreadCommentsSet"] = $5243889752facbc2$export$92c1e243fe45a57f;

});

parcelRegister("3FlVr", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable check-file/filename-blocklist */ // oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports
var $3196fb7749a17aaf$export$3b10d30805d4d939 = /*#__PURE__*/ function(ReactionLocation) {
    ReactionLocation["PAGE"] = "page";
    ReactionLocation["BLOGPOST"] = "blogpost";
    ReactionLocation["PAGE_COMMENT"] = "page-comment";
    ReactionLocation["INLINE_COMMENT"] = "inline-comment";
    ReactionLocation["EDITOR_INLINE_COMMENT"] = "editor-inline-comment";
    ReactionLocation["FEED_PAGE"] = "feed-page";
    ReactionLocation["FEED_BLOGPOST"] = "feed-blogpost";
    ReactionLocation["FEED_COMMENT"] = "feed-comment";
    ReactionLocation["OBJECT_COMMENT_FOOTER_PAGE"] = "object-comment-footer-page";
    ReactionLocation["OBJECT_COMMENT_FOOTER_BLOGPOST"] = "object-comment-footer-blogpost";
    return ReactionLocation;
}({});
var $3196fb7749a17aaf$export$d86afc9493bb8e1 = /*#__PURE__*/ function(ReactionContainerType) {
    ReactionContainerType["PAGE"] = "page";
    ReactionContainerType["BLOGPOST"] = "blogpost";
    ReactionContainerType["SPACE"] = "space";
    return ReactionContainerType;
}({});
module.exports["ReactionLocation"] = $3196fb7749a17aaf$export$3b10d30805d4d939;
module.exports["ReactionContainerType"] = $3196fb7749a17aaf$export$d86afc9493bb8e1;

});

parcelRegister("1NF8X", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");


var $bFPHx = parcelRequire("bFPHx");


var $5Kc7f = parcelRequire("5Kc7f");


const $032b81a28ff18608$export$96ee387620e23ced = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "XLglR",
    name: "ReactionsLoader",
    loading: (props)=>{
        return props?.summaryViewEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5Kc7f.ReactionsSummaryViewPlaceholder), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bFPHx.ReactionsPlaceholder), {
            useAccuratePills: true,
            ...props
        });
    },
    loader: async ()=>(await (parcelRequire("hkYAW"))).Reactions
});

const $032b81a28ff18608$export$ddfc48793728637f = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "4wRdk",
    name: "ReactionsLoaderBackground",
    loading: (props)=>{
        return props?.summaryViewEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5Kc7f.ReactionsSummaryViewPlaceholder), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bFPHx.ReactionsPlaceholder), null);
    },
    loader: async ()=>(await (parcelRequire("hkYAW"))).Reactions
});
module.exports["ReactionsLoader"] = $032b81a28ff18608$export$96ee387620e23ced;
module.exports["ReactionsLoaderBackground"] = $032b81a28ff18608$export$ddfc48793728637f;

});

parcelRegister("bFPHx", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $b3Wpp = parcelRequire("b3Wpp");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $b35Wv = parcelRequire("b35Wv");


var $4ez2K = parcelRequire("4ez2K");


var $1sCHt = parcelRequire("1sCHt");


var $jMyy4 = parcelRequire("jMyy4");


var $ep3mz = parcelRequire("ep3mz");

const $3ae84312c23de134$var$ReactionsPlaceholderQuery = (0, $b3Wpp.default);
const $3ae84312c23de134$var$placeholderContainerStyles = null;
const $3ae84312c23de134$var$reactionPillStyles = null;
const $3ae84312c23de134$var$reactionIconStyles = null;
const $3ae84312c23de134$var$DEFAULT_NUM_PILLS = 2;
const $3ae84312c23de134$export$47a91e92112986d6 = (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { useAccuratePills: useAccuratePills, onlyRenderPicker: onlyRenderPicker, customAnalyticsAttributes: customAnalyticsAttributes } = t0;
    const isSSR = window.__SSR_RENDERED__ || undefined;
    const [contentId] = (0, $ep3mz.usePageContentId)();
    let t1;
    if ($[0] !== contentId) {
        t1 = {
            contentId: contentId
        };
        $[0] = contentId;
        $[1] = t1;
    } else t1 = $[1];
    const t2 = !isSSR || !useAccuratePills || !contentId || onlyRenderPicker;
    let t3;
    if ($[2] !== t1 || $[3] !== t2) {
        t3 = {
            variables: t1,
            skip: t2
        };
        $[2] = t1;
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)($3ae84312c23de134$var$ReactionsPlaceholderQuery, {
        ...t3,
        __callerPackage__: "reactions"
    });
    if (loading) return null;
    let t4;
    if ($[5] !== customAnalyticsAttributes || $[6] !== onlyRenderPicker) {
        t4 = (numPills)=>onlyRenderPicker ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
                justifyContent: "center",
                alignItems: "center",
                testId: "reactions-picker-placeholder"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                appearance: "subtle",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($b35Wv))),
                label: "",
                analyticsContext: {
                    name: "reactionsPicker",
                    ...customAnalyticsAttributes
                }
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                "data-testid": "reactions-placeholder",
                className: (0, $hekY6.default)([
                    "_3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _0wOv4QsJSq _313842FQfX _1DCdHiFQfX _2XsHFMdnbC"
                ])
            }, Array(numPills).fill("").map($3ae84312c23de134$var$_temp), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                "data-testid": "reaction-icon",
                className: (0, $hekY6.default)([
                    "_2uo31faVjy _0bjKvDS5Zs _39xV02xpxF _0jFU0VxpxF _2XsHFMgVvo"
                ])
            }));
        $[5] = customAnalyticsAttributes;
        $[6] = onlyRenderPicker;
        $[7] = t4;
    } else t4 = $[7];
    const renderPlaceholder = t4;
    if (isSSR) {
        const numDistinctReactions = data?.content?.nodes?.[0]?.contentReactionsSummary?.reactionsSummaryForEmoji.length;
        const numReactionPills = numDistinctReactions !== undefined ? numDistinctReactions : $3ae84312c23de134$var$DEFAULT_NUM_PILLS;
        let t5;
        if ($[8] !== numReactionPills || $[9] !== renderPlaceholder) {
            t5 = renderPlaceholder(numReactionPills);
            $[8] = numReactionPills;
            $[9] = renderPlaceholder;
            $[10] = t5;
        } else t5 = $[10];
        return t5;
    } else {
        let t5;
        if ($[11] !== renderPlaceholder) {
            t5 = renderPlaceholder($3ae84312c23de134$var$DEFAULT_NUM_PILLS);
            $[11] = renderPlaceholder;
            $[12] = t5;
        } else t5 = $[12];
        return t5;
    }
};
function $3ae84312c23de134$var$_temp(_, i) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        key: i,
        "data-testid": "reactions-pill",
        className: (0, $hekY6.default)([
            "_2uo31faVjy _0bjKvDS5Zs _39xV02hzUg _0jFU0VoWWg _0adFHs1Y8M"
        ])
    });
}
module.exports["ReactionsPlaceholder"] = $3ae84312c23de134$export$47a91e92112986d6;

});

parcelRegister("b3Wpp", function(module, exports) {
/**
 * @generated SignedSource<<1d6855ec0a749a41169ad18fea189d4c>>
 * @relayHash 82e58e09cb6c0ae8731a0483a5357faf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d94877ce2b304668842025392ca6cfa2689c4ad6aec2d397cee17e057f1968a6
const $41658e2724bc842d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "concreteType": "ReactionsSummaryResponse",
                            "kind": "LinkedField",
                            "name": "contentReactionsSummary",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ReactionsSummaryForEmoji",
                                    "kind": "LinkedField",
                                    "name": "reactionsSummaryForEmoji",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ReactionsPlaceholderQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ReactionsPlaceholderQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "82e58e09cb6c0ae8731a0483a5357faf",
            "id": "d94877ce2b304668842025392ca6cfa2689c4ad6aec2d397cee17e057f1968a6",
            "metadata": {},
            "name": "ReactionsPlaceholderQuery",
            "operationKind": "query",
            "text": "query ReactionsPlaceholderQuery($contentId:ID!){content(id:$contentId){nodes{id,contentReactionsSummary{reactionsSummaryForEmoji{id}}}}}"
        }
    };
}();
$41658e2724bc842d$var$node.hash = "22ecbec40a97883abeadc26399cf4367";
var $41658e2724bc842d$export$2e2bcd8739ae039 = $41658e2724bc842d$var$node;
module.exports["default"] = $41658e2724bc842d$export$2e2bcd8739ae039;

});

parcelRegister("5Kc7f", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $1l0kj = parcelRequire("1l0kj");


var $iKpb2 = parcelRequire("iKpb2");

const $aba7293523a7a5b0$var$styles = {
    emojiPlaceholderBackground: "_0KLXruGsB2",
    wrapperStyles: "_2Zuz6Q2ADO _1Znuxb8HPE _313842Ll21",
    countSkeletonStyles: "_0bjKvDS5Zs _39xV02uFDC _0jFU0VuFDC _0KLXruGsB2"
};
const $aba7293523a7a5b0$var$PLACEHOLDER_COMMON_PROPS = {
    shortName: 'loading-placeholder',
    size: 16,
    xcss: $aba7293523a7a5b0$var$styles.emojiPlaceholderBackground
};
const $aba7293523a7a5b0$export$d85d0301f09f2005 = ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.050",
            alignBlock: "center",
            className: (0, $hekY6.default)([
                $aba7293523a7a5b0$var$styles.wrapperStyles
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iKpb2.default), $aba7293523a7a5b0$var$PLACEHOLDER_COMMON_PROPS), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iKpb2.default), $aba7293523a7a5b0$var$PLACEHOLDER_COMMON_PROPS), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iKpb2.default), $aba7293523a7a5b0$var$PLACEHOLDER_COMMON_PROPS), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $aba7293523a7a5b0$var$styles.countSkeletonStyles
            ])
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
module.exports["ReactionsSummaryViewPlaceholder"] = $aba7293523a7a5b0$export$d85d0301f09f2005;

});

parcelRegister("hkYAW", function(module, exports) {

let $c9f34ece6ba76655$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c9f34ece6ba76655$var$load("7BHAC"),
    $c9f34ece6ba76655$var$load("N3TvS"),
    $c9f34ece6ba76655$var$load("8lMr1"),
    $c9f34ece6ba76655$var$load("1vUE6"),
    $c9f34ece6ba76655$var$load("h0X0x"),
    $c9f34ece6ba76655$var$load("7l4Nc"),
    $c9f34ece6ba76655$var$load("7g00Y"),
    $c9f34ece6ba76655$var$load("30b92"),
    $c9f34ece6ba76655$var$load("6wr18"),
    $c9f34ece6ba76655$var$load("59hV4"),
    $c9f34ece6ba76655$var$load("keazL"),
    $c9f34ece6ba76655$var$load("dhXIT"),
    $c9f34ece6ba76655$var$load("6TLS9"),
    $c9f34ece6ba76655$var$load("ea3NB"),
    $c9f34ece6ba76655$var$load("fuOfV"),
    $c9f34ece6ba76655$var$load("jL1Ke"),
    $c9f34ece6ba76655$var$load("5MQ0D"),
    $c9f34ece6ba76655$var$load("ffEVr"),
    $c9f34ece6ba76655$var$load("5gsbh"),
    $c9f34ece6ba76655$var$load("h4Nf7"),
    $c9f34ece6ba76655$var$load("Wowvf"),
    $c9f34ece6ba76655$var$load("4g6rd"),
    $c9f34ece6ba76655$var$load("ayJxT"),
    $c9f34ece6ba76655$var$load("hhss7"),
    $c9f34ece6ba76655$var$load("43z9c"),
    $c9f34ece6ba76655$var$load("7EorR"),
    $c9f34ece6ba76655$var$load("1C6qR")
]).then(()=>parcelRequire('kTkGJ'));

});

parcelRegister("ewCYL", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $9wGTI = parcelRequire("9wGTI");

const $9204e37f72fd5b13$var$getPageCommentLeftMargin = (isDisabled)=>{
    if (isDisabled) // reactions-spacer is 5px wide
    return '0';
    else return '5px';
};
const $9204e37f72fd5b13$var$reactionsContainerStyles = null; // styling for disable state of reactions
const $9204e37f72fd5b13$var$disabledOrReadOnlyStyles = null; // hide the add reaction button and users dialog link for read-only
const $9204e37f72fd5b13$var$readOnlyStyles = null;
const $9204e37f72fd5b13$export$3dcc1cf4fc9c7641 = ({ isDisabled: isDisabled, hasReactions: _hasReactions, readOnly: readOnly, ...props })=>{
    'use no memo';
    return /*#__PURE__*/ $cozmU.createElement("div", {
        ...props,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _4l3O9BCNcR _1RO7DI0ULC _3zEvDYnQyn _10gybenQyn _3Zv1Q0uNcX _0mapbD5UaJ _3PGAKIZpcK",
            (isDisabled || readOnly) && "_4CzNtGsyl5 _3PGAKIKGUX _0jwYZZsyl5 _4c1j4xYbGa",
            readOnly && "_0uUfRBYbGa _0c8i1XYbGa"
        ])
    });
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $9204e37f72fd5b13$export$c7a67ebff2d113d4 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $9204e37f72fd5b13$export$3dcc1cf4fc9c7641 : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_313842UNDJ _0adFHsSPN1 _1DCdHidnbC _2XsHFMdnbC _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $9204e37f72fd5b13$export$b4e61fe3d4c2583b = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $9204e37f72fd5b13$export$3dcc1cf4fc9c7641 : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2XsHFMdnbC _313842UNDJ",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // apply for inline comment on view or edit page
const $9204e37f72fd5b13$export$86c494d6cf94f63c = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(8);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? $9204e37f72fd5b13$export$3dcc1cf4fc9c7641 : t2;
        const t3 = __cmplp.isDisabled ? "var(--ds-text-subtlest, #6B6E76)" : "var(--ds-text-subtle, #505258)";
        let t4;
        if ($[3] !== t3) {
            t4 = (0, $9aYkv.default)(t3);
            $[3] = t3;
            $[4] = t4;
        } else t4 = $[4];
        let t5;
        if ($[5] !== __cmpls || $[6] !== t4) {
            t5 = {
                ...__cmpls,
                "--_10axpyj": t4
            };
            $[5] = __cmpls;
            $[6] = t4;
            $[7] = t5;
        } else t5 = $[7];
        t1 = /*#__PURE__*/ $cozmU.createElement(C, {
            ...__cmplp,
            style: t5,
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_3PGAKINTQj",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $9204e37f72fd5b13$export$144e39595b801848 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $9204e37f72fd5b13$export$3dcc1cf4fc9c7641 : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_313842UNDJ",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // Original empty-state footer styling, retained as the gate-off fallback so that disabling
const $9204e37f72fd5b13$var$objectCommentFooterReactionsLegacyStyles = null;
const $9204e37f72fd5b13$var$objectCommentFooterReactionsStyles = null; // This container defaults to shrink-to-fit like its flex children below — without this, expanding
// would right-align pills inside a content-width box instead of the row's real available width.
const $9204e37f72fd5b13$var$footerReactionsExpandedContainerStyles = null; // The render params are intentionally untyped: the ambient `css` prop in this package resolves to
const $9204e37f72fd5b13$export$6534fd4b5ea3346a = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, ref)=>{
    const $ = (0, $bDgLe.c)(13);
    let isDisabled;
    let isFooterReactionsExpanded;
    let props;
    let readOnly;
    if ($[0] !== t0) {
        const { isDisabled: t1, hasReactions: hasReactions, readOnly: t2, isFooterReactionsExpanded: t3, ...t4 } = t0;
        isDisabled = t1;
        readOnly = t2;
        isFooterReactionsExpanded = t3;
        props = t4;
        $[0] = t0;
        $[1] = isDisabled;
        $[2] = isFooterReactionsExpanded;
        $[3] = props;
        $[4] = readOnly;
    } else {
        isDisabled = $[1];
        isFooterReactionsExpanded = $[2];
        props = $[3];
        readOnly = $[4];
    }
    const t1 = (isDisabled || readOnly) && "_4CzNtGsyl5 _3PGAKIKGUX _0jwYZZsyl5 _4c1j4xYbGa";
    const t2 = readOnly && "_0uUfRBYbGa _0c8i1XYbGa";
    let t3;
    if ($[5] !== isFooterReactionsExpanded || $[6] !== t1 || $[7] !== t2) {
        t3 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _4l3O9BCNcR _1RO7DI0ULC _3zEvDYnQyn _10gybenQyn _3Zv1Q0uNcX _0mapbD5UaJ _3PGAKIZpcK",
            t1,
            t2,
            (0, $9wGTI.fg)("add_a_reaction_bug") && "_0aFT5vbt8w _0hPCNLchRC _4kzS0HAsDq _04oUsnYvD1 _2RxggLYvD1 _00QdnPzXzM _4DJMR3Va5s _3UmIXGmnOE _39ls2CZpcK _0cW5eq2ADO",
            isFooterReactionsExpanded && "_39xV02N91d"
        ]);
        $[5] = isFooterReactionsExpanded;
        $[6] = t1;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== props || $[10] !== ref || $[11] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement("div", {
            ref: ref,
            ...props,
            className: t3
        });
        $[9] = props;
        $[10] = ref;
        $[11] = t3;
        $[12] = t4;
    } else t4 = $[12];
    return t4;
});
$9204e37f72fd5b13$export$6534fd4b5ea3346a.displayName = 'ObjectCommentFooterReactionsContainer'; // The collapsed/expanded reaction row. Collapsed stays `nowrap` (bounded pill count + toggle +
const $9204e37f72fd5b13$export$d2d9b59cc4dfea4d = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2mHwu81Y8M _3iDTPbQ4SZ _3TGfC9LRg7 _0hPCNLDIqT _42MJ74Pgdg _02Aeu5Pgdg _2gUqonKTcp _4aPBP7KTcp _2iBf4IVa5s _2mvsG2Va5s _2EF54HDIqT _1oEL8TDIqT _3KguNwcK7c _2a62DYcK7c _04wfO1cK7c _0c8i1XQ4SZ _2HfJ4cDIqT _0HuvzyVa5s _3u8lNwdnbC _0m7I8m7dHp _0iBqpaHnLE _1mdsfvz9WS _1NRHDUN91d",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // Styled to match the reaction pills it sits next to, rather than as plain subtle text.
const $9204e37f72fd5b13$export$f6626a1bfb292b2e = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "button" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4FKVYEw3P6 _2sNsIg7NXe _0bjKvDKTcp _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0jFU0VVa5s _1UtDYzKGUX _0KLXru66of _0wOv4Q7zJH _4EiLyUXzJH _34b3D2FQfX _1eOmH6o126 _3gzVzLN4oS",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $9204e37f72fd5b13$export$a44f62ffda6523d1 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4ouGXIGVdc _3138425zaO",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $9204e37f72fd5b13$export$49f6fd955ad6275a = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2XsHFM1Y8M",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
module.exports["ReactionsContainer"] = $9204e37f72fd5b13$export$3dcc1cf4fc9c7641;
module.exports["PageReactionsContainer"] = $9204e37f72fd5b13$export$c7a67ebff2d113d4;
module.exports["PageCommentReactionsContainer"] = $9204e37f72fd5b13$export$b4e61fe3d4c2583b;
module.exports["InlineCommentReactionsContainer"] = $9204e37f72fd5b13$export$86c494d6cf94f63c;
module.exports["FeedReactionsContainer"] = $9204e37f72fd5b13$export$144e39595b801848;
module.exports["ObjectCommentFooterReactionsContainer"] = $9204e37f72fd5b13$export$6534fd4b5ea3346a;
module.exports["FooterReactionsRow"] = $9204e37f72fd5b13$export$d2d9b59cc4dfea4d;
module.exports["FooterReactionsExpandToggle"] = $9204e37f72fd5b13$export$f6626a1bfb292b2e;
module.exports["MutationErrorContainer"] = $9204e37f72fd5b13$export$a44f62ffda6523d1;

});

parcelRegister("5qhgL", function(module, exports) {
/* reactions-utils.ts generated by @compiled/babel-plugin v3.0.2 */ 
var $ewCYL = parcelRequire("ewCYL");


var $3FlVr = parcelRequire("3FlVr");

const $bfbd403eb560ce3e$export$610a53f6a2b349ea = (location)=>{
    switch(location){
        case (0, $3FlVr.ReactionLocation).PAGE:
        case (0, $3FlVr.ReactionLocation).BLOGPOST:
            return 0, $ewCYL.PageReactionsContainer;
        case (0, $3FlVr.ReactionLocation).PAGE_COMMENT:
            return 0, $ewCYL.PageCommentReactionsContainer;
        case (0, $3FlVr.ReactionLocation).INLINE_COMMENT:
        case (0, $3FlVr.ReactionLocation).EDITOR_INLINE_COMMENT:
            return 0, $ewCYL.InlineCommentReactionsContainer;
        case (0, $3FlVr.ReactionLocation).FEED_PAGE:
        case (0, $3FlVr.ReactionLocation).FEED_BLOGPOST:
        case (0, $3FlVr.ReactionLocation).FEED_COMMENT:
            return 0, $ewCYL.FeedReactionsContainer;
        case (0, $3FlVr.ReactionLocation).OBJECT_COMMENT_FOOTER_PAGE:
        case (0, $3FlVr.ReactionLocation).OBJECT_COMMENT_FOOTER_BLOGPOST:
            return 0, $ewCYL.ObjectCommentFooterReactionsContainer;
        default:
            return 0, $ewCYL.ReactionsContainer;
    }
};
const $bfbd403eb560ce3e$export$bab27241713f2853 = (location)=>{
    switch(location){
        case (0, $3FlVr.ReactionLocation).PAGE:
        case (0, $3FlVr.ReactionLocation).FEED_PAGE:
        case (0, $3FlVr.ReactionLocation).OBJECT_COMMENT_FOOTER_PAGE:
            return 'page';
        case (0, $3FlVr.ReactionLocation).BLOGPOST:
        case (0, $3FlVr.ReactionLocation).FEED_BLOGPOST:
        case (0, $3FlVr.ReactionLocation).OBJECT_COMMENT_FOOTER_BLOGPOST:
            return 'blogpost';
        case (0, $3FlVr.ReactionLocation).PAGE_COMMENT:
        case (0, $3FlVr.ReactionLocation).INLINE_COMMENT:
        case (0, $3FlVr.ReactionLocation).EDITOR_INLINE_COMMENT:
        case (0, $3FlVr.ReactionLocation).FEED_COMMENT:
            return 'comment';
    }
};
const $bfbd403eb560ce3e$export$ebc11b395f5b2d6c = (location)=>{
    let isPage = false;
    let isComment = false;
    let isFeed = false;
    switch(location){
        case (0, $3FlVr.ReactionLocation).PAGE:
        case (0, $3FlVr.ReactionLocation).BLOGPOST:
        case (0, $3FlVr.ReactionLocation).OBJECT_COMMENT_FOOTER_PAGE:
        case (0, $3FlVr.ReactionLocation).OBJECT_COMMENT_FOOTER_BLOGPOST:
            isPage = true;
            break;
        case (0, $3FlVr.ReactionLocation).FEED_PAGE:
        case (0, $3FlVr.ReactionLocation).FEED_BLOGPOST:
            isFeed = true;
            break;
        case (0, $3FlVr.ReactionLocation).PAGE_COMMENT:
        case (0, $3FlVr.ReactionLocation).INLINE_COMMENT:
        case (0, $3FlVr.ReactionLocation).EDITOR_INLINE_COMMENT:
            isComment = true;
            break;
        // Feed comment is a special case that looks and queries like feed, but is technically a comment
        case (0, $3FlVr.ReactionLocation).FEED_COMMENT:
            isComment = true;
            isFeed = true;
            break;
    }
    return {
        isPage: isPage,
        isComment: isComment,
        isFeed: isFeed
    };
};
module.exports["getWrappingContainerByLocation"] = $bfbd403eb560ce3e$export$610a53f6a2b349ea;
module.exports["getContentTypeByLocation"] = $bfbd403eb560ce3e$export$bab27241713f2853;
module.exports["getBooleanLocationTypes"] = $bfbd403eb560ce3e$export$ebc11b395f5b2d6c;

});

parcelRegister("ke5Nx", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7zgzO = parcelRequire("7zgzO");

var $7176b627a488fb1c$export$eeec4f91154bc947 = /*#__PURE__*/ function(ReactionType) {
    ReactionType["COMMENT"] = "comment";
    return ReactionType;
}({});
const $7176b627a488fb1c$export$2278b801a31eb230 = ()=>{
    const $ = (0, $bDgLe.c)(15);
    const { getQueryParams: getQueryParams, setQueryParams: setQueryParams } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    let t0;
    if ($[0] !== getQueryParams) {
        t0 = getQueryParams();
        $[0] = getQueryParams;
        $[1] = t0;
    } else t0 = $[1];
    const { action: action, contentId: contentId, contentType: contentType, focusedCommentId: focusedCommentId, emojiId: emojiId } = t0;
    const reaction = action && action === "react";
    const quickReaction = action && action === "addReaction";
    const focusedPageReactionsId = reaction && contentType && (contentType === "page" || contentType === "blogpost") && contentId ? contentId : undefined;
    const focusedCommentReactionsId = reaction && focusedCommentId ? focusedCommentId : undefined;
    const quickReactionsEmojiId = quickReaction && emojiId ? emojiId : undefined;
    const focusedCommentQuickReactionsId = quickReactionsEmojiId && focusedCommentId ? focusedCommentId : undefined;
    const focusedPageQuickReactionsId = quickReaction && quickReactionsEmojiId && contentType && (contentType === "page" || contentType === "blogpost") && contentId ? contentId : undefined;
    let t1;
    if ($[2] !== action || $[3] !== emojiId || $[4] !== focusedCommentId || $[5] !== getQueryParams || $[6] !== setQueryParams) {
        t1 = (t2)=>{
            const { reactionType: reactionType } = t2 === undefined ? {} : t2;
            if (action && emojiId) {
                const queryParams = getQueryParams();
                setQueryParams({
                    ...queryParams,
                    action: undefined,
                    emojiId: undefined,
                    contentType: undefined,
                    contentId: undefined
                });
            } else if (reactionType === "comment" && action && focusedCommentId) {
                const queryParams_0 = getQueryParams();
                setQueryParams({
                    ...queryParams_0,
                    action: undefined,
                    focusedCommentId: undefined
                });
            }
        };
        $[2] = action;
        $[3] = emojiId;
        $[4] = focusedCommentId;
        $[5] = getQueryParams;
        $[6] = setQueryParams;
        $[7] = t1;
    } else t1 = $[7];
    const removeReactionsQueryParams = t1;
    let t2;
    if ($[8] !== focusedCommentQuickReactionsId || $[9] !== focusedCommentReactionsId || $[10] !== focusedPageQuickReactionsId || $[11] !== focusedPageReactionsId || $[12] !== quickReactionsEmojiId || $[13] !== removeReactionsQueryParams) {
        t2 = {
            focusedPageReactionsId: focusedPageReactionsId,
            focusedCommentReactionsId: focusedCommentReactionsId,
            focusedCommentQuickReactionsId: focusedCommentQuickReactionsId,
            focusedPageQuickReactionsId: focusedPageQuickReactionsId,
            quickReactionsEmojiId: quickReactionsEmojiId,
            removeReactionsQueryParams: removeReactionsQueryParams
        };
        $[8] = focusedCommentQuickReactionsId;
        $[9] = focusedCommentReactionsId;
        $[10] = focusedPageQuickReactionsId;
        $[11] = focusedPageReactionsId;
        $[12] = quickReactionsEmojiId;
        $[13] = removeReactionsQueryParams;
        $[14] = t2;
    } else t2 = $[14];
    return t2;
};
module.exports["ReactionType"] = $7176b627a488fb1c$export$eeec4f91154bc947;
module.exports["useReactionsQueryParams"] = $7176b627a488fb1c$export$2278b801a31eb230;

});

parcelRegister("aUU0C", function(module, exports) {

var $3u5lg = parcelRequire("3u5lg");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $6b57ff110c624a89$var$initialState = {
    annotations: []
};
const $6b57ff110c624a89$var$actions = {
    setEditorAnnotations: (newAnnotations, pageId)=>({ getState: getState, setState: setState })=>{
            const { annotations: annotations } = getState();
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(newAnnotations, annotations)) setState({
                annotations: newAnnotations,
                pageId: pageId
            });
        }
};
const $6b57ff110c624a89$var$EditorAnnotationsStore = (0, $8s9DV.createStore)({
    initialState: $6b57ff110c624a89$var$initialState,
    actions: $6b57ff110c624a89$var$actions,
    name: 'EditorAnnotationsStore'
});
const $6b57ff110c624a89$export$af3b3e68acbfeb43 = (0, $kBr4q.createHook)($6b57ff110c624a89$var$EditorAnnotationsStore);
const $6b57ff110c624a89$export$72e98d7f4c892f01 = (0, $kBr4q.createActionsHook)($6b57ff110c624a89$var$EditorAnnotationsStore);
module.exports["useEditorAnnotations"] = $6b57ff110c624a89$export$af3b3e68acbfeb43;
module.exports["useEditorAnnotationsActions"] = $6b57ff110c624a89$export$72e98d7f4c892f01;

});

parcelRegister("5fMeR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $fJCU9 = parcelRequire("fJCU9");


var $7aw3q = parcelRequire("7aw3q");


var $9wGTI = parcelRequire("9wGTI");


var $aWwYt = parcelRequire("aWwYt");


var $jvYFk = parcelRequire("jvYFk");


var $gczDe = parcelRequire("gczDe");


var $gfqXk = parcelRequire("gfqXk");


var $cD1qu = parcelRequire("cD1qu");


var $aSsfA = parcelRequire("aSsfA");


var $htsj6 = parcelRequire("htsj6");


var $cZa7r = parcelRequire("cZa7r");


var $3mVfX = parcelRequire("3mVfX");


var $ep3mz = parcelRequire("ep3mz");


var $dANtQ = parcelRequire("dANtQ");


var $gEtAQ = parcelRequire("gEtAQ");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $cMvMc = parcelRequire("cMvMc");


var $8aF6s = parcelRequire("8aF6s");


var $bSvtO = parcelRequire("bSvtO");


var $6mKj3 = parcelRequire("6mKj3");


var $jmjWc = parcelRequire("jmjWc");


var $4pGaH = parcelRequire("4pGaH");


const $3b7f940e5fdc8097$var$CommentsPanelFilterMenu = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Cp4VO",
    name: "CommentsPanelFilterMenu",
    loader: async ()=>(await (parcelRequire("aACKf"))).CommentsPanelFilterMenu
});

const $3b7f940e5fdc8097$var$CommentsPanelFooter = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "V6uhH",
    name: "CommentsPanelFooter",
    loader: async ()=>(await (parcelRequire("a8A2O"))).CommentsPanelFooter
});

const $3b7f940e5fdc8097$var$CommentsPanelHeaderIcon = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "EqpEC",
    name: "CommentsPanelHeaderIcon",
    loader: async ()=>(await (parcelRequire("60ddt"))).CommentsPanelHeaderIcon
});

const $3b7f940e5fdc8097$var$CommentsPanelWrapper = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "r3W5r",
    name: "CommentsPanelWrapper",
    loader: async ()=>(await (parcelRequire("1hHLn"))).CommentsPanelWrapper
});

const $3b7f940e5fdc8097$var$CommentsPanelHeaderActions = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "4wZwH",
    name: "CommentsPanelHeaderActions",
    loader: async ()=>(await (parcelRequire("lLNji"))).CommentsPanelHeaderActions
});
const $3b7f940e5fdc8097$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    commentsPanelHeaderLabel: {
        id: "comments-panel.panel.header.label",
        defaultMessage: "Comments"
    }
});
const $3b7f940e5fdc8097$export$b215887829902b28 = (pageMode)=>{
    // Always preload the core components
    // eslint-disable-next-line @typescript-eslint/no-floating-promises -- Intentional fire-and-forget preload
    $3b7f940e5fdc8097$var$CommentsPanelWrapper.preload();
    // eslint-disable-next-line @typescript-eslint/no-floating-promises -- Intentional fire-and-forget preload
    $3b7f940e5fdc8097$var$CommentsPanelFilterMenu.preload();
    // eslint-disable-next-line @typescript-eslint/no-floating-promises -- Intentional fire-and-forget preload
    $3b7f940e5fdc8097$var$CommentsPanelHeaderIcon.preload();
    // eslint-disable-next-line @typescript-eslint/no-floating-promises -- Intentional fire-and-forget preload
    $3b7f940e5fdc8097$var$CommentsPanelHeaderActions.preload();
    // Only preload footer in view mode (not edit mode)
    if (pageMode !== (0, $cD1qu.PageMode).EDIT) // eslint-disable-next-line @typescript-eslint/no-floating-promises -- Intentional fire-and-forget preload
    $3b7f940e5fdc8097$var$CommentsPanelFooter.preload();
};
const $3b7f940e5fdc8097$export$833f9a16214bbf3d = (preloadedCanAddComments)=>{
    const isSpaceOverviewPage = (0, $gEtAQ.isSpaceOverview)();
    const isDatabaseView = (0, $gEtAQ.isDatabase)();
    const isWhiteboardView = (0, $gEtAQ.isWhiteboard)();
    const isSlidesView = (0, $gEtAQ.isSlides)();
    const { contentStatus: contentStatus } = (0, $htsj6.useContentStatus)();
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const panel = (0, $aWwYt.usePanel)();
    const { showObjectSidebar: showObjectSidebar, hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { setViewProps: setViewProps, setEditorViewProps: setEditorViewProps } = (0, $cZa7r.useAnnotationsDispatch)();
    const { setCurrentView: setCurrentView, setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setReplyToCommentId: setReplyToCommentId } = (0, $3mVfX.useCommentsPanelActions)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { canAddComments: canAddComments } = (0, $dANtQ.useAddCommentPermissionCheck)(contentId ?? '', true, preloadedCanAddComments);
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const eventEmitter = pageMode === (0, $cD1qu.PageMode).VIEW ? (0, $gczDe.getRendererAnnotationEventEmitter)() : (0, $gfqXk.getEditorAnnotationEventEmitter)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const allowComments = (0, $7aw3q.useEmbeddedComments)();
    // a ref is needed here because of a closure issue with canClosePanel
    const hasContentChangedRef = (0, $cozmU.useRef)(hasContentChanged);
    (0, $cozmU.useEffect)(()=>{
        hasContentChangedRef.current = hasContentChanged;
    }, [
        hasContentChanged
    ]);
    const onPanelCloseFunction = ()=>{
        setCurrentView(undefined);
        // Unselect active annotations on the page
        if (pageMode === (0, $cD1qu.PageMode).VIEW) {
            eventEmitter.emit((0, $fJCU9.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
            eventEmitter.emit((0, $fJCU9.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS);
            setViewProps(null);
        } else {
            eventEmitter.emit('setselectedannotation', '');
            setEditorViewProps(null);
        }
        // clear selected comment thread in the comments panel
        setCurrentlySelectedThreadKey('');
        setReplyToCommentId();
    };
    const onPanelClose = (0, $cozmU.useCallback)(onPanelCloseFunction, [
        setCurrentView,
        pageMode,
        eventEmitter,
        setViewProps,
        setEditorViewProps,
        setCurrentlySelectedThreadKey,
        setReplyToCommentId
    ]);
    const canClosePanel = (0, $cozmU.useCallback)(async ()=>{
        if (hasContentChangedRef.current && !(0, $9wGTI.fg)('confluence_comments_fix_duplicate_modal')) return new Promise((resolve)=>{
            showModal((0, $cMvMc.CommentWarningDialog), {
                onConfirm: ()=>{
                    resetContentChanged && resetContentChanged();
                    resolve(true);
                },
                onCancel: ()=>{
                    resolve(false);
                }
            });
        });
        else return true;
    }, [
        resetContentChanged,
        showModal
    ]);
    const showCommentsPanelFunction = ({ openWithView: openWithView, initialSort: initialSort } = {})=>{
        if (!allowComments) return;
        experienceTracker.start({
            name: (0, $irVI7.SIDEBAR_COMMENTS_PANEL_LOAD_EXPERIENCE),
            attributes: {
                openWithView: openWithView,
                contentId: contentId,
                pageMode: pageMode
            }
        });
        const loadFooterComments = pageMode !== (0, $cD1qu.PageMode).EDIT;
        // Drag-to-resize on page surfaces only (same exclusions as the panel
        // itself). `expValEquals` is the LAST clause per
        // `confluence-feature-gating/no-preconditioning` so exposure is only
        // recorded for users who actually meet the surface preconditions.
        const isResizableSurface = !isSpaceOverviewPage && !isDatabaseView && !isWhiteboardView && !isSlidesView && (0, $6mKj3.expValEquals)('confluence_fe_comments_panel_resize', 'isEnabled', true);
        const showFooter = canAddComments && contentStatus !== (0, $cD1qu.ContentStatus).DRAFT && loadFooterComments && !isSpaceOverviewPage && !isDatabaseView && !isWhiteboardView && !isSlidesView;
        showObjectSidebar({
            id: (0, $jvYFk.PanelName).CommentsPanel,
            headerComponentElements: {
                HeaderIcon: $3b7f940e5fdc8097$var$CommentsPanelHeaderIcon,
                headerLabel: $3b7f940e5fdc8097$export$a7357cdd1f0b0168.commentsPanelHeaderLabel,
                HeaderRightAlignedElement: $3b7f940e5fdc8097$var$CommentsPanelHeaderActions
            },
            BodyComponent: ()=>(0, $cozmU.createElement)((0, $4pGaH.CommentsPanelPermissionContext).Provider, {
                    value: preloadedCanAddComments
                }, (0, $cozmU.createElement)($3b7f940e5fdc8097$var$CommentsPanelWrapper, {
                    openWithView: openWithView,
                    initialSort: initialSort
                })),
            FooterComponent: showFooter ? $3b7f940e5fdc8097$var$CommentsPanelFooter : undefined,
            closeOptions: {
                canClosePanel: canClosePanel,
                onPanelClose: onPanelClose
            },
            isResizable: isResizableSurface
        }, 'push');
    };
    const showCommentsPanel = (0, $cozmU.useCallback)(showCommentsPanelFunction, [
        allowComments,
        canAddComments,
        canClosePanel,
        contentId,
        contentStatus,
        experienceTracker,
        isDatabaseView,
        isSpaceOverviewPage,
        isWhiteboardView,
        isSlidesView,
        onPanelClose,
        pageMode,
        preloadedCanAddComments,
        showObjectSidebar
    ]);
    // NOTE: Exposing the hide function for now while we have the CommentButton
    return {
        isCommentsPanelShown: isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).CommentsPanel,
        showCommentsPanel: showCommentsPanel,
        hideCommentsPanel: hideObjectSidebar
    };
};
module.exports["preloadCommentsPanel"] = $3b7f940e5fdc8097$export$b215887829902b28;
module.exports["useShowCommentsPanel"] = $3b7f940e5fdc8097$export$833f9a16214bbf3d;

});

parcelRegister("aACKf", function(module, exports) {

let $7b5b52224132910d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $7b5b52224132910d$var$load("hhu66"),
    $7b5b52224132910d$var$load("6wr18"),
    $7b5b52224132910d$var$load("gbis9"),
    $7b5b52224132910d$var$load("w3Gc8"),
    $7b5b52224132910d$var$load("ffEVr"),
    $7b5b52224132910d$var$load("bZz7X")
]).then(()=>parcelRequire('g9dNl'));

});

parcelRegister("a8A2O", function(module, exports) {

let $76169c69375f5349$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $76169c69375f5349$var$load("aLwQm"),
    $76169c69375f5349$var$load("lkHIj"),
    $76169c69375f5349$var$load("b8BFA"),
    $76169c69375f5349$var$load("7BHAC"),
    $76169c69375f5349$var$load("N3TvS"),
    $76169c69375f5349$var$load("fEvpQ"),
    $76169c69375f5349$var$load("6wr18"),
    $76169c69375f5349$var$load("aIw3f"),
    $76169c69375f5349$var$load("8LtYa"),
    $76169c69375f5349$var$load("bY2TC"),
    $76169c69375f5349$var$load("gbis9"),
    $76169c69375f5349$var$load("gAKfH"),
    $76169c69375f5349$var$load("ffEVr"),
    $76169c69375f5349$var$load("hhss7"),
    $76169c69375f5349$var$load("9zpfi"),
    $76169c69375f5349$var$load("9pNir"),
    $76169c69375f5349$var$load("8lMr1"),
    $76169c69375f5349$var$load("1vUE6"),
    $76169c69375f5349$var$load("7A87G"),
    $76169c69375f5349$var$load("kT6dz"),
    $76169c69375f5349$var$load("aAWLw"),
    $76169c69375f5349$var$load("6q8Rl")
]).then(()=>parcelRequire('gFN6K'));

});

parcelRegister("60ddt", function(module, exports) {

let $45ecfea625e292e8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $45ecfea625e292e8$var$load("6wr18"),
    $45ecfea625e292e8$var$load("ffEVr"),
    $45ecfea625e292e8$var$load("jtuzz")
]).then(()=>parcelRequire('ioFqb'));

});

parcelRegister("1hHLn", function(module, exports) {

let $0ef9536fbc2e07d1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $0ef9536fbc2e07d1$var$load("kT6dz"),
    $0ef9536fbc2e07d1$var$load("64FEU"),
    $0ef9536fbc2e07d1$var$load("6TLS9"),
    $0ef9536fbc2e07d1$var$load("lkHIj"),
    $0ef9536fbc2e07d1$var$load("b8BFA"),
    $0ef9536fbc2e07d1$var$load("7BHAC"),
    $0ef9536fbc2e07d1$var$load("N3TvS"),
    $0ef9536fbc2e07d1$var$load("h0X0x"),
    $0ef9536fbc2e07d1$var$load("7l4Nc"),
    $0ef9536fbc2e07d1$var$load("7g00Y"),
    $0ef9536fbc2e07d1$var$load("jsNWB"),
    $0ef9536fbc2e07d1$var$load("fHwKU"),
    $0ef9536fbc2e07d1$var$load("53Y0O"),
    $0ef9536fbc2e07d1$var$load("kYlwR"),
    $0ef9536fbc2e07d1$var$load("3fvxJ"),
    $0ef9536fbc2e07d1$var$load("50xKF"),
    $0ef9536fbc2e07d1$var$load("34Kox"),
    $0ef9536fbc2e07d1$var$load("7Y0AX"),
    $0ef9536fbc2e07d1$var$load("1GCFv"),
    $0ef9536fbc2e07d1$var$load("2bOpC"),
    $0ef9536fbc2e07d1$var$load("6thPm"),
    $0ef9536fbc2e07d1$var$load("bY2TC"),
    $0ef9536fbc2e07d1$var$load("11vYs"),
    $0ef9536fbc2e07d1$var$load("gbis9"),
    $0ef9536fbc2e07d1$var$load("RylUf"),
    $0ef9536fbc2e07d1$var$load("bABRe"),
    $0ef9536fbc2e07d1$var$load("4aKct"),
    $0ef9536fbc2e07d1$var$load("dxcsb"),
    $0ef9536fbc2e07d1$var$load("jqoep"),
    $0ef9536fbc2e07d1$var$load("6dLts"),
    $0ef9536fbc2e07d1$var$load("jdPbE"),
    $0ef9536fbc2e07d1$var$load("eUsnQ"),
    $0ef9536fbc2e07d1$var$load("L98h8"),
    $0ef9536fbc2e07d1$var$load("dfVn7"),
    $0ef9536fbc2e07d1$var$load("fEhMd"),
    $0ef9536fbc2e07d1$var$load("6wr18"),
    $0ef9536fbc2e07d1$var$load("Wowvf"),
    $0ef9536fbc2e07d1$var$load("7gL7H"),
    $0ef9536fbc2e07d1$var$load("hhss7"),
    $0ef9536fbc2e07d1$var$load("lrmeP"),
    $0ef9536fbc2e07d1$var$load("6fY3H"),
    $0ef9536fbc2e07d1$var$load("dtNxV"),
    $0ef9536fbc2e07d1$var$load("9zpfi"),
    $0ef9536fbc2e07d1$var$load("9pNir"),
    $0ef9536fbc2e07d1$var$load("a7sEM"),
    $0ef9536fbc2e07d1$var$load("ffEVr"),
    $0ef9536fbc2e07d1$var$load("a6kGP"),
    $0ef9536fbc2e07d1$var$load("dB5kj"),
    $0ef9536fbc2e07d1$var$load("8Jd6S"),
    $0ef9536fbc2e07d1$var$load("dIY7W"),
    $0ef9536fbc2e07d1$var$load("8lMr1"),
    $0ef9536fbc2e07d1$var$load("1vUE6"),
    $0ef9536fbc2e07d1$var$load("1sii7"),
    $0ef9536fbc2e07d1$var$load("fEvpQ"),
    $0ef9536fbc2e07d1$var$load("fWCBZ"),
    $0ef9536fbc2e07d1$var$load("7A87G"),
    $0ef9536fbc2e07d1$var$load("75JEs"),
    $0ef9536fbc2e07d1$var$load("lywre"),
    $0ef9536fbc2e07d1$var$load("43z9c"),
    $0ef9536fbc2e07d1$var$load("7EorR"),
    $0ef9536fbc2e07d1$var$load("gd3iv")
]).then(()=>parcelRequire('5hqV2'));

});

parcelRegister("lLNji", function(module, exports) {

let $fd943cbc8fcb164f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $fd943cbc8fcb164f$var$load("hhu66"),
    $fd943cbc8fcb164f$var$load("6wr18"),
    $fd943cbc8fcb164f$var$load("gbis9"),
    $fd943cbc8fcb164f$var$load("w3Gc8"),
    $fd943cbc8fcb164f$var$load("ffEVr"),
    $fd943cbc8fcb164f$var$load("bZz7X"),
    $fd943cbc8fcb164f$var$load("9izCO")
]).then(()=>parcelRequire('gDZxl'));

});

parcelRegister("6lAIr", function(module, exports) {

var $cD1qu = parcelRequire("cD1qu");


var $6mKj3 = parcelRequire("6mKj3");


var $i6UMJ = parcelRequire("i6UMJ");


var $3mVfX = parcelRequire("3mVfX");

const $475d5d8641a18b80$var$isParentCommentOpen = (commentData)=>commentData.isOpen;
const $475d5d8641a18b80$var$isInlineLocation = (location)=>{
    return location != null && 'inlineMarkerRef' in location;
};
const $475d5d8641a18b80$var$isParentComment = (comment)=>'isOpen' in comment;
const $475d5d8641a18b80$var$getVisibleGeneralComments = ({ isCommentValid: isCommentValid, comments: comments })=>Object.values(comments).reduce((acc, comment)=>{
        if (isCommentValid(comment)) acc.push({
            ...comment,
            replies: comment.replies.filter((reply)=>reply && isCommentValid(reply))
        });
        return acc;
    }, []);
const $475d5d8641a18b80$var$getNextInlineResolveProperties = (inlineResolveProperties, isDangling)=>{
    if (!inlineResolveProperties) return {};
    return {
        inlineResolveProperties: {
            ...inlineResolveProperties,
            isDangling: isDangling
        }
    };
};
const $475d5d8641a18b80$var$updateCommentLocation = (comment, isDangling)=>{
    const commentLocation = comment.location;
    if (!$475d5d8641a18b80$var$isInlineLocation(commentLocation)) return commentLocation;
    // Preserve the existing location reference when the derived value is unchanged.
    const existingResolveProperties = commentLocation.inlineResolveProperties;
    if (!existingResolveProperties) return commentLocation;
    if (existingResolveProperties.isDangling === isDangling) return commentLocation;
    return {
        ...commentLocation,
        ...$475d5d8641a18b80$var$getNextInlineResolveProperties(commentLocation.inlineResolveProperties, isDangling)
    };
};
const $475d5d8641a18b80$var$getNextComment = (comment, isDangling)=>{
    const nextLocation = $475d5d8641a18b80$var$updateCommentLocation(comment, isDangling);
    if (nextLocation === comment.location) return comment;
    return {
        ...comment,
        location: nextLocation
    };
};
const $475d5d8641a18b80$var$getVisibleInlineComments = (isCommentValid, comments, orderedAnnotationIds, _isNewDanglingCommentExperienceEnabled)=>{
    const activeMarkerRefs = new Set(orderedAnnotationIds);
    const nonDangling = [];
    const dangling = [];
    const validComments = Object.values(comments).reduce((acc, comment)=>{
        if (isCommentValid(comment)) {
            // Reuse the original reply and comment references when filtering changes nothing.
            const filteredReplies = comment.replies.filter(isCommentValid);
            const replies = filteredReplies.length === comment.replies.length ? comment.replies : filteredReplies;
            if (replies === comment.replies) acc.push(comment);
            else acc.push({
                ...comment,
                replies: replies
            });
        }
        return acc;
    }, []);
    for (const comment of validComments){
        const commentLocation = comment.location;
        const inlineMarkerRef = $475d5d8641a18b80$var$isInlineLocation(commentLocation) ? commentLocation.inlineMarkerRef : null;
        const isDangling = !inlineMarkerRef || !activeMarkerRefs.has(inlineMarkerRef);
        const updatedComment = $475d5d8641a18b80$var$getNextComment(comment, isDangling);
        if (isDangling) dangling.push(updatedComment);
        else nonDangling.push(updatedComment);
    }
    return [
        nonDangling,
        dangling
    ];
};
const $475d5d8641a18b80$export$70df9f207ee9869d = (comment)=>$475d5d8641a18b80$var$isParentComment(comment) ? !$475d5d8641a18b80$var$isParentCommentOpen(comment) : true;
const $475d5d8641a18b80$export$28d3eb19856355d7 = (comment)=>$475d5d8641a18b80$var$isParentComment(comment) ? $475d5d8641a18b80$var$isParentCommentOpen(comment) : true;
const $475d5d8641a18b80$var$sortInlineCommentsByOrderedActiveAnnotationIdList = (comments, orderedAnnotationIds)=>{
    const commentsByMarkerRef = new Map(comments.map((comment)=>{
        const commentLocation = comment.location;
        const inlineMarkerRef = $475d5d8641a18b80$var$isInlineLocation(commentLocation) ? commentLocation.inlineMarkerRef : null;
        return [
            inlineMarkerRef,
            comment
        ];
    }));
    return orderedAnnotationIds.map((id)=>commentsByMarkerRef.get(id)).filter((comment)=>comment !== undefined);
};
const $475d5d8641a18b80$var$getVisibleInlineThreadsForView = (currentView, sortedNonDanglingComments, danglingComments)=>{
    switch(currentView){
        case (0, $3mVfX.ViewValues).OPEN:
            // Detached threads join the Open view after the attached ones, so the list stays
            // partitioned by type for the general comments divider.
            return (0, $6mKj3.expValEquals)('cc_comments_detached_in_open_view', 'isEnabled', true) ? [
                ...sortedNonDanglingComments,
                ...danglingComments
            ] : sortedNonDanglingComments;
        case (0, $3mVfX.ViewValues).DELETED_CONTENT:
            return danglingComments;
        default:
            return [
                ...sortedNonDanglingComments,
                ...danglingComments
            ];
    }
};
const $475d5d8641a18b80$var$getVisibleInlineThreads = ({ isCommentValid: isCommentValid, commentsDataMap: commentsDataMap, orderedAnnotationIds: orderedAnnotationIds, currentView: currentView, isNewDanglingCommentExperienceEnabled: isNewDanglingCommentExperienceEnabled })=>{
    const [nonDanglingComments, danglingComments] = $475d5d8641a18b80$var$getVisibleInlineComments(isCommentValid, commentsDataMap.inline, orderedAnnotationIds, isNewDanglingCommentExperienceEnabled);
    const sortedNonDanglingComments = $475d5d8641a18b80$var$sortInlineCommentsByOrderedActiveAnnotationIdList(nonDanglingComments, orderedAnnotationIds);
    const visibleInlineThreadsForView = isNewDanglingCommentExperienceEnabled ? $475d5d8641a18b80$var$getVisibleInlineThreadsForView(currentView, sortedNonDanglingComments, danglingComments) : [
        ...sortedNonDanglingComments,
        ...danglingComments
    ];
    return visibleInlineThreadsForView;
};
const $475d5d8641a18b80$var$getIsCommentValid = ({ currentView: currentView })=>{
    switch(currentView){
        case (0, $3mVfX.ViewValues).RESOLVED:
            return $475d5d8641a18b80$export$70df9f207ee9869d;
        default:
            return $475d5d8641a18b80$export$28d3eb19856355d7;
    }
};
// Determine if general comments are enabled based on the user's selection and that the user is not
// in Edit mode. All comments are loaded regardless of the page mode, so since we don't want general
// comments in the list in Edit mode we need to explicitly hide them here.
const $475d5d8641a18b80$var$isGeneralCommentsEnabled = ({ includeGeneralComments: includeGeneralComments, pageMode: pageMode })=>includeGeneralComments && pageMode !== (0, $cD1qu.PageMode).EDIT;
const $475d5d8641a18b80$export$cbe812921774e978 = ({ commentsDataMap: commentsDataMap, orderedAnnotationIds: orderedAnnotationIds, includeInlineComments: includeInlineComments, includeGeneralComments: includeGeneralComments, currentView: currentView = (0, $3mVfX.ViewValues).OPEN, isNewDanglingCommentExperienceEnabled: isNewDanglingCommentExperienceEnabled = false, isCommentValid: providedIsCommentValid, pageMode: pageMode })=>{
    const threads = [];
    const isCommentValid = providedIsCommentValid ?? $475d5d8641a18b80$var$getIsCommentValid({
        currentView: currentView
    });
    if (includeInlineComments) {
        const inlineThreads = $475d5d8641a18b80$var$getVisibleInlineThreads({
            isCommentValid: isCommentValid,
            commentsDataMap: commentsDataMap,
            orderedAnnotationIds: orderedAnnotationIds,
            currentView: currentView,
            isNewDanglingCommentExperienceEnabled: isNewDanglingCommentExperienceEnabled
        });
        threads.push(...inlineThreads);
    }
    if ($475d5d8641a18b80$var$isGeneralCommentsEnabled({
        includeGeneralComments: includeGeneralComments,
        pageMode: pageMode
    })) {
        const generalThreads = $475d5d8641a18b80$var$getVisibleGeneralComments({
            isCommentValid: isCommentValid,
            comments: commentsDataMap.general
        }).sort((0, $i6UMJ.getCommentsSortedOldestToNewest));
        threads.push(...generalThreads);
    }
    return threads;
};
module.exports["isCommentOpen"] = $475d5d8641a18b80$export$28d3eb19856355d7;
module.exports["getVisibleCommentThreads"] = $475d5d8641a18b80$export$cbe812921774e978;

});

parcelRegister("1czFr", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $gi0WF = parcelRequire("gi0WF");

const $e63c8ea486e09ced$export$faaf0da9552bb131 = (debounceMs = 1000)=>{
    const markCommentsAsRead = (0, $gi0WF.useMarkCommentsAsRead)();
    const pendingCommentIds = (0, $cozmU.useRef)(new Set());
    const timeoutRef = (0, $cozmU.useRef)(null);
    const beforeUnloadHandlerRef = (0, $cozmU.useRef)(null);
    const debouncedMarkCommentsAsRead = (0, $cozmU.useCallback)((commentId)=>{
        // Add the comment ID to the pending set
        pendingCommentIds.current.add(commentId);
        // Clear any existing timeout
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        // Set a new timeout to batch and send the request
        timeoutRef.current = setTimeout(()=>{
            const commentIdsToMark = Array.from(pendingCommentIds.current);
            // Clear the pending set
            pendingCommentIds.current.clear();
            // Reset the timeout ref
            timeoutRef.current = null;
            // Only call the mutation if there are comments to mark
            if (commentIdsToMark.length > 0) markCommentsAsRead(commentIdsToMark);
        }, debounceMs);
    }, [
        markCommentsAsRead,
        debounceMs
    ]);
    // Function to send pending comment IDs
    const sendPendingComments = (0, $cozmU.useCallback)(()=>{
        const commentIdsToMark = Array.from(pendingCommentIds.current);
        if (commentIdsToMark.length === 0) return;
        // Clear the pending set
        pendingCommentIds.current.clear();
        // Just call the existing mutation function
        markCommentsAsRead(commentIdsToMark);
    }, [
        markCommentsAsRead
    ]);
    // Beforeunload event handler (e.g. when the user closes the tab or window)
    const handleBeforeUnload = (0, $cozmU.useCallback)((_event)=>{
        sendPendingComments();
    }, [
        sendPendingComments
    ]);
    // Set up beforeunload event listener
    (0, $cozmU.useEffect)(()=>{
        beforeUnloadHandlerRef.current = handleBeforeUnload;
        window.addEventListener('beforeunload', handleBeforeUnload);
        return ()=>{
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [
        handleBeforeUnload
    ]);
    // Flush pending comments and clear timeout
    const flushPendingComments = (0, $cozmU.useCallback)(()=>{
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        // Send any pending comments
        sendPendingComments();
    }, [
        sendPendingComments
    ]);
    return {
        debouncedMarkCommentsAsRead: debouncedMarkCommentsAsRead,
        flushPendingComments: flushPendingComments
    };
};
module.exports["useDebouncedMarkCommentsAsRead"] = $e63c8ea486e09ced$export$faaf0da9552bb131;

});

parcelRegister("gi0WF", function(module, exports) {

var $8rdFk = parcelRequire("8rdFk");


var $cozmU = parcelRequire("cozmU");


var $308Wd = parcelRequire("308Wd");


var $7Sm4c = parcelRequire("7Sm4c");


var $1uFM6 = parcelRequire("1uFM6");


var $6fil2 = parcelRequire("6fil2");


var $fJlJm = parcelRequire("fJlJm");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $bMmYR = parcelRequire("bMmYR");


var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");

const $170c9bba7ed44542$var$markCommentsAsReadMutation = (0, $8rdFk.default);
const $170c9bba7ed44542$export$db614d7d47784b95 = ()=>{
    const [markCommentsAsRead] = (0, $308Wd.useMutationInterop)($170c9bba7ed44542$var$markCommentsAsReadMutation, {
        __callerPackage__: "unread-comments"
    });
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const markCommentsAsReadFn = (0, $cozmU.useCallback)(async (commentIds)=>{
        if (commentIds.length === 0) return;
        // Start experience tracking for marking comments as read
        experienceTracker.start({
            name: (0, $irVI7.MARK_COMMENTS_AS_READ_EXPERIENCE),
            attributes: {
                commentIds: commentIds,
                commentCount: commentIds.length
            }
        });
        let attemptNumber = 1;
        try {
            const result = await (0, $bMmYR.retry)(async (attempt)=>{
                attemptNumber = attempt + 1;
                return await markCommentsAsRead({
                    variables: {
                        commentIds: commentIds
                    }
                });
            }, {}, async (error)=>{
                // Don't retry for expected errors (403/unauthorized, network errors)
                return !(0, $1uFM6.isUnauthorizedError)(error) && !(0, $6fil2.containsNetworkError)(error);
            });
            // Check if the mutation succeeded
            if (result?.data?.markCommentsAsRead?.success) // Mark experience as successful
            experienceTracker.succeed({
                name: (0, $irVI7.MARK_COMMENTS_AS_READ_EXPERIENCE),
                attributes: {
                    commentIds: commentIds,
                    commentCount: commentIds.length,
                    attemptNumber: attemptNumber
                }
            });
            else // Backend returned success: false
            experienceTracker.fail({
                name: (0, $irVI7.MARK_COMMENTS_AS_READ_EXPERIENCE),
                error: new Error('Backend returned success: false'),
                attributes: {
                    attemptNumber: attemptNumber
                }
            });
        } catch (err) {
            // Handle expected errors (403/unauthorized, network errors) - abort experience tracking
            if ((0, $1uFM6.isUnauthorizedError)(err) || (0, $6fil2.containsNetworkError)(err)) {
                experienceTracker.abort({
                    name: (0, $irVI7.MARK_COMMENTS_AS_READ_EXPERIENCE),
                    reason: 'Expected error (unauthorized or network error)'
                });
                (0, $7Sm4c.markErrorAsHandled)(err);
                return;
            }
            // Mark experience as failed for unexpected errors
            experienceTracker.fail({
                name: (0, $irVI7.MARK_COMMENTS_AS_READ_EXPERIENCE),
                error: err,
                attributes: {
                    attemptNumber: attemptNumber
                }
            });
            // Handle unexpected errors (including 500) - track them with context
            (0, $fJlJm.setContentErrorAttributes)(err, {
                objectType: 'comment'
            });
            (0, $5ZqQS.getMonitoringClient)().submitError(err, {
                attribution: (0, $3IBnw.Attribution).COMMENTS
            });
            (0, $7Sm4c.markErrorAsHandled)(err);
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- experienceTracker from context doesn't need to be in deps
    [
        markCommentsAsRead
    ]);
    return markCommentsAsReadFn;
};
module.exports["useMarkCommentsAsRead"] = $170c9bba7ed44542$export$db614d7d47784b95;

});

parcelRegister("8rdFk", function(module, exports) {
/**
 * @generated SignedSource<<fede2250a28c1036d502c7a0d09fbbf6>>
 * @relayHash 446a6fa3fbbe8bbb4444e858a1c7626c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2666786691a2a90a6a0d6434d55d4758dfc395b6e9ba53c0598118cccde4da14
const $4a78b10481ac8443$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "commentIds"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "commentIds",
                            "variableName": "commentIds"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "MarkCommentsAsReadPayload",
            "kind": "LinkedField",
            "name": "markCommentsAsRead",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "kind": "ScalarField",
                    "name": "errors"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useMarkCommentsAsReadMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useMarkCommentsAsReadMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "446a6fa3fbbe8bbb4444e858a1c7626c",
            "id": "2666786691a2a90a6a0d6434d55d4758dfc395b6e9ba53c0598118cccde4da14",
            "metadata": {},
            "name": "useMarkCommentsAsReadMutation",
            "operationKind": "mutation",
            "text": "mutation useMarkCommentsAsReadMutation($commentIds:[ID!]!){markCommentsAsRead(input:{commentIds:$commentIds}){success,errors}}"
        }
    };
}();
$4a78b10481ac8443$var$node.hash = "d155280f920b93703b5ae452997bdcaf";
var $4a78b10481ac8443$export$2e2bcd8739ae039 = $4a78b10481ac8443$var$node;
module.exports["default"] = $4a78b10481ac8443$export$2e2bcd8739ae039;

});

parcelRegister("3plmx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $ggGdk = parcelRequire("ggGdk");


var $kLzei = parcelRequire("kLzei");


var $bQm3c = parcelRequire("bQm3c");


var $btIEy = parcelRequire("btIEy");


var $i6Ps3 = parcelRequire("i6Ps3");


var $eaaOs = parcelRequire("eaaOs");


var $6M71K = parcelRequire("6M71K");

const $78db0f388b3bc59b$var$useInitialState = ()=>{
    return (0, $cozmU.useMemo)(()=>{
        const ssrProvidersData = window['__SSR_EDITOR_NODE_DATA_PROVIDERS_DATA__'] || {};
        const ssrData = ssrProvidersData.editorCardProvider;
        if (!ssrData) return undefined;
        return Object.entries(ssrData).reduce((acc, [cacheKey, details])=>{
            const { metadataStatus: cacheMetadataStatus, url: url } = (0, $eaaOs.getUrlAndMetadataStatus)(cacheKey);
            const status = (0, $ggGdk.getStatus)(details);
            const metadataStatus = status === 'resolved' ? cacheMetadataStatus : 'resolved';
            if (acc[url]?.metadataStatus === 'resolved' && metadataStatus !== 'resolved') return acc;
            acc[url] = {
                status: status,
                details: details,
                metadataStatus: metadataStatus
            };
            return acc;
        }, {});
    }, []);
};
const $78db0f388b3bc59b$var$useStoreOptions = ()=>{
    const isPageSSR = (0, $i6Ps3.isPageSSRd)();
    const initialState = $78db0f388b3bc59b$var$useInitialState();
    const oldInitialState = window['__SSR_SMARTLINKS__'];
    const oldStoreOptions = (0, $btIEy.useStoreOptions)(oldInitialState, isPageSSR);
    return (0, $cozmU.useMemo)(()=>{
        if (initialState) return {
            initialState: initialState
        };
        return oldStoreOptions.storeOptions;
    }, [
        oldStoreOptions,
        initialState
    ]);
};
function $78db0f388b3bc59b$export$eaed11d22c122636(WrappedComponent) {
    return (props)=>{
        const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
        const storeOptions = $78db0f388b3bc59b$var$useStoreOptions();
        const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6M71K.ConfluenceSmartCardProvider), {
            ...(0, $kLzei.getSmartCardRenderers)(),
            storeOptions: storeOptions,
            isAdminHubAIEnabled: isAdminHubAIEnabled
        }, content));
    };
}
module.exports["withSmartCardProviderContext"] = $78db0f388b3bc59b$export$eaed11d22c122636;

});

parcelRegister("inDu6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $kRW4Y = parcelRequire("kRW4Y");

function $34458177b4f70747$export$69f1ef99d32d73a0(InnerComponent) {
    var _WithDialogs;
    return _WithDialogs = class WithDialogs extends (0, $cozmU.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
                to: [
                    (0, $kRW4Y.DialogsStateContainer)
                ]
            }, (dialogs)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(InnerComponent, {
                    ...this.props,
                    dialogs: dialogs
                }));
        }
    }, _WithDialogs.displayName = `withDialogs(${InnerComponent.displayName || InnerComponent.name})`, _WithDialogs;
}
module.exports["withDialogs"] = $34458177b4f70747$export$69f1ef99d32d73a0;

});

parcelRegister("cgy29", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $aWwYt = parcelRequire("aWwYt");


var $cMvMc = parcelRequire("cMvMc");


var $9jl6v = parcelRequire("9jl6v");


var $bSvtO = parcelRequire("bSvtO");


var $brNvA = parcelRequire("brNvA");


var $cZa7r = parcelRequire("cZa7r");


var $4DJgG = parcelRequire("4DJgG");

const $dacb5f0322f4a333$export$5ae138a5a05281f1 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { contentId: contentId, isFabric: isFabric, sendKeyboardShortcutAnalytics: sendKeyboardShortcutAnalytics } = t0;
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { setSelectionOptionsForCreateEditor: setSelectionOptionsForCreateEditor } = (0, $cZa7r.useAnnotationsDispatch)();
    const { createComment: createComment } = (0, $9jl6v.useInlineCommentsDispatchContext)();
    const { commentToReattach: commentToReattach } = (0, $brNvA.useReattachComment)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const content = (0, $cozmU.useRef)(null);
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            content.current = document.querySelector("div#content");
        };
        t2 = [];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[2] !== commentToReattach || $[3] !== contentId || $[4] !== createComment || $[5] !== hideObjectSidebar || $[6] !== isFabric || $[7] !== isObjectSidebarShown || $[8] !== setSelectionOptionsForCreateEditor) {
        t3 = (t4)=>{
            const { experienceAttributes: experienceAttributes } = t4 === undefined ? {} : t4;
            if (isObjectSidebarShown) hideObjectSidebar();
            if (isFabric) setSelectionOptionsForCreateEditor({
                experienceAttributes: experienceAttributes
            });
            else if (content.current) createComment((0, $4DJgG.getLegacyConvertedSelectionObj)({
                content: content,
                contentId: contentId,
                commentToReattach: commentToReattach
            }));
        };
        $[2] = commentToReattach;
        $[3] = contentId;
        $[4] = createComment;
        $[5] = hideObjectSidebar;
        $[6] = isFabric;
        $[7] = isObjectSidebarShown;
        $[8] = setSelectionOptionsForCreateEditor;
        $[9] = t3;
    } else t3 = $[9];
    const createReactInlineCommentHighlight = t3;
    let t4;
    if ($[10] !== createReactInlineCommentHighlight || $[11] !== hasContentChanged || $[12] !== sendKeyboardShortcutAnalytics) {
        const handleCommentButtonClick = (t5)=>{
            const { dialogs: dialogs, shortcut: shortcut, experienceAttributes: experienceAttributes_0 } = t5;
            if (hasContentChanged) dialogs.showModal((0, $cMvMc.CommentWarningDialog), {
                onConfirm: ()=>createReactInlineCommentHighlight({
                        experienceAttributes: experienceAttributes_0
                    })
            });
            else createReactInlineCommentHighlight({
                experienceAttributes: experienceAttributes_0
            });
            if (shortcut) sendKeyboardShortcutAnalytics(shortcut);
        };
        t4 = {
            handleCommentButtonClick: handleCommentButtonClick
        };
        $[10] = createReactInlineCommentHighlight;
        $[11] = hasContentChanged;
        $[12] = sendKeyboardShortcutAnalytics;
        $[13] = t4;
    } else t4 = $[13];
    return t4;
} : ({ contentId: contentId, isFabric: isFabric, sendKeyboardShortcutAnalytics: sendKeyboardShortcutAnalytics })=>{
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { setSelectionOptionsForCreateEditor: setSelectionOptionsForCreateEditor } = (0, $cZa7r.useAnnotationsDispatch)();
    const { createComment: createComment } = (0, $9jl6v.useInlineCommentsDispatchContext)();
    const { commentToReattach: commentToReattach } = (0, $brNvA.useReattachComment)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const content = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        content.current = document.querySelector('div#content');
    }, []);
    const createReactInlineCommentHighlight = ({ experienceAttributes: experienceAttributes } = {})=>{
        if (isObjectSidebarShown) hideObjectSidebar();
        if (isFabric) setSelectionOptionsForCreateEditor({
            experienceAttributes: experienceAttributes
        });
        else if (content.current) createComment((0, $4DJgG.getLegacyConvertedSelectionObj)({
            content: content,
            contentId: contentId,
            commentToReattach: commentToReattach
        }));
    };
    const handleCommentButtonClick = ({ dialogs: dialogs, shortcut: shortcut, experienceAttributes: experienceAttributes_0 })=>{
        if (hasContentChanged) dialogs.showModal((0, $cMvMc.CommentWarningDialog), {
            onConfirm: ()=>createReactInlineCommentHighlight({
                    experienceAttributes: experienceAttributes_0
                })
        });
        else createReactInlineCommentHighlight({
            experienceAttributes: experienceAttributes_0
        });
        if (shortcut) sendKeyboardShortcutAnalytics(shortcut);
    };
    return {
        handleCommentButtonClick: handleCommentButtonClick
    };
};
module.exports["useCreateCommentAction"] = $dacb5f0322f4a333$export$5ae138a5a05281f1;

});

parcelRegister("izhdc", function(module, exports) {

var $8i27m = parcelRequire("8i27m");

const $fd72c77cd5bf52d0$export$8a92cb9a88bcfd3b = (currentlyRenderedThreads, unresolvedInlineComments)=>{
    // Grab everything on the screen as a set for quick access
    const allRenderedInlineCommentIds = new Set(unresolvedInlineComments);
    // Grab all of the refs for inline comments that are available on the panel
    const panelCommentRefs = currentlyRenderedThreads.map((comment)=>{
        if (comment.type === 'INLINE') {
            if ('inlineMarkerRef' in comment && comment.inlineMarkerRef) return {
                ref: comment.inlineMarkerRef,
                type: (0, $8i27m.CommentType).INLINE
            };
            else return {
                ref: '',
                type: (0, $8i27m.CommentType).INLINE
            };
        } else return {
            ref: comment.id,
            type: (0, $8i27m.CommentType).GENERAL
        };
    }).filter((comment)=>{
        return comment.ref !== '';
    });
    // Grab the refs that we can navigate too (aka the ones rendered on the page, so open (i.e. not resolved) comments)
    const navigableInlineCommentRefs = new Set(panelCommentRefs.map((comment)=>{
        if (comment.type === (0, $8i27m.CommentType).INLINE) return allRenderedInlineCommentIds.has(comment.ref) ? comment.ref : '';
        else return comment.ref;
    }));
    return {
        panelCommentRefs: panelCommentRefs,
        navigableInlineCommentRefs: navigableInlineCommentRefs
    };
};
const $fd72c77cd5bf52d0$export$6fbaa3cb5c58ff29 = (action, panelCommentRefs, currentlySelectedThreadKey)=>{
    let nextIndex = panelCommentRefs.findIndex((comment)=>{
        return comment.ref === currentlySelectedThreadKey;
    });
    if (nextIndex === -1) nextIndex = 0;
    else if (action === 'next') nextIndex = (nextIndex + 1) % panelCommentRefs.length;
    else nextIndex = (nextIndex - 1 + panelCommentRefs.length) % panelCommentRefs.length;
    return panelCommentRefs[nextIndex];
};
module.exports["parsePanelAndInlineRefs"] = $fd72c77cd5bf52d0$export$8a92cb9a88bcfd3b;
module.exports["getNextRef"] = $fd72c77cd5bf52d0$export$6fbaa3cb5c58ff29;

});

parcelRegister("gSkOQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $aSsfA = parcelRequire("aSsfA");


var $6lAIr = parcelRequire("6lAIr");


var $i6UMJ = parcelRequire("i6UMJ");


var $8i27m = parcelRequire("8i27m");


var $4L9ve = parcelRequire("4L9ve");

const $89de80864b4e19fe$export$618f651f678380bf = ()=>{
    const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList } = (0, $8i27m.useCommentsDataState)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { commentsDataMap: commentsDataMap } = (0, $4L9ve.useProcessedCommentsDataState)();
    return (0, $cozmU.useMemo)(()=>{
        const footerCommentThreads = (0, $6lAIr.getVisibleCommentThreads)({
            includeGeneralComments: true,
            commentsDataMap: commentsDataMap,
            includeInlineComments: false,
            orderedAnnotationIds: (0, $i6UMJ.getAnnotationThreadKeys)(orderedActiveAnnotationIdList),
            pageMode: pageMode
        });
        const footerCommentIds = footerCommentThreads.map((thread)=>thread.id);
        return {
            footerCommentIds: footerCommentIds,
            footerCommentThreads: footerCommentThreads
        };
    }, [
        commentsDataMap,
        orderedActiveAnnotationIdList,
        pageMode
    ]);
};
module.exports["useFooterComments"] = $89de80864b4e19fe$export$618f651f678380bf;

});

parcelRegister("fIKxq", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");


var $6mKj3 = parcelRequire("6mKj3");


var $8zMP3 = parcelRequire("8zMP3");


var $ihn35 = parcelRequire("ihn35");


// One loadable per arm with an UNCONDITIONAL loader. The arm must be chosen at render
// time (below), never inside a loader: on the server loaders run once at module-init,
// before per-request Statsig is ready, so a gate read there caches the default (control)
// for the whole process and treatment never SSRs.
const $d90c1a5bdc683f34$var$EndOfPageRecommendationControlLoadable = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "11WpM",
    name: "EndOfPageRecommendationControlLoadable",
    loader: async ()=>(await (parcelRequire("fLtVd"))).EndOfPageRecommendation
});

const $d90c1a5bdc683f34$var$EndOfPageRecommendationTwgLoadable = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HEana",
    name: "EndOfPageRecommendationTwgLoadable",
    loader: async ()=>(await (parcelRequire("9W4u4"))).EndOfPageRecommendationTwg
});
const $d90c1a5bdc683f34$export$ea341515a2d0d231 = Object.assign((props)=>(0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_eop_recs_twg_source_exp', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d90c1a5bdc683f34$var$EndOfPageRecommendationTwgLoadable, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d90c1a5bdc683f34$var$EndOfPageRecommendationControlLoadable, props), {
    preload: ()=>{
        $d90c1a5bdc683f34$var$EndOfPageRecommendationControlLoadable.preload();
        $d90c1a5bdc683f34$var$EndOfPageRecommendationTwgLoadable.preload();
    }
});
const $d90c1a5bdc683f34$export$ab3a258d2d028df5 = (props)=>{
    const $ = (0, $bDgLe.c)(4);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [];
        $[0] = t0;
    } else t0 = $[0];
    (0, $cozmU.useEffect)($d90c1a5bdc683f34$var$_temp, t0);
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihn35.EndOfPageRecPlaceholderContainer), null);
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== props) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
            dataFetcherName: "end-of-page-recommendations",
            fallback: t1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d90c1a5bdc683f34$export$ea341515a2d0d231, props));
        $[2] = props;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
};
function $d90c1a5bdc683f34$var$_temp() {
    (0, $6mKj3.manuallyLogExpExposure)("confluence_eop_recs_twg_source_exp");
}
module.exports["EndOfPageRecommendationLoader"] = $d90c1a5bdc683f34$export$ea341515a2d0d231;
module.exports["EndOfPageRecommendationFinalLoader"] = $d90c1a5bdc683f34$export$ab3a258d2d028df5;

});

parcelRegister("ihn35", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $e8a7d12ee4dfec6a$export$f0a7c5a0719c820d = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_313842IZbP _0adFHsIZbP _1DCdHiIZbP _2XsHFMIZbP _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuDIqT _0Of8r2p0Oa _1wydGWkG2W _1EqgXl8yGE _39xV02N91d _0jFU0Vv6H3",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$efb20161e583b9b8 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2sNsIgEqul _3iDTPbQ4SZ _37wbyuI7V3 _0hPCNLDIqT _1wydGW2ADO",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$80837d77c7223a53 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2mHwu81Y8M _3iDTPbQ4SZ _0hPCNLDIqT _1Znuxb2ADO",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$7b34b3c5c4f8605a = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _3iDTPbQ4SZ _0KLXruDMqu _0jFU0VHZdu _39xV02dnbC",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$48423cf6a25b5248 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2mHwu88HPE _2sNsIgmnOE _4FKVYEADSh _3iDTPbQ4SZ _0aFT5vbt8w _1EqgXlPyJ7",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$77a9080c0e27b9d1 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$49166591ec160d97 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _2Zuz6Q2ADO",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$ee3e739bedcb3f4c = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_0aFT5v1qpb _3TGfC9HnLE _2mHwu85zaO _3iDTPbQ4SZ _0jFU0VT0NC _37wbyuI7V3",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$227f3f793075b973 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isNav4Enabled: isNav4Enabled, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2mHwu8NHnM _2sNsIgmnOE _3iDTPbQ4SZ _0aFT5vbt8w _1ZnuxbGXk2 _1EqgXlB9Ek",
            !__cmplp.isNav4Enabled && "_2Zuz6QkG2W",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$545440ab15c19255 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2mHwu85zaO _3iDTPbQ4SZ _0aFT5vbt8w",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$bb7ed78cda4c11ab = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2mHwu88HPE _2sNsIgd8bj _1UtDYzZpcK _3iDTPbQ4SZ _0hPCNLDIqT _2Zuz6QNHnM",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$a436177ded449686 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2mHwu85zaO _3iDTPbQ4SZ _0hPCNLDIqT _2Zuz6Q8HPE",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$faaa5da096482ae9 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2sNsIgd8bj _1UtDYzZpcK",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$a1abff0c22b50819 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2XsHFM1Y8M",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$23b4998b204f6604 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "p" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2sNsIgd8bj _1UtDYzZpcK _1wydGW2ADO",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
module.exports["EndOfPageRecPlaceholderContainer"] = $e8a7d12ee4dfec6a$export$f0a7c5a0719c820d;
module.exports["InfoContainer"] = $e8a7d12ee4dfec6a$export$48423cf6a25b5248;
module.exports["FeedbackContainer"] = $e8a7d12ee4dfec6a$export$77a9080c0e27b9d1;
module.exports["EndOfPageRecAdminConfigContainer"] = $e8a7d12ee4dfec6a$export$227f3f793075b973;
module.exports["EndOfPageRecHideControlContainer"] = $e8a7d12ee4dfec6a$export$545440ab15c19255;
module.exports["EndOfPageRecHideToggleContainer"] = $e8a7d12ee4dfec6a$export$bb7ed78cda4c11ab;
module.exports["SpaceFeedbackButtonWrapper"] = $e8a7d12ee4dfec6a$export$a1abff0c22b50819;

});

parcelRegister("fLtVd", function(module, exports) {

let $b7a274a56aa86e3f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b7a274a56aa86e3f$var$load("he7Ox"),
    $b7a274a56aa86e3f$var$load("8lMr1"),
    $b7a274a56aa86e3f$var$load("1vUE6"),
    $b7a274a56aa86e3f$var$load("7g00Y"),
    $b7a274a56aa86e3f$var$load("7A87G"),
    $b7a274a56aa86e3f$var$load("i1AvA"),
    $b7a274a56aa86e3f$var$load("keazL"),
    $b7a274a56aa86e3f$var$load("dhXIT"),
    $b7a274a56aa86e3f$var$load("6wr18"),
    $b7a274a56aa86e3f$var$load("7gL7H"),
    $b7a274a56aa86e3f$var$load("ea3NB"),
    $b7a274a56aa86e3f$var$load("5tJYH"),
    $b7a274a56aa86e3f$var$load("huBNP"),
    $b7a274a56aa86e3f$var$load("amIJr"),
    $b7a274a56aa86e3f$var$load("4ZzjZ"),
    $b7a274a56aa86e3f$var$load("3cJjP"),
    $b7a274a56aa86e3f$var$load("11yNG"),
    $b7a274a56aa86e3f$var$load("gQYVn"),
    $b7a274a56aa86e3f$var$load("9RGBF"),
    $b7a274a56aa86e3f$var$load("2iL13"),
    $b7a274a56aa86e3f$var$load("cpTbC"),
    $b7a274a56aa86e3f$var$load("fhT77"),
    $b7a274a56aa86e3f$var$load("jvUhP"),
    $b7a274a56aa86e3f$var$load("7sOKp"),
    $b7a274a56aa86e3f$var$load("7Ysw6"),
    $b7a274a56aa86e3f$var$load("3xL2F"),
    $b7a274a56aa86e3f$var$load("kMyku"),
    $b7a274a56aa86e3f$var$load("hG1ar"),
    $b7a274a56aa86e3f$var$load("2GC7K"),
    $b7a274a56aa86e3f$var$load("cklhl"),
    $b7a274a56aa86e3f$var$load("bLIUJ"),
    $b7a274a56aa86e3f$var$load("kobFT"),
    $b7a274a56aa86e3f$var$load("701fE"),
    $b7a274a56aa86e3f$var$load("8qNIV"),
    $b7a274a56aa86e3f$var$load("gpIIT"),
    $b7a274a56aa86e3f$var$load("cHAvQ"),
    $b7a274a56aa86e3f$var$load("5d2zd"),
    $b7a274a56aa86e3f$var$load("frCen"),
    $b7a274a56aa86e3f$var$load("hZzel"),
    $b7a274a56aa86e3f$var$load("hUZCM"),
    $b7a274a56aa86e3f$var$load("7zQG2"),
    $b7a274a56aa86e3f$var$load("1HPRy"),
    $b7a274a56aa86e3f$var$load("3eAWG"),
    $b7a274a56aa86e3f$var$load("ffEVr"),
    $b7a274a56aa86e3f$var$load("9BBvG"),
    $b7a274a56aa86e3f$var$load("h0X0x"),
    $b7a274a56aa86e3f$var$load("7l4Nc"),
    $b7a274a56aa86e3f$var$load("cYv6T"),
    $b7a274a56aa86e3f$var$load("Wowvf"),
    $b7a274a56aa86e3f$var$load("4g6rd"),
    $b7a274a56aa86e3f$var$load("hhss7"),
    $b7a274a56aa86e3f$var$load("7EorR"),
    $b7a274a56aa86e3f$var$load("iV6RN")
]).then(()=>parcelRequire('kPKkS'));

});

parcelRegister("9W4u4", function(module, exports) {

let $73bd0245669fb843$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $73bd0245669fb843$var$load("he7Ox"),
    $73bd0245669fb843$var$load("8lMr1"),
    $73bd0245669fb843$var$load("1vUE6"),
    $73bd0245669fb843$var$load("7g00Y"),
    $73bd0245669fb843$var$load("7A87G"),
    $73bd0245669fb843$var$load("i1AvA"),
    $73bd0245669fb843$var$load("keazL"),
    $73bd0245669fb843$var$load("dhXIT"),
    $73bd0245669fb843$var$load("6wr18"),
    $73bd0245669fb843$var$load("7gL7H"),
    $73bd0245669fb843$var$load("ea3NB"),
    $73bd0245669fb843$var$load("5tJYH"),
    $73bd0245669fb843$var$load("huBNP"),
    $73bd0245669fb843$var$load("amIJr"),
    $73bd0245669fb843$var$load("4ZzjZ"),
    $73bd0245669fb843$var$load("3cJjP"),
    $73bd0245669fb843$var$load("11yNG"),
    $73bd0245669fb843$var$load("gQYVn"),
    $73bd0245669fb843$var$load("9RGBF"),
    $73bd0245669fb843$var$load("2iL13"),
    $73bd0245669fb843$var$load("cpTbC"),
    $73bd0245669fb843$var$load("fhT77"),
    $73bd0245669fb843$var$load("jvUhP"),
    $73bd0245669fb843$var$load("7sOKp"),
    $73bd0245669fb843$var$load("7Ysw6"),
    $73bd0245669fb843$var$load("3xL2F"),
    $73bd0245669fb843$var$load("kMyku"),
    $73bd0245669fb843$var$load("hG1ar"),
    $73bd0245669fb843$var$load("2GC7K"),
    $73bd0245669fb843$var$load("cklhl"),
    $73bd0245669fb843$var$load("bLIUJ"),
    $73bd0245669fb843$var$load("kobFT"),
    $73bd0245669fb843$var$load("701fE"),
    $73bd0245669fb843$var$load("8qNIV"),
    $73bd0245669fb843$var$load("gpIIT"),
    $73bd0245669fb843$var$load("cHAvQ"),
    $73bd0245669fb843$var$load("5d2zd"),
    $73bd0245669fb843$var$load("frCen"),
    $73bd0245669fb843$var$load("hZzel"),
    $73bd0245669fb843$var$load("hUZCM"),
    $73bd0245669fb843$var$load("7zQG2"),
    $73bd0245669fb843$var$load("1HPRy"),
    $73bd0245669fb843$var$load("3eAWG"),
    $73bd0245669fb843$var$load("ffEVr"),
    $73bd0245669fb843$var$load("9BBvG"),
    $73bd0245669fb843$var$load("h0X0x"),
    $73bd0245669fb843$var$load("7l4Nc"),
    $73bd0245669fb843$var$load("cYv6T"),
    $73bd0245669fb843$var$load("Wowvf"),
    $73bd0245669fb843$var$load("4g6rd"),
    $73bd0245669fb843$var$load("hhss7"),
    $73bd0245669fb843$var$load("7EorR"),
    $73bd0245669fb843$var$load("3KskI")
]).then(()=>parcelRequire('5mYJd'));

});

parcelRegister("JTIzG", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");

var $27a67c702eae1a5a$export$419c8aa8913e9327 = /*#__PURE__*/ function(BriefingNudgeExperimentState) {
    BriefingNudgeExperimentState["CONTROL"] = "control";
    BriefingNudgeExperimentState["NUDGE"] = "nudge";
    BriefingNudgeExperimentState["NUDGE_AUTOPLAY"] = "nudge_autoplay";
    return BriefingNudgeExperimentState;
}({});
const $27a67c702eae1a5a$export$df5bf03825b93c3d = ()=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isAIEarlyAccessEnabled: isAIEarlyAccessEnabled, isAtlassianHostedLLMOnlyEnabled: isAtlassianHostedLLMOnlyEnabled } = (0, $bQm3c.useSessionData)();
    // Deferred: MediaSource is unavailable during SSR
    const [audioSupportedByBrowser, setAudioSupportedByBrowser] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        setAudioSupportedByBrowser(typeof MediaSource !== 'undefined' && MediaSource.isTypeSupported('audio/mpeg'));
    }, []);
    const { isAIPolicyEnabled: isAIPolicyEnabled, isAudioV3EnabledForPolicy: isAudioV3EnabledForPolicy, isAudioBylineEntrypointEnabled: isAudioBylineEntrypointEnabled } = (0, $cozmU.useMemo)(()=>{
        const aiPolicyEnabled = !isAtlassianHostedLLMOnlyEnabled && isAdminHubAIEnabled && isAIEarlyAccessEnabled;
        const audioV3EnabledForPolicy = aiPolicyEnabled && (0, $6mKj3.isExperimentEnabled)('confluence_audio_v3');
        return {
            isAIPolicyEnabled: aiPolicyEnabled,
            isAudioV3EnabledForPolicy: audioV3EnabledForPolicy,
            // Keep byline visibility stable through SSR and hydration. ListenByline checks browser
            // support after hydration and disables its trigger when audio playback is unsupported.
            isAudioBylineEntrypointEnabled: audioV3EnabledForPolicy
        };
    }, [
        isAdminHubAIEnabled,
        isAIEarlyAccessEnabled,
        isAtlassianHostedLLMOnlyEnabled
    ]);
    const isAudioV3Enabled = isAudioV3EnabledForPolicy && audioSupportedByBrowser;
    const audioBriefingNudgeExperimentState = (0, $cozmU.useMemo)(()=>{
        if (!isAudioV3Enabled) return "control";
        if ((0, $6mKj3.expValEquals)('confluence_audio_v3_briefing_nudge', 'variant', 'nudge')) return "nudge";
        else if ((0, $6mKj3.expValEquals)('confluence_audio_v3_briefing_nudge', 'variant', 'nudge_autoplay')) return "nudge_autoplay";
        else return "control";
    }, [
        isAudioV3Enabled
    ]);
    return {
        isAIPolicyAndBrowserSupportEnabled: isAIPolicyEnabled && audioSupportedByBrowser,
        isAudioV3Enabled: isAudioV3Enabled,
        isAudioBylineEntrypointEnabled: isAudioBylineEntrypointEnabled,
        audioBriefingNudgeExperimentState: audioBriefingNudgeExperimentState
    };
};
module.exports["BriefingNudgeExperimentState"] = $27a67c702eae1a5a$export$419c8aa8913e9327;
module.exports["useAudioFeatureFlags"] = $27a67c702eae1a5a$export$df5bf03825b93c3d;

});

parcelRegister("bnSPF", function(module, exports) {
const $76e54e1c758c6257$var$CARD_NODE_TYPES = new Set([
    'inlineCard',
    'blockCard',
    'embedCard'
]);
function $76e54e1c758c6257$export$17ea34445ac2b9ee(doc, includeLinkMarks = false) {
    if (!doc) return [];
    const countByUrl = new Map();
    const addUrl = (url)=>{
        if (typeof url === 'string' && url) countByUrl.set(url, (countByUrl.get(url) ?? 0) + 1);
    };
    function walk(node) {
        if ($76e54e1c758c6257$var$CARD_NODE_TYPES.has(node.type)) addUrl(node.attrs?.url);
        if (includeLinkMarks) addUrl(node.marks?.find((mark)=>mark?.type === 'link')?.attrs?.href);
        if (Array.isArray(node.content)) node.content.forEach(walk);
    }
    walk(doc);
    return Array.from(countByUrl, ([url, count], occurrenceIndex)=>({
            url: url,
            occurrenceIndex: occurrenceIndex,
            count: count
        }));
}
module.exports["extractSmartLinksFromAdf"] = $76e54e1c758c6257$export$17ea34445ac2b9ee;

});

parcelRegister("5J49L", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kDhla = parcelRequire("kDhla");


var $8WQTF = parcelRequire("8WQTF");

const $6b155e8150ddb3e3$var$EMPTY_PAGE_ADF = {
    adf: null,
    contentId: undefined
};
function $6b155e8150ddb3e3$export$bac928e80dac4527(contentId) {
    const { pageAdf: rendererPageAdf, pageId: rendererContentId } = (0, $8WQTF.useRendererActions)();
    const { fullPageEditorPresetAPI: fullPageEditorPresetAPI } = (0, $kDhla.useFullPageEditorApiState)();
    const [editorPageAdf, setEditorPageAdf] = (0, $cozmU.useState)($6b155e8150ddb3e3$var$EMPTY_PAGE_ADF);
    const hasCurrentRendererAdf = Boolean(rendererPageAdf && rendererContentId && (!contentId || rendererContentId === contentId));
    (0, $cozmU.useEffect)(()=>{
        if (hasCurrentRendererAdf || !fullPageEditorPresetAPI || !contentId) return;
        let active = true;
        fullPageEditorPresetAPI.core.actions.requestDocument((doc)=>{
            if (active && doc) setEditorPageAdf({
                adf: doc,
                contentId: contentId
            });
        }, {
            alwaysFire: true
        });
        return ()=>{
            active = false;
        };
    }, [
        contentId,
        fullPageEditorPresetAPI,
        hasCurrentRendererAdf
    ]);
    if (hasCurrentRendererAdf && rendererPageAdf && rendererContentId) return {
        adf: rendererPageAdf,
        contentId: rendererContentId
    };
    return !contentId || editorPageAdf.contentId === contentId ? editorPageAdf : $6b155e8150ddb3e3$var$EMPTY_PAGE_ADF;
}
module.exports["usePageAdf"] = $6b155e8150ddb3e3$export$bac928e80dac4527;

});

parcelRegister("lOxqc", function(module, exports) {

var $cxMI6 = parcelRequire("cxMI6");

const $550abe5a694aeafb$export$45bb2daf3af483ad = 'TWG';
const $550abe5a694aeafb$var$contentIdOf = (node)=>node.pageId ?? node.blogPostId ?? undefined;
const $550abe5a694aeafb$var$AUTHORITY_SCORE_RANK = {
    VERY_HIGH: 3,
    HIGH: 2,
    MEDIUM: 1,
    LOW: 0
};
const $550abe5a694aeafb$var$DEFAULT_AUTHORITY_SCORE = 'LOW';
// RETURN column names from `buildTwgRecsCypher`.
const $550abe5a694aeafb$var$ENTITY_COLUMN_KEY = 'entity';
const $550abe5a694aeafb$var$AUTHORITY_COLUMN_KEY = 'auth';
// Score is the last segment of the auth node's ARI (`.../authority-score/MEDIUM`);
// missing/unrecognised falls back to LOW so ranking is always defined.
const $550abe5a694aeafb$var$parseAuthorityScore = (authAri)=>{
    const score = authAri?.split('/').pop()?.toUpperCase();
    return score && score in $550abe5a694aeafb$var$AUTHORITY_SCORE_RANK ? score : $550abe5a694aeafb$var$DEFAULT_AUTHORITY_SCORE;
};
// Content statuses that cc-smarts would never recommend. We filter these out of the
// TWG results so treatment doesn't surface drafts/archived/trashed/etc. that control
// can't (the graph traversal isn't status-filtered, unlike the cc-smarts backend).
const $550abe5a694aeafb$var$NON_CURRENT_STATUSES = new Set([
    'archived',
    'deleted',
    'draft',
    'historical',
    'trashed'
]);
// Keep CURRENT and unknown/absent status (ConfluenceBlogPost.status is nullable and may
// not hydrate), dropping only definitively non-current content. Lenient on purpose so a
// blog whose status doesn't resolve isn't silently dropped.
const $550abe5a694aeafb$var$isCurrentContent = (node)=>{
    const status = node.pageStatus ?? node.blogPostStatus;
    return !status || !$550abe5a694aeafb$var$NON_CURRENT_STATUSES.has(String(status).toLowerCase());
};
const $550abe5a694aeafb$export$7440bc9de8627a49 = (data)=>{
    const seen = new Set();
    const nodes = [];
    // Each edge is one row; iterate per-row so the `entity` and `auth` columns stay paired.
    const edges = data?.graphStore_cypherQueryV2?.edges ?? [];
    for (const edge of edges){
        let node;
        let authorityScore = $550abe5a694aeafb$var$DEFAULT_AUTHORITY_SCORE;
        // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity -- bounded by RETURN column count
        for (const column of edge?.node?.columns ?? []){
            if (column?.key === $550abe5a694aeafb$var$AUTHORITY_COLUMN_KEY) authorityScore = $550abe5a694aeafb$var$parseAuthorityScore(column?.value?.id);
            else if (column?.key === $550abe5a694aeafb$var$ENTITY_COLUMN_KEY) // Relay's multi-fragment union type doesn't allow direct field access.
            node = column?.value?.data;
        }
        const contentId = node ? $550abe5a694aeafb$var$contentIdOf(node) : undefined;
        if (node && contentId && $550abe5a694aeafb$var$isCurrentContent(node) && !seen.has(contentId)) {
            seen.add(contentId);
            nodes.push({
                ...node,
                authorityScore: authorityScore
            });
        }
    }
    // Stable sort (ES2019+): equal-score nodes keep their traversal order.
    return [
        ...nodes
    ].sort((a, b)=>$550abe5a694aeafb$var$AUTHORITY_SCORE_RANK[b.authorityScore] - $550abe5a694aeafb$var$AUTHORITY_SCORE_RANK[a.authorityScore]);
};
// Map an AGG content node onto the `content` shape transformGlobalContent expects.
// Renames: webUi->webui, subtype->subType, owner.user.name->displayName,
// owner.user.accountId->creatorId, properties->emoji.nodes. `type` is derived from
// which id is present (the AGG enum is `PAGE`/`BLOG_POST`, which wouldn't match the
// card's lower-case, no-underscore content types and would render the wrong icon).
const $550abe5a694aeafb$var$toGlobalContentShape = (node)=>{
    const status = node.pageStatus ?? node.blogPostStatus;
    return {
        id: $550abe5a694aeafb$var$contentIdOf(node) ?? '',
        title: node.title ?? '',
        type: node.blogPostId ? 'blogpost' : 'page',
        subType: node.subtype ?? undefined,
        status: status ? String(status).toLowerCase() : undefined,
        links: {
            webui: node.links?.webUi ?? ''
        },
        space: {
            id: node.space?.id ?? '',
            key: node.space?.key ?? '',
            alias: node.space?.alias ?? '',
            name: node.space?.name ?? ''
        },
        creatorId: node.owner?.user?.accountId ?? '',
        history: {
            ownedBy: {
                displayName: node.owner?.user?.name ?? ''
            }
        },
        emoji: {
            nodes: node.properties ?? []
        }
    };
};
const $550abe5a694aeafb$export$a7ad6e153f92c731 = (data)=>{
    return $550abe5a694aeafb$export$7440bc9de8627a49(data).map((node)=>{
        const card = (0, $cxMI6.transformGlobalContent)($550abe5a694aeafb$var$toGlobalContentShape(node));
        // Parity with the cc-smarts transformer: zero these + stamp a strategy.
        card.likesCount = 0;
        card.commentsCount = 0;
        card.recommendationStrategy = $550abe5a694aeafb$export$45bb2daf3af483ad;
        return card;
    });
};
module.exports["TWG_STRATEGY"] = $550abe5a694aeafb$export$45bb2daf3af483ad;
module.exports["transformTwgRecs"] = $550abe5a694aeafb$export$a7ad6e153f92c731;

});

parcelRegister("jc6xl", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $2rapj = parcelRequire("2rapj");


var $lOxqc = parcelRequire("lOxqc");


var $ky8L5 = parcelRequire("ky8L5");

const $362c0e733b0222dd$export$7018f964cac4cdb1 = (t0)=>{
    const $ = (0, $bDgLe.c)(29);
    const { entityId: entityId, entityType: entityType, spaceKey: spaceKey, skip: t1 } = t0;
    const skip = t1 === undefined ? false : t1;
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    let t2;
    if ($[0] !== cloudId || $[1] !== entityId || $[2] !== entityType || $[3] !== skip) {
        t2 = skip || !(0, $ky8L5.isTwgSupportedContentType)(entityType) || !cloudId || !entityId;
        $[0] = cloudId;
        $[1] = entityId;
        $[2] = entityType;
        $[3] = skip;
        $[4] = t2;
    } else t2 = $[4];
    const shouldSkip = t2;
    let t3;
    if ($[5] !== cloudId || $[6] !== entityId || $[7] !== entityType || $[8] !== shouldSkip) {
        t3 = shouldSkip ? "" : (0, $ky8L5.buildTwgRecsCypher)((0, $ky8L5.buildTwgContentAri)(cloudId, entityId, entityType));
        $[5] = cloudId;
        $[6] = entityId;
        $[7] = entityType;
        $[8] = shouldSkip;
        $[9] = t3;
    } else t3 = $[9];
    const cypherQuery = t3;
    let t4;
    if ($[10] !== cypherQuery || $[11] !== spaceKey) {
        t4 = {
            cypherQuery: cypherQuery,
            first: (0, $ky8L5.MAX_TWG_RECS),
            key: spaceKey,
            keyString: spaceKey
        };
        $[10] = cypherQuery;
        $[11] = spaceKey;
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] !== cloudId || $[14] !== shouldSkip) {
        t5 = shouldSkip ? undefined : {
            headers: {
                "X-Query-Context": (0, $ky8L5.buildTwgQueryContext)(cloudId)
            }
        };
        $[13] = cloudId;
        $[14] = shouldSkip;
        $[15] = t5;
    } else t5 = $[15];
    let t6;
    if ($[16] !== shouldSkip || $[17] !== t4 || $[18] !== t5) {
        t6 = {
            variables: t4,
            interopApolloAggClient: true,
            context: t5,
            errorPolicy: "all",
            fetchPolicy: "cache-first",
            skip: shouldSkip
        };
        $[16] = shouldSkip;
        $[17] = t4;
        $[18] = t5;
        $[19] = t6;
    } else t6 = $[19];
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)((0, $2rapj.default), {
        ...t6,
        __callerPackage__: "page-recommendations"
    });
    let t7;
    if ($[20] !== data) {
        t7 = (0, $lOxqc.transformTwgRecs)(data);
        $[20] = data;
        $[21] = t7;
    } else t7 = $[21];
    const pageCardData = t7;
    const isEnabled = Boolean(data?.getRecommendedPagesSpaceStatus?.recommendedPagesEnabled && data?.getRecommendedPagesSpaceStatus?.defaultBehavior === "SHOWN");
    const t8 = data?.space?.id ?? undefined;
    let t9;
    if ($[22] !== error || $[23] !== isEnabled || $[24] !== loading || $[25] !== pageCardData || $[26] !== shouldSkip || $[27] !== t8) {
        t9 = {
            pageCardData: pageCardData,
            spaceId: t8,
            isEnabled: isEnabled,
            loading: loading,
            error: error,
            skip: shouldSkip
        };
        $[22] = error;
        $[23] = isEnabled;
        $[24] = loading;
        $[25] = pageCardData;
        $[26] = shouldSkip;
        $[27] = t8;
        $[28] = t9;
    } else t9 = $[28];
    return t9;
};
module.exports["useTwgRecommendationData"] = $362c0e733b0222dd$export$7018f964cac4cdb1;

});

parcelRegister("4r9Ir", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7IghX = parcelRequire("7IghX");

const $4ae3b5b25efc2fdf$export$c465d99c658013a3 = /*#__PURE__*/ (0, $cozmU.createContext)({
    newCommentPositions: [],
    addNewComment: ()=>{},
    removeComment: ()=>{},
    acknowledgeComment: ()=>{},
    acknowledgeComments: ()=>{},
    clearNewComments: ()=>{}
});
const $4ae3b5b25efc2fdf$var$getCommentScreenPosition = (commentId)=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const commentElem = document.querySelector(`#comment-${commentId}`);
    if (commentElem) return {
        top: commentElem.offsetTop,
        bottom: commentElem.offsetTop + commentElem.offsetHeight
    };
    return {
        top: Number.NEGATIVE_INFINITY,
        bottom: Number.POSITIVE_INFINITY
    };
};
const $4ae3b5b25efc2fdf$export$18a14437c7fa7b9f = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [newCommentPositions, setNewCommentPositions] = (0, $cozmU.useState)(t1);
    const { count: count, setCount: setCount } = (0, $cozmU.useContext)((0, $7IghX.PageCommentsCountContext));
    let t2;
    if ($[1] !== count || $[2] !== setCount) {
        t2 = (t3)=>{
            const { currentUserMadeComment: currentUserMadeComment, newCommentId: newCommentId } = t3;
            if (newCommentId) {
                const pos = $4ae3b5b25efc2fdf$var$getCommentScreenPosition(newCommentId);
                setNewCommentPositions((existingPositions)=>{
                    const commentExists = existingPositions.some((e)=>e.id === newCommentId);
                    return !commentExists ? [
                        ...existingPositions,
                        {
                            id: newCommentId,
                            pos: pos,
                            seen: false,
                            currentUserMadeComment: currentUserMadeComment
                        }
                    ] : existingPositions;
                });
                setCount(count + 1);
            }
        };
        $[1] = count;
        $[2] = setCount;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== count || $[5] !== newCommentPositions || $[6] !== setCount) {
        t3 = (commentId)=>{
            if (commentId) {
                const idx = newCommentPositions.findIndex((comment)=>commentId === comment.id);
                if (idx !== -1) {
                    const positionCopy = [
                        ...newCommentPositions
                    ];
                    positionCopy.splice(idx, 1);
                    setNewCommentPositions(positionCopy);
                }
                const newCount = count - 1;
                setCount(newCount < 0 ? 0 : newCount);
            }
        };
        $[4] = count;
        $[5] = newCommentPositions;
        $[6] = setCount;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    let t5;
    if ($[8] !== newCommentPositions) {
        t4 = (commentId_0)=>{
            if (commentId_0) {
                const comment_0 = newCommentPositions.find((commentPosition)=>commentPosition.id === commentId_0);
                if (comment_0) comment_0.seen = true;
            }
        };
        t5 = (commentIds)=>{
            if (commentIds && commentIds.length) commentIds.forEach((commentId_1)=>{
                const comment_1 = newCommentPositions.find((commentPosition_0)=>commentPosition_0.id === commentId_1);
                if (comment_1) comment_1.seen = true;
            });
        };
        $[8] = newCommentPositions;
        $[9] = t4;
        $[10] = t5;
    } else {
        t4 = $[9];
        t5 = $[10];
    }
    let t6;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>{
            setNewCommentPositions([]);
        };
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== newCommentPositions || $[13] !== t2 || $[14] !== t3 || $[15] !== t4 || $[16] !== t5) {
        t7 = {
            newCommentPositions: newCommentPositions,
            addNewComment: t2,
            removeComment: t3,
            acknowledgeComment: t4,
            acknowledgeComments: t5,
            clearNewComments: t6
        };
        $[12] = newCommentPositions;
        $[13] = t2;
        $[14] = t3;
        $[15] = t4;
        $[16] = t5;
        $[17] = t7;
    } else t7 = $[17];
    const newCommentsContextValue = t7;
    let t8;
    if ($[18] !== children || $[19] !== newCommentsContextValue) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4ae3b5b25efc2fdf$export$c465d99c658013a3.Provider, {
            value: newCommentsContextValue
        }, children);
        $[18] = children;
        $[19] = newCommentsContextValue;
        $[20] = t8;
    } else t8 = $[20];
    return t8;
} : ({ children: children })=>{
    const [newCommentPositions, setNewCommentPositions] = (0, $cozmU.useState)([]);
    const { count: count, setCount: setCount } = (0, $cozmU.useContext)((0, $7IghX.PageCommentsCountContext));
    const newCommentsContextValue = (0, $cozmU.useMemo)(()=>({
            newCommentPositions: newCommentPositions,
            addNewComment: ({ currentUserMadeComment: currentUserMadeComment, newCommentId: newCommentId })=>{
                if (newCommentId) {
                    const pos = $4ae3b5b25efc2fdf$var$getCommentScreenPosition(newCommentId);
                    setNewCommentPositions((existingPositions)=>{
                        const commentExists = existingPositions.some((e)=>e.id === newCommentId);
                        return !commentExists ? [
                            ...existingPositions,
                            {
                                id: newCommentId,
                                pos: pos,
                                seen: false,
                                currentUserMadeComment: currentUserMadeComment
                            }
                        ] : existingPositions;
                    });
                    // Update the comment count
                    setCount(count + 1);
                }
            },
            removeComment: (commentId)=>{
                if (commentId) {
                    const idx = newCommentPositions.findIndex((comment)=>commentId === comment.id);
                    if (idx !== -1) {
                        const positionCopy = [
                            ...newCommentPositions
                        ];
                        positionCopy.splice(idx, 1);
                        setNewCommentPositions(positionCopy);
                    }
                    // Update the comment count
                    const newCount = count - 1;
                    setCount(newCount < 0 ? 0 : newCount);
                }
            },
            acknowledgeComment: (commentId_0)=>{
                if (commentId_0) {
                    const comment_0 = newCommentPositions.find((commentPosition)=>commentPosition.id === commentId_0);
                    if (comment_0) comment_0.seen = true;
                }
            },
            acknowledgeComments: (commentIds)=>{
                if (commentIds && commentIds.length) commentIds.forEach((commentId_1)=>{
                    const comment_1 = newCommentPositions.find((commentPosition_0)=>commentPosition_0.id === commentId_1);
                    if (comment_1) comment_1.seen = true;
                });
            },
            clearNewComments: ()=>{
                setNewCommentPositions([]);
            }
        }), [
        count,
        newCommentPositions,
        setCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4ae3b5b25efc2fdf$export$c465d99c658013a3.Provider, {
        value: newCommentsContextValue
    }, children);
};
module.exports["NewCommentsContext"] = $4ae3b5b25efc2fdf$export$c465d99c658013a3;
module.exports["NewCommentsProvider"] = $4ae3b5b25efc2fdf$export$18a14437c7fa7b9f;

});

parcelRegister("7IghX", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $230ca5ca2ceedabc$export$560530991a10c1f8 = /*#__PURE__*/ (0, $cozmU.createContext)({
    count: 0,
    setCount: ()=>{}
});
const $230ca5ca2ceedabc$export$d3be1c3b23ba5810 = ({ children: children, contentId: contentId })=>{
    const [count, setCount] = (0, $cozmU.useState)(0);
    const pageCommentsCountContextValue = (0, $cozmU.useMemo)(()=>({
            count: count,
            setCount: setCount
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        count,
        contentId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($230ca5ca2ceedabc$export$560530991a10c1f8.Provider, {
        value: pageCommentsCountContextValue
    }, children);
};
module.exports["PageCommentsCountContext"] = $230ca5ca2ceedabc$export$560530991a10c1f8;
module.exports["PageCommentsCountProvider"] = $230ca5ca2ceedabc$export$d3be1c3b23ba5810;

});

parcelRegister("804Ue", function(module, exports) {

var $lFugL = parcelRequire("lFugL");


var $cozmU = parcelRequire("cozmU");


var $c0rhi = parcelRequire("c0rhi");


var $9wGTI = parcelRequire("9wGTI");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $flE5X = parcelRequire("flE5X");


var $cAdj8 = parcelRequire("cAdj8");


var $cD1qu = parcelRequire("cD1qu");


var $aSsfA = parcelRequire("aSsfA");


var $a8ZQ3 = parcelRequire("a8ZQ3");


var $6mKj3 = parcelRequire("6mKj3");

var $11771bad87ca0882$export$c51d39001809fe3e = /*#__PURE__*/ function(PubSubState) {
    PubSubState[PubSubState["ACTIVE"] = 0] = "ACTIVE";
    PubSubState[PubSubState["TERMINATED"] = 1] = "TERMINATED";
    return PubSubState;
}({});
var $11771bad87ca0882$export$77deeade63afd3a6 = /*#__PURE__*/ function(CommentEventType) {
    CommentEventType[CommentEventType["ALL"] = 0] = "ALL";
    CommentEventType[CommentEventType["FOOTER"] = 1] = "FOOTER";
    CommentEventType[CommentEventType["INLINE"] = 2] = "INLINE";
    return CommentEventType;
}({});
const $11771bad87ca0882$export$5a33be95ac52bdad = 2000;
const $11771bad87ca0882$export$f09c511f29ef2d = 3000;
const $11771bad87ca0882$export$45c0a7c4ba2fbb03 = ({ contentId: contentId, eventType: eventType, subscribeToPubSubEvents: subscribeToPubSubEvents, unsubscribeFromPubSubEvents: unsubscribeFromPubSubEvents, onEventFetchSuccess: onEventFetchSuccess, onFetchContentVersionEvent: onFetchContentVersionEvent, onDocumentReturn: onDocumentReturn, lastPollTime: lastPollTime, inactiveInterval: inactiveInterval = $11771bad87ca0882$export$5a33be95ac52bdad, returnInterval: returnInterval = $11771bad87ca0882$export$f09c511f29ef2d, isAutoReloadPageComments: isAutoReloadPageComments = false })=>{
    const { documentNeedsUpdate: documentNeedsUpdate, publishedDocumentVersion: publishedDocumentVersion, currentDocumentVersion: currentDocumentVersion } = (0, $a8ZQ3.useDocumentUpdateStatus)();
    const { setDocumentNeedsUpdate: setDocumentNeedsUpdate, setPublishedDocumentVersion: setPublishedDocumentVersion } = (0, $a8ZQ3.useDocumentUpdateStatusDispatch)();
    const lastEventCheckTimeRef = (0, $cozmU.useRef)(lastPollTime || Date.now());
    const subscriptionShutdownTimer = (0, $cozmU.useRef)(null);
    const missedEventQueryTimeout = (0, $cozmU.useRef)(null);
    // Check if document is undefined to handle SSR playwright tests
    const [documentVisible, setDocumentVisible] = (0, $cozmU.useState)(typeof document !== 'undefined' ? !document.hidden : true);
    const [pubSubState, setPubSubState] = (0, $cozmU.useState)(0);
    const { pageInfo: pageInfo, refetch: refetch } = (0, $cAdj8.usePageInfo)({
        fetchPolicy: 'cache-first',
        // this is required for page navigation using the page tree
        onCompleted: (data)=>{
            if (!(0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated_v2', 'isEnabled', true)) {
                const number = data?.content?.nodes?.[0]?.version?.number;
                if (number) setPublishedDocumentVersion(number);
            }
        }
    });
    const pageMode = (0, $aSsfA.useGetPageMode)();
    (0, $cozmU.useEffect)(()=>{
        const latestVersion = pageInfo?.version?.number;
        if (latestVersion && (0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated_v2', 'isEnabled', true)) {
            setPublishedDocumentVersion(latestVersion);
            if ((0, $6mKj3.expValEquals)('confluence_fe_correct_document_needs_update', 'isEnabled', true)) // Set documentNeedsUpdate to true only if all of the following are true:
            // 1. pageMode is VIEW
            // 2. currentDocumentVersion is set to a valid version number
            // 3. latestVersion is different from currentDocumentVersion
            // Otherwise, set documentNeedsUpdate to false.
            setDocumentNeedsUpdate(pageMode === (0, $cD1qu.PageMode).VIEW && currentDocumentVersion > 0 && latestVersion !== currentDocumentVersion);
            else setDocumentNeedsUpdate(latestVersion !== currentDocumentVersion);
        }
    }, [
        pageInfo?.version?.number,
        currentDocumentVersion,
        setPublishedDocumentVersion,
        setDocumentNeedsUpdate,
        pageMode
    ]);
    const fetchContentVersionNumber = async ()=>{
        try {
            if (refetch) {
                const { data: data } = await refetch();
                return data?.content?.nodes?.[0]?.version?.number;
            }
        } catch (e) {
            if ((0, $1uFM6.isUnauthorizedError)(e) || e instanceof (0, $flE5X.NoNetworkError)) (0, $7Sm4c.markErrorAsHandled)(e);
            return;
        }
    };
    const fetchMissingCommentEventsSinceTime = async (contentId, since)=>{
        try {
            const response = await (0, $c0rhi.queryInterop)({
                query: (0, $lFugL.default),
                variables: {
                    contentId: contentId,
                    since: since
                },
                fetchPolicy: 'no-cache',
                errorPolicy: 'all',
                __callerPackage__: "comments-pubsub"
            });
            const comments = response.data?.quickReload?.comments || [];
            let filteredCommentEvents = comments;
            // Filter out comment events tha we're not subscribed to
            if (eventType !== 0) filteredCommentEvents = comments.filter((comment)=>eventType === 1 ? comment.comment?.location.type === 'FOOTER' : comment.comment?.location.type === 'INLINE');
            const commentEvents = filteredCommentEvents.map((comment)=>{
                const commentId = comment.comment?.id;
                const type = comment.comment?.location.type;
                const accountId = comment.comment?.author?.accountId || '';
                return {
                    id: commentId,
                    type: type,
                    accountId: accountId
                };
            });
            const time = response.data?.quickReload?.time;
            return {
                commentEvents: commentEvents,
                time: time,
                contentId: contentId
            };
        } catch (e) {
            if ((0, $1uFM6.isUnauthorizedError)(e) || e instanceof (0, $flE5X.NoNetworkError)) (0, $7Sm4c.markErrorAsHandled)(e);
            // Just do nothing
            return;
        }
    };
    const clearMissedEventTimeout = ()=>{
        if (missedEventQueryTimeout.current) {
            clearTimeout(missedEventQueryTimeout.current);
            missedEventQueryTimeout.current = null;
        }
    };
    const checkAndHandleMissedEvents = ()=>{
        // If we already have a timeout queued clear it
        clearMissedEventTimeout();
        // Check for the missed events on a timeout after the user has been back for 3 seconds
        missedEventQueryTimeout.current = setTimeout(async ()=>{
            if (documentNeedsUpdate) return;
            const contentLatestVersion = await fetchContentVersionNumber();
            if (!isAutoReloadPageComments && contentLatestVersion !== publishedDocumentVersion) {
                if (!(0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated_v2', 'isEnabled', true)) // when experiment is ON, this is done in the useEffect block above
                setPublishedDocumentVersion(contentLatestVersion);
                onFetchContentVersionEvent && onFetchContentVersionEvent();
                return;
            }
            // Call passed in fetch function
            fetchMissingCommentEventsSinceTime(contentId, lastEventCheckTimeRef.current || Date.now()).then((res)=>{
                // This check of content types is needed in case the promise resolves after a user has already changed pages
                if (res && contentId === res.contentId) {
                    lastEventCheckTimeRef.current = res.time ?? Date.now();
                    // Return the result to the caller
                    onEventFetchSuccess(res);
                }
            // If the call fails, do nothing, just assume the events were missed
            });
        }, returnInterval);
    };
    // Wire up pub sub events when the component mounts
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            window.removeEventListener('beforeunload', unsubscribeFromPubSubEvents);
            unsubscribeFromPubSubEvents();
            if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
            (0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) return;
            clearMissedEventTimeout();
        };
    // We only want to resub when the content changes or the passed in functions change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId
    ]);
    // Need to subscribe to the pubsub when component mounts or contentId, publishedDocumentVersion changes
    (0, $cozmU.useEffect)(()=>{
        // No need to subscribe to the pubsub when doc version is 0
        // We need the events only when we have a valid version number i.e published
        if (publishedDocumentVersion === 0) return;
        subscribeToPubSubEvents();
        // Make sure to unsubscribe from pubsub events if the browser closes
        window.addEventListener('beforeunload', unsubscribeFromPubSubEvents);
    // We only want to resub when the content changes or the passed in functions change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        publishedDocumentVersion,
        documentNeedsUpdate
    ]);
    // Listen to document visibility changes
    (0, $cozmU.useEffect)(()=>{
        if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) return;
        const changeVisibility = ()=>setDocumentVisible(!document.hidden);
        document.addEventListener('visibilitychange', changeVisibility);
        return ()=>{
            document.removeEventListener('visibilitychange', changeVisibility);
        };
    }, [
        setDocumentVisible
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) return;
        if (documentVisible && subscriptionShutdownTimer.current) {
            clearTimeout(subscriptionShutdownTimer.current);
            subscriptionShutdownTimer.current = null;
        }
        // When the document becomes hidden, record the current time as the last check time
        if (!documentVisible) lastEventCheckTimeRef.current = Date.now();
        // If the document is no longer visible, set a timeout to unsubscribe from pubsub events
        if (!documentVisible && !subscriptionShutdownTimer.current && pubSubState === 0) subscriptionShutdownTimer.current = setTimeout(()=>{
            unsubscribeFromPubSubEvents();
            setPubSubState(1);
        }, inactiveInterval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        documentVisible
    ]);
    // Resubscribe to the pubsub events when we come back and handle any missed events
    (0, $cozmU.useEffect)(()=>{
        if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) return;
        setPubSubState((prevState)=>{
            if (documentVisible && prevState === 1) {
                onDocumentReturn && onDocumentReturn();
                checkAndHandleMissedEvents();
                subscribeToPubSubEvents();
                return 0;
            }
            return prevState;
        });
    // We only want this to fire when the document visibility has changed, not the pubsub state
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        documentVisible
    ]);
    return null;
};
module.exports["CommentEventType"] = $11771bad87ca0882$export$77deeade63afd3a6;
module.exports["MissedPubSubCommentEventsHandler"] = $11771bad87ca0882$export$45c0a7c4ba2fbb03;

});

parcelRegister("lFugL", function(module, exports) {
/**
 * @generated SignedSource<<ec37448e00124aacfed3c0e6870df73b>>
 * @relayHash 7477557bbdcb7cd2b6d07a81a3bcb66a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b47931f2ea144024bb11778c3ea928f58c21a4afcb19e487b4f53bc0a3d0c559
const $f560d9e78fe64cde$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "since"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "pageId",
            "variableName": "contentId"
        },
        {
            "kind": "Variable",
            "name": "since",
            "variableName": "since"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "time"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = [
        {
            "kind": "ScalarField",
            "name": "accountId"
        }
    ], v6 = {
        "kind": "InlineFragment",
        "selections": v5 /*: any*/ ,
        "type": "KnownUser"
    }, v7 = {
        "kind": "InlineFragment",
        "selections": v5 /*: any*/ ,
        "type": "UnknownUser"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "MissedPubSubCommentEventsHandlerQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "QuickReload",
                    "kind": "LinkedField",
                    "name": "quickReload",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "QuickReloadComment",
                            "kind": "LinkedField",
                            "name": "comments",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "comment",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "location",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "author",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "MissedPubSubCommentEventsHandlerQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "QuickReload",
                    "kind": "LinkedField",
                    "name": "quickReload",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "QuickReloadComment",
                            "kind": "LinkedField",
                            "name": "comments",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "comment",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "location",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                v4 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "author",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "7477557bbdcb7cd2b6d07a81a3bcb66a",
            "id": "b47931f2ea144024bb11778c3ea928f58c21a4afcb19e487b4f53bc0a3d0c559",
            "metadata": {},
            "name": "MissedPubSubCommentEventsHandlerQuery",
            "operationKind": "query",
            "text": "query MissedPubSubCommentEventsHandlerQuery($contentId:Long!,$since:Long!){quickReload(pageId:$contentId,since:$since){time,comments{comment{id,location{__typename,type},author{__typename,...on KnownUser{accountId},...on UnknownUser{accountId}}}}}}"
        }
    };
}();
$f560d9e78fe64cde$var$node.hash = "7c3b6fa82a316ebe81a0bcd5cab2114e";
var $f560d9e78fe64cde$export$2e2bcd8739ae039 = $f560d9e78fe64cde$var$node;
module.exports["default"] = $f560d9e78fe64cde$export$2e2bcd8739ae039;

});

parcelRegister("hfNnW", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $3ZKFP = parcelRequire("3ZKFP");

const $8c6826fc16df1cbc$export$e314db58fea1ec32 = ({ accountId: accountId = null, currentUserId: currentUserId = null, originTabId: originTabId = null, isReply: isReply = false, isOwnReplyPubSubProcessingEnabled: isOwnReplyPubSubProcessingEnabled = false })=>{
    if ((0, $6mKj3.expVal)('cc_use_browser_tab_id', 'isEnabled', false)) return originTabId === (0, $3ZKFP.getBrowserTabId)();
    if (!accountId || accountId !== currentUserId) return false;
    // Agents comment through public APIs, so their events reach the frontend as current-user
    // events; processing own replies is the workaround for that until the originating tab is used.
    if (!isReply) return true;
    return !isOwnReplyPubSubProcessingEnabled;
};
module.exports["shouldSkipOwnPubSubEvent"] = $8c6826fc16df1cbc$export$e314db58fea1ec32;

});

parcelRegister("b11gn", function(module, exports) {

var $irVI7 = parcelRequire("irVI7");


var $fGzMp = parcelRequire("fGzMp");


var $4L9ve = parcelRequire("4L9ve");


var $kgNLQ = parcelRequire("kgNLQ");

var $c84c3a6392bd7f68$export$4dc7cc9100b67c07 = /*#__PURE__*/ function(CommentsPubSubSource) {
    CommentsPubSubSource["EditorInlineCommentsPubSub"] = "editorInlineCommentsPubSub";
    CommentsPubSubSource["RendererInlineCommentsPubSub"] = "rendererInlineCommentsPubSub";
    CommentsPubSubSource["PageCommentsPubSub"] = "pageCommentsPubSub";
    return CommentsPubSubSource;
}({});
var $c84c3a6392bd7f68$export$6c1f9a49b2d5ac05 = /*#__PURE__*/ function(CommentsPubsubTrackedEventType) {
    CommentsPubsubTrackedEventType["Resolve"] = "resolve";
    CommentsPubsubTrackedEventType["Reopen"] = "reopen";
    CommentsPubsubTrackedEventType["Edit"] = "edit";
    return CommentsPubsubTrackedEventType;
}({});
/**
 * A commentResolved / InlineCommentResolved event promises the refetched comment is resolved.
 * If a network-only refetch still shows it unresolved, the read raced ahead of replication and
 * the success can't be verified.
 */ const $c84c3a6392bd7f68$var$getStaleResolveError = (comment)=>comment && (0, $kgNLQ.isCommentResolved)(comment) ? undefined : new Error('commentResolved: stale read');
/**
 * A commentReopened / InlineCommentUnresolved event promises the refetched comment is
 * unresolved. Same staleness risk as resolve, in the other direction.
 */ const $c84c3a6392bd7f68$var$getStaleReopenError = (comment)=>comment && !(0, $kgNLQ.isCommentResolved)(comment) ? undefined : new Error('commentReopened: stale read');
/**
 * A commentUpdated / InlineCommentUpdated event carries no version number of its own (neither
 * the AVI nor the AGG payload includes one), so the only way to catch a stale (pre-edit) read is
 * comparing the refetched version against the version we had cached before the refetch was
 * issued (see getCachedCommentVersionNumber).
 */ const $c84c3a6392bd7f68$var$getStaleEditError = (comment, previousVersionNumber)=>{
    const currentVersionNumber = comment?.version?.number ?? null;
    return previousVersionNumber != null && currentVersionNumber != null && currentVersionNumber <= previousVersionNumber ? new Error('commentUpdated: stale read') : undefined;
};
const $c84c3a6392bd7f68$var$getStaleCommentError = (type, comment, previousVersionNumber)=>{
    switch(type){
        case "resolve":
            return $c84c3a6392bd7f68$var$getStaleResolveError(comment);
        case "reopen":
            return $c84c3a6392bd7f68$var$getStaleReopenError(comment);
        case "edit":
            return $c84c3a6392bd7f68$var$getStaleEditError(comment, previousVersionNumber);
        default:
            return undefined;
    }
};
const $c84c3a6392bd7f68$export$c83a826d1956bd57 = (source, commentId)=>{
    // Unique per event invocation; lets us detect concurrent-event collisions
    // by matching initialTrackingId === terminalTrackingId in logs.
    let trackingId;
    const fail = (err)=>{
        (0, $fGzMp.getExperienceTracker)().fail({
            name: (0, $irVI7.COMMENTS_PUBSUB_EVENT_EXPERIENCE),
            error: err instanceof Error ? err : new Error(String(err)),
            attributes: {
                terminalTrackingId: trackingId
            }
        });
    };
    return {
        start: (event)=>{
            // IMPORTANT - because this is in a factory method, it is deliberate that mixing
            // & matching starts / failures / successes across invocations will lead to different trackingIDs.
            // If you need to refactor this to be cross-file, or cross-function for a valid case,
            // you'll probably need to lift this out of the factory
            trackingId = crypto.randomUUID();
            (0, $fGzMp.getExperienceTracker)().start({
                name: (0, $irVI7.COMMENTS_PUBSUB_EVENT_EXPERIENCE),
                // 15s — above the AGG client's ~10s network timeout.
                timeout: 15000,
                attributes: {
                    event: event,
                    source: source,
                    initialTrackingId: trackingId,
                    commentId: commentId
                }
            });
        },
        fail: fail,
        handleCompletePubSubExperiences: async (eventsToValidate = [])=>{
            // Rejections deliberately propagate rather than being reported here - a failing
            // fetchCommentById is handled by the caller's existing catch, which fails the
            // experience and rethrows.
            const staleErrors = await Promise.all(eventsToValidate.map(async (trackedEvent)=>{
                // Each entry is either a plain Promise<void> or a TrackedCommentEvent - never
                // both - so only one of these two awaits is ever doing real work. Awaiting a
                // plain promise resolves to undefined and short-circuits below. Awaiting a
                // TrackedCommentEvent (not itself a promise) resolves immediately to itself;
                // its `comment` field is what actually gets awaited next.
                const event = await trackedEvent;
                if (!event) return undefined;
                return $c84c3a6392bd7f68$var$getStaleCommentError(event.type, await event.comment, event.previousVersionNumber);
            }));
            const staleError = staleErrors.find((error)=>error);
            if (staleError) {
                fail(staleError);
                return;
            }
            (0, $fGzMp.getExperienceTracker)().succeed({
                name: (0, $irVI7.COMMENTS_PUBSUB_EVENT_EXPERIENCE),
                attributes: {
                    terminalTrackingId: trackingId
                }
            });
        }
    };
};
const $c84c3a6392bd7f68$export$bfad633ca9511e62 = (commentId)=>(0, $4L9ve.getProcessedCommentsDataState)().flatCommentsMap[commentId]?.version?.number ?? null;
module.exports["CommentsPubSubSource"] = $c84c3a6392bd7f68$export$4dc7cc9100b67c07;
module.exports["CommentsPubsubTrackedEventType"] = $c84c3a6392bd7f68$export$6c1f9a49b2d5ac05;
module.exports["createCommentsPubSubExperienceTracker"] = $c84c3a6392bd7f68$export$c83a826d1956bd57;
module.exports["getCachedCommentVersionNumber"] = $c84c3a6392bd7f68$export$bfad633ca9511e62;

});

parcelRegister("lfmjq", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7aRa9 = parcelRequire("7aRa9");

const $0d3a7c976c53fe50$export$687b1508b29e79eb = (0, $7aRa9.withFlags)(({ flags: flags })=>{
    const intl = (0, $kSwu1.useIntl)();
    (0, $cozmU.useEffect)(()=>{
        const urlParams = new URLSearchParams(window.location.search);
        const moved = urlParams.get('moved');
        if (moved === 'success') {
            // Show the success flag
            flags.showSuccessFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $0d3a7c976c53fe50$var$i18n.movePageItemMovedTitle),
                isAutoDismiss: true
            });
            // Clean up URL parameters without causing a page reload
            urlParams.delete('moved');
            const newParams = urlParams.size > 0 ? `?${urlParams.toString()}` : '';
            const newUrl = `${window.location.pathname}${newParams}${window.location.hash}`;
            window.history.replaceState({}, '', newUrl);
        }
    }, [
        flags,
        intl
    ]);
    return null;
});
const $0d3a7c976c53fe50$var$i18n = (0, $kSwu1.defineMessages)({
    movePageItemMovedTitle: {
        id: "page-tree.move-page.flag.success",
        defaultMessage: "Item moved"
    }
});
module.exports["MovePageSuccessFlag"] = $0d3a7c976c53fe50$export$687b1508b29e79eb;

});

parcelRegister("hd53J", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $ln0hx = parcelRequire("ln0hx");

var $1kHsc = parcelRequire("1kHsc");


var $6mKj3 = parcelRequire("6mKj3");


var $cD1qu = parcelRequire("cD1qu");


var $aSsfA = parcelRequire("aSsfA");


var $NYiei = parcelRequire("NYiei");


var $4L9ve = parcelRequire("4L9ve");

// Initiates the loading of all comment data for the specified page in the background
// This component is also responsible for processing the raw comments data and updating
// the ProcessedCommentsDataStore with categorized results using default contentStatus filters.
// Experience tracking constants
const $52b7f7492d78c524$var$COMMENTS_DATA_BACKGROUND_LOAD_EXPERIENCE = 'comments-data-background-load';
const $52b7f7492d78c524$export$bdd232a9ca677e73 = ({ contentId: contentId })=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const [{ lastProcessedData: lastProcessedData }, { setProcessedData: setProcessedData, setError: setError, setRefetch: setRefetch, clearErrorAndResetIsDataProcessed: clearErrorAndResetIsDataProcessed, setDataToProcessed: setDataToProcessed, processCommentsData: processCommentsData }] = (0, $4L9ve.useProcessedCommentsData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const previousContentId = (0, $cozmU.useRef)(undefined);
    // Track refetch count to force effect to run after every refetch
    const [refetchCount, setRefetchCount] = (0, $cozmU.useState)(0);
    // Call the hook to load all comments - should only when content has settled and is ready so we
    // don't impact loading times
    // Always fetch with network-only to ensure we get fresh data
    const { loading: loading, error: error, data: data, refetch: refetch } = (0, $NYiei.useAllCommentsData)({
        contentId: contentId,
        options: {
            skip: !contentId,
            fetchPolicy: 'network-only'
        }
    });
    // Set refetch function in store whenever it changes.
    // Wrap refetch so that when the view calls it (e.g. Retry), we clear error/processed state first.
    // Increment refetchCount in .then() to force the processing effect to run.
    // On refetch failure we always setError, then call the caller's onError if they passed one.
    (0, $cozmU.useEffect)(()=>{
        if (refetch) {
            const wrappedRefetch = ({ onError: callerOnError, preserveProcessedData: preserveProcessedData = false } = {})=>{
                if (!preserveProcessedData) clearErrorAndResetIsDataProcessed();
                return refetch({
                    onError: (err)=>{
                        setError(err instanceof Error ? err : new Error(String(err)));
                        callerOnError?.(err);
                    }
                }).then((result)=>{
                    setRefetchCount((c)=>c + 1);
                    return result;
                });
            };
            setRefetch(wrappedRefetch);
        }
    }, [
        refetch,
        setRefetch,
        clearErrorAndResetIsDataProcessed,
        setError
    ]);
    // Process and update the ProcessedCommentsDataStore when data changes or refetch completes
    // This is the ONLY place where the processed data store should be updated
    // Depends on refetchCount to ensure effect runs after every refetch
    (0, $cozmU.useEffect)(()=>{
        // Don't process data while loading
        if (loading) return;
        if (error) {
            setError(error);
            return;
        }
        // When data is undefined (e.g. refetch failed and error was set in the wrapper catch),
        // don't call setProcessedData or we'd overwrite that error with error: undefined.
        if (data === undefined) return;
        // Fast path: if data reference is same as last processed (cached data from refetch),
        // just flip isDataProcessed to true without reprocessing
        if (data === lastProcessedData) {
            setDataToProcessed();
            return;
        }
        const stats = processCommentsData({
            data: data,
            pageMode: pageMode
        });
        if (previousContentId.current !== contentId && (0, $6mKj3.expValEquals)('confluence_fe_emit_comments_data_stats_event', 'isEnabled', true)) {
            previousContentId.current = contentId;
            if (stats) createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'loaded',
                    actionSubject: 'comments',
                    actionSubjectId: 'CommentsDataBackgroundLoader',
                    objectType: 'page',
                    objectId: contentId,
                    source: pageMode === (0, $cD1qu.PageMode).VIEW ? 'viewPageScreen' : 'editPageScreen',
                    attributes: {
                        pageMode: pageMode,
                        isLivePage: pageMode === (0, $cD1qu.PageMode).LIVE,
                        ...stats
                    }
                }
            }).fire();
        }
    }, [
        data,
        loading,
        error,
        pageMode,
        setProcessedData,
        setError,
        contentId,
        previousContentId,
        refetchCount,
        lastProcessedData,
        setDataToProcessed,
        processCommentsData,
        createAnalyticsEvent
    ]);
    // Experience tracking: Handle success/failure when loading completes
    (0, $cozmU.useEffect)(()=>{
        if (!contentId) return;
        // Only track completion if we're not still loading
        if (!loading) {
            if (error) // Experience failed due to error
            experienceTracker.fail({
                name: $52b7f7492d78c524$var$COMMENTS_DATA_BACKGROUND_LOAD_EXPERIENCE,
                error: error
            });
            else // Experience succeeded - comments data loaded successfully
            experienceTracker.succeed({
                name: $52b7f7492d78c524$var$COMMENTS_DATA_BACKGROUND_LOAD_EXPERIENCE
            });
        }
    }, [
        loading,
        error,
        contentId,
        experienceTracker
    ]);
    // This component only triggers the hook, doesn't render anything other than the ExperienceStart,
    // which handles being rendered multiple times with the same props gracefully
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
        name: $52b7f7492d78c524$var$COMMENTS_DATA_BACKGROUND_LOAD_EXPERIENCE,
        attributes: {
            contentId: contentId
        }
    });
};
module.exports["CommentsDataBackgroundLoader"] = $52b7f7492d78c524$export$bdd232a9ca677e73;

});

parcelRegister("jXhAV", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $d2180b659da4cd23$export$cace184d1f5b9f1 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "QfGBR",
    name: "QuickReload",
    loader: async ()=>{
        const { QuickReload: QuickReload } = await (parcelRequire("3t7C5"));
        return QuickReload;
    }
});
module.exports["QuickReload"] = $d2180b659da4cd23$export$cace184d1f5b9f1;

});

parcelRegister("3t7C5", function(module, exports) {

let $2869fc65f0038106$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2869fc65f0038106$var$load("9H0e8"),
    $2869fc65f0038106$var$load("7sjI9"),
    $2869fc65f0038106$var$load("7BHAC"),
    $2869fc65f0038106$var$load("N3TvS"),
    $2869fc65f0038106$var$load("6wr18"),
    $2869fc65f0038106$var$load("bAgKB"),
    $2869fc65f0038106$var$load("ifgY7"),
    $2869fc65f0038106$var$load("34Kox"),
    $2869fc65f0038106$var$load("7Y0AX"),
    $2869fc65f0038106$var$load("8LtYa"),
    $2869fc65f0038106$var$load("fky9A"),
    $2869fc65f0038106$var$load("7EorR"),
    $2869fc65f0038106$var$load("jqoep"),
    $2869fc65f0038106$var$load("jXx9i"),
    $2869fc65f0038106$var$load("ffEVr"),
    $2869fc65f0038106$var$load("7XFs3")
]).then(()=>parcelRequire('1EPbu'));

});

parcelRegister("fSC8h", function(module, exports) {
var $aa49ff5a5783772f$export$c51d39001809fe3e = /*#__PURE__*/ function(PubSubState) {
    PubSubState[PubSubState["POLLING_ONLY"] = 0] = "POLLING_ONLY";
    PubSubState[PubSubState["PUBSUB_ONLY"] = 1] = "PUBSUB_ONLY";
    PubSubState[PubSubState["ACTIVE"] = 2] = "ACTIVE";
    PubSubState[PubSubState["TERMINATED"] = 3] = "TERMINATED";
    return PubSubState;
}({});
const $aa49ff5a5783772f$export$5a33be95ac52bdad = 2000;
var $aa49ff5a5783772f$export$8f29965b50c50222 = /*#__PURE__*/ function(PubSubFlagType) {
    PubSubFlagType[PubSubFlagType["COMMENT"] = 0] = "COMMENT";
    PubSubFlagType[PubSubFlagType["EDIT"] = 1] = "EDIT";
    return PubSubFlagType;
}({});
var $aa49ff5a5783772f$export$6ea4b0c62affbe44 = /*#__PURE__*/ function(PageMode) {
    PageMode[PageMode["EDITOR"] = 0] = "EDITOR";
    PageMode[PageMode["LIVE"] = 1] = "LIVE";
    PageMode[PageMode["RENDERER"] = 2] = "RENDERER";
    return PageMode;
}({});
module.exports["PubSubState"] = $aa49ff5a5783772f$export$c51d39001809fe3e;
module.exports["INACTIVE_TAB_WAIT_INTERVAL"] = $aa49ff5a5783772f$export$5a33be95ac52bdad;
module.exports["PubSubFlagType"] = $aa49ff5a5783772f$export$8f29965b50c50222;
module.exports["PageMode"] = $aa49ff5a5783772f$export$6ea4b0c62affbe44;

});

parcelRegister("5kqgA", function(module, exports) {

var $awDRb = parcelRequire("awDRb");


var $b07B9 = parcelRequire("b07B9");


var $aX2oa = parcelRequire("aX2oa");


var $5WAcP = parcelRequire("5WAcP");


var $5x3Dm = parcelRequire("5x3Dm");


var $co8T8 = parcelRequire("co8T8");


var $cozmU = parcelRequire("cozmU");


var $5BvyC = parcelRequire("5BvyC");

var $8jDil = parcelRequire("8jDil");


var $308Wd = parcelRequire("308Wd");


var $bQm3c = parcelRequire("bQm3c");


var $gKr8t = parcelRequire("gKr8t");

const $a5c37f1d79bf5cbd$export$d8614f1b6b2d1358 = ({ contentId: contentId, contentType: contentType, options: queryOptions = {} })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [createPagePropertyMutation, createPagePropertyResult] = (0, $308Wd.useMutationInterop)((0, $co8T8.default), {
        ...queryOptions,
        client: (0, $gKr8t.getAGGClient)(),
        context: {
            headers: {
                'X-ExperimentalApi': 'confluence-agg-beta'
            }
        },
        __callerPackage__: "update-content-property-utils"
    });
    const [updatePagePropertyMutation, updatePagePropertyResult] = (0, $308Wd.useMutationInterop)((0, $5x3Dm.default), {
        ...queryOptions,
        client: (0, $gKr8t.getAGGClient)(),
        context: {
            headers: {
                'X-ExperimentalApi': 'confluence-agg-beta'
            }
        },
        __callerPackage__: "update-content-property-utils"
    });
    const [deletePagePropertyMutation, deletePagePropertyResult] = (0, $308Wd.useMutationInterop)((0, $5WAcP.default), {
        ...queryOptions,
        client: (0, $gKr8t.getAGGClient)(),
        context: {
            headers: {
                'X-ExperimentalApi': 'confluence-agg-beta'
            }
        },
        __callerPackage__: "update-content-property-utils"
    });
    const [createBlogPropertyMutation, createBlogPropertyResult] = (0, $308Wd.useMutationInterop)((0, $aX2oa.default), {
        ...queryOptions,
        client: (0, $gKr8t.getAGGClient)(),
        context: {
            headers: {
                'X-ExperimentalApi': 'confluence-agg-beta'
            }
        },
        __callerPackage__: "update-content-property-utils"
    });
    const [updateBlogPropertyMutation, updateBlogPropertyResult] = (0, $308Wd.useMutationInterop)((0, $b07B9.default), {
        ...queryOptions,
        client: (0, $gKr8t.getAGGClient)(),
        context: {
            headers: {
                'X-ExperimentalApi': 'confluence-agg-beta'
            }
        },
        __callerPackage__: "update-content-property-utils"
    });
    const [deleteBlogPropertyMutation, deleteBlogPropertyResult] = (0, $308Wd.useMutationInterop)((0, $awDRb.default), {
        ...queryOptions,
        client: (0, $gKr8t.getAGGClient)(),
        context: {
            headers: {
                'X-ExperimentalApi': 'confluence-agg-beta'
            }
        },
        __callerPackage__: "update-content-property-utils"
    });
    const updateContentProperty = (0, $cozmU.useCallback)(({ propertyKey: propertyKey, propertyValue: propertyValueString, isDelete: isDelete = false, hasExistingProperty: hasExistingProperty = false, options: options = {}, shouldOptimisticResponse: shouldOptimisticResponse = false })=>{
        if (isDelete) {
            if (contentType === 'page') return deletePagePropertyMutation({
                variables: {
                    pageId: (0, $8jDil.ConfluencePageAri).create({
                        siteId: cloudId,
                        pageId: contentId
                    }).toString(),
                    propertyKey: propertyKey
                },
                ...options,
                optimisticResponse: shouldOptimisticResponse ? {
                    success: true,
                    errors: []
                } : undefined
            });
            else if (contentType === 'blogpost') return deleteBlogPropertyMutation({
                variables: {
                    blogPostId: (0, $5BvyC.ConfluenceBlogpostAri).create({
                        siteId: cloudId,
                        blogpostId: contentId
                    }).toString(),
                    propertyKey: propertyKey
                },
                ...options,
                optimisticResponse: shouldOptimisticResponse ? {
                    success: true,
                    errors: []
                } : undefined
            });
        } else if (!!propertyValueString) {
            // Property value need to be stringified again before passing to graphql otherwise backend cannot parse it correctly
            const propertyValue = JSON.stringify(propertyValueString);
            if (hasExistingProperty) {
                // When there is existing property, we update it
                if (contentType === 'page') return updatePagePropertyMutation({
                    variables: {
                        pageId: (0, $8jDil.ConfluencePageAri).create({
                            siteId: cloudId,
                            pageId: contentId
                        }).toString(),
                        propertyKey: propertyKey,
                        propertyValue: propertyValue
                    },
                    ...options,
                    optimisticResponse: shouldOptimisticResponse ? {
                        success: true,
                        pageProperty: {
                            key: propertyKey,
                            value: propertyValue
                        },
                        errors: []
                    } : undefined
                });
                else if (contentType === 'blogpost') return updateBlogPropertyMutation({
                    variables: {
                        blogPostId: (0, $5BvyC.ConfluenceBlogpostAri).create({
                            siteId: cloudId,
                            blogpostId: contentId
                        }).toString(),
                        propertyKey: propertyKey,
                        propertyValue: propertyValue
                    },
                    ...options,
                    optimisticResponse: shouldOptimisticResponse ? {
                        success: true,
                        blogPostProperty: {
                            key: propertyKey,
                            value: propertyValue
                        },
                        errors: []
                    } : undefined
                });
            } else {
                // When there is no existing property, we create it
                if (contentType === 'page') return createPagePropertyMutation({
                    variables: {
                        pageId: (0, $8jDil.ConfluencePageAri).create({
                            siteId: cloudId,
                            pageId: contentId
                        }).toString(),
                        propertyKey: propertyKey,
                        propertyValue: propertyValue
                    },
                    ...options,
                    optimisticResponse: shouldOptimisticResponse ? {
                        success: true,
                        pageProperty: {
                            key: propertyKey,
                            value: propertyValue
                        },
                        errors: []
                    } : undefined
                });
                else if (contentType === 'blogpost') return createBlogPropertyMutation({
                    variables: {
                        blogPostId: (0, $5BvyC.ConfluenceBlogpostAri).create({
                            siteId: cloudId,
                            blogpostId: contentId
                        }).toString(),
                        propertyKey: propertyKey,
                        propertyValue: propertyValue
                    },
                    ...options,
                    optimisticResponse: shouldOptimisticResponse ? {
                        success: true,
                        blogPostProperty: {
                            key: propertyKey,
                            value: propertyValue
                        },
                        errors: []
                    } : undefined
                });
            }
        }
    }, [
        createPagePropertyMutation,
        createBlogPropertyMutation,
        updatePagePropertyMutation,
        updateBlogPropertyMutation,
        deletePagePropertyMutation,
        deleteBlogPropertyMutation,
        contentId,
        cloudId,
        contentType
    ]);
    const processUpdateContentPropertyResult = (0, $cozmU.useCallback)((result)=>{
        if (result && 'confluence' in result && result.confluence) {
            if ('createPageProperty' in result.confluence) {
                const { createPageProperty: createPageProperty } = result.confluence;
                return {
                    success: createPageProperty?.success,
                    id: createPageProperty?.pageProperty?.id,
                    key: createPageProperty?.pageProperty?.key,
                    value: createPageProperty?.pageProperty?.value,
                    errors: createPageProperty?.errors ? [
                        ...createPageProperty.errors
                    ] : undefined
                };
            }
            if ('createBlogPostProperty' in result.confluence) {
                const { createBlogPostProperty: createBlogPostProperty } = result.confluence;
                return {
                    success: createBlogPostProperty?.success,
                    id: createBlogPostProperty?.blogPostProperty?.id,
                    key: createBlogPostProperty?.blogPostProperty?.key,
                    value: createBlogPostProperty?.blogPostProperty?.value,
                    errors: createBlogPostProperty?.errors ? [
                        ...createBlogPostProperty.errors
                    ] : undefined
                };
            }
            if ('updateValuePageProperty' in result.confluence) {
                const { updateValuePageProperty: updateValuePageProperty } = result.confluence;
                return {
                    success: updateValuePageProperty?.success,
                    id: updateValuePageProperty?.pageProperty?.id,
                    key: updateValuePageProperty?.pageProperty?.key,
                    value: updateValuePageProperty?.pageProperty?.value,
                    errors: updateValuePageProperty?.errors ? [
                        ...updateValuePageProperty.errors
                    ] : undefined
                };
            }
            if ('updateValueBlogPostProperty' in result.confluence) {
                const { updateValueBlogPostProperty: updateValueBlogPostProperty } = result.confluence;
                return {
                    success: updateValueBlogPostProperty?.success,
                    id: updateValueBlogPostProperty?.blogPostProperty?.id,
                    key: updateValueBlogPostProperty?.blogPostProperty?.key,
                    value: updateValueBlogPostProperty?.blogPostProperty?.value,
                    errors: updateValueBlogPostProperty?.errors ? [
                        ...updateValueBlogPostProperty.errors
                    ] : undefined
                };
            }
            if ('deletePageProperty' in result.confluence) {
                const { deletePageProperty: deletePageProperty } = result.confluence;
                return {
                    success: deletePageProperty?.success,
                    errors: deletePageProperty?.errors ? [
                        ...deletePageProperty.errors
                    ] : undefined
                };
            }
            if ('deleteBlogPostProperty' in result.confluence) {
                const { deleteBlogPostProperty: deleteBlogPostProperty } = result.confluence;
                return {
                    success: deleteBlogPostProperty?.success,
                    errors: deleteBlogPostProperty?.errors ? [
                        ...deleteBlogPostProperty.errors
                    ] : undefined
                };
            }
        }
        return null;
    }, []);
    return {
        updateContentProperty: updateContentProperty,
        processUpdateContentPropertyResult: processUpdateContentPropertyResult,
        updateContentPropertyResult: createPagePropertyResult || updatePagePropertyResult || deletePagePropertyResult || createBlogPropertyResult || updateBlogPropertyResult || deleteBlogPropertyResult
    };
};
module.exports["useUpdateContentProperty"] = $a5c37f1d79bf5cbd$export$d8614f1b6b2d1358;

});

parcelRegister("awDRb", function(module, exports) {
/**
 * @generated SignedSource<<dfe8519267b68a4378b78429167f3c63>>
 * @relayHash 7ea43002279108ebdaf4bacd5136e32c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b94e26cf760050f97f1735eb7c08613c6631650155dfaef62fc5ff0db5b416cf
const $070558e2bb126032$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "blogPostId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "propertyKey"
    }, v2 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "blogPostId",
                    "variableName": "blogPostId"
                },
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "propertyKey"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useUpdateContentPropertyBlogDeleteMutation",
            "selections": [
                {
                    "concreteType": "ConfluenceMutationApi",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "ConfluenceDeleteBlogPostPropertyPayload",
                            "kind": "LinkedField",
                            "name": "deleteBlogPostProperty",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useUpdateContentPropertyBlogDeleteMutation",
            "selections": [
                {
                    "concreteType": "ConfluenceMutationApi",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "ConfluenceDeleteBlogPostPropertyPayload",
                            "kind": "LinkedField",
                            "name": "deleteBlogPostProperty",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "7ea43002279108ebdaf4bacd5136e32c",
            "id": "b94e26cf760050f97f1735eb7c08613c6631650155dfaef62fc5ff0db5b416cf",
            "metadata": {},
            "name": "useUpdateContentPropertyBlogDeleteMutation",
            "operationKind": "mutation",
            "text": "mutation useUpdateContentPropertyBlogDeleteMutation($propertyKey:String!,$blogPostId:ID!){confluence{deleteBlogPostProperty(input:{key:$propertyKey,blogPostId:$blogPostId}){success,errors{message,extensions{__typename,statusCode,...on BulkMutationErrorExtension{id}}}}}}"
        }
    };
}();
$070558e2bb126032$var$node.hash = "9c55ced69dfdca7b034578bc15733a6a";
var $070558e2bb126032$export$2e2bcd8739ae039 = $070558e2bb126032$var$node;
module.exports["default"] = $070558e2bb126032$export$2e2bcd8739ae039;

});

parcelRegister("b07B9", function(module, exports) {
/**
 * @generated SignedSource<<7575a61e168d4fd5931f7e5595e93934>>
 * @relayHash 83c667f6e4eab61cc7723fc091cb0002
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 83b68e9d7eb3a6372d990fbb1ea21f606ae1cf9fdb97bb2190a609d28a9954c9
const $22e9015d273a347d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "blogPostId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "propertyKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "propertyValue"
    }, v3 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "blogPostId",
                    "variableName": "blogPostId"
                },
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "propertyKey"
                },
                {
                    "kind": "Variable",
                    "name": "value",
                    "variableName": "propertyValue"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "success"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "concreteType": "ConfluenceBlogPostProperty",
        "kind": "LinkedField",
        "name": "blogPostProperty",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "key"
            },
            {
                "kind": "ScalarField",
                "name": "value"
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "message"
    }, v8 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useUpdateContentPropertyBlogUpdateMutation",
            "selections": [
                {
                    "concreteType": "ConfluenceMutationApi",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "ConfluenceUpdateValueBlogPostPropertyPayload",
                            "kind": "LinkedField",
                            "name": "updateValueBlogPostProperty",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useUpdateContentPropertyBlogUpdateMutation",
            "selections": [
                {
                    "concreteType": "ConfluenceMutationApi",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "ConfluenceUpdateValueBlogPostPropertyPayload",
                            "kind": "LinkedField",
                            "name": "updateValueBlogPostProperty",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v5 /*: any*/ 
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "83c667f6e4eab61cc7723fc091cb0002",
            "id": "83b68e9d7eb3a6372d990fbb1ea21f606ae1cf9fdb97bb2190a609d28a9954c9",
            "metadata": {},
            "name": "useUpdateContentPropertyBlogUpdateMutation",
            "operationKind": "mutation",
            "text": "mutation useUpdateContentPropertyBlogUpdateMutation($propertyKey:String!,$blogPostId:ID!,$propertyValue:String!){confluence{updateValueBlogPostProperty(input:{key:$propertyKey,blogPostId:$blogPostId,value:$propertyValue}){success,blogPostProperty{id,key,value},errors{message,extensions{__typename,statusCode,...on BulkMutationErrorExtension{id}}}}}}"
        }
    };
}();
$22e9015d273a347d$var$node.hash = "580533e46ac660d594c903425683aacb";
var $22e9015d273a347d$export$2e2bcd8739ae039 = $22e9015d273a347d$var$node;
module.exports["default"] = $22e9015d273a347d$export$2e2bcd8739ae039;

});

parcelRegister("aX2oa", function(module, exports) {
/**
 * @generated SignedSource<<b3f8ab82df27637909fcdd1713b75918>>
 * @relayHash faed0d2f1dd78a502a219a9a5d9dc53b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d4a419a258f4c5ca2db7e6708ac16a9abfa6d2a91dbdf3fc909766277682e0c0
const $fcc85e5ea801be9e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "blogPostId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "propertyKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "propertyValue"
    }, v3 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "blogPostId",
                    "variableName": "blogPostId"
                },
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "propertyKey"
                },
                {
                    "kind": "Variable",
                    "name": "value",
                    "variableName": "propertyValue"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "success"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "concreteType": "ConfluenceBlogPostProperty",
        "kind": "LinkedField",
        "name": "blogPostProperty",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "key"
            },
            {
                "kind": "ScalarField",
                "name": "value"
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "message"
    }, v8 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useUpdateContentPropertyBlogCreateMutation",
            "selections": [
                {
                    "concreteType": "ConfluenceMutationApi",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "ConfluenceCreateBlogPostPropertyPayload",
                            "kind": "LinkedField",
                            "name": "createBlogPostProperty",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useUpdateContentPropertyBlogCreateMutation",
            "selections": [
                {
                    "concreteType": "ConfluenceMutationApi",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "ConfluenceCreateBlogPostPropertyPayload",
                            "kind": "LinkedField",
                            "name": "createBlogPostProperty",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v5 /*: any*/ 
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "faed0d2f1dd78a502a219a9a5d9dc53b",
            "id": "d4a419a258f4c5ca2db7e6708ac16a9abfa6d2a91dbdf3fc909766277682e0c0",
            "metadata": {},
            "name": "useUpdateContentPropertyBlogCreateMutation",
            "operationKind": "mutation",
            "text": "mutation useUpdateContentPropertyBlogCreateMutation($propertyKey:String!,$blogPostId:ID!,$propertyValue:String!){confluence{createBlogPostProperty(input:{key:$propertyKey,blogPostId:$blogPostId,value:$propertyValue}){success,blogPostProperty{id,key,value},errors{message,extensions{__typename,statusCode,...on BulkMutationErrorExtension{id}}}}}}"
        }
    };
}();
$fcc85e5ea801be9e$var$node.hash = "1ac5be7a6ec97ac06bb016be27c4c3a0";
var $fcc85e5ea801be9e$export$2e2bcd8739ae039 = $fcc85e5ea801be9e$var$node;
module.exports["default"] = $fcc85e5ea801be9e$export$2e2bcd8739ae039;

});

parcelRegister("5WAcP", function(module, exports) {
/**
 * @generated SignedSource<<c5551e0bc3921a0985db3a2a7e1c0d4c>>
 * @relayHash ff4d35071121f198fae1a7890dfd8302
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d7131b41a92502615d964ebb289e6095bdc12211082b0acc52ded04f767ae954
const $a12a59c8911be0e2$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "propertyKey"
    }, v2 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "propertyKey"
                },
                {
                    "kind": "Variable",
                    "name": "pageId",
                    "variableName": "pageId"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useUpdateContentPropertyPageDeleteMutation",
            "selections": [
                {
                    "concreteType": "ConfluenceMutationApi",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "ConfluenceDeletePagePropertyPayload",
                            "kind": "LinkedField",
                            "name": "deletePageProperty",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useUpdateContentPropertyPageDeleteMutation",
            "selections": [
                {
                    "concreteType": "ConfluenceMutationApi",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "ConfluenceDeletePagePropertyPayload",
                            "kind": "LinkedField",
                            "name": "deletePageProperty",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "ff4d35071121f198fae1a7890dfd8302",
            "id": "d7131b41a92502615d964ebb289e6095bdc12211082b0acc52ded04f767ae954",
            "metadata": {},
            "name": "useUpdateContentPropertyPageDeleteMutation",
            "operationKind": "mutation",
            "text": "mutation useUpdateContentPropertyPageDeleteMutation($propertyKey:String!,$pageId:ID!){confluence{deletePageProperty(input:{key:$propertyKey,pageId:$pageId}){success,errors{message,extensions{__typename,statusCode,...on BulkMutationErrorExtension{id}}}}}}"
        }
    };
}();
$a12a59c8911be0e2$var$node.hash = "c20456827070d144db3082bf07a8c31a";
var $a12a59c8911be0e2$export$2e2bcd8739ae039 = $a12a59c8911be0e2$var$node;
module.exports["default"] = $a12a59c8911be0e2$export$2e2bcd8739ae039;

});

parcelRegister("5x3Dm", function(module, exports) {
/**
 * @generated SignedSource<<56f4baafca333faf75f7d54926973a2c>>
 * @relayHash 3010f6b1356aae10019a1ad07e146372
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 799d904d34743a2ad3869f0c1587983f184044efc037e58ca7920c9641500955
const $c8d393500a85ca00$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "propertyKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "propertyValue"
    }, v3 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "propertyKey"
                },
                {
                    "kind": "Variable",
                    "name": "pageId",
                    "variableName": "pageId"
                },
                {
                    "kind": "Variable",
                    "name": "value",
                    "variableName": "propertyValue"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "success"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "concreteType": "ConfluencePageProperty",
        "kind": "LinkedField",
        "name": "pageProperty",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "key"
            },
            {
                "kind": "ScalarField",
                "name": "value"
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "message"
    }, v8 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useUpdateContentPropertyPageUpdateMutation",
            "selections": [
                {
                    "concreteType": "ConfluenceMutationApi",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "ConfluenceUpdateValuePagePropertyPayload",
                            "kind": "LinkedField",
                            "name": "updateValuePageProperty",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useUpdateContentPropertyPageUpdateMutation",
            "selections": [
                {
                    "concreteType": "ConfluenceMutationApi",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "ConfluenceUpdateValuePagePropertyPayload",
                            "kind": "LinkedField",
                            "name": "updateValuePageProperty",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v5 /*: any*/ 
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "3010f6b1356aae10019a1ad07e146372",
            "id": "799d904d34743a2ad3869f0c1587983f184044efc037e58ca7920c9641500955",
            "metadata": {},
            "name": "useUpdateContentPropertyPageUpdateMutation",
            "operationKind": "mutation",
            "text": "mutation useUpdateContentPropertyPageUpdateMutation($propertyKey:String!,$pageId:ID!,$propertyValue:String!){confluence{updateValuePageProperty(input:{key:$propertyKey,pageId:$pageId,value:$propertyValue}){success,pageProperty{id,key,value},errors{message,extensions{__typename,statusCode,...on BulkMutationErrorExtension{id}}}}}}"
        }
    };
}();
$c8d393500a85ca00$var$node.hash = "4b090e3281dd15c3d9500ac77008df26";
var $c8d393500a85ca00$export$2e2bcd8739ae039 = $c8d393500a85ca00$var$node;
module.exports["default"] = $c8d393500a85ca00$export$2e2bcd8739ae039;

});

parcelRegister("co8T8", function(module, exports) {
/**
 * @generated SignedSource<<986ee9c28f9f845e1d05fa984d3be73f>>
 * @relayHash 775b265500f7bd394ac32842ea15a9b6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f4ec12421aefe00f5172e1e893f8debec2d20b956db4831765eb2119ba6cbbc7
const $7454710a26b8c5f5$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "propertyKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "propertyValue"
    }, v3 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "propertyKey"
                },
                {
                    "kind": "Variable",
                    "name": "pageId",
                    "variableName": "pageId"
                },
                {
                    "kind": "Variable",
                    "name": "value",
                    "variableName": "propertyValue"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "success"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "concreteType": "ConfluencePageProperty",
        "kind": "LinkedField",
        "name": "pageProperty",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "key"
            },
            {
                "kind": "ScalarField",
                "name": "value"
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "message"
    }, v8 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useUpdateContentPropertyPageCreateMutation",
            "selections": [
                {
                    "concreteType": "ConfluenceMutationApi",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "ConfluenceCreatePagePropertyPayload",
                            "kind": "LinkedField",
                            "name": "createPageProperty",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useUpdateContentPropertyPageCreateMutation",
            "selections": [
                {
                    "concreteType": "ConfluenceMutationApi",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "ConfluenceCreatePagePropertyPayload",
                            "kind": "LinkedField",
                            "name": "createPageProperty",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v5 /*: any*/ 
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "775b265500f7bd394ac32842ea15a9b6",
            "id": "f4ec12421aefe00f5172e1e893f8debec2d20b956db4831765eb2119ba6cbbc7",
            "metadata": {},
            "name": "useUpdateContentPropertyPageCreateMutation",
            "operationKind": "mutation",
            "text": "mutation useUpdateContentPropertyPageCreateMutation($propertyKey:String!,$pageId:ID!,$propertyValue:String!){confluence{createPageProperty(input:{key:$propertyKey,pageId:$pageId,value:$propertyValue}){success,pageProperty{id,key,value},errors{message,extensions{__typename,statusCode,...on BulkMutationErrorExtension{id}}}}}}"
        }
    };
}();
$7454710a26b8c5f5$var$node.hash = "787bb4cf02c8a8364865f8c585f8b1ad";
var $7454710a26b8c5f5$export$2e2bcd8739ae039 = $7454710a26b8c5f5$var$node;
module.exports["default"] = $7454710a26b8c5f5$export$2e2bcd8739ae039;

});

parcelRegister("9U6SN", function(module, exports) {
/**
 * @generated SignedSource<<0e39bd4fcc50a14c02858c2dd6f59efc>>
 * @relayHash f098bfefab69014f9a90b0b0339a4e37
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5195e72d403695f3ff11ad63f280922367586e7f9ba8b44b557f5ce82be03514
const $732eb3191b0a20f1$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v6 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ 
        ],
        "type": "KnownUser"
    }, v9 = {
        "concreteType": "ConfluenceAgent",
        "kind": "LinkedField",
        "name": "agent",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            v7 /*: any*/ ,
            v6 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useContentContributorsDetailsPanelContentCollaboratorsQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "ConfluenceCollaboratorConnection",
                    "kind": "LinkedField",
                    "name": "confluence_contentCollaborators",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceCollaborator",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "person",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v9 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useContentContributorsDetailsPanelContentCollaboratorsQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "ConfluenceCollaboratorConnection",
                    "kind": "LinkedField",
                    "name": "confluence_contentCollaborators",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceCollaborator",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "person",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v9 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "f098bfefab69014f9a90b0b0339a4e37",
            "id": "5195e72d403695f3ff11ad63f280922367586e7f9ba8b44b557f5ce82be03514",
            "metadata": {},
            "name": "useContentContributorsDetailsPanelContentCollaboratorsQuery",
            "operationKind": "query",
            "text": "query useContentContributorsDetailsPanelContentCollaboratorsQuery($cloudId:ID!,$id:ID!,$first:Int!){confluence_contentCollaborators(cloudId:$cloudId,id:$id,first:$first){nodes{person{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId}},agent{displayName,accountId,profilePicture{path}}}}}"
        }
    };
}();
$732eb3191b0a20f1$var$node.hash = "feab7438e52371c4bf16fc7ca78b68fd";
var $732eb3191b0a20f1$export$2e2bcd8739ae039 = $732eb3191b0a20f1$var$node;
module.exports["default"] = $732eb3191b0a20f1$export$2e2bcd8739ae039;

});

parcelRegister("erzVD", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $d0c6da6b618ff535$export$44ec82a0a8c60a0e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "xpRfQ",
    name: "InspectPermissionsDialog",
    loader: async ()=>(await (parcelRequire("6VHB3"))).InspectPermissionsDialog
});
module.exports["InspectPermissionsDialog"] = $d0c6da6b618ff535$export$44ec82a0a8c60a0e;

});

parcelRegister("6VHB3", function(module, exports) {

let $50b9e255a9368fbf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $50b9e255a9368fbf$var$load("gkVge"),
    $50b9e255a9368fbf$var$load("kVHWO"),
    $50b9e255a9368fbf$var$load("amPsT"),
    $50b9e255a9368fbf$var$load("LWh5V"),
    $50b9e255a9368fbf$var$load("c831e"),
    $50b9e255a9368fbf$var$load("30b92"),
    $50b9e255a9368fbf$var$load("l3CW5"),
    $50b9e255a9368fbf$var$load("6dLts"),
    $50b9e255a9368fbf$var$load("jdPbE"),
    $50b9e255a9368fbf$var$load("keazL"),
    $50b9e255a9368fbf$var$load("dhXIT"),
    $50b9e255a9368fbf$var$load("ea3NB"),
    $50b9e255a9368fbf$var$load("6wr18"),
    $50b9e255a9368fbf$var$load("59hV4"),
    $50b9e255a9368fbf$var$load("fuOfV"),
    $50b9e255a9368fbf$var$load("jL1Ke"),
    $50b9e255a9368fbf$var$load("5MQ0D"),
    $50b9e255a9368fbf$var$load("ffEVr"),
    $50b9e255a9368fbf$var$load("5gsbh"),
    $50b9e255a9368fbf$var$load("fwbNS"),
    $50b9e255a9368fbf$var$load("h0X0x"),
    $50b9e255a9368fbf$var$load("7l4Nc"),
    $50b9e255a9368fbf$var$load("h4Nf7"),
    $50b9e255a9368fbf$var$load("Wowvf"),
    $50b9e255a9368fbf$var$load("4g6rd"),
    $50b9e255a9368fbf$var$load("hhss7"),
    $50b9e255a9368fbf$var$load("7EorR"),
    $50b9e255a9368fbf$var$load("85liN")
]).then(()=>parcelRequire('jl66H'));

});

parcelRegister("6UqI3", function(module, exports) {
const $a3c7cd489159fe33$export$28eddf802cd184f7 = (spaceKey)=>{
    return spaceKey?.[0] === '~' ? 'personal' : 'global';
};
module.exports["getSpaceType"] = $a3c7cd489159fe33$export$28eddf802cd184f7;

});

parcelRegister("ePExc", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $ec704748a0115052$export$9542b2119eeb5eb4 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "327gI",
    name: "ShareAndRestrictDialogController",
    loader: async ()=>(await (parcelRequire("awamG"))).Controller
});
module.exports["ShareAndRestrictDialogController"] = $ec704748a0115052$export$9542b2119eeb5eb4;

});

parcelRegister("awamG", function(module, exports) {

let $7a84eece98a9ed78$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $7a84eece98a9ed78$var$load("5iVGR"),
    $7a84eece98a9ed78$var$load("1cQg7"),
    $7a84eece98a9ed78$var$load("6dLts"),
    $7a84eece98a9ed78$var$load("jdPbE"),
    $7a84eece98a9ed78$var$load("6wr18"),
    $7a84eece98a9ed78$var$load("bRqDI"),
    $7a84eece98a9ed78$var$load("2M3d5"),
    $7a84eece98a9ed78$var$load("k55bj"),
    $7a84eece98a9ed78$var$load("7EorR"),
    $7a84eece98a9ed78$var$load("hhss7"),
    $7a84eece98a9ed78$var$load("ffEVr"),
    $7a84eece98a9ed78$var$load("bunf9")
]).then(()=>parcelRequire('4adOe'));

});

parcelRegister("fdPUP", function(module, exports) {
const $73fa77a308d85fef$export$219d516b185caa05 = 'ShareAndRestrictDialog';
const $73fa77a308d85fef$export$da7d900b1da56fbf = 'share-and-restrict-dialog-user-picker-input';
const $73fa77a308d85fef$export$3f89eb51f735e9b3 = [
    'page'
];
const $73fa77a308d85fef$export$b1e4cd5fa4074c7a = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions';
const $73fa77a308d85fef$export$ce504fce6cf8855f = 'https://support.atlassian.com/confluence-cloud/docs/manage-permissions-on-the-page-level/';
module.exports["SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE"] = $73fa77a308d85fef$export$219d516b185caa05;
module.exports["USER_PICKER_INPUT_ID"] = $73fa77a308d85fef$export$da7d900b1da56fbf;
module.exports["ACCESS_LINK_ENROLLED_CONTENT_TYPES"] = $73fa77a308d85fef$export$3f89eb51f735e9b3;
module.exports["SAC_CONTENT_PERMS_MANAGEMENT_DOCUMENTATION"] = $73fa77a308d85fef$export$ce504fce6cf8855f;

});

parcelRegister("3P1RK", function(module, exports) {

var $fHoxN = parcelRequire("fHoxN");

var $4a56ff9e2636e665$export$ad59ff7dc414850a = /*#__PURE__*/ function(SpacePermissionsTabKey) {
    SpacePermissionsTabKey["Groups"] = "groups";
    SpacePermissionsTabKey["Users"] = "users";
    SpacePermissionsTabKey["Guests"] = "guests";
    SpacePermissionsTabKey["AnonymousAccess"] = "anonymous";
    SpacePermissionsTabKey["PublicLinks"] = "public-links";
    SpacePermissionsTabKey["Analytics"] = "analytics";
    SpacePermissionsTabKey["Apps"] = "apps";
    return SpacePermissionsTabKey;
}({});
const $4a56ff9e2636e665$export$d4f1d7ffc41e2d29 = {
    ["groups"]: (0, $fHoxN.PermissionDisplayType).GROUP,
    ["users"]: (0, $fHoxN.PermissionDisplayType).LICENSED_USER,
    ["guests"]: (0, $fHoxN.PermissionDisplayType).GUEST_USER,
    ["anonymous"]: (0, $fHoxN.PermissionDisplayType).ANONYMOUS
};
module.exports["SpacePermissionsTabKey"] = $4a56ff9e2636e665$export$ad59ff7dc414850a;
module.exports["SPACE_PERMISSION_TAB_KEY_PRINCIPAL_MAP"] = $4a56ff9e2636e665$export$d4f1d7ffc41e2d29;

});

parcelRegister("fHoxN", function(module, exports) {
/**
 * @generated SignedSource<<ea3843edd17bea243ec9dc06a44ce09f>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $8a20bb30841ead37$export$f1a726cdbae0d72a = /*#__PURE__*/ function(PermissionDisplayType) {
    PermissionDisplayType["ANONYMOUS"] = "ANONYMOUS";
    PermissionDisplayType["GROUP"] = "GROUP";
    PermissionDisplayType["GUEST_USER"] = "GUEST_USER";
    PermissionDisplayType["LICENSED_USER"] = "LICENSED_USER";
    return PermissionDisplayType;
}({});
var $8a20bb30841ead37$export$a99f5dae9c149910 = /*#__PURE__*/ function(SpacePermissionType) {
    SpacePermissionType["ADMINISTER_SPACE"] = "ADMINISTER_SPACE";
    SpacePermissionType["ARCHIVE_PAGE"] = "ARCHIVE_PAGE";
    SpacePermissionType["ARCHIVE_SPACE"] = "ARCHIVE_SPACE";
    SpacePermissionType["COMMENT"] = "COMMENT";
    SpacePermissionType["CREATE_ATTACHMENT"] = "CREATE_ATTACHMENT";
    SpacePermissionType["CREATE_BLOG"] = "CREATE_BLOG";
    SpacePermissionType["CREATE_EDIT_PAGE"] = "CREATE_EDIT_PAGE";
    SpacePermissionType["DELETE_SPACE"] = "DELETE_SPACE";
    SpacePermissionType["EDIT_BLOG"] = "EDIT_BLOG";
    SpacePermissionType["EDIT_NATIVE_CONTENT"] = "EDIT_NATIVE_CONTENT";
    SpacePermissionType["EXPORT_CONTENT"] = "EXPORT_CONTENT";
    SpacePermissionType["EXPORT_PAGE"] = "EXPORT_PAGE";
    SpacePermissionType["EXPORT_SPACE"] = "EXPORT_SPACE";
    SpacePermissionType["MANAGE_GUEST_USERS"] = "MANAGE_GUEST_USERS";
    SpacePermissionType["MANAGE_NONLICENSED_USERS"] = "MANAGE_NONLICENSED_USERS";
    SpacePermissionType["MANAGE_PUBLIC_LINKS"] = "MANAGE_PUBLIC_LINKS";
    SpacePermissionType["MANAGE_USERS"] = "MANAGE_USERS";
    SpacePermissionType["REMOVE_ATTACHMENT"] = "REMOVE_ATTACHMENT";
    SpacePermissionType["REMOVE_BLOG"] = "REMOVE_BLOG";
    SpacePermissionType["REMOVE_COMMENT"] = "REMOVE_COMMENT";
    SpacePermissionType["REMOVE_MAIL"] = "REMOVE_MAIL";
    SpacePermissionType["REMOVE_OWN_CONTENT"] = "REMOVE_OWN_CONTENT";
    SpacePermissionType["REMOVE_PAGE"] = "REMOVE_PAGE";
    SpacePermissionType["SET_PAGE_PERMISSIONS"] = "SET_PAGE_PERMISSIONS";
    SpacePermissionType["VIEW_SPACE"] = "VIEW_SPACE";
    return SpacePermissionType;
}({});
module.exports["PermissionDisplayType"] = $8a20bb30841ead37$export$f1a726cdbae0d72a;
module.exports["SpacePermissionType"] = $8a20bb30841ead37$export$a99f5dae9c149910;

});

parcelRegister("dcvq8", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $28c0ce898ab65517$export$7bd982897ab56fe5 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "1kdap",
    name: "GlobalFeedbackCollector",
    loader: async ()=>(await (parcelRequire("hEJM3"))).GlobalFeedbackCollector
});

const $28c0ce898ab65517$export$76de8e4d628aac4a = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "7vDuP",
    name: "LazyGlobalFeedbackCollector",
    loader: async ()=>(await (parcelRequire("hEJM3"))).GlobalFeedbackCollector
});
module.exports["GlobalFeedbackCollector"] = $28c0ce898ab65517$export$7bd982897ab56fe5;
module.exports["LazyGlobalFeedbackCollector"] = $28c0ce898ab65517$export$76de8e4d628aac4a;

});

parcelRegister("hEJM3", function(module, exports) {

let $cda9addd653760d9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $cda9addd653760d9$var$load("4nZ85"),
    $cda9addd653760d9$var$load("kHXvF"),
    $cda9addd653760d9$var$load("iWnyc"),
    $cda9addd653760d9$var$load("hhss7"),
    $cda9addd653760d9$var$load("dGk3x")
]).then(()=>parcelRequire('liJpy'));

});

parcelRegister("kqv9Z", function(module, exports) {

var $ctTo0 = parcelRequire("ctTo0");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");

const $99c6e251b2ec7d79$export$cba1c8c35ebe424d = (0, $ctTo0.default);
const $99c6e251b2ec7d79$export$4439c5c8012e5b3c = ({ skip: skip = false } = {})=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $jMyy4.useQueryInterop)($99c6e251b2ec7d79$export$cba1c8c35ebe424d, {
        variables: {
            cloudId: cloudId
        },
        skip: skip,
        __callerPackage__: "access-requests"
    });
    const settings = data?.confluence_accessRequestSettings;
    const spaceEnabled = settings?.spaceAccessRequestSettings?.enabled;
    const contentEnabled = settings?.contentAccessRequestSettings?.enabled;
    const spaceMessageContent = settings?.spaceAccessRequestSettings?.messageContent;
    const contentMessageContent = settings?.contentAccessRequestSettings?.messageContent;
    return {
        spaceEnabled: spaceEnabled,
        contentEnabled: contentEnabled,
        spaceMessageContent: spaceMessageContent,
        contentMessageContent: contentMessageContent,
        loading: loading,
        error: error,
        refetch: refetch
    };
};
module.exports["ACCESS_REQUEST_SETTINGS_QUERY"] = $99c6e251b2ec7d79$export$cba1c8c35ebe424d;
module.exports["useAccessRequestSettings"] = $99c6e251b2ec7d79$export$4439c5c8012e5b3c;

});

parcelRegister("6Skv2", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $i28ZW = parcelRequire("i28ZW");

const $56a1bd181349f72b$export$6f68fdaa2d77a244 = (operations, operation, targetType)=>(operations || []).some((op)=>op?.operation === operation && op?.targetType === targetType);
const $56a1bd181349f72b$export$1f45e3a137b2157c = (space)=>(0, $6mKj3.expVal)('permissions_rbac_dependencies_callsites', 'isEnabled', false) ? (0, $i28ZW.hasSpaceOperation)(space?.operations, (0, $i28ZW.MANAGE_PUBLIC_LINKS)) : Boolean(space?.currentUser?.isAdmin);
const $56a1bd181349f72b$export$818b606ecaafcde3 = (space)=>space ? $56a1bd181349f72b$export$1f45e3a137b2157c(space) : undefined;
module.exports["hasPublicLinksOperation"] = $56a1bd181349f72b$export$6f68fdaa2d77a244;
module.exports["hasManagePublicLinksOperation"] = $56a1bd181349f72b$export$1f45e3a137b2157c;
module.exports["hasManagePublicLinksOperationOrUndefined"] = $56a1bd181349f72b$export$818b606ecaafcde3;

});

parcelRegister("hC6vw", function(module, exports) {
/**
 * @generated SignedSource<<05f748b5a6c8adbf92302798905bd021>>
 * This file was auto-generated by a codemod
 * @see https://go/connie-relay-migration-fyi
 **/ var $d0a960900d3ff81b$export$cb24eb3958583602 = /*#__PURE__*/ function(PublicLinkPageStatus) {
    PublicLinkPageStatus["BLOCKED_BY_ORG"] = "BLOCKED_BY_ORG";
    PublicLinkPageStatus["BLOCKED_BY_PRODUCT"] = "BLOCKED_BY_PRODUCT";
    PublicLinkPageStatus["BLOCKED_BY_SPACE"] = "BLOCKED_BY_SPACE";
    PublicLinkPageStatus["BLOCKED_BY_CONTAINER_POLICY"] = "BLOCKED_BY_CONTAINER_POLICY";
    PublicLinkPageStatus["BLOCKED_BY_CLASSIFICATION_LEVEL"] = "BLOCKED_BY_CLASSIFICATION_LEVEL";
    PublicLinkPageStatus["OFF"] = "OFF";
    PublicLinkPageStatus["ON"] = "ON";
    PublicLinkPageStatus["SITE_BLOCKED"] = "SITE_BLOCKED";
    PublicLinkPageStatus["SITE_DISABLED"] = "SITE_DISABLED";
    PublicLinkPageStatus["SPACE_BLOCKED"] = "SPACE_BLOCKED";
    PublicLinkPageStatus["SPACE_DISABLED"] = "SPACE_DISABLED";
    return PublicLinkPageStatus;
}({});
module.exports["PublicLinkPageStatus"] = $d0a960900d3ff81b$export$cb24eb3958583602;

});

parcelRegister("5izWN", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $e2e3e1973cea2910$export$acd4d92ce9f1584f = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { label: label, color: t1 } = t0;
    const color = t1 === undefined ? "currentColor" : t1;
    const t2 = label || undefined;
    const t3 = label ? "img" : "presentation";
    const t4 = label ? undefined : true;
    let t5;
    if ($[0] !== color) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M11.5885 8.1713C7.8852 6.38061 6.80333 6.11304 5.24293 6.11304C3.41207 6.11304 1.85167 6.87459 0.457716 9.01518L0.228858 9.36509C0.0416106 9.65324 0 9.75616 0 9.87965C0 10.0031 0.0624158 10.1061 0.291274 10.2501L2.64227 11.7115C2.7671 11.7938 2.87113 11.835 2.97515 11.835C3.09999 11.835 3.18321 11.7733 3.30804 11.588L3.68253 11.0117C4.26508 10.1266 4.78521 9.83849 5.45098 9.83849C6.03353 9.83849 6.72011 10.0031 7.57312 10.4148L10.0281 11.5674C10.2778 11.6909 10.5483 11.6292 10.6731 11.341L11.8382 8.78877C11.963 8.50062 11.8798 8.31537 11.5885 8.1713ZM0.790601 3.6637C4.49394 5.45439 5.57581 5.72197 7.13621 5.72197C8.96708 5.72197 10.5275 4.96041 11.9214 2.81982L12.1503 2.46991C12.3375 2.18176 12.3791 2.07884 12.3791 1.95535C12.3791 1.83185 12.3167 1.72894 12.0879 1.58486L9.73687 0.123496C9.61204 0.0411652 9.50801 0 9.40399 0C9.27915 0 9.19593 0.0617478 9.0711 0.246991L8.69661 0.823304C8.11406 1.70836 7.59393 1.99651 6.92816 1.99651C6.34561 1.99651 5.65904 1.83185 4.80602 1.4202L2.351 0.267574C2.10133 0.144078 1.83086 0.205826 1.70603 0.493983L0.540937 3.04623C0.416106 3.33438 0.499327 3.51963 0.790601 3.6637Z",
            fill: color
        });
        $[0] = color;
        $[1] = t5;
    } else t5 = $[1];
    let t6;
    if ($[2] !== t2 || $[3] !== t3 || $[4] !== t4 || $[5] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "16",
            height: "16",
            viewBox: "0 -0.5 13 13",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "aria-label": t2,
            role: t3,
            "aria-hidden": t4
        }, t5);
        $[2] = t2;
        $[3] = t3;
        $[4] = t4;
        $[5] = t5;
        $[6] = t6;
    } else t6 = $[6];
    return t6;
} : ({ label: label, color: color = 'currentColor' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 -0.5 13 13",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation',
        "aria-hidden": label ? undefined : true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M11.5885 8.1713C7.8852 6.38061 6.80333 6.11304 5.24293 6.11304C3.41207 6.11304 1.85167 6.87459 0.457716 9.01518L0.228858 9.36509C0.0416106 9.65324 0 9.75616 0 9.87965C0 10.0031 0.0624158 10.1061 0.291274 10.2501L2.64227 11.7115C2.7671 11.7938 2.87113 11.835 2.97515 11.835C3.09999 11.835 3.18321 11.7733 3.30804 11.588L3.68253 11.0117C4.26508 10.1266 4.78521 9.83849 5.45098 9.83849C6.03353 9.83849 6.72011 10.0031 7.57312 10.4148L10.0281 11.5674C10.2778 11.6909 10.5483 11.6292 10.6731 11.341L11.8382 8.78877C11.963 8.50062 11.8798 8.31537 11.5885 8.1713ZM0.790601 3.6637C4.49394 5.45439 5.57581 5.72197 7.13621 5.72197C8.96708 5.72197 10.5275 4.96041 11.9214 2.81982L12.1503 2.46991C12.3375 2.18176 12.3791 2.07884 12.3791 1.95535C12.3791 1.83185 12.3167 1.72894 12.0879 1.58486L9.73687 0.123496C9.61204 0.0411652 9.50801 0 9.40399 0C9.27915 0 9.19593 0.0617478 9.0711 0.246991L8.69661 0.823304C8.11406 1.70836 7.59393 1.99651 6.92816 1.99651C6.34561 1.99651 5.65904 1.83185 4.80602 1.4202L2.351 0.267574C2.10133 0.144078 1.83086 0.205826 1.70603 0.493983L0.540937 3.04623C0.416106 3.33438 0.499327 3.51963 0.790601 3.6637Z",
        fill: color
    }));
module.exports["ConfluenceLogoIcon"] = $e2e3e1973cea2910$export$acd4d92ce9f1584f;

});

parcelRegister("4Ewfm", function(module, exports) {

var $fg72c = parcelRequire("fg72c");


var $8oEoE = parcelRequire("8oEoE");

const $b2ff9ab7087360b2$export$3b523c26f78a7afe = (principal)=>{
    if (principal.type === 'user') {
        const warning = principal.knownErrors?.accessWarning;
        return warning === 'pending-site-access-warning' || warning === 'pending-userbase-propagation-warning';
    }
    return false;
};
function $b2ff9ab7087360b2$export$9871f41355e50e43({ principals: principals, removals: removals, principalsPendingAccess: principalsPendingAccess, removeAll: removeAll }) {
    if (Array.from(principals.values()).some(({ principal: principal })=>$b2ff9ab7087360b2$export$3b523c26f78a7afe(principal))) return true;
    if (principalsPendingAccess.some(({ principal: { id: id } })=>removals.has(id))) return true;
    if (removeAll && principalsPendingAccess.length > 0) return true;
    return false;
}
function $b2ff9ab7087360b2$export$e84d96463240149a({ generalAccess: generalAccess, principals: principals }) {
    return $b2ff9ab7087360b2$var$getRestrictions({
        generalAccess: generalAccess,
        principals: principals,
        restrictionType: 'mutation-restrictions'
    });
}
function $b2ff9ab7087360b2$export$50e102a305a0ed72({ generalAccess: generalAccess, principals: principals }) {
    const currentRestrictions = $b2ff9ab7087360b2$var$getRestrictions({
        generalAccess: generalAccess,
        principals: principals,
        restrictionType: 'publish-modal-restrictions'
    });
    const read = {
        operation: 'read',
        restrictions: {
            user: {
                results: []
            },
            group: {
                results: []
            }
        }
    };
    const update = {
        operation: 'update',
        restrictions: {
            user: {
                results: []
            },
            group: {
                results: []
            }
        }
    };
    const { publishModalReadRestrictions: publishModalReadRestrictions, publishModalUpdateRestrictions: publishModalUpdateRestrictions } = $b2ff9ab7087360b2$var$convertToPublishModalRestrictions(read, update, currentRestrictions);
    return [
        publishModalReadRestrictions,
        publishModalUpdateRestrictions
    ];
}
function $b2ff9ab7087360b2$export$49bcbf98a41d5666({ generalAccess: generalAccess, principals: principals }) {
    const restrictions = $b2ff9ab7087360b2$var$getRestrictions({
        generalAccess: generalAccess,
        principals: principals,
        restrictionType: 'mutation-restrictions'
    });
    const gqlInput = {
        read: restrictions.read,
        update: restrictions.update
    };
    gqlInput.restrictionState = (0, $fg72c.generalAccessLevelToMode)(generalAccess);
    gqlInput.permissions = $b2ff9ab7087360b2$var$buildPermissionsFromPrincipals(principals, generalAccess);
    return gqlInput;
}
/**
 * Builds the flat permissions array format (view/edit) from the principals map.
 * This is the new format used by the permissions + restrictionState fields on ConfluenceContentInput.
 *
 * Unlike the old restrictions format (read/update with separate user/group arrays),
 * this produces flat arrays of { id, type } objects for view and edit.
 */ function $b2ff9ab7087360b2$var$buildPermissionsFromPrincipals(principals, _generalAccess) {
    const viewList = [];
    const editList = [];
    for (const [_, value] of principals){
        const { role: role, principal: principal } = value;
        const principalType = principal.type === 'user' ? 'USER' : 'GROUP';
        // Add can-view principals to view list
        if (role === 'can-view') viewList.push({
            id: principal.id,
            type: principalType
        });
        // Add can-edit principals to edit list only
        if (role === 'can-edit') editList.push({
            id: principal.id,
            type: principalType
        });
    }
    return {
        view: viewList,
        edit: editList
    };
}
/**
 * Generates restrictions based on the general access level, the provided principals map and restrictionType.
 */ function $b2ff9ab7087360b2$var$getRestrictions({ generalAccess: generalAccess, principals: principals, restrictionType: restrictionType }) {
    switch(generalAccess){
        case 'restricted':
            return {
                read: $b2ff9ab7087360b2$var$getReadList(principals, restrictionType),
                update: $b2ff9ab7087360b2$var$getUpdateList(principals, restrictionType)
            };
        case 'open-can-view':
            return {
                read: {
                    group: [],
                    user: []
                },
                update: $b2ff9ab7087360b2$var$getUpdateList(principals, restrictionType)
            };
        default:
            return {
                read: {
                    group: [],
                    user: []
                },
                update: {
                    group: [],
                    user: []
                }
            };
    }
}
/**
 * Converts the current state to publish modal restrictions by transforming user and group lists.
 *
 * @param {ContentRestriction} read - The read restrictions content.
 * @param {ContentRestriction} update - The update restrictions content.
 * @param {PageRestrictionsInput} currentRestrictions - The current restrictions input.
 * @returns {{ publishModalReadRestrictions: ContentRestriction, publishModalUpdateRestrictions: ContentRestriction }} The transformed publish modal restrictions.
 */ function $b2ff9ab7087360b2$var$convertToPublishModalRestrictions(read, update, currentRestrictions) {
    const { restrictions: { user: { results: readUserList }, group: { results: readGroupList } } } = read;
    const { restrictions: { user: { results: updateUserList }, group: { results: updateGroupList } } } = update;
    const { read: currentReadList, update: currentUpdateList } = currentRestrictions;
    $b2ff9ab7087360b2$var$pushTransformedUser(readUserList, currentReadList.user);
    $b2ff9ab7087360b2$var$pushTransformedUser(updateUserList, currentUpdateList.user);
    $b2ff9ab7087360b2$var$pushTransformedGroup(readGroupList, currentReadList.group);
    $b2ff9ab7087360b2$var$pushTransformedGroup(updateGroupList, currentUpdateList.group);
    return {
        publishModalReadRestrictions: read,
        publishModalUpdateRestrictions: update
    };
}
/**
 * Transforms and adds user restrictions to the publish modal user list.
 */ function $b2ff9ab7087360b2$var$pushTransformedUser(list, users) {
    for (const user of users){
        if (!user) continue;
        list.push({
            ...user,
            type: 'known',
            // instead of type: 'user'
            publicName: user.displayName,
            isExternalCollaborator: false
        });
    }
}
/**
 * Transforms and adds group restrictions to the publish modal group list.
 */ function $b2ff9ab7087360b2$var$pushTransformedGroup(list, groups) {
    for (const group of groups){
        if (!group) continue;
        list.push(group);
    }
}
const $b2ff9ab7087360b2$var$getUsageType = (principal)=>{
    if ((principal.type === 'group' || principal.type === 'team') && 'usageType' in principal && principal.usageType) return principal.usageType;
    if (principal.type === 'group') return (0, $8oEoE.ConfluenceGroupUsageType).USERBASE_GROUP;
    if (principal.type === 'team') return (0, $8oEoE.ConfluenceGroupUsageType).TEAM_COLLABORATION;
};
/**
 * Generates a list of principals with 'can-edit' access for the update list.
 */ function $b2ff9ab7087360b2$var$getUpdateList(principals, restrictionType) {
    const groupList = [];
    const userList = [];
    for (const [_, value] of principals){
        const { role: role, principal: principal } = value;
        const validGroupType = principal.type === 'group' || principal.type === 'team';
        if (validGroupType && role === 'can-edit') groupList.push({
            id: principal.id,
            name: principal.name,
            ...restrictionType === 'publish-modal-restrictions' && {
                type: 'group'
            },
            ...restrictionType === 'publish-modal-restrictions' && {
                usageType: $b2ff9ab7087360b2$var$getUsageType(principal)
            }
        });
        if (principal.type === 'user' && role === 'can-edit') userList.push({
            ...restrictionType === 'mutation-restrictions' && {
                id: principal.id
            },
            ...restrictionType === 'publish-modal-restrictions' && {
                type: 'user',
                accountId: principal.id,
                displayName: principal.name,
                profilePicture: {
                    path: principal.avatarUrl
                },
                email: principal.email
            }
        });
    }
    return {
        group: groupList,
        user: userList
    };
}
/**
 * Generates a list of principals with 'can-view' access for the read list.
 */ function $b2ff9ab7087360b2$var$getReadList(principals, restrictionType) {
    const groupList = [];
    const userList = [];
    for (const [_, value] of principals){
        const { role: role, principal: principal } = value;
        const validGroupType = principal.type === 'group' || principal.type === 'team';
        if (validGroupType && (role === 'can-view' || role === 'can-edit')) groupList.push({
            id: principal.id,
            name: principal.name,
            ...restrictionType === 'publish-modal-restrictions' && {
                type: 'group'
            },
            ...restrictionType === 'publish-modal-restrictions' && {
                usageType: $b2ff9ab7087360b2$var$getUsageType(principal)
            }
        });
        if (principal.type === 'user' && (role === 'can-view' || role === 'can-edit')) userList.push({
            ...restrictionType === 'mutation-restrictions' && {
                id: principal.id
            },
            ...restrictionType === 'publish-modal-restrictions' && {
                type: 'user',
                accountId: principal.id,
                displayName: principal.name,
                profilePicture: {
                    path: principal.avatarUrl
                },
                email: principal.email
            }
        });
    }
    return {
        group: groupList,
        user: userList
    };
}
module.exports["isUserPendingAccess"] = $b2ff9ab7087360b2$export$3b523c26f78a7afe;
module.exports["shouldMutationIncludeInvites"] = $b2ff9ab7087360b2$export$9871f41355e50e43;
module.exports["getRestrictionsForMutation"] = $b2ff9ab7087360b2$export$e84d96463240149a;
module.exports["getRestrictionsForPublishModal"] = $b2ff9ab7087360b2$export$50e102a305a0ed72;
module.exports["getGqlRestrictionsInputForPublishModal"] = $b2ff9ab7087360b2$export$49bcbf98a41d5666;

});

parcelRegister("fg72c", function(module, exports) {
const $06bae8500a7e571b$export$406c89e51172952a = {
    restricted: 'VIEW_RESTRICTED',
    'open-can-view': 'EDIT_RESTRICTED',
    'open-can-edit': 'OPEN'
};
const $06bae8500a7e571b$export$3e8e3eee6dfccab0 = (level)=>$06bae8500a7e571b$export$406c89e51172952a[level];
module.exports["generalAccessLevelToMode"] = $06bae8500a7e571b$export$3e8e3eee6dfccab0;

});

parcelRegister("8oEoE", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $0f8a7127f2228c42$export$e7c9280c9da1cc0a = /*#__PURE__*/ function(ConfluenceGroupUsageType) {
    ConfluenceGroupUsageType["ADMIN_OVERSIGHT"] = "ADMIN_OVERSIGHT";
    ConfluenceGroupUsageType["TEAM_COLLABORATION"] = "TEAM_COLLABORATION";
    ConfluenceGroupUsageType["USERBASE_GROUP"] = "USERBASE_GROUP";
    return ConfluenceGroupUsageType;
}({});
var $0f8a7127f2228c42$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["ConfluenceGroupUsageType"] = $0f8a7127f2228c42$export$e7c9280c9da1cc0a;

});

parcelRegister("7QoAs", function(module, exports) {
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports

var $c0rhi = parcelRequire("c0rhi");


var $d9tcB = parcelRequire("d9tcB");


var $fdPUP = parcelRequire("fdPUP");


var $4Ewfm = parcelRequire("4Ewfm");


var $22cFL = parcelRequire("22cFL");


var $jI7Td = parcelRequire("jI7Td");

const $164b2844d962585d$var$blockedAccessUsersLimit = 10;
const $164b2844d962585d$var$blockedAccessLevelsLimit = 10;
const $164b2844d962585d$export$4da22e4767045266 = async ({ contentId: contentId, cloudId: cloudId, edition: edition, numberOfAncestors: numberOfAncestors, addMode: addMode, stagedUserPrincipals: stagedUserPrincipals, setMasterState: setMasterState, fireAnalyticEvent: fireAnalyticEvent })=>{
    //The validation  is skipped if free edition
    if (edition == (0, $d9tcB.ConfluenceEdition).FREE) return {
        showWarnRestrictionsDialog: false,
        showResolveRestrictionsDialog: false
    };
    const activeStagedUserPrincipals = stagedUserPrincipals.filter((user)=>!(0, $4Ewfm.isUserPendingAccess)({
            type: 'user',
            ...user
        }));
    //The validation  is skipped if staged user count is 0
    if (activeStagedUserPrincipals.length == 0) return {
        showWarnRestrictionsDialog: false,
        showResolveRestrictionsDialog: false
    };
    // if staged user count is greater than 10,
    // or content is more than 10 levels deep
    if (activeStagedUserPrincipals.length > $164b2844d962585d$var$blockedAccessUsersLimit || numberOfAncestors > $164b2844d962585d$var$blockedAccessLevelsLimit) {
        fireAnalyticEvent({
            eventType: 'sendOperationalEvent',
            action: 'BlockedAccessCheckLimitExceeded',
            actionSubject: 'BlockedAccessCheck',
            source: (0, $fdPUP.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
            attributes: {
                NewUsersCount: activeStagedUserPrincipals.length,
                numberOfAncestors: numberOfAncestors
            }
        });
        const accountIds = activeStagedUserPrincipals.map((user)=>{
            return user.id;
        });
        const { data: usersContentAccessData, error: usersContentAccessError } = await (0, $c0rhi.queryInterop)({
            query: (0, $jI7Td.default),
            variables: {
                accessType: addMode == 'as-editor' ? 'EDIT' : 'VIEW',
                accountIds: accountIds,
                cloudId: cloudId,
                contentId: contentId
            },
            fetchPolicy: 'network-only',
            __callerPackage__: "share-and-restrict-dialog"
        });
        if (usersContentAccessError) {
            fireAnalyticEvent({
                eventType: 'sendOperationalEvent',
                action: 'errored',
                actionSubject: 'UsersContentAccessQuery',
                actionSubjectId: 'validateRestrictedPrincipals',
                attributes: {
                    message: usersContentAccessError.message
                }
            });
            return {
                showWarnRestrictionsDialog: false,
                showResolveRestrictionsDialog: false
            };
        }
        const canNotAccessList = usersContentAccessData?.confluence_userContentAccess?.cannotAccessList;
        if (canNotAccessList != null && canNotAccessList.length > 0) {
            const restrictedUserPrincipalsList = canNotAccessList.map((userId)=>{
                const restrictedPrincipal = {
                    userPrincipal: activeStagedUserPrincipals.find((val)=>val.id === userId),
                    restrictedResources: null
                };
                return restrictedPrincipal;
            });
            setMasterState((s)=>({
                    ...s,
                    restrictedUserPrincipals: restrictedUserPrincipalsList
                }));
            return {
                showWarnRestrictionsDialog: true,
                showResolveRestrictionsDialog: false
            };
        }
    } else {
        const blockedAccessSubjects = activeStagedUserPrincipals.map((user)=>{
            const blockedAccessSubject = {
                subjectId: user.id,
                subjectType: 'USER'
            };
            return blockedAccessSubject;
        });
        const { data: data, error: error } = await (0, $c0rhi.queryInterop)({
            query: (0, $22cFL.default),
            variables: {
                // The GraphQL query expects a number, but contentId is a string. For the relay migration we will type it as any to not break existing functionality,
                // but this should be fixed in the future and keep the types consistent.
                contentId: contentId,
                accessType: addMode == 'as-editor' ? 'EDIT' : 'VIEW',
                subjects: blockedAccessSubjects
            },
            fetchPolicy: 'network-only',
            __callerPackage__: "share-and-restrict-dialog"
        });
        if (error) fireAnalyticEvent({
            eventType: 'sendOperationalEvent',
            action: 'errored',
            actionSubject: 'BlockedAccessRestrictionsQuery',
            actionSubjectId: 'validateRestrictedPrincipals',
            attributes: {
                message: error?.message
            }
        });
        const blockedAccessRestrictions = data?.blockedAccessRestrictions;
        const blockedAccessRestrictionSummary = blockedAccessRestrictions?.blockedAccessRestrictionSummary;
        if (blockedAccessRestrictions && blockedAccessRestrictionSummary && blockedAccessRestrictionSummary.length > 0) {
            const restrictedUserPrincipalsList = blockedAccessRestrictionSummary.map((restrictedUser)=>{
                const restrictedPrincipal = {
                    userPrincipal: activeStagedUserPrincipals.find((val)=>val.id === restrictedUser?.subject?.subjectId),
                    restrictedResources: restrictedUser?.restrictedResources
                };
                return restrictedPrincipal;
            });
            const assignableSpaceRolesIntersection = blockedAccessRestrictions.blockedAccessAssignableSpaceRolesIntersection;
            setMasterState((s)=>({
                    ...s,
                    restrictedUserPrincipals: restrictedUserPrincipalsList,
                    assignableSpaceRolesIntersection: assignableSpaceRolesIntersection
                }));
            //current user is not empowered to fix at least one of the selected user's restrictions
            if (!blockedAccessRestrictions.canFixRestrictionsForAllSubjects) return {
                showWarnRestrictionsDialog: true,
                showResolveRestrictionsDialog: false
            };
            return {
                showWarnRestrictionsDialog: false,
                showResolveRestrictionsDialog: true,
                // Expose this extra info for Realtime requests to consume
                // In USD these get set directly on the masterState
                // But realtime requests don't have access to masterState
                restrictedUserPrincipals: restrictedUserPrincipalsList,
                assignableSpaceRolesIntersection: assignableSpaceRolesIntersection
            };
        }
    }
    // all added principles can access or blocked access was skipped
    return {
        showWarnRestrictionsDialog: false,
        showResolveRestrictionsDialog: false
    };
};
module.exports["validateRestrictedPrincipals"] = $164b2844d962585d$export$4da22e4767045266;

});

parcelRegister("22cFL", function(module, exports) {
/**
 * @generated SignedSource<<75c554d8ad4e342d8666c6b62aee9b86>>
 * @relayHash 0823488049ea540f2c3f5c4cb3a9f517
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e32f72b766dc4dbdcd33139b587c228b30663d8a6a179388fcc7ec57c1ddfaed
const $855873b1252722a0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accessType"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "subjects"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "subjectId"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "accessType",
                    "variableName": "accessType"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "subjects",
                    "variableName": "subjects"
                }
            ],
            "concreteType": "BlockedAccessRestrictions",
            "kind": "LinkedField",
            "name": "blockedAccessRestrictions",
            "plural": false,
            "selections": [
                {
                    "concreteType": "SubjectRestrictionHierarchySummary",
                    "kind": "LinkedField",
                    "name": "blockedAccessRestrictionSummary",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "BlockedAccessSubject",
                            "kind": "LinkedField",
                            "name": "subject",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "subjectType"
                                }
                            ]
                        },
                        {
                            "concreteType": "RestrictedResource",
                            "kind": "LinkedField",
                            "name": "restrictedResources",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "resourceId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resourceTitle"
                                },
                                {
                                    "concreteType": "RestrictedResourceLinks",
                                    "kind": "LinkedField",
                                    "name": "resourceLink",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "base"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "webUi"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "requiredAccessType"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resourceType"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "BlockedAccessEmpowerment",
                    "kind": "LinkedField",
                    "name": "blockedAccessEmpowerment",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "isCurrentUserEmpowered"
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceBlockedAccessAssignableSpaceRole",
                    "kind": "LinkedField",
                    "name": "blockedAccessAssignableSpaceRolesIntersection",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "roleId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "roleDescription"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "roleName"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "roleType"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "canFixRestrictionsForAllSubjects"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "BlockedAccessRestrictionsQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "BlockedAccessRestrictionsQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "0823488049ea540f2c3f5c4cb3a9f517",
            "id": "e32f72b766dc4dbdcd33139b587c228b30663d8a6a179388fcc7ec57c1ddfaed",
            "metadata": {},
            "name": "BlockedAccessRestrictionsQuery",
            "operationKind": "query",
            "text": "query BlockedAccessRestrictionsQuery($accessType:ResourceAccessType!,$contentId:Long!,$subjects:[BlockedAccessSubjectInput]!){blockedAccessRestrictions(accessType:$accessType,contentId:$contentId,subjects:$subjects){blockedAccessRestrictionSummary{subject{subjectId,subjectType},restrictedResources{resourceId,resourceTitle,resourceLink{base,webUi},requiredAccessType,resourceType}},blockedAccessEmpowerment{subjectId,isCurrentUserEmpowered},blockedAccessAssignableSpaceRolesIntersection{roleId,roleDescription,roleName,roleType},canFixRestrictionsForAllSubjects}}"
        }
    };
}();
$855873b1252722a0$var$node.hash = "cc9731fa07afd21d30e45e70eeb338f4";
var $855873b1252722a0$export$2e2bcd8739ae039 = $855873b1252722a0$var$node;
module.exports["default"] = $855873b1252722a0$export$2e2bcd8739ae039;

});

parcelRegister("jI7Td", function(module, exports) {
/**
 * @generated SignedSource<<bc99a62c4eb8102fc854786a36828b06>>
 * @relayHash 727771f625528321882e822398d219fd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e7c474d1f3ca6df3ee1f24f128085a09a26f1796477554de890782e7d51f18e9
const $b86f4f4db61ac40f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accessType"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountIds"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "accessType",
                    "variableName": "accessType"
                },
                {
                    "kind": "Variable",
                    "name": "accountIds",
                    "variableName": "accountIds"
                },
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ConfluenceUserContentAccessResult",
            "kind": "LinkedField",
            "name": "confluence_userContentAccess",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "canAccessList"
                },
                {
                    "kind": "ScalarField",
                    "name": "cannotAccessList"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "UsersContentAccessQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "UsersContentAccessQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "727771f625528321882e822398d219fd",
            "id": "e7c474d1f3ca6df3ee1f24f128085a09a26f1796477554de890782e7d51f18e9",
            "metadata": {},
            "name": "UsersContentAccessQuery",
            "operationKind": "query",
            "text": "query UsersContentAccessQuery($accessType:ResourceAccessType!,$accountIds:[String]!,$cloudId:ID!,$contentId:ID!){confluence_userContentAccess(accessType:$accessType,accountIds:$accountIds,cloudId:$cloudId,contentId:$contentId){canAccessList,cannotAccessList}}"
        }
    };
}();
$b86f4f4db61ac40f$var$node.hash = "3af84917efe0ce91f68b18f96d2f126c";
var $b86f4f4db61ac40f$export$2e2bcd8739ae039 = $b86f4f4db61ac40f$var$node;
module.exports["default"] = $b86f4f4db61ac40f$export$2e2bcd8739ae039;

});

parcelRegister("f2UnK", function(module, exports) {

var $8NGcs = parcelRequire("8NGcs");


var $dYU3e = parcelRequire("dYU3e");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $0ac8a6fa9069d7d8$var$preloadSpaceRoleModeQuery = (0, $8NGcs.default);
const $0ac8a6fa9069d7d8$export$5174d1e945d5fe4d = (cloudId)=>{
    return (0, $dYU3e.query)({
        query: $0ac8a6fa9069d7d8$var$preloadSpaceRoleModeQuery,
        variables: {
            cloudId: cloudId
        },
        fetchPolicy: 'cache-first',
        __callerPackage__: "share-and-restrict-dialog"
    }).then(({ data: data, hasErrors: hasErrors })=>{
        if (hasErrors) // Handle errors silently for preloading
        return null;
        return data?.confluence_spaceRoleMode || null;
    }).catch((error)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        return null;
    });
};
const $0ac8a6fa9069d7d8$export$c715e7f8018f9029 = async (cloudId)=>{
    await $0ac8a6fa9069d7d8$export$5174d1e945d5fe4d(cloudId);
};
module.exports["preloadSpaceRoleMode"] = $0ac8a6fa9069d7d8$export$c715e7f8018f9029;

});

parcelRegister("8NGcs", function(module, exports) {
/**
 * @generated SignedSource<<bbbcf040ac95e90832074d5908ee571b>>
 * @relayHash 4c198432b204cbcb18fb5160733adf98
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cd62fad16e429cace180371436855ef292c31e1ca910185b179fd16e1c7852d4
const $556eda7e15abe5d2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ScalarField",
            "name": "confluence_spaceRoleMode"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadSpaceRoleModeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadSpaceRoleModeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "4c198432b204cbcb18fb5160733adf98",
            "id": "cd62fad16e429cace180371436855ef292c31e1ca910185b179fd16e1c7852d4",
            "metadata": {},
            "name": "preloadSpaceRoleModeQuery",
            "operationKind": "query",
            "text": "query preloadSpaceRoleModeQuery($cloudId:ID!){confluence_spaceRoleMode(cloudId:$cloudId)}"
        }
    };
}();
$556eda7e15abe5d2$var$node.hash = "1b6118c2bdcdd04e86f799370c9c7bca";
var $556eda7e15abe5d2$export$2e2bcd8739ae039 = $556eda7e15abe5d2$var$node;
module.exports["default"] = $556eda7e15abe5d2$export$2e2bcd8739ae039;

});

parcelRegister("gabmL", function(module, exports) {

var $9eNhQ = parcelRequire("9eNhQ");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $bQm3c = parcelRequire("bQm3c");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $euL71 = parcelRequire("euL71");


var $jMyy4 = parcelRequire("jMyy4");


var $6mKj3 = parcelRequire("6mKj3");


var $hC6vw = parcelRequire("hC6vw");


var $1X7PR = parcelRequire("1X7PR");


var $bgRei = parcelRequire("bgRei");

const $b34fb09a67265b07$var$KNOWN_ERROR_MESSAGES = [
    'This is a Standard/Premium feature. You are currently subscribed to the Free plan.',
    'Anonymous access is not permitted'
];
const $b34fb09a67265b07$var$i18n = (0, $kSwu1.defineMessages)({
    publicLinkUrlPathError: {
        id: "public-links.usePublicLinkDataProvider.sharePathError.message",
        defaultMessage: "publicLinkStatus was ON, but no publicLinkUrlPath was provided"
    }
});
const $b34fb09a67265b07$var$computeData = (pageData, contentData, permissionsData, isPublicLinkStatusOnForContent, enrolledContentTypes, edition)=>{
    // Are Public Links allowed for this content type
    const isPublicLinkAllowedForContentType = !contentData.error && contentData.data !== undefined && enrolledContentTypes.includes(contentData.data.contentType);
    // Are Editable Public Links allowed for this content type
    const isPublicLinkEditAllowedForContentType = isPublicLinkAllowedForContentType && (edition === (0, $euL71.ConfluenceEdition).PREMIUM || (0, $6mKj3.expVal)('shareable_links_m0', 'isEnabled', false)) && contentData.data?.contentType === 'whiteboard';
    // Can current user edit Public Link status
    const baseCanEditPublicLink = !contentData.error && contentData.data?.canEditPublicLink === true;
    const canUpdateOrDeletePublicLink = !contentData.error && (contentData.data?.canUpdatePublicLink === true || contentData.data?.canDeletePublicLink === true);
    // Render-time call to ensure the experiment exposure is tracked even when baseCanEditPublicLink short-circuits the next clause.
    (0, $6mKj3.expVal)('permissions_rbac_dependencies_callsites', 'isEnabled', false);
    const isWhiteboardWithoutM0 = contentData.data?.contentType === 'whiteboard' && !(0, $6mKj3.expVal)('shareable_links_m0', 'isEnabled', false);
    const canEditPublicLink = baseCanEditPublicLink && (!isPublicLinkStatusOnForContent || canUpdateOrDeletePublicLink || !(0, $6mKj3.expVal)('permissions_rbac_dependencies_callsites', 'isEnabled', false) || // When shareable_links_m0 is off for whiteboards, canUpdateOrDeletePublicLink operations
    // may not be available (the public_link RBAC operations are part of the m0 permissions
    // model). In this case, fall back to baseCanEditPublicLink only.
    isWhiteboardWithoutM0);
    // Value for if the Public Link has edit permissions i.e. Editable Public Whiteboards
    const isEditPublicLink = !!(!permissionsData.error && permissionsData.data?.hasEditPermission);
    // Are Public Links enabled by admins at Site and Space levels
    const isPublicLinkAdminEnabled = isPublicLinkStatusOnForContent || !pageData.error && pageData.data?.pageStatus === (0, $hC6vw.PublicLinkPageStatus).OFF;
    // Is Public Link allowed for content type, admin enabled, and status ON
    const isPublicLinkFullyEnabled = isPublicLinkStatusOnForContent && isPublicLinkAdminEnabled && isPublicLinkAllowedForContentType;
    const refetch = (dataToFetch = 'all')=>{
        // if dataToFetch !== permission, it means it's either all or public-link
        if (dataToFetch !== 'permission') {
            pageData.refetch();
            contentData.refetch?.();
        }
        // if dataToFetch !== public-link, it means it's either all or permission
        if (dataToFetch !== 'public-link') isPublicLinkEditAllowedForContentType && permissionsData.refetch();
    };
    return {
        isPublicLinkAdminEnabled: isPublicLinkAdminEnabled,
        isPublicLinkFullyEnabled: isPublicLinkFullyEnabled,
        isPublicLinkAllowedForContentType: isPublicLinkAllowedForContentType,
        isPublicLinkEditAllowedForContentType: isPublicLinkEditAllowedForContentType,
        isEditPublicLink: isEditPublicLink,
        canEditPublicLink: canEditPublicLink,
        publicLinkStatus: pageData.data?.pageStatus,
        publicLinkSharePath: pageData.data?.publicLinkUrlPath,
        refetch: refetch
    };
};
const $b34fb09a67265b07$export$4725159de576f61f = (props)=>{
    const publicLinkData = $b34fb09a67265b07$export$b7ccc28cc819be23({
        pageId: props.contentId,
        ...props
    });
    return publicLinkData.isLoading ? {
        isPublicLinkFullyEnabled: false,
        isPublicLinkAdminEnabled: false,
        isPublicLinkAllowedForContentType: false,
        isPublicLinkEditAllowedForContentType: false,
        canEditPublicLink: false,
        publicLinkStatus: undefined,
        publicLinkSharePath: undefined,
        isEditPublicLink: false,
        refetch: ()=>{},
        ...publicLinkData
    } : publicLinkData;
};
const $b34fb09a67265b07$export$b7ccc28cc819be23 = (props)=>{
    const enrolledContentTypes = [
        'page',
        'whiteboard'
    ];
    const intl = (0, $kSwu1.useIntl)();
    const { isLicensed: isLicensed, edition: edition } = (0, $bQm3c.useSessionData)();
    let contentData = (0, $1X7PR.usePublicLinkContentQuery)({
        contentId: props.pageId,
        skip: props.contentQueryProps?.skip
    });
    const contentType = props.contentQueryProps?.skip ? props.contentQueryProps?.contentType : contentData?.data?.contentType;
    contentData = {
        ...contentData,
        data: {
            ...contentData?.data,
            canEditPublicLink: contentData?.data?.canEditPublicLink ?? false,
            canUpdatePublicLink: contentData?.data?.canUpdatePublicLink ?? false,
            canDeletePublicLink: contentData?.data?.canDeletePublicLink ?? false,
            contentType: contentType ?? ''
        }
    };
    const shouldSkip = props.skip || !enrolledContentTypes.includes(contentData?.data?.contentType || '') || !isLicensed || edition === (0, $euL71.ConfluenceEdition).FREE;
    const rawPageData = (0, $jMyy4.useQueryInterop)((0, $9eNhQ.default), {
        variables: {
            pageId: props.pageId
        },
        fetchPolicy: props.fetchPolicy,
        skip: shouldSkip,
        __callerPackage__: "public-links"
    });
    const permissionsData = (0, $bgRei.usePublicLinkPermissionsForObject)({
        objectId: props.pageId,
        skip: shouldSkip || edition !== (0, $euL71.ConfluenceEdition).PREMIUM && !(0, $6mKj3.expVal)('shareable_links_m0', 'isEnabled', false) || contentData?.data?.contentType !== 'whiteboard'
    });
    const pageData = (0, $cozmU.useMemo)(()=>({
            isLoading: rawPageData.loading,
            data: rawPageData.data?.publicLinkPage,
            error: rawPageData.error,
            refetch: rawPageData.refetch
        }), [
        rawPageData.loading,
        rawPageData.data,
        rawPageData.error,
        rawPageData.refetch
    ]);
    if ((0, $1uFM6.isUnauthorizedError)(rawPageData.error) || // We currently aren't being given error types by the backend.
    // When we do, we can better parse these expected errors.
    // https://product-fabric.atlassian.net/browse/CPE-1991
    $b34fb09a67265b07$var$KNOWN_ERROR_MESSAGES.some((msg)=>rawPageData.error?.message?.includes(msg))) (0, $7Sm4c.markErrorAsHandled)(rawPageData.error);
    // Is Public Link Status for page ON
    const isPublicLinkStatusOnForContent = !pageData.error && pageData.data?.pageStatus === (0, $hC6vw.PublicLinkPageStatus).ON;
    const loading = pageData.isLoading || contentData.isLoading || permissionsData.isLoading;
    const errors = (0, $cozmU.useMemo)(()=>[
            pageData,
            contentData,
            permissionsData
        ].map((query)=>!query.isLoading && query.error).filter((err)=>Boolean(err)), [
        pageData,
        contentData,
        permissionsData
    ]);
    if (isPublicLinkStatusOnForContent && pageData.data?.publicLinkUrlPath === null) errors.push(new Error(intl.formatMessage($b34fb09a67265b07$var$i18n.publicLinkUrlPathError)));
    return loading ? {
        isLoading: true,
        errors: errors
    } : {
        isLoading: false,
        errors: errors,
        ...$b34fb09a67265b07$var$computeData(pageData, contentData, permissionsData, isPublicLinkStatusOnForContent, enrolledContentTypes, edition)
    };
};
const $b34fb09a67265b07$export$b86a4cadf4c50ae1 = ({ contentId: contentId, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children($b34fb09a67265b07$export$b7ccc28cc819be23({
        pageId: contentId
    })));
module.exports["usePublicLinkData"] = $b34fb09a67265b07$export$4725159de576f61f;
module.exports["usePublicLinkPageDataProvider"] = $b34fb09a67265b07$export$b7ccc28cc819be23;

});

parcelRegister("9eNhQ", function(module, exports) {
/**
 * @generated SignedSource<<f3ce31061615fe76b947269deb5d6c75>>
 * @relayHash 3f5a736f4dd660a89b02a4452e465d11
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d041a328d30295536c08edf8e81645ba3b1dcbd7e16c6e2d0e375aa0b48fc184
const $858700f9e1edfc48$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "pageId",
                    "variableName": "pageId"
                }
            ],
            "concreteType": "PublicLinkPage",
            "kind": "LinkedField",
            "name": "publicLinkPage",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "pageId"
                },
                {
                    "kind": "ScalarField",
                    "name": "pageStatus"
                },
                {
                    "kind": "ScalarField",
                    "name": "publicLinkUrlPath"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePublicLinkPageDataProviderPublicLinkPageQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePublicLinkPageDataProviderPublicLinkPageQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "3f5a736f4dd660a89b02a4452e465d11",
            "id": "d041a328d30295536c08edf8e81645ba3b1dcbd7e16c6e2d0e375aa0b48fc184",
            "metadata": {},
            "name": "usePublicLinkPageDataProviderPublicLinkPageQuery",
            "operationKind": "query",
            "text": "query usePublicLinkPageDataProviderPublicLinkPageQuery($pageId:ID!){publicLinkPage(pageId:$pageId){pageId,pageStatus,publicLinkUrlPath}}"
        }
    };
}();
$858700f9e1edfc48$var$node.hash = "c030204610be720b223484d4a8d871cf";
var $858700f9e1edfc48$export$2e2bcd8739ae039 = $858700f9e1edfc48$var$node;
module.exports["default"] = $858700f9e1edfc48$export$2e2bcd8739ae039;

});

parcelRegister("1X7PR", function(module, exports) {

var $OoVEI = parcelRequire("OoVEI");


var $cozmU = parcelRequire("cozmU");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $cLo2u = parcelRequire("cLo2u");


var $foQ4a = parcelRequire("foQ4a");


var $jMyy4 = parcelRequire("jMyy4");


var $6mKj3 = parcelRequire("6mKj3");


var $6Skv2 = parcelRequire("6Skv2");

const $3e0fb5c21944a86f$var$computeData = (data, isExternalCollaborator)=>{
    const contentType = data?.content?.nodes?.[0]?.type || '';
    const operations = data?.content?.nodes?.[0]?.operations || [];
    const hasManagePublicLinksPermission = Boolean(data?.space?.currentUser?.isAdmin);
    const canEditContent = (0, $6Skv2.hasPublicLinksOperation)(operations, 'update', contentType);
    const canCreatePublicLink = (0, $6Skv2.hasPublicLinksOperation)(operations, 'create_public_link', contentType);
    const canUpdatePublicLink = (0, $6Skv2.hasPublicLinksOperation)(operations, 'update', 'public_link');
    const canDeletePublicLink = (0, $6Skv2.hasPublicLinksOperation)(operations, 'delete', 'public_link');
    const canEditPublicLink = (0, $6mKj3.expVal)('permissions_rbac_dependencies_callsites', 'isEnabled', false) ? canCreatePublicLink && !isExternalCollaborator : (hasManagePublicLinksPermission || canEditContent) && !isExternalCollaborator;
    return {
        contentType: contentType,
        canEditPublicLink: canEditPublicLink,
        canUpdatePublicLink: canUpdatePublicLink,
        canDeletePublicLink: canDeletePublicLink
    };
};
const $3e0fb5c21944a86f$export$13a7a098bd5c2599 = (props)=>{
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    const { isExternalCollaborator: isExternalCollaborator } = (0, $foQ4a.useIsExternalCollaborator)();
    const { loading: loading, data: data, error: error, refetch: refetch } = (0, $jMyy4.useQueryInterop)((0, $OoVEI.default), {
        skip: props.skip,
        variables: {
            contentId: props.contentId,
            hasSpaceKey: Boolean(spaceKey),
            spaceKey: spaceKey ?? ''
        },
        __callerPackage__: "public-links"
    });
    (0, $cozmU.useEffect)(()=>{
        if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    }, [
        error
    ]);
    return loading ? {
        isLoading: true,
        refetch: refetch
    } : {
        isLoading: false,
        error: error,
        data: error ? undefined : $3e0fb5c21944a86f$var$computeData(data, isExternalCollaborator),
        refetch: refetch
    };
};
module.exports["usePublicLinkContentQuery"] = $3e0fb5c21944a86f$export$13a7a098bd5c2599;

});

parcelRegister("OoVEI", function(module, exports) {
/**
 * @generated SignedSource<<5d5c701005fd929073b85f42c85deac0>>
 * @relayHash 6ab077a19d911ef98a26d3adbdc3fb56
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d97e35dd1097710a89c08e998e3514fe92b46c99fab60a5106b9d4e4545db9da
const $77c51ddc0082b191$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hasSpaceKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "condition": "hasSpaceKey",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "key",
                            "variableName": "spaceKey"
                        }
                    ],
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "concreteType": "SpaceUserMetadata",
                            "kind": "LinkedField",
                            "name": "currentUser",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isAdmin"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "usePublicLinkContentQueryPublicLinkContentQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "usePublicLinkContentQueryPublicLinkContentQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "6ab077a19d911ef98a26d3adbdc3fb56",
            "id": "d97e35dd1097710a89c08e998e3514fe92b46c99fab60a5106b9d4e4545db9da",
            "metadata": {},
            "name": "usePublicLinkContentQueryPublicLinkContentQuery",
            "operationKind": "query",
            "text": "query usePublicLinkContentQueryPublicLinkContentQuery($contentId:ID!,$spaceKey:String!,$hasSpaceKey:Boolean!){content(id:$contentId){nodes{id,type,operations{operation,targetType}}},space(key:$spaceKey)@include(if:$hasSpaceKey){id,currentUser{isAdmin}}}"
        }
    };
}();
$77c51ddc0082b191$var$node.hash = "59655c56a4e7fa1ddec49b3697d04128";
var $77c51ddc0082b191$export$2e2bcd8739ae039 = $77c51ddc0082b191$var$node;
module.exports["default"] = $77c51ddc0082b191$export$2e2bcd8739ae039;

});

parcelRegister("bgRei", function(module, exports) {

var $8lkfF = parcelRequire("8lkfF");


var $cozmU = parcelRequire("cozmU");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $jMyy4 = parcelRequire("jMyy4");


var $j0YKV = parcelRequire("j0YKV");

const $6b8bec8977e1e896$export$c2d35981ca787f77 = ({ objectId: objectId, objectType: objectType = (0, $j0YKV.PublicLinkPermissionsObjectType).CONTENT, skip: skip })=>{
    const { loading: loading, error: error, data: data, refetch: refetch } = (0, $jMyy4.useQueryInterop)((0, $8lkfF.default), {
        variables: {
            objectId: objectId,
            objectType: objectType
        },
        skip: skip,
        __callerPackage__: "public-links"
    });
    (0, $cozmU.useEffect)(()=>{
        if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    }, [
        error
    ]);
    const hasEditPermission = data?.publicLinkPermissionsForObject?.permissions?.includes((0, $j0YKV.PublicLinkPermissionsType).EDIT) ?? false;
    return loading ? {
        isLoading: true,
        refetch: refetch
    } : {
        isLoading: false,
        error: error,
        refetch: refetch,
        data: error ? undefined : {
            hasEditPermission: hasEditPermission,
            permissions: data?.publicLinkPermissionsForObject?.permissions ?? []
        }
    };
};
module.exports["usePublicLinkPermissionsForObject"] = $6b8bec8977e1e896$export$c2d35981ca787f77;

});

parcelRegister("8lkfF", function(module, exports) {
/**
 * @generated SignedSource<<cb28f26c1ca7292c5219e38ecf8b7ea3>>
 * @relayHash f71176804f0f8510a7464cc538777917
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 52a378cda6f621b63f57ad3ac3acae72028609509efa958d34656dfe1fe45eb1
const $5d187f97ac5d0d36$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "objectId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "objectType"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "objectId",
                    "variableName": "objectId"
                },
                {
                    "kind": "Variable",
                    "name": "objectType",
                    "variableName": "objectType"
                }
            ],
            "concreteType": "PublicLinkPermissions",
            "kind": "LinkedField",
            "name": "publicLinkPermissionsForObject",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "permissions"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePublicLinkPermissionsForObjectPublicLinkPermissionsForObjectQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePublicLinkPermissionsForObjectPublicLinkPermissionsForObjectQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "f71176804f0f8510a7464cc538777917",
            "id": "52a378cda6f621b63f57ad3ac3acae72028609509efa958d34656dfe1fe45eb1",
            "metadata": {},
            "name": "usePublicLinkPermissionsForObjectPublicLinkPermissionsForObjectQuery",
            "operationKind": "query",
            "text": "query usePublicLinkPermissionsForObjectPublicLinkPermissionsForObjectQuery($objectId:ID!,$objectType:PublicLinkPermissionsObjectType!){publicLinkPermissionsForObject(objectId:$objectId,objectType:$objectType){permissions}}"
        }
    };
}();
$5d187f97ac5d0d36$var$node.hash = "374477f8db79649c77f638ae2ac0ca9b";
var $5d187f97ac5d0d36$export$2e2bcd8739ae039 = $5d187f97ac5d0d36$var$node;
module.exports["default"] = $5d187f97ac5d0d36$export$2e2bcd8739ae039;

});

parcelRegister("j0YKV", function(module, exports) {
/**
 * @generated SignedSource<<f0cd509e142f69bcae46da270cdbb1c1>>
 * This file was auto-generated by a codemod
 * @see https://go/connie-relay-migration-fyi
 **/ var $d2563be1c2ded005$export$fcb2676e4c5b8efd = /*#__PURE__*/ function(PublicLinkPermissionsObjectType) {
    PublicLinkPermissionsObjectType["CONTENT"] = "CONTENT";
    return PublicLinkPermissionsObjectType;
}({});
var $d2563be1c2ded005$export$1d899d09218cc934 = /*#__PURE__*/ function(PublicLinkPermissionsType) {
    PublicLinkPermissionsType["EDIT"] = "EDIT";
    return PublicLinkPermissionsType;
}({});
module.exports["PublicLinkPermissionsObjectType"] = $d2563be1c2ded005$export$fcb2676e4c5b8efd;
module.exports["PublicLinkPermissionsType"] = $d2563be1c2ded005$export$1d899d09218cc934;

});

parcelRegister("gqypm", function(module, exports) {

var $CIjCq = parcelRequire("CIjCq");


var $f7MuR = parcelRequire("f7MuR");

const $a585c4c0c1029461$export$650aef70f4433205 = ({ skip: skip, fetchPolicy: fetchPolicy })=>{
    const traitsResult = (0, $f7MuR.useSiteUserTraits)({
        skip: skip,
        fetchPolicy: fetchPolicy
    });
    const adaptedData = traitsResult.data !== null ? {
        experimentalSiteUserPersonalization: {
            attributes: (0, $CIjCq.stringifyPersonalizationAttributes)(traitsResult.data.attributes)
        }
    } : undefined;
    return {
        data: adaptedData,
        loading: traitsResult.loading,
        error: traitsResult.error ?? undefined
    };
};
module.exports["useExperimentalSiteUserPersonalization"] = $a585c4c0c1029461$export$650aef70f4433205;

});

parcelRegister("CIjCq", function(module, exports) {
/**
 * The TAP delivery API returns mixed types (boolean, number, string), but the
 * previous experimental GraphQL schema defined all values as String!, causing
 * automatic coercion. When bypassing GraphQL via useExperimentalQuery, we need
 * to manually coerce to maintain the same behavior consumer code expects.
 */ function $3c8babd51a2343c1$export$1660902c4f08468b(attributes) {
    if (!attributes) return [];
    return attributes.map((attr)=>({
            ...attr,
            value: String(attr.value)
        }));
}
module.exports["stringifyPersonalizationAttributes"] = $3c8babd51a2343c1$export$1660902c4f08468b;

});

parcelRegister("04VgG", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $47a3fe800ce35819$export$77dedcd16f070a20 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7obd3",
    name: "ReadTime",
    loader: async ()=>(await (parcelRequire("iOvhz"))).ReadTime
});
module.exports["ReadTime"] = $47a3fe800ce35819$export$77dedcd16f070a20;

});

parcelRegister("iOvhz", function(module, exports) {

let $0388db823da3c292$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0388db823da3c292$var$load("irgIM").then(()=>parcelRequire('cbZqw'));

});

parcelRegister("jkVM2", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $5f9bfd31a6a2d08f$export$2791e79b1a186ba4 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CFAQV",
    name: "EditorContentState",
    loader: async ()=>(await (parcelRequire("ln6oL"))).EditorContentState
});
module.exports["EditorContentState"] = $5f9bfd31a6a2d08f$export$2791e79b1a186ba4;

});

parcelRegister("ln6oL", function(module, exports) {

let $f8f0b58841eb9f75$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f8f0b58841eb9f75$var$load("ezYRV"),
    $f8f0b58841eb9f75$var$load("bAgF6"),
    $f8f0b58841eb9f75$var$load("hhu66"),
    $f8f0b58841eb9f75$var$load("el56J"),
    $f8f0b58841eb9f75$var$load("hhss7"),
    $f8f0b58841eb9f75$var$load("9cpj1"),
    $f8f0b58841eb9f75$var$load("ljCe8")
]).then(()=>parcelRequire('iDxDj'));

});

parcelRegister("earLp", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $9DHhW = parcelRequire("9DHhW");


var $bQm3c = parcelRequire("bQm3c");


var $7QM6o = parcelRequire("7QM6o");

var $a91836006a246f35$export$cb7d54f314e067cb = /*#__PURE__*/ function(ActionSubjectId) {
    ActionSubjectId["EDITOR_TITLE_DATA_CLASSIFICATION_POPUP"] = "editorTitleDataClassificationPopup";
    ActionSubjectId["CONTENT_TYPE_TITLE_DATA_CLASSIFICATION_POPUP"] = "contentTypeTitleDataClassificationPopup";
    ActionSubjectId["GENERIC_DATA_CLASSIFICATION_MODAL_POPUP"] = "genericDataClassificationModalPopup";
    return ActionSubjectId;
}({});
const $a91836006a246f35$var$getEditPopupViewedScreenEvent = ({ cloudId: cloudId, spaceId: spaceId, orgId: orgId, actionSubjectId: actionSubjectId })=>({
        type: 'sendScreenEvent',
        data: {
            name: 'dataClassificationEditPopup',
            action: 'viewed',
            actionSubject: 'popup',
            actionSubjectId: actionSubjectId,
            attributes: {
                cloudId: cloudId,
                spaceId: spaceId,
                orgId: orgId
            }
        }
    });
const $a91836006a246f35$export$c5f7a48280d6f361 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(5);
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t0;
    if ($[0] !== cloudId || $[1] !== createAnalyticsEvent || $[2] !== orgId || $[3] !== spaceId) {
        t0 = {
            trackEditPopupViewed: (actionSubjectId)=>{
                if (!spaceId || !cloudId || !orgId) return;
                createAnalyticsEvent($a91836006a246f35$var$getEditPopupViewedScreenEvent({
                    cloudId: cloudId,
                    spaceId: spaceId,
                    orgId: orgId,
                    actionSubjectId: actionSubjectId
                })).fire();
            },
            trackRenderTagError: (errorMessage)=>{
                if (!spaceId || !cloudId || !orgId) return;
                createAnalyticsEvent({
                    type: "sendOperationalEvent",
                    data: {
                        action: "failed",
                        actionSubject: "dataClassificationTagRender",
                        source: "confluence-frontend",
                        attributes: {
                            cloudId: cloudId,
                            spaceId: spaceId,
                            orgId: orgId,
                            error: errorMessage
                        }
                    }
                }).fire();
            }
        };
        $[0] = cloudId;
        $[1] = createAnalyticsEvent;
        $[2] = orgId;
        $[3] = spaceId;
        $[4] = t0;
    } else t0 = $[4];
    return t0;
} : ()=>{
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    return {
        trackEditPopupViewed: (actionSubjectId)=>{
            if (!spaceId || !cloudId || !orgId) return;
            createAnalyticsEvent($a91836006a246f35$var$getEditPopupViewedScreenEvent({
                cloudId: cloudId,
                spaceId: spaceId,
                orgId: orgId,
                actionSubjectId: actionSubjectId
            })).fire();
        },
        trackRenderTagError: (errorMessage)=>{
            if (!spaceId || !cloudId || !orgId) return;
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'failed',
                    actionSubject: 'dataClassificationTagRender',
                    source: 'confluence-frontend',
                    attributes: {
                        cloudId: cloudId,
                        spaceId: spaceId,
                        orgId: orgId,
                        error: errorMessage
                    }
                }
            }).fire();
        }
    };
};
module.exports["ActionSubjectId"] = $a91836006a246f35$export$cb7d54f314e067cb;
module.exports["useTrackClassificationAnalytics"] = $a91836006a246f35$export$c5f7a48280d6f361;

});

parcelRegister("6Ry4r", function(module, exports) {
const $588818833e6e4a91$export$44b43449ad5e39e3 = (classification)=>{
    // Prefer ADF guideline over plain text
    if (classification?.guidelineADF) return {
        guideline: classification.guidelineADF,
        guidelineRepresentation: 'EDITOR'
    };
    // Fall back to plain text guideline
    return {
        guideline: classification?.guideline,
        guidelineRepresentation: 'PLAIN'
    };
};
module.exports["getGuidelineProps"] = $588818833e6e4a91$export$44b43449ad5e39e3;

});

parcelRegister("93WhG", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $81f08aaba4f97dd2$export$39a13631616da233 = (0, $kSwu1.defineMessages)({
    classifyContent: {
        id: "data-classification.shared-messages.edit-popup.classify-content",
        defaultMessage: "Classify content"
    },
    fetchErrorTextPrimary: {
        id: "data-classification.shared-messages.fetch-error.primary",
        defaultMessage: "Unable to load classification. Try again."
    },
    fetchErrorTextSecondary: {
        id: "data-classification.shared-messages.fetch-error.secondary",
        defaultMessage: "Try reloading now."
    },
    saveErrorTextPrimary: {
        id: "data-classification.shared-messages.save-error.primary",
        defaultMessage: "Update to classification failed to save"
    },
    saveErrorTextSecondary: {
        id: "data-classification.shared-messages.save-error.secondary",
        defaultMessage: "Please try again."
    }
});
module.exports["sharedMessages"] = $81f08aaba4f97dd2$export$39a13631616da233;

});

parcelRegister("gfkT8", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $1cYlh = parcelRequire("1cYlh");

const $4ebf6b4d55a3b532$var$actionMessage = (0, $kSwu1.defineMessage)({
    id: "data-classification.settings-panel.error-flag-action",
    defaultMessage: "Refresh page"
});
const $4ebf6b4d55a3b532$export$fedbe2c138bb22c4 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { flags: flags, type: type, title: title, description: description, classification: classification, spaceName: spaceName, showRefresh: showRefresh } = t0;
    let t1;
    let t2;
    if ($[0] !== classification || $[1] !== description || $[2] !== flags || $[3] !== showRefresh || $[4] !== spaceName || $[5] !== title || $[6] !== type) {
        t1 = ()=>{
            const actions = !!showRefresh ? [
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $4ebf6b4d55a3b532$var$actionMessage),
                    onClick: $4ebf6b4d55a3b532$var$_temp
                }
            ] : [];
            const showFlag = async ()=>{
                const successFlag = await flags.showFlag({
                    type: type,
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), title),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                        ...description,
                        values: {
                            spaceName: spaceName,
                            classification: classification === (0, $1cYlh.NO_CLASSIFICATION) ? "unclassified" : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, classification)
                        }
                    }),
                    actions: actions
                });
                setTimeout(()=>flags.hideFlag(successFlag.id), 5000);
            };
            showFlag().catch(console.error);
        };
        t2 = [
            flags,
            type,
            title,
            description,
            spaceName,
            showRefresh,
            classification
        ];
        $[0] = classification;
        $[1] = description;
        $[2] = flags;
        $[3] = showRefresh;
        $[4] = spaceName;
        $[5] = title;
        $[6] = type;
        $[7] = t1;
        $[8] = t2;
    } else {
        t1 = $[7];
        t2 = $[8];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
} : ({ flags: flags, type: type, title: title, description: description, classification: classification, spaceName: spaceName, showRefresh: showRefresh })=>{
    (0, $cozmU.useEffect)(()=>{
        const actions = !!showRefresh ? [
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $4ebf6b4d55a3b532$var$actionMessage),
                onClick: ()=>window.location.reload()
            }
        ] : [];
        const showFlag = async ()=>{
            const successFlag = await flags.showFlag({
                type: type,
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), title),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...description,
                    values: {
                        spaceName: spaceName,
                        classification: classification === (0, $1cYlh.NO_CLASSIFICATION) ? 'unclassified' : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, classification)
                    }
                }),
                actions: actions
            });
            setTimeout(()=>flags.hideFlag(successFlag.id), 5000);
        };
        // eslint-disable-next-line no-console
        showFlag().catch(console.error);
    }, [
        flags,
        type,
        title,
        description,
        spaceName,
        showRefresh,
        classification
    ]);
    return null;
};
const $4ebf6b4d55a3b532$var$SaveFlagGetter = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4ebf6b4d55a3b532$export$fedbe2c138bb22c4, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4ebf6b4d55a3b532$export$fedbe2c138bb22c4, props);
};
const $4ebf6b4d55a3b532$var$SaveFlagWithErrorBoundary = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).DLP
})($4ebf6b4d55a3b532$var$SaveFlagGetter);
const $4ebf6b4d55a3b532$export$ac7557ff3627d244 = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4ebf6b4d55a3b532$var$SaveFlagWithErrorBoundary, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4ebf6b4d55a3b532$var$SaveFlagWithErrorBoundary, props);
function $4ebf6b4d55a3b532$var$_temp() {
    return window.location.reload();
}
module.exports["SaveFlag"] = $4ebf6b4d55a3b532$export$ac7557ff3627d244;

});

parcelRegister("40pD8", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $512bc11813ea6463$var$ClassificationModalContext = /*#__PURE__*/ (0, $cozmU.createContext)({
    isClassificationModalOpen: false
});
$512bc11813ea6463$var$ClassificationModalContext.displayName = 'ClassificationModalContext';
const $512bc11813ea6463$export$ed3f7b1d90b3e679 = /*#__PURE__*/ (0, $cozmU.createContext)({
    setIsClassificationModalOpen: ()=>{}
});
$512bc11813ea6463$export$ed3f7b1d90b3e679.displayName = 'ClassificationModalDispatchContext';
const $512bc11813ea6463$export$dd63fef46bf243c2 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { children: children } = t0;
    const [isClassificationModalOpen, setIsClassificationModalOpen] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] !== isClassificationModalOpen) {
        t1 = {
            isClassificationModalOpen: isClassificationModalOpen
        };
        $[0] = isClassificationModalOpen;
        $[1] = t1;
    } else t1 = $[1];
    const contextValue = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            setIsClassificationModalOpen: (value)=>setIsClassificationModalOpen(value)
        };
        $[2] = t2;
    } else t2 = $[2];
    const dispatchContextValue = t2;
    let t3;
    if ($[3] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($512bc11813ea6463$export$ed3f7b1d90b3e679.Provider, {
            value: dispatchContextValue
        }, children);
        $[3] = children;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== contextValue || $[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($512bc11813ea6463$var$ClassificationModalContext.Provider, {
            value: contextValue
        }, t3);
        $[5] = contextValue;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : ({ children: children })=>{
    const [isClassificationModalOpen, setIsClassificationModalOpen] = (0, $cozmU.useState)(false);
    const contextValue = (0, $cozmU.useMemo)(()=>({
            isClassificationModalOpen: isClassificationModalOpen
        }), [
        isClassificationModalOpen
    ]);
    const dispatchContextValue = (0, $cozmU.useMemo)(()=>({
            setIsClassificationModalOpen: (value)=>setIsClassificationModalOpen(value)
        }), [
        setIsClassificationModalOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($512bc11813ea6463$var$ClassificationModalContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($512bc11813ea6463$export$ed3f7b1d90b3e679.Provider, {
        value: dispatchContextValue
    }, children));
};
const $512bc11813ea6463$export$3e27c86e4ac00950 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $cozmU.useContext)($512bc11813ea6463$var$ClassificationModalContext);
} : ()=>{
    return (0, $cozmU.useContext)($512bc11813ea6463$var$ClassificationModalContext);
};
const $512bc11813ea6463$export$6c62639a7ca504f5 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $cozmU.useContext)($512bc11813ea6463$export$ed3f7b1d90b3e679);
} : ()=>{
    return (0, $cozmU.useContext)($512bc11813ea6463$export$ed3f7b1d90b3e679);
};
module.exports["ClassificationModalContextProvider"] = $512bc11813ea6463$export$dd63fef46bf243c2;
module.exports["useClassificationModalContext"] = $512bc11813ea6463$export$3e27c86e4ac00950;
module.exports["useClassificationModalDispatchContext"] = $512bc11813ea6463$export$6c62639a7ca504f5;

});

parcelRegister("18vK6", function(module, exports) {

var $6ZtPk = parcelRequire("6ZtPk");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $7zgzO = parcelRequire("7zgzO");


var $1NBp8 = parcelRequire("1NBp8");


var $jMyy4 = parcelRequire("jMyy4");


var $kfIha = parcelRequire("kfIha");


var $1RN2b = parcelRequire("1RN2b");

const $c8a2a643eaa1809a$var$useCopyContentLinkCopyLinkQuery = (0, $6ZtPk.default);
var $c8a2a643eaa1809a$export$61634440d18842d5 = /*#__PURE__*/ function(SUPPORTED_CONTENT_TYPES) {
    SUPPORTED_CONTENT_TYPES["PAGE"] = "page";
    SUPPORTED_CONTENT_TYPES["BLOGPOST"] = "blogpost";
    SUPPORTED_CONTENT_TYPES["OVERVIEW"] = "overview";
    SUPPORTED_CONTENT_TYPES["WHITEBOARD"] = "whiteboard";
    SUPPORTED_CONTENT_TYPES["EMBED"] = "embed";
    SUPPORTED_CONTENT_TYPES["DATABASE"] = "database";
    return SUPPORTED_CONTENT_TYPES;
}({});
const $c8a2a643eaa1809a$export$a049904f049cf16d = ({ pageMode: pageMode, contentType: contentType, contentId: contentId, spaceKey: spaceKey, source: source })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [unsupportedLinkError, setUnsupportedLinkError] = (0, $cozmU.useState)();
    const { toUrl: toUrl } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const { copyToClipboard: copyToClipboard } = (0, $kfIha.useCopyToClipboard)();
    const { data: data, loading: loading, error: queryError } = (0, $jMyy4.useQueryInterop)($c8a2a643eaa1809a$var$useCopyContentLinkCopyLinkQuery, {
        variables: {
            contentId: contentId
        },
        __callerPackage__: "share-and-restrict-dialog"
    });
    const getCopyContentLink = (0, $cozmU.useCallback)(()=>{
        let copyLink;
        // Try to get the page link from queried data, shortened (for view mode) if possible.
        if (data) {
            const links = data?.singleContent?.links;
            if (pageMode === (0, $1RN2b.PAGE_MODE).EDIT) copyLink = links?.editui;
            else // pageMode === "view" OR no page mode specified, eg for whiteboards
            copyLink = links?.tinyui || links?.webui;
            if (copyLink && links?.base) return `${links.base}${copyLink}`;
        }
        // Fallback behavior: Use content type + page mode to construct URL.
        let routeName, additionalParams;
        if (pageMode === (0, $1RN2b.PAGE_MODE).EDIT) {
            routeName = contentType === "blogpost" ? (0, $1NBp8.EDIT_BLOG_V2).name : (0, $1NBp8.EDIT_PAGE_V2).name;
            additionalParams = {
                contentType: // EDIT_BLOG_V2 and EDIT_PAGE_V2 routes expect particular contentType format during route construction
                contentType === "blogpost" ? 'blog' : 'pages'
            };
        } else switch(contentType){
            case "overview":
                routeName = (0, $1NBp8.SPACE_OVERVIEW).name;
                break;
            case "blogpost":
                routeName = (0, $1NBp8.VIEW_BLOG).name;
                break;
            case "page":
                routeName = (0, $1NBp8.VIEW_PAGE).name;
                break;
            case "whiteboard":
                routeName = (0, $1NBp8.WHITEBOARD_BOARD).name;
                break;
            case "embed":
                routeName = (0, $1NBp8.EMBED_VIEW).name;
                break;
            case "database":
                routeName = (0, $1NBp8.DATABASE_VIEW).name;
                break;
            // omit unsupported content types
            default:
                if (!contentType) // contentType is undefined/empty - this is a data issue, not a
                // truly unsupported type. Return undefined rather than erroring.
                return undefined;
                const error = new Error(`Received an unexpected content type: '${contentType}'`);
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'thrown',
                        actionSubject: 'error',
                        actionSubjectId: (0, $1RN2b.ACTION_SUBJECT_ID),
                        source: source,
                        attributes: {
                            error: error?.message,
                            contentType: contentType,
                            pageMode: pageMode
                        }
                    }
                }).fire();
                setUnsupportedLinkError(error);
        }
        if (routeName) {
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'copied',
                    actionSubject: 'fallbackLink',
                    actionSubjectId: (0, $1RN2b.ACTION_SUBJECT_ID),
                    source: source,
                    attributes: {
                        queryError: queryError?.message,
                        isDataLoading: loading,
                        route: routeName
                    }
                }
            }).fire();
            // Omit contentSlug, because user perception is that link sharing
            // is more secure without the content title in the URL.
            return `${window.location.origin}${toUrl(routeName, {
                contentId: contentId,
                spaceKey: spaceKey,
                ...additionalParams
            })}`;
        }
        return undefined;
    }, [
        toUrl,
        contentId,
        contentType,
        spaceKey,
        pageMode,
        source,
        data,
        loading,
        queryError,
        createAnalyticsEvent
    ]);
    const copyContentLink = (0, $cozmU.useCallback)(()=>{
        return copyToClipboard(getCopyContentLink());
    }, [
        getCopyContentLink,
        copyToClipboard
    ]);
    return (0, $cozmU.useMemo)(()=>({
            queryError: queryError,
            unsupportedLinkError: unsupportedLinkError,
            getCopyContentLink: getCopyContentLink,
            copyContentLink: copyContentLink
        }), [
        queryError,
        unsupportedLinkError,
        getCopyContentLink,
        copyContentLink
    ]);
};
module.exports["SUPPORTED_CONTENT_TYPES"] = $c8a2a643eaa1809a$export$61634440d18842d5;
module.exports["useCopyContentLink"] = $c8a2a643eaa1809a$export$a049904f049cf16d;

});

parcelRegister("6ZtPk", function(module, exports) {
/**
 * @generated SignedSource<<eb2b56a2caf0d743247e79708ebe7cd0>>
 * @relayHash 18ff4f8d8b4085f53eca6f5430f839ae
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 696a1658ae695a2ccdd29b5b577d0bea392665ecbf8da6a0b6fcc65e73032b59
const $833a147e3ae344d9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "editui"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "webui"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "tinyui"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "base"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useCopyContentLinkCopyLinkQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useCopyContentLinkCopyLinkQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "18ff4f8d8b4085f53eca6f5430f839ae",
            "id": "696a1658ae695a2ccdd29b5b577d0bea392665ecbf8da6a0b6fcc65e73032b59",
            "metadata": {},
            "name": "useCopyContentLinkCopyLinkQuery",
            "operationKind": "query",
            "text": "query useCopyContentLinkCopyLinkQuery($contentId:ID!){singleContent(id:$contentId){id,links{editui,webui,tinyui,base}}}"
        }
    };
}();
$833a147e3ae344d9$var$node.hash = "d21c9891b99750e37c7d31e767baec64";
var $833a147e3ae344d9$export$2e2bcd8739ae039 = $833a147e3ae344d9$var$node;
module.exports["default"] = $833a147e3ae344d9$export$2e2bcd8739ae039;

});

parcelRegister("6MSEP", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $9387550ed869acb8$export$4242cfff65d64b16 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "M3-19",
    name: "RestrictedPage",
    loader: async ()=>(await (parcelRequire("00KoQ"))).RestrictedPage
});
module.exports["RestrictedPage"] = $9387550ed869acb8$export$4242cfff65d64b16;

});

parcelRegister("00KoQ", function(module, exports) {

let $0000949dda5afb49$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $0000949dda5afb49$var$load("ezYRV"),
    $0000949dda5afb49$var$load("6wr18"),
    $0000949dda5afb49$var$load("ffEVr"),
    $0000949dda5afb49$var$load("h0X0x"),
    $0000949dda5afb49$var$load("7l4Nc"),
    $0000949dda5afb49$var$load("2OcM6"),
    $0000949dda5afb49$var$load("hhss7"),
    $0000949dda5afb49$var$load("7EorR"),
    $0000949dda5afb49$var$load("kUiwW")
]).then(()=>parcelRequire('3kPYw'));

});

parcelRegister("dmDX7", function(module, exports) {

var $7NYI2 = parcelRequire("7NYI2");


var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $6mKj3 = parcelRequire("6mKj3");

const $4aa29e57813b75ee$var$UsePendingRequestExistsQuery = (0, $7NYI2.default);
const $4aa29e57813b75ee$export$5354a7f39c2c364a = ({ contentId: contentId, preferPreloadedData: preferPreloadedData = false })=>{
    const { userId: userId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const shouldSkip = !userId || !cloudId || !contentId || !(0, $6mKj3.expValEquals)('confluence_frontend_existing_access_request_checks', 'cohort', 'experiment');
    const [isLoadingForFirstTime, setIsLoadingForFirstTime] = (0, $cozmU.useState)(!shouldSkip);
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($4aa29e57813b75ee$var$UsePendingRequestExistsQuery, {
        variables: {
            cloudId: cloudId,
            accessRequestedAaid: userId ?? '',
            contentId: contentId ?? ''
        },
        skip: shouldSkip,
        fetchPolicy: preferPreloadedData ? 'cache-first' : 'network-only',
        onCompleted: ()=>{
            setIsLoadingForFirstTime(false);
        },
        __callerPackage__: "access-requests"
    });
    // SSR-safe resolution signal, for consumers that render on the server. `true` as soon as the
    // answer is available in the store on the current render — including the server render, when the
    // result was SSR-preloaded and read via `cache-first`. Unlike `isLoadingForFirstTime`, this lets an
    // SSR consumer render the resolved copy directly into the server HTML.
    const isPendingRequestResolvedForSSR = shouldSkip || data !== undefined;
    const pendingRequestExists = Boolean(data?.confluence_pendingRequestExists?.isPendingAccessRequestExists);
    return {
        pendingRequestExists: pendingRequestExists,
        loading: loading,
        error: error,
        isLoadingForFirstTime: isLoadingForFirstTime,
        isPendingRequestResolvedForSSR: isPendingRequestResolvedForSSR
    };
};
module.exports["usePendingRequestExists"] = $4aa29e57813b75ee$export$5354a7f39c2c364a;

});

parcelRegister("7NYI2", function(module, exports) {
/**
 * @generated SignedSource<<4d7ccfc95dff4e3b611db90e9453df55>>
 * @relayHash f8787096f4d42896880d52d9cbd4670c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ca265d253ef91a90727e0b2a379d714b1851230382cb448d534c1124fd0266b9
const $3cde78eca68e7b16$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accessRequestedAaid"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "accessRequestedAaid",
                    "variableName": "accessRequestedAaid"
                },
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ConfluencePendingAccessRequest",
            "kind": "LinkedField",
            "name": "confluence_pendingRequestExists",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isPendingAccessRequestExists"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePendingRequestExistsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePendingRequestExistsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "f8787096f4d42896880d52d9cbd4670c",
            "id": "ca265d253ef91a90727e0b2a379d714b1851230382cb448d534c1124fd0266b9",
            "metadata": {},
            "name": "usePendingRequestExistsQuery",
            "operationKind": "query",
            "text": "query usePendingRequestExistsQuery($accessRequestedAaid:String!,$cloudId:ID!,$contentId:ID!){confluence_pendingRequestExists(accessRequestedAaid:$accessRequestedAaid,cloudId:$cloudId,contentId:$contentId){isPendingAccessRequestExists}}"
        }
    };
}();
$3cde78eca68e7b16$var$node.hash = "4d877c3ca505e954e3d6f173f1138ce0";
var $3cde78eca68e7b16$export$2e2bcd8739ae039 = $3cde78eca68e7b16$var$node;
module.exports["default"] = $3cde78eca68e7b16$export$2e2bcd8739ae039;

});

parcelRegister("f3euL", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $1UCmC = parcelRequire("1UCmC");

const $af526147f97ee327$export$dcb53e05895a448a = (0, $lSOAM.createPageLoadMetric)({
    key: (0, $1UCmC.INACCESSIBLE_PAGE_LOAD_KEY)
});
module.exports["INACCESSIBLE_PAGE_LOAD"] = $af526147f97ee327$export$dcb53e05895a448a;

});

parcelRegister("iVU5h", function(module, exports) {
const $6269d9b82324487a$export$42ca032027818031 = ()=>{
    return new URLSearchParams(window.location.search).get('amn-referral-source') || '';
};
module.exports["getAMNReferralSourceFromQueryParam"] = $6269d9b82324487a$export$42ca032027818031;

});

parcelRegister("iSXh4", function(module, exports) {

var $9VdrT = parcelRequire("9VdrT");


var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $7Sm4c = parcelRequire("7Sm4c");


var $bQm3c = parcelRequire("bQm3c");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $5ZqQS = parcelRequire("5ZqQS");

const $270f2eb7bad14df2$var$createAriId = (cloudId, pageId)=>`ari:cloud:confluence:${cloudId}:page/${pageId}`;
const $270f2eb7bad14df2$var$AutomatedMeetingNotesPagePropertiesQuery = (0, $9VdrT.default);
const $270f2eb7bad14df2$var$IsAutomatedMeetingNotesPropertyKey = 'isAutomatedMeetingNotes';
const $270f2eb7bad14df2$var$MeetingRecurrenceAriPropertyKey = 'meetingRecurrenceAri';
const $270f2eb7bad14df2$export$d2c3b4dbe2618d37 = (pageId)=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($270f2eb7bad14df2$var$AutomatedMeetingNotesPagePropertiesQuery, {
        variables: {
            pageAri: $270f2eb7bad14df2$var$createAriId(cloudId, pageId)
        },
        __callerPackage__: "automated-meeting-notes"
    });
    (0, $cozmU.useEffect)(()=>{
        if (error) {
            if (!(0, $1uFM6.isUnauthorizedError)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).INTEGRATIONS
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    }, [
        error
    ]);
    return {
        isLoading: loading,
        ...$270f2eb7bad14df2$export$1607cf22d9dbad(data)
    };
};
const $270f2eb7bad14df2$export$1607cf22d9dbad = (data)=>{
    const pageProperties = data?.page?.properties?.nodes;
    const amnProperty = pageProperties?.find((property)=>property?.key === $270f2eb7bad14df2$var$IsAutomatedMeetingNotesPropertyKey);
    const recurrenceProperty = pageProperties?.find((property)=>property?.key === $270f2eb7bad14df2$var$MeetingRecurrenceAriPropertyKey);
    const isAMN = amnProperty?.value === 'true';
    const isRecurringParent = recurrenceProperty != undefined;
    const isLiveAMNPage = data?.page?.subType?.toLowerCase() === 'live' && isAMN;
    return {
        isAMN: isAMN,
        isRecurringParent: isRecurringParent,
        isLiveAMNPage: isLiveAMNPage
    };
};
module.exports["useAutomatedMeetingNotesPageProperties"] = $270f2eb7bad14df2$export$d2c3b4dbe2618d37;
module.exports["extractAmnPageProperties"] = $270f2eb7bad14df2$export$1607cf22d9dbad;

});

parcelRegister("9VdrT", function(module, exports) {
/**
 * @generated SignedSource<<c55748e87ec72b47f4575a0869b376cf>>
 * @relayHash 2d27dcc1d1eac2731f01ec3e79c7f7d9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bf3bc462d3d8204f9ed38909105bf232600e50daaab2de0e4c1b07ae2dc4f5bd
const $2aa10c7c748cb29a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageAri"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "pageAri"
                }
            ],
            "concreteType": "Page",
            "kind": "LinkedField",
            "name": "page",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "keys",
                            "value": [
                                "isAutomatedMeetingNotes",
                                "meetingRecurrenceAri"
                            ]
                        }
                    ],
                    "concreteType": "PaginatedJsonContentPropertyList",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JsonContentProperty",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ],
                    "storageKey": "properties(keys:[\"isAutomatedMeetingNotes\",\"meetingRecurrenceAri\"])"
                },
                {
                    "kind": "ScalarField",
                    "name": "subType"
                },
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useAutomatedMeetingNotesPagePropertiesQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useAutomatedMeetingNotesPagePropertiesQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "2d27dcc1d1eac2731f01ec3e79c7f7d9",
            "id": "bf3bc462d3d8204f9ed38909105bf232600e50daaab2de0e4c1b07ae2dc4f5bd",
            "metadata": {},
            "name": "useAutomatedMeetingNotesPagePropertiesQuery",
            "operationKind": "query",
            "text": "query useAutomatedMeetingNotesPagePropertiesQuery($pageAri:ID!){page(id:$pageAri){properties(keys:[\"isAutomatedMeetingNotes\",\"meetingRecurrenceAri\"]){nodes{key,value}},subType,id}}"
        }
    };
}();
$2aa10c7c748cb29a$var$node.hash = "a7e1d622b5e3dfb0202b4f6045de22bd";
var $2aa10c7c748cb29a$export$2e2bcd8739ae039 = $2aa10c7c748cb29a$var$node;
module.exports["default"] = $2aa10c7c748cb29a$export$2e2bcd8739ae039;

});

parcelRegister("7r2px", function(module, exports) {

var $7W8i8 = parcelRequire("7W8i8");

const $0bdd6e0a6db7c960$var$logger = (0, $7W8i8.getLogger)('retrieveContentExtensionMetrics');
const $0bdd6e0a6db7c960$export$1fa8ce0cc2ea267e = 10;
const $0bdd6e0a6db7c960$export$5da22daff5be7fe6 = (contentBody)=>{
    try {
        const contentExtensionMetrics = {
            contentExtensionCount: {
                connect: {},
                forge: {}
            },
            contentExtensionKeys: {
                connect: [],
                forge: []
            },
            depth: {
                connect: [],
                forge: []
            },
            hasExtensions: false
        };
        const document = JSON.parse(contentBody);
        const visit = (node)=>{
            $0bdd6e0a6db7c960$export$bd4248834ea73a5(node, contentExtensionMetrics);
        };
        document?.content?.forEach(visit);
        return contentExtensionMetrics;
    } catch  {
        $0bdd6e0a6db7c960$var$logger.error`Unable to parse ADF`;
        return {};
    }
};
const $0bdd6e0a6db7c960$export$bd4248834ea73a5 = (node, contentExtensionMetrics, depth)=>{
    $0bdd6e0a6db7c960$var$retrieveContentExtensionCountFromNode(node, contentExtensionMetrics.contentExtensionCount);
    $0bdd6e0a6db7c960$var$retrieveContentExtensionKeysFromNode(node, contentExtensionMetrics.contentExtensionKeys);
    if (depth !== undefined) $0bdd6e0a6db7c960$var$retrieveContentExtensionDepthFromNode(node, contentExtensionMetrics.depth, depth);
    contentExtensionMetrics.hasExtensions = contentExtensionMetrics.contentExtensionKeys?.connect.length > 0 || contentExtensionMetrics.contentExtensionKeys?.forge.length > 0;
    return contentExtensionMetrics;
};
function $0bdd6e0a6db7c960$var$retrieveContentExtensionKeysFromNode({ attrs: attrs, type: type }, contentExtensionKeys) {
    if (attrs && type) {
        const { extensionType: extensionType, extensionKey: extensionKey } = attrs;
        if (extensionType === 'com.atlassian.ecosystem' && extensionKey) contentExtensionKeys.forge.push(extensionKey);
        else if (extensionType === 'com.atlassian.confluence.macro.core' && extensionKey) contentExtensionKeys.connect.push(extensionKey);
        else if (extensionType === 'com.atlassian.confluence.migration' && extensionKey) contentExtensionKeys.connect.push(extensionKey);
        else return;
    }
}
function $0bdd6e0a6db7c960$var$retrieveContentExtensionCountFromNode({ attrs: attrs, type: type }, contentExtensionCount) {
    if (attrs && type) {
        const { extensionType: extensionType } = attrs;
        let extensionsObj;
        if (extensionType === 'com.atlassian.ecosystem') extensionsObj = contentExtensionCount.forge;
        else if (extensionType === 'com.atlassian.confluence.macro.core') extensionsObj = contentExtensionCount.connect;
        else if (extensionType === 'com.atlassian.confluence.migration') extensionsObj = contentExtensionCount.connect;
        else return;
        if (extensionsObj) extensionsObj[type] = (extensionsObj[type] || 0) + 1;
    }
}
function $0bdd6e0a6db7c960$var$retrieveContentExtensionDepthFromNode({ attrs: attrs, type: type }, contentExtensionDepth, depth) {
    if (attrs && type) {
        const { extensionType: extensionType } = attrs;
        if (extensionType === 'com.atlassian.ecosystem') contentExtensionDepth.forge.push(depth);
        else if (extensionType === 'com.atlassian.confluence.macro.core' || extensionType === 'com.atlassian.confluence.migration') contentExtensionDepth.connect.push(depth);
    }
}
module.exports["retrieveContentExtensionMetrics"] = $0bdd6e0a6db7c960$export$5da22daff5be7fe6;
module.exports["retrieveContentExtensionMetricsFromNode"] = $0bdd6e0a6db7c960$export$bd4248834ea73a5;

});

parcelRegister("juCeZ", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $jtuBN = parcelRequire("jtuBN");


var $9Z1sw = parcelRequire("9Z1sw");

const $816e839f3c4509f6$export$b3d89882591ee965 = (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { contentId: contentId, location: location } = t0;
    const batchResult = (0, $9Z1sw.useWebPanelLocationBatchResult)(location);
    let t1;
    if ($[0] !== contentId || $[1] !== location) {
        t1 = {
            contentId: contentId,
            location: location
        };
        $[0] = contentId;
        $[1] = location;
        $[2] = t1;
    } else t1 = $[2];
    const t2 = Boolean(batchResult);
    let t3;
    if ($[3] !== t1 || $[4] !== t2) {
        t3 = {
            variables: t1,
            skip: t2
        };
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    const baseOptions = t3;
    const { data: data } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $9Z1sw.WebPanelLocationQuery), {
        ...baseOptions,
        __callerPackage__: "web-panel-location"
    });
    let t4;
    if ($[6] !== batchResult?.data?.webPanels || $[7] !== data?.webPanels) {
        const panels = batchResult?.data?.webPanels || data?.webPanels || [];
        t4 = panels.map($816e839f3c4509f6$var$_temp).join(",");
        $[6] = batchResult?.data?.webPanels;
        $[7] = data?.webPanels;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
};
function $816e839f3c4509f6$var$_temp(panel) {
    return panel?.moduleKey;
}
module.exports["useConnectAppsData"] = $816e839f3c4509f6$export$b3d89882591ee965;

});

parcelRegister("JCGnt", function(module, exports) {

var $6vgLy = parcelRequire("6vgLy");


var $f7MuR = parcelRequire("f7MuR");

const $affa2edf03b5b535$var$CONFLUENCE_FIRST_ACTIVE_TRAIT = 'confluence_first_active';
const $affa2edf03b5b535$export$750d18e9348a361a = ({ activeDaysThreshold: activeDaysThreshold = 28, activeUserCutoffDate: activeUserCutoffDate }, skip = false)=>{
    const { data: data, loading: loading, error: error } = (0, $f7MuR.useSiteUserTraits)({
        skipBootstrap: skip
    });
    const confluenceFirstActive = data?.attributes?.find(({ name: name })=>name === $affa2edf03b5b535$var$CONFLUENCE_FIRST_ACTIVE_TRAIT)?.value;
    const firstActiveDate = confluenceFirstActive ? new Date(confluenceFirstActive) : null;
    const { isNewlyCreatedUser: isNewlyCreatedUser } = (0, $6vgLy.useShouldExcludeUser)({
        checkDate: firstActiveDate,
        daysThreshold: activeDaysThreshold,
        cutoffDate: activeUserCutoffDate
    });
    if (loading) return {
        isNewUser: null,
        loading: true
    };
    if (error) return {
        isNewUser: null,
        error: error
    };
    return {
        isNewUser: isNewlyCreatedUser,
        loading: false,
        error: null
    };
};
module.exports["useIsNewUser"] = $affa2edf03b5b535$export$750d18e9348a361a;

});

parcelRegister("6vgLy", function(module, exports) {

var $gkHoc = parcelRequire("gkHoc");

var $6Mfv2 = parcelRequire("6Mfv2");

var $esV19 = parcelRequire("esV19");

const $859f2d1feb92d345$export$30b189c21f25ee23 = ({ checkDate: checkDate, daysThreshold: daysThreshold = 14, cutoffDate: cutoffDate })=>{
    // If there is no check date, we cannot determine if user is new
    if (!checkDate) return {
        shouldExclude: true,
        isNewlyCreatedUser: null,
        isNewUserAfterCutoffDate: false
    };
    const isNewlyCreatedUser = (0, $6Mfv2.default)((0, $gkHoc.default)(checkDate, daysThreshold), new Date());
    // Check if user is a new user (date is AFTER the cutoff date)
    // These users don't need changeboarding since it's all new to them
    const isNewUserAfterCutoffDate = cutoffDate && (0, $esV19.default)(cutoffDate) ? (0, $6Mfv2.default)(checkDate, cutoffDate) : false;
    const shouldExclude = isNewlyCreatedUser || isNewUserAfterCutoffDate;
    return {
        shouldExclude: shouldExclude,
        isNewlyCreatedUser: isNewlyCreatedUser,
        isNewUserAfterCutoffDate: isNewUserAfterCutoffDate
    };
};
module.exports["useShouldExcludeUser"] = $859f2d1feb92d345$export$30b189c21f25ee23;

});

parcelRegister("6KaG6", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $ce38ba3becf24406$export$877a45ed8043e865 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "K9Gzp",
    name: "ObjectSidebarPanel",
    loader: async ()=>(await (parcelRequire("eKETO"))).ObjectSidebarPanelWrapper
});
module.exports["ObjectSidebarPanel"] = $ce38ba3becf24406$export$877a45ed8043e865;

});

parcelRegister("eKETO", function(module, exports) {

let $abd51646464b6c11$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $abd51646464b6c11$var$load("fEhMd"),
    $abd51646464b6c11$var$load("7A87G"),
    $abd51646464b6c11$var$load("g9l6t"),
    $abd51646464b6c11$var$load("bAgF6"),
    $abd51646464b6c11$var$load("hhu66"),
    $abd51646464b6c11$var$load("hhss7"),
    $abd51646464b6c11$var$load("43z9c"),
    $abd51646464b6c11$var$load("7EorR"),
    $abd51646464b6c11$var$load("gr9Xf")
]).then(()=>parcelRequire('iFpSu'));

});

parcelRegister("7N1sB", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7sJoX = parcelRequire("7sJoX");


var $j6vyT = parcelRequire("j6vyT");


var $lpNn5 = parcelRequire("lpNn5");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $6mKj3 = parcelRequire("6mKj3");


var $euozR = parcelRequire("euozR");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4EKKB = parcelRequire("4EKKB");


var $aJPUt = parcelRequire("aJPUt");


var $9QIM2 = parcelRequire("9QIM2");


var $1P7Cq = parcelRequire("1P7Cq");


var $666Tc = parcelRequire("666Tc");

const $c0db869228662b46$var$i18n = (0, $kSwu1.defineMessages)({
    nextCommentLabel: {
        id: "inline-comments-common.next-comment-label",
        defaultMessage: "Next comment"
    },
    previousCommentLabel: {
        id: "inline-comments-common.previous-comment-label",
        defaultMessage: "Previous comment"
    },
    nextAnnotationLabel: {
        id: "inline-comments-common.next-annotation-label",
        defaultMessage: "Next"
    },
    previousAnnotationLabel: {
        id: "inline-comments-common.previous-annotation-label",
        defaultMessage: "Previous"
    }
});
const $c0db869228662b46$export$c7f093fedf3e73fe = (t0)=>{
    const $ = (0, $bDgLe.c)(48);
    const { isSSRFocusedComment: isSSRFocusedComment, goToNextInlineComment: goToNextInlineComment, goToPrevInlineComment: goToPrevInlineComment } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isEditorOpen = (0, $euozR.useIsEditorOpen)();
    const pageClass = (0, $9QIM2.usePageClass)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const t1 = isEditorOpen ? (0, $gnkil.UNIVERSAL_PREV_COMMENT_SHORTCUT) : (0, $gnkil.PREV_COMMENT_SHORTCUT);
    let t2;
    if ($[0] !== t1) {
        t2 = {
            shortcut: t1
        };
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const prevCommentShortcutStrings = (0, $4tOXV.useShortcutStrings)(t2);
    const t3 = isEditorOpen ? (0, $gnkil.UNIVERSAL_NEXT_COMMENT_SHORTCUT) : (0, $gnkil.NEXT_COMMENT_SHORTCUT);
    let t4;
    if ($[2] !== t3) {
        t4 = {
            shortcut: t3
        };
        $[2] = t3;
        $[3] = t4;
    } else t4 = $[3];
    const nextCommentShortcutStrings = (0, $4tOXV.useShortcutStrings)(t4);
    const renderServerPlaceholder = (0, $1P7Cq.useIsSSROrHydrating)();
    const noop = $c0db869228662b46$var$_temp;
    const isPageOrDoc = pageClass === "renderer" || pageClass === "editor";
    let t5;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $6mKj3.expVal)("confluence_inline_reactions", "isEnabled", false) ? $c0db869228662b46$var$i18n.previousAnnotationLabel : $c0db869228662b46$var$i18n.previousCommentLabel);
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $6mKj3.expVal)("confluence_inline_reactions", "isEnabled", false) ? $c0db869228662b46$var$i18n.previousAnnotationLabel : $c0db869228662b46$var$i18n.previousCommentLabel;
        $[5] = t6;
    } else t6 = $[5];
    let t7;
    if ($[6] !== formatMessage) {
        t7 = formatMessage(t6);
        $[6] = formatMessage;
        $[7] = t7;
    } else t7 = $[7];
    let t8;
    if ($[8] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), {
            label: t7,
            color: "var(--ds-icon-subtle, #505258)",
            spacing: "spacious",
            size: "small"
        });
        $[8] = t7;
        $[9] = t8;
    } else t8 = $[9];
    let t9;
    if ($[10] !== experienceTracker || $[11] !== goToPrevInlineComment || $[12] !== isPageOrDoc || $[13] !== isSSRFocusedComment || $[14] !== pageClass) {
        t9 = !isSSRFocusedComment ? ()=>{
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.start({
                pageClass: pageClass,
                entryPoint: "comment-navigation"
            });
            if (isPageOrDoc) experienceTracker.start({
                name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                timeout: (0, $aJPUt.ExperienceTimeout).VIEW_INLINE_COMMENT,
                attributes: {
                    entryPoint: "inline-comments-common/CommentNavigation",
                    pageClass: pageClass
                }
            });
            (0, $4EKKB.selectInlineComment).debug("Navigating to previous comment via button.");
            return goToPrevInlineComment();
        } : noop;
        $[10] = experienceTracker;
        $[11] = goToPrevInlineComment;
        $[12] = isPageOrDoc;
        $[13] = isSSRFocusedComment;
        $[14] = pageClass;
        $[15] = t9;
    } else t9 = $[15];
    let t10;
    if ($[16] !== isSSRFocusedComment || $[17] !== t8 || $[18] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $666Tc.InlineHeaderButton), {
            isSSRFocusedComment: isSSRFocusedComment,
            "data-cy": "inline-nav-previous",
            testId: "comment-navigation-prev",
            iconBefore: t8,
            onClick: t9
        });
        $[16] = isSSRFocusedComment;
        $[17] = t8;
        $[18] = t9;
        $[19] = t10;
    } else t10 = $[19];
    let t11;
    if ($[20] !== prevCommentShortcutStrings || $[21] !== t10) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: t5,
            shortcut: prevCommentShortcutStrings,
            hideTooltipOnClick: true,
            position: "top"
        }, t10);
        $[20] = prevCommentShortcutStrings;
        $[21] = t10;
        $[22] = t11;
    } else t11 = $[22];
    let t12;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $6mKj3.expVal)("confluence_inline_reactions", "isEnabled", false) ? $c0db869228662b46$var$i18n.nextAnnotationLabel : $c0db869228662b46$var$i18n.nextCommentLabel);
        $[23] = t12;
    } else t12 = $[23];
    let t13;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = (0, $6mKj3.expVal)("confluence_inline_reactions", "isEnabled", false) ? $c0db869228662b46$var$i18n.nextAnnotationLabel : $c0db869228662b46$var$i18n.nextCommentLabel;
        $[24] = t13;
    } else t13 = $[24];
    let t14;
    if ($[25] !== formatMessage) {
        t14 = formatMessage(t13);
        $[25] = formatMessage;
        $[26] = t14;
    } else t14 = $[26];
    let t15;
    if ($[27] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
            label: t14,
            color: "var(--ds-icon-subtle, #505258)",
            spacing: "spacious",
            size: "small"
        });
        $[27] = t14;
        $[28] = t15;
    } else t15 = $[28];
    let t16;
    if ($[29] !== experienceTracker || $[30] !== goToNextInlineComment || $[31] !== isPageOrDoc || $[32] !== isSSRFocusedComment || $[33] !== pageClass) {
        t16 = !isSSRFocusedComment ? ()=>{
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.start({
                pageClass: pageClass,
                entryPoint: "comment-navigation"
            });
            if (isPageOrDoc) experienceTracker.start({
                name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                timeout: (0, $aJPUt.ExperienceTimeout).VIEW_INLINE_COMMENT,
                attributes: {
                    entryPoint: "inline-comments-common/CommentNavigation",
                    pageClass: pageClass
                }
            });
            (0, $4EKKB.selectInlineComment).debug("Navigating to next comment via button.");
            return goToNextInlineComment();
        } : noop;
        $[29] = experienceTracker;
        $[30] = goToNextInlineComment;
        $[31] = isPageOrDoc;
        $[32] = isSSRFocusedComment;
        $[33] = pageClass;
        $[34] = t16;
    } else t16 = $[34];
    let t17;
    if ($[35] !== isSSRFocusedComment || $[36] !== t15 || $[37] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $666Tc.InlineHeaderButton), {
            isSSRFocusedComment: isSSRFocusedComment,
            "data-cy": "inline-nav-next",
            testId: "comment-navigation-next",
            iconBefore: t15,
            onClick: t16
        });
        $[35] = isSSRFocusedComment;
        $[36] = t15;
        $[37] = t16;
        $[38] = t17;
    } else t17 = $[38];
    let t18;
    if ($[39] !== nextCommentShortcutStrings || $[40] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: t12,
            shortcut: nextCommentShortcutStrings,
            hideTooltipOnClick: true,
            position: "top"
        }, t17);
        $[39] = nextCommentShortcutStrings;
        $[40] = t17;
        $[41] = t18;
    } else t18 = $[41];
    let t19;
    if ($[42] !== renderServerPlaceholder) {
        t19 = renderServerPlaceholder ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            id: "inline-comment-index"
        }) : null;
        $[42] = renderServerPlaceholder;
        $[43] = t19;
    } else t19 = $[43];
    let t20;
    if ($[44] !== t11 || $[45] !== t18 || $[46] !== t19) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $666Tc.NavigationContainer), {
            "data-testid": "comment-navigation-container"
        }, t11, t18, t19);
        $[44] = t11;
        $[45] = t18;
        $[46] = t19;
        $[47] = t20;
    } else t20 = $[47];
    return t20;
};
function $c0db869228662b46$var$_temp() {}
module.exports["CommentNavigation"] = $c0db869228662b46$export$c7f093fedf3e73fe;

});

parcelRegister("euozR", function(module, exports) {

var $7rovI = parcelRequire("7rovI");


var $efvKr = parcelRequire("efvKr");


var $de2j9 = parcelRequire("de2j9");

const $8e83317b0c681e7b$export$1cffcb5a5e9a9c48 = ()=>{
    const [t0] = (0, $efvKr.useLivePageMode)();
    const { isEditMode: isLiveEditMode } = t0;
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const { isAvailable: isAccessLinkEditAvailable, isEditMode: isAccessLinkEditing } = (0, $7rovI.useAccessLinkEditMode)();
    const isEditorOpen = isLiveEditMode || isOnEditRoute || isAccessLinkEditAvailable && isAccessLinkEditing;
    return isEditorOpen;
};
module.exports["useIsEditorOpen"] = $8e83317b0c681e7b$export$1cffcb5a5e9a9c48;

});

parcelRegister("iXzFq", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $jlIaF = parcelRequire("jlIaF");

const $71e3d8e13a87be5f$var$getLegacyActionUrl = (redirectToEditor, contentId)=>{
    if (redirectToEditor) return `${0, $jlIaF.CONTEXT_PATH}/pages/resumedraft.action?draftId=${contentId}`;
    return `${0, $jlIaF.CONTEXT_PATH}/pages/viewpage.action?pageId=${contentId}`;
};
const $71e3d8e13a87be5f$export$11b68a3633074ac0 = ({ contentType: contentType, contentSubType: contentSubType = null, contentId: contentId, spaceKey: spaceKey, redirectToEditor: redirectToEditor = false, useLegacyActionUrl: useLegacyActionUrl = false })=>{
    if (!contentId) return null;
    // assume all page sub types will only redirect to view page
    // can refactor to be more specific if needed
    if (contentType === 'page' && contentSubType !== null) return (0, $1NBp8.VIEW_PAGE).toUrl({
        spaceKey: spaceKey,
        contentId: contentId
    });
    if (contentType === 'page' && useLegacyActionUrl) return $71e3d8e13a87be5f$var$getLegacyActionUrl(redirectToEditor, contentId);
    if (contentType === 'page' && redirectToEditor) return (0, $1NBp8.EDIT_PAGE_V2).toUrl({
        spaceKey: spaceKey,
        contentType: 'pages',
        contentId: contentId
    });
    if (contentType === 'blogpost' && redirectToEditor) return (0, $1NBp8.EDIT_BLOG_V2).toUrl({
        spaceKey: spaceKey,
        contentId: contentId,
        contentType: 'blog'
    });
    switch(contentType){
        case 'page':
            return (0, $1NBp8.VIEW_PAGE).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'blogpost':
            return (0, $1NBp8.VIEW_BLOG).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'whiteboard':
            return (0, $1NBp8.WHITEBOARD_BOARD).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'database':
            return (0, $1NBp8.DATABASE_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'slide':
            return (0, $1NBp8.SLIDES_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'embed':
            return (0, $1NBp8.EMBED_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'folder':
            return (0, $1NBp8.FOLDER_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
    }
    return null;
};
module.exports["getUrlForContentType"] = $71e3d8e13a87be5f$export$11b68a3633074ac0;

});

parcelRegister("3Xfhj", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $bf3492583e212e7a$export$cf8a0a38543b2f6c = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "EfLS5",
    loader: async ()=>(await (parcelRequire("8xE3g"))).PageContentRendererFabric,
    name: 'PageContentRendererFabric'
});

const $bf3492583e212e7a$export$43e0568dbf658f88 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "VZbpe",
    loader: async ()=>(await (parcelRequire("8j2Mq"))).PageContentRendererTiny,
    name: 'PageContentRendererTiny'
});
module.exports["PageContentRendererFabric"] = $bf3492583e212e7a$export$cf8a0a38543b2f6c;
module.exports["PageContentRendererTiny"] = $bf3492583e212e7a$export$43e0568dbf658f88;

});

parcelRegister("8xE3g", function(module, exports) {

let $63807936e4fd3c2c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $63807936e4fd3c2c$var$load("kT6dz"),
    $63807936e4fd3c2c$var$load("6WNyl"),
    $63807936e4fd3c2c$var$load("ezYRV"),
    $63807936e4fd3c2c$var$load("50xKF"),
    $63807936e4fd3c2c$var$load("lkHIj"),
    $63807936e4fd3c2c$var$load("b8BFA"),
    $63807936e4fd3c2c$var$load("hFd8H"),
    $63807936e4fd3c2c$var$load("7BHAC"),
    $63807936e4fd3c2c$var$load("N3TvS"),
    $63807936e4fd3c2c$var$load("6Qybl"),
    $63807936e4fd3c2c$var$load("fxlto"),
    $63807936e4fd3c2c$var$load("2F69B"),
    $63807936e4fd3c2c$var$load("53Y0O"),
    $63807936e4fd3c2c$var$load("kYlwR"),
    $63807936e4fd3c2c$var$load("5Op3U"),
    $63807936e4fd3c2c$var$load("gbis9"),
    $63807936e4fd3c2c$var$load("RylUf"),
    $63807936e4fd3c2c$var$load("bABRe"),
    $63807936e4fd3c2c$var$load("7SteV"),
    $63807936e4fd3c2c$var$load("64FEU"),
    $63807936e4fd3c2c$var$load("4aKct"),
    $63807936e4fd3c2c$var$load("dxcsb"),
    $63807936e4fd3c2c$var$load("6dLts"),
    $63807936e4fd3c2c$var$load("jdPbE"),
    $63807936e4fd3c2c$var$load("eUsnQ"),
    $63807936e4fd3c2c$var$load("L98h8"),
    $63807936e4fd3c2c$var$load("dfVn7"),
    $63807936e4fd3c2c$var$load("fEhMd"),
    $63807936e4fd3c2c$var$load("keazL"),
    $63807936e4fd3c2c$var$load("dhXIT"),
    $63807936e4fd3c2c$var$load("7gL7H"),
    $63807936e4fd3c2c$var$load("ea3NB"),
    $63807936e4fd3c2c$var$load("6wr18"),
    $63807936e4fd3c2c$var$load("59hV4"),
    $63807936e4fd3c2c$var$load("lrmeP"),
    $63807936e4fd3c2c$var$load("6fY3H"),
    $63807936e4fd3c2c$var$load("dtNxV"),
    $63807936e4fd3c2c$var$load("9zpfi"),
    $63807936e4fd3c2c$var$load("9pNir"),
    $63807936e4fd3c2c$var$load("a7sEM"),
    $63807936e4fd3c2c$var$load("aLbuU"),
    $63807936e4fd3c2c$var$load("ffEVr"),
    $63807936e4fd3c2c$var$load("a6kGP"),
    $63807936e4fd3c2c$var$load("dB5kj"),
    $63807936e4fd3c2c$var$load("dIY7W"),
    $63807936e4fd3c2c$var$load("8lMr1"),
    $63807936e4fd3c2c$var$load("1vUE6"),
    $63807936e4fd3c2c$var$load("h0X0x"),
    $63807936e4fd3c2c$var$load("7l4Nc"),
    $63807936e4fd3c2c$var$load("fEvpQ"),
    $63807936e4fd3c2c$var$load("Wowvf"),
    $63807936e4fd3c2c$var$load("4g6rd"),
    $63807936e4fd3c2c$var$load("7g00Y"),
    $63807936e4fd3c2c$var$load("fWCBZ"),
    $63807936e4fd3c2c$var$load("7A87G"),
    $63807936e4fd3c2c$var$load("2nsSd"),
    $63807936e4fd3c2c$var$load("hhss7"),
    $63807936e4fd3c2c$var$load("75JEs"),
    $63807936e4fd3c2c$var$load("lywre"),
    $63807936e4fd3c2c$var$load("43z9c"),
    $63807936e4fd3c2c$var$load("7EorR"),
    $63807936e4fd3c2c$var$load("kNILH")
]).then(()=>parcelRequire('8ThhQ'));

});

parcelRegister("8j2Mq", function(module, exports) {

let $60c24126546edd83$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $60c24126546edd83$var$load("4g6rd"),
    $60c24126546edd83$var$load("7g00Y"),
    $60c24126546edd83$var$load("bm0oR"),
    $60c24126546edd83$var$load("61Bv2"),
    $60c24126546edd83$var$load("30b92"),
    $60c24126546edd83$var$load("keazL"),
    $60c24126546edd83$var$load("dhXIT"),
    $60c24126546edd83$var$load("ea3NB"),
    $60c24126546edd83$var$load("6wr18"),
    $60c24126546edd83$var$load("59hV4"),
    $60c24126546edd83$var$load("fuOfV"),
    $60c24126546edd83$var$load("jL1Ke"),
    $60c24126546edd83$var$load("5MQ0D"),
    $60c24126546edd83$var$load("ffEVr"),
    $60c24126546edd83$var$load("5gsbh"),
    $60c24126546edd83$var$load("h0X0x"),
    $60c24126546edd83$var$load("7l4Nc"),
    $60c24126546edd83$var$load("fwbNS"),
    $60c24126546edd83$var$load("h4Nf7"),
    $60c24126546edd83$var$load("Wowvf"),
    $60c24126546edd83$var$load("fWCBZ"),
    $60c24126546edd83$var$load("hhss7"),
    $60c24126546edd83$var$load("43z9c"),
    $60c24126546edd83$var$load("7EorR"),
    $60c24126546edd83$var$load("e9VVN")
]).then(()=>parcelRequire('ixmFo'));

});

parcelRegister("ayQVU", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

// editor property is expected to be:
//   1. ""    -> auto conversion will happen
//   2. "v2"  -> explicitly using fabric editor
//   3. "v1"  -> explicitly using tinyMCE editor
// when parsing editor property, if neither of the above data is received,
// then it's an unexpected case and we set it as "unset" for analytics.
function $0e83f72969672585$var$parseEditorProperty(value) {
    if (!value) return '';
    if (value?.includes('v2')) return 'v2';
    if (value?.includes('v1')) return 'v1';
    return 'unset';
}
function $0e83f72969672585$export$a53517c120ec9f4(content) {
    const contentProperties = content?.properties?.nodes;
    const editorInfo = contentProperties?.filter((p)=>p?.key === 'editor');
    const editorPropertieValueRaw = editorInfo?.[0]?.value;
    const editorProperty = $0e83f72969672585$var$parseEditorProperty(editorPropertieValueRaw);
    if (content && 'metadata' in content && content?.metadata?.frontend && 'fabricEditorSupported' in content.metadata.frontend) return {
        queryDataId: content?.id,
        editorProperty: editorProperty,
        fabricEditorSupported: content?.metadata?.frontend?.fabricEditorSupported,
        isAutoConverted: (0, $9wGTI.fg)('confluence_editor_auto-convert_changes') ? !!content?.metadata?.frontend?.fabricEditorSupported && // For pages migrated from DC, with editor property not set, it's easy,
        // they'll always be auto-converted. We explicitly set the editor property
        // to v1 when reverting back to TinyMCE.
        (editorProperty === '' || // For pages created in cloud, with editor property set to v1, we only want to show
        // the auto-conversion settings when it is initially converted to fabric editor.
        // This means the editor property is still set to TinyMCE (v1) but the page is Fabric Editor.
        editorProperty === 'v1' && content?.body?.dynamic?.representation === 'atlas_doc_format') : undefined
    };
    return {
        queryDataId: content?.id,
        editorProperty: editorProperty,
        fabricEditorSupported: null,
        isAutoConverted: (0, $9wGTI.fg)('confluence_editor_auto-convert_changes') ? false : undefined
    };
}
module.exports["getAutoConvertionInfo"] = $0e83f72969672585$export$a53517c120ec9f4;

});

parcelRegister("IxgpR", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $bQm3c = parcelRequire("bQm3c");

const $0e9e4b59a5aca70c$var$isLocaleStringEnglish = (locale = '')=>{
    const englishPrefix = 'en';
    return locale.toLowerCase().startsWith(englishPrefix);
};
const $0e9e4b59a5aca70c$export$c43edf0c6374359f = ({ localeChecks: localeChecks = [
    'session',
    'intl'
] } = {})=>{
    const { locale: intlLocale = '' } = (0, $kSwu1.useIntl)() || {};
    const { locale: sessionLocale = '' } = (0, $bQm3c.useSessionData)() || {};
    const localeCheckers = {
        session: ()=>$0e9e4b59a5aca70c$var$isLocaleStringEnglish(sessionLocale),
        intl: ()=>$0e9e4b59a5aca70c$var$isLocaleStringEnglish(intlLocale)
    };
    return localeChecks.every((check)=>localeCheckers[check]());
};
module.exports["useCheckIsLocaleEnglish"] = $0e9e4b59a5aca70c$export$c43edf0c6374359f;

});

parcelRegister("kymtV", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kcIQr = parcelRequire("kcIQr");


var $8aF6s = parcelRequire("8aF6s");


var $jBejw = parcelRequire("jBejw");


var $gsAuf = parcelRequire("gsAuf");

const $9bfe716549ab8714$export$1ec43e43e3a28820 = ()=>{
    const { createAndResolve: createAndResolve, loading: loading } = (0, $gsAuf.useCreatePagePdfExportTask)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { createEvent: createEvent } = (0, $kcIQr.useConfluenceAnalyticsEvents)();
    const startExport = (0, $cozmU.useCallback)(async ({ contentId: contentId, contentType: contentType, url: url, source: source = 'menu' })=>{
        const commonAttributes = {
            contentId: contentId,
            contentType: contentType ?? null,
            exportSource: source
        };
        // One track event per create attempt (funnel entry for every surface, including legacy which
        // opens no modal) carrying the resolved decision and backend error code. Shared by the
        // initial run and "Try again" so both are instrumented identically.
        const runCreate = async ()=>{
            const result = await createAndResolve(contentId, contentType);
            if (result.type === 'error') createEvent({
                type: 'sendTrackEvent',
                data: {
                    source: 'pagePdfExport',
                    action: 'failed',
                    actionSubject: 'pagePdfExportCreate',
                    attributes: {
                        ...commonAttributes,
                        decision: 'error',
                        reason: result.reason,
                        errorCode: result.errorCode ?? null,
                        statusCode: result.statusCode ?? null
                    }
                }
            }).fire();
            else createEvent({
                type: 'sendTrackEvent',
                data: {
                    source: 'pagePdfExport',
                    action: 'succeeded',
                    actionSubject: 'pagePdfExportCreate',
                    attributes: {
                        ...commonAttributes,
                        decision: result.type,
                        exportTaskId: result.type === 'modal' ? result.exportTaskId ?? null : null
                    }
                }
            }).fire();
            return result;
        };
        // Real "Try again": re-run the same create flow. Defined once here so the overflow menu and
        // the Cmd/Ctrl+P shortcut share identical retry behaviour. A legacy decision navigates to
        // the hidden-action URL as a side effect; the modal maps modal/error decisions itself.
        const onRetry = async ()=>{
            const retryDecision = await runCreate();
            if (retryDecision.type === 'legacy' && url) window.location.assign(url);
            return retryDecision;
        };
        const decision = await runCreate();
        switch(decision.type){
            case 'legacy':
                // V1/V2: navigate to the hidden-action URL when the caller provided one. Callers that
                // own their own legacy fallback (e.g. the print shortcut) omit `url`, and act on the
                // returned `legacy` decision instead.
                if (url) window.location.assign(url);
                break;
            case 'modal':
                showModal((0, $jBejw.PagePdfExportModal), {
                    contentId: contentId,
                    contentType: contentType,
                    exportTaskId: decision.exportTaskId,
                    source: source,
                    onRetry: onRetry
                });
                break;
            case 'error':
            default:
                // Open the modal in its built-in error state (null task id); "Try again" re-runs create.
                showModal((0, $jBejw.PagePdfExportModal), {
                    contentId: contentId,
                    contentType: contentType,
                    exportTaskId: null,
                    source: source,
                    onRetry: onRetry
                });
                break;
        }
        return decision;
    }, [
        createAndResolve,
        createEvent,
        showModal
    ]);
    return {
        startExport: startExport,
        loading: loading
    };
};
module.exports["useStartPagePdfExport"] = $9bfe716549ab8714$export$1ec43e43e3a28820;

});

parcelRegister("jBejw", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $e57c66f2698c5617$export$d106071c054f3436 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "1xkUz",
    name: "PagePdfExportModal",
    loader: async ()=>(await (parcelRequire("diSC0"))).PagePdfExportModal
});
module.exports["PagePdfExportModal"] = $e57c66f2698c5617$export$d106071c054f3436;

});

parcelRegister("diSC0", function(module, exports) {

let $9af7519a8320c87f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9af7519a8320c87f$var$load("6wr18"),
    $9af7519a8320c87f$var$load("dxcsb"),
    $9af7519a8320c87f$var$load("99ObF"),
    $9af7519a8320c87f$var$load("ffEVr"),
    $9af7519a8320c87f$var$load("oKrxj")
]).then(()=>parcelRequire('liWq5'));

});

parcelRegister("gsAuf", function(module, exports) {

var $fM8Mx = parcelRequire("fM8Mx");


var $cozmU = parcelRequire("cozmU");


var $5BvyC = parcelRequire("5BvyC");

var $8jDil = parcelRequire("8jDil");


var $308Wd = parcelRequire("308Wd");


var $bQm3c = parcelRequire("bQm3c");


var $b0AwI = parcelRequire("b0AwI");

/**
 * The `contentId` mutation input is typed `ID!` but the backend expects a type-specific Confluence
 * content ARI — `blogpost/…` for blogposts, `page/…` for everything else. Live docs are
 * `contentType === 'page'`, so they correctly resolve to a page ARI.
 */ const $01eed5ca3125a453$var$buildContentAri = (cloudId, contentId, contentType)=>contentType === 'blogpost' ? (0, $5BvyC.ConfluenceBlogpostAri).create({
        siteId: cloudId,
        blogpostId: contentId
    }).toString() : (0, $8jDil.ConfluencePageAri).create({
        siteId: cloudId,
        pageId: contentId
    }).toString();
const $01eed5ca3125a453$var$CREATE_PDF_EXPORT_TASK_MUTATION = (0, $fM8Mx.default);
const $01eed5ca3125a453$export$c9155252c3ac4484 = ()=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [createTask, { loading: loading }] = (0, $308Wd.useMutationInterop)($01eed5ca3125a453$var$CREATE_PDF_EXPORT_TASK_MUTATION, {
        __callerPackage__: "page-pdf-export"
    });
    const createAndResolve = (0, $cozmU.useCallback)(async (contentId, contentType)=>{
        let createResult;
        try {
            const result = await createTask({
                variables: {
                    contentId: $01eed5ca3125a453$var$buildContentAri(cloudId, contentId, contentType)
                }
            });
            const payload = result?.data?.confluence_createPdfExportTaskForSingleContent;
            createResult = payload ? {
                success: payload.success,
                exportVersion: payload.exportVersion,
                exportTaskId: payload.exportTaskId,
                errors: payload.errors?.map((error)=>({
                        message: error?.message ?? null,
                        extensions: error?.extensions ? {
                            errorType: error.extensions.errorType ?? null,
                            statusCode: error.extensions.statusCode ?? null
                        } : null
                    })) ?? null
            } : undefined;
        } catch (error) {
            createResult = undefined;
        }
        return (0, $b0AwI.resolvePagePdfExportCreateResult)({
            createResult: createResult,
            isExperimentEnabled: true
        });
    }, [
        createTask,
        cloudId
    ]);
    return {
        createAndResolve: createAndResolve,
        loading: loading
    };
};
module.exports["useCreatePagePdfExportTask"] = $01eed5ca3125a453$export$c9155252c3ac4484;

});

parcelRegister("fM8Mx", function(module, exports) {
/**
 * @generated SignedSource<<a3e608f92169bde9e02a07e39432e594>>
 * @relayHash 96dce17396b98402ea852d82fd7ba6ba
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0cc26de84f1d64f1941793801db3e6df205067025012647431441512d2deafb8
const $3b0cc2b76685a2ca$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "exportTaskId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "exportVersion"
    }, v5 = {
        "kind": "ScalarField",
        "name": "message"
    }, v6 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v7 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useCreatePagePdfExportTaskMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceCreatePdfExportTaskForSingleContentPayload",
                    "kind": "LinkedField",
                    "name": "confluence_createPdfExportTaskForSingleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useCreatePagePdfExportTaskMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceCreatePdfExportTaskForSingleContentPayload",
                    "kind": "LinkedField",
                    "name": "confluence_createPdfExportTaskForSingleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "96dce17396b98402ea852d82fd7ba6ba",
            "id": "0cc26de84f1d64f1941793801db3e6df205067025012647431441512d2deafb8",
            "metadata": {},
            "name": "useCreatePagePdfExportTaskMutation",
            "operationKind": "mutation",
            "text": "mutation useCreatePagePdfExportTaskMutation($contentId:ID!){confluence_createPdfExportTaskForSingleContent(input:{contentId:$contentId}){success,exportTaskId,exportVersion,errors{message,extensions{__typename,errorType,statusCode,...on BulkMutationErrorExtension{id}}}}}"
        }
    };
}();
$3b0cc2b76685a2ca$var$node.hash = "744df54379316c281f95d3307db18404";
var $3b0cc2b76685a2ca$export$2e2bcd8739ae039 = $3b0cc2b76685a2ca$var$node;
module.exports["default"] = $3b0cc2b76685a2ca$export$2e2bcd8739ae039;

});

parcelRegister("b0AwI", function(module, exports) {
const $da9c7f91e4b9420f$export$3ccc38d5bb117541 = ({ createResult: createResult, isExperimentEnabled: isExperimentEnabled })=>{
    if (!createResult || createResult.success === false || Boolean(createResult.errors?.length)) {
        const errorCode = createResult?.errors?.map((error)=>error?.extensions?.errorType).find((value)=>Boolean(value)) ?? null;
        const statusCode = createResult?.errors?.map((error)=>error?.extensions?.statusCode).find((value)=>value != null) ?? null;
        return {
            type: 'error',
            reason: 'create-failed',
            errorCode: errorCode,
            statusCode: statusCode
        };
    }
    if (!isExperimentEnabled) return {
        type: 'legacy'
    };
    switch(createResult.exportVersion){
        case 'V1':
        case 'V2':
            return {
                type: 'legacy'
            };
        case 'V3':
            return {
                type: 'modal',
                exportTaskId: createResult.exportTaskId
            };
        default:
            return {
                type: 'error',
                reason: 'unsupported-export-version'
            };
    }
};
module.exports["resolvePagePdfExportCreateResult"] = $da9c7f91e4b9420f$export$3ccc38d5bb117541;

});

parcelRegister("lOI2p", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $d8ad782c0a3406d7$export$8cca2d6324f11821 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { onClose: onClose, popupRef: popupRef, triggerRef: triggerRef } = t0;
    let t1;
    let t2;
    if ($[0] !== onClose || $[1] !== popupRef || $[2] !== triggerRef) {
        t1 = ()=>{
            if (!popupRef) return;
            const keyDownEvent = (t3)=>{
                const { key: key } = t3;
                if (key === "Escape" || key === "Esc") onClose();
            };
            const clickEvent = (event)=>{
                if (!document.body.contains(event.target)) return;
                if (popupRef && popupRef.contains(event.target)) return;
                if (triggerRef && triggerRef.contains(event.target)) return;
                if (event.target.closest(".atlaskit-portal-container [role=dialog]")) return;
                onClose();
            };
            window.addEventListener("click", clickEvent);
            window.addEventListener("keydown", keyDownEvent);
            return ()=>{
                window.removeEventListener("click", clickEvent);
                window.removeEventListener("keydown", keyDownEvent);
            };
        };
        t2 = [
            popupRef,
            triggerRef,
            onClose
        ];
        $[0] = onClose;
        $[1] = popupRef;
        $[2] = triggerRef;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
} : ({ onClose: onClose, popupRef: popupRef, triggerRef: triggerRef })=>{
    (0, $cozmU.useEffect)(()=>{
        if (!popupRef) return;
        const keyDownEvent = ({ key: key })=>{
            if (key === 'Escape' || key === 'Esc') onClose();
        };
        const clickEvent = (event)=>{
            // Refresh button inside Forge app triggers earlier then clickEvent
            // Forge App starts update and popup does not have event.target anymore
            if (!document.body.contains(event.target)) return;
            // Do not close if interaction was performed on the current popup
            if (popupRef && popupRef.contains(event.target)) return;
            // Do not close if interaction was performed on the trigger container
            if (triggerRef && triggerRef.contains(event.target)) return;
            // Do not close if interaction was performed on the ModalDialog with an error
            if (event.target.closest('.atlaskit-portal-container [role=dialog]')) return;
            onClose();
        };
        window.addEventListener('click', clickEvent);
        window.addEventListener('keydown', keyDownEvent);
        return ()=>{
            window.removeEventListener('click', clickEvent);
            window.removeEventListener('keydown', keyDownEvent);
        };
    }, [
        popupRef,
        triggerRef,
        onClose
    ]);
};
module.exports["useInlineDialogCloseManager"] = $d8ad782c0a3406d7$export$8cca2d6324f11821;

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("gektR", function(module, exports) {

var $kNIYN = parcelRequire("kNIYN");


var $jVylI = parcelRequire("jVylI");

class $904056f857fff237$export$e38a13e9484b72c7 extends (0, $kNIYN.Container) {
    constructor(...args){
        super(...args);
        this.state = {
            alignmentButtonState: (0, $jVylI.TitleAlignmentType).LEFT,
            isUpdatingAlignment: false,
            isLoadingComplete: false
        };
        this.toggleAlignmentButton = (newAlignmentState)=>{
            if (this.state.alignmentButtonState !== newAlignmentState) this.setState({
                alignmentButtonState: newAlignmentState || (0, $jVylI.TitleAlignmentType).LEFT
            });
        };
        this.setIsLoadingComplete = (isLoadingComplete)=>{
            this.setState({
                isLoadingComplete: isLoadingComplete
            });
        };
        this.setIsUpdatingAlignment = (isUpdatingAlignment)=>{
            this.setState({
                isUpdatingAlignment: isUpdatingAlignment
            });
        };
        this.resetToDefaults = ()=>{
            this.setState({
                alignmentButtonState: (0, $jVylI.TitleAlignmentType).LEFT,
                isUpdatingAlignment: false,
                isLoadingComplete: false
            });
        };
    }
}
module.exports["AlignmentButtonContainer"] = $904056f857fff237$export$e38a13e9484b72c7;

});

parcelRegister("63EIj", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $36c7522a305dc07d$export$cbe74da24be93fbd = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "lwzlE",
    name: "RendererContentState",
    loader: async ()=>(await (parcelRequire("iuP36"))).RendererContentState
});
module.exports["RendererContentState"] = $36c7522a305dc07d$export$cbe74da24be93fbd;

});

parcelRegister("iuP36", function(module, exports) {

let $d772a0a32c3c5c2c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d772a0a32c3c5c2c$var$load("ezYRV"),
    $d772a0a32c3c5c2c$var$load("hhss7"),
    $d772a0a32c3c5c2c$var$load("9opeZ")
]).then(()=>parcelRequire('44FvL'));

});

parcelRegister("4wEOc", function(module, exports) {

var $hGuUS = parcelRequire("hGuUS");


var $jMyy4 = parcelRequire("jMyy4");

'use no memo';
const $17b0e005176b05e7$var$UseIsDataClassificationEnabledForOrgQuery = (0, $hGuUS.default);
const $17b0e005176b05e7$export$2e6840e38da4c328 = ({ skip: skip = false } = {})=>{
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($17b0e005176b05e7$var$UseIsDataClassificationEnabledForOrgQuery, {
        context: {
            single: true
        },
        skip: skip,
        __callerPackage__: "data-classification"
    });
    const isEnabled = Boolean(data?.isDataClassificationEnabled);
    return {
        isEnabled: isEnabled,
        error: error,
        loading: loading
    };
};
module.exports["useIsDataClassificationEnabledForOrg"] = $17b0e005176b05e7$export$2e6840e38da4c328;

});

parcelRegister("hGuUS", function(module, exports) {
/**
 * @generated SignedSource<<4d55aa969e816897d00319e58e9ae80b>>
 * @relayHash 7a459e5b02d70f6bd0fcfe9c6f09aaed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f7439efefbddad3c834c2882c87168c3d526f7ef715c67e6eb50135d0daa5fbe
const $d06bb9e5b53f54be$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "isDataClassificationEnabled"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useIsDataClassificationEnabledForOrgQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useIsDataClassificationEnabledForOrgQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "7a459e5b02d70f6bd0fcfe9c6f09aaed",
            "id": "f7439efefbddad3c834c2882c87168c3d526f7ef715c67e6eb50135d0daa5fbe",
            "metadata": {},
            "name": "useIsDataClassificationEnabledForOrgQuery",
            "operationKind": "query",
            "text": "query useIsDataClassificationEnabledForOrgQuery{isDataClassificationEnabled}"
        }
    };
}();
$d06bb9e5b53f54be$var$node.hash = "5fefa316f3ebea3d1e92d59f94b250db";
var $d06bb9e5b53f54be$export$2e2bcd8739ae039 = $d06bb9e5b53f54be$var$node;
module.exports["default"] = $d06bb9e5b53f54be$export$2e2bcd8739ae039;

});

parcelRegister("dpqzw", function(module, exports) {
const $e10f62297c04a73f$export$51c8f3f20bd49804 = 'fabric-editor-popup-scroll-parent';
const $e10f62297c04a73f$export$547bf96576574b25 = '.ProseMirror > *';
const $e10f62297c04a73f$export$f76b40820c13783a = '.ak-renderer-document';
const $e10f62297c04a73f$export$7718f42d39a9217b = 'content';
module.exports["EDITOR_PARENT_CLASS"] = $e10f62297c04a73f$export$51c8f3f20bd49804;
module.exports["EDITOR_CHILDREN_SELECTOR"] = $e10f62297c04a73f$export$547bf96576574b25;
module.exports["RENDERED_CONTENT_SELECTOR"] = $e10f62297c04a73f$export$f76b40820c13783a;
module.exports["FABRIC_PAGE_CONTENT_ID"] = $e10f62297c04a73f$export$7718f42d39a9217b;

});

parcelRegister("gkIgp", function(module, exports) {
var $44e99c386783fe05$export$ea1a2a449eaeaa2d = /*#__PURE__*/ function(CollabServiceProperty) {
    CollabServiceProperty["NCS"] = "ncs";
    CollabServiceProperty["SYNCHRONY"] = "synchrony";
    return CollabServiceProperty;
}({});
module.exports["CollabServiceProperty"] = $44e99c386783fe05$export$ea1a2a449eaeaa2d;

});

parcelRegister("4ri4I", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $4d309a7dc7a1cda3$export$64697004958d0ff1 = {
    editSource: ''
};
const $4d309a7dc7a1cda3$var$Store = (0, $8s9DV.createStore)({
    initialState: {
        ...$4d309a7dc7a1cda3$export$64697004958d0ff1
    },
    actions: {
        setEditSource: (editSource)=>({ setState: setState })=>{
                setState({
                    editSource: editSource
                });
            }
    },
    name: 'setEditSource'
});
const $4d309a7dc7a1cda3$export$ee479a8e5902b302 = (0, $kBr4q.createHook)($4d309a7dc7a1cda3$var$Store);
const $4d309a7dc7a1cda3$export$7e972f51583fdb8e = (0, $kBr4q.createActionsHook)($4d309a7dc7a1cda3$var$Store);
module.exports["useEditSource"] = $4d309a7dc7a1cda3$export$ee479a8e5902b302;
module.exports["useEditSourceActions"] = $4d309a7dc7a1cda3$export$7e972f51583fdb8e;

});

parcelRegister("5zmqi", function(module, exports) {
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports

var $c0rhi = parcelRequire("c0rhi");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $nIvaQ = parcelRequire("nIvaQ");


var $4qUu8 = parcelRequire("4qUu8");

const $59f6faa17a0b40be$var$COLLAB_DRAFT_VARIABLES = (contentId)=>({
        id: contentId,
        hydrateAdf: true
    });
const $59f6faa17a0b40be$export$81644b1180210cfe = async (contentId)=>{
    let convertedBody;
    try {
        const monolithResult = await (0, $c0rhi.queryInterop)({
            query: (0, $4qUu8.MarkdownConvertedBodyQuery),
            context: {
                single: true
            },
            fetchPolicy: 'network-only',
            variables: {
                contentId: contentId,
                status: [
                    'draft',
                    'current'
                ]
            },
            __callerPackage__: "content-markdown-mode"
        });
        const value = monolithResult?.data?.content?.nodes?.[0]?.body?.atlas_doc_format?.value;
        if (typeof value === 'string' && value.length > 0) convertedBody = value;
    } catch  {
        return undefined;
    }
    if (!convertedBody) return undefined;
    // Best-effort cache mirror. Isolated so a cache miss / write failure does
    // not drop the body the caller needs for `replaceDocument` — that path
    // is what keeps the editor populated across the mode flip.
    const collabDraftQuery = (0, $nIvaQ.getCollabDraftQuery)();
    try {
        const existing = (0, $l1uFv.readQueryInterop)({
            query: collabDraftQuery,
            variables: $59f6faa17a0b40be$var$COLLAB_DRAFT_VARIABLES(contentId),
            __callerPackage__: "content-markdown-mode"
        });
        // Preserve version + metadata (incl. `relevance` on the WithRelevance
        // variant); swap only `document`.
        (0, $fEmGS.writeQueryInterop)({
            query: collabDraftQuery,
            variables: $59f6faa17a0b40be$var$COLLAB_DRAFT_VARIABLES(contentId),
            data: {
                collabDraft: {
                    ...existing?.collabDraft,
                    document: convertedBody
                }
            },
            __callerPackage__: "content-markdown-mode"
        });
    } catch  {
    // see JSDoc
    }
    return convertedBody;
};
module.exports["refetchPageContent"] = $59f6faa17a0b40be$export$81644b1180210cfe;

});

parcelRegister("4qUu8", function(module, exports) {

var $1Qv9J = parcelRequire("1Qv9J");

const $0faef94ba621a68c$export$76c2bcd049e9b532 = (0, $1Qv9J.default);
module.exports["MarkdownConvertedBodyQuery"] = $0faef94ba621a68c$export$76c2bcd049e9b532;

});

parcelRegister("1Qv9J", function(module, exports) {
/**
 * @generated SignedSource<<9ba1093d2faffa7671c8a9ee5e67ea5a>>
 * @relayHash ec1aaca340bdd49293f1094fa3362f18
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c81830ee1f700a3e723bb561e8443b4ce4e0320dccd87bb214ea614cd125bf54
const $6562e0b89e6e4559$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentBodyPerRepresentation",
                            "kind": "LinkedField",
                            "name": "body",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentBody",
                                    "kind": "LinkedField",
                                    "name": "atlas_doc_format",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "MarkdownConvertedBodyQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "MarkdownConvertedBodyQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "ec1aaca340bdd49293f1094fa3362f18",
            "id": "c81830ee1f700a3e723bb561e8443b4ce4e0320dccd87bb214ea614cd125bf54",
            "metadata": {},
            "name": "MarkdownConvertedBodyQuery",
            "operationKind": "query",
            "text": "query MarkdownConvertedBodyQuery($contentId:ID!,$status:[String]!){content(id:$contentId,status:$status){nodes{id,body{atlas_doc_format{value}}}}}"
        }
    };
}();
$6562e0b89e6e4559$var$node.hash = "2652b00bc6d31f1e4785aeb0c45e5e03";
var $6562e0b89e6e4559$export$2e2bcd8739ae039 = $6562e0b89e6e4559$var$node;
module.exports["default"] = $6562e0b89e6e4559$export$2e2bcd8739ae039;

});

parcelRegister("hTLSK", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $l1uFv = parcelRequire("l1uFv");


var $308Wd = parcelRequire("308Wd");


var $fEmGS = parcelRequire("fEmGS");


var $bQm3c = parcelRequire("bQm3c");


var $aJUpe = parcelRequire("aJUpe");


var $3PFO2 = parcelRequire("3PFO2");

const $f198f33a94a9cbf9$export$b6672b8bd1ee20b6 = (contentId, isMarkdownMode, isMarkdownModeEnabled)=>{
    const variables = {
        contentId: contentId,
        isMarkdownModeEnabled: isMarkdownModeEnabled
    };
    try {
        const cached = (0, $l1uFv.readQueryInterop)({
            query: (0, $aJUpe.default),
            variables: variables,
            __callerPackage__: "content-markdown-mode"
        });
        const updatedNodes = (cached?.content?.nodes ?? []).map((node)=>{
            if (!node || node.id !== contentId) return node;
            return {
                ...node,
                contentProperties: {
                    ...node.contentProperties,
                    latest: {
                        ...node.contentProperties?.latest,
                        isMarkdownMode: isMarkdownMode
                    }
                }
            };
        });
        (0, $fEmGS.writeQueryInterop)({
            query: (0, $aJUpe.default),
            variables: variables,
            data: {
                content: {
                    ...cached?.content,
                    nodes: updatedNodes
                }
            },
            __callerPackage__: "content-markdown-mode"
        });
    } catch  {
    // Cache miss — see JSDoc.
    }
};
const $f198f33a94a9cbf9$export$3572aa176fa6e0e3 = ()=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [updateMarkdownModeMutation, { loading: loading, error: error }] = (0, $308Wd.useMutationInterop)((0, $3PFO2.default), {
        __callerPackage__: "content-markdown-mode"
    });
    const updateMarkdownMode = (0, $cozmU.useCallback)(async (contentId, isMarkdownMode)=>{
        try {
            const result = await updateMarkdownModeMutation({
                variables: {
                    cloudId: cloudId,
                    input: {
                        contentId: contentId,
                        isMarkdownMode: isMarkdownMode
                    }
                }
            });
            const payload = result?.data?.confluence_updateMarkdownMode;
            if (payload?.success) return {
                success: true
            };
            const errorMessage = payload?.errors?.[0]?.message ?? undefined;
            return {
                success: false,
                errorMessage: errorMessage
            };
        } catch (e) {
            const errorMessage = e instanceof Error ? e.message : undefined;
            return {
                success: false,
                errorMessage: errorMessage
            };
        }
    }, [
        cloudId,
        updateMarkdownModeMutation
    ]);
    return {
        updateMarkdownMode: updateMarkdownMode,
        loading: loading,
        error: error
    };
};
module.exports["patchIsMarkdownModeCache"] = $f198f33a94a9cbf9$export$b6672b8bd1ee20b6;
module.exports["useUpdateMarkdownMode"] = $f198f33a94a9cbf9$export$3572aa176fa6e0e3;

});

parcelRegister("3PFO2", function(module, exports) {
/**
 * @generated SignedSource<<fe0f747cedae005b17051370ed3320b8>>
 * @relayHash d0b91783b4821bd978a5d2fd0c120efd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 601f697afe038b9fda9c5a6d14bb839534ca3e6825e77daf39701b3165183f73
const $a1d16a3b56c472ef$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "ConfluenceUpdateMarkdownModePayload",
            "kind": "LinkedField",
            "name": "confluence_updateMarkdownMode",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "contentId"
                },
                {
                    "kind": "ScalarField",
                    "name": "isMarkdownMode"
                },
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "UpdateMarkdownModeMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "UpdateMarkdownModeMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "d0b91783b4821bd978a5d2fd0c120efd",
            "id": "601f697afe038b9fda9c5a6d14bb839534ca3e6825e77daf39701b3165183f73",
            "metadata": {},
            "name": "UpdateMarkdownModeMutation",
            "operationKind": "mutation",
            "text": "mutation UpdateMarkdownModeMutation($cloudId:ID!,$input:ConfluenceUpdateMarkdownModeInput!){confluence_updateMarkdownMode(cloudId:$cloudId,input:$input){contentId,isMarkdownMode,success,errors{message}}}"
        }
    };
}();
$a1d16a3b56c472ef$var$node.hash = "47efe092e8db2f8efa6d6b357d26f1f8";
var $a1d16a3b56c472ef$export$2e2bcd8739ae039 = $a1d16a3b56c472ef$var$node;
module.exports["default"] = $a1d16a3b56c472ef$export$2e2bcd8739ae039;

});

parcelRegister("kXsBa", function(module, exports) {

var $cXQmG = parcelRequire("cXQmG");


var $7gy2b = parcelRequire("7gy2b");


var $cozmU = parcelRequire("cozmU");


var $cgpF0 = parcelRequire("cgpF0");


var $ij4CE = parcelRequire("ij4CE");


var $9wGTI = parcelRequire("9wGTI");


var $308Wd = parcelRequire("308Wd");




const $563fbe27571904a7$export$57b25de3525e313f = (contentId, currentTitle)=>{
    const [isEditing, setIsEditing] = (0, $cozmU.useState)(false);
    const [updatedTitleFromPubsub, setUpdatedTitleFromPubsub] = (0, $cozmU.useState)(undefined);
    const isProcessingTitleUpdate = (0, $cozmU.useRef)(false);
    const onMutationComplete = ()=>{
        setUpdateError(undefined);
        setIsEditing(false);
    };
    const [updateError, setUpdateError] = (0, $cozmU.useState)(undefined);
    const [updateContentTitle, { loading: updateLoading }] = (0, $308Wd.useMutationInterop)((0, $7gy2b.default), {
        onCompleted: onMutationComplete,
        onError: setUpdateError,
        __callerPackage__: "content-types-header"
    });
    const writeFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentArtifact: (0, $cXQmG.default),
        fragmentSpec: (0, $cXQmG.default),
        __callerPackage__: "content-types-header"
    });
    const updateCache = (0, $cozmU.useCallback)((value)=>{
        writeFragmentInterop({
            fragmentId: `Content:${contentId}`,
            data: {
                id: contentId,
                title: value,
                __typename: 'Content'
            }
        });
    }, [
        contentId,
        writeFragmentInterop
    ]);
    const updateTitle = (0, $cozmU.useCallback)(async (value_0)=>{
        if (value_0 === currentTitle) {
            setIsEditing(false);
            // We have to manually clear the error here because it is no longer relevant to this most recent call to `updateTitle`,
            // since we're now attempting to set the title back to the current title, which should be valid.
            setUpdateError(undefined);
            if (updatedTitleFromPubsub && updatedTitleFromPubsub !== currentTitle) {
                updateCache(updatedTitleFromPubsub);
                setUpdatedTitleFromPubsub(undefined);
            }
            if (!isProcessingTitleUpdate.current) return true;
        }
        try {
            const response = await updateContentTitle({
                variables: {
                    contentId: contentId,
                    title: value_0
                }
            });
            return Boolean(response.data?.updateTitle);
        } catch  {
            // error handled by useMutation result updateError
            return false;
        }
    }, [
        contentId,
        currentTitle,
        updateCache,
        updateContentTitle,
        updatedTitleFromPubsub
    ]);
    /**
   * The following section is a mutation queue to ensure that title updates are processed sequentially and that the
   * latest title is always the one that gets applied.
   * This is important because multiple title updates can be triggered in quick succession when AI inline streaming
   * occurs and we want to avoid stale state errors from the GQL store, but also ensure the latest title is the one that
   * gets applied.
   */ const latestQueuedTitleUpdate = (0, $cozmU.useRef)();
    const processQueue = (0, $cozmU.useCallback)(async ()=>{
        if (isProcessingTitleUpdate.current) return;
        isProcessingTitleUpdate.current = true;
        try {
            let nextUpdate = latestQueuedTitleUpdate.current;
            latestQueuedTitleUpdate.current = undefined;
            // We keep updating the title until there are no more titles in the cache
            while(nextUpdate !== undefined){
                const result = await updateTitle(nextUpdate.title);
                nextUpdate.resolve?.(result);
                nextUpdate = latestQueuedTitleUpdate.current;
                latestQueuedTitleUpdate.current = undefined;
            }
        } finally{
            isProcessingTitleUpdate.current = false;
        }
    }, [
        updateTitle
    ]);
    const enqueueTitle = (0, $cozmU.useCallback)(async (title)=>{
        latestQueuedTitleUpdate.current?.resolve?.(false);
        latestQueuedTitleUpdate.current = {
            title: title
        };
        if (!isProcessingTitleUpdate.current) await processQueue();
    }, [
        processQueue
    ]);
    // Fire-and-forget wrapper for the non-gated path. The underlying `updateTitle`
    // returns the mutation outcome but no public caller branches on it, so erase
    // the boolean here to keep the public type honest.
    const updateTitleVoid = (0, $cozmU.useCallback)(async (value_1)=>{
        await updateTitle(value_1);
    }, [
        updateTitle
    ]);
    const enqueueTitleAndWait = (0, $cozmU.useCallback)(async (title_0)=>{
        // Resolving the previous queued update as false means it was superseded, not that the BE mutation failed.
        latestQueuedTitleUpdate.current?.resolve?.(false);
        const result = new Promise((resolve)=>{
            latestQueuedTitleUpdate.current = {
                title: title_0,
                resolve: resolve
            };
        });
        if (!isProcessingTitleUpdate.current) processQueue();
        return result;
    }, [
        processQueue
    ]);
    // Set the title change handler when the component mounts
    // Content types use this method to update the title from within the iframe
    (0, $cozmU.useEffect)(()=>{
        (0, $cgpF0.contentTypesTitleServiceSingleton).setTitleChangeHandler(updateTitle);
        return ()=>{
            (0, $cgpF0.contentTypesTitleServiceSingleton).setTitleChangeHandler(()=>{});
        };
    }, [
        updateTitle
    ]);
    return {
        isEditing: isEditing,
        setIsEditing: setIsEditing,
        setUpdatedTitleFromPubsub: setUpdatedTitleFromPubsub,
        updateLoading: updateLoading,
        updateError: updateError,
        updateTitle: (0, $9wGTI.fg)('platform_editor_ai_aifc_patch_ga_blockers') ? enqueueTitle : updateTitleVoid,
        updateTitleAndWait: (0, $9wGTI.fg)('platform_editor_ai_aifc_patch_ga_blockers') ? enqueueTitleAndWait : updateTitle,
        updateCache: updateCache
    };
};
module.exports["useContentTypesTitleUpdate"] = $563fbe27571904a7$export$57b25de3525e313f;

});

parcelRegister("cXQmG", function(module, exports) {
/**
 * @generated SignedSource<<aec625eb8d10dac10d8b75f45f93e968>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d6b675ba61ab7de1$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useContentTypesTitleUpdateContentTitleWriteFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "__typename"
        }
    ],
    "type": "Content"
};
$d6b675ba61ab7de1$var$node.hash = "3d624df929b7f5b6bedfdab8b98fb427";
var $d6b675ba61ab7de1$export$2e2bcd8739ae039 = $d6b675ba61ab7de1$var$node;
module.exports["default"] = $d6b675ba61ab7de1$export$2e2bcd8739ae039;

});

parcelRegister("7gy2b", function(module, exports) {
/**
 * @generated SignedSource<<5d2bbc80e1c6738ea6a17dcaad56e8d9>>
 * @relayHash d1c5670c44e9f8fc9ac768758d436087
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8e8353d3ad0b3fc7ac6fe01393daf5d0934740f4bc4ac7fb665f4815b9daf79c
const $2064637d3d8753f2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "title"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "title",
                    "variableName": "title"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "updateTitle",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                },
                {
                    "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "editui"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "webui"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContentTypesTitleUpdateContentTitleMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContentTypesTitleUpdateContentTitleMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "d1c5670c44e9f8fc9ac768758d436087",
            "id": "8e8353d3ad0b3fc7ac6fe01393daf5d0934740f4bc4ac7fb665f4815b9daf79c",
            "metadata": {},
            "name": "useContentTypesTitleUpdateContentTitleMutation",
            "operationKind": "mutation",
            "text": "mutation useContentTypesTitleUpdateContentTitleMutation($contentId:ID!,$title:String){updateTitle(contentId:$contentId,title:$title){id,title,links{editui,webui}}}"
        }
    };
}();
$2064637d3d8753f2$var$node.hash = "8c498978fbdcfa01faf33b30473c33ec";
var $2064637d3d8753f2$export$2e2bcd8739ae039 = $2064637d3d8753f2$var$node;
module.exports["default"] = $2064637d3d8753f2$export$2e2bcd8739ae039;

});

parcelRegister("cgpF0", function(module, exports) {
class $ef2bdef46a40b8c0$export$b44304baa0bf4e7b {
    updateTitle(title) {
        this.titleChangeHandler(title);
    }
    setTitleChangeHandler(cb) {
        this.titleChangeHandler = cb;
    }
    constructor(){
        this.titleChangeHandler = void 0;
        this.titleChangeHandler = ()=>{};
    }
}
const $ef2bdef46a40b8c0$export$6450770420296206 = new $ef2bdef46a40b8c0$export$b44304baa0bf4e7b();
module.exports["contentTypesTitleServiceSingleton"] = $ef2bdef46a40b8c0$export$6450770420296206;

});

parcelRegister("kSPGK", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

class $5d6af3820d303892$var$OptimisticTitleChangeEventBus {
    emit(contentId, title) {
        if (this.listeners[contentId]) this.listeners[contentId].forEach((fn)=>{
            fn(title);
        });
    }
    subscribe(contentId, fn) {
        if (!this.listeners[contentId]) this.listeners[contentId] = [];
        this.listeners[contentId].push(fn);
    }
    unsubcribe(contentId, fn) {
        if (this.listeners[contentId]) {
            const index = this.listeners[contentId].findIndex((item)=>item[0] === fn);
            if (index !== -1) this.listeners[contentId].splice(index, 1);
        }
    }
    constructor(){
        this.listeners = void 0;
        this.listeners = {};
    }
}
const $5d6af3820d303892$var$optimisticTitleChangeEventBus = new $5d6af3820d303892$var$OptimisticTitleChangeEventBus();
const $5d6af3820d303892$export$255638cdf0226b65 = (contentId, initialTitle, onOptimisticUpdate)=>{
    const $ = (0, $bDgLe.c)(16);
    const [optimisticTitle, setOptimisticTitle] = (0, $cozmU.useState)(initialTitle);
    let t0;
    if ($[0] !== contentId || $[1] !== optimisticTitle) {
        t0 = (value)=>{
            if (value !== optimisticTitle) $5d6af3820d303892$var$optimisticTitleChangeEventBus && $5d6af3820d303892$var$optimisticTitleChangeEventBus.emit(contentId, value);
        };
        $[0] = contentId;
        $[1] = optimisticTitle;
        $[2] = t0;
    } else t0 = $[2];
    const publishOptimisticTitle = t0;
    let t1;
    if ($[3] !== contentId || $[4] !== onOptimisticUpdate) {
        t1 = (title)=>{
            setOptimisticTitle(title);
            onOptimisticUpdate && onOptimisticUpdate(contentId, title);
        };
        $[3] = contentId;
        $[4] = onOptimisticUpdate;
        $[5] = t1;
    } else t1 = $[5];
    const handleTitleChanged = t1;
    let t2;
    let t3;
    if ($[6] !== contentId || $[7] !== handleTitleChanged) {
        t2 = ()=>{
            $5d6af3820d303892$var$optimisticTitleChangeEventBus && $5d6af3820d303892$var$optimisticTitleChangeEventBus.subscribe(contentId, handleTitleChanged);
            return ()=>{
                $5d6af3820d303892$var$optimisticTitleChangeEventBus && $5d6af3820d303892$var$optimisticTitleChangeEventBus.unsubcribe(contentId, handleTitleChanged);
            };
        };
        t3 = [
            contentId,
            handleTitleChanged
        ];
        $[6] = contentId;
        $[7] = handleTitleChanged;
        $[8] = t2;
        $[9] = t3;
    } else {
        t2 = $[8];
        t3 = $[9];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    let t5;
    if ($[10] !== initialTitle) {
        t4 = ()=>{
            setOptimisticTitle(initialTitle);
        };
        t5 = [
            initialTitle
        ];
        $[10] = initialTitle;
        $[11] = t4;
        $[12] = t5;
    } else {
        t4 = $[11];
        t5 = $[12];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[13] !== optimisticTitle || $[14] !== publishOptimisticTitle) {
        t6 = {
            optimisticTitle: optimisticTitle,
            setOptimisticTitle: publishOptimisticTitle
        };
        $[13] = optimisticTitle;
        $[14] = publishOptimisticTitle;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
};
module.exports["useOptimisticTitleChange"] = $5d6af3820d303892$export$255638cdf0226b65;

});

parcelRegister("6DT7W", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $8e77e8dd4ed98ba0$export$8e100eba08cca59e = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "C9H24",
    name: "RequestAccessPopupComponent",
    loader: async ()=>(await (parcelRequire("3Oija"))).RequestAccessPopupComponent
});
module.exports["RequestAccessPopupComponent"] = $8e77e8dd4ed98ba0$export$8e100eba08cca59e;

});

parcelRegister("3Oija", function(module, exports) {

let $2c643e358e42e420$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2c643e358e42e420$var$load("lk4cE").then(()=>parcelRequire('1hgMC'));

});

parcelRegister("lfFzM", function(module, exports) {

var $6b4nE = parcelRequire("6b4nE");


var $jMyy4 = parcelRequire("jMyy4");


var $6jrkJ = parcelRequire("6jrkJ");


var $hiC7Y = parcelRequire("hiC7Y");

const $f78b3fd6fbd1f922$export$dd53ec461ae8f03e = ()=>{
    // if the claim does not exist, we'll skip doing the actual query
    const hasSuperAdminClaim = (0, $6jrkJ.getSuperAdminClaim)();
    const { loading: loading, error: error, data: data } = (0, $jMyy4.useQueryInterop)((0, $hiC7Y.default), {
        skip: !hasSuperAdminClaim,
        __callerPackage__: "super-admin"
    });
    return hasSuperAdminClaim ? {
        loading: loading,
        error: error,
        isSuperAdmin: Boolean(data?.user?.confluence?.roles?.isSuperAdmin)
    } : {
        loading: false,
        isSuperAdmin: false
    };
};
const $f78b3fd6fbd1f922$export$a7f16c8c21f70b7a = ({ children: children })=>{
    const { isSuperAdmin: isSuperAdmin, loading: loading, error: error } = $f78b3fd6fbd1f922$export$dd53ec461ae8f03e();
    return children({
        loading: loading,
        error: error,
        isSuperAdmin: isSuperAdmin
    });
};
$f78b3fd6fbd1f922$export$a7f16c8c21f70b7a.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func.isRequired
};
module.exports["useIsSuperAdmin"] = $f78b3fd6fbd1f922$export$dd53ec461ae8f03e;
module.exports["AdminKeyQuery"] = $f78b3fd6fbd1f922$export$a7f16c8c21f70b7a;

});

parcelRegister("grWYF", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $8lt1a = parcelRequire("8lt1a");


var $dPJCf = parcelRequire("dPJCf");


var $lsxnT = parcelRequire("lsxnT");


var $fdPUP = parcelRequire("fdPUP");

const $3a4ed6f24f1b06e9$var$useJourneyIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('journeyId');
function $3a4ed6f24f1b06e9$export$715107a573a5fba6(t0) {
    const $ = (0, $bDgLe.c)(11);
    const { onClose: onClose, journeyId: journeyId } = t0;
    const { Spotlight: Spotlight } = (0, $lsxnT.useChoreographerAssets)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    let t2;
    if ($[0] !== createAnalyticsEvent || $[1] !== journeyId) {
        t1 = ()=>{
            createAnalyticsEvent({
                type: "sendScreenEvent",
                data: {
                    name: "onboardingPagePermissionsSpotlight",
                    attributes: {
                        source: (0, $fdPUP.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                        journeyId: journeyId
                    }
                }
            }).fire();
        };
        t2 = [
            createAnalyticsEvent,
            journeyId
        ];
        $[0] = createAnalyticsEvent;
        $[1] = journeyId;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "share-and-restrict-dialog.share-and-restrict-spotlight-onboarding.ok",
            defaultMessage: "Ok"
        });
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== onClose) {
        t4 = [
            {
                onClick: onClose,
                text: t3
            }
        ];
        $[5] = onClose;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "share-and-restrict-dialog.share-and-restrict-spotlight-onboarding.body",
            defaultMessage: "Control who can view, edit, and comment on your pages."
        });
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== Spotlight || $[9] !== t4) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Spotlight, {
            actions: t4,
            target: "share-button-spotlight-target",
            targetRadius: 3,
            targetBgColor: "var(--ds-surface, #FFFFFF)",
            dialogPlacement: "bottom right",
            dialogWidth: 275,
            messageType: "transactional"
        }, t5);
        $[8] = Spotlight;
        $[9] = t4;
        $[10] = t6;
    } else t6 = $[10];
    return t6;
}
function $3a4ed6f24f1b06e9$export$31f46f470e475335() {
    const $ = (0, $bDgLe.c)(10);
    const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
    const journeyId = $3a4ed6f24f1b06e9$var$useJourneyIdQueryParam();
    const [isSpotlightActive, setIsSpotlightActive] = (0, $cozmU.useState)(false);
    const hasRun = (0, $cozmU.useRef)(false);
    const [cachedJourneyId, setCachedJourneyId] = (0, $cozmU.useState)();
    let t0;
    let t1;
    if ($[0] !== journeyId || $[1] !== setQueryParams) {
        t0 = ()=>{
            if (hasRun.current) return;
            hasRun.current = true;
            if (journeyId !== "onboarding-page-permissions") return;
            setCachedJourneyId(journeyId);
            setQueryParams({
                journeyId: null
            });
            setIsSpotlightActive(true);
        };
        t1 = [
            journeyId,
            setQueryParams
        ];
        $[0] = journeyId;
        $[1] = setQueryParams;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>setIsSpotlightActive(false);
        $[4] = t2;
    } else t2 = $[4];
    const handleOnClose = t2;
    let t3;
    if ($[5] !== cachedJourneyId || $[6] !== isSpotlightActive) {
        t3 = isSpotlightActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3a4ed6f24f1b06e9$export$715107a573a5fba6, {
            onClose: handleOnClose,
            journeyId: cachedJourneyId
        });
        $[5] = cachedJourneyId;
        $[6] = isSpotlightActive;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8lt1a.default), null, t3);
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
}
module.exports["OnboardingPagePermissionsSpotlight"] = $3a4ed6f24f1b06e9$export$715107a573a5fba6;
module.exports["OnboardingPagePermissionsSpotlightLoader"] = $3a4ed6f24f1b06e9$export$31f46f470e475335;

});

parcelRegister("c4ECQ", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ var $e40ae21eed558c2b$export$91111a1ebace330 = /*#__PURE__*/ function(ContentRestrictionType) {
    ContentRestrictionType["NO_RESTRICTIONS"] = "NO_RESTRICTIONS";
    ContentRestrictionType["RESTRICT_EDIT"] = "RESTRICT_EDIT";
    ContentRestrictionType["RESTRICT_VIEW"] = "RESTRICT_VIEW";
    return ContentRestrictionType;
}({});
var $e40ae21eed558c2b$export$7602248773d1f745 = /*#__PURE__*/ function(RestrictionFrom) {
    RestrictionFrom["DIRECT"] = "DIRECT";
    RestrictionFrom["MULTIPLE"] = "MULTIPLE";
    RestrictionFrom["NONE"] = "NONE";
    RestrictionFrom["PAGE_INHERITED"] = "PAGE_INHERITED";
    RestrictionFrom["SPACE"] = "SPACE";
    return RestrictionFrom;
}({});
var $e40ae21eed558c2b$export$8eda7e02f8f033b2 = /*#__PURE__*/ function(EntityType) {
    EntityType["GROUP"] = "GROUP";
    EntityType["USER"] = "USER";
    return EntityType;
}({});
var $e40ae21eed558c2b$export$af2022a36dc13b47 = /*#__PURE__*/ function(PermissionType) {
    PermissionType["EDIT"] = "EDIT";
    PermissionType["VIEW"] = "VIEW";
    return PermissionType;
}({});
var $e40ae21eed558c2b$export$efe8384a5aa2f235 = /*#__PURE__*/ function(ErrorMessageType) {
    ErrorMessageType["NO_ANCESTOR_VIEW"] = "NO_ANCESTOR_VIEW";
    ErrorMessageType["NO_SPACE_VIEW"] = "NO_SPACE_VIEW";
    ErrorMessageType["NO_SPACE_EDIT"] = "NO_SPACE_EDIT";
    return ErrorMessageType;
}({});
module.exports["ContentRestrictionType"] = $e40ae21eed558c2b$export$91111a1ebace330;
module.exports["RestrictionFrom"] = $e40ae21eed558c2b$export$7602248773d1f745;
module.exports["EntityType"] = $e40ae21eed558c2b$export$8eda7e02f8f033b2;
module.exports["PermissionType"] = $e40ae21eed558c2b$export$af2022a36dc13b47;

});

parcelRegister("fG32j", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $kdKo9 = parcelRequire("kdKo9");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $ep3mz = parcelRequire("ep3mz");



var $jMyy4 = parcelRequire("jMyy4");

const $06e8bea7aad8a7b8$var$SpaceRestrictionCheckQuery = (0, $kdKo9.default);
const $06e8bea7aad8a7b8$export$f1b4255eb8ae314e = (0, $3u0dr.isReactCompilerActiveV2)() ? function SpaceRestrictionCheck(t0) {
    const $ = (0, $bDgLe.c)(14);
    const { asSuperAdmin: asSuperAdmin, children: children, spaceKey: spaceKey, contentId: contentId } = t0;
    const [stateSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    let t1;
    if ($[0] !== asSuperAdmin) {
        t1 = asSuperAdmin == undefined ? undefined : {
            asSuperAdmin: asSuperAdmin
        };
        $[0] = asSuperAdmin;
        $[1] = t1;
    } else t1 = $[1];
    const t2 = spaceKey || stateSpaceKey;
    let t3;
    if ($[2] !== t2) {
        t3 = {
            spaceKey: t2
        };
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== t1 || $[5] !== t3) {
        t4 = {
            context: t1,
            errorPolicy: "all",
            variables: t3
        };
        $[4] = t1;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($06e8bea7aad8a7b8$var$SpaceRestrictionCheckQuery, {
        ...t4,
        __callerPackage__: "restrictions"
    });
    let t5;
    let t6;
    if ($[7] !== children || $[8] !== contentId || $[9] !== data || $[10] !== error || $[11] !== loading) {
        t6 = Symbol.for("react.early_return_sentinel");
        bb0: {
            let isSpaceNotFound;
            let isSpaceRestricted;
            if (error) {
                isSpaceNotFound = $06e8bea7aad8a7b8$export$498e7daa29ea2c61(error);
                isSpaceRestricted = $06e8bea7aad8a7b8$export$ee3dd1f0a88cef(error);
                if (isSpaceNotFound || isSpaceRestricted) (0, $7Sm4c.markErrorAsHandled)(error);
            } else if (data) {
                const errorSwallowed = data.space === null;
                isSpaceNotFound = errorSwallowed && window.__SPACE_NOTFOUND_CHECK_ERROR__;
                isSpaceRestricted = errorSwallowed && window.__SPACE_RESTRICTED_CHECK_ERROR__;
            }
            if (loading) {
                t6 = null;
                break bb0;
            }
            const contentIsNotViewableBecauseOfSpaceRestrictions = Boolean(contentId) && window?.__SPACE_RESTRICTED_ERROR__ === contentId;
            t5 = children({
                error: error,
                isSpaceNotFound: isSpaceNotFound,
                isSpaceRestricted: isSpaceRestricted || contentIsNotViewableBecauseOfSpaceRestrictions
            });
        }
        $[7] = children;
        $[8] = contentId;
        $[9] = data;
        $[10] = error;
        $[11] = loading;
        $[12] = t5;
        $[13] = t6;
    } else {
        t5 = $[12];
        t6 = $[13];
    }
    if (t6 !== Symbol.for("react.early_return_sentinel")) return t6;
    return t5;
} : function SpaceRestrictionCheck({ asSuperAdmin: asSuperAdmin, children: children, spaceKey: spaceKey, contentId: contentId }) {
    const [stateSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($06e8bea7aad8a7b8$var$SpaceRestrictionCheckQuery, {
        context: asSuperAdmin == undefined ? undefined : {
            asSuperAdmin: asSuperAdmin
        },
        errorPolicy: 'all',
        variables: {
            // XXX Though SpaceRestrictionCheckProps defines spaceKey as required,
            // SpaceBaseComponent is not written in TypeScript and it may provide
            // undefined as it is reading spaceKey from redux. While it would result
            // in a better separation of concerns to have a fix in SpaceBaseComponent,
            // such a fix would be riskier.
            spaceKey: spaceKey || stateSpaceKey
        },
        __callerPackage__: "restrictions"
    });
    let isSpaceNotFound;
    let isSpaceRestricted;
    if (error) {
        isSpaceNotFound = $06e8bea7aad8a7b8$export$498e7daa29ea2c61(error);
        isSpaceRestricted = $06e8bea7aad8a7b8$export$ee3dd1f0a88cef(error);
        if (isSpaceNotFound || isSpaceRestricted) (0, $7Sm4c.markErrorAsHandled)(error);
    } else if (data) {
        const errorSwallowed = data.space === null;
        isSpaceNotFound = errorSwallowed && window['__SPACE_NOTFOUND_CHECK_ERROR__'];
        isSpaceRestricted = errorSwallowed && window['__SPACE_RESTRICTED_CHECK_ERROR__'];
    }
    if (loading) return null;
    const contentIsNotViewableBecauseOfSpaceRestrictions = Boolean(contentId) && window?.['__SPACE_RESTRICTED_ERROR__'] === contentId;
    return children({
        error: error,
        isSpaceNotFound: isSpaceNotFound,
        isSpaceRestricted: isSpaceRestricted || contentIsNotViewableBecauseOfSpaceRestrictions
    });
};
function $06e8bea7aad8a7b8$export$498e7daa29ea2c61(error) {
    return $06e8bea7aad8a7b8$var$isSpaceError(error, ({ statusCode: statusCode })=>statusCode === 404 || statusCode === 400);
}
function $06e8bea7aad8a7b8$export$ee3dd1f0a88cef(error) {
    return $06e8bea7aad8a7b8$var$isSpaceError(error, ()=>(0, $1uFM6.isUnauthorizedError)(error));
}
function $06e8bea7aad8a7b8$var$isSpaceError({ graphQLErrors: graphQLErrors }, extensionsPredicate) {
    if (graphQLErrors && graphQLErrors.length > 0) for (const { extensions: extensions, path: path } of graphQLErrors){
        if (Array.isArray(path) && path.indexOf('space') !== -1 && extensions && extensionsPredicate(extensions)) return true;
    }
    return false;
}
module.exports["SpaceRestrictionCheck"] = $06e8bea7aad8a7b8$export$f1b4255eb8ae314e;
module.exports["isSpaceNotFoundError"] = $06e8bea7aad8a7b8$export$498e7daa29ea2c61;
module.exports["isSpaceRestrictedError"] = $06e8bea7aad8a7b8$export$ee3dd1f0a88cef;

});

parcelRegister("lqy4C", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4c1VG = parcelRequire("4c1VG");


var $alLTz = parcelRequire("alLTz");


var $cLhhP = parcelRequire("cLhhP");

const $047fd93b8f400f5d$export$5419ac0b96bac54b = ({ source: source })=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isEligibleUser = (0, $alLTz.useIsStorageEnforcementEligible)();
    const { isStorageEnforcementGracePeriodComplete: isStorageEnforcementGracePeriodComplete } = (0, $4c1VG.useGetCurrentStorageUsage)({
        skip: !isEligibleUser
    });
    const { showBlockCreateModal: showBlockCreateModal } = (0, $cLhhP.useBlockCreateModalActions)();
    const shouldBlockCreate = isEligibleUser && Boolean(isStorageEnforcementGracePeriodComplete);
    const enforceStorageLimit = (0, $cozmU.useCallback)((callback)=>(...args)=>{
            if (shouldBlockCreate) {
                // If the callback is a DOM event (e.g. click, keydown/keyup)
                // handler, prevent the default action (e.g. navigating to an href):
                const event = args?.[0];
                if (event && typeof event.preventDefault === 'function') event.preventDefault();
                experienceTracker.start({
                    name: (0, $irVI7.ONBOARDING_STORAGE_ENFORCEMENT_BLOCK_CREATE_MODAL)
                });
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'render',
                        actionSubject: 'hardStorageEnforcement',
                        actionSubjectId: 'enforceStorageLimit',
                        source: source || 'onboarding'
                    }
                }).fire();
                showBlockCreateModal(source);
                return;
            }
            return callback.apply(undefined, args);
        }, [
        createAnalyticsEvent,
        experienceTracker,
        shouldBlockCreate,
        showBlockCreateModal,
        source
    ]);
    return {
        shouldBlockCreate: shouldBlockCreate,
        enforceStorageLimit: enforceStorageLimit
    };
};
module.exports["useHardStorageEnforcement"] = $047fd93b8f400f5d$export$5419ac0b96bac54b;

});

parcelRegister("4c1VG", function(module, exports) {

var $1hmAp = parcelRequire("1hmAp");


var $jMyy4 = parcelRequire("jMyy4");

const $1f652a8c0a42982a$var$useGetCurrentStorageUsageQuery = (0, $1hmAp.default);
const $1f652a8c0a42982a$export$8bf54c39c48ff2d2 = ({ skip: skip } = {})=>{
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($1f652a8c0a42982a$var$useGetCurrentStorageUsageQuery, {
        skip: skip,
        __callerPackage__: "storage-enforcement"
    });
    return {
        currentUsage: data?.storage?.bytesUsed ?? 0,
        isStorageEnforcementGracePeriodComplete: data?.storage?.isStorageEnforcementGracePeriodComplete,
        gracePeriodEndDate: data?.storage?.gracePeriodEndDate,
        loading: loading,
        error: error
    };
};
module.exports["useGetCurrentStorageUsage"] = $1f652a8c0a42982a$export$8bf54c39c48ff2d2;

});

parcelRegister("alLTz", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");

const $2f3a7af74886cca0$export$3fc4fcb674af9bce = ()=>{
    const { edition: edition, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isEligibleUser = edition === (0, $euL71.ConfluenceEdition).FREE && isLoggedIn;
    return isEligibleUser;
};
module.exports["useIsStorageEnforcementEligible"] = $2f3a7af74886cca0$export$3fc4fcb674af9bce;

});

parcelRegister("cLhhP", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $ff89d2fd8e30c2ae$var$initialState = {
    isActive: false,
    source: ''
};
const $ff89d2fd8e30c2ae$var$NAME = 'BLOCK_CREATE_MODAL_STORE';
const $ff89d2fd8e30c2ae$var$BlockCreateModalStore = (0, $8s9DV.createStore)({
    name: $ff89d2fd8e30c2ae$var$NAME,
    initialState: $ff89d2fd8e30c2ae$var$initialState,
    actions: {
        showBlockCreateModal: (source)=>({ setState: setState })=>{
                setState({
                    isActive: true,
                    source: source
                });
            },
        onBlockCreateModalClose: ()=>({ setState: setState })=>{
                setState({
                    isActive: false,
                    source: ''
                });
            }
    }
});
const $ff89d2fd8e30c2ae$export$88ea7ab80ee27dbc = (0, $kBr4q.createHook)($ff89d2fd8e30c2ae$var$BlockCreateModalStore);
const $ff89d2fd8e30c2ae$export$d0e21e34c085fe56 = (0, $kBr4q.createActionsHook)($ff89d2fd8e30c2ae$var$BlockCreateModalStore);
module.exports["useBlockCreateModalStore"] = $ff89d2fd8e30c2ae$export$88ea7ab80ee27dbc;
module.exports["useBlockCreateModalActions"] = $ff89d2fd8e30c2ae$export$d0e21e34c085fe56;

});

parcelRegister("ftFOj", function(module, exports) {

var $ieWRE = parcelRequire("ieWRE");


var $jtuBN = parcelRequire("jtuBN");


var $gZneu = parcelRequire("gZneu");

/** @schema cc */ const $46cf70134ef7593d$var$query = (0, $ieWRE.default);
const $46cf70134ef7593d$export$957cf4ab6fd3f58e = (spaceKey)=>{
    const isSmartFoldersSupported = (0, $gZneu.useIsSmartFoldersSupported)();
    const shouldSkipQuery = !isSmartFoldersSupported || !spaceKey;
    const { loading: loading, data: data } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)($46cf70134ef7593d$var$query, {
        variables: {
            spaceKey: spaceKey ?? ''
        },
        skip: shouldSkipQuery,
        __callerPackage__: "smart-folder"
    });
    const enabledContentTypes = data?.space?.spaceTypeSettings?.enabledContentTypes;
    const isFoldersEnabledInSpace = enabledContentTypes?.isFoldersEnabled ?? false;
    const isSmartFoldersEnabledInSpace = enabledContentTypes?.isSmartFoldersEnabled ?? false;
    return {
        isSmartFoldersEnabled: isSmartFoldersSupported && isFoldersEnabledInSpace && isSmartFoldersEnabledInSpace,
        loading: loading
    };
};
module.exports["useIsSmartFoldersEnabled"] = $46cf70134ef7593d$export$957cf4ab6fd3f58e;

});

parcelRegister("gZneu", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");

const $23af0ee2a39f4a09$export$4f0b8fcf328460ea = ()=>{
    const { isRovoEnabled: isRovoEnabled } = (0, $bQm3c.useSessionData)();
    return isRovoEnabled && (0, $6mKj3.expVal)('confluence_smart_folders_milestone_1', 'isEnabled', false);
};
module.exports["useIsSmartFoldersSupported"] = $23af0ee2a39f4a09$export$4f0b8fcf328460ea;

});

parcelRegister("4P3Ik", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $6gnMn = parcelRequire("6gnMn");

const $4a53954b5495bdb9$export$8a7102ea5a6f8dc8 = (0, $kSwu1.defineMessages)({
    creatingDocs: {
        id: "dev-docs.sync-status-presentation.creating-docs",
        defaultMessage: "Creating docs"
    },
    notSynced: {
        id: "dev-docs.sync-status-presentation.not-synced",
        defaultMessage: "Not synced"
    },
    synced: {
        id: "dev-docs.sync-status-presentation.synced",
        defaultMessage: "Synced"
    },
    syncing: {
        id: "dev-docs.sync-status-presentation.syncing",
        defaultMessage: "Syncing"
    }
});
const $4a53954b5495bdb9$export$5924af9eaba412f8 = {
    failed: $4a53954b5495bdb9$export$8a7102ea5a6f8dc8.notSynced,
    synced: $4a53954b5495bdb9$export$8a7102ea5a6f8dc8.synced,
    syncing: $4a53954b5495bdb9$export$8a7102ea5a6f8dc8.syncing,
    unknown: $4a53954b5495bdb9$export$8a7102ea5a6f8dc8.creatingDocs
};
const $4a53954b5495bdb9$export$cf03f2dfdf4219ef = {
    failed: 'removed',
    synced: 'success',
    syncing: 'inprogress',
    unknown: 'inprogress'
};
const $4a53954b5495bdb9$export$35311d2cb09dda22 = (timestamp, intl)=>{
    if (!timestamp) return null;
    const timestampMs = new Date(timestamp).getTime();
    if (Number.isNaN(timestampMs)) return null;
    return (0, $6gnMn.formatRelativeTimeAgo)(timestampMs, intl, new Date(Date.now()));
};
const $4a53954b5495bdb9$export$55cd9fcee22b4449 = (syncStatus, syncMetadata)=>{
    if (syncStatus.status === 'syncing') return null;
    return syncStatus.status === 'failed' ? syncMetadata?.latestSyncAttemptAt ?? syncMetadata?.lastSynced ?? null : syncMetadata?.lastSynced ?? null;
};
module.exports["devDocsSyncStatusMessages"] = $4a53954b5495bdb9$export$5924af9eaba412f8;
module.exports["devDocsSyncStatusAppearances"] = $4a53954b5495bdb9$export$cf03f2dfdf4219ef;
module.exports["formatDevDocsRelativeSyncTime"] = $4a53954b5495bdb9$export$35311d2cb09dda22;
module.exports["getDevDocsSyncStatusTimestamp"] = $4a53954b5495bdb9$export$55cd9fcee22b4449;

});

parcelRegister("idfQJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6YkHb = parcelRequire("6YkHb");


var $fxqZn = parcelRequire("fxqZn");


var $fyTd1 = parcelRequire("fyTd1");


var $fONL3 = parcelRequire("fONL3");

const $538838085c952370$var$DevDocsScmProviderBrandIcon = ({ provider: provider, size: size })=>{
    if (provider === 'github') switch(size){
        case 'large':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fyTd1.GitHubIcon), {
                label: "",
                size: "xlarge",
                testId: "dev-docs-github-icon"
            });
        case 'medium':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fyTd1.GitHubIcon), {
                label: "",
                size: "large",
                testId: "dev-docs-github-icon"
            });
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fyTd1.GitHubIcon), {
                label: "",
                size: "small",
                testId: "dev-docs-github-icon"
            });
    }
    switch(size){
        case 'large':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fxqZn.BitbucketIcon), {
                appearance: "brand",
                label: "",
                size: "xlarge"
            });
        case 'medium':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fxqZn.BitbucketIcon), {
                appearance: "brand",
                label: "",
                size: "large"
            });
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fxqZn.BitbucketIcon), {
                appearance: "brand",
                label: "",
                size: "small"
            });
    }
};
const $538838085c952370$export$baf7f667000d5120 = ({ provider: provider })=>{
    const providerKey = (0, $fONL3.getDevDocsSourceProviderConfigFromValue)(provider)?.provider;
    switch(providerKey){
        case 'github':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fyTd1.GitHubIcon), {
                label: "",
                size: "xxsmall",
                testId: "dev-docs-github-icon"
            });
        case 'bitbucket':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fxqZn.BitbucketIcon), {
                appearance: "brand",
                label: "",
                size: "xsmall"
            });
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6YkHb))), {
                label: ""
            });
    }
};
const $538838085c952370$export$aa878a664e851ba8 = ({ provider: provider, size: size = 'small' })=>{
    const providerKey = (0, $fONL3.getDevDocsSourceProviderConfigFromValue)(provider)?.provider;
    if (providerKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($538838085c952370$var$DevDocsScmProviderBrandIcon, {
        provider: providerKey,
        size: size
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($538838085c952370$export$baf7f667000d5120, {
        provider: provider
    });
};
const $538838085c952370$export$7f490fa62960c9b0 = ({ sourceUrl: sourceUrl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($538838085c952370$export$baf7f667000d5120, {
        provider: sourceUrl
    });
const $538838085c952370$export$85f61ad9846f98b = ()=>{
    const id = (0, $cozmU.useId)().replace(/:/g, '');
    const githubMaskId = `devDocsScmProviderButtonIconsGithubMask-${id}`;
    const clipId = `devDocsScmProviderButtonIconsClip0-${id}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "40",
        height: "23",
        viewBox: "0 0 40 23",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        focusable: "false"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        mask: `url(#${githubMaskId})`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        y: "1.5",
        width: "20",
        height: "20",
        rx: "5",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.0001 5.5C6.68675 5.5 4 8.25424 4 11.6519C4 14.37 5.7192 16.676 8.1032 17.4894C8.40306 17.5464 8.51315 17.356 8.51315 17.1935C8.51315 17.0468 8.50759 16.5622 8.50501 16.0481C6.83579 16.4203 6.48356 15.3223 6.48356 15.3223C6.21062 14.6112 5.81736 14.4221 5.81736 14.4221C5.27298 14.0403 5.8584 14.0482 5.8584 14.0482C6.4609 14.0916 6.77816 14.6821 6.77816 14.6821C7.3133 15.6226 8.18179 15.3507 8.52418 15.1935C8.57803 14.7959 8.73353 14.5245 8.90512 14.3709C7.57243 14.2153 6.17147 13.6878 6.17147 11.3306C6.17147 10.6589 6.40586 10.1102 6.78968 9.67934C6.72739 9.52439 6.52201 8.89869 6.84781 8.05131C6.84781 8.05131 7.35165 7.88597 8.49825 8.6819C8.97686 8.54559 9.49014 8.47724 10.0001 8.47489C10.51 8.47724 11.0236 8.54559 11.5031 8.6819C12.6483 7.88597 13.1515 8.05131 13.1515 8.05131C13.4781 8.89869 13.2726 9.52439 13.2103 9.67934C13.595 10.1102 13.8278 10.6589 13.8278 11.3306C13.8278 13.6934 12.4242 14.2137 11.0881 14.366C11.3033 14.5569 11.4951 14.9313 11.4951 15.5052C11.4951 16.3284 11.4881 16.9909 11.4881 17.1935C11.4881 17.3572 11.5961 17.549 11.9003 17.4886C14.283 16.6742 16 14.3691 16 11.6519C16 8.25424 13.3137 5.5 10.0001 5.5Z",
        fill: "#161514"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: `url(#${clipId})`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M18 6.5C18 3.73858 20.2386 1.5 23 1.5L33 1.5C35.7614 1.5 38 3.73858 38 6.5V16.5C38 19.2614 35.7614 21.5 33 21.5H23C20.2386 21.5 18 19.2614 18 16.5V6.5Z",
        fill: "#94C748"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M32.8689 11.3016L32.0471 16.3216C31.9935 16.6253 31.7791 16.8039 31.4754 16.8039H24.5081C24.2044 16.8039 23.9901 16.6253 23.9365 16.3216L22.4894 7.37131C22.4358 7.06761 22.5966 6.87109 22.8824 6.87109H33.1011C33.3869 6.87109 33.5477 7.06761 33.4941 7.37131L33.1011 9.72946C33.0475 10.0689 32.851 10.2118 32.5294 10.2118H26.3839C26.2946 10.2118 26.241 10.2654 26.2589 10.3726L26.7412 13.3381C26.7591 13.4096 26.8127 13.4632 26.8842 13.4632H29.0994C29.1708 13.4632 29.2244 13.4096 29.2423 13.3381L29.5817 11.1944C29.6175 10.9264 29.7961 10.8192 30.0462 10.8192H32.458C32.8153 10.8192 32.9224 10.9979 32.8689 11.3016Z",
        fill: "#101214"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("mask", {
        id: githubMaskId,
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "40",
        height: "23"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "23",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "16.5",
        width: "23",
        height: "23",
        rx: "6.5",
        fill: "black"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: clipId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "20",
        height: "20",
        fill: "white",
        transform: "translate(18 1.5)"
    }))));
};
const $538838085c952370$export$a04b967a3e5840e8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        "aria-hidden": "true",
        "data-testid": "dev-docs-choose-repository-illustration",
        fill: "none",
        focusable: "false",
        height: "59",
        viewBox: "0 0 74 59",
        width: "74",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M57.8899 7 28.0599 58.67l-12.12-7L45.7699 0l12.12 7Z",
        fill: "#6A9A23"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "m50.9698 3-12.19 15.06 8.67 7.01 10.44-18.08L50.9698 3Z",
        fill: "#FCA700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "m26.0699 34.1104-10.13 17.55 7.37 4.26 11.47-15.27-8.71-6.54Z",
        fill: "#AF59E1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "m34.96 18.5599-14.25 11.53 14.07 10.55-7.64 10.18L0 30.4699l26.96-21.8 8 9.9v-.01Zm38.78 11.41L46.6 50.3299l-7.64-10.18 14.07-10.55-14.25-11.53 8-9.9 26.96 21.8Z",
        fill: "var(--ds-background-neutral-hovered, #0B120E24)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "m46.7798 8.16016-8 9.90004 8.67 7.01 6.45-11.15-7.12-5.76004Z",
        fill: "var(--ds-icon, #292A2E)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "m34.7802 40.6504-8.71-6.54-6.41 11.11 7.48 5.61 7.64-10.18Z",
        fill: "var(--ds-icon, #292A2E)"
    }));
const $538838085c952370$export$fcf557f4087626cf = ()=>{
    const id = (0, $cozmU.useId)().replace(/:/g, '');
    const clipId = `devDocsScmProviderPanelIconsClip-${id}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        "aria-hidden": "true",
        fill: "none",
        focusable: "false",
        height: "36",
        viewBox: "0 0 64 36",
        width: "64",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        y: "1.58496",
        width: "32",
        height: "32",
        rx: "8",
        fill: "#94C748"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "m23.79 17.2694-1.3149 8.032c-.0857.4859-.4287.7718-.9147.7718H10.4128c-.4859 0-.8289-.2859-.91465-.7718L7.18287 10.981c-.08575-.4859.1715-.8003.62884-.8003H24.1616c.4573 0 .7145.3144.6288.8003l-.6288 3.773c-.0858.5431-.4002.7718-.9147.7718h-9.8328c-.1429 0-.2287.0858-.2001.2573l.7718 4.7448c.0286.1144.1143.2001.2286.2001h3.5444c.1144 0 .2001-.0857.2287-.2001l.5431-3.43c.0571-.4288.343-.6003.7432-.6003h3.8587c.5717 0 .7432.2859.6575.7718Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: `url(#${clipId})`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M28.8362 11.3009c-.4618-4.39407 2.7259-8.33057 7.12-8.7924L51.8685.83604c4.3941-.46183 8.3306 2.72588 8.7924 7.11995l1.6725 15.91231c.4618 4.3941-2.7259 8.3306-7.12 8.7924l-15.9123 1.6725c-4.3941.4618-8.3306-2.7259-8.7924-7.1199l-1.6725-15.9124Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "m44.184 7.67665.704-.074c.1691.01181.4051-.0178.5828-.0201.3878-.00388.7756.01403 1.1614.05365 2.4546.25864 4.7268 1.41567 6.3798 3.2485 1.0431 1.1532 1.8012 2.5349 2.2133 4.0343.0699.2539.1299.5104.1798.769.0143.0791.0678.4293.0866.4867l.0778.7412c-.0086.0816.0143.4199.0167.5314.0038.2989-.0053.5979-.0275.896-.1393 1.8411-.7861 3.6076-1.8684 5.1034-.8779 1.217-2.0181 2.2212-3.3362 2.9385-.1968.1069-.4092.2205-.6176.3019-.1613.063-.3936.057-.5348-.0488-.2035-.1523-.1971-.4168-.2192-.6453l-.0529-.5387c-.0643-.6631-.1273-1.34-.2051-2.0007-.0775-.6593-.3182-1.2569-.8528-1.6748.2042-.0389.4631-.1083.6635-.1663.8929-.2583 1.7672-.6617 2.3992-1.3634.8647-.9602 1.0545-2.1781.9938-3.4254-.059-1.2115-.4193-2.1713-1.3354-2.9945.2475-.9105.0307-1.8038-.3752-2.6273-.843-.0722-2.0136.7975-2.6241 1.3074-1.7173-.262-3.3494-.112-4.9742.5247-.7164-.372-2.0169-.9686-2.8396-.7347-.2684.8215-.2146 1.8718.1763 2.6489-.5117.6865-.7801 1.5239-.7627 2.3801.0168 1.2543.4549 2.7489 1.3708 3.6421.958.9345 2.4039 1.2043 3.694 1.1875-.3608.4279-.4678.8499-.4947 1.4016-.2963.1627-.5405.2732-.8774.3433-.7398.1538-1.4025-.0704-1.9119-.6248-.1054-.1147-.1979-.2407-.2999-.3591-.1534-.1747-.3288-.3286-.5218-.4581-.3595-.2371-.7339-.3429-1.1598-.2523-.2941.0625-.3931.2031-.1327.4213.1824.1528.4031.1979.5848.3461.329.2625.5997.6137.8302.9637.0788.1197.1385.2468.21.3674.1554.2618.3774.4776.6435.6255.8105.4514 1.8849.264 2.732.0209.0094.164.0397.3778.0585.5434l.0961.8689c.0153.1346.0699.4232.0524.5442-.0924.6378-.7689.4192-1.1363.3176-.8655-.2391-1.6951-.5932-2.4666-1.0527-2.0878-1.241-3.6515-3.2007-4.398-5.5119-.1144-.3558-.209-.7176-.2832-1.0839-.0325-.1631-.0645-.4259-.1026-.5727l-.0025-.0095-.0752-.7149c.007-.0755-.0138-.3628-.0165-.4606-.0073-.2732-.0031-.5466.0127-.8195.0895-1.5655.5476-3.0878 1.3367-4.4427 1.2301-2.1184 3.1954-3.7112 5.5226-4.47596.3729-.12182.7526-.22227 1.137-.30087.1794-.03621.4197-.05783.5883-.10532Z",
        fill: "#1D2022"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "m36.0084 3.00576 15.9124-1.67246c4.1194-.43297 7.8099 2.55551 8.2429 6.67496l1.6724 15.91234c.433 4.1195-2.5555 7.8099-6.6749 8.2429l-15.9124 1.6724c-4.1194.433-7.8099-2.5555-8.2429-6.6749l-1.6724-15.9124c-.433-4.11941 2.5555-7.80987 6.6749-8.24284Z",
        stroke: "#0B120E",
        strokeOpacity: ".14"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: clipId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M28.8362 11.3009c-.4618-4.39407 2.7259-8.33057 7.12-8.7924L51.8685.83604c4.3941-.46183 8.3306 2.72588 8.7924 7.11995l1.6725 15.91231c.4618 4.3941-2.7259 8.3306-7.12 8.7924l-15.9123 1.6725c-4.3941.4618-8.3306-2.7259-8.7924-7.1199l-1.6725-15.9124Z"
    }))));
};
module.exports["DevDocsScmProviderIcon"] = $538838085c952370$export$baf7f667000d5120;
module.exports["DevDocsScmProviderLogo"] = $538838085c952370$export$aa878a664e851ba8;
module.exports["DevDocsScmProviderSourceIcon"] = $538838085c952370$export$7f490fa62960c9b0;
module.exports["DevDocsScmProviderButtonIcons"] = $538838085c952370$export$85f61ad9846f98b;
module.exports["DevDocsChooseRepositoryIllustration"] = $538838085c952370$export$a04b967a3e5840e8;
module.exports["DevDocsScmProviderPanelIcons"] = $538838085c952370$export$fcf557f4087626cf;

});

parcelRegister("fONL3", function(module, exports) {

var $6gp4u = parcelRequire("6gp4u");

const $eef06249f4fc4cc7$var$GITHUB_REPOSITORY_SHORTHAND_PATTERN = /^([A-Za-z0-9_.-]+)\/([A-Za-z0-9_.-]+(?:\.git)?)$/;
const $eef06249f4fc4cc7$var$BITBUCKET_INTEGRATION_HOST = 'integration.bb-inf.net';
const $eef06249f4fc4cc7$var$REPOSITORY_RESOURCE_TYPE = 'repository';
const $eef06249f4fc4cc7$var$buildRepositoryUrl = (host, { owner: owner, repo: repo })=>`https://${host}/${owner}/${repo}`;
const $eef06249f4fc4cc7$var$getBitbucketHost = (environment)=>environment === 'STAGING' ? $eef06249f4fc4cc7$var$BITBUCKET_INTEGRATION_HOST : 'bitbucket.org';
const $eef06249f4fc4cc7$var$stripGitSuffix = (value)=>value.replace(/\.git$/i, '');
const $eef06249f4fc4cc7$var$stripUuidBraces = (value)=>value.replace(/^\{(.+)\}$/, '$1');
const $eef06249f4fc4cc7$var$buildBitbucketRepositoryAri = ({ objectId: objectId })=>{
    if (!objectId) return undefined;
    try {
        return (0, $6gp4u.BitbucketRepositoryAri).create({
            repositoryId: $eef06249f4fc4cc7$var$stripUuidBraces(objectId)
        }).toString();
    } catch  {
        return undefined;
    }
};
const $eef06249f4fc4cc7$export$9651f3dd35e51282 = (pathParts)=>{
    if (pathParts.length < 2) return undefined;
    const [owner, repoPath] = pathParts;
    const repo = repoPath ? $eef06249f4fc4cc7$var$stripGitSuffix(repoPath) : undefined;
    return owner && repo ? {
        owner: owner,
        repo: repo
    } : undefined;
};
const $eef06249f4fc4cc7$export$f812d4ea50497f49 = (value)=>{
    const repositoryShorthand = value.match($eef06249f4fc4cc7$var$GITHUB_REPOSITORY_SHORTHAND_PATTERN);
    if (!repositoryShorthand) return undefined;
    const [, owner, repoPath] = repositoryShorthand;
    const repo = repoPath ? $eef06249f4fc4cc7$var$stripGitSuffix(repoPath) : undefined;
    return owner && repo ? {
        owner: owner,
        repo: repo
    } : undefined;
};
const $eef06249f4fc4cc7$export$e7f966d02dce4619 = (host)=>host.toLowerCase().replace(/^www\./, '');
const $eef06249f4fc4cc7$export$354ce7f5f6d9970 = (repository, host)=>$eef06249f4fc4cc7$var$buildRepositoryUrl(host, repository);
const $eef06249f4fc4cc7$export$d8f345c623fa528a = (providerConfig, host)=>{
    const normalizedHost = host ? $eef06249f4fc4cc7$export$e7f966d02dce4619(host) : null;
    return providerConfig.provider === 'bitbucket' && normalizedHost === $eef06249f4fc4cc7$var$BITBUCKET_INTEGRATION_HOST ? normalizedHost : providerConfig.canonicalHost;
};
const $eef06249f4fc4cc7$export$b4adbc4025bc991f = (value)=>{
    if (!value) return undefined;
    let parsedUrl;
    try {
        parsedUrl = new URL(value);
    } catch  {
        return undefined;
    }
    const repository = $eef06249f4fc4cc7$export$9651f3dd35e51282(parsedUrl.pathname.split('/').filter(Boolean));
    if (!repository) return undefined;
    const host = $eef06249f4fc4cc7$export$e7f966d02dce4619(parsedUrl.hostname);
    return {
        host: host,
        repository: repository,
        url: $eef06249f4fc4cc7$export$354ce7f5f6d9970(repository, host)
    };
};
const $eef06249f4fc4cc7$export$18b147ae9dea07b = [
    {
        buildCanonicalUrl: (repository, { environment: environment } = {})=>$eef06249f4fc4cc7$var$buildRepositoryUrl($eef06249f4fc4cc7$var$getBitbucketHost(environment), repository),
        buildObjectResolverRepositoryAri: $eef06249f4fc4cc7$var$buildBitbucketRepositoryAri,
        canonicalHost: 'bitbucket.org',
        displayName: 'Bitbucket',
        objectResolverProviderKey: 'integration-bitbucket-object-provider',
        provider: 'bitbucket',
        repositoryAriPattern: /^ari:cloud:bitbucket::repository\/[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/,
        scmType: 'BITBUCKET'
    },
    {
        buildCanonicalUrl: (repository)=>$eef06249f4fc4cc7$var$buildRepositoryUrl('github.com', repository),
        canonicalHost: 'github.com',
        displayName: 'GitHub',
        objectResolverProviderKey: 'github-object-provider',
        provider: 'github',
        repositoryAriPattern: /^ari:third-party:github\.github::repository\/[0-9]+$/,
        scmType: 'GITHUB'
    }
];
const $eef06249f4fc4cc7$export$25b2d56cd64b0713 = (host)=>{
    const normalizedHost = $eef06249f4fc4cc7$export$e7f966d02dce4619(host);
    return $eef06249f4fc4cc7$export$18b147ae9dea07b.find((providerConfig)=>providerConfig.canonicalHost === normalizedHost || providerConfig.provider === 'bitbucket' && normalizedHost === $eef06249f4fc4cc7$var$BITBUCKET_INTEGRATION_HOST);
};
const $eef06249f4fc4cc7$var$normalizeProviderValue = (value)=>{
    const normalizedValue = value?.toLowerCase().replace(/\s+/g, '').trim();
    return normalizedValue || null;
};
const $eef06249f4fc4cc7$var$getHostFromProviderValue = (value)=>{
    try {
        return new URL(value).hostname;
    } catch  {
        try {
            return new URL(`https://${value}`).hostname;
        } catch  {
            return null;
        }
    }
};
const $eef06249f4fc4cc7$export$16184dfce7539500 = (value)=>{
    const normalizedValue = $eef06249f4fc4cc7$var$normalizeProviderValue(value);
    if (!normalizedValue) return undefined;
    const trimmedValue = value?.trim() ?? '';
    const hostProviderConfig = $eef06249f4fc4cc7$export$25b2d56cd64b0713($eef06249f4fc4cc7$var$getHostFromProviderValue(trimmedValue) ?? '');
    if (hostProviderConfig) return hostProviderConfig;
    return $eef06249f4fc4cc7$export$18b147ae9dea07b.find((providerConfig)=>{
        const providerIdentifiers = [
            providerConfig.provider,
            providerConfig.displayName,
            providerConfig.canonicalHost,
            providerConfig.objectResolverProviderKey,
            providerConfig.scmType
        ];
        return providerConfig.repositoryAriPattern.test(trimmedValue) || providerIdentifiers.some((providerIdentifier)=>{
            const normalizedIdentifier = $eef06249f4fc4cc7$var$normalizeProviderValue(providerIdentifier);
            return normalizedIdentifier ? normalizedValue === normalizedIdentifier : false;
        });
    });
};
const $eef06249f4fc4cc7$export$3f5207994c079797 = (value)=>$eef06249f4fc4cc7$export$16184dfce7539500(value)?.provider ?? null;
const $eef06249f4fc4cc7$export$77974dc89b5b9d22 = ({ environment: environment, provider: provider, repoName: repoName })=>{
    const providerConfig = $eef06249f4fc4cc7$export$16184dfce7539500(provider);
    const repository = repoName ? $eef06249f4fc4cc7$export$9651f3dd35e51282(repoName.split('/')) : undefined;
    return providerConfig && repository ? providerConfig.buildCanonicalUrl(repository, {
        environment: environment
    }) : null;
};
const $eef06249f4fc4cc7$export$acb1b6d41bfe6bca = ({ environment: environment, fallbackTitle: fallbackTitle, provider: provider, repoName: repoName })=>{
    const normalizedRepoName = repoName?.trim() || null;
    return {
        title: normalizedRepoName ?? fallbackTitle,
        url: $eef06249f4fc4cc7$export$77974dc89b5b9d22({
            environment: environment,
            provider: provider,
            repoName: normalizedRepoName
        })
    };
};
const $eef06249f4fc4cc7$export$9b7d9c81264df445 = (metadata)=>{
    const key = metadata?.key?.toLowerCase();
    const product = metadata?.product?.toLowerCase();
    const resourceType = metadata?.resourceType?.toLowerCase();
    return $eef06249f4fc4cc7$export$18b147ae9dea07b.find((providerConfig)=>{
        const provider = providerConfig.provider.toLowerCase();
        const displayName = providerConfig.displayName.toLowerCase();
        return key === providerConfig.objectResolverProviderKey.toLowerCase() || product === provider || product === displayName || resourceType === $eef06249f4fc4cc7$var$REPOSITORY_RESOURCE_TYPE && (key === provider || key === displayName);
    });
};
const $eef06249f4fc4cc7$export$cc2e4b3c6e3f425b = (appName)=>$eef06249f4fc4cc7$export$3f5207994c079797(appName);
const $eef06249f4fc4cc7$export$b4189d2b8e03b0f7 = (containerApp)=>$eef06249f4fc4cc7$export$cc2e4b3c6e3f425b(containerApp) !== null;
const $eef06249f4fc4cc7$export$9302c28651566346 = (value)=>$eef06249f4fc4cc7$export$16184dfce7539500(value)?.displayName ?? (value?.trim() || null);
const $eef06249f4fc4cc7$export$e801024d904ce3d9 = (provider)=>{
    const providerConfig = $eef06249f4fc4cc7$export$18b147ae9dea07b.find((sourceProviderConfig)=>sourceProviderConfig.provider === provider);
    if (!providerConfig) throw new Error(`Missing Dev Docs source provider config for ${provider}`);
    return providerConfig;
};
module.exports["getRepositoryPartsFromPathParts"] = $eef06249f4fc4cc7$export$9651f3dd35e51282;
module.exports["getGithubRepositoryPartsFromShorthand"] = $eef06249f4fc4cc7$export$f812d4ea50497f49;
module.exports["getDevDocsNormalizedSourceProviderHost"] = $eef06249f4fc4cc7$export$e7f966d02dce4619;
module.exports["buildDevDocsRepositoryRootUrl"] = $eef06249f4fc4cc7$export$354ce7f5f6d9970;
module.exports["getDevDocsRepositoryRootHost"] = $eef06249f4fc4cc7$export$d8f345c623fa528a;
module.exports["getDevDocsRepositoryRootUrl"] = $eef06249f4fc4cc7$export$b4adbc4025bc991f;
module.exports["getDevDocsSourceProviderByHost"] = $eef06249f4fc4cc7$export$25b2d56cd64b0713;
module.exports["getDevDocsSourceProviderConfigFromValue"] = $eef06249f4fc4cc7$export$16184dfce7539500;
module.exports["getDevDocsSourceProviderFromValue"] = $eef06249f4fc4cc7$export$3f5207994c079797;
module.exports["getDevDocsRepositoryUrl"] = $eef06249f4fc4cc7$export$77974dc89b5b9d22;
module.exports["getDevDocsRepositoryDisplay"] = $eef06249f4fc4cc7$export$acb1b6d41bfe6bca;
module.exports["getDevDocsSourceProviderConfigFromObjectResolverMetadata"] = $eef06249f4fc4cc7$export$9b7d9c81264df445;
module.exports["getDevDocsSourceProviderForAppName"] = $eef06249f4fc4cc7$export$cc2e4b3c6e3f425b;
module.exports["getDevDocsSourceProviderDisplayName"] = $eef06249f4fc4cc7$export$9302c28651566346;
module.exports["getDevDocsSourceProviderConfig"] = $eef06249f4fc4cc7$export$e801024d904ce3d9;

});

parcelRegister("3BmH5", function(module, exports) {

var $6rBRz = parcelRequire("6rBRz");

const $b13a5e685a63e41e$export$1813df84621a6710 = (properties)=>{
    const devDocsProperties = (0, $6rBRz.getDevDocsProperties)(properties);
    const smartFolderProperties = (0, $6rBRz.getDevDocsSmartFolderProperties)(properties);
    return {
        containerApp: smartFolderProperties?.containerApp ?? null,
        devDocsProperties: devDocsProperties,
        smartFolderProperties: smartFolderProperties
    };
};
module.exports["getDevDocsFolderMetadata"] = $b13a5e685a63e41e$export$1813df84621a6710;

});

parcelRegister("6rBRz", function(module, exports) {
const $7f56be30e613d57d$export$717f665ef6ce5e67 = 'devdocsProperties';
const $7f56be30e613d57d$var$SMART_FOLDER_PROPERTIES_KEY = 'smartFolderProperties';
const $7f56be30e613d57d$var$parseContentPropertyValue = (propertyValue)=>{
    let parsedValue = propertyValue;
    try {
        for(let unwrapCount = 0; unwrapCount < 3; unwrapCount += 1){
            if (typeof parsedValue === 'string') {
                parsedValue = JSON.parse(parsedValue);
                continue;
            }
            if (!parsedValue || typeof parsedValue !== 'object' || Array.isArray(parsedValue)) return null;
            const value = parsedValue.value;
            if (typeof value === 'string' || value && typeof value === 'object') {
                parsedValue = value;
                continue;
            }
            return parsedValue;
        }
    } catch  {
        return null;
    }
    return parsedValue && typeof parsedValue === 'object' && !Array.isArray(parsedValue) ? parsedValue : null;
};
const $7f56be30e613d57d$var$getStringValue = (parsedValue, key)=>{
    const value = parsedValue[key];
    return typeof value === 'string' && value.length > 0 ? value : null;
};
const $7f56be30e613d57d$var$getBooleanValue = (parsedValue, key)=>parsedValue[key] === true;
const $7f56be30e613d57d$var$getObjectValue = (parsedValue, key)=>{
    const value = parsedValue[key];
    return value && typeof value === 'object' && !Array.isArray(value) ? value : null;
};
const $7f56be30e613d57d$export$48d1088454f9afc1 = (properties)=>{
    const devDocsProperties = properties?.find((property)=>property?.key === $7f56be30e613d57d$export$717f665ef6ce5e67);
    const parsedValue = devDocsProperties?.value !== undefined ? $7f56be30e613d57d$var$parseContentPropertyValue(devDocsProperties.value) : null;
    return parsedValue ? {
        customPrompt: $7f56be30e613d57d$var$getStringValue($7f56be30e613d57d$var$getObjectValue(parsedValue, 'devDocsConfig') ?? {}, 'customPrompt'),
        ref: $7f56be30e613d57d$var$getStringValue($7f56be30e613d57d$var$getObjectValue(parsedValue, 'devDocsConfig') ?? {}, 'ref'),
        repoName: $7f56be30e613d57d$var$getStringValue($7f56be30e613d57d$var$getObjectValue(parsedValue, 'devDocsConfig') ?? {}, 'repoName'),
        syncTaskAri: $7f56be30e613d57d$var$getStringValue(parsedValue, 'syncTaskAri')
    } : null;
};
const $7f56be30e613d57d$export$8cfd9e7aae7c88a3 = (properties)=>Boolean(properties?.some((property)=>property?.key === $7f56be30e613d57d$export$717f665ef6ce5e67));
const $7f56be30e613d57d$export$a9f33e9d1e3524ad = (properties)=>{
    const smartFolderProperties = properties?.find((property)=>property?.key === $7f56be30e613d57d$var$SMART_FOLDER_PROPERTIES_KEY);
    const parsedValue = smartFolderProperties?.value !== undefined ? $7f56be30e613d57d$var$parseContentPropertyValue(smartFolderProperties.value) : null;
    return parsedValue ? {
        containerApp: $7f56be30e613d57d$var$getStringValue(parsedValue, 'containerApp'),
        lastSynced: $7f56be30e613d57d$var$getStringValue(parsedValue, 'lastSynced'),
        lastSyncAttemptedAt: $7f56be30e613d57d$var$getStringValue(parsedValue, 'lastSyncAttemptedAt'),
        lastSyncTaskAri: $7f56be30e613d57d$var$getStringValue(parsedValue, 'lastSyncTaskAri'),
        syncErrorType: $7f56be30e613d57d$var$getStringValue(parsedValue, 'syncErrorType'),
        syncInProgress: $7f56be30e613d57d$var$getBooleanValue(parsedValue, 'syncInProgress')
    } : null;
};
module.exports["getDevDocsProperties"] = $7f56be30e613d57d$export$48d1088454f9afc1;
module.exports["hasDevDocsContentProperty"] = $7f56be30e613d57d$export$8cfd9e7aae7c88a3;
module.exports["getDevDocsSmartFolderProperties"] = $7f56be30e613d57d$export$a9f33e9d1e3524ad;

});

parcelRegister("i1PdO", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");


var $aboIx = parcelRequire("aboIx");

const $294e9e08bc7d2598$var$getPropertyCollections = ({ contentProperties: contentProperties, devDocsOwnershipProperties: devDocsOwnershipProperties, devDocsProperties: devDocsProperties, propertyCollections: propertyCollections, smartFolderProperties: smartFolderProperties })=>[
        ...propertyCollections ?? [],
        contentProperties,
        devDocsOwnershipProperties,
        devDocsProperties,
        smartFolderProperties
    ];
const $294e9e08bc7d2598$export$acc7106896b1bce2 = (sources)=>{
    const { contentProperties: contentProperties, devDocsOwnershipProperties: devDocsOwnershipProperties, devDocsProperties: devDocsProperties, propertyCollections: propertyCollections, smartFolderProperties: smartFolderProperties } = sources;
    const isDevDocsEnabled = (0, $6mKj3.isExperimentEnabled)('confluence_dev_docs');
    const isDevDocsOwned = (0, $cozmU.useMemo)(()=>(0, $aboIx.isDevDocsOwnedFolder)({
            propertyCollections: $294e9e08bc7d2598$var$getPropertyCollections({
                contentProperties: contentProperties,
                devDocsOwnershipProperties: devDocsOwnershipProperties,
                devDocsProperties: devDocsProperties,
                propertyCollections: propertyCollections,
                smartFolderProperties: smartFolderProperties
            })
        }), [
        contentProperties,
        devDocsOwnershipProperties,
        devDocsProperties,
        propertyCollections,
        smartFolderProperties
    ]);
    return (0, $cozmU.useMemo)(()=>({
            isDevDocsEnabled: isDevDocsEnabled,
            isDevDocsEligible: isDevDocsEnabled && isDevDocsOwned,
            isDevDocsOwned: isDevDocsOwned
        }), [
        isDevDocsEnabled,
        isDevDocsOwned
    ]);
};
module.exports["useDevDocsFolderEligibility"] = $294e9e08bc7d2598$export$acc7106896b1bce2;

});

parcelRegister("aboIx", function(module, exports) {

var $6rBRz = parcelRequire("6rBRz");

const $95f2a41306aaddc5$var$DEV_DOCS_CONTAINER_APPS = new Set([
    'bitbucket',
    'github'
]);
const $95f2a41306aaddc5$var$isDevDocsContainerApp = (containerApp)=>Boolean(containerApp && $95f2a41306aaddc5$var$DEV_DOCS_CONTAINER_APPS.has(containerApp.trim().toLowerCase()));
const $95f2a41306aaddc5$export$270f9eb55072514a = ({ propertyCollections: propertyCollections = [] })=>{
    if (propertyCollections.some((properties)=>(0, $6rBRz.hasDevDocsContentProperty)(properties))) return true;
    return propertyCollections.some((properties)=>$95f2a41306aaddc5$var$isDevDocsContainerApp((0, $6rBRz.getDevDocsSmartFolderProperties)(properties)?.containerApp));
};
const $95f2a41306aaddc5$export$4977c1f16ed3f03f = ({ ownershipProperties: ownershipProperties, smartFolderProperties: smartFolderProperties })=>$95f2a41306aaddc5$export$270f9eb55072514a({
        propertyCollections: [
            ownershipProperties,
            smartFolderProperties
        ]
    });
module.exports["isDevDocsOwnedFolder"] = $95f2a41306aaddc5$export$270f9eb55072514a;
module.exports["shouldExcludeDevDocsAutoSync"] = $95f2a41306aaddc5$export$4977c1f16ed3f03f;

});

parcelRegister("sD2Tz", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $9Vkdl = parcelRequire("9Vkdl");


var $1Gu3g = parcelRequire("1Gu3g");


var $4ri4I = parcelRequire("4ri4I");


var $6mKj3 = parcelRequire("6mKj3");


var $58PBI = parcelRequire("58PBI");

// predictive prefetch only runs in browser environments that expose the API.
// Evaluated lazily (as a function) so that test environments can mock window.matchMedia before it is checked.
const $f75716c2560aeeb6$var$getHasMatchMedia = ()=>typeof window !== 'undefined' && typeof window.matchMedia === 'function'; // Copied from https://foresightjs.com/docs/react/hook
function $f75716c2560aeeb6$var$useForesight(options, enabled) {
    const $ = (0, $bDgLe.c)(5);
    const elementRef = (0, $cozmU.useRef)(null);
    const registerResults = (0, $cozmU.useRef)(null);
    let t0;
    let t1;
    if ($[0] !== enabled || $[1] !== options) {
        t0 = ()=>{
            if (!elementRef.current || !enabled) return;
            if (!$f75716c2560aeeb6$var$getHasMatchMedia()) return;
            (0, $9Vkdl.ForesightManager).initialize({
                enableMousePrediction: true,
                trajectoryPredictionTime: (0, $6mKj3.expVal)("platform_editor_predictive_collabdraft_prefetch", "trajectoryPredictionTime", 120),
                positionHistorySize: 8
            });
            const currentElement = elementRef.current;
            registerResults.current = (0, $9Vkdl.ForesightManager).instance.register({
                element: currentElement,
                ...options
            });
            return ()=>{
                (0, $9Vkdl.ForesightManager).instance?.unregister(currentElement, "useEffect");
            };
        };
        t1 = [
            options,
            enabled
        ];
        $[0] = enabled;
        $[1] = options;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            elementRef: elementRef,
            registerResults: registerResults
        };
        $[4] = t2;
    } else t2 = $[4];
    return t2;
}
const $f75716c2560aeeb6$var$PREFETCH_CLICK_WINDOW_MS = 15000;
const $f75716c2560aeeb6$var$pendingPrefetchAnalyticsEvents = new Map();
const $f75716c2560aeeb6$var$clearPendingPrefetchAnalytics = (contentId)=>{
    const pendingPrefetch = $f75716c2560aeeb6$var$pendingPrefetchAnalyticsEvents.get(contentId);
    if (pendingPrefetch) {
        clearTimeout(pendingPrefetch.timeoutId);
        $f75716c2560aeeb6$var$pendingPrefetchAnalyticsEvents.delete(contentId);
    }
};
const $f75716c2560aeeb6$var$registerPendingPrefetchAnalytics = ({ contentId: contentId, sendPrefetchAnalyticsEvent: sendPrefetchAnalyticsEvent })=>{
    // If there's an existing pending prefetch event for this content that hasn't
    // resolved or timed out yet, fire a prefetchUnused event for it before
    // replacing it with the new one.
    const pendingPrefetch = $f75716c2560aeeb6$var$pendingPrefetchAnalyticsEvents.get(contentId);
    $f75716c2560aeeb6$var$clearPendingPrefetchAnalytics(contentId);
    if (pendingPrefetch) sendPrefetchAnalyticsEvent('prefetchUnused', contentId, {
        clickWindowMs: $f75716c2560aeeb6$var$PREFETCH_CLICK_WINDOW_MS,
        prefetchSource: 'foresightjs'
    });
    const firedAt = Date.now();
    const timeoutId = setTimeout(()=>{
        const pendingPrefetch = $f75716c2560aeeb6$var$pendingPrefetchAnalyticsEvents.get(contentId);
        if (!pendingPrefetch || pendingPrefetch.firedAt !== firedAt) return;
        $f75716c2560aeeb6$var$pendingPrefetchAnalyticsEvents.delete(contentId);
        sendPrefetchAnalyticsEvent('prefetchUnused', contentId, {
            clickWindowMs: $f75716c2560aeeb6$var$PREFETCH_CLICK_WINDOW_MS,
            prefetchSource: 'foresightjs'
        });
    }, $f75716c2560aeeb6$var$PREFETCH_CLICK_WINDOW_MS);
    $f75716c2560aeeb6$var$pendingPrefetchAnalyticsEvents.set(contentId, {
        firedAt: firedAt,
        timeoutId: timeoutId
    });
};
const $f75716c2560aeeb6$export$545c7ef2fbcc68a6 = (contentId, sendPrefetchAnalyticsEvent)=>{
    const pendingPrefetch = $f75716c2560aeeb6$var$pendingPrefetchAnalyticsEvents.get(contentId);
    if (!pendingPrefetch) return;
    const timeToClickMs = Date.now() - pendingPrefetch.firedAt;
    clearTimeout(pendingPrefetch.timeoutId);
    $f75716c2560aeeb6$var$pendingPrefetchAnalyticsEvents.delete(contentId);
    sendPrefetchAnalyticsEvent('prefetchAndClick', contentId, {
        clickWindowMs: $f75716c2560aeeb6$var$PREFETCH_CLICK_WINDOW_MS,
        prefetchSource: 'foresightjs',
        timeToClickMs: timeToClickMs
    });
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Styling div for hover area only
const $f75716c2560aeeb6$var$HoverAreaWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1mT5xdRAKS _4jFnWevLYW _3Ku51Iogpp _3dCYwDWVPG",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f75716c2560aeeb6$export$93fd4db39a89045f = ({ contentId: contentId, spaceKey: spaceKey, children: children, editSource: editSource, isEmbeddedEditor: isEmbeddedEditor, sendPrefetchAnalyticsEvent: sendPrefetchAnalyticsEvent, predictivelyPrefetch: predictivelyPrefetch })=>{
    const preloader = (0, $cozmU.useContext)((0, $58PBI.EditContentButtonPreloaderContext)); // See packages/confluence-fabric-editor/src/editorPreloader.tsx
    const [doPreload, setDoPreload] = (0, $cozmU.useState)(false);
    const doPreloadRef = (0, $cozmU.useRef)(doPreload);
    const [{ editSource: contextEditSource }, { setEditSource: setEditSource }] = (0, $4ri4I.useEditSource)();
    (0, $cozmU.useEffect)(()=>{
        // Keep the ref in sync with the latest doPreload value so that the function returned by
        // cleanup editorPreloadManager always uses the current doPreload value instead of the one before.
        doPreloadRef.current = doPreload;
    }, [
        doPreload
    ]); // Cleanup editorPreloadManager on contentId change and unmount.
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            $f75716c2560aeeb6$var$clearPendingPrefetchAnalytics(contentId);
            if (doPreloadRef.current) (0, $1Gu3g.EditorPreloadManager).removePreloadedId(contentId);
        };
    }, [
        contentId
    ]); // Register edit-button element with ForesightJS for mouse trajectory prediction
    // Only call useForesight when predictive prefetch is enabled
    const foresightOptions = (0, $cozmU.useMemo)(()=>({
            callback: async ()=>{
                if ((0, $1Gu3g.EditorPreloadManager).shouldPreload(contentId) && predictivelyPrefetch) {
                    setDoPreload(true);
                    setEditSource(editSource);
                    $f75716c2560aeeb6$var$registerPendingPrefetchAnalytics({
                        contentId: contentId,
                        sendPrefetchAnalyticsEvent: sendPrefetchAnalyticsEvent
                    });
                }
            },
            name: `edit-button-${contentId}`,
            reactivateAfter: 15000
        }), [
        contentId,
        editSource,
        setEditSource,
        setDoPreload,
        predictivelyPrefetch,
        sendPrefetchAnalyticsEvent
    ]);
    const { elementRef: elementRef } = $f75716c2560aeeb6$var$useForesight(foresightOptions, predictivelyPrefetch); // On hover callback
    const onHover = (0, $cozmU.useCallback)(async ()=>{
        if ((0, $1Gu3g.EditorPreloadManager).shouldPreload(contentId)) {
            setDoPreload(true);
            setEditSource(editSource);
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        editSource
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f75716c2560aeeb6$var$HoverAreaWrapper, {
        ref: $f75716c2560aeeb6$var$getHasMatchMedia() && predictivelyPrefetch && (0, $6mKj3.expValEquals)('platform_editor_predictive_collabdraft_prefetch', 'isEnabled', true) ? elementRef : null,
        onMouseEnter: $f75716c2560aeeb6$var$getHasMatchMedia() && predictivelyPrefetch && (0, $6mKj3.expValEquals)('platform_editor_predictive_collabdraft_prefetch', 'isEnabled', true) ? undefined : onHover
    }, children), editSource === contextEditSource && doPreload && preloader ? preloader({
        contentId: contentId,
        spaceKey: spaceKey,
        isEmbeddedEditor: isEmbeddedEditor
    }) : null);
};
module.exports["resolvePendingPrefetchAnalytics"] = $f75716c2560aeeb6$export$545c7ef2fbcc68a6;
module.exports["EditContentButtonPreloader"] = $f75716c2560aeeb6$export$93fd4db39a89045f;

});

parcelRegister("9Vkdl", function(module, exports) {

var $akD6a = parcelRequire("akD6a");

function $73991e0e121001da$var$k() {
    let n = $73991e0e121001da$var$E(), e = $73991e0e121001da$var$L();
    return {
        isTouchDevice: n,
        isLimitedConnection: e,
        shouldRegister: !e
    };
}
function $73991e0e121001da$var$E() {
    return typeof window > "u" || typeof navigator > "u" ? !1 : window.matchMedia("(pointer: coarse)").matches && navigator.maxTouchPoints > 0;
}
function $73991e0e121001da$var$L() {
    let n = navigator.connection;
    if (!n) return !1;
    let e = $73991e0e121001da$export$1435e6a4c843d234.instance.getManagerData.globalSettings.minimumConnectionType, t = [
        "slow-2g",
        "2g",
        "3g",
        "4g"
    ], i = t.indexOf(n.effectiveType), r = t.indexOf(e);
    return i < r || n.saveData;
}
function $73991e0e121001da$var$F(n) {
    if (typeof window > "u" || typeof document > "u") return !1;
    let e = window.innerWidth || document.documentElement.clientWidth, t = window.innerHeight || document.documentElement.clientHeight;
    return n.top < t && n.bottom > 0 && n.left < e && n.right > 0;
}
function $73991e0e121001da$var$T() {
    return {
        mouse: {
            hover: 0,
            trajectory: 0
        },
        tab: {
            forwards: 0,
            reverse: 0
        },
        scroll: {
            down: 0,
            left: 0,
            right: 0,
            up: 0
        },
        touch: 0,
        viewport: 0,
        total: 0
    };
}
function $73991e0e121001da$var$H() {
    return {
        debug: !1,
        enableManagerLogging: !1,
        enableMousePrediction: !0,
        enableScrollPrediction: !0,
        positionHistorySize: 8,
        trajectoryPredictionTime: 120,
        scrollMargin: 150,
        defaultHitSlop: {
            top: 0,
            left: 0,
            right: 0,
            bottom: 0
        },
        enableTabPrediction: !0,
        tabOffset: 2,
        touchDeviceStrategy: "onTouchStart",
        minimumConnectionType: "3g"
    };
}
function $73991e0e121001da$var$R(n, e, t) {
    let { element: i, callback: r, hitSlop: o, name: s, meta: c, reactivateAfter: b } = n, d = i.getBoundingClientRect(), a = o ? (0, $akD6a.b)(o) : t;
    return {
        id: e,
        element: i,
        callback: r,
        elementBounds: {
            originalRect: d,
            expandedRect: (0, $akD6a.c)(d, a),
            hitSlop: a
        },
        name: s || i.id || "unnamed",
        isIntersectingWithViewport: $73991e0e121001da$var$F(d),
        registerCount: 1,
        meta: c ?? {},
        callbackInfo: {
            callbackFiredCount: 0,
            lastCallbackInvokedAt: void 0,
            lastCallbackCompletedAt: void 0,
            lastCallbackRuntime: void 0,
            lastCallbackStatus: void 0,
            lastCallbackErrorMessage: void 0,
            reactivateAfter: b ?? 1 / 0,
            isCallbackActive: !0,
            isRunningCallback: !1,
            reactivateTimeoutId: void 0
        }
    };
}
var $73991e0e121001da$var$f = class {
    addEventListener(e, t, i) {
        if (i?.signal?.aborted) return;
        let r = this.eventListeners.get(e) ?? [];
        r.push(t), this.eventListeners.set(e, r), i?.signal?.addEventListener("abort", ()=>this.removeEventListener(e, t));
    }
    removeEventListener(e, t) {
        let i = this.eventListeners.get(e);
        if (!i) return;
        let r = i.indexOf(t);
        r > -1 && i.splice(r, 1);
    }
    emit(e) {
        let t = this.eventListeners.get(e.type);
        if (!(!t || t.length === 0)) for(let i = 0; i < t.length; i++)try {
            let r = t[i];
            r && r(e);
        } catch (r) {
            console.error(`Error in ForesightManager event listener ${i} for ${e.type}:`, r);
        }
    }
    hasListeners(e) {
        let t = this.eventListeners.get(e);
        return t !== void 0 && t.length > 0;
    }
    getEventListeners() {
        return this.eventListeners;
    }
    constructor(){
        this.eventListeners = new Map;
    }
};
function $73991e0e121001da$var$y(n, e) {
    return n !== void 0 && e !== n;
}
var $73991e0e121001da$var$I = {
    trajectoryPredictionTime: {
        min: 10,
        max: 200
    },
    positionHistorySize: {
        min: 2,
        max: 30
    },
    scrollMargin: {
        min: 30,
        max: 300
    },
    tabOffset: {
        min: 0,
        max: 20
    }
};
function $73991e0e121001da$var$h(n, e, t) {
    if (!$73991e0e121001da$var$y(t, n[e])) return !1;
    let { min: i, max: r } = $73991e0e121001da$var$I[e];
    return n[e] = (0, $akD6a.a)(t, i, r, e), !0;
}
function $73991e0e121001da$var$m(n, e, t) {
    return $73991e0e121001da$var$y(t, n[e]) ? (n[e] = t, !0) : !1;
}
function $73991e0e121001da$var$M(n, e) {
    $73991e0e121001da$var$h(n, "trajectoryPredictionTime", e.trajectoryPredictionTime), $73991e0e121001da$var$h(n, "positionHistorySize", e.positionHistorySize), $73991e0e121001da$var$h(n, "scrollMargin", e.scrollMargin), $73991e0e121001da$var$h(n, "tabOffset", e.tabOffset), $73991e0e121001da$var$m(n, "enableMousePrediction", e.enableMousePrediction), $73991e0e121001da$var$m(n, "enableScrollPrediction", e.enableScrollPrediction), $73991e0e121001da$var$m(n, "enableTabPrediction", e.enableTabPrediction), $73991e0e121001da$var$m(n, "enableManagerLogging", e.enableManagerLogging), e.defaultHitSlop !== void 0 && (n.defaultHitSlop = (0, $akD6a.b)(e.defaultHitSlop)), e.touchDeviceStrategy !== void 0 && (n.touchDeviceStrategy = e.touchDeviceStrategy), e.minimumConnectionType !== void 0 && (n.minimumConnectionType = e.minimumConnectionType), e.debug !== void 0 && (n.debug = e.debug);
}
function $73991e0e121001da$var$D(n, e) {
    let t = [], i = !1, r = !1, o = !1, s = !1, c = !1;
    if (!e) return {
        changedSettings: t,
        positionHistorySizeChanged: i,
        scrollPredictionChanged: r,
        tabPredictionChanged: o,
        hitSlopChanged: s,
        touchStrategyChanged: c
    };
    let b = [
        "trajectoryPredictionTime",
        "positionHistorySize",
        "scrollMargin",
        "tabOffset"
    ];
    for (let a of b){
        let l = n[a];
        $73991e0e121001da$var$h(n, a, e[a]) && (t.push({
            setting: a,
            oldValue: l,
            newValue: n[a]
        }), a === "positionHistorySize" && (i = !0));
    }
    let d = [
        "enableMousePrediction",
        "enableScrollPrediction",
        "enableTabPrediction"
    ];
    for (let a of d){
        let l = n[a];
        $73991e0e121001da$var$m(n, a, e[a]) && (t.push({
            setting: a,
            oldValue: l,
            newValue: n[a]
        }), a === "enableScrollPrediction" && (r = !0), a === "enableTabPrediction" && (o = !0));
    }
    if (e.defaultHitSlop !== void 0) {
        let a = n.defaultHitSlop, l = (0, $akD6a.b)(e.defaultHitSlop);
        (0, $akD6a.d)(a, l) || (n.defaultHitSlop = l, t.push({
            setting: "defaultHitSlop",
            oldValue: a,
            newValue: l
        }), s = !0);
    }
    if (e.touchDeviceStrategy !== void 0) {
        let a = n.touchDeviceStrategy;
        n.touchDeviceStrategy = e.touchDeviceStrategy, t.push({
            setting: "touchDeviceStrategy",
            oldValue: a,
            newValue: e.touchDeviceStrategy
        }), c = !0;
    }
    if (e.minimumConnectionType !== void 0) {
        let a = n.minimumConnectionType;
        n.minimumConnectionType = e.minimumConnectionType, t.push({
            setting: "minimumConnectionType",
            oldValue: a,
            newValue: e.minimumConnectionType
        });
    }
    return {
        changedSettings: t,
        positionHistorySizeChanged: i,
        scrollPredictionChanged: r,
        tabPredictionChanged: o,
        hitSlopChanged: s,
        touchStrategyChanged: c
    };
}


var $73991e0e121001da$export$1435e6a4c843d234 = class n {
    async getOrCreateDesktopHandler() {
        if (!this.desktopHandler) {
            let { DesktopHandler: e } = await (parcelRequire("2GQEm"));
            this.desktopHandler = new e(this.handlerDependencies), this.devLog("DesktopHandler lazy loaded");
        }
        return this.desktopHandler;
    }
    async getOrCreateTouchHandler() {
        if (!this.touchDeviceHandler) {
            let { TouchDeviceHandler: e } = await (parcelRequire("4mSfC"));
            this.touchDeviceHandler = new e(this.handlerDependencies), this.devLog("TouchDeviceHandler lazy loaded");
        }
        return this.touchDeviceHandler;
    }
    static initialize(e) {
        return this.isInitiated || (n.manager = new n(e)), n.manager;
    }
    static get isInitiated() {
        return !!n.manager;
    }
    static get instance() {
        return this.initialize();
    }
    generateId() {
        return `foresight-${++this.idCounter}`;
    }
    get isUsingDesktopHandler() {
        return this.currentDeviceStrategy === "mouse" || this.currentDeviceStrategy === "pen";
    }
    addEventListener(e, t, i) {
        this.eventEmitter.addEventListener(e, t, i);
    }
    removeEventListener(e, t) {
        this.eventEmitter.removeEventListener(e, t);
    }
    hasListeners(e) {
        return this.eventEmitter.hasListeners(e);
    }
    get getManagerData() {
        let e = this.desktopHandler?.loadedPredictors, t = this.touchDeviceHandler?.loadedPredictors;
        return {
            registeredElements: this.elements,
            globalSettings: this._globalSettings,
            globalCallbackHits: this._globalCallbackHits,
            eventListeners: this.eventEmitter.getEventListeners(),
            currentDeviceStrategy: this.currentDeviceStrategy,
            activeElementCount: this.activeElementCount,
            loadedModules: {
                desktopHandler: this.desktopHandler !== null,
                touchHandler: this.touchDeviceHandler !== null,
                predictors: {
                    mouse: e?.mouse ?? !1,
                    tab: e?.tab ?? !1,
                    scroll: e?.scroll ?? !1,
                    viewport: t?.viewport ?? !1,
                    touchStart: t?.touchStart ?? !1
                }
            }
        };
    }
    get registeredElements() {
        return this.elements;
    }
    register(e) {
        let { element: t, ...i } = e;
        return t instanceof NodeList ? Array.from(t, (r)=>this.registerElement({
                ...i,
                element: r
            })) : this.registerElement({
            ...i,
            element: t
        });
    }
    registerElement(e) {
        let { isTouchDevice: t, isLimitedConnection: i, shouldRegister: r } = $73991e0e121001da$var$k();
        if (!r) return {
            isLimitedConnection: i,
            isTouchDevice: t,
            isRegistered: !1,
            unregister: ()=>{},
            elementData: null
        };
        let o = this.elements.get(e.element);
        if (o) return o.registerCount++, {
            isLimitedConnection: i,
            isTouchDevice: t,
            isRegistered: !1,
            unregister: ()=>{},
            elementData: null
        };
        this.isSetup || this.initializeGlobalListeners();
        let s = $73991e0e121001da$var$R(e, this.generateId(), this._globalSettings.defaultHitSlop);
        return this.elements.set(e.element, s), this.activeElementCount++, this.updateCheckableStatus(s), this.currentlyActiveHandler?.observeElement(e.element), this.eventEmitter.emit({
            type: "elementRegistered",
            timestamp: Date.now(),
            elementData: s
        }), {
            isTouchDevice: t,
            isLimitedConnection: i,
            isRegistered: !0,
            unregister: ()=>{
                this.unregister(e.element);
            },
            elementData: s
        };
    }
    unregister(e, t) {
        e instanceof NodeList ? e.forEach((i)=>this.unregisterElement(i, t)) : this.unregisterElement(e, t);
    }
    unregisterElement(e, t) {
        let i = this.elements.get(e);
        if (!i) return;
        this.clearReactivateTimeout(i), this.currentlyActiveHandler?.unobserveElement(e), this.elements.delete(e), this.checkableElements.delete(i), i.callbackInfo.isCallbackActive && this.activeElementCount--;
        let r = this.elements.size === 0 && this.isSetup;
        r && (this.devLog("All elements unregistered, removing global listeners"), this.removeGlobalListeners()), this.eventEmitter.emit({
            type: "elementUnregistered",
            elementData: i,
            timestamp: Date.now(),
            unregisterReason: t ?? "by user",
            wasLastRegisteredElement: r
        });
    }
    reactivate(e) {
        e instanceof NodeList ? e.forEach((t)=>this.reactivateElement(t)) : this.reactivateElement(e);
    }
    reactivateElement(e) {
        let t = this.elements.get(e);
        t && (this.isSetup || this.initializeGlobalListeners(), this.clearReactivateTimeout(t), t.callbackInfo.isRunningCallback || (t.callbackInfo.isCallbackActive = !0, this.activeElementCount++, this.updateCheckableStatus(t), this.currentlyActiveHandler?.observeElement(e), this.eventEmitter.emit({
            type: "elementReactivated",
            elementData: t,
            timestamp: Date.now()
        })));
    }
    clearReactivateTimeout(e) {
        clearTimeout(e.callbackInfo.reactivateTimeoutId), e.callbackInfo.reactivateTimeoutId = void 0;
    }
    updateCheckableStatus(e) {
        e.isIntersectingWithViewport && e.callbackInfo.isCallbackActive && !e.callbackInfo.isRunningCallback ? this.checkableElements.add(e) : this.checkableElements.delete(e);
    }
    callCallback(e, t) {
        e.callbackInfo.isRunningCallback || !e.callbackInfo.isCallbackActive || (this.markElementAsRunning(e), this.executeCallbackAsync(e, t));
    }
    markElementAsRunning(e) {
        e.callbackInfo.callbackFiredCount++, e.callbackInfo.lastCallbackInvokedAt = Date.now(), e.callbackInfo.isRunningCallback = !0, this.clearReactivateTimeout(e), this.checkableElements.delete(e);
    }
    async executeCallbackAsync(e, t) {
        this.updateHitCounters(t), this.eventEmitter.emit({
            type: "callbackInvoked",
            timestamp: Date.now(),
            elementData: e,
            hitType: t
        });
        let i = performance.now(), r, o = null;
        try {
            await e.callback(e), r = "success";
        } catch (s) {
            o = s instanceof Error ? s.message : String(s), r = "error", console.error(`Error in callback for element ${e.name}:`, s);
        }
        this.finalizeCallback(e, t, i, r, o);
    }
    finalizeCallback(e, t, i, r, o) {
        e.callbackInfo.lastCallbackCompletedAt = Date.now(), e.callbackInfo.isRunningCallback = !1, e.callbackInfo.isCallbackActive = !1, this.activeElementCount--, this.currentlyActiveHandler?.unobserveElement(e.element), e.callbackInfo.reactivateAfter !== 1 / 0 && (e.callbackInfo.reactivateTimeoutId = setTimeout(()=>{
            this.reactivate(e.element);
        }, e.callbackInfo.reactivateAfter));
        let s = this.activeElementCount === 0;
        s && (this.devLog("All elements unactivated, removing global listeners"), this.removeGlobalListeners()), this.eventEmitter.emit({
            type: "callbackCompleted",
            timestamp: Date.now(),
            elementData: e,
            hitType: t,
            elapsed: e.callbackInfo.lastCallbackRuntime = performance.now() - i,
            status: e.callbackInfo.lastCallbackStatus = r,
            errorMessage: e.callbackInfo.lastCallbackErrorMessage = o,
            wasLastActiveElement: s
        });
    }
    updateHitCounters(e) {
        switch(e.kind){
            case "mouse":
                this._globalCallbackHits.mouse[e.subType]++;
                break;
            case "tab":
                this._globalCallbackHits.tab[e.subType]++;
                break;
            case "scroll":
                this._globalCallbackHits.scroll[e.subType]++;
                break;
            case "touch":
                this._globalCallbackHits.touch++;
                break;
            case "viewport":
                this._globalCallbackHits.viewport++;
                break;
            default:
        }
        this._globalCallbackHits.total++;
    }
    async setDeviceStrategy(e) {
        let t = this.currentDeviceStrategy;
        t !== e && this.devLog(`Switching device strategy from ${t} to ${e}`), this.currentlyActiveHandler?.disconnect(), this.currentlyActiveHandler = e === "mouse" || e === "pen" ? await this.getOrCreateDesktopHandler() : await this.getOrCreateTouchHandler(), this.currentlyActiveHandler.connect();
    }
    initializeGlobalListeners() {
        this.isSetup || typeof document > "u" || (this.devLog("Initializing global listeners (pointermove, MutationObserver)"), this.setDeviceStrategy(this.currentDeviceStrategy), document.addEventListener("pointermove", this.handlePointerMove), this.domObserver = new MutationObserver(this.handleDomMutations), this.domObserver.observe(document.documentElement, {
            childList: !0,
            subtree: !0,
            attributes: !1
        }), this.isSetup = !0);
    }
    removeGlobalListeners() {
        typeof document > "u" || (this.isSetup = !1, this.domObserver?.disconnect(), this.domObserver = null, document.removeEventListener("pointermove", this.handlePointerMove), this.currentlyActiveHandler?.disconnect(), this.rafId && (cancelAnimationFrame(this.rafId), this.rafId = null), this.pendingPointerEvent = null);
    }
    alterGlobalSettings(e) {
        let t = $73991e0e121001da$var$D(this._globalSettings, e);
        t.positionHistorySizeChanged && this.desktopHandler && this.desktopHandler.trajectoryPositions.positions.resize(this._globalSettings.positionHistorySize), t.scrollPredictionChanged && this.isUsingDesktopHandler && this.desktopHandler && (this._globalSettings.enableScrollPrediction ? this.desktopHandler.connectScrollPredictor() : this.desktopHandler.disconnectScrollPredictor()), t.tabPredictionChanged && this.isUsingDesktopHandler && this.desktopHandler && (this._globalSettings.enableTabPrediction ? this.desktopHandler.connectTabPredictor() : this.desktopHandler.disconnectTabPredictor()), t.hitSlopChanged && this.forceUpdateAllElementBounds(), t.touchStrategyChanged && !this.isUsingDesktopHandler && this.touchDeviceHandler && this.touchDeviceHandler.setTouchPredictor(), t.changedSettings.length > 0 && this.eventEmitter.emit({
            type: "managerSettingsChanged",
            timestamp: Date.now(),
            managerData: this.getManagerData,
            updatedSettings: t.changedSettings
        });
    }
    forceUpdateAllElementBounds() {
        for (let e of this.elements.values())e.isIntersectingWithViewport && this.forceUpdateElementBounds(e);
    }
    forceUpdateElementBounds(e) {
        let t = e.element.getBoundingClientRect(), i = (0, $akD6a.c)(t, e.elementBounds.hitSlop);
        if (!(0, $akD6a.d)(i, e.elementBounds.expandedRect)) {
            let r = {
                ...e,
                elementBounds: {
                    ...e.elementBounds,
                    originalRect: t,
                    expandedRect: i
                }
            };
            this.elements.set(e.element, r), this.eventEmitter.emit({
                type: "elementDataUpdated",
                elementData: r,
                updatedProps: [
                    "bounds"
                ]
            });
        }
    }
    devLog(e) {
        this._globalSettings.enableManagerLogging && console.log(`%c\u{1F6E0}\uFE0F ForesightManager: ${e}`, "color: #16a34a; font-weight: bold;");
    }
    constructor(e){
        this.elements = new Map;
        this.checkableElements = new Set;
        this.idCounter = 0;
        this.activeElementCount = 0;
        this.desktopHandler = null;
        this.touchDeviceHandler = null;
        this.currentlyActiveHandler = null;
        this.isSetup = !1;
        this.pendingPointerEvent = null;
        this.rafId = null;
        this.domObserver = null;
        this.currentDeviceStrategy = $73991e0e121001da$var$E() ? "touch" : "mouse";
        this.eventEmitter = new $73991e0e121001da$var$f;
        this._globalCallbackHits = $73991e0e121001da$var$T();
        this._globalSettings = $73991e0e121001da$var$H();
        this.handlePointerMove = (e)=>{
            this.pendingPointerEvent = e, e.pointerType !== this.currentDeviceStrategy && (this.eventEmitter.emit({
                type: "deviceStrategyChanged",
                timestamp: Date.now(),
                newStrategy: e.pointerType,
                oldStrategy: this.currentDeviceStrategy
            }), this.currentDeviceStrategy = e.pointerType, this.setDeviceStrategy(this.currentDeviceStrategy)), !this.rafId && (this.rafId = requestAnimationFrame(()=>{
                if (!this.isUsingDesktopHandler) {
                    this.rafId = null;
                    return;
                }
                this.pendingPointerEvent && this.desktopHandler?.processMouseMovement(this.pendingPointerEvent), this.rafId = null;
            }));
        };
        this.handleDomMutations = (e)=>{
            if (!e.length) return;
            this.desktopHandler?.invalidateTabCache();
            let t = !1;
            for(let i = 0; i < e.length; i++){
                let r = e[i];
                if (r && r.type === "childList" && r.removedNodes.length > 0) {
                    t = !0;
                    break;
                }
            }
            if (t) for (let i of this.elements.keys())i.isConnected || this.unregister(i, "disconnected");
        };
        e !== void 0 && $73991e0e121001da$var$M(this._globalSettings, e), this.handlerDependencies = {
            elements: this.elements,
            callCallback: this.callCallback.bind(this),
            emit: this.eventEmitter.emit.bind(this.eventEmitter),
            hasListeners: this.eventEmitter.hasListeners.bind(this.eventEmitter),
            settings: this._globalSettings
        }, this.devLog(`ForesightManager initialized with device strategy: ${this.currentDeviceStrategy}`), this.initializeGlobalListeners();
    }
};
module.exports["ForesightManager"] = $73991e0e121001da$export$1435e6a4c843d234;

});

parcelRegister("akD6a", function(module, exports) {
function $785a19cc58757094$export$407448d2b89b1813(t, o, e, r) {
    return t < o ? console.warn(`ForesightJS: "${r}" value ${t} is below minimum bound ${o}, clamping to ${o}`) : t > e && console.warn(`ForesightJS: "${r}" value ${t} is above maximum bound ${e}, clamping to ${e}`), Math.min(Math.max(t, o), e);
}
function $785a19cc58757094$export$8b22cf2602fb60ce(t) {
    if (typeof t == "number") {
        let o = $785a19cc58757094$export$407448d2b89b1813(t, 0, 2e3, "hitslop");
        return {
            top: o,
            left: o,
            right: o,
            bottom: o
        };
    }
    return {
        top: $785a19cc58757094$export$407448d2b89b1813(t.top, 0, 2e3, "hitslop - top"),
        left: $785a19cc58757094$export$407448d2b89b1813(t.left, 0, 2e3, "hitslop - left"),
        right: $785a19cc58757094$export$407448d2b89b1813(t.right, 0, 2e3, "hitslop - right"),
        bottom: $785a19cc58757094$export$407448d2b89b1813(t.bottom, 0, 2e3, "hitslop - bottom")
    };
}
function $785a19cc58757094$export$db3b6bfb95261072(t, o) {
    return {
        left: t.left - o.left,
        right: t.right + o.right,
        top: t.top - o.top,
        bottom: t.bottom + o.bottom
    };
}
function $785a19cc58757094$export$4368d992c4eafac0(t, o) {
    return !t || !o ? t === o : t.left === o.left && t.right === o.right && t.top === o.top && t.bottom === o.bottom;
}
function $785a19cc58757094$export$f1e1789686576879(t, o) {
    return t.x >= o.left && t.x <= o.right && t.y >= o.top && t.y <= o.bottom;
}
module.exports["a"] = $785a19cc58757094$export$407448d2b89b1813;
module.exports["b"] = $785a19cc58757094$export$8b22cf2602fb60ce;
module.exports["c"] = $785a19cc58757094$export$db3b6bfb95261072;
module.exports["d"] = $785a19cc58757094$export$4368d992c4eafac0;
module.exports["e"] = $785a19cc58757094$export$f1e1789686576879;

});

parcelRegister("2GQEm", function(module, exports) {

let $1f58583a48d142e6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1f58583a48d142e6$var$load("1gINj").then(()=>parcelRequire('11JE0'));

});

parcelRegister("4mSfC", function(module, exports) {

let $32e34c97c7dd1cf5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $32e34c97c7dd1cf5$var$load("1GVLI").then(()=>parcelRequire('5CVfh'));

});

parcelRegister("1Gu3g", function(module, exports) {
/**
 * Editor Preload Manager
 *
 * A static cache for preloaded contentId's designed to prevent
 * the duplication of preload triggers on any one page during
 * a user's session
 */ class $4fc0e3bf51597bc1$export$369fde9923d909f1 {
    /**
   * Should Preload
   *
   * A mutative lookup to the cache that'll insert the contentId provided
   * if it's not already present. Returns true if the cache did not already
   * contain the provided contentId.
   */ static shouldPreload(contentId) {
        if (this.cache.has(contentId)) return false;
        this.cache.add(contentId);
        return true;
    }
    /**
   * Remove Preloaded ID
   *
   * Removes a contentId from the cache, allowing it to be re-preloaded
   */ static removePreloadedId(contentId) {
        this.cache.delete(contentId);
        this.intentCache.delete(contentId);
    }
    /**
   * Clear
   *
   * Removes all cached contentId's from the cache
   */ static clear() {
        this.cache.clear();
        this.intentCache.clear();
    }
}
$4fc0e3bf51597bc1$export$369fde9923d909f1.cache = new Set();
$4fc0e3bf51597bc1$export$369fde9923d909f1.intentCache = new Set();
module.exports["EditorPreloadManager"] = $4fc0e3bf51597bc1$export$369fde9923d909f1;

});

parcelRegister("58PBI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $037500d910957a1c$var$noop = ()=>null;
const $037500d910957a1c$export$2dc50c54ef05578f = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext($037500d910957a1c$var$noop);
$037500d910957a1c$export$2dc50c54ef05578f.displayName = 'EditContentButtonPreloaderContext';
module.exports["EditContentButtonPreloaderContext"] = $037500d910957a1c$export$2dc50c54ef05578f;

});

parcelRegister("3TgYS", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $fjHkB = parcelRequire("fjHkB");

var $8s9DV = parcelRequire("8s9DV");

var $e8033b5fc56f919b$export$1e5f9e0e1f5f771c = /*#__PURE__*/ function(LocalActivityAction) {
    LocalActivityAction["deleted"] = "deleted";
    LocalActivityAction["viewed"] = "viewed";
    return LocalActivityAction;
}({});
const $e8033b5fc56f919b$export$c008b11c6b6e84c9 = (0, $8s9DV.createStore)({
    name: 'localActivityStore',
    initialState: {
        localActivity: []
    },
    actions: {
        setLocalActivity: (localActivity)=>({ setState: setState })=>{
                setState({
                    localActivity: [
                        ...localActivity
                    ]
                });
            },
        getLocalActivity: ()=>({ getState: getState })=>{
                return getState().localActivity;
            }
    }
});
const $e8033b5fc56f919b$var$localActivitySelector = (0, $fjHkB.createSelector)((state)=>state.localActivity, (localActivity)=>localActivity);
const $e8033b5fc56f919b$export$f16e1a8a1b5f5fcc = (0, $kBr4q.createStateHook)($e8033b5fc56f919b$export$c008b11c6b6e84c9, {
    selector: $e8033b5fc56f919b$var$localActivitySelector
});
const $e8033b5fc56f919b$export$b62470c19b810f2b = (0, $kBr4q.createActionsHook)($e8033b5fc56f919b$export$c008b11c6b6e84c9);
module.exports["LocalActivityAction"] = $e8033b5fc56f919b$export$1e5f9e0e1f5f771c;
module.exports["useLocalActivityCache"] = $e8033b5fc56f919b$export$f16e1a8a1b5f5fcc;
module.exports["useLocalActivityCacheStoreActions"] = $e8033b5fc56f919b$export$b62470c19b810f2b;

});

parcelRegister("jYPbB", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3TgYS = parcelRequire("3TgYS");


var $fdNea = parcelRequire("fdNea");

const $62bd2c9093526b74$export$c4f820168ec5144 = ()=>{
    const { getLocalActivity: getLocalActivity, setLocalActivity: setLocalActivity } = (0, $3TgYS.useLocalActivityCacheStoreActions)();
    const track = (0, $cozmU.useCallback)((contentId, action)=>{
        (0, $fdNea.trackLocalActivity)({
            contentId: contentId,
            action: action
        }, setLocalActivity, getLocalActivity);
    }, [
        setLocalActivity,
        getLocalActivity
    ]);
    return {
        track: track
    };
};
module.exports["useLocalActivityTracker"] = $62bd2c9093526b74$export$c4f820168ec5144;

});

parcelRegister("fdNea", function(module, exports) {

var $de4za = parcelRequire("de4za");


var $cozmU = parcelRequire("cozmU");


var $3TgYS = parcelRequire("3TgYS");


var $fFmJj = parcelRequire("fFmJj");

const $5be82f78ca966df2$var$useLocalActivityContentFragment = (0, $de4za.default);
const $5be82f78ca966df2$var$MAX_EVENTS = 100;
const $5be82f78ca966df2$var$contentIdsToBeEvicted = new Set();
const $5be82f78ca966df2$var$isMarkedForEviction = (event)=>$5be82f78ca966df2$var$contentIdsToBeEvicted.has(event.content.id || '');
const $5be82f78ca966df2$export$1b153e31f71ec597 = ({ filters: filters } = {})=>{
    const readLocalActivityContentFragment = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: $5be82f78ca966df2$var$useLocalActivityContentFragment,
        __callerPackage__: "local-activity"
    });
    const dehydratedLocalActivities = (0, $3TgYS.useLocalActivityCache)();
    const localActivities = [];
    for (const event of dehydratedLocalActivities){
        const hydratedEvent = {
            ...event
        };
        try {
            if (event?.content?.id) {
                const contentFragment = readLocalActivityContentFragment({
                    id: `Content:${event.content.id}`
                });
                if (contentFragment) hydratedEvent.content = {
                    ...hydratedEvent.content,
                    ...contentFragment
                };
            }
        } catch  {
        // If the fragment does not exist, don't do anything this event will get filtered out
        }
        localActivities.push(hydratedEvent);
    }
    /**
   * Events which are marked as consistent for all backend APIs can safely be evicted.
   * At the time of writing, there is only 1 supported backend API (Activity Platform),
   * so we can immediately mark the event for eviction.
   *
   * This eviction is "lazy", meaning that the event is *marked* as evicted & filtered from the
   * result set, but not actually removed from memory until `trackLocalActivity` is called.
   */ const markAsConsistent = (0, $cozmU.useCallback)((contentId)=>{
        $5be82f78ca966df2$var$contentIdsToBeEvicted.add(contentId);
    }, []);
    const result = {
        viewedEvents: [],
        deletedContentIds: new Set(),
        markAsConsistent: markAsConsistent
    };
    localActivities.forEach((event)=>{
        if (!$5be82f78ca966df2$var$shouldIncludeEvent(event, filters)) return;
        if (event.action === (0, $3TgYS.LocalActivityAction).viewed) result.viewedEvents.push(event);
        else if (event.action === (0, $3TgYS.LocalActivityAction).deleted) result.deletedContentIds.add(event.content.id || '');
    });
    return result;
};
const $5be82f78ca966df2$var$shouldIncludeEvent = (event, filters)=>{
    // Filter events which will be evicted
    if ($5be82f78ca966df2$var$isMarkedForEviction(event)) return false;
    if (!filters) return true;
    return filters.spaceKey === ('space' in event.content ? event.content.space?.key : undefined);
};
const $5be82f78ca966df2$export$3fa173aba6d1fb4b = ({ contentId: contentId, action: action }, setLocalActivity, getLocalActivity)=>{
    /**
   * The Content is dehydrated (i.e. only Content.id is present, not full Content)
   * because we may not know all Content data at track time.
   * The full Content will be hydrated from cache automatically when querying in useLocalActivity
   */ let dehydratedEvents = [];
    try {
        dehydratedEvents = getLocalActivity()?.filter((e)=>!$5be82f78ca966df2$var$isMarkedForEviction(e)).slice(0, $5be82f78ca966df2$var$MAX_EVENTS - 1) || [];
    } catch  {}
    $5be82f78ca966df2$var$contentIdsToBeEvicted.clear();
    const data = {
        localActivity: [
            {
                id: `${contentId}-${action}`,
                action: action,
                timestamp: new Date().toISOString(),
                content: {
                    id: contentId,
                    __typename: 'Content'
                },
                __typename: 'LocalActivityEvent'
            },
            ...dehydratedEvents
        ]
    };
    setLocalActivity(data.localActivity);
};
module.exports["useLocalActivity"] = $5be82f78ca966df2$export$1b153e31f71ec597;
module.exports["trackLocalActivity"] = $5be82f78ca966df2$export$3fa173aba6d1fb4b;

});

parcelRegister("de4za", function(module, exports) {
/**
 * @generated SignedSource<<b2f9f951eae1eb199798be4df9dd7524>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2b7736c1a4cd6fb8$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "key"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "useLocalActivityContentFragment",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "title"
            },
            {
                "kind": "ScalarField",
                "name": "hasRestrictions"
            },
            {
                "kind": "ScalarField",
                "name": "hasInheritedRestrictions"
            },
            {
                "concreteType": "Space",
                "kind": "LinkedField",
                "name": "space",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    v1 /*: any*/ 
                ]
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "keys",
                        "value": [
                            "emoji-title-published",
                            "emoji-title-draft"
                        ]
                    }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JsonContentProperty",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "value"
                            },
                            v1 /*: any*/ ,
                            {
                                "concreteType": "Version",
                                "kind": "LinkedField",
                                "name": "version",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "number"
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\"])"
            }
        ],
        "type": "Content"
    };
}();
$2b7736c1a4cd6fb8$var$node.hash = "e057d047fb173be62229acfca15ccbce";
var $2b7736c1a4cd6fb8$export$2e2bcd8739ae039 = $2b7736c1a4cd6fb8$var$node;
module.exports["default"] = $2b7736c1a4cd6fb8$export$2e2bcd8739ae039;

});

parcelRegister("7NoF3", function(module, exports) {
const $e900dacf455c7c27$export$45d9f22b250b4fa6 = 'PAGE_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$daadd9484abf9243 = 'BLOG_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$18ec89b444ed9e13 = 'SPACE_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$1670e1f700b91982 = 'PAGE_EDIT_SHORTCUT_E';
const $e900dacf455c7c27$export$99c4be058cda9518 = 'BLOG_EDIT_SHORTCUT_E';
const $e900dacf455c7c27$export$9a65fbf92be78751 = 'SPACE_EDIT_SHORTCUT_E';
const $e900dacf455c7c27$export$a5c6eb91dd72e7c0 = 'NAVIGATION_RECENT_DROPDOWN_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$835a97ed77363e2a = 'PAGECARD_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$d8133449fbfd82d4 = 'PAGECARD_DRAFT_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$aca8dbff71ee152b = 'QUICK_ACTIONS_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$3a91fd27464e4cde = 'EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$62ca21e37a92c063 = 'CREATE_PAGE_SHORTCUT';
const $e900dacf455c7c27$export$6eda3121bad7aadf = 'CREATE_NAV_BUTTON_CLICK';
const $e900dacf455c7c27$export$7698b0f9c7cef133 = 'CREATE_PAGETREE_BLOG_BUTTON_CLICK';
const $e900dacf455c7c27$export$d83b4b43e279cde5 = 'CREATE_PAGETREE_CHILDPAGE_BUTTON_CLICK';
const $e900dacf455c7c27$export$1dd5c358458f3c8f = 'CREATE_PAGETREE_PAGE_BUTTON_CLICK';
const $e900dacf455c7c27$export$6e88709afea7d3ed = [
    $e900dacf455c7c27$export$aca8dbff71ee152b,
    $e900dacf455c7c27$export$835a97ed77363e2a,
    $e900dacf455c7c27$export$d8133449fbfd82d4,
    $e900dacf455c7c27$export$a5c6eb91dd72e7c0
];
module.exports["PAGE_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$45d9f22b250b4fa6;
module.exports["BLOG_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$daadd9484abf9243;
module.exports["SPACE_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$18ec89b444ed9e13;
module.exports["PAGE_EDIT_SHORTCUT_E"] = $e900dacf455c7c27$export$1670e1f700b91982;
module.exports["BLOG_EDIT_SHORTCUT_E"] = $e900dacf455c7c27$export$99c4be058cda9518;
module.exports["SPACE_EDIT_SHORTCUT_E"] = $e900dacf455c7c27$export$9a65fbf92be78751;
module.exports["PAGECARD_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$835a97ed77363e2a;
module.exports["QUICK_ACTIONS_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$aca8dbff71ee152b;
module.exports["CREATE_PAGE_SHORTCUT"] = $e900dacf455c7c27$export$62ca21e37a92c063;
module.exports["CREATE_NAV_BUTTON_CLICK"] = $e900dacf455c7c27$export$6eda3121bad7aadf;
module.exports["CREATE_PAGETREE_BLOG_BUTTON_CLICK"] = $e900dacf455c7c27$export$7698b0f9c7cef133;
module.exports["InitialLoadEditSources"] = $e900dacf455c7c27$export$6e88709afea7d3ed;

});

parcelRegister("2cKGu", function(module, exports) {

var $1ggpj = parcelRequire("1ggpj");

const $c721ee7829bb57f5$export$f2c6bba4d41ef211 = (contentType, contentMode)=>{
    // Starring currently doesn't support unpublished drafts (which could be of contentType page or blogpost)
    if (contentMode === 'draft') return false;
    return contentType === 'page' || contentType === 'blogpost' || (0, $1ggpj.isCanvasContentType)(contentType) || contentType === 'database' || contentType === 'embed' || contentType === 'folder';
};
module.exports["useIsStarringEnabled"] = $c721ee7829bb57f5$export$f2c6bba4d41ef211;

});

parcelRegister("fZLJ8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3BmH5 = parcelRequire("3BmH5");


var $i1PdO = parcelRequire("i1PdO");


var $aboIx = parcelRequire("aboIx");

const $050967cdd11104af$var$MANAGED_FOLDER_SUBTYPE = 'managed';
const $050967cdd11104af$var$isManagedFolderAncestor = (ancestor)=>ancestor?.type?.toLowerCase() === 'folder' && ancestor?.subType?.toLowerCase() === $050967cdd11104af$var$MANAGED_FOLDER_SUBTYPE;
const $050967cdd11104af$var$getCreatedByDisplayName = (ancestor)=>{
    const displayName = ancestor?.['history']?.createdBy?.displayName?.trim();
    return displayName || null;
};
const $050967cdd11104af$export$b792028224cde203 = (ancestors)=>{
    const managedDevDocsAncestor = ancestors?.find((ancestor)=>{
        if (!$050967cdd11104af$var$isManagedFolderAncestor(ancestor)) return false;
        if (!(0, $aboIx.isDevDocsOwnedFolder)({
            propertyCollections: [
                ancestor?.properties?.nodes
            ]
        })) return false;
        return Boolean((0, $3BmH5.getDevDocsFolderMetadata)(ancestor?.properties?.nodes).devDocsProperties?.repoName);
    });
    const folderMetadata = (0, $3BmH5.getDevDocsFolderMetadata)(managedDevDocsAncestor?.properties?.nodes);
    const repoName = folderMetadata.devDocsProperties?.repoName;
    const folderId = managedDevDocsAncestor?.id;
    if (!repoName || !folderId) return null;
    return {
        folderId: folderId,
        folderWebui: managedDevDocsAncestor?.links?.webui ?? null,
        repoName: repoName,
        provider: folderMetadata.containerApp,
        owner: $050967cdd11104af$var$getCreatedByDisplayName(managedDevDocsAncestor),
        lastSynced: folderMetadata.smartFolderProperties?.lastSynced ?? null
    };
};
const $050967cdd11104af$export$1e19ef9187efb6c7 = (ancestors)=>{
    const ancestorPropertyCollections = (0, $cozmU.useMemo)(()=>ancestors?.map((ancestor)=>ancestor?.properties?.nodes) ?? [], [
        ancestors
    ]);
    const { isDevDocsEligible: isDevDocsEligible } = (0, $i1PdO.useDevDocsFolderEligibility)({
        propertyCollections: ancestorPropertyCollections
    });
    return (0, $cozmU.useMemo)(()=>{
        if (!isDevDocsEligible) return null;
        return $050967cdd11104af$export$b792028224cde203(ancestors);
    }, [
        ancestors,
        isDevDocsEligible
    ]);
};
module.exports["getDevDocsConnectionFromAncestors"] = $050967cdd11104af$export$b792028224cde203;
module.exports["useDevDocsBylineConnection"] = $050967cdd11104af$export$1e19ef9187efb6c7;

});

parcelRegister("aYZaZ", function(module, exports) {
$parcel$export(module.exports, "Buttons", () => (parcelRequire("iQb1R")).Buttons);

var $jmjWc = parcelRequire("jmjWc");


var $6tSjb = parcelRequire("6tSjb");


var $iQb1R = parcelRequire("iQb1R");


const $ecc7cc41466863e8$export$82d507aca0e648e3 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ZRz6B",
    name: "EllipsisDropdownComponent",
    loader: async ()=>(await (parcelRequire("bqncX"))).EllipsisDropdownComponent,
    loading: (0, $6tSjb.EllipsisPlaceholder)
});
module.exports["EllipsisDropdownComponent"] = $ecc7cc41466863e8$export$82d507aca0e648e3;

});

parcelRegister("6tSjb", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $5SGpQ = parcelRequire("5SGpQ");


var $6TaGl = parcelRequire("6TaGl");

const $565f8db62106cdff$var$i18n = (0, $kSwu1.defineMessages)({
    more: {
        id: "editor-ellipsis-dropdown.placeholder.ellipsis.more",
        defaultMessage: "More"
    }
});
const $565f8db62106cdff$export$2edf2f3658d4e349 = ()=>{
    const intl = (0, $kSwu1.useIntl)();
    const label = intl.formatMessage($565f8db62106cdff$var$i18n.more);
    const moreIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
        color: "currentColor",
        spacing: "spacious",
        label: label
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5SGpQ.default), {
        testId: "ellipsis-placeholder",
        isDisabled: true,
        iconBefore: moreIcon,
        appearance: "subtle"
    });
};
module.exports["EllipsisPlaceholder"] = $565f8db62106cdff$export$2edf2f3658d4e349;

});

parcelRegister("bqncX", function(module, exports) {

let $8514200b8759cfa9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $8514200b8759cfa9$var$load("6WNyl"),
    $8514200b8759cfa9$var$load("fky9A"),
    $8514200b8759cfa9$var$load("87mhv"),
    $8514200b8759cfa9$var$load("iY5MP")
]).then(()=>parcelRequire('3d2EW'));

});

parcelRegister("iQb1R", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ var $f15550a75cff81e6$export$665d5a662b7213f3 = /*#__PURE__*/ function(Buttons) {
    Buttons["DELETE_DRAFT"] = "delete-draft";
    Buttons["EDIT_LABELS"] = "edit-labels";
    Buttons["MOVE_PAGE"] = "move-page";
    Buttons["PREVIEW"] = "preview";
    Buttons["PUBLISH_WITHOUT_NOTIFY"] = "publish-without-notify";
    Buttons["RESOLVED_COMMENTS"] = "resolved-comments";
    Buttons["TEMPLATE_BROWSER"] = "template-browser";
    Buttons["VIEW_CHANGES"] = "view-changes";
    Buttons["EXPORT"] = "export";
    Buttons["ADVANCED"] = "advanced";
    Buttons["ARCHIVE"] = "archive";
    Buttons["ATTACHMENTS"] = "attachments";
    Buttons["SWITCH_TO_LIVE_EDIT"] = "switch-to-live-edit";
    Buttons["CLASSIFY_CONTENT"] = "classify-content";
    Buttons["MANAGE"] = "manage";
    Buttons["PRESENT"] = "presentation-mode";
    return Buttons;
}({});
module.exports["Buttons"] = $f15550a75cff81e6$export$665d5a662b7213f3;

});

parcelRegister("dfgVG", function(module, exports) {

var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $d6588355bb2f168c$export$37ee5f1519219257 = (contentId)=>{
    return (0, $17wUi.confluenceSessionStorageInstance)?.getItem((0, $1UApO.keys).EDITOR_REVERTED) === contentId;
};
const $d6588355bb2f168c$export$1c5c21f47c0c866b = (contentId)=>{
    (0, $17wUi.confluenceSessionStorageInstance)?.setItem((0, $1UApO.keys).EDITOR_REVERTED, contentId);
};
const $d6588355bb2f168c$export$75835fd24886e23f = ()=>{
    (0, $17wUi.confluenceSessionStorageInstance)?.removeItem((0, $1UApO.keys).EDITOR_REVERTED);
};
module.exports["checkRevertFlag"] = $d6588355bb2f168c$export$37ee5f1519219257;
module.exports["addRevertFlag"] = $d6588355bb2f168c$export$1c5c21f47c0c866b;
module.exports["removeRevertFlag"] = $d6588355bb2f168c$export$75835fd24886e23f;

});

parcelRegister("l3C2L", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $ff94b9918380dc5d$export$cc6c027a319af205 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "9P0ef",
    name: "ViewChangesDialogLoader",
    loader: async ()=>(await (parcelRequire("7ZA6D"))).ViewChangesDialog
});
module.exports["ViewChangesDialogLoader"] = $ff94b9918380dc5d$export$cc6c027a319af205;

});

parcelRegister("7ZA6D", function(module, exports) {

let $5d1a3cd258c0dc56$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5d1a3cd258c0dc56$var$load("lJJQ8").then(()=>parcelRequire('iDTLl'));

});

parcelRegister("6ld6a", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $iKWdo = parcelRequire("iKWdo");


var $1wIeS = parcelRequire("1wIeS");


var $jtuBN = parcelRequire("jtuBN");


var $8wW9d = parcelRequire("8wW9d");


var $kxhju = parcelRequire("kxhju");


var $62BfR = parcelRequire("62BfR");

const $f64809aa9d8f3ca2$export$13a30d244c53e90d = (t0)=>{
    const $ = (0, $bDgLe.c)(26);
    const { location: location, contentId: t1, spaceKey: t2, version: t3, allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems, skipQuery: skipQuery, skipFetchIfCached: skipFetchIfCached } = t0;
    const contentId = t1 === undefined ? null : t1;
    const spaceKey = t2 === undefined ? null : t2;
    const version = t3 === undefined ? null : t3;
    const t4 = Array.isArray(location) ? null : location;
    let t5;
    if ($[0] !== location) {
        t5 = Array.isArray(location) ? location : [];
        $[0] = location;
        $[1] = t5;
    } else t5 = $[1];
    let t6;
    if ($[2] !== contentId || $[3] !== spaceKey || $[4] !== t4 || $[5] !== t5 || $[6] !== version) {
        t6 = {
            location: t4,
            locations: t5,
            contentId: contentId,
            spaceKey: spaceKey,
            version: version
        };
        $[2] = contentId;
        $[3] = spaceKey;
        $[4] = t4;
        $[5] = t5;
        $[6] = version;
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] !== skipFetchIfCached || $[9] !== skipQuery || $[10] !== t6) {
        t7 = {
            variables: t6,
            skip: skipQuery,
            skipFetchIfCached: skipFetchIfCached
        };
        $[8] = skipFetchIfCached;
        $[9] = skipQuery;
        $[10] = t6;
        $[11] = t7;
    } else t7 = $[11];
    const baseQueryOptions = t7;
    const { data: data, loading: loading, error: error } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $kxhju.WebItemLocationQuery), {
        ...baseQueryOptions,
        __callerPackage__: "web-item-location"
    });
    if (!data) {
        let t8;
        let t9;
        if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
            t8 = [];
            t9 = [];
            $[12] = t8;
            $[13] = t9;
        } else {
            t8 = $[12];
            t9 = $[13];
        }
        let t10;
        if ($[14] !== error || $[15] !== loading) {
            t10 = {
                loading: loading,
                error: error,
                webItems: t8,
                webSections: t9
            };
            $[14] = error;
            $[15] = loading;
            $[16] = t10;
        } else t10 = $[16];
        return t10;
    }
    let webItems;
    let webSections;
    if ($[17] !== allowedWebItems || $[18] !== data || $[19] !== notAllowedWebItems) {
        webItems = $f64809aa9d8f3ca2$var$getWebItems((0, $62BfR.replaceAtlTokenPlaceholder)(data)?.webItemSections ?? [], {
            allowedWebItems: allowedWebItems,
            notAllowedWebItems: notAllowedWebItems
        });
        webSections = (0, (/*@__PURE__*/$parcel$interopDefault($1wIeS)))(webItems.map($f64809aa9d8f3ca2$var$_temp));
        webItems.sort($f64809aa9d8f3ca2$var$sortWebItems);
        (0, $8wW9d.recordNonContentAppKeys)("web-item", webItems.map($f64809aa9d8f3ca2$var$_temp2));
        $[17] = allowedWebItems;
        $[18] = data;
        $[19] = notAllowedWebItems;
        $[20] = webItems;
        $[21] = webSections;
    } else {
        webItems = $[20];
        webSections = $[21];
    }
    let t8;
    if ($[22] !== error || $[23] !== webItems || $[24] !== webSections) {
        t8 = {
            loading: false,
            error: error,
            webItems: webItems,
            webSections: webSections
        };
        $[22] = error;
        $[23] = webItems;
        $[24] = webSections;
        $[25] = t8;
    } else t8 = $[25];
    return t8;
};
const $f64809aa9d8f3ca2$var$getWebItems = (webItemSections, webItemFilterOptions)=>{
    const webItems = webItemSections.flatMap((section)=>{
        return section.items.filter($f64809aa9d8f3ca2$var$filterWebItem(webItemFilterOptions)).map($f64809aa9d8f3ca2$var$transformWebItem(section));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($iKWdo)))(webItems, 'completeKey');
};
const $f64809aa9d8f3ca2$var$filterWebItem = ({ allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems })=>(item)=>{
        if (!item || !item.completeKey) return false;
        const isAllowed = !allowedWebItems || allowedWebItems.includes(item.completeKey);
        const isDisallowed = notAllowedWebItems?.includes(item.completeKey);
        return isAllowed && !isDisallowed;
    };
const $f64809aa9d8f3ca2$var$transformWebItem = (section)=>(rawItem)=>({
            ...rawItem,
            params: $f64809aa9d8f3ca2$var$getParamsObject(rawItem),
            webSection: $f64809aa9d8f3ca2$var$getWebSection(rawItem),
            parentSection: {
                label: section.label || section.styleClass
            }
        });
const $f64809aa9d8f3ca2$var$sortWebItems = (webItemA, webItemB)=>{
    if (!webItemA.weight || !webItemB.weight || !webItemA.label || !webItemB.label) return 0;
    if (webItemA.weight - webItemB.weight === 0) return webItemA.label.localeCompare(webItemB.label);
    else return webItemA.weight - webItemB.weight;
};
const $f64809aa9d8f3ca2$var$getWebSection = (item)=>{
    if (item.section && item.section.indexOf('/') !== -1) {
        const parts = item.section.split('/');
        return parts[1];
    }
};
const $f64809aa9d8f3ca2$var$getParamsObject = (item)=>{
    const paramObj = {};
    item.params?.forEach((param)=>{
        if (param?.key) paramObj[param.key] = param.value ?? '';
    });
    return paramObj;
};
function $f64809aa9d8f3ca2$var$_temp(webItem) {
    return webItem.section;
}
function $f64809aa9d8f3ca2$var$_temp2(webItem_0) {
    return webItem_0.completeKey;
}
module.exports["useWebItemLocation"] = $f64809aa9d8f3ca2$export$13a30d244c53e90d;

});

parcelRegister("d8oE8", function(module, exports) {
const $305fd3cd961d4815$export$bd41ea3025fc88df = (push, contentType, spaceKey, contentId, contentStatus)=>{
    if (!contentType || !contentId) return;
    const isBlogPost = contentType === 'blogpost';
    const isCreate = contentStatus === 'draft';
    if (isBlogPost && !isCreate) push(`${window.location.origin}/wiki/spaces/${spaceKey}/blog/edit/${contentId}`);
    else if (!isCreate) push(`${window.location.origin}/wiki/spaces/${spaceKey}/pages/edit/${contentId}`);
    else push(`${window.location.origin}/wiki/spaces/${spaceKey}/pages/create?draftId=${contentId}`);
};
module.exports["onClickPageRevert"] = $305fd3cd961d4815$export$bd41ea3025fc88df;

});

parcelRegister("c54hr", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $367766f6f044c46b$var$initialState = {
    isMenuOpen: false,
    isCloseMenuDisabled: false
};
const $367766f6f044c46b$var$actions = {
    setIsMenuOpen: (isMenuOpen)=>({ setState: setState })=>{
            setState({
                isMenuOpen: isMenuOpen
            });
        },
    setIsCloseMenuDisabled: (isCloseMenuDisabled)=>({ setState: setState })=>{
            setState({
                isCloseMenuDisabled: isCloseMenuDisabled
            });
        }
};
const $367766f6f044c46b$var$Store = (0, $8s9DV.createStore)({
    initialState: $367766f6f044c46b$var$initialState,
    actions: $367766f6f044c46b$var$actions,
    name: 'more-actions-menu-store'
});
const $367766f6f044c46b$export$14d00db016c2b3ef = (0, $kBr4q.createStateHook)($367766f6f044c46b$var$Store);
const $367766f6f044c46b$export$1f1f8c486fa8a1cb = (0, $kBr4q.createActionsHook)($367766f6f044c46b$var$Store);
module.exports["useMoreActionsMenuState"] = $367766f6f044c46b$export$14d00db016c2b3ef;
module.exports["useMoreActionsMenuActions"] = $367766f6f044c46b$export$1f1f8c486fa8a1cb;

});

parcelRegister("1PC5x", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $297029061926b2dd$export$77691412571457f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "8jq35",
    name: "LinkToThisPageDialog",
    loader: async ()=>(await (parcelRequire("itLch"))).LinkToThisPageDialog
});
module.exports["LinkToThisPageDialog"] = $297029061926b2dd$export$77691412571457f;

});

parcelRegister("itLch", function(module, exports) {

let $d73f8bc3a05bd793$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d73f8bc3a05bd793$var$load("iWnyc"),
    $d73f8bc3a05bd793$var$load("hhss7"),
    $d73f8bc3a05bd793$var$load("Wowvf"),
    $d73f8bc3a05bd793$var$load("dXoLf")
]).then(()=>parcelRequire('gaLJH'));

});

parcelRegister("82Ooj", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $7W8i8 = parcelRequire("7W8i8");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $3802aca2c5107012$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    livePagesEditModeFlagTitle: {
        id: "live-pages-features.live-pages.edit-mode-flag.title.livedocs",
        defaultMessage: "You\u2019re editing this live doc"
    },
    livePagesEditModeFlagDescription: {
        id: "live-pages-features.live-pages.edit-mode-flag.description",
        defaultMessage: "Tip: To switch to viewing only, use the keyboard shortcut {keyCombination}."
    },
    livePagesViewModeFlagTitle: {
        id: "live-pages-features.live-pages.view-mode-flag.title.livedocs",
        defaultMessage: "You\u2019re viewing this live doc"
    },
    livePagesViewModeFlagDescription: {
        id: "live-pages-features.live-pages.view-mode-flag.description",
        defaultMessage: "Tip: To start editing, select {keyCombination} on your keyboard."
    }
});
const $3802aca2c5107012$export$f1bb393ced142bbb = (flags)=>{
    const intl = (0, $kSwu1.useIntl)();
    const logger = (0, $7W8i8.getLogger)('editor-mainbuttons-livepage-modechanger');
    const hasLivePageModeFlagBeenShown = (mode)=>{
        try {
            const flagsShown = JSON.parse((0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).LIVE_PAGES_MODE_SWITCHING_FLAG_SHOWN) || '{}');
            return flagsShown[mode] === true;
        } catch (error) {
            logger.error`Error checking if live page mode flag has been shown for mode: "${mode}". Reason: ${error.message}`;
            return false;
        }
    };
    const setLivePageModeFlagAsShown = (mode)=>{
        try {
            const flagsShown = JSON.parse((0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).LIVE_PAGES_MODE_SWITCHING_FLAG_SHOWN) || '{}');
            flagsShown[mode] = true;
            (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).LIVE_PAGES_MODE_SWITCHING_FLAG_SHOWN, JSON.stringify(flagsShown));
        } catch (error) {
            logger.error`Error setting live page mode flag as shown for mode: "${mode}". Reason: ${error.message}`;
        }
    };
    const modeDetails = {
        view: {
            title: intl.formatMessage($3802aca2c5107012$export$a7357cdd1f0b0168.livePagesViewModeFlagTitle),
            description: intl.formatMessage($3802aca2c5107012$export$a7357cdd1f0b0168.livePagesViewModeFlagDescription, {
                keyCombination: (0, $4tOXV.getShortcutString)((0, $gnkil.LIVE_PAGE_MODE_SWITCH_TO_EDIT), intl.formatMessage)
            })
        },
        edit: {
            title: intl.formatMessage($3802aca2c5107012$export$a7357cdd1f0b0168.livePagesEditModeFlagTitle),
            description: intl.formatMessage($3802aca2c5107012$export$a7357cdd1f0b0168.livePagesEditModeFlagDescription, {
                keyCombination: (0, $4tOXV.getShortcutString)((0, $gnkil.LIVE_PAGE_MODE_SWITCH_TO_VIEW), intl.formatMessage)
            })
        }
    };
    const showLivePageModeFlag = (newMode)=>{
        const selectedModeDetails = modeDetails[newMode];
        if (selectedModeDetails) {
            if (!hasLivePageModeFlagBeenShown(newMode)) {
                const { title: title, description: description } = selectedModeDetails;
                const flagId = 'live-pages-mode-flag';
                // hide any flags that are currently showing
                flags.hideFlag(flagId);
                flags.showFlag({
                    id: flagId,
                    title: title,
                    description: description,
                    close: 'auto'
                });
                setLivePageModeFlagAsShown(newMode);
            }
        }
    };
    return {
        showLivePageModeFlag: showLivePageModeFlag
    };
};
module.exports["useLivePageModeFlag"] = $3802aca2c5107012$export$f1bb393ced142bbb;

});

parcelRegister("5KL6w", function(module, exports) {
$parcel$export(module.exports, "usePresenterModeContext", () => (parcelRequire("l1b8J")).usePresenterModeContext);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");


var $3HHS0 = parcelRequire("3HHS0");


var $l1b8J = parcelRequire("l1b8J");


const $51949aafbfeff0f9$export$d9be451d5ed0cecd = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "qz-Pe",
    name: "PresenterModeContextProvider",
    loader: async ()=>(await (parcelRequire("6LWSe"))).PresenterModeContextProvider
});

const $51949aafbfeff0f9$export$62fbe81a4ea288fa = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "P5ZKu",
    name: "LazyPresenterModeContextConsumer",
    loader: async ()=>(await (parcelRequire("6LWSe"))).PresenterModeContextConsumer,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3HHS0.PresentationModePlaceholder), null)
});
module.exports["PresenterModeContextProvider"] = $51949aafbfeff0f9$export$d9be451d5ed0cecd;
module.exports["LazyPresenterModeContextConsumer"] = $51949aafbfeff0f9$export$62fbe81a4ea288fa;

});

parcelRegister("3HHS0", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $667e8b8d9015d9ff$export$a718db6ba6835b50 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            height: '40px',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-250, 20px)"}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            alignItems: 'center',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            boxSizing: 'border-box'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            height: '17px',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            backgroundColor: "var(--ds-background-neutral, #0515240F)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            borderRadius: '10%'
        }
    }));
};
module.exports["PresentationModePlaceholder"] = $667e8b8d9015d9ff$export$a718db6ba6835b50;

});

parcelRegister("6LWSe", function(module, exports) {

let $4ee4ccf846ab21f8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $4ee4ccf846ab21f8$var$load("7A87G"),
    $4ee4ccf846ab21f8$var$load("6wr18"),
    $4ee4ccf846ab21f8$var$load("ffEVr"),
    $4ee4ccf846ab21f8$var$load("a7sEM"),
    $4ee4ccf846ab21f8$var$load("5gsbh"),
    $4ee4ccf846ab21f8$var$load("8lMr1"),
    $4ee4ccf846ab21f8$var$load("1vUE6"),
    $4ee4ccf846ab21f8$var$load("7g00Y"),
    $4ee4ccf846ab21f8$var$load("58mds")
]).then(()=>parcelRequire('5etuL'));

});

parcelRegister("l1b8J", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $fb6fb6e8473a5f8b$export$ad28f4824d7c6233 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    isPresenterModeActive: false,
    isBrowserFullscreen: false,
    hasEnteredPresentMode: false,
    presenterModeContextError: null,
    isPresenterModeEnabled: false,
    enterPresenterMode: ()=>{
    // Intentional no-op
    },
    exitPresenterMode: ()=>{
    // Intentional no-op
    },
    setPresenterModeContextError: ()=>{
    // Intentional no-op
    },
    enterBrowserFullscreen: ()=>{
    // Intentional no-op
    },
    enterSystemFullscreen: ()=>{
    // Intentional no-op
    },
    setIsBrowserFullscreen: ()=>{
    // Intentional no-op
    },
    setHasEnteredPresentMode: ()=>{
    // Intentional no-op
    }
});
const $fb6fb6e8473a5f8b$export$5b228b85ce187234 = ()=>{
    return (0, $cozmU.useContext)($fb6fb6e8473a5f8b$export$ad28f4824d7c6233);
};
module.exports["PresenterModeContext"] = $fb6fb6e8473a5f8b$export$ad28f4824d7c6233;
module.exports["usePresenterModeContext"] = $fb6fb6e8473a5f8b$export$5b228b85ce187234;

});

parcelRegister("3oWMY", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $goxV5 = parcelRequire("goxV5");


const $aac74fc16bd2f0e9$export$60620c3d63f5f30 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "tETtx",
    name: "RendererPageCoverPicture",
    loader: async ()=>{
        return (await (parcelRequire("1NNJ5"))).RendererPageCoverPicture;
    },
    loading: (0, $goxV5.RendererPageCoverPicturePlaceholder)
});
module.exports["RendererPageCoverPicture"] = $aac74fc16bd2f0e9$export$60620c3d63f5f30;

});

parcelRegister("goxV5", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $jVylI = parcelRequire("jVylI");


var $75Ax4 = parcelRequire("75Ax4");

/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-dynamic-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/use-tokens-space, @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766 */ const $be005db184746995$var$Placeholder = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { isFixedWidthImageOption: isFixedWidthImageOption, smartSpaceOverviewHeight: smartSpaceOverviewHeight, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_19y14qn": (0, $9aYkv.default)(__cmplp.smartSpaceOverviewHeight, "px")
            },
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_1DCdHiPgdg _0KLXruDMqu",
                __cmplp.isFixedWidthImageOption ? "_313842dnbC _0adFHsIZbP _1DCdHidnbC _2XsHFMIZbP _313842LYhK _39xV02OAqP" : "_313842LYhK _39xV02rFfx _2XsHFM5ksT",
                __cmplp.smartSpaceOverviewHeight ? "_0jFU0Vm31q" : __cmplp.isFixedWidthImageOption ? "_0jFU0V6Tex" : "_0jFU0VurUm",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $be005db184746995$export$e9417b149b0db09d = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { coverPicture: coverPicture, isPagePreview: isPagePreview, contentAppearance: contentAppearance, isSpaceOverview: isSpaceOverview, hasEmoji: hasEmoji, coverPictureWidthOverride: coverPictureWidthOverride, isSmartSpaceOverview: isSmartSpaceOverview } = t0;
    const hasCoverPicture = isPagePreview ? !!coverPicture?.draft?.value?.id : !!coverPicture?.published?.value?.id;
    const appearance = isPagePreview ? contentAppearance.draft : contentAppearance.published;
    const isFixedWidthImageOption = coverPictureWidthOverride === (0, $jVylI.COVERPICTUREWIDTH).FIXED;
    const smartSpaceOverviewHeight = isSmartSpaceOverview ? (0, $75Ax4.SMART_SPACE_OVERVIEW_FIXED_HEIGHT_FULL_WIDTH) : undefined;
    let t1;
    if ($[0] !== appearance || $[1] !== hasCoverPicture || $[2] !== hasEmoji || $[3] !== isFixedWidthImageOption || $[4] !== isPagePreview || $[5] !== isSpaceOverview || $[6] !== smartSpaceOverviewHeight) {
        t1 = hasCoverPicture ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($be005db184746995$var$Placeholder, {
            contentAppearance: appearance,
            isPagePreview: isPagePreview,
            isSpaceOverview: isSpaceOverview,
            smartSpaceOverviewHeight: smartSpaceOverviewHeight,
            hasEmoji: hasEmoji,
            isFixedWidthImageOption: isFixedWidthImageOption
        })) : null;
        $[0] = appearance;
        $[1] = hasCoverPicture;
        $[2] = hasEmoji;
        $[3] = isFixedWidthImageOption;
        $[4] = isPagePreview;
        $[5] = isSpaceOverview;
        $[6] = smartSpaceOverviewHeight;
        $[7] = t1;
    } else t1 = $[7];
    return t1;
};
module.exports["RendererPageCoverPicturePlaceholder"] = $be005db184746995$export$e9417b149b0db09d;

});

parcelRegister("1NNJ5", function(module, exports) {

let $1500f0a4b44c70d0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1500f0a4b44c70d0$var$load("9zpfi"),
    $1500f0a4b44c70d0$var$load("9pNir"),
    $1500f0a4b44c70d0$var$load("kDVdu"),
    $1500f0a4b44c70d0$var$load("7BHAC"),
    $1500f0a4b44c70d0$var$load("N3TvS"),
    $1500f0a4b44c70d0$var$load("h0X0x"),
    $1500f0a4b44c70d0$var$load("7l4Nc"),
    $1500f0a4b44c70d0$var$load("7A87G"),
    $1500f0a4b44c70d0$var$load("coGVA"),
    $1500f0a4b44c70d0$var$load("RI3SR"),
    $1500f0a4b44c70d0$var$load("dtNxV"),
    $1500f0a4b44c70d0$var$load("jXx9i"),
    $1500f0a4b44c70d0$var$load("kGmwI"),
    $1500f0a4b44c70d0$var$load("kT6dz"),
    $1500f0a4b44c70d0$var$load("aAWLw"),
    $1500f0a4b44c70d0$var$load("7EorR"),
    $1500f0a4b44c70d0$var$load("4Bg7q")
]).then(()=>parcelRequire('9ChZM'));

});

parcelRegister("jcM8h", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $kN9tW = parcelRequire("kN9tW");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $aDSIl = parcelRequire("aDSIl");


var $7ZB0A = parcelRequire("7ZB0A");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $is1T6 = parcelRequire("is1T6");


var $4n1IT = parcelRequire("4n1IT");


var $6mKj3 = parcelRequire("6mKj3");


var $irVI7 = parcelRequire("irVI7");


var $a6t12 = parcelRequire("a6t12");


var $68BwE = parcelRequire("68BwE");


var $jFm04 = parcelRequire("jFm04");


var $3SLf9 = parcelRequire("3SLf9");


var $jMyy4 = parcelRequire("jMyy4");

const $a26c936fb563039b$var$i18n = (0, $kSwu1.defineMessages)({
    creator: {
        id: "content-ownership.content-owner-popup.creator",
        defaultMessage: "<b>Creator</b>"
    },
    owner: {
        id: "content-ownership.content-owner-popup.owner",
        defaultMessage: "<b>Owner</b>"
    },
    changeOwner: {
        id: "content-ownership.content-owner-popup.change-owner",
        defaultMessage: "Change owner"
    },
    ariaLabel: {
        id: "content-ownership.content-owner-popup.ariaLabel",
        defaultMessage: "More information about {name}"
    }
});
// fixed dimensions
const $a26c936fb563039b$var$contentOwnerContainerStyles = (0, $buxP3.xcss)({
    width: '232px',
    height: '180px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    padding: 'space.250'
});
const $a26c936fb563039b$var$contentOwnerViewerContainerStyles = (0, $buxP3.xcss)({
    width: '232px',
    height: '140px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    padding: 'space.250'
});
const $a26c936fb563039b$var$contentOwnerItemStyles = (0, $buxP3.xcss)({
    display: 'flex',
    flexDirection: 'column',
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
});
const $a26c936fb563039b$var$contentCreatorItemStyles = (0, $buxP3.xcss)({
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: 'space.100'
});
const $a26c936fb563039b$var$contentOwnerChangeItemStyles = (0, $buxP3.xcss)({
    marginTop: 'space.100'
});
const $a26c936fb563039b$var$contentOwnerNameItemStyles = (0, $buxP3.xcss)({
    marginTop: 'space.025',
    textDecoration: 'underline',
    color: 'color.text',
    ':hover': {
        color: 'color.link',
        cursor: 'pointer'
    }
});
const $a26c936fb563039b$var$ContentOwnerDetailsPanelName = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { userId: userId, fullName: fullName, ariaLabel: ariaLabel } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            0,
            28
        ];
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== fullName || $[2] !== userId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6t12.ProfileCardWrapper), {
            userId: userId,
            position: "left-start",
            offset: t1,
            trigger: (0, $6mKj3.expValEquals)("confluence_profile_card_consistent_updates", "isEnabled", true) ? "click" : "hover",
            fullName: fullName
        }, fullName);
        $[1] = fullName;
        $[2] = userId;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== ariaLabel || $[5] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $a26c936fb563039b$var$contentOwnerNameItemStyles,
            role: "tooltip",
            "aria-label": ariaLabel
        }, t2);
        $[4] = ariaLabel;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ userId: userId, fullName: fullName, ariaLabel: ariaLabel })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $a26c936fb563039b$var$contentOwnerNameItemStyles,
        role: "tooltip",
        "aria-label": ariaLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6t12.ProfileCardWrapper), {
        userId: userId,
        position: "left-start",
        offset: [
            0,
            28
        ],
        trigger: (0, $6mKj3.expValEquals)('confluence_profile_card_consistent_updates', 'isEnabled', true) ? 'click' : 'hover',
        fullName: fullName
    }, fullName));
};
const $a26c936fb563039b$var$ContentOwnerDetailsPanel = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(32);
    const { ownedBy: ownedBy, createdBy: createdBy, closePopup: closePopup, openModal: openModal, setInitialFocusRef: setInitialFocusRef } = t0;
    const intl = (0, $kSwu1.useIntl)();
    const experienceTracker = (0, $68BwE.useExperienceTrackerContext)();
    let t1;
    if ($[0] !== closePopup || $[1] !== experienceTracker || $[2] !== openModal) {
        t1 = ()=>{
            openModal();
            closePopup();
            experienceTracker.start({
                name: (0, $irVI7.CONTENT_OWNERSHIP_DIALOG_EXPERIENCE)
            });
        };
        $[0] = closePopup;
        $[1] = experienceTracker;
        $[2] = openModal;
        $[3] = t1;
    } else t1 = $[3];
    const onClickChangeOwner = t1;
    const isAllowedToChange = (0, $3SLf9.useIsAllowedToChangeOwner)(ownedBy.userId);
    const t2 = isAllowedToChange ? $a26c936fb563039b$var$contentOwnerContainerStyles : $a26c936fb563039b$var$contentOwnerViewerContainerStyles;
    let t3;
    if ($[4] !== t2) {
        t3 = [
            t2
        ];
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...$a26c936fb563039b$var$i18n.creator,
            values: {
                b: $a26c936fb563039b$var$_temp
            }
        });
        $[6] = t4;
    } else t4 = $[6];
    const t5 = createdBy.userId;
    const t6 = createdBy.fullName;
    let t7;
    if ($[7] !== createdBy.fullName || $[8] !== intl) {
        t7 = intl.formatMessage($a26c936fb563039b$var$i18n.ariaLabel, {
            name: createdBy.fullName
        });
        $[7] = createdBy.fullName;
        $[8] = intl;
        $[9] = t7;
    } else t7 = $[9];
    let t8;
    if ($[10] !== createdBy.fullName || $[11] !== createdBy.userId || $[12] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $a26c936fb563039b$var$contentCreatorItemStyles
        }, t4, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a26c936fb563039b$var$ContentOwnerDetailsPanelName, {
            userId: t5,
            fullName: t6,
            ariaLabel: t7
        }));
        $[10] = createdBy.fullName;
        $[11] = createdBy.userId;
        $[12] = t7;
        $[13] = t8;
    } else t8 = $[13];
    let t9;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...$a26c936fb563039b$var$i18n.owner,
            values: {
                b: $a26c936fb563039b$var$_temp2
            }
        });
        $[14] = t9;
    } else t9 = $[14];
    const t10 = ownedBy.userId;
    const t11 = ownedBy.fullName;
    let t12;
    if ($[15] !== intl || $[16] !== ownedBy.fullName) {
        t12 = intl.formatMessage($a26c936fb563039b$var$i18n.ariaLabel, {
            name: ownedBy.fullName
        });
        $[15] = intl;
        $[16] = ownedBy.fullName;
        $[17] = t12;
    } else t12 = $[17];
    let t13;
    if ($[18] !== ownedBy.fullName || $[19] !== ownedBy.userId || $[20] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $a26c936fb563039b$var$contentOwnerItemStyles
        }, t9, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a26c936fb563039b$var$ContentOwnerDetailsPanelName, {
            userId: t10,
            fullName: t11,
            ariaLabel: t12
        }));
        $[18] = ownedBy.fullName;
        $[19] = ownedBy.userId;
        $[20] = t12;
        $[21] = t13;
    } else t13 = $[21];
    let t14;
    if ($[22] !== intl || $[23] !== isAllowedToChange || $[24] !== onClickChangeOwner || $[25] !== setInitialFocusRef) {
        t14 = isAllowedToChange && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $a26c936fb563039b$var$contentOwnerChangeItemStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            onClick: onClickChangeOwner,
            appearance: "link",
            spacing: "none",
            ref: setInitialFocusRef
        }, intl.formatMessage($a26c936fb563039b$var$i18n.changeOwner)));
        $[22] = intl;
        $[23] = isAllowedToChange;
        $[24] = onClickChangeOwner;
        $[25] = setInitialFocusRef;
        $[26] = t14;
    } else t14 = $[26];
    let t15;
    if ($[27] !== t13 || $[28] !== t14 || $[29] !== t3 || $[30] !== t8) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: t3
        }, t8, t13, t14);
        $[27] = t13;
        $[28] = t14;
        $[29] = t3;
        $[30] = t8;
        $[31] = t15;
    } else t15 = $[31];
    return t15;
} : ({ ownedBy: ownedBy, createdBy: createdBy, closePopup: closePopup, openModal: openModal, setInitialFocusRef: setInitialFocusRef })=>{
    const intl = (0, $kSwu1.useIntl)();
    const experienceTracker = (0, $68BwE.useExperienceTrackerContext)();
    const onClickChangeOwner = (0, $cozmU.useCallback)(()=>{
        openModal();
        closePopup();
        experienceTracker.start({
            name: (0, $irVI7.CONTENT_OWNERSHIP_DIALOG_EXPERIENCE)
        });
    }, [
        closePopup,
        openModal,
        experienceTracker
    ]);
    const isAllowedToChange = (0, $3SLf9.useIsAllowedToChangeOwner)(ownedBy.userId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: [
            isAllowedToChange ? $a26c936fb563039b$var$contentOwnerContainerStyles : $a26c936fb563039b$var$contentOwnerViewerContainerStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $a26c936fb563039b$var$contentCreatorItemStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$a26c936fb563039b$var$i18n.creator,
        values: {
            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, chunks)
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a26c936fb563039b$var$ContentOwnerDetailsPanelName, {
        userId: createdBy.userId,
        fullName: createdBy.fullName,
        ariaLabel: intl.formatMessage($a26c936fb563039b$var$i18n.ariaLabel, {
            name: createdBy.fullName
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $a26c936fb563039b$var$contentOwnerItemStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$a26c936fb563039b$var$i18n.owner,
        values: {
            b: (chunks_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, chunks_0)
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a26c936fb563039b$var$ContentOwnerDetailsPanelName, {
        userId: ownedBy.userId,
        fullName: ownedBy.fullName,
        ariaLabel: intl.formatMessage($a26c936fb563039b$var$i18n.ariaLabel, {
            name: ownedBy.fullName
        })
    })), isAllowedToChange && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $a26c936fb563039b$var$contentOwnerChangeItemStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        onClick: onClickChangeOwner,
        appearance: "link",
        spacing: "none",
        ref: setInitialFocusRef
    }, intl.formatMessage($a26c936fb563039b$var$i18n.changeOwner))));
};
const $a26c936fb563039b$var$ContentOwnerDetailsPanelWrapper = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { ownedBy: ownedBy, createdBy: createdBy, closePopup: closePopup, setInitialFocusRef: setInitialFocusRef } = t0;
    if (!ownedBy || !createdBy) return null;
    let t1;
    if ($[0] !== closePopup || $[1] !== createdBy || $[2] !== ownedBy || $[3] !== setInitialFocusRef) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jFm04.ContentOwnershipContextConsumer), null, (t2)=>{
            const { openModal: openModal } = t2;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a26c936fb563039b$var$ContentOwnerDetailsPanel, {
                ownedBy: ownedBy,
                createdBy: createdBy,
                closePopup: closePopup,
                openModal: openModal,
                setInitialFocusRef: setInitialFocusRef
            });
        });
        $[0] = closePopup;
        $[1] = createdBy;
        $[2] = ownedBy;
        $[3] = setInitialFocusRef;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : ({ ownedBy: ownedBy, createdBy: createdBy, closePopup: closePopup, setInitialFocusRef: setInitialFocusRef })=>{
    if (!ownedBy || !createdBy) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jFm04.ContentOwnershipContextConsumer), null, ({ openModal: openModal })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a26c936fb563039b$var$ContentOwnerDetailsPanel, {
            ownedBy: ownedBy,
            createdBy: createdBy,
            closePopup: closePopup,
            openModal: openModal,
            setInitialFocusRef: setInitialFocusRef
        }));
};
const $a26c936fb563039b$export$62380b37452323f8 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(28);
    const { contentId: contentId, itemId: itemId, itemLabel: itemLabel, isOpen: isOpen, onClick: onClick, onCloseParent: onCloseParent, onClosePopup: onClosePopup, onMouseEnter: onMouseEnter, elemBefore: elemBefore } = t0;
    let t1;
    if ($[0] !== onCloseParent || $[1] !== onClosePopup) {
        t1 = ()=>{
            onClosePopup();
            onCloseParent?.();
        };
        $[0] = onCloseParent;
        $[1] = onClosePopup;
        $[2] = t1;
    } else t1 = $[2];
    const closeOwnerDialog = t1;
    let t2;
    if ($[3] !== contentId) {
        t2 = {
            contentId: contentId
        };
        $[3] = contentId;
        $[4] = t2;
    } else t2 = $[4];
    const t3 = !contentId;
    let t4;
    if ($[5] !== t2 || $[6] !== t3) {
        t4 = {
            variables: t2,
            skip: t3
        };
        $[5] = t2;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    const { data: ownerHistoryData } = (0, $jMyy4.useQueryInterop)((0, $kN9tW.default), {
        ...t4,
        __callerPackage__: "content-ownership"
    });
    const toUserData = $a26c936fb563039b$var$_temp3;
    const t5 = ownerHistoryData?.singleContent?.history?.ownedBy;
    let t6;
    if ($[8] !== t5) {
        t6 = toUserData(t5);
        $[8] = t5;
        $[9] = t6;
    } else t6 = $[9];
    const ownedBy = t6;
    const t7 = ownerHistoryData?.singleContent?.history?.createdBy;
    let t8;
    if ($[10] !== t7) {
        t8 = toUserData(t7);
        $[10] = t7;
        $[11] = t8;
    } else t8 = $[11];
    const createdBy = t8;
    const t9 = `container-${itemId}`;
    let t10;
    if ($[12] !== closeOwnerDialog || $[13] !== createdBy || $[14] !== ownedBy) {
        t10 = (t11)=>{
            const { setInitialFocusRef: setInitialFocusRef } = t11;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a26c936fb563039b$var$ContentOwnerDetailsPanelWrapper, {
                ownedBy: ownedBy,
                createdBy: createdBy,
                closePopup: closeOwnerDialog,
                setInitialFocusRef: setInitialFocusRef
            });
        };
        $[12] = closeOwnerDialog;
        $[13] = createdBy;
        $[14] = ownedBy;
        $[15] = t10;
    } else t10 = $[15];
    let t11;
    if ($[16] !== elemBefore || $[17] !== isOpen || $[18] !== itemLabel || $[19] !== onClick || $[20] !== onMouseEnter) {
        t11 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
                elemBefore: elemBefore,
                ...triggerProps,
                onClick: onClick,
                onMouseEnter: onMouseEnter,
                isSelected: isOpen,
                elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                    label: "",
                    color: "var(--ds-icon, #292A2E)",
                    size: "small"
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, itemLabel));
        $[16] = elemBefore;
        $[17] = isOpen;
        $[18] = itemLabel;
        $[19] = onClick;
        $[20] = onMouseEnter;
        $[21] = t11;
    } else t11 = $[21];
    let t12;
    if ($[22] !== isOpen || $[23] !== onClosePopup || $[24] !== t10 || $[25] !== t11 || $[26] !== t9) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
            key: t9,
            isOpen: isOpen,
            onClose: onClosePopup,
            onBlur: onClosePopup,
            placement: "left-start",
            content: t10,
            trigger: t11
        });
        $[22] = isOpen;
        $[23] = onClosePopup;
        $[24] = t10;
        $[25] = t11;
        $[26] = t9;
        $[27] = t12;
    } else t12 = $[27];
    return t12;
} : ({ contentId: contentId, itemId: itemId, itemLabel: itemLabel, isOpen: isOpen, onClick: onClick, onCloseParent: onCloseParent, onClosePopup: onClosePopup, onMouseEnter: onMouseEnter, elemBefore: elemBefore })=>{
    const closeOwnerDialog = ()=>{
        onClosePopup();
        onCloseParent?.();
    };
    const { data: ownerHistoryData } = (0, $jMyy4.useQueryInterop)((0, $kN9tW.default), {
        variables: {
            contentId: contentId
        },
        skip: !contentId,
        __callerPackage__: "content-ownership"
    });
    const toUserData = (user)=>({
            userId: user?.accountId ?? undefined,
            fullName: user?.displayName,
            isAnonymous: !user?.accountId
        });
    const ownedBy = toUserData(ownerHistoryData?.singleContent?.history?.ownedBy);
    const createdBy = toUserData(ownerHistoryData?.singleContent?.history?.createdBy);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
        key: `container-${itemId}`,
        isOpen: isOpen,
        onClose: onClosePopup,
        // @ts-ignore onBlur not a supported Popup prop, but works as intended. Keep this around until live pages behavior is finalized
        onBlur: onClosePopup,
        placement: "left-start",
        content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a26c936fb563039b$var$ContentOwnerDetailsPanelWrapper, {
                ownedBy: ownedBy,
                createdBy: createdBy,
                closePopup: closeOwnerDialog,
                setInitialFocusRef: setInitialFocusRef
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
                elemBefore: elemBefore,
                ...triggerProps,
                onClick: onClick,
                // @ts-ignore onMouseEnter not a supported Popup prop, but works as intended. Keep this around until live pages behavior is finalized
                onMouseEnter: onMouseEnter,
                isSelected: isOpen,
                elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                    label: "",
                    color: "var(--ds-icon, #292A2E)",
                    size: "small"
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, itemLabel))
    });
};
function $a26c936fb563039b$var$_temp(chunks) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, chunks);
}
function $a26c936fb563039b$var$_temp2(chunks_0) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, chunks_0);
}
function $a26c936fb563039b$var$_temp3(user) {
    return {
        userId: user?.accountId ?? undefined,
        fullName: user?.displayName,
        isAnonymous: !user?.accountId
    };
}
module.exports["ContentOwnerPopupComponent"] = $a26c936fb563039b$export$62380b37452323f8;

});

parcelRegister("kN9tW", function(module, exports) {
/**
 * @generated SignedSource<<10c675709560dcdd57f41b244dd44cf1>>
 * @relayHash 7fe01343636a1cc8e3587d1c0025997f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 70169404e9af278282103e5852c5a75edc0d3390fd4aa4707ab74a4bbff37105
const $cbf179a03b0882d6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v4 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v5 = [
        v3 /*: any*/ ,
        v4 /*: any*/ 
    ], v6 = [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        v3 /*: any*/ ,
        v4 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentOwnerPopupComponentContentOwnerQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "createdBy",
                                    "plural": false,
                                    "selections": v5 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "ownedBy",
                                    "plural": false,
                                    "selections": v5 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentOwnerPopupComponentContentOwnerQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "createdBy",
                                    "plural": false,
                                    "selections": v6 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "ownedBy",
                                    "plural": false,
                                    "selections": v6 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "7fe01343636a1cc8e3587d1c0025997f",
            "id": "70169404e9af278282103e5852c5a75edc0d3390fd4aa4707ab74a4bbff37105",
            "metadata": {},
            "name": "ContentOwnerPopupComponentContentOwnerQuery",
            "operationKind": "query",
            "text": "query ContentOwnerPopupComponentContentOwnerQuery($contentId:ID!){singleContent(id:$contentId){id,history{createdBy{__typename,displayName,...on KnownUser{accountId}},ownedBy{__typename,displayName,...on KnownUser{accountId}}}}}"
        }
    };
}();
$cbf179a03b0882d6$var$node.hash = "ab500ff679b71481a192bc88337cadcd";
var $cbf179a03b0882d6$export$2e2bcd8739ae039 = $cbf179a03b0882d6$var$node;
module.exports["default"] = $cbf179a03b0882d6$export$2e2bcd8739ae039;

});

parcelRegister("3SLf9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $bQm3c = parcelRequire("bQm3c");


var $i28ZW = parcelRequire("i28ZW");


var $6mKj3 = parcelRequire("6mKj3");


var $ep3mz = parcelRequire("ep3mz");


var $5k5SG = parcelRequire("5k5SG");


var $68BwE = parcelRequire("68BwE");

const $93ff62a422a2769d$export$fe5ee8722fdedf98 = (ownedByAccountId)=>{
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const isSpaceOrSiteAdmin = (0, $5k5SG.useIsSpaceOrSiteAdmin)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { isSiteAdmin: isSiteAdmin } = (0, $68BwE.useSPAViewContext)();
    const { canManageContent: canManageContent = false } = (0, $i28ZW.useSpaceManagementOperations)({
        spaceKey: spaceKey ?? '',
        skip: !spaceKey || !(0, $6mKj3.expVal)('permissions_rbac_dependencies_callsites', 'isEnabled', false)
    }) ?? {};
    const isElevated = (0, $6mKj3.expVal)('permissions_rbac_dependencies_callsites', 'isEnabled', false) ? canManageContent || isSiteAdmin : isSpaceOrSiteAdmin;
    return (0, $cozmU.useMemo)(()=>{
        if (!userId) return false;
        const isCurrentUserOwner = ownedByAccountId === userId;
        return isElevated || isCurrentUserOwner;
    }, [
        isElevated,
        ownedByAccountId,
        userId
    ]);
};
module.exports["useIsAllowedToChangeOwner"] = $93ff62a422a2769d$export$fe5ee8722fdedf98;

});

parcelRegister("lyx2E", function(module, exports) {
/* contentTypesHeaderStyles.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $w6R6I = parcelRequire("w6R6I");


var $3izAL = parcelRequire("3izAL");

const $3d1681a377877e6e$export$e139d3b51c488e9b = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFloating: isFloating, hasPointerEvents: hasPointerEvents, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1fwhixl": (0, $9aYkv.default)((()=>{
                return __cmplp.isFloating ? 'absolute' : 'relative';
            })()),
            "--_17xabpo": (0, $9aYkv.default)((()=>{
                return __cmplp.hasPointerEvents ? 'auto' : 'none';
            })())
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0KLXrujOvk _1mT5xd1EEW _1pp6NdHETu _39xV02N91d _3iDTPbgBM8",
            __cmplp.className
        ])
    });
});
const $3d1681a377877e6e$var$styles = {
    base: "_0bjKvDKxmn _2Y7lL42ADO _1pp6NdIZbP _0KLXrulfZc _0xmtko1Y8M _3iDTPbQ4SZ _3TGfC9LRg7 _46hvQm1Y8M _0jFU0VN91d",
    alignCenter: "_4xdlr0DIqT"
};
const $3d1681a377877e6e$export$b1249ef660098484 = ({ isContentHeaderPinned: isContentHeaderPinned = false, xcss: xcss, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: (0, $w6R6I.cx)($3d1681a377877e6e$var$styles.base, isContentHeaderPinned && $3d1681a377877e6e$var$styles.alignCenter, xcss)
    }, children);
};
module.exports["ContentTypesHeaderContainer"] = $3d1681a377877e6e$export$e139d3b51c488e9b;
module.exports["TitleAndBreadcrumbsWrapper"] = $3d1681a377877e6e$export$b1249ef660098484;

});

parcelRegister("iOaib", function(module, exports) {
/**
 * The markdown filename suffix. Used as a visual hint when a content
 * surface is in markdown mode, and as the gesture trigger for switching
 * to markdown mode (e.g. typing `.md` at the end of a title).
 */ const $aeb0c44d8485e554$export$509c4be251ab8715 = '.md';
const $aeb0c44d8485e554$export$10607f80e07a7230 = (s)=>s.trimEnd().endsWith($aeb0c44d8485e554$export$509c4be251ab8715);
const $aeb0c44d8485e554$export$47193e44f183d52c = (s)=>{
    const trimmed = s.trimEnd();
    return trimmed.endsWith($aeb0c44d8485e554$export$509c4be251ab8715) ? trimmed.slice(0, -$aeb0c44d8485e554$export$509c4be251ab8715.length) : s;
};
module.exports["MARKDOWN_SUFFIX"] = $aeb0c44d8485e554$export$509c4be251ab8715;
module.exports["endsWithMarkdownSuffix"] = $aeb0c44d8485e554$export$10607f80e07a7230;
module.exports["stripMarkdownSuffix"] = $aeb0c44d8485e554$export$47193e44f183d52c;

});

parcelRegister("3u7PM", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $3cfcff3140a018ad$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    noEditAccessFlagTitle: {
        id: "edit-features.no-edit-access-flag.title",
        defaultMessage: "This shortcut requires edit access"
    },
    noEditAccessFlagDescription: {
        id: "edit-features.no-edit-access-flag.description",
        defaultMessage: "To use this keyboard shortcut, you'll need edit access to this content."
    }
});
const $3cfcff3140a018ad$export$175b3f54640daa25 = (flags)=>{
    const intl = (0, $kSwu1.useIntl)();
    const showNoEditAccessFlag = ()=>{
        flags.showFlag({
            id: 'live-pages-mode-flag',
            title: intl.formatMessage($3cfcff3140a018ad$export$a7357cdd1f0b0168.noEditAccessFlagTitle),
            description: intl.formatMessage($3cfcff3140a018ad$export$a7357cdd1f0b0168.noEditAccessFlagDescription),
            close: 'auto'
        });
    };
    return {
        showNoEditAccessFlag: showNoEditAccessFlag
    };
};
module.exports["useNoEditAccessFlag"] = $3cfcff3140a018ad$export$175b3f54640daa25;

});

parcelRegister("briGH", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ 
var $7W8i8 = parcelRequire("7W8i8");

const $8540b650e122e686$var$RETRY_STATUS_CODE = [
    409,
    412
];
const $8540b650e122e686$export$8e3b4758c0e0a83 = (response)=>response?.data?.experimentalMigratePages?.status;
const $8540b650e122e686$var$logger = (0, $7W8i8.getLogger)('PageMigration');
const $8540b650e122e686$export$9369b12211e1fce4 = (refetchContentHash, migratePages, retriesLeft = 3, interval = 1000, statusCodes = [])=>{
    return new Promise((resolve, reject)=>{
        // b/c contentHash is variable and could changed when user in preview
        // perform refetch to grab the latest contentHash (to avoid 412 and 409 error when performing migration)
        return refetchContentHash().then((contentHash)=>{
            migratePages(contentHash).then((response)=>{
                const status = $8540b650e122e686$export$8e3b4758c0e0a83(response);
                setTimeout(()=>{
                    if (retriesLeft === 1) {
                        const message = 'Number of retrying attempt reach maximum number of retries';
                        $8540b650e122e686$var$logger.debug`${message}`;
                        return reject(message, statusCodes);
                    }
                    // only retry when status code is 409, 412
                    if ($8540b650e122e686$var$RETRY_STATUS_CODE.indexOf(Number.parseInt(status)) !== -1) {
                        statusCodes.push(Number.parseInt(status));
                        $8540b650e122e686$export$9369b12211e1fce4(refetchContentHash, migratePages, retriesLeft - 1, interval, statusCodes).then(resolve, reject);
                    } else return resolve(response, statusCodes);
                }, interval);
            }).catch((error)=>{
                return reject(error, statusCodes);
            });
        });
    });
};
module.exports["getStatusFromResponse"] = $8540b650e122e686$export$8e3b4758c0e0a83;
module.exports["retry"] = $8540b650e122e686$export$9369b12211e1fce4;

});

parcelRegister("1Zthr", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $86e4d9c8583d266f$export$9c05e92142f10f44 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CxVtX",
    name: "UnarchivePagesDialogLoader",
    loader: async ()=>(await (parcelRequire("6cT5A"))).UnarchivePagesLoader
});
module.exports["UnarchivePagesDialogLoader"] = $86e4d9c8583d266f$export$9c05e92142f10f44;

});

parcelRegister("6cT5A", function(module, exports) {

let $484e98a13a5b3f76$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $484e98a13a5b3f76$var$load("iWnyc"),
    $484e98a13a5b3f76$var$load("7BHAC"),
    $484e98a13a5b3f76$var$load("N3TvS"),
    $484e98a13a5b3f76$var$load("4g6rd"),
    $484e98a13a5b3f76$var$load("7A87G"),
    $484e98a13a5b3f76$var$load("6wr18"),
    $484e98a13a5b3f76$var$load("dRQ13"),
    $484e98a13a5b3f76$var$load("4QN8n"),
    $484e98a13a5b3f76$var$load("LWh5V"),
    $484e98a13a5b3f76$var$load("9pso5"),
    $484e98a13a5b3f76$var$load("251nM"),
    $484e98a13a5b3f76$var$load("kHXvF"),
    $484e98a13a5b3f76$var$load("jXx9i"),
    $484e98a13a5b3f76$var$load("ffEVr"),
    $484e98a13a5b3f76$var$load("5gsbh"),
    $484e98a13a5b3f76$var$load("8lMr1"),
    $484e98a13a5b3f76$var$load("1vUE6"),
    $484e98a13a5b3f76$var$load("7EorR"),
    $484e98a13a5b3f76$var$load("Wowvf"),
    $484e98a13a5b3f76$var$load("ayJxT"),
    $484e98a13a5b3f76$var$load("hhss7"),
    $484e98a13a5b3f76$var$load("dxDVc")
]).then(()=>parcelRequire('ew61I'));

});

parcelRegister("bYfSa", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $93a5db5531d4a12b$var$initialState = {
    dialog: {
        isOpen: false
    }
};
const $93a5db5531d4a12b$export$83212c186871ba71 = (0, $8s9DV.createStore)({
    initialState: $93a5db5531d4a12b$var$initialState,
    actions: {
        openConvertDialog: (payload)=>({ setState: setState, getState: getState })=>{
                const next = {
                    isOpen: true,
                    direction: payload.direction,
                    isLossy: payload.direction === 'toMarkdown' ? Boolean(payload.isLossy) : false,
                    syncBlockCount: payload.direction === 'toMarkdown' ? Math.max(payload.syncBlockCount ?? 0, 0) : 0
                };
                const current = getState();
                if (current.dialog.isOpen && current.dialog.direction === next.direction && current.dialog.isLossy === next.isLossy && current.dialog.syncBlockCount === next.syncBlockCount) return;
                setState({
                    dialog: next
                });
            },
        closeConvertDialog: ()=>({ setState: setState, getState: getState })=>{
                if (getState().dialog.isOpen) setState({
                    dialog: {
                        isOpen: false
                    }
                });
            }
    },
    name: 'ConvertDialogStore'
});
const $93a5db5531d4a12b$export$ad39afc4acff5a42 = (0, $kBr4q.createHook)($93a5db5531d4a12b$export$83212c186871ba71);
const $93a5db5531d4a12b$export$df72975e717193c9 = (0, $kBr4q.createActionsHook)($93a5db5531d4a12b$export$83212c186871ba71);
module.exports["useConvertDialogState"] = $93a5db5531d4a12b$export$ad39afc4acff5a42;
module.exports["useConvertDialogActions"] = $93a5db5531d4a12b$export$df72975e717193c9;

});

parcelRegister("bJrpn", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");


var $bYfSa = parcelRequire("bYfSa");


var $03dyQ = parcelRequire("03dyQ");


var $lhtqQ = parcelRequire("lhtqQ");


var $8cRVT = parcelRequire("8cRVT");


var $5zmqi = parcelRequire("5zmqi");


var $LSims = parcelRequire("LSims");


var $fEvT8 = parcelRequire("fEvT8");


var $hTLSK = parcelRequire("hTLSK");

const $f03ea469cfc6fc83$export$76935da616701441 = ({ contentId: contentId, isLivePage: isLivePage, editorActions: editorActions, flags: flags })=>{
    const { updateMarkdownMode: updateMarkdownMode, loading: isUpdating } = (0, $hTLSK.useUpdateMarkdownMode)();
    const isMarkdownMode = (0, $LSims.useIsMarkdownMode)(isLivePage ? contentId : undefined);
    // Dialog open/close lives in a sweet-state store so multiple call sites
    // (header overflow menu, title `.md`-suffix gesture, `cmd+shift+x`
    // shortcut) all drive the same dialog instance rendered by `MoreActions`.
    const [{ dialog: dialog }] = (0, $bYfSa.useConvertDialogState)();
    const { openConvertDialog: openConvertDialog, closeConvertDialog: closeConvertDialog } = (0, $bYfSa.useConvertDialogActions)();
    const convertFlags = (0, $fEvT8.useMarkdownConvertFlags)(flags);
    // Wait for any unconfirmed collab steps to be acked before flipping the
    // markdown-mode flag. The convert mutation invalidates the live-doc
    // session on the BE, which triggers an NCS restore that would otherwise
    // re-apply our unconfirmed steps on top of the server doc that already
    // has them — duplicating anything typed just before the click.
    const drainUnconfirmedSteps = (0, $cozmU.useCallback)(async ()=>{
        if (!('getResolvedEditorState' in editorActions)) return;
        try {
            await editorActions.getResolvedEditorState('publish');
        } catch  {
        // Swallow — don't block convert if the drain fails.
        }
    }, [
        editorActions
    ]);
    const flipFlagToMarkdown = (0, $cozmU.useCallback)(async ()=>{
        await drainUnconfirmedSteps();
        const result = await updateMarkdownMode(contentId, true);
        if (!result.success) {
            convertFlags.showError('toMarkdown');
            return {
                success: false
            };
        }
        // Replace the PM doc with the markdown-safe BE body BEFORE flipping
        // the mode cache. The flip triggers `reconfigureState`, which migrates
        // the current doc via `PMNode.fromJSON(markdownSchema, ...)` — any
        // rich-text-only node still in the doc (`status`, `panel`, `expand`,
        // ...) throws and resets the editor to empty.
        //
        // Monolith holds the rich-text ADF; NCS catchupv2 delivers the
        // filtered version. Running `filterToMarkdownSafeAdf` here matches
        // what NCS would deliver without FE/BE divergence (same pipeline
        // filter).
        const convertedBody = await (0, $5zmqi.refetchPageContent)(contentId);
        if (convertedBody && 'replaceDocument' in editorActions) try {
            const parsed = JSON.parse(convertedBody);
            const safe = (0, $lhtqQ.filterToMarkdownSafeAdf)(parsed);
            if (safe) editorActions.replaceDocument(safe, false);
        } catch  {
        // Editor unmounted, JSON parse failed, or filter rejected the
        // input. The flip still proceeds; NCS catchupv2 recovers.
        }
        (0, $hTLSK.patchIsMarkdownModeCache)(contentId, true, (0, $6mKj3.expValEquals)('cc-markdown-mode', 'isEnabled', true));
        convertFlags.showSuccess('toMarkdown');
        return {
            success: true
        };
    }, [
        contentId,
        convertFlags,
        drainUnconfirmedSteps,
        editorActions,
        updateMarkdownMode
    ]);
    const flipFlagToRichText = (0, $cozmU.useCallback)(async ()=>{
        await drainUnconfirmedSteps();
        const result = await updateMarkdownMode(contentId, false);
        if (!result.success) {
            convertFlags.showError('toRichText');
            return {
                success: false
            };
        }
        // Rich-text schema is a superset of markdown, so the `reconfigureState`
        // migration always succeeds — no doc replace needed. Refetch still
        // runs so the `CollabDraftQuery` cache mirrors the BE body and the
        // dialog holds in `isSubmitting` for the round-trip.
        await (0, $5zmqi.refetchPageContent)(contentId);
        (0, $hTLSK.patchIsMarkdownModeCache)(contentId, false, (0, $6mKj3.expValEquals)('cc-markdown-mode', 'isEnabled', true));
        convertFlags.showSuccess('toRichText');
        return {
            success: true
        };
    }, [
        contentId,
        convertFlags,
        drainUnconfirmedSteps,
        updateMarkdownMode
    ]);
    const confirmConvertToMarkdown = (0, $cozmU.useCallback)(()=>flipFlagToMarkdown(), [
        flipFlagToMarkdown
    ]);
    const confirmConvertToRichText = (0, $cozmU.useCallback)(async ()=>{
        return flipFlagToRichText();
    }, [
        flipFlagToRichText
    ]);
    // Entry point for the "Convert to markdown" menu item / shortcut /
    // `.md` title gesture. The dialog always opens; synced-block and lossy
    // signals are captured in dialog state and rendered as warning treatment.
    const convertToMarkdown = (0, $cozmU.useCallback)(async ()=>{
        let adf;
        if ('getValue' in editorActions) try {
            adf = await editorActions.getValue();
        } catch  {
            adf = undefined;
        }
        const syncBlockNodeCount = (0, $03dyQ.countSyncBlocks)(adf);
        const isLossy = syncBlockNodeCount > 0 ? false : await (0, $8cRVT.isMarkdownConversionLossy)(adf, contentId);
        openConvertDialog({
            direction: 'toMarkdown',
            isLossy: isLossy,
            syncBlockCount: syncBlockNodeCount
        });
    }, [
        contentId,
        editorActions,
        openConvertDialog
    ]);
    const convertToRichText = (0, $cozmU.useCallback)(async ()=>{
        openConvertDialog({
            direction: 'toRichText'
        });
    }, [
        openConvertDialog
    ]);
    return {
        isMarkdownMode: isMarkdownMode,
        isUpdating: isUpdating,
        convertDialogState: dialog,
        closeConvertDialog: closeConvertDialog,
        convertToMarkdown: convertToMarkdown,
        convertToRichText: convertToRichText,
        confirmConvertToMarkdown: confirmConvertToMarkdown,
        confirmConvertToRichText: confirmConvertToRichText
    };
};
module.exports["useMarkdownModeActions"] = $f03ea469cfc6fc83$export$76935da616701441;

});

parcelRegister("03dyQ", function(module, exports) {

var $4EPzQ = parcelRequire("4EPzQ");

const $d8d60ab22e6f347d$export$dfea1f72f7cab2b = (adf)=>{
    if (adf === undefined || adf === null) return 0;
    if (typeof adf !== 'object' || typeof adf.type !== 'string') return 0;
    return (0, $4EPzQ.reduce)(adf, (acc, node)=>node.type === 'bodiedSyncBlock' ? acc + 1 : acc, 0);
};
module.exports["countSyncBlocks"] = $d8d60ab22e6f347d$export$dfea1f72f7cab2b;

});

parcelRegister("lhtqQ", function(module, exports) {

var $jTt8P = parcelRequire("jTt8P");


var $ftIY0 = parcelRequire("ftIY0");

const $fbc0577d3febc813$export$796ad20fc99717ad = (adf)=>{
    if (adf === undefined || adf === null) return undefined;
    if (typeof adf !== 'object' || typeof adf.type !== 'string') return undefined;
    const result = (0, $jTt8P.traverse)(adf, {
        any: (node)=>{
            // 1. Drop nodes whose type isn't in the supported set.
            if (!(0, $ftIY0.MARKDOWN_SERIALIZABLE_NODE_TYPES).has(node.type)) return false;
            // 2. Drop merged-cell table cells / headers.
            if ((node.type === 'tableCell' || node.type === 'tableHeader') && (0, $ftIY0.hasMergedCellSpan)(node)) return false;
            // 3. Strip unsupported marks but keep the node.
            if (Array.isArray(node.marks) && node.marks.length > 0) {
                const filteredMarks = node.marks.filter((mark)=>mark && (0, $ftIY0.SUPPORTED_MARK_TYPES).has(mark.type));
                if (filteredMarks.length === node.marks.length) // Nothing to strip — keep node identity (returning the same node
                // reference signals "no change" to the traversal).
                return node;
                if (filteredMarks.length === 0) {
                    // Avoid leaving an empty `marks: []` on the output.
                    const { marks: _marks, ...rest } = node;
                    return rest;
                }
                return {
                    ...node,
                    marks: filteredMarks
                };
            }
            return node;
        }
    });
    return result === false ? undefined : result;
};
module.exports["filterToMarkdownSafeAdf"] = $fbc0577d3febc813$export$796ad20fc99717ad;

});

parcelRegister("ftIY0", function(module, exports) {
/**
 * Shared source-of-truth for which ADF nodes / marks are losslessly
 * representable in our markdown pipeline. Used by:
 *
 *  - `isMarkdownConversionLossyLocal(adf)` — local predicate that decides
 *    whether the rich-text → markdown confirmation dialog should be shown.
 *  - `filterToMarkdownSafeAdf(adf)`   — transformer that strips unsupported
 *    nodes / marks before we replace the document on convert.
 *
 * The pipeline opts into these GFM extensions on top of CommonMark:
 *   - TablesExtension          (GFM §4.10)
 *   - TaskListItemsExtension   (GFM §5.3)
 *   - StrikethroughExtension   (GFM §6.5)
 *   - AutolinkExtension        (GFM §6.9)
 */ const $bbb67cdc72502262$export$5970427aa01c4899 = new Set([
    // Document root
    'doc',
    // Block
    'paragraph',
    'heading',
    'blockquote',
    'codeBlock',
    'bulletList',
    'orderedList',
    'listItem',
    'rule',
    // GFM table (basic — see merged-cell check at the call site)
    'table',
    'tableRow',
    'tableHeader',
    'tableCell',
    // GFM task list items (rendered as `- [ ]` / `- [x]`)
    'taskList',
    'taskItem',
    // Media — only the `mediaSingle` wrapper + its `media` child are supported.
    // `mediaGroup`, `mediaInline`, and captioned `mediaSingleCaption` are NOT
    // in this set: they have no lossless CommonMark/GFM representation, so we
    // drop them via `filterToMarkdownSafeAdf` rather than silently degrading.
    //
    // `media` itself round-trips as a CommonMark image (`![alt](url)`):
    //   - `type: 'external'` — URL is the public `attrs.url`.
    //   - `type: 'file'`     — URL is the tenant Confluence proxy URL
    //                          (`/wiki/download/attachments/{contentId}/{filename}`)
    //                          built by an injected serialiser. No media tokens
    //                          ever land in the markdown text — the renderer's
    //                          session cookie auths the proxy fetch.
    'mediaSingle',
    'media',
    // Inline
    'text',
    'hardBreak'
]);
const $bbb67cdc72502262$export$d79bb6026ae1b0e = new Set([
    ...$bbb67cdc72502262$export$5970427aa01c4899,
    // Smart links degrade to regular Markdown links. The conversion is still
    // lossy because rich smartlink rendering is not represented in GFM, but the
    // URL should survive the rich-text -> markdown conversion.
    'inlineCard'
]);
const $bbb67cdc72502262$export$a9a2d20833ede9a6 = new Set([
    'em',
    'strong',
    'strike',
    'code',
    'link'
]);
const $bbb67cdc72502262$export$64c6f110c3ddfdf0 = (node)=>{
    const colspan = node.attrs?.colspan;
    const rowspan = node.attrs?.rowspan;
    return typeof colspan === 'number' && colspan > 1 || typeof rowspan === 'number' && rowspan > 1;
};
module.exports["SUPPORTED_NODE_TYPES"] = $bbb67cdc72502262$export$5970427aa01c4899;
module.exports["MARKDOWN_SERIALIZABLE_NODE_TYPES"] = $bbb67cdc72502262$export$d79bb6026ae1b0e;
module.exports["SUPPORTED_MARK_TYPES"] = $bbb67cdc72502262$export$a9a2d20833ede9a6;
module.exports["hasMergedCellSpan"] = $bbb67cdc72502262$export$64c6f110c3ddfdf0;

});

parcelRegister("8cRVT", function(module, exports) {

var $4EPzQ = parcelRequire("4EPzQ");


var $c0rhi = parcelRequire("c0rhi");


var $ge2sX = parcelRequire("ge2sX");


var $ftIY0 = parcelRequire("ftIY0");


var $knBoM = parcelRequire("knBoM");

/**
 * Returns `true` when the supplied document contains nodes / marks that don't
 * round-trip cleanly into the markdown pipeline (panels, expands, layouts,
 * status, date, mention, smart cards, media, custom marks, tables with merged
 * cells, etc.). Callers use this to decide whether to surface a confirmation
 * dialog before kicking off a rich-text → markdown conversion.
 *
 * The decision is based purely on **node `type`** and **mark `type`** — the
 * content of supported nodes is irrelevant.
 *
 * Keep this check stricter than `filterToMarkdownSafeAdf`: some nodes, such as
 * `inlineCard`, are safe to pass to the markdown serializer because the URL can
 * degrade to a regular Markdown link, but the rich smart-link rendering is
 * still lost. Those nodes should continue to trigger the confirmation dialog.
 */ const $3408489e988a2177$var$isNodeLossy = (node)=>{
    if (!(0, $ftIY0.SUPPORTED_NODE_TYPES).has(node.type)) return true;
    if (Array.isArray(node.marks)) for (const mark of node.marks){
        if (mark && !(0, $ftIY0.SUPPORTED_MARK_TYPES).has(mark.type)) return true;
    }
    if ((node.type === 'tableCell' || node.type === 'tableHeader') && (0, $ftIY0.hasMergedCellSpan)(node)) return true;
    return false;
};
const $3408489e988a2177$export$38a08ed0b4959725 = (adf)=>{
    if (adf === undefined || adf === null) return false;
    if (typeof adf !== 'object' || typeof adf.type !== 'string') return false;
    return (0, $4EPzQ.reduce)(adf, (acc, node)=>acc || $3408489e988a2177$var$isNodeLossy(node), false);
};
const $3408489e988a2177$var$isMarkdownConversionLossyGraphql = async (contentId)=>{
    try {
        const { cloudId: cloudId } = await (0, $ge2sX.getSessionData)();
        if (!cloudId) return undefined;
        const { data: data } = await (0, $c0rhi.queryInterop)({
            query: (0, $knBoM.ValidateConvertPageToMarkdownModeQuery),
            variables: {
                cloudId: cloudId,
                contentId: contentId
            },
            fetchPolicy: 'network-only',
            interopApolloAggClient: true,
            __callerPackage__: "content-markdown-mode"
        });
        const isLossless = data?.confluence_validateConvertPageToMarkdownMode?.isLossless;
        return typeof isLossless === 'boolean' ? !isLossless : undefined;
    } catch  {
        return undefined;
    }
};
const $3408489e988a2177$export$9477c765bd6693f4 = async (adf, contentId)=>{
    if (contentId) {
        const graphqlResult = await $3408489e988a2177$var$isMarkdownConversionLossyGraphql(contentId);
        if (typeof graphqlResult === 'boolean') return graphqlResult;
    }
    return $3408489e988a2177$export$38a08ed0b4959725(adf);
};
module.exports["isMarkdownConversionLossy"] = $3408489e988a2177$export$9477c765bd6693f4;

});

parcelRegister("knBoM", function(module, exports) {

var $5vrKv = parcelRequire("5vrKv");

const $eae5d89f0551e425$export$db295ff502a9150a = (0, $5vrKv.default);
module.exports["ValidateConvertPageToMarkdownModeQuery"] = $eae5d89f0551e425$export$db295ff502a9150a;

});

parcelRegister("5vrKv", function(module, exports) {
/**
 * @generated SignedSource<<3051a9bd301cd38cb8cb6ed83844353a>>
 * @relayHash 5f62c435dcac8baaf0c8fe7285050069
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f2eabe404746fdc5ee133f0a7e9771978eede747044e4df12abad078af3528bd
const $f88b9492edf7e7b7$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ConfluenceValidateConvertPageToMarkdownModeResult",
            "kind": "LinkedField",
            "name": "confluence_validateConvertPageToMarkdownMode",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isLossless"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ValidateConvertPageToMarkdownModeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ValidateConvertPageToMarkdownModeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "5f62c435dcac8baaf0c8fe7285050069",
            "id": "f2eabe404746fdc5ee133f0a7e9771978eede747044e4df12abad078af3528bd",
            "metadata": {},
            "name": "ValidateConvertPageToMarkdownModeQuery",
            "operationKind": "query",
            "text": "query ValidateConvertPageToMarkdownModeQuery($cloudId:ID!,$contentId:ID!){confluence_validateConvertPageToMarkdownMode(cloudId:$cloudId,contentId:$contentId){isLossless}}"
        }
    };
}();
$f88b9492edf7e7b7$var$node.hash = "492958e6bac166c062e3d8a2a17a0d5c";
var $f88b9492edf7e7b7$export$2e2bcd8739ae039 = $f88b9492edf7e7b7$var$node;
module.exports["default"] = $f88b9492edf7e7b7$export$2e2bcd8739ae039;

});

parcelRegister("fEvT8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $i1t43 = parcelRequire("i1t43");

const $a3779901118e4ab6$var$i18n = (0, $kSwu1.defineMessages)({
    convertToMarkdownError: {
        id: "content-markdown-mode.use-markdown-mode-actions.convert-to-markdown-error",
        defaultMessage: "Failed to convert to markdown"
    },
    convertToRichTextError: {
        id: "content-markdown-mode.use-markdown-mode-actions.convert-to-rich-text-error",
        defaultMessage: "Failed to convert to rich text"
    },
    convertToMarkdownSuccessTitle: {
        id: "content-markdown-mode.use-markdown-mode-actions.convert-to-markdown-success.title",
        defaultMessage: "You\u2019ve converted to markdown"
    },
    convertToMarkdownSuccessBody: {
        id: "content-markdown-mode.use-markdown-mode-actions.convert-to-markdown-success.body",
        defaultMessage: "Edits to this doc are now made in markdown."
    },
    findOutMoreAboutMarkdown: {
        id: "content-markdown-mode.use-markdown-mode-actions.find-out-more.markdown",
        defaultMessage: "Find out more about markdown"
    },
    convertToRichTextSuccessTitle: {
        id: "content-markdown-mode.use-markdown-mode-actions.convert-to-rich-text-success.title",
        defaultMessage: "You\u2019ve converted to a live doc"
    },
    convertToRichTextSuccessBody: {
        id: "content-markdown-mode.use-markdown-mode-actions.convert-to-rich-text-success.body",
        defaultMessage: "Updates to this doc will now be instant and visible in real time."
    },
    findOutMoreAboutLiveDocs: {
        id: "content-markdown-mode.use-markdown-mode-actions.find-out-more.live-docs",
        defaultMessage: "Find out more about live docs"
    }
});
const $a3779901118e4ab6$var$LIVE_DOCS_LEARN_MORE_URL = 'https://support.atlassian.com/confluence-cloud/docs/create-and-collaborate-in-real-time-with-live-docs/';
const $a3779901118e4ab6$var$MARKDOWN_LEARN_MORE_URL = 'https://support.atlassian.com/confluence-cloud/docs/keyboard-shortcuts-markdown-and-autocomplete/';
// Matches the page → live-doc convert success flag.
const $a3779901118e4ab6$var$CONVERT_SUCCESS_FLAG_AUTO_CLOSE_MS = 11000;
const $a3779901118e4ab6$export$6cae3f92397e1d6d = (flags)=>{
    const intl = (0, $kSwu1.useIntl)();
    return (0, $cozmU.useMemo)(()=>({
            showError: (direction)=>{
                if (!flags.showErrorFlag) return;
                const message = direction === 'toMarkdown' ? $a3779901118e4ab6$var$i18n.convertToMarkdownError : $a3779901118e4ab6$var$i18n.convertToRichTextError;
                flags.showErrorFlag({
                    title: intl.formatMessage(message)
                });
            },
            showSuccess: (direction)=>{
                if (!flags.showFlag) return;
                const isToMarkdown = direction === 'toMarkdown';
                const flagId = isToMarkdown ? 'content-markdown-mode-convert-to-markdown-flag' : 'content-markdown-mode-convert-to-rich-text-flag';
                const learnMoreUrl = isToMarkdown ? $a3779901118e4ab6$var$MARKDOWN_LEARN_MORE_URL : $a3779901118e4ab6$var$LIVE_DOCS_LEARN_MORE_URL;
                const titleMessage = isToMarkdown ? $a3779901118e4ab6$var$i18n.convertToMarkdownSuccessTitle : $a3779901118e4ab6$var$i18n.convertToRichTextSuccessTitle;
                const bodyMessage = isToMarkdown ? $a3779901118e4ab6$var$i18n.convertToMarkdownSuccessBody : $a3779901118e4ab6$var$i18n.convertToRichTextSuccessBody;
                const learnMoreMessage = isToMarkdown ? $a3779901118e4ab6$var$i18n.findOutMoreAboutMarkdown : $a3779901118e4ab6$var$i18n.findOutMoreAboutLiveDocs;
                flags.showFlag({
                    id: flagId,
                    type: 'success',
                    title: intl.formatMessage(titleMessage),
                    description: intl.formatMessage(bodyMessage),
                    // Survive the editor-unmount `hideAllFlags()` during the
                    // conversion remount — we dismiss manually below.
                    close: 'never',
                    actions: [
                        {
                            // Real anchor via `@atlaskit/link` — browser owns
                            // navigation. `rel="noopener noreferrer"` prevents
                            // tabnabbing (canonical Confluence pattern, see
                            // `editor-flags/buildEditorFlagMessage.tsx`).
                            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                                href: learnMoreUrl,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                appearance: "subtle"
                            }, intl.formatMessage(learnMoreMessage)),
                            onClick: ()=>{}
                        }
                    ]
                });
                setTimeout(()=>flags.hideFlag?.(flagId), $a3779901118e4ab6$var$CONVERT_SUCCESS_FLAG_AUTO_CLOSE_MS);
            }
        }), [
        flags,
        intl
    ]);
};
module.exports["useMarkdownConvertFlags"] = $a3779901118e4ab6$export$6cae3f92397e1d6d;

});

parcelRegister("6eFi0", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $ad336c78e6fcf61a$export$492577bc4a81367b = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "seFL5",
    name: "ResolvedInlineCommentsDialogLoader",
    loader: async ()=>(await (parcelRequire("lgo3r"))).ResolvedInlineCommentsDialog
});
module.exports["ResolvedInlineCommentsDialogLoader"] = $ad336c78e6fcf61a$export$492577bc4a81367b;

});

parcelRegister("lgo3r", function(module, exports) {

let $f7adc0528c9673fc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f7adc0528c9673fc$var$load("fky9A"),
    $f7adc0528c9673fc$var$load("gbis9"),
    $f7adc0528c9673fc$var$load("lkHIj"),
    $f7adc0528c9673fc$var$load("b8BFA"),
    $f7adc0528c9673fc$var$load("7BHAC"),
    $f7adc0528c9673fc$var$load("N3TvS"),
    $f7adc0528c9673fc$var$load("7g00Y"),
    $f7adc0528c9673fc$var$load("6MdJu"),
    $f7adc0528c9673fc$var$load("lK9vp"),
    $f7adc0528c9673fc$var$load("53Y0O"),
    $f7adc0528c9673fc$var$load("kYlwR"),
    $f7adc0528c9673fc$var$load("50xKF"),
    $f7adc0528c9673fc$var$load("1GCFv"),
    $f7adc0528c9673fc$var$load("cJsay"),
    $f7adc0528c9673fc$var$load("cIET7"),
    $f7adc0528c9673fc$var$load("RylUf"),
    $f7adc0528c9673fc$var$load("4AElS"),
    $f7adc0528c9673fc$var$load("1cQg7"),
    $f7adc0528c9673fc$var$load("eUsnQ"),
    $f7adc0528c9673fc$var$load("L98h8"),
    $f7adc0528c9673fc$var$load("dfVn7"),
    $f7adc0528c9673fc$var$load("aEiTV"),
    $f7adc0528c9673fc$var$load("fEhMd"),
    $f7adc0528c9673fc$var$load("aCJpU"),
    $f7adc0528c9673fc$var$load("aLwQm"),
    $f7adc0528c9673fc$var$load("kHXvF"),
    $f7adc0528c9673fc$var$load("6wr18"),
    $f7adc0528c9673fc$var$load("Wowvf"),
    $f7adc0528c9673fc$var$load("7gL7H"),
    $f7adc0528c9673fc$var$load("hhss7"),
    $f7adc0528c9673fc$var$load("lrmeP"),
    $f7adc0528c9673fc$var$load("6fY3H"),
    $f7adc0528c9673fc$var$load("dtNxV"),
    $f7adc0528c9673fc$var$load("jXx9i"),
    $f7adc0528c9673fc$var$load("e3Gt5"),
    $f7adc0528c9673fc$var$load("9zpfi"),
    $f7adc0528c9673fc$var$load("9pNir"),
    $f7adc0528c9673fc$var$load("a7sEM"),
    $f7adc0528c9673fc$var$load("ffEVr"),
    $f7adc0528c9673fc$var$load("a6kGP"),
    $f7adc0528c9673fc$var$load("dB5kj"),
    $f7adc0528c9673fc$var$load("kDVdu"),
    $f7adc0528c9673fc$var$load("8Jd6S"),
    $f7adc0528c9673fc$var$load("dIY7W"),
    $f7adc0528c9673fc$var$load("8lMr1"),
    $f7adc0528c9673fc$var$load("1vUE6"),
    $f7adc0528c9673fc$var$load("ckGjo"),
    $f7adc0528c9673fc$var$load("1sii7"),
    $f7adc0528c9673fc$var$load("fEvpQ"),
    $f7adc0528c9673fc$var$load("kGmwI"),
    $f7adc0528c9673fc$var$load("fWCBZ"),
    $f7adc0528c9673fc$var$load("7A87G"),
    $f7adc0528c9673fc$var$load("75JEs"),
    $f7adc0528c9673fc$var$load("lywre"),
    $f7adc0528c9673fc$var$load("43z9c"),
    $f7adc0528c9673fc$var$load("kT6dz"),
    $f7adc0528c9673fc$var$load("aAWLw"),
    $f7adc0528c9673fc$var$load("7EorR"),
    $f7adc0528c9673fc$var$load("hOsjc")
]).then(()=>parcelRequire('92Mdh'));

});

parcelRegister("bzwhi", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $67Foi = parcelRequire("67Foi");


var $lsxnT = parcelRequire("lsxnT");


var $dINOl = parcelRequire("dINOl");


var $1j3IV = parcelRequire("1j3IV");


var $4R0nV = parcelRequire("4R0nV");


var $4TcLf = parcelRequire("4TcLf");


var $4ZXww = parcelRequire("4ZXww");


var $kSwrz = parcelRequire("kSwrz");

var $2347032a59a3f6fa$export$6054829ec0b77d62 = /*#__PURE__*/ function(MoreActionsObjectSidebarTourSteps) {
    MoreActionsObjectSidebarTourSteps[MoreActionsObjectSidebarTourSteps["FIRST"] = 0] = "FIRST";
    return MoreActionsObjectSidebarTourSteps;
}({});
const $2347032a59a3f6fa$var$i18n = (0, $kSwu1.defineMessages)({
    ok: {
        id: "object-sidebar-components.more-actions.tour.ok",
        defaultMessage: "OK"
    },
    getTheDetailsYouNeed: {
        id: "object-sidebar-components.more-actions.tour.get-the-details-you-need",
        defaultMessage: "Get the details you need"
    },
    viewAndManageOwnership: {
        id: "object-sidebar-components.more-actions.tour.view-and-manage-ownership",
        defaultMessage: "View and manage ownership, labels, and more in a single panel."
    }
});
const $2347032a59a3f6fa$var$MORE_ACTIONS_OBJECT_SIDEBAR_SPOTLIGHT_NAME = 'more-actions-object-sidebar-spotlight';
const $2347032a59a3f6fa$var$useSpotlights = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { end: end } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const theme = (0, $IQ4Dz.useThemeObserver)();
    const GetTheDetailsYouNeedGif = theme.colorMode === "dark" ? (0, (/*@__PURE__*/$parcel$interopDefault($1j3IV))) : (0, (/*@__PURE__*/$parcel$interopDefault($4R0nV)));
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage($2347032a59a3f6fa$var$i18n.ok);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== end || $[3] !== t1) {
        t2 = [
            {
                onClick: end,
                text: t1
            }
        ];
        $[2] = end;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== formatMessage) {
        t3 = formatMessage($2347032a59a3f6fa$var$i18n.getTheDetailsYouNeed);
        $[5] = formatMessage;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== end) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dINOl.CrossIconCloseButton), {
            onClose: end,
            source: $2347032a59a3f6fa$var$MORE_ACTIONS_OBJECT_SIDEBAR_SPOTLIGHT_NAME
        });
        $[7] = end;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== formatMessage) {
        t5 = formatMessage($2347032a59a3f6fa$var$i18n.viewAndManageOwnership);
        $[9] = formatMessage;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== GetTheDetailsYouNeedGif || $[12] !== t2 || $[13] !== t3 || $[14] !== t4 || $[15] !== t5) {
        t6 = [
            {
                key: (0, $4ZXww.OBJECT_SIDEBAR_TOUR_TARGETS).SIDEBAR_DETAILS_BUTTON,
                target: (0, $4ZXww.OBJECT_SIDEBAR_TOUR_TARGETS).SIDEBAR_DETAILS_BUTTON,
                targetRadius: 3,
                actions: t2,
                image: GetTheDetailsYouNeedGif,
                dialogWidth: 341,
                heading: t3,
                headingAfterElement: t4,
                children: t5
            }
        ];
        $[11] = GetTheDetailsYouNeedGif;
        $[12] = t2;
        $[13] = t3;
        $[14] = t4;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    return t6;
} : ({ end: end })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const theme = (0, $IQ4Dz.useThemeObserver)();
    const GetTheDetailsYouNeedGif = theme.colorMode === 'dark' ? (0, (/*@__PURE__*/$parcel$interopDefault($1j3IV))) : (0, (/*@__PURE__*/$parcel$interopDefault($4R0nV)));
    return [
        {
            key: (0, $4ZXww.OBJECT_SIDEBAR_TOUR_TARGETS).SIDEBAR_DETAILS_BUTTON,
            target: (0, $4ZXww.OBJECT_SIDEBAR_TOUR_TARGETS).SIDEBAR_DETAILS_BUTTON,
            targetRadius: 3,
            actions: [
                {
                    onClick: end,
                    text: formatMessage($2347032a59a3f6fa$var$i18n.ok)
                }
            ],
            image: GetTheDetailsYouNeedGif,
            dialogWidth: 341,
            heading: formatMessage($2347032a59a3f6fa$var$i18n.getTheDetailsYouNeed),
            headingAfterElement: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dINOl.CrossIconCloseButton), {
                onClose: end,
                source: $2347032a59a3f6fa$var$MORE_ACTIONS_OBJECT_SIDEBAR_SPOTLIGHT_NAME
            }),
            children: formatMessage($2347032a59a3f6fa$var$i18n.viewAndManageOwnership)
        }
    ];
};
const $2347032a59a3f6fa$var$FLOATING_ACTION_BAR_CHANGEBOARDING = 'floatingActionBarChangeboarding';
const $2347032a59a3f6fa$var$SCREEN_EVENT_SUBJECTS = [
    $2347032a59a3f6fa$var$FLOATING_ACTION_BAR_CHANGEBOARDING
];
const $2347032a59a3f6fa$export$4ead2825721da9b4 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { step: step } = t0;
    const [t1, t2] = (0, $4TcLf.useMoreActionsObjectSidebarTourState)();
    const { activeSpotlightIndex: activeSpotlightIndex, lastActiveSpotlightIndex: lastActiveSpotlightIndex } = t1;
    const { concludeTour: endTour, initiateTour: initiateTour, resetTour: resetTour } = t2;
    const [messageType] = (0, $cozmU.useState)((0, $kSwrz.MessageType).Transactional);
    const { Spotlight: Spotlight } = (0, $lsxnT.useChoreographerAssets)();
    let t3;
    if ($[0] !== endTour) {
        t3 = ()=>{
            endTour();
        };
        $[0] = endTour;
        $[1] = t3;
    } else t3 = $[1];
    const concludeTour = t3;
    let t4;
    if ($[2] !== concludeTour) {
        t4 = {
            end: concludeTour
        };
        $[2] = concludeTour;
        $[3] = t4;
    } else t4 = $[3];
    const spotlights = $2347032a59a3f6fa$var$useSpotlights(t4);
    let t5;
    if ($[4] !== Spotlight || $[5] !== activeSpotlightIndex || $[6] !== messageType || $[7] !== spotlights || $[8] !== step) {
        t5 = activeSpotlightIndex === step ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Spotlight, {
            messageType: messageType,
            shouldWatchTarget: true,
            dialogPlacement: "left bottom",
            targetBgColor: "var(--ds-surface-overlay, #FFFFFF)",
            ...spotlights[activeSpotlightIndex]
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $67Foi.ScreenEvent), {
            id: $2347032a59a3f6fa$var$SCREEN_EVENT_SUBJECTS[activeSpotlightIndex],
            name: $2347032a59a3f6fa$var$SCREEN_EVENT_SUBJECTS[activeSpotlightIndex]
        })) : null;
        $[4] = Spotlight;
        $[5] = activeSpotlightIndex;
        $[6] = messageType;
        $[7] = spotlights;
        $[8] = step;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== activeSpotlightIndex || $[11] !== concludeTour || $[12] !== initiateTour || $[13] !== lastActiveSpotlightIndex || $[14] !== resetTour || $[15] !== t5) {
        t6 = {
            activeSpotlight: t5,
            initiateTour: initiateTour,
            concludeTour: concludeTour,
            resetTour: resetTour,
            activeSpotlightIndex: activeSpotlightIndex,
            lastActiveSpotlightIndex: lastActiveSpotlightIndex
        };
        $[10] = activeSpotlightIndex;
        $[11] = concludeTour;
        $[12] = initiateTour;
        $[13] = lastActiveSpotlightIndex;
        $[14] = resetTour;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    return t6;
} : ({ step: step })=>{
    const [{ activeSpotlightIndex: activeSpotlightIndex, lastActiveSpotlightIndex: lastActiveSpotlightIndex }, { concludeTour: endTour, initiateTour: initiateTour, resetTour: resetTour }] = (0, $4TcLf.useMoreActionsObjectSidebarTourState)();
    const [messageType, _] = (0, $cozmU.useState)((0, $kSwrz.MessageType).Transactional);
    const { Spotlight: Spotlight } = (0, $lsxnT.useChoreographerAssets)();
    const concludeTour = (0, $cozmU.useCallback)(()=>{
        endTour();
    }, [
        endTour
    ]);
    const spotlights = $2347032a59a3f6fa$var$useSpotlights({
        end: concludeTour
    });
    return {
        activeSpotlight: activeSpotlightIndex === step ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Spotlight, {
            messageType: messageType,
            shouldWatchTarget: true,
            dialogPlacement: "left bottom",
            targetBgColor: "var(--ds-surface-overlay, #FFFFFF)",
            ...spotlights[activeSpotlightIndex]
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $67Foi.ScreenEvent), {
            id: $2347032a59a3f6fa$var$SCREEN_EVENT_SUBJECTS[activeSpotlightIndex],
            name: $2347032a59a3f6fa$var$SCREEN_EVENT_SUBJECTS[activeSpotlightIndex]
        })) : null,
        initiateTour: initiateTour,
        concludeTour: concludeTour,
        resetTour: resetTour,
        activeSpotlightIndex: activeSpotlightIndex,
        lastActiveSpotlightIndex: lastActiveSpotlightIndex
    };
};
module.exports["MoreActionsObjectSidebarTourSteps"] = $2347032a59a3f6fa$export$6054829ec0b77d62;
module.exports["useMoreActionsObjectSidebarTour"] = $2347032a59a3f6fa$export$4ead2825721da9b4;

});

parcelRegister("dINOl", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $l3wuH = parcelRequire("l3wuH");


var $9DHhW = parcelRequire("9DHhW");

const $732e88608cb14d24$export$f56d620db6064703 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { onClose: onClose, source: source } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== onClose || $[2] !== source) {
        t1 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "dismiss",
                    source: source
                }
            }).fire();
            onClose();
        };
        $[0] = createAnalyticsEvent;
        $[1] = onClose;
        $[2] = source;
        $[3] = t1;
    } else t1 = $[3];
    const handleClick = t1;
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $732e88608cb14d24$var$messages.dismiss);
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== handleClick) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: $732e88608cb14d24$var$_temp,
            appearance: "subtle",
            label: t2,
            onClick: handleClick
        });
        $[5] = handleClick;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ onClose: onClose, source: source })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const handleClick = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'dismiss',
                source: source
            }
        }).fire();
        onClose();
    }, [
        onClose,
        createAnalyticsEvent,
        source
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                ...iconProps,
                color: "var(--ds-icon-inverse, #FFFFFF)"
            }),
        appearance: "subtle",
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $732e88608cb14d24$var$messages.dismiss),
        onClick: handleClick
    });
};
const $732e88608cb14d24$var$messages = (0, $kSwu1.defineMessages)({
    dismiss: {
        id: "object-sidebar-components.cross-icon-close-button.dismiss",
        defaultMessage: "Dismiss"
    }
});
function $732e88608cb14d24$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
        ...iconProps,
        color: "var(--ds-icon-inverse, #FFFFFF)"
    });
}
module.exports["CrossIconCloseButton"] = $732e88608cb14d24$export$f56d620db6064703;

});

parcelRegister("1j3IV", function(module, exports) {
module.exports = new URL("GetTheDetailsYouNeedDark.bbe9839d.gif", import.meta.url).toString();

});

parcelRegister("4R0nV", function(module, exports) {
module.exports = new URL("GetTheDetailsYouNeedLight.9900190e.gif", import.meta.url).toString();

});

parcelRegister("4TcLf", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $2cb4928bb9fae204$var$initialState = {
    activeSpotlightIndex: null,
    lastActiveSpotlightIndex: null
};
const $2cb4928bb9fae204$var$Store = (0, $8s9DV.createStore)({
    initialState: $2cb4928bb9fae204$var$initialState,
    actions: {
        goToStep: (nextStep)=>({ setState: setState })=>{
                setState({
                    activeSpotlightIndex: nextStep
                });
            },
        resetTour: ()=>({ setState: setState })=>{
                setState($2cb4928bb9fae204$var$initialState);
            },
        initiateTour: ()=>({ setState: setState })=>{
                setState({
                    activeSpotlightIndex: 0
                });
            },
        proceedToNext: ()=>({ setState: setState, getState: getState })=>{
                const { activeSpotlightIndex: activeSpotlightIndex } = getState();
                if (activeSpotlightIndex === null) return;
                setState({
                    activeSpotlightIndex: activeSpotlightIndex + 1,
                    lastActiveSpotlightIndex: activeSpotlightIndex
                });
            },
        concludeTour: ()=>({ setState: setState, getState: getState })=>{
                const { activeSpotlightIndex: activeSpotlightIndex } = getState();
                setState({
                    activeSpotlightIndex: null,
                    lastActiveSpotlightIndex: activeSpotlightIndex
                });
            }
    }
});
const $2cb4928bb9fae204$export$2488884e040ac8b3 = (0, $kBr4q.createHook)($2cb4928bb9fae204$var$Store);
const $2cb4928bb9fae204$export$66587c60bfe17f2b = (0, $kBr4q.createActionsHook)($2cb4928bb9fae204$var$Store);
module.exports["useMoreActionsObjectSidebarTourState"] = $2cb4928bb9fae204$export$2488884e040ac8b3;

});

parcelRegister("4ZXww", function(module, exports) {
const $6699361aa30cfc48$var$OBJECT_SIDEBAR_TOUR_TARGET_PREFIX = 'object-sidebar-tour-target:';
const $6699361aa30cfc48$export$461ea60ca403d592 = {
    MORE_ACTIONS_ITEMS: `${$6699361aa30cfc48$var$OBJECT_SIDEBAR_TOUR_TARGET_PREFIX}more-actions-items`,
    OBJECT_SIDEBAR_CONTROL: `${$6699361aa30cfc48$var$OBJECT_SIDEBAR_TOUR_TARGET_PREFIX}object-sidebar-control`,
    SIDEBAR_DETAILS_BUTTON: `${$6699361aa30cfc48$var$OBJECT_SIDEBAR_TOUR_TARGET_PREFIX}sidebar-details-button`
};
module.exports["OBJECT_SIDEBAR_TOUR_TARGETS"] = $6699361aa30cfc48$export$461ea60ca403d592;

});

parcelRegister("kSwrz", function(module, exports) {
var $c5d0a4f039ea82e6$export$80edbf15fa61a4db = /*#__PURE__*/ function(MessageType) {
    MessageType["Engagement"] = "engagement";
    MessageType["Transactional"] = "transactional";
    return MessageType;
}({});
module.exports["MessageType"] = $c5d0a4f039ea82e6$export$80edbf15fa61a4db;

});

parcelRegister("g95v4", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $8aF6s = parcelRequire("8aF6s");


var $bjj9l = parcelRequire("bjj9l");

const $4f70211624fcedf9$export$7098d17bb6837941 = ()=>{
    const $ = (0, $bDgLe.c)(2);
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    let t0;
    if ($[0] !== showModal) {
        t0 = (t1)=>{
            const options = t1 === undefined ? {} : t1;
            showModal((0, $bjj9l.AgentsAwarenessModalLoadable), {
                ...options,
                messageType: "transactional"
            });
        };
        $[0] = showModal;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
module.exports["useOpenAgentsAwarenessModal"] = $4f70211624fcedf9$export$7098d17bb6837941;

});

parcelRegister("bjj9l", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $7ff73ce59b909ea5$export$ac9258c1e2a42c0e = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "U0FPT",
    name: "AgentsAwarenessModalLoadable",
    loader: async ()=>(await (parcelRequire("ikkFW"))).AgentsAwarenessModalConnected
});
module.exports["AgentsAwarenessModalLoadable"] = $7ff73ce59b909ea5$export$ac9258c1e2a42c0e;

});

parcelRegister("ikkFW", function(module, exports) {

let $d57a21fd4797db67$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d57a21fd4797db67$var$load("64FEU"),
    $d57a21fd4797db67$var$load("h0X0x"),
    $d57a21fd4797db67$var$load("7l4Nc"),
    $d57a21fd4797db67$var$load("fEvpQ"),
    $d57a21fd4797db67$var$load("dlYE2"),
    $d57a21fd4797db67$var$load("60a9E"),
    $d57a21fd4797db67$var$load("7EorR"),
    $d57a21fd4797db67$var$load("jqoep"),
    $d57a21fd4797db67$var$load("6wr18"),
    $d57a21fd4797db67$var$load("59hV4"),
    $d57a21fd4797db67$var$load("cN2rp"),
    $d57a21fd4797db67$var$load("VXbA1"),
    $d57a21fd4797db67$var$load("ffEVr"),
    $d57a21fd4797db67$var$load("31AYA"),
    $d57a21fd4797db67$var$load("n2DB9"),
    $d57a21fd4797db67$var$load("4jVw5")
]).then(()=>parcelRequire('8WeUp'));

});

parcelRegister("jh2Zn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::77b3b779f37199a8c52774c0643da229>>
 * @codegenCommand afm workspace @atlassian/logo-third-party generate:components
 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $bD1F5 = parcelRequire("bD1F5");

const $0983d2d116935ae4$var$markup = '<svg width="100%" height="100%" fill="none" viewBox="0 0 48 48"><path fill="#26251e" d="M36.674 16.124 24.625 9.168a1.25 1.25 0 0 0-1.251 0l-12.05 6.956a1.05 1.05 0 0 0-.525.912v14.028c0 .376.2.723.526.91l12.05 6.958c.386.223.864.223 1.25 0l12.05-6.957c.325-.188.526-.535.526-.911V17.035c0-.376-.2-.723-.526-.91m-.757 1.474L24.286 37.745c-.079.136-.287.08-.287-.077V24.476a.74.74 0 0 0-.369-.64L12.206 17.24c-.136-.078-.08-.286.077-.286h23.264a.43.43 0 0 1 .371.644"/></svg>';
function $0983d2d116935ae4$export$8ce9a6eef5b50cda({ size: size, label: label = 'Cursor', testId: testId, type: type, UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bD1F5.ThirdPartyLogoWrapper), {
        markup: $0983d2d116935ae4$var$markup,
        label: label,
        size: size,
        testId: testId,
        type: type,
        UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry
    });
}
module.exports["CursorIcon"] = $0983d2d116935ae4$export$8ce9a6eef5b50cda;

});

parcelRegister("hL4RO", function(module, exports) {
// Slack Connect web-item ids are `<addonKey>__<moduleKey>`. The addon key is bare in prod but
// suffixed on non-prod installs (e.g. `-ddev`, `-stg-east`), so match on prefix + module suffix.
const $655d13c70191fa8e$var$SLACK_CONNECT_APP_ID_PREFIX = 'confluence-chats-integration';
// Module suffixes being deprecated as part of the Connect deprecation. Add future modules here.
const $655d13c70191fa8e$var$DEPRECATED_CONNECT_MODULE_SUFFIXES = [
    '__page-config-dialog-trigger',
    '__profile'
];
const $655d13c70191fa8e$export$66793f50054894c5 = [
    '__space-config-link'
];
const $655d13c70191fa8e$export$2855598082f8f510 = (webItemId, moduleSuffixes = $655d13c70191fa8e$var$DEPRECATED_CONNECT_MODULE_SUFFIXES)=>Boolean(webItemId?.startsWith($655d13c70191fa8e$var$SLACK_CONNECT_APP_ID_PREFIX) && moduleSuffixes.some((suffix)=>webItemId.endsWith(suffix)));
module.exports["DEPRECATED_SPACE_SETTINGS_MODULE_SUFFIXES"] = $655d13c70191fa8e$export$66793f50054894c5;
module.exports["isDeprecatedConnectWebItem"] = $655d13c70191fa8e$export$2855598082f8f510;

});

parcelRegister("d8J72", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $bYLFm = parcelRequire("bYLFm");


var $gjbSq = parcelRequire("gjbSq");


var $b3j2Y = parcelRequire("b3j2Y");


var $3eMfQ = parcelRequire("3eMfQ");

const $6f5c98e13f07416a$export$dc453ea17a7d7b53 = (t0)=>{
    const $ = (0, $bDgLe.c)(30);
    let contentId;
    let dialogs;
    let onClick;
    let props;
    let sectionItem;
    let shouldHighlight;
    let spaceKey;
    if ($[0] !== t0) {
        ({ sectionItem: sectionItem, contentId: contentId, spaceKey: spaceKey, dialogs: dialogs, shouldHighlight: shouldHighlight, onClick: onClick, ...props } = t0);
        $[0] = t0;
        $[1] = contentId;
        $[2] = dialogs;
        $[3] = onClick;
        $[4] = props;
        $[5] = sectionItem;
        $[6] = shouldHighlight;
        $[7] = spaceKey;
    } else {
        contentId = $[1];
        dialogs = $[2];
        onClick = $[3];
        props = $[4];
        sectionItem = $[5];
        shouldHighlight = $[6];
        spaceKey = $[7];
    }
    let t1;
    if ($[8] !== contentId || $[9] !== spaceKey) {
        t1 = {
            contentId: contentId,
            spaceKey: spaceKey
        };
        $[8] = contentId;
        $[9] = spaceKey;
        $[10] = t1;
    } else t1 = $[10];
    const { canConvertPageToFolder: canConvertPageToFolder, contentTitle: contentTitle, error: error } = (0, $gjbSq.useCanConvertPageToFolder)(t1);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t2;
    if ($[11] !== contentId || $[12] !== contentTitle || $[13] !== createAnalyticsEvent || $[14] !== dialogs || $[15] !== onClick || $[16] !== spaceKey) {
        t2 = (e)=>{
            onClick?.(e);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "convertPageToFolder",
                    source: "contentToolsItem"
                }
            }).fire();
            dialogs.showDialog((0, $bYLFm.ConvertPageToFolderDialog), {
                contentId: contentId,
                spaceKey: spaceKey,
                contentTitle: contentTitle
            });
        };
        $[11] = contentId;
        $[12] = contentTitle;
        $[13] = createAnalyticsEvent;
        $[14] = dialogs;
        $[15] = onClick;
        $[16] = spaceKey;
        $[17] = t2;
    } else t2 = $[17];
    const openDialog = t2;
    if (!canConvertPageToFolder) {
        let t3;
        if ($[18] !== error) {
            t3 = error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: error
            }) : null;
            $[18] = error;
            $[19] = t3;
        } else t3 = $[19];
        return t3;
    }
    let t3;
    if ($[20] !== error) {
        t3 = error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        });
        $[20] = error;
        $[21] = t3;
    } else t3 = $[21];
    let t4;
    if ($[22] !== openDialog || $[23] !== props || $[24] !== sectionItem || $[25] !== shouldHighlight) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3eMfQ.LazyContentToolsItem), {
            key: sectionItem.completeKey,
            ...sectionItem,
            url: "",
            ...props,
            onClick: openDialog,
            shouldHighlight: shouldHighlight
        });
        $[22] = openDialog;
        $[23] = props;
        $[24] = sectionItem;
        $[25] = shouldHighlight;
        $[26] = t4;
    } else t4 = $[26];
    let t5;
    if ($[27] !== t3 || $[28] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t3, t4);
        $[27] = t3;
        $[28] = t4;
        $[29] = t5;
    } else t5 = $[29];
    return t5;
};
module.exports["ConvertToFolderItem"] = $6f5c98e13f07416a$export$dc453ea17a7d7b53;

});

parcelRegister("bYLFm", function(module, exports) {

var $WfKBt = parcelRequire("WfKBt");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7aRdF = parcelRequire("7aRdF");


var $eQiT1 = parcelRequire("eQiT1");


var $9Umtx = parcelRequire("9Umtx");


var $jq995 = parcelRequire("jq995");


var $fEPJS = parcelRequire("fEPJS");


var $1VhsF = parcelRequire("1VhsF");


var $ad7Ou = parcelRequire("ad7Ou");


var $7joZr = parcelRequire("7joZr");


var $9DHhW = parcelRequire("9DHhW");


var $kA6Zo = parcelRequire("kA6Zo");


var $2wCqQ = parcelRequire("2wCqQ");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $fGzMp = parcelRequire("fGzMp");


var $dPJCf = parcelRequire("dPJCf");


var $67Foi = parcelRequire("67Foi");


var $1NBp8 = parcelRequire("1NBp8");


var $cb6fO = parcelRequire("cb6fO");


var $b3j2Y = parcelRequire("b3j2Y");


var $95rLf = parcelRequire("95rLf");


var $7Sm4c = parcelRequire("7Sm4c");


var $7aRa9 = parcelRequire("7aRa9");


var $6mKj3 = parcelRequire("6mKj3");


var $euL71 = parcelRequire("euL71");


var $bQm3c = parcelRequire("bQm3c");


var $laFNM = parcelRequire("laFNM");


var $308Wd = parcelRequire("308Wd");

const $ad7bf5a97d16ed21$var$COMPONENT_NAME = 'ConvertPageToFolderDialogModal';
const $ad7bf5a97d16ed21$var$source = 'VIEW_PAGE';
const $ad7bf5a97d16ed21$var$warningMessageStyles = (0, $buxP3.xcss)({
    marginBottom: 'space.100'
});
const $ad7bf5a97d16ed21$export$de0fa8bd80a55013 = 241;
const $ad7bf5a97d16ed21$var$ConvertPageToFolderDialogComponent = ({ spaceKey: spaceKey, contentId: contentId, contentTitle: contentTitle, onClose: onClose, flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const isPremium = edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    const { approvalRequest: approvalRequest } = (0, $laFNM.useApprovals)();
    const hasApprovalReview = Boolean(approvalRequest?.review);
    const [isConverting, setIsConverting] = (0, $cozmU.useState)(false);
    const [convertPageToFolderMutation, { error: convertPageToFolderError }] = (0, $308Wd.useMutationInterop)((0, $WfKBt.default), {
        __callerPackage__: "folder-conversion"
    });
    const handleOnClose = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'clicked',
                actionSubject: $ad7bf5a97d16ed21$var$COMPONENT_NAME,
                actionSubjectId: `${$ad7bf5a97d16ed21$var$COMPONENT_NAME}CancelButton`,
                source: $ad7bf5a97d16ed21$var$source
            }
        }).fire();
        onClose();
    }, [
        createAnalyticsEvent,
        onClose
    ]);
    const convertPageToFolderSuccess = (data)=>{
        setIsConverting(false);
        experienceTracker.succeed({
            name: (0, $irVI7.CONVERT_PAGE_TO_FOLDER_EXPERIENCE)
        });
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                actionSubject: $ad7bf5a97d16ed21$var$COMPONENT_NAME,
                action: 'success',
                attributes: undefined,
                source: $ad7bf5a97d16ed21$var$source
            }
        }).fire();
        flags.showFlag({
            type: 'success-circle',
            title: formatMessage($ad7bf5a97d16ed21$var$i18n.successFlagTitle),
            description: formatMessage($ad7bf5a97d16ed21$var$i18n.successFlagDescription),
            close: 'auto'
        });
        const contentId = data?.data?.convertToFolder?.content?.id;
        if (contentId) {
            const newlyCreatedFolderUrl = (0, $1NBp8.FOLDER_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId,
                contentSlug: (0, $cb6fO.generateSlug)(contentTitle)
            });
            newlyCreatedFolderUrl && push(newlyCreatedFolderUrl);
        }
        onClose();
    };
    const showErrorFlag = ({ title: title, description: description, actions: actions })=>{
        flags.showFlag({
            type: 'error',
            title: title,
            description: description,
            close: 'auto',
            actions: actions
        });
    };
    const abortExperienceOnExpectedError = (error)=>{
        (0, $7Sm4c.markErrorAsHandled)(error);
        experienceTracker.abort({
            name: (0, $irVI7.CONVERT_PAGE_TO_FOLDER_EXPERIENCE),
            reason: 'Expected Apollo error'
        });
    };
    const convertPageToFolderFailure = (error)=>{
        if ($ad7bf5a97d16ed21$var$isPageEditRestrictedError(error)) {
            showErrorFlag({
                title: formatMessage($ad7bf5a97d16ed21$var$i18n.editPermissionErrorFlagTitle),
                description: formatMessage($ad7bf5a97d16ed21$var$i18n.editPermissionErrorFlagDescription)
            });
            abortExperienceOnExpectedError(error);
        } else if ($ad7bf5a97d16ed21$var$isNameCollisionError(error)) {
            showErrorFlag({
                title: formatMessage($ad7bf5a97d16ed21$var$i18n.nameCollisionErrorFlagTitle),
                description: formatMessage($ad7bf5a97d16ed21$var$i18n.nameCollisionErrorFlagDescription)
            });
            abortExperienceOnExpectedError(error);
        } else if ($ad7bf5a97d16ed21$var$isNameLengthLimitError(error) && contentTitle) {
            showErrorFlag({
                title: formatMessage($ad7bf5a97d16ed21$var$i18n.nameLengthLimitErrorFlagTitle),
                description: formatMessage($ad7bf5a97d16ed21$var$i18n.nameLengthLimitErrorFlagDescription, {
                    numCharsOverLimit: contentTitle.length - $ad7bf5a97d16ed21$export$de0fa8bd80a55013
                })
            });
            abortExperienceOnExpectedError(error);
        } else {
            showErrorFlag({
                title: formatMessage($ad7bf5a97d16ed21$var$i18n.defaultErrorFlagTitle),
                description: formatMessage($ad7bf5a97d16ed21$var$i18n.defaultErrorFlagDescription),
                actions: [
                    {
                        content: formatMessage($ad7bf5a97d16ed21$var$i18n.defaultErrorFlagAction),
                        onClick: handlePageToFolderConversion
                    }
                ]
            });
            if ((0, $95rLf.isExpectedApolloError)(error)) {
                abortExperienceOnExpectedError(error);
                return;
            }
            (0, $fGzMp.stopExperienceOnError)((0, $irVI7.CONVERT_PAGE_TO_FOLDER_EXPERIENCE), error);
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    actionSubject: $ad7bf5a97d16ed21$var$COMPONENT_NAME,
                    action: 'failed',
                    attributes: {
                        error: error
                    },
                    actionSubjectId: `${$ad7bf5a97d16ed21$var$COMPONENT_NAME}ConvertButton`,
                    source: $ad7bf5a97d16ed21$var$source
                }
            }).fire();
        }
    };
    const handlePageToFolderConversion = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: $ad7bf5a97d16ed21$var$COMPONENT_NAME,
                actionSubjectId: `${$ad7bf5a97d16ed21$var$COMPONENT_NAME}ConvertButton`,
                source: $ad7bf5a97d16ed21$var$source
            }
        }).fire();
        setIsConverting(true);
        experienceTracker.start({
            name: (0, $irVI7.CONVERT_PAGE_TO_FOLDER_EXPERIENCE)
        });
        convertPageToFolderMutation({
            variables: {
                id: contentId
            }
        }).then((data)=>{
            convertPageToFolderSuccess(data);
        }).catch((error)=>{
            convertPageToFolderFailure(error);
            setIsConverting(false);
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
        width: "450px",
        key: "ConvertPageToFolderDialog",
        onClose: handleOnClose,
        shouldScrollInViewport: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $ad7bf5a97d16ed21$var$i18n.dialogHeader))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
        space: "space.100"
    }, isPremium && hasApprovalReview && (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $ad7bf5a97d16ed21$var$warningMessageStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
        appearance: "warning"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $ad7bf5a97d16ed21$var$i18n.approvalsWarning))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $ad7bf5a97d16ed21$var$i18n.dialogDescription))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        justifyContent: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7joZr.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        onClick: handleOnClose,
        appearance: "subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $ad7bf5a97d16ed21$var$i18n.cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        onClick: handlePageToFolderConversion,
        appearance: "primary",
        isLoading: isConverting
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $ad7bf5a97d16ed21$var$i18n.dialogSubmitText)))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $67Foi.ScreenEvent), {
        name: "convertPageToFolderDialogModalScreen",
        id: "convertPageToFolderModalScreenEvent"
    }), convertPageToFolderError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: convertPageToFolderError
    }));
};
const $ad7bf5a97d16ed21$var$ConvertPageToFolderDialogWithFlags = (0, $7aRa9.withFlags)($ad7bf5a97d16ed21$var$ConvertPageToFolderDialogComponent);
const $ad7bf5a97d16ed21$export$ae121ae5418ce48b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $laFNM.ApprovalsProvider), {
        contentId: props.contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ad7bf5a97d16ed21$var$ConvertPageToFolderDialogWithFlags, props));
const $ad7bf5a97d16ed21$var$isPageEditRestrictedError = (error)=>error.message.includes('User does not have permissions to perform this action');
const $ad7bf5a97d16ed21$var$isNameCollisionError = (error)=>error.message.includes('A folder exists with the same title in this space');
const $ad7bf5a97d16ed21$var$isNameLengthLimitError = (error)=>error.message.includes('Title cannot be longer than 255 characters');
const $ad7bf5a97d16ed21$var$i18n = (0, $kSwu1.defineMessages)({
    dialogHeader: {
        id: "folder-conversion.convert-page-to-folder.dialog.header",
        defaultMessage: "Convert this page into a folder?"
    },
    dialogDescription: {
        id: "folder-conversion.convert-page-to-folder.dialog.description",
        defaultMessage: "We\u2019ll archive the original page, so you don\u2019t need to worry about losing your work."
    },
    cancel: {
        id: "folder-conversion.convert-page-to-folder.dialog.cancel",
        defaultMessage: "Cancel"
    },
    dialogSubmitText: {
        id: "folder-conversion.convert-page-to-folder.dialog.submit",
        defaultMessage: "Convert"
    },
    approvalsWarning: {
        id: "folder-conversion.convert-page-to-folder.dialog.approvalsWarning",
        defaultMessage: "This will end an approval."
    },
    successFlagTitle: {
        id: "folder-conversion.convert-page-to-folder.flags.success-message.title",
        defaultMessage: "Conversion complete"
    },
    successFlagDescription: {
        id: "folder-conversion.convert-page-to-folder.flags.success-message.description.placeholder-title",
        defaultMessage: "We\u2019ve finished converting the page to a folder."
    },
    defaultErrorFlagTitle: {
        id: "folder-conversion.convert-page-to-folder.flags.error-message.title",
        defaultMessage: "We couldn\u2019t convert the page to a folder"
    },
    defaultErrorFlagDescription: {
        id: "folder-conversion.convert-page-to-folder.flags.error-message.description.placeholder-title",
        defaultMessage: "Something went wrong, and we were unable to convert this page to a folder."
    },
    defaultErrorFlagAction: {
        id: "folder-conversion.convert-page-to-folder.flags.error-message.action",
        defaultMessage: "Try again"
    },
    editPermissionErrorFlagTitle: {
        id: "folder-conversion.convert-page-to-folder.flags.error-message.edit-permissions.title",
        defaultMessage: "Request edit and archive access to continue"
    },
    editPermissionErrorFlagDescription: {
        id: "folder-conversion.convert-page-to-folder.flags.error-message.edit-permissions.description",
        defaultMessage: "To convert this page to a folder, you\u2019ll need permission to edit and archive it."
    },
    nameCollisionErrorFlagTitle: {
        id: "folder-conversion.convert-page-to-folder.flags.error-message.name-collision.title",
        defaultMessage: "Rename this page to continue"
    },
    nameCollisionErrorFlagDescription: {
        id: "folder-conversion.convert-page-to-folder.flags.error-message.name-collision.description",
        defaultMessage: "To avoid duplicate titles, you\u2019ll need to rename this page before we can convert it to a folder and archive the original."
    },
    nameLengthLimitErrorFlagTitle: {
        id: "folder-conversion.convert-page-to-folder.flags.error-message.name-length-limit.title",
        defaultMessage: "Give this page a shorter title"
    },
    nameLengthLimitErrorFlagDescription: {
        id: "folder-conversion.convert-page-to-folder.flags.error-message.name-length-limit.description",
        defaultMessage: "Before we can convert this page to a folder, archiving the original, you\u2019ll need to give it a title that is at least {numCharsOverLimit, plural, one {# character} other {# characters}} shorter."
    }
});
module.exports["ConvertPageToFolderDialog"] = $ad7bf5a97d16ed21$export$ae121ae5418ce48b;

});

parcelRegister("WfKBt", function(module, exports) {
/**
 * @generated SignedSource<<a6c73600adeb768aa334b04a865edb6f>>
 * @relayHash 4eea0357b0c46bdca044a6b3b9b301ec
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c9a17fe744f7014b84fa0265289a77140bedf705796685c18a7cc805136059b2
const $c938044c857e7ec1$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "ConfluenceConvertContentToFolderPayload",
            "kind": "LinkedField",
            "name": "convertToFolder",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ConvertPageToFolderDialogConvertPageToFolderMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ConvertPageToFolderDialogConvertPageToFolderMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "4eea0357b0c46bdca044a6b3b9b301ec",
            "id": "c9a17fe744f7014b84fa0265289a77140bedf705796685c18a7cc805136059b2",
            "metadata": {},
            "name": "ConvertPageToFolderDialogConvertPageToFolderMutation",
            "operationKind": "mutation",
            "text": "mutation ConvertPageToFolderDialogConvertPageToFolderMutation($id:ID!){convertToFolder(id:$id){content{id}}}"
        }
    };
}();
$c938044c857e7ec1$var$node.hash = "9e061c22a3f4cc67b35d81eed7b18a16";
var $c938044c857e7ec1$export$2e2bcd8739ae039 = $c938044c857e7ec1$var$node;
module.exports["default"] = $c938044c857e7ec1$export$2e2bcd8739ae039;

});

parcelRegister("gjbSq", function(module, exports) {

var $95rLf = parcelRequire("95rLf");


var $7Sm4c = parcelRequire("7Sm4c");


var $3jwuS = parcelRequire("3jwuS");


var $gEtAQ = parcelRequire("gEtAQ");


var $cEgMD = parcelRequire("cEgMD");


var $jr6cv = parcelRequire("jr6cv");


var $jMyy4 = parcelRequire("jMyy4");

const $8906a897a8abc933$export$cf0b322c7c05f5e9 = 'action-convert-page-to-folder';
const $8906a897a8abc933$export$9009d9583737dc08 = ({ contentId: contentId, spaceKey: spaceKey, skipQuery: skipQuery })=>{
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)((0, $jr6cv.default), {
        skip: Boolean(skipQuery) || // Company Hub hides its space from the user, is rather presented to the user as "a new surface", not a page so converting it to a folder wouldn't make sense.
        // Additionally, if this query were to execute, it would break the Company Hub history/version preview, because it doesn't respect the versionOverride query parameter.
        (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey),
        variables: {
            contentId: contentId,
            spaceKey: spaceKey
        },
        __callerPackage__: "folder-conversion"
    });
    const isViewPageRoute = (0, $gEtAQ.isViewPage)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isPage = data?.singleContent?.type === 'page';
    const isFoldersEnabledForSpace = data?.space?.spaceTypeSettings?.enabledContentTypes?.isFoldersEnabled;
    const isPublished = data?.singleContent?.status === 'current';
    let canEdit = false;
    let canArchive = false; // need to check archive permission since page is archived as a part of conversion
    data?.singleContent?.operations?.forEach((operationCheckResult)=>{
        if (operationCheckResult?.targetType === 'page') {
            if (operationCheckResult?.operation === 'update') canEdit = true;
            else if (operationCheckResult?.operation === 'archive') canArchive = true;
        }
    });
    const canConvertPageToFolder = Boolean(isViewPageRoute && !isLivePage && isPage && isFoldersEnabledForSpace && isPublished && canEdit && canArchive);
    if ((0, $95rLf.isExpectedApolloError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    const contentTitle = data?.singleContent?.title;
    const hasLoaded = $8906a897a8abc933$export$d5c654a6fe10b3c1(Boolean(skipQuery), Boolean(data), Boolean(error), loading);
    return {
        canConvertPageToFolder: canConvertPageToFolder,
        contentTitle: contentTitle,
        loading: loading,
        error: error,
        hasLoaded: hasLoaded
    };
};
const $8906a897a8abc933$export$d5c654a6fe10b3c1 = (skip, hasData, hasError, loading)=>{
    return skip || (hasData || hasError) && !loading;
};
module.exports["CONVERT_PAGE_TO_FOLDER_WEBITEM_ID"] = $8906a897a8abc933$export$cf0b322c7c05f5e9;
module.exports["useCanConvertPageToFolder"] = $8906a897a8abc933$export$9009d9583737dc08;

});

parcelRegister("jr6cv", function(module, exports) {
/**
 * @generated SignedSource<<cff4ec53e648470d277e9ebff3ca6267>>
 * @relayHash 48a9429ef50ceb1df349c422f817239b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9d4b264a2064bf474a2da6e6304f03e630787bd8c8a1da86bbb0fe266d4ae062
const $98dc97ed41815985$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "SpaceTypeSettings",
                    "kind": "LinkedField",
                    "name": "spaceTypeSettings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "EnabledContentTypes",
                            "kind": "LinkedField",
                            "name": "enabledContentTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isFoldersEnabled"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "title"
                },
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "kind": "ScalarField",
                    "name": "status"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ConvertPageToFolderQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ConvertPageToFolderQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "48a9429ef50ceb1df349c422f817239b",
            "id": "9d4b264a2064bf474a2da6e6304f03e630787bd8c8a1da86bbb0fe266d4ae062",
            "metadata": {},
            "name": "ConvertPageToFolderQuery",
            "operationKind": "query",
            "text": "query ConvertPageToFolderQuery($contentId:ID!,$spaceKey:String!){space(key:$spaceKey){id,spaceTypeSettings{enabledContentTypes{isFoldersEnabled}}},singleContent(id:$contentId){id,title,type,status,operations{operation,targetType}}}"
        }
    };
}();
$98dc97ed41815985$var$node.hash = "ed0995bcdb62a84d190715c954ff6018";
var $98dc97ed41815985$export$2e2bcd8739ae039 = $98dc97ed41815985$var$node;
module.exports["default"] = $98dc97ed41815985$export$2e2bcd8739ae039;

});

parcelRegister("3eMfQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");


var $9wGTI = parcelRequire("9wGTI");


var $4LDXE = parcelRequire("4LDXE");



const $35cdf415560d18a2$export$ecf6343598832c90 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "ldI6_",
    name: "LazyContentToolsItem",
    loader: async ()=>(0, $9wGTI.fg)('confluence_link_item_append_trace_context') ? (await (parcelRequire("4cPvJ"))).ContentToolsItemWithRoutesContext : (await (parcelRequire("J1GVU"))).ContentToolsItem
});


const $35cdf415560d18a2$export$3de34eae48b0740b = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "uFc6G",
    name: "LazyContentToolsItemWithPlaceholder",
    loader: async ()=>(0, $9wGTI.fg)('confluence_link_item_append_trace_context') ? (await (parcelRequire("4cPvJ"))).ContentToolsItemWithRoutesContext : (await (parcelRequire("J1GVU"))).ContentToolsItem,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4LDXE.ContentToolsItemPlaceholder), null)
});
module.exports["LazyContentToolsItem"] = $35cdf415560d18a2$export$ecf6343598832c90;
module.exports["LazyContentToolsItemWithPlaceholder"] = $35cdf415560d18a2$export$3de34eae48b0740b;

});

parcelRegister("4LDXE", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $e6ba7f6f1ee193d5$export$4a15f2daa593cc3 = ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: {
                height: "40px",
                display: "flex",
                width: "100%",
                padding: "var(--ds-space-100, 8px) var(--ds-space-250, 20px)",
                alignItems: "center",
                boxSizing: "border-box"
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: {
                height: "17px",
                width: "100%",
                backgroundColor: "var(--ds-skeleton, #0515240F)",
                borderRadius: "10%"
            }
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
module.exports["ContentToolsItemPlaceholder"] = $e6ba7f6f1ee193d5$export$4a15f2daa593cc3;

});

parcelRegister("4cPvJ", function(module, exports) {

let $31003d64a3cbc110$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $31003d64a3cbc110$var$load("bzc8Q"),
    $31003d64a3cbc110$var$load("4TY0p")
]).then(()=>parcelRequire('ebxOW'));

});

parcelRegister("J1GVU", function(module, exports) {

let $087583f96ab988ae$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $087583f96ab988ae$var$load("bzc8Q").then(()=>parcelRequire('al4VD'));

});

parcelRegister("k9WFY", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $77aec7b4d93beceb$export$c4e96d849cdd6a3d = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "g6cZS",
    name: "PublishPageAsBlogDialog",
    loader: async ()=>(await (parcelRequire("glQH7"))).PublishPageAsBlogDialog
});
module.exports["PublishPageAsBlogDialog"] = $77aec7b4d93beceb$export$c4e96d849cdd6a3d;

});

parcelRegister("glQH7", function(module, exports) {

let $be777b8b27a77359$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $be777b8b27a77359$var$load("6HLQW"),
    $be777b8b27a77359$var$load("4fYzp"),
    $be777b8b27a77359$var$load("hBTro"),
    $be777b8b27a77359$var$load("5zDuS"),
    $be777b8b27a77359$var$load("fJjZJ")
]).then(()=>parcelRequire('8d4o6'));

});

parcelRegister("5G6sa", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $f44739e864265bc9$var$ContentHistoryStore = (0, $8s9DV.createStore)({
    initialState: {
        wasTransitionedFromEditor: false
    },
    actions: {
        setWasTransitionedFromEditor: (wasTransitionedFromEditor)=>({ setState: setState })=>{
                setState({
                    wasTransitionedFromEditor: wasTransitionedFromEditor
                });
            }
    },
    name: 'newContentHistoryState'
});
const $f44739e864265bc9$export$90587b2a92cba8d5 = (0, $kBr4q.createStateHook)($f44739e864265bc9$var$ContentHistoryStore);
const $f44739e864265bc9$export$9b1a939bc5c5d3b = (0, $kBr4q.createActionsHook)($f44739e864265bc9$var$ContentHistoryStore);
module.exports["useNewContentHistoryState"] = $f44739e864265bc9$export$90587b2a92cba8d5;
module.exports["useNewContentHistoryActions"] = $f44739e864265bc9$export$9b1a939bc5c5d3b;

});

parcelRegister("7om8k", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hNRe4 = parcelRequire("hNRe4");

const $a7795cfffaaaa1a7$export$a976a35f73cf7a61 = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hNRe4.PageOwnershipByLineWithContributorsDropdown), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hNRe4.PageOwnershipByLineWithContributorsDropdown), props);
};
module.exports["BadgeStylePageOwnershipByline"] = $a7795cfffaaaa1a7$export$a976a35f73cf7a61;

});

parcelRegister("hNRe4", function(module, exports) {
/* PageOwnershipByLineWithContributorsDropdown.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $arQY7 = parcelRequire("arQY7");


var $lpNn5 = parcelRequire("lpNn5");


var $4n1IT = parcelRequire("4n1IT");


var $w6R6I = parcelRequire("w6R6I");


var $1l0kj = parcelRequire("1l0kj");


var $4aRua = parcelRequire("4aRua");


var $hBYtq = parcelRequire("hBYtq");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $jmjWc = parcelRequire("jmjWc");


var $ep3mz = parcelRequire("ep3mz");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $eToX6 = parcelRequire("eToX6");


var $kuujH = parcelRequire("kuujH");


var $jFm04 = parcelRequire("jFm04");


var $2zphh = parcelRequire("2zphh");


var $iMxJy = parcelRequire("iMxJy");


var $h9NKn = parcelRequire("h9NKn");


var $ctQwt = parcelRequire("ctQwt");


const $a1b50edf1fd86d1e$var$LazyPopupContent = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "_Qz_k",
    name: "LazyPopupContent",
    loader: async ()=>(await (parcelRequire("cls8c"))).PageOwnershipByLineWithContributorsDropdownContent
});
const $a1b50edf1fd86d1e$var$styles = {
    openTrigger: "_0KLXruo126",
    trigger: "_0bjKvDKxmn _23rrnHyKLB _0LQT5E1Y8M _03SyCP1Y8M _46hvQmFQfX _0xmtkoFQfX _0KLXru66of _39HuIbz8Lp _1ANEUSzUZr _1eOmH6o126 _3sFUREiSCN _3gzVzLN4oS",
    smartFolderHeaderTrigger: "_3iDTPbQ4SZ _0hPCNLDIqT _4kiQYAoWWg",
    previewPanelCard: "_0LQT5E1Y8M _03SyCP1Y8M _46hvQmFQfX _0xmtkoFQfX _39HuIbz8Lp _1ANEUSzUZr"
};
const $a1b50edf1fd86d1e$var$PageOwnershipByLineWithContributorsDropdownComponent = ({ owner: owner, author: author, contributorCountWithoutOwner: contributorCountWithoutOwner, analyticsSource: analyticsSource, generatedBy: generatedBy, isSmartFolderHeaderByline: isSmartFolderHeaderByline = false, shouldRenderToParent: shouldRenderToParentProp })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { openModal: openChangeOwnerModal } = (0, $jFm04.useContentOwnershipContext)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [isDropdownOpen, setIsDropdownOpen] = (0, $cozmU.useState)(false);
    const triggerRefDuplicate = (0, $cozmU.useRef)(null);
    const createDuplicateRef = (0, $iMxJy.useDuplicateRef)(); // Tracks whether the dropdown was explicitly opened by a click (pinned open).
    // When pinned, the dropdown stays open even when the mouse leaves.
    const isPinnedRef = (0, $cozmU.useRef)(false); // Reset state when changing contentId
    (0, $cozmU.useEffect)(()=>{
        setIsDropdownOpen(false);
        isPinnedRef.current = false;
    }, [
        contentId
    ]);
    const pageOwner = owner ?? author;
    const avatarSrc = (0, $2zphh.getUserAvatarSrc)(pageOwner);
    const profileCardResidesInPreviewPanel = (0, $eToX6.isInPreviewPanel)();
    const onPopupTriggerClick = (0, $cozmU.useCallback)(()=>{
        // The click-to-open experiment forces a simple click toggle regardless of the hover feature.
        if ((0, $6mKj3.expValEquals)('confluence_profile_card_consistent_updates', 'isEnabled', true)) {
            setIsDropdownOpen((prev)=>!prev);
            return;
        }
        if (isDropdownOpen && !isPinnedRef.current) // Menu is open from hover — pin it open instead of closing
        isPinnedRef.current = true; // already open — no state change needed
        else {
            // Closed → open and pin, or pinned → close and unpin
            const next = !isDropdownOpen;
            isPinnedRef.current = next;
            setIsDropdownOpen(next);
        }
    }, [
        isDropdownOpen
    ]); // Hover-to-open logic: the dropdown opens on hover instead of requiring a click
    // (tooltip is also hidden). A 200ms delay on mouse leave prevents the dropdown
    // from closing while the user moves their cursor from the trigger to the popup content.
    const hoverCloseTimeoutRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        return ()=>clearHoverCloseTimeout();
    }, []);
    const clearHoverCloseTimeout = ()=>{
        if (hoverCloseTimeoutRef.current) {
            clearTimeout(hoverCloseTimeoutRef.current);
            hoverCloseTimeoutRef.current = null;
        }
    };
    const startHoverCloseTimeout = ()=>{
        clearHoverCloseTimeout();
        hoverCloseTimeoutRef.current = setTimeout(()=>{
            setIsDropdownOpen(false);
        }, 200);
    }; // When the click-to-open experiment is on, the byline dropdown must only open on click, so the
    // hover-to-open behaviour is suppressed.
    const onPopupTriggerMouseEnter = ()=>{
        if ((0, $6mKj3.expValEquals)('confluence_profile_card_consistent_updates', 'isEnabled', true)) return;
        clearHoverCloseTimeout();
        setIsDropdownOpen(true);
    };
    const onPopupTriggerMouseLeave = ()=>{
        if ((0, $6mKj3.expValEquals)('confluence_profile_card_consistent_updates', 'isEnabled', true)) return;
        if (!isPinnedRef.current) startHoverCloseTimeout();
    };
    const onPopupContentMouseEnter = ()=>{
        clearHoverCloseTimeout();
    };
    const onPopupContentMouseLeave = ()=>{
        if ((0, $6mKj3.expValEquals)('confluence_profile_card_consistent_updates', 'isEnabled', true)) return;
        if (!isPinnedRef.current) startHoverCloseTimeout();
    };
    const onPopupClose = (0, $cozmU.useCallback)(()=>{
        clearHoverCloseTimeout();
        isPinnedRef.current = false;
        setIsDropdownOpen(false);
    }, []);
    const onChangeOwnerClick = (0, $cozmU.useCallback)(()=>{
        // accessibility: return focus to dropdown trigger when change owner modal closes - doesnt happen automatically because the change owner modal trigger is in the dropdown which gets unmounted when the modal opens.
        openChangeOwnerModal({
            returnFocusRef: triggerRefDuplicate
        });
        setIsDropdownOpen(false);
    }, [
        openChangeOwnerModal,
        triggerRefDuplicate
    ]);
    const shouldUseCollaborators = !analyticsSource.startsWith('folder') && generatedBy !== 'ONBOARDING' && (0, $6mKj3.expValEquals)('dual_agent_avatar_card', 'isEnabled', true);
    const collaboratorsByline = shouldUseCollaborators ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $h9NKn.CollaboratorsByline), {
        owner: pageOwner,
        fallbackContributorCount: contributorCountWithoutOwner
    }) : null;
    const ownerInfoInsidePreviewPanel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center",
        xcss: $a1b50edf1fd86d1e$var$styles.previewPanelCard
    }, collaboratorsByline ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
        src: avatarSrc,
        borderColor: "transparent",
        size: "xxsmall"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtle",
        maxLines: 1
    }, intl.formatMessage(generatedBy === 'ONBOARDING' ? (0, $kuujH.i18n).bylineMainTextCreatedByConfluence : (0, $kuujH.i18n).abbreviatedBylineMainText, {
        user: pageOwner.fullName
    }))));
    const popupTrigger = ({ ref: ref, ...triggerProps })=>{
        const triggerRef = createDuplicateRef(ref, triggerRefDuplicate);
        const pressable = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            testId: "owner-with-contributors-dropdown-trigger",
            xcss: (0, $w6R6I.cx)($a1b50edf1fd86d1e$var$styles.trigger, isSmartFolderHeaderByline && $a1b50edf1fd86d1e$var$styles.smartFolderHeaderTrigger, isDropdownOpen && (0, $9wGTI.fg)('confluence_byline_analytics_popup_layout') && $a1b50edf1fd86d1e$var$styles.openTrigger),
            onClick: onPopupTriggerClick,
            onMouseEnter: onPopupTriggerMouseEnter,
            onMouseLeave: onPopupTriggerMouseLeave,
            ref: triggerRef,
            ...triggerProps
        }, collaboratorsByline ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.050",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
            src: avatarSrc,
            borderColor: "transparent",
            size: "xxsmall"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtle",
            maxLines: 1
        }, intl.formatMessage(generatedBy === 'ONBOARDING' ? (0, $kuujH.i18n).bylineMainTextCreatedByConfluence : (0, $kuujH.i18n).abbreviatedBylineMainText, {
            user: pageOwner.fullName
        })))); // The click-to-open experiment keeps the tooltip so the trigger reads as clickable;
        // otherwise render the pressable without a tooltip (hover-to-open is the default).
        if (!(0, $6mKj3.expValEquals)('confluence_profile_card_consistent_updates', 'isEnabled', true)) return pressable;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: isDropdownOpen ? undefined : intl.formatMessage(analyticsSource.startsWith('folder') ? (0, $kuujH.i18n).ownerDropdownTooltip : (0, $kuujH.i18n).ownerWithContributorsDropdownTooltip),
            position: "bottom",
            hideTooltipOnClick: true
        }, pressable);
    };
    const content = profileCardResidesInPreviewPanel ? ownerInfoInsidePreviewPanel : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                role: "presentation",
                onMouseEnter: onPopupContentMouseEnter,
                onMouseLeave: onPopupContentMouseLeave,
                onFocus: onPopupContentMouseEnter,
                onBlur: onPopupContentMouseLeave
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a1b50edf1fd86d1e$var$LazyPopupContent, {
                analyticsSource: `${analyticsSource}-byline`,
                owner: pageOwner,
                onChangeOwnerClick: onChangeOwnerClick,
                contributorCountWithoutOwner: contributorCountWithoutOwner
            })),
        trigger: popupTrigger,
        isOpen: isDropdownOpen,
        onClose: onPopupClose,
        placement: "bottom-start",
        shouldRenderToParent: shouldRenderToParentProp !== undefined ? shouldRenderToParentProp : (0, $6mKj3.expValEquals)('a11y-fixes-week2-may-2026', 'isEnabled', true)
    }); // Keep interaction state above the shared query's loading/error boundaries.
    return shouldUseCollaborators ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ctQwt.CollaboratorsQueryProvider), {
        isDropdownOpen: isDropdownOpen
    }, content) : content;
};
const $a1b50edf1fd86d1e$export$4f664a3a9881436 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
})((0, $jFm04.withContentOwnershipContextProvider)($a1b50edf1fd86d1e$var$PageOwnershipByLineWithContributorsDropdownComponent));
module.exports["PageOwnershipByLineWithContributorsDropdown"] = $a1b50edf1fd86d1e$export$4f664a3a9881436;

});

parcelRegister("2zphh", function(module, exports) {
const $bf70d92172ad781d$export$eae7710ac4f92e1b = (user)=>{
    return user.isAnonymous || !user.avatarUrl ? undefined : user.avatarUrl;
};
module.exports["getUserAvatarSrc"] = $bf70d92172ad781d$export$eae7710ac4f92e1b;

});

parcelRegister("iMxJy", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $cozmU = parcelRequire("cozmU");


var $dOBRD = parcelRequire("dOBRD");

const $de8876e797e08e86$export$376d7d7a8afb5e40 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const [createDuplicateRef] = (0, $cozmU.useState)($de8876e797e08e86$var$_temp2);
    return createDuplicateRef;
} : ()=>{
    const [createDuplicateRef] = (0, $cozmU.useState)(()=>(0, $dOBRD.default)((ref, duplicatedRef)=>{
            return (node)=>{
                if (typeof ref === 'function') ref(node);
                else if (ref) ref.current = node;
                duplicatedRef.current = node;
            };
        }));
    return createDuplicateRef;
};
function $de8876e797e08e86$var$_temp(ref, duplicatedRef) {
    return (node)=>{
        if (typeof ref === "function") ref(node);
        else if (ref) ref.current = node;
        duplicatedRef.current = node;
    };
}
function $de8876e797e08e86$var$_temp2() {
    return (0, $dOBRD.default)($de8876e797e08e86$var$_temp);
}
module.exports["useDuplicateRef"] = $de8876e797e08e86$export$376d7d7a8afb5e40;

});

parcelRegister("h9NKn", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $arQY7 = parcelRequire("arQY7");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");


var $1l0kj = parcelRequire("1l0kj");


var $4aRua = parcelRequire("4aRua");


var $d6Ahp = parcelRequire("d6Ahp");


var $3EM6l = parcelRequire("3EM6l");


var $a4kze = parcelRequire("a4kze");


var $ctQwt = parcelRequire("ctQwt");


var $8p2kA = parcelRequire("8p2kA");


var $2zphh = parcelRequire("2zphh");

const $573d9ec286f22814$var$MAX_NUMBERED_OTHER_CONTRIBUTORS = 4;
const $573d9ec286f22814$var$MAX_TOTAL_BYLINE_AVATARS = 3; // Matches the 2px surface ring ADS Avatar draws, so brand tiles separate from overlapping avatars.
const $573d9ec286f22814$var$BYLINE_PRESENCE_OUTLINE = {
    width: 2
};
const $573d9ec286f22814$var$messages = (0, $kSwu1.defineMessages)({
    byline: {
        id: "content-ownership.byline.owner-with-collaborators",
        defaultMessage: "{ownerName}{otherCount, plural, =0 {} one { and 1 other} other { and # others}}"
    },
    bylineWithoutCount: {
        id: "content-ownership.byline.owner-with-others",
        defaultMessage: "{ownerName} and others"
    }
});
const $573d9ec286f22814$var$styles = {
    avatarStack: "_2YgrGrP0S5",
    avatar: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _1mT5xdRAKS _3YEZNOdnbC",
    overlappingAvatar: "_0GTcwR5UaJ"
};
const $573d9ec286f22814$export$1d15c703a7455632 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(48);
    const { owner: owner, fallbackContributorCount: fallbackContributorCount } = t0;
    const collaborators = (0, $ctQwt.useCollaboratorsQueryResult)()?.data?.confluence_contentCollaborators;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const colorMode = (0, $3EM6l.useAgentAvatarColorMode)();
    let t1;
    if ($[0] !== collaborators || $[1] !== owner.userId) {
        t1 = (0, $8p2kA.getCollaboratorItems)(collaborators, owner.userId);
        $[0] = collaborators;
        $[1] = owner.userId;
        $[2] = t1;
    } else t1 = $[2];
    const items = t1;
    let t2;
    if ($[3] !== items) {
        const seen = new Set();
        t2 = items.filter((item)=>{
            const identity = item.kind === "agent" ? JSON.stringify([
                "agent",
                item.agent.accountId
            ]) : JSON.stringify([
                "human",
                item.user.userId || item.key
            ]);
            if (seen.has(identity)) return false;
            seen.add(identity);
            return true;
        });
        $[3] = items;
        $[4] = t2;
    } else t2 = $[4];
    const uniqueItems = t2;
    const otherCount = collaborators?.nodes ? items.length : fallbackContributorCount;
    let T0;
    let T1;
    let t10;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    let t9;
    if ($[5] !== colorMode || $[6] !== owner || $[7] !== uniqueItems) {
        const visibleNonOwnerItems = uniqueItems.slice(0, $573d9ec286f22814$var$MAX_TOTAL_BYLINE_AVATARS - 1);
        T1 = (0, $1l0kj.Inline);
        t9 = "space.050";
        t10 = "center";
        T0 = (0, $1l0kj.Inline);
        t3 = "center";
        t4 = "true";
        t5 = "byline-collaborator-avatars";
        t6 = $573d9ec286f22814$var$styles.avatarStack;
        const t11 = visibleNonOwnerItems.length + 1;
        let t12;
        if ($[18] !== t11) {
            t12 = {
                zIndex: t11
            };
            $[18] = t11;
            $[19] = t12;
        } else t12 = $[19];
        let t13;
        if ($[20] !== owner) {
            t13 = (0, $2zphh.getUserAvatarSrc)(owner);
            $[20] = owner;
            $[21] = t13;
        } else t13 = $[21];
        let t14;
        if ($[22] !== t13) {
            t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
                src: t13,
                borderColor: "var(--ds-surface, #FFFFFF)",
                size: "xxsmall"
            });
            $[22] = t13;
            $[23] = t14;
        } else t14 = $[23];
        if ($[24] !== t12 || $[25] !== t14) {
            t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $573d9ec286f22814$var$styles.avatar,
                style: t12
            }, t14);
            $[24] = t12;
            $[25] = t14;
            $[26] = t7;
        } else t7 = $[26];
        t8 = visibleNonOwnerItems.map((item_0, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                key: item_0.key,
                xcss: (0, $w6R6I.cx)($573d9ec286f22814$var$styles.avatar, $573d9ec286f22814$var$styles.overlappingAvatar),
                style: {
                    zIndex: visibleNonOwnerItems.length - index
                }
            }, item_0.kind === "agent" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d6Ahp.AgentRowAvatar), {
                name: item_0.agent.displayName,
                agentIcon: (0, $a4kze.getAgentBrand)(item_0.agent.displayName)?.agentIcon,
                avatarUrl: item_0.agent.avatarUrl,
                avatarSize: "xxsmall",
                hasInlineSpacing: false,
                fillProfileClickableFrame: true,
                presenceOutline: $573d9ec286f22814$var$BYLINE_PRESENCE_OUTLINE,
                colorMode: colorMode
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
                src: (0, $2zphh.getUserAvatarSrc)(item_0.user),
                borderColor: "var(--ds-surface, #FFFFFF)",
                size: "xxsmall"
            })));
        $[5] = colorMode;
        $[6] = owner;
        $[7] = uniqueItems;
        $[8] = T0;
        $[9] = T1;
        $[10] = t10;
        $[11] = t3;
        $[12] = t4;
        $[13] = t5;
        $[14] = t6;
        $[15] = t7;
        $[16] = t8;
        $[17] = t9;
    } else {
        T0 = $[8];
        T1 = $[9];
        t10 = $[10];
        t3 = $[11];
        t4 = $[12];
        t5 = $[13];
        t6 = $[14];
        t7 = $[15];
        t8 = $[16];
        t9 = $[17];
    }
    let t11;
    if ($[27] !== T0 || $[28] !== t3 || $[29] !== t4 || $[30] !== t5 || $[31] !== t6 || $[32] !== t7 || $[33] !== t8) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            alignBlock: t3,
            "aria-hidden": t4,
            testId: t5,
            xcss: t6
        }, t7, t8);
        $[27] = T0;
        $[28] = t3;
        $[29] = t4;
        $[30] = t5;
        $[31] = t6;
        $[32] = t7;
        $[33] = t8;
        $[34] = t11;
    } else t11 = $[34];
    const t12 = otherCount > $573d9ec286f22814$var$MAX_NUMBERED_OTHER_CONTRIBUTORS ? $573d9ec286f22814$var$messages.bylineWithoutCount : $573d9ec286f22814$var$messages.byline;
    let t13;
    if ($[35] !== formatMessage || $[36] !== otherCount || $[37] !== owner.fullName || $[38] !== t12) {
        t13 = formatMessage(t12, {
            ownerName: owner.fullName,
            otherCount: otherCount
        });
        $[35] = formatMessage;
        $[36] = otherCount;
        $[37] = owner.fullName;
        $[38] = t12;
        $[39] = t13;
    } else t13 = $[39];
    let t14;
    if ($[40] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtle",
            maxLines: 1
        }, t13);
        $[40] = t13;
        $[41] = t14;
    } else t14 = $[41];
    let t15;
    if ($[42] !== T1 || $[43] !== t10 || $[44] !== t11 || $[45] !== t14 || $[46] !== t9) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T1, {
            space: t9,
            alignBlock: t10
        }, t11, t14);
        $[42] = T1;
        $[43] = t10;
        $[44] = t11;
        $[45] = t14;
        $[46] = t9;
        $[47] = t15;
    } else t15 = $[47];
    return t15;
} : ({ owner: owner, fallbackContributorCount: fallbackContributorCount })=>{
    const collaborators = (0, $ctQwt.useCollaboratorsQueryResult)()?.data?.confluence_contentCollaborators;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const colorMode = (0, $3EM6l.useAgentAvatarColorMode)();
    const items = (0, $cozmU.useMemo)(()=>(0, $8p2kA.getCollaboratorItems)(collaborators, owner.userId), [
        collaborators,
        owner.userId
    ]);
    const uniqueItems = (0, $cozmU.useMemo)(()=>{
        const seen = new Set();
        return items.filter((item)=>{
            const identity = item.kind === 'agent' ? JSON.stringify([
                'agent',
                item.agent.accountId
            ]) : JSON.stringify([
                'human',
                item.user.userId || item.key
            ]);
            if (seen.has(identity)) return false;
            seen.add(identity);
            return true;
        });
    }, [
        items
    ]); // Count each agent-person pair in the text; deduplicate identities only in the avatar stack.
    const otherCount = collaborators?.nodes ? items.length : fallbackContributorCount; // The owner is rendered separately and occupies the first slot in the avatar stack.
    const visibleNonOwnerItems = uniqueItems.slice(0, $573d9ec286f22814$var$MAX_TOTAL_BYLINE_AVATARS - 1);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        "aria-hidden": "true",
        testId: "byline-collaborator-avatars",
        xcss: $573d9ec286f22814$var$styles.avatarStack
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $573d9ec286f22814$var$styles.avatar,
        style: {
            zIndex: visibleNonOwnerItems.length + 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
        src: (0, $2zphh.getUserAvatarSrc)(owner),
        borderColor: "var(--ds-surface, #FFFFFF)",
        size: "xxsmall"
    })), visibleNonOwnerItems.map((item_0, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: item_0.key,
            xcss: (0, $w6R6I.cx)($573d9ec286f22814$var$styles.avatar, $573d9ec286f22814$var$styles.overlappingAvatar),
            style: {
                zIndex: visibleNonOwnerItems.length - index
            }
        }, item_0.kind === 'agent' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d6Ahp.AgentRowAvatar), {
            name: item_0.agent.displayName,
            agentIcon: (0, $a4kze.getAgentBrand)(item_0.agent.displayName)?.agentIcon,
            avatarUrl: item_0.agent.avatarUrl,
            avatarSize: "xxsmall",
            hasInlineSpacing: false,
            fillProfileClickableFrame: true,
            presenceOutline: $573d9ec286f22814$var$BYLINE_PRESENCE_OUTLINE,
            colorMode: colorMode
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
            src: (0, $2zphh.getUserAvatarSrc)(item_0.user),
            borderColor: "var(--ds-surface, #FFFFFF)",
            size: "xxsmall"
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtle",
        maxLines: 1
    }, formatMessage(otherCount > $573d9ec286f22814$var$MAX_NUMBERED_OTHER_CONTRIBUTORS ? $573d9ec286f22814$var$messages.bylineWithoutCount : $573d9ec286f22814$var$messages.byline, {
        ownerName: owner.fullName,
        otherCount: otherCount
    })));
};
module.exports["CollaboratorsByline"] = $573d9ec286f22814$export$1d15c703a7455632;

});

parcelRegister("ctQwt", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $3IBnw = parcelRequire("3IBnw");


var $b3j2Y = parcelRequire("b3j2Y");


var $eCryJ = parcelRequire("eCryJ");


var $6mKj3 = parcelRequire("6mKj3");


var $i9VoI = parcelRequire("i9VoI");


var $3jwuS = parcelRequire("3jwuS");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");


var $hvS6g = parcelRequire("hvS6g");


var $iU5Yo = parcelRequire("iU5Yo");


var $jBVey = parcelRequire("jBVey");


var $j8h6K = parcelRequire("j8h6K");


var $jq832 = parcelRequire("jq832");


var $7Xe6d = parcelRequire("7Xe6d");

const $d5893d6178857c63$var$CollaboratorsQueryContext = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $d5893d6178857c63$export$5ab3848aa2c45083 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $cozmU.useContext)($d5893d6178857c63$var$CollaboratorsQueryContext);
} : ()=>(0, $cozmU.useContext)($d5893d6178857c63$var$CollaboratorsQueryContext);
// Error boundaries retain their fallback component; context keeps children and retry current.
const $d5893d6178857c63$var$FallbackContext = /*#__PURE__*/ (0, $cozmU.createContext)({
    children: null,
    refetch: async ()=>undefined
});
const $d5893d6178857c63$var$QueryErrorFallback = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { error: error } = t0;
    const { children: children, refetch: refetch } = (0, $cozmU.useContext)($d5893d6178857c63$var$FallbackContext);
    let t1;
    if ($[0] !== error || $[1] !== refetch) {
        t1 = {
            loading: false,
            error: error,
            refetch: refetch
        };
        $[0] = error;
        $[1] = refetch;
        $[2] = t1;
    } else t1 = $[2];
    const value = t1;
    let t2;
    if ($[3] !== children || $[4] !== value) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d5893d6178857c63$var$CollaboratorsQueryContext.Provider, {
            value: value
        }, children);
        $[3] = children;
        $[4] = value;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ error: error })=>{
    const { children: children, refetch: refetch } = (0, $cozmU.useContext)($d5893d6178857c63$var$FallbackContext);
    const value = (0, $cozmU.useMemo)(()=>({
            loading: false,
            error: error,
            refetch: refetch
        }), [
        error,
        refetch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d5893d6178857c63$var$CollaboratorsQueryContext.Provider, {
        value: value
    }, children);
};
const $d5893d6178857c63$export$355e14e528f9d57c = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    let t0;
    if ($[0] !== isLivePage || $[1] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d5893d6178857c63$var$RefreshingCollaboratorsQueryProvider, {
            ...props,
            isLivePage: isLivePage
        });
        $[0] = isLivePage;
        $[1] = props;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props)=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d5893d6178857c63$var$RefreshingCollaboratorsQueryProvider, {
        ...props,
        isLivePage: isLivePage
    });
};
// The preloader warms the same Relay operation; both consumers read its shared result synchronously.
const $d5893d6178857c63$var$RefreshingCollaboratorsQueryProvider = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(35);
    const { children: children, isDropdownOpen: isDropdownOpen, isLivePage: isLivePage } = t0;
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const t1 = contentId || "";
    const t2 = spaceKey || "";
    let t3;
    if ($[0] !== cloudId || $[1] !== t1 || $[2] !== t2) {
        t3 = (0, $jBVey.getContentCollaboratorsQueryVariables)({
            cloudId: cloudId,
            contentId: t1,
            spaceKey: t2
        });
        $[0] = cloudId;
        $[1] = t1;
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    const variables = t3;
    const [retryCount, setRetryCount] = (0, $cozmU.useState)(0);
    let t4;
    if ($[4] !== environment || $[5] !== variables) {
        t4 = ()=>(0, $6SsN4.fetchQuery)(environment, (0, $iU5Yo.default), variables, {
                fetchPolicy: "network-only"
            }).toPromise();
        $[4] = environment;
        $[5] = variables;
        $[6] = t4;
    } else t4 = $[6];
    const refetch = t4;
    let t5;
    if ($[7] !== refetch) {
        t5 = async ()=>{
            await refetch();
            setRetryCount($d5893d6178857c63$var$_temp);
        };
        $[7] = refetch;
        $[8] = t5;
    } else t5 = $[8];
    const retry = t5;
    let t6;
    if ($[9] !== children || $[10] !== retry) {
        t6 = {
            children: children,
            refetch: retry
        };
        $[9] = children;
        $[10] = retry;
        $[11] = t6;
    } else t6 = $[11];
    const fallbackValue = t6;
    let t7;
    if ($[12] !== retry) {
        t7 = {
            loading: true,
            refetch: retry
        };
        $[12] = retry;
        $[13] = t7;
    } else t7 = $[13];
    const loadingValue = t7;
    if (!cloudId || !contentId || !spaceKey) {
        let t8;
        if ($[14] !== children) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
            $[14] = children;
            $[15] = t8;
        } else t8 = $[15];
        return t8;
    }
    const t8 = `${cloudId}:${contentId}:${spaceKey}:${retryCount}`;
    let t9;
    if ($[16] !== children || $[17] !== loadingValue) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d5893d6178857c63$var$CollaboratorsQueryContext.Provider, {
            value: loadingValue
        }, children);
        $[16] = children;
        $[17] = loadingValue;
        $[18] = t9;
    } else t9 = $[18];
    let t10;
    if ($[19] !== children || $[20] !== isDropdownOpen || $[21] !== isLivePage || $[22] !== refetch || $[23] !== retryCount || $[24] !== variables) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d5893d6178857c63$var$QueriedCollaboratorsProvider, {
            variables: variables,
            refetch: refetch,
            fetchKey: retryCount,
            isDropdownOpen: isDropdownOpen,
            isLivePage: isLivePage
        }, children);
        $[19] = children;
        $[20] = isDropdownOpen;
        $[21] = isLivePage;
        $[22] = refetch;
        $[23] = retryCount;
        $[24] = variables;
        $[25] = t10;
    } else t10 = $[25];
    let t11;
    if ($[26] !== t10 || $[27] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hvS6g.RelaySuspense), {
            interactionName: "collaborators-byline",
            fallback: t9
        }, t10);
        $[26] = t10;
        $[27] = t9;
        $[28] = t11;
    } else t11 = $[28];
    let t12;
    if ($[29] !== t11 || $[30] !== t8) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCryJ.GenericErrorBoundary), {
            key: t8,
            attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES,
            renderOnError: $d5893d6178857c63$var$QueryErrorFallback
        }, t11);
        $[29] = t11;
        $[30] = t8;
        $[31] = t12;
    } else t12 = $[31];
    let t13;
    if ($[32] !== fallbackValue || $[33] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d5893d6178857c63$var$FallbackContext.Provider, {
            value: fallbackValue
        }, t12);
        $[32] = fallbackValue;
        $[33] = t12;
        $[34] = t13;
    } else t13 = $[34];
    return t13;
} : ({ children: children, isDropdownOpen: isDropdownOpen, isLivePage: isLivePage })=>{
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const variables = (0, $cozmU.useMemo)(()=>(0, $jBVey.getContentCollaboratorsQueryVariables)({
            cloudId: cloudId,
            contentId: contentId || '',
            spaceKey: spaceKey || ''
        }), [
        cloudId,
        contentId,
        spaceKey
    ]);
    const [retryCount, setRetryCount] = (0, $cozmU.useState)(0);
    const refetch = (0, $cozmU.useCallback)(()=>(0, $6SsN4.fetchQuery)(environment, (0, $iU5Yo.default), variables, {
            fetchPolicy: 'network-only'
        }).toPromise(), [
        environment,
        variables
    ]);
    const retry = (0, $cozmU.useCallback)(async ()=>{
        await refetch();
        setRetryCount((count)=>count + 1);
    }, [
        refetch
    ]);
    const fallbackValue = (0, $cozmU.useMemo)(()=>({
            children: children,
            refetch: retry
        }), [
        children,
        retry
    ]);
    const loadingValue = (0, $cozmU.useMemo)(()=>({
            loading: true,
            refetch: retry
        }), [
        retry
    ]);
    if (!cloudId || !contentId || !spaceKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d5893d6178857c63$var$FallbackContext.Provider, {
        value: fallbackValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCryJ.GenericErrorBoundary), {
        key: `${cloudId}:${contentId}:${spaceKey}:${retryCount}`,
        attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES,
        renderOnError: $d5893d6178857c63$var$QueryErrorFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hvS6g.RelaySuspense), {
        interactionName: "collaborators-byline",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d5893d6178857c63$var$CollaboratorsQueryContext.Provider, {
            value: loadingValue
        }, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d5893d6178857c63$var$QueriedCollaboratorsProvider, {
        variables: variables,
        refetch: refetch,
        fetchKey: retryCount,
        isDropdownOpen: isDropdownOpen,
        isLivePage: isLivePage
    }, children))));
};
const $d5893d6178857c63$var$QueriedCollaboratorsProvider = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(38);
    const { children: children, variables: variables, refetch: refetch, fetchKey: fetchKey, isDropdownOpen: isDropdownOpen, isLivePage: isLivePage } = t0;
    const [contentType] = (0, $ep3mz.useContentType)();
    let t1;
    if ($[0] !== fetchKey) {
        t1 = {
            fetchPolicy: "store-or-network",
            fetchKey: fetchKey
        };
        $[0] = fetchKey;
        $[1] = t1;
    } else t1 = $[1];
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $iU5Yo.default), variables, t1);
    let t2;
    if ($[2] !== isLivePage) {
        t2 = isLivePage && (0, $6mKj3.expValEquals)("team_eu_26_demo_temp_contributors_polling_exp", "isEnabled", true);
        $[2] = isLivePage;
        $[3] = t2;
    } else t2 = $[3];
    const pollingEnabled = t2;
    let t3;
    if ($[4] !== pollingEnabled) {
        t3 = {
            pollingEnabled: pollingEnabled
        };
        $[4] = pollingEnabled;
        $[5] = t3;
    } else t3 = $[5];
    const { error: error, refreshNow: refreshNow } = (0, $j8h6K.useContributorsPolling)(refetch, t3);
    const eventRefreshEnabled = isLivePage && !pollingEnabled;
    let t4;
    if ($[6] !== eventRefreshEnabled || $[7] !== refreshNow || $[8] !== variables.id) {
        t4 = {
            contentId: variables.id,
            enabled: eventRefreshEnabled,
            refreshNow: refreshNow
        };
        $[6] = eventRefreshEnabled;
        $[7] = refreshNow;
        $[8] = variables.id;
        $[9] = t4;
    } else t4 = $[9];
    const onActivity = (0, $jq832.useContributorsActivityRefresh)(t4);
    let t5;
    if ($[10] !== contentType || $[11] !== eventRefreshEnabled || $[12] !== onActivity || $[13] !== variables.cloudId || $[14] !== variables.id) {
        t5 = {
            enabled: eventRefreshEnabled,
            cloudId: variables.cloudId,
            contentId: variables.id,
            contentType: contentType,
            onActivity: onActivity
        };
        $[10] = contentType;
        $[11] = eventRefreshEnabled;
        $[12] = onActivity;
        $[13] = variables.cloudId;
        $[14] = variables.id;
        $[15] = t5;
    } else t5 = $[15];
    (0, $7Xe6d.useLiveContributorsActivity)(t5);
    let t6;
    if ($[16] !== refreshNow || $[17] !== variables.id) {
        t6 = (_eventName, response)=>{
            if (response.id === variables.id && response.pageUpdated?.trigger === "publish") refreshNow({
                queueIfInFlight: true
            });
        };
        $[16] = refreshNow;
        $[17] = variables.id;
        $[18] = t6;
    } else t6 = $[18];
    const onPageUpdated = t6;
    const t7 = isLivePage || contentType !== "page" && contentType !== "blogpost";
    let t8;
    if ($[19] !== contentType || $[20] !== onPageUpdated || $[21] !== t7 || $[22] !== variables.id) {
        t8 = {
            contentId: variables.id,
            contentType: contentType,
            delta: "pageUpdated",
            subscriberId: "bylineContributorsPageUpdated",
            onDataReceived: onPageUpdated,
            skip: t7
        };
        $[19] = contentType;
        $[20] = onPageUpdated;
        $[21] = t7;
        $[22] = variables.id;
        $[23] = t8;
    } else t8 = $[23];
    (0, $i9VoI.useSubscriptionEvent)(t8);
    let t10;
    let t9;
    if ($[24] !== isDropdownOpen || $[25] !== refreshNow) {
        t9 = ()=>{
            if (isDropdownOpen) refreshNow();
        };
        t10 = [
            isDropdownOpen,
            refreshNow
        ];
        $[24] = isDropdownOpen;
        $[25] = refreshNow;
        $[26] = t10;
        $[27] = t9;
    } else {
        t10 = $[26];
        t9 = $[27];
    }
    (0, $cozmU.useEffect)(t9, t10);
    let t11;
    if ($[28] !== data || $[29] !== error || $[30] !== refreshNow) {
        t11 = {
            data: data,
            loading: false,
            error: error,
            refetch: refreshNow
        };
        $[28] = data;
        $[29] = error;
        $[30] = refreshNow;
        $[31] = t11;
    } else t11 = $[31];
    const value = t11;
    let t12;
    if ($[32] !== error) {
        t12 = error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        });
        $[32] = error;
        $[33] = t12;
    } else t12 = $[33];
    let t13;
    if ($[34] !== children || $[35] !== t12 || $[36] !== value) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d5893d6178857c63$var$CollaboratorsQueryContext.Provider, {
            value: value
        }, t12, children);
        $[34] = children;
        $[35] = t12;
        $[36] = value;
        $[37] = t13;
    } else t13 = $[37];
    return t13;
} : ({ children: children, variables: variables, refetch: refetch, fetchKey: fetchKey, isDropdownOpen: isDropdownOpen, isLivePage: isLivePage })=>{
    const [contentType] = (0, $ep3mz.useContentType)();
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $iU5Yo.default), variables, {
        fetchPolicy: 'store-or-network',
        fetchKey: fetchKey
    });
    // Keep the demo polling fallback; live docs otherwise refresh after collaboration activity.
    const pollingEnabled = isLivePage && (0, $6mKj3.expValEquals)('team_eu_26_demo_temp_contributors_polling_exp', 'isEnabled', true);
    const { error: error, refreshNow: refreshNow } = (0, $j8h6K.useContributorsPolling)(refetch, {
        pollingEnabled: pollingEnabled
    });
    const eventRefreshEnabled = isLivePage && !pollingEnabled;
    const onActivity = (0, $jq832.useContributorsActivityRefresh)({
        contentId: variables.id,
        enabled: eventRefreshEnabled,
        refreshNow: refreshNow
    });
    (0, $7Xe6d.useLiveContributorsActivity)({
        enabled: eventRefreshEnabled,
        cloudId: variables.cloudId,
        contentId: variables.id,
        contentType: contentType,
        onActivity: onActivity
    });
    const onPageUpdated = (0, $cozmU.useCallback)((_eventName, response)=>{
        if (response.id === variables.id && response.pageUpdated?.trigger === 'publish') // Classic contributors change on publish, regardless of who published the page.
        refreshNow({
            queueIfInFlight: true
        });
    }, [
        variables.id,
        refreshNow
    ]);
    (0, $i9VoI.useSubscriptionEvent)({
        contentId: variables.id,
        contentType: contentType,
        delta: 'pageUpdated',
        subscriberId: 'bylineContributorsPageUpdated',
        onDataReceived: onPageUpdated,
        skip: isLivePage || contentType !== 'page' && contentType !== 'blogpost'
    });
    (0, $cozmU.useEffect)(()=>{
        if (isDropdownOpen) // Opening the popup refreshes both views and restarts the interval when polling is enabled.
        refreshNow();
    }, [
        isDropdownOpen,
        refreshNow
    ]);
    const value = (0, $cozmU.useMemo)(()=>({
            data: data,
            loading: false,
            error: error,
            refetch: refreshNow
        }), [
        data,
        error,
        refreshNow
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d5893d6178857c63$var$CollaboratorsQueryContext.Provider, {
        value: value
    }, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }), children);
};
function $d5893d6178857c63$var$_temp(count) {
    return count + 1;
}
module.exports["useCollaboratorsQueryResult"] = $d5893d6178857c63$export$5ab3848aa2c45083;
module.exports["CollaboratorsQueryProvider"] = $d5893d6178857c63$export$355e14e528f9d57c;

});

parcelRegister("hvS6g", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $91ZZN = parcelRequire("91ZZN");

const $e332deabb876ffbc$export$c3136e12f209350a = (0, $3u0dr.isReactCompilerActiveV2)() ? function RelaySuspense(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { children: children, fallback: fallback, interactionName: interactionName } = t0;
    let t1;
    if ($[0] !== children || $[1] !== fallback || $[2] !== interactionName) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
            fallback: fallback,
            interactionName: interactionName
        }, children);
        $[0] = children;
        $[1] = fallback;
        $[2] = interactionName;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : function RelaySuspense({ children: children, fallback: fallback, interactionName: interactionName }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
        fallback: fallback,
        interactionName: interactionName
    }, children);
};
module.exports["RelaySuspense"] = $e332deabb876ffbc$export$c3136e12f209350a;

});

parcelRegister("j8h6K", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $dec1297aab67b013$var$CONTRIBUTORS_REFRESH_INTERVAL_MS = 5000;
const $dec1297aab67b013$export$bb7a54a15a8d9baf = (refresh, { pollingEnabled: pollingEnabled })=>{
    const [error, setError] = (0, $cozmU.useState)();
    const refreshRef = (0, $cozmU.useRef)(undefined);
    const refreshNow = (0, $cozmU.useCallback)((options)=>refreshRef.current?.(options) ?? Promise.resolve(), []);
    (0, $cozmU.useEffect)(()=>{
        setError(undefined);
        let disposed = false;
        let inFlight = false;
        let refreshQueued = false;
        let timer;
        const clearTimer = ()=>{
            if (timer !== undefined) {
                clearTimeout(timer);
                timer = undefined;
            }
        };
        const scheduleRefresh = ()=>{
            if (pollingEnabled && !disposed && !document.hidden) timer = setTimeout(refreshContributors, $dec1297aab67b013$var$CONTRIBUTORS_REFRESH_INTERVAL_MS);
        };
        const refreshContributors = async ({ queueIfInFlight: queueIfInFlight = false } = {})=>{
            // Opening the dropdown replaces the pending poll; reuse any request already in flight.
            clearTimer();
            if (disposed || document.hidden) return;
            if (inFlight) {
                // A publish may arrive after the active request read the previous version.
                refreshQueued = refreshQueued || queueIfInFlight;
                return;
            }
            inFlight = true;
            try {
                do {
                    refreshQueued = false;
                    try {
                        await refresh();
                        if (!disposed) setError(undefined);
                    } catch (error) {
                        if (!disposed) setError(error instanceof Error ? error : new Error('Failed to refresh contributors'));
                    }
                }while (refreshQueued && !disposed && !document.hidden);
            } finally{
                inFlight = false;
                // Live docs restart their polling interval after any request finishes.
                scheduleRefresh();
            }
        };
        const onVisibilityChange = ()=>{
            clearTimer();
            if (!document.hidden) // Without polling, no later timer will catch changes missed while hidden.
            refreshContributors({
                queueIfInFlight: !pollingEnabled
            });
        };
        // Manual refreshes use the same timer and in-flight guard as scheduled requests.
        refreshRef.current = refreshContributors;
        document.addEventListener('visibilitychange', onVisibilityChange);
        // Returning to a page reads a warm Relay store, which can hold contributors from before a
        // publish that happened while the reader was elsewhere. Refresh on mount to correct it.
        refreshContributors();
        return ()=>{
            disposed = true;
            refreshRef.current = undefined;
            clearTimer();
            document.removeEventListener('visibilitychange', onVisibilityChange);
        };
    }, [
        refresh,
        pollingEnabled
    ]);
    return {
        error: error,
        refreshNow: refreshNow
    };
};
module.exports["useContributorsPolling"] = $dec1297aab67b013$export$bb7a54a15a8d9baf;

});

parcelRegister("jq832", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $51aa30ea1911d087$var$ACTIVITY_REFRESH_DELAY_MS = 5000;
const $51aa30ea1911d087$var$ACTIVITY_FOLLOW_UP_DELAY_MS = 40000;
const $51aa30ea1911d087$var$refreshIfVisible = (refreshNow, isHidden)=>{
    if (!isHidden) refreshNow({
        queueIfInFlight: true
    });
};
const $51aa30ea1911d087$export$53d4bb28d33c2be = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { contentId: contentId, enabled: enabled, refreshNow: refreshNow } = t0;
    const activityRef = (0, $cozmU.useRef)(undefined);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>activityRef.current?.();
        $[0] = t1;
    } else t1 = $[0];
    const onActivity = t1;
    let t2;
    if ($[1] !== enabled || $[2] !== refreshNow) {
        t2 = ()=>{
            if (!enabled) return;
            let activityTimer;
            let followUpTimer;
            let followUpDeadline;
            const clearTimers = ()=>{
                if (activityTimer !== undefined) {
                    clearTimeout(activityTimer);
                    activityTimer = undefined;
                }
                if (followUpTimer !== undefined) {
                    clearTimeout(followUpTimer);
                    followUpTimer = undefined;
                }
            };
            const refreshAfterActivity = ()=>{
                activityTimer = undefined;
                $51aa30ea1911d087$var$refreshIfVisible(refreshNow, document.hidden);
            };
            const refreshAfterActivitySettles = ()=>{
                followUpTimer = undefined;
                followUpDeadline = undefined;
                $51aa30ea1911d087$var$refreshIfVisible(refreshNow, document.hidden);
            };
            activityRef.current = ()=>{
                if (!document.hidden && activityTimer === undefined) activityTimer = setTimeout(refreshAfterActivity, $51aa30ea1911d087$var$ACTIVITY_REFRESH_DELAY_MS);
                followUpDeadline = Date.now() + $51aa30ea1911d087$var$ACTIVITY_FOLLOW_UP_DELAY_MS;
                if (followUpTimer !== undefined) {
                    clearTimeout(followUpTimer);
                    followUpTimer = undefined;
                }
                if (!document.hidden) followUpTimer = setTimeout(refreshAfterActivitySettles, $51aa30ea1911d087$var$ACTIVITY_FOLLOW_UP_DELAY_MS);
            };
            const onVisibilityChange = ()=>{
                clearTimers();
                if (!document.hidden && followUpDeadline !== undefined) {
                    const remaining = followUpDeadline - Date.now();
                    if (remaining > 0) followUpTimer = setTimeout(refreshAfterActivitySettles, remaining);
                    else followUpDeadline = undefined;
                }
            };
            document.addEventListener("visibilitychange", onVisibilityChange);
            return ()=>{
                activityRef.current = undefined;
                clearTimers();
                document.removeEventListener("visibilitychange", onVisibilityChange);
            };
        };
        $[1] = enabled;
        $[2] = refreshNow;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== contentId || $[5] !== enabled || $[6] !== refreshNow) {
        t3 = [
            contentId,
            enabled,
            refreshNow
        ];
        $[4] = contentId;
        $[5] = enabled;
        $[6] = refreshNow;
        $[7] = t3;
    } else t3 = $[7];
    (0, $cozmU.useEffect)(t2, t3);
    return onActivity;
} : ({ contentId: contentId, enabled: enabled, refreshNow: refreshNow })=>{
    const activityRef = (0, $cozmU.useRef)(undefined);
    const onActivity = (0, $cozmU.useCallback)(()=>activityRef.current?.(), []);
    (0, $cozmU.useEffect)(()=>{
        if (!enabled) return;
        let activityTimer;
        let followUpTimer;
        let followUpDeadline;
        const clearTimers = ()=>{
            if (activityTimer !== undefined) {
                clearTimeout(activityTimer);
                activityTimer = undefined;
            }
            if (followUpTimer !== undefined) {
                clearTimeout(followUpTimer);
                followUpTimer = undefined;
            }
        };
        // Refresh the batch five seconds after its first activity, even if edits continue.
        const refreshAfterActivity = ()=>{
            activityTimer = undefined;
            $51aa30ea1911d087$var$refreshIfVisible(refreshNow, document.hidden);
        };
        // Recheck once forty seconds after the latest activity to catch delayed agent attribution.
        const refreshAfterActivitySettles = ()=>{
            followUpTimer = undefined;
            followUpDeadline = undefined;
            $51aa30ea1911d087$var$refreshIfVisible(refreshNow, document.hidden);
        };
        activityRef.current = ()=>{
            // Keep the first deadline so continuous typing cannot postpone every refresh.
            if (!document.hidden && activityTimer === undefined) activityTimer = setTimeout(refreshAfterActivity, $51aa30ea1911d087$var$ACTIVITY_REFRESH_DELAY_MS);
            // Agent attribution can arrive later than NCS edits. Recheck once after activity stops.
            followUpDeadline = Date.now() + $51aa30ea1911d087$var$ACTIVITY_FOLLOW_UP_DELAY_MS;
            if (followUpTimer !== undefined) {
                clearTimeout(followUpTimer);
                followUpTimer = undefined;
            }
            if (!document.hidden) followUpTimer = setTimeout(refreshAfterActivitySettles, $51aa30ea1911d087$var$ACTIVITY_FOLLOW_UP_DELAY_MS);
        };
        const onVisibilityChange = ()=>{
            clearTimers();
            if (!document.hidden && followUpDeadline !== undefined) {
                const remaining = followUpDeadline - Date.now();
                if (remaining > 0) followUpTimer = setTimeout(refreshAfterActivitySettles, remaining);
                else // The shared refresh coordinator already fetches on tab return.
                followUpDeadline = undefined;
            }
        };
        document.addEventListener('visibilitychange', onVisibilityChange);
        return ()=>{
            activityRef.current = undefined;
            clearTimers();
            document.removeEventListener('visibilitychange', onVisibilityChange);
        };
    }, [
        contentId,
        enabled,
        refreshNow
    ]);
    return onActivity;
};
module.exports["useContributorsActivityRefresh"] = $51aa30ea1911d087$export$53d4bb28d33c2be;

});

parcelRegister("7Xe6d", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $2wSyg = parcelRequire("2wSyg");


var $hYoU4 = parcelRequire("hYoU4");

const $89dfa4cdfbc4ded6$export$65ddaa5f3264ff82 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { enabled: enabled, cloudId: cloudId, contentId: contentId, contentType: contentType, onActivity: onActivity } = t0;
    const [t1] = (0, $hYoU4.useNativeCollabState)();
    const { collabEditProvider: collabEditProvider } = t1;
    const { subscribeDraftSyncSuccess: subscribeDraftSyncSuccess } = (0, $2wSyg.useDraftSyncAndPublishContext)();
    let t2;
    let t3;
    if ($[0] !== cloudId || $[1] !== collabEditProvider || $[2] !== contentId || $[3] !== contentType || $[4] !== enabled || $[5] !== onActivity) {
        t2 = ()=>{
            if (!enabled || !collabEditProvider || !contentType) return;
            const documentAri = `ari:cloud:confluence:${cloudId}:${contentType}/${contentId}`;
            if (collabEditProvider.getDocumentAri() !== documentAri) return;
            collabEditProvider.on("data", onActivity);
            return ()=>{
                collabEditProvider.off("data", onActivity);
            };
        };
        t3 = [
            enabled,
            collabEditProvider,
            cloudId,
            contentId,
            contentType,
            onActivity
        ];
        $[0] = cloudId;
        $[1] = collabEditProvider;
        $[2] = contentId;
        $[3] = contentType;
        $[4] = enabled;
        $[5] = onActivity;
        $[6] = t2;
        $[7] = t3;
    } else {
        t2 = $[6];
        t3 = $[7];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    let t5;
    if ($[8] !== contentId || $[9] !== enabled || $[10] !== onActivity || $[11] !== subscribeDraftSyncSuccess) {
        t4 = ()=>{
            if (!enabled) return;
            return subscribeDraftSyncSuccess((syncedContentId)=>{
                if (syncedContentId === contentId) onActivity();
            });
        };
        t5 = [
            enabled,
            contentId,
            onActivity,
            subscribeDraftSyncSuccess
        ];
        $[8] = contentId;
        $[9] = enabled;
        $[10] = onActivity;
        $[11] = subscribeDraftSyncSuccess;
        $[12] = t4;
        $[13] = t5;
    } else {
        t4 = $[12];
        t5 = $[13];
    }
    (0, $cozmU.useEffect)(t4, t5);
} : ({ enabled: enabled, cloudId: cloudId, contentId: contentId, contentType: contentType, onActivity: onActivity })=>{
    const [{ collabEditProvider: collabEditProvider }] = (0, $hYoU4.useNativeCollabState)();
    const { subscribeDraftSyncSuccess: subscribeDraftSyncSuccess } = (0, $2wSyg.useDraftSyncAndPublishContext)();
    // Both listeners are enabled only for live docs with demo polling off.
    // Classic pages use the separate pageUpdated subscription in CollaboratorsQueryProvider.
    (0, $cozmU.useEffect)(()=>{
        if (!enabled || !collabEditProvider || !contentType) return;
        // The shared store can briefly retain the previous page's provider during navigation.
        const documentAri = `ari:cloud:confluence:${cloudId}:${contentType}/${contentId}`;
        if (collabEditProvider.getDocumentAri() !== documentAri) return;
        // Data includes acknowledged local edits, remote edits, and reconnect catch-up steps.
        collabEditProvider.on('data', onActivity);
        return ()=>{
            collabEditProvider.off('data', onActivity);
        };
    }, [
        enabled,
        collabEditProvider,
        cloudId,
        contentId,
        contentType,
        onActivity
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!enabled) return;
        return subscribeDraftSyncSuccess((syncedContentId)=>{
            if (syncedContentId === contentId) onActivity();
        });
    }, [
        enabled,
        contentId,
        onActivity,
        subscribeDraftSyncSuccess
    ]);
};
module.exports["useLiveContributorsActivity"] = $89dfa4cdfbc4ded6$export$65ddaa5f3264ff82;

});

parcelRegister("8p2kA", function(module, exports) {
const $0fc9f8082eb13b7a$export$ecbde51c22a65dc3 = (collaborators, ownerId)=>{
    const items = [];
    const seen = new Set();
    for (const [index, node] of (collaborators?.nodes ?? []).entries()){
        if (!node?.person) continue;
        const { person: person, agent: agent } = node;
        const isOwner = Boolean(person.accountId && person.accountId === ownerId);
        if (!agent && isOwner) continue;
        // Anonymous identities cannot be safely deduplicated by their display names.
        const personKey = person.accountId ?? `anonymous-${index}`;
        const key = JSON.stringify([
            personKey,
            agent?.accountId ?? null
        ]);
        if (seen.has(key)) continue;
        seen.add(key);
        const user = {
            isAnonymous: !person.accountId,
            userId: person.accountId ?? '',
            fullName: person.displayName ?? '',
            avatarUrl: person.profilePicture?.path ?? '',
            jobTitle: person.jobTitle ?? null
        };
        const item = agent ? {
            kind: 'agent',
            key: key,
            user: user,
            agent: {
                accountId: agent.accountId,
                displayName: agent.displayName ?? '',
                avatarUrl: agent.profilePicture?.path ?? ''
            }
        } : {
            kind: 'human',
            key: key,
            user: user
        };
        items.push(item);
    }
    return items;
};
module.exports["getCollaboratorItems"] = $0fc9f8082eb13b7a$export$ecbde51c22a65dc3;

});

parcelRegister("cls8c", function(module, exports) {

let $8fcd4479bee3bea8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $8fcd4479bee3bea8$var$load("7EorR"),
    $8fcd4479bee3bea8$var$load("7Y0AX"),
    $8fcd4479bee3bea8$var$load("cWvhX")
]).then(()=>parcelRequire('8M3ga'));

});

parcelRegister("pG0Ei", function(module, exports) {
var $8787696ab5570b52$export$b8ca5fa4899cbfc7 = /*#__PURE__*/ function(AccountType) {
    AccountType["NORMAL"] = "normal";
    AccountType["GUEST"] = "guest";
    AccountType["ANONYMOUS"] = "anonymous";
    return AccountType;
}({});
module.exports["AccountType"] = $8787696ab5570b52$export$b8ca5fa4899cbfc7;

});

parcelRegister("6Cgm9", function(module, exports) {

var $adSL7 = parcelRequire("adSL7");


var $99waa = parcelRequire("99waa");


var $g2Qne = parcelRequire("g2Qne");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");


var $7Sm4c = parcelRequire("7Sm4c");





var $lvOsp = parcelRequire("lvOsp");


var $51PuZ = parcelRequire("51PuZ");


var $eycex = parcelRequire("eycex");


var $iijpI = parcelRequire("iijpI");


var $pG0Ei = parcelRequire("pG0Ei");

const $a06bc898f9be5b40$var$usePageViewsAnalyticsViewersQuery = (0, $g2Qne.default);
const $a06bc898f9be5b40$var$usePageViewsAnalyticsViewersWithoutLimitQuery = (0, $99waa.default);
const $a06bc898f9be5b40$var$usePageViewsAnalyticsViewersWithActorTypeQuery = (0, $adSL7.default);
const $a06bc898f9be5b40$var$viewerPermissionTypeToNonAnonymousAccountType = {
    APP: (0, $pG0Ei.AccountType).NORMAL,
    EXTERNAL: (0, $pG0Ei.AccountType).GUEST,
    INTERNAL: (0, $pG0Ei.AccountType).NORMAL,
    JSD: (0, $pG0Ei.AccountType).NORMAL
};
const $a06bc898f9be5b40$var$getPageViewsFromData = (data, useRootActorTypeQuery)=>{
    if (!data) return [];
    if (useRootActorTypeQuery) {
        const pageViews = data.contentAnalyticsViewsByUser?.pageViews ?? [];
        return [
            ...pageViews
        ];
    }
    const pageViews = data.singleContent?.contentAnalyticsViewsByUser?.pageViews ?? [];
    return [
        ...pageViews
    ];
};
const $a06bc898f9be5b40$export$aa26e7cd917f1cc = (contentId, { limit: limit, skip: skip, isPrivacyModeEnabled: isPrivacyModeEnabled = false, includeViewersActorType: includeViewersActorType = false, includeAgentTypePreview: includeAgentTypePreview = true } = {})=>{
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const hasLimit = limit != null;
    // Omitting $actorType on the WithActorType document still sends null; AGG rejects it.
    const actorTypeQueryValue = includeViewersActorType && hasLimit ? (0, $iijpI.getGatedPageAnalyticsActorTypeQueryValue)((0, $iijpI.ActorType).All, (0, $6mKj3.expVal)('ai_agent_analytics', 'isEnabled', false)) : undefined;
    const useRootActorTypeQuery = actorTypeQueryValue !== undefined;
    const limitedQuery = useRootActorTypeQuery ? $a06bc898f9be5b40$var$usePageViewsAnalyticsViewersWithActorTypeQuery : $a06bc898f9be5b40$var$usePageViewsAnalyticsViewersQuery;
    const unlimitedQuery = $a06bc898f9be5b40$var$usePageViewsAnalyticsViewersWithoutLimitQuery;
    const [fetchLimitedViewers, { data: limitedData, loading: isLimitedLoading, error: limitedError, called: isLimitedCalled }] = (0, $lvOsp.useLazyQueryInterop)(limitedQuery, {
        // network-only fetch policy added due to apparent caching issues where singleContent sometimes is set as null. Context: https://atlassian.slack.com/archives/C07GCFW40S3/p1742843738957579
        fetchPolicy: 'network-only',
        __callerPackage__: "confluence-analytics"
    });
    const [fetchViewersWithoutLimit, { data: unlimitedData, loading: isUnlimitedLoading, error: unlimitedError, called: isUnlimitedCalled }] = (0, $lvOsp.useLazyQueryInterop)(unlimitedQuery, {
        // Skip Relay store read/write so Mentions lifetime viewers stay isolated from Viewers-table actor/date records.
        fetchPolicy: 'no-store',
        __callerPackage__: "confluence-analytics"
    });
    const data = hasLimit ? limitedData : unlimitedData;
    const isLoading = hasLimit ? isLimitedLoading : isUnlimitedLoading;
    const pageViews = (0, $cozmU.useMemo)(()=>{
        const views = $a06bc898f9be5b40$var$getPageViewsFromData(data, useRootActorTypeQuery);
        if (!includeAgentTypePreview) return views;
        return [
            ...(0, $eycex.toInjectedAgentTypePreviewPageViews)((0, $6mKj3.expVal)('ai_analytics_agent_types', 'isEnabled', false), (0, $6mKj3.expVal)('dual_agent_avatar_card', 'isEnabled', false)),
            ...views
        ];
    }, [
        data,
        includeAgentTypePreview,
        useRootActorTypeQuery
    ]);
    const error = hasLimit ? limitedError : unlimitedError;
    const isLoadViewersCalled = hasLimit ? isLimitedCalled : isUnlimitedCalled;
    // Permissions errors returned with status code 200
    if ((error?.message.includes('PermissionException') || error?.message.includes('403')) && !(0, $7Sm4c.isErrorMarkedAsHandled)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    const loadViewers = (0, $cozmU.useCallback)(()=>{
        if (skip || (0, $9wGTI.fg)('confluence_analytics_contract_testing')) return;
        const variables = {
            contentId: contentId,
            engageTimeThreshold: 20,
            isPrivacyModeEnabled: isPrivacyModeEnabled,
            ...actorTypeQueryValue !== undefined ? {
                actorType: actorTypeQueryValue
            } : {}
        };
        if (limit != null) {
            // in case we need to exclude the current user we request 1 more than is needed.
            fetchLimitedViewers({
                variables: {
                    ...variables,
                    limit: limit + 1
                }
            });
            return;
        }
        fetchViewersWithoutLimit({
            variables: variables
        });
    }, [
        actorTypeQueryValue,
        contentId,
        fetchLimitedViewers,
        fetchViewersWithoutLimit,
        limit,
        skip,
        isPrivacyModeEnabled
    ]);
    const fetchedViewers = (0, $cozmU.useMemo)(()=>{
        if (!data) return null;
        // Maps a single human/anonymous page view to an Account (no agent grouping).
        const toHumanAccount = (pageView)=>{
            if (!pageView.userProfile) {
                const anonymousAccount = {
                    id: null,
                    name: null,
                    avatarURL: null,
                    accountType: (0, $pG0Ei.AccountType).ANONYMOUS,
                    lastViewedAt: pageView.lastViewedAt,
                    isEngaged: pageView.isEngaged ?? null
                };
                return anonymousAccount;
            }
            const permissionType = pageView.confluenceUser?.permissionType;
            const knownAccount = {
                id: pageView.userProfile?.id ?? '',
                name: pageView.userProfile?.displayName ?? '',
                avatarURL: pageView.userProfile?.photos?.[0]?.value ?? '',
                lastViewedAt: pageView.lastViewedAt,
                accountType: (permissionType ? $a06bc898f9be5b40$var$viewerPermissionTypeToNonAnonymousAccountType[permissionType] : undefined) ?? (0, $pG0Ei.AccountType).NORMAL,
                isDeactivated: !pageView.userProfile?.isActive,
                isEngaged: pageView.isEngaged ?? null
            };
            return knownAccount;
        };
        // Agent UI is gated behind `ai_agent_analytics`. When the gate is off,
        // drop agent page views instead of mapping them through `toHumanAccount`
        // (which treats a missing `userProfile` as Anonymous). Real human
        // anonymous views still map as Anonymous.
        if (!(0, $6mKj3.expVal)('ai_agent_analytics', 'isEnabled', false)) {
            const humanAccounts = [];
            for (const pageView_0 of pageViews)if (!(0, $51PuZ.isAgentPageView)(pageView_0)) humanAccounts.push(toHumanAccount(pageView_0));
            return humanAccounts;
        }
        const agentGroups = new Map();
        for (const pageView_1 of pageViews){
            if (!(0, $51PuZ.isAgentPageView)(pageView_1)) continue;
            const key = (0, $51PuZ.agentGroupKey)(pageView_1);
            const group = agentGroups.get(key);
            if (group) group.push(pageView_1);
            else agentGroups.set(key, [
                pageView_1
            ]);
        }
        const buildAgentAccount = (record, groupKey)=>{
            const groupRecords = agentGroups.get(groupKey) ?? [
                record
            ];
            const resolvedName = groupRecords.find((r)=>r.userProfile?.displayName)?.userProfile?.displayName;
            const { name: resolvedAgentName, agentIcon: agentIcon, avatarUrl: avatarUrl } = (0, $51PuZ.resolveAgentNameAndIcon)(groupRecords, formatMessage);
            const resolvedAgentIcon = (0, $51PuZ.getAutonomousAgentBrand)(record)?.agentIcon ?? agentIcon;
            const name = (0, $51PuZ.isUnidentifiedAgentGroupKey)(groupKey) ? (0, $51PuZ.getUnknownAgentSingularName)(formatMessage) : resolvedAgentName;
            // Autonomous agent activity is reported against the agent's own account; it
            // has no attributed person, so it must not read as "with {the agent}".
            const relatedId = (0, $51PuZ.isSelfAttributedAgentRecord)(record) ? undefined : record.relatedUserAccountId ?? record.relatedUser?.id;
            const relatedName = record.relatedUser?.displayName ?? '';
            const relatedAvatarURL = record.relatedUser?.photos?.find((photo)=>photo?.isPrimary)?.value ?? record.relatedUser?.photos?.find(Boolean)?.value;
            const attributedUser = relatedId ? {
                id: relatedId,
                name: relatedName,
                lastViewedAt: record.lastViewedAt,
                ...relatedAvatarURL ? {
                    avatarURL: relatedAvatarURL
                } : {}
            } : undefined;
            const identityAccountId = record.userProfile?.id;
            return {
                id: `${groupKey}${relatedId ? `:${relatedId}` : ''}`,
                name: name,
                avatarURL: avatarUrl ?? '',
                accountType: (0, $pG0Ei.AccountType).NORMAL,
                lastViewedAt: record.lastViewedAt,
                isEngaged: null,
                isAgent: true,
                ...resolvedAgentIcon ? {
                    agentIcon: resolvedAgentIcon
                } : {},
                ...resolvedName && !(0, $51PuZ.isUnidentifiedAgentGroupKey)(groupKey) ? {
                    isDeactivated: !groupRecords.find((r_0)=>r_0.userProfile)?.userProfile?.isActive
                } : {},
                ...attributedUser ? {
                    attributedUsers: [
                        attributedUser
                    ]
                } : {},
                ...identityAccountId ? {
                    identityAccountId: identityAccountId
                } : {}
            };
        };
        // One row per (agent, related user); autonomous agents get a single row.
        const emittedAgentRowKeys = new Set();
        const accounts = [];
        for (const pageView_2 of pageViews){
            if (!(0, $51PuZ.isAgentPageView)(pageView_2)) {
                accounts.push(toHumanAccount(pageView_2));
                continue;
            }
            const key_0 = (0, $51PuZ.agentGroupKey)(pageView_2);
            // Must match `buildAgentAccount`'s attribution rule, or a self-attributed
            // record would be keyed as attributed but rendered as autonomous.
            const relatedId_0 = (0, $51PuZ.isSelfAttributedAgentRecord)(pageView_2) ? undefined : pageView_2.relatedUserAccountId ?? pageView_2.relatedUser?.id;
            if ((0, $51PuZ.isUnidentifiedAgentGroupKey)(key_0) && !relatedId_0) continue;
            const rowKey = `${key_0}:${relatedId_0 ?? ''}`;
            if (emittedAgentRowKeys.has(rowKey)) continue;
            emittedAgentRowKeys.add(rowKey);
            accounts.push(buildAgentAccount(pageView_2, key_0));
        }
        return accounts;
    }, [
        data,
        formatMessage,
        pageViews
    ]);
    const viewers = (0, $cozmU.useMemo)(()=>{
        if (!fetchedViewers) return null;
        const filteredViewers = fetchedViewers.filter((account)=>account.id !== userId);
        if (limit) return filteredViewers.slice(0, limit);
        return filteredViewers;
    }, [
        fetchedViewers,
        limit,
        userId
    ]);
    return {
        contentId: data?.singleContent?.id ?? undefined,
        error: error,
        isLoading: isLoading,
        viewers: viewers,
        loadViewers: loadViewers,
        isLoadViewersCalled: isLoadViewersCalled
    };
};
module.exports["usePageViews"] = $a06bc898f9be5b40$export$aa26e7cd917f1cc;

});

parcelRegister("adSL7", function(module, exports) {
/**
 * @generated SignedSource<<5c4c0b1bdd853a24076090dd034238a5>>
 * @relayHash d717910a34c78e88e5f0cf6fd7986948
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4b39a08b8b7d33aa63b6ede55e32463c741290c08d610e26910e19f75689ca9d
const $5da215546acce137$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "actorType"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "engageTimeThreshold"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isPrivacyModeEnabled"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "limit"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "args": [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "contentId"
            }
        ],
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "singleContent",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "subType"
            },
            {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "number"
                    }
                ]
            }
        ]
    }, v7 = [
        {
            "kind": "Variable",
            "name": "actorType",
            "variableName": "actorType"
        },
        {
            "kind": "Variable",
            "name": "contentId",
            "variableName": "contentId"
        },
        {
            "kind": "Variable",
            "name": "engageTimeThreshold",
            "variableName": "engageTimeThreshold"
        },
        {
            "kind": "Variable",
            "name": "isPrivacyModeEnabled",
            "variableName": "isPrivacyModeEnabled"
        },
        {
            "kind": "Variable",
            "name": "limit",
            "variableName": "limit"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v9 = {
        "concreteType": "AtlassianUserPhoto",
        "kind": "LinkedField",
        "name": "photos",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "value"
            },
            {
                "kind": "ScalarField",
                "name": "isPrimary"
            }
        ]
    }, v10 = {
        "concreteType": "ContentAnalyticsPageViewInfo",
        "kind": "LinkedField",
        "name": "pageViews",
        "plural": true,
        "selections": [
            {
                "concreteType": "AtlassianUser",
                "kind": "LinkedField",
                "name": "userProfile",
                "plural": false,
                "selections": [
                    v5 /*: any*/ ,
                    v8 /*: any*/ ,
                    v9 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "isActive"
                    }
                ]
            },
            {
                "concreteType": "ConfluenceUser",
                "kind": "LinkedField",
                "name": "confluenceUser",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "permissionType"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "accountType"
            },
            {
                "kind": "ScalarField",
                "name": "agentType"
            },
            {
                "kind": "ScalarField",
                "name": "relatedUserAccountId"
            },
            {
                "concreteType": "AtlassianUser",
                "kind": "LinkedField",
                "name": "relatedUser",
                "plural": false,
                "selections": [
                    v5 /*: any*/ ,
                    v8 /*: any*/ ,
                    v9 /*: any*/ 
                ]
            },
            {
                "kind": "ScalarField",
                "name": "views"
            },
            {
                "kind": "ScalarField",
                "name": "lastViewedAt"
            },
            {
                "kind": "ScalarField",
                "name": "lastVersionViewedNumber"
            },
            {
                "kind": "ScalarField",
                "name": "lastVersionViewedUrl"
            },
            {
                "kind": "ScalarField",
                "name": "isEngaged"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "usePageViewsAnalyticsViewersWithActorTypeQuery",
            "selections": [
                v6 /*: any*/ ,
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "ContentAnalyticsViewsByUser",
                    "kind": "LinkedField",
                    "name": "contentAnalyticsViewsByUser",
                    "plural": false,
                    "selections": [
                        v10 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "usePageViewsAnalyticsViewersWithActorTypeQuery",
            "selections": [
                v6 /*: any*/ ,
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "ContentAnalyticsViewsByUser",
                    "kind": "LinkedField",
                    "name": "contentAnalyticsViewsByUser",
                    "plural": false,
                    "selections": [
                        v10 /*: any*/ ,
                        v5 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "d717910a34c78e88e5f0cf6fd7986948",
            "id": "4b39a08b8b7d33aa63b6ede55e32463c741290c08d610e26910e19f75689ca9d",
            "metadata": {},
            "name": "usePageViewsAnalyticsViewersWithActorTypeQuery",
            "operationKind": "query",
            "text": "query usePageViewsAnalyticsViewersWithActorTypeQuery($contentId:ID!,$limit:Int,$engageTimeThreshold:Int,$isPrivacyModeEnabled:Boolean,$actorType:ConfluencePageAnalyticsActorType){singleContent(id:$contentId){id,subType,version{number}},contentAnalyticsViewsByUser(contentId:$contentId,limit:$limit,engageTimeThreshold:$engageTimeThreshold,isPrivacyModeEnabled:$isPrivacyModeEnabled,actorType:$actorType){pageViews{userProfile{id,displayName,photos{value,isPrimary},isActive},confluenceUser{permissionType},accountType,agentType,relatedUserAccountId,relatedUser{id,displayName,photos{value,isPrimary}},views,lastViewedAt,lastVersionViewedNumber,lastVersionViewedUrl,isEngaged},id}}"
        }
    };
}();
$5da215546acce137$var$node.hash = "eb5f809bd8367e8c7bdf5326f35bc263";
var $5da215546acce137$export$2e2bcd8739ae039 = $5da215546acce137$var$node;
module.exports["default"] = $5da215546acce137$export$2e2bcd8739ae039;

});

parcelRegister("99waa", function(module, exports) {
/**
 * @generated SignedSource<<6c63b1e49008a473777214c8c04af293>>
 * @relayHash bf433dd55cb5e7779366a5c70983e76d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 473f165d297ccb666ad3688bbe9525b403ec8a6c2ac02fd1d712c6f5874a6aae
const $857ddbc9c1489691$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "engageTimeThreshold"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isPrivacyModeEnabled"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v4 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "number"
            }
        ]
    }, v5 = [
        {
            "kind": "Variable",
            "name": "engageTimeThreshold",
            "variableName": "engageTimeThreshold"
        },
        {
            "kind": "Variable",
            "name": "isPrivacyModeEnabled",
            "variableName": "isPrivacyModeEnabled"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v7 = {
        "concreteType": "AtlassianUserPhoto",
        "kind": "LinkedField",
        "name": "photos",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "value"
            },
            {
                "kind": "ScalarField",
                "name": "isPrimary"
            }
        ]
    }, v8 = {
        "concreteType": "ContentAnalyticsPageViewInfo",
        "kind": "LinkedField",
        "name": "pageViews",
        "plural": true,
        "selections": [
            {
                "concreteType": "AtlassianUser",
                "kind": "LinkedField",
                "name": "userProfile",
                "plural": false,
                "selections": [
                    v2 /*: any*/ ,
                    v6 /*: any*/ ,
                    v7 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "isActive"
                    }
                ]
            },
            {
                "concreteType": "ConfluenceUser",
                "kind": "LinkedField",
                "name": "confluenceUser",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "permissionType"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "accountType"
            },
            {
                "kind": "ScalarField",
                "name": "agentType"
            },
            {
                "kind": "ScalarField",
                "name": "relatedUserAccountId"
            },
            {
                "concreteType": "AtlassianUser",
                "kind": "LinkedField",
                "name": "relatedUser",
                "plural": false,
                "selections": [
                    v2 /*: any*/ ,
                    v6 /*: any*/ ,
                    v7 /*: any*/ 
                ]
            },
            {
                "kind": "ScalarField",
                "name": "views"
            },
            {
                "kind": "ScalarField",
                "name": "lastViewedAt"
            },
            {
                "kind": "ScalarField",
                "name": "lastVersionViewedNumber"
            },
            {
                "kind": "ScalarField",
                "name": "lastVersionViewedUrl"
            },
            {
                "kind": "ScalarField",
                "name": "isEngaged"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePageViewsAnalyticsViewersWithoutLimitQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "ContentAnalyticsViewsByUser",
                            "kind": "LinkedField",
                            "name": "contentAnalyticsViewsByUser",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePageViewsAnalyticsViewersWithoutLimitQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "ContentAnalyticsViewsByUser",
                            "kind": "LinkedField",
                            "name": "contentAnalyticsViewsByUser",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ ,
                                v2 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "bf433dd55cb5e7779366a5c70983e76d",
            "id": "473f165d297ccb666ad3688bbe9525b403ec8a6c2ac02fd1d712c6f5874a6aae",
            "metadata": {},
            "name": "usePageViewsAnalyticsViewersWithoutLimitQuery",
            "operationKind": "query",
            "text": "query usePageViewsAnalyticsViewersWithoutLimitQuery($contentId:ID!,$engageTimeThreshold:Int,$isPrivacyModeEnabled:Boolean){singleContent(id:$contentId){id,subType,version{number},contentAnalyticsViewsByUser(engageTimeThreshold:$engageTimeThreshold,isPrivacyModeEnabled:$isPrivacyModeEnabled){pageViews{userProfile{id,displayName,photos{value,isPrimary},isActive},confluenceUser{permissionType},accountType,agentType,relatedUserAccountId,relatedUser{id,displayName,photos{value,isPrimary}},views,lastViewedAt,lastVersionViewedNumber,lastVersionViewedUrl,isEngaged},id}}}"
        }
    };
}();
$857ddbc9c1489691$var$node.hash = "d68405636bde80879b4472474acc7681";
var $857ddbc9c1489691$export$2e2bcd8739ae039 = $857ddbc9c1489691$var$node;
module.exports["default"] = $857ddbc9c1489691$export$2e2bcd8739ae039;

});

parcelRegister("g2Qne", function(module, exports) {
/**
 * @generated SignedSource<<3cc0256fd25f0169875fa895fb06f6b4>>
 * @relayHash 413598f2025b3debecb0303a1a584a12
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cff3923a6d9f1c0ce3bc3c41993bace3777812bbe1258df2681ea4d5d1e58945
const $f45d24bac38da2fc$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "engageTimeThreshold"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isPrivacyModeEnabled"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "limit"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v7 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "number"
            }
        ]
    }, v8 = [
        {
            "kind": "Variable",
            "name": "engageTimeThreshold",
            "variableName": "engageTimeThreshold"
        },
        {
            "kind": "Variable",
            "name": "isPrivacyModeEnabled",
            "variableName": "isPrivacyModeEnabled"
        },
        {
            "kind": "Variable",
            "name": "limit",
            "variableName": "limit"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v10 = {
        "concreteType": "AtlassianUserPhoto",
        "kind": "LinkedField",
        "name": "photos",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "value"
            },
            {
                "kind": "ScalarField",
                "name": "isPrimary"
            }
        ]
    }, v11 = {
        "concreteType": "ContentAnalyticsPageViewInfo",
        "kind": "LinkedField",
        "name": "pageViews",
        "plural": true,
        "selections": [
            {
                "concreteType": "AtlassianUser",
                "kind": "LinkedField",
                "name": "userProfile",
                "plural": false,
                "selections": [
                    v5 /*: any*/ ,
                    v9 /*: any*/ ,
                    v10 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "isActive"
                    }
                ]
            },
            {
                "concreteType": "ConfluenceUser",
                "kind": "LinkedField",
                "name": "confluenceUser",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "permissionType"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "accountType"
            },
            {
                "kind": "ScalarField",
                "name": "agentType"
            },
            {
                "kind": "ScalarField",
                "name": "relatedUserAccountId"
            },
            {
                "concreteType": "AtlassianUser",
                "kind": "LinkedField",
                "name": "relatedUser",
                "plural": false,
                "selections": [
                    v5 /*: any*/ ,
                    v9 /*: any*/ ,
                    v10 /*: any*/ 
                ]
            },
            {
                "kind": "ScalarField",
                "name": "views"
            },
            {
                "kind": "ScalarField",
                "name": "lastViewedAt"
            },
            {
                "kind": "ScalarField",
                "name": "lastVersionViewedNumber"
            },
            {
                "kind": "ScalarField",
                "name": "lastVersionViewedUrl"
            },
            {
                "kind": "ScalarField",
                "name": "isEngaged"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "usePageViewsAnalyticsViewersQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        {
                            "args": v8 /*: any*/ ,
                            "concreteType": "ContentAnalyticsViewsByUser",
                            "kind": "LinkedField",
                            "name": "contentAnalyticsViewsByUser",
                            "plural": false,
                            "selections": [
                                v11 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "usePageViewsAnalyticsViewersQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        {
                            "args": v8 /*: any*/ ,
                            "concreteType": "ContentAnalyticsViewsByUser",
                            "kind": "LinkedField",
                            "name": "contentAnalyticsViewsByUser",
                            "plural": false,
                            "selections": [
                                v11 /*: any*/ ,
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "413598f2025b3debecb0303a1a584a12",
            "id": "cff3923a6d9f1c0ce3bc3c41993bace3777812bbe1258df2681ea4d5d1e58945",
            "metadata": {},
            "name": "usePageViewsAnalyticsViewersQuery",
            "operationKind": "query",
            "text": "query usePageViewsAnalyticsViewersQuery($contentId:ID!,$limit:Int,$engageTimeThreshold:Int,$isPrivacyModeEnabled:Boolean){singleContent(id:$contentId){id,subType,version{number},contentAnalyticsViewsByUser(limit:$limit,engageTimeThreshold:$engageTimeThreshold,isPrivacyModeEnabled:$isPrivacyModeEnabled){pageViews{userProfile{id,displayName,photos{value,isPrimary},isActive},confluenceUser{permissionType},accountType,agentType,relatedUserAccountId,relatedUser{id,displayName,photos{value,isPrimary}},views,lastViewedAt,lastVersionViewedNumber,lastVersionViewedUrl,isEngaged},id}}}"
        }
    };
}();
$f45d24bac38da2fc$var$node.hash = "2259c206b01256262eebd5e59bc6249e";
var $f45d24bac38da2fc$export$2e2bcd8739ae039 = $f45d24bac38da2fc$var$node;
module.exports["default"] = $f45d24bac38da2fc$export$2e2bcd8739ae039;

});

parcelRegister("51PuZ", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $a4kze = parcelRequire("a4kze");


var $6mKj3 = parcelRequire("6mKj3");

/**
 * Shared, query-agnostic classification core for AI-agent page views.
 *
 * Both the Page Analytics viewers table (`agentViewers.ts`) and the byline
 * analytics dialog (`usePageViews.ts`) read agent page views from
 * `ContentAnalyticsPageViewInfo` but shape them into different row models. The
 * *rules* for detecting agents, grouping their views, and resolving an agent's
 * display name + fallback icon are identical, so they live here as the single
 * source of truth.
 *
 * Agents carry no resolvable account id in the analytics data, so identity is
 * resolved entirely locally:
 *   - Source agents ("Atlassian MCP", "Teamwork Graph CLI") → treated as
 *     external/unidentified: folded into the "External agents" row + AI-agent icon.
 *   - Resolved (has `userProfile.displayName`) → that name, hexagon avatar,
 *     grouped by `displayName` (so the same agent under different account ids
 *     consolidates into one row).
 *   - Resolved to a known brand (Cursor, Claude, Claude Code, ChatGPT, Figma, Dia,
 *     Codex) → the brand name + brand icon, grouped by brand, so a product's
 *     per-integration accounts ("Claude Code (atlassian-mcp)", "…-2") read as one row.
 *   - Unresolved + `agentType === 'rovo_chat'` → "Rovo" + Rovo icon.
 *   - Unresolved (any other agentType) → "External agents" (aggregated) or
 *     "External agent" (a single agent attributed to a named person) + AI-agent icon.
 * Unresolved agents of the same type roll up into a single fallback row.
 */ const $67183ad6188fcf05$var$i18n = (0, $kSwu1.defineMessages)({
    unknownAgents: {
        id: "confluence-analytics.agent-classification.unknown-agents",
        defaultMessage: "External agents"
    },
    unknownAgent: {
        id: "confluence-analytics.agent-classification.unknown-agent",
        defaultMessage: "External agent"
    }
});
const $67183ad6188fcf05$export$eab4c408f5abf2ff = (formatMessage)=>formatMessage($67183ad6188fcf05$var$i18n.unknownAgent);
const $67183ad6188fcf05$export$c7c7160dc5a9d33a = 'rovo_chat';
const $67183ad6188fcf05$var$ATLASSIAN_MCP_AGENT_DISPLAY_NAME = 'Atlassian MCP';
const $67183ad6188fcf05$var$TEAMWORK_GRAPH_CLI_AGENT_DISPLAY_NAME = 'Teamwork Graph CLI';
const $67183ad6188fcf05$export$7af4520dc934019f = 'Cursor';
const $67183ad6188fcf05$export$d048749c292c39ba = 'Claude';
const $67183ad6188fcf05$export$7dc1083f44d74774 = 'Claude Code';
const $67183ad6188fcf05$export$31ec687fdc994f09 = 'ChatGPT';
const $67183ad6188fcf05$export$2ea0ce5717de8323 = 'Figma';
const $67183ad6188fcf05$export$6f59e6429875a6c1 = 'Dia';
const $67183ad6188fcf05$export$601e106de03de187 = 'Codex';
/** Group-key prefix for unresolved agents. */ const $67183ad6188fcf05$var$FALLBACK_KEY_PREFIX = '__fallback__:';
const $67183ad6188fcf05$export$4fcfd4291fd95196 = `${$67183ad6188fcf05$var$FALLBACK_KEY_PREFIX}${$67183ad6188fcf05$export$c7c7160dc5a9d33a}`;
const $67183ad6188fcf05$export$e3b8290e8c3dc86b = `${$67183ad6188fcf05$var$FALLBACK_KEY_PREFIX}unknown`;
const $67183ad6188fcf05$var$AGENT_NAME_GROK = 'Grok';
const $67183ad6188fcf05$var$AGENT_NAME_GITHUB_COPILOT = 'GitHub Copilot';
const $67183ad6188fcf05$var$AGENT_NAME_VISUAL_STUDIO_CODE = 'Visual Studio Code';
const $67183ad6188fcf05$var$AGENT_NAME_OPEN_CODE = 'Open Code';
const $67183ad6188fcf05$var$AGENT_NAME_HERMES_AGENT = 'Hermes Agent';
const $67183ad6188fcf05$var$AGENT_NAME_KIRO = 'Kiro';
const $67183ad6188fcf05$var$AGENT_NAME_LOVABLE = 'Lovable';
const $67183ad6188fcf05$var$AGENT_NAME_REPLIT = 'Replit';
const $67183ad6188fcf05$var$AGENT_NAME_CANVA = 'Canva';
const $67183ad6188fcf05$var$AGENT_NAME_FIRST_PARTY = '1P';
const $67183ad6188fcf05$var$AGENT_NAME_AMPLITUDE = 'Amplitude';
const $67183ad6188fcf05$var$AGENT_NAME_CORTEX = 'Cortex';
const $67183ad6188fcf05$var$AGENT_NAME_DATABRICKS = 'Databricks';
const $67183ad6188fcf05$var$AGENT_NAME_MANUS = 'Manus';
const $67183ad6188fcf05$var$AGENT_NAME_OPENAI = 'OpenAI';
const $67183ad6188fcf05$var$AGENT_NAME_SLACK = 'Slack';
const $67183ad6188fcf05$var$PRIORITY_AGENT_TYPE_KEYS = new Set([
    'figma',
    'lovable',
    'replit',
    'canva',
    'first_party',
    'amplitude',
    'chatgpt',
    'cortex',
    'databricks',
    'github_copilot',
    'manus',
    'openai',
    'slack',
    'antigravity',
    'gemini',
    'microsoft_copilot',
    'claude',
    'codex',
    'cursor',
    'dia',
    'grok',
    'hermes',
    'kiro',
    'vscode'
]);
// Preserve the previous experiment's rollout independently of the Presence rollout.
const $67183ad6188fcf05$var$LEGACY_AGENT_TYPE_KEYS = new Set([
    'claude',
    'codex',
    'cursor',
    'chatgpt',
    'dia',
    'grok',
    'github_copilot',
    'vscode',
    'open_code',
    'hermes',
    'kiro',
    $67183ad6188fcf05$export$c7c7160dc5a9d33a
]);
const $67183ad6188fcf05$export$e2808ca494c2d9be = (agentType)=>{
    const normalized = agentType?.trim().toLowerCase();
    return Boolean(normalized && $67183ad6188fcf05$var$LEGACY_AGENT_TYPE_KEYS.has(normalized));
};
const $67183ad6188fcf05$export$f0cc0dee841bf490 = (agentType)=>{
    const normalized = agentType?.trim().toLowerCase();
    return Boolean(normalized && $67183ad6188fcf05$var$PRIORITY_AGENT_TYPE_KEYS.has(normalized));
};
const $67183ad6188fcf05$var$KNOWN_AGENT_TYPE_BRANDS = {
    antigravity: {
        name: 'Antigravity',
        agentIcon: 'antigravity',
        groupKey: 'Antigravity'
    },
    gemini: {
        name: 'Gemini',
        agentIcon: 'gemini',
        groupKey: 'Gemini'
    },
    microsoft_copilot: {
        name: 'Microsoft Copilot',
        agentIcon: 'microsoft-copilot',
        groupKey: 'Microsoft Copilot'
    },
    claude: {
        name: $67183ad6188fcf05$export$d048749c292c39ba,
        agentIcon: 'claude',
        groupKey: $67183ad6188fcf05$export$d048749c292c39ba
    },
    codex: {
        name: $67183ad6188fcf05$export$601e106de03de187,
        agentIcon: 'codex',
        groupKey: $67183ad6188fcf05$export$601e106de03de187
    },
    cursor: {
        name: $67183ad6188fcf05$export$7af4520dc934019f,
        agentIcon: 'cursor',
        groupKey: $67183ad6188fcf05$export$7af4520dc934019f
    },
    chatgpt: {
        name: $67183ad6188fcf05$export$31ec687fdc994f09,
        agentIcon: 'chatgpt',
        groupKey: $67183ad6188fcf05$export$31ec687fdc994f09
    },
    dia: {
        name: $67183ad6188fcf05$export$6f59e6429875a6c1,
        agentIcon: 'dia',
        groupKey: $67183ad6188fcf05$export$6f59e6429875a6c1
    },
    figma: {
        name: $67183ad6188fcf05$export$2ea0ce5717de8323,
        agentIcon: 'figma',
        groupKey: $67183ad6188fcf05$export$2ea0ce5717de8323
    },
    lovable: {
        name: $67183ad6188fcf05$var$AGENT_NAME_LOVABLE,
        agentIcon: 'lovable',
        groupKey: $67183ad6188fcf05$var$AGENT_NAME_LOVABLE
    },
    replit: {
        name: $67183ad6188fcf05$var$AGENT_NAME_REPLIT,
        agentIcon: 'replit',
        groupKey: $67183ad6188fcf05$var$AGENT_NAME_REPLIT
    },
    canva: {
        name: $67183ad6188fcf05$var$AGENT_NAME_CANVA,
        agentIcon: 'canva',
        groupKey: $67183ad6188fcf05$var$AGENT_NAME_CANVA
    },
    grok: {
        name: $67183ad6188fcf05$var$AGENT_NAME_GROK,
        agentIcon: 'grok',
        groupKey: $67183ad6188fcf05$var$AGENT_NAME_GROK
    },
    github_copilot: {
        name: $67183ad6188fcf05$var$AGENT_NAME_GITHUB_COPILOT,
        agentIcon: 'github-copilot',
        groupKey: $67183ad6188fcf05$var$AGENT_NAME_GITHUB_COPILOT
    },
    vscode: {
        name: $67183ad6188fcf05$var$AGENT_NAME_VISUAL_STUDIO_CODE,
        agentIcon: 'vscode',
        groupKey: $67183ad6188fcf05$var$AGENT_NAME_VISUAL_STUDIO_CODE
    },
    open_code: {
        name: $67183ad6188fcf05$var$AGENT_NAME_OPEN_CODE,
        agentIcon: 'open-code',
        groupKey: $67183ad6188fcf05$var$AGENT_NAME_OPEN_CODE
    },
    hermes: {
        name: $67183ad6188fcf05$var$AGENT_NAME_HERMES_AGENT,
        agentIcon: 'hermes',
        groupKey: $67183ad6188fcf05$var$AGENT_NAME_HERMES_AGENT
    },
    kiro: {
        name: $67183ad6188fcf05$var$AGENT_NAME_KIRO,
        agentIcon: 'kiro',
        groupKey: $67183ad6188fcf05$var$AGENT_NAME_KIRO
    },
    first_party: {
        name: $67183ad6188fcf05$var$AGENT_NAME_FIRST_PARTY,
        agentIcon: 'first-party',
        groupKey: $67183ad6188fcf05$var$AGENT_NAME_FIRST_PARTY
    },
    amplitude: {
        name: $67183ad6188fcf05$var$AGENT_NAME_AMPLITUDE,
        agentIcon: 'amplitude',
        groupKey: $67183ad6188fcf05$var$AGENT_NAME_AMPLITUDE
    },
    cortex: {
        name: $67183ad6188fcf05$var$AGENT_NAME_CORTEX,
        agentIcon: 'cortex',
        groupKey: $67183ad6188fcf05$var$AGENT_NAME_CORTEX
    },
    databricks: {
        name: $67183ad6188fcf05$var$AGENT_NAME_DATABRICKS,
        agentIcon: 'databricks',
        groupKey: $67183ad6188fcf05$var$AGENT_NAME_DATABRICKS
    },
    manus: {
        name: $67183ad6188fcf05$var$AGENT_NAME_MANUS,
        agentIcon: 'manus',
        groupKey: $67183ad6188fcf05$var$AGENT_NAME_MANUS
    },
    openai: {
        name: $67183ad6188fcf05$var$AGENT_NAME_OPENAI,
        agentIcon: 'openai',
        groupKey: $67183ad6188fcf05$var$AGENT_NAME_OPENAI
    },
    slack: {
        name: $67183ad6188fcf05$var$AGENT_NAME_SLACK,
        agentIcon: 'slack',
        groupKey: $67183ad6188fcf05$var$AGENT_NAME_SLACK
    },
    [$67183ad6188fcf05$export$c7c7160dc5a9d33a]: {
        name: 'Rovo',
        agentIcon: 'rovo',
        groupKey: $67183ad6188fcf05$export$4fcfd4291fd95196
    }
};
const $67183ad6188fcf05$var$EXTERNAL_AGENT_TYPES = new Set([
    'twg',
    'mcp'
]);
const $67183ad6188fcf05$export$2cbed9b06ea7b2c1 = (pageView)=>pageView.accountType === 'AGENT' || pageView.agentType != null && pageView.agentType !== '';
const $67183ad6188fcf05$export$939c7376dc073a78 = (pageView)=>!!pageView.userProfile?.displayName;
const $67183ad6188fcf05$export$70ce5fa8ab74e3a = (record)=>{
    const relatedAccountId = record.relatedUserAccountId ?? record.relatedUser?.id;
    if (!relatedAccountId) return false;
    return relatedAccountId === record.userProfile?.id || relatedAccountId === record.accountId;
};
const $67183ad6188fcf05$export$5f3f502685876df = (agentType)=>{
    const normalized = agentType?.trim().toLowerCase();
    if (!normalized) return undefined;
    if ($67183ad6188fcf05$var$EXTERNAL_AGENT_TYPES.has(normalized)) return {
        kind: 'external'
    };
    const brand = Object.prototype.hasOwnProperty.call($67183ad6188fcf05$var$KNOWN_AGENT_TYPE_BRANDS, normalized) ? $67183ad6188fcf05$var$KNOWN_AGENT_TYPE_BRANDS[normalized] : undefined;
    if (brand) return {
        kind: 'brand',
        ...brand
    };
    return undefined;
};
const $67183ad6188fcf05$export$ec814f1a9aeb4b71 = (record)=>{
    const mapping = $67183ad6188fcf05$export$5f3f502685876df(record.agentType);
    return $67183ad6188fcf05$export$70ce5fa8ab74e3a(record) && mapping?.kind === 'brand' ? mapping : undefined;
};
/**
 * Source agents (e.g. Atlassian MCP, Teamwork Graph CLI) resolve to a display
 * name but represent activity from agents without a unique identifier, so they
 * are treated as external/unidentified rather than named agents.
 */ const $67183ad6188fcf05$var$isUnidentifiedSourceAgent = (pageView)=>pageView.userProfile?.displayName === $67183ad6188fcf05$var$ATLASSIAN_MCP_AGENT_DISPLAY_NAME || pageView.userProfile?.displayName === $67183ad6188fcf05$var$TEAMWORK_GRAPH_CLI_AGENT_DISPLAY_NAME;
/**
 * Analytics handles the exact "Rovo" name separately under ai_agent_analytics.
 * Exclude Rovo brand matches here to preserve that policy and keep suffixed Rovo
 * accounts grouped by their own display name, with their own avatar.
 */ const $67183ad6188fcf05$var$getAgentBrand = (displayName)=>{
    const brand = (0, $a4kze.getAgentBrand)(displayName);
    return brand?.agentIcon === 'rovo' ? undefined : brand;
};
const $67183ad6188fcf05$var$getProfileAvatarUrl = (userProfile)=>userProfile?.avatarUrl ?? userProfile?.photos?.find((photo)=>photo?.isPrimary)?.value ?? userProfile?.photos?.find(Boolean)?.value ?? undefined;
const $67183ad6188fcf05$var$ROVO_FALLBACK_DISPLAY_NAME = 'Rovo';
const $67183ad6188fcf05$export$f947ba472de8fa33 = (pageView)=>{
    const typeMapping = $67183ad6188fcf05$export$5f3f502685876df(pageView.agentType);
    if (typeMapping?.kind === 'external') return $67183ad6188fcf05$export$e3b8290e8c3dc86b;
    if (typeMapping?.kind === 'brand' && $67183ad6188fcf05$export$f0cc0dee841bf490(pageView.agentType) && (0, $6mKj3.expVal)('dual_agent_avatar_card', 'isEnabled', false)) return typeMapping.groupKey;
    if (typeMapping?.kind === 'brand' && $67183ad6188fcf05$export$e2808ca494c2d9be(pageView.agentType) && (0, $6mKj3.expVal)('dual_agent_avatar_card', 'isEnabled', false)) return typeMapping.groupKey;
    if ($67183ad6188fcf05$var$isUnidentifiedSourceAgent(pageView)) return $67183ad6188fcf05$export$e3b8290e8c3dc86b;
    if ($67183ad6188fcf05$export$939c7376dc073a78(pageView)) {
        const displayName = pageView.userProfile?.displayName ?? '';
        if (displayName === $67183ad6188fcf05$var$ROVO_FALLBACK_DISPLAY_NAME && (0, $6mKj3.expVal)('ai_agent_analytics', 'isEnabled', false)) return $67183ad6188fcf05$export$4fcfd4291fd95196;
        return $67183ad6188fcf05$var$getAgentBrand(displayName)?.name ?? displayName;
    }
    return pageView.agentType === $67183ad6188fcf05$export$c7c7160dc5a9d33a ? $67183ad6188fcf05$export$4fcfd4291fd95196 : $67183ad6188fcf05$export$e3b8290e8c3dc86b;
};
const $67183ad6188fcf05$export$ff6ff512b7960604 = (agentGroupKeyValue)=>agentGroupKeyValue === $67183ad6188fcf05$export$e3b8290e8c3dc86b;
const $67183ad6188fcf05$export$2d687ba75dd39eaa = (agentGroupKeyValue)=>agentGroupKeyValue === $67183ad6188fcf05$export$e3b8290e8c3dc86b;
const $67183ad6188fcf05$export$c9407f416ee8a7ec = (records, formatMessage)=>{
    const typeMapping = $67183ad6188fcf05$export$5f3f502685876df(records[0]?.agentType);
    if (records.some((record)=>$67183ad6188fcf05$export$5f3f502685876df(record.agentType)?.kind === 'external')) return {
        name: formatMessage($67183ad6188fcf05$var$i18n.unknownAgents),
        agentIcon: 'ai-agent'
    };
    if (typeMapping?.kind === 'brand' && $67183ad6188fcf05$export$f0cc0dee841bf490(records[0]?.agentType) && (0, $6mKj3.expVal)('dual_agent_avatar_card', 'isEnabled', false)) return {
        name: typeMapping.name,
        agentIcon: typeMapping.agentIcon
    };
    if (typeMapping?.kind === 'brand' && $67183ad6188fcf05$export$e2808ca494c2d9be(records[0]?.agentType) && (0, $6mKj3.expVal)('dual_agent_avatar_card', 'isEnabled', false)) return {
        name: typeMapping.name,
        agentIcon: typeMapping.agentIcon
    };
    const resolvedProfile = records.filter((record)=>!$67183ad6188fcf05$var$isUnidentifiedSourceAgent(record)).find((record)=>record.userProfile?.displayName)?.userProfile;
    if (records.some($67183ad6188fcf05$var$isUnidentifiedSourceAgent)) return {
        name: formatMessage($67183ad6188fcf05$var$i18n.unknownAgents),
        agentIcon: 'ai-agent'
    };
    if (resolvedProfile?.displayName) {
        // The Cursor/Claude/Claude Code/ChatGPT/Figma/Dia/Codex agents resolve to a real
        // account, but we show the brand name + brand icon rather than the account's own name
        // and `picture`, so per-integration variants (e.g. "Claude Code (atlassian-mcp)") read
        // as the single product row they are grouped into by `agentGroupKey`.
        const brand = $67183ad6188fcf05$var$getAgentBrand(resolvedProfile.displayName);
        if (brand) return {
            name: brand.name,
            agentIcon: brand.agentIcon
        };
        if (resolvedProfile.displayName === $67183ad6188fcf05$var$ROVO_FALLBACK_DISPLAY_NAME && (0, $6mKj3.expVal)('ai_agent_analytics', 'isEnabled', false)) return {
            name: $67183ad6188fcf05$var$ROVO_FALLBACK_DISPLAY_NAME,
            agentIcon: 'rovo'
        };
        return {
            name: resolvedProfile.displayName,
            avatarUrl: $67183ad6188fcf05$var$getProfileAvatarUrl(resolvedProfile)
        };
    }
    if (records[0]?.agentType === $67183ad6188fcf05$export$c7c7160dc5a9d33a) return {
        name: 'Rovo',
        agentIcon: 'rovo'
    };
    return {
        name: formatMessage($67183ad6188fcf05$var$i18n.unknownAgents),
        agentIcon: 'ai-agent'
    };
};
module.exports["getUnknownAgentSingularName"] = $67183ad6188fcf05$export$eab4c408f5abf2ff;
module.exports["AGENT_TYPE_ROVO_CHAT"] = $67183ad6188fcf05$export$c7c7160dc5a9d33a;
module.exports["isLegacyAgentType"] = $67183ad6188fcf05$export$e2808ca494c2d9be;
module.exports["isPriorityAgentType"] = $67183ad6188fcf05$export$f0cc0dee841bf490;
module.exports["isAgentPageView"] = $67183ad6188fcf05$export$2cbed9b06ea7b2c1;
module.exports["isSelfAttributedAgentRecord"] = $67183ad6188fcf05$export$70ce5fa8ab74e3a;
module.exports["getAgentTypeMapping"] = $67183ad6188fcf05$export$5f3f502685876df;
module.exports["getAutonomousAgentBrand"] = $67183ad6188fcf05$export$ec814f1a9aeb4b71;
module.exports["agentGroupKey"] = $67183ad6188fcf05$export$f947ba472de8fa33;
module.exports["isUnknownAgentGroupKey"] = $67183ad6188fcf05$export$ff6ff512b7960604;
module.exports["isUnidentifiedAgentGroupKey"] = $67183ad6188fcf05$export$2d687ba75dd39eaa;
module.exports["resolveAgentNameAndIcon"] = $67183ad6188fcf05$export$c9407f416ee8a7ec;

});

parcelRegister("eycex", function(module, exports) {

var $9HT4T = parcelRequire("9HT4T");


var $7Hsin = parcelRequire("7Hsin");


var $lVCPj = parcelRequire("lVCPj");

const $f2c2b299bdb4781d$var$previewFile = (0, (/*@__PURE__*/$parcel$interopDefault($9HT4T)));
const $f2c2b299bdb4781d$var$autonomousPreviewFile = {
    agents: $f2c2b299bdb4781d$var$previewFile.agents.filter((agent)=>agent.accountId === agent.relatedUserAccountId)
};
const $f2c2b299bdb4781d$var$assistivePreviewFile = {
    agents: $f2c2b299bdb4781d$var$previewFile.agents.filter((agent)=>agent.accountId !== agent.relatedUserAccountId)
};
const $f2c2b299bdb4781d$var$inProgressPreviewFile = (0, (/*@__PURE__*/$parcel$interopDefault($7Hsin)));
const $f2c2b299bdb4781d$var$priorityPreviewFile = (0, (/*@__PURE__*/$parcel$interopDefault($lVCPj)));
const $f2c2b299bdb4781d$export$6ceda4efcbdb98fd = ()=>$f2c2b299bdb4781d$var$previewFile.agents;
const $f2c2b299bdb4781d$export$fadc097792cf4773 = ()=>$f2c2b299bdb4781d$var$inProgressPreviewFile.agents;
const $f2c2b299bdb4781d$export$2197c31f5545182 = ()=>$f2c2b299bdb4781d$var$priorityPreviewFile.agents;
const $f2c2b299bdb4781d$var$toPreviewUser = (id, displayName)=>id && displayName ? {
        id: id,
        displayName: displayName,
        photos: [],
        isActive: true
    } : null;
const $f2c2b299bdb4781d$var$toPageViews = (file)=>file.agents.map((agent)=>({
            accountType: 'AGENT',
            agentType: agent.agentType,
            userProfile: $f2c2b299bdb4781d$var$toPreviewUser(agent.accountId, agent.displayName),
            relatedUserAccountId: agent.relatedUserAccountId,
            relatedUser: $f2c2b299bdb4781d$var$toPreviewUser(agent.relatedUserAccountId, agent.relatedUserDisplayName),
            confluenceUser: {
                permissionType: 'APP'
            },
            views: agent.views,
            lastViewedAt: agent.lastViewedAt,
            lastVersionViewedNumber: 1,
            lastVersionViewedUrl: '',
            isEngaged: false
        }));
const $f2c2b299bdb4781d$export$90b6cb4a5d0b034a = ()=>$f2c2b299bdb4781d$var$toPageViews($f2c2b299bdb4781d$var$previewFile);
const $f2c2b299bdb4781d$export$5d9f78b4f211410d = ()=>$f2c2b299bdb4781d$var$toPageViews($f2c2b299bdb4781d$var$inProgressPreviewFile);
const $f2c2b299bdb4781d$export$6889461c1703f10e = ()=>$f2c2b299bdb4781d$var$toPageViews($f2c2b299bdb4781d$var$priorityPreviewFile);
const $f2c2b299bdb4781d$export$108396eece6bba1d = (isAgentTypesEnabled, isPriorityTypesEnabled)=>{
    if (!isAgentTypesEnabled) return [];
    if (isPriorityTypesEnabled) return [
        ...$f2c2b299bdb4781d$var$toPageViews($f2c2b299bdb4781d$var$autonomousPreviewFile),
        ...$f2c2b299bdb4781d$export$5d9f78b4f211410d(),
        ...$f2c2b299bdb4781d$export$6889461c1703f10e()
    ];
    return [
        ...$f2c2b299bdb4781d$var$toPageViews($f2c2b299bdb4781d$var$autonomousPreviewFile),
        ...$f2c2b299bdb4781d$export$6889461c1703f10e(),
        ...$f2c2b299bdb4781d$var$toPageViews($f2c2b299bdb4781d$var$assistivePreviewFile)
    ];
};
const $f2c2b299bdb4781d$var$toActivityByUser = (file)=>file.agents.map((agent)=>({
            accountId: agent.accountId,
            accountType: 'AGENT',
            agentType: agent.agentType,
            relatedUserAccountId: agent.relatedUserAccountId,
            viewed: agent.views,
            created: agent.created,
            updated: agent.updated,
            commentCreated: agent.commentCreated,
            searchPerformed: agent.searchPerformed
        }));
const $f2c2b299bdb4781d$export$7a84ab201937e031 = ()=>$f2c2b299bdb4781d$var$toActivityByUser($f2c2b299bdb4781d$var$previewFile);
const $f2c2b299bdb4781d$export$f0beb945db31ca2 = ()=>$f2c2b299bdb4781d$var$toActivityByUser($f2c2b299bdb4781d$var$inProgressPreviewFile);
const $f2c2b299bdb4781d$export$7065b3eb14e0c2a4 = ()=>$f2c2b299bdb4781d$var$toActivityByUser($f2c2b299bdb4781d$var$priorityPreviewFile);
const $f2c2b299bdb4781d$export$875ddfbef4a71881 = (isAgentTypesEnabled, isPriorityTypesEnabled)=>{
    if (!isAgentTypesEnabled) return [];
    if (isPriorityTypesEnabled) return [
        ...$f2c2b299bdb4781d$var$toActivityByUser($f2c2b299bdb4781d$var$autonomousPreviewFile),
        ...$f2c2b299bdb4781d$export$f0beb945db31ca2(),
        ...$f2c2b299bdb4781d$export$7065b3eb14e0c2a4()
    ];
    return [
        ...$f2c2b299bdb4781d$var$toActivityByUser($f2c2b299bdb4781d$var$autonomousPreviewFile),
        ...$f2c2b299bdb4781d$export$7065b3eb14e0c2a4(),
        ...$f2c2b299bdb4781d$var$toActivityByUser($f2c2b299bdb4781d$var$assistivePreviewFile)
    ];
};
const $f2c2b299bdb4781d$var$toRelatedUserDetails = (file)=>{
    const details = {};
    for (const agent of file.agents)if (agent.relatedUserAccountId && agent.relatedUserDisplayName) details[agent.relatedUserAccountId] = {
        displayName: agent.relatedUserDisplayName,
        profilePicPath: null
    };
    return details;
};
const $f2c2b299bdb4781d$export$28bd8fc667123934 = ()=>$f2c2b299bdb4781d$var$toRelatedUserDetails($f2c2b299bdb4781d$var$previewFile);
const $f2c2b299bdb4781d$export$7e1eee1bdd2f6628 = ()=>$f2c2b299bdb4781d$var$toRelatedUserDetails($f2c2b299bdb4781d$var$inProgressPreviewFile);
const $f2c2b299bdb4781d$export$3d569c2cdb15b818 = ()=>$f2c2b299bdb4781d$var$toRelatedUserDetails($f2c2b299bdb4781d$var$priorityPreviewFile);
const $f2c2b299bdb4781d$export$50830ea5c911779a = (isAgentTypesEnabled, isPriorityTypesEnabled)=>{
    if (!isAgentTypesEnabled) return {};
    if (isPriorityTypesEnabled) return {
        ...$f2c2b299bdb4781d$export$3d569c2cdb15b818(),
        ...$f2c2b299bdb4781d$export$7e1eee1bdd2f6628()
    };
    return {
        ...$f2c2b299bdb4781d$export$3d569c2cdb15b818(),
        ...$f2c2b299bdb4781d$export$28bd8fc667123934()
    };
};
module.exports["getAgentTypePreviewAgents"] = $f2c2b299bdb4781d$export$6ceda4efcbdb98fd;
module.exports["getInProgressAgentTypePreviewAgents"] = $f2c2b299bdb4781d$export$fadc097792cf4773;
module.exports["getPriorityAgentTypePreviewAgents"] = $f2c2b299bdb4781d$export$2197c31f5545182;
module.exports["toInjectedAgentTypePreviewPageViews"] = $f2c2b299bdb4781d$export$108396eece6bba1d;
module.exports["toInjectedAgentTypePreviewActivityByUser"] = $f2c2b299bdb4781d$export$875ddfbef4a71881;
module.exports["toInjectedAgentTypePreviewRelatedUserDetails"] = $f2c2b299bdb4781d$export$50830ea5c911779a;

});

parcelRegister("9HT4T", function(module, exports) {
module.exports = JSON.parse("{\"agents\":[{\"agentType\":\"grok\",\"accountId\":\"712020:mock-agent-grok\",\"displayName\":\"Grok session\",\"views\":96,\"created\":4,\"updated\":2,\"commentCreated\":1,\"searchPerformed\":0,\"relatedUserAccountId\":\"712020:mock-human-alex\",\"relatedUserDisplayName\":\"Alex Rivera\",\"lastViewedAt\":\"2026-08-21T15:04:00.000Z\"},{\"agentType\":\"grok\",\"accountId\":\"712020:mock-agent-grok\",\"displayName\":\"Grok session\",\"views\":42,\"created\":2,\"updated\":1,\"commentCreated\":1,\"searchPerformed\":0,\"relatedUserAccountId\":\"712020:mock-agent-grok\",\"relatedUserDisplayName\":\"Grok session\",\"lastViewedAt\":\"2026-08-21T16:12:00.000Z\"},{\"agentType\":\"github_copilot\",\"accountId\":\"712020:mock-agent-github-copilot\",\"displayName\":\"Copilot session\",\"views\":88,\"created\":3,\"updated\":1,\"commentCreated\":0,\"searchPerformed\":0,\"relatedUserAccountId\":\"712020:mock-human-alex\",\"relatedUserDisplayName\":\"Alex Rivera\",\"lastViewedAt\":\"2026-08-21T14:50:00.000Z\"},{\"agentType\":\"vscode\",\"accountId\":\"712020:mock-agent-vscode\",\"displayName\":\"VS Code session\",\"views\":81,\"created\":2,\"updated\":2,\"commentCreated\":0,\"searchPerformed\":1,\"relatedUserAccountId\":\"712020:mock-human-alex\",\"relatedUserDisplayName\":\"Alex Rivera\",\"lastViewedAt\":\"2026-08-21T14:20:00.000Z\"},{\"agentType\":\"open_code\",\"accountId\":\"712020:mock-agent-open-code\",\"displayName\":\"Open Code session\",\"views\":74,\"created\":1,\"updated\":0,\"commentCreated\":0,\"searchPerformed\":0,\"relatedUserAccountId\":\"712020:mock-human-sam\",\"relatedUserDisplayName\":\"Sam Chen\",\"lastViewedAt\":\"2026-08-21T13:40:00.000Z\"},{\"agentType\":\"kiro\",\"accountId\":\"712020:mock-agent-kiro\",\"displayName\":\"Kiro session\",\"views\":61,\"created\":2,\"updated\":1,\"commentCreated\":0,\"searchPerformed\":0,\"relatedUserAccountId\":\"712020:mock-human-sam\",\"relatedUserDisplayName\":\"Sam Chen\",\"lastViewedAt\":\"2026-08-21T13:10:00.000Z\"},{\"agentType\":\"hermes\",\"accountId\":\"712020:mock-agent-hermes\",\"displayName\":\"Hermes session\",\"views\":67,\"created\":5,\"updated\":3,\"commentCreated\":2,\"searchPerformed\":0,\"relatedUserAccountId\":\"712020:mock-human-sam\",\"relatedUserDisplayName\":\"Sam Chen\",\"lastViewedAt\":\"2026-08-21T12:45:00.000Z\"}]}");

});

parcelRegister("7Hsin", function(module, exports) {
module.exports = JSON.parse("{\"agents\":[{\"agentType\":\"mcp\",\"accountId\":\"712020:mock-agent-external\",\"displayName\":\"External session\",\"views\":110,\"created\":5,\"updated\":2,\"commentCreated\":1,\"searchPerformed\":0,\"relatedUserAccountId\":\"712020:mock-human-alex\",\"relatedUserDisplayName\":\"Alex Rivera\",\"lastViewedAt\":\"2026-08-21T15:30:00.000Z\"},{\"agentType\":\"cursor\",\"accountId\":\"712020:mock-agent-cursor\",\"displayName\":\"Cursor session\",\"views\":104,\"created\":4,\"updated\":2,\"commentCreated\":0,\"searchPerformed\":1,\"relatedUserAccountId\":\"712020:mock-human-alex\",\"relatedUserDisplayName\":\"Alex Rivera\",\"lastViewedAt\":\"2026-08-21T15:18:00.000Z\"},{\"agentType\":\"canva\",\"accountId\":\"712020:mock-agent-canva\",\"displayName\":\"Canva session\",\"views\":99,\"created\":3,\"updated\":1,\"commentCreated\":1,\"searchPerformed\":0,\"relatedUserAccountId\":\"712020:mock-human-sam\",\"relatedUserDisplayName\":\"Sam Chen\",\"lastViewedAt\":\"2026-08-21T15:10:00.000Z\"},{\"agentType\":\"claude\",\"accountId\":\"712020:mock-agent-claude\",\"displayName\":\"Claude session\",\"views\":96,\"created\":4,\"updated\":2,\"commentCreated\":1,\"searchPerformed\":0,\"relatedUserAccountId\":\"712020:mock-human-alex\",\"relatedUserDisplayName\":\"Alex Rivera\",\"lastViewedAt\":\"2026-08-21T15:04:00.000Z\"},{\"agentType\":\"codex\",\"accountId\":\"712020:mock-agent-codex\",\"displayName\":\"Codex session\",\"views\":88,\"created\":3,\"updated\":1,\"commentCreated\":0,\"searchPerformed\":0,\"relatedUserAccountId\":\"712020:mock-human-alex\",\"relatedUserDisplayName\":\"Alex Rivera\",\"lastViewedAt\":\"2026-08-21T14:50:00.000Z\"},{\"agentType\":\"rovo_chat\",\"accountId\":\"712020:mock-agent-rovo\",\"displayName\":\"Rovo session\",\"views\":81,\"created\":2,\"updated\":2,\"commentCreated\":0,\"searchPerformed\":1,\"relatedUserAccountId\":\"712020:mock-human-sam\",\"relatedUserDisplayName\":\"Sam Chen\",\"lastViewedAt\":\"2026-08-21T14:20:00.000Z\"},{\"agentType\":\"first_party\",\"accountId\":\"712020:mock-agent-first-party\",\"displayName\":\"1P session\",\"views\":80,\"created\":2,\"updated\":1,\"commentCreated\":1,\"searchPerformed\":0,\"relatedUserAccountId\":\"712020:mock-human-alex\",\"relatedUserDisplayName\":\"Alex Rivera\",\"lastViewedAt\":\"2026-08-21T14:10:00.000Z\"},{\"agentType\":\"amplitude\",\"accountId\":\"712020:mock-agent-amplitude\",\"displayName\":\"Amplitude session\",\"views\":78,\"created\":1,\"updated\":2,\"commentCreated\":0,\"searchPerformed\":1,\"relatedUserAccountId\":\"712020:mock-human-sam\",\"relatedUserDisplayName\":\"Sam Chen\",\"lastViewedAt\":\"2026-08-21T14:00:00.000Z\"},{\"agentType\":\"antigravity\",\"accountId\":\"712020:mock-agent-antigravity\",\"displayName\":\"Antigravity session\",\"views\":77,\"created\":3,\"updated\":1,\"commentCreated\":0,\"searchPerformed\":0,\"relatedUserAccountId\":\"712020:mock-human-alex\",\"relatedUserDisplayName\":\"Alex Rivera\",\"lastViewedAt\":\"2026-08-21T13:50:00.000Z\"},{\"agentType\":\"chatgpt\",\"accountId\":\"712020:mock-agent-chatgpt\",\"displayName\":\"ChatGPT session\",\"views\":76,\"created\":2,\"updated\":1,\"commentCreated\":1,\"searchPerformed\":0,\"relatedUserAccountId\":\"712020:mock-human-sam\",\"relatedUserDisplayName\":\"Sam Chen\",\"lastViewedAt\":\"2026-08-21T13:40:00.000Z\"},{\"agentType\":\"cortex\",\"accountId\":\"712020:mock-agent-cortex\",\"displayName\":\"Cortex session\",\"views\":75,\"created\":1,\"updated\":3,\"commentCreated\":0,\"searchPerformed\":1,\"relatedUserAccountId\":\"712020:mock-human-alex\",\"relatedUserDisplayName\":\"Alex Rivera\",\"lastViewedAt\":\"2026-08-21T13:30:00.000Z\"},{\"agentType\":\"databricks\",\"accountId\":\"712020:mock-agent-databricks\",\"displayName\":\"Databricks session\",\"views\":74,\"created\":2,\"updated\":2,\"commentCreated\":0,\"searchPerformed\":0,\"relatedUserAccountId\":\"712020:mock-human-sam\",\"relatedUserDisplayName\":\"Sam Chen\",\"lastViewedAt\":\"2026-08-21T13:20:00.000Z\"},{\"agentType\":\"dia\",\"accountId\":\"712020:mock-agent-dia\",\"displayName\":\"Dia session\",\"views\":73,\"created\":1,\"updated\":1,\"commentCreated\":1,\"searchPerformed\":0,\"relatedUserAccountId\":\"712020:mock-human-alex\",\"relatedUserDisplayName\":\"Alex Rivera\",\"lastViewedAt\":\"2026-08-21T13:10:00.000Z\"},{\"agentType\":\"gemini\",\"accountId\":\"712020:mock-agent-gemini\",\"displayName\":\"Gemini session\",\"views\":72,\"created\":3,\"updated\":2,\"commentCreated\":0,\"searchPerformed\":1,\"relatedUserAccountId\":\"712020:mock-human-sam\",\"relatedUserDisplayName\":\"Sam Chen\",\"lastViewedAt\":\"2026-08-21T13:00:00.000Z\"},{\"agentType\":\"github_copilot\",\"accountId\":\"712020:mock-agent-github-copilot\",\"displayName\":\"GitHub Copilot session\",\"views\":71,\"created\":2,\"updated\":1,\"commentCreated\":0,\"searchPerformed\":0,\"relatedUserAccountId\":\"712020:mock-human-alex\",\"relatedUserDisplayName\":\"Alex Rivera\",\"lastViewedAt\":\"2026-08-21T12:50:00.000Z\"},{\"agentType\":\"grok\",\"accountId\":\"712020:mock-agent-grok\",\"displayName\":\"Grok session\",\"views\":70,\"created\":1,\"updated\":2,\"commentCreated\":1,\"searchPerformed\":0,\"relatedUserAccountId\":\"712020:mock-human-sam\",\"relatedUserDisplayName\":\"Sam Chen\",\"lastViewedAt\":\"2026-08-21T12:40:00.000Z\"},{\"agentType\":\"hermes\",\"accountId\":\"712020:mock-agent-hermes\",\"displayName\":\"Hermes Agent session\",\"views\":69,\"created\":2,\"updated\":1,\"commentCreated\":0,\"searchPerformed\":1,\"relatedUserAccountId\":\"712020:mock-human-alex\",\"relatedUserDisplayName\":\"Alex Rivera\",\"lastViewedAt\":\"2026-08-21T12:30:00.000Z\"},{\"agentType\":\"kiro\",\"accountId\":\"712020:mock-agent-kiro\",\"displayName\":\"Kiro session\",\"views\":68,\"created\":3,\"updated\":2,\"commentCreated\":0,\"searchPerformed\":0,\"relatedUserAccountId\":\"712020:mock-human-sam\",\"relatedUserDisplayName\":\"Sam Chen\",\"lastViewedAt\":\"2026-08-21T12:20:00.000Z\"},{\"agentType\":\"manus\",\"accountId\":\"712020:mock-agent-manus\",\"displayName\":\"Manus session\",\"views\":67,\"created\":1,\"updated\":1,\"commentCreated\":1,\"searchPerformed\":0,\"relatedUserAccountId\":\"712020:mock-human-alex\",\"relatedUserDisplayName\":\"Alex Rivera\",\"lastViewedAt\":\"2026-08-21T12:10:00.000Z\"},{\"agentType\":\"microsoft_copilot\",\"accountId\":\"712020:mock-agent-microsoft-copilot\",\"displayName\":\"Microsoft Copilot session\",\"views\":66,\"created\":2,\"updated\":3,\"commentCreated\":0,\"searchPerformed\":1,\"relatedUserAccountId\":\"712020:mock-human-sam\",\"relatedUserDisplayName\":\"Sam Chen\",\"lastViewedAt\":\"2026-08-21T12:00:00.000Z\"},{\"agentType\":\"openai\",\"accountId\":\"712020:mock-agent-openai\",\"displayName\":\"OpenAI session\",\"views\":65,\"created\":3,\"updated\":1,\"commentCreated\":0,\"searchPerformed\":0,\"relatedUserAccountId\":\"712020:mock-human-alex\",\"relatedUserDisplayName\":\"Alex Rivera\",\"lastViewedAt\":\"2026-08-21T11:50:00.000Z\"},{\"agentType\":\"slack\",\"accountId\":\"712020:mock-agent-slack\",\"displayName\":\"Slack session\",\"views\":64,\"created\":1,\"updated\":2,\"commentCreated\":1,\"searchPerformed\":0,\"relatedUserAccountId\":\"712020:mock-human-sam\",\"relatedUserDisplayName\":\"Sam Chen\",\"lastViewedAt\":\"2026-08-21T11:40:00.000Z\"},{\"agentType\":\"vscode\",\"accountId\":\"712020:mock-agent-vscode\",\"displayName\":\"Visual Studio Code session\",\"views\":63,\"created\":2,\"updated\":1,\"commentCreated\":0,\"searchPerformed\":1,\"relatedUserAccountId\":\"712020:mock-human-alex\",\"relatedUserDisplayName\":\"Alex Rivera\",\"lastViewedAt\":\"2026-08-21T11:30:00.000Z\"}]}");

});

parcelRegister("lVCPj", function(module, exports) {
module.exports = JSON.parse("{\"agents\":[{\"agentType\":\"figma\",\"accountId\":\"712020:mock-agent-figma\",\"displayName\":\"Figma session\",\"views\":92,\"created\":3,\"updated\":2,\"commentCreated\":1,\"searchPerformed\":0,\"relatedUserAccountId\":\"712020:mock-human-alex\",\"relatedUserDisplayName\":\"Alex Rivera\",\"lastViewedAt\":\"2026-08-21T15:20:00.000Z\"},{\"agentType\":\"lovable\",\"accountId\":\"712020:mock-agent-lovable\",\"displayName\":\"Lovable session\",\"views\":85,\"created\":4,\"updated\":1,\"commentCreated\":0,\"searchPerformed\":0,\"relatedUserAccountId\":\"712020:mock-human-alex\",\"relatedUserDisplayName\":\"Alex Rivera\",\"lastViewedAt\":\"2026-08-21T15:10:00.000Z\"},{\"agentType\":\"replit\",\"accountId\":\"712020:mock-agent-replit\",\"displayName\":\"Replit session\",\"views\":79,\"created\":2,\"updated\":2,\"commentCreated\":0,\"searchPerformed\":1,\"relatedUserAccountId\":\"712020:mock-human-sam\",\"relatedUserDisplayName\":\"Sam Chen\",\"lastViewedAt\":\"2026-08-21T15:00:00.000Z\"}]}");

});

parcelRegister("iijpI", function(module, exports) {

var $lxyQ2 = parcelRequire("lxyQ2");

var $89c065ae24c67492$export$ec2f7d5cc9321319 = /*#__PURE__*/ function(ActorType) {
    ActorType["All"] = "all";
    ActorType["Agent"] = "agent";
    ActorType["People"] = "people";
    return ActorType;
}({});
const $89c065ae24c67492$export$a324ebfaa6bb1279 = "all";
const $89c065ae24c67492$export$bd229db7a51decf1 = "all";
const $89c065ae24c67492$export$6b2d8ce1c97165a8 = 'all';
const $89c065ae24c67492$export$ccbaac385048c4d1 = null;
const $89c065ae24c67492$export$d74ebd7baeb8755e = [
    "agent",
    "people"
];
const $89c065ae24c67492$export$6a0793f74e46c673 = (actorType)=>{
    switch(actorType){
        case "agent":
            return 'AGENTS';
        case "people":
            return 'PEOPLE';
        case "all":
        default:
            return 'ALL';
    }
};
const $89c065ae24c67492$export$d9a836fd726d8258 = (actorType)=>$89c065ae24c67492$export$6a0793f74e46c673(actorType);
const $89c065ae24c67492$export$6d8340b7982757c6 = (actorType, isAiAgentAnalyticsEnabled)=>isAiAgentAnalyticsEnabled ? $89c065ae24c67492$export$6a0793f74e46c673(actorType) : undefined;
const $89c065ae24c67492$export$26cf0921dc28eb3d = (actorType, isEnabled)=>$89c065ae24c67492$export$6d8340b7982757c6(actorType, isEnabled);
const $89c065ae24c67492$export$7303df937b7038a9 = (actorType, isEnabled)=>isEnabled ? actorType : "all";
const $89c065ae24c67492$export$e3bff52591eb3184 = (activityTypes)=>activityTypes.map($89c065ae24c67492$export$6a0793f74e46c673).join(',');
const $89c065ae24c67492$export$7a1a67957238c773 = (activityTypes, isEnabled)=>isEnabled ? $89c065ae24c67492$export$e3bff52591eb3184(activityTypes) : undefined;
const $89c065ae24c67492$export$dc80676529c9d2ff = (activityTypes)=>activityTypes.length === 1 ? activityTypes[0] : "all";
const $89c065ae24c67492$export$58ca1e1c2a69240c = (actorType)=>{
    switch(actorType){
        case "agent":
            return [
                "agent"
            ];
        case "people":
            return [
                "people"
            ];
        case "all":
        default:
            return $89c065ae24c67492$export$d74ebd7baeb8755e;
    }
};
const $89c065ae24c67492$export$bd5b4743f464a7c3 = [
    'global',
    'personal',
    'collaboration',
    'knowledge_base'
];
const $89c065ae24c67492$export$fa731dd295d99d4c = (tab)=>{
    if (tab === (0, $lxyQ2.SiteAnalyticsTab).Spaces || tab === (0, $lxyQ2.SiteAnalyticsTab).Users) return $89c065ae24c67492$export$bd5b4743f464a7c3;
    return [
        'global'
    ];
};
const $89c065ae24c67492$export$d227d6644e5e690 = (spaceType)=>{
    if (spaceType.length === 1 && spaceType[0] === 'global') return true;
    return spaceType.length === $89c065ae24c67492$export$bd5b4743f464a7c3.length && $89c065ae24c67492$export$bd5b4743f464a7c3.every((type)=>spaceType.includes(type));
};
const $89c065ae24c67492$export$5c12bcfd5a371181 = [
    'page',
    'blogpost',
    'livedoc'
];
const $89c065ae24c67492$export$1e1f41b068b58214 = [
    ...$89c065ae24c67492$export$5c12bcfd5a371181,
    'whiteboard',
    'database'
];
module.exports["ActorType"] = $89c065ae24c67492$export$ec2f7d5cc9321319;
module.exports["DEFAULT_ANALYTICS_ACTOR_TYPE"] = $89c065ae24c67492$export$a324ebfaa6bb1279;
module.exports["DEFAULT_PAGE_ANALYTICS_ACTOR_TYPE"] = $89c065ae24c67492$export$bd229db7a51decf1;
module.exports["DEFAULT_PAGE_ANALYTICS_MENTIONS_VIEW_STATE"] = $89c065ae24c67492$export$6b2d8ce1c97165a8;
module.exports["DEFAULT_PAGE_ANALYTICS_ENGAGEMENT_FILTER"] = $89c065ae24c67492$export$ccbaac385048c4d1;
module.exports["DEFAULT_SITE_ANALYTICS_ACTIVITY_TYPES"] = $89c065ae24c67492$export$d74ebd7baeb8755e;
module.exports["getAnalyticsActorType"] = $89c065ae24c67492$export$6a0793f74e46c673;
module.exports["getGatedAnalyticsActorType"] = $89c065ae24c67492$export$6d8340b7982757c6;
module.exports["getGatedPageAnalyticsActorTypeQueryValue"] = $89c065ae24c67492$export$26cf0921dc28eb3d;
module.exports["getGatedPageAnalyticsActorType"] = $89c065ae24c67492$export$7303df937b7038a9;
module.exports["getGatedSiteAnalyticsActivityTypeQueryValue"] = $89c065ae24c67492$export$7a1a67957238c773;
module.exports["getSiteAnalyticsActivityByUserActorType"] = $89c065ae24c67492$export$dc80676529c9d2ff;
module.exports["getSiteAnalyticsActivityTypesFromActorType"] = $89c065ae24c67492$export$58ca1e1c2a69240c;
module.exports["ALL_SITE_SPACE_TYPES"] = $89c065ae24c67492$export$bd5b4743f464a7c3;
module.exports["getDefaultSiteSpaceTypes"] = $89c065ae24c67492$export$fa731dd295d99d4c;
module.exports["isDefaultSiteSpaceTypeSelection"] = $89c065ae24c67492$export$d227d6644e5e690;
module.exports["LEGACY_SPACE_CONTENT_TYPES"] = $89c065ae24c67492$export$5c12bcfd5a371181;
module.exports["ALL_SPACE_CONTENT_TYPES"] = $89c065ae24c67492$export$1e1f41b068b58214;

});

parcelRegister("lxyQ2", function(module, exports) {

var $irVI7 = parcelRequire("irVI7");

const $829fd8e029366927$export$8f5092a35000d0fd = 'analyticsPageScreen';
const $829fd8e029366927$export$7d4a741bc8a8e084 = 'analyticsSearchScreen';
const $829fd8e029366927$export$718591836cad1ed8 = 'instance';
const $829fd8e029366927$export$35932a8133da6919 = 'site-analytics-tabs';
var $829fd8e029366927$export$b37a6ebf0f3a7689 = /*#__PURE__*/ function(SiteAnalyticsTab) {
    SiteAnalyticsTab[SiteAnalyticsTab["Overview"] = 0] = "Overview";
    SiteAnalyticsTab[SiteAnalyticsTab["Spaces"] = 1] = "Spaces";
    SiteAnalyticsTab[SiteAnalyticsTab["Users"] = 2] = "Users";
    SiteAnalyticsTab[SiteAnalyticsTab["Search"] = 3] = "Search";
    return SiteAnalyticsTab;
}({});
const $829fd8e029366927$export$4daaaf7ccc6ce432 = 'site-analytics-active-readers-card';
const $829fd8e029366927$export$4ec793ef68b58f1f = 'site-analytics-active-agents-card';
const $829fd8e029366927$export$71a916b05c2345e8 = 'site-analytics-overview-chart';
const $829fd8e029366927$export$6f03f1345722975f = 'site-analytics-overview-cards-grid';
const $829fd8e029366927$export$b73f2210e9d2eef2 = 'site-analytics-popular-searches-card';
const $829fd8e029366927$export$2e2f0952f7f9fd73 = 'site-analytics-popular-spaces-card';
const $829fd8e029366927$export$ba6665eb2c047b16 = 'site-analytics-search-panel-ctr-card';
const $829fd8e029366927$export$93679d1eeb6e3798 = 'site-analytics-search-panel-most-clicked-content-card';
const $829fd8e029366927$export$21716d3d57c7a6c8 = 'site-analytics-search-panel-most-clicked-spaces-card';
const $829fd8e029366927$export$b411c56a03d140f8 = 'site-analytics-search-panel-searches-card';
const $829fd8e029366927$export$40cd470a4aa2f106 = 'site-analytics-search-panel';
const $829fd8e029366927$export$1f830a2c5ce62517 = 'site-analytics-search-table';
const $829fd8e029366927$export$5119e0141b046a7b = 'site-analytics-spaces-table';
const $829fd8e029366927$export$a7b9d6d50ba9a286 = 'site-analytics-user-table';
const $829fd8e029366927$export$e4b0600052c25d67 = {
    [0]: [
        (0, $irVI7.SITE_ANALYTICS_OVERVIEW_CHART_EXPERIENCE),
        (0, $irVI7.SITE_ANALYTICS_POPULAR_SPACES_CARD_EXPERIENCE),
        (0, $irVI7.SITE_ANALYTICS_ACTIVE_READERS_CARD_EXPERIENCE),
        (0, $irVI7.SITE_ANALYTICS_POPULAR_SEARCHES_CARD_EXPERIENCE)
    ],
    [1]: [
        (0, $irVI7.SITE_ANALYTICS_SPACES_TABLE_EXPERIENCE)
    ],
    [2]: [
        (0, $irVI7.SITE_ANALYTICS_USERS_TABLE_EXPERIENCE)
    ],
    [3]: [
        (0, $irVI7.SITE_ANALYTICS_SEARCH_TABLE_EXPERIENCE)
    ]
};
const $829fd8e029366927$export$ed5650d37f0ec06d = [
    (0, $irVI7.SITE_ANALYTICS_SEARCH_PANEL_GRAPH_EXPERIENCE),
    (0, $irVI7.SITE_ANALYTICS_SEARCH_PANEL_CONTENT_LIST_EXPERIENCE),
    (0, $irVI7.SITE_ANALYTICS_SEARCH_PANEL_SPACES_LIST_EXPERIENCE)
];
module.exports["SITE_ANALYTICS_SCREEN_ANALYTICS_SOURCE"] = $829fd8e029366927$export$8f5092a35000d0fd;
module.exports["SITE_ANALYTICS_SEARCH_ANALYTICS_SOURCE"] = $829fd8e029366927$export$7d4a741bc8a8e084;
module.exports["SITE_ANALYTICS_SCREEN_ANALYTICS_LEVEL"] = $829fd8e029366927$export$718591836cad1ed8;
module.exports["SITE_ANALYTICS_TABS_UI_ID"] = $829fd8e029366927$export$35932a8133da6919;
module.exports["SiteAnalyticsTab"] = $829fd8e029366927$export$b37a6ebf0f3a7689;
module.exports["MOST_ACTIVE_READERS_CARD_TEST_ID"] = $829fd8e029366927$export$4daaaf7ccc6ce432;
module.exports["MOST_ACTIVE_AGENTS_CARD_TEST_ID"] = $829fd8e029366927$export$4ec793ef68b58f1f;
module.exports["OVERVIEW_CHART_TEST_ID"] = $829fd8e029366927$export$71a916b05c2345e8;
module.exports["OVERVIEW_CARDS_GRID_TEST_ID"] = $829fd8e029366927$export$6f03f1345722975f;
module.exports["POPULAR_SEARCHES_CARD_TEST_ID"] = $829fd8e029366927$export$b73f2210e9d2eef2;
module.exports["POPULAR_SPACES_CARD_TEST_ID"] = $829fd8e029366927$export$2e2f0952f7f9fd73;
module.exports["SEARCH_PANEL_CTR_CARD_TEST_ID"] = $829fd8e029366927$export$ba6665eb2c047b16;
module.exports["SEARCH_PANEL_MOST_CLICKED_CONTENT_CARD_TEST_ID"] = $829fd8e029366927$export$93679d1eeb6e3798;
module.exports["SEARCH_PANEL_MOST_CLICKED_SPACES_CARD_TEST_ID"] = $829fd8e029366927$export$21716d3d57c7a6c8;
module.exports["SEARCH_PANEL_SEARCHES_CARD_TEST_ID"] = $829fd8e029366927$export$b411c56a03d140f8;
module.exports["SEARCH_PANEL_TEST_ID"] = $829fd8e029366927$export$40cd470a4aa2f106;
module.exports["SEARCH_TABLE_TEST_ID"] = $829fd8e029366927$export$1f830a2c5ce62517;
module.exports["SPACES_TABLE_TEST_ID"] = $829fd8e029366927$export$5119e0141b046a7b;
module.exports["USER_TABLE_TEST_ID"] = $829fd8e029366927$export$a7b9d6d50ba9a286;
module.exports["SiteAnalyticsSubExperiences"] = $829fd8e029366927$export$e4b0600052c25d67;
module.exports["SearchPanelSubExperiences"] = $829fd8e029366927$export$ed5650d37f0ec06d;

});

parcelRegister("1MB8j", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $euL71 = parcelRequire("euL71");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");

const $c05d08673a543c00$export$c6b8a74a25d01e7c = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] !== edition) {
        t0 = edition === (0, $euL71.ConfluenceEdition).PREMIUM && (0, $9wGTI.fg)("ccir_privacy_mode");
        $[0] = edition;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    return edition === (0, $euL71.ConfluenceEdition).PREMIUM && (0, $9wGTI.fg)('ccir_privacy_mode');
};
module.exports["useIsPrivacyModeEligible"] = $c05d08673a543c00$export$c6b8a74a25d01e7c;

});

parcelRegister("9nqKo", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $6mKj3 = parcelRequire("6mKj3");


var $1xpoY = parcelRequire("1xpoY");


var $iSiFN = parcelRequire("iSiFN");

const $f023d34f74189591$var$AudioContentContext = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $f023d34f74189591$var$AudioContentFragmentProvider = ({ children: children, contentId: contentId, contentFragmentRef: contentFragmentRef })=>{
    const content = (0, $6SsN4.useFragment)((0, $iSiFN.AudioContentFragment), contentFragmentRef ?? null);
    const audioContent = content?.id === contentId ? content : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f023d34f74189591$var$AudioContentContext.Provider, {
        value: audioContent
    }, children);
};
const $f023d34f74189591$export$ca92888d1efa6a7e = ({ children: children, contentId: contentId, contentFragmentRef: contentFragmentRef })=>{
    if (!contentFragmentRef || (0, $1xpoY.default).isKillSwitchOn('confluence_vp_audio_frag_reader') || !(0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f023d34f74189591$var$AudioContentContext.Provider, {
        value: undefined
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f023d34f74189591$var$AudioContentFragmentProvider, {
        contentId: contentId,
        contentFragmentRef: contentFragmentRef
    }, children);
};
const $f023d34f74189591$export$61111ce547e7f8ba = ()=>(0, $cozmU.useContext)($f023d34f74189591$var$AudioContentContext);
module.exports["AudioContentProvider"] = $f023d34f74189591$export$ca92888d1efa6a7e;
module.exports["useAudioContentFragmentData"] = $f023d34f74189591$export$61111ce547e7f8ba;

});

parcelRegister("iSiFN", function(module, exports) {

var $fDQS7 = parcelRequire("fDQS7");

const $b40bdebba97598fa$export$459c3120b35cf218 = (0, $fDQS7.default);
module.exports["AudioContentFragment"] = $b40bdebba97598fa$export$459c3120b35cf218;

});

parcelRegister("fDQS7", function(module, exports) {
/**
 * @generated SignedSource<<7f38d1b6237aafe6550f2b9bc8f46222>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c20cf4cfa88eb93b$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "value"
    }, v2 = [
        {
            "kind": "ScalarField",
            "name": "displayName"
        },
        {
            "concreteType": "Icon",
            "kind": "LinkedField",
            "name": "profilePicture",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "path"
                }
            ]
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "AudioContentFragment_content",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "title"
            },
            {
                "kind": "ScalarField",
                "name": "subType"
            },
            {
                "alias": "emoji",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "key",
                        "value": "emoji-title-published"
                    }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JsonContentProperty",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                            v0 /*: any*/ ,
                            v1 /*: any*/ 
                        ]
                    }
                ],
                "storageKey": "properties(key:\"emoji-title-published\")"
            },
            {
                "concreteType": "History",
                "kind": "LinkedField",
                "name": "history",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": v2 /*: any*/ 
                    },
                    {
                        "kind": "LinkedField",
                        "name": "ownedBy",
                        "plural": false,
                        "selections": v2 /*: any*/ 
                    }
                ]
            },
            {
                "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "webui"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "base"
                    }
                ]
            },
            {
                "alias": "audioProperties",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "keys",
                        "value": [
                            "emoji-title-published",
                            "editor"
                        ]
                    }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JsonContentProperty",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                            v1 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "key"
                            }
                        ]
                    }
                ],
                "storageKey": "properties(keys:[\"emoji-title-published\",\"editor\"])"
            }
        ],
        "type": "Content"
    };
}();
$c20cf4cfa88eb93b$var$node.hash = "b232c7e0b2db86037e433e186b56a94e";
var $c20cf4cfa88eb93b$export$2e2bcd8739ae039 = $c20cf4cfa88eb93b$var$node;
module.exports["default"] = $c20cf4cfa88eb93b$export$2e2bcd8739ae039;

});

parcelRegister("8dynS", function(module, exports) {

var $fR63l = parcelRequire("fR63l");

const $06fddef4acfae0a8$export$9a80c24535b38e83 = 'confluence_3p_smartlink_connection_link_count';
const $06fddef4acfae0a8$export$d02d73057c4016d5 = 'confluence_3p_smartlink_connection_link_count_by_team_type_';
const $06fddef4acfae0a8$var$SUFFICIENCY_THRESHOLD = 20;
const $06fddef4acfae0a8$export$545eb843b77efaec = 3;
const $06fddef4acfae0a8$export$8594dab83de99a34 = [
    'google-drive',
    'slack',
    'github'
];
const $06fddef4acfae0a8$export$5dbf4404d8d730eb = {
    c_suite: [
        'google-drive',
        'slack',
        'github'
    ],
    customer_service: [
        'google-drive',
        'slack',
        'onedrive'
    ],
    data_science: [
        'google-drive',
        'github',
        'slack'
    ],
    design: [
        'google-drive',
        'figma',
        'slack'
    ],
    engineering: [
        'google-drive',
        'github',
        'slack'
    ],
    finance: [
        'google-drive',
        'slack',
        'onedrive'
    ],
    human_resources: [
        'google-drive',
        'slack',
        'onedrive'
    ],
    information_technology: [
        'google-drive',
        'slack',
        'github'
    ],
    legal: [
        'google-drive',
        'slack',
        'sharepoint'
    ],
    marketing: [
        'google-drive',
        'slack',
        'figma'
    ],
    // `na` is the "no signal" floor row — kept in sync with the standalone
    // `DEFAULT_FALLBACK_APPS` export above by referencing the same constant.
    na: $06fddef4acfae0a8$export$8594dab83de99a34,
    operations: [
        'google-drive',
        'slack',
        'onedrive'
    ],
    other: [
        'google-drive',
        'github',
        'slack'
    ],
    product_management: [
        'google-drive',
        'figma',
        'slack'
    ],
    program_management: [
        'google-drive',
        'onedrive',
        'sharepoint'
    ],
    sales: [
        'google-drive',
        'slack',
        'sharepoint'
    ]
};
const $06fddef4acfae0a8$export$db8c8b18ca3de852 = 'na';
const $06fddef4acfae0a8$var$APP_ID_TO_PRODUCT_KEY_ALIASES = {
    drive: (0, $fR63l.ProductKeys3P).GoogleDrive,
    figma: (0, $fR63l.ProductKeys3P).Figma,
    github: (0, $fR63l.ProductKeys3P).Github,
    'google-drive': (0, $fR63l.ProductKeys3P).GoogleDrive,
    onedrive: (0, $fR63l.ProductKeys3P).OneDrive,
    sharepoint: (0, $fR63l.ProductKeys3P).Sharepoint,
    slack: (0, $fR63l.ProductKeys3P).Slack
};
const $06fddef4acfae0a8$export$acda930d8972381e = (raw)=>{
    if (!raw || raw.trim().length === 0) return [];
    return raw.split(',').map((entry)=>entry.trim()).filter((entry)=>entry.length > 0).map((entry)=>{
        const separatorIndex = entry.indexOf(':');
        if (separatorIndex <= 0 || separatorIndex === entry.length - 1) return undefined;
        const appId = entry.slice(0, separatorIndex).trim();
        const count = Number(entry.slice(separatorIndex + 1).trim());
        if (appId.length === 0 || !Number.isFinite(count)) return undefined;
        return {
            appId: appId,
            count: count
        };
    }).filter((entry)=>entry !== undefined);
};
const $06fddef4acfae0a8$export$299a268eb011b7ef = (raw)=>{
    if (raw === undefined || raw.trim() === '') return undefined;
    const scalarCount = Number(raw);
    if (Number.isInteger(scalarCount) && scalarCount >= 0) return scalarCount;
    const appCounts = $06fddef4acfae0a8$export$acda930d8972381e(raw);
    if (appCounts.length === 0) return undefined;
    // parseAppCounts only guarantees isFinite; re-filter to positive integers before summing.
    const totalCount = appCounts.reduce((total, { count: count })=>{
        if (!Number.isInteger(count) || count <= 0) return total;
        return total + count;
    }, 0);
    return totalCount > 0 ? totalCount : undefined;
};
const $06fddef4acfae0a8$export$fe68bf06dd562208 = (parsed)=>parsed.map((entry, index)=>({
            ...entry,
            index: index
        })).filter((entry)=>entry.count > 0).sort((a, b)=>{
        if (b.count !== a.count) return b.count - a.count;
        return a.index - b.index;
    }).map((entry)=>entry.appId);
const $06fddef4acfae0a8$export$f9f1f4a4ade7c6e2 = (appId)=>{
    return $06fddef4acfae0a8$var$APP_ID_TO_PRODUCT_KEY_ALIASES[appId.toLowerCase()];
};
const $06fddef4acfae0a8$export$551da10284cad191 = (apps)=>apps.map($06fddef4acfae0a8$export$f9f1f4a4ade7c6e2).filter((productKey)=>productKey !== undefined);
const $06fddef4acfae0a8$export$7cc148373d70b178 = (existing, incoming, max)=>{
    const result = [];
    const seen = new Set();
    for (const productKey of [
        ...existing,
        ...incoming
    ])if (!seen.has(productKey)) {
        seen.add(productKey);
        result.push(productKey);
        if (result.length >= max) return result;
    }
    return result;
};
const $06fddef4acfae0a8$export$5d0c03a62d0c5b9f = ({ siteWideSmartlinkAppCounts: siteWideSmartlinkAppCounts, teamTypeSmartlinkAppCounts: teamTypeSmartlinkAppCounts, teamTypeKey: teamTypeKey } = {}, maxRecommendedApps = $06fddef4acfae0a8$export$545eb843b77efaec, options = {})=>{
    let productKeys = [];
    // Tier 1 — per-team-type TAP trait, gated on sufficiency.
    //
    // The sufficiency check is intentionally performed against the raw
    // (pre-filter) sum: it reflects whether the site as a whole has enough
    // activity for this team type to trust the signal, independent of which
    // apps we happen to support today. Only positive counts contribute so a
    // malformed TAP row with negatives (`"github:50, x:-40"`) cannot drag the
    // total below the threshold.
    const teamTypeParsed = $06fddef4acfae0a8$export$acda930d8972381e(teamTypeSmartlinkAppCounts);
    const teamTypePositiveSum = teamTypeParsed.reduce((sum, entry)=>sum + Math.max(0, entry.count), 0);
    if (teamTypePositiveSum >= $06fddef4acfae0a8$var$SUFFICIENCY_THRESHOLD) productKeys = $06fddef4acfae0a8$export$7cc148373d70b178([], $06fddef4acfae0a8$export$551da10284cad191($06fddef4acfae0a8$export$fe68bf06dd562208(teamTypeParsed)), maxRecommendedApps);
    // Tier 2 — site-wide TAP trait backfill.
    if (productKeys.length < maxRecommendedApps) {
        const siteWideParsed = $06fddef4acfae0a8$export$acda930d8972381e(siteWideSmartlinkAppCounts);
        productKeys = $06fddef4acfae0a8$export$7cc148373d70b178(productKeys, $06fddef4acfae0a8$export$551da10284cad191($06fddef4acfae0a8$export$fe68bf06dd562208(siteWideParsed)), maxRecommendedApps);
    }
    // Tier 3 — HARDCODED_DEFAULTS for the user's team type.
    //
    // If the caller didn't pass a teamTypeKey, or passed one we don't have
    // a curated row for, fall through to the `na` row. Because
    // HARDCODED_DEFAULTS.na references DEFAULT_FALLBACK_APPS by identity,
    // this single tier covers both the team-type-known case and the
    // "no signal at all" floor — no separate Tier 4 is needed.
    //
    // Skipped when `options.traitOnly` is set so animation callers (which
    // have their own department-based fallback) can distinguish "real signal"
    // from "cold-start defaults".
    if (!options.traitOnly && productKeys.length < maxRecommendedApps) {
        const tier3AppIds = (teamTypeKey ? $06fddef4acfae0a8$export$5dbf4404d8d730eb[teamTypeKey] : undefined) ?? $06fddef4acfae0a8$export$5dbf4404d8d730eb[$06fddef4acfae0a8$export$db8c8b18ca3de852] ?? [];
        productKeys = $06fddef4acfae0a8$export$7cc148373d70b178(productKeys, $06fddef4acfae0a8$export$551da10284cad191(tier3AppIds), maxRecommendedApps);
    }
    return productKeys;
};
module.exports["SMARTLINK_CONNECTION_LINK_COUNT_TRAIT"] = $06fddef4acfae0a8$export$9a80c24535b38e83;
module.exports["SMARTLINK_CONNECTION_LINK_COUNT_BY_TEAM_TYPE_TRAIT_PREFIX"] = $06fddef4acfae0a8$export$d02d73057c4016d5;
module.exports["DEFAULT_FALLBACK_APPS"] = $06fddef4acfae0a8$export$8594dab83de99a34;
module.exports["parseAppCounts"] = $06fddef4acfae0a8$export$acda930d8972381e;
module.exports["parseSmartlinkConnectionLinkCount"] = $06fddef4acfae0a8$export$299a268eb011b7ef;
module.exports["canonicalizeAppIdToProductKey"] = $06fddef4acfae0a8$export$f9f1f4a4ade7c6e2;
module.exports["resolveRecommendedProductKeys"] = $06fddef4acfae0a8$export$5d0c03a62d0c5b9f;

});

parcelRegister("8gF2o", function(module, exports) {
/**
 * Utilities for talking to the Atlassian outbound-auth gateway, which is the
 * canonical source of truth for whether a user has a working OAuth connection
 * to a given Smart Link connector.
 *
 * Why this exists
 * ---------------
 * Previously we relied on the CDS endpoint
 *   GET /gateway/api/third-party-configuration/connected-data-sources/{cloudId}
 * (via `get3pSearchConfig`) to determine both the OAuth start URL and whether
 * the user was already connected. That endpoint has four well-known problems
 * for the Confluence onboarding "Connect your 3P tools" experience:
 *
 *   1. Edition-gated: CDS only works on Standard+ tenants with Rovo
 *      provisioned. Free tier tenants return 403.
 *   2. Lazy-init: the registry behind CDS (ERS) does not have a
 *      `smartlinks-connector-{provider}` row until a Smart Link resolve event
 *      for that provider has fired on the tenant. Brand-new tenants are
 *      effectively empty.
 *   3. Not a definitive provider universe: CDS only enumerates what's already
 *      been touched on this tenant, not what's available to connect.
 *   4. No back-population: even after a user connects via a fallback path,
 *      CDS does not see it (until/unless ERS gets the event), so downstream
 *      surfaces like the post-office banner keep re-prompting.
 *
 * The outbound-auth gateway endpoint
 *   GET /gateway/api/outbound-auth/aaId/{aaId}
 * powers id.atlassian.com/manage-profile/apps. It is cookie-authed (no ASAP
 * needed), works cross-origin from *.atlassian.net, and returns the user's
 * full OAuth-grant list with a per-account `status` field. This is the same
 * data the Atlassian ID Manage Profile UI uses.
 *
 * Canonical container UUIDs come from
 *   ai-3p-connector/connector-service/implementation/src/main/resources/application-prod.yml
 *   ai-3p-connector/connector-service/implementation/src/main/resources/application.yml      (staging)
 * under `linking-platform.providers[]`. The `containerId` + `serviceKey`
 * tuples in the outbound-auth response match those values exactly.
 *
 * Backwards-compat / defensive design
 * -----------------------------------
 *  - All network/parse failures return `null` and let callers fall back to
 *    whatever they were doing before. This module never throws.
 *  - The container maps are `Partial<Record<...>>` and helpers return `null`
 *    when a product has no mapping. Callers are expected to filter such
 *    providers out rather than render broken Connect buttons.
 */ 
var $fR63l = parcelRequire("fR63l");


var $bNe5y = parcelRequire("bNe5y");

// Verified identical in prod and staging gdrive CDS URLs.
const $ee8d2d572fb3c0d4$var$SMARTLINK_GDRIVE_SCOPES = [
    'https://www.googleapis.com/auth/drive.readonly',
    'https://www.googleapis.com/auth/userinfo.profile',
    'https://www.googleapis.com/auth/userinfo.email'
];
const $ee8d2d572fb3c0d4$export$860f54a43e361c13 = {
    [(0, $fR63l.ProductKeys3P).GoogleDrive]: {
        containerId: 'ff32b4a9-0056-4c40-bb6e-eebf3b1d82f7_c50f3d56-68fc-4c3c-8191-6717f173dc54',
        serviceKey: 'gdrive',
        defaultScopes: $ee8d2d572fb3c0d4$var$SMARTLINK_GDRIVE_SCOPES
    },
    [(0, $fR63l.ProductKeys3P).Slack]: {
        containerId: '25ab8ceb-e2e9-4b3a-b4ef-902049561d3a_74232f16-3f89-4bc8-9dcb-b5481bca783e',
        serviceKey: 'slack'
    },
    [(0, $fR63l.ProductKeys3P).OneDrive]: {
        containerId: '00f40f12-faac-4ac8-8d6d-310f96ac97f5_f039c3c2-7e00-41c4-b1cf-70743efbf91a',
        serviceKey: 'onedrive'
    },
    [(0, $fR63l.ProductKeys3P).Sharepoint]: {
        containerId: '7289b5af-9aa4-4977-bb8b-6876502a6466_e7e24a0a-0b03-4ef8-9a83-642e6ef97dbc',
        serviceKey: 'sharepoint'
    },
    [(0, $fR63l.ProductKeys3P).Github]: {
        containerId: 'c364f950-69f5-4812-9716-ed71a8d3d408_a57ca83d-597f-4de9-8dca-f9d3cd18d3a7',
        serviceKey: 'github'
    },
    [(0, $fR63l.ProductKeys3P).Figma]: {
        containerId: '7f89dc0c-5c1e-4b71-997f-220bf92361aa_73fbf758-c657-4f06-8edd-f721911f7f53',
        serviceKey: 'figma'
    },
    [(0, $fR63l.ProductKeys3P).Teams]: {
        containerId: 'fe8ece6c-97b6-45ac-959d-865da9a33409_61030824-303b-4751-bca5-1def33b6b0d0',
        serviceKey: 'ms-teams'
    },
    [(0, $fR63l.ProductKeys3P).Dropbox]: {
        containerId: 'd4d6a241-1008-42cf-b2d6-d0b380c096d6_b6796989-c34a-4e19-a4e1-ccc7655f8fd6',
        serviceKey: 'dropbox'
    },
    [(0, $fR63l.ProductKeys3P).Airtable]: {
        containerId: 'c5805f5a-3e9a-48a5-a8f5-7b04aac4ad16_572b2748-e9b1-4161-b36d-19f962646d1a',
        serviceKey: 'airtable'
    },
    [(0, $fR63l.ProductKeys3P).LaunchDarkly]: {
        containerId: '30ba2eba-6d3f-4124-8060-0ea9a9c9e990_d28912a6-171c-41a2-9adb-1426eccbc767',
        serviceKey: 'launchdarkly'
    },
    [(0, $fR63l.ProductKeys3P).ClickUp]: {
        containerId: '12967bc2-803e-4f8d-9e66-1aa48773a5a4_13a589a5-f514-4b63-a104-7d454b8dc676',
        serviceKey: 'clickup'
    },
    [(0, $fR63l.ProductKeys3P).Pipedrive]: {
        containerId: '1edf2d8e-c159-4ffe-8be0-165821a0ecf1_743950e9-2685-4558-a5b0-ae5d3b47853c',
        serviceKey: 'pipedrive'
    },
    [(0, $fR63l.ProductKeys3P).Gitlab]: {
        containerId: '790bd6ce-7ef8-404a-a9dc-798feb10b12b_049b63cb-90b1-4bfa-aa02-f3fdd9298b03',
        serviceKey: 'gitlab'
    },
    [(0, $fR63l.ProductKeys3P).Docusign]: {
        containerId: '35cd5415-c24c-457e-af7c-ac84df8c8628_0a7329e4-b658-41a1-89c2-419514a5ca08',
        serviceKey: 'docusign'
    },
    [(0, $fR63l.ProductKeys3P).Dovetail]: {
        containerId: 'b51f1664-8705-4938-a9a5-02a7eb3395cb_cba4f674-8eea-43aa-874f-8f16af6b75cb',
        serviceKey: 'dovetail'
    },
    [(0, $fR63l.ProductKeys3P).Box]: {
        containerId: '3a79e004-2e3e-45fe-8a21-84f53568a8ee_35421d47-ad3e-44f5-9cde-60bfa869e0b0',
        serviceKey: 'box'
    },
    [(0, $fR63l.ProductKeys3P).AdobeXD]: {
        containerId: '80c22a47-9ca7-4690-88db-65b375f402a7_ad251cf5-828d-494d-b555-4294d9654173',
        serviceKey: 'adobexd'
    },
    [(0, $fR63l.ProductKeys3P).Asana]: {
        containerId: '2487d697-ed1e-4cf5-9655-f1fb1355c341_a927cae4-3500-4386-9ac3-28e87671c2c8',
        serviceKey: 'asana'
    },
    [(0, $fR63l.ProductKeys3P).Smartsheet]: {
        containerId: '101a27da-d409-4f8c-9c75-326eec4fd5d4_fe89f892-8c94-4574-88f7-5898c05be186',
        serviceKey: 'smartsheet'
    },
    [(0, $fR63l.ProductKeys3P).Mural]: {
        containerId: 'cc21faf3-19fc-4522-af92-295866ef82e7_373f2501-6f74-4c0f-9bfa-c54cdea00066',
        serviceKey: 'mural'
    },
    [(0, $fR63l.ProductKeys3P).PowerBI]: {
        containerId: '9c59191f-63ab-44b2-a2cb-2f20adc75365_556e62ba-588b-494d-8c6c-b672e50537f6',
        serviceKey: 'power-bi'
    },
    [(0, $fR63l.ProductKeys3P).Miro]: {
        containerId: 'd01d8332-4637-4ea4-8b14-17a9d1a61504_a894175f-cb17-4e45-88fa-c348967f379c',
        serviceKey: 'miro'
    },
    [(0, $fR63l.ProductKeys3P).Hubspot]: {
        containerId: 'da0f0482-f78f-4eec-b7e6-0bc98ca5a54c_707406e8-d607-427a-b32e-e1d4710c0f2d',
        serviceKey: 'hubspot'
    },
    [(0, $fR63l.ProductKeys3P).Notion]: {
        containerId: '2bc172f6-c553-4fe1-85d4-3e2e087f84f6_be0969ca-ea7e-4685-abaa-7de142c01b36',
        serviceKey: 'notion'
    },
    [(0, $fR63l.ProductKeys3P).Sentry]: {
        containerId: '977cb3af-b6e9-4450-9ce5-bf40f9c73dff_3a8bcf5e-44ab-4f5b-b18d-340027b6a97e',
        serviceKey: 'sentry'
    },
    [(0, $fR63l.ProductKeys3P).PagerDuty]: {
        containerId: '49cdc160-0ad5-4dbf-adad-6a57fb082774_5cef1b1a-44aa-409e-97b3-b90065cbb39e',
        serviceKey: 'pagerduty'
    },
    [(0, $fR63l.ProductKeys3P).Salesforce]: {
        containerId: '2b45cadc-67a2-4902-8148-03e4de5ba747_db858b85-c098-45e7-96c8-9ccc9caf72da',
        serviceKey: 'salesforce'
    },
    [(0, $fR63l.ProductKeys3P).Amplitude]: {
        containerId: '1e30cfdf-cceb-43f4-b34a-dde94e1f9b21_939acc6f-274a-42da-acdc-8af5a14fe698',
        serviceKey: 'amplitude'
    },
    [(0, $fR63l.ProductKeys3P).Lucid]: {
        containerId: '9262005e-5c1a-49af-9ec0-4a354f581c73_80f25935-3f1f-40e1-9b2a-35db54297ebf',
        serviceKey: 'lucid'
    },
    [(0, $fR63l.ProductKeys3P).Zeplin]: {
        containerId: 'a401d4f0-b3d1-4b64-a85d-3952bd42d9a7_3da3c5e7-89db-4330-878f-dff1fe878556',
        serviceKey: 'zeplin'
    },
    [(0, $fR63l.ProductKeys3P).Todoist]: {
        containerId: '0202ace9-65df-40e3-b539-d831b446dad9_c7809c53-31e9-4fc0-8df9-8b8dcb418bb8',
        serviceKey: 'todoist'
    },
    [(0, $fR63l.ProductKeys3P).Stripe]: {
        containerId: 'bb81e8b8-7d0d-4a24-bb5b-acf31ab97bbc_f38b2a60-30a9-4abd-9086-efb78f6986ce',
        serviceKey: 'stripe'
    },
    [(0, $fR63l.ProductKeys3P).AzureDevops]: {
        // Sourced from ai-3p-connector application-prod.yml
        // (permission.linking-platform-info[container=6b34a992…]).
        containerId: '6b34a992-af2a-4a16-8a4d-89038c48a355_719d2d91-a89a-46f5-bacc-e3baf87d21c8',
        serviceKey: 'azuredevops'
    },
    [(0, $fR63l.ProductKeys3P).Webex]: {
        // Sourced from ai-3p-connector application-prod.yml
        // (permission.linking-platform-info[container=18025f11…]).
        containerId: '18025f11-aafe-49ca-ad45-d48f7005e459_19846c70-0c88-44f6-a7c1-d5bdd77c606c',
        serviceKey: 'webex'
    }
};
const $ee8d2d572fb3c0d4$export$e25d6f2386134a66 = {
    [(0, $fR63l.ProductKeys3P).GoogleDrive]: {
        containerId: '2357cbb7-bf5c-4fe4-a9c6-c8e172ccb5b1_3b53863d-a6bb-4818-91da-4de04f975f48',
        serviceKey: 'gdrive',
        defaultScopes: $ee8d2d572fb3c0d4$var$SMARTLINK_GDRIVE_SCOPES
    },
    [(0, $fR63l.ProductKeys3P).Slack]: {
        containerId: '32a368b4-220e-45a9-b65f-df104dc2e559_7ab21f60-b89a-44c1-bed3-00282c3e7b9e',
        serviceKey: 'slack'
    },
    [(0, $fR63l.ProductKeys3P).OneDrive]: {
        containerId: '6b74c0f8-ce5e-43b0-a68e-eba0fed27cea_4254f605-625b-4026-904a-bdf8ee6de413',
        serviceKey: 'onedrive'
    },
    [(0, $fR63l.ProductKeys3P).Sharepoint]: {
        containerId: '03d0881e-f10f-4751-ab11-27592812060e_b269c883-58b9-463a-9b77-50b6cd8da5fc',
        serviceKey: 'sharepoint'
    },
    [(0, $fR63l.ProductKeys3P).Github]: {
        containerId: '9bb160f8-1abb-4dc8-9780-ca5327e7ccc8_91300e36-3710-4f7b-aba2-95f43be1ac6f',
        serviceKey: 'github'
    },
    [(0, $fR63l.ProductKeys3P).Figma]: {
        containerId: '652e701c-09ac-4e05-bd96-4c95b5c8cac5_ccaebdc1-68e5-406a-b1f4-efcc5962aa40',
        serviceKey: 'figma'
    },
    [(0, $fR63l.ProductKeys3P).Teams]: {
        containerId: 'd27ee9f8-f60b-4076-910b-f16da23b7df4_b3763282-4b2e-4b4b-b924-3c8ba8f6e218',
        serviceKey: 'ms-teams'
    },
    [(0, $fR63l.ProductKeys3P).Dropbox]: {
        containerId: 'd7a3169c-13c8-4b76-96b6-e8f9f849313d_d73e8370-9035-494d-ae16-20854375cb6f',
        serviceKey: 'dropbox'
    },
    [(0, $fR63l.ProductKeys3P).Airtable]: {
        containerId: '070278f6-260c-420f-be4f-a7942a712c23_c2fe283b-51d2-4a0a-8e7f-4ce1199e0a10',
        serviceKey: 'airtable'
    },
    [(0, $fR63l.ProductKeys3P).LaunchDarkly]: {
        containerId: 'd63e3423-0a85-461f-9650-7f26342c62bf_49e197a6-c428-442e-a5ca-f9d4889c82d8',
        serviceKey: 'launchdarkly'
    },
    [(0, $fR63l.ProductKeys3P).ClickUp]: {
        containerId: 'fe20ccd3-b054-4139-aacb-8d98e086c16d_0b40b3c7-4c18-40e3-a030-101c94347723',
        serviceKey: 'clickup'
    },
    [(0, $fR63l.ProductKeys3P).Pipedrive]: {
        containerId: '6012b82a-da48-44ff-af6e-da1c73b279f6_e6a2cefa-c9fe-4d50-b8ea-36391a2d41e6',
        serviceKey: 'pipedrive'
    },
    [(0, $fR63l.ProductKeys3P).Gitlab]: {
        containerId: 'a7b83eeb-482d-402d-b87d-21ede67e73ed_3082dfec-249f-45d9-b84d-b49d256874e9',
        serviceKey: 'gitlab'
    },
    [(0, $fR63l.ProductKeys3P).Docusign]: {
        containerId: 'ec9d65b4-72ee-4030-8dd1-e393026cf335_f4f50986-99a8-4f96-8b52-917d4c6bbbb7',
        serviceKey: 'docusign'
    },
    [(0, $fR63l.ProductKeys3P).Dovetail]: {
        containerId: 'f9a3bf31-88d5-4b5a-80c2-cc32670259a2_c0c8e23b-ec93-45bb-928c-91b9671f0041',
        serviceKey: 'dovetail'
    },
    [(0, $fR63l.ProductKeys3P).Box]: {
        containerId: '43cd20d8-11a7-4910-8789-06523fb2e6db_957783c9-4448-4d91-93dc-0ad7b24a327a',
        serviceKey: 'box'
    },
    [(0, $fR63l.ProductKeys3P).AdobeXD]: {
        containerId: 'c1225a08-acd6-4908-84a7-d5b573f14cc1_e701a1e0-b819-4077-99ac-0b3525510c66',
        serviceKey: 'adobexd'
    },
    [(0, $fR63l.ProductKeys3P).Asana]: {
        containerId: '35462eee-abe5-4873-ba7a-610d4c85f640_cb8525b3-26b3-467d-b42c-cb944e912311',
        serviceKey: 'asana'
    },
    [(0, $fR63l.ProductKeys3P).Smartsheet]: {
        containerId: '48cb55a0-db03-4ce4-8f76-1f986f734652_e6b58d0f-fa9f-4543-9b67-5957b73dee6f',
        serviceKey: 'smartsheet'
    },
    [(0, $fR63l.ProductKeys3P).Mural]: {
        containerId: '95d1bad0-96d7-40a8-996f-b8226dfd8fa1_d6095215-c4a5-4be1-bdd9-7065ed65ae37',
        serviceKey: 'mural'
    },
    [(0, $fR63l.ProductKeys3P).PowerBI]: {
        containerId: 'ea3c5a46-228c-47ea-8c4b-f18e0f17fe8c_abc5ee35-a08c-4481-aa26-0439ce58b4c4',
        serviceKey: 'power-bi'
    },
    [(0, $fR63l.ProductKeys3P).Miro]: {
        containerId: 'e37bcd89-df89-4e65-90f9-98a92fa2dbd0_7c1ec941-d9e7-40be-96fb-69fae6b6bfd2',
        serviceKey: 'miro'
    },
    [(0, $fR63l.ProductKeys3P).Hubspot]: {
        containerId: 'aca58c62-2fb0-4abc-93f0-08bc704ab82a_c39eff84-66f8-4fa9-bb75-768ac83b5f6d',
        serviceKey: 'hubspot'
    },
    [(0, $fR63l.ProductKeys3P).Notion]: {
        containerId: '60913f14-f7e5-465a-9df7-a5f7974caad6_80617f98-fa46-4b5e-9c8e-a54bc42b7c3e',
        serviceKey: 'notion'
    },
    [(0, $fR63l.ProductKeys3P).Sentry]: {
        containerId: '59ec4558-3649-433e-a6b9-7964ae040b78_39660d3a-f2c9-446a-9a53-db433bbc7c2d',
        serviceKey: 'sentry'
    },
    [(0, $fR63l.ProductKeys3P).PagerDuty]: {
        containerId: '2db77a65-0037-45ea-9f57-642051d86ff5_dd18e9a6-e52a-4b80-9a2f-1aa487c9f747',
        serviceKey: 'pagerduty'
    },
    [(0, $fR63l.ProductKeys3P).Salesforce]: {
        containerId: 'd62184e4-87e4-41b2-9321-8b3c1dede9d7_433a0c54-84d5-41ee-9c21-684887b34330',
        serviceKey: 'salesforce'
    },
    [(0, $fR63l.ProductKeys3P).Amplitude]: {
        containerId: '953d4aed-a528-4a5e-9f84-fe42741063f5_eed898af-fb54-4a76-ba73-8d6261639a1a',
        serviceKey: 'amplitude'
    },
    [(0, $fR63l.ProductKeys3P).Lucid]: {
        containerId: 'd188e82f-311c-429d-a17f-bde97037890e_937a3756-c797-4f04-bde1-3eba582b91cf',
        serviceKey: 'lucid'
    },
    [(0, $fR63l.ProductKeys3P).Zeplin]: {
        containerId: '2e14b294-385f-4d3c-a0a0-3e29e1f3a30b_f156da1b-5880-4fc1-ae67-2581ab8fda87',
        serviceKey: 'zeplin'
    },
    [(0, $fR63l.ProductKeys3P).Todoist]: {
        containerId: '6ff1e497-21ac-4f8e-ac74-b869e2c3f274_0f5c1a58-fdae-41ae-841d-2bc5a2875c38',
        serviceKey: 'todoist'
    },
    [(0, $fR63l.ProductKeys3P).Stripe]: {
        containerId: '48824814-f7d3-465a-9535-f589940c8e5a_8a330cd4-3af2-4c32-8c8e-8e751a3fad8a',
        serviceKey: 'stripe'
    },
    [(0, $fR63l.ProductKeys3P).AzureDevops]: {
        // containerId sourced from the canonical Confluence page
        // (page id 6649924469). serviceKey assumed identical to prod —
        // ai-3p-connector's application-staging.yml does NOT declare a
        // per-provider serviceKey for Azure DevOps, but every other
        // provider in this file uses the same serviceKey across both
        // environments, so the prod value is the safe assumption.
        containerId: '784f3542-1a1d-4f49-8769-f3c2cb1e83b3_b91efd28-4d10-43d4-bcae-a5b0fef72bb1',
        serviceKey: 'azuredevops'
    },
    [(0, $fR63l.ProductKeys3P).Webex]: {
        // containerId sourced from the canonical Confluence page
        // (page id 6649924469). serviceKey assumed identical to prod
        // (see note on AzureDevops above).
        containerId: 'ead13644-c3c5-4f8d-8d31-58be86dc7c8e_cedff546-1b81-4f3c-b65d-30c4cb2d8c61',
        serviceKey: 'webex'
    }
};
const $ee8d2d572fb3c0d4$var$ATLASSIAN_ID_BASE_URLS = {
    prod: 'https://id.atlassian.com',
    staging: 'https://id.stg.internal.atlassian.com'
};
const $ee8d2d572fb3c0d4$var$CONTAINER_MAPS = {
    prod: $ee8d2d572fb3c0d4$export$860f54a43e361c13,
    staging: $ee8d2d572fb3c0d4$export$e25d6f2386134a66
};
const $ee8d2d572fb3c0d4$var$isProdHostname = ()=>{
    if (typeof window === 'undefined' || !window.location) return true;
    return window.location.hostname.endsWith('.atlassian.net');
};
const $ee8d2d572fb3c0d4$var$getEnvFromHostname = ()=>$ee8d2d572fb3c0d4$var$isProdHostname() ? 'prod' : 'staging';
const $ee8d2d572fb3c0d4$export$d73c6d475285293 = (payload)=>{
    if (!payload || !Array.isArray(payload.containers) || payload.containers.length === 0) return null;
    const prodUuids = new Set(Object.values($ee8d2d572fb3c0d4$export$860f54a43e361c13).map((m)=>m?.containerId));
    const stagingUuids = new Set(Object.values($ee8d2d572fb3c0d4$export$e25d6f2386134a66).map((m)=>m?.containerId));
    let prodHits = 0;
    let stagingHits = 0;
    for (const c of payload.containers){
        const id = c.container?.containerId;
        if (!id) continue;
        if (prodUuids.has(id)) prodHits++;
        if (stagingUuids.has(id)) stagingHits++;
    }
    if (prodHits === 0 && stagingHits === 0) return null;
    return prodHits >= stagingHits ? 'prod' : 'staging';
};
const $ee8d2d572fb3c0d4$var$getAtlassianIdBaseUrl = (env)=>$ee8d2d572fb3c0d4$var$ATLASSIAN_ID_BASE_URLS[env];
const $ee8d2d572fb3c0d4$var$getContainerMap = (env)=>$ee8d2d572fb3c0d4$var$CONTAINER_MAPS[env];
const $ee8d2d572fb3c0d4$export$50ff30f26c11fe5f = async (aaId, { forceRefresh: forceRefresh = false } = {})=>{
    if (!aaId) return null;
    try {
        const response = await (0, $bNe5y.fetchAccountsByAaId)({
            aaid: aaId,
            // When `forceRefresh` is true, bypass the cache (always hit the
            // gateway). Otherwise, prefer cached values over the network when
            // they are still warm — the post-office banner re-mounts on most
            // navigation events and we don't want to thrash the gateway.
            onlyRefreshIfExpired: !forceRefresh,
            returnExpired: true
        });
        if (!response || !Array.isArray(response.containers)) return null;
        return response;
    } catch  {
        return null;
    }
};
const $ee8d2d572fb3c0d4$export$6d3a2e8837b79055 = (payload, productKey, env)=>{
    if (!payload || !Array.isArray(payload.containers) || payload.containers.length === 0) return false;
    // Prefer the env we detect from the payload itself (deterministic — the
    // gateway can only return UUIDs from one env at a time). Fall back to
    // hostname-based detection only if the payload contains no recognised
    // UUIDs in either map (defensive — should be unreachable since the
    // gateway always returns at least the user's atlassian-token-service-key
    // container, plus any Smart Link grants).
    const resolvedEnv = env ?? $ee8d2d572fb3c0d4$export$d73c6d475285293(payload) ?? $ee8d2d572fb3c0d4$var$getEnvFromHostname();
    const mapping = $ee8d2d572fb3c0d4$var$getContainerMap(resolvedEnv)[productKey];
    if (!mapping) return false;
    const matchingContainer = payload.containers.find((c)=>c.container?.containerId === mapping.containerId);
    if (!matchingContainer) return false;
    const services = Array.isArray(matchingContainer.services) ? matchingContainer.services : [];
    // Filter services by the expected serviceKey. For unique-container
    // providers this is a no-op (one service per container). For shared
    // containers it ensures we only look at accounts owned by the right
    // service.
    const matchingServices = services.filter((s)=>s.service?.serviceKey === mapping.serviceKey);
    return matchingServices.some((s)=>(Array.isArray(s.accounts) ? s.accounts : []).some((account)=>account.status === 'available'));
};
const $ee8d2d572fb3c0d4$export$8acaf25597d6f4b9 = (productKey, env)=>{
    const resolvedEnv = env ?? $ee8d2d572fb3c0d4$var$getEnvFromHostname();
    const mapping = $ee8d2d572fb3c0d4$var$getContainerMap(resolvedEnv)[productKey];
    if (!mapping) return null;
    const baseUrl = $ee8d2d572fb3c0d4$var$getAtlassianIdBaseUrl(resolvedEnv);
    const params = new URLSearchParams({
        serviceKey: mapping.serviceKey,
        containerId: mapping.containerId
    });
    if (mapping.defaultScopes?.length) params.set('scopes', mapping.defaultScopes.join(' '));
    // URLSearchParams encodes spaces as '+'; gateway expects RFC 3986 '%20'.
    return `${baseUrl}/outboundAuth/start?${params.toString().replace(/\+/g, '%20')}`;
};
const $ee8d2d572fb3c0d4$export$27e6019a895f8241 = (productKey, env)=>{
    const resolvedEnv = env ?? $ee8d2d572fb3c0d4$var$getEnvFromHostname();
    return Boolean($ee8d2d572fb3c0d4$var$getContainerMap(resolvedEnv)[productKey]);
};
module.exports["detectEnvFromPayload"] = $ee8d2d572fb3c0d4$export$d73c6d475285293;
module.exports["fetchOutboundAuthAccounts"] = $ee8d2d572fb3c0d4$export$50ff30f26c11fe5f;
module.exports["isAuthenticatedForProduct"] = $ee8d2d572fb3c0d4$export$6d3a2e8837b79055;
module.exports["buildSmartLinkAuthUrl"] = $ee8d2d572fb3c0d4$export$8acaf25597d6f4b9;
module.exports["hasSmartLinkContainerMapping"] = $ee8d2d572fb3c0d4$export$27e6019a895f8241;

});

parcelRegister("bNe5y", function(module, exports) {

var $fyjce = parcelRequire("fyjce");


var $9C63M = parcelRequire("9C63M");


var $feBoR = parcelRequire("feBoR");

const $4fb07153bd78bc9f$var$accountsByAaIdCache = (0, $fyjce.promiseCache)({
    name: 'accounts-by-aaid-cache',
    expiration: 1800000 // 30 minutes
});
const $4fb07153bd78bc9f$export$75264ee4f9af0fe1 = async ({ aaid: aaid, onlyRefreshIfExpired: onlyRefreshIfExpired = true, expiration: expiration, degradationCallback: degradationCallback = ()=>{}, cacheAnalyticsCallback: cacheAnalyticsCallback, returnExpired: returnExpired = false })=>{
    const supplier = ()=>{
        const accountsPromise = (0, $feBoR.fetchAccountsByAaIdInternal)(aaid);
        const degrader = new (0, $9C63M.DegradablePromise)(accountsPromise, degradationCallback);
        return degrader.promise();
    };
    const cacheKey = aaid;
    return $4fb07153bd78bc9f$var$accountsByAaIdCache.refreshOnAccessDecorator({
        key: cacheKey,
        supplier: supplier,
        returnExpired: returnExpired,
        onlyRefreshIfExpired: onlyRefreshIfExpired,
        expiration: expiration,
        analyticsCallback: cacheAnalyticsCallback
    });
};
module.exports["fetchAccountsByAaId"] = $4fb07153bd78bc9f$export$75264ee4f9af0fe1;

});

parcelRegister("feBoR", function(module, exports) {

var $kKR0X = parcelRequire("kKR0X");

const $bc7e7cf1bc3ed88d$export$8fc8913ba4f36c51 = async (aaid)=>{
    const url = `/gateway/api/outbound-auth/aaId/${aaid}`;
    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    if (!response.ok) throw new (0, $kKR0X.OutboundAuthApiError)('Failed to fetch accounts by aaId');
    return await response.json();
};
module.exports["fetchAccountsByAaIdInternal"] = $bc7e7cf1bc3ed88d$export$8fc8913ba4f36c51;

});

parcelRegister("kKR0X", function(module, exports) {
/**
 * Type definitions for Outbound Auth service responses
 *
 * These types mirror the response models from the outbound-auth service.
 * Source of truth: https://bitbucket.org/atlassian/outbound-auth/
 * Reference implementation: /src/service/accountManagement.ts
 * API Spec: /docs/content/platform/outbound-auth/swagger.yaml
 */ /**
 * Include fields for controlling what data is returned in account responses
 * Mirrors AtlassianAuthAccount.IncludeFields from outbound-auth service
 */ var $e9dc573f98a366a7$export$9e1d8c9863da0d81 = /*#__PURE__*/ function(IncludeFields) {
    IncludeFields["AccessToken"] = "accessToken";
    IncludeFields["DisplayName"] = "displayName";
    IncludeFields["AaId"] = "aaId";
    IncludeFields["AvatarUrl"] = "avatarUrl";
    IncludeFields["ExternalAccountId"] = "externalAccountId";
    IncludeFields["Expiry"] = "expiry";
    return IncludeFields;
}({});
class $e9dc573f98a366a7$export$7f02dcf7cf9277d8 extends Error {
    constructor(message){
        super(message);
        this.name = 'OutboundAuthApiError';
    }
}
module.exports["OutboundAuthApiError"] = $e9dc573f98a366a7$export$7f02dcf7cf9277d8;

});

parcelRegister("aV3a0", function(module, exports) {

var $kae7O = parcelRequire("kae7O");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $5T18X = parcelRequire("5T18X");


var $jMyy4 = parcelRequire("jMyy4");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $f9jv7 = parcelRequire("f9jv7");


var $i9VoI = parcelRequire("i9VoI");


var $7Sm4c = parcelRequire("7Sm4c");


var $5kqgA = parcelRequire("5kqgA");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $gzIc1 = parcelRequire("gzIc1");


var $jVylI = parcelRequire("jVylI");

const $c042cea05c5afe3c$var$useTitleContentPropertiesForEditorQuery = (0, $kae7O.default);
const $c042cea05c5afe3c$export$56ad806c83a5bd5e = (queryData)=>queryData?.content?.nodes?.[0]?.pageTitleDraft?.nodes?.find((node)=>node?.key === 'page-title-property-draft');
const $c042cea05c5afe3c$var$i18n = (0, $kSwu1.defineMessages)({
    errorFlagTitle: {
        id: "content-topper.page-title.alignment.error.title",
        defaultMessage: "We couldn\u2019t update the title alignment"
    },
    errorFlagDescription: {
        id: "content-topper.page-title.alignment.error.description",
        defaultMessage: "Try again, or refresh the page."
    }
});
const $c042cea05c5afe3c$export$e3e4716593714d84 = ({ contentId: contentId, propertyKey: propertyKey = 'page-title-property-draft', isDelete: isDelete = false, loadTitleContentProperties: loadTitleContentProperties = false, updateAlignmentState: updateAlignmentState, updateCoverPictureWidthState: updateCoverPictureWidthState, contentType: contentType, flags: flags, updateIsLoadingComplete: updateIsLoadingComplete })=>{
    const isInitialLoadComplete = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(false);
    const isTitleCenteredInitial = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(false);
    const handleError = (0, $cozmU.useCallback)((error, suppressErrors)=>{
        const isUnauthOrNotFoundError = (0, $1uFM6.isUnauthorizedError)(error) || (0, $f9jv7.isNotFoundError)(error);
        if (!isUnauthOrNotFoundError) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).MIGRATIONS_TOOLING
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        if (!suppressErrors) flags?.showErrorFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $c042cea05c5afe3c$var$i18n.errorFlagTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $c042cea05c5afe3c$var$i18n.errorFlagDescription)
        });
    }, [
        flags
    ]);
    const getAlignmentFromContentProperty = (response)=>{
        const titlePropertyContent = $c042cea05c5afe3c$export$56ad806c83a5bd5e(response);
        if (titlePropertyContent?.value) try {
            return (0, $gzIc1.contentPropertyHelper)(titlePropertyContent)?.titleLayoutAlignment || (0, $jVylI.defaultPropertyValue).titleLayoutAlignment;
        } catch (e) {
            handleError(e, false);
            return (0, $jVylI.defaultPropertyValue).titleLayoutAlignment;
        }
        else return (0, $jVylI.defaultPropertyValue).titleLayoutAlignment;
    };
    const onCompleted = (response_0)=>{
        const coverPictureWidth = response_0.content?.nodes?.[0]?.metadata?.frontend?.coverPictureWidth || (0, $jVylI.COVERPICTUREWIDTH).FULL;
        updateAlignmentState?.(getAlignmentFromContentProperty(response_0));
        updateCoverPictureWidthState?.(coverPictureWidth);
    };
    const { data: data, networkStatus: networkStatus, refetch: refetchProperties } = (0, $jMyy4.useQueryInterop)($c042cea05c5afe3c$var$useTitleContentPropertiesForEditorQuery, {
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft',
                'archived'
            ]
        },
        fetchPolicy: window.__SSR_RENDERED__ ? 'cache-first' : 'cache-and-network',
        // cache-and-network is required for: edit cover width, transition out of edit, transition back to edit for same page (for Live Docs and Classic pages)
        onError: (error_0)=>{
            handleError(error_0, true);
        },
        skip: !(loadTitleContentProperties || Boolean(window.__SSR_RENDERED__)),
        notifyOnNetworkStatusChange: true,
        __callerPackage__: "content-topper"
    });
    const isTitleAlignmentLoading = networkStatus === (0, $5T18X.NetworkStatus).loading && !data;
    const refetchLoading = networkStatus === (0, $5T18X.NetworkStatus).refetch;
    const coverImageWidthCached = data?.content?.nodes?.[0]?.metadata?.frontend?.coverPictureWidth;
    isTitleCenteredInitial.current = (Boolean(window.__SSR_RENDERED__) || !isTitleAlignmentLoading) && getAlignmentFromContentProperty(data) === (0, $jVylI.TitleAlignmentType).CENTER;
    if (!isInitialLoadComplete.current && loadTitleContentProperties && data) {
        isInitialLoadComplete.current = true;
        onCompleted(data);
        updateIsLoadingComplete?.(true);
    }
    const { updateContentProperty: updateContentProperty, updateContentPropertyResult: { loading: isUpdatingAlignment } = {} } = (0, $5kqgA.useUpdateContentProperty)({
        contentId: contentId,
        contentType: contentType || 'page'
    });
    const onPageTitlePropertyUpdatedSubscriptionData = (0, $cozmU.useCallback)((_eventName, response_1)=>{
        const { pageTitlePropertyUpdated: pageTitlePropertyUpdated } = response_1 || {};
        try {
            const value = JSON.parse(pageTitlePropertyUpdated?.value);
            updateAlignmentState?.(value?.titleLayoutAlignment);
        } catch (error_1) {
            (0, $5ZqQS.getMonitoringClient)().submitError(error_1, {
                attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
            });
            (0, $7Sm4c.markErrorAsHandled)(error_1);
        }
    }, [
        updateAlignmentState
    ]);
    (0, $i9VoI.useSubscriptionEvent)({
        contentId: contentId,
        contentType: contentType || 'page',
        delta: 'pageTitlePropertyUpdated',
        onDataReceived: onPageTitlePropertyUpdatedSubscriptionData,
        subscriberId: 'useTitleContentPropertiesForEditor'
    });
    const updatePageTitleProperty = (0, $cozmU.useCallback)(async (propertyValue)=>{
        try {
            const getVersionNumber = (data_0)=>data_0?.content?.nodes?.[0]?.pageTitleDraft?.nodes?.[0]?.version?.number || 0;
            const versionData = await refetchProperties();
            const versionNumber = getVersionNumber(versionData.data);
            const newVersionNumber = versionNumber ? versionNumber + 1 : 1;
            await updateContentProperty({
                propertyKey: propertyKey,
                propertyValue: propertyValue,
                isDelete: isDelete,
                hasExistingProperty: versionNumber > 0,
                shouldOptimisticResponse: true,
                options: {
                    update: ()=>{
                        try {
                            const cacheData = (0, $l1uFv.readQueryInterop)({
                                query: $c042cea05c5afe3c$var$useTitleContentPropertiesForEditorQuery,
                                variables: {
                                    contentId: contentId,
                                    status: [
                                        'current',
                                        'draft',
                                        'archived'
                                    ]
                                },
                                __callerPackage__: "content-topper"
                            });
                            cacheData.content.nodes[0].pageTitleDraft.nodes[0] = {
                                ...cacheData.content.nodes[0].pageTitleDraft.nodes[0],
                                id: contentId,
                                key: propertyKey,
                                value: JSON.stringify(propertyValue),
                                version: {
                                    number: newVersionNumber,
                                    __typename: 'Version'
                                }
                            };
                            (0, $fEmGS.writeQueryInterop)({
                                query: $c042cea05c5afe3c$var$useTitleContentPropertiesForEditorQuery,
                                variables: {
                                    contentId: contentId,
                                    status: [
                                        'current',
                                        'draft',
                                        'archived'
                                    ]
                                },
                                data: cacheData,
                                __callerPackage__: "content-topper"
                            });
                        } catch (error_2) {
                            throw new Error(` failed to write to cache while updating ${propertyKey} content property after user updated page title${error_2.message}`);
                        }
                    }
                }
            });
        } catch (err) {
            handleError(err, false);
        }
    }, [
        propertyKey,
        contentId,
        isDelete,
        updateContentProperty,
        refetchProperties,
        handleError
    ]);
    return {
        isUpdatingAlignment: isUpdatingAlignment || refetchLoading,
        updatePageTitleProperty: updatePageTitleProperty,
        onCompleted: // exported for testing purposes
        onCompleted,
        isTitleAlignmentLoading: isTitleAlignmentLoading,
        isTitleCenteredInitial: isTitleCenteredInitial.current,
        coverImageWidthCached: coverImageWidthCached
    };
};
module.exports["useTitleContentPropertiesForEditor"] = $c042cea05c5afe3c$export$e3e4716593714d84;

});

parcelRegister("kygIi", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $bfabf86e1c7ccf01$export$f52c1c9ada99fe59 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "XMjnz",
    name: "LazyMeetingNotesAutomationDiscoveryFragment",
    loader: async ()=>(await (parcelRequire("bCqWr"))).MeetingNotesAutomationDiscoveryFragment
});
module.exports["LazyMeetingNotesAutomationDiscoveryFragment"] = $bfabf86e1c7ccf01$export$f52c1c9ada99fe59;

});

parcelRegister("bCqWr", function(module, exports) {

let $8758245f1c041cff$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $8758245f1c041cff$var$load("h0X0x"),
    $8758245f1c041cff$var$load("7l4Nc"),
    $8758245f1c041cff$var$load("7g00Y"),
    $8758245f1c041cff$var$load("7A87G"),
    $8758245f1c041cff$var$load("6wr18"),
    $8758245f1c041cff$var$load("dlYE2"),
    $8758245f1c041cff$var$load("ffEVr"),
    $8758245f1c041cff$var$load("jXx9i"),
    $8758245f1c041cff$var$load("31AYA"),
    $8758245f1c041cff$var$load("n2DB9"),
    $8758245f1c041cff$var$load("gKeEd")
]).then(()=>parcelRequire('21Y7u'));

});

parcelRegister("gjEAi", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $44846349058524ee$export$9e2285f96d44792b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Swb7P",
    name: 'ApprovalBannerLoadable',
    loader: async ()=>(await (parcelRequire("9vZE0"))).ApprovalBanner
});
module.exports["ApprovalBanner"] = $44846349058524ee$export$9e2285f96d44792b;

});

parcelRegister("9vZE0", function(module, exports) {

let $6ed6d3918691ce4a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6ed6d3918691ce4a$var$load("ezYRV"),
    $6ed6d3918691ce4a$var$load("9cpj1"),
    $6ed6d3918691ce4a$var$load("8gmaR")
]).then(()=>parcelRequire('hbQeG'));

});

parcelRegister("lrMxq", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7boqA = parcelRequire("7boqA");


var $jmjWc = parcelRequire("jmjWc");


var $fgdVB = parcelRequire("fgdVB");


const $172892494f392667$var$ObjectSidebarControlLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "liSnz",
    name: "ObjectSidebarControlLoader",
    loader: async ()=>(await (parcelRequire("fWoeg"))).ObjectSidebarControl
});
const $172892494f392667$export$3fab07431350539e = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
            metric: (0, $fgdVB.OBJECT_SIDEBAR_CONTROL_METRIC)
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($172892494f392667$var$ObjectSidebarControlLoader, props));
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
        metric: (0, $fgdVB.OBJECT_SIDEBAR_CONTROL_METRIC)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($172892494f392667$var$ObjectSidebarControlLoader, props));
module.exports["ObjectSidebarControl"] = $172892494f392667$export$3fab07431350539e;

});

parcelRegister("fWoeg", function(module, exports) {

let $b9af112dfee0778d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b9af112dfee0778d$var$load("kIZM6"),
    $b9af112dfee0778d$var$load("6WNyl"),
    $b9af112dfee0778d$var$load("5Op3U"),
    $b9af112dfee0778d$var$load("bY2TC"),
    $b9af112dfee0778d$var$load("lkHIj"),
    $b9af112dfee0778d$var$load("b8BFA"),
    $b9af112dfee0778d$var$load("7BHAC"),
    $b9af112dfee0778d$var$load("N3TvS"),
    $b9af112dfee0778d$var$load("6wr18"),
    $b9af112dfee0778d$var$load("kujst"),
    $b9af112dfee0778d$var$load("5iXyL"),
    $b9af112dfee0778d$var$load("bb3WM"),
    $b9af112dfee0778d$var$load("jdmfD"),
    $b9af112dfee0778d$var$load("isCfG"),
    $b9af112dfee0778d$var$load("j5Kob"),
    $b9af112dfee0778d$var$load("3fvxJ"),
    $b9af112dfee0778d$var$load("koD3t"),
    $b9af112dfee0778d$var$load("7BITa"),
    $b9af112dfee0778d$var$load("65uwt"),
    $b9af112dfee0778d$var$load("6XCf4"),
    $b9af112dfee0778d$var$load("ebvEF"),
    $b9af112dfee0778d$var$load("hSDwk"),
    $b9af112dfee0778d$var$load("aMUi4"),
    $b9af112dfee0778d$var$load("2DZ5c"),
    $b9af112dfee0778d$var$load("g4pu7"),
    $b9af112dfee0778d$var$load("frf7L"),
    $b9af112dfee0778d$var$load("l3mVS"),
    $b9af112dfee0778d$var$load("7oMW2"),
    $b9af112dfee0778d$var$load("k6TzV"),
    $b9af112dfee0778d$var$load("diMTQ"),
    $b9af112dfee0778d$var$load("iN26T"),
    $b9af112dfee0778d$var$load("64FEU"),
    $b9af112dfee0778d$var$load("dxcsb"),
    $b9af112dfee0778d$var$load("99ObF"),
    $b9af112dfee0778d$var$load("jqoep"),
    $b9af112dfee0778d$var$load("7EorR"),
    $b9af112dfee0778d$var$load("aEiTV"),
    $b9af112dfee0778d$var$load("VXbA1"),
    $b9af112dfee0778d$var$load("1qlDN"),
    $b9af112dfee0778d$var$load("1yVM6"),
    $b9af112dfee0778d$var$load("8GFi1"),
    $b9af112dfee0778d$var$load("ffEVr"),
    $b9af112dfee0778d$var$load("lz0TS"),
    $b9af112dfee0778d$var$load("hHIPg")
]).then(()=>parcelRequire('lVF98'));

});

parcelRegister("7Qvc2", function(module, exports) {
const $bcd09bd1d7b9cf0f$export$449c8054b4d9a926 = 'agentReceiptPanel';
const $bcd09bd1d7b9cf0f$export$109252224b02bc40 = 'ROVO_SMART_CREATION';
module.exports["AGENT_TRUST_RECEIPT_PANEL_ID"] = $bcd09bd1d7b9cf0f$export$449c8054b4d9a926;
module.exports["ROVO_SMART_CREATION_GENERATED_BY"] = $bcd09bd1d7b9cf0f$export$109252224b02bc40;

});

parcelRegister("b2GGc", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $jC4nA = parcelRequire("jC4nA");


var $jmjWc = parcelRequire("jmjWc");


var $7Qvc2 = parcelRequire("7Qvc2");

const $6e30f4ac71490dc9$var$i18n = (0, $kSwu1.defineMessages)({
    headerLabel: {
        id: "agent-trust-receipt.panel.header.non-final",
        defaultMessage: "Agent receipt"
    }
});
const $6e30f4ac71490dc9$var$AgentReceiptHeaderIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jC4nA))), {
        label: "",
        color: "currentColor"
    });

// Interaction-only, gated panel body — lazy so its chunk only loads when the panel is opened, and
// never ships in the byline/right-rail entry-point bundles that statically import this factory.
const $6e30f4ac71490dc9$var$LazyAgentTrustReceiptPanelBody = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "vTotT",
    name: "LazyAgentTrustReceiptPanelBody",
    loader: async ()=>(await (parcelRequire("4g2fx"))).AgentTrustReceiptPanelBody
});
const $6e30f4ac71490dc9$var$AgentTrustReceiptBodyComponent = ({ receipt: receipt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6e30f4ac71490dc9$var$LazyAgentTrustReceiptPanelBody, {
        receipt: receipt
    });
const $6e30f4ac71490dc9$export$2249a9400d169a9f = ({ receipt: receipt })=>({
        id: (0, $7Qvc2.AGENT_TRUST_RECEIPT_PANEL_ID),
        headerComponentElements: {
            HeaderIcon: $6e30f4ac71490dc9$var$AgentReceiptHeaderIcon,
            headerLabel: $6e30f4ac71490dc9$var$i18n.headerLabel
        },
        BodyComponent: $6e30f4ac71490dc9$var$AgentTrustReceiptBodyComponent,
        props: {
            receipt: receipt
        }
    });
module.exports["createAgentTrustReceiptPanel"] = $6e30f4ac71490dc9$export$2249a9400d169a9f;

});

parcelRegister("4g2fx", function(module, exports) {

let $319a66ca7fd0f4d9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $319a66ca7fd0f4d9$var$load("6wr18"),
    $319a66ca7fd0f4d9$var$load("ffEVr"),
    $319a66ca7fd0f4d9$var$load("eOkWq"),
    $319a66ca7fd0f4d9$var$load("e6FBZ")
]).then(()=>parcelRequire('eBdsu'));

});

parcelRegister("essql", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4L9ve = parcelRequire("4L9ve");


var $8i27m = parcelRequire("8i27m");


var $aUU0C = parcelRequire("aUU0C");


var $bQm3c = parcelRequire("bQm3c");


var $8WQTF = parcelRequire("8WQTF");


var $htsj6 = parcelRequire("htsj6");


var $aqBZ0 = parcelRequire("aqBZ0");


var $9wGTI = parcelRequire("9wGTI");


var $7Sm4c = parcelRequire("7Sm4c");


var $1uFM6 = parcelRequire("1uFM6");


var $6fil2 = parcelRequire("6fil2");


var $fJlJm = parcelRequire("fJlJm");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $fHAwL = parcelRequire("fHAwL");


var $d3bcC = parcelRequire("d3bcC");


var $9nXVV = parcelRequire("9nXVV");


var $3bH25 = parcelRequire("3bH25");


var $e4kZB = parcelRequire("e4kZB");

const $2524304961e9b056$var$MAX_UNREAD_COMMENTS_SUPPORTED = 1000;
const $2524304961e9b056$export$3c5a4187b7dbe412 = ({ pageId: pageId, pageContentTypeProps: pageContentTypeProps, onCommentRead: onCommentRead })=>{
    const [{ isUpdatingUnreadComments: isUpdatingUnreadComments }, { setIsUpdatingUnreadComments: setIsUpdatingUnreadComments, setIsUnreadQueryLoading: setIsUnreadQueryLoading, updateUnreadCommentIDSet: updateUnreadCommentIDSet, setShouldClearVisibleThreads: setShouldClearVisibleThreads }] = (0, $fHAwL.useUnreadComments)();
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    // Setup observer for unread comments
    (0, $9nXVV.useUnreadCommentsObserverSetup)({
        pageId: pageId,
        onCommentRead: onCommentRead
    });
    // Destructure pageContentTypeProps with defaults
    const { pageMode: pageMode } = pageContentTypeProps || {};
    const { contentStatus: contentStatus } = (0, $htsj6.useContentStatus)();
    // Get processed comments data
    const { commentsDataMap: commentsDataMap, error: error, openComments: openComments, isDataProcessed: isDataProcessed } = (0, $4L9ve.useProcessedCommentsDataState)();
    const loading = !isDataProcessed;
    // Get comments data directly from comments-data package (for pages only)
    // This fixes the circular dependency issue
    const [{ orderedActiveAnnotationIdList: orderedActiveAnnotationIdList = [] }] = (0, $8i27m.useCommentsData)();
    const { isDanglingCallback: isDanglingCallback } = (0, $3bH25.useIsDanglingCallback)({
        pageMode: pageMode
    });
    // We still need these for the logic in handleUpdateUnreadComments
    const [editorAnnotationsState] = (0, $aUU0C.useEditorAnnotations)();
    const { annotations: annotations, pageId: editorPageId } = editorAnnotationsState;
    const isRenderer = pageMode === 'view';
    const rendererActionsResult = (0, $8WQTF.useRendererActions)();
    const { rendererActions: rendererActions, pageId: rendererPageId } = rendererActionsResult || {};
    const { getViewedCommentsFresh: getViewedCommentsFresh } = (0, $d3bcC.useViewedComments)({
        pageId: pageId || ''
    });
    (0, $cozmU.useEffect)(()=>{
        // isUnreadQueryLoading is used in other areas of the code to make sure unread logic is processed before further logic
        setIsUnreadQueryLoading(loading);
    }, [
        loading,
        setIsUnreadQueryLoading
    ]);
    // Handle GraphQL query errors with proper error handling
    (0, $cozmU.useEffect)(()=>{
        if (!error || !pageId) return;
        // Handle expected errors (403/unauthorized, network errors) - just mark as handled
        if ((0, $1uFM6.isUnauthorizedError)(error) || (0, $6fil2.containsNetworkError)(error)) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            return;
        }
        // Handle unexpected errors (including 500) - track them with context
        (0, $fJlJm.setContentErrorAttributes)(error, {
            objectId: pageId,
            objectType: 'page'
        });
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).COMMENTS
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
    }, [
        error,
        pageId
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (pageId) {
            updateUnreadCommentIDSet(new Set(), 'removeAll');
            setShouldClearVisibleThreads(false);
            // reset so we can recreate the set for the page that the user is changing to
            setIsUpdatingUnreadComments(true);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        pageId
    ]);
    const resetStates = (0, $cozmU.useCallback)(()=>{
        setIsUpdatingUnreadComments(false);
    }, [
        setIsUpdatingUnreadComments
    ]);
    const handleUpdateUnreadComments = (0, $cozmU.useCallback)(async ()=>{
        if (userId && isUpdatingUnreadComments) {
            if (loading) return [];
            if (!pageId) return;
            const currentAllCommentsFromQuery = openComments || [];
            if (currentAllCommentsFromQuery.length === 0) {
                resetStates(); // we no longer need to create the set if there are no comments on the page
                return;
            }
            // Skip if renderer actions or editor annotations are for different page
            if (pageMode && (isRenderer && rendererActions && rendererPageId !== pageId || !isRenderer && annotations && editorPageId !== pageId)) return; // Wait for next rerender when rendererActions / annotations are updated for the current page
            const rendererAnnotations = rendererActions?.getAnnotationMarks() || [];
            const annotationsInEditorDoc = new Set(annotations || []);
            if (currentAllCommentsFromQuery.length < $2524304961e9b056$var$MAX_UNREAD_COMMENTS_SUPPORTED) {
                const isArchived = contentStatus === (0, $aqBZ0.CONTENT_STATUS_ARCHIVED);
                const hasPageComments = currentAllCommentsFromQuery.some((comment)=>comment?.location?.type === 'FOOTER');
                // skip creating unread comments set if the page is archived
                // or if there are no page comments and inline comments
                if (isArchived || pageMode && !hasPageComments && (isRenderer && rendererAnnotations?.length === 0 || !isRenderer && annotationsInEditorDoc?.size === 0)) return;
                // continuing here means one of these 3 scenarios are true so we do want to check for unread comments
                // 1. no inline comments, yes page comments
                // 2. yes inline comments, no page comments
                // 3. yes inline comments, yes page comments
                const viewedComments = await getViewedCommentsFresh();
                if (viewedComments.success && viewedComments.data) (0, $e4kZB.createUnreadCommentsSet)({
                    allComments: currentAllCommentsFromQuery,
                    currentUserId: userId,
                    pageId: pageId,
                    updateUnreadCommentIDSet: updateUnreadCommentIDSet,
                    resetStates: resetStates,
                    viewedComments: viewedComments.data,
                    isDanglingCallback: isDanglingCallback
                });
            }
        }
    }, [
        userId,
        isUpdatingUnreadComments,
        loading,
        pageId,
        pageMode,
        isRenderer,
        rendererActions,
        rendererPageId,
        annotations,
        editorPageId,
        openComments,
        resetStates,
        contentStatus,
        getViewedCommentsFresh,
        updateUnreadCommentIDSet,
        isDanglingCallback
    ]);
    (0, $3bH25.useDanglingAndResolvedHandler)({
        orderedActiveAnnotationIdList: orderedActiveAnnotationIdList,
        commentsDataMap: commentsDataMap,
        userId: userId || '',
        pageId: pageId || '',
        isDanglingCallback: pageMode ? isDanglingCallback : undefined
    });
    (0, $cozmU.useEffect)(()=>{
        const isNotPageContentType = !pageContentTypeProps;
        if (isNotPageContentType && !(0, $9wGTI.fg)('cc-whiteboards-consolidating-comments-unread')) return;
        handleUpdateUnreadComments();
    }, [
        handleUpdateUnreadComments,
        rendererActions,
        annotations,
        pageContentTypeProps
    ]);
};
module.exports["useUnreadCommentsSetup"] = $2524304961e9b056$export$3c5a4187b7dbe412;

});

parcelRegister("9nXVV", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9wGTI = parcelRequire("9wGTI");


var $c1UWH = parcelRequire("c1UWH");


var $fHAwL = parcelRequire("fHAwL");


var $1czFr = parcelRequire("1czFr");


var $d3bcC = parcelRequire("d3bcC");

const $b14365a28be63efb$var$MARK_COMMENTS_AS_READ_DEBOUNCE_MS = 1000;
const $b14365a28be63efb$export$d5d84acfffa9b3ca = ({ pageId: pageId, onCommentRead: onCommentRead })=>{
    const { updateUnreadCommentIDSet: updateUnreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsActions)();
    const { debouncedMarkCommentsAsRead: debouncedMarkCommentsAsRead, flushPendingComments: flushPendingComments } = (0, $1czFr.useDebouncedMarkCommentsAsRead)($b14365a28be63efb$var$MARK_COMMENTS_AS_READ_DEBOUNCE_MS);
    const { updateViewedCommentsCache: updateViewedCommentsCache } = (0, $d3bcC.useViewedComments)({
        pageId: pageId || ''
    });
    const intersectionCallback = (0, $cozmU.useCallback)((commentId)=>{
        if (commentId) {
            updateUnreadCommentIDSet(new Set([
                commentId
            ]), 'remove');
            debouncedMarkCommentsAsRead(commentId);
            updateViewedCommentsCache([
                commentId
            ]);
            if ((0, $9wGTI.fg)('cc-whiteboards-consolidating-comments-unread')) // Notify external systems about the comment being read (e.g. content types, whiteboards, databases)
            onCommentRead?.([
                commentId
            ]);
        }
    }, [
        updateUnreadCommentIDSet,
        debouncedMarkCommentsAsRead,
        updateViewedCommentsCache,
        onCommentRead
    ]);
    // Create refs to avoid stale closures in useEffect
    const intersectionCallbackRef = (0, $cozmU.useRef)(intersectionCallback);
    intersectionCallbackRef.current = intersectionCallback;
    const flushPendingCommentsRef = (0, $cozmU.useRef)(flushPendingComments);
    flushPendingCommentsRef.current = flushPendingComments;
    (0, $cozmU.useEffect)(()=>{
        if (!pageId) return;
        const observer = (0, $c1UWH.getUnreadCommentsIntersectionObserver)();
        observer.registerIntersectionCallback((commentId)=>{
            intersectionCallbackRef.current(commentId);
        });
        return ()=>{
            observer.disconnect();
            flushPendingCommentsRef.current();
        };
    }, [
        pageId
    ]);
};
module.exports["useUnreadCommentsObserverSetup"] = $b14365a28be63efb$export$d5d84acfffa9b3ca;

});

parcelRegister("3bH25", function(module, exports) {
/* eslint-disable object-shorthand */ 
var $cozmU = parcelRequire("cozmU");


var $aUU0C = parcelRequire("aUU0C");


var $8WQTF = parcelRequire("8WQTF");


var $fHAwL = parcelRequire("fHAwL");


var $d3bcC = parcelRequire("d3bcC");


var $e4kZB = parcelRequire("e4kZB");

const $280745ffe1b8b376$export$30b625574e8a38c7 = ({ pageMode: pageMode })=>{
    const [editorAnnotationsState] = (0, $aUU0C.useEditorAnnotations)();
    const { annotations: annotations } = editorAnnotationsState;
    const rendererActionsResult = (0, $8WQTF.useRendererActions)();
    const { rendererActions: rendererActions } = rendererActionsResult || {};
    const isDanglingCallback = (0, $cozmU.useCallback)((markerRef)=>{
        if (!pageMode) return false;
        return (0, $e4kZB.commentIsDangling)({
            pageMode: pageMode,
            annotationsInEditorDoc: new Set(annotations),
            rendererAnnotations: new Set(rendererActions?.getAnnotationMarks()?.map((ann)=>ann.attrs.id).filter(Boolean) || [])
        })(markerRef);
    }, [
        annotations,
        rendererActions,
        pageMode
    ]);
    return {
        isDanglingCallback: isDanglingCallback
    };
};
// Helper function to process added annotations (reopened / undangled)
const $280745ffe1b8b376$var$processAddedAnnotations = ({ currentList: currentList, previousThreadKeys: previousThreadKeys, commentsDataMap: commentsDataMap, viewedComments: viewedComments, userId: userId, isDanglingCallback: isDanglingCallback })=>{
    const addedCommentIds = new Set();
    for (const annotation of currentList)if (!previousThreadKeys.has(annotation.threadKey)) {
        const commentData = commentsDataMap.inline[annotation.threadKey];
        if (commentData) {
            // Early return if comment is already viewed
            if (viewedComments.has(commentData.id)) return addedCommentIds;
            // Add the main comment ID if it's a valid unread comment
            if ((0, $e4kZB.isValidUnreadComment)({
                comment: commentData,
                currentUserId: userId,
                viewedComments: viewedComments,
                isDanglingCallback: isDanglingCallback
            })) addedCommentIds.add(commentData.id);
            // Add all reply IDs if they're valid unread comments
            commentData.replies?.forEach((reply)=>{
                if (reply) {
                    // Skip if reply is already viewed
                    if (viewedComments.has(reply.id)) return;
                    if ((0, $e4kZB.isValidUnreadComment)({
                        comment: reply,
                        currentUserId: userId,
                        viewedComments: viewedComments,
                        isDanglingCallback: isDanglingCallback
                    })) addedCommentIds.add(reply.id);
                }
            });
        }
    }
    return addedCommentIds;
};
// Helper function to process removed annotations (resolved / dangled)
const $280745ffe1b8b376$var$processRemovedAnnotations = ({ previousList: previousList, currentThreadKeys: currentThreadKeys, commentsDataMap: commentsDataMap })=>{
    const removedCommentIds = new Set();
    for (const annotation of previousList)if (!currentThreadKeys.has(annotation.threadKey)) {
        const commentData = commentsDataMap.inline[annotation.threadKey];
        if (commentData) {
            // Add the main comment ID
            removedCommentIds.add(commentData.id);
            // Add all reply IDs
            commentData.replies?.forEach((reply)=>{
                if (reply) removedCommentIds.add(reply.id);
            });
        }
    }
    return removedCommentIds;
};
const $280745ffe1b8b376$export$ce2ddc24e5a132d = ({ orderedActiveAnnotationIdList: orderedActiveAnnotationIdList, commentsDataMap: commentsDataMap, userId: userId, pageId: pageId, isDanglingCallback: isDanglingCallback })=>{
    const [{ isUpdatingUnreadComments: isUpdatingUnreadComments }, { updateUnreadCommentIDSet: updateUnreadCommentIDSet }] = (0, $fHAwL.useUnreadComments)();
    const { getViewedCommentsCacheOnly: getViewedCommentsCacheOnly } = (0, $d3bcC.useViewedComments)({
        pageId: pageId
    });
    // Keep track of the previous orderedActiveAnnotationIdList
    const previousOrderedActiveAnnotationIdListRef = (0, $cozmU.useRef)(orderedActiveAnnotationIdList);
    // Handle the async getViewedComments call
    const processAnnotations = (0, $cozmU.useCallback)(async ()=>{
        const previousList = previousOrderedActiveAnnotationIdListRef.current;
        const currentList = orderedActiveAnnotationIdList;
        // Early exit if lists are identical (same length)
        if (previousList.length === currentList.length) return;
        // Build thread key sets for processing
        const previousThreadKeys = new Set(previousList.map((annotation)=>annotation.threadKey));
        const currentThreadKeys = new Set(currentList.map((annotation)=>annotation.threadKey));
        const viewedCommentsResult = getViewedCommentsCacheOnly();
        if (!viewedCommentsResult.success || !viewedCommentsResult.data) return;
        const viewedComments = viewedCommentsResult.data;
        // Process added annotations (reopened / undangled)
        const addedCommentIds = $280745ffe1b8b376$var$processAddedAnnotations({
            currentList: currentList,
            previousThreadKeys: previousThreadKeys,
            commentsDataMap: commentsDataMap,
            viewedComments: viewedComments,
            userId: userId,
            isDanglingCallback: isDanglingCallback
        });
        // Process removed annotations (resolved / dangled)
        const removedCommentIds = $280745ffe1b8b376$var$processRemovedAnnotations({
            previousList: previousList,
            currentThreadKeys: currentThreadKeys,
            commentsDataMap: commentsDataMap
        });
        // Update unread comment ID set for added annotations
        if (addedCommentIds.size > 0) updateUnreadCommentIDSet(addedCommentIds, 'add');
        // Update unread comment ID set for removed annotations
        if (removedCommentIds.size > 0) updateUnreadCommentIDSet(removedCommentIds, 'remove');
        // Update the previous list ref to current list for next comparison
        previousOrderedActiveAnnotationIdListRef.current = currentList;
    }, [
        orderedActiveAnnotationIdList,
        commentsDataMap,
        userId,
        isDanglingCallback,
        getViewedCommentsCacheOnly,
        updateUnreadCommentIDSet
    ]);
    (0, $cozmU.useEffect)(()=>{
        // skip entirely if:
        // - feature flag is disabled
        // - isDanglingCallback check is not enabled
        // - isUpdatingUnreadComments being true means the unread query and viewed comments query are not complete yet, which means we shouldn't process the annotations yet
        if (!isDanglingCallback || isUpdatingUnreadComments) return;
        processAnnotations();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- exclude commentsDataMap because we don't need to rerun this hook when it changes
    }, [
        processAnnotations,
        isUpdatingUnreadComments
    ]);
};
module.exports["useIsDanglingCallback"] = $280745ffe1b8b376$export$30b625574e8a38c7;
module.exports["useDanglingAndResolvedHandler"] = $280745ffe1b8b376$export$ce2ddc24e5a132d;

});

parcelRegister("98zed", function(module, exports) {

var $dPJCf = parcelRequire("dPJCf");


var $eNbbn = parcelRequire("eNbbn");

const $91141199ce9a5735$export$899773b8bcad4fc7 = ()=>{
    const isTransition = (0, $dPJCf.useIsTransition)();
    const ssrStatus = (0, $eNbbn.useLivePageSSRStatus)();
    if (!ssrStatus.isTypeKnown && isTransition) return {
        isLive: undefined,
        isTypeKnown: false
    };
    return ssrStatus;
};
module.exports["useIsLivePageWithSSR"] = $91141199ce9a5735$export$899773b8bcad4fc7;

});

parcelRegister("kE2cJ", function(module, exports) {

var $jiJCD = parcelRequire("jiJCD");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");



parcelRequire("gSgn8");


var $9wGTI = parcelRequire("9wGTI");


var $7zgzO = parcelRequire("7zgzO");

const $14c2681824cc07d8$export$7b9b5b70059a466b = ({ href: href = null, name: name, params: params, to: to = null, usePush: usePush = false, forceReload: forceReload = false, reason: reason, skipRouteChange: skipRouteChange = false, excludedQueryParams: excludedQueryParams })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { push: push, replace: replace, toUrl: toUrl, getHash: getHash, getQueryParams: getQueryParams, getHref: getHref, matchRoute: matchRoute } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const getUrl = ()=>{
        const customPath = href || to;
        let parsedUrl = {};
        if (customPath) parsedUrl = (0, $jiJCD.parse)(customPath, true);
        const currentQuery = getQueryParams();
        if (excludedQueryParams && (0, $9wGTI.fg)('confluence_frontend_excluded_query_params_redirect')) excludedQueryParams.forEach((param)=>{
            delete currentQuery[param];
        });
        return toUrl(name, {
            hash: getHash(),
            query: currentQuery,
            ...params,
            ...parsedUrl
        });
    };
    (0, $cozmU.useEffect)(()=>{
        const oldRoute = matchRoute(getHref());
        const oldRouteName = oldRoute?.name || null;
        const getAnalyticsAttributes = ({ newRouteName: newRouteName })=>({
                oldRouteName: oldRouteName,
                newRouteName: newRouteName,
                // It is safe to fire an event with the names of the route params because they are not UGC.
                // They are part of our route definitions. In contrast, the values of the route params are UGC.
                // Additionally, both the names and values of the route query params are UGC because they are
                // read directly from the URL without matching against our route definitions.
                oldRouteParamNames: Object.keys(oldRoute?.params || {}),
                newRouteParamNames: Object.keys(params || {}),
                // Space key related attributes.
                isOldRouteSpaceKeyDefined: !!oldRoute?.params?.spaceKey,
                isNewRouteSpaceKeyDefined: !!params?.spaceKey,
                areSpaceKeysEqual: oldRoute?.params?.spaceKey === params?.spaceKey,
                areSpaceKeysEqualLowercase: oldRoute?.params?.spaceKey?.toLowerCase() === params?.spaceKey?.toLowerCase()
            });
        const doRedirect = ()=>{
            // Reset the delayed content redirection object to avoid unnecessary redirects
            window['__DELAYED_CONTENT_REDIRECTION__'] = {};
            const gottenUrl = getUrl();
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'redirect',
                    actionSubject: oldRouteName,
                    actionSubjectId: name || matchRoute(gottenUrl)?.name,
                    source: oldRouteName
                }
            }).fire();
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'redirect',
                    actionSubject: 'route',
                    source: 'Redirection',
                    attributes: getAnalyticsAttributes({
                        newRouteName: name || matchRoute(gottenUrl)?.name
                    })
                }
            }).fire();
            // Skip route change by only rewrite URL
            if (skipRouteChange) try {
                window.history.replaceState({}, '', gottenUrl);
                return;
            } catch  {
            // If replaceState failed, then run the redirect normally
            }
            (usePush ? push : replace)(gottenUrl, forceReload);
        };
        try {
            doRedirect();
        } catch (error) {
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'redirectFailed',
                    actionSubject: 'route',
                    source: 'Redirection',
                    attributes: {
                        ...getAnalyticsAttributes({
                            newRouteName: name
                        }),
                        errorMessage: error?.message
                    }
                }
            }).fire();
            throw error;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
module.exports["Redirection"] = $14c2681824cc07d8$export$7b9b5b70059a466b;

});

parcelRegister("4yKPM", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $508846ea2a5b6903$export$1c961952eacaae6a = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "BrZ9o",
    name: "InlineCommentsHighlighterLoader",
    loader: async ()=>(await (parcelRequire("jrZdI"))).InlineCommentsHighlighter
});
module.exports["InlineCommentsHighlighterLoader"] = $508846ea2a5b6903$export$1c961952eacaae6a;

});

parcelRegister("jrZdI", function(module, exports) {

let $e29007040e0e6e7c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e29007040e0e6e7c$var$load("fky9A"),
    $e29007040e0e6e7c$var$load("7g00Y"),
    $e29007040e0e6e7c$var$load("7A87G"),
    $e29007040e0e6e7c$var$load("8LtYa"),
    $e29007040e0e6e7c$var$load("9H0e8"),
    $e29007040e0e6e7c$var$load("hhu66"),
    $e29007040e0e6e7c$var$load("gbis9"),
    $e29007040e0e6e7c$var$load("ayJxT"),
    $e29007040e0e6e7c$var$load("2nsSd"),
    $e29007040e0e6e7c$var$load("7EorR"),
    $e29007040e0e6e7c$var$load("cGAab")
]).then(()=>parcelRequire('c2Ip8'));

});

parcelRegister("jhifQ", function(module, exports) {

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");

const $56fbb6365252754d$export$f8c96a5c7f3b43a6 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.FOCUSED_INLINE_COMMENT_SEGMENT_KEY)
});
const $56fbb6365252754d$export$ac7f79e65475cee7 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.RENDERER_INLINE_COMMENT_RENDER_SEGMENT_KEY)
});
module.exports["FOCUSED_INLINE_COMMENT_METRIC"] = $56fbb6365252754d$export$f8c96a5c7f3b43a6;
module.exports["RENDERER_INLINE_COMMENT_RENDER_METRIC"] = $56fbb6365252754d$export$ac7f79e65475cee7;

});

parcelRegister("8amSw", function(module, exports) {
$parcel$export(module.exports, "CUSTOM_HEADER_FOOTER_TYPES", () => (parcelRequire("lvV7v")).CUSTOM_HEADER_FOOTER_TYPES);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $jmjWc = parcelRequire("jmjWc");



var $lvV7v = parcelRequire("lvV7v");


const $b4c0f70deb5f986b$export$c002ebd7506cf24 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "3f0hi",
    name: "CustomHeaderFooterLoader",
    loader: async ()=>(await (parcelRequire("b2Yhh"))).CustomHeaderFooter
});

const $b4c0f70deb5f986b$export$abd9d7fbad77ffb4 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "gCcak",
    name: "CustomHeaderFooterBackgroundLoader",
    loader: async ()=>(await (parcelRequire("b2Yhh"))).CustomHeaderFooter
});
module.exports["CustomHeaderFooterLoader"] = $b4c0f70deb5f986b$export$c002ebd7506cf24;

});

parcelRegister("b2Yhh", function(module, exports) {

let $80aea37fd221852a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $80aea37fd221852a$var$load("43z9c"),
    $80aea37fd221852a$var$load("bVl1P")
]).then(()=>parcelRequire('hnY2b'));

});

parcelRegister("lvV7v", function(module, exports) {
const $f7cada3b80c5d028$export$c16b69b19b9f847 = {
    HEADER: 'header',
    FOOTER: 'footer'
};
module.exports["CUSTOM_HEADER_FOOTER_TYPES"] = $f7cada3b80c5d028$export$c16b69b19b9f847;

});

parcelRegister("6pBXK", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $95494d62ea246593$export$ffdc57aecb97ae41 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "nmqvg",
    name: "ReadingAidsAcronymsHighlighter",
    loader: async ()=>(await (parcelRequire("3jZOc"))).ReadingAidsAcronymsHighlighter
});
module.exports["ReadingAidsAcronymsHighlighter"] = $95494d62ea246593$export$ffdc57aecb97ae41;

});

parcelRegister("3jZOc", function(module, exports) {

let $26b3175999865824$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $26b3175999865824$var$load("6mkG4").then(()=>parcelRequire('6vx1i'));

});

parcelRegister("kJNMt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7zgzO = parcelRequire("7zgzO");


var $fURMF = parcelRequire("fURMF");

const $0e8eac2a5609c7f2$export$139fec31c31601bb = ({ isSmooth: isSmooth })=>{
    const { getHash: getHash, getQueryParams: getQueryParams } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    // we're using refs here to avoid violating the rules
    // of hooks, but still prevent ourselves from
    // scrolling to page start multiple times in case if
    // `RoutesContext` changes unexpectedly -- if that happens,
    // we'll just take the latest context values into account
    // when executing scroll, and ignore everything we've seen
    // prior to that.
    const getHashRef = (0, $cozmU.useRef)(getHash);
    const getQueryParamsRef = (0, $cozmU.useRef)(getQueryParams);
    getHashRef.current = getHash;
    getQueryParamsRef.current = getQueryParams;
    (0, $cozmU.useEffect)(()=>{
        const hash = getHashRef.current();
        const queryParams = getQueryParamsRef.current();
        const queryParamsThatTriggerScroll = [
            'focusedCommentId'
        ];
        const doesPageHaveExplicitScrollTarget = hash.length > 0 || queryParamsThatTriggerScroll.some((paramName)=>Boolean(queryParams[paramName]));
        if (!doesPageHaveExplicitScrollTarget) (0, $fURMF.scrollToPageStart)(isSmooth);
    }, [
        getHashRef,
        getQueryParamsRef,
        isSmooth
    ]);
    return null;
};
module.exports["ScrollToPageStart"] = $0e8eac2a5609c7f2$export$139fec31c31601bb;

});

parcelRegister("dJ5r4", function(module, exports) {
$parcel$export(module.exports, "ViewCommentShortcutListener", () => (parcelRequire("fPcdI")).ViewCommentShortcutListener);

var $fPcdI = parcelRequire("fPcdI");


});

parcelRegister("fPcdI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $fJCU9 = parcelRequire("fJCU9");


var $9DHhW = parcelRequire("9DHhW");


var $9FoVw = parcelRequire("9FoVw");


var $aHcFH = parcelRequire("aHcFH");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $liGyh = parcelRequire("liGyh");


var $dANtQ = parcelRequire("dANtQ");


var $9QIM2 = parcelRequire("9QIM2");


var $fNzRA = parcelRequire("fNzRA");


var $9jl6v = parcelRequire("9jl6v");


var $bSvtO = parcelRequire("bSvtO");


var $cMvMc = parcelRequire("cMvMc");


var $8aF6s = parcelRequire("8aF6s");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4EKKB = parcelRequire("4EKKB");


var $aJPUt = parcelRequire("aJPUt");


var $inDu6 = parcelRequire("inDu6");


var $6GD8y = parcelRequire("6GD8y");


var $gnkil = parcelRequire("gnkil");


var $gczDe = parcelRequire("gczDe");


var $3mVfX = parcelRequire("3mVfX");


var $aWwYt = parcelRequire("aWwYt");


var $jvYFk = parcelRequire("jvYFk");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $cgy29 = parcelRequire("cgy29");


var $8i27m = parcelRequire("8i27m");


var $fHAwL = parcelRequire("fHAwL");


var $4L9ve = parcelRequire("4L9ve");


var $bQm3c = parcelRequire("bQm3c");


var $izhdc = parcelRequire("izhdc");


var $gSkOQ = parcelRequire("gSkOQ");

const $c392465906bed01c$var$ViewCommentShortcutListenerComponent = ({ isFabricPage: isFabricPage, contentId: contentId, dialogs: dialogs, preloadedCanAddComments: preloadedCanAddComments })=>{
    const { navigateToInlineComment: navigateToInlineComment } = (0, $9jl6v.useInlineCommentsDispatchContext)();
    const { activeHighlight: activeHighlight } = (0, $9jl6v.useInlineCommentsContext)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { removeCommentQueryParams: removeCommentQueryParams } = (0, $liGyh.useInlineCommentQueryParams)();
    const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList } = (0, $8i27m.useCommentsDataState)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const { commentsDataMap: commentsDataMap } = (0, $4L9ve.useProcessedCommentsDataState)();
    const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
    const pageClass = (0, $9QIM2.usePageClass)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [isNextCommentLoading, setIsNextCommentLoading] = (0, $cozmU.useState)(false);
    const [{ currentlyRenderedThreads: currentlyRenderedThreads, currentlySelectedThreadKey: currentlySelectedThreadKey }, { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey }] = (0, $3mVfX.useCommentsPanel)();
    // Track previous annotation for difference-based scrolling
    const previousAnnotationRef = (0, $cozmU.useRef)(undefined);
    // Update ref whenever activeHighlight changes
    (0, $cozmU.useEffect)(()=>{
        // Only update if there's a valid value (not empty string or null)
        if (activeHighlight) previousAnnotationRef.current = activeHighlight;
    }, [
        activeHighlight
    ]);
    const { isObjectSidebarShown: isObjectSidebarShown, panel: panel } = (0, $aWwYt.useObjectSidebarState)();
    const { expandCommentContainer: expandCommentContainer, setFooterEditorEntry: setFooterEditorEntry } = (0, $fNzRA.useObjectCommentDispatchContext)();
    const { expanded: expanded, isObjectCommentWrapperVisible: isObjectCommentWrapperVisible, footerEditorEntry: footerEditorEntry } = (0, $fNzRA.useObjectCommentContext)();
    const { addFooterCommentAdf: addFooterCommentAdf } = (0, $3mVfX.useCommentsPanelState)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { unreadCommentIDSet: unreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsState)();
    const { canAddComments: canAddComments } = (0, $dANtQ.useAddCommentPermissionCheck)(contentId ?? '', false, preloadedCanAddComments);
    const orderedActiveAnnotations = (0, $cozmU.useMemo)(()=>{
        return orderedActiveAnnotationIdList.map((a)=>a.threadKey);
    }, [
        orderedActiveAnnotationIdList
    ]);
    (0, $cozmU.useEffect)(()=>{
        setIsNextCommentLoading(false);
    }, [
        activeHighlight,
        currentlySelectedThreadKey
    ]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            setCurrentlySelectedThreadKey('');
        };
    }, [
        setCurrentlySelectedThreadKey
    ]);
    const { footerCommentThreads: footerCommentThreads, footerCommentIds: footerCommentIds } = (0, $gSkOQ.useFooterComments)();
    const { unreadInlineComments: unreadInlineComments, unreadGeneralComments: unreadGeneralComments } = (0, $cozmU.useMemo)(()=>{
        const unreadInlineComments = [];
        const unreadGeneralComments = [];
        orderedActiveAnnotations.forEach((threadKey)=>{
            const commentData = commentsDataMap.inline[threadKey];
            if (commentData) {
                let isCommentUnread = false;
                let hasUnreadReplies = false;
                // Use unreadCommentIDSet when feature flag is enabled
                // in SSR, unreadCommentIDSet is undefined
                isCommentUnread = unreadCommentIDSet?.has(commentData.id);
                hasUnreadReplies = commentData.replies?.some((reply)=>reply && unreadCommentIDSet?.has(reply.id)) || false;
                if (isCommentUnread || hasUnreadReplies) unreadInlineComments.push(threadKey);
            }
        });
        Object.keys(commentsDataMap.general).forEach((threadKey)=>{
            const commentData = commentsDataMap.general[threadKey];
            if (commentData) {
                let isCommentUnread = false;
                let hasUnreadReplies = false;
                // Use unreadCommentIDSet when feature flag is enabled
                isCommentUnread = unreadCommentIDSet?.has(commentData.id);
                hasUnreadReplies = commentData.replies?.some((reply)=>reply && unreadCommentIDSet?.has(reply.id)) || false;
                if (isCommentUnread || hasUnreadReplies) unreadGeneralComments.push(threadKey);
            }
        });
        return {
            unreadInlineComments: unreadInlineComments,
            unreadGeneralComments: unreadGeneralComments
        };
    }, [
        commentsDataMap,
        orderedActiveAnnotations,
        unreadCommentIDSet
    ]);
    const sendKeyboardShortcutAnalytics = (shortcut)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'viewPage',
                action: 'pressed',
                actionSubject: 'keyboardShortcut',
                actionSubjectId: 'createComment',
                attributes: {
                    key: shortcut
                }
            }
        }).fire();
    };
    const { handleCommentButtonClick: handleCommentButtonClick } = (0, $cgy29.useCreateCommentAction)({
        contentId: contentId || '',
        isFabric: isFabricPage,
        sendKeyboardShortcutAnalytics: sendKeyboardShortcutAnalytics
    });
    const getCommentIndex = (0, $cozmU.useCallback)((currentThreadKey)=>{
        return [
            ...orderedActiveAnnotations,
            ...footerCommentIds
        ]?.findIndex((threadKey)=>threadKey === currentThreadKey);
    }, [
        orderedActiveAnnotations,
        footerCommentIds
    ]);
    const openInlineComment = (0, $cozmU.useCallback)((markerRef)=>{
        if (pageClass === 'renderer' || pageClass === 'editor') experienceTracker.start({
            name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
            timeout: (0, $aJPUt.ExperienceTimeout).VIEW_INLINE_COMMENT,
            attributes: {
                annotationId: markerRef,
                entryPoint: 'comments-shortcuts/ViewCommentShortcutListener',
                pageClass: 'renderer'
            }
        });
        const previousAnnotationId = previousAnnotationRef.current;
        setCurrentlySelectedThreadKey('');
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const commentElement = document.getElementById(markerRef);
        (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
            annotationId: markerRef
        });
        (0, $4EKKB.selectInlineComment).debug(`Keyboard selection now triggering annotation selection for annotation ${markerRef}`);
        emitter.emit((0, $fJCU9.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
            annotationIds: [
                markerRef
            ],
            eventTarget: commentElement
        });
        (0, $9FoVw.handleKeyboardShortcutNavigation)({
            scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
            block: 'center',
            annotationId: markerRef,
            previousAnnotationId: previousAnnotationId,
            commentType: 'INLINE',
            isCommentsPanelOpen: isObjectSidebarShown,
            hasKeyPressed: true,
            context: (0, $9FoVw.NavigationContext).RENDERER
        });
    }, [
        emitter,
        setCurrentlySelectedThreadKey,
        experienceTracker,
        pageClass,
        isObjectSidebarShown
    ]);
    const scrollToFooterComment = (0, $cozmU.useCallback)((threadKey)=>{
        // Reset previous annotation ref when navigating to footer comment
        previousAnnotationRef.current = undefined;
        setCurrentlySelectedThreadKey(threadKey);
        emitter.emit((0, $fJCU9.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
            annotationIds: [],
            eventTarget: null
        });
        (0, $9FoVw.handleKeyboardShortcutNavigation)({
            scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
            block: 'center',
            annotationId: threadKey,
            commentType: 'FOOTER',
            isCommentsPanelOpen: isObjectSidebarShown,
            hasKeyPressed: true
        });
    }, [
        emitter,
        setCurrentlySelectedThreadKey,
        isObjectSidebarShown
    ]);
    const onNavigationClick = (0, $cozmU.useCallback)((nextMarkerRef)=>{
        if (hasContentChanged) showModal((0, $cMvMc.CommentWarningDialog), {
            onConfirm: ()=>{
                resetContentChanged();
                openInlineComment(nextMarkerRef);
            }
        });
        else openInlineComment(nextMarkerRef);
    }, [
        hasContentChanged,
        resetContentChanged,
        showModal,
        openInlineComment
    ]);
    const handlePanelCommentNavigation = (0, $cozmU.useCallback)((action)=>{
        // If nothing is on the panel, there's nothing to navigate to
        if (currentlyRenderedThreads.length === 0) return;
        const { panelCommentRefs: panelCommentRefs, navigableInlineCommentRefs: navigableInlineCommentRefs } = (0, $izhdc.parsePanelAndInlineRefs)(currentlyRenderedThreads, orderedActiveAnnotations);
        const nextRef = (0, $izhdc.getNextRef)(action, panelCommentRefs, currentlySelectedThreadKey);
        // Handle panel selection state management in the listener
        setCurrentlySelectedThreadKey(nextRef.ref);
        (0, $9FoVw.handleKeyboardShortcutNavigation)({
            scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
            block: 'center',
            annotationId: nextRef.ref,
            commentType: nextRef.type === (0, $8i27m.CommentType).GENERAL ? 'FOOTER' : 'INLINE',
            isCommentsPanelOpen: isObjectSidebarShown,
            hasKeyPressed: true,
            context: (0, $9FoVw.NavigationContext).RENDERER,
            isResolved: !navigableInlineCommentRefs.has(nextRef.ref)
        });
    }, [
        currentlyRenderedThreads,
        orderedActiveAnnotations,
        currentlySelectedThreadKey,
        setCurrentlySelectedThreadKey,
        isObjectSidebarShown
    ]);
    const handleNextCommentNavigation = (0, $cozmU.useCallback)(({ action: action, isNavigateToNextUnread: isNavigateToNextUnread })=>{
        //Check if the next inline comment is still in process of being rendered. Otherwise, quickly pressing keys will force comment to open and close instead of navigating
        if (isNextCommentLoading) return;
        setIsNextCommentLoading(true);
        navigateToInlineComment({
            action: action,
            triggeredByKeyboardShortcut: true,
            currentCommentIndex: getCommentIndex(activeHighlight || currentlySelectedThreadKey || ''),
            getCommentIndex: getCommentIndex,
            onNavigationClick: onNavigationClick,
            isEditor: false,
            removeCommentQueryParams: removeCommentQueryParams,
            unresolvedInlineComments: orderedActiveAnnotations,
            createAnalyticsEvent: createAnalyticsEvent,
            contentId: contentId,
            isNavigateToNextUnread: isNavigateToNextUnread,
            unreadInlineComments: unreadInlineComments,
            unreadGeneralComments: unreadGeneralComments,
            footerComments: footerCommentIds,
            scrollToFooterComment: scrollToFooterComment,
            commentsDataMap: commentsDataMap
        });
    }, [
        isNextCommentLoading,
        navigateToInlineComment,
        getCommentIndex,
        activeHighlight,
        currentlySelectedThreadKey,
        onNavigationClick,
        removeCommentQueryParams,
        orderedActiveAnnotations,
        createAnalyticsEvent,
        contentId,
        unreadInlineComments,
        unreadGeneralComments,
        footerCommentIds,
        scrollToFooterComment,
        commentsDataMap
    ]);
    const handleStandaloneCommentNavigation = (0, $cozmU.useCallback)((action)=>{
        if (activeHighlight || currentlySelectedThreadKey) handleNextCommentNavigation({
            isNavigateToNextUnread: false,
            action: action
        });
        else {
            // No highlight selected, so we navigate to the first inline comment
            const firstInlineCommentMarkerRef = orderedActiveAnnotations[0];
            if (!firstInlineCommentMarkerRef && footerCommentThreads.length === 0) return;
            if (firstInlineCommentMarkerRef) openInlineComment(firstInlineCommentMarkerRef);
            else scrollToFooterComment(footerCommentThreads[0]?.id);
        }
    }, [
        activeHighlight,
        currentlySelectedThreadKey,
        orderedActiveAnnotations,
        handleNextCommentNavigation,
        footerCommentThreads,
        openInlineComment,
        scrollToFooterComment
    ]);
    const handleCommentNavigation = (0, $cozmU.useCallback)((action)=>{
        // Define behavior when the comments panel is shown - panel FG is a prereq for nav, so has to be checked first
        if (isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).CommentsPanel) handlePanelCommentNavigation(action);
        else // Comments panel not shown
        handleStandaloneCommentNavigation(action);
    }, [
        isObjectSidebarShown,
        panel?.id,
        handlePanelCommentNavigation,
        handleStandaloneCommentNavigation
    ]);
    const handleNextUnreadNavigation = (0, $cozmU.useCallback)(()=>{
        //unread panel navigation
        if (isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).CommentsPanel) {
            let nextThreadKey = '';
            let nextCommentType = (0, $8i27m.CommentType).GENERAL;
            if (!currentlySelectedThreadKey) {
                if (unreadInlineComments.length > 0) {
                    nextThreadKey = unreadInlineComments[0];
                    nextCommentType = (0, $8i27m.CommentType).INLINE;
                } else nextThreadKey = unreadGeneralComments[0];
            } else {
                nextThreadKey = (0, $aHcFH.getNextUnreadThreadKey)(getCommentIndex(currentlySelectedThreadKey ?? '') + 1, //Add one otherwise it might get stuck on the current comment because there are unread replies which are collapsed
                [
                    ...orderedActiveAnnotations,
                    ...footerCommentIds
                ], [
                    ...unreadInlineComments,
                    ...unreadGeneralComments
                ]) ?? '';
                if (unreadInlineComments.includes(nextThreadKey)) nextCommentType = (0, $8i27m.CommentType).INLINE;
            }
            // Handle panel selection state management in the listener
            setCurrentlySelectedThreadKey(nextThreadKey);
            (0, $9FoVw.handleKeyboardShortcutNavigation)({
                scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                block: 'center',
                annotationId: nextThreadKey,
                commentType: nextCommentType === (0, $8i27m.CommentType).GENERAL ? 'FOOTER' : 'INLINE',
                isCommentsPanelOpen: isObjectSidebarShown,
                hasKeyPressed: true,
                context: (0, $9FoVw.NavigationContext).RENDERER,
                shortcutType: (0, $9FoVw.ShortcutType).UNREAD
            });
            return;
        }
        if (activeHighlight || currentlySelectedThreadKey) handleNextCommentNavigation({
            isNavigateToNextUnread: true,
            action: 'next'
        });
        else {
            if (unreadInlineComments.length + unreadGeneralComments.length === 0) return;
            if (unreadInlineComments[0]) openInlineComment(unreadInlineComments[0]);
            else scrollToFooterComment(unreadGeneralComments[0]);
        }
    }, [
        isObjectSidebarShown,
        panel?.id,
        handleNextCommentNavigation,
        unreadInlineComments,
        activeHighlight,
        openInlineComment,
        scrollToFooterComment,
        currentlySelectedThreadKey,
        unreadGeneralComments,
        footerCommentIds,
        getCommentIndex,
        orderedActiveAnnotations,
        setCurrentlySelectedThreadKey
    ]);
    const openCommentEditorShortcutCb = (e)=>{
        e.preventDefault();
        // This check is necessary to see which keyboard shortcut was used so it can be sent to analytics.
        // e.key is used to get the key that was pressed according to the current keyboard layout.
        // We compare with CREATE_COMMENT_SHORTCUT because it is a single-letter keyboard shortcut.
        // It's more difficult to compare with UNIVERSAL_OPEN_COMMENT_EDITOR because it includes modifiers.  Modifiers which change what e.key maps to depending on the keyboard layout.
        const shortcut = e.key === (0, $gnkil.CREATE_COMMENT_SHORTCUT) ? (0, $gnkil.CREATE_COMMENT_SHORTCUT) : (0, $gnkil.UNIVERSAL_OPEN_COMMENT_EDITOR);
        if (canAddComments || !(0, $9wGTI.fg)('confluence_fe_add_comment_kb_check_permission')) {
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            if (document.querySelector('[data-testid="highlightActionsPopup"]')) {
                // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                const createButton = document.querySelector('#create-inline-comment-button');
                // If createButton is not found or is disabled, do nothing.
                // This handles the case when hovering over media (image/video) objects in renderer.
                // In this scenario, a `highlightActionsPopup` is shown but the Comment button (which
                // has a different id) behaves differently: if any comment exists on the media object,
                // button click opens it as standalone; otherwise button click opens CreateComment.
                // Keyboard shortcut is disabled for this scenario.
                const createButtonIsEnabled = createButton && createButton?.getAttribute('disabled') !== '';
                if (createButtonIsEnabled) handleCommentButtonClick({
                    dialogs: dialogs,
                    shortcut: shortcut,
                    experienceAttributes: {
                        entryPoint: 'keyboardShortcut',
                        edition: edition
                    }
                });
            } else {
                // Check if we should show sticky draft instead of scrolling to object comment wrapper
                const isShowStickyDraft = !isObjectCommentWrapperVisible && (addFooterCommentAdf || expanded) && footerEditorEntry !== (0, $fNzRA.AddFooterCommentMode).STICKY_DRAFT;
                if (!expanded) expandCommentContainer({
                    entryPoint: 'keyboardShortcutView'
                });
                if (isShowStickyDraft || !isObjectCommentWrapperVisible) setFooterEditorEntry((0, $fNzRA.AddFooterCommentMode).STICKY_DRAFT);
                else // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                document.querySelector(`[data-testid='object-comment-wrapper']`)?.scrollIntoView({
                    behavior: 'smooth'
                });
            }
        }
        sendKeyboardShortcutAnalytics(shortcut);
    };
    if (!isFabricPage) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "comments-shortcut-listener"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_SELECT_COMMENT_SHORTCUT),
        listener: ()=>{
            const openComment = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            document.getElementById('renderer-comments-sidebar') || // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            document.getElementById(`comment-thread-${currentlySelectedThreadKey}-container`);
            if (openComment) (0, $aHcFH.focusElementAndUpdateTabIndex)(openComment);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_NEXT_COMMENT_SHORTCUT),
        deprecatedAccelerator: (0, $gnkil.NEXT_COMMENT_SHORTCUT),
        listener: ()=>{
            if (!(isNextCommentLoading && (0, $6mKj3.expValEquals)('cc_comments_fix_keyboard_select_timeout', 'isEnabled', true))) (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.start({
                pageClass: pageClass,
                entryPoint: 'keyboard-navigation'
            });
            (0, $4EKKB.selectInlineComment).debug('keyboard navigation to next comment', {
                // whenTriggered props added to help debug on Hello (for reproducing issues)
                activeHighlightWhenTriggered: activeHighlight,
                currentlySelectedThreadKeyWhenTriggered: currentlySelectedThreadKey,
                alreadyNavigating: isNextCommentLoading
            });
            handleCommentNavigation('next');
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_PREV_COMMENT_SHORTCUT),
        deprecatedAccelerator: (0, $gnkil.PREV_COMMENT_SHORTCUT),
        listener: ()=>{
            if (!(isNextCommentLoading && (0, $6mKj3.expValEquals)('cc_comments_fix_keyboard_select_timeout', 'isEnabled', true))) (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.start({
                pageClass: pageClass,
                entryPoint: 'keyboard-navigation'
            });
            (0, $4EKKB.selectInlineComment).debug('keyboard navigation to previous comment', {
                // whenTriggered props added to help debug on Hello (for reproducing issues)
                activeHighlightWhenTriggered: activeHighlight,
                currentlySelectedThreadKeyWhenTriggered: currentlySelectedThreadKey,
                alreadyNavigating: isNextCommentLoading
            });
            handleCommentNavigation('previous');
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_NEXT_UNREAD_COMMENT_SHORTCUT),
        listener: ()=>{
            if (!(isNextCommentLoading && (0, $6mKj3.expValEquals)('cc_comments_fix_keyboard_select_timeout', 'isEnabled', true))) (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.start({
                pageClass: pageClass,
                entryPoint: 'keyboard-navigation'
            });
            (0, $4EKKB.selectInlineComment).debug('Keyboard navigation to next unread comment', {
                // whenTriggered props added to help debug on Hello (for reproducing issues)
                activeHighlightWhenTriggered: activeHighlight,
                currentlySelectedThreadKeyWhenTriggered: currentlySelectedThreadKey,
                alreadyNavigating: isNextCommentLoading
            });
            handleNextUnreadNavigation();
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
        deprecatedAccelerator: (0, $gnkil.CREATE_COMMENT_SHORTCUT),
        accelerator: (0, $gnkil.UNIVERSAL_OPEN_COMMENT_EDITOR),
        listener: (e)=>openCommentEditorShortcutCb(e)
    }));
};
const $c392465906bed01c$export$c1f9f1253d923bc1 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).COMMENTS
})((0, $inDu6.withDialogs)($c392465906bed01c$var$ViewCommentShortcutListenerComponent));
module.exports["ViewCommentShortcutListener"] = $c392465906bed01c$export$c1f9f1253d923bc1;

});

parcelRegister("fyPYm", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bavCP = parcelRequire("bavCP");


var $eyzLS = parcelRequire("eyzLS");

let $701bdc3764047e40$var$lastContentId;
const $701bdc3764047e40$export$cc2fc38458ee98cc = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { contentId: contentId } = t0;
    let t1;
    let t2;
    if ($[0] !== contentId) {
        t1 = ()=>{
            $701bdc3764047e40$var$lastContentId = contentId;
        };
        t2 = [
            contentId
        ];
        $[0] = contentId;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[3] !== contentId) {
        t3 = {
            contentId: contentId
        };
        $[3] = contentId;
        $[4] = t3;
    } else t3 = $[4];
    const t4 = $701bdc3764047e40$var$lastContentId === contentId;
    let t5;
    if ($[5] !== t3 || $[6] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bavCP.QueryInterop), {
            query: (0, $eyzLS.default),
            variables: t3,
            fetchPolicy: "network-only",
            skip: t4,
            __callerPackage__: "content-body"
        }, $701bdc3764047e40$var$_temp);
        $[5] = t3;
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    return t5;
};
function $701bdc3764047e40$var$_temp() {
    return null;
}
module.exports["ContentViewedEvent"] = $701bdc3764047e40$export$cc2fc38458ee98cc;

});

parcelRegister("eyzLS", function(module, exports) {
/**
 * @generated SignedSource<<b170f4062a7b22df5c789ae2263ec5d9>>
 * @relayHash 6b82c836e177933e272ade59efcd5b5c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6442e1d626bb37ef4897bdc166747bc6f6f93f7d888574ea37d7d5521fde4b42
const $ac80f5dc8fd0c04e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "trigger",
                    "value": "viewed"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentViewedEventQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentViewedEventQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "6b82c836e177933e272ade59efcd5b5c",
            "id": "6442e1d626bb37ef4897bdc166747bc6f6f93f7d888574ea37d7d5521fde4b42",
            "metadata": {},
            "name": "ContentViewedEventQuery",
            "operationKind": "query",
            "text": "query ContentViewedEventQuery($contentId:ID){content(id:$contentId,trigger:\"viewed\"){nodes{id}}}"
        }
    };
}();
$ac80f5dc8fd0c04e$var$node.hash = "d8b1d8e3bca16082db7c9284db04b505";
var $ac80f5dc8fd0c04e$export$2e2bcd8739ae039 = $ac80f5dc8fd0c04e$var$node;
module.exports["default"] = $ac80f5dc8fd0c04e$export$2e2bcd8739ae039;

});

parcelRegister("39nIX", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");

var $398ES = parcelRequire("398ES");


var $7boqA = parcelRequire("7boqA");


var $5RuD9 = parcelRequire("5RuD9");


var $jhifQ = parcelRequire("jhifQ");


/* View Mode Exports */ const $166368e9a123fc4e$var$InlineCommentsLoaderPaint = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "fZs06",
    name: "InlineCommentsLoaderPaint",
    loader: async ()=>(await (parcelRequire("aaM39"))).InlineComments,
    loading: (0, $5RuD9.InlineCommentsLoading)
});

const $166368e9a123fc4e$var$InlineCommentsLoaderLazy = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "i8DIK",
    name: "InlineCommentsLoaderLazy",
    loader: async ()=>(await (parcelRequire("aaM39"))).InlineComments,
    loading: (0, $5RuD9.InlineCommentsLoading)
});

const $166368e9a123fc4e$var$InlineCommentsLoaderAfterPaint = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "vilgC",
    name: "InlineCommentsLoaderAfterPaint",
    loader: async ()=>(await (parcelRequire("aaM39"))).InlineComments
});

const $166368e9a123fc4e$var$InlineCommentsLoaderBackground = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "05zPo",
    name: "InlineCommentsLoaderBackground",
    loader: async ()=>(await (parcelRequire("aaM39"))).InlineComments
});
const $166368e9a123fc4e$var$loaders = {
    [(0, $398ES.LoadingPriority).LAZY]: $166368e9a123fc4e$var$InlineCommentsLoaderLazy,
    [(0, $398ES.LoadingPriority).PAINT]: $166368e9a123fc4e$var$InlineCommentsLoaderPaint,
    [(0, $398ES.LoadingPriority).AFTER_PAINT]: $166368e9a123fc4e$var$InlineCommentsLoaderAfterPaint
};
const $166368e9a123fc4e$export$bceb71dc98e1c75f = ({ loadingPriority: loadingPriority, focusedCommentId: focusedCommentId, ...rest })=>{
    const CommentsLoader = $166368e9a123fc4e$var$loaders[loadingPriority] || $166368e9a123fc4e$var$InlineCommentsLoaderBackground;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, focusedCommentId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
        key: `start-${focusedCommentId}`,
        metric: (0, $jhifQ.FOCUSED_INLINE_COMMENT_METRIC)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(CommentsLoader, rest));
};
module.exports["InlineCommentsLoader"] = $166368e9a123fc4e$export$bceb71dc98e1c75f;

});

parcelRegister("5RuD9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $8uhVX = parcelRequire("8uhVX");


var $beAZw = parcelRequire("beAZw");

const $58d1b0f1d68392b5$var$checkForSSRFocusedComment = ()=>{
    if (window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']) return true;
    return false;
};
const $58d1b0f1d68392b5$export$d174da0f28ffce9e = ()=>{
    return $58d1b0f1d68392b5$var$checkForSSRFocusedComment() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8uhVX.FocusedInlineComment), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $beAZw.InlineCommentsLoadingSkeleton), null);
};
module.exports["InlineCommentsLoading"] = $58d1b0f1d68392b5$export$d174da0f28ffce9e;

});

parcelRegister("8uhVX", function(module, exports) {
/* FocusedInlineComment.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $dOBRD = parcelRequire("dOBRD");


var $kSwu1 = parcelRequire("kSwu1");


var $9wGTI = parcelRequire("9wGTI");


var $jMyy4 = parcelRequire("jMyy4");


var $7zgzO = parcelRequire("7zgzO");


var $ep3mz = parcelRequire("ep3mz");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");




var $9CnRS = parcelRequire("9CnRS");


var $666Tc = parcelRequire("666Tc");


var $k5dl6 = parcelRequire("k5dl6");



var $f8HSn = parcelRequire("f8HSn");


var $qYtBT = parcelRequire("qYtBT");


var $dQJV7 = parcelRequire("dQJV7");


var $c04ej = parcelRequire("c04ej");

const $d9a6205ec51ab13a$var$parseContent = (0, $dOBRD.default)((content)=>{
    if (!content?.length) return null;
    try {
        return JSON.parse(content);
    } catch  {
        return null;
    }
});
const $d9a6205ec51ab13a$var$FocusedInlineCommentContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = (0, $666Tc.SidebarContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_162hus6": (0, $9aYkv.default)(__cmplp.offset, "px")
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2IhTon3k40 _2mf0CM1PzL _2PfEqSsyl5",
            __cmplp.showSkeleton ? "_3iDTPbvLZJ" : "_3iDTPbYbGa",
            __cmplp.className
        ])
    });
}); /* Comment Editor CSS*/ 
const $d9a6205ec51ab13a$var$EditorContainerSSRFallback = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = (0, $666Tc.EditorContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2qR9w71Y8M _3ppEVQOeNX _2saX4d4Y4b _1nozOlmnOE _2xyuKVuNcX _1gNu1g2Njc _3lRpoLN91d",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $d9a6205ec51ab13a$var$EditorContainerSSRTokenized = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = (0, $666Tc.EditorContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2qR9w71Y8M _3ppEVQOeNX _2saX4dKxmn _1nozOlmnOE _2xyuKVuNcX _1gNu1g2Njc _3lRpoLN91d",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $d9a6205ec51ab13a$var$CommentContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFocused: isFocused, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4FKVYEeCFc _2xIroY98eZ _497WNwYbGa _2zndICT6kp _3JzbaednbC _2bqfgddnbC _3iDTPbQ4SZ _0aFT5vbt8w _4aZwk7dnbC _18JcJDy7kJ",
            __cmplp.isFocused && "_2uo31fDM2k",
            __cmplp.className
        ])
    });
});
const $d9a6205ec51ab13a$export$622cea445a1c5b7d = ()=>{
    if (window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']) return window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']['markerRefOffset'];
    return 0;
}; // Makes sure to only show focusedInlineCommentSSR if the page was ssr'd
const $d9a6205ec51ab13a$export$db871669e60ed1cb = ()=>{
    if (window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']) return true;
    return false;
};
const $d9a6205ec51ab13a$export$7afb8d400fcdf579 = ({ focusedCommentData: focusedCommentData } = {})=>{
    const EditorContainerSSR = (0, $9wGTI.fg)('confluence_frontend_tokenize_border') ? $d9a6205ec51ab13a$var$EditorContainerSSRTokenized : $d9a6205ec51ab13a$var$EditorContainerSSRFallback;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { match: match } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const focusedCommentId = match?.query.focusedCommentId;
    const focusedCommentIdString = typeof focusedCommentId === 'string' ? focusedCommentId : ''; // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const { data: legacyData } = (0, $jMyy4.useQueryInterop)((0, $k5dl6.default), {
        variables: {
            commentId: focusedCommentIdString,
            contentId: contentId
        },
        skip: focusedCommentData !== undefined || !(contentId && focusedCommentId),
        __callerPackage__: "inline-comments"
    });
    const data = focusedCommentData ?? legacyData;
    let commentData;
    let isTopLevelComment = true; /* If focusedCommentId is a reply grab top-level comment Data from ancestors.
                                 If ancestors is non-empty it means focusedCommentId is a reply*/ 
    if (data?.comments?.nodes?.[0]?.ancestors && data.comments.nodes[0].ancestors.length > 0) {
        commentData = data.comments.nodes[0].ancestors[0];
        isTopLevelComment = false;
    } else commentData = data?.comments?.nodes?.[0];
    if (window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']) window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']['isTopLevelComment'] = isTopLevelComment;
    const content = data?.content?.nodes?.[0];
    const operations = content?.operations || [];
    const canCreateComments = Boolean(operations.find((op)=>op?.operation === 'create' && op?.targetType === 'comment'));
    const topCommentUserId = commentData?.author?.accountId;
    const topCommentUserAvatar = commentData?.author?.profilePicture?.path;
    const topCommentDisplayName = commentData?.author?.displayName;
    const commentId = commentData?.id;
    const when = commentData?.version?.when;
    const commentContent = commentData?.body?.value;
    const permissionType = commentData?.author?.permissionType;
    const currentUserAvatarUrl = data?.user?.photos?.[0]?.value ?? undefined;
    const currentUserDisplayName = data?.user?.displayName ?? undefined;
    const currentUserId = data?.user?.id;
    const adf = $d9a6205ec51ab13a$var$parseContent(commentContent);
    const renderReplies = ()=>{
        const replies = commentData?.replies || [];
        return replies.map((reply)=>{
            const adf = $d9a6205ec51ab13a$var$parseContent(reply?.body?.value);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d9a6205ec51ab13a$var$CommentContainer, {
                key: reply?.id,
                isFocused: focusedCommentId === reply?.id,
                "data-comment-id": reply?.id
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f8HSn.CommentAuthor), {
                commentMode: "view",
                userId: reply?.author?.accountId,
                avatarUrl: reply?.author?.profilePicture?.path,
                displayName: reply?.author?.displayName,
                date: reply?.version?.when,
                permissionType: reply?.author?.permissionType
            }), adf && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c04ej.CommentRenderer), {
                adf: adf
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQJV7.CommentActions), {
                isReply: true,
                permissions: reply?.permissions
            }));
        });
    }; // Scroll to focusedInlineComment if it's out of the screen
    const scrollOffset = window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment'] && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']['scrollOffset'];
    if (scrollOffset) window.scrollTo({
        top: scrollOffset
    });
    if (data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).COLLABORATION
    }, undefined, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d9a6205ec51ab13a$var$FocusedInlineCommentContainer, {
        mode: "view",
        id: "focused-inline-comment-sidebar-skeleton",
        "data-testid": "focused-inline-comment-sidebar-skeleton",
        showSkeleton: $d9a6205ec51ab13a$export$db871669e60ed1cb(),
        offset: $d9a6205ec51ab13a$export$622cea445a1c5b7d()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $qYtBT.CommentHeader), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d9a6205ec51ab13a$var$CommentContainer, {
        tabIndex: -1,
        "data-comment-id": commentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f8HSn.CommentAuthor), {
        commentMode: "view",
        userId: topCommentUserId,
        avatarUrl: topCommentUserAvatar,
        displayName: topCommentDisplayName,
        date: when,
        permissionType: permissionType,
        size: "medium"
    }), adf && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c04ej.CommentRenderer), {
        adf: adf
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQJV7.CommentActions), {
        permissions: commentData?.permissions,
        isReply: false
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $666Tc.ReplyListContainer), {
        "data-testid": "reply-container"
    }, renderReplies()), canCreateComments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $666Tc.NewReplyContainer), {
        mode: "view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(EditorContainerSSR, {
        isReply: true,
        mode: "view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f8HSn.CommentAuthor), {
        commentMode: "reply",
        userId: currentUserId,
        avatarUrl: currentUserAvatarUrl,
        displayName: currentUserDisplayName,
        date: when,
        permissionType: permissionType,
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
        disabled: true,
        placeholder: formatMessage((0, $9CnRS.i18n).replyPlaceholder),
        "aria-label": formatMessage((0, $9CnRS.i18n).replyPlaceholder)
    })))), undefined);
    return null;
};
module.exports["FocusedInlineComment"] = $d9a6205ec51ab13a$export$7afb8d400fcdf579;

});

parcelRegister("f8HSn", function(module, exports) {
/* CommentAuthor.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $fs6LW = parcelRequire("fs6LW");


var $gvWVt = parcelRequire("gvWVt");


var $1YXTQ = parcelRequire("1YXTQ");


var $7tI6B = parcelRequire("7tI6B");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b0598b16360d1677$var$DateContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0aFT5v1qpb _3TGfC9LRg7 _3iDTPbQ4SZ _0hPCNLDIqT _2nAzZY7NXe _3RsaIWDqSm _0wo9inYbGa _4iwgQuue9s _446nnCjOvk _2lNPC8ue9s _0C6zJvue9s _38OER1ue9s",
            __cmplp.className
        ])
    });
});
const $b0598b16360d1677$var$AuthorContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { commentMode: commentMode, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _22oNuexTF4 _2yDaurOiJt _4spS4gp3yX _3hQzY9X0uO _1jiWpAxTF4 _29j1ZvOiJt _14UqCFp3yX _0ojMq8X0uO _3SAfpPX0uO",
            __cmplp.commentMode !== 'reply' ? "_2XsHFMLl21" : "_2XsHFMOLYo",
            __cmplp.commentMode === 'view' && "_1wydGW2ADO",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b0598b16360d1677$var$AvatarWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { commentMode: commentMode, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _1Znuxb2ADO",
            __cmplp.commentMode === 'view' && "_0jFU0VcGqM",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b0598b16360d1677$var$Container = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5vbt8w",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b0598b16360d1677$var$ProfileLinkContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _2T6Qwz7NXe _0Q3GESdnbC _4eIIqhdnbC _0Hw68KdnbC _2c53ZwdnbC _0dd3JMYbGa _2G5wyoue9s _44YFBHjOvk _300gQyZpcK _3jmJJAZpcK _3sSsf9ZpcK _2kTPupxTF4 _0uh2fEOiJt _38Fkkxp3yX _2je84wX0uO _2nvP5bxTF4 _25zaNoOiJt _0BkunOp3yX _1ntv0BX0uO _2XmlcKq7kh _4iwgQuX0uO",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b0598b16360d1677$var$LozengeWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2Zuz6Q2ADO _1RrJLiBwqQ",
            __cmplp.className
        ])
    });
});
const $b0598b16360d1677$export$d05a2f5fbf67a6d7 = ({ commentMode: commentMode, userId: userId, date: date, displayName: displayName, avatarUrl: avatarUrl, permissionType: permissionType, size: size })=>{
    const isDateShown = commentMode === 'view' && date;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0598b16360d1677$var$AuthorContainer, {
        commentMode: commentMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0598b16360d1677$var$AvatarWrapper, {
        commentMode: commentMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fs6LW.ProfileAvatar), {
        userId: userId,
        src: avatarUrl,
        size: size,
        trigger: "click",
        name: displayName
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0598b16360d1677$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0598b16360d1677$var$ProfileLinkContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, displayName), permissionType === (0, $7tI6B.SitePermissionType).EXTERNAL ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0598b16360d1677$var$LozengeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gvWVt.ExternalCollaboratorUserLozenge), null)) : null), isDateShown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0598b16360d1677$var$DateContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1YXTQ.TimeAgo), {
        date: date
    })))));
};
module.exports["CommentAuthor"] = $b0598b16360d1677$export$d05a2f5fbf67a6d7;

});

parcelRegister("qYtBT", function(module, exports) {
/* CommentHeader.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $l3wuH = parcelRequire("l3wuH");


var $6TaGl = parcelRequire("6TaGl");


var $7N1sB = parcelRequire("7N1sB");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9359cd91b07ea16f$var$SidebarHeader = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4FKVYEadeX _1mT5xdRAKS _3iDTPbQ4SZ _0jFU0VfFOW _0Of8r28HPE _3w3L6SfmT7 _2b10MqKxmn _0MaIcWSPN1 _2umo1wSPN1 _1F9kkuIZbP _41HqaF8HPE _0YELLt1Y8M _2DyqaeUWqv",
            __cmplp.className
        ])
    });
});
const $9359cd91b07ea16f$export$af4e8b81cdb5570a = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9359cd91b07ea16f$var$SidebarHeader, {
        "data-testid": "inline-comment-ssr-header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7N1sB.CommentNavigation), {
        goToNextInlineComment: ()=>{},
        goToPrevInlineComment: ()=>{}
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        id: "dropdown"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
        label: "overflow-menu-icon",
        color: "var(--ds-icon-disabled, #080F214A)",
        spacing: "spacious"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        id: "close-icon-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
        label: "close-icon",
        color: `${"var(--ds-icon-disabled, #080F214A)"}`,
        spacing: "none"
    })));
};
module.exports["CommentHeader"] = $9359cd91b07ea16f$export$af4e8b81cdb5570a;

});

parcelRegister("dQJV7", function(module, exports) {
/* CommentActions.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $bFPHx = parcelRequire("bFPHx");


var $666Tc = parcelRequire("666Tc");


var $9CnRS = parcelRequire("9CnRS");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e6040be4eb93366f$var$ActionsContainerSSR = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = (0, $666Tc.ActionsContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4kiQYAfFOW _3iDTPbQ4SZ _0hPCNLDIqT",
            __cmplp.className
        ])
    });
});
const $e6040be4eb93366f$var$ActionItem = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0aFT5v1qpb _3TGfC9LRg7 _3iDTPbccYA _1UtDYzKGUX _3138421Y8M _2ed5MiiZR3 _2EaR2a7dHp _04CNNZAEMG _0XEZqI7NXe _0sfB8dz9WS _0gKGieGaer _45Fm8l0dzo _0Ya3911Y8M _4m1FceSsSj _0y3UDVbQDk _1z9enHKGUX _0RxVZVKGUX",
            __cmplp.className
        ])
    });
});
const $e6040be4eb93366f$var$ActionButton = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2uo31fYbGa _30huDKYbGa _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _2xIroY98eZ _497WNwOLYo _2zndICT6kp _1UtDYzOLYo _4ya3eEOLYo _0wOv4Q7zJH",
            __cmplp.className
        ])
    });
});
const $e6040be4eb93366f$export$e75a036919cd8d68 = ({ isReply: isReply, permissions: permissions })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e6040be4eb93366f$var$ActionsContainerSSR, null, permissions.isResolvable && !isReply && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e6040be4eb93366f$var$ActionItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e6040be4eb93366f$var$ActionButton, {
        type: "button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $9CnRS.i18n).resolve))), permissions.isEditable && isReply && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e6040be4eb93366f$var$ActionItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e6040be4eb93366f$var$ActionButton, {
        type: "button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $9CnRS.i18n).edit))), permissions.isRemovable && isReply && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e6040be4eb93366f$var$ActionItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e6040be4eb93366f$var$ActionButton, {
        type: "button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $9CnRS.i18n).delete))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e6040be4eb93366f$var$ActionItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bFPHx.ReactionsPlaceholder), null)));
module.exports["CommentActions"] = $e6040be4eb93366f$export$e75a036919cd8d68;

});

parcelRegister("c04ej", function(module, exports) {
/* CommentRenderer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $bzqa9 = parcelRequire("bzqa9");


var $hEeUR = parcelRequire("hEeUR");


var $6mKj3 = parcelRequire("6mKj3");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $61a27fe9845a1cb4$var$CommentRendererContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _0Of8r28HPE _1wydGW8HPE",
            __cmplp.className
        ])
    });
});
const $61a27fe9845a1cb4$export$ce6d3ea87eba7794 = ({ adf: adf })=>{
    const eventHandlers = (0, $bzqa9.useEventHandlers)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($61a27fe9845a1cb4$var$CommentRendererContainer, {
        id: "ssr-comment-renderer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hEeUR.ADFRenderer), {
        document: adf,
        appearance: "comment",
        eventHandlers: eventHandlers,
        ...(0, $6mKj3.expValEquals)('confluence_comments_media_ssr_support', 'isEnabled', true) && {
            media: undefined
        }
    }));
};
module.exports["CommentRenderer"] = $61a27fe9845a1cb4$export$ce6d3ea87eba7794;

});

parcelRegister("beAZw", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $rVJpV = parcelRequire("rVJpV");


var $666Tc = parcelRequire("666Tc");

const $c9d0ea73f4f989e9$export$bb9f90f28a3a4c80 = ()=>{
    if (window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['clickedInlineHighlightElements'] && Array.isArray(window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['clickedInlineHighlightElements'])) return Boolean(window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['clickedInlineHighlightElements'].length);
    return false;
};
const $c9d0ea73f4f989e9$export$e90f33bd7f6da077 = ({ offset: offset = 0 })=>{
    /* For SSR check window object or use offset if passed */ // Previously, clicking on a comment via the inline comment button would still generate an offset.
    // That meant that on transitions, the loading skeleton would still flicker, so we check for window.__SSR_RENDERED__ as well
    /// to prevent the flicker on transitions.
    const sideBarOffset = window.__SSR_RENDERED__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['sidebarCommentOffset'] || offset;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $666Tc.LoadingSkeletonContainer), {
        id: "inline-comment-sidebar-skeleton",
        "data-testid": "inline-comment-sidebar-skeleton",
        showSkeleton: $c9d0ea73f4f989e9$export$bb9f90f28a3a4c80() || Boolean(offset),
        offset: sideBarOffset,
        mode: "view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $rVJpV.LoadingSkeletonChildren), null));
};
module.exports["InlineCommentsLoadingSkeleton"] = $c9d0ea73f4f989e9$export$e90f33bd7f6da077;

});

parcelRegister("rVJpV", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $7sJoX = parcelRequire("7sJoX");


var $j6vyT = parcelRequire("j6vyT");


var $lfoFx = parcelRequire("lfoFx");


var $l3wuH = parcelRequire("l3wuH");


var $6TaGl = parcelRequire("6TaGl");


var $666Tc = parcelRequire("666Tc");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5ae94c9feb318d8$var$SkeletonContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4FKVYE5zaO _2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _3iDTPbQ4SZ _0aFT5vbt8w",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5ae94c9feb318d8$var$CommentSkeletonRow = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { flex: flex, useColumnDirection: useColumnDirection, marginTop: marginTop, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_flb7sw": (0, $9aYkv.default)(__cmplp.flex),
                "--_11vu6jx": (0, $9aYkv.default)(__cmplp.marginTop, "px")
            },
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_3iDTPbQ4SZ _313842nyBQ",
                __cmplp.flex ? "_1ma2CfoML7" : "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG",
                __cmplp.useColumnDirection ? "_0aFT5vbt8w" : "_0aFT5v1qpb",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $f5ae94c9feb318d8$var$CommentAuthorSkeleton = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_0bjKvDS5Zs _0jFU0VUofl _39xV02Uofl _0KLXruGsB2",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5ae94c9feb318d8$var$CommentSkeletonLine = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { marginBottom: marginBottom, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_iz5w78": (0, $9aYkv.default)(__cmplp.marginBottom, "px"),
                "--_10ib6lf": (0, $9aYkv.default)(__cmplp.height, "px"),
                "--_1gljcou": (0, $9aYkv.default)(__cmplp.width, "px")
            },
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_0bjKvD4Y4b _0KLXruGsB2 _39xV027Ovj",
                typeof __cmplp.marginBottom === "number" ? "_1DCdHipKMF" : "_1DCdHi2AF2",
                __cmplp.height ? "_0jFU0VQtZt" : "_0jFU0VJg58",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $f5ae94c9feb318d8$var$SpinnerContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _3138422ADO",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5ae94c9feb318d8$var$SidebarHeader = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4FKVYEWlT4 _1mT5xdRAKS _3iDTPbQ4SZ _37wbyuI7V3 _0jFU0VfFOW",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f5ae94c9feb318d8$var$CloseButton = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $666Tc.InlineHeaderButton) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMyrFs _0jFU0VoWWg _39xV02oWWg",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f5ae94c9feb318d8$var$NavContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $666Tc.NavigationContainer) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_0hPCNLDIqT",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f5ae94c9feb318d8$export$4857ba7068d0bed8 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_313842dnbC _1DCdHidnbC _1mT5xdRAKS _0KLXrulfZc",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f5ae94c9feb318d8$export$a42ae5e40534ea56 = ()=>{
    const $ = (0, $bDgLe.c)(7);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $666Tc.InlineHeaderButton), {
            "data-cy": "inline-nav-previous",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), {
                label: "",
                color: "var(--ds-icon-disabled, #080F214A)",
                spacing: "spacious",
                size: "small"
            })
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$var$NavContainer, null, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $666Tc.InlineHeaderButton), {
            "data-cy": "inline-nav-previous",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                label: "",
                color: "var(--ds-icon-disabled, #080F214A)",
                spacing: "spacious",
                size: "small"
            })
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$var$CommentSkeletonLine, {
            width: 30,
            height: 8,
            marginBottom: 0
        }));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
            spacing: "spacious",
            label: "",
            color: "var(--ds-icon-disabled, #080F214A)"
        });
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$var$SidebarHeader, null, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$var$NavContainer, null, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$var$CloseButton, {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                label: ""
            })
        })));
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$var$CommentSkeletonRow, {
            flex: 1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$var$CommentAuthorSkeleton, null));
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$export$4857ba7068d0bed8, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$var$SkeletonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$var$CommentSkeletonRow, {
            flex: 1
        }, t4, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$var$CommentSkeletonRow, {
            flex: 5,
            marginTop: 5,
            useColumnDirection: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$var$CommentSkeletonLine, {
            width: 81
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$var$CommentSkeletonLine, {
            width: 53,
            height: 6
        })))));
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, t3, t5, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            size: "medium",
            interactionName: "inline-comments-loading-skeleton"
        })));
        $[6] = t6;
    } else t6 = $[6];
    return t6;
};
module.exports["LoadingSkeletonChildren"] = $f5ae94c9feb318d8$export$a42ae5e40534ea56;

});

parcelRegister("aaM39", function(module, exports) {

let $76801c456898e393$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $76801c456898e393$var$load("11vYs"),
    $76801c456898e393$var$load("lkHIj"),
    $76801c456898e393$var$load("b8BFA"),
    $76801c456898e393$var$load("7BHAC"),
    $76801c456898e393$var$load("N3TvS"),
    $76801c456898e393$var$load("6wr18"),
    $76801c456898e393$var$load("lK9vp"),
    $76801c456898e393$var$load("50xKF"),
    $76801c456898e393$var$load("34Kox"),
    $76801c456898e393$var$load("7Y0AX"),
    $76801c456898e393$var$load("cKqFC"),
    $76801c456898e393$var$load("2bOpC"),
    $76801c456898e393$var$load("bY2TC"),
    $76801c456898e393$var$load("Wowvf"),
    $76801c456898e393$var$load("jqoep"),
    $76801c456898e393$var$load("7EorR"),
    $76801c456898e393$var$load("eUsnQ"),
    $76801c456898e393$var$load("e3Gt5"),
    $76801c456898e393$var$load("ffEVr"),
    $76801c456898e393$var$load("dIY7W"),
    $76801c456898e393$var$load("fWCBZ"),
    $76801c456898e393$var$load("75JEs"),
    $76801c456898e393$var$load("lywre"),
    $76801c456898e393$var$load("1PFZq")
]).then(()=>parcelRequire('31yzi'));

});

parcelRegister("kXxhd", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $jMyy4 = parcelRequire("jMyy4");


var $iffSy = parcelRequire("iffSy");


var $6mKj3 = parcelRequire("6mKj3");


var $1xpoY = parcelRequire("1xpoY");


var $8zMP3 = parcelRequire("8zMP3");


var $kkyaa = parcelRequire("kkyaa");


var $1ydBT = parcelRequire("1ydBT");


var $cQbnm = parcelRequire("cQbnm");

const $c617e062ca15da40$var$ConversationFocusedInlineCommentReader = (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { contentId: contentId, focusedCommentId: focusedCommentId, children: children } = t0;
    let t1;
    if ($[0] !== contentId || $[1] !== focusedCommentId) {
        t1 = (0, $cQbnm.buildPreloadObjectCommentsQueryVariables)(contentId, !(0, $1xpoY.default).isKillSwitchOn("confluence_vp_conversation_data_frag_reader") && (0, $6mKj3.expVal)("confluence_exp_conversation_contract", "isEnabled", false), !(0, $1xpoY.default).isKillSwitchOn("confluence_vp_comment_threads_frag_reader") && (0, $6mKj3.expVal)("confluence_exp_conversation_contract", "isEnabled", false), focusedCommentId, true);
        $[0] = contentId;
        $[1] = focusedCommentId;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== t1) {
        t2 = {
            variables: t1,
            fetchPolicy: "cache-first"
        };
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    const { data: data, error: error } = (0, $jMyy4.useQueryInterop)((0, $1ydBT.default), {
        ...t2,
        __callerPackage__: "object-comments"
    });
    const comments = (0, $6SsN4.useFragment)((0, $kkyaa.ViewPageConversationFocusedInlineCommentFragment), data?.focusedInlineComment);
    const context = (0, $6SsN4.useFragment)((0, $kkyaa.ViewPageConversationFocusedInlineCommentContextFragment), data?.focusedInlineCommentContext);
    let t3;
    if ($[5] !== children || $[6] !== comments || $[7] !== context || $[8] !== error) {
        t3 = children({
            data: context ? {
                comments: comments ?? null,
                content: context.focusedContent,
                user: context.user
            } : undefined,
            error: error
        });
        $[5] = children;
        $[6] = comments;
        $[7] = context;
        $[8] = error;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
};
const $c617e062ca15da40$export$6bfb579013157167 = (props)=>{
    const $ = (0, $bDgLe.c)(5);
    if (!props.skip && props.contentId && props.focusedCommentId && (0, $iffSy.isRelayEnabled)("@confluence/object-comments", {
        operationName: "ObjectCommentContainerPreloadObjectCommentsQuery"
    }) && !(0, $1xpoY.default).isKillSwitchOn("confluence_vp_conversation_query") && (0, $6mKj3.expVal)("confluence_exp_conversation_contract", "isEnabled", false)) {
        const t0 = `${props.contentId}:${props.focusedCommentId}`;
        let t1;
        if ($[0] !== props || $[1] !== t0) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
                dataFetcherName: "object-comments"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c617e062ca15da40$var$ConversationFocusedInlineCommentReader, {
                key: t0,
                ...props
            }));
            $[0] = props;
            $[1] = t0;
            $[2] = t1;
        } else t1 = $[2];
        return t1;
    }
    let t0;
    if ($[3] !== props.children) {
        t0 = props.children(undefined);
        $[3] = props.children;
        $[4] = t0;
    } else t0 = $[4];
    return t0;
};
module.exports["ConversationFocusedInlineCommentData"] = $c617e062ca15da40$export$6bfb579013157167;

});

parcelRegister("kkyaa", function(module, exports) {

var $2ibqk = parcelRequire("2ibqk");


var $cYQhX = parcelRequire("cYQhX");

const $9486c2afa4269137$export$23ec50f41a8c03f3 = (0, $cYQhX.default);
const $9486c2afa4269137$export$d6fc2ec6b9462cd3 = (0, $2ibqk.default);
module.exports["ViewPageConversationFocusedInlineCommentContextFragment"] = $9486c2afa4269137$export$23ec50f41a8c03f3;
module.exports["ViewPageConversationFocusedInlineCommentFragment"] = $9486c2afa4269137$export$d6fc2ec6b9462cd3;

});

parcelRegister("2ibqk", function(module, exports) {
/**
 * @generated SignedSource<<a5cceb9bf54989b6a7b98d4adca43291>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a856f16fd0c61a63$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v2 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v1 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v3 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v1 /*: any*/ 
    }, v4 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v5 = {
        "kind": "ScalarField",
        "name": "isInlineComment"
    }, v6 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v8 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v7 /*: any*/ 
                ]
            },
            {
                "kind": "ScalarField",
                "name": "when"
            },
            {
                "kind": "ScalarField",
                "name": "number"
            }
        ]
    }, v9 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "editui"
            }
        ]
    }, v10 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v7 /*: any*/ ,
            {
                "concreteType": "Icon",
                "kind": "LinkedField",
                "name": "profilePicture",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "path"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "permissionType"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    }
                ],
                "type": "KnownUser"
            }
        ]
    }, v11 = {
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "replies",
        "plural": true,
        "selections": [
            v0 /*: any*/ ,
            v2 /*: any*/ ,
            v3 /*: any*/ ,
            v4 /*: any*/ ,
            v5 /*: any*/ ,
            v6 /*: any*/ ,
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v10 /*: any*/ 
        ]
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "ViewPageConversation_focusedInlineComment",
        "selections": [
            {
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "Comment",
                        "kind": "LinkedField",
                        "name": "ancestors",
                        "plural": true,
                        "selections": [
                            v0 /*: any*/ ,
                            v2 /*: any*/ ,
                            v3 /*: any*/ ,
                            v4 /*: any*/ ,
                            v5 /*: any*/ ,
                            v6 /*: any*/ ,
                            v8 /*: any*/ ,
                            v9 /*: any*/ ,
                            v10 /*: any*/ ,
                            v11 /*: any*/ 
                        ]
                    },
                    v0 /*: any*/ ,
                    v2 /*: any*/ ,
                    v3 /*: any*/ ,
                    v4 /*: any*/ ,
                    v5 /*: any*/ ,
                    v6 /*: any*/ ,
                    v8 /*: any*/ ,
                    v9 /*: any*/ ,
                    v10 /*: any*/ ,
                    v11 /*: any*/ 
                ]
            }
        ],
        "type": "PaginatedCommentList"
    };
}();
$a856f16fd0c61a63$var$node.hash = "37af883d6bca3956d59413c98a596144";
var $a856f16fd0c61a63$export$2e2bcd8739ae039 = $a856f16fd0c61a63$var$node;
module.exports["default"] = $a856f16fd0c61a63$export$2e2bcd8739ae039;

});

parcelRegister("cYQhX", function(module, exports) {
/**
 * @generated SignedSource<<34de7da99f0006e94754dd590c6724b9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5f0126da97f3bb0a$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "pageId"
            }
        ],
        "kind": "Fragment",
        "name": "ViewPageConversation_focusedInlineCommentContext",
        "selections": [
            {
                "alias": "focusedContent",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "id",
                        "variableName": "pageId"
                    }
                ],
                "concreteType": "PaginatedContentListWithChild",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "Content",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "type"
                            },
                            {
                                "concreteType": "Space",
                                "kind": "LinkedField",
                                "name": "space",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    v1 /*: any*/ 
                                ]
                            },
                            v1 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "alias": "user",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "current",
                        "value": true
                    }
                ],
                "concreteType": "AtlassianUser",
                "kind": "LinkedField",
                "name": "confluence_atlassianUser",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "displayName"
                    },
                    {
                        "concreteType": "AtlassianUserPhoto",
                        "kind": "LinkedField",
                        "name": "photos",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "value"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "isPrimary"
                            }
                        ]
                    }
                ],
                "storageKey": "confluence_atlassianUser(current:true)"
            }
        ],
        "type": "Query"
    };
}();
$5f0126da97f3bb0a$var$node.hash = "ddb1698b02dde6247368f7bab97ffc0a";
var $5f0126da97f3bb0a$export$2e2bcd8739ae039 = $5f0126da97f3bb0a$var$node;
module.exports["default"] = $5f0126da97f3bb0a$export$2e2bcd8739ae039;

});

parcelRegister("3s9yq", function(module, exports) {

var $4gWyR = parcelRequire("4gWyR");

const $dc6096cce6b3b96b$export$8c4bf31cea6aa53c = (0, $4gWyR.default);
module.exports["InlineCommentsQuery"] = $dc6096cce6b3b96b$export$8c4bf31cea6aa53c;

});

parcelRegister("4gWyR", function(module, exports) {
/**
 * @generated SignedSource<<3bfeca0bb9e902eac5c5f7e4df1177b1>>
 * @relayHash b1e02ca7b094a1ff9aaf5a6b5ddc5a29
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9ca55d271207d138fc62881aa0d6c6f83af1c22e78c15115c42f10e48b73f506
const $ed32661450888f95$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "type"
    }, v3 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v4 = {
        "args": [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "pageId"
            }
        ],
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
            {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v1 /*: any*/ ,
                    v2 /*: any*/ ,
                    {
                        "concreteType": "Space",
                        "kind": "LinkedField",
                        "name": "space",
                        "plural": false,
                        "selections": [
                            v1 /*: any*/ ,
                            v3 /*: any*/ 
                        ]
                    },
                    v3 /*: any*/ 
                ]
            }
        ]
    }, v5 = [
        {
            "kind": "Literal",
            "name": "depth",
            "value": "ROOT"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        },
        {
            "kind": "Variable",
            "name": "pageId",
            "variableName": "pageId"
        },
        {
            "kind": "Literal",
            "name": "type",
            "value": "UNRESOLVED"
        }
    ], v6 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v7 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v6 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v8 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v9 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v6 /*: any*/ 
    }, v10 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v11 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "editui"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v13 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v14 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v15 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v16 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "kind": "ScalarField",
                "name": "inlineText"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    v12 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "isDangling"
                    },
                    v13 /*: any*/ ,
                    v14 /*: any*/ ,
                    v15 /*: any*/ 
                ]
            }
        ],
        "type": "InlineComment"
    }, v17 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "commentResolveProperties",
                "plural": false,
                "selections": [
                    v12 /*: any*/ ,
                    v13 /*: any*/ ,
                    v14 /*: any*/ ,
                    v15 /*: any*/ 
                ]
            }
        ],
        "type": "FooterComment"
    }, v18 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v2 /*: any*/ ,
            v16 /*: any*/ ,
            v17 /*: any*/ 
        ]
    }, v19 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v20 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v21 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v22 = {
        "kind": "ScalarField",
        "name": "when"
    }, v23 = {
        "kind": "ScalarField",
        "name": "number"
    }, v24 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v21 /*: any*/ 
                ]
            },
            v22 /*: any*/ ,
            v23 /*: any*/ 
        ]
    }, v25 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v26 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v27 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v28 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v21 /*: any*/ ,
            v25 /*: any*/ ,
            v26 /*: any*/ ,
            v27 /*: any*/ 
        ]
    }, v29 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v30 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v29 /*: any*/ ,
            v2 /*: any*/ ,
            v16 /*: any*/ ,
            v17 /*: any*/ 
        ]
    }, v31 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v29 /*: any*/ ,
                    v21 /*: any*/ 
                ]
            },
            v22 /*: any*/ ,
            v23 /*: any*/ 
        ]
    }, v32 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v29 /*: any*/ ,
            v21 /*: any*/ ,
            v25 /*: any*/ ,
            v26 /*: any*/ ,
            v27 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "InlineCommentsQuery",
            "selections": [
                v4 /*: any*/ ,
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v24 /*: any*/ ,
                                v28 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        v28 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "InlineCommentsQuery",
            "selections": [
                v4 /*: any*/ ,
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v30 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v31 /*: any*/ ,
                                v32 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v30 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v31 /*: any*/ ,
                                        v32 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "b1e02ca7b094a1ff9aaf5a6b5ddc5a29",
            "id": "9ca55d271207d138fc62881aa0d6c6f83af1c22e78c15115c42f10e48b73f506",
            "metadata": {},
            "name": "InlineCommentsQuery",
            "operationKind": "query",
            "text": "query InlineCommentsQuery($pageId:ID!)@allowHigherTimeout{content(id:$pageId){nodes{id,type,space{id,operations{operation,targetType}},operations{operation,targetType}}},comments(pageId:$pageId,type:UNRESOLVED,depth:ROOT,first:1000){nodes{id,body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{resolved,isDangling,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},replies{id,body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{resolved,isDangling,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}}}}}}"
        }
    };
}();
$ed32661450888f95$var$node.hash = "82d41657ba53df28146f886f7478ca62";
var $ed32661450888f95$export$2e2bcd8739ae039 = $ed32661450888f95$var$node;
module.exports["default"] = $ed32661450888f95$export$2e2bcd8739ae039;

});

parcelRegister("aXika", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9nqKo = parcelRequire("9nqKo");


var $irVI7 = parcelRequire("irVI7");


var $8Ss4E = parcelRequire("8Ss4E");


var $fGzMp = parcelRequire("fGzMp");


var $aJPUt = parcelRequire("aJPUt");


var $ep3mz = parcelRequire("ep3mz");


var $jMyy4 = parcelRequire("jMyy4");


var $4zbo1 = parcelRequire("4zbo1");


var $f9opb = parcelRequire("f9opb");

var $jgc4t = parcelRequire("jgc4t");

var $3qGQ7 = parcelRequire("3qGQ7");


var $1uFM6 = parcelRequire("1uFM6");


var $95rLf = parcelRequire("95rLf");


var $4L9ve = parcelRequire("4L9ve");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $7Sm4c = parcelRequire("7Sm4c");


var $9Q3jD = parcelRequire("9Q3jD");


var $a8ZQ3 = parcelRequire("a8ZQ3");


var $1NBp8 = parcelRequire("1NBp8");


var $5kjCz = parcelRequire("5kjCz");


var $4KFTW = parcelRequire("4KFTW");


var $isEtk = parcelRequire("isEtk");


var $c0urc = parcelRequire("c0urc");

var $1SNEF = parcelRequire("1SNEF");


var $bQm3c = parcelRequire("bQm3c");


var $kvJHJ = parcelRequire("kvJHJ");


var $7boqA = parcelRequire("7boqA");


var $essql = parcelRequire("essql");


var $hu6Tz = parcelRequire("hu6Tz");


var $1xpoY = parcelRequire("1xpoY");




var $gsWjA = parcelRequire("gsWjA");


var $2aFNh = parcelRequire("2aFNh");


var $iuaOs = parcelRequire("iuaOs");


var $4Uwwc = parcelRequire("4Uwwc");

const $50e9068f0df1c4d8$var$pageMap = {
    SPACE_OVERVIEW: {
        route: (0, $1NBp8.SPACE_OVERVIEW),
        errorAttribution: 'next-space-overview',
        name: (0, $irVI7.SPACE_OVERVIEW_EXPERIENCE),
        isContentView: false
    },
    COMPANY_HUB: {
        route: (0, $1NBp8.COMPANY_HUB),
        errorAttribution: 'next-company-hub',
        name: (0, $irVI7.FRONT_COVER_LOAD_EXPERIENCE),
        isContentView: false
    },
    page: {
        route: (0, $1NBp8.VIEW_PAGE),
        errorAttribution: 'next-view-page',
        name: (0, $irVI7.VIEW_PAGE_EXPERIENCE),
        isContentView: true
    }
};
const $50e9068f0df1c4d8$export$2fe638b9bbc723fb = /*#__PURE__*/ (0, $cozmU.memo)(({ contentId: contentId, spaceKey: spaceKey, children: children, stickyHeader: stickyHeader, contentScreenStyles: contentScreenStyles, isContainerContentView: isContainerContentView = true, versionOverride: versionOverride = null, customPerfData: customPerfData, isEmbeddedPage: isEmbeddedPage, hasDocumentContractAnalyticsByline: hasDocumentContractAnalyticsByline = false, hasDocumentContractContentHeader: hasDocumentContractContentHeader = false })=>{
    const { setCurrentDocumentVersion: setCurrentDocumentVersion, setDocumentNeedsUpdate: setDocumentNeedsUpdate, setPublishedDocumentVersion: setPublishedDocumentVersion } = (0, $a8ZQ3.useDocumentUpdateStatusDispatch)();
    const [{ routeName: routeName = '', contentType: contentType }] = (0, $ep3mz.usePageState)();
    const { activationId: activationId, cloudId: cloudId, edition: edition, isAdminHubAIEnabled: isAdminHubAIEnabled, isLicensed: isLicensed, isLoggedIn: isLoggedIn, isRovoLLMEnabled: isRovoLLMEnabled, userId: userId } = (0, $bQm3c.useSessionData)();
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(window.__SSR_RENDERED__);
    (0, $essql.useUnreadCommentsSetup)({
        pageId: contentId,
        pageContentTypeProps: {
            pageMode: 'view'
        }
    });
    const extractDataAndSetPublishedVersion = (0, $cozmU.useCallback)(({ refetchContentQueryResult: refetchContentQueryResult })=>{
        const { data: data } = refetchContentQueryResult;
        if (data) {
            const versionNumber = data.content?.nodes?.[0]?.version?.number;
            if (versionNumber !== undefined && versionNumber !== null) setPublishedDocumentVersion(versionNumber);
        }
    }, [
        setPublishedDocumentVersion
    ]);
    const isBlogpost = contentType === 'blogpost';
    const attachmentDownloadDspAction = 'ATTACHMENT_DOWNLOAD';
    const shouldUseRouteOwnedDsp = // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    routeName !== (0, $1NBp8.SPACE_OVERVIEW).name && routeName !== (0, $1NBp8.COMPANY_HUB).name && // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_dsp_reader') && // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false) && (0, $9wGTI.fg)('dlp_attachment_download_respects_data_export_dsp');
    const dspAction = shouldUseRouteOwnedDsp ? attachmentDownloadDspAction : undefined;
    const shouldUseRouteOwnedCustomChrome = // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    routeName !== (0, $1NBp8.SPACE_OVERVIEW).name && routeName !== (0, $1NBp8.COMPANY_HUB).name && // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_custom_chrome_reader') && // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false);
    const shouldUseContentHeaderFragment = // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    hasDocumentContractContentHeader && // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_header_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false);
    const shouldUseFabricEligibilityFragment = // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    shouldUseContentHeaderFragment && // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_fabric_eligibility_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false);
    const shouldUseRouteOwnedMedia = !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_media_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false) && !(0, $6mKj3.expVal)('confluence_media_token_preload_agg_query', 'isEnabled', false);
    const skipContentQuery = !contentId || !spaceKey;
    const autohighlightsQueryVariables = userId && !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_autohighlights_unified_query') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false) ? (0, $hu6Tz.getAutohighlightsQueryVariables)({
        contentId: contentId,
        cloudId: cloudId,
        activationId: activationId,
        contentType: isBlogpost ? 'blogpost' : 'page'
    }) : undefined;
    // Keep the hydrated query aligned with useAIRovoButtonEnablement without coupling this
    // content-data boundary to the Rovo Button hook.
    const isRovoButtonEnabled = isAdminHubAIEnabled && isRovoLLMEnabled;
    const rovoActivationQueryVariables = !isBlogpost && routeName !== (0, $1NBp8.SPACE_OVERVIEW).name && routeName !== (0, $1NBp8.COMPANY_HUB).name && isLoggedIn && isLicensed && userId && cloudId && isRovoButtonEnabled && (0, $9wGTI.fg)('confluence_rovo_agent_session_nudges') ? {
        cloudId: cloudId
    } : undefined;
    const pageContentQueryVariables = {
        ...(0, $3qGQ7.createContentUnifiedQueryVariables)({
            userId: userId,
            contentId: contentId,
            spaceKey: spaceKey,
            versionOverride: versionOverride,
            isSSR: isSSR,
            // @ts-ignore -- Downstream packages are checked against the last generated content-unified-query declaration.
            includeRendererAssetsMedia: shouldUseRouteOwnedMedia,
            // @ts-ignore -- Downstream packages are checked against the last generated content-unified-query declaration.
            includeRendererAssetsCustomChrome: shouldUseRouteOwnedCustomChrome,
            includeRendererAssetsDsp: Boolean(dspAction),
            rendererAssetsDspAction: dspAction,
            // confluence-feature-gating/inline-usage: expValEquals must be inlined
            agentSessionsUserId: !!userId && (0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true) ? userId : undefined,
            includeAgentTrustReceiptData: (0, $9wGTI.fg)('cc_sparks_agent_trust_receipt'),
            includeBylineContributors: !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_title_byline_frag_dedup') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
            includeConnectionAncestors: (0, $6mKj3.isExperimentEnabled)('confluence_1p_and_3p_connection_byline_experiment'),
            includeAutomationDiscoveries: (0, $9wGTI.fg)('cc_automations_discovery_nudges'),
            includeMetadata: !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_meta_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
            includeClassification: !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_classification_context_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
            includeReactions: !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_reactions_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
            includeAudioContent: !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_audio_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
            // @ts-ignore -- Downstream packages are checked against the last generated content-unified-query declaration.
            includeAnalyticsByline: hasDocumentContractAnalyticsByline && !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_analytics_byline_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
            // @ts-ignore -- Downstream packages are checked against the last generated content-unified-query declaration.
            includeContentHeader: shouldUseContentHeaderFragment,
            includeSmartCreateFeedback: shouldUseContentHeaderFragment && !versionOverride && !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_smart_create_banner_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
            includeContentHeaderAccess: shouldUseContentHeaderFragment && !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_access_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
            includeFabricEditorEligibility: shouldUseFabricEligibilityFragment,
            includeContentHeaderPublicLink: shouldUseContentHeaderFragment && !isBlogpost && !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_access_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
            rovoActivationQueryVariables: rovoActivationQueryVariables,
            autohighlightsQueryVariables: autohighlightsQueryVariables
        }),
        ...!(0, $1xpoY.default).isKillSwitchOn('confluence_vp_mode_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false) ? {
            useContentModeFragment: true
        } : {}
    };
    const blogContentQueryVariables = {
        ...(0, $3qGQ7.createContentBlogUnifiedQueryVariables)({
            userId: userId,
            contentId: contentId,
            spaceKey: spaceKey,
            versionOverride: versionOverride,
            isSSR: isSSR,
            // @ts-ignore -- Downstream packages are checked against the last generated content-unified-query declaration.
            includeRendererAssetsMedia: shouldUseRouteOwnedMedia,
            // @ts-ignore -- Downstream packages are checked against the last generated content-unified-query declaration.
            includeRendererAssetsCustomChrome: shouldUseRouteOwnedCustomChrome,
            includeRendererAssetsDsp: Boolean(dspAction),
            rendererAssetsDspAction: dspAction,
            includeAgentTrustReceiptData: (0, $9wGTI.fg)('cc_sparks_agent_trust_receipt'),
            includeBylineContributors: !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_title_byline_frag_dedup') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
            includeAutomationDiscoveries: (0, $9wGTI.fg)('cc_automations_discovery_nudges'),
            includeMetadata: !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_meta_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
            includeClassification: !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_classification_context_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
            includeReactions: !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_reactions_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
            includeAudioContent: !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_audio_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
            // @ts-ignore -- Downstream packages are checked against the last generated content-unified-query declaration.
            includeAnalyticsByline: hasDocumentContractAnalyticsByline && !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_analytics_byline_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
            // @ts-ignore -- Downstream packages are checked against the last generated content-unified-query declaration.
            includeContentHeader: shouldUseContentHeaderFragment,
            includeSmartCreateFeedback: shouldUseContentHeaderFragment && !versionOverride && !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_smart_create_banner_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
            includeContentHeaderAccess: shouldUseContentHeaderFragment && !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_access_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
            includeFabricEditorEligibility: shouldUseFabricEligibilityFragment,
            includeContentHeaderPublicLink: false,
            autohighlightsQueryVariables: autohighlightsQueryVariables
        }),
        ...!(0, $1xpoY.default).isKillSwitchOn('confluence_vp_mode_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false) ? {
            useContentModeFragment: true
        } : {}
    };
    const pageContentQueryResult = (0, $jMyy4.useQueryInterop)((0, $jgc4t.default), {
        fetchPolicy: 'cache-first',
        errorPolicy: 'all',
        context: {
            single: true
        },
        skip: skipContentQuery || isBlogpost,
        variables: pageContentQueryVariables,
        __callerPackage__: "view-page-common"
    });
    const blogContentQueryResult = (0, $jMyy4.useQueryInterop)((0, $f9opb.default), {
        fetchPolicy: 'cache-first',
        errorPolicy: 'all',
        context: {
            single: true
        },
        skip: skipContentQuery || !isBlogpost,
        variables: blogContentQueryVariables,
        __callerPackage__: "view-page-common"
    });
    const rawContentQueryResult = isBlogpost ? blogContentQueryResult : pageContentQueryResult;
    // The preloader's path check does not cover errors returned by this runtime query.
    // Filter before both PagePrerequisites and the renderer receive the shared result.
    const contentQueryResult = (0, $cozmU.useMemo)(()=>({
            ...rawContentQueryResult,
            error: (0, $4Uwwc.getViewPageContentError)(rawContentQueryResult.error, contentId, rawContentQueryResult.data?.content?.nodes?.[0]?.id)
        }), [
        rawContentQueryResult,
        contentId
    ]);
    const { route: route, errorAttribution: errorAttribution, name: name, isContentView: isContentView } = $50e9068f0df1c4d8$var$pageMap[routeName] ?? $50e9068f0df1c4d8$var$pageMap['page'];
    const contentQueryVariables = isBlogpost ? blogContentQueryVariables : pageContentQueryVariables;
    const { refetch: refetch } = contentQueryResult;
    (0, $2aFNh.useContentExtensionMetrics)(contentQueryResult?.data?.content?.nodes?.[0]?.body?.dynamic?.value, customPerfData);
    (0, $cozmU.useEffect)(()=>{
        // If navigating to a different page, always assume document is up to date.
        // Added for COMMENTS-5327, so when user jumps from an outdated page to another
        // up-to-date page, we won't disable the comment button due to outdated-ness.
        // Caveat: The destination page may not actually be up-to-date, e.g. if the
        // page content was loaded from cache that's saved from the user's previous
        // visit in the same browser tab, and a new version was published since then.
        // Invoking `setDocumentNeedsUpdate(false)` here means `documentNeedsUpdate`
        // may be `false` when page is actually outdated, but this scenario can already
        // occur before this change. COMMENTS-5816 tracks fixing this scenario altogether.
        if (!(0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated_v2', 'isEnabled', true)) // With confluence_fe_disable_comment_if_page_outdated_v2 ON,
        // `documentNeedsUpdate` is set to true whenever we set a new
        // `publishedDocumentVersion` IF it's different from `currentDocumentVersion`.
        // This useEffect can be cleaned up after v2 is fully rolled out.
        setDocumentNeedsUpdate(false);
    }, [
        contentId,
        setDocumentNeedsUpdate
    ]);
    // Use this instead of `contentQueryResult.data?.content?.nodes?.[0]?.version?.number`
    // because that field is fetched by other queries too, and thus may become mismatched
    // with the actual version of `body` in GQL cache.
    const contentVersion = contentQueryResult.data?.content?.nodes?.[0]?.body?.dynamic?.content?.version?.number;
    (0, $cozmU.useEffect)(()=>{
        if (contentVersion && (0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated_v2', 'isEnabled', true)) setCurrentDocumentVersion(contentVersion);
    }, [
        contentVersion,
        setCurrentDocumentVersion
    ]);
    const reload = (0, $cozmU.useCallback)(async ()=>{
        (0, $fGzMp.getExperienceTracker)().start({
            name: name,
            timeout: (0, $aJPUt.ExperienceTimeout).PAGE_LOAD,
            attributes: {
                contentType: (0, $8Ss4E.routeNameToContentTypeMap)[routeName],
                contentId: contentId,
                isSpaceOverviewNextRendered: true,
                edition: edition,
                quickReload: true //tell exp metrics error came from reload and not primary experience
            }
        });
        try {
            const refetchContentQueryResult = await refetch(contentQueryVariables);
            extractDataAndSetPublishedVersion({
                refetchContentQueryResult: refetchContentQueryResult
            });
        } catch (error) {
            if ((0, $1uFM6.isUnauthorizedError)(error) || (0, $95rLf.isExpectedApolloError)(error)) {
                (0, $7Sm4c.markErrorAsHandled)(error);
                (0, $fGzMp.getExperienceTracker)().abort({
                    name: name,
                    reason: 'Expected Apollo error'
                });
                return; //if it's an expected GQL failure don't throw or fail the experience
            }
            (0, $fGzMp.stopExperienceOnError)(name, error);
            throw error; //this successfully avoids the success below
        }
        (0, $fGzMp.getExperienceTracker)().succeed({
            name: name
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        refetch,
        contentId
    ]);
    const content = contentQueryResult.data?.content?.nodes?.[0];
    // Downstream packages are checked against the last generated content-unified-query declaration.
    const contentWithAudioFragment = content;
    const fabricEditorSupported = contentQueryResult.loading ? null : content?.metadata?.frontend?.fabricEditorSupported ?? null;
    const bodyRepresentation = contentQueryResult.loading ? null : content?.body?.dynamic?.representation ?? null;
    (0, $iuaOs.useContentReloadOnFabricSupportChange)({
        contentId: contentId,
        fabricEditorSupported: fabricEditorSupported,
        bodyRepresentation: bodyRepresentation,
        reload: reload
    });
    (0, $1SNEF.useQuickReloadSubscriber)({
        name: 'content',
        types: [
            (0, $c0urc.ReloadType).content,
            (0, $c0urc.ReloadType).comment
        ],
        reload: reload
    });
    (0, $1SNEF.useQuickReloadSubscriber)({
        name: 'commentsDataManager',
        types: [
            (0, $c0urc.ReloadType).comment
        ],
        reload: async ()=>{
            await (0, $4L9ve.getProcessedCommentsDataState)().refetch?.();
        },
        priority: (0, $c0urc.ReloadPriority).background
    });
    const resolvedStickyHeader = typeof stickyHeader === 'function' ? stickyHeader(contentQueryResult.data) : stickyHeader;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
        key: contentId,
        metric: (0, $gsWjA.VIEW_PAGE_CONTAINER_METRIC)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4KFTW.MacroExperienceStart), {
        contentId: contentId,
        mode: (0, $5kjCz.RENDERER),
        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Q3jD.PagePrerequisites), {
        route: route,
        contentQueryResult: contentQueryResult,
        versionOverride: versionOverride
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9nqKo.AudioContentProvider), {
        contentId: contentId,
        contentFragmentRef: contentWithAudioFragment?.audioContentFragment
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $isEtk.ContentStateContainer), {
        scope: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4zbo1.ContentContainer), {
        fetchTheme: true,
        contentThemeSpaceData: contentQueryResult.data ? contentQueryResult.data.space ?? null : undefined,
        contentId: contentId,
        spaceKey: spaceKey,
        key: "content-screen",
        errorAttribution: errorAttribution,
        isScreenContentView: isContentView,
        isContainerContentView: isContainerContentView,
        contentScreenStyles: contentScreenStyles,
        stickyHeader: resolvedStickyHeader,
        versionOverride: versionOverride,
        isEmbeddedPage: isEmbeddedPage
    }, ({ isThemed: isThemed })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("article", null, children && children({
            isThemed: isThemed,
            contentQueryData: contentQueryResult.data,
            contentQueryError: contentQueryResult.error,
            contentQueryRefetch: reload
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
            key: contentId,
            metric: (0, $gsWjA.VIEW_PAGE_CONTAINER_METRIC),
            customData: {
                isThemed: isThemed
            }
        })))))));
});
module.exports["ViewPageContainer"] = $50e9068f0df1c4d8$export$2fe638b9bbc723fb;

});

parcelRegister("4zbo1", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $jMyy4 = parcelRequire("jMyy4");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $f9opb = parcelRequire("f9opb");

var $jgc4t = parcelRequire("jgc4t");


var $b3j2Y = parcelRequire("b3j2Y");


var $gXrHX = parcelRequire("gXrHX");


var $lyE2O = parcelRequire("lyE2O");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $ep3mz = parcelRequire("ep3mz");


var $3jwuS = parcelRequire("3jwuS");


var $bEdUx = parcelRequire("bEdUx");


var $aWwYt = parcelRequire("aWwYt");


var $6KaG6 = parcelRequire("6KaG6");


var $5Myco = parcelRequire("5Myco");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $1xpoY = parcelRequire("1xpoY");


var $dPJCf = parcelRequire("dPJCf");


var $1vpkQ = parcelRequire("1vpkQ");


var $jln20 = parcelRequire("jln20");


var $3YWj2 = parcelRequire("3YWj2");


var $9Gxdl = parcelRequire("9Gxdl");


var $VPepg = parcelRequire("VPepg");

const $699adfe23402337d$var$EMPTY_CONTENT_SCREEN_STYLES = {};
const $699adfe23402337d$var$EMPTY_LOOK_AND_FEEL = {};
const $699adfe23402337d$var$useContentRecommendationParam = (0, $dPJCf.createSingleQueryParamHook)('contentRecommendation');
const $699adfe23402337d$var$contentWrapperStyles = null;
const $699adfe23402337d$var$ContentContainerThemeRenderer = (t0)=>{
    const $ = (0, $bDgLe.c)(52);
    const { children: children, spaceKey: spaceKey, errorAttribution: errorAttribution, contentScreenStyles: t1, stickyHeader: t2, isEmbeddedPage: isEmbeddedPage, isScreenContentView: isScreenContentView, isContainerContentView: isContainerContentView, isLivePage: isLivePage, isObjectSidebarShown: isObjectSidebarShown, pageMode: pageMode, behavior: behavior, shouldAddBannerPadding: shouldAddBannerPadding, themeData: themeData, loading: loading, error: error } = t0;
    const contentScreenStyles = t1 === undefined ? $699adfe23402337d$var$EMPTY_CONTENT_SCREEN_STYLES : t1;
    const stickyHeader = t2 === undefined ? null : t2;
    const theme = Boolean(themeData?.theme);
    const lookAndFeel = themeData?.lookAndFeel || $699adfe23402337d$var$EMPTY_LOOK_AND_FEEL;
    const { isAccessLinkRequest: isAccessLinkRequest } = (0, $cozmU.useContext)((0, $gXrHX.ExternalShareContext));
    let t3;
    if ($[0] !== children || $[1] !== loading || $[2] !== theme) {
        t3 = typeof children === "function" ? children({
            isThemed: theme,
            isLoading: loading
        }) : children;
        $[0] = children;
        $[1] = loading;
        $[2] = theme;
        $[3] = t3;
    } else t3 = $[3];
    const childrenToRender = t3;
    let t4;
    if ($[4] !== childrenToRender || $[5] !== error || $[6] !== isAccessLinkRequest) {
        t4 = isAccessLinkRequest && (0, $lyE2O.isSpaceDenialError)(error) && childrenToRender != null;
        $[4] = childrenToRender;
        $[5] = error;
        $[6] = isAccessLinkRequest;
        $[7] = t4;
    } else t4 = $[7];
    const shouldIgnoreSpaceDenialOnAccessLink = t4;
    if (error && !shouldIgnoreSpaceDenialOnAccessLink) {
        let t5;
        if ($[8] !== error) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: error
            });
            $[8] = error;
            $[9] = t5;
        } else t5 = $[9];
        let t6;
        if ($[10] !== childrenToRender || $[11] !== errorAttribution || $[12] !== t5) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
                attribution: errorAttribution
            }, childrenToRender, t5);
            $[10] = childrenToRender;
            $[11] = errorAttribution;
            $[12] = t5;
            $[13] = t6;
        } else t6 = $[13];
        return t6;
    }
    const t5 = !theme && stickyHeader ? stickyHeader : null;
    const t6 = shouldAddBannerPadding ? 12 : 0;
    let t7;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (0, $hekY6.default)([
            "_2O5VijiZR3 _3YEZNO7dHp _1bHrqEAEMG _3iDTPbvLZJ _39xV02N91d"
        ]);
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== childrenToRender || $[16] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t7
        }, childrenToRender);
        $[15] = childrenToRender;
        $[16] = t7;
        $[17] = t8;
    } else t8 = $[17];
    let t9;
    if ($[18] !== error || $[19] !== shouldIgnoreSpaceDenialOnAccessLink) {
        t9 = error && shouldIgnoreSpaceDenialOnAccessLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        }) : null;
        $[18] = error;
        $[19] = shouldIgnoreSpaceDenialOnAccessLink;
        $[20] = t9;
    } else t9 = $[20];
    let t10;
    if ($[21] !== behavior || $[22] !== isObjectSidebarShown || $[23] !== pageMode) {
        t10 = !(0, $9wGTI.fg)("ads-panel-system-confluence-object-sidebar") && isObjectSidebarShown && pageMode === (0, $cD1qu.PageMode).VIEW && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, behavior === "push" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5Myco.ObjectSidebarPushPlaceholder), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6KaG6.ObjectSidebarPanel), {
            ignoreGap: true
        }));
        $[21] = behavior;
        $[22] = isObjectSidebarShown;
        $[23] = pageMode;
        $[24] = t10;
    } else t10 = $[24];
    let t11;
    if ($[25] !== t10 || $[26] !== t8 || $[27] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, t8, t9, t10);
        $[25] = t10;
        $[26] = t8;
        $[27] = t9;
        $[28] = t11;
    } else t11 = $[28];
    let t12;
    if ($[29] !== isContainerContentView || $[30] !== isLivePage || $[31] !== loading || $[32] !== lookAndFeel || $[33] !== t11 || $[34] !== t6 || $[35] !== theme) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Gxdl.ContentContainerComponent), {
            isThemed: theme,
            lookAndFeel: lookAndFeel,
            isContentView: isContainerContentView,
            isLoading: loading,
            isLivePage: isLivePage,
            additionalPaddingTop: t6
        }, t11);
        $[29] = isContainerContentView;
        $[30] = isLivePage;
        $[31] = loading;
        $[32] = lookAndFeel;
        $[33] = t11;
        $[34] = t6;
        $[35] = theme;
        $[36] = t12;
    } else t12 = $[36];
    let t13;
    if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bEdUx.HighlightActionsProviderForNav4), null);
        $[37] = t13;
    } else t13 = $[37];
    let t14;
    if ($[38] !== contentScreenStyles || $[39] !== isEmbeddedPage || $[40] !== isLivePage || $[41] !== isScreenContentView || $[42] !== loading || $[43] !== lookAndFeel || $[44] !== spaceKey || $[45] !== t12 || $[46] !== t5 || $[47] !== theme) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3YWj2.ContentScreenComponent), {
            spaceKey: spaceKey,
            isThemed: theme,
            isLoading: loading,
            lookAndFeel: lookAndFeel,
            isContentView: isScreenContentView,
            contentScreenStyles: contentScreenStyles,
            isLivePage: isLivePage,
            isEmbeddedPage: isEmbeddedPage
        }, t5, t12, t13);
        $[38] = contentScreenStyles;
        $[39] = isEmbeddedPage;
        $[40] = isLivePage;
        $[41] = isScreenContentView;
        $[42] = loading;
        $[43] = lookAndFeel;
        $[44] = spaceKey;
        $[45] = t12;
        $[46] = t5;
        $[47] = theme;
        $[48] = t14;
    } else t14 = $[48];
    let t15;
    if ($[49] !== errorAttribution || $[50] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: errorAttribution
        }, t14);
        $[49] = errorAttribution;
        $[50] = t14;
        $[51] = t15;
    } else t15 = $[51];
    return t15;
};
const $699adfe23402337d$var$ContentContainerWithThemeFragment = (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    let contentThemeSpaceData;
    let props;
    if ($[0] !== t0) {
        ({ contentThemeSpaceData: contentThemeSpaceData, ...props } = t0);
        $[0] = t0;
        $[1] = contentThemeSpaceData;
        $[2] = props;
    } else {
        contentThemeSpaceData = $[1];
        props = $[2];
    }
    const themeData = (0, $6SsN4.useFragment)((0, $VPepg.ContentContainerThemeFragment), contentThemeSpaceData);
    let t1;
    if ($[3] !== props || $[4] !== themeData) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($699adfe23402337d$var$ContentContainerThemeRenderer, {
            ...props,
            themeData: themeData,
            loading: false
        });
        $[3] = props;
        $[4] = themeData;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
};
const $699adfe23402337d$var$ContentContainerWithThemeQuery = (t0)=>{
    const $ = (0, $bDgLe.c)(29);
    let contentId;
    let fetchTheme;
    let isBlogpost;
    let props;
    let spaceKey;
    let versionOverride;
    if ($[0] !== t0) {
        ({ contentId: contentId, spaceKey: spaceKey, versionOverride: versionOverride, isBlogpost: isBlogpost, fetchTheme: fetchTheme, ...props } = t0);
        $[0] = t0;
        $[1] = contentId;
        $[2] = fetchTheme;
        $[3] = isBlogpost;
        $[4] = props;
        $[5] = spaceKey;
        $[6] = versionOverride;
    } else {
        contentId = $[1];
        fetchTheme = $[2];
        isBlogpost = $[3];
        props = $[4];
        spaceKey = $[5];
        versionOverride = $[6];
    }
    const skipThemeQuery = !fetchTheme || !contentId;
    const isSSR = Boolean(window.__SSR_RENDERED__);
    let t1;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            single: true
        };
        $[7] = t1;
    } else t1 = $[7];
    const t2 = skipThemeQuery || isBlogpost;
    let t3;
    if ($[8] !== contentId || $[9] !== spaceKey || $[10] !== versionOverride) {
        t3 = {
            contentId: contentId,
            spaceKey: spaceKey,
            versionOverride: versionOverride,
            isSSR: isSSR,
            useNewContentTopper: true
        };
        $[8] = contentId;
        $[9] = spaceKey;
        $[10] = versionOverride;
        $[11] = t3;
    } else t3 = $[11];
    let t4;
    if ($[12] !== t2 || $[13] !== t3) {
        t4 = {
            context: t1,
            skip: t2,
            variables: t3
        };
        $[12] = t2;
        $[13] = t3;
        $[14] = t4;
    } else t4 = $[14];
    const pageThemeQueryResult = (0, $jMyy4.useQueryInterop)((0, $jgc4t.default), {
        ...t4,
        __callerPackage__: "content-container"
    });
    let t5;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
            single: true
        };
        $[15] = t5;
    } else t5 = $[15];
    const t6 = skipThemeQuery || !isBlogpost;
    let t7;
    if ($[16] !== contentId || $[17] !== spaceKey || $[18] !== versionOverride) {
        t7 = {
            contentId: contentId,
            spaceKey: spaceKey,
            isSSR: isSSR,
            versionOverride: versionOverride,
            useNewContentTopper: true
        };
        $[16] = contentId;
        $[17] = spaceKey;
        $[18] = versionOverride;
        $[19] = t7;
    } else t7 = $[19];
    let t8;
    if ($[20] !== t6 || $[21] !== t7) {
        t8 = {
            context: t5,
            skip: t6,
            variables: t7
        };
        $[20] = t6;
        $[21] = t7;
        $[22] = t8;
    } else t8 = $[22];
    const blogThemeQueryResult = (0, $jMyy4.useQueryInterop)((0, $f9opb.default), {
        ...t8,
        __callerPackage__: "content-container"
    });
    const queryResult = isBlogpost ? blogThemeQueryResult : pageThemeQueryResult;
    const t9 = queryResult.data?.space;
    let t10;
    if ($[23] !== props || $[24] !== queryResult.error || $[25] !== queryResult.loading || $[26] !== spaceKey || $[27] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($699adfe23402337d$var$ContentContainerThemeRenderer, {
            ...props,
            themeData: t9,
            loading: queryResult.loading,
            error: queryResult.error,
            spaceKey: spaceKey
        });
        $[23] = props;
        $[24] = queryResult.error;
        $[25] = queryResult.loading;
        $[26] = spaceKey;
        $[27] = t9;
        $[28] = t10;
    } else t10 = $[28];
    return t10;
};
const $699adfe23402337d$export$9d2b4227a95687cc = ({ contentId: contentId, fetchTheme: fetchTheme = false, children: children, isScreenContentView: isScreenContentView = false, isContainerContentView: isContainerContentView = false, spaceKey: spaceKey, errorAttribution: errorAttribution = (0, $3IBnw.Attribution).BACKBONE, contentScreenStyles: contentScreenStyles = $699adfe23402337d$var$EMPTY_CONTENT_SCREEN_STYLES, stickyHeader: stickyHeader = null, versionOverride: versionOverride = null, isEmbeddedPage: isEmbeddedPage, contentThemeSpaceData: contentThemeSpaceData })=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const behavior = (0, $aWwYt.useBehavior)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const contentRecommendationParam = $699adfe23402337d$var$useContentRecommendationParam();
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const isSidebarApprovalsPaneOpen = rightSidebarContext.getCurrent()?.panelId === (0, $1vpkQ.APPROVALS_PANE_ID) && pageMode === (0, $cD1qu.PageMode).VIEW;
    const approvalsPaneContextKey = (0, $1vpkQ.getApprovalsPaneContextKey)({
        contentId: contentId,
        contentStatus: (0, $1vpkQ.APPROVALS_PANE_CURRENT_CONTENT_STATUS)
    });
    const rightSidebarContextRef = (0, $cozmU.useRef)(rightSidebarContext);
    rightSidebarContextRef.current = rightSidebarContext;
    (0, $cozmU.useEffect)(()=>{
        hideObjectSidebar();
    }, [
        contentId,
        hideObjectSidebar
    ]);
    (0, $cozmU.useEffect)(()=>{
        (0, $1vpkQ.syncApprovalsPaneContextOwnership)({
            isApprovalsExperimentEnabled: (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true),
            isSidebarApprovalsPaneOpen: isSidebarApprovalsPaneOpen,
            contextKey: approvalsPaneContextKey,
            closeApprovalsPane: ()=>rightSidebarContextRef.current.close((0, $1vpkQ.APPROVALS_PANE_ID))
        });
    }, [
        approvalsPaneContextKey,
        isSidebarApprovalsPaneOpen
    ]);
    const isBlogpost = contentType === 'blogpost';
    const hasParentThemeData = contentThemeSpaceData !== undefined;
    const shouldAddBannerPadding = !isLivePage && contentRecommendationParam === 'on' && (0, $9wGTI.fg)('cc-engagement-nth-user-teammate-rollout-gate');
    const sharedProps = {
        children: children,
        spaceKey: spaceKey,
        errorAttribution: errorAttribution,
        contentScreenStyles: contentScreenStyles,
        stickyHeader: stickyHeader,
        isEmbeddedPage: isEmbeddedPage,
        isScreenContentView: isScreenContentView,
        isContainerContentView: isContainerContentView,
        isLivePage: isLivePage,
        isObjectSidebarShown: isObjectSidebarShown,
        pageMode: pageMode,
        behavior: behavior,
        shouldAddBannerPadding: shouldAddBannerPadding
    };
    if (hasParentThemeData && !(0, $1xpoY.default).isKillSwitchOn('confluence_frontend_view_page_relay_fragment_dedup') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($699adfe23402337d$var$ContentContainerWithThemeFragment, {
        ...sharedProps,
        contentThemeSpaceData: contentThemeSpaceData
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($699adfe23402337d$var$ContentContainerWithThemeQuery, {
        ...sharedProps,
        contentId: contentId,
        spaceKey: spaceKey,
        versionOverride: versionOverride,
        isBlogpost: isBlogpost,
        fetchTheme: fetchTheme
    });
};
module.exports["ContentContainer"] = $699adfe23402337d$export$9d2b4227a95687cc;

});

parcelRegister("3YWj2", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kNIYN = parcelRequire("kNIYN");


var $hrAmX = parcelRequire("hrAmX");


var $3Klda = parcelRequire("3Klda");

const $7517944cc70514f3$export$af5427d1c079635b = {
    position: 'relative',
    background: "var(--ds-surface, #FFFFFF)",
    paddingTop: '0',
    paddingRight: "var(--ds-space-500, 40px)",
    paddingBottom: "var(--ds-space-250, 20px)",
    paddingLeft: "var(--ds-space-500, 40px)",
    minHeight: 'calc(100vh - 56px)',
    boxSizing: 'border-box',
    // added in for cover image
    '--full-cover-image-margin': '-40px',
    // should be the negative value of the padding of the container
    '--full-cover-image-width': 'calc(100% + 80px)' // should do calculations based on the padding of the container
};
const $7517944cc70514f3$export$ae92da2802c530ea = {
    position: 'fixed',
    width: '100%',
    height: '100%',
    top: '0',
    display: 'none',
    bottom: '0',
    left: '0',
    right: '0',
    zIndex: '10',
    background: "var(--ds-skeleton, #0515240F)"
};
const $7517944cc70514f3$var$LIVE_PAGES_SCREEN_STYLES = {
    paddingTop: '0px',
    paddingRight: '0px',
    paddingBottom: '0px',
    paddingLeft: '0px',
    minHeight: 'unset',
    // added in for cover image
    '--full-cover-image-margin': '0px',
    // should be the negative value of the padding of the container
    '--full-cover-image-width': '100%' // should do calculations based on the padding of the container
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7517944cc70514f3$var$OverflowHiddenDiv = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $7517944cc70514f3$var$PositionRelativeDiv = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1mT5xdRAKS",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $7517944cc70514f3$var$DEFAULT_LOOK_AND_FEEL = {
    content: {
        screen: $7517944cc70514f3$export$af5427d1c079635b
    }
};
const $7517944cc70514f3$var$EMPTY_CONTENT_SCREEN_STYLES = {};
function $7517944cc70514f3$var$convertGutters(customScreenStyles) {
    if (customScreenStyles.gutterLeft === 'none') customScreenStyles.paddingLeft = '0';
    if (customScreenStyles.gutterRight === 'none') customScreenStyles.paddingRight = '0';
    if (customScreenStyles.gutterTop === '0px') customScreenStyles.paddingTop = '0';
    if (customScreenStyles.gutterBottom === '0px') customScreenStyles.paddingBottom = '0';
    return customScreenStyles;
}
function $7517944cc70514f3$var$getStylesFromLookAndFeel(lookAndFeel) {
    if (!lookAndFeel || !lookAndFeel.content) return {};
    const screenLookAndFeel = $7517944cc70514f3$var$convertGutters({
        ...lookAndFeel.content.screen
    });
    delete screenLookAndFeel.layer;
    return screenLookAndFeel;
}
function $7517944cc70514f3$var$adjustMinHeight(styles, bannerHeight, isEmbeddedPage) {
    const updatedStyles = {
        ...styles
    };
    // When in embedded confluence, override minHeight to 'auto' so the content area sizes to its actual content
    if (isEmbeddedPage) updatedStyles.minHeight = 'auto';
    else if (updatedStyles.minHeight === '100vh' && bannerHeight > 0) // Update the minHeight style only if a banner is being shown and the minHeight is "100vh" (aka full height)
    updatedStyles.minHeight = `calc(${updatedStyles.minHeight} - ${bannerHeight}px)`;
    return updatedStyles;
}
const $7517944cc70514f3$export$b578f5d8b8749ec2 = ({ spaceKey: spaceKey, children: children, lookAndFeel: lookAndFeel = $7517944cc70514f3$var$DEFAULT_LOOK_AND_FEEL, contentScreenStyles: // This prop contains react-css values to customize the default content screen styles according to the consumer's need.
contentScreenStyles = $7517944cc70514f3$var$EMPTY_CONTENT_SCREEN_STYLES, isThemed: isThemed = false, isContentView: isContentView = false, isLoading: isLoading = false, isLivePage: isLivePage = false, isEmbeddedPage: isEmbeddedPage = false })=>{
    const previousStyleState = (0, $cozmU.useRef)(null);
    const shouldApplyTheme = isThemed || isContentView;
    let styles;
    // 99.9% of time we should have lookAndFeel preloaded on SSR
    if (isLoading) {
        const previous = previousStyleState.current;
        // In transition since style in the same space should be the same
        // We can optimistically use the same style as the previous one
        if (spaceKey && spaceKey === previous?.spaceKey) styles = previous?.getStyles(isLivePage) || $7517944cc70514f3$export$ae92da2802c530ea;
        else styles = $7517944cc70514f3$export$ae92da2802c530ea;
    } else {
        const getStyles = shouldApplyTheme ? (live)=>({
                ...$7517944cc70514f3$export$af5427d1c079635b,
                ...live ? $7517944cc70514f3$var$LIVE_PAGES_SCREEN_STYLES : {},
                ...contentScreenStyles,
                ...$7517944cc70514f3$var$getStylesFromLookAndFeel(lookAndFeel)
            }) : ()=>({});
        previousStyleState.current = {
            getStyles: getStyles,
            spaceKey: spaceKey
        };
        styles = getStyles(isLivePage);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: [
            (0, $hrAmX.BannerStateContainer)
        ]
    }, (bannerState)=>{
        const bannerHeight = bannerState.getTotalHeight();
        const updatedStyles = $7517944cc70514f3$var$adjustMinHeight(styles, bannerHeight, isEmbeddedPage);
        // styles came from a GraphQL result which will contain __typename
        delete updatedStyles.__typename;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "content-screen-component",
            className: "content-screen-component",
            style: updatedStyles
        }, shouldApplyTheme ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3Klda.ContentScreenBackgroundLayer), {
            lookAndFeel: lookAndFeel
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7517944cc70514f3$var$PositionRelativeDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7517944cc70514f3$var$OverflowHiddenDiv, null), children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children));
    });
};
module.exports["ContentScreenComponent"] = $7517944cc70514f3$export$b578f5d8b8749ec2;

});

parcelRegister("3Klda", function(module, exports) {

var $6b4nE = parcelRequire("6b4nE");


var $cozmU = parcelRequire("cozmU");

const $2ba61f17a8768eba$var$screenLayerStyles = {
    display: 'block',
    position: 'absolute',
    width: '100%',
    top: 0,
    left: 0,
    height: 250
};
class $2ba61f17a8768eba$export$e0e5b47f08900b58 extends (0, $cozmU.Component) {
    render() {
        const { lookAndFeel: lookAndFeel } = this.props;
        if (!lookAndFeel || !lookAndFeel.content) return null;
        const customScreenLayerStyles = lookAndFeel?.content?.screen?.layer || {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "content-screen-background-layer",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                ...$2ba61f17a8768eba$var$screenLayerStyles,
                ...customScreenLayerStyles
            }
        });
    }
}
$2ba61f17a8768eba$export$e0e5b47f08900b58.propTypes = {
    lookAndFeel: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object
};
module.exports["ContentScreenBackgroundLayer"] = $2ba61f17a8768eba$export$e0e5b47f08900b58;

});

parcelRegister("9Gxdl", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6b4nE = parcelRequire("6b4nE");


var $lTECB = parcelRequire("lTECB");


var $lJlG6 = parcelRequire("lJlG6");

// Both default styles are needed to properly apply `background-color` in resulting DOM when merged with look-and-feel
const $70d1ccf7a353c4c2$var$DEFAULT_CONTAINER_STYLES = {
    background: "var(--ds-surface, #FFFFFF)",
    backgroundColor: "var(--ds-surface, #FFFFFF)"
};
const $70d1ccf7a353c4c2$var$LOADING_SCREEN_STYLES = {
    position: 'fixed',
    width: '100%',
    height: '100%',
    top: '0',
    display: 'none',
    bottom: '0',
    left: '0',
    right: '0',
    zIndex: '10',
    background: "var(--ds-skeleton, #0515240F)"
};
const $70d1ccf7a353c4c2$var$_convertVerticalGutterSize = (gutterValue)=>{
    switch(gutterValue){
        case 'small':
        case 'medium':
        case 'large':
        case 'default':
            return null;
        default:
            return gutterValue;
    }
};
const $70d1ccf7a353c4c2$var$_convertHorizontalGutterSize = (gutterValue)=>{
    switch(gutterValue){
        case 'small':
            return 5;
        case 'medium':
            return 10;
        case 'large':
            return 15;
        case 'default':
            return null;
        case 'none':
        default:
            return 0;
    }
};
class $70d1ccf7a353c4c2$export$b5a05341299897cc extends (0, $cozmU.Component) {
    static _getContainerStyles(lookAndFeel, isThemed, isLivePage, additionalPaddingTop) {
        if (!lookAndFeel.content) return $70d1ccf7a353c4c2$var$DEFAULT_CONTAINER_STYLES;
        const { screen: screen, container: container } = lookAndFeel.content;
        const containerStyles = {
            ...$70d1ccf7a353c4c2$var$DEFAULT_CONTAINER_STYLES,
            ...container
        };
        const { padding: padding } = containerStyles;
        let paddingTop = additionalPaddingTop || 0;
        // if page header is fixed, content will need to be pushed down so that the title of the page isn't covered (unless rendered via embedded-confluence)
        // themed spaces do not have fixed headers and do not need the styling
        if (!isThemed && !isLivePage && !(0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)() && !(0, $lJlG6.isMobileApp_DO_NOT_USE)()) // add 46px padding since the object header height is 56px and with-sticky-header div above it has 10px height already
        paddingTop += 46;
        containerStyles.padding = `${paddingTop}px 0px 0px 0px`;
        if (isThemed && padding === '0') // if the theme doesn't have a padding, we should add a padding because otherwise comments overflow the container
        // see also: https://product-fabric.atlassian.net/wiki/spaces/~speachey/pages/3093430887/DEVHELP-6933
        containerStyles.padding = '20px';
        const { gutterTop: gutterTop, gutterBottom: gutterBottom } = screen;
        if (gutterTop) containerStyles.marginTop = $70d1ccf7a353c4c2$var$_convertVerticalGutterSize(screen.gutterTop);
        if (gutterBottom) containerStyles.marginBottom = $70d1ccf7a353c4c2$var$_convertVerticalGutterSize(screen.gutterBottom);
        const gutterRight = $70d1ccf7a353c4c2$var$_convertHorizontalGutterSize(screen.gutterRight);
        const gutterLeft = $70d1ccf7a353c4c2$var$_convertHorizontalGutterSize(screen.gutterLeft);
        if (gutterRight !== null) containerStyles.marginRight = `${gutterRight}%`;
        if (gutterLeft !== null) containerStyles.marginLeft = `${gutterLeft}%`;
        containerStyles.width = `${100 - gutterRight - gutterLeft}%`;
        containerStyles.boxSizing = 'border-box';
        containerStyles.display = 'flex';
        containerStyles.flexDirection = 'row';
        // container is from graphql result which will contain __typename
        delete containerStyles.__typename;
        return containerStyles;
    }
    static _getInlineCommentStyles(lookAndFeel) {
        if (!lookAndFeel.content) return null;
        const { screen: screen = {} } = lookAndFeel.content;
        const gutterRight = $70d1ccf7a353c4c2$var$_convertHorizontalGutterSize(screen.gutterRight);
        if (gutterRight === 0) /**
       * When we have no gutterRight, we need to override the default ic-sidebar marging-right of -20px and make it 0
       *  so that it does not pull too far right.
       */ return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("style", null, '.ic-sidebar.ic-is-spa-view-page { margin-right: 0 !important; }'));
        return null;
    }
    getLoadingStyles() {
        const { isLoading: isLoading } = this.props;
        return isLoading ? $70d1ccf7a353c4c2$var$LOADING_SCREEN_STYLES : {};
    }
    render() {
        const { lookAndFeel: lookAndFeel, isThemed: isThemed, isContentView: isContentView, isLivePage: isLivePage, additionalPaddingTop: additionalPaddingTop } = this.props;
        const shouldApplyTheme = isThemed || isContentView;
        const containerStyles = shouldApplyTheme ? $70d1ccf7a353c4c2$export$b5a05341299897cc._getContainerStyles(lookAndFeel, isThemed, isLivePage, additionalPaddingTop) : this.getLoadingStyles();
        const inLineCommentStyles = shouldApplyTheme ? $70d1ccf7a353c4c2$export$b5a05341299897cc._getInlineCommentStyles(lookAndFeel) : null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "content-container-component",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: this.props.className,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: containerStyles
        }, inLineCommentStyles, this.props.children);
    }
}
$70d1ccf7a353c4c2$export$b5a05341299897cc.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).any,
    lookAndFeel: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    isThemed: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    /**
   * In view page we apply default style regardless whether theme was enabled or not
   */ isContentView: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    isLivePage: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    additionalPaddingTop: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).number
};
$70d1ccf7a353c4c2$export$b5a05341299897cc.defaultProps = {
    isContentView: false,
    lookAndFeel: {
        content: {
            screen: $70d1ccf7a353c4c2$var$DEFAULT_CONTAINER_STYLES
        }
    },
    isLivePage: false
};
module.exports["ContentContainerComponent"] = $70d1ccf7a353c4c2$export$b5a05341299897cc;

});

parcelRegister("VPepg", function(module, exports) {

var $6rIhr = parcelRequire("6rIhr");

const $847592e36c5d5e9b$export$bc63ffaabbce08aa = (0, $6rIhr.default);
module.exports["ContentContainerThemeFragment"] = $847592e36c5d5e9b$export$bc63ffaabbce08aa;

});

parcelRegister("6rIhr", function(module, exports) {
/**
 * @generated SignedSource<<9ee77f54bb9332f4676335e626d51f90>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $da9651dac0078049$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "background"
    }, v1 = {
        "kind": "ScalarField",
        "name": "backgroundColor"
    }, v2 = {
        "kind": "ScalarField",
        "name": "backgroundImage"
    }, v3 = {
        "kind": "ScalarField",
        "name": "backgroundPosition"
    }, v4 = {
        "kind": "ScalarField",
        "name": "backgroundSize"
    }, v5 = {
        "kind": "ScalarField",
        "name": "backgroundRepeat"
    }, v6 = {
        "kind": "ScalarField",
        "name": "backgroundOrigin"
    }, v7 = {
        "kind": "ScalarField",
        "name": "backgroundClip"
    }, v8 = {
        "kind": "ScalarField",
        "name": "backgroundAttachment"
    }, v9 = {
        "kind": "ScalarField",
        "name": "backgroundBlendMode"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "ContentContainerTheme_space",
        "selections": [
            {
                "concreteType": "Theme",
                "kind": "LinkedField",
                "name": "theme",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "themeKey"
                    }
                ]
            },
            {
                "concreteType": "LookAndFeel",
                "kind": "LinkedField",
                "name": "lookAndFeel",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "ContentLookAndFeel",
                        "kind": "LinkedField",
                        "name": "content",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "ScreenLookAndFeel",
                                "kind": "LinkedField",
                                "name": "screen",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    v1 /*: any*/ ,
                                    v2 /*: any*/ ,
                                    v3 /*: any*/ ,
                                    v4 /*: any*/ ,
                                    v5 /*: any*/ ,
                                    v6 /*: any*/ ,
                                    v7 /*: any*/ ,
                                    v8 /*: any*/ ,
                                    v9 /*: any*/ ,
                                    {
                                        "concreteType": "LayerScreenLookAndFeel",
                                        "kind": "LinkedField",
                                        "name": "layer",
                                        "plural": false,
                                        "selections": [
                                            v0 /*: any*/ ,
                                            v1 /*: any*/ ,
                                            v2 /*: any*/ ,
                                            v3 /*: any*/ ,
                                            v4 /*: any*/ ,
                                            v5 /*: any*/ ,
                                            v6 /*: any*/ ,
                                            v7 /*: any*/ ,
                                            v8 /*: any*/ ,
                                            v9 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "width"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "height"
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "gutterTop"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "gutterRight"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "gutterBottom"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "gutterLeft"
                                    }
                                ]
                            },
                            {
                                "concreteType": "ContainerLookAndFeel",
                                "kind": "LinkedField",
                                "name": "container",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    v1 /*: any*/ ,
                                    v2 /*: any*/ ,
                                    v3 /*: any*/ ,
                                    v4 /*: any*/ ,
                                    v5 /*: any*/ ,
                                    v6 /*: any*/ ,
                                    v7 /*: any*/ ,
                                    v8 /*: any*/ ,
                                    v9 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "padding"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "borderRadius"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Space"
    };
}();
$da9651dac0078049$var$node.hash = "bfa43eb9ba39936a810f3d392573282f";
var $da9651dac0078049$export$2e2bcd8739ae039 = $da9651dac0078049$var$node;
module.exports["default"] = $da9651dac0078049$export$2e2bcd8739ae039;

});

parcelRegister("9Q3jD", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4uSkp = parcelRequire("4uSkp");


var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");


var $7Sm4c = parcelRequire("7Sm4c");


var $aMcHK = parcelRequire("aMcHK");


var $iPRuY = parcelRequire("iPRuY");

const $fb83eb4a10554029$export$69ad3f5eb9aa63a1 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { children: children, contentQueryResult: contentQueryResult, route: route, versionOverride: versionOverride, status: status } = t0;
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    if ($[0] !== experienceTracker) {
        t1 = (error)=>{
            const isTimeoutError = error?.toString().includes("SocketTimeoutException");
            if (isTimeoutError) experienceTracker.fail({
                name: (0, $irVI7.VIEW_PAGE_EXPERIENCE),
                error: error
            });
            else experienceTracker.abort({
                name: (0, $irVI7.VIEW_PAGE_EXPERIENCE),
                reason: error.message
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
        };
        $[0] = experienceTracker;
        $[1] = t1;
    } else t1 = $[1];
    const handleTimeoutError = t1;
    let t2;
    if ($[2] !== experienceTracker) {
        t2 = (error_0)=>{
            const isUserError = (0, $aMcHK.getStatusCodeError)(error_0)?.startsWith("4");
            if (isUserError) experienceTracker.abort({
                name: (0, $irVI7.VIEW_PAGE_EXPERIENCE),
                reason: error_0.message
            });
            else experienceTracker.fail({
                name: (0, $irVI7.VIEW_PAGE_EXPERIENCE),
                error: error_0
            });
            (0, $7Sm4c.markErrorAsHandled)(error_0);
            throw error_0;
        };
        $[2] = experienceTracker;
        $[3] = t2;
    } else t2 = $[3];
    const handleUnexpectedError = t2;
    let t3;
    if ($[4] !== children || $[5] !== contentQueryResult || $[6] !== handleTimeoutError || $[7] !== handleUnexpectedError || $[8] !== route || $[9] !== status || $[10] !== versionOverride) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4uSkp.ViewPageGateway), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iPRuY.ContentPrerequisites), {
            route: route,
            contentQueryResult: contentQueryResult,
            versionOverride: versionOverride,
            handleUnexpectedError: handleUnexpectedError,
            handleTimeoutError: handleTimeoutError,
            status: status
        }, children));
        $[4] = children;
        $[5] = contentQueryResult;
        $[6] = handleTimeoutError;
        $[7] = handleUnexpectedError;
        $[8] = route;
        $[9] = status;
        $[10] = versionOverride;
        $[11] = t3;
    } else t3 = $[11];
    return t3;
} : ({ children: children, contentQueryResult: contentQueryResult, route: route, versionOverride: versionOverride, status: status })=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const handleTimeoutError = (error)=>{
        const isTimeoutError = error?.toString().includes('SocketTimeoutException');
        if (isTimeoutError) experienceTracker.fail({
            name: (0, $irVI7.VIEW_PAGE_EXPERIENCE),
            error: error
        });
        else experienceTracker.abort({
            name: (0, $irVI7.VIEW_PAGE_EXPERIENCE),
            reason: error.message
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
    };
    const handleUnexpectedError = (error_0)=>{
        const isUserError = (0, $aMcHK.getStatusCodeError)(error_0)?.startsWith('4');
        if (isUserError) experienceTracker.abort({
            name: (0, $irVI7.VIEW_PAGE_EXPERIENCE),
            reason: error_0.message
        });
        else experienceTracker.fail({
            name: (0, $irVI7.VIEW_PAGE_EXPERIENCE),
            error: error_0
        });
        (0, $7Sm4c.markErrorAsHandled)(error_0);
        throw error_0; // Throw to propagate to error boundary - otherwise just shows a blank screen
    };
    // When unauthorized and viewing a restricted page, user is prompted
    // with SuperAdmin gateway
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4uSkp.ViewPageGateway), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iPRuY.ContentPrerequisites), {
        route: route,
        contentQueryResult: contentQueryResult,
        versionOverride: versionOverride,
        handleUnexpectedError: handleUnexpectedError,
        handleTimeoutError: handleTimeoutError,
        status: status
    }, children));
};
module.exports["PagePrerequisites"] = $fb83eb4a10554029$export$69ad3f5eb9aa63a1;

});

parcelRegister("4uSkp", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $6b4nE = parcelRequire("6b4nE");


var $cozmU = parcelRequire("cozmU");


var $bavCP = parcelRequire("bavCP");


var $lLRfG = parcelRequire("lLRfG");


var $1uFM6 = parcelRequire("1uFM6");


var $9xNes = parcelRequire("9xNes");


var $f3euL = parcelRequire("f3euL");


var $ep3mz = parcelRequire("ep3mz");


var $2k9aV = parcelRequire("2k9aV");


var $c4ECQ = parcelRequire("c4ECQ");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $lfFzM = parcelRequire("lfFzM");


var $iPPFu = parcelRequire("iPPFu");

function $34641b344ae1099e$export$27cc57004471e91(hasDirectRestrictions, hasPageInheritedRestrictions, hasSpaceRestrictions) {
    // multiple restrictions = at least two.
    const hasMultipleRestrictions = hasDirectRestrictions ? hasPageInheritedRestrictions || hasSpaceRestrictions : hasPageInheritedRestrictions && hasSpaceRestrictions;
    if (hasMultipleRestrictions) return (0, $c4ECQ.RestrictionFrom).MULTIPLE;
    if (hasDirectRestrictions) return (0, $c4ECQ.RestrictionFrom).DIRECT;
    if (hasPageInheritedRestrictions) return (0, $c4ECQ.RestrictionFrom).PAGE_INHERITED;
    if (hasSpaceRestrictions) return (0, $c4ECQ.RestrictionFrom).SPACE;
    return (0, $c4ECQ.RestrictionFrom).NONE;
}
const $34641b344ae1099e$var$CUSTOM_ATTRIBUTES = {
    inaccessiblePageType: 'RESTRICTED_CONFIRMATION_PAGE'
};
class $34641b344ae1099e$export$92eba4cf4af6c314 extends (0, $cozmU.PureComponent) {
    componentDidMount() {
        this.checkConsentToViewPage();
    }
    componentDidUpdate() {
        this.checkConsentToViewPage();
    }
    checkConsentToViewPage() {
        const localStorageValue = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).RESTRICTED_PAGE_CONFIRMED);
        if (!localStorageValue) {
            this.setState({
                restrictedPageViewConfirmed: false
            });
            return;
        }
        // Set the state if it matches so we can skip rendering the confirmation.
        if (String(localStorageValue) === this.props.contentId) this.setState({
            restrictedPageViewConfirmed: true
        });
        else {
            // This means the user is on a different page currently. Can safely
            // delete the entry now so we can render the confirmation again if the
            // former page is accessed again.
            (0, $17wUi.confluenceLocalStorageInstance).removeItem((0, $1UApO.keys).RESTRICTED_PAGE_CONFIRMED);
            this.setState({
                restrictedPageViewConfirmed: false
            });
        }
    }
    render() {
        const { children: children, contentId: contentId } = this.props;
        if (!contentId) // in this case children renders ContentPrerequisites which shows the appropriate 404 page
        return children;
        const { restrictedPageViewConfirmed: restrictedPageViewConfirmed } = this.state;
        if (restrictedPageViewConfirmed) return children;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfFzM.AdminKeyQuery), null, ({ loading: loading, error: error, isSuperAdmin: isSuperAdmin })=>{
            if (loading) return null;
            if (error) throw error;
            if (!isSuperAdmin) return children;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bavCP.QueryInterop), {
                query: (0, $iPPFu.ViewPageGatewayQuery),
                variables: {
                    contentId: contentId
                },
                fetchPolicy: "network-only",
                context: {
                    asSuperAdmin: false
                },
                __callerPackage__: "view-page-gateway"
            }, ({ loading: loading, error: error })=>{
                if (loading) return null;
                // render confirmation if the user is accessing a restricted
                // page and has not already confirmed viewing the page
                if (error && !restrictedPageViewConfirmed && (0, $1uFM6.isUnauthorizedError)(error)) return this.renderRestrictedPageConfirmation();
                return children;
            });
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            restrictedPageViewConfirmed: false
        };
        this.onRestrictedPageViewConfirmClick = ()=>{
            (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).RESTRICTED_PAGE_CONFIRMED, this.props.contentId);
            // Set the state regardles of localstorage setItem succeeding or not so we
            // can render the page.
            this.setState({
                restrictedPageViewConfirmed: true
            });
        };
        this.renderRestrictedPageConfirmation = ()=>{
            const { contentId: contentId, spaceKey: spaceKey } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2k9aV.RestrictionsCheck), {
                contentId: contentId,
                spaceKey: spaceKey
            }, ({ hasDirectViewRestrictions: hasDirectViewRestrictions, hasInheritedViewRestrictions: hasInheritedViewRestrictions, isSpaceRestricted: isSpaceRestricted, error: error })=>{
                if (error) throw error;
                const restrictionFromType = $34641b344ae1099e$export$27cc57004471e91(hasDirectViewRestrictions, hasInheritedViewRestrictions, isSpaceRestricted);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9xNes.RestrictedPageConfirmation), {
                    restrictionFromType: restrictionFromType,
                    onViewPageClick: this.onRestrictedPageViewConfirmClick
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lLRfG.PageLoadEnd), {
                    metric: (0, $f3euL.INACCESSIBLE_PAGE_LOAD),
                    customData: {
                        contentId: contentId,
                        ...$34641b344ae1099e$var$CUSTOM_ATTRIBUTES
                    }
                }));
            });
        };
    }
}
$34641b344ae1099e$export$92eba4cf4af6c314.propTypes = {
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).node.isRequired
};
const $34641b344ae1099e$export$35cf1eab48371b15 = (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ep3mz.PageSubscriber), null, (t2)=>{
            const { contentId: contentId, spaceKey: spaceKey } = t2;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($34641b344ae1099e$export$92eba4cf4af6c314, {
                contentId: contentId,
                spaceKey: spaceKey
            }, children);
        });
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
$34641b344ae1099e$export$35cf1eab48371b15.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).node.isRequired
};
module.exports["ViewPageGateway"] = $34641b344ae1099e$export$35cf1eab48371b15;

});

parcelRegister("9xNes", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $4667b31838ac7b2c$export$8c5f260af94a9e2e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "tXIbI",
    name: "RestrictedPageConfirmation",
    loader: async ()=>(await (parcelRequire("fPQ3g"))).RestrictedPageConfirmation
});
module.exports["RestrictedPageConfirmation"] = $4667b31838ac7b2c$export$8c5f260af94a9e2e;

});

parcelRegister("fPQ3g", function(module, exports) {

let $b873fed1dab1bebc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b873fed1dab1bebc$var$load("37xVM").then(()=>parcelRequire('7NZoR'));

});

parcelRegister("2k9aV", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $80NaV = parcelRequire("80NaV");


var $fG32j = parcelRequire("fG32j");

const $d8539e55a4f27a93$export$26883b91564da8f7 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children, spaceKey: spaceKey } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = (t2)=>{
            const { error: spaceRestrictionCheckError, isSpaceRestricted: isSpaceRestricted } = t2;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $80NaV.PageViewRestrictions), null, (t3)=>{
                const { error: pageViewRestrictionsError, hasDirectViewRestrictions: hasDirectViewRestrictions, hasInheritedViewRestrictions: hasInheritedViewRestrictions } = t3;
                return children({
                    error: spaceRestrictionCheckError || pageViewRestrictionsError,
                    hasDirectViewRestrictions: hasDirectViewRestrictions,
                    hasInheritedViewRestrictions: hasInheritedViewRestrictions,
                    isSpaceRestricted: isSpaceRestricted
                });
            });
        };
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== spaceKey || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fG32j.SpaceRestrictionCheck), {
            asSuperAdmin: false,
            spaceKey: spaceKey
        }, t1);
        $[2] = spaceKey;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ children: children, spaceKey: spaceKey })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fG32j.SpaceRestrictionCheck), {
        asSuperAdmin: false,
        spaceKey: spaceKey
    }, ({ error: spaceRestrictionCheckError, isSpaceRestricted: isSpaceRestricted })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $80NaV.PageViewRestrictions), null, ({ error: pageViewRestrictionsError, hasDirectViewRestrictions: hasDirectViewRestrictions, hasInheritedViewRestrictions: hasInheritedViewRestrictions })=>children({
                error: spaceRestrictionCheckError || pageViewRestrictionsError,
                hasDirectViewRestrictions: hasDirectViewRestrictions,
                hasInheritedViewRestrictions: hasInheritedViewRestrictions,
                isSpaceRestricted: isSpaceRestricted
            })));
module.exports["RestrictionsCheck"] = $d8539e55a4f27a93$export$26883b91564da8f7;

});

parcelRegister("80NaV", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $jLw6A = parcelRequire("jLw6A");

const $ac3796b23ede5ce7$export$6bf9ddef68460137 = (0, $3u0dr.isReactCompilerActiveV2)() ? function PageViewRestrictions(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { children: children } = t0;
    const { restrictions: restrictions, error: error, loading: loading } = (0, $jLw6A.usePageRestrictionsContext)();
    const hasDirectViewRestrictions = Boolean(restrictions?.hasViewRestrictions);
    const hasInheritedViewRestrictions = Boolean(restrictions?.hasInheritedRestrictions);
    if (loading) return null;
    let t1;
    if ($[0] !== children || $[1] !== error || $[2] !== hasDirectViewRestrictions || $[3] !== hasInheritedViewRestrictions) {
        t1 = children({
            error: error,
            hasDirectViewRestrictions: hasDirectViewRestrictions,
            hasInheritedViewRestrictions: hasInheritedViewRestrictions
        });
        $[0] = children;
        $[1] = error;
        $[2] = hasDirectViewRestrictions;
        $[3] = hasInheritedViewRestrictions;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : function PageViewRestrictions({ children: children }) {
    const { restrictions: restrictions, error: error, loading: loading } = (0, $jLw6A.usePageRestrictionsContext)();
    const hasDirectViewRestrictions = Boolean(restrictions?.hasViewRestrictions);
    const hasInheritedViewRestrictions = Boolean(restrictions?.hasInheritedRestrictions);
    if (loading) return null;
    return children({
        error: error,
        hasDirectViewRestrictions: hasDirectViewRestrictions,
        hasInheritedViewRestrictions: hasInheritedViewRestrictions
    });
};
module.exports["PageViewRestrictions"] = $ac3796b23ede5ce7$export$6bf9ddef68460137;

});

parcelRegister("iPPFu", function(module, exports) {

var $4TFAM = parcelRequire("4TFAM");

parcelRequire("6SsN4");

const $db6511a61fa44cc3$export$aaf44510d6f97779 = (0, $4TFAM.default);
module.exports["ViewPageGatewayQuery"] = $db6511a61fa44cc3$export$aaf44510d6f97779;

});

parcelRegister("4TFAM", function(module, exports) {
/**
 * @generated SignedSource<<81653e42791a16b5c2fc1ce2c6d3fb97>>
 * @relayHash 1acb34527ccd100c0ace8e92cab69d27
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 57a50bcfa4464ca8772d815dabebd3afaae7a423dc8d57145cebe9e090f27da7
const $592a74ea097f12b6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ViewPageGatewayQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ViewPageGatewayQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "1acb34527ccd100c0ace8e92cab69d27",
            "id": "57a50bcfa4464ca8772d815dabebd3afaae7a423dc8d57145cebe9e090f27da7",
            "metadata": {},
            "name": "ViewPageGatewayQuery",
            "operationKind": "query",
            "text": "query ViewPageGatewayQuery($contentId:ID){content(id:$contentId){nodes{id,status}}}"
        }
    };
}();
$592a74ea097f12b6$var$node.hash = "c438f21d4b5a7f5b4c6a8f3518f32689";
var $592a74ea097f12b6$export$2e2bcd8739ae039 = $592a74ea097f12b6$var$node;
module.exports["default"] = $592a74ea097f12b6$export$2e2bcd8739ae039;

});

parcelRegister("iPRuY", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $9inwL = parcelRequire("9inwL");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $jMyy4 = parcelRequire("jMyy4");


var $7Sm4c = parcelRequire("7Sm4c");


var $1uFM6 = parcelRequire("1uFM6");


var $f9jv7 = parcelRequire("f9jv7");


var $9wGTI = parcelRequire("9wGTI");


var $ep3mz = parcelRequire("ep3mz");


var $kE2cJ = parcelRequire("kE2cJ");


var $hpnxK = parcelRequire("hpnxK");


var $hNtOj = parcelRequire("hNtOj");


var $dPJCf = parcelRequire("dPJCf");


var $1NBp8 = parcelRequire("1NBp8");


var $frfjk = parcelRequire("frfjk");


var $gMFJB = parcelRequire("gMFJB");


var $llOcx = parcelRequire("llOcx");


var $jH9vM = parcelRequire("jH9vM");


var $iElL7 = parcelRequire("iElL7");

/**
 * `space` is nullable in AGG, so a denied space read nulls that one field and the content still
 * resolves. Every 403 must be space-scoped: a content-scoped, pathless, network or mixed set
 * still restricts.
 */ const $eb18cf4dc4cf4350$var$isSpaceDenialOnly = (error)=>{
    const graphQLErrors = error.graphQLErrors ?? [];
    return graphQLErrors.length > 0 && !error.networkError && graphQLErrors.every((e)=>(0, $1uFM6.isUnauthorizedError)(e) && e.path?.[0] === 'space');
};
const $eb18cf4dc4cf4350$var$useContentPrerequisites = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(26);
    const { spaceKey: spaceKey, contentId: contentId, contentQueryResult: contentQueryResult, handleUnexpectedError: handleUnexpectedError, handleTimeoutError: handleTimeoutError, status: status, skip: skip } = t0;
    const missingSpaceKey = !spaceKey;
    const missingContentId = !contentId;
    const missingContentSSR = undefined;
    const contentQueryResultCheck = (0, $9wGTI.fg)("use_content_query_result_data_error") ? contentQueryResult?.data || contentQueryResult?.error : contentQueryResult;
    const skipContentPrerequisites = skip || missingContentId || Boolean(contentQueryResultCheck) && !missingContentSSR;
    let t1;
    if ($[0] !== status) {
        t1 = status ? {
            status: status
        } : {};
        $[0] = status;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== contentId || $[3] !== missingSpaceKey || $[4] !== spaceKey || $[5] !== t1) {
        t2 = {
            contentId: contentId,
            missingSpaceKey: missingSpaceKey,
            spaceKey: spaceKey,
            ...t1
        };
        $[2] = contentId;
        $[3] = missingSpaceKey;
        $[4] = spaceKey;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== skipContentPrerequisites || $[8] !== t2) {
        t3 = {
            errorPolicy: "all",
            variables: t2,
            skip: skipContentPrerequisites
        };
        $[7] = skipContentPrerequisites;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    const contentPrerequisitesQueryResult = (0, $jMyy4.useQueryInterop)((0, $9inwL.default), {
        ...t3,
        __callerPackage__: "content-prerequisites"
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { data: data, error: error, loading: queryLoading } = skipContentPrerequisites ? contentQueryResult || {} : contentPrerequisitesQueryResult;
    const [t4] = (0, $ep3mz.usePageState)();
    const { contentIdLoading: contentIdLoading } = t4;
    const isAccessLinkRoute = (0, $dPJCf.useIsOnRoute)((0, $1NBp8.ACCESS_LINK));
    const loading = queryLoading || contentIdLoading;
    const hasContent = (data?.content?.nodes?.length ?? 0) > 0;
    const isDroppableSpaceDenial = Boolean(error && isAccessLinkRoute && hasContent && $eb18cf4dc4cf4350$var$isSpaceDenialOnly(error));
    (0, $cozmU.useEffect)(()=>{
        if (!isDroppableSpaceDenial) return;
        createAnalyticsEvent({
            type: "sendOperationalEvent",
            data: {
                source: "ContentPrerequisites",
                action: "ignoredSpaceDenial",
                actionSubject: "accessLinkContent",
                attributes: {
                    contentId: contentId,
                    graphQLErrorCount: error?.graphQLErrors?.length ?? 0
                }
            }
        }).fire();
    }, [
        isDroppableSpaceDenial,
        error,
        contentId,
        createAnalyticsEvent
    ]);
    if ((!data || missingContentId) && loading) {
        let t5;
        if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
            t5 = {
                isLoading: true
            };
            $[10] = t5;
        } else t5 = $[10];
        return t5;
    }
    const isEmptyContent = !loading && !error && data && !data?.content;
    const isTimeoutError = error?.toString().includes("SocketTimeoutException");
    if (isDroppableSpaceDenial) (0, $7Sm4c.markErrorAsHandled)(error);
    const effectiveError = isDroppableSpaceDenial ? undefined : error;
    if (effectiveError && (0, $1uFM6.isUnauthorizedError)(effectiveError) || isEmptyContent) {
        if (effectiveError) (0, $7Sm4c.markErrorAsHandled)(effectiveError);
        if (isEmptyContent && true) createAnalyticsEvent({
            type: "sendOperationalEvent",
            data: {
                source: "ContentPrerequisites",
                action: "returnedEmpty",
                actionSubject: "content",
                attributes: {
                    contentId: contentId,
                    skip: skip,
                    hadContentQueryData: Boolean(contentQueryResult?.data)
                }
            }
        }).fire();
        let t5;
        if ($[11] !== effectiveError) {
            t5 = {
                error: effectiveError,
                isRestricted: true
            };
            $[11] = effectiveError;
            $[12] = t5;
        } else t5 = $[12];
        return t5;
    }
    let t5;
    if ($[13] !== data?.content?.nodes) {
        t5 = data?.content?.nodes || [];
        $[13] = data?.content?.nodes;
        $[14] = t5;
    } else t5 = $[14];
    const content = t5;
    const shouldHandleErrors = !!effectiveError;
    if (missingContentId || content.length === 0 && !shouldHandleErrors || shouldHandleErrors && (0, $f9jv7.isNotFoundError)(effectiveError)) {
        let t6;
        if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
            t6 = {
                isNotFound: true
            };
            $[15] = t6;
        } else t6 = $[15];
        return t6;
    }
    const expectedSpaceKey = content[0]?.space?.alias || content[0]?.space?.key;
    const wrongSpaceKeyOnSSR = undefined;
    let t6;
    if ($[16] !== effectiveError) {
        t6 = effectiveError && (0, $hpnxK.isNotFoundSpaceError)(effectiveError);
        $[16] = effectiveError;
        $[17] = t6;
    } else t6 = $[17];
    const notFoundSpaceError = t6;
    if (missingSpaceKey || wrongSpaceKeyOnSSR || notFoundSpaceError) {
        (0, $7Sm4c.markErrorAsHandled)(effectiveError);
        const t7 = `CP-noSK:${missingSpaceKey}|wrongSK:${Boolean(wrongSpaceKeyOnSSR)}|noSpace:${Boolean(notFoundSpaceError)}`;
        let t8;
        if ($[18] !== expectedSpaceKey || $[19] !== t7) {
            t8 = {
                isRedirect: true,
                redirectSpaceKey: expectedSpaceKey,
                redirectReason: t7
            };
            $[18] = expectedSpaceKey;
            $[19] = t7;
            $[20] = t8;
        } else t8 = $[20];
        return t8;
    }
    if (effectiveError && handleTimeoutError && isTimeoutError) {
        handleTimeoutError(effectiveError);
        let t7;
        if ($[21] !== effectiveError) {
            t7 = {
                error: effectiveError,
                isTimeoutError: true
            };
            $[21] = effectiveError;
            $[22] = t7;
        } else t7 = $[22];
        return t7;
    }
    if (effectiveError && handleUnexpectedError) {
        handleUnexpectedError(effectiveError);
        let t7;
        if ($[23] !== effectiveError) {
            t7 = {
                error: effectiveError,
                isUnexpectedError: true
            };
            $[23] = effectiveError;
            $[24] = t7;
        } else t7 = $[24];
        return t7;
    }
    let t7;
    if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = {};
        $[25] = t7;
    } else t7 = $[25];
    return t7;
} : ({ spaceKey: spaceKey, contentId: contentId, contentQueryResult: contentQueryResult, handleUnexpectedError: handleUnexpectedError, handleTimeoutError: handleTimeoutError, status: status, skip: skip })=>{
    // Redirect legacy url which doesn't have spaceKey
    const missingSpaceKey = !spaceKey;
    const missingContentId = !contentId;
    // Content is considered missing when we attempted to use contentQueryResult but no data
    // is available due to known or unknown errors. This is only applicable for SSR.
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const missingContentSSR = undefined;
    // We need to check for "data" or "error" existence in contentQueryResult and not just the existence of contentQueryResult,
    // since this object is the query result from Apollo and it might be present but with no data or error such as { variables: fn, refetch: fn }
    const contentQueryResultCheck = (0, $9wGTI.fg)('use_content_query_result_data_error') ? contentQueryResult?.data || contentQueryResult?.error : contentQueryResult;
    const skipContentPrerequisites = skip || missingContentId || Boolean(contentQueryResultCheck) && !missingContentSSR;
    const contentPrerequisitesQueryResult = (0, $jMyy4.useQueryInterop)((0, $9inwL.default), {
        errorPolicy: 'all',
        variables: {
            contentId: contentId,
            missingSpaceKey: missingSpaceKey,
            spaceKey: spaceKey,
            ...status ? {
                status: status
            } : {}
        },
        skip: skipContentPrerequisites,
        __callerPackage__: "content-prerequisites"
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { data: data, error: error, loading: queryLoading } = skipContentPrerequisites ? contentQueryResult || {} : contentPrerequisitesQueryResult;
    const [{ contentIdLoading: contentIdLoading }] = (0, $ep3mz.usePageState)();
    // Not the `route` prop — that arrives as `VIEW_PAGE`, because `ViewPageContainer`'s `pageMap`
    // has no `ACCESS_LINK` entry.
    const isAccessLinkRoute = (0, $dPJCf.useIsOnRoute)((0, $1NBp8.ACCESS_LINK));
    const loading = queryLoading || contentIdLoading;
    const hasContent = (data?.content?.nodes?.length ?? 0) > 0;
    // `hasContent` matters: dropping the error with no content falls through to `isNotFound` below,
    // trading one wrong screen for another.
    const isDroppableSpaceDenial = Boolean(error && isAccessLinkRoute && hasContent && $eb18cf4dc4cf4350$var$isSpaceDenialOnly(error));
    (0, $cozmU.useEffect)(()=>{
        if (!isDroppableSpaceDenial) return;
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                source: 'ContentPrerequisites',
                action: 'ignoredSpaceDenial',
                actionSubject: 'accessLinkContent',
                attributes: {
                    contentId: contentId,
                    graphQLErrorCount: error?.graphQLErrors?.length ?? 0
                }
            }
        }).fire();
    }, [
        isDroppableSpaceDenial,
        error,
        contentId,
        createAnalyticsEvent
    ]);
    if ((!data || missingContentId) && loading) return {
        isLoading: true
    };
    // Known Apollo bug: Errors are not saved within Apollo in-memory cache
    // https://github.com/apollographql/apollo-client/issues/4806. For restricted spaces and pages,
    // the 403 error is subsequently undefined after retrieval attempt. Restricted spaces means
    // content will be null, but the error might be undefined.
    const isEmptyContent = !loading && !error && data && !data?.content;
    const isTimeoutError = error?.toString().includes('SocketTimeoutException');
    if (isDroppableSpaceDenial) // Not in the effect above: this races a short window in GraphqlErrorProcessor after which
    // the error is reported anyway, and effects never run under SSR.
    (0, $7Sm4c.markErrorAsHandled)(error);
    const effectiveError = isDroppableSpaceDenial ? undefined : error;
    if (effectiveError && (0, $1uFM6.isUnauthorizedError)(effectiveError) || isEmptyContent) {
        if (effectiveError) (0, $7Sm4c.markErrorAsHandled)(effectiveError);
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        if (isEmptyContent && true) createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                source: 'ContentPrerequisites',
                action: 'returnedEmpty',
                actionSubject: 'content',
                attributes: {
                    contentId: contentId,
                    skip: skip,
                    hadContentQueryData: Boolean(contentQueryResult?.data)
                }
            }
        }).fire();
        return {
            error: effectiveError,
            isRestricted: true
        };
    }
    // Catch all for errors, no content and calls that return null/undefined
    // If FF is on, this catches Not Found errors (404) and other errors are handled below
    const content = data?.content?.nodes || [];
    const shouldHandleErrors = !!effectiveError;
    if (missingContentId || content.length === 0 && !shouldHandleErrors || shouldHandleErrors && (0, $f9jv7.isNotFoundError)(effectiveError)) return {
        isNotFound: true
    };
    const expectedSpaceKey = content[0]?.space?.alias || content[0]?.space?.key;
    // Checks for case where old / wrong spacekey is provided causing reload
    // on SSR -> SPA transition once the ContentRedirectQuery resolves.
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const wrongSpaceKeyOnSSR = undefined;
    const notFoundSpaceError = effectiveError && (0, $hpnxK.isNotFoundSpaceError)(effectiveError);
    if (missingSpaceKey || wrongSpaceKeyOnSSR || notFoundSpaceError) {
        (0, $7Sm4c.markErrorAsHandled)(effectiveError);
        return {
            isRedirect: true,
            redirectSpaceKey: expectedSpaceKey,
            redirectReason: `CP-noSK:${missingSpaceKey}|wrongSK:${Boolean(wrongSpaceKeyOnSSR)}|noSpace:${Boolean(notFoundSpaceError)}`
        };
    }
    if (effectiveError && handleTimeoutError && isTimeoutError) {
        handleTimeoutError(effectiveError);
        return {
            error: effectiveError,
            isTimeoutError: true
        };
    }
    if (effectiveError && handleUnexpectedError) {
        handleUnexpectedError(effectiveError);
        return {
            error: effectiveError,
            isUnexpectedError: true
        };
    }
    return {};
};
const $eb18cf4dc4cf4350$export$1ff4591c5a23ba79 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(32);
    const { children: children, route: route, contentQueryResult: contentQueryResult, passThroughOnLoading: t1, handleUnexpectedError: handleUnexpectedError, handleTimeoutError: handleTimeoutError, status: status, versionOverride: versionOverride } = t0;
    const passThroughOnLoading = t1 === undefined ? false : t1;
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const isTransition = (0, $dPJCf.useIsTransition)();
    let t2;
    if ($[0] !== contentId || $[1] !== contentQueryResult || $[2] !== handleTimeoutError || $[3] !== handleUnexpectedError || $[4] !== spaceKey || $[5] !== status) {
        t2 = {
            spaceKey: spaceKey,
            contentId: contentId,
            contentQueryResult: contentQueryResult,
            handleUnexpectedError: handleUnexpectedError,
            handleTimeoutError: handleTimeoutError,
            status: status
        };
        $[0] = contentId;
        $[1] = contentQueryResult;
        $[2] = handleTimeoutError;
        $[3] = handleUnexpectedError;
        $[4] = spaceKey;
        $[5] = status;
        $[6] = t2;
    } else t2 = $[6];
    const prerequisites = $eb18cf4dc4cf4350$var$useContentPrerequisites(t2);
    if (prerequisites.isNotFound) {
        let t3;
        if ($[7] !== contentId || $[8] !== route || $[9] !== spaceKey) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $frfjk.NotFoundContainer), {
                route: route,
                spaceKey: spaceKey,
                contentId: contentId
            });
            $[7] = contentId;
            $[8] = route;
            $[9] = spaceKey;
            $[10] = t3;
        } else t3 = $[10];
        return t3;
    }
    let t3;
    if ($[11] !== children || $[12] !== contentId || $[13] !== isTransition || $[14] !== passThroughOnLoading || $[15] !== prerequisites.error || $[16] !== prerequisites.isLoading || $[17] !== prerequisites.isRedirect || $[18] !== prerequisites.isRestricted || $[19] !== prerequisites.isTimeoutError || $[20] !== prerequisites.redirectReason || $[21] !== prerequisites.redirectSpaceKey || $[22] !== route || $[23] !== spaceKey) {
        t3 = ()=>{
            if (!isTransition && contentId && (0, $hNtOj.ssrPermissionsErrorHandler).getRestrictedRoute() === "view") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $llOcx.UnauthorizedScreen), {
                contentId: contentId,
                accessType: (0, $hNtOj.ssrPermissionsErrorHandler).getErrorType()
            });
            if (prerequisites.isLoading) return passThroughOnLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gMFJB.ContentExpansionContainer), null, children) : null;
            if (contentId && prerequisites.isRestricted) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $llOcx.UnauthorizedScreen), {
                contentId: contentId,
                accessType: $eb18cf4dc4cf4350$var$getAccessType(prerequisites.error)
            });
            if (prerequisites.isRedirect) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
                name: route.name,
                reason: prerequisites.redirectReason,
                params: {
                    contentId: contentId,
                    spaceKey: prerequisites.redirectSpaceKey
                }
            });
            if (prerequisites.isTimeoutError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iElL7.TimeoutErrorScreen), {
                contentId: contentId,
                spaceKey: spaceKey
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gMFJB.ContentExpansionContainer), null, children);
        };
        $[11] = children;
        $[12] = contentId;
        $[13] = isTransition;
        $[14] = passThroughOnLoading;
        $[15] = prerequisites.error;
        $[16] = prerequisites.isLoading;
        $[17] = prerequisites.isRedirect;
        $[18] = prerequisites.isRestricted;
        $[19] = prerequisites.isTimeoutError;
        $[20] = prerequisites.redirectReason;
        $[21] = prerequisites.redirectSpaceKey;
        $[22] = route;
        $[23] = spaceKey;
        $[24] = t3;
    } else t3 = $[24];
    const getContentComponent = t3;
    let t4;
    if ($[25] !== versionOverride) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jH9vM.ContentRedirect), {
            versionOverride: versionOverride
        });
        $[25] = versionOverride;
        $[26] = t4;
    } else t4 = $[26];
    let t5;
    if ($[27] !== getContentComponent) {
        t5 = getContentComponent();
        $[27] = getContentComponent;
        $[28] = t5;
    } else t5 = $[28];
    let t6;
    if ($[29] !== t4 || $[30] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t4, t5);
        $[29] = t4;
        $[30] = t5;
        $[31] = t6;
    } else t6 = $[31];
    return t6;
} : ({ children: children, route: route, contentQueryResult: contentQueryResult, passThroughOnLoading: passThroughOnLoading = false, handleUnexpectedError: handleUnexpectedError, handleTimeoutError: handleTimeoutError, status: status, versionOverride: versionOverride })=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const isTransition = (0, $dPJCf.useIsTransition)();
    const prerequisites = $eb18cf4dc4cf4350$var$useContentPrerequisites({
        spaceKey: spaceKey,
        contentId: contentId,
        contentQueryResult: contentQueryResult,
        handleUnexpectedError: handleUnexpectedError,
        handleTimeoutError: handleTimeoutError,
        status: status
    });
    if (prerequisites.isNotFound) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $frfjk.NotFoundContainer), {
        route: route,
        spaceKey: spaceKey,
        contentId: contentId
    });
    const getContentComponent = ()=>{
        if (!isTransition && contentId && (0, $hNtOj.ssrPermissionsErrorHandler).getRestrictedRoute() === 'view') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $llOcx.UnauthorizedScreen), {
            contentId: contentId,
            accessType: (0, $hNtOj.ssrPermissionsErrorHandler).getErrorType()
        });
        if (prerequisites.isLoading) return passThroughOnLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gMFJB.ContentExpansionContainer), null, children) : null;
        if (contentId && prerequisites.isRestricted) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $llOcx.UnauthorizedScreen), {
            contentId: contentId,
            accessType: $eb18cf4dc4cf4350$var$getAccessType(prerequisites.error)
        });
        if (prerequisites.isRedirect) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
            name: route.name,
            reason: prerequisites.redirectReason,
            params: {
                contentId: contentId,
                spaceKey: prerequisites.redirectSpaceKey
            }
        });
        if (prerequisites.isTimeoutError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iElL7.TimeoutErrorScreen), {
            contentId: contentId,
            spaceKey: spaceKey
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gMFJB.ContentExpansionContainer), null, children);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jH9vM.ContentRedirect), {
        versionOverride: versionOverride
    }), getContentComponent());
};
function $eb18cf4dc4cf4350$var$getAccessType(error) {
    return error?.graphQLErrors?.[0]?.extensions?.data?.errors?.[0]?.message?.key === 'confluence.content.restricted.inherited' ? 'inherited' : 'view';
}
module.exports["ContentPrerequisites"] = $eb18cf4dc4cf4350$export$1ff4591c5a23ba79;

});

parcelRegister("frfjk", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $b2p4s = parcelRequire("b2p4s");


var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $lt6Lx = parcelRequire("lt6Lx");


var $3IBnw = parcelRequire("3IBnw");


var $f9jv7 = parcelRequire("f9jv7");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $1NBp8 = parcelRequire("1NBp8");


var $wtSEP = parcelRequire("wtSEP");


var $3WD5B = parcelRequire("3WD5B");


var $kE2cJ = parcelRequire("kE2cJ");


var $gMFJB = parcelRequire("gMFJB");

const $4bb6cb1596a8393b$export$32fe640941018446 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { route: route, spaceKey: spaceKey, contentId: contentId } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = window.location.search.match(/draftShareId=(.*?)(#|&|$)/)?.[1] ?? "";
        $[0] = t1;
    } else t1 = $[0];
    const urlDraftShareId = t1;
    const t2 = contentId ?? "";
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = [
            "draft"
        ];
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] !== t2) {
        t4 = {
            contentId: t2,
            draftShareId: urlDraftShareId,
            status: t3
        };
        $[2] = t2;
        $[3] = t4;
    } else t4 = $[3];
    const t5 = !contentId || !spaceKey || route !== (0, $1NBp8.VIEW_PAGE);
    let t6;
    if ($[4] !== t4 || $[5] !== t5) {
        t6 = {
            variables: t4,
            skip: t5,
            fetchPolicy: window.__SSR_RENDERED__ ? "cache-only" : "cache-and-network",
            onError: $4bb6cb1596a8393b$var$_temp
        };
        $[4] = t4;
        $[5] = t5;
        $[6] = t6;
    } else t6 = $[6];
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $b2p4s.default), {
        ...t6,
        __callerPackage__: "content-prerequisites"
    });
    let t7;
    if ($[7] !== contentId || $[8] !== data?.content?.nodes?.[0]?.links?.webui || $[9] !== data?.content?.nodes?.[0]?.properties?.nodes?.[0]?.value || $[10] !== spaceKey) {
        t7 = Symbol.for("react.early_return_sentinel");
        bb0: {
            const draftShareId = data?.content?.nodes?.[0]?.links?.webui?.match(/draftShareId=(.*?)(#|&|$)/)?.[1];
            const isFabric = data?.content?.nodes?.[0]?.properties?.nodes?.[0]?.value === "\"v2\"";
            if (isFabric && draftShareId) {
                t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
                    href: (0, $1NBp8.EDIT_PAGE_V2).toUrl({
                        contentId: contentId,
                        spaceKey: spaceKey,
                        contentType: "pages"
                    }, {
                        query: {
                            draftShareId: draftShareId
                        }
                    })
                });
                break bb0;
            }
        }
        $[7] = contentId;
        $[8] = data?.content?.nodes?.[0]?.links?.webui;
        $[9] = data?.content?.nodes?.[0]?.properties?.nodes?.[0]?.value;
        $[10] = spaceKey;
        $[11] = t7;
    } else t7 = $[11];
    if (t7 !== Symbol.for("react.early_return_sentinel")) return t7;
    let t8;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lt6Lx.DocumentContentTitle), {
            notFound: true
        });
        $[12] = t8;
    } else t8 = $[12];
    let t9;
    if ($[13] !== route || $[14] !== spaceKey) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gMFJB.ContentExpansionContainer), null, t8, route === (0, $1NBp8.SPACE_OVERVIEW) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3WD5B.OverviewNotFound), {
            spaceKey: spaceKey
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $wtSEP.NotFound), null));
        $[13] = route;
        $[14] = spaceKey;
        $[15] = t9;
    } else t9 = $[15];
    return t9;
} : ({ route: route, spaceKey: spaceKey, contentId: contentId })=>{
    // View page URLs inserted by the `/Create Confluence page` extension will include draftShareId
    const urlDraftShareId = window.location.search.match(/draftShareId=(.*?)(#|&|$)/)?.[1] ?? '';
    /*
   * If we've hit this component, the page may actually be an unpublished draft,
   * if so then redirect to the editor given the user has edit permission
   */ const { data: data } = (0, $jMyy4.useQueryInterop)((0, $b2p4s.default), {
        variables: {
            contentId: contentId ?? '',
            draftShareId: urlDraftShareId,
            status: [
                'draft'
            ]
        },
        skip: !contentId || !spaceKey || route !== (0, $1NBp8.VIEW_PAGE),
        fetchPolicy: window.__SSR_RENDERED__ ? 'cache-only' : 'cache-and-network',
        onError: (error)=>{
            if (!(0, $1uFM6.isUnauthorizedError)(error) && !(0, $f9jv7.isNotFoundError)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
        },
        __callerPackage__: "content-prerequisites"
    });
    // Query result will include draftShareId if the page is a draft
    const draftShareId = data?.content?.nodes?.[0]?.links?.webui?.match(/draftShareId=(.*?)(#|&|$)/)?.[1];
    const isFabric = data?.content?.nodes?.[0]?.properties?.nodes?.[0]?.value === '"v2"';
    if (isFabric && draftShareId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        href: (0, $1NBp8.EDIT_PAGE_V2).toUrl({
            contentId: contentId,
            spaceKey: spaceKey,
            contentType: 'pages'
        }, {
            query: {
                draftShareId: draftShareId
            }
        })
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gMFJB.ContentExpansionContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lt6Lx.DocumentContentTitle), {
        notFound: true
    }), route === (0, $1NBp8.SPACE_OVERVIEW) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3WD5B.OverviewNotFound), {
        spaceKey: spaceKey
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $wtSEP.NotFound), null));
};
function $4bb6cb1596a8393b$var$_temp(error) {
    if (!(0, $1uFM6.isUnauthorizedError)(error) && !(0, $f9jv7.isNotFoundError)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
        attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
    });
    (0, $7Sm4c.markErrorAsHandled)(error);
}
module.exports["NotFoundContainer"] = $4bb6cb1596a8393b$export$32fe640941018446;

});

parcelRegister("3WD5B", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $122d2f3e6774c3f2$export$df359d26db880cab = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AHMpB",
    name: "OverviewNotFound",
    loader: async ()=>// eslint-disable-next-line
        (await (parcelRequire("9NMv1"))).OverviewNotFound
});
module.exports["OverviewNotFound"] = $122d2f3e6774c3f2$export$df359d26db880cab;

});

parcelRegister("9NMv1", function(module, exports) {

let $722e4f9ba06e42b4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $722e4f9ba06e42b4$var$load("bn8Oy").then(()=>parcelRequire('bDiji'));

});

parcelRegister("gMFJB", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $d38ee66b6872a958$export$ffe4f7ef348542da = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_39xV02N91d",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_39xV02N91d",
            __cmplp.className
        ])
    });
});
module.exports["ContentExpansionContainer"] = $d38ee66b6872a958$export$ffe4f7ef348542da;

});

parcelRegister("llOcx", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lt6Lx = parcelRequire("lt6Lx");


var $88O8D = parcelRequire("88O8D");


var $6MSEP = parcelRequire("6MSEP");


var $gMFJB = parcelRequire("gMFJB");

const $3d886ddd51b4b1de$export$6af94d617557e778 = /*#__PURE__*/ (0, $cozmU.memo)((0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $bDgLe.c)(4);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $88O8D.LoginIfAnonymous), null);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lt6Lx.DocumentContentTitle), {
            siteTitleOnly: true
        });
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== props) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gMFJB.ContentExpansionContainer), null, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6MSEP.RestrictedPage), props)));
        $[2] = props;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $88O8D.LoginIfAnonymous), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gMFJB.ContentExpansionContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lt6Lx.DocumentContentTitle), {
        siteTitleOnly: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6MSEP.RestrictedPage), props))));
module.exports["UnauthorizedScreen"] = $3d886ddd51b4b1de$export$6af94d617557e778;

});

parcelRegister("88O8D", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lTECB = parcelRequire("lTECB");


var $kE2cJ = parcelRequire("kE2cJ");


var $bQm3c = parcelRequire("bQm3c");


var $jEeDd = parcelRequire("jEeDd");

const $d2b0786819b3899c$export$cd1cc7f28314b96a = ()=>{
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    return userId ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        href: (0, $jEeDd.getLoginLink)(),
        usePush: (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)()
    });
};
module.exports["LoginIfAnonymous"] = $d2b0786819b3899c$export$cd1cc7f28314b96a;

});

parcelRegister("jH9vM", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $4uNpa = parcelRequire("4uNpa");


var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $1uFM6 = parcelRequire("1uFM6");


var $6mKj3 = parcelRequire("6mKj3");


var $7Sm4c = parcelRequire("7Sm4c");


var $ep3mz = parcelRequire("ep3mz");


var $cb6fO = parcelRequire("cb6fO");


var $bQm3c = parcelRequire("bQm3c");


var $bFVuH = parcelRequire("bFVuH");

const $5b842fead80f6623$export$2ca6584fed43f61 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(20);
    const { versionOverride: versionOverride } = t0;
    const [t1] = (0, $ep3mz.usePageState)();
    const { contentId: contentId, contentSlug: contentSlug, spaceKey: spaceKey } = t1;
    const { isHideTitleInUrl: isHideTitleInUrl } = (0, $bQm3c.useSessionData)();
    let t2;
    if ($[0] !== contentId || $[1] !== versionOverride) {
        t2 = {
            contentId: contentId,
            versionOverride: versionOverride
        };
        $[0] = contentId;
        $[1] = versionOverride;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            single: true
        };
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== t2) {
        t4 = {
            errorPolicy: "all",
            variables: t2,
            context: t3
        };
        $[4] = t2;
        $[5] = t4;
    } else t4 = $[5];
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)((0, $4uNpa.default), {
        ...t4,
        __callerPackage__: "content-prerequisites"
    });
    if (loading) return null;
    if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    const content = data?.content?.nodes?.[0];
    const space = content?.space;
    const title = content?.title;
    let t5;
    if ($[6] !== isHideTitleInUrl) {
        t5 = isHideTitleInUrl && (0, $6mKj3.isExperimentEnabled)("confluence_hide_content_title_in_url");
        $[6] = isHideTitleInUrl;
        $[7] = t5;
    } else t5 = $[7];
    const redirectToHideTitleSlug = t5;
    let t6;
    if ($[8] !== content || $[9] !== redirectToHideTitleSlug || $[10] !== space?.alias || $[11] !== space?.key || $[12] !== title) {
        t6 = content && {
            ...content,
            slug: redirectToHideTitleSlug ? undefined : (0, $cb6fO.generateSlug)(title),
            spaceKey: space?.alias || space?.key,
            createdDate: content?.history?.createdDate
        };
        $[8] = content;
        $[9] = redirectToHideTitleSlug;
        $[10] = space?.alias;
        $[11] = space?.key;
        $[12] = title;
        $[13] = t6;
    } else t6 = $[13];
    const contentWithSlug = t6;
    let t7;
    if ($[14] !== contentSlug || $[15] !== contentWithSlug || $[16] !== redirectToHideTitleSlug || $[17] !== space || $[18] !== spaceKey) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bFVuH.ContentRedirectComponent), {
            contentSlugInUrl: contentSlug,
            contentWithSlug: contentWithSlug,
            space: space,
            spaceKeyInUrl: spaceKey,
            redirectToHideTitleSlug: redirectToHideTitleSlug
        });
        $[14] = contentSlug;
        $[15] = contentWithSlug;
        $[16] = redirectToHideTitleSlug;
        $[17] = space;
        $[18] = spaceKey;
        $[19] = t7;
    } else t7 = $[19];
    return t7;
} : ({ versionOverride: versionOverride })=>{
    const [{ contentId: contentId, contentSlug: contentSlug, spaceKey: spaceKey }] = (0, $ep3mz.usePageState)();
    const { isHideTitleInUrl: isHideTitleInUrl } = (0, $bQm3c.useSessionData)();
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)((0, $4uNpa.default), {
        errorPolicy: 'all',
        variables: {
            contentId: contentId,
            versionOverride: versionOverride
        },
        context: {
            single: true
        },
        __callerPackage__: "content-prerequisites"
    });
    if (loading) return null;
    // UnauthorizedError is a special case here since no specific UI are required for it.
    // In case of an UnauthorizedError the data or content are expected to be empty, and
    // ContentRedirectComponent will handle such case properly.
    if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    const content = data?.content?.nodes?.[0];
    const space = content?.space;
    const title = content?.title;
    const redirectToHideTitleSlug = isHideTitleInUrl && (0, $6mKj3.isExperimentEnabled)('confluence_hide_content_title_in_url');
    const contentWithSlug = content && {
        ...content,
        slug: redirectToHideTitleSlug ? undefined : (0, $cb6fO.generateSlug)(title),
        spaceKey: space?.alias || space?.key,
        createdDate: content?.history?.createdDate
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bFVuH.ContentRedirectComponent), {
        contentSlugInUrl: contentSlug,
        contentWithSlug: contentWithSlug,
        space: space,
        spaceKeyInUrl: spaceKey,
        redirectToHideTitleSlug: redirectToHideTitleSlug
    });
};
module.exports["ContentRedirect"] = $5b842fead80f6623$export$2ca6584fed43f61;

});

parcelRegister("bFVuH", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1NBp8 = parcelRequire("1NBp8");


var $6HckY = parcelRequire("6HckY");


var $kE2cJ = parcelRequire("kE2cJ");


var $7zgzO = parcelRequire("7zgzO");


var $4o1RV = parcelRequire("4o1RV");


var $3jwuS = parcelRequire("3jwuS");

const $40c3e9fb4beb4b02$export$c859cd2f253879ed = /*#__PURE__*/ (0, $cozmU.memo)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(60);
    const { contentWithSlug: contentWithSlug, space: space, spaceKeyInUrl: spaceKeyInUrl, contentSlugInUrl: t1, redirectToHideTitleSlug: redirectToHideTitleSlug } = t0;
    const contentSlugInUrl = t1 === undefined ? "" : t1;
    const { match: match, replace: replace, toUrl: toUrl, getHash: getHash, getQueryParams: getQueryParams } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const { routePolicy: routePolicy } = (0, $4o1RV.useNavigationPolicy)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    let t2;
    if ($[0] !== contentWithSlug || $[1] !== isLivePage || $[2] !== spaceKeyInUrl) {
        t2 = ()=>{
            if (isLivePage) return false;
            return contentWithSlug && spaceKeyInUrl !== contentWithSlug?.spaceKey;
        };
        $[0] = contentWithSlug;
        $[1] = isLivePage;
        $[2] = spaceKeyInUrl;
        $[3] = t2;
    } else t2 = $[3];
    const shouldRedirectIncorrectSpaceKey = t2;
    let t3;
    if ($[4] !== contentSlugInUrl || $[5] !== contentWithSlug?.slug || $[6] !== isLivePage) {
        t3 = ()=>isLivePage ? false : decodeURIComponent(contentWithSlug?.slug || "") !== decodeURIComponent(contentSlugInUrl);
        $[4] = contentSlugInUrl;
        $[5] = contentWithSlug?.slug;
        $[6] = isLivePage;
        $[7] = t3;
    } else t3 = $[7];
    contentWithSlug?.slug;
    const shouldRedirectIncorrectSlug = t3;
    const isIncorrectSlug = shouldRedirectIncorrectSlug();
    let t4;
    if ($[8] !== shouldRedirectIncorrectSpaceKey) {
        t4 = shouldRedirectIncorrectSpaceKey();
        $[8] = shouldRedirectIncorrectSpaceKey;
        $[9] = t4;
    } else t4 = $[9];
    const isIncorrectSpaceKey = t4;
    const hasContentTitleToStrip = redirectToHideTitleSlug && isIncorrectSlug;
    let t5;
    if ($[10] !== getHash || $[11] !== redirectToHideTitleSlug) {
        t5 = redirectToHideTitleSlug && Boolean(getHash());
        $[10] = getHash;
        $[11] = redirectToHideTitleSlug;
        $[12] = t5;
    } else t5 = $[12];
    const hasAnchorHashToStrip = t5;
    let t6;
    if ($[13] !== contentWithSlug || $[14] !== getQueryParams || $[15] !== hasAnchorHashToStrip || $[16] !== hasContentTitleToStrip || $[17] !== isIncorrectSpaceKey || $[18] !== match?.name || $[19] !== match?.params || $[20] !== replace || $[21] !== toUrl) {
        t6 = ()=>{
            if (!contentWithSlug || isIncorrectSpaceKey) return;
            if (!hasContentTitleToStrip && !hasAnchorHashToStrip) return;
            window.__DELAYED_CONTENT_REDIRECTION__ = {};
            const targetUrl = toUrl(match?.name, {
                ...match?.params,
                hash: undefined,
                query: getQueryParams(),
                spaceKey: contentWithSlug.spaceKey,
                contentId: contentWithSlug.id,
                contentSlug: contentWithSlug.slug
            });
            replace(targetUrl);
        };
        $[13] = contentWithSlug;
        $[14] = getQueryParams;
        $[15] = hasAnchorHashToStrip;
        $[16] = hasContentTitleToStrip;
        $[17] = isIncorrectSpaceKey;
        $[18] = match?.name;
        $[19] = match?.params;
        $[20] = replace;
        $[21] = toUrl;
        $[22] = t6;
    } else t6 = $[22];
    const t7 = match?.name;
    const t8 = match?.params;
    let t9;
    if ($[23] !== contentWithSlug || $[24] !== getHash || $[25] !== getQueryParams || $[26] !== hasAnchorHashToStrip || $[27] !== hasContentTitleToStrip || $[28] !== isIncorrectSpaceKey || $[29] !== replace || $[30] !== t7 || $[31] !== t8 || $[32] !== toUrl) {
        t9 = [
            hasContentTitleToStrip,
            hasAnchorHashToStrip,
            isIncorrectSpaceKey,
            contentWithSlug,
            t7,
            t8,
            replace,
            toUrl,
            getHash,
            getQueryParams
        ];
        $[23] = contentWithSlug;
        $[24] = getHash;
        $[25] = getQueryParams;
        $[26] = hasAnchorHashToStrip;
        $[27] = hasContentTitleToStrip;
        $[28] = isIncorrectSpaceKey;
        $[29] = replace;
        $[30] = t7;
        $[31] = t8;
        $[32] = toUrl;
        $[33] = t9;
    } else t9 = $[33];
    (0, $cozmU.useEffect)(t6, t9);
    if (!contentWithSlug) return null;
    if (space && contentWithSlug.id === `${space.homepageId}` && match?.name === (0, $1NBp8.VIEW_PAGE).name) {
        let t10;
        if ($[34] !== contentWithSlug || $[35] !== match?.params || $[36] !== routePolicy) {
            t10 = !routePolicy || routePolicy.willPushInSelf((0, $1NBp8.VIEW_PAGE).name, match?.params.contentId, (0, $1NBp8.SPACE_OVERVIEW).name, contentWithSlug.id);
            $[34] = contentWithSlug;
            $[35] = match?.params;
            $[36] = routePolicy;
            $[37] = t10;
        } else t10 = $[37];
        const willPushInSelf = t10;
        let t11;
        if ($[38] !== contentWithSlug || $[39] !== willPushInSelf) {
            t11 = willPushInSelf ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
                name: (0, $1NBp8.SPACE_OVERVIEW).name,
                params: {
                    spaceKey: contentWithSlug.spaceKey,
                    contentId: contentWithSlug.id,
                    contentSlug: contentWithSlug.slug
                }
            }) : null;
            $[38] = contentWithSlug;
            $[39] = willPushInSelf;
            $[40] = t11;
        } else t11 = $[40];
        return t11;
    }
    if (!isIncorrectSpaceKey && (isIncorrectSlug || window.__DELAYED_CONTENT_REDIRECTION__?.contentSlug)) {
        const t10 = match?.name;
        const t11 = `CRC-wrongSK:${isIncorrectSpaceKey}|wrongSlug:${isIncorrectSlug}`;
        const t12 = match?.params;
        let t13;
        if ($[41] !== contentWithSlug.id || $[42] !== contentWithSlug.slug || $[43] !== contentWithSlug.spaceKey || $[44] !== t12) {
            t13 = {
                ...t12,
                spaceKey: contentWithSlug.spaceKey,
                contentId: contentWithSlug.id,
                contentSlug: contentWithSlug.slug
            };
            $[41] = contentWithSlug.id;
            $[42] = contentWithSlug.slug;
            $[43] = contentWithSlug.spaceKey;
            $[44] = t12;
            $[45] = t13;
        } else t13 = $[45];
        const t14 = Boolean(!isIncorrectSlug);
        let t15;
        if ($[46] !== t10 || $[47] !== t11 || $[48] !== t13 || $[49] !== t14) {
            t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6HckY.DelayRedirectionOnClient), {
                name: t10,
                reason: t11,
                params: t13,
                skipRouteChange: t14
            });
            $[46] = t10;
            $[47] = t11;
            $[48] = t13;
            $[49] = t14;
            $[50] = t15;
        } else t15 = $[50];
        return t15;
    }
    if (!isIncorrectSpaceKey && !isIncorrectSlug) return null;
    const t10 = match?.name;
    const t11 = `CRC-wrongSK:${isIncorrectSpaceKey}|wrongSlug:${isIncorrectSlug}`;
    const t12 = match?.params;
    let t13;
    if ($[51] !== contentWithSlug.id || $[52] !== contentWithSlug.slug || $[53] !== contentWithSlug.spaceKey || $[54] !== t12) {
        t13 = {
            ...t12,
            spaceKey: contentWithSlug.spaceKey,
            contentId: contentWithSlug.id,
            contentSlug: contentWithSlug.slug
        };
        $[51] = contentWithSlug.id;
        $[52] = contentWithSlug.slug;
        $[53] = contentWithSlug.spaceKey;
        $[54] = t12;
        $[55] = t13;
    } else t13 = $[55];
    let t14;
    if ($[56] !== t10 || $[57] !== t11 || $[58] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
            name: t10,
            reason: t11,
            params: t13
        });
        $[56] = t10;
        $[57] = t11;
        $[58] = t13;
        $[59] = t14;
    } else t14 = $[59];
    return t14;
} : ({ contentWithSlug: contentWithSlug, space: space, spaceKeyInUrl: spaceKeyInUrl, contentSlugInUrl: contentSlugInUrl = '', redirectToHideTitleSlug: redirectToHideTitleSlug })=>{
    const { match: match, replace: replace, toUrl: toUrl, getHash: getHash, getQueryParams: getQueryParams } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const { routePolicy: routePolicy } = (0, $4o1RV.useNavigationPolicy)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const shouldRedirectIncorrectSpaceKey = (0, $cozmU.useCallback)(()=>{
        if (isLivePage) /*
       * Live Pages exist on the view page route, but render the Confluence editor
       * The Confluence editor has its own space key redirection logic and move event listeners (via useSpaceKeyWatcher)
       * Consequently this redirection will clash with the redirects from the editor.
       */ return false;
        return contentWithSlug && spaceKeyInUrl !== contentWithSlug?.spaceKey;
    }, [
        spaceKeyInUrl,
        contentWithSlug,
        isLivePage
    ]);
    const shouldRedirectIncorrectSlug = (0, $cozmU.useCallback)(()=>{
        // When current slug in URL does not match with slug in content ==> slug changed
        // Important to decode when compare because react router decodes the params first
        // so contentSlug will be decoded string
        //
        // Live pages will handle its own redirection logic from content slug
        return isLivePage ? false : decodeURIComponent(contentWithSlug?.slug || '') !== decodeURIComponent(contentSlugInUrl);
    }, [
        contentWithSlug?.slug,
        contentSlugInUrl,
        isLivePage
    ]);
    const isIncorrectSlug = shouldRedirectIncorrectSlug();
    const isIncorrectSpaceKey = shouldRedirectIncorrectSpaceKey();
    const hasContentTitleToStrip = redirectToHideTitleSlug && isIncorrectSlug;
    const hasAnchorHashToStrip = redirectToHideTitleSlug && Boolean(getHash());
    // Strip the content title slug and/or heading anchor hash from the URL when the
    // hide-title-in-url setting and experiment are enabled.
    // This runs as a useEffect (rather than relying on <Redirection>) so that it fires on every navigation,
    // including revisits to pages / blogs.
    (0, $cozmU.useEffect)(()=>{
        if (!contentWithSlug || isIncorrectSpaceKey) return;
        if (!hasContentTitleToStrip && !hasAnchorHashToStrip) return;
        window['__DELAYED_CONTENT_REDIRECTION__'] = {};
        const targetUrl = toUrl(match?.name, {
            ...match?.params,
            // When hiding title from the address bar URL, also strip heading anchor hashes to avoid exposing UGC in the address bar.
            hash: undefined,
            query: getQueryParams(),
            spaceKey: contentWithSlug.spaceKey,
            contentId: contentWithSlug.id,
            contentSlug: contentWithSlug.slug
        });
        replace(targetUrl);
    }, [
        hasContentTitleToStrip,
        hasAnchorHashToStrip,
        isIncorrectSpaceKey,
        contentWithSlug,
        match?.name,
        match?.params,
        replace,
        toUrl,
        getHash,
        getQueryParams
    ]);
    // Don't redirect if we have insufficient information to successfully redirect the user
    if (!contentWithSlug) return null;
    // Do redirect if we should go back to the Space Home Overview Tab
    if (space && contentWithSlug.id === `${space.homepageId}` && match?.name === (0, $1NBp8.VIEW_PAGE).name) {
        const willPushInSelf = !routePolicy || routePolicy.willPushInSelf((0, $1NBp8.VIEW_PAGE).name, match?.params.contentId, (0, $1NBp8.SPACE_OVERVIEW).name, contentWithSlug.id);
        return willPushInSelf ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
            name: (0, $1NBp8.SPACE_OVERVIEW).name,
            params: {
                spaceKey: contentWithSlug.spaceKey,
                contentId: contentWithSlug.id,
                contentSlug: contentWithSlug.slug
            }
        }) : null;
    }
    // Incorrect slug cannot do redirection in SSR, if there is #anchor fragment in the URL,
    // it will be lost in the redirection, as #anchor fragment is not passed to the server.
    // So we need to do redirection in client side.
    // If the content slug is already fixed in PageState, but URL is incorrect, rewrite URL without
    // triggering route change.
    if (!isIncorrectSpaceKey && (isIncorrectSlug || window.__DELAYED_CONTENT_REDIRECTION__?.contentSlug)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6HckY.DelayRedirectionOnClient), {
        name: match?.name,
        reason: `CRC-wrongSK:${isIncorrectSpaceKey}|wrongSlug:${isIncorrectSlug}`,
        params: {
            ...match?.params,
            spaceKey: contentWithSlug.spaceKey,
            contentId: contentWithSlug.id,
            contentSlug: contentWithSlug.slug
        },
        skipRouteChange: Boolean(!isIncorrectSlug)
    });
    // Don't redirect if we otherwise don't need to
    if (!isIncorrectSpaceKey && !isIncorrectSlug) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        name: match?.name,
        reason: `CRC-wrongSK:${isIncorrectSpaceKey}|wrongSlug:${isIncorrectSlug}`,
        params: {
            ...match?.params,
            spaceKey: contentWithSlug.spaceKey,
            contentId: contentWithSlug.id,
            contentSlug: contentWithSlug.slug
        }
    });
});
module.exports["ContentRedirectComponent"] = $40c3e9fb4beb4b02$export$c859cd2f253879ed;

});

parcelRegister("6HckY", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kE2cJ = parcelRequire("kE2cJ");

const $aab50db669fe7470$export$9c627468834548a9 = (props)=>{
    // In client-side rendering, we can directly render the Redirection component
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), props);
};
module.exports["DelayRedirectionOnClient"] = $aab50db669fe7470$export$9c627468834548a9;

});

parcelRegister("iElL7", function(module, exports) {

var $lS0xA = parcelRequire("lS0xA");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kA6Zo = parcelRequire("kA6Zo");


var $buxP3 = parcelRequire("buxP3");


var $6Pqow = parcelRequire("6Pqow");


var $3izAL = parcelRequire("3izAL");


var $I7hWB = parcelRequire("I7hWB");


var $9DHhW = parcelRequire("9DHhW");


var $8lYIw = parcelRequire("8lYIw");


var $1NBp8 = parcelRequire("1NBp8");


var $ep3mz = parcelRequire("ep3mz");


var $jMyy4 = parcelRequire("jMyy4");

const $dc6f00ca158cde35$var$timeoutErrorStyles = (0, $buxP3.xcss)({
    margin: 'auto',
    width: '50%',
    height: '90vh'
});
const $dc6f00ca158cde35$var$timeoutErrorBorderContainerStyles = (0, $buxP3.xcss)({
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderColor: 'color.border',
    padding: 'space.500',
    borderRadius: 'radius.large'
});
const $dc6f00ca158cde35$var$headingStyles = (0, $buxP3.xcss)({
    paddingBottom: 'space.200'
});
const $dc6f00ca158cde35$var$bulletStyles = null;
const $dc6f00ca158cde35$var$i18n = (0, $kSwu1.defineMessages)({
    heading: {
        id: "content-prerequisites.timeout-error-screen.heading",
        defaultMessage: "Unable to load page"
    },
    resolutionOptions: {
        id: "content-prerequisites.timeout-error-screen.resolution-options",
        defaultMessage: "To resolve this issue, you may want to:"
    },
    reloadPage: {
        id: "content-prerequisites.timeout-error-screen.reload-page",
        defaultMessage: "Reload this page"
    },
    convertToCloudEditor: {
        id: "content-prerequisites.timeout-error-screen.convert-to-cloud-editor",
        defaultMessage: "<EditLink>Return to edit mode</EditLink> and convert to the <SACLink>cloud editor</SACLink> now"
    },
    removeMacroOrBreakPageContent: {
        id: "content-prerequisites.timeout-error-screen.remove-excerpt-macro-or-break-page-content",
        defaultMessage: "Remove one or more excerpt macros, or break this page content into several smaller pages"
    },
    contactAdmin: {
        id: "content-prerequisites.timeout-error-screen.contact-admin",
        defaultMessage: "If this keeps happening, ask your admin to contact <SupportLink>our Support team</SupportLink> and give them the URL of this page."
    }
});
const $dc6f00ca158cde35$export$f8e8c76e5ae5ca9e = ({ contentId: contentId, spaceKey: spaceKey })=>{
    const [{ contentType: contentType }] = (0, $ep3mz.usePageState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isBlogpost = contentType === 'blogpost';
    const routeType = isBlogpost ? (0, $1NBp8.EDIT_BLOG) : (0, $1NBp8.EDIT_PAGE);
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $lS0xA.default), {
        variables: {
            contentId: contentId
        },
        __callerPackage__: "content-prerequisites"
    });
    const linkParams = (0, $cozmU.useMemo)(()=>({
            contentId: contentId,
            spaceKey: spaceKey,
            contentType: isBlogpost ? 'blog' : 'pages'
        }), [
        contentId,
        spaceKey,
        isBlogpost
    ]); // If the editor property is undefined or null, we assume it's TinyMCE even though the missing missing property is not strictly TinyMCE.
    // It's okay to assume this for the purposes of this error screen b/c editor property as null is most likely TinyMCE.
    const editorProperty = data?.singleContent?.properties?.nodes?.[0]?.value;
    const isTinyMCE = !editorProperty || editorProperty === '"v1"';
    (0, $cozmU.useEffect)(()=>{
        if (isTinyMCE) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'errorScreen',
                attributes: {
                    customErrorUI: 'tinyMceTimeouts',
                    editorProperty: editorProperty
                }
            }
        })?.fire();
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isTinyMCE,
        createAnalyticsEvent
    ]);
    if (!isTinyMCE) return null;
    const editHref = routeType.toUrl(linkParams);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        xcss: $dc6f00ca158cde35$var$timeoutErrorStyles,
        direction: "column",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $dc6f00ca158cde35$var$timeoutErrorBorderContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $dc6f00ca158cde35$var$headingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "large",
        as: "h2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $dc6f00ca158cde35$var$i18n.heading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
        as: "p"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $dc6f00ca158cde35$var$i18n.resolutionOptions)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("ul", {
        className: (0, $hekY6.default)([
            "_1wydGW5zaO"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $dc6f00ca158cde35$var$i18n.reloadPage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$dc6f00ca158cde35$var$i18n.convertToCloudEditor,
        values: {
            SACLink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8lYIw.Link), {
                    target: "_blank",
                    href: "https://support.atlassian.com/confluence-cloud/docs/convert-pages-to-the-new-editor"
                }, chunks),
            EditLink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8lYIw.Link), {
                    target: "_blank",
                    href: editHref
                }, chunks)
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $dc6f00ca158cde35$var$i18n.removeMacroOrBreakPageContent))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
        as: "p"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$dc6f00ca158cde35$var$i18n.contactAdmin,
        values: {
            SupportLink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8lYIw.Link), {
                    target: "_blank",
                    href: "https://support.atlassian.com/contact/#/"
                }, chunks)
        }
    }))));
};
module.exports["TimeoutErrorScreen"] = $dc6f00ca158cde35$export$f8e8c76e5ae5ca9e;

});

parcelRegister("lS0xA", function(module, exports) {
/**
 * @generated SignedSource<<6f05060aef91edbb8530ac92dd61a679>>
 * @relayHash c72c86c38eafd81a46c0b3d86969a316
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9ffa8f11ede7fae2172b2e0f0740171fc9fa13cfe1a648392c4c5e36a4a0557a
const $82ca62ae3478d21d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "key",
                            "value": "editor"
                        }
                    ],
                    "concreteType": "PaginatedJsonContentPropertyList",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JsonContentProperty",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ],
                    "storageKey": "properties(key:\"editor\")"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "TimeoutErrorScreenQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "TimeoutErrorScreenQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "c72c86c38eafd81a46c0b3d86969a316",
            "id": "9ffa8f11ede7fae2172b2e0f0740171fc9fa13cfe1a648392c4c5e36a4a0557a",
            "metadata": {},
            "name": "TimeoutErrorScreenQuery",
            "operationKind": "query",
            "text": "query TimeoutErrorScreenQuery($contentId:ID!){singleContent(id:$contentId){id,properties(key:\"editor\"){nodes{id,key,value}}}}"
        }
    };
}();
$82ca62ae3478d21d$var$node.hash = "607b11a2ee268d24f66b7b4f714aa8ae";
var $82ca62ae3478d21d$export$2e2bcd8739ae039 = $82ca62ae3478d21d$var$node;
module.exports["default"] = $82ca62ae3478d21d$export$2e2bcd8739ae039;

});

parcelRegister("2aFNh", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7r2px = parcelRequire("7r2px");

function $73c871442f6e75aa$export$6bbd36bf45aa851e(contentBody, customPerfData) {
    const memoRef = (0, $cozmU.useRef)({
        contentBody: undefined,
        contentExtensionMetrics: undefined
    });
    if (customPerfData && (memoRef.current.contentBody !== contentBody || !('contentExtensionMetrics' in customPerfData))) {
        // `retrieveContentExtensionsMetrics` parses the ADF string into JSON, but that's likely to be only one of multiple such parsings.
        // For example, the Atlaskit editor/renderer will very likely parse the ADF string into JSON as well.
        // For large documents (e.g. 16MB) such parsing can take noticeable time which is undesirable especially before rendering.
        // This allows an alternative to `retrieveContentExtensionsMetrics` to optionally perform the computation in a more performant way.
        // But if it doesn't, `retrieveContentExtensionsMetrics` will be the fallback.
        let propertyValue;
        Object.defineProperty(customPerfData, 'contentExtensionMetrics', {
            enumerable: true,
            get () {
                if (propertyValue) return propertyValue;
                memoRef.current.contentBody = contentBody;
                const contentExtensionMetrics = contentBody ? (0, $7r2px.retrieveContentExtensionMetrics)(contentBody) : {};
                memoRef.current.contentExtensionMetrics = contentExtensionMetrics;
                return memoRef.current.contentExtensionMetrics;
            },
            set (value) {
                propertyValue = value;
            }
        });
    }
}
module.exports["useContentExtensionMetrics"] = $73c871442f6e75aa$export$6bbd36bf45aa851e;

});

parcelRegister("iuaOs", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9wGTI = parcelRequire("9wGTI");

const $53a589a30318add1$export$c86a38251c189bb6 = (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { contentId: contentId, fabricEditorSupported: fabricEditorSupported, bodyRepresentation: bodyRepresentation, reload: reload } = t0;
    const currentContentId = (0, $cozmU.useRef)(null);
    const currentFabricEditorSupportedRef = (0, $cozmU.useRef)(null);
    const currentBodyRepresentationRef = (0, $cozmU.useRef)(null);
    let t1;
    let t2;
    if ($[0] !== bodyRepresentation || $[1] !== contentId || $[2] !== fabricEditorSupported || $[3] !== reload) {
        t1 = ()=>{
            if (!(0, $9wGTI.fg)("confluence_refetch_content_on_fabric_support_chng")) return;
            if (contentId !== currentContentId.current) {
                currentContentId.current = contentId;
                currentFabricEditorSupportedRef.current = fabricEditorSupported;
                currentBodyRepresentationRef.current = bodyRepresentation;
            } else {
                if (fabricEditorSupported === null || currentFabricEditorSupportedRef.current === null || bodyRepresentation === null || currentBodyRepresentationRef.current === null) {
                    currentFabricEditorSupportedRef.current = fabricEditorSupported;
                    currentBodyRepresentationRef.current = bodyRepresentation;
                } else if (fabricEditorSupported !== currentFabricEditorSupportedRef.current || bodyRepresentation !== currentBodyRepresentationRef.current) {
                    currentFabricEditorSupportedRef.current = fabricEditorSupported;
                    currentBodyRepresentationRef.current = bodyRepresentation;
                    reload();
                }
            }
        };
        t2 = [
            contentId,
            fabricEditorSupported,
            bodyRepresentation,
            reload
        ];
        $[0] = bodyRepresentation;
        $[1] = contentId;
        $[2] = fabricEditorSupported;
        $[3] = reload;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $cozmU.useEffect)(t1, t2);
};
module.exports["useContentReloadOnFabricSupportChange"] = $53a589a30318add1$export$c86a38251c189bb6;

});

parcelRegister("4Uwwc", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $hpnxK = parcelRequire("hpnxK");


var $422HI = parcelRequire("422HI");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");

const $d0d29961fce521a3$export$b5c74b0bb5aab26a = (error, contentId, resolvedContentId)=>{
    // Never use missing content or the previous page's data to dismiss a permission failure.
    if (!error || !contentId || resolvedContentId !== contentId) return error;
    const graphQLErrors = error.graphQLErrors.filter((graphQLError)=>{
        if (graphQLError.path?.[0] === 'contentAnalyticsViewers' && (0, $1uFM6.isUnauthorizedError)(graphQLError) || (0, $hpnxK.isUnsupportedCustomerAccountFieldError)(graphQLError) && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false)) {
            (0, $7Sm4c.markErrorAsHandled)(graphQLError);
            return false;
        }
        return true;
    });
    if (graphQLErrors.length === error.graphQLErrors.length) return error;
    if (!graphQLErrors.length && !error.networkError) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return undefined;
    }
    return new (0, $422HI.ApolloErrorInterop)({
        graphQLErrors: graphQLErrors,
        networkError: error.networkError,
        extraInfo: error.extraInfo
    });
};
module.exports["getViewPageContentError"] = $d0d29961fce521a3$export$b5c74b0bb5aab26a;

});

parcelRegister("dGhsu", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $dZIWX = parcelRequire("dZIWX");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");

parcelRequire("7R8Im");
var $9XdgS = parcelRequire("9XdgS");

parcelRequire("kQRQB");
var $a3W69 = parcelRequire("a3W69");


var $jVylI = parcelRequire("jVylI");


var $zalpJ = parcelRequire("zalpJ");


var $4PPzL = parcelRequire("4PPzL");


var $3IBnw = parcelRequire("3IBnw");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $gjEAi = parcelRequire("gjEAi");


var $kygIi = parcelRequire("kygIi");


var $8zMP3 = parcelRequire("8zMP3");


var $bQm3c = parcelRequire("bQm3c");


var $1xpoY = parcelRequire("1xpoY");


var $35oAA = parcelRequire("35oAA");

const $aaeb66d37f355457$export$a5ae28e9da358c58 = (0, $dZIWX.default);
const $aaeb66d37f355457$var$ByLineWithClassificationFragment = (0, $9XdgS.ByLine);
const $aaeb66d37f355457$var$ByLineFromFragmentWithClassificationFragment = (0, $9XdgS.ByLineFromFragment);
const $aaeb66d37f355457$var$BylineCenterStyles = (0, $buxP3.xcss)({
    justifyContent: 'center'
});
const $aaeb66d37f355457$var$ApprovalBannerStyles = (0, $buxP3.xcss)({
    marginBlockEnd: 'space.200'
});
const $aaeb66d37f355457$var$styles = {
    titleAreaBannerWrapper: "_0rIjyk5zaO"
};
const $aaeb66d37f355457$var$TitleAreaBannerWrapper = (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $aaeb66d37f355457$var$styles.titleAreaBannerWrapper
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
const $aaeb66d37f355457$export$6ac99e13b8ebf390 = (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = (0, $6mKj3.UNSAFE_expValNoExposure)("confluence_ssr_byline", "isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($aaeb66d37f355457$var$ContentTitleWithByLineInner, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
            dataFetcherName: "byline-apps"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($aaeb66d37f355457$var$ContentTitleWithByLineInner, props));
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
}; // Construct the byline boundary in the hook-free composition component. Title
const $aaeb66d37f355457$var$ContentTitleWithByLineInner = (t0)=>{
    const $ = (0, $bDgLe.c)(39);
    let analyticsBylineFragmentRef;
    let byLineContributors;
    let bylineClassificationFragmentRef;
    let contentClassificationFragmentRef;
    let contentFragmentRef;
    let props;
    let reactionsContentFragmentRef;
    let titleSpaceFragmentRef;
    if ($[0] !== t0) {
        ({ contentFragmentRef: contentFragmentRef, byLineContributors: byLineContributors, titleSpaceFragmentRef: titleSpaceFragmentRef, bylineClassificationFragmentRef: bylineClassificationFragmentRef, contentClassificationFragmentRef: contentClassificationFragmentRef, reactionsContentFragmentRef: reactionsContentFragmentRef, analyticsBylineFragmentRef: analyticsBylineFragmentRef, ...props } = t0);
        $[0] = t0;
        $[1] = analyticsBylineFragmentRef;
        $[2] = byLineContributors;
        $[3] = bylineClassificationFragmentRef;
        $[4] = contentClassificationFragmentRef;
        $[5] = contentFragmentRef;
        $[6] = props;
        $[7] = reactionsContentFragmentRef;
        $[8] = titleSpaceFragmentRef;
    } else {
        analyticsBylineFragmentRef = $[1];
        byLineContributors = $[2];
        bylineClassificationFragmentRef = $[3];
        contentClassificationFragmentRef = $[4];
        contentFragmentRef = $[5];
        props = $[6];
        reactionsContentFragmentRef = $[7];
        titleSpaceFragmentRef = $[8];
    }
    if (contentFragmentRef && !(0, $1xpoY.default).isKillSwitchOn("confluence_vp_title_byline_frag_dedup") && (0, $6mKj3.expVal)("confluence_exp_vp_document", "isEnabled", false)) {
        let t1;
        if ($[9] !== analyticsBylineFragmentRef || $[10] !== byLineContributors || $[11] !== bylineClassificationFragmentRef || $[12] !== contentClassificationFragmentRef || $[13] !== props || $[14] !== reactionsContentFragmentRef) {
            t1 = (0, $6mKj3.UNSAFE_expValNoExposure)("confluence_ssr_byline", "isEnabled", false) ? (byLineFragmentRef)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
                    dataFetcherName: "byline-apps"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($aaeb66d37f355457$var$ByLineFromFragmentWithClassificationFragment, {
                    contentId: props.contentId,
                    contentFragmentRef: byLineFragmentRef,
                    contentContributors: byLineContributors,
                    bylineClassificationFragmentRef: bylineClassificationFragmentRef,
                    contentClassificationFragmentRef: contentClassificationFragmentRef,
                    reactionsContentFragmentRef: reactionsContentFragmentRef,
                    analyticsBylineFragmentRef: analyticsBylineFragmentRef,
                    hasByLineContributors: props.hasByLineContributors,
                    hasByLineExtensions: props.hasByLineExtensions,
                    shouldShowBylineReactions: props.shouldShowBylineReactions,
                    contentType: props.contentType,
                    contentSubType: props.contentSubType,
                    spaceId: props.spaceId
                })) : undefined;
            $[9] = analyticsBylineFragmentRef;
            $[10] = byLineContributors;
            $[11] = bylineClassificationFragmentRef;
            $[12] = contentClassificationFragmentRef;
            $[13] = props;
            $[14] = reactionsContentFragmentRef;
            $[15] = t1;
        } else t1 = $[15];
        let t2;
        if ($[16] !== analyticsBylineFragmentRef || $[17] !== byLineContributors || $[18] !== bylineClassificationFragmentRef || $[19] !== contentClassificationFragmentRef || $[20] !== contentFragmentRef || $[21] !== props || $[22] !== reactionsContentFragmentRef || $[23] !== t1 || $[24] !== titleSpaceFragmentRef) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($aaeb66d37f355457$var$ContentTitleWithByLineFragmentReader, {
                ...props,
                contentFragmentRef: contentFragmentRef,
                byLineContributors: byLineContributors,
                titleSpaceFragmentRef: titleSpaceFragmentRef,
                bylineClassificationFragmentRef: bylineClassificationFragmentRef,
                contentClassificationFragmentRef: contentClassificationFragmentRef,
                reactionsContentFragmentRef: reactionsContentFragmentRef,
                analyticsBylineFragmentRef: analyticsBylineFragmentRef,
                renderByLine: t1
            });
            $[16] = analyticsBylineFragmentRef;
            $[17] = byLineContributors;
            $[18] = bylineClassificationFragmentRef;
            $[19] = contentClassificationFragmentRef;
            $[20] = contentFragmentRef;
            $[21] = props;
            $[22] = reactionsContentFragmentRef;
            $[23] = t1;
            $[24] = titleSpaceFragmentRef;
            $[25] = t2;
        } else t2 = $[25];
        return t2;
    }
    let t1;
    if ($[26] !== analyticsBylineFragmentRef || $[27] !== bylineClassificationFragmentRef || $[28] !== contentClassificationFragmentRef || $[29] !== props || $[30] !== reactionsContentFragmentRef) {
        t1 = (0, $6mKj3.UNSAFE_expValNoExposure)("confluence_ssr_byline", "isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
            dataFetcherName: "byline-apps"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($aaeb66d37f355457$var$ContentByLineQuery, {
            ...props,
            bylineClassificationFragmentRef: bylineClassificationFragmentRef,
            contentClassificationFragmentRef: contentClassificationFragmentRef,
            reactionsContentFragmentRef: reactionsContentFragmentRef,
            analyticsBylineFragmentRef: analyticsBylineFragmentRef
        })) : undefined;
        $[26] = analyticsBylineFragmentRef;
        $[27] = bylineClassificationFragmentRef;
        $[28] = contentClassificationFragmentRef;
        $[29] = props;
        $[30] = reactionsContentFragmentRef;
        $[31] = t1;
    } else t1 = $[31];
    let t2;
    if ($[32] !== analyticsBylineFragmentRef || $[33] !== bylineClassificationFragmentRef || $[34] !== contentClassificationFragmentRef || $[35] !== props || $[36] !== reactionsContentFragmentRef || $[37] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($aaeb66d37f355457$var$ContentTitleWithByLineQuery, {
            ...props,
            bylineClassificationFragmentRef: bylineClassificationFragmentRef,
            contentClassificationFragmentRef: contentClassificationFragmentRef,
            reactionsContentFragmentRef: reactionsContentFragmentRef,
            analyticsBylineFragmentRef: analyticsBylineFragmentRef,
            byLine: t1
        });
        $[32] = analyticsBylineFragmentRef;
        $[33] = bylineClassificationFragmentRef;
        $[34] = contentClassificationFragmentRef;
        $[35] = props;
        $[36] = reactionsContentFragmentRef;
        $[37] = t1;
        $[38] = t2;
    } else t2 = $[38];
    return t2;
};
const $aaeb66d37f355457$var$ContentByLineQuery = (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { contentId: contentId, hasByLineContributors: hasByLineContributors, hasByLineExtensions: hasByLineExtensions, shouldShowBylineReactions: shouldShowBylineReactions, contentSubType: contentSubType, spaceId: spaceId, bylineClassificationFragmentRef: bylineClassificationFragmentRef, contentClassificationFragmentRef: contentClassificationFragmentRef, reactionsContentFragmentRef: reactionsContentFragmentRef, analyticsBylineFragmentRef: analyticsBylineFragmentRef, contentType: contentType } = t0;
    const { versionOverride: versionOverride, embeddedContentRender: embeddedContentRender } = (0, $35oAA.useViewPageParams)();
    let t1;
    if ($[0] !== analyticsBylineFragmentRef || $[1] !== bylineClassificationFragmentRef || $[2] !== contentClassificationFragmentRef || $[3] !== contentId || $[4] !== contentSubType || $[5] !== contentType || $[6] !== embeddedContentRender || $[7] !== hasByLineContributors || $[8] !== hasByLineExtensions || $[9] !== reactionsContentFragmentRef || $[10] !== shouldShowBylineReactions || $[11] !== spaceId || $[12] !== versionOverride) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($aaeb66d37f355457$var$ByLineWithClassificationFragment, {
            contentId: contentId,
            versionOverride: versionOverride,
            embeddedContentRender: embeddedContentRender,
            hasByLineContributors: hasByLineContributors,
            hasByLineExtensions: hasByLineExtensions,
            shouldShowBylineReactions: shouldShowBylineReactions,
            contentType: contentType,
            contentSubType: contentSubType,
            spaceId: spaceId,
            bylineClassificationFragmentRef: bylineClassificationFragmentRef,
            contentClassificationFragmentRef: contentClassificationFragmentRef,
            reactionsContentFragmentRef: reactionsContentFragmentRef,
            analyticsBylineFragmentRef: analyticsBylineFragmentRef
        });
        $[0] = analyticsBylineFragmentRef;
        $[1] = bylineClassificationFragmentRef;
        $[2] = contentClassificationFragmentRef;
        $[3] = contentId;
        $[4] = contentSubType;
        $[5] = contentType;
        $[6] = embeddedContentRender;
        $[7] = hasByLineContributors;
        $[8] = hasByLineExtensions;
        $[9] = reactionsContentFragmentRef;
        $[10] = shouldShowBylineReactions;
        $[11] = spaceId;
        $[12] = versionOverride;
        $[13] = t1;
    } else t1 = $[13];
    return t1;
};
const $aaeb66d37f355457$var$ContentTitleWithByLineQuery = (t0)=>{
    const $ = (0, $bDgLe.c)(39);
    const { contentId: contentId, spaceKey: spaceKey, banner: banner, headingContainer: headingContainer, hasCoverPicture: hasCoverPicture, pageWidthType: pageWidthType, isEmbeddedPage: isEmbeddedPage, contentType: contentType, meetingNotesAutomationDiscoveryFragmentRef: meetingNotesAutomationDiscoveryFragmentRef, hasByLineContributors: hasByLineContributors, hasByLineExtensions: hasByLineExtensions, shouldShowBylineReactions: shouldShowBylineReactions, contentSubType: contentSubType, spaceId: spaceId, bylineClassificationFragmentRef: bylineClassificationFragmentRef, contentClassificationFragmentRef: contentClassificationFragmentRef, reactionsContentFragmentRef: reactionsContentFragmentRef, analyticsBylineFragmentRef: analyticsBylineFragmentRef, byLine: byLine, hasByLine: t1 } = t0;
    const hasByLine = t1 === undefined ? true : t1;
    const { versionOverride: versionOverride, embeddedContentRender: embeddedContentRender } = (0, $35oAA.useViewPageParams)();
    const { isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    let t2;
    if ($[0] !== contentType || $[1] !== isEmbeddedPage || $[2] !== isRovoLLMEnabled) {
        t2 = isRovoLLMEnabled && contentType === "page" && !isEmbeddedPage && (0, $9wGTI.fg)("cc_automations_discovery_nudges");
        $[0] = contentType;
        $[1] = isEmbeddedPage;
        $[2] = isRovoLLMEnabled;
        $[3] = t2;
    } else t2 = $[3];
    const shouldRenderMeetingNotesAutomationDiscovery = t2;
    let t3;
    if ($[4] !== contentId) {
        t3 = {
            contentId: contentId
        };
        $[4] = contentId;
        $[5] = t3;
    } else t3 = $[5];
    const { titleContentProperties: titleContentProperties } = (0, $zalpJ.useTitleContentPropertiesForPublishedPage)(t3);
    const isBylineCenterStyles = titleContentProperties?.titleLayoutAlignment == (0, $jVylI.TitleAlignmentType).CENTER;
    const t4 = isBylineCenterStyles && $aaeb66d37f355457$var$BylineCenterStyles;
    let t5;
    if ($[6] !== t4) {
        t5 = [
            t4
        ];
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    const t6 = isBylineCenterStyles ? "centered-content-title-and-byline" : "content-title-and-byline";
    let t7;
    if ($[8] !== analyticsBylineFragmentRef || $[9] !== byLine || $[10] !== bylineClassificationFragmentRef || $[11] !== contentClassificationFragmentRef || $[12] !== contentId || $[13] !== contentSubType || $[14] !== contentType || $[15] !== embeddedContentRender || $[16] !== hasByLine || $[17] !== hasByLineContributors || $[18] !== hasByLineExtensions || $[19] !== meetingNotesAutomationDiscoveryFragmentRef || $[20] !== reactionsContentFragmentRef || $[21] !== shouldRenderMeetingNotesAutomationDiscovery || $[22] !== shouldShowBylineReactions || $[23] !== spaceId || $[24] !== versionOverride) {
        t7 = hasByLine && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, byLine ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($aaeb66d37f355457$var$ByLineWithClassificationFragment, {
            contentId: contentId,
            versionOverride: versionOverride,
            embeddedContentRender: embeddedContentRender,
            hasByLineContributors: hasByLineContributors,
            hasByLineExtensions: hasByLineExtensions,
            shouldShowBylineReactions: shouldShowBylineReactions,
            contentType: contentType,
            contentSubType: contentSubType,
            spaceId: spaceId,
            bylineClassificationFragmentRef: bylineClassificationFragmentRef,
            contentClassificationFragmentRef: contentClassificationFragmentRef,
            reactionsContentFragmentRef: reactionsContentFragmentRef,
            analyticsBylineFragmentRef: analyticsBylineFragmentRef
        }), (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $aaeb66d37f355457$var$ApprovalBannerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gjEAi.ApprovalBanner), null))), shouldRenderMeetingNotesAutomationDiscovery && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kygIi.LazyMeetingNotesAutomationDiscoveryFragment), {
            contentFragmentRef: meetingNotesAutomationDiscoveryFragmentRef,
            postOfficePlacementId: "confluence-view-page-title-area-banner",
            WrapperComponent: $aaeb66d37f355457$var$TitleAreaBannerWrapper
        }));
        $[8] = analyticsBylineFragmentRef;
        $[9] = byLine;
        $[10] = bylineClassificationFragmentRef;
        $[11] = contentClassificationFragmentRef;
        $[12] = contentId;
        $[13] = contentSubType;
        $[14] = contentType;
        $[15] = embeddedContentRender;
        $[16] = hasByLine;
        $[17] = hasByLineContributors;
        $[18] = hasByLineExtensions;
        $[19] = meetingNotesAutomationDiscoveryFragmentRef;
        $[20] = reactionsContentFragmentRef;
        $[21] = shouldRenderMeetingNotesAutomationDiscovery;
        $[22] = shouldShowBylineReactions;
        $[23] = spaceId;
        $[24] = versionOverride;
        $[25] = t7;
    } else t7 = $[25];
    let t8;
    if ($[26] !== t5 || $[27] !== t6 || $[28] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: t5,
            testId: t6
        }, t7);
        $[26] = t5;
        $[27] = t6;
        $[28] = t7;
        $[29] = t8;
    } else t8 = $[29];
    let t9;
    if ($[30] !== banner || $[31] !== contentId || $[32] !== hasCoverPicture || $[33] !== headingContainer || $[34] !== isEmbeddedPage || $[35] !== pageWidthType || $[36] !== spaceKey || $[37] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a3W69.ContentTitle), {
            banner: banner,
            contentId: contentId,
            spaceKey: spaceKey,
            headingContainer: headingContainer,
            hasCoverPicture: hasCoverPicture,
            pageWidthType: pageWidthType,
            isEmbeddedPage: isEmbeddedPage
        }, t8);
        $[30] = banner;
        $[31] = contentId;
        $[32] = hasCoverPicture;
        $[33] = headingContainer;
        $[34] = isEmbeddedPage;
        $[35] = pageWidthType;
        $[36] = spaceKey;
        $[37] = t8;
        $[38] = t9;
    } else t9 = $[38];
    return t9;
};
const $aaeb66d37f355457$var$ContentTitleWithByLineFragmentReader = (t0)=>{
    const $ = (0, $bDgLe.c)(43);
    const { contentFragmentRef: contentFragmentRef, titleSpaceFragmentRef: titleSpaceFragmentRef, contentId: contentId, spaceKey: spaceKey, banner: banner, headingContainer: headingContainer, hasCoverPicture: hasCoverPicture, pageWidthType: pageWidthType, isEmbeddedPage: isEmbeddedPage, contentType: contentType, byLineContributors: byLineContributors, hasByLineContributors: hasByLineContributors, hasByLineExtensions: hasByLineExtensions, shouldShowBylineReactions: shouldShowBylineReactions, contentSubType: contentSubType, spaceId: spaceId, bylineClassificationFragmentRef: bylineClassificationFragmentRef, contentClassificationFragmentRef: contentClassificationFragmentRef, reactionsContentFragmentRef: reactionsContentFragmentRef, analyticsBylineFragmentRef: analyticsBylineFragmentRef, renderByLine: renderByLine, hasByLine: t1 } = t0;
    const hasByLine = t1 === undefined ? true : t1;
    const content = (0, $6SsN4.useFragment)($aaeb66d37f355457$export$a5ae28e9da358c58, contentFragmentRef);
    const { isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    let t2;
    if ($[0] !== contentType || $[1] !== isEmbeddedPage || $[2] !== isRovoLLMEnabled) {
        t2 = isRovoLLMEnabled && contentType === "page" && !isEmbeddedPage && (0, $9wGTI.fg)("cc_automations_discovery_nudges");
        $[0] = contentType;
        $[1] = isEmbeddedPage;
        $[2] = isRovoLLMEnabled;
        $[3] = t2;
    } else t2 = $[3];
    const shouldRenderMeetingNotesAutomationDiscovery = t2;
    let t3;
    if ($[4] !== content) {
        t3 = (0, $zalpJ.getTitleContentProperty)({
            content: {
                nodes: [
                    content
                ]
            }
        });
        $[4] = content;
        $[5] = t3;
    } else t3 = $[5];
    const { titleContentProperties: titleContentProperties } = t3;
    let t4;
    if ($[6] !== banner || $[7] !== content) {
        t4 = /*#__PURE__*/ (0, $cozmU.isValidElement)(banner) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(banner, {
            contentFragmentRef: content
        }) : banner;
        $[6] = banner;
        $[7] = content;
        $[8] = t4;
    } else t4 = $[8];
    const bannerWithContentFragmentRef = t4;
    const isBylineCenterStyles = titleContentProperties?.titleLayoutAlignment == (0, $jVylI.TitleAlignmentType).CENTER;
    const t5 = isBylineCenterStyles && $aaeb66d37f355457$var$BylineCenterStyles;
    let t6;
    if ($[9] !== t5) {
        t6 = [
            t5
        ];
        $[9] = t5;
        $[10] = t6;
    } else t6 = $[10];
    const t7 = isBylineCenterStyles ? "centered-content-title-and-byline" : "content-title-and-byline";
    let t8;
    if ($[11] !== analyticsBylineFragmentRef || $[12] !== byLineContributors || $[13] !== bylineClassificationFragmentRef || $[14] !== content || $[15] !== contentClassificationFragmentRef || $[16] !== contentId || $[17] !== contentSubType || $[18] !== contentType || $[19] !== hasByLine || $[20] !== hasByLineContributors || $[21] !== hasByLineExtensions || $[22] !== reactionsContentFragmentRef || $[23] !== renderByLine || $[24] !== shouldRenderMeetingNotesAutomationDiscovery || $[25] !== shouldShowBylineReactions || $[26] !== spaceId) {
        t8 = hasByLine && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, renderByLine ? renderByLine(content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($aaeb66d37f355457$var$ByLineFromFragmentWithClassificationFragment, {
            contentId: contentId,
            contentFragmentRef: content,
            bylineClassificationFragmentRef: bylineClassificationFragmentRef,
            contentContributors: byLineContributors,
            contentClassificationFragmentRef: contentClassificationFragmentRef,
            reactionsContentFragmentRef: reactionsContentFragmentRef,
            analyticsBylineFragmentRef: analyticsBylineFragmentRef,
            hasByLineContributors: hasByLineContributors,
            hasByLineExtensions: hasByLineExtensions,
            shouldShowBylineReactions: shouldShowBylineReactions,
            contentType: contentType,
            contentSubType: contentSubType,
            spaceId: spaceId
        }), (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $aaeb66d37f355457$var$ApprovalBannerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gjEAi.ApprovalBanner), null))), shouldRenderMeetingNotesAutomationDiscovery && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kygIi.LazyMeetingNotesAutomationDiscoveryFragment), {
            contentFragmentRef: content,
            postOfficePlacementId: "confluence-view-page-title-area-banner",
            WrapperComponent: $aaeb66d37f355457$var$TitleAreaBannerWrapper
        }));
        $[11] = analyticsBylineFragmentRef;
        $[12] = byLineContributors;
        $[13] = bylineClassificationFragmentRef;
        $[14] = content;
        $[15] = contentClassificationFragmentRef;
        $[16] = contentId;
        $[17] = contentSubType;
        $[18] = contentType;
        $[19] = hasByLine;
        $[20] = hasByLineContributors;
        $[21] = hasByLineExtensions;
        $[22] = reactionsContentFragmentRef;
        $[23] = renderByLine;
        $[24] = shouldRenderMeetingNotesAutomationDiscovery;
        $[25] = shouldShowBylineReactions;
        $[26] = spaceId;
        $[27] = t8;
    } else t8 = $[27];
    let t9;
    if ($[28] !== t6 || $[29] !== t7 || $[30] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: t6,
            testId: t7
        }, t8);
        $[28] = t6;
        $[29] = t7;
        $[30] = t8;
        $[31] = t9;
    } else t9 = $[31];
    let t10;
    if ($[32] !== bannerWithContentFragmentRef || $[33] !== content || $[34] !== contentId || $[35] !== hasCoverPicture || $[36] !== headingContainer || $[37] !== isEmbeddedPage || $[38] !== pageWidthType || $[39] !== spaceKey || $[40] !== t9 || $[41] !== titleSpaceFragmentRef) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a3W69.ContentTitleFromFragment), {
            banner: bannerWithContentFragmentRef,
            contentId: contentId,
            spaceKey: spaceKey,
            headingContainer: headingContainer,
            hasCoverPicture: hasCoverPicture,
            pageWidthType: pageWidthType,
            isEmbeddedPage: isEmbeddedPage,
            contentFragmentRef: content,
            spaceFragmentRef: titleSpaceFragmentRef
        }, t9);
        $[32] = bannerWithContentFragmentRef;
        $[33] = content;
        $[34] = contentId;
        $[35] = hasCoverPicture;
        $[36] = headingContainer;
        $[37] = isEmbeddedPage;
        $[38] = pageWidthType;
        $[39] = spaceKey;
        $[40] = t9;
        $[41] = titleSpaceFragmentRef;
        $[42] = t10;
    } else t10 = $[42];
    return t10;
};
module.exports["ContentTitleWithByLine"] = $aaeb66d37f355457$export$6ac99e13b8ebf390;

});

parcelRegister("dZIWX", function(module, exports) {
/**
 * @generated SignedSource<<662cb69c38d7d9eb20e64b514bde7e8f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $95f197b43e539c4a$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "useNewContentTopper",
        "variableName": "useNewContentTopper"
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includeConnectionAncestors"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "useNewContentTopper"
            }
        ],
        "kind": "Fragment",
        "name": "ContentTitleWithByLine_content",
        "selections": [
            {
                "args": [
                    v0 /*: any*/ 
                ],
                "kind": "FragmentSpread",
                "name": "ContentTitle_content"
            },
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "includeConnectionAncestors",
                        "variableName": "includeConnectionAncestors"
                    },
                    v0 /*: any*/ 
                ],
                "kind": "FragmentSpread",
                "name": "ByLine_content"
            },
            {
                "kind": "FragmentSpread",
                "name": "ArchivedPageBannerV2Status_content"
            },
            {
                "kind": "FragmentSpread",
                "name": "MeetingNotesAutomationDiscoveryFragment_content"
            }
        ],
        "type": "Content"
    };
}();
$95f197b43e539c4a$var$node.hash = "91555ecdfbb0de4b8c123665e7056de8";
var $95f197b43e539c4a$export$2e2bcd8739ae039 = $95f197b43e539c4a$var$node;
module.exports["default"] = $95f197b43e539c4a$export$2e2bcd8739ae039;

});

parcelRegister("7R8Im", function(module, exports) {
$parcel$export(module.exports, "ByLine", () => (parcelRequire("9XdgS")).ByLine);
$parcel$export(module.exports, "ByLineFromFragment", () => (parcelRequire("9XdgS")).ByLineFromFragment);

var $9XdgS = parcelRequire("9XdgS");


});

parcelRegister("9XdgS", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $daVgg = parcelRequire("daVgg");


var $kSpAb = parcelRequire("kSpAb");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $9DHhW = parcelRequire("9DHhW");


var $kvJHJ = parcelRequire("kvJHJ");


var $7boqA = parcelRequire("7boqA");


var $zalpJ = parcelRequire("zalpJ");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $4PPzL = parcelRequire("4PPzL");


var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");


var $dnfJM = parcelRequire("dnfJM");


var $jjv3l = parcelRequire("jjv3l");


var $7Sm4c = parcelRequire("7Sm4c");


var $ep3mz = parcelRequire("ep3mz");


var $c0urc = parcelRequire("c0urc");

var $1SNEF = parcelRequire("1SNEF");


var $jMyy4 = parcelRequire("jMyy4");


var $6mKj3 = parcelRequire("6mKj3");


var $fxLAA = parcelRequire("fxLAA");


var $80xNa = parcelRequire("80xNa");


var $fabPv = parcelRequire("fabPv");


var $hlP5l = parcelRequire("hlP5l");


var $4J61X = parcelRequire("4J61X");


var $83fWZ = parcelRequire("83fWZ");


var $2gstp = parcelRequire("2gstp");


var $6lbeL = parcelRequire("6lbeL");


var $cI2rq = parcelRequire("cI2rq");

const $0559514361f7ee96$export$f2d7ca777241edb7 = (0, $kSpAb.default);
const $0559514361f7ee96$export$4aabfa7af1f71de0 = (0, $daVgg.default);
// WARN: This is temporary code to send analytics event when we would crash the part
// of the ByLine experience when byline user is undefined due to any reason.
// This is done as part of https://ops.internal.atlassian.com/jira/browse/HOT-106424
// investigation. This code should be removed once we know the root cause/impact.
const $0559514361f7ee96$var$HOT106424Tracker = (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { content: content, contentId: contentId, contentContributors: contentContributors, isExternalShareRequest: isExternalShareRequest } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    if ($[0] !== content || $[1] !== contentContributors?.nodes || $[2] !== contentId || $[3] !== createAnalyticsEvent || $[4] !== isExternalShareRequest) {
        t1 = ()=>{
            const byUser = content?.version?.by;
            const createdBy = content?.history?.createdBy;
            const hasEmptyContributors = (contentContributors?.nodes || []).some($0559514361f7ee96$var$_temp);
            const contentHistory = content?.history;
            const createdDate = content?.history?.createdDate;
            if (hasEmptyContributors || !createdBy || !byUser) createAnalyticsEvent({
                type: "sendOperationalEvent",
                data: {
                    source: "byLine",
                    action: "byLineUserEmpty",
                    actionSubject: "content",
                    attributes: {
                        contentId: contentId,
                        isExternalShareRequest: isExternalShareRequest,
                        hasEmptyContributors: hasEmptyContributors,
                        hasCreatedBy: Boolean(createdBy),
                        hasByUser: Boolean(byUser),
                        hasContent: Boolean(content),
                        hasHistory: Boolean(contentHistory),
                        hasCreatedDate: Boolean(createdDate)
                    }
                }
            }).fire();
        };
        $[0] = content;
        $[1] = contentContributors?.nodes;
        $[2] = contentId;
        $[3] = createAnalyticsEvent;
        $[4] = isExternalShareRequest;
        $[5] = t1;
    } else t1 = $[5];
    let t2;
    if ($[6] !== content || $[7] !== contentContributors || $[8] !== contentId || $[9] !== createAnalyticsEvent || $[10] !== isExternalShareRequest) {
        t2 = [
            content,
            contentId,
            contentContributors,
            createAnalyticsEvent,
            isExternalShareRequest
        ];
        $[6] = content;
        $[7] = contentContributors;
        $[8] = contentId;
        $[9] = createAnalyticsEvent;
        $[10] = isExternalShareRequest;
        $[11] = t2;
    } else t2 = $[11];
    (0, $cozmU.useEffect)(t1, t2);
    return null;
};
const $0559514361f7ee96$export$3da174e1e9f9b5b4 = (t0)=>{
    const $ = (0, $bDgLe.c)(71);
    let analyticsBylineFragmentRef;
    let bylineClassificationFragmentRef;
    let contentClassificationFragmentRef;
    let contentContributors;
    let contentFragmentRef;
    let contentId;
    let contentSubType;
    let contentType;
    let passThroughProps;
    let reactionsContentFragmentRef;
    let shouldShowBylineReactions;
    let spaceId;
    if ($[0] !== t0) {
        ({ contentFragmentRef: contentFragmentRef, contentContributors: contentContributors, contentId: contentId, shouldShowBylineReactions: shouldShowBylineReactions, contentType: contentType, spaceId: spaceId, contentSubType: contentSubType, bylineClassificationFragmentRef: bylineClassificationFragmentRef, contentClassificationFragmentRef: contentClassificationFragmentRef, reactionsContentFragmentRef: reactionsContentFragmentRef, analyticsBylineFragmentRef: analyticsBylineFragmentRef, ...passThroughProps } = t0);
        $[0] = t0;
        $[1] = analyticsBylineFragmentRef;
        $[2] = bylineClassificationFragmentRef;
        $[3] = contentClassificationFragmentRef;
        $[4] = contentContributors;
        $[5] = contentFragmentRef;
        $[6] = contentId;
        $[7] = contentSubType;
        $[8] = contentType;
        $[9] = passThroughProps;
        $[10] = reactionsContentFragmentRef;
        $[11] = shouldShowBylineReactions;
        $[12] = spaceId;
    } else {
        analyticsBylineFragmentRef = $[1];
        bylineClassificationFragmentRef = $[2];
        contentClassificationFragmentRef = $[3];
        contentContributors = $[4];
        contentFragmentRef = $[5];
        contentId = $[6];
        contentSubType = $[7];
        contentType = $[8];
        passThroughProps = $[9];
        reactionsContentFragmentRef = $[10];
        shouldShowBylineReactions = $[11];
        spaceId = $[12];
    }
    const content = (0, $6SsN4.useFragment)($0559514361f7ee96$export$f2d7ca777241edb7, contentFragmentRef);
    const bylineAppContentProperties = (0, $cI2rq.useBylineAppContentProperties)(contentId);
    const contentContributorsData = (0, $6SsN4.useFragment)($0559514361f7ee96$export$4aabfa7af1f71de0, contentContributors ?? null);
    if (!content) return null;
    const t1 = content.history?.createdBy;
    let t2;
    if ($[13] !== t1) {
        t2 = (0, $83fWZ.toUserProps)(t1);
        $[13] = t1;
        $[14] = t2;
    } else t2 = $[14];
    const author = t2;
    let t3;
    if ($[15] !== content.history?.ownedBy || $[16] !== content.type) {
        t3 = content.history?.ownedBy && (content.type === "page" || content.type === "blogpost") ? (0, $83fWZ.toUserProps)(content.history?.ownedBy) : null;
        $[15] = content.history?.ownedBy;
        $[16] = content.type;
        $[17] = t3;
    } else t3 = $[17];
    const owner = t3;
    const t4 = content.version?.by;
    let t5;
    if ($[18] !== t4) {
        t5 = (0, $83fWZ.toUserProps)(t4);
        $[18] = t4;
        $[19] = t5;
    } else t5 = $[19];
    const by = t5;
    const contributorsCount = contentContributorsData?.count || 0;
    const isOwnerContributor = contentContributorsData?.isOwnerContributor || false;
    let t6;
    if ($[20] !== content.editorProperty?.nodes) {
        const editorVersion = content.editorProperty?.nodes?.find($0559514361f7ee96$var$_temp2);
        t6 = editorVersion?.value?.includes("v2") || false;
        $[20] = content.editorProperty?.nodes;
        $[21] = t6;
    } else t6 = $[21];
    const isFabricPage = t6;
    let t7;
    if ($[22] !== content) {
        t7 = (0, $zalpJ.getTitleContentProperty)({
            content: {
                nodes: [
                    content
                ]
            }
        });
        $[22] = content;
        $[23] = t7;
    } else t7 = $[23];
    const { titleContentProperties: titleContentProperties } = t7;
    const generatedBy = content.contentProperties?.latest?.generatedBy;
    let t8;
    let t9;
    if ($[24] !== contentId) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
            name: (0, $irVI7.VIEW_PAGE_BYLINE_EXPERIENCE),
            id: contentId
        });
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
            key: contentId,
            metric: (0, $hlP5l.BYLINE_METRIC)
        });
        $[24] = contentId;
        $[25] = t8;
        $[26] = t9;
    } else {
        t8 = $[25];
        t9 = $[26];
    }
    const t10 = content.ancestors ?? null;
    const t11 = content.history?.createdDate || null;
    const t12 = content.version?.friendlyWhen || "";
    const t13 = content.version?.when || null;
    const t14 = Number(content.version?.number || "");
    const t15 = content.version?.contentTypeModified || false;
    let t16;
    if ($[27] !== by || $[28] !== t12 || $[29] !== t13 || $[30] !== t14 || $[31] !== t15) {
        t16 = {
            friendlyWhen: t12,
            when: t13,
            number: t14,
            by: by,
            contentTypeModified: t15
        };
        $[27] = by;
        $[28] = t12;
        $[29] = t13;
        $[30] = t14;
        $[31] = t15;
        $[32] = t16;
    } else t16 = $[32];
    let t17;
    if ($[33] !== analyticsBylineFragmentRef || $[34] !== author || $[35] !== bylineAppContentProperties || $[36] !== bylineClassificationFragmentRef || $[37] !== content || $[38] !== contentClassificationFragmentRef || $[39] !== contentId || $[40] !== contentSubType || $[41] !== contentType || $[42] !== contributorsCount || $[43] !== generatedBy || $[44] !== isFabricPage || $[45] !== isOwnerContributor || $[46] !== owner || $[47] !== passThroughProps || $[48] !== reactionsContentFragmentRef || $[49] !== shouldShowBylineReactions || $[50] !== spaceId || $[51] !== t10 || $[52] !== t11 || $[53] !== t16 || $[54] !== titleContentProperties) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2gstp.ByLineWithContributorsComponent), {
            contentId: contentId,
            author: author,
            owner: owner,
            contributorsCount: contributorsCount,
            isOwnerContributor: isOwnerContributor,
            isFabricPage: isFabricPage,
            shouldShowBylineReactions: shouldShowBylineReactions,
            contentSubType: contentSubType,
            spaceId: spaceId,
            contentType: contentType,
            titleContentProperties: titleContentProperties,
            generatedBy: generatedBy,
            connectionAncestors: t10,
            createdDate: t11,
            contentFragmentRef: content,
            bylineClassificationFragmentRef: bylineClassificationFragmentRef,
            contentClassificationFragmentRef: contentClassificationFragmentRef,
            reactionsContentFragmentRef: reactionsContentFragmentRef,
            analyticsBylineFragmentRef: analyticsBylineFragmentRef,
            bylineAppContentProperties: bylineAppContentProperties,
            version: t16,
            ...passThroughProps
        });
        $[33] = analyticsBylineFragmentRef;
        $[34] = author;
        $[35] = bylineAppContentProperties;
        $[36] = bylineClassificationFragmentRef;
        $[37] = content;
        $[38] = contentClassificationFragmentRef;
        $[39] = contentId;
        $[40] = contentSubType;
        $[41] = contentType;
        $[42] = contributorsCount;
        $[43] = generatedBy;
        $[44] = isFabricPage;
        $[45] = isOwnerContributor;
        $[46] = owner;
        $[47] = passThroughProps;
        $[48] = reactionsContentFragmentRef;
        $[49] = shouldShowBylineReactions;
        $[50] = spaceId;
        $[51] = t10;
        $[52] = t11;
        $[53] = t16;
        $[54] = titleContentProperties;
        $[55] = t17;
    } else t17 = $[55];
    let t18;
    if ($[56] !== contributorsCount) {
        t18 = {
            contributorsCount: contributorsCount
        };
        $[56] = contributorsCount;
        $[57] = t18;
    } else t18 = $[57];
    let t19;
    if ($[58] !== contentId || $[59] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
            key: contentId,
            metric: (0, $hlP5l.BYLINE_METRIC),
            customData: t18
        });
        $[58] = contentId;
        $[59] = t18;
        $[60] = t19;
    } else t19 = $[60];
    let t20;
    if ($[61] !== content || $[62] !== contentContributorsData || $[63] !== contentId) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0559514361f7ee96$var$HOT106424Tracker, {
            content: content,
            contentId: contentId,
            contentContributors: contentContributorsData,
            isExternalShareRequest: false
        });
        $[61] = content;
        $[62] = contentContributorsData;
        $[63] = contentId;
        $[64] = t20;
    } else t20 = $[64];
    let t21;
    if ($[65] !== t17 || $[66] !== t19 || $[67] !== t20 || $[68] !== t8 || $[69] !== t9) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).BACKBONE
        }, t8, t9, t17, t19, t20);
        $[65] = t17;
        $[66] = t19;
        $[67] = t20;
        $[68] = t8;
        $[69] = t9;
        $[70] = t21;
    } else t21 = $[70];
    return t21;
};
const $0559514361f7ee96$export$3b7993d3cbe5f289 = (t0)=>{
    const $ = (0, $bDgLe.c)(26);
    const { contentId: contentId, versionOverride: versionOverride, embeddedContentRender: embeddedContentRender, shouldShowBylineReactions: shouldShowBylineReactions, contentType: contentType, spaceId: spaceId, contentSubType: contentSubType, bylineClassificationFragmentRef: bylineClassificationFragmentRef, contentClassificationFragmentRef: contentClassificationFragmentRef, reactionsContentFragmentRef: reactionsContentFragmentRef, analyticsBylineFragmentRef: analyticsBylineFragmentRef, ...passThroughProps } = t0;
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const isRestrictedExternalShare = (0, $jjv3l.useIsRestrictedExternalShareRequest)();
    const isAccessLinkRequest = (0, $dnfJM.useIsAccessLinkRequest)();
    const bylineAppContentProperties = (0, $cI2rq.useBylineAppContentProperties)(contentId, !isRestrictedExternalShare);
    const t1 = versionOverride || null;
    const t2 = embeddedContentRender || null;
    let t3;
    let t4;
    let t5;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $6mKj3.expValEquals)("cc-markdown-mode", "isEnabled", true);
        t4 = (0, $6mKj3.expValEquals)("confluence_classification_level_v2", "isEnabled", true) ? {
            useClassificationLevelV2: true
        } : {};
        t5 = (0, $6mKj3.isExperimentEnabled)("confluence_1p_and_3p_connection_byline_experiment");
        $[0] = t3;
        $[1] = t4;
        $[2] = t5;
    } else {
        t3 = $[0];
        t4 = $[1];
        t5 = $[2];
    }
    let t6;
    if ($[3] !== contentId || $[4] !== spaceKey || $[5] !== t1 || $[6] !== t2) {
        t6 = {
            contentId: contentId,
            spaceKey: spaceKey,
            versionOverride: t1,
            embeddedContentRender: t2,
            limit: (0, $80xNa.DEFAULT_CONTRIBUTORS_FETCH_LIMIT),
            useNewContentTopper: true,
            isMarkdownModeEnabled: t3,
            ...t4,
            includeDevDocsBylineConnection: t5
        };
        $[3] = contentId;
        $[4] = spaceKey;
        $[5] = t1;
        $[6] = t2;
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = {
            allowOnExternalPage: true,
            single: true
        };
        $[8] = t7;
    } else t7 = $[8];
    let t8;
    if ($[9] !== t6) {
        t8 = {
            variables: t6,
            context: t7,
            errorPolicy: "all"
        };
        $[9] = t6;
        $[10] = t8;
    } else t8 = $[10];
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $jMyy4.useQueryInterop)(isRestrictedExternalShare ? (0, $6lbeL.ExternalByLineQuery) : (0, $fxLAA.default), {
        ...t8,
        __callerPackage__: "content-header"
    });
    let t9;
    if ($[11] !== contentId || $[12] !== refetch) {
        t9 = ()=>refetch({
                contentId: contentId,
                cacheBuster: ""
            });
        $[11] = contentId;
        $[12] = refetch;
        $[13] = t9;
    } else t9 = $[13];
    const reload = t9;
    let t10;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = [
            (0, $c0urc.ReloadType).content
        ];
        $[14] = t10;
    } else t10 = $[14];
    let t11;
    if ($[15] !== reload) {
        t11 = {
            name: "byline",
            types: t10,
            reload: reload
        };
        $[15] = reload;
        $[16] = t11;
    } else t11 = $[16];
    (0, $1SNEF.useQuickReloadSubscriber)(t11);
    const renderByLine = ()=>{
        if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4J61X.ByLinePlaceholder), null);
        const content = isRestrictedExternalShare ? data?.singleContent : data?.content?.nodes?.[0];
        const shouldRenderWithSpaceDenial = isAccessLinkRequest && Boolean(content) && (0, $fabPv.isSpaceDenialOnly)(error);
        if (error && shouldRenderWithSpaceDenial) (0, $7Sm4c.markErrorAsHandled)(error);
        else if (error) {
            if ((0, $1uFM6.isUnauthorizedError)(error)) {
                (0, $7Sm4c.markErrorAsHandled)(error);
                return null;
            } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: error
            });
        } else {
            if (!content) return null;
        }
        const author = (0, $83fWZ.toUserProps)(content?.history?.createdBy);
        const owner = content?.history?.ownedBy && (content?.type === "page" || content?.type === "blogpost") ? (0, $83fWZ.toUserProps)(content?.history?.ownedBy) : null;
        const by = (0, $83fWZ.toUserProps)(content?.version?.by);
        const contributorsCount = data?.contentContributors?.count || 0;
        const isOwnerContributor = data?.contentContributors?.isOwnerContributor || false;
        const isFabricPage = !isRestrictedExternalShare ? (0, $83fWZ.isFabricEditor)(data) : false;
        const { titleContentProperties: titleContentProperties } = (0, $zalpJ.getTitleContentProperty)(data);
        const contentHeaderContent = !isRestrictedExternalShare ? data?.content?.nodes?.[0] : null;
        const generatedBy = contentHeaderContent?.contentProperties?.latest?.generatedBy;
        const connectionAncestors = contentHeaderContent?.ancestors ?? null;
        const componentProps = {
            contentId: contentId,
            author: author,
            owner: owner,
            contributorsCount: contributorsCount,
            isOwnerContributor: isOwnerContributor,
            isFabricPage: isFabricPage,
            shouldShowBylineReactions: shouldShowBylineReactions,
            contentSubType: contentSubType,
            spaceId: spaceId,
            contentType: contentType,
            titleContentProperties: titleContentProperties,
            generatedBy: generatedBy,
            connectionAncestors: connectionAncestors,
            createdDate: content?.history?.createdDate || null,
            bylineClassificationFragmentRef: bylineClassificationFragmentRef,
            contentClassificationFragmentRef: contentClassificationFragmentRef,
            reactionsContentFragmentRef: reactionsContentFragmentRef,
            analyticsBylineFragmentRef: analyticsBylineFragmentRef,
            bylineAppContentProperties: bylineAppContentProperties,
            version: {
                friendlyWhen: content?.version?.friendlyWhen || "",
                when: content?.version?.when || null,
                number: Number(content?.version?.number || ""),
                by: by,
                contentTypeModified: content?.version?.contentTypeModified || false
            },
            ...passThroughProps
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2gstp.ByLineWithContributorsComponent), componentProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
            key: contentId,
            metric: (0, $hlP5l.BYLINE_METRIC),
            customData: {
                contributorsCount: contributorsCount
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0559514361f7ee96$var$HOT106424Tracker, {
            content: content,
            contentId: contentId,
            contentContributors: data?.contentContributors,
            isExternalShareRequest: isRestrictedExternalShare
        }));
    };
    const T0 = (0, $4PPzL.ErrorBoundary);
    const t12 = (0, $3IBnw.Attribution);
    let t13;
    let t14;
    if ($[17] !== contentId) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
            name: (0, $irVI7.VIEW_PAGE_BYLINE_EXPERIENCE),
            id: contentId
        });
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
            key: contentId,
            metric: (0, $hlP5l.BYLINE_METRIC)
        });
        $[17] = contentId;
        $[18] = t13;
        $[19] = t14;
    } else {
        t13 = $[18];
        t14 = $[19];
    }
    const t15 = renderByLine();
    let t16;
    if ($[20] !== T0 || $[21] !== t12.BACKBONE || $[22] !== t13 || $[23] !== t14 || $[24] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            attribution: t12.BACKBONE
        }, t13, t14, t15);
        $[20] = T0;
        $[21] = t12.BACKBONE;
        $[22] = t13;
        $[23] = t14;
        $[24] = t15;
        $[25] = t16;
    } else t16 = $[25];
    return t16;
};
function $0559514361f7ee96$var$_temp(node) {
    return !node;
}
function $0559514361f7ee96$var$_temp2(property) {
    return property?.key === "editor";
}
module.exports["ByLineFromFragment"] = $0559514361f7ee96$export$3da174e1e9f9b5b4;
module.exports["ByLine"] = $0559514361f7ee96$export$3b7993d3cbe5f289;

});

parcelRegister("daVgg", function(module, exports) {
/**
 * @generated SignedSource<<5a7bb06770f2b343c8473e42d15fcb56>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b0ceb5a87a1ab66b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ByLineContributors_contentContributors",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "count"
        },
        {
            "kind": "ScalarField",
            "name": "isCurrentUserContributor"
        },
        {
            "kind": "ScalarField",
            "name": "isOwnerContributor"
        },
        {
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "accountId"
                        }
                    ],
                    "type": "KnownUser"
                },
                {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "profilePicture",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "path"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "ContentContributors"
};
$b0ceb5a87a1ab66b$var$node.hash = "779053a535fff2e4b879239a0c659d33";
var $b0ceb5a87a1ab66b$export$2e2bcd8739ae039 = $b0ceb5a87a1ab66b$var$node;
module.exports["default"] = $b0ceb5a87a1ab66b$export$2e2bcd8739ae039;

});

parcelRegister("kSpAb", function(module, exports) {
/**
 * @generated SignedSource<<ee71c3f2c1807926afd626e17901d50d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $02a8f9783e035b58$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "type"
    }, v2 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v3 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v4 = [
        v1 /*: any*/ ,
        v3 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "accountId"
                }
            ],
            "type": "KnownUser"
        },
        {
            "concreteType": "Icon",
            "kind": "LinkedField",
            "name": "profilePicture",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "path"
                }
            ]
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "number"
    }, v6 = {
        "kind": "ScalarField",
        "name": "key"
    }, v7 = {
        "kind": "ScalarField",
        "name": "value"
    }, v8 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v0 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ]
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includeConnectionAncestors"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "useNewContentTopper"
            }
        ],
        "kind": "Fragment",
        "name": "ByLine_content",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "useReadTime_content"
            },
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            v2 /*: any*/ ,
            {
                "concreteType": "History",
                "kind": "LinkedField",
                "name": "history",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "createdDate"
                    },
                    {
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": v4 /*: any*/ 
                    },
                    {
                        "kind": "LinkedField",
                        "name": "ownedBy",
                        "plural": false,
                        "selections": v4 /*: any*/ 
                    },
                    {
                        "kind": "LinkedField",
                        "name": "lastOwnedBy",
                        "plural": false,
                        "selections": v4 /*: any*/ 
                    }
                ]
            },
            {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "by",
                        "plural": false,
                        "selections": v4 /*: any*/ 
                    },
                    {
                        "kind": "ScalarField",
                        "name": "friendlyWhen"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "when"
                    },
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "contentTypeModified"
                    }
                ]
            },
            {
                "concreteType": "ContentProperties",
                "kind": "LinkedField",
                "name": "contentProperties",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "PublishedContentProperties",
                        "kind": "LinkedField",
                        "name": "latest",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "generatedBy"
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "RendererContentState_content"
            },
            {
                "condition": "useNewContentTopper",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "alias": "pageTitlePublished",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "key",
                                "value": "page-title-property-published"
                            }
                        ],
                        "concreteType": "PaginatedJsonContentPropertyList",
                        "kind": "LinkedField",
                        "name": "properties",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JsonContentProperty",
                                "kind": "LinkedField",
                                "name": "nodes",
                                "plural": true,
                                "selections": [
                                    v0 /*: any*/ ,
                                    v6 /*: any*/ ,
                                    v7 /*: any*/ ,
                                    {
                                        "concreteType": "Version",
                                        "kind": "LinkedField",
                                        "name": "version",
                                        "plural": false,
                                        "selections": [
                                            v5 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ],
                        "storageKey": "properties(key:\"page-title-property-published\")"
                    }
                ]
            },
            {
                "alias": "editorProperty",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "key",
                        "value": "editor"
                    }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": v8 /*: any*/ ,
                "storageKey": "properties(key:\"editor\")"
            },
            {
                "concreteType": "ContentMetadata",
                "kind": "LinkedField",
                "name": "metadata",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                        "kind": "LinkedField",
                        "name": "frontend",
                        "plural": false,
                        "selections": [
                            {
                                "condition": "useNewContentTopper",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "coverPictureWidth"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "condition": "includeConnectionAncestors",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "Content",
                        "kind": "LinkedField",
                        "name": "ancestors",
                        "plural": true,
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "title"
                            },
                            v1 /*: any*/ ,
                            v2 /*: any*/ ,
                            {
                                "concreteType": "History",
                                "kind": "LinkedField",
                                "name": "history",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "createdBy",
                                        "plural": false,
                                        "selections": [
                                            v3 /*: any*/ 
                                        ]
                                    }
                                ]
                            },
                            {
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "keys",
                                        "value": [
                                            "devdocsProperties",
                                            "smartFolderProperties"
                                        ]
                                    }
                                ],
                                "concreteType": "PaginatedJsonContentPropertyList",
                                "kind": "LinkedField",
                                "name": "properties",
                                "plural": false,
                                "selections": v8 /*: any*/ ,
                                "storageKey": "properties(keys:[\"devdocsProperties\",\"smartFolderProperties\"])"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Content"
    };
}();
$02a8f9783e035b58$var$node.hash = "3f05feb4c48e931bd5441145ff3e2092";
var $02a8f9783e035b58$export$2e2bcd8739ae039 = $02a8f9783e035b58$var$node;
module.exports["default"] = $02a8f9783e035b58$export$2e2bcd8739ae039;

});

parcelRegister("4J61X", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $ep3mz = parcelRequire("ep3mz");


var $jVylI = parcelRequire("jVylI");


var $zalpJ = parcelRequire("zalpJ");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f1d8e46f2fc87fe7$var$Container = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isTitleCenterAligned: isTitleCenterAligned, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2XghbEQU1O _0jFU0VUF4f _3iDTPbQ4SZ",
            __cmplp.isTitleCenterAligned ? "_37wbyuDIqT" : "_37wbyuzUZr",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f1d8e46f2fc87fe7$var$Circle = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isTitleCenterAligned: isTitleCenterAligned, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_0bjKvDS5Zs _0KLXruGsB2",
            __cmplp.isTitleCenterAligned ? "_39xV02NHnM" : "_39xV02Va5s",
            __cmplp.isTitleCenterAligned ? "_0jFU0VNHnM" : "_0jFU0VVa5s",
            __cmplp.isTitleCenterAligned ? "_313842dnbC _0adFHsXJux _1DCdHidnbC _2XsHFMdnbC" : "_3138424Y4b _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f1d8e46f2fc87fe7$var$LineContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _2XsHFM2ADO _0adFHsFQfX",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f1d8e46f2fc87fe7$var$Line1 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_0bjKvDcjp5 _0KLXruGsB2 _39xV02QEt6 _0jFU0VEbN9 _3138421Y8M",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f1d8e46f2fc87fe7$var$Line2 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isTitleCenterAligned: isTitleCenterAligned, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_0bjKvDcjp5 _0KLXruGsB2 _0jFU0VxpxF _3138421Y8M",
            __cmplp.isTitleCenterAligned ? "_39xV024qGD" : "_39xV02b1xp",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f1d8e46f2fc87fe7$var$FirstRowContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _37wbyuDIqT",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f1d8e46f2fc87fe7$export$438daec06afefb9e = ()=>{
    const $ = (0, $bDgLe.c)(17);
    const [contentId] = (0, $ep3mz.usePageContentId)();
    let t0;
    if ($[0] !== contentId) {
        t0 = {
            contentId: contentId
        };
        $[0] = contentId;
        $[1] = t0;
    } else t0 = $[1];
    const { titleContentProperties: titleContentProperties } = (0, $zalpJ.useTitleContentPropertiesForPublishedPage)(t0);
    const isTitleCenterAligned = titleContentProperties?.titleLayoutAlignment == (0, $jVylI.TitleAlignmentType).CENTER;
    if (isTitleCenterAligned) {
        let t1;
        if ($[2] !== isTitleCenterAligned) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d8e46f2fc87fe7$var$Circle, {
                isTitleCenterAligned: isTitleCenterAligned
            });
            $[2] = isTitleCenterAligned;
            $[3] = t1;
        } else t1 = $[3];
        let t2;
        if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d8e46f2fc87fe7$var$Line1, null);
            $[4] = t2;
        } else t2 = $[4];
        let t3;
        if ($[5] !== t1) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d8e46f2fc87fe7$var$FirstRowContainer, null, t1, t2);
            $[5] = t1;
            $[6] = t3;
        } else t3 = $[6];
        let t4;
        if ($[7] !== isTitleCenterAligned) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d8e46f2fc87fe7$var$Line2, {
                isTitleCenterAligned: isTitleCenterAligned
            });
            $[7] = isTitleCenterAligned;
            $[8] = t4;
        } else t4 = $[8];
        let t5;
        if ($[9] !== t3 || $[10] !== t4) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d8e46f2fc87fe7$var$LineContainer, null, t3, t4);
            $[9] = t3;
            $[10] = t4;
            $[11] = t5;
        } else t5 = $[11];
        let t6;
        if ($[12] !== isTitleCenterAligned || $[13] !== t5) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d8e46f2fc87fe7$var$Container, {
                isTitleCenterAligned: isTitleCenterAligned
            }, t5);
            $[12] = isTitleCenterAligned;
            $[13] = t5;
            $[14] = t6;
        } else t6 = $[14];
        return t6;
    }
    let t1;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d8e46f2fc87fe7$var$Circle, null);
        $[15] = t1;
    } else t1 = $[15];
    let t2;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d8e46f2fc87fe7$var$Container, null, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d8e46f2fc87fe7$var$LineContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d8e46f2fc87fe7$var$Line1, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d8e46f2fc87fe7$var$Line2, null)));
        $[16] = t2;
    } else t2 = $[16];
    return t2;
};
module.exports["ByLinePlaceholder"] = $f1d8e46f2fc87fe7$export$438daec06afefb9e;

});

parcelRegister("2gstp", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $9wGTI = parcelRequire("9wGTI");


var $04VgG = parcelRequire("04VgG");


var $fImWv = parcelRequire("fImWv");


var $jjv3l = parcelRequire("jjv3l");


var $7om8k = parcelRequire("7om8k");


var $9yQxv = parcelRequire("9yQxv");


var $jVylI = parcelRequire("jVylI");


var $jkVM2 = parcelRequire("jkVM2");


var $63EIj = parcelRequire("63EIj");


var $iRRUp = parcelRequire("iRRUp");


var $2wo33 = parcelRequire("2wo33");


var $lfBMY = parcelRequire("lfBMY");


var $cD1qu = parcelRequire("cD1qu");


var $ep3mz = parcelRequire("ep3mz");


var $6mKj3 = parcelRequire("6mKj3");


var $a9SX7 = parcelRequire("a9SX7");


var $JTIzG = parcelRequire("JTIzG");


var $l2a4I = parcelRequire("l2a4I");


var $3oEKC = parcelRequire("3oEKC");


var $5vi32 = parcelRequire("5vi32");


var $6iOCg = parcelRequire("6iOCg");


var $35Exc = parcelRequire("35Exc");


var $AavAW = parcelRequire("AavAW");


var $aKxcs = parcelRequire("aKxcs");


var $5YSiR = parcelRequire("5YSiR");


var $3TrzI = parcelRequire("3TrzI");

const $22b7bc4596013b99$var$bylineLastUpdatedStyles = (0, $buxP3.xcss)({
    marginTop: 'space.negative.025',
    marginLeft: 'space.negative.050',
    marginRight: 'space.negative.075'
});
const $22b7bc4596013b99$var$ReadTimeWithContentFragmentRef = (0, $04VgG.ReadTime);
// Downstream packages are checked against the last generated confluence-analytics declaration.
const $22b7bc4596013b99$var$AnalyticsByLineWithFragmentRef = (0, $fImWv.AnalyticsByLine);
const $22b7bc4596013b99$export$773979b66159aa2 = /*#__PURE__*/ (0, $cozmU.memo)((t0)=>{
    const $ = (0, $bDgLe.c)(59);
    const { contentId: contentId, author: author, owner: owner, version: version, contributorsCount: contributorsCount, isOwnerContributor: isOwnerContributor, hasByLineContributors: hasByLineContributors, hasByLineExtensions: hasByLineExtensions, isFabricPage: isFabricPage, titleContentProperties: titleContentProperties, shouldShowBylineReactions: shouldShowBylineReactions, contentType: contentType, contentSubType: contentSubType, spaceId: spaceId, generatedBy: generatedBy, connectionAncestors: connectionAncestors, createdDate: createdDate, contentFragmentRef: contentFragmentRef, bylineClassificationFragmentRef: bylineClassificationFragmentRef, contentClassificationFragmentRef: contentClassificationFragmentRef, reactionsContentFragmentRef: reactionsContentFragmentRef, analyticsBylineFragmentRef: analyticsBylineFragmentRef, bylineAppContentProperties: bylineAppContentProperties } = t0;
    const isRestrictedExternalShare = (0, $jjv3l.useIsRestrictedExternalShareRequest)();
    const [contentTypeFromContext] = (0, $ep3mz.useContentType)();
    const { isAudioBylineEntrypointEnabled: isAudioBylineEntrypointEnabled } = (0, $JTIzG.useAudioFeatureFlags)();
    const t1 = contentType ?? contentTypeFromContext;
    let t2;
    if ($[0] !== contentId || $[1] !== t1) {
        t2 = {
            contentId: contentId,
            contentType: t1,
            operation: (0, $lfBMY.OperationTypes).UPDATE,
            status: (0, $cD1qu.CURRENT_STATUS)
        };
        $[0] = contentId;
        $[1] = t1;
        $[2] = t2;
    } else t2 = $[2];
    const canUpdateContent = (0, $2wo33.useCanPerformContentOperation)(t2);
    const hasEditPermission = canUpdateContent ?? false;
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const isTitleCenterAligned = titleContentProperties?.titleLayoutAlignment == (0, $jVylI.TitleAlignmentType).CENTER;
    const showByLineContributors = hasByLineContributors ?? true;
    const showByLineExtensions = hasByLineExtensions ?? true;
    let t3;
    if ($[3] !== generatedBy || $[4] !== isEmbeddedConfluence) {
        t3 = generatedBy === (0, $3TrzI.AI_PLANNER_GENERATED_BY) && (0, $9wGTI.fg)("confluence_ai_planner_sync_byline") && !(isEmbeddedConfluence && (0, $9wGTI.fg)("migrate_planner_to_docs_tab"));
        $[3] = generatedBy;
        $[4] = isEmbeddedConfluence;
        $[5] = t3;
    } else t3 = $[5];
    const shouldRenderAIPlannerSyncByline = t3;
    const BylineMainDiv = (0, $6mKj3.expValEquals)("confluence_byline_min_height", "isEnabled", true) ? (0, $35Exc.StandardPageBylineStyledMainDiv) : (0, $35Exc.StyledMainDiv);
    let t4;
    if ($[6] !== author || $[7] !== bylineClassificationFragmentRef || $[8] !== contentClassificationFragmentRef || $[9] !== contentFragmentRef || $[10] !== contentId || $[11] !== contentType || $[12] !== contentTypeFromContext || $[13] !== contributorsCount || $[14] !== generatedBy || $[15] !== hasEditPermission || $[16] !== isFabricPage || $[17] !== isOwnerContributor || $[18] !== owner || $[19] !== showByLineContributors || $[20] !== version) {
        t4 = showByLineContributors && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7om8k.BadgeStylePageOwnershipByline), {
            owner: owner,
            author: author,
            analyticsSource: "renderer",
            contributorCountWithoutOwner: contributorsCount - (isOwnerContributor ? 1 : 0),
            generatedBy: generatedBy
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aKxcs.BylineClassification), {
            contentId: contentId,
            classificationContextFragmentRef: bylineClassificationFragmentRef,
            contentFragmentRef: contentClassificationFragmentRef
        }), (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jkVM2.EditorContentState), {
            contentId: contentId,
            contentType: contentType ?? contentTypeFromContext,
            isViewMode: true,
            canEdit: hasEditPermission,
            userOffline: false
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $63EIj.RendererContentState), {
            contentId: contentId,
            isDraft: false,
            hasSeparator: false,
            contentFragmentRef: contentFragmentRef
        }), !isFabricPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $22b7bc4596013b99$var$bylineLastUpdatedStyles,
            testId: "page-last-modified"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $AavAW.ByLineLastUpdatedCompact), {
            version: version
        })));
        $[6] = author;
        $[7] = bylineClassificationFragmentRef;
        $[8] = contentClassificationFragmentRef;
        $[9] = contentFragmentRef;
        $[10] = contentId;
        $[11] = contentType;
        $[12] = contentTypeFromContext;
        $[13] = contributorsCount;
        $[14] = generatedBy;
        $[15] = hasEditPermission;
        $[16] = isFabricPage;
        $[17] = isOwnerContributor;
        $[18] = owner;
        $[19] = showByLineContributors;
        $[20] = version;
        $[21] = t4;
    } else t4 = $[21];
    let t5;
    if ($[22] !== contentId || $[23] !== contentType || $[24] !== contentTypeFromContext || $[25] !== generatedBy || $[26] !== isEmbeddedConfluence || $[27] !== shouldRenderAIPlannerSyncByline) {
        t5 = shouldRenderAIPlannerSyncByline && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5YSiR.LazyAIPlannerSyncByline), {
            contentId: contentId,
            contentType: contentType ?? contentTypeFromContext,
            generatedBy: generatedBy,
            isEmbeddedConfluence: isEmbeddedConfluence
        });
        $[22] = contentId;
        $[23] = contentType;
        $[24] = contentTypeFromContext;
        $[25] = generatedBy;
        $[26] = isEmbeddedConfluence;
        $[27] = shouldRenderAIPlannerSyncByline;
        $[28] = t5;
    } else t5 = $[28];
    let t6;
    if ($[29] !== analyticsBylineFragmentRef || $[30] !== author || $[31] !== connectionAncestors || $[32] !== contentFragmentRef || $[33] !== contentId || $[34] !== contentSubType || $[35] !== contentType || $[36] !== contentTypeFromContext || $[37] !== createdDate || $[38] !== generatedBy || $[39] !== isAudioBylineEntrypointEnabled || $[40] !== isRestrictedExternalShare || $[41] !== reactionsContentFragmentRef || $[42] !== shouldShowBylineReactions || $[43] !== showByLineExtensions || $[44] !== spaceId || $[45] !== version?.number || $[46] !== version?.when) {
        t6 = showByLineExtensions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($22b7bc4596013b99$var$ReadTimeWithContentFragmentRef, {
            contentId: contentId,
            contentFragmentRef: contentFragmentRef
        }), (0, $9wGTI.fg)("cc_sparks_agent_trust_receipt") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3oEKC.AgentTrustReceiptBylineChip), {
            contentId: contentId,
            generatedBy: generatedBy,
            creatorName: author?.fullName,
            createdAt: createdDate,
            lastUpdatedAt: version?.when,
            versionNumber: version?.number
        }), (0, $6mKj3.isExperimentEnabled)("confluence_1p_and_3p_connection_byline_experiment") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l2a4I.BylineConnections), {
            contentId: contentId,
            contentType: contentType ?? contentTypeFromContext,
            connectionAncestors: connectionAncestors,
            pageVersion: version?.number,
            pageUpdatedAt: version?.when
        }), isAudioBylineEntrypointEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9SX7.ListenByline), {
            contentId: contentId,
            contentType: contentType ?? undefined
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($22b7bc4596013b99$var$AnalyticsByLineWithFragmentRef, {
            contentId: contentId,
            contentAuthorId: author.userId,
            analyticsBylineFragmentRef: analyticsBylineFragmentRef
        }), shouldShowBylineReactions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iRRUp.ViewPageBylineReactions), {
            contentId: contentId,
            contentType: contentType,
            spaceId: spaceId,
            contentSubType: contentSubType,
            reactionsContentFragmentRef: reactionsContentFragmentRef,
            noFlexWrap: true,
            noRelativeContainer: true
        }), !isRestrictedExternalShare && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9yQxv.AutoConversionByLine), null));
        $[29] = analyticsBylineFragmentRef;
        $[30] = author;
        $[31] = connectionAncestors;
        $[32] = contentFragmentRef;
        $[33] = contentId;
        $[34] = contentSubType;
        $[35] = contentType;
        $[36] = contentTypeFromContext;
        $[37] = createdDate;
        $[38] = generatedBy;
        $[39] = isAudioBylineEntrypointEnabled;
        $[40] = isRestrictedExternalShare;
        $[41] = reactionsContentFragmentRef;
        $[42] = shouldShowBylineReactions;
        $[43] = showByLineExtensions;
        $[44] = spaceId;
        $[45] = version?.number;
        $[46] = version?.when;
        $[47] = t6;
    } else t6 = $[47];
    let t7;
    if ($[48] !== bylineAppContentProperties || $[49] !== contentId || $[50] !== isTitleCenterAligned || $[51] !== showByLineExtensions || $[52] !== t4 || $[53] !== t5 || $[54] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $35Exc.StyledTextDiv), {
            hasBadgeStylePageOwnerBylineItem: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6iOCg.SingleLineByLine), {
            contentId: contentId,
            isTitleCenterAlignedOverride: isTitleCenterAligned,
            showByLineExtensions: showByLineExtensions,
            bylineAppContentProperties: bylineAppContentProperties
        }, t4, t5, t6));
        $[48] = bylineAppContentProperties;
        $[49] = contentId;
        $[50] = isTitleCenterAligned;
        $[51] = showByLineExtensions;
        $[52] = t4;
        $[53] = t5;
        $[54] = t6;
        $[55] = t7;
    } else t7 = $[55];
    let t8;
    if ($[56] !== isTitleCenterAligned || $[57] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(BylineMainDiv, {
            className: "page-metadata-modification-info",
            "data-testid": "page-main-div",
            isTitleCenterAligned: isTitleCenterAligned
        }, t7);
        $[56] = isTitleCenterAligned;
        $[57] = t7;
        $[58] = t8;
    } else t8 = $[58];
    return t8;
});
module.exports["ByLineWithContributorsComponent"] = $22b7bc4596013b99$export$773979b66159aa2;

});

parcelRegister("9yQxv", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $b3f1a98366675b36$export$bffecd160d81d78c = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "yzXpt",
    loader: async ()=>(await (parcelRequire("9IvbC"))).AutoConversionByLine,
    name: 'AutoConversionByLine'
});
module.exports["AutoConversionByLine"] = $b3f1a98366675b36$export$bffecd160d81d78c;

});

parcelRegister("9IvbC", function(module, exports) {

let $71306a162b99b673$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $71306a162b99b673$var$load("22DNY").then(()=>parcelRequire('6VDyY'));

});

parcelRegister("iRRUp", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5sUij = parcelRequire("5sUij");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $3izAL = parcelRequire("3izAL");


var $kA6Zo = parcelRequire("kA6Zo");


var $buxP3 = parcelRequire("buxP3");


var $b35Wv = parcelRequire("b35Wv");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $isEtk = parcelRequire("isEtk");


var $bQm3c = parcelRequire("bQm3c");


var $5Kc7f = parcelRequire("5Kc7f");


var $23eq9 = parcelRequire("23eq9");


var $1NF8X = parcelRequire("1NF8X");


var $3FlVr = parcelRequire("3FlVr");


var $ke5Nx = parcelRequire("ke5Nx");


var $4RNeW = parcelRequire("4RNeW");

const $7bbeff754c7e0bdb$var$i18n = (0, $kSwu1.defineMessages)({
    addNew: {
        id: "reactions.view-page.byline.reactions.add.new",
        defaultMessage: "Add new"
    },
    addReaction: {
        id: "reactions.view-page.byline.reactions.add.reaction",
        defaultMessage: "Add reaction"
    }
});
const $7bbeff754c7e0bdb$var$ViewPageReactionsContainerCommonStyles = (0, $buxP3.xcss)({
    display: 'flex',
    clear: 'both',
    overflow: 'visible',
    maxWidth: 'unset',
    margin: 'unset',
    marginBottom: 'space.025',
    marginTop: 'space.025',
    height: '28px'
});
const $7bbeff754c7e0bdb$var$ReactionsComponent = (t0)=>{
    const $ = (0, $bDgLe.c)(20);
    const { contentId: contentId, contentType: contentType, spaceId: spaceId, contentSubType: contentSubType, noFlexWrap: noFlexWrap, noRelativeContainer: noRelativeContainer, reactionsData: reactionsData } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [state] = (0, $isEtk.useContentState)();
    const { focusedPageReactionsId: focusedPageReactionsId } = (0, $ke5Nx.useReactionsQueryParams)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            rootMargin: "-100px 0px 0px 0px",
            triggerOnce: true
        };
        $[0] = t1;
    } else t1 = $[0];
    const [reactionsRef, reactionsSectionInView] = (0, $5sUij.useInView)(t1);
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b35Wv))), {
            testId: "emoji-add-icon",
            color: "var(--ds-icon-subtle, #505258)",
            label: ""
        });
        $[1] = t2;
    } else t2 = $[1];
    const customIcon = t2;
    const isSSR = Boolean(window.__SSR_RENDERED__);
    const isInViewAndNotOnServer = reactionsSectionInView && state?.isContentReady;
    let t3;
    if ($[2] !== contentId || $[3] !== contentSubType || $[4] !== contentType || $[5] !== edition || $[6] !== focusedPageReactionsId || $[7] !== formatMessage || $[8] !== noFlexWrap || $[9] !== noRelativeContainer || $[10] !== reactionsData || $[11] !== spaceId) {
        t3 = ()=>{
            if (contentType && spaceId) {
                const ReactionsLoader = focusedPageReactionsId ? (0, $1NF8X.ReactionsLoaderBackground) : (0, $23eq9.ReactionsSSRLoader);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
                    testId: "view-page-byline-reactions-wrapper",
                    "data-vc": "view-page-byline-reactions-wrapper"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ReactionsLoader, {
                    contentId: contentId,
                    location: contentType,
                    containerId: spaceId,
                    containerType: (0, $3FlVr.ReactionContainerType).SPACE,
                    contentSubType: contentSubType,
                    reactionsData: reactionsData,
                    summaryViewEnabled: true,
                    summaryViewThreshold: 1,
                    allowSelectFromSummaryView: true,
                    useButtonAlignmentStyling: true,
                    summaryViewPlacement: "bottom-start",
                    customAnalyticsAttributes: {
                        edition: edition
                    },
                    isSubtle: true,
                    reactionPickerTriggerIcon: customIcon,
                    useDefaultStyledContainer: true,
                    noFlexWrap: noFlexWrap,
                    noRelativeContainer: noRelativeContainer,
                    reactionPickerTriggerText: formatMessage($7bbeff754c7e0bdb$var$i18n.addNew),
                    hoverableSummaryView: true,
                    optimisticallyLoadSummaryEmojis: isSSR,
                    renderParticleEffectOnSummaryView: true
                }));
            } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5Kc7f.ReactionsSummaryViewPlaceholder), null);
        };
        $[2] = contentId;
        $[3] = contentSubType;
        $[4] = contentType;
        $[5] = edition;
        $[6] = focusedPageReactionsId;
        $[7] = formatMessage;
        $[8] = noFlexWrap;
        $[9] = noRelativeContainer;
        $[10] = reactionsData;
        $[11] = spaceId;
        $[12] = t3;
    } else t3 = $[12];
    const displayReactions = t3;
    let t4;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = [
            $7bbeff754c7e0bdb$var$ViewPageReactionsContainerCommonStyles
        ];
        $[13] = t4;
    } else t4 = $[13];
    let t5;
    if ($[14] !== displayReactions || $[15] !== isInViewAndNotOnServer) {
        t5 = isSSR || isInViewAndNotOnServer ? displayReactions() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5Kc7f.ReactionsSummaryViewPlaceholder), null);
        $[14] = displayReactions;
        $[15] = isInViewAndNotOnServer;
        $[16] = t5;
    } else t5 = $[16];
    let t6;
    if ($[17] !== reactionsRef || $[18] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            ref: reactionsRef,
            testId: "view-page-byline-reactions",
            xcss: t4
        }, t5);
        $[17] = reactionsRef;
        $[18] = t5;
        $[19] = t6;
    } else t6 = $[19];
    return t6;
};
const $7bbeff754c7e0bdb$export$c52ae103b3391553 = (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        const reactions = props.reactionsContentFragmentRef ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7bbeff754c7e0bdb$var$ViewPageBylineReactionsFragmentReader, {
            ...props,
            reactionsContentFragmentRef: props.reactionsContentFragmentRef
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7bbeff754c7e0bdb$var$ReactionsComponent, props);
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSqtY.TransparentErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).NOTIFICATIONS
        }, reactions);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
const $7bbeff754c7e0bdb$var$ViewPageBylineReactionsFragmentReader = (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    let props;
    let reactionsContentFragmentRef;
    if ($[0] !== t0) {
        ({ reactionsContentFragmentRef: reactionsContentFragmentRef, ...props } = t0);
        $[0] = t0;
        $[1] = props;
        $[2] = reactionsContentFragmentRef;
    } else {
        props = $[1];
        reactionsContentFragmentRef = $[2];
    }
    const content = (0, $6SsN4.useFragment)((0, $4RNeW.ReactionsContentFragment_content), reactionsContentFragmentRef);
    let t1;
    if ($[3] !== content.contentReactionsSummary || $[4] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7bbeff754c7e0bdb$var$ReactionsComponent, {
            ...props,
            reactionsData: content.contentReactionsSummary
        });
        $[3] = content.contentReactionsSummary;
        $[4] = props;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
};
module.exports["ViewPageBylineReactions"] = $7bbeff754c7e0bdb$export$c52ae103b3391553;

});

parcelRegister("23eq9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");


var $5Kc7f = parcelRequire("5Kc7f");


var $bFPHx = parcelRequire("bFPHx");


const $7b10285448e39671$export$818988cb4f30ec46 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "vP7ts",
    name: "ReactionsSSRLoader",
    loading: (props)=>{
        return props?.summaryViewEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5Kc7f.ReactionsSummaryViewPlaceholder), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bFPHx.ReactionsPlaceholder), null);
    },
    loader: async ()=>(await (parcelRequire("hkYAW"))).Reactions
});
module.exports["ReactionsSSRLoader"] = $7b10285448e39671$export$818988cb4f30ec46;

});

parcelRegister("4RNeW", function(module, exports) {

var $jG90l = parcelRequire("jG90l");

const $ec5d2b49526d7beb$export$775e4c56cd01bef0 = (0, $jG90l.default);
module.exports["ReactionsContentFragment_content"] = $ec5d2b49526d7beb$export$775e4c56cd01bef0;

});

parcelRegister("jG90l", function(module, exports) {
/**
 * @generated SignedSource<<84ffca27fbfe7c65cbcf62a794426f5e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3c4825abea248692$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "ReactionsContentFragment_content",
        "selections": [
            v0 /*: any*/ ,
            {
                "concreteType": "ReactionsSummaryResponse",
                "kind": "LinkedField",
                "name": "contentReactionsSummary",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "reactionsCount"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "ari"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "containerAri"
                    },
                    {
                        "concreteType": "ReactionsSummaryForEmoji",
                        "kind": "LinkedField",
                        "name": "reactionsSummaryForEmoji",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "emojiId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "count"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "reacted"
                            },
                            v0 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "type": "Content"
    };
}();
$3c4825abea248692$var$node.hash = "8f56d4c4019bf4c3d755d097e2930c4e";
var $3c4825abea248692$export$2e2bcd8739ae039 = $3c4825abea248692$var$node;
module.exports["default"] = $3c4825abea248692$export$2e2bcd8739ae039;

});

parcelRegister("3oEKC", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $jC4nA = parcelRequire("jC4nA");


var $aWwYt = parcelRequire("aWwYt");


var $b2GGc = parcelRequire("b2GGc");


var $e2zD6 = parcelRequire("e2zD6");

const $577177aaf22dc1ba$var$i18n = (0, $kSwu1.defineMessages)({
    viewReceiptAction: {
        id: "agent-trust-receipt.byline-chip.view-receipt-action.non-final",
        defaultMessage: "View receipt"
    }
});
const $577177aaf22dc1ba$var$AgentTrustReceiptBylineChipButton = ({ receipt: receipt })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { showObjectSidebar: showObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const chipLabel = `${receipt.scenario.label} - ${formatMessage($577177aaf22dc1ba$var$i18n.viewReceiptAction)}`;
    const openReceiptPanel = (0, $cozmU.useCallback)(()=>{
        showObjectSidebar((0, $b2GGc.createAgentTrustReceiptPanel)({
            receipt: receipt
        }), 'push');
    }, [
        receipt,
        showObjectSidebar
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        spacing: "compact",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($jC4nA))),
        testId: "agent-trust-receipt-byline-chip",
        onClick: openReceiptPanel
    }, chipLabel);
};
const $577177aaf22dc1ba$var$AgentTrustReceiptBylineChipInner = ({ contentId: contentId, generatedBy: generatedBy, creatorName: creatorName, createdAt: createdAt, lastUpdatedAt: lastUpdatedAt, versionNumber: versionNumber })=>{
    const receipt = (0, $cozmU.useMemo)(()=>(0, $e2zD6.resolveAgentTrustReceipt)(contentId, {
            generatedBy: generatedBy,
            creatorName: creatorName,
            createdAt: createdAt,
            lastUpdatedAt: lastUpdatedAt,
            versionNumber: versionNumber
        }), [
        contentId,
        generatedBy,
        creatorName,
        createdAt,
        lastUpdatedAt,
        versionNumber
    ]);
    if (!receipt) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($577177aaf22dc1ba$var$AgentTrustReceiptBylineChipButton, {
        receipt: receipt
    });
};
const $577177aaf22dc1ba$export$5f6967bf6f7e3690 = $577177aaf22dc1ba$var$AgentTrustReceiptBylineChipInner;
module.exports["AgentTrustReceiptBylineChip"] = $577177aaf22dc1ba$export$5f6967bf6f7e3690;

});

parcelRegister("e2zD6", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $7Qvc2 = parcelRequire("7Qvc2");

const $05a5c042457d6268$var$CREATED_BY_AI_LABEL = 'Created with Rovo';
const $05a5c042457d6268$var$EDITED_BY_AI_LABEL = 'Edited with Rovo';
const $05a5c042457d6268$var$READ_BY_AI_LABEL = 'Viewed by Rovo';
const $05a5c042457d6268$var$SOURCE_LABEL = 'Source';
const $05a5c042457d6268$var$EVIDENCE_LABEL = 'Evidence';
const $05a5c042457d6268$var$PERSISTENCE_LABEL = 'Persistence';
const $05a5c042457d6268$var$NETWORK_CALLS_LABEL = 'Network calls';
const $05a5c042457d6268$var$CREATOR_LABEL = 'Creator';
const $05a5c042457d6268$var$VERSION_LABEL = 'Version';
const $05a5c042457d6268$var$UNKNOWN_CREATOR_NAME = 'the page creator';
const $05a5c042457d6268$var$REAL_DATA_SOURCE_VALUE = 'Page content property (generatedBy)';
const $05a5c042457d6268$var$REAL_DATA_NONE_VALUE = 'None (read from existing page data)';
const $05a5c042457d6268$var$SPARK_RECEIPT_SCENARIOS = {
    CREATED_BY_AI: {
        id: 'CREATED_BY_AI',
        label: $05a5c042457d6268$var$CREATED_BY_AI_LABEL,
        description: 'Spark preview data indicates Rovo created this page.'
    },
    EDITED_BY_AI: {
        id: 'EDITED_BY_AI',
        label: $05a5c042457d6268$var$EDITED_BY_AI_LABEL,
        description: 'Spark preview data indicates Rovo helped edit this page.'
    },
    READ_BY_AI: {
        id: 'READ_BY_AI',
        label: $05a5c042457d6268$var$READ_BY_AI_LABEL,
        description: 'Spark preview data indicates Rovo read this page as context.'
    }
};
const $05a5c042457d6268$var$ROVO_AGENT_ACTOR = {
    id: 'rovo-agent-spark-preview',
    name: 'Rovo agent',
    type: 'agent',
    agentType: 'rovo',
    iconKey: 'rovo-agent'
};
const $05a5c042457d6268$var$SPACE_ORGANIZER_ACTOR = {
    id: 'space-organizer-agent-spark-preview',
    name: 'Space Organizer Agent',
    type: 'agent',
    agentType: 'space-organizer',
    iconKey: 'space-organizer-agent'
};
const $05a5c042457d6268$var$DEV_DOCS_ACTOR = {
    id: 'dev-docs-agent-spark-preview',
    name: 'Dev Docs Agent',
    type: 'agent',
    agentType: 'dev-docs',
    iconKey: 'dev-docs-agent'
};
const $05a5c042457d6268$var$FABRICATED_BUCKETS = [
    {
        scenarioId: 'EDITED_BY_AI',
        actor: $05a5c042457d6268$var$SPACE_ORGANIZER_ACTOR
    },
    {
        scenarioId: 'READ_BY_AI',
        actor: $05a5c042457d6268$var$DEV_DOCS_ACTOR
    }
];
const $05a5c042457d6268$var$isValidContentId = (contentId)=>/^[1-9]\d*$/.test(contentId);
const $05a5c042457d6268$var$resolveFabricatedBucket = (contentId)=>{
    const lastDigit = Number(contentId.charAt(contentId.length - 1));
    return lastDigit % $05a5c042457d6268$var$FABRICATED_BUCKETS.length;
};
const $05a5c042457d6268$var$createSparkPreviewSignals = (scenario)=>[
        {
            id: 'source',
            label: $05a5c042457d6268$var$SOURCE_LABEL,
            value: 'Spark preview fixture'
        },
        {
            id: 'evidence',
            label: $05a5c042457d6268$var$EVIDENCE_LABEL,
            value: `Example evidence for ${scenario.label.toLowerCase()}`
        },
        {
            id: 'persistence',
            label: $05a5c042457d6268$var$PERSISTENCE_LABEL,
            value: 'None'
        },
        {
            id: 'network',
            label: $05a5c042457d6268$var$NETWORK_CALLS_LABEL,
            value: 'None'
        }
    ];
const $05a5c042457d6268$var$createSparkPreviewEvents = (actor, scenario)=>[
        {
            id: 'context-reviewed',
            occurredAt: '2026-06-03T21:00:00.000Z',
            title: 'Context reviewed',
            description: `${actor.name} inspected example page context for ${scenario.label.toLowerCase()}.`
        },
        {
            id: 'agent-action',
            occurredAt: '2026-06-03T21:02:00.000Z',
            title: scenario.label,
            description: `${actor.name} performed the Spark preview activity recorded in this receipt.`
        },
        {
            id: 'receipt-created',
            occurredAt: '2026-06-03T21:04:00.000Z',
            title: 'Receipt prepared',
            description: 'Example evidence was collected for review in this Spark preview receipt.'
        }
    ].sort((a, b)=>a.occurredAt.localeCompare(b.occurredAt));
// Builds a CREATED_BY_AI receipt backed by REAL page data (creator, created/updated timestamps,
// version number) for pages confirmed to be created by Rovo Smart Create. Events with a missing
// timestamp are omitted so the panel never renders an Invalid Date.
const $05a5c042457d6268$var$createRealCreatedByAiReceipt = (contentId, pageData)=>{
    const scenario = $05a5c042457d6268$var$SPARK_RECEIPT_SCENARIOS.CREATED_BY_AI;
    const creatorName = pageData.creatorName?.trim() || $05a5c042457d6268$var$UNKNOWN_CREATOR_NAME;
    const versionDetail = typeof pageData.versionNumber === 'number' ? `${$05a5c042457d6268$var$VERSION_LABEL} ${pageData.versionNumber}` : null;
    const events = [];
    if (pageData.createdAt) events.push({
        id: 'page-created',
        occurredAt: pageData.createdAt,
        title: scenario.label,
        description: `${creatorName} created this page with Rovo.`
    });
    if (pageData.lastUpdatedAt) events.push({
        id: 'page-last-updated',
        occurredAt: pageData.lastUpdatedAt,
        title: 'Last updated',
        description: versionDetail ? `Latest published change (${versionDetail.toLowerCase()}).` : 'Latest published change.'
    });
    events.sort((a, b)=>a.occurredAt.localeCompare(b.occurredAt));
    const signals = [
        {
            id: 'source',
            label: $05a5c042457d6268$var$SOURCE_LABEL,
            value: $05a5c042457d6268$var$REAL_DATA_SOURCE_VALUE
        },
        {
            id: 'creator',
            label: $05a5c042457d6268$var$CREATOR_LABEL,
            value: creatorName
        },
        {
            id: 'version',
            label: $05a5c042457d6268$var$VERSION_LABEL,
            value: versionDetail ?? 'Unknown'
        },
        {
            id: 'persistence',
            label: $05a5c042457d6268$var$PERSISTENCE_LABEL,
            value: $05a5c042457d6268$var$REAL_DATA_NONE_VALUE
        },
        {
            id: 'network',
            label: $05a5c042457d6268$var$NETWORK_CALLS_LABEL,
            value: $05a5c042457d6268$var$REAL_DATA_NONE_VALUE
        }
    ];
    return {
        contentId: contentId,
        actor: $05a5c042457d6268$var$ROVO_AGENT_ACTOR,
        scenario: scenario,
        // CREATED_BY_AI receipts are sourced from real page data, so they must NOT claim "no audit log
        // was created" — that copy only applies to fabricated Spark preview receipts.
        summary: `Created with Rovo by ${creatorName}. This receipt is sourced from existing page data.`,
        events: events,
        signals: signals
    };
};
const $05a5c042457d6268$export$a31b6deb77eb892e = (contentId, pageData)=>{
    if (!(0, $9wGTI.fg)('cc_sparks_agent_trust_receipt')) return null;
    const normalizedContentId = contentId.trim();
    if (!$05a5c042457d6268$var$isValidContentId(normalizedContentId)) return null;
    // Real CREATED_BY_AI data only when the page is positively confirmed as Rovo Smart Create.
    // Exact-literal match excludes null, ONBOARDING, and AI_PLANNER.
    if (pageData?.generatedBy === (0, $7Qvc2.ROVO_SMART_CREATION_GENERATED_BY)) return $05a5c042457d6268$var$createRealCreatedByAiReceipt(normalizedContentId, pageData);
    // Non-Rovo pages fall back to fabricated EDITED_BY_AI / READ_BY_AI demo receipts only — never
    // CREATED_BY_AI, so "Created with Rovo" is never asserted on a page Rovo did not create.
    const { scenarioId: scenarioId, actor: actor } = $05a5c042457d6268$var$FABRICATED_BUCKETS[$05a5c042457d6268$var$resolveFabricatedBucket(normalizedContentId)];
    const scenario = $05a5c042457d6268$var$SPARK_RECEIPT_SCENARIOS[scenarioId];
    return {
        contentId: normalizedContentId,
        actor: actor,
        scenario: scenario,
        summary: `${scenario.description} This receipt identifies ${actor.name}, the recorded agent activity, and the chronological events available for review. Spark preview data only, not a durable audit log.`,
        events: $05a5c042457d6268$var$createSparkPreviewEvents(actor, scenario),
        signals: $05a5c042457d6268$var$createSparkPreviewSignals(scenario)
    };
};
module.exports["resolveAgentTrustReceipt"] = $05a5c042457d6268$export$a31b6deb77eb892e;

});

parcelRegister("AavAW", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $buxP3 = parcelRequire("buxP3");


var $kA6Zo = parcelRequire("kA6Zo");


var $5ZtfK = parcelRequire("5ZtfK");

const $5783a7702ddb8025$var$loadingStyle = (0, $buxP3.xcss)({
    width: '85px',
    backgroundColor: 'color.skeleton.subtle',
    height: '24px',
    borderRadius: 'radius.full'
});
const $5783a7702ddb8025$var$lastUpdateStyles = (0, $buxP3.xcss)({
    marginTop: 'space.025',
    marginLeft: 'space.100',
    marginRight: 'space.150'
});
const $5783a7702ddb8025$var$i18n = (0, $kSwu1.defineMessages)({
    lastUpdateIconLabel: {
        id: "content-header.by-line.live-pages.last.updated.icon.label",
        defaultMessage: "Last updated"
    }
});
const $5783a7702ddb8025$export$b76f09da983efdc2 = /*#__PURE__*/ (0, $cozmU.memo)((t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { version: version, loading: loading } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== intl) {
        t1 = intl.formatMessage($5783a7702ddb8025$var$i18n.lastUpdateIconLabel);
        $[0] = intl;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5ZtfK))), {
            label: t1,
            color: "var(--ds-text-subtle, #505258)",
            testId: "last-updated-icon"
        });
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== loading || $[5] !== version) {
        t3 = loading && !version.friendlyWhen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            xcss: $5783a7702ddb8025$var$loadingStyle,
            alignItems: "center",
            justifyContent: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null)) : version?.friendlyWhen;
        $[4] = loading;
        $[5] = version;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== t2 || $[8] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            alignItems: "center",
            gap: "space.075",
            xcss: $5783a7702ddb8025$var$lastUpdateStyles,
            testId: "live-page-last-updated"
        }, t2, t3);
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
});
module.exports["ByLineLastUpdatedCompact"] = $5783a7702ddb8025$export$b76f09da983efdc2;

});

parcelRegister("6lbeL", function(module, exports) {

var $9HhEw = parcelRequire("9HhEw");

const $3ade7df4fa86d9cd$export$83e33e2cb03d444b = (0, $9HhEw.default);
module.exports["ExternalByLineQuery"] = $3ade7df4fa86d9cd$export$83e33e2cb03d444b;

});

parcelRegister("kQRQB", function(module, exports) {
$parcel$export(module.exports, "ContentTitle", () => (parcelRequire("a3W69")).ContentTitle);
$parcel$export(module.exports, "ContentTitleFromFragment", () => (parcelRequire("a3W69")).ContentTitleFromFragment);

var $a3W69 = parcelRequire("a3W69");


});

parcelRegister("6UMDm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9wGTI = parcelRequire("9wGTI");


var $dfgVG = parcelRequire("dfgVG");

var $jNUT6 = parcelRequire("jNUT6");

const $1493c1e4d7d497eb$export$f12106fa80cfd400 = /*#__PURE__*/ (0, $cozmU.createContext)({
    editorProperty: '',
    fabricEditorSupported: false,
    isAutoConverted: false,
    queryDataId: ''
});
const $1493c1e4d7d497eb$export$78dcd8ae786efebe = ({ editorProperty: editorProperty, fabricEditorSupported: fabricEditorSupported, isAutoConverted: isAutoConvertedWithNewTinyPages, queryDataId: queryDataId, children: children })=>{
    const isAutoConverted = (0, $9wGTI.fg)('confluence_editor_auto-convert_changes') ? isAutoConvertedWithNewTinyPages : !editorProperty && fabricEditorSupported;
    const isFabric = editorProperty === 'v2' || ((0, $9wGTI.fg)('confluence_editor_auto-convert_changes') ? isAutoConvertedWithNewTinyPages : isAutoConverted);
    const autoConversionContextValue = (0, $cozmU.useMemo)(()=>({
            editorProperty: editorProperty,
            fabricEditorSupported: fabricEditorSupported,
            isAutoConverted: isAutoConverted,
            queryDataId: queryDataId
        }), [
        editorProperty,
        fabricEditorSupported,
        isAutoConverted,
        queryDataId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1493c1e4d7d497eb$export$f12106fa80cfd400.Provider, {
        value: autoConversionContextValue
    }, children, !isFabric && queryDataId && (0, $dfgVG.checkRevertFlag)(queryDataId) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "auto-editor-conversion-revert-success"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jNUT6.RevertEditorSuccess), null)));
};
const $1493c1e4d7d497eb$export$847684e45bf010db = ()=>(0, $cozmU.useContext)($1493c1e4d7d497eb$export$f12106fa80cfd400);
module.exports["AutoConversionByLineContextProvider"] = $1493c1e4d7d497eb$export$78dcd8ae786efebe;
module.exports["useAutoConversionByLineContext"] = $1493c1e4d7d497eb$export$847684e45bf010db;

});

parcelRegister("jNUT6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7aRa9 = parcelRequire("7aRa9");


var $dfgVG = parcelRequire("dfgVG");

const $1d10088386de9373$var$i18n = (0, $kSwu1.defineMessages)({
    revertEditorFlagSuccessTitle: {
        id: "editor-conversion.revert-editor.flag.success.title",
        defaultMessage: "Page is reverted to legacy editor"
    },
    revertEditorFlagSuccessBody: {
        id: "editor-conversion.revert-editor.flag.success.body",
        defaultMessage: "Please note, cloud editor features such as better real-time collaboration, smart links, Live Docs, and AI-powered features are not available."
    }
});
const $1d10088386de9373$export$974b18a34ecfb5af = ({ flags: flags })=>{
    (0, $cozmU.useEffect)(()=>{
        const description = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $1d10088386de9373$var$i18n.revertEditorFlagSuccessBody);
        flags.showSuccessFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $1d10088386de9373$var$i18n.revertEditorFlagSuccessTitle),
            description: description,
            isAutoDismiss: true
        });
        (0, $dfgVG.removeRevertFlag)();
    }, [
        flags
    ]);
    return null;
};
const $1d10088386de9373$export$b2e4e7debfeba26 = (0, $7aRa9.withFlags)($1d10088386de9373$export$974b18a34ecfb5af);
module.exports["RevertEditorSuccess"] = $1d10088386de9373$export$b2e4e7debfeba26;

});

parcelRegister("4mihy", function(module, exports) {

var $cJCba = parcelRequire("cJCba");

const $4aa61b5693986156$export$2799e7163d440679 = (createAnalyticsEvent, source, importSource, importDate, contentId, rating, dataFormat, feedback)=>{
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: 'submitted',
            actionSubject: 'survey',
            actionSubjectId: 'importFeedbackSurvey',
            source: source,
            attributes: {
                rating: rating,
                dataFormat: dataFormat,
                feedback: feedback,
                importType: importSource,
                importDate: importDate.toISOString(),
                contentType: (0, $cJCba.getIsWhiteboardSource)(importSource) ? 'whiteboard' : 'page',
                contentId: contentId
            }
        }
    }).fire();
};
module.exports["submitSurveyFeedback"] = $4aa61b5693986156$export$2799e7163d440679;

});

parcelRegister("cJCba", function(module, exports) {
var $ac1d1a087c23a95b$export$ddc693d0d8207b4d = /*#__PURE__*/ function(ImportSource) {
    ImportSource["NOTION"] = "Notion";
    ImportSource["MIRO"] = "Miro";
    ImportSource["MURAL"] = "Mural";
    return ImportSource;
}({});
const $ac1d1a087c23a95b$export$5571cbf5d27f8c0c = (importSource)=>{
    return [
        "Miro",
        "Mural"
    ].map((source)=>source.toLowerCase()).includes(importSource.toLowerCase());
};
const $ac1d1a087c23a95b$export$38afe04e637d5e32 = (importSource)=>{
    const normalizedInput = importSource.toLowerCase();
    for (const source of Object.values($ac1d1a087c23a95b$export$ddc693d0d8207b4d)){
        if (normalizedInput.includes(source.toLowerCase())) return source;
    }
    return undefined;
};
module.exports["ImportSource"] = $ac1d1a087c23a95b$export$ddc693d0d8207b4d;
module.exports["getIsWhiteboardSource"] = $ac1d1a087c23a95b$export$5571cbf5d27f8c0c;
module.exports["getImportSourceEnum"] = $ac1d1a087c23a95b$export$38afe04e637d5e32;

});

parcelRegister("jQob7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $dTHYM = parcelRequire("dTHYM");


var $7BfeF = parcelRequire("7BfeF");


var $9DzWa = parcelRequire("9DzWa");


var $dUI0h = parcelRequire("dUI0h");


var $hpa99 = parcelRequire("hpa99");


var $ad7Ou = parcelRequire("ad7Ou");


var $7aRdF = parcelRequire("7aRdF");


var $fEPJS = parcelRequire("fEPJS");


var $eQiT1 = parcelRequire("eQiT1");


var $9Umtx = parcelRequire("9Umtx");


var $jq995 = parcelRequire("jq995");


var $aRGok = parcelRequire("aRGok");


var $6wGOF = parcelRequire("6wGOF");


var $e3Wrf = parcelRequire("e3Wrf");


var $dinVW = parcelRequire("dinVW");


var $4aRua = parcelRequire("4aRua");


var $4MnFz = parcelRequire("4MnFz");


var $chu6R = parcelRequire("chu6R");


var $9wGTI = parcelRequire("9wGTI");


var $4mihy = parcelRequire("4mihy");


var $54nea = parcelRequire("54nea");


var $cJCba = parcelRequire("cJCba");


var $aUiHE = parcelRequire("aUiHE");

const $3069ee56b74f24de$export$5efdacda4e928df9 = ({ isOpen: isOpen, closeModal: closeModal, importSource: importSource, importDate: importDate, contentId: contentId, onFeedbackSubmit: onFeedbackSubmit })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $4MnFz.useFlags)();
    const importSourceEnum = (0, $cJCba.getImportSourceEnum)(importSource);
    const NOTION_DATA_FORMAT_OPTIONS = (0, $54nea.useDataFormatOptions)();
    const DATA_FORMAT_OPTIONS = (0, $54nea.useDataFormatOptionsFromSource)(importSourceEnum);
    if (!importSourceEnum && (0, $9wGTI.fg)('cc_importer_axp_enable_miro_import_bulk_feedback')) return null;
    const onSubmit = (data)=>{
        if (!data['data-format'] || data['data-format'].length === 0) return {
            'data-format': intl.formatMessage((0, $aUiHE.modalFormMessages).selectDataFormatError)
        };
        (0, $4mihy.submitSurveyFeedback)(createAnalyticsEvent, 'importedPageFeedbackSurveyModal', importSourceEnum ?? importSource, importDate, contentId, 'negative', // Modal only shown for negative feedback
        data['data-format'].map((option)=>option.value), data['tell-us-about-your-experience']);
        closeModal();
        onFeedbackSubmit();
        showFlag({
            isAutoDismiss: true,
            title: intl.formatMessage((0, $aUiHE.modalFormMessages).submittedTitle),
            description: intl.formatMessage((0, $aUiHE.modalFormMessages).submittedDescription),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
                color: "var(--ds-icon-success, #6A9A23)",
                label: ""
            })
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
        onClose: closeModal,
        width: "large",
        testId: "import-feedback-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dTHYM.default), {
        onSubmit: onSubmit,
        id: "feedback-modal-form"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $aUiHE.modalFormMessages).modalTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $aUiHE.modalFormMessages).requiredFieldsAsterisk), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hpa99.RequiredAsterisk), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $aUiHE.modalFormMessages).feedbackText,
        values: {
            source: importSourceEnum
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        name: "data-format",
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $aUiHE.modalFormMessages).dataFormatLabel),
        isRequired: true,
        testId: "data-format-select-field"
    }, ({ fieldProps: { id: id, ...rest }, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6wGOF.default), {
            inputId: id,
            ...rest,
            options: (0, $9wGTI.fg)('cc_importer_axp_enable_miro_import_bulk_feedback') ? DATA_FORMAT_OPTIONS : NOTION_DATA_FORMAT_OPTIONS,
            menuPosition: "fixed",
            isClearable: true,
            isMulti: true,
            clearControlLabel: intl.formatMessage((0, $aUiHE.modalFormMessages).dataFormatClearControlLabel),
            testId: "data-format-select-dropdown"
        }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, error), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9DzWa.HelperMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $aUiHE.modalFormMessages).dataFormatHelperText)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $aUiHE.modalFormMessages).tellUsAboutYourExperience),
        name: "tell-us-about-your-experience",
        testId: "tell-us-about-your-experience-field",
        isRequired: true
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
            ...fieldProps,
            placeholder: intl.formatMessage((0, $aUiHE.modalFormMessages).tellUsAboutYourExperiencePlaceholder),
            testId: "tell-us-about-your-experience-textarea"
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: closeModal,
        testId: "feedback-modal-close-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $aUiHE.modalFormMessages).closeButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        type: "submit",
        testId: "feedback-modal-submit-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $aUiHE.modalFormMessages).feedbackButton)))))));
};
module.exports["FeedbackModal"] = $3069ee56b74f24de$export$5efdacda4e928df9;

});

parcelRegister("54nea", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $cJCba = parcelRequire("cJCba");


var $kyTyD = parcelRequire("kyTyD");


var $3M5DA = parcelRequire("3M5DA");


var $ffmqQ = parcelRequire("ffmqQ");

const $b21152ef0867f201$var$NOTION_DATA_FORMAT_OPTIONS = [
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).mentions,
        value: 'mentions'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).audioEmbeddedLink,
        value: 'audio_embedded_link'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).attachments,
        value: 'attachments'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).blockEquation,
        value: 'block_equation'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).breadcrumb,
        value: 'breadcrumb'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).bulletedLists,
        value: 'bulleted_lists'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).button,
        value: 'button'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).callout,
        value: 'callout'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).codeBlock,
        value: 'code_block'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).codeMermaid,
        value: 'code_mermaid'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).twoColumns,
        value: 'two_columns'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).customizedText,
        value: 'customized_text'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).databaseChildPageProperties,
        value: 'database_child_properties'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).dates,
        value: 'dates'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).dividers,
        value: 'dividers'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).embed,
        value: 'embed'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).emojis,
        value: 'emojis'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).headerImages,
        value: 'header_images'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).headings,
        value: 'headings'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).images,
        value: 'images'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).inlineEquation,
        value: 'inline_equation'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).linkToPage,
        value: 'link_to_page'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).numberedLists,
        value: 'numbered_lists'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).pageComments,
        value: 'page_comments'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).pageEmojis,
        value: 'page_emojis'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).quotes,
        value: 'quotes'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).reminder,
        value: 'reminder'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).staticTables,
        value: 'static_tables'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).syncedBlock,
        value: 'synced_block'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).tableCustomization,
        value: 'table_customization'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).tableData,
        value: 'table_data'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).tableOfContents,
        value: 'table_of_contents'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).todoList,
        value: 'todo_list'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).toggleHeading,
        value: 'toggle_heading'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).toggleList,
        value: 'toggle_list'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).videoEmbeddedLink,
        value: 'video_embedded_link'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).webBookmark,
        value: 'web_bookmark'
    },
    {
        message: (0, $kyTyD.notionDataFormatOptionsMessages).other,
        value: 'other'
    }
];
const $b21152ef0867f201$var$MIRO_DATA_FORMAT_OPTIONS = [
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).comments,
        value: 'comments'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).colors,
        value: 'colors'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).connectors,
        value: 'connectors'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).rotations,
        value: 'rotations'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).shapes,
        value: 'shapes'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).talkTracks,
        value: 'talk_tracks'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).lockedElements,
        value: 'locked_elements'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).stickyNotes,
        value: 'sticky_notes'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).frames,
        value: 'frames'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).borders,
        value: 'borders'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).draw,
        value: 'draw'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).websiteEmbeds,
        value: 'website_embeds'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).jiraCards,
        value: 'jira_cards'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).tables,
        value: 'tables'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).gifs,
        value: 'gifs'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).text,
        value: 'text'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).stamps,
        value: 'stamps'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).tags,
        value: 'tags'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).mindMaps,
        value: 'mind_maps'
    },
    {
        message: (0, $3M5DA.miroDataFormatOptionsMessages).other,
        value: 'other'
    }
];
const $b21152ef0867f201$var$MURAL_DATA_FORMAT_OPTIONS = [
    {
        message: (0, $ffmqQ.muralDataFormatOptionsMessages).borders,
        value: 'borders'
    },
    {
        message: (0, $ffmqQ.muralDataFormatOptionsMessages).colors,
        value: 'colors'
    },
    {
        message: (0, $ffmqQ.muralDataFormatOptionsMessages).comments,
        value: 'comments'
    },
    {
        message: (0, $ffmqQ.muralDataFormatOptionsMessages).connectors,
        value: 'connectors'
    },
    {
        message: (0, $ffmqQ.muralDataFormatOptionsMessages).draw,
        value: 'draw'
    },
    {
        message: (0, $ffmqQ.muralDataFormatOptionsMessages).gifs,
        value: 'gifs'
    },
    {
        message: (0, $ffmqQ.muralDataFormatOptionsMessages).lockedElements,
        value: 'locked_elements'
    },
    {
        message: (0, $ffmqQ.muralDataFormatOptionsMessages).mindMaps,
        value: 'mind_maps'
    },
    {
        message: (0, $ffmqQ.muralDataFormatOptionsMessages).rotations,
        value: 'rotations'
    },
    {
        message: (0, $ffmqQ.muralDataFormatOptionsMessages).shapes,
        value: 'shapes'
    },
    {
        message: (0, $ffmqQ.muralDataFormatOptionsMessages).stamps,
        value: 'stamps'
    },
    {
        message: (0, $ffmqQ.muralDataFormatOptionsMessages).stickyNotes,
        value: 'sticky_notes'
    },
    {
        message: (0, $ffmqQ.muralDataFormatOptionsMessages).tables,
        value: 'tables'
    },
    {
        message: (0, $ffmqQ.muralDataFormatOptionsMessages).tags,
        value: 'tags'
    },
    {
        message: (0, $ffmqQ.muralDataFormatOptionsMessages).text,
        value: 'text'
    },
    {
        message: (0, $ffmqQ.muralDataFormatOptionsMessages).websiteEmbeds,
        value: 'website_embeds'
    },
    {
        message: (0, $ffmqQ.muralDataFormatOptionsMessages).other,
        value: 'other'
    }
];
const $b21152ef0867f201$export$1e5c15dd4d474cfc = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return $b21152ef0867f201$var$NOTION_DATA_FORMAT_OPTIONS.map((option)=>({
            value: option.value,
            label: formatMessage(option.message)
        }));
};
const $b21152ef0867f201$export$769861949a982d7a = (importSource)=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let dataFormatOptions;
    switch(importSource){
        case (0, $cJCba.ImportSource).NOTION:
            dataFormatOptions = $b21152ef0867f201$var$NOTION_DATA_FORMAT_OPTIONS;
            break;
        case (0, $cJCba.ImportSource).MIRO:
            dataFormatOptions = $b21152ef0867f201$var$MIRO_DATA_FORMAT_OPTIONS;
            break;
        case (0, $cJCba.ImportSource).MURAL:
            dataFormatOptions = $b21152ef0867f201$var$MURAL_DATA_FORMAT_OPTIONS;
            break;
        default:
            // Should never happen
            dataFormatOptions = $b21152ef0867f201$var$NOTION_DATA_FORMAT_OPTIONS;
    }
    return dataFormatOptions.map((option)=>({
            value: option.value,
            label: formatMessage(option.message)
        }));
};
module.exports["useDataFormatOptions"] = $b21152ef0867f201$export$1e5c15dd4d474cfc;
module.exports["useDataFormatOptionsFromSource"] = $b21152ef0867f201$export$769861949a982d7a;

});

parcelRegister("kyTyD", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $b8d9cf0582cd5f3a$export$5487dbca878f120b = (0, $kSwu1.defineMessages)({
    mentions: {
        id: "import-feedback.data-format-options.notion.mentions",
        defaultMessage: "@mentions"
    },
    audioEmbeddedLink: {
        id: "import-feedback.data-format-options.notion.audio-embedded-link",
        defaultMessage: "Audio (embedded link)"
    },
    attachments: {
        id: "import-feedback.data-format-options.notion.attachments",
        defaultMessage: "Attachments"
    },
    blockEquation: {
        id: "import-feedback.data-format-options.notion.block-equation",
        defaultMessage: "Block equation"
    },
    breadcrumb: {
        id: "import-feedback.data-format-options.notion.breadcrumb",
        defaultMessage: "Breadcrumb"
    },
    bulletedLists: {
        id: "import-feedback.data-format-options.notion.bulleted-lists",
        defaultMessage: "Bullet lists"
    },
    button: {
        id: "import-feedback.data-format-options.notion.button",
        defaultMessage: "Button"
    },
    callout: {
        id: "import-feedback.data-format-options.notion.callout",
        defaultMessage: "Callout"
    },
    codeBlock: {
        id: "import-feedback.data-format-options.notion.code-block",
        defaultMessage: "Code block"
    },
    codeMermaid: {
        id: "import-feedback.data-format-options.notion.code-mermaid",
        defaultMessage: "Code - Mermaid (diagram)"
    },
    twoColumns: {
        id: "import-feedback.data-format-options.notion.two-columns",
        defaultMessage: "2 columns"
    },
    customizedText: {
        id: "import-feedback.data-format-options.notion.customized-text",
        defaultMessage: "Customized text"
    },
    databaseChildPageProperties: {
        id: "import-feedback.data-format-options.notion.database-child-page-properties",
        defaultMessage: "Database child page properties"
    },
    dates: {
        id: "import-feedback.data-format-options.notion.dates",
        defaultMessage: "Dates"
    },
    dividers: {
        id: "import-feedback.data-format-options.notion.dividers",
        defaultMessage: "Dividers"
    },
    embed: {
        id: "import-feedback.data-format-options.notion.embed",
        defaultMessage: "Embed (e.g. Figma)"
    },
    emojis: {
        id: "import-feedback.data-format-options.notion.emojis",
        defaultMessage: "Emojis"
    },
    headerImages: {
        id: "import-feedback.data-format-options.notion.header-images",
        defaultMessage: "Header images"
    },
    headings: {
        id: "import-feedback.data-format-options.notion.headings",
        defaultMessage: "Headings"
    },
    images: {
        id: "import-feedback.data-format-options.notion.images",
        defaultMessage: "Images"
    },
    inlineEquation: {
        id: "import-feedback.data-format-options.notion.inline-equation",
        defaultMessage: "Inline equation"
    },
    linkToPage: {
        id: "import-feedback.data-format-options.notion.link-to-page",
        defaultMessage: "Link to page"
    },
    numberedLists: {
        id: "import-feedback.data-format-options.notion.numbered-lists",
        defaultMessage: "Numbered lists"
    },
    pageComments: {
        id: "import-feedback.data-format-options.notion.page-comments",
        defaultMessage: "Page comments"
    },
    pageEmojis: {
        id: "import-feedback.data-format-options.notion.page-emojis",
        defaultMessage: "Page emojis"
    },
    quotes: {
        id: "import-feedback.data-format-options.notion.quotes",
        defaultMessage: "Quotes"
    },
    reminder: {
        id: "import-feedback.data-format-options.notion.reminder",
        defaultMessage: "Reminder"
    },
    staticTables: {
        id: "import-feedback.data-format-options.notion.static-tables",
        defaultMessage: "Static tables"
    },
    syncedBlock: {
        id: "import-feedback.data-format-options.notion.synced-block",
        defaultMessage: "Synced block"
    },
    tableCustomization: {
        id: "import-feedback.data-format-options.notion.table-customization",
        defaultMessage: "Table customization"
    },
    tableData: {
        id: "import-feedback.data-format-options.notion.table-data",
        defaultMessage: "Table data"
    },
    tableOfContents: {
        id: "import-feedback.data-format-options.notion.table-of-contents",
        defaultMessage: "Table of contents"
    },
    todoList: {
        id: "import-feedback.data-format-options.notion.todo-list",
        defaultMessage: "To-Do list"
    },
    toggleHeading: {
        id: "import-feedback.data-format-options.notion.toggle-heading",
        defaultMessage: "Toggle heading"
    },
    toggleList: {
        id: "import-feedback.data-format-options.notion.toggle-list",
        defaultMessage: "Toggle list"
    },
    videoEmbeddedLink: {
        id: "import-feedback.data-format-options.notion.video-embedded-link",
        defaultMessage: "Video (embedded link)"
    },
    webBookmark: {
        id: "import-feedback.data-format-options.notion.web-bookmark",
        defaultMessage: "Web bookmark"
    },
    other: {
        id: "import-feedback.data-format-options.notion.other",
        defaultMessage: "Other"
    }
});
module.exports["notionDataFormatOptionsMessages"] = $b8d9cf0582cd5f3a$export$5487dbca878f120b;

});

parcelRegister("3M5DA", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $78b530d7902d0707$export$c02ae8a2bd2ff74a = (0, $kSwu1.defineMessages)({
    comments: {
        id: "import-feedback.data-format-options.miro.comments",
        defaultMessage: "Comments"
    },
    colors: {
        id: "import-feedback.data-format-options.miro.colors",
        defaultMessage: "Colors"
    },
    connectors: {
        id: "import-feedback.data-format-options.miro.connectors",
        defaultMessage: "Connectors"
    },
    rotations: {
        id: "import-feedback.data-format-options.miro.rotations",
        defaultMessage: "Rotations"
    },
    shapes: {
        id: "import-feedback.data-format-options.miro.shapes",
        defaultMessage: "Shapes"
    },
    talkTracks: {
        id: "import-feedback.data-format-options.miro.talk-tracks",
        defaultMessage: "Talk Tracks"
    },
    lockedElements: {
        id: "import-feedback.data-format-options.miro.locked-elements",
        defaultMessage: "Locked Elements"
    },
    stickyNotes: {
        id: "import-feedback.data-format-options.miro.sticky-notes",
        defaultMessage: "Sticky notes"
    },
    frames: {
        id: "import-feedback.data-format-options.miro.frames",
        defaultMessage: "Frames"
    },
    borders: {
        id: "import-feedback.data-format-options.miro.borders",
        defaultMessage: "Borders"
    },
    draw: {
        id: "import-feedback.data-format-options.miro.draw",
        defaultMessage: "Draw"
    },
    websiteEmbeds: {
        id: "import-feedback.data-format-options.miro.website-embeds",
        defaultMessage: "Website embeds"
    },
    jiraCards: {
        id: "import-feedback.data-format-options.miro.jira-cards",
        defaultMessage: "Jira cards"
    },
    tables: {
        id: "import-feedback.data-format-options.miro.tables",
        defaultMessage: "Tables"
    },
    gifs: {
        id: "import-feedback.data-format-options.miro.gifs",
        defaultMessage: "GIFs"
    },
    text: {
        id: "import-feedback.data-format-options.miro.text",
        defaultMessage: "Text"
    },
    stamps: {
        id: "import-feedback.data-format-options.miro.stamps",
        defaultMessage: "Stamps"
    },
    tags: {
        id: "import-feedback.data-format-options.miro.tags",
        defaultMessage: "Tags"
    },
    mindMaps: {
        id: "import-feedback.data-format-options.miro.mind-maps",
        defaultMessage: "Mind maps"
    },
    other: {
        id: "import-feedback.data-format-options.miro.other",
        defaultMessage: "Other"
    }
});
module.exports["miroDataFormatOptionsMessages"] = $78b530d7902d0707$export$c02ae8a2bd2ff74a;

});

parcelRegister("ffmqQ", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $ff44c6ff801bbed9$export$47d9fbb91e8e28a3 = (0, $kSwu1.defineMessages)({
    comments: {
        id: "import-feedback.data-format-options.mural.comments",
        defaultMessage: "Comments"
    },
    stickyNotes: {
        id: "import-feedback.data-format-options.mural.sticky-notes",
        defaultMessage: "Sticky Notes"
    },
    borders: {
        id: "import-feedback.data-format-options.mural.borders",
        defaultMessage: "Borders"
    },
    draw: {
        id: "import-feedback.data-format-options.mural.draw",
        defaultMessage: "Draw"
    },
    websiteEmbeds: {
        id: "import-feedback.data-format-options.mural.website-embeds",
        defaultMessage: "Website Embeds"
    },
    tables: {
        id: "import-feedback.data-format-options.mural.tables",
        defaultMessage: "Tables"
    },
    gifs: {
        id: "import-feedback.data-format-options.mural.gifs",
        defaultMessage: "GIFs"
    },
    text: {
        id: "import-feedback.data-format-options.mural.text",
        defaultMessage: "Text"
    },
    stamps: {
        id: "import-feedback.data-format-options.mural.stamps",
        defaultMessage: "Stamps"
    },
    tags: {
        id: "import-feedback.data-format-options.mural.tags",
        defaultMessage: "Tags"
    },
    mindMaps: {
        id: "import-feedback.data-format-options.mural.mind-maps",
        defaultMessage: "Mind Maps"
    },
    colors: {
        id: "import-feedback.data-format-options.mural.colors",
        defaultMessage: "Colors"
    },
    connectors: {
        id: "import-feedback.data-format-options.mural.connectors",
        defaultMessage: "Connectors"
    },
    rotations: {
        id: "import-feedback.data-format-options.mural.rotations",
        defaultMessage: "Rotations"
    },
    shapes: {
        id: "import-feedback.data-format-options.mural.shapes",
        defaultMessage: "Shapes"
    },
    lockedElements: {
        id: "import-feedback.data-format-options.mural.locked-elements",
        defaultMessage: "Locked Elements"
    },
    other: {
        id: "import-feedback.data-format-options.mural.other",
        defaultMessage: "Other"
    }
});
module.exports["muralDataFormatOptionsMessages"] = $ff44c6ff801bbed9$export$47d9fbb91e8e28a3;

});

parcelRegister("aUiHE", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $a14bce3fd3c2a8ba$export$4055a71a6988efc8 = (0, $kSwu1.defineMessages)({
    modalTitle: {
        id: "import-feedback.feedback-modal.title",
        defaultMessage: "Give feedback on imported content"
    },
    dataFormatHelperText: {
        id: "import-feedback.feedback-modal.data-format-helper-text",
        defaultMessage: "Start typing to get a list of possible matches or press down to select."
    },
    requiredFieldsAsterisk: {
        id: "import-feedback.feedback-modal.required-fields-asterisk",
        defaultMessage: "Required fields are marked with an asterisk"
    },
    feedbackText: {
        id: "import-feedback.feedback-modal.feedback-text",
        defaultMessage: "This content was imported from {source\t}. Please let us know what issues you found below!"
    },
    dataFormatLabel: {
        id: "import-feedback.feedback-modal.data-format-label",
        defaultMessage: "Data formats with issues"
    },
    dataFormatClearControlLabel: {
        id: "import-feedback.feedback-modal.data-format-clear-control-label",
        defaultMessage: "Clear selected data format"
    },
    tellUsAboutYourExperience: {
        id: "import-feedback.feedback-modal.tell-us-about-your-experience",
        defaultMessage: "Tell us about your experience"
    },
    tellUsAboutYourExperiencePlaceholder: {
        id: "import-feedback.feedback-modal.tell-us-about-your-experience-placeholder",
        defaultMessage: "Please expand on what could be improved for this imported content."
    },
    feedbackButton: {
        id: "import-feedback.feedback-modal.feedback-button",
        defaultMessage: "Send Feedback"
    },
    closeButton: {
        id: "import-feedback.feedback-modal.close-button",
        defaultMessage: "Cancel"
    },
    selectDataFormatError: {
        id: "import-feedback.feedback-modal.select-data-format-error",
        defaultMessage: "Please select a data format"
    },
    submittedTitle: {
        id: "import-feedback.feedback-modal.submitted-title",
        defaultMessage: "Thanks!"
    },
    submittedDescription: {
        id: "import-feedback.feedback-modal.submitted-description",
        defaultMessage: "Your valuable feedback helps us continually improve our products."
    }
});
module.exports["modalFormMessages"] = $a14bce3fd3c2a8ba$export$4055a71a6988efc8;

});

parcelRegister("aK6zf", function(module, exports) {
const $08986653719b52d0$var$IMPORT_SOURCE_PROPERTY_KEY = 'import-source';
const $08986653719b52d0$var$IMPORT_DATE_PROPERTY_KEY = 'imported-page-modified-date';
const $08986653719b52d0$export$e8d166ad05d55a7e = 90;
const $08986653719b52d0$export$660ec42e439d82e5 = 120000; // 2 minutes
function $08986653719b52d0$export$d7c17bfc5f552f72(contentQueryData) {
    const pageProperties = contentQueryData?.content?.nodes?.[0]?.properties?.nodes;
    const importedFromProperty = pageProperties?.find((property)=>property?.key === $08986653719b52d0$var$IMPORT_SOURCE_PROPERTY_KEY);
    return importedFromProperty?.value || undefined;
}
function $08986653719b52d0$export$cccab9e45bf98465(contentQueryData) {
    const pageProperties = contentQueryData?.content?.nodes?.[0]?.properties?.nodes;
    const originalImportDate = pageProperties?.find((property)=>property?.key === $08986653719b52d0$var$IMPORT_DATE_PROPERTY_KEY)?.value?.replace(/^"|"$/g, '');
    return originalImportDate ? new Date(originalImportDate) : undefined;
}
function $08986653719b52d0$export$f5748926afca39a(contentQueryData) {
    const importedFromProperty = $08986653719b52d0$export$d7c17bfc5f552f72(contentQueryData);
    const originalImportDate = $08986653719b52d0$export$cccab9e45bf98465(contentQueryData);
    const lastModifiedDate = contentQueryData?.content?.nodes?.[0]?.metadata?.lastModifiedDate ? new Date(contentQueryData?.content?.nodes?.[0]?.metadata?.lastModifiedDate) : undefined;
    if (!originalImportDate || !lastModifiedDate) return false;
    return !!importedFromProperty && $08986653719b52d0$var$isPageWithinFeedbackTimeThreshold(originalImportDate) && !$08986653719b52d0$var$isPageLastModifiedAfterImportDate(lastModifiedDate, originalImportDate);
}
function $08986653719b52d0$var$isPageWithinFeedbackTimeThreshold(importDate) {
    return Date.now() <= importDate.getTime() + $08986653719b52d0$export$e8d166ad05d55a7e * 86400000;
}
function $08986653719b52d0$var$isPageLastModifiedAfterImportDate(lastModifiedDate, importDate) {
    return lastModifiedDate.getTime() > importDate.getTime() + $08986653719b52d0$export$660ec42e439d82e5;
}
module.exports["getImportSource"] = $08986653719b52d0$export$d7c17bfc5f552f72;
module.exports["getImportDate"] = $08986653719b52d0$export$cccab9e45bf98465;
module.exports["isImportBannerEnabled"] = $08986653719b52d0$export$f5748926afca39a;

});

parcelRegister("8tF9d", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $c08f0377995c9fbd$export$8f5a21cf0975ea0d = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "TAXXG",
    name: "LivePageComponentLoader",
    loader: async ()=>(await (parcelRequire("hDJff"))).LivePageComponent
});
module.exports["LivePageComponentLoader"] = $c08f0377995c9fbd$export$8f5a21cf0975ea0d;

});

parcelRegister("hDJff", function(module, exports) {

let $cd792ce646a449a0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $cd792ce646a449a0$var$load("7BHAC"),
    $cd792ce646a449a0$var$load("N3TvS"),
    $cd792ce646a449a0$var$load("7g00Y"),
    $cd792ce646a449a0$var$load("7A87G"),
    $cd792ce646a449a0$var$load("6wr18"),
    $cd792ce646a449a0$var$load("7fJS0"),
    $cd792ce646a449a0$var$load("Jyh1v"),
    $cd792ce646a449a0$var$load("6TqFw"),
    $cd792ce646a449a0$var$load("7sjI9"),
    $cd792ce646a449a0$var$load("02yT2"),
    $cd792ce646a449a0$var$load("ffEVr"),
    $cd792ce646a449a0$var$load("jXx9i"),
    $cd792ce646a449a0$var$load("aLbuU"),
    $cd792ce646a449a0$var$load("kDVdu"),
    $cd792ce646a449a0$var$load("8Jd6S"),
    $cd792ce646a449a0$var$load("5gsbh"),
    $cd792ce646a449a0$var$load("8lMr1"),
    $cd792ce646a449a0$var$load("1vUE6"),
    $cd792ce646a449a0$var$load("h0X0x"),
    $cd792ce646a449a0$var$load("7l4Nc"),
    $cd792ce646a449a0$var$load("fwbNS"),
    $cd792ce646a449a0$var$load("ckGjo"),
    $cd792ce646a449a0$var$load("d6DuA"),
    $cd792ce646a449a0$var$load("5is1n"),
    $cd792ce646a449a0$var$load("7XOYs"),
    $cd792ce646a449a0$var$load("irflG"),
    $cd792ce646a449a0$var$load("bV5bW"),
    $cd792ce646a449a0$var$load("6S5sb"),
    $cd792ce646a449a0$var$load("1sii7"),
    $cd792ce646a449a0$var$load("fEvpQ"),
    $cd792ce646a449a0$var$load("8OeKT"),
    $cd792ce646a449a0$var$load("kGmwI"),
    $cd792ce646a449a0$var$load("hhss7"),
    $cd792ce646a449a0$var$load("7EorR"),
    $cd792ce646a449a0$var$load("fz1VH")
]).then(()=>parcelRequire('egCae'));

});

parcelRegister("cMKmt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3TgYS = parcelRequire("3TgYS");


var $jYPbB = parcelRequire("jYPbB");

const $46239388d4485db7$export$9d6b189b48dfd2fa = ({ contentId: contentId })=>{
    $46239388d4485db7$var$useLocalActivityViewPageTracker(contentId);
    return null;
};
const $46239388d4485db7$var$useLocalActivityViewPageTracker = (contentId)=>{
    const { track: track } = (0, $jYPbB.useLocalActivityTracker)();
    (0, $cozmU.useEffect)(()=>{
        track(contentId, (0, $3TgYS.LocalActivityAction).viewed);
    }, [
        track,
        contentId
    ]);
};
module.exports["LocalActivityViewPageTracker"] = $46239388d4485db7$export$9d6b189b48dfd2fa;

});

parcelRegister("3nzqU", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $9wGTI = parcelRequire("9wGTI");


var $JCGnt = parcelRequire("JCGnt");


const $4d7d073c1c91ca91$var$useLazyAmplitudeInit = ()=>{
    return (0, $cozmU.useCallback)(async ()=>{
        if (!(0, $9wGTI.fg)('cc_engagement_amplitude_session_replay_gate')) return; // no-op
        const module = await (parcelRequire("3sUQf"));
        return module.AmplitudeSessionReplay.init();
    }, []);
};

const $4d7d073c1c91ca91$var$useLazyAmplitudeStop = ()=>{
    return (0, $cozmU.useCallback)(async ()=>{
        if (!(0, $9wGTI.fg)('cc_engagement_amplitude_session_replay_gate')) return; // no-op
        const module = await (parcelRequire("3sUQf"));
        return module.AmplitudeSessionReplay.stop();
    }, []);
};
const $4d7d073c1c91ca91$export$7ac5f7e6449ca924 = ({ skip: skip = false, timeoutMs: timeoutMs = 180000 // 3 minutes default
 } = {})=>{
    const amplitudeInit = $4d7d073c1c91ca91$var$useLazyAmplitudeInit();
    const amplitudeStop = $4d7d073c1c91ca91$var$useLazyAmplitudeStop();
    const timeoutRef = (0, $cozmU.useRef)();
    const isInitializedRef = (0, $cozmU.useRef)(false);
    const analyticsEventFiredRef = (0, $cozmU.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { isNewUser: isNewUser, loading: isLoadingNewUser } = (0, $JCGnt.useIsNewUser)({}, skip || !(0, $9wGTI.fg)('cc_engagement_amplitude_session_replay_gate'));
    (0, $cozmU.useEffect)(()=>{
        if (skip || !(0, $9wGTI.fg)('cc_engagement_amplitude_session_replay_gate')) return;
        // Initialize amplitude
        amplitudeInit();
        isInitializedRef.current = true;
        // Set timeout to stop after specified time
        timeoutRef.current = setTimeout(()=>{
            amplitudeStop();
            isInitializedRef.current = false;
        }, timeoutMs);
        // Cleanup function
        return ()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
            if (isInitializedRef.current) {
                amplitudeStop();
                isInitializedRef.current = false;
            }
        };
    }, [
        skip,
        amplitudeInit,
        amplitudeStop,
        timeoutMs
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (skip || !(0, $9wGTI.fg)('cc_engagement_amplitude_session_replay_gate') || !isInitializedRef.current || analyticsEventFiredRef.current || isLoadingNewUser) return;
        if (isNewUser) {
            //Use this analytics event to add extra attributes so it can be filtered in Amplitude
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'triggered',
                    actionSubject: 'amplitudeSessionReplay',
                    source: 'confluenceAmplitudeSessionReplay',
                    attributes: {
                        isNewUser: true
                    }
                }
            }).fire();
            analyticsEventFiredRef.current = true;
        }
    }, [
        skip,
        isNewUser,
        createAnalyticsEvent,
        isLoadingNewUser
    ]);
    // Cleanup effect that always runs on unmount
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
            if (isInitializedRef.current) {
                amplitudeStop();
                isInitializedRef.current = false;
            }
        };
    }, [
        amplitudeStop
    ]);
    // Handle pagehide to stop amplitude session replay when page closes
    (0, $cozmU.useEffect)(()=>{
        if (skip || !(0, $9wGTI.fg)('cc_engagement_amplitude_session_replay_gate')) return;
        const handlePageHide = ()=>{
            if (isInitializedRef.current) {
                amplitudeStop();
                isInitializedRef.current = false;
            }
        };
        window.addEventListener('pagehide', handlePageHide);
        return ()=>{
            window.removeEventListener('pagehide', handlePageHide);
        };
    }, [
        skip,
        amplitudeStop
    ]);
};
module.exports["useAmplitudeSessionReplay"] = $4d7d073c1c91ca91$export$7ac5f7e6449ca924;

});

parcelRegister("3sUQf", function(module, exports) {

let $2860142d72563b41$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2860142d72563b41$var$load("czC5b").then(()=>parcelRequire('d1GUC'));

});


//# sourceMappingURL=ViewPage.4c147957.js.map
